(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
(function (global){(function (){
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):(e="undefined"!=typeof globalThis?globalThis:e||self).AdyenCheckout=t()}(this,(function(){"use strict";var e="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},t=function(e){return e&&e.Math==Math&&e},r=t("object"==typeof globalThis&&globalThis)||t("object"==typeof window&&window)||t("object"==typeof self&&self)||t("object"==typeof e&&e)||function(){return this}()||Function("return this")(),a={},n=function(e){try{return!!e()}catch(e){return!0}},o=!n((function(){return 7!=Object.defineProperty({},1,{get:function(){return 7}})[1]})),i={},l={}.propertyIsEnumerable,s=Object.getOwnPropertyDescriptor,c=s&&!l.call({1:2},1);i.f=c?function(e){var t=s(this,e);return!!t&&t.enumerable}:l;var d,u,p=function(e,t){return{enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}},m={}.toString,h=function(e){return m.call(e).slice(8,-1)},f=h,y="".split,b=n((function(){return!Object("z").propertyIsEnumerable(0)}))?function(e){return"String"==f(e)?y.call(e,""):Object(e)}:Object,v=function(e){if(null==e)throw TypeError("Can't call method on "+e);return e},g=b,k=v,C=function(e){return g(k(e))},_=function(e){return"function"==typeof e},N=_,w=function(e){return"object"==typeof e?null!==e:N(e)},P=r,F=_,D=function(e){return F(e)?e:void 0},A=function(e,t){return arguments.length<2?D(P[e]):P[e]&&P[e][t]},S=A("navigator","userAgent")||"",x=r,B=S,T=x.process,z=x.Deno,I=T&&T.versions||z&&z.version,j=I&&I.v8;j?u=(d=j.split("."))[0]<4?1:d[0]+d[1]:B&&(!(d=B.match(/Edge\/(\d+)/))||d[1]>=74)&&(d=B.match(/Chrome\/(\d+)/))&&(u=d[1]);var M=u&&+u,O=M,E=n,R=!!Object.getOwnPropertySymbols&&!E((function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&O&&O<41})),L=R&&!Symbol.sham&&"symbol"==typeof Symbol.iterator,V=_,U=A,K=L?function(e){return"symbol"==typeof e}:function(e){var t=U("Symbol");return V(t)&&Object(e)instanceof t},H=function(e){try{return String(e)}catch(e){return"Object"}},q=_,G=H,Y=function(e){if(q(e))return e;throw TypeError(G(e)+" is not a function")},W=Y,J=function(e,t){var r=e[t];return null==r?void 0:W(r)},Z=_,Q=w,$={exports:{}},X=r,ee=function(e,t){try{Object.defineProperty(X,e,{value:t,configurable:!0,writable:!0})}catch(r){X[e]=t}return t},te=ee,re="__core-js_shared__",ae=r[re]||te(re,{}),ne=ae;($.exports=function(e,t){return ne[e]||(ne[e]=void 0!==t?t:{})})("versions",[]).push({version:"3.18.1",mode:"global",copyright:"\xa9 2021 Denis Pushkarev (zloirock.ru)"});var oe=v,ie=function(e){return Object(oe(e))},le=ie,se={}.hasOwnProperty,ce=Object.hasOwn||function(e,t){return se.call(le(e),t)},de=0,ue=Math.random(),pe=function(e){return"Symbol("+String(void 0===e?"":e)+")_"+(++de+ue).toString(36)},me=r,he=$.exports,fe=ce,ye=pe,be=R,ve=L,ge=he("wks"),ke=me.Symbol,Ce=ve?ke:ke&&ke.withoutSetter||ye,_e=function(e){return fe(ge,e)&&(be||"string"==typeof ge[e])||(be&&fe(ke,e)?ge[e]=ke[e]:ge[e]=Ce("Symbol."+e)),ge[e]},Ne=w,we=K,Pe=J,Fe=function(e,t){var r,a;if("string"===t&&Z(r=e.toString)&&!Q(a=r.call(e)))return a;if(Z(r=e.valueOf)&&!Q(a=r.call(e)))return a;if("string"!==t&&Z(r=e.toString)&&!Q(a=r.call(e)))return a;throw TypeError("Can't convert object to primitive value")},De=_e("toPrimitive"),Ae=function(e,t){if(!Ne(e)||we(e))return e;var r,a=Pe(e,De);if(a){if(void 0===t&&(t="default"),r=a.call(e,t),!Ne(r)||we(r))return r;throw TypeError("Can't convert object to primitive value")}return void 0===t&&(t="number"),Fe(e,t)},Se=K,xe=function(e){var t=Ae(e,"string");return Se(t)?t:String(t)},Be=w,Te=r.document,ze=Be(Te)&&Be(Te.createElement),Ie=function(e){return ze?Te.createElement(e):{}},je=Ie,Me=!o&&!n((function(){return 7!=Object.defineProperty(je("div"),"a",{get:function(){return 7}}).a})),Oe=o,Ee=i,Re=p,Le=C,Ve=xe,Ue=ce,Ke=Me,He=Object.getOwnPropertyDescriptor;a.f=Oe?He:function(e,t){if(e=Le(e),t=Ve(t),Ke)try{return He(e,t)}catch(e){}if(Ue(e,t))return Re(!Ee.f.call(e,t),e[t])};var qe={},Ge=w,Ye=function(e){if(Ge(e))return e;throw TypeError(String(e)+" is not an object")},We=o,Je=Me,Ze=Ye,Qe=xe,$e=Object.defineProperty;qe.f=We?$e:function(e,t,r){if(Ze(e),t=Qe(t),Ze(r),Je)try{return $e(e,t,r)}catch(e){}if("get"in r||"set"in r)throw TypeError("Accessors not supported");return"value"in r&&(e[t]=r.value),e};var Xe=qe,et=p,tt=o?function(e,t,r){return Xe.f(e,t,et(1,r))}:function(e,t,r){return e[t]=r,e},rt={exports:{}},at=_,nt=ae,ot=Function.toString;at(nt.inspectSource)||(nt.inspectSource=function(e){return ot.call(e)});var it,lt,st,ct=nt.inspectSource,dt=_,ut=ct,pt=r.WeakMap,mt=dt(pt)&&/native code/.test(ut(pt)),ht=$.exports,ft=pe,yt=ht("keys"),bt=function(e){return yt[e]||(yt[e]=ft(e))},vt={},gt=mt,kt=w,Ct=tt,_t=ce,Nt=ae,wt=bt,Pt=vt,Ft="Object already initialized",Dt=r.WeakMap;if(gt||Nt.state){var At=Nt.state||(Nt.state=new Dt),St=At.get,xt=At.has,Bt=At.set;it=function(e,t){if(xt.call(At,e))throw new TypeError(Ft);return t.facade=e,Bt.call(At,e,t),t},lt=function(e){return St.call(At,e)||{}},st=function(e){return xt.call(At,e)}}else{var Tt=wt("state");Pt[Tt]=!0,it=function(e,t){if(_t(e,Tt))throw new TypeError(Ft);return t.facade=e,Ct(e,Tt,t),t},lt=function(e){return _t(e,Tt)?e[Tt]:{}},st=function(e){return _t(e,Tt)}}var zt={set:it,get:lt,has:st,enforce:function(e){return st(e)?lt(e):it(e,{})},getterFor:function(e){return function(t){var r;if(!kt(t)||(r=lt(t)).type!==e)throw TypeError("Incompatible receiver, "+e+" required");return r}}},It=o,jt=ce,Mt=Function.prototype,Ot=It&&Object.getOwnPropertyDescriptor,Et=jt(Mt,"name"),Rt={EXISTS:Et,PROPER:Et&&"something"===function(){}.name,CONFIGURABLE:Et&&(!It||It&&Ot(Mt,"name").configurable)},Lt=r,Vt=_,Ut=ce,Kt=tt,Ht=ee,qt=ct,Gt=Rt.CONFIGURABLE,Yt=zt.get,Wt=zt.enforce,Jt=String(String).split("String");(rt.exports=function(e,t,r,a){var n,o=!!a&&!!a.unsafe,i=!!a&&!!a.enumerable,l=!!a&&!!a.noTargetGet,s=a&&void 0!==a.name?a.name:t;Vt(r)&&("Symbol("===String(s).slice(0,7)&&(s="["+String(s).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!Ut(r,"name")||Gt&&r.name!==s)&&Kt(r,"name",s),(n=Wt(r)).source||(n.source=Jt.join("string"==typeof s?s:""))),e!==Lt?(o?!l&&e[t]&&(i=!0):delete e[t],i?e[t]=r:Kt(e,t,r)):i?e[t]=r:Ht(t,r)})(Function.prototype,"toString",(function(){return Vt(this)&&Yt(this).source||qt(this)}));var Zt={},Qt=Math.ceil,$t=Math.floor,Xt=function(e){return isNaN(e=+e)?0:(e>0?$t:Qt)(e)},er=Xt,tr=Math.min,rr=function(e){return e>0?tr(er(e),9007199254740991):0},ar=Xt,nr=Math.max,or=Math.min,ir=C,lr=rr,sr=function(e,t){var r=ar(e);return r<0?nr(r+t,0):or(r,t)},cr=function(e){return function(t,r,a){var n,o=ir(t),i=lr(o.length),l=sr(a,i);if(e&&r!=r){for(;i>l;)if((n=o[l++])!=n)return!0}else for(;i>l;l++)if((e||l in o)&&o[l]===r)return e||l||0;return!e&&-1}},dr={includes:cr(!0),indexOf:cr(!1)},ur=ce,pr=C,mr=dr.indexOf,hr=vt,fr=function(e,t){var r,a=pr(e),n=0,o=[];for(r in a)!ur(hr,r)&&ur(a,r)&&o.push(r);for(;t.length>n;)ur(a,r=t[n++])&&(~mr(o,r)||o.push(r));return o},yr=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"],br=fr,vr=yr.concat("length","prototype");Zt.f=Object.getOwnPropertyNames||function(e){return br(e,vr)};var gr={};gr.f=Object.getOwnPropertySymbols;var kr=Zt,Cr=gr,_r=Ye,Nr=A("Reflect","ownKeys")||function(e){var t=kr.f(_r(e)),r=Cr.f;return r?t.concat(r(e)):t},wr=ce,Pr=Nr,Fr=a,Dr=qe,Ar=n,Sr=_,xr=/#|\.prototype\./,Br=function(e,t){var r=zr[Tr(e)];return r==jr||r!=Ir&&(Sr(t)?Ar(t):!!t)},Tr=Br.normalize=function(e){return String(e).replace(xr,".").toLowerCase()},zr=Br.data={},Ir=Br.NATIVE="N",jr=Br.POLYFILL="P",Mr=Br,Or=r,Er=a.f,Rr=tt,Lr=rt.exports,Vr=ee,Ur=function(e,t){for(var r=Pr(t),a=Dr.f,n=Fr.f,o=0;o<r.length;o++){var i=r[o];wr(e,i)||a(e,i,n(t,i))}},Kr=Mr,Hr=function(e,t){var r,a,n,o,i,l=e.target,s=e.global,c=e.stat;if(r=s?Or:c?Or[l]||Vr(l,{}):(Or[l]||{}).prototype)for(a in t){if(o=t[a],n=e.noTargetGet?(i=Er(r,a))&&i.value:r[a],!Kr(s?a:l+(c?".":"#")+a,e.forced)&&void 0!==n){if(typeof o==typeof n)continue;Ur(o,n)}(e.sham||n&&n.sham)&&Rr(o,"sham",!0),Lr(r,a,o,e)}},qr=fr,Gr=yr,Yr=Object.keys||function(e){return qr(e,Gr)},Wr=o,Jr=n,Zr=Yr,Qr=gr,$r=i,Xr=ie,ea=b,ta=Object.assign,ra=Object.defineProperty,aa=!ta||Jr((function(){if(Wr&&1!==ta({b:1},ta(ra({},"a",{enumerable:!0,get:function(){ra(this,"b",{value:3,enumerable:!1})}}),{b:2})).b)return!0;var e={},t={},r=Symbol(),a="abcdefghijklmnopqrst";return e[r]=7,a.split("").forEach((function(e){t[e]=e})),7!=ta({},e)[r]||Zr(ta({},t)).join("")!=a}))?function(e,t){for(var r=Xr(e),a=arguments.length,n=1,o=Qr.f,i=$r.f;a>n;)for(var l,s=ea(arguments[n++]),c=o?Zr(s).concat(o(s)):Zr(s),d=c.length,u=0;d>u;)l=c[u++],Wr&&!i.call(s,l)||(r[l]=s[l]);return r}:ta;Hr({target:"Object",stat:!0,forced:Object.assign!==aa},{assign:aa});var na=r;na.Object.assign;var oa=ie,ia=Yr;Hr({target:"Object",stat:!0,forced:n((function(){ia(1)}))},{keys:function(e){return ia(oa(e))}}),na.Object.keys;var la,sa=qe,ca=Ye,da=Yr,ua=o?Object.defineProperties:function(e,t){ca(e);for(var r,a=da(t),n=a.length,o=0;n>o;)sa.f(e,r=a[o++],t[r]);return e},pa=A("document","documentElement"),ma=Ye,ha=ua,fa=yr,ya=vt,ba=pa,va=Ie,ga=bt("IE_PROTO"),ka=function(){},Ca=function(e){return"<script>"+e+"</"+"script>"},_a=function(e){e.write(Ca("")),e.close();var t=e.parentWindow.Object;return e=null,t},Na=function(){try{la=new ActiveXObject("htmlfile")}catch(e){}var e,t;Na="undefined"!=typeof document?document.domain&&la?_a(la):((t=va("iframe")).style.display="none",ba.appendChild(t),t.src=String("javascript:"),(e=t.contentWindow.document).open(),e.write(Ca("document.F=Object")),e.close(),e.F):_a(la);for(var r=fa.length;r--;)delete Na.prototype[fa[r]];return Na()};ya[ga]=!0;var wa=Object.create||function(e,t){var r;return null!==e?(ka.prototype=ma(e),r=new ka,ka.prototype=null,r[ga]=e):r=Na(),void 0===t?r:ha(r,t)},Pa=wa,Fa=qe,Da=_e("unscopables"),Aa=Array.prototype;null==Aa[Da]&&Fa.f(Aa,Da,{configurable:!0,value:Pa(null)});var Sa=function(e){Aa[Da][e]=!0},xa=dr.includes,Ba=Sa;Hr({target:"Array",proto:!0},{includes:function(e){return xa(this,e,arguments.length>1?arguments[1]:void 0)}}),Ba("includes");var Ta=Y,za=function(e,t,r){if(Ta(e),void 0===t)return e;switch(r){case 0:return function(){return e.call(t)};case 1:return function(r){return e.call(t,r)};case 2:return function(r,a){return e.call(t,r,a)};case 3:return function(r,a,n){return e.call(t,r,a,n)}}return function(){return e.apply(t,arguments)}},Ia=r,ja=za,Ma=Function.call,Oa=function(e,t,r){return ja(Ma,Ia[e].prototype[t],r)};Oa("Array","includes");var Ea=h,Ra=Array.isArray||function(e){return"Array"==Ea(e)},La={};La[_e("toStringTag")]="z";var Va="[object z]"===String(La),Ua=Va,Ka=_,Ha=h,qa=_e("toStringTag"),Ga="Arguments"==Ha(function(){return arguments}()),Ya=Ua?Ha:function(e){var t,r,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=function(e,t){try{return e[t]}catch(e){}}(t=Object(e),qa))?r:Ga?Ha(t):"Object"==(a=Ha(t))&&Ka(t.callee)?"Arguments":a},Wa=n,Ja=_,Za=Ya,Qa=ct,$a=[],Xa=A("Reflect","construct"),en=/^\s*(?:class|function)\b/,tn=en.exec,rn=!en.exec((function(){})),an=function(e){if(!Ja(e))return!1;try{return Xa(Object,$a,e),!0}catch(e){return!1}},nn=!Xa||Wa((function(){var e;return an(an.call)||!an(Object)||!an((function(){e=!0}))||e}))?function(e){if(!Ja(e))return!1;switch(Za(e)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}return rn||!!tn.call(en,Qa(e))}:an,on=Ra,ln=nn,sn=w,cn=_e("species"),dn=function(e){var t;return on(e)&&(t=e.constructor,(ln(t)&&(t===Array||on(t.prototype))||sn(t)&&null===(t=t[cn]))&&(t=void 0)),void 0===t?Array:t},un=za,pn=b,mn=ie,hn=rr,fn=function(e,t){return new(dn(e))(0===t?0:t)},yn=[].push,bn=function(e){var t=1==e,r=2==e,a=3==e,n=4==e,o=6==e,i=7==e,l=5==e||o;return function(s,c,d,u){for(var p,m,h=mn(s),f=pn(h),y=un(c,d,3),b=hn(f.length),v=0,g=u||fn,k=t?g(s,b):r||i?g(s,0):void 0;b>v;v++)if((l||v in f)&&(m=y(p=f[v],v,h),e))if(t)k[v]=m;else if(m)switch(e){case 3:return!0;case 5:return p;case 6:return v;case 2:yn.call(k,p)}else switch(e){case 4:return!1;case 7:yn.call(k,p)}return o?-1:a||n?n:k}},vn={forEach:bn(0),map:bn(1),filter:bn(2),some:bn(3),every:bn(4),find:bn(5),findIndex:bn(6),filterReject:bn(7)},gn=Hr,kn=vn.find,Cn=Sa,_n="find",Nn=!0;_n in[]&&Array(1).find((function(){Nn=!1})),gn({target:"Array",proto:!0,forced:Nn},{find:function(e){return kn(this,e,arguments.length>1?arguments[1]:void 0)}}),Cn(_n),Oa("Array","find");var wn=Hr,Pn=vn.findIndex,Fn=Sa,Dn="findIndex",An=!0;Dn in[]&&Array(1).findIndex((function(){An=!1})),wn({target:"Array",proto:!0,forced:An},{findIndex:function(e){return Pn(this,e,arguments.length>1?arguments[1]:void 0)}}),Fn(Dn),Oa("Array","findIndex");var Sn=!n((function(){function e(){}return e.prototype.constructor=null,Object.getPrototypeOf(new e)!==e.prototype})),xn=ce,Bn=_,Tn=ie,zn=Sn,In=bt("IE_PROTO"),jn=Object.prototype,Mn=zn?Object.getPrototypeOf:function(e){var t=Tn(e);if(xn(t,In))return t[In];var r=t.constructor;return Bn(r)&&t instanceof r?r.prototype:t instanceof Object?jn:null},On=_,En=Ye,Rn=function(e){if("object"==typeof e||On(e))return e;throw TypeError("Can't set "+String(e)+" as a prototype")},Ln=Object.setPrototypeOf||("__proto__"in{}?function(){var e,t=!1,r={};try{(e=Object.getOwnPropertyDescriptor(Object.prototype,"__proto__").set).call(r,[]),t=r instanceof Array}catch(e){}return function(r,a){return En(r),Rn(a),t?e.call(r,a):r.__proto__=a,r}}():void 0),Vn=w,Un=tt,Kn={},Hn=Kn,qn=_e("iterator"),Gn=Array.prototype,Yn=Ya,Wn=J,Jn=Kn,Zn=_e("iterator"),Qn=function(e){if(null!=e)return Wn(e,Zn)||Wn(e,"@@iterator")||Jn[Yn(e)]},$n=Y,Xn=Ye,eo=Qn,to=Ye,ro=J,ao=Ye,no=function(e){return void 0!==e&&(Hn.Array===e||Gn[qn]===e)},oo=rr,io=za,lo=function(e,t){var r=arguments.length<2?eo(e):t;if($n(r))return Xn(r.call(e));throw TypeError(String(e)+" is not iterable")},so=Qn,co=function(e,t,r){var a,n;to(e);try{if(!(a=ro(e,"return"))){if("throw"===t)throw r;return r}a=a.call(e)}catch(e){n=!0,a=e}if("throw"===t)throw r;if(n)throw a;return to(a),r},uo=function(e,t){this.stopped=e,this.result=t},po=function(e,t,r){var a,n,o,i,l,s,c,d=r&&r.that,u=!(!r||!r.AS_ENTRIES),p=!(!r||!r.IS_ITERATOR),m=!(!r||!r.INTERRUPTED),h=io(t,d,1+u+m),f=function(e){return a&&co(a,"normal",e),new uo(!0,e)},y=function(e){return u?(ao(e),m?h(e[0],e[1],f):h(e[0],e[1])):m?h(e,f):h(e)};if(p)a=e;else{if(!(n=so(e)))throw TypeError(String(e)+" is not iterable");if(no(n)){for(o=0,i=oo(e.length);i>o;o++)if((l=y(e[o]))&&l instanceof uo)return l;return new uo(!1)}a=lo(e,n)}for(s=a.next;!(c=s.call(a)).done;){try{l=y(c.value)}catch(e){co(a,"throw",e)}if("object"==typeof l&&l&&l instanceof uo)return l}return new uo(!1)},mo=Ya,ho=function(e){if("Symbol"===mo(e))throw TypeError("Cannot convert a Symbol value to a string");return String(e)},fo=Hr,yo=Mn,bo=Ln,vo=wa,go=tt,ko=p,Co=function(e,t){Vn(t)&&"cause"in t&&Un(e,"cause",e.cause)},_o=po,No=ho,wo=function(e,t){var r=this;if(!(r instanceof wo))return new wo(e,t);bo&&(r=bo(new Error(void 0),yo(r))),void 0!==t&&go(r,"message",No(t)),arguments.length>2&&Co(r,arguments[2]);var a=[];return _o(e,a.push,{that:a}),go(r,"errors",a),r};wo.prototype=vo(Error.prototype,{constructor:ko(5,wo),message:ko(5,""),name:ko(5,"AggregateError")}),fo({global:!0},{AggregateError:wo});var Po,Fo,Do,Ao=n,So=_,xo=Mn,Bo=rt.exports,To=_e("iterator"),zo=!1;[].keys&&("next"in(Do=[].keys())?(Fo=xo(xo(Do)))!==Object.prototype&&(Po=Fo):zo=!0),(null==Po||Ao((function(){var e={};return Po[To].call(e)!==e})))&&(Po={}),So(Po[To])||Bo(Po,To,(function(){return this}));var Io={IteratorPrototype:Po,BUGGY_SAFARI_ITERATORS:zo},jo=qe.f,Mo=ce,Oo=_e("toStringTag"),Eo=function(e,t,r){e&&!Mo(e=r?e:e.prototype,Oo)&&jo(e,Oo,{configurable:!0,value:t})},Ro=Io.IteratorPrototype,Lo=wa,Vo=p,Uo=Eo,Ko=Kn,Ho=function(){return this},qo=Hr,Go=Rt,Yo=_,Wo=function(e,t,r){var a=t+" Iterator";return e.prototype=Lo(Ro,{next:Vo(1,r)}),Uo(e,a,!1),Ko[a]=Ho,e},Jo=Mn,Zo=Ln,Qo=Eo,$o=tt,Xo=rt.exports,ei=Kn,ti=Go.PROPER,ri=Go.CONFIGURABLE,ai=Io.IteratorPrototype,ni=Io.BUGGY_SAFARI_ITERATORS,oi=_e("iterator"),ii="keys",li="values",si="entries",ci=function(){return this},di=function(e,t,r,a,n,o,i){Wo(r,t,a);var l,s,c,d=function(e){if(e===n&&f)return f;if(!ni&&e in m)return m[e];switch(e){case ii:case li:case si:return function(){return new r(this,e)}}return function(){return new r(this)}},u=t+" Iterator",p=!1,m=e.prototype,h=m[oi]||m["@@iterator"]||n&&m[n],f=!ni&&h||d(n),y="Array"==t&&m.entries||h;if(y&&(l=Jo(y.call(new e)))!==Object.prototype&&l.next&&(Jo(l)!==ai&&(Zo?Zo(l,ai):Yo(l[oi])||Xo(l,oi,ci)),Qo(l,u,!0)),ti&&n==li&&h&&h.name!==li&&(ri?$o(m,"name",li):(p=!0,f=function(){return h.call(this)})),n)if(s={values:d(li),keys:o?f:d(ii),entries:d(si)},i)for(c in s)(ni||p||!(c in m))&&Xo(m,c,s[c]);else qo({target:t,proto:!0,forced:ni||p},s);return m[oi]!==f&&Xo(m,oi,f,{name:n}),ei[t]=f,s},ui=C,pi=Sa,mi=Kn,hi=zt,fi=di,yi="Array Iterator",bi=hi.set,vi=hi.getterFor(yi);fi(Array,"Array",(function(e,t){bi(this,{type:yi,target:ui(e),index:0,kind:t})}),(function(){var e=vi(this),t=e.target,r=e.kind,a=e.index++;return!t||a>=t.length?(e.target=void 0,{value:void 0,done:!0}):"keys"==r?{value:a,done:!1}:"values"==r?{value:t[a],done:!1}:{value:[a,t[a]],done:!1}}),"values"),mi.Arguments=mi.Array,pi("keys"),pi("values"),pi("entries");var gi=Ya,ki=Va?{}.toString:function(){return"[object "+gi(this)+"]"},Ci=Va,_i=rt.exports,Ni=ki;Ci||_i(Object.prototype,"toString",Ni,{unsafe:!0});var wi=r.Promise,Pi=rt.exports,Fi=A,Di=qe,Ai=o,Si=_e("species"),xi=_e("iterator"),Bi=!1;try{var Ti=0,zi={next:function(){return{done:!!Ti++}},return:function(){Bi=!0}};zi[xi]=function(){return this},Array.from(zi,(function(){throw 2}))}catch(Eh){}var Ii,ji,Mi,Oi,Ei=nn,Ri=H,Li=Ye,Vi=function(e){if(Ei(e))return e;throw TypeError(Ri(e)+" is not a constructor")},Ui=_e("species"),Ki=function(e,t){var r,a=Li(e).constructor;return void 0===a||null==(r=Li(a)[Ui])?t:Vi(r)},Hi=/(?:ipad|iphone|ipod).*applewebkit/i.test(S),qi="process"==h(r.process),Gi=r,Yi=_,Wi=n,Ji=za,Zi=pa,Qi=Ie,$i=Hi,Xi=qi,el=Gi.setImmediate,tl=Gi.clearImmediate,rl=Gi.process,al=Gi.MessageChannel,nl=Gi.Dispatch,ol=0,il={},ll="onreadystatechange";try{Ii=Gi.location}catch(Eh){}var sl=function(e){if(il.hasOwnProperty(e)){var t=il[e];delete il[e],t()}},cl=function(e){return function(){sl(e)}},dl=function(e){sl(e.data)},ul=function(e){Gi.postMessage(String(e),Ii.protocol+"//"+Ii.host)};el&&tl||(el=function(e){for(var t=[],r=arguments.length,a=1;r>a;)t.push(arguments[a++]);return il[++ol]=function(){(Yi(e)?e:Function(e)).apply(void 0,t)},ji(ol),ol},tl=function(e){delete il[e]},Xi?ji=function(e){rl.nextTick(cl(e))}:nl&&nl.now?ji=function(e){nl.now(cl(e))}:al&&!$i?(Oi=(Mi=new al).port2,Mi.port1.onmessage=dl,ji=Ji(Oi.postMessage,Oi,1)):Gi.addEventListener&&Yi(Gi.postMessage)&&!Gi.importScripts&&Ii&&"file:"!==Ii.protocol&&!Wi(ul)?(ji=ul,Gi.addEventListener("message",dl,!1)):ji=ll in Qi("script")?function(e){Zi.appendChild(Qi("script")).onreadystatechange=function(){Zi.removeChild(this),sl(e)}}:function(e){setTimeout(cl(e),0)});var pl,ml,hl,fl,yl,bl,vl,gl,kl={set:el,clear:tl},Cl=r,_l=/ipad|iphone|ipod/i.test(S)&&void 0!==Cl.Pebble,Nl=/web0s(?!.*chrome)/i.test(S),wl=r,Pl=a.f,Fl=kl.set,Dl=Hi,Al=_l,Sl=Nl,xl=qi,Bl=wl.MutationObserver||wl.WebKitMutationObserver,Tl=wl.document,zl=wl.process,Il=wl.Promise,jl=Pl(wl,"queueMicrotask"),Ml=jl&&jl.value;Ml||(pl=function(){var e,t;for(xl&&(e=zl.domain)&&e.exit();ml;){t=ml.fn,ml=ml.next;try{t()}catch(e){throw ml?fl():hl=void 0,e}}hl=void 0,e&&e.enter()},Dl||xl||Sl||!Bl||!Tl?!Al&&Il&&Il.resolve?((vl=Il.resolve(void 0)).constructor=Il,gl=vl.then,fl=function(){gl.call(vl,pl)}):fl=xl?function(){zl.nextTick(pl)}:function(){Fl.call(wl,pl)}:(yl=!0,bl=Tl.createTextNode(""),new Bl(pl).observe(bl,{characterData:!0}),fl=function(){bl.data=yl=!yl}));var Ol=Ml||function(e){var t={fn:e,next:void 0};hl&&(hl.next=t),ml||(ml=t,fl()),hl=t},El={},Rl=Y,Ll=function(e){var t,r;this.promise=new e((function(e,a){if(void 0!==t||void 0!==r)throw TypeError("Bad Promise constructor");t=e,r=a})),this.resolve=Rl(t),this.reject=Rl(r)};El.f=function(e){return new Ll(e)};var Vl,Ul,Kl,Hl,ql=Ye,Gl=w,Yl=El,Wl=function(e,t){if(ql(e),Gl(t)&&t.constructor===e)return t;var r=Yl.f(e);return(0,r.resolve)(t),r.promise},Jl=r,Zl=function(e){try{return{error:!1,value:e()}}catch(e){return{error:!0,value:e}}},Ql="object"==typeof window,$l=Hr,Xl=r,es=A,ts=wi,rs=rt.exports,as=function(e,t,r){for(var a in t)Pi(e,a,t[a],r);return e},ns=Ln,os=Eo,is=function(e){var t=Fi(e),r=Di.f;Ai&&t&&!t[Si]&&r(t,Si,{configurable:!0,get:function(){return this}})},ls=Y,ss=_,cs=w,ds=function(e,t,r){if(e instanceof t)return e;throw TypeError("Incorrect "+(r?r+" ":"")+"invocation")},us=ct,ps=po,ms=function(e,t){if(!t&&!Bi)return!1;var r=!1;try{var a={};a[xi]=function(){return{next:function(){return{done:r=!0}}}},e(a)}catch(e){}return r},hs=Ki,fs=kl.set,ys=Ol,bs=Wl,vs=function(e,t){var r=Jl.console;r&&r.error&&(1===arguments.length?r.error(e):r.error(e,t))},gs=El,ks=Zl,Cs=zt,_s=Mr,Ns=Ql,ws=qi,Ps=M,Fs=_e("species"),Ds="Promise",As=Cs.get,Ss=Cs.set,xs=Cs.getterFor(Ds),Bs=ts&&ts.prototype,Ts=ts,zs=Bs,Is=Xl.TypeError,js=Xl.document,Ms=Xl.process,Os=gs.f,Es=Os,Rs=!!(js&&js.createEvent&&Xl.dispatchEvent),Ls=ss(Xl.PromiseRejectionEvent),Vs="unhandledrejection",Us=!1,Ks=_s(Ds,(function(){var e=us(Ts),t=e!==String(Ts);if(!t&&66===Ps)return!0;if(Ps>=51&&/native code/.test(e))return!1;var r=new Ts((function(e){e(1)})),a=function(e){e((function(){}),(function(){}))};return(r.constructor={})[Fs]=a,!(Us=r.then((function(){}))instanceof a)||!t&&Ns&&!Ls})),Hs=Ks||!ms((function(e){Ts.all(e).catch((function(){}))})),qs=function(e){var t;return!(!cs(e)||!ss(t=e.then))&&t},Gs=function(e,t){if(!e.notified){e.notified=!0;var r=e.reactions;ys((function(){for(var a=e.value,n=1==e.state,o=0;r.length>o;){var i,l,s,c=r[o++],d=n?c.ok:c.fail,u=c.resolve,p=c.reject,m=c.domain;try{d?(n||(2===e.rejection&&Zs(e),e.rejection=1),!0===d?i=a:(m&&m.enter(),i=d(a),m&&(m.exit(),s=!0)),i===c.promise?p(Is("Promise-chain cycle")):(l=qs(i))?l.call(i,u,p):u(i)):p(a)}catch(e){m&&!s&&m.exit(),p(e)}}e.reactions=[],e.notified=!1,t&&!e.rejection&&Ws(e)}))}},Ys=function(e,t,r){var a,n;Rs?((a=js.createEvent("Event")).promise=t,a.reason=r,a.initEvent(e,!1,!0),Xl.dispatchEvent(a)):a={promise:t,reason:r},!Ls&&(n=Xl["on"+e])?n(a):e===Vs&&vs("Unhandled promise rejection",r)},Ws=function(e){fs.call(Xl,(function(){var t,r=e.facade,a=e.value;if(Js(e)&&(t=ks((function(){ws?Ms.emit("unhandledRejection",a,r):Ys(Vs,r,a)})),e.rejection=ws||Js(e)?2:1,t.error))throw t.value}))},Js=function(e){return 1!==e.rejection&&!e.parent},Zs=function(e){fs.call(Xl,(function(){var t=e.facade;ws?Ms.emit("rejectionHandled",t):Ys("rejectionhandled",t,e.value)}))},Qs=function(e,t,r){return function(a){e(t,a,r)}},$s=function(e,t,r){e.done||(e.done=!0,r&&(e=r),e.value=t,e.state=2,Gs(e,!0))},Xs=function(e,t,r){if(!e.done){e.done=!0,r&&(e=r);try{if(e.facade===t)throw Is("Promise can't be resolved itself");var a=qs(t);a?ys((function(){var r={done:!1};try{a.call(t,Qs(Xs,r,e),Qs($s,r,e))}catch(t){$s(r,t,e)}})):(e.value=t,e.state=1,Gs(e,!1))}catch(t){$s({done:!1},t,e)}}};if(Ks&&(zs=(Ts=function(e){ds(this,Ts,Ds),ls(e),Vl.call(this);var t=As(this);try{e(Qs(Xs,t),Qs($s,t))}catch(e){$s(t,e)}}).prototype,(Vl=function(e){Ss(this,{type:Ds,done:!1,notified:!1,parent:!1,reactions:[],rejection:!1,state:0,value:void 0})}).prototype=as(zs,{then:function(e,t){var r=xs(this),a=Os(hs(this,Ts));return a.ok=!ss(e)||e,a.fail=ss(t)&&t,a.domain=ws?Ms.domain:void 0,r.parent=!0,r.reactions.push(a),0!=r.state&&Gs(r,!1),a.promise},catch:function(e){return this.then(void 0,e)}}),Ul=function(){var e=new Vl,t=As(e);this.promise=e,this.resolve=Qs(Xs,t),this.reject=Qs($s,t)},gs.f=Os=function(e){return e===Ts||e===Kl?new Ul(e):Es(e)},ss(ts)&&Bs!==Object.prototype)){Hl=Bs.then,Us||(rs(Bs,"then",(function(e,t){var r=this;return new Ts((function(e,t){Hl.call(r,e,t)})).then(e,t)}),{unsafe:!0}),rs(Bs,"catch",zs.catch,{unsafe:!0}));try{delete Bs.constructor}catch(Eh){}ns&&ns(Bs,zs)}$l({global:!0,wrap:!0,forced:Ks},{Promise:Ts}),os(Ts,Ds,!1),is(Ds),Kl=es(Ds),$l({target:Ds,stat:!0,forced:Ks},{reject:function(e){var t=Os(this);return t.reject.call(void 0,e),t.promise}}),$l({target:Ds,stat:!0,forced:Ks},{resolve:function(e){return bs(this,e)}}),$l({target:Ds,stat:!0,forced:Hs},{all:function(e){var t=this,r=Os(t),a=r.resolve,n=r.reject,o=ks((function(){var r=ls(t.resolve),o=[],i=0,l=1;ps(e,(function(e){var s=i++,c=!1;o.push(void 0),l++,r.call(t,e).then((function(e){c||(c=!0,o[s]=e,--l||a(o))}),n)})),--l||a(o)}));return o.error&&n(o.value),r.promise},race:function(e){var t=this,r=Os(t),a=r.reject,n=ks((function(){var n=ls(t.resolve);ps(e,(function(e){n.call(t,e).then(r.resolve,a)}))}));return n.error&&a(n.value),r.promise}});var ec=Y,tc=El,rc=Zl,ac=po;Hr({target:"Promise",stat:!0},{allSettled:function(e){var t=this,r=tc.f(t),a=r.resolve,n=r.reject,o=rc((function(){var r=ec(t.resolve),n=[],o=0,i=1;ac(e,(function(e){var l=o++,s=!1;n.push(void 0),i++,r.call(t,e).then((function(e){s||(s=!0,n[l]={status:"fulfilled",value:e},--i||a(n))}),(function(e){s||(s=!0,n[l]={status:"rejected",reason:e},--i||a(n))}))})),--i||a(n)}));return o.error&&n(o.value),r.promise}});var nc=Y,oc=A,ic=El,lc=Zl,sc=po,cc="No one promise resolved";Hr({target:"Promise",stat:!0},{any:function(e){var t=this,r=ic.f(t),a=r.resolve,n=r.reject,o=lc((function(){var r=nc(t.resolve),o=[],i=0,l=1,s=!1;sc(e,(function(e){var c=i++,d=!1;o.push(void 0),l++,r.call(t,e).then((function(e){d||s||(s=!0,a(e))}),(function(e){d||s||(d=!0,o[c]=e,--l||n(new(oc("AggregateError"))(o,cc)))}))})),--l||n(new(oc("AggregateError"))(o,cc))}));return o.error&&n(o.value),r.promise}});var dc=Hr,uc=wi,pc=n,mc=A,hc=_,fc=Ki,yc=Wl,bc=rt.exports;if(dc({target:"Promise",proto:!0,real:!0,forced:!!uc&&pc((function(){uc.prototype.finally.call({then:function(){}},(function(){}))}))},{finally:function(e){var t=fc(this,mc("Promise")),r=hc(e);return this.then(r?function(r){return yc(t,e()).then((function(){return r}))}:e,r?function(r){return yc(t,e()).then((function(){throw r}))}:e)}}),hc(uc)){var vc=mc("Promise").prototype.finally;uc.prototype.finally!==vc&&bc(uc.prototype,"finally",vc,{unsafe:!0})}var gc=Xt,kc=ho,Cc=v,_c=function(e){return function(t,r){var a,n,o=kc(Cc(t)),i=gc(r),l=o.length;return i<0||i>=l?e?"":void 0:(a=o.charCodeAt(i))<55296||a>56319||i+1===l||(n=o.charCodeAt(i+1))<56320||n>57343?e?o.charAt(i):a:e?o.slice(i,i+2):n-56320+(a-55296<<10)+65536}},Nc={codeAt:_c(!1),charAt:_c(!0)}.charAt,wc=ho,Pc=zt,Fc=di,Dc="String Iterator",Ac=Pc.set,Sc=Pc.getterFor(Dc);Fc(String,"String",(function(e){Ac(this,{type:Dc,string:wc(e),index:0})}),(function(){var e,t=Sc(this),r=t.string,a=t.index;return a>=r.length?{value:void 0,done:!0}:(e=Nc(r,a),t.index+=e.length,{value:e,done:!1})})),na.Promise,[Element.prototype,CharacterData.prototype,DocumentType.prototype].forEach((function(e){e.hasOwnProperty("remove")||Object.defineProperty(e,"remove",{configurable:!0,enumerable:!0,writable:!0,value:function(){null!==this.parentNode&&this.parentNode.removeChild(this)}})}));var xc=function(e,t){return(xc=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(e,t){e.__proto__=t}||function(e,t){for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r])})(e,t)};function Bc(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Class extends value "+String(t)+" is not a constructor or null");function r(){this.constructor=e}xc(e,t),e.prototype=null===t?Object.create(t):(r.prototype=t.prototype,new r)}var Tc=function(){return(Tc=Object.assign||function(e){for(var t,r=1,a=arguments.length;r<a;r++)for(var n in t=arguments[r])Object.prototype.hasOwnProperty.call(t,n)&&(e[n]=t[n]);return e}).apply(this,arguments)};function zc(e,t){var r={};for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&t.indexOf(a)<0&&(r[a]=e[a]);if(null!=e&&"function"==typeof Object.getOwnPropertySymbols){var n=0;for(a=Object.getOwnPropertySymbols(e);n<a.length;n++)t.indexOf(a[n])<0&&Object.prototype.propertyIsEnumerable.call(e,a[n])&&(r[a[n]]=e[a[n]])}return r}function Ic(e,t,r,a){return new(r||(r=Promise))((function(n,o){function i(e){try{s(a.next(e))}catch(e){o(e)}}function l(e){try{s(a.throw(e))}catch(e){o(e)}}function s(e){var t;e.done?n(e.value):(t=e.value,t instanceof r?t:new r((function(e){e(t)}))).then(i,l)}s((a=a.apply(e,t||[])).next())}))}function jc(e,t){var r,a,n,o,i={label:0,sent:function(){if(1&n[0])throw n[1];return n[1]},trys:[],ops:[]};return o={next:l(0),throw:l(1),return:l(2)},"function"==typeof Symbol&&(o[Symbol.iterator]=function(){return this}),o;function l(o){return function(l){return function(o){if(r)throw new TypeError("Generator is already executing.");for(;i;)try{if(r=1,a&&(n=2&o[0]?a.return:o[0]?a.throw||((n=a.return)&&n.call(a),0):a.next)&&!(n=n.call(a,o[1])).done)return n;switch(a=0,n&&(o=[2&o[0],n.value]),o[0]){case 0:case 1:n=o;break;case 4:return i.label++,{value:o[1],done:!1};case 5:i.label++,a=o[1],o=[0];continue;case 7:o=i.ops.pop(),i.trys.pop();continue;default:if(!(n=i.trys,(n=n.length>0&&n[n.length-1])||6!==o[0]&&2!==o[0])){i=0;continue}if(3===o[0]&&(!n||o[1]>n[0]&&o[1]<n[3])){i.label=o[1];break}if(6===o[0]&&i.label<n[1]){i.label=n[1],n=o;break}if(n&&i.label<n[2]){i.label=n[2],i.ops.push(o);break}n[2]&&i.ops.pop(),i.trys.pop();continue}o=t.call(e,i)}catch(e){o=[6,e],a=0}finally{r=n=0}if(5&o[0])throw o[1];return{value:o[0]?o[1]:void 0,done:!0}}([o,l])}}}function Mc(e,t,r){if(r||2===arguments.length)for(var a,n=0,o=t.length;n<o;n++)!a&&n in t||(a||(a=Array.prototype.slice.call(t,0,n)),a[n]=t[n]);return e.concat(a||Array.prototype.slice.call(t))}var Oc={payButton:"Pay","payButton.redirecting":"Redirecting...",storeDetails:"Save for my next payment","creditCard.holderName":"Name on card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Invalid cardholder name","creditCard.numberField.title":"Card number","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Expiry date","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"Month","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"Year","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Remember for next time","creditCard.cvcField.placeholder.4digits":"4 digits","creditCard.cvcField.placeholder.3digits":"3 digits","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Number of installments",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} months","installments.oneTime":"One time payment","installments.installments":"Installments payment","installments.revolving":"Revolving payment","sepaDirectDebit.ibanField.invalid":"Invalid account number","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Holder Name","sepa.ibanNumber":"Account Number (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirect failed","error.subtitle.payment":"Payment failed","error.subtitle.refused":"Payment refused","error.message.unknown":"An unknown error occurred","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Select your bank","creditCard.success":"Payment Successful",loading:"Loading\u2026",continue:"Continue",continueTo:"Continue to","wechatpay.timetopay":"You have %@ to pay","wechatpay.scanqrcode":"Scan QR code",personalDetails:"Personal details",companyDetails:"Company details","companyDetails.name":"Company name","companyDetails.registrationNumber":"Registration number",socialSecurityNumber:"Social security number",firstName:"First name",infix:"Prefix",lastName:"Last name",mobileNumber:"Mobile number","mobileNumber.invalid":"Invalid mobile number",city:"City",postalCode:"Postal code",countryCode:"Country Code",telephoneNumber:"Telephone number",dateOfBirth:"Date of birth",shopperEmail:"Email address",gender:"Gender",male:"Male",female:"Female",billingAddress:"Billing address",street:"Street",stateOrProvince:"State or province",country:"Country",houseNumberOrName:"House number",separateDeliveryAddress:"Specify a separate delivery address",deliveryAddress:"Delivery Address",zipCode:"Zip code",apartmentSuite:"Apartment / Suite",provinceOrTerritory:"Province or Territory",cityTown:"City / Town",address:"Address",state:"State","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Select your wallet",privacyPolicy:"Privacy policy","afterPay.agreement":"I agree with the %@ of AfterPay",paymentConditions:"payment conditions",openApp:"Open the app","voucher.readInstructions":"Read instructions","voucher.introduction":"Thank you for your purchase, please use the following coupon to complete your payment.","voucher.expirationDate":"Expiration Date","voucher.alternativeReference":"Alternative Reference","dragonpay.voucher.non.bank.selectField.placeholder":"Select your provider","dragonpay.voucher.bank.selectField.placeholder":"Select your bank","voucher.paymentReferenceLabel":"Payment Reference","voucher.surcharge":"Incl. %@ surcharge","voucher.introduction.doku":"Thank you for your purchase, please use the following information to complete your payment.","voucher.shopperName":"Shopper Name","voucher.merchantName":"Merchant","voucher.introduction.econtext":"Thank you for your purchase, please use the following information to complete your payment.","voucher.telephoneNumber":"Phone Number","voucher.shopperReference":"Shopper Reference","voucher.collectionInstitutionNumber":"Collection Institution Number","voucher.econtext.telephoneNumber.invalid":"Telephone number must be 10 or 11 digits long","boletobancario.btnLabel":"Generate Boleto","boleto.sendCopyToEmail":"Send a copy to my email","button.copy":"Copy","button.download":"Download","boleto.socialSecurityNumber":"CPF/CNPJ","creditCard.storedCard.description.ariaLabel":"Stored card ends in %@","voucher.entity":"Entity",donateButton:"Donate",notNowButton:"Not now",thanksForYourSupport:"Thanks for your support!",preauthorizeWith:"Preauthorize with",confirmPreauthorization:"Confirm preauthorization",confirmPurchase:"Confirm purchase",applyGiftcard:"Redeem",giftcardBalance:"Gift card balance",deductedBalance:"Deducted balance","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"First 2 digits of card password","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Invalid password","creditCard.taxNumber.label":"Cardholder birthdate (YYMMDD) or Corporate registration number (10 digits)","creditCard.taxNumber.labelAlt":"Corporate registration number (10 digits)","creditCard.taxNumber.invalid":"Invalid Cardholder birthdate or Corporate registration number","storedPaymentMethod.disable.button":"Remove","storedPaymentMethod.disable.confirmation":"Remove stored payment method","storedPaymentMethod.disable.confirmButton":"Yes, remove","storedPaymentMethod.disable.cancelButton":"Cancel","ach.bankAccount":"Bank account","ach.accountHolderNameField.title":"Account holder name","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Invalid account holder name","ach.accountNumberField.title":"Account number","ach.accountNumberField.invalid":"Invalid account number","ach.accountLocationField.title":"ABA routing number","ach.accountLocationField.invalid":"Invalid ABA routing number","select.state":"Select state","select.stateOrProvince":"Select state or province","select.provinceOrTerritory":"Select province or territory","select.country":"Select country","select.noOptionsFound":"No options found","select.filter.placeholder":"Search...","telephoneNumber.invalid":"Invalid telephone number",qrCodeOrApp:"or","paypal.processingPayment":"Processing payment...",generateQRCode:"Generate QR code","await.waitForConfirmation":"Waiting for confirmation","mbway.confirmPayment":"Confirm your payment on the MB WAY app","shopperEmail.invalid":"Invalid email address","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"You must be at least 18 years old","blik.confirmPayment":"Open your banking app to confirm the payment.","blik.invalid":"Enter 6 numbers","blik.code":"6-digit code","blik.help":"Get the code from your banking app.","swish.pendingMessage":"After you scan, the status can be pending for up to 10 minutes. Attempting to pay again within this time may result in multiple charges.","error.va.gen.01":"Incomplete field","error.va.gen.02":"Field not valid","error.va.sf-cc-num.01":"Invalid card number","error.va.sf-cc-num.03":"Unsupported card entered","error.va.sf-cc-dat.01":"Card too old","error.va.sf-cc-dat.02":"Date too far in the future","error.va.sf-cc-dat.03":"Your card expires before check out date","error.va.sf-ach-num.01":"Invalid account number","error.va.sf-ach-loc.01":"Invalid ABA routing number","error.va.sf-kcp-pwd.01":"Invalid password","error.giftcard.no-balance":"This gift card has zero balance","error.giftcard.card-error":"In our records we have no gift card with this number","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Sign out from Amazon","amazonpay.changePaymentDetails":"Change payment details","partialPayment.warning":"Select another payment method to pay the remaining","partialPayment.remainingBalance":"Remaining balance will be %{amount}","bankTransfer.beneficiary":"Beneficiary","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Continue to create a new bank transfer payment. You can use the details in the following screen to finalize this payment.","bankTransfer.instructions":"Thank you for your purchase, please use the following information to complete your payment.","bacs.accountHolderName":"Bank account holder name","bacs.accountHolderName.invalid":"Invalid bank account holder name","bacs.accountNumber":"Bank account number","bacs.accountNumber.invalid":"Invalid bank account number","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Invalid sort code","bacs.consent.amount":"I agree that the above amount will be deducted from my bank account.","bacs.consent.account":"I confirm the account is in my name and I am the only signatory required to authorise the Direct Debit on this account.",edit:"Edit","bacs.confirm":"Confirm and pay","bacs.result.introduction":"Download your Direct Debit Instruction (DDI / Mandate)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured card number","creditCard.encryptedCardNumber.aria.label":"Card number field","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for secured card expiry date","creditCard.encryptedExpiryDate.aria.label":"Expiry date field","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for secured card expiry month","creditCard.encryptedExpiryMonth.aria.label":"Expiry month field","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for secured card expiry year","creditCard.encryptedExpiryYear.aria.label":"Expiry year field","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured card security code","creditCard.encryptedSecurityCode.aria.label":"Security code field","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for secured gift card number","giftcard.encryptedCardNumber.aria.label":"Gift card number field","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for secured gift card security code","giftcard.encryptedSecurityCode.aria.label":"Gift card security code field",giftcardTransactionLimit:"Max. %{amount} allowed per transaction on this gift card","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for secured bank account number","ach.encryptedBankAccountNumber.aria.label":"Bank account field","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for secured bank routing number","ach.encryptedBankLocationId.aria.label":"Bank routing number field","pix.instructions":"Open the app with the PIX registered key, choose Pay with PIX and scan the QR Code or copy and paste the code","twint.saved":"saved"},Ec=Object.freeze({__proto__:null,default:Oc}),Rc="en-US",Lc=Oc,Vc={ar:function(){return Promise.resolve().then((function(){return Nk}))},"cs-CZ":function(){return Promise.resolve().then((function(){return wk}))},"da-DK":function(){return Promise.resolve().then((function(){return Pk}))},"de-DE":function(){return Promise.resolve().then((function(){return Fk}))},"el-GR":function(){return Promise.resolve().then((function(){return Dk}))},"en-US":function(){return Promise.resolve().then((function(){return Ec}))},"es-ES":function(){return Promise.resolve().then((function(){return Ak}))},"fi-FI":function(){return Promise.resolve().then((function(){return Sk}))},"fr-FR":function(){return Promise.resolve().then((function(){return xk}))},"hr-HR":function(){return Promise.resolve().then((function(){return Bk}))},"hu-HU":function(){return Promise.resolve().then((function(){return Tk}))},"it-IT":function(){return Promise.resolve().then((function(){return zk}))},"ja-JP":function(){return Promise.resolve().then((function(){return Ik}))},"ko-KR":function(){return Promise.resolve().then((function(){return jk}))},"nl-NL":function(){return Promise.resolve().then((function(){return Mk}))},"no-NO":function(){return Promise.resolve().then((function(){return Ok}))},"pl-PL":function(){return Promise.resolve().then((function(){return Ek}))},"pt-BR":function(){return Promise.resolve().then((function(){return Rk}))},"ro-RO":function(){return Promise.resolve().then((function(){return Lk}))},"ru-RU":function(){return Promise.resolve().then((function(){return Vk}))},"sk-SK":function(){return Promise.resolve().then((function(){return Uk}))},"sl-SI":function(){return Promise.resolve().then((function(){return Kk}))},"sv-SE":function(){return Promise.resolve().then((function(){return Hk}))},"zh-CN":function(){return Promise.resolve().then((function(){return qk}))},"zh-TW":function(){return Promise.resolve().then((function(){return Gk}))}},Uc=function(e){return e.toLowerCase().substring(0,2)};function Kc(e){var t=e.replace("_","-");if(new RegExp("([a-z]{2})([-])([A-Z]{2})").test(t))return t;var r=t.split("-"),a=r[0],n=r[1];if(!a||!n)return null;var o=[a.toLowerCase(),n.toUpperCase()].join("-");return 5===o.length?o:null}function Hc(e,t){if(void 0===t&&(t=[]),!e||e.length<1||e.length>5)return Rc;var r=Kc(e);return t.indexOf(r)>-1?r:function(e,t){return e&&"string"==typeof e&&t.find((function(t){return Uc(t)===Uc(e)}))||null}(r||e,t)}var qc,Gc,Yc,Wc,Jc,Zc=function(e,t){return e.replace(/%{(\w+)}/g,(function(e,r){return t[r]||""}))},Qc={IDR:1,JPY:1,KRW:1,VND:1,BYR:1,CVE:1,DJF:1,GHC:1,GNF:1,KMF:1,PYG:1,RWF:1,UGX:1,VUV:1,XAF:1,XOF:1,XPF:1,MRO:10,BHD:1e3,IQD:1e3,JOD:1e3,KWD:1e3,OMR:1e3,LYD:1e3,TND:1e3},$c=function(e,t){var r=function(e){return Qc[e]||100}(t);return parseInt(String(e),10)/r},Xc=function(){function e(e,t){var r=this;void 0===e&&(e=Rc),void 0===t&&(t={}),this.translations=Lc;var a=Object.keys(Vc);this.customTranslations=function(e,t){return void 0===e&&(e={}),Object.keys(e).reduce((function(r,a){var n=Kc(a)||Hc(a,t);return n&&(r[n]=e[a]),r}),{})}(t,a);var n=Object.keys(this.customTranslations);this.supportedLocales=Mc(Mc([],a),n).filter((function(e,t,r){return r.indexOf(e)===t})),this.locale=Kc(e)||Hc(e,this.supportedLocales)||Rc;var o=this.locale.split("-")[0];this.languageCode=o,this.loaded=function(e,t){return void 0===t&&(t={}),Ic(void 0,void 0,void 0,(function(){var r,a;return jc(this,(function(n){switch(n.label){case 0:return r=Hc(e,Object.keys(Vc))||Rc,[4,Vc[r]()];case 1:return a=n.sent(),[2,Tc(Tc(Tc({},Lc),a.default),!!t[e]&&t[e])]}}))}))}(this.locale,this.customTranslations).then((function(e){r.translations=e}))}return e.prototype.get=function(e,t){var r=function(e,t,r){void 0===r&&(r={values:{},count:0});var a=t+"__plural",n=function(e){return t+"__"+e};return Object.prototype.hasOwnProperty.call(e,n(r.count))?Zc(e[n(r.count)],r.values):Object.prototype.hasOwnProperty.call(e,a)&&r.count>1?Zc(e[a],r.values):Object.prototype.hasOwnProperty.call(e,t)?Zc(e[t],r.values):null}(this.translations,e,t);return null!==r?r:e},e.prototype.amount=function(e,t,r){return function(e,t,r,a){void 0===a&&(a={});var n=e.toString(),o=$c(n,r),i=t.replace("_","-"),l=Tc({style:"currency",currency:r,currencyDisplay:"symbol"},a);try{return o.toLocaleString(i,l)}catch(e){return n}}(e,this.locale,t,r)},e.prototype.date=function(e,t){void 0===t&&(t={});var r=Tc({year:"numeric",month:"2-digit",day:"2-digit"},t);return new Date(e).toLocaleDateString(this.locale,r)},e}(),ed={},td=[],rd=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;function ad(e,t){for(var r in t)e[r]=t[r];return e}function nd(e){var t=e.parentNode;t&&t.removeChild(e)}function od(e,t,r){var a,n,o,i=arguments,l={};for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:l[o]=t[o];if(arguments.length>3)for(r=[r],o=3;o<arguments.length;o++)r.push(i[o]);if(null!=r&&(l.children=r),"function"==typeof e&&null!=e.defaultProps)for(o in e.defaultProps)void 0===l[o]&&(l[o]=e.defaultProps[o]);return id(e,l,a,n,null)}function id(e,t,r,a,n){var o={type:e,props:t,key:r,ref:a,__k:null,__:null,__b:0,__e:null,__d:void 0,__c:null,__h:null,constructor:void 0,__v:null==n?++qc.__v:n};return null!=qc.vnode&&qc.vnode(o),o}function ld(e){return e.children}function sd(e,t){this.props=e,this.context=t}function cd(e,t){if(null==t)return e.__?cd(e.__,e.__.__k.indexOf(e)+1):null;for(var r;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e)return r.__e;return"function"==typeof e.type?cd(e):null}function dd(e){var t,r;if(null!=(e=e.__)&&null!=e.__c){for(e.__e=e.__c.base=null,t=0;t<e.__k.length;t++)if(null!=(r=e.__k[t])&&null!=r.__e){e.__e=e.__c.base=r.__e;break}return dd(e)}}function ud(e){(!e.__d&&(e.__d=!0)&&Gc.push(e)&&!pd.__r++||Wc!==qc.debounceRendering)&&((Wc=qc.debounceRendering)||Yc)(pd)}function pd(){for(var e;pd.__r=Gc.length;)e=Gc.sort((function(e,t){return e.__v.__b-t.__v.__b})),Gc=[],e.some((function(e){var t,r,a,n,o,i;e.__d&&(o=(n=(t=e).__v).__e,(i=t.__P)&&(r=[],(a=ad({},n)).__v=n.__v+1,Cd(i,n,a,t.__n,void 0!==i.ownerSVGElement,null!=n.__h?[o]:null,r,null==o?cd(n):o,n.__h),_d(r,n),n.__e!=o&&dd(n)))}))}function md(e,t,r,a,n,o,i,l,s,c){var d,u,p,m,h,f,y,b=a&&a.__k||td,v=b.length;for(r.__k=[],d=0;d<t.length;d++)if(null!=(m=r.__k[d]=null==(m=t[d])||"boolean"==typeof m?null:"string"==typeof m||"number"==typeof m||"bigint"==typeof m?id(null,m,null,null,m):Array.isArray(m)?id(ld,{children:m},null,null,null):m.__b>0?id(m.type,m.props,m.key,null,m.__v):m)){if(m.__=r,m.__b=r.__b+1,null===(p=b[d])||p&&m.key==p.key&&m.type===p.type)b[d]=void 0;else for(u=0;u<v;u++){if((p=b[u])&&m.key==p.key&&m.type===p.type){b[u]=void 0;break}p=null}Cd(e,m,p=p||ed,n,o,i,l,s,c),h=m.__e,(u=m.ref)&&p.ref!=u&&(y||(y=[]),p.ref&&y.push(p.ref,null,m),y.push(u,m.__c||h,m)),null!=h?(null==f&&(f=h),"function"==typeof m.type&&null!=m.__k&&m.__k===p.__k?m.__d=s=hd(m,s,e):s=yd(e,m,p,b,h,s),c||"option"!==r.type?"function"==typeof r.type&&(r.__d=s):e.value=""):s&&p.__e==s&&s.parentNode!=e&&(s=cd(p))}for(r.__e=f,d=v;d--;)null!=b[d]&&("function"==typeof r.type&&null!=b[d].__e&&b[d].__e==r.__d&&(r.__d=cd(a,d+1)),wd(b[d],b[d]));if(y)for(d=0;d<y.length;d++)Nd(y[d],y[++d],y[++d])}function hd(e,t,r){var a,n;for(a=0;a<e.__k.length;a++)(n=e.__k[a])&&(n.__=e,t="function"==typeof n.type?hd(n,t,r):yd(r,n,n,e.__k,n.__e,t));return t}function fd(e,t){return t=t||[],null==e||"boolean"==typeof e||(Array.isArray(e)?e.some((function(e){fd(e,t)})):t.push(e)),t}function yd(e,t,r,a,n,o){var i,l,s;if(void 0!==t.__d)i=t.__d,t.__d=void 0;else if(null==r||n!=o||null==n.parentNode)e:if(null==o||o.parentNode!==e)e.appendChild(n),i=null;else{for(l=o,s=0;(l=l.nextSibling)&&s<a.length;s+=2)if(l==n)break e;e.insertBefore(n,o),i=o}return void 0!==i?i:n.nextSibling}function bd(e,t,r){"-"===t[0]?e.setProperty(t,r):e[t]=null==r?"":"number"!=typeof r||rd.test(t)?r:r+"px"}function vd(e,t,r,a,n){var o;e:if("style"===t)if("string"==typeof r)e.style.cssText=r;else{if("string"==typeof a&&(e.style.cssText=a=""),a)for(t in a)r&&t in r||bd(e.style,t,"");if(r)for(t in r)a&&r[t]===a[t]||bd(e.style,t,r[t])}else if("o"===t[0]&&"n"===t[1])o=t!==(t=t.replace(/Capture$/,"")),t=t.toLowerCase()in e?t.toLowerCase().slice(2):t.slice(2),e.l||(e.l={}),e.l[t+o]=r,r?a||e.addEventListener(t,o?kd:gd,o):e.removeEventListener(t,o?kd:gd,o);else if("dangerouslySetInnerHTML"!==t){if(n)t=t.replace(/xlink[H:h]/,"h").replace(/sName$/,"s");else if("href"!==t&&"list"!==t&&"form"!==t&&"tabIndex"!==t&&"download"!==t&&t in e)try{e[t]=null==r?"":r;break e}catch(e){}"function"==typeof r||(null!=r&&(!1!==r||"a"===t[0]&&"r"===t[1])?e.setAttribute(t,r):e.removeAttribute(t))}}function gd(e){this.l[e.type+!1](qc.event?qc.event(e):e)}function kd(e){this.l[e.type+!0](qc.event?qc.event(e):e)}function Cd(e,t,r,a,n,o,i,l,s){var c,d,u,p,m,h,f,y,b,v,g,k=t.type;if(void 0!==t.constructor)return null;null!=r.__h&&(s=r.__h,l=t.__e=r.__e,t.__h=null,o=[l]),(c=qc.__b)&&c(t);try{e:if("function"==typeof k){if(y=t.props,b=(c=k.contextType)&&a[c.__c],v=c?b?b.props.value:c.__:a,r.__c?f=(d=t.__c=r.__c).__=d.__E:("prototype"in k&&k.prototype.render?t.__c=d=new k(y,v):(t.__c=d=new sd(y,v),d.constructor=k,d.render=Pd),b&&b.sub(d),d.props=y,d.state||(d.state={}),d.context=v,d.__n=a,u=d.__d=!0,d.__h=[]),null==d.__s&&(d.__s=d.state),null!=k.getDerivedStateFromProps&&(d.__s==d.state&&(d.__s=ad({},d.__s)),ad(d.__s,k.getDerivedStateFromProps(y,d.__s))),p=d.props,m=d.state,u)null==k.getDerivedStateFromProps&&null!=d.componentWillMount&&d.componentWillMount(),null!=d.componentDidMount&&d.__h.push(d.componentDidMount);else{if(null==k.getDerivedStateFromProps&&y!==p&&null!=d.componentWillReceiveProps&&d.componentWillReceiveProps(y,v),!d.__e&&null!=d.shouldComponentUpdate&&!1===d.shouldComponentUpdate(y,d.__s,v)||t.__v===r.__v){d.props=y,d.state=d.__s,t.__v!==r.__v&&(d.__d=!1),d.__v=t,t.__e=r.__e,t.__k=r.__k,t.__k.forEach((function(e){e&&(e.__=t)})),d.__h.length&&i.push(d);break e}null!=d.componentWillUpdate&&d.componentWillUpdate(y,d.__s,v),null!=d.componentDidUpdate&&d.__h.push((function(){d.componentDidUpdate(p,m,h)}))}d.context=v,d.props=y,d.state=d.__s,(c=qc.__r)&&c(t),d.__d=!1,d.__v=t,d.__P=e,c=d.render(d.props,d.state,d.context),d.state=d.__s,null!=d.getChildContext&&(a=ad(ad({},a),d.getChildContext())),u||null==d.getSnapshotBeforeUpdate||(h=d.getSnapshotBeforeUpdate(p,m)),g=null!=c&&c.type===ld&&null==c.key?c.props.children:c,md(e,Array.isArray(g)?g:[g],t,r,a,n,o,i,l,s),d.base=t.__e,t.__h=null,d.__h.length&&i.push(d),f&&(d.__E=d.__=null),d.__e=!1}else null==o&&t.__v===r.__v?(t.__k=r.__k,t.__e=r.__e):t.__e=function(e,t,r,a,n,o,i,l){var s,c,d,u,p=r.props,m=t.props,h=t.type,f=0;if("svg"===h&&(n=!0),null!=o)for(;f<o.length;f++)if((s=o[f])&&(s===e||(h?s.localName==h:3==s.nodeType))){e=s,o[f]=null;break}if(null==e){if(null===h)return document.createTextNode(m);e=n?document.createElementNS("http://www.w3.org/2000/svg",h):document.createElement(h,m.is&&m),o=null,l=!1}if(null===h)p===m||l&&e.data===m||(e.data=m);else{if(o=o&&td.slice.call(e.childNodes),c=(p=r.props||ed).dangerouslySetInnerHTML,d=m.dangerouslySetInnerHTML,!l){if(null!=o)for(p={},u=0;u<e.attributes.length;u++)p[e.attributes[u].name]=e.attributes[u].value;(d||c)&&(d&&(c&&d.__html==c.__html||d.__html===e.innerHTML)||(e.innerHTML=d&&d.__html||""))}if(function(e,t,r,a,n){var o;for(o in r)"children"===o||"key"===o||o in t||vd(e,o,null,r[o],a);for(o in t)n&&"function"!=typeof t[o]||"children"===o||"key"===o||"value"===o||"checked"===o||r[o]===t[o]||vd(e,o,t[o],r[o],a)}(e,m,p,n,l),d)t.__k=[];else if(f=t.props.children,md(e,Array.isArray(f)?f:[f],t,r,a,n&&"foreignObject"!==h,o,i,e.firstChild,l),null!=o)for(f=o.length;f--;)null!=o[f]&&nd(o[f]);l||("value"in m&&void 0!==(f=m.value)&&(f!==e.value||"progress"===h&&!f)&&vd(e,"value",f,p.value,!1),"checked"in m&&void 0!==(f=m.checked)&&f!==e.checked&&vd(e,"checked",f,p.checked,!1))}return e}(r.__e,t,r,a,n,o,i,s);(c=qc.diffed)&&c(t)}catch(e){t.__v=null,(s||null!=o)&&(t.__e=l,t.__h=!!s,o[o.indexOf(l)]=null),qc.__e(e,t,r)}}function _d(e,t){qc.__c&&qc.__c(t,e),e.some((function(t){try{e=t.__h,t.__h=[],e.some((function(e){e.call(t)}))}catch(e){qc.__e(e,t.__v)}}))}function Nd(e,t,r){try{"function"==typeof e?e(t):e.current=t}catch(e){qc.__e(e,r)}}function wd(e,t,r){var a,n,o;if(qc.unmount&&qc.unmount(e),(a=e.ref)&&(a.current&&a.current!==e.__e||Nd(a,null,t)),r||"function"==typeof e.type||(r=null!=(n=e.__e)),e.__e=e.__d=void 0,null!=(a=e.__c)){if(a.componentWillUnmount)try{a.componentWillUnmount()}catch(e){qc.__e(e,t)}a.base=a.__P=null}if(a=e.__k)for(o=0;o<a.length;o++)a[o]&&wd(a[o],t,r);null!=n&&nd(n)}function Pd(e,t,r){return this.constructor(e,r)}function Fd(e,t,r){var a,n,o;qc.__&&qc.__(e,t),n=(a="function"==typeof r)?null:r&&r.__k||t.__k,o=[],Cd(t,e=(!a&&r||t).__k=od(ld,null,[e]),n||ed,ed,void 0!==t.ownerSVGElement,!a&&r?[r]:n?null:t.firstChild?td.slice.call(t.childNodes):null,o,!a&&r?r:n?n.__e:t.firstChild,a),_d(o,e)}qc={__e:function(e,t){for(var r,a,n;t=t.__;)if((r=t.__c)&&!r.__)try{if((a=r.constructor)&&null!=a.getDerivedStateFromError&&(r.setState(a.getDerivedStateFromError(e)),n=r.__d),null!=r.componentDidCatch&&(r.componentDidCatch(e),n=r.__d),n)return r.__E=r}catch(t){e=t}throw e},__v:0},sd.prototype.setState=function(e,t){var r;r=null!=this.__s&&this.__s!==this.state?this.__s:this.__s=ad({},this.state),"function"==typeof e&&(e=e(ad({},r),this.props)),e&&ad(r,e),null!=e&&this.__v&&(t&&this.__h.push(t),ud(this))},sd.prototype.forceUpdate=function(e){this.__v&&(this.__e=!0,e&&this.__h.push(e),ud(this))},sd.prototype.render=ld,Gc=[],Yc="function"==typeof Promise?Promise.prototype.then.bind(Promise.resolve()):setTimeout,pd.__r=0,Jc=0;var Dd=function(e,t){return t.split(".").reduce((function(e,t){return e&&e[t]?e[t]:void 0}),e)},Ad=function(){var e=this;this.events={},this.on=function(t,r){e.events[t]=e.events[t]||[],e.events[t].push(r)},this.off=function(t,r){e.events[t]&&(e.events[t]=e.events[t].reduce((function(e,t){return t!==r&&e.push(t),e}),[]))},this.emit=function(t,r){e.events[t]&&e.events[t].forEach((function(e){e(r)}))}};function Sd(){return"xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g,(function(e){var t=16*Math.random()|0;return("x"==e?t:3&t|8).toString(16)}))}var xd=function(){function e(e){this._id=this.constructor.type+"-"+Sd(),this.eventEmitter=new Ad,this.props=this.formatProps(Tc(Tc({},this.constructor.defaultProps),e)),this._parentInstance=this.props._parentInstance,this._node=null,this.state={}}return e.prototype.formatProps=function(e){return e},e.prototype.formatData=function(){return{}},e.prototype.setState=function(e){this.state=Tc(Tc({},this.state),e)},Object.defineProperty(e.prototype,"data",{get:function(){var e=Dd(this.props,"modules.risk.data"),t=Dd(this.props,"modules.analytics.checkoutAttemptId"),r=this.state.order||this.props.order;return Tc(Tc(Tc(Tc(Tc({},e&&{riskData:{clientData:e}}),t&&{checkoutAttemptId:t}),r&&{order:{orderData:r.orderData,pspReference:r.pspReference}}),this.formatData()),{clientStateDataIndicator:!0})},enumerable:!1,configurable:!0}),e.prototype.render=function(){throw new Error("Payment method cannot be rendered.")},e.prototype.mount=function(e){var t,r="string"==typeof e?document.querySelector(e):e;if(!r)throw new Error("Component could not mount. Root node was not found.");if(this._node)throw new Error("Component is already mounted.");return this._node=r,this._component=this.render(),Fd(this._component,r),this.props.modules&&this.props.modules.analytics&&!this.props.isDropin&&this.props.modules.analytics.send({containerWidth:this._node&&this._node.offsetWidth,component:null!==(t=this.constructor.analyticsType)&&void 0!==t?t:this.constructor.type,flavor:"components"}),this},e.prototype.update=function(e){return this.props=this.formatProps(Tc(Tc({},this.props),e)),this.state={},this.unmount().remount()},e.prototype.remount=function(e){if(!this._node)throw new Error("Component is not mounted.");return Fd(e||this.render(),this._node,null),this},e.prototype.unmount=function(){return this._node&&Fd(null,this._node),this},e.prototype.remove=function(){this.unmount(),this._parentInstance&&this._parentInstance.remove(this)},e.defaultProps={},e}(),Bd="https://checkoutshopper-live.adyen.com/checkoutshopper/",Td=["amount","countryCode","environment","loadingContext","i18n","modules","order","clientKey","showPayButton","installmentOptions","onSubmit","onAdditionalDetails","onCancel","onChange","onError","onBalanceCheck","onOrderRequest","setStatusAutomatically"],zd=function(e){var t=e.loadingContext,r=void 0===t?Bd:t,a=e.extension,n=void 0===a?"svg":a,o=zc(e,["loadingContext","extension"]);return function(e){return function(e){var t=e.name,r=e.loadingContext,a=e.imageFolder,n=void 0===a?"":a,o=e.parentFolder,i=void 0===o?"":o,l=e.extension,s=e.size,c=void 0===s?"":s,d=e.subFolder;return r+"images/"+n+(void 0===d?"":d)+i+t+c+"."+l}(Tc({extension:n,loadingContext:r,imageFolder:"logos/",parentFolder:"",name:e},o))}},Id={exports:{}};!function(e){!function(){var t={}.hasOwnProperty;function r(){for(var e=[],a=0;a<arguments.length;a++){var n=arguments[a];if(n){var o=typeof n;if("string"===o||"number"===o)e.push(n);else if(Array.isArray(n)){if(n.length){var i=r.apply(null,n);i&&e.push(i)}}else if("object"===o)if(n.toString===Object.prototype.toString)for(var l in n)t.call(n,l)&&n[l]&&e.push(l);else e.push(n.toString())}}return e.join(" ")}e.exports?(r.default=r,e.exports=r):window.classNames=r}()}(Id);var jd,Md,Od,Ed=Id.exports,Rd=function(e){var t=e.inline,r=void 0!==t&&t,a=e.size;return od("div",{className:"adyen-checkout__spinner__wrapper "+(r?"adyen-checkout__spinner__wrapper--inline":"")},od("div",{className:"adyen-checkout__spinner adyen-checkout__spinner--"+(void 0===a?"large":a)}))},Ld=0,Vd=[],Ud=qc.__b,Kd=qc.__r,Hd=qc.diffed,qd=qc.__c,Gd=qc.unmount;function Yd(e,t){qc.__h&&qc.__h(Md,e,Ld||t),Ld=0;var r=Md.__H||(Md.__H={__:[],__h:[]});return e>=r.__.length&&r.__.push({}),r.__[e]}function Wd(e){return Ld=1,Jd(iu,e)}function Jd(e,t,r){var a=Yd(jd++,2);return a.t=e,a.__c||(a.__=[r?r(t):iu(void 0,t),function(e){var t=a.t(a.__[0],e);a.__[0]!==t&&(a.__=[t,a.__[1]],a.__c.setState({}))}],a.__c=Md),a.__}function Zd(e,t){var r=Yd(jd++,3);!qc.__s&&ou(r.__H,t)&&(r.__=e,r.__H=t,Md.__H.__h.push(r))}function Qd(e,t){var r=Yd(jd++,4);!qc.__s&&ou(r.__H,t)&&(r.__=e,r.__H=t,Md.__h.push(r))}function $d(e){return Ld=5,Xd((function(){return{current:e}}),[])}function Xd(e,t){var r=Yd(jd++,7);return ou(r.__H,t)&&(r.__=e(),r.__H=t,r.__h=e),r.__}function eu(e,t){return Ld=8,Xd((function(){return e}),t)}function tu(){Vd.forEach((function(e){if(e.__P)try{e.__H.__h.forEach(au),e.__H.__h.forEach(nu),e.__H.__h=[]}catch(t){e.__H.__h=[],qc.__e(t,e.__v)}})),Vd=[]}qc.__b=function(e){Md=null,Ud&&Ud(e)},qc.__r=function(e){Kd&&Kd(e),jd=0;var t=(Md=e.__c).__H;t&&(t.__h.forEach(au),t.__h.forEach(nu),t.__h=[])},qc.diffed=function(e){Hd&&Hd(e);var t=e.__c;t&&t.__H&&t.__H.__h.length&&(1!==Vd.push(t)&&Od===qc.requestAnimationFrame||((Od=qc.requestAnimationFrame)||function(e){var t,r=function(){clearTimeout(a),ru&&cancelAnimationFrame(t),setTimeout(e)},a=setTimeout(r,100);ru&&(t=requestAnimationFrame(r))})(tu)),Md=void 0},qc.__c=function(e,t){t.some((function(e){try{e.__h.forEach(au),e.__h=e.__h.filter((function(e){return!e.__||nu(e)}))}catch(r){t.some((function(e){e.__h&&(e.__h=[])})),t=[],qc.__e(r,e.__v)}})),qd&&qd(e,t)},qc.unmount=function(e){Gd&&Gd(e);var t=e.__c;if(t&&t.__H)try{t.__H.__.forEach(au)}catch(e){qc.__e(e,t.__v)}};var ru="function"==typeof requestAnimationFrame;function au(e){var t=Md;"function"==typeof e.__c&&e.__c(),Md=t}function nu(e){var t=Md;e.__c=e.__(),Md=t}function ou(e,t){return!e||e.length!==t.length||t.some((function(t,r){return t!==e[r]}))}function iu(e,t){return"function"==typeof t?t(e):t}var lu=function(e,t){var r={__c:t="__cC"+Jc++,__:e,Consumer:function(e,t){return e.children(t)},Provider:function(e){var r,a;return this.getChildContext||(r=[],(a={})[t]=this,this.getChildContext=function(){return a},this.shouldComponentUpdate=function(e){this.props.value!==e.value&&r.some(ud)},this.sub=function(e){r.push(e);var t=e.componentWillUnmount;e.componentWillUnmount=function(){r.splice(r.indexOf(e),1),t&&t.call(e)}}),e.children}};return r.Provider.__=r.Consumer.contextType=r}({i18n:new Xc,loadingContext:""});function su(){return function(e){var t=Md.context[e.__c],r=Yd(jd++,9);return r.__c=e,t?(null==r.__&&(r.__=!0,t.sub(Md)),t.props.value):e.__}(lu)}var cu=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onClick=function(e){e.preventDefault(),t.props.disabled||t.props.onClick(e,{complete:t.complete})},t.complete=function(e){void 0===e&&(e=1e3),t.setState({completed:!0}),setTimeout((function(){t.setState({completed:!1})}),e)},t}return Bc(t,e),t.prototype.render=function(e,t){var r=e.classNameModifiers,a=void 0===r?[]:r,n=e.disabled,o=e.href,i=e.icon,l=e.secondary,s=e.inline,c=e.label,d=e.status,u=t.completed,p=su().i18n,m=i?od("img",{className:"adyen-checkout__button__icon",src:i,alt:"","aria-hidden":"true"}):"",h=Mc(Mc(Mc(Mc(Mc([],a),s?["inline"]:[]),u?["completed"]:[]),l?["secondary"]:[]),"loading"===d||"redirect"===d?["loading"]:[]),f=Ed(Mc(["adyen-checkout__button"],h.map((function(e){return"adyen-checkout__button--"+e})))),y={loading:od(Rd,{size:"medium"}),redirect:od("span",{className:"adyen-checkout__button__content"},od(Rd,{size:"small",inline:!0}),p.get("payButton.redirecting")),default:od("span",{className:"adyen-checkout__button__content"},m,od("span",{className:"adyen-checkout__button__text"},c))},b=y[d]||y.default;return o?od("a",{className:f,href:o,disabled:n,target:this.props.target,rel:this.props.rel},b):od("button",{className:f,type:"button",disabled:n,onClick:this.onClick},b)},t.defaultProps={status:"default",disabled:!1,label:"",secondary:!1,inline:!1,target:"_self",onClick:function(){}},t}(sd),du=function(e,t){return e.get("payButton")+" "+((null==t?void 0:t.value)&&(null==t?void 0:t.currency)?e.amount(t.value,t.currency):"")},uu=function(e){var t=e.amount,r=e.classNameModifiers,a=void 0===r?[]:r,n=e.label,o=zc(e,["amount","classNameModifiers","label"]),i=su().i18n,l=t&&{}.hasOwnProperty.call(t,"value")&&0===t.value?i.get("confirmPreauthorization"):du(i,t);return od(cu,Tc({},o,{disabled:"loading"===o.status,classNameModifiers:Mc(Mc([],a),["pay"]),label:n||l}))},pu=function(e){function t(t){var r=e.call(this,t)||this;return r.payButton=function(e){return od(uu,Tc({},e,{amount:r.props.amount,onClick:r.submit}))},r.submit=r.submit.bind(r),r.setState=r.setState.bind(r),r.onValid=r.onValid.bind(r),r.onComplete=r.onComplete.bind(r),r.handleAction=r.handleAction.bind(r),r.elementRef=t&&t.elementRef||r,r}return Bc(t,e),t.prototype.setState=function(e){this.state=Tc(Tc({},this.state),e),this.onChange()},t.prototype.onChange=function(){var e=this.isValid,t={data:this.data,errors:this.state.errors,valid:this.state.valid,isValid:e};return this.props.onChange&&this.props.onChange(t,this.elementRef),e&&this.onValid(),t},t.prototype.onValid=function(){var e={data:this.data};return this.props.onValid&&this.props.onValid(e,this.elementRef),e},t.prototype.startPayment=function(){return Promise.resolve(!0)},t.prototype.submit=function(){var e=this,t=this.props,r=t.onError,a=void 0===r?function(){}:r,n=t.onSubmit,o=void 0===n?function(){}:n;this.startPayment().then((function(){var t=e,r=t.data,a=t.isValid;return a?(!1!==e.props.setStatusAutomatically&&e.setStatus("loading"),o({data:r,isValid:a},e.elementRef)):(e.showValidation(),!1)})).catch((function(e){return a(e)}))},t.prototype.onComplete=function(e){this.props.onComplete&&this.props.onComplete(e,this.elementRef)},t.prototype.showValidation=function(){return this.componentRef&&this.componentRef.showValidation&&this.componentRef.showValidation(),this},t.prototype.setStatus=function(e){return this.componentRef&&this.componentRef.setStatus&&this.componentRef.setStatus(e),this},t.prototype.handleAction=function(e,t){var r=this;if(void 0===t&&(t={}),!e||!e.type)throw new Error("Invalid Action");var a=this.props._parentInstance.createFromAction(e,Tc(Tc({},t),{onAdditionalDetails:function(e){return r.props.onAdditionalDetails(e,r.elementRef)}}));return a?(this.unmount(),a.mount(this._node),a):null},Object.defineProperty(t.prototype,"isValid",{get:function(){return!1},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zd({loadingContext:this.props.loadingContext})(this.constructor.type)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"accessibleName",{get:function(){return this.displayName},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"type",{get:function(){return this.props.type||this.constructor.type},enumerable:!1,configurable:!0}),t}(xd),mu=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.iframeOnLoad=function(){this.props.callback&&"function"==typeof this.props.callback&&this.props.callback(this.iframeEl.contentWindow)},t.prototype.componentDidMount=function(){this.iframeEl.addEventListener?this.iframeEl.addEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.attachEvent?this.iframeEl.attachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=this.iframeOnLoad.bind(this)},t.prototype.componentWillUnmount=function(){this.iframeEl.removeEventListener?this.iframeEl.removeEventListener("load",this.iframeOnLoad.bind(this),!1):this.iframeEl.detachEvent?this.iframeEl.detachEvent("onload",this.iframeOnLoad.bind(this)):this.iframeEl.onload=null},t.prototype.render=function(e){var t=this,r=e.name,a=e.src,n=e.width,o=e.height,i=e.minWidth,l=e.minHeight,s=e.border;return od("iframe",{ref:function(e){t.iframeEl=e},allow:e.allow,className:"adyen-checkout__iframe adyen-checkout__iframe--"+r,name:r,src:a,width:n,height:o,"min-width":i,"min-height":l,border:s,style:{border:0},frameBorder:"0",title:e.title,referrerpolicy:"origin"})},t.defaultProps={width:"0",height:"0",minWidth:"0",minHeight:"0",border:"0",src:null,allow:null,title:"components iframe"},t}(sd),hu=function(e,t,r){var a;return{promise:new Promise((function(n,o){a=setTimeout((function(){o(r)}),e),t.then((function(e){clearTimeout(a),n(e)})).catch((function(e){clearTimeout(a),o(e)}))})),cancel:function(){clearTimeout(a)}}},fu="deviceFingerprint",yu={result:{type:fu,value:"df-timedOut"},errorCode:"timeout"},bu={result:{type:fu,value:"df-failed"}},vu="unknownError",gu={timeout:"iframe loading timed out",wrongOrigin:"Result did not come from the expected origin",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},ku=function(e,t,r,a,n){return function(o){var i=Tc({},a);if((o.origin||o.originalEvent.origin)!==e)return"Message was not sent from the expected domain";if("string"!=typeof o.data)return"Event data was not of type string";if(!o.data.length)return"Invalid event data string";try{var l=JSON.parse(o.data);if(!Object.prototype.hasOwnProperty.call(l,"type")||l.type!==n)return"Event data was not of expected type";t(l)}catch(e){return r(i),!1}return!0}},Cu=function(e){var t=/^(?:([A-Za-z]+):)?(\/{0,3})([0-9.\-A-Za-z]+)(?::(\d+))?(?:\/([^?#]*))?(?:\?([^#]*))?(?:#(.*))?$/.exec(e);if(!t)return null;var r=t[1],a=t[2],n=t[3],o=t[4];return r&&a&&n?r+":"+a+n+(o?":"+o:""):null},_u=function(e){function t(t){var r=e.call(this,t)||this;return r.postMessageDomain=Cu(r.props.loadingContext)||r.props.loadingContext,r}return Bc(t,e),t.prototype.getDfpPromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=ku(e.postMessageDomain,t,r,bu,fu),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.deviceFingerPrintPromise=hu(2e4,this.getDfpPromise(),yu),this.deviceFingerPrintPromise.promise.then((function(t){e.props.onCompleteFingerprint(t),window.removeEventListener("message",e.processMessageHandler)})).catch((function(t){e.props.onErrorFingerprint(t),window.removeEventListener("message",e.processMessageHandler)}))},t.prototype.render=function(e){var t=e.dfpURL;return od("div",{className:"adyen-checkout-risk__device-fingerprint"},od(mu,{name:"dfIframe",src:t,allow:"geolocation; microphone; camera;",title:"devicefingerprinting iframe"}))},t}(sd),Nu=function(e){function t(t){var r=e.call(this,t)||this;return t.clientKey&&(r.state={status:"retrievingFingerPrint",dfpURL:r.props.loadingContext+"assets/html/"+t.clientKey+"/dfp.1.0.0.html"}),r}return Bc(t,e),t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){t.props.onComplete(e)}))},t.prototype.render=function(e,t){var r=this,a=e.loadingContext,n=t.dfpURL;return"retrievingFingerPrint"===this.state.status?od("div",{className:"adyen-checkout-risk__device-fingerprint--wrapper",style:{position:"absolute",width:0,height:0}},od(_u,{loadingContext:a,dfpURL:n,onCompleteFingerprint:function(e){r.setStatusComplete(e)},onErrorFingerprint:function(e){var t;r.props.onError({errorCode:t=e.errorCode,message:gu[t]||gu[vu],type:fu}),r.setStatusComplete(e.result)}})):null},t.defaultProps={onComplete:function(){},onError:function(){}},t}(sd),wu=window.atob,Pu=window.btoa,Fu={decode:function(e){return!!Fu.isBase64(e)&&(!!Fu.isBase64(e)&&(t=e,decodeURIComponent(Array.prototype.map.call(wu(t),(function(e){return"%"+("00"+e.charCodeAt(0).toString(16)).slice(-2)})).join(""))));var t},encode:function(e){return Pu(e)},isBase64:function(e){return!!e&&(!(e.length%4)&&Pu(wu(e))===e)}},Du=function(e){function t(t){var r,a=e.call(this,t)||this;a.nodeRiskContainer=null,a.onComplete=function(e){var t,r=Tc(Tc({},a.state.data),((t={})[e.type]=e.value,t.persistentCookie=e.persistentCookie,t.components=e.components,t));a.setState({data:r,isValid:!0}),a.props.risk.onComplete(a.data),a.cleanUp()},a.onError=function(e){a.props.risk.onError(e),a.cleanUp()},a.cleanUp=function(){a.nodeRiskContainer&&a.nodeRiskContainer.remove()};var n=((r={}).deviceFingerprint=null,r);return a.setState({data:n}),!0===a.props.risk.enabled&&(document.querySelector(a.props.risk.node)?(a.nodeRiskContainer=document.createElement("div"),document.querySelector(a.props.risk.node).appendChild(a.nodeRiskContainer),a.mount(a.nodeRiskContainer)):a.onError({message:"RiskModule node was not found"})),a}return Bc(t,e),t.prototype.formatProps=function(e){return Tc(Tc({},e),{risk:Tc(Tc({},t.defaultProps.risk),e.risk)})},Object.defineProperty(t.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"data",{get:function(){if(this.isValid){var e=Tc({version:"1.0.0"},this.state.data);return Fu.encode(JSON.stringify(e))}return!1},enumerable:!1,configurable:!0}),t.prototype.componentWillUnmount=function(){this.cleanUp()},t.prototype.render=function(){return od(Nu,Tc({},this.props,{loadingContext:this.props.loadingContext,onComplete:this.onComplete,onError:this.onError}))},t.type="risk",t.defaultProps={risk:{enabled:!0,onComplete:function(){},onError:function(){},node:"body"}},t}(xd);function Au(e){var t=e.children,r=e.classNameModifiers,a=void 0===r?[]:r,n=e.label,o=e.readonly,i=void 0!==o&&o,l=su().i18n;return od("div",{className:Ed(Mc(Mc(["adyen-checkout__fieldset"],a.map((function(e){return"adyen-checkout__fieldset--"+e}))),[{"adyen-checkout__fieldset--readonly":i}]))},n&&od("div",{className:"adyen-checkout__fieldset__title"},l.get(n)),od("div",{className:"adyen-checkout__fieldset__fields"},t))}var Su,xu=function(e){var t=e.type,r=e.className,a=void 0===r?"":r,n=su().loadingContext,o=zd({loadingContext:n,imageFolder:"components/"})(t);return od("img",{className:Ed("adyen-checkout__icon",a),alt:t,src:o})},Bu=Date.now(),Tu=function(e){return void 0===e&&(e="field"),e+"-"+(Bu+=1)},zu="Unsupported card entered",Iu="-ariaError",ju=((Su={})["incomplete field"]="error.va.gen.01",Su["field not valid"]="error.va.gen.02",Su["luhn check failed"]="error.va.sf-cc-num.01",Su["Card too old"]="error.va.sf-cc-dat.01",Su["Date too far in future"]="error.va.sf-cc-dat.02",Su["Your card expires before check out date"]="error.va.sf-cc-dat.03",Su["Unsupported card entered"]="error.va.sf-cc-num.03",Su),Mu=ju["incomplete field"],Ou=function(e){function t(t){var r=e.call(this,t)||this;return r.state={focused:!1},r.onFocus=r.onFocus.bind(r),r.onBlur=r.onBlur.bind(r),r.uniqueId=Tu("adyen-checkout-"+r.props.name),r}return Bc(t,e),t.prototype.onFocus=function(e){var t=this;this.setState({focused:!0},(function(){t.props.onFocus&&t.props.onFocus(e)}))},t.prototype.onBlur=function(e){var t=this;this.setState({focused:!1},(function(){t.props.onBlur&&t.props.onBlur(e),t.props.onFieldBlur&&t.props.onFieldBlur(e)}))},t.getDerivedStateFromProps=function(e,t){return void 0!==e.focused&&e.focused!==t.focused?{focused:e.focused}:void 0!==e.filled&&e.filled!==t.filled?{filled:e.filled}:null},t.prototype.render=function(e){var t=this,r=e.className,a=void 0===r?"":r,n=e.classNameModifiers,o=void 0===n?[]:n,i=e.children,l=e.errorMessage,s=e.helper,c=e.inputWrapperModifiers,d=void 0===c?[]:c,u=e.isLoading,p=e.isValid,m=e.label,h=e.dualBrandingElements,f=e.dir,y=e.name,b=e.showValidIcon;return od("div",{className:Ed("adyen-checkout__field",a,o.map((function(e){return"adyen-checkout__field--"+e})),{"adyen-checkout__field--error":l,"adyen-checkout__field--valid":p})},od("label",{onClick:this.props.onFocusField,className:Ed({"adyen-checkout__label":!0,"adyen-checkout__label--focused":this.state.focused,"adyen-checkout__label--filled":this.state.filled,"adyen-checkout__label--disabled":this.props.disabled}),htmlFor:y&&this.uniqueId},"string"==typeof m&&od("span",{className:Ed({"adyen-checkout__label__text":!0,"adyen-checkout__label__text--error":l})},m),"function"==typeof m&&m(),s&&od("span",{className:"adyen-checkout__helper-text"},s),od("div",{className:Ed(Mc(["adyen-checkout__input-wrapper"],d.map((function(e){return"adyen-checkout__input-wrapper--"+e})))),dir:f},fd(i).map((function(e){return function(e,t,r){var a,n,o,i=arguments,l=ad({},e.props);for(o in t)"key"==o?a=t[o]:"ref"==o?n=t[o]:l[o]=t[o];if(arguments.length>3)for(r=[r],o=3;o<arguments.length;o++)r.push(i[o]);return null!=r&&(l.children=r),id(e.type,l,a||e.key,n||e.ref,null)}(e,Tc({isValid:p,onFocus:t.onFocus,onBlur:t.onBlur,isInvalid:!!l},y&&{uniqueId:t.uniqueId}))})),u&&od("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--loading"},od(Rd,{size:"small"})),p&&!1!==b&&!h&&od("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--valid"},od(xu,{type:"checkmark"})),l&&od("span",{className:"adyen-checkout-input__inline-validation adyen-checkout-input__inline-validation--invalid"},od(xu,{type:"field_error"}))),l&&l.length&&od("span",{className:"adyen-checkout__error-text","aria-live":"polite",id:""+this.uniqueId+Iu},l)))},t}(sd),Eu=function(e){var t=e.data,r=t.name,a=t.registrationNumber;return od(Au,{classNameModifiers:["companyDetails"],label:"companyDetails",readonly:!0},r&&r+" ",a&&a+" ")};function Ru(e){var t=e.autoCorrect,r=e.classNameModifiers,a=e.isInvalid,n=e.isValid,o=e.readonly,i=void 0===o?null:o,l=e.spellCheck,s=e.type,c=e.uniqueId,d=Wd(!1),u=d[0],p=d[1],m=Ed("adyen-checkout__input",["adyen-checkout__input--"+s],e.className,{"adyen-checkout__input--invalid":a,"adyen-checkout__input--valid":n},r.map((function(e){return"adyen-checkout__input--"+e})));e.classNameModifiers,e.uniqueId;var h=zc(e,["classNameModifiers","uniqueId"]);return od("input",Tc({id:c},h,{type:s,className:m,onInput:function(t){t.target.value=t.target.value.replace(/[\uff01-\uff5e]/g,(function(e){return String.fromCharCode(e.charCodeAt(0)-65248)})),e.onInput(t)},readOnly:i,spellCheck:l,autoCorrect:t,"aria-describedby":""+c+Iu,onChange:function(t){var r;p(!0),null===(r=null==e?void 0:e.onChange)||void 0===r||r.call(e,t)},onBlur:function(t){var r,a;u||null===(r=null==e?void 0:e.onChange)||void 0===r||r.call(e,t),p(!1),null===(a=null==e?void 0:e.onBlur)||void 0===a||a.call(e,t)}}))}function Lu(e){return od(Ru,Tc({classNameModifiers:["large"]},e,{"aria-required":e.required,type:"text"}))}Ru.defaultProps={type:"text",classNameModifiers:[]};var Vu=function(){var e=document.createElement("input");return e.setAttribute("type","date"),"date"===e.type},Uu=function(e){if(void 0===e&&(e=""),-1===e.indexOf("/"))return e;var t=e.split("/"),r=t[0],a=void 0===r?"":r,n=t[1],o=void 0===n?"":n,i=t[2],l=void 0===i?"":i;return a&&o&&l?l+"-"+o+"-"+a:null};function Ku(e){return od(Ru,Xd(Vu,[])?Tc({},e,{type:"date"}):Tc({},e,{onInput:function(t){var r=t.target.value;t.target.value=function(e){var t=e.replace(/\D|\s/g,"").replace(/^(00)(.*)?/,"01$2").replace(/^(3[2-9])(.*)?/,"0$1$2").replace(/^([4-9])(.*)?/,"0$1").replace(/^([0-9]{2})(00)(.*)?/,"$101").replace(/^(3[01])(02)(.*)?/,"29$2").replace(/^([0-9]{2})([2-9]|1[3-9])(.*)?/,"$10$2").replace(/^([0-9]{2})([0-9]{2})([0-9])/,"$1/$2/$3").replace(/^([0-9]{2})([0-9])/,"$1/$2"),r=t.split("/"),a=r[0],n=void 0===a?"":a,o=r[1],i=void 0===o?"":o,l=r[2],s=void 0===l?"":l;return 4===s.length&&"29"===n&&"02"===i&&(Number(s)%4!=0||"00"===s.substr(2,2)&&Number(s)%400!=0)?t.replace(/^29/,"28"):t}(r),e.onInput(t)},maxLength:10}))}function Hu(e){return od(Ru,Tc({},e,{type:"tel"}))}function qu(e){return od(Ru,Tc({},e,{type:"email",autoCapitalize:"off"}))}function Gu(e){var t=e.items,r=e.i18n,a=e.name,n=e.onChange,o=e.value,i=e.isInvalid,l=e.uniqueId,s=null==l?void 0:l.replace(/[0-9]/g,"").substring(0,l.lastIndexOf("-"));return od("div",{className:"adyen-checkout__radio_group"},t.map((function(t){var l=Tu(s);return od("div",{key:t.id,className:"adyen-checkout__radio_group__input-wrapper"},od("input",{id:l,type:"radio",checked:o===t.id,className:"adyen-checkout__radio_group__input",name:a,onChange:n,onClick:n,value:t.id}),od("label",{className:Ed(["adyen-checkout__label__text","adyen-checkout__radio_group__label",e.className,{"adyen-checkout__radio_group__label--invalid":i}]),htmlFor:l},r.get(t.name)))})))}function Yu(e){var t=e.classNameModifiers,r=void 0===t?[]:t,a=e.label,n=e.isInvalid,o=e.onChange,i=zc(e,["classNameModifiers","label","isInvalid","onChange"]);return od("label",{className:"adyen-checkout__checkbox"},od("input",Tc({},i,{className:Ed(["adyen-checkout__checkbox__input",[i.className],{"adyen-checkout__checkbox__input--invalid":n},r.map((function(e){return"adyen-checkout__input--"+e}))]),type:"checkbox",onChange:o})),od("span",{className:"adyen-checkout__checkbox__label"},a))}Gu.defaultProps={onChange:function(){},items:[]},Yu.defaultProps={onChange:function(){}};var Wu="Select-module_adyen-checkout__dropdown__2kGp2",Ju="Select-module_adyen-checkout__dropdown__button__waz0I",Zu="Select-module_adyen-checkout__dropdown__button--active__1EqeU",Qu="Select-module_adyen-checkout__filter-input__HMjy5",$u="Select-module_adyen-checkout__dropdown__list__2UxAp",Xu="Select-module_adyen-checkout__dropdown__list--active__Mlt8t",ep="Select-module_adyen-checkout__dropdown__element__3nIQR";function tp(e){var t=e.backgroundUrl,r=void 0===t?"":t,a=e.className,n=void 0===a?"":a,o=e.classNameModifiers,i=void 0===o?[]:o,l=e.src,s=void 0===l?"":l,c=e.alt,d=void 0===c?"":c,u=e.showOnError,p=void 0!==u&&u,m=Wd(!1),h=m[0],f=m[1],y=$d(null),b=function(){f(!0)},v=Ed.apply(void 0,Mc([[n],"adyen-checkout__image",{"adyen-checkout__image--loaded":h}],i.map((function(e){return"adyen-checkout__image--"+e}))));return Zd((function(){var e=r?new Image:y.current;e.src=r||s,e.onload=b,f(!!e.complete)}),[]),r?od("div",Tc({style:{backgroundUrl:r}},e,{className:v})):od("img",Tc({},e,{alt:d,ref:y,className:v,onError:function(){f(p)}}))}function rp(e){var t=e.filterable,r=e.toggleButtonRef,a=zc(e,["filterable","toggleButtonRef"]);return od(t?"div":"button",Tc({},a,{ref:r}))}function ap(e){var t,r=su().i18n,a=e.active,n=e.readonly,o=e.showList;return od(rp,{"aria-disabled":n,"aria-expanded":o,"aria-haspopup":"listbox",className:Ed((t={"adyen-checkout__dropdown__button":!0},t[Ju]=!0,t["adyen-checkout__dropdown__button--readonly"]=n,t["adyen-checkout__dropdown__button--active"]=o,t[Zu]=o,t["adyen-checkout__dropdown__button--invalid"]=e.isInvalid,t["adyen-checkout__dropdown__button--valid"]=e.isValid,t)),filterable:e.filterable,onClick:n?null:e.toggleList,onKeyDown:n?null:e.onButtonKeyDown,role:e.filterable?"button":null,tabIndex:"0",title:a.name||e.placeholder,toggleButtonRef:e.toggleButtonRef,type:e.filterable?null:"button","aria-describedby":e.ariaDescribedBy,id:e.id},o&&e.filterable?od("input",{"aria-autocomplete":"list","aria-controls":e.selectListId,"aria-expanded":o,"aria-owns":e.selectListId,autoComplete:"off",className:Ed("adyen-checkout__filter-input",[Qu]),onInput:e.onInput,placeholder:r.get("select.filter.placeholder"),ref:e.filterInputRef,role:"combobox",type:"text"}):od(ld,null,od("span",{className:"adyen-checkout__dropdown__button__text"},a.selectedOptionName||a.name||e.placeholder),a.icon&&od(tp,{className:"adyen-checkout__dropdown__button__icon",src:a.icon,alt:a.name})))}var np=function(e){var t=e.item,r=e.selected,a=zc(e,["item","selected"]);return od("li",{"aria-disabled":!!t.disabled,"aria-selected":r,className:Ed(["adyen-checkout__dropdown__element",ep,{"adyen-checkout__dropdown__element--active":r,"adyen-checkout__dropdown__element--disabled":!!t.disabled}]),"data-disabled":!!t.disabled,"data-value":t.id,onClick:a.onSelect,onKeyDown:a.onKeyDown,role:"option",tabIndex:-1},od("span",null,t.name),t.icon&&od(tp,{className:"adyen-checkout__dropdown__element__icon",alt:t.name,src:t.icon}))};function op(e){var t,r=e.active,a=e.items,n=e.showList,o=e.textFilter,i=zc(e,["active","items","showList","textFilter"]),l=su().i18n,s=a.filter((function(e){return!o||e.name.toLowerCase().includes(o)}));return od("ul",{className:Ed((t={test:!0,"adyen-checkout__dropdown__list":!0},t[$u]=!0,t["adyen-checkout__dropdown__list--active"]=n,t[Xu]=n,t)),id:i.selectListId,ref:i.selectListRef,role:"listbox"},s.length?s.map((function(e){return od(np,{item:e,key:e.id,onKeyDown:i.onKeyDown,onSelect:i.onSelect,selected:e.id===r.id})})):od("div",{className:"adyen-checkout__dropdown__element adyen-checkout__dropdown__element--no-options"},l.get("select.noOptionsFound")))}var ip={arrowDown:"ArrowDown",arrowUp:"ArrowUp",enter:"Enter",escape:"Escape",space:" ",tab:"Tab"};function lp(e){var t=e.items,r=void 0===t?[]:t,a=e.className,n=void 0===a?"":a,o=e.classNameModifiers,i=void 0===o?[]:o,l=e.filterable,s=void 0===l||l,c=e.readonly,d=void 0!==c&&c,u=e.onChange,p=void 0===u?function(){}:u,m=e.selected,h=e.name,f=e.isInvalid,y=e.isValid,b=e.placeholder,v=e.uniqueId,g=$d(null),k=$d(null),C=$d(null),_=$d(null),N=Wd(null),w=N[0],P=N[1],F=Wd(!1),D=F[0],A=F[1],S=Xd((function(){return"select-"+Sd()}),[]),x=r.find((function(e){return e.id===m}))||{},B=function(){P(null),A(!1),C.current&&C.current.focus()},T=function(e){e.preventDefault();var t=_.current.contains(e.currentTarget)?e.currentTarget:_.current.firstElementChild;if(!t.getAttribute("data-disabled")){B();var r=t.getAttribute("data-value");p({target:{value:r,name:h}})}},z=function(e){(e.composedPath?!e.composedPath().includes(k.current):!k.current.contains(e.target))&&A(!1)};return Zd((function(){D&&s&&g.current&&g.current.focus()}),[D]),Zd((function(){return document.addEventListener("click",z,!1),function(){document.removeEventListener("click",z,!1)}}),[]),od("div",{className:Ed(Mc(["adyen-checkout__dropdown",Wu,n],i.map((function(e){return"adyen-checkout__dropdown--"+e})))),ref:k},od(ap,{id:null!=v?v:null,active:x,filterInputRef:g,filterable:s,isInvalid:f,isValid:y,onButtonKeyDown:function(e){var t;e.key===ip.enter&&s&&D&&w?T(e):e.key===ip.escape?B():![ip.arrowUp,ip.arrowDown,ip.enter].includes(e.key)&&(e.key!==ip.space||s&&D)?(e.shiftKey&&e.key===ip.tab||e.key===ip.tab)&&B():(e.preventDefault(),A(!0),(null===(t=_.current)||void 0===t?void 0:t.firstElementChild)&&_.current.firstElementChild.focus())},onInput:function(e){var t=e.target.value;P(t.toLowerCase())},placeholder:b,readonly:d,selectListId:S,showList:D,toggleButtonRef:C,toggleList:function(e){e.preventDefault(),A(!D)},ariaDescribedBy:v?""+v+Iu:null}),od(op,{active:x,items:r,onKeyDown:function(e){var t=e.target;switch(e.key){case ip.escape:e.preventDefault(),B();break;case ip.space:case ip.enter:T(e);break;case ip.arrowDown:e.preventDefault(),t.nextElementSibling&&t.nextElementSibling.focus();break;case ip.arrowUp:e.preventDefault(),t.previousElementSibling?t.previousElementSibling.focus():s&&g.current&&g.current.focus();break;case ip.tab:B()}},onSelect:T,selectListId:S,selectListRef:_,showList:D,textFilter:w}))}lp.defaultProps={className:"",classNameModifiers:[],filterable:!0,items:[],readonly:!1,onChange:function(){}};var sp=function(e,t){var r={boolean:Yu,date:Ku,emailAddress:qu,radio:Gu,select:lp,tel:Hu,text:Lu,default:Lu};return od(r[e]||r.default,Tc({},t))},cp=/^\s*[\w\-+_]+(\.[\w\-+_]+)*@[\w\-+_]+\.[\w\-+_]+(\.[\w-+_]+)*\s*$/,dp=/^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,up=function(){function e(e,t,r,a){this.shouldValidate=e.modes.includes(r),this.isValid=e.validate(t,a),this.errorMessage=e.errorMessage}return e.prototype.hasError=function(){return!this.isValid&&this.shouldValidate},e}(),pp=function(){function e(e){this.validationResults=e}return Object.defineProperty(e.prototype,"isValid",{get:function(){return this.validationResults.every((function(e){return e.isValid}))},enumerable:!1,configurable:!0}),e.prototype.hasError=function(){return Boolean(this.getError())},e.prototype.getError=function(){return this.validationResults.find((function(e){return e.hasError()}))},e.prototype.getAllErrors=function(){return this.validationResults.filter((function(e){return e.hasError()}))},e}(),mp=function(){function e(e){void 0===e&&(e={}),this.rules={shopperEmail:{validate:function(e){return cp.test(e)},errorMessage:"error.va.gen.01",modes:["blur"]},default:{validate:function(){return!0},modes:["blur","input"]}},this.setRules(e)}return e.prototype.setRules=function(e){this.rules=Tc(Tc({},this.rules),e)},e.prototype.getRulesFor=function(e){var t,r=null!==(t=this.rules[e])&&void 0!==t?t:this.rules.default;return Array.isArray(r)||(r=[r]),r},e.prototype.validate=function(e,t){var r=e.key,a=e.value,n=e.mode,o=void 0===n?"blur":n,i=this.getRulesFor(r).map((function(e){return new up(e,a,o,t)}));return new pp(i)},e}(),hp=function(e,t){return Object.keys(e).filter((function(e){return!t.includes(e)})).reduce((function(t,r){return t[r]=e[r],t}),{})},fp=function(e,t,r,a){return t.reduce((function(e,t){var n,o,i;return Tc(Tc({},e),((n={})[t]=null!==(i=null!==(o=e[t])&&void 0!==o?o:a[t])&&void 0!==i?i:r,n))}),e)};function yp(e){var t=e.schema,r=e.defaultData,a=e.processField,n=t.reduce((function(e,t){var n,o,i,l=function(e){var t;if(void 0===r[e])return{valid:!1,errors:null,data:null};var n=a({key:e,value:r[e],mode:"blur"},{state:{data:r}}),o=n[0],i=n[1];return{valid:null!==(t=i.isValid)&&void 0!==t&&t,errors:i.hasError()?i.getError():null,data:o}}(t),s=l.valid,c=l.errors,d=l.data;return{valid:Tc(Tc({},e.valid),(n={},n[t]=s,n)),errors:Tc(Tc({},e.errors),(o={},o[t]=c,o)),data:Tc(Tc({},e.data),(i={},i[t]=d,i))}}),{data:{},valid:{},errors:{}});return{schema:t,data:n.data,valid:n.valid,errors:n.errors}}function bp(e){var t,r=e.rules,a=void 0===r?{}:r,n=e.formatters,o=void 0===n?{}:n,i=e.defaultData,l=void 0===i?{}:i,s=Xd((function(){return new mp(a)}),[]),c=function(e,t){var r=e.key,a=e.value,n=e.mode,i=o[r]?o[r](null!=a?a:""):a;return[i,s.validate({key:r,value:i,mode:n},t)]},d=Jd(function(e){return function(t,r){var a,n,o,i,l,s,c,d=r.type,u=r.key,p=r.value,m=r.mode,h=r.defaultData,f=r.schema;switch(d){case"setData":return Tc(Tc({},t),{data:Tc(Tc({},t.data),(a={},a[u]=p,a))});case"setValid":return Tc(Tc({},t),{valid:Tc(Tc({},t.valid),(n={},n[u]=p,n))});case"setErrors":return Tc(Tc({},t),{errors:Tc(Tc({},t.errors),(o={},o[u]=p,o))});case"updateField":var y=e({key:u,value:p,mode:m},{state:t}),b=y[0],v=y[1];return Tc(Tc({},t),{data:Tc(Tc({},t.data),(i={},i[u]=b,i)),errors:Tc(Tc({},t.errors),(l={},l[u]=v.hasError()?v.getError():null,l)),valid:Tc(Tc({},t.valid),(s={},s[u]=null!==(c=v.isValid)&&void 0!==c&&c,s))});case"setSchema":var g=yp({schema:f,defaultData:h,processField:e}),k=t.schema.filter((function(e){return!f.includes(e)})),C=f.filter((function(e){return!t.schema.includes(e)})),_=fp(hp(t.data,k),C,null,g.data),N=fp(hp(t.valid,k),C,!1,g.valid),w=fp(hp(t.errors,k),C,null,g.errors);return Tc(Tc({},t),{schema:f,data:_,valid:N,errors:w});case"validateForm":var P=t.schema.reduce((function(r,a){var n,o,i,l=e({key:a,value:t.data[a],mode:"blur"},{state:t})[1];return{valid:Tc(Tc({},r.valid),(n={},n[a]=null!==(i=l.isValid)&&void 0!==i&&i,n)),errors:Tc(Tc({},r.errors),(o={},o[a]=l.hasError()?l.getError():null,o))}}),{valid:t.valid,errors:t.errors});return Tc(Tc({},t),{valid:P.valid,errors:P.errors});default:throw new Error("Undefined useForm action")}}}(c),{defaultData:l,schema:null!==(t=e.schema)&&void 0!==t?t:[],processField:c},yp),u=d[0],p=d[1],m=Xd((function(){return u.schema.every((function(e){return u.valid[e]}))}),[u.schema,u.valid]),h=eu((function(){p({type:"validateForm"})}),[]),f=eu((function(e,t){return p({type:"setErrors",key:e,value:t})}),[]),y=eu((function(e,t){return p({type:"setValid",key:e,value:t})}),[]),b=eu((function(e,t){return p({type:"setData",key:e,value:t})}),[]);return{handleChangeFor:function(e,t){return void 0===t&&(t="blur"),function(r){var a=function(e,t){return t.target?"checkbox"===t.target.type?!u.data[e]:t.target.value:t}(e,r);p({type:"updateField",key:e,value:a,mode:t})}},triggerValidation:h,setSchema:eu((function(e){return p({type:"setSchema",schema:e,defaultData:l})}),[u.schema]),setData:b,setValid:y,setErrors:f,isValid:m,schema:u.schema,valid:u.valid,errors:u.errors,data:u.data}}function vp(e){var t=e.label,r=void 0===t?"":t,a=e.namePrefix,n=e.requiredFields,o=e.visibility,i=su().i18n,l=bp({schema:n,rules:e.validationRules,defaultData:e.data}),s=l.handleChangeFor,c=l.triggerValidation,d=l.data,u=l.valid,p=l.errors,m=l.isValid,h=function(e){return(a?a+".":"")+e},f=function(e){return function(t){var r=t.target.name.split(a+".").pop();s(r,e)(t)}};return Zd((function(){var t=function(e){var t=e.name,r=e.registrationNumber;return Tc({},(t||r)&&{company:Tc(Tc({},t&&{name:t}),r&&{registrationNumber:r})})}(d);e.onChange({data:t,valid:u,errors:p,isValid:m})}),[d,u,p,m]),this.showValidation=c,"hidden"===o?null:"readOnly"===o?od(Eu,Tc({},e,{data:d})):od(Au,{classNameModifiers:[r],label:r},n.includes("name")&&od(Ou,{label:i.get("companyDetails.name"),classNameModifiers:["name"],errorMessage:!!p.name},sp("text",{name:h("name"),value:d.name,classNameModifiers:["name"],onInput:f("input"),onChange:f("blur"),spellCheck:!1})),n.includes("registrationNumber")&&od(Ou,{label:i.get("companyDetails.registrationNumber"),classNameModifiers:["registrationNumber"],errorMessage:!!p.registrationNumber},sp("text",{name:h("registrationNumber"),value:d.registrationNumber,classNameModifiers:["registrationNumber"],onInput:f("input"),onChange:f("blur"),spellCheck:!1})))}vp.defaultProps={data:{},onChange:function(){},visibility:"editable",requiredFields:["name","registrationNumber"],validationRules:{default:{validate:function(e){return e&&e.length>0},modes:["blur"]}}};var gp,kp,Cp,_p,Np,wp,Pp,Fp,Dp,Ap=function(e){var t=e.data,r=t.firstName,a=t.lastName,n=t.shopperEmail,o=t.telephoneNumber;return od(Au,{classNameModifiers:["personalDetails"],label:"personalDetails",readonly:!0},r&&r+" ",a&&a+" ",n&&od(ld,null,od("br",null),n),o&&od(ld,null,od("br",null),o))},Sp={default:{validate:function(e){return e&&e.length>0},modes:["blur"]},dateOfBirth:{validate:function(e){return function(e){if(!e)return!1;var t=Uu(e),r=Date.now()-Date.parse(t);return new Date(r).getFullYear()-1970>=18}(e)},errorMessage:"dateOfBirth.invalid",modes:["blur"]},telephoneNumber:{validate:function(e){return dp.test(e)},modes:["blur"]},shopperEmail:{validate:function(e){return cp.test(e)},modes:["blur"]}};function xp(e){var t=e.label,r=void 0===t?"":t,a=e.namePrefix,n=e.placeholders,o=e.requiredFields,i=e.visibility,l=su().i18n,s=Xd(Vu,[]),c=bp({schema:o,rules:e.validationRules,defaultData:e.data}),d=c.handleChangeFor,u=c.triggerValidation,p=c.data,m=c.valid,h=c.errors,f=c.isValid,y=function(e){return function(t){var r=t.target.name.split(a+".").pop();d(r,e)(t)}},b=function(e){return(a?a+".":"")+e},v=function(e){return e&&e.errorMessage?l.get(e.errorMessage):!!e};return Zd((function(){var t=function(e){var t=e.firstName,r=e.lastName,a=e.gender,n=e.dateOfBirth,o=e.shopperEmail,i=e.telephoneNumber;return Tc(Tc(Tc(Tc({},(t||r)&&{shopperName:Tc(Tc(Tc({},t&&{firstName:t}),r&&{lastName:r}),a&&{gender:a})}),n&&{dateOfBirth:Uu(n)}),o&&{shopperEmail:o}),i&&{telephoneNumber:i})}(p);e.onChange({data:t,valid:m,errors:h,isValid:f})}),[p,m,h,f]),this.showValidation=u,"hidden"===i?null:"readOnly"===i?od(Ap,Tc({},e,{data:p})):od(Au,{classNameModifiers:["personalDetails"],label:r},o.includes("firstName")&&od(Ou,{label:l.get("firstName"),classNameModifiers:["col-50","firstName"],errorMessage:!!h.firstName,name:"firstName"},sp("text",{name:b("firstName"),value:p.firstName,classNameModifiers:["firstName"],onInput:y("input"),onChange:y("blur"),placeholder:n.firstName,spellCheck:!1})),o.includes("lastName")&&od(Ou,{label:l.get("lastName"),classNameModifiers:["col-50","lastName"],errorMessage:!!h.lastName,name:"lastName"},sp("text",{name:b("lastName"),value:p.lastName,classNameModifiers:["lastName"],onInput:y("input"),onChange:y("blur"),placeholder:n.lastName,spellCheck:!1})),o.includes("gender")&&od(Ou,{errorMessage:!!h.gender,classNameModifiers:["gender"],name:"gender"},sp("radio",{i18n:l,name:b("gender"),value:p.gender,items:[{id:"MALE",name:"male"},{id:"FEMALE",name:"female"}],classNameModifiers:["gender"],onInput:y("input"),onChange:y("blur")})),o.includes("dateOfBirth")&&od(Ou,{label:l.get("dateOfBirth"),classNameModifiers:["col-50","lastName"],errorMessage:v(h.dateOfBirth),helper:s?null:l.get("dateOfBirth.format"),name:"dateOfBirth"},sp("date",{name:b("dateOfBirth"),value:p.dateOfBirth,classNameModifiers:["dateOfBirth"],onInput:y("input"),onChange:y("blur"),placeholder:n.dateOfBirth})),o.includes("shopperEmail")&&od(Ou,{label:l.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:v(h.shopperEmail),dir:"ltr",name:"emailAddress"},sp("emailAddress",{name:b("shopperEmail"),value:p.shopperEmail,classNameModifiers:["shopperEmail"],onInput:y("input"),onChange:y("blur"),placeholder:n.shopperEmail})),o.includes("telephoneNumber")&&od(Ou,{label:l.get("telephoneNumber"),classNameModifiers:["telephoneNumber"],errorMessage:v(h.telephoneNumber),dir:"ltr",name:"telephoneNumber"},sp("tel",{name:b("telephoneNumber"),value:p.telephoneNumber,classNameModifiers:["telephoneNumber"],onInput:y("input"),onChange:y("blur"),placeholder:n.telephoneNumber})))}xp.defaultProps={data:{},onChange:function(){},placeholders:{},requiredFields:["firstName","lastName","gender","dateOfBirth","shopperEmail","telephoneNumber"],validationRules:Sp,visibility:"editable"};var Bp="N/A",Tp=["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],zp=Tp[0],Ip=Tp[1],jp=Tp[2],Mp=Tp[3],Op=Tp[4],Ep=Tp[5],Rp={AU:{hasDataset:!0,labels:(gp={},gp[Ip]="apartmentSuite",gp[Op]="state",gp[zp]="address",gp),optionalFields:[Ip],placeholders:(kp={},kp[Op]="select.state",kp),schema:[Ep,zp,Ip,Mp,[[Op,50],[jp,50]]]},BR:{hasDataset:!0,labels:(Cp={},Cp[Op]="state",Cp),placeholders:(_p={},_p[Op]="select.state",_p)},CA:{hasDataset:!0,labels:(Np={},Np[Ip]="apartmentSuite",Np[Op]="provinceOrTerritory",Np[zp]="address",Np),optionalFields:[Ip],schema:[Ep,zp,Ip,[[Mp,70],[jp,30]],Op]},GB:{labels:(wp={},wp[Mp]="cityTown",wp),schema:[Ep,[[Ip,30],[zp,70]],[[Mp,70],[jp,30]],Op]},US:{hasDataset:!0,labels:(Pp={},Pp[jp]="zipCode",Pp[Ip]="apartmentSuite",Pp[Op]="state",Pp[zp]="address",Pp),optionalFields:[Ip],placeholders:(Fp={},Fp[Op]="select.state",Fp),schema:[Ep,zp,Ip,Mp,[[Op,50],[jp,50]]]},default:{optionalFields:[],placeholders:(Dp={},Dp[Op]="select.provinceOrTerritory",Dp),schema:[Ep,[[zp,70],[Ip,30]],[[jp,30],[Mp,70]],Op]}},Lp=function(e){var t=e.data,r=e.label,a=t.street,n=t.houseNumberOrName,o=t.city,i=t.postalCode,l=t.stateOrProvince,s=t.country;return od(Au,{classNameModifiers:[r],label:r,readonly:!0},!!a&&a,n&&", "+n+",",od("br",null),i&&""+i,o&&", "+o,l&&l!==Bp&&", "+l,s&&", "+s+" ")},Vp=function(e){return{houseNumberOrName:{validate:function(t,r){var a,n,o=null===(n=null===(a=r.state)||void 0===a?void 0:a.data)||void 0===n?void 0:n.country;return o&&e.countryHasOptionalField(o,"houseNumberOrName")||(null==t?void 0:t.length)>0},modes:["blur"]},default:{validate:function(e){return(null==e?void 0:e.length)>0},modes:["blur"],errorMessage:ju["incomplete field"]}}},Up="undefined"!=typeof globalThis&&globalThis||"undefined"!=typeof self&&self||void 0!==Up&&Up,Kp="URLSearchParams"in Up,Hp="Symbol"in Up&&"iterator"in Symbol,qp="FileReader"in Up&&"Blob"in Up&&function(){try{return new Blob,!0}catch(e){return!1}}(),Gp="FormData"in Up,Yp="ArrayBuffer"in Up;if(Yp)var Wp=["[object Int8Array]","[object Uint8Array]","[object Uint8ClampedArray]","[object Int16Array]","[object Uint16Array]","[object Int32Array]","[object Uint32Array]","[object Float32Array]","[object Float64Array]"],Jp=ArrayBuffer.isView||function(e){return e&&Wp.indexOf(Object.prototype.toString.call(e))>-1};function Zp(e){if("string"!=typeof e&&(e=String(e)),/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(e)||""===e)throw new TypeError('Invalid character in header field name: "'+e+'"');return e.toLowerCase()}function Qp(e){return"string"!=typeof e&&(e=String(e)),e}function $p(e){var t={next:function(){var t=e.shift();return{done:void 0===t,value:t}}};return Hp&&(t[Symbol.iterator]=function(){return t}),t}function Xp(e){this.map={},e instanceof Xp?e.forEach((function(e,t){this.append(t,e)}),this):Array.isArray(e)?e.forEach((function(e){this.append(e[0],e[1])}),this):e&&Object.getOwnPropertyNames(e).forEach((function(t){this.append(t,e[t])}),this)}function em(e){if(e.bodyUsed)return Promise.reject(new TypeError("Already read"));e.bodyUsed=!0}function tm(e){return new Promise((function(t,r){e.onload=function(){t(e.result)},e.onerror=function(){r(e.error)}}))}function rm(e){var t=new FileReader,r=tm(t);return t.readAsArrayBuffer(e),r}function am(e){if(e.slice)return e.slice(0);var t=new Uint8Array(e.byteLength);return t.set(new Uint8Array(e)),t.buffer}function nm(){return this.bodyUsed=!1,this._initBody=function(e){var t;this.bodyUsed=this.bodyUsed,this._bodyInit=e,e?"string"==typeof e?this._bodyText=e:qp&&Blob.prototype.isPrototypeOf(e)?this._bodyBlob=e:Gp&&FormData.prototype.isPrototypeOf(e)?this._bodyFormData=e:Kp&&URLSearchParams.prototype.isPrototypeOf(e)?this._bodyText=e.toString():Yp&&qp&&((t=e)&&DataView.prototype.isPrototypeOf(t))?(this._bodyArrayBuffer=am(e.buffer),this._bodyInit=new Blob([this._bodyArrayBuffer])):Yp&&(ArrayBuffer.prototype.isPrototypeOf(e)||Jp(e))?this._bodyArrayBuffer=am(e):this._bodyText=e=Object.prototype.toString.call(e):this._bodyText="",this.headers.get("content-type")||("string"==typeof e?this.headers.set("content-type","text/plain;charset=UTF-8"):this._bodyBlob&&this._bodyBlob.type?this.headers.set("content-type",this._bodyBlob.type):Kp&&URLSearchParams.prototype.isPrototypeOf(e)&&this.headers.set("content-type","application/x-www-form-urlencoded;charset=UTF-8"))},qp&&(this.blob=function(){var e=em(this);if(e)return e;if(this._bodyBlob)return Promise.resolve(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(new Blob([this._bodyArrayBuffer]));if(this._bodyFormData)throw new Error("could not read FormData body as blob");return Promise.resolve(new Blob([this._bodyText]))},this.arrayBuffer=function(){if(this._bodyArrayBuffer){var e=em(this);return e||(ArrayBuffer.isView(this._bodyArrayBuffer)?Promise.resolve(this._bodyArrayBuffer.buffer.slice(this._bodyArrayBuffer.byteOffset,this._bodyArrayBuffer.byteOffset+this._bodyArrayBuffer.byteLength)):Promise.resolve(this._bodyArrayBuffer))}return this.blob().then(rm)}),this.text=function(){var e=em(this);if(e)return e;if(this._bodyBlob)return function(e){var t=new FileReader,r=tm(t);return t.readAsText(e),r}(this._bodyBlob);if(this._bodyArrayBuffer)return Promise.resolve(function(e){for(var t=new Uint8Array(e),r=new Array(t.length),a=0;a<t.length;a++)r[a]=String.fromCharCode(t[a]);return r.join("")}(this._bodyArrayBuffer));if(this._bodyFormData)throw new Error("could not read FormData body as text");return Promise.resolve(this._bodyText)},Gp&&(this.formData=function(){return this.text().then(lm)}),this.json=function(){return this.text().then(JSON.parse)},this}Xp.prototype.append=function(e,t){e=Zp(e),t=Qp(t);var r=this.map[e];this.map[e]=r?r+", "+t:t},Xp.prototype.delete=function(e){delete this.map[Zp(e)]},Xp.prototype.get=function(e){return e=Zp(e),this.has(e)?this.map[e]:null},Xp.prototype.has=function(e){return this.map.hasOwnProperty(Zp(e))},Xp.prototype.set=function(e,t){this.map[Zp(e)]=Qp(t)},Xp.prototype.forEach=function(e,t){for(var r in this.map)this.map.hasOwnProperty(r)&&e.call(t,this.map[r],r,this)},Xp.prototype.keys=function(){var e=[];return this.forEach((function(t,r){e.push(r)})),$p(e)},Xp.prototype.values=function(){var e=[];return this.forEach((function(t){e.push(t)})),$p(e)},Xp.prototype.entries=function(){var e=[];return this.forEach((function(t,r){e.push([r,t])})),$p(e)},Hp&&(Xp.prototype[Symbol.iterator]=Xp.prototype.entries);var om=["DELETE","GET","HEAD","OPTIONS","POST","PUT"];function im(e,t){if(!(this instanceof im))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');var r=(t=t||{}).body;if(e instanceof im){if(e.bodyUsed)throw new TypeError("Already read");this.url=e.url,this.credentials=e.credentials,t.headers||(this.headers=new Xp(e.headers)),this.method=e.method,this.mode=e.mode,this.signal=e.signal,r||null==e._bodyInit||(r=e._bodyInit,e.bodyUsed=!0)}else this.url=String(e);if(this.credentials=t.credentials||this.credentials||"same-origin",!t.headers&&this.headers||(this.headers=new Xp(t.headers)),this.method=function(e){var t=e.toUpperCase();return om.indexOf(t)>-1?t:e}(t.method||this.method||"GET"),this.mode=t.mode||this.mode||null,this.signal=t.signal||this.signal,this.referrer=null,("GET"===this.method||"HEAD"===this.method)&&r)throw new TypeError("Body not allowed for GET or HEAD requests");if(this._initBody(r),!("GET"!==this.method&&"HEAD"!==this.method||"no-store"!==t.cache&&"no-cache"!==t.cache)){var a=/([?&])_=[^&]*/;if(a.test(this.url))this.url=this.url.replace(a,"$1_="+(new Date).getTime());else{this.url+=(/\?/.test(this.url)?"&":"?")+"_="+(new Date).getTime()}}}function lm(e){var t=new FormData;return e.trim().split("&").forEach((function(e){if(e){var r=e.split("="),a=r.shift().replace(/\+/g," "),n=r.join("=").replace(/\+/g," ");t.append(decodeURIComponent(a),decodeURIComponent(n))}})),t}function sm(e,t){if(!(this instanceof sm))throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');t||(t={}),this.type="default",this.status=void 0===t.status?200:t.status,this.ok=this.status>=200&&this.status<300,this.statusText=void 0===t.statusText?"":""+t.statusText,this.headers=new Xp(t.headers),this.url=t.url||"",this._initBody(e)}im.prototype.clone=function(){return new im(this,{body:this._bodyInit})},nm.call(im.prototype),nm.call(sm.prototype),sm.prototype.clone=function(){return new sm(this._bodyInit,{status:this.status,statusText:this.statusText,headers:new Xp(this.headers),url:this.url})},sm.error=function(){var e=new sm(null,{status:0,statusText:""});return e.type="error",e};var cm=[301,302,303,307,308];sm.redirect=function(e,t){if(-1===cm.indexOf(t))throw new RangeError("Invalid status code");return new sm(null,{status:t,headers:{location:e}})};var dm=Up.DOMException;try{new dm}catch(e){(dm=function(e,t){this.message=e,this.name=t;var r=Error(e);this.stack=r.stack}).prototype=Object.create(Error.prototype),dm.prototype.constructor=dm}function um(e,t){return new Promise((function(r,a){var n=new im(e,t);if(n.signal&&n.signal.aborted)return a(new dm("Aborted","AbortError"));var o=new XMLHttpRequest;function i(){o.abort()}o.onload=function(){var e,t,a={status:o.status,statusText:o.statusText,headers:(e=o.getAllResponseHeaders()||"",t=new Xp,e.replace(/\r?\n[\t ]+/g," ").split("\r").map((function(e){return 0===e.indexOf("\n")?e.substr(1,e.length):e})).forEach((function(e){var r=e.split(":"),a=r.shift().trim();if(a){var n=r.join(":").trim();t.append(a,n)}})),t)};a.url="responseURL"in o?o.responseURL:a.headers.get("X-Request-URL");var n="response"in o?o.response:o.responseText;setTimeout((function(){r(new sm(n,a))}),0)},o.onerror=function(){setTimeout((function(){a(new TypeError("Network request failed"))}),0)},o.ontimeout=function(){setTimeout((function(){a(new TypeError("Network request failed"))}),0)},o.onabort=function(){setTimeout((function(){a(new dm("Aborted","AbortError"))}),0)},o.open(n.method,function(e){try{return""===e&&Up.location.href?Up.location.href:e}catch(t){return e}}(n.url),!0),"include"===n.credentials?o.withCredentials=!0:"omit"===n.credentials&&(o.withCredentials=!1),"responseType"in o&&(qp?o.responseType="blob":Yp&&n.headers.get("Content-Type")&&-1!==n.headers.get("Content-Type").indexOf("application/octet-stream")&&(o.responseType="arraybuffer")),!t||"object"!=typeof t.headers||t.headers instanceof Xp?n.headers.forEach((function(e,t){o.setRequestHeader(t,e)})):Object.getOwnPropertyNames(t.headers).forEach((function(e){o.setRequestHeader(e,Qp(t.headers[e]))})),n.signal&&(n.signal.addEventListener("abort",i),o.onreadystatechange=function(){4===o.readyState&&n.signal.removeEventListener("abort",i)}),o.send(void 0===n._bodyInit?null:n._bodyInit)}))}um.polyfill=!0,Up.fetch||(Up.fetch=um,Up.Headers=Xp,Up.Request=im,Up.Response=sm);var pm="fetch"in window?window.fetch:um;function mm(e,t){var r=e.headers,a=void 0===r?[]:r,n=e.errorLevel,o=void 0===n?"warn":n,i=e.loadingContext,l=void 0===i?Bd:i,s=e.method,c=void 0===s?"GET":s,d=e.path,u=Tc({method:c,mode:"cors",cache:"default",credentials:"same-origin",headers:Tc({Accept:"application/json, text/plain, */*","Content-Type":"POST"===c?"application/json":"text/plain"},a),redirect:"follow",referrerPolicy:"no-referrer-when-downgrade"},t&&{body:JSON.stringify(t)}),p=""+l+d;return pm(p,u).then((function(t){return t.ok?t.json():hm(e.errorMessage||"Service at "+p+" is not available",o)})).catch((function(t){return hm(e.errorMessage||"Call to "+p+" failed. Error= "+t,o)}))}function hm(e,t){switch(t){case"silent":return null;case"info":case"warn":case"error":return console[t](e);default:throw new Error(e)}}var fm=function(e,t){return mm(Tc(Tc({},e),{method:"POST"}),t)};function ym(e,t,r){return function(e,t){return mm(Tc(Tc({},e),{method:"GET"}),t)}({loadingContext:t,errorLevel:"warn",errorMessage:"Dataset "+e+" is not available",path:"datasets/"+e+"/"+r+".json"})}function bm(e){var t=e.classNameModifiers,r=e.label,a=e.onDropdownChange,n=e.readOnly,o=e.selectedCountry,i=e.specifications,l=e.value,s=su(),c=s.i18n,d=s.loadingContext,u=Wd([]),p=u[0],m=u[1],h=Wd(!1),f=h[0],y=h[1],b=i.getPlaceholderKeyForField("stateOrProvince",o);return Qd((function(){if(!o||!i.countryHasDataset(o))return m([]),void y(!0);ym("states/"+o,d,c.locale).then((function(e){var t=e&&e.length?e:[];m(t),y(!0)})).catch((function(){m([]),y(!0)}))}),[o]),f&&p.length?od(Ou,{label:r,classNameModifiers:t,errorMessage:e.errorMessage,isValid:!!l,showValidIcon:!1,name:"stateOrProvince"},sp("select",{name:"stateOrProvince",onChange:a,selected:l,placeholder:c.get(b),items:p,readonly:n&&!!l})):null}function vm(e){var t=e.allowedCountries,r=void 0===t?[]:t,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.errorMessage,i=e.onDropdownChange,l=e.value,s=su(),c=s.i18n,d=s.loadingContext,u=Wd([]),p=u[0],m=u[1],h=Wd(!1),f=h[0],y=h[1],b=Wd(e.readOnly),v=b[0],g=b[1];return Qd((function(){ym("countries",d,c.locale).then((function(e){var t=r.length?e.filter((function(e){return r.includes(e.id)})):e;m(t||[]),g(1===t.length||v),y(!0)})).catch((function(e){console.error(e),m([]),y(!0)}))}),[]),f?od(Ou,{name:"country",label:c.get("country"),errorMessage:o,classNameModifiers:n,isValid:!!l,showValidIcon:!1},sp("select",{onChange:i,name:"country",placeholder:c.get("select.country"),selected:l,items:p,readonly:v&&!!l})):null}function gm(e){var t,r=su().i18n,a=e.classNameModifiers,n=void 0===a?[]:a,o=e.data,i=e.errors,l=e.valid,s=e.fieldName,c=e.onInput,d=e.onChange,u=r.get(null===(t=i[s])||void 0===t?void 0:t.errorMessage)||!!i[s],p=o[s],m=o.country,h=e.specifications.countryHasOptionalField(m,s),f=e.specifications.getKeyForField(s,m),y=h?" "+r.get("field.title.optional"):"",b=""+r.get(f)+y;switch(s){case"country":return od(vm,{allowedCountries:e.allowedCountries,classNameModifiers:n,label:b,errorMessage:u,onDropdownChange:e.onDropdownChange,value:p});case"stateOrProvince":return od(bm,{classNameModifiers:n,label:b,errorMessage:u,onDropdownChange:e.onDropdownChange,selectedCountry:m,specifications:e.specifications,value:p});default:return od(Ou,{label:b,classNameModifiers:n,errorMessage:u,isValid:l[s],name:s},sp("text",{classNameModifiers:n,name:s,value:p,onInput:c,onChange:d}))}}var km=function(){function e(e){this.specifications=Tc(Tc({},Rp),e)}return e.prototype.countryHasDataset=function(e){var t,r;return!!(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.hasDataset)},e.prototype.countryHasOptionalField=function(e,t){var r,a,n;return!!(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[e])||void 0===a?void 0:a.optionalFields)||void 0===n?void 0:n.includes(t))},e.prototype.getAddressSchemaForCountry=function(e){var t,r;return(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.schema)||this.specifications.default.schema},e.prototype.getOptionalFieldsForCountry=function(e){var t,r,a;return(null===(r=null===(t=this.specifications)||void 0===t?void 0:t[e])||void 0===r?void 0:r.optionalFields)||(null===(a=this.specifications.default)||void 0===a?void 0:a.optionalFields)||[]},e.prototype.getKeyForField=function(e,t){var r,a,n;return(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[t])||void 0===a?void 0:a.labels)||void 0===n?void 0:n[e])||e},e.prototype.getPlaceholderKeyForField=function(e,t){var r,a,n,o,i,l;return(null===(n=null===(a=null===(r=this.specifications)||void 0===r?void 0:r[t])||void 0===a?void 0:a.placeholders)||void 0===n?void 0:n[e])||(null===(l=null===(i=null===(o=this.specifications)||void 0===o?void 0:o.default)||void 0===i?void 0:i.placeholders)||void 0===l?void 0:l[e])},e}();function Cm(e){var t=e.label,r=void 0===t?"":t,a=e.requiredFields,n=e.visibility,o=Xd((function(){return new km(e.specifications)}),[e.specifications]),i=bp({schema:a,defaultData:e.data,rules:e.validationRules||Vp(o)}),l=i.data,s=i.errors,c=i.valid,d=i.isValid,u=i.handleChangeFor,p=i.triggerValidation;if(Zd((function(){var e=o.countryHasDataset(l.country)?"":Bp,t=Tc(Tc({},l),{stateOrProvince:e});a.forEach((function(e){var r;u(e,"input")(null!==(r=t[e])&&void 0!==r?r:"")}))}),[l.country]),Zd((function(){var e=a.includes("stateOrProvince"),t=l.country&&o.countryHasDataset(l.country),r=e&&t,n=l.stateOrProvince||(r?"":Bp);u("stateOrProvince","input")(n)}),[]),Zd((function(){var t=o.getOptionalFieldsForCountry(l.country),r=Tp.reduce((function(r,n){var o=t.includes(n),i=a.includes(n),s=l[n],c=e.data[n],d=o&&!s||!i?i||s||!c?Bp:c:s;return(null==d?void 0:d.length)&&(r[n]=d),r}),{});e.onChange({data:r,valid:c,errors:s,isValid:d})}),[l,c,s,d]),this.showValidation=p,"hidden"===n)return null;if("readOnly"===n)return od(Lp,{data:l,label:r});var m=function(t,r){var n=r.classNameModifiers,i=void 0===n?[]:n;return a.includes(t)?od(gm,{key:t,allowedCountries:e.allowedCountries,classNameModifiers:Mc(Mc([],i),[t]),data:l,errors:s,valid:c,fieldName:t,onInput:u(t,"input"),onChange:u(t,"blur"),onDropdownChange:u(t,"blur"),specifications:o}):null};return od(Au,{classNameModifiers:[r],label:r},o.getAddressSchemaForCountry(l.country).map((function(e){return e instanceof Array?od("div",{className:"adyen-checkout__field-group"},e.map((function(e){var t=e[0],r=e[1];return m(t,{classNameModifiers:["col-"+r]})}))):m(e,{})})))}function _m(e){var t,r,a=e.errorMessage,n=e.label,o=e.onChange,i=zc(e,["errorMessage","label","onChange"]);return od(Ou,{classNameModifiers:["consentCheckbox"],errorMessage:a},od(Yu,{name:"consentCheckbox",classNameModifiers:Mc(Mc([],null!==(t=i.classNameModifiers)&&void 0!==t?t:i.classNameModifiers=[]),["consentCheckbox"]),onInput:o,value:null===(r=null==i?void 0:i.data)||void 0===r?void 0:r.consentCheckbox,label:n,checked:i.checked}))}Cm.defaultProps={countryCode:null,data:{},onChange:function(){},visibility:"editable",requiredFields:Tp,specifications:{}};var Nm=["companyDetails","personalDetails","billingAddress","deliveryAddress"],wm=function(e,t){return void 0===t&&(t={}),Nm.reduce((function(r,a){var n,o="hidden"!==e[a],i="deliveryAddress"===a,l="hidden"===(null==e?void 0:e.billingAddress);return r[a]=o&&(!i||l||(void 0===(n=t[a])&&(n={}),Object.keys(n).length>1)),r}),{})};function Pm(e){var t=e.countryCode,r=e.visibility,a=su().i18n,n=Wd(wm(r,e.data)),o=n[0],i=n[1],l=Nm.reduce((function(e,t){return e[t]={current:null},e}),{}),s=!!e.consentCheckboxLabel,c=!s&&Object.keys(o).every((function(e){return!o[e]})),d="editable"===r.deliveryAddress&&"hidden"!==r.billingAddress,u=Wd(Tc(Tc({},e.data),s&&{consentCheckbox:!1})),p=u[0],m=u[1],h=Wd({}),f=h[0],y=h[1],b=Wd({}),v=b[0],g=b[1],k=Wd("ready"),C=k[0],_=k[1];this.setStatus=_,Zd((function(){var t=Object.keys(o).every((function(e){return!o[e]||!!v[e]})),r=!s||!!v.consentCheckbox,a=t&&r,n=function(e,t){return Object.keys(t).filter((function(t){return e[t]})).reduce((function(e,r){return e[r]=t[r],e}),{})}(o,p);e.onChange({data:n,errors:f,valid:v,isValid:a})}),[p,o]);var N=function(e){return function(t){m((function(r){var a;return Tc(Tc({},r),((a={})[e]=t.data,a))})),g((function(r){var a;return Tc(Tc({},r),((a={})[e]=t.isValid,a))})),y((function(r){var a;return Tc(Tc({},r),((a={})[e]=t.errors,a))}))}};return this.showValidation=function(){Nm.forEach((function(e){l[e].current&&l[e].current.showValidation()})),y(Tc({},s&&{consentCheckbox:!p.consentCheckbox}))},od("div",{className:"adyen-checkout__open-invoice"},o.companyDetails&&od(vp,{data:e.data.companyDetails,label:"companyDetails",onChange:N("companyDetails"),ref:l.companyDetails,visibility:r.companyDetails}),o.personalDetails&&od(xp,{data:e.data.personalDetails,requiredFields:e.personalDetailsRequiredFields,label:"personalDetails",onChange:N("personalDetails"),ref:l.personalDetails,visibility:r.personalDetails}),o.billingAddress&&od(Cm,{allowedCountries:e.allowedCountries,countryCode:t,data:p.billingAddress,label:"billingAddress",onChange:N("billingAddress"),ref:l.billingAddress,visibility:r.billingAddress}),d&&od(Yu,{label:a.get("separateDeliveryAddress"),checked:o.deliveryAddress,classNameModifiers:["separateDeliveryAddress"],name:"separateDeliveryAddress",onChange:function(){i((function(e){return Tc(Tc({},e),{deliveryAddress:!o.deliveryAddress})}))}}),o.deliveryAddress&&od(Cm,{allowedCountries:e.allowedCountries,countryCode:t,data:p.deliveryAddress,label:"deliveryAddress",onChange:N("deliveryAddress"),ref:l.deliveryAddress,visibility:r.deliveryAddress}),s&&od(_m,{data:p,errorMessage:!!f.consentCheckbox,label:e.consentCheckboxLabel,onChange:function(e){var t=e.target.checked;m((function(e){return Tc(Tc({},e),{consentCheckbox:t})})),g((function(e){return Tc(Tc({},e),{consentCheckbox:t})})),y((function(e){return Tc(Tc({},e),{consentCheckbox:!t})}))}}),e.showPayButton&&e.payButton({status:C,classNameModifiers:Mc([],c?["standalone"]:[]),label:a.get("confirmPurchase")}))}var Fm=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={loaded:!1},t}return Bc(t,e),t.prototype.componentDidMount=function(){var e=this;this.props.i18n?this.props.i18n.loaded.then((function(){e.setState({loaded:!0})})):this.setState({loaded:!0})},t.prototype.render=function(e){var t=e.children;return this.state.loaded?od(lu.Provider,{value:{i18n:this.props.i18n,loadingContext:this.props.loadingContext}},fd(t)):null},t}(sd),Dm=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){var r,a,n=e.countryCode||(null===(a=null===(r=e.data)||void 0===r?void 0:r.billingAddress)||void 0===a?void 0:a.countryCode);return Tc(Tc({},e),{allowedCountries:[n],visibility:Tc(Tc({},t.defaultProps.visibility),e.visibility),data:Tc(Tc({},e.data),{billingAddress:Tc(Tc({},e.data.billingAddress),{country:n}),deliveryAddress:Tc(Tc({},e.data.deliveryAddress),{country:n})})})},t.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,r=t.companyDetails,a=void 0===r?{}:r,n=t.personalDetails,o=void 0===n?{}:n,i=t.billingAddress,l=t.deliveryAddress;return Tc(Tc(Tc(Tc({paymentMethod:{type:this.constructor.type}},o),a),i&&{billingAddress:i}),(l||i)&&{deliveryAddress:l||i})},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Pm,Tc({ref:function(t){e.componentRef=t}},this.props,this.state,{consentCheckbox:this.props.consentCheckbox,onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"hidden",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},t}(pu);function Am(e){var t=su().i18n,r=t.get("paymentConditions"),a=t.get("afterPay.agreement").split("%@"),n=a[0],o=a[1];return n&&o?od(ld,null,n,od("a",{className:"adyen-checkout__link",target:"_blank",rel:"noopener noreferrer",href:e.url},r),o):od("span",{className:"adyen-checkout__checkbox__label"},t.get("privacyPolicy"))}var Sm=["BE","NL"];var xm=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){var r,a,n;return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Sm,consentCheckboxLabel:od(Am,{url:(a=t.countryCode,n=null===(r=t.i18n)||void 0===r?void 0:r.locale,"en"===(null==n?void 0:n.toLowerCase().slice(0,2))?"https://www.afterpay.nl/en/algemeen/pay-with-afterpay/payment-conditions":"be"===(null==a?void 0:a.toLowerCase())?"https://www.afterpay.be/be/footer/betalen-met-afterpay/betalingsvoorwaarden":"https://www.afterpay.nl/nl/algemeen/betalen-met-afterpay/betalingsvoorwaarden")})})},t.type="afterpay_default",t}(Dm),Bm=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Sm,consentCheckboxLabel:od(Am,{url:"https://www.afterpay.nl/nl/algemeen/zakelijke-partners/betalingsvoorwaarden-zakelijk"})})},t.type="afterpay_b2b",t.defaultProps={onChange:function(){},data:{companyDetails:{},personalDetails:{},billingAddress:{},deliveryAddress:{}},visibility:{companyDetails:"editable",personalDetails:"editable",billingAddress:"editable",deliveryAddress:"editable"}},t}(Dm);function Tm(){var e=Dd(window,"screen.colorDepth")||"",t=!!Dd(window,"navigator.javaEnabled")&&window.navigator.javaEnabled(),r=Dd(window,"screen.height")||"",a=Dd(window,"screen.width")||"",n=Dd(window,"navigator.userAgent")||"";return{acceptHeader:"*/*",colorDepth:e,language:Dd(window,"navigator.language")||Dd(window,"navigator.browserLanguage")||"en",javaEnabled:t,screenHeight:r,screenWidth:a,userAgent:n,timeZoneOffset:(new Date).getTimezoneOffset()}}var zm={EU:"EUR",UK:"GBP",US:"USD"},Im=["en_GB","de_DE","fr_FR","it_IT","es_ES"],jm=["en_US"];function Mm(e,t){return function(e){return"US"===e?jm:Im}(t).includes(e)?e:function(e){return"US"===e?"en_US":"en_GB"}(t)}function Om(e){return"noTagline"===e?"C0001":null}function Em(e){var t=e.addressDetails,r=e.cancelUrl,a=e.checkoutMode,n=e.deliverySpecifications,o=e.returnUrl,i=e.merchantMetadata,l=e.configuration.storeId,s="ProcessOrder"===a,c=s?function(e){return{amount:String($c(e.value,e.currency)),currencyCode:e.currency}}(e.amount):null;return Tc(Tc(Tc(Tc({storeId:l,webCheckoutDetails:Tc(Tc(Tc({},s?{checkoutResultReturnUrl:o}:{checkoutReviewReturnUrl:o}),r&&{checkoutCancelUrl:r}),s&&{checkoutMode:a})},s&&{paymentDetails:{chargeAmount:c,paymentIntent:"Confirm",presentmentCurrency:c.currencyCode,totalOrderAmount:c}}),i&&{merchantMetadata:i}),n&&{deliverySpecifications:n}),t&&{addressDetails:t})}function Rm(e,t,r){return fm({loadingContext:e,path:"v1/AmazonPayUtility/getCheckoutDetails?clientKey="+t},r)}function Lm(e){var t=this,r=su().loadingContext,a=e.amazonRef,n=e.configuration,o=void 0===n?{}:n,i=Wd(null),l=i[0],s=i[1],c=Em(e),d=function(e){var t;return Tc(Tc(Tc({},e.buttonColor&&{buttonColor:e.buttonColor}),e.design&&{design:Om(e.design)}),{checkoutLanguage:Mm(e.locale,e.region),ledgerCurrency:zm[e.configuration.region]||e.currency||(null===(t=e.amount)||void 0===t?void 0:t.currency),merchantId:e.configuration.merchantId,productType:e.productType,placement:e.placement,sandbox:"TEST"===e.environment})}(e),u=function(){new Promise(e.onClick).then(t.initCheckout).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))};return this.initCheckout=function(){var e={payloadJSON:JSON.stringify(c),publicKeyId:o.publicKeyId,signature:l};a.Pay.initCheckout(Tc(Tc({},d),{createCheckoutSessionConfig:e}))},Zd((function(){var n=e.clientKey;(function(e,t,r){var a={loadingContext:e,path:"v1/AmazonPayUtility/signString?clientKey="+t},n={stringToSign:JSON.stringify(r)};return fm(a,n)})(r,n,c).then((function(t){if(!(null==t?void 0:t.signature))return console.error("Could not get AmazonPay signature");s(t.signature),e.showPayButton&&a.Pay.renderButton("#amazonPayButton",d).onClick(u)})).catch((function(r){console.error(r),e.onError&&e.onError(r,t.componentRef)}))}),[]),e.showPayButton?od("div",{className:"adyen-checkout__amazonpay__button",id:"amazonPayButton"}):null}function Vm(e){var t=su().i18n,r=e.amazonRef,a=e.amazonCheckoutSessionId;return Zd((function(){var e={amazonCheckoutSessionId:a,changeAction:"changeAddress"};r.Pay.bindChangeAction(".adyen-checkout__amazonpay__button--changeAddress",e)}),[]),od("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--ghost adyen-checkout__amazonpay__button--changeAddress"},t.get("amazonpay.changePaymentDetails"))}function Um(e){var t=this,r=su(),a=r.i18n,n=r.loadingContext;return this.createOrder=function(){var r=e.amazonCheckoutSessionId,a=e.amount,o=e.clientKey,i=e.publicKeyId,l=e.region,s=e.returnUrl;(function(e,t,r){return fm({loadingContext:e,path:"v1/AmazonPayUtility/updateCheckoutSession?clientKey="+t},r)})(n,o,{amount:a,checkoutResultReturnUrl:s,checkoutSessionId:r,publicKeyId:i,region:l}).then((function(e){var t;if(!(null===(t=null==e?void 0:e.action)||void 0===t?void 0:t.type))return console.error(e.errorMessage||"Could not get the AmazonPay URL");"redirect"===e.action.type&&window.location.assign(e.action.url)})).catch((function(r){e.onError&&e.onError(r,t.componentRef)}))},od(cu,{classNameModifiers:["standalone","pay"],label:a.get("confirmPurchase"),onClick:this.createOrder})}function Km(e){return od("button",{type:"button",className:"adyen-checkout__button  adyen-checkout__button--ghost adyen-checkout__amazonpay__button--signOut",onClick:function(){new Promise(e.onSignOut).then((function(){e.amazonRef.Pay.signout()})).catch(console.error)}},su().i18n.get("amazonpay.signout"))}var Hm=function(e,t){var r=this;void 0===t&&(t="body"),this.load=function(){return new Promise((function(e,t){r.script.src=r.src,r.script.async=!0,r.script.onload=e,r.script.onerror=function(){r.remove(),t(new Error("Unable to load script "+r.src))};var a=document.querySelector(r.node),n=a.querySelector('script[src="'+r.src+'"]');n?n.addEventListener("load",e):a.appendChild(r.script)}))},this.remove=function(){return r.script.remove()},this.script=document.createElement("script"),this.src=e,this.node=t};function qm(e){var t,r,a=Wd("pending"),n=a[0],o=a[1],i=$d(null),l=$d(null),s=function(){o("ready")};return this.submit=function(){return i.current&&i.current.initCheckout?i.current.initCheckout():l.current&&l.current.createOrder?l.current.createOrder():void 0},Zd((function(){var t="US"===e.region?"https://static-na.payments-amazon.com/checkout.js":"https://static-eu.payments-amazon.com/checkout.js",r=new Hm(t);return window.amazon?s():r.load().then(s),function(){r.remove()}}),[]),"pending"===n?od("div",{className:"adyen-checkout__amazonpay"},od("div",{className:"adyen-checkout__amazonpay__status adyen-checkout__amazonpay__status--pending"},od(Rd,null))):e.showSignOutButton?od("div",{className:"adyen-checkout__amazonpay"},od(Km,{amazonRef:window.amazon,onSignOut:e.onSignOut})):e.amazonCheckoutSessionId?od("div",{className:"adyen-checkout__amazonpay"},e.showOrderButton&&od(Um,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amount:e.amount,clientKey:e.clientKey,onError:e.onError,publicKeyId:null===(t=e.configuration)||void 0===t?void 0:t.publicKeyId,region:null===(r=e.configuration)||void 0===r?void 0:r.region,returnUrl:e.returnUrl,ref:l}),e.showChangePaymentDetailsButton&&od(Vm,{amazonCheckoutSessionId:e.amazonCheckoutSessionId,amazonRef:window.amazon})):od("div",{className:"adyen-checkout__amazonpay"},od(Lm,Tc({},e,{amazonRef:window.amazon,ref:i})))}var Gm={cancelUrl:window.location.href,configuration:{},environment:"TEST",locale:"en_GB",placement:"Cart",productType:"PayAndShip",region:"EU",returnUrl:window.location.href,showOrderButton:!0,showChangePaymentDetailsButton:!1,showSignOutButton:!1,showPayButton:!0,onClick:function(e){return e()},onSignOut:function(e){return e()}},Ym=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){return Tc(Tc({},e),{checkoutMode:e.isDropin?"ProcessOrder":e.checkoutMode,environment:e.environment.toUpperCase(),locale:e.locale.replace("-","_"),productType:e.isDropin&&!e.addressDetails?"PayOnly":e.productType,region:e.region.toUpperCase()})},t.prototype.formatData=function(){var e=this.props.amazonCheckoutSessionId;return{paymentMethod:Tc({type:t.type},e&&{checkoutSessionId:e}),browserInfo:this.browserInfo}},t.prototype.getShopperDetails=function(){var e=this.props,t=e.amazonCheckoutSessionId,r=e.configuration,a=void 0===r?{}:r,n=e.loadingContext,o=e.clientKey;return t?Rm(n,o,{checkoutSessionId:t,getDeliveryAddress:!0,publicKeyId:a.publicKeyId,region:a.region}):console.error("Could not shopper details. Missing checkoutSessionId.")},t.prototype.handleDeclineFlow=function(){var e=this,t=this.props,r=t.amazonCheckoutSessionId,a=t.configuration,n=void 0===a?{}:a,o=t.loadingContext,i=t.clientKey;if(!r)return console.error("Could handle the decline flow. Missing checkoutSessionId.");Rm(o,i,{checkoutSessionId:r,getDeclineFlowUrl:!0,publicKeyId:n.publicKeyId,region:n.region}).then((function(e){if(void 0===e&&(e={}),!(null==e?void 0:e.declineFlowUrl))throw e;window.location.assign(e.declineFlowUrl)})).catch((function(t){e.props.onError&&e.props.onError(t,e.componentRef)}))},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Tm()},enumerable:!1,configurable:!0}),t.prototype.submit=function(){var e=this.data,t=this.isValid,r=this.props.onSubmit,a=void 0===r?function(){}:r;return this.componentRef&&this.componentRef.submit?this.componentRef.submit():a({data:e,isValid:t},this)},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(qm,Tc({ref:function(t){e.componentRef=t}},this.props)))},t.type="amazonpay",t.defaultProps=Gm,t}(pu),Wm={"apple-pay-button":"ApplePayButton-module_apple-pay-button__26P3-","apple-pay-button-black":"ApplePayButton-module_apple-pay-button-black__3Ml54","apple-pay-button-white":"ApplePayButton-module_apple-pay-button-white__1qE8A","apple-pay-button-white-with-line":"ApplePayButton-module_apple-pay-button-white-with-line__j9FE5","apple-pay-button--type-plain":"ApplePayButton-module_apple-pay-button--type-plain__2mnnX","apple-pay-button--type-buy":"ApplePayButton-module_apple-pay-button--type-buy__eMnIy","apple-pay-button--type-donate":"ApplePayButton-module_apple-pay-button--type-donate__3zvI8","apple-pay-button--type-check-out":"ApplePayButton-module_apple-pay-button--type-check-out__ipg0J","apple-pay-button--type-book":"ApplePayButton-module_apple-pay-button--type-book__155Xs","apple-pay-button--type-subscribe":"ApplePayButton-module_apple-pay-button--type-subscribe__3uPJ5","apple-pay-button--type-add-money":"ApplePayButton-module_apple-pay-button--type-add-money__xmCaj","apple-pay-button--type-contribute":"ApplePayButton-module_apple-pay-button--type-contribute__RCq2P","apple-pay-button--type-order":"ApplePayButton-module_apple-pay-button--type-order__f5tpZ","apple-pay-button--type-reload":"ApplePayButton-module_apple-pay-button--type-reload__1P53C","apple-pay-button--type-rent":"ApplePayButton-module_apple-pay-button--type-rent__2J4wk","apple-pay-button--type-support":"ApplePayButton-module_apple-pay-button--type-support__3-p0R","apple-pay-button--type-tip":"ApplePayButton-module_apple-pay-button--type-tip__2-gCt","apple-pay-button--type-top-up":"ApplePayButton-module_apple-pay-button--type-top-up__9UKXI"},Jm=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.render=function(e){var t=e.buttonColor,r=e.buttonType;return od("button",{type:"button","aria-label":this.props.i18n.get("payButton"),lang:this.props.i18n.languageCode,className:Ed("adyen-checkout__applepay__button","adyen-checkout__applepay__button--"+t,"adyen-checkout__applepay__button--"+r,[Wm["apple-pay-button"]],[Wm["apple-pay-button-"+t]],[Wm["apple-pay-button--type-"+r]]),onClick:this.props.onClick})},t.defaultProps={onClick:function(){},buttonColor:"black",buttonType:"plain"},t}(sd),Zm=function(){function e(e,t){var r=this;this.session=new ApplePaySession(t.version,e),this.session.onvalidatemerchant=function(e){return r.onvalidatemerchant(e,t.onValidateMerchant)},this.session.onpaymentauthorized=function(e){return r.onpaymentauthorized(e,t.onPaymentAuthorized)},this.session.oncancel=function(e){return r.oncancel(e,t.onCancel)},"function"==typeof t.onPaymentMethodSelected&&(this.session.onpaymentmethodselected=function(e){return r.onpaymentmethodselected(e,t.onPaymentMethodSelected)}),"function"==typeof t.onShippingContactSelected&&(this.session.onshippingcontactselected=function(e){return r.onshippingcontactselected(e,t.onShippingContactSelected)}),"function"==typeof t.onShippingMethodSelected&&(this.session.onshippingmethodselected=function(e){return r.onshippingmethodselected(e,t.onShippingMethodSelected)})}return e.prototype.begin=function(){return this.session.begin()},e.prototype.onvalidatemerchant=function(e,t){var r=this;new Promise((function(r,a){return t(r,a,e.validationURL)})).then((function(e){r.session.completeMerchantValidation(e)})).catch((function(e){console.error(e),r.session.abort()}))},e.prototype.onpaymentauthorized=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(){r.session.completePayment(ApplePaySession.STATUS_SUCCESS)})).catch((function(){r.session.completePayment(ApplePaySession.STATUS_FAILURE)}))},e.prototype.onpaymentmethodselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completePaymentMethodSelection(e)})).catch((function(e){r.session.completePaymentMethodSelection(e)}))},e.prototype.onshippingcontactselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingContactSelection(e)})).catch((function(e){r.session.completeShippingContactSelection(e)}))},e.prototype.onshippingmethodselected=function(e,t){var r=this;return new Promise((function(r,a){return t(r,a,e)})).then((function(e){r.session.completeShippingMethodSelection(e)})).catch((function(e){r.session.completeShippingMethodSelection(e)}))},e.prototype.oncancel=function(e,t){return t(e)},e}(),Qm={amount:{currency:"USD",value:0},countryCode:"US",totalPriceStatus:"final",totalPriceLabel:void 0,configuration:{merchantName:"",merchantId:""},initiative:"web",lineItems:void 0,merchantCapabilities:["supports3DS"],shippingMethods:void 0,shippingType:void 0,supportedCountries:void 0,supportedNetworks:["amex","discover","masterCard","visa"],requiredBillingContactFields:void 0,requiredShippingContactFields:void 0,billingContact:void 0,shippingContact:void 0,applicationData:void 0,onClick:function(e){return e()},onSubmit:function(){},onError:function(){},onAuthorized:function(e){return e()},onPaymentMethodSelected:null,onShippingContactSelected:null,onShippingMethodSelected:null,buttonType:"plain",buttonColor:"black",showPayButton:!0},$m=function(e){var t=e.countryCode;e.companyName;var r=e.amount,a=zc(e,["countryCode","companyName","amount"]),n=function(e){return String($c(e.value,e.currency))}(r);return{countryCode:t,currencyCode:r.currency,total:{label:a.totalPriceLabel,amount:n,type:a.totalPriceStatus},lineItems:a.lineItems,shippingMethods:a.shippingMethods,shippingType:a.shippingType,merchantCapabilities:a.merchantCapabilities,supportedCountries:a.supportedCountries,supportedNetworks:a.supportedNetworks,requiredShippingContactFields:a.requiredShippingContactFields,requiredBillingContactFields:a.requiredBillingContactFields,billingContact:a.billingContact,shippingContact:a.shippingContact,applicationData:a.applicationData}};var Xm=function(e){function t(t){var r=e.call(this,t)||this;return r.startSession=r.startSession.bind(r),r.submit=r.submit.bind(r),r.validateMerchant=r.validateMerchant.bind(r),r}return Bc(t,e),t.prototype.formatProps=function(e){var t,r,a,n,o=e.version||function(e){for(var t=[],r=e;r>0;r--)t.push(r);return t.find((function(e){return e&&window.ApplePaySession&&ApplePaySession.supportsVersion(e)}))}(11),i=(null===(t=e.brands)||void 0===t?void 0:t.length)?(a=e.brands,n={mc:"masterCard",amex:"amex",visa:"visa",elodebit:"elo",elo:"elo",interac:"interac",discover:"discover",jcb:"jcb",electron:"electron",maestro:"maestro",girocard:"girocard",cartebancaire:"cartesBancaires"},a.reduce((function(e,t){return n[t]&&!e.includes(n[t])&&e.push(n[t]),e}),[])):e.supportedNetworks;return Tc(Tc({},e),{configuration:e.configuration,supportedNetworks:i,version:o,totalPriceLabel:e.totalPriceLabel||(null===(r=e.configuration)||void 0===r?void 0:r.merchantName),onCancel:function(t){return e.onError(t)}})},t.prototype.formatData=function(){return{paymentMethod:Tc({type:t.type},this.state)}},t.prototype.submit=function(){var e=this;this.startSession((function(t,r,a){e.props.onSubmit&&e.props.onSubmit({data:e.data,isValid:e.isValid},e.elementRef),e.props.onAuthorized(t,r,a)}))},t.prototype.startPayment=function(){var e=this;return new Promise((function(t){e.startSession((function(r,a,n){return e.props.onAuthorized(r,a,n),t(!0)}))}))},t.prototype.startSession=function(e){var t=this,r=this.props,a=r.version,n=r.onValidateMerchant,o=r.onCancel,i=r.onPaymentMethodSelected,l=r.onShippingMethodSelected,s=r.onShippingContactSelected;return new Promise((function(e,r){return t.props.onClick(e,r)})).then((function(){var r=$m(Tc({companyName:t.props.configuration.merchantName},t.props));new Zm(r,{version:a,onCancel:o,onPaymentMethodSelected:i,onShippingMethodSelected:l,onShippingContactSelected:s,onValidateMerchant:n||t.validateMerchant,onPaymentAuthorized:function(r,a,n){n.payment.token&&n.payment.token.paymentData&&t.setState({applePayToken:btoa(JSON.stringify(n.payment.token.paymentData))}),e(r,a,n)}}).begin()}))},t.prototype.validateMerchant=function(e,t){return Ic(this,void 0,void 0,(function(){var r,a,n,o,i,l,s,c,d,u,p,m,h;return jc(this,(function(f){switch(f.label){case 0:r=window.location.hostname,a=this.props,n=a.clientKey,o=a.configuration,i=a.loadingContext,l=a.initiative,s=o.merchantName,c=o.merchantId,d={loadingContext:i,path:"v1/applePay/sessions?clientKey="+n},u={displayName:s,domainName:r,initiative:l,merchantIdentifier:c},f.label=1;case 1:return f.trys.push([1,3,,4]),[4,fm(d,u)];case 2:return p=f.sent(),(m=Fu.decode(p.data))||t("Could not decode Apple Pay session"),h=JSON.parse(m),e(h),[3,4];case 3:return f.sent(),t("Could not get Apple Pay session"),[3,4];case 4:return[2]}}))}))},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.isAvailable=function(){return"https:"!==document.location.protocol?Promise.reject(new Error("Trying to start an Apple Pay session from an insecure document")):this.props.onValidateMerchant||this.props.clientKey?window.ApplePaySession&&ApplePaySession.canMakePayments()&&ApplePaySession.supportsVersion(this.props.version)?Promise.resolve(!0):Promise.reject(new Error("Apple Pay is not available on this device")):Promise.reject(new Error("clientKey was not provided"))},t.prototype.render=function(){var e=this;return this.props.showPayButton?od(Jm,{i18n:this.props.i18n,buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,onClick:function(t){t.preventDefault(),e.submit()}}):null},t.type="applepay",t.defaultProps=Qm,t}(pu),eh=function(e,t){var r,a=e.issuer,n=null===(r=e.items.find((function(e){return e.id===a})))||void 0===r?void 0:r.name;return a&&n?t.get("continueTo")+" "+n:t.get("continue")},th=["issuer"],rh={issuer:{validate:function(e){return!!e&&e.length>0},modes:["blur"]}};function ah(e){var t=e.items,r=e.placeholder,a=e.issuer,n=zc(e,["items","placeholder","issuer"]),o=su().i18n,i=bp({schema:th,defaultData:{issuer:a},rules:rh}),l=i.handleChangeFor,s=i.triggerValidation,c=i.data,d=i.valid,u=i.errors,p=i.isValid,m=Wd("ready"),h=m[0],f=m[1];return this.setStatus=function(e){f(e)},Zd((function(){n.onChange({data:c,valid:d,errors:u,isValid:p})}),[c,d,u,p]),this.showValidation=function(){s()},od("div",{className:"adyen-checkout__issuer-list"},od(Ou,{errorMessage:!!u.issuer,classNameModifiers:["issuer-list"]},sp("select",{items:t,selected:c.issuer,placeholder:o.get(r),name:"issuer",className:"adyen-checkout__issuer-list__dropdown",onChange:l("issuer")})),n.showPayButton&&n.payButton({status:h,label:eh({issuer:c.issuer,items:t},o)}))}ah.defaultProps={onChange:function(){},placeholder:"idealIssuer.selectField.placeholder"};var nh=function(e,t){return function(r){if(!r)return null;var a=Tc({parentFolder:r?t+"/":"",type:r||t},e);return zd(a)(r)}},oh=function(e){function t(t){var r=e.call(this,t)||this;if(r.props.showImage){var a=nh({loadingContext:r.props.loadingContext},r.constructor.type);r.props.issuers=r.props.issuers.map((function(e){return Tc(Tc({},e),{icon:a(e.id)})}))}return r}return Bc(t,e),t.prototype.formatProps=function(e){var t=e.details&&e.details.length&&(e.details.find((function(e){return"issuer"===e.key}))||{}).items||e.issuers||[];return Tc(Tc({},e),{issuers:t})},t.prototype.formatData=function(){var e,t;return{paymentMethod:{type:this.constructor.type,issuer:null===(t=null===(e=this.state)||void 0===e?void 0:e.data)||void 0===t?void 0:t.issuer}}},Object.defineProperty(t.prototype,"isValid",{get:function(){var e;return!!(null===(e=this.state)||void 0===e?void 0:e.isValid)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(ah,Tc({ref:function(t){e.componentRef=t},items:this.props.issuers},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.defaultProps={showImage:!0,onValid:function(){},issuers:[],loadingContext:Bd},t}(pu),ih=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="billdesk_online",t}(oh),lh=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{showImage:!1,placeholder:"issuerList.wallet.placeholder"})},t.type="billdesk_wallet",t}(oh),sh="encryptedCardNumber",ch="encryptedExpiryDate",dh="encryptedExpiryMonth",uh="encryptedExpiryYear",ph="encryptedSecurityCode",mh="encryptedPassword",hh="giftcard",fh=["amex","mc","visa"],yh=["sepa","sepadirectdebit","ach",hh],bh="required",vh="optional",gh="hidden",kh=bh,Ch=gh,_h="data-cse",Nh="data-info",wh="data-uid",Ph=function(e,t){return t===ch?(e.encryptedExpiryMonth=!1,e.encryptedExpiryYear=!1):e[t]=!1,e},Fh=function(e,t){return function(r,a){var n=!0!==t.valid[a]?function(e,t){return 1!==t||e!==dh&&e!==uh?e:ch}(a,e):null;return(n=function(e,t){var r=e===ph,a=!t.errors.encryptedSecurityCode;return(t.cvcPolicy===vh||t.cvcPolicy===gh)&&a&&r?null:e}(n,t))&&!r.includes(n)&&r.push(n),r}},Dh=function(e,t){var r="card"===e?"nocard":e||"nocard";return zd({type:r,extension:"svg",loadingContext:t})(r)};function Ah(e){return"object"==typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function Sh(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=Ah(e[0])?e[0]:e;return{from:function(e){return r.map((function(t){var r;return t in e?((r={})[t]=e[t],r):{}})).reduce((function(e,t){return Tc(Tc({},e),t)}),{})}}}function xh(){for(var e=[],t=0;t<arguments.length;t++)e[t]=arguments[t];var r=Ah(e[0])?e[0]:e;return{from:function(e){var t=Object.keys(e).filter((function(e){return!r.includes(e)}));return Sh.apply(void 0,t).from(e)}}}var Bh=Object.prototype.toString;function Th(e){return"object"==typeof e&&null!==e&&"[object Array]"===Object.prototype.toString.call(e)}function zh(e){return null!=e}function Ih(e){return!1!==e&&zh(e)}function jh(e){return!!e&&"object"==typeof e}function Mh(e,t){void 0===e&&(e={}),void 0===t&&(t={});var r=Object.keys(e),a=Object.keys(t);if(r.length!==a.length)return!1;for(var n=0,o=r;n<o.length;n++){var i=o[n];if(jh(e[i])&&!Mh(e[i],t[i]))return!1;if(e[i]!==t[i])return!1}return!0}function Oh(e){return!Ih(e)||(!(!("number"==typeof(t=e)||jh(t)&&"[object Number]"===Bh.call(t))||0!==e&&!Number.isNaN(e))||(!(!Th(e)&&!function(e){return"string"==typeof e||jh(e)&&"[object String]"===Bh.call(e)}(e)||0!==e.length)||!(!jh(e)||0!==Object.keys(e).length)));var t}var Eh=window.console&&window.console.error&&window.console.error.bind(window.console);window.console&&window.console.info&&window.console.info.bind(window.console);var Rh=window.console&&window.console.log&&window.console.log.bind(window.console),Lh=window.console&&window.console.warn&&window.console.warn.bind(window.console);function Vh(){var e;this.config.cardGroupTypes=Th(e=this.props.cardGroupTypes)&&e.length?e:fh;var t=this.props.loadingContext;if(t){var r;this.config.loadingContext="/"===(r=t).charAt(r.length-1)?t:t+"/",this.config.isCreditCardType=!1===yh.includes(this.props.type),this.config.iframeUIConfig=this.props.iframeUIConfig,this.config.allowedDOMAccess=!(!1===this.props.allowedDOMAccess||"false"===this.props.allowedDOMAccess),this.config.autoFocus=!(!1===this.props.autoFocus||"false"===this.props.autoFocus),this.config.showWarnings=!0===this.props.showWarnings||"true"===this.props.showWarnings,this.config.trimTrailingSeparator=!(!1===this.props.trimTrailingSeparator||"false"===this.props.trimTrailingSeparator),this.config.keypadFix=!(!1===this.props.keypadFix||"false"===this.props.keypadFix),this.config.legacyInputMode=this.props.legacyInputMode||null,this.config.minimumExpiryDate=this.props.minimumExpiryDate||null,this.config.implementationType=this.props.implementationType,this.config.sfLogAtStart=!0===this.props._b$dl;var a=this.config.isCreditCardType?"card":this.props.type;a.indexOf("sepa")>-1&&(a="iban");var n=btoa(window.location.origin);this.config.iframeSrc=this.config.loadingContext+"securedfields/"+this.props.clientKey+"/3.5.4/securedFields.html?type="+a+"&d="+n}else Lh("WARNING Config :: no loadingContext has been specified!")}var Uh=function(){};function Kh(e){void 0===e&&(e={}),this.callbacks.onLoad=e.onLoad?e.onLoad:Uh,this.callbacks.onConfigSuccess=e.onConfigSuccess?e.onConfigSuccess:Uh,this.callbacks.onFieldValid=e.onFieldValid?e.onFieldValid:Uh,this.callbacks.onAllValid=e.onAllValid?e.onAllValid:Uh,this.callbacks.onBrand=e.onBrand?e.onBrand:Uh,this.callbacks.onError=e.onError?e.onError:Uh,this.callbacks.onFocus=e.onFocus?e.onFocus:Uh,this.callbacks.onBinValue=e.onBinValue?e.onBinValue:Uh,this.callbacks.onAutoComplete=e.onAutoComplete?e.onAutoComplete:Uh,this.callbacks.onAdditionalSFConfig=e.onAdditionalSFConfig?e.onAdditionalSFConfig:Uh,this.callbacks.onAdditionalSFRemoved=e.onAdditionalSFRemoved?e.onAdditionalSFRemoved:Uh}var Hh=function(e,t,r){if(t){var a=JSON.stringify(e);t.postMessage(a,r)}},qh=function(e,t){return!Mh(e,t)};function Gh(e){if(e.fieldType===sh){var t={brand:e.brand,cvcPolicy:e.cvcPolicy,showSocialSecurityNumber:e.showSocialSecurityNumber},r=qh(t,this.state.brand);if(!r)return null;var a="card"===this.state.type||"bcmc"===this.state.type;if(a&&r&&(this.state.brand=t,Object.prototype.hasOwnProperty.call(this.state.securedFields,ph))){var n={txVariant:this.state.type,brand:t.brand,fieldType:ph,cvcPolicy:e.cvcPolicy,numKey:this.state.securedFields.encryptedSecurityCode.numKey};Hh(n,this.getIframeContentWin(ph),this.config.loadingContext)}var o=a?Sh(["brand","cvcPolicy","cvcText","datePolicy","showSocialSecurityNumber"]).from(e):null;if(o&&o.brand){var i=o;i.type=this.state.type,i.rootNode=this.props.rootNode,this.callbacks.onBrand(i)}return!0}return!1}var Yh=function(e){return{fieldType:e.fieldType,encryptedFieldName:e.encryptedFieldName,uid:e.uuid,valid:e.isValid,type:e.txVariant,rootNode:e.rootNode}},Wh=function(e,t){var r=[];return e&&"function"==typeof e.querySelectorAll&&(r=[].slice.call(e.querySelectorAll(t))),r},Jh=function(e,t){if(e)return e.querySelector(t)},Zh=function(e,t){if(e)return e.getAttribute(t)},Qh=function(e,t,r,a){if("function"!=typeof e.addEventListener){if(!e.attachEvent)throw new Error(": Unable to bind "+t+"-event");e.attachEvent("on"+t,r)}else e.addEventListener(t,r,a)},$h=function(e,t,r,a){if("function"==typeof e.addEventListener)e.removeEventListener(t,r,a);else{if(!e.attachEvent)throw new Error(": Unable to unbind "+t+"-event");e.detachEvent("on"+t,r)}},Xh=function(e,t,r,a,n){if(!Object.prototype.hasOwnProperty.call(e,"error"))return null;var o=t,i={rootNode:a,fieldType:e.fieldType,error:null,type:null},l=""!==e.error;return l||o.hasError?o.errorType===ju["Unsupported card entered"]?null:(i.error=l?e.error:"",i.type=r,o.hasError=l,o.errorType=i.error,n(i),i):null};function ef(e){var t,r,a,n,o=e.fieldType;if("card"===this.state.type&&Object.prototype.hasOwnProperty.call(e,"cvcPolicy")&&zh(e.cvcPolicy)&&Object.prototype.hasOwnProperty.call(this.state.securedFields,ph)&&(this.state.securedFields.encryptedSecurityCode.cvcPolicy=e.cvcPolicy),Xh(e,this.state.securedFields[o],this.state.type,this.props.rootNode,this.callbacks.onError),this.state.securedFields[o].isEncrypted){t=function(e){var t,r,a=e.fieldType,n=e.txVariant,o=e.rootNode,i=a===ch,l=[],s=["encryptedExpiryMonth","encryptedExpiryYear"],c=i?2:1;for(t=0;t<c;t+=1){r=i?s[t]:a;var d=Yh({fieldType:a,encryptedFieldName:i?r:a,uuid:n+"-encrypted-"+r,isValid:!1,txVariant:n,rootNode:o});l.push(d)}return l}({fieldType:o,txVariant:this.state.type,rootNode:this.props.rootNode}),o===sh&&(t[0].endDigits="");for(var i=0,l=t.length;i<l;i+=1)this.config.allowedDOMAccess&&(r=this.props.rootNode,a=t[i].uid,n=void 0,(n=Jh(r,"#"+a))&&r.removeChild(n)),this.callbacks.onFieldValid(t[i]);this.state.securedFields[o].isEncrypted=!1}this.assessFormValidity(),Object.prototype.hasOwnProperty.call(e,"brand")&&this.processBrand(e)}function tf(e){var t,r,a=e.fieldType;this.config.autoFocus&&("year"!==e.type&&a!==uh||this.setFocusOnFrame(ph),a===dh&&this.setFocusOnFrame(uh));var n=e[a];this.state.securedFields[a].isEncrypted=!0,this.config.allowedDOMAccess&&function(e,t,r){var a,n,o,i,l,s,c,d;for(a=0;a<e.length;a+=1){var u=e[a];n=t+"-encrypted-"+(o=u.encryptedFieldName),l=o,s=u.blob,d=void 0,(d=Jh(i=r,"#"+(c=n)))||((d=document.createElement("input")).type="hidden",d.name=l,d.id=c,i.appendChild(d)),d.setAttribute("value",s)}}(n,this.state.type,this.props.rootNode),Xh({error:"",fieldType:a},this.state.securedFields[a],this.state.type,this.props.rootNode,this.callbacks.onError);var o=function(e){var t,r,a,n,o,i=e.fieldType,l=e.txVariant,s=e.rootNode,c=e.encryptedObjArr,d=[];for(t=0;t<c.length;t+=1){r=l+"-encrypted-"+(n=(a=c[t]).encryptedFieldName),o=a.blob;var u=Yh({fieldType:i,encryptedFieldName:n,uuid:r,isValid:!0,txVariant:l,rootNode:s});u.blob=o,d.push(u)}return d}({fieldType:a,txVariant:this.state.type,rootNode:this.props.rootNode,encryptedObjArr:n});if(a===dh&&Object.prototype.hasOwnProperty.call(this.state.securedFields,uh)){var i={txVariant:this.state.type,code:e.code,blob:n[0].blob,fieldType:uh,numKey:this.state.securedFields.encryptedExpiryYear.numKey};Hh(i,this.getIframeContentWin(uh),this.config.loadingContext)}for(a===sh&&Ih(e.endDigits)&&(o[0].endDigits=e.endDigits),t=0,r=o.length;t<r;t+=1)this.callbacks.onFieldValid(o[t]);this.assessFormValidity()}var rf={__NO_BRAND:"noBrand",cards:[]};rf.cards.push({cardType:"mc",startingRules:[51,52,53,54,55,22,23,24,25,26,27],permittedLengths:[16],pattern:/^(5[1-5][0-9]{0,14}|2[2-7][0-9]{0,14})$/,securityCode:"CVC"}),rf.cards.push({cardType:"visadankort",startingRules:[4571],permittedLengths:[16],pattern:/^(4571)[0-9]{0,12}$/}),rf.cards.push({cardType:"visa",startingRules:[4],permittedLengths:[13,16,19],pattern:/^4[0-9]{0,18}$/,securityCode:"CVV"}),rf.cards.push({cardType:"amex",startingRules:[34,37],permittedLengths:[15],pattern:/^3[47][0-9]{0,13}$/,securityCode:"CID"}),rf.cards.push({cardType:"diners",startingRules:[36],permittedLengths:[14],pattern:/^(36)[0-9]{0,12}$/}),rf.cards.push({cardType:"maestrouk",startingRules:[6759],permittedLengths:[16,18,19],pattern:/^(6759)[0-9]{0,15}$/}),rf.cards.push({cardType:"solo",startingRules:[6767],permittedLengths:[16,18,19],pattern:/^(6767)[0-9]{0,15}$/}),rf.cards.push({cardType:"laser",startingRules:[6304,6706,677117,677120],permittedLengths:[16,17,18,19],pattern:/^(6304|6706|6709|6771)[0-9]{0,15}$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"discover",startingRules:[6011,644,645,646,647,648,649,65],permittedLengths:[16],pattern:/^(6011[0-9]{0,12}|(644|645|646|647|648|649)[0-9]{0,13}|65[0-9]{0,14})$/}),rf.cards.push({cardType:"jcb",startingRules:[3528,3529,353,354,355,356,357,358],permittedLengths:[16,19],pattern:/^(352[8,9]{1}[0-9]{0,15}|35[4-8]{1}[0-9]{0,16})$/,securityCode:"CAV"}),rf.cards.push({cardType:"bcmc",startingRules:[6703,479658,606005],permittedLengths:[16,17,18,19],pattern:/^((6703)[0-9]{0,15}|(479658|606005)[0-9]{0,13})$/,cvcPolicy:"hidden"}),rf.cards.push({cardType:"bijcard",startingRules:[5100081],permittedLengths:[16],pattern:/^(5100081)[0-9]{0,9}$/}),rf.cards.push({cardType:"dankort",startingRules:[5019],permittedLengths:[16],pattern:/^(5019)[0-9]{0,12}$/}),rf.cards.push({cardType:"hipercard",startingRules:[606282],permittedLengths:[16],pattern:/^(606282)[0-9]{0,10}$/}),rf.cards.push({cardType:"cup",startingRules:[62,81],permittedLengths:[14,15,16,17,18,19],pattern:/^(62|81)[0-9]{0,17}$/}),rf.cards.push({cardType:"maestro",startingRules:[50,56,57,58,6],permittedLengths:[16,17,18,19],pattern:/^(5[0|6-8][0-9]{0,17}|6[0-9]{0,18})$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"elo",startingRules:[506699,50670,50671,50672,50673,50674,50675,50676,506770,506771,506772,506773,506774,506775,506776,506777,506778,401178,438935,451416,457631,457632,504175,627780,636297,636368],permittedLengths:[16],pattern:/^((((506699)|(506770)|(506771)|(506772)|(506773)|(506774)|(506775)|(506776)|(506777)|(506778)|(401178)|(438935)|(451416)|(457631)|(457632)|(504175)|(627780)|(636368)|(636297))[0-9]{0,10})|((50676)|(50675)|(50674)|(50673)|(50672)|(50671)|(50670))[0-9]{0,11})$/}),rf.cards.push({cardType:"uatp",startingRules:[1],permittedLengths:[15],pattern:/^1[0-9]{0,14}$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"cartebancaire",startingRules:[4,5,6],permittedLengths:[16],pattern:/^[4-6][0-9]{0,15}$/}),rf.cards.push({cardType:"visaalphabankbonus",startingRules:[450903],permittedLengths:[16],pattern:/^(450903)[0-9]{0,10}$/}),rf.cards.push({cardType:"mcalphabankbonus",startingRules:[510099],permittedLengths:[16],pattern:/^(510099)[0-9]{0,10}$/}),rf.cards.push({cardType:"hiper",startingRules:[637095,637568,637599,637609,637612],permittedLengths:[16],pattern:/^(637095|637568|637599|637609|637612)[0-9]{0,10}$/}),rf.cards.push({cardType:"oasis",startingRules:[982616],permittedLengths:[16],pattern:/^(982616)[0-9]{0,10}$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"karenmillen",startingRules:[98261465],permittedLengths:[16],pattern:/^(98261465)[0-9]{0,8}$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"warehouse",startingRules:[982633],permittedLengths:[16],pattern:/^(982633)[0-9]{0,10}$/,cvcPolicy:"optional"}),rf.cards.push({cardType:"mir",startingRules:[220],permittedLengths:[16,17,18,19],pattern:/^(220)[0-9]{0,16}$/}),rf.cards.push({cardType:"codensa",startingRules:[590712],permittedLengths:[16],pattern:/^(590712)[0-9]{0,10}$/}),rf.cards.push({cardType:"naranja",startingRules:[377798,377799,402917,402918,527571,527572,589562],permittedLengths:[16,17,18,19],pattern:/^(37|40|5[28])([279])\d*$/}),rf.cards.push({cardType:"cabal",startingRules:[589657,600691,603522,6042,6043,636908],permittedLengths:[16,17,18,19],pattern:/^(58|6[03])([03469])\d*$/}),rf.cards.push({cardType:"shopping",startingRules:[2799,589407,603488],permittedLengths:[16,17,18,19],pattern:/^(27|58|60)([39])\d*$/}),rf.cards.push({cardType:"argencard",startingRules:[501],permittedLengths:[16,17,18,19],pattern:/^(50)(1)\d*$/}),rf.cards.push({cardType:"troy",startingRules:[9792],permittedLengths:[16],pattern:/^(97)(9)\d*$/}),rf.cards.push({cardType:"forbrugsforeningen",startingRules:[600722],permittedLengths:[16],pattern:/^(60)(0)\d*$/}),rf.cards.push({cardType:"vpay",startingRules:[401,408,413,434,435,437,439,441,442,443,444,446,447,455,458,460,461,463,466,471,479,482,483,487],permittedLengths:[13,14,15,16,17,18,19],pattern:/^(40[1,8]|413|43[4,5]|44[1,2,3,4,6,7]|45[5,8]|46[0,1,3,6]|47[1,9]|48[2,3,7])[0-9]{0,16}$/}),rf.cards.push({cardType:"rupay",startingRules:[508528],permittedLengths:[16],pattern:/^(100003|508(2|[5-9])|60(69|[7-8])|652(1[5-9]|[2-5][0-9]|8[5-9])|65300[3-4]|8172([0-1]|[3-5]|7|9)|817(3[3-8]|40[6-9]|410)|35380([0-2]|[5-6]|9))[0-9]{0,12}$/});var af=function(e){return rf.cards.filter((function(t){return t.cardType===e}))[0]},nf=function(e){return void 0===e&&(e="card"),"card"===e||"scheme"===e};rf.__NO_BRAND,rf.cards;var of=function(e){var t=ju[e];return t||((t=Object.keys(ju).find((function(t){return ju[t]===e})))||e)},lf=function(e,t){var r=Tc({},e);return r.error=r.error?r.error:function(e){return Object.keys(ju).reduce((function(t,r){var a=ju[r];return(a.indexOf("sf-")>-1||a.indexOf("gen.01")>-1)&&(t[a]=e.get(a)),t}),{})}(t),r};var sf,cf=function(e){function t(t,r){var a=e.call(this)||this,n=["fieldType","iframeSrc","cvcPolicy","datePolicy","loadingContext","holderEl"],o=xh(n).from(t);a.config=Tc(Tc(Tc({},a.config),o),{iframeUIConfig:Tc({},o.iframeUIConfig)});var i=Sh(n).from(t);return a.fieldType=i.fieldType,a.cvcPolicy=i.cvcPolicy,a.datePolicy=i.datePolicy,a.iframeSrc=i.iframeSrc,a.loadingContext=i.loadingContext,a.holderEl=i.holderEl,a.isValid=!1,a.iframeContentWindow=null,a.numKey=function(){if(!window.crypto)return 4294967296*Math.random()|0;var e=new Uint32Array(1);return window.crypto.getRandomValues(e),e[0]}(),a.isEncrypted=!1,a.hasError=!1,a.errorType="",a.init(r)}return Bc(t,e),t.prototype.init=function(e){var t=function(e,t,r){var a,n=["ach","giftcard"].includes(e.txVariant)?e.txVariant:"creditCard",o=r.get(n+"."+t+".aria.iframeTitle"),i=r.get(n+"."+t+".aria.label"),l=r.locale,s=lf({iframeTitle:o,label:i},r);return Tc(Tc({},l&&{lang:l}),((a={})[t]=s,a))}(this.config,this.fieldType,e);this.config.iframeUIConfig.ariaConfig=t;var r=function(e,t,r){var a,n,o,i=e.txVariant,l=function(e){var t;return(t={}).encryptedCardNumber=e.get&&e.get("creditCard.numberField.placeholder"),t.encryptedExpiryDate=e.get&&e.get("creditCard.expiryDateField.placeholder"),t.encryptedExpiryMonth=e.get&&e.get("creditCard.expiryDateField.month.placeholder"),t.encryptedExpiryYear=e.get&&e.get("creditCard.expiryDateField.year.placeholder"),t.encryptedSecurityCode=e.get&&e.get("creditCard.cvcField.placeholder"),t.encryptedSecurityCode3digits=e.get&&e.get("creditCard.cvcField.placeholder.3digits"),t.encryptedSecurityCode4digits=e.get&&e.get("creditCard.cvcField.placeholder.4digits"),t.encryptedPassword=e.get&&e.get("creditCard.encryptedPassword.placeholder"),t}(r);return Tc(Tc(Tc({},t!==ph&&((a={})[t]=l[t],a)),t===ph&&i===hh&&((n={})[t]=l[t],n)),t===ph&&i!==hh&&((o={}).encryptedSecurityCode3digits=l.encryptedSecurityCode3digits,o.encryptedSecurityCode4digits=l.encryptedSecurityCode4digits,o))}(this.config,this.fieldType,e);this.config.iframeUIConfig.placeholders=r;var a=function(e){var t=e.src,r=e.title,a=void 0===r?"iframe element":r,n=e.policy,o=void 0===n?"origin":n,i=e.styleStr,l=void 0===i?"border: none; height:100%; width:100%;":i,s=document.createElement("iframe");s.setAttribute("src",t),s.setAttribute("class","js-iframe"),s.setAttribute("title",a),s.setAttribute("frameborder","0"),s.setAttribute("scrolling","no"),s.setAttribute("allowtransparency","true"),s.setAttribute("style",l),s.setAttribute("referrerpolicy",o);var c=document.createTextNode("<p>Your browser does not support iframes.</p>");return s.appendChild(c),s}({src:this.iframeSrc,title:t[this.fieldType].iframeTitle,policy:"origin"});this.holderEl.appendChild(a);var n=Jh(this.holderEl,".js-iframe");return n&&(this.iframeContentWindow=n.contentWindow,this.iframeOnLoadListener=this.iframeOnLoadListenerFn,Qh(n,"load",this.iframeOnLoadListener,!1)),this},t.prototype.iframeOnLoadListenerFn=function(){$h(window,"load",this.iframeOnLoadListener,!1),this.postMessageListener=this.postMessageListenerFn,Qh(window,"message",this.postMessageListener,!1);var e={fieldType:this.fieldType,cvcPolicy:this.cvcPolicy,numKey:this.numKey,txVariant:this.config.txVariant,extraFieldData:this.config.extraFieldData,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig,sfLogAtStart:this.config.sfLogAtStart,showWarnings:this.config.showWarnings,trimTrailingSeparator:this.config.trimTrailingSeparator,isCreditCardType:this.config.isCreditCardType,legacyInputMode:this.config.legacyInputMode,minimumExpiryDate:this.config.minimumExpiryDate,uid:this.config.uid,implementationType:this.config.implementationType};Hh(e,this.iframeContentWindow,this.loadingContext),this.onIframeLoadedCallback()},t.prototype.postMessageListenerFn=function(e){if(function(e,t,r){var a=e.origin,n=t.indexOf("/checkoutshopper/"),o=n>-1?t.substring(0,n):t,i=o.length-1;return"/"===o.charAt(i)&&(o=o.substring(0,i)),a===o||(r&&(Lh("WARNING postMessageValidation: postMessage listener for iframe::origin mismatch!\n Received message with origin:",a,"but the only allowed origin for messages to CSF is",o),Lh("### event.data=",e.data)),!1)}(e,this.loadingContext,this.config.showWarnings)){var t;try{t=JSON.parse(e.data)}catch(t){return function(e){return e.data&&e.data.type&&"string"==typeof e.data.type&&e.data.type.indexOf("webpack")>-1}(e)?void(this.config.showWarnings&&Rh("### SecuredField::postMessageListenerFn:: PARSE FAIL - WEBPACK")):function(e){return e.data&&"string"==typeof e.data&&e.data.indexOf("cvox")>-1}(e)?void(this.config.showWarnings&&Rh("### SecuredField::postMessageListenerFn:: PARSE FAIL - CHROMEVOX")):void(this.config.showWarnings&&Rh("### SecuredField::postMessageListenerFn:: PARSE FAIL - UNKNOWN REASON: event.data=",e.data))}if(Object.prototype.hasOwnProperty.call(t,"action")&&Object.prototype.hasOwnProperty.call(t,"numKey"))if(this.numKey===t.numKey)switch(t.action){case"encryption":this.isValid=!0,this.onEncryptionCallback(t);break;case"config":this.onConfigCallback(t);break;case"focus":this.onFocusCallback(t);break;case"binValue":this.onBinValueCallback(t);break;case"click":this.onClickCallback(t);break;case"shifttab":this.onShiftTabCallback(t);break;case"autoComplete":this.onAutoCompleteCallback(t);break;default:this.isValid=!1,this.onValidationCallback(t)}else this.config.showWarnings&&Lh("WARNING SecuredField :: postMessage listener for iframe :: data mismatch! (Probably a message from an unrelated securedField)");else this.config.showWarnings&&Lh("WARNING SecuredField :: postMessage listener for iframe :: data mismatch!")}},t.prototype.destroy=function(){$h(window,"message",this.postMessageListener,!1),this.iframeContentWindow=null,function(e){for(;e.firstChild;)e.removeChild(e.firstChild)}(this.holderEl)},t.prototype.onIframeLoaded=function(e){return this.onIframeLoadedCallback=e,this},t.prototype.onEncryption=function(e){return this.onEncryptionCallback=e,this},t.prototype.onValidation=function(e){return this.onValidationCallback=e,this},t.prototype.onConfig=function(e){return this.onConfigCallback=e,this},t.prototype.onFocus=function(e){return this.onFocusCallback=e,this},t.prototype.onBinValue=function(e){return this.onBinValueCallback=e,this},t.prototype.onClick=function(e){return this.onClickCallback=e,this},t.prototype.onShiftTab=function(e){return this.onShiftTabCallback=e,this},t.prototype.onAutoComplete=function(e){return this.onAutoCompleteCallback=e,this},Object.defineProperty(t.prototype,"errorType",{get:function(){return this._errorType},set:function(e){this._errorType=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"hasError",{get:function(){return this._hasError},set:function(e){this._hasError=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){if(this.fieldType===ph)switch(this.cvcPolicy){case gh:return!0;case vh:return!this.hasError;default:return this._isValid}return this.fieldType===ch&&this.datePolicy===Ch||this._isValid},set:function(e){this._isValid=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"cvcPolicy",{get:function(){return this._cvcPolicy},set:function(e){this.fieldType===ph&&e!==this.cvcPolicy&&(this._cvcPolicy=e,this.hasError&&"isValidated"===this.errorType&&(this.hasError=!1))},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"datePolicy",{get:function(){return this._datePolicy},set:function(e){this.fieldType===ch&&e!==this.datePolicy&&(this._datePolicy=e)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"iframeContentWindow",{get:function(){return this._iframeContentWindow},set:function(e){this._iframeContentWindow=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isEncrypted",{get:function(){return this._isEncrypted},set:function(e){this._isEncrypted=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"numKey",{get:function(){return this._numKey},set:function(e){this._numKey=e},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"iframeOnLoadListener",{get:function(){return this._iframeOnLoadListener},set:function(e){this._iframeOnLoadListener=e.bind(this)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"postMessageListener",{get:function(){return this._postMessageListener},set:function(e){this._postMessageListener=e.bind(this)},enumerable:!1,configurable:!0}),t}((function(){this.config={}}));function df(){this.encryptedAttrName=_h;var e=Wh(this.props.rootNode,"["+this.encryptedAttrName+"]");return sf=bh,this.config.isCreditCardType?(this.isSingleBrandedCard=!1,this.securityCode="",this.createCardSecuredFields(e)):this.createNonCardSecuredFields(e)}function uf(e){return e.forEach(this.setupSecuredField.bind(this)),e.length}function pf(e){var t=this,r=this.state.type;if("card"===r&&1===this.config.cardGroupTypes.length&&(r=this.config.cardGroupTypes[0],this.state.type=r),this.isSingleBrandedCard="card"!==r,this.isSingleBrandedCard){var a=af(r);zh(a)?(sf=a.cvcPolicy||bh,this.securityCode=a.securityCode):this.state.type="unrecognised-single-brand"}if(e.forEach(this.setupSecuredField.bind(this)),this.isSingleBrandedCard){var n={type:this.state.type,rootNode:this.props.rootNode,brand:r,cvcPolicy:sf,cvcText:this.securityCode};setTimeout((function(){t.callbacks.onBrand(n)}),0)}return e.length}function mf(e){var t=this,r=Zh(e,this.encryptedAttrName);r===uh&&(this.state.hasSeparateDateFields=!0);var a={fieldType:r,extraFieldData:Zh(e,Nh),uid:Zh(e,wh),txVariant:this.state.type,cardGroupTypes:this.config.cardGroupTypes,iframeUIConfig:this.config.iframeUIConfig?this.config.iframeUIConfig:{},sfLogAtStart:this.config.sfLogAtStart,trimTrailingSeparator:this.config.trimTrailingSeparator,cvcPolicy:sf,datePolicy:kh,isCreditCardType:this.config.isCreditCardType,iframeSrc:this.config.iframeSrc,loadingContext:this.config.loadingContext,showWarnings:this.config.showWarnings,holderEl:e,legacyInputMode:this.config.legacyInputMode,minimumExpiryDate:this.config.minimumExpiryDate,implementationType:this.config.implementationType},n=new cf(a,this.props.i18n).onIframeLoaded((function(){if(t.state.iframeCount+=1,t.state.iframeCount===t.state.originalNumIframes){t.callbacks.onLoad({iframesLoaded:!0})}})).onConfig((function(e){t.handleIframeConfigFeedback(e)})).onFocus((function(e){t.handleFocus(e)})).onBinValue((function(e){t.handleBinValue(e)})).onClick((function(e){t.postMessageToAllIframes({fieldType:e.fieldType,click:!0})})).onShiftTab((function(e){t.handleSFShiftTab(e.fieldType)})).onEncryption((function(e){t.handleEncryption(e)})).onValidation((function(e){t.handleValidation(e)})).onAutoComplete((function(e){t.processAutoComplete(e)}));this.state.securedFields[r]=n}function hf(e,t){if(Object.prototype.hasOwnProperty.call(this.state.securedFields,e)){var r={txVariant:this.state.type,fieldType:e,focus:!0,numKey:this.state.securedFields[e].numKey};Hh(r,this.getIframeContentWin(e),this.config.loadingContext)}}function ff(e){var t=this,r=Object.keys(e||{});r.length&&Object.keys(this.state.securedFields).forEach((function(a){var n={txVariant:t.state.type,fieldType:a,numKey:t.state.securedFields[a].numKey};r.forEach((function(t){n[t]=e[t]})),Hh(n,t.getIframeContentWin(a),t.config.loadingContext)}))}function yf(){var e=this;this.postMessageToAllIframes({destroy:!0}),Object.keys(this.state.securedFields).forEach((function(t){var r=e.state.securedFields[t];r&&r.destroy(),e.state.securedFields[t]=null})),this.destroyTouchendListener(),this.state.securedFields={}}function bf(e){var t=this;if("cc-name"===e.name){var r=Tc({},e);delete r.numKey;var a=r;this.callbacks.onAutoComplete(a)}if("cc-exp"===e.name){var n=e.value.replace(/[^0-9]/gi,"/").split("/");if(2!==n.length)return;1===n[0].length&&(n[0]="0"+n[0]);var o=n[0],i=n[1].substr(2),l=o+"/"+i;if(Object.prototype.hasOwnProperty.call(this.state.securedFields,ch)){var s={txVariant:this.state.type,fieldType:ch,autoComplete:l,numKey:this.state.securedFields.encryptedExpiryDate.numKey};return void Hh(s,this.getIframeContentWin(ch),this.config.loadingContext)}if(Object.prototype.hasOwnProperty.call(this.state.securedFields,dh)){s={txVariant:this.state.type,fieldType:dh,autoComplete:o,numKey:this.state.securedFields.encryptedExpiryMonth.numKey};Hh(s,this.getIframeContentWin(dh),this.config.loadingContext)}Object.prototype.hasOwnProperty.call(this.state.securedFields,uh)&&setTimeout((function(){var e={txVariant:t.state.type,fieldType:uh,autoComplete:i,numKey:t.state.securedFields.encryptedExpiryYear.numKey};Hh(e,t.getIframeContentWin(uh),t.config.loadingContext)}),0)}}function vf(e){var t=Tc({},e);delete t.numKey,t.rootNode=this.props.rootNode,t.type=this.state.type;var r=t.fieldType;t.focus?this.state.currentFocusObject!==r&&(this.state.currentFocusObject=r,this.state.registerFieldForIos||this.handleAdditionalFields()):this.state.currentFocusObject===r&&(this.state.currentFocusObject=null);var a=t;a.currentFocusObject=this.state.currentFocusObject,this.callbacks.onFocus(a)}function gf(e){if(this.state.iframeConfigCount+=1,this.state.isConfigured){var t={additionalIframeConfigured:!0,fieldType:e.fieldType,type:this.state.type};this.callbacks.onAdditionalSFConfig(t)}else if(this.state.iframeConfigCount===this.state.originalNumIframes)return this.isConfigured(),!0;return!1}function kf(){var e;this.state.isConfigured=!0;var t={iframesConfigured:!0,type:this.state.type,rootNode:this.props.rootNode};if(this.callbacks.onConfigSuccess(t),1===this.state.numIframes&&this.config.isCreditCardType){if("card"===this.state.type)return void Eh("ERROR: Payment method with a single secured field - but 'type' has not been set to a specific card brand");var r=af(this.state.type);if(r)(null!==(e=r.cvcPolicy)&&void 0!==e?e:bh)!==bh&&this.assessFormValidity()}}function Cf(){var e=function(e){for(var t=Object.keys(e),r=0,a=t.length;r<a;r+=1)if(!e[t[r]].isValid)return!1;return!0}(this.state.securedFields),t=e!==this.state.allValid;if(this.state.allValid=e,e||t){var r={allValid:e,type:this.state.type,rootNode:this.props.rootNode};this.callbacks.onAllValid(r)}}function _f(e){var t=e.binValue,r=e.encryptedBin,a=e.uuid,n={binValue:t,type:this.state.type};r&&(n.encryptedBin=r,n.uuid=a),this.callbacks.onBinValue(n)}function Nf(e){if(Object.prototype.hasOwnProperty.call(this.state.securedFields,sh)){var t=Tc(Tc({txVariant:this.state.type},e),{fieldType:sh,numKey:this.state.securedFields.encryptedCardNumber.numKey});Hh(t,this.getIframeContentWin(sh),this.config.loadingContext)}}function wf(e){var t,r="card"===this.state.type;if(!e||!Object.keys(e).length)return r&&this.sendBrandToCardSF({brand:"reset"}),void("card"===this.state.type&&Object.prototype.hasOwnProperty.call(this.state.securedFields,ch)&&(this.state.securedFields.encryptedExpiryDate.datePolicy=kh));var a=e.supportedBrands[0],n=a.brand,o=!0===a.showExpiryDate?kh:Ch,i={brand:n,cvcPolicy:a.cvcPolicy,datePolicy:o,cvcText:"Security code",showSocialSecurityNumber:null!==(t=a.showSocialSecurityNumber)&&void 0!==t&&t,fieldType:sh};this.processBrand(i),r&&this.sendBrandToCardSF({brand:n,enableLuhnCheck:!1!==e.supportedBrands[0].enableLuhnCheck}),Object.prototype.hasOwnProperty.call(this.state.securedFields,ph)&&(this.state.securedFields.encryptedSecurityCode.cvcPolicy=a.cvcPolicy),Object.prototype.hasOwnProperty.call(this.state.securedFields,ch)&&(this.state.securedFields.encryptedExpiryDate.datePolicy=o),this.assessFormValidity()}var Pf={__IS_ANDROID:/(android)/i.test(navigator.userAgent),__IS_IE:function(){var e=navigator.userAgent,t=e.indexOf("MSIE ");if(t>0)return parseInt(e.substring(t+5,e.indexOf(".",t)),10);if(e.indexOf("Trident/")>0){var r=e.indexOf("rv:");return parseInt(e.substring(r+3,e.indexOf(".",r)),10)}var a=e.indexOf("Edge/");return a>0&&parseInt(e.substring(a+5,e.indexOf(".",a)),10)}(),__IS_IOS:/iphone|ipod|ipad/i.test(navigator.userAgent),__IS_FIREFOX:/(firefox)/i.test(navigator.userAgent),__IS_SAFARI:/(safari)/i.test(navigator.userAgent)&&!/(chrome)/i.test(navigator.userAgent)};var Ff={touchendListener:function(e){var t,r=e.target;if(r instanceof HTMLInputElement||HTMLTextAreaElement&&r instanceof HTMLTextAreaElement){var a=r.value,n="selectionStart"in(t=r)?t.selectionStart:0,o=!1;n===a.length&&(n-=1,o=!0),r.value=a,r.setSelectionRange&&(r.focus(),r.setSelectionRange(n,n),o&&(n+=1,setTimeout((function(){r.setSelectionRange(n,n)}),0)))}else{if(this.config.keypadFix){var i=this.props.rootNode,l=document.createElement("input");l.style.width="1px",l.style.height="1px",l.style.opacity="0",l.style.fontSize="18px",i.appendChild(l),l.focus(),i.removeChild(l)}}this.destroyTouchendListener(),this.state.registerFieldForIos=!1,this.postMessageToAllIframes({fieldType:"additionalField",click:!0})},handleAdditionalFields:function(){if(Pf.__IS_IOS){var e=Jh(document,"body");e.style.cursor="pointer",Qh(e,"touchend",this.touchendListener),this.state.registerFieldForIos=!0}},destroyTouchendListener:function(){if(Pf.__IS_IOS){var e=Jh(document,"body");e.style.cursor="auto",$h(e,"touchend",this.touchendListener)}}},Df=function(e,t){return function(e,t){void 0===t&&(t=!0);var r=Array.prototype.slice.call(Wh(document,"*[data-cse], a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), object, embed, *[tabindex], *[contenteditable]")),a=[];r.forEach((function(e){var t=e.getAttribute("tabindex"),r=!t||parseInt(t,10)>=0,n=e.getBoundingClientRect(),o=n.width>0&&n.height>0;r&&o&&a.push(e)}));var n=function(e,t){for(var r=0;r<e.length;r+=1)if(t(e[r]))return r;return-1}(a,(function(t){return t===e||e.contains(t)}));return a[n+(t?-1:1)]}(Jh(t,"[data-cse="+e+"]"))};var Af=function(e){var t;switch(this.state.type){case"ach":t=function(e){var t;return"encryptedBankLocationId"===e&&(t="encryptedBankAccountNumber"),{fieldToFocus:t,additionalField:void 0}}(e);break;case"giftcard":t=function(e,t){var r,a;switch(e){case sh:r=Df(sh,t);break;case ph:a=sh}return{fieldToFocus:a,additionalField:r}}(e,this.props.rootNode);break;default:t=this.state.isKCP?function(e,t,r){var a,n;switch(e){case sh:a=Df(sh,t);break;case ch:case dh:n=sh;break;case uh:n=dh;break;case ph:n=r?uh:ch;break;case mh:case"encryptedPin":a=Df(e,t)}return{fieldToFocus:n,additionalField:a}}(e,this.props.rootNode,this.state.hasSeparateDateFields):function(e,t,r,a){var n,o;switch(e){case sh:n=Df(sh,t);break;case ch:case dh:o=sh;break;case uh:o=dh;break;case ph:1===a?n=Df(ph,t):o=r?uh:ch}return{fieldToFocus:o,additionalField:n}}(e,this.props.rootNode,this.state.hasSeparateDateFields,this.state.numIframes)}var r,a=t.fieldToFocus,n=t.additionalField;a?this.setFocusOnFrame(a,false):n&&(r=n)&&(r.focus(),r.blur(),r.focus())},Sf=function(e){(Pf.__IS_FIREFOX||Pf.__IS_IE&&Pf.__IS_IE<=11)&&this.handleShiftTab(e)},xf=function(e){void 0===e&&(e="You cannot use secured fields"),Lh(e+" - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},Bf=function(e){function t(t){var r=e.call(this,t)||this;return r.state={type:r.props.type,brand:"card"!==r.props.type?{brand:r.props.type,cvcPolicy:"required"}:{brand:null,cvcPolicy:"required"},allValid:void 0,numIframes:0,originalNumIframes:0,iframeCount:0,iframeConfigCount:0,isConfigured:!1,hasSeparateDateFields:!1,currentFocusObject:null,registerFieldForIos:!1,securedFields:{},isKCP:!1},r.configHandler=Vh,r.callbacksHandler=Kh,r.handleIframeConfigFeedback=gf,r.isConfigured=kf,r.assessFormValidity=Cf,r.processBrand=Gh,r.handleValidation=ef,r.handleEncryption=tf,r.createSecuredFields=df,r.createNonCardSecuredFields=uf,r.createCardSecuredFields=pf,r.setupSecuredField=mf,r.postMessageToAllIframes=ff,r.setFocusOnFrame=hf,r.handleFocus=vf,r.handleAdditionalFields=Ff.handleAdditionalFields,r.touchendListener=Ff.touchendListener.bind(r),r.destroyTouchendListener=Ff.destroyTouchendListener,r.handleSFShiftTab=Sf,r.handleShiftTab=Af,r.destroySecuredFields=yf,r.processAutoComplete=bf,r.handleBinValue=_f,r.brandsFromBinLookup=wf,r.sendBrandToCardSF=Nf,r.init(),r}return Bc(t,e),t.prototype.init=function(){this.configHandler(),this.callbacksHandler(this.props.callbacks);var e=this.createSecuredFields();this.state.numIframes=this.state.originalNumIframes=e,this.state.isKCP=!!this.props.isKCP},t.prototype.createReturnObject=function(){var e=this;return{updateStyles:function(t){e.state.isConfigured?e.postMessageToAllIframes({styleObject:t}):Lh("You cannot update the secured fields styling - they are not yet configured. Use the 'onConfigSuccess' callback to know when this has happened.")},setFocusOnFrame:function(t){e.state.isConfigured?e.setFocusOnFrame(t):xf("You cannot set focus on any secured field")},isValidated:function(t,r){if(e.state.isConfigured){if(Object.prototype.hasOwnProperty.call(e.state.securedFields,t)){e.state.securedFields[t].hasError=!0,""===e.state.securedFields[t].errorType&&(e.state.securedFields[t].errorType="isValidated");var a={txVariant:e.state.type,fieldType:t,externalValidation:!0,code:r,numKey:e.state.securedFields[t].numKey};Hh(a,e.getIframeContentWin(t),e.config.loadingContext)}}else xf("You cannot set validated on any secured field")},hasUnsupportedCard:function(t,r){if(e.state.isConfigured){if(Object.prototype.hasOwnProperty.call(e.state.securedFields,t)){e.state.securedFields[t].hasError=!!r,e.state.securedFields[t].errorType=r;var a={txVariant:e.state.type,fieldType:t,unsupportedCard:!!r,code:r,numKey:e.state.securedFields[t].numKey};Hh(a,e.getIframeContentWin(t),e.config.loadingContext)}}else xf("You cannot set hasUnsupportedCard on any secured field")},destroy:function(){e.state.isConfigured?e.destroySecuredFields():xf("You cannot destroy secured fields")},brandsFromBinLookup:function(t){if(!e.config.isCreditCardType)return null;e.state.isConfigured?e.brandsFromBinLookup(t):xf("You cannot set pass brands to secured fields")},addSecuredField:function(t){var r=Jh(e.props.rootNode,'[data-cse="'+t+'"]');r&&(e.state.numIframes+=1,e.setupSecuredField(r))},removeSecuredField:function(t){if(e.state.securedFields[t]){e.state.securedFields[t].destroy(),delete e.state.securedFields[t],e.state.numIframes-=1;var r={additionalIframeRemoved:!0,fieldType:t,type:e.state.type};e.callbacks.onAdditionalSFRemoved(r)}},setKCPStatus:function(t){e.state.isKCP=t}}},t.prototype.getIframeContentWin=function(e){var t;return(null===(t=this.state.securedFields[e])||void 0===t?void 0:t.iframeContentWindow)||null},t}((function(e){this.props=e,this.state={},this.config={},this.callbacks={}})),Tf=function(e){if(!e)throw new Error("No securedFields configuration object defined");var t=Tc({},e),r=nf(t.type);if(t.type=r?"card":t.type,!Object.prototype.hasOwnProperty.call(t,"rootNode"))return Eh('ERROR: SecuredFields configuration object is missing a "rootNode" property'),null;if(Oh(t.clientKey))return Lh('WARNING: AdyenCheckout configuration object is missing a "clientKey" property.'),null;var a=function(e){var t;return"object"==typeof e&&(t=e),"string"!=typeof e||(t=Jh(document,e))?t:null}(t.rootNode);return a?(t.rootNode=a,new Bf(t).createReturnObject()):(window.console&&window.console.error&&window.console.error("ERROR: SecuredFields cannot find a valid rootNode element for",t.type),null)};var zf={handleFocus:function(e){e.fieldType===ph&&(this.numCharsInCVC=e.numChars),this.props.onFocus(e)},handleOnAllValid:function(e){var t=this;return!this.state.hasUnsupportedCard&&(this.setState({isSfpValid:e.allValid},(function(){t.props.onChange(t.state),t.props.onAllValid(e)})),!0)},handleOnAutoComplete:function(e){var t=this;this.setState({autoCompleteName:e.value},(function(){t.props.onChange(t.state),t.setState({autoCompleteName:null})})),this.props.onAutoComplete(e)},handleOnFieldValid:function(e){var t=this;return(!this.state.hasUnsupportedCard||e.fieldType!==sh)&&(this.setState((function(t){var r,a,n,o;return{data:Tc(Tc({},t.data),(r={},r[e.encryptedFieldName]=e.blob,r)),valid:Tc(Tc({},t.valid),(a={},a[e.encryptedFieldName]=e.valid,a)),errors:Tc(Tc({},t.errors),(n={},n[e.fieldType]=null!==(o=t.errors[e.fieldType])&&void 0!==o&&o,n))}}),(function(){t.props.onChange(t.state),t.props.onFieldValid(e)})),!0)},handleOnLoad:function(e){var t=this;this.props.onLoad(e),this.originKeyErrorTimeout=setTimeout((function(){"ready"!==t.state.status&&(t.setState({status:"originKeyError"}),t.props.onError({error:"originKeyError",fieldType:"defaultError"}))}),this.originKeyTimeoutMS)},handleOnConfigSuccess:function(e){var t=this;clearTimeout(this.originKeyErrorTimeout),this.setState({status:"ready"},(function(){t.props.onConfigSuccess(e)}))},handleOnBrand:function(e){var t=this;this.setState((function(r){var a,n,o=(e.cvcPolicy!==vh&&e.cvcPolicy!==gh||0!==t.numCharsInCVC)&&r.errors.encryptedSecurityCode;return{brand:e.brand,cvcPolicy:null!==(n=e.cvcPolicy)&&void 0!==n?n:bh,showSocialSecurityNumber:e.showSocialSecurityNumber,errors:Tc(Tc({},r.errors),zh(o)&&(a={},a.encryptedSecurityCode=o,a)),hideDateForBrand:e.datePolicy===Ch}}),(function(){var r,a;t.props.onChange(t.state);var n=null!==(a=null===(r=t.props.brandsConfiguration[e.brand])||void 0===r?void 0:r.icon)&&void 0!==a?a:Dh(e.brand,t.props.loadingContext);t.props.onBrand(Tc(Tc({},e),{brandImageUrl:n}))}))},handleOnError:function(e,t){var r=this;void 0===t&&(t=null);var a=e.error;this.setState((function(r){var n,o,i;return Tc(Tc(Tc({errors:Tc(Tc({},r.errors),(n={},n[e.fieldType]=a||!1,n)),hasUnsupportedCard:null!==t&&t},t&&{data:Tc(Tc({},r.data),(o={},o.encryptedCardNumber=void 0,o))}),t&&{valid:Tc(Tc({},r.valid),(i={},i.encryptedCardNumber=!1,i))}),t&&{isSfpValid:!1})}),(function(){r.props.onChange(r.state)})),e.errorI18n=this.props.i18n.get(a);var n=of(a);return e.errorText=""!==n?n:"error was cleared",this.props.onError(e),!0},handleOnNoDataRequired:function(){var e=this;this.setState({status:"ready"},(function(){return e.props.onChange({isSfpValid:!0})}))}},If={type:"card",keypadFix:!0,rootNode:null,loadingContext:null,groupTypes:[],allowedDOMAccess:!1,showWarnings:!1,autoFocus:!0,trimTrailingSeparator:!0,onChange:function(){},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onFocus:function(){},onAutoComplete:function(){},placeholders:{},styles:{}},jf=function(e){function t(t){var r=e.call(this,t)||this;r.setRootNode=function(e){r.rootNode=e};var a={status:"loading",brand:t.type,errors:{},valid:{},data:{},cvcPolicy:bh,isSfpValid:!1,hasKoreanFields:r.props.hasKoreanFields};return r.state=a,r.originKeyErrorTimeout=null,r.originKeyTimeoutMS=15e3,r.numCharsInCVC=0,r.handleOnLoad=zf.handleOnLoad.bind(r),r.handleOnConfigSuccess=zf.handleOnConfigSuccess.bind(r),r.handleOnFieldValid=zf.handleOnFieldValid.bind(r),r.handleOnAllValid=zf.handleOnAllValid.bind(r),r.handleOnBrand=zf.handleOnBrand.bind(r),r.handleFocus=zf.handleFocus.bind(r),r.handleOnError=zf.handleOnError.bind(r),r.handleOnNoDataRequired=zf.handleOnNoDataRequired.bind(r),r.handleOnAutoComplete=zf.handleOnAutoComplete.bind(r),r.processBinLookupResponse=r.processBinLookupResponse.bind(r),r.setFocusOn=r.setFocusOn.bind(r),r.updateStyles=r.updateStyles.bind(r),r.handleUnsupportedCard=r.handleUnsupportedCard.bind(r),r.showValidation=r.showValidation.bind(r),r.destroy=r.destroy.bind(r),r}return Bc(t,e),t.prototype.componentDidMount=function(){this.props.rootNode&&this.setRootNode(this.props.rootNode);var e,t=(e=this.rootNode)?Array.prototype.slice.call(e.querySelectorAll('[data-cse*="encrypted"]')).map((function(e){return e.getAttribute("data-cse")})):[],r=t.reduce(Ph,{});this.setState({valid:r}),this.numDateFields=t.filter((function(e){return e.match(/Expiry/)})).length,t.length?(this.destroy(),this.initializeCSF(this.rootNode)):this.handleOnNoDataRequired()},t.prototype.componentDidUpdate=function(){this.checkForKCPFields()},t.prototype.componentWillUnmount=function(){this.csf=null},t.prototype.initializeCSF=function(e){var t=this.props.loadingContext,r={rootNode:e,type:this.props.type,clientKey:this.props.clientKey,cardGroupTypes:this.props.groupTypes,allowedDOMAccess:this.props.allowedDOMAccess,autoFocus:this.props.autoFocus,trimTrailingSeparator:this.props.trimTrailingSeparator,loadingContext:t,keypadFix:this.props.keypadFix,showWarnings:this.props.showWarnings,iframeUIConfig:{sfStyles:this.props.styles},i18n:this.props.i18n,callbacks:{onLoad:this.handleOnLoad,onConfigSuccess:this.handleOnConfigSuccess,onFieldValid:this.handleOnFieldValid,onAllValid:this.handleOnAllValid,onBrand:this.handleOnBrand,onError:this.handleOnError,onFocus:this.handleFocus,onBinValue:this.props.onBinValue,onAutoComplete:this.handleOnAutoComplete,onAdditionalSFConfig:this.props.onAdditionalSFConfig,onAdditionalSFRemoved:this.props.onAdditionalSFRemoved},isKCP:this.state.hasKoreanFields,legacyInputMode:this.props.legacyInputMode,minimumExpiryDate:this.props.minimumExpiryDate,implementationType:this.props.implementationType||"components"};this.csf=Tf(r)},t.prototype.checkForKCPFields=function(){var e=this,t=!1;if(this.props.koreanAuthenticationRequired&&(t=this.issuingCountryCode?"kr"===this.issuingCountryCode:"kr"===this.props.countryCode),this.state.hasKoreanFields&&!t){this.setState((function(e){var t,r,a;return{data:Tc(Tc({},e.data),(t={},t.encryptedPassword=void 0,t)),valid:Tc(Tc({},e.valid),(r={},r.encryptedPassword=!1,r)),errors:Tc(Tc({},e.errors),(a={},a.encryptedPassword=!1,a)),hasKoreanFields:!1}}),(function(){e.props.onChange(e.state)})),this.csf.removeSecuredField(mh),this.csf.setKCPStatus(!1)}if(!this.state.hasKoreanFields&&t){this.setState((function(e){var t;return{valid:Tc(Tc({},e.valid),(t={},t.encryptedPassword=!1,t)),hasKoreanFields:!0,isSfpValid:!1}}),(function(){e.props.onChange(e.state)})),this.csf.addSecuredField(mh),this.csf.setKCPStatus(!0)}},t.prototype.getChildContext=function(){return{i18n:this.props.i18n}},t.prototype.handleUnsupportedCard=function(e){var t=!!e.error;return e.rootNode=this.rootNode,this.handleOnError(e,t),this.csf&&this.csf.hasUnsupportedCard(sh,e.error),t},t.prototype.setFocusOn=function(e){this.csf&&this.csf.setFocusOnFrame(e)},t.prototype.updateStyles=function(e){this.csf&&this.csf.updateStyles(e)},t.prototype.destroy=function(){this.csf&&this.csf.destroy()},t.prototype.showValidation=function(){var e=this,t=this.numDateFields,r=this.state;Object.keys(r.valid).reduce(Fh(t,r),[]).forEach((function(t){var a=function(e,t,r){return{rootNode:t,fieldType:e,error:Dd(r,"errors."+e)||Mu,type:"card"}}(t,e.rootNode,r);e.handleOnError(a,r.hasUnsupportedCard),e.csf&&e.csf.isValidated&&e.csf.isValidated(t,a.error)}))},t.prototype.mapErrorsToValidationRuleResult=function(){var e=this;return Object.keys(this.state.errors).reduce((function(t,r){return e.state.errors[r]?t[r]={isValid:!1,errorMessage:of(e.state.errors[r])}:t[r]=null,t}),{})},t.prototype.processBinLookupResponse=function(e,t){var r,a=this;if(this.state.hasUnsupportedCard&&(this.setState((function(e){var t;return{errors:Tc(Tc({},e.errors),(t={},t.encryptedCardNumber=!1,t)),hasUnsupportedCard:!1}})),this.csf&&e)){this.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""})}this.issuingCountryCode=null===(r=null==e?void 0:e.issuingCountryCode)||void 0===r?void 0:r.toLowerCase(),(null==t?void 0:t.brand)&&this.setState(t,(function(){a.props.onChange(a.state)})),this.csf&&this.csf.brandsFromBinLookup(e)},t.prototype.render=function(e,t){return e.render({setRootNode:this.setRootNode,setFocusOn:this.setFocusOn},t)},t.defaultProps=If,t}(sd),Mf={base:{caretColor:"#0066FF"}},Of={"card-input__wrapper":"CardInput-module_card-input__wrapper__2tAzu","card-input__icon":"CardInput-module_card-input__icon__2Iaf5","card-input__form":"CardInput-module_card-input__form__2Ij_n","card-input__spinner":"CardInput-module_card-input__spinner__1wHzq","card-input__spinner--active":"CardInput-module_card-input__spinner--active__1Dzoe","card-input__form--loading":"CardInput-module_card-input__form--loading__3zh3Y","adyen-checkout__input":"CardInput-module_adyen-checkout__input__3Jmld","adyen-checkout__card__cvc__input--hidden":"CardInput-module_adyen-checkout__card__cvc__input--hidden__1Z1lp","adyen-checkout__card__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-date__input--hidden__3850Y","adyen-checkout__card__exp-cvc__exp-date__input--hidden":"CardInput-module_adyen-checkout__card__exp-cvc__exp-date__input--hidden__3wxr3","revolving-plan-installments__disabled":"CardInput-module_revolving-plan-installments__disabled__2yP53"},Ef="LoadingWrapper-module_loading-input__form__1jpVs",Rf="LoadingWrapper-module_loading-input__form--loading__3LDWz",Lf="LoadingWrapper-module_loading-input__spinner__3eCyK",Vf="LoadingWrapper-module_loading-input__spinner--active__3UDtX",Uf=function(e){var t,r,a=e.children,n=e.status,o=Ed("adyen-checkout__loading-input__form",Ef,((t={})[Rf]="loading"===n,t));return od("div",{style:{position:"relative"}},od("div",{className:Ed(((r={})[Lf]=!0,r[Vf]="loading"===n,r))},od(Rd,null)),od("div",{className:o},a))};function Kf(e){var t=e.frontCVC,r=void 0!==t&&t;return od("div",{className:Ed({"adyen-checkout__card__cvc__hint__wrapper":!0,"adyen-checkout__field__cvc--front-hint":!!r,"adyen-checkout__field__cvc--back-hint":!r})},od("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--front",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},od("path",{d:"M0 3C0 1.34315 1.34315 0 3 0H24C25.6569 0 27 1.34315 27 3V15C27 16.6569 25.6569 18 24 18H3C1.34315 18 0 16.6569 0 15V3Z",fill:"#E6E9EB"}),od("rect",{x:"4",y:"12",width:"19",height:"2",fill:"#B9C4C9"}),od("rect",{x:"4",y:"4",width:"4",height:"4",rx:"1",fill:"white"}),od("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"4.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})),od("svg",{className:"adyen-checkout__card__cvc__hint adyen-checkout__card__cvc__hint--back",width:"27",height:"18",viewBox:"0 0 27 18",fill:"none",xmlns:"http://www.w3.org/2000/svg"},od("path",{d:"M27 4.00001V3.37501C27 2.4799 26.6444 1.62146 26.0115 0.988518C25.3786 0.355581 24.5201 0 23.625 0H3.375C2.47989 0 1.62145 0.355581 0.988514 0.988518C0.355579 1.62146 0 2.4799 0 3.37501V4.00001H27Z",fill:"#E6E9EB"}),od("path",{d:"M0 6.99994V14.6666C0 15.5507 0.355579 16.3985 0.988514 17.0237C1.62145 17.6488 2.47989 18 3.375 18H23.625C24.5201 18 25.3786 17.6488 26.0115 17.0237C26.6444 16.3985 27 15.5507 27 14.6666V6.99994H0Z",fill:"#E6E9EB"}),od("rect",{y:"4.00012",width:"27",height:"3.00001",fill:"#687282"}),od("path",{d:"M4 11C4 10.4477 4.44772 10 5 10H21C22.1046 10 23 10.8954 23 12C23 13.1046 22.1046 14 21 14H5C4.44771 14 4 13.5523 4 13V11Z",fill:"white"}),od("rect",{className:"adyen-checkout__card__cvc__hint__location",x:"16.5",y:"9.5",width:"7",height:"5",rx:"2.5",stroke:"#D10244"})))}function Hf(e){var t,r=((t={})["data-cse"]=e.encryptedFieldType,t[Nh]=e["data-info"],t[wh]=e.uniqueId,t.className=e.className,t);return od("span",Tc({},r),e.children)}function qf(e){var t,r,a=e.label,n=e.onFocusField,o=void 0===n?function(){}:n,i=e.error,l=void 0===i?"":i,s=e.className,c=void 0===s?"":s,d=e.classNameModifiers,u=void 0===d?[]:d,p=e.focused,m=e.filled,h=e.isValid,f=e.frontCVC,y=void 0!==f&&f,b=e.cvcPolicy,v=void 0===b?bh:b,g=su().i18n,k=Ed(c,((t={"adyen-checkout__field__cvc":!0})[Of["adyen-checkout__card__cvc__input--hidden"]]=v===gh,t["adyen-checkout__field__cvc--optional"]=v===vh,t)),C=Ed(((r={"adyen-checkout__input":!0,"adyen-checkout__input--small":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":l,"adyen-checkout__input--focus":p,"adyen-checkout__input--valid":h})[Of["adyen-checkout__input"]]=!0,r)),_=v!==vh?a:g.get("creditCard.cvcField.title.optional");return od(Ou,{label:_,focused:p,filled:m,classNameModifiers:Mc(Mc([],u),["securityCode"]),onFocusField:function(){return o("encryptedSecurityCode")},className:k,errorMessage:l&&g.get(l),isValid:h,dir:"ltr",name:"encryptedSecurityCode"},od(Hf,{encryptedFieldType:"encryptedSecurityCode",className:C}),od(Kf,{frontCVC:y}))}function Gf(e){var t=e.brand,r=e.hasCVC,a=e.onFocusField,n=e.errors,o=e.valid,i=zc(e,["brand","hasCVC","onFocusField","errors","valid"]),l=su().i18n;return od("div",{className:"adyen-checkout__card__form adyen-checkout__card__form--oneClick","aria-label":l.get("creditCard.storedCard.description.ariaLabel").replace("%@",i.lastFour)+" "+l.get("creditCard.expiryDateField.title")+" "+i.expiryMonth+"/"+i.expiryYear},od("div",{className:"adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper"},od(Ou,{label:l.get("creditCard.expiryDateField.title"),className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],disabled:!0},od("div",{className:"adyen-checkout__input adyen-checkout__input--disabled adyen-checkout__card__exp-date__input--oneclick",dir:"ltr"},i.expiryMonth," / ",i.expiryYear)),r&&od(qf,{cvcPolicy:i.cvcPolicy,error:n.encryptedSecurityCode,focused:"encryptedSecurityCode"===i.focusedElement,filled:!!o.encryptedSecurityCode||!!n.encryptedSecurityCode,isValid:!!o.encryptedSecurityCode,label:l.get("creditCard.cvcField.title"),onFocusField:a,className:"adyen-checkout__field--50",classNameModifiers:["storedCard"],frontCVC:"amex"===t})))}function Yf(e){var t,r,a=su().i18n,n=e.amount,o=e.brand,i=e.onChange,l=e.type,s=e.installmentOptions[o]||e.installmentOptions.card,c=Wd((null==s?void 0:s.preselectedValue)||(null==s?void 0:s.values[0])),d=c[0],u=c[1],p=Wd("onetime"),m=p[0],h=p[1],f=null===(t=null==s?void 0:s.plans)||void 0===t?void 0:t.includes("revolving"),y=function(e){var t=e.target.value;u(Number(t))},b=function(e){var t,r,o;return"amount"===l?(t="installmentOption",r={count:e,values:{times:e,partialValue:(o=e,a.amount(n.value/o,n.currency))}}):(t="installmentOptionMonths",r={count:e,values:{times:e}}),{id:e,name:n.value?a.get(t,r):""+e}};return Zd((function(){var e,t=(null===(e=null==s?void 0:s.values)||void 0===e?void 0:e.includes(d))?d:null==s?void 0:s.values[0];u(t)}),[o]),Zd((function(){var e=Tc(Tc({value:d},f&&"revolving"===m&&{plan:m,value:1}),f&&"onetime"===m&&{value:1});i(s?e:{value:null})}),[d,s,m]),s?0===n.value?null:od("div",{className:"adyen-checkout__installments"},f?od(Au,{classNameModifiers:["revolving-plan"],label:""},od(Gu,{items:[{id:"onetime",name:"installments.oneTime"},{id:"installments",name:"installments.installments"},{id:"revolving",name:"installments.revolving"}],i18n:a,onChange:function(e){var t=e.currentTarget.getAttribute("value");h(t)},value:m}),od(Ou,{className:"installments"!==m?""+Of["revolving-plan-installments__disabled"]:""+Of["revolving-plan-installments"],classNameModifiers:["revolving-plan-installments"]},sp("select",{filterable:!1,items:s.values.map(b),selected:d,onChange:y,name:"installments"}))):od(Ou,{label:a.get("installments"),classNameModifiers:["installments"]},sp("select",{filterable:!1,items:s.values.map(b),selected:d,onChange:y,name:"installments",readonly:1===(null===(r=null==s?void 0:s.values)||void 0===r?void 0:r.length)}))):null}Yf.defaultProps={brand:"",amount:{},onChange:function(){}};var Wf=function(e,t){return zd({type:"card"===e?"nocard":e||"nocard",extension:"svg",loadingContext:t})(e)};function Jf(e){var t,r,a=e.brand,n=e.brandsConfiguration,o=void 0===n?{}:n,i=su().loadingContext,l="card"===a?"nocard":a,s=null!==(r=null===(t=o[a])||void 0===t?void 0:t.icon)&&void 0!==r?r:Wf(l,i);return od("img",{className:Of["card-input__icon"]+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:a,src:s})}var Zf=function(e){var t,r,a=e.brand,n=e.onClick,o=e.dataValue,i=e.notSelected,l=e.brandsConfiguration,s=void 0===l?{}:l,c=su().loadingContext,d="card"===a?"nocard":a,u=null!==(r=null===(t=s[a])||void 0===t?void 0:t.icon)&&void 0!==r?r:Wf(d,c);return od("img",{className:Of["card-input__icon"]+" "+(i?"adyen-checkout__card__cardNumber__brandIcon--not-selected":"")+" adyen-checkout__card__cardNumber__brandIcon",onError:function(e){e.target.style.cssText="display: none"},alt:a,src:u,onClick:n,"data-value":o})};function Qf(e){var t,r=su().i18n,a=e.error,n=void 0===a?"":a,o=e.isValid,i=void 0!==o&&o,l=e.onFocusField,s=void 0===l?function(){}:l,c=e.dualBrandingElements,d=e.dualBrandingChangeHandler,u=e.dualBrandingSelected;return od(Ou,{label:e.label,focused:e.focused,filled:e.filled,classNameModifiers:["cardNumber"],onFocusField:function(){return s("encryptedCardNumber")},errorMessage:n&&r.get(n),isValid:i,dualBrandingElements:c,dir:"ltr",name:"encryptedCardNumber"},od(Hf,{encryptedFieldType:"encryptedCardNumber",className:Ed((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0},t[Of["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=n,t["adyen-checkout__input--focus"]=e.focused,t["adyen-checkout__input--valid"]=i,t["adyen-checkout__card__cardNumber__input--noBrand"]=!e.showBrandIcon,t))},e.showBrandIcon&&!c&&od(Jf,{brandsConfiguration:e.brandsConfiguration,brand:e.brand})),c&&!n&&od("div",{className:Ed(["adyen-checkout__card__dual-branding__buttons",{"adyen-checkout__card__dual-branding__buttons--active":i}])},c.map((function(t){return od(Zf,{key:t.id,brand:t.id,brandsConfiguration:e.brandsConfiguration,onClick:d,dataValue:t.id,notSelected:""!==u&&u!==t.id})}))))}function $f(e){var t,r=e.label,a=e.focused,n=e.filled,o=e.onFocusField,i=e.className,l=void 0===i?"":i,s=e.error,c=void 0===s?"":s,d=e.isValid,u=void 0!==d&&d,p=e.hideDateForBrand,m=void 0!==p&&p,h=su().i18n,f=Ed(l,((t={})[Of["adyen-checkout__card__exp-date__input--hidden"]]=m,t));return od(Ou,{label:r,classNameModifiers:["expiryDate"],className:f,focused:a,filled:n,onFocusField:function(){return o("encryptedExpiryDate")},errorMessage:c&&h.get(c),isValid:u,dir:"ltr",name:"encryptedExpiryDate"},od(Hf,{encryptedFieldType:"encryptedExpiryDate",className:Ed("adyen-checkout__input","adyen-checkout__input--small","adyen-checkout__card__exp-date__input",[Of["adyen-checkout__input"]],{"adyen-checkout__input--error":c,"adyen-checkout__input--focus":a,"adyen-checkout__input--valid":u})}))}function Xf(e){var t,r=e.brand,a=e.brandsConfiguration,n=e.dualBrandingElements,o=e.dualBrandingChangeHandler,i=e.dualBrandingSelected,l=e.errors,s=e.focusedElement,c=e.hasCVC,d=e.cvcPolicy,u=e.hideDateForBrand,p=e.onFocusField,m=e.showBrandIcon,h=e.valid,f=su().i18n;return od("div",{className:"adyen-checkout__card__form"},od(Qf,{brand:r,brandsConfiguration:a,error:l.encryptedCardNumber,focused:"encryptedCardNumber"===s,isValid:!!h.encryptedCardNumber,label:f.get("creditCard.numberField.title"),onFocusField:p,filled:!!l.encryptedCardNumber||!!h.encryptedCardNumber,showBrandIcon:m,dualBrandingElements:n,dualBrandingChangeHandler:o,dualBrandingSelected:i}),od("div",{className:Ed("adyen-checkout__card__exp-cvc adyen-checkout__field-wrapper",(t={},t[Of["adyen-checkout__card__exp-cvc__exp-date__input--hidden"]]=u,t))},od($f,{error:l.encryptedExpiryDate||l.encryptedExpiryYear||l.encryptedExpiryMonth,focused:"encryptedExpiryDate"===s,isValid:!!h.encryptedExpiryMonth&&!!h.encryptedExpiryYear,filled:!!l.encryptedExpiryDate||!!h.encryptedExpiryYear,label:f.get("creditCard.expiryDateField.title"),onFocusField:p,className:"adyen-checkout__field--50",hideDateForBrand:u}),c&&od(qf,{error:l.encryptedSecurityCode,focused:"encryptedSecurityCode"===s,cvcPolicy:d,isValid:!!h.encryptedSecurityCode,filled:!!l.encryptedSecurityCode||!!h.encryptedSecurityCode,label:f.get("creditCard.cvcField.title"),onFocusField:p,className:"adyen-checkout__field--50",frontCVC:"amex"===r})))}function ey(e){var t,r=su().i18n,a=Xd((function(){var t;return(null===(t=e.value)||void 0===t?void 0:t.length)>6?r.get("creditCard.taxNumber.labelAlt"):r.get("creditCard.taxNumber.label")}),[e.value]);return od("div",{className:"adyen-checkout__card__kcp-authentication"},od(Ou,{label:a,filled:e.filled,classNameModifiers:["kcp-taxNumber"],errorMessage:e.error&&r.get("creditCard.taxNumber.invalid"),isValid:e.isValid,dir:"ltr",name:"kcpTaxNumberOrDOB"},sp("tel",{className:"adyen-checkout__card__kcp-taxNumber__input "+Of["adyen-checkout__input"],placeholder:r.get("creditCard.taxNumber.placeholder"),maxLength:10,minLength:6,autoComplete:!1,value:e.value,required:!0,onChange:e.onChange,onInput:e.onInput})),od(Ou,{label:r.get("creditCard.encryptedPassword.label"),focused:"encryptedPassword"===e.focusedElement,filled:e.filled,classNameModifiers:["50","koreanAuthentication-encryptedPassword"],onFocusField:function(){return e.onFocusField("encryptedPassword")},errorMessage:e.encryptedPasswordState.errors&&r.get("creditCard.encryptedPassword.invalid"),isValid:e.encryptedPasswordState.valid,dir:"ltr",name:"encryptedPassword"},od(Hf,{encryptedFieldType:"encryptedPassword",className:Ed((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[Of["adyen-checkout__input"]]=!0,t["adyen-checkout__input--error"]=e.encryptedPasswordState.errors,t["adyen-checkout__input--valid"]=e.encryptedPasswordState.valid,t["adyen-checkout__input--focus"]="encryptedPassword"===e.focusedElement,t))})))}function ty(e){var t=e.onChange,r=e.onInput,a=e.valid,n=void 0!==a&&a,o=e.error,i=void 0===o?null:o,l=e.data,s=void 0===l?"":l,c=su().i18n;return od(Ou,{label:""+c.get("boleto.socialSecurityNumber"),classNameModifiers:["socialSecurityNumber"],errorMessage:!!i,isValid:Boolean(n)},sp("text",{name:"socialSecurityNumber",autocorrect:"off",spellcheck:!1,value:s,maxLength:18,onInput:r,onChange:t}))}function ry(e){var t=e.storeDetails,r=void 0!==t&&t,a=zc(e,["storeDetails"]),n=su().i18n,o=Wd(r),i=o[0],l=o[1];return Zd((function(){a.onChange(i)}),[i]),od("div",{className:"adyen-checkout__store-details"},sp("boolean",{onChange:function(e){l(e.target.checked)},label:n.get("storeDetails"),value:i,name:"storeDetails"}))}function ay(e){return e.replace(/[^0-9]/g,"").trim()}function ny(e){if(void 0===e&&(e=""),"string"!=typeof e)return"";var t=ay(e);return t.length>11?function(e){return e.replace(/^(\d{2})(\d{3})(\d{3})?(\d{4})?(\d{1,2})?$/g,(function(e,t,r,a,n,o){return void 0===n&&(n=""),void 0===o&&(o=""),t+"."+r+"."+a+"/"+n+(o.length?"-"+o:"")}))}(t):function(e){return e.replace(/\W/gi,"").replace(/(\d{3})(?!$)/g,"$1.").replace(/(.{11}).(\d{1,2})$/g,"$1-$2")}(t)}function oy(e){return/(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/.test(e)}var iy={socialSecurityNumber:ny},ly={socialSecurityNumber:[{modes:["blur"],validate:oy}],taxNumber:[{modes:["blur"],validate:function(e){return 6===(null==e?void 0:e.length)||10===(null==e?void 0:e.length)}}],holderName:[{modes:["blur"],validate:function(e){return(null==e?void 0:e.trim().length)>0}}],default:[{modes:["blur"],validate:function(e){return!!e&&"string"==typeof e&&e.trim().length>0}}]};function sy(e,t,r){var a=t.sfp,n=r.dualBrandSelectElements,o=r.setDualBrandSelectElements,i=r.setSelectedBrandValue,l=r.issuingCountryCode,s=r.setIssuingCountryCode;return{processBinLookup:function(t,r){var n,l=(null==t?void 0:t.issuingCountryCode)?t.issuingCountryCode.toLowerCase():null;if(s(l),t&&Object.keys(t).length){if(null===(n=t.supportedBrands)||void 0===n?void 0:n.length){var c=t.supportedBrands;if(c.length>1){var d=(p=(u=c)[0],m=u[1],{dualBrandSelectElements:[{id:p.brand,brandObject:p},{id:m.brand,brandObject:m}],selectedBrandValue:"",leadBrand:p});o(d.dualBrandSelectElements),i(d.selectedBrandValue),a.current.processBinLookupResponse({issuingCountryCode:t.issuingCountryCode,supportedBrands:[d.leadBrand]})}else o([]),i(""),i(c[0].brand),a.current.processBinLookupResponse({issuingCountryCode:t.issuingCountryCode,supportedBrands:c})}var u,p,m}else{o([]),i("");var h=r&&"card"!==e.type?e.type:null;a.current.processBinLookupResponse(t,{brand:h,cvcPolicy:e.cvcPolicy})}},handleDualBrandSelection:function(e){var t=e;if(e instanceof Event){var r=e.target;t=r.getAttribute("data-value")||r.getAttribute("alt")}i(t);var o=n.reduce((function(e,r){return r.brandObject.brand===t&&e.push(r.brandObject),e}),[]);a.current.processBinLookupResponse({issuingCountryCode:l,supportedBrands:o})}}}function cy(e){var t=e.onChange,r=e.onInput,a=e.placeholder,n=e.value,o=e.required,i=e.error,l=void 0!==i&&i,s=e.isValid,c=su().i18n;return od(Ou,{label:c.get("creditCard.holderName"),className:"adyen-checkout__card__holderName",errorMessage:l&&c.get("creditCard.holderName.invalid"),isValid:!!s,name:"holderName"},sp("text",{className:"adyen-checkout__card__holderName__input "+Of["adyen-checkout__input"],placeholder:a||c.get("creditCard.holderName.placeholder"),value:n,required:o,onChange:t,onInput:r}))}function dy(e){var t,r,a=this,n=$d(null),o=$d(null),i=Wd("ready"),l=i[0],s=i[1],c=Wd({}),d=c[0],u=c[1],p=Wd(Tc({},e.holderNameRequired&&{holderName:!1})),m=p[0],h=p[1],f=Wd(Tc({},e.hasHolderName&&{holderName:null!==(t=e.data.holderName)&&void 0!==t?t:""})),y=f[0],b=f[1],v=Wd(""),g=v[0],k=v[1],C=Wd(!1),_=C[0],N=C[1],w=Wd(!1),P=w[0],F=w[1],D=Wd(bh),A=D[0],S=D[1],x=Wd(null),B=x[0],T=x[1],z=Wd([]),I=z[0],j=z[1],M=Wd(""),O=M[0],E=M[1],R=Wd(!1),L=R[0],V=R[1],U=Wd(e.billingAddressRequired?e.data.billingAddress:null),K=U[0],H=U[1],q=Wd(!1),G=q[0],Y=q[1],W=Wd(""),J=W[0],Z=W[1],Q=Wd({value:null}),$=Q[0],X=Q[1],ee=bp({schema:[],defaultData:e.data,formatters:iy,rules:ly}),te=ee.handleChangeFor,re=ee.triggerValidation,ae=ee.data,ne=ee.valid,oe=ee.errors,ie=ee.setSchema,le=ee.setData,se=ee.setValid,ce=ee.setErrors,de=!!Object.keys(e.installmentOptions).length,ue=null===(r=e.showInstallmentAmounts)||void 0===r||r,pe="kr"===(null!=B?B:e.countryCode),me=e.configuration.koreanAuthenticationRequired&&pe,he=G&&"auto"===e.configuration.socialSecurityNumberMode||"show"===e.configuration.socialSecurityNumberMode,fe=function(e){V(e)},ye=function(e){X(e)},be=function(e){le("billingAddress",e.data),se("billingAddress",e.isValid),ce("billingAddress",e.errors)},ve=Xd((function(){return sy(e,{sfp:n},{dualBrandSelectElements:I,setDualBrandSelectElements:j,setSelectedBrandValue:E,issuingCountryCode:B,setIssuingCountryCode:T})}),[I,B]);this.showValidation=function(){n.current.showValidation(),re(),(null==o?void 0:o.current)&&o.current.showValidation()},this.processBinLookupResponse=function(e,t){ve.processBinLookup(e,t)},this.setStatus=s,Zd((function(){return a.setFocusOn=n.current.setFocusOn,a.updateStyles=n.current.updateStyles,a.handleUnsupportedCard=n.current.handleUnsupportedCard,function(){n.current.destroy()}}),[]),Zd((function(){var t=Mc(Mc(Mc(Mc([],e.hasHolderName?["holderName"]:[]),he?["socialSecurityNumber"]:[]),me?["taxNumber"]:[]),e.billingAddressRequired?["billingAddress"]:[]);ie(t)}),[e.hasHolderName,he,me]),Zd((function(){var t;b(Tc(Tc({},y),{holderName:null!==(t=ae.holderName)&&void 0!==t?t:"",taxNumber:ae.taxNumber})),Z(ae.socialSecurityNumber),e.billingAddressRequired&&H(Tc({},ae.billingAddress)),h(Tc(Tc({},m),{holderName:!e.holderNameRequired||ne.holderName,socialSecurityNumber:!!ne.socialSecurityNumber&&ne.socialSecurityNumber,taxNumber:!!ne.taxNumber&&ne.taxNumber,billingAddress:!!ne.billingAddress&&ne.billingAddress})),u(Tc(Tc({},d),{holderName:e.holderNameRequired&&oe.holderName?oe.holderName:null,socialSecurityNumber:he&&oe.socialSecurityNumber?oe.socialSecurityNumber:null,taxNumber:me&&oe.taxNumber?oe.taxNumber:null,billingAddress:e.billingAddressRequired&&oe.billingAddress?oe.billingAddress:null}))}),[ae,ne,oe]),Zd((function(){var t=m.holderName,r=_,a=!e.billingAddressRequired||m.billingAddress,o=!me||!!m.taxNumber&&!!m.encryptedPassword,i=!he||!!m.socialSecurityNumber,l=r&&t&&a&&o&&i,s=n.current.mapErrorsToValidationRuleResult();e.onChange({data:y,valid:m,errors:Tc(Tc({},d),s),isValid:l,billingAddress:K,selectedBrandValue:O,storePaymentMethod:L,socialSecurityNumber:J,installments:$})}),[y,m,d,O,L,$]);var ge=od(cy,{required:e.holderNameRequired,placeholder:e.placeholders.holderName,value:ae.holderName,error:!!oe.holderName&&e.holderNameRequired,isValid:!!ne.holderName,onChange:te("holderName","blur"),onInput:te("holderName","input")}),ke=function(t){return od(Yf,{amount:e.amount,brand:t,installmentOptions:e.installmentOptions,onChange:ye,type:ue?"amount":"months"})};return od(jf,Tc({ref:n},e,{styles:Tc(Tc({},Mf),e.styles),koreanAuthenticationRequired:e.configuration.koreanAuthenticationRequired,hasKoreanFields:!(!e.configuration.koreanAuthenticationRequired||"kr"!==e.countryCode),onChange:function(t){if(t.autoCompleteName){if(!e.hasHolderName)return;var r=(a="blur",ly["holderName"].reduce((function(e,t){return e.length||t.modes.includes(a)&&e.push(t.validate),e}),[])[0])(t.autoCompleteName)?t.autoCompleteName:null;r&&(le("holderName",r),se("holderName",!0),ce("holderName",null))}else{var a;b(Tc(Tc({},y),t.data)),u(Tc(Tc({},d),t.errors)),h(Tc(Tc({},m),t.valid)),N(t.isSfpValid),S(t.cvcPolicy),Y(t.showSocialSecurityNumber),F(t.hideDateForBrand)}},onBrand:e.onBrand,onFocus:function(t){k(t.currentFocusObject),!0===t.focus?e.onFocus(t):e.onBlur(t)},type:e.brand,render:function(t,r){var n,i=t.setRootNode,s=t.setFocusOn;return od("div",{ref:i,className:"adyen-checkout__card-input "+Of["card-input__wrapper"]+" adyen-checkout__card-input--"+(null!==(n=e.fundingSource)&&void 0!==n?n:"credit")},e.storedPaymentMethodId?od(Uf,{status:r.status},od(Gf,Tc({},e,{errors:r.errors,brand:r.brand,hasCVC:e.hasCVC,cvcPolicy:A,onFocusField:s,focusedElement:g,status:r.status,valid:r.valid})),de&&ke(r.brand)):od(Uf,{status:r.status},e.hasHolderName&&e.positionHolderNameOnTop&&ge,od(Xf,Tc({},e,{brand:r.brand,brandsConfiguration:a.props.brandsConfiguration,focusedElement:g,onFocusField:s,hasCVC:e.hasCVC,cvcPolicy:A,hideDateForBrand:P,errors:r.errors,valid:r.valid,dualBrandingElements:I.length>0&&I,dualBrandingChangeHandler:ve.handleDualBrandSelection,dualBrandingSelected:O})),e.hasHolderName&&!e.positionHolderNameOnTop&&ge,me&&od(ey,{onFocusField:s,focusedElement:g,encryptedPasswordState:{data:r.encryptedPassword,valid:!!r.valid&&r.valid.encryptedPassword,errors:!!r.errors&&r.errors.encryptedPassword},value:y.taxNumber,error:!!d.taxNumber,isValid:!!m.taxNumber,onChange:te("taxNumber","blur"),onInput:te("taxNumber","input")}),he&&od("div",{className:"adyen-checkout__card__socialSecurityNumber"},od(ty,{onChange:te("socialSecurityNumber","blur"),onInput:te("socialSecurityNumber","input"),error:null==d?void 0:d.socialSecurityNumber,valid:null==m?void 0:m.socialSecurityNumber,data:J})),e.enableStoreDetails&&od(ry,{onChange:fe}),de&&ke(r.brand),e.billingAddressRequired&&od(Cm,{label:"billingAddress",data:K,onChange:be,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,ref:o})),e.showPayButton&&e.payButton({status:l,icon:zd({loadingContext:e.loadingContext,imageFolder:"components/"})("lock")}))}}))}dy.defaultProps={details:[],type:"card",hasHolderName:!1,holderNameRequired:!1,enableStoreDetails:!1,hideCVC:!1,hasCVC:!0,hasStoreDetails:!1,storedDetails:null,showBrandIcon:!0,positionHolderNameOnTop:!1,billingAddressRequired:!1,billingAddressRequiredFields:["street","houseNumberOrName","postalCode","city","stateOrProvince","country"],installmentOptions:{},configuration:{koreanAuthenticationRequired:!1,socialSecurityNumberMode:"auto"},onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},data:{billingAddress:{}},styles:{},placeholders:{}};var uy=function(e){return function(t){return t.brand===e}},py=function(e){return e.brand.includes("plcc")||e.brand.includes("cbcc")},my=function(e){var t=null;return function(r){if(!1!==e.props.doBinLookup){if(r.encryptedBin&&e.props.clientKey)t=r.uuid,fm({loadingContext:e.props.loadingContext,path:"v2/bin/binLookup?token="+e.props.clientKey},{supportedBrands:e.props.brands||fh,encryptedBin:r.encryptedBin,requestId:r.uuid}).then((function(a){var n;if((null==a?void 0:a.requestId)===t)if(null===(n=a.brands)||void 0===n?void 0:n.length){var o=(2===a.brands.length?function(e,t){var r=e.map((function(e){return Tc({},e)})),a=r.some(uy("bcmc")),n=r.some(uy("maestro")),o=r.some(uy("visa")),i=r.some(uy("cartebancaire")),l=r.some(py);return"bcmc"===t&&a&&"bcmc"!==r[0].brand&&r.reverse(),"bcmc"===t&&a&&n&&(r[1].cvcPolicy=gh),"card"===t&&o&&i&&"visa"!==r[0].brand&&r.reverse(),"card"===t&&l&&(r[0].brand.includes("plcc")||r[0].brand.includes("cbcc")||r.reverse()),r}(a.brands,e.props.type):a.brands).reduce((function(e,t){return e.detectedBrands.push(t.brand),!0===t.supported?(e.supportedBrands.push(t),e):e}),{supportedBrands:[],detectedBrands:[]});if(o.supportedBrands.length)return e.processBinLookupResponse(Tc({issuingCountryCode:a.issuingCountryCode,supportedBrands:o.supportedBrands},a.showSocialSecurityNumber?{showSocialSecurityNumber:a.showSocialSecurityNumber}:{})),void e.onBinLookup({type:r.type,detectedBrands:o.detectedBrands,supportedBrands:o.supportedBrands.map((function(e){return e.brand})),supportedBrandsRaw:o.supportedBrands,brands:e.props.brands||fh});if(o.detectedBrands.length){var i={type:"card",fieldType:"encryptedCardNumber",error:of(zu),detectedBrands:o.detectedBrands};return e.handleUnsupportedCard(i),void e.onBinLookup({type:r.type,detectedBrands:o.detectedBrands,supportedBrands:null,brands:e.props.brands||fh})}}else e.onBinLookup({type:r.type,detectedBrands:null,supportedBrands:null,brands:e.props.brands||fh}),e.processBinLookupResponse({},!0);else(null==a?void 0:a.requestId)||e.props.onError(a||{errorType:"binLookup",message:"unknownError"})}));else if(t){e.processBinLookupResponse(null,!0),t=null;e.handleUnsupportedCard({type:"card",fieldType:"encryptedCardNumber",error:""}),e.onBinLookup({isReset:!0})}e.props.onBinValue&&e.props.onBinValue(r)}else e.props.onBinValue&&e.props.onBinValue(r)}},hy=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBrand=function(e){t.eventEmitter.emit("brand",Tc(Tc({},e),{brand:"card"===e.brand?null:e.brand})),t.props.onBrand&&t.props.onBrand(e)},t.onBinValue=my(t),t}return Bc(t,e),t.prototype.formatProps=function(e){var t,r,a,n;return Tc(Tc(Tc(Tc({},e),{holderNameRequired:!!e.hasHolderName&&e.holderNameRequired,hasCVC:!(e.brand&&"bcmc"===e.brand||e.hideCVC),billingAddressRequired:!e.storedPaymentMethodId&&e.billingAddressRequired}),e.brands&&!e.groupTypes&&{groupTypes:e.brands}),{type:"scheme"===e.type?"card":e.type,countryCode:e.countryCode?e.countryCode.toLowerCase():null,configuration:Tc(Tc({},e.configuration),{socialSecurityNumberMode:null!==(r=null===(t=e.configuration)||void 0===t?void 0:t.socialSecurityNumberMode)&&void 0!==r?r:"auto"}),brandsConfiguration:e.brandsConfiguration||(null===(a=e.configuration)||void 0===a?void 0:a.brandsConfiguration)||{},icon:e.icon||(null===(n=e.configuration)||void 0===n?void 0:n.icon)})},t.prototype.formatData=function(){var e=this.state.selectedBrandValue||this.props.brand,r=this.props.enableStoreDetails&&void 0!==this.state.storePaymentMethod;return Tc(Tc(Tc(Tc(Tc({paymentMethod:Tc(Tc(Tc(Tc({type:t.type},this.state.data),this.props.storedPaymentMethodId&&{storedPaymentMethodId:this.props.storedPaymentMethodId}),e&&{brand:e}),this.props.fundingSource&&{fundingSource:this.props.fundingSource})},this.state.billingAddress&&{billingAddress:this.state.billingAddress}),this.state.socialSecurityNumber&&{socialSecurityNumber:this.state.socialSecurityNumber}),r&&{storePaymentMethod:Boolean(this.state.storePaymentMethod)}),this.state.installments&&this.state.installments.value&&{installments:this.state.installments}),{browserInfo:this.browserInfo})},t.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},t.prototype.processBinLookupResponse=function(e,t){var r;return void 0===t&&(t=!1),(null===(r=this.componentRef)||void 0===r?void 0:r.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e,t),this},t.prototype.handleUnsupportedCard=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.handleUnsupportedCard)&&this.componentRef.handleUnsupportedCard(e),this},t.prototype.onBinLookup=function(e){if(!e.isReset){var t=xh("supportedBrandsRaw").from(e);this.props.onBinLookup(t)}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zd({loadingContext:this.props.loadingContext})(this.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"brands",{get:function(){var e=this.props,t=e.brands,r=e.loadingContext,a=e.brandsConfiguration;return t?t.map((function(e){var t,n;return{icon:null!==(n=null===(t=a[e])||void 0===t?void 0:t.icon)&&void 0!==n?n:zd({loadingContext:r})(e),name:e}})):[]},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"brand",{get:function(){return this.props.brand||this.props.type},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.storedPaymentMethodId?"\u2022\u2022\u2022\u2022 "+this.props.lastFour:this.props.name||t.type},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"accessibleName",{get:function(){return(this.props.name||t.type)+(this.props.storedPaymentMethodId?" "+this.props.i18n.get("creditCard.storedCard.description.ariaLabel").replace("%@",this.props.lastFour):"")},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Tm()},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(dy,Tc({ref:function(t){e.componentRef=t}},this.props,this.state,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton,onBrand:this.onBrand,onBinValue:this.onBinValue,brand:this.brand})))},t.type="scheme",t.defaultProps={onBinLookup:function(){}},t}(pu),fy=function(e){function t(t){var r=e.call(this,t)||this;return r.onBrand=function(e){r.props.onBrand&&r.props.onBrand(e)},r}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{brands:["bcmc","maestro","visa"],type:"bcmc",cvcPolicy:gh})},t}(hy);function yy(e){var t=e.description,r=void 0===t?"":t,a=e.name,n=void 0===a?"":a,o=e.logoUrl,i=void 0===o?"":o,l=e.url,s=void 0===l?"":l,c=e.backgroundUrl,d=void 0===c?"":c;return od("div",{className:"adyen-checkout__campaign-container"},od(tp,{className:"adyen-checkout__campaign-background-image",style:{backgroundImage:"linear-gradient(0, #000, #0003), url("+d+")"},backgroundUrl:d}),od("div",{className:"adyen-checkout__campaign-content"},i&&od("img",{src:i,className:"adyen-checkout__campaign-logo",alt:n}),n&&od("div",{className:"adyen-checkout__campaign-title"},n),r&&od("div",{className:"adyen-checkout__campaign-description"},r,s&&" \u203a")))}function by(e){var t=e.url;return od("div",{className:"adyen-checkout__campaign"},!t&&od(yy,Tc({},e)),t&&od("a",{href:t,className:"adyen-checkout__campaign-link",target:"_blank",rel:"noopener noreferrer"},od(yy,Tc({},e))))}var vy=function(e){var t=e.options,r=void 0===t?[]:t,a=e.name,n=e.onChange;return od("div",{className:"adyen-checkout__button-group"},r.map((function(e,t){var r=e.label,o=e.selected,i=e.value,l=e.disabled;return od("label",{key:""+a+t,className:Ed({"adyen-checkout__button":!0,"adyen-checkout__button--selected":o,"adyen-checkout__button--disabled":l})},od("input",{type:"radio",className:"adyen-checkout__button-group__input",value:i,checked:o,onChange:n,disabled:l}),od("span",{className:"adyen-checkout__button-text"},r))})))};function gy(e){var t=e.amounts,r=e.onCancel,a=e.onDonate,n=e.showCancelButton,o=void 0===n||n,i=su(),l=i.i18n,s=i.loadingContext,c=t.currency,d=Wd("ready"),u=d[0],p=d[1],m=Wd(!1),h=m[0],f=m[1],y=Wd({currency:c,value:null}),b=y[0],v=y[1];this.setStatus=function(e){p(e)};var g=function(e,t){return l.amount(e,t,{minimumFractionDigits:0,maximumFractionDigits:0})};return Zd((function(){e.onChange({data:{amount:b},isValid:h})}),[b,h]),"error"===u?od("div",{className:"adyen-checkout__adyen-giving"},od(tp,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--error",src:zd({loadingContext:s,imageFolder:"components/"})("error"),alt:l.get("error.message.unknown")}),od("div",{className:"adyen-checkout__status__text"},l.get("error.message.unknown"))):"success"===u?od("div",{className:"adyen-checkout__adyen-giving"},od(tp,{className:"adyen-checkout__status__icon adyen-checkout__status__icon--success",src:zd({loadingContext:s,imageFolder:"components/"})("heart"),alt:l.get("thanksForYourSupport")}),od("div",{className:"adyen-checkout__status__text"},l.get("thanksForYourSupport"))):od("div",{className:"adyen-checkout__adyen-giving"},od(by,Tc({},e)),od("div",{className:"adyen-checkout__adyen-giving-actions"},od("div",{className:"adyen-checkout__amounts"},od(vy,{options:t.values.map((function(e){return{value:e,label:g(e,c),disabled:"loading"===u,selected:e===b.value}})),name:"amount",onChange:function(e){var t=e.target,r=parseInt(t.value,10);f(!0),v((function(e){return Tc(Tc({},e),{value:r})}))}})),od(cu,{classNameModifiers:["donate"],onClick:function(){p("loading"),a({data:{amount:b}})},label:l.get("donateButton"),disabled:!b.value,status:u}),o&&od(cu,{classNameModifiers:["ghost","decline"],onClick:function(){p("loading"),r({data:{amount:b},isValid:h})},disabled:"loading"===u,label:l.get("notNowButton")+" \u203a"})))}gy.defaultProps={onCancel:function(){},onChange:function(){},onDonate:function(){},amounts:{},showCancelButton:!0};var ky=function(e){function t(t){var r=e.call(this,t)||this;return r.handleRef=function(e){r.componentRef=e},r.donate=r.donate.bind(r),r}return Bc(t,e),Object.defineProperty(t.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){return this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.setState=function(e){this.state=Tc(Tc({},this.state),e)},t.prototype.donate=function(){var e=this.data,t=this.isValid;this.props.onDonate({data:e,isValid:t},this)},t.prototype.render=function(){return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(gy,Tc({},this.props,{ref:this.handleRef,onChange:this.setState,onDonate:this.donate})))},t.type="donation",t.defaultProps={onCancel:function(){},onDonate:function(){}},t}(pu),Cy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.componentDidMount=function(){var e=this;new Promise((function(t,r){return e.props.beforeRedirect(t,r,e.props.url)})).then((function(){e.postForm?e.postForm.submit():window.location.assign(e.props.url)})).catch((function(){}))},t.prototype.render=function(e){var t=this,r=e.url,a=e.method,n=e.data,o=void 0===n?{}:n;return"POST"===a?od("form",{method:"post",action:r,style:{display:"none"},ref:function(e){t.postForm=e}},Object.keys(o).map((function(e){return od("input",{type:"hidden",name:e,key:e,value:o[e]})}))):null},t.defaultProps={beforeRedirect:function(e){return e()},method:"GET",data:{}},t}(sd);function _y(e){var t=e.payButton,r=e.onSubmit,a=e.amount,n=void 0===a?null:a,o=e.name,i=zc(e,["payButton","onSubmit","amount","name"]),l=su().i18n,s=Wd("ready"),c=s[0],d=s[1];this.setStatus=function(e){d(e)};return od(ld,null,t(Tc(Tc({},i),{status:c,classNameModifiers:["standalone"],label:n&&{}.hasOwnProperty.call(n,"value")&&0===n.value?l.get("preauthorizeWith")+" "+o:l.get("continueTo")+" "+o,onClick:r})))}var Ny=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){return Tc(Tc({},e),{showButton:!!e.showPayButton})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return zd({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.url&&this.props.method?od(Cy,Tc({},this.props)):this.props.showButton?od(Fm,Tc({},this.props,{loadingContext:this.props.loadingContext}),od(_y,Tc({},this.props,{onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},t.type="redirect",t.defaultProps={type:t.type,showPayButton:!0},t}(pu),wy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){var t;return Tc(Tc({},e),{showPayButton:null!==(t=e.showButton)&&void 0!==t?t:e.showPayButton})},t.prototype.formatData=function(){return{paymentMethod:{type:t.type}}},Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name||this.constructor.type},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(_y,Tc({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}}))):null},t.type="giropay",t}(Ny),Py=2,Fy=0,Dy="adyen",Ay="https://pay.google.com/gp/p/js/pay.js";function Sy(e){var t=e.amount,r=e.countryCode,a=void 0===r?"US":r,n=e.totalPriceStatus,o=void 0===n?"FINAL":n,i=zc(e,["amount","countryCode","totalPriceStatus"]),l=String($c(t.value,t.currency));return Tc({countryCode:a,currencyCode:t.currency,totalPrice:l,totalPriceStatus:o},i.transactionInfo)}function xy(e){var t=e.configuration,r=zc(e,["configuration"]);return{apiVersion:Py,apiVersionMinor:Fy,transactionInfo:Sy(r),merchantInfo:Tc({merchantId:t.merchantId,merchantName:t.merchantName},t.merchantOrigin?{merchantOrigin:t.merchantOrigin}:{}),allowedPaymentMethods:[{type:"CARD",tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{gateway:Dy,gatewayMerchantId:t.gatewayMerchantId}},parameters:{allowedAuthMethods:r.allowedAuthMethods,allowedCardNetworks:r.allowedCardNetworks,allowPrepaidCards:r.allowPrepaidCards,allowCreditCards:r.allowCreditCards,billingAddressRequired:r.billingAddressRequired,billingAddressParameters:r.billingAddressParameters}}],emailRequired:r.emailRequired,shippingAddressRequired:r.shippingAddressRequired,shippingAddressParameters:r.shippingAddressParameters,shippingOptionRequired:r.shippingOptionRequired,shippingOptionParameters:r.shippingOptionParameters,callbackIntents:r.callbackIntents}}var By=["en","ar","bg","ca","cs","da","de","el","es","et","fi","fr","hr","id","it","ja","ko","ms","nl","no","pl","pt","ru","sk","sl","sr","sv","th","tr","uk","zh"];var Ty=function(){function e(e){var t=function(e){switch(void 0===e&&(e="TEST"),e.toLowerCase()){case"production":case"live":return"PRODUCTION";default:return"TEST"}}(e.environment);this.paymentsClient=this.getGooglePaymentsClient({environment:t,paymentDataCallbacks:e.paymentDataCallbacks})}return e.prototype.getGooglePaymentsClient=function(e){var t;return Ic(this,void 0,void 0,(function(){return jc(this,(function(r){switch(r.label){case 0:return(null===(t=window.google)||void 0===t?void 0:t.payments)?[3,2]:[4,new Hm(Ay).load()];case 1:r.sent(),r.label=2;case 2:return[2,new google.payments.api.PaymentsClient(e)]}}))}))},e.prototype.isReadyToPay=function(e){return this.paymentsClient?this.paymentsClient.then((function(t){return t.isReadyToPay(function(e){var t=e.allowedAuthMethods,r=e.allowedCardNetworks,a=e.existingPaymentMethodRequired;return{apiVersion:Py,apiVersionMinor:Fy,allowedPaymentMethods:[{type:"CARD",parameters:{allowedAuthMethods:t,allowedCardNetworks:r},tokenizationSpecification:{type:"PAYMENT_GATEWAY",parameters:{}}}],existingPaymentMethodRequired:void 0!==a&&a}}(e))})):Promise.reject(new Error("Google Pay is not available"))},e.prototype.prefetchPaymentData=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=xy(e);this.paymentsClient.then((function(e){return e.prefetchPaymentData(t)}))},e.prototype.initiatePayment=function(e){if(!this.paymentsClient)throw new Error("Google Pay is not available");var t=xy(e);return this.paymentsClient.then((function(e){return e.loadPaymentData(t)}))},e}(),zy=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.clicked=!1,t.handleClick=function(e){e.preventDefault(),e.stopPropagation(),t.clicked||(t.props.onClick(e),t.clicked=!0,setTimeout((function(){t.clicked=!1}),300))},t}return Bc(t,e),t.prototype.componentDidMount=function(){var e=this,t=this.props,r=t.buttonColor,a=t.buttonType,n=t.buttonLocale,o=t.buttonSizeMode;t.paymentsClient.then((function(t){return t.createButton({onClick:e.handleClick,buttonType:a,buttonColor:r,buttonLocale:n,buttonSizeMode:o})})).then((function(t){e.paywithgoogleWrapper.appendChild(t)}))},t.prototype.render=function(){var e=this;return od("span",{className:"adyen-checkout__paywithgoogle",ref:function(t){e.paywithgoogleWrapper=t}})},t.defaultProps={buttonColor:"default",buttonType:"long",buttonSizeMode:"static"},t}(sd),Iy={environment:"TEST",existingPaymentMethodRequired:!1,buttonColor:"default",buttonType:"long",buttonSizeMode:void 0,showPayButton:!0,configuration:{gatewayMerchantId:"",merchantId:"",merchantName:""},amount:{value:0,currency:"USD"},countryCode:"US",totalPriceStatus:"FINAL",onError:function(){},onAuthorized:function(e){return e},onSubmit:function(){},onClick:function(e){return e()},allowedAuthMethods:["PAN_ONLY","CRYPTOGRAM_3DS"],allowedCardNetworks:["AMEX","DISCOVER","JCB","MASTERCARD","VISA"],allowCreditCards:!0,allowPrepaidCards:!0,billingAddressRequired:!1,billingAddressParameters:void 0,emailRequired:!1,shippingAddressRequired:!1,shippingAddressParameters:void 0,shippingOptionRequired:!1,shippingOptionParameters:void 0,paymentMethods:[]},jy=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.googlePay=new Ty(t.props),t.loadPayment=function(){var e=t.props.onAuthorized,r=void 0===e?function(){}:e;return new Promise((function(e,r){return t.props.onClick(e,r)})).then((function(){return t.googlePay.initiatePayment(t.props)})).then((function(e){return t.setState({googlePayToken:e.paymentMethodData.tokenizationData.token,googlePayCardNetwork:e.paymentMethodData.info.cardNetwork}),r(e)})).catch((function(e){t.props.onError&&t.props.onError(e)}))},t.submit=function(){return t.loadPayment().then((function(){t.props.onSubmit&&t.isValid&&t.props.onSubmit({data:t.data,isValid:t.isValid},t.elementRef)}))},t.startPayment=function(){return t.loadPayment()},t.isAvailable=function(){return t.isReadyToPay().then((function(e){if(!e.result)throw new Error("Google Pay is not available");if(!1===e.paymentMethodPresent)throw new Error("Google Pay - No paymentMethodPresent");return!0})).catch((function(){return!1}))},t.isReadyToPay=function(){return t.googlePay.isReadyToPay(t.props)},t.prefetch=function(){return t.googlePay.prefetchPaymentData(t.props)},t}return Bc(t,e),t.prototype.formatProps=function(e){var t,r,a,n,o,i,l=(null===(t=e.brands)||void 0===t?void 0:t.length)?(o=e.brands,i={mc:"MASTERCARD",amex:"AMEX",visa:"VISA",interac:"INTERAC",discover:"DISCOVER"},o.reduce((function(e,t){return i[t]&&!e.includes(i[t])&&e.push(i[t]),e}),[])):e.allowedCardNetworks,s=null!==(r=e.buttonSizeMode)&&void 0!==r?r:e.isDropin?"fill":"static",c=function(e){void 0===e&&(e="");var t=e.toLowerCase().substring(0,2);return By.includes(t)?t:null}(null!==(a=e.buttonLocale)&&void 0!==a?a:null===(n=e.i18n)||void 0===n?void 0:n.locale);return Tc(Tc({},e),{showButton:!0===e.showPayButton,configuration:e.configuration,allowedCardNetworks:l,buttonSizeMode:s,buttonLocale:c})},t.prototype.formatData=function(){var e;return{paymentMethod:Tc({type:null!==(e=this.props.type)&&void 0!==e?e:t.type},this.state),browserInfo:this.browserInfo}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.googlePayToken},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Tm()},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){var e;return null!==(e=this.props.icon)&&void 0!==e?e:zd({loadingContext:this.props.loadingContext})("googlepay")},enumerable:!1,configurable:!0}),t.prototype.render=function(){return this.props.showPayButton?od(zy,{buttonColor:this.props.buttonColor,buttonType:this.props.buttonType,buttonSizeMode:this.props.buttonSizeMode,buttonLocale:this.props.buttonLocale,paymentsClient:this.googlePay.paymentsClient,onClick:this.submit}):null},t.type="paywithgoogle",t.defaultProps=Iy,t}(pu),My=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="entercash",t}(oh),Oy={telephoneNumber:[{validate:function(e){return!!e&&e.length<=11},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["input","blur"]},{validate:function(e){return!!e&&dp.test(e)&&(10===e.length||11===e.length)},errorMessage:"voucher.econtext.telephoneNumber.invalid",modes:["blur"]}]};function Ey(e){var t=$d(null),r=su().i18n,a=Wd("ready"),n=a[0],o=a[1];return this.setStatus=o,this.showValidation=function(){t.current&&t.current.showValidation()},od("div",{className:"adyen-checkout__econtext-input__field"},od(xp,{data:e.data,requiredFields:["firstName","lastName","telephoneNumber","shopperEmail"],onChange:e.onChange,namePrefix:"econtext",ref:t,validationRules:Oy}),e.showPayButton&&e.payButton({status:n,label:r.get("confirmPurchase")}))}function Ry(e){var t,r,a=(t=e,(r=document.createElement("textArea")).readOnly=!0,r.value=t,document.body.appendChild(r),r);if(window.navigator.userAgent.match(/ipad|iphone/i)){var n=document.createRange();n.selectNodeContents(a);var o=window.getSelection();o.removeAllRanges(),o.addRange(n),a.setSelectionRange(0,999999)}else a.select();document.execCommand("copy"),document.body.removeChild(a)}function Ly(e){var t=e.voucherDetails,r=void 0===t?[]:t,a=e.className,n=void 0===a?"":a,o=zc(e,["voucherDetails","className"]),i=su(),l=i.i18n,s=i.loadingContext;return od("div",{className:Ed("adyen-checkout__voucher-result","adyen-checkout__voucher-result--"+o.paymentMethodType,n)},od("div",{className:"adyen-checkout__voucher-result__top"},od("div",{className:"adyen-checkout__voucher-result__image"},!!o.imageUrl&&od("span",{className:"adyen-checkout__voucher-result__image__wrapper"},od("img",{alt:o.paymentMethodType,className:"adyen-checkout__voucher-result__image__brand",src:o.imageUrl})),!!o.issuerImageUrl&&od("span",{className:"adyen-checkout__voucher-result__image__wrapper"},od("img",{alt:o.paymentMethodType,className:"adyen-checkout__voucher-result__image__issuer",src:o.issuerImageUrl}))),od("div",{className:"adyen-checkout__voucher-result__introduction"},o.introduction," ",o.instructionsUrl&&od("a",{className:"adyen-checkout__link adyen-checkout__link--voucher-result-instructions",href:o.instructionsUrl,target:"_blank",rel:"noopener noreferrer"},l.get("voucher.readInstructions")," \u203a")),o.amount&&od("div",{className:"adyen-checkout__voucher-result__amount"},o.amount,o.surcharge&&od("span",{className:"adyen-checkout__voucher-result__surcharge"},"(",l.get("voucher.surcharge").replace("%@",o.surcharge),")"))),o.reference&&od("div",{className:"adyen-checkout__voucher-result__separator"},od("div",{className:"adyen-checkout__voucher-result__separator__inner"}),od("div",{className:"adyen-checkout__voucher-result__code__label"},od("span",{className:"adyen-checkout__voucher-result__code__label__text"},l.get("voucher.paymentReferenceLabel")))),od("div",{className:"adyen-checkout__voucher-result__bottom"},o.reference&&od("div",{className:"adyen-checkout__voucher-result__code"},o.barcode&&od("img",{alt:l.get("voucher.paymentReferenceLabel"),className:"adyen-checkout__voucher-result__code__barcode",src:o.barcode}),od("span",null,o.reference)),(!!o.downloadUrl||!!o.copyBtn)&&od("ul",{className:"adyen-checkout__voucher-result__actions"},!!o.copyBtn&&od("li",{className:"adyen-checkout__voucher-result__actions__item"},od(cu,{inline:!0,secondary:!0,onClick:function(e,t){var r=t.complete;Ry(o.reference),r()},icon:zd({loadingContext:s,imageFolder:"components/"})("copy"),label:l.get("button.copy")})),!!o.downloadUrl&&od("li",{className:"adyen-checkout__voucher-result__actions__item"},od(cu,{inline:!0,secondary:!0,href:o.downloadUrl,icon:zd({loadingContext:s,imageFolder:"components/"})("download"),label:o.downloadButtonText||l.get("button.download"),target:"_blank",rel:"noopener noreferrer"}))),od("ul",{className:"adyen-checkout__voucher-result__details"},r.filter((function(e){var t=e.label,r=e.value;return!!t&&!!r})).map((function(e,t){var r=e.label,a=e.value;return od("li",{key:t,className:"adyen-checkout__voucher-result__details__item"},od("span",{className:"adyen-checkout__voucher-result__details__label"},r),od("span",{className:"adyen-checkout__voucher-result__details__value"},a))})))))}var Vy=function(e){var t=e.reference,r=e.totalAmount,a=e.expiresAt,n=e.paymentMethodType,o=e.maskedTelephoneNumber,i=e.instructionsUrl,l=e.collectionInstitutionNumber,s=su(),c=s.loadingContext,d=s.i18n;return od(Ly,{paymentMethodType:n,reference:t,introduction:d.get("voucher.introduction.econtext"),imageUrl:zd({loadingContext:c})(n),instructionsUrl:i,amount:r&&d.amount(r.value,r.currency),voucherDetails:[{label:d.get("voucher.collectionInstitutionNumber"),value:l},{label:d.get("voucher.expirationDate"),value:d.date(a)},{label:d.get("voucher.telephoneNumber"),value:o}],copyBtn:!0})},Uy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){return Tc(Tc({},this.state.data),{paymentMethod:{type:this.props.type||t.type}})},Object.defineProperty(t.prototype,"icon",{get:function(){return zd({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?od(Vy,Tc({ref:function(t){e.componentRef=t}},this.props)):od(Ey,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="econtext",t}(pu),Ky=["ES","FR"],Hy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Ky})},t.type="facilypay_3x",t}(Dm),qy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Ky})},t.type="facilypay_4x",t}(Dm),Gy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Ky})},t.type="facilypay_6x",t}(Dm),Yy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Ky})},t.type="facilypay_10x",t}(Dm),Wy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Ky})},t.type="facilypay_12x",t}(Dm),Jy=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="ideal",t}(oh),Zy=["black","white"],Qy=["en_US","en_AU","en_GB","fr_CA","es_ES","it_IT","fr_FR","de_DE","pt_BR","zh_CN","da_DK","zh_HK","id_ID","he_IL","ja_JP","ko_KR","nl_NL","no_NO","pl_PL","pt_PT","ru_RU","sv_SE","th_TH","zh_TW"],$y=function(e,t){return void 0===t&&(t={}),"paypal"===e?Tc({},t):Object.keys(t).reduce((function(e,r){var a=t[r];return("color"!==r||Zy.includes(a))&&(e[r]=a),e}),{})},Xy=function(e){var t=e.amount,r=e.countryCode,a=e.debug,n=e.environment,o=void 0===n?"":n,i=e.locale,l=e.configuration,s=e.commit,c=e.vault,d=function(e){var t=e?e.replace("-","_"):null;return Qy.includes(t)?t:null}(i),u=t?t.currency:null,p="test"===o.toLowerCase(),m=p?"AVzsPoGmjcm99YG02kq0iWL3KP3JedbMQJO2QUnVUc-t7aUzjkBWte7relkAC5SPUL50ovLGKmxfA674":"AU0Z-TP9t5_9196agaBN6ZD3UAwypdP1IX8ZYH3PcNNAQMXUTDQlChruXqQEhyI6-NKBKowN6ydkj477",h=l.merchantId,f=l.intent;return Tc(Tc(Tc(Tc(Tc(Tc(Tc({},h&&{"merchant-id":h}),d&&{locale:d}),r&&p&&{"buyer-country":r}),a&&p&&{debug:a}),u&&{currency:u}),f&&{intent:f}),{commit:s,vault:c,"client-id":m,"integration-date":"2020-02-01",components:"buttons,funding-eligibility"})};function eb(e){var t=e.onInit,r=e.onComplete,a=e.onClick,n=e.onCancel,o=e.onError,i=e.onShippingChange,l=e.onSubmit,s=e.paypalRef,c=e.style,d=$d(null),u=$d(null),p=function(e,d){var u=s.Buttons({fundingSource:e,style:$y(e,c),onInit:t,onClick:a,onCancel:n,onError:o,onShippingChange:i,createOrder:l,onApprove:r});u.isEligible()&&u.render(d.current)};return Zd((function(){var t=s.FUNDING,r=t.PAYPAL,a=t.CREDIT;p(r,d),e.blockPayPalCreditButton||p(a,u)}),[]),od("div",{className:"adyen-checkout__paypal__buttons"},od("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--paypal",ref:d}),od("div",{className:"adyen-checkout__paypal__button adyen-checkout__paypal__button--credit",ref:u}))}function tb(e){var t=su().i18n,r=Wd("pending"),a=r[0],n=r[1];this.setStatus=function(e){n(e)};var o=function(){n("ready")};return Zd((function(){var t=function(e){var t=Xy(e);return"https://www.paypal.com/sdk/js?"+decodeURIComponent(Object.keys(t).map((function(e){return e+"="+t[e]})).join("&"))}(e),r=new Hm(t);return window.paypal?o():r.load().then(o),function(){r.remove()}}),[]),od("div",{className:"adyen-checkout__paypal"},"pending"===a?od("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--pending"},od(Rd,null)):"processing"===a?od("div",{className:"adyen-checkout__paypal__status adyen-checkout__paypal__status--processing"},od(Rd,{size:"medium",inline:!0})," ",t.get("paypal.processingPayment")):od(eb,Tc({},e,{onComplete:function(t){n("processing"),e.onComplete(t)},paypalRef:window.paypal})))}var rb={environment:"TEST",status:"loading",showPayButton:!0,merchantId:"",intent:null,commit:!0,vault:!1,style:{height:48},blockPayPalCreditButton:!1,configuration:{merchantId:"",intent:null},onSubmit:function(){},onAdditionalDetails:function(){},onInit:function(){},onClick:function(){},onCancel:function(){},onError:function(){},onShippingChange:function(){}},ab="No token was provided",nb="Calling submit() is not supported for this payment method",ob="The instance of the PayPal component being used is not the same which started the payment",ib=function(e){function t(t){var r=e.call(this,t)||this;return r.paymentData=null,r.resolve=null,r.reject=null,r.handleAction=r.handleAction.bind(r),r.updateWithAction=r.updateWithAction.bind(r),r.handleCancel=r.handleCancel.bind(r),r.handleComplete=r.handleComplete.bind(r),r.handleError=r.handleError.bind(r),r.handleSubmit=r.handleSubmit.bind(r),r.submit=r.submit.bind(r),r}return Bc(t,e),t.prototype.formatData=function(){return{paymentMethod:{type:t.type,subtype:t.subtype}}},t.prototype.handleAction=function(e){return this.updateWithAction(e)},t.prototype.updateWithAction=function(e){if(e.paymentMethodType!==this.data.paymentMethod.type)throw new Error("Invalid Action");return e.paymentData&&(this.paymentData=e.paymentData),e.sdkData&&e.sdkData.token?this.handleResolve(e.sdkData.token):this.handleReject(ab),null},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.handleCancel=function(e){this.props.onCancel(e,this.elementRef)},t.prototype.handleComplete=function(e){var t={data:{details:e,paymentData:this.paymentData}};this.props.onAdditionalDetails(t,this.elementRef)},t.prototype.handleError=function(e){this.props.onError(e,this.elementRef)},t.prototype.handleResolve=function(e){if(!this.resolve)return this.handleError(ob);this.resolve(e)},t.prototype.handleReject=function(e){if(!this.reject)return this.handleError(ob);this.reject(new Error(e))},t.prototype.startPayment=function(){return Promise.reject(nb)},t.prototype.handleSubmit=function(){var e=this,t=this.data,r=this.isValid;return this.props.onSubmit&&this.props.onSubmit({data:t,isValid:r},this.elementRef),new Promise((function(t,r){e.resolve=t,e.reject=r}))},t.prototype.submit=function(){var e=this;this.startPayment().catch((function(t){e.props.onError(t,e.elementRef)}))},t.prototype.render=function(){var e=this;return this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(tb,Tc({ref:function(t){e.componentRef=t}},this.props,{onCancel:this.handleCancel,onChange:this.setState,onComplete:this.handleComplete,onError:this.handleError,onSubmit:this.handleSubmit}))):null},t.type="paypal",t.subtype="sdk",t.defaultProps=rb,t}(pu);function lb(e){var t,r=su().i18n,a=Wd("ready"),n=a[0],o=a[1],i=!!(null===(t=null==e?void 0:e.items)||void 0===t?void 0:t.length),l=bp({schema:Mc(Mc([],i?["phonePrefix"]:[]),["phoneNumber"]),defaultData:Tc({},i?{phonePrefix:e.selected}:{}),rules:{phoneNumber:{modes:["blur"],errorMessage:"error.va.gen.01",validate:function(e){return(null==e?void 0:e.length)>6}}}}),s=l.handleChangeFor,c=l.triggerValidation,d=l.data,u=l.valid,p=l.errors,m=l.isValid;return Zd((function(){e.onChange({data:d,valid:u,errors:p,isValid:m})}),[d,u,p,m]),this.showValidation=c,this.setStatus=o,od("div",{className:"adyen-checkout__phone-input"},od(Ou,{errorMessage:!!p.phoneNumber,label:r.get(e.phoneLabel),className:Ed({"adyen-checkout__input--phone-number":!0}),inputWrapperModifiers:["phoneInput"]},od("div",{className:"adyen-checkout__input-wrapper"},od("div",{className:Ed({"adyen-checkout__input":!0,"adyen-checkout__input--invalid":!!p.phoneNumber})},!!i&&od(Ou,{inputWrapperModifiers:["phoneInput"]},sp("select",{className:"adyen-checkout__dropdown--small adyen-checkout__countryFlag",filterable:!1,items:e.items,name:e.prefixName,onChange:s("phonePrefix"),placeholder:r.get("infix"),selected:d.phonePrefix}),od("div",{className:"adyen-checkout__phoneNumber"},od("div",null,d.phonePrefix),od("input",{type:"tel",name:e.phoneName,value:d.phoneNumber,onInput:s("phoneNumber","input"),onChange:s("phoneNumber","blur"),placeholder:"123 456 789",className:"adyen-checkout__input adyen-checkout__input--phoneNumber",autoCorrect:"off"})))))),this.props.showPayButton&&this.props.payButton({status:n}))}lb.defaultProps={phoneLabel:"telephoneNumber"};var sb=function(e){if(!e)throw new Error("No item passed");if(!e.code||!e.id)return!1;var t=e.code.toUpperCase().replace(/./g,(function(e){return String.fromCodePoint?String.fromCodePoint(e.charCodeAt(0)+127397):""}));return Tc(Tc({},e),{name:t+" "+e.name+" ("+e.id+")",selectedOptionName:t})},cb=function(e,t){if(e&&t){var r=e.find((function(e){return e.code===t}));return!!r&&r.id}return!1},db=[{id:"+7",name:"Russian Federation",code:"RU"},{id:"+9955",name:"Georgia",code:"GE"},{id:"+507",name:"Panama",code:"PA"},{id:"+44",name:"United Kingdom",code:"GB"},{id:"+992",name:"Tajikistan",code:"TJ"},{id:"+370",name:"Lithuania",code:"LT"},{id:"+972",name:"Israel",code:"IL"},{id:"+996",name:"Kyrgyzstan",code:"KG"},{id:"+380",name:"Ukraine",code:"UA"},{id:"+84",name:"Viet Nam",code:"VN"},{id:"+90",name:"Turkey",code:"TR"},{id:"+994",name:"Azerbaijan",code:"AZ"},{id:"+374",name:"Armenia",code:"AM"},{id:"+371",name:"Latvia",code:"LV"},{id:"+91",name:"India",code:"IN"},{id:"+66",name:"Thailand",code:"TH"},{id:"+373",name:"Moldova",code:"MD"},{id:"+1",name:"United States",code:"US"},{id:"+81",name:"Japan",code:"JP"},{id:"+998",name:"Uzbekistan",code:"UZ"},{id:"+77",name:"Kazakhstan",code:"KZ"},{id:"+375",name:"Belarus",code:"BY"},{id:"+372",name:"Estonia",code:"EE"},{id:"+40",name:"Romania",code:"RO"},{id:"+82",name:"Korea",code:"KR"}],ub=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return Tc(Tc({onValid:function(){}},e),{selected:cb(e.items,e.countryCode)})},t.prototype.formatData=function(){return{paymentMethod:{type:t.type,"qiwiwallet.telephoneNumberPrefix":this.state.data?this.state.data.phonePrefix:"","qiwiwallet.telephoneNumber":this.state.data?this.state.data.phoneNumber:""}}},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(lb,Tc({ref:function(t){e.componentRef=t}},this.props,this.state,{phoneLabel:"mobileNumber",onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="qiwiwallet",t.defaultProps={items:db.map(sb).filter((function(e){return!1!==e})),countryCode:db[0].code,prefixName:"qiwiwallet.telephoneNumberPrefix",phoneName:"qiwiwallet.telephoneNumber"},t}(pu);function pb(e){var t=this,r=$d(null),a=Wd({}),n=a[0],o=a[1],i=Wd({}),l=i[0],s=i[1],c=Wd({}),d=c[0],u=c[1],p=Wd(!1),m=p[0],h=p[1],f=Wd(null),y=f[0],b=f[1],v=Wd([]),g=v[0],k=v[1],C=Wd(""),_=C[0],N=C[1],w=Xd((function(){return sy(e,{sfp:r},{dualBrandSelectElements:g,setDualBrandSelectElements:k,setSelectedBrandValue:N,issuingCountryCode:y,setIssuingCountryCode:b})}),[g,y]);return this.processBinLookupResponse=function(e,t){w.processBinLookup(e,t)},this.dualBrandingChangeHandler=w.handleDualBrandSelection,Zd((function(){return t.setFocusOn=r.current.setFocusOn,t.updateStyles=r.current.updateStyles,t.showValidation=r.current.showValidation,t.handleUnsupportedCard=r.current.handleUnsupportedCard,function(){r.current.destroy()}}),[]),Zd((function(){e.onChange({data:d,valid:l,errors:n,isValid:m,selectedBrandValue:_})}),[d,l,n,_]),od(jf,Tc({ref:r},e,{onChange:function(e){u(Tc(Tc({},d),e.data)),o(Tc(Tc({},n),e.errors)),s(Tc(Tc({},l),e.valid)),h(e.isSfpValid)},render:function(){return null}}))}pb.defaultProps={onChange:function(){},onError:function(){}};var mb=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBinValue=my(t),t}return Bc(t,e),t.prototype.formatProps=function(e){return Tc(Tc(Tc({},e),{type:"scheme"===e.type?"card":e.type}),e.brands&&!e.groupTypes&&{groupTypes:e.brands})},t.prototype.formatData=function(){var e=this.state.selectedBrandValue||this.props.brand;return{paymentMethod:Tc(Tc({type:t.type},this.state.data),e&&{brand:e}),browserInfo:this.browserInfo}},t.prototype.updateStyles=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.updateStyles)&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.setFocusOn)&&this.componentRef.setFocusOn(e),this},t.prototype.processBinLookupResponse=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.processBinLookupResponse)&&this.componentRef.processBinLookupResponse(e),this},t.prototype.dualBrandingChangeHandler=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.dualBrandingChangeHandler)&&this.componentRef.dualBrandingChangeHandler(e),this},t.prototype.handleUnsupportedCard=function(e){var t;return(null===(t=this.componentRef)||void 0===t?void 0:t.handleUnsupportedCard)&&this.componentRef.handleUnsupportedCard(e),this},t.prototype.onBinLookup=function(e){var t,r=this,a=Tc({},e);a.rootNode=this._node,a.isReset||(a.supportedBrandsRaw=null===(t=e.supportedBrandsRaw)||void 0===t?void 0:t.map((function(e){var t,a;return e.brandImageUrl=null!==(a=null===(t=r.props.brandsConfiguration[e.brand])||void 0===t?void 0:t.icon)&&void 0!==a?a:Dh(e.brand,r.props.loadingContext),e}))),this.props.onBinLookup(a)},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){return zd({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"browserInfo",{get:function(){return Tm()},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(pb,Tc({ref:function(t){e.componentRef=t}},this.props,this.state,{rootNode:this._node,onChange:this.setState,onBinValue:this.onBinValue,implementationType:"custom"})))},t.type="scheme",t.analyticsType="custom-scheme",t.defaultProps={onBinLookup:function(){},brandsConfiguration:{}},t}(pu),hb={AD:{length:24,structure:"F04F04A12",example:"AD9912345678901234567890"},AE:{length:23,structure:"F03F16",example:"AE993331234567890123456"},AL:{length:28,structure:"F08A16",example:"AL47212110090000000235698741"},AT:{length:20,structure:"F05F11",example:"AT611904300234573201"},AZ:{length:28,structure:"U04A20",example:"AZ21NABZ00000000137010001944"},BA:{length:20,structure:"F03F03F08F02",example:"BA391290079401028494"},BE:{length:16,structure:"F03F07F02",example:"BE68 5390 0754 7034"},BG:{length:22,structure:"U04F04F02A08",example:"BG80BNBG96611020345678"},BH:{length:22,structure:"U04A14",example:"BH67BMAG00001299123456"},BR:{length:29,structure:"F08F05F10U01A01",example:"BR9700360305000010009795493P1"},CH:{length:21,structure:"F05A12",example:"CH9300762011623852957"},CR:{length:22,structure:"F04F14",example:"CR72012300000171549015"},CY:{length:28,structure:"F03F05A16",example:"CY17002001280000001200527600"},CZ:{length:24,structure:"F04F06F10",example:"CZ6508000000192000145399"},DE:{length:22,structure:"F08F10",example:"DE00123456789012345678"},DK:{length:18,structure:"F04F09F01",example:"DK5000400440116243"},DO:{length:28,structure:"U04F20",example:"DO28BAGR00000001212453611324"},EE:{length:20,structure:"F02F02F11F01",example:"EE382200221020145685"},ES:{length:24,structure:"F04F04F01F01F10",example:"ES9121000418450200051332"},FI:{length:18,structure:"F06F07F01",example:"FI2112345600000785"},FO:{length:18,structure:"F04F09F01",example:"FO6264600001631634"},FR:{length:27,structure:"F05F05A11F02",example:"FR1420041010050500013M02606"},GB:{length:22,structure:"U04F06F08",example:"GB29NWBK60161331926819"},GE:{length:22,structure:"U02F16",example:"GE29NB0000000101904917"},GI:{length:23,structure:"U04A15",example:"GI75NWBK000000007099453"},GL:{length:18,structure:"F04F09F01",example:"GL8964710001000206"},GR:{length:27,structure:"F03F04A16",example:"GR1601101250000000012300695"},GT:{length:28,structure:"A04A20",example:"GT82TRAJ01020000001210029690"},HR:{length:21,structure:"F07F10",example:"HR1210010051863000160"},HU:{length:28,structure:"F03F04F01F15F01",example:"HU42117730161111101800000000"},IE:{length:22,structure:"U04F06F08",example:"IE29AIBK93115212345678"},IL:{length:23,structure:"F03F03F13",example:"IL620108000000099999999"},IS:{length:26,structure:"F04F02F06F10",example:"IS140159260076545510730339"},IT:{length:27,structure:"U01F05F05A12",example:"IT60X0542811101000000123456"},KW:{length:30,structure:"U04A22",example:"KW81CBKU0000000000001234560101"},KZ:{length:20,structure:"F03A13",example:"KZ86125KZT5004100100"},LB:{length:28,structure:"F04A20",example:"LB62099900000001001901229114"},LC:{length:32,structure:"U04F24",example:"LC07HEMM000100010012001200013015"},LI:{length:21,structure:"F05A12",example:"LI21088100002324013AA"},LT:{length:20,structure:"F05F11",example:"LT121000011101001000"},LU:{length:20,structure:"F03A13",example:"LU280019400644750000"},LV:{length:21,structure:"U04A13",example:"LV80BANK0000435195001"},MC:{length:27,structure:"F05F05A11F02",example:"MC5811222000010123456789030"},MD:{length:24,structure:"U02A18",example:"MD24AG000225100013104168"},ME:{length:22,structure:"F03F13F02",example:"ME25505000012345678951"},MK:{length:19,structure:"F03A10F02",example:"MK07250120000058984"},MR:{length:27,structure:"F05F05F11F02",example:"MR1300020001010000123456753"},MT:{length:31,structure:"U04F05A18",example:"MT84MALT011000012345MTLCAST001S"},MU:{length:30,structure:"U04F02F02F12F03U03",example:"MU17BOMM0101101030300200000MUR"},NL:{length:18,structure:"U04F10",example:"NL99BANK0123456789"},NO:{length:15,structure:"F04F06F01",example:"NO9386011117947"},PK:{length:24,structure:"U04A16",example:"PK36SCBL0000001123456702"},PL:{length:28,structure:"F08F16",example:"PL00123456780912345678901234"},PS:{length:29,structure:"U04A21",example:"PS92PALS000000000400123456702"},PT:{length:25,structure:"F04F04F11F02",example:"PT50000201231234567890154"},RO:{length:24,structure:"U04A16",example:"RO49AAAA1B31007593840000"},RS:{length:22,structure:"F03F13F02",example:"RS35260005601001611379"},SA:{length:24,structure:"F02A18",example:"SA0380000000608010167519"},SE:{length:24,structure:"F03F16F01",example:"SE4550000000058398257466"},SI:{length:19,structure:"F05F08F02",example:"SI56263300012039086"},SK:{length:24,structure:"F04F06F10",example:"SK3112000000198742637541"},SM:{length:27,structure:"U01F05F05A12",example:"SM86U0322509800000000270100"},ST:{length:25,structure:"F08F11F02",example:"ST68000100010051845310112"},TL:{length:23,structure:"F03F14F02",example:"TL380080012345678910157"},TN:{length:24,structure:"F02F03F13F02",example:"TN5910006035183598478831"},TR:{length:26,structure:"F05F01A16",example:"TR330006100519786457841326"},VG:{length:24,structure:"U04F16",example:"VG96VPVG0000012345678901"},XK:{length:20,structure:"F04F10F02",example:"XK051212012345678906"},AO:{length:25,structure:"F21",example:"AO69123456789012345678901"},BF:{length:27,structure:"F23",example:"BF2312345678901234567890123"},BI:{length:16,structure:"F12",example:"BI41123456789012"},BJ:{length:28,structure:"F24",example:"BJ39123456789012345678901234"},CI:{length:28,structure:"U01F23",example:"CI17A12345678901234567890123"},CM:{length:27,structure:"F23",example:"CM9012345678901234567890123"},CV:{length:25,structure:"F21",example:"CV30123456789012345678901"},DZ:{length:24,structure:"F20",example:"DZ8612345678901234567890"},IR:{length:26,structure:"F22",example:"IR861234568790123456789012"},JO:{length:30,structure:"A04F22",example:"JO15AAAA1234567890123456789012"},MG:{length:27,structure:"F23",example:"MG1812345678901234567890123"},ML:{length:28,structure:"U01F23",example:"ML15A12345678901234567890123"},MZ:{length:25,structure:"F21",example:"MZ25123456789012345678901"},QA:{length:29,structure:"U04A21",example:"QA30AAAA123456789012345678901"},SN:{length:28,structure:"U01F23",example:"SN52A12345678901234567890123"},UA:{length:29,structure:"F25",example:"UA511234567890123456789012345"}},fb=function(e){return e.replace(/\W/gi,"").replace(/(.{4})(?!$)/g,"$1 ").trim()},yb=function(e){return e.replace(/[^a-zA-Z0-9]/g,"").toUpperCase()},bb=function(e,t){return function(e,t){if(null===t||!hb[t]||!hb[t].structure)return!1;var r=hb[t].structure.match(/(.{3})/g).map((function(e){var t,r=e.slice(0,1),a=parseInt(e.slice(1),10);switch(r){case"A":t="0-9A-Za-z";break;case"B":t="0-9A-Z";break;case"C":t="A-Za-z";break;case"F":t="0-9";break;case"L":t="a-z";break;case"U":t="A-Z";break;case"W":t="0-9a-z"}return"(["+t+"]{"+a+"})"}));return new RegExp("^"+r.join("")+"$")}(0,t)},vb=function(e){return void 0===e&&(e=null),e&&hb[e]&&hb[e].example?fb(hb[e].example):"AB00 1234 5678 9012 3456 7890"};function gb(e,t){void 0===t&&(t=null),this.status=e,this.code=t}var kb=function(e){var t=yb(e);return 1===function(e){for(var t,r=e;r.length>2;)t=r.slice(0,9),r=parseInt(t,10)%97+r.slice(t.length);return parseInt(r,10)%97}(function(e){var t=e,r="A".charCodeAt(0),a="Z".charCodeAt(0);return(t=(t=t.toUpperCase()).substr(4)+t.substr(0,4)).split("").map((function(e){var t=e.charCodeAt(0);return t>=r&&t<=a?t-r+10:e})).join("")}(t))&&function(e){var t=e.slice(0,2),r=bb(0,t);return r.test&&r.test(e.slice(4))||!1}(t)},Cb=function(e){var t=yb(e);if(e.length<2)return new gb("no-validate","TOO_SHORT");var r=function(e){return!(!e||!hb[e])&&hb[e]}(t.slice(0,2));return r?t.length>r.length?new gb("invalid","TOO_LONG"):t.length===r.length?kb(e)?new gb("valid","VALID"):new gb("invalid","INVALID_IBAN"):new gb("no-validate","UNKNOWN"):new gb("invalid","INVALID_COUNTRY")},_b=function(e){return!!(e&&e.length&&e.length>0)},Nb=function(e){function t(t){var r,a,n=e.call(this,t)||this;if(n.setData=function(e,t,r){n.setState((function(r){var a;return{data:Tc(Tc({},r.data),(a={},a[e]=t,a))}}),r)},n.setError=function(e,t,r){n.setState((function(r){var a;return{errors:Tc(Tc({},r.errors),(a={},a[e]=t,a))}}),r)},n.setValid=function(e,t,r){n.setState((function(r){var a;return{valid:Tc(Tc({},r.valid),(a={},a[e]=t,a))}}),r)},n.handleHolderInput=function(e){n.setState((function(t){return{data:Tc(Tc({},t.data),{"sepa.ownerName":e})}}),(function(){n.setError("holder",!_b(n.state.data["sepa.ownerName"])),n.onChange()}))},n.handleIbanInput=function(e){var t=e.target.value,r=yb(t),a=fb(r),o=Cb(a).status,i=e.target.selectionStart,l=n.state.data["sepa.ibanNumber"],s=function(e,t,r){if(0===e||!t.length)return 0;var a=t.length-r.length,n=a>0,o=function(e,t){return/\s/.test(e.charAt(t))},i=e-a;return n&&(o(t,i+1)||o(t,i))?e+1:!n&&o(t,e-1)?e-1:e}(i,a,l);n.setState((function(e){return{data:Tc(Tc({},e.data),{"sepa.ibanNumber":a}),errors:Tc(Tc({},e.errors),{iban:"invalid"===o?"sepaDirectDebit.ibanField.invalid":null}),valid:Tc(Tc({},e.valid),{iban:"valid"===o})}}),(function(){e.target.setSelectionRange(s,s),n.onChange()}))},n.handleIbanBlur=function(e){var t=e.target.value;if(t.length>0){var r=Cb(t).status;n.setError("iban","valid"!==r?"sepaDirectDebit.ibanField.invalid":null)}},n.state={status:"ready",data:{"sepa.ownerName":(null===(r=null==t?void 0:t.data)||void 0===r?void 0:r.ownerName)||"","sepa.ibanNumber":(null===(a=null==t?void 0:t.data)||void 0===a?void 0:a.ibanNumber)||""},isValid:!1,cursor:0,errors:{},valid:{}},n.state.data["sepa.ibanNumber"]){var o=yb(n.state.data["sepa.ibanNumber"]);n.state.data["sepa.ibanNumber"]=fb(o)}if(n.state.data["sepa.ibanNumber"]||n.state.data["sepa.ownerName"]){var i=n.props.holderName?_b(n.state.data["sepa.ownerName"]):"",l=(n.state.data["sepa.ibanNumber"]?"valid"===Cb(n.state.data["sepa.ibanNumber"]).status:"")&&i,s={data:n.state.data,isValid:l};n.props.onChange(s)}return n}return Bc(t,e),t.prototype.setStatus=function(e){this.setState({status:e})},t.prototype.onChange=function(){var e=this.props.holderName?_b(this.state.data["sepa.ownerName"]):"",t="valid"===Cb(this.state.data["sepa.ibanNumber"]).status&&e,r={data:this.state.data,isValid:t};this.props.onChange(r)},t.prototype.showValidation=function(){var e=Cb(this.state.data["sepa.ibanNumber"]).status,t=_b(this.state.data["sepa.ownerName"]);this.setError("iban","valid"!==e?"sepaDirectDebit.ibanField.invalid":null),this.setError("holder",!t||null)},t.prototype.render=function(e,t){var r=this,a=e.placeholders,n=e.countryCode,o=t.data,i=t.errors,l=t.valid,s=su().i18n;return od("div",{className:"adyen-checkout__iban-input"},this.props.holderName&&od(Ou,{className:"adyen-checkout__field--owner-name",label:s.get("sepa.ownerName"),filled:o["sepa.ownerName"]&&o["sepa.ownerName"].length,errorMessage:!!i.holder&&s.get("creditCard.holderName.invalid"),dir:"ltr"},sp("text",{name:"sepa.ownerName",className:"adyen-checkout__iban-input__owner-name",placeholder:"ownerName"in a?a.ownerName:s.get("sepaDirectDebit.nameField.placeholder"),value:o["sepa.ownerName"],"aria-invalid":!!this.state.errors.holder,"aria-label":s.get("sepa.ownerName"),onInput:function(e){return r.handleHolderInput(e.target.value)}})),od(Ou,{className:"adyen-checkout__field--iban-number",label:s.get("sepa.ibanNumber"),errorMessage:!!i.iban&&s.get(i.iban),filled:o["sepa.ibanNumber"]&&o["sepa.ibanNumber"].length,isValid:l.iban,onBlur:this.handleIbanBlur,dir:"ltr"},sp("text",{ref:function(e){r.ibanNumber=e},name:"sepa.ibanNumber",className:"adyen-checkout__iban-input__iban-number",classNameModifiers:["large"],placeholder:"ibanNumber"in a?a.ibanNumber:vb(n),value:o["sepa.ibanNumber"],onInput:this.handleIbanInput,"aria-invalid":!!this.state.errors.iban,"aria-label":s.get("sepa.ibanNumber"),autocorrect:"off",spellcheck:!1})),this.props.showPayButton&&this.props.payButton({status:this.state.status}))},t.defaultProps={onChange:function(){},countryCode:null,holderName:!0,placeholders:{}},t}(sd),wb=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){return Tc({holderName:!0},e)},t.prototype.formatData=function(){return{paymentMethod:{type:t.type,iban:this.state.data["sepa.ibanNumber"],ownerName:this.state.data["sepa.ownerName"]}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,Tc({},this.props,{loadingContext:this.props.loadingContext}),od(Nb,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="sepadirectdebit",t}(pu),Pb=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.componentDidMount=function(){this.formEl.submit()},t.prototype.render=function(e){var t=this,r=e.name,a=e.action,n=e.target,o=e.inputName,i=e.inputValue;return od("form",{ref:function(e){t.formEl=e},method:"POST",className:Ed(["adyen-checkout__threeds2__form","adyen-checkout__threeds2__form--"+r]),name:r,action:a,target:n,style:{display:"none"}},od("input",{name:o,value:i}))},t}(sd),Fb={result:{transStatus:"U"},type:"challengeResult"},Db={result:{transStatus:"U"},type:"challengeResult",errorCode:"timeout"},Ab={result:{threeDSCompInd:"N"},type:"fingerPrintResult"},Sb={result:{threeDSCompInd:"N"},type:"fingerPrintResult",errorCode:"timeout"},xb="unknownError",Bb={timeout:"ThreeDS2 timed out",wrongOrigin:"Result came in the right format but not from the expected origin",HTMLElementError:"No proper HTML element was passed",wrongDataType:"Result data was not of the expected type",missingProperty:"Result data did not contain the expected properties",unknownError:"An unknown error occurred"},Tb={"01":["250px","400px"],"02":["390px","400px"],"03":["500px","600px"],"04":["600px","400px"],"05":["100%","100%"]},zb=function(e){var t=Fu.decode(e);try{return t&&JSON.parse(t)}catch(e){throw new Error("Could not decode token")}},Ib=function(e){if(!e||!Object.keys(e).length)throw new Error("No (populated) data object to encode");return Fu.encode(JSON.stringify(e))},jb=function(e){var t=1===e.length?"0"+e:e;return Object.prototype.hasOwnProperty.call(Tb,t)?t:"02"},Mb=function(e,t,r){var a;return{data:(a={},a[e]=Ib({threeDSCompInd:t.threeDSCompInd}),a.paymentData=r,a)}},Ob=function(e,t,r){return{data:{details:{"threeds2.fingerprint":Ib(t)},paymentData:r}}},Eb=function(e,t,r){var a;return{data:{details:(a={},a[e]=Ib({transStatus:t,authorisationToken:r}),a)}}},Rb=function(e,t,r){return{data:{details:{"threeds2.challengeResult":Ib({transStatus:t})},paymentData:r}}},Lb=function(e){return{errorCode:e,message:Bb[e]||Bb[xb]}},Vb=function(e){var t=window.btoa(e).split("=")[0];return t=(t=t.replace(/\+/g,"-")).replace(/\//g,"_")},Ub=["elementRef"],Kb=["createFromAction","onAdditionalDetails"],Hb="threeDSIframe",qb=function(e){function t(t){var r=e.call(this,t)||this;r.iframeCallback=function(){r.setState({status:"iframeLoaded"})};var a=JSON.stringify(r.props.cReqData),n=Vb(a);return r.state={base64URLencodedData:n},r}return Bc(t,e),t.prototype.get3DS2ChallengePromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=ku(e.props.postMessageDomain,t,r,Fb,"challengeResult"),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.challengePromise=hu(6e5,this.get3DS2ChallengePromise(),Db),this.challengePromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteChallenge(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorChallenge(t)}))},t.prototype.componentWillUnmount=function(){this.challengePromise&&this.challengePromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},t.prototype.render=function(e,t){var r=e.acsURL,a=e.cReqData,n=e.iframeSizeArr,o=t.base64URLencodedData,i=t.status,l=n[0],s=n[1];return od("div",{className:Ed(["adyen-checkout__threeds2__challenge","adyen-checkout__threeds2__challenge--"+a.challengeWindowSize])},"iframeLoaded"!==i&&od(Rd,null),od(mu,{name:Hb,width:l,height:s,callback:this.iframeCallback}),od(Pb,{name:"cReqForm",action:r,target:Hb,inputName:"creq",inputValue:o}))},t}(sd),Gb=function(e){function t(t){var r=e.call(this,t)||this;if(r.props.token){var a=function(e){var t,r=e.token,a=e.size,n=zb(r),o=n.acsTransID,i=n.acsURL,l=n.messageVersion,s=n.threeDSNotificationURL,c=n.threeDSServerTransID,d=Cu(s);return{acsURL:i,cReqData:{acsTransID:o,messageVersion:l,threeDSServerTransID:c,messageType:"CReq",challengeWindowSize:jb(a)},iframeSizeArr:(t=a,Tb[jb(t)]),postMessageDomain:d}}({token:r.props.token,size:r.props.challengeWindowSize||r.props.size});r.state={status:"retrievingChallengeToken",challengeData:a}}else r.state={status:"error"},r.props.onError("Missing challengeToken parameter");return r}return Bc(t,e),t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?Rb:Eb)(t.props.dataKey,e.transStatus,t.props.paymentData);t.props.onComplete(r)}))},t.prototype.render=function(e,t){var r=this,a=t.challengeData;return"retrievingChallengeToken"===this.state.status?od(qb,Tc({onCompleteChallenge:function(e){r.setStatusComplete(e.result)},onErrorChallenge:function(e){var t=Lb(e.errorCode);r.props.onError(t),r.setStatusComplete(e.result)}},a)):null},t.defaultProps={onComplete:function(){},onError:function(){}},t}(sd),Yb=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.render=function(){return zh(this.props.paymentData)?od(Gb,Tc({},this.props,{onComplete:this.onComplete})):(this.props.onError({errorCode:"threeds2.challenge",message:"No paymentData received. Challenge cannot proceed"}),null)},t.type="threeDS2Challenge",t.defaultProps={dataKey:"threeDSResult",size:"02",type:"ChallengeShopper"},t}(pu),Wb="threeDSMethodIframe",Jb=function(e){function t(t){var r=e.call(this,t)||this,a=r.props,n=a.threeDSServerTransID,o=a.threeDSMethodNotificationURL,i=JSON.stringify({threeDSServerTransID:n,threeDSMethodNotificationURL:o}),l=Vb(i);return r.state={base64URLencodedData:l},r}return Bc(t,e),t.prototype.get3DS2MethodPromise=function(){var e=this;return new Promise((function(t,r){e.processMessageHandler=ku(e.props.postMessageDomain,t,r,Ab,"fingerPrintResult"),window.addEventListener("message",e.processMessageHandler)}))},t.prototype.componentDidMount=function(){var e=this;this.fingerPrintPromise=hu(1e4,this.get3DS2MethodPromise(),Sb),this.fingerPrintPromise.promise.then((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onCompleteFingerprint(t)})).catch((function(t){window.removeEventListener("message",e.processMessageHandler),e.props.onErrorFingerprint(t)}))},t.prototype.componentWillUnmount=function(){this.fingerPrintPromise&&this.fingerPrintPromise.cancel(),window.removeEventListener("message",this.processMessageHandler)},t.prototype.render=function(e,t){var r=e.threeDSMethodURL,a=t.base64URLencodedData;return od("div",{className:"adyen-checkout__3ds2-device-fingerprint"},this.props.showSpinner&&od(Rd,null),od("div",{style:{display:"none"}},od(mu,{name:Wb}),od(Pb,{name:"threeDSMethodForm",action:r,target:Wb,inputName:"threeDSMethodData",inputValue:a})))},t.defaultProps={showSpinner:!0},t}(sd),Zb=function(e){function t(t){var r=e.call(this,t)||this,a=r.props,n=a.token,o=a.notificationURL;if(n){var i=function(e){var t=e.token,r=e.notificationURL,a=zb(t),n=a.threeDSMethodNotificationURL,o=a.threeDSMethodUrl,i=r||n;return{threeDSServerTransID:a.threeDSServerTransID,threeDSMethodURL:o,threeDSMethodNotificationURL:i,postMessageDomain:Cu(i)}}({token:n,notificationURL:o});r.state={status:"init",fingerPrintData:i}}else r.state={status:"error"},r.props.onError("Missing fingerprintToken parameter");return r}return Bc(t,e),t.prototype.componentDidMount=function(){this.state.fingerPrintData&&this.state.fingerPrintData.threeDSMethodURL&&this.state.fingerPrintData.threeDSMethodURL.length?this.setState({status:"retrievingFingerPrint"}):this.setStatusComplete({threeDSCompInd:"U"})},t.prototype.setStatusComplete=function(e){var t=this;this.setState({status:"complete"},(function(){var r=(t.props.useOriginalFlow?Ob:Mb)(t.props.dataKey,e,t.props.paymentData);t.props.onComplete(r)}))},t.prototype.render=function(e,t){var r=this,a=t.fingerPrintData;return"retrievingFingerPrint"===this.state.status?od(Jb,Tc({onCompleteFingerprint:function(e){r.setStatusComplete(e.result)},onErrorFingerprint:function(e){var t=Lb(e.errorCode);r.props.onError(t),r.setStatusComplete(e.result)},showSpinner:this.props.showSpinner},a)):null},t.type="scheme",t.defaultProps={onComplete:function(){},onError:function(){},paymentData:"",showSpinner:!0},t}(sd);function Qb(e){var t=this,r=e.data;fm({path:"v1/submitThreeDS2Fingerprint?token="+this.props.clientKey,loadingContext:this.props.loadingContext},Tc({},r)).then((function(e){var r,a,n,o=null!==(r=t.props.elementRef)&&void 0!==r?r:t;if(e.action||e.details){if("completed"===e.type){var i=e.details;return t.onComplete({data:{details:i}})}return"threeDS2"===(null===(a=e.action)||void 0===a?void 0:a.type)?o.handleAction(e.action,Sh("challengeWindowSize").from(t.props)):"redirect"===(null===(n=e.action)||void 0===n?void 0:n.type)?o.handleAction(e.action):void 0}console.error("Handled Error::callSubmit3DS2Fingerprint::FAILED:: resData=",e)}))}var $b=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.callSubmit3DS2Fingerprint=Qb.bind(t),t}return Bc(t,e),t.prototype.render=function(){return zh(this.props.paymentData)?od(Zb,Tc({},this.props,{onComplete:this.props.useOriginalFlow?this.onComplete:this.callSubmit3DS2Fingerprint})):(this.props.onError({errorCode:t.defaultProps.dataKey,message:"No paymentData received. Fingerprinting cannot proceed"}),null)},t.type="threeDS2Fingerprint",t.defaultProps={dataKey:"fingerprintResult",type:"IdentifyShopper"},t}(pu),Xb=function(e,t){if(void 0===t&&(t=2),0===t)return e;var r=String(e);return r.length>=t?r:("0".repeat(t)+r).slice(-1*t)},ev=function(e,t){var r=new Date,a=t.getTime()-r.getTime(),n=a/1e3,o=function(e,t,r){var a=r.getTime()-e.getTime();return 100-Math.round(100*(t.getTime()-e.getTime())/a)}(e,r,t);return{total:a,minutes:Xb(Math.floor(n/60%60)),seconds:Xb(Math.floor(n%60)),completed:a<=0,percentage:o}},tv=function(e){function t(t){var r=e.call(this,t)||this,a=6e4*r.props.minutesFromNow,n=(new Date).getTime();return r.state={startTime:new Date(n),endTime:new Date(n+a),minutes:"-",seconds:"-"},r}return Bc(t,e),t.prototype.tick=function(){var e=ev(this.state.startTime,this.state.endTime);if(e.completed)return this.props.onCompleted(),this.clearInterval();var t={minutes:e.minutes,seconds:e.seconds,percentage:e.percentage};return this.setState(Tc({},t)),this.props.onTick(t),t},t.prototype.clearInterval=function(){clearInterval(this.interval),delete this.interval},t.prototype.componentDidMount=function(){var e=this;this.interval=setInterval((function(){e.tick()}),1e3)},t.prototype.componentWillUnmount=function(){this.clearInterval()},t.prototype.render=function(){return od("span",{className:"adyen-checkout__countdown"},od("span",{className:"countdown__minutes"},this.state.minutes),od("span",{className:"countdown__separator"},":"),od("span",{className:"countdown__seconds"},this.state.seconds))},t.defaultProps={onTick:function(){},onCompleted:function(){}},t}(sd);function rv(e,t,r){if(!e||!t)throw new Error("Could not check the payment status");return fm({loadingContext:r,path:"services/PaymentInitiation/v1/status?clientKey="+t},{paymentData:e})}var av=function(e){switch(e.resultCode.toLowerCase()){case"refused":case"error":case"cancelled":return{type:"error",props:Tc(Tc({},e),{message:"error.subtitle.refused"})};case"unknown":return{type:"error",props:Tc(Tc({},e),{message:"error.message.unknown"})};case"pending":case"received":return{type:e.resultCode.toLowerCase(),props:e};case"authorised":default:return{type:"success",props:e}}},nv=function(e){if(!e.type&&e.resultCode)return av(e);if(!e.type)return{type:"error",props:e};switch(e.type.toLowerCase()){case"pending":return{type:"pending",props:e};case"complete":return av(e);case"validation":default:return{type:"error",props:e}}},ov=function(e){function t(t){var r=e.call(this,t)||this;return r.statusInterval=function(){r.checkStatus(),r.setState({timePassed:r.state.timePassed+r.props.delay}),r.state.timePassed>=r.props.throttleTime&&r.setState({delay:r.props.throttledInterval})},r.redirectToApp=function(e,t){void 0===t&&(t=function(){}),setTimeout((function(){r.props.onError(r.props.type+" App was not found"),t()}),25),window.location.assign(e)},r.state={buttonStatus:"default",completed:!1,delay:t.delay,expired:!1,loading:!0,onError:function(){},percentage:100,timePassed:0},r.onTimeUp=r.onTimeUp.bind(r),r.onTick=r.onTick.bind(r),r.onComplete=r.onComplete.bind(r),r.onError=r.onError.bind(r),r.checkStatus=r.checkStatus.bind(r),r}return Bc(t,e),t.prototype.componentDidMount=function(){var e=this,t=this.props,r=t.shouldRedirectOnMobile,a=t.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent),o=function(){e.interval=setInterval(e.statusInterval,e.state.delay)};r&&a&&n?this.redirectToApp(a,o):o()},t.prototype.componentDidUpdate=function(e,t){t.delay!==this.state.delay&&(clearInterval(this.interval),this.interval=setInterval(this.statusInterval,this.state.delay))},t.prototype.componentWillUnmount=function(){clearInterval(this.interval)},t.prototype.onTick=function(e){this.setState({percentage:e.percentage})},t.prototype.onTimeUp=function(){return this.setState({expired:!0}),clearInterval(this.interval),this.props.onError({type:"error",props:{errorMessage:"Payment Expired"}})},t.prototype.onComplete=function(e){return clearInterval(this.interval),this.setState({completed:!0,loading:!1}),this.props.onComplete({data:{details:{payload:e.props.payload},paymentData:this.props.paymentData}}),e},t.prototype.onError=function(e){return clearInterval(this.interval),this.setState({expired:!0,loading:!1}),this.props.onComplete({data:{details:{payload:e.props.payload},paymentData:this.props.paymentData}}),e},t.prototype.checkStatus=function(){var e=this,t=this.props;return rv(t.paymentData,t.clientKey,t.loadingContext).then(nv).catch((function(e){return{type:"network-error",props:e}})).then((function(t){switch(t.type){case"success":return e.onComplete(t);case"error":return e.onError(t);default:e.setState({loading:!1})}return t}))},t.prototype.render=function(e,t){var r=this,a=e.amount,n=e.url,o=e.brandLogo,i=e.countdownTime,l=e.i18n,s=e.loadingContext,c=e.type,d=t.expired,u=t.completed,p=t.loading,m=this.props.qrCodeData?s+"barcode.shtml?barcodeType=qrCode&fileType=png&data="+this.props.qrCodeData:this.props.qrCodeImage,h=function(e,t){return od("div",{className:"adyen-checkout__qr-loader adyen-checkout__qr-loader--result"},od("img",{className:"adyen-checkout__qr-loader__icon adyen-checkout__qr-loader__icon--result",src:zd({loadingContext:s,imageFolder:"components/"})(e),alt:l.get(t)}),od("div",{className:"adyen-checkout__qr-loader__subtitle adyen-checkout__qr-loader__subtitle--result"},l.get(t)))};if(d)return h("error","error.subtitle.payment");if(u)return h("success","creditCard.success");if(p)return od("div",{className:"adyen-checkout__qr-loader"},o&&od("img",{alt:c,src:o,className:"adyen-checkout__qr-loader__brand-logo"}),od(Rd,null));var f=l.get("wechatpay.timetopay").split("%@");return od("div",{className:"\n                    adyen-checkout__qr-loader\n                    adyen-checkout__qr-loader--"+c+"\n                    "+this.props.classNameModifiers.map((function(e){return"adyen-checkout__qr-loader--"+e}))+"\n                "},o&&od("img",{src:o,alt:c,className:"adyen-checkout__qr-loader__brand-logo"}),od("div",{className:"adyen-checkout__qr-loader__subtitle"},l.get(this.props.introduction)),od("img",{src:m,alt:l.get("wechatpay.scanqrcode")}),a&&a.value&&a.currency&&od("div",{className:"adyen-checkout__qr-loader__payment_amount"},l.amount(a.value,a.currency)),od("div",{className:"adyen-checkout__qr-loader__progress"},od("span",{className:"adyen-checkout__qr-loader__percentage",style:{width:this.state.percentage+"%"}})),od("div",{className:"adyen-checkout__qr-loader__countdown"},f[0],"\xa0",od(tv,{minutesFromNow:i,onTick:this.onTick,onCompleted:this.onTimeUp}),"\xa0",f[1]),this.props.instructions&&od("div",{className:"adyen-checkout__qr-loader__instructions"},l.get(this.props.instructions)),this.props.copyBtn&&od("div",{className:"adyen-checkout__qr-loader__actions"},od(cu,{inline:!0,secondary:!0,onClick:function(e,t){var a=t.complete;Ry(r.props.qrCodeData),a()},icon:zd({loadingContext:s,imageFolder:"components/"})("copy"),label:l.get("button.copy")})),n&&od("div",{className:"adyen-checkout__qr-loader__app-link"},od("span",{className:"adyen-checkout__qr-loader__separator__label"},l.get("or")),od(cu,{classNameModifiers:["qr-loader"],onClick:function(){return r.redirectToApp(n)},label:l.get("openApp")})))},t.defaultProps={delay:2e3,countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,classNameModifiers:[],throttledInterval:1e4,introduction:"wechatpay.scanqrcode"},t}(sd),iv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatData=function(){return{paymentMethod:Tc({type:this.props.type||this.constructor.type},this.state.data)}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.renderQRCode=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(ov,Tc({ref:function(t){e.componentRef=t}},this.props,{shouldRedirectOnMobile:this.props.shouldRedirectOnMobile,type:this.constructor.type,brandLogo:this.props.brandLogo||this.icon,delay:this.props.delay,onComplete:this.onComplete,countdownTime:this.props.countdownTime,instructions:this.props.instructions})))},t.prototype.render=function(){var e=this;return this.props.paymentData?this.renderQRCode():this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(_y,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton,ref:function(t){e.componentRef=t}})):null},t.defaultProps={qrCodeImage:"",amount:null,paymentData:null,onError:function(){},onComplete:function(){}},t}(pu),lv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc({delay:2e3,countdownTime:15},e.prototype.formatProps.call(this,t))},t.type="wechatpayQR",t}(iv),sv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){var r=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return Tc({delay:2e3,countdownTime:15,shouldRedirectOnMobile:!0,buttonLabel:r?"openApp":"generateQRCode"},e.prototype.formatProps.call(this,t))},t.type="bcmc_mobile",t}(iv),cv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="molpay_ebanking_fpx_MY",t}(oh),dv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="molpay_ebanking_TH",t}(oh),uv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="molpay_ebanking_VN",t}(oh),pv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="openbanking_UK",t}(oh);function mv(e){var t=su().i18n,r=function(){return["dragonpay_ebanking","dragonpay_otc_banking","dragonpay_otc_non_banking"].indexOf(e.type)>-1},a=bp({schema:Mc(Mc([],r()?["issuer"]:[]),["shopperEmail"]),rules:{issuer:{validate:function(e){return r()&&!!e},modes:["input","blur"]}}}),n=a.handleChangeFor,o=a.triggerValidation,i=a.data,l=a.valid,s=a.errors,c=a.isValid,d=nh({},e.type),u=e.items.map((function(e){return Tc(Tc({},e),{icon:d(e.id&&e.id.toLowerCase())})})),p=function(e){return"dragonpay_otc_non_banking"===e?"dragonpay.voucher.non.bank.selectField.placeholder":"dragonpay.voucher.bank.selectField.placeholder"};Zd((function(){e.onChange({isValid:c,data:i,valid:l,errors:s})}),[c,i,l,s]);var m=Wd("ready"),h=m[0],f=m[1];return this.setStatus=f,this.showValidation=o,od("div",{className:"adyen-checkout__dragonpay-input__field"},od(Ou,{label:t.get("shopperEmail"),errorMessage:!!s.shopperEmail},sp("emailAddress",{name:"dragonpay.shopperEmail",autoCorrect:"off",value:i.shopperEmail,className:"adyen-checkout__input--large",spellCheck:!1,onInput:n("shopperEmail","input"),onChange:n("shopperEmail","blur")})),r()&&od(Ou,{label:t.get(p(e.type)),errorMessage:!!s.issuer},sp("select",{items:u,selected:i.issuer,placeholder:t.get(p(e.type)),name:"issuer",className:"adyen-checkout__dropdown--large adyen-checkout__issuer-list__dropdown",onChange:n("issuer")})),e.showPayButton&&e.payButton({status:h,label:t.get("confirmPurchase")}))}function hv(e){var t=e.reference,r=e.totalAmount,a=e.surcharge,n=e.expiresAt,o=e.alternativeReference,i=e.instructionsUrl,l=e.icon,s=e.issuer,c=e.paymentMethodType,d=su(),u=d.loadingContext,p=d.i18n,m=nh({loadingContext:u},c)(s.toLowerCase());return od(Ly,{reference:t,paymentMethodType:c,introduction:p.get("voucher.introduction"),imageUrl:l,issuerImageUrl:m,instructionsUrl:i,amount:r&&p.amount(r.value,r.currency),surcharge:a&&p.amount(a.value,a.currency),voucherDetails:[{label:p.get("voucher.expirationDate"),value:p.date(n)},{label:p.get("voucher.alternativeReference"),value:o}],copyBtn:!0})}mv.defaultProps={data:{},items:[],onChange:function(){}};var fv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data,r=e.issuer,a=e.shopperEmail;return Tc(Tc({},a&&{shopperEmail:a}),{paymentMethod:Tc(Tc({},r&&{issuer:r}),{type:this.props.type||t.type})})},t.prototype.formatProps=function(e){var t,r,a;return Tc(Tc({},e),{issuers:null!==(a=null===(r=null===(t=e.details)||void 0===t?void 0:t.find((function(e){return"issuer"===e.key})))||void 0===r?void 0:r.items)&&void 0!==a?a:e.issuers})},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?od(hv,Tc({ref:function(t){e.componentRef=t},icon:this.icon},this.props)):od(mv,Tc({ref:function(t){e.componentRef=t},items:this.props.issuers},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="dragonpay",t}(pu);function yv(e){var t=$d(null),r=su().i18n,a=Wd("ready"),n=a[0],o=a[1];return this.setStatus=o,this.showValidation=function(){t.current&&t.current.showValidation()},od("div",{className:"adyen-checkout__doku-input__field"},od(xp,{data:e.data,requiredFields:["firstName","lastName","shopperEmail"],onChange:e.onChange,namePrefix:"doku",ref:t}),e.showPayButton&&e.payButton({status:n,label:r.get("confirmPurchase")}))}var bv=function(e){var t=e.reference,r=e.expiresAt,a=e.instructionsUrl,n=e.shopperName,o=e.merchantName,i=e.totalAmount,l=e.paymentMethodType,s=su(),c=s.loadingContext,d=s.i18n;return od(Ly,{paymentMethodType:l,reference:t,introduction:d.get("voucher.introduction.doku"),imageUrl:zd({loadingContext:c})(l),instructionsUrl:a,amount:i&&d.amount(i.value,i.currency),voucherDetails:[{label:d.get("voucher.expirationDate"),value:d.date(r)},{label:d.get("voucher.shopperName"),value:n},{label:d.get("voucher.merchantName"),value:o}],copyBtn:!0})},vv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){return Tc(Tc({},this.state.data),{paymentMethod:{type:this.props.type||t.type}})},Object.defineProperty(t.prototype,"icon",{get:function(){return zd({loadingContext:this.props.loadingContext})(this.props.type)},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?od(bv,Tc({ref:function(t){e.componentRef=t}},this.props)):od(yv,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="doku",t}(pu),gv={socialSecurityNumber:{validate:oy,errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},kv={socialSecurityNumber:function(e){return ny(e)}};function Cv(e){var t=e.errors,r=e.value,a=e.onInput,n=e.onChange,o=su().i18n,i=Wd(!1),l=i[0],s=i[1];return od("div",{className:Ed("adyen-checkout__fieldset","adyen-checkout__fieldset--sendCopyToEmail",e.classNames)},od(Ou,{classNameModifiers:["sendCopyToEmail"]},sp("boolean",{onChange:function(t){s(t.target.checked),e.onToggle(l)},label:o.get("boleto.sendCopyToEmail"),name:"sendCopyToEmail",value:l})),l&&od(Ou,{label:o.get("shopperEmail"),classNameModifiers:["shopperEmail"],errorMessage:t},sp("emailAddress",{name:"shopperEmail",autoCorrect:"off",spellCheck:!1,value:r,onInput:a,onChange:n})))}function _v(e){var t=e.i18n,r=e.data,a=e.handleChangeFor,n=e.errors,o=e.valid;return od("div",{className:"adyen-checkout__fieldset adyen-checkout__fieldset--address adyen-checkout__fieldset--personalDetails"},od("div",{className:"adyen-checkout__fieldset__title"},t.get("personalDetails")),od("div",{className:"adyen-checkout__fieldset__fields"},od(Ou,{label:t.get("firstName"),classNameModifiers:["firstName","col-50"],errorMessage:!!n.firstName},sp("text",{name:"firstName",autocorrect:"off",spellcheck:!1,value:r.firstName,onInput:a("firstName","input"),onChange:a("firstName")})),od(Ou,{label:t.get("lastName"),classNameModifiers:["lastName","col-50"],errorMessage:!!n.lastName},sp("text",{name:"lastName",autocorrect:"off",spellcheck:!1,value:r.lastName,onInput:a("lastName","input"),onChange:a("lastName")})),od(ty,{data:r.socialSecurityNumber,error:n.socialSecurityNumber,valid:o.socialSecurityNumber,onInput:a("socialSecurityNumber","input"),onChange:a("socialSecurityNumber")})))}function Nv(e){var t=su().i18n,r=$d(null),a=bp({schema:["firstName","lastName","socialSecurityNumber","billingAddress","shopperEmail"],defaultData:e.data,rules:gv,formatters:kv}),n=a.handleChangeFor,o=a.triggerValidation,i=a.setSchema,l=a.setData,s=a.setValid,c=a.setErrors,d=a.data,u=a.valid,p=a.errors,m=a.isValid,h=Wd(!1),f=h[0],y=h[1];Zd((function(){var t=Mc(Mc(Mc([],e.personalDetailsRequired?["firstName","lastName","socialSecurityNumber"]:[]),e.billingAddressRequired?["billingAddress"]:[]),f?["shopperEmail"]:[]);i(t)}),[f,e.personalDetailsRequired,e.billingAddressRequired]);var b=Wd("ready"),v=b[0],g=b[1];this.setStatus=g,this.showValidation=function(){o(),e.billingAddressRequired&&r.current.showValidation()},Zd((function(){var t=!e.billingAddressRequired||Boolean(u.billingAddress);e.onChange({data:d,valid:u,errors:p,isValid:m&&t})}),[d,u,p]);var k=Mc([],e.personalDetailsRequired||e.billingAddressRequired||e.showEmailAddress?[]:["standalone"]);return od("div",{className:"adyen-checkout__boleto-input__field"},e.personalDetailsRequired&&od(_v,{i18n:t,data:d,handleChangeFor:n,errors:p,valid:u}),e.billingAddressRequired&&od(Cm,{allowedCountries:["BR"],label:"billingAddress",data:Tc(Tc({},e.data.billingAddress),{country:"BR"}),onChange:function(e){l("billingAddress",e.data),s("billingAddress",e.isValid),c("billingAddress",e.errors)},requiredFields:["country","street","houseNumberOrName","postalCode","city","stateOrProvince"],ref:r}),e.showEmailAddress&&od(Cv,{value:d.shopperEmail,errors:p.shopperEmail,onToggle:function(){return y(!f)},onInput:n("shopperEmail","input"),onChange:n("shopperEmail")}),e.showPayButton&&e.payButton({status:v,label:t.get("boletobancario.btnLabel"),classNameModifiers:k}))}Nv.defaultProps={data:{},showEmailAddress:!0,personalDetailsRequired:!0,billingAddressRequired:!0};var wv=function(e){var t=su(),r=t.i18n,a=t.loadingContext,n=e.reference,o=e.expiresAt,i=e.totalAmount,l=e.paymentMethodType,s=e.downloadUrl,c=n.replace(/[^\d]/g,"").replace(/^(\d{4})(\d{5})\d{1}(\d{10})\d{1}(\d{10})\d{1}(\d{15})$/,"$1$5$2$3$4");return od(Ly,{reference:n,paymentMethodType:"boletobancario",barcode:a+"barcode.shtml?data="+c+"&barcodeType=BT_Int2of5A&fileType=png",introduction:r.get("voucher.introduction"),imageUrl:zd({loadingContext:a})(l),amount:i&&r.amount(i.value,i.currency),voucherDetails:[{label:r.get("voucher.expirationDate"),value:r.date(o)}],downloadUrl:s,copyBtn:!0})},Pv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data,r=void 0===e?{}:e,a=r.billingAddress,n=r.shopperEmail,o=r.firstName,i=r.lastName,l=r.socialSecurityNumber,s=void 0===l?"":l;return Tc(Tc(Tc(Tc({paymentMethod:{type:this.props.type||t.type}},a&&{billingAddress:a}),n&&{shopperEmail:n}),o&&i&&{shopperName:{firstName:o,lastName:i}}),s&&{socialSecurityNumber:ay(s)})},t.prototype.render=function(){return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?od(wv,Tc({ref:this.handleRef,icon:this.icon},this.props)):od(Nv,Tc({ref:this.handleRef},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="boletobancario",t}(pu),Fv=function(e){var t=su(),r=t.i18n,a=t.loadingContext,n=e.alternativeReference,o=e.reference,i=e.expiresAt,l=e.merchantReference,s=e.totalAmount,c=e.paymentMethodType,d=e.downloadUrl,u=a+"barcode.shtml?data="+o+"&barcodeType=BT_Code128C&fileType=png",p=Mc(Mc(Mc([],i?[{label:r.get("voucher.expirationDate"),value:r.date(i)}]:[]),l?[{label:r.get("voucher.shopperReference"),value:l}]:[]),n?[{label:r.get("voucher.alternativeReference"),value:n}]:[]);return od(Ly,{amount:s&&r.amount(s.value,s.currency),barcode:u,copyBtn:!0,downloadUrl:d,imageUrl:zd({loadingContext:a})(c),introduction:r.get("voucher.introduction"),paymentMethodType:"oxxo",reference:o,voucherDetails:p})},Dv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return Tc(Tc({},e),{name:"Oxxo"})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||t.type}}},t.prototype.render=function(){return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.reference?od(Fv,Tc({ref:this.handleRef},this.props)):this.payButton(Tc(Tc({},this.props),{classNameModifiers:["standalone"],label:this.props.i18n.get("continueTo")+" "+this.props.name,onClick:this.submit})))},t.type="oxxo",t}(pu),Av=function(e){var t=su(),r=t.i18n,a=t.loadingContext,n=e.entity,o=e.reference,i=e.expiresAt,l=e.merchantReference,s=e.totalAmount,c=e.paymentMethodType,d=e.downloadUrl,u=Mc(Mc(Mc([],n?[{label:r.get("voucher.entity"),value:n}]:[]),i?[{label:r.get("voucher.expirationDate"),value:r.date(i)}]:[]),l?[{label:r.get("voucher.shopperReference"),value:l}]:[]);return od(Ly,{amount:s&&r.amount(s.value,s.currency),barcode:null,copyBtn:!0,downloadUrl:d,imageUrl:zd({loadingContext:a})(c),introduction:r.get("voucher.introduction"),paymentMethodType:"multibanco",reference:o,voucherDetails:u})},Sv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.handleRef=function(e){t.componentRef=e},t}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(e){return Tc(Tc({},e),{name:e.name||"Multibanco"})},t.prototype.formatData=function(){return{paymentMethod:{type:this.props.type||t.type}}},t.prototype.render=function(){var e=this;return this.props.reference?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Av,Tc({ref:this.handleRef},this.props))):this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(_y,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}})):null},t.type="multibanco",t.defaultProps={showPayButton:!0},t}(pu),xv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="dotpay",t}(oh),Bv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="eps",t}(oh);function Tv(e){var t=e.children,r=e.classNames,a=void 0===r?[]:r,n=e.type,o=void 0===n?"error":n,i=e.icon;return od("div",{className:Ed("adyen-checkout__alert-message","adyen-checkout__alert-message--"+o,a)},i&&od(xu,{className:"adyen-checkout__alert-message__icon",type:i}),t)}function zv(e){e.brand;var t=e.amount,r=e.balance,a=e.transactionLimit,n=zc(e,["brand","amount","balance","transactionLimit"]),o=su().i18n,i=t.value>(null==a?void 0:a.value)?a:t,l=(null==r?void 0:r.value)-(null==i?void 0:i.value);return od("div",{className:"adyen-checkout__giftcard-result"},od("ul",{className:"adyen-checkout__giftcard-result__balance"},od("li",{className:"adyen-checkout__giftcard-result__balance__item"},od("span",{className:"adyen-checkout__giftcard-result__balance__title"},o.get("giftcardBalance")),od("span",{className:"adyen-checkout__giftcard-result__balance__value adyen-checkout__giftcard-result__balance__value--amount"},o.amount(r.value,r.currency))),a&&od("li",{className:"adyen-checkout__giftcard-result__balance__item"},od("span",{className:"adyen-checkout__giftcard-result__balance__title adyen-checkout__giftcard-result__balance__title--transactionLimit"},o.get("giftcardTransactionLimit",{values:{amount:o.amount(a.value,a.currency)}})))),this.props.showPayButton&&this.props.payButton({amount:i,status:n.status,onClick:n.onSubmit}),od("p",{className:"adyen-checkout__giftcard-result__remaining-balance"},o.get("partialPayment.remainingBalance",{values:{amount:o.amount(l,r.currency)}})))}var Iv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={status:"ready",data:{},balance:null,transactionLimit:null,focusedElement:!1,isValid:!1},t.onChange=function(e){t.props.onChange({data:e.data,isValid:e.isSfpValid})},t.showValidation=function(){t.sfp.showValidation()},t.handleFocus=function(e){t.setState({focusedElement:e.currentFocusObject}),!0===e.focus?t.props.onFocus(e):t.props.onBlur(e)},t.setBalance=function(e){var r=e.balance,a=e.transactionLimit;t.setState({balance:r,transactionLimit:a})},t}return Bc(t,e),t.prototype.setStatus=function(e){this.setState({status:e})},t.prototype.render=function(e,t){var r,a=this,n=t.focusedElement,o=t.balance,i=t.transactionLimit,l=su().i18n,s=(null==i?void 0:i.value)<(null==o?void 0:o.value)?i:o,c=(null==s?void 0:s.value)>=(null===(r=this.props.amount)||void 0===r?void 0:r.value);if(s&&c)return od(zv,Tc({balance:o,transactionLimit:i,onSubmit:e.onSubmit},e));var d=function(e){if(e.errors.encryptedCardNumber)return l.get("error.va.gen.01");switch(a.state.status){case"no-balance":return l.get("error.giftcard.no-balance");case"card-error":return l.get("error.giftcard.card-error");case"currency-error":return l.get("error.giftcard.currency-error");default:return null}};return od("div",{className:"adyen-checkout__giftcard"},"error"===this.state.status&&od(Tv,{icon:"cross"},l.get("error.message.unknown")),od(jf,Tc({},this.props,{ref:function(e){a.sfp=e},onChange:this.onChange,onFocus:this.handleFocus,type:hh,render:function(t,r){var a=t.setRootNode,o=t.setFocusOn;return od("div",{ref:a,className:"adyen-checkout__field-wrapper"},od(Ou,{label:l.get("creditCard.numberField.title"),classNameModifiers:Mc(["number"],e.pinRequired?["70"]:["100"]),errorMessage:d(r),focused:"encryptedCardNumber"===n,onFocusField:function(){return o("encryptedCardNumber")},dir:"ltr",name:"encryptedCardNumber"},od(Hf,{encryptedFieldType:"encryptedCardNumber","data-info":'{"length":"15-32", "maskInterval":4}',className:Ed({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cardNumber__input":!0,"adyen-checkout__input--error":d(r),"adyen-checkout__input--focus":"encryptedCardNumber"===n})})),e.pinRequired&&od(Ou,{label:l.get("creditCard.pin.title"),classNameModifiers:["pin","30"],errorMessage:r.errors.encryptedSecurityCode&&l.get(r.errors.encryptedSecurityCode),focused:"encryptedSecurityCode"===n,onFocusField:function(){return o("encryptedSecurityCode")},dir:"ltr",name:"encryptedSecurityCode"},od(Hf,{encryptedFieldType:"encryptedSecurityCode","data-info":'{"length":"3-10", "maskInterval": 0}',className:Ed({"adyen-checkout__input":!0,"adyen-checkout__input--large":!0,"adyen-checkout__card__cvc__input":!0,"adyen-checkout__input--error":r.errors.encryptedSecurityCode,"adyen-checkout__input--focus":"encryptedSecurityCode"===n})})))}})),this.props.showPayButton&&this.props.payButton({status:this.state.status,onClick:this.props.onBalanceCheck,label:l.get("applyGiftcard")}))},t.defaultProps={pinRequired:!0,onChange:function(){},onFocus:function(){},onBlur:function(){}},t}(sd),jv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onBalanceCheck=function(){return t.props.onBalanceCheck?t.isValid?new Promise((function(e,r){t.setStatus("loading"),t.props.onBalanceCheck(e,r,t.formatData())})).then((function(e){var r,a=e.balance,n=e.transactionLimit;if(!a)throw new Error("card-error");if((null==a?void 0:a.currency)!==(null===(r=t.props.amount)||void 0===r?void 0:r.currency))throw new Error("currency-error");if((null==a?void 0:a.value)<=0)throw new Error("no-balance");if(t.componentRef.setBalance({balance:a,transactionLimit:n}),t.props.amount.value>a.value||t.props.amount.value>n.value)return t.props.order?t.submit():t.onOrderRequest(t.data)})).catch((function(e){t.setStatus((null==e?void 0:e.message)||"error"),t.props.onError&&t.props.onError(e)})):(t.showValidation(),!1):t.submit()},t.onOrderRequest=function(e){return new Promise((function(r,a){t.props.onOrderRequest(r,a,e)})).then((function(e){t.setState({order:{orderData:e.orderData,pspReference:e.pspReference}}),t.submit()}))},t.payButton=function(e){return od(uu,Tc({},e))},t}return Bc(t,e),t.prototype.formatProps=function(e){return Tc(Tc({},null==e?void 0:e.configuration),e)},t.prototype.formatData=function(){var e,t;return{paymentMethod:{type:this.constructor.type,brand:this.props.brand,encryptedCardNumber:null===(e=this.state.data)||void 0===e?void 0:e.encryptedCardNumber,encryptedSecurityCode:null===(t=this.state.data)||void 0===t?void 0:t.encryptedSecurityCode}}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"icon",{get:function(){var e;return(null===(e=this.props.brandsConfiguration[this.props.brand])||void 0===e?void 0:e.icon)||this.props.icon||zd({loadingContext:this.props.loadingContext})(this.props.brand)},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Iv,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onBalanceCheck:this.onBalanceCheck,onSubmit:this.submit,payButton:this.payButton})))},t.type="giftcard",t.defaultProps={brandsConfiguration:{}},t}(pu),Mv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.type="vipps",t.defaultProps={type:t.type,showPayButton:!0,name:"Vipps"},t}(Ny),Ov=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="payu_IN_cashcard",t}(oh),Ev=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{showImage:!1})},t.type="payu_IN_nb",t}(oh),Rv=["AT","CH","DE","NL"],Lv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:t.countryCode?[t.countryCode]:Rv})},t.type="ratepay",t}(Dm),Vv=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc({shouldRedirectOnMobile:!0,delay:2e3,countdownTime:15,instructions:"swish.pendingMessage"},e.prototype.formatProps.call(this,t))},t.type="swish",t}(iv),Uv={isDropin:!0,onReady:function(){},onComplete:function(){},onCancel:function(){},onError:function(){},onSelect:function(){},onDisableStoredPaymentMethod:null,onChange:function(){},onSubmit:function(){},onAdditionalDetails:function(){},amount:{},installmentOptions:{},paymentMethodsConfiguration:{},openFirstPaymentMethod:!0,openFirstStoredPaymentMethod:!0,showStoredPaymentMethods:!0,showPaymentMethods:!0,showRemoveStoredPaymentMethodButton:!1,showPayButton:!0},Kv=function(e){var t=e.paymentMethodComponent,r=e.isLoaded;return t&&r?od("div",{className:"adyen-checkout__payment-method__details__content"},t):null},Hv={"adyen-checkout__payment-methods-list":"DropinComponent-module_adyen-checkout__payment-methods-list__2T9kQ","adyen-checkout__payment-method":"DropinComponent-module_adyen-checkout__payment-method__2ZClo","adyen-checkout__payment-method__details":"DropinComponent-module_adyen-checkout__payment-method__details__2_jFP","adyen-checkout__payment-method__image":"DropinComponent-module_adyen-checkout__payment-method__image__Fg2uw","adyen-checkout__payment-method__image__wrapper":"DropinComponent-module_adyen-checkout__payment-method__image__wrapper__pTTKr","adyen-checkout__payment-method--selected":"DropinComponent-module_adyen-checkout__payment-method--selected__1zXEA"},qv=["googlepay","paywithgoogle"],Gv=function(e){var t=e.src,r=e.altDescription,a=e.type,n=e.disabled,o=void 0!==n&&n;return od("span",{className:Ed("adyen-checkout__payment-method__image__wrapper",Hv["adyen-checkout__payment-method__image__wrapper"],{"adyen-checkout__payment-method__image__wrapper--outline":!qv.includes(a),"adyen-checkout__payment-method__image__wrapper--disabled":!!o})},od(tp,{className:"adyen-checkout__payment-method__image "+Hv["adyen-checkout__payment-method__image"],src:t,alt:r,focusable:"false"}))},Yv=function(e){var t=e.id,r=e.open,a=e.onDisable,n=e.onCancel,o=su().i18n;return od("div",{id:t,"aria-hidden":!r,className:Ed({"adyen-checkout__payment-method__disable-confirmation":!0,"adyen-checkout__payment-method__disable-confirmation--open":r})},od("div",{className:"adyen-checkout__payment-method__disable-confirmation__content"},o.get("storedPaymentMethod.disable.confirmation"),od("div",{className:"adyen-checkout__payment-method__disable-confirmation__buttons"},od("button",{type:"button",className:Ed("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--remove"),disabled:!r,onClick:a},o.get("storedPaymentMethod.disable.confirmButton")),od("button",{type:"button",className:Ed("adyen-checkout__button","adyen-checkout__payment-method__disable-confirmation__button","adyen-checkout__payment-method__disable-confirmation__button--cancel"),disabled:!r,onClick:n},o.get("storedPaymentMethod.disable.cancelButton")))))},Wv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={showDisableStoredPaymentMethodConfirmation:!1},t.isMouseDown=!1,t.onFocus=function(){t.isMouseDown||t.props.onSelect()},t.onClick=function(){t.props.onSelect()},t.onMouseDown=function(){t.isMouseDown=!0},t.onMouseUp=function(){t.isMouseDown=!1},t.toggleDisableConfirmation=function(){t.setState({showDisableStoredPaymentMethodConfirmation:!t.state.showDisableStoredPaymentMethodConfirmation})},t.onDisableStoredPaymentMethod=function(){t.props.onDisableStoredPaymentMethod(t.props.paymentMethod),t.toggleDisableConfirmation()},t}return Bc(t,e),t.prototype.componentDidMount=function(){var e=this;this.props.paymentMethod.eventEmitter.on("brand",(function(t){e.setState({activeBrand:t.brand})}))},t.prototype.componentWillUnmount=function(){var e=this;this.props.paymentMethod.eventEmitter.off("brand",(function(t){e.setState({activeBrand:t.brand})}))},t.prototype.render=function(e,t){var r,a,n=e.paymentMethod,o=e.isSelected,i=e.isDisabling,l=e.isLoaded,s=e.isLoading,c=e.onSelect,d=e.standalone,u=t.activeBrand,p=void 0===u?null:u,m=su().i18n;if(!n)return null;var h=Ed(((r={"adyen-checkout__payment-method":!0})[Hv["adyen-checkout__payment-method"]]=!0,r["adyen-checkout__payment-method--"+n.props.type]=!0,r["adyen-checkout__payment-method--"+(null!==(a=n.props.fundingSource)&&void 0!==a?a:"credit")]=!0,r["adyen-checkout__payment-method--selected"]=o,r[Hv["adyen-checkout__payment-method--selected"]]=o,r["adyen-checkout__payment-method--loading"]=s,r["adyen-checkout__payment-method--disabling"]=i,r["adyen-checkout__payment-method--confirming"]=this.state.showDisableStoredPaymentMethodConfirmation,r["adyen-checkout__payment-method--standalone"]=d,r[Hv["adyen-checkout__payment-method--loading"]]=s,r[n._id]=!0,r[this.props.className]=!0,r)),f=this.props.showRemovePaymentMethodButton&&n.props.oneClick&&o,y="remove-"+n._id,b="container-"+n._id,v="button-"+n._id,g=!n.props.oneClick&&n.brands&&n.brands.length>0;return od("li",{key:n._id,className:h,onFocus:this.onFocus,onClick:c,onMouseDown:this.onMouseDown,onMouseUp:this.onMouseUp,"aria-labelledby":v},od("div",{className:"adyen-checkout__payment-method__header"},od("button",{className:"adyen-checkout__payment-method__header__title",id:v,"aria-label":n.accessibleName,"aria-expanded":o,"aria-controls":b,onClick:c},od("span",{className:Ed({"adyen-checkout__payment-method__radio":!0,"adyen-checkout__payment-method__radio--selected":o}),"aria-hidden":"true"}),od(Gv,{altDescription:n.props.name,type:n.type,src:n.icon}),od("span",{className:Ed({"adyen-checkout__payment-method__name":!0,"adyen-checkout__payment-method__name--selected":o})},n.displayName)),f&&od("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:this.toggleDisableConfirmation,"aria-expanded":this.state.showDisableStoredPaymentMethodConfirmation,"aria-controls":y},m.get("storedPaymentMethod.disable.button")),g&&od("span",{className:"adyen-checkout__payment-method__brands"},n.brands.map((function(e){return od(Gv,{key:e.name,altDescription:e.name,type:e.name,disabled:p&&e.name!==p,src:e.icon})})))),od("div",{className:"adyen-checkout__payment-method__details "+Hv["adyen-checkout__payment-method__details"],id:b,role:"region","aria-labelledby":v},f&&od(Yv,{id:y,open:this.state.showDisableStoredPaymentMethodConfirmation,onDisable:this.onDisableStoredPaymentMethod,onCancel:this.toggleDisableConfirmation}),od(Kv,{paymentMethodComponent:n.render(),isLoaded:l})))},t.defaultProps={paymentMethod:null,isSelected:!1,isLoaded:!1,isLoading:!1,showDisableStoredPaymentMethodConfirmation:!1,onSelect:function(){}},t}(sd),Jv=function(e){var t,r=e.order,a=e.orderStatus,n=e.onOrderCancel,o=su(),i=o.loadingContext,l=o.i18n;return od("div",null,od("ul",{className:"adyen-checkout__order-payment-methods-list"},null===(t=null==a?void 0:a.paymentMethods)||void 0===t?void 0:t.map((function(e,t){return od("li",{key:e.type+"-"+t,className:"adyen-checkout__order-payment-method"},od("div",{className:"adyen-checkout__order-payment-method__header"},od("div",{className:"adyen-checkout__payment-method__header__title"},od(Gv,{altDescription:e.name,type:e.type,src:zd({loadingContext:i})(e.type)}),"\u2022\u2022\u2022\u2022 ",e.lastFour),n&&od("button",{type:"button",className:"adyen-checkout__button adyen-checkout__button--inline adyen-checkout__button--link",onClick:function(){n({order:r})}},l.get("storedPaymentMethod.disable.button"))),od("div",{className:"adyen-checkout__order-payment-method__details"},od("div",{className:"adyen-checkout__order-payment-method__deducted-amount"},od("div",{className:"adyen-checkout__order-payment-method__deducted-amount__label"},l.get("deductedBalance")),od("div",{className:"adyen-checkout__order-payment-method__deducted-amount__value"},l.amount(e.amount.value,e.amount.currency)))))}))),a.remainingAmount&&od("div",{className:"adyen-checkout__order-remaining-amount"},l.get("partialPayment.warning")," ",od("strong",null,l.amount(a.remainingAmount.value,a.remainingAmount.currency))))},Zv=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.onSelect=function(e){return function(){return t.props.onSelect(e)}},t}return Bc(t,e),t.prototype.componentDidMount=function(){if(this.props.paymentMethods[0]){var e=this.props.paymentMethods[0];(this.props.openFirstStoredPaymentMethod&&!0===Dd(e,"props.oneClick")||this.props.openFirstPaymentMethod)&&this.onSelect(e)()}},t.prototype.render=function(e){var t,r=this,a=e.paymentMethods,n=e.activePaymentMethod,o=e.cachedPaymentMethods,i=e.isLoading,l=Ed(((t={})[Hv["adyen-checkout__payment-methods-list"]]=!0,t["adyen-checkout__payment-methods-list"]=!0,t["adyen-checkout__payment-methods-list--loading"]=i,t));return od(ld,null,this.props.orderStatus&&od(Jv,{order:this.props.order,orderStatus:this.props.orderStatus,onOrderCancel:this.props.onOrderCancel}),od("ul",{className:l},a.map((function(e,t,l){var s=n&&n._id===e._id,c=e._id in o,d=n&&l[t+1]&&n._id===l[t+1]._id;return od(Wv,{className:Ed({"adyen-checkout__payment-method--next-selected":d}),standalone:1===a.length,paymentMethod:e,isSelected:s,isDisabling:s&&r.props.isDisabling,isLoaded:c,isLoading:i,onSelect:r.onSelect(e),key:e._id,showRemovePaymentMethodButton:r.props.showRemovePaymentMethodButton,onDisableStoredPaymentMethod:r.props.onDisableStoredPaymentMethod})}))))},t.defaultProps={paymentMethods:[],activePaymentMethod:null,cachedPaymentMethods:{},orderStatus:null,onSelect:function(){},onDisableStoredPaymentMethod:function(){},isDisabling:!1,isLoading:!1},t}(sd),Qv=function(e){var t=e.message,r=su(),a=r.i18n,n=r.loadingContext;return od("div",{className:"adyen-checkout__status adyen-checkout__status--success"},od(tp,{height:"88",className:"adyen-checkout__status__icon",src:zd({loadingContext:n,extension:"gif",imageFolder:"components/"})("success"),alt:a.get(t||"creditCard.success")}),od("span",{className:"adyen-checkout__status__text"},a.get(t||"creditCard.success")))},$v=function(e){var t=e.message,r=su(),a=r.loadingContext,n=r.i18n;return od("div",{className:"adyen-checkout__status adyen-checkout__status--error"},od(tp,{className:"adyen-checkout__status__icon",src:zd({loadingContext:a,extension:"gif",imageFolder:"components/"})("error"),alt:n.get(t||"error.message.unknown"),height:"88"}),od("span",{className:"adyen-checkout__status__text"},n.get(t||"error.message.unknown")))};function Xv(e,t){var r={path:"v1/order/status?clientKey="+e.clientKey,loadingContext:e.loadingContext};return fm(r,{orderData:t.orderData})}var eg=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={elements:[],orderStatus:null,isDisabling:!1,status:{type:"loading"},activePaymentMethod:null,cachedPaymentMethods:{}},t.prepareDropinData=function(){var e=t.props,r=e.order,a=e.clientKey,n=e.loadingContext,o=t.props.onCreateElements(),i=o[0],l=o[1],s=r?Xv({clientKey:a,loadingContext:n},r):null;Promise.all([i,l,s]).then((function(e){var r=e[0],a=e[1],n=e[2];t.setState({elements:Mc(Mc([],r),a),orderStatus:n}),t.setStatus({type:"ready"}),t.props.modules.analytics&&t.props.modules.analytics.send({containerWidth:t.base&&t.base.offsetWidth,paymentMethods:a.map((function(e){return e.props.type})),component:"dropin",flavor:"dropin"})}))},t.setStatus=function(e){t.setState({status:e})},t.setActivePaymentMethod=function(e){t.setState((function(t){var r;return{activePaymentMethod:e,cachedPaymentMethods:Tc(Tc({},t.cachedPaymentMethods),(r={},r[e._id]=!0,r))}}))},t.handleOnSelectPaymentMethod=function(e){var r=t.state.activePaymentMethod;t.setActivePaymentMethod(e),(r&&r._id!==e._id||!r)&&t.props.onSelect(e)},t.handleDisableStoredPaymentMethod=function(e){t.setState({isDisabling:!0}),new Promise((function(r,a){return t.props.onDisableStoredPaymentMethod(e.props.storedPaymentMethodId,r,a)})).then((function(){t.setState((function(t){return{elements:t.elements.filter((function(t){return t._id!==e._id}))}})),t.setState({isDisabling:!1})})).catch((function(){t.setState({isDisabling:!1})}))},t}return Bc(t,e),t.prototype.componentDidMount=function(){this.prepareDropinData()},t.prototype.componentDidUpdate=function(e,t){t.status.type!==this.state.status.type&&this.state.activePaymentMethod&&this.state.activePaymentMethod.setStatus(this.state.status.type),"ready"===this.state.status.type&&"ready"!==t.status.type&&this.props.onReady&&this.props.onReady()},t.prototype.closeActivePaymentMethod=function(){this.setState({activePaymentMethod:null})},t.prototype.render=function(e,t){var r,a,n=t.elements,o=t.status,i=t.activePaymentMethod,l=t.cachedPaymentMethods,s="loading"===o.type,c="redirect"===o.type;switch(o.type){case"success":return od(Qv,{message:null===(r=o.props)||void 0===r?void 0:r.message});case"error":return od($v,{message:null===(a=o.props)||void 0===a?void 0:a.message});case"custom":return o.props.component.render();default:return od("div",{className:"adyen-checkout__dropin adyen-checkout__dropin--"+o.type},c&&o.props.component&&o.props.component.render(),s&&o.props&&o.props.component&&o.props.component.render(),n&&!!n.length&&od(Zv,{isLoading:s||c,isDisabling:this.state.isDisabling,paymentMethods:n,activePaymentMethod:i,cachedPaymentMethods:l,order:this.props.order,orderStatus:this.state.orderStatus,onOrderCancel:this.props.onOrderCancel,onSelect:this.handleOnSelectPaymentMethod,openFirstPaymentMethod:this.props.openFirstPaymentMethod,openFirstStoredPaymentMethod:this.props.openFirstStoredPaymentMethod,onDisableStoredPaymentMethod:this.handleDisableStoredPaymentMethod,showRemovePaymentMethodButton:this.props.showRemovePaymentMethodButton}))}},t}(sd);var tg=["androidpay","samsungpay"],rg=function(e){return!tg.includes(e.constructor.type)},ag=function(e){return!!e},ng=function(e){if(e.isAvailable){var t=new Promise((function(e,t){return setTimeout(t,5e3)}));return Promise.race([e.isAvailable(),t])}return Promise.resolve(!!e)},og=function(e,t,r){void 0===e&&(e=[]);var a=e.map((function(e){return r(e,t)})).filter(ag).filter(rg),n=a.map(ng).map((function(e){return e.catch((function(e){return e}))}));return Promise.all(n).then((function(e){return a.filter((function(t,r){return!0===e[r]}))}))},ig=function(e){function t(t){var r=e.call(this,t)||this;return r.dropinRef=null,r.handleSubmit=function(){var e=r.activePaymentMethod,t=e.data,a=e.isValid;return a?(!1!==r.props.setStatusAutomatically&&r.setStatus("loading"),r.props.onSubmit({data:t,isValid:a},r)):(r.showValidation(),!1)},r.handleCreate=function(){var e=r.props,t=e.paymentMethods,a=e.storedPaymentMethods,n=e.showStoredPaymentMethods,o=e.showPaymentMethods,i=e._parentInstance,l=function(e){return{elementRef:e.elementRef,showPayButton:e.showPayButton,isDropin:!0}}(Tc(Tc({},r.props),{elementRef:r.elementRef}));return[n?function(e,t,r){return void 0===e&&(e=[]),og(e,Tc(Tc({},t),{oneClick:!0}),r)}(a,l,null==i?void 0:i.create):[],o?og(t,l,null==i?void 0:i.create):[]]},r.submit=r.submit.bind(r),r}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.dropinRef&&!!this.dropinRef.state.activePaymentMethod&&!!this.dropinRef.state.activePaymentMethod.isValid},enumerable:!1,configurable:!0}),t.prototype.showValidation=function(){return this.dropinRef.state.activePaymentMethod&&this.dropinRef.state.activePaymentMethod.showValidation(),this},t.prototype.setStatus=function(e,t){var r;return void 0===t&&(t={}),null===(r=this.dropinRef)||void 0===r||r.setStatus({type:e,props:t}),this},Object.defineProperty(t.prototype,"activePaymentMethod",{get:function(){var e,t;return(null===(e=this.dropinRef)||void 0===e?void 0:e.state)||(null===(t=this.dropinRef)||void 0===t?void 0:t.state.activePaymentMethod)?this.dropinRef.state.activePaymentMethod:null},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"data",{get:function(){return this.activePaymentMethod?this.dropinRef.state.activePaymentMethod.data:null},enumerable:!1,configurable:!0}),t.prototype.submit=function(){var e=this;if(!this.activePaymentMethod)throw new Error("No active payment method.");this.activePaymentMethod.startPayment().then(this.handleSubmit).catch((function(t){return e.props.onError(t)}))},t.prototype.handleAction=function(e,t){var r,a=this;if(void 0===t&&(t={}),!e||!e.type)throw new Error("Invalid Action");if("redirect"!==e.type&&(null===(r=this.activePaymentMethod)||void 0===r?void 0:r.updateWithAction))return this.activePaymentMethod.updateWithAction(e);var n=this.props._parentInstance.createFromAction(e,Tc(Tc({},t),{elementRef:this.elementRef,onAdditionalDetails:function(e){return a.props.onAdditionalDetails(e,a.elementRef)},isDropin:!0}));return n?this.setStatus(n.props.statusType,{component:n}):null},t.prototype.closeActivePaymentMethod=function(){this.dropinRef.closeActivePaymentMethod()},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(eg,Tc({},this.props,{onChange:this.setState,onSubmit:this.handleSubmit,elementRef:this.elementRef,onCreateElements:this.handleCreate,ref:function(t){e.dropinRef=t}})))},t.type="dropin",t.defaultProps=Uv,t}(pu),lg="AchInput-module_sf-input__wrapper__1V7mk",sg="AchInput-module_adyen-checkout__input__1SeSl",cg=function(e){var t,r=e.id,a=e.dataInfo,n=e.className,o=void 0===n?"":n,i=e.label,l=e.focused,s=e.filled,c=e.errorMessage,d=void 0===c?"":c,u=e.isValid,p=void 0!==u&&u,m=e.onFocusField,h=e.dir,f="encrypted"+(r.charAt(0).toUpperCase()+r.slice(1));return od(Ou,{label:i,focused:l,filled:s,classNameModifiers:[r],onFocusField:function(){return m(f)},errorMessage:d,isValid:p,className:o,dir:h,name:r},od(Hf,{encryptedFieldType:f,"data-info":a,className:Ed((t={"adyen-checkout__input":!0,"adyen-checkout__input--large":!0},t[sg]=!0,t["adyen-checkout__input--error"]=d.length,t["adyen-checkout__input--focus"]=l,t["adyen-checkout__input--valid"]=p,t))}))},dg=function(e){var t=e.focusedElement,r=e.onFocusField,a=e.errors,n=e.valid,o=su().i18n;return od("div",{className:"adyen-checkout__ach-sf__form adyen-checkout__field-wrapper"},od(cg,{id:"bankAccountNumber",focused:"encryptedBankAccountNumber"===t,isValid:!!n.encryptedBankAccountNumber,label:o.get("ach.accountNumberField.title"),onFocusField:r,filled:!!a.encryptedBankAccountNumber||!!n.encryptedBankAccountNumber,errorMessage:!!a.encryptedBankAccountNumber&&o.get("ach.accountNumberField.invalid"),dataInfo:'{"length":"4-17", "maskInterval": 4}',className:"adyen-checkout__field--50",dir:"ltr"}),od(cg,{id:"bankLocationId",focused:"encryptedBankLocationId"===t,isValid:!!n.encryptedBankLocationId,label:o.get("ach.accountLocationField.title"),onFocusField:r,filled:!!a.encryptedBankLocationId||!!n.encryptedBankLocationId,errorMessage:!!a.encryptedBankLocationId&&o.get("ach.accountLocationField.invalid"),dataInfo:'{"length":9}',className:"adyen-checkout__field--50",dir:"ltr"}))},ug={base:{caretColor:"#0066FF"}};function pg(e,t){return void 0===t&&(t=!1),!t||!!e&&"string"==typeof e&&e.trim().length>0}function mg(e){var t=this,r=su().i18n,a=e.hasHolderName&&(e.holderName||e.data.holderName),n=Wd({}),o=n[0],i=n[1],l=Wd(Tc({},e.holderNameRequired&&{holderName:a})),s=l[0],c=l[1],d=Wd(Tc({},e.hasHolderName&&{holderName:e.holderName||e.data.holderName})),u=d[0],p=d[1],m=Wd(e.billingAddressRequired?e.data.billingAddress:null),h=m[0],f=m[1],y=Wd(!1),b=y[0],v=y[1],g=Wd(""),k=g[0],C=g[1],_=function(e){f(Tc(Tc({},h),e.data)),c(Tc(Tc({},s),{billingAddress:e.isValid}))},N=function(t){var r=t.target.value;p(Tc(Tc({},u),{holderName:r})),i(Tc(Tc({},o),{holderName:!!e.holderNameRequired&&!pg(r)})),c(Tc(Tc({},s),{holderName:!e.holderNameRequired||pg(r,e.holderNameRequired)}))},w=$d(null),P=$d(null),F=Wd("ready"),D=F[0],A=F[1];return this.setStatus=function(e){A(e)},this.showValidation=function(){w.current.showValidation(),e.holderNameRequired&&!s.holderName&&i(Tc(Tc({},o),{holderName:!0})),P.current&&P.current.showValidation()},Zd((function(){return t.setFocusOn=w.current.setFocusOn,t.updateStyles=w.current.updateStyles,function(){w.current.destroy()}}),[]),Zd((function(){var t=pg(u.holderName,e.holderNameRequired),r=b,a=!e.billingAddressRequired||Boolean(s.billingAddress),n=r&&t&&a;e.onChange({data:u,isValid:n,billingAddress:h})}),[u,s,o]),od("div",{className:"adyen-checkout__ach"},od(jf,Tc({ref:w},e,{styles:Tc(Tc({},ug),e.styles),onChange:function(t){var r=t,a=r.autoCompleteName?r.autoCompleteName:u.holderName;p(Tc(Tc(Tc({},u),r.data),{holderName:a})),i(Tc(Tc({},o),r.errors)),c(Tc(Tc(Tc({},s),r.valid),{holderName:!e.holderNameRequired||pg(a,e.holderNameRequired)})),v(r.isSfpValid)},onFocus:function(t){var r=!0===t.focus;C(t.currentFocusObject),r?e.onFocus(t):e.onBlur(t)},render:function(t,a){var n=t.setRootNode,i=t.setFocusOn;return od("div",{ref:n,className:"adyen-checkout__ach-input "+lg},od(Uf,{status:a.status},od("div",{className:Ed(["adyen-checkout__fieldset","adyen-checkout__fieldset--ach"])},od("div",{className:"adyen-checkout__fieldset__title"},r.get("ach.bankAccount")),e.hasHolderName&&od(Ou,{label:r.get("ach.accountHolderNameField.title"),className:"adyen-checkout__pm__holderName",errorMessage:!!o.holderName&&r.get("ach.accountHolderNameField.invalid"),isValid:!!s.holderName,name:"holderName"},sp("text",{className:"adyen-checkout__pm__holderName__input "+sg,placeholder:e.placeholders.holderName||r.get("ach.accountHolderNameField.placeholder"),value:u.holderName,required:e.holderNameRequired,onInput:N})),od(dg,{focusedElement:k,onFocusField:i,errors:a.errors,valid:a.valid})),e.billingAddressRequired&&od(Cm,{label:"billingAddress",data:h,onChange:_,allowedCountries:e.billingAddressAllowedCountries,requiredFields:e.billingAddressRequiredFields,ref:P})))}})),e.showPayButton&&e.payButton({status:D,label:r.get("confirmPurchase")}))}mg.defaultProps={details:[],type:"ach",hasHolderName:!0,holderNameRequired:!0,billingAddressRequired:!0,billingAddressAllowedCountries:["US","PR"],onLoad:function(){},onConfigSuccess:function(){},onAllValid:function(){},onFieldValid:function(){},onBrand:function(){},onError:function(){},onBinValue:function(){},onBlur:function(){},onFocus:function(){},onChange:function(){},holderName:"",data:{holderName:"",billingAddress:{}},styles:{},placeholders:{}};var hg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){var t;return Tc(Tc({},e),{holderNameRequired:null!==(t=e.hasHolderName)&&void 0!==t?t:e.holderNameRequired})},t.prototype.formatData=function(){var e,r=Tc(Tc({type:t.type},this.state.data),{ownerName:null===(e=this.state.data)||void 0===e?void 0:e.holderName});return delete r.holderName,Tc({paymentMethod:r},this.state.billingAddress&&{billingAddress:this.state.billingAddress})},t.prototype.updateStyles=function(e){return this.componentRef&&this.componentRef.updateStyles&&this.componentRef.updateStyles(e),this},t.prototype.setFocusOn=function(e){return this.componentRef&&this.componentRef.setFocusOn&&this.componentRef.setFocusOn(e),this},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(mg,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="ach",t}(pu),fg=/^[+]*[0-9]{1,4}[\s/0-9]*$/;function yg(e){var t=su().i18n,r=bp({schema:["telephoneNumber"],defaultData:e.data,rules:{telephoneNumber:{validate:function(e){return fg.test(e)&&e.length>=7},errorMessage:"mobileNumber.invalid",modes:["blur"]}},formatters:{telephoneNumber:function(e){return e.replace(/[^0-9+\s]/g,"")}}}),a=r.handleChangeFor,n=r.triggerValidation,o=r.data,i=r.valid,l=r.errors,s=r.isValid,c=Wd("ready"),d=c[0],u=c[1];return this.setStatus=u,this.showValidation=n,Zd((function(){e.onChange({data:o,valid:i,errors:l,isValid:s})}),[o,i,l,s]),od("div",{className:"adyen-checkout__mb-way"},od(Ou,{errorMessage:!!l.telephoneNumber&&t.get("mobileNumber.invalid"),label:t.get("mobileNumber"),className:Ed("adyen-checkout__input--phone-number"),isValid:i.telephoneNumber,dir:"ltr",name:"telephoneNumber"},sp("tel",{value:o.telephoneNumber,className:"adyen-checkout__pm__phoneNumber__input",placeholder:e.placeholders.telephoneNumber,required:!0,autoCorrect:"off",onChange:a("telephoneNumber","blur"),onInput:a("telephoneNumber","input")})),e.showPayButton&&e.payButton({status:d,label:t.get("confirmPurchase")}))}yg.defaultProps={onChange:function(){}};var bg=2e3,vg=15,gg=6e4,kg=1e4,Cg="mbway",_g="mbway.confirmPayment",Ng="await.waitForConfirmation",wg=!1;function Pg(e){var t=this,r=su(),a=r.i18n,n=r.loadingContext,o=Wd(!1),i=o[0],l=o[1],s=Wd(!1),c=s[0],d=s[1],u=Wd(!0),p=u[0],m=u[1],h=Wd(e.delay),f=h[0],y=h[1],b=Wd(100),v=b[0],g=b[1],k=Wd(0),C=k[0],_=k[1],N=Wd(!1),w=N[0],P=N[1],F=Wd(null),D=F[0],A=F[1],S=function(){rv(e.paymentData,e.clientKey,n).then(nv).catch((function(e){var r=e.message,a=zc(e,["message"]);return{type:"network-error",props:Tc(Tc({},r&&{message:t.props.i18n.get(r)}),a)}})).then((function(r){switch(r.type){case"success":!function(r){l(!0);var a={data:{details:{payload:r.props.payload},paymentData:e.paymentData}};e.onComplete(a,t)}(r);break;case"error":!function(r){d(!0);var a={data:{details:{payload:r.props.payload},paymentData:e.paymentData}};e.onComplete(a,t)}(r);break;default:m(!1)}}))};Zd((function(){var r=e.shouldRedirectOnMobile,a=e.url,n=window.matchMedia("(max-width: 768px)").matches&&/Android|iPhone|iPod/.test(navigator.userAgent);return r&&a&&n?t.redirectToApp(a,S):S(),function(){clearTimeout(D)}}),[]),Zd((function(){if(c)return clearTimeout(D);if(i)return clearTimeout(D);if(!p){A(setTimeout((function(){S();var t=C+f;_(t),t>=e.throttleTime&&!w&&(y(e.throttleInterval),P(!0))}),f))}}),[p,C,c,i]);var x=function(e,t){return od("div",{className:"adyen-checkout__await adyen-checkout__await--result"},od("img",{className:"adyen-checkout__await__icon adyen-checkout__await__icon--result",src:zd({loadingContext:n,imageFolder:"components/"})(e),alt:a.get(t)}),od("div",{className:"adyen-checkout__await__subtitle adyen-checkout__await__subtitle--result"},a.get(t)))};if(c)return x("error","error.subtitle.payment");if(i)return x("success","creditCard.success");if(p)return od("div",{className:"adyen-checkout__await"},e.brandLogo&&od("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),od(Rd,{inline:!1,size:"large"}));var B=a.get("wechatpay.timetopay").split("%@");return od("div",{className:Ed("adyen-checkout__await","adyen-checkout__await--"+e.type,e.classNameModifiers.map((function(e){return"adyen-checkout__await--"+e})))},e.brandLogo&&od("img",{src:e.brandLogo,alt:e.type,className:"adyen-checkout__await__brand-logo"}),od("div",{className:"adyen-checkout__await__subtitle"},e.messageText),od("div",{className:"adyen-checkout__await__indicator-holder"},od("div",{className:"adyen-checkout__await__indicator-spinner"},od(Rd,{inline:!1,size:"medium"})),od("div",{className:"adyen-checkout__await__indicator-text"},e.awaitText)),e.showCountdownTimer&&od("div",{className:"adyen-checkout__await__countdown-holder"},od("div",{className:"adyen-checkout__await__progress"},od("span",{className:"adyen-checkout__await__percentage",style:{width:v+"%"}})),od("div",{className:"adyen-checkout__await__countdown"},B[0],"\xa0",od(tv,{minutesFromNow:e.countdownTime,onTick:function(e){g(e.percentage)},onCompleted:function(){d(!0),clearTimeout(D);e.onError({type:"error",props:{errorMessage:"Payment Expired"}},t)}}),"\xa0",B[1])),e.url&&od("div",{className:"adyen-checkout__await__app-link"},od("span",{className:"adyen-checkout__await__separator__label"},a.get("or")),od(cu,{classNameModifiers:["await"],onClick:function(){return r=e.url,void 0===a&&(a=function(){}),setTimeout((function(){var r=e.type+" App was not found";e.onError(r,t),a()}),25),void window.location.assign(r);var r,a},label:a.get("openApp")})))}Pg.defaultProps={countdownTime:15,onError:function(){},onComplete:function(){},throttleTime:6e4,throttleInterval:1e4,showCountdownTimer:!0,classNameModifiers:[],shouldRedirectOnMobile:!1,url:null};var Fg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(e){var t=e.data,r=void 0===t?{}:t,a=e.placeholders,n=void 0===a?{}:a;return Tc(Tc({},e),{data:{telephoneNumber:r.telephoneNumber||r.phoneNumber},placeholders:{telephoneNumber:n.telephoneNumber||n.phoneNumber||"+351 932 123 456"}})},t.prototype.formatData=function(){var e;return{paymentMethod:Tc({type:t.type},(null===(e=this.state.data)||void 0===e?void 0:e.telephoneNumber)&&{telephoneNumber:this.state.data.telephoneNumber})}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"displayName",{get:function(){return this.props.name},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.paymentData?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Pg,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:Cg,messageText:this.props.i18n.get(_g),awaitText:this.props.i18n.get(Ng),showCountdownTimer:wg,delay:bg,countdownTime:vg,throttleTime:gg,throttleInterval:kg})):od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(yg,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="mbway",t}(pu);function Dg(e){var t=this,r=su(),a=r.i18n,n=r.loadingContext,o=bp({schema:["blikCode"],rules:{blikCode:{validate:function(e){return 6===(null==e?void 0:e.length)},errorMessage:"blik.invalid",modes:["blur"]}}}),i=o.handleChangeFor,l=o.triggerValidation,s=o.data,c=o.valid,d=o.errors,u=o.isValid;Zd((function(){e.onChange({data:s,errors:d,valid:c,isValid:u},t)}),[s,c,d,u]);var p=Wd("ready"),m=p[0],h=p[1];return this.setStatus=h,this.showValidation=l,od("div",{className:"adyen-checkout__blik"},od("p",{className:"adyen-checkout__blik__helper"},a.get("blik.help")),od(Ou,{errorMessage:!!d.blikCode&&a.get(d.blikCode.errorMessage),label:a.get("blik.code"),classNameModifiers:["blikCode","50"],isValid:c.blikCode,dir:"ltr"},sp("text",{value:s.blikCode,name:"blikCode",spellcheck:!1,required:!0,autocorrect:"off",onInput:i("blikCode","input"),onChange:i("blikCode","blur"),placeholder:"123456",maxLength:6})),e.showPayButton&&e.payButton({status:m,icon:zd({loadingContext:n,imageFolder:"components/"})("lock")}))}Dg.defaultProps={data:{blikCode:""}};var Ag=2e3,Sg=15,xg=6e4,Bg=1e4,Tg="blik",zg="blik.confirmPayment",Ig="await.waitForConfirmation",jg=!1,Mg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatData=function(){var e=!!this.props.storedPaymentMethodId;return{paymentMethod:Tc(Tc({type:t.type},!e&&{blikCode:this.state.data.blikCode}),e&&{storedPaymentMethodId:this.props.storedPaymentMethodId})}},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.props.storedPaymentMethodId||!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return this.props.paymentData?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Pg,{ref:function(t){e.componentRef=t},clientKey:this.props.clientKey,paymentData:this.props.paymentData,onError:this.props.onError,onComplete:this.onComplete,brandLogo:this.icon,type:Tg,messageText:this.props.i18n.get(zg),awaitText:this.props.i18n.get(Ig),showCountdownTimer:jg,delay:Ag,countdownTime:Sg,throttleTime:xg,throttleInterval:Bg})):od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.storedPaymentMethodId?od(_y,{name:this.displayName,amount:this.props.amount,payButton:this.payButton,onSubmit:this.submit,ref:function(t){e.componentRef=t}}):od(Dg,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton})))},t.type="blik",t}(pu);function Og(e){var t=e.reference,r=e.totalAmount,a=e.paymentMethodType,n=su(),o=n.loadingContext,i=n.i18n;return od(Ly,{paymentMethodType:a,introduction:i.get("bankTransfer.instructions"),imageUrl:zd({loadingContext:o})(a),amount:r&&i.amount(r.value,r.currency),voucherDetails:[{label:i.get("bankTransfer.beneficiary"),value:e.beneficiary},{label:i.get("bankTransfer.iban"),value:e.iban},{label:i.get("bankTransfer.bic"),value:e.bic},{label:i.get("bankTransfer.reference"),value:t}]})}function Eg(e){var t=su().i18n,r=Wd(!1),a=r[0],n=r[1],o=bp({schema:[],defaultData:e.data}),i=o.handleChangeFor,l=o.triggerValidation,s=o.data,c=o.valid,d=o.errors,u=o.isValid,p=o.setSchema;return Zd((function(){p(a?["shopperEmail"]:[])}),[a]),this.showValidation=l,Zd((function(){e.onChange({data:s,errors:d,valid:c,isValid:u})}),[s,c,d,a,u]),od("div",{className:"adyen-checkout__bankTransfer"},od("p",{className:"adyen-checkout__bankTransfer__introduction"},t.get("bankTransfer.introduction")),od(Cv,{classNames:"adyen-checkout__bankTransfer__emailField",value:s.shopperEmail,errors:d.shopperEmail,onToggle:function(){return n(!a)},onInput:i("shopperEmail","input"),onChange:i("shopperEmail","blur")}))}var Rg=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.state={isValid:!t.props.showEmailAddress,data:{}},t.handleRef=function(e){t.componentRef=e},t}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){var e=this.state.data.shopperEmail;return Tc({paymentMethod:{type:t.type}},e&&{shopperEmail:e})},t.prototype.render=function(){return this.props.reference?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Og,Tc({ref:this.handleRef},this.props))):this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.showEmailAddress&&od(Eg,Tc({ref:this.handleRef},this.props,{onChange:this.setState})),od(_y,Tc({},this.props,{name:this.displayName,onSubmit:this.submit,payButton:this.payButton}))):null},t.type="bankTransfer_IBAN",t.defaultProps={showPayButton:!0,showEmailAddress:!0},t}(pu),Lg=["CA","US"],Vg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),t.prototype.formatProps=function(t){return Tc(Tc({},e.prototype.formatProps.call(this,t)),{allowedCountries:Lg,personalDetailsRequiredFields:["firstName","lastName","telephoneNumber","shopperEmail"]})},t.type="affirm",t}(Dm),Ug={socialSecurityNumber:{validate:oy,errorMessage:"",modes:["blur"]},default:{validate:function(e){return!!e&&e.length>0},errorMessage:"",modes:["blur"]}},Kg={socialSecurityNumber:function(e){return ny(e)}};function Hg(e){var t=su().i18n,r=["firstName","lastName","socialSecurityNumber"],a=bp({schema:r,defaultData:e.data,rules:Ug,formatters:Kg}),n=a.handleChangeFor,o=a.triggerValidation,i=a.setSchema,l=a.data,s=a.valid,c=a.errors,d=a.isValid;Zd((function(){var t=e.personalDetailsRequired?Mc([],r):[];i(t)}),[e.personalDetailsRequired]);var u=Wd("ready"),p=u[0],m=u[1];this.setStatus=m,this.showValidation=function(){o()},Zd((function(){e.onChange({data:l,valid:s,errors:c,isValid:d})}),[l,s,c]);var h=e.personalDetailsRequired?[]:["standalone"];return od("div",{className:"adyen-checkout__pix-input__field"},e.personalDetailsRequired&&od(_v,{i18n:t,data:l,handleChangeFor:n,errors:c,valid:s}),e.showPayButton&&e.payButton({status:p,label:t.get("continueTo")+" "+e.name,classNameModifiers:h}))}Hg.defaultProps={data:{},personalDetailsRequired:!1};var qg=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.formatProps=function(t){return Tc({delay:2e3,countdownTime:15,copyBtn:!0,introduction:"pix.instructions"},e.prototype.formatProps.call(this,t))},t.prototype.formatData=function(){var e=this.state.data,t=void 0===e?{}:e,r=t.firstName,a=t.lastName,n=t.socialSecurityNumber,o=void 0===n?"":n;return Tc(Tc({paymentMethod:{type:this.props.type||this.constructor.type}},r&&a&&{shopperName:{firstName:r,lastName:a}}),o&&{socialSecurityNumber:ay(o)})},t.prototype.render=function(){var e=this;return this.props.paymentData?this.renderQRCode():this.props.showPayButton?od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Hg,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,onSubmit:this.submit,payButton:this.payButton}))):null},t.type="pix",t.defaultProps=Tc({personalDetailsRequired:!1},iv.defaultProps),t}(iv),Gg=/^(\d){1,8}$/,Yg=/^(\d){6}$/,Wg=/[^0-9]/g,Jg={bankAccountNumber:{modes:["blur","input"],validate:function(e){return!!e&&Gg.test(e)}},bankLocationId:[{modes:["input"],validate:function(e){return!!e&&/^(\d){1,6}$/.test(e)}},{modes:["blur"],validate:function(e){return!!e&&Yg.test(e)}}],amountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},accountConsentCheckbox:{modes:["blur"],validate:function(e){return!!e}},default:{modes:["blur"],validate:function(e){return!!e&&e.length>0}}},Zg={bankAccountNumber:function(e){return e.replace(Wg,"")},bankLocationId:function(e){return e.replace(Wg,"")}},Qg="enter-data",$g="confirm-data";function Xg(e){var t,r,a=this,n=su().i18n,o=bp({schema:["holderName","bankAccountNumber","bankLocationId","shopperEmail","amountConsentCheckbox","accountConsentCheckbox"],defaultData:e.data,formatters:Zg,rules:Jg}),i=o.handleChangeFor,l=o.triggerValidation,s=o.data,c=o.valid,d=o.errors,u=o.isValid,p=Wd(Qg),m=p[0],h=p[1];this.setStatus=h,this.showValidation=l;return Zd((function(){e.onChange({data:s,valid:c,errors:d,isValid:u})}),[s,c,d,u]),od("div",{className:Ed({"adyen-checkout__bacs":!0,"adyen-checkout__bacs--confirm":m===$g||"loading"===m})},m==$g&&od("div",{className:Ed({"adyen-checkout__bacs--edit":!0,"adyen-checkout__bacs--edit-dropin":e.isDropin})},sp("text",{name:"bacsEdit",className:"adyen-checkout__bacs--edit-button",value:n.get("edit"),"aria-label":n.get("edit"),readonly:!0,onClick:function(){return a.setStatus(Qg)}})),od(Ou,{className:Ed({"adyen-checkout__bacs--holder-name":!0,"adyen-checkout__field--inactive":m===$g||"loading"===m}),label:n.get("bacs.accountHolderName"),errorMessage:!!d.holderName&&n.get("bacs.accountHolderName.invalid"),isValid:c.holderName,name:"accountHolderName"},sp("text",{name:"bacs.accountHolderName",className:"adyen-checkout__bacs-input--holder-name",placeholder:e.placeholders.holderName,value:s.holderName,"aria-invalid":!c.holderName,"aria-label":n.get("bacs.accountHolderName"),"aria-required":"true",required:!0,readonly:m===$g||"loading"===m,autocorrect:"off",onChange:i("holderName","blur"),onInput:i("holderName","input")})),od("div",{className:"adyen-checkout__bacs__num-id adyen-checkout__field-wrapper"},od(Ou,{errorMessage:!!d.bankAccountNumber&&n.get("bacs.accountNumber.invalid"),label:n.get("bacs.accountNumber"),className:Ed({"adyen-checkout__bacs--bank-account-number":!0,"adyen-checkout__field--inactive":m===$g||"loading"===m}),classNameModifiers:["col-70"],isValid:c.bankAccountNumber,name:"bankAccountNumber"},sp("text",{value:s.bankAccountNumber,className:"adyen-checkout__bacs-input--bank-account-number",placeholder:e.placeholders.bankAccountNumber,"aria-invalid":!c.bankAccountNumber,"aria-label":n.get("bacs.accountNumber"),"aria-required":"true",required:!0,readonly:m===$g||"loading"===m,autocorrect:"off",onChange:i("bankAccountNumber","blur"),onInput:i("bankAccountNumber","input")})),od(Ou,{errorMessage:!!d.bankLocationId&&n.get("bacs.bankLocationId.invalid"),label:n.get("bacs.bankLocationId"),className:Ed({"adyen-checkout__bacs--bank-location-id":!0,"adyen-checkout__field--inactive":m===$g||"loading"===m}),classNameModifiers:["col-30"],isValid:c.bankLocationId,name:"bankLocationId"},sp("text",{value:s.bankLocationId,className:"adyen-checkout__bacs-input--bank-location-id",placeholder:e.placeholders.bankLocationId,"aria-invalid":!c.bankLocationId,"aria-label":n.get("bacs.bankLocationId"),"aria-required":"true",required:!0,readonly:m===$g||"loading"===m,autocorrect:"off",onChange:i("bankLocationId","blur"),onInput:i("bankLocationId","input")}))),od(Ou,{errorMessage:!!d.shopperEmail&&n.get("shopperEmail.invalid"),label:n.get("shopperEmail"),className:Ed({"adyen-checkout__bacs--shopper-email":!0,"adyen-checkout__field--inactive":m===$g||"loading"===m}),isValid:c.shopperEmail,name:"emailAddress"},sp("emailAddress",{value:s.shopperEmail,name:"shopperEmail",className:"adyen-checkout__bacs-input--shopper-email",classNameModifiers:["large"],placeholder:e.placeholders.shopperEmail,spellcheck:!1,"aria-invalid":!c.shopperEmail,"aria-label":n.get("shopperEmail"),"aria-required":"true",required:!0,readonly:m===$g||"loading"===m,autocorrect:"off",onInput:i("shopperEmail","input"),onChange:i("shopperEmail","blur")})),m===Qg&&od(_m,{classNameModifiers:["amountConsentCheckbox"],errorMessage:!!d.amountConsentCheckbox,label:n.get("bacs.consent.amount"),onChange:i("amountConsentCheckbox"),checked:!!s.amountConsentCheckbox}),m===Qg&&od(_m,{classNameModifiers:["accountConsentCheckbox"],errorMessage:!!d.accountConsentCheckbox,label:n.get("bacs.consent.account"),onChange:i("accountConsentCheckbox"),checked:!!s.accountConsentCheckbox}),e.showPayButton&&e.payButton({status:m,label:m===Qg?n.get("continue"):n.get("bacs.confirm")+" "+((null===(t=e.amount)||void 0===t?void 0:t.value)&&(null===(r=e.amount)||void 0===r?void 0:r.currency)?n.amount(e.amount.value,e.amount.currency):""),icon:zd({loadingContext:e.loadingContext,imageFolder:"components/"})("lock"),onClick:function(){return u?m===Qg?a.setStatus($g):m===$g?e.onSubmit():void 0:a.showValidation()}}))}Xg.defaultProps={data:{},placeholders:{}};var ek=function(e){var t=su(),r=t.i18n,a=t.loadingContext,n=e.url,o=e.paymentMethodType;return od(Ly,{paymentMethodType:o,introduction:r.get("bacs.result.introduction"),imageUrl:zd({loadingContext:a})(o),downloadUrl:n,downloadButtonText:r.get("download.pdf")})},tk=function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.payButton=function(e){return od(uu,Tc({amount:t.props.amount,onClick:t.submit},e))},t}return Bc(t,e),t.prototype.formatData=function(){var e,r,a,n;return Tc({paymentMethod:Tc(Tc(Tc({type:t.type},(null===(e=this.state.data)||void 0===e?void 0:e.holderName)&&{holderName:this.state.data.holderName}),(null===(r=this.state.data)||void 0===r?void 0:r.bankAccountNumber)&&{bankAccountNumber:this.state.data.bankAccountNumber}),(null===(a=this.state.data)||void 0===a?void 0:a.bankLocationId)&&{bankLocationId:this.state.data.bankLocationId})},(null===(n=this.state.data)||void 0===n?void 0:n.shopperEmail)&&{shopperEmail:this.state.data.shopperEmail})},Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},this.props.url?od(ek,{ref:function(t){e.componentRef=t},icon:this.icon,url:this.props.url,paymentMethodType:this.props.paymentMethodType}):od(Xg,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState,payButton:this.payButton,onSubmit:this.submit})))},t.type="directdebit_GB",t}(pu),rk=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(Cm,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState})))},t}(pu),ak=function(e){function t(){return null!==e&&e.apply(this,arguments)||this}return Bc(t,e),Object.defineProperty(t.prototype,"data",{get:function(){return this.state.data},enumerable:!1,configurable:!0}),Object.defineProperty(t.prototype,"isValid",{get:function(){return!!this.state.isValid},enumerable:!1,configurable:!0}),t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(xp,Tc({ref:function(t){e.componentRef=t}},this.props,{onChange:this.setState})))},t}(pu);function nk(e){var t=e.sdkData;e.paymentMethodType;var r=e.payButton,a=zc(e,["sdkData","paymentMethodType","payButton"]),n=$d(null),o=Wd("ready"),i=o[0],l=o[1],s=function(){l("error"),a.onComplete({data:{paymentData:a.paymentData,details:{}}})};return Zd((function(){window.klarnaAsyncCallback=function(){window.Klarna.Payments.init({client_token:t.client_token}),window.Klarna.Payments.load({container:n.current,payment_method_category:t.payment_method_category},(function(e){e.show_form&&!e.error||s()}))};var e=new Hm("https://x.klarnacdn.net/kp/lib/v1/api.js");return e.load(),function(){e.remove()}}),[]),"error"!==i&&"success"!==i?od("div",{className:"adyen-checkout__klarna-widget"},od("div",{ref:n}),r({status:i,disabled:"loading"===i,onClick:function(){l("loading");try{window.Klarna.Payments.authorize({payment_method_category:t.payment_method_category},(function(e){!0===e.approved&&!0===e.show_form?(l("success"),a.onComplete({data:{paymentData:a.paymentData,details:{token:e.authorization_token}}})):e.approved||!0!==e.show_form?s():(l("ready"),a.onError(e))}))}catch(e){s()}}})):null}function ok(e){var t=Wd({sdkData:e.sdkData,paymentMethodType:e.paymentMethodType,paymentData:e.paymentData}),r=t[0],a=t[1],n=Wd("ready"),o=n[0],i=n[1];return this.setAction=a,this.setStatus=i,r.sdkData?od(nk,{sdkData:r.sdkData,paymentMethodType:r.paymentMethodType,paymentData:r.paymentData,payButton:e.payButton,onComplete:e.onComplete,onError:e.onError}):e.showPayButton?e.payButton(Tc(Tc({},e),{status:o,disabled:"loading"===o,classNameModifiers:["standalone"],label:this.props.i18n.get("continueTo")+" "+e.displayName})):null}var ik=function(e){function t(t){var r=e.call(this,t)||this;return r.payButton=function(e){return od(uu,Tc({amount:r.props.amount,onClick:r.submit},e))},r.onComplete=r.onComplete.bind(r),r.updateWithAction=r.updateWithAction.bind(r),r.submit=r.submit.bind(r),r}return Bc(t,e),Object.defineProperty(t.prototype,"isValid",{get:function(){return!0},enumerable:!1,configurable:!0}),t.prototype.formatData=function(){return{paymentMethod:Tc({type:this.type},this.props.useKlarnaWidget?{subtype:"sdk"}:{})}},t.prototype.updateWithAction=function(e){if(e.paymentMethodType!==this.type)throw new Error("Invalid Action");this.componentRef.setAction(e)},t.prototype.render=function(){var e=this;return od(Fm,{i18n:this.props.i18n,loadingContext:this.props.loadingContext},od(ok,Tc({},this.props,{ref:function(t){e.componentRef=t},displayName:this.displayName,onComplete:function(t){return e.props.onAdditionalDetails(t,e.elementRef)},onError:this.props.onError,payButton:this.payButton})))},t.type="klarna",t.defaultProps={useKlarnaWidget:!1},t}(pu),lk={dropin:ig,ach:hg,address:rk,afterpay:xm,afterpay_default:xm,afterpay_b2b:Bm,amazonpay:Ym,amex:hy,applepay:Xm,bankTransfer_IBAN:Rg,bcmc:fy,bcmc_mobile:sv,bcmc_mobile_QR:sv,blik:Mg,billdesk_online:ih,billdesk_wallet:lh,boletobancario:Pv,boletobancario_bancodobrasil:Pv,boletobancario_bradesco:Pv,boletobancario_hsbc:Pv,boletobancario_itau:Pv,boletobancario_santander:Pv,primeiropay_boleto:Pv,card:hy,storedCard:hy,diners:hy,directdebit_GB:tk,discover:hy,doku:vv,doku_alfamart:vv,doku_permata_lite_atm:vv,doku_indomaret:vv,doku_atm_mandiri_va:vv,doku_sinarmas_va:vv,doku_mandiri_va:vv,doku_cimb_va:vv,doku_danamon_va:vv,doku_bri_va:vv,doku_bni_va:vv,doku_bca_va:vv,doku_wallet:vv,donation:ky,dotpay:xv,dragonpay_ebanking:fv,dragonpay_otc_banking:fv,dragonpay_otc_non_banking:fv,dragonpay_otc_philippines:fv,econtext_seven_eleven:Uy,econtext_atm:Uy,econtext_stores:Uy,econtext_online:Uy,entercash:My,eps:Bv,facilypay_3x:Hy,facilypay_4x:qy,facilypay_6x:Gy,facilypay_10x:Yy,facilypay_12x:Wy,giropay:wy,ideal:Jy,jcb:hy,kcp:hy,klarna:ik,klarna_paynow:ik,klarna_account:ik,maestro:hy,mbway:Fg,mc:hy,molpay_ebanking_fpx_MY:cv,molpay_ebanking_TH:dv,molpay_ebanking_VN:uv,openbanking_UK:pv,paypal:ib,payu_IN_cashcard:Ov,payu_IN_nb:Ev,paywithgoogle:jy,personal_details:ak,googlepay:jy,pix:qg,qiwiwallet:ub,ratepay:Lv,redirect:Ny,securedfields:mb,sepadirectdebit:wb,scheme:hy,threeDS2Challenge:Yb,threeDS2DeviceFingerprint:$b,visa:hy,wechatpay:lv,wechatpayQR:lv,oxxo:Dv,multibanco:Sv,giftcard:jv,vipps:Mv,swish:Vv,affirm:Vg,twint:function(e){function t(){var t=null!==e&&e.apply(this,arguments)||this;return t.payButton=function(e){return od(uu,Tc({},e,{label:t.payButtonLabel(),onClick:t.submit}))},t}return Bc(t,e),Object.defineProperty(t.prototype,"displayName",{get:function(){var e=this.props,t=e.i18n,r=e.name;return e.storedPaymentMethodId?r+" "+t.get("twint.saved"):r||this.constructor.type},enumerable:!1,configurable:!0}),t.prototype.payButtonLabel=function(){var e=this.props,t=e.i18n,r=e.amount,a=e.storedPaymentMethodId,n=e.name;return a?du(t,r):t.get("continueTo")+" "+n},t.type="twint",t.defaultProps={type:t.type,showPayButton:!0},t}(Ny),default:null},sk=function(e,t){var r=lk[e]||lk.default;return r?new r(Tc(Tc({},t),{id:e+"-"+Sd()})):null},ck=function(e,t,r){void 0===t&&(t={}),void 0===r&&(r=!1);var a=e;return"scheme"===e&&(a=r?"storedCard":"card"),t[a]||{}};function dk(e){return!this.length||this.indexOf(e.type)>-1}function uk(e){return!this.length||this.indexOf(e.type)<0}function pk(e){return!!e&&!!e.supportedShopperInteractions&&e.supportedShopperInteractions.includes("Ecommerce")}var mk=["scheme","blik","twint"];function hk(e){return!!e&&!!e.type&&mk.includes(e.type)}var fk=function(e){return Tc(Tc({},e),{storedPaymentMethodId:e.id})},yk=function(){function e(e,t){void 0===t&&(t={}),this.paymentMethods=[],this.storedPaymentMethods=[],function(e){var t,r;if("string"==typeof e)throw new Error('paymentMethodsResponse was provided but of an incorrect type (should be an object but a string was provided).Try JSON.parse("{...}") your paymentMethodsResponse.');if(e instanceof Array)throw new Error("paymentMethodsResponse was provided but of an incorrect type (should be an object but an array was provided).Please check you are passing the whole response.");!e||(null===(t=null==e?void 0:e.paymentMethods)||void 0===t?void 0:t.length)||(null===(r=null==e?void 0:e.storePaymentMethods)||void 0===r?void 0:r.length)||console.warn("paymentMethodsResponse was provided but no payment methods were found.")}(e),this.paymentMethods=e?function(e,t){var r=t.allowPaymentMethods,a=void 0===r?[]:r,n=t.removePaymentMethods,o=void 0===n?[]:n;return e?e.filter(dk,a).filter(uk,o):[]}(e.paymentMethods,t):[],this.storedPaymentMethods=e?function(e,t){var r=t.allowPaymentMethods,a=void 0===r?[]:r,n=t.removePaymentMethods,o=void 0===n?[]:n;return e?e.filter(hk).filter(dk,a).filter(uk,o).filter(pk).map(fk):[]}(e.storedPaymentMethods,t):[]}return e.prototype.has=function(e){return Boolean(this.paymentMethods.find((function(t){return t.type===e})))},e.prototype.find=function(e){return this.paymentMethods.find((function(t){return t.type===e}))},e}(),bk=function(e){return function(t,r){return sk(t.paymentMethodType,Tc(Tc(Tc({},t),r),{onComplete:r.onAdditionalDetails,onError:r.onError,statusType:e}))}},vk={redirect:function(e,t){return sk("redirect",Tc(Tc(Tc({},t),e),{statusType:"redirect"}))},threeDS2Fingerprint:function(e,t){return sk("threeDS2DeviceFingerprint",Tc(Tc({createFromAction:t.createFromAction,token:e.token,paymentData:e.paymentData,onError:t.onError,showSpinner:!t.isDropin,isDropin:!!t.isDropin},t),{type:"IdentifyShopper",onComplete:t.onAdditionalDetails,statusType:"loading",useOriginalFlow:!0}))},threeDS2Challenge:function(e,t){var r;return sk("threeDS2Challenge",Tc(Tc({},t),{token:e.token,paymentData:e.paymentData,onComplete:t.onAdditionalDetails,onError:t.onError,size:null!==(r=t.size)&&void 0!==r?r:"02",isDropin:!!t.isDropin,type:"ChallengeShopper",statusType:"custom",useOriginalFlow:!0}))},threeDS2:function(e,t){var r="fingerprint"===e.subtype?"threeDS2DeviceFingerprint":"threeDS2Challenge",a="fingerprint"===e.subtype?e.paymentData:e.authorisationToken,n=Tc({token:e.token,paymentData:a,onComplete:t.onAdditionalDetails,onError:t.onError,isDropin:!!t.isDropin,loadingContext:t.loadingContext,clientKey:t.clientKey,_parentInstance:t._parentInstance,paymentMethodType:t.paymentMethodType,challengeWindowSize:t.challengeWindowSize},function(e,t){if("fingerprint"===e){var r=Sh(t.elementRef?Ub:Kb).from(t);return r.showSpinner=!t.isDropin,r.statusType="loading",r}return{statusType:"custom"}}(e.subtype,t));return sk(r,n)},voucher:bk("custom"),qrCode:bk("custom"),await:bk("custom"),bankTransfer:bk("custom"),sdk:bk("custom")};var gk=function(){function e(){this.events=[]}return e.prototype.add=function(e){this.events.push(e)},e.prototype.run=function(e){var t=this.events.map((function(t){return t(e)}));return this.events=[],Promise.all(t)},e}(),kk=function(){function e(t){var r=t.loadingContext,a=t.locale,n=t.clientKey,o=t.analytics;this.checkoutAttemptId=null,this.queue=new gk,this.props=Tc(Tc({},e.defaultProps),o),this.logEvent=function(e){return function(t){var r=Tc({version:"4.9.0",payload_version:1,platform:"web",locale:e.locale},t),a=Object.keys(r).map((function(e){return encodeURIComponent(e)+"="+encodeURIComponent(r[e])})).join("&");(new Image).src=e.loadingContext+"images/analytics.png?"+a}}({loadingContext:r,locale:a}),this.logTelemetry=function(e){return function(t){if(!e.clientKey)return Promise.reject();var r={errorLevel:"silent",loadingContext:e.loadingContext,path:"v2/analytics/log?clientKey="+e.clientKey},a=Tc({version:"4.9.0",platform:"web",locale:e.locale,flavor:"components",userAgent:navigator.userAgent,referrer:window.location.href,screenWidth:window.screen.width},t);return fm(r,a)}}({loadingContext:r,locale:a,clientKey:n}),this.collectId=function(e){var t,r=e.loadingContext,a=e.clientKey,n=e.experiments,o={errorLevel:"silent",loadingContext:r,path:"v2/analytics/id?clientKey="+a};return function(){return t||(a?t=fm(o,{experiments:n}).then((function(e){return null==e?void 0:e.id})).catch((function(){})):Promise.reject())}}({loadingContext:r,clientKey:n,experiments:this.props.experiments});var i=this.props,l=i.conversion,s=i.enabled;!0===l&&!0===s&&this.props.checkoutAttemptId&&(this.checkoutAttemptId=this.props.checkoutAttemptId,this.queue.run(this.checkoutAttemptId))}return e.prototype.send=function(e){var t=this,r=this.props,a=r.conversion,n=r.enabled,o=r.payload,i=r.telemetry;if(!0===n){if(!0!==a||this.checkoutAttemptId||this.collectId().then((function(e){t.checkoutAttemptId=e,t.queue.run(t.checkoutAttemptId)})),!0===i){this.queue.add((function(r){return t.logTelemetry(Tc(Tc(Tc({},e),o&&Tc({},o)),{checkoutAttemptId:r})).catch((function(){}))})),a&&!this.checkoutAttemptId||this.queue.run(this.checkoutAttemptId)}this.logEvent(e)}},e.defaultProps={enabled:!0,telemetry:!0,conversion:!1,checkoutAttemptId:null,experiments:[]},e}();function Ck(e){return Object.keys(e).reduce((function(t,r){return Td.includes(r)&&(t[r]=e[r]),t}),{})}var _k=function(){function e(e){var t=this;this.components=[],this.update=function(e){return void 0===e&&(e={}),t.setOptions(e),t.components.forEach((function(e){return e.update(t.getPropsForComponent(t.options))})),t},this.remove=function(e){return t.components=t.components.filter((function(t){return t._id!==e._id})),e.unmount(),t},this.setOptions=function(e){return t.options=Tc(Tc({},t.options),e),t.options.loadingContext=function(e){void 0===e&&(e="https://checkoutshopper-live.adyen.com/checkoutshopper/");var t={test:"https://checkoutshopper-test.adyen.com/checkoutshopper/",live:"https://checkoutshopper-live.adyen.com/checkoutshopper/","live-us":"https://checkoutshopper-live-us.adyen.com/checkoutshopper/","live-au":"https://checkoutshopper-live-au.adyen.com/checkoutshopper/"};return t[e]||t[e.toLowerCase()]||e}(t.options.environment),t.modules={risk:new Du(t.options),analytics:new kk(t.options),i18n:new Xc(t.options.locale,t.options.translations)},t.paymentMethodsResponse=new yk(t.options.paymentMethodsResponse,t.options),t},this.create=this.create.bind(this),this.createFromAction=this.createFromAction.bind(this),this.setOptions(e)}return e.prototype.create=function(e,t){var r=this.getPropsForComponent(t);return e?this.handleCreate(e,r):this.handleCreateError()},e.prototype.createFromAction=function(e,t){if(void 0===t&&(t={}),e.type){var r=ck(e.type,this.options.paymentMethodsConfiguration);return function(e,t){void 0===t&&(t={});var r=vk[e.type];if(r&&"function"==typeof r)return r(e,t);throw new Error("Invalid Action")}(e,Tc(Tc(Tc({},Ck(this.options)),r),this.getPropsForComponent(t)))}return this.handleCreateError()},e.prototype.getPropsForComponent=function(e){return Tc(Tc({paymentMethods:this.paymentMethodsResponse.paymentMethods,storedPaymentMethods:this.paymentMethodsResponse.storedPaymentMethods},e),{i18n:this.modules.i18n,modules:this.modules,createFromAction:this.createFromAction,_parentInstance:this})},e.prototype.handleCreate=function(e,t){if(void 0===t&&(t={}),e.prototype instanceof pu){var r=t.supportedShopperInteractions?[]:this.paymentMethodsResponse.find(t.type),a=ck(t.type,this.options.paymentMethodsConfiguration,!!t.storedPaymentMethodId),n=Ck(this.options),o=new e(Tc(Tc(Tc(Tc({},n),r),a),t));return t.isDropin||this.components.push(o),o}if("string"==typeof e&&lk[e])return this.handleCreate(lk[e],Tc({type:e},t));if("string"==typeof e&&this.paymentMethodsResponse.has(e)){a=ck(e,this.options.paymentMethodsConfiguration);return this.handleCreate(lk.redirect,Tc(Tc(Tc(Tc({},Ck(this.options)),this.paymentMethodsResponse.find(e)),a),t))}if("object"==typeof e&&"string"==typeof e.type){a=ck(e.type,this.options.paymentMethodsConfiguration,!!e.storedPaymentMethodId);return this.handleCreate(e.type,Tc(Tc(Tc({},e),t),a))}return this.handleCreateError(e)},e.prototype.handleCreateError=function(e){var t=e&&e.name?e.name:"The passed payment method";throw new Error(e?t+" is not a valid Checkout Component":"No Payment Method component was passed")},e.version={version:"4.9.0",revision:"613457b",branch:"HEAD",buildId:"@adyen/adyen-web-7f7fc758-7413-4bfe-a0f7-b832395b3a80"},e}(),Nk=Object.freeze({__proto__:null,default:{payButton:"\u062f\u0641\u0639","payButton.redirecting":"\u062c\u0627\u0631\u0650 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647...",storeDetails:"\u062d\u0641\u0638 \u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a\u064a \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.holderName":"\u0627\u0644\u0627\u0633\u0645 \u0639\u0644\u0649 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.holderName.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","creditCard.holderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","creditCard.numberField.title":"\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.numberField.placeholder":"3456 9012 5678 1234","creditCard.expiryDateField.title":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.expiryDateField.placeholder":"\u0634\u0647\u0631/\u0633\u0646\u0629","creditCard.expiryDateField.month":"\u0634\u0647\u0631","creditCard.expiryDateField.month.placeholder":"\u0634\u0647\u0631","creditCard.expiryDateField.year.placeholder":"\u0633\u0646\u0629","creditCard.expiryDateField.year":"\u0633\u0646\u0629","creditCard.cvcField.title":"\u0631\u0645\u0632 CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0627\u062d\u062a\u0641\u0638 \u0628\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0644\u0644\u0645\u0631\u0629 \u0627\u0644\u0642\u0627\u062f\u0645\u0629","creditCard.cvcField.placeholder.4digits":"4 \u0623\u0631\u0642\u0627\u0645","creditCard.cvcField.placeholder.3digits":"3 \u0623\u0631\u0642\u0627\u0645","creditCard.taxNumber.placeholder":"\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629 / 0123456789",installments:"\u0639\u062f\u062f \u0627\u0644\u0623\u0642\u0633\u0627\u0637",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} \u0623\u0634\u0647\u0631","installments.oneTime":"\u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0648\u0627\u062d\u062f\u0629","installments.installments":"\u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u0623\u0642\u0633\u0627\u0637","installments.revolving":"\u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u062f\u0648\u0631\u064a","sepaDirectDebit.ibanField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","sepaDirectDebit.nameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","sepa.ownerName":"\u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","sepa.ibanNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 (IBAN)","error.title":"\u062e\u0637\u0623","error.subtitle.redirect":"\u0641\u0634\u0644 \u0625\u0639\u0627\u062f\u0629 \u0627\u0644\u062a\u0648\u062c\u064a\u0647","error.subtitle.payment":"\u0641\u0634\u0644 \u0627\u0644\u062f\u0641\u0639","error.subtitle.refused":"\u062a\u0645 \u0631\u0641\u0636 \u0627\u0644\u062f\u0641\u0639","error.message.unknown":"\u062d\u062f\u062b \u062e\u0637\u0623 \u063a\u064a\u0631 \u0645\u0639\u0631\u0648\u0641","idealIssuer.selectField.title":"\u0627\u0644\u0628\u0646\u0643","idealIssuer.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","creditCard.success":"\u0646\u062c\u062d \u0627\u0644\u062f\u0641\u0639",loading:"\u062c\u0627\u0631\u0650 \u0627\u0644\u062a\u062d\u0645\u064a\u0644...",continue:"\u0645\u062a\u0627\u0628\u0639\u0629",continueTo:"\u0645\u062a\u0627\u0628\u0639\u0629 \u0625\u0644\u0649","wechatpay.timetopay":"\u0644\u062f\u064a\u0643 %@ \u0644\u0644\u062f\u0641\u0639","wechatpay.scanqrcode":"\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629",personalDetails:"\u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u062e\u0635\u064a\u0629",companyDetails:"\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.name":"\u0627\u0633\u0645 \u0627\u0644\u0634\u0631\u0643\u0629","companyDetails.registrationNumber":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0633\u062c\u064a\u0644",socialSecurityNumber:"\u0631\u0642\u0645 \u0627\u0644\u0636\u0645\u0627\u0646 \u0627\u0644\u0627\u062c\u062a\u0645\u0627\u0639\u064a",firstName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u0648\u0644",infix:"\u0628\u0627\u062f\u0626\u0629",lastName:"\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0623\u062e\u064a\u0631",mobileNumber:"\u0631\u0642\u0645 \u0627\u0644\u062c\u0648\u0627\u0644","mobileNumber.invalid":"\u0631\u0642\u0645 \u062c\u0648\u0627\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",city:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629",postalCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",countryCode:"\u0631\u0645\u0632 \u0627\u0644\u0628\u0644\u062f",telephoneNumber:"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641",dateOfBirth:"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0645\u064a\u0644\u0627\u062f",shopperEmail:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0628\u0631\u064a\u062f \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a",gender:"\u0627\u0644\u0646\u0648\u0639",male:"\u0630\u0643\u0631",female:"\u0623\u0646\u062b\u0649",billingAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0641\u0648\u0627\u062a\u064a\u0631",street:"\u0627\u0644\u0634\u0627\u0631\u0639",stateOrProvince:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629",country:"\u0627\u0644\u0628\u0644\u062f",houseNumberOrName:"\u0631\u0642\u0645 \u0627\u0644\u0645\u0646\u0632\u0644",separateDeliveryAddress:"\u062d\u062f\u062f \u0639\u0646\u0648\u0627\u0646 \u062a\u0633\u0644\u064a\u0645 \u0645\u0646\u0641\u0635\u0644",deliveryAddress:"\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u062a\u0633\u0644\u064a\u0645",zipCode:"\u0627\u0644\u0631\u0645\u0632 \u0627\u0644\u0628\u0631\u064a\u062f\u064a",apartmentSuite:"\u0627\u0644\u0634\u0642\u0629 / \u0627\u0644\u062c\u0646\u0627\u062d",provinceOrTerritory:"\u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645",cityTown:"\u0627\u0644\u0645\u062f\u064a\u0646\u0629 / \u0627\u0644\u0628\u0644\u062f\u0629",address:"\u0627\u0644\u0639\u0646\u0648\u0627\u0646",state:"\u0627\u0644\u0648\u0644\u0627\u064a\u0629","field.title.optional":"(\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","creditCard.cvcField.title.optional":"\u0631\u0645\u0632 CVC / CVV (\u0627\u062e\u062a\u064a\u0627\u0631\u064a)","issuerList.wallet.placeholder":"\u062d\u062f\u062f \u0645\u062d\u0641\u0638\u062a\u0643",privacyPolicy:"\u0633\u064a\u0627\u0633\u0629 \u0627\u0644\u062e\u0635\u0648\u0635\u064a\u0629","afterPay.agreement":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 %@ \u0644\u0634\u0631\u0643\u0629 AfterPay",paymentConditions:"\u0634\u0631\u0648\u0637 \u0627\u0644\u062f\u0641\u0639",openApp:"\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642","voucher.readInstructions":"\u0642\u0631\u0627\u0621\u0629 \u0627\u0644\u062a\u0639\u0644\u064a\u0645\u0627\u062a","voucher.introduction":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0642\u0633\u064a\u0645\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.expirationDate":"\u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","voucher.alternativeReference":"\u0627\u0644\u0645\u0631\u062c\u0639 \u0627\u0644\u0628\u062f\u064a\u0644","dragonpay.voucher.non.bank.selectField.placeholder":"\u062d\u062f\u062f \u0645\u0642\u062f\u0645 \u0627\u0644\u062e\u062f\u0645\u0629","dragonpay.voucher.bank.selectField.placeholder":"\u062d\u062f\u062f \u0627\u0644\u0628\u0646\u0643 \u0627\u0644\u0630\u064a \u062a\u062a\u0639\u0627\u0645\u0644 \u0645\u0639\u0647","voucher.paymentReferenceLabel":"\u0645\u0631\u062c\u0639 \u0627\u0644\u062f\u0641\u0639","voucher.surcharge":"\u0628\u0645\u0627 \u0641\u064a \u0630\u0644\u0643 %@ \u0631\u0633\u0645\u064b\u0627 \u0625\u0636\u0627\u0641\u064a\u064b\u0627","voucher.introduction.doku":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.shopperName":"\u0627\u0633\u0645 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.merchantName":"\u0627\u0644\u062a\u0627\u062c\u0631","voucher.introduction.econtext":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","voucher.telephoneNumber":"\u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641","voucher.shopperReference":"\u0645\u0631\u062c\u0639 \u0627\u0644\u0645\u062a\u0633\u0648\u0642","voucher.collectionInstitutionNumber":"\u0631\u0642\u0645 \u0627\u0644\u0645\u0624\u0633\u0633\u0629 \u0627\u0644\u0645\u0643\u0644\u0641\u0629 \u0628\u0627\u0644\u062a\u062d\u0635\u064a\u0644","voucher.econtext.telephoneNumber.invalid":"\u064a\u062c\u0628 \u0623\u0646 \u064a\u0643\u0648\u0646 \u0631\u0642\u0645 \u0627\u0644\u0647\u0627\u062a\u0641 \u0628\u0637\u0648\u0644 10 \u0623\u0648 11 \u0631\u0642\u0645\u064b\u0627","boletobancario.btnLabel":"\u0625\u0646\u0634\u0627\u0621 \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 Boleto","boleto.sendCopyToEmail":"\u0625\u0631\u0633\u0627\u0644 \u0646\u0633\u062e\u0629 \u0625\u0644\u0649 \u0628\u0631\u064a\u062f\u064a \u0627\u0644\u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a","button.copy":"\u0646\u0633\u062e","button.download":"\u062a\u0646\u0632\u064a\u0644","creditCard.storedCard.description.ariaLabel":"\u062a\u0646\u062a\u0647\u064a \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u062e\u0632\u0646\u0629 \u0641\u064a %@","voucher.entity":"\u0627\u0644\u0643\u064a\u0627\u0646",donateButton:"\u0627\u0644\u062a\u0628\u0631\u0639",notNowButton:"\u0644\u064a\u0633 \u0627\u0644\u0622\u0646",thanksForYourSupport:"\u0634\u0643\u0631\u064b\u0627 \u0639\u0644\u0649 \u062f\u0639\u0645\u0643!",preauthorizeWith:"\u062a\u0641\u0648\u064a\u0636 \u0645\u0633\u0628\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645",confirmPreauthorization:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062a\u0641\u0648\u064a\u0636 \u0627\u0644\u0645\u0633\u0628\u0642",confirmPurchase:"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u0634\u0631\u0627\u0621",applyGiftcard:"\u0627\u0633\u062a\u0631\u062f\u0627\u062f",giftcardBalance:"\u0631\u0635\u064a\u062f \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",deductedBalance:"\u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062e\u0635\u0648\u0645","creditCard.pin.title":"\u0631\u0642\u0645 \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0634\u062e\u0635\u064a","creditCard.encryptedPassword.label":"\u0623\u0648\u0644 \u0631\u0642\u0645\u0627\u0646 \u0645\u0646 \u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","creditCard.taxNumber.label":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 (\u064a\u0648\u0645 \u0634\u0647\u0631 \u0633\u0646\u0629) \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.labelAlt":"\u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 (10 \u0623\u0631\u0642\u0627\u0645)","creditCard.taxNumber.invalid":"\u062a\u0627\u0631\u064a\u062e \u0645\u064a\u0644\u0627\u062f \u062d\u0627\u0645\u0644 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0623\u0648 \u0631\u0642\u0645 \u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u0634\u0631\u0643\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","storedPaymentMethod.disable.button":"\u0625\u0632\u0627\u0644\u0629","storedPaymentMethod.disable.confirmation":"\u0625\u0632\u0627\u0644\u0629 \u0637\u0631\u064a\u0642\u0629 \u0627\u0644\u062f\u0641\u0639 \u0627\u0644\u0645\u062e\u0632\u0646\u0629","storedPaymentMethod.disable.confirmButton":"\u0646\u0639\u0645\u060c \u0623\u0631\u063a\u0628 \u0641\u064a \u0625\u0632\u0627\u0644\u062a\u0647\u0627","storedPaymentMethod.disable.cancelButton":"\u0625\u0644\u063a\u0627\u0621","ach.bankAccount":"\u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.accountHolderNameField.title":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountHolderNameField.placeholder":"\u062c\u0645\u064a\u0644 \u0633\u0639\u064a\u062f","ach.accountHolderNameField.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountNumberField.title":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628","ach.accountNumberField.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","ach.accountLocationField.title":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA","ach.accountLocationField.invalid":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","select.state":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629","select.stateOrProvince":"\u062d\u062f\u062f \u0627\u0644\u0648\u0644\u0627\u064a\u0629 \u0623\u0648 \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629","select.provinceOrTerritory":"\u062d\u062f\u062f \u0627\u0644\u0645\u0642\u0627\u0637\u0639\u0629 \u0623\u0648 \u0627\u0644\u0625\u0642\u0644\u064a\u0645","select.country":"\u062d\u062f\u062f \u0627\u0644\u0628\u0644\u062f","select.noOptionsFound":"\u0644\u0627 \u062a\u0648\u062c\u062f \u062e\u064a\u0627\u0631\u0627\u062a","select.filter.placeholder":"\u0628\u062d\u062b...","telephoneNumber.invalid":"\u0631\u0642\u0645 \u0647\u0627\u062a\u0641 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d",qrCodeOrApp:"\u0623\u0648","paypal.processingPayment":"\u062c\u0627\u0631\u0650 \u0645\u0639\u0627\u0644\u062c\u0629 \u0627\u0644\u0645\u062f\u0641\u0648\u0639\u0627\u062a...",generateQRCode:"\u0625\u0646\u0634\u0627\u0621 \u0631\u0645\u0632 \u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0633\u0631\u064a\u0639\u0629","await.waitForConfirmation":"\u0641\u064a \u0627\u0646\u062a\u0638\u0627\u0631 \u0627\u0644\u062a\u0623\u0643\u064a\u062f","mbway.confirmPayment":"\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639 \u0639\u0644\u0649 \u062a\u0637\u0628\u064a\u0642 MB WAY","shopperEmail.invalid":"\u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064a\u062f \u0625\u0644\u0643\u062a\u0631\u0648\u0646\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","dateOfBirth.format":"\u064a\u0648\u0645/\u0634\u0647\u0631/\u0633\u0646\u0629","dateOfBirth.invalid":"\u064a\u062c\u0628 \u0623\u0644\u0627 \u064a\u0642\u0644 \u0639\u0645\u0631\u0643 \u0639\u0646 18 \u0639\u0627\u0645\u064b\u0627","blik.confirmPayment":"\u0627\u0641\u062a\u062d \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a \u0644\u062a\u0623\u0643\u064a\u062f \u0627\u0644\u062f\u0641\u0639.","blik.invalid":"\u0623\u062f\u062e\u0644 6 \u0623\u0631\u0642\u0627\u0645","blik.code":"\u0631\u0645\u0632 \u0645\u0643\u0648\u0646 \u0645\u0646 6 \u0623\u0631\u0642\u0627\u0645","blik.help":"\u0627\u062d\u0635\u0644 \u0639\u0644\u0649 \u0627\u0644\u0631\u0645\u0632 \u0645\u0646 \u062a\u0637\u0628\u064a\u0642\u0643 \u0627\u0644\u0628\u0646\u0643\u064a.","swish.pendingMessage":"\u0628\u0639\u062f \u0642\u064a\u0627\u0645\u0643 \u0628\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627\u060c \u064a\u0645\u0643\u0646 \u0623\u0646 \u062a\u0638\u0644 \u0627\u0644\u062d\u0627\u0644\u0629 \u0645\u0639\u0644\u0642\u0629 \u0644\u0645\u062f\u0629 \u062a\u0635\u0644 \u0625\u0644\u0649 10 \u062f\u0642\u0627\u0626\u0642. \u0642\u062f \u062a\u0624\u062f\u064a \u0645\u062d\u0627\u0648\u0644\u0629 \u0627\u0644\u062f\u0641\u0639 \u0645\u0631\u0629 \u0623\u062e\u0631\u0649 \u062e\u0644\u0627\u0644 \u0647\u0630\u0627 \u0627\u0644\u0648\u0642\u062a \u0625\u0644\u0649 \u0641\u0631\u0636 \u0631\u0633\u0648\u0645 \u0645\u062a\u0639\u062f\u062f\u0629.","error.va.gen.01":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0645\u0643\u062a\u0645\u0644","error.va.gen.02":"\u062d\u0642\u0644 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.01":"\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-cc-num.03":"\u062a\u0645 \u0625\u062f\u062e\u0627\u0644 \u0628\u0637\u0627\u0642\u0629 \u063a\u064a\u0631 \u0645\u062f\u0639\u0648\u0645\u0629","error.va.sf-cc-dat.01":"\u0628\u0637\u0627\u0642\u0629 \u0642\u062f\u064a\u0645\u0629 \u062c\u062f\u064b\u0627","error.va.sf-cc-dat.02":"\u0627\u0644\u062a\u0627\u0631\u064a\u062e \u0628\u0639\u064a\u062f \u0644\u0644\u063a\u0627\u064a\u0629 \u0641\u064a \u0627\u0644\u0645\u0633\u062a\u0642\u0628\u0644","error.va.sf-cc-dat.03":"\u062a\u0646\u062a\u0647\u064a \u0635\u0644\u0627\u062d\u064a\u0629 \u0628\u0637\u0627\u0642\u062a\u0643 \u0642\u0628\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0633\u062f\u0627\u062f","error.va.sf-ach-num.01":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-ach-loc.01":"\u0631\u0642\u0645 \u062a\u0648\u062c\u064a\u0647 ABA \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","error.va.sf-kcp-pwd.01":"\u0643\u0644\u0645\u0629 \u0645\u0631\u0648\u0631 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d\u0629","error.giftcard.no-balance":"\u0644\u0627 \u064a\u0648\u062c\u062f \u0631\u0635\u064a\u062f \u0628\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","error.giftcard.card-error":"\u0644\u0627 \u062a\u0648\u062c\u062f \u0628\u0633\u062c\u0644\u0627\u062a\u0646\u0627 \u0628\u0637\u0627\u0642\u0629 \u0647\u062f\u0627\u064a\u0627 \u062a\u062d\u0645\u0644 \u0647\u0630\u0627 \u0627\u0644\u0631\u0642\u0645","error.giftcard.currency-error":"\u0644\u0627 \u062a\u0633\u0631\u064a \u0628\u0637\u0627\u0642\u0627\u062a \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0625\u0644\u0627 \u0628\u0627\u0644\u0639\u0645\u0644\u0629 \u0627\u0644\u062a\u064a \u0635\u062f\u0631\u062a \u0628\u0647\u0627","amazonpay.signout":"\u062a\u0633\u062c\u064a\u0644 \u0627\u0644\u062e\u0631\u0648\u062c \u0645\u0646 \u0645\u0648\u0642\u0639 Amazon","amazonpay.changePaymentDetails":"\u062a\u063a\u064a\u064a\u0631 \u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u062f\u0641\u0639","partialPayment.warning":"\u062a\u062d\u062f\u064a\u062f \u0637\u0631\u064a\u0642\u0629 \u062f\u0641\u0639 \u0623\u062e\u0631\u0649 \u0644\u062a\u0633\u062f\u064a\u062f \u0627\u0644\u0645\u0628\u0644\u063a \u0627\u0644\u0645\u062a\u0628\u0642\u064a","partialPayment.remainingBalance":"\u0633\u064a\u0628\u0644\u063a \u0627\u0644\u0631\u0635\u064a\u062f \u0627\u0644\u0645\u062a\u0628\u0642\u064a %{amount}","bankTransfer.beneficiary":"\u0627\u0644\u0645\u0633\u062a\u0641\u064a\u062f","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u0643\u0648\u062f \u0627\u0644\u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643\u064a","bankTransfer.reference":"\u0627\u0644\u0645\u0631\u062c\u0639","bankTransfer.introduction":"\u0642\u0645 \u0628\u0627\u0644\u0645\u062a\u0627\u0628\u0639\u0629 \u0644\u0625\u0646\u0634\u0627\u0621 \u0645\u062f\u0641\u0648\u0639\u0627\u062a \u062a\u062d\u0648\u064a\u0644 \u0628\u0646\u0643\u064a\u0629 \u062c\u062f\u064a\u062f\u0629. \u064a\u0645\u0643\u0646\u0643 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0628\u064a\u0627\u0646\u0627\u062a \u0627\u0644\u0648\u0627\u0631\u062f\u0629 \u0641\u064a \u0627\u0644\u0634\u0627\u0634\u0629 \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bankTransfer.instructions":"\u0634\u0643\u0631\u064b\u0627 \u0644\u0643 \u0639\u0644\u0649 \u0634\u0631\u0627\u0626\u0643\u060c \u064a\u0631\u062c\u0649 \u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0627\u0644\u0645\u0639\u0644\u0648\u0645\u0627\u062a \u0627\u0644\u062a\u0627\u0644\u064a\u0629 \u0644\u0625\u062a\u0645\u0627\u0645 \u0639\u0645\u0644\u064a\u0629 \u0627\u0644\u062f\u0641\u0639.","bacs.accountHolderName":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountHolderName.invalid":"\u0627\u0633\u0645 \u0635\u0627\u062d\u0628 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.accountNumber":"\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","bacs.accountNumber.invalid":"\u0631\u0642\u0645 \u062d\u0633\u0627\u0628 \u0628\u0646\u0643\u064a \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.bankLocationId":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0627\u0644\u0628\u0646\u0643","bacs.bankLocationId.invalid":"\u0631\u0645\u0632 \u062a\u0639\u0631\u064a\u0641 \u0628\u0646\u0643 \u063a\u064a\u0631 \u0635\u062d\u064a\u062d","bacs.consent.amount":"\u0623\u0648\u0627\u0641\u0642 \u0639\u0644\u0649 \u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0644\u063a \u0623\u0639\u0644\u0627\u0647 \u0645\u0646 \u062d\u0633\u0627\u0628\u064a \u0627\u0644\u0628\u0646\u0643\u064a.","bacs.consent.account":"\u0623\u0624\u0643\u062f \u0623\u0646 \u0627\u0644\u062d\u0633\u0627\u0628 \u0628\u0627\u0633\u0645\u064a \u0648\u0623\u0646\u0627 \u0648\u062d\u062f\u064a \u0635\u0627\u062d\u0628 \u0627\u0644\u062a\u0648\u0642\u064a\u0639 \u0627\u0644\u0645\u0637\u0627\u0644\u0628 \u0628\u0627\u0644\u0625\u0630\u0646 \u0628\u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 \u0641\u064a \u0647\u0630\u0627 \u0627\u0644\u062d\u0633\u0627\u0628.",edit:"\u062a\u062d\u0631\u064a\u0631","bacs.confirm":"\u062a\u0623\u0643\u064a\u062f \u0648\u062f\u0641\u0639","bacs.result.introduction":"\u062a\u0646\u0632\u064a\u0644 \u062a\u0639\u0644\u064a\u0645\u0627\u062a \u0627\u0644\u062e\u0635\u0645 \u0627\u0644\u0645\u0628\u0627\u0634\u0631 (\u062a\u0639\u0644\u064a\u0645\u0627\u062a / \u062a\u0641\u0648\u064a\u0636 DDI)","download.pdf":"\u062a\u0646\u0632\u064a\u0644 \u0645\u0644\u0641 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedCardNumber.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u0628\u0637\u0627\u0642\u0629","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u062a\u0627\u0631\u064a\u062e \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryDate.aria.label":"\u062d\u0642\u0644 \u062a\u0627\u0631\u064a\u062e \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0634\u0647\u0631 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryMonth.aria.label":"\u062d\u0642\u0644 \u0634\u0647\u0631 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0633\u0646\u0629 \u0627\u0646\u062a\u0647\u0627\u0621 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedExpiryYear.aria.label":"\u062d\u0642\u0644 \u0633\u0646\u0629 \u0627\u0644\u0627\u0646\u062a\u0647\u0627\u0621","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0627\u0644\u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","creditCard.encryptedSecurityCode.aria.label":"\u062d\u0642\u0644 \u0631\u0645\u0632 \u0627\u0644\u0623\u0645\u0627\u0646","giftcard.encryptedCardNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedCardNumber.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0627\u0644\u0645\u0624\u0645\u0646\u0629","giftcard.encryptedSecurityCode.aria.label":"\u062d\u0642\u0644 \u0631\u0645\u0632 \u0623\u0645\u0627\u0646 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627",giftcardTransactionLimit:"\u064a\u0633\u0645\u062d \u0641\u0642\u0637 \u0628\u062d\u062f \u0623\u0642\u0635\u0649 %{amount} \u0644\u0643\u0644 \u0645\u0639\u0627\u0645\u0644\u0629 \u0639\u0644\u0649 \u0628\u0637\u0627\u0642\u0629 \u0627\u0644\u0647\u062f\u0627\u064a\u0627 \u0647\u0630\u0647","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankAccountNumber.aria.label":"\u062d\u0642\u0644 \u0627\u0644\u062d\u0633\u0627\u0628 \u0627\u0644\u0628\u0646\u0643\u064a","ach.encryptedBankLocationId.aria.iframeTitle":"\u0627\u0644\u0625\u0637\u0627\u0631 \u0627\u0644\u0645\u0636\u0645\u0646 \u0644\u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a \u0627\u0644\u0645\u0624\u0645\u0646","ach.encryptedBankLocationId.aria.label":"\u062d\u0642\u0644 \u0631\u0642\u0645 \u0627\u0644\u062a\u0648\u062c\u064a\u0647 \u0627\u0644\u0628\u0646\u0643\u064a","pix.instructions":"\u0627\u0641\u062a\u062d \u0627\u0644\u062a\u0637\u0628\u064a\u0642 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 \u0645\u0641\u062a\u0627\u062d PIX \u0627\u0644\u0645\u0633\u062c\u0644\u060c \u0648\u0627\u062e\u062a\u0631 \u0627\u0644\u062f\u0641\u0639 \u0628\u0627\u0633\u062a\u062e\u062f\u0627\u0645 PIX \u0648\u0627\u0645\u0633\u062d \u0631\u0645\u0632 \u0627\u0644\u0627\u0633\u062a\u062c\u0627\u0628\u0629 \u0627\u0644\u0633\u0631\u064a\u0639\u0629 \u0636\u0648\u0626\u064a\u064b\u0627 \u0623\u0648 \u0627\u0646\u0633\u062e \u0627\u0644\u0631\u0645\u0632 \u0648\u0627\u0644\u0635\u0642\u0647","twint.saved":"\u0627\u0644\u0645\u062d\u0641\u0648\u0638\u0629"}}),wk=Object.freeze({__proto__:null,default:{payButton:"Zaplatit","payButton.redirecting":"P\u0159esm\u011brov\xe1n\xed...",storeDetails:"Ulo\u017eit pro\xa0p\u0159\xed\u0161t\xed platby","creditCard.holderName":"Jm\xe9no na\xa0kart\u011b","creditCard.holderName.placeholder":"Jan Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Konec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"M\u011bs\xedc","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"K\xf3d CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamatovat si pro\xa0p\u0159\xed\u0161t\u011b","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Po\u010det spl\xe1tek",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} m\u011bs\xedc\u016f","installments.oneTime":"Jednor\xe1zov\xe1 platba","installments.installments":"Platba na\xa0spl\xe1tky","installments.revolving":"Opakuj\xedc\xed se platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"Jan Nov\xe1k","sepa.ownerName":"Jm\xe9no dr\u017eitele \xfa\u010dtu","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"P\u0159esm\u011brov\xe1n\xed selhalo","error.subtitle.payment":"Platba selhala","error.subtitle.refused":"Platba zam\xedtnuta","error.message.unknown":"Do\u0161lo k\xa0nezn\xe1m\xe9 chyb\u011b","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svou banku","creditCard.success":"Platba prob\u011bhla \xfasp\u011b\u0161n\u011b",loading:"Na\u010d\xedt\xe1n\xed\u2026",continue:"Pokra\u010dovat",continueTo:"Pokra\u010dovat k","wechatpay.timetopay":"Na\xa0zaplacen\xed v\xe1m zb\xfdv\xe1 %@","wechatpay.scanqrcode":"Naskenovat QR k\xf3d",personalDetails:"Osobn\xed \xfadaje",companyDetails:"\xdadaje o\xa0spole\u010dnosti","companyDetails.name":"N\xe1zev spole\u010dnosti","companyDetails.registrationNumber":"Registra\u010dn\xed \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Jm\xe9no",infix:"Prefix",lastName:"P\u0159\xedjmen\xed",mobileNumber:"\u010c\xedslo na mobil","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo mobiln\xedho telefonu",city:"M\u011bsto",postalCode:"PS\u010c",countryCode:"K\xf3d zem\u011b",telephoneNumber:"Telefonn\xed \u010d\xedslo",dateOfBirth:"Datum narozen\xed",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlav\xed",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xed adresa",street:"Ulice",stateOrProvince:"Kraj nebo okres",country:"Zem\u011b",houseNumberOrName:"\u010c\xedslo popisn\xe9",separateDeliveryAddress:"Zadat dodac\xed adresu odli\u0161nou od faktura\u010dn\xed",deliveryAddress:"Dodac\xed adresa",zipCode:"PS\u010c",apartmentSuite:"Byt",provinceOrTerritory:"Provincie nebo teritorium",cityTown:"M\u011bsto",address:"Adresa",state:"St\xe1t","field.title.optional":"(nepovinn\xe9)","creditCard.cvcField.title.optional":"K\xf3d CVC/CVV (voliteln\xe9)","issuerList.wallet.placeholder":"Vyberte svou pen\u011b\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xedch \xfadaj\u016f","afterPay.agreement":"Souhlas\xedm s %@ spole\u010dnosti AfterPay",paymentConditions:"platebn\xedmi podm\xednkami",openApp:"Otev\u0159ete aplikaci","voucher.readInstructions":"P\u0159e\u010dt\u011bte si pokyny","voucher.introduction":"D\u011bkujeme za\xa0n\xe1kup. K\xa0dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed kup\xf3n.","voucher.expirationDate":"Datum konce platnosti","voucher.alternativeReference":"N\xe1hradn\xed \u010d\xedslo","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte sv\xe9ho poskytovatele","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svou banku","voucher.paymentReferenceLabel":"\u010c\xedslo platby","voucher.surcharge":"V\u010detn\u011b p\u0159ir\xe1\u017eky %@","voucher.introduction.doku":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.shopperName":"Jm\xe9no kupuj\xedc\xedho","voucher.merchantName":"Obchodn\xedk","voucher.introduction.econtext":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","voucher.telephoneNumber":"Telefonn\xed \u010d\xedslo","voucher.shopperReference":"\u010c\xedslo kupuj\xedc\xedho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasn\xed instituce","voucher.econtext.telephoneNumber.invalid":"Telefonn\xed \u010d\xedslo mus\xed obsahovat 10 nebo 11 \u010d\xedslic.","boletobancario.btnLabel":"Vygenerovat Boleto","boleto.sendCopyToEmail":"Poslat mi kopii na e-mail","button.copy":"Kop\xedrovat","button.download":"St\xe1hnout","creditCard.storedCard.description.ariaLabel":"Ulo\u017een\xe1 karta kon\u010d\xed na %@","voucher.entity":"Subjekt",donateButton:"P\u0159isp\u011bt",notNowButton:"Te\u010f ne",thanksForYourSupport:"D\u011bkujeme v\xe1m za podporu!",preauthorizeWith:"P\u0159edautorizovat pomoc\xed",confirmPreauthorization:"Potvrdit p\u0159edautorizaci",confirmPurchase:"Potvrdit n\xe1kup",applyGiftcard:"Uplatnit",giftcardBalance:"Z\u016fstatek na d\xe1rkov\xe9 kart\u011b",deductedBalance:"Ode\u010dten\xfd z\u016fstatek","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prvn\xed 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplatn\xe9 heslo","creditCard.taxNumber.label":"Datum narozen\xed dr\u017eitele karty (RRMMDD) nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Registra\u010dn\xed \u010d\xedslo spole\u010dnosti (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xe9 datum narozen\xed dr\u017eitele karty nebo registra\u010dn\xed \u010d\xedslo spole\u010dnosti","storedPaymentMethod.disable.button":"Odebrat","storedPaymentMethod.disable.confirmation":"Odebrat ulo\u017een\xfd zp\u016fsob platby","storedPaymentMethod.disable.confirmButton":"Ano, odebrat","storedPaymentMethod.disable.cancelButton":"Zru\u0161it","ach.bankAccount":"Bankovn\xed \xfa\u010det","ach.accountHolderNameField.title":"Jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountHolderNameField.placeholder":"Jan Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","select.state":"Vyberte st\xe1t","select.stateOrProvince":"Vyberte kraj nebo okres","select.provinceOrTerritory":"Vyberte provincii nebo teritorium","select.country":"Vyberte zemi","select.noOptionsFound":"Nebyly nalezeny \u017e\xe1dn\xe9 mo\u017enosti","select.filter.placeholder":"Hledat...","telephoneNumber.invalid":"Neplatn\xe9 telefonn\xed \u010d\xedslo",qrCodeOrApp:"nebo","paypal.processingPayment":"Zpracov\xe1n\xed platby...",generateQRCode:"Vygenerovat QR k\xf3d","await.waitForConfirmation":"\u010cek\xe1 se na\xa0potvrzen\xed","mbway.confirmPayment":"Potvr\u010fte platbu v\xa0aplikaci MB WAY","shopperEmail.invalid":"Neplatn\xe1 e-mailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xed v\xe1m b\xfdt alespo\u0148 18 let","blik.confirmPayment":"Spus\u0165te bankovn\xed aplikaci a potvr\u010fte platbu.","blik.invalid":"Zadejte 6 \u010d\xedsel","blik.code":"\u0160estim\xedstn\xfd k\xf3d","blik.help":"Z\xedskejte k\xf3d z bankovn\xed aplikace.","swish.pendingMessage":"Po naskenov\xe1n\xed QR k\xf3du m\u016f\u017ee trvat a\u017e 10 minut, ne\u017e se stav zm\u011bn\xed. Pokud budete zkou\u0161et b\u011bhem t\xe9to doby platbu opakovat, m\u016f\u017ee b\xfdt \u010d\xe1stka zaplacena v\xedcekr\xe1t.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole nen\xed platn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zad\xe1na nepodporovan\xe1 karta","error.va.sf-cc-dat.01":"P\u0159\xedli\u0161 star\xe1 karta","error.va.sf-cc-dat.02":"Datum p\u0159\xedli\u0161 daleko v budoucnosti","error.va.sf-cc-dat.03":"Platnost karty vypr\u0161\xed p\u0159ed datem z\xfa\u010dtov\xe1n\xed","error.va.sf-ach-num.01":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","error.va.sf-ach-loc.01":"Neplatn\xe9 sm\u011brovac\xed tranzitn\xed \u010d\xedslo ABA","error.va.sf-kcp-pwd.01":"Neplatn\xe9 heslo","error.giftcard.no-balance":"Na d\xe1rkov\xe9 kart\u011b je nulov\xfd z\u016fstatek","error.giftcard.card-error":"V\xa0na\u0161ich z\xe1znamech nen\xed \u017e\xe1dn\xe1 d\xe1rkov\xe1 karta s\xa0t\xedmto \u010d\xedslem","error.giftcard.currency-error":"D\xe1rkov\xe9 karty jsou platn\xe9 jenom v\xa0m\u011bn\u011b, ve kter\xe9 byly vystaven\xe9","amazonpay.signout":"Odhl\xe1sit se z Amazonu","amazonpay.changePaymentDetails":"Zm\u011bnit \xfadaje o platb\u011b","partialPayment.warning":"Zvolte jin\xfd zp\u016fsob platby pro platbu zb\xfdvaj\xedc\xedch","partialPayment.remainingBalance":"Zb\xfdvaj\xedc\xed z\u016fstatek bude %{amount}","bankTransfer.beneficiary":"P\u0159\xedjemce","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Odkaz","bankTransfer.introduction":"Vytvo\u0159te novou platbu bankovn\xedm p\u0159evodem. K dokon\u010den\xed t\xe9to platby m\u016f\u017eete pou\u017e\xedt \xfadaje na n\xe1sleduj\xedc\xed obrazovce.","bankTransfer.instructions":"D\u011bkujeme za n\xe1kup. K dokon\u010den\xed platby pou\u017eijte pros\xedm n\xe1sleduj\xedc\xed informace.","bacs.accountHolderName":"Jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 jm\xe9no dr\u017eitele bankovn\xedho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankovn\xedho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankovn\xedho \xfa\u010dtu","bacs.bankLocationId":"K\xf3d Sort","bacs.bankLocationId.invalid":"Neplatn\xfd k\xf3d Sort","bacs.consent.amount":"Souhlas\xedm s\xa0t\xedm, \u017ee mi bude n\xe1sleduj\xedc\xed \u010d\xe1stka ode\u010dtena z\xa0bankovn\xedho \xfa\u010dtu.","bacs.consent.account":"Potvrzuji, \u017ee \xfa\u010det je veden na moje jm\xe9no a\xa0jsem jedin\xfdm disponentem, jeho\u017e podpis je nutn\xfd ke schv\xe1len\xed p\u0159\xedm\xe9ho inkasa.",edit:"Editovat","bacs.confirm":"Potvrdit a\xa0zaplatit","bacs.result.introduction":"St\xe1hn\u011bte si pokyny k\xa0p\u0159\xedm\xe9mu inkasu (DDI / podpisov\xe9 pr\xe1vo)","download.pdf":"St\xe1hnout PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 karty","creditCard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pro datum vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryDate.aria.label":"Pole pro datum vypr\u0161en\xed platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pro m\u011bs\xedc vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryMonth.aria.label":"Pole pro m\u011bs\xedc vypr\u0161en\xed platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pro rok vypr\u0161en\xed platnosti zabezpe\u010den\xe9 karty","creditCard.encryptedExpiryYear.aria.label":"Pole pro rok vypr\u0161en\xed platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 karty","creditCard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedCardNumber.aria.label":"Pole pro \u010d\xedslo d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pro bezpe\u010dnostn\xed k\xf3d zabezpe\u010den\xe9 d\xe1rkov\xe9 karty","giftcard.encryptedSecurityCode.aria.label":"Pole pro bezpe\u010dnostn\xed k\xf3d d\xe1rkov\xe9 karty",giftcardTransactionLimit:"Maxim\xe1ln\xed povolen\xe1 \u010d\xe1stka za jednu transakci touto d\xe1rkovou kartou je %{amount}.","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho bankovn\xedho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole pro bankovn\xed \xfa\u010det","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pro \u010d\xedslo zabezpe\u010den\xe9ho k\xf3du banky","ach.encryptedBankLocationId.aria.label":"Pole pro k\xf3d banky","twint.saved":"ulo\u017eeno"}}),Pk=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer ...",storeDetails:"Gem til min n\xe6ste betaling","creditCard.holderName":"Navn p\xe5 kort","creditCard.holderName.placeholder":"J. Hansen","creditCard.holderName.invalid":"Ugyldigt kortholdernavn","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Udl\xf8bsdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til n\xe6ste gang","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD/0123456789",installments:"Antal rater",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Afdragsbetaling","installments.revolving":"L\xf8bende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldigt kontonummer","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Kontohavernavn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fejl","error.subtitle.redirect":"Omdirigering fejlede","error.subtitle.payment":"Betaling fejlede","error.subtitle.refused":"Betaling afvist","error.message.unknown":"Der opstod en ukendt fejl","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe6lg din bank","creditCard.success":"Betaling gennemf\xf8rt",loading:"Indl\xe6ser\u2026",continue:"Forts\xe6t",continueTo:"Forts\xe6t til","wechatpay.timetopay":"Du har %@ at betale","wechatpay.scanqrcode":"Scan QR-kode",personalDetails:"Personlige oplysninger",companyDetails:"Virksomhedsoplysninger","companyDetails.name":"Virksomhedsnavn","companyDetails.registrationNumber":"CVR-nummer",socialSecurityNumber:"CPR-nummer",firstName:"Fornavn",infix:"Pr\xe6fiks",lastName:"Efternavn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldigt mobilnummer",city:"By",postalCode:"Postnummer",countryCode:"Landekode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-mailadresse",gender:"K\xf8n",male:"Mand",female:"Kvinde",billingAddress:"Faktureringsadresse",street:"Gade",stateOrProvince:"Region eller kommune",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Angiv en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Lejlighed/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Stat","field.title.optional":"(valgfrit)","creditCard.cvcField.title.optional":"CVC / CVV (valgfrit)","issuerList.wallet.placeholder":"V\xe6lg tegnebog",privacyPolicy:"Politik om privatlivets fred","afterPay.agreement":"Jeg accepterer AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5bn appen","voucher.readInstructions":"L\xe6s anvisningerne","voucher.introduction":"Tak for dit k\xf8b. Brug f\xf8lgende kupon til at gennemf\xf8re din betaling.","voucher.expirationDate":"Udl\xf8bsdato","voucher.alternativeReference":"Alternativ reference","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe6lg din udbyder","dragonpay.voucher.bank.selectField.placeholder":"V\xe6lg din bank","voucher.paymentReferenceLabel":"Betalingsreference","voucher.surcharge":"Inkl. till\xe6gsbegyr p\xe5 %@","voucher.introduction.doku":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.shopperName":"Kundenavn","voucher.merchantName":"S\xe6lger","voucher.introduction.econtext":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf8bers reference","voucher.collectionInstitutionNumber":"Id-nummer til opkr\xe6vningsinstitution","voucher.econtext.telephoneNumber.invalid":"Telefonnummer skal best\xe5 af 10 eller 11 cifre","boletobancario.btnLabel":"Gener\xe9r Boleto","boleto.sendCopyToEmail":"Send en kopi til min e-mail","button.copy":"Kopi\xe9r","button.download":"Download","boleto.socialSecurityNumber":"CPF / CNPJ","creditCard.storedCard.description.ariaLabel":"Gemt kort ender p\xe5 %@","voucher.entity":"Enhed",donateButton:"Giv et bidrag",notNowButton:"Ikke nu",thanksForYourSupport:"Tak for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkend med",confirmPreauthorization:"Bekr\xe6ft forh\xe5ndsgodkendelse",confirmPurchase:"Bekr\xe6ft k\xf8b",applyGiftcard:"Indl\xf8s",giftcardBalance:"Saldo p\xe5 gavekort",deductedBalance:"Fratrukket saldo","creditCard.pin.title":"Pinkode","creditCard.encryptedPassword.label":"F\xf8rste 2 cifre i adgangskode til kort","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig adgangskode","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (\xc5\xc5MMDD) eller virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.labelAlt":"Virksomheds registreringsnummer (10 cifre)","creditCard.taxNumber.invalid":"Ugyldig f\xf8dselsdato for kortholder eller virksomheds registreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern gemt betalingsm\xe5de","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Annuller","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontohavers navn","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ugyldigt kontohavernavn","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldigt kontonummer","ach.accountLocationField.title":"ABA-registreringsnummer","ach.accountLocationField.invalid":"Ugyldigt ABA-registreringsnummer","select.state":"V\xe6lg stat","select.stateOrProvince":"V\xe6lg region eller kommune","select.provinceOrTerritory":"V\xe6lg provins eller territorium","select.country":"V\xe6lg land","select.noOptionsFound":"Ingen muligheder fundet","select.filter.placeholder":"S\xf8g ...","telephoneNumber.invalid":"Ugyldigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling ...",generateQRCode:"Gener\xe9r QR-kode","await.waitForConfirmation":"Venter p\xe5 bekr\xe6ftelse","mbway.confirmPayment":"Bekr\xe6ft din betaling p\xe5 appen MB WAY","shopperEmail.invalid":"Ugyldig e-mailadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du skal v\xe6re mindst 18 \xe5r","blik.confirmPayment":"\xc5bn din bankapp for at bekr\xe6fte betalingen.","blik.invalid":"Indtast 6 tal","blik.code":"6-cifret kode","blik.help":"F\xe5 koden fra din bankapp.","swish.pendingMessage":"Visning af status kan tage op til 10 minutter efter scanning. Et nyt fors\xf8g p\xe5 betaling inden for dette tidsrum kan muligvis medf\xf8re flere gebyrer.","error.va.gen.01":"Felt ikke udfyldt","error.va.gen.02":"Ugyldigt felt","error.va.sf-cc-num.01":"Ugyldigt kortnummer","error.va.sf-cc-num.03":"Ikke-underst\xf8ttet kort indtastet","error.va.sf-cc-dat.01":"Kort for gammelt","error.va.sf-cc-dat.02":"Dato for langt ude i fremtiden","error.va.sf-cc-dat.03":"Dit kort udl\xf8ber f\xf8r betalingsdatoen","error.va.sf-ach-num.01":"Ugyldigt kontonummer","error.va.sf-ach-loc.01":"Ugyldigt ABA-registreringsnummer","error.va.sf-kcp-pwd.01":"Ugyldig adgangskode","error.giftcard.no-balance":"Saldoen p\xe5 gavekortet er 0","error.giftcard.card-error":"Vi har ikke et gavekort med dette nummer i vores optegnelser","error.giftcard.currency-error":"Gavekort er kun gyldige i udstedelsesvalutaen","amazonpay.signout":"Log ud af Amazon","amazonpay.changePaymentDetails":"Skift betalingsoplysninger","partialPayment.warning":"V\xe6lg en anden betalingsm\xe5de til betaling af restbel\xf8bet","partialPayment.remainingBalance":"Restbel\xf8bet vil v\xe6re %{amount}","bankTransfer.beneficiary":"Betalingsmodtager","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Reference","bankTransfer.introduction":"Forts\xe6t med at oprette ny betalingsoverf\xf8rsel via bank. Du kan bruge oplysningerne p\xe5 den f\xf8lgende sk\xe6rm til at afslutte betalingen.","bankTransfer.instructions":"Tak for dit k\xf8b. Brug f\xf8lgende oplysninger til at gennemf\xf8re din betaling.","bacs.accountHolderName":"Bankkontohavers navn","bacs.accountHolderName.invalid":"Ugyldigt navn p\xe5 bankkontohaver","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldigt bankkontonummer","bacs.bankLocationId":"Registreringsnummer","bacs.bankLocationId.invalid":"Ugyldigt registreringsnummer","bacs.consent.amount":"Jeg accepterer, at bel\xf8bet ovenfor tr\xe6kkes p\xe5 min bankkonto.","bacs.consent.account":"Jeg bekr\xe6fter, at kontoen er i mit navn, og at jeg er den eneste underskriver, der kr\xe6ves for at godkende direkte debitering af kontoen.",edit:"Rediger","bacs.confirm":"Bekr\xe6ft, og betal","bacs.result.introduction":"Download vejledningen til direkte debitering (fuldmagt til direkte debitering)","download.pdf":"Download PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe til sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe til udl\xf8bsdato for sikret kort","creditCard.encryptedExpiryDate.aria.label":"Felt til udl\xf8bsdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe til udl\xf8bsm\xe5ned for sikret kort","creditCard.encryptedExpiryMonth.aria.label":"Felt til udl\xf8bsm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe til udl\xf8bs\xe5r for sikret kort","creditCard.encryptedExpiryYear.aria.label":"Felt til udl\xf8bs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret kort","creditCard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe til nummer for sikret gavekort","giftcard.encryptedCardNumber.aria.label":"Felt til gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe til sikkerhedskode for sikret gavekort","giftcard.encryptedSecurityCode.aria.label":"Felt til sikkerhedskode for gavekort",giftcardTransactionLimit:"Maks. %{amount} tilladt pr. transaktion p\xe5 dette gavekort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe til sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Felt til bankkonto","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe til registreringsnummer for sikret bank","ach.encryptedBankLocationId.aria.label":"Felt til registreringsnummer for bank","twint.saved":"gemt"}}),Fk=Object.freeze({__proto__:null,default:{payButton:"Zahlen","payButton.redirecting":"Umleiten\xa0\u2026",storeDetails:"F\xfcr zuk\xfcnftige Zahlvorg\xe4nge speichern","creditCard.holderName":"Name auf der Karte","creditCard.holderName.placeholder":"A. M\xfcller","creditCard.holderName.invalid":"Ung\xfcltiger Karteninhabername","creditCard.numberField.title":"Kartennummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Ablaufdatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Monat","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jahr","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"F\xfcr das n\xe4chste Mal speichern","creditCard.cvcField.placeholder.4digits":"4 Stellen","creditCard.cvcField.placeholder.3digits":"3 Stellen","creditCard.taxNumber.placeholder":"JJMMTT/0123456789",installments:"Anzahl der Raten",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} Monate","installments.oneTime":"Einmalige Zahlung","installments.installments":"Ratenzahlung","installments.revolving":"Ratenzahlung","sepaDirectDebit.ibanField.invalid":"Ung\xfcltige Kontonummer","sepaDirectDebit.nameField.placeholder":"A. M\xfcller","sepa.ownerName":"Name des Kontoinhabers","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fehler","error.subtitle.redirect":"Weiterleitung fehlgeschlagen","error.subtitle.payment":"Zahlung fehlgeschlagen","error.subtitle.refused":"Zahlvorgang verweigert","error.message.unknown":"Es ist ein unbekannter Fehler aufgetreten.","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank ausw\xe4hlen","creditCard.success":"Zahlung erfolgreich",loading:"Laden \u2026",continue:"Weiter",continueTo:"Weiter zu","wechatpay.timetopay":"Sie haben noch %@ um zu zahlen","wechatpay.scanqrcode":"QR-Code scannen",personalDetails:"Pers\xf6nliche Angaben",companyDetails:"Unternehmensdaten","companyDetails.name":"Unternehmensname","companyDetails.registrationNumber":"Registrierungsnummer",socialSecurityNumber:"Sozialversicherungsnummer",firstName:"Vorname",infix:"Vorwahl",lastName:"Nachname",mobileNumber:"Handynummer","mobileNumber.invalid":"Ung\xfcltige Handynummer",city:"Stadt",postalCode:"Postleitzahl",countryCode:"Landesvorwahl",telephoneNumber:"Telefonnummer",dateOfBirth:"Geburtsdatum",shopperEmail:"E-Mail-Adresse",gender:"Geschlecht",male:"M\xe4nnlich",female:"Weiblich",billingAddress:"Rechnungsadresse",street:"Stra\xdfe",stateOrProvince:"Bundesland",country:"Land",houseNumberOrName:"Hausnummer",separateDeliveryAddress:"Abweichende Lieferadresse angeben",deliveryAddress:"Lieferadresse",zipCode:"PLZ",apartmentSuite:"Wohnung/Geschoss",provinceOrTerritory:"Provinz oder Territorium",cityTown:"Ort",address:"Stra\xdfe und Hausnummer",state:"Bundesstaat","field.title.optional":"(optional)","creditCard.cvcField.title.optional":"CVC / CVV (optional)","issuerList.wallet.placeholder":"Virtuelle Brieftasche ausw\xe4hlen",privacyPolicy:"Datenschutz","afterPay.agreement":"Ich bin mit den %@ von AfterPay einverstanden",paymentConditions:"Zahlungsbedingungen",openApp:"App \xf6ffnen","voucher.readInstructions":"Anweisungen lesen","voucher.introduction":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung des folgenden Gutscheins ab.","voucher.expirationDate":"G\xfcltig bis","voucher.alternativeReference":"Alternative Referenz","dragonpay.voucher.non.bank.selectField.placeholder":"Anbieter ausw\xe4hlen","dragonpay.voucher.bank.selectField.placeholder":"Bank ausw\xe4hlen","voucher.paymentReferenceLabel":"Zahlungsreferenz","voucher.surcharge":"Inkl. % @Zuschlag","voucher.introduction.doku":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.shopperName":"Name des K\xe4ufers","voucher.merchantName":"H\xe4ndler","voucher.introduction.econtext":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundenreferenz","voucher.collectionInstitutionNumber":"Nummer der Zahlungsannahmestelle","voucher.econtext.telephoneNumber.invalid":"Die Telefonnummer muss 10- oder 11-stellig sein","boletobancario.btnLabel":"Boleto generieren","boleto.sendCopyToEmail":"Eine Kopie an meine E-Mail-Adresse senden","button.copy":"Kopieren","button.download":"Herunterladen","creditCard.storedCard.description.ariaLabel":"Gespeicherte Karte endet auf %@","voucher.entity":"Entit\xe4t",donateButton:"Spenden",notNowButton:"Nicht jetzt",thanksForYourSupport:"Danke f\xfcr Ihre Unterst\xfctzung!",preauthorizeWith:"Vorautorisieren mit",confirmPreauthorization:"Vorautorisierung best\xe4tigen",confirmPurchase:"Kauf best\xe4tigen",applyGiftcard:"Einl\xf6sen",giftcardBalance:"Saldo der Geschenkkarte",deductedBalance:"Abgezogener Betrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Die ersten zwei Ziffern des Kartenpassworts","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ung\xfcltiges Passwort","creditCard.taxNumber.label":"Geburtsdatum des Karteninhabers (JJMMTT) oder Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.labelAlt":"Unternehmensregistrierungsnummer (10-stellig)","creditCard.taxNumber.invalid":"Ung\xfcltiges Geburtsdatum des Karteninhabers oder ung\xfcltige Unternehmensregistrierungsnummer","storedPaymentMethod.disable.button":"Entfernen","storedPaymentMethod.disable.confirmation":"Gespeicherte Zahlungsmethode entfernen","storedPaymentMethod.disable.confirmButton":"Ja, entfernen","storedPaymentMethod.disable.cancelButton":"Abbrechen","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Name des Kontoinhabers","ach.accountHolderNameField.placeholder":"A. M\xfcller","ach.accountHolderNameField.invalid":"Ung\xfcltiger Kontoinhabername","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ung\xfcltige Kontonummer","ach.accountLocationField.title":"ABA-Nummer","ach.accountLocationField.invalid":"Ung\xfcltige ABA-Nummer","select.state":"Bundesstaat ausw\xe4hlen","select.stateOrProvince":"Bundesland oder Provinz/Region ausw\xe4hlen","select.provinceOrTerritory":"Provinz oder Territorium ausw\xe4hlen","select.country":"Land ausw\xe4hlen","select.noOptionsFound":"Keine Optionen gefunden","select.filter.placeholder":"Suche\xa0\u2026","telephoneNumber.invalid":"Ung\xfcltige Telefonnummer",qrCodeOrApp:"oder","paypal.processingPayment":"Zahlung wird verarbeitet\xa0\u2026",generateQRCode:"QR-Code generieren","await.waitForConfirmation":"Warten auf Best\xe4tigung","mbway.confirmPayment":"Best\xe4tigen Sie Ihre Zahlung in der MB WAY-App","shopperEmail.invalid":"Ung\xfcltige E-Mail-Adresse","dateOfBirth.format":"TT.MM.JJJJ","dateOfBirth.invalid":"Sie m\xfcssen mindestens 18 Jahre alt sein","blik.confirmPayment":"\xd6ffnen Sie Ihre Banking-App, um die Zahlung zu best\xe4tigen.","blik.invalid":"6 Zahlen eingeben","blik.code":"6-stelliger Code","blik.help":"Rufen Sie den Code \xfcber Ihre Banking-App ab.","swish.pendingMessage":"Es kann sein, dass der Status bis zu 10 Minuten nach dem Scan \u201eausstehend\u201c lautet. Wenn Sie w\xe4hrenddessen einen neuen Zahlungsversuch unternehmen, kann es sein, dass Ihnen mehrere Betr\xe4ge in Rechnung gestellt werden.","error.va.gen.01":"Feld nicht ausgef\xfcllt","error.va.gen.02":"Feld ung\xfcltig","error.va.sf-cc-num.01":"Ung\xfcltige Kartennummer","error.va.sf-cc-num.03":"Nicht unterst\xfctzte Karte eingegeben","error.va.sf-cc-dat.01":"Karte zu alt","error.va.sf-cc-dat.02":"Datum zu weit in der Zukunft","error.va.sf-cc-dat.03":"Ihre Karte l\xe4uft vor dem Bezahldatum ab.","error.va.sf-ach-num.01":"Ung\xfcltige Kontonummer","error.va.sf-ach-loc.01":"Ung\xfcltige ABA-Nummer","error.va.sf-kcp-pwd.01":"Ung\xfcltiges Passwort","error.giftcard.no-balance":"Auf dieser Geschenkkarte ist kein Guthaben vorhanden","error.giftcard.card-error":"Es gibt in unserem System keine Geschenkkarte mit dieser Nummer","error.giftcard.currency-error":"Geschenkkarten sind nur in der W\xe4hrung g\xfcltig, in der sie ausgestellt wurden","amazonpay.signout":"Von Amazon abmelden","amazonpay.changePaymentDetails":"Zahlungsinformationen \xe4ndern","partialPayment.warning":"W\xe4hlen Sie eine andere Zahlungsmethode zur Zahlung des Restbetrags","partialPayment.remainingBalance":"Es verbleibt ein Restbetrag von %{amount}","bankTransfer.beneficiary":"Empf\xe4nger","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenz","bankTransfer.introduction":"Fortfahren, um eine neue Bank\xfcberweisungszahlung zu erstellen. Sie k\xf6nnen die Informationen auf dem n\xe4chsten Bildschirm verwenden, um diese Zahlung abzuschlie\xdfen.","bankTransfer.instructions":"Vielen Dank f\xfcr Ihren Kauf. Bitte schlie\xdfen Sie Ihre Zahlung unter Verwendung der folgenden Informationen ab.","bacs.accountHolderName":"Name des Bankkontoinhabers","bacs.accountHolderName.invalid":"Ung\xfcltiger Bankkontoinhabername","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ung\xfcltige Bankkontonummer","bacs.bankLocationId":"Bankleitzahl","bacs.bankLocationId.invalid":"Ung\xfcltige Bankleitzahl","bacs.consent.amount":"Ich bin damit einverstanden, dass der oben genannte Betrag von meinem Bankkonto abgebucht wird.","bacs.consent.account":"Ich best\xe4tige, dass das Konto unter meinem Namen l\xe4uft und ich der einzige erforderliche Unterzeichner bin, um die Lastschrift f\xfcr dieses Konto zu autorisieren.",edit:"Bearbeiten","bacs.confirm":"Best\xe4tigen und bezahlen","bacs.result.introduction":"Laden Sie Ihre Lastschriftanweisung (DDI/Einzugserm\xe4chtigung) herunter","download.pdf":"PDF herunterladen","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Nummer der gesicherten Karte","creditCard.encryptedCardNumber.aria.label":"Feld \u201eKartennummer\u201c","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xfcr Ablaufdatum der gesicherten Karte","creditCard.encryptedExpiryDate.aria.label":"Feld \u201eAblaufdatum\u201c","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xfcr Monat des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryMonth.aria.label":"Feld \u201eMonat des Ablaufdatums\u201c","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xfcr Jahr des Ablaufdatums der gesicherten Karte","creditCard.encryptedExpiryYear.aria.label":"Feld \u201eJahr des Ablaufdatums\u201c","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Karte","creditCard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode\u201c","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xfcr Geschenkkartennummer der gesicherten Karte","giftcard.encryptedCardNumber.aria.label":"Feld \u201eGeschenkkartennummer\u201c","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xfcr Sicherheitscode der gesicherten Geschenkkarte","giftcard.encryptedSecurityCode.aria.label":"Feld \u201eSicherheitscode der Geschenkkarte\u201c",giftcardTransactionLimit:"Der zul\xe4ssige H\xf6chstbetrag pro Transaktion f\xfcr diese Geschenkkarte ist %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xfcr gesicherte Bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Feld \u201eBankkonto\u201c","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xfcr gesicherte BLZ","ach.encryptedBankLocationId.aria.label":"Bankleitzahl-Feld","twint.saved":"hinterlegt"}}),Dk=Object.freeze({__proto__:null,default:{payButton:"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","payButton.redirecting":"\u0391\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7...",storeDetails:"\u0391\u03c0\u03bf\u03b8\u03ae\u03ba\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03bf\u03c5","creditCard.holderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03c3\u03c4\u03b7\u03bd \u03ba\u03ac\u03c1\u03c4\u03b1","creditCard.holderName.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","creditCard.holderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.expiryDateField.placeholder":"\u039c\u039c/\u0395\u0395","creditCard.expiryDateField.month":"\u039c\u03ae\u03bd\u03b1\u03c2","creditCard.expiryDateField.month.placeholder":"\u039c\u039c","creditCard.expiryDateField.year.placeholder":"\u0395\u0395","creditCard.expiryDateField.year":"\u0388\u03c4\u03bf\u03c2","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0391\u03c0\u03bf\u03bc\u03bd\u03b7\u03bc\u03cc\u03bd\u03b5\u03c5\u03c3\u03b7 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03b7 \u03c6\u03bf\u03c1\u03ac","creditCard.cvcField.placeholder.4digits":"4\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.cvcField.placeholder.3digits":"3\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2","creditCard.taxNumber.placeholder":"\u0395\u0395\u039c\u039c\u0397\u0397 / 0123456789",installments:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03cc\u03c3\u03b5\u03c9\u03bd",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u03bc\u03ae\u03bd\u03b5\u03c2","installments.oneTime":"\u0395\u03c6\u03ac\u03c0\u03b1\u03be \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","installments.installments":"\u03a0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03b5 \u03b4\u03cc\u03c3\u03b5\u03b9\u03c2","installments.revolving":"\u0391\u03bd\u03b1\u03ba\u03c5\u03ba\u03bb\u03bf\u03cd\u03bc\u03b5\u03bd\u03b7 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","sepaDirectDebit.ibanField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","sepaDirectDebit.nameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","sepa.ownerName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5","sepa.ibanNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd (IBAN)","error.title":"\u03a3\u03c6\u03ac\u03bb\u03bc\u03b1","error.subtitle.redirect":"\u0397 \u03b1\u03bd\u03b1\u03ba\u03b1\u03c4\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.payment":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03ad\u03c4\u03c5\u03c7\u03b5","error.subtitle.refused":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03af\u03c6\u03b8\u03b7\u03ba\u03b5","error.message.unknown":"\u03a0\u03c1\u03bf\u03ad\u03ba\u03c5\u03c8\u03b5 \u03ac\u03b3\u03bd\u03c9\u03c3\u03c4\u03bf \u03c3\u03c6\u03ac\u03bb\u03bc\u03b1","idealIssuer.selectField.title":"\u03a4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1","idealIssuer.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","creditCard.success":"\u0397 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03b8\u03b7\u03ba\u03b5 \u03b5\u03c0\u03b9\u03c4\u03c5\u03c7\u03ce\u03c2",loading:"\u03a6\u03cc\u03c1\u03c4\u03c9\u03c3\u03b7...",continue:"\u03a3\u03c5\u03bd\u03ad\u03c7\u03b5\u03b9\u03b1",continueTo:"\u039c\u03b5\u03c4\u03ac\u03b2\u03b1\u03c3\u03b7 \u03c3\u03c4\u03b7\u03bd","wechatpay.timetopay":"\u0388\u03c7\u03b5\u03c4\u03b5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03ac\u03b8\u03b5\u03c3\u03ae \u03c3\u03b1\u03c2 %@ \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","wechatpay.scanqrcode":"\u03a3\u03ac\u03c1\u03c9\u03c3\u03b7 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR",personalDetails:"\u03a0\u03c1\u03bf\u03c3\u03c9\u03c0\u03b9\u03ba\u03ac \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1",companyDetails:"\u03a3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.name":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03af\u03b1\u03c2","companyDetails.registrationNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",socialSecurityNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c6\u03bf\u03c1\u03bf\u03bb\u03bf\u03b3\u03b9\u03ba\u03bf\u03cd \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5",firstName:"\u038c\u03bd\u03bf\u03bc\u03b1",infix:"\u03a0\u03c1\u03cc\u03b8\u03b5\u03bc\u03b1",lastName:"\u0395\u03c0\u03ce\u03bd\u03c5\u03bc\u03bf",mobileNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd","mobileNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03b9\u03bd\u03b7\u03c4\u03bf\u03cd",city:"\u03a0\u03cc\u03bb\u03b7",postalCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2",countryCode:"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c7\u03ce\u03c1\u03b1\u03c2",telephoneNumber:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",dateOfBirth:"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2",shopperEmail:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email",gender:"\u03a6\u03cd\u03bb\u03bf",male:"\u0386\u03bd\u03c4\u03c1\u03b1\u03c2",female:"\u0393\u03c5\u03bd\u03b1\u03af\u03ba\u03b1",billingAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c4\u03b9\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2",street:"\u039f\u03b4\u03cc\u03c2",stateOrProvince:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1",country:"\u03a7\u03ce\u03c1\u03b1",houseNumberOrName:"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bf\u03b9\u03ba\u03af\u03b1\u03c2",separateDeliveryAddress:"\u039a\u03b1\u03b8\u03bf\u03c1\u03af\u03c3\u03c4\u03b5 \u03bc\u03b9\u03b1 \u03be\u03b5\u03c7\u03c9\u03c1\u03b9\u03c3\u03c4\u03ae \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",deliveryAddress:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 \u03c0\u03b1\u03c1\u03ac\u03b4\u03bf\u03c3\u03b7\u03c2",zipCode:"\u03a4\u03b1\u03c7\u03c5\u03b4\u03c1\u03bf\u03bc\u03b9\u03ba\u03cc\u03c2 \u03ba\u03ce\u03b4\u03b9\u03ba\u03b1\u03c2",apartmentSuite:"\u0394\u03b9\u03b1\u03bc\u03ad\u03c1\u03b9\u03c3\u03bc\u03b1/\u0393\u03c1\u03b1\u03c6\u03b5\u03af\u03bf",provinceOrTerritory:"\u0395\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1",cityTown:"\u03a0\u03cc\u03bb\u03b7 / \u039a\u03bf\u03b9\u03bd\u03cc\u03c4\u03b7\u03c4\u03b1",address:"\u0394\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7",state:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","field.title.optional":"(\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03cc)","creditCard.cvcField.title.optional":"CVC/CVV (\u03c0\u03c1\u03bf\u03b1\u03b9\u03c1\u03b5\u03c4\u03b9\u03ba\u03ac)","issuerList.wallet.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf \u03c0\u03bf\u03c1\u03c4\u03bf\u03c6\u03cc\u03bb\u03b9 \u03c3\u03b1\u03c2",privacyPolicy:"\u03a0\u03bf\u03bb\u03b9\u03c4\u03b9\u03ba\u03ae \u03b1\u03c0\u03bf\u03c1\u03c1\u03ae\u03c4\u03bf\u03c5","afterPay.agreement":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03c4\u03bf\u03c5\u03c2 %@ \u03c4\u03bf\u03c5 AfterPay",paymentConditions:"\u03cc\u03c1\u03bf\u03c5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2",openApp:"\u0386\u03bd\u03bf\u03b9\u03b3\u03bc\u03b1 \u03c4\u03b7\u03c2 \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae\u03c2","voucher.readInstructions":"\u0394\u03b9\u03b1\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03bf\u03b4\u03b7\u03b3\u03af\u03b5\u03c2","voucher.introduction":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03bf \u03c0\u03b1\u03c1\u03b1\u03ba\u03ac\u03c4\u03c9 \u03ba\u03bf\u03c5\u03c0\u03cc\u03bd\u03b9 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.expirationDate":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","voucher.alternativeReference":"\u0395\u03bd\u03b1\u03bb\u03bb\u03b1\u03ba\u03c4\u03b9\u03ba\u03ae \u03b1\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","dragonpay.voucher.non.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03bf\u03bd \u03c0\u03ac\u03c1\u03bf\u03c7\u03cc \u03c3\u03b1\u03c2","dragonpay.voucher.bank.selectField.placeholder":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03ac \u03c3\u03b1\u03c2","voucher.paymentReferenceLabel":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","voucher.surcharge":"\u03a0\u03b5\u03c1\u03b9\u03bb\u03b1\u03bc\u03b2\u03ac\u03bd\u03b5\u03c4\u03b1\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7 %@","voucher.introduction.doku":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.shopperName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.merchantName":"\u0388\u03bc\u03c0\u03bf\u03c1\u03bf\u03c2","voucher.introduction.econtext":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","voucher.telephoneNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5","voucher.shopperReference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac \u03b1\u03b3\u03bf\u03c1\u03b1\u03c3\u03c4\u03ae","voucher.collectionInstitutionNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c0\u03c1\u03b1\u03ba\u03c4\u03bf\u03c1\u03b5\u03af\u03bf\u03c5 \u03b5\u03b9\u03c3\u03c0\u03c1\u03ac\u03be\u03b5\u03c9\u03bd","voucher.econtext.telephoneNumber.invalid":"\u039f \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5 \u03c0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03c0\u03b5\u03c1\u03b9\u03ad\u03c7\u03b5\u03b9 10 \u03ae 11 \u03c8\u03b7\u03c6\u03af\u03b1","boletobancario.btnLabel":"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 Boleto","boleto.sendCopyToEmail":"\u0391\u03c0\u03bf\u03c3\u03c4\u03bf\u03bb\u03ae \u03b1\u03bd\u03c4\u03b9\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5 \u03c3\u03c4\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email \u03bc\u03bf\u03c5","button.copy":"\u0391\u03bd\u03c4\u03b9\u03b3\u03c1\u03b1\u03c6\u03ae","button.download":"\u039b\u03ae\u03c8\u03b7","creditCard.storedCard.description.ariaLabel":"\u0397 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c4\u03b5\u03bb\u03b5\u03b9\u03ce\u03bd\u03b5\u03b9 \u03c3\u03b5 %@","voucher.entity":"\u039f\u03bd\u03c4\u03cc\u03c4\u03b7\u03c4\u03b1",donateButton:"\u0394\u03c9\u03c1\u03b5\u03ac",notNowButton:"\u038c\u03c7\u03b9 \u03c4\u03ce\u03c1\u03b1",thanksForYourSupport:"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03c5\u03c0\u03bf\u03c3\u03c4\u03ae\u03c1\u03b9\u03be\u03b7!",preauthorizeWith:"\u03a0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03bc\u03b5",confirmPreauthorization:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03c0\u03c1\u03bf\u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7\u03c2",confirmPurchase:"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03b1\u03b3\u03bf\u03c1\u03ac\u03c2",applyGiftcard:"\u0395\u03be\u03b1\u03c1\u03b3\u03cd\u03c1\u03c9\u03c3\u03b7",giftcardBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",deductedBalance:"\u03a5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03c0\u03bf\u03c5 \u03b1\u03c6\u03b1\u03b9\u03c1\u03ad\u03b8\u03b7\u03ba\u03b5","creditCard.pin.title":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 PIN","creditCard.encryptedPassword.label":"\u03a4\u03b1 \u03c0\u03c1\u03ce\u03c4\u03b1 2 \u03c8\u03b7\u03c6\u03af\u03b1 \u03c4\u03bf\u03c5 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2 \u03c4\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","creditCard.taxNumber.label":"\u0397\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 (YYMMDD) \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.labelAlt":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd (10 \u03c8\u03b7\u03c6\u03af\u03b1)","creditCard.taxNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b3\u03ad\u03bd\u03bd\u03b7\u03c3\u03b7\u03c2 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2 \u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bc\u03b7\u03c4\u03c1\u03ce\u03bf\u03c5 \u03b5\u03c4\u03b1\u03b9\u03c1\u03b5\u03b9\u03ce\u03bd","storedPaymentMethod.disable.button":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.confirmation":"\u0391\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7 \u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03c5\u03bc\u03ad\u03bd\u03bf\u03c5 \u03c4\u03c1\u03cc\u03c0\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","storedPaymentMethod.disable.confirmButton":"\u039d\u03b1\u03b9, \u03b1\u03c6\u03b1\u03af\u03c1\u03b5\u03c3\u03b7","storedPaymentMethod.disable.cancelButton":"\u0386\u03ba\u03c5\u03c1\u03bf","ach.bankAccount":"\u03a4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2","ach.accountHolderNameField.title":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountHolderNameField.placeholder":"\u0393. \u03a0\u03b1\u03c0\u03b1\u03b4\u03ac\u03ba\u03b7\u03c2","ach.accountHolderNameField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03ba\u03b1\u03c4\u03cc\u03c7\u03bf\u03c5 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountNumberField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.accountLocationField.title":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","ach.accountLocationField.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","select.state":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1","select.stateOrProvince":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c0\u03bf\u03bb\u03b9\u03c4\u03b5\u03af\u03b1 \u03ae \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1","select.provinceOrTerritory":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03b5\u03c0\u03b1\u03c1\u03c7\u03af\u03b1 \u03ae \u03c0\u03b5\u03c1\u03b9\u03c6\u03ad\u03c1\u03b5\u03b9\u03b1","select.country":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03c7\u03ce\u03c1\u03b1","select.noOptionsFound":"\u0394\u03b5\u03bd \u03b2\u03c1\u03ad\u03b8\u03b7\u03ba\u03b1\u03bd \u03b5\u03c0\u03b9\u03bb\u03bf\u03b3\u03ad\u03c2","select.filter.placeholder":"\u0391\u03bd\u03b1\u03b6\u03ae\u03c4\u03b7\u03c3\u03b7...","telephoneNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03b7\u03bb\u03b5\u03c6\u03ce\u03bd\u03bf\u03c5",qrCodeOrApp:"\u03ae","paypal.processingPayment":"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2...",generateQRCode:"\u0394\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03af\u03b1 \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd QR","await.waitForConfirmation":"\u0391\u03bd\u03b1\u03bc\u03bf\u03bd\u03ae \u03b3\u03b9\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7\u2026","mbway.confirmPayment":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03c3\u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae MB WAY","shopperEmail.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03b7 \u03b4\u03b9\u03b5\u03cd\u03b8\u03c5\u03bd\u03c3\u03b7 email","dateOfBirth.format":"\u0397\u0397/\u039c\u039c/\u0395\u0395\u0395\u0395","dateOfBirth.invalid":"\u03a0\u03c1\u03ad\u03c0\u03b5\u03b9 \u03bd\u03b1 \u03b5\u03af\u03c3\u03c4\u03b5 \u03c4\u03bf\u03c5\u03bb\u03ac\u03c7\u03b9\u03c3\u03c4\u03bf\u03bd 18 \u03b5\u03c4\u03ce\u03bd","blik.confirmPayment":"\u0391\u03bd\u03bf\u03af\u03be\u03c4\u03b5 \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b5\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","blik.invalid":"\u0395\u03b9\u03c3\u03b1\u03b3\u03ac\u03b3\u03b5\u03c4\u03b5 6 \u03c8\u03b7\u03c6\u03af\u03b1","blik.code":"6\u03c8\u03ae\u03c6\u03b9\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2","blik.help":"\u039b\u03ac\u03b2\u03b5\u03c4\u03b5 \u03c4\u03bf\u03bd \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b5\u03c6\u03b1\u03c1\u03bc\u03bf\u03b3\u03ae \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03c3\u03b1\u03c2.","swish.pendingMessage":"\u039c\u03b5\u03c4\u03ac \u03c4\u03b7 \u03c3\u03ac\u03c1\u03c9\u03c3\u03b7, \u03b7 \u03ba\u03b1\u03c4\u03ac\u03c3\u03c4\u03b1\u03c3\u03b7 \u03bc\u03c0\u03bf\u03c1\u03b5\u03af \u03bd\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03b5\u03ba\u03ba\u03c1\u03b5\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ad\u03c9\u03c2 10 \u03bb\u03b5\u03c0\u03c4\u03ac. \u0397 \u03b1\u03c0\u03cc\u03c0\u03b5\u03b9\u03c1\u03b1 \u03b5\u03ba \u03bd\u03ad\u03bf\u03c5 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b5\u03bd\u03c4\u03cc\u03c2 \u03b1\u03c5\u03c4\u03bf\u03cd \u03c4\u03bf\u03c5 \u03c7\u03c1\u03bf\u03bd\u03b9\u03ba\u03bf\u03cd \u03b4\u03b9\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03b5\u03bd\u03b4\u03ad\u03c7\u03b5\u03c4\u03b1\u03b9 \u03bd\u03b1 \u03c0\u03c1\u03bf\u03ba\u03b1\u03bb\u03ad\u03c3\u03b5\u03b9 \u03c0\u03c1\u03cc\u03c3\u03b8\u03b5\u03c4\u03b7 \u03c7\u03c1\u03ad\u03c9\u03c3\u03b7.","error.va.gen.01":"\u0395\u03bb\u03bb\u03b9\u03c0\u03ad\u03c2 \u03c0\u03b5\u03b4\u03af\u03bf","error.va.gen.02":"\u03a4\u03bf \u03c0\u03b5\u03b4\u03af\u03bf \u03b4\u03b5\u03bd \u03b5\u03af\u03bd\u03b1\u03b9 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf","error.va.sf-cc-num.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","error.va.sf-cc-num.03":"\u0395\u03b9\u03c3\u03ac\u03c7\u03b8\u03b7\u03ba\u03b5 \u03bc\u03b7 \u03c5\u03c0\u03bf\u03c3\u03c4\u03b7\u03c1\u03b9\u03b6\u03cc\u03bc\u03b5\u03bd\u03b7 \u03ba\u03ac\u03c1\u03c4\u03b1","error.va.sf-cc-dat.01":"\u0397 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03c0\u03b1\u03bb\u03b9\u03ac","error.va.sf-cc-dat.02":"\u0397 \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c0\u03bf\u03bb\u03cd \u03bc\u03b1\u03ba\u03c1\u03b9\u03bd\u03ae","error.va.sf-cc-dat.03":"\u0397 \u03ba\u03ac\u03c1\u03c4\u03b1 \u03c3\u03b1\u03c2 \u03bb\u03ae\u03b3\u03b5\u03b9 \u03c0\u03c1\u03b9\u03bd \u03b1\u03c0\u03cc \u03c4\u03b7\u03bd \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03b1\u03bd\u03b1\u03c7\u03ce\u03c1\u03b7\u03c3\u03b7\u03c2","error.va.sf-ach-num.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","error.va.sf-ach-loc.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03b4\u03c1\u03bf\u03bc\u03bf\u03bb\u03cc\u03b3\u03b7\u03c3\u03b7\u03c2 ABA","error.va.sf-kcp-pwd.01":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c0\u03c1\u03cc\u03c3\u03b2\u03b1\u03c3\u03b7\u03c2","error.giftcard.no-balance":"\u0397 \u03c3\u03c5\u03b3\u03ba\u03b5\u03ba\u03c1\u03b9\u03bc\u03ad\u03bd\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03ad\u03c7\u03b5\u03b9 \u03bc\u03b7\u03b4\u03b5\u03bd\u03b9\u03ba\u03cc \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf","error.giftcard.card-error":"\u03a3\u03c4\u03b1 \u03b1\u03c1\u03c7\u03b5\u03af\u03b1 \u03bc\u03b1\u03c2 \u03b4\u03b5\u03bd \u03c5\u03c0\u03ac\u03c1\u03c7\u03b5\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03bc\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc","error.giftcard.currency-error":"\u039f\u03b9 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b5\u03c2 \u03b9\u03c3\u03c7\u03cd\u03bf\u03c5\u03bd \u03bc\u03cc\u03bd\u03bf \u03b3\u03b9\u03b1 \u03c4\u03bf \u03bd\u03cc\u03bc\u03b9\u03c3\u03bc\u03b1 \u03c3\u03c4\u03bf \u03bf\u03c0\u03bf\u03af\u03bf \u03b5\u03ba\u03b4\u03cc\u03b8\u03b7\u03ba\u03b1\u03bd","amazonpay.signout":"\u0391\u03c0\u03bf\u03c3\u03cd\u03bd\u03b4\u03b5\u03c3\u03b7 \u03b1\u03c0\u03cc \u03c4\u03bf Amazon","amazonpay.changePaymentDetails":"\u0391\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03c9\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2","partialPayment.warning":"\u0395\u03c0\u03b9\u03bb\u03ad\u03be\u03c4\u03b5 \u03ad\u03bd\u03b1\u03bd \u03ac\u03bb\u03bb\u03bf \u03c4\u03c1\u03cc\u03c0\u03bf \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae\u03c2 \u03b3\u03b9\u03b1 \u03ba\u03b1\u03c4\u03b1\u03b2\u03bf\u03bb\u03ae \u03c4\u03bf\u03c5 \u03b5\u03bd\u03b1\u03c0\u03bf\u03bc\u03b5\u03af\u03bd\u03b1\u03bd\u03c4\u03bf\u03c2 \u03c0\u03bf\u03c3\u03bf\u03cd","partialPayment.remainingBalance":"\u03a4\u03bf \u03c5\u03c0\u03cc\u03bb\u03bf\u03b9\u03c0\u03bf \u03b8\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","bankTransfer.beneficiary":"\u0394\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c2","bankTransfer.iban":"\u0399\u0392\u0391\u039d","bankTransfer.bic":"BIC","bankTransfer.reference":"\u0391\u03bd\u03b1\u03c6\u03bf\u03c1\u03ac","bankTransfer.introduction":"\u03a3\u03c5\u03bd\u03b5\u03c7\u03af\u03c3\u03c4\u03b5 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03b4\u03b7\u03bc\u03b9\u03bf\u03c5\u03c1\u03b3\u03ae\u03c3\u03b5\u03c4\u03b5 \u03bd\u03ad\u03b1 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae \u03bc\u03ad\u03c3\u03c9 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03ae\u03c2 \u03bc\u03b5\u03c4\u03b1\u03c6\u03bf\u03c1\u03ac\u03c2. \u039c\u03c0\u03bf\u03c1\u03b5\u03af\u03c4\u03b5 \u03bd\u03b1 \u03c7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b1 \u03c3\u03c4\u03bf\u03b9\u03c7\u03b5\u03af\u03b1 \u03c3\u03c4\u03b7\u03bd \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b7 \u03bf\u03b8\u03cc\u03bd\u03b7 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bankTransfer.instructions":"\u03a3\u03b1\u03c2 \u03b5\u03c5\u03c7\u03b1\u03c1\u03b9\u03c3\u03c4\u03bf\u03cd\u03bc\u03b5 \u03b3\u03b9\u03b1 \u03c4\u03b7\u03bd \u03b1\u03b3\u03bf\u03c1\u03ac. \u03a7\u03c1\u03b7\u03c3\u03b9\u03bc\u03bf\u03c0\u03bf\u03b9\u03ae\u03c3\u03c4\u03b5 \u03c4\u03b9\u03c2 \u03b1\u03ba\u03cc\u03bb\u03bf\u03c5\u03b8\u03b5\u03c2 \u03c0\u03bb\u03b7\u03c1\u03bf\u03c6\u03bf\u03c1\u03af\u03b5\u03c2 \u03b3\u03b9\u03b1 \u03bd\u03b1 \u03bf\u03bb\u03bf\u03ba\u03bb\u03b7\u03c1\u03ce\u03c3\u03b5\u03c4\u03b5 \u03c4\u03b7\u03bd \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae.","bacs.accountHolderName":"\u038c\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountHolderName.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf \u03cc\u03bd\u03bf\u03bc\u03b1 \u03b4\u03b9\u03ba\u03b1\u03b9\u03bf\u03cd\u03c7\u03bf\u03c5 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber":"\u0391\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.accountNumber.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc\u03c2 \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","bacs.bankLocationId":"\u039a\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.bankLocationId.invalid":"\u039c\u03b7 \u03ad\u03b3\u03ba\u03c5\u03c1\u03bf\u03c2 \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","bacs.consent.amount":"\u0391\u03c0\u03bf\u03b4\u03ad\u03c7\u03bf\u03bc\u03b1\u03b9 \u03cc\u03c4\u03b9 \u03c4\u03bf \u03c0\u03b9\u03bf \u03c0\u03ac\u03bd\u03c9 \u03c0\u03bf\u03c3\u03cc \u03b8\u03b1 \u03b1\u03c6\u03b1\u03b9\u03c1\u03b5\u03b8\u03b5\u03af \u03b1\u03c0\u03cc \u03c4\u03bf\u03bd \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03cc \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc \u03bc\u03bf\u03c5.","bacs.consent.account":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03b9\u03ce\u03bd\u03c9 \u03cc\u03c4\u03b9 \u03bf \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc\u03c2 \u03b5\u03af\u03bd\u03b1\u03b9 \u03c3\u03c4\u03bf \u03cc\u03bd\u03bf\u03bc\u03ac \u03bc\u03bf\u03c5 \u03ba\u03b1\u03b9 \u03c0\u03c9\u03c2 \u03b5\u03af\u03bc\u03b1\u03b9 \u03bf/\u03b7 \u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03cc\u03c2/\u03bc\u03bf\u03bd\u03b1\u03b4\u03b9\u03ba\u03ae \u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03c9\u03bd/\u03c5\u03c0\u03bf\u03b3\u03c1\u03ac\u03c6\u03bf\u03c5\u03c3\u03b1 \u03c0\u03bf\u03c5 \u03b1\u03c0\u03b1\u03b9\u03c4\u03b5\u03af\u03c4\u03b1\u03b9 \u03b3\u03b9\u03b1 \u03b5\u03be\u03bf\u03c5\u03c3\u03b9\u03bf\u03b4\u03cc\u03c4\u03b7\u03c3\u03b7 \u03c4\u03b7\u03c2 \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 \u03c3\u03b5 \u03b1\u03c5\u03c4\u03cc\u03bd \u03c4\u03bf\u03bd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03cc.",edit:"\u0395\u03c0\u03b5\u03be\u03b5\u03c1\u03b3\u03b1\u03c3\u03af\u03b1","bacs.confirm":"\u0395\u03c0\u03b9\u03b2\u03b5\u03b2\u03b1\u03af\u03c9\u03c3\u03b7 \u03ba\u03b1\u03b9 \u03c0\u03bb\u03b7\u03c1\u03c9\u03bc\u03ae","bacs.result.introduction":"\u039a\u03b1\u03c4\u03b5\u03b2\u03ac\u03c3\u03c4\u03b5 \u03c4\u03b7\u03bd \u0395\u03bd\u03c4\u03bf\u03bb\u03ae \u0386\u03bc\u03b5\u03c3\u03b7\u03c2 \u03a7\u03c1\u03ad\u03c9\u03c3\u03b7\u03c2 (DDI/\u0395\u03bd\u03c4\u03bf\u03bb\u03ae)","download.pdf":"\u039b\u03ae\u03c8\u03b7 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryDate.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b7\u03bc\u03b5\u03c1\u03bf\u03bc\u03b7\u03bd\u03af\u03b1\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryMonth.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03bc\u03ae\u03bd\u03b1 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ad\u03c2 \u03ad\u03c4\u03bf\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedExpiryYear.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ad\u03c4\u03bf\u03c5\u03c2 \u03bb\u03ae\u03be\u03b7\u03c2","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","creditCard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedCardNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03ba\u03c9\u03b4\u03b9\u03ba\u03cc \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2","giftcard.encryptedSecurityCode.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03b1\u03c3\u03c6\u03b1\u03bb\u03b5\u03af\u03b1\u03c2 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1\u03c2",giftcardTransactionLimit:"\u03a4\u03bf \u03bc\u03ad\u03b3\u03b9\u03c3\u03c4\u03bf \u03b5\u03c0\u03b9\u03c4\u03c1\u03b5\u03c0\u03cc\u03bc\u03b5\u03bd\u03bf \u03c0\u03bf\u03c3\u03cc \u03b1\u03bd\u03ac \u03c3\u03c5\u03bd\u03b1\u03bb\u03bb\u03b1\u03b3\u03ae \u03c3\u03b5 \u03b1\u03c5\u03c4\u03ae\u03bd \u03c4\u03b7 \u03b4\u03c9\u03c1\u03bf\u03ba\u03ac\u03c1\u03c4\u03b1 \u03b5\u03af\u03bd\u03b1\u03b9 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankAccountNumber.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03c4\u03c1\u03b1\u03c0\u03b5\u03b6\u03b9\u03ba\u03bf\u03cd \u03bb\u03bf\u03b3\u03b1\u03c1\u03b9\u03b1\u03c3\u03bc\u03bf\u03cd","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u03b3\u03b9\u03b1 \u03b1\u03c3\u03c6\u03b1\u03bb\u03ae \u03b1\u03c1\u03b9\u03b8\u03bc\u03cc \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","ach.encryptedBankLocationId.aria.label":"\u03a0\u03b5\u03b4\u03af\u03bf \u03b1\u03c1\u03b9\u03b8\u03bc\u03bf\u03cd \u03ba\u03c9\u03b4\u03b9\u03ba\u03bf\u03cd \u03c5\u03c0\u03bf\u03ba\u03b1\u03c4\u03b1\u03c3\u03c4\u03ae\u03bc\u03b1\u03c4\u03bf\u03c2 \u03c4\u03c1\u03ac\u03c0\u03b5\u03b6\u03b1\u03c2","twint.saved":"\u03b1\u03c0\u03bf\u03b8\u03b7\u03ba\u03b5\u03cd\u03c4\u03b7\u03ba\u03b5"}}),Ak=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirigiendo...",storeDetails:"Recordar para mi pr\xf3ximo pago","creditCard.holderName":"Nombre en la tarjeta","creditCard.holderName.placeholder":"Juan P\xe9rez","creditCard.holderName.invalid":"Nombre del titular de tarjeta no v\xe1lido","creditCard.numberField.title":"N\xfamero de tarjeta","creditCard.expiryDateField.title":"Fecha de expiraci\xf3n","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mes","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"A\xf1o","creditCard.cvcField.title":"CVC / CVV","creditCard.storeDetailsButton":"Recordar para la pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAMMDD / 0123456789",installments:"N\xfamero de plazos",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0meses","installments.oneTime":"Pago \xfanico","installments.installments":"Pago fraccionado","installments.revolving":"Pago rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de cuenta no v\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nombre del titular de cuenta","sepa.ibanNumber":"N\xfamero de cuenta (IBAN)","error.title":"Error","error.subtitle.redirect":"Redirecci\xf3n fallida","error.subtitle.payment":"Pago fallido","error.subtitle.refused":"Pago rechazado","error.message.unknown":"Se ha producido un error desconocido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Seleccione su banco","creditCard.success":"Pago realizado correctamente",loading:"Cargando...",continue:"Continuar",continueTo:"Continuar a","wechatpay.timetopay":"Tiene %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Datos personales",companyDetails:"Datos de la empresa","companyDetails.name":"Nombre de la empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"N\xfamero de seguridad social",firstName:"Nombre",infix:"Prefijo",lastName:"Apellidos",mobileNumber:"Tel\xe9fono m\xf3vil","mobileNumber.invalid":"N\xfamero de m\xf3vil no v\xe1lido",city:"Ciudad",postalCode:"C\xf3digo postal",countryCode:"Prefijo internacional",telephoneNumber:"N\xfamero de tel\xe9fono",dateOfBirth:"Fecha de nacimiento",shopperEmail:"Direcci\xf3n de correo electr\xf3nico",gender:"G\xe9nero",male:"Masculino",female:"Femenino",billingAddress:"Direcci\xf3n de facturaci\xf3n",street:"Calle",stateOrProvince:"Provincia o estado",country:"Pa\xeds",houseNumberOrName:"N\xfamero de vivienda",separateDeliveryAddress:"Especificar otra direcci\xf3n de env\xedo",deliveryAddress:"Direcci\xf3n de env\xedo",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Ciudad/poblaci\xf3n",address:"Direcci\xf3n",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Seleccione su monedero electr\xf3nico",privacyPolicy:"Pol\xedtica de privacidad","afterPay.agreement":"S\xed, acepto las %@ de AfterPay",paymentConditions:"condiciones de pago",openApp:"Abrir la aplicaci\xf3n","voucher.readInstructions":"Leer instrucciones","voucher.introduction":"Gracias por su compra. Use el siguiente cup\xf3n para completar su pago.","voucher.expirationDate":"Fecha de caducidad","voucher.alternativeReference":"Referencia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Seleccione su proveedor","dragonpay.voucher.bank.selectField.placeholder":"Seleccione su banco","voucher.paymentReferenceLabel":"Referencia de pago","voucher.surcharge":"Incluye recargo de %@","voucher.introduction.doku":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.shopperName":"Nombre del comprador","voucher.merchantName":"Vendedor","voucher.introduction.econtext":"Gracias por su compra. Use la informaci\xf3n siguiente para completar su pago.","voucher.telephoneNumber":"N\xfamero de tel\xe9fono","voucher.shopperReference":"Referencia cliente","voucher.collectionInstitutionNumber":"N\xfamero de instituci\xf3n de cobro","voucher.econtext.telephoneNumber.invalid":"El n\xfamero de tel\xe9fono debe tener 10 u 11 d\xedgitos","boletobancario.btnLabel":"Generar Boleto","boleto.sendCopyToEmail":"Enviar copia a mi correo electr\xf3nico","button.copy":"Copiar","button.download":"Descargar","creditCard.storedCard.description.ariaLabel":"La tarjeta almacenada termina en %@","voucher.entity":"Entidad",donateButton:"Donar",notNowButton:"Ahora no",thanksForYourSupport:"\xa1Gracias por su contribuci\xf3n!",preauthorizeWith:"Preautorizar con",confirmPreauthorization:"Confirmar preautorizaci\xf3n",confirmPurchase:"Confirmar compra",applyGiftcard:"Canjear",giftcardBalance:"Saldo de la tarjeta regalo",deductedBalance:"Saldo deducido","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primeros 2 d\xedgitos de la contrase\xf1a de la tarjeta","creditCard.encryptedPassword.invalid":"Contrase\xf1a incorrecta","creditCard.taxNumber.label":"Fecha de nacimiento del titular de la tarjeta (AAMMDD) o n\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro comercial (10 d\xedgitos)","creditCard.taxNumber.invalid":"Fecha de nacimiento del titular o n\xfamero de registro comercial incorrectos","storedPaymentMethod.disable.button":"Eliminar","storedPaymentMethod.disable.confirmation":"Eliminar m\xe9todo de pago almacenado","storedPaymentMethod.disable.confirmButton":"S\xed, eliminar","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Cuenta bancaria","ach.accountHolderNameField.title":"Nombre del titular de la cuenta","ach.accountHolderNameField.placeholder":"Juan P\xe9rez","ach.accountHolderNameField.invalid":"El nombre del titular de la cuenta no es v\xe1lido","ach.accountNumberField.title":"N\xfamero de cuenta","ach.accountNumberField.invalid":"N\xfamero de cuenta no v\xe1lido","ach.accountLocationField.title":"N\xfamero de ruta ABA","ach.accountLocationField.invalid":"El n\xfamero de ruta ABA no es v\xe1lido","select.state":"Seleccione el estado","select.stateOrProvince":"Seleccione el estado o provincia","select.provinceOrTerritory":"Seleccione la provincia o territorio","select.country":"Seleccione el pa\xeds","select.noOptionsFound":"No se encontraron opciones","select.filter.placeholder":"Buscar...","telephoneNumber.invalid":"El n\xfamero de tel\xe9fono no es v\xe1lido",qrCodeOrApp:"o","paypal.processingPayment":"Procesando pago...",generateQRCode:"Generar c\xf3digo QR","await.waitForConfirmation":"Esperando confirmaci\xf3n","mbway.confirmPayment":"Confirme su pago en la aplicaci\xf3n MB WAY","shopperEmail.invalid":"La direcci\xf3n de correo electr\xf3nico no es v\xe1lida","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Debe ser mayor de 18 a\xf1os","blik.confirmPayment":"Abra la aplicaci\xf3n de su banco para confirmar el pago.","blik.invalid":"Introduzca 6 d\xedgitos","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Consiga el c\xf3digo en la aplicaci\xf3n de su banco.","swish.pendingMessage":"Tras escanearlo, su estado puede seguir en pendiente hasta 10\xa0minutos. Podr\xedan realizarse varios cargos si se intenta pagar de nuevo durante este periodo.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo no v\xe1lido","error.va.sf-cc-num.01":"N\xfamero de tarjeta no v\xe1lido","error.va.sf-cc-num.03":"Se ha introducido una tarjeta no admitida","error.va.sf-cc-dat.01":"Tarjeta demasiado vieja","error.va.sf-cc-dat.02":"Fecha con demasiada antelaci\xf3n","error.va.sf-cc-dat.03":"Su tarjeta caduca antes de la fecha de pago","error.va.sf-ach-num.01":"N\xfamero de cuenta no v\xe1lido","error.va.sf-ach-loc.01":"El n\xfamero de ruta ABA no es v\xe1lido","error.va.sf-kcp-pwd.01":"Contrase\xf1a incorrecta","error.giftcard.no-balance":"Esta tarjeta regalo no tiene saldo","error.giftcard.card-error":"No tenemos ninguna tarjeta regalo con este n\xfamero en nuestros registros.","error.giftcard.currency-error":"Las tarjetas regalo solo son v\xe1lidas en la moneda en que fueron emitidas","amazonpay.signout":"Salir de Amazon","amazonpay.changePaymentDetails":"Cambiar detalles de pago","partialPayment.warning":"Seleccione otro m\xe9todo de pago para pagar la cantidad restante","partialPayment.remainingBalance":"El saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.reference":"referencia","bankTransfer.introduction":"Contin\xfae para crear un nuevo pago mediante transferencia bancaria. Puede utilizar los detalles en la siguiente pantalla para finalizar este pago.","bankTransfer.instructions":"Gracias por su compra. Use la siguiente informaci\xf3n para completar su pago.","bacs.accountHolderName":"Nombre del titular de la cuenta bancaria","bacs.accountHolderName.invalid":"El nombre del titular de la cuenta bancaria no es v\xe1lido","bacs.accountNumber":"N\xfamero de cuenta bancaria","bacs.accountNumber.invalid":"El n\xfamero de cuenta bancaria no es v\xe1lido","bacs.bankLocationId":"C\xf3digo de sucursal","bacs.bankLocationId.invalid":"El c\xf3digo de sucursal no es v\xe1lido","bacs.consent.amount":"Estoy de acuerdo con que la cantidad anterior se deduzca de mi cuenta bancaria.","bacs.consent.account":"Confirmo que la cuenta est\xe1 a mi nombre y soy el \xfanico firmante necesario para autorizar d\xe9bitos directos en esta cuenta.",edit:"Editar","bacs.confirm":"Confirmar y pagar","bacs.result.introduction":"Descargue su instrucci\xf3n de d\xe9bito directo (IDD/mandato)","download.pdf":"Descargar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de tarjeta asegurada","creditCard.encryptedCardNumber.aria.label":"Campo del n\xfamero de tarjeta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe de la fecha de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryDate.aria.label":"Campo de la fecha de caducidad","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe del mes de caducidad de tarjeta asegurada","creditCard.encryptedExpiryMonth.aria.label":"Campo del mes de caducidad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe del a\xf1o de caducidad de la tarjeta asegurada","creditCard.encryptedExpiryYear.aria.label":"Campo del a\xf1o de caducidad","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta asegurada","creditCard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe del n\xfamero de la tarjeta de regalo asegurada","giftcard.encryptedCardNumber.aria.label":"Campo del n\xfamero de la tarjeta de regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe del c\xf3digo de seguridad de la tarjeta de regalo asegurada","giftcard.encryptedSecurityCode.aria.label":"Campo del c\xf3digo de seguridad de la tarjeta de regalo",giftcardTransactionLimit:"Se permite un m\xe1ximo de %{amount} por transacci\xf3n en esta tarjeta regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe del n\xfamero de la cuenta bancaria asegurada","ach.encryptedBankAccountNumber.aria.label":"Campo de la cuenta bancaria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe del n\xfamero de ruta del banco asegurado","ach.encryptedBankLocationId.aria.label":"Campo del n\xfamero de ruta del banco","twint.saved":"guardado"}}),Sk=Object.freeze({__proto__:null,default:{payButton:"Maksa","payButton.redirecting":"Uudelleenohjataan ...",storeDetails:"Tallenna seuraavaa maksuani varten","creditCard.holderName":"Nimi kortilla","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Ei-kelvollinen kortinhaltijan nimi","creditCard.numberField.title":"Kortin numero","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Voimassaolop\xe4iv\xe4m\xe4\xe4r\xe4","creditCard.expiryDateField.placeholder":"KK / VV","creditCard.expiryDateField.month":"Kuukausi","creditCard.expiryDateField.month.placeholder":"KK","creditCard.expiryDateField.year.placeholder":"VV","creditCard.expiryDateField.year":"Vuosi","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Muista seuraavalla kerralla","creditCard.cvcField.placeholder.4digits":"4 lukua","creditCard.cvcField.placeholder.3digits":"3 lukua","creditCard.taxNumber.placeholder":"VVKKPP / 0123456789",installments:"Asennusten m\xe4\xe4r\xe4",installmentOption:"% {kertaa} x% {osittainenarvo}",installmentOptionMonths:"% {kertaa} kuukautta","installments.oneTime":"Kertamaksu","installments.installments":"Er\xe4maksu","installments.revolving":"Toistuva maksu","sepaDirectDebit.ibanField.invalid":"V\xe4\xe4r\xe4 tilin numero","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Haltijan nimi","sepa.ibanNumber":"Tilinumero (IBAN)","error.title":"Virhe","error.subtitle.redirect":"Uuteen kohteeseen siirto ep\xe4onnistui","error.subtitle.payment":"Maksu ep\xe4nnistui","error.subtitle.refused":"Maksu hyl\xe4tty","error.message.unknown":"Tapahtui tuntematon virhe","idealIssuer.selectField.title":"Pankki","idealIssuer.selectField.placeholder":"Valitse pankkisi","creditCard.success":"Maksu onnistui",loading:"Ladataan...",continue:"Jatka",continueTo:"Jatka kohteeseen","wechatpay.timetopay":"Sinulla on %@ maksettavana","wechatpay.scanqrcode":"Skannaa QR-koodi",personalDetails:"Henkil\xf6tiedot",companyDetails:"Yhti\xf6n tiedot","companyDetails.name":"Yhti\xf6n nimi","companyDetails.registrationNumber":"Rekisterinumero",socialSecurityNumber:"Sosiaaliturvatunnus",firstName:"Etunimi",infix:"Etuliite",lastName:"Sukunimi",mobileNumber:"Matkapuhelinnumero","mobileNumber.invalid":"Ei-kelvollinen matkapuhelinnumero",city:"Kaupunki",postalCode:"Postinumero",countryCode:"Maakoodi",telephoneNumber:"Puhelinnumero",dateOfBirth:"Syntym\xe4aika",shopperEmail:"S\xe4hk\xf6postiosoite",gender:"Sukupuoli",male:"Mies",female:"Nainen",billingAddress:"Laskutusosoite",street:"Katu",stateOrProvince:"Osavaltio tai l\xe4\xe4ni",country:"Maa",houseNumberOrName:"Talon numero",separateDeliveryAddress:"M\xe4\xe4rit\xe4 erillinen toimitusosoite",deliveryAddress:"Toimitusosoite",zipCode:"Postinumero",apartmentSuite:"Huoneisto / sviitti",provinceOrTerritory:"Maakunta tai alue",cityTown:"Kaupunki / taajama",address:"Osoite",state:"Osavaltio","field.title.optional":"(valinnainen)","creditCard.cvcField.title.optional":"CVC / CVV (valinnainen)","issuerList.wallet.placeholder":"Valitse lompakkosi",privacyPolicy:"Tietosuojamenettely","afterPay.agreement":"Hyv\xe4ksyn AfterPayn %@",paymentConditions:"maksuehdot",openApp:"Avaa sovellus","voucher.readInstructions":"Lue ohjeet","voucher.introduction":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavaa kuponkia vied\xe4ksesi maksusi p\xe4\xe4t\xf6kseen.","voucher.expirationDate":"Vanhenemisp\xe4iv\xe4m\xe4\xe4r\xe4","voucher.alternativeReference":"Vaihtoehtoinen viite","dragonpay.voucher.non.bank.selectField.placeholder":"Valitse toimittajasi","dragonpay.voucher.bank.selectField.placeholder":"Valitse pankkisi","voucher.paymentReferenceLabel":"Maksun viite","voucher.surcharge":"Sis. %@ lis\xe4maksun","voucher.introduction.doku":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.shopperName":"Ostajan nimi","voucher.merchantName":"Kauppias","voucher.introduction.econtext":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","voucher.telephoneNumber":"Puhelinnumero","voucher.shopperReference":"Ostajan viite","voucher.collectionInstitutionNumber":"Ker\xe4\xe4v\xe4n laitoksen numero","voucher.econtext.telephoneNumber.invalid":"Puhelinnumeron on oltava 10 tai 11 numeroa pitk\xe4","boletobancario.btnLabel":"Luo Boleto","boleto.sendCopyToEmail":"L\xe4het\xe4 kopio s\xe4hk\xf6postiini","button.copy":"Kopio","button.download":"Lataa","creditCard.storedCard.description.ariaLabel":"Tallennetun kortin viimeiset luvut ovat %@","voucher.entity":"Kokonaisuus",donateButton:"Lahjoita",notNowButton:"Ei nyt",thanksForYourSupport:"Kiitos tuestasi!",preauthorizeWith:"Ennkkolupa k\xe4ytt\xe4j\xe4n kanssa",confirmPreauthorization:"Vahvista ennakkolupa",confirmPurchase:"Vahvista hankinta",applyGiftcard:"Lunasta",giftcardBalance:"Lahjakortin saldo",deductedBalance:"V\xe4hennetty saldo","creditCard.pin.title":"Pin-tunnus","creditCard.encryptedPassword.label":"Kortin salasanan ensimm\xe4iset 2 lukua","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Kelpaamaton salasana","creditCard.taxNumber.label":"Kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.labelAlt":"Yrityksen rekisterinumero (10 lukua)","creditCard.taxNumber.invalid":"Kelpaamaton kortinhaltijan syntym\xe4p\xe4iv\xe4 (VVKKPP) tai yrityksen rekisterinumero","storedPaymentMethod.disable.button":"Poista","storedPaymentMethod.disable.confirmation":"Poista tallennettu maksutapa","storedPaymentMethod.disable.confirmButton":"Kyll\xe4, poista","storedPaymentMethod.disable.cancelButton":"Peruuta","ach.bankAccount":"Pankkitili","ach.accountHolderNameField.title":"Tilinhaltijan nimi","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Ei-kelvollinen tilinhaltijan nimi","ach.accountNumberField.title":"Tilinumero","ach.accountNumberField.invalid":"V\xe4\xe4r\xe4 tilin numero","ach.accountLocationField.title":"ABA-reititysnumero","ach.accountLocationField.invalid":"Ei-kelvollinen ABA-reititysnumero","select.state":"Valitse osavaltio","select.stateOrProvince":"Valitse osavaltio tai l\xe4\xe4ni","select.provinceOrTerritory":"Valitse maakunta tai alue","select.country":"Valitse maa","select.noOptionsFound":"Vaihtoehtoja ei l\xf6ytynyt","select.filter.placeholder":"Hae...","telephoneNumber.invalid":"Ei-kelvollinen puhelinnumero",qrCodeOrApp:"tai","paypal.processingPayment":"Maksua k\xe4sitell\xe4\xe4n...",generateQRCode:"Tuota QR-koodi","await.waitForConfirmation":"Odottaa vahvistusta","mbway.confirmPayment":"Vahvista maksusi MB WAY -sovelluksella","shopperEmail.invalid":"Ei-kelvollinen s\xe4hk\xf6postiosoite","dateOfBirth.format":"PP/KK/VVVV","dateOfBirth.invalid":"Sinun on oltava v\xe4hint\xe4\xe4n 18-vuotias","blik.confirmPayment":"Avaa pankkisovelluksesi vahvistaaksesi maksun.","blik.invalid":"Sy\xf6t\xe4 6 lukua","blik.code":"6-numeroinen koodi","blik.help":"Hanki koodi pankkisovelluksestasi.","swish.pendingMessage":"Skannattuasi, tila voi odottaa jopa 10 minuuttia. Yritys maksaa uudelleen t\xe4ss\xe4 ajassa voi tuottaa moninkertaisia maksuja.","error.va.gen.01":"T\xe4ydent\xe4m\xe4t\xf6n kentt\xe4","error.va.gen.02":"Kentt\xe4 ei kelpaa","error.va.sf-cc-num.01":"V\xe4\xe4r\xe4 kortin numero","error.va.sf-cc-num.03":"Ei-tuettu kortti asetettu","error.va.sf-cc-dat.01":"Kortti on liian vanha","error.va.sf-cc-dat.02":"P\xe4iv\xe4m\xe4\xe4r\xe4 liian kaukana tulevaisuudessa","error.va.sf-cc-dat.03":"Korttisi vanhenee ennen l\xe4ht\xf6p\xe4iv\xe4\xe4","error.va.sf-ach-num.01":"V\xe4\xe4r\xe4 tilin numero","error.va.sf-ach-loc.01":"Ei-kelvollinen ABA-reititysnumero","error.va.sf-kcp-pwd.01":"Kelpaamaton salasana","error.giftcard.no-balance":"Lahjakortin saldo on nolla","error.giftcard.card-error":"Asiakirjoissamme ei ole t\xe4m\xe4n numeron lahjakorttia","error.giftcard.currency-error":"Gift cards are only valid in the currency they were issued in","amazonpay.signout":"Kirjaudu ulos Amazonista","amazonpay.changePaymentDetails":"Muuta maksutietoja","partialPayment.warning":"Valitse toinen maksutapa j\xe4\xe4nn\xf6ksen maksamiseksi","partialPayment.remainingBalance":"J\xe4ljell\xe4 oleva saldo on %{summa}","bankTransfer.beneficiary":"Edunsaaja","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Viite","bankTransfer.introduction":"Jatka uuden pankkisiirtomaksun luomista. Voit viimeistell\xe4 t\xe4m\xe4n maksun seuraavan n\xe4yt\xf6n tietojen avulla.","bankTransfer.instructions":"Kiitos hankinnastasi, k\xe4yt\xe4 seuraavia tietoja p\xe4\xe4tt\xe4\xe4ksesi maksusi.","bacs.accountHolderName":"Tilinhaltijan nimi","bacs.accountHolderName.invalid":"Ei-kelvollinen tilinhaltijan nimi","bacs.accountNumber":"Pankkitilinumero","bacs.accountNumber.invalid":"V\xe4\xe4r\xe4 tilin numero","bacs.bankLocationId":"Lajittelukoodi","bacs.bankLocationId.invalid":"Ei-kelvollinen lajittelukoodi","bacs.consent.amount":"Hyv\xe4ksyn, ett\xe4 alla oleva summa veloitetaan pankkitililt\xe4ni.","bacs.consent.account":"Vahvistan, ett\xe4 tili on nimess\xe4ni ja olen ainoa allekirjoittaja, joka vaaditaan valtuuttamaan suoraveloitus t\xe4ll\xe4 tilill\xe4.",edit:"Muokkaa","bacs.confirm":"Vahvista ja maksa","bacs.result.introduction":"Lataa suoraveloitusohjeet (DDI / Mandate)","download.pdf":"Lataa PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle kortin numerolle","creditCard.encryptedCardNumber.aria.label":"Kortin numero -kentt\xe4","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6p\xe4iv\xe4lle","creditCard.encryptedExpiryDate.aria.label":"Viimeinen voimassaolop\xe4iv\xe4 -kentt\xe4","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle k\xe4ytt\xf6kuukaudelle","creditCard.encryptedExpiryMonth.aria.label":"Viimeinen voimassaolokuukausi -kentt\xe4","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe suojatulle kortin viimeiselle voimassaolovuodelle","creditCard.encryptedExpiryYear.aria.label":"Viimeinen voimassaolovuosi-kentt\xe4","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle kortin turvakoodille","creditCard.encryptedSecurityCode.aria.label":"Turvakoodikentt\xe4","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe suojatulle lahjakortin numerolle","giftcard.encryptedCardNumber.aria.label":"Lahjakorttinumeron kentt\xe4","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe suojatulle lahjakortin turvakoodille","giftcard.encryptedSecurityCode.aria.label":"Lahjakortin turvakoodikentt\xe4",giftcardTransactionLimit:"Maks. % {summa} sallittu tapahtumaa kohti t\xe4ll\xe4 lahjakortilla","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe suojatulle pankkitilinumerolle","ach.encryptedBankAccountNumber.aria.label":"Pankkitilikentt\xe4","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe suojatulle pankin reititysnumerolle","ach.encryptedBankLocationId.aria.label":"Pankin reititysnumerokentt\xe4","twint.saved":"tallennettu"}}),xk=Object.freeze({__proto__:null,default:{payButton:"Payer","payButton.redirecting":"Redirection...",storeDetails:"Sauvegarder pour mon prochain paiement","creditCard.holderName":"Nom sur la carte","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nom du porteur de carte incorrect","creditCard.numberField.title":"Num\xe9ro de la carte","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Date d'expiration","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mois","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ann\xe9e","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Enregistrer pour la prochaine fois","creditCard.cvcField.placeholder.4digits":"4\xa0chiffres","creditCard.cvcField.placeholder.3digits":"3\xa0chiffres","creditCard.taxNumber.placeholder":"AAMMJJ / 0123456789",installments:"Nombre de versements",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\xa0mois","installments.oneTime":"Paiement unique","installments.installments":"Paiement \xe9chelonn\xe9","installments.revolving":"Paiement en plusieurs fois","sepaDirectDebit.ibanField.invalid":"Num\xe9ro de compte non valide","sepaDirectDebit.nameField.placeholder":"N. Bernard","sepa.ownerName":"Au nom de","sepa.ibanNumber":"Num\xe9ro de compte (IBAN)","error.title":"Erreur","error.subtitle.redirect":"\xc9chec de la redirection","error.subtitle.payment":"\xc9chec du paiement","error.subtitle.refused":"Paiement refus\xe9","error.message.unknown":"Une erreur inconnue s'est produite","idealIssuer.selectField.title":"Banque","idealIssuer.selectField.placeholder":"S\xe9lectionnez votre banque","creditCard.success":"Paiement r\xe9ussi",loading:"Chargement en cours...",continue:"Continuer",continueTo:"Poursuivre vers","wechatpay.timetopay":"Vous avez %@ pour payer cette somme","wechatpay.scanqrcode":"Scanner le code QR",personalDetails:"Informations personnelles",companyDetails:"Coordonn\xe9es de l'entreprise","companyDetails.name":"Nom de l'entreprise","companyDetails.registrationNumber":"Num\xe9ro d'enregistrement",socialSecurityNumber:"Num\xe9ro de s\xe9curit\xe9 sociale",firstName:"Pr\xe9nom",infix:"Pr\xe9fixe",lastName:"Nom de famille",mobileNumber:"Num\xe9ro de portable","mobileNumber.invalid":"Num\xe9ro de portable non valide",city:"Ville",postalCode:"Code postal",countryCode:"Code pays",telephoneNumber:"Num\xe9ro de t\xe9l\xe9phone",dateOfBirth:"Date de naissance",shopperEmail:"Adresse e-mail",gender:"Sexe",male:"Homme",female:"Femme",billingAddress:"Adresse de facturation",street:"Rue",stateOrProvince:"\xc9tat ou province",country:"Pays",houseNumberOrName:"Num\xe9ro de rue",separateDeliveryAddress:"Indiquer une adresse de livraison distincte",deliveryAddress:"Adresse de livraison",zipCode:"Code postal",apartmentSuite:"Appartement",provinceOrTerritory:"Province ou territoire",cityTown:"Ville",address:"Adresse",state:"\xc9tat","field.title.optional":"(facultatif)","creditCard.cvcField.title.optional":"CVC / CVV (facultatif)","issuerList.wallet.placeholder":"S\xe9lectionnez votre portefeuille",privacyPolicy:"Politique de confidentialit\xe9","afterPay.agreement":"J'accepte les %@ de AfterPay",paymentConditions:"conditions de paiement",openApp:"Ouvrir l'application","voucher.readInstructions":"Lire les instructions","voucher.introduction":"Merci pour votre achat, veuillez utiliser le coupon suivant pour finaliser votre paiement.","voucher.expirationDate":"Date d'expiration","voucher.alternativeReference":"Autre r\xe9f\xe9rence","dragonpay.voucher.non.bank.selectField.placeholder":"S\xe9lectionnez votre fournisseur","dragonpay.voucher.bank.selectField.placeholder":"S\xe9lectionnez votre banque","voucher.paymentReferenceLabel":"R\xe9f\xe9rence du paiement","voucher.surcharge":"Comprend une surcharge de %@","voucher.introduction.doku":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.shopperName":"Nom de l'acheteur","voucher.merchantName":"Marchand","voucher.introduction.econtext":"Nous vous remercions de votre achat. Veuillez finaliser votre paiement \xe0 l'aide des informations suivantes.","voucher.telephoneNumber":"Num\xe9ro de t\xe9l\xe9phone","voucher.shopperReference":"R\xe9f\xe9rence client","voucher.collectionInstitutionNumber":"Num\xe9ro du point de paiement","voucher.econtext.telephoneNumber.invalid":"Le num\xe9ro de t\xe9l\xe9phone doit comporter 10 ou 11\xa0chiffres","boletobancario.btnLabel":"G\xe9n\xe9rer un Boleto","boleto.sendCopyToEmail":"Envoyer une copie \xe0 mon adresse e-mail","button.copy":"Copier","button.download":"T\xe9l\xe9charger","creditCard.storedCard.description.ariaLabel":"La carte enregistr\xe9e se termine en %@","voucher.entity":"Entit\xe9",donateButton:"Faire un don",notNowButton:"Pas maintenant",thanksForYourSupport:"Merci de votre soutien\xa0!",preauthorizeWith:"Pr\xe9-autoriser avec",confirmPreauthorization:"Confirmer la pr\xe9-autorisation",confirmPurchase:"Confirmer l'achat",applyGiftcard:"Utiliser",giftcardBalance:"Solde de la carte cadeau",deductedBalance:"Solde d\xe9duit","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Les deux premiers chiffres du code de votre carte","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Code incorrect","creditCard.taxNumber.label":"Date de naissance du porteur de carte (au format AAMMJJ) ou num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.labelAlt":"Num\xe9ro d'identification de l'entreprise (\xe0 10\xa0chiffres)","creditCard.taxNumber.invalid":"Date de naissance du porteur de carte ou num\xe9ro d'identification de l'entreprise incorrect(e)","storedPaymentMethod.disable.button":"Supprimer","storedPaymentMethod.disable.confirmation":"Supprimer le mode de paiement enregistr\xe9","storedPaymentMethod.disable.confirmButton":"Oui, supprimer","storedPaymentMethod.disable.cancelButton":"Annuler","ach.bankAccount":"Compte bancaire","ach.accountHolderNameField.title":"Nom du titulaire du compte","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nom du titulaire du compte incorrect","ach.accountNumberField.title":"Num\xe9ro du compte","ach.accountNumberField.invalid":"Num\xe9ro du compte incorrect","ach.accountLocationField.title":"Code ABA","ach.accountLocationField.invalid":"Code ABA incorrect","select.state":"S\xe9lectionnez l'\xc9tat","select.stateOrProvince":"S\xe9lectionnez l'\xc9tat ou la province","select.provinceOrTerritory":"S\xe9lectionnez la province ou le territoire","select.country":"S\xe9lectionnez le pays","select.noOptionsFound":"Aucune option trouv\xe9e","select.filter.placeholder":"Recherche...","telephoneNumber.invalid":"Num\xe9ro de t\xe9l\xe9phone incorrect",qrCodeOrApp:"ou","paypal.processingPayment":"Traitement du paiement en cours...",generateQRCode:"G\xe9n\xe9rer un code QR","await.waitForConfirmation":"En attente de confirmation","mbway.confirmPayment":"Confirmez votre paiement sur l'application MB WAY","shopperEmail.invalid":"Adresse e-mail incorrecte","dateOfBirth.format":"JJ/MM/AAAA","dateOfBirth.invalid":"Vous devez \xeatre \xe2g\xe9(e) d'au moins 18\xa0ans","blik.confirmPayment":"Ouvrez votre application bancaire pour confirmer le paiement.","blik.invalid":"Saisissez les 6\xa0chiffres","blik.code":"Code \xe0 6\xa0chiffres","blik.help":"Ouvrez votre application bancaire pour obtenir le code.","swish.pendingMessage":"Apr\xe8s avoir scann\xe9 le code QR, la mise \xe0 jour du statut de paiement peut prendre jusqu'\xe0 10\xa0minutes. Si vous effectuez une nouvelle tentative de paiement dans ce d\xe9lai, cela pourrait occasionner plusieurs d\xe9bits.","error.va.gen.01":"Champ incomplet","error.va.gen.02":"Champ non valide","error.va.sf-cc-num.01":"Num\xe9ro de carte non valide","error.va.sf-cc-num.03":"Carte ins\xe9r\xe9e non prise en charge","error.va.sf-cc-dat.01":"Carte trop ancienne","error.va.sf-cc-dat.02":"La date doit \xeatre plus proche","error.va.sf-cc-dat.03":"Votre carte expirera avant la date de paiement","error.va.sf-ach-num.01":"Num\xe9ro de compte non valide","error.va.sf-ach-loc.01":"Code ABA incorrect","error.va.sf-kcp-pwd.01":"Code incorrect","error.giftcard.no-balance":"Aucun solde n'est disponible sur cette carte cadeau","error.giftcard.card-error":"Aucune carte cadeau ne correspond \xe0 ce num\xe9ro","error.giftcard.currency-error":"Les cartes cadeaux sont valables uniquement dans la devise dans laquelle elles ont \xe9t\xe9 \xe9mises","amazonpay.signout":"Se d\xe9connecter d'Amazon","amazonpay.changePaymentDetails":"Modifier les informations de paiement","partialPayment.warning":"S\xe9lectionnez un autre mode de paiement pour r\xe9gler le solde","partialPayment.remainingBalance":"Le solde restant sera de %{amount}","bankTransfer.beneficiary":"B\xe9n\xe9ficiaire","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"R\xe9f\xe9rence","bankTransfer.introduction":"Continuez \xe0 cr\xe9er un nouveau paiement par virement bancaire. Utilisez les informations de l'\xe9cran suivant pour finaliser ce paiement.","bankTransfer.instructions":"Merci pour votre achat\xa0! Veuillez utiliser les informations suivantes pour finaliser votre paiement.","bacs.accountHolderName":"Nom du titulaire du compte bancaire","bacs.accountHolderName.invalid":"Nom du titulaire du compte bancaire incorrect","bacs.accountNumber":"Num\xe9ro du compte bancaire","bacs.accountNumber.invalid":"Num\xe9ro du compte bancaire incorrect","bacs.bankLocationId":"Code de tri (sort code)","bacs.bankLocationId.invalid":"Code de tri (sort code) non valide","bacs.consent.amount":"J'accepte que le montant ci-dessus soit d\xe9duit de mon compte bancaire.","bacs.consent.account":"Je confirme \xeatre le titulaire du compte et qu'aucune autre signature que la mienne n'est requise pour autoriser un pr\xe9l\xe8vement sur ce compte.",edit:"Modifier","bacs.confirm":"Confirmer et payer","bacs.result.introduction":"T\xe9l\xe9chargez votre mandat de pr\xe9l\xe8vement (DDI)","download.pdf":"T\xe9l\xe9charger le PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de carte avec garantie","creditCard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de carte","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pour la date d'expiration de la carte avec garantie","creditCard.encryptedExpiryDate.aria.label":"Champ de la date d'expiration","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pour le mois d'expiration de la carte avec garantie","creditCard.encryptedExpiryMonth.aria.label":"Champ du mois d'expiration","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pour l'ann\xe9e d'expiration de la carte avec garantie","creditCard.encryptedExpiryYear.aria.label":"Champ de l'ann\xe9e d'expiration","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte avec garantie","creditCard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pour le num\xe9ro de la carte-cadeau avec garantie","giftcard.encryptedCardNumber.aria.label":"Champ du num\xe9ro de la carte cadeau","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pour le code de s\xe9curit\xe9 de la carte-cadeau avec garantie","giftcard.encryptedSecurityCode.aria.label":"Champ du code de s\xe9curit\xe9 de la carte-cadeau",giftcardTransactionLimit:"Montant maximum autoris\xe9 par transaction avec cette carte cadeau\xa0: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pour le num\xe9ro du compte bancaire avec garantie","ach.encryptedBankAccountNumber.aria.label":"Champ du compte bancaire","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pour le num\xe9ro de routage du compte avec garantie","ach.encryptedBankLocationId.aria.label":"Champ du num\xe9ro de routage","twint.saved":"stock\xe9"}}),Bk=Object.freeze({__proto__:null,default:{payButton:"Platiti","payButton.redirecting":"Preusmjeravanje...",storeDetails:"Pohrani za moje sljede\u0107e pla\u0107anje","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Neva\u017ee\u0107e ime vlasnika kartice","creditCard.numberField.title":"Broj kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum isteka","creditCard.expiryDateField.placeholder":"MM/GG","creditCard.expiryDateField.month":"Mjesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"GG","creditCard.expiryDateField.year":"Godina","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapamtiti za sljede\u0107i put","creditCard.cvcField.placeholder.4digits":"4 znamenke","creditCard.cvcField.placeholder.3digits":"3 znamenke","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Broj rata",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"Mjeseci: %{times}","installments.oneTime":"Jednokratno pla\u0107anje","installments.installments":"Pla\u0107anje na rate","installments.revolving":"Obnovljivo pla\u0107anje","sepaDirectDebit.ibanField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Ime vlasnika","sepa.ibanNumber":"Broj ra\u010duna (IBAN)","error.title":"Gre\u0161ka","error.subtitle.redirect":"Preusmjeravanje nije uspjelo","error.subtitle.payment":"Pla\u0107anje nije uspjelo","error.subtitle.refused":"Pla\u0107anje odbijeno","error.message.unknown":"Dogodila se nepoznata gre\u0161ka","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Odaberite banku","creditCard.success":"Pla\u0107anje uspje\u0161no",loading:"U\u010ditavanje\u2026",continue:"Nastavi",continueTo:"Nastavi na","wechatpay.timetopay":"Imate %@ za pla\u0107anje","wechatpay.scanqrcode":"Skeniraj QR k\xf4d",personalDetails:"Osobni podatci",companyDetails:"Detalji tvrtke","companyDetails.name":"Naziv tvrtke","companyDetails.registrationNumber":"Mati\u010dni broj",socialSecurityNumber:"Broj socijalnog osiguranja",firstName:"Ime",infix:"Prefiks",lastName:"Prezime",mobileNumber:"Broj mobilnog telefona","mobileNumber.invalid":"Neva\u017ee\u0107i broj mobilnog telefona",city:"Grad",postalCode:"Po\u0161tanski broj",countryCode:"Pozivni broj dr\u017eave",telephoneNumber:"Telefonski broj",dateOfBirth:"Datum ro\u0111enja",shopperEmail:"Adresa e-po\u0161te",gender:"Spol",male:"Mu\u0161karac",female:"\u017dena",billingAddress:"Adresa za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ili pokrajina",country:"Zemlja",houseNumberOrName:"Ku\u0107ni broj",separateDeliveryAddress:"Navedite zasebnu adresu za dostavu",deliveryAddress:"Adresa za dostavu",zipCode:"Po\u0161tanski broj",apartmentSuite:"Stan/apartman",provinceOrTerritory:"Pokrajina ili teritorij",cityTown:"Grad",address:"Adresa",state:"Savezna dr\u017eava","field.title.optional":"(neobavezno)","creditCard.cvcField.title.optional":"CVC/CVV (nije obavezno)","issuerList.wallet.placeholder":"Odaberite svoju nov\u010danik",privacyPolicy:"Politika privatnosti","afterPay.agreement":"Sla\u017eem se s %@ usluge AfterPay",paymentConditions:"uvjetima pla\u0107anja",openApp:"Otvorite aplikaciju","voucher.readInstructions":"Pro\u010ditajte upute","voucher.introduction":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107i kupon za dovr\u0161etak pla\u0107anja.","voucher.expirationDate":"Datum isteka","voucher.alternativeReference":"Alternativna referenca","dragonpay.voucher.non.bank.selectField.placeholder":"Odaberite davatelja usluge","dragonpay.voucher.bank.selectField.placeholder":"Odaberite banku","voucher.paymentReferenceLabel":"Referenca za pla\u0107anje","voucher.surcharge":"Uklju\u010duje %@ nadoplate","voucher.introduction.doku":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovac","voucher.introduction.econtext":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","voucher.telephoneNumber":"Broj telefona","voucher.shopperReference":"Referenca kupca","voucher.collectionInstitutionNumber":"Broj ustanove za prikupljanje","voucher.econtext.telephoneNumber.invalid":"Telefonski broj mora imati 10 ili 11 znamenki","boletobancario.btnLabel":"Generiraj Boleto","boleto.sendCopyToEmail":"Po\u0161alji kopiju na moju e-po\u0161tu","button.copy":"Kopiraj","button.download":"Preuzmi","creditCard.storedCard.description.ariaLabel":"Pohranjena kartica zavr\u0161ava na %@","voucher.entity":"Entitet",donateButton:"Doniraj",notNowButton:"Ne sada",thanksForYourSupport:"Hvala na podr\u0161ci!",preauthorizeWith:"Prethodno odobri s",confirmPreauthorization:"Potvrdite prethodno odobrenje",confirmPurchase:"Potvrdite kupnju",applyGiftcard:"Iskoristite",giftcardBalance:"Stanje na poklon-kartici",deductedBalance:"Potro\u0161eni iznos","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prve 2 znamenke lozinke kartice","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Lozinka je neto\u010dna","creditCard.taxNumber.label":"Datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.labelAlt":"Registracijski broj tvrtke (10 znamenki)","creditCard.taxNumber.invalid":"Neto\u010dan datum ro\u0111enja vlasnika kartice (GGMMDD) ili registracijski broj tvrtke (10 znamenki)","storedPaymentMethod.disable.button":"Ukloni","storedPaymentMethod.disable.confirmation":"Uklonite pohranjeni na\u010din pla\u0107anja","storedPaymentMethod.disable.confirmButton":"Da, ukloni","storedPaymentMethod.disable.cancelButton":"Otka\u017ei","ach.bankAccount":"Bankovni ra\u010dun","ach.accountHolderNameField.title":"Ime vlasnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Neva\u017ee\u0107e ime vlasnika ra\u010duna","ach.accountNumberField.title":"Broj ra\u010duna","ach.accountNumberField.invalid":"Neva\u017ee\u0107i broj ra\u010duna","ach.accountLocationField.title":"ABA identifikacijski broj","ach.accountLocationField.invalid":"Neva\u017ee\u0107i ABA identifikacijski broj","select.state":"Odaberite saveznu dr\u017eavu","select.stateOrProvince":"Odaberite dr\u017eavu ili provinciju","select.provinceOrTerritory":"Odaberite provinciju ili teritorij","select.country":"Odaberite dr\u017eavu","select.noOptionsFound":"Nije prona\u0111ena nijedna opcija","select.filter.placeholder":"Tra\u017ei...","telephoneNumber.invalid":"Neva\u017ee\u0107i telefonski broj",qrCodeOrApp:"ili","paypal.processingPayment":"Obrada pla\u0107anja u tijeku...",generateQRCode:"Generirajte QR k\xf4d","await.waitForConfirmation":"\u010ceka se potvrda","mbway.confirmPayment":"Potvrdite uplatu u aplikaciji MB WAY","shopperEmail.invalid":"Neva\u017ee\u0107a adresa e-po\u0161te","dateOfBirth.format":"DD/MM/GGGG","dateOfBirth.invalid":"Morate imati najmanje 18 godina","blik.confirmPayment":"Otvorite svoju bankovnu aplikaciju kako biste potvrdili pla\u0107anje.","blik.invalid":"Unesite 6 znamenki","blik.code":"6-znamenkasti k\xf4d","blik.help":"Preuzmite k\xf4d iz bankovne aplikacije.","swish.pendingMessage":"Nakon skeniranja status mo\u017ee biti na \u010dekanju do 10 minuta. Poku\u0161aj ponovnog pla\u0107anja u istom periodu mo\u017ee rezultirati vi\u0161estrukim naplatama.","error.va.gen.01":"Nepotpuno polje","error.va.gen.02":"Neva\u017ee\u0107e polje","error.va.sf-cc-num.01":"Neva\u017ee\u0107i broj kartice","error.va.sf-cc-num.03":"Unijeli ste nepodr\u017eanu vrstu kartice","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predaleko u budu\u0107nosti","error.va.sf-cc-dat.03":"Va\u0161a kartica istje\u010de prije datuma pla\u0107anja","error.va.sf-ach-num.01":"Neva\u017ee\u0107i broj ra\u010duna","error.va.sf-ach-loc.01":"Neva\u017ee\u0107i ABA identifikacijski broj","error.va.sf-kcp-pwd.01":"Lozinka je neto\u010dna","error.giftcard.no-balance":"Stanje na ovoj poklon-kartici iznosi nula","error.giftcard.card-error":"U na\u0161oj evidenciji nemamo poklon-karticu s ovim brojem","error.giftcard.currency-error":"Poklon-kartice vrijede samo u valuti u kojoj su izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Promijenite pojedinosti o pla\u0107anju","partialPayment.warning":"Odaberite drugi na\u010din pla\u0107anja da biste platili preostali iznos","partialPayment.remainingBalance":"Preostalo stanje na ra\u010dunu iznosit \u0107e %{amount}","bankTransfer.beneficiary":"Primatelj","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nastavite da biste kreirali novu uplatu putem bankovne transakcije. Za finaliziranje ovog pla\u0107anja mo\u017eete se koristiti pojedinostima na sljede\u0107em zaslonu.","bankTransfer.instructions":"Zahvaljujemo na kupnji, upotrijebite sljede\u0107e podatke za dovr\u0161etak pla\u0107anja.","bacs.accountHolderName":"Ime vlasnika bankovnog ra\u010duna","bacs.accountHolderName.invalid":"Neva\u017ee\u0107e ime vlasnika bankovnog ra\u010duna","bacs.accountNumber":"Broj bankovnog ra\u010duna","bacs.accountNumber.invalid":"Neva\u017ee\u0107i broj bankovnog ra\u010duna","bacs.bankLocationId":"Identifikacijski k\xf4d banke (UK)","bacs.bankLocationId.invalid":"Neva\u017ee\u0107i identifikacijski k\xf4d banke (UK)","bacs.consent.amount":"Sla\u017eem se da se gore navedeni iznos oduzme s mog bankovnog ra\u010duna.","bacs.consent.account":"Potvr\u0111ujem da je ra\u010dun na moje ime i da sam jedini potpisnik potreban za autorizaciju izravnog tere\u0107enja na ovom ra\u010dunu.",edit:"Uredi","bacs.confirm":"Potvrdi i plati","bacs.result.introduction":"Preuzmite upute za izravno tere\u0107enje (DDI / mandat)","download.pdf":"Preuzmite PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid kartice","creditCard.encryptedCardNumber.aria.label":"Polje za broj kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za datum isteka prepaid kartice","creditCard.encryptedExpiryDate.aria.label":"Polje za datum isteka","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za mjesec isteka prepaid kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje za mjesec isteka","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za godinu isteka prepaid kartice","creditCard.encryptedExpiryYear.aria.label":"Polje za godinu isteka","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid kartice","creditCard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za broj prepaid poklon-kartice","giftcard.encryptedCardNumber.aria.label":"Polje za broj poklon-kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za sigurnosni k\xf4d prepaid poklon-kartice","giftcard.encryptedSecurityCode.aria.label":"Polje za sigurnosni k\xf4d poklon-kartice",giftcardTransactionLimit:"Na ovoj je poklon-kartici maks. dopu\u0161teno %{amount} po transakciji","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za prepaid broj bankovnog ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje za broj bankovnog ra\u010duna","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za identifikacijski broj prepaid banke","ach.encryptedBankLocationId.aria.label":"Polje za identifikacijski broj banke","twint.saved":"spremljeno"}}),Tk=Object.freeze({__proto__:null,default:{payButton:"Fizet\xe9s","payButton.redirecting":"\xc1tir\xe1ny\xedt\xe1s...",storeDetails:"Ment\xe9s a k\xf6vetkez\u0151 fizet\xe9shez","creditCard.holderName":"A k\xe1rty\xe1n szerepl\u0151 n\xe9v","creditCard.holderName.placeholder":"Gipsz Jakab","creditCard.holderName.invalid":"A k\xe1rtyatulajdonos neve \xe9rv\xe9nytelen","creditCard.numberField.title":"K\xe1rtyasz\xe1m","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Lej\xe1rati d\xe1tum","creditCard.expiryDateField.placeholder":"HH/\xc9\xc9","creditCard.expiryDateField.month":"H\xf3nap","creditCard.expiryDateField.month.placeholder":"HH","creditCard.expiryDateField.year.placeholder":"\xc9\xc9","creditCard.expiryDateField.year":"\xc9v","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Megjegyz\xe9s a k\xf6vetkez\u0151 alkalomra","creditCard.cvcField.placeholder.4digits":"4 sz\xe1mjegy\u0171","creditCard.cvcField.placeholder.3digits":"3 sz\xe1mjegy\u0171","creditCard.taxNumber.placeholder":"\xc9\xc9HHNN / 0123456789",installments:"R\xe9szletek sz\xe1ma",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} h\xf3nap","installments.oneTime":"Egy\xf6sszeg\u0171 fizet\xe9s","installments.installments":"R\xe9szletfizet\xe9s","installments.revolving":"T\xf6bb\xf6sszeg\u0171 fizet\xe9s","sepaDirectDebit.ibanField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","sepaDirectDebit.nameField.placeholder":"Gipsz Jakab","sepa.ownerName":"Sz\xe1mlatulajdonos neve","sepa.ibanNumber":"Sz\xe1mlasz\xe1m (IBAN)","error.title":"Hiba","error.subtitle.redirect":"Sikertelen \xe1tir\xe1ny\xedt\xe1s","error.subtitle.payment":"Sikertelen fizet\xe9s","error.subtitle.refused":"A fizet\xe9s elutas\xedtva","error.message.unknown":"Ismeretlen hiba t\xf6rt\xe9nt","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","creditCard.success":"Sikeres fizet\xe9s",loading:"Bet\xf6lt\xe9s\u2026",continue:"Folytat\xe1s",continueTo:"Folytat\xe1s a k\xf6vetkez\u0151vel:","wechatpay.timetopay":"Fizet\xe9shez rendelkez\xe9sre \xe1ll\xf3 id\u0151: %@","wechatpay.scanqrcode":"QR-k\xf3d beolvas\xe1sa",personalDetails:"Szem\xe9lyes adatok",companyDetails:"C\xe9g adatai","companyDetails.name":"C\xe9gn\xe9v","companyDetails.registrationNumber":"C\xe9gjegyz\xe9ksz\xe1m",socialSecurityNumber:"Szem\xe9lyi igazolv\xe1ny sz\xe1ma",firstName:"Keresztn\xe9v",infix:"El\u0151tag",lastName:"Vezet\xe9kn\xe9v",mobileNumber:"Mobiltelefonsz\xe1m","mobileNumber.invalid":"\xc9rv\xe9nytelen mobilsz\xe1m",city:"V\xe1ros",postalCode:"Ir\xe1ny\xedt\xf3sz\xe1m",countryCode:"Orsz\xe1gk\xf3d",telephoneNumber:"Telefonsz\xe1m",dateOfBirth:"Sz\xfclet\xe9si d\xe1tum",shopperEmail:"E-mail-c\xedm",gender:"Nem",male:"F\xe9rfi",female:"N\u0151",billingAddress:"Sz\xe1ml\xe1z\xe1si c\xedm",street:"Utca",stateOrProvince:"\xc1llam vagy tartom\xe1ny",country:"Orsz\xe1g",houseNumberOrName:"H\xe1zsz\xe1m",separateDeliveryAddress:"Elt\xe9r\u0151 sz\xe1ll\xedt\xe1si c\xedm megad\xe1sa",deliveryAddress:"Sz\xe1ll\xedt\xe1si c\xedm",zipCode:"Ir\xe1ny\xedt\xf3sz\xe1m",apartmentSuite:"Lak\xe1s/ajt\xf3sz\xe1m",provinceOrTerritory:"Tartom\xe1ny vagy ter\xfclet",cityTown:"V\xe1ros",address:"C\xedm",state:"\xc1llam","field.title.optional":"(nem k\xf6telez\u0151)","creditCard.cvcField.title.optional":"CVC/CVV (opcion\xe1lis)","issuerList.wallet.placeholder":"P\xe9nzt\xe1rca kiv\xe1laszt\xe1sa",privacyPolicy:"Adatv\xe9delmi szab\xe1lyzat","afterPay.agreement":"Elfogadom az AfterPay %@",paymentConditions:"fizet\xe9si felt\xe9teleit",openApp:"Alkalmaz\xe1s megnyit\xe1sa","voucher.readInstructions":"Olvassa el az utas\xedt\xe1sokat","voucher.introduction":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 kupont.","voucher.expirationDate":"Lej\xe1rati d\xe1tum","voucher.alternativeReference":"Alternat\xedv hivatkoz\xe1s","dragonpay.voucher.non.bank.selectField.placeholder":"Szolg\xe1ltat\xf3 kiv\xe1laszt\xe1sa","dragonpay.voucher.bank.selectField.placeholder":"Bank kiv\xe1laszt\xe1sa","voucher.paymentReferenceLabel":"Fizet\xe9si referencia","voucher.surcharge":"%@ p\xf3td\xedjat tartalmaz","voucher.introduction.doku":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.shopperName":"V\xe1s\xe1rl\xf3 neve","voucher.merchantName":"Keresked\u0151","voucher.introduction.econtext":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","voucher.telephoneNumber":"Telefonsz\xe1m","voucher.shopperReference":"V\xe1s\xe1rl\xf3i referencia","voucher.collectionInstitutionNumber":"Beszed\u0151 c\xe9g sz\xe1ma","voucher.econtext.telephoneNumber.invalid":"A telefonsz\xe1mnak 10 vagy 11 sz\xe1mjegyb\u0151l kell \xe1llnia","boletobancario.btnLabel":"Boleto l\xe9trehoz\xe1sa","boleto.sendCopyToEmail":"M\xe1solat k\xfcld\xe9se az e-mail-c\xedmemre","button.copy":"M\xe1sol\xe1s","button.download":"Let\xf6lt\xe9s","creditCard.storedCard.description.ariaLabel":"A t\xe1rolt k\xe1rtya sz\xe1m\xe1nak v\xe9gz\u0151d\xe9se: %@","voucher.entity":"Entit\xe1s",donateButton:"Adom\xe1nyoz\xe1s",notNowButton:"Most nem",thanksForYourSupport:"K\xf6sz\xf6nj\xfck a t\xe1mogat\xe1s\xe1t!",preauthorizeWith:"El\u0151zetes meghatalmaz\xe1s a k\xf6vetkez\u0151vel:",confirmPreauthorization:"El\u0151zetes meghatalmaz\xe1s j\xf3v\xe1hagy\xe1sa",confirmPurchase:"Fizet\xe9s j\xf3v\xe1hagy\xe1sa",applyGiftcard:"Bev\xe1lt\xe1s",giftcardBalance:"Aj\xe1nd\xe9kk\xe1rtya egyenlege",deductedBalance:"Levont egyenleg","creditCard.pin.title":"PIN-k\xf3d","creditCard.encryptedPassword.label":"K\xe1rtya jelszav\xe1nak els\u0151 2 sz\xe1mjegye","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\xc9rv\xe9nytelen jelsz\xf3","creditCard.taxNumber.label":"K\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma (\xc9\xc9HHNN) vagy c\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.labelAlt":"C\xe9gjegyz\xe9ksz\xe1m (10 sz\xe1mjegy\u0171)","creditCard.taxNumber.invalid":"A k\xe1rtyatulajdonos sz\xfclet\xe9si d\xe1tuma vagy a c\xe9gjegyz\xe9ksz\xe1m \xe9rv\xe9nytelen","storedPaymentMethod.disable.button":"Elt\xe1vol\xedt\xe1s","storedPaymentMethod.disable.confirmation":"T\xe1rolt fizet\xe9si m\xf3d elt\xe1vol\xedt\xe1sa","storedPaymentMethod.disable.confirmButton":"Igen, elt\xe1vol\xedtom","storedPaymentMethod.disable.cancelButton":"M\xe9gse","ach.bankAccount":"Banksz\xe1mla","ach.accountHolderNameField.title":"Sz\xe1mlatulajdonos neve","ach.accountHolderNameField.placeholder":"Gipsz Jakab","ach.accountHolderNameField.invalid":"A sz\xe1mlatulajdonos neve \xe9rv\xe9nytelen","ach.accountNumberField.title":"Sz\xe1mlasz\xe1m","ach.accountNumberField.invalid":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","ach.accountLocationField.title":"ABA-ir\xe1ny\xedt\xf3sz\xe1m","ach.accountLocationField.invalid":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","select.state":"\xc1llam kiv\xe1laszt\xe1sa","select.stateOrProvince":"\xc1llam vagy tartom\xe1ny kiv\xe1laszt\xe1sa","select.provinceOrTerritory":"Tartom\xe1ny vagy ter\xfclet kiv\xe1laszt\xe1sa","select.country":"Orsz\xe1g kiv\xe1laszt\xe1sa","select.noOptionsFound":"Nincsenek tal\xe1latok","select.filter.placeholder":"Keres\xe9s...","telephoneNumber.invalid":"\xc9rv\xe9nytelen telefonsz\xe1m",qrCodeOrApp:"vagy","paypal.processingPayment":"Fizet\xe9s feldolgoz\xe1sa\u2026",generateQRCode:"QR-k\xf3d l\xe9trehoz\xe1sa","await.waitForConfirmation":"V\xe1rakoz\xe1s a j\xf3v\xe1hagy\xe1sra","mbway.confirmPayment":"Fizet\xe9s j\xf3v\xe1hagy\xe1sa az MB WAY alkalmaz\xe1sban","shopperEmail.invalid":"\xc9rv\xe9nytelen e-mail-c\xedm","dateOfBirth.format":"NN/HH/\xc9\xc9\xc9\xc9","dateOfBirth.invalid":"Legal\xe1bb 18 \xe9vesnek kell lennie","blik.confirmPayment":"A fizet\xe9s j\xf3v\xe1hagy\xe1s\xe1hoz nyissa meg a banki alkalmaz\xe1st.","blik.invalid":"Adjon meg 6 sz\xe1mjegyet","blik.code":"6 sz\xe1mjegy\u0171 k\xf3d","blik.help":"K\xf3d lek\xe9r\xe9se a banki alkalmaz\xe1sb\xf3l.","swish.pendingMessage":"A QR-k\xf3d beolvas\xe1s\xe1t k\xf6vet\u0151en az \xe1llapot ak\xe1r 10 percig is f\xfcgg\u0151ben lehet. Ha ek\xf6zben \xfajb\xf3l fizet\xe9st k\xeds\xe9rel meg, az t\xf6bbsz\xf6ri fizet\xe9st eredm\xe9nyezhet.","error.va.gen.01":"Hi\xe1nyos mez\u0151","error.va.gen.02":"\xc9rv\xe9nytelen mez\u0151","error.va.sf-cc-num.01":"\xc9rv\xe9nytelen k\xe1rtyasz\xe1m","error.va.sf-cc-num.03":"A megadott k\xe1rtya nem t\xe1mogatott","error.va.sf-cc-dat.01":"A k\xe1rtya t\xfal r\xe9gi","error.va.sf-cc-dat.02":"T\xfal t\xe1voli j\xf6v\u0151beli d\xe1tum","error.va.sf-cc-dat.03":"A k\xe1rtya lej\xe1r a fizet\xe9s d\xe1tuma el\u0151tt","error.va.sf-ach-num.01":"\xc9rv\xe9nytelen sz\xe1mlasz\xe1m","error.va.sf-ach-loc.01":"\xc9rv\xe9nytelen ABA-ir\xe1ny\xedt\xf3sz\xe1m","error.va.sf-kcp-pwd.01":"\xc9rv\xe9nytelen jelsz\xf3","error.giftcard.no-balance":"Az aj\xe1nd\xe9kk\xe1rtya egyenlege nulla","error.giftcard.card-error":"Nyilv\xe1ntart\xe1sunkban nem szerepel ilyen sz\xe1m\xfa aj\xe1nd\xe9kk\xe1rtya","error.giftcard.currency-error":"Az aj\xe1nd\xe9kk\xe1rty\xe1k csak abban a p\xe9nznemben \xe9rv\xe9nyesek, amelyre ki\xe1ll\xedtott\xe1k azokat","amazonpay.signout":"Kijelentkez\xe9s az Amazonr\xf3l","amazonpay.changePaymentDetails":"Fizet\xe9si adatok m\xf3dos\xedt\xe1sa","partialPayment.warning":"M\xe1sik fizet\xe9si m\xf3d v\xe1laszt\xe1sa a fennmarad\xf3 r\xe9sz fizet\xe9s\xe9hez","partialPayment.remainingBalance":"A fennmarad\xf3 egyenleg %{amount} lesz","bankTransfer.beneficiary":"Kedvezm\xe9nyezett","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencia","bankTransfer.introduction":"Folytassa, hogy elind\xedtson egy \xfaj banki \xe1tutal\xe1sos fizet\xe9st. A fizet\xe9s v\xe9gleges\xedt\xe9s\xe9hez felhaszn\xe1lhatja a k\xf6vetkez\u0151 k\xe9perny\u0151n megjelen\u0151 adatokat.","bankTransfer.instructions":"K\xf6sz\xf6nj\xfck a v\xe1s\xe1rl\xe1st! K\xe9rj\xfck, a fizet\xe9shez haszn\xe1lja a k\xf6vetkez\u0151 inform\xe1ci\xf3t.","bacs.accountHolderName":"Banksz\xe1mla-tulajdonos neve","bacs.accountHolderName.invalid":"A banksz\xe1mla-tulajdonos neve \xe9rv\xe9nytelen","bacs.accountNumber":"Banksz\xe1mlasz\xe1m","bacs.accountNumber.invalid":"\xc9rv\xe9nytelen banksz\xe1mlasz\xe1m","bacs.bankLocationId":"Banki azonos\xedt\xf3","bacs.bankLocationId.invalid":"\xc9rv\xe9nytelen banki azonos\xedt\xf3","bacs.consent.amount":"Elfogadom, hogy a fenti \xf6sszeget levonj\xe1k a banksz\xe1ml\xe1mr\xf3l.","bacs.consent.account":"Meger\u0151s\xedtem, hogy a banksz\xe1mla az \xe9n nevemen van, \xe9s \xe9n vagyok a banksz\xe1ml\xe1t \xe9rint\u0151 beszed\xe9si megb\xedz\xe1s j\xf3v\xe1hagy\xe1s\xe1hoz sz\xfcks\xe9ges egyetlen al\xe1\xedr\xf3.",edit:"Szerkeszt\xe9s","bacs.confirm":"Meger\u0151s\xedt\xe9s \xe9s fizet\xe9s","bacs.result.introduction":"Beszed\xe9si megb\xedz\xe1si utas\xedt\xe1s (meghatalmaz\xe1s) let\xf6lt\xe9se","download.pdf":"PDF let\xf6lt\xe9se","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyasz\xe1mhoz","creditCard.encryptedCardNumber.aria.label":"K\xe1rtyasz\xe1m mez\u0151je","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati d\xe1tumhoz","creditCard.encryptedExpiryDate.aria.label":"Lej\xe1rati d\xe1tum mez\u0151je","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati h\xf3naphoz","creditCard.encryptedExpiryMonth.aria.label":"Lej\xe1rati h\xf3nap mez\u0151je","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyalej\xe1rati \xe9vhez","creditCard.encryptedExpiryYear.aria.label":"Lej\xe1rati \xe9v mez\u0151je","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos k\xe1rtyabiztons\xe1gi k\xf3dhoz","creditCard.encryptedSecurityCode.aria.label":"Biztons\xe1gi k\xf3d mez\u0151je","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtyasz\xe1mhoz","giftcard.encryptedCardNumber.aria.label":"Aj\xe1nd\xe9kk\xe1rtyasz\xe1m mez\u0151je","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe a biztons\xe1gos aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dhoz","giftcard.encryptedSecurityCode.aria.label":"Aj\xe1nd\xe9kk\xe1rtya biztons\xe1gi k\xf3dj\xe1nak mez\u0151je",giftcardTransactionLimit:"Ezen az aj\xe1nd\xe9kk\xe1rty\xe1n a tranzakci\xf3nk\xe9nt enged\xe9lyezett maxim\xe1lis \xf6sszeg %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe a biztons\xe1gos banksz\xe1mlasz\xe1mhoz","ach.encryptedBankAccountNumber.aria.label":"Banksz\xe1mla mez\u0151je","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe a biztons\xe1gos bankazonos\xedt\xf3 k\xf3dhoz","ach.encryptedBankLocationId.aria.label":"Bankazonos\xedt\xf3 k\xf3d mez\u0151je","twint.saved":"mentve"}}),zk=Object.freeze({__proto__:null,default:{payButton:"Paga","payButton.redirecting":"Reindirizzamento...",storeDetails:"Salva per il prossimo pagamento","creditCard.holderName":"Nome sulla carta","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome del titolare della carta non valido","creditCard.numberField.title":"Numero carta","creditCard.expiryDateField.title":"Data di scadenza","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"Mese","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Anno","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Ricorda per la prossima volta","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AAMMGG/0123456789",installments:"Numero di rate",installmentOption:"%{partialValue} x%{times}",installmentOptionMonths:"%{times} mesi","installments.oneTime":"Pagamento una tantum","installments.installments":"Pagamento rateale","installments.revolving":"Pagamento ricorrente","sepaDirectDebit.ibanField.invalid":"Numero di conto non valido","sepaDirectDebit.nameField.placeholder":"A. Bianchi","sepa.ownerName":"Nome Intestatario Conto","sepa.ibanNumber":"Numero di conto (IBAN)","error.title":"Errore","error.subtitle.redirect":"Reindirizzamento non riuscito","error.subtitle.payment":"Pagamento non riuscito","error.subtitle.refused":"Pagamento respinto","error.message.unknown":"Si \xe8 verificato un errore sconosciuto","idealIssuer.selectField.title":"Banca","idealIssuer.selectField.placeholder":"Seleziona la banca","creditCard.success":"Pagamento riuscito",loading:"Caricamento in corso...",continue:"Continua",continueTo:"Procedi verso","wechatpay.timetopay":"Devi pagare %@","wechatpay.scanqrcode":"Scansiona il codice QR",personalDetails:"Dati personali",companyDetails:"Informazioni dell'azienda","companyDetails.name":"Ragione sociale","companyDetails.registrationNumber":"Numero di registrazione",socialSecurityNumber:"Numero di previdenza sociale",firstName:"Nome",infix:"Prefisso",lastName:"Cognome",mobileNumber:"Numero di cellulare","mobileNumber.invalid":"Numero di cellulare non valido",city:"Citt\xe0",postalCode:"Codice postale",countryCode:"Codice nazionale",telephoneNumber:"Numero di telefono",dateOfBirth:"Data di nascita",shopperEmail:"Indirizzo e-mail",gender:"Sesso",male:"Uomo",female:"Donna",billingAddress:"Indirizzo di fatturazione",street:"Via",stateOrProvince:"Stato o provincia",country:"Paese",houseNumberOrName:"Numero civico",separateDeliveryAddress:"Specifica un indirizzo di consegna alternativo",deliveryAddress:"Indirizzo di consegna",zipCode:"CAP",apartmentSuite:"Appartamento/suite",provinceOrTerritory:"Provincia o territorio",cityTown:"Citt\xe0",address:"Indirizzo",state:"Stato","field.title.optional":"(facoltativo)","creditCard.cvcField.title.optional":"CVC/CVV (facoltativo)","issuerList.wallet.placeholder":"Seleziona il tuo portafoglio",privacyPolicy:"Informativa sulla privacy","afterPay.agreement":"Accetto i %@ di AfterPay",paymentConditions:"termini di pagamento",openApp:"Apri l'app","voucher.readInstructions":"Leggi le istruzioni","voucher.introduction":"Grazie per il tuo acquisto, utilizza il seguente coupon per completare il pagamento.","voucher.expirationDate":"Data di scadenza","voucher.alternativeReference":"Riferimento alternativo","dragonpay.voucher.non.bank.selectField.placeholder":"Seleziona il tuo fornitore","dragonpay.voucher.bank.selectField.placeholder":"Seleziona la banca","voucher.paymentReferenceLabel":"Riferimento del pagamento","voucher.surcharge":"Include un sovrapprezzo di %@","voucher.introduction.doku":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.shopperName":"Nome dell'acquirente","voucher.merchantName":"Esercente","voucher.introduction.econtext":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","voucher.telephoneNumber":"Numero di telefono","voucher.shopperReference":"Riferimento dell'acquirente","voucher.collectionInstitutionNumber":"Codice identificativo del negozio","voucher.econtext.telephoneNumber.invalid":"Il numero di telefono deve essere di 10 o 11 cifre","boletobancario.btnLabel":"Genera Boleto","boleto.sendCopyToEmail":"Invia una copia alla mia e-mail","button.copy":"Copia","button.download":"Scarica","creditCard.storedCard.description.ariaLabel":"La carta memorizzata termina in %@","voucher.entity":"Entit\xe0",donateButton:"Dona",notNowButton:"Non ora",thanksForYourSupport:"Grazie per il tuo sostegno!",preauthorizeWith:"Preautorizza con",confirmPreauthorization:"Conferma preautorizzazione",confirmPurchase:"Conferma acquisto",applyGiftcard:"Riscatta",giftcardBalance:"Saldo del buono",deductedBalance:"Importo detratto","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Prime 2 cifre della password della carta","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Password non valida","creditCard.taxNumber.label":"Data di nascita del titolare della carta (AAMMGG) o numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.labelAlt":"Numero di registrazione aziendale (10 cifre)","creditCard.taxNumber.invalid":"Data di nascita del titolare della carta o numero di registrazione aziendale non validi","storedPaymentMethod.disable.button":"Rimuovi","storedPaymentMethod.disable.confirmation":"Rimuovi il metodo di pagamento archiviato","storedPaymentMethod.disable.confirmButton":"S\xec, rimuoverli","storedPaymentMethod.disable.cancelButton":"Cancella","ach.bankAccount":"Conto bancario","ach.accountHolderNameField.title":"Nome del titolare del conto","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome del titolare del conto non valido","ach.accountNumberField.title":"Numero di conto","ach.accountNumberField.invalid":"Numero di conto non valido","ach.accountLocationField.title":"Codice ABA","ach.accountLocationField.invalid":"Codice ABA non valido","select.state":"Seleziona stato","select.stateOrProvince":"Seleziona stato o provincia","select.provinceOrTerritory":"Seleziona provincia o territorio","select.country":"Seleziona paese","select.noOptionsFound":"Nessuna opzione trovata","select.filter.placeholder":"Cerca...","telephoneNumber.invalid":"Numero di telefono non valido",qrCodeOrApp:"o","paypal.processingPayment":"Elaborazione del pagamento in corso...",generateQRCode:"Genera codice QR","await.waitForConfirmation":"In attesa di conferma","mbway.confirmPayment":"Conferma il pagamento con l'app MB WAY","shopperEmail.invalid":"Indirizzo e-mail non valido","dateOfBirth.format":"GG/MM/AAAA","dateOfBirth.invalid":"Devi avere almeno 18 anni","blik.confirmPayment":"Apri l'app della tua banca per confermare il pagamento.","blik.invalid":"Inserisci 6 numeri","blik.code":"Codice a 6 cifre","blik.help":"Ottieni il codice dalla app della tua banca.","swish.pendingMessage":"In seguito alla scansione, lo stato della transazione pu\xf2 rimanere in sospeso per un massimo di 10 minuti. Un nuovo tentativo di pagamento durante questo lasso di tempo pu\xf2 comportare pagamenti multipli.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo non valido","error.va.sf-cc-num.01":"Numero carta non valido","error.va.sf-cc-num.03":"Tipo di carta non supportato","error.va.sf-cc-dat.01":"Carta troppo vecchia","error.va.sf-cc-dat.02":"Data troppo avanti nel futuro","error.va.sf-cc-dat.03":"La tua carta scade prima della data di check out","error.va.sf-ach-num.01":"Numero di conto non valido","error.va.sf-ach-loc.01":"Codice ABA non valido","error.va.sf-kcp-pwd.01":"Password non valida","error.giftcard.no-balance":"Questo buono regalo ha un saldo pari a zero","error.giftcard.card-error":"Non abbiamo alcun buono regalo con questo numero nei nostri archivi","error.giftcard.currency-error":"I buono regalo sono validi solo nella valuta in cui sono state emessi","amazonpay.signout":"Esci da Amazon","amazonpay.changePaymentDetails":"Modifica i dettagli di pagamento","partialPayment.warning":"Seleziona un altro metodo di pagamento per pagare l'importo rimanente","partialPayment.remainingBalance":"Il saldo rimanente sar\xe0 di %{amount}","bankTransfer.beneficiary":"Beneficiario","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Riferimento","bankTransfer.introduction":"Continua per creare un nuovo pagamento tramite bonifico bancario. Puoi utilizzare i dettagli nella schermata seguente per completare l'operazione.","bankTransfer.instructions":"Grazie per il tuo acquisto, utilizza i seguenti dati per completare il pagamento.","bacs.accountHolderName":"Nome del titolare del conto bancario","bacs.accountHolderName.invalid":"Nome del titolare del conto bancario non valido","bacs.accountNumber":"Numero di conto bancario","bacs.accountNumber.invalid":"Numero di conto bancario non valido","bacs.bankLocationId":"Sort code","bacs.bankLocationId.invalid":"Sort code non valido","bacs.consent.amount":"Accetto che l'importo sopra indicato venga detratto dal mio conto bancario.","bacs.consent.account":"Confermo che il conto \xe8 intestato al sottoscritto e che sono l'unico firmatario a dover autorizzare l'addebito diretto su questo conto.",edit:"Modifica","bacs.confirm":"Conferma e paga","bacs.result.introduction":"Scarica le Istruzioni per l'addebito diretto (DDI / Mandato)","download.pdf":"Scarica PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta protetta","creditCard.encryptedCardNumber.aria.label":"Campo numero di carta","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe data di scadenza per numero di carta protetta","creditCard.encryptedExpiryDate.aria.label":"Campo data di scadenza","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe mese di scadenza per numero di carta protetta","creditCard.encryptedExpiryMonth.aria.label":"Campo mese di scadenza","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe anno di scadenza per numero di carta protetta","creditCard.encryptedExpiryYear.aria.label":"Campo anno di scadenza","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta protetta","creditCard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe per numero di carta regalo protetta","giftcard.encryptedCardNumber.aria.label":"Campo numero carta regalo","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe per codice di sicurezza della carta regalo protetta","giftcard.encryptedSecurityCode.aria.label":"Campo codice di sicurezza della carta regalo",giftcardTransactionLimit:"Importo massimo di %{amount} per transazione su questo buono regalo","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe per numero di numero di conto bancario protetto","ach.encryptedBankAccountNumber.aria.label":"Campo conto bancario","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe per numero di routing bancario sicuro","ach.encryptedBankLocationId.aria.label":"Campo numero di routing bancario","twint.saved":"memorizzato"}}),Ik=Object.freeze({__proto__:null,default:{payButton:"\u652f\u6255\u3046","payButton.redirecting":"\u30ea\u30c0\u30a4\u30ec\u30af\u30c8\u3057\u3066\u3044\u307e\u3059...",storeDetails:"\u6b21\u56de\u306e\u304a\u652f\u6255\u3044\u306e\u305f\u3081\u8a73\u7d30\u3092\u4fdd\u5b58","creditCard.holderName":"\u30ab\u30fc\u30c9\u4e0a\u306e\u540d\u524d","creditCard.holderName.placeholder":"Taro Yamada","creditCard.holderName.invalid":"\u7121\u52b9\u306a\u30ab\u30fc\u30c9\u6240\u6709\u8005\u540d","creditCard.numberField.title":"\u30ab\u30fc\u30c9\u756a\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u52b9\u671f\u9650","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9 (CVC)","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u6b21\u56de\u306e\u305f\u3081\u306b\u4fdd\u5b58\u3057\u307e\u3059","creditCard.cvcField.placeholder.4digits":"4\u6841","creditCard.cvcField.placeholder.3digits":"3\u6841","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff08YYMMDD\uff09/ 0123456789",installments:"\u5206\u5272\u56de\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\u304b\u6708","installments.oneTime":"\u4e00\u62ec\u6255\u3044","installments.installments":"\u5206\u5272\u6255\u3044","installments.revolving":"\u30ea\u30dc\u6255\u3044","sepaDirectDebit.ibanField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u540d\u7fa9","sepa.ibanNumber":"\u53e3\u5ea7\u756a\u53f7 (IBAN)","error.title":"\u30a8\u30e9\u30fc","error.subtitle.redirect":"\u753b\u9762\u306e\u5207\u308a\u66ff\u3048\u5931\u6557\u306b\u3057\u307e\u3057\u305f","error.subtitle.payment":"\u652f\u6255\u3067\u304d\u307e\u305b\u3093\u3067\u3057\u305f","error.subtitle.refused":"\u30ab\u30fc\u30c9\u4f1a\u793e\u3067\u53d6\u5f15\u304c\u627f\u8a8d\u3055\u308c\u307e\u305b\u3093\u3067\u3057\u305f\u3002","error.message.unknown":"\u4e0d\u660e\u306a\u30a8\u30e9\u30fc\u304c\u767a\u751f\u3057\u307e\u3057\u305f","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","creditCard.success":"\u8a8d\u8a3c\u304c\u6210\u529f\u3057\u307e\u3057\u305f",loading:"\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059...",continue:"\u7d9a\u3051\u308b",continueTo:"\u6b21\u3078\u9032\u3080\uff1a","wechatpay.timetopay":"%@\u3092\u304a\u652f\u6255\u3044\u4e0b\u3055\u3044\u3002","wechatpay.scanqrcode":"QR \u30b3\u30fc\u30c9\u3092\u30b9\u30ad\u30e3\u30f3\u3059\u308b",personalDetails:"\u500b\u4eba\u60c5\u5831",companyDetails:"\u4f1a\u793e\u60c5\u5831","companyDetails.name":"\u4f1a\u793e\u540d","companyDetails.registrationNumber":"\u767b\u9332\u756a\u53f7",socialSecurityNumber:"\u30bd\u30fc\u30b7\u30e3\u30eb\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u756a\u53f7",firstName:"\u540d",infix:"\u656c\u79f0",lastName:"\u59d3",mobileNumber:"\u643a\u5e2f\u756a\u53f7","mobileNumber.invalid":"\u7121\u52b9\u306a\u643a\u5e2f\u96fb\u8a71\u756a\u53f7",city:"\u5e02\u533a",postalCode:"\u90f5\u4fbf\u756a\u53f7",countryCode:"\u56fd\u30b3\u30fc\u30c9",telephoneNumber:"\u96fb\u8a71\u756a\u53f7",dateOfBirth:"\u751f\u5e74\u6708\u65e5",shopperEmail:"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9",gender:"\u6027\u5225",male:"\u7537\u6027",female:"\u5973\u6027",billingAddress:"\u3054\u8acb\u6c42\u4f4f\u6240",street:"\u756a\u5730",stateOrProvince:"\u90fd\u9053\u5e9c\u770c",country:"\u56fd",houseNumberOrName:"\u90e8\u5c4b\u756a\u53f7",separateDeliveryAddress:"\u5225\u306e\u914d\u9001\u5148\u4f4f\u6240\u3092\u6307\u5b9a\u3057\u3066\u304f\u3060\u3055\u3044",deliveryAddress:"\u914d\u9001\u5148\u4f4f\u6240",zipCode:"\u90f5\u4fbf\u756a\u53f7",apartmentSuite:"\u30a2\u30d1\u30fc\u30c8\u540d/\u90e8\u5c4b\u540d",provinceOrTerritory:"\u5dde\u307e\u305f\u306f\u6e96\u5dde",cityTown:"\u5e02\u533a\u753a\u6751",address:"\u4f4f\u6240",state:"\u90fd\u9053\u5e9c\u770c","field.title.optional":"\uff08\u4efb\u610f\uff09","creditCard.cvcField.title.optional":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30fc\u30b3\u30fc\u30c9(\u4efb\u610f)","issuerList.wallet.placeholder":"\u30a6\u30a9\u30ec\u30c3\u30c8\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044",privacyPolicy:"\u30d7\u30e9\u30a4\u30d0\u30b7\u30fc\u30dd\u30ea\u30b7\u30fc","afterPay.agreement":"AfterPay\u306e%@\u3067\u540c\u610f",paymentConditions:"\u652f\u6255\u6761\u4ef6",openApp:"\u30a2\u30d7\u30ea\u3092\u958b\u304f","voucher.readInstructions":"\u624b\u9806\u3092\u53c2\u7167\u3057\u3066\u304f\u3060\u3055\u3044","voucher.introduction":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u30af\u30fc\u30dd\u30f3\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.expirationDate":"\u6709\u52b9\u671f\u9650","voucher.alternativeReference":"\u5225\u306e\u53c2\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u30d7\u30ed\u30d0\u30a4\u30c0\u30fc\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","dragonpay.voucher.bank.selectField.placeholder":"\u9280\u884c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","voucher.paymentReferenceLabel":"\u652f\u6255\u306e\u53c2\u7167","voucher.surcharge":"%@ \u306e\u8ffd\u52a0\u6599\u91d1\u3092\u542b\u3080","voucher.introduction.doku":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.shopperName":"\u8cfc\u5165\u8005\u6c0f\u540d","voucher.merchantName":"\u696d\u8005","voucher.introduction.econtext":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u756a\u53f7","voucher.shopperReference":"\u8cfc\u5165\u8005\u5411\u3051\u53c2\u8003\u60c5\u5831","voucher.collectionInstitutionNumber":"\u53ce\u7d0d\u6a5f\u95a2\u756a\u53f7","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u756a\u53f7\u306f10\u6841\u307e\u305f\u306f11\u6841\u306b\u3057\u3066\u304f\u3060\u3055\u3044","boletobancario.btnLabel":"Boleto\u3092\u751f\u6210\u3059\u308b","boleto.sendCopyToEmail":"\u81ea\u5206\u306e\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u306b\u30b3\u30d4\u30fc\u3092\u9001\u4fe1\u3059\u308b","button.copy":"\u30b3\u30d4\u30fc","button.download":"\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.storedCard.description.ariaLabel":"\u4fdd\u5b58\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306f\uff05@\u306b\u7d42\u4e86\u3057\u307e\u3059","voucher.entity":"\u30a8\u30f3\u30c6\u30a3\u30c6\u30a3",donateButton:"\u5bc4\u4ed8\u3059\u308b",notNowButton:"\u4eca\u306f\u3057\u306a\u3044",thanksForYourSupport:"\u3054\u652f\u63f4\u3044\u305f\u3060\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002",preauthorizeWith:"\u6b21\u3067\u4e8b\u524d\u8a8d\u8a3c\u3059\u308b\uff1a",confirmPreauthorization:"\u4e8b\u524d\u627f\u8a8d\u3092\u78ba\u8a8d\u3059\u308b",confirmPurchase:"\u8cfc\u5165\u3092\u78ba\u8a8d\u3059\u308b",applyGiftcard:"\u5229\u7528\u3059\u308b",giftcardBalance:"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8",deductedBalance:"\u5dee\u3057\u5f15\u304d\u5f8c\u6b8b\u9ad8","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"\u30ab\u30fc\u30c9\u306e\u30d1\u30b9\u30ef\u30fc\u30c9\u306e\u6700\u521d\u306e2\u6841","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","creditCard.taxNumber.label":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\uff08YYMMDD\uff09\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.labelAlt":"\u6cd5\u4eba\u767b\u9332\u756a\u53f7\uff0810\u6841\uff09","creditCard.taxNumber.invalid":"\u30ab\u30fc\u30c9\u6240\u6709\u8005\u306e\u751f\u5e74\u6708\u65e5\u307e\u305f\u306f\u6cd5\u4eba\u767b\u9332\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","storedPaymentMethod.disable.button":"\u524a\u9664","storedPaymentMethod.disable.confirmation":"\u4fdd\u5b58\u3055\u308c\u3066\u3044\u308b\u652f\u6255\u65b9\u6cd5\u3092\u524a\u9664\u3059\u308b","storedPaymentMethod.disable.confirmButton":"\u306f\u3044\u3001\u524a\u9664\u3057\u307e\u3059","storedPaymentMethod.disable.cancelButton":"\u30ad\u30e3\u30f3\u30bb\u30eb","ach.bankAccount":"\u9280\u884c\u53e3\u5ea7","ach.accountHolderNameField.title":"\u53e3\u5ea7\u540d\u7fa9","ach.accountHolderNameField.placeholder":"Taro Yamada","ach.accountHolderNameField.invalid":"\u7121\u52b9\u306a\u53e3\u5ea7\u540d\u7fa9","ach.accountNumberField.title":"\u53e3\u5ea7\u756a\u53f7","ach.accountNumberField.invalid":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","ach.accountLocationField.title":"ABA\u30ca\u30f3\u30d0\u30fc","ach.accountLocationField.invalid":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","select.state":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.stateOrProvince":"\u90fd\u9053\u5e9c\u770c\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.provinceOrTerritory":"\u5dde\u307e\u305f\u306f\u6e96\u5dde\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.country":"\u56fd\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","select.noOptionsFound":"\u30aa\u30d7\u30b7\u30e7\u30f3\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f","select.filter.placeholder":"\u691c\u7d22...","telephoneNumber.invalid":"\u7121\u52b9\u306a\u96fb\u8a71\u756a\u53f7",qrCodeOrApp:"\u307e\u305f\u306f","paypal.processingPayment":"\u652f\u6255\u3044\u3092\u51e6\u7406\u3057\u3066\u3044\u307e\u3059...",generateQRCode:"QR\u30b3\u30fc\u30c9\u3092\u751f\u6210\u3059\u308b","await.waitForConfirmation":"\u78ba\u8a8d\u3092\u5f85\u3063\u3066\u3044\u307e\u3059","mbway.confirmPayment":"MB WAY\u30a2\u30d7\u30ea\u3067\u652f\u6255\u3092\u78ba\u8a8d\u3059\u308b","shopperEmail.invalid":"E\u30e1\u30fc\u30eb\u30a2\u30c9\u30ec\u30b9\u304c\u7121\u52b9\u3067\u3059","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"18\u6b73\u4ee5\u4e0a\u306e\u65b9\u306e\u307f\u3054\u5229\u7528\u3044\u305f\u3060\u3051\u307e\u3059","blik.confirmPayment":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u3092\u958b\u3044\u3066\u3001\u652f\u6255\u3092\u78ba\u8a8d\u3057\u3066\u304f\u3060\u3055\u3044\u3002","blik.invalid":"6\u3064\u306e\u6570\u5b57\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044","blik.code":"6\u6841\u306e\u30b3\u30fc\u30c9","blik.help":"\u30d0\u30f3\u30ad\u30f3\u30b0\u30a2\u30d7\u30ea\u304b\u3089\u30b3\u30fc\u30c9\u3092\u53d6\u5f97\u3057\u3066\u304f\u3060\u3055\u3044\u3002","swish.pendingMessage":"\u30b9\u30ad\u30e3\u30f3\u5f8c\u3001\u30b9\u30c6\u30fc\u30bf\u30b9\u306f\u6700\u592710\u5206\u9593\u4fdd\u7559\u72b6\u614b\u306b\u306a\u308a\u307e\u3059\u3002\u3053\u306e\u9593\u306b\u518d\u5ea6\u304a\u652f\u6255\u3044\u3044\u305f\u3060\u3053\u3046\u3068\u3059\u308b\u3068\u3001\u8907\u6570\u306e\u8acb\u6c42\u304c\u767a\u751f\u3059\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059\u3002","error.va.gen.01":"\u4e0d\u5b8c\u5168\u306a\u30d5\u30a3\u30fc\u30eb\u30c9","error.va.gen.02":"\u30d5\u30a3\u30fc\u30eb\u30c9\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.01":"\u30ab\u30fc\u30c9\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","error.va.sf-cc-num.03":"\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u306a\u3044\u30ab\u30fc\u30c9\u304c\u5165\u529b\u3055\u308c\u307e\u3057\u305f","error.va.sf-cc-dat.01":"\u30ab\u30fc\u30c9\u304c\u53e4\u3059\u304e\u307e\u3059","error.va.sf-cc-dat.02":"\u672a\u6765\u306e\u65e5\u4ed8\u304c\u5148\u3059\u304e\u3067\u3059","error.va.sf-cc-dat.03":"\u30c1\u30a7\u30c3\u30af\u30a2\u30a6\u30c8\u65e5\u3088\u308a\u524d\u306b\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u304c\u5207\u308c\u307e\u3059","error.va.sf-ach-num.01":"\u53e3\u5ea7\u756a\u53f7\u306e\u5165\u529b\u9593\u9055\u3044","error.va.sf-ach-loc.01":"\u7121\u52b9\u306aABA\u30ca\u30f3\u30d0\u30fc","error.va.sf-kcp-pwd.01":"\u30d1\u30b9\u30ef\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","error.giftcard.no-balance":"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u6b8b\u9ad8\u306f\u30bc\u30ed\u3067\u3059","error.giftcard.card-error":"\u8a18\u9332\u3067\u306f\u3001\u3053\u306e\u756a\u53f7\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3042\u308a\u307e\u305b\u3093","error.giftcard.currency-error":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306f\u3001\u767a\u884c\u3055\u308c\u305f\u901a\u8ca8\u3067\u306e\u307f\u6709\u52b9\u3067\u3059\u3002","amazonpay.signout":"Amazon\u304b\u3089\u30b5\u30a4\u30f3\u30a2\u30a6\u30c8\u3059\u308b","amazonpay.changePaymentDetails":"\u652f\u6255\u660e\u7d30\u3092\u5909\u66f4\u3059\u308b","partialPayment.warning":"\u6b8b\u91d1\u3092\u652f\u6255\u3046\u5225\u306e\u652f\u6255\u65b9\u6cd5\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044","partialPayment.remainingBalance":"\u6b8b\u308a\u306e\u6b8b\u9ad8\u306f%{amount}\u306b\u306a\u308a\u307e\u3059","bankTransfer.beneficiary":"\u53d7\u76ca\u8005","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c2\u7167","bankTransfer.introduction":"\u65b0\u3057\u3044\u9280\u884c\u632f\u8fbc\u306b\u3088\u308b\u304a\u652f\u6255\u306e\u4f5c\u6210\u3092\u7d9a\u884c\u3057\u307e\u3059\u3002\u6b21\u306e\u753b\u9762\u306e\u8a73\u7d30\u3092\u4f7f\u7528\u3057\u3066\u3001\u3053\u306e\u304a\u652f\u6255\u3044\u3092\u78ba\u5b9a\u3067\u304d\u307e\u3059\u3002","bankTransfer.instructions":"\u304a\u8cb7\u3044\u4e0a\u3052\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\u4ee5\u4e0b\u306e\u60c5\u5831\u3092\u4f7f\u7528\u3057\u3066\u3001\u304a\u652f\u6255\u3044\u3092\u5b8c\u4e86\u3057\u3066\u304f\u3060\u3055\u3044\u3002","bacs.accountHolderName":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9","bacs.accountHolderName.invalid":"\u9280\u884c\u53e3\u5ea7\u540d\u7fa9\u304c\u7121\u52b9\u3067\u3059","bacs.accountNumber":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7","bacs.accountNumber.invalid":"\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u304c\u7121\u52b9\u3067\u3059","bacs.bankLocationId":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9","bacs.bankLocationId.invalid":"\u30bd\u30fc\u30c8\u30b3\u30fc\u30c9\u304c\u7121\u52b9\u3067\u3059","bacs.consent.amount":"\u4e0a\u8a18\u306e\u91d1\u984d\u304c\u79c1\u306e\u9280\u884c\u53e3\u5ea7\u304b\u3089\u5f15\u304d\u843d\u3068\u3055\u308c\u308b\u3053\u3068\u306b\u540c\u610f\u3057\u307e\u3059\u3002","bacs.consent.account":"\u53e3\u5ea7\u304c\u79c1\u306e\u540d\u7fa9\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u3001\u3053\u306e\u53e3\u5ea7\u304b\u3089\u306e\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u3092\u627f\u8a8d\u3059\u308b\u305f\u3081\u306b\u5fc5\u8981\u306a\u552f\u4e00\u306e\u7f72\u540d\u8005\u3067\u3042\u308b\u3053\u3068\u3092\u78ba\u8a8d\u3057\u307e\u3059\u3002",edit:"\u7de8\u96c6","bacs.confirm":"\u78ba\u8a8d\u3057\u3066\u652f\u6255\u3046","bacs.result.introduction":"\u81ea\u52d5\u5f15\u304d\u843d\u3068\u3057\u306e\u8aac\u660e (DDI/\u59d4\u4efb\u72b6) \u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9\u3059\u308b","download.pdf":"PDF\u3092\u30c0\u30a6\u30f3\u30ed\u30fc\u30c9","creditCard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","creditCard.encryptedCardNumber.aria.label":"\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u65e5\u306e iframe","creditCard.encryptedExpiryDate.aria.label":"\u6709\u52b9\u671f\u9650\u65e5\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u6708\u306e iframe","creditCard.encryptedExpiryMonth.aria.label":"\u6709\u52b9\u671f\u9650\u6708\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u6709\u52b9\u671f\u9650\u5e74\u306e iframe","creditCard.encryptedExpiryYear.aria.label":"\u6709\u52b9\u671f\u9650\u5e74\u30d5\u30a3\u30fc\u30eb\u30c9","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","creditCard.encryptedSecurityCode.aria.label":"\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedCardNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u306e iframe","giftcard.encryptedCardNumber.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u306e iframe","giftcard.encryptedSecurityCode.aria.label":"\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u306e\u30bb\u30ad\u30e5\u30ea\u30c6\u30a3\u30b3\u30fc\u30c9\u30d5\u30a3\u30fc\u30eb\u30c9",giftcardTransactionLimit:"\u3053\u306e\u30ae\u30d5\u30c8\u30ab\u30fc\u30c9\u3067\u306e\u53d6\u5f15\u3054\u3068\u306b\u8a31\u53ef\u3055\u308c\u308b\u6700\u5927%{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u53e3\u5ea7\u756a\u53f7\u306e iframe","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u53e3\u5ea7\u30d5\u30a3\u30fc\u30eb\u30c9","ach.encryptedBankLocationId.aria.iframeTitle":"\u4fdd\u8b77\u3055\u308c\u305f\u9280\u884c\u652f\u5e97\u756a\u53f7\u306e iframe","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u652f\u5e97\u756a\u53f7\u30d5\u30a3\u30fc\u30eb\u30c9","twint.saved":"\u3092\u4fdd\u5b58\u3057\u307e\u3057\u305f"}}),jk=Object.freeze({__proto__:null,default:{payButton:"\uacb0\uc81c","payButton.redirecting":"\ub9ac\ub514\ub809\uc158 \uc911...",storeDetails:"\ub2e4\uc74c \uacb0\uc81c\ub97c \uc704\ud574 \uc774 \uc218\ub2e8 \uc800\uc7a5","creditCard.holderName":"\uce74\ub4dc\uc0c1\uc758 \uc774\ub984","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc774\ub984","creditCard.numberField.title":"\uce74\ub4dc \ubc88\ud638","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\ub9cc\ub8cc\uc77c","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\uc6d4","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\uc5f0\ub3c4","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\ub2e4\uc74c\uc744 \uc704\ud574 \uc800\uc7a5","creditCard.cvcField.placeholder.4digits":"4\uc790\ub9ac","creditCard.cvcField.placeholder.3digits":"3\uc790\ub9ac","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"\ud560\ubd80 \uac1c\uc6d4 \uc218",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times}\uac1c\uc6d4","installments.oneTime":"\uc77c\uc2dc\ubd88 \uacb0\uc81c","installments.installments":"\ud560\ubd80 \uacb0\uc81c","installments.revolving":"\ub9ac\ubcfc\ube59 \uacb0\uc81c","sepaDirectDebit.ibanField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\uc18c\uc720\uc790 \uc774\ub984","sepa.ibanNumber":"\uacc4\uc88c \ubc88\ud638(IBAN)","error.title":"\uc624\ub958","error.subtitle.redirect":"\ub9ac\ub514\ub809\uc158 \uc2e4\ud328","error.subtitle.payment":"\uacb0\uc81c \uc2e4\ud328","error.subtitle.refused":"\uacb0\uc81c \uac70\ubd80","error.message.unknown":"\uc54c \uc218 \uc5c6\ub294 \uc624\ub958 \ubc1c\uc0dd","idealIssuer.selectField.title":"\uc740\ud589","idealIssuer.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","creditCard.success":"\uacb0\uc81c \uc131\uacf5",loading:"\ub85c\ub4dc \uc911\u2026",continue:"\uacc4\uc18d",continueTo:"\ub2e4\uc74c\uc73c\ub85c \uacc4\uc18d:","wechatpay.timetopay":"\ub0a8\uc740 \uacb0\uc81c \uc2dc\ud55c: %@","wechatpay.scanqrcode":"QR \ucf54\ub4dc \uc2a4\uce94",personalDetails:"\uac1c\uc778 \uc815\ubcf4",companyDetails:"\ud68c\uc0ac \uc815\ubcf4","companyDetails.name":"\ud68c\uc0ac\uba85","companyDetails.registrationNumber":"\ub4f1\ub85d \ubc88\ud638",socialSecurityNumber:"\uc0ac\ud68c \ubcf4\uc7a5 \ubc88\ud638(\uc8fc\ubbfc\ub4f1\ub85d\ubc88\ud638)",firstName:"\uc774\ub984",infix:"\uba85\uce6d",lastName:"\uc131",mobileNumber:"\ud734\ub300\ud3f0 \ubc88\ud638","mobileNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ud734\ub300\ud3f0 \ubc88\ud638",city:"\uc2dc",postalCode:"\uc6b0\ud3b8\ubc88\ud638",countryCode:"\uad6d\uac00 \ucf54\ub4dc",telephoneNumber:"\uc804\ud654\ubc88\ud638",dateOfBirth:"\uc0dd\ub144\uc6d4\uc77c",shopperEmail:"\uc774\uba54\uc77c \uc8fc\uc18c",gender:"\uc131\ubcc4",male:"\ub0a8\uc131",female:"\uc5ec\uc131",billingAddress:"\uccad\uad6c\uc9c0 \uc8fc\uc18c",street:"\ub3c4\ub85c\uba85",stateOrProvince:"\uc8fc/\ub3c4",country:"\uad6d\uac00",houseNumberOrName:"\uc9d1 \uc804\ud654\ubc88\ud638",separateDeliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c \ubcc4\ub3c4 \uc9c0\uc815",deliveryAddress:"\ubc30\uc1a1 \uc8fc\uc18c",zipCode:"\uc6b0\ud3b8\ubc88\ud638",apartmentSuite:"\uc544\ud30c\ud2b8/\uac74\ubb3c",provinceOrTerritory:"\ub3c4",cityTown:"\uc2dc/\uad6c",address:"\uc8fc\uc18c",state:"\uc8fc","field.title.optional":"(\uc120\ud0dd \uc0ac\ud56d)","creditCard.cvcField.title.optional":"CVC / CVV (\uc120\ud0dd)","issuerList.wallet.placeholder":"\uc804\uc790 \uc9c0\uac11 \uc120\ud0dd",privacyPolicy:"\uac1c\uc778\uc815\ubcf4 \ubcf4\ud638\uc815\ucc45","afterPay.agreement":"AfterPay\uc758 %@\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.",paymentConditions:"\uacb0\uc81c \uc870\uac74",openApp:"\uc571 \uc5f4\uae30","voucher.readInstructions":"\uc548\ub0b4 \uc77d\uae30","voucher.introduction":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ucfe0\ud3f0\uc744 \uc0ac\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.expirationDate":"\ub9cc\ub8cc\uc77c","voucher.alternativeReference":"\ub300\uccb4 \ucc38\uc870\ubc88\ud638","dragonpay.voucher.non.bank.selectField.placeholder":"\uc81c\uacf5 \uc5c5\uccb4 \uc120\ud0dd","dragonpay.voucher.bank.selectField.placeholder":"\uc740\ud589 \uc120\ud0dd","voucher.paymentReferenceLabel":"\uacb0\uc81c \ucc38\uc870\ubc88\ud638","voucher.surcharge":"%@ \ud560\uc99d\ub8cc \ud3ec\ud568","voucher.introduction.doku":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.shopperName":"\uad6c\ub9e4\uc790 \uc774\ub984","voucher.merchantName":"\uac00\ub9f9\uc810","voucher.introduction.econtext":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","voucher.telephoneNumber":"\uc804\ud654\ubc88\ud638","voucher.shopperReference":"\uad6c\ub9e4\uc790 \ucc38\uc870\ubc88\ud638","voucher.collectionInstitutionNumber":"\uc218\uae08 \uae30\uad00 \ubc88\ud638","voucher.econtext.telephoneNumber.invalid":"\uc804\ud654\ubc88\ud638\ub294 10\uc790\ub9ac \ub610\ub294 11\uc790\ub9ac \uc22b\uc790\uc5ec\uc57c \ud569\ub2c8\ub2e4","boletobancario.btnLabel":"Boleto \uc0dd\uc131","boleto.sendCopyToEmail":"\ub0b4 \uc774\uba54\uc77c\ub85c \uc0ac\ubcf8 \ubcf4\ub0b4\uae30","button.copy":"\ubcf5\uc0ac","button.download":"\ub2e4\uc6b4\ub85c\ub4dc","creditCard.storedCard.description.ariaLabel":"\uc800\uc7a5\ub41c \uce74\ub4dc\ub294 %@ \ud6c4 \uc885\ub8cc\ub429\ub2c8\ub2e4.","voucher.entity":"\ubc1c\uae09\uc0ac",donateButton:"\uae30\ubd80\ud558\uae30",notNowButton:"\ub2e4\uc74c\uc5d0 \ud558\uae30",thanksForYourSupport:"\ub3c4\uc640\uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4!",preauthorizeWith:"\uc0ac\uc804 \uc2b9\uc778 \ubc29\ubc95:",confirmPreauthorization:"\uc0ac\uc804 \uc2b9\uc778 \ud655\uc778",confirmPurchase:"\uad6c\ub9e4 \ud655\uc778",applyGiftcard:"\uae30\ud504\ud2b8 \uce74\ub4dc\ub85c \uacb0\uc81c",giftcardBalance:"\uae30\ud504\ud2b8 \uce74\ub4dc \uc794\uc561",deductedBalance:"\uacf5\uc81c \uc794\uc561","creditCard.pin.title":"\ube44\ubc00\ubc88\ud638","creditCard.encryptedPassword.label":"\uce74\ub4dc \ube44\ubc00\ubc88\ud638 \uccab 2\uc790\ub9ac","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","creditCard.taxNumber.label":"\uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c(\uc608: 870130) \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.labelAlt":"\ubc95\uc778 \ub4f1\ub85d \ubc88\ud638(10\uc790\ub9ac)","creditCard.taxNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \uc18c\uc720\uc790 \uc0dd\ub144\uc6d4\uc77c \ub610\ub294 \ubc95\uc778 \ub4f1\ub85d \ubc88\ud638","storedPaymentMethod.disable.button":"\uc0ad\uc81c","storedPaymentMethod.disable.confirmation":"\uc800\uc7a5\ub41c \uacb0\uc81c \uc218\ub2e8 \uc0ad\uc81c","storedPaymentMethod.disable.confirmButton":"\uc608, \uc0ad\uc81c\ud569\ub2c8\ub2e4","storedPaymentMethod.disable.cancelButton":"\ucde8\uc18c","ach.bankAccount":"\uc740\ud589 \uacc4\uc88c","ach.accountHolderNameField.title":"\uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \uc18c\uc720\uc790 \uc774\ub984","ach.accountNumberField.title":"\uacc4\uc88c \ubc88\ud638","ach.accountNumberField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","ach.accountLocationField.title":"ABA \ub77c\uc6b0\ud305 \ubc88\ud638","ach.accountLocationField.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","select.state":"\uc8fc \uc120\ud0dd","select.stateOrProvince":"\uc8fc/\ub3c4 \uc120\ud0dd","select.provinceOrTerritory":"\ub3c4 \uc120\ud0dd","select.country":"\uad6d\uac00 \uc120\ud0dd","select.noOptionsFound":"\uac80\uc0c9\ub41c \uc635\uc158 \uc5c6\uc74c","select.filter.placeholder":"\uac80\uc0c9...","telephoneNumber.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc804\ud654\ubc88\ud638",qrCodeOrApp:"\ub610\ub294","paypal.processingPayment":"\uacb0\uc81c \ucc98\ub9ac \uc911...",generateQRCode:"QR \ucf54\ub4dc \uc0dd\uc131","await.waitForConfirmation":"\ud655\uc778 \ub300\uae30\uc911","mbway.confirmPayment":"MB WAY \uc571\uc5d0\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc2ed\uc2dc\uc624","shopperEmail.invalid":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uc774\uba54\uc77c \uc8fc\uc18c","dateOfBirth.format":"DD(\uc77c)/MM(\uc6d4)/YYYY(\uc5f0\ub3c4)","dateOfBirth.invalid":"\ucd5c\uc18c 18\uc138 \uc774\uc0c1\uc774\uc5b4\uc57c \ud569\ub2c8\ub2e4","blik.confirmPayment":"\ubc45\ud0b9 \uc571\uc744 \uc5f4\uc5b4\uc11c \uacb0\uc81c\ub97c \ud655\uc778\ud558\uc138\uc694.","blik.invalid":"6\uc790\ub9ac \uc22b\uc790 \uc785\ub825","blik.code":"6\uc790\ub9ac \ucf54\ub4dc","blik.help":"\ubc45\ud0b9 \uc571\uc5d0\uc11c \ucf54\ub4dc\ub97c \uac00\uc838\uc624\uc138\uc694.","swish.pendingMessage":"\uc2a4\uce94 \ud6c4 \ucd5c\ub300 10\ubd84 \ub3d9\uc548 \uc0c1\ud0dc\uac00 \ubcf4\ub958\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4. 10\ubd84 \ub0b4\uc5d0 \ub2e4\uc2dc \uc2dc\ub3c4\ud560 \uacbd\uc6b0 \uae08\uc561\uc774 \uc5ec\ub7ec \ubc88 \uccad\uad6c\ub420 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","error.va.gen.01":"\ubbf8\uc644\ub8cc \ud544\ub4dc","error.va.gen.02":"\ud544\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.va.sf-cc-num.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uce74\ub4dc \ubc88\ud638\uc785\ub2c8\ub2e4","error.va.sf-cc-num.03":"\uc9c0\uc6d0\ub418\uc9c0 \uc54a\ub294 \uce74\ub4dc\uac00 \uc785\ub825\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.01":"\uce74\ub4dc\uac00 \ub108\ubb34 \uc624\ub798\ub418\uc5c8\uc2b5\ub2c8\ub2e4","error.va.sf-cc-dat.02":"\ud604\uc7ac\ub85c\ubd80\ud130 \ub108\ubb34 \uba3c \ub0a0\uc9dc\uc785\ub2c8\ub2e4","error.va.sf-cc-dat.03":"\uadc0\ud558\uc758 \uce74\ub4dc\uac00 \uacb0\uc81c\uc77c \uc804\uc5d0 \ub9cc\ub8cc\ub429\ub2c8\ub2e4.","error.va.sf-ach-num.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \uacc4\uc88c \ubc88\ud638","error.va.sf-ach-loc.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 ABA \ub77c\uc6b0\ud305 \ubc88\ud638","error.va.sf-kcp-pwd.01":"\uc720\ud6a8\ud558\uc9c0 \uc54a\uc740 \ubc88\ud638","error.giftcard.no-balance":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc\uc5d0\ub294 \uc794\uc561\uc774 \uc5c6\uc2b5\ub2c8\ub2e4","error.giftcard.card-error":"\uc774 \uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638\ub294 \ub2f9\uc0ac\uc5d0 \ub4f1\ub85d\ub418\uc5b4 \uc788\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","error.giftcard.currency-error":"\uae30\ud504\ud2b8 \uce74\ub4dc\ub294 \ubc1c\uae09\ub41c \ud1b5\ud654\ub85c\ub9cc \uc0ac\uc6a9\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4","amazonpay.signout":"Amazon\uc5d0\uc11c \ub85c\uadf8\uc544\uc6c3","amazonpay.changePaymentDetails":"\uacb0\uc81c \uc815\ubcf4 \ubcc0\uacbd","partialPayment.warning":"\ub098\uba38\uc9c0 \ube44\uc6a9 \uc9c0\ubd88\uc5d0 \uc0ac\uc6a9\ud560 \ub2e4\ub978 \uacb0\uc81c \uc218\ub2e8 \uc120\ud0dd\ud558\uae30","partialPayment.remainingBalance":"\ub0a8\uc740 \uc794\uc561\uc740 %{amount}\uc785\ub2c8\ub2e4","bankTransfer.beneficiary":"\uc218\ub839\uc778","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\ucc38\uc870 \ubc88\ud638","bankTransfer.introduction":"\uc0c8 \uacc4\uc88c \uc774\uccb4 \uac74\uc744 \uacc4\uc18d \uc9c4\ud589\ud569\ub2c8\ub2e4. \ub2e4\uc74c \ud654\uba74\uc5d0 \ub098\uc624\ub294 \uc815\ubcf4\ub97c \uc774\uc6a9\ud574 \uc774\uccb4\ub97c \uc644\ub8cc\ud558\uc2e4 \uc218 \uc788\uc2b5\ub2c8\ub2e4.","bankTransfer.instructions":"\uad6c\ub9e4\ud574 \uc8fc\uc154\uc11c \uac10\uc0ac\ud569\ub2c8\ub2e4. \ub2e4\uc74c \uc815\ubcf4\ub97c \uc774\uc6a9\ud558\uc5ec \uacb0\uc81c\ub97c \uc644\ub8cc\ud558\uc2ed\uc2dc\uc624.","bacs.accountHolderName":"\uc608\uae08\uc8fc \uc774\ub984","bacs.accountHolderName.invalid":"\uc608\uae08\uc8fc \uc774\ub984\uc774 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.accountNumber":"\uacc4\uc88c \ubc88\ud638","bacs.accountNumber.invalid":"\uacc4\uc88c \ubc88\ud638\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.bankLocationId":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc","bacs.bankLocationId.invalid":"\uc740\ud589 \uc2dd\ubcc4 \ucf54\ub4dc\uac00 \uc720\ud6a8\ud558\uc9c0 \uc54a\uc2b5\ub2c8\ub2e4","bacs.consent.amount":"\uacc4\uc88c\uc5d0\uc11c \uc704\uc758 \uae08\uc561\uc744 \uc774\uccb4\ud558\ub294 \uac83\uc5d0 \ub3d9\uc758\ud569\ub2c8\ub2e4.","bacs.consent.account":"\ubcf8\uc778\uc774 \uc774 \uacc4\uc88c\uc758 \uc608\uae08\uc8fc\uc774\uba70, \uc774 \uacc4\uc88c\uc5d0\uc11c\uc758 \uc790\ub3d9 \uc774\uccb4\ub97c \uc2b9\uc778\ud558\uae30 \uc704\ud574 \ud544\uc694\ud55c \uc720\uc77c\ud55c \uc11c\uba85\uc778\uc785\ub2c8\ub2e4.",edit:"\uc218\uc815","bacs.confirm":"\ud655\uc778 \ubc0f \uacb0\uc81c","bacs.result.introduction":"\uc790\ub3d9 \uc774\uccb4 \uc548\ub0b4(DDI/\ud544\uc218) \ub2e4\uc6b4\ub85c\ub4dc","download.pdf":"PDF \ub2e4\uc6b4\ub85c\ub4dc","creditCard.encryptedCardNumber.aria.iframeTitle":"\uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedCardNumber.aria.label":"\uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","creditCard.encryptedExpiryDate.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \ub0a0\uc9dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryDate.aria.label":"\ub9cc\ub8cc \ub0a0\uc9dc \uc785\ub825\ub780","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc6d4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryMonth.aria.label":"\ub9cc\ub8cc \uc6d4 \uc785\ub825\ub780","creditCard.encryptedExpiryYear.aria.iframeTitle":"\uce74\ub4dc \ub9cc\ub8cc \uc5f0\ub3c4 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedExpiryYear.aria.label":"\ub9cc\ub8cc \uc5f0\ub3c4 \uc785\ub825\ub780","creditCard.encryptedSecurityCode.aria.iframeTitle":"\uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","creditCard.encryptedSecurityCode.aria.label":"\ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780","giftcard.encryptedCardNumber.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedCardNumber.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubc88\ud638 \uc785\ub825\ub780","giftcard.encryptedSecurityCode.aria.iframeTitle":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \ubcf4\uc548\uc744 \uc704\ud55c Iframe","giftcard.encryptedSecurityCode.aria.label":"\uae30\ud504\ud2b8 \uce74\ub4dc \ubcf4\uc548 \ucf54\ub4dc \uc785\ub825\ub780",giftcardTransactionLimit:"\uc774 \uae30\ud504\ud2b8\uce74\ub4dc\ub85c \uac74\ub2f9 \uacb0\uc81c \uac00\ub2a5\ud55c \ucd5c\uace0 \uc561\uc218\ub294 %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\uc740\ud589 \uacc4\uc88c \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankAccountNumber.aria.label":"\uc740\ud589 \uacc4\uc88c \uc785\ub825\ub780","ach.encryptedBankLocationId.aria.iframeTitle":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \ubcf4\uc548\uc744 \uc704\ud55c Iframe","ach.encryptedBankLocationId.aria.label":"\uc740\ud589 \ub77c\uc6b0\ud305 \ubc88\ud638 \uc785\ub825\ub780","twint.saved":"\uc800\uc7a5\ub428"}}),Mk=Object.freeze({__proto__:null,default:{payButton:"Betaal","payButton.redirecting":"U wordt doorverwezen...",storeDetails:"Bewaar voor mijn volgende betaling","creditCard.holderName":"Naam op kaart","creditCard.holderName.placeholder":"J. Janssen","creditCard.holderName.invalid":"Ongeldige naam kaarthouder","creditCard.numberField.title":"Kaartnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Vervaldatum","creditCard.expiryDateField.placeholder":"MM/JJ","creditCard.expiryDateField.month":"Maand","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"JJ","creditCard.expiryDateField.year":"Jaar","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Onthouden voor de volgende keer","creditCard.cvcField.placeholder.4digits":"4 cijfers","creditCard.cvcField.placeholder.3digits":"3 cijfers","creditCard.taxNumber.placeholder":"JJMMDD / 0123456789",installments:"Aantal termijnen",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} maanden","installments.oneTime":"Eenmalige betaling","installments.installments":"Betaling termijnen","installments.revolving":"Terugkerende betaling","sepaDirectDebit.ibanField.invalid":"Ongeldig rekeningnummer","sepaDirectDebit.nameField.placeholder":"J. Janssen","sepa.ownerName":"Ten name van","sepa.ibanNumber":"Rekeningnummer (IBAN)","error.title":"Fout","error.subtitle.redirect":"Doorsturen niet gelukt","error.subtitle.payment":"Betaling is niet geslaagd","error.subtitle.refused":"Betaling geweigerd","error.message.unknown":"Er is een onbekende fout opgetreden","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Selecteer uw bank","creditCard.success":"Betaling geslaagd",loading:"Laden....",continue:"Doorgaan",continueTo:"Doorgaan naar","wechatpay.timetopay":"U heeft %@ om te betalen","wechatpay.scanqrcode":"QR-code scannen",personalDetails:"Persoonlijke gegevens",companyDetails:"Bedrijfsgegevens","companyDetails.name":"Bedrijfsnaam","companyDetails.registrationNumber":"Registratienummer",socialSecurityNumber:"Burgerservicenummer",firstName:"Voornaam",infix:"Voorvoegsel",lastName:"Achternaam",mobileNumber:"Telefoonnummer mobiel","mobileNumber.invalid":"Ongeldig mobiel nummer",city:"Stad",postalCode:"Postcode",countryCode:"Landcode",telephoneNumber:"Telefoonnummer",dateOfBirth:"Geboortedatum",shopperEmail:"E-mailadres",gender:"Geslacht",male:"Man",female:"Vrouw",billingAddress:"Factuuradres",street:"Straatnaam",stateOrProvince:"Staat of provincie",country:"Land",houseNumberOrName:"Huisnummer",separateDeliveryAddress:"Een afwijkend bezorgadres opgeven",deliveryAddress:"Bezorgadres",zipCode:"Postcode",apartmentSuite:"Appartement/Suite",provinceOrTerritory:"Provincie of territorium",cityTown:"Stad",address:"Adres",state:"Staat","field.title.optional":"(optioneel)","creditCard.cvcField.title.optional":"CVC / CVV (optioneel)","issuerList.wallet.placeholder":"Selecteer uw portemonnee",privacyPolicy:"Privacybeleid","afterPay.agreement":"Ik ga akkoord met de %@ van AfterPay",paymentConditions:"betalingsvoorwaarden",openApp:"Open de app","voucher.readInstructions":"Instructies lezen","voucher.introduction":"Bedankt voor uw aankoop. Gebruik deze coupon om uw betaling te voltooien.","voucher.expirationDate":"Vervaldatum","voucher.alternativeReference":"Alternatieve referentie","dragonpay.voucher.non.bank.selectField.placeholder":"Selecteer uw aanbieder","dragonpay.voucher.bank.selectField.placeholder":"Selecteer uw bank","voucher.paymentReferenceLabel":"Betalingsreferentie","voucher.surcharge":"Inclusief %@ toeslag","voucher.introduction.doku":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.shopperName":"Klantnaam","voucher.merchantName":"Verkoper","voucher.introduction.econtext":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","voucher.telephoneNumber":"Telefoonnummer","voucher.shopperReference":"Klant referentie","voucher.collectionInstitutionNumber":"Nummer ophaallocatie","voucher.econtext.telephoneNumber.invalid":"Het telefoonnummer moet uit 10 of 11 cijfers bestaan","boletobancario.btnLabel":"Boleto genereren","boleto.sendCopyToEmail":"Stuur een kopie naar mijn e-mailadres","button.copy":"Kopi\xebren","button.download":"Downloaden","creditCard.storedCard.description.ariaLabel":"Opgeslagen kaart eindigt op %@","voucher.entity":"Entiteit",donateButton:"Doneren",notNowButton:"Niet nu",thanksForYourSupport:"Bedankt voor uw donatie!",preauthorizeWith:"Preautorisatie uitvoeren met",confirmPreauthorization:"Preautorisatie bevestigen",confirmPurchase:"Aankoop bevestigen",applyGiftcard:"Inwisselen",giftcardBalance:"Saldo cadeaukaart",deductedBalance:"Afgetrokken bedrag","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Eerste twee cijfers van het wachtwoord van de kaart","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ongeldig wachtwoord","creditCard.taxNumber.label":"Geboortedatum (JJ-MM-DD) of bedrijfsregistratienummer (10 cijfers) van kaarthouder","creditCard.taxNumber.labelAlt":"Bedrijfsregistratienummer (10 cijfers)","creditCard.taxNumber.invalid":"Geboortedatum of bedrijfsregistratienummer van kaarthouder is ongeldig","storedPaymentMethod.disable.button":"Verwijderen","storedPaymentMethod.disable.confirmation":"Opgeslagen betalingsmethode verwijderen","storedPaymentMethod.disable.confirmButton":"Ja, verwijderen","storedPaymentMethod.disable.cancelButton":"Annuleren","ach.bankAccount":"Bankrekening","ach.accountHolderNameField.title":"Naam rekeninghouder","ach.accountHolderNameField.placeholder":"J. Janssen","ach.accountHolderNameField.invalid":"Ongeldige naam rekeninghouder","ach.accountNumberField.title":"Rekeningnummer","ach.accountNumberField.invalid":"Ongeldig rekeningnummer","ach.accountLocationField.title":"Routingnummer (ABA)","ach.accountLocationField.invalid":"Ongeldig routingnummer (ABA)","select.state":"Selecteer staat","select.stateOrProvince":"Selecteer staat of provincie","select.provinceOrTerritory":"Selecteer provincie of territorium","select.country":"Selecteer land","select.noOptionsFound":"Geen opties gevonden","select.filter.placeholder":"Zoeken...","telephoneNumber.invalid":"Ongeldig telefoonnummer",qrCodeOrApp:"of","paypal.processingPayment":"Betaling wordt verwerkt...",generateQRCode:"Genereer QR-code","await.waitForConfirmation":"Wacht op bevestiging","mbway.confirmPayment":"Bevestig uw betaling via de MB WAY-app","shopperEmail.invalid":"Ongeldig e-mailadres","dateOfBirth.format":"DD/MM/JJJJ","dateOfBirth.invalid":"U moet minimaal 18 jaar oud zijn","blik.confirmPayment":"Open uw bankapp om de betaling te bevestigen.","blik.invalid":"Voer 6 cijfers in","blik.code":"6-cijferige code","blik.help":"Haal de code op in uw bankapp.","swish.pendingMessage":"Nadat u hebt gescand, kan de status maximaal 10 minuten in behandeling zijn. Als u binnen deze periode opnieuw probeert te betalen, kunnen er meerdere keren kosten in rekening worden gebracht.","error.va.gen.01":"Onvolledig veld","error.va.gen.02":"Veld niet geldig","error.va.sf-cc-num.01":"Ongeldig kaartnummer","error.va.sf-cc-num.03":"Niet-ondersteunde kaart ingevoerd","error.va.sf-cc-dat.01":"Kaart te oud","error.va.sf-cc-dat.02":"Datum te ver in de toekomst","error.va.sf-cc-dat.03":"Uw kaart verloopt voor de betaaldatum","error.va.sf-ach-num.01":"Ongeldig rekeningnummer","error.va.sf-ach-loc.01":"Ongeldig routingnummer (ABA)","error.va.sf-kcp-pwd.01":"Ongeldig wachtwoord","error.giftcard.no-balance":"Deze cadeaukaart heeft geen saldo","error.giftcard.card-error":"We hebben geen cadeaukaart met dit nummer in onze administratie","error.giftcard.currency-error":"Cadeaukaarten zijn alleen geldig in de valuta waarin ze zijn uitgegeven","amazonpay.signout":"Afmelden bij Amazon","amazonpay.changePaymentDetails":"Betalingsgegevens wijzigen","partialPayment.warning":"Selecteer een andere betaalmethode om het resterende deel te betalen","partialPayment.remainingBalance":"Het resterende saldo is %{amount}","bankTransfer.beneficiary":"Begunstigde","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referentie","bankTransfer.introduction":"Ga door om een nieuwe overschrijving aan te maken. U kunt de gegevens in het volgende scherm gebruiken om deze betaling af te ronden.","bankTransfer.instructions":"Bedankt voor uw aankoop. Gebruik de volgende informatie om uw betaling te voltooien.","bacs.accountHolderName":"Naam bankrekeninghouder","bacs.accountHolderName.invalid":"Ongeldige naam bankrekeninghouder","bacs.accountNumber":"Bankrekeningnummer","bacs.accountNumber.invalid":"Ongeldig bankrekeningnummer","bacs.bankLocationId":"Bankcode","bacs.bankLocationId.invalid":"Ongeldige bankcode","bacs.consent.amount":"Ik ga ermee akkoord dat het bovengenoemde bedrag van mijn bankrekening wordt afgeschreven.","bacs.consent.account":"Ik bevestig dat de rekening op mijn naam staat en dat ik de enige ondertekenaar ben die toestemming kan geven voor automatische incasso's vanaf deze rekening.",edit:"Bewerken","bacs.confirm":"Bevestigen en betalen","bacs.result.introduction":"Download uw machtiging automatische incasso","download.pdf":"PDF downloaden","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd kaartnummer","creditCard.encryptedCardNumber.aria.label":"Veld voor kaartnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe voor vervaldatum beveiligde kaart","creditCard.encryptedExpiryDate.aria.label":"Veld voor vervaldatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe voor vervalmaand beveiligde kaart","creditCard.encryptedExpiryMonth.aria.label":"Veld voor vervalmaand","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe voor vervaljaar beveiligde kaart","creditCard.encryptedExpiryYear.aria.label":"Veld voor vervaljaar","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde kaart","creditCard.encryptedSecurityCode.aria.label":"Veld voor beveiligingscode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe voor beveiligd cadeaubonnummer","giftcard.encryptedCardNumber.aria.label":"Veld voor cadeaubonnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe voor beveiligingscode beveiligde cadeaubon","giftcard.encryptedSecurityCode.aria.label":"Veld beveiligingscode cadeaubon",giftcardTransactionLimit:"Max. %{amount} toegestaan per transactie met deze cadeaubon","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe voor beveiligd bankrekeningnummer","ach.encryptedBankAccountNumber.aria.label":"Veld voor bankrekening","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe voor beveiligde BIC-code","ach.encryptedBankLocationId.aria.label":"Veld voor BIC-code","twint.saved":"opgeslagen"}}),Ok=Object.freeze({__proto__:null,default:{payButton:"Betal","payButton.redirecting":"Omdirigerer...",storeDetails:"Lagre til min neste betaling","creditCard.holderName":"Navn p\xe5 kortet","creditCard.holderName.placeholder":"O. Nordmann","creditCard.holderName.invalid":"Ugyldig navn p\xe5 kortholder","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utl\xf8psdato","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5ned","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Husk til neste gang","creditCard.cvcField.placeholder.4digits":"4 siffer","creditCard.cvcField.placeholder.3digits":"3 siffer","creditCard.taxNumber.placeholder":"YYMMDD / 0123456789",installments:"Antall avdrag",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} m\xe5neder","installments.oneTime":"Engangsbetaling","installments.installments":"Avdragsbetaling","installments.revolving":"Gjentakende betaling","sepaDirectDebit.ibanField.invalid":"Ugyldig kontonummer","sepaDirectDebit.nameField.placeholder":"O. Nordmann","sepa.ownerName":"Kortholders navn","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Feil","error.subtitle.redirect":"Videresending feilet","error.subtitle.payment":"Betaling feilet","error.subtitle.refused":"Betaling avvist","error.message.unknown":"En ukjent feil oppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Velg din bank","creditCard.success":"Betalingen var vellykket",loading:"Laster...",continue:"Fortsett",continueTo:"Fortsett til","wechatpay.timetopay":"Du har %@ igjen til \xe5 betale","wechatpay.scanqrcode":"Skann QR-kode",personalDetails:"Personopplysninger",companyDetails:"Firmadetaljer","companyDetails.name":"Firmanavn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"Fornavn",infix:"Prefiks",lastName:"Etternavn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ugyldig mobilnummer",city:"Poststed",postalCode:"Postnummer",countryCode:"Landkode",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf8dselsdato",shopperEmail:"E-postadresse",gender:"Kj\xf8nn",male:"Mann",female:"Kvinne",billingAddress:"Faktureringsadresse",street:"Gate",stateOrProvince:"Fylke",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Spesifiser en separat leveringsadresse",deliveryAddress:"Leveringsadresse",zipCode:"Postnummer",apartmentSuite:"Leilighet/suite",provinceOrTerritory:"Provins eller territorium",cityTown:"By",address:"Adresse",state:"Delstat","field.title.optional":"(valgfritt)","creditCard.cvcField.title.optional":"CVC / CVV (valgfritt)","issuerList.wallet.placeholder":"Velg lommebok",privacyPolicy:"Retningslinjer for personvern","afterPay.agreement":"Jeg godtar AfterPays %@",paymentConditions:"betalingsbetingelser",openApp:"\xc5pne appen","voucher.readInstructions":"Les instruksjoner","voucher.introduction":"Takk for ditt kj\xf8p. Vennligst bruk den f\xf8lgende kupongen til \xe5 fullf\xf8re betalingen.","voucher.expirationDate":"Utl\xf8psdato","voucher.alternativeReference":"Alternativ referanse","dragonpay.voucher.non.bank.selectField.placeholder":"Velg din leverand\xf8r","dragonpay.voucher.bank.selectField.placeholder":"Velg din bank","voucher.paymentReferenceLabel":"Betalingsreferanse","voucher.surcharge":"Inkl. %@ tilleggsavgift","voucher.introduction.doku":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.shopperName":"Kundenavn","voucher.merchantName":"Forhandler","voucher.introduction.econtext":"Takk for ditt kj\xf8p, vennligst bruk den f\xf8lgende informasjonen for \xe5 fullf\xf8re betalingen.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"Kundereferanse","voucher.collectionInstitutionNumber":"Innbetalingslokasjonsnummer","voucher.econtext.telephoneNumber.invalid":"Telefonnummeret m\xe5 v\xe6re 10 eller 11 sifre langt","boletobancario.btnLabel":"Generer Boleto","boleto.sendCopyToEmail":"Send meg en kopi p\xe5 e-post","button.copy":"Kopier","button.download":"Last ned","creditCard.storedCard.description.ariaLabel":"Lagret kort slutter p\xe5 %@","voucher.entity":"Enhet",donateButton:"Don\xe9r",notNowButton:"Ikke n\xe5",thanksForYourSupport:"Takk for din st\xf8tte!",preauthorizeWith:"Forh\xe5ndsgodkjenn med",confirmPreauthorization:"Bekreft forh\xe5ndsgodkjenning",confirmPurchase:"Bekreft kj\xf8p",applyGiftcard:"L\xf8s inn",giftcardBalance:"Gavekortsaldo",deductedBalance:"Fratrukket bel\xf8p","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"F\xf8rste 2 sifre av kortpassord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ugyldig passord","creditCard.taxNumber.label":"Kortholders f\xf8dselsdato (YYMMDD) eller bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.labelAlt":"Bedriftsregistreringsnummer (10 siffer)","creditCard.taxNumber.invalid":"Ugyldig kortholders f\xf8dselsdato eller bedriftsregistreringsnummer","storedPaymentMethod.disable.button":"Fjern","storedPaymentMethod.disable.confirmation":"Fjern lagret betalingsmetode","storedPaymentMethod.disable.confirmButton":"Ja, fjern","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoholders navn","ach.accountHolderNameField.placeholder":"O. Nordmann","ach.accountHolderNameField.invalid":"Ugyldig navn p\xe5 kontoholder","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ugyldig kontonummer","ach.accountLocationField.title":"ABA-dirigeringsnummer","ach.accountLocationField.invalid":"Ugyldig ABA-dirigeringsnummer","select.state":"Velg delstat","select.stateOrProvince":"Velg delstat eller provins","select.provinceOrTerritory":"Velg provins eller territorium","select.country":"Velg land","select.noOptionsFound":"Ingen alternativer funnet","select.filter.placeholder":"S\xf8k\xa0\u2026","telephoneNumber.invalid":"Ugyldig telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandler betaling \u2026",generateQRCode:"Generer QR-kode","await.waitForConfirmation":"Venter p\xe5 bekreftelse","mbway.confirmPayment":"Bekreft betalingen din i MB WAY-appen","shopperEmail.invalid":"Ugyldig e-postadresse","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5 v\xe6re minst 18 \xe5r gammel","blik.confirmPayment":"\xc5pne bank-appen din for \xe5 bekrefte betalingen.","blik.invalid":"Tast inn 6 tall","blik.code":"6-sifret kode","blik.help":"Hent koden fra bank-appen din.","swish.pendingMessage":"Etter at du har skannet koden kan det ta opptil 10 minutter f\xf8r betalingen vises som bekreftet. Fors\xf8k p\xe5 \xe5 betale igjen kan f\xf8re til flere innbetalinger.","error.va.gen.01":"Ufullstendig felt","error.va.gen.02":"Feltet er ikke gyldig","error.va.sf-cc-num.01":"Ugyldig kortnummer","error.va.sf-cc-num.03":"Det angitte kortet st\xf8ttes ikke","error.va.sf-cc-dat.01":"Kortet er for gammelt","error.va.sf-cc-dat.02":"Datoen er for langt inn i fremtiden","error.va.sf-cc-dat.03":"Kortet ditt utl\xf8per f\xf8r betalingsdatoen","error.va.sf-ach-num.01":"Ugyldig kontonummer","error.va.sf-ach-loc.01":"Ugyldig ABA-dirigeringsnummer","error.va.sf-kcp-pwd.01":"Ugyldig passord","error.giftcard.no-balance":"Dette gavekortet har en saldo p\xe5 null","error.giftcard.card-error":"Vi har ikke noe gavekort med dette nummeret i registrene v\xe5re","error.giftcard.currency-error":"Gavekort er kun gyldige i den valutaen de ble utstedt i","amazonpay.signout":"Logg ut av Amazon","amazonpay.changePaymentDetails":"Endre betalingsdetaljer","partialPayment.warning":"Velg en annen betalingsmetode for \xe5 betale det gjenv\xe6rende","partialPayment.remainingBalance":"Gjenv\xe6rende saldo vil v\xe6re %{amount}","bankTransfer.beneficiary":"Mottaker","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referanse","bankTransfer.introduction":"Fortsett for \xe5 opprette en ny betaling via bankoverf\xf8ring. Du kan bruke detaljene i det f\xf8lgende skjermbildet for \xe5 fullf\xf8re betalingen.","bankTransfer.instructions":"Takk for kj\xf8pet. Vennligst benytt den f\xf8lgende informasjonen til \xe5 fullf\xf8re betalingen.","bacs.accountHolderName":"Kontoholders navn","bacs.accountHolderName.invalid":"Ugyldig kontoholdernavn","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ugyldig bankkontonummer","bacs.bankLocationId":"Sorteringskode","bacs.bankLocationId.invalid":"Ugyldig sorteringskode","bacs.consent.amount":"Jeg samtykker til at bel\xf8pet ovenfor blir trukket fra bankkontoen min.","bacs.consent.account":"Jeg bekrefter at kontoen st\xe5r i mitt navn, og at jeg er den eneste signataren som kreves for \xe5 autorisere direktebelastningen p\xe5 denne kontoen.",edit:"Endre","bacs.confirm":"Bekreft og betal","bacs.result.introduction":"Last ned instruksjoner for direktebelastning (DDI/ mandat)","download.pdf":"Last ned PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret kortnummer","creditCard.encryptedCardNumber.aria.label":"Kortnummerfelt","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe for sikret kortutl\xf8psdato","creditCard.encryptedExpiryDate.aria.label":"Felt for utl\xf8psdato","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe for sikret kortutl\xf8psm\xe5ned","creditCard.encryptedExpiryMonth.aria.label":"Felt for utl\xf8psm\xe5ned","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe for sikret kortutl\xf8ps\xe5r","creditCard.encryptedExpiryYear.aria.label":"Felt for utl\xf8ps\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret kortsikkerhetskode","creditCard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe for sikret gavekortnummer","giftcard.encryptedCardNumber.aria.label":"Felt for gavekortnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe for sikret gavekort-sikkerhetskode","giftcard.encryptedSecurityCode.aria.label":"Felt for sikkerhetskode for gavekort",giftcardTransactionLimit:"Maksimalt %{amount} per transaksjon er tillatt p\xe5 dette gavekortet","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe for sikret bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"Bankkontofelt","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe for sikret bankdirigeringsnummer","ach.encryptedBankLocationId.aria.label":"Felt for bankdirigeringsnummer","twint.saved":"lagret"}}),Ek=Object.freeze({__proto__:null,default:{payButton:"Zap\u0142a\u0107","payButton.redirecting":"Przekierowywanie...",storeDetails:"Zapisz na potrzeby nast\u0119pnej p\u0142atno\u015bci","creditCard.holderName":"Imi\u0119 i nazwisko na karcie","creditCard.holderName.placeholder":"J. Kowalski","creditCard.holderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza karty","creditCard.numberField.title":"Numer karty ","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data wa\u017cno\u015bci","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Miesi\u0105c","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapami\u0119taj na przysz\u0142o\u015b\u0107","creditCard.cvcField.placeholder.4digits":"4 cyfry","creditCard.cvcField.placeholder.3digits":"3 cyfry","creditCard.taxNumber.placeholder":"RRMMDD / 0123456789",installments:"Liczba rat",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} miesi\u0119cy","installments.oneTime":"P\u0142atno\u015b\u0107 jednorazowa","installments.installments":"P\u0142atno\u015b\u0107 ratalna","installments.revolving":"P\u0142atno\u015b\u0107 odnawialna","sepaDirectDebit.ibanField.invalid":"Nieprawid\u0142owy numer rachunku","sepaDirectDebit.nameField.placeholder":"J. Kowalski","sepa.ownerName":"Imi\u0119 i nazwisko posiadacza karty","sepa.ibanNumber":"Numer rachunku (IBAN)","error.title":"B\u0142\u0105d","error.subtitle.redirect":"Przekierowanie nie powiod\u0142o si\u0119","error.subtitle.payment":"P\u0142atno\u015b\u0107 nie powiod\u0142a si\u0119","error.subtitle.refused":"P\u0142atno\u015b\u0107 zosta\u0142a odrzucona","error.message.unknown":"Wyst\u0105pi\u0142 nieoczekiwany b\u0142\u0105d","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"Wybierz sw\xf3j bank","creditCard.success":"P\u0142atno\u015b\u0107 zako\u0144czona sukcesem",loading:"\u0141adowanie...",continue:"Kontynuuj",continueTo:"Przejd\u017a do","wechatpay.timetopay":"Masz do zap\u0142acenia %@","wechatpay.scanqrcode":"Zeskanuj kod QR",personalDetails:"Dane osobowe",companyDetails:"Dane firmy","companyDetails.name":"Nazwa firmy","companyDetails.registrationNumber":"Numer w rejestrze",socialSecurityNumber:"Numer dowodu osobistego",firstName:"Imi\u0119",infix:"Prefiks",lastName:"Nazwisko",mobileNumber:"Numer telefonu kom\xf3rkowego","mobileNumber.invalid":"Nieprawid\u0142owy numer telefonu kom\xf3rkowego",city:"Miasto",postalCode:"Kod pocztowy",countryCode:"Kod kraju",telephoneNumber:"Numer telefonu",dateOfBirth:"Data urodzenia",shopperEmail:"Adres e-mail",gender:"P\u0142e\u0107",male:"M\u0119\u017cczyzna",female:"Kobieta",billingAddress:"Adres rozliczeniowy",street:"Ulica",stateOrProvince:"Wojew\xf3dztwo",country:"Kraj",houseNumberOrName:"Numer domu i mieszkania",separateDeliveryAddress:"Podaj osobny adres dostawy",deliveryAddress:"Adres dostawy",zipCode:"Kod pocztowy",apartmentSuite:"Numer domu/mieszkania",provinceOrTerritory:"Region lub terytorium",cityTown:"Miejscowo\u015b\u0107",address:"Adres",state:"Stan","field.title.optional":"(opcjonalnie)","creditCard.cvcField.title.optional":"CVC / CVV (opcjonalnie)","issuerList.wallet.placeholder":"Wybierz sw\xf3j portfel",privacyPolicy:"Polityka prywatno\u015bci.","afterPay.agreement":"Zgadzam si\u0119 z dokumentem %@ AfterPay",paymentConditions:"warunki p\u0142atno\u015bci",openApp:"Otw\xf3rz aplikacj\u0119","voucher.readInstructions":"Przeczytaj instrukcje","voucher.introduction":"Dzi\u0119kujemy za zakup, doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu tego kuponu.","voucher.expirationDate":"Data wa\u017cno\u015bci","voucher.alternativeReference":"Dodatkowy numer referencyjny","dragonpay.voucher.non.bank.selectField.placeholder":"Wybierz dostawc\u0119","dragonpay.voucher.bank.selectField.placeholder":"Wybierz sw\xf3j bank","voucher.paymentReferenceLabel":"Nr referencyjny p\u0142atno\u015bci","voucher.surcharge":"Zawiera %@ op\u0142aty dodatkowej","voucher.introduction.doku":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.shopperName":"Imi\u0119 i nazwisko klienta","voucher.merchantName":"Sprzedaj\u0105cy","voucher.introduction.econtext":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","voucher.telephoneNumber":"Numer telefonu","voucher.shopperReference":"Dane referencyjne kupuj\u0105cych","voucher.collectionInstitutionNumber":"Numer instytucji pobieraj\u0105cej op\u0142at\u0119","voucher.econtext.telephoneNumber.invalid":"Numer telefonu musi mie\u0107 10 lub 11 cyfr","boletobancario.btnLabel":"Wygeneruj p\u0142atno\u015b\u0107 Boleto","boleto.sendCopyToEmail":"Wy\u015blij kopi\u0119 na m\xf3j e-mail","button.copy":"Kopiuj","button.download":"Pobierz","creditCard.storedCard.description.ariaLabel":"Zapisana karta ko\u0144czy si\u0119 na % @","voucher.entity":"Pozycja",donateButton:"Przeka\u017c darowizn\u0119",notNowButton:"Nie teraz",thanksForYourSupport:"Dzi\u0119kujemy za wsparcie!",preauthorizeWith:"Autoryzuj wst\u0119pnie za pomoc\u0105:",confirmPreauthorization:"Potwierd\u017a autoryzacj\u0119 wst\u0119pn\u0105",confirmPurchase:"Potwierd\u017a zakup",applyGiftcard:"Wykorzystaj",giftcardBalance:"Saldo karty podarunkowej",deductedBalance:"Saldo potr\u0105cone","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Pierwsze 2 cyfry has\u0142a karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Nieprawid\u0142owe has\u0142o","creditCard.taxNumber.label":"Data urodzenia posiadacza karty (RRMMDD) lub firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.labelAlt":"Firmowy numer rejestracyjny (10 cyfr)","creditCard.taxNumber.invalid":"Nieprawid\u0142owa data urodzenia posiadacza karty lub nieprawid\u0142owy firmowy numer rejestracyjny","storedPaymentMethod.disable.button":"Usu\u0144","storedPaymentMethod.disable.confirmation":"Usu\u0144 zapisan\u0105 metod\u0119 p\u0142atno\u015bci","storedPaymentMethod.disable.confirmButton":"Tak, usu\u0144","storedPaymentMethod.disable.cancelButton":"Anuluj","ach.bankAccount":"Rachunek bankowy","ach.accountHolderNameField.title":"Imi\u0119 i nazwisko posiadacza rachunku","ach.accountHolderNameField.placeholder":"J. Kowalski","ach.accountHolderNameField.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","ach.accountNumberField.title":"Numer rachunku","ach.accountNumberField.invalid":"Nieprawid\u0142owy numer rachunku","ach.accountLocationField.title":"Kod bankowy ABA Routing Number","ach.accountLocationField.invalid":"Nieprawid\u0142owy kod bankowy ABA Routing Number","select.state":"Wybierz stan","select.stateOrProvince":"Wybierz stan/wojew\xf3dztwo","select.provinceOrTerritory":"Wybierz region/terytorium","select.country":"Wybierz kraj","select.noOptionsFound":"Nie znaleziono opcji","select.filter.placeholder":"Szukaj...","telephoneNumber.invalid":"Nieprawid\u0142owy numer telefonu",qrCodeOrApp:"lub","paypal.processingPayment":"Przetwarzanie p\u0142atno\u015bci...",generateQRCode:"Wygeneruj kod QR","await.waitForConfirmation":"Oczekiwanie na potwierdzenie","mbway.confirmPayment":"Potwierd\u017a p\u0142atno\u015b\u0107 w aplikacji MB WAY","shopperEmail.invalid":"Niepoprawny adres email","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Musisz mie\u0107 co najmniej 18 lat","blik.confirmPayment":"Otw\xf3rz aplikacj\u0119 bankow\u0105, aby potwierdzi\u0107 p\u0142atno\u015b\u0107.","blik.invalid":"Wpisz 6 cyfr","blik.code":"6-cyfrowy kod","blik.help":"Uzyskaj kod ze swojej aplikacji bankowej.","swish.pendingMessage":"Po zeskanowaniu transakcja mo\u017ce mie\u0107 status \u201eOczekuj\u0105ca\u201d do 10 minut. Pr\xf3ba ponownego dokonania p\u0142atno\u015bci w tym czasie mo\u017ce spowodowa\u0107 wielokrotne naliczenie op\u0142aty.","error.va.gen.01":"Niekompletne dane w polu","error.va.gen.02":"Dane w polu s\u0105 nieprawid\u0142owe","error.va.sf-cc-num.01":"Nieprawid\u0142owy numer karty","error.va.sf-cc-num.03":"Wprowadzono nieobs\u0142ugiwan\u0105 kart\u0119","error.va.sf-cc-dat.01":"Termin wa\u017cno\u015bci karty min\u0105\u0142","error.va.sf-cc-dat.02":"Data w zbyt odleg\u0142ej przysz\u0142o\u015bci","error.va.sf-cc-dat.03":"Twoja karta traci wa\u017cno\u015b\u0107 przed dat\u0105 p\u0142atno\u015bci","error.va.sf-ach-num.01":"Nieprawid\u0142owy numer rachunku","error.va.sf-ach-loc.01":"Nieprawid\u0142owy kod bankowy ABA Routing Number","error.va.sf-kcp-pwd.01":"Nieprawid\u0142owe has\u0142o","error.giftcard.no-balance":"Saldo karty podarunkowej jest puste","error.giftcard.card-error":"W naszych rejestrach nie ma karty podarunkowej o tym numerze","error.giftcard.currency-error":"Karty podarunkowe s\u0105 wa\u017cne tylko w walucie, w kt\xf3rej zosta\u0142y wydane","amazonpay.signout":"Wyloguj si\u0119 z Amazon","amazonpay.changePaymentDetails":"Zmie\u0144 szczeg\xf3\u0142y p\u0142atno\u015bci","partialPayment.warning":"Wybierz inn\u0105 metod\u0119 p\u0142atno\u015bci, aby zap\u0142aci\u0107 pozosta\u0142\u0105 kwot\u0119","partialPayment.remainingBalance":"Pozosta\u0142e saldo wynosi %{kwota}","bankTransfer.beneficiary":"Beneficjent","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Ref. sprze.","bankTransfer.introduction":"Kontynuuj tworzenie nowej p\u0142atno\u015bci przelewem bankowym. Mo\u017cesz u\u017cy\u0107 szczeg\xf3\u0142\xf3w na nast\u0119pnym ekranie, aby sfinalizowa\u0107 t\u0119 p\u0142atno\u015b\u0107.","bankTransfer.instructions":"Dzi\u0119kujemy za zakup. Doko\u0144cz p\u0142atno\u015b\u0107 przy u\u017cyciu poni\u017cszych informacji.","bacs.accountHolderName":"Imi\u0119 i nazwisko posiadacza rachunku","bacs.accountHolderName.invalid":"Nieprawid\u0142owe imi\u0119 i nazwisko posiadacza rachunku","bacs.accountNumber":"Numer rachunku","bacs.accountNumber.invalid":"Nieprawid\u0142owy numer rachunku","bacs.bankLocationId":"Numer rozliczeniowy SORT","bacs.bankLocationId.invalid":"Nieprawid\u0142owy numer rozliczeniowy SORT","bacs.consent.amount":"Wyra\u017cam zgod\u0119 na pobranie powy\u017cszej kwoty z mojego rachunku bankowego.","bacs.consent.account":"Potwierdzam, \u017ce konto jest zarejestrowane na moje nazwisko i jestem jedynym sygnatariuszem wymaganym do autoryzacji polecenia zap\u0142aty na tym koncie.",edit:"Edytuj","bacs.confirm":"Potwierd\u017a i zap\u0142a\u0107","bacs.result.introduction":"Pobierz dyspozycj\u0119 polecenia zap\u0142aty (DDI/upowa\u017cnienie)","download.pdf":"Pobierz PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty","creditCard.encryptedCardNumber.aria.label":"Pole numeru karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Element Iframe dla daty wa\u017cno\u015bci zabezpieczonej karty","creditCard.encryptedExpiryDate.aria.label":"Pole daty wa\u017cno\u015bci","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Element Iframe dla miesi\u0105ca wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole miesi\u0105ca wyga\u015bni\u0119cia","creditCard.encryptedExpiryYear.aria.iframeTitle":"Element Iframe dla roku wyga\u015bni\u0119cia zabezpieczonej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roku wyga\u015bni\u0119cia","creditCard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty","creditCard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa","giftcard.encryptedCardNumber.aria.iframeTitle":"Element Iframe dla numeru zabezpieczonej karty podarunkowej","giftcard.encryptedCardNumber.aria.label":"Pole numeru karty podarunkowej","giftcard.encryptedSecurityCode.aria.iframeTitle":"Element Iframe dla kodu bezpiecze\u0144stwa zabezpieczonej karty podarunkowej","giftcard.encryptedSecurityCode.aria.label":"Pole kodu bezpiecze\u0144stwa karty podarunkowej",giftcardTransactionLimit:"Maks. dozwolona kwota (%{amount}) na transakcj\u0119 t\u0105 kart\u0105 upominkow\u0105","ach.encryptedBankAccountNumber.aria.iframeTitle":"Element Iframe dla zabezpieczonego numeru rachunku bankowego","ach.encryptedBankAccountNumber.aria.label":"Pole rachunku bankowego","ach.encryptedBankLocationId.aria.iframeTitle":"Element Iframe dla zabezpieczonego kodu bankowego (Bank Routing Number)","ach.encryptedBankLocationId.aria.label":"Pole kodu bankowego (Bank Routing Number)","twint.saved":"zapisano"}}),Rk=Object.freeze({__proto__:null,default:{payButton:"Pagar","payButton.redirecting":"Redirecionando...",storeDetails:"Salvar para meu pr\xf3ximo pagamento","creditCard.holderName":"Nome no cart\xe3o","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Nome do titular do cart\xe3o inv\xe1lido","creditCard.numberField.title":"N\xfamero do cart\xe3o","creditCard.expiryDateField.title":"Data de validade","creditCard.expiryDateField.placeholder":"MM/AA","creditCard.expiryDateField.month":"M\xeas","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"Ano","creditCard.cvcField.title":"CVC/CVV","creditCard.storeDetailsButton":"Lembrar para a pr\xf3xima vez","creditCard.cvcField.placeholder.4digits":"4 d\xedgitos","creditCard.cvcField.placeholder.3digits":"3 d\xedgitos","creditCard.taxNumber.placeholder":"AAAMMDD / 0123456789",installments:"Op\xe7\xf5es de Parcelamento",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} meses","installments.oneTime":"Pagamento \xe0 vista","installments.installments":"Pagamento parcelado","installments.revolving":"Pagamento rotativo","sepaDirectDebit.ibanField.invalid":"N\xfamero de conta inv\xe1lido","sepaDirectDebit.nameField.placeholder":"J. Silva","sepa.ownerName":"Nome do titular\xa0da conta banc\xe1ria","sepa.ibanNumber":"N\xfamero de conta (NIB)","error.title":"Erro","error.subtitle.redirect":"Falha no redirecionamento","error.subtitle.payment":"Falha no pagamento","error.subtitle.refused":"Pagamento recusado","error.message.unknown":"Ocorreu um erro desconhecido","idealIssuer.selectField.title":"Banco","idealIssuer.selectField.placeholder":"Selecione seu banco","creditCard.success":"Pagamento bem-sucedido",loading:"Carregando...",continue:"Continuar",continueTo:"Continuar para","wechatpay.timetopay":"Voc\xea tem %@ para pagar","wechatpay.scanqrcode":"Escanear c\xf3digo QR",personalDetails:"Informa\xe7\xf5es pessoais",companyDetails:"Dados da empresa","companyDetails.name":"Nome da empresa","companyDetails.registrationNumber":"N\xfamero de registro",socialSecurityNumber:"CPF",firstName:"Nome",infix:"Prefixo",lastName:"Sobrenome",mobileNumber:"Celular","mobileNumber.invalid":"N\xfamero de celular inv\xe1lido",city:"Cidade",postalCode:"CEP",countryCode:"C\xf3digo do pa\xeds",telephoneNumber:"N\xfamero de telefone",dateOfBirth:"Data de nascimento",shopperEmail:"Endere\xe7o de e-mail",gender:"G\xeanero",male:"Masculino",female:"Feminino",billingAddress:"Endere\xe7o de cobran\xe7a",street:"Rua",stateOrProvince:"Estado ou prov\xedncia",country:"Pa\xeds",houseNumberOrName:"N\xfamero da casa",separateDeliveryAddress:"Especificar um endere\xe7o de entrega separado",deliveryAddress:"Endere\xe7o de entrega",zipCode:"C\xf3digo postal",apartmentSuite:"Apartamento/Conjunto",provinceOrTerritory:"Prov\xedncia ou territ\xf3rio",cityTown:"Cidade",address:"Endere\xe7o",state:"Estado","field.title.optional":"(opcional)","creditCard.cvcField.title.optional":"CVC / CVV (opcional)","issuerList.wallet.placeholder":"Selecione uma carteira",privacyPolicy:"Pol\xedtica de Privacidade","afterPay.agreement":"Eu concordo com as %@ do AfterPay",paymentConditions:"condi\xe7\xf5es de pagamento",openApp:"Abrir o aplicativo","voucher.readInstructions":"Leia as instru\xe7\xf5es","voucher.introduction":"Obrigado pela sua compra, use o cupom a seguir para concluir o seu pagamento.","voucher.expirationDate":"Data de validade","voucher.alternativeReference":"Refer\xeancia alternativa","dragonpay.voucher.non.bank.selectField.placeholder":"Selecione o seu fornecedor","dragonpay.voucher.bank.selectField.placeholder":"Selecione seu banco","voucher.paymentReferenceLabel":"Refer\xeancia de pagamento","voucher.surcharge":"Inclui %@ de sobretaxa","voucher.introduction.doku":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.shopperName":"Nome do consumidor","voucher.merchantName":"Comerciante online","voucher.introduction.econtext":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","voucher.telephoneNumber":"N\xfamero de telefone","voucher.shopperReference":"Refer\xeancia do consumidor","voucher.collectionInstitutionNumber":"N\xfamero da institui\xe7\xe3o de cobran\xe7a","voucher.econtext.telephoneNumber.invalid":"O n\xfamero de telefone deve ter 10 ou 11 d\xedgitos","boletobancario.btnLabel":"Gerar Boleto","boleto.sendCopyToEmail":"Enviar uma c\xf3pia por e-mail","button.copy":"Copiar","button.download":"Baixar","creditCard.storedCard.description.ariaLabel":"O cart\xe3o armazenado termina em %@","voucher.entity":"Entidade",donateButton:"Doar",notNowButton:"Agora n\xe3o",thanksForYourSupport:"Obrigado pelo apoio!",preauthorizeWith:"Pr\xe9-autorizar com",confirmPreauthorization:"Confirmar pr\xe9-autoriza\xe7\xe3o",confirmPurchase:"Confirmar compra",applyGiftcard:"Resgatar",giftcardBalance:"Saldo do vale-presente",deductedBalance:"Saldo debitado","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"Primeiros dois d\xedgitos da senha do cart\xe3o","creditCard.encryptedPassword.invalid":"Senha inv\xe1lida","creditCard.taxNumber.label":"Data de nascimento do titular do cart\xe3o (AAMMDD) ou n\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.labelAlt":"N\xfamero de registro corporativo (10 d\xedgitos)","creditCard.taxNumber.invalid":"Data de nascimento do titular do cart\xe3o ou n\xfamero de registro corporativo inv\xe1lidos","storedPaymentMethod.disable.button":"Remover","storedPaymentMethod.disable.confirmation":"Remover m\xe9todo de pagamento armazenado","storedPaymentMethod.disable.confirmButton":"Sim, remover","storedPaymentMethod.disable.cancelButton":"Cancelar","ach.bankAccount":"Conta banc\xe1ria","ach.accountHolderNameField.title":"Nome do titular da conta","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Nome do titular da conta inv\xe1lido","ach.accountNumberField.title":"N\xfamero da conta","ach.accountNumberField.invalid":"N\xfamero de conta inv\xe1lido","ach.accountLocationField.title":"N\xfamero de roteamento ABA","ach.accountLocationField.invalid":"N\xfamero de roteamento ABA inv\xe1lido","select.state":"Selecionar estado","select.stateOrProvince":"Selecione estado ou prov\xedncia","select.provinceOrTerritory":"Selecionar prov\xedncia ou territ\xf3rio","select.country":"Selecione o pa\xeds","select.noOptionsFound":"Nenhuma op\xe7\xe3o encontrada","select.filter.placeholder":"Pesquisar...","telephoneNumber.invalid":"N\xfamero de telefone inv\xe1lido",qrCodeOrApp:"ou","paypal.processingPayment":"Processando pagamento...",generateQRCode:"Gerar c\xf3digo QR","await.waitForConfirmation":"Aguardando confirma\xe7\xe3o","mbway.confirmPayment":"Confirme seu pagamento no aplicativo MB WAY","shopperEmail.invalid":"Endere\xe7o de e-mail inv\xe1lido","dateOfBirth.format":"DD/MM/AAAA","dateOfBirth.invalid":"Voc\xea deve ter pelo menos 18 anos","blik.confirmPayment":"Abra o aplicativo do seu banco para confirmar o pagamento.","blik.invalid":"Digite 6 n\xfameros","blik.code":"C\xf3digo de 6 d\xedgitos","blik.help":"Obtenha o c\xf3digo no aplicativo do seu banco.","swish.pendingMessage":"Depois de escanear o QR, o status pode ficar pendente por at\xe9 10 minutos. N\xe3o tente refazer o pagamento antes desse per\xedodo para evitar cobran\xe7a duplicada.","error.va.gen.01":"Campo incompleto","error.va.gen.02":"Campo inv\xe1lido","error.va.sf-cc-num.01":"N\xfamero de cart\xe3o inv\xe1lido","error.va.sf-cc-num.03":"O cart\xe3o inserido n\xe3o \xe9 aceito","error.va.sf-cc-dat.01":"Cart\xe3o muito antigo","error.va.sf-cc-dat.02":"Data muito distante","error.va.sf-cc-dat.03":"Seu cart\xe3o expira antes da data do pagamento","error.va.sf-ach-num.01":"N\xfamero de conta inv\xe1lido","error.va.sf-ach-loc.01":"N\xfamero de roteamento ABA inv\xe1lido","error.va.sf-kcp-pwd.01":"Senha inv\xe1lida","error.giftcard.no-balance":"Este vale-presente tem saldo zero","error.giftcard.card-error":"N\xe3o existe um vale-presente com esse n\xfamero em nossos registros","error.giftcard.currency-error":"Os vales-presente s\xe3o v\xe1lidos somente na moeda em que foram emitidos","amazonpay.signout":"Sair do Amazon","amazonpay.changePaymentDetails":"Alterar dados de pagamento","partialPayment.warning":"Selecione outro m\xe9todo de pagamento para pagar o restante","partialPayment.remainingBalance":"O saldo restante ser\xe1 %{amount}","bankTransfer.beneficiary":"Benefici\xe1rio","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Refer\xeancia","bankTransfer.introduction":"Continue criando o novo pagamento por transfer\xeancia banc\xe1ria. Use as informa\xe7\xf5es na tela a seguir para conclu\xed-lo.","bankTransfer.instructions":"Obrigado pela sua compra, use a informa\xe7\xe3o a seguir para concluir o seu pagamento.","bacs.accountHolderName":"Nome do titular da conta banc\xe1ria","bacs.accountHolderName.invalid":"Nome do titular da conta banc\xe1ria inv\xe1lido","bacs.accountNumber":"N\xfamero da conta banc\xe1ria","bacs.accountNumber.invalid":"N\xfamero da conta banc\xe1ria inv\xe1lido","bacs.bankLocationId":"C\xf3digo de classifica\xe7\xe3o","bacs.bankLocationId.invalid":"C\xf3digo de classifica\xe7\xe3o inv\xe1lido","bacs.consent.amount":"Concordo que o valor acima seja deduzido da minha conta banc\xe1ria.","bacs.consent.account":"Confirmo que a conta est\xe1 em meu nome e que sou o \xfanico signat\xe1rio que deve autorizar o d\xe9bito direto nessa conta.",edit:"Editar","bacs.confirm":"Confirmar e pagar","bacs.result.introduction":"Baixar instru\xe7\xe3o de d\xe9bito direto (DDI)","download.pdf":"Baixar PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o seguro","creditCard.encryptedCardNumber.aria.label":"Campo de n\xfamero de cart\xe3o","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe para data de validade do cart\xe3o seguro","creditCard.encryptedExpiryDate.aria.label":"Campo de data de validade","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe para m\xeas de validade do cart\xe3o seguro","creditCard.encryptedExpiryMonth.aria.label":"Campo de m\xeas de validade","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe para ano de validade do cart\xe3o seguro","creditCard.encryptedExpiryYear.aria.label":"Campo de ano de validade","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o seguro","creditCard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe para n\xfamero de cart\xe3o-presente seguro","giftcard.encryptedCardNumber.aria.label":"Campo de n\xfamero do cart\xe3o-presente","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe para c\xf3digo de seguran\xe7a do cart\xe3o-presente seguro","giftcard.encryptedSecurityCode.aria.label":"Campo de c\xf3digo de seguran\xe7a do cart\xe3o-presente",giftcardTransactionLimit:"M\xe1ximo de %{amount} permitido por transa\xe7\xe3o neste cart\xe3o-presente","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe para n\xfamero de conta banc\xe1ria segura","ach.encryptedBankAccountNumber.aria.label":"Campo de conta banc\xe1ria","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe para n\xfamero de roteamento banc\xe1rio seguro","ach.encryptedBankLocationId.aria.label":"Campo de n\xfamero de roteamento banc\xe1rio","pix.instructions":"Abra o app com sua chave PIX cadastrada, escolha Pagar com Pix e escaneie o QR Code ou copie e cole o c\xf3digo","twint.saved":"salvo"}}),Lk=Object.freeze({__proto__:null,default:{payButton:"Pl\u0103ti\u021bi","payButton.redirecting":"Se redirec\u021bioneaz\u0103...",storeDetails:"Salveaz\u0103 pentru urm\u0103toarea mea plat\u0103","creditCard.holderName":"Numele de pe card","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"Numele posesorului de card este incorect","creditCard.numberField.title":"Num\u0103r card","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Data expir\u0103rii","creditCard.expiryDateField.placeholder":"LL/AA","creditCard.expiryDateField.month":"Lun\u0103","creditCard.expiryDateField.month.placeholder":"LL","creditCard.expiryDateField.year.placeholder":"AA","creditCard.expiryDateField.year":"An","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Re\u021bine pentru data viitoare","creditCard.cvcField.placeholder.4digits":"4 cifre","creditCard.cvcField.placeholder.3digits":"3 cifre","creditCard.taxNumber.placeholder":"AALLZZ / 0123456789",installments:"Num\u0103r de rate",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} luni","installments.oneTime":"Plat\u0103 unic\u0103","installments.installments":"Plat\u0103 \xeen rate","installments.revolving":"Plat\u0103 recurent\u0103","sepaDirectDebit.ibanField.invalid":"Num\u0103rul de cont este incorect","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"Nume posesor","sepa.ibanNumber":"Num\u0103r cont (IBAN)","error.title":"Eroare","error.subtitle.redirect":"Redirec\u021bionare e\u0219uat\u0103","error.subtitle.payment":"Plat\u0103 e\u0219uat\u0103","error.subtitle.refused":"Plat\u0103 refuzat\u0103","error.message.unknown":"S-a produs o eroare necunoscut\u0103","idealIssuer.selectField.title":"Banc\u0103","idealIssuer.selectField.placeholder":"Selecta\u021bi-v\u0103 banca","creditCard.success":"Plat\u0103 reu\u0219it\u0103",loading:"Se \xeencarc\u0103...",continue:"Continuare",continueTo:"Continua\u021bi c\u0103tre","wechatpay.timetopay":"Trebuie s\u0103 achita\u021bi %@","wechatpay.scanqrcode":"Scana\u021bi codul QR",personalDetails:"Informa\u021bii personale",companyDetails:"Informa\u021bii societate","companyDetails.name":"Denumirea societ\u0103\u021bii","companyDetails.registrationNumber":"Num\u0103r de \xeenregistrare",socialSecurityNumber:"Cod numeric personal",firstName:"Prenume",infix:"Titulatur\u0103",lastName:"Nume de familie",mobileNumber:"Num\u0103r de mobil","mobileNumber.invalid":"Num\u0103r de telefon mobil incorect",city:"Ora\u0219",postalCode:"Cod po\u0219tal",countryCode:"Codul \u021b\u0103rii",telephoneNumber:"Num\u0103r de telefon",dateOfBirth:"Data na\u0219terii",shopperEmail:"Adres\u0103 de e-mail",gender:"Gen",male:"B\u0103rbat",female:"Femeie",billingAddress:"Adresa de facturare",street:"Strada",stateOrProvince:"Jude\u021b sau provincie",country:"\u021aar\u0103",houseNumberOrName:"Num\u0103r",separateDeliveryAddress:"Specifica\u021bi o adres\u0103 de livrare separat\u0103",deliveryAddress:"Adres\u0103 de livrare",zipCode:"Cod po\u0219tal",apartmentSuite:"Apartament",provinceOrTerritory:"Provincie sau teritoriu",cityTown:"Ora\u0219/localitate",address:"Adres\u0103",state:"Stat","field.title.optional":"(op\u021bional)","creditCard.cvcField.title.optional":"CVC/CVV (op\u021bional)","issuerList.wallet.placeholder":"Selecta\u021bi-v\u0103 portofelul",privacyPolicy:"Politica de confiden\u021bialitate","afterPay.agreement":"Sunt de acord cu %@ apar\u021bin\xe2nd AfterPay",paymentConditions:"condi\u021bii de plat\u0103",openApp:"Deschide\u021bi aplica\u021bia","voucher.readInstructions":"Citi\u021bi instruc\u021biunile","voucher.introduction":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103torul cupon pentru a v\u0103 finaliza plata.","voucher.expirationDate":"Data de expirare","voucher.alternativeReference":"Referin\u021b\u0103 alternativ\u0103","dragonpay.voucher.non.bank.selectField.placeholder":"Selecta\u021bi furnizorul dvs.","dragonpay.voucher.bank.selectField.placeholder":"Selecta\u021bi banca dvs.","voucher.paymentReferenceLabel":"Referin\u021ba pl\u0103\u021bii","voucher.surcharge":"Include suprataxa de %@","voucher.introduction.doku":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.shopperName":"Nume cump\u0103r\u0103tor","voucher.merchantName":"Comerciant","voucher.introduction.econtext":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","voucher.telephoneNumber":"Num\u0103r de telefon","voucher.shopperReference":"Referin\u021b\u0103 cump\u0103r\u0103tor","voucher.collectionInstitutionNumber":"Num\u0103r institu\u021bie de colectare","voucher.econtext.telephoneNumber.invalid":"Num\u0103rul de telefon trebuie s\u0103 aib\u0103 10 sau 11 cifre","boletobancario.btnLabel":"Generare Boleto","boleto.sendCopyToEmail":"Trimite o copie la adresa mea de e-mail","button.copy":"Copiere","button.download":"Desc\u0103rcare","creditCard.storedCard.description.ariaLabel":"Cardul memorat se termin\u0103 \xeen %@","voucher.entity":"Entitate",donateButton:"Dona\u021bi",notNowButton:"Nu acum",thanksForYourSupport:"V\u0103 mul\u021bumim pentru sprijin!",preauthorizeWith:"Preautorizare cu",confirmPreauthorization:"Confirma\u021bi preautorizarea",confirmPurchase:"Confirma\u021bi achizi\u021bia",applyGiftcard:"Valorificare",giftcardBalance:"Soldul de pe cardul cadou",deductedBalance:"Sold sc\u0103zut","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Primele 2 cifre ale parolei aferente cardului","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Parol\u0103 incorect\u0103","creditCard.taxNumber.label":"Data de na\u0219tere a posesorului de card (AALLZZ) sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre).","creditCard.taxNumber.labelAlt":"Num\u0103rul de \xeenregistrare al societ\u0103\u021bii (10 cifre)","creditCard.taxNumber.invalid":"Data de na\u0219tere a posesorului de card sau num\u0103rul de \xeenregistrare al societ\u0103\u021bii este incorect","storedPaymentMethod.disable.button":"\u0218tergere","storedPaymentMethod.disable.confirmation":"\u0218terge\u021bi metoda de plat\u0103 memorat\u0103","storedPaymentMethod.disable.confirmButton":"Da, \u0219terge","storedPaymentMethod.disable.cancelButton":"Anulare","ach.bankAccount":"Cont bancar","ach.accountHolderNameField.title":"Numele titularului de cont","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"Numele titularului de cont este incorect","ach.accountNumberField.title":"Num\u0103r de cont","ach.accountNumberField.invalid":"Num\u0103rul de cont este incorect","ach.accountLocationField.title":"Num\u0103r de direc\u021bionare ABA","ach.accountLocationField.invalid":"Num\u0103r de direc\u021bionare ABA incorect","select.state":"Selecta\u021bi statul","select.stateOrProvince":"Selecta\u021bi jude\u021bul sau provincia","select.provinceOrTerritory":"Selecta\u021bi provincia sau teritoriul","select.country":"Selecta\u021bi \u021bara","select.noOptionsFound":"Nu s-a g\u0103sit nicio op\u021biune","select.filter.placeholder":"C\u0103utare...","telephoneNumber.invalid":"Num\u0103r de telefon incorect",qrCodeOrApp:"sau","paypal.processingPayment":"Se prelucreaz\u0103 plata...",generateQRCode:"Genera\u021bi codul QR","await.waitForConfirmation":"Se a\u0219teapt\u0103 confirmarea","mbway.confirmPayment":"Confirma\u021bi plata \xeen aplica\u021bia MB WAY","shopperEmail.invalid":"Adres\u0103 de e-mail incorect\u0103","dateOfBirth.format":"ZZ/LL/AAAA","dateOfBirth.invalid":"Trebuie s\u0103 ave\u021bi minimum 18 ani","blik.confirmPayment":"Deschide\u021bi aplica\u021bia dvs. de banking pentru a confirma plata.","blik.invalid":"Introduce\u021bi 6 cifre","blik.code":"Cod din 6 cifre","blik.help":"Ob\u021bine\u021bi codul din aplica\u021bia dvs. de banking.","swish.pendingMessage":"Dup\u0103 ce scana\u021bi, starea poate fi \u201e\xeen a\u0219teptare\u201d timp de maximum 10 minute. \xcencerc\u0103rile de a pl\u0103ti din nou \xeen acest r\u0103stimp pot genera prelev\u0103ri multiple de fonduri.","error.va.gen.01":"C\xe2mp incomplet","error.va.gen.02":"C\xe2mp incorect","error.va.sf-cc-num.01":"Num\u0103r de card incorect","error.va.sf-cc-num.03":"A fost introdus un card neacceptat","error.va.sf-cc-dat.01":"Cardul este prea vechi","error.va.sf-cc-dat.02":"Data este prea departe \xeen viitor","error.va.sf-cc-dat.03":"Cardul dvs. expir\u0103 \xeenainte de data de check-out","error.va.sf-ach-num.01":"Num\u0103rul de cont este incorect","error.va.sf-ach-loc.01":"Num\u0103r de direc\u021bionare ABA incorect","error.va.sf-kcp-pwd.01":"Parol\u0103 incorect\u0103","error.giftcard.no-balance":"Acest card cadou are soldul zero","error.giftcard.card-error":"\xcen eviden\u021bele noastre nu figureaz\u0103 niciun card cadou cu acest num\u0103r","error.giftcard.currency-error":"Cardurile cadou sunt valabile numai \xeen moneda \xeen care au fost emise","amazonpay.signout":"Deconecta\u021bi-v\u0103 de pe platforma Amazon","amazonpay.changePaymentDetails":"Modifica\u021bi detaliile de plat\u0103","partialPayment.warning":"Pentru a achita suma r\u0103mas\u0103, selecta\u021bi o alt\u0103 metod\u0103 de plat\u0103","partialPayment.remainingBalance":"Soldul r\u0103mas va fi de %{amount}","bankTransfer.beneficiary":"Beneficiar","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referin\u0163\u0103","bankTransfer.introduction":"Continua\u021bi s\u0103 crea\u021bi o nou\u0103 plat\u0103 prin transfer bancar. Pute\u021bi utiliza detaliile din ecranul urm\u0103tor pentru a finaliza aceast\u0103 plat\u0103.","bankTransfer.instructions":"V\u0103 mul\u021bumim pentru cump\u0103r\u0103turi, v\u0103 rug\u0103m s\u0103 utiliza\u021bi urm\u0103toarele informa\u021bii pentru a v\u0103 finaliza plata.","bacs.accountHolderName":"Numele titularului contului bancar","bacs.accountHolderName.invalid":"Numele titularului contului bancar este incorect","bacs.accountNumber":"Num\u0103rul contului bancar","bacs.accountNumber.invalid":"Num\u0103rul contului bancar este incorect","bacs.bankLocationId":"Cod de identificare bancar\u0103","bacs.bankLocationId.invalid":"Cod de identificare bancar\u0103 incorect","bacs.consent.amount":"Sunt de acord ca suma men\u021bionat\u0103 mai sus s\u0103 fie dedus\u0103 din contul meu bancar.","bacs.consent.account":"Confirm c\u0103 sunt titularul acestui cont \u0219i c\u0103 sunt singurul semnatar necesar pentru autorizarea debitului direct pentru acest cont.",edit:"Editare","bacs.confirm":"Confirma\u021bi \u0219i pl\u0103ti\u021bi","bacs.result.introduction":"Desc\u0103rca\u021bi instruc\u021biunile de debitare direct\u0103 (DDI/mandat)","download.pdf":"Desc\u0103rca\u021bi PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului securizat","creditCard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pentru data de expirare a cardului securizat","creditCard.encryptedExpiryDate.aria.label":"C\xe2mp aferent datei de expirare","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pentru luna de expirare a cardului securizat","creditCard.encryptedExpiryMonth.aria.label":"C\xe2mp aferent lunii de expirare","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pentru anul de expirare a cardului securizat","creditCard.encryptedExpiryYear.aria.label":"C\xe2mp aferent anului de expirare","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului securizat","creditCard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pentru num\u0103rul cardului cadou securizat","giftcard.encryptedCardNumber.aria.label":"C\xe2mp aferent num\u0103rului cardului cadou","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pentru codul de securitate al cardului cadou securizat","giftcard.encryptedSecurityCode.aria.label":"C\xe2mp aferent codului de securitate al cardului cadou",giftcardTransactionLimit:"Pentru acest card cadou, suma maxim\u0103 permis\u0103 per tranzac\u021bie este de %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pentru num\u0103rul contului bancar securizat","ach.encryptedBankAccountNumber.aria.label":"C\xe2mp aferent contului bancar","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pentru num\u0103rul securizat de direc\u021bionare bancar\u0103 (routing number)","ach.encryptedBankLocationId.aria.label":"C\xe2mp aferent codului de direc\u021bionare bancar\u0103 (routing number)","twint.saved":"salvat"}}),Vk=Object.freeze({__proto__:null,default:{payButton:"\u0417\u0430\u043f\u043b\u0430\u0442\u0438\u0442\u044c","payButton.redirecting":"\u041f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u0435...",storeDetails:"\u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u0434\u043b\u044f \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u0433\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0430","creditCard.holderName":"\u0418\u043c\u044f \u043d\u0430 \u043a\u0430\u0440\u0442\u0435","creditCard.holderName.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","creditCard.holderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.title":"\u041d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.expiryDateField.placeholder":"\u041c\u041c/\u0413\u0413","creditCard.expiryDateField.month":"\u041c\u0435\u0441\u044f\u0446","creditCard.expiryDateField.month.placeholder":"\u041c\u041c","creditCard.expiryDateField.year.placeholder":"\u0413\u0413","creditCard.expiryDateField.year":"\u0413\u043e\u0434","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u0417\u0430\u043f\u043e\u043c\u043d\u0438\u0442\u044c \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u0440\u0430\u0437","creditCard.cvcField.placeholder.4digits":"4 \u0446\u0438\u0444\u0440\u044b","creditCard.cvcField.placeholder.3digits":"3 \u0446\u0438\u0444\u0440\u044b","creditCard.taxNumber.placeholder":"\u0413\u0413\u041c\u041c\u0414\u0414 / 0123456789",installments:"\u041a\u043e\u043b\u0438\u0447\u0435\u0441\u0442\u0432\u043e \u043f\u043b\u0430\u0442\u0435\u0436\u0435\u0439",installmentOption:"%{times}\xd7 %{partialValue}",installmentOptionMonths:"%{times} \u043c\u0435\u0441.","installments.oneTime":"\u041e\u0434\u043d\u043e\u0440\u0430\u0437\u043e\u0432\u044b\u0439 \u043f\u043b\u0430\u0442\u0435\u0436","installments.installments":"\u0420\u0430\u0441\u0441\u0440\u043e\u0447\u043a\u0430","installments.revolving":"\u041f\u043e\u0432\u0442\u043e\u0440\u044f\u044e\u0449\u0430\u044f\u0441\u044f \u043e\u043f\u043b\u0430\u0442\u0430","sepaDirectDebit.ibanField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","sepaDirectDebit.nameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","sepa.ownerName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430","sepa.ibanNumber":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430 (IBAN)","error.title":"\u041e\u0448\u0438\u0431\u043a\u0430","error.subtitle.redirect":"\u0421\u0431\u043e\u0439 \u043f\u0435\u0440\u0435\u043d\u0430\u043f\u0440\u0430\u0432\u043b\u0435\u043d\u0438\u044f","error.subtitle.payment":"\u0421\u0431\u043e\u0439 \u043e\u043f\u043b\u0430\u0442\u044b","error.subtitle.refused":"\u041e\u043f\u043b\u0430\u0442\u0430 \u043e\u0442\u043a\u043b\u043e\u043d\u0435\u043d\u0430","error.message.unknown":"\u0412\u043e\u0437\u043d\u0438\u043a\u043b\u0430 \u043d\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043d\u0430\u044f \u043e\u0448\u0438\u0431\u043a\u0430","idealIssuer.selectField.title":"\u0411\u0430\u043d\u043a","idealIssuer.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","creditCard.success":"\u041f\u043b\u0430\u0442\u0435\u0436 \u0443\u0441\u043f\u0435\u0448\u043d\u043e \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d",loading:"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430\u2026",continue:"\u041f\u0440\u043e\u0434\u043e\u043b\u0436\u0438\u0442\u044c",continueTo:"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u043a","wechatpay.timetopay":"\u0423 \u0432\u0430\u0441 %@ \u043d\u0430 \u043e\u043f\u043b\u0430\u0442\u0443","wechatpay.scanqrcode":"\u0421\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u0442\u044c QR-\u043a\u043e\u0434",personalDetails:"\u041b\u0438\u0447\u043d\u044b\u0435 \u0434\u0430\u043d\u043d\u044b\u0435",companyDetails:"\u0414\u0430\u043d\u043d\u044b\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.name":"\u041d\u0430\u0437\u0432\u0430\u043d\u0438\u0435 \u043a\u043e\u043c\u043f\u0430\u043d\u0438\u0438","companyDetails.registrationNumber":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440",socialSecurityNumber:"\u041d\u043e\u043c\u0435\u0440 \u0441\u043e\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0433\u043e \u0441\u0442\u0440\u0430\u0445\u043e\u0432\u0430\u043d\u0438\u044f \u0438\u043b\u0438 \u0418\u041d\u041d",firstName:"\u0418\u043c\u044f",infix:"\u041f\u0440\u0438\u0441\u0442\u0430\u0432\u043a\u0430",lastName:"\u0424\u0430\u043c\u0438\u043b\u0438\u044f",mobileNumber:"\u041c\u043e\u0431\u0438\u043b\u044c\u043d\u044b\u0439 \u0442\u0435\u043b\u0435\u0444\u043e\u043d","mobileNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0439 \u043d\u043e\u043c\u0435\u0440 \u043c\u043e\u0431\u0438\u043b\u044c\u043d\u043e\u0433\u043e",city:"\u0413\u043e\u0440\u043e\u0434",postalCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",countryCode:"\u041a\u043e\u0434 \u0441\u0442\u0440\u0430\u043d\u044b",telephoneNumber:"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",dateOfBirth:"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f",shopperEmail:"\u0410\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b",gender:"\u041f\u043e\u043b",male:"\u041c\u0443\u0436\u0447\u0438\u043d\u0430",female:"\u0416\u0435\u043d\u0449\u0438\u043d\u0430",billingAddress:"\u041f\u043b\u0430\u0442\u0435\u0436\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441",street:"\u0423\u043b\u0438\u0446\u0430",stateOrProvince:"\u0420\u0435\u0433\u0438\u043e\u043d",country:"\u0421\u0442\u0440\u0430\u043d\u0430",houseNumberOrName:"\u041d\u043e\u043c\u0435\u0440 \u0434\u043e\u043c\u0430",separateDeliveryAddress:"\u0423\u043a\u0430\u0436\u0438\u0442\u0435 \u043e\u0442\u0434\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",deliveryAddress:"\u0410\u0434\u0440\u0435\u0441 \u0434\u043e\u0441\u0442\u0430\u0432\u043a\u0438",zipCode:"\u041f\u043e\u0447\u0442\u043e\u0432\u044b\u0439 \u0438\u043d\u0434\u0435\u043a\u0441",apartmentSuite:"\u041a\u0432\u0430\u0440\u0442\u0438\u0440\u0430 / \u043f\u043e\u043c\u0435\u0449\u0435\u043d\u0438\u0435",provinceOrTerritory:"\u041f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044f \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044f",cityTown:"\u0413\u043e\u0440\u043e\u0434",address:"\u0410\u0434\u0440\u0435\u0441",state:"\u0428\u0442\u0430\u0442","field.title.optional":"(\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","creditCard.cvcField.title.optional":"CVC / CVV (\u043d\u0435\u043e\u0431\u044f\u0437\u0430\u0442\u0435\u043b\u044c\u043d\u043e)","issuerList.wallet.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043a\u043e\u0448\u0435\u043b\u0435\u043a",privacyPolicy:"\u041f\u043e\u043b\u0438\u0442\u0438\u043a\u0430 \u043a\u043e\u043d\u0444\u0438\u0434\u0435\u043d\u0446\u0438\u0430\u043b\u044c\u043d\u043e\u0441\u0442\u0438","afterPay.agreement":"\u042f \u043f\u0440\u0438\u043d\u0438\u043c\u0430\u044e %@ AfterPay",paymentConditions:"\u0443\u0441\u043b\u043e\u0432\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b",openApp:"\u041e\u0442\u043a\u0440\u044b\u0442\u044c \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435","voucher.readInstructions":"\u041f\u0440\u043e\u0447\u0438\u0442\u0430\u0439\u0442\u0435 \u0438\u043d\u0441\u0442\u0440\u0443\u043a\u0446\u0438\u0438","voucher.introduction":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0439 \u043a\u0443\u043f\u043e\u043d.","voucher.expirationDate":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","voucher.alternativeReference":"\u0414\u0440\u0443\u0433\u043e\u0439 \u043a\u043e\u0434","dragonpay.voucher.non.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0432\u043e\u0435\u0433\u043e \u043e\u043f\u0435\u0440\u0430\u0442\u043e\u0440\u0430","dragonpay.voucher.bank.selectField.placeholder":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0431\u0430\u043d\u043a","voucher.paymentReferenceLabel":"\u041a\u043e\u0434 \u043e\u043f\u043b\u0430\u0442\u044b","voucher.surcharge":"\u0412\u043a\u043b. \u043a\u043e\u043c\u0438\u0441\u0441\u0438\u044e %@","voucher.introduction.doku":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.shopperName":"\u0418\u043c\u044f \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.merchantName":"\u041f\u0440\u043e\u0434\u0430\u0432\u0435\u0446","voucher.introduction.econtext":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","voucher.telephoneNumber":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430","voucher.shopperReference":"\u0418\u0434\u0435\u043d\u0442\u0438\u0444\u0438\u043a\u0430\u0442\u043e\u0440 \u043f\u043e\u043a\u0443\u043f\u0430\u0442\u0435\u043b\u044f","voucher.collectionInstitutionNumber":"\u041d\u043e\u043c\u0435\u0440 \u043f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044f \u0441\u0440\u0435\u0434\u0441\u0442\u0432","voucher.econtext.telephoneNumber.invalid":"\u041d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430 \u0434\u043e\u043b\u0436\u0435\u043d \u0431\u044b\u0442\u044c \u0434\u043b\u0438\u043d\u043e\u0439 10 \u0438\u043b\u0438 11 \u0446\u0438\u0444\u0440","boletobancario.btnLabel":"\u0421\u043e\u0437\u0434\u0430\u0442\u044c Boleto","boleto.sendCopyToEmail":"\u041e\u0442\u043f\u0440\u0430\u0432\u0438\u0442\u044c \u043c\u043d\u0435 \u043a\u043e\u043f\u0438\u044e \u043d\u0430 \u044d\u043b. \u043f\u043e\u0447\u0442\u0443","button.copy":"\u041a\u043e\u043f\u0438\u044f","button.download":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c","creditCard.storedCard.description.ariaLabel":"\u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u0430\u044f \u043a\u0430\u0440\u0442\u0430 \u0437\u0430\u043a\u0430\u043d\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044f \u043d\u0430 %@","voucher.entity":"\u041e\u0431\u044a\u0435\u043a\u0442",donateButton:"\u041f\u043e\u0436\u0435\u0440\u0442\u0432\u043e\u0432\u0430\u0442\u044c",notNowButton:"\u041f\u043e\u0437\u0436\u0435",thanksForYourSupport:"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u0434\u0434\u0435\u0440\u0436\u043a\u0443!",preauthorizeWith:"\u041f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044f \u0432",confirmPreauthorization:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u0440\u0435\u0434\u0430\u0432\u0442\u043e\u0440\u0438\u0437\u0430\u0446\u0438\u044e",confirmPurchase:"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u043f\u043e\u043a\u0443\u043f\u043a\u0443",applyGiftcard:"\u0418\u0441\u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u044c",giftcardBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",deductedBalance:"\u0411\u0430\u043b\u0430\u043d\u0441 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0439","creditCard.pin.title":"PIN-\u043a\u043e\u0434","creditCard.encryptedPassword.label":"\u041f\u0435\u0440\u0432\u044b\u0435 2 \u0446\u0438\u0444\u0440\u044b \u043f\u0430\u0440\u043e\u043b\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedPassword.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","creditCard.taxNumber.label":"\u0414\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b (\u0413\u0413\u041c\u041c\u0414\u0414) \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.labelAlt":"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f (10 \u0446\u0438\u0444\u0440)","creditCard.taxNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u0430\u044f \u0434\u0430\u0442\u0430 \u0440\u043e\u0436\u0434\u0435\u043d\u0438\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b \u0438\u043b\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043e\u043d\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043f\u0440\u0435\u0434\u043f\u0440\u0438\u044f\u0442\u0438\u044f","storedPaymentMethod.disable.button":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.confirmation":"\u0423\u0434\u0430\u043b\u0438\u0442\u044c \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043d\u044b\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b","storedPaymentMethod.disable.confirmButton":"\u0414\u0430, \u0443\u0434\u0430\u043b\u0438\u0442\u044c","storedPaymentMethod.disable.cancelButton":"\u041e\u0442\u043c\u0435\u043d\u0438\u0442\u044c","ach.bankAccount":"\u0411\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u0438\u0439 \u0441\u0447\u0435\u0442","ach.accountHolderNameField.title":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountHolderNameField.placeholder":"\u0418. \u041f\u0435\u0442\u0440\u043e\u0432","ach.accountHolderNameField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u043a\u0430\u0440\u0442\u044b","ach.accountNumberField.title":"\u041d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountNumberField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","ach.accountLocationField.title":"\u041c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","ach.accountLocationField.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","select.state":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442","select.stateOrProvince":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0448\u0442\u0430\u0442 \u0438\u043b\u0438 \u043e\u0431\u043b\u0430\u0441\u0442\u044c","select.provinceOrTerritory":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u043f\u0440\u043e\u0432\u0438\u043d\u0446\u0438\u044e \u0438\u043b\u0438 \u0442\u0435\u0440\u0440\u0438\u0442\u043e\u0440\u0438\u044e","select.country":"\u0412\u044b\u0431\u0435\u0440\u0438\u0442\u0435 \u0441\u0442\u0440\u0430\u043d\u0443","select.noOptionsFound":"\u0412\u0430\u0440\u0438\u0430\u043d\u0442\u043e\u0432 \u043d\u0435 \u043d\u0430\u0439\u0434\u0435\u043d\u043e","select.filter.placeholder":"\u041f\u043e\u0438\u0441\u043a\u2026","telephoneNumber.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0442\u0435\u043b\u0435\u0444\u043e\u043d\u0430",qrCodeOrApp:"\u0438\u043b\u0438","paypal.processingPayment":"\u041f\u043b\u0430\u0442\u0435\u0436 \u043e\u0431\u0440\u0430\u0431\u0430\u0442\u044b\u0432\u0430\u0435\u0442\u0441\u044f\u2026",generateQRCode:"\u0421\u043e\u0437\u0434\u0430\u0442\u044c QR-\u043a\u043e\u0434","await.waitForConfirmation":"\u041e\u0436\u0438\u0434\u0430\u043d\u0438\u0435 \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f","mbway.confirmPayment":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u0435 \u043e\u043f\u043b\u0430\u0442\u0443 \u0432 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0438 MB WAY","shopperEmail.invalid":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u0430\u0434\u0440\u0435\u0441 \u044d\u043b. \u043f\u043e\u0447\u0442\u044b","dateOfBirth.format":"\u0414\u0414/\u041c\u041c/\u0413\u0413\u0413\u0413","dateOfBirth.invalid":"\u0412\u0430\u043c \u0434\u043e\u043b\u0436\u043d\u043e \u0431\u044b\u0442\u044c 18 \u043b\u0435\u0442 \u0438\u043b\u0438 \u0431\u043e\u043b\u044c\u0448\u0435","blik.confirmPayment":"\u0414\u043b\u044f \u043f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0442\u043a\u0440\u043e\u0439\u0442\u0435 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u0435 \u0431\u0430\u043d\u043a\u0430.","blik.invalid":"\u0412\u0432\u0435\u0434\u0438\u0442\u0435 6 \u0446\u0438\u0444\u0440","blik.code":"6-\u0437\u043d\u0430\u0447\u043d\u044b\u0439 \u043a\u043e\u0434","blik.help":"\u041f\u043e\u043b\u0443\u0447\u0438\u0442\u0435 \u043a\u043e\u0434 \u0438\u0437 \u043f\u0440\u0438\u043b\u043e\u0436\u0435\u043d\u0438\u044f \u0432\u0430\u0448\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u0430.","swish.pendingMessage":"\u041e\u0431\u0440\u0430\u0431\u043e\u0442\u043a\u0430 \u043e\u043f\u043b\u0430\u0442\u044b \u043f\u043e\u0441\u043b\u0435 \u0441\u043a\u0430\u043d\u0438\u0440\u043e\u0432\u0430\u043d\u0438\u044f \u043c\u043e\u0436\u0435\u0442 \u0437\u0430\u043d\u044f\u0442\u044c 10 \u043c\u0438\u043d\u0443\u0442. \u041f\u043e\u043f\u044b\u0442\u043a\u0430 \u043f\u0440\u043e\u0432\u0435\u0441\u0442\u0438 \u043e\u043f\u043b\u0430\u0442\u0443 \u043f\u043e\u0432\u0442\u043e\u0440\u043d\u043e \u0432 \u0442\u0435\u0447\u0435\u043d\u0438\u0435 \u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0433\u043e \u0432\u0440\u0435\u043c\u0435\u043d\u0438 \u043c\u043e\u0436\u0435\u0442 \u043f\u0440\u0438\u0432\u0435\u0441\u0442\u0438 \u043a \u043d\u0435\u0441\u043a\u043e\u043b\u044c\u043a\u0438\u043c \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u044f\u043c \u0441\u043e \u0441\u0447\u0435\u0442\u0430.","error.va.gen.01":"\u041d\u0435\u0437\u0430\u043f\u043e\u043b\u043d\u0435\u043d\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.gen.02":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u043e\u0435 \u043f\u043e\u043b\u0435","error.va.sf-cc-num.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u043a\u0430\u0440\u0442\u044b","error.va.sf-cc-num.03":"\u0412\u0432\u0435\u0434\u0435\u043d\u0430 \u043d\u0435\u043f\u043e\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u043c\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.01":"\u0423\u0441\u0442\u0430\u0440\u0435\u0432\u0448\u0430\u044f \u043a\u0430\u0440\u0442\u0430","error.va.sf-cc-dat.02":"\u0414\u0430\u0442\u0430 \u0441\u043b\u0438\u0448\u043a\u043e\u043c \u0434\u0430\u043b\u0435\u043a\u043e \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043c","error.va.sf-cc-dat.03":"\u0421\u0440\u043e\u043a \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u0432\u0430\u0448\u0435\u0439 \u043a\u0430\u0440\u0442\u044b \u0438\u0441\u0442\u0435\u043a\u0430\u0435\u0442 \u0434\u043e \u0434\u0430\u0442\u044b \u043e\u043f\u043b\u0430\u0442\u044b","error.va.sf-ach-num.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0441\u0447\u0435\u0442\u0430","error.va.sf-ach-loc.01":"\u041d\u0435\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043b\u044c\u043d\u044b\u0439 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 ABA","error.va.sf-kcp-pwd.01":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043f\u0430\u0440\u043e\u043b\u044c","error.giftcard.no-balance":"\u041d\u0430 \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435 \u043d\u0435\u0442 \u0441\u0440\u0435\u0434\u0441\u0442\u0432","error.giftcard.card-error":"\u0423 \u043d\u0430\u0441 \u043d\u0435 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043e\u0432\u0430\u043d\u0430 \u043a\u0430\u0440\u0442\u0430 \u0441 \u0442\u0430\u043a\u0438\u043c \u043d\u043e\u043c\u0435\u0440\u043e\u043c","error.giftcard.currency-error":"\u041f\u0440\u0438\u043d\u0438\u043c\u0430\u044e\u0442\u0441\u044f \u0442\u043e\u043b\u044c\u043a\u043e \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u044b\u0435 \u043a\u0430\u0440\u0442\u044b \u0441\u043e\u043e\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044e\u0449\u0435\u0439 \u0432\u0430\u043b\u044e\u0442\u044b","amazonpay.signout":"\u0412\u044b\u0439\u0442\u0438 \u0438\u0437 Amazon","amazonpay.changePaymentDetails":"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c \u0438\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0438\u044e \u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u0435","partialPayment.warning":"\u0412\u044b\u0431\u0440\u0430\u0442\u044c \u0434\u0440\u0443\u0433\u043e\u0439 \u0441\u043f\u043e\u0441\u043e\u0431 \u043e\u043f\u043b\u0430\u0442\u044b \u043e\u0441\u0442\u0430\u0442\u043a\u0430","partialPayment.remainingBalance":"\u041e\u0441\u0442\u0430\u0442\u043e\u043a \u043d\u0430 \u0431\u0430\u043b\u0430\u043d\u0441\u0435 \u0441\u043e\u0441\u0442\u0430\u0432\u0438\u0442 %{amount}","bankTransfer.beneficiary":"\u041f\u043e\u043b\u0443\u0447\u0430\u0442\u0435\u043b\u044c","bankTransfer.reference":"\u0421\u0441\u044b\u043b\u043a\u0430","bankTransfer.introduction":"\u0414\u043b\u044f \u0441\u043e\u0437\u0434\u0430\u043d\u0438\u044f \u043d\u043e\u0432\u043e\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u043f\u0435\u0440\u0435\u0447\u0438\u0441\u043b\u0435\u043d\u0438\u044f \u043f\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u0434\u0430\u043b\u0435\u0435. \u0414\u043b\u044f \u043e\u043a\u043e\u043d\u0447\u0430\u0442\u0435\u043b\u044c\u043d\u043e\u0433\u043e \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d\u0438\u044f \u043f\u043b\u0430\u0442\u0435\u0436\u0430 \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f \u043d\u0430 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0435\u043c \u044d\u043a\u0440\u0430\u043d\u0435.","bankTransfer.instructions":"\u0411\u043b\u0430\u0433\u043e\u0434\u0430\u0440\u0438\u043c \u0437\u0430 \u043f\u043e\u043a\u0443\u043f\u043a\u0443. \u0414\u043b\u044f \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043d\u0438\u044f \u043e\u043f\u043b\u0430\u0442\u044b \u0438\u0441\u043f\u043e\u043b\u044c\u0437\u0443\u0439\u0442\u0435 \u0441\u043b\u0435\u0434\u0443\u044e\u0449\u0438\u0435 \u0441\u0432\u0435\u0434\u0435\u043d\u0438\u044f.","bacs.accountHolderName":"\u0418\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountHolderName.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u043e\u0435 \u0438\u043c\u044f \u0432\u043b\u0430\u0434\u0435\u043b\u044c\u0446\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber":"\u041d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.accountNumber.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043d\u043e\u043c\u0435\u0440 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","bacs.bankLocationId":"\u041a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.bankLocationId.invalid":"\u041d\u0435\u0432\u0435\u0440\u043d\u044b\u0439 \u043a\u043e\u0434 \u0431\u0430\u043d\u043a\u0430","bacs.consent.amount":"\u0412\u044b\u0440\u0430\u0436\u0430\u044e \u0441\u043e\u0433\u043b\u0430\u0441\u0438\u0435 \u043d\u0430 \u0441\u043f\u0438\u0441\u0430\u043d\u0438\u0435 \u0432\u044b\u0448\u0435\u0443\u043a\u0430\u0437\u0430\u043d\u043d\u043e\u0439 \u0441\u0443\u043c\u043c\u044b \u0441 \u043c\u043e\u0435\u0433\u043e \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430.","bacs.consent.account":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044e, \u0447\u0442\u043e \u0441\u0447\u0435\u0442 \u043e\u0444\u043e\u0440\u043c\u043b\u0435\u043d \u043d\u0430 \u043c\u043e\u0435 \u0438\u043c\u044f \u0438 \u0447\u0442\u043e \u044f \u2013 \u0435\u0434\u0438\u043d\u0441\u0442\u0432\u0435\u043d\u043d\u043e\u0435 \u043b\u0438\u0446\u043e, \u0438\u043c\u0435\u044e\u0449\u0435\u0435 \u043f\u0440\u0430\u0432\u043e \u043f\u043e\u0434\u043f\u0438\u0441\u0438, \u0440\u0430\u0437\u0440\u0435\u0448\u0430\u044e\u0449\u0435\u0439 \u043f\u0440\u044f\u043c\u043e\u0435 \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0441\u043e \u0441\u0447\u0435\u0442\u0430.",edit:"\u0418\u0437\u043c\u0435\u043d\u0438\u0442\u044c","bacs.confirm":"\u041f\u043e\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044c \u0438 \u043e\u043f\u043b\u0430\u0442\u0438\u0442\u044c","bacs.result.introduction":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c \u0440\u0430\u0441\u043f\u043e\u0440\u044f\u0436\u0435\u043d\u0438\u0435 \u043f\u0440\u044f\u043c\u043e\u0433\u043e \u0434\u0435\u0431\u0435\u0442\u043e\u0432\u0430\u043d\u0438\u044f (DDI / \u043f\u043e\u0440\u0443\u0447\u0435\u043d\u0438\u0435)","download.pdf":"\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044c PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryDate.aria.label":"\u041f\u043e\u043b\u0435 \u0434\u0430\u0442\u044b \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryMonth.aria.label":"\u041f\u043e\u043b\u0435 \u043c\u0435\u0441\u044f\u0446\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0434\u0430\u043d\u043d\u044b\u0445 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f \u043a\u0430\u0440\u0442\u044b","creditCard.encryptedExpiryYear.aria.label":"\u041f\u043e\u043b\u0435 \u0433\u043e\u0434\u0430 \u0441\u0440\u043e\u043a\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044f","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","creditCard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedCardNumber.aria.label":"\u041f\u043e\u043b\u0435 \u043d\u043e\u043c\u0435\u0440\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b","giftcard.encryptedSecurityCode.aria.label":"\u041f\u043e\u043b\u0435 \u0437\u0430\u0449\u0438\u0442\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0430 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u044b",giftcardTransactionLimit:"\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0441\u0443\u043c\u043c\u0430 \u043e\u043f\u0435\u0440\u0430\u0446\u0438\u0438 \u043f\u043e \u044d\u0442\u043e\u0439 \u043f\u043e\u0434\u0430\u0440\u043e\u0447\u043d\u043e\u0439 \u043a\u0430\u0440\u0442\u0435: %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankAccountNumber.aria.label":"\u041f\u043e\u043b\u0435 \u0431\u0430\u043d\u043a\u043e\u0432\u0441\u043a\u043e\u0433\u043e \u0441\u0447\u0435\u0442\u0430","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe \u0434\u043b\u044f \u0437\u0430\u0449\u0438\u0442\u044b \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430","ach.encryptedBankLocationId.aria.label":"\u041f\u043e\u043b\u0435 \u043c\u0430\u0440\u0448\u0440\u0443\u0442\u043d\u043e\u0433\u043e \u043d\u043e\u043c\u0435\u0440\u0430 \u0431\u0430\u043d\u043a\u0430","twint.saved":"\u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e"}}),Uk=Object.freeze({__proto__:null,default:{payButton:"Zaplati\u0165","payButton.redirecting":"Prebieha presmerovanie ...",storeDetails:"Ulo\u017ei\u0165 pre moju \u010fal\u0161iu platbu","creditCard.holderName":"Meno na karte","creditCard.holderName.placeholder":"J. Nov\xe1k","creditCard.holderName.invalid":"Neplatn\xe9 meno dr\u017eite\u013ea karty","creditCard.numberField.title":"\u010c\xedslo karty","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Koniec platnosti","creditCard.expiryDateField.placeholder":"MM/RR","creditCard.expiryDateField.month":"Mesiac","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"RR","creditCard.expiryDateField.year":"Rok","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapam\xe4ta\u0165 na bud\xface pou\u017eitie","creditCard.cvcField.placeholder.4digits":"4 \u010d\xedslice","creditCard.cvcField.placeholder.3digits":"3 \u010d\xedslice","creditCard.taxNumber.placeholder":"RRMMDD/0123456789",installments:"Po\u010det spl\xe1tok",installmentOption:"% {times} x % {partialValue}",installmentOptionMonths:"%{times} mesiace/-ov","installments.oneTime":"Jednorazov\xe1 platba","installments.installments":"Platba po spl\xe1tkach","installments.revolving":"Revolvingov\xe1 platba","sepaDirectDebit.ibanField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","sepaDirectDebit.nameField.placeholder":"J. Nov\xe1k","sepa.ownerName":"Meno dr\u017eite\u013ea","sepa.ibanNumber":"\u010c\xedslo \xfa\u010dtu (IBAN)","error.title":"Chyba","error.subtitle.redirect":"Nepodarilo sa presmerova\u0165","error.subtitle.payment":"Platba zlyhala","error.subtitle.refused":"Platba bola zamietnut\xe1","error.message.unknown":"Vyskytla sa nezn\xe1ma chyba","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Vyberte svoju banku","creditCard.success":"Platba bola \xfaspe\u0161n\xe1",loading:"Na\u010d\xedtava sa\u2026",continue:"Pokra\u010dova\u0165",continueTo:"Pokra\u010dova\u0165 do","wechatpay.timetopay":"Na zaplatenie m\xe1te %@","wechatpay.scanqrcode":"Naskenujte QR k\xf3d",personalDetails:"Osobn\xe9 \xfadaje",companyDetails:"\xdadaje o spolo\u010dnosti","companyDetails.name":"N\xe1zov spolo\u010dnosti","companyDetails.registrationNumber":"Identifika\u010dn\xe9 \u010d\xedslo",socialSecurityNumber:"Rodn\xe9 \u010d\xedslo",firstName:"Krstn\xe9 meno",infix:"Predpona k priezvisku (ak existuje)",lastName:"Priezvisko",mobileNumber:"Mobiln\xe9 telef\xf3nne \u010d\xedslo","mobileNumber.invalid":"Neplatn\xe9 \u010d\xedslo na mobil",city:"Mesto",postalCode:"PS\u010c",countryCode:"K\xf3d krajiny",telephoneNumber:"Telef\xf3nne \u010d\xedslo",dateOfBirth:"D\xe1tum narodenia",shopperEmail:"E-mailov\xe1 adresa",gender:"Pohlavie",male:"Mu\u017e",female:"\u017dena",billingAddress:"Faktura\u010dn\xe1 adresa",street:"Ulica",stateOrProvince:"Kraj",country:"Krajina",houseNumberOrName:"\u010c\xedslo domu",separateDeliveryAddress:"Zadajte samostatn\xfa dodaciu adresu",deliveryAddress:"Dodacia adresa",zipCode:"PS\u010c",apartmentSuite:"Byt/apartm\xe1n",provinceOrTerritory:"Okres alebo \xfazemie",cityTown:"Mesto/obec",address:"Adresa",state:"\u0160t\xe1t","field.title.optional":"(volite\u013en\xe9)","creditCard.cvcField.title.optional":"CVC/CVV (volite\u013en\xe9)","issuerList.wallet.placeholder":"Vyberte si pe\u0148a\u017eenku",privacyPolicy:"Z\xe1sady ochrany osobn\xfdch \xfadajov","afterPay.agreement":"S\xfahlas\xedm s %@ AfterPay",paymentConditions:"podmienkami platby",openApp:"Otvorte aplik\xe1ciu","voucher.readInstructions":"Pre\u010d\xedtajte si pokyny","voucher.introduction":"\u010eakujeme v\xe1m za n\xe1kup; na dokon\u010denie platby pou\u017eite nasleduj\xfaci kup\xf3n.","voucher.expirationDate":"D\xe1tum vypr\u0161ania platnosti","voucher.alternativeReference":"Alternat\xedvny odkaz","dragonpay.voucher.non.bank.selectField.placeholder":"Vyberte si poskytovate\u013ea","dragonpay.voucher.bank.selectField.placeholder":"Vyberte svoju banku","voucher.paymentReferenceLabel":"Platobn\xe1 referencia","voucher.surcharge":"Vr\xe1tane poplatku vo v\xfd\u0161ke %@","voucher.introduction.doku":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.shopperName":"Meno kupuj\xfaceho","voucher.merchantName":"Predajca","voucher.introduction.econtext":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","voucher.telephoneNumber":"Telef\xf3nne \u010d\xedslo","voucher.shopperReference":"Referencia kupuj\xfaceho","voucher.collectionInstitutionNumber":"\u010c\xedslo inkasnej in\u0161tit\xfacie","voucher.econtext.telephoneNumber.invalid":"Telef\xf3nne \u010d\xedslo mus\xed ma\u0165 10 alebo 11 \u010d\xedslic","boletobancario.btnLabel":"Generova\u0165 Boleto","boleto.sendCopyToEmail":"Zasla\u0165 k\xf3piu na m\xf4j e-mail","button.copy":"Kop\xedrova\u0165","button.download":"Stiahnu\u0165","creditCard.storedCard.description.ariaLabel":"Platnos\u0165 ulo\u017eenej karty kon\u010d\xed o %@","voucher.entity":"Subjekt",donateButton:"Prispie\u0165",notNowButton:"Teraz nie",thanksForYourSupport:"\u010eakujeme za podporu!",preauthorizeWith:"Predbe\u017ene autorizova\u0165 pomocou",confirmPreauthorization:"Potvr\u010fte predbe\u017en\xfa autoriz\xe1ciu",confirmPurchase:"Potvr\u010fte n\xe1kup",applyGiftcard:"Uplatni\u0165",giftcardBalance:"Zostatok na dar\u010dekovej karte",deductedBalance:"Zn\xed\u017een\xfd zostatok","creditCard.pin.title":"K\xf3d PIN","creditCard.encryptedPassword.label":"Prv\xe9 2 \u010d\xedslice hesla karty","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neplan\xe9 heslo","creditCard.taxNumber.label":"D\xe1tum narodenia dr\u017eite\u013ea karty (RRRMMDD) alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.labelAlt":"Identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie (10 \u010d\xedslic)","creditCard.taxNumber.invalid":"Neplatn\xfd d\xe1tum narodenia dr\u017eite\u013ea karty alebo identifika\u010dn\xe9 \u010d\xedslo organiz\xe1cie","storedPaymentMethod.disable.button":"Odstr\xe1ni\u0165","storedPaymentMethod.disable.confirmation":"Odstr\xe1ni\u0165 ulo\u017een\xfd sp\xf4sob platby","storedPaymentMethod.disable.confirmButton":"\xc1no, odstr\xe1ni\u0165","storedPaymentMethod.disable.cancelButton":"Zru\u0161i\u0165","ach.bankAccount":"Bankov\xfd \xfa\u010det","ach.accountHolderNameField.title":"Meno majite\u013ea \xfa\u010dtu","ach.accountHolderNameField.placeholder":"J. Nov\xe1k","ach.accountHolderNameField.invalid":"Neplatn\xe9 meno majite\u013ea \xfa\u010dtu","ach.accountNumberField.title":"\u010c\xedslo \xfa\u010dtu","ach.accountNumberField.invalid":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","ach.accountLocationField.title":"Smerovacie \u010d\xedslo ABA","ach.accountLocationField.invalid":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","select.state":"Vyberte kraj","select.stateOrProvince":"Vyberte kraj alebo okres","select.provinceOrTerritory":"Vyberte okres alebo \xfazemie","select.country":"Vyberte krajinu","select.noOptionsFound":"Neboli n\xe1jden\xe9 \u017eiadne mo\u017enosti","select.filter.placeholder":"Vyh\u013ead\xe1vanie...","telephoneNumber.invalid":"Neplatn\xe9 telef\xf3nne \u010d\xedslo",qrCodeOrApp:"alebo","paypal.processingPayment":"Platba sa sprac\xfava.",generateQRCode:"Generova\u0165 QR k\xf3d","await.waitForConfirmation":"\u010cak\xe1 sa na potvrdenie","mbway.confirmPayment":"Potvr\u010fte svoju platbu v aplik\xe1cii MB WAY","shopperEmail.invalid":"Neplatn\xe1 emailov\xe1 adresa","dateOfBirth.format":"DD/MM/RRRR","dateOfBirth.invalid":"Mus\xedte ma\u0165 aspo\u0148 18 rokov","blik.confirmPayment":"Otvorte svoju bankov\xfa aplik\xe1ciu a potvr\u010fte platbu.","blik.invalid":"Zadajte 6 \u010d\xedslic","blik.code":"6-cifern\xfd k\xf3d","blik.help":"Z\xedskajte k\xf3d zo svojej bankovej aplik\xe1cie.","swish.pendingMessage":"Po nasn\xedman\xed m\xf4\u017ee spracovanie trva\u0165 a\u017e 10 min\xfat. Pokus o op\xe4tovn\xe9 zaplatenie v tejto lehote m\xf4\u017ee vies\u0165 k nieko\u013ek\xfdm poplatkom.","error.va.gen.01":"Ne\xfapln\xe9 pole","error.va.gen.02":"Pole je neplatn\xe9","error.va.sf-cc-num.01":"Neplatn\xe9 \u010d\xedslo karty","error.va.sf-cc-num.03":"Zadali ste nepodporovan\xfa kartu","error.va.sf-cc-dat.01":"Karta je pr\xedli\u0161 star\xe1","error.va.sf-cc-dat.02":"D\xe1tum je pr\xedli\u0161 \u010faleko v bud\xfacnosti","error.va.sf-cc-dat.03":"Platnos\u0165 va\u0161ej karty vypr\u0161\xed pred d\xe1tumom odhl\xe1senia","error.va.sf-ach-num.01":"Neplatn\xe9 \u010d\xedslo \xfa\u010dtu","error.va.sf-ach-loc.01":"Neplatn\xe9 smerovacie \u010d\xedslo ABA","error.va.sf-kcp-pwd.01":"Neplan\xe9 heslo","error.giftcard.no-balance":"T\xe1to dar\u010dekov\xe1 karta m\xe1 nulov\xfd zostatok","error.giftcard.card-error":"V na\u0161ich z\xe1znamoch nem\xe1me \u017eiadnu dar\u010dekov\xfa kartu s t\xfdmto \u010d\xedslom","error.giftcard.currency-error":"Dar\u010dekov\xe9 karty s\xfa platn\xe9 iba v mene, v ktorej boli vydan\xe9","amazonpay.signout":"Odhl\xe1si\u0165 sa z Amazonu","amazonpay.changePaymentDetails":"Zmeni\u0165 podrobnosti o platbe","partialPayment.warning":"Ak chcete zaplati\u0165 zostatok, vyberte in\xfd sp\xf4sob platby","partialPayment.remainingBalance":"Zvy\u0161n\xfd zostatok bude %{amount}","bankTransfer.beneficiary":"Pr\xedjemca","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referencie","bankTransfer.introduction":"Pokra\u010dujte vo vytv\xe1ran\xed novej platby bankov\xfdm prevodom. T\xfato platbu m\xf4\u017eete dokon\u010di\u0165 pomocou inform\xe1ci\xed na nasleduj\xfacej obrazovke.","bankTransfer.instructions":"\u010eakujeme v\xe1m za n\xe1kup. Na dokon\u010denie platby pou\u017eite nasleduj\xface inform\xe1cie.","bacs.accountHolderName":"Meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountHolderName.invalid":"Neplatn\xe9 meno majite\u013ea bankov\xe9ho \xfa\u010dtu","bacs.accountNumber":"\u010c\xedslo bankov\xe9ho \xfa\u010dtu","bacs.accountNumber.invalid":"Neplatn\xe9 \u010d\xedslo bankov\xe9ho \xfa\u010dtu","bacs.bankLocationId":"Variabiln\xfd symbol","bacs.bankLocationId.invalid":"Neplatn\xfd variabiln\xfd symbol","bacs.consent.amount":"S\xfahlas\xedm s t\xfdm, \u017ee ni\u017e\u0161ie uveden\xe1 \u010diastka bude odp\xedsan\xe1 z m\xf4jho bankov\xe9ho \xfa\u010dtu.","bacs.consent.account":"Potvrdzujem, \u017ee \xfa\u010det je na moje meno a som jedin\xfd podpisovate\u013e, ktor\xfd je povinn\xfd autorizova\u0165 inkaso v tomto \xfa\u010dte.",edit:"Upravi\u0165","bacs.confirm":"Potvrdi\u0165 a zaplati\u0165","bacs.result.introduction":"Stiahnite si pokyny k inkasu (DDI/Mand\xe1t)","download.pdf":"Stiahnu\u0165 vo form\xe1te PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 \u010d\xedslo karty","creditCard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo karty","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe pre de\u0148 konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryDate.aria.label":"Pole d\u0148a konca platnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe pre mesiac konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryMonth.aria.label":"Pole mesiaca konca platnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe pre rok konca platnosti zabezpe\u010denej karty","creditCard.encryptedExpiryYear.aria.label":"Pole roka konca platnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej karty","creditCard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedCardNumber.aria.label":"Pole pre \u010d\xedslo dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe pre bezpe\u010dnostn\xfd k\xf3d zabezpe\u010denej dar\u010dekovej karty","giftcard.encryptedSecurityCode.aria.label":"Pole bezpe\u010dnostn\xe9ho k\xf3du dar\u010dekovej karty",giftcardTransactionLimit:"Pre transakciu s touto dar\u010dekovou kartou je povolen\xe9 maximum %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe pre \u010d\xedslo zabezpe\u010den\xe9ho bankov\xe9ho \xfa\u010dtu","ach.encryptedBankAccountNumber.aria.label":"Pole bankov\xe9ho \xfa\u010dtu","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe pre zabezpe\u010den\xe9 smerovacie \u010d\xedslo banky","ach.encryptedBankLocationId.aria.label":"Pole smerovacieho \u010d\xedsla banky","twint.saved":"ulo\u017een\xe9"}}),Kk=Object.freeze({__proto__:null,default:{payButton:"Pla\u010dilo","payButton.redirecting":"Preusmerjanje ...",storeDetails:"Shrani za moje naslednje pla\u010dilo","creditCard.holderName":"Ime na kartici","creditCard.holderName.placeholder":"J. Novak","creditCard.holderName.invalid":"Neveljavno ime imetnika kartice","creditCard.numberField.title":"\u0160tevilka kartice","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Datum veljavnosti","creditCard.expiryDateField.placeholder":"MM/LL","creditCard.expiryDateField.month":"Mesec","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"LL","creditCard.expiryDateField.year":"Leto","creditCard.cvcField.title":"CVC/CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Zapomni si za prihodnji\u010d","creditCard.cvcField.placeholder.4digits":"4 \u0161tevke","creditCard.cvcField.placeholder.3digits":"3 \u0161tevke","creditCard.taxNumber.placeholder":"LLMMDD / 0123456789",installments:"\u0160tevilo obrokov",installmentOption:"%{times} \xd7 %{partialValue}",installmentOptionMonths:"\u0160t. mesecev: %{times}","installments.oneTime":"Enkratno pla\u010dilo","installments.installments":"Obro\u010dno pla\u010dilo","installments.revolving":"Revolving pla\u010dilo","sepaDirectDebit.ibanField.invalid":"Neveljavna \u0161tevilka ra\u010duna","sepaDirectDebit.nameField.placeholder":"J. Novak","sepa.ownerName":"Ime imetnika","sepa.ibanNumber":"\u0160tevilka ra\u010duna (IBAN)","error.title":"Napaka","error.subtitle.redirect":"Preusmeritev ni uspela","error.subtitle.payment":"Pla\u010dilo ni uspelo","error.subtitle.refused":"Pla\u010dilo je bilo zavrnjeno","error.message.unknown":"Pri\u0161lo je do neznane napake","idealIssuer.selectField.title":"Banka","idealIssuer.selectField.placeholder":"Izberite svojo banko","creditCard.success":"Pla\u010dilo je bilo uspe\u0161no",loading:"Nalaganje \u2026",continue:"Nadaljuj",continueTo:"Nadaljujte na","wechatpay.timetopay":"Pla\u010dati morate %@","wechatpay.scanqrcode":"Opti\u010dno preberite kodo QR",personalDetails:"Osebni podatki",companyDetails:"Podrobnosti o podjetju","companyDetails.name":"Ime podjetja","companyDetails.registrationNumber":"Mati\u010dna \u0161tevilka podjetja",socialSecurityNumber:"\u0160tevilka socialnega zavarovanja",firstName:"Ime",infix:"Naziv",lastName:"Priimek",mobileNumber:"\u0160tevilka mobilnega telefona","mobileNumber.invalid":"Neveljavna \u0161tevilka mobilnega telefona",city:"Mesto",postalCode:"Po\u0161tna \u0161tevilka",countryCode:"Koda dr\u017eave",telephoneNumber:"Telefonska \u0161tevilka",dateOfBirth:"Datum rojstva",shopperEmail:"Elektronski naslov",gender:"Spol",male:"Mo\u0161ki",female:"\u017denski",billingAddress:"Naslov za ra\u010dun",street:"Ulica",stateOrProvince:"Dr\u017eava ali provinca",country:"Dr\u017eava",houseNumberOrName:"Hi\u0161na \u0161tevilka",separateDeliveryAddress:"Navedite lo\u010den naslov za dostavo",deliveryAddress:"Naslov za dostavo",zipCode:"Po\u0161tna \u0161tevilka",apartmentSuite:"\u0160t. apartmaja/stanovanja",provinceOrTerritory:"Obmo\u010dje ali ozemlje",cityTown:"Mesto",address:"Naslov",state:"Dr\u017eava","field.title.optional":"(izbirno)","creditCard.cvcField.title.optional":"CVC/CVV (neobvezno)","issuerList.wallet.placeholder":"Izberite svojo denarnico",privacyPolicy:"Pravilnik o zasebnosti","afterPay.agreement":"Strinjam se s %@ ponudnika AfterPay",paymentConditions:"pla\u010dilnimi pogoji",openApp:"Odprite aplikacijo","voucher.readInstructions":"Preberite navodila","voucher.introduction":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.expirationDate":"Datum poteka veljavnosti","voucher.alternativeReference":"Druga referen\u010dna \u0161tevilka","dragonpay.voucher.non.bank.selectField.placeholder":"Izberite svojega ponudnika","dragonpay.voucher.bank.selectField.placeholder":"Izberite svojo banko","voucher.paymentReferenceLabel":"Referen\u010dna \u0161tevilka pla\u010dila","voucher.surcharge":"Vklj. %@ dopla\u010dila","voucher.introduction.doku":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.shopperName":"Ime kupca","voucher.merchantName":"Trgovec","voucher.introduction.econtext":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","voucher.telephoneNumber":"Telefonska \u0161tevilka","voucher.shopperReference":"Referen\u010dna \u0161tevilka kupca","voucher.collectionInstitutionNumber":"\u0160tevilka ustanove za zbiranje","voucher.econtext.telephoneNumber.invalid":"Telefonska \u0161tevilka mora vsebovati 10 ali 11 \u0161tevk","boletobancario.btnLabel":"Ustvari Boleto","boleto.sendCopyToEmail":"Po\u0161lji kopijo na moj elektronski naslov","button.copy":"Kopiraj","button.download":"Prenesi","creditCard.storedCard.description.ariaLabel":"Shranjena kartica se kon\u010da na %@","voucher.entity":"Entiteta",donateButton:"Donirajte",notNowButton:"Ne zdaj",thanksForYourSupport:"Zahvaljujemo se vam za podporo!",preauthorizeWith:"Predhodna odobritev s/z:",confirmPreauthorization:"Potrdi predhodno odobritev",confirmPurchase:"Potrditev nakupa",applyGiftcard:"Unov\u010di",giftcardBalance:"Stanje na darilni kartici",deductedBalance:"Odbiti znesek","creditCard.pin.title":"PIN","creditCard.encryptedPassword.label":"Prvi dve \u0161tevki gesla za kartico","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Neveljavno geslo","creditCard.taxNumber.label":"Datum rojstva imetnika kartice (LLMMDD) ali registracijska \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.labelAlt":"Mati\u010dna \u0161tevilka podjetja (10 \u0161tevk)","creditCard.taxNumber.invalid":"Neveljaven datum rojstva imetnika kartice ali mati\u010dna \u0161tevilka podjetja","storedPaymentMethod.disable.button":"Odstrani","storedPaymentMethod.disable.confirmation":"Odstrani shranjen na\u010din pla\u010dila","storedPaymentMethod.disable.confirmButton":"Da, odstrani","storedPaymentMethod.disable.cancelButton":"Prekli\u010di","ach.bankAccount":"Ban\u010dni ra\u010dun","ach.accountHolderNameField.title":"Ime imetnika ra\u010duna","ach.accountHolderNameField.placeholder":"J. Novak","ach.accountHolderNameField.invalid":"Neveljavno ime imetnika ra\u010duna","ach.accountNumberField.title":"\u0160tevilka ra\u010duna","ach.accountNumberField.invalid":"Neveljavna \u0161tevilka ra\u010duna","ach.accountLocationField.title":"Koda banke ABA","ach.accountLocationField.invalid":"Neveljavna koda banke ABA","select.state":"Izberite dr\u017eavo","select.stateOrProvince":"Izberite dr\u017eavo ali provinco","select.provinceOrTerritory":"Izberite obmo\u010dje ali ozemlje","select.country":"Izberite dr\u017eavo","select.noOptionsFound":"Ni najdenih mo\u017enosti","select.filter.placeholder":"Iskanje ...","telephoneNumber.invalid":"Neveljavna telefonska \u0161tevilka",qrCodeOrApp:"ali","paypal.processingPayment":"Obdelava pla\u010dila ...",generateQRCode:"Ustvari kodo QR","await.waitForConfirmation":"\u010cakanje na potrditev","mbway.confirmPayment":"Potrdite svoje pla\u010dilo v aplikaciji MB WAY","shopperEmail.invalid":"Neveljaven elektronski naslov","dateOfBirth.format":"DD/MM/LLLL","dateOfBirth.invalid":"Imeti morate najmanj 18 let","blik.confirmPayment":"Za potrditev pla\u010dila odprite svojo ban\u010dno aplikacijo.","blik.invalid":"Vnesite 6 \u0161tevilk","blik.code":"6-mestna koda","blik.help":"Pridobite kodo iz ban\u010dne aplikacije.","swish.pendingMessage":"Ko opti\u010dno preberete, lahko \u010dakanje traja do 10 minut. Poskus ponovnega pla\u010dila v tem \u010dasu lahko povzro\u010di ve\u010d odtegljajev.","error.va.gen.01":"Nepopolno polje","error.va.gen.02":"Polje ni veljavno","error.va.sf-cc-num.01":"Neveljavna \u0161tevilka kartice","error.va.sf-cc-num.03":"Vnesena je nepodprta kartica","error.va.sf-cc-dat.01":"Kartica je prestara","error.va.sf-cc-dat.02":"Datum je predale\u010d v prihodnosti","error.va.sf-cc-dat.03":"Va\u0161a kartica pote\u010de pred datumom odjave","error.va.sf-ach-num.01":"Neveljavna \u0161tevilka ra\u010duna","error.va.sf-ach-loc.01":"Neveljavna koda banke ABA","error.va.sf-kcp-pwd.01":"Neveljavno geslo","error.giftcard.no-balance":"Na tej darilni kartici ni sredstev","error.giftcard.card-error":"V na\u0161i evidenci nimamo darilne kartice s to \u0161tevilko","error.giftcard.currency-error":"Darilne kartice so veljavne samo za valuto, za katero so bile izdane","amazonpay.signout":"Odjava iz Amazona","amazonpay.changePaymentDetails":"Sprememba podrobnosti pla\u010dila","partialPayment.warning":"Izberite drugo vrsto pla\u010dila za pla\u010dilo ostanka","partialPayment.remainingBalance":"Preostalo stanje bo %{amount}","bankTransfer.beneficiary":"Upravi\u010denec","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"Referenca","bankTransfer.introduction":"Nadaljujte ustvarjanje novega pla\u010dila z ban\u010dnim nakazilom. Za dokon\u010danje tega pla\u010dila lahko uporabite podatke na naslednjem zaslonu.","bankTransfer.instructions":"Zahvaljujemo se vam za nakup. Za dokon\u010danje pla\u010dila uporabite naslednji kupon.","bacs.accountHolderName":"Ime imetnika ban\u010dnega ra\u010duna","bacs.accountHolderName.invalid":"Neveljavno ime imetnika ra\u010duna","bacs.accountNumber":"\u0160tevilka ban\u010dnega ra\u010duna","bacs.accountNumber.invalid":"Neveljavna \u0161tevilka ban\u010dnega ra\u010duna","bacs.bankLocationId":"\u0160tevilka banke","bacs.bankLocationId.invalid":"Neveljavna \u0161tevilka banke","bacs.consent.amount":"Sogla\u0161am s tem, da bo zgornji znesek odtegnjen z mojega ban\u010dnega ra\u010duna.","bacs.consent.account":"Potrjujem, da je ra\u010dun ustvarjen v mojem imenu in sem edini podpisnik za odobritev neposredne bremenitve za ta ra\u010dun.",edit:"Uredi","bacs.confirm":"Potrdi in pla\u010daj","bacs.result.introduction":"Prenesite navodila za neposredno bremenitev (DDI/mandat)","download.pdf":"Prenos datoteke PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko kartice","creditCard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko kartice","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe za zavarovan potek veljavnosti kartice","creditCard.encryptedExpiryDate.aria.label":"Polje z datumom poteka veljavnosti","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe za zavarovan mesec poteka veljavnosti kartice","creditCard.encryptedExpiryMonth.aria.label":"Polje z mesecem poteka veljavnosti","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe za zavarovano leto poteka veljavnosti kartice","creditCard.encryptedExpiryYear.aria.label":"Polje z letom poteka veljavnosti","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo kartice","creditCard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko darilne kartice","giftcard.encryptedCardNumber.aria.label":"Polje s \u0161tevilko darilne kartice","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe za zavarovano varnostno kodo darilne kartice","giftcard.encryptedSecurityCode.aria.label":"Polje z varnostno kodo darilne kartice",giftcardTransactionLimit:"Za posamezno transakcijo na tej darilni kartici je dovoljeno najve\u010d %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe za zavarovano \u0161tevilko ban\u010dnega ra\u010duna","ach.encryptedBankAccountNumber.aria.label":"Polje z ban\u010dnim ra\u010dunom","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe za zavarovano kodo banke","ach.encryptedBankLocationId.aria.label":"Polje s kodo banke","twint.saved":"shranjeno"}}),Hk=Object.freeze({__proto__:null,default:{payButton:"Betala","payButton.redirecting":"Omdirigerar\u2026",storeDetails:"Spara till min n\xe4sta betalning","creditCard.holderName":"Namn p\xe5 kort","creditCard.holderName.placeholder":"A. Andersson","creditCard.holderName.invalid":"Kortinnehavarens namn \xe4r ogiltigt","creditCard.numberField.title":"Kortnummer","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"Utg\xe5ngsdatum","creditCard.expiryDateField.placeholder":"MM/\xc5\xc5","creditCard.expiryDateField.month":"M\xe5nad","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"\xc5\xc5","creditCard.expiryDateField.year":"\xc5r","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"Spara kortuppgifter","creditCard.cvcField.placeholder.4digits":"4 siffror","creditCard.cvcField.placeholder.3digits":"3 siffror","creditCard.taxNumber.placeholder":"\xc5\xc5MMDD / 0123456789",installments:"Antal delbetalningar",installmentOption:"%{times} x %{partialValue}",installmentOptionMonths:"%{times} m\xe5nader","installments.oneTime":"Eng\xe5ngsbetalning","installments.installments":"Delbetalningar","installments.revolving":"Uppdelad betalning","sepaDirectDebit.ibanField.invalid":"Ogiltigt kontonummer","sepaDirectDebit.nameField.placeholder":"A. Andersson","sepa.ownerName":"K\xe4nt av kontoinnehavaren","sepa.ibanNumber":"Kontonummer (IBAN)","error.title":"Fel","error.subtitle.redirect":"Omdirigering misslyckades","error.subtitle.payment":"Betalning misslyckades","error.subtitle.refused":"Betalning avvisad","error.message.unknown":"Ett ok\xe4nt fel uppstod","idealIssuer.selectField.title":"Bank","idealIssuer.selectField.placeholder":"V\xe4lj din bank","creditCard.success":"Betalning lyckades",loading:"Laddar\u2026",continue:"Forts\xe4tt",continueTo:"Forts\xe4tt till","wechatpay.timetopay":"Du har %@ att betala","wechatpay.scanqrcode":"Skanna QR-kod",personalDetails:"Personuppgifter",companyDetails:"F\xf6retagsinformation","companyDetails.name":"F\xf6retagsnamn","companyDetails.registrationNumber":"Registreringsnummer",socialSecurityNumber:"Personnummer",firstName:"F\xf6rnamn",infix:"Prefix",lastName:"Efternamn",mobileNumber:"Mobilnummer","mobileNumber.invalid":"Ogiltigt mobilnummer",city:"Stad",postalCode:"Postnummer",countryCode:"Landskod",telephoneNumber:"Telefonnummer",dateOfBirth:"F\xf6delsedatum",shopperEmail:"E-postadress",gender:"K\xf6n",male:"Man",female:"Kvinna",billingAddress:"Faktureringsadress",street:"Gatuadress",stateOrProvince:"Delstat eller region",country:"Land",houseNumberOrName:"Husnummer",separateDeliveryAddress:"Ange en separat leveransadress",deliveryAddress:"Leveransadress",zipCode:"Postnummer",apartmentSuite:"L\xe4genhetsnummer",provinceOrTerritory:"Provins eller territorium",cityTown:"Ort",address:"Adress",state:"Delstat","field.title.optional":"(valfritt)","creditCard.cvcField.title.optional":"CVC/CVV (tillval)","issuerList.wallet.placeholder":"V\xe4j din pl\xe5nbok",privacyPolicy:"Sekretesspolicy","afterPay.agreement":"Jag godk\xe4nner AfterPays %@",paymentConditions:"betalvillkor",openApp:"\xd6ppna appen","voucher.readInstructions":"L\xe4s instruktionerna","voucher.introduction":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande kupong f\xf6r att slutf\xf6ra din betalning.","voucher.expirationDate":"Utg\xe5ngsdatum","voucher.alternativeReference":"Alternativ referens","dragonpay.voucher.non.bank.selectField.placeholder":"V\xe4lj din leverant\xf6r","dragonpay.voucher.bank.selectField.placeholder":"V\xe4lj din bank","voucher.paymentReferenceLabel":"Betalreferens","voucher.surcharge":"Inklusive %@ i avgift","voucher.introduction.doku":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.shopperName":"Konsumentens namn","voucher.merchantName":"Handlare","voucher.introduction.econtext":"Tack f\xf6r ditt k\xf6p, v\xe4nligen anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","voucher.telephoneNumber":"Telefonnummer","voucher.shopperReference":"K\xf6parreferens","voucher.collectionInstitutionNumber":"Nummer p\xe5 upph\xe4mtningsplats","voucher.econtext.telephoneNumber.invalid":"Telefonnumret m\xe5ste inneh\xe5lla 10 eller 11 siffror","boletobancario.btnLabel":"Generera Boleto","boleto.sendCopyToEmail":"Skicka en kopia till min e-post","button.copy":"Kopiera","button.download":"Ladda ner","creditCard.storedCard.description.ariaLabel":"Sparat kort slutar p\xe5 %@","voucher.entity":"Enhet",donateButton:"Donera",notNowButton:"Inte nu",thanksForYourSupport:"Tack f\xf6r ditt st\xf6d!",preauthorizeWith:"F\xf6rauktorisera med",confirmPreauthorization:"Bekr\xe4fta f\xf6rauktorisering",confirmPurchase:"Bekr\xe4fta k\xf6p",applyGiftcard:"L\xf6s in",giftcardBalance:"Presentkortssaldo",deductedBalance:"Avdraget saldo","creditCard.pin.title":"PIN-kod","creditCard.encryptedPassword.label":"De tv\xe5 f\xf6rsta siffrorna i kortets l\xf6senord","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"Ogiltigt l\xf6senord","creditCard.taxNumber.label":"Kortinnehavarens f\xf6delsedatum (\xc5\xc5MMDD) eller f\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.labelAlt":"F\xf6retagets organisationsnummer (10 siffror)","creditCard.taxNumber.invalid":"Ogiltigt f\xf6delsedatum eller organisationsnummer","storedPaymentMethod.disable.button":"Ta bort","storedPaymentMethod.disable.confirmation":"Ta bort sparat betalningss\xe4tt","storedPaymentMethod.disable.confirmButton":"Ja, ta bort","storedPaymentMethod.disable.cancelButton":"Avbryt","ach.bankAccount":"Bankkonto","ach.accountHolderNameField.title":"Kontoinnehavarens namn","ach.accountHolderNameField.placeholder":"A. Andersson","ach.accountHolderNameField.invalid":"Kontoinnehavarens namn \xe4r ogiltigt","ach.accountNumberField.title":"Kontonummer","ach.accountNumberField.invalid":"Ogiltigt kontonummer","ach.accountLocationField.title":"ABA-nummer","ach.accountLocationField.invalid":"Ogiltigt ABA-nummer","select.state":"V\xe4lj delstat","select.stateOrProvince":"V\xe4lj delstat eller provins","select.provinceOrTerritory":"V\xe4lj provins eller territorium","select.country":"V\xe4lj land","select.noOptionsFound":"Inga alternativ hittades","select.filter.placeholder":"S\xf6k efter\u2026","telephoneNumber.invalid":"Ogiltigt telefonnummer",qrCodeOrApp:"eller","paypal.processingPayment":"Behandlar betalning \u2026",generateQRCode:"Generera QR-kod","await.waitForConfirmation":"V\xe4ntar p\xe5 bekr\xe4ftelse","mbway.confirmPayment":"Bekr\xe4fta din betalning i appen MB WAY","shopperEmail.invalid":"Ogiltig e-postadress","dateOfBirth.format":"DD/MM/\xc5\xc5\xc5\xc5","dateOfBirth.invalid":"Du m\xe5ste vara minst 18 \xe5r","blik.confirmPayment":"\xd6ppna din bankapp f\xf6r att bekr\xe4fta betalningen.","blik.invalid":"Ange 6 siffror","blik.code":"Sexsiffrig kod","blik.help":"H\xe4mta koden fr\xe5n din bankapp.","swish.pendingMessage":"N\xe4r du har skannat kan statusen vara v\xe4ntande i upp till tio minuter. Att f\xf6rs\xf6ka betala igen inom denna tid kan leda till flera debiteringar.","error.va.gen.01":"Ofullst\xe4ndigt f\xe4lt","error.va.gen.02":"F\xe4ltet ogiltigt","error.va.sf-cc-num.01":"Ogiltigt kortnummer","error.va.sf-cc-num.03":"Det angivna kortet st\xf6ds inte","error.va.sf-cc-dat.01":"Kortet \xe4r f\xf6r gammalt","error.va.sf-cc-dat.02":"Datumet ligger f\xf6r l\xe5ngt fram i framtiden","error.va.sf-cc-dat.03":"Ditt kort g\xe5r ut f\xf6re betalningsdatumet","error.va.sf-ach-num.01":"Ogiltigt kontonummer","error.va.sf-ach-loc.01":"Ogiltigt ABA-nummer","error.va.sf-kcp-pwd.01":"Ogiltigt l\xf6senord","error.giftcard.no-balance":"Saldot f\xf6r detta presentkort \xe4r noll","error.giftcard.card-error":"Vi har inte registrerat n\xe5got presentkort med det numret","error.giftcard.currency-error":"Presentkort \xe4r endast giltiga i den valuta som de utf\xe4rdades i","amazonpay.signout":"Logga ut fr\xe5n Amazon","amazonpay.changePaymentDetails":"\xc4ndra betalningsuppgifter","partialPayment.warning":"V\xe4lj ett annat betalningss\xe4tt f\xf6r att betala det \xe5terst\xe5ende","partialPayment.remainingBalance":"\xc5terst\xe5ende saldo blir %{amount}","bankTransfer.beneficiary":"Mottagare","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"referens","bankTransfer.introduction":"Forts\xe4tt f\xf6r att skapa en ny bank\xf6verf\xf6ring. Du kan anv\xe4nda informationen p\xe5 f\xf6ljande sk\xe4rm f\xf6r att slutf\xf6ra denna betalning.","bankTransfer.instructions":"Tack f\xf6r ditt k\xf6p! Anv\xe4nd f\xf6ljande information f\xf6r att slutf\xf6ra din betalning.","bacs.accountHolderName":"Bankkontoinnehavarens namn","bacs.accountHolderName.invalid":"Ogiltigt namn p\xe5 bankkontoinnehavare","bacs.accountNumber":"Bankkontonummer","bacs.accountNumber.invalid":"Ogiltigt bankkontonummer","bacs.bankLocationId":"Clearingnummer","bacs.bankLocationId.invalid":"Ogiltigt clearingnummer","bacs.consent.amount":"Jag godk\xe4nner att ovanst\xe5ende belopp dras fr\xe5n mitt bankkonto.","bacs.consent.account":"Jag bekr\xe4ftar att jag \xe4r kontoinnehavare och att jag \xe4r den enda person vars godk\xe4nnande kr\xe4vs f\xf6r att auktorisera autogiro fr\xe5n detta konto.",edit:"Redigera","bacs.confirm":"Bekr\xe4fta och betala","bacs.result.introduction":"Ladda ner din instruktion f\xf6r autogiro/direktdebitering (DDI / Mandate)","download.pdf":"Ladda ner PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat kortnummer","creditCard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r kortnummer","creditCard.encryptedExpiryDate.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngsdatum f\xf6r kort","creditCard.encryptedExpiryDate.aria.label":"F\xe4lt f\xf6r utg\xe5ngsdatum","creditCard.encryptedExpiryMonth.aria.iframeTitle":"Iframe f\xf6r s\xe4krad utg\xe5ngsm\xe5nad f\xf6r kort","creditCard.encryptedExpiryMonth.aria.label":"F\xe4lt f\xf6r utg\xe5ngsm\xe5nad","creditCard.encryptedExpiryYear.aria.iframeTitle":"Iframe f\xf6r s\xe4krat utg\xe5ngs\xe5r f\xf6r kort","creditCard.encryptedExpiryYear.aria.label":"F\xe4lt f\xf6r utg\xe5ngs\xe5r","creditCard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r kort","creditCard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod","giftcard.encryptedCardNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat presentkortsnummer","giftcard.encryptedCardNumber.aria.label":"F\xe4lt f\xf6r presentkortsnummer","giftcard.encryptedSecurityCode.aria.iframeTitle":"Iframe f\xf6r s\xe4krad s\xe4kerhetskod f\xf6r presentkort","giftcard.encryptedSecurityCode.aria.label":"F\xe4lt f\xf6r s\xe4kerhetskod f\xf6r presentkort",giftcardTransactionLimit:"Maximalt %{amount} per transaktion \xe4r till\xe5tet p\xe5 detta presentkort","ach.encryptedBankAccountNumber.aria.iframeTitle":"Iframe f\xf6r s\xe4krat bankkontonummer","ach.encryptedBankAccountNumber.aria.label":"F\xe4lt f\xf6r bankkontonummer","ach.encryptedBankLocationId.aria.iframeTitle":"Iframe f\xf6r s\xe4krat clearingnummer","ach.encryptedBankLocationId.aria.label":"F\xe4lt f\xf6r clearingnummer","twint.saved":"sparat"}}),qk=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u6b63\u5728\u91cd\u5b9a\u5411...",storeDetails:"\u4fdd\u5b58\u4ee5\u4fbf\u4e0b\u6b21\u652f\u4ed8\u4f7f\u7528","creditCard.holderName":"\u5361\u7247\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u59d3\u540d","creditCard.numberField.title":"\u5361\u53f7","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u6709\u6548\u671f","creditCard.expiryDateField.placeholder":"\u6708\u6708/\u5e74\u5e74","creditCard.expiryDateField.month":"\u6708","creditCard.expiryDateField.month.placeholder":"\u6708\u6708","creditCard.expiryDateField.year.placeholder":"\u5e74\u5e74","creditCard.expiryDateField.year":"\u5e74","creditCard.cvcField.title":"CVC / CVV","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8bb0\u4f4f\u4ee5\u4fbf\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6570","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6570","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5 / 0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u671f\u6570",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"%{times} \u4e2a\u6708","installments.oneTime":"\u5168\u6b3e\u652f\u4ed8","installments.installments":"\u5206\u671f\u652f\u4ed8","installments.revolving":"\u5faa\u73af\u652f\u4ed8","sepaDirectDebit.ibanField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u5361\u4eba\u59d3\u540d","sepa.ibanNumber":"\u8d26\u53f7 (IBAN)","error.title":"\u9519\u8bef","error.subtitle.redirect":"\u91cd\u5b9a\u5411\u5931\u8d25","error.subtitle.payment":"\u652f\u4ed8\u5931\u8d25","error.subtitle.refused":"\u652f\u4ed8\u88ab\u62d2","error.message.unknown":"\u53d1\u751f\u672a\u77e5\u9519\u8bef","idealIssuer.selectField.title":"\u94f6\u884c","idealIssuer.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","creditCard.success":"\u652f\u4ed8\u6210\u529f",loading:"\u6b63\u5728\u52a0\u8f7d...",continue:"\u7ee7\u7eed",continueTo:"\u7ee7\u7eed\u81f3","wechatpay.timetopay":"\u60a8\u9700\u8981\u652f\u4ed8 %@","wechatpay.scanqrcode":"\u626b\u63cf\u4e8c\u7ef4\u7801",personalDetails:"\u4e2a\u4eba\u8be6\u7ec6\u4fe1\u606f",companyDetails:"\u516c\u53f8\u8be6\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u79f0","companyDetails.registrationNumber":"\u6ce8\u518c\u53f7",socialSecurityNumber:"\u793e\u4f1a\u4fdd\u9669\u53f7\u7801",firstName:"\u540d\u5b57",infix:"\u524d\u7f00",lastName:"\u59d3\u6c0f",mobileNumber:"\u624b\u673a\u53f7","mobileNumber.invalid":"\u65e0\u6548\u7684\u624b\u673a\u53f7\u7801",city:"\u57ce\u5e02",postalCode:"\u90ae\u653f\u7f16\u7801",countryCode:"\u56fd\u5bb6\u4ee3\u7801",telephoneNumber:"\u7535\u8bdd\u53f7\u7801",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u7535\u5b50\u90ae\u4ef6\u5730\u5740",gender:"\u6027\u522b",male:"\u7537",female:"\u5973",billingAddress:"\u8d26\u5355\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde\u6216\u7701",country:"\u56fd\u5bb6/\u5730\u533a",houseNumberOrName:"\u95e8\u724c\u53f7",separateDeliveryAddress:"\u6307\u5b9a\u4e00\u4e2a\u5355\u72ec\u7684\u5bc4\u9001\u5730\u5740",deliveryAddress:"\u5bc4\u9001\u5730\u5740",zipCode:"\u90ae\u653f\u7f16\u7801",apartmentSuite:"\u516c\u5bd3 / \u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u533a",cityTown:"\u5e02 / \u9547",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u53ef\u9009\uff09","creditCard.cvcField.title.optional":"CVC / CVV\uff08\u53ef\u9009\uff09","issuerList.wallet.placeholder":"\u9009\u62e9\u60a8\u7684\u94b1\u5305",privacyPolicy:"\u9690\u79c1\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684 %@",paymentConditions:"\u652f\u4ed8\u6761\u4ef6",openApp:"\u6253\u5f00\u5e94\u7528","voucher.readInstructions":"\u9605\u8bfb\u8bf4\u660e","voucher.introduction":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4f18\u60e0\u5238\u5b8c\u6210\u652f\u4ed8\u3002","voucher.expirationDate":"\u6709\u6548\u671f","voucher.alternativeReference":"\u5907\u9009\u4ee3\u7801","dragonpay.voucher.non.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u63d0\u4f9b\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9009\u62e9\u60a8\u7684\u94f6\u884c","voucher.paymentReferenceLabel":"\u4ea4\u6613\u53f7","voucher.surcharge":"\u5305\u62ec %@ \u7684\u9644\u52a0\u8d39","voucher.introduction.doku":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.shopperName":"\u987e\u5ba2\u59d3\u540d","voucher.merchantName":"\u5546\u6237","voucher.introduction.econtext":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","voucher.telephoneNumber":"\u7535\u8bdd\u53f7\u7801","voucher.shopperReference":"\u987e\u5ba2\u53c2\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u673a\u6784\u7f16\u53f7","voucher.econtext.telephoneNumber.invalid":"\u7535\u8bdd\u53f7\u7801\u5fc5\u987b\u4e3a 10 \u6216 11 \u4f4d\u6570\u5b57","boletobancario.btnLabel":"\u751f\u6210 Boleto","boleto.sendCopyToEmail":"\u5c06\u526f\u672c\u53d1\u9001\u5230\u6211\u7684\u7535\u5b50\u90ae\u7bb1","button.copy":"\u590d\u5236","button.download":"\u4e0b\u8f7d","creditCard.storedCard.description.ariaLabel":"\u5b58\u50a8\u7684\u5361\u7247\u4ee5 \uff05@ \u7ed3\u5c3e","voucher.entity":"\u5b9e\u4f53",donateButton:"\u6350\u8d60",notNowButton:"\u6682\u4e0d",thanksForYourSupport:"\u611f\u8c22\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u9884\u5148\u6388\u6743",confirmPreauthorization:"\u786e\u8ba4\u9884\u5148\u6388\u6743",confirmPurchase:"\u786e\u8ba4\u8d2d\u4e70",applyGiftcard:"\u5151\u6362",giftcardBalance:"\u793c\u54c1\u5361\u4f59\u989d",deductedBalance:"\u6263\u51cf\u4f59\u989d","creditCard.pin.title":"Pin","creditCard.encryptedPassword.label":"\u5361\u7247\u5bc6\u7801\u7684\u524d 2 \u4f4d\u6570","creditCard.encryptedPassword.invalid":"\u65e0\u6548\u7684\u5bc6\u7801","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5 (YYMMDD) \u6216\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u6ce8\u518c\u53f7\uff0810 \u4f4d\u6570\uff09","creditCard.taxNumber.invalid":"\u65e0\u6548\u7684\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u6ce8\u518c\u53f7","storedPaymentMethod.disable.button":"\u5220\u9664","storedPaymentMethod.disable.confirmation":"\u5220\u9664\u5b58\u50a8\u7684\u652f\u4ed8\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u5220\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u94f6\u884c\u8d26\u6237","ach.accountHolderNameField.title":"\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u65e0\u6548\u7684\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","ach.accountNumberField.title":"\u8d26\u53f7","ach.accountNumberField.invalid":"\u65e0\u6548\u7684\u8d26\u53f7","ach.accountLocationField.title":"ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","ach.accountLocationField.invalid":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","select.state":"\u9009\u62e9\u5dde","select.stateOrProvince":"\u9009\u62e9\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9009\u62e9\u7701\u6216\u5730\u533a","select.country":"\u9009\u62e9\u56fd\u5bb6/\u5730\u533a","select.noOptionsFound":"\u672a\u627e\u5230\u4efb\u4f55\u9009\u9879","select.filter.placeholder":"\u641c\u7d22\u2026\u2026","telephoneNumber.invalid":"\u65e0\u6548\u7684\u7535\u8bdd\u53f7\u7801",qrCodeOrApp:"\u6216\u8005","paypal.processingPayment":"\u6b63\u5728\u5904\u7406\u4ed8\u6b3e...",generateQRCode:"\u751f\u6210\u4e8c\u7ef4\u7801","await.waitForConfirmation":"\u7b49\u5f85\u786e\u8ba4","mbway.confirmPayment":"\u5728 MB WAY \u5e94\u7528\u4e0a\u786e\u8ba4\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u65e0\u6548\u7684\u90ae\u4ef6\u5730\u5740","dateOfBirth.format":"DD/MM/YYYY","dateOfBirth.invalid":"\u60a8\u5fc5\u987b\u5e74\u6ee1 18 \u5468\u5c81","blik.confirmPayment":"\u6253\u5f00\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4ee5\u786e\u8ba4\u652f\u4ed8\u3002","blik.invalid":"\u8f93\u5165 6 \u4f4d\u6570","blik.code":"6 \u4f4d\u6570\u4ee3\u7801","blik.help":"\u4ece\u60a8\u7684\u94f6\u884c\u5e94\u7528\u4e2d\u83b7\u53d6\u4ee3\u7801\u3002","swish.pendingMessage":"\u626b\u63cf\u540e\uff0c\u72b6\u6001\u53ef\u80fd\u4f1a\u4fdd\u6301\u6700\u591a 10 \u5206\u949f\u3002\u5728\u6b64\u65f6\u95f4\u5185\u518d\u6b21\u5c1d\u8bd5\u4ed8\u6b3e\u53ef\u80fd\u4f1a\u5bfc\u81f4\u591a\u6b21\u6536\u8d39\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u5b57\u6bb5","error.va.gen.02":"\u65e0\u6548\u5b57\u6bb5","error.va.sf-cc-num.01":"\u65e0\u6548\u7684\u5361\u53f7","error.va.sf-cc-num.03":"\u4e0d\u652f\u6301\u8f93\u5165\u7684\u5361\u7247","error.va.sf-cc-dat.01":"\u5361\u7247\u592a\u65e7","error.va.sf-cc-dat.02":"\u65e5\u671f\u592a\u4e45\u8fdc","error.va.sf-cc-dat.03":"\u60a8\u7684\u5361\u5728\u7ed3\u8d26\u65e5\u671f\u524d\u5df2\u8fc7\u671f","error.va.sf-ach-num.01":"\u65e0\u6548\u7684\u8d26\u53f7","error.va.sf-ach-loc.01":"\u65e0\u6548\u7684 ABA \u8def\u7531\u7535\u6c47\u7f16\u7801","error.va.sf-kcp-pwd.01":"\u65e0\u6548\u7684\u5bc6\u7801","error.giftcard.no-balance":"\u793c\u54c1\u5361\u4f59\u989d\u4e3a\u96f6","error.giftcard.card-error":"\u6211\u4eec\u7684\u6570\u636e\u5e93\u4e2d\u6ca1\u6709\u8fd9\u4e2a\u53f7\u7801\u7684\u793c\u54c1\u5361","error.giftcard.currency-error":"\u793c\u54c1\u5361\u4ec5\u4ee5\u5176\u53d1\u884c\u7684\u8d27\u5e01\u4e3a\u6709\u6548\u8d27\u5e01","amazonpay.signout":"\u9000\u51fa Amazon","amazonpay.changePaymentDetails":"\u66f4\u6539\u652f\u4ed8\u8be6\u60c5","partialPayment.warning":"\u8bf7\u9009\u62e9\u5176\u4ed6\u652f\u4ed8\u65b9\u5f0f\u652f\u4ed8\u5269\u4f59\u6b3e\u9879","partialPayment.remainingBalance":"\u5269\u4f59\u989d\u5ea6\u4e3a %{amount}","bankTransfer.beneficiary":"\u6536\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"\u4e2d\u56fd\u5de5\u5546\u94f6\u884c","bankTransfer.reference":"\u53c2\u8003","bankTransfer.introduction":"\u7ee7\u7eed\u65b0\u5efa\u94f6\u884c\u8f6c\u8d26\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u5c4f\u5e55\u4e2d\u7684\u8be6\u7ec6\u4fe1\u606f\u6765\u5b8c\u6210\u8fd9\u7b14\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u611f\u8c22\u60a8\u7684\u8d2d\u4e70\uff0c\u8bf7\u4f7f\u7528\u4ee5\u4e0b\u4fe1\u606f\u5b8c\u6210\u652f\u4ed8\u3002","bacs.accountHolderName":"\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u6237\u6301\u6709\u4eba\u59d3\u540d","bacs.accountNumber":"\u94f6\u884c\u8d26\u53f7","bacs.accountNumber.invalid":"\u65e0\u6548\u7684\u94f6\u884c\u8d26\u53f7","bacs.bankLocationId":"\u5206\u7c7b\u4ee3\u7801","bacs.bankLocationId.invalid":"\u65e0\u6548\u7684\u5206\u7c7b\u4ee3\u7801","bacs.consent.amount":"\u6211\u540c\u610f\u4ece\u94f6\u884c\u8d26\u6237\u4e2d\u6263\u9664\u4e0a\u8ff0\u91d1\u989d\u3002","bacs.consent.account":"\u6211\u786e\u8ba4\u8be5\u8d26\u6237\u4e3a\u6211\u540d\u4e0b\u7684\u8d26\u6237\uff0c\u5e76\u4e14\u6211\u662f\u6388\u6743\u8be5\u8d26\u6237\u76f4\u63a5\u501f\u8bb0\u7684\u552f\u4e00\u7b7e\u7f72\u4eba\u3002",edit:"\u7f16\u8f91","bacs.confirm":"\u786e\u8ba4\u5e76\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f7d\u60a8\u7684\u76f4\u63a5\u501f\u8bb0\u6307\u793a\uff08DDI/\u59d4\u6258\uff09","download.pdf":"\u4e0b\u8f7d PDF \u6587\u4ef6","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u53f7 Iframe","creditCard.encryptedCardNumber.aria.label":"\u5361\u53f7\u5b57\u6bb5","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u65e5\u671f Iframe","creditCard.encryptedExpiryDate.aria.label":"\u8fc7\u671f\u65e5\u671f\u5b57\u6bb5","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u6708\u4efd Iframe","creditCard.encryptedExpiryMonth.aria.label":"\u8fc7\u671f\u6708\u4efd\u5b57\u6bb5","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u8fc7\u671f\u5e74\u4efd Iframe","creditCard.encryptedExpiryYear.aria.label":"\u8fc7\u671f\u5e74\u4efd\u5b57\u6bb5","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u7247\u5b89\u5168\u7801 Iframe","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u7801\u5b57\u6bb5","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u53f7 Iframe","giftcard.encryptedCardNumber.aria.label":"\u793c\u54c1\u5361\u53f7\u5b57\u6bb5","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u793c\u54c1\u5361\u5b89\u5168\u7801 Iframe","giftcard.encryptedSecurityCode.aria.label":"\u793c\u54c1\u5361\u5b89\u5168\u7801\u5b57\u6bb5",giftcardTransactionLimit:"\u6b64\u793c\u54c1\u5361\u4e0a\u6bcf\u7b14\u4ea4\u6613\u5141\u8bb8\u7684\u6700\u5927\u91d1\u989d\u4e3a %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8d26\u53f7 Iframe","ach.encryptedBankAccountNumber.aria.label":"\u94f6\u884c\u8d26\u53f7\u5b57\u6bb5","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801 Iframe","ach.encryptedBankLocationId.aria.label":"\u94f6\u884c\u8def\u7531\u7535\u6c47\u7f16\u7801\u5b57\u6bb5","twint.saved":"\u5df2\u4fdd\u5b58"}}),Gk=Object.freeze({__proto__:null,default:{payButton:"\u652f\u4ed8","payButton.redirecting":"\u91cd\u65b0\u5c0e\u5411\u4e2d......",storeDetails:"\u5132\u5b58\u4ee5\u4f9b\u4e0b\u6b21\u4ed8\u6b3e\u4f7f\u7528","creditCard.holderName":"\u4fe1\u7528\u5361\u4e0a\u7684\u59d3\u540d","creditCard.holderName.placeholder":"J. Smith","creditCard.holderName.invalid":"\u6301\u5361\u4eba\u59d3\u540d\u7121\u6548","creditCard.numberField.title":"\u4fe1\u7528\u5361\u865f\u78bc","creditCard.numberField.placeholder":"1234 5678 9012 3456","creditCard.expiryDateField.title":"\u5230\u671f\u65e5\u671f","creditCard.expiryDateField.placeholder":"MM/YY","creditCard.expiryDateField.month":"\u6708\u4efd","creditCard.expiryDateField.month.placeholder":"MM","creditCard.expiryDateField.year.placeholder":"YY","creditCard.expiryDateField.year":"\u5e74\u4efd","creditCard.cvcField.title":"\u4fe1\u7528\u5361\u9a57\u8b49\u78bc / \u4fe1\u7528\u5361\u5b89\u5168\u78bc","creditCard.cvcField.placeholder":"123","creditCard.storeDetailsButton":"\u8a18\u4f4f\u4f9b\u4e0b\u6b21\u4f7f\u7528","creditCard.cvcField.placeholder.4digits":"4 \u4f4d\u6578","creditCard.cvcField.placeholder.3digits":"3 \u4f4d\u6578","creditCard.taxNumber.placeholder":"\u5e74\u6708\u65e5\uff0f0123456789",installments:"\u5206\u671f\u4ed8\u6b3e\u7684\u671f\u6578",installmentOption:"%{times}x %{partialValue}",installmentOptionMonths:"\uff05{times} \u500b\u6708","installments.oneTime":"\u4e00\u6b21\u6027\u4ed8\u6b3e","installments.installments":"\u5206\u671f\u4ed8\u6b3e","installments.revolving":"\u5ef6\u671f\u4ed8\u6b3e","sepaDirectDebit.ibanField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","sepaDirectDebit.nameField.placeholder":"J. Smith","sepa.ownerName":"\u6301\u6709\u4eba\u540d\u7a31","sepa.ibanNumber":"\u5e33\u6236\u865f\u78bc (IBAN)","error.title":"\u932f\u8aa4","error.subtitle.redirect":"\u7121\u6cd5\u91cd\u65b0\u5c0e\u5411","error.subtitle.payment":"\u4ed8\u6b3e\u5931\u6557","error.subtitle.refused":"\u4ed8\u6b3e\u906d\u62d2\u7d55","error.message.unknown":"\u767c\u751f\u672a\u77e5\u932f\u8aa4","idealIssuer.selectField.title":"\u9280\u884c","idealIssuer.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","creditCard.success":"\u4ed8\u6b3e\u6210\u529f",loading:"\u6b63\u5728\u8f09\u5165...",continue:"\u7e7c\u7e8c",continueTo:"\u7e7c\u7e8c\u524d\u5f80","wechatpay.timetopay":"\u60a8\u6709 %@ \u53ef\u4ee5\u652f\u4ed8","wechatpay.scanqrcode":"\u6383\u63cf QR \u4ee3\u78bc",personalDetails:"\u500b\u4eba\u8a73\u7d30\u8cc7\u6599",companyDetails:"\u516c\u53f8\u8a73\u60c5","companyDetails.name":"\u516c\u53f8\u540d\u7a31","companyDetails.registrationNumber":"\u8a3b\u518a\u865f\u78bc",socialSecurityNumber:"\u793e\u6703\u5b89\u5168\u78bc",firstName:"\u540d\u5b57",infix:"\u524d\u7db4",lastName:"\u59d3\u6c0f",mobileNumber:"\u884c\u52d5\u96fb\u8a71\u865f\u78bc","mobileNumber.invalid":"\u624b\u6a5f\u865f\u78bc\u7121\u6548",city:"\u57ce\u5e02",postalCode:"\u90f5\u905e\u5340\u865f",countryCode:"\u570b\u5bb6\u4ee3\u78bc",telephoneNumber:"\u96fb\u8a71\u865f\u78bc",dateOfBirth:"\u51fa\u751f\u65e5\u671f",shopperEmail:"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740",gender:"\u6027\u5225",male:"\u7537",female:"\u5973",billingAddress:"\u5e33\u55ae\u5730\u5740",street:"\u8857\u9053",stateOrProvince:"\u5dde/\u7e23/\u5e02",country:"\u570b\u5bb6/\u5730\u5340",houseNumberOrName:"\u9580\u724c\u865f",separateDeliveryAddress:"\u6307\u5b9a\u53e6\u4e00\u500b\u6d3e\u9001\u5730\u5740",deliveryAddress:"\u6d3e\u9001\u5730\u5740",zipCode:"\u90f5\u905e\u5340\u865f",apartmentSuite:"\u516c\u5bd3\uff0f\u5957\u623f",provinceOrTerritory:"\u7701\u6216\u5730\u5340",cityTown:"\u5e02\uff0f\u93ae",address:"\u5730\u5740",state:"\u5dde","field.title.optional":"\uff08\u9078\u7528\uff09","creditCard.cvcField.title.optional":"CVC / CVV (\u53ef\u9078)","issuerList.wallet.placeholder":"\u9078\u53d6\u60a8\u7684\u96fb\u5b50\u9322\u5305",privacyPolicy:"\u96b1\u79c1\u6b0a\u653f\u7b56","afterPay.agreement":"\u6211\u540c\u610f AfterPay \u7684%@",paymentConditions:"\u4ed8\u6b3e\u7d30\u5247",openApp:"\u958b\u555f\u61c9\u7528\u7a0b\u5f0f","voucher.readInstructions":"\u95b1\u89bd\u8aaa\u660e","voucher.introduction":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u512a\u60e0\u5238\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.expirationDate":"\u5230\u671f\u65e5\u671f","voucher.alternativeReference":"\u5099\u9078\u53c3\u7167","dragonpay.voucher.non.bank.selectField.placeholder":"\u9078\u64c7\u60a8\u7684\u4f9b\u61c9\u5546","dragonpay.voucher.bank.selectField.placeholder":"\u9078\u53d6\u60a8\u7684\u9280\u884c","voucher.paymentReferenceLabel":"\u4ed8\u6b3e\u53c3\u7167\u865f\u78bc","voucher.surcharge":"\u5305\u542b %@ \u9644\u52a0\u8cbb","voucher.introduction.doku":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.shopperName":"\u8cfc\u7269\u8005\u59d3\u540d","voucher.merchantName":"\u5546\u5bb6","voucher.introduction.econtext":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","voucher.telephoneNumber":"\u96fb\u8a71\u865f\u78bc","voucher.shopperReference":"\u8cfc\u7269\u8005\u53c3\u8003","voucher.collectionInstitutionNumber":"\u6536\u6b3e\u6a5f\u69cb\u7de8\u865f","voucher.econtext.telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7684\u9577\u5ea6\u5fc5\u9808\u70ba 10 \u6216 11 \u4f4d\u6578","boletobancario.btnLabel":"\u7522\u751f Boleto","boleto.sendCopyToEmail":"\u5c07\u8907\u672c\u50b3\u9001\u81f3\u6211\u7684\u96fb\u5b50\u90f5\u4ef6","button.copy":"\u8907\u88fd","button.download":"\u4e0b\u8f09","creditCard.storedCard.description.ariaLabel":"\u5df2\u5132\u5b58\u4ee5 %@ \u7d50\u5c3e\u7684\u4fe1\u7528\u5361","voucher.entity":"\u5be6\u9ad4",donateButton:"\u6350\u8d08",notNowButton:"\u7a0d\u5f8c\u518d\u8aaa",thanksForYourSupport:"\u611f\u8b1d\u60a8\u7684\u652f\u6301\uff01",preauthorizeWith:"\u900f\u904e\u4ee5\u4e0b\u65b9\u5f0f\u9032\u884c\u9810\u5148\u6388\u6b0a\uff1a",confirmPreauthorization:"\u78ba\u8a8d\u9810\u5148\u6388\u6b0a",confirmPurchase:"\u78ba\u8a8d\u8cfc\u8cb7",applyGiftcard:"\u514c\u63db",giftcardBalance:"\u79ae\u54c1\u5361\u9918\u984d",deductedBalance:"\u6263\u9664\u9918\u984d","creditCard.pin.title":"\u6578\u5b57\u5bc6\u78bc","creditCard.encryptedPassword.label":"\u5361\u5bc6\u78bc\u7684\u524d 2 \u4f4d\u6578\u5b57","creditCard.encryptedPassword.placeholder":"12","creditCard.encryptedPassword.invalid":"\u5bc6\u78bc\u7121\u6548","creditCard.taxNumber.label":"\u6301\u5361\u4eba\u751f\u65e5\uff08\u5e74\u6708\u65e5\uff09\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.labelAlt":"\u516c\u53f8\u8a3b\u518a\u865f\u78bc\uff0810 \u4f4d\u6578\uff09","creditCard.taxNumber.invalid":"\u6301\u5361\u4eba\u751f\u65e5\u6216\u516c\u53f8\u8a3b\u518a\u865f\u78bc\u7121\u6548","storedPaymentMethod.disable.button":"\u79fb\u9664","storedPaymentMethod.disable.confirmation":"\u79fb\u9664\u5df2\u5132\u5b58\u4ed8\u6b3e\u65b9\u5f0f","storedPaymentMethod.disable.confirmButton":"\u662f\uff0c\u8acb\u79fb\u9664","storedPaymentMethod.disable.cancelButton":"\u53d6\u6d88","ach.bankAccount":"\u9280\u884c\u5e33\u6236","ach.accountHolderNameField.title":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","ach.accountHolderNameField.placeholder":"J. Smith","ach.accountHolderNameField.invalid":"\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","ach.accountNumberField.title":"\u5e33\u6236\u865f\u78bc","ach.accountNumberField.invalid":"\u5e33\u6236\u865f\u78bc\u7121\u6548","ach.accountLocationField.title":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f","ach.accountLocationField.invalid":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","select.state":"\u9078\u53d6\u5dde","select.stateOrProvince":"\u9078\u64c7\u5dde\u6216\u7701","select.provinceOrTerritory":"\u9078\u53d6\u7701\u6216\u5730\u5340","select.country":"\u9078\u64c7\u570b\u5bb6\uff0f\u5730\u5340","select.noOptionsFound":"\u627e\u4e0d\u5230\u4efb\u4f55\u9078\u9805","select.filter.placeholder":"\u641c\u5c0b\u2026\u2026","telephoneNumber.invalid":"\u96fb\u8a71\u865f\u78bc\u7121\u6548",qrCodeOrApp:"\u6216","paypal.processingPayment":"\u6b63\u5728\u8655\u7406\u4ed8\u6b3e\u2026\u2026",generateQRCode:"\u7522\u751f QR \u4ee3\u78bc","await.waitForConfirmation":"\u6b63\u5728\u7b49\u5019\u78ba\u8a8d","mbway.confirmPayment":"\u5728 MB WAY \u61c9\u7528\u7a0b\u5f0f\u4e0a\u78ba\u8a8d\u60a8\u7684\u4ed8\u6b3e","shopperEmail.invalid":"\u96fb\u5b50\u90f5\u4ef6\u5730\u5740\u7121\u6548","dateOfBirth.format":"\u65e5\uff0f\u6708\uff0f\u5e74","dateOfBirth.invalid":"\u60a8\u5fc5\u9808\u5e74\u6eff 18 \u6b72","blik.confirmPayment":"\u958b\u555f\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4ee5\u78ba\u8a8d\u4ed8\u6b3e\u3002","blik.invalid":"\u8f38\u5165 6 \u500b\u6578\u5b57","blik.code":"6 \u4f4d\u6578\u4ee3\u78bc","blik.help":"\u5f9e\u60a8\u7684\u9280\u884c\u61c9\u7528\u7a0b\u5f0f\u4e2d\u7372\u53d6\u4ee3\u78bc\u3002","swish.pendingMessage":"\u6383\u63cf\u5f8c\uff0c\u8a72\u5f85\u5b8c\u6210\u72c0\u614b\u53ef\u80fd\u6301\u7e8c\u9577\u9054 10 \u5206\u9418\u3002\u8a66\u5716\u5728\u9019\u6bb5\u6642\u9593\u5167\u518d\u6b21\u4ed8\u6b3e\u53ef\u80fd\u6703\u5c0e\u81f4\u591a\u91cd\u6536\u8cbb\u3002","error.va.gen.01":"\u4e0d\u5b8c\u6574\u6b04\u4f4d","error.va.gen.02":"\u6b04\u4f4d\u7121\u6548","error.va.sf-cc-num.01":"\u4fe1\u7528\u5361\u865f\u78bc\u7121\u6548","error.va.sf-cc-num.03":"\u8f38\u5165\u4e86\u4e0d\u652f\u63f4\u7684\u5361","error.va.sf-cc-dat.01":"\u5361\u592a\u820a","error.va.sf-cc-dat.02":"\u672a\u4f86\u65e5\u671f\u8ddd\u4eca\u592a\u4e45","error.va.sf-cc-dat.03":"\u60a8\u7684\u5361\u6703\u65bc\u4ed8\u6b3e\u65e5\u671f\u524d\u5230\u671f","error.va.sf-ach-num.01":"\u5e33\u6236\u865f\u78bc\u7121\u6548","error.va.sf-ach-loc.01":"ABA \u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7121\u6548","error.va.sf-kcp-pwd.01":"\u5bc6\u78bc\u7121\u6548","error.giftcard.no-balance":"\u6b64\u79ae\u54c1\u5361\u7684\u9918\u984d\u70ba\u96f6","error.giftcard.card-error":"\u6211\u5011\u7684\u8a18\u9304\u4e2d\u4e26\u6c92\u6709\u9019\u500b\u865f\u78bc\u7684\u79ae\u54c1\u5361","error.giftcard.currency-error":"\u79ae\u54c1\u5361\u53ea\u80fd\u4ee5\u5176\u7c3d\u767c\u6642\u6240\u4f7f\u7528\u7684\u8ca8\u5e63\u9032\u884c\u7d50\u7b97","amazonpay.signout":"\u5f9e Amazon \u767b\u51fa","amazonpay.changePaymentDetails":"\u8b8a\u66f4\u4ed8\u6b3e\u660e\u7d30","partialPayment.warning":"\u9078\u53d6\u5176\u4ed6\u4ed8\u6b3e\u65b9\u5f0f\u4f86\u652f\u4ed8\u9918\u984d","partialPayment.remainingBalance":"\u9918\u984d\u5c07\u70ba %{amount}","bankTransfer.beneficiary":"\u53d7\u6b3e\u4eba","bankTransfer.iban":"IBAN","bankTransfer.bic":"BIC","bankTransfer.reference":"\u53c3\u7167","bankTransfer.introduction":"\u7e7c\u7e8c\u5efa\u7acb\u65b0\u7684\u9280\u884c\u8f49\u5e33\u4ed8\u6b3e\u3002\u60a8\u53ef\u4ee5\u4f7f\u7528\u4ee5\u4e0b\u87a2\u5e55\u4e2d\u7684\u8a73\u7d30\u8cc7\u8a0a\u4f86\u5b8c\u6210\u6b64\u9805\u4ed8\u6b3e\u3002","bankTransfer.instructions":"\u591a\u8b1d\u60e0\u9867\uff0c\u8acb\u4f7f\u7528\u4ee5\u4e0b\u8cc7\u8a0a\u5b8c\u6210\u4ed8\u6b3e\u3002","bacs.accountHolderName":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d","bacs.accountHolderName.invalid":"\u9280\u884c\u5e33\u6236\u6301\u6709\u4eba\u59d3\u540d\u7121\u6548","bacs.accountNumber":"\u9280\u884c\u5e33\u6236\u865f\u78bc","bacs.accountNumber.invalid":"\u9280\u884c\u5e33\u6236\u865f\u78bc\u7121\u6548","bacs.bankLocationId":"\u9280\u884c\u4ee3\u78bc","bacs.bankLocationId.invalid":"\u9280\u884c\u4ee3\u78bc\u7121\u6548","bacs.consent.amount":"\u6211\u540c\u610f\u5f9e\u6211\u7684\u9280\u884c\u5e33\u6236\u6263\u9664\u4e0a\u8ff0\u91d1\u984d\u3002","bacs.consent.account":"\u6211\u78ba\u8a8d\u8a72\u5e33\u6236\u4ee5\u6211\u7684\u540d\u7fa9\u958b\u8a2d\uff0c\u4e26\u4e14\u6211\u662f\u6388\u6b0a\u5f9e\u8a72\u5e33\u6236\u76f4\u63a5\u6263\u6b3e\u7684\u552f\u4e00\u7c3d\u7f72\u4eba\u3002",edit:"\u7de8\u8f2f","bacs.confirm":"\u78ba\u8a8d\u4e26\u652f\u4ed8","bacs.result.introduction":"\u4e0b\u8f09\u60a8\u7684\u76f4\u63a5\u6263\u6b3e\u6307\u793a\uff08DDI\uff0f\u6388\u6b0a\uff09","download.pdf":"\u4e0b\u8f09 PDF","creditCard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u5361\u865f\u7684 IFrame","creditCard.encryptedCardNumber.aria.label":"\u5361\u865f\u6b04\u4f4d","creditCard.encryptedExpiryDate.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u65e5\u671f\u7684 IFrame","creditCard.encryptedExpiryDate.aria.label":"\u5230\u671f\u65e5\u671f\u6b04\u4f4d","creditCard.encryptedExpiryMonth.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u6708\u4efd\u7684 IFrame","creditCard.encryptedExpiryMonth.aria.label":"\u5230\u671f\u6708\u4efd\u6b04\u4f4d","creditCard.encryptedExpiryYear.aria.iframeTitle":"\u5b89\u5168\u5361\u5230\u671f\u5e74\u4efd\u7684 IFrame","creditCard.encryptedExpiryYear.aria.label":"\u5230\u671f\u5e74\u4efd\u6b04\u4f4d","creditCard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u5361\u5b89\u5168\u78bc\u7684 IFrame","creditCard.encryptedSecurityCode.aria.label":"\u5b89\u5168\u78bc\u6b04\u4f4d","giftcard.encryptedCardNumber.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u865f\u7684 IFrame","giftcard.encryptedCardNumber.aria.label":"\u79ae\u54c1\u5361\u865f\u6b04\u4f4d","giftcard.encryptedSecurityCode.aria.iframeTitle":"\u5b89\u5168\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u7684 IFrame","giftcard.encryptedSecurityCode.aria.label":"\u79ae\u54c1\u5361\u5b89\u5168\u78bc\u6b04\u4f4d",giftcardTransactionLimit:"\u6b64\u79ae\u54c1\u5361\u6bcf\u7b46\u4ea4\u6613\u7684\u91d1\u984d\u4e0a\u9650\u70ba %{amount}","ach.encryptedBankAccountNumber.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u5e33\u6236\u865f\u78bc\u7684 IFrame","ach.encryptedBankAccountNumber.aria.label":"\u9280\u884c\u5e33\u6236\u6b04\u4f4d","ach.encryptedBankLocationId.aria.iframeTitle":"\u5b89\u5168\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u7684 IFrame","ach.encryptedBankLocationId.aria.label":"\u9280\u884c\u532f\u6b3e\u8def\u5f91\u7de8\u865f\u6b04\u4f4d","twint.saved":"\u5132\u5b58\u7684"}});return _k}));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],2:[function(require,module,exports){
(function (global,setImmediate){(function (){
/*! @vimeo/player v2.20.1 | (c) 2023 Vimeo | MIT License | https://github.com/vimeo/player.js */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global.Vimeo = global.Vimeo || {}, global.Vimeo.Player = factory()));
}(this, (function () { 'use strict';

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      enumerableOnly && (symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      })), keys.push.apply(keys, symbols);
    }
    return keys;
  }
  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = null != arguments[i] ? arguments[i] : {};
      i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
    return target;
  }
  function _regeneratorRuntime() {
    _regeneratorRuntime = function () {
      return exports;
    };
    var exports = {},
      Op = Object.prototype,
      hasOwn = Op.hasOwnProperty,
      defineProperty = Object.defineProperty || function (obj, key, desc) {
        obj[key] = desc.value;
      },
      $Symbol = "function" == typeof Symbol ? Symbol : {},
      iteratorSymbol = $Symbol.iterator || "@@iterator",
      asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
      toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
      return Object.defineProperty(obj, key, {
        value: value,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }), obj[key];
    }
    try {
      define({}, "");
    } catch (err) {
      define = function (obj, key, value) {
        return obj[key] = value;
      };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
      var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
        generator = Object.create(protoGenerator.prototype),
        context = new Context(tryLocsList || []);
      return defineProperty(generator, "_invoke", {
        value: makeInvokeMethod(innerFn, self, context)
      }), generator;
    }
    function tryCatch(fn, obj, arg) {
      try {
        return {
          type: "normal",
          arg: fn.call(obj, arg)
        };
      } catch (err) {
        return {
          type: "throw",
          arg: err
        };
      }
    }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () {
      return this;
    });
    var getProto = Object.getPrototypeOf,
      NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) {
      ["next", "throw", "return"].forEach(function (method) {
        define(prototype, method, function (arg) {
          return this._invoke(method, arg);
        });
      });
    }
    function AsyncIterator(generator, PromiseImpl) {
      function invoke(method, arg, resolve, reject) {
        var record = tryCatch(generator[method], generator, arg);
        if ("throw" !== record.type) {
          var result = record.arg,
            value = result.value;
          return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
            invoke("next", value, resolve, reject);
          }, function (err) {
            invoke("throw", err, resolve, reject);
          }) : PromiseImpl.resolve(value).then(function (unwrapped) {
            result.value = unwrapped, resolve(result);
          }, function (error) {
            return invoke("throw", error, resolve, reject);
          });
        }
        reject(record.arg);
      }
      var previousPromise;
      defineProperty(this, "_invoke", {
        value: function (method, arg) {
          function callInvokeWithMethodAndArg() {
            return new PromiseImpl(function (resolve, reject) {
              invoke(method, arg, resolve, reject);
            });
          }
          return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(innerFn, self, context) {
      var state = "suspendedStart";
      return function (method, arg) {
        if ("executing" === state) throw new Error("Generator is already running");
        if ("completed" === state) {
          if ("throw" === method) throw arg;
          return doneResult();
        }
        for (context.method = method, context.arg = arg;;) {
          var delegate = context.delegate;
          if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
              if (delegateResult === ContinueSentinel) continue;
              return delegateResult;
            }
          }
          if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
            if ("suspendedStart" === state) throw state = "completed", context.arg;
            context.dispatchException(context.arg);
          } else "return" === context.method && context.abrupt("return", context.arg);
          state = "executing";
          var record = tryCatch(innerFn, self, context);
          if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
            return {
              value: record.arg,
              done: context.done
            };
          }
          "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
        }
      };
    }
    function maybeInvokeDelegate(delegate, context) {
      var methodName = context.method,
        method = delegate.iterator[methodName];
      if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
      var record = tryCatch(method, delegate.iterator, context.arg);
      if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
      var info = record.arg;
      return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
    }
    function pushTryEntry(locs) {
      var entry = {
        tryLoc: locs[0]
      };
      1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
      var record = entry.completion || {};
      record.type = "normal", delete record.arg, entry.completion = record;
    }
    function Context(tryLocsList) {
      this.tryEntries = [{
        tryLoc: "root"
      }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(iterable) {
      if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod) return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next) return iterable;
        if (!isNaN(iterable.length)) {
          var i = -1,
            next = function next() {
              for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
              return next.value = undefined, next.done = !0, next;
            };
          return next.next = next;
        }
      }
      return {
        next: doneResult
      };
    }
    function doneResult() {
      return {
        value: undefined,
        done: !0
      };
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: !0
    }), defineProperty(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
      var ctor = "function" == typeof genFun && genFun.constructor;
      return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
    }, exports.mark = function (genFun) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
    }, exports.awrap = function (arg) {
      return {
        __await: arg
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
      return this;
    }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
      void 0 === PromiseImpl && (PromiseImpl = Promise);
      var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
      return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
        return result.done ? result.value : iter.next();
      });
    }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
      return this;
    }), define(Gp, "toString", function () {
      return "[object Generator]";
    }), exports.keys = function (val) {
      var object = Object(val),
        keys = [];
      for (var key in object) keys.push(key);
      return keys.reverse(), function next() {
        for (; keys.length;) {
          var key = keys.pop();
          if (key in object) return next.value = key, next.done = !1, next;
        }
        return next.done = !0, next;
      };
    }, exports.values = values, Context.prototype = {
      constructor: Context,
      reset: function (skipTempReset) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
      },
      stop: function () {
        this.done = !0;
        var rootRecord = this.tryEntries[0].completion;
        if ("throw" === rootRecord.type) throw rootRecord.arg;
        return this.rval;
      },
      dispatchException: function (exception) {
        if (this.done) throw exception;
        var context = this;
        function handle(loc, caught) {
          return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
        }
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i],
            record = entry.completion;
          if ("root" === entry.tryLoc) return handle("end");
          if (entry.tryLoc <= this.prev) {
            var hasCatch = hasOwn.call(entry, "catchLoc"),
              hasFinally = hasOwn.call(entry, "finallyLoc");
            if (hasCatch && hasFinally) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            } else if (hasCatch) {
              if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            } else {
              if (!hasFinally) throw new Error("try statement without catch or finally");
              if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
            }
          }
        }
      },
      abrupt: function (type, arg) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
            var finallyEntry = entry;
            break;
          }
        }
        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
        var record = finallyEntry ? finallyEntry.completion : {};
        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
      },
      complete: function (record, afterLoc) {
        if ("throw" === record.type) throw record.arg;
        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
      },
      finish: function (finallyLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        }
      },
      catch: function (tryLoc) {
        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
          var entry = this.tryEntries[i];
          if (entry.tryLoc === tryLoc) {
            var record = entry.completion;
            if ("throw" === record.type) {
              var thrown = record.arg;
              resetTryEntry(entry);
            }
            return thrown;
          }
        }
        throw new Error("illegal catch attempt");
      },
      delegateYield: function (iterable, resultName, nextLoc) {
        return this.delegate = {
          iterator: values(iterable),
          resultName: resultName,
          nextLoc: nextLoc
        }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
      }
    }, exports;
  }
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
        args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(undefined);
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    Object.defineProperty(subClass, "prototype", {
      writable: false
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }
  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }
  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };
    return _setPrototypeOf(o, p);
  }
  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }
  function _construct(Parent, args, Class) {
    if (_isNativeReflectConstruct()) {
      _construct = Reflect.construct.bind();
    } else {
      _construct = function _construct(Parent, args, Class) {
        var a = [null];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) _setPrototypeOf(instance, Class.prototype);
        return instance;
      };
    }
    return _construct.apply(null, arguments);
  }
  function _isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
  }
  function _wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrapNativeSuper = function _wrapNativeSuper(Class) {
      if (Class === null || !_isNativeFunction(Class)) return Class;
      if (typeof Class !== "function") {
        throw new TypeError("Super expression must either be null or a function");
      }
      if (typeof _cache !== "undefined") {
        if (_cache.has(Class)) return _cache.get(Class);
        _cache.set(Class, Wrapper);
      }
      function Wrapper() {
        return _construct(Class, arguments, _getPrototypeOf(this).constructor);
      }
      Wrapper.prototype = Object.create(Class.prototype, {
        constructor: {
          value: Wrapper,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      return _setPrototypeOf(Wrapper, Class);
    };
    return _wrapNativeSuper(Class);
  }
  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
  }
  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    } else if (call !== void 0) {
      throw new TypeError("Derived constructors may only return object or undefined");
    }
    return _assertThisInitialized(self);
  }
  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
        result;
      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;
        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }
      return _possibleConstructorReturn(this, result);
    };
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }

  /**
   * @module lib/functions
   */

  /**
   * Check to see this is a node environment.
   * @type {Boolean}
   */
  /* global global */
  var isNode = typeof global !== 'undefined' && {}.toString.call(global) === '[object global]';

  /**
   * Get the name of the method for a given getter or setter.
   *
   * @param {string} prop The name of the property.
   * @param {string} type Either “get” or “set”.
   * @return {string}
   */
  function getMethodName(prop, type) {
    if (prop.indexOf(type.toLowerCase()) === 0) {
      return prop;
    }
    return "".concat(type.toLowerCase()).concat(prop.substr(0, 1).toUpperCase()).concat(prop.substr(1));
  }

  /**
   * Check to see if the object is a DOM Element.
   *
   * @param {*} element The object to check.
   * @return {boolean}
   */
  function isDomElement(element) {
    return Boolean(element && element.nodeType === 1 && 'nodeName' in element && element.ownerDocument && element.ownerDocument.defaultView);
  }

  /**
   * Check to see whether the value is a number.
   *
   * @see http://dl.dropboxusercontent.com/u/35146/js/tests/isNumber.html
   * @param {*} value The value to check.
   * @param {boolean} integer Check if the value is an integer.
   * @return {boolean}
   */
  function isInteger(value) {
    // eslint-disable-next-line eqeqeq
    return !isNaN(parseFloat(value)) && isFinite(value) && Math.floor(value) == value;
  }

  /**
   * Check to see if the URL is a Vimeo url.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */
  function isVimeoUrl(url) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(url);
  }

  /**
   * Check to see if the URL is for a Vimeo embed.
   *
   * @param {string} url The url string.
   * @return {boolean}
   */
  function isVimeoEmbed(url) {
    var expr = /^https:\/\/player\.vimeo\.com\/video\/\d+/;
    return expr.test(url);
  }

  /**
   * Get the Vimeo URL from an element.
   * The element must have either a data-vimeo-id or data-vimeo-url attribute.
   *
   * @param {object} oEmbedParameters The oEmbed parameters.
   * @return {string}
   */
  function getVimeoUrl() {
    var oEmbedParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var id = oEmbedParameters.id;
    var url = oEmbedParameters.url;
    var idOrUrl = id || url;
    if (!idOrUrl) {
      throw new Error('An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.');
    }
    if (isInteger(idOrUrl)) {
      return "https://vimeo.com/".concat(idOrUrl);
    }
    if (isVimeoUrl(idOrUrl)) {
      return idOrUrl.replace('http:', 'https:');
    }
    if (id) {
      throw new TypeError("\u201C".concat(id, "\u201D is not a valid video id."));
    }
    throw new TypeError("\u201C".concat(idOrUrl, "\u201D is not a vimeo.com url."));
  }

  /* eslint-disable max-params */
  /**
   * A utility method for attaching and detaching event handlers
   *
   * @param {EventTarget} target
   * @param {string | string[]} eventName
   * @param {function} callback
   * @param {'addEventListener' | 'on'} onName
   * @param {'removeEventListener' | 'off'} offName
   * @return {{cancel: (function(): void)}}
   */
  var subscribe = function subscribe(target, eventName, callback) {
    var onName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'addEventListener';
    var offName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'removeEventListener';
    var eventNames = typeof eventName === 'string' ? [eventName] : eventName;
    eventNames.forEach(function (evName) {
      target[onName](evName, callback);
    });
    return {
      cancel: function cancel() {
        return eventNames.forEach(function (evName) {
          return target[offName](evName, callback);
        });
      }
    };
  };

  var arrayIndexOfSupport = typeof Array.prototype.indexOf !== 'undefined';
  var postMessageSupport = typeof window !== 'undefined' && typeof window.postMessage !== 'undefined';
  if (!isNode && (!arrayIndexOfSupport || !postMessageSupport)) {
    throw new Error('Sorry, the Vimeo Player API is not available in this browser.');
  }

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /*!
   * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
   * https://github.com/polygonplanet/weakmap-polyfill
   * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
   * @license MIT
   */

  (function (self) {

    if (self.WeakMap) {
      return;
    }
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    var hasDefine = Object.defineProperty && function () {
      try {
        // Avoid IE8's broken Object.defineProperty
        return Object.defineProperty({}, 'x', {
          value: 1
        }).x === 1;
      } catch (e) {}
    }();
    var defineProperty = function (object, name, value) {
      if (hasDefine) {
        Object.defineProperty(object, name, {
          configurable: true,
          writable: true,
          value: value
        });
      } else {
        object[name] = value;
      }
    };
    self.WeakMap = function () {
      // ECMA-262 23.3 WeakMap Objects
      function WeakMap() {
        if (this === void 0) {
          throw new TypeError("Constructor WeakMap requires 'new'");
        }
        defineProperty(this, '_id', genId('_WeakMap'));

        // ECMA-262 23.3.1.1 WeakMap([iterable])
        if (arguments.length > 0) {
          // Currently, WeakMap `iterable` argument is not supported
          throw new TypeError('WeakMap iterable is not supported');
        }
      }

      // ECMA-262 23.3.3.2 WeakMap.prototype.delete(key)
      defineProperty(WeakMap.prototype, 'delete', function (key) {
        checkInstance(this, 'delete');
        if (!isObject(key)) {
          return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          delete key[this._id];
          return true;
        }
        return false;
      });

      // ECMA-262 23.3.3.3 WeakMap.prototype.get(key)
      defineProperty(WeakMap.prototype, 'get', function (key) {
        checkInstance(this, 'get');
        if (!isObject(key)) {
          return void 0;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          return entry[1];
        }
        return void 0;
      });

      // ECMA-262 23.3.3.4 WeakMap.prototype.has(key)
      defineProperty(WeakMap.prototype, 'has', function (key) {
        checkInstance(this, 'has');
        if (!isObject(key)) {
          return false;
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          return true;
        }
        return false;
      });

      // ECMA-262 23.3.3.5 WeakMap.prototype.set(key, value)
      defineProperty(WeakMap.prototype, 'set', function (key, value) {
        checkInstance(this, 'set');
        if (!isObject(key)) {
          throw new TypeError('Invalid value used as weak map key');
        }
        var entry = key[this._id];
        if (entry && entry[0] === key) {
          entry[1] = value;
          return this;
        }
        defineProperty(key, this._id, [key, value]);
        return this;
      });
      function checkInstance(x, methodName) {
        if (!isObject(x) || !hasOwnProperty.call(x, '_id')) {
          throw new TypeError(methodName + ' method called on incompatible receiver ' + typeof x);
        }
      }
      function genId(prefix) {
        return prefix + '_' + rand() + '.' + rand();
      }
      function rand() {
        return Math.random().toString().substring(2);
      }
      defineProperty(WeakMap, '_polyfill', true);
      return WeakMap;
    }();
    function isObject(x) {
      return Object(x) === x;
    }
  })(typeof globalThis !== 'undefined' ? globalThis : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : commonjsGlobal);

  var npo_src = createCommonjsModule(function (module) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */

  (function UMD(name, context, definition) {
    // special form of UMD for polyfilling across evironments
    context[name] = context[name] || definition();
    if ( module.exports) {
      module.exports = context[name];
    }
  })("Promise", typeof commonjsGlobal != "undefined" ? commonjsGlobal : commonjsGlobal, function DEF() {

    var builtInProp,
      cycle,
      scheduling_queue,
      ToString = Object.prototype.toString,
      timer = typeof setImmediate != "undefined" ? function timer(fn) {
        return setImmediate(fn);
      } : setTimeout;

    // dammit, IE8.
    try {
      Object.defineProperty({}, "x", {});
      builtInProp = function builtInProp(obj, name, val, config) {
        return Object.defineProperty(obj, name, {
          value: val,
          writable: true,
          configurable: config !== false
        });
      };
    } catch (err) {
      builtInProp = function builtInProp(obj, name, val) {
        obj[name] = val;
        return obj;
      };
    }

    // Note: using a queue instead of array for efficiency
    scheduling_queue = function Queue() {
      var first, last, item;
      function Item(fn, self) {
        this.fn = fn;
        this.self = self;
        this.next = void 0;
      }
      return {
        add: function add(fn, self) {
          item = new Item(fn, self);
          if (last) {
            last.next = item;
          } else {
            first = item;
          }
          last = item;
          item = void 0;
        },
        drain: function drain() {
          var f = first;
          first = last = cycle = void 0;
          while (f) {
            f.fn.call(f.self);
            f = f.next;
          }
        }
      };
    }();
    function schedule(fn, self) {
      scheduling_queue.add(fn, self);
      if (!cycle) {
        cycle = timer(scheduling_queue.drain);
      }
    }

    // promise duck typing
    function isThenable(o) {
      var _then,
        o_type = typeof o;
      if (o != null && (o_type == "object" || o_type == "function")) {
        _then = o.then;
      }
      return typeof _then == "function" ? _then : false;
    }
    function notify() {
      for (var i = 0; i < this.chain.length; i++) {
        notifyIsolated(this, this.state === 1 ? this.chain[i].success : this.chain[i].failure, this.chain[i]);
      }
      this.chain.length = 0;
    }

    // NOTE: This is a separate function to isolate
    // the `try..catch` so that other code can be
    // optimized better
    function notifyIsolated(self, cb, chain) {
      var ret, _then;
      try {
        if (cb === false) {
          chain.reject(self.msg);
        } else {
          if (cb === true) {
            ret = self.msg;
          } else {
            ret = cb.call(void 0, self.msg);
          }
          if (ret === chain.promise) {
            chain.reject(TypeError("Promise-chain cycle"));
          } else if (_then = isThenable(ret)) {
            _then.call(ret, chain.resolve, chain.reject);
          } else {
            chain.resolve(ret);
          }
        }
      } catch (err) {
        chain.reject(err);
      }
    }
    function resolve(msg) {
      var _then,
        self = this;

      // already triggered?
      if (self.triggered) {
        return;
      }
      self.triggered = true;

      // unwrap
      if (self.def) {
        self = self.def;
      }
      try {
        if (_then = isThenable(msg)) {
          schedule(function () {
            var def_wrapper = new MakeDefWrapper(self);
            try {
              _then.call(msg, function $resolve$() {
                resolve.apply(def_wrapper, arguments);
              }, function $reject$() {
                reject.apply(def_wrapper, arguments);
              });
            } catch (err) {
              reject.call(def_wrapper, err);
            }
          });
        } else {
          self.msg = msg;
          self.state = 1;
          if (self.chain.length > 0) {
            schedule(notify, self);
          }
        }
      } catch (err) {
        reject.call(new MakeDefWrapper(self), err);
      }
    }
    function reject(msg) {
      var self = this;

      // already triggered?
      if (self.triggered) {
        return;
      }
      self.triggered = true;

      // unwrap
      if (self.def) {
        self = self.def;
      }
      self.msg = msg;
      self.state = 2;
      if (self.chain.length > 0) {
        schedule(notify, self);
      }
    }
    function iteratePromises(Constructor, arr, resolver, rejecter) {
      for (var idx = 0; idx < arr.length; idx++) {
        (function IIFE(idx) {
          Constructor.resolve(arr[idx]).then(function $resolver$(msg) {
            resolver(idx, msg);
          }, rejecter);
        })(idx);
      }
    }
    function MakeDefWrapper(self) {
      this.def = self;
      this.triggered = false;
    }
    function MakeDef(self) {
      this.promise = self;
      this.state = 0;
      this.triggered = false;
      this.chain = [];
      this.msg = void 0;
    }
    function Promise(executor) {
      if (typeof executor != "function") {
        throw TypeError("Not a function");
      }
      if (this.__NPO__ !== 0) {
        throw TypeError("Not a promise");
      }

      // instance shadowing the inherited "brand"
      // to signal an already "initialized" promise
      this.__NPO__ = 1;
      var def = new MakeDef(this);
      this["then"] = function then(success, failure) {
        var o = {
          success: typeof success == "function" ? success : true,
          failure: typeof failure == "function" ? failure : false
        };
        // Note: `then(..)` itself can be borrowed to be used against
        // a different promise constructor for making the chained promise,
        // by substituting a different `this` binding.
        o.promise = new this.constructor(function extractChain(resolve, reject) {
          if (typeof resolve != "function" || typeof reject != "function") {
            throw TypeError("Not a function");
          }
          o.resolve = resolve;
          o.reject = reject;
        });
        def.chain.push(o);
        if (def.state !== 0) {
          schedule(notify, def);
        }
        return o.promise;
      };
      this["catch"] = function $catch$(failure) {
        return this.then(void 0, failure);
      };
      try {
        executor.call(void 0, function publicResolve(msg) {
          resolve.call(def, msg);
        }, function publicReject(msg) {
          reject.call(def, msg);
        });
      } catch (err) {
        reject.call(def, err);
      }
    }
    var PromisePrototype = builtInProp({}, "constructor", Promise, /*configurable=*/false);

    // Note: Android 4 cannot use `Object.defineProperty(..)` here
    Promise.prototype = PromisePrototype;

    // built-in "brand" to signal an "uninitialized" promise
    builtInProp(PromisePrototype, "__NPO__", 0, /*configurable=*/false);
    builtInProp(Promise, "resolve", function Promise$resolve(msg) {
      var Constructor = this;

      // spec mandated checks
      // note: best "isPromise" check that's practical for now
      if (msg && typeof msg == "object" && msg.__NPO__ === 1) {
        return msg;
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        resolve(msg);
      });
    });
    builtInProp(Promise, "reject", function Promise$reject(msg) {
      return new this(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        reject(msg);
      });
    });
    builtInProp(Promise, "all", function Promise$all(arr) {
      var Constructor = this;

      // spec mandated checks
      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }
      if (arr.length === 0) {
        return Constructor.resolve([]);
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        var len = arr.length,
          msgs = Array(len),
          count = 0;
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          msgs[idx] = msg;
          if (++count === len) {
            resolve(msgs);
          }
        }, reject);
      });
    });
    builtInProp(Promise, "race", function Promise$race(arr) {
      var Constructor = this;

      // spec mandated checks
      if (ToString.call(arr) != "[object Array]") {
        return Constructor.reject(TypeError("Not an array"));
      }
      return new Constructor(function executor(resolve, reject) {
        if (typeof resolve != "function" || typeof reject != "function") {
          throw TypeError("Not a function");
        }
        iteratePromises(Constructor, arr, function resolver(idx, msg) {
          resolve(msg);
        }, reject);
      });
    });
    return Promise;
  });
  });

  /**
   * @module lib/callbacks
   */

  var callbackMap = new WeakMap();

  /**
   * Store a callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @param {(function(this:Player, *): void|{resolve: function, reject: function})} callback
   *        The callback to call or an object with resolve and reject functions for a promise.
   * @return {void}
   */
  function storeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    if (!(name in playerCallbacks)) {
      playerCallbacks[name] = [];
    }
    playerCallbacks[name].push(callback);
    callbackMap.set(player.element, playerCallbacks);
  }

  /**
   * Get the callbacks for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @return {function[]}
   */
  function getCallbacks(player, name) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    return playerCallbacks[name] || [];
  }

  /**
   * Remove a stored callback for a method or event for a player.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name
   * @param {function} [callback] The specific callback to remove.
   * @return {boolean} Was this the last callback?
   */
  function removeCallback(player, name, callback) {
    var playerCallbacks = callbackMap.get(player.element) || {};
    if (!playerCallbacks[name]) {
      return true;
    }

    // If no callback is passed, remove all callbacks for the event
    if (!callback) {
      playerCallbacks[name] = [];
      callbackMap.set(player.element, playerCallbacks);
      return true;
    }
    var index = playerCallbacks[name].indexOf(callback);
    if (index !== -1) {
      playerCallbacks[name].splice(index, 1);
    }
    callbackMap.set(player.element, playerCallbacks);
    return playerCallbacks[name] && playerCallbacks[name].length === 0;
  }

  /**
   * Return the first stored callback for a player and event or method.
   *
   * @param {Player} player The player object.
   * @param {string} name The method or event name.
   * @return {function} The callback, or false if there were none
   */
  function shiftCallbacks(player, name) {
    var playerCallbacks = getCallbacks(player, name);
    if (playerCallbacks.length < 1) {
      return false;
    }
    var callback = playerCallbacks.shift();
    removeCallback(player, name, callback);
    return callback;
  }

  /**
   * Move callbacks associated with an element to another element.
   *
   * @param {HTMLElement} oldElement The old element.
   * @param {HTMLElement} newElement The new element.
   * @return {void}
   */
  function swapCallbacks(oldElement, newElement) {
    var playerCallbacks = callbackMap.get(oldElement);
    callbackMap.set(newElement, playerCallbacks);
    callbackMap.delete(oldElement);
  }

  /**
   * @module lib/postmessage
   */

  /**
   * Parse a message received from postMessage.
   *
   * @param {*} data The data received from postMessage.
   * @return {object}
   */
  function parseMessageData(data) {
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (error) {
        // If the message cannot be parsed, throw the error as a warning
        console.warn(error);
        return {};
      }
    }
    return data;
  }

  /**
   * Post a message to the specified target.
   *
   * @param {Player} player The player object to use.
   * @param {string} method The API method to call.
   * @param {object} params The parameters to send to the player.
   * @return {void}
   */
  function postMessage(player, method, params) {
    if (!player.element.contentWindow || !player.element.contentWindow.postMessage) {
      return;
    }
    var message = {
      method: method
    };
    if (params !== undefined) {
      message.value = params;
    }

    // IE 8 and 9 do not support passing messages, so stringify them
    var ieVersion = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, '$1'));
    if (ieVersion >= 8 && ieVersion < 10) {
      message = JSON.stringify(message);
    }
    player.element.contentWindow.postMessage(message, player.origin);
  }

  /**
   * Parse the data received from a message event.
   *
   * @param {Player} player The player that received the message.
   * @param {(Object|string)} data The message data. Strings will be parsed into JSON.
   * @return {void}
   */
  function processData(player, data) {
    data = parseMessageData(data);
    var callbacks = [];
    var param;
    if (data.event) {
      if (data.event === 'error') {
        var promises = getCallbacks(player, data.data.method);
        promises.forEach(function (promise) {
          var error = new Error(data.data.message);
          error.name = data.data.name;
          promise.reject(error);
          removeCallback(player, data.data.method, promise);
        });
      }
      callbacks = getCallbacks(player, "event:".concat(data.event));
      param = data.data;
    } else if (data.method) {
      var callback = shiftCallbacks(player, data.method);
      if (callback) {
        callbacks.push(callback);
        param = data.value;
      }
    }
    callbacks.forEach(function (callback) {
      try {
        if (typeof callback === 'function') {
          callback.call(player, param);
          return;
        }
        callback.resolve(param);
      } catch (e) {
        // empty
      }
    });
  }

  /**
   * @module lib/embed
   */
  var oEmbedParameters = ['autopause', 'autoplay', 'background', 'byline', 'color', 'colors', 'controls', 'dnt', 'height', 'id', 'interactive_params', 'keyboard', 'loop', 'maxheight', 'maxwidth', 'muted', 'playsinline', 'portrait', 'responsive', 'speed', 'texttrack', 'title', 'transparent', 'url', 'width'];

  /**
   * Get the 'data-vimeo'-prefixed attributes from an element as an object.
   *
   * @param {HTMLElement} element The element.
   * @param {Object} [defaults={}] The default values to use.
   * @return {Object<string, string>}
   */
  function getOEmbedParameters(element) {
    var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return oEmbedParameters.reduce(function (params, param) {
      var value = element.getAttribute("data-vimeo-".concat(param));
      if (value || value === '') {
        params[param] = value === '' ? 1 : value;
      }
      return params;
    }, defaults);
  }

  /**
   * Create an embed from oEmbed data inside an element.
   *
   * @param {object} data The oEmbed data.
   * @param {HTMLElement} element The element to put the iframe in.
   * @return {HTMLIFrameElement} The iframe embed.
   */
  function createEmbed(_ref, element) {
    var html = _ref.html;
    if (!element) {
      throw new TypeError('An element must be provided');
    }
    if (element.getAttribute('data-vimeo-initialized') !== null) {
      return element.querySelector('iframe');
    }
    var div = document.createElement('div');
    div.innerHTML = html;
    element.appendChild(div.firstChild);
    element.setAttribute('data-vimeo-initialized', 'true');
    return element.querySelector('iframe');
  }

  /**
   * Make an oEmbed call for the specified URL.
   *
   * @param {string} videoUrl The vimeo.com url for the video.
   * @param {Object} [params] Parameters to pass to oEmbed.
   * @param {HTMLElement} element The element.
   * @return {Promise}
   */
  function getOEmbedData(videoUrl) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;
    return new Promise(function (resolve, reject) {
      if (!isVimeoUrl(videoUrl)) {
        throw new TypeError("\u201C".concat(videoUrl, "\u201D is not a vimeo.com url."));
      }
      var url = "https://vimeo.com/api/oembed.json?url=".concat(encodeURIComponent(videoUrl));
      for (var param in params) {
        if (params.hasOwnProperty(param)) {
          url += "&".concat(param, "=").concat(encodeURIComponent(params[param]));
        }
      }
      var xhr = 'XDomainRequest' in window ? new XDomainRequest() : new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.onload = function () {
        if (xhr.status === 404) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D was not found.")));
          return;
        }
        if (xhr.status === 403) {
          reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
          return;
        }
        try {
          var json = JSON.parse(xhr.responseText);
          // Check api response for 403 on oembed
          if (json.domain_status_code === 403) {
            // We still want to create the embed to give users visual feedback
            createEmbed(json, element);
            reject(new Error("\u201C".concat(videoUrl, "\u201D is not embeddable.")));
            return;
          }
          resolve(json);
        } catch (error) {
          reject(error);
        }
      };
      xhr.onerror = function () {
        var status = xhr.status ? " (".concat(xhr.status, ")") : '';
        reject(new Error("There was an error fetching the embed code from Vimeo".concat(status, ".")));
      };
      xhr.send();
    });
  }

  /**
   * Initialize all embeds within a specific element
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function initializeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    var elements = [].slice.call(parent.querySelectorAll('[data-vimeo-id], [data-vimeo-url]'));
    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error creating an embed: ".concat(error));
      }
    };
    elements.forEach(function (element) {
      try {
        // Skip any that have data-vimeo-defer
        if (element.getAttribute('data-vimeo-defer') !== null) {
          return;
        }
        var params = getOEmbedParameters(element);
        var url = getVimeoUrl(params);
        getOEmbedData(url, params, element).then(function (data) {
          return createEmbed(data, element);
        }).catch(handleError);
      } catch (error) {
        handleError(error);
      }
    });
  }

  /**
   * Resize embeds when messaged by the player.
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function resizeEmbeds() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    // Prevent execution if users include the player.js script multiple times.
    if (window.VimeoPlayerResizeEmbeds_) {
      return;
    }
    window.VimeoPlayerResizeEmbeds_ = true;
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }

      // 'spacechange' is fired only on embeds with cards
      if (!event.data || event.data.event !== 'spacechange') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        if (iframes[i].contentWindow !== event.source) {
          continue;
        }

        // Change padding-bottom of the enclosing div to accommodate
        // card carousel without distorting aspect ratio
        var space = iframes[i].parentElement;
        space.style.paddingBottom = "".concat(event.data.data[0].bottom, "px");
        break;
      }
    };
    window.addEventListener('message', onMessage);
  }

  /**
   * Add chapters to existing metadata for Google SEO
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function initAppendVideoMetadata() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoSeoMetadataAppended) {
      return;
    }
    window.VimeoSeoMetadataAppended = true;
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }
      var data = parseMessageData(event.data);
      if (!data || data.event !== 'ready') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      for (var i = 0; i < iframes.length; i++) {
        var iframe = iframes[i];

        // Initiate appendVideoMetadata if iframe is a Vimeo embed
        var isValidMessageSource = iframe.contentWindow === event.source;
        if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
          var player = new Player(iframe);
          player.callMethod('appendVideoMetadata', window.location.href);
        }
      }
    };
    window.addEventListener('message', onMessage);
  }

  /**
   * Seek to time indicated by vimeo_t query parameter if present in URL
   *
   * @param {HTMLElement} [parent=document] The parent element.
   * @return {void}
   */
  function checkUrlTimeParam() {
    var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    //  Prevent execution if users include the player.js script multiple times.
    if (window.VimeoCheckedUrlTimeParam) {
      return;
    }
    window.VimeoCheckedUrlTimeParam = true;
    var handleError = function handleError(error) {
      if ('console' in window && console.error) {
        console.error("There was an error getting video Id: ".concat(error));
      }
    };
    var onMessage = function onMessage(event) {
      if (!isVimeoUrl(event.origin)) {
        return;
      }
      var data = parseMessageData(event.data);
      if (!data || data.event !== 'ready') {
        return;
      }
      var iframes = parent.querySelectorAll('iframe');
      var _loop = function _loop() {
        var iframe = iframes[i];
        var isValidMessageSource = iframe.contentWindow === event.source;
        if (isVimeoEmbed(iframe.src) && isValidMessageSource) {
          var player = new Player(iframe);
          player.getVideoId().then(function (videoId) {
            var matches = new RegExp("[?&]vimeo_t_".concat(videoId, "=([^&#]*)")).exec(window.location.href);
            if (matches && matches[1]) {
              var sec = decodeURI(matches[1]);
              player.setCurrentTime(sec);
            }
            return;
          }).catch(handleError);
        }
      };
      for (var i = 0; i < iframes.length; i++) {
        _loop();
      }
    };
    window.addEventListener('message', onMessage);
  }

  /* MIT License

  Copyright (c) Sindre Sorhus <sindresorhus@gmail.com> (sindresorhus.com)

  Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
  Terms */

  function initializeScreenfull() {
    var fn = function () {
      var val;
      var fnMap = [['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
      // New WebKit
      ['webkitRequestFullscreen', 'webkitExitFullscreen', 'webkitFullscreenElement', 'webkitFullscreenEnabled', 'webkitfullscreenchange', 'webkitfullscreenerror'],
      // Old WebKit
      ['webkitRequestFullScreen', 'webkitCancelFullScreen', 'webkitCurrentFullScreenElement', 'webkitCancelFullScreen', 'webkitfullscreenchange', 'webkitfullscreenerror'], ['mozRequestFullScreen', 'mozCancelFullScreen', 'mozFullScreenElement', 'mozFullScreenEnabled', 'mozfullscreenchange', 'mozfullscreenerror'], ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']];
      var i = 0;
      var l = fnMap.length;
      var ret = {};
      for (; i < l; i++) {
        val = fnMap[i];
        if (val && val[1] in document) {
          for (i = 0; i < val.length; i++) {
            ret[fnMap[0][i]] = val[i];
          }
          return ret;
        }
      }
      return false;
    }();
    var eventNameMap = {
      fullscreenchange: fn.fullscreenchange,
      fullscreenerror: fn.fullscreenerror
    };
    var screenfull = {
      request: function request(element) {
        return new Promise(function (resolve, reject) {
          var onFullScreenEntered = function onFullScreenEntered() {
            screenfull.off('fullscreenchange', onFullScreenEntered);
            resolve();
          };
          screenfull.on('fullscreenchange', onFullScreenEntered);
          element = element || document.documentElement;
          var returnPromise = element[fn.requestFullscreen]();
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenEntered).catch(reject);
          }
        });
      },
      exit: function exit() {
        return new Promise(function (resolve, reject) {
          if (!screenfull.isFullscreen) {
            resolve();
            return;
          }
          var onFullScreenExit = function onFullScreenExit() {
            screenfull.off('fullscreenchange', onFullScreenExit);
            resolve();
          };
          screenfull.on('fullscreenchange', onFullScreenExit);
          var returnPromise = document[fn.exitFullscreen]();
          if (returnPromise instanceof Promise) {
            returnPromise.then(onFullScreenExit).catch(reject);
          }
        });
      },
      on: function on(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document.addEventListener(eventName, callback);
        }
      },
      off: function off(event, callback) {
        var eventName = eventNameMap[event];
        if (eventName) {
          document.removeEventListener(eventName, callback);
        }
      }
    };
    Object.defineProperties(screenfull, {
      isFullscreen: {
        get: function get() {
          return Boolean(document[fn.fullscreenElement]);
        }
      },
      element: {
        enumerable: true,
        get: function get() {
          return document[fn.fullscreenElement];
        }
      },
      isEnabled: {
        enumerable: true,
        get: function get() {
          // Coerce to boolean in case of old WebKit
          return Boolean(document[fn.fullscreenEnabled]);
        }
      }
    });
    return screenfull;
  }

  /** @typedef {import('./timing-src-connector.types').PlayerControls} PlayerControls */
  /** @typedef {import('./timing-object.types').TimingObject} TimingObject */
  /** @typedef {import('./timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
  /** @typedef {(msg: string) => any} Logger */
  /** @typedef {import('timing-object.types').TConnectionState} TConnectionState */

  /**
   * @type {TimingSrcConnectorOptions}
   *
   * For details on these properties and their effects, see the typescript definition referenced above.
   */
  var defaultOptions = {
    role: 'viewer',
    autoPlayMuted: true,
    allowedDrift: 0.3,
    maxAllowedDrift: 1,
    minCheckInterval: 0.1,
    maxRateAdjustment: 0.2,
    maxTimeToCatchUp: 1
  };

  /**
   * There's a proposed W3C spec for the Timing Object which would introduce a new set of APIs that would simplify time-synchronization tasks for browser applications.
   *
   * Proposed spec: https://webtiming.github.io/timingobject/
   * V3 Spec: https://timingsrc.readthedocs.io/en/latest/
   * Demuxed talk: https://www.youtube.com/watch?v=cZSjDaGDmX8
   *
   * This class makes it easy to connect Vimeo.Player to a provided TimingObject via Vimeo.Player.setTimingSrc(myTimingObject, options) and the synchronization will be handled automatically.
   *
   * There are 5 general responsibilities in TimingSrcConnector:
   *
   * 1. `updatePlayer()` which sets the player's currentTime, playbackRate and pause/play state based on current state of the TimingObject.
   * 2. `updateTimingObject()` which sets the TimingObject's position and velocity from the player's state.
   * 3. `playerUpdater` which listens for change events on the TimingObject and will respond by calling updatePlayer.
   * 4. `timingObjectUpdater` which listens to the player events of seeked, play and pause and will respond by calling `updateTimingObject()`.
   * 5. `maintainPlaybackPosition` this is code that constantly monitors the player to make sure it's always in sync with the TimingObject. This is needed because videos will generally not play with precise time accuracy and there will be some drift which becomes more noticeable over longer periods (as noted in the timing-object spec). More details on this method below.
   */
  var TimingSrcConnector = /*#__PURE__*/function (_EventTarget) {
    _inherits(TimingSrcConnector, _EventTarget);
    var _super = _createSuper(TimingSrcConnector);
    /**
     * @param {PlayerControls} player
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     * @param {Logger} logger
     */
    function TimingSrcConnector(_player, timingObject) {
      var _this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var logger = arguments.length > 3 ? arguments[3] : undefined;
      _classCallCheck(this, TimingSrcConnector);
      _this = _super.call(this);
      _defineProperty(_assertThisInitialized(_this), "logger", void 0);
      _defineProperty(_assertThisInitialized(_this), "speedAdjustment", 0);
      /**
       * @param {PlayerControls} player
       * @param {number} newAdjustment
       * @return {Promise<void>}
       */
      _defineProperty(_assertThisInitialized(_this), "adjustSpeed", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(player, newAdjustment) {
          var newPlaybackRate;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.speedAdjustment === newAdjustment)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _context.next = 4;
                return player.getPlaybackRate();
              case 4:
                _context.t0 = _context.sent;
                _context.t1 = _this.speedAdjustment;
                _context.t2 = _context.t0 - _context.t1;
                _context.t3 = newAdjustment;
                newPlaybackRate = _context.t2 + _context.t3;
                _this.log("New playbackRate:  ".concat(newPlaybackRate));
                _context.next = 12;
                return player.setPlaybackRate(newPlaybackRate);
              case 12:
                _this.speedAdjustment = newAdjustment;
              case 13:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }());
      _this.logger = logger;
      _this.init(timingObject, _player, _objectSpread2(_objectSpread2({}, defaultOptions), options));
      return _this;
    }
    _createClass(TimingSrcConnector, [{
      key: "disconnect",
      value: function disconnect() {
        this.dispatchEvent(new Event('disconnect'));
      }

      /**
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {Promise<void>}
       */
    }, {
      key: "init",
      value: function () {
        var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(timingObject, player, options) {
          var _this2 = this;
          var playerUpdater, positionSync, timingObjectUpdater;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.waitForTOReadyState(timingObject, 'open');
              case 2:
                if (!(options.role === 'viewer')) {
                  _context2.next = 10;
                  break;
                }
                _context2.next = 5;
                return this.updatePlayer(timingObject, player, options);
              case 5:
                playerUpdater = subscribe(timingObject, 'change', function () {
                  return _this2.updatePlayer(timingObject, player, options);
                });
                positionSync = this.maintainPlaybackPosition(timingObject, player, options);
                this.addEventListener('disconnect', function () {
                  positionSync.cancel();
                  playerUpdater.cancel();
                });
                _context2.next = 14;
                break;
              case 10:
                _context2.next = 12;
                return this.updateTimingObject(timingObject, player);
              case 12:
                timingObjectUpdater = subscribe(player, ['seeked', 'play', 'pause', 'ratechange'], function () {
                  return _this2.updateTimingObject(timingObject, player);
                }, 'on', 'off');
                this.addEventListener('disconnect', function () {
                  return timingObjectUpdater.cancel();
                });
              case 14:
              case "end":
                return _context2.stop();
            }
          }, _callee2, this);
        }));
        function init(_x3, _x4, _x5) {
          return _init.apply(this, arguments);
        }
        return init;
      }()
      /**
       * Sets the TimingObject's state to reflect that of the player
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @return {Promise<void>}
       */
    }, {
      key: "updateTimingObject",
      value: function () {
        var _updateTimingObject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(timingObject, player) {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = timingObject;
                _context3.next = 3;
                return player.getCurrentTime();
              case 3:
                _context3.t1 = _context3.sent;
                _context3.next = 6;
                return player.getPaused();
              case 6:
                if (!_context3.sent) {
                  _context3.next = 10;
                  break;
                }
                _context3.t2 = 0;
                _context3.next = 13;
                break;
              case 10:
                _context3.next = 12;
                return player.getPlaybackRate();
              case 12:
                _context3.t2 = _context3.sent;
              case 13:
                _context3.t3 = _context3.t2;
                _context3.t4 = {
                  position: _context3.t1,
                  velocity: _context3.t3
                };
                _context3.t0.update.call(_context3.t0, _context3.t4);
              case 16:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        function updateTimingObject(_x6, _x7) {
          return _updateTimingObject.apply(this, arguments);
        }
        return updateTimingObject;
      }()
      /**
       * Sets the player's timing state to reflect that of the TimingObject
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {Promise<void>}
       */
    }, {
      key: "updatePlayer",
      value: function () {
        var _updatePlayer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(timingObject, player, options) {
          var _timingObject$query, position, velocity;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _timingObject$query = timingObject.query(), position = _timingObject$query.position, velocity = _timingObject$query.velocity;
                if (typeof position === 'number') {
                  player.setCurrentTime(position);
                }
                if (!(typeof velocity === 'number')) {
                  _context5.next = 25;
                  break;
                }
                if (!(velocity === 0)) {
                  _context5.next = 11;
                  break;
                }
                _context5.next = 6;
                return player.getPaused();
              case 6:
                _context5.t0 = _context5.sent;
                if (!(_context5.t0 === false)) {
                  _context5.next = 9;
                  break;
                }
                player.pause();
              case 9:
                _context5.next = 25;
                break;
              case 11:
                if (!(velocity > 0)) {
                  _context5.next = 25;
                  break;
                }
                _context5.next = 14;
                return player.getPaused();
              case 14:
                _context5.t1 = _context5.sent;
                if (!(_context5.t1 === true)) {
                  _context5.next = 19;
                  break;
                }
                _context5.next = 18;
                return player.play().catch( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(err) {
                    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(err.name === 'NotAllowedError' && options.autoPlayMuted)) {
                            _context4.next = 5;
                            break;
                          }
                          _context4.next = 3;
                          return player.setMuted(true);
                        case 3:
                          _context4.next = 5;
                          return player.play().catch(function (err2) {
                            return console.error('Couldn\'t play the video from TimingSrcConnector. Error:', err2);
                          });
                        case 5:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x11) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              case 18:
                this.updatePlayer(timingObject, player, options);
              case 19:
                _context5.next = 21;
                return player.getPlaybackRate();
              case 21:
                _context5.t2 = _context5.sent;
                _context5.t3 = velocity;
                if (!(_context5.t2 !== _context5.t3)) {
                  _context5.next = 25;
                  break;
                }
                player.setPlaybackRate(velocity);
              case 25:
              case "end":
                return _context5.stop();
            }
          }, _callee5, this);
        }));
        function updatePlayer(_x8, _x9, _x10) {
          return _updatePlayer.apply(this, arguments);
        }
        return updatePlayer;
      }()
      /**
       * Since video players do not play with 100% time precision, we need to closely monitor
       * our player to be sure it remains in sync with the TimingObject.
       *
       * If out of sync, we use the current conditions and the options provided to determine
       * whether to re-sync via setting currentTime or adjusting the playbackRate
       *
       * @param {TimingObject} timingObject
       * @param {PlayerControls} player
       * @param {TimingSrcConnectorOptions} options
       * @return {{cancel: (function(): void)}}
       */
    }, {
      key: "maintainPlaybackPosition",
      value: function maintainPlaybackPosition(timingObject, player, options) {
        var _this3 = this;
        var allowedDrift = options.allowedDrift,
          maxAllowedDrift = options.maxAllowedDrift,
          minCheckInterval = options.minCheckInterval,
          maxRateAdjustment = options.maxRateAdjustment,
          maxTimeToCatchUp = options.maxTimeToCatchUp;
        var syncInterval = Math.min(maxTimeToCatchUp, Math.max(minCheckInterval, maxAllowedDrift)) * 1000;
        var check = /*#__PURE__*/function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
            var diff, diffAbs, min, max, adjustment;
            return _regeneratorRuntime().wrap(function _callee6$(_context6) {
              while (1) switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.t0 = timingObject.query().velocity === 0;
                  if (_context6.t0) {
                    _context6.next = 6;
                    break;
                  }
                  _context6.next = 4;
                  return player.getPaused();
                case 4:
                  _context6.t1 = _context6.sent;
                  _context6.t0 = _context6.t1 === true;
                case 6:
                  if (!_context6.t0) {
                    _context6.next = 8;
                    break;
                  }
                  return _context6.abrupt("return");
                case 8:
                  _context6.t2 = timingObject.query().position;
                  _context6.next = 11;
                  return player.getCurrentTime();
                case 11:
                  _context6.t3 = _context6.sent;
                  diff = _context6.t2 - _context6.t3;
                  diffAbs = Math.abs(diff);
                  _this3.log("Drift: ".concat(diff));
                  if (!(diffAbs > maxAllowedDrift)) {
                    _context6.next = 22;
                    break;
                  }
                  _context6.next = 18;
                  return _this3.adjustSpeed(player, 0);
                case 18:
                  player.setCurrentTime(timingObject.query().position);
                  _this3.log('Resync by currentTime');
                  _context6.next = 29;
                  break;
                case 22:
                  if (!(diffAbs > allowedDrift)) {
                    _context6.next = 29;
                    break;
                  }
                  min = diffAbs / maxTimeToCatchUp;
                  max = maxRateAdjustment;
                  adjustment = min < max ? (max - min) / 2 : max;
                  _context6.next = 28;
                  return _this3.adjustSpeed(player, adjustment * Math.sign(diff));
                case 28:
                  _this3.log('Resync by playbackRate');
                case 29:
                case "end":
                  return _context6.stop();
              }
            }, _callee6);
          }));
          return function check() {
            return _ref3.apply(this, arguments);
          };
        }();
        var interval = setInterval(function () {
          return check();
        }, syncInterval);
        return {
          cancel: function cancel() {
            return clearInterval(interval);
          }
        };
      }

      /**
       * @param {string} msg
       */
    }, {
      key: "log",
      value: function log(msg) {
        var _this$logger;
        (_this$logger = this.logger) === null || _this$logger === void 0 ? void 0 : _this$logger.call(this, "TimingSrcConnector: ".concat(msg));
      }
    }, {
      key: "waitForTOReadyState",
      value:
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function waitForTOReadyState(timingObject, state) {
        return new Promise(function (resolve) {
          var check = function check() {
            if (timingObject.readyState === state) {
              resolve();
            } else {
              timingObject.addEventListener('readystatechange', check, {
                once: true
              });
            }
          };
          check();
        });
      }
    }]);
    return TimingSrcConnector;
  }( /*#__PURE__*/_wrapNativeSuper(EventTarget));

  var playerMap = new WeakMap();
  var readyMap = new WeakMap();
  var screenfull = {};
  var Player = /*#__PURE__*/function () {
    /**
     * Create a Player.
     *
     * @param {(HTMLIFrameElement|HTMLElement|string|jQuery)} element A reference to the Vimeo
     *        player iframe, and id, or a jQuery object.
     * @param {object} [options] oEmbed parameters to use when creating an embed in the element.
     * @return {Player}
     */
    function Player(element) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      _classCallCheck(this, Player);
      /* global jQuery */
      if (window.jQuery && element instanceof jQuery) {
        if (element.length > 1 && window.console && console.warn) {
          console.warn('A jQuery object with multiple elements was passed, using the first element.');
        }
        element = element[0];
      }

      // Find an element by ID
      if (typeof document !== 'undefined' && typeof element === 'string') {
        element = document.getElementById(element);
      }

      // Not an element!
      if (!isDomElement(element)) {
        throw new TypeError('You must pass either a valid element or a valid id.');
      }

      // Already initialized an embed in this div, so grab the iframe
      if (element.nodeName !== 'IFRAME') {
        var iframe = element.querySelector('iframe');
        if (iframe) {
          element = iframe;
        }
      }

      // iframe url is not a Vimeo url
      if (element.nodeName === 'IFRAME' && !isVimeoUrl(element.getAttribute('src') || '')) {
        throw new Error('The player element passed isn’t a Vimeo embed.');
      }

      // If there is already a player object in the map, return that
      if (playerMap.has(element)) {
        return playerMap.get(element);
      }
      this._window = element.ownerDocument.defaultView;
      this.element = element;
      this.origin = '*';
      var readyPromise = new npo_src(function (resolve, reject) {
        _this._onMessage = function (event) {
          if (!isVimeoUrl(event.origin) || _this.element.contentWindow !== event.source) {
            return;
          }
          if (_this.origin === '*') {
            _this.origin = event.origin;
          }
          var data = parseMessageData(event.data);
          var isError = data && data.event === 'error';
          var isReadyError = isError && data.data && data.data.method === 'ready';
          if (isReadyError) {
            var error = new Error(data.data.message);
            error.name = data.data.name;
            reject(error);
            return;
          }
          var isReadyEvent = data && data.event === 'ready';
          var isPingResponse = data && data.method === 'ping';
          if (isReadyEvent || isPingResponse) {
            _this.element.setAttribute('data-ready', 'true');
            resolve();
            return;
          }
          processData(_this, data);
        };
        _this._window.addEventListener('message', _this._onMessage);
        if (_this.element.nodeName !== 'IFRAME') {
          var params = getOEmbedParameters(element, options);
          var url = getVimeoUrl(params);
          getOEmbedData(url, params, element).then(function (data) {
            var iframe = createEmbed(data, element);
            // Overwrite element with the new iframe,
            // but store reference to the original element
            _this.element = iframe;
            _this._originalElement = element;
            swapCallbacks(element, iframe);
            playerMap.set(_this.element, _this);
            return data;
          }).catch(reject);
        }
      });

      // Store a copy of this Player in the map
      readyMap.set(this, readyPromise);
      playerMap.set(this.element, this);

      // Send a ping to the iframe so the ready promise will be resolved if
      // the player is already ready.
      if (this.element.nodeName === 'IFRAME') {
        postMessage(this, 'ping');
      }
      if (screenfull.isEnabled) {
        var exitFullscreen = function exitFullscreen() {
          return screenfull.exit();
        };
        this.fullscreenchangeHandler = function () {
          if (screenfull.isFullscreen) {
            storeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          } else {
            removeCallback(_this, 'event:exitFullscreen', exitFullscreen);
          }
          // eslint-disable-next-line
          _this.ready().then(function () {
            postMessage(_this, 'fullscreenchange', screenfull.isFullscreen);
          });
        };
        screenfull.on('fullscreenchange', this.fullscreenchangeHandler);
      }
      return this;
    }

    /**
     * Get a promise for a method.
     *
     * @param {string} name The API method to call.
     * @param {Object} [args={}] Arguments to send via postMessage.
     * @return {Promise}
     */
    _createClass(Player, [{
      key: "callMethod",
      value: function callMethod(name) {
        var _this2 = this;
        var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return new npo_src(function (resolve, reject) {
          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this2.ready().then(function () {
            storeCallback(_this2, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this2, name, args);
          }).catch(reject);
        });
      }

      /**
       * Get a promise for the value of a player property.
       *
       * @param {string} name The property name
       * @return {Promise}
       */
    }, {
      key: "get",
      value: function get(name) {
        var _this3 = this;
        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'get');

          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this3.ready().then(function () {
            storeCallback(_this3, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this3, name);
          }).catch(reject);
        });
      }

      /**
       * Get a promise for setting the value of a player property.
       *
       * @param {string} name The API method to call.
       * @param {mixed} value The value to set.
       * @return {Promise}
       */
    }, {
      key: "set",
      value: function set(name, value) {
        var _this4 = this;
        return new npo_src(function (resolve, reject) {
          name = getMethodName(name, 'set');
          if (value === undefined || value === null) {
            throw new TypeError('There must be a value to set.');
          }

          // We are storing the resolve/reject handlers to call later, so we
          // can’t return here.
          // eslint-disable-next-line promise/always-return
          return _this4.ready().then(function () {
            storeCallback(_this4, name, {
              resolve: resolve,
              reject: reject
            });
            postMessage(_this4, name, value);
          }).catch(reject);
        });
      }

      /**
       * Add an event listener for the specified event. Will call the
       * callback with a single parameter, `data`, that contains the data for
       * that event.
       *
       * @param {string} eventName The name of the event.
       * @param {function(*)} callback The function to call when the event fires.
       * @return {void}
       */
    }, {
      key: "on",
      value: function on(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }
        if (!callback) {
          throw new TypeError('You must pass a callback function.');
        }
        if (typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }
        var callbacks = getCallbacks(this, "event:".concat(eventName));
        if (callbacks.length === 0) {
          this.callMethod('addEventListener', eventName).catch(function () {
            // Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
        storeCallback(this, "event:".concat(eventName), callback);
      }

      /**
       * Remove an event listener for the specified event. Will remove all
       * listeners for that event if a `callback` isn’t passed, or only that
       * specific callback if it is passed.
       *
       * @param {string} eventName The name of the event.
       * @param {function} [callback] The specific callback to remove.
       * @return {void}
       */
    }, {
      key: "off",
      value: function off(eventName, callback) {
        if (!eventName) {
          throw new TypeError('You must pass an event name.');
        }
        if (callback && typeof callback !== 'function') {
          throw new TypeError('The callback must be a function.');
        }
        var lastCallback = removeCallback(this, "event:".concat(eventName), callback);

        // If there are no callbacks left, remove the listener
        if (lastCallback) {
          this.callMethod('removeEventListener', eventName).catch(function (e) {
            // Ignore the error. There will be an error event fired that
            // will trigger the error callback if they are listening.
          });
        }
      }

      /**
       * A promise to load a new video.
       *
       * @promise LoadVideoPromise
       * @fulfill {number} The video with this id or url successfully loaded.
       * @reject {TypeError} The id was not a number.
       */
      /**
       * Load a new video into this embed. The promise will be resolved if
       * the video is successfully loaded, or it will be rejected if it could
       * not be loaded.
       *
       * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
       * @return {LoadVideoPromise}
       */
    }, {
      key: "loadVideo",
      value: function loadVideo(options) {
        return this.callMethod('loadVideo', options);
      }

      /**
       * A promise to perform an action when the Player is ready.
       *
       * @todo document errors
       * @promise LoadVideoPromise
       * @fulfill {void}
       */
      /**
       * Trigger a function when the player iframe has initialized. You do not
       * need to wait for `ready` to trigger to begin adding event listeners
       * or calling other methods.
       *
       * @return {ReadyPromise}
       */
    }, {
      key: "ready",
      value: function ready() {
        var readyPromise = readyMap.get(this) || new npo_src(function (resolve, reject) {
          reject(new Error('Unknown player. Probably unloaded.'));
        });
        return npo_src.resolve(readyPromise);
      }

      /**
       * A promise to add a cue point to the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point to use for removeCuePoint.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Add a cue point to the player.
       *
       * @param {number} time The time for the cue point.
       * @param {object} [data] Arbitrary data to be returned with the cue point.
       * @return {AddCuePointPromise}
       */
    }, {
      key: "addCuePoint",
      value: function addCuePoint(time) {
        var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return this.callMethod('addCuePoint', {
          time: time,
          data: data
        });
      }

      /**
       * A promise to remove a cue point from the player.
       *
       * @promise AddCuePointPromise
       * @fulfill {string} The id of the cue point that was removed.
       * @reject {InvalidCuePoint} The cue point with the specified id was not
       *         found.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Remove a cue point from the video.
       *
       * @param {string} id The id of the cue point to remove.
       * @return {RemoveCuePointPromise}
       */
    }, {
      key: "removeCuePoint",
      value: function removeCuePoint(id) {
        return this.callMethod('removeCuePoint', id);
      }

      /**
       * A representation of a text track on a video.
       *
       * @typedef {Object} VimeoTextTrack
       * @property {string} language The ISO language code.
       * @property {string} kind The kind of track it is (captions or subtitles).
       * @property {string} label The human‐readable label for the track.
       */
      /**
       * A promise to enable a text track.
       *
       * @promise EnableTextTrackPromise
       * @fulfill {VimeoTextTrack} The text track that was enabled.
       * @reject {InvalidTrackLanguageError} No track was available with the
       *         specified language.
       * @reject {InvalidTrackError} No track was available with the specified
       *         language and kind.
       */
      /**
       * Enable the text track with the specified language, and optionally the
       * specified kind (captions or subtitles).
       *
       * When set via the API, the track language will not change the viewer’s
       * stored preference.
       *
       * @param {string} language The two‐letter language code.
       * @param {string} [kind] The kind of track to enable (captions or subtitles).
       * @return {EnableTextTrackPromise}
       */
    }, {
      key: "enableTextTrack",
      value: function enableTextTrack(language, kind) {
        if (!language) {
          throw new TypeError('You must pass a language.');
        }
        return this.callMethod('enableTextTrack', {
          language: language,
          kind: kind
        });
      }

      /**
       * A promise to disable the active text track.
       *
       * @promise DisableTextTrackPromise
       * @fulfill {void} The track was disabled.
       */
      /**
       * Disable the currently-active text track.
       *
       * @return {DisableTextTrackPromise}
       */
    }, {
      key: "disableTextTrack",
      value: function disableTextTrack() {
        return this.callMethod('disableTextTrack');
      }

      /**
       * A promise to pause the video.
       *
       * @promise PausePromise
       * @fulfill {void} The video was paused.
       */
      /**
       * Pause the video if it’s playing.
       *
       * @return {PausePromise}
       */
    }, {
      key: "pause",
      value: function pause() {
        return this.callMethod('pause');
      }

      /**
       * A promise to play the video.
       *
       * @promise PlayPromise
       * @fulfill {void} The video was played.
       */
      /**
       * Play the video if it’s paused. **Note:** on iOS and some other
       * mobile devices, you cannot programmatically trigger play. Once the
       * viewer has tapped on the play button in the player, however, you
       * will be able to use this function.
       *
       * @return {PlayPromise}
       */
    }, {
      key: "play",
      value: function play() {
        return this.callMethod('play');
      }

      /**
       * Request that the player enters fullscreen.
       * @return {Promise}
       */
    }, {
      key: "requestFullscreen",
      value: function requestFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.request(this.element);
        }
        return this.callMethod('requestFullscreen');
      }

      /**
       * Request that the player exits fullscreen.
       * @return {Promise}
       */
    }, {
      key: "exitFullscreen",
      value: function exitFullscreen() {
        if (screenfull.isEnabled) {
          return screenfull.exit();
        }
        return this.callMethod('exitFullscreen');
      }

      /**
       * Returns true if the player is currently fullscreen.
       * @return {Promise}
       */
    }, {
      key: "getFullscreen",
      value: function getFullscreen() {
        if (screenfull.isEnabled) {
          return npo_src.resolve(screenfull.isFullscreen);
        }
        return this.get('fullscreen');
      }

      /**
       * Request that the player enters picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "requestPictureInPicture",
      value: function requestPictureInPicture() {
        return this.callMethod('requestPictureInPicture');
      }

      /**
       * Request that the player exits picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "exitPictureInPicture",
      value: function exitPictureInPicture() {
        return this.callMethod('exitPictureInPicture');
      }

      /**
       * Returns true if the player is currently picture-in-picture.
       * @return {Promise}
       */
    }, {
      key: "getPictureInPicture",
      value: function getPictureInPicture() {
        return this.get('pictureInPicture');
      }

      /**
       * A promise to prompt the viewer to initiate remote playback.
       *
       * @promise RemotePlaybackPromptPromise
       * @fulfill {void}
       * @reject {NotFoundError} No remote playback device is available.
       */
      /**
       * Request to prompt the user to initiate remote playback.
       *
       * @return {RemotePlaybackPromptPromise}
       */
    }, {
      key: "remotePlaybackPrompt",
      value: function remotePlaybackPrompt() {
        return this.callMethod('remotePlaybackPrompt');
      }

      /**
       * A promise to unload the video.
       *
       * @promise UnloadPromise
       * @fulfill {void} The video was unloaded.
       */
      /**
       * Return the player to its initial state.
       *
       * @return {UnloadPromise}
       */
    }, {
      key: "unload",
      value: function unload() {
        return this.callMethod('unload');
      }

      /**
       * Cleanup the player and remove it from the DOM
       *
       * It won't be usable and a new one should be constructed
       *  in order to do any operations.
       *
       * @return {Promise}
       */
    }, {
      key: "destroy",
      value: function destroy() {
        var _this5 = this;
        return new npo_src(function (resolve) {
          readyMap.delete(_this5);
          playerMap.delete(_this5.element);
          if (_this5._originalElement) {
            playerMap.delete(_this5._originalElement);
            _this5._originalElement.removeAttribute('data-vimeo-initialized');
          }
          if (_this5.element && _this5.element.nodeName === 'IFRAME' && _this5.element.parentNode) {
            // If we've added an additional wrapper div, remove that from the DOM.
            // If not, just remove the iframe element.
            if (_this5.element.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== _this5.element.parentNode) {
              _this5.element.parentNode.parentNode.removeChild(_this5.element.parentNode);
            } else {
              _this5.element.parentNode.removeChild(_this5.element);
            }
          }

          // If the clip is private there is a case where the element stays the
          // div element. Destroy should reset the div and remove the iframe child.
          if (_this5.element && _this5.element.nodeName === 'DIV' && _this5.element.parentNode) {
            _this5.element.removeAttribute('data-vimeo-initialized');
            var iframe = _this5.element.querySelector('iframe');
            if (iframe && iframe.parentNode) {
              // If we've added an additional wrapper div, remove that from the DOM.
              // If not, just remove the iframe element.
              if (iframe.parentNode.parentNode && _this5._originalElement && _this5._originalElement !== iframe.parentNode) {
                iframe.parentNode.parentNode.removeChild(iframe.parentNode);
              } else {
                iframe.parentNode.removeChild(iframe);
              }
            }
          }
          _this5._window.removeEventListener('message', _this5._onMessage);
          if (screenfull.isEnabled) {
            screenfull.off('fullscreenchange', _this5.fullscreenchangeHandler);
          }
          resolve();
        });
      }

      /**
       * A promise to get the autopause behavior of the video.
       *
       * @promise GetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */
      /**
       * Get the autopause behavior for this player.
       *
       * @return {GetAutopausePromise}
       */
    }, {
      key: "getAutopause",
      value: function getAutopause() {
        return this.get('autopause');
      }

      /**
       * A promise to set the autopause behavior of the video.
       *
       * @promise SetAutopausePromise
       * @fulfill {boolean} Whether autopause is turned on or off.
       * @reject {UnsupportedError} Autopause is not supported with the current
       *         player or browser.
       */
      /**
       * Enable or disable the autopause behavior of this player.
       *
       * By default, when another video is played in the same browser, this
       * player will automatically pause. Unless you have a specific reason
       * for doing so, we recommend that you leave autopause set to the
       * default (`true`).
       *
       * @param {boolean} autopause
       * @return {SetAutopausePromise}
       */
    }, {
      key: "setAutopause",
      value: function setAutopause(autopause) {
        return this.set('autopause', autopause);
      }

      /**
       * A promise to get the buffered property of the video.
       *
       * @promise GetBufferedPromise
       * @fulfill {Array} Buffered Timeranges converted to an Array.
       */
      /**
       * Get the buffered property of the video.
       *
       * @return {GetBufferedPromise}
       */
    }, {
      key: "getBuffered",
      value: function getBuffered() {
        return this.get('buffered');
      }

      /**
       * @typedef {Object} CameraProperties
       * @prop {number} props.yaw - Number between 0 and 360.
       * @prop {number} props.pitch - Number between -90 and 90.
       * @prop {number} props.roll - Number between -180 and 180.
       * @prop {number} props.fov - The field of view in degrees.
       */
      /**
       * A promise to get the camera properties of the player.
       *
       * @promise GetCameraPromise
       * @fulfill {CameraProperties} The camera properties.
       */
      /**
       * For 360° videos get the camera properties for this player.
       *
       * @return {GetCameraPromise}
       */
    }, {
      key: "getCameraProps",
      value: function getCameraProps() {
        return this.get('cameraProps');
      }

      /**
       * A promise to set the camera properties of the player.
       *
       * @promise SetCameraPromise
       * @fulfill {Object} The camera was successfully set.
       * @reject {RangeError} The range was out of bounds.
       */
      /**
       * For 360° videos set the camera properties for this player.
       *
       * @param {CameraProperties} camera The camera properties
       * @return {SetCameraPromise}
       */
    }, {
      key: "setCameraProps",
      value: function setCameraProps(camera) {
        return this.set('cameraProps', camera);
      }

      /**
       * A representation of a chapter.
       *
       * @typedef {Object} VimeoChapter
       * @property {number} startTime The start time of the chapter.
       * @property {object} title The title of the chapter.
       * @property {number} index The place in the order of Chapters. Starts at 1.
       */
      /**
       * A promise to get chapters for the video.
       *
       * @promise GetChaptersPromise
       * @fulfill {VimeoChapter[]} The chapters for the video.
       */
      /**
       * Get an array of all the chapters for the video.
       *
       * @return {GetChaptersPromise}
       */
    }, {
      key: "getChapters",
      value: function getChapters() {
        return this.get('chapters');
      }

      /**
       * A promise to get the currently active chapter.
       *
       * @promise GetCurrentChaptersPromise
       * @fulfill {VimeoChapter|undefined} The current chapter for the video.
       */
      /**
       * Get the currently active chapter for the video.
       *
       * @return {GetCurrentChaptersPromise}
       */
    }, {
      key: "getCurrentChapter",
      value: function getCurrentChapter() {
        return this.get('currentChapter');
      }

      /**
       * A promise to get the accent color of the player.
       *
       * @promise GetColorPromise
       * @fulfill {string} The hex color of the player.
       */
      /**
       * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
       *
       * @return {GetColorPromise}
       */
    }, {
      key: "getColor",
      value: function getColor() {
        return this.get('color');
      }

      /**
       * A promise to get all colors for the player in an array.
       *
       * @promise GetColorsPromise
       * @fulfill {string[]} The hex colors of the player.
       */
      /**
       * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
       *
       * @return {GetColorPromise}
       */
    }, {
      key: "getColors",
      value: function getColors() {
        return npo_src.all([this.get('colorOne'), this.get('colorTwo'), this.get('colorThree'), this.get('colorFour')]);
      }

      /**
       * A promise to set the accent color of the player.
       *
       * @promise SetColorPromise
       * @fulfill {string} The color was successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */
      /**
       * Set the accent color of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       * Note this is deprecated in place of `setColorTwo`.
       *
       * @param {string} color The hex or rgb color string to set.
       * @return {SetColorPromise}
       */
    }, {
      key: "setColor",
      value: function setColor(color) {
        return this.set('color', color);
      }

      /**
       * A promise to set all colors for the player.
       *
       * @promise SetColorsPromise
       * @fulfill {string[]} The colors were successfully set.
       * @reject {TypeError} The string was not a valid hex or rgb color.
       * @reject {ContrastError} The color was set, but the contrast is
       *         outside of the acceptable range.
       * @reject {EmbedSettingsError} The owner of the player has chosen to
       *         use a specific color.
       */
      /**
       * Set the colors of this player to a hex or rgb string. Setting the
       * color may fail if the owner of the video has set their embed
       * preferences to force a specific color.
       * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
       * If a color should not be set, the index in the array can be left as null.
       *
       * @param {string[]} colors Array of the hex or rgb color strings to set.
       * @return {SetColorsPromise}
       */
    }, {
      key: "setColors",
      value: function setColors(colors) {
        if (!Array.isArray(colors)) {
          return new npo_src(function (resolve, reject) {
            return reject(new TypeError('Argument must be an array.'));
          });
        }
        var nullPromise = new npo_src(function (resolve) {
          return resolve(null);
        });
        var colorPromises = [colors[0] ? this.set('colorOne', colors[0]) : nullPromise, colors[1] ? this.set('colorTwo', colors[1]) : nullPromise, colors[2] ? this.set('colorThree', colors[2]) : nullPromise, colors[3] ? this.set('colorFour', colors[3]) : nullPromise];
        return npo_src.all(colorPromises);
      }

      /**
       * A representation of a cue point.
       *
       * @typedef {Object} VimeoCuePoint
       * @property {number} time The time of the cue point.
       * @property {object} data The data passed when adding the cue point.
       * @property {string} id The unique id for use with removeCuePoint.
       */
      /**
       * A promise to get the cue points of a video.
       *
       * @promise GetCuePointsPromise
       * @fulfill {VimeoCuePoint[]} The cue points added to the video.
       * @reject {UnsupportedError} Cue points are not supported with the current
       *         player or browser.
       */
      /**
       * Get an array of the cue points added to the video.
       *
       * @return {GetCuePointsPromise}
       */
    }, {
      key: "getCuePoints",
      value: function getCuePoints() {
        return this.get('cuePoints');
      }

      /**
       * A promise to get the current time of the video.
       *
       * @promise GetCurrentTimePromise
       * @fulfill {number} The current time in seconds.
       */
      /**
       * Get the current playback position in seconds.
       *
       * @return {GetCurrentTimePromise}
       */
    }, {
      key: "getCurrentTime",
      value: function getCurrentTime() {
        return this.get('currentTime');
      }

      /**
       * A promise to set the current time of the video.
       *
       * @promise SetCurrentTimePromise
       * @fulfill {number} The actual current time that was set.
       * @reject {RangeError} the time was less than 0 or greater than the
       *         video’s duration.
       */
      /**
       * Set the current playback position in seconds. If the player was
       * paused, it will remain paused. Likewise, if the player was playing,
       * it will resume playing once the video has buffered.
       *
       * You can provide an accurate time and the player will attempt to seek
       * to as close to that time as possible. The exact time will be the
       * fulfilled value of the promise.
       *
       * @param {number} currentTime
       * @return {SetCurrentTimePromise}
       */
    }, {
      key: "setCurrentTime",
      value: function setCurrentTime(currentTime) {
        return this.set('currentTime', currentTime);
      }

      /**
       * A promise to get the duration of the video.
       *
       * @promise GetDurationPromise
       * @fulfill {number} The duration in seconds.
       */
      /**
       * Get the duration of the video in seconds. It will be rounded to the
       * nearest second before playback begins, and to the nearest thousandth
       * of a second after playback begins.
       *
       * @return {GetDurationPromise}
       */
    }, {
      key: "getDuration",
      value: function getDuration() {
        return this.get('duration');
      }

      /**
       * A promise to get the ended state of the video.
       *
       * @promise GetEndedPromise
       * @fulfill {boolean} Whether or not the video has ended.
       */
      /**
       * Get the ended state of the video. The video has ended if
       * `currentTime === duration`.
       *
       * @return {GetEndedPromise}
       */
    }, {
      key: "getEnded",
      value: function getEnded() {
        return this.get('ended');
      }

      /**
       * A promise to get the loop state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the player is set to loop.
       */
      /**
       * Get the loop state of the player.
       *
       * @return {GetLoopPromise}
       */
    }, {
      key: "getLoop",
      value: function getLoop() {
        return this.get('loop');
      }

      /**
       * A promise to set the loop state of the player.
       *
       * @promise SetLoopPromise
       * @fulfill {boolean} The loop state that was set.
       */
      /**
       * Set the loop state of the player. When set to `true`, the player
       * will start over immediately once playback ends.
       *
       * @param {boolean} loop
       * @return {SetLoopPromise}
       */
    }, {
      key: "setLoop",
      value: function setLoop(loop) {
        return this.set('loop', loop);
      }

      /**
       * A promise to set the muted state of the player.
       *
       * @promise SetMutedPromise
       * @fulfill {boolean} The muted state that was set.
       */
      /**
       * Set the muted state of the player. When set to `true`, the player
       * volume will be muted.
       *
       * @param {boolean} muted
       * @return {SetMutedPromise}
       */
    }, {
      key: "setMuted",
      value: function setMuted(muted) {
        return this.set('muted', muted);
      }

      /**
       * A promise to get the muted state of the player.
       *
       * @promise GetMutedPromise
       * @fulfill {boolean} Whether or not the player is muted.
       */
      /**
       * Get the muted state of the player.
       *
       * @return {GetMutedPromise}
       */
    }, {
      key: "getMuted",
      value: function getMuted() {
        return this.get('muted');
      }

      /**
       * A promise to get the paused state of the player.
       *
       * @promise GetLoopPromise
       * @fulfill {boolean} Whether or not the video is paused.
       */
      /**
       * Get the paused state of the player.
       *
       * @return {GetLoopPromise}
       */
    }, {
      key: "getPaused",
      value: function getPaused() {
        return this.get('paused');
      }

      /**
       * A promise to get the playback rate of the player.
       *
       * @promise GetPlaybackRatePromise
       * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
       */
      /**
       * Get the playback rate of the player on a scale from `0` to `2`.
       *
       * @return {GetPlaybackRatePromise}
       */
    }, {
      key: "getPlaybackRate",
      value: function getPlaybackRate() {
        return this.get('playbackRate');
      }

      /**
       * A promise to set the playbackrate of the player.
       *
       * @promise SetPlaybackRatePromise
       * @fulfill {number} The playback rate was set.
       * @reject {RangeError} The playback rate was less than 0 or greater than 2.
       */
      /**
       * Set the playback rate of the player on a scale from `0` to `2`. When set
       * via the API, the playback rate will not be synchronized to other
       * players or stored as the viewer's preference.
       *
       * @param {number} playbackRate
       * @return {SetPlaybackRatePromise}
       */
    }, {
      key: "setPlaybackRate",
      value: function setPlaybackRate(playbackRate) {
        return this.set('playbackRate', playbackRate);
      }

      /**
       * A promise to get the played property of the video.
       *
       * @promise GetPlayedPromise
       * @fulfill {Array} Played Timeranges converted to an Array.
       */
      /**
       * Get the played property of the video.
       *
       * @return {GetPlayedPromise}
       */
    }, {
      key: "getPlayed",
      value: function getPlayed() {
        return this.get('played');
      }

      /**
       * A promise to get the qualities available of the current video.
       *
       * @promise GetQualitiesPromise
       * @fulfill {Array} The qualities of the video.
       */
      /**
       * Get the qualities of the current video.
       *
       * @return {GetQualitiesPromise}
       */
    }, {
      key: "getQualities",
      value: function getQualities() {
        return this.get('qualities');
      }

      /**
       * A promise to get the current set quality of the video.
       *
       * @promise GetQualityPromise
       * @fulfill {string} The current set quality.
       */
      /**
       * Get the current set quality of the video.
       *
       * @return {GetQualityPromise}
       */
    }, {
      key: "getQuality",
      value: function getQuality() {
        return this.get('quality');
      }

      /**
       * A promise to set the video quality.
       *
       * @promise SetQualityPromise
       * @fulfill {number} The quality was set.
       * @reject {RangeError} The quality is not available.
       */
      /**
       * Set a video quality.
       *
       * @param {string} quality
       * @return {SetQualityPromise}
       */
    }, {
      key: "setQuality",
      value: function setQuality(quality) {
        return this.set('quality', quality);
      }

      /**
       * A promise to get the remote playback availability.
       *
       * @promise RemotePlaybackAvailabilityPromise
       * @fulfill {boolean} Whether remote playback is available.
       */
      /**
       * Get the availability of remote playback.
       *
       * @return {RemotePlaybackAvailabilityPromise}
       */
    }, {
      key: "getRemotePlaybackAvailability",
      value: function getRemotePlaybackAvailability() {
        return this.get('remotePlaybackAvailability');
      }

      /**
       * A promise to get the current remote playback state.
       *
       * @promise RemotePlaybackStatePromise
       * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
       */
      /**
       * Get the current remote playback state.
       *
       * @return {RemotePlaybackStatePromise}
       */
    }, {
      key: "getRemotePlaybackState",
      value: function getRemotePlaybackState() {
        return this.get('remotePlaybackState');
      }

      /**
       * A promise to get the seekable property of the video.
       *
       * @promise GetSeekablePromise
       * @fulfill {Array} Seekable Timeranges converted to an Array.
       */
      /**
       * Get the seekable property of the video.
       *
       * @return {GetSeekablePromise}
       */
    }, {
      key: "getSeekable",
      value: function getSeekable() {
        return this.get('seekable');
      }

      /**
       * A promise to get the seeking property of the player.
       *
       * @promise GetSeekingPromise
       * @fulfill {boolean} Whether or not the player is currently seeking.
       */
      /**
       * Get if the player is currently seeking.
       *
       * @return {GetSeekingPromise}
       */
    }, {
      key: "getSeeking",
      value: function getSeeking() {
        return this.get('seeking');
      }

      /**
       * A promise to get the text tracks of a video.
       *
       * @promise GetTextTracksPromise
       * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
       */
      /**
       * Get an array of the text tracks that exist for the video.
       *
       * @return {GetTextTracksPromise}
       */
    }, {
      key: "getTextTracks",
      value: function getTextTracks() {
        return this.get('textTracks');
      }

      /**
       * A promise to get the embed code for the video.
       *
       * @promise GetVideoEmbedCodePromise
       * @fulfill {string} The `<iframe>` embed code for the video.
       */
      /**
       * Get the `<iframe>` embed code for the video.
       *
       * @return {GetVideoEmbedCodePromise}
       */
    }, {
      key: "getVideoEmbedCode",
      value: function getVideoEmbedCode() {
        return this.get('videoEmbedCode');
      }

      /**
       * A promise to get the id of the video.
       *
       * @promise GetVideoIdPromise
       * @fulfill {number} The id of the video.
       */
      /**
       * Get the id of the video.
       *
       * @return {GetVideoIdPromise}
       */
    }, {
      key: "getVideoId",
      value: function getVideoId() {
        return this.get('videoId');
      }

      /**
       * A promise to get the title of the video.
       *
       * @promise GetVideoTitlePromise
       * @fulfill {number} The title of the video.
       */
      /**
       * Get the title of the video.
       *
       * @return {GetVideoTitlePromise}
       */
    }, {
      key: "getVideoTitle",
      value: function getVideoTitle() {
        return this.get('videoTitle');
      }

      /**
       * A promise to get the native width of the video.
       *
       * @promise GetVideoWidthPromise
       * @fulfill {number} The native width of the video.
       */
      /**
       * Get the native width of the currently‐playing video. The width of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoWidthPromise}
       */
    }, {
      key: "getVideoWidth",
      value: function getVideoWidth() {
        return this.get('videoWidth');
      }

      /**
       * A promise to get the native height of the video.
       *
       * @promise GetVideoHeightPromise
       * @fulfill {number} The native height of the video.
       */
      /**
       * Get the native height of the currently‐playing video. The height of
       * the highest‐resolution available will be used before playback begins.
       *
       * @return {GetVideoHeightPromise}
       */
    }, {
      key: "getVideoHeight",
      value: function getVideoHeight() {
        return this.get('videoHeight');
      }

      /**
       * A promise to get the vimeo.com url for the video.
       *
       * @promise GetVideoUrlPromise
       * @fulfill {number} The vimeo.com url for the video.
       * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
       */
      /**
       * Get the vimeo.com url for the video.
       *
       * @return {GetVideoUrlPromise}
       */
    }, {
      key: "getVideoUrl",
      value: function getVideoUrl() {
        return this.get('videoUrl');
      }

      /**
       * A promise to get the volume level of the player.
       *
       * @promise GetVolumePromise
       * @fulfill {number} The volume level of the player on a scale from 0 to 1.
       */
      /**
       * Get the current volume level of the player on a scale from `0` to `1`.
       *
       * Most mobile devices do not support an independent volume from the
       * system volume. In those cases, this method will always return `1`.
       *
       * @return {GetVolumePromise}
       */
    }, {
      key: "getVolume",
      value: function getVolume() {
        return this.get('volume');
      }

      /**
       * A promise to set the volume level of the player.
       *
       * @promise SetVolumePromise
       * @fulfill {number} The volume was set.
       * @reject {RangeError} The volume was less than 0 or greater than 1.
       */
      /**
       * Set the volume of the player on a scale from `0` to `1`. When set
       * via the API, the volume level will not be synchronized to other
       * players or stored as the viewer’s preference.
       *
       * Most mobile devices do not support setting the volume. An error will
       * *not* be triggered in that situation.
       *
       * @param {number} volume
       * @return {SetVolumePromise}
       */
    }, {
      key: "setVolume",
      value: function setVolume(volume) {
        return this.set('volume', volume);
      }

      /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
      /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
      /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */

      /**
       * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
       *
       * @param {TimingObject} timingObject
       * @param {TimingSrcConnectorOptions} options
       *
       * @return {Promise<TimingSrcConnector>}
       */
    }, {
      key: "setTimingSrc",
      value: function () {
        var _setTimingSrc = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(timingObject, options) {
          var _this6 = this;
          var connector;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (timingObject) {
                  _context.next = 2;
                  break;
                }
                throw new TypeError('A Timing Object must be provided.');
              case 2:
                _context.next = 4;
                return this.ready();
              case 4:
                connector = new TimingSrcConnector(this, timingObject, options);
                postMessage(this, 'notifyTimingObjectConnect');
                connector.addEventListener('disconnect', function () {
                  return postMessage(_this6, 'notifyTimingObjectDisconnect');
                });
                return _context.abrupt("return", connector);
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee, this);
        }));
        function setTimingSrc(_x, _x2) {
          return _setTimingSrc.apply(this, arguments);
        }
        return setTimingSrc;
      }()
    }]);
    return Player;
  }(); // Setup embed only if this is not a node environment
  if (!isNode) {
    screenfull = initializeScreenfull();
    initializeEmbeds();
    resizeEmbeds();
    initAppendVideoMetadata();
    checkUrlTimeParam();
  }

  return Player;

})));


}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"timers":256}],3:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":4}],4:[function(require,module,exports){
(function (global){(function (){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],5:[function(require,module,exports){
module.exports = require('./lib/axios');
},{"./lib/axios":7}],6:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var settle = require('./../core/settle');
var cookies = require('./../helpers/cookies');
var buildURL = require('./../helpers/buildURL');
var buildFullPath = require('../core/buildFullPath');
var parseHeaders = require('./../helpers/parseHeaders');
var isURLSameOrigin = require('./../helpers/isURLSameOrigin');
var transitionalDefaults = require('../defaults/transitional');
var AxiosError = require('../core/AxiosError');
var CanceledError = require('../cancel/CanceledError');
var parseProtocol = require('../helpers/parseProtocol');

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};

},{"../cancel/CanceledError":9,"../core/AxiosError":12,"../core/buildFullPath":14,"../defaults/transitional":20,"../helpers/parseProtocol":32,"./../core/settle":17,"./../helpers/buildURL":23,"./../helpers/cookies":25,"./../helpers/isURLSameOrigin":28,"./../helpers/parseHeaders":31,"./../utils":36}],7:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var bind = require('./helpers/bind');
var Axios = require('./core/Axios');
var mergeConfig = require('./core/mergeConfig');
var defaults = require('./defaults');

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = require('./cancel/CanceledError');
axios.CancelToken = require('./cancel/CancelToken');
axios.isCancel = require('./cancel/isCancel');
axios.VERSION = require('./env/data').version;
axios.toFormData = require('./helpers/toFormData');

// Expose AxiosError class
axios.AxiosError = require('../lib/core/AxiosError');

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = require('./helpers/spread');

// Expose isAxiosError
axios.isAxiosError = require('./helpers/isAxiosError');

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

},{"../lib/core/AxiosError":12,"./cancel/CancelToken":8,"./cancel/CanceledError":9,"./cancel/isCancel":10,"./core/Axios":11,"./core/mergeConfig":16,"./defaults":19,"./env/data":21,"./helpers/bind":22,"./helpers/isAxiosError":27,"./helpers/spread":33,"./helpers/toFormData":34,"./utils":36}],8:[function(require,module,exports){
'use strict';

var CanceledError = require('./CanceledError');

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

},{"./CanceledError":9}],9:[function(require,module,exports){
'use strict';

var AxiosError = require('../core/AxiosError');
var utils = require('../utils');

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;

},{"../core/AxiosError":12,"../utils":36}],10:[function(require,module,exports){
'use strict';

module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

},{}],11:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var buildURL = require('../helpers/buildURL');
var InterceptorManager = require('./InterceptorManager');
var dispatchRequest = require('./dispatchRequest');
var mergeConfig = require('./mergeConfig');
var buildFullPath = require('./buildFullPath');
var validator = require('../helpers/validator');

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;

},{"../helpers/buildURL":23,"../helpers/validator":35,"./../utils":36,"./InterceptorManager":13,"./buildFullPath":14,"./dispatchRequest":15,"./mergeConfig":16}],12:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;

},{"../utils":36}],13:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

},{"./../utils":36}],14:[function(require,module,exports){
'use strict';

var isAbsoluteURL = require('../helpers/isAbsoluteURL');
var combineURLs = require('../helpers/combineURLs');

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

},{"../helpers/combineURLs":24,"../helpers/isAbsoluteURL":26}],15:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var transformData = require('./transformData');
var isCancel = require('../cancel/isCancel');
var defaults = require('../defaults');
var CanceledError = require('../cancel/CanceledError');

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

},{"../cancel/CanceledError":9,"../cancel/isCancel":10,"../defaults":19,"./../utils":36,"./transformData":18}],16:[function(require,module,exports){
'use strict';

var utils = require('../utils');

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

},{"../utils":36}],17:[function(require,module,exports){
'use strict';

var AxiosError = require('./AxiosError');

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};

},{"./AxiosError":12}],18:[function(require,module,exports){
'use strict';

var utils = require('./../utils');
var defaults = require('../defaults');

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

},{"../defaults":19,"./../utils":36}],19:[function(require,module,exports){
(function (process){(function (){
'use strict';

var utils = require('../utils');
var normalizeHeaderName = require('../helpers/normalizeHeaderName');
var AxiosError = require('../core/AxiosError');
var transitionalDefaults = require('./transitional');
var toFormData = require('../helpers/toFormData');

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = require('../adapters/xhr');
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = require('../adapters/http');
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: require('./env/FormData')
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

}).call(this)}).call(this,require('_process'))

},{"../adapters/http":6,"../adapters/xhr":6,"../core/AxiosError":12,"../helpers/normalizeHeaderName":29,"../helpers/toFormData":34,"../utils":36,"./env/FormData":30,"./transitional":20,"_process":216}],20:[function(require,module,exports){
'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};

},{}],21:[function(require,module,exports){
module.exports = {
  "version": "0.27.2"
};
},{}],22:[function(require,module,exports){
'use strict';

module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

},{}],23:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

},{"./../utils":36}],24:[function(require,module,exports){
'use strict';

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

},{}],25:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

},{"./../utils":36}],26:[function(require,module,exports){
'use strict';

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

},{}],27:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};

},{"./../utils":36}],28:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

},{"./../utils":36}],29:[function(require,module,exports){
'use strict';

var utils = require('../utils');

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

},{"../utils":36}],30:[function(require,module,exports){
// eslint-disable-next-line strict
module.exports = null;

},{}],31:[function(require,module,exports){
'use strict';

var utils = require('./../utils');

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

},{"./../utils":36}],32:[function(require,module,exports){
'use strict';

module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};

},{}],33:[function(require,module,exports){
'use strict';

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

},{}],34:[function(require,module,exports){
(function (Buffer){(function (){
'use strict';

var utils = require('../utils');

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;

}).call(this)}).call(this,require("buffer").Buffer)

},{"../utils":36,"buffer":38}],35:[function(require,module,exports){
'use strict';

var VERSION = require('../env/data').version;
var AxiosError = require('../core/AxiosError');

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};

},{"../core/AxiosError":12,"../env/data":21}],36:[function(require,module,exports){
'use strict';

var bind = require('./helpers/bind');

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};

},{"./helpers/bind":22}],37:[function(require,module,exports){
'use strict'

exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}

},{}],38:[function(require,module,exports){
(function (Buffer){(function (){
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */

'use strict'

var base64 = require('base64-js')
var ieee754 = require('ieee754')

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = { __proto__: Uint8Array.prototype, foo: function () { return 42 } }
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  buf.__proto__ = Buffer.prototype
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

// Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
if (typeof Symbol !== 'undefined' && Symbol.species != null &&
    Buffer[Symbol.species] === Buffer) {
  Object.defineProperty(Buffer, Symbol.species, {
    value: null,
    configurable: true,
    enumerable: false,
    writable: false
  })
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayLike(value)
  }

  if (value == null) {
    throw TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Buffer.prototype.__proto__ = Uint8Array.prototype
Buffer.__proto__ = Uint8Array

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  buf.__proto__ = Buffer.prototype
  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      buf = Buffer.from(buf)
    }
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
        : (firstByte > 0xBF) ? 2
          : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  newBuf.__proto__ = Buffer.prototype
  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (var i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

}).call(this)}).call(this,require("buffer").Buffer)

},{"base64-js":37,"buffer":38,"ieee754":47}],39:[function(require,module,exports){
/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

( function( window, factory ) {
  /*global define: false, module: false */
  'use strict';
  // universal module definition
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }

}( window, function factory() {
  'use strict';

  var matchesMethod = ( function() {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if ( ElemProto.matches ) {
      return 'matches';
    }
    // check un-prefixed
    if ( ElemProto.matchesSelector ) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = [ 'webkit', 'moz', 'ms', 'o' ];

    for ( var i=0; i < prefixes.length; i++ ) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if ( ElemProto[ method ] ) {
        return method;
      }
    }
  })();

  return function matchesSelector( elem, selector ) {
    return elem[ matchesMethod ]( selector );
  };

}));

},{}],40:[function(require,module,exports){
'use strict';

/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/
var dijkstra = {
  single_source_shortest_paths: function(graph, s, d) {
    // Predecessor map for each node that has been encountered.
    // node ID => predecessor node ID
    var predecessors = {};

    // Costs of shortest paths from s to all nodes encountered.
    // node ID => cost
    var costs = {};
    costs[s] = 0;

    // Costs of shortest paths from s to all nodes encountered; differs from
    // `costs` in that it provides easy access to the node that currently has
    // the known shortest path from s.
    // XXX: Do we actually need both `costs` and `open`?
    var open = dijkstra.PriorityQueue.make();
    open.push(s, 0);

    var closest,
        u, v,
        cost_of_s_to_u,
        adjacent_nodes,
        cost_of_e,
        cost_of_s_to_u_plus_cost_of_e,
        cost_of_s_to_v,
        first_visit;
    while (!open.empty()) {
      // In the nodes remaining in graph that have a known cost from s,
      // find the node, u, that currently has the shortest path from s.
      closest = open.pop();
      u = closest.value;
      cost_of_s_to_u = closest.cost;

      // Get nodes adjacent to u...
      adjacent_nodes = graph[u] || {};

      // ...and explore the edges that connect u to those nodes, updating
      // the cost of the shortest paths to any or all of those nodes as
      // necessary. v is the node across the current edge from u.
      for (v in adjacent_nodes) {
        if (adjacent_nodes.hasOwnProperty(v)) {
          // Get the cost of the edge running from u to v.
          cost_of_e = adjacent_nodes[v];

          // Cost of s to u plus the cost of u to v across e--this is *a*
          // cost from s to v that may or may not be less than the current
          // known cost to v.
          cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;

          // If we haven't visited v yet OR if the current known cost from s to
          // v is greater than the new cost we just found (cost of s to u plus
          // cost of u to v across e), update v's cost in the cost list and
          // update v's predecessor in the predecessor list (it's now u).
          cost_of_s_to_v = costs[v];
          first_visit = (typeof costs[v] === 'undefined');
          if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
            costs[v] = cost_of_s_to_u_plus_cost_of_e;
            open.push(v, cost_of_s_to_u_plus_cost_of_e);
            predecessors[v] = u;
          }
        }
      }
    }

    if (typeof d !== 'undefined' && typeof costs[d] === 'undefined') {
      var msg = ['Could not find a path from ', s, ' to ', d, '.'].join('');
      throw new Error(msg);
    }

    return predecessors;
  },

  extract_shortest_path_from_predecessor_list: function(predecessors, d) {
    var nodes = [];
    var u = d;
    var predecessor;
    while (u) {
      nodes.push(u);
      predecessor = predecessors[u];
      u = predecessors[u];
    }
    nodes.reverse();
    return nodes;
  },

  find_path: function(graph, s, d) {
    var predecessors = dijkstra.single_source_shortest_paths(graph, s, d);
    return dijkstra.extract_shortest_path_from_predecessor_list(
      predecessors, d);
  },

  /**
   * A very naive priority queue implementation.
   */
  PriorityQueue: {
    make: function (opts) {
      var T = dijkstra.PriorityQueue,
          t = {},
          key;
      opts = opts || {};
      for (key in T) {
        if (T.hasOwnProperty(key)) {
          t[key] = T[key];
        }
      }
      t.queue = [];
      t.sorter = opts.sorter || T.default_sorter;
      return t;
    },

    default_sorter: function (a, b) {
      return a.cost - b.cost;
    },

    /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */
    push: function (value, cost) {
      var item = {value: value, cost: cost};
      this.queue.push(item);
      this.queue.sort(this.sorter);
    },

    /**
     * Return the highest priority element in the queue.
     */
    pop: function () {
      return this.queue.shift();
    },

    empty: function () {
      return this.queue.length === 0;
    }
  }
};


// node.js module exports
if (typeof module !== 'undefined') {
  module.exports = dijkstra;
}

},{}],41:[function(require,module,exports){
'use strict'

module.exports = function encodeUtf8 (input) {
  var result = []
  var size = input.length

  for (var index = 0; index < size; index++) {
    var point = input.charCodeAt(index)

    if (point >= 0xD800 && point <= 0xDBFF && size > index + 1) {
      var second = input.charCodeAt(index + 1)

      if (second >= 0xDC00 && second <= 0xDFFF) {
        // https://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
        point = (point - 0xD800) * 0x400 + second - 0xDC00 + 0x10000
        index += 1
      }
    }

    // US-ASCII
    if (point < 0x80) {
      result.push(point)
      continue
    }

    // 2-byte UTF-8
    if (point < 0x800) {
      result.push((point >> 6) | 192)
      result.push((point & 63) | 128)
      continue
    }

    // 3-byte UTF-8
    if (point < 0xD800 || (point >= 0xE000 && point < 0x10000)) {
      result.push((point >> 12) | 224)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // 4-byte UTF-8
    if (point >= 0x10000 && point <= 0x10FFFF) {
      result.push((point >> 18) | 240)
      result.push(((point >> 12) & 63) | 128)
      result.push(((point >> 6) & 63) | 128)
      result.push((point & 63) | 128)
      continue
    }

    // Invalid character
    result.push(0xEF, 0xBF, 0xBD)
  }

  return new Uint8Array(result).buffer
}

},{}],42:[function(require,module,exports){
/**
 * EvEmitter v2.1.1
 * Lil' event emitter
 * MIT License
 */

( function( global, factory ) {
  // universal module definition
  if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

function EvEmitter() {}

let proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) return this;

  // set events hash
  let events = this._events = this._events || {};
  // set listeners array
  let listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( !listeners.includes( listener ) ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) return this;

  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  let onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  let onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  let listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) return this;

  let index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  let listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) return this;

  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice( 0 );
  args = args || [];
  // once stuff
  let onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( let listener of listeners ) {
    let isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
  return this;
};

return EvEmitter;

} ) );

},{}],43:[function(require,module,exports){
/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

( function( window, factory ) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'desandro-matches-selector/matches-selector'
    ], function( matchesSelector ) {
      return factory( window, matchesSelector );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('desandro-matches-selector')
    );
  } else {
    // browser global
    window.fizzyUIUtils = factory(
      window,
      window.matchesSelector
    );
  }

}( window, function factory( window, matchesSelector ) {

'use strict';

var utils = {};

// ----- extend ----- //

// extends objects
utils.extend = function( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
};

// ----- modulo ----- //

utils.modulo = function( num, div ) {
  return ( ( num % div ) + div ) % div;
};

// ----- makeArray ----- //

var arraySlice = Array.prototype.slice;

// turn element or nodeList into an array
utils.makeArray = function( obj ) {
  if ( Array.isArray( obj ) ) {
    // use object if already an array
    return obj;
  }
  // return empty array if undefined or null. #6
  if ( obj === null || obj === undefined ) {
    return [];
  }

  var isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  if ( isArrayLike ) {
    // convert nodeList to array
    return arraySlice.call( obj );
  }

  // array of single index
  return [ obj ];
};

// ----- removeFrom ----- //

utils.removeFrom = function( ary, obj ) {
  var index = ary.indexOf( obj );
  if ( index != -1 ) {
    ary.splice( index, 1 );
  }
};

// ----- getParent ----- //

utils.getParent = function( elem, selector ) {
  while ( elem.parentNode && elem != document.body ) {
    elem = elem.parentNode;
    if ( matchesSelector( elem, selector ) ) {
      return elem;
    }
  }
};

// ----- getQueryElement ----- //

// use element as selector string
utils.getQueryElement = function( elem ) {
  if ( typeof elem == 'string' ) {
    return document.querySelector( elem );
  }
  return elem;
};

// ----- handleEvent ----- //

// enable .ontype to trigger from .addEventListener( elem, 'type' )
utils.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

// ----- filterFindElements ----- //

utils.filterFindElements = function( elems, selector ) {
  // make array of elems
  elems = utils.makeArray( elems );
  var ffElems = [];

  elems.forEach( function( elem ) {
    // check that elem is an actual element
    if ( !( elem instanceof HTMLElement ) ) {
      return;
    }
    // add elem if no selector
    if ( !selector ) {
      ffElems.push( elem );
      return;
    }
    // filter & find items if we have a selector
    // filter
    if ( matchesSelector( elem, selector ) ) {
      ffElems.push( elem );
    }
    // find children
    var childElems = elem.querySelectorAll( selector );
    // concat childElems to filterFound array
    for ( var i=0; i < childElems.length; i++ ) {
      ffElems.push( childElems[i] );
    }
  });

  return ffElems;
};

// ----- debounceMethod ----- //

utils.debounceMethod = function( _class, methodName, threshold ) {
  threshold = threshold || 100;
  // original method
  var method = _class.prototype[ methodName ];
  var timeoutName = methodName + 'Timeout';

  _class.prototype[ methodName ] = function() {
    var timeout = this[ timeoutName ];
    clearTimeout( timeout );

    var args = arguments;
    var _this = this;
    this[ timeoutName ] = setTimeout( function() {
      method.apply( _this, args );
      delete _this[ timeoutName ];
    }, threshold );
  };
};

// ----- docReady ----- //

utils.docReady = function( callback ) {
  var readyState = document.readyState;
  if ( readyState == 'complete' || readyState == 'interactive' ) {
    // do async to allow for other scripts to run. metafizzy/flickity#441
    setTimeout( callback );
  } else {
    document.addEventListener( 'DOMContentLoaded', callback );
  }
};

// ----- htmlInit ----- //

// http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
utils.toDashed = function( str ) {
  return str.replace( /(.)([A-Z])/g, function( match, $1, $2 ) {
    return $1 + '-' + $2;
  }).toLowerCase();
};

var console = window.console;
/**
 * allow user to initialize classes via [data-namespace] or .js-namespace class
 * htmlInit( Widget, 'widgetName' )
 * options are parsed from data-namespace-options
 */
utils.htmlInit = function( WidgetClass, namespace ) {
  utils.docReady( function() {
    var dashedNamespace = utils.toDashed( namespace );
    var dataAttr = 'data-' + dashedNamespace;
    var dataAttrElems = document.querySelectorAll( '[' + dataAttr + ']' );
    var jsDashElems = document.querySelectorAll( '.js-' + dashedNamespace );
    var elems = utils.makeArray( dataAttrElems )
      .concat( utils.makeArray( jsDashElems ) );
    var dataOptionsAttr = dataAttr + '-options';
    var jQuery = window.jQuery;

    elems.forEach( function( elem ) {
      var attr = elem.getAttribute( dataAttr ) ||
        elem.getAttribute( dataOptionsAttr );
      var options;
      try {
        options = attr && JSON.parse( attr );
      } catch ( error ) {
        // log error, do not initialize
        if ( console ) {
          console.error( 'Error parsing ' + dataAttr + ' on ' + elem.className +
          ': ' + error );
        }
        return;
      }
      // initialize
      var instance = new WidgetClass( elem, options );
      // make available via $().data('namespace')
      if ( jQuery ) {
        jQuery.data( elem, namespace, instance );
      }
    });

  });
};

// -----  ----- //

return utils;

}));

},{"desandro-matches-selector":39}],44:[function(require,module,exports){
/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

( function( window, factory ) {
  /* jshint strict: false */ /* globals define, module */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }

})( window, function factory() {
'use strict';

// -------------------------- helpers -------------------------- //

// get a number from a string, not a percentage
function getStyleSize( value ) {
  var num = parseFloat( value );
  // not a percent like '100%', and a number
  var isValid = value.indexOf('%') == -1 && !isNaN( num );
  return isValid && num;
}

function noop() {}

var logError = typeof console == 'undefined' ? noop :
  function( message ) {
    console.error( message );
  };

// -------------------------- measurements -------------------------- //

var measurements = [
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'paddingBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'marginBottom',
  'borderLeftWidth',
  'borderRightWidth',
  'borderTopWidth',
  'borderBottomWidth'
];

var measurementsLength = measurements.length;

function getZeroSize() {
  var size = {
    width: 0,
    height: 0,
    innerWidth: 0,
    innerHeight: 0,
    outerWidth: 0,
    outerHeight: 0
  };
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    size[ measurement ] = 0;
  }
  return size;
}

// -------------------------- getStyle -------------------------- //

/**
 * getStyle, get style of element, check for Firefox bug
 * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
 */
function getStyle( elem ) {
  var style = getComputedStyle( elem );
  if ( !style ) {
    logError( 'Style returned ' + style +
      '. Are you running this code in a hidden iframe on Firefox? ' +
      'See https://bit.ly/getsizebug1' );
  }
  return style;
}

// -------------------------- setup -------------------------- //

var isSetup = false;

var isBoxSizeOuter;

/**
 * setup
 * check isBoxSizerOuter
 * do on first getSize() rather than on page load for Firefox bug
 */
function setup() {
  // setup once
  if ( isSetup ) {
    return;
  }
  isSetup = true;

  // -------------------------- box sizing -------------------------- //

  /**
   * Chrome & Safari measure the outer-width on style.width on border-box elems
   * IE11 & Firefox<29 measures the inner-width
   */
  var div = document.createElement('div');
  div.style.width = '200px';
  div.style.padding = '1px 2px 3px 4px';
  div.style.borderStyle = 'solid';
  div.style.borderWidth = '1px 2px 3px 4px';
  div.style.boxSizing = 'border-box';

  var body = document.body || document.documentElement;
  body.appendChild( div );
  var style = getStyle( div );
  // round value for browser zoom. desandro/masonry#928
  isBoxSizeOuter = Math.round( getStyleSize( style.width ) ) == 200;
  getSize.isBoxSizeOuter = isBoxSizeOuter;

  body.removeChild( div );
}

// -------------------------- getSize -------------------------- //

function getSize( elem ) {
  setup();

  // use querySeletor if elem is string
  if ( typeof elem == 'string' ) {
    elem = document.querySelector( elem );
  }

  // do not proceed on non-objects
  if ( !elem || typeof elem != 'object' || !elem.nodeType ) {
    return;
  }

  var style = getStyle( elem );

  // if hidden, everything is 0
  if ( style.display == 'none' ) {
    return getZeroSize();
  }

  var size = {};
  size.width = elem.offsetWidth;
  size.height = elem.offsetHeight;

  var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

  // get all measurements
  for ( var i=0; i < measurementsLength; i++ ) {
    var measurement = measurements[i];
    var value = style[ measurement ];
    var num = parseFloat( value );
    // any 'auto', 'medium' value will be 0
    size[ measurement ] = !isNaN( num ) ? num : 0;
  }

  var paddingWidth = size.paddingLeft + size.paddingRight;
  var paddingHeight = size.paddingTop + size.paddingBottom;
  var marginWidth = size.marginLeft + size.marginRight;
  var marginHeight = size.marginTop + size.marginBottom;
  var borderWidth = size.borderLeftWidth + size.borderRightWidth;
  var borderHeight = size.borderTopWidth + size.borderBottomWidth;

  var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

  // overwrite width and height if we can get it from style
  var styleWidth = getStyleSize( style.width );
  if ( styleWidth !== false ) {
    size.width = styleWidth +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth );
  }

  var styleHeight = getStyleSize( style.height );
  if ( styleHeight !== false ) {
    size.height = styleHeight +
      // add padding and border unless it's already including it
      ( isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight );
  }

  size.innerWidth = size.width - ( paddingWidth + borderWidth );
  size.innerHeight = size.height - ( paddingHeight + borderHeight );

  size.outerWidth = size.width + marginWidth;
  size.outerHeight = size.height + marginHeight;

  return size;
}

return getSize;

});

},{}],45:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.window = global.window || {}));
}(this, (function (exports) { 'use strict';

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  /*!
   * GSAP 3.12.2
   * https://greensock.com
   *
   * @license Copyright 2008-2023, GreenSock. All rights reserved.
   * Subject to the terms at https://greensock.com/standard-license or for
   * Club GreenSock members, the agreement issued with that membership.
   * @author: Jack Doyle, jack@greensock.com
  */
  var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
      lineHeight: ""
    }
  },
      _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
  },
      _suppressOverwrites,
      _reverting,
      _context,
      _bigNum = 1e8,
      _tinyNum = 1 / _bigNum,
      _2PI = Math.PI * 2,
      _HALF_PI = _2PI / 4,
      _gsID = 0,
      _sqrt = Math.sqrt,
      _cos = Math.cos,
      _sin = Math.sin,
      _isString = function _isString(value) {
    return typeof value === "string";
  },
      _isFunction = function _isFunction(value) {
    return typeof value === "function";
  },
      _isNumber = function _isNumber(value) {
    return typeof value === "number";
  },
      _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
  },
      _isObject = function _isObject(value) {
    return typeof value === "object";
  },
      _isNotFalse = function _isNotFalse(value) {
    return value !== false;
  },
      _windowExists = function _windowExists() {
    return typeof window !== "undefined";
  },
      _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
  },
      _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function () {},
      _isArray = Array.isArray,
      _strictNumExp = /(?:-?\.?\d|\.)+/gi,
      _numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g,
      _numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g,
      _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi,
      _relExp = /[+-]=-?[.\d]+/,
      _delimitedValueExp = /[^,'"\[\]\s]+/gi,
      _unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i,
      _globalTimeline,
      _win,
      _coreInitted,
      _doc,
      _globals = {},
      _installScope = {},
      _coreReady,
      _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
  },
      _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
  },
      _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
  },
      _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
  },
      _emptyFunc = function _emptyFunc() {
    return 0;
  },
      _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
  },
      _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
  },
      _revertConfig = {
    suppressEvents: true
  },
      _reservedProps = {},
      _lazyTweens = [],
      _lazyLookup = {},
      _lastRenderedFrame,
      _plugins = {},
      _effects = {},
      _nextGCFrame = 30,
      _harnessPlugins = [],
      _callbackNames = "",
      _harness = function _harness(targets) {
    var target = targets[0],
        harnessPlugin,
        i;
    _isObject(target) || _isFunction(target) || (targets = [targets]);

    if (!(harnessPlugin = (target._gsap || {}).harness)) {
      i = _harnessPlugins.length;

      while (i-- && !_harnessPlugins[i].targetTest(target)) {}

      harnessPlugin = _harnessPlugins[i];
    }

    i = targets.length;

    while (i--) {
      targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    }

    return targets;
  },
      _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
  },
      _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
  },
      _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
  },
      _round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
  },
      _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
  },
      _parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0),
        end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
  },
      _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    var l = toFind.length,
        i = 0;

    for (; toSearch.indexOf(toFind[i]) < 0 && ++i < l;) {}

    return i < l;
  },
      _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length,
        a = _lazyTweens.slice(0),
        i,
        tween;

    _lazyLookup = {};
    _lazyTweens.length = 0;

    for (i = 0; i < l; i++) {
      tween = a[i];
      tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
  },
      _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || _reverting && time < 0 && (animation._initted || animation._startAt));
    _lazyTweens.length && !_reverting && _lazyRender();
  },
      _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
  },
      _passThrough = function _passThrough(p) {
    return p;
  },
      _setDefaults = function _setDefaults(obj, defaults) {
    for (var p in defaults) {
      p in obj || (obj[p] = defaults[p]);
    }

    return obj;
  },
      _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function (obj, defaults) {
      for (var p in defaults) {
        p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
      }
    };
  },
      _merge = function _merge(base, toMerge) {
    for (var p in toMerge) {
      base[p] = toMerge[p];
    }

    return base;
  },
      _mergeDeep = function _mergeDeep(base, toMerge) {
    for (var p in toMerge) {
      p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    }

    return base;
  },
      _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {},
        p;

    for (p in obj) {
      p in excluding || (copy[p] = obj[p]);
    }

    return copy;
  },
      _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline,
        func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;

    if (_isNotFalse(vars.inherit)) {
      while (parent) {
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
      }
    }

    return vars;
  },
      _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length,
        match = i === a2.length;

    while (match && i-- && a1[i] === a2[i]) {}

    return i < 0;
  },
      _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) {
      firstProp = "_first";
    }

    if (lastProp === void 0) {
      lastProp = "_last";
    }

    var prev = parent[lastProp],
        t;

    if (sortBy) {
      t = child[sortBy];

      while (prev && prev[sortBy] > t) {
        prev = prev._prev;
      }
    }

    if (prev) {
      child._next = prev._next;
      prev._next = child;
    } else {
      child._next = parent[firstProp];
      parent[firstProp] = child;
    }

    if (child._next) {
      child._next._prev = child;
    } else {
      parent[lastProp] = child;
    }

    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
  },
      _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) {
      firstProp = "_first";
    }

    if (lastProp === void 0) {
      lastProp = "_last";
    }

    var prev = child._prev,
        next = child._next;

    if (prev) {
      prev._next = next;
    } else if (parent[firstProp] === child) {
      parent[firstProp] = next;
    }

    if (next) {
      next._prev = prev;
    } else if (parent[lastProp] === child) {
      parent[lastProp] = prev;
    }

    child._next = child._prev = child.parent = null;
  },
      _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
  },
      _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
      var a = animation;

      while (a) {
        a._dirty = 1;
        a = a.parent;
      }
    }

    return animation;
  },
      _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;

    while (parent && parent.parent) {
      parent._dirty = 1;
      parent.totalDuration();
      parent = parent.parent;
    }

    return animation;
  },
      _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
  },
      _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
  },
      _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
  },
      _animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime /= cycleDuration);
    return tTime && whole === tTime ? whole - 1 : whole;
  },
      _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
  },
      _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
  },
      _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    var parent = animation._dp;

    if (parent && parent.smoothChildTiming && animation._ts) {
      animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));

      _setEnd(animation);

      parent._dirty || _uncache(parent, animation);
    }

    return animation;
  },
      _postAddChecks = function _postAddChecks(timeline, child) {
    var t;

    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
      t = _parentToChildTotalTime(timeline.rawTime(), child);

      if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) {
        child.render(t, true);
      }
    }

    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
      if (timeline._dur < timeline.duration()) {
        t = timeline;

        while (t._dp) {
          t.rawTime() >= 0 && t.totalTime(t._tTime);
          t = t._dp;
        }
      }

      timeline._zTime = -_tinyNum;
    }
  },
      _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));

    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);

    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime);
    return timeline;
  },
      _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
  },
      _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);

    if (!tween._initted) {
      return 1;
    }

    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
      _lazyTweens.push(tween);

      tween._lazy = [tTime, suppressEvents];
      return 1;
    }
  },
      _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
  },
      _isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
  },
      _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio,
        ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1,
        repeatDelay = tween._rDelay,
        tTime = 0,
        pt,
        iteration,
        prevIteration;

    if (repeatDelay && tween._repeat) {
      tTime = _clamp(0, tween._tDur, totalTime);
      iteration = _animationCycle(tTime, repeatDelay);
      tween._yoyo && iteration & 1 && (ratio = 1 - ratio);

      if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
        prevRatio = 1 - ratio;
        tween.vars.repeatRefresh && tween._initted && tween.invalidate();
      }
    }

    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
      if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) {
        return;
      }

      prevIteration = tween._zTime;
      tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0);
      suppressEvents || (suppressEvents = totalTime && !prevIteration);
      tween.ratio = ratio;
      tween._from && (ratio = 1 - ratio);
      tween._time = 0;
      tween._tTime = tTime;
      pt = tween._pt;

      while (pt) {
        pt.r(ratio, pt.d);
        pt = pt._next;
      }

      totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
      tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
      tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");

      if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
        ratio && _removeFromParent(tween, 1);

        if (!suppressEvents && !_reverting) {
          _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);

          tween._prom && tween._prom();
        }
      }
    } else if (!tween._zTime) {
      tween._zTime = totalTime;
    }
  },
      _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;

    if (time > prevTime) {
      child = animation._first;

      while (child && child._start <= time) {
        if (child.data === "isPause" && child._start > prevTime) {
          return child;
        }

        child = child._next;
      }
    } else {
      child = animation._last;

      while (child && child._start >= time) {
        if (child.data === "isPause" && child._start < prevTime) {
          return child;
        }

        child = child._prev;
      }
    }
  },
      _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat,
        dur = _roundPrecise(duration) || 0,
        totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
  },
      _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
  },
      _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
  },
      _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels,
        recent = animation._recent || _zeroPosition,
        clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur,
        i,
        offset,
        isPercent;

    if (_isString(position) && (isNaN(position) || position in labels)) {
      offset = position.charAt(0);
      isPercent = position.substr(-1) === "%";
      i = position.indexOf("=");

      if (offset === "<" || offset === ">") {
        i >= 0 && (position = position.replace(/=/, ""));
        return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
      }

      if (i < 0) {
        position in labels || (labels[position] = clippedDuration);
        return labels[position];
      }

      offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));

      if (isPercent && percentAnimation) {
        offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
      }

      return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }

    return position == null ? clippedDuration : +position;
  },
      _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]),
        varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1),
        vars = params[varsIndex],
        irVars,
        parent;

    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;

    if (type) {
      irVars = vars;
      parent = timeline;

      while (parent && !("immediateRender" in irVars)) {
        irVars = parent.vars.defaults || {};
        parent = _isNotFalse(parent.vars.inherit) && parent.parent;
      }

      vars.immediateRender = _isNotFalse(irVars.immediateRender);
      type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1];
    }

    return new Tween(params[0], vars, params[varsIndex + 1]);
  },
      _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
  },
      _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
  },
      getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
  },
      clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function (v) {
      return _clamp(min, max, v);
    });
  },
      _slice = [].slice,
      _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
  },
      _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) {
      accumulator = [];
    }

    return ar.forEach(function (value) {
      var _accumulator;

      return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
  },
      toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [value] : [];
  },
      selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function (v) {
      var el = value.current || value.nativeElement || value;
      return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
  },
      shuffle = function shuffle(a) {
    return a.sort(function () {
      return .5 - Math.random();
    });
  },
      distribute = function distribute(v) {
    if (_isFunction(v)) {
      return v;
    }

    var vars = _isObject(v) ? v : {
      each: v
    },
        ease = _parseEase(vars.ease),
        from = vars.from || 0,
        base = parseFloat(vars.base) || 0,
        cache = {},
        isDecimal = from > 0 && from < 1,
        ratios = isNaN(from) || isDecimal,
        axis = vars.axis,
        ratioX = from,
        ratioY = from;

    if (_isString(from)) {
      ratioX = ratioY = {
        center: .5,
        edges: .5,
        end: 1
      }[from] || 0;
    } else if (!isDecimal && ratios) {
      ratioX = from[0];
      ratioY = from[1];
    }

    return function (i, target, a) {
      var l = (a || vars).length,
          distances = cache[l],
          originX,
          originY,
          x,
          y,
          d,
          j,
          max,
          min,
          wrapAt;

      if (!distances) {
        wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [1, _bigNum])[1];

        if (!wrapAt) {
          max = -_bigNum;

          while (max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l) {}

          wrapAt--;
        }

        distances = cache[l] = [];
        originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
        originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
        max = 0;
        min = _bigNum;

        for (j = 0; j < l; j++) {
          x = j % wrapAt - originX;
          y = originY - (j / wrapAt | 0);
          distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
          d > max && (max = d);
          d < min && (min = d);
        }

        from === "random" && shuffle(distances);
        distances.max = max - min;
        distances.min = min;
        distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
        distances.b = l < 0 ? base - l : base;
        distances.u = getUnit(vars.amount || vars.each) || 0;
        ease = ease && l < 0 ? _invertEase(ease) : ease;
      }

      l = (distances[i] - distances.min) / distances.max || 0;
      return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u;
    };
  },
      _roundModifier = function _roundModifier(v) {
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length);
    return function (raw) {
      var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);

      return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw));
    };
  },
      snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo),
        radius,
        is2D;

    if (!isArray && _isObject(snapTo)) {
      radius = isArray = snapTo.radius || _bigNum;

      if (snapTo.values) {
        snapTo = toArray(snapTo.values);

        if (is2D = !_isNumber(snapTo[0])) {
          radius *= radius;
        }
      } else {
        snapTo = _roundModifier(snapTo.increment);
      }
    }

    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function (raw) {
      is2D = snapTo(raw);
      return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function (raw) {
      var x = parseFloat(is2D ? raw.x : raw),
          y = parseFloat(is2D ? raw.y : 0),
          min = _bigNum,
          closest = 0,
          i = snapTo.length,
          dx,
          dy;

      while (i--) {
        if (is2D) {
          dx = snapTo[i].x - x;
          dy = snapTo[i].y - y;
          dx = dx * dx + dy * dy;
        } else {
          dx = Math.abs(snapTo[i] - x);
        }

        if (dx < min) {
          min = dx;
          closest = i;
        }
      }

      closest = !radius || min <= radius ? snapTo[closest] : raw;
      return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
  },
      random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? !!(roundingIncrement = 0) : !returnFunction, function () {
      return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5) && (returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
  },
      pipe = function pipe() {
    for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
      functions[_key] = arguments[_key];
    }

    return function (value) {
      return functions.reduce(function (v, f) {
        return f(v);
      }, value);
    };
  },
      unitize = function unitize(func, unit) {
    return function (value) {
      return func(parseFloat(value)) + (unit || getUnit(value));
    };
  },
      normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
  },
      _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function (index) {
      return a[~~wrapper(index)];
    });
  },
      wrap = function wrap(min, max, value) {
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function (value) {
      return (range + (value - min) % range) % range + min;
    });
  },
      wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min,
        total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function (value) {
      value = (total + (value - min) % total) % total || 0;
      return min + (value > range ? total - value : value);
    });
  },
      _replaceRandom = function _replaceRandom(value) {
    var prev = 0,
        s = "",
        i,
        nums,
        end,
        isArray;

    while (~(i = value.indexOf("random(", prev))) {
      end = value.indexOf(")", i);
      isArray = value.charAt(i + 7) === "[";
      nums = value.substr(i + 7, end - i - 7).match(isArray ? _delimitedValueExp : _strictNumExp);
      s += value.substr(prev, i - prev) + random(isArray ? nums : +nums[0], isArray ? 0 : +nums[1], +nums[2] || 1e-5);
      prev = end + 1;
    }

    return s + value.substr(prev, value.length - prev);
  },
      mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin,
        outRange = outMax - outMin;
    return _conditionalReturn(value, function (value) {
      return outMin + ((value - inMin) / inRange * outRange || 0);
    });
  },
      interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function (p) {
      return (1 - p) * start + p * end;
    };

    if (!func) {
      var isString = _isString(start),
          master = {},
          p,
          i,
          interpolators,
          l,
          il;

      progress === true && (mutate = 1) && (progress = null);

      if (isString) {
        start = {
          p: start
        };
        end = {
          p: end
        };
      } else if (_isArray(start) && !_isArray(end)) {
        interpolators = [];
        l = start.length;
        il = l - 2;

        for (i = 1; i < l; i++) {
          interpolators.push(interpolate(start[i - 1], start[i]));
        }

        l--;

        func = function func(p) {
          p *= l;
          var i = Math.min(il, ~~p);
          return interpolators[i](p - i);
        };

        progress = end;
      } else if (!mutate) {
        start = _merge(_isArray(start) ? [] : {}, start);
      }

      if (!interpolators) {
        for (p in end) {
          _addPropTween.call(master, start, p, "get", end[p]);
        }

        func = function func(p) {
          return _renderPropTweens(p, master) || (isString ? start.p : start);
        };
      }
    }

    return _conditionalReturn(progress, func);
  },
      _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    var labels = timeline.labels,
        min = _bigNum,
        p,
        distance,
        label;

    for (p in labels) {
      distance = labels[p] - fromTime;

      if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
        label = p;
        min = distance;
      }
    }

    return label;
  },
      _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars,
        callback = v[type],
        prevContext = _context,
        context = animation._ctx,
        params,
        scope,
        result;

    if (!callback) {
      return;
    }

    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender();
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
  },
      _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);

    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
  },
      _quickTween,
      _registerPluginQueue = [],
      _createPlugin = function _createPlugin(config) {
    if (_windowExists() && config) {
      config = !config.name && config["default"] || config;

      var name = config.name,
          isFunc = _isFunction(config),
          Plugin = name && !isFunc && config.init ? function () {
        this._props = [];
      } : config,
          instanceDefaults = {
        init: _emptyFunc,
        render: _renderPropTweens,
        add: _addPropTween,
        kill: _killPropTweensOf,
        modifier: _addPluginModifier,
        rawVars: 0
      },
          statics = {
        targetTest: 0,
        get: 0,
        getSetter: _getSetter,
        aliases: {},
        register: 0
      };

      _wake();

      if (config !== Plugin) {
        if (_plugins[name]) {
          return;
        }

        _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics));

        _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics)));

        _plugins[Plugin.prop = name] = Plugin;

        if (config.targetTest) {
          _harnessPlugins.push(Plugin);

          _reservedProps[name] = 1;
        }

        name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin";
      }

      _addGlobal(name, Plugin);

      config.register && config.register(gsap, Plugin, PropTween);
    } else {
      config && _registerPluginQueue.push(config);
    }
  },
      _255 = 255,
      _colorLookup = {
    aqua: [0, _255, _255],
    lime: [0, _255, 0],
    silver: [192, 192, 192],
    black: [0, 0, 0],
    maroon: [128, 0, 0],
    teal: [0, 128, 128],
    blue: [0, 0, _255],
    navy: [0, 0, 128],
    white: [_255, _255, _255],
    olive: [128, 128, 0],
    yellow: [_255, _255, 0],
    orange: [_255, 165, 0],
    gray: [128, 128, 128],
    purple: [128, 0, 128],
    green: [0, 128, 0],
    red: [_255, 0, 0],
    pink: [_255, 192, 203],
    cyan: [0, _255, _255],
    transparent: [_255, _255, _255, 0]
  },
      _hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
  },
      splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [v >> 16, v >> 8 & _255, v & _255] : 0,
        r,
        g,
        b,
        h,
        s,
        l,
        max,
        min,
        d,
        wasHSL;

    if (!a) {
      if (v.substr(-1) === ",") {
        v = v.substr(0, v.length - 1);
      }

      if (_colorLookup[v]) {
        a = _colorLookup[v];
      } else if (v.charAt(0) === "#") {
        if (v.length < 6) {
          r = v.charAt(1);
          g = v.charAt(2);
          b = v.charAt(3);
          v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
        }

        if (v.length === 9) {
          a = parseInt(v.substr(1, 6), 16);
          return [a >> 16, a >> 8 & _255, a & _255, parseInt(v.substr(7), 16) / 255];
        }

        v = parseInt(v.substr(1), 16);
        a = [v >> 16, v >> 8 & _255, v & _255];
      } else if (v.substr(0, 3) === "hsl") {
        a = wasHSL = v.match(_strictNumExp);

        if (!toHSL) {
          h = +a[0] % 360 / 360;
          s = +a[1] / 100;
          l = +a[2] / 100;
          g = l <= .5 ? l * (s + 1) : l + s - l * s;
          r = l * 2 - g;
          a.length > 3 && (a[3] *= 1);
          a[0] = _hue(h + 1 / 3, r, g);
          a[1] = _hue(h, r, g);
          a[2] = _hue(h - 1 / 3, r, g);
        } else if (~v.indexOf("=")) {
          a = v.match(_numExp);
          forceAlpha && a.length < 4 && (a[3] = 1);
          return a;
        }
      } else {
        a = v.match(_strictNumExp) || _colorLookup.transparent;
      }

      a = a.map(Number);
    }

    if (toHSL && !wasHSL) {
      r = a[0] / _255;
      g = a[1] / _255;
      b = a[2] / _255;
      max = Math.max(r, g, b);
      min = Math.min(r, g, b);
      l = (max + min) / 2;

      if (max === min) {
        h = s = 0;
      } else {
        d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
        h *= 60;
      }

      a[0] = ~~(h + .5);
      a[1] = ~~(s * 100 + .5);
      a[2] = ~~(l * 100 + .5);
    }

    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
  },
      _colorOrderData = function _colorOrderData(v) {
    var values = [],
        c = [],
        i = -1;
    v.split(_colorExp).forEach(function (v) {
      var a = v.match(_numWithUnitExp) || [];
      values.push.apply(values, a);
      c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
  },
      _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "",
        colors = (s + result).match(_colorExp),
        type = toHSL ? "hsla(" : "rgba(",
        i = 0,
        c,
        shell,
        d,
        l;

    if (!colors) {
      return s;
    }

    colors = colors.map(function (color) {
      return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });

    if (orderMatchData) {
      d = _colorOrderData(s);
      c = orderMatchData.c;

      if (c.join(result) !== d.c.join(result)) {
        shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
        l = shell.length - 1;

        for (; i < l; i++) {
          result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
      }
    }

    if (!shell) {
      shell = s.split(_colorExp);
      l = shell.length - 1;

      for (; i < l; i++) {
        result += shell[i] + colors[i];
      }
    }

    return result + shell[l];
  },
      _colorExp = function () {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b",
        p;

    for (p in _colorLookup) {
      s += "|" + p + "\\b";
    }

    return new RegExp(s + ")", "gi");
  }(),
      _hslExp = /hsl[a]?\(/,
      _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "),
        toHSL;
    _colorExp.lastIndex = 0;

    if (_colorExp.test(combined)) {
      toHSL = _hslExp.test(combined);
      a[1] = _formatColors(a[1], toHSL);
      a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1]));
      return true;
    }
  },
      _tickerActive,
      _ticker = function () {
    var _getTime = Date.now,
        _lagThreshold = 500,
        _adjustedLag = 33,
        _startTime = _getTime(),
        _lastUpdate = _startTime,
        _gap = 1000 / 240,
        _nextTime = _gap,
        _listeners = [],
        _id,
        _req,
        _raf,
        _self,
        _delta,
        _i,
        _tick = function _tick(v) {
      var elapsed = _getTime() - _lastUpdate,
          manual = v === true,
          overlap,
          dispatch,
          time,
          frame;

      elapsed > _lagThreshold && (_startTime += elapsed - _adjustedLag);
      _lastUpdate += elapsed;
      time = _lastUpdate - _startTime;
      overlap = time - _nextTime;

      if (overlap > 0 || manual) {
        frame = ++_self.frame;
        _delta = time - _self.time * 1000;
        _self.time = time = time / 1000;
        _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
        dispatch = 1;
      }

      manual || (_id = _req(_tick));

      if (dispatch) {
        for (_i = 0; _i < _listeners.length; _i++) {
          _listeners[_i](time, _delta, frame, v);
        }
      }
    };

    _self = {
      time: 0,
      frame: 0,
      tick: function tick() {
        _tick(true);
      },
      deltaRatio: function deltaRatio(fps) {
        return _delta / (1000 / (fps || 60));
      },
      wake: function wake() {
        if (_coreReady) {
          if (!_coreInitted && _windowExists()) {
            _win = _coreInitted = window;
            _doc = _win.document || {};
            _globals.gsap = gsap;
            (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);

            _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});

            _raf = _win.requestAnimationFrame;

            _registerPluginQueue.forEach(_createPlugin);
          }

          _id && _self.sleep();

          _req = _raf || function (f) {
            return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
          };

          _tickerActive = 1;

          _tick(2);
        }
      },
      sleep: function sleep() {
        (_raf ? _win.cancelAnimationFrame : clearTimeout)(_id);
        _tickerActive = 0;
        _req = _emptyFunc;
      },
      lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
        _lagThreshold = threshold || Infinity;
        _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
      },
      fps: function fps(_fps) {
        _gap = 1000 / (_fps || 240);
        _nextTime = _self.time * 1000 + _gap;
      },
      add: function add(callback, once, prioritize) {
        var func = once ? function (t, d, f, v) {
          callback(t, d, f, v);

          _self.remove(func);
        } : callback;

        _self.remove(callback);

        _listeners[prioritize ? "unshift" : "push"](func);

        _wake();

        return func;
      },
      remove: function remove(callback, i) {
        ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
      },
      _listeners: _listeners
    };
    return _self;
  }(),
      _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
  },
      _easeMap = {},
      _customEaseExp = /^[\d.\-M][\d.\-,\s]/,
      _quotesExp = /["']/g,
      _parseObjectInString = function _parseObjectInString(value) {
    var obj = {},
        split = value.substr(1, value.length - 3).split(":"),
        key = split[0],
        i = 1,
        l = split.length,
        index,
        val,
        parsedVal;

    for (; i < l; i++) {
      val = split[i];
      index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
      parsedVal = val.substr(0, index);
      obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
      key = val.substr(index + 1).trim();
    }

    return obj;
  },
      _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1,
        close = value.indexOf(")"),
        nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
  },
      _configEaseFromString = function _configEaseFromString(name) {
    var split = (name + "").split("("),
        ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [_parseObjectInString(split[1])] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
  },
      _invertEase = function _invertEase(ease) {
    return function (p) {
      return 1 - ease(1 - p);
    };
  },
      _propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first,
        ease;

    while (child) {
      if (child instanceof Timeline) {
        _propagateYoyoEase(child, isYoyo);
      } else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
        if (child.timeline) {
          _propagateYoyoEase(child.timeline, isYoyo);
        } else {
          ease = child._ease;
          child._ease = child._yEase;
          child._yEase = ease;
          child._yoyo = isYoyo;
        }
      }

      child = child._next;
    }
  },
      _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
  },
      _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) {
      easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
      };
    }

    if (easeInOut === void 0) {
      easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
      };
    }

    var ease = {
      easeIn: easeIn,
      easeOut: easeOut,
      easeInOut: easeInOut
    },
        lowercaseName;

    _forEachName(names, function (name) {
      _easeMap[name] = _globals[name] = ease;
      _easeMap[lowercaseName = name.toLowerCase()] = easeOut;

      for (var p in ease) {
        _easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
      }
    });

    return ease;
  },
      _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function (p) {
      return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
  },
      _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1,
        p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1),
        p3 = p2 / _2PI * (Math.asin(1 / p1) || 0),
        easeOut = function easeOut(p) {
      return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    },
        ease = type === "out" ? easeOut : type === "in" ? function (p) {
      return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);

    p2 = _2PI / p2;

    ease.config = function (amplitude, period) {
      return _configElastic(type, amplitude, period);
    };

    return ease;
  },
      _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) {
      overshoot = 1.70158;
    }

    var easeOut = function easeOut(p) {
      return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    },
        ease = type === "out" ? easeOut : type === "in" ? function (p) {
      return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);

    ease.config = function (overshoot) {
      return _configBack(type, overshoot);
    };

    return ease;
  };

  _forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function (name, i) {
    var power = i < 5 ? i + 1 : i;

    _insertEase(name + ",Power" + (power - 1), i ? function (p) {
      return Math.pow(p, power);
    } : function (p) {
      return p;
    }, function (p) {
      return 1 - Math.pow(1 - p, power);
    }, function (p) {
      return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
  });

  _easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;

  _insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());

  (function (n, c) {
    var n1 = 1 / c,
        n2 = 2 * n1,
        n3 = 2.5 * n1,
        easeOut = function easeOut(p) {
      return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };

    _insertEase("Bounce", function (p) {
      return 1 - easeOut(1 - p);
    }, easeOut);
  })(7.5625, 2.75);

  _insertEase("Expo", function (p) {
    return p ? Math.pow(2, 10 * (p - 1)) : 0;
  });

  _insertEase("Circ", function (p) {
    return -(_sqrt(1 - p * p) - 1);
  });

  _insertEase("Sine", function (p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
  });

  _insertEase("Back", _configBack("in"), _configBack("out"), _configBack());

  _easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
      if (steps === void 0) {
        steps = 1;
      }

      var p1 = 1 / steps,
          p2 = steps + (immediateStart ? 0 : 1),
          p3 = immediateStart ? 1 : 0,
          max = 1 - _tinyNum;
      return function (p) {
        return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
      };
    }
  };
  _defaults.ease = _easeMap["quad.out"];

  _forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function (name) {
    return _callbackNames += name + "," + name + "Params,";
  });

  var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
  };
  var Animation = function () {
    function Animation(vars) {
      this.vars = vars;
      this._delay = +vars.delay || 0;

      if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
        this._rDelay = vars.repeatDelay || 0;
        this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
      }

      this._ts = 1;

      _setDuration(this, +vars.duration, 1, 1);

      this.data = vars.data;

      if (_context) {
        this._ctx = _context;

        _context.data.push(this);
      }

      _tickerActive || _ticker.wake();
    }

    var _proto = Animation.prototype;

    _proto.delay = function delay(value) {
      if (value || value === 0) {
        this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
        this._delay = value;
        return this;
      }

      return this._delay;
    };

    _proto.duration = function duration(value) {
      return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };

    _proto.totalDuration = function totalDuration(value) {
      if (!arguments.length) {
        return this._tDur;
      }

      this._dirty = 0;
      return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };

    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
      _wake();

      if (!arguments.length) {
        return this._tTime;
      }

      var parent = this._dp;

      if (parent && parent.smoothChildTiming && this._ts) {
        _alignPlayhead(this, _totalTime);

        !parent._dp || parent.parent || _postAddChecks(parent, this);

        while (parent && parent.parent) {
          if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) {
            parent.totalTime(parent._tTime, true);
          }

          parent = parent.parent;
        }

        if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) {
          _addToTimeline(this._dp, this, this._start - this._delay);
        }
      }

      if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
        this._ts || (this._pTime = _totalTime);

        _lazySafeRender(this, _totalTime, suppressEvents);
      }

      return this;
    };

    _proto.time = function time(value, suppressEvents) {
      return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time;
    };

    _proto.totalProgress = function totalProgress(value, suppressEvents) {
      return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.ratio;
    };

    _proto.progress = function progress(value, suppressEvents) {
      return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.ratio;
    };

    _proto.iteration = function iteration(value, suppressEvents) {
      var cycleDuration = this.duration() + this._rDelay;

      return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    };

    _proto.timeScale = function timeScale(value) {
      if (!arguments.length) {
        return this._rts === -_tinyNum ? 0 : this._rts;
      }

      if (this._rts === value) {
        return this;
      }

      var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime;
      this._rts = +value || 0;
      this._ts = this._ps || value === -_tinyNum ? 0 : this._rts;
      this.totalTime(_clamp(-Math.abs(this._delay), this._tDur, tTime), true);

      _setEnd(this);

      return _recacheAncestors(this);
    };

    _proto.paused = function paused(value) {
      if (!arguments.length) {
        return this._ps;
      }

      if (this._ps !== value) {
        this._ps = value;

        if (value) {
          this._pTime = this._tTime || Math.max(-this._delay, this.rawTime());
          this._ts = this._act = 0;
        } else {
          _wake();

          this._ts = this._rts;
          this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum));
        }
      }

      return this;
    };

    _proto.startTime = function startTime(value) {
      if (arguments.length) {
        this._start = value;
        var parent = this.parent || this._dp;
        parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, value - this._delay);
        return this;
      }

      return this._start;
    };

    _proto.endTime = function endTime(includeRepeats) {
      return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };

    _proto.rawTime = function rawTime(wrapRepeats) {
      var parent = this.parent || this._dp;
      return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };

    _proto.revert = function revert(config) {
      if (config === void 0) {
        config = _revertConfig;
      }

      var prevIsReverting = _reverting;
      _reverting = config;

      if (this._initted || this._startAt) {
        this.timeline && this.timeline.revert(config);
        this.totalTime(-0.01, config.suppressEvents);
      }

      this.data !== "nested" && config.kill !== false && this.kill();
      _reverting = prevIsReverting;
      return this;
    };

    _proto.globalTime = function globalTime(rawTime) {
      var animation = this,
          time = arguments.length ? rawTime : animation.rawTime();

      while (animation) {
        time = animation._start + time / (animation._ts || 1);
        animation = animation._dp;
      }

      return !this.parent && this._sat ? this._sat.vars.immediateRender ? -Infinity : this._sat.globalTime(rawTime) : time;
    };

    _proto.repeat = function repeat(value) {
      if (arguments.length) {
        this._repeat = value === Infinity ? -2 : value;
        return _onUpdateTotalDuration(this);
      }

      return this._repeat === -2 ? Infinity : this._repeat;
    };

    _proto.repeatDelay = function repeatDelay(value) {
      if (arguments.length) {
        var time = this._time;
        this._rDelay = value;

        _onUpdateTotalDuration(this);

        return time ? this.time(time) : this;
      }

      return this._rDelay;
    };

    _proto.yoyo = function yoyo(value) {
      if (arguments.length) {
        this._yoyo = value;
        return this;
      }

      return this._yoyo;
    };

    _proto.seek = function seek(position, suppressEvents) {
      return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };

    _proto.restart = function restart(includeDelay, suppressEvents) {
      return this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
    };

    _proto.play = function play(from, suppressEvents) {
      from != null && this.seek(from, suppressEvents);
      return this.reversed(false).paused(false);
    };

    _proto.reverse = function reverse(from, suppressEvents) {
      from != null && this.seek(from || this.totalDuration(), suppressEvents);
      return this.reversed(true).paused(false);
    };

    _proto.pause = function pause(atTime, suppressEvents) {
      atTime != null && this.seek(atTime, suppressEvents);
      return this.paused(true);
    };

    _proto.resume = function resume() {
      return this.paused(false);
    };

    _proto.reversed = function reversed(value) {
      if (arguments.length) {
        !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0));
        return this;
      }

      return this._rts < 0;
    };

    _proto.invalidate = function invalidate() {
      this._initted = this._act = 0;
      this._zTime = -_tinyNum;
      return this;
    };

    _proto.isActive = function isActive() {
      var parent = this.parent || this._dp,
          start = this._start,
          rawTime;
      return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };

    _proto.eventCallback = function eventCallback(type, callback, params) {
      var vars = this.vars;

      if (arguments.length > 1) {
        if (!callback) {
          delete vars[type];
        } else {
          vars[type] = callback;
          params && (vars[type + "Params"] = params);
          type === "onUpdate" && (this._onUpdate = callback);
        }

        return this;
      }

      return vars[type];
    };

    _proto.then = function then(onFulfilled) {
      var self = this;
      return new Promise(function (resolve) {
        var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough,
            _resolve = function _resolve() {
          var _then = self.then;
          self.then = null;
          _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
          resolve(f);
          self.then = _then;
        };

        if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) {
          _resolve();
        } else {
          self._prom = _resolve;
        }
      });
    };

    _proto.kill = function kill() {
      _interrupt(this);
    };

    return Animation;
  }();

  _setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
  });

  var Timeline = function (_Animation) {
    _inheritsLoose(Timeline, _Animation);

    function Timeline(vars, position) {
      var _this;

      if (vars === void 0) {
        vars = {};
      }

      _this = _Animation.call(this, vars) || this;
      _this.labels = {};
      _this.smoothChildTiming = !!vars.smoothChildTiming;
      _this.autoRemoveChildren = !!vars.autoRemoveChildren;
      _this._sort = _isNotFalse(vars.sortChildren);
      _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
      vars.reversed && _this.reverse();
      vars.paused && _this.paused(true);
      vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
      return _this;
    }

    var _proto2 = Timeline.prototype;

    _proto2.to = function to(targets, vars, position) {
      _createTweenType(0, arguments, this);

      return this;
    };

    _proto2.from = function from(targets, vars, position) {
      _createTweenType(1, arguments, this);

      return this;
    };

    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
      _createTweenType(2, arguments, this);

      return this;
    };

    _proto2.set = function set(targets, vars, position) {
      vars.duration = 0;
      vars.parent = this;
      _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
      vars.immediateRender = !!vars.immediateRender;
      new Tween(targets, vars, _parsePosition(this, position), 1);
      return this;
    };

    _proto2.call = function call(callback, params, position) {
      return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    };

    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
      vars.duration = duration;
      vars.stagger = vars.stagger || stagger;
      vars.onComplete = onCompleteAll;
      vars.onCompleteParams = onCompleteAllParams;
      vars.parent = this;
      new Tween(targets, vars, _parsePosition(this, position));
      return this;
    };

    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
      vars.runBackwards = 1;
      _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
      return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };

    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
      toVars.startAt = fromVars;
      _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
      return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };

    _proto2.render = function render(totalTime, suppressEvents, force) {
      var prevTime = this._time,
          tDur = this._dirty ? this.totalDuration() : this._tDur,
          dur = this._dur,
          tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime),
          crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur),
          time,
          child,
          next,
          iteration,
          cycleDuration,
          prevPaused,
          pauseTween,
          timeScale,
          prevStart,
          prevIteration,
          yoyo,
          isYoyo;
      this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);

      if (tTime !== this._tTime || force || crossingStart) {
        if (prevTime !== this._time && dur) {
          tTime += this._time - prevTime;
          totalTime += this._time - prevTime;
        }

        time = tTime;
        prevStart = this._start;
        timeScale = this._ts;
        prevPaused = !timeScale;

        if (crossingStart) {
          dur || (prevTime = this._zTime);
          (totalTime || !suppressEvents) && (this._zTime = totalTime);
        }

        if (this._repeat) {
          yoyo = this._yoyo;
          cycleDuration = dur + this._rDelay;

          if (this._repeat < -1 && totalTime < 0) {
            return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
          }

          time = _roundPrecise(tTime % cycleDuration);

          if (tTime === tDur) {
            iteration = this._repeat;
            time = dur;
          } else {
            iteration = ~~(tTime / cycleDuration);

            if (iteration && iteration === tTime / cycleDuration) {
              time = dur;
              iteration--;
            }

            time > dur && (time = dur);
          }

          prevIteration = _animationCycle(this._tTime, cycleDuration);
          !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration);

          if (yoyo && iteration & 1) {
            time = dur - time;
            isYoyo = 1;
          }

          if (iteration !== prevIteration && !this._lock) {
            var rewinding = yoyo && prevIteration & 1,
                doesWrap = rewinding === (yoyo && iteration & 1);
            iteration < prevIteration && (rewinding = !rewinding);
            prevTime = rewinding ? 0 : tTime % dur ? dur : tTime;
            this._lock = 1;
            this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
            this._tTime = tTime;
            !suppressEvents && this.parent && _callback(this, "onRepeat");
            this.vars.repeatRefresh && !isYoyo && (this.invalidate()._lock = 1);

            if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) {
              return this;
            }

            dur = this._dur;
            tDur = this._tDur;

            if (doesWrap) {
              this._lock = 2;
              prevTime = rewinding ? dur : -0.0001;
              this.render(prevTime, true);
              this.vars.repeatRefresh && !isYoyo && this.invalidate();
            }

            this._lock = 0;

            if (!this._ts && !prevPaused) {
              return this;
            }

            _propagateYoyoEase(this, isYoyo);
          }
        }

        if (this._hasPause && !this._forcing && this._lock < 2) {
          pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));

          if (pauseTween) {
            tTime -= time - (time = pauseTween._start);
          }
        }

        this._tTime = tTime;
        this._time = time;
        this._act = !timeScale;

        if (!this._initted) {
          this._onUpdate = this.vars.onUpdate;
          this._initted = 1;
          this._zTime = totalTime;
          prevTime = 0;
        }

        if (!prevTime && time && !suppressEvents && !iteration) {
          _callback(this, "onStart");

          if (this._tTime !== tTime) {
            return this;
          }
        }

        if (time >= prevTime && totalTime >= 0) {
          child = this._first;

          while (child) {
            next = child._next;

            if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
              if (child.parent !== this) {
                return this.render(totalTime, suppressEvents, force);
              }

              child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);

              if (time !== this._time || !this._ts && !prevPaused) {
                pauseTween = 0;
                next && (tTime += this._zTime = -_tinyNum);
                break;
              }
            }

            child = next;
          }
        } else {
          child = this._last;
          var adjustedTime = totalTime < 0 ? totalTime : time;

          while (child) {
            next = child._prev;

            if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
              if (child.parent !== this) {
                return this.render(totalTime, suppressEvents, force);
              }

              child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && (child._initted || child._startAt));

              if (time !== this._time || !this._ts && !prevPaused) {
                pauseTween = 0;
                next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum);
                break;
              }
            }

            child = next;
          }
        }

        if (pauseTween && !suppressEvents) {
          this.pause();
          pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;

          if (this._ts) {
            this._start = prevStart;

            _setEnd(this);

            return this.render(totalTime, suppressEvents, force);
          }
        }

        this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
        if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) if (!this._lock) {
          (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);

          if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);

            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
          }
        }
      }

      return this;
    };

    _proto2.add = function add(child, position) {
      var _this2 = this;

      _isNumber(position) || (position = _parsePosition(this, position, child));

      if (!(child instanceof Animation)) {
        if (_isArray(child)) {
          child.forEach(function (obj) {
            return _this2.add(obj, position);
          });
          return this;
        }

        if (_isString(child)) {
          return this.addLabel(child, position);
        }

        if (_isFunction(child)) {
          child = Tween.delayedCall(0, child);
        } else {
          return this;
        }
      }

      return this !== child ? _addToTimeline(this, child, position) : this;
    };

    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
      if (nested === void 0) {
        nested = true;
      }

      if (tweens === void 0) {
        tweens = true;
      }

      if (timelines === void 0) {
        timelines = true;
      }

      if (ignoreBeforeTime === void 0) {
        ignoreBeforeTime = -_bigNum;
      }

      var a = [],
          child = this._first;

      while (child) {
        if (child._start >= ignoreBeforeTime) {
          if (child instanceof Tween) {
            tweens && a.push(child);
          } else {
            timelines && a.push(child);
            nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
          }
        }

        child = child._next;
      }

      return a;
    };

    _proto2.getById = function getById(id) {
      var animations = this.getChildren(1, 1, 1),
          i = animations.length;

      while (i--) {
        if (animations[i].vars.id === id) {
          return animations[i];
        }
      }
    };

    _proto2.remove = function remove(child) {
      if (_isString(child)) {
        return this.removeLabel(child);
      }

      if (_isFunction(child)) {
        return this.killTweensOf(child);
      }

      _removeLinkedListItem(this, child);

      if (child === this._recent) {
        this._recent = this._last;
      }

      return _uncache(this);
    };

    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
      if (!arguments.length) {
        return this._tTime;
      }

      this._forcing = 1;

      if (!this._dp && this._ts) {
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
      }

      _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);

      this._forcing = 0;
      return this;
    };

    _proto2.addLabel = function addLabel(label, position) {
      this.labels[label] = _parsePosition(this, position);
      return this;
    };

    _proto2.removeLabel = function removeLabel(label) {
      delete this.labels[label];
      return this;
    };

    _proto2.addPause = function addPause(position, callback, params) {
      var t = Tween.delayedCall(0, callback || _emptyFunc, params);
      t.data = "isPause";
      this._hasPause = 1;
      return _addToTimeline(this, t, _parsePosition(this, position));
    };

    _proto2.removePause = function removePause(position) {
      var child = this._first;
      position = _parsePosition(this, position);

      while (child) {
        if (child._start === position && child.data === "isPause") {
          _removeFromParent(child);
        }

        child = child._next;
      }
    };

    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
      var tweens = this.getTweensOf(targets, onlyActive),
          i = tweens.length;

      while (i--) {
        _overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
      }

      return this;
    };

    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
      var a = [],
          parsedTargets = toArray(targets),
          child = this._first,
          isGlobalTime = _isNumber(onlyActive),
          children;

      while (child) {
        if (child instanceof Tween) {
          if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) {
            a.push(child);
          }
        } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) {
          a.push.apply(a, children);
        }

        child = child._next;
      }

      return a;
    };

    _proto2.tweenTo = function tweenTo(position, vars) {
      vars = vars || {};

      var tl = this,
          endTime = _parsePosition(tl, position),
          _vars = vars,
          startAt = _vars.startAt,
          _onStart = _vars.onStart,
          onStartParams = _vars.onStartParams,
          immediateRender = _vars.immediateRender,
          initted,
          tween = Tween.to(tl, _setDefaults({
        ease: vars.ease || "none",
        lazy: false,
        immediateRender: false,
        time: endTime,
        overwrite: "auto",
        duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
        onStart: function onStart() {
          tl.pause();

          if (!initted) {
            var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
            tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
            initted = 1;
          }

          _onStart && _onStart.apply(tween, onStartParams || []);
        }
      }, vars));

      return immediateRender ? tween.render(0) : tween;
    };

    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
      return this.tweenTo(toPosition, _setDefaults({
        startAt: {
          time: _parsePosition(this, fromPosition)
        }
      }, vars));
    };

    _proto2.recent = function recent() {
      return this._recent;
    };

    _proto2.nextLabel = function nextLabel(afterTime) {
      if (afterTime === void 0) {
        afterTime = this._time;
      }

      return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };

    _proto2.previousLabel = function previousLabel(beforeTime) {
      if (beforeTime === void 0) {
        beforeTime = this._time;
      }

      return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };

    _proto2.currentLabel = function currentLabel(value) {
      return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };

    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
      if (ignoreBeforeTime === void 0) {
        ignoreBeforeTime = 0;
      }

      var child = this._first,
          labels = this.labels,
          p;

      while (child) {
        if (child._start >= ignoreBeforeTime) {
          child._start += amount;
          child._end += amount;
        }

        child = child._next;
      }

      if (adjustLabels) {
        for (p in labels) {
          if (labels[p] >= ignoreBeforeTime) {
            labels[p] += amount;
          }
        }
      }

      return _uncache(this);
    };

    _proto2.invalidate = function invalidate(soft) {
      var child = this._first;
      this._lock = 0;

      while (child) {
        child.invalidate(soft);
        child = child._next;
      }

      return _Animation.prototype.invalidate.call(this, soft);
    };

    _proto2.clear = function clear(includeLabels) {
      if (includeLabels === void 0) {
        includeLabels = true;
      }

      var child = this._first,
          next;

      while (child) {
        next = child._next;
        this.remove(child);
        child = next;
      }

      this._dp && (this._time = this._tTime = this._pTime = 0);
      includeLabels && (this.labels = {});
      return _uncache(this);
    };

    _proto2.totalDuration = function totalDuration(value) {
      var max = 0,
          self = this,
          child = self._last,
          prevStart = _bigNum,
          prev,
          start,
          parent;

      if (arguments.length) {
        return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
      }

      if (self._dirty) {
        parent = self.parent;

        while (child) {
          prev = child._prev;
          child._dirty && child.totalDuration();
          start = child._start;

          if (start > prevStart && self._sort && child._ts && !self._lock) {
            self._lock = 1;
            _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
          } else {
            prevStart = start;
          }

          if (start < 0 && child._ts) {
            max -= start;

            if (!parent && !self._dp || parent && parent.smoothChildTiming) {
              self._start += start / self._ts;
              self._time -= start;
              self._tTime -= start;
            }

            self.shiftChildren(-start, false, -1e999);
            prevStart = 0;
          }

          child._end > max && child._ts && (max = child._end);
          child = prev;
        }

        _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);

        self._dirty = 0;
      }

      return self._tDur;
    };

    Timeline.updateRoot = function updateRoot(time) {
      if (_globalTimeline._ts) {
        _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));

        _lastRenderedFrame = _ticker.frame;
      }

      if (_ticker.frame >= _nextGCFrame) {
        _nextGCFrame += _config.autoSleep || 120;
        var child = _globalTimeline._first;
        if (!child || !child._ts) if (_config.autoSleep && _ticker._listeners.length < 2) {
          while (child && !child._ts) {
            child = child._next;
          }

          child || _ticker.sleep();
        }
      }
    };

    return Timeline;
  }(Animation);

  _setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
  });

  var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter),
        index = 0,
        matchIndex = 0,
        result,
        startNums,
        color,
        endNum,
        chunk,
        startNum,
        hasRandom,
        a;
    pt.b = start;
    pt.e = end;
    start += "";
    end += "";

    if (hasRandom = ~end.indexOf("random(")) {
      end = _replaceRandom(end);
    }

    if (stringFilter) {
      a = [start, end];
      stringFilter(a, target, prop);
      start = a[0];
      end = a[1];
    }

    startNums = start.match(_complexStringNumExp) || [];

    while (result = _complexStringNumExp.exec(end)) {
      endNum = result[0];
      chunk = end.substring(index, result.index);

      if (color) {
        color = (color + 1) % 5;
      } else if (chunk.substr(-5) === "rgba(") {
        color = 1;
      }

      if (endNum !== startNums[matchIndex++]) {
        startNum = parseFloat(startNums[matchIndex - 1]) || 0;
        pt._pt = {
          _next: pt._pt,
          p: chunk || matchIndex === 1 ? chunk : ",",
          s: startNum,
          c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
          m: color && color < 4 ? Math.round : 0
        };
        index = _complexStringNumExp.lastIndex;
      }
    }

    pt.c = index < end.length ? end.substring(index, end.length) : "";
    pt.fp = funcParam;

    if (_relExp.test(end) || hasRandom) {
      pt.e = 0;
    }

    this._pt = pt;
    return pt;
  },
      _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop],
        parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](),
        setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc,
        pt;

    if (_isString(end)) {
      if (~end.indexOf("random(")) {
        end = _replaceRandom(end);
      }

      if (end.charAt(1) === "=") {
        pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);

        if (pt || pt === 0) {
          end = pt;
        }
      }
    }

    if (!optional || parsedStart !== end || _forceAllPropTweens) {
      if (!isNaN(parsedStart * end) && end !== "") {
        pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
        funcParam && (pt.fp = funcParam);
        modifier && pt.modifier(modifier, this, target);
        return this._pt = pt;
      }

      !currentValue && !(prop in target) && _missingPlugin(prop, end);
      return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
  },
      _processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));

    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) {
      return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    }

    var copy = {},
        p;

    for (p in vars) {
      copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    }

    return copy;
  },
      _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;

    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
      tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);

      if (tween !== _quickTween) {
        ptLookup = tween._ptLookup[tween._targets.indexOf(target)];
        i = plugin._props.length;

        while (i--) {
          ptLookup[plugin._props[i]] = pt;
        }
      }
    }

    return plugin;
  },
      _overwritingTween,
      _forceAllPropTweens,
      _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars,
        ease = vars.ease,
        startAt = vars.startAt,
        immediateRender = vars.immediateRender,
        lazy = vars.lazy,
        onUpdate = vars.onUpdate,
        onUpdateParams = vars.onUpdateParams,
        callbackScope = vars.callbackScope,
        runBackwards = vars.runBackwards,
        yoyoEase = vars.yoyoEase,
        keyframes = vars.keyframes,
        autoRevert = vars.autoRevert,
        dur = tween._dur,
        prevStartAt = tween._startAt,
        targets = tween._targets,
        parent = tween.parent,
        fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets,
        autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites,
        tl = tween.timeline,
        cleanVars,
        i,
        p,
        pt,
        target,
        hasPriority,
        gsData,
        harness,
        plugin,
        ptLookup,
        index,
        harnessVars,
        overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;

    if (yoyoEase && tween._yoyo && !tween._repeat) {
      yoyoEase = tween._yEase;
      tween._yEase = tween._ease;
      tween._ease = yoyoEase;
    }

    tween._from = !tl && !!vars.runBackwards;

    if (!tl || keyframes && !vars.stagger) {
      harness = targets[0] ? _getCache(targets[0]).harness : 0;
      harnessVars = harness && vars[harness.prop];
      cleanVars = _copyExcluding(vars, _reservedProps);

      if (prevStartAt) {
        prevStartAt._zTime < 0 && prevStartAt.progress(1);
        time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig);
        prevStartAt._lazy = 0;
      }

      if (startAt) {
        _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
          data: "isStart",
          overwrite: false,
          parent: parent,
          immediateRender: true,
          lazy: !prevStartAt && _isNotFalse(lazy),
          startAt: null,
          delay: 0,
          onUpdate: onUpdate,
          onUpdateParams: onUpdateParams,
          callbackScope: callbackScope,
          stagger: 0
        }, startAt)));

        tween._startAt._dp = 0;
        tween._startAt._sat = tween;
        time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill);

        if (immediateRender) {
          if (dur && time <= 0 && tTime <= 0) {
            time && (tween._zTime = time);
            return;
          }
        }
      } else if (runBackwards && dur) {
        if (!prevStartAt) {
          time && (immediateRender = false);
          p = _setDefaults({
            overwrite: false,
            data: "isFromStart",
            lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
            immediateRender: immediateRender,
            stagger: 0,
            parent: parent
          }, cleanVars);
          harnessVars && (p[harness.prop] = harnessVars);

          _removeFromParent(tween._startAt = Tween.set(targets, p));

          tween._startAt._dp = 0;
          tween._startAt._sat = tween;
          time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
          tween._zTime = time;

          if (!immediateRender) {
            _initTween(tween._startAt, _tinyNum, _tinyNum);
          } else if (!time) {
            return;
          }
        }
      }

      tween._pt = tween._ptCache = 0;
      lazy = dur && _isNotFalse(lazy) || lazy && !dur;

      for (i = 0; i < targets.length; i++) {
        target = targets[i];
        gsData = target._gsap || _harness(targets)[i]._gsap;
        tween._ptLookup[i] = ptLookup = {};
        _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender();
        index = fullTargets === targets ? i : fullTargets.indexOf(target);

        if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
          tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);

          plugin._props.forEach(function (name) {
            ptLookup[name] = pt;
          });

          plugin.priority && (hasPriority = 1);
        }

        if (!harness || harnessVars) {
          for (p in cleanVars) {
            if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) {
              plugin.priority && (hasPriority = 1);
            } else {
              ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
          }
        }

        tween._op && tween._op[i] && tween.kill(target, tween._op[i]);

        if (autoOverwrite && tween._pt) {
          _overwritingTween = tween;

          _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time));

          overwritten = !tween.parent;
          _overwritingTween = 0;
        }

        tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
      }

      hasPriority && _sortPropTweensByPriority(tween);
      tween._onInit && tween._onInit(tween);
    }

    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten;
    keyframes && time <= 0 && tl.render(_bigNum, true, true);
  },
      _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property],
        pt,
        rootPT,
        lookup,
        i;

    if (!ptCache) {
      ptCache = tween._ptCache[property] = [];
      lookup = tween._ptLookup;
      i = tween._targets.length;

      while (i--) {
        pt = lookup[i][property];

        if (pt && pt.d && pt.d._pt) {
          pt = pt.d._pt;

          while (pt && pt.p !== property && pt.fp !== property) {
            pt = pt._next;
          }
        }

        if (!pt) {
          _forceAllPropTweens = 1;
          tween.vars[property] = "+=0";

          _initTween(tween, time);

          _forceAllPropTweens = 0;
          return 1;
        }

        ptCache.push(pt);
      }
    }

    i = ptCache.length;

    while (i--) {
      rootPT = ptCache[i];
      pt = rootPT._pt || rootPT;
      pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
      pt.c = value - pt.s;
      rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e));
      rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b));
    }
  },
      _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0,
        propertyAliases = harness && harness.aliases,
        copy,
        p,
        i,
        aliases;

    if (!propertyAliases) {
      return vars;
    }

    copy = _merge({}, vars);

    for (p in propertyAliases) {
      if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;

        while (i--) {
          copy[aliases[i]] = copy[p];
        }
      }
    }

    return copy;
  },
      _parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut",
        p,
        a;

    if (_isArray(obj)) {
      a = allProps[prop] || (allProps[prop] = []);
      obj.forEach(function (value, i) {
        return a.push({
          t: i / (obj.length - 1) * 100,
          v: value,
          e: ease
        });
      });
    } else {
      for (p in obj) {
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
          t: parseFloat(prop),
          v: obj[p],
          e: ease
        });
      }
    }
  },
      _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
  },
      _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert",
      _staggerPropsToSkip = {};

  _forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function (name) {
    return _staggerPropsToSkip[name] = 1;
  });

  var Tween = function (_Animation2) {
    _inheritsLoose(Tween, _Animation2);

    function Tween(targets, vars, position, skipInherit) {
      var _this3;

      if (typeof vars === "number") {
        position.duration = vars;
        vars = position;
        position = null;
      }

      _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
      var _this3$vars = _this3.vars,
          duration = _this3$vars.duration,
          delay = _this3$vars.delay,
          immediateRender = _this3$vars.immediateRender,
          stagger = _this3$vars.stagger,
          overwrite = _this3$vars.overwrite,
          keyframes = _this3$vars.keyframes,
          defaults = _this3$vars.defaults,
          scrollTrigger = _this3$vars.scrollTrigger,
          yoyoEase = _this3$vars.yoyoEase,
          parent = vars.parent || _globalTimeline,
          parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [targets] : toArray(targets),
          tl,
          i,
          copy,
          l,
          p,
          curTarget,
          staggerFunc,
          staggerVarsToMerge;
      _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://greensock.com", !_config.nullTargetWarn) || [];
      _this3._ptLookup = [];
      _this3._overwrite = overwrite;

      if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
        vars = _this3.vars;
        tl = _this3.timeline = new Timeline({
          data: "nested",
          defaults: defaults || {},
          targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
        });
        tl.kill();
        tl.parent = tl._dp = _assertThisInitialized(_this3);
        tl._start = 0;

        if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
          l = parsedTargets.length;
          staggerFunc = stagger && distribute(stagger);

          if (_isObject(stagger)) {
            for (p in stagger) {
              if (~_staggerTweenProps.indexOf(p)) {
                staggerVarsToMerge || (staggerVarsToMerge = {});
                staggerVarsToMerge[p] = stagger[p];
              }
            }
          }

          for (i = 0; i < l; i++) {
            copy = _copyExcluding(vars, _staggerPropsToSkip);
            copy.stagger = 0;
            yoyoEase && (copy.yoyoEase = yoyoEase);
            staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
            curTarget = parsedTargets[i];
            copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
            copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;

            if (!stagger && l === 1 && copy.delay) {
              _this3._delay = delay = copy.delay;
              _this3._start += delay;
              copy.delay = 0;
            }

            tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
            tl._ease = _easeMap.none;
          }

          tl.duration() ? duration = delay = 0 : _this3.timeline = 0;
        } else if (keyframes) {
          _inheritDefaults(_setDefaults(tl.vars.defaults, {
            ease: "none"
          }));

          tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
          var time = 0,
              a,
              kf,
              v;

          if (_isArray(keyframes)) {
            keyframes.forEach(function (frame) {
              return tl.to(parsedTargets, frame, ">");
            });
            tl.duration();
          } else {
            copy = {};

            for (p in keyframes) {
              p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
            }

            for (p in copy) {
              a = copy[p].sort(function (a, b) {
                return a.t - b.t;
              });
              time = 0;

              for (i = 0; i < a.length; i++) {
                kf = a[i];
                v = {
                  ease: kf.e,
                  duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                };
                v[p] = kf.v;
                tl.to(parsedTargets, v, time);
                time += v.duration;
              }
            }

            tl.duration() < duration && tl.to({}, {
              duration: duration - tl.duration()
            });
          }
        }

        duration || _this3.duration(duration = tl.duration());
      } else {
        _this3.timeline = 0;
      }

      if (overwrite === true && !_suppressOverwrites) {
        _overwritingTween = _assertThisInitialized(_this3);

        _globalTimeline.killTweensOf(parsedTargets);

        _overwritingTween = 0;
      }

      _addToTimeline(parent, _assertThisInitialized(_this3), position);

      vars.reversed && _this3.reverse();
      vars.paused && _this3.paused(true);

      if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
        _this3._tTime = -_tinyNum;

        _this3.render(Math.max(0, -delay) || 0);
      }

      scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
      return _this3;
    }

    var _proto3 = Tween.prototype;

    _proto3.render = function render(totalTime, suppressEvents, force) {
      var prevTime = this._time,
          tDur = this._tDur,
          dur = this._dur,
          isNegative = totalTime < 0,
          tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime,
          time,
          pt,
          iteration,
          cycleDuration,
          prevIteration,
          isYoyo,
          ratio,
          timeline,
          yoyoEase;

      if (!dur) {
        _renderZeroDurationTween(this, totalTime, suppressEvents, force);
      } else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative) {
        time = tTime;
        timeline = this.timeline;

        if (this._repeat) {
          cycleDuration = dur + this._rDelay;

          if (this._repeat < -1 && isNegative) {
            return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
          }

          time = _roundPrecise(tTime % cycleDuration);

          if (tTime === tDur) {
            iteration = this._repeat;
            time = dur;
          } else {
            iteration = ~~(tTime / cycleDuration);

            if (iteration && iteration === tTime / cycleDuration) {
              time = dur;
              iteration--;
            }

            time > dur && (time = dur);
          }

          isYoyo = this._yoyo && iteration & 1;

          if (isYoyo) {
            yoyoEase = this._yEase;
            time = dur - time;
          }

          prevIteration = _animationCycle(this._tTime, cycleDuration);

          if (time === prevTime && !force && this._initted) {
            this._tTime = tTime;
            return this;
          }

          if (iteration !== prevIteration) {
            timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo);

            if (this.vars.repeatRefresh && !isYoyo && !this._lock) {
              this._lock = force = 1;
              this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
            }
          }
        }

        if (!this._initted) {
          if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
            this._tTime = 0;
            return this;
          }

          if (prevTime !== this._time) {
            return this;
          }

          if (dur !== this._dur) {
            return this.render(totalTime, suppressEvents, force);
          }
        }

        this._tTime = tTime;
        this._time = time;

        if (!this._act && this._ts) {
          this._act = 1;
          this._lazy = 0;
        }

        this.ratio = ratio = (yoyoEase || this._ease)(time / dur);

        if (this._from) {
          this.ratio = ratio = 1 - ratio;
        }

        if (time && !prevTime && !suppressEvents && !iteration) {
          _callback(this, "onStart");

          if (this._tTime !== tTime) {
            return this;
          }
        }

        pt = this._pt;

        while (pt) {
          pt.r(ratio, pt.d);
          pt = pt._next;
        }

        timeline && timeline.render(totalTime < 0 ? totalTime : !time && isYoyo ? -_tinyNum : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);

        if (this._onUpdate && !suppressEvents) {
          isNegative && _rewindStartAt(this, totalTime, suppressEvents, force);

          _callback(this, "onUpdate");
        }

        this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");

        if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
          isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
          (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1);

          if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
            _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);

            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
          }
        }
      }

      return this;
    };

    _proto3.targets = function targets() {
      return this._targets;
    };

    _proto3.invalidate = function invalidate(soft) {
      (!soft || !this.vars.runBackwards) && (this._startAt = 0);
      this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
      this._ptLookup = [];
      this.timeline && this.timeline.invalidate(soft);
      return _Animation2.prototype.invalidate.call(this, soft);
    };

    _proto3.resetTo = function resetTo(property, value, start, startIsRelative) {
      _tickerActive || _ticker.wake();
      this._ts || this.play();
      var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts),
          ratio;
      this._initted || _initTween(this, time);
      ratio = this._ease(time / this._dur);

      if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time)) {
        return this.resetTo(property, value, start, startIsRelative);
      }

      _alignPlayhead(this, 0);

      this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
      return this.render(0);
    };

    _proto3.kill = function kill(targets, vars) {
      if (vars === void 0) {
        vars = "all";
      }

      if (!targets && (!vars || vars === "all")) {
        this._lazy = this._pt = 0;
        return this.parent ? _interrupt(this) : this;
      }

      if (this.timeline) {
        var tDur = this.timeline.totalDuration();
        this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this);
        this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1);
        return this;
      }

      var parsedTargets = this._targets,
          killingTargets = targets ? toArray(targets) : parsedTargets,
          propTweenLookup = this._ptLookup,
          firstPT = this._pt,
          overwrittenProps,
          curLookup,
          curOverwriteProps,
          props,
          p,
          pt,
          i;

      if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
        vars === "all" && (this._pt = 0);
        return _interrupt(this);
      }

      overwrittenProps = this._op = this._op || [];

      if (vars !== "all") {
        if (_isString(vars)) {
          p = {};

          _forEachName(vars, function (name) {
            return p[name] = 1;
          });

          vars = p;
        }

        vars = _addAliasesToVars(parsedTargets, vars);
      }

      i = parsedTargets.length;

      while (i--) {
        if (~killingTargets.indexOf(parsedTargets[i])) {
          curLookup = propTweenLookup[i];

          if (vars === "all") {
            overwrittenProps[i] = vars;
            props = curLookup;
            curOverwriteProps = {};
          } else {
            curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
            props = vars;
          }

          for (p in props) {
            pt = curLookup && curLookup[p];

            if (pt) {
              if (!("kill" in pt.d) || pt.d.kill(p) === true) {
                _removeLinkedListItem(this, pt, "_pt");
              }

              delete curLookup[p];
            }

            if (curOverwriteProps !== "all") {
              curOverwriteProps[p] = 1;
            }
          }
        }
      }

      this._initted && !this._pt && firstPT && _interrupt(this);
      return this;
    };

    Tween.to = function to(targets, vars) {
      return new Tween(targets, vars, arguments[2]);
    };

    Tween.from = function from(targets, vars) {
      return _createTweenType(1, arguments);
    };

    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
      return new Tween(callback, 0, {
        immediateRender: false,
        lazy: false,
        overwrite: false,
        delay: delay,
        onComplete: callback,
        onReverseComplete: callback,
        onCompleteParams: params,
        onReverseCompleteParams: params,
        callbackScope: scope
      });
    };

    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
      return _createTweenType(2, arguments);
    };

    Tween.set = function set(targets, vars) {
      vars.duration = 0;
      vars.repeatDelay || (vars.repeat = 0);
      return new Tween(targets, vars);
    };

    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
      return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };

    return Tween;
  }(Animation);

  _setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
  });

  _forEachName("staggerTo,staggerFrom,staggerFromTo", function (name) {
    Tween[name] = function () {
      var tl = new Timeline(),
          params = _slice.call(arguments, 0);

      params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
      return tl[name].apply(tl, params);
    };
  });

  var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
  },
      _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
  },
      _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
  },
      _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
  },
      _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
  },
      _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
  },
      _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
  },
      _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt,
        s = "";

    if (!ratio && data.b) {
      s = data.b;
    } else if (ratio === 1 && data.e) {
      s = data.e;
    } else {
      while (pt) {
        s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s;
        pt = pt._next;
      }

      s += data.c;
    }

    data.set(data.t, data.p, s, data);
  },
      _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;

    while (pt) {
      pt.r(ratio, pt.d);
      pt = pt._next;
    }
  },
      _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt,
        next;

    while (pt) {
      next = pt._next;
      pt.p === property && pt.modifier(modifier, tween, target);
      pt = next;
    }
  },
      _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt,
        hasNonDependentRemaining,
        next;

    while (pt) {
      next = pt._next;

      if (pt.p === property && !pt.op || pt.op === property) {
        _removeLinkedListItem(this, pt, "_pt");
      } else if (!pt.dep) {
        hasNonDependentRemaining = 1;
      }

      pt = next;
    }

    return !hasNonDependentRemaining;
  },
      _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
  },
      _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt,
        next,
        pt2,
        first,
        last;

    while (pt) {
      next = pt._next;
      pt2 = first;

      while (pt2 && pt2.pr > pt.pr) {
        pt2 = pt2._next;
      }

      if (pt._prev = pt2 ? pt2._prev : last) {
        pt._prev._next = pt;
      } else {
        first = pt;
      }

      if (pt._next = pt2) {
        pt2._prev = pt;
      } else {
        last = pt;
      }

      pt = next;
    }

    parent._pt = first;
  };

  var PropTween = function () {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
      this.t = target;
      this.s = start;
      this.c = change;
      this.p = prop;
      this.r = renderer || _renderPlain;
      this.d = data || this;
      this.set = setter || _setterPlain;
      this.pr = priority || 0;
      this._next = next;

      if (next) {
        next._prev = this;
      }
    }

    var _proto4 = PropTween.prototype;

    _proto4.modifier = function modifier(func, tween, target) {
      this.mSet = this.mSet || this.set;
      this.set = _setterWithModifier;
      this.m = func;
      this.mt = target;
      this.tween = tween;
    };

    return PropTween;
  }();

  _forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function (name) {
    return _reservedProps[name] = 1;
  });

  _globals.TweenMax = _globals.TweenLite = Tween;
  _globals.TimelineLite = _globals.TimelineMax = Timeline;
  _globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
  });
  _config.stringFilter = _colorStringFilter;

  var _media = [],
      _listeners = {},
      _emptyArray = [],
      _lastMediaTime = 0,
      _contextID = 0,
      _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function (f) {
      return f();
    });
  },
      _onMediaChange = function _onMediaChange() {
    var time = Date.now(),
        matches = [];

    if (time - _lastMediaTime > 2) {
      _dispatch("matchMediaInit");

      _media.forEach(function (c) {
        var queries = c.queries,
            conditions = c.conditions,
            match,
            p,
            anyMatch,
            toggled;

        for (p in queries) {
          match = _win.matchMedia(queries[p]).matches;
          match && (anyMatch = 1);

          if (match !== conditions[p]) {
            conditions[p] = match;
            toggled = 1;
          }
        }

        if (toggled) {
          c.revert();
          anyMatch && matches.push(c);
        }
      });

      _dispatch("matchMediaRevert");

      matches.forEach(function (c) {
        return c.onMatch(c);
      });
      _lastMediaTime = time;

      _dispatch("matchMedia");
    }
  };

  var Context = function () {
    function Context(func, scope) {
      this.selector = scope && selector(scope);
      this.data = [];
      this._r = [];
      this.isReverted = false;
      this.id = _contextID++;
      func && this.add(func);
    }

    var _proto5 = Context.prototype;

    _proto5.add = function add(name, func, scope) {
      if (_isFunction(name)) {
        scope = func;
        func = name;
        name = _isFunction;
      }

      var self = this,
          f = function f() {
        var prev = _context,
            prevSelector = self.selector,
            result;
        prev && prev !== self && prev.data.push(self);
        scope && (self.selector = selector(scope));
        _context = self;
        result = func.apply(self, arguments);
        _isFunction(result) && self._r.push(result);
        _context = prev;
        self.selector = prevSelector;
        self.isReverted = false;
        return result;
      };

      self.last = f;
      return name === _isFunction ? f(self) : name ? self[name] = f : f;
    };

    _proto5.ignore = function ignore(func) {
      var prev = _context;
      _context = null;
      func(this);
      _context = prev;
    };

    _proto5.getTweens = function getTweens() {
      var a = [];
      this.data.forEach(function (e) {
        return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
      });
      return a;
    };

    _proto5.clear = function clear() {
      this._r.length = this.data.length = 0;
    };

    _proto5.kill = function kill(revert, matchMedia) {
      var _this4 = this;

      if (revert) {
        var tweens = this.getTweens();
        this.data.forEach(function (t) {
          if (t.data === "isFlip") {
            t.revert();
            t.getChildren(true, true, false).forEach(function (tween) {
              return tweens.splice(tweens.indexOf(tween), 1);
            });
          }
        });
        tweens.map(function (t) {
          return {
            g: t.globalTime(0),
            t: t
          };
        }).sort(function (a, b) {
          return b.g - a.g || -Infinity;
        }).forEach(function (o) {
          return o.t.revert(revert);
        });
        this.data.forEach(function (e) {
          return !(e instanceof Tween) && e.revert && e.revert(revert);
        });

        this._r.forEach(function (f) {
          return f(revert, _this4);
        });

        this.isReverted = true;
      } else {
        this.data.forEach(function (e) {
          return e.kill && e.kill();
        });
      }

      this.clear();

      if (matchMedia) {
        var i = _media.length;

        while (i--) {
          _media[i].id === this.id && _media.splice(i, 1);
        }
      }
    };

    _proto5.revert = function revert(config) {
      this.kill(config || {});
    };

    return Context;
  }();

  var MatchMedia = function () {
    function MatchMedia(scope) {
      this.contexts = [];
      this.scope = scope;
    }

    var _proto6 = MatchMedia.prototype;

    _proto6.add = function add(conditions, func, scope) {
      _isObject(conditions) || (conditions = {
        matches: conditions
      });
      var context = new Context(0, scope || this.scope),
          cond = context.conditions = {},
          mq,
          p,
          active;
      _context && !context.selector && (context.selector = _context.selector);
      this.contexts.push(context);
      func = context.add("onMatch", func);
      context.queries = conditions;

      for (p in conditions) {
        if (p === "all") {
          active = 1;
        } else {
          mq = _win.matchMedia(conditions[p]);

          if (mq) {
            _media.indexOf(context) < 0 && _media.push(context);
            (cond[p] = mq.matches) && (active = 1);
            mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
          }
        }
      }

      active && func(context);
      return this;
    };

    _proto6.revert = function revert(config) {
      this.kill(config || {});
    };

    _proto6.kill = function kill(revert) {
      this.contexts.forEach(function (c) {
        return c.kill(revert, true);
      });
    };

    return MatchMedia;
  }();

  var _gsap = {
    registerPlugin: function registerPlugin() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      args.forEach(function (config) {
        return _createPlugin(config);
      });
    },
    timeline: function timeline(vars) {
      return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
      return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
      _isString(target) && (target = toArray(target)[0]);

      var getter = _getCache(target || {}).get,
          format = unit ? _passThrough : _numericIfPossible;

      unit === "native" && (unit = "");
      return !target ? target : !property ? function (property, unit, uncache) {
        return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
      } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
      target = toArray(target);

      if (target.length > 1) {
        var setters = target.map(function (t) {
          return gsap.quickSetter(t, property, unit);
        }),
            l = setters.length;
        return function (value) {
          var i = l;

          while (i--) {
            setters[i](value);
          }
        };
      }

      target = target[0] || {};

      var Plugin = _plugins[property],
          cache = _getCache(target),
          p = cache.harness && (cache.harness.aliases || {})[property] || property,
          setter = Plugin ? function (value) {
        var p = new Plugin();
        _quickTween._pt = 0;
        p.init(target, unit ? value + unit : value, _quickTween, 0, [target]);
        p.render(1, p);
        _quickTween._pt && _renderPropTweens(1, _quickTween);
      } : cache.set(target, p);

      return Plugin ? setter : function (value) {
        return setter(target, p, unit ? value + unit : value, cache, 1);
      };
    },
    quickTo: function quickTo(target, property, vars) {
      var _merge2;

      var tween = gsap.to(target, _merge((_merge2 = {}, _merge2[property] = "+=0.1", _merge2.paused = true, _merge2), vars || {})),
          func = function func(value, start, startIsRelative) {
        return tween.resetTo(property, value, start, startIsRelative);
      };

      func.tween = tween;
      return func;
    },
    isTweening: function isTweening(targets) {
      return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
      value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
      return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
      return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
      var name = _ref3.name,
          effect = _ref3.effect,
          plugins = _ref3.plugins,
          defaults = _ref3.defaults,
          extendTimeline = _ref3.extendTimeline;
      (plugins || "").split(",").forEach(function (pluginName) {
        return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
      });

      _effects[name] = function (targets, vars, tl) {
        return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
      };

      if (extendTimeline) {
        Timeline.prototype[name] = function (targets, vars, position) {
          return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
      }
    },
    registerEase: function registerEase(name, ease) {
      _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
      return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
      return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
      if (vars === void 0) {
        vars = {};
      }

      var tl = new Timeline(vars),
          child,
          next;
      tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);

      _globalTimeline.remove(tl);

      tl._dp = 0;
      tl._time = tl._tTime = _globalTimeline._time;
      child = _globalTimeline._first;

      while (child) {
        next = child._next;

        if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) {
          _addToTimeline(tl, child, child._start - child._delay);
        }

        child = next;
      }

      _addToTimeline(_globalTimeline, tl, 0);

      return tl;
    },
    context: function context(func, scope) {
      return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
      return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
      return _media.forEach(function (c) {
        var cond = c.conditions,
            found,
            p;

        for (p in cond) {
          if (cond[p]) {
            cond[p] = false;
            found = 1;
          }
        }

        found && c.revert();
      }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
      var a = _listeners[type] || (_listeners[type] = []);
      ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
      var a = _listeners[type],
          i = a && a.indexOf(callback);
      i >= 0 && a.splice(i, 1);
    },
    utils: {
      wrap: wrap,
      wrapYoyo: wrapYoyo,
      distribute: distribute,
      random: random,
      snap: snap,
      normalize: normalize,
      getUnit: getUnit,
      clamp: clamp,
      splitColor: splitColor,
      toArray: toArray,
      selector: selector,
      mapRange: mapRange,
      pipe: pipe,
      unitize: unitize,
      interpolate: interpolate,
      shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
      PropTween: PropTween,
      globals: _addGlobal,
      Tween: Tween,
      Timeline: Timeline,
      Animation: Animation,
      getCache: _getCache,
      _removeLinkedListItem: _removeLinkedListItem,
      reverting: function reverting() {
        return _reverting;
      },
      context: function context(toAdd) {
        if (toAdd && _context) {
          _context.data.push(toAdd);

          toAdd._ctx = _context;
        }

        return _context;
      },
      suppressOverwrites: function suppressOverwrites(value) {
        return _suppressOverwrites = value;
      }
    }
  };

  _forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function (name) {
    return _gsap[name] = Tween[name];
  });

  _ticker.add(Timeline.updateRoot);

  _quickTween = _gsap.to({}, {
    duration: 0
  });

  var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;

    while (pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop) {
      pt = pt._next;
    }

    return pt;
  },
      _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets,
        p,
        i,
        pt;

    for (p in modifiers) {
      i = targets.length;

      while (i--) {
        pt = tween._ptLookup[i][p];

        if (pt && (pt = pt.d)) {
          if (pt._pt) {
            pt = _getPluginPropTween(pt, p);
          }

          pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
        }
      }
    }
  },
      _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
      name: name,
      rawVars: 1,
      init: function init(target, vars, tween) {
        tween._onInit = function (tween) {
          var temp, p;

          if (_isString(vars)) {
            temp = {};

            _forEachName(vars, function (name) {
              return temp[name] = 1;
            });

            vars = temp;
          }

          if (modifier) {
            temp = {};

            for (p in vars) {
              temp[p] = modifier(vars[p]);
            }

            vars = temp;
          }

          _addModifiers(tween, vars);
        };
      }
    };
  };

  var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
      var p, pt, v;
      this.tween = tween;

      for (p in vars) {
        v = target.getAttribute(p) || "";
        pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
        pt.op = p;
        pt.b = v;

        this._props.push(p);
      }
    },
    render: function render(ratio, data) {
      var pt = data._pt;

      while (pt) {
        _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d);
        pt = pt._next;
      }
    }
  }, {
    name: "endArray",
    init: function init(target, value) {
      var i = value.length;

      while (i--) {
        this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
      }
    }
  }, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap;
  Tween.version = Timeline.version = gsap.version = "3.12.2";
  _coreReady = 1;
  _windowExists() && _wake();
  var Power0 = _easeMap.Power0,
      Power1 = _easeMap.Power1,
      Power2 = _easeMap.Power2,
      Power3 = _easeMap.Power3,
      Power4 = _easeMap.Power4,
      Linear = _easeMap.Linear,
      Quad = _easeMap.Quad,
      Cubic = _easeMap.Cubic,
      Quart = _easeMap.Quart,
      Quint = _easeMap.Quint,
      Strong = _easeMap.Strong,
      Elastic = _easeMap.Elastic,
      Back = _easeMap.Back,
      SteppedEase = _easeMap.SteppedEase,
      Bounce = _easeMap.Bounce,
      Sine = _easeMap.Sine,
      Expo = _easeMap.Expo,
      Circ = _easeMap.Circ;

  var _win$1,
      _doc$1,
      _docElement,
      _pluginInitted,
      _tempDiv,
      _tempDivStyler,
      _recentSetterPlugin,
      _reverting$1,
      _windowExists$1 = function _windowExists() {
    return typeof window !== "undefined";
  },
      _transformProps = {},
      _RAD2DEG = 180 / Math.PI,
      _DEG2RAD = Math.PI / 180,
      _atan2 = Math.atan2,
      _bigNum$1 = 1e8,
      _capsExp = /([A-Z])/g,
      _horizontalExp = /(left|right|width|margin|padding|x)/i,
      _complexExp = /[\s,\(]\S/,
      _propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
  },
      _renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
  },
      _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
  },
      _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
  },
      _renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -.5 : .5)) + data.u, data);
  },
      _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
  },
      _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
  },
      _setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
  },
      _setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
  },
      _setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
  },
      _setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
  },
      _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
  },
      _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
  },
      _transformProp = "transform",
      _transformOriginProp = _transformProp + "Origin",
      _saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;

    var target = this.target,
        style = target.style;

    if (property in _transformProps && style) {
      this.tfm = this.tfm || {};

      if (property !== "transform") {
        property = _propertyAliases[property] || property;
        ~property.indexOf(",") ? property.split(",").forEach(function (a) {
          return _this.tfm[a] = _get(target, a);
        }) : this.tfm[property] = target._gsap.x ? target._gsap[property] : _get(target, property);
      } else {
        return _propertyAliases.transform.split(",").forEach(function (p) {
          return _saveStyle.call(_this, p, isNotCSS);
        });
      }

      if (this.props.indexOf(_transformProp) >= 0) {
        return;
      }

      if (target._gsap.svg) {
        this.svgo = target.getAttribute("data-svg-origin");
        this.props.push(_transformOriginProp, isNotCSS, "");
      }

      property = _transformProp;
    }

    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
  },
      _removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
      style.removeProperty("translate");
      style.removeProperty("scale");
      style.removeProperty("rotate");
    }
  },
      _revertStyle = function _revertStyle() {
    var props = this.props,
        target = this.target,
        style = target.style,
        cache = target._gsap,
        i,
        p;

    for (i = 0; i < props.length; i += 3) {
      props[i + 1] ? target[props[i]] = props[i + 2] : props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
    }

    if (this.tfm) {
      for (p in this.tfm) {
        cache[p] = this.tfm[p];
      }

      if (cache.svg) {
        cache.renderTransform();
        target.setAttribute("data-svg-origin", this.svgo || "");
      }

      i = _reverting$1();

      if ((!i || !i.isStart) && !style[_transformProp]) {
        _removeIndependentTransforms(style);

        cache.uncache = 1;
      }
    }
  },
      _getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
      target: target,
      props: [],
      revert: _revertStyle,
      save: _saveStyle
    };
    target._gsap || gsap.core.getCache(target);
    properties && properties.split(",").forEach(function (p) {
      return saver.save(p);
    });
    return saver;
  },
      _supports3D,
      _createElement = function _createElement(type, ns) {
    var e = _doc$1.createElementNS ? _doc$1.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc$1.createElement(type);
    return e.style ? e : _doc$1.createElement(type);
  },
      _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || "";
  },
      _prefixes = "O,Moz,ms,Ms,Webkit".split(","),
      _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || _tempDiv,
        s = e.style,
        i = 5;

    if (property in s && !preferPrefix) {
      return property;
    }

    property = property.charAt(0).toUpperCase() + property.substr(1);

    while (i-- && !(_prefixes[i] + property in s)) {}

    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
  },
      _initCore = function _initCore() {
    if (_windowExists$1() && window.document) {
      _win$1 = window;
      _doc$1 = _win$1.document;
      _docElement = _doc$1.documentElement;
      _tempDiv = _createElement("div") || {
        style: {}
      };
      _tempDivStyler = _createElement("div");
      _transformProp = _checkPropPrefix(_transformProp);
      _transformOriginProp = _transformProp + "Origin";
      _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0";
      _supports3D = !!_checkPropPrefix("perspective");
      _reverting$1 = gsap.core.reverting;
      _pluginInitted = 1;
    }
  },
      _getBBoxHack = function _getBBoxHack(swapIfPossible) {
    var svg = _createElement("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
        oldParent = this.parentNode,
        oldSibling = this.nextSibling,
        oldCSS = this.style.cssText,
        bbox;

    _docElement.appendChild(svg);

    svg.appendChild(this);
    this.style.display = "block";

    if (swapIfPossible) {
      try {
        bbox = this.getBBox();
        this._gsapBBox = this.getBBox;
        this.getBBox = _getBBoxHack;
      } catch (e) {}
    } else if (this._gsapBBox) {
      bbox = this._gsapBBox();
    }

    if (oldParent) {
      if (oldSibling) {
        oldParent.insertBefore(this, oldSibling);
      } else {
        oldParent.appendChild(this);
      }
    }

    _docElement.removeChild(svg);

    this.style.cssText = oldCSS;
    return bbox;
  },
      _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;

    while (i--) {
      if (target.hasAttribute(attributesArray[i])) {
        return target.getAttribute(attributesArray[i]);
      }
    }
  },
      _getBBox = function _getBBox(target) {
    var bounds;

    try {
      bounds = target.getBBox();
    } catch (error) {
      bounds = _getBBoxHack.call(target, true);
    }

    bounds && (bounds.width || bounds.height) || target.getBBox === _getBBoxHack || (bounds = _getBBoxHack.call(target, true));
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
      x: +_getAttributeFallbacks(target, ["x", "cx", "x1"]) || 0,
      y: +_getAttributeFallbacks(target, ["y", "cy", "y1"]) || 0,
      width: 0,
      height: 0
    } : bounds;
  },
      _isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
  },
      _removeProperty = function _removeProperty(target, property) {
    if (property) {
      var style = target.style;

      if (property in _transformProps && property !== _transformOriginProp) {
        property = _transformProp;
      }

      if (style.removeProperty) {
        if (property.substr(0, 2) === "ms" || property.substr(0, 6) === "webkit") {
          property = "-" + property;
        }

        style.removeProperty(property.replace(_capsExp, "-$1").toLowerCase());
      } else {
        style.removeAttribute(property);
      }
    }
  },
      _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new PropTween(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;

    plugin._props.push(property);

    return pt;
  },
      _nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
  },
      _nonStandardLayouts = {
    grid: 1,
    flex: 1
  },
      _convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0,
        curUnit = (value + "").trim().substr((curValue + "").length) || "px",
        style = _tempDiv.style,
        horizontal = _horizontalExp.test(property),
        isRootSVG = target.tagName.toLowerCase() === "svg",
        measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"),
        amount = 100,
        toPixels = unit === "px",
        toPercent = unit === "%",
        px,
        parent,
        cache,
        isSVG;

    if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) {
      return curValue;
    }

    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && _isSVG(target);

    if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
      px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
      return _round(toPercent ? curValue / px * amount : curValue / 100 * px);
    }

    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;

    if (isSVG) {
      parent = (target.ownerSVGElement || {}).parentNode;
    }

    if (!parent || parent === _doc$1 || !parent.appendChild) {
      parent = _doc$1.body;
    }

    cache = parent._gsap;

    if (cache && toPercent && cache.width && horizontal && cache.time === _ticker.time && !cache.uncache) {
      return _round(curValue / cache.width * amount);
    } else {
      (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
      parent === target && (style.position = "static");
      parent.appendChild(_tempDiv);
      px = _tempDiv[measureProperty];
      parent.removeChild(_tempDiv);
      style.position = "absolute";

      if (horizontal && toPercent) {
        cache = _getCache(parent);
        cache.time = _ticker.time;
        cache.width = parent[measureProperty];
      }
    }

    return _round(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
  },
      _get = function _get(target, property, unit, uncache) {
    var value;
    _pluginInitted || _initCore();

    if (property in _propertyAliases && property !== "transform") {
      property = _propertyAliases[property];

      if (~property.indexOf(",")) {
        property = property.split(",")[0];
      }
    }

    if (_transformProps[property] && property !== "transform") {
      value = _parseTransform(target, uncache);
      value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
      value = target.style[property];

      if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) {
        value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || _getProperty(target, property) || (property === "opacity" ? 1 : 0);
      }
    }

    return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
  },
      _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    if (!start || start === "none") {
      var p = _checkPropPrefix(prop, target, 1),
          s = p && _getComputedProperty(target, p, 1);

      if (s && s !== start) {
        prop = p;
        start = s;
      } else if (prop === "borderColor") {
        start = _getComputedProperty(target, "borderTopColor");
      }
    }

    var pt = new PropTween(this._pt, target.style, prop, 0, 1, _renderComplexString),
        index = 0,
        matchIndex = 0,
        a,
        result,
        startValues,
        startNum,
        color,
        startValue,
        endValue,
        endNum,
        chunk,
        endUnit,
        startUnit,
        endValues;
    pt.b = start;
    pt.e = end;
    start += "";
    end += "";

    if (end === "auto") {
      target.style[prop] = end;
      end = _getComputedProperty(target, prop) || end;
      target.style[prop] = start;
    }

    a = [start, end];

    _colorStringFilter(a);

    start = a[0];
    end = a[1];
    startValues = start.match(_numWithUnitExp) || [];
    endValues = end.match(_numWithUnitExp) || [];

    if (endValues.length) {
      while (result = _numWithUnitExp.exec(end)) {
        endValue = result[0];
        chunk = end.substring(index, result.index);

        if (color) {
          color = (color + 1) % 5;
        } else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") {
          color = 1;
        }

        if (endValue !== (startValue = startValues[matchIndex++] || "")) {
          startNum = parseFloat(startValue) || 0;
          startUnit = startValue.substr((startNum + "").length);
          endValue.charAt(1) === "=" && (endValue = _parseRelative(startNum, endValue) + startUnit);
          endNum = parseFloat(endValue);
          endUnit = endValue.substr((endNum + "").length);
          index = _numWithUnitExp.lastIndex - endUnit.length;

          if (!endUnit) {
            endUnit = endUnit || _config.units[prop] || startUnit;

            if (index === end.length) {
              end += endUnit;
              pt.e += endUnit;
            }
          }

          if (startUnit !== endUnit) {
            startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
          }

          pt._pt = {
            _next: pt._pt,
            p: chunk || matchIndex === 1 ? chunk : ",",
            s: startNum,
            c: endNum - startNum,
            m: color && color < 4 || prop === "zIndex" ? Math.round : 0
          };
        }
      }

      pt.c = index < end.length ? end.substring(index, end.length) : "";
    } else {
      pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
    }

    _relExp.test(end) && (pt.e = 0);
    this._pt = pt;
    return pt;
  },
      _keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
  },
      _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "),
        x = split[0],
        y = split[1] || "50%";

    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
      value = x;
      x = y;
      y = value;
    }

    split[0] = _keywordToPercent[x] || x;
    split[1] = _keywordToPercent[y] || y;
    return split.join(" ");
  },
      _renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
      var target = data.t,
          style = target.style,
          props = data.u,
          cache = target._gsap,
          prop,
          clearTransforms,
          i;

      if (props === "all" || props === true) {
        style.cssText = "";
        clearTransforms = 1;
      } else {
        props = props.split(",");
        i = props.length;

        while (--i > -1) {
          prop = props[i];

          if (_transformProps[prop]) {
            clearTransforms = 1;
            prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
          }

          _removeProperty(target, prop);
        }
      }

      if (clearTransforms) {
        _removeProperty(target, _transformProp);

        if (cache) {
          cache.svg && target.removeAttribute("transform");

          _parseTransform(target, 1);

          cache.uncache = 1;

          _removeIndependentTransforms(style);
        }
      }
    }
  },
      _specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
      if (tween.data !== "isFromStart") {
        var pt = plugin._pt = new PropTween(plugin._pt, target, property, 0, 0, _renderClearProps);
        pt.u = endValue;
        pt.pr = -10;
        pt.tween = tween;

        plugin._props.push(property);

        return 1;
      }
    }
  },
      _identity2DMatrix = [1, 0, 0, 1, 0, 0],
      _rotationalProperties = {},
      _isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
  },
      _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = _getComputedProperty(target, _transformProp);

    return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match(_numExp).map(_round);
  },
      _getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || _getCache(target),
        style = target.style,
        matrix = _getComputedTransformMatrixAsArray(target),
        parent,
        nextSibling,
        temp,
        addedToDOM;

    if (cache.svg && target.getAttribute("transform")) {
      temp = target.transform.baseVal.consolidate().matrix;
      matrix = [temp.a, temp.b, temp.c, temp.d, temp.e, temp.f];
      return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
    } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
      temp = style.display;
      style.display = "block";
      parent = target.parentNode;

      if (!parent || !target.offsetParent) {
        addedToDOM = 1;
        nextSibling = target.nextElementSibling;

        _docElement.appendChild(target);
      }

      matrix = _getComputedTransformMatrixAsArray(target);
      temp ? style.display = temp : _removeProperty(target, "display");

      if (addedToDOM) {
        nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
      }
    }

    return force2D && matrix.length > 6 ? [matrix[0], matrix[1], matrix[4], matrix[5], matrix[12], matrix[13]] : matrix;
  },
      _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap,
        matrix = matrixArray || _getMatrix(target, true),
        xOriginOld = cache.xOrigin || 0,
        yOriginOld = cache.yOrigin || 0,
        xOffsetOld = cache.xOffset || 0,
        yOffsetOld = cache.yOffset || 0,
        a = matrix[0],
        b = matrix[1],
        c = matrix[2],
        d = matrix[3],
        tx = matrix[4],
        ty = matrix[5],
        originSplit = origin.split(" "),
        xOrigin = parseFloat(originSplit[0]) || 0,
        yOrigin = parseFloat(originSplit[1]) || 0,
        bounds,
        determinant,
        x,
        y;

    if (!originIsAbsolute) {
      bounds = _getBBox(target);
      xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
      yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin);
    } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
      x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
      y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
      xOrigin = x;
      yOrigin = y;
    }

    if (smooth || smooth !== false && cache.smooth) {
      tx = xOrigin - xOriginOld;
      ty = yOrigin - yOriginOld;
      cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
      cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else {
      cache.xOffset = cache.yOffset = 0;
    }

    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[_transformOriginProp] = "0px 0px";

    if (pluginToAddPropTweensTo) {
      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);

      _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }

    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
  },
      _parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new GSCache(target);

    if ("x" in cache && !uncache && !cache.uncache) {
      return cache;
    }

    var style = target.style,
        invertedScaleX = cache.scaleX < 0,
        px = "px",
        deg = "deg",
        cs = getComputedStyle(target),
        origin = _getComputedProperty(target, _transformOriginProp) || "0",
        x,
        y,
        z,
        scaleX,
        scaleY,
        rotation,
        rotationX,
        rotationY,
        skewX,
        skewY,
        perspective,
        xOrigin,
        yOrigin,
        matrix,
        angle,
        cos,
        sin,
        a,
        b,
        c,
        d,
        a12,
        a22,
        t1,
        t2,
        t3,
        a13,
        a23,
        a33,
        a42,
        a43,
        a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && _isSVG(target));

    if (cs.translate) {
      if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") {
        style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
      }

      style.scale = style.rotate = style.translate = "none";
    }

    matrix = _getMatrix(target, cache.svg);

    if (cache.svg) {
      if (cache.uncache) {
        t2 = target.getBBox();
        origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
        t1 = "";
      } else {
        t1 = !uncache && target.getAttribute("data-svg-origin");
      }

      _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }

    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;

    if (matrix !== _identity2DMatrix) {
      a = matrix[0];
      b = matrix[1];
      c = matrix[2];
      d = matrix[3];
      x = a12 = matrix[4];
      y = a22 = matrix[5];

      if (matrix.length === 6) {
        scaleX = Math.sqrt(a * a + b * b);
        scaleY = Math.sqrt(d * d + c * c);
        rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0;
        skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
        skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));

        if (cache.svg) {
          x -= xOrigin - (xOrigin * a + yOrigin * c);
          y -= yOrigin - (xOrigin * b + yOrigin * d);
        }
      } else {
        a32 = matrix[6];
        a42 = matrix[7];
        a13 = matrix[8];
        a23 = matrix[9];
        a33 = matrix[10];
        a43 = matrix[11];
        x = matrix[12];
        y = matrix[13];
        z = matrix[14];
        angle = _atan2(a32, a33);
        rotationX = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(-angle);
          sin = Math.sin(-angle);
          t1 = a12 * cos + a13 * sin;
          t2 = a22 * cos + a23 * sin;
          t3 = a32 * cos + a33 * sin;
          a13 = a12 * -sin + a13 * cos;
          a23 = a22 * -sin + a23 * cos;
          a33 = a32 * -sin + a33 * cos;
          a43 = a42 * -sin + a43 * cos;
          a12 = t1;
          a22 = t2;
          a32 = t3;
        }

        angle = _atan2(-c, a33);
        rotationY = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(-angle);
          sin = Math.sin(-angle);
          t1 = a * cos - a13 * sin;
          t2 = b * cos - a23 * sin;
          t3 = c * cos - a33 * sin;
          a43 = d * sin + a43 * cos;
          a = t1;
          b = t2;
          c = t3;
        }

        angle = _atan2(b, a);
        rotation = angle * _RAD2DEG;

        if (angle) {
          cos = Math.cos(angle);
          sin = Math.sin(angle);
          t1 = a * cos + b * sin;
          t2 = a12 * cos + a22 * sin;
          b = b * cos - a * sin;
          a22 = a22 * cos - a12 * sin;
          a = t1;
          a12 = t2;
        }

        if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
          rotationX = rotation = 0;
          rotationY = 180 - rotationY;
        }

        scaleX = _round(Math.sqrt(a * a + b * b + c * c));
        scaleY = _round(Math.sqrt(a22 * a22 + a32 * a32));
        angle = _atan2(a12, a22);
        skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
        perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
      }

      if (cache.svg) {
        t1 = target.getAttribute("transform");
        cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
        t1 && target.setAttribute("transform", t1);
      }
    }

    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
      if (invertedScaleX) {
        scaleX *= -1;
        skewX += rotation <= 0 ? 180 : -180;
        rotation += rotation <= 0 ? 180 : -180;
      } else {
        scaleY *= -1;
        skewX += skewX <= 0 ? 180 : -180;
      }
    }

    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = _round(scaleX);
    cache.scaleY = _round(scaleY);
    cache.rotation = _round(rotation) + deg;
    cache.rotationX = _round(rotationX) + deg;
    cache.rotationY = _round(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;

    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || 0) {
      style[_transformOriginProp] = _firstTwoOnly(origin);
    }

    cache.xOffset = cache.yOffset = 0;
    cache.force3D = _config.force3D;
    cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
  },
      _firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
  },
      _addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = getUnit(start);
    return _round(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
  },
      _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;

    _renderCSSTransforms(ratio, cache);
  },
      _zeroDeg = "0deg",
      _zeroPx = "0px",
      _endParenthesis = ") ",
      _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this,
        xPercent = _ref.xPercent,
        yPercent = _ref.yPercent,
        x = _ref.x,
        y = _ref.y,
        z = _ref.z,
        rotation = _ref.rotation,
        rotationY = _ref.rotationY,
        rotationX = _ref.rotationX,
        skewX = _ref.skewX,
        skewY = _ref.skewY,
        scaleX = _ref.scaleX,
        scaleY = _ref.scaleY,
        transformPerspective = _ref.transformPerspective,
        force3D = _ref.force3D,
        target = _ref.target,
        zOrigin = _ref.zOrigin,
        transforms = "",
        use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true;

    if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
      var angle = parseFloat(rotationY) * _DEG2RAD,
          a13 = Math.sin(angle),
          a33 = Math.cos(angle),
          cos;

      angle = parseFloat(rotationX) * _DEG2RAD;
      cos = Math.cos(angle);
      x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
      y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
      z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }

    if (transformPerspective !== _zeroPx) {
      transforms += "perspective(" + transformPerspective + _endParenthesis;
    }

    if (xPercent || yPercent) {
      transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    }

    if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) {
      transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
    }

    if (rotation !== _zeroDeg) {
      transforms += "rotate(" + rotation + _endParenthesis;
    }

    if (rotationY !== _zeroDeg) {
      transforms += "rotateY(" + rotationY + _endParenthesis;
    }

    if (rotationX !== _zeroDeg) {
      transforms += "rotateX(" + rotationX + _endParenthesis;
    }

    if (skewX !== _zeroDeg || skewY !== _zeroDeg) {
      transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
    }

    if (scaleX !== 1 || scaleY !== 1) {
      transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
    }

    target.style[_transformProp] = transforms || "translate(0, 0)";
  },
      _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this,
        xPercent = _ref2.xPercent,
        yPercent = _ref2.yPercent,
        x = _ref2.x,
        y = _ref2.y,
        rotation = _ref2.rotation,
        skewX = _ref2.skewX,
        skewY = _ref2.skewY,
        scaleX = _ref2.scaleX,
        scaleY = _ref2.scaleY,
        target = _ref2.target,
        xOrigin = _ref2.xOrigin,
        yOrigin = _ref2.yOrigin,
        xOffset = _ref2.xOffset,
        yOffset = _ref2.yOffset,
        forceCSS = _ref2.forceCSS,
        tx = parseFloat(x),
        ty = parseFloat(y),
        a11,
        a21,
        a12,
        a22,
        temp;

    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);

    if (skewY) {
      skewY = parseFloat(skewY);
      skewX += skewY;
      rotation += skewY;
    }

    if (rotation || skewX) {
      rotation *= _DEG2RAD;
      skewX *= _DEG2RAD;
      a11 = Math.cos(rotation) * scaleX;
      a21 = Math.sin(rotation) * scaleX;
      a12 = Math.sin(rotation - skewX) * -scaleY;
      a22 = Math.cos(rotation - skewX) * scaleY;

      if (skewX) {
        skewY *= _DEG2RAD;
        temp = Math.tan(skewX - skewY);
        temp = Math.sqrt(1 + temp * temp);
        a12 *= temp;
        a22 *= temp;

        if (skewY) {
          temp = Math.tan(skewY);
          temp = Math.sqrt(1 + temp * temp);
          a11 *= temp;
          a21 *= temp;
        }
      }

      a11 = _round(a11);
      a21 = _round(a21);
      a12 = _round(a12);
      a22 = _round(a22);
    } else {
      a11 = scaleX;
      a22 = scaleY;
      a21 = a12 = 0;
    }

    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
      tx = _convertToUnit(target, "x", x, "px");
      ty = _convertToUnit(target, "y", y, "px");
    }

    if (xOrigin || yOrigin || xOffset || yOffset) {
      tx = _round(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
      ty = _round(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }

    if (xPercent || yPercent) {
      temp = target.getBBox();
      tx = _round(tx + xPercent / 100 * temp.width);
      ty = _round(ty + yPercent / 100 * temp.height);
    }

    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[_transformProp] = temp);
  },
      _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360,
        isString = _isString(endValue),
        endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1),
        change = endNum - startNum,
        finalValue = startNum + change + "deg",
        direction,
        pt;

    if (isString) {
      direction = endValue.split("_")[1];

      if (direction === "short") {
        change %= cap;

        if (change !== change % (cap / 2)) {
          change += change < 0 ? cap : -cap;
        }
      }

      if (direction === "cw" && change < 0) {
        change = (change + cap * _bigNum$1) % cap - ~~(change / cap) * cap;
      } else if (direction === "ccw" && change > 0) {
        change = (change - cap * _bigNum$1) % cap - ~~(change / cap) * cap;
      }
    }

    plugin._pt = pt = new PropTween(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";

    plugin._props.push(property);

    return pt;
  },
      _assign = function _assign(target, source) {
    for (var p in source) {
      target[p] = source[p];
    }

    return target;
  },
      _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    var startCache = _assign({}, target._gsap),
        exclude = "perspective,force3D,transformOrigin,svgOrigin",
        style = target.style,
        endCache,
        p,
        startValue,
        endValue,
        startNum,
        endNum,
        startUnit,
        endUnit;

    if (startCache.svg) {
      startValue = target.getAttribute("transform");
      target.setAttribute("transform", "");
      style[_transformProp] = transforms;
      endCache = _parseTransform(target, 1);

      _removeProperty(target, _transformProp);

      target.setAttribute("transform", startValue);
    } else {
      startValue = getComputedStyle(target)[_transformProp];
      style[_transformProp] = transforms;
      endCache = _parseTransform(target, 1);
      style[_transformProp] = startValue;
    }

    for (p in _transformProps) {
      startValue = startCache[p];
      endValue = endCache[p];

      if (startValue !== endValue && exclude.indexOf(p) < 0) {
        startUnit = getUnit(startValue);
        endUnit = getUnit(endValue);
        startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
        endNum = parseFloat(endValue);
        plugin._pt = new PropTween(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
        plugin._pt.u = endUnit || 0;

        plugin._props.push(p);
      }
    }

    _assign(endCache, startCache);
  };

  _forEachName("padding,margin,Width,Radius", function (name, index) {
    var t = "Top",
        r = "Right",
        b = "Bottom",
        l = "Left",
        props = (index < 3 ? [t, r, b, l] : [t + l, t + r, b + r, b + l]).map(function (side) {
      return index < 2 ? name + side : "border" + side + name;
    });

    _specialProps[index > 1 ? "border" + name : name] = function (plugin, target, property, endValue, tween) {
      var a, vars;

      if (arguments.length < 4) {
        a = props.map(function (prop) {
          return _get(plugin, prop, property);
        });
        vars = a.join(" ");
        return vars.split(a[0]).length === 5 ? a[0] : vars;
      }

      a = (endValue + "").split(" ");
      vars = {};
      props.forEach(function (prop, i) {
        return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
      });
      plugin.init(target, vars, tween);
    };
  });

  var CSSPlugin = {
    name: "css",
    register: _initCore,
    targetTest: function targetTest(target) {
      return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
      var props = this._props,
          style = target.style,
          startAt = tween.vars.startAt,
          startValue,
          endValue,
          endNum,
          startNum,
          type,
          specialProp,
          p,
          startUnit,
          endUnit,
          relative,
          isTransformRelated,
          transformPropTween,
          cache,
          smooth,
          hasPriority,
          inlineProps;
      _pluginInitted || _initCore();
      this.styles = this.styles || _getStyleSaver(target);
      inlineProps = this.styles.props;
      this.tween = tween;

      for (p in vars) {
        if (p === "autoRound") {
          continue;
        }

        endValue = vars[p];

        if (_plugins[p] && _checkPlugin(p, vars, tween, index, target, targets)) {
          continue;
        }

        type = typeof endValue;
        specialProp = _specialProps[p];

        if (type === "function") {
          endValue = endValue.call(tween, index, target, targets);
          type = typeof endValue;
        }

        if (type === "string" && ~endValue.indexOf("random(")) {
          endValue = _replaceRandom(endValue);
        }

        if (specialProp) {
          specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
        } else if (p.substr(0, 2) === "--") {
          startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
          endValue += "";
          _colorExp.lastIndex = 0;

          if (!_colorExp.test(startValue)) {
            startUnit = getUnit(startValue);
            endUnit = getUnit(endValue);
          }

          endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
          this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
          props.push(p);
          inlineProps.push(p, 0, style[p]);
        } else if (type !== "undefined") {
          if (startAt && p in startAt) {
            startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
            _isString(startValue) && ~startValue.indexOf("random(") && (startValue = _replaceRandom(startValue));
            getUnit(startValue + "") || (startValue += _config.units[p] || getUnit(_get(target, p)) || "");
            (startValue + "").charAt(1) === "=" && (startValue = _get(target, p));
          } else {
            startValue = _get(target, p);
          }

          startNum = parseFloat(startValue);
          relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
          relative && (endValue = endValue.substr(2));
          endNum = parseFloat(endValue);

          if (p in _propertyAliases) {
            if (p === "autoAlpha") {
              if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) {
                startNum = 0;
              }

              inlineProps.push("visibility", 0, style.visibility);

              _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
            }

            if (p !== "scale" && p !== "transform") {
              p = _propertyAliases[p];
              ~p.indexOf(",") && (p = p.split(",")[0]);
            }
          }

          isTransformRelated = p in _transformProps;

          if (isTransformRelated) {
            this.styles.save(p);

            if (!transformPropTween) {
              cache = target._gsap;
              cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform);
              smooth = vars.smoothOrigin !== false && cache.smooth;
              transformPropTween = this._pt = new PropTween(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1);
              transformPropTween.dep = 1;
            }

            if (p === "scale") {
              this._pt = new PropTween(this._pt, cache, "scaleY", cache.scaleY, (relative ? _parseRelative(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
              this._pt.u = 0;
              props.push("scaleY", p);
              p += "X";
            } else if (p === "transformOrigin") {
              inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
              endValue = _convertKeywordsToPercentages(endValue);

              if (cache.svg) {
                _applySVGOrigin(target, endValue, 0, smooth, 0, this);
              } else {
                endUnit = parseFloat(endValue.split(" ")[2]) || 0;
                endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);

                _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
              }

              continue;
            } else if (p === "svgOrigin") {
              _applySVGOrigin(target, endValue, 1, smooth, 0, this);

              continue;
            } else if (p in _rotationalProperties) {
              _addRotationalPropTween(this, cache, p, startNum, relative ? _parseRelative(startNum, relative + endValue) : endValue);

              continue;
            } else if (p === "smoothOrigin") {
              _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);

              continue;
            } else if (p === "force3D") {
              cache[p] = endValue;
              continue;
            } else if (p === "transform") {
              _addRawTransformPTs(this, endValue, target);

              continue;
            }
          } else if (!(p in style)) {
            p = _checkPropPrefix(p) || p;
          }

          if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
            startUnit = (startValue + "").substr((startNum + "").length);
            endNum || (endNum = 0);
            endUnit = getUnit(endValue) || (p in _config.units ? _config.units[p] : startUnit);
            startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
            this._pt = new PropTween(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? _parseRelative(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
            this._pt.u = endUnit || 0;

            if (startUnit !== endUnit && endUnit !== "%") {
              this._pt.b = startValue;
              this._pt.r = _renderCSSPropWithBeginning;
            }
          } else if (!(p in style)) {
            if (p in target) {
              this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
            } else if (p !== "parseTransform") {
              _missingPlugin(p, endValue);

              continue;
            }
          } else {
            _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
          }

          isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : inlineProps.push(p, 1, startValue || target[p]));
          props.push(p);
        }
      }

      hasPriority && _sortPropTweensByPriority(this);
    },
    render: function render(ratio, data) {
      if (data.tween._time || !_reverting$1()) {
        var pt = data._pt;

        while (pt) {
          pt.r(ratio, pt.d);
          pt = pt._next;
        }
      } else {
        data.styles.revert();
      }
    },
    get: _get,
    aliases: _propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
      var p = _propertyAliases[property];
      p && p.indexOf(",") < 0 && (property = p);
      return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}) && (property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !_isUndefined(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : _getSetter(target, property);
    },
    core: {
      _removeProperty: _removeProperty,
      _getMatrix: _getMatrix
    }
  };
  gsap.utils.checkPrefix = _checkPropPrefix;
  gsap.core.getStyleSaver = _getStyleSaver;

  (function (positionAndScale, rotation, others, aliases) {
    var all = _forEachName(positionAndScale + "," + rotation + "," + others, function (name) {
      _transformProps[name] = 1;
    });

    _forEachName(rotation, function (name) {
      _config.units[name] = "deg";
      _rotationalProperties[name] = 1;
    });

    _propertyAliases[all[13]] = positionAndScale + "," + rotation;

    _forEachName(aliases, function (name) {
      var split = name.split(":");
      _propertyAliases[split[1]] = all[split[0]];
    });
  })("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");

  _forEachName("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function (name) {
    _config.units[name] = "px";
  });

  gsap.registerPlugin(CSSPlugin);

  var gsapWithCSS = gsap.registerPlugin(CSSPlugin) || gsap,
      TweenMaxWithCSS = gsapWithCSS.core.Tween;

  exports.Back = Back;
  exports.Bounce = Bounce;
  exports.CSSPlugin = CSSPlugin;
  exports.Circ = Circ;
  exports.Cubic = Cubic;
  exports.Elastic = Elastic;
  exports.Expo = Expo;
  exports.Linear = Linear;
  exports.Power0 = Power0;
  exports.Power1 = Power1;
  exports.Power2 = Power2;
  exports.Power3 = Power3;
  exports.Power4 = Power4;
  exports.Quad = Quad;
  exports.Quart = Quart;
  exports.Quint = Quint;
  exports.Sine = Sine;
  exports.SteppedEase = SteppedEase;
  exports.Strong = Strong;
  exports.TimelineLite = Timeline;
  exports.TimelineMax = Timeline;
  exports.TweenLite = Tween;
  exports.TweenMax = TweenMaxWithCSS;
  exports.default = gsapWithCSS;
  exports.gsap = gsapWithCSS;

  if (typeof(window) === 'undefined' || window !== exports) {Object.defineProperty(exports, '__esModule', { value: true });} else {delete window.default;}

})));

},{}],46:[function(require,module,exports){
/*!
 * html2canvas 1.4.1 <https://html2canvas.hertzen.com>
 * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
 * Released under MIT License
 */
(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.html2canvas = factory());
}(this, (function () { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __spreadArray(to, from, pack) {
        if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar) ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
        return to.concat(ar || from);
    }

    var Bounds = /** @class */ (function () {
        function Bounds(left, top, width, height) {
            this.left = left;
            this.top = top;
            this.width = width;
            this.height = height;
        }
        Bounds.prototype.add = function (x, y, w, h) {
            return new Bounds(this.left + x, this.top + y, this.width + w, this.height + h);
        };
        Bounds.fromClientRect = function (context, clientRect) {
            return new Bounds(clientRect.left + context.windowBounds.left, clientRect.top + context.windowBounds.top, clientRect.width, clientRect.height);
        };
        Bounds.fromDOMRectList = function (context, domRectList) {
            var domRect = Array.from(domRectList).find(function (rect) { return rect.width !== 0; });
            return domRect
                ? new Bounds(domRect.left + context.windowBounds.left, domRect.top + context.windowBounds.top, domRect.width, domRect.height)
                : Bounds.EMPTY;
        };
        Bounds.EMPTY = new Bounds(0, 0, 0, 0);
        return Bounds;
    }());
    var parseBounds = function (context, node) {
        return Bounds.fromClientRect(context, node.getBoundingClientRect());
    };
    var parseDocumentSize = function (document) {
        var body = document.body;
        var documentElement = document.documentElement;
        if (!body || !documentElement) {
            throw new Error("Unable to get document size");
        }
        var width = Math.max(Math.max(body.scrollWidth, documentElement.scrollWidth), Math.max(body.offsetWidth, documentElement.offsetWidth), Math.max(body.clientWidth, documentElement.clientWidth));
        var height = Math.max(Math.max(body.scrollHeight, documentElement.scrollHeight), Math.max(body.offsetHeight, documentElement.offsetHeight), Math.max(body.clientHeight, documentElement.clientHeight));
        return new Bounds(0, 0, width, height);
    };

    /*
     * css-line-break 2.1.0 <https://github.com/niklasvh/css-line-break#readme>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var toCodePoints$1 = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint$1 = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var chars$2 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$2 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$2 = 0; i$2 < chars$2.length; i$2++) {
        lookup$2[chars$2.charCodeAt(i$2)] = i$2;
    }

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1$1 = 0; i$1$1 < chars$1$1.length; i$1$1++) {
        lookup$1$1[chars$1$1.charCodeAt(i$1$1)] = i$1$1;
    }
    var decode$1 = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1$1[base64.charCodeAt(i)];
            encoded2 = lookup$1$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array$1 = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2$1 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1$1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT$1 = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2$1 = UTRIE2_SHIFT_1$1 - UTRIE2_SHIFT_2$1;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET$1 = 0x10000 >> UTRIE2_SHIFT_2$1;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_2$1;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK$1 = UTRIE2_DATA_BLOCK_LENGTH$1 - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH$1 = 0x400 >> UTRIE2_SHIFT_2$1;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH$1 = UTRIE2_LSCP_INDEX_2_OFFSET$1 + UTRIE2_LSCP_INDEX_2_LENGTH$1;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 = UTRIE2_INDEX_2_BMP_LENGTH$1;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH$1 = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET$1 = UTRIE2_UTF8_2B_INDEX_2_OFFSET$1 + UTRIE2_UTF8_2B_INDEX_2_LENGTH$1;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 = 0x10000 >> UTRIE2_SHIFT_1$1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH$1 = 1 << UTRIE2_SHIFT_1_2$1;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK$1 = UTRIE2_INDEX_2_BLOCK_LENGTH$1 - 1;
    var slice16$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32$1 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64$1 = function (base64, _byteLength) {
        var buffer = decode$1(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array$1(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array$1(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16$1(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16$1(view16, (headerLength + view32[4]) / 2)
            : slice32$1(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie$1(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie$1 = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2$1];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET$1 + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2$1)];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET$1 - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH$1 + (codePoint >> UTRIE2_SHIFT_1$1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2$1) & UTRIE2_INDEX_2_MASK$1;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT$1) + (codePoint & UTRIE2_DATA_MASK$1);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$3 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$3 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$3 = 0; i$3 < chars$3.length; i$3++) {
        lookup$3[chars$3.charCodeAt(i$3)] = i$3;
    }

    var base64$1 = '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';

    var LETTER_NUMBER_MODIFIER = 50;
    // Non-tailorable Line Breaking Classes
    var BK = 1; //  Cause a line break (after)
    var CR$1 = 2; //  Cause a line break (after), except between CR and LF
    var LF$1 = 3; //  Cause a line break (after)
    var CM = 4; //  Prohibit a line break between the character and the preceding character
    var NL = 5; //  Cause a line break (after)
    var WJ = 7; //  Prohibit line breaks before and after
    var ZW = 8; //  Provide a break opportunity
    var GL = 9; //  Prohibit line breaks before and after
    var SP = 10; // Enable indirect line breaks
    var ZWJ$1 = 11; // Prohibit line breaks within joiner sequences
    // Break Opportunities
    var B2 = 12; //  Provide a line break opportunity before and after the character
    var BA = 13; //  Generally provide a line break opportunity after the character
    var BB = 14; //  Generally provide a line break opportunity before the character
    var HY = 15; //  Provide a line break opportunity after the character, except in numeric context
    var CB = 16; //   Provide a line break opportunity contingent on additional information
    // Characters Prohibiting Certain Breaks
    var CL = 17; //  Prohibit line breaks before
    var CP = 18; //  Prohibit line breaks before
    var EX = 19; //  Prohibit line breaks before
    var IN = 20; //  Allow only indirect line breaks between pairs
    var NS = 21; //  Allow only indirect line breaks before
    var OP = 22; //  Prohibit line breaks after
    var QU = 23; //  Act like they are both opening and closing
    // Numeric Context
    var IS = 24; //  Prevent breaks after any and before numeric
    var NU = 25; //  Form numeric expressions for line breaking purposes
    var PO = 26; //  Do not break following a numeric expression
    var PR = 27; //  Do not break in front of a numeric expression
    var SY = 28; //  Prevent a break before; and allow a break after
    // Other Characters
    var AI = 29; //  Act like AL when the resolvedEAW is N; otherwise; act as ID
    var AL = 30; //  Are alphabetic characters or symbols that are used with alphabetic characters
    var CJ = 31; //  Treat as NS or ID for strict or normal breaking.
    var EB = 32; //  Do not break from following Emoji Modifier
    var EM = 33; //  Do not break from preceding Emoji Base
    var H2 = 34; //  Form Korean syllable blocks
    var H3 = 35; //  Form Korean syllable blocks
    var HL = 36; //  Do not break around a following hyphen; otherwise act as Alphabetic
    var ID = 37; //  Break before or after; except in some numeric context
    var JL = 38; //  Form Korean syllable blocks
    var JV = 39; //  Form Korean syllable blocks
    var JT = 40; //  Form Korean syllable blocks
    var RI$1 = 41; //  Keep pairs together. For pairs; break before and after other classes
    var SA = 42; //  Provide a line break opportunity contingent on additional, language-specific context analysis
    var XX = 43; //  Have as yet unknown line breaking behavior or unassigned code positions
    var ea_OP = [0x2329, 0xff08];
    var BREAK_MANDATORY = '!';
    var BREAK_NOT_ALLOWED$1 = '×';
    var BREAK_ALLOWED$1 = '÷';
    var UnicodeTrie$1 = createTrieFromBase64$1(base64$1);
    var ALPHABETICS = [AL, HL];
    var HARD_LINE_BREAKS = [BK, CR$1, LF$1, NL];
    var SPACE$1 = [SP, ZW];
    var PREFIX_POSTFIX = [PR, PO];
    var LINE_BREAKS = HARD_LINE_BREAKS.concat(SPACE$1);
    var KOREAN_SYLLABLE_BLOCK = [JL, JV, JT, H2, H3];
    var HYPHEN = [HY, BA];
    var codePointsToCharacterClasses = function (codePoints, lineBreak) {
        if (lineBreak === void 0) { lineBreak = 'strict'; }
        var types = [];
        var indices = [];
        var categories = [];
        codePoints.forEach(function (codePoint, index) {
            var classType = UnicodeTrie$1.get(codePoint);
            if (classType > LETTER_NUMBER_MODIFIER) {
                categories.push(true);
                classType -= LETTER_NUMBER_MODIFIER;
            }
            else {
                categories.push(false);
            }
            if (['normal', 'auto', 'loose'].indexOf(lineBreak) !== -1) {
                // U+2010, – U+2013, 〜 U+301C, ゠ U+30A0
                if ([0x2010, 0x2013, 0x301c, 0x30a0].indexOf(codePoint) !== -1) {
                    indices.push(index);
                    return types.push(CB);
                }
            }
            if (classType === CM || classType === ZWJ$1) {
                // LB10 Treat any remaining combining mark or ZWJ as AL.
                if (index === 0) {
                    indices.push(index);
                    return types.push(AL);
                }
                // LB9 Do not break a combining character sequence; treat it as if it has the line breaking class of
                // the base character in all of the following rules. Treat ZWJ as if it were CM.
                var prev = types[index - 1];
                if (LINE_BREAKS.indexOf(prev) === -1) {
                    indices.push(indices[index - 1]);
                    return types.push(prev);
                }
                indices.push(index);
                return types.push(AL);
            }
            indices.push(index);
            if (classType === CJ) {
                return types.push(lineBreak === 'strict' ? NS : ID);
            }
            if (classType === SA) {
                return types.push(AL);
            }
            if (classType === AI) {
                return types.push(AL);
            }
            // For supplementary characters, a useful default is to treat characters in the range 10000..1FFFD as AL
            // and characters in the ranges 20000..2FFFD and 30000..3FFFD as ID, until the implementation can be revised
            // to take into account the actual line breaking properties for these characters.
            if (classType === XX) {
                if ((codePoint >= 0x20000 && codePoint <= 0x2fffd) || (codePoint >= 0x30000 && codePoint <= 0x3fffd)) {
                    return types.push(ID);
                }
                else {
                    return types.push(AL);
                }
            }
            types.push(classType);
        });
        return [indices, types, categories];
    };
    var isAdjacentWithSpaceIgnored = function (a, b, currentIndex, classTypes) {
        var current = classTypes[currentIndex];
        if (Array.isArray(a) ? a.indexOf(current) !== -1 : a === current) {
            var i = currentIndex;
            while (i <= classTypes.length) {
                i++;
                var next = classTypes[i];
                if (next === b) {
                    return true;
                }
                if (next !== SP) {
                    break;
                }
            }
        }
        if (current === SP) {
            var i = currentIndex;
            while (i > 0) {
                i--;
                var prev = classTypes[i];
                if (Array.isArray(a) ? a.indexOf(prev) !== -1 : a === prev) {
                    var n = currentIndex;
                    while (n <= classTypes.length) {
                        n++;
                        var next = classTypes[n];
                        if (next === b) {
                            return true;
                        }
                        if (next !== SP) {
                            break;
                        }
                    }
                }
                if (prev !== SP) {
                    break;
                }
            }
        }
        return false;
    };
    var previousNonSpaceClassType = function (currentIndex, classTypes) {
        var i = currentIndex;
        while (i >= 0) {
            var type = classTypes[i];
            if (type === SP) {
                i--;
            }
            else {
                return type;
            }
        }
        return 0;
    };
    var _lineBreakAtIndex = function (codePoints, classTypes, indicies, index, forbiddenBreaks) {
        if (indicies[index] === 0) {
            return BREAK_NOT_ALLOWED$1;
        }
        var currentIndex = index - 1;
        if (Array.isArray(forbiddenBreaks) && forbiddenBreaks[currentIndex] === true) {
            return BREAK_NOT_ALLOWED$1;
        }
        var beforeIndex = currentIndex - 1;
        var afterIndex = currentIndex + 1;
        var current = classTypes[currentIndex];
        // LB4 Always break after hard line breaks.
        // LB5 Treat CR followed by LF, as well as CR, LF, and NL as hard line breaks.
        var before = beforeIndex >= 0 ? classTypes[beforeIndex] : 0;
        var next = classTypes[afterIndex];
        if (current === CR$1 && next === LF$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        if (HARD_LINE_BREAKS.indexOf(current) !== -1) {
            return BREAK_MANDATORY;
        }
        // LB6 Do not break before hard line breaks.
        if (HARD_LINE_BREAKS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB7 Do not break before spaces or zero width space.
        if (SPACE$1.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB8 Break before any character following a zero-width space, even if one or more spaces intervene.
        if (previousNonSpaceClassType(currentIndex, classTypes) === ZW) {
            return BREAK_ALLOWED$1;
        }
        // LB8a Do not break after a zero width joiner.
        if (UnicodeTrie$1.get(codePoints[currentIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // zwj emojis
        if ((current === EB || current === EM) && UnicodeTrie$1.get(codePoints[afterIndex]) === ZWJ$1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB11 Do not break before or after Word joiner and related characters.
        if (current === WJ || next === WJ) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12 Do not break after NBSP and related characters.
        if (current === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB12a Do not break before NBSP and related characters, except after spaces and hyphens.
        if ([SP, BA, HY].indexOf(current) === -1 && next === GL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB13 Do not break before ‘]’ or ‘!’ or ‘;’ or ‘/’, even after spaces.
        if ([CL, CP, EX, IS, SY].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB14 Do not break after ‘[’, even after spaces.
        if (previousNonSpaceClassType(currentIndex, classTypes) === OP) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB15 Do not break within ‘”[’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(QU, OP, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB16 Do not break between closing punctuation and a nonstarter (lb=NS), even with intervening spaces.
        if (isAdjacentWithSpaceIgnored([CL, CP], NS, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB17 Do not break within ‘——’, even with intervening spaces.
        if (isAdjacentWithSpaceIgnored(B2, B2, currentIndex, classTypes)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB18 Break after spaces.
        if (current === SP) {
            return BREAK_ALLOWED$1;
        }
        // LB19 Do not break before or after quotation marks, such as ‘ ” ’.
        if (current === QU || next === QU) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB20 Break before and after unresolved CB.
        if (next === CB || current === CB) {
            return BREAK_ALLOWED$1;
        }
        // LB21 Do not break before hyphen-minus, other hyphens, fixed-width spaces, small kana, and other non-starters, or after acute accents.
        if ([BA, HY, NS].indexOf(next) !== -1 || current === BB) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21a Don't break after Hebrew + Hyphen.
        if (before === HL && HYPHEN.indexOf(current) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB21b Don’t break between Solidus and Hebrew letters.
        if (current === SY && next === HL) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB22 Do not break before ellipsis.
        if (next === IN) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23 Do not break between digits and letters.
        if ((ALPHABETICS.indexOf(next) !== -1 && current === NU) || (ALPHABETICS.indexOf(current) !== -1 && next === NU)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB23a Do not break between numeric prefixes and ideographs, or between ideographs and numeric postfixes.
        if ((current === PR && [ID, EB, EM].indexOf(next) !== -1) ||
            ([ID, EB, EM].indexOf(current) !== -1 && next === PO)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB24 Do not break between numeric prefix/postfix and letters, or between letters and prefix/postfix.
        if ((ALPHABETICS.indexOf(current) !== -1 && PREFIX_POSTFIX.indexOf(next) !== -1) ||
            (PREFIX_POSTFIX.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB25 Do not break between the following pairs of classes relevant to numbers:
        if (
        // (PR | PO) × ( OP | HY )? NU
        ([PR, PO].indexOf(current) !== -1 &&
            (next === NU || ([OP, HY].indexOf(next) !== -1 && classTypes[afterIndex + 1] === NU))) ||
            // ( OP | HY ) × NU
            ([OP, HY].indexOf(current) !== -1 && next === NU) ||
            // NU ×	(NU | SY | IS)
            (current === NU && [NU, SY, IS].indexOf(next) !== -1)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // NU (NU | SY | IS)* × (NU | SY | IS | CL | CP)
        if ([NU, SY, IS, CL, CP].indexOf(next) !== -1) {
            var prevIndex = currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // NU (NU | SY | IS)* (CL | CP)? × (PO | PR))
        if ([PR, PO].indexOf(next) !== -1) {
            var prevIndex = [CL, CP].indexOf(current) !== -1 ? beforeIndex : currentIndex;
            while (prevIndex >= 0) {
                var type = classTypes[prevIndex];
                if (type === NU) {
                    return BREAK_NOT_ALLOWED$1;
                }
                else if ([SY, IS].indexOf(type) !== -1) {
                    prevIndex--;
                }
                else {
                    break;
                }
            }
        }
        // LB26 Do not break a Korean syllable.
        if ((JL === current && [JL, JV, H2, H3].indexOf(next) !== -1) ||
            ([JV, H2].indexOf(current) !== -1 && [JV, JT].indexOf(next) !== -1) ||
            ([JT, H3].indexOf(current) !== -1 && next === JT)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB27 Treat a Korean Syllable Block the same as ID.
        if ((KOREAN_SYLLABLE_BLOCK.indexOf(current) !== -1 && [IN, PO].indexOf(next) !== -1) ||
            (KOREAN_SYLLABLE_BLOCK.indexOf(next) !== -1 && current === PR)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB28 Do not break between alphabetics (“at”).
        if (ALPHABETICS.indexOf(current) !== -1 && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB29 Do not break between numeric punctuation and alphabetics (“e.g.”).
        if (current === IS && ALPHABETICS.indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30 Do not break between letters, numbers, or ordinary symbols and opening or closing parentheses.
        if ((ALPHABETICS.concat(NU).indexOf(current) !== -1 &&
            next === OP &&
            ea_OP.indexOf(codePoints[afterIndex]) === -1) ||
            (ALPHABETICS.concat(NU).indexOf(next) !== -1 && current === CP)) {
            return BREAK_NOT_ALLOWED$1;
        }
        // LB30a Break between two regional indicator symbols if and only if there are an even number of regional
        // indicators preceding the position of the break.
        if (current === RI$1 && next === RI$1) {
            var i = indicies[currentIndex];
            var count = 1;
            while (i > 0) {
                i--;
                if (classTypes[i] === RI$1) {
                    count++;
                }
                else {
                    break;
                }
            }
            if (count % 2 !== 0) {
                return BREAK_NOT_ALLOWED$1;
            }
        }
        // LB30b Do not break between an emoji base and an emoji modifier.
        if (current === EB && next === EM) {
            return BREAK_NOT_ALLOWED$1;
        }
        return BREAK_ALLOWED$1;
    };
    var cssFormattedClasses = function (codePoints, options) {
        if (!options) {
            options = { lineBreak: 'normal', wordBreak: 'normal' };
        }
        var _a = codePointsToCharacterClasses(codePoints, options.lineBreak), indicies = _a[0], classTypes = _a[1], isLetterNumber = _a[2];
        if (options.wordBreak === 'break-all' || options.wordBreak === 'break-word') {
            classTypes = classTypes.map(function (type) { return ([NU, AL, SA].indexOf(type) !== -1 ? ID : type); });
        }
        var forbiddenBreakpoints = options.wordBreak === 'keep-all'
            ? isLetterNumber.map(function (letterNumber, i) {
                return letterNumber && codePoints[i] >= 0x4e00 && codePoints[i] <= 0x9fff;
            })
            : undefined;
        return [indicies, classTypes, forbiddenBreakpoints];
    };
    var Break = /** @class */ (function () {
        function Break(codePoints, lineBreak, start, end) {
            this.codePoints = codePoints;
            this.required = lineBreak === BREAK_MANDATORY;
            this.start = start;
            this.end = end;
        }
        Break.prototype.slice = function () {
            return fromCodePoint$1.apply(void 0, this.codePoints.slice(this.start, this.end));
        };
        return Break;
    }());
    var LineBreaker = function (str, options) {
        var codePoints = toCodePoints$1(str);
        var _a = cssFormattedClasses(codePoints, options), indicies = _a[0], classTypes = _a[1], forbiddenBreakpoints = _a[2];
        var length = codePoints.length;
        var lastEnd = 0;
        var nextIndex = 0;
        return {
            next: function () {
                if (nextIndex >= length) {
                    return { done: true, value: null };
                }
                var lineBreak = BREAK_NOT_ALLOWED$1;
                while (nextIndex < length &&
                    (lineBreak = _lineBreakAtIndex(codePoints, classTypes, indicies, ++nextIndex, forbiddenBreakpoints)) ===
                        BREAK_NOT_ALLOWED$1) { }
                if (lineBreak !== BREAK_NOT_ALLOWED$1 || nextIndex === length) {
                    var value = new Break(codePoints, lineBreak, lastEnd, nextIndex);
                    lastEnd = nextIndex;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };

    // https://www.w3.org/TR/css-syntax-3
    var FLAG_UNRESTRICTED = 1 << 0;
    var FLAG_ID = 1 << 1;
    var FLAG_INTEGER = 1 << 2;
    var FLAG_NUMBER = 1 << 3;
    var LINE_FEED = 0x000a;
    var SOLIDUS = 0x002f;
    var REVERSE_SOLIDUS = 0x005c;
    var CHARACTER_TABULATION = 0x0009;
    var SPACE = 0x0020;
    var QUOTATION_MARK = 0x0022;
    var EQUALS_SIGN = 0x003d;
    var NUMBER_SIGN = 0x0023;
    var DOLLAR_SIGN = 0x0024;
    var PERCENTAGE_SIGN = 0x0025;
    var APOSTROPHE = 0x0027;
    var LEFT_PARENTHESIS = 0x0028;
    var RIGHT_PARENTHESIS = 0x0029;
    var LOW_LINE = 0x005f;
    var HYPHEN_MINUS = 0x002d;
    var EXCLAMATION_MARK = 0x0021;
    var LESS_THAN_SIGN = 0x003c;
    var GREATER_THAN_SIGN = 0x003e;
    var COMMERCIAL_AT = 0x0040;
    var LEFT_SQUARE_BRACKET = 0x005b;
    var RIGHT_SQUARE_BRACKET = 0x005d;
    var CIRCUMFLEX_ACCENT = 0x003d;
    var LEFT_CURLY_BRACKET = 0x007b;
    var QUESTION_MARK = 0x003f;
    var RIGHT_CURLY_BRACKET = 0x007d;
    var VERTICAL_LINE = 0x007c;
    var TILDE = 0x007e;
    var CONTROL = 0x0080;
    var REPLACEMENT_CHARACTER = 0xfffd;
    var ASTERISK = 0x002a;
    var PLUS_SIGN = 0x002b;
    var COMMA = 0x002c;
    var COLON = 0x003a;
    var SEMICOLON = 0x003b;
    var FULL_STOP = 0x002e;
    var NULL = 0x0000;
    var BACKSPACE = 0x0008;
    var LINE_TABULATION = 0x000b;
    var SHIFT_OUT = 0x000e;
    var INFORMATION_SEPARATOR_ONE = 0x001f;
    var DELETE = 0x007f;
    var EOF = -1;
    var ZERO = 0x0030;
    var a = 0x0061;
    var e = 0x0065;
    var f = 0x0066;
    var u = 0x0075;
    var z = 0x007a;
    var A = 0x0041;
    var E = 0x0045;
    var F = 0x0046;
    var U = 0x0055;
    var Z = 0x005a;
    var isDigit = function (codePoint) { return codePoint >= ZERO && codePoint <= 0x0039; };
    var isSurrogateCodePoint = function (codePoint) { return codePoint >= 0xd800 && codePoint <= 0xdfff; };
    var isHex = function (codePoint) {
        return isDigit(codePoint) || (codePoint >= A && codePoint <= F) || (codePoint >= a && codePoint <= f);
    };
    var isLowerCaseLetter = function (codePoint) { return codePoint >= a && codePoint <= z; };
    var isUpperCaseLetter = function (codePoint) { return codePoint >= A && codePoint <= Z; };
    var isLetter = function (codePoint) { return isLowerCaseLetter(codePoint) || isUpperCaseLetter(codePoint); };
    var isNonASCIICodePoint = function (codePoint) { return codePoint >= CONTROL; };
    var isWhiteSpace = function (codePoint) {
        return codePoint === LINE_FEED || codePoint === CHARACTER_TABULATION || codePoint === SPACE;
    };
    var isNameStartCodePoint = function (codePoint) {
        return isLetter(codePoint) || isNonASCIICodePoint(codePoint) || codePoint === LOW_LINE;
    };
    var isNameCodePoint = function (codePoint) {
        return isNameStartCodePoint(codePoint) || isDigit(codePoint) || codePoint === HYPHEN_MINUS;
    };
    var isNonPrintableCodePoint = function (codePoint) {
        return ((codePoint >= NULL && codePoint <= BACKSPACE) ||
            codePoint === LINE_TABULATION ||
            (codePoint >= SHIFT_OUT && codePoint <= INFORMATION_SEPARATOR_ONE) ||
            codePoint === DELETE);
    };
    var isValidEscape = function (c1, c2) {
        if (c1 !== REVERSE_SOLIDUS) {
            return false;
        }
        return c2 !== LINE_FEED;
    };
    var isIdentifierStart = function (c1, c2, c3) {
        if (c1 === HYPHEN_MINUS) {
            return isNameStartCodePoint(c2) || isValidEscape(c2, c3);
        }
        else if (isNameStartCodePoint(c1)) {
            return true;
        }
        else if (c1 === REVERSE_SOLIDUS && isValidEscape(c1, c2)) {
            return true;
        }
        return false;
    };
    var isNumberStart = function (c1, c2, c3) {
        if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
            if (isDigit(c2)) {
                return true;
            }
            return c2 === FULL_STOP && isDigit(c3);
        }
        if (c1 === FULL_STOP) {
            return isDigit(c2);
        }
        return isDigit(c1);
    };
    var stringToNumber = function (codePoints) {
        var c = 0;
        var sign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                sign = -1;
            }
            c++;
        }
        var integers = [];
        while (isDigit(codePoints[c])) {
            integers.push(codePoints[c++]);
        }
        var int = integers.length ? parseInt(fromCodePoint$1.apply(void 0, integers), 10) : 0;
        if (codePoints[c] === FULL_STOP) {
            c++;
        }
        var fraction = [];
        while (isDigit(codePoints[c])) {
            fraction.push(codePoints[c++]);
        }
        var fracd = fraction.length;
        var frac = fracd ? parseInt(fromCodePoint$1.apply(void 0, fraction), 10) : 0;
        if (codePoints[c] === E || codePoints[c] === e) {
            c++;
        }
        var expsign = 1;
        if (codePoints[c] === PLUS_SIGN || codePoints[c] === HYPHEN_MINUS) {
            if (codePoints[c] === HYPHEN_MINUS) {
                expsign = -1;
            }
            c++;
        }
        var exponent = [];
        while (isDigit(codePoints[c])) {
            exponent.push(codePoints[c++]);
        }
        var exp = exponent.length ? parseInt(fromCodePoint$1.apply(void 0, exponent), 10) : 0;
        return sign * (int + frac * Math.pow(10, -fracd)) * Math.pow(10, expsign * exp);
    };
    var LEFT_PARENTHESIS_TOKEN = {
        type: 2 /* LEFT_PARENTHESIS_TOKEN */
    };
    var RIGHT_PARENTHESIS_TOKEN = {
        type: 3 /* RIGHT_PARENTHESIS_TOKEN */
    };
    var COMMA_TOKEN = { type: 4 /* COMMA_TOKEN */ };
    var SUFFIX_MATCH_TOKEN = { type: 13 /* SUFFIX_MATCH_TOKEN */ };
    var PREFIX_MATCH_TOKEN = { type: 8 /* PREFIX_MATCH_TOKEN */ };
    var COLUMN_TOKEN = { type: 21 /* COLUMN_TOKEN */ };
    var DASH_MATCH_TOKEN = { type: 9 /* DASH_MATCH_TOKEN */ };
    var INCLUDE_MATCH_TOKEN = { type: 10 /* INCLUDE_MATCH_TOKEN */ };
    var LEFT_CURLY_BRACKET_TOKEN = {
        type: 11 /* LEFT_CURLY_BRACKET_TOKEN */
    };
    var RIGHT_CURLY_BRACKET_TOKEN = {
        type: 12 /* RIGHT_CURLY_BRACKET_TOKEN */
    };
    var SUBSTRING_MATCH_TOKEN = { type: 14 /* SUBSTRING_MATCH_TOKEN */ };
    var BAD_URL_TOKEN = { type: 23 /* BAD_URL_TOKEN */ };
    var BAD_STRING_TOKEN = { type: 1 /* BAD_STRING_TOKEN */ };
    var CDO_TOKEN = { type: 25 /* CDO_TOKEN */ };
    var CDC_TOKEN = { type: 24 /* CDC_TOKEN */ };
    var COLON_TOKEN = { type: 26 /* COLON_TOKEN */ };
    var SEMICOLON_TOKEN = { type: 27 /* SEMICOLON_TOKEN */ };
    var LEFT_SQUARE_BRACKET_TOKEN = {
        type: 28 /* LEFT_SQUARE_BRACKET_TOKEN */
    };
    var RIGHT_SQUARE_BRACKET_TOKEN = {
        type: 29 /* RIGHT_SQUARE_BRACKET_TOKEN */
    };
    var WHITESPACE_TOKEN = { type: 31 /* WHITESPACE_TOKEN */ };
    var EOF_TOKEN = { type: 32 /* EOF_TOKEN */ };
    var Tokenizer = /** @class */ (function () {
        function Tokenizer() {
            this._value = [];
        }
        Tokenizer.prototype.write = function (chunk) {
            this._value = this._value.concat(toCodePoints$1(chunk));
        };
        Tokenizer.prototype.read = function () {
            var tokens = [];
            var token = this.consumeToken();
            while (token !== EOF_TOKEN) {
                tokens.push(token);
                token = this.consumeToken();
            }
            return tokens;
        };
        Tokenizer.prototype.consumeToken = function () {
            var codePoint = this.consumeCodePoint();
            switch (codePoint) {
                case QUOTATION_MARK:
                    return this.consumeStringToken(QUOTATION_MARK);
                case NUMBER_SIGN:
                    var c1 = this.peekCodePoint(0);
                    var c2 = this.peekCodePoint(1);
                    var c3 = this.peekCodePoint(2);
                    if (isNameCodePoint(c1) || isValidEscape(c2, c3)) {
                        var flags = isIdentifierStart(c1, c2, c3) ? FLAG_ID : FLAG_UNRESTRICTED;
                        var value = this.consumeName();
                        return { type: 5 /* HASH_TOKEN */, value: value, flags: flags };
                    }
                    break;
                case DOLLAR_SIGN:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUFFIX_MATCH_TOKEN;
                    }
                    break;
                case APOSTROPHE:
                    return this.consumeStringToken(APOSTROPHE);
                case LEFT_PARENTHESIS:
                    return LEFT_PARENTHESIS_TOKEN;
                case RIGHT_PARENTHESIS:
                    return RIGHT_PARENTHESIS_TOKEN;
                case ASTERISK:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return SUBSTRING_MATCH_TOKEN;
                    }
                    break;
                case PLUS_SIGN:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case COMMA:
                    return COMMA_TOKEN;
                case HYPHEN_MINUS:
                    var e1 = codePoint;
                    var e2 = this.peekCodePoint(0);
                    var e3 = this.peekCodePoint(1);
                    if (isNumberStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    if (isIdentifierStart(e1, e2, e3)) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    if (e2 === HYPHEN_MINUS && e3 === GREATER_THAN_SIGN) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDC_TOKEN;
                    }
                    break;
                case FULL_STOP:
                    if (isNumberStart(codePoint, this.peekCodePoint(0), this.peekCodePoint(1))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeNumericToken();
                    }
                    break;
                case SOLIDUS:
                    if (this.peekCodePoint(0) === ASTERISK) {
                        this.consumeCodePoint();
                        while (true) {
                            var c = this.consumeCodePoint();
                            if (c === ASTERISK) {
                                c = this.consumeCodePoint();
                                if (c === SOLIDUS) {
                                    return this.consumeToken();
                                }
                            }
                            if (c === EOF) {
                                return this.consumeToken();
                            }
                        }
                    }
                    break;
                case COLON:
                    return COLON_TOKEN;
                case SEMICOLON:
                    return SEMICOLON_TOKEN;
                case LESS_THAN_SIGN:
                    if (this.peekCodePoint(0) === EXCLAMATION_MARK &&
                        this.peekCodePoint(1) === HYPHEN_MINUS &&
                        this.peekCodePoint(2) === HYPHEN_MINUS) {
                        this.consumeCodePoint();
                        this.consumeCodePoint();
                        return CDO_TOKEN;
                    }
                    break;
                case COMMERCIAL_AT:
                    var a1 = this.peekCodePoint(0);
                    var a2 = this.peekCodePoint(1);
                    var a3 = this.peekCodePoint(2);
                    if (isIdentifierStart(a1, a2, a3)) {
                        var value = this.consumeName();
                        return { type: 7 /* AT_KEYWORD_TOKEN */, value: value };
                    }
                    break;
                case LEFT_SQUARE_BRACKET:
                    return LEFT_SQUARE_BRACKET_TOKEN;
                case REVERSE_SOLIDUS:
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        this.reconsumeCodePoint(codePoint);
                        return this.consumeIdentLikeToken();
                    }
                    break;
                case RIGHT_SQUARE_BRACKET:
                    return RIGHT_SQUARE_BRACKET_TOKEN;
                case CIRCUMFLEX_ACCENT:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return PREFIX_MATCH_TOKEN;
                    }
                    break;
                case LEFT_CURLY_BRACKET:
                    return LEFT_CURLY_BRACKET_TOKEN;
                case RIGHT_CURLY_BRACKET:
                    return RIGHT_CURLY_BRACKET_TOKEN;
                case u:
                case U:
                    var u1 = this.peekCodePoint(0);
                    var u2 = this.peekCodePoint(1);
                    if (u1 === PLUS_SIGN && (isHex(u2) || u2 === QUESTION_MARK)) {
                        this.consumeCodePoint();
                        this.consumeUnicodeRangeToken();
                    }
                    this.reconsumeCodePoint(codePoint);
                    return this.consumeIdentLikeToken();
                case VERTICAL_LINE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return DASH_MATCH_TOKEN;
                    }
                    if (this.peekCodePoint(0) === VERTICAL_LINE) {
                        this.consumeCodePoint();
                        return COLUMN_TOKEN;
                    }
                    break;
                case TILDE:
                    if (this.peekCodePoint(0) === EQUALS_SIGN) {
                        this.consumeCodePoint();
                        return INCLUDE_MATCH_TOKEN;
                    }
                    break;
                case EOF:
                    return EOF_TOKEN;
            }
            if (isWhiteSpace(codePoint)) {
                this.consumeWhiteSpace();
                return WHITESPACE_TOKEN;
            }
            if (isDigit(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeNumericToken();
            }
            if (isNameStartCodePoint(codePoint)) {
                this.reconsumeCodePoint(codePoint);
                return this.consumeIdentLikeToken();
            }
            return { type: 6 /* DELIM_TOKEN */, value: fromCodePoint$1(codePoint) };
        };
        Tokenizer.prototype.consumeCodePoint = function () {
            var value = this._value.shift();
            return typeof value === 'undefined' ? -1 : value;
        };
        Tokenizer.prototype.reconsumeCodePoint = function (codePoint) {
            this._value.unshift(codePoint);
        };
        Tokenizer.prototype.peekCodePoint = function (delta) {
            if (delta >= this._value.length) {
                return -1;
            }
            return this._value[delta];
        };
        Tokenizer.prototype.consumeUnicodeRangeToken = function () {
            var digits = [];
            var codePoint = this.consumeCodePoint();
            while (isHex(codePoint) && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
            }
            var questionMarks = false;
            while (codePoint === QUESTION_MARK && digits.length < 6) {
                digits.push(codePoint);
                codePoint = this.consumeCodePoint();
                questionMarks = true;
            }
            if (questionMarks) {
                var start_1 = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? ZERO : digit); })), 16);
                var end = parseInt(fromCodePoint$1.apply(void 0, digits.map(function (digit) { return (digit === QUESTION_MARK ? F : digit); })), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start_1, end: end };
            }
            var start = parseInt(fromCodePoint$1.apply(void 0, digits), 16);
            if (this.peekCodePoint(0) === HYPHEN_MINUS && isHex(this.peekCodePoint(1))) {
                this.consumeCodePoint();
                codePoint = this.consumeCodePoint();
                var endDigits = [];
                while (isHex(codePoint) && endDigits.length < 6) {
                    endDigits.push(codePoint);
                    codePoint = this.consumeCodePoint();
                }
                var end = parseInt(fromCodePoint$1.apply(void 0, endDigits), 16);
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: end };
            }
            else {
                return { type: 30 /* UNICODE_RANGE_TOKEN */, start: start, end: start };
            }
        };
        Tokenizer.prototype.consumeIdentLikeToken = function () {
            var value = this.consumeName();
            if (value.toLowerCase() === 'url' && this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return this.consumeUrlToken();
            }
            else if (this.peekCodePoint(0) === LEFT_PARENTHESIS) {
                this.consumeCodePoint();
                return { type: 19 /* FUNCTION_TOKEN */, value: value };
            }
            return { type: 20 /* IDENT_TOKEN */, value: value };
        };
        Tokenizer.prototype.consumeUrlToken = function () {
            var value = [];
            this.consumeWhiteSpace();
            if (this.peekCodePoint(0) === EOF) {
                return { type: 22 /* URL_TOKEN */, value: '' };
            }
            var next = this.peekCodePoint(0);
            if (next === APOSTROPHE || next === QUOTATION_MARK) {
                var stringToken = this.consumeStringToken(this.consumeCodePoint());
                if (stringToken.type === 0 /* STRING_TOKEN */) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: stringToken.value };
                    }
                }
                this.consumeBadUrlRemnants();
                return BAD_URL_TOKEN;
            }
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === EOF || codePoint === RIGHT_PARENTHESIS) {
                    return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                }
                else if (isWhiteSpace(codePoint)) {
                    this.consumeWhiteSpace();
                    if (this.peekCodePoint(0) === EOF || this.peekCodePoint(0) === RIGHT_PARENTHESIS) {
                        this.consumeCodePoint();
                        return { type: 22 /* URL_TOKEN */, value: fromCodePoint$1.apply(void 0, value) };
                    }
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === QUOTATION_MARK ||
                    codePoint === APOSTROPHE ||
                    codePoint === LEFT_PARENTHESIS ||
                    isNonPrintableCodePoint(codePoint)) {
                    this.consumeBadUrlRemnants();
                    return BAD_URL_TOKEN;
                }
                else if (codePoint === REVERSE_SOLIDUS) {
                    if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                        value.push(this.consumeEscapedCodePoint());
                    }
                    else {
                        this.consumeBadUrlRemnants();
                        return BAD_URL_TOKEN;
                    }
                }
                else {
                    value.push(codePoint);
                }
            }
        };
        Tokenizer.prototype.consumeWhiteSpace = function () {
            while (isWhiteSpace(this.peekCodePoint(0))) {
                this.consumeCodePoint();
            }
        };
        Tokenizer.prototype.consumeBadUrlRemnants = function () {
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (codePoint === RIGHT_PARENTHESIS || codePoint === EOF) {
                    return;
                }
                if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    this.consumeEscapedCodePoint();
                }
            }
        };
        Tokenizer.prototype.consumeStringSlice = function (count) {
            var SLICE_STACK_SIZE = 50000;
            var value = '';
            while (count > 0) {
                var amount = Math.min(SLICE_STACK_SIZE, count);
                value += fromCodePoint$1.apply(void 0, this._value.splice(0, amount));
                count -= amount;
            }
            this._value.shift();
            return value;
        };
        Tokenizer.prototype.consumeStringToken = function (endingCodePoint) {
            var value = '';
            var i = 0;
            do {
                var codePoint = this._value[i];
                if (codePoint === EOF || codePoint === undefined || codePoint === endingCodePoint) {
                    value += this.consumeStringSlice(i);
                    return { type: 0 /* STRING_TOKEN */, value: value };
                }
                if (codePoint === LINE_FEED) {
                    this._value.splice(0, i);
                    return BAD_STRING_TOKEN;
                }
                if (codePoint === REVERSE_SOLIDUS) {
                    var next = this._value[i + 1];
                    if (next !== EOF && next !== undefined) {
                        if (next === LINE_FEED) {
                            value += this.consumeStringSlice(i);
                            i = -1;
                            this._value.shift();
                        }
                        else if (isValidEscape(codePoint, next)) {
                            value += this.consumeStringSlice(i);
                            value += fromCodePoint$1(this.consumeEscapedCodePoint());
                            i = -1;
                        }
                    }
                }
                i++;
            } while (true);
        };
        Tokenizer.prototype.consumeNumber = function () {
            var repr = [];
            var type = FLAG_INTEGER;
            var c1 = this.peekCodePoint(0);
            if (c1 === PLUS_SIGN || c1 === HYPHEN_MINUS) {
                repr.push(this.consumeCodePoint());
            }
            while (isDigit(this.peekCodePoint(0))) {
                repr.push(this.consumeCodePoint());
            }
            c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            if (c1 === FULL_STOP && isDigit(c2)) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            c1 = this.peekCodePoint(0);
            c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if ((c1 === E || c1 === e) && (((c2 === PLUS_SIGN || c2 === HYPHEN_MINUS) && isDigit(c3)) || isDigit(c2))) {
                repr.push(this.consumeCodePoint(), this.consumeCodePoint());
                type = FLAG_NUMBER;
                while (isDigit(this.peekCodePoint(0))) {
                    repr.push(this.consumeCodePoint());
                }
            }
            return [stringToNumber(repr), type];
        };
        Tokenizer.prototype.consumeNumericToken = function () {
            var _a = this.consumeNumber(), number = _a[0], flags = _a[1];
            var c1 = this.peekCodePoint(0);
            var c2 = this.peekCodePoint(1);
            var c3 = this.peekCodePoint(2);
            if (isIdentifierStart(c1, c2, c3)) {
                var unit = this.consumeName();
                return { type: 15 /* DIMENSION_TOKEN */, number: number, flags: flags, unit: unit };
            }
            if (c1 === PERCENTAGE_SIGN) {
                this.consumeCodePoint();
                return { type: 16 /* PERCENTAGE_TOKEN */, number: number, flags: flags };
            }
            return { type: 17 /* NUMBER_TOKEN */, number: number, flags: flags };
        };
        Tokenizer.prototype.consumeEscapedCodePoint = function () {
            var codePoint = this.consumeCodePoint();
            if (isHex(codePoint)) {
                var hex = fromCodePoint$1(codePoint);
                while (isHex(this.peekCodePoint(0)) && hex.length < 6) {
                    hex += fromCodePoint$1(this.consumeCodePoint());
                }
                if (isWhiteSpace(this.peekCodePoint(0))) {
                    this.consumeCodePoint();
                }
                var hexCodePoint = parseInt(hex, 16);
                if (hexCodePoint === 0 || isSurrogateCodePoint(hexCodePoint) || hexCodePoint > 0x10ffff) {
                    return REPLACEMENT_CHARACTER;
                }
                return hexCodePoint;
            }
            if (codePoint === EOF) {
                return REPLACEMENT_CHARACTER;
            }
            return codePoint;
        };
        Tokenizer.prototype.consumeName = function () {
            var result = '';
            while (true) {
                var codePoint = this.consumeCodePoint();
                if (isNameCodePoint(codePoint)) {
                    result += fromCodePoint$1(codePoint);
                }
                else if (isValidEscape(codePoint, this.peekCodePoint(0))) {
                    result += fromCodePoint$1(this.consumeEscapedCodePoint());
                }
                else {
                    this.reconsumeCodePoint(codePoint);
                    return result;
                }
            }
        };
        return Tokenizer;
    }());

    var Parser = /** @class */ (function () {
        function Parser(tokens) {
            this._tokens = tokens;
        }
        Parser.create = function (value) {
            var tokenizer = new Tokenizer();
            tokenizer.write(value);
            return new Parser(tokenizer.read());
        };
        Parser.parseValue = function (value) {
            return Parser.create(value).parseComponentValue();
        };
        Parser.parseValues = function (value) {
            return Parser.create(value).parseComponentValues();
        };
        Parser.prototype.parseComponentValue = function () {
            var token = this.consumeToken();
            while (token.type === 31 /* WHITESPACE_TOKEN */) {
                token = this.consumeToken();
            }
            if (token.type === 32 /* EOF_TOKEN */) {
                throw new SyntaxError("Error parsing CSS component value, unexpected EOF");
            }
            this.reconsumeToken(token);
            var value = this.consumeComponentValue();
            do {
                token = this.consumeToken();
            } while (token.type === 31 /* WHITESPACE_TOKEN */);
            if (token.type === 32 /* EOF_TOKEN */) {
                return value;
            }
            throw new SyntaxError("Error parsing CSS component value, multiple values found when expecting only one");
        };
        Parser.prototype.parseComponentValues = function () {
            var values = [];
            while (true) {
                var value = this.consumeComponentValue();
                if (value.type === 32 /* EOF_TOKEN */) {
                    return values;
                }
                values.push(value);
                values.push();
            }
        };
        Parser.prototype.consumeComponentValue = function () {
            var token = this.consumeToken();
            switch (token.type) {
                case 11 /* LEFT_CURLY_BRACKET_TOKEN */:
                case 28 /* LEFT_SQUARE_BRACKET_TOKEN */:
                case 2 /* LEFT_PARENTHESIS_TOKEN */:
                    return this.consumeSimpleBlock(token.type);
                case 19 /* FUNCTION_TOKEN */:
                    return this.consumeFunction(token);
            }
            return token;
        };
        Parser.prototype.consumeSimpleBlock = function (type) {
            var block = { type: type, values: [] };
            var token = this.consumeToken();
            while (true) {
                if (token.type === 32 /* EOF_TOKEN */ || isEndingTokenFor(token, type)) {
                    return block;
                }
                this.reconsumeToken(token);
                block.values.push(this.consumeComponentValue());
                token = this.consumeToken();
            }
        };
        Parser.prototype.consumeFunction = function (functionToken) {
            var cssFunction = {
                name: functionToken.value,
                values: [],
                type: 18 /* FUNCTION */
            };
            while (true) {
                var token = this.consumeToken();
                if (token.type === 32 /* EOF_TOKEN */ || token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */) {
                    return cssFunction;
                }
                this.reconsumeToken(token);
                cssFunction.values.push(this.consumeComponentValue());
            }
        };
        Parser.prototype.consumeToken = function () {
            var token = this._tokens.shift();
            return typeof token === 'undefined' ? EOF_TOKEN : token;
        };
        Parser.prototype.reconsumeToken = function (token) {
            this._tokens.unshift(token);
        };
        return Parser;
    }());
    var isDimensionToken = function (token) { return token.type === 15 /* DIMENSION_TOKEN */; };
    var isNumberToken = function (token) { return token.type === 17 /* NUMBER_TOKEN */; };
    var isIdentToken = function (token) { return token.type === 20 /* IDENT_TOKEN */; };
    var isStringToken = function (token) { return token.type === 0 /* STRING_TOKEN */; };
    var isIdentWithValue = function (token, value) {
        return isIdentToken(token) && token.value === value;
    };
    var nonWhiteSpace = function (token) { return token.type !== 31 /* WHITESPACE_TOKEN */; };
    var nonFunctionArgSeparator = function (token) {
        return token.type !== 31 /* WHITESPACE_TOKEN */ && token.type !== 4 /* COMMA_TOKEN */;
    };
    var parseFunctionArgs = function (tokens) {
        var args = [];
        var arg = [];
        tokens.forEach(function (token) {
            if (token.type === 4 /* COMMA_TOKEN */) {
                if (arg.length === 0) {
                    throw new Error("Error parsing function args, zero tokens for arg");
                }
                args.push(arg);
                arg = [];
                return;
            }
            if (token.type !== 31 /* WHITESPACE_TOKEN */) {
                arg.push(token);
            }
        });
        if (arg.length) {
            args.push(arg);
        }
        return args;
    };
    var isEndingTokenFor = function (token, type) {
        if (type === 11 /* LEFT_CURLY_BRACKET_TOKEN */ && token.type === 12 /* RIGHT_CURLY_BRACKET_TOKEN */) {
            return true;
        }
        if (type === 28 /* LEFT_SQUARE_BRACKET_TOKEN */ && token.type === 29 /* RIGHT_SQUARE_BRACKET_TOKEN */) {
            return true;
        }
        return type === 2 /* LEFT_PARENTHESIS_TOKEN */ && token.type === 3 /* RIGHT_PARENTHESIS_TOKEN */;
    };

    var isLength = function (token) {
        return token.type === 17 /* NUMBER_TOKEN */ || token.type === 15 /* DIMENSION_TOKEN */;
    };

    var isLengthPercentage = function (token) {
        return token.type === 16 /* PERCENTAGE_TOKEN */ || isLength(token);
    };
    var parseLengthPercentageTuple = function (tokens) {
        return tokens.length > 1 ? [tokens[0], tokens[1]] : [tokens[0]];
    };
    var ZERO_LENGTH = {
        type: 17 /* NUMBER_TOKEN */,
        number: 0,
        flags: FLAG_INTEGER
    };
    var FIFTY_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var HUNDRED_PERCENT = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 100,
        flags: FLAG_INTEGER
    };
    var getAbsoluteValueForTuple = function (tuple, width, height) {
        var x = tuple[0], y = tuple[1];
        return [getAbsoluteValue(x, width), getAbsoluteValue(typeof y !== 'undefined' ? y : x, height)];
    };
    var getAbsoluteValue = function (token, parent) {
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            return (token.number / 100) * parent;
        }
        if (isDimensionToken(token)) {
            switch (token.unit) {
                case 'rem':
                case 'em':
                    return 16 * token.number; // TODO use correct font-size
                case 'px':
                default:
                    return token.number;
            }
        }
        return token.number;
    };

    var DEG = 'deg';
    var GRAD = 'grad';
    var RAD = 'rad';
    var TURN = 'turn';
    var angle = {
        name: 'angle',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit) {
                    case DEG:
                        return (Math.PI * value.number) / 180;
                    case GRAD:
                        return (Math.PI / 200) * value.number;
                    case RAD:
                        return value.number;
                    case TURN:
                        return Math.PI * 2 * value.number;
                }
            }
            throw new Error("Unsupported angle type");
        }
    };
    var isAngle = function (value) {
        if (value.type === 15 /* DIMENSION_TOKEN */) {
            if (value.unit === DEG || value.unit === GRAD || value.unit === RAD || value.unit === TURN) {
                return true;
            }
        }
        return false;
    };
    var parseNamedSide = function (tokens) {
        var sideOrCorner = tokens
            .filter(isIdentToken)
            .map(function (ident) { return ident.value; })
            .join(' ');
        switch (sideOrCorner) {
            case 'to bottom right':
            case 'to right bottom':
            case 'left top':
            case 'top left':
                return [ZERO_LENGTH, ZERO_LENGTH];
            case 'to top':
            case 'bottom':
                return deg(0);
            case 'to bottom left':
            case 'to left bottom':
            case 'right top':
            case 'top right':
                return [ZERO_LENGTH, HUNDRED_PERCENT];
            case 'to right':
            case 'left':
                return deg(90);
            case 'to top left':
            case 'to left top':
            case 'right bottom':
            case 'bottom right':
                return [HUNDRED_PERCENT, HUNDRED_PERCENT];
            case 'to bottom':
            case 'top':
                return deg(180);
            case 'to top right':
            case 'to right top':
            case 'left bottom':
            case 'bottom left':
                return [HUNDRED_PERCENT, ZERO_LENGTH];
            case 'to left':
            case 'right':
                return deg(270);
        }
        return 0;
    };
    var deg = function (deg) { return (Math.PI * deg) / 180; };

    var color$1 = {
        name: 'color',
        parse: function (context, value) {
            if (value.type === 18 /* FUNCTION */) {
                var colorFunction = SUPPORTED_COLOR_FUNCTIONS[value.name];
                if (typeof colorFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported color function \"" + value.name + "\"");
                }
                return colorFunction(context, value.values);
            }
            if (value.type === 5 /* HASH_TOKEN */) {
                if (value.value.length === 3) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), 1);
                }
                if (value.value.length === 4) {
                    var r = value.value.substring(0, 1);
                    var g = value.value.substring(1, 2);
                    var b = value.value.substring(2, 3);
                    var a = value.value.substring(3, 4);
                    return pack(parseInt(r + r, 16), parseInt(g + g, 16), parseInt(b + b, 16), parseInt(a + a, 16) / 255);
                }
                if (value.value.length === 6) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), 1);
                }
                if (value.value.length === 8) {
                    var r = value.value.substring(0, 2);
                    var g = value.value.substring(2, 4);
                    var b = value.value.substring(4, 6);
                    var a = value.value.substring(6, 8);
                    return pack(parseInt(r, 16), parseInt(g, 16), parseInt(b, 16), parseInt(a, 16) / 255);
                }
            }
            if (value.type === 20 /* IDENT_TOKEN */) {
                var namedColor = COLORS[value.value.toUpperCase()];
                if (typeof namedColor !== 'undefined') {
                    return namedColor;
                }
            }
            return COLORS.TRANSPARENT;
        }
    };
    var isTransparent = function (color) { return (0xff & color) === 0; };
    var asString = function (color) {
        var alpha = 0xff & color;
        var blue = 0xff & (color >> 8);
        var green = 0xff & (color >> 16);
        var red = 0xff & (color >> 24);
        return alpha < 255 ? "rgba(" + red + "," + green + "," + blue + "," + alpha / 255 + ")" : "rgb(" + red + "," + green + "," + blue + ")";
    };
    var pack = function (r, g, b, a) {
        return ((r << 24) | (g << 16) | (b << 8) | (Math.round(a * 255) << 0)) >>> 0;
    };
    var getTokenColorValue = function (token, i) {
        if (token.type === 17 /* NUMBER_TOKEN */) {
            return token.number;
        }
        if (token.type === 16 /* PERCENTAGE_TOKEN */) {
            var max = i === 3 ? 1 : 255;
            return i === 3 ? (token.number / 100) * max : Math.round((token.number / 100) * max);
        }
        return 0;
    };
    var rgb = function (_context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        if (tokens.length === 3) {
            var _a = tokens.map(getTokenColorValue), r = _a[0], g = _a[1], b = _a[2];
            return pack(r, g, b, 1);
        }
        if (tokens.length === 4) {
            var _b = tokens.map(getTokenColorValue), r = _b[0], g = _b[1], b = _b[2], a = _b[3];
            return pack(r, g, b, a);
        }
        return 0;
    };
    function hue2rgb(t1, t2, hue) {
        if (hue < 0) {
            hue += 1;
        }
        if (hue >= 1) {
            hue -= 1;
        }
        if (hue < 1 / 6) {
            return (t2 - t1) * hue * 6 + t1;
        }
        else if (hue < 1 / 2) {
            return t2;
        }
        else if (hue < 2 / 3) {
            return (t2 - t1) * 6 * (2 / 3 - hue) + t1;
        }
        else {
            return t1;
        }
    }
    var hsl = function (context, args) {
        var tokens = args.filter(nonFunctionArgSeparator);
        var hue = tokens[0], saturation = tokens[1], lightness = tokens[2], alpha = tokens[3];
        var h = (hue.type === 17 /* NUMBER_TOKEN */ ? deg(hue.number) : angle.parse(context, hue)) / (Math.PI * 2);
        var s = isLengthPercentage(saturation) ? saturation.number / 100 : 0;
        var l = isLengthPercentage(lightness) ? lightness.number / 100 : 0;
        var a = typeof alpha !== 'undefined' && isLengthPercentage(alpha) ? getAbsoluteValue(alpha, 1) : 1;
        if (s === 0) {
            return pack(l * 255, l * 255, l * 255, 1);
        }
        var t2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
        var t1 = l * 2 - t2;
        var r = hue2rgb(t1, t2, h + 1 / 3);
        var g = hue2rgb(t1, t2, h);
        var b = hue2rgb(t1, t2, h - 1 / 3);
        return pack(r * 255, g * 255, b * 255, a);
    };
    var SUPPORTED_COLOR_FUNCTIONS = {
        hsl: hsl,
        hsla: hsl,
        rgb: rgb,
        rgba: rgb
    };
    var parseColor = function (context, value) {
        return color$1.parse(context, Parser.create(value).parseComponentValue());
    };
    var COLORS = {
        ALICEBLUE: 0xf0f8ffff,
        ANTIQUEWHITE: 0xfaebd7ff,
        AQUA: 0x00ffffff,
        AQUAMARINE: 0x7fffd4ff,
        AZURE: 0xf0ffffff,
        BEIGE: 0xf5f5dcff,
        BISQUE: 0xffe4c4ff,
        BLACK: 0x000000ff,
        BLANCHEDALMOND: 0xffebcdff,
        BLUE: 0x0000ffff,
        BLUEVIOLET: 0x8a2be2ff,
        BROWN: 0xa52a2aff,
        BURLYWOOD: 0xdeb887ff,
        CADETBLUE: 0x5f9ea0ff,
        CHARTREUSE: 0x7fff00ff,
        CHOCOLATE: 0xd2691eff,
        CORAL: 0xff7f50ff,
        CORNFLOWERBLUE: 0x6495edff,
        CORNSILK: 0xfff8dcff,
        CRIMSON: 0xdc143cff,
        CYAN: 0x00ffffff,
        DARKBLUE: 0x00008bff,
        DARKCYAN: 0x008b8bff,
        DARKGOLDENROD: 0xb886bbff,
        DARKGRAY: 0xa9a9a9ff,
        DARKGREEN: 0x006400ff,
        DARKGREY: 0xa9a9a9ff,
        DARKKHAKI: 0xbdb76bff,
        DARKMAGENTA: 0x8b008bff,
        DARKOLIVEGREEN: 0x556b2fff,
        DARKORANGE: 0xff8c00ff,
        DARKORCHID: 0x9932ccff,
        DARKRED: 0x8b0000ff,
        DARKSALMON: 0xe9967aff,
        DARKSEAGREEN: 0x8fbc8fff,
        DARKSLATEBLUE: 0x483d8bff,
        DARKSLATEGRAY: 0x2f4f4fff,
        DARKSLATEGREY: 0x2f4f4fff,
        DARKTURQUOISE: 0x00ced1ff,
        DARKVIOLET: 0x9400d3ff,
        DEEPPINK: 0xff1493ff,
        DEEPSKYBLUE: 0x00bfffff,
        DIMGRAY: 0x696969ff,
        DIMGREY: 0x696969ff,
        DODGERBLUE: 0x1e90ffff,
        FIREBRICK: 0xb22222ff,
        FLORALWHITE: 0xfffaf0ff,
        FORESTGREEN: 0x228b22ff,
        FUCHSIA: 0xff00ffff,
        GAINSBORO: 0xdcdcdcff,
        GHOSTWHITE: 0xf8f8ffff,
        GOLD: 0xffd700ff,
        GOLDENROD: 0xdaa520ff,
        GRAY: 0x808080ff,
        GREEN: 0x008000ff,
        GREENYELLOW: 0xadff2fff,
        GREY: 0x808080ff,
        HONEYDEW: 0xf0fff0ff,
        HOTPINK: 0xff69b4ff,
        INDIANRED: 0xcd5c5cff,
        INDIGO: 0x4b0082ff,
        IVORY: 0xfffff0ff,
        KHAKI: 0xf0e68cff,
        LAVENDER: 0xe6e6faff,
        LAVENDERBLUSH: 0xfff0f5ff,
        LAWNGREEN: 0x7cfc00ff,
        LEMONCHIFFON: 0xfffacdff,
        LIGHTBLUE: 0xadd8e6ff,
        LIGHTCORAL: 0xf08080ff,
        LIGHTCYAN: 0xe0ffffff,
        LIGHTGOLDENRODYELLOW: 0xfafad2ff,
        LIGHTGRAY: 0xd3d3d3ff,
        LIGHTGREEN: 0x90ee90ff,
        LIGHTGREY: 0xd3d3d3ff,
        LIGHTPINK: 0xffb6c1ff,
        LIGHTSALMON: 0xffa07aff,
        LIGHTSEAGREEN: 0x20b2aaff,
        LIGHTSKYBLUE: 0x87cefaff,
        LIGHTSLATEGRAY: 0x778899ff,
        LIGHTSLATEGREY: 0x778899ff,
        LIGHTSTEELBLUE: 0xb0c4deff,
        LIGHTYELLOW: 0xffffe0ff,
        LIME: 0x00ff00ff,
        LIMEGREEN: 0x32cd32ff,
        LINEN: 0xfaf0e6ff,
        MAGENTA: 0xff00ffff,
        MAROON: 0x800000ff,
        MEDIUMAQUAMARINE: 0x66cdaaff,
        MEDIUMBLUE: 0x0000cdff,
        MEDIUMORCHID: 0xba55d3ff,
        MEDIUMPURPLE: 0x9370dbff,
        MEDIUMSEAGREEN: 0x3cb371ff,
        MEDIUMSLATEBLUE: 0x7b68eeff,
        MEDIUMSPRINGGREEN: 0x00fa9aff,
        MEDIUMTURQUOISE: 0x48d1ccff,
        MEDIUMVIOLETRED: 0xc71585ff,
        MIDNIGHTBLUE: 0x191970ff,
        MINTCREAM: 0xf5fffaff,
        MISTYROSE: 0xffe4e1ff,
        MOCCASIN: 0xffe4b5ff,
        NAVAJOWHITE: 0xffdeadff,
        NAVY: 0x000080ff,
        OLDLACE: 0xfdf5e6ff,
        OLIVE: 0x808000ff,
        OLIVEDRAB: 0x6b8e23ff,
        ORANGE: 0xffa500ff,
        ORANGERED: 0xff4500ff,
        ORCHID: 0xda70d6ff,
        PALEGOLDENROD: 0xeee8aaff,
        PALEGREEN: 0x98fb98ff,
        PALETURQUOISE: 0xafeeeeff,
        PALEVIOLETRED: 0xdb7093ff,
        PAPAYAWHIP: 0xffefd5ff,
        PEACHPUFF: 0xffdab9ff,
        PERU: 0xcd853fff,
        PINK: 0xffc0cbff,
        PLUM: 0xdda0ddff,
        POWDERBLUE: 0xb0e0e6ff,
        PURPLE: 0x800080ff,
        REBECCAPURPLE: 0x663399ff,
        RED: 0xff0000ff,
        ROSYBROWN: 0xbc8f8fff,
        ROYALBLUE: 0x4169e1ff,
        SADDLEBROWN: 0x8b4513ff,
        SALMON: 0xfa8072ff,
        SANDYBROWN: 0xf4a460ff,
        SEAGREEN: 0x2e8b57ff,
        SEASHELL: 0xfff5eeff,
        SIENNA: 0xa0522dff,
        SILVER: 0xc0c0c0ff,
        SKYBLUE: 0x87ceebff,
        SLATEBLUE: 0x6a5acdff,
        SLATEGRAY: 0x708090ff,
        SLATEGREY: 0x708090ff,
        SNOW: 0xfffafaff,
        SPRINGGREEN: 0x00ff7fff,
        STEELBLUE: 0x4682b4ff,
        TAN: 0xd2b48cff,
        TEAL: 0x008080ff,
        THISTLE: 0xd8bfd8ff,
        TOMATO: 0xff6347ff,
        TRANSPARENT: 0x00000000,
        TURQUOISE: 0x40e0d0ff,
        VIOLET: 0xee82eeff,
        WHEAT: 0xf5deb3ff,
        WHITE: 0xffffffff,
        WHITESMOKE: 0xf5f5f5ff,
        YELLOW: 0xffff00ff,
        YELLOWGREEN: 0x9acd32ff
    };

    var backgroundClip = {
        name: 'background-clip',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundColor = {
        name: "background-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var parseColorStop = function (context, args) {
        var color = color$1.parse(context, args[0]);
        var stop = args[1];
        return stop && isLengthPercentage(stop) ? { color: color, stop: stop } : { color: color, stop: null };
    };
    var processColorStops = function (stops, lineLength) {
        var first = stops[0];
        var last = stops[stops.length - 1];
        if (first.stop === null) {
            first.stop = ZERO_LENGTH;
        }
        if (last.stop === null) {
            last.stop = HUNDRED_PERCENT;
        }
        var processStops = [];
        var previous = 0;
        for (var i = 0; i < stops.length; i++) {
            var stop_1 = stops[i].stop;
            if (stop_1 !== null) {
                var absoluteValue = getAbsoluteValue(stop_1, lineLength);
                if (absoluteValue > previous) {
                    processStops.push(absoluteValue);
                }
                else {
                    processStops.push(previous);
                }
                previous = absoluteValue;
            }
            else {
                processStops.push(null);
            }
        }
        var gapBegin = null;
        for (var i = 0; i < processStops.length; i++) {
            var stop_2 = processStops[i];
            if (stop_2 === null) {
                if (gapBegin === null) {
                    gapBegin = i;
                }
            }
            else if (gapBegin !== null) {
                var gapLength = i - gapBegin;
                var beforeGap = processStops[gapBegin - 1];
                var gapValue = (stop_2 - beforeGap) / (gapLength + 1);
                for (var g = 1; g <= gapLength; g++) {
                    processStops[gapBegin + g - 1] = gapValue * g;
                }
                gapBegin = null;
            }
        }
        return stops.map(function (_a, i) {
            var color = _a.color;
            return { color: color, stop: Math.max(Math.min(1, processStops[i] / lineLength), 0) };
        });
    };
    var getAngleFromCorner = function (corner, width, height) {
        var centerX = width / 2;
        var centerY = height / 2;
        var x = getAbsoluteValue(corner[0], width) - centerX;
        var y = centerY - getAbsoluteValue(corner[1], height);
        return (Math.atan2(y, x) + Math.PI * 2) % (Math.PI * 2);
    };
    var calculateGradientDirection = function (angle, width, height) {
        var radian = typeof angle === 'number' ? angle : getAngleFromCorner(angle, width, height);
        var lineLength = Math.abs(width * Math.sin(radian)) + Math.abs(height * Math.cos(radian));
        var halfWidth = width / 2;
        var halfHeight = height / 2;
        var halfLineLength = lineLength / 2;
        var yDiff = Math.sin(radian - Math.PI / 2) * halfLineLength;
        var xDiff = Math.cos(radian - Math.PI / 2) * halfLineLength;
        return [lineLength, halfWidth - xDiff, halfWidth + xDiff, halfHeight - yDiff, halfHeight + yDiff];
    };
    var distance = function (a, b) { return Math.sqrt(a * a + b * b); };
    var findCorner = function (width, height, x, y, closest) {
        var corners = [
            [0, 0],
            [0, height],
            [width, 0],
            [width, height]
        ];
        return corners.reduce(function (stat, corner) {
            var cx = corner[0], cy = corner[1];
            var d = distance(x - cx, y - cy);
            if (closest ? d < stat.optimumDistance : d > stat.optimumDistance) {
                return {
                    optimumCorner: corner,
                    optimumDistance: d
                };
            }
            return stat;
        }, {
            optimumDistance: closest ? Infinity : -Infinity,
            optimumCorner: null
        }).optimumCorner;
    };
    var calculateRadius = function (gradient, x, y, width, height) {
        var rx = 0;
        var ry = 0;
        switch (gradient.size) {
            case 0 /* CLOSEST_SIDE */:
                // The ending shape is sized so that that it exactly meets the side of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, it exactly meets the closest side in each dimension.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.min(Math.abs(x), Math.abs(x - width));
                    ry = Math.min(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 2 /* CLOSEST_CORNER */:
                // The ending shape is sized so that that it passes through the corner of the gradient box closest to the gradient’s center.
                // If the shape is an ellipse, the ending shape is given the same aspect-ratio it would have if closest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.min(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "closest-side")
                    var c = Math.min(Math.abs(y), Math.abs(y - height)) / Math.min(Math.abs(x), Math.abs(x - width));
                    var _a = findCorner(width, height, x, y, true), cx = _a[0], cy = _a[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
            case 1 /* FARTHEST_SIDE */:
                // Same as closest-side, except the ending shape is sized based on the farthest side(s)
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(Math.abs(x), Math.abs(x - width), Math.abs(y), Math.abs(y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    rx = Math.max(Math.abs(x), Math.abs(x - width));
                    ry = Math.max(Math.abs(y), Math.abs(y - height));
                }
                break;
            case 3 /* FARTHEST_CORNER */:
                // Same as closest-corner, except the ending shape is sized based on the farthest corner.
                // If the shape is an ellipse, the ending shape is given the same aspect ratio it would have if farthest-side were specified.
                if (gradient.shape === 0 /* CIRCLE */) {
                    rx = ry = Math.max(distance(x, y), distance(x, y - height), distance(x - width, y), distance(x - width, y - height));
                }
                else if (gradient.shape === 1 /* ELLIPSE */) {
                    // Compute the ratio ry/rx (which is to be the same as for "farthest-side")
                    var c = Math.max(Math.abs(y), Math.abs(y - height)) / Math.max(Math.abs(x), Math.abs(x - width));
                    var _b = findCorner(width, height, x, y, false), cx = _b[0], cy = _b[1];
                    rx = distance(cx - x, (cy - y) / c);
                    ry = c * rx;
                }
                break;
        }
        if (Array.isArray(gradient.size)) {
            rx = getAbsoluteValue(gradient.size[0], width);
            ry = gradient.size.length === 2 ? getAbsoluteValue(gradient.size[1], height) : rx;
        }
        return [rx, ry];
    };

    var linearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ && firstToken.value === 'to') {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = angle.parse(context, firstToken);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return { angle: angle$1, stops: stops, type: 1 /* LINEAR_GRADIENT */ };
    };

    var prefixLinearGradient = function (context, tokens) {
        var angle$1 = deg(180);
        var stops = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            if (i === 0) {
                var firstToken = arg[0];
                if (firstToken.type === 20 /* IDENT_TOKEN */ &&
                    ['top', 'left', 'right', 'bottom'].indexOf(firstToken.value) !== -1) {
                    angle$1 = parseNamedSide(arg);
                    return;
                }
                else if (isAngle(firstToken)) {
                    angle$1 = (angle.parse(context, firstToken) + deg(270)) % deg(360);
                    return;
                }
            }
            var colorStop = parseColorStop(context, arg);
            stops.push(colorStop);
        });
        return {
            angle: angle$1,
            stops: stops,
            type: 1 /* LINEAR_GRADIENT */
        };
    };

    var webkitGradient = function (context, tokens) {
        var angle = deg(180);
        var stops = [];
        var type = 1 /* LINEAR_GRADIENT */;
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var firstToken = arg[0];
            if (i === 0) {
                if (isIdentToken(firstToken) && firstToken.value === 'linear') {
                    type = 1 /* LINEAR_GRADIENT */;
                    return;
                }
                else if (isIdentToken(firstToken) && firstToken.value === 'radial') {
                    type = 2 /* RADIAL_GRADIENT */;
                    return;
                }
            }
            if (firstToken.type === 18 /* FUNCTION */) {
                if (firstToken.name === 'from') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: ZERO_LENGTH, color: color });
                }
                else if (firstToken.name === 'to') {
                    var color = color$1.parse(context, firstToken.values[0]);
                    stops.push({ stop: HUNDRED_PERCENT, color: color });
                }
                else if (firstToken.name === 'color-stop') {
                    var values = firstToken.values.filter(nonFunctionArgSeparator);
                    if (values.length === 2) {
                        var color = color$1.parse(context, values[1]);
                        var stop_1 = values[0];
                        if (isNumberToken(stop_1)) {
                            stops.push({
                                stop: { type: 16 /* PERCENTAGE_TOKEN */, number: stop_1.number * 100, flags: stop_1.flags },
                                color: color
                            });
                        }
                    }
                }
            }
        });
        return type === 1 /* LINEAR_GRADIENT */
            ? {
                angle: (angle + deg(180)) % deg(360),
                stops: stops,
                type: type
            }
            : { size: size, shape: shape, stops: stops, position: position, type: type };
    };

    var CLOSEST_SIDE = 'closest-side';
    var FARTHEST_SIDE = 'farthest-side';
    var CLOSEST_CORNER = 'closest-corner';
    var FARTHEST_CORNER = 'farthest-corner';
    var CIRCLE = 'circle';
    var ELLIPSE = 'ellipse';
    var COVER = 'cover';
    var CONTAIN = 'contain';
    var radialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                var isAtPosition_1 = false;
                isColorStop = arg.reduce(function (acc, token) {
                    if (isAtPosition_1) {
                        if (isIdentToken(token)) {
                            switch (token.value) {
                                case 'center':
                                    position.push(FIFTY_PERCENT);
                                    return acc;
                                case 'top':
                                case 'left':
                                    position.push(ZERO_LENGTH);
                                    return acc;
                                case 'right':
                                case 'bottom':
                                    position.push(HUNDRED_PERCENT);
                                    return acc;
                            }
                        }
                        else if (isLengthPercentage(token) || isLength(token)) {
                            position.push(token);
                        }
                    }
                    else if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case 'at':
                                isAtPosition_1 = true;
                                return false;
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case COVER:
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var prefixRadialGradient = function (context, tokens) {
        var shape = 0 /* CIRCLE */;
        var size = 3 /* FARTHEST_CORNER */;
        var stops = [];
        var position = [];
        parseFunctionArgs(tokens).forEach(function (arg, i) {
            var isColorStop = true;
            if (i === 0) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case 'center':
                                position.push(FIFTY_PERCENT);
                                return false;
                            case 'top':
                            case 'left':
                                position.push(ZERO_LENGTH);
                                return false;
                            case 'right':
                            case 'bottom':
                                position.push(HUNDRED_PERCENT);
                                return false;
                        }
                    }
                    else if (isLengthPercentage(token) || isLength(token)) {
                        position.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            else if (i === 1) {
                isColorStop = arg.reduce(function (acc, token) {
                    if (isIdentToken(token)) {
                        switch (token.value) {
                            case CIRCLE:
                                shape = 0 /* CIRCLE */;
                                return false;
                            case ELLIPSE:
                                shape = 1 /* ELLIPSE */;
                                return false;
                            case CONTAIN:
                            case CLOSEST_SIDE:
                                size = 0 /* CLOSEST_SIDE */;
                                return false;
                            case FARTHEST_SIDE:
                                size = 1 /* FARTHEST_SIDE */;
                                return false;
                            case CLOSEST_CORNER:
                                size = 2 /* CLOSEST_CORNER */;
                                return false;
                            case COVER:
                            case FARTHEST_CORNER:
                                size = 3 /* FARTHEST_CORNER */;
                                return false;
                        }
                    }
                    else if (isLength(token) || isLengthPercentage(token)) {
                        if (!Array.isArray(size)) {
                            size = [];
                        }
                        size.push(token);
                        return false;
                    }
                    return acc;
                }, isColorStop);
            }
            if (isColorStop) {
                var colorStop = parseColorStop(context, arg);
                stops.push(colorStop);
            }
        });
        return { size: size, shape: shape, stops: stops, position: position, type: 2 /* RADIAL_GRADIENT */ };
    };

    var isLinearGradient = function (background) {
        return background.type === 1 /* LINEAR_GRADIENT */;
    };
    var isRadialGradient = function (background) {
        return background.type === 2 /* RADIAL_GRADIENT */;
    };
    var image = {
        name: 'image',
        parse: function (context, value) {
            if (value.type === 22 /* URL_TOKEN */) {
                var image_1 = { url: value.value, type: 0 /* URL */ };
                context.cache.addImage(value.value);
                return image_1;
            }
            if (value.type === 18 /* FUNCTION */) {
                var imageFunction = SUPPORTED_IMAGE_FUNCTIONS[value.name];
                if (typeof imageFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported image function \"" + value.name + "\"");
                }
                return imageFunction(context, value.values);
            }
            throw new Error("Unsupported image type " + value.type);
        }
    };
    function isSupportedImage(value) {
        return (!(value.type === 20 /* IDENT_TOKEN */ && value.value === 'none') &&
            (value.type !== 18 /* FUNCTION */ || !!SUPPORTED_IMAGE_FUNCTIONS[value.name]));
    }
    var SUPPORTED_IMAGE_FUNCTIONS = {
        'linear-gradient': linearGradient,
        '-moz-linear-gradient': prefixLinearGradient,
        '-ms-linear-gradient': prefixLinearGradient,
        '-o-linear-gradient': prefixLinearGradient,
        '-webkit-linear-gradient': prefixLinearGradient,
        'radial-gradient': radialGradient,
        '-moz-radial-gradient': prefixRadialGradient,
        '-ms-radial-gradient': prefixRadialGradient,
        '-o-radial-gradient': prefixRadialGradient,
        '-webkit-radial-gradient': prefixRadialGradient,
        '-webkit-gradient': webkitGradient
    };

    var backgroundImage = {
        name: 'background-image',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens
                .filter(function (value) { return nonFunctionArgSeparator(value) && isSupportedImage(value); })
                .map(function (value) { return image.parse(context, value); });
        }
    };

    var backgroundOrigin = {
        name: 'background-origin',
        initialValue: 'border-box',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.map(function (token) {
                if (isIdentToken(token)) {
                    switch (token.value) {
                        case 'padding-box':
                            return 1 /* PADDING_BOX */;
                        case 'content-box':
                            return 2 /* CONTENT_BOX */;
                    }
                }
                return 0 /* BORDER_BOX */;
            });
        }
    };

    var backgroundPosition = {
        name: 'background-position',
        initialValue: '0% 0%',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) { return values.filter(isLengthPercentage); })
                .map(parseLengthPercentageTuple);
        }
    };

    var backgroundRepeat = {
        name: 'background-repeat',
        initialValue: 'repeat',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens)
                .map(function (values) {
                return values
                    .filter(isIdentToken)
                    .map(function (token) { return token.value; })
                    .join(' ');
            })
                .map(parseBackgroundRepeat);
        }
    };
    var parseBackgroundRepeat = function (value) {
        switch (value) {
            case 'no-repeat':
                return 1 /* NO_REPEAT */;
            case 'repeat-x':
            case 'repeat no-repeat':
                return 2 /* REPEAT_X */;
            case 'repeat-y':
            case 'no-repeat repeat':
                return 3 /* REPEAT_Y */;
            case 'repeat':
            default:
                return 0 /* REPEAT */;
        }
    };

    var BACKGROUND_SIZE;
    (function (BACKGROUND_SIZE) {
        BACKGROUND_SIZE["AUTO"] = "auto";
        BACKGROUND_SIZE["CONTAIN"] = "contain";
        BACKGROUND_SIZE["COVER"] = "cover";
    })(BACKGROUND_SIZE || (BACKGROUND_SIZE = {}));
    var backgroundSize = {
        name: 'background-size',
        initialValue: '0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseFunctionArgs(tokens).map(function (values) { return values.filter(isBackgroundSizeInfoToken); });
        }
    };
    var isBackgroundSizeInfoToken = function (value) {
        return isIdentToken(value) || isLengthPercentage(value);
    };

    var borderColorForSide = function (side) { return ({
        name: "border-" + side + "-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    }); };
    var borderTopColor = borderColorForSide('top');
    var borderRightColor = borderColorForSide('right');
    var borderBottomColor = borderColorForSide('bottom');
    var borderLeftColor = borderColorForSide('left');

    var borderRadiusForSide = function (side) { return ({
        name: "border-radius-" + side,
        initialValue: '0 0',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return parseLengthPercentageTuple(tokens.filter(isLengthPercentage));
        }
    }); };
    var borderTopLeftRadius = borderRadiusForSide('top-left');
    var borderTopRightRadius = borderRadiusForSide('top-right');
    var borderBottomRightRadius = borderRadiusForSide('bottom-right');
    var borderBottomLeftRadius = borderRadiusForSide('bottom-left');

    var borderStyleForSide = function (side) { return ({
        name: "border-" + side + "-style",
        initialValue: 'solid',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, style) {
            switch (style) {
                case 'none':
                    return 0 /* NONE */;
                case 'dashed':
                    return 2 /* DASHED */;
                case 'dotted':
                    return 3 /* DOTTED */;
                case 'double':
                    return 4 /* DOUBLE */;
            }
            return 1 /* SOLID */;
        }
    }); };
    var borderTopStyle = borderStyleForSide('top');
    var borderRightStyle = borderStyleForSide('right');
    var borderBottomStyle = borderStyleForSide('bottom');
    var borderLeftStyle = borderStyleForSide('left');

    var borderWidthForSide = function (side) { return ({
        name: "border-" + side + "-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    }); };
    var borderTopWidth = borderWidthForSide('top');
    var borderRightWidth = borderWidthForSide('right');
    var borderBottomWidth = borderWidthForSide('bottom');
    var borderLeftWidth = borderWidthForSide('left');

    var color = {
        name: "color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var direction = {
        name: 'direction',
        initialValue: 'ltr',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, direction) {
            switch (direction) {
                case 'rtl':
                    return 1 /* RTL */;
                case 'ltr':
                default:
                    return 0 /* LTR */;
            }
        }
    };

    var display = {
        name: 'display',
        initialValue: 'inline-block',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).reduce(function (bit, token) {
                return bit | parseDisplayValue(token.value);
            }, 0 /* NONE */);
        }
    };
    var parseDisplayValue = function (display) {
        switch (display) {
            case 'block':
            case '-webkit-box':
                return 2 /* BLOCK */;
            case 'inline':
                return 4 /* INLINE */;
            case 'run-in':
                return 8 /* RUN_IN */;
            case 'flow':
                return 16 /* FLOW */;
            case 'flow-root':
                return 32 /* FLOW_ROOT */;
            case 'table':
                return 64 /* TABLE */;
            case 'flex':
            case '-webkit-flex':
                return 128 /* FLEX */;
            case 'grid':
            case '-ms-grid':
                return 256 /* GRID */;
            case 'ruby':
                return 512 /* RUBY */;
            case 'subgrid':
                return 1024 /* SUBGRID */;
            case 'list-item':
                return 2048 /* LIST_ITEM */;
            case 'table-row-group':
                return 4096 /* TABLE_ROW_GROUP */;
            case 'table-header-group':
                return 8192 /* TABLE_HEADER_GROUP */;
            case 'table-footer-group':
                return 16384 /* TABLE_FOOTER_GROUP */;
            case 'table-row':
                return 32768 /* TABLE_ROW */;
            case 'table-cell':
                return 65536 /* TABLE_CELL */;
            case 'table-column-group':
                return 131072 /* TABLE_COLUMN_GROUP */;
            case 'table-column':
                return 262144 /* TABLE_COLUMN */;
            case 'table-caption':
                return 524288 /* TABLE_CAPTION */;
            case 'ruby-base':
                return 1048576 /* RUBY_BASE */;
            case 'ruby-text':
                return 2097152 /* RUBY_TEXT */;
            case 'ruby-base-container':
                return 4194304 /* RUBY_BASE_CONTAINER */;
            case 'ruby-text-container':
                return 8388608 /* RUBY_TEXT_CONTAINER */;
            case 'contents':
                return 16777216 /* CONTENTS */;
            case 'inline-block':
                return 33554432 /* INLINE_BLOCK */;
            case 'inline-list-item':
                return 67108864 /* INLINE_LIST_ITEM */;
            case 'inline-table':
                return 134217728 /* INLINE_TABLE */;
            case 'inline-flex':
                return 268435456 /* INLINE_FLEX */;
            case 'inline-grid':
                return 536870912 /* INLINE_GRID */;
        }
        return 0 /* NONE */;
    };

    var float = {
        name: 'float',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, float) {
            switch (float) {
                case 'left':
                    return 1 /* LEFT */;
                case 'right':
                    return 2 /* RIGHT */;
                case 'inline-start':
                    return 3 /* INLINE_START */;
                case 'inline-end':
                    return 4 /* INLINE_END */;
            }
            return 0 /* NONE */;
        }
    };

    var letterSpacing = {
        name: 'letter-spacing',
        initialValue: '0',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'normal') {
                return 0;
            }
            if (token.type === 17 /* NUMBER_TOKEN */) {
                return token.number;
            }
            if (token.type === 15 /* DIMENSION_TOKEN */) {
                return token.number;
            }
            return 0;
        }
    };

    var LINE_BREAK;
    (function (LINE_BREAK) {
        LINE_BREAK["NORMAL"] = "normal";
        LINE_BREAK["STRICT"] = "strict";
    })(LINE_BREAK || (LINE_BREAK = {}));
    var lineBreak = {
        name: 'line-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, lineBreak) {
            switch (lineBreak) {
                case 'strict':
                    return LINE_BREAK.STRICT;
                case 'normal':
                default:
                    return LINE_BREAK.NORMAL;
            }
        }
    };

    var lineHeight = {
        name: 'line-height',
        initialValue: 'normal',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    };
    var computeLineHeight = function (token, fontSize) {
        if (isIdentToken(token) && token.value === 'normal') {
            return 1.2 * fontSize;
        }
        else if (token.type === 17 /* NUMBER_TOKEN */) {
            return fontSize * token.number;
        }
        else if (isLengthPercentage(token)) {
            return getAbsoluteValue(token, fontSize);
        }
        return fontSize;
    };

    var listStyleImage = {
        name: 'list-style-image',
        initialValue: 'none',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            return image.parse(context, token);
        }
    };

    var listStylePosition = {
        name: 'list-style-position',
        initialValue: 'outside',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'inside':
                    return 0 /* INSIDE */;
                case 'outside':
                default:
                    return 1 /* OUTSIDE */;
            }
        }
    };

    var listStyleType = {
        name: 'list-style-type',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, type) {
            switch (type) {
                case 'disc':
                    return 0 /* DISC */;
                case 'circle':
                    return 1 /* CIRCLE */;
                case 'square':
                    return 2 /* SQUARE */;
                case 'decimal':
                    return 3 /* DECIMAL */;
                case 'cjk-decimal':
                    return 4 /* CJK_DECIMAL */;
                case 'decimal-leading-zero':
                    return 5 /* DECIMAL_LEADING_ZERO */;
                case 'lower-roman':
                    return 6 /* LOWER_ROMAN */;
                case 'upper-roman':
                    return 7 /* UPPER_ROMAN */;
                case 'lower-greek':
                    return 8 /* LOWER_GREEK */;
                case 'lower-alpha':
                    return 9 /* LOWER_ALPHA */;
                case 'upper-alpha':
                    return 10 /* UPPER_ALPHA */;
                case 'arabic-indic':
                    return 11 /* ARABIC_INDIC */;
                case 'armenian':
                    return 12 /* ARMENIAN */;
                case 'bengali':
                    return 13 /* BENGALI */;
                case 'cambodian':
                    return 14 /* CAMBODIAN */;
                case 'cjk-earthly-branch':
                    return 15 /* CJK_EARTHLY_BRANCH */;
                case 'cjk-heavenly-stem':
                    return 16 /* CJK_HEAVENLY_STEM */;
                case 'cjk-ideographic':
                    return 17 /* CJK_IDEOGRAPHIC */;
                case 'devanagari':
                    return 18 /* DEVANAGARI */;
                case 'ethiopic-numeric':
                    return 19 /* ETHIOPIC_NUMERIC */;
                case 'georgian':
                    return 20 /* GEORGIAN */;
                case 'gujarati':
                    return 21 /* GUJARATI */;
                case 'gurmukhi':
                    return 22 /* GURMUKHI */;
                case 'hebrew':
                    return 22 /* HEBREW */;
                case 'hiragana':
                    return 23 /* HIRAGANA */;
                case 'hiragana-iroha':
                    return 24 /* HIRAGANA_IROHA */;
                case 'japanese-formal':
                    return 25 /* JAPANESE_FORMAL */;
                case 'japanese-informal':
                    return 26 /* JAPANESE_INFORMAL */;
                case 'kannada':
                    return 27 /* KANNADA */;
                case 'katakana':
                    return 28 /* KATAKANA */;
                case 'katakana-iroha':
                    return 29 /* KATAKANA_IROHA */;
                case 'khmer':
                    return 30 /* KHMER */;
                case 'korean-hangul-formal':
                    return 31 /* KOREAN_HANGUL_FORMAL */;
                case 'korean-hanja-formal':
                    return 32 /* KOREAN_HANJA_FORMAL */;
                case 'korean-hanja-informal':
                    return 33 /* KOREAN_HANJA_INFORMAL */;
                case 'lao':
                    return 34 /* LAO */;
                case 'lower-armenian':
                    return 35 /* LOWER_ARMENIAN */;
                case 'malayalam':
                    return 36 /* MALAYALAM */;
                case 'mongolian':
                    return 37 /* MONGOLIAN */;
                case 'myanmar':
                    return 38 /* MYANMAR */;
                case 'oriya':
                    return 39 /* ORIYA */;
                case 'persian':
                    return 40 /* PERSIAN */;
                case 'simp-chinese-formal':
                    return 41 /* SIMP_CHINESE_FORMAL */;
                case 'simp-chinese-informal':
                    return 42 /* SIMP_CHINESE_INFORMAL */;
                case 'tamil':
                    return 43 /* TAMIL */;
                case 'telugu':
                    return 44 /* TELUGU */;
                case 'thai':
                    return 45 /* THAI */;
                case 'tibetan':
                    return 46 /* TIBETAN */;
                case 'trad-chinese-formal':
                    return 47 /* TRAD_CHINESE_FORMAL */;
                case 'trad-chinese-informal':
                    return 48 /* TRAD_CHINESE_INFORMAL */;
                case 'upper-armenian':
                    return 49 /* UPPER_ARMENIAN */;
                case 'disclosure-open':
                    return 50 /* DISCLOSURE_OPEN */;
                case 'disclosure-closed':
                    return 51 /* DISCLOSURE_CLOSED */;
                case 'none':
                default:
                    return -1 /* NONE */;
            }
        }
    };

    var marginForSide = function (side) { return ({
        name: "margin-" + side,
        initialValue: '0',
        prefix: false,
        type: 4 /* TOKEN_VALUE */
    }); };
    var marginTop = marginForSide('top');
    var marginRight = marginForSide('right');
    var marginBottom = marginForSide('bottom');
    var marginLeft = marginForSide('left');

    var overflow = {
        name: 'overflow',
        initialValue: 'visible',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (overflow) {
                switch (overflow.value) {
                    case 'hidden':
                        return 1 /* HIDDEN */;
                    case 'scroll':
                        return 2 /* SCROLL */;
                    case 'clip':
                        return 3 /* CLIP */;
                    case 'auto':
                        return 4 /* AUTO */;
                    case 'visible':
                    default:
                        return 0 /* VISIBLE */;
                }
            });
        }
    };

    var overflowWrap = {
        name: 'overflow-wrap',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'break-word':
                    return "break-word" /* BREAK_WORD */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var paddingForSide = function (side) { return ({
        name: "padding-" + side,
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length-percentage'
    }); };
    var paddingTop = paddingForSide('top');
    var paddingRight = paddingForSide('right');
    var paddingBottom = paddingForSide('bottom');
    var paddingLeft = paddingForSide('left');

    var textAlign = {
        name: 'text-align',
        initialValue: 'left',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textAlign) {
            switch (textAlign) {
                case 'right':
                    return 2 /* RIGHT */;
                case 'center':
                case 'justify':
                    return 1 /* CENTER */;
                case 'left':
                default:
                    return 0 /* LEFT */;
            }
        }
    };

    var position = {
        name: 'position',
        initialValue: 'static',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, position) {
            switch (position) {
                case 'relative':
                    return 1 /* RELATIVE */;
                case 'absolute':
                    return 2 /* ABSOLUTE */;
                case 'fixed':
                    return 3 /* FIXED */;
                case 'sticky':
                    return 4 /* STICKY */;
            }
            return 0 /* STATIC */;
        }
    };

    var textShadow = {
        name: 'text-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: COLORS.TRANSPARENT,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else {
                            shadow.blur = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var textTransform = {
        name: 'text-transform',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, textTransform) {
            switch (textTransform) {
                case 'uppercase':
                    return 2 /* UPPERCASE */;
                case 'lowercase':
                    return 1 /* LOWERCASE */;
                case 'capitalize':
                    return 3 /* CAPITALIZE */;
            }
            return 0 /* NONE */;
        }
    };

    var transform$1 = {
        name: 'transform',
        initialValue: 'none',
        prefix: true,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */ && token.value === 'none') {
                return null;
            }
            if (token.type === 18 /* FUNCTION */) {
                var transformFunction = SUPPORTED_TRANSFORM_FUNCTIONS[token.name];
                if (typeof transformFunction === 'undefined') {
                    throw new Error("Attempting to parse an unsupported transform function \"" + token.name + "\"");
                }
                return transformFunction(token.values);
            }
            return null;
        }
    };
    var matrix = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        return values.length === 6 ? values : null;
    };
    // doesn't support 3D transforms at the moment
    var matrix3d = function (args) {
        var values = args.filter(function (arg) { return arg.type === 17 /* NUMBER_TOKEN */; }).map(function (arg) { return arg.number; });
        var a1 = values[0], b1 = values[1]; values[2]; values[3]; var a2 = values[4], b2 = values[5]; values[6]; values[7]; values[8]; values[9]; values[10]; values[11]; var a4 = values[12], b4 = values[13]; values[14]; values[15];
        return values.length === 16 ? [a1, b1, a2, b2, a4, b4] : null;
    };
    var SUPPORTED_TRANSFORM_FUNCTIONS = {
        matrix: matrix,
        matrix3d: matrix3d
    };

    var DEFAULT_VALUE = {
        type: 16 /* PERCENTAGE_TOKEN */,
        number: 50,
        flags: FLAG_INTEGER
    };
    var DEFAULT = [DEFAULT_VALUE, DEFAULT_VALUE];
    var transformOrigin = {
        name: 'transform-origin',
        initialValue: '50% 50%',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var origins = tokens.filter(isLengthPercentage);
            if (origins.length !== 2) {
                return DEFAULT;
            }
            return [origins[0], origins[1]];
        }
    };

    var visibility = {
        name: 'visible',
        initialValue: 'none',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, visibility) {
            switch (visibility) {
                case 'hidden':
                    return 1 /* HIDDEN */;
                case 'collapse':
                    return 2 /* COLLAPSE */;
                case 'visible':
                default:
                    return 0 /* VISIBLE */;
            }
        }
    };

    var WORD_BREAK;
    (function (WORD_BREAK) {
        WORD_BREAK["NORMAL"] = "normal";
        WORD_BREAK["BREAK_ALL"] = "break-all";
        WORD_BREAK["KEEP_ALL"] = "keep-all";
    })(WORD_BREAK || (WORD_BREAK = {}));
    var wordBreak = {
        name: 'word-break',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, wordBreak) {
            switch (wordBreak) {
                case 'break-all':
                    return WORD_BREAK.BREAK_ALL;
                case 'keep-all':
                    return WORD_BREAK.KEEP_ALL;
                case 'normal':
                default:
                    return WORD_BREAK.NORMAL;
            }
        }
    };

    var zIndex = {
        name: 'z-index',
        initialValue: 'auto',
        prefix: false,
        type: 0 /* VALUE */,
        parse: function (_context, token) {
            if (token.type === 20 /* IDENT_TOKEN */) {
                return { auto: true, order: 0 };
            }
            if (isNumberToken(token)) {
                return { auto: false, order: token.number };
            }
            throw new Error("Invalid z-index number parsed");
        }
    };

    var time = {
        name: 'time',
        parse: function (_context, value) {
            if (value.type === 15 /* DIMENSION_TOKEN */) {
                switch (value.unit.toLowerCase()) {
                    case 's':
                        return 1000 * value.number;
                    case 'ms':
                        return value.number;
                }
            }
            throw new Error("Unsupported time type");
        }
    };

    var opacity = {
        name: 'opacity',
        initialValue: '1',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            return 1;
        }
    };

    var textDecorationColor = {
        name: "text-decoration-color",
        initialValue: 'transparent',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var textDecorationLine = {
        name: 'text-decoration-line',
        initialValue: 'none',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            return tokens
                .filter(isIdentToken)
                .map(function (token) {
                switch (token.value) {
                    case 'underline':
                        return 1 /* UNDERLINE */;
                    case 'overline':
                        return 2 /* OVERLINE */;
                    case 'line-through':
                        return 3 /* LINE_THROUGH */;
                    case 'none':
                        return 4 /* BLINK */;
                }
                return 0 /* NONE */;
            })
                .filter(function (line) { return line !== 0 /* NONE */; });
        }
    };

    var fontFamily = {
        name: "font-family",
        initialValue: '',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var accumulator = [];
            var results = [];
            tokens.forEach(function (token) {
                switch (token.type) {
                    case 20 /* IDENT_TOKEN */:
                    case 0 /* STRING_TOKEN */:
                        accumulator.push(token.value);
                        break;
                    case 17 /* NUMBER_TOKEN */:
                        accumulator.push(token.number.toString());
                        break;
                    case 4 /* COMMA_TOKEN */:
                        results.push(accumulator.join(' '));
                        accumulator.length = 0;
                        break;
                }
            });
            if (accumulator.length) {
                results.push(accumulator.join(' '));
            }
            return results.map(function (result) { return (result.indexOf(' ') === -1 ? result : "'" + result + "'"); });
        }
    };

    var fontSize = {
        name: "font-size",
        initialValue: '0',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'length'
    };

    var fontWeight = {
        name: 'font-weight',
        initialValue: 'normal',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isNumberToken(token)) {
                return token.number;
            }
            if (isIdentToken(token)) {
                switch (token.value) {
                    case 'bold':
                        return 700;
                    case 'normal':
                    default:
                        return 400;
                }
            }
            return 400;
        }
    };

    var fontVariant = {
        name: 'font-variant',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            return tokens.filter(isIdentToken).map(function (token) { return token.value; });
        }
    };

    var fontStyle = {
        name: 'font-style',
        initialValue: 'normal',
        prefix: false,
        type: 2 /* IDENT_VALUE */,
        parse: function (_context, overflow) {
            switch (overflow) {
                case 'oblique':
                    return "oblique" /* OBLIQUE */;
                case 'italic':
                    return "italic" /* ITALIC */;
                case 'normal':
                default:
                    return "normal" /* NORMAL */;
            }
        }
    };

    var contains = function (bit, value) { return (bit & value) !== 0; };

    var content = {
        name: 'content',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return [];
            }
            return tokens;
        }
    };

    var counterIncrement = {
        name: 'counter-increment',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var increments = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (counter.type === 20 /* IDENT_TOKEN */) {
                    var increment = next && isNumberToken(next) ? next.number : 1;
                    increments.push({ counter: counter.value, increment: increment });
                }
            }
            return increments;
        }
    };

    var counterReset = {
        name: 'counter-reset',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return [];
            }
            var resets = [];
            var filtered = tokens.filter(nonWhiteSpace);
            for (var i = 0; i < filtered.length; i++) {
                var counter = filtered[i];
                var next = filtered[i + 1];
                if (isIdentToken(counter) && counter.value !== 'none') {
                    var reset = next && isNumberToken(next) ? next.number : 0;
                    resets.push({ counter: counter.value, reset: reset });
                }
            }
            return resets;
        }
    };

    var duration = {
        name: 'duration',
        initialValue: '0s',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (context, tokens) {
            return tokens.filter(isDimensionToken).map(function (token) { return time.parse(context, token); });
        }
    };

    var quotes = {
        name: 'quotes',
        initialValue: 'none',
        prefix: true,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            if (tokens.length === 0) {
                return null;
            }
            var first = tokens[0];
            if (first.type === 20 /* IDENT_TOKEN */ && first.value === 'none') {
                return null;
            }
            var quotes = [];
            var filtered = tokens.filter(isStringToken);
            if (filtered.length % 2 !== 0) {
                return null;
            }
            for (var i = 0; i < filtered.length; i += 2) {
                var open_1 = filtered[i].value;
                var close_1 = filtered[i + 1].value;
                quotes.push({ open: open_1, close: close_1 });
            }
            return quotes;
        }
    };
    var getQuote = function (quotes, depth, open) {
        if (!quotes) {
            return '';
        }
        var quote = quotes[Math.min(depth, quotes.length - 1)];
        if (!quote) {
            return '';
        }
        return open ? quote.open : quote.close;
    };

    var boxShadow = {
        name: 'box-shadow',
        initialValue: 'none',
        type: 1 /* LIST */,
        prefix: false,
        parse: function (context, tokens) {
            if (tokens.length === 1 && isIdentWithValue(tokens[0], 'none')) {
                return [];
            }
            return parseFunctionArgs(tokens).map(function (values) {
                var shadow = {
                    color: 0x000000ff,
                    offsetX: ZERO_LENGTH,
                    offsetY: ZERO_LENGTH,
                    blur: ZERO_LENGTH,
                    spread: ZERO_LENGTH,
                    inset: false
                };
                var c = 0;
                for (var i = 0; i < values.length; i++) {
                    var token = values[i];
                    if (isIdentWithValue(token, 'inset')) {
                        shadow.inset = true;
                    }
                    else if (isLength(token)) {
                        if (c === 0) {
                            shadow.offsetX = token;
                        }
                        else if (c === 1) {
                            shadow.offsetY = token;
                        }
                        else if (c === 2) {
                            shadow.blur = token;
                        }
                        else {
                            shadow.spread = token;
                        }
                        c++;
                    }
                    else {
                        shadow.color = color$1.parse(context, token);
                    }
                }
                return shadow;
            });
        }
    };

    var paintOrder = {
        name: 'paint-order',
        initialValue: 'normal',
        prefix: false,
        type: 1 /* LIST */,
        parse: function (_context, tokens) {
            var DEFAULT_VALUE = [0 /* FILL */, 1 /* STROKE */, 2 /* MARKERS */];
            var layers = [];
            tokens.filter(isIdentToken).forEach(function (token) {
                switch (token.value) {
                    case 'stroke':
                        layers.push(1 /* STROKE */);
                        break;
                    case 'fill':
                        layers.push(0 /* FILL */);
                        break;
                    case 'markers':
                        layers.push(2 /* MARKERS */);
                        break;
                }
            });
            DEFAULT_VALUE.forEach(function (value) {
                if (layers.indexOf(value) === -1) {
                    layers.push(value);
                }
            });
            return layers;
        }
    };

    var webkitTextStrokeColor = {
        name: "-webkit-text-stroke-color",
        initialValue: 'currentcolor',
        prefix: false,
        type: 3 /* TYPE_VALUE */,
        format: 'color'
    };

    var webkitTextStrokeWidth = {
        name: "-webkit-text-stroke-width",
        initialValue: '0',
        type: 0 /* VALUE */,
        prefix: false,
        parse: function (_context, token) {
            if (isDimensionToken(token)) {
                return token.number;
            }
            return 0;
        }
    };

    var CSSParsedDeclaration = /** @class */ (function () {
        function CSSParsedDeclaration(context, declaration) {
            var _a, _b;
            this.animationDuration = parse(context, duration, declaration.animationDuration);
            this.backgroundClip = parse(context, backgroundClip, declaration.backgroundClip);
            this.backgroundColor = parse(context, backgroundColor, declaration.backgroundColor);
            this.backgroundImage = parse(context, backgroundImage, declaration.backgroundImage);
            this.backgroundOrigin = parse(context, backgroundOrigin, declaration.backgroundOrigin);
            this.backgroundPosition = parse(context, backgroundPosition, declaration.backgroundPosition);
            this.backgroundRepeat = parse(context, backgroundRepeat, declaration.backgroundRepeat);
            this.backgroundSize = parse(context, backgroundSize, declaration.backgroundSize);
            this.borderTopColor = parse(context, borderTopColor, declaration.borderTopColor);
            this.borderRightColor = parse(context, borderRightColor, declaration.borderRightColor);
            this.borderBottomColor = parse(context, borderBottomColor, declaration.borderBottomColor);
            this.borderLeftColor = parse(context, borderLeftColor, declaration.borderLeftColor);
            this.borderTopLeftRadius = parse(context, borderTopLeftRadius, declaration.borderTopLeftRadius);
            this.borderTopRightRadius = parse(context, borderTopRightRadius, declaration.borderTopRightRadius);
            this.borderBottomRightRadius = parse(context, borderBottomRightRadius, declaration.borderBottomRightRadius);
            this.borderBottomLeftRadius = parse(context, borderBottomLeftRadius, declaration.borderBottomLeftRadius);
            this.borderTopStyle = parse(context, borderTopStyle, declaration.borderTopStyle);
            this.borderRightStyle = parse(context, borderRightStyle, declaration.borderRightStyle);
            this.borderBottomStyle = parse(context, borderBottomStyle, declaration.borderBottomStyle);
            this.borderLeftStyle = parse(context, borderLeftStyle, declaration.borderLeftStyle);
            this.borderTopWidth = parse(context, borderTopWidth, declaration.borderTopWidth);
            this.borderRightWidth = parse(context, borderRightWidth, declaration.borderRightWidth);
            this.borderBottomWidth = parse(context, borderBottomWidth, declaration.borderBottomWidth);
            this.borderLeftWidth = parse(context, borderLeftWidth, declaration.borderLeftWidth);
            this.boxShadow = parse(context, boxShadow, declaration.boxShadow);
            this.color = parse(context, color, declaration.color);
            this.direction = parse(context, direction, declaration.direction);
            this.display = parse(context, display, declaration.display);
            this.float = parse(context, float, declaration.cssFloat);
            this.fontFamily = parse(context, fontFamily, declaration.fontFamily);
            this.fontSize = parse(context, fontSize, declaration.fontSize);
            this.fontStyle = parse(context, fontStyle, declaration.fontStyle);
            this.fontVariant = parse(context, fontVariant, declaration.fontVariant);
            this.fontWeight = parse(context, fontWeight, declaration.fontWeight);
            this.letterSpacing = parse(context, letterSpacing, declaration.letterSpacing);
            this.lineBreak = parse(context, lineBreak, declaration.lineBreak);
            this.lineHeight = parse(context, lineHeight, declaration.lineHeight);
            this.listStyleImage = parse(context, listStyleImage, declaration.listStyleImage);
            this.listStylePosition = parse(context, listStylePosition, declaration.listStylePosition);
            this.listStyleType = parse(context, listStyleType, declaration.listStyleType);
            this.marginTop = parse(context, marginTop, declaration.marginTop);
            this.marginRight = parse(context, marginRight, declaration.marginRight);
            this.marginBottom = parse(context, marginBottom, declaration.marginBottom);
            this.marginLeft = parse(context, marginLeft, declaration.marginLeft);
            this.opacity = parse(context, opacity, declaration.opacity);
            var overflowTuple = parse(context, overflow, declaration.overflow);
            this.overflowX = overflowTuple[0];
            this.overflowY = overflowTuple[overflowTuple.length > 1 ? 1 : 0];
            this.overflowWrap = parse(context, overflowWrap, declaration.overflowWrap);
            this.paddingTop = parse(context, paddingTop, declaration.paddingTop);
            this.paddingRight = parse(context, paddingRight, declaration.paddingRight);
            this.paddingBottom = parse(context, paddingBottom, declaration.paddingBottom);
            this.paddingLeft = parse(context, paddingLeft, declaration.paddingLeft);
            this.paintOrder = parse(context, paintOrder, declaration.paintOrder);
            this.position = parse(context, position, declaration.position);
            this.textAlign = parse(context, textAlign, declaration.textAlign);
            this.textDecorationColor = parse(context, textDecorationColor, (_a = declaration.textDecorationColor) !== null && _a !== void 0 ? _a : declaration.color);
            this.textDecorationLine = parse(context, textDecorationLine, (_b = declaration.textDecorationLine) !== null && _b !== void 0 ? _b : declaration.textDecoration);
            this.textShadow = parse(context, textShadow, declaration.textShadow);
            this.textTransform = parse(context, textTransform, declaration.textTransform);
            this.transform = parse(context, transform$1, declaration.transform);
            this.transformOrigin = parse(context, transformOrigin, declaration.transformOrigin);
            this.visibility = parse(context, visibility, declaration.visibility);
            this.webkitTextStrokeColor = parse(context, webkitTextStrokeColor, declaration.webkitTextStrokeColor);
            this.webkitTextStrokeWidth = parse(context, webkitTextStrokeWidth, declaration.webkitTextStrokeWidth);
            this.wordBreak = parse(context, wordBreak, declaration.wordBreak);
            this.zIndex = parse(context, zIndex, declaration.zIndex);
        }
        CSSParsedDeclaration.prototype.isVisible = function () {
            return this.display > 0 && this.opacity > 0 && this.visibility === 0 /* VISIBLE */;
        };
        CSSParsedDeclaration.prototype.isTransparent = function () {
            return isTransparent(this.backgroundColor);
        };
        CSSParsedDeclaration.prototype.isTransformed = function () {
            return this.transform !== null;
        };
        CSSParsedDeclaration.prototype.isPositioned = function () {
            return this.position !== 0 /* STATIC */;
        };
        CSSParsedDeclaration.prototype.isPositionedWithZIndex = function () {
            return this.isPositioned() && !this.zIndex.auto;
        };
        CSSParsedDeclaration.prototype.isFloating = function () {
            return this.float !== 0 /* NONE */;
        };
        CSSParsedDeclaration.prototype.isInlineLevel = function () {
            return (contains(this.display, 4 /* INLINE */) ||
                contains(this.display, 33554432 /* INLINE_BLOCK */) ||
                contains(this.display, 268435456 /* INLINE_FLEX */) ||
                contains(this.display, 536870912 /* INLINE_GRID */) ||
                contains(this.display, 67108864 /* INLINE_LIST_ITEM */) ||
                contains(this.display, 134217728 /* INLINE_TABLE */));
        };
        return CSSParsedDeclaration;
    }());
    var CSSParsedPseudoDeclaration = /** @class */ (function () {
        function CSSParsedPseudoDeclaration(context, declaration) {
            this.content = parse(context, content, declaration.content);
            this.quotes = parse(context, quotes, declaration.quotes);
        }
        return CSSParsedPseudoDeclaration;
    }());
    var CSSParsedCounterDeclaration = /** @class */ (function () {
        function CSSParsedCounterDeclaration(context, declaration) {
            this.counterIncrement = parse(context, counterIncrement, declaration.counterIncrement);
            this.counterReset = parse(context, counterReset, declaration.counterReset);
        }
        return CSSParsedCounterDeclaration;
    }());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var parse = function (context, descriptor, style) {
        var tokenizer = new Tokenizer();
        var value = style !== null && typeof style !== 'undefined' ? style.toString() : descriptor.initialValue;
        tokenizer.write(value);
        var parser = new Parser(tokenizer.read());
        switch (descriptor.type) {
            case 2 /* IDENT_VALUE */:
                var token = parser.parseComponentValue();
                return descriptor.parse(context, isIdentToken(token) ? token.value : descriptor.initialValue);
            case 0 /* VALUE */:
                return descriptor.parse(context, parser.parseComponentValue());
            case 1 /* LIST */:
                return descriptor.parse(context, parser.parseComponentValues());
            case 4 /* TOKEN_VALUE */:
                return parser.parseComponentValue();
            case 3 /* TYPE_VALUE */:
                switch (descriptor.format) {
                    case 'angle':
                        return angle.parse(context, parser.parseComponentValue());
                    case 'color':
                        return color$1.parse(context, parser.parseComponentValue());
                    case 'image':
                        return image.parse(context, parser.parseComponentValue());
                    case 'length':
                        var length_1 = parser.parseComponentValue();
                        return isLength(length_1) ? length_1 : ZERO_LENGTH;
                    case 'length-percentage':
                        var value_1 = parser.parseComponentValue();
                        return isLengthPercentage(value_1) ? value_1 : ZERO_LENGTH;
                    case 'time':
                        return time.parse(context, parser.parseComponentValue());
                }
                break;
        }
    };

    var elementDebuggerAttribute = 'data-html2canvas-debug';
    var getElementDebugType = function (element) {
        var attribute = element.getAttribute(elementDebuggerAttribute);
        switch (attribute) {
            case 'all':
                return 1 /* ALL */;
            case 'clone':
                return 2 /* CLONE */;
            case 'parse':
                return 3 /* PARSE */;
            case 'render':
                return 4 /* RENDER */;
            default:
                return 0 /* NONE */;
        }
    };
    var isDebugging = function (element, type) {
        var elementType = getElementDebugType(element);
        return elementType === 1 /* ALL */ || type === elementType;
    };

    var ElementContainer = /** @class */ (function () {
        function ElementContainer(context, element) {
            this.context = context;
            this.textNodes = [];
            this.elements = [];
            this.flags = 0;
            if (isDebugging(element, 3 /* PARSE */)) {
                debugger;
            }
            this.styles = new CSSParsedDeclaration(context, window.getComputedStyle(element, null));
            if (isHTMLElementNode(element)) {
                if (this.styles.animationDuration.some(function (duration) { return duration > 0; })) {
                    element.style.animationDuration = '0s';
                }
                if (this.styles.transform !== null) {
                    // getBoundingClientRect takes transforms into account
                    element.style.transform = 'none';
                }
            }
            this.bounds = parseBounds(this.context, element);
            if (isDebugging(element, 4 /* RENDER */)) {
                this.flags |= 16 /* DEBUG_RENDER */;
            }
        }
        return ElementContainer;
    }());

    /*
     * text-segmentation 1.0.3 <https://github.com/niklasvh/text-segmentation>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var base64 = 'AAAAAAAAAAAAEA4AGBkAAFAaAAACAAAAAAAIABAAGAAwADgACAAQAAgAEAAIABAACAAQAAgAEAAIABAACAAQAAgAEAAIABAAQABIAEQATAAIABAACAAQAAgAEAAIABAAVABcAAgAEAAIABAACAAQAGAAaABwAHgAgACIAI4AlgAIABAAmwCjAKgAsAC2AL4AvQDFAMoA0gBPAVYBWgEIAAgACACMANoAYgFkAWwBdAF8AX0BhQGNAZUBlgGeAaMBlQGWAasBswF8AbsBwwF0AcsBYwHTAQgA2wG/AOMBdAF8AekB8QF0AfkB+wHiAHQBfAEIAAMC5gQIAAsCEgIIAAgAFgIeAggAIgIpAggAMQI5AkACygEIAAgASAJQAlgCYAIIAAgACAAKBQoFCgUTBRMFGQUrBSsFCAAIAAgACAAIAAgACAAIAAgACABdAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABoAmgCrwGvAQgAbgJ2AggAHgEIAAgACADnAXsCCAAIAAgAgwIIAAgACAAIAAgACACKAggAkQKZAggAPADJAAgAoQKkAqwCsgK6AsICCADJAggA0AIIAAgACAAIANYC3gIIAAgACAAIAAgACABAAOYCCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAkASoB+QIEAAgACAA8AEMCCABCBQgACABJBVAFCAAIAAgACAAIAAgACAAIAAgACABTBVoFCAAIAFoFCABfBWUFCAAIAAgACAAIAAgAbQUIAAgACAAIAAgACABzBXsFfQWFBYoFigWKBZEFigWKBYoFmAWfBaYFrgWxBbkFCAAIAAgACAAIAAgACAAIAAgACAAIAMEFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAMgFCADQBQgACAAIAAgACAAIAAgACAAIAAgACAAIAO4CCAAIAAgAiQAIAAgACABAAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAD0AggACAD8AggACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIANYFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAMDvwAIAAgAJAIIAAgACAAIAAgACAAIAAgACwMTAwgACAB9BOsEGwMjAwgAKwMyAwsFYgE3A/MEPwMIAEUDTQNRAwgAWQOsAGEDCAAIAAgACAAIAAgACABpAzQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFOgU0BTUFNgU3BTgFOQU6BTQFNQU2BTcFOAU5BToFNAU1BTYFNwU4BTkFIQUoBSwFCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABtAwgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABMAEwACAAIAAgACAAIABgACAAIAAgACAC/AAgACAAyAQgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACAAIAAwAAgACAAIAAgACAAIAAgACAAIAAAARABIAAgACAAIABQASAAIAAgAIABwAEAAjgCIABsAqAC2AL0AigDQAtwC+IJIQqVAZUBWQqVAZUBlQGVAZUBlQGrC5UBlQGVAZUBlQGVAZUBlQGVAXsKlQGVAbAK6wsrDGUMpQzlDJUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAZUBlQGVAfAKAAuZA64AtwCJALoC6ADwAAgAuACgA/oEpgO6AqsD+AAIAAgAswMIAAgACAAIAIkAuwP5AfsBwwPLAwgACAAIAAgACADRA9kDCAAIAOED6QMIAAgACAAIAAgACADuA/YDCAAIAP4DyQAIAAgABgQIAAgAXQAOBAgACAAIAAgACAAIABMECAAIAAgACAAIAAgACAD8AAQBCAAIAAgAGgQiBCoECAExBAgAEAEIAAgACAAIAAgACAAIAAgACAAIAAgACAA4BAgACABABEYECAAIAAgATAQYAQgAVAQIAAgACAAIAAgACAAIAAgACAAIAFoECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAOQEIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAB+BAcACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAEABhgSMBAgACAAIAAgAlAQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAwAEAAQABAADAAMAAwADAAQABAAEAAQABAAEAAQABHATAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAdQMIAAgACAAIAAgACAAIAMkACAAIAAgAfQMIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACACFA4kDCAAIAAgACAAIAOcBCAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAIcDCAAIAAgACAAIAAgACAAIAAgACAAIAJEDCAAIAAgACADFAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABgBAgAZgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAbAQCBXIECAAIAHkECAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACABAAJwEQACjBKoEsgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAC6BMIECAAIAAgACAAIAAgACABmBAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAxwQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAGYECAAIAAgAzgQIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBd0FXwUIAOIF6gXxBYoF3gT5BQAGCAaKBYoFigWKBYoFigWKBYoFigWKBYoFigXWBIoFigWKBYoFigWKBYoFigWKBYsFEAaKBYoFigWKBYoFigWKBRQGCACKBYoFigWKBQgACAAIANEECAAIABgGigUgBggAJgYIAC4GMwaKBYoF0wQ3Bj4GigWKBYoFigWKBYoFigWKBYoFigWKBYoFigUIAAgACAAIAAgACAAIAAgAigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWKBYoFigWLBf///////wQABAAEAAQABAAEAAQABAAEAAQAAwAEAAQAAgAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAQADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUAAAAFAAUAAAAFAAUAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUAAQAAAAUABQAFAAUABQAFAAAAAAAFAAUAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAFAAUAAQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAAABwAHAAcAAAAHAAcABwAFAAEAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAcABwAFAAUAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAAAAQABAAAAAAAAAAAAAAAFAAUABQAFAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAHAAcAAAAHAAcAAAAAAAUABQAHAAUAAQAHAAEABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwABAAUABQAFAAUAAAAAAAAAAAAAAAEAAQABAAEAAQABAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABQANAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABAAEAAQABAAEAAQABAAEAAQABAAEAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAABQAHAAUABQAFAAAAAAAAAAcABQAFAAUABQAFAAQABAAEAAQABAAEAAQABAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAEAAQABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUAAAAFAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAUAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAcABwAFAAcABwAAAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUABwAHAAUABQAFAAUAAAAAAAcABwAAAAAABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAABQAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAAAAAAAAAAABQAFAAAAAAAFAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAFAAUABQAFAAUAAAAFAAUABwAAAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABwAFAAUABQAFAAAAAAAHAAcAAAAAAAcABwAFAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAAAAAAAAAHAAcABwAAAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAABQAHAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAUABQAFAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAHAAcABQAHAAcAAAAFAAcABwAAAAcABwAFAAUAAAAAAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAFAAcABwAFAAUABQAAAAUAAAAHAAcABwAHAAcABwAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAHAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAABwAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAUAAAAFAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABwAFAAUABQAFAAUAAAAFAAUAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABwAFAAUABQAFAAUABQAAAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABQAFAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABQAFAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAHAAUABQAFAAUABQAFAAUABwAHAAcABwAHAAcABwAHAAUABwAHAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABwAHAAcABwAFAAUABwAHAAcAAAAAAAAAAAAHAAcABQAHAAcABwAHAAcABwAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAcABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAUABQAFAAUABQAFAAUAAAAFAAAABQAAAAAABQAFAAUABQAFAAUABQAFAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAFAAUAAAAAAAUABQAFAAUABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABwAFAAcABwAHAAcABwAFAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAUABQAFAAUABwAHAAUABQAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABQAFAAcABwAHAAUABwAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAcABQAFAAUABQAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAAAAAABwAFAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAAAAAAAAAFAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAUABQAHAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAUABQAFAAUABQAHAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAcABwAFAAUABQAFAAcABwAFAAUABwAHAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAFAAcABwAFAAUABwAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAFAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAFAAUABQAAAAAABQAFAAAAAAAAAAAAAAAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAcABwAAAAAAAAAAAAAABwAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAcABwAFAAcABwAAAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAFAAUABQAAAAUABQAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABwAFAAUABQAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAUABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAHAAcABQAHAAUABQAAAAAAAAAAAAAAAAAFAAAABwAHAAcABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAHAAcABwAAAAAABwAHAAAAAAAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABwAHAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAFAAUABwAFAAcABwAFAAcABQAFAAcABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAHAAcABQAFAAUABQAAAAAABwAHAAcABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAHAAUABQAFAAUABQAFAAUABQAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABwAFAAcABwAFAAUABQAFAAUABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAcABwAFAAUABQAFAAcABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAUABQAFAAUABQAHAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAFAAUABQAFAAAAAAAFAAUABwAHAAcABwAFAAAAAAAAAAcAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABwAHAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAcABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUAAAAHAAUABQAFAAUABQAFAAUABwAFAAUABwAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUAAAAAAAAABQAAAAUABQAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAHAAcABwAHAAcAAAAFAAUAAAAHAAcABQAHAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAAAAUABQAFAAAAAAAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAFAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAFAAUABQAAAAAABQAFAAUABQAFAAUABQAAAAUABQAAAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAFAAUABQAFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABQAFAAUABQAFAAUABQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAFAAUABQAFAAUADgAOAA4ADgAOAA4ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAA8ADwAPAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAcABwAHAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAgACAAIAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAMAAwADAAMAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkACQAJAAkAAAAAAAAAAAAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAKAAoACgAAAAAAAAAAAAsADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwACwAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAMAAwADAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAADgAOAA4AAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAAAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4AAAAOAAAAAAAAAAAAAAAAAA4AAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAAAAAAAAAAAA4AAAAOAAAAAAAAAAAADgAOAA4AAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAA4AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4AAAAAAA4ADgAOAA4ADgAOAA4ADgAOAAAADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4ADgAOAAAAAAAAAAAAAAAAAAAAAAAAAAAADgAOAA4ADgAOAA4AAAAAAAAAAAAAAAAAAAAAAA4ADgAOAA4ADgAOAA4ADgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAOAA4ADgAOAA4ADgAAAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4ADgAOAA4AAAAAAAAAAAA=';

    /*
     * utrie 1.0.2 <https://github.com/niklasvh/utrie>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup$1 = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i$1 = 0; i$1 < chars$1.length; i$1++) {
        lookup$1[chars$1.charCodeAt(i$1)] = i$1;
    }
    var decode = function (base64) {
        var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
        if (base64[base64.length - 1] === '=') {
            bufferLength--;
            if (base64[base64.length - 2] === '=') {
                bufferLength--;
            }
        }
        var buffer = typeof ArrayBuffer !== 'undefined' &&
            typeof Uint8Array !== 'undefined' &&
            typeof Uint8Array.prototype.slice !== 'undefined'
            ? new ArrayBuffer(bufferLength)
            : new Array(bufferLength);
        var bytes = Array.isArray(buffer) ? buffer : new Uint8Array(buffer);
        for (i = 0; i < len; i += 4) {
            encoded1 = lookup$1[base64.charCodeAt(i)];
            encoded2 = lookup$1[base64.charCodeAt(i + 1)];
            encoded3 = lookup$1[base64.charCodeAt(i + 2)];
            encoded4 = lookup$1[base64.charCodeAt(i + 3)];
            bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
            bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
            bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
        }
        return buffer;
    };
    var polyUint16Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 2) {
            bytes.push((buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };
    var polyUint32Array = function (buffer) {
        var length = buffer.length;
        var bytes = [];
        for (var i = 0; i < length; i += 4) {
            bytes.push((buffer[i + 3] << 24) | (buffer[i + 2] << 16) | (buffer[i + 1] << 8) | buffer[i]);
        }
        return bytes;
    };

    /** Shift size for getting the index-2 table offset. */
    var UTRIE2_SHIFT_2 = 5;
    /** Shift size for getting the index-1 table offset. */
    var UTRIE2_SHIFT_1 = 6 + 5;
    /**
     * Shift size for shifting left the index array values.
     * Increases possible data size with 16-bit index values at the cost
     * of compactability.
     * This requires data blocks to be aligned by UTRIE2_DATA_GRANULARITY.
     */
    var UTRIE2_INDEX_SHIFT = 2;
    /**
     * Difference between the two shift sizes,
     * for getting an index-1 offset from an index-2 offset. 6=11-5
     */
    var UTRIE2_SHIFT_1_2 = UTRIE2_SHIFT_1 - UTRIE2_SHIFT_2;
    /**
     * The part of the index-2 table for U+D800..U+DBFF stores values for
     * lead surrogate code _units_ not code _points_.
     * Values for lead surrogate code _points_ are indexed with this portion of the table.
     * Length=32=0x20=0x400>>UTRIE2_SHIFT_2. (There are 1024=0x400 lead surrogates.)
     */
    var UTRIE2_LSCP_INDEX_2_OFFSET = 0x10000 >> UTRIE2_SHIFT_2;
    /** Number of entries in a data block. 32=0x20 */
    var UTRIE2_DATA_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_2;
    /** Mask for getting the lower bits for the in-data-block offset. */
    var UTRIE2_DATA_MASK = UTRIE2_DATA_BLOCK_LENGTH - 1;
    var UTRIE2_LSCP_INDEX_2_LENGTH = 0x400 >> UTRIE2_SHIFT_2;
    /** Count the lengths of both BMP pieces. 2080=0x820 */
    var UTRIE2_INDEX_2_BMP_LENGTH = UTRIE2_LSCP_INDEX_2_OFFSET + UTRIE2_LSCP_INDEX_2_LENGTH;
    /**
     * The 2-byte UTF-8 version of the index-2 table follows at offset 2080=0x820.
     * Length 32=0x20 for lead bytes C0..DF, regardless of UTRIE2_SHIFT_2.
     */
    var UTRIE2_UTF8_2B_INDEX_2_OFFSET = UTRIE2_INDEX_2_BMP_LENGTH;
    var UTRIE2_UTF8_2B_INDEX_2_LENGTH = 0x800 >> 6; /* U+0800 is the first code point after 2-byte UTF-8 */
    /**
     * The index-1 table, only used for supplementary code points, at offset 2112=0x840.
     * Variable length, for code points up to highStart, where the last single-value range starts.
     * Maximum length 512=0x200=0x100000>>UTRIE2_SHIFT_1.
     * (For 0x100000 supplementary code points U+10000..U+10ffff.)
     *
     * The part of the index-2 table for supplementary code points starts
     * after this index-1 table.
     *
     * Both the index-1 table and the following part of the index-2 table
     * are omitted completely if there is only BMP data.
     */
    var UTRIE2_INDEX_1_OFFSET = UTRIE2_UTF8_2B_INDEX_2_OFFSET + UTRIE2_UTF8_2B_INDEX_2_LENGTH;
    /**
     * Number of index-1 entries for the BMP. 32=0x20
     * This part of the index-1 table is omitted from the serialized form.
     */
    var UTRIE2_OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> UTRIE2_SHIFT_1;
    /** Number of entries in an index-2 block. 64=0x40 */
    var UTRIE2_INDEX_2_BLOCK_LENGTH = 1 << UTRIE2_SHIFT_1_2;
    /** Mask for getting the lower bits for the in-index-2-block offset. */
    var UTRIE2_INDEX_2_MASK = UTRIE2_INDEX_2_BLOCK_LENGTH - 1;
    var slice16 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint16Array(Array.prototype.slice.call(view, start, end));
    };
    var slice32 = function (view, start, end) {
        if (view.slice) {
            return view.slice(start, end);
        }
        return new Uint32Array(Array.prototype.slice.call(view, start, end));
    };
    var createTrieFromBase64 = function (base64, _byteLength) {
        var buffer = decode(base64);
        var view32 = Array.isArray(buffer) ? polyUint32Array(buffer) : new Uint32Array(buffer);
        var view16 = Array.isArray(buffer) ? polyUint16Array(buffer) : new Uint16Array(buffer);
        var headerLength = 24;
        var index = slice16(view16, headerLength / 2, view32[4] / 2);
        var data = view32[5] === 2
            ? slice16(view16, (headerLength + view32[4]) / 2)
            : slice32(view32, Math.ceil((headerLength + view32[4]) / 4));
        return new Trie(view32[0], view32[1], view32[2], view32[3], index, data);
    };
    var Trie = /** @class */ (function () {
        function Trie(initialValue, errorValue, highStart, highValueIndex, index, data) {
            this.initialValue = initialValue;
            this.errorValue = errorValue;
            this.highStart = highStart;
            this.highValueIndex = highValueIndex;
            this.index = index;
            this.data = data;
        }
        /**
         * Get the value for a code point as stored in the Trie.
         *
         * @param codePoint the code point
         * @return the value
         */
        Trie.prototype.get = function (codePoint) {
            var ix;
            if (codePoint >= 0) {
                if (codePoint < 0x0d800 || (codePoint > 0x0dbff && codePoint <= 0x0ffff)) {
                    // Ordinary BMP code point, excluding leading surrogates.
                    // BMP uses a single level lookup.  BMP index starts at offset 0 in the Trie2 index.
                    // 16 bit data is stored in the index array itself.
                    ix = this.index[codePoint >> UTRIE2_SHIFT_2];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0xffff) {
                    // Lead Surrogate Code Point.  A Separate index section is stored for
                    // lead surrogate code units and code points.
                    //   The main index has the code unit data.
                    //   For this function, we need the code point data.
                    // Note: this expression could be refactored for slightly improved efficiency, but
                    //       surrogate code points will be so rare in practice that it's not worth it.
                    ix = this.index[UTRIE2_LSCP_INDEX_2_OFFSET + ((codePoint - 0xd800) >> UTRIE2_SHIFT_2)];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint < this.highStart) {
                    // Supplemental code point, use two-level lookup.
                    ix = UTRIE2_INDEX_1_OFFSET - UTRIE2_OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> UTRIE2_SHIFT_1);
                    ix = this.index[ix];
                    ix += (codePoint >> UTRIE2_SHIFT_2) & UTRIE2_INDEX_2_MASK;
                    ix = this.index[ix];
                    ix = (ix << UTRIE2_INDEX_SHIFT) + (codePoint & UTRIE2_DATA_MASK);
                    return this.data[ix];
                }
                if (codePoint <= 0x10ffff) {
                    return this.data[this.highValueIndex];
                }
            }
            // Fall through.  The code point is outside of the legal range of 0..0x10ffff.
            return this.errorValue;
        };
        return Trie;
    }());

    /*
     * base64-arraybuffer 1.0.2 <https://github.com/niklasvh/base64-arraybuffer>
     * Copyright (c) 2022 Niklas von Hertzen <https://hertzen.com>
     * Released under MIT License
     */
    var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // Use a lookup table to find the index.
    var lookup = typeof Uint8Array === 'undefined' ? [] : new Uint8Array(256);
    for (var i = 0; i < chars.length; i++) {
        lookup[chars.charCodeAt(i)] = i;
    }

    var Prepend = 1;
    var CR = 2;
    var LF = 3;
    var Control = 4;
    var Extend = 5;
    var SpacingMark = 7;
    var L = 8;
    var V = 9;
    var T = 10;
    var LV = 11;
    var LVT = 12;
    var ZWJ = 13;
    var Extended_Pictographic = 14;
    var RI = 15;
    var toCodePoints = function (str) {
        var codePoints = [];
        var i = 0;
        var length = str.length;
        while (i < length) {
            var value = str.charCodeAt(i++);
            if (value >= 0xd800 && value <= 0xdbff && i < length) {
                var extra = str.charCodeAt(i++);
                if ((extra & 0xfc00) === 0xdc00) {
                    codePoints.push(((value & 0x3ff) << 10) + (extra & 0x3ff) + 0x10000);
                }
                else {
                    codePoints.push(value);
                    i--;
                }
            }
            else {
                codePoints.push(value);
            }
        }
        return codePoints;
    };
    var fromCodePoint = function () {
        var codePoints = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            codePoints[_i] = arguments[_i];
        }
        if (String.fromCodePoint) {
            return String.fromCodePoint.apply(String, codePoints);
        }
        var length = codePoints.length;
        if (!length) {
            return '';
        }
        var codeUnits = [];
        var index = -1;
        var result = '';
        while (++index < length) {
            var codePoint = codePoints[index];
            if (codePoint <= 0xffff) {
                codeUnits.push(codePoint);
            }
            else {
                codePoint -= 0x10000;
                codeUnits.push((codePoint >> 10) + 0xd800, (codePoint % 0x400) + 0xdc00);
            }
            if (index + 1 === length || codeUnits.length > 0x4000) {
                result += String.fromCharCode.apply(String, codeUnits);
                codeUnits.length = 0;
            }
        }
        return result;
    };
    var UnicodeTrie = createTrieFromBase64(base64);
    var BREAK_NOT_ALLOWED = '×';
    var BREAK_ALLOWED = '÷';
    var codePointToClass = function (codePoint) { return UnicodeTrie.get(codePoint); };
    var _graphemeBreakAtIndex = function (_codePoints, classTypes, index) {
        var prevIndex = index - 2;
        var prev = classTypes[prevIndex];
        var current = classTypes[index - 1];
        var next = classTypes[index];
        // GB3 Do not break between a CR and LF
        if (current === CR && next === LF) {
            return BREAK_NOT_ALLOWED;
        }
        // GB4 Otherwise, break before and after controls.
        if (current === CR || current === LF || current === Control) {
            return BREAK_ALLOWED;
        }
        // GB5
        if (next === CR || next === LF || next === Control) {
            return BREAK_ALLOWED;
        }
        // Do not break Hangul syllable sequences.
        // GB6
        if (current === L && [L, V, LV, LVT].indexOf(next) !== -1) {
            return BREAK_NOT_ALLOWED;
        }
        // GB7
        if ((current === LV || current === V) && (next === V || next === T)) {
            return BREAK_NOT_ALLOWED;
        }
        // GB8
        if ((current === LVT || current === T) && next === T) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9 Do not break before extending characters or ZWJ.
        if (next === ZWJ || next === Extend) {
            return BREAK_NOT_ALLOWED;
        }
        // Do not break before SpacingMarks, or after Prepend characters.
        // GB9a
        if (next === SpacingMark) {
            return BREAK_NOT_ALLOWED;
        }
        // GB9a
        if (current === Prepend) {
            return BREAK_NOT_ALLOWED;
        }
        // GB11 Do not break within emoji modifier sequences or emoji zwj sequences.
        if (current === ZWJ && next === Extended_Pictographic) {
            while (prev === Extend) {
                prev = classTypes[--prevIndex];
            }
            if (prev === Extended_Pictographic) {
                return BREAK_NOT_ALLOWED;
            }
        }
        // GB12 Do not break within emoji flag sequences.
        // That is, do not break between regional indicator (RI) symbols
        // if there is an odd number of RI characters before the break point.
        if (current === RI && next === RI) {
            var countRI = 0;
            while (prev === RI) {
                countRI++;
                prev = classTypes[--prevIndex];
            }
            if (countRI % 2 === 0) {
                return BREAK_NOT_ALLOWED;
            }
        }
        return BREAK_ALLOWED;
    };
    var GraphemeBreaker = function (str) {
        var codePoints = toCodePoints(str);
        var length = codePoints.length;
        var index = 0;
        var lastEnd = 0;
        var classTypes = codePoints.map(codePointToClass);
        return {
            next: function () {
                if (index >= length) {
                    return { done: true, value: null };
                }
                var graphemeBreak = BREAK_NOT_ALLOWED;
                while (index < length &&
                    (graphemeBreak = _graphemeBreakAtIndex(codePoints, classTypes, ++index)) === BREAK_NOT_ALLOWED) { }
                if (graphemeBreak !== BREAK_NOT_ALLOWED || index === length) {
                    var value = fromCodePoint.apply(null, codePoints.slice(lastEnd, index));
                    lastEnd = index;
                    return { value: value, done: false };
                }
                return { done: true, value: null };
            },
        };
    };
    var splitGraphemes = function (str) {
        var breaker = GraphemeBreaker(str);
        var graphemes = [];
        var bk;
        while (!(bk = breaker.next()).done) {
            if (bk.value) {
                graphemes.push(bk.value.slice());
            }
        }
        return graphemes;
    };

    var testRangeBounds = function (document) {
        var TEST_HEIGHT = 123;
        if (document.createRange) {
            var range = document.createRange();
            if (range.getBoundingClientRect) {
                var testElement = document.createElement('boundtest');
                testElement.style.height = TEST_HEIGHT + "px";
                testElement.style.display = 'block';
                document.body.appendChild(testElement);
                range.selectNode(testElement);
                var rangeBounds = range.getBoundingClientRect();
                var rangeHeight = Math.round(rangeBounds.height);
                document.body.removeChild(testElement);
                if (rangeHeight === TEST_HEIGHT) {
                    return true;
                }
            }
        }
        return false;
    };
    var testIOSLineBreak = function (document) {
        var testElement = document.createElement('boundtest');
        testElement.style.width = '50px';
        testElement.style.display = 'block';
        testElement.style.fontSize = '12px';
        testElement.style.letterSpacing = '0px';
        testElement.style.wordSpacing = '0px';
        document.body.appendChild(testElement);
        var range = document.createRange();
        testElement.innerHTML = typeof ''.repeat === 'function' ? '&#128104;'.repeat(10) : '';
        var node = testElement.firstChild;
        var textList = toCodePoints$1(node.data).map(function (i) { return fromCodePoint$1(i); });
        var offset = 0;
        var prev = {};
        // ios 13 does not handle range getBoundingClientRect line changes correctly #2177
        var supports = textList.every(function (text, i) {
            range.setStart(node, offset);
            range.setEnd(node, offset + text.length);
            var rect = range.getBoundingClientRect();
            offset += text.length;
            var boundAhead = rect.x > prev.x || rect.y > prev.y;
            prev = rect;
            if (i === 0) {
                return true;
            }
            return boundAhead;
        });
        document.body.removeChild(testElement);
        return supports;
    };
    var testCORS = function () { return typeof new Image().crossOrigin !== 'undefined'; };
    var testResponseType = function () { return typeof new XMLHttpRequest().responseType === 'string'; };
    var testSVG = function (document) {
        var img = new Image();
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return false;
        }
        img.src = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg'></svg>";
        try {
            ctx.drawImage(img, 0, 0);
            canvas.toDataURL();
        }
        catch (e) {
            return false;
        }
        return true;
    };
    var isGreenPixel = function (data) {
        return data[0] === 0 && data[1] === 255 && data[2] === 0 && data[3] === 255;
    };
    var testForeignObject = function (document) {
        var canvas = document.createElement('canvas');
        var size = 100;
        canvas.width = size;
        canvas.height = size;
        var ctx = canvas.getContext('2d');
        if (!ctx) {
            return Promise.reject(false);
        }
        ctx.fillStyle = 'rgb(0, 255, 0)';
        ctx.fillRect(0, 0, size, size);
        var img = new Image();
        var greenImageSrc = canvas.toDataURL();
        img.src = greenImageSrc;
        var svg = createForeignObjectSVG(size, size, 0, 0, img);
        ctx.fillStyle = 'red';
        ctx.fillRect(0, 0, size, size);
        return loadSerializedSVG$1(svg)
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, size, size).data;
            ctx.fillStyle = 'red';
            ctx.fillRect(0, 0, size, size);
            var node = document.createElement('div');
            node.style.backgroundImage = "url(" + greenImageSrc + ")";
            node.style.height = size + "px";
            // Firefox 55 does not render inline <img /> tags
            return isGreenPixel(data)
                ? loadSerializedSVG$1(createForeignObjectSVG(size, size, 0, 0, node))
                : Promise.reject(false);
        })
            .then(function (img) {
            ctx.drawImage(img, 0, 0);
            // Edge does not render background-images
            return isGreenPixel(ctx.getImageData(0, 0, size, size).data);
        })
            .catch(function () { return false; });
    };
    var createForeignObjectSVG = function (width, height, x, y, node) {
        var xmlns = 'http://www.w3.org/2000/svg';
        var svg = document.createElementNS(xmlns, 'svg');
        var foreignObject = document.createElementNS(xmlns, 'foreignObject');
        svg.setAttributeNS(null, 'width', width.toString());
        svg.setAttributeNS(null, 'height', height.toString());
        foreignObject.setAttributeNS(null, 'width', '100%');
        foreignObject.setAttributeNS(null, 'height', '100%');
        foreignObject.setAttributeNS(null, 'x', x.toString());
        foreignObject.setAttributeNS(null, 'y', y.toString());
        foreignObject.setAttributeNS(null, 'externalResourcesRequired', 'true');
        svg.appendChild(foreignObject);
        foreignObject.appendChild(node);
        return svg;
    };
    var loadSerializedSVG$1 = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () { return resolve(img); };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };
    var FEATURES = {
        get SUPPORT_RANGE_BOUNDS() {
            var value = testRangeBounds(document);
            Object.defineProperty(FEATURES, 'SUPPORT_RANGE_BOUNDS', { value: value });
            return value;
        },
        get SUPPORT_WORD_BREAKING() {
            var value = FEATURES.SUPPORT_RANGE_BOUNDS && testIOSLineBreak(document);
            Object.defineProperty(FEATURES, 'SUPPORT_WORD_BREAKING', { value: value });
            return value;
        },
        get SUPPORT_SVG_DRAWING() {
            var value = testSVG(document);
            Object.defineProperty(FEATURES, 'SUPPORT_SVG_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_FOREIGNOBJECT_DRAWING() {
            var value = typeof Array.from === 'function' && typeof window.fetch === 'function'
                ? testForeignObject(document)
                : Promise.resolve(false);
            Object.defineProperty(FEATURES, 'SUPPORT_FOREIGNOBJECT_DRAWING', { value: value });
            return value;
        },
        get SUPPORT_CORS_IMAGES() {
            var value = testCORS();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_IMAGES', { value: value });
            return value;
        },
        get SUPPORT_RESPONSE_TYPE() {
            var value = testResponseType();
            Object.defineProperty(FEATURES, 'SUPPORT_RESPONSE_TYPE', { value: value });
            return value;
        },
        get SUPPORT_CORS_XHR() {
            var value = 'withCredentials' in new XMLHttpRequest();
            Object.defineProperty(FEATURES, 'SUPPORT_CORS_XHR', { value: value });
            return value;
        },
        get SUPPORT_NATIVE_TEXT_SEGMENTATION() {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var value = !!(typeof Intl !== 'undefined' && Intl.Segmenter);
            Object.defineProperty(FEATURES, 'SUPPORT_NATIVE_TEXT_SEGMENTATION', { value: value });
            return value;
        }
    };

    var TextBounds = /** @class */ (function () {
        function TextBounds(text, bounds) {
            this.text = text;
            this.bounds = bounds;
        }
        return TextBounds;
    }());
    var parseTextBounds = function (context, value, styles, node) {
        var textList = breakText(value, styles);
        var textBounds = [];
        var offset = 0;
        textList.forEach(function (text) {
            if (styles.textDecorationLine.length || text.trim().length > 0) {
                if (FEATURES.SUPPORT_RANGE_BOUNDS) {
                    var clientRects = createRange(node, offset, text.length).getClientRects();
                    if (clientRects.length > 1) {
                        var subSegments = segmentGraphemes(text);
                        var subOffset_1 = 0;
                        subSegments.forEach(function (subSegment) {
                            textBounds.push(new TextBounds(subSegment, Bounds.fromDOMRectList(context, createRange(node, subOffset_1 + offset, subSegment.length).getClientRects())));
                            subOffset_1 += subSegment.length;
                        });
                    }
                    else {
                        textBounds.push(new TextBounds(text, Bounds.fromDOMRectList(context, clientRects)));
                    }
                }
                else {
                    var replacementNode = node.splitText(text.length);
                    textBounds.push(new TextBounds(text, getWrapperBounds(context, node)));
                    node = replacementNode;
                }
            }
            else if (!FEATURES.SUPPORT_RANGE_BOUNDS) {
                node = node.splitText(text.length);
            }
            offset += text.length;
        });
        return textBounds;
    };
    var getWrapperBounds = function (context, node) {
        var ownerDocument = node.ownerDocument;
        if (ownerDocument) {
            var wrapper = ownerDocument.createElement('html2canvaswrapper');
            wrapper.appendChild(node.cloneNode(true));
            var parentNode = node.parentNode;
            if (parentNode) {
                parentNode.replaceChild(wrapper, node);
                var bounds = parseBounds(context, wrapper);
                if (wrapper.firstChild) {
                    parentNode.replaceChild(wrapper.firstChild, wrapper);
                }
                return bounds;
            }
        }
        return Bounds.EMPTY;
    };
    var createRange = function (node, offset, length) {
        var ownerDocument = node.ownerDocument;
        if (!ownerDocument) {
            throw new Error('Node has no owner document');
        }
        var range = ownerDocument.createRange();
        range.setStart(node, offset);
        range.setEnd(node, offset + length);
        return range;
    };
    var segmentGraphemes = function (value) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, { granularity: 'grapheme' });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return splitGraphemes(value);
    };
    var segmentWords = function (value, styles) {
        if (FEATURES.SUPPORT_NATIVE_TEXT_SEGMENTATION) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var segmenter = new Intl.Segmenter(void 0, {
                granularity: 'word'
            });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return Array.from(segmenter.segment(value)).map(function (segment) { return segment.segment; });
        }
        return breakWords(value, styles);
    };
    var breakText = function (value, styles) {
        return styles.letterSpacing !== 0 ? segmentGraphemes(value) : segmentWords(value, styles);
    };
    // https://drafts.csswg.org/css-text/#word-separator
    var wordSeparators = [0x0020, 0x00a0, 0x1361, 0x10100, 0x10101, 0x1039, 0x1091];
    var breakWords = function (str, styles) {
        var breaker = LineBreaker(str, {
            lineBreak: styles.lineBreak,
            wordBreak: styles.overflowWrap === "break-word" /* BREAK_WORD */ ? 'break-word' : styles.wordBreak
        });
        var words = [];
        var bk;
        var _loop_1 = function () {
            if (bk.value) {
                var value = bk.value.slice();
                var codePoints = toCodePoints$1(value);
                var word_1 = '';
                codePoints.forEach(function (codePoint) {
                    if (wordSeparators.indexOf(codePoint) === -1) {
                        word_1 += fromCodePoint$1(codePoint);
                    }
                    else {
                        if (word_1.length) {
                            words.push(word_1);
                        }
                        words.push(fromCodePoint$1(codePoint));
                        word_1 = '';
                    }
                });
                if (word_1.length) {
                    words.push(word_1);
                }
            }
        };
        while (!(bk = breaker.next()).done) {
            _loop_1();
        }
        return words;
    };

    var TextContainer = /** @class */ (function () {
        function TextContainer(context, node, styles) {
            this.text = transform(node.data, styles.textTransform);
            this.textBounds = parseTextBounds(context, this.text, styles, node);
        }
        return TextContainer;
    }());
    var transform = function (text, transform) {
        switch (transform) {
            case 1 /* LOWERCASE */:
                return text.toLowerCase();
            case 3 /* CAPITALIZE */:
                return text.replace(CAPITALIZE, capitalize);
            case 2 /* UPPERCASE */:
                return text.toUpperCase();
            default:
                return text;
        }
    };
    var CAPITALIZE = /(^|\s|:|-|\(|\))([a-z])/g;
    var capitalize = function (m, p1, p2) {
        if (m.length > 0) {
            return p1 + p2.toUpperCase();
        }
        return m;
    };

    var ImageElementContainer = /** @class */ (function (_super) {
        __extends(ImageElementContainer, _super);
        function ImageElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            _this.src = img.currentSrc || img.src;
            _this.intrinsicWidth = img.naturalWidth;
            _this.intrinsicHeight = img.naturalHeight;
            _this.context.cache.addImage(_this.src);
            return _this;
        }
        return ImageElementContainer;
    }(ElementContainer));

    var CanvasElementContainer = /** @class */ (function (_super) {
        __extends(CanvasElementContainer, _super);
        function CanvasElementContainer(context, canvas) {
            var _this = _super.call(this, context, canvas) || this;
            _this.canvas = canvas;
            _this.intrinsicWidth = canvas.width;
            _this.intrinsicHeight = canvas.height;
            return _this;
        }
        return CanvasElementContainer;
    }(ElementContainer));

    var SVGElementContainer = /** @class */ (function (_super) {
        __extends(SVGElementContainer, _super);
        function SVGElementContainer(context, img) {
            var _this = _super.call(this, context, img) || this;
            var s = new XMLSerializer();
            var bounds = parseBounds(context, img);
            img.setAttribute('width', bounds.width + "px");
            img.setAttribute('height', bounds.height + "px");
            _this.svg = "data:image/svg+xml," + encodeURIComponent(s.serializeToString(img));
            _this.intrinsicWidth = img.width.baseVal.value;
            _this.intrinsicHeight = img.height.baseVal.value;
            _this.context.cache.addImage(_this.svg);
            return _this;
        }
        return SVGElementContainer;
    }(ElementContainer));

    var LIElementContainer = /** @class */ (function (_super) {
        __extends(LIElementContainer, _super);
        function LIElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return LIElementContainer;
    }(ElementContainer));

    var OLElementContainer = /** @class */ (function (_super) {
        __extends(OLElementContainer, _super);
        function OLElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.start = element.start;
            _this.reversed = typeof element.reversed === 'boolean' && element.reversed === true;
            return _this;
        }
        return OLElementContainer;
    }(ElementContainer));

    var CHECKBOX_BORDER_RADIUS = [
        {
            type: 15 /* DIMENSION_TOKEN */,
            flags: 0,
            unit: 'px',
            number: 3
        }
    ];
    var RADIO_BORDER_RADIUS = [
        {
            type: 16 /* PERCENTAGE_TOKEN */,
            flags: 0,
            number: 50
        }
    ];
    var reformatInputBounds = function (bounds) {
        if (bounds.width > bounds.height) {
            return new Bounds(bounds.left + (bounds.width - bounds.height) / 2, bounds.top, bounds.height, bounds.height);
        }
        else if (bounds.width < bounds.height) {
            return new Bounds(bounds.left, bounds.top + (bounds.height - bounds.width) / 2, bounds.width, bounds.width);
        }
        return bounds;
    };
    var getInputValue = function (node) {
        var value = node.type === PASSWORD ? new Array(node.value.length + 1).join('\u2022') : node.value;
        return value.length === 0 ? node.placeholder || '' : value;
    };
    var CHECKBOX = 'checkbox';
    var RADIO = 'radio';
    var PASSWORD = 'password';
    var INPUT_COLOR = 0x2a2a2aff;
    var InputElementContainer = /** @class */ (function (_super) {
        __extends(InputElementContainer, _super);
        function InputElementContainer(context, input) {
            var _this = _super.call(this, context, input) || this;
            _this.type = input.type.toLowerCase();
            _this.checked = input.checked;
            _this.value = getInputValue(input);
            if (_this.type === CHECKBOX || _this.type === RADIO) {
                _this.styles.backgroundColor = 0xdededeff;
                _this.styles.borderTopColor =
                    _this.styles.borderRightColor =
                        _this.styles.borderBottomColor =
                            _this.styles.borderLeftColor =
                                0xa5a5a5ff;
                _this.styles.borderTopWidth =
                    _this.styles.borderRightWidth =
                        _this.styles.borderBottomWidth =
                            _this.styles.borderLeftWidth =
                                1;
                _this.styles.borderTopStyle =
                    _this.styles.borderRightStyle =
                        _this.styles.borderBottomStyle =
                            _this.styles.borderLeftStyle =
                                1 /* SOLID */;
                _this.styles.backgroundClip = [0 /* BORDER_BOX */];
                _this.styles.backgroundOrigin = [0 /* BORDER_BOX */];
                _this.bounds = reformatInputBounds(_this.bounds);
            }
            switch (_this.type) {
                case CHECKBOX:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    CHECKBOX_BORDER_RADIUS;
                    break;
                case RADIO:
                    _this.styles.borderTopRightRadius =
                        _this.styles.borderTopLeftRadius =
                            _this.styles.borderBottomRightRadius =
                                _this.styles.borderBottomLeftRadius =
                                    RADIO_BORDER_RADIUS;
                    break;
            }
            return _this;
        }
        return InputElementContainer;
    }(ElementContainer));

    var SelectElementContainer = /** @class */ (function (_super) {
        __extends(SelectElementContainer, _super);
        function SelectElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            var option = element.options[element.selectedIndex || 0];
            _this.value = option ? option.text || '' : '';
            return _this;
        }
        return SelectElementContainer;
    }(ElementContainer));

    var TextareaElementContainer = /** @class */ (function (_super) {
        __extends(TextareaElementContainer, _super);
        function TextareaElementContainer(context, element) {
            var _this = _super.call(this, context, element) || this;
            _this.value = element.value;
            return _this;
        }
        return TextareaElementContainer;
    }(ElementContainer));

    var IFrameElementContainer = /** @class */ (function (_super) {
        __extends(IFrameElementContainer, _super);
        function IFrameElementContainer(context, iframe) {
            var _this = _super.call(this, context, iframe) || this;
            _this.src = iframe.src;
            _this.width = parseInt(iframe.width, 10) || 0;
            _this.height = parseInt(iframe.height, 10) || 0;
            _this.backgroundColor = _this.styles.backgroundColor;
            try {
                if (iframe.contentWindow &&
                    iframe.contentWindow.document &&
                    iframe.contentWindow.document.documentElement) {
                    _this.tree = parseTree(context, iframe.contentWindow.document.documentElement);
                    // http://www.w3.org/TR/css3-background/#special-backgrounds
                    var documentBackgroundColor = iframe.contentWindow.document.documentElement
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.documentElement).backgroundColor)
                        : COLORS.TRANSPARENT;
                    var bodyBackgroundColor = iframe.contentWindow.document.body
                        ? parseColor(context, getComputedStyle(iframe.contentWindow.document.body).backgroundColor)
                        : COLORS.TRANSPARENT;
                    _this.backgroundColor = isTransparent(documentBackgroundColor)
                        ? isTransparent(bodyBackgroundColor)
                            ? _this.styles.backgroundColor
                            : bodyBackgroundColor
                        : documentBackgroundColor;
                }
            }
            catch (e) { }
            return _this;
        }
        return IFrameElementContainer;
    }(ElementContainer));

    var LIST_OWNERS = ['OL', 'UL', 'MENU'];
    var parseNodeTree = function (context, node, parent, root) {
        for (var childNode = node.firstChild, nextNode = void 0; childNode; childNode = nextNode) {
            nextNode = childNode.nextSibling;
            if (isTextNode(childNode) && childNode.data.trim().length > 0) {
                parent.textNodes.push(new TextContainer(context, childNode, parent.styles));
            }
            else if (isElementNode(childNode)) {
                if (isSlotElement(childNode) && childNode.assignedNodes) {
                    childNode.assignedNodes().forEach(function (childNode) { return parseNodeTree(context, childNode, parent, root); });
                }
                else {
                    var container = createContainer(context, childNode);
                    if (container.styles.isVisible()) {
                        if (createsRealStackingContext(childNode, container, root)) {
                            container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
                        }
                        else if (createsStackingContext(container.styles)) {
                            container.flags |= 2 /* CREATES_STACKING_CONTEXT */;
                        }
                        if (LIST_OWNERS.indexOf(childNode.tagName) !== -1) {
                            container.flags |= 8 /* IS_LIST_OWNER */;
                        }
                        parent.elements.push(container);
                        childNode.slot;
                        if (childNode.shadowRoot) {
                            parseNodeTree(context, childNode.shadowRoot, container, root);
                        }
                        else if (!isTextareaElement(childNode) &&
                            !isSVGElement(childNode) &&
                            !isSelectElement(childNode)) {
                            parseNodeTree(context, childNode, container, root);
                        }
                    }
                }
            }
        }
    };
    var createContainer = function (context, element) {
        if (isImageElement(element)) {
            return new ImageElementContainer(context, element);
        }
        if (isCanvasElement(element)) {
            return new CanvasElementContainer(context, element);
        }
        if (isSVGElement(element)) {
            return new SVGElementContainer(context, element);
        }
        if (isLIElement(element)) {
            return new LIElementContainer(context, element);
        }
        if (isOLElement(element)) {
            return new OLElementContainer(context, element);
        }
        if (isInputElement(element)) {
            return new InputElementContainer(context, element);
        }
        if (isSelectElement(element)) {
            return new SelectElementContainer(context, element);
        }
        if (isTextareaElement(element)) {
            return new TextareaElementContainer(context, element);
        }
        if (isIFrameElement(element)) {
            return new IFrameElementContainer(context, element);
        }
        return new ElementContainer(context, element);
    };
    var parseTree = function (context, element) {
        var container = createContainer(context, element);
        container.flags |= 4 /* CREATES_REAL_STACKING_CONTEXT */;
        parseNodeTree(context, element, container, container);
        return container;
    };
    var createsRealStackingContext = function (node, container, root) {
        return (container.styles.isPositionedWithZIndex() ||
            container.styles.opacity < 1 ||
            container.styles.isTransformed() ||
            (isBodyElement(node) && root.styles.isTransparent()));
    };
    var createsStackingContext = function (styles) { return styles.isPositioned() || styles.isFloating(); };
    var isTextNode = function (node) { return node.nodeType === Node.TEXT_NODE; };
    var isElementNode = function (node) { return node.nodeType === Node.ELEMENT_NODE; };
    var isHTMLElementNode = function (node) {
        return isElementNode(node) && typeof node.style !== 'undefined' && !isSVGElementNode(node);
    };
    var isSVGElementNode = function (element) {
        return typeof element.className === 'object';
    };
    var isLIElement = function (node) { return node.tagName === 'LI'; };
    var isOLElement = function (node) { return node.tagName === 'OL'; };
    var isInputElement = function (node) { return node.tagName === 'INPUT'; };
    var isHTMLElement = function (node) { return node.tagName === 'HTML'; };
    var isSVGElement = function (node) { return node.tagName === 'svg'; };
    var isBodyElement = function (node) { return node.tagName === 'BODY'; };
    var isCanvasElement = function (node) { return node.tagName === 'CANVAS'; };
    var isVideoElement = function (node) { return node.tagName === 'VIDEO'; };
    var isImageElement = function (node) { return node.tagName === 'IMG'; };
    var isIFrameElement = function (node) { return node.tagName === 'IFRAME'; };
    var isStyleElement = function (node) { return node.tagName === 'STYLE'; };
    var isScriptElement = function (node) { return node.tagName === 'SCRIPT'; };
    var isTextareaElement = function (node) { return node.tagName === 'TEXTAREA'; };
    var isSelectElement = function (node) { return node.tagName === 'SELECT'; };
    var isSlotElement = function (node) { return node.tagName === 'SLOT'; };
    // https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
    var isCustomElement = function (node) { return node.tagName.indexOf('-') > 0; };

    var CounterState = /** @class */ (function () {
        function CounterState() {
            this.counters = {};
        }
        CounterState.prototype.getCounterValue = function (name) {
            var counter = this.counters[name];
            if (counter && counter.length) {
                return counter[counter.length - 1];
            }
            return 1;
        };
        CounterState.prototype.getCounterValues = function (name) {
            var counter = this.counters[name];
            return counter ? counter : [];
        };
        CounterState.prototype.pop = function (counters) {
            var _this = this;
            counters.forEach(function (counter) { return _this.counters[counter].pop(); });
        };
        CounterState.prototype.parse = function (style) {
            var _this = this;
            var counterIncrement = style.counterIncrement;
            var counterReset = style.counterReset;
            var canReset = true;
            if (counterIncrement !== null) {
                counterIncrement.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    if (counter && entry.increment !== 0) {
                        canReset = false;
                        if (!counter.length) {
                            counter.push(1);
                        }
                        counter[Math.max(0, counter.length - 1)] += entry.increment;
                    }
                });
            }
            var counterNames = [];
            if (canReset) {
                counterReset.forEach(function (entry) {
                    var counter = _this.counters[entry.counter];
                    counterNames.push(entry.counter);
                    if (!counter) {
                        counter = _this.counters[entry.counter] = [];
                    }
                    counter.push(entry.reset);
                });
            }
            return counterNames;
        };
        return CounterState;
    }());
    var ROMAN_UPPER = {
        integers: [1000, 900, 500, 400, 100, 90, 50, 40, 10, 9, 5, 4, 1],
        values: ['M', 'CM', 'D', 'CD', 'C', 'XC', 'L', 'XL', 'X', 'IX', 'V', 'IV', 'I']
    };
    var ARMENIAN = {
        integers: [
            9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90, 80, 70,
            60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'Ք',
            'Փ',
            'Ւ',
            'Ց',
            'Ր',
            'Տ',
            'Վ',
            'Ս',
            'Ռ',
            'Ջ',
            'Պ',
            'Չ',
            'Ո',
            'Շ',
            'Ն',
            'Յ',
            'Մ',
            'Ճ',
            'Ղ',
            'Ձ',
            'Հ',
            'Կ',
            'Ծ',
            'Խ',
            'Լ',
            'Ի',
            'Ժ',
            'Թ',
            'Ը',
            'Է',
            'Զ',
            'Ե',
            'Դ',
            'Գ',
            'Բ',
            'Ա'
        ]
    };
    var HEBREW = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 400, 300, 200, 100, 90, 80, 70, 60, 50, 40, 30, 20,
            19, 18, 17, 16, 15, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'י׳',
            'ט׳',
            'ח׳',
            'ז׳',
            'ו׳',
            'ה׳',
            'ד׳',
            'ג׳',
            'ב׳',
            'א׳',
            'ת',
            'ש',
            'ר',
            'ק',
            'צ',
            'פ',
            'ע',
            'ס',
            'נ',
            'מ',
            'ל',
            'כ',
            'יט',
            'יח',
            'יז',
            'טז',
            'טו',
            'י',
            'ט',
            'ח',
            'ז',
            'ו',
            'ה',
            'ד',
            'ג',
            'ב',
            'א'
        ]
    };
    var GEORGIAN = {
        integers: [
            10000, 9000, 8000, 7000, 6000, 5000, 4000, 3000, 2000, 1000, 900, 800, 700, 600, 500, 400, 300, 200, 100, 90,
            80, 70, 60, 50, 40, 30, 20, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1
        ],
        values: [
            'ჵ',
            'ჰ',
            'ჯ',
            'ჴ',
            'ხ',
            'ჭ',
            'წ',
            'ძ',
            'ც',
            'ჩ',
            'შ',
            'ყ',
            'ღ',
            'ქ',
            'ფ',
            'ჳ',
            'ტ',
            'ს',
            'რ',
            'ჟ',
            'პ',
            'ო',
            'ჲ',
            'ნ',
            'მ',
            'ლ',
            'კ',
            'ი',
            'თ',
            'ჱ',
            'ზ',
            'ვ',
            'ე',
            'დ',
            'გ',
            'ბ',
            'ა'
        ]
    };
    var createAdditiveCounter = function (value, min, max, symbols, fallback, suffix) {
        if (value < min || value > max) {
            return createCounterText(value, fallback, suffix.length > 0);
        }
        return (symbols.integers.reduce(function (string, integer, index) {
            while (value >= integer) {
                value -= integer;
                string += symbols.values[index];
            }
            return string;
        }, '') + suffix);
    };
    var createCounterStyleWithSymbolResolver = function (value, codePointRangeLength, isNumeric, resolver) {
        var string = '';
        do {
            if (!isNumeric) {
                value--;
            }
            string = resolver(value) + string;
            value /= codePointRangeLength;
        } while (value * codePointRangeLength >= codePointRangeLength);
        return string;
    };
    var createCounterStyleFromRange = function (value, codePointRangeStart, codePointRangeEnd, isNumeric, suffix) {
        var codePointRangeLength = codePointRangeEnd - codePointRangeStart + 1;
        return ((value < 0 ? '-' : '') +
            (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, isNumeric, function (codePoint) {
                return fromCodePoint$1(Math.floor(codePoint % codePointRangeLength) + codePointRangeStart);
            }) +
                suffix));
    };
    var createCounterStyleFromSymbols = function (value, symbols, suffix) {
        if (suffix === void 0) { suffix = '. '; }
        var codePointRangeLength = symbols.length;
        return (createCounterStyleWithSymbolResolver(Math.abs(value), codePointRangeLength, false, function (codePoint) { return symbols[Math.floor(codePoint % codePointRangeLength)]; }) + suffix);
    };
    var CJK_ZEROS = 1 << 0;
    var CJK_TEN_COEFFICIENTS = 1 << 1;
    var CJK_TEN_HIGH_COEFFICIENTS = 1 << 2;
    var CJK_HUNDRED_COEFFICIENTS = 1 << 3;
    var createCJKCounter = function (value, numbers, multipliers, negativeSign, suffix, flags) {
        if (value < -9999 || value > 9999) {
            return createCounterText(value, 4 /* CJK_DECIMAL */, suffix.length > 0);
        }
        var tmp = Math.abs(value);
        var string = suffix;
        if (tmp === 0) {
            return numbers[0] + string;
        }
        for (var digit = 0; tmp > 0 && digit <= 4; digit++) {
            var coefficient = tmp % 10;
            if (coefficient === 0 && contains(flags, CJK_ZEROS) && string !== '') {
                string = numbers[coefficient] + string;
            }
            else if (coefficient > 1 ||
                (coefficient === 1 && digit === 0) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_COEFFICIENTS)) ||
                (coefficient === 1 && digit === 1 && contains(flags, CJK_TEN_HIGH_COEFFICIENTS) && value > 100) ||
                (coefficient === 1 && digit > 1 && contains(flags, CJK_HUNDRED_COEFFICIENTS))) {
                string = numbers[coefficient] + (digit > 0 ? multipliers[digit - 1] : '') + string;
            }
            else if (coefficient === 1 && digit > 0) {
                string = multipliers[digit - 1] + string;
            }
            tmp = Math.floor(tmp / 10);
        }
        return (value < 0 ? negativeSign : '') + string;
    };
    var CHINESE_INFORMAL_MULTIPLIERS = '十百千萬';
    var CHINESE_FORMAL_MULTIPLIERS = '拾佰仟萬';
    var JAPANESE_NEGATIVE = 'マイナス';
    var KOREAN_NEGATIVE = '마이너스';
    var createCounterText = function (value, type, appendSuffix) {
        var defaultSuffix = appendSuffix ? '. ' : '';
        var cjkSuffix = appendSuffix ? '、' : '';
        var koreanSuffix = appendSuffix ? ', ' : '';
        var spaceSuffix = appendSuffix ? ' ' : '';
        switch (type) {
            case 0 /* DISC */:
                return '•' + spaceSuffix;
            case 1 /* CIRCLE */:
                return '◦' + spaceSuffix;
            case 2 /* SQUARE */:
                return '◾' + spaceSuffix;
            case 5 /* DECIMAL_LEADING_ZERO */:
                var string = createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
                return string.length < 4 ? "0" + string : string;
            case 4 /* CJK_DECIMAL */:
                return createCounterStyleFromSymbols(value, '〇一二三四五六七八九', cjkSuffix);
            case 6 /* LOWER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 7 /* UPPER_ROMAN */:
                return createAdditiveCounter(value, 1, 3999, ROMAN_UPPER, 3 /* DECIMAL */, defaultSuffix);
            case 8 /* LOWER_GREEK */:
                return createCounterStyleFromRange(value, 945, 969, false, defaultSuffix);
            case 9 /* LOWER_ALPHA */:
                return createCounterStyleFromRange(value, 97, 122, false, defaultSuffix);
            case 10 /* UPPER_ALPHA */:
                return createCounterStyleFromRange(value, 65, 90, false, defaultSuffix);
            case 11 /* ARABIC_INDIC */:
                return createCounterStyleFromRange(value, 1632, 1641, true, defaultSuffix);
            case 12 /* ARMENIAN */:
            case 49 /* UPPER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix);
            case 35 /* LOWER_ARMENIAN */:
                return createAdditiveCounter(value, 1, 9999, ARMENIAN, 3 /* DECIMAL */, defaultSuffix).toLowerCase();
            case 13 /* BENGALI */:
                return createCounterStyleFromRange(value, 2534, 2543, true, defaultSuffix);
            case 14 /* CAMBODIAN */:
            case 30 /* KHMER */:
                return createCounterStyleFromRange(value, 6112, 6121, true, defaultSuffix);
            case 15 /* CJK_EARTHLY_BRANCH */:
                return createCounterStyleFromSymbols(value, '子丑寅卯辰巳午未申酉戌亥', cjkSuffix);
            case 16 /* CJK_HEAVENLY_STEM */:
                return createCounterStyleFromSymbols(value, '甲乙丙丁戊己庚辛壬癸', cjkSuffix);
            case 17 /* CJK_IDEOGRAPHIC */:
            case 48 /* TRAD_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 47 /* TRAD_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹貳參肆伍陸柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '負', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 42 /* SIMP_CHINESE_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', CHINESE_INFORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 41 /* SIMP_CHINESE_FORMAL */:
                return createCJKCounter(value, '零壹贰叁肆伍陆柒捌玖', CHINESE_FORMAL_MULTIPLIERS, '负', cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS | CJK_HUNDRED_COEFFICIENTS);
            case 26 /* JAPANESE_INFORMAL */:
                return createCJKCounter(value, '〇一二三四五六七八九', '十百千万', JAPANESE_NEGATIVE, cjkSuffix, 0);
            case 25 /* JAPANESE_FORMAL */:
                return createCJKCounter(value, '零壱弐参四伍六七八九', '拾百千万', JAPANESE_NEGATIVE, cjkSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 31 /* KOREAN_HANGUL_FORMAL */:
                return createCJKCounter(value, '영일이삼사오육칠팔구', '십백천만', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 33 /* KOREAN_HANJA_INFORMAL */:
                return createCJKCounter(value, '零一二三四五六七八九', '十百千萬', KOREAN_NEGATIVE, koreanSuffix, 0);
            case 32 /* KOREAN_HANJA_FORMAL */:
                return createCJKCounter(value, '零壹貳參四五六七八九', '拾百千', KOREAN_NEGATIVE, koreanSuffix, CJK_ZEROS | CJK_TEN_COEFFICIENTS | CJK_TEN_HIGH_COEFFICIENTS);
            case 18 /* DEVANAGARI */:
                return createCounterStyleFromRange(value, 0x966, 0x96f, true, defaultSuffix);
            case 20 /* GEORGIAN */:
                return createAdditiveCounter(value, 1, 19999, GEORGIAN, 3 /* DECIMAL */, defaultSuffix);
            case 21 /* GUJARATI */:
                return createCounterStyleFromRange(value, 0xae6, 0xaef, true, defaultSuffix);
            case 22 /* GURMUKHI */:
                return createCounterStyleFromRange(value, 0xa66, 0xa6f, true, defaultSuffix);
            case 22 /* HEBREW */:
                return createAdditiveCounter(value, 1, 10999, HEBREW, 3 /* DECIMAL */, defaultSuffix);
            case 23 /* HIRAGANA */:
                return createCounterStyleFromSymbols(value, 'あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほまみむめもやゆよらりるれろわゐゑをん');
            case 24 /* HIRAGANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'いろはにほへとちりぬるをわかよたれそつねならむうゐのおくやまけふこえてあさきゆめみしゑひもせす');
            case 27 /* KANNADA */:
                return createCounterStyleFromRange(value, 0xce6, 0xcef, true, defaultSuffix);
            case 28 /* KATAKANA */:
                return createCounterStyleFromSymbols(value, 'アイウエオカキクケコサシスセソタチツテトナニヌネノハヒフヘホマミムメモヤユヨラリルレロワヰヱヲン', cjkSuffix);
            case 29 /* KATAKANA_IROHA */:
                return createCounterStyleFromSymbols(value, 'イロハニホヘトチリヌルヲワカヨタレソツネナラムウヰノオクヤマケフコエテアサキユメミシヱヒモセス', cjkSuffix);
            case 34 /* LAO */:
                return createCounterStyleFromRange(value, 0xed0, 0xed9, true, defaultSuffix);
            case 37 /* MONGOLIAN */:
                return createCounterStyleFromRange(value, 0x1810, 0x1819, true, defaultSuffix);
            case 38 /* MYANMAR */:
                return createCounterStyleFromRange(value, 0x1040, 0x1049, true, defaultSuffix);
            case 39 /* ORIYA */:
                return createCounterStyleFromRange(value, 0xb66, 0xb6f, true, defaultSuffix);
            case 40 /* PERSIAN */:
                return createCounterStyleFromRange(value, 0x6f0, 0x6f9, true, defaultSuffix);
            case 43 /* TAMIL */:
                return createCounterStyleFromRange(value, 0xbe6, 0xbef, true, defaultSuffix);
            case 44 /* TELUGU */:
                return createCounterStyleFromRange(value, 0xc66, 0xc6f, true, defaultSuffix);
            case 45 /* THAI */:
                return createCounterStyleFromRange(value, 0xe50, 0xe59, true, defaultSuffix);
            case 46 /* TIBETAN */:
                return createCounterStyleFromRange(value, 0xf20, 0xf29, true, defaultSuffix);
            case 3 /* DECIMAL */:
            default:
                return createCounterStyleFromRange(value, 48, 57, true, defaultSuffix);
        }
    };

    var IGNORE_ATTRIBUTE = 'data-html2canvas-ignore';
    var DocumentCloner = /** @class */ (function () {
        function DocumentCloner(context, element, options) {
            this.context = context;
            this.options = options;
            this.scrolledElements = [];
            this.referenceElement = element;
            this.counters = new CounterState();
            this.quoteDepth = 0;
            if (!element.ownerDocument) {
                throw new Error('Cloned element does not have an owner document');
            }
            this.documentElement = this.cloneNode(element.ownerDocument.documentElement, false);
        }
        DocumentCloner.prototype.toIFrame = function (ownerDocument, windowSize) {
            var _this = this;
            var iframe = createIFrameContainer(ownerDocument, windowSize);
            if (!iframe.contentWindow) {
                return Promise.reject("Unable to find iframe window");
            }
            var scrollX = ownerDocument.defaultView.pageXOffset;
            var scrollY = ownerDocument.defaultView.pageYOffset;
            var cloneWindow = iframe.contentWindow;
            var documentClone = cloneWindow.document;
            /* Chrome doesn't detect relative background-images assigned in inline <style> sheets when fetched through getComputedStyle
             if window url is about:blank, we can assign the url to current by writing onto the document
             */
            var iframeLoad = iframeLoader(iframe).then(function () { return __awaiter(_this, void 0, void 0, function () {
                var onclone, referenceElement;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.scrolledElements.forEach(restoreNodeScroll);
                            if (cloneWindow) {
                                cloneWindow.scrollTo(windowSize.left, windowSize.top);
                                if (/(iPad|iPhone|iPod)/g.test(navigator.userAgent) &&
                                    (cloneWindow.scrollY !== windowSize.top || cloneWindow.scrollX !== windowSize.left)) {
                                    this.context.logger.warn('Unable to restore scroll position for cloned document');
                                    this.context.windowBounds = this.context.windowBounds.add(cloneWindow.scrollX - windowSize.left, cloneWindow.scrollY - windowSize.top, 0, 0);
                                }
                            }
                            onclone = this.options.onclone;
                            referenceElement = this.clonedReferenceElement;
                            if (typeof referenceElement === 'undefined') {
                                return [2 /*return*/, Promise.reject("Error finding the " + this.referenceElement.nodeName + " in the cloned document")];
                            }
                            if (!(documentClone.fonts && documentClone.fonts.ready)) return [3 /*break*/, 2];
                            return [4 /*yield*/, documentClone.fonts.ready];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            if (!/(AppleWebKit)/g.test(navigator.userAgent)) return [3 /*break*/, 4];
                            return [4 /*yield*/, imagesReady(documentClone)];
                        case 3:
                            _a.sent();
                            _a.label = 4;
                        case 4:
                            if (typeof onclone === 'function') {
                                return [2 /*return*/, Promise.resolve()
                                        .then(function () { return onclone(documentClone, referenceElement); })
                                        .then(function () { return iframe; })];
                            }
                            return [2 /*return*/, iframe];
                    }
                });
            }); });
            documentClone.open();
            documentClone.write(serializeDoctype(document.doctype) + "<html></html>");
            // Chrome scrolls the parent document for some reason after the write to the cloned window???
            restoreOwnerScroll(this.referenceElement.ownerDocument, scrollX, scrollY);
            documentClone.replaceChild(documentClone.adoptNode(this.documentElement), documentClone.documentElement);
            documentClone.close();
            return iframeLoad;
        };
        DocumentCloner.prototype.createElementClone = function (node) {
            if (isDebugging(node, 2 /* CLONE */)) {
                debugger;
            }
            if (isCanvasElement(node)) {
                return this.createCanvasClone(node);
            }
            if (isVideoElement(node)) {
                return this.createVideoClone(node);
            }
            if (isStyleElement(node)) {
                return this.createStyleClone(node);
            }
            var clone = node.cloneNode(false);
            if (isImageElement(clone)) {
                if (isImageElement(node) && node.currentSrc && node.currentSrc !== node.src) {
                    clone.src = node.currentSrc;
                    clone.srcset = '';
                }
                if (clone.loading === 'lazy') {
                    clone.loading = 'eager';
                }
            }
            if (isCustomElement(clone)) {
                return this.createCustomElementClone(clone);
            }
            return clone;
        };
        DocumentCloner.prototype.createCustomElementClone = function (node) {
            var clone = document.createElement('html2canvascustomelement');
            copyCSSStyles(node.style, clone);
            return clone;
        };
        DocumentCloner.prototype.createStyleClone = function (node) {
            try {
                var sheet = node.sheet;
                if (sheet && sheet.cssRules) {
                    var css = [].slice.call(sheet.cssRules, 0).reduce(function (css, rule) {
                        if (rule && typeof rule.cssText === 'string') {
                            return css + rule.cssText;
                        }
                        return css;
                    }, '');
                    var style = node.cloneNode(false);
                    style.textContent = css;
                    return style;
                }
            }
            catch (e) {
                // accessing node.sheet.cssRules throws a DOMException
                this.context.logger.error('Unable to access cssRules property', e);
                if (e.name !== 'SecurityError') {
                    throw e;
                }
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.createCanvasClone = function (canvas) {
            var _a;
            if (this.options.inlineImages && canvas.ownerDocument) {
                var img = canvas.ownerDocument.createElement('img');
                try {
                    img.src = canvas.toDataURL();
                    return img;
                }
                catch (e) {
                    this.context.logger.info("Unable to inline canvas contents, canvas is tainted", canvas);
                }
            }
            var clonedCanvas = canvas.cloneNode(false);
            try {
                clonedCanvas.width = canvas.width;
                clonedCanvas.height = canvas.height;
                var ctx = canvas.getContext('2d');
                var clonedCtx = clonedCanvas.getContext('2d');
                if (clonedCtx) {
                    if (!this.options.allowTaint && ctx) {
                        clonedCtx.putImageData(ctx.getImageData(0, 0, canvas.width, canvas.height), 0, 0);
                    }
                    else {
                        var gl = (_a = canvas.getContext('webgl2')) !== null && _a !== void 0 ? _a : canvas.getContext('webgl');
                        if (gl) {
                            var attribs = gl.getContextAttributes();
                            if ((attribs === null || attribs === void 0 ? void 0 : attribs.preserveDrawingBuffer) === false) {
                                this.context.logger.warn('Unable to clone WebGL context as it has preserveDrawingBuffer=false', canvas);
                            }
                        }
                        clonedCtx.drawImage(canvas, 0, 0);
                    }
                }
                return clonedCanvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone canvas as it is tainted", canvas);
            }
            return clonedCanvas;
        };
        DocumentCloner.prototype.createVideoClone = function (video) {
            var canvas = video.ownerDocument.createElement('canvas');
            canvas.width = video.offsetWidth;
            canvas.height = video.offsetHeight;
            var ctx = canvas.getContext('2d');
            try {
                if (ctx) {
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    if (!this.options.allowTaint) {
                        ctx.getImageData(0, 0, canvas.width, canvas.height);
                    }
                }
                return canvas;
            }
            catch (e) {
                this.context.logger.info("Unable to clone video as it is tainted", video);
            }
            var blankCanvas = video.ownerDocument.createElement('canvas');
            blankCanvas.width = video.offsetWidth;
            blankCanvas.height = video.offsetHeight;
            return blankCanvas;
        };
        DocumentCloner.prototype.appendChildNode = function (clone, child, copyStyles) {
            if (!isElementNode(child) ||
                (!isScriptElement(child) &&
                    !child.hasAttribute(IGNORE_ATTRIBUTE) &&
                    (typeof this.options.ignoreElements !== 'function' || !this.options.ignoreElements(child)))) {
                if (!this.options.copyStyles || !isElementNode(child) || !isStyleElement(child)) {
                    clone.appendChild(this.cloneNode(child, copyStyles));
                }
            }
        };
        DocumentCloner.prototype.cloneChildNodes = function (node, clone, copyStyles) {
            var _this = this;
            for (var child = node.shadowRoot ? node.shadowRoot.firstChild : node.firstChild; child; child = child.nextSibling) {
                if (isElementNode(child) && isSlotElement(child) && typeof child.assignedNodes === 'function') {
                    var assignedNodes = child.assignedNodes();
                    if (assignedNodes.length) {
                        assignedNodes.forEach(function (assignedNode) { return _this.appendChildNode(clone, assignedNode, copyStyles); });
                    }
                }
                else {
                    this.appendChildNode(clone, child, copyStyles);
                }
            }
        };
        DocumentCloner.prototype.cloneNode = function (node, copyStyles) {
            if (isTextNode(node)) {
                return document.createTextNode(node.data);
            }
            if (!node.ownerDocument) {
                return node.cloneNode(false);
            }
            var window = node.ownerDocument.defaultView;
            if (window && isElementNode(node) && (isHTMLElementNode(node) || isSVGElementNode(node))) {
                var clone = this.createElementClone(node);
                clone.style.transitionProperty = 'none';
                var style = window.getComputedStyle(node);
                var styleBefore = window.getComputedStyle(node, ':before');
                var styleAfter = window.getComputedStyle(node, ':after');
                if (this.referenceElement === node && isHTMLElementNode(clone)) {
                    this.clonedReferenceElement = clone;
                }
                if (isBodyElement(clone)) {
                    createPseudoHideStyles(clone);
                }
                var counters = this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
                var before = this.resolvePseudoContent(node, clone, styleBefore, PseudoElementType.BEFORE);
                if (isCustomElement(node)) {
                    copyStyles = true;
                }
                if (!isVideoElement(node)) {
                    this.cloneChildNodes(node, clone, copyStyles);
                }
                if (before) {
                    clone.insertBefore(before, clone.firstChild);
                }
                var after = this.resolvePseudoContent(node, clone, styleAfter, PseudoElementType.AFTER);
                if (after) {
                    clone.appendChild(after);
                }
                this.counters.pop(counters);
                if ((style && (this.options.copyStyles || isSVGElementNode(node)) && !isIFrameElement(node)) ||
                    copyStyles) {
                    copyCSSStyles(style, clone);
                }
                if (node.scrollTop !== 0 || node.scrollLeft !== 0) {
                    this.scrolledElements.push([clone, node.scrollLeft, node.scrollTop]);
                }
                if ((isTextareaElement(node) || isSelectElement(node)) &&
                    (isTextareaElement(clone) || isSelectElement(clone))) {
                    clone.value = node.value;
                }
                return clone;
            }
            return node.cloneNode(false);
        };
        DocumentCloner.prototype.resolvePseudoContent = function (node, clone, style, pseudoElt) {
            var _this = this;
            if (!style) {
                return;
            }
            var value = style.content;
            var document = clone.ownerDocument;
            if (!document || !value || value === 'none' || value === '-moz-alt-content' || style.display === 'none') {
                return;
            }
            this.counters.parse(new CSSParsedCounterDeclaration(this.context, style));
            var declaration = new CSSParsedPseudoDeclaration(this.context, style);
            var anonymousReplacedElement = document.createElement('html2canvaspseudoelement');
            copyCSSStyles(style, anonymousReplacedElement);
            declaration.content.forEach(function (token) {
                if (token.type === 0 /* STRING_TOKEN */) {
                    anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                }
                else if (token.type === 22 /* URL_TOKEN */) {
                    var img = document.createElement('img');
                    img.src = token.value;
                    img.style.opacity = '1';
                    anonymousReplacedElement.appendChild(img);
                }
                else if (token.type === 18 /* FUNCTION */) {
                    if (token.name === 'attr') {
                        var attr = token.values.filter(isIdentToken);
                        if (attr.length) {
                            anonymousReplacedElement.appendChild(document.createTextNode(node.getAttribute(attr[0].value) || ''));
                        }
                    }
                    else if (token.name === 'counter') {
                        var _a = token.values.filter(nonFunctionArgSeparator), counter = _a[0], counterStyle = _a[1];
                        if (counter && isIdentToken(counter)) {
                            var counterState = _this.counters.getCounterValue(counter.value);
                            var counterType = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            anonymousReplacedElement.appendChild(document.createTextNode(createCounterText(counterState, counterType, false)));
                        }
                    }
                    else if (token.name === 'counters') {
                        var _b = token.values.filter(nonFunctionArgSeparator), counter = _b[0], delim = _b[1], counterStyle = _b[2];
                        if (counter && isIdentToken(counter)) {
                            var counterStates = _this.counters.getCounterValues(counter.value);
                            var counterType_1 = counterStyle && isIdentToken(counterStyle)
                                ? listStyleType.parse(_this.context, counterStyle.value)
                                : 3 /* DECIMAL */;
                            var separator = delim && delim.type === 0 /* STRING_TOKEN */ ? delim.value : '';
                            var text = counterStates
                                .map(function (value) { return createCounterText(value, counterType_1, false); })
                                .join(separator);
                            anonymousReplacedElement.appendChild(document.createTextNode(text));
                        }
                    }
                    else ;
                }
                else if (token.type === 20 /* IDENT_TOKEN */) {
                    switch (token.value) {
                        case 'open-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, _this.quoteDepth++, true)));
                            break;
                        case 'close-quote':
                            anonymousReplacedElement.appendChild(document.createTextNode(getQuote(declaration.quotes, --_this.quoteDepth, false)));
                            break;
                        default:
                            // safari doesn't parse string tokens correctly because of lack of quotes
                            anonymousReplacedElement.appendChild(document.createTextNode(token.value));
                    }
                }
            });
            anonymousReplacedElement.className = PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            var newClassName = pseudoElt === PseudoElementType.BEFORE
                ? " " + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE
                : " " + PSEUDO_HIDE_ELEMENT_CLASS_AFTER;
            if (isSVGElementNode(clone)) {
                clone.className.baseValue += newClassName;
            }
            else {
                clone.className += newClassName;
            }
            return anonymousReplacedElement;
        };
        DocumentCloner.destroy = function (container) {
            if (container.parentNode) {
                container.parentNode.removeChild(container);
                return true;
            }
            return false;
        };
        return DocumentCloner;
    }());
    var PseudoElementType;
    (function (PseudoElementType) {
        PseudoElementType[PseudoElementType["BEFORE"] = 0] = "BEFORE";
        PseudoElementType[PseudoElementType["AFTER"] = 1] = "AFTER";
    })(PseudoElementType || (PseudoElementType = {}));
    var createIFrameContainer = function (ownerDocument, bounds) {
        var cloneIframeContainer = ownerDocument.createElement('iframe');
        cloneIframeContainer.className = 'html2canvas-container';
        cloneIframeContainer.style.visibility = 'hidden';
        cloneIframeContainer.style.position = 'fixed';
        cloneIframeContainer.style.left = '-10000px';
        cloneIframeContainer.style.top = '0px';
        cloneIframeContainer.style.border = '0';
        cloneIframeContainer.width = bounds.width.toString();
        cloneIframeContainer.height = bounds.height.toString();
        cloneIframeContainer.scrolling = 'no'; // ios won't scroll without it
        cloneIframeContainer.setAttribute(IGNORE_ATTRIBUTE, 'true');
        ownerDocument.body.appendChild(cloneIframeContainer);
        return cloneIframeContainer;
    };
    var imageReady = function (img) {
        return new Promise(function (resolve) {
            if (img.complete) {
                resolve();
                return;
            }
            if (!img.src) {
                resolve();
                return;
            }
            img.onload = resolve;
            img.onerror = resolve;
        });
    };
    var imagesReady = function (document) {
        return Promise.all([].slice.call(document.images, 0).map(imageReady));
    };
    var iframeLoader = function (iframe) {
        return new Promise(function (resolve, reject) {
            var cloneWindow = iframe.contentWindow;
            if (!cloneWindow) {
                return reject("No window assigned for iframe");
            }
            var documentClone = cloneWindow.document;
            cloneWindow.onload = iframe.onload = function () {
                cloneWindow.onload = iframe.onload = null;
                var interval = setInterval(function () {
                    if (documentClone.body.childNodes.length > 0 && documentClone.readyState === 'complete') {
                        clearInterval(interval);
                        resolve(iframe);
                    }
                }, 50);
            };
        });
    };
    var ignoredStyleProperties = [
        'all',
        'd',
        'content' // Safari shows pseudoelements if content is set
    ];
    var copyCSSStyles = function (style, target) {
        // Edge does not provide value for cssText
        for (var i = style.length - 1; i >= 0; i--) {
            var property = style.item(i);
            if (ignoredStyleProperties.indexOf(property) === -1) {
                target.style.setProperty(property, style.getPropertyValue(property));
            }
        }
        return target;
    };
    var serializeDoctype = function (doctype) {
        var str = '';
        if (doctype) {
            str += '<!DOCTYPE ';
            if (doctype.name) {
                str += doctype.name;
            }
            if (doctype.internalSubset) {
                str += doctype.internalSubset;
            }
            if (doctype.publicId) {
                str += "\"" + doctype.publicId + "\"";
            }
            if (doctype.systemId) {
                str += "\"" + doctype.systemId + "\"";
            }
            str += '>';
        }
        return str;
    };
    var restoreOwnerScroll = function (ownerDocument, x, y) {
        if (ownerDocument &&
            ownerDocument.defaultView &&
            (x !== ownerDocument.defaultView.pageXOffset || y !== ownerDocument.defaultView.pageYOffset)) {
            ownerDocument.defaultView.scrollTo(x, y);
        }
    };
    var restoreNodeScroll = function (_a) {
        var element = _a[0], x = _a[1], y = _a[2];
        element.scrollLeft = x;
        element.scrollTop = y;
    };
    var PSEUDO_BEFORE = ':before';
    var PSEUDO_AFTER = ':after';
    var PSEUDO_HIDE_ELEMENT_CLASS_BEFORE = '___html2canvas___pseudoelement_before';
    var PSEUDO_HIDE_ELEMENT_CLASS_AFTER = '___html2canvas___pseudoelement_after';
    var PSEUDO_HIDE_ELEMENT_STYLE = "{\n    content: \"\" !important;\n    display: none !important;\n}";
    var createPseudoHideStyles = function (body) {
        createStyles(body, "." + PSEUDO_HIDE_ELEMENT_CLASS_BEFORE + PSEUDO_BEFORE + PSEUDO_HIDE_ELEMENT_STYLE + "\n         ." + PSEUDO_HIDE_ELEMENT_CLASS_AFTER + PSEUDO_AFTER + PSEUDO_HIDE_ELEMENT_STYLE);
    };
    var createStyles = function (body, styles) {
        var document = body.ownerDocument;
        if (document) {
            var style = document.createElement('style');
            style.textContent = styles;
            body.appendChild(style);
        }
    };

    var CacheStorage = /** @class */ (function () {
        function CacheStorage() {
        }
        CacheStorage.getOrigin = function (url) {
            var link = CacheStorage._link;
            if (!link) {
                return 'about:blank';
            }
            link.href = url;
            link.href = link.href; // IE9, LOL! - http://jsfiddle.net/niklasvh/2e48b/
            return link.protocol + link.hostname + link.port;
        };
        CacheStorage.isSameOrigin = function (src) {
            return CacheStorage.getOrigin(src) === CacheStorage._origin;
        };
        CacheStorage.setContext = function (window) {
            CacheStorage._link = window.document.createElement('a');
            CacheStorage._origin = CacheStorage.getOrigin(window.location.href);
        };
        CacheStorage._origin = 'about:blank';
        return CacheStorage;
    }());
    var Cache = /** @class */ (function () {
        function Cache(context, _options) {
            this.context = context;
            this._options = _options;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this._cache = {};
        }
        Cache.prototype.addImage = function (src) {
            var result = Promise.resolve();
            if (this.has(src)) {
                return result;
            }
            if (isBlobImage(src) || isRenderable(src)) {
                (this._cache[src] = this.loadImage(src)).catch(function () {
                    // prevent unhandled rejection
                });
                return result;
            }
            return result;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Cache.prototype.match = function (src) {
            return this._cache[src];
        };
        Cache.prototype.loadImage = function (key) {
            return __awaiter(this, void 0, void 0, function () {
                var isSameOrigin, useCORS, useProxy, src;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            isSameOrigin = CacheStorage.isSameOrigin(key);
                            useCORS = !isInlineImage(key) && this._options.useCORS === true && FEATURES.SUPPORT_CORS_IMAGES && !isSameOrigin;
                            useProxy = !isInlineImage(key) &&
                                !isSameOrigin &&
                                !isBlobImage(key) &&
                                typeof this._options.proxy === 'string' &&
                                FEATURES.SUPPORT_CORS_XHR &&
                                !useCORS;
                            if (!isSameOrigin &&
                                this._options.allowTaint === false &&
                                !isInlineImage(key) &&
                                !isBlobImage(key) &&
                                !useProxy &&
                                !useCORS) {
                                return [2 /*return*/];
                            }
                            src = key;
                            if (!useProxy) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.proxy(src)];
                        case 1:
                            src = _a.sent();
                            _a.label = 2;
                        case 2:
                            this.context.logger.debug("Added image " + key.substring(0, 256));
                            return [4 /*yield*/, new Promise(function (resolve, reject) {
                                    var img = new Image();
                                    img.onload = function () { return resolve(img); };
                                    img.onerror = reject;
                                    //ios safari 10.3 taints canvas with data urls unless crossOrigin is set to anonymous
                                    if (isInlineBase64Image(src) || useCORS) {
                                        img.crossOrigin = 'anonymous';
                                    }
                                    img.src = src;
                                    if (img.complete === true) {
                                        // Inline XML images may fail to parse, throwing an Error later on
                                        setTimeout(function () { return resolve(img); }, 500);
                                    }
                                    if (_this._options.imageTimeout > 0) {
                                        setTimeout(function () { return reject("Timed out (" + _this._options.imageTimeout + "ms) loading image"); }, _this._options.imageTimeout);
                                    }
                                })];
                        case 3: return [2 /*return*/, _a.sent()];
                    }
                });
            });
        };
        Cache.prototype.has = function (key) {
            return typeof this._cache[key] !== 'undefined';
        };
        Cache.prototype.keys = function () {
            return Promise.resolve(Object.keys(this._cache));
        };
        Cache.prototype.proxy = function (src) {
            var _this = this;
            var proxy = this._options.proxy;
            if (!proxy) {
                throw new Error('No proxy defined');
            }
            var key = src.substring(0, 256);
            return new Promise(function (resolve, reject) {
                var responseType = FEATURES.SUPPORT_RESPONSE_TYPE ? 'blob' : 'text';
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        if (responseType === 'text') {
                            resolve(xhr.response);
                        }
                        else {
                            var reader_1 = new FileReader();
                            reader_1.addEventListener('load', function () { return resolve(reader_1.result); }, false);
                            reader_1.addEventListener('error', function (e) { return reject(e); }, false);
                            reader_1.readAsDataURL(xhr.response);
                        }
                    }
                    else {
                        reject("Failed to proxy resource " + key + " with status code " + xhr.status);
                    }
                };
                xhr.onerror = reject;
                var queryString = proxy.indexOf('?') > -1 ? '&' : '?';
                xhr.open('GET', "" + proxy + queryString + "url=" + encodeURIComponent(src) + "&responseType=" + responseType);
                if (responseType !== 'text' && xhr instanceof XMLHttpRequest) {
                    xhr.responseType = responseType;
                }
                if (_this._options.imageTimeout) {
                    var timeout_1 = _this._options.imageTimeout;
                    xhr.timeout = timeout_1;
                    xhr.ontimeout = function () { return reject("Timed out (" + timeout_1 + "ms) proxying " + key); };
                }
                xhr.send();
            });
        };
        return Cache;
    }());
    var INLINE_SVG = /^data:image\/svg\+xml/i;
    var INLINE_BASE64 = /^data:image\/.*;base64,/i;
    var INLINE_IMG = /^data:image\/.*/i;
    var isRenderable = function (src) { return FEATURES.SUPPORT_SVG_DRAWING || !isSVG(src); };
    var isInlineImage = function (src) { return INLINE_IMG.test(src); };
    var isInlineBase64Image = function (src) { return INLINE_BASE64.test(src); };
    var isBlobImage = function (src) { return src.substr(0, 4) === 'blob'; };
    var isSVG = function (src) { return src.substr(-3).toLowerCase() === 'svg' || INLINE_SVG.test(src); };

    var Vector = /** @class */ (function () {
        function Vector(x, y) {
            this.type = 0 /* VECTOR */;
            this.x = x;
            this.y = y;
        }
        Vector.prototype.add = function (deltaX, deltaY) {
            return new Vector(this.x + deltaX, this.y + deltaY);
        };
        return Vector;
    }());

    var lerp = function (a, b, t) {
        return new Vector(a.x + (b.x - a.x) * t, a.y + (b.y - a.y) * t);
    };
    var BezierCurve = /** @class */ (function () {
        function BezierCurve(start, startControl, endControl, end) {
            this.type = 1 /* BEZIER_CURVE */;
            this.start = start;
            this.startControl = startControl;
            this.endControl = endControl;
            this.end = end;
        }
        BezierCurve.prototype.subdivide = function (t, firstHalf) {
            var ab = lerp(this.start, this.startControl, t);
            var bc = lerp(this.startControl, this.endControl, t);
            var cd = lerp(this.endControl, this.end, t);
            var abbc = lerp(ab, bc, t);
            var bccd = lerp(bc, cd, t);
            var dest = lerp(abbc, bccd, t);
            return firstHalf ? new BezierCurve(this.start, ab, abbc, dest) : new BezierCurve(dest, bccd, cd, this.end);
        };
        BezierCurve.prototype.add = function (deltaX, deltaY) {
            return new BezierCurve(this.start.add(deltaX, deltaY), this.startControl.add(deltaX, deltaY), this.endControl.add(deltaX, deltaY), this.end.add(deltaX, deltaY));
        };
        BezierCurve.prototype.reverse = function () {
            return new BezierCurve(this.end, this.endControl, this.startControl, this.start);
        };
        return BezierCurve;
    }());
    var isBezierCurve = function (path) { return path.type === 1 /* BEZIER_CURVE */; };

    var BoundCurves = /** @class */ (function () {
        function BoundCurves(element) {
            var styles = element.styles;
            var bounds = element.bounds;
            var _a = getAbsoluteValueForTuple(styles.borderTopLeftRadius, bounds.width, bounds.height), tlh = _a[0], tlv = _a[1];
            var _b = getAbsoluteValueForTuple(styles.borderTopRightRadius, bounds.width, bounds.height), trh = _b[0], trv = _b[1];
            var _c = getAbsoluteValueForTuple(styles.borderBottomRightRadius, bounds.width, bounds.height), brh = _c[0], brv = _c[1];
            var _d = getAbsoluteValueForTuple(styles.borderBottomLeftRadius, bounds.width, bounds.height), blh = _d[0], blv = _d[1];
            var factors = [];
            factors.push((tlh + trh) / bounds.width);
            factors.push((blh + brh) / bounds.width);
            factors.push((tlv + blv) / bounds.height);
            factors.push((trv + brv) / bounds.height);
            var maxFactor = Math.max.apply(Math, factors);
            if (maxFactor > 1) {
                tlh /= maxFactor;
                tlv /= maxFactor;
                trh /= maxFactor;
                trv /= maxFactor;
                brh /= maxFactor;
                brv /= maxFactor;
                blh /= maxFactor;
                blv /= maxFactor;
            }
            var topWidth = bounds.width - trh;
            var rightHeight = bounds.height - brv;
            var bottomWidth = bounds.width - brh;
            var leftHeight = bounds.height - blv;
            var borderTopWidth = styles.borderTopWidth;
            var borderRightWidth = styles.borderRightWidth;
            var borderBottomWidth = styles.borderBottomWidth;
            var borderLeftWidth = styles.borderLeftWidth;
            var paddingTop = getAbsoluteValue(styles.paddingTop, element.bounds.width);
            var paddingRight = getAbsoluteValue(styles.paddingRight, element.bounds.width);
            var paddingBottom = getAbsoluteValue(styles.paddingBottom, element.bounds.width);
            var paddingLeft = getAbsoluteValue(styles.paddingLeft, element.bounds.width);
            this.topLeftBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3, tlh - borderLeftWidth / 3, tlv - borderTopWidth / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + borderTopWidth / 3);
            this.topRightBorderDoubleOuterBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 3, trh - borderRightWidth / 3, trv - borderTopWidth / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + borderTopWidth / 3);
            this.bottomRightBorderDoubleOuterBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 3, brv - borderBottomWidth / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.bottomLeftBorderDoubleOuterBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 3, bounds.top + leftHeight, blh - borderLeftWidth / 3, blv - borderBottomWidth / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 3, bounds.top + bounds.height - borderBottomWidth / 3);
            this.topLeftBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3, tlh - (borderLeftWidth * 2) / 3, tlv - (borderTopWidth * 2) / 3, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.topRightBorderDoubleInnerBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + (borderTopWidth * 2) / 3, trh - (borderRightWidth * 2) / 3, trv - (borderTopWidth * 2) / 3, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + (borderTopWidth * 2) / 3);
            this.bottomRightBorderDoubleInnerBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - (borderRightWidth * 2) / 3, brv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.bottomLeftBorderDoubleInnerBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + leftHeight, blh - (borderLeftWidth * 2) / 3, blv - (borderBottomWidth * 2) / 3, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + (borderLeftWidth * 2) / 3, bounds.top + bounds.height - (borderBottomWidth * 2) / 3);
            this.topLeftBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2, tlh - borderLeftWidth / 2, tlv - borderTopWidth / 2, CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + borderTopWidth / 2);
            this.topRightBorderStroke =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top + borderTopWidth / 2, trh - borderRightWidth / 2, trv - borderTopWidth / 2, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + borderTopWidth / 2);
            this.bottomRightBorderStroke =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh - borderRightWidth / 2, brv - borderBottomWidth / 2, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.bottomLeftBorderStroke =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth / 2, bounds.top + leftHeight, blh - borderLeftWidth / 2, blv - borderBottomWidth / 2, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth / 2, bounds.top + bounds.height - borderBottomWidth / 2);
            this.topLeftBorderBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left, bounds.top, tlh, tlv, CORNER.TOP_LEFT)
                    : new Vector(bounds.left, bounds.top);
            this.topRightBorderBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + topWidth, bounds.top, trh, trv, CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top);
            this.bottomRightBorderBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + bottomWidth, bounds.top + rightHeight, brh, brv, CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width, bounds.top + bounds.height);
            this.bottomLeftBorderBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left, bounds.top + leftHeight, blh, blv, CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left, bounds.top + bounds.height);
            this.topLeftPaddingBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + borderTopWidth, Math.max(0, tlh - borderLeftWidth), Math.max(0, tlv - borderTopWidth), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + borderTopWidth);
            this.topRightPaddingBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width - borderRightWidth), bounds.top + borderTopWidth, topWidth > bounds.width + borderRightWidth ? 0 : Math.max(0, trh - borderRightWidth), Math.max(0, trv - borderTopWidth), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + borderTopWidth);
            this.bottomRightPaddingBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - borderLeftWidth), bounds.top + Math.min(rightHeight, bounds.height - borderBottomWidth), Math.max(0, brh - borderRightWidth), Math.max(0, brv - borderBottomWidth), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - borderRightWidth, bounds.top + bounds.height - borderBottomWidth);
            this.bottomLeftPaddingBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth, bounds.top + Math.min(leftHeight, bounds.height - borderBottomWidth), Math.max(0, blh - borderLeftWidth), Math.max(0, blv - borderBottomWidth), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth, bounds.top + bounds.height - borderBottomWidth);
            this.topLeftContentBox =
                tlh > 0 || tlv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop, Math.max(0, tlh - (borderLeftWidth + paddingLeft)), Math.max(0, tlv - (borderTopWidth + paddingTop)), CORNER.TOP_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + borderTopWidth + paddingTop);
            this.topRightContentBox =
                trh > 0 || trv > 0
                    ? getCurvePoints(bounds.left + Math.min(topWidth, bounds.width + borderLeftWidth + paddingLeft), bounds.top + borderTopWidth + paddingTop, topWidth > bounds.width + borderLeftWidth + paddingLeft ? 0 : trh - borderLeftWidth + paddingLeft, trv - (borderTopWidth + paddingTop), CORNER.TOP_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + borderTopWidth + paddingTop);
            this.bottomRightContentBox =
                brh > 0 || brv > 0
                    ? getCurvePoints(bounds.left + Math.min(bottomWidth, bounds.width - (borderLeftWidth + paddingLeft)), bounds.top + Math.min(rightHeight, bounds.height + borderTopWidth + paddingTop), Math.max(0, brh - (borderRightWidth + paddingRight)), brv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_RIGHT)
                    : new Vector(bounds.left + bounds.width - (borderRightWidth + paddingRight), bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
            this.bottomLeftContentBox =
                blh > 0 || blv > 0
                    ? getCurvePoints(bounds.left + borderLeftWidth + paddingLeft, bounds.top + leftHeight, Math.max(0, blh - (borderLeftWidth + paddingLeft)), blv - (borderBottomWidth + paddingBottom), CORNER.BOTTOM_LEFT)
                    : new Vector(bounds.left + borderLeftWidth + paddingLeft, bounds.top + bounds.height - (borderBottomWidth + paddingBottom));
        }
        return BoundCurves;
    }());
    var CORNER;
    (function (CORNER) {
        CORNER[CORNER["TOP_LEFT"] = 0] = "TOP_LEFT";
        CORNER[CORNER["TOP_RIGHT"] = 1] = "TOP_RIGHT";
        CORNER[CORNER["BOTTOM_RIGHT"] = 2] = "BOTTOM_RIGHT";
        CORNER[CORNER["BOTTOM_LEFT"] = 3] = "BOTTOM_LEFT";
    })(CORNER || (CORNER = {}));
    var getCurvePoints = function (x, y, r1, r2, position) {
        var kappa = 4 * ((Math.sqrt(2) - 1) / 3);
        var ox = r1 * kappa; // control point offset horizontal
        var oy = r2 * kappa; // control point offset vertical
        var xm = x + r1; // x-middle
        var ym = y + r2; // y-middle
        switch (position) {
            case CORNER.TOP_LEFT:
                return new BezierCurve(new Vector(x, ym), new Vector(x, ym - oy), new Vector(xm - ox, y), new Vector(xm, y));
            case CORNER.TOP_RIGHT:
                return new BezierCurve(new Vector(x, y), new Vector(x + ox, y), new Vector(xm, ym - oy), new Vector(xm, ym));
            case CORNER.BOTTOM_RIGHT:
                return new BezierCurve(new Vector(xm, y), new Vector(xm, y + oy), new Vector(x + ox, ym), new Vector(x, ym));
            case CORNER.BOTTOM_LEFT:
            default:
                return new BezierCurve(new Vector(xm, ym), new Vector(xm - ox, ym), new Vector(x, y + oy), new Vector(x, y));
        }
    };
    var calculateBorderBoxPath = function (curves) {
        return [curves.topLeftBorderBox, curves.topRightBorderBox, curves.bottomRightBorderBox, curves.bottomLeftBorderBox];
    };
    var calculateContentBoxPath = function (curves) {
        return [
            curves.topLeftContentBox,
            curves.topRightContentBox,
            curves.bottomRightContentBox,
            curves.bottomLeftContentBox
        ];
    };
    var calculatePaddingBoxPath = function (curves) {
        return [
            curves.topLeftPaddingBox,
            curves.topRightPaddingBox,
            curves.bottomRightPaddingBox,
            curves.bottomLeftPaddingBox
        ];
    };

    var TransformEffect = /** @class */ (function () {
        function TransformEffect(offsetX, offsetY, matrix) {
            this.offsetX = offsetX;
            this.offsetY = offsetY;
            this.matrix = matrix;
            this.type = 0 /* TRANSFORM */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return TransformEffect;
    }());
    var ClipEffect = /** @class */ (function () {
        function ClipEffect(path, target) {
            this.path = path;
            this.target = target;
            this.type = 1 /* CLIP */;
        }
        return ClipEffect;
    }());
    var OpacityEffect = /** @class */ (function () {
        function OpacityEffect(opacity) {
            this.opacity = opacity;
            this.type = 2 /* OPACITY */;
            this.target = 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */;
        }
        return OpacityEffect;
    }());
    var isTransformEffect = function (effect) {
        return effect.type === 0 /* TRANSFORM */;
    };
    var isClipEffect = function (effect) { return effect.type === 1 /* CLIP */; };
    var isOpacityEffect = function (effect) { return effect.type === 2 /* OPACITY */; };

    var equalPath = function (a, b) {
        if (a.length === b.length) {
            return a.some(function (v, i) { return v === b[i]; });
        }
        return false;
    };
    var transformPath = function (path, deltaX, deltaY, deltaW, deltaH) {
        return path.map(function (point, index) {
            switch (index) {
                case 0:
                    return point.add(deltaX, deltaY);
                case 1:
                    return point.add(deltaX + deltaW, deltaY);
                case 2:
                    return point.add(deltaX + deltaW, deltaY + deltaH);
                case 3:
                    return point.add(deltaX, deltaY + deltaH);
            }
            return point;
        });
    };

    var StackingContext = /** @class */ (function () {
        function StackingContext(container) {
            this.element = container;
            this.inlineLevel = [];
            this.nonInlineLevel = [];
            this.negativeZIndex = [];
            this.zeroOrAutoZIndexOrTransformedOrOpacity = [];
            this.positiveZIndex = [];
            this.nonPositionedFloats = [];
            this.nonPositionedInlineLevel = [];
        }
        return StackingContext;
    }());
    var ElementPaint = /** @class */ (function () {
        function ElementPaint(container, parent) {
            this.container = container;
            this.parent = parent;
            this.effects = [];
            this.curves = new BoundCurves(this.container);
            if (this.container.styles.opacity < 1) {
                this.effects.push(new OpacityEffect(this.container.styles.opacity));
            }
            if (this.container.styles.transform !== null) {
                var offsetX = this.container.bounds.left + this.container.styles.transformOrigin[0].number;
                var offsetY = this.container.bounds.top + this.container.styles.transformOrigin[1].number;
                var matrix = this.container.styles.transform;
                this.effects.push(new TransformEffect(offsetX, offsetY, matrix));
            }
            if (this.container.styles.overflowX !== 0 /* VISIBLE */) {
                var borderBox = calculateBorderBoxPath(this.curves);
                var paddingBox = calculatePaddingBoxPath(this.curves);
                if (equalPath(borderBox, paddingBox)) {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                }
                else {
                    this.effects.push(new ClipEffect(borderBox, 2 /* BACKGROUND_BORDERS */));
                    this.effects.push(new ClipEffect(paddingBox, 4 /* CONTENT */));
                }
            }
        }
        ElementPaint.prototype.getEffects = function (target) {
            var inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(this.container.styles.position) === -1;
            var parent = this.parent;
            var effects = this.effects.slice(0);
            while (parent) {
                var croplessEffects = parent.effects.filter(function (effect) { return !isClipEffect(effect); });
                if (inFlow || parent.container.styles.position !== 0 /* STATIC */ || !parent.parent) {
                    effects.unshift.apply(effects, croplessEffects);
                    inFlow = [2 /* ABSOLUTE */, 3 /* FIXED */].indexOf(parent.container.styles.position) === -1;
                    if (parent.container.styles.overflowX !== 0 /* VISIBLE */) {
                        var borderBox = calculateBorderBoxPath(parent.curves);
                        var paddingBox = calculatePaddingBoxPath(parent.curves);
                        if (!equalPath(borderBox, paddingBox)) {
                            effects.unshift(new ClipEffect(paddingBox, 2 /* BACKGROUND_BORDERS */ | 4 /* CONTENT */));
                        }
                    }
                }
                else {
                    effects.unshift.apply(effects, croplessEffects);
                }
                parent = parent.parent;
            }
            return effects.filter(function (effect) { return contains(effect.target, target); });
        };
        return ElementPaint;
    }());
    var parseStackTree = function (parent, stackingContext, realStackingContext, listItems) {
        parent.container.elements.forEach(function (child) {
            var treatAsRealStackingContext = contains(child.flags, 4 /* CREATES_REAL_STACKING_CONTEXT */);
            var createsStackingContext = contains(child.flags, 2 /* CREATES_STACKING_CONTEXT */);
            var paintContainer = new ElementPaint(child, parent);
            if (contains(child.styles.display, 2048 /* LIST_ITEM */)) {
                listItems.push(paintContainer);
            }
            var listOwnerItems = contains(child.flags, 8 /* IS_LIST_OWNER */) ? [] : listItems;
            if (treatAsRealStackingContext || createsStackingContext) {
                var parentStack = treatAsRealStackingContext || child.styles.isPositioned() ? realStackingContext : stackingContext;
                var stack = new StackingContext(paintContainer);
                if (child.styles.isPositioned() || child.styles.opacity < 1 || child.styles.isTransformed()) {
                    var order_1 = child.styles.zIndex.order;
                    if (order_1 < 0) {
                        var index_1 = 0;
                        parentStack.negativeZIndex.some(function (current, i) {
                            if (order_1 > current.element.container.styles.zIndex.order) {
                                index_1 = i;
                                return false;
                            }
                            else if (index_1 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.negativeZIndex.splice(index_1, 0, stack);
                    }
                    else if (order_1 > 0) {
                        var index_2 = 0;
                        parentStack.positiveZIndex.some(function (current, i) {
                            if (order_1 >= current.element.container.styles.zIndex.order) {
                                index_2 = i + 1;
                                return false;
                            }
                            else if (index_2 > 0) {
                                return true;
                            }
                            return false;
                        });
                        parentStack.positiveZIndex.splice(index_2, 0, stack);
                    }
                    else {
                        parentStack.zeroOrAutoZIndexOrTransformedOrOpacity.push(stack);
                    }
                }
                else {
                    if (child.styles.isFloating()) {
                        parentStack.nonPositionedFloats.push(stack);
                    }
                    else {
                        parentStack.nonPositionedInlineLevel.push(stack);
                    }
                }
                parseStackTree(paintContainer, stack, treatAsRealStackingContext ? stack : realStackingContext, listOwnerItems);
            }
            else {
                if (child.styles.isInlineLevel()) {
                    stackingContext.inlineLevel.push(paintContainer);
                }
                else {
                    stackingContext.nonInlineLevel.push(paintContainer);
                }
                parseStackTree(paintContainer, stackingContext, realStackingContext, listOwnerItems);
            }
            if (contains(child.flags, 8 /* IS_LIST_OWNER */)) {
                processListItems(child, listOwnerItems);
            }
        });
    };
    var processListItems = function (owner, elements) {
        var numbering = owner instanceof OLElementContainer ? owner.start : 1;
        var reversed = owner instanceof OLElementContainer ? owner.reversed : false;
        for (var i = 0; i < elements.length; i++) {
            var item = elements[i];
            if (item.container instanceof LIElementContainer &&
                typeof item.container.value === 'number' &&
                item.container.value !== 0) {
                numbering = item.container.value;
            }
            item.listValue = createCounterText(numbering, item.container.styles.listStyleType, true);
            numbering += reversed ? -1 : 1;
        }
    };
    var parseStackingContexts = function (container) {
        var paintContainer = new ElementPaint(container, null);
        var root = new StackingContext(paintContainer);
        var listItems = [];
        parseStackTree(paintContainer, root, root, listItems);
        processListItems(paintContainer.container, listItems);
        return root;
    };

    var parsePathForBorder = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftPaddingBox, curves.topRightBorderBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightPaddingBox, curves.bottomRightBorderBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftPaddingBox, curves.topLeftBorderBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderDoubleOuter = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox, curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderBox, curves.topRightBorderDoubleOuterBox, curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderBox, curves.bottomRightBorderDoubleOuterBox, curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderBox, curves.bottomLeftBorderDoubleOuterBox, curves.topLeftBorderBox, curves.topLeftBorderDoubleOuterBox);
        }
    };
    var parsePathForBorderDoubleInner = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createPathFromCurves(curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox, curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox);
            case 1:
                return createPathFromCurves(curves.topRightBorderDoubleInnerBox, curves.topRightPaddingBox, curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox);
            case 2:
                return createPathFromCurves(curves.bottomRightBorderDoubleInnerBox, curves.bottomRightPaddingBox, curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox);
            case 3:
            default:
                return createPathFromCurves(curves.bottomLeftBorderDoubleInnerBox, curves.bottomLeftPaddingBox, curves.topLeftBorderDoubleInnerBox, curves.topLeftPaddingBox);
        }
    };
    var parsePathForBorderStroke = function (curves, borderSide) {
        switch (borderSide) {
            case 0:
                return createStrokePathFromCurves(curves.topLeftBorderStroke, curves.topRightBorderStroke);
            case 1:
                return createStrokePathFromCurves(curves.topRightBorderStroke, curves.bottomRightBorderStroke);
            case 2:
                return createStrokePathFromCurves(curves.bottomRightBorderStroke, curves.bottomLeftBorderStroke);
            case 3:
            default:
                return createStrokePathFromCurves(curves.bottomLeftBorderStroke, curves.topLeftBorderStroke);
        }
    };
    var createStrokePathFromCurves = function (outer1, outer2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        return path;
    };
    var createPathFromCurves = function (outer1, inner1, outer2, inner2) {
        var path = [];
        if (isBezierCurve(outer1)) {
            path.push(outer1.subdivide(0.5, false));
        }
        else {
            path.push(outer1);
        }
        if (isBezierCurve(outer2)) {
            path.push(outer2.subdivide(0.5, true));
        }
        else {
            path.push(outer2);
        }
        if (isBezierCurve(inner2)) {
            path.push(inner2.subdivide(0.5, true).reverse());
        }
        else {
            path.push(inner2);
        }
        if (isBezierCurve(inner1)) {
            path.push(inner1.subdivide(0.5, false).reverse());
        }
        else {
            path.push(inner1);
        }
        return path;
    };

    var paddingBox = function (element) {
        var bounds = element.bounds;
        var styles = element.styles;
        return bounds.add(styles.borderLeftWidth, styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth), -(styles.borderTopWidth + styles.borderBottomWidth));
    };
    var contentBox = function (element) {
        var styles = element.styles;
        var bounds = element.bounds;
        var paddingLeft = getAbsoluteValue(styles.paddingLeft, bounds.width);
        var paddingRight = getAbsoluteValue(styles.paddingRight, bounds.width);
        var paddingTop = getAbsoluteValue(styles.paddingTop, bounds.width);
        var paddingBottom = getAbsoluteValue(styles.paddingBottom, bounds.width);
        return bounds.add(paddingLeft + styles.borderLeftWidth, paddingTop + styles.borderTopWidth, -(styles.borderRightWidth + styles.borderLeftWidth + paddingLeft + paddingRight), -(styles.borderTopWidth + styles.borderBottomWidth + paddingTop + paddingBottom));
    };

    var calculateBackgroundPositioningArea = function (backgroundOrigin, element) {
        if (backgroundOrigin === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundOrigin === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundPaintingArea = function (backgroundClip, element) {
        if (backgroundClip === 0 /* BORDER_BOX */) {
            return element.bounds;
        }
        if (backgroundClip === 2 /* CONTENT_BOX */) {
            return contentBox(element);
        }
        return paddingBox(element);
    };
    var calculateBackgroundRendering = function (container, index, intrinsicSize) {
        var backgroundPositioningArea = calculateBackgroundPositioningArea(getBackgroundValueForIndex(container.styles.backgroundOrigin, index), container);
        var backgroundPaintingArea = calculateBackgroundPaintingArea(getBackgroundValueForIndex(container.styles.backgroundClip, index), container);
        var backgroundImageSize = calculateBackgroundSize(getBackgroundValueForIndex(container.styles.backgroundSize, index), intrinsicSize, backgroundPositioningArea);
        var sizeWidth = backgroundImageSize[0], sizeHeight = backgroundImageSize[1];
        var position = getAbsoluteValueForTuple(getBackgroundValueForIndex(container.styles.backgroundPosition, index), backgroundPositioningArea.width - sizeWidth, backgroundPositioningArea.height - sizeHeight);
        var path = calculateBackgroundRepeatPath(getBackgroundValueForIndex(container.styles.backgroundRepeat, index), position, backgroundImageSize, backgroundPositioningArea, backgroundPaintingArea);
        var offsetX = Math.round(backgroundPositioningArea.left + position[0]);
        var offsetY = Math.round(backgroundPositioningArea.top + position[1]);
        return [path, offsetX, offsetY, sizeWidth, sizeHeight];
    };
    var isAuto = function (token) { return isIdentToken(token) && token.value === BACKGROUND_SIZE.AUTO; };
    var hasIntrinsicValue = function (value) { return typeof value === 'number'; };
    var calculateBackgroundSize = function (size, _a, bounds) {
        var intrinsicWidth = _a[0], intrinsicHeight = _a[1], intrinsicProportion = _a[2];
        var first = size[0], second = size[1];
        if (!first) {
            return [0, 0];
        }
        if (isLengthPercentage(first) && second && isLengthPercentage(second)) {
            return [getAbsoluteValue(first, bounds.width), getAbsoluteValue(second, bounds.height)];
        }
        var hasIntrinsicProportion = hasIntrinsicValue(intrinsicProportion);
        if (isIdentToken(first) && (first.value === BACKGROUND_SIZE.CONTAIN || first.value === BACKGROUND_SIZE.COVER)) {
            if (hasIntrinsicValue(intrinsicProportion)) {
                var targetRatio = bounds.width / bounds.height;
                return targetRatio < intrinsicProportion !== (first.value === BACKGROUND_SIZE.COVER)
                    ? [bounds.width, bounds.width / intrinsicProportion]
                    : [bounds.height * intrinsicProportion, bounds.height];
            }
            return [bounds.width, bounds.height];
        }
        var hasIntrinsicWidth = hasIntrinsicValue(intrinsicWidth);
        var hasIntrinsicHeight = hasIntrinsicValue(intrinsicHeight);
        var hasIntrinsicDimensions = hasIntrinsicWidth || hasIntrinsicHeight;
        // If the background-size is auto or auto auto:
        if (isAuto(first) && (!second || isAuto(second))) {
            // If the image has both horizontal and vertical intrinsic dimensions, it's rendered at that size.
            if (hasIntrinsicWidth && hasIntrinsicHeight) {
                return [intrinsicWidth, intrinsicHeight];
            }
            // If the image has no intrinsic dimensions and has no intrinsic proportions,
            // it's rendered at the size of the background positioning area.
            if (!hasIntrinsicProportion && !hasIntrinsicDimensions) {
                return [bounds.width, bounds.height];
            }
            // TODO If the image has no intrinsic dimensions but has intrinsic proportions, it's rendered as if contain had been specified instead.
            // If the image has only one intrinsic dimension and has intrinsic proportions, it's rendered at the size corresponding to that one dimension.
            // The other dimension is computed using the specified dimension and the intrinsic proportions.
            if (hasIntrinsicDimensions && hasIntrinsicProportion) {
                var width_1 = hasIntrinsicWidth
                    ? intrinsicWidth
                    : intrinsicHeight * intrinsicProportion;
                var height_1 = hasIntrinsicHeight
                    ? intrinsicHeight
                    : intrinsicWidth / intrinsicProportion;
                return [width_1, height_1];
            }
            // If the image has only one intrinsic dimension but has no intrinsic proportions,
            // it's rendered using the specified dimension and the other dimension of the background positioning area.
            var width_2 = hasIntrinsicWidth ? intrinsicWidth : bounds.width;
            var height_2 = hasIntrinsicHeight ? intrinsicHeight : bounds.height;
            return [width_2, height_2];
        }
        // If the image has intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the specified dimension and the intrinsic proportions.
        if (hasIntrinsicProportion) {
            var width_3 = 0;
            var height_3 = 0;
            if (isLengthPercentage(first)) {
                width_3 = getAbsoluteValue(first, bounds.width);
            }
            else if (isLengthPercentage(second)) {
                height_3 = getAbsoluteValue(second, bounds.height);
            }
            if (isAuto(first)) {
                width_3 = height_3 * intrinsicProportion;
            }
            else if (!second || isAuto(second)) {
                height_3 = width_3 / intrinsicProportion;
            }
            return [width_3, height_3];
        }
        // If the image has no intrinsic proportions, it's stretched to the specified dimension.
        // The unspecified dimension is computed using the image's corresponding intrinsic dimension,
        // if there is one. If there is no such intrinsic dimension,
        // it becomes the corresponding dimension of the background positioning area.
        var width = null;
        var height = null;
        if (isLengthPercentage(first)) {
            width = getAbsoluteValue(first, bounds.width);
        }
        else if (second && isLengthPercentage(second)) {
            height = getAbsoluteValue(second, bounds.height);
        }
        if (width !== null && (!second || isAuto(second))) {
            height =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (width / intrinsicWidth) * intrinsicHeight
                    : bounds.height;
        }
        if (height !== null && isAuto(first)) {
            width =
                hasIntrinsicWidth && hasIntrinsicHeight
                    ? (height / intrinsicHeight) * intrinsicWidth
                    : bounds.width;
        }
        if (width !== null && height !== null) {
            return [width, height];
        }
        throw new Error("Unable to calculate background-size for element");
    };
    var getBackgroundValueForIndex = function (values, index) {
        var value = values[index];
        if (typeof value === 'undefined') {
            return values[0];
        }
        return value;
    };
    var calculateBackgroundRepeatPath = function (repeat, _a, _b, backgroundPositioningArea, backgroundPaintingArea) {
        var x = _a[0], y = _a[1];
        var width = _b[0], height = _b[1];
        switch (repeat) {
            case 2 /* REPEAT_X */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + backgroundPositioningArea.width), Math.round(height + backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left), Math.round(height + backgroundPositioningArea.top + y))
                ];
            case 3 /* REPEAT_Y */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.height + backgroundPositioningArea.top))
                ];
            case 1 /* NO_REPEAT */:
                return [
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y)),
                    new Vector(Math.round(backgroundPositioningArea.left + x + width), Math.round(backgroundPositioningArea.top + y + height)),
                    new Vector(Math.round(backgroundPositioningArea.left + x), Math.round(backgroundPositioningArea.top + y + height))
                ];
            default:
                return [
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left + backgroundPaintingArea.width), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top)),
                    new Vector(Math.round(backgroundPaintingArea.left), Math.round(backgroundPaintingArea.height + backgroundPaintingArea.top))
                ];
        }
    };

    var SMALL_IMAGE = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

    var SAMPLE_TEXT = 'Hidden Text';
    var FontMetrics = /** @class */ (function () {
        function FontMetrics(document) {
            this._data = {};
            this._document = document;
        }
        FontMetrics.prototype.parseMetrics = function (fontFamily, fontSize) {
            var container = this._document.createElement('div');
            var img = this._document.createElement('img');
            var span = this._document.createElement('span');
            var body = this._document.body;
            container.style.visibility = 'hidden';
            container.style.fontFamily = fontFamily;
            container.style.fontSize = fontSize;
            container.style.margin = '0';
            container.style.padding = '0';
            container.style.whiteSpace = 'nowrap';
            body.appendChild(container);
            img.src = SMALL_IMAGE;
            img.width = 1;
            img.height = 1;
            img.style.margin = '0';
            img.style.padding = '0';
            img.style.verticalAlign = 'baseline';
            span.style.fontFamily = fontFamily;
            span.style.fontSize = fontSize;
            span.style.margin = '0';
            span.style.padding = '0';
            span.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.appendChild(span);
            container.appendChild(img);
            var baseline = img.offsetTop - span.offsetTop + 2;
            container.removeChild(span);
            container.appendChild(this._document.createTextNode(SAMPLE_TEXT));
            container.style.lineHeight = 'normal';
            img.style.verticalAlign = 'super';
            var middle = img.offsetTop - container.offsetTop + 2;
            body.removeChild(container);
            return { baseline: baseline, middle: middle };
        };
        FontMetrics.prototype.getMetrics = function (fontFamily, fontSize) {
            var key = fontFamily + " " + fontSize;
            if (typeof this._data[key] === 'undefined') {
                this._data[key] = this.parseMetrics(fontFamily, fontSize);
            }
            return this._data[key];
        };
        return FontMetrics;
    }());

    var Renderer = /** @class */ (function () {
        function Renderer(context, options) {
            this.context = context;
            this.options = options;
        }
        return Renderer;
    }());

    var MASK_OFFSET = 10000;
    var CanvasRenderer = /** @class */ (function (_super) {
        __extends(CanvasRenderer, _super);
        function CanvasRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this._activeEffects = [];
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            if (!options.canvas) {
                _this.canvas.width = Math.floor(options.width * options.scale);
                _this.canvas.height = Math.floor(options.height * options.scale);
                _this.canvas.style.width = options.width + "px";
                _this.canvas.style.height = options.height + "px";
            }
            _this.fontMetrics = new FontMetrics(document);
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.ctx.textBaseline = 'bottom';
            _this._activeEffects = [];
            _this.context.logger.debug("Canvas renderer initialized (" + options.width + "x" + options.height + ") with scale " + options.scale);
            return _this;
        }
        CanvasRenderer.prototype.applyEffects = function (effects) {
            var _this = this;
            while (this._activeEffects.length) {
                this.popEffect();
            }
            effects.forEach(function (effect) { return _this.applyEffect(effect); });
        };
        CanvasRenderer.prototype.applyEffect = function (effect) {
            this.ctx.save();
            if (isOpacityEffect(effect)) {
                this.ctx.globalAlpha = effect.opacity;
            }
            if (isTransformEffect(effect)) {
                this.ctx.translate(effect.offsetX, effect.offsetY);
                this.ctx.transform(effect.matrix[0], effect.matrix[1], effect.matrix[2], effect.matrix[3], effect.matrix[4], effect.matrix[5]);
                this.ctx.translate(-effect.offsetX, -effect.offsetY);
            }
            if (isClipEffect(effect)) {
                this.path(effect.path);
                this.ctx.clip();
            }
            this._activeEffects.push(effect);
        };
        CanvasRenderer.prototype.popEffect = function () {
            this._activeEffects.pop();
            this.ctx.restore();
        };
        CanvasRenderer.prototype.renderStack = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var styles;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            styles = stack.element.container.styles;
                            if (!styles.isVisible()) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderStackContent(stack)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNode = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (contains(paint.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            if (!paint.container.styles.isVisible()) return [3 /*break*/, 3];
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(paint)];
                        case 1:
                            _a.sent();
                            return [4 /*yield*/, this.renderNodeContent(paint)];
                        case 2:
                            _a.sent();
                            _a.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderTextWithLetterSpacing = function (text, letterSpacing, baseline) {
            var _this = this;
            if (letterSpacing === 0) {
                this.ctx.fillText(text.text, text.bounds.left, text.bounds.top + baseline);
            }
            else {
                var letters = segmentGraphemes(text.text);
                letters.reduce(function (left, letter) {
                    _this.ctx.fillText(letter, left, text.bounds.top + baseline);
                    return left + _this.ctx.measureText(letter).width;
                }, text.bounds.left);
            }
        };
        CanvasRenderer.prototype.createFontStyle = function (styles) {
            var fontVariant = styles.fontVariant
                .filter(function (variant) { return variant === 'normal' || variant === 'small-caps'; })
                .join('');
            var fontFamily = fixIOSSystemFonts(styles.fontFamily).join(', ');
            var fontSize = isDimensionToken(styles.fontSize)
                ? "" + styles.fontSize.number + styles.fontSize.unit
                : styles.fontSize.number + "px";
            return [
                [styles.fontStyle, fontVariant, styles.fontWeight, fontSize, fontFamily].join(' '),
                fontFamily,
                fontSize
            ];
        };
        CanvasRenderer.prototype.renderTextNode = function (text, styles) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, font, fontFamily, fontSize, _b, baseline, middle, paintOrder;
                var _this = this;
                return __generator(this, function (_c) {
                    _a = this.createFontStyle(styles), font = _a[0], fontFamily = _a[1], fontSize = _a[2];
                    this.ctx.font = font;
                    this.ctx.direction = styles.direction === 1 /* RTL */ ? 'rtl' : 'ltr';
                    this.ctx.textAlign = 'left';
                    this.ctx.textBaseline = 'alphabetic';
                    _b = this.fontMetrics.getMetrics(fontFamily, fontSize), baseline = _b.baseline, middle = _b.middle;
                    paintOrder = styles.paintOrder;
                    text.textBounds.forEach(function (text) {
                        paintOrder.forEach(function (paintOrderLayer) {
                            switch (paintOrderLayer) {
                                case 0 /* FILL */:
                                    _this.ctx.fillStyle = asString(styles.color);
                                    _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                    var textShadows = styles.textShadow;
                                    if (textShadows.length && text.text.trim().length) {
                                        textShadows
                                            .slice(0)
                                            .reverse()
                                            .forEach(function (textShadow) {
                                            _this.ctx.shadowColor = asString(textShadow.color);
                                            _this.ctx.shadowOffsetX = textShadow.offsetX.number * _this.options.scale;
                                            _this.ctx.shadowOffsetY = textShadow.offsetY.number * _this.options.scale;
                                            _this.ctx.shadowBlur = textShadow.blur.number;
                                            _this.renderTextWithLetterSpacing(text, styles.letterSpacing, baseline);
                                        });
                                        _this.ctx.shadowColor = '';
                                        _this.ctx.shadowOffsetX = 0;
                                        _this.ctx.shadowOffsetY = 0;
                                        _this.ctx.shadowBlur = 0;
                                    }
                                    if (styles.textDecorationLine.length) {
                                        _this.ctx.fillStyle = asString(styles.textDecorationColor || styles.color);
                                        styles.textDecorationLine.forEach(function (textDecorationLine) {
                                            switch (textDecorationLine) {
                                                case 1 /* UNDERLINE */:
                                                    // Draws a line at the baseline of the font
                                                    // TODO As some browsers display the line as more than 1px if the font-size is big,
                                                    // need to take that into account both in position and size
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top + baseline), text.bounds.width, 1);
                                                    break;
                                                case 2 /* OVERLINE */:
                                                    _this.ctx.fillRect(text.bounds.left, Math.round(text.bounds.top), text.bounds.width, 1);
                                                    break;
                                                case 3 /* LINE_THROUGH */:
                                                    // TODO try and find exact position for line-through
                                                    _this.ctx.fillRect(text.bounds.left, Math.ceil(text.bounds.top + middle), text.bounds.width, 1);
                                                    break;
                                            }
                                        });
                                    }
                                    break;
                                case 1 /* STROKE */:
                                    if (styles.webkitTextStrokeWidth && text.text.trim().length) {
                                        _this.ctx.strokeStyle = asString(styles.webkitTextStrokeColor);
                                        _this.ctx.lineWidth = styles.webkitTextStrokeWidth;
                                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                                        _this.ctx.lineJoin = !!window.chrome ? 'miter' : 'round';
                                        _this.ctx.strokeText(text.text, text.bounds.left, text.bounds.top + baseline);
                                    }
                                    _this.ctx.strokeStyle = '';
                                    _this.ctx.lineWidth = 0;
                                    _this.ctx.lineJoin = 'miter';
                                    break;
                            }
                        });
                    });
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderReplacedElement = function (container, curves, image) {
            if (image && container.intrinsicWidth > 0 && container.intrinsicHeight > 0) {
                var box = contentBox(container);
                var path = calculatePaddingBoxPath(curves);
                this.path(path);
                this.ctx.save();
                this.ctx.clip();
                this.ctx.drawImage(image, 0, 0, container.intrinsicWidth, container.intrinsicHeight, box.left, box.top, box.width, box.height);
                this.ctx.restore();
            }
        };
        CanvasRenderer.prototype.renderNodeContent = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var container, curves, styles, _i, _a, child, image, image, iframeRenderer, canvas, size, _b, fontFamily, fontSize, baseline, bounds, x, textBounds, img, image, url, fontFamily, bounds;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(4 /* CONTENT */));
                            container = paint.container;
                            curves = paint.curves;
                            styles = container.styles;
                            _i = 0, _a = container.textNodes;
                            _c.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderTextNode(child, styles)];
                        case 2:
                            _c.sent();
                            _c.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4:
                            if (!(container instanceof ImageElementContainer)) return [3 /*break*/, 8];
                            _c.label = 5;
                        case 5:
                            _c.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.context.cache.match(container.src)];
                        case 6:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 8];
                        case 7:
                            _c.sent();
                            this.context.logger.error("Error loading image " + container.src);
                            return [3 /*break*/, 8];
                        case 8:
                            if (container instanceof CanvasElementContainer) {
                                this.renderReplacedElement(container, curves, container.canvas);
                            }
                            if (!(container instanceof SVGElementContainer)) return [3 /*break*/, 12];
                            _c.label = 9;
                        case 9:
                            _c.trys.push([9, 11, , 12]);
                            return [4 /*yield*/, this.context.cache.match(container.svg)];
                        case 10:
                            image = _c.sent();
                            this.renderReplacedElement(container, curves, image);
                            return [3 /*break*/, 12];
                        case 11:
                            _c.sent();
                            this.context.logger.error("Error loading svg " + container.svg.substring(0, 255));
                            return [3 /*break*/, 12];
                        case 12:
                            if (!(container instanceof IFrameElementContainer && container.tree)) return [3 /*break*/, 14];
                            iframeRenderer = new CanvasRenderer(this.context, {
                                scale: this.options.scale,
                                backgroundColor: container.backgroundColor,
                                x: 0,
                                y: 0,
                                width: container.width,
                                height: container.height
                            });
                            return [4 /*yield*/, iframeRenderer.render(container.tree)];
                        case 13:
                            canvas = _c.sent();
                            if (container.width && container.height) {
                                this.ctx.drawImage(canvas, 0, 0, container.width, container.height, container.bounds.left, container.bounds.top, container.bounds.width, container.bounds.height);
                            }
                            _c.label = 14;
                        case 14:
                            if (container instanceof InputElementContainer) {
                                size = Math.min(container.bounds.width, container.bounds.height);
                                if (container.type === CHECKBOX) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.path([
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79),
                                            new Vector(container.bounds.left + size * 0.16, container.bounds.top + size * 0.5549),
                                            new Vector(container.bounds.left + size * 0.27347, container.bounds.top + size * 0.44071),
                                            new Vector(container.bounds.left + size * 0.39694, container.bounds.top + size * 0.5649),
                                            new Vector(container.bounds.left + size * 0.72983, container.bounds.top + size * 0.23),
                                            new Vector(container.bounds.left + size * 0.84, container.bounds.top + size * 0.34085),
                                            new Vector(container.bounds.left + size * 0.39363, container.bounds.top + size * 0.79)
                                        ]);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                                else if (container.type === RADIO) {
                                    if (container.checked) {
                                        this.ctx.save();
                                        this.ctx.beginPath();
                                        this.ctx.arc(container.bounds.left + size / 2, container.bounds.top + size / 2, size / 4, 0, Math.PI * 2, true);
                                        this.ctx.fillStyle = asString(INPUT_COLOR);
                                        this.ctx.fill();
                                        this.ctx.restore();
                                    }
                                }
                            }
                            if (isTextInputElement(container) && container.value.length) {
                                _b = this.createFontStyle(styles), fontFamily = _b[0], fontSize = _b[1];
                                baseline = this.fontMetrics.getMetrics(fontFamily, fontSize).baseline;
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = canvasTextAlign(container.styles.textAlign);
                                bounds = contentBox(container);
                                x = 0;
                                switch (container.styles.textAlign) {
                                    case 1 /* CENTER */:
                                        x += bounds.width / 2;
                                        break;
                                    case 2 /* RIGHT */:
                                        x += bounds.width;
                                        break;
                                }
                                textBounds = bounds.add(x, 0, 0, -bounds.height / 2 + 1);
                                this.ctx.save();
                                this.path([
                                    new Vector(bounds.left, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top),
                                    new Vector(bounds.left + bounds.width, bounds.top + bounds.height),
                                    new Vector(bounds.left, bounds.top + bounds.height)
                                ]);
                                this.ctx.clip();
                                this.renderTextWithLetterSpacing(new TextBounds(container.value, textBounds), styles.letterSpacing, baseline);
                                this.ctx.restore();
                                this.ctx.textBaseline = 'alphabetic';
                                this.ctx.textAlign = 'left';
                            }
                            if (!contains(container.styles.display, 2048 /* LIST_ITEM */)) return [3 /*break*/, 20];
                            if (!(container.styles.listStyleImage !== null)) return [3 /*break*/, 19];
                            img = container.styles.listStyleImage;
                            if (!(img.type === 0 /* URL */)) return [3 /*break*/, 18];
                            image = void 0;
                            url = img.url;
                            _c.label = 15;
                        case 15:
                            _c.trys.push([15, 17, , 18]);
                            return [4 /*yield*/, this.context.cache.match(url)];
                        case 16:
                            image = _c.sent();
                            this.ctx.drawImage(image, container.bounds.left - (image.width + 10), container.bounds.top);
                            return [3 /*break*/, 18];
                        case 17:
                            _c.sent();
                            this.context.logger.error("Error loading list-style-image " + url);
                            return [3 /*break*/, 18];
                        case 18: return [3 /*break*/, 20];
                        case 19:
                            if (paint.listValue && container.styles.listStyleType !== -1 /* NONE */) {
                                fontFamily = this.createFontStyle(styles)[0];
                                this.ctx.font = fontFamily;
                                this.ctx.fillStyle = asString(styles.color);
                                this.ctx.textBaseline = 'middle';
                                this.ctx.textAlign = 'right';
                                bounds = new Bounds(container.bounds.left, container.bounds.top + getAbsoluteValue(container.styles.paddingTop, container.bounds.width), container.bounds.width, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 1);
                                this.renderTextWithLetterSpacing(new TextBounds(paint.listValue, bounds), styles.letterSpacing, computeLineHeight(styles.lineHeight, styles.fontSize.number) / 2 + 2);
                                this.ctx.textBaseline = 'bottom';
                                this.ctx.textAlign = 'left';
                            }
                            _c.label = 20;
                        case 20: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderStackContent = function (stack) {
            return __awaiter(this, void 0, void 0, function () {
                var _i, _a, child, _b, _c, child, _d, _e, child, _f, _g, child, _h, _j, child, _k, _l, child, _m, _o, child;
                return __generator(this, function (_p) {
                    switch (_p.label) {
                        case 0:
                            if (contains(stack.element.container.flags, 16 /* DEBUG_RENDER */)) {
                                debugger;
                            }
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            return [4 /*yield*/, this.renderNodeBackgroundAndBorders(stack.element)];
                        case 1:
                            // https://www.w3.org/TR/css-position-3/#painting-order
                            // 1. the background and borders of the element forming the stacking context.
                            _p.sent();
                            _i = 0, _a = stack.negativeZIndex;
                            _p.label = 2;
                        case 2:
                            if (!(_i < _a.length)) return [3 /*break*/, 5];
                            child = _a[_i];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 3:
                            _p.sent();
                            _p.label = 4;
                        case 4:
                            _i++;
                            return [3 /*break*/, 2];
                        case 5: 
                        // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                        return [4 /*yield*/, this.renderNodeContent(stack.element)];
                        case 6:
                            // 3. For all its in-flow, non-positioned, block-level descendants in tree order:
                            _p.sent();
                            _b = 0, _c = stack.nonInlineLevel;
                            _p.label = 7;
                        case 7:
                            if (!(_b < _c.length)) return [3 /*break*/, 10];
                            child = _c[_b];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 8:
                            _p.sent();
                            _p.label = 9;
                        case 9:
                            _b++;
                            return [3 /*break*/, 7];
                        case 10:
                            _d = 0, _e = stack.nonPositionedFloats;
                            _p.label = 11;
                        case 11:
                            if (!(_d < _e.length)) return [3 /*break*/, 14];
                            child = _e[_d];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 12:
                            _p.sent();
                            _p.label = 13;
                        case 13:
                            _d++;
                            return [3 /*break*/, 11];
                        case 14:
                            _f = 0, _g = stack.nonPositionedInlineLevel;
                            _p.label = 15;
                        case 15:
                            if (!(_f < _g.length)) return [3 /*break*/, 18];
                            child = _g[_f];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 16:
                            _p.sent();
                            _p.label = 17;
                        case 17:
                            _f++;
                            return [3 /*break*/, 15];
                        case 18:
                            _h = 0, _j = stack.inlineLevel;
                            _p.label = 19;
                        case 19:
                            if (!(_h < _j.length)) return [3 /*break*/, 22];
                            child = _j[_h];
                            return [4 /*yield*/, this.renderNode(child)];
                        case 20:
                            _p.sent();
                            _p.label = 21;
                        case 21:
                            _h++;
                            return [3 /*break*/, 19];
                        case 22:
                            _k = 0, _l = stack.zeroOrAutoZIndexOrTransformedOrOpacity;
                            _p.label = 23;
                        case 23:
                            if (!(_k < _l.length)) return [3 /*break*/, 26];
                            child = _l[_k];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 24:
                            _p.sent();
                            _p.label = 25;
                        case 25:
                            _k++;
                            return [3 /*break*/, 23];
                        case 26:
                            _m = 0, _o = stack.positiveZIndex;
                            _p.label = 27;
                        case 27:
                            if (!(_m < _o.length)) return [3 /*break*/, 30];
                            child = _o[_m];
                            return [4 /*yield*/, this.renderStack(child)];
                        case 28:
                            _p.sent();
                            _p.label = 29;
                        case 29:
                            _m++;
                            return [3 /*break*/, 27];
                        case 30: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.mask = function (paths) {
            this.ctx.beginPath();
            this.ctx.moveTo(0, 0);
            this.ctx.lineTo(this.canvas.width, 0);
            this.ctx.lineTo(this.canvas.width, this.canvas.height);
            this.ctx.lineTo(0, this.canvas.height);
            this.ctx.lineTo(0, 0);
            this.formatPath(paths.slice(0).reverse());
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.path = function (paths) {
            this.ctx.beginPath();
            this.formatPath(paths);
            this.ctx.closePath();
        };
        CanvasRenderer.prototype.formatPath = function (paths) {
            var _this = this;
            paths.forEach(function (point, index) {
                var start = isBezierCurve(point) ? point.start : point;
                if (index === 0) {
                    _this.ctx.moveTo(start.x, start.y);
                }
                else {
                    _this.ctx.lineTo(start.x, start.y);
                }
                if (isBezierCurve(point)) {
                    _this.ctx.bezierCurveTo(point.startControl.x, point.startControl.y, point.endControl.x, point.endControl.y, point.end.x, point.end.y);
                }
            });
        };
        CanvasRenderer.prototype.renderRepeat = function (path, pattern, offsetX, offsetY) {
            this.path(path);
            this.ctx.fillStyle = pattern;
            this.ctx.translate(offsetX, offsetY);
            this.ctx.fill();
            this.ctx.translate(-offsetX, -offsetY);
        };
        CanvasRenderer.prototype.resizeImage = function (image, width, height) {
            var _a;
            if (image.width === width && image.height === height) {
                return image;
            }
            var ownerDocument = (_a = this.canvas.ownerDocument) !== null && _a !== void 0 ? _a : document;
            var canvas = ownerDocument.createElement('canvas');
            canvas.width = Math.max(1, width);
            canvas.height = Math.max(1, height);
            var ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height);
            return canvas;
        };
        CanvasRenderer.prototype.renderBackgroundImage = function (container) {
            return __awaiter(this, void 0, void 0, function () {
                var index, _loop_1, this_1, _i, _a, backgroundImage;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            index = container.styles.backgroundImage.length - 1;
                            _loop_1 = function (backgroundImage) {
                                var image, url, _c, path, x, y, width, height, pattern, _d, path, x, y, width, height, _e, lineLength, x0, x1, y0, y1, canvas, ctx, gradient_1, pattern, _f, path, left, top_1, width, height, position, x, y, _g, rx, ry, radialGradient_1, midX, midY, f, invF;
                                return __generator(this, function (_h) {
                                    switch (_h.label) {
                                        case 0:
                                            if (!(backgroundImage.type === 0 /* URL */)) return [3 /*break*/, 5];
                                            image = void 0;
                                            url = backgroundImage.url;
                                            _h.label = 1;
                                        case 1:
                                            _h.trys.push([1, 3, , 4]);
                                            return [4 /*yield*/, this_1.context.cache.match(url)];
                                        case 2:
                                            image = _h.sent();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _h.sent();
                                            this_1.context.logger.error("Error loading background-image " + url);
                                            return [3 /*break*/, 4];
                                        case 4:
                                            if (image) {
                                                _c = calculateBackgroundRendering(container, index, [
                                                    image.width,
                                                    image.height,
                                                    image.width / image.height
                                                ]), path = _c[0], x = _c[1], y = _c[2], width = _c[3], height = _c[4];
                                                pattern = this_1.ctx.createPattern(this_1.resizeImage(image, width, height), 'repeat');
                                                this_1.renderRepeat(path, pattern, x, y);
                                            }
                                            return [3 /*break*/, 6];
                                        case 5:
                                            if (isLinearGradient(backgroundImage)) {
                                                _d = calculateBackgroundRendering(container, index, [null, null, null]), path = _d[0], x = _d[1], y = _d[2], width = _d[3], height = _d[4];
                                                _e = calculateGradientDirection(backgroundImage.angle, width, height), lineLength = _e[0], x0 = _e[1], x1 = _e[2], y0 = _e[3], y1 = _e[4];
                                                canvas = document.createElement('canvas');
                                                canvas.width = width;
                                                canvas.height = height;
                                                ctx = canvas.getContext('2d');
                                                gradient_1 = ctx.createLinearGradient(x0, y0, x1, y1);
                                                processColorStops(backgroundImage.stops, lineLength).forEach(function (colorStop) {
                                                    return gradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                });
                                                ctx.fillStyle = gradient_1;
                                                ctx.fillRect(0, 0, width, height);
                                                if (width > 0 && height > 0) {
                                                    pattern = this_1.ctx.createPattern(canvas, 'repeat');
                                                    this_1.renderRepeat(path, pattern, x, y);
                                                }
                                            }
                                            else if (isRadialGradient(backgroundImage)) {
                                                _f = calculateBackgroundRendering(container, index, [
                                                    null,
                                                    null,
                                                    null
                                                ]), path = _f[0], left = _f[1], top_1 = _f[2], width = _f[3], height = _f[4];
                                                position = backgroundImage.position.length === 0 ? [FIFTY_PERCENT] : backgroundImage.position;
                                                x = getAbsoluteValue(position[0], width);
                                                y = getAbsoluteValue(position[position.length - 1], height);
                                                _g = calculateRadius(backgroundImage, x, y, width, height), rx = _g[0], ry = _g[1];
                                                if (rx > 0 && ry > 0) {
                                                    radialGradient_1 = this_1.ctx.createRadialGradient(left + x, top_1 + y, 0, left + x, top_1 + y, rx);
                                                    processColorStops(backgroundImage.stops, rx * 2).forEach(function (colorStop) {
                                                        return radialGradient_1.addColorStop(colorStop.stop, asString(colorStop.color));
                                                    });
                                                    this_1.path(path);
                                                    this_1.ctx.fillStyle = radialGradient_1;
                                                    if (rx !== ry) {
                                                        midX = container.bounds.left + 0.5 * container.bounds.width;
                                                        midY = container.bounds.top + 0.5 * container.bounds.height;
                                                        f = ry / rx;
                                                        invF = 1 / f;
                                                        this_1.ctx.save();
                                                        this_1.ctx.translate(midX, midY);
                                                        this_1.ctx.transform(1, 0, 0, f, 0, 0);
                                                        this_1.ctx.translate(-midX, -midY);
                                                        this_1.ctx.fillRect(left, invF * (top_1 - midY) + midY, width, height * invF);
                                                        this_1.ctx.restore();
                                                    }
                                                    else {
                                                        this_1.ctx.fill();
                                                    }
                                                }
                                            }
                                            _h.label = 6;
                                        case 6:
                                            index--;
                                            return [2 /*return*/];
                                    }
                                });
                            };
                            this_1 = this;
                            _i = 0, _a = container.styles.backgroundImage.slice(0).reverse();
                            _b.label = 1;
                        case 1:
                            if (!(_i < _a.length)) return [3 /*break*/, 4];
                            backgroundImage = _a[_i];
                            return [5 /*yield**/, _loop_1(backgroundImage)];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3:
                            _i++;
                            return [3 /*break*/, 1];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderSolidBorder = function (color, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.path(parsePathForBorder(curvePoints, side));
                    this.ctx.fillStyle = asString(color);
                    this.ctx.fill();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.renderDoubleBorder = function (color, width, side, curvePoints) {
            return __awaiter(this, void 0, void 0, function () {
                var outerPaths, innerPaths;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!(width < 3)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.renderSolidBorder(color, side, curvePoints)];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                        case 2:
                            outerPaths = parsePathForBorderDoubleOuter(curvePoints, side);
                            this.path(outerPaths);
                            this.ctx.fillStyle = asString(color);
                            this.ctx.fill();
                            innerPaths = parsePathForBorderDoubleInner(curvePoints, side);
                            this.path(innerPaths);
                            this.ctx.fill();
                            return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderNodeBackgroundAndBorders = function (paint) {
            return __awaiter(this, void 0, void 0, function () {
                var styles, hasBackground, borders, backgroundPaintingArea, side, _i, borders_1, border;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.applyEffects(paint.getEffects(2 /* BACKGROUND_BORDERS */));
                            styles = paint.container.styles;
                            hasBackground = !isTransparent(styles.backgroundColor) || styles.backgroundImage.length;
                            borders = [
                                { style: styles.borderTopStyle, color: styles.borderTopColor, width: styles.borderTopWidth },
                                { style: styles.borderRightStyle, color: styles.borderRightColor, width: styles.borderRightWidth },
                                { style: styles.borderBottomStyle, color: styles.borderBottomColor, width: styles.borderBottomWidth },
                                { style: styles.borderLeftStyle, color: styles.borderLeftColor, width: styles.borderLeftWidth }
                            ];
                            backgroundPaintingArea = calculateBackgroundCurvedPaintingArea(getBackgroundValueForIndex(styles.backgroundClip, 0), paint.curves);
                            if (!(hasBackground || styles.boxShadow.length)) return [3 /*break*/, 2];
                            this.ctx.save();
                            this.path(backgroundPaintingArea);
                            this.ctx.clip();
                            if (!isTransparent(styles.backgroundColor)) {
                                this.ctx.fillStyle = asString(styles.backgroundColor);
                                this.ctx.fill();
                            }
                            return [4 /*yield*/, this.renderBackgroundImage(paint.container)];
                        case 1:
                            _a.sent();
                            this.ctx.restore();
                            styles.boxShadow
                                .slice(0)
                                .reverse()
                                .forEach(function (shadow) {
                                _this.ctx.save();
                                var borderBoxArea = calculateBorderBoxPath(paint.curves);
                                var maskOffset = shadow.inset ? 0 : MASK_OFFSET;
                                var shadowPaintingArea = transformPath(borderBoxArea, -maskOffset + (shadow.inset ? 1 : -1) * shadow.spread.number, (shadow.inset ? 1 : -1) * shadow.spread.number, shadow.spread.number * (shadow.inset ? -2 : 2), shadow.spread.number * (shadow.inset ? -2 : 2));
                                if (shadow.inset) {
                                    _this.path(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.mask(shadowPaintingArea);
                                }
                                else {
                                    _this.mask(borderBoxArea);
                                    _this.ctx.clip();
                                    _this.path(shadowPaintingArea);
                                }
                                _this.ctx.shadowOffsetX = shadow.offsetX.number + maskOffset;
                                _this.ctx.shadowOffsetY = shadow.offsetY.number;
                                _this.ctx.shadowColor = asString(shadow.color);
                                _this.ctx.shadowBlur = shadow.blur.number;
                                _this.ctx.fillStyle = shadow.inset ? asString(shadow.color) : 'rgba(0,0,0,1)';
                                _this.ctx.fill();
                                _this.ctx.restore();
                            });
                            _a.label = 2;
                        case 2:
                            side = 0;
                            _i = 0, borders_1 = borders;
                            _a.label = 3;
                        case 3:
                            if (!(_i < borders_1.length)) return [3 /*break*/, 13];
                            border = borders_1[_i];
                            if (!(border.style !== 0 /* NONE */ && !isTransparent(border.color) && border.width > 0)) return [3 /*break*/, 11];
                            if (!(border.style === 2 /* DASHED */)) return [3 /*break*/, 5];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 2 /* DASHED */)];
                        case 4:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 5:
                            if (!(border.style === 3 /* DOTTED */)) return [3 /*break*/, 7];
                            return [4 /*yield*/, this.renderDashedDottedBorder(border.color, border.width, side, paint.curves, 3 /* DOTTED */)];
                        case 6:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 7:
                            if (!(border.style === 4 /* DOUBLE */)) return [3 /*break*/, 9];
                            return [4 /*yield*/, this.renderDoubleBorder(border.color, border.width, side, paint.curves)];
                        case 8:
                            _a.sent();
                            return [3 /*break*/, 11];
                        case 9: return [4 /*yield*/, this.renderSolidBorder(border.color, side, paint.curves)];
                        case 10:
                            _a.sent();
                            _a.label = 11;
                        case 11:
                            side++;
                            _a.label = 12;
                        case 12:
                            _i++;
                            return [3 /*break*/, 3];
                        case 13: return [2 /*return*/];
                    }
                });
            });
        };
        CanvasRenderer.prototype.renderDashedDottedBorder = function (color, width, side, curvePoints, style) {
            return __awaiter(this, void 0, void 0, function () {
                var strokePaths, boxPaths, startX, startY, endX, endY, length, dashLength, spaceLength, useLineDash, multiplier, numberOfDashes, minSpace, maxSpace, path1, path2, path1, path2;
                return __generator(this, function (_a) {
                    this.ctx.save();
                    strokePaths = parsePathForBorderStroke(curvePoints, side);
                    boxPaths = parsePathForBorder(curvePoints, side);
                    if (style === 2 /* DASHED */) {
                        this.path(boxPaths);
                        this.ctx.clip();
                    }
                    if (isBezierCurve(boxPaths[0])) {
                        startX = boxPaths[0].start.x;
                        startY = boxPaths[0].start.y;
                    }
                    else {
                        startX = boxPaths[0].x;
                        startY = boxPaths[0].y;
                    }
                    if (isBezierCurve(boxPaths[1])) {
                        endX = boxPaths[1].end.x;
                        endY = boxPaths[1].end.y;
                    }
                    else {
                        endX = boxPaths[1].x;
                        endY = boxPaths[1].y;
                    }
                    if (side === 0 || side === 2) {
                        length = Math.abs(startX - endX);
                    }
                    else {
                        length = Math.abs(startY - endY);
                    }
                    this.ctx.beginPath();
                    if (style === 3 /* DOTTED */) {
                        this.formatPath(strokePaths);
                    }
                    else {
                        this.formatPath(boxPaths.slice(0, 2));
                    }
                    dashLength = width < 3 ? width * 3 : width * 2;
                    spaceLength = width < 3 ? width * 2 : width;
                    if (style === 3 /* DOTTED */) {
                        dashLength = width;
                        spaceLength = width;
                    }
                    useLineDash = true;
                    if (length <= dashLength * 2) {
                        useLineDash = false;
                    }
                    else if (length <= dashLength * 2 + spaceLength) {
                        multiplier = length / (2 * dashLength + spaceLength);
                        dashLength *= multiplier;
                        spaceLength *= multiplier;
                    }
                    else {
                        numberOfDashes = Math.floor((length + spaceLength) / (dashLength + spaceLength));
                        minSpace = (length - numberOfDashes * dashLength) / (numberOfDashes - 1);
                        maxSpace = (length - (numberOfDashes + 1) * dashLength) / numberOfDashes;
                        spaceLength =
                            maxSpace <= 0 || Math.abs(spaceLength - minSpace) < Math.abs(spaceLength - maxSpace)
                                ? minSpace
                                : maxSpace;
                    }
                    if (useLineDash) {
                        if (style === 3 /* DOTTED */) {
                            this.ctx.setLineDash([0, dashLength + spaceLength]);
                        }
                        else {
                            this.ctx.setLineDash([dashLength, spaceLength]);
                        }
                    }
                    if (style === 3 /* DOTTED */) {
                        this.ctx.lineCap = 'round';
                        this.ctx.lineWidth = width;
                    }
                    else {
                        this.ctx.lineWidth = width * 2 + 1.1;
                    }
                    this.ctx.strokeStyle = asString(color);
                    this.ctx.stroke();
                    this.ctx.setLineDash([]);
                    // dashed round edge gap
                    if (style === 2 /* DASHED */) {
                        if (isBezierCurve(boxPaths[0])) {
                            path1 = boxPaths[3];
                            path2 = boxPaths[0];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                        if (isBezierCurve(boxPaths[1])) {
                            path1 = boxPaths[1];
                            path2 = boxPaths[2];
                            this.ctx.beginPath();
                            this.formatPath([new Vector(path1.end.x, path1.end.y), new Vector(path2.start.x, path2.start.y)]);
                            this.ctx.stroke();
                        }
                    }
                    this.ctx.restore();
                    return [2 /*return*/];
                });
            });
        };
        CanvasRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var stack;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(this.options.x, this.options.y, this.options.width, this.options.height);
                            }
                            stack = parseStackingContexts(element);
                            return [4 /*yield*/, this.renderStack(stack)];
                        case 1:
                            _a.sent();
                            this.applyEffects([]);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return CanvasRenderer;
    }(Renderer));
    var isTextInputElement = function (container) {
        if (container instanceof TextareaElementContainer) {
            return true;
        }
        else if (container instanceof SelectElementContainer) {
            return true;
        }
        else if (container instanceof InputElementContainer && container.type !== RADIO && container.type !== CHECKBOX) {
            return true;
        }
        return false;
    };
    var calculateBackgroundCurvedPaintingArea = function (clip, curves) {
        switch (clip) {
            case 0 /* BORDER_BOX */:
                return calculateBorderBoxPath(curves);
            case 2 /* CONTENT_BOX */:
                return calculateContentBoxPath(curves);
            case 1 /* PADDING_BOX */:
            default:
                return calculatePaddingBoxPath(curves);
        }
    };
    var canvasTextAlign = function (textAlign) {
        switch (textAlign) {
            case 1 /* CENTER */:
                return 'center';
            case 2 /* RIGHT */:
                return 'right';
            case 0 /* LEFT */:
            default:
                return 'left';
        }
    };
    // see https://github.com/niklasvh/html2canvas/pull/2645
    var iOSBrokenFonts = ['-apple-system', 'system-ui'];
    var fixIOSSystemFonts = function (fontFamilies) {
        return /iPhone OS 15_(0|1)/.test(window.navigator.userAgent)
            ? fontFamilies.filter(function (fontFamily) { return iOSBrokenFonts.indexOf(fontFamily) === -1; })
            : fontFamilies;
    };

    var ForeignObjectRenderer = /** @class */ (function (_super) {
        __extends(ForeignObjectRenderer, _super);
        function ForeignObjectRenderer(context, options) {
            var _this = _super.call(this, context, options) || this;
            _this.canvas = options.canvas ? options.canvas : document.createElement('canvas');
            _this.ctx = _this.canvas.getContext('2d');
            _this.options = options;
            _this.canvas.width = Math.floor(options.width * options.scale);
            _this.canvas.height = Math.floor(options.height * options.scale);
            _this.canvas.style.width = options.width + "px";
            _this.canvas.style.height = options.height + "px";
            _this.ctx.scale(_this.options.scale, _this.options.scale);
            _this.ctx.translate(-options.x, -options.y);
            _this.context.logger.debug("EXPERIMENTAL ForeignObject renderer initialized (" + options.width + "x" + options.height + " at " + options.x + "," + options.y + ") with scale " + options.scale);
            return _this;
        }
        ForeignObjectRenderer.prototype.render = function (element) {
            return __awaiter(this, void 0, void 0, function () {
                var svg, img;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            svg = createForeignObjectSVG(this.options.width * this.options.scale, this.options.height * this.options.scale, this.options.scale, this.options.scale, element);
                            return [4 /*yield*/, loadSerializedSVG(svg)];
                        case 1:
                            img = _a.sent();
                            if (this.options.backgroundColor) {
                                this.ctx.fillStyle = asString(this.options.backgroundColor);
                                this.ctx.fillRect(0, 0, this.options.width * this.options.scale, this.options.height * this.options.scale);
                            }
                            this.ctx.drawImage(img, -this.options.x * this.options.scale, -this.options.y * this.options.scale);
                            return [2 /*return*/, this.canvas];
                    }
                });
            });
        };
        return ForeignObjectRenderer;
    }(Renderer));
    var loadSerializedSVG = function (svg) {
        return new Promise(function (resolve, reject) {
            var img = new Image();
            img.onload = function () {
                resolve(img);
            };
            img.onerror = reject;
            img.src = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(new XMLSerializer().serializeToString(svg));
        });
    };

    var Logger = /** @class */ (function () {
        function Logger(_a) {
            var id = _a.id, enabled = _a.enabled;
            this.id = id;
            this.enabled = enabled;
            this.start = Date.now();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.debug = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.debug === 'function') {
                    // eslint-disable-next-line no-console
                    console.debug.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.prototype.getTime = function () {
            return Date.now() - this.start;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.info = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.info === 'function') {
                    // eslint-disable-next-line no-console
                    console.info.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.warn = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.warn === 'function') {
                    // eslint-disable-next-line no-console
                    console.warn.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Logger.prototype.error = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.enabled) {
                // eslint-disable-next-line no-console
                if (typeof window !== 'undefined' && window.console && typeof console.error === 'function') {
                    // eslint-disable-next-line no-console
                    console.error.apply(console, __spreadArray([this.id, this.getTime() + "ms"], args));
                }
                else {
                    this.info.apply(this, args);
                }
            }
        };
        Logger.instances = {};
        return Logger;
    }());

    var Context = /** @class */ (function () {
        function Context(options, windowBounds) {
            var _a;
            this.windowBounds = windowBounds;
            this.instanceName = "#" + Context.instanceCount++;
            this.logger = new Logger({ id: this.instanceName, enabled: options.logging });
            this.cache = (_a = options.cache) !== null && _a !== void 0 ? _a : new Cache(this, options);
        }
        Context.instanceCount = 1;
        return Context;
    }());

    var html2canvas = function (element, options) {
        if (options === void 0) { options = {}; }
        return renderElement(element, options);
    };
    if (typeof window !== 'undefined') {
        CacheStorage.setContext(window);
    }
    var renderElement = function (element, opts) { return __awaiter(void 0, void 0, void 0, function () {
        var ownerDocument, defaultView, resourceOptions, contextOptions, windowOptions, windowBounds, context, foreignObjectRendering, cloneOptions, documentCloner, clonedElement, container, _a, width, height, left, top, backgroundColor, renderOptions, canvas, renderer, root, renderer;
        var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
        return __generator(this, function (_u) {
            switch (_u.label) {
                case 0:
                    if (!element || typeof element !== 'object') {
                        return [2 /*return*/, Promise.reject('Invalid element provided as first argument')];
                    }
                    ownerDocument = element.ownerDocument;
                    if (!ownerDocument) {
                        throw new Error("Element is not attached to a Document");
                    }
                    defaultView = ownerDocument.defaultView;
                    if (!defaultView) {
                        throw new Error("Document is not attached to a Window");
                    }
                    resourceOptions = {
                        allowTaint: (_b = opts.allowTaint) !== null && _b !== void 0 ? _b : false,
                        imageTimeout: (_c = opts.imageTimeout) !== null && _c !== void 0 ? _c : 15000,
                        proxy: opts.proxy,
                        useCORS: (_d = opts.useCORS) !== null && _d !== void 0 ? _d : false
                    };
                    contextOptions = __assign({ logging: (_e = opts.logging) !== null && _e !== void 0 ? _e : true, cache: opts.cache }, resourceOptions);
                    windowOptions = {
                        windowWidth: (_f = opts.windowWidth) !== null && _f !== void 0 ? _f : defaultView.innerWidth,
                        windowHeight: (_g = opts.windowHeight) !== null && _g !== void 0 ? _g : defaultView.innerHeight,
                        scrollX: (_h = opts.scrollX) !== null && _h !== void 0 ? _h : defaultView.pageXOffset,
                        scrollY: (_j = opts.scrollY) !== null && _j !== void 0 ? _j : defaultView.pageYOffset
                    };
                    windowBounds = new Bounds(windowOptions.scrollX, windowOptions.scrollY, windowOptions.windowWidth, windowOptions.windowHeight);
                    context = new Context(contextOptions, windowBounds);
                    foreignObjectRendering = (_k = opts.foreignObjectRendering) !== null && _k !== void 0 ? _k : false;
                    cloneOptions = {
                        allowTaint: (_l = opts.allowTaint) !== null && _l !== void 0 ? _l : false,
                        onclone: opts.onclone,
                        ignoreElements: opts.ignoreElements,
                        inlineImages: foreignObjectRendering,
                        copyStyles: foreignObjectRendering
                    };
                    context.logger.debug("Starting document clone with size " + windowBounds.width + "x" + windowBounds.height + " scrolled to " + -windowBounds.left + "," + -windowBounds.top);
                    documentCloner = new DocumentCloner(context, element, cloneOptions);
                    clonedElement = documentCloner.clonedReferenceElement;
                    if (!clonedElement) {
                        return [2 /*return*/, Promise.reject("Unable to find element in cloned iframe")];
                    }
                    return [4 /*yield*/, documentCloner.toIFrame(ownerDocument, windowBounds)];
                case 1:
                    container = _u.sent();
                    _a = isBodyElement(clonedElement) || isHTMLElement(clonedElement)
                        ? parseDocumentSize(clonedElement.ownerDocument)
                        : parseBounds(context, clonedElement), width = _a.width, height = _a.height, left = _a.left, top = _a.top;
                    backgroundColor = parseBackgroundColor(context, clonedElement, opts.backgroundColor);
                    renderOptions = {
                        canvas: opts.canvas,
                        backgroundColor: backgroundColor,
                        scale: (_o = (_m = opts.scale) !== null && _m !== void 0 ? _m : defaultView.devicePixelRatio) !== null && _o !== void 0 ? _o : 1,
                        x: ((_p = opts.x) !== null && _p !== void 0 ? _p : 0) + left,
                        y: ((_q = opts.y) !== null && _q !== void 0 ? _q : 0) + top,
                        width: (_r = opts.width) !== null && _r !== void 0 ? _r : Math.ceil(width),
                        height: (_s = opts.height) !== null && _s !== void 0 ? _s : Math.ceil(height)
                    };
                    if (!foreignObjectRendering) return [3 /*break*/, 3];
                    context.logger.debug("Document cloned, using foreign object rendering");
                    renderer = new ForeignObjectRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(clonedElement)];
                case 2:
                    canvas = _u.sent();
                    return [3 /*break*/, 5];
                case 3:
                    context.logger.debug("Document cloned, element located at " + left + "," + top + " with size " + width + "x" + height + " using computed rendering");
                    context.logger.debug("Starting DOM parsing");
                    root = parseTree(context, clonedElement);
                    if (backgroundColor === root.styles.backgroundColor) {
                        root.styles.backgroundColor = COLORS.TRANSPARENT;
                    }
                    context.logger.debug("Starting renderer for element at " + renderOptions.x + "," + renderOptions.y + " with size " + renderOptions.width + "x" + renderOptions.height);
                    renderer = new CanvasRenderer(context, renderOptions);
                    return [4 /*yield*/, renderer.render(root)];
                case 4:
                    canvas = _u.sent();
                    _u.label = 5;
                case 5:
                    if ((_t = opts.removeContainer) !== null && _t !== void 0 ? _t : true) {
                        if (!DocumentCloner.destroy(container)) {
                            context.logger.error("Cannot detach cloned iframe as it is not in the DOM anymore");
                        }
                    }
                    context.logger.debug("Finished rendering");
                    return [2 /*return*/, canvas];
            }
        });
    }); };
    var parseBackgroundColor = function (context, element, backgroundColorOverride) {
        var ownerDocument = element.ownerDocument;
        // http://www.w3.org/TR/css3-background/#special-backgrounds
        var documentBackgroundColor = ownerDocument.documentElement
            ? parseColor(context, getComputedStyle(ownerDocument.documentElement).backgroundColor)
            : COLORS.TRANSPARENT;
        var bodyBackgroundColor = ownerDocument.body
            ? parseColor(context, getComputedStyle(ownerDocument.body).backgroundColor)
            : COLORS.TRANSPARENT;
        var defaultBackgroundColor = typeof backgroundColorOverride === 'string'
            ? parseColor(context, backgroundColorOverride)
            : backgroundColorOverride === null
                ? COLORS.TRANSPARENT
                : 0xffffffff;
        return element === ownerDocument.documentElement
            ? isTransparent(documentBackgroundColor)
                ? isTransparent(bodyBackgroundColor)
                    ? defaultBackgroundColor
                    : bodyBackgroundColor
                : documentBackgroundColor
            : defaultBackgroundColor;
    };

    return html2canvas;

})));


},{}],47:[function(require,module,exports){
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}

},{}],48:[function(require,module,exports){
/*!
 * imagesLoaded v5.0.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) {
  // universal module definition
  if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory( window, require('ev-emitter') );
  } else {
    // browser global
    window.imagesLoaded = factory( window, window.EvEmitter );
  }

} )( typeof window !== 'undefined' ? window : this,
    function factory( window, EvEmitter ) {

let $ = window.jQuery;
let console = window.console;

// -------------------------- helpers -------------------------- //

// turn element or nodeList into an array
function makeArray( obj ) {
  // use object if already an array
  if ( Array.isArray( obj ) ) return obj;

  let isArrayLike = typeof obj == 'object' && typeof obj.length == 'number';
  // convert nodeList to array
  if ( isArrayLike ) return [ ...obj ];

  // array of single index
  return [ obj ];
}

// -------------------------- imagesLoaded -------------------------- //

/**
 * @param {[Array, Element, NodeList, String]} elem
 * @param {[Object, Function]} options - if function, use as callback
 * @param {Function} onAlways - callback function
 * @returns {ImagesLoaded}
 */
function ImagesLoaded( elem, options, onAlways ) {
  // coerce ImagesLoaded() without new, to be new ImagesLoaded()
  if ( !( this instanceof ImagesLoaded ) ) {
    return new ImagesLoaded( elem, options, onAlways );
  }
  // use elem as selector string
  let queryElem = elem;
  if ( typeof elem == 'string' ) {
    queryElem = document.querySelectorAll( elem );
  }
  // bail if bad element
  if ( !queryElem ) {
    console.error(`Bad element for imagesLoaded ${queryElem || elem}`);
    return;
  }

  this.elements = makeArray( queryElem );
  this.options = {};
  // shift arguments if no options set
  if ( typeof options == 'function' ) {
    onAlways = options;
  } else {
    Object.assign( this.options, options );
  }

  if ( onAlways ) this.on( 'always', onAlways );

  this.getImages();
  // add jQuery Deferred object
  if ( $ ) this.jqDeferred = new $.Deferred();

  // HACK check async to allow time to bind listeners
  setTimeout( this.check.bind( this ) );
}

ImagesLoaded.prototype = Object.create( EvEmitter.prototype );

ImagesLoaded.prototype.getImages = function() {
  this.images = [];

  // filter & find items if we have an item selector
  this.elements.forEach( this.addElementImages, this );
};

const elementNodeTypes = [ 1, 9, 11 ];

/**
 * @param {Node} elem
 */
ImagesLoaded.prototype.addElementImages = function( elem ) {
  // filter siblings
  if ( elem.nodeName === 'IMG' ) {
    this.addImage( elem );
  }
  // get background image on element
  if ( this.options.background === true ) {
    this.addElementBackgroundImages( elem );
  }

  // find children
  // no non-element nodes, #143
  let { nodeType } = elem;
  if ( !nodeType || !elementNodeTypes.includes( nodeType ) ) return;

  let childImgs = elem.querySelectorAll('img');
  // concat childElems to filterFound array
  for ( let img of childImgs ) {
    this.addImage( img );
  }

  // get child background images
  if ( typeof this.options.background == 'string' ) {
    let children = elem.querySelectorAll( this.options.background );
    for ( let child of children ) {
      this.addElementBackgroundImages( child );
    }
  }
};

const reURL = /url\((['"])?(.*?)\1\)/gi;

ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
  let style = getComputedStyle( elem );
  // Firefox returns null if in a hidden iframe https://bugzil.la/548397
  if ( !style ) return;

  // get url inside url("...")
  let matches = reURL.exec( style.backgroundImage );
  while ( matches !== null ) {
    let url = matches && matches[2];
    if ( url ) {
      this.addBackground( url, elem );
    }
    matches = reURL.exec( style.backgroundImage );
  }
};

/**
 * @param {Image} img
 */
ImagesLoaded.prototype.addImage = function( img ) {
  let loadingImage = new LoadingImage( img );
  this.images.push( loadingImage );
};

ImagesLoaded.prototype.addBackground = function( url, elem ) {
  let background = new Background( url, elem );
  this.images.push( background );
};

ImagesLoaded.prototype.check = function() {
  this.progressedCount = 0;
  this.hasAnyBroken = false;
  // complete if no images
  if ( !this.images.length ) {
    this.complete();
    return;
  }

  /* eslint-disable-next-line func-style */
  let onProgress = ( image, elem, message ) => {
    // HACK - Chrome triggers event before object properties have changed. #83
    setTimeout( () => {
      this.progress( image, elem, message );
    } );
  };

  this.images.forEach( function( loadingImage ) {
    loadingImage.once( 'progress', onProgress );
    loadingImage.check();
  } );
};

ImagesLoaded.prototype.progress = function( image, elem, message ) {
  this.progressedCount++;
  this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
  // progress event
  this.emitEvent( 'progress', [ this, image, elem ] );
  if ( this.jqDeferred && this.jqDeferred.notify ) {
    this.jqDeferred.notify( this, image );
  }
  // check if completed
  if ( this.progressedCount === this.images.length ) {
    this.complete();
  }

  if ( this.options.debug && console ) {
    console.log( `progress: ${message}`, image, elem );
  }
};

ImagesLoaded.prototype.complete = function() {
  let eventName = this.hasAnyBroken ? 'fail' : 'done';
  this.isComplete = true;
  this.emitEvent( eventName, [ this ] );
  this.emitEvent( 'always', [ this ] );
  if ( this.jqDeferred ) {
    let jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
    this.jqDeferred[ jqMethod ]( this );
  }
};

// --------------------------  -------------------------- //

function LoadingImage( img ) {
  this.img = img;
}

LoadingImage.prototype = Object.create( EvEmitter.prototype );

LoadingImage.prototype.check = function() {
  // If complete is true and browser supports natural sizes,
  // try to check for image status manually.
  let isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    // report based on naturalWidth
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    return;
  }

  // If none of the checks above matched, simulate loading on detached element.
  this.proxyImage = new Image();
  // add crossOrigin attribute. #204
  if ( this.img.crossOrigin ) {
    this.proxyImage.crossOrigin = this.img.crossOrigin;
  }
  this.proxyImage.addEventListener( 'load', this );
  this.proxyImage.addEventListener( 'error', this );
  // bind to image as well for Firefox. #191
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.proxyImage.src = this.img.currentSrc || this.img.src;
};

LoadingImage.prototype.getIsImageComplete = function() {
  // check for non-zero, non-undefined naturalWidth
  // fixes Safari+InfiniteScroll+Masonry bug infinite-scroll#671
  return this.img.complete && this.img.naturalWidth;
};

LoadingImage.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  let { parentNode } = this.img;
  // emit progress with parent <picture> or self <img>
  let elem = parentNode.nodeName === 'PICTURE' ? parentNode : this.img;
  this.emitEvent( 'progress', [ this, elem, message ] );
};

// ----- events ----- //

// trigger specified handler for event type
LoadingImage.prototype.handleEvent = function( event ) {
  let method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

LoadingImage.prototype.onload = function() {
  this.confirm( true, 'onload' );
  this.unbindEvents();
};

LoadingImage.prototype.onerror = function() {
  this.confirm( false, 'onerror' );
  this.unbindEvents();
};

LoadingImage.prototype.unbindEvents = function() {
  this.proxyImage.removeEventListener( 'load', this );
  this.proxyImage.removeEventListener( 'error', this );
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

// -------------------------- Background -------------------------- //

function Background( url, element ) {
  this.url = url;
  this.element = element;
  this.img = new Image();
}

// inherit LoadingImage prototype
Background.prototype = Object.create( LoadingImage.prototype );

Background.prototype.check = function() {
  this.img.addEventListener( 'load', this );
  this.img.addEventListener( 'error', this );
  this.img.src = this.url;
  // check if image is already complete
  let isComplete = this.getIsImageComplete();
  if ( isComplete ) {
    this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
    this.unbindEvents();
  }
};

Background.prototype.unbindEvents = function() {
  this.img.removeEventListener( 'load', this );
  this.img.removeEventListener( 'error', this );
};

Background.prototype.confirm = function( isLoaded, message ) {
  this.isLoaded = isLoaded;
  this.emitEvent( 'progress', [ this, this.element, message ] );
};

// -------------------------- jQuery -------------------------- //

ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
  jQuery = jQuery || window.jQuery;
  if ( !jQuery ) return;

  // set local variable
  $ = jQuery;
  // $().imagesLoaded()
  $.fn.imagesLoaded = function( options, onAlways ) {
    let instance = new ImagesLoaded( this, options, onAlways );
    return instance.jqDeferred.promise( $( this ) );
  };
};
// try making plugin
ImagesLoaded.makeJQueryPlugin();

// --------------------------  -------------------------- //

return ImagesLoaded;

} );

},{"ev-emitter":42}],49:[function(require,module,exports){
/*!
 * jQuery UI Accordion 1.13.2
 * http://jqueryui.com
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 */

//>>label: Accordion
//>>group: Widgets
/* eslint-disable max-len */
//>>description: Displays collapsible content panels for presenting information in a limited amount of space.
/* eslint-enable max-len */
//>>docs: http://api.jqueryui.com/accordion/
//>>demos: http://jqueryui.com/accordion/
//>>css.structure: ../../themes/base/core.css
//>>css.structure: ../../themes/base/accordion.css
//>>css.theme: ../../themes/base/theme.css

( function( factory ) {
	"use strict";

	if ( typeof define === "function" && define.amd ) {

		// AMD. Register as an anonymous module.
		define( [
			"jquery",
			"../version",
			"../keycode",
			"../unique-id",
			"../widget"
		], factory );
	} else {

		// Browser globals
		factory( jQuery );
	}
} )( function( $ ) {
"use strict";

return $.widget( "ui.accordion", {
	version: "1.13.2",
	options: {
		active: 0,
		animate: {},
		classes: {
			"ui-accordion-header": "ui-corner-top",
			"ui-accordion-header-collapsed": "ui-corner-all",
			"ui-accordion-content": "ui-corner-bottom"
		},
		collapsible: false,
		event: "click",
		header: function( elem ) {
			return elem.find( "> li > :first-child" ).add( elem.find( "> :not(li)" ).even() );
		},
		heightStyle: "auto",
		icons: {
			activeHeader: "ui-icon-triangle-1-s",
			header: "ui-icon-triangle-1-e"
		},

		// Callbacks
		activate: null,
		beforeActivate: null
	},

	hideProps: {
		borderTopWidth: "hide",
		borderBottomWidth: "hide",
		paddingTop: "hide",
		paddingBottom: "hide",
		height: "hide"
	},

	showProps: {
		borderTopWidth: "show",
		borderBottomWidth: "show",
		paddingTop: "show",
		paddingBottom: "show",
		height: "show"
	},

	_create: function() {
		var options = this.options;

		this.prevShow = this.prevHide = $();
		this._addClass( "ui-accordion", "ui-widget ui-helper-reset" );
		this.element.attr( "role", "tablist" );

		// Don't allow collapsible: false and active: false / null
		if ( !options.collapsible && ( options.active === false || options.active == null ) ) {
			options.active = 0;
		}

		this._processPanels();

		// handle negative values
		if ( options.active < 0 ) {
			options.active += this.headers.length;
		}
		this._refresh();
	},

	_getCreateEventData: function() {
		return {
			header: this.active,
			panel: !this.active.length ? $() : this.active.next()
		};
	},

	_createIcons: function() {
		var icon, children,
			icons = this.options.icons;

		if ( icons ) {
			icon = $( "<span>" );
			this._addClass( icon, "ui-accordion-header-icon", "ui-icon " + icons.header );
			icon.prependTo( this.headers );
			children = this.active.children( ".ui-accordion-header-icon" );
			this._removeClass( children, icons.header )
				._addClass( children, null, icons.activeHeader )
				._addClass( this.headers, "ui-accordion-icons" );
		}
	},

	_destroyIcons: function() {
		this._removeClass( this.headers, "ui-accordion-icons" );
		this.headers.children( ".ui-accordion-header-icon" ).remove();
	},

	_destroy: function() {
		var contents;

		// Clean up main element
		this.element.removeAttr( "role" );

		// Clean up headers
		this.headers
			.removeAttr( "role aria-expanded aria-selected aria-controls tabIndex" )
			.removeUniqueId();

		this._destroyIcons();

		// Clean up content panels
		contents = this.headers.next()
			.css( "display", "" )
			.removeAttr( "role aria-hidden aria-labelledby" )
			.removeUniqueId();

		if ( this.options.heightStyle !== "content" ) {
			contents.css( "height", "" );
		}
	},

	_setOption: function( key, value ) {
		if ( key === "active" ) {

			// _activate() will handle invalid values and update this.options
			this._activate( value );
			return;
		}

		if ( key === "event" ) {
			if ( this.options.event ) {
				this._off( this.headers, this.options.event );
			}
			this._setupEvents( value );
		}

		this._super( key, value );

		// Setting collapsible: false while collapsed; open first panel
		if ( key === "collapsible" && !value && this.options.active === false ) {
			this._activate( 0 );
		}

		if ( key === "icons" ) {
			this._destroyIcons();
			if ( value ) {
				this._createIcons();
			}
		}
	},

	_setOptionDisabled: function( value ) {
		this._super( value );

		this.element.attr( "aria-disabled", value );

		// Support: IE8 Only
		// #5332 / #6059 - opacity doesn't cascade to positioned elements in IE
		// so we need to add the disabled class to the headers and panels
		this._toggleClass( null, "ui-state-disabled", !!value );
		this._toggleClass( this.headers.add( this.headers.next() ), null, "ui-state-disabled",
			!!value );
	},

	_keydown: function( event ) {
		if ( event.altKey || event.ctrlKey ) {
			return;
		}

		var keyCode = $.ui.keyCode,
			length = this.headers.length,
			currentIndex = this.headers.index( event.target ),
			toFocus = false;

		switch ( event.keyCode ) {
		case keyCode.RIGHT:
		case keyCode.DOWN:
			toFocus = this.headers[ ( currentIndex + 1 ) % length ];
			break;
		case keyCode.LEFT:
		case keyCode.UP:
			toFocus = this.headers[ ( currentIndex - 1 + length ) % length ];
			break;
		case keyCode.SPACE:
		case keyCode.ENTER:
			this._eventHandler( event );
			break;
		case keyCode.HOME:
			toFocus = this.headers[ 0 ];
			break;
		case keyCode.END:
			toFocus = this.headers[ length - 1 ];
			break;
		}

		if ( toFocus ) {
			$( event.target ).attr( "tabIndex", -1 );
			$( toFocus ).attr( "tabIndex", 0 );
			$( toFocus ).trigger( "focus" );
			event.preventDefault();
		}
	},

	_panelKeyDown: function( event ) {
		if ( event.keyCode === $.ui.keyCode.UP && event.ctrlKey ) {
			$( event.currentTarget ).prev().trigger( "focus" );
		}
	},

	refresh: function() {
		var options = this.options;
		this._processPanels();

		// Was collapsed or no panel
		if ( ( options.active === false && options.collapsible === true ) ||
				!this.headers.length ) {
			options.active = false;
			this.active = $();

		// active false only when collapsible is true
		} else if ( options.active === false ) {
			this._activate( 0 );

		// was active, but active panel is gone
		} else if ( this.active.length && !$.contains( this.element[ 0 ], this.active[ 0 ] ) ) {

			// all remaining panel are disabled
			if ( this.headers.length === this.headers.find( ".ui-state-disabled" ).length ) {
				options.active = false;
				this.active = $();

			// activate previous panel
			} else {
				this._activate( Math.max( 0, options.active - 1 ) );
			}

		// was active, active panel still exists
		} else {

			// make sure active index is correct
			options.active = this.headers.index( this.active );
		}

		this._destroyIcons();

		this._refresh();
	},

	_processPanels: function() {
		var prevHeaders = this.headers,
			prevPanels = this.panels;

		if ( typeof this.options.header === "function" ) {
			this.headers = this.options.header( this.element );
		} else {
			this.headers = this.element.find( this.options.header );
		}
		this._addClass( this.headers, "ui-accordion-header ui-accordion-header-collapsed",
			"ui-state-default" );

		this.panels = this.headers.next().filter( ":not(.ui-accordion-content-active)" ).hide();
		this._addClass( this.panels, "ui-accordion-content", "ui-helper-reset ui-widget-content" );

		// Avoid memory leaks (#10056)
		if ( prevPanels ) {
			this._off( prevHeaders.not( this.headers ) );
			this._off( prevPanels.not( this.panels ) );
		}
	},

	_refresh: function() {
		var maxHeight,
			options = this.options,
			heightStyle = options.heightStyle,
			parent = this.element.parent();

		this.active = this._findActive( options.active );
		this._addClass( this.active, "ui-accordion-header-active", "ui-state-active" )
			._removeClass( this.active, "ui-accordion-header-collapsed" );
		this._addClass( this.active.next(), "ui-accordion-content-active" );
		this.active.next().show();

		this.headers
			.attr( "role", "tab" )
			.each( function() {
				var header = $( this ),
					headerId = header.uniqueId().attr( "id" ),
					panel = header.next(),
					panelId = panel.uniqueId().attr( "id" );
				header.attr( "aria-controls", panelId );
				panel.attr( "aria-labelledby", headerId );
			} )
			.next()
				.attr( "role", "tabpanel" );

		this.headers
			.not( this.active )
				.attr( {
					"aria-selected": "false",
					"aria-expanded": "false",
					tabIndex: -1
				} )
				.next()
					.attr( {
						"aria-hidden": "true"
					} )
					.hide();

		// Make sure at least one header is in the tab order
		if ( !this.active.length ) {
			this.headers.eq( 0 ).attr( "tabIndex", 0 );
		} else {
			this.active.attr( {
				"aria-selected": "true",
				"aria-expanded": "true",
				tabIndex: 0
			} )
				.next()
					.attr( {
						"aria-hidden": "false"
					} );
		}

		this._createIcons();

		this._setupEvents( options.event );

		if ( heightStyle === "fill" ) {
			maxHeight = parent.height();
			this.element.siblings( ":visible" ).each( function() {
				var elem = $( this ),
					position = elem.css( "position" );

				if ( position === "absolute" || position === "fixed" ) {
					return;
				}
				maxHeight -= elem.outerHeight( true );
			} );

			this.headers.each( function() {
				maxHeight -= $( this ).outerHeight( true );
			} );

			this.headers.next()
				.each( function() {
					$( this ).height( Math.max( 0, maxHeight -
						$( this ).innerHeight() + $( this ).height() ) );
				} )
				.css( "overflow", "auto" );
		} else if ( heightStyle === "auto" ) {
			maxHeight = 0;
			this.headers.next()
				.each( function() {
					var isVisible = $( this ).is( ":visible" );
					if ( !isVisible ) {
						$( this ).show();
					}
					maxHeight = Math.max( maxHeight, $( this ).css( "height", "" ).height() );
					if ( !isVisible ) {
						$( this ).hide();
					}
				} )
				.height( maxHeight );
		}
	},

	_activate: function( index ) {
		var active = this._findActive( index )[ 0 ];

		// Trying to activate the already active panel
		if ( active === this.active[ 0 ] ) {
			return;
		}

		// Trying to collapse, simulate a click on the currently active header
		active = active || this.active[ 0 ];

		this._eventHandler( {
			target: active,
			currentTarget: active,
			preventDefault: $.noop
		} );
	},

	_findActive: function( selector ) {
		return typeof selector === "number" ? this.headers.eq( selector ) : $();
	},

	_setupEvents: function( event ) {
		var events = {
			keydown: "_keydown"
		};
		if ( event ) {
			$.each( event.split( " " ), function( index, eventName ) {
				events[ eventName ] = "_eventHandler";
			} );
		}

		this._off( this.headers.add( this.headers.next() ) );
		this._on( this.headers, events );
		this._on( this.headers.next(), { keydown: "_panelKeyDown" } );
		this._hoverable( this.headers );
		this._focusable( this.headers );
	},

	_eventHandler: function( event ) {
		var activeChildren, clickedChildren,
			options = this.options,
			active = this.active,
			clicked = $( event.currentTarget ),
			clickedIsActive = clicked[ 0 ] === active[ 0 ],
			collapsing = clickedIsActive && options.collapsible,
			toShow = collapsing ? $() : clicked.next(),
			toHide = active.next(),
			eventData = {
				oldHeader: active,
				oldPanel: toHide,
				newHeader: collapsing ? $() : clicked,
				newPanel: toShow
			};

		event.preventDefault();

		if (

				// click on active header, but not collapsible
				( clickedIsActive && !options.collapsible ) ||

				// allow canceling activation
				( this._trigger( "beforeActivate", event, eventData ) === false ) ) {
			return;
		}

		options.active = collapsing ? false : this.headers.index( clicked );

		// When the call to ._toggle() comes after the class changes
		// it causes a very odd bug in IE 8 (see #6720)
		this.active = clickedIsActive ? $() : clicked;
		this._toggle( eventData );

		// Switch classes
		// corner classes on the previously active header stay after the animation
		this._removeClass( active, "ui-accordion-header-active", "ui-state-active" );
		if ( options.icons ) {
			activeChildren = active.children( ".ui-accordion-header-icon" );
			this._removeClass( activeChildren, null, options.icons.activeHeader )
				._addClass( activeChildren, null, options.icons.header );
		}

		if ( !clickedIsActive ) {
			this._removeClass( clicked, "ui-accordion-header-collapsed" )
				._addClass( clicked, "ui-accordion-header-active", "ui-state-active" );
			if ( options.icons ) {
				clickedChildren = clicked.children( ".ui-accordion-header-icon" );
				this._removeClass( clickedChildren, null, options.icons.header )
					._addClass( clickedChildren, null, options.icons.activeHeader );
			}

			this._addClass( clicked.next(), "ui-accordion-content-active" );
		}
	},

	_toggle: function( data ) {
		var toShow = data.newPanel,
			toHide = this.prevShow.length ? this.prevShow : data.oldPanel;

		// Handle activating a panel during the animation for another activation
		this.prevShow.add( this.prevHide ).stop( true, true );
		this.prevShow = toShow;
		this.prevHide = toHide;

		if ( this.options.animate ) {
			this._animate( toShow, toHide, data );
		} else {
			toHide.hide();
			toShow.show();
			this._toggleComplete( data );
		}

		toHide.attr( {
			"aria-hidden": "true"
		} );
		toHide.prev().attr( {
			"aria-selected": "false",
			"aria-expanded": "false"
		} );

		// if we're switching panels, remove the old header from the tab order
		// if we're opening from collapsed state, remove the previous header from the tab order
		// if we're collapsing, then keep the collapsing header in the tab order
		if ( toShow.length && toHide.length ) {
			toHide.prev().attr( {
				"tabIndex": -1,
				"aria-expanded": "false"
			} );
		} else if ( toShow.length ) {
			this.headers.filter( function() {
				return parseInt( $( this ).attr( "tabIndex" ), 10 ) === 0;
			} )
				.attr( "tabIndex", -1 );
		}

		toShow
			.attr( "aria-hidden", "false" )
			.prev()
				.attr( {
					"aria-selected": "true",
					"aria-expanded": "true",
					tabIndex: 0
				} );
	},

	_animate: function( toShow, toHide, data ) {
		var total, easing, duration,
			that = this,
			adjust = 0,
			boxSizing = toShow.css( "box-sizing" ),
			down = toShow.length &&
				( !toHide.length || ( toShow.index() < toHide.index() ) ),
			animate = this.options.animate || {},
			options = down && animate.down || animate,
			complete = function() {
				that._toggleComplete( data );
			};

		if ( typeof options === "number" ) {
			duration = options;
		}
		if ( typeof options === "string" ) {
			easing = options;
		}

		// fall back from options to animation in case of partial down settings
		easing = easing || options.easing || animate.easing;
		duration = duration || options.duration || animate.duration;

		if ( !toHide.length ) {
			return toShow.animate( this.showProps, duration, easing, complete );
		}
		if ( !toShow.length ) {
			return toHide.animate( this.hideProps, duration, easing, complete );
		}

		total = toShow.show().outerHeight();
		toHide.animate( this.hideProps, {
			duration: duration,
			easing: easing,
			step: function( now, fx ) {
				fx.now = Math.round( now );
			}
		} );
		toShow
			.hide()
			.animate( this.showProps, {
				duration: duration,
				easing: easing,
				complete: complete,
				step: function( now, fx ) {
					fx.now = Math.round( now );
					if ( fx.prop !== "height" ) {
						if ( boxSizing === "content-box" ) {
							adjust += fx.now;
						}
					} else if ( that.options.heightStyle !== "content" ) {
						fx.now = Math.round( total - toHide.outerHeight() - adjust );
						adjust = 0;
					}
				}
			} );
	},

	_toggleComplete: function( data ) {
		var toHide = data.oldPanel,
			prev = toHide.prev();

		this._removeClass( toHide, "ui-accordion-content-active" );
		this._removeClass( prev, "ui-accordion-header-active" )
			._addClass( prev, "ui-accordion-header-collapsed" );

		// Work around for rendering bug in IE (#5421)
		if ( toHide.length ) {
			toHide.parent()[ 0 ].className = toHide.parent()[ 0 ].className;
		}
		this._trigger( "activate", null, data );
	}
} );

} );

},{}],50:[function(require,module,exports){
'use strict';

var _barcodes = require('./barcodes/');

var _barcodes2 = _interopRequireDefault(_barcodes);

var _merge = require('./help/merge.js');

var _merge2 = _interopRequireDefault(_merge);

var _linearizeEncodings = require('./help/linearizeEncodings.js');

var _linearizeEncodings2 = _interopRequireDefault(_linearizeEncodings);

var _fixOptions = require('./help/fixOptions.js');

var _fixOptions2 = _interopRequireDefault(_fixOptions);

var _getRenderProperties = require('./help/getRenderProperties.js');

var _getRenderProperties2 = _interopRequireDefault(_getRenderProperties);

var _optionsFromStrings = require('./help/optionsFromStrings.js');

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _ErrorHandler = require('./exceptions/ErrorHandler.js');

var _ErrorHandler2 = _interopRequireDefault(_ErrorHandler);

var _exceptions = require('./exceptions/exceptions.js');

var _defaults = require('./options/defaults.js');

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The protype of the object returned from the JsBarcode() call


// Help functions
var API = function API() {};

// The first call of the library API
// Will return an object with all barcodes calls and the data that is used
// by the renderers


// Default values


// Exceptions
// Import all the barcodes
var JsBarcode = function JsBarcode(element, text, options) {
	var api = new API();

	if (typeof element === "undefined") {
		throw Error("No element to render on was provided.");
	}

	// Variables that will be pased through the API calls
	api._renderProperties = (0, _getRenderProperties2.default)(element);
	api._encodings = [];
	api._options = _defaults2.default;
	api._errorHandler = new _ErrorHandler2.default(api);

	// If text is set, use the simple syntax (render the barcode directly)
	if (typeof text !== "undefined") {
		options = options || {};

		if (!options.format) {
			options.format = autoSelectBarcode();
		}

		api.options(options)[options.format](text, options).render();
	}

	return api;
};

// To make tests work TODO: remove
JsBarcode.getModule = function (name) {
	return _barcodes2.default[name];
};

// Register all barcodes
for (var name in _barcodes2.default) {
	if (_barcodes2.default.hasOwnProperty(name)) {
		// Security check if the propery is a prototype property
		registerBarcode(_barcodes2.default, name);
	}
}
function registerBarcode(barcodes, name) {
	API.prototype[name] = API.prototype[name.toUpperCase()] = API.prototype[name.toLowerCase()] = function (text, options) {
		var api = this;
		return api._errorHandler.wrapBarcodeCall(function () {
			// Ensure text is options.text
			options.text = typeof options.text === 'undefined' ? undefined : '' + options.text;

			var newOptions = (0, _merge2.default)(api._options, options);
			newOptions = (0, _optionsFromStrings2.default)(newOptions);
			var Encoder = barcodes[name];
			var encoded = encode(text, Encoder, newOptions);
			api._encodings.push(encoded);

			return api;
		});
	};
}

// encode() handles the Encoder call and builds the binary string to be rendered
function encode(text, Encoder, options) {
	// Ensure that text is a string
	text = "" + text;

	var encoder = new Encoder(text, options);

	// If the input is not valid for the encoder, throw error.
	// If the valid callback option is set, call it instead of throwing error
	if (!encoder.valid()) {
		throw new _exceptions.InvalidInputException(encoder.constructor.name, text);
	}

	// Make a request for the binary data (and other infromation) that should be rendered
	var encoded = encoder.encode();

	// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
	// Convert to [1-1, 1-2, 2, 3-1, 3-2]
	encoded = (0, _linearizeEncodings2.default)(encoded);

	// Merge
	for (var i = 0; i < encoded.length; i++) {
		encoded[i].options = (0, _merge2.default)(options, encoded[i].options);
	}

	return encoded;
}

function autoSelectBarcode() {
	// If CODE128 exists. Use it
	if (_barcodes2.default["CODE128"]) {
		return "CODE128";
	}

	// Else, take the first (probably only) barcode
	return Object.keys(_barcodes2.default)[0];
}

// Sets global encoder options
// Added to the api by the JsBarcode function
API.prototype.options = function (options) {
	this._options = (0, _merge2.default)(this._options, options);
	return this;
};

// Will create a blank space (usually in between barcodes)
API.prototype.blank = function (size) {
	var zeroes = new Array(size + 1).join("0");
	this._encodings.push({ data: zeroes });
	return this;
};

// Initialize JsBarcode on all HTML elements defined.
API.prototype.init = function () {
	// Should do nothing if no elements where found
	if (!this._renderProperties) {
		return;
	}

	// Make sure renderProperies is an array
	if (!Array.isArray(this._renderProperties)) {
		this._renderProperties = [this._renderProperties];
	}

	var renderProperty;
	for (var i in this._renderProperties) {
		renderProperty = this._renderProperties[i];
		var options = (0, _merge2.default)(this._options, renderProperty.options);

		if (options.format == "auto") {
			options.format = autoSelectBarcode();
		}

		this._errorHandler.wrapBarcodeCall(function () {
			var text = options.value;
			var Encoder = _barcodes2.default[options.format.toUpperCase()];
			var encoded = encode(text, Encoder, options);

			render(renderProperty, encoded, options);
		});
	}
};

// The render API call. Calls the real render function.
API.prototype.render = function () {
	if (!this._renderProperties) {
		throw new _exceptions.NoElementException();
	}

	if (Array.isArray(this._renderProperties)) {
		for (var i = 0; i < this._renderProperties.length; i++) {
			render(this._renderProperties[i], this._encodings, this._options);
		}
	} else {
		render(this._renderProperties, this._encodings, this._options);
	}

	return this;
};

API.prototype._defaults = _defaults2.default;

// Prepares the encodings and calls the renderer
function render(renderProperties, encodings, options) {
	encodings = (0, _linearizeEncodings2.default)(encodings);

	for (var i = 0; i < encodings.length; i++) {
		encodings[i].options = (0, _merge2.default)(options, encodings[i].options);
		(0, _fixOptions2.default)(encodings[i].options);
	}

	(0, _fixOptions2.default)(options);

	var Renderer = renderProperties.renderer;
	var renderer = new Renderer(renderProperties.element, encodings, options);
	renderer.render();

	if (renderProperties.afterRender) {
		renderProperties.afterRender();
	}
}

// Export to browser
if (typeof window !== "undefined") {
	window.JsBarcode = JsBarcode;
}

// Export to jQuery
/*global jQuery */
if (typeof jQuery !== 'undefined') {
	jQuery.fn.JsBarcode = function (content, options) {
		var elementArray = [];
		jQuery(this).each(function () {
			elementArray.push(this);
		});
		return JsBarcode(elementArray, content, options);
	};
}

// Export to commonJS
module.exports = JsBarcode;
},{"./barcodes/":84,"./exceptions/ErrorHandler.js":86,"./exceptions/exceptions.js":87,"./help/fixOptions.js":88,"./help/getRenderProperties.js":90,"./help/linearizeEncodings.js":91,"./help/merge.js":92,"./help/optionsFromStrings.js":93,"./options/defaults.js":94}],51:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Barcode = function Barcode(data, options) {
	_classCallCheck(this, Barcode);

	this.data = data;
	this.text = options.text || data;
	this.options = options;
};

exports.default = Barcode;
},{}],52:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require('../Barcode.js');

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// This is the master class,
// it does require the start code to be included in the string
var CODE128 = function (_Barcode) {
	_inherits(CODE128, _Barcode);

	function CODE128(data, options) {
		_classCallCheck(this, CODE128);

		// Get array of ascii codes from data
		var _this = _possibleConstructorReturn(this, (CODE128.__proto__ || Object.getPrototypeOf(CODE128)).call(this, data.substring(1), options));

		_this.bytes = data.split('').map(function (char) {
			return char.charCodeAt(0);
		});
		return _this;
	}

	_createClass(CODE128, [{
		key: 'valid',
		value: function valid() {
			// ASCII value ranges 0-127, 200-211
			return (/^[\x00-\x7F\xC8-\xD3]+$/.test(this.data)
			);
		}

		// The public encoding function

	}, {
		key: 'encode',
		value: function encode() {
			var bytes = this.bytes;
			// Remove the start code from the bytes and set its index
			var startIndex = bytes.shift() - 105;
			// Get start set by index
			var startSet = _constants.SET_BY_CODE[startIndex];

			if (startSet === undefined) {
				throw new RangeError('The encoding does not start with a start character.');
			}

			if (this.shouldEncodeAsEan128() === true) {
				bytes.unshift(_constants.FNC1);
			}

			// Start encode with the right type
			var encodingResult = CODE128.next(bytes, 1, startSet);

			return {
				text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, '') : this.text,
				data:
				// Add the start bits
				CODE128.getBar(startIndex) +
				// Add the encoded bits
				encodingResult.result +
				// Add the checksum
				CODE128.getBar((encodingResult.checksum + startIndex) % _constants.MODULO) +
				// Add the end bits
				CODE128.getBar(_constants.STOP)
			};
		}

		// GS1-128/EAN-128

	}, {
		key: 'shouldEncodeAsEan128',
		value: function shouldEncodeAsEan128() {
			var isEAN128 = this.options.ean128 || false;
			if (typeof isEAN128 === 'string') {
				isEAN128 = isEAN128.toLowerCase() === 'true';
			}
			return isEAN128;
		}

		// Get a bar symbol by index

	}], [{
		key: 'getBar',
		value: function getBar(index) {
			return _constants.BARS[index] ? _constants.BARS[index].toString() : '';
		}

		// Correct an index by a set and shift it from the bytes array

	}, {
		key: 'correctIndex',
		value: function correctIndex(bytes, set) {
			if (set === _constants.SET_A) {
				var charCode = bytes.shift();
				return charCode < 32 ? charCode + 64 : charCode - 32;
			} else if (set === _constants.SET_B) {
				return bytes.shift() - 32;
			} else {
				return (bytes.shift() - 48) * 10 + bytes.shift() - 48;
			}
		}
	}, {
		key: 'next',
		value: function next(bytes, pos, set) {
			if (!bytes.length) {
				return { result: '', checksum: 0 };
			}

			var nextCode = void 0,
			    index = void 0;

			// Special characters
			if (bytes[0] >= 200) {
				index = bytes.shift() - 105;
				var nextSet = _constants.SWAP[index];

				// Swap to other set
				if (nextSet !== undefined) {
					nextCode = CODE128.next(bytes, pos + 1, nextSet);
				}
				// Continue on current set but encode a special character
				else {
						// Shift
						if ((set === _constants.SET_A || set === _constants.SET_B) && index === _constants.SHIFT) {
							// Convert the next character so that is encoded correctly
							bytes[0] = set === _constants.SET_A ? bytes[0] > 95 ? bytes[0] - 96 : bytes[0] : bytes[0] < 32 ? bytes[0] + 96 : bytes[0];
						}
						nextCode = CODE128.next(bytes, pos + 1, set);
					}
			}
			// Continue encoding
			else {
					index = CODE128.correctIndex(bytes, set);
					nextCode = CODE128.next(bytes, pos + 1, set);
				}

			// Get the correct binary encoding and calculate the weight
			var enc = CODE128.getBar(index);
			var weight = index * pos;

			return {
				result: enc + nextCode.result,
				checksum: weight + nextCode.checksum
			};
		}
	}]);

	return CODE128;
}(_Barcode3.default);

exports.default = CODE128;
},{"../Barcode.js":51,"./constants":58}],53:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = require('./CODE128.js');

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128A = function (_CODE) {
	_inherits(CODE128A, _CODE);

	function CODE128A(string, options) {
		_classCallCheck(this, CODE128A);

		return _possibleConstructorReturn(this, (CODE128A.__proto__ || Object.getPrototypeOf(CODE128A)).call(this, _constants.A_START_CHAR + string, options));
	}

	_createClass(CODE128A, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.A_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128A;
}(_CODE3.default);

exports.default = CODE128A;
},{"./CODE128.js":52,"./constants":58}],54:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = require('./CODE128.js');

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128B = function (_CODE) {
	_inherits(CODE128B, _CODE);

	function CODE128B(string, options) {
		_classCallCheck(this, CODE128B);

		return _possibleConstructorReturn(this, (CODE128B.__proto__ || Object.getPrototypeOf(CODE128B)).call(this, _constants.B_START_CHAR + string, options));
	}

	_createClass(CODE128B, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.B_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128B;
}(_CODE3.default);

exports.default = CODE128B;
},{"./CODE128.js":52,"./constants":58}],55:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CODE2 = require('./CODE128.js');

var _CODE3 = _interopRequireDefault(_CODE2);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128C = function (_CODE) {
	_inherits(CODE128C, _CODE);

	function CODE128C(string, options) {
		_classCallCheck(this, CODE128C);

		return _possibleConstructorReturn(this, (CODE128C.__proto__ || Object.getPrototypeOf(CODE128C)).call(this, _constants.C_START_CHAR + string, options));
	}

	_createClass(CODE128C, [{
		key: 'valid',
		value: function valid() {
			return new RegExp('^' + _constants.C_CHARS + '+$').test(this.data);
		}
	}]);

	return CODE128C;
}(_CODE3.default);

exports.default = CODE128C;
},{"./CODE128.js":52,"./constants":58}],56:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE2 = require('./CODE128');

var _CODE3 = _interopRequireDefault(_CODE2);

var _auto = require('./auto');

var _auto2 = _interopRequireDefault(_auto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CODE128AUTO = function (_CODE) {
	_inherits(CODE128AUTO, _CODE);

	function CODE128AUTO(data, options) {
		_classCallCheck(this, CODE128AUTO);

		// ASCII value ranges 0-127, 200-211
		if (/^[\x00-\x7F\xC8-\xD3]+$/.test(data)) {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, (0, _auto2.default)(data), options));
		} else {
			var _this = _possibleConstructorReturn(this, (CODE128AUTO.__proto__ || Object.getPrototypeOf(CODE128AUTO)).call(this, data, options));
		}
		return _possibleConstructorReturn(_this);
	}

	return CODE128AUTO;
}(_CODE3.default);

exports.default = CODE128AUTO;
},{"./CODE128":52,"./auto":57}],57:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = require('./constants');

// Match Set functions
var matchSetALength = function matchSetALength(string) {
	return string.match(new RegExp('^' + _constants.A_CHARS + '*'))[0].length;
};
var matchSetBLength = function matchSetBLength(string) {
	return string.match(new RegExp('^' + _constants.B_CHARS + '*'))[0].length;
};
var matchSetC = function matchSetC(string) {
	return string.match(new RegExp('^' + _constants.C_CHARS + '*'))[0];
};

// CODE128A or CODE128B
function autoSelectFromAB(string, isA) {
	var ranges = isA ? _constants.A_CHARS : _constants.B_CHARS;
	var untilC = string.match(new RegExp('^(' + ranges + '+?)(([0-9]{2}){2,})([^0-9]|$)'));

	if (untilC) {
		return untilC[1] + String.fromCharCode(204) + autoSelectFromC(string.substring(untilC[1].length));
	}

	var chars = string.match(new RegExp('^' + ranges + '+'))[0];

	if (chars.length === string.length) {
		return string;
	}

	return chars + String.fromCharCode(isA ? 205 : 206) + autoSelectFromAB(string.substring(chars.length), !isA);
}

// CODE128C
function autoSelectFromC(string) {
	var cMatch = matchSetC(string);
	var length = cMatch.length;

	if (length === string.length) {
		return string;
	}

	string = string.substring(length);

	// Select A/B depending on the longest match
	var isA = matchSetALength(string) >= matchSetBLength(string);
	return cMatch + String.fromCharCode(isA ? 206 : 205) + autoSelectFromAB(string, isA);
}

// Detect Code Set (A, B or C) and format the string

exports.default = function (string) {
	var newString = void 0;
	var cLength = matchSetC(string).length;

	// Select 128C if the string start with enough digits
	if (cLength >= 2) {
		newString = _constants.C_START_CHAR + autoSelectFromC(string);
	} else {
		// Select A/B depending on the longest match
		var isA = matchSetALength(string) > matchSetBLength(string);
		newString = (isA ? _constants.A_START_CHAR : _constants.B_START_CHAR) + autoSelectFromAB(string, isA);
	}

	return newString.replace(/[\xCD\xCE]([^])[\xCD\xCE]/, // Any sequence between 205 and 206 characters
	function (match, char) {
		return String.fromCharCode(203) + char;
	});
};
},{"./constants":58}],58:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _SET_BY_CODE;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// constants for internal usage
var SET_A = exports.SET_A = 0;
var SET_B = exports.SET_B = 1;
var SET_C = exports.SET_C = 2;

// Special characters
var SHIFT = exports.SHIFT = 98;
var START_A = exports.START_A = 103;
var START_B = exports.START_B = 104;
var START_C = exports.START_C = 105;
var MODULO = exports.MODULO = 103;
var STOP = exports.STOP = 106;
var FNC1 = exports.FNC1 = 207;

// Get set by start code
var SET_BY_CODE = exports.SET_BY_CODE = (_SET_BY_CODE = {}, _defineProperty(_SET_BY_CODE, START_A, SET_A), _defineProperty(_SET_BY_CODE, START_B, SET_B), _defineProperty(_SET_BY_CODE, START_C, SET_C), _SET_BY_CODE);

// Get next set by code
var SWAP = exports.SWAP = {
	101: SET_A,
	100: SET_B,
	99: SET_C
};

var A_START_CHAR = exports.A_START_CHAR = String.fromCharCode(208); // START_A + 105
var B_START_CHAR = exports.B_START_CHAR = String.fromCharCode(209); // START_B + 105
var C_START_CHAR = exports.C_START_CHAR = String.fromCharCode(210); // START_C + 105

// 128A (Code Set A)
// ASCII characters 00 to 95 (0–9, A–Z and control codes), special characters, and FNC 1–4
var A_CHARS = exports.A_CHARS = "[\x00-\x5F\xC8-\xCF]";

// 128B (Code Set B)
// ASCII characters 32 to 127 (0–9, A–Z, a–z), special characters, and FNC 1–4
var B_CHARS = exports.B_CHARS = "[\x20-\x7F\xC8-\xCF]";

// 128C (Code Set C)
// 00–99 (encodes two digits with a single code point) and FNC1
var C_CHARS = exports.C_CHARS = "(\xCF*[0-9]{2}\xCF*)";

// CODE128 includes 107 symbols:
// 103 data symbols, 3 start symbols (A, B and C), and 1 stop symbol (the last one)
// Each symbol consist of three black bars (1) and three white spaces (0).
var BARS = exports.BARS = [11011001100, 11001101100, 11001100110, 10010011000, 10010001100, 10001001100, 10011001000, 10011000100, 10001100100, 11001001000, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011000, 11011000110, 11000110110, 10100011000, 10001011000, 10001000110, 10110001000, 10001101000, 10001100010, 11010001000, 11000101000, 11000100010, 10110111000, 10110001110, 10001101110, 10111011000, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101000, 11011100010, 11011101110, 11101011000, 11101000110, 11100010110, 11101101000, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 10100110000, 10100001100, 10010110000, 10010000110, 10000101100, 10000100110, 10110010000, 10110000100, 10011010000, 10011000010, 10000110100, 10000110010, 11000010010, 11001010000, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111000, 10100011110, 10001011110, 10111101000, 10111100010, 11110101000, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 11010010000, 11010011100, 1100011101011];
},{}],59:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CODE128C = exports.CODE128B = exports.CODE128A = exports.CODE128 = undefined;

var _CODE128_AUTO = require('./CODE128_AUTO.js');

var _CODE128_AUTO2 = _interopRequireDefault(_CODE128_AUTO);

var _CODE128A = require('./CODE128A.js');

var _CODE128A2 = _interopRequireDefault(_CODE128A);

var _CODE128B = require('./CODE128B.js');

var _CODE128B2 = _interopRequireDefault(_CODE128B);

var _CODE128C = require('./CODE128C.js');

var _CODE128C2 = _interopRequireDefault(_CODE128C);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CODE128 = _CODE128_AUTO2.default;
exports.CODE128A = _CODE128A2.default;
exports.CODE128B = _CODE128B2.default;
exports.CODE128C = _CODE128C2.default;
},{"./CODE128A.js":53,"./CODE128B.js":54,"./CODE128C.js":55,"./CODE128_AUTO.js":56}],60:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.CODE39 = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Code_39#Encoding

var CODE39 = function (_Barcode) {
	_inherits(CODE39, _Barcode);

	function CODE39(data, options) {
		_classCallCheck(this, CODE39);

		data = data.toUpperCase();

		// Calculate mod43 checksum if enabled
		if (options.mod43) {
			data += getCharacter(mod43checksum(data));
		}

		return _possibleConstructorReturn(this, (CODE39.__proto__ || Object.getPrototypeOf(CODE39)).call(this, data, options));
	}

	_createClass(CODE39, [{
		key: "encode",
		value: function encode() {
			// First character is always a *
			var result = getEncoding("*");

			// Take every character and add the binary representation to the result
			for (var i = 0; i < this.data.length; i++) {
				result += getEncoding(this.data[i]) + "0";
			}

			// Last character is always a *
			result += getEncoding("*");

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
		}
	}]);

	return CODE39;
}(_Barcode3.default);

// All characters. The position in the array is the (checksum) value


var characters = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"];

// The decimal representation of the characters, is converted to the
// corresponding binary with the getEncoding function
var encodings = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];

// Get the binary representation of a character by converting the encodings
// from decimal to binary
function getEncoding(character) {
	return getBinary(characterValue(character));
}

function getBinary(characterValue) {
	return encodings[characterValue].toString(2);
}

function getCharacter(characterValue) {
	return characters[characterValue];
}

function characterValue(character) {
	return characters.indexOf(character);
}

function mod43checksum(data) {
	var checksum = 0;
	for (var i = 0; i < data.length; i++) {
		checksum += characterValue(data[i]);
	}

	checksum = checksum % 43;
	return checksum;
}

exports.CODE39 = CODE39;
},{"../Barcode.js":51}],61:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _encoder = require('./encoder');

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = require('../Barcode');

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Base class for EAN8 & EAN13
var EAN = function (_Barcode) {
	_inherits(EAN, _Barcode);

	function EAN(data, options) {
		_classCallCheck(this, EAN);

		// Make sure the font is not bigger than the space between the guard bars
		var _this = _possibleConstructorReturn(this, (EAN.__proto__ || Object.getPrototypeOf(EAN)).call(this, data, options));

		_this.fontSize = !options.flat && options.fontSize > options.width * 10 ? options.width * 10 : options.fontSize;

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(EAN, [{
		key: 'encode',
		value: function encode() {
			return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
		}
	}, {
		key: 'leftText',
		value: function leftText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText(from, to) {
			return this.text.substr(from, to);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode(data, structure) {
			return (0, _encoder2.default)(data, structure);
		}
	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var textOptions = { fontSize: this.fontSize };
			var guardOptions = { height: this.guardHeight };

			return [{ data: _constants.SIDE_BIN, options: guardOptions }, { data: this.leftEncode(), text: this.leftText(), options: textOptions }, { data: _constants.MIDDLE_BIN, options: guardOptions }, { data: this.rightEncode(), text: this.rightText(), options: textOptions }, { data: _constants.SIDE_BIN, options: guardOptions }];
		}
	}, {
		key: 'encodeFlat',
		value: function encodeFlat() {
			var data = [_constants.SIDE_BIN, this.leftEncode(), _constants.MIDDLE_BIN, this.rightEncode(), _constants.SIDE_BIN];

			return {
				data: data.join(''),
				text: this.text
			};
		}
	}]);

	return EAN;
}(_Barcode3.default);

exports.default = EAN;
},{"../Barcode":51,"./constants":68,"./encoder":69}],62:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _constants = require('./constants');

var _EAN2 = require('./EAN');

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Binary_encoding_of_data_digits_into_EAN-13_barcode

// Calculate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit
var checksum = function checksum(number) {
	var res = number.substr(0, 12).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 3 : sum + a;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN13 = function (_EAN) {
	_inherits(EAN13, _EAN);

	function EAN13(data, options) {
		_classCallCheck(this, EAN13);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{12}$/) !== -1) {
			data += checksum(data);
		}

		// Adds a last character to the end of the barcode
		var _this = _possibleConstructorReturn(this, (EAN13.__proto__ || Object.getPrototypeOf(EAN13)).call(this, data, options));

		_this.lastChar = options.lastChar;
		return _this;
	}

	_createClass(EAN13, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftText', this).call(this, 1, 6);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(1, 6);
			var structure = _constants.EAN13_STRUCTURE[this.data[0]];
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'leftEncode', this).call(this, data, structure);
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightText', this).call(this, 7, 6);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(7, 6);
			return _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'rightEncode', this).call(this, data, 'RRRRRR');
		}

		// The "standard" way of printing EAN13 barcodes with guard bars

	}, {
		key: 'encodeGuarded',
		value: function encodeGuarded() {
			var data = _get(EAN13.prototype.__proto__ || Object.getPrototypeOf(EAN13.prototype), 'encodeGuarded', this).call(this);

			// Extend data with left digit & last character
			if (this.options.displayValue) {
				data.unshift({
					data: '000000000000',
					text: this.text.substr(0, 1),
					options: { textAlign: 'left', fontSize: this.fontSize }
				});

				if (this.options.lastChar) {
					data.push({
						data: '00'
					});
					data.push({
						data: '00000',
						text: this.options.lastChar,
						options: { fontSize: this.fontSize }
					});
				}
			}

			return data;
		}
	}]);

	return EAN13;
}(_EAN3.default);

exports.default = EAN13;
},{"./EAN":61,"./constants":68}],63:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _encoder = require('./encoder');

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = require('../Barcode');

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_2#Encoding

var EAN2 = function (_Barcode) {
	_inherits(EAN2, _Barcode);

	function EAN2(data, options) {
		_classCallCheck(this, EAN2);

		return _possibleConstructorReturn(this, (EAN2.__proto__ || Object.getPrototypeOf(EAN2)).call(this, data, options));
	}

	_createClass(EAN2, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{2}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			// Choose the structure based on the number mod 4
			var structure = _constants.EAN2_STRUCTURE[parseInt(this.data) % 4];
			return {
				// Start bits + Encode the two digits with 01 in between
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN2;
}(_Barcode3.default);

exports.default = EAN2;
},{"../Barcode":51,"./constants":68,"./encoder":69}],64:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _encoder = require('./encoder');

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = require('../Barcode');

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/EAN_5#Encoding

var checksum = function checksum(data) {
	var result = data.split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a * 9 : sum + a * 3;
	}, 0);
	return result % 10;
};

var EAN5 = function (_Barcode) {
	_inherits(EAN5, _Barcode);

	function EAN5(data, options) {
		_classCallCheck(this, EAN5);

		return _possibleConstructorReturn(this, (EAN5.__proto__ || Object.getPrototypeOf(EAN5)).call(this, data, options));
	}

	_createClass(EAN5, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{5}$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var structure = _constants.EAN5_STRUCTURE[checksum(this.data)];
			return {
				data: '1011' + (0, _encoder2.default)(this.data, structure, '01'),
				text: this.text
			};
		}
	}]);

	return EAN5;
}(_Barcode3.default);

exports.default = EAN5;
},{"../Barcode":51,"./constants":68,"./encoder":69}],65:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _EAN2 = require('./EAN');

var _EAN3 = _interopRequireDefault(_EAN2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// http://www.barcodeisland.com/ean8.phtml

// Calculate the checksum digit
var checksum = function checksum(number) {
	var res = number.substr(0, 7).split('').map(function (n) {
		return +n;
	}).reduce(function (sum, a, idx) {
		return idx % 2 ? sum + a : sum + a * 3;
	}, 0);

	return (10 - res % 10) % 10;
};

var EAN8 = function (_EAN) {
	_inherits(EAN8, _EAN);

	function EAN8(data, options) {
		_classCallCheck(this, EAN8);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{7}$/) !== -1) {
			data += checksum(data);
		}

		return _possibleConstructorReturn(this, (EAN8.__proto__ || Object.getPrototypeOf(EAN8)).call(this, data, options));
	}

	_createClass(EAN8, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === checksum(this.data);
		}
	}, {
		key: 'leftText',
		value: function leftText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftText', this).call(this, 0, 4);
		}
	}, {
		key: 'leftEncode',
		value: function leftEncode() {
			var data = this.data.substr(0, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'leftEncode', this).call(this, data, 'LLLL');
		}
	}, {
		key: 'rightText',
		value: function rightText() {
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightText', this).call(this, 4, 4);
		}
	}, {
		key: 'rightEncode',
		value: function rightEncode() {
			var data = this.data.substr(4, 4);
			return _get(EAN8.prototype.__proto__ || Object.getPrototypeOf(EAN8.prototype), 'rightEncode', this).call(this, data, 'RRRR');
		}
	}]);

	return EAN8;
}(_EAN3.default);

exports.default = EAN8;
},{"./EAN":61}],66:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checksum = checksum;

var _encoder = require("./encoder");

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding

var UPC = function (_Barcode) {
	_inherits(UPC, _Barcode);

	function UPC(data, options) {
		_classCallCheck(this, UPC);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{11}$/) !== -1) {
			data += checksum(data);
		}

		var _this = _possibleConstructorReturn(this, (UPC.__proto__ || Object.getPrototypeOf(UPC)).call(this, data, options));

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPC, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == checksum(this.data);
		}
	}, {
		key: "encode",
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: "flatEncoding",
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += (0, _encoder2.default)(this.data.substr(0, 6), "LLLLLL");
			result += "01010";
			result += (0, _encoder2.default)(this.data.substr(6, 6), "RRRRRR");
			result += "101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "guardedEncoding",
		value: function guardedEncoding() {
			var result = [];

			// Add the first digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(0, 1),
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101" + (0, _encoder2.default)(this.data[0], "L"),
				options: { height: this.guardHeight }
			});

			// Add the left side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(1, 5), "LLLLL"),
				text: this.text.substr(1, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the middle bits
			result.push({
				data: "01010",
				options: { height: this.guardHeight }
			});

			// Add the right side
			result.push({
				data: (0, _encoder2.default)(this.data.substr(6, 5), "RRRRR"),
				text: this.text.substr(6, 5),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: (0, _encoder2.default)(this.data[11], "R") + "101",
				options: { height: this.guardHeight }
			});

			// Add the last digit
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text.substr(11, 1),
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}]);

	return UPC;
}(_Barcode3.default);

// Calulate the checksum digit
// https://en.wikipedia.org/wiki/International_Article_Number_(EAN)#Calculation_of_checksum_digit


function checksum(number) {
	var result = 0;

	var i;
	for (i = 1; i < 11; i += 2) {
		result += parseInt(number[i]);
	}
	for (i = 0; i < 11; i += 2) {
		result += parseInt(number[i]) * 3;
	}

	return (10 - result % 10) % 10;
}

exports.default = UPC;
},{"../Barcode.js":51,"./encoder":69}],67:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _encoder = require('./encoder');

var _encoder2 = _interopRequireDefault(_encoder);

var _Barcode2 = require('../Barcode.js');

var _Barcode3 = _interopRequireDefault(_Barcode2);

var _UPC = require('./UPC.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#Encoding
//
// UPC-E documentation:
// https://en.wikipedia.org/wiki/Universal_Product_Code#UPC-E

var EXPANSIONS = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"];

var PARITIES = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]];

var UPCE = function (_Barcode) {
	_inherits(UPCE, _Barcode);

	function UPCE(data, options) {
		_classCallCheck(this, UPCE);

		var _this = _possibleConstructorReturn(this, (UPCE.__proto__ || Object.getPrototypeOf(UPCE)).call(this, data, options));
		// Code may be 6 or 8 digits;
		// A 7 digit code is ambiguous as to whether the extra digit
		// is a UPC-A check or number system digit.


		_this.isValid = false;
		if (data.search(/^[0-9]{6}$/) !== -1) {
			_this.middleDigits = data;
			_this.upcA = expandToUPCA(data, "0");
			_this.text = options.text || '' + _this.upcA[0] + data + _this.upcA[_this.upcA.length - 1];
			_this.isValid = true;
		} else if (data.search(/^[01][0-9]{7}$/) !== -1) {
			_this.middleDigits = data.substring(1, data.length - 1);
			_this.upcA = expandToUPCA(_this.middleDigits, data[0]);

			if (_this.upcA[_this.upcA.length - 1] === data[data.length - 1]) {
				_this.isValid = true;
			} else {
				// checksum mismatch
				return _possibleConstructorReturn(_this);
			}
		} else {
			return _possibleConstructorReturn(_this);
		}

		_this.displayValue = options.displayValue;

		// Make sure the font is not bigger than the space between the guard bars
		if (options.fontSize > options.width * 10) {
			_this.fontSize = options.width * 10;
		} else {
			_this.fontSize = options.fontSize;
		}

		// Make the guard bars go down half the way of the text
		_this.guardHeight = options.height + _this.fontSize / 2 + options.textMargin;
		return _this;
	}

	_createClass(UPCE, [{
		key: 'valid',
		value: function valid() {
			return this.isValid;
		}
	}, {
		key: 'encode',
		value: function encode() {
			if (this.options.flat) {
				return this.flatEncoding();
			} else {
				return this.guardedEncoding();
			}
		}
	}, {
		key: 'flatEncoding',
		value: function flatEncoding() {
			var result = "";

			result += "101";
			result += this.encodeMiddleDigits();
			result += "010101";

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: 'guardedEncoding',
		value: function guardedEncoding() {
			var result = [];

			// Add the UPC-A number system digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[0],
					options: { textAlign: "left", fontSize: this.fontSize }
				});
			}

			// Add the guard bars
			result.push({
				data: "101",
				options: { height: this.guardHeight }
			});

			// Add the 6 UPC-E digits
			result.push({
				data: this.encodeMiddleDigits(),
				text: this.text.substring(1, 7),
				options: { fontSize: this.fontSize }
			});

			// Add the end bits
			result.push({
				data: "010101",
				options: { height: this.guardHeight }
			});

			// Add the UPC-A check digit beneath the quiet zone
			if (this.displayValue) {
				result.push({
					data: "00000000",
					text: this.text[7],
					options: { textAlign: "right", fontSize: this.fontSize }
				});
			}

			return result;
		}
	}, {
		key: 'encodeMiddleDigits',
		value: function encodeMiddleDigits() {
			var numberSystem = this.upcA[0];
			var checkDigit = this.upcA[this.upcA.length - 1];
			var parity = PARITIES[parseInt(checkDigit)][parseInt(numberSystem)];
			return (0, _encoder2.default)(this.middleDigits, parity);
		}
	}]);

	return UPCE;
}(_Barcode3.default);

function expandToUPCA(middleDigits, numberSystem) {
	var lastUpcE = parseInt(middleDigits[middleDigits.length - 1]);
	var expansion = EXPANSIONS[lastUpcE];

	var result = "";
	var digitIndex = 0;
	for (var i = 0; i < expansion.length; i++) {
		var c = expansion[i];
		if (c === 'X') {
			result += middleDigits[digitIndex++];
		} else {
			result += c;
		}
	}

	result = '' + numberSystem + result;
	return '' + result + (0, _UPC.checksum)(result);
}

exports.default = UPCE;
},{"../Barcode.js":51,"./UPC.js":66,"./encoder":69}],68:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
// Standard start end and middle bits
var SIDE_BIN = exports.SIDE_BIN = '101';
var MIDDLE_BIN = exports.MIDDLE_BIN = '01010';

var BINARIES = exports.BINARIES = {
	'L': [// The L (left) type of encoding
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'G': [// The G type of encoding
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111'],
	'R': [// The R (right) type of encoding
	'1110010', '1100110', '1101100', '1000010', '1011100', '1001110', '1010000', '1000100', '1001000', '1110100'],
	'O': [// The O (odd) encoding for UPC-E
	'0001101', '0011001', '0010011', '0111101', '0100011', '0110001', '0101111', '0111011', '0110111', '0001011'],
	'E': [// The E (even) encoding for UPC-E
	'0100111', '0110011', '0011011', '0100001', '0011101', '0111001', '0000101', '0010001', '0001001', '0010111']
};

// Define the EAN-2 structure
var EAN2_STRUCTURE = exports.EAN2_STRUCTURE = ['LL', 'LG', 'GL', 'GG'];

// Define the EAN-5 structure
var EAN5_STRUCTURE = exports.EAN5_STRUCTURE = ['GGLLL', 'GLGLL', 'GLLGL', 'GLLLG', 'LGGLL', 'LLGGL', 'LLLGG', 'LGLGL', 'LGLLG', 'LLGLG'];

// Define the EAN-13 structure
var EAN13_STRUCTURE = exports.EAN13_STRUCTURE = ['LLLLLL', 'LLGLGG', 'LLGGLG', 'LLGGGL', 'LGLLGG', 'LGGLLG', 'LGGGLL', 'LGLGLG', 'LGLGGL', 'LGGLGL'];
},{}],69:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _constants = require('./constants');

// Encode data string
var encode = function encode(data, structure, separator) {
	var encoded = data.split('').map(function (val, idx) {
		return _constants.BINARIES[structure[idx]];
	}).map(function (val, idx) {
		return val ? val[data[idx]] : '';
	});

	if (separator) {
		var last = data.length - 1;
		encoded = encoded.map(function (val, idx) {
			return idx < last ? val + separator : val;
		});
	}

	return encoded.join('');
};

exports.default = encode;
},{"./constants":68}],70:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPCE = exports.UPC = exports.EAN2 = exports.EAN5 = exports.EAN8 = exports.EAN13 = undefined;

var _EAN = require('./EAN13.js');

var _EAN2 = _interopRequireDefault(_EAN);

var _EAN3 = require('./EAN8.js');

var _EAN4 = _interopRequireDefault(_EAN3);

var _EAN5 = require('./EAN5.js');

var _EAN6 = _interopRequireDefault(_EAN5);

var _EAN7 = require('./EAN2.js');

var _EAN8 = _interopRequireDefault(_EAN7);

var _UPC = require('./UPC.js');

var _UPC2 = _interopRequireDefault(_UPC);

var _UPCE = require('./UPCE.js');

var _UPCE2 = _interopRequireDefault(_UPCE);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.EAN13 = _EAN2.default;
exports.EAN8 = _EAN4.default;
exports.EAN5 = _EAN6.default;
exports.EAN2 = _EAN8.default;
exports.UPC = _UPC2.default;
exports.UPCE = _UPCE2.default;
},{"./EAN13.js":62,"./EAN2.js":63,"./EAN5.js":64,"./EAN8.js":65,"./UPC.js":66,"./UPCE.js":67}],71:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.GenericBarcode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericBarcode = function (_Barcode) {
	_inherits(GenericBarcode, _Barcode);

	function GenericBarcode(data, options) {
		_classCallCheck(this, GenericBarcode);

		return _possibleConstructorReturn(this, (GenericBarcode.__proto__ || Object.getPrototypeOf(GenericBarcode)).call(this, data, options)); // Sets this.data and this.text
	}

	// Return the corresponding binary numbers for the data provided


	_createClass(GenericBarcode, [{
		key: "encode",
		value: function encode() {
			return {
				data: "10101010101010101010101010101010101010101",
				text: this.text
			};
		}

		// Resturn true/false if the string provided is valid for this encoder

	}, {
		key: "valid",
		value: function valid() {
			return true;
		}
	}]);

	return GenericBarcode;
}(_Barcode3.default);

exports.GenericBarcode = GenericBarcode;
},{"../Barcode.js":51}],72:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _constants = require('./constants');

var _Barcode2 = require('../Barcode');

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ITF = function (_Barcode) {
	_inherits(ITF, _Barcode);

	function ITF() {
		_classCallCheck(this, ITF);

		return _possibleConstructorReturn(this, (ITF.__proto__ || Object.getPrototypeOf(ITF)).apply(this, arguments));
	}

	_createClass(ITF, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^([0-9]{2})+$/) !== -1;
		}
	}, {
		key: 'encode',
		value: function encode() {
			var _this2 = this;

			// Calculate all the digit pairs
			var encoded = this.data.match(/.{2}/g).map(function (pair) {
				return _this2.encodePair(pair);
			}).join('');

			return {
				data: _constants.START_BIN + encoded + _constants.END_BIN,
				text: this.text
			};
		}

		// Calculate the data of a number pair

	}, {
		key: 'encodePair',
		value: function encodePair(pair) {
			var second = _constants.BINARIES[pair[1]];

			return _constants.BINARIES[pair[0]].split('').map(function (first, idx) {
				return (first === '1' ? '111' : '1') + (second[idx] === '1' ? '000' : '0');
			}).join('');
		}
	}]);

	return ITF;
}(_Barcode3.default);

exports.default = ITF;
},{"../Barcode":51,"./constants":74}],73:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ITF2 = require('./ITF');

var _ITF3 = _interopRequireDefault(_ITF2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Calculate the checksum digit
var checksum = function checksum(data) {
	var res = data.substr(0, 13).split('').map(function (num) {
		return parseInt(num, 10);
	}).reduce(function (sum, n, idx) {
		return sum + n * (3 - idx % 2 * 2);
	}, 0);

	return Math.ceil(res / 10) * 10 - res;
};

var ITF14 = function (_ITF) {
	_inherits(ITF14, _ITF);

	function ITF14(data, options) {
		_classCallCheck(this, ITF14);

		// Add checksum if it does not exist
		if (data.search(/^[0-9]{13}$/) !== -1) {
			data += checksum(data);
		}
		return _possibleConstructorReturn(this, (ITF14.__proto__ || Object.getPrototypeOf(ITF14)).call(this, data, options));
	}

	_createClass(ITF14, [{
		key: 'valid',
		value: function valid() {
			return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === checksum(this.data);
		}
	}]);

	return ITF14;
}(_ITF3.default);

exports.default = ITF14;
},{"./ITF":72}],74:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
var START_BIN = exports.START_BIN = '1010';
var END_BIN = exports.END_BIN = '11101';

var BINARIES = exports.BINARIES = ['00110', '10001', '01001', '11000', '00101', '10100', '01100', '00011', '10010', '01010'];
},{}],75:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITF14 = exports.ITF = undefined;

var _ITF = require('./ITF');

var _ITF2 = _interopRequireDefault(_ITF);

var _ITF3 = require('./ITF14');

var _ITF4 = _interopRequireDefault(_ITF3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ITF = _ITF2.default;
exports.ITF14 = _ITF4.default;
},{"./ITF":72,"./ITF14":73}],76:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// https://en.wikipedia.org/wiki/MSI_Barcode#Character_set_and_binary_lookup

var MSI = function (_Barcode) {
	_inherits(MSI, _Barcode);

	function MSI(data, options) {
		_classCallCheck(this, MSI);

		return _possibleConstructorReturn(this, (MSI.__proto__ || Object.getPrototypeOf(MSI)).call(this, data, options));
	}

	_createClass(MSI, [{
		key: "encode",
		value: function encode() {
			// Start bits
			var ret = "110";

			for (var i = 0; i < this.data.length; i++) {
				// Convert the character to binary (always 4 binary digits)
				var digit = parseInt(this.data[i]);
				var bin = digit.toString(2);
				bin = addZeroes(bin, 4 - bin.length);

				// Add 100 for every zero and 110 for every 1
				for (var b = 0; b < bin.length; b++) {
					ret += bin[b] == "0" ? "100" : "110";
				}
			}

			// End bits
			ret += "1001";

			return {
				data: ret,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.data.search(/^[0-9]+$/) !== -1;
		}
	}]);

	return MSI;
}(_Barcode3.default);

function addZeroes(number, n) {
	for (var i = 0; i < n; i++) {
		number = "0" + number;
	}
	return number;
}

exports.default = MSI;
},{"../Barcode.js":51}],77:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = require('./MSI.js');

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = require('./checksums.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI10 = function (_MSI) {
	_inherits(MSI10, _MSI);

	function MSI10(data, options) {
		_classCallCheck(this, MSI10);

		return _possibleConstructorReturn(this, (MSI10.__proto__ || Object.getPrototypeOf(MSI10)).call(this, data + (0, _checksums.mod10)(data), options));
	}

	return MSI10;
}(_MSI3.default);

exports.default = MSI10;
},{"./MSI.js":76,"./checksums.js":81}],78:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = require('./MSI.js');

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = require('./checksums.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1010 = function (_MSI) {
	_inherits(MSI1010, _MSI);

	function MSI1010(data, options) {
		_classCallCheck(this, MSI1010);

		data += (0, _checksums.mod10)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1010.__proto__ || Object.getPrototypeOf(MSI1010)).call(this, data, options));
	}

	return MSI1010;
}(_MSI3.default);

exports.default = MSI1010;
},{"./MSI.js":76,"./checksums.js":81}],79:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = require('./MSI.js');

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = require('./checksums.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI11 = function (_MSI) {
	_inherits(MSI11, _MSI);

	function MSI11(data, options) {
		_classCallCheck(this, MSI11);

		return _possibleConstructorReturn(this, (MSI11.__proto__ || Object.getPrototypeOf(MSI11)).call(this, data + (0, _checksums.mod11)(data), options));
	}

	return MSI11;
}(_MSI3.default);

exports.default = MSI11;
},{"./MSI.js":76,"./checksums.js":81}],80:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _MSI2 = require('./MSI.js');

var _MSI3 = _interopRequireDefault(_MSI2);

var _checksums = require('./checksums.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MSI1110 = function (_MSI) {
	_inherits(MSI1110, _MSI);

	function MSI1110(data, options) {
		_classCallCheck(this, MSI1110);

		data += (0, _checksums.mod11)(data);
		data += (0, _checksums.mod10)(data);
		return _possibleConstructorReturn(this, (MSI1110.__proto__ || Object.getPrototypeOf(MSI1110)).call(this, data, options));
	}

	return MSI1110;
}(_MSI3.default);

exports.default = MSI1110;
},{"./MSI.js":76,"./checksums.js":81}],81:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.mod10 = mod10;
exports.mod11 = mod11;
function mod10(number) {
	var sum = 0;
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[i]);
		if ((i + number.length) % 2 === 0) {
			sum += n;
		} else {
			sum += n * 2 % 10 + Math.floor(n * 2 / 10);
		}
	}
	return (10 - sum % 10) % 10;
}

function mod11(number) {
	var sum = 0;
	var weights = [2, 3, 4, 5, 6, 7];
	for (var i = 0; i < number.length; i++) {
		var n = parseInt(number[number.length - 1 - i]);
		sum += weights[i % weights.length] * n;
	}
	return (11 - sum % 11) % 11;
}
},{}],82:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MSI1110 = exports.MSI1010 = exports.MSI11 = exports.MSI10 = exports.MSI = undefined;

var _MSI = require('./MSI.js');

var _MSI2 = _interopRequireDefault(_MSI);

var _MSI3 = require('./MSI10.js');

var _MSI4 = _interopRequireDefault(_MSI3);

var _MSI5 = require('./MSI11.js');

var _MSI6 = _interopRequireDefault(_MSI5);

var _MSI7 = require('./MSI1010.js');

var _MSI8 = _interopRequireDefault(_MSI7);

var _MSI9 = require('./MSI1110.js');

var _MSI10 = _interopRequireDefault(_MSI9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MSI = _MSI2.default;
exports.MSI10 = _MSI4.default;
exports.MSI11 = _MSI6.default;
exports.MSI1010 = _MSI8.default;
exports.MSI1110 = _MSI10.default;
},{"./MSI.js":76,"./MSI10.js":77,"./MSI1010.js":78,"./MSI11.js":79,"./MSI1110.js":80}],83:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.codabar = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding specification:
// http://www.barcodeisland.com/codabar.phtml

var codabar = function (_Barcode) {
	_inherits(codabar, _Barcode);

	function codabar(data, options) {
		_classCallCheck(this, codabar);

		if (data.search(/^[0-9\-\$\:\.\+\/]+$/) === 0) {
			data = "A" + data + "A";
		}

		var _this = _possibleConstructorReturn(this, (codabar.__proto__ || Object.getPrototypeOf(codabar)).call(this, data.toUpperCase(), options));

		_this.text = _this.options.text || _this.text.replace(/[A-D]/g, '');
		return _this;
	}

	_createClass(codabar, [{
		key: "valid",
		value: function valid() {
			return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
		}
	}, {
		key: "encode",
		value: function encode() {
			var result = [];
			var encodings = this.getEncodings();
			for (var i = 0; i < this.data.length; i++) {
				result.push(encodings[this.data.charAt(i)]);
				// for all characters except the last, append a narrow-space ("0")
				if (i !== this.data.length - 1) {
					result.push("0");
				}
			}
			return {
				text: this.text,
				data: result.join('')
			};
		}
	}, {
		key: "getEncodings",
		value: function getEncodings() {
			return {
				"0": "101010011",
				"1": "101011001",
				"2": "101001011",
				"3": "110010101",
				"4": "101101001",
				"5": "110101001",
				"6": "100101011",
				"7": "100101101",
				"8": "100110101",
				"9": "110100101",
				"-": "101001101",
				"$": "101100101",
				":": "1101011011",
				"/": "1101101011",
				".": "1101101101",
				"+": "1011011011",
				"A": "1011001001",
				"B": "1001001011",
				"C": "1010010011",
				"D": "1010011001"
			};
		}
	}]);

	return codabar;
}(_Barcode3.default);

exports.codabar = codabar;
},{"../Barcode.js":51}],84:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _CODE = require('./CODE39/');

var _CODE2 = require('./CODE128/');

var _EAN_UPC = require('./EAN_UPC/');

var _ITF = require('./ITF/');

var _MSI = require('./MSI/');

var _pharmacode = require('./pharmacode/');

var _codabar = require('./codabar');

var _GenericBarcode = require('./GenericBarcode/');

exports.default = {
	CODE39: _CODE.CODE39,
	CODE128: _CODE2.CODE128, CODE128A: _CODE2.CODE128A, CODE128B: _CODE2.CODE128B, CODE128C: _CODE2.CODE128C,
	EAN13: _EAN_UPC.EAN13, EAN8: _EAN_UPC.EAN8, EAN5: _EAN_UPC.EAN5, EAN2: _EAN_UPC.EAN2, UPC: _EAN_UPC.UPC, UPCE: _EAN_UPC.UPCE,
	ITF14: _ITF.ITF14,
	ITF: _ITF.ITF,
	MSI: _MSI.MSI, MSI10: _MSI.MSI10, MSI11: _MSI.MSI11, MSI1010: _MSI.MSI1010, MSI1110: _MSI.MSI1110,
	pharmacode: _pharmacode.pharmacode,
	codabar: _codabar.codabar,
	GenericBarcode: _GenericBarcode.GenericBarcode
};
},{"./CODE128/":59,"./CODE39/":60,"./EAN_UPC/":70,"./GenericBarcode/":71,"./ITF/":75,"./MSI/":82,"./codabar":83,"./pharmacode/":85}],85:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.pharmacode = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Barcode2 = require("../Barcode.js");

var _Barcode3 = _interopRequireDefault(_Barcode2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Encoding documentation
// http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf

var pharmacode = function (_Barcode) {
	_inherits(pharmacode, _Barcode);

	function pharmacode(data, options) {
		_classCallCheck(this, pharmacode);

		var _this = _possibleConstructorReturn(this, (pharmacode.__proto__ || Object.getPrototypeOf(pharmacode)).call(this, data, options));

		_this.number = parseInt(data, 10);
		return _this;
	}

	_createClass(pharmacode, [{
		key: "encode",
		value: function encode() {
			var z = this.number;
			var result = "";

			// http://i.imgur.com/RMm4UDJ.png
			// (source: http://www.gomaro.ch/ftproot/Laetus_PHARMA-CODE.pdf, page: 34)
			while (!isNaN(z) && z != 0) {
				if (z % 2 === 0) {
					// Even
					result = "11100" + result;
					z = (z - 2) / 2;
				} else {
					// Odd
					result = "100" + result;
					z = (z - 1) / 2;
				}
			}

			// Remove the two last zeroes
			result = result.slice(0, -2);

			return {
				data: result,
				text: this.text
			};
		}
	}, {
		key: "valid",
		value: function valid() {
			return this.number >= 3 && this.number <= 131070;
		}
	}]);

	return pharmacode;
}(_Barcode3.default);

exports.pharmacode = pharmacode;
},{"../Barcode.js":51}],86:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*eslint no-console: 0 */

var ErrorHandler = function () {
	function ErrorHandler(api) {
		_classCallCheck(this, ErrorHandler);

		this.api = api;
	}

	_createClass(ErrorHandler, [{
		key: "handleCatch",
		value: function handleCatch(e) {
			// If babel supported extending of Error in a correct way instanceof would be used here
			if (e.name === "InvalidInputException") {
				if (this.api._options.valid !== this.api._defaults.valid) {
					this.api._options.valid(false);
				} else {
					throw e.message;
				}
			} else {
				throw e;
			}

			this.api.render = function () {};
		}
	}, {
		key: "wrapBarcodeCall",
		value: function wrapBarcodeCall(func) {
			try {
				var result = func.apply(undefined, arguments);
				this.api._options.valid(true);
				return result;
			} catch (e) {
				this.handleCatch(e);

				return this.api;
			}
		}
	}]);

	return ErrorHandler;
}();

exports.default = ErrorHandler;
},{}],87:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InvalidInputException = function (_Error) {
	_inherits(InvalidInputException, _Error);

	function InvalidInputException(symbology, input) {
		_classCallCheck(this, InvalidInputException);

		var _this = _possibleConstructorReturn(this, (InvalidInputException.__proto__ || Object.getPrototypeOf(InvalidInputException)).call(this));

		_this.name = "InvalidInputException";

		_this.symbology = symbology;
		_this.input = input;

		_this.message = '"' + _this.input + '" is not a valid input for ' + _this.symbology;
		return _this;
	}

	return InvalidInputException;
}(Error);

var InvalidElementException = function (_Error2) {
	_inherits(InvalidElementException, _Error2);

	function InvalidElementException() {
		_classCallCheck(this, InvalidElementException);

		var _this2 = _possibleConstructorReturn(this, (InvalidElementException.__proto__ || Object.getPrototypeOf(InvalidElementException)).call(this));

		_this2.name = "InvalidElementException";
		_this2.message = "Not supported type to render on";
		return _this2;
	}

	return InvalidElementException;
}(Error);

var NoElementException = function (_Error3) {
	_inherits(NoElementException, _Error3);

	function NoElementException() {
		_classCallCheck(this, NoElementException);

		var _this3 = _possibleConstructorReturn(this, (NoElementException.__proto__ || Object.getPrototypeOf(NoElementException)).call(this));

		_this3.name = "NoElementException";
		_this3.message = "No element to render on.";
		return _this3;
	}

	return NoElementException;
}(Error);

exports.InvalidInputException = InvalidInputException;
exports.InvalidElementException = InvalidElementException;
exports.NoElementException = NoElementException;
},{}],88:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = fixOptions;


function fixOptions(options) {
	// Fix the margins
	options.marginTop = options.marginTop || options.margin;
	options.marginBottom = options.marginBottom || options.margin;
	options.marginRight = options.marginRight || options.margin;
	options.marginLeft = options.marginLeft || options.margin;

	return options;
}
},{}],89:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _optionsFromStrings = require("./optionsFromStrings.js");

var _optionsFromStrings2 = _interopRequireDefault(_optionsFromStrings);

var _defaults = require("../options/defaults.js");

var _defaults2 = _interopRequireDefault(_defaults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getOptionsFromElement(element) {
	var options = {};
	for (var property in _defaults2.default) {
		if (_defaults2.default.hasOwnProperty(property)) {
			// jsbarcode-*
			if (element.hasAttribute("jsbarcode-" + property.toLowerCase())) {
				options[property] = element.getAttribute("jsbarcode-" + property.toLowerCase());
			}

			// data-*
			if (element.hasAttribute("data-" + property.toLowerCase())) {
				options[property] = element.getAttribute("data-" + property.toLowerCase());
			}
		}
	}

	options["value"] = element.getAttribute("jsbarcode-value") || element.getAttribute("data-value");

	// Since all atributes are string they need to be converted to integers
	options = (0, _optionsFromStrings2.default)(options);

	return options;
}

exports.default = getOptionsFromElement;
},{"../options/defaults.js":94,"./optionsFromStrings.js":93}],90:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /* global HTMLImageElement */
/* global HTMLCanvasElement */
/* global SVGElement */

var _getOptionsFromElement = require("./getOptionsFromElement.js");

var _getOptionsFromElement2 = _interopRequireDefault(_getOptionsFromElement);

var _renderers = require("../renderers");

var _renderers2 = _interopRequireDefault(_renderers);

var _exceptions = require("../exceptions/exceptions.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Takes an element and returns an object with information about how
// it should be rendered
// This could also return an array with these objects
// {
//   element: The element that the renderer should draw on
//   renderer: The name of the renderer
//   afterRender (optional): If something has to done after the renderer
//     completed, calls afterRender (function)
//   options (optional): Options that can be defined in the element
// }

function getRenderProperties(element) {
	// If the element is a string, query select call again
	if (typeof element === "string") {
		return querySelectedRenderProperties(element);
	}
	// If element is array. Recursivly call with every object in the array
	else if (Array.isArray(element)) {
			var returnArray = [];
			for (var i = 0; i < element.length; i++) {
				returnArray.push(getRenderProperties(element[i]));
			}
			return returnArray;
		}
		// If element, render on canvas and set the uri as src
		else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLImageElement) {
				return newCanvasRenderProperties(element);
			}
			// If SVG
			else if (element && element.nodeName && element.nodeName.toLowerCase() === 'svg' || typeof SVGElement !== 'undefined' && element instanceof SVGElement) {
					return {
						element: element,
						options: (0, _getOptionsFromElement2.default)(element),
						renderer: _renderers2.default.SVGRenderer
					};
				}
				// If canvas (in browser)
				else if (typeof HTMLCanvasElement !== 'undefined' && element instanceof HTMLCanvasElement) {
						return {
							element: element,
							options: (0, _getOptionsFromElement2.default)(element),
							renderer: _renderers2.default.CanvasRenderer
						};
					}
					// If canvas (in node)
					else if (element && element.getContext) {
							return {
								element: element,
								renderer: _renderers2.default.CanvasRenderer
							};
						} else if (element && (typeof element === "undefined" ? "undefined" : _typeof(element)) === 'object' && !element.nodeName) {
							return {
								element: element,
								renderer: _renderers2.default.ObjectRenderer
							};
						} else {
							throw new _exceptions.InvalidElementException();
						}
}

function querySelectedRenderProperties(string) {
	var selector = document.querySelectorAll(string);
	if (selector.length === 0) {
		return undefined;
	} else {
		var returnArray = [];
		for (var i = 0; i < selector.length; i++) {
			returnArray.push(getRenderProperties(selector[i]));
		}
		return returnArray;
	}
}

function newCanvasRenderProperties(imgElement) {
	var canvas = document.createElement('canvas');
	return {
		element: canvas,
		options: (0, _getOptionsFromElement2.default)(imgElement),
		renderer: _renderers2.default.CanvasRenderer,
		afterRender: function afterRender() {
			imgElement.setAttribute("src", canvas.toDataURL());
		}
	};
}

exports.default = getRenderProperties;
},{"../exceptions/exceptions.js":87,"../renderers":96,"./getOptionsFromElement.js":89}],91:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = linearizeEncodings;

// Encodings can be nestled like [[1-1, 1-2], 2, [3-1, 3-2]
// Convert to [1-1, 1-2, 2, 3-1, 3-2]

function linearizeEncodings(encodings) {
	var linearEncodings = [];
	function nextLevel(encoded) {
		if (Array.isArray(encoded)) {
			for (var i = 0; i < encoded.length; i++) {
				nextLevel(encoded[i]);
			}
		} else {
			encoded.text = encoded.text || "";
			encoded.data = encoded.data || "";
			linearEncodings.push(encoded);
		}
	}
	nextLevel(encodings);

	return linearEncodings;
}
},{}],92:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (old, replaceObj) {
  return _extends({}, old, replaceObj);
};
},{}],93:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = optionsFromStrings;

// Convert string to integers/booleans where it should be

function optionsFromStrings(options) {
	var intOptions = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];

	for (var intOption in intOptions) {
		if (intOptions.hasOwnProperty(intOption)) {
			intOption = intOptions[intOption];
			if (typeof options[intOption] === "string") {
				options[intOption] = parseInt(options[intOption], 10);
			}
		}
	}

	if (typeof options["displayValue"] === "string") {
		options["displayValue"] = options["displayValue"] != "false";
	}

	return options;
}
},{}],94:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
var defaults = {
	width: 2,
	height: 100,
	format: "auto",
	displayValue: true,
	fontOptions: "",
	font: "monospace",
	text: undefined,
	textAlign: "center",
	textPosition: "bottom",
	textMargin: 2,
	fontSize: 20,
	background: "#ffffff",
	lineColor: "#000000",
	margin: 10,
	marginTop: undefined,
	marginBottom: undefined,
	marginLeft: undefined,
	marginRight: undefined,
	valid: function valid() {}
};

exports.default = defaults;
},{}],95:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = require("../help/merge.js");

var _merge2 = _interopRequireDefault(_merge);

var _shared = require("./shared.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CanvasRenderer = function () {
	function CanvasRenderer(canvas, encodings, options) {
		_classCallCheck(this, CanvasRenderer);

		this.canvas = canvas;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(CanvasRenderer, [{
		key: "render",
		value: function render() {
			// Abort if the browser does not support HTML5 canvas
			if (!this.canvas.getContext) {
				throw new Error('The browser does not support canvas.');
			}

			this.prepareCanvas();
			for (var i = 0; i < this.encodings.length; i++) {
				var encodingOptions = (0, _merge2.default)(this.options, this.encodings[i].options);

				this.drawCanvasBarcode(encodingOptions, this.encodings[i]);
				this.drawCanvasText(encodingOptions, this.encodings[i]);

				this.moveCanvasDrawing(this.encodings[i]);
			}

			this.restoreCanvas();
		}
	}, {
		key: "prepareCanvas",
		value: function prepareCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.save();

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options, ctx);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			this.canvas.width = totalWidth + this.options.marginLeft + this.options.marginRight;

			this.canvas.height = maxHeight;

			// Paint the canvas
			ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
			if (this.options.background) {
				ctx.fillStyle = this.options.background;
				ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
			}

			ctx.translate(this.options.marginLeft, 0);
		}
	}, {
		key: "drawCanvasBarcode",
		value: function drawCanvasBarcode(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.marginTop + options.fontSize + options.textMargin;
			} else {
				yFrom = options.marginTop;
			}

			ctx.fillStyle = options.lineColor;

			for (var b = 0; b < binary.length; b++) {
				var x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					ctx.fillRect(x, yFrom, options.width, options.height);
				} else if (binary[b]) {
					ctx.fillRect(x, yFrom, options.width, options.height * binary[b]);
				}
			}
		}
	}, {
		key: "drawCanvasText",
		value: function drawCanvasText(options, encoding) {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			var font = options.fontOptions + " " + options.fontSize + "px " + options.font;

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				if (options.textPosition == "top") {
					y = options.marginTop + options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.marginTop + options.fontSize;
				}

				ctx.font = font;

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					ctx.textAlign = 'left';
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					ctx.textAlign = 'right';
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						ctx.textAlign = 'center';
					}

				ctx.fillText(encoding.text, x, y);
			}
		}
	}, {
		key: "moveCanvasDrawing",
		value: function moveCanvasDrawing(encoding) {
			var ctx = this.canvas.getContext("2d");

			ctx.translate(encoding.width, 0);
		}
	}, {
		key: "restoreCanvas",
		value: function restoreCanvas() {
			// Get the canvas context
			var ctx = this.canvas.getContext("2d");

			ctx.restore();
		}
	}]);

	return CanvasRenderer;
}();

exports.default = CanvasRenderer;
},{"../help/merge.js":92,"./shared.js":98}],96:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _canvas = require('./canvas.js');

var _canvas2 = _interopRequireDefault(_canvas);

var _svg = require('./svg.js');

var _svg2 = _interopRequireDefault(_svg);

var _object = require('./object.js');

var _object2 = _interopRequireDefault(_object);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { CanvasRenderer: _canvas2.default, SVGRenderer: _svg2.default, ObjectRenderer: _object2.default };
},{"./canvas.js":95,"./object.js":97,"./svg.js":99}],97:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ObjectRenderer = function () {
	function ObjectRenderer(object, encodings, options) {
		_classCallCheck(this, ObjectRenderer);

		this.object = object;
		this.encodings = encodings;
		this.options = options;
	}

	_createClass(ObjectRenderer, [{
		key: "render",
		value: function render() {
			this.object.encodings = this.encodings;
		}
	}]);

	return ObjectRenderer;
}();

exports.default = ObjectRenderer;
},{}],98:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getTotalWidthOfEncodings = exports.calculateEncodingAttributes = exports.getBarcodePadding = exports.getEncodingHeight = exports.getMaximumHeightOfEncodings = undefined;

var _merge = require("../help/merge.js");

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getEncodingHeight(encoding, options) {
	return options.height + (options.displayValue && encoding.text.length > 0 ? options.fontSize + options.textMargin : 0) + options.marginTop + options.marginBottom;
}

function getBarcodePadding(textWidth, barcodeWidth, options) {
	if (options.displayValue && barcodeWidth < textWidth) {
		if (options.textAlign == "center") {
			return Math.floor((textWidth - barcodeWidth) / 2);
		} else if (options.textAlign == "left") {
			return 0;
		} else if (options.textAlign == "right") {
			return Math.floor(textWidth - barcodeWidth);
		}
	}
	return 0;
}

function calculateEncodingAttributes(encodings, barcodeOptions, context) {
	for (var i = 0; i < encodings.length; i++) {
		var encoding = encodings[i];
		var options = (0, _merge2.default)(barcodeOptions, encoding.options);

		// Calculate the width of the encoding
		var textWidth;
		if (options.displayValue) {
			textWidth = messureText(encoding.text, options, context);
		} else {
			textWidth = 0;
		}

		var barcodeWidth = encoding.data.length * options.width;
		encoding.width = Math.ceil(Math.max(textWidth, barcodeWidth));

		encoding.height = getEncodingHeight(encoding, options);

		encoding.barcodePadding = getBarcodePadding(textWidth, barcodeWidth, options);
	}
}

function getTotalWidthOfEncodings(encodings) {
	var totalWidth = 0;
	for (var i = 0; i < encodings.length; i++) {
		totalWidth += encodings[i].width;
	}
	return totalWidth;
}

function getMaximumHeightOfEncodings(encodings) {
	var maxHeight = 0;
	for (var i = 0; i < encodings.length; i++) {
		if (encodings[i].height > maxHeight) {
			maxHeight = encodings[i].height;
		}
	}
	return maxHeight;
}

function messureText(string, options, context) {
	var ctx;

	if (context) {
		ctx = context;
	} else if (typeof document !== "undefined") {
		ctx = document.createElement("canvas").getContext("2d");
	} else {
		// If the text cannot be messured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	ctx.font = options.fontOptions + " " + options.fontSize + "px " + options.font;

	// Calculate the width of the encoding
	var measureTextResult = ctx.measureText(string);
	if (!measureTextResult) {
		// Some implementations don't implement measureText and return undefined.
		// If the text cannot be measured we will return 0.
		// This will make some barcode with big text render incorrectly
		return 0;
	}
	var size = measureTextResult.width;
	return size;
}

exports.getMaximumHeightOfEncodings = getMaximumHeightOfEncodings;
exports.getEncodingHeight = getEncodingHeight;
exports.getBarcodePadding = getBarcodePadding;
exports.calculateEncodingAttributes = calculateEncodingAttributes;
exports.getTotalWidthOfEncodings = getTotalWidthOfEncodings;
},{"../help/merge.js":92}],99:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _merge = require("../help/merge.js");

var _merge2 = _interopRequireDefault(_merge);

var _shared = require("./shared.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgns = "http://www.w3.org/2000/svg";

var SVGRenderer = function () {
	function SVGRenderer(svg, encodings, options) {
		_classCallCheck(this, SVGRenderer);

		this.svg = svg;
		this.encodings = encodings;
		this.options = options;
		this.document = options.xmlDocument || document;
	}

	_createClass(SVGRenderer, [{
		key: "render",
		value: function render() {
			var currentX = this.options.marginLeft;

			this.prepareSVG();
			for (var i = 0; i < this.encodings.length; i++) {
				var encoding = this.encodings[i];
				var encodingOptions = (0, _merge2.default)(this.options, encoding.options);

				var group = this.createGroup(currentX, encodingOptions.marginTop, this.svg);

				this.setGroupOptions(group, encodingOptions);

				this.drawSvgBarcode(group, encodingOptions, encoding);
				this.drawSVGText(group, encodingOptions, encoding);

				currentX += encoding.width;
			}
		}
	}, {
		key: "prepareSVG",
		value: function prepareSVG() {
			// Clear the SVG
			while (this.svg.firstChild) {
				this.svg.removeChild(this.svg.firstChild);
			}

			(0, _shared.calculateEncodingAttributes)(this.encodings, this.options);
			var totalWidth = (0, _shared.getTotalWidthOfEncodings)(this.encodings);
			var maxHeight = (0, _shared.getMaximumHeightOfEncodings)(this.encodings);

			var width = totalWidth + this.options.marginLeft + this.options.marginRight;
			this.setSvgAttributes(width, maxHeight);

			if (this.options.background) {
				this.drawRect(0, 0, width, maxHeight, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
			}
		}
	}, {
		key: "drawSvgBarcode",
		value: function drawSvgBarcode(parent, options, encoding) {
			var binary = encoding.data;

			// Creates the barcode out of the encoded binary
			var yFrom;
			if (options.textPosition == "top") {
				yFrom = options.fontSize + options.textMargin;
			} else {
				yFrom = 0;
			}

			var barWidth = 0;
			var x = 0;
			for (var b = 0; b < binary.length; b++) {
				x = b * options.width + encoding.barcodePadding;

				if (binary[b] === "1") {
					barWidth++;
				} else if (barWidth > 0) {
					this.drawRect(x - options.width * barWidth, yFrom, options.width * barWidth, options.height, parent);
					barWidth = 0;
				}
			}

			// Last draw is needed since the barcode ends with 1
			if (barWidth > 0) {
				this.drawRect(x - options.width * (barWidth - 1), yFrom, options.width * barWidth, options.height, parent);
			}
		}
	}, {
		key: "drawSVGText",
		value: function drawSVGText(parent, options, encoding) {
			var textElem = this.document.createElementNS(svgns, 'text');

			// Draw the text if displayValue is set
			if (options.displayValue) {
				var x, y;

				textElem.setAttribute("style", "font:" + options.fontOptions + " " + options.fontSize + "px " + options.font);

				if (options.textPosition == "top") {
					y = options.fontSize - options.textMargin;
				} else {
					y = options.height + options.textMargin + options.fontSize;
				}

				// Draw the text in the correct X depending on the textAlign option
				if (options.textAlign == "left" || encoding.barcodePadding > 0) {
					x = 0;
					textElem.setAttribute("text-anchor", "start");
				} else if (options.textAlign == "right") {
					x = encoding.width - 1;
					textElem.setAttribute("text-anchor", "end");
				}
				// In all other cases, center the text
				else {
						x = encoding.width / 2;
						textElem.setAttribute("text-anchor", "middle");
					}

				textElem.setAttribute("x", x);
				textElem.setAttribute("y", y);

				textElem.appendChild(this.document.createTextNode(encoding.text));

				parent.appendChild(textElem);
			}
		}
	}, {
		key: "setSvgAttributes",
		value: function setSvgAttributes(width, height) {
			var svg = this.svg;
			svg.setAttribute("width", width + "px");
			svg.setAttribute("height", height + "px");
			svg.setAttribute("x", "0px");
			svg.setAttribute("y", "0px");
			svg.setAttribute("viewBox", "0 0 " + width + " " + height);

			svg.setAttribute("xmlns", svgns);
			svg.setAttribute("version", "1.1");

			svg.setAttribute("style", "transform: translate(0,0)");
		}
	}, {
		key: "createGroup",
		value: function createGroup(x, y, parent) {
			var group = this.document.createElementNS(svgns, 'g');
			group.setAttribute("transform", "translate(" + x + ", " + y + ")");

			parent.appendChild(group);

			return group;
		}
	}, {
		key: "setGroupOptions",
		value: function setGroupOptions(group, options) {
			group.setAttribute("style", "fill:" + options.lineColor + ";");
		}
	}, {
		key: "drawRect",
		value: function drawRect(x, y, width, height, parent) {
			var rect = this.document.createElementNS(svgns, 'rect');

			rect.setAttribute("x", x);
			rect.setAttribute("y", y);
			rect.setAttribute("width", width);
			rect.setAttribute("height", height);

			parent.appendChild(rect);

			return rect;
		}
	}]);

	return SVGRenderer;
}();

exports.default = SVGRenderer;
},{"../help/merge.js":92,"./shared.js":98}],100:[function(require,module,exports){
var hashClear = require('./_hashClear'),
    hashDelete = require('./_hashDelete'),
    hashGet = require('./_hashGet'),
    hashHas = require('./_hashHas'),
    hashSet = require('./_hashSet');

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

},{"./_hashClear":149,"./_hashDelete":150,"./_hashGet":151,"./_hashHas":152,"./_hashSet":153}],101:[function(require,module,exports){
var listCacheClear = require('./_listCacheClear'),
    listCacheDelete = require('./_listCacheDelete'),
    listCacheGet = require('./_listCacheGet'),
    listCacheHas = require('./_listCacheHas'),
    listCacheSet = require('./_listCacheSet');

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

},{"./_listCacheClear":161,"./_listCacheDelete":162,"./_listCacheGet":163,"./_listCacheHas":164,"./_listCacheSet":165}],102:[function(require,module,exports){
var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

},{"./_getNative":145,"./_root":178}],103:[function(require,module,exports){
var mapCacheClear = require('./_mapCacheClear'),
    mapCacheDelete = require('./_mapCacheDelete'),
    mapCacheGet = require('./_mapCacheGet'),
    mapCacheHas = require('./_mapCacheHas'),
    mapCacheSet = require('./_mapCacheSet');

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

},{"./_mapCacheClear":166,"./_mapCacheDelete":167,"./_mapCacheGet":168,"./_mapCacheHas":169,"./_mapCacheSet":170}],104:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    stackClear = require('./_stackClear'),
    stackDelete = require('./_stackDelete'),
    stackGet = require('./_stackGet'),
    stackHas = require('./_stackHas'),
    stackSet = require('./_stackSet');

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

},{"./_ListCache":101,"./_stackClear":182,"./_stackDelete":183,"./_stackGet":184,"./_stackHas":185,"./_stackSet":186}],105:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

},{"./_root":178}],106:[function(require,module,exports){
var root = require('./_root');

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

},{"./_root":178}],107:[function(require,module,exports){
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

},{}],108:[function(require,module,exports){
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

},{}],109:[function(require,module,exports){
var baseTimes = require('./_baseTimes'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isBuffer = require('./isBuffer'),
    isIndex = require('./_isIndex'),
    isTypedArray = require('./isTypedArray');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

},{"./_baseTimes":130,"./_isIndex":156,"./isArguments":194,"./isArray":195,"./isBuffer":198,"./isTypedArray":205}],110:[function(require,module,exports){
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

},{}],111:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;

},{"./_baseAssignValue":114,"./eq":190}],112:[function(require,module,exports){
var baseAssignValue = require('./_baseAssignValue'),
    eq = require('./eq');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

},{"./_baseAssignValue":114,"./eq":190}],113:[function(require,module,exports){
var eq = require('./eq');

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

},{"./eq":190}],114:[function(require,module,exports){
var defineProperty = require('./_defineProperty');

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

},{"./_defineProperty":142}],115:[function(require,module,exports){
var isObject = require('./isObject');

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;

},{"./isObject":201}],116:[function(require,module,exports){
var baseForOwn = require('./_baseForOwn'),
    createBaseEach = require('./_createBaseEach');

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

},{"./_baseForOwn":119,"./_createBaseEach":140}],117:[function(require,module,exports){
var arrayPush = require('./_arrayPush'),
    isFlattenable = require('./_isFlattenable');

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;

},{"./_arrayPush":110,"./_isFlattenable":155}],118:[function(require,module,exports){
var createBaseFor = require('./_createBaseFor');

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

},{"./_createBaseFor":141}],119:[function(require,module,exports){
var baseFor = require('./_baseFor'),
    keys = require('./keys');

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

},{"./_baseFor":118,"./keys":206}],120:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    getRawTag = require('./_getRawTag'),
    objectToString = require('./_objectToString');

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;

},{"./_Symbol":105,"./_getRawTag":147,"./_objectToString":175}],121:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

},{"./_baseGetTag":120,"./isObjectLike":202}],122:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isMasked = require('./_isMasked'),
    isObject = require('./isObject'),
    toSource = require('./_toSource');

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

},{"./_isMasked":159,"./_toSource":187,"./isFunction":199,"./isObject":201}],123:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isLength = require('./isLength'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

},{"./_baseGetTag":120,"./isLength":200,"./isObjectLike":202}],124:[function(require,module,exports){
var isPrototype = require('./_isPrototype'),
    nativeKeys = require('./_nativeKeys');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

},{"./_isPrototype":160,"./_nativeKeys":172}],125:[function(require,module,exports){
var isObject = require('./isObject'),
    isPrototype = require('./_isPrototype'),
    nativeKeysIn = require('./_nativeKeysIn');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;

},{"./_isPrototype":160,"./_nativeKeysIn":173,"./isObject":201}],126:[function(require,module,exports){
var Stack = require('./_Stack'),
    assignMergeValue = require('./_assignMergeValue'),
    baseFor = require('./_baseFor'),
    baseMergeDeep = require('./_baseMergeDeep'),
    isObject = require('./isObject'),
    keysIn = require('./keysIn'),
    safeGet = require('./_safeGet');

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;

},{"./_Stack":104,"./_assignMergeValue":111,"./_baseFor":118,"./_baseMergeDeep":127,"./_safeGet":179,"./isObject":201,"./keysIn":207}],127:[function(require,module,exports){
var assignMergeValue = require('./_assignMergeValue'),
    cloneBuffer = require('./_cloneBuffer'),
    cloneTypedArray = require('./_cloneTypedArray'),
    copyArray = require('./_copyArray'),
    initCloneObject = require('./_initCloneObject'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray'),
    isArrayLikeObject = require('./isArrayLikeObject'),
    isBuffer = require('./isBuffer'),
    isFunction = require('./isFunction'),
    isObject = require('./isObject'),
    isPlainObject = require('./isPlainObject'),
    isTypedArray = require('./isTypedArray'),
    safeGet = require('./_safeGet'),
    toPlainObject = require('./toPlainObject');

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;

},{"./_assignMergeValue":111,"./_cloneBuffer":134,"./_cloneTypedArray":135,"./_copyArray":136,"./_initCloneObject":154,"./_safeGet":179,"./isArguments":194,"./isArray":195,"./isArrayLikeObject":197,"./isBuffer":198,"./isFunction":199,"./isObject":201,"./isPlainObject":203,"./isTypedArray":205,"./toPlainObject":211}],128:[function(require,module,exports){
var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

},{"./_overRest":177,"./_setToString":180,"./identity":193}],129:[function(require,module,exports){
var constant = require('./constant'),
    defineProperty = require('./_defineProperty'),
    identity = require('./identity');

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

},{"./_defineProperty":142,"./constant":188,"./identity":193}],130:[function(require,module,exports){
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

},{}],131:[function(require,module,exports){
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;

},{}],132:[function(require,module,exports){
var identity = require('./identity');

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

},{"./identity":193}],133:[function(require,module,exports){
var Uint8Array = require('./_Uint8Array');

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;

},{"./_Uint8Array":106}],134:[function(require,module,exports){
var root = require('./_root');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

},{"./_root":178}],135:[function(require,module,exports){
var cloneArrayBuffer = require('./_cloneArrayBuffer');

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;

},{"./_cloneArrayBuffer":133}],136:[function(require,module,exports){
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;

},{}],137:[function(require,module,exports){
var assignValue = require('./_assignValue'),
    baseAssignValue = require('./_baseAssignValue');

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

},{"./_assignValue":112,"./_baseAssignValue":114}],138:[function(require,module,exports){
var root = require('./_root');

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

},{"./_root":178}],139:[function(require,module,exports){
var baseRest = require('./_baseRest'),
    isIterateeCall = require('./_isIterateeCall');

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

},{"./_baseRest":128,"./_isIterateeCall":157}],140:[function(require,module,exports){
var isArrayLike = require('./isArrayLike');

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

},{"./isArrayLike":196}],141:[function(require,module,exports){
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

},{}],142:[function(require,module,exports){
var getNative = require('./_getNative');

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;

},{"./_getNative":145}],143:[function(require,module,exports){
(function (global){(function (){
/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],144:[function(require,module,exports){
var isKeyable = require('./_isKeyable');

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;

},{"./_isKeyable":158}],145:[function(require,module,exports){
var baseIsNative = require('./_baseIsNative'),
    getValue = require('./_getValue');

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

},{"./_baseIsNative":122,"./_getValue":148}],146:[function(require,module,exports){
var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;

},{"./_overArg":176}],147:[function(require,module,exports){
var Symbol = require('./_Symbol');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

},{"./_Symbol":105}],148:[function(require,module,exports){
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

},{}],149:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

},{"./_nativeCreate":171}],150:[function(require,module,exports){
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

},{}],151:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

},{"./_nativeCreate":171}],152:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

},{"./_nativeCreate":171}],153:[function(require,module,exports){
var nativeCreate = require('./_nativeCreate');

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

},{"./_nativeCreate":171}],154:[function(require,module,exports){
var baseCreate = require('./_baseCreate'),
    getPrototype = require('./_getPrototype'),
    isPrototype = require('./_isPrototype');

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;

},{"./_baseCreate":115,"./_getPrototype":146,"./_isPrototype":160}],155:[function(require,module,exports){
var Symbol = require('./_Symbol'),
    isArguments = require('./isArguments'),
    isArray = require('./isArray');

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;

},{"./_Symbol":105,"./isArguments":194,"./isArray":195}],156:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;

},{}],157:[function(require,module,exports){
var eq = require('./eq'),
    isArrayLike = require('./isArrayLike'),
    isIndex = require('./_isIndex'),
    isObject = require('./isObject');

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

},{"./_isIndex":156,"./eq":190,"./isArrayLike":196,"./isObject":201}],158:[function(require,module,exports){
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;

},{}],159:[function(require,module,exports){
var coreJsData = require('./_coreJsData');

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;

},{"./_coreJsData":138}],160:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;

},{}],161:[function(require,module,exports){
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

},{}],162:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

},{"./_assocIndexOf":113}],163:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

},{"./_assocIndexOf":113}],164:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

},{"./_assocIndexOf":113}],165:[function(require,module,exports){
var assocIndexOf = require('./_assocIndexOf');

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

},{"./_assocIndexOf":113}],166:[function(require,module,exports){
var Hash = require('./_Hash'),
    ListCache = require('./_ListCache'),
    Map = require('./_Map');

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;

},{"./_Hash":100,"./_ListCache":101,"./_Map":102}],167:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

},{"./_getMapData":144}],168:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

},{"./_getMapData":144}],169:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

},{"./_getMapData":144}],170:[function(require,module,exports){
var getMapData = require('./_getMapData');

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

},{"./_getMapData":144}],171:[function(require,module,exports){
var getNative = require('./_getNative');

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

},{"./_getNative":145}],172:[function(require,module,exports){
var overArg = require('./_overArg');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

},{"./_overArg":176}],173:[function(require,module,exports){
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;

},{}],174:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

},{"./_freeGlobal":143}],175:[function(require,module,exports){
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

},{}],176:[function(require,module,exports){
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

},{}],177:[function(require,module,exports){
var apply = require('./_apply');

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

},{"./_apply":107}],178:[function(require,module,exports){
var freeGlobal = require('./_freeGlobal');

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

},{"./_freeGlobal":143}],179:[function(require,module,exports){
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;

},{}],180:[function(require,module,exports){
var baseSetToString = require('./_baseSetToString'),
    shortOut = require('./_shortOut');

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

},{"./_baseSetToString":129,"./_shortOut":181}],181:[function(require,module,exports){
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

},{}],182:[function(require,module,exports){
var ListCache = require('./_ListCache');

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;

},{"./_ListCache":101}],183:[function(require,module,exports){
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

},{}],184:[function(require,module,exports){
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

},{}],185:[function(require,module,exports){
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

},{}],186:[function(require,module,exports){
var ListCache = require('./_ListCache'),
    Map = require('./_Map'),
    MapCache = require('./_MapCache');

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

},{"./_ListCache":101,"./_Map":102,"./_MapCache":103}],187:[function(require,module,exports){
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

},{}],188:[function(require,module,exports){
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;

},{}],189:[function(require,module,exports){
module.exports = require('./forEach');

},{"./forEach":192}],190:[function(require,module,exports){
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;

},{}],191:[function(require,module,exports){
var baseFlatten = require('./_baseFlatten');

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;

},{"./_baseFlatten":117}],192:[function(require,module,exports){
var arrayEach = require('./_arrayEach'),
    baseEach = require('./_baseEach'),
    castFunction = require('./_castFunction'),
    isArray = require('./isArray');

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

},{"./_arrayEach":108,"./_baseEach":116,"./_castFunction":132,"./isArray":195}],193:[function(require,module,exports){
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

},{}],194:[function(require,module,exports){
var baseIsArguments = require('./_baseIsArguments'),
    isObjectLike = require('./isObjectLike');

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

},{"./_baseIsArguments":121,"./isObjectLike":202}],195:[function(require,module,exports){
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

},{}],196:[function(require,module,exports){
var isFunction = require('./isFunction'),
    isLength = require('./isLength');

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

},{"./isFunction":199,"./isLength":200}],197:[function(require,module,exports){
var isArrayLike = require('./isArrayLike'),
    isObjectLike = require('./isObjectLike');

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;

},{"./isArrayLike":196,"./isObjectLike":202}],198:[function(require,module,exports){
var root = require('./_root'),
    stubFalse = require('./stubFalse');

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

},{"./_root":178,"./stubFalse":210}],199:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isObject = require('./isObject');

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

},{"./_baseGetTag":120,"./isObject":201}],200:[function(require,module,exports){
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

},{}],201:[function(require,module,exports){
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

},{}],202:[function(require,module,exports){
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

},{}],203:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    getPrototype = require('./_getPrototype'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;

},{"./_baseGetTag":120,"./_getPrototype":146,"./isObjectLike":202}],204:[function(require,module,exports){
var baseGetTag = require('./_baseGetTag'),
    isArray = require('./isArray'),
    isObjectLike = require('./isObjectLike');

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;

},{"./_baseGetTag":120,"./isArray":195,"./isObjectLike":202}],205:[function(require,module,exports){
var baseIsTypedArray = require('./_baseIsTypedArray'),
    baseUnary = require('./_baseUnary'),
    nodeUtil = require('./_nodeUtil');

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

},{"./_baseIsTypedArray":123,"./_baseUnary":131,"./_nodeUtil":174}],206:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeys = require('./_baseKeys'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

},{"./_arrayLikeKeys":109,"./_baseKeys":124,"./isArrayLike":196}],207:[function(require,module,exports){
var arrayLikeKeys = require('./_arrayLikeKeys'),
    baseKeysIn = require('./_baseKeysIn'),
    isArrayLike = require('./isArrayLike');

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;

},{"./_arrayLikeKeys":109,"./_baseKeysIn":125,"./isArrayLike":196}],208:[function(require,module,exports){
(function (global){(function (){
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],209:[function(require,module,exports){
var baseMerge = require('./_baseMerge'),
    createAssigner = require('./_createAssigner');

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;

},{"./_baseMerge":126,"./_createAssigner":139}],210:[function(require,module,exports){
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

},{}],211:[function(require,module,exports){
var copyObject = require('./_copyObject'),
    keysIn = require('./keysIn');

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;

},{"./_copyObject":137,"./keysIn":207}],212:[function(require,module,exports){
/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
        'outlayer/outlayer',
        'get-size/get-size'
      ],
      factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      require('outlayer'),
      require('get-size')
    );
  } else {
    // browser global
    window.Masonry = factory(
      window.Outlayer,
      window.getSize
    );
  }

}( window, function factory( Outlayer, getSize ) {

'use strict';

// -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';

  var proto = Masonry.prototype;

  proto._resetLayout = function() {
    this.getSize();
    this._getMeasurement( 'columnWidth', 'outerWidth' );
    this._getMeasurement( 'gutter', 'outerWidth' );
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for ( var i=0; i < this.cols; i++ ) {
      this.colYs.push( 0 );
    }

    this.maxY = 0;
    this.horizontalColIndex = 0;
  };

  proto.measureColumns = function() {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if ( !this.columnWidth ) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize( firstItemElem ).outerWidth ||
        // if first elem has no width, default to size of container
        this.containerWidth;
    }

    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[ mathMethod ]( cols );
    this.cols = Math.max( cols, 1 );
  };

  proto.getContainerWidth = function() {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize( container );
    this.containerWidth = size && size.innerWidth;
  };

  proto._getItemLayoutPosition = function( item ) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[ mathMethod ]( item.size.outerWidth / this.columnWidth );
    colSpan = Math.min( colSpan, this.cols );
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ?
      '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[ colPosMethod ]( colSpan, item );
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for ( var i = colPosition.col; i < setMax; i++ ) {
      this.colYs[i] = setHeight;
    }

    return position;
  };

  proto._getTopColPosition = function( colSpan ) {
    var colGroup = this._getTopColGroup( colSpan );
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply( Math, colGroup );

    return {
      col: colGroup.indexOf( minimumY ),
      y: minimumY,
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function( colSpan ) {
    if ( colSpan < 2 ) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }

    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for ( var i = 0; i < groupCount; i++ ) {
      colGroup[i] = this._getColGroupY( i, colSpan );
    }
    return colGroup;
  };

  proto._getColGroupY = function( col, colSpan ) {
    if ( colSpan < 2 ) {
      return this.colYs[ col ];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice( col, col + colSpan );
    // and get the max value of the array
    return Math.max.apply( Math, groupColYs );
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function( colSpan, item ) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;

    return {
      col: col,
      y: this._getColGroupY( col, colSpan ),
    };
  };

  proto._manageStamp = function( stamp ) {
    var stampSize = getSize( stamp );
    var offset = this._getElementOffset( stamp );
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor( firstX / this.columnWidth );
    firstCol = Math.max( 0, firstCol );
    var lastCol = Math.floor( lastX / this.columnWidth );
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min( this.cols - 1, lastCol );
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = ( isOriginTop ? offset.top : offset.bottom ) +
      stampSize.outerHeight;
    for ( var i = firstCol; i <= lastCol; i++ ) {
      this.colYs[i] = Math.max( stampMaxY, this.colYs[i] );
    }
  };

  proto._getContainerSize = function() {
    this.maxY = Math.max.apply( Math, this.colYs );
    var size = {
      height: this.maxY
    };

    if ( this._getOption('fitWidth') ) {
      size.width = this._getContainerFitWidth();
    }

    return size;
  };

  proto._getContainerFitWidth = function() {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while ( --i ) {
      if ( this.colYs[i] !== 0 ) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return ( this.cols - unusedCols ) * this.columnWidth - this.gutter;
  };

  proto.needsResizeLayout = function() {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };

  return Masonry;

}));

},{"get-size":44,"outlayer":215}],213:[function(require,module,exports){
/**
 * Outlayer Item
 */

( function( window, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size'
      ],
      factory
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      require('ev-emitter'),
      require('get-size')
    );
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(
      window.EvEmitter,
      window.getSize
    );
  }

}( window, function factory( EvEmitter, getSize ) {
'use strict';

// ----- helpers ----- //

function isEmptyObj( obj ) {
  for ( var prop in obj ) {
    return false;
  }
  prop = null;
  return true;
}

// -------------------------- CSS3 support -------------------------- //


var docElemStyle = document.documentElement.style;

var transitionProperty = typeof docElemStyle.transition == 'string' ?
  'transition' : 'WebkitTransition';
var transformProperty = typeof docElemStyle.transform == 'string' ?
  'transform' : 'WebkitTransform';

var transitionEndEvent = {
  WebkitTransition: 'webkitTransitionEnd',
  transition: 'transitionend'
}[ transitionProperty ];

// cache all vendor properties that could have vendor prefix
var vendorProperties = {
  transform: transformProperty,
  transition: transitionProperty,
  transitionDuration: transitionProperty + 'Duration',
  transitionProperty: transitionProperty + 'Property',
  transitionDelay: transitionProperty + 'Delay'
};

// -------------------------- Item -------------------------- //

function Item( element, layout ) {
  if ( !element ) {
    return;
  }

  this.element = element;
  // parent layout class, i.e. Masonry, Isotope, or Packery
  this.layout = layout;
  this.position = {
    x: 0,
    y: 0
  };

  this._create();
}

// inherit EvEmitter
var proto = Item.prototype = Object.create( EvEmitter.prototype );
proto.constructor = Item;

proto._create = function() {
  // transition objects
  this._transn = {
    ingProperties: {},
    clean: {},
    onEnd: {}
  };

  this.css({
    position: 'absolute'
  });
};

// trigger specified handler for event type
proto.handleEvent = function( event ) {
  var method = 'on' + event.type;
  if ( this[ method ] ) {
    this[ method ]( event );
  }
};

proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * apply CSS styles to element
 * @param {Object} style
 */
proto.css = function( style ) {
  var elemStyle = this.element.style;

  for ( var prop in style ) {
    // use vendor property if available
    var supportedProp = vendorProperties[ prop ] || prop;
    elemStyle[ supportedProp ] = style[ prop ];
  }
};

 // measure position, and sets it
proto.getPosition = function() {
  var style = getComputedStyle( this.element );
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  var xValue = style[ isOriginLeft ? 'left' : 'right' ];
  var yValue = style[ isOriginTop ? 'top' : 'bottom' ];
  var x = parseFloat( xValue );
  var y = parseFloat( yValue );
  // convert percent to pixels
  var layoutSize = this.layout.size;
  if ( xValue.indexOf('%') != -1 ) {
    x = ( x / 100 ) * layoutSize.width;
  }
  if ( yValue.indexOf('%') != -1 ) {
    y = ( y / 100 ) * layoutSize.height;
  }
  // clean up 'auto' or other non-integer values
  x = isNaN( x ) ? 0 : x;
  y = isNaN( y ) ? 0 : y;
  // remove padding from measurement
  x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
  y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;

  this.position.x = x;
  this.position.y = y;
};

// set settled position, apply padding
proto.layoutPosition = function() {
  var layoutSize = this.layout.size;
  var style = {};
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');

  // x
  var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
  var xProperty = isOriginLeft ? 'left' : 'right';
  var xResetProperty = isOriginLeft ? 'right' : 'left';

  var x = this.position.x + layoutSize[ xPadding ];
  // set in percentage or pixels
  style[ xProperty ] = this.getXValue( x );
  // reset other property
  style[ xResetProperty ] = '';

  // y
  var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
  var yProperty = isOriginTop ? 'top' : 'bottom';
  var yResetProperty = isOriginTop ? 'bottom' : 'top';

  var y = this.position.y + layoutSize[ yPadding ];
  // set in percentage or pixels
  style[ yProperty ] = this.getYValue( y );
  // reset other property
  style[ yResetProperty ] = '';

  this.css( style );
  this.emitEvent( 'layout', [ this ] );
};

proto.getXValue = function( x ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && !isHorizontal ?
    ( ( x / this.layout.size.width ) * 100 ) + '%' : x + 'px';
};

proto.getYValue = function( y ) {
  var isHorizontal = this.layout._getOption('horizontal');
  return this.layout.options.percentPosition && isHorizontal ?
    ( ( y / this.layout.size.height ) * 100 ) + '%' : y + 'px';
};

proto._transitionTo = function( x, y ) {
  this.getPosition();
  // get current x & y from top/left
  var curX = this.position.x;
  var curY = this.position.y;

  var didNotMove = x == this.position.x && y == this.position.y;

  // save end position
  this.setPosition( x, y );

  // if did not move and not transitioning, just go to layout
  if ( didNotMove && !this.isTransitioning ) {
    this.layoutPosition();
    return;
  }

  var transX = x - curX;
  var transY = y - curY;
  var transitionStyle = {};
  transitionStyle.transform = this.getTranslate( transX, transY );

  this.transition({
    to: transitionStyle,
    onTransitionEnd: {
      transform: this.layoutPosition
    },
    isCleaning: true
  });
};

proto.getTranslate = function( x, y ) {
  // flip cooridinates if origin on right or bottom
  var isOriginLeft = this.layout._getOption('originLeft');
  var isOriginTop = this.layout._getOption('originTop');
  x = isOriginLeft ? x : -x;
  y = isOriginTop ? y : -y;
  return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
};

// non transition + transform support
proto.goTo = function( x, y ) {
  this.setPosition( x, y );
  this.layoutPosition();
};

proto.moveTo = proto._transitionTo;

proto.setPosition = function( x, y ) {
  this.position.x = parseFloat( x );
  this.position.y = parseFloat( y );
};

// ----- transition ----- //

/**
 * @param {Object} style - CSS
 * @param {Function} onTransitionEnd
 */

// non transition, just trigger callback
proto._nonTransition = function( args ) {
  this.css( args.to );
  if ( args.isCleaning ) {
    this._removeStyles( args.to );
  }
  for ( var prop in args.onTransitionEnd ) {
    args.onTransitionEnd[ prop ].call( this );
  }
};

/**
 * proper transition
 * @param {Object} args - arguments
 *   @param {Object} to - style to transition to
 *   @param {Object} from - style to start transition from
 *   @param {Boolean} isCleaning - removes transition styles after transition
 *   @param {Function} onTransitionEnd - callback
 */
proto.transition = function( args ) {
  // redirect to nonTransition if no transition duration
  if ( !parseFloat( this.layout.options.transitionDuration ) ) {
    this._nonTransition( args );
    return;
  }

  var _transition = this._transn;
  // keep track of onTransitionEnd callback by css property
  for ( var prop in args.onTransitionEnd ) {
    _transition.onEnd[ prop ] = args.onTransitionEnd[ prop ];
  }
  // keep track of properties that are transitioning
  for ( prop in args.to ) {
    _transition.ingProperties[ prop ] = true;
    // keep track of properties to clean up when transition is done
    if ( args.isCleaning ) {
      _transition.clean[ prop ] = true;
    }
  }

  // set from styles
  if ( args.from ) {
    this.css( args.from );
    // force redraw. http://blog.alexmaccaw.com/css-transitions
    var h = this.element.offsetHeight;
    // hack for JSHint to hush about unused var
    h = null;
  }
  // enable transition
  this.enableTransition( args.to );
  // set styles that are transitioning
  this.css( args.to );

  this.isTransitioning = true;

};

// dash before all cap letters, including first for
// WebkitTransform => -webkit-transform
function toDashedAll( str ) {
  return str.replace( /([A-Z])/g, function( $1 ) {
    return '-' + $1.toLowerCase();
  });
}

var transitionProps = 'opacity,' + toDashedAll( transformProperty );

proto.enableTransition = function(/* style */) {
  // HACK changing transitionProperty during a transition
  // will cause transition to jump
  if ( this.isTransitioning ) {
    return;
  }

  // make `transition: foo, bar, baz` from style object
  // HACK un-comment this when enableTransition can work
  // while a transition is happening
  // var transitionValues = [];
  // for ( var prop in style ) {
  //   // dash-ify camelCased properties like WebkitTransition
  //   prop = vendorProperties[ prop ] || prop;
  //   transitionValues.push( toDashedAll( prop ) );
  // }
  // munge number to millisecond, to match stagger
  var duration = this.layout.options.transitionDuration;
  duration = typeof duration == 'number' ? duration + 'ms' : duration;
  // enable transition styles
  this.css({
    transitionProperty: transitionProps,
    transitionDuration: duration,
    transitionDelay: this.staggerDelay || 0
  });
  // listen for transition end event
  this.element.addEventListener( transitionEndEvent, this, false );
};

// ----- events ----- //

proto.onwebkitTransitionEnd = function( event ) {
  this.ontransitionend( event );
};

proto.onotransitionend = function( event ) {
  this.ontransitionend( event );
};

// properties that I munge to make my life easier
var dashedVendorProperties = {
  '-webkit-transform': 'transform'
};

proto.ontransitionend = function( event ) {
  // disregard bubbled events from children
  if ( event.target !== this.element ) {
    return;
  }
  var _transition = this._transn;
  // get property name of transitioned property, convert to prefix-free
  var propertyName = dashedVendorProperties[ event.propertyName ] || event.propertyName;

  // remove property that has completed transitioning
  delete _transition.ingProperties[ propertyName ];
  // check if any properties are still transitioning
  if ( isEmptyObj( _transition.ingProperties ) ) {
    // all properties have completed transitioning
    this.disableTransition();
  }
  // clean style
  if ( propertyName in _transition.clean ) {
    // clean up style
    this.element.style[ event.propertyName ] = '';
    delete _transition.clean[ propertyName ];
  }
  // trigger onTransitionEnd callback
  if ( propertyName in _transition.onEnd ) {
    var onTransitionEnd = _transition.onEnd[ propertyName ];
    onTransitionEnd.call( this );
    delete _transition.onEnd[ propertyName ];
  }

  this.emitEvent( 'transitionEnd', [ this ] );
};

proto.disableTransition = function() {
  this.removeTransitionStyles();
  this.element.removeEventListener( transitionEndEvent, this, false );
  this.isTransitioning = false;
};

/**
 * removes style property from element
 * @param {Object} style
**/
proto._removeStyles = function( style ) {
  // clean up transition styles
  var cleanStyle = {};
  for ( var prop in style ) {
    cleanStyle[ prop ] = '';
  }
  this.css( cleanStyle );
};

var cleanTransitionStyle = {
  transitionProperty: '',
  transitionDuration: '',
  transitionDelay: ''
};

proto.removeTransitionStyles = function() {
  // remove transition
  this.css( cleanTransitionStyle );
};

// ----- stagger ----- //

proto.stagger = function( delay ) {
  delay = isNaN( delay ) ? 0 : delay;
  this.staggerDelay = delay + 'ms';
};

// ----- show/hide/remove ----- //

// remove element from DOM
proto.removeElem = function() {
  this.element.parentNode.removeChild( this.element );
  // remove display: none
  this.css({ display: '' });
  this.emitEvent( 'remove', [ this ] );
};

proto.remove = function() {
  // just remove element if no transition support or no transition
  if ( !transitionProperty || !parseFloat( this.layout.options.transitionDuration ) ) {
    this.removeElem();
    return;
  }

  // start transition
  this.once( 'transitionEnd', function() {
    this.removeElem();
  });
  this.hide();
};

proto.reveal = function() {
  delete this.isHidden;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onRevealTransitionEnd;

  this.transition({
    from: options.hiddenStyle,
    to: options.visibleStyle,
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onRevealTransitionEnd = function() {
  // check if still visible
  // during transition, item may have been hidden
  if ( !this.isHidden ) {
    this.emitEvent('reveal');
  }
};

/**
 * get style property use for hide/reveal transition end
 * @param {String} styleProperty - hiddenStyle/visibleStyle
 * @returns {String}
 */
proto.getHideRevealTransitionEndProperty = function( styleProperty ) {
  var optionStyle = this.layout.options[ styleProperty ];
  // use opacity
  if ( optionStyle.opacity ) {
    return 'opacity';
  }
  // get first property
  for ( var prop in optionStyle ) {
    return prop;
  }
};

proto.hide = function() {
  // set flag
  this.isHidden = true;
  // remove display: none
  this.css({ display: '' });

  var options = this.layout.options;

  var onTransitionEnd = {};
  var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
  onTransitionEnd[ transitionEndProperty ] = this.onHideTransitionEnd;

  this.transition({
    from: options.visibleStyle,
    to: options.hiddenStyle,
    // keep hidden stuff hidden
    isCleaning: true,
    onTransitionEnd: onTransitionEnd
  });
};

proto.onHideTransitionEnd = function() {
  // check if still hidden
  // during transition, item may have been un-hidden
  if ( this.isHidden ) {
    this.css({ display: 'none' });
    this.emitEvent('hide');
  }
};

proto.destroy = function() {
  this.css({
    position: '',
    left: '',
    right: '',
    top: '',
    bottom: '',
    transition: '',
    transform: ''
  });
};

return Item;

}));

},{"ev-emitter":214,"get-size":44}],214:[function(require,module,exports){
/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

( function( global, factory ) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( factory );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }

}( typeof window != 'undefined' ? window : this, function() {

"use strict";

function EvEmitter() {}

var proto = EvEmitter.prototype;

proto.on = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // set events hash
  var events = this._events = this._events || {};
  // set listeners array
  var listeners = events[ eventName ] = events[ eventName ] || [];
  // only add once
  if ( listeners.indexOf( listener ) == -1 ) {
    listeners.push( listener );
  }

  return this;
};

proto.once = function( eventName, listener ) {
  if ( !eventName || !listener ) {
    return;
  }
  // add event
  this.on( eventName, listener );
  // set once flag
  // set onceEvents hash
  var onceEvents = this._onceEvents = this._onceEvents || {};
  // set onceListeners object
  var onceListeners = onceEvents[ eventName ] = onceEvents[ eventName ] || {};
  // set flag
  onceListeners[ listener ] = true;

  return this;
};

proto.off = function( eventName, listener ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  var index = listeners.indexOf( listener );
  if ( index != -1 ) {
    listeners.splice( index, 1 );
  }

  return this;
};

proto.emitEvent = function( eventName, args ) {
  var listeners = this._events && this._events[ eventName ];
  if ( !listeners || !listeners.length ) {
    return;
  }
  // copy over to avoid interference if .off() in listener
  listeners = listeners.slice(0);
  args = args || [];
  // once stuff
  var onceListeners = this._onceEvents && this._onceEvents[ eventName ];

  for ( var i=0; i < listeners.length; i++ ) {
    var listener = listeners[i]
    var isOnce = onceListeners && onceListeners[ listener ];
    if ( isOnce ) {
      // remove listener
      // remove before trigger to prevent recursion
      this.off( eventName, listener );
      // unset once flag
      delete onceListeners[ listener ];
    }
    // trigger listener
    listener.apply( this, args );
  }

  return this;
};

proto.allOff = function() {
  delete this._events;
  delete this._onceEvents;
};

return EvEmitter;

}));

},{}],215:[function(require,module,exports){
/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

( function( window, factory ) {
  'use strict';
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if ( typeof define == 'function' && define.amd ) {
    // AMD - RequireJS
    define( [
        'ev-emitter/ev-emitter',
        'get-size/get-size',
        'fizzy-ui-utils/utils',
        './item'
      ],
      function( EvEmitter, getSize, utils, Item ) {
        return factory( window, EvEmitter, getSize, utils, Item);
      }
    );
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(
      window,
      require('ev-emitter'),
      require('get-size'),
      require('fizzy-ui-utils'),
      require('./item')
    );
  } else {
    // browser global
    window.Outlayer = factory(
      window,
      window.EvEmitter,
      window.getSize,
      window.fizzyUIUtils,
      window.Outlayer.Item
    );
  }

}( window, function factory( window, EvEmitter, getSize, utils, Item ) {
'use strict';

// ----- vars ----- //

var console = window.console;
var jQuery = window.jQuery;
var noop = function() {};

// -------------------------- Outlayer -------------------------- //

// globally unique identifiers
var GUID = 0;
// internal store of all Outlayer intances
var instances = {};


/**
 * @param {Element, String} element
 * @param {Object} options
 * @constructor
 */
function Outlayer( element, options ) {
  var queryElement = utils.getQueryElement( element );
  if ( !queryElement ) {
    if ( console ) {
      console.error( 'Bad element for ' + this.constructor.namespace +
        ': ' + ( queryElement || element ) );
    }
    return;
  }
  this.element = queryElement;
  // add jQuery
  if ( jQuery ) {
    this.$element = jQuery( this.element );
  }

  // options
  this.options = utils.extend( {}, this.constructor.defaults );
  this.option( options );

  // add id for Outlayer.getFromElement
  var id = ++GUID;
  this.element.outlayerGUID = id; // expando
  instances[ id ] = this; // associate via id

  // kick it off
  this._create();

  var isInitLayout = this._getOption('initLayout');
  if ( isInitLayout ) {
    this.layout();
  }
}

// settings are for internal use only
Outlayer.namespace = 'outlayer';
Outlayer.Item = Item;

// default options
Outlayer.defaults = {
  containerStyle: {
    position: 'relative'
  },
  initLayout: true,
  originLeft: true,
  originTop: true,
  resize: true,
  resizeContainer: true,
  // item options
  transitionDuration: '0.4s',
  hiddenStyle: {
    opacity: 0,
    transform: 'scale(0.001)'
  },
  visibleStyle: {
    opacity: 1,
    transform: 'scale(1)'
  }
};

var proto = Outlayer.prototype;
// inherit EvEmitter
utils.extend( proto, EvEmitter.prototype );

/**
 * set options
 * @param {Object} opts
 */
proto.option = function( opts ) {
  utils.extend( this.options, opts );
};

/**
 * get backwards compatible option value, check old name
 */
proto._getOption = function( option ) {
  var oldOption = this.constructor.compatOptions[ option ];
  return oldOption && this.options[ oldOption ] !== undefined ?
    this.options[ oldOption ] : this.options[ option ];
};

Outlayer.compatOptions = {
  // currentName: oldName
  initLayout: 'isInitLayout',
  horizontal: 'isHorizontal',
  layoutInstant: 'isLayoutInstant',
  originLeft: 'isOriginLeft',
  originTop: 'isOriginTop',
  resize: 'isResizeBound',
  resizeContainer: 'isResizingContainer'
};

proto._create = function() {
  // get items from children
  this.reloadItems();
  // elements that affect layout, but are not laid out
  this.stamps = [];
  this.stamp( this.options.stamp );
  // set container style
  utils.extend( this.element.style, this.options.containerStyle );

  // bind resize method
  var canBindResize = this._getOption('resize');
  if ( canBindResize ) {
    this.bindResize();
  }
};

// goes through all children again and gets bricks in proper order
proto.reloadItems = function() {
  // collection of item elements
  this.items = this._itemize( this.element.children );
};


/**
 * turn elements into Outlayer.Items to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - collection of new Outlayer Items
 */
proto._itemize = function( elems ) {

  var itemElems = this._filterFindItemElements( elems );
  var Item = this.constructor.Item;

  // create new Outlayer Items for collection
  var items = [];
  for ( var i=0; i < itemElems.length; i++ ) {
    var elem = itemElems[i];
    var item = new Item( elem, this );
    items.push( item );
  }

  return items;
};

/**
 * get item elements to be used in layout
 * @param {Array or NodeList or HTMLElement} elems
 * @returns {Array} items - item elements
 */
proto._filterFindItemElements = function( elems ) {
  return utils.filterFindElements( elems, this.options.itemSelector );
};

/**
 * getter method for getting item elements
 * @returns {Array} elems - collection of item elements
 */
proto.getItemElements = function() {
  return this.items.map( function( item ) {
    return item.element;
  });
};

// ----- init & layout ----- //

/**
 * lays out all items
 */
proto.layout = function() {
  this._resetLayout();
  this._manageStamps();

  // don't animate first layout
  var layoutInstant = this._getOption('layoutInstant');
  var isInstant = layoutInstant !== undefined ?
    layoutInstant : !this._isLayoutInited;
  this.layoutItems( this.items, isInstant );

  // flag for initalized
  this._isLayoutInited = true;
};

// _init is alias for layout
proto._init = proto.layout;

/**
 * logic before any new layout
 */
proto._resetLayout = function() {
  this.getSize();
};


proto.getSize = function() {
  this.size = getSize( this.element );
};

/**
 * get measurement from option, for columnWidth, rowHeight, gutter
 * if option is String -> get element from selector string, & get size of element
 * if option is Element -> get size of element
 * else use option as a number
 *
 * @param {String} measurement
 * @param {String} size - width or height
 * @private
 */
proto._getMeasurement = function( measurement, size ) {
  var option = this.options[ measurement ];
  var elem;
  if ( !option ) {
    // default to 0
    this[ measurement ] = 0;
  } else {
    // use option as an element
    if ( typeof option == 'string' ) {
      elem = this.element.querySelector( option );
    } else if ( option instanceof HTMLElement ) {
      elem = option;
    }
    // use size of element, if element
    this[ measurement ] = elem ? getSize( elem )[ size ] : option;
  }
};

/**
 * layout a collection of item elements
 * @api public
 */
proto.layoutItems = function( items, isInstant ) {
  items = this._getItemsForLayout( items );

  this._layoutItems( items, isInstant );

  this._postLayout();
};

/**
 * get the items to be laid out
 * you may want to skip over some items
 * @param {Array} items
 * @returns {Array} items
 */
proto._getItemsForLayout = function( items ) {
  return items.filter( function( item ) {
    return !item.isIgnored;
  });
};

/**
 * layout items
 * @param {Array} items
 * @param {Boolean} isInstant
 */
proto._layoutItems = function( items, isInstant ) {
  this._emitCompleteOnItems( 'layout', items );

  if ( !items || !items.length ) {
    // no items, emit event with empty array
    return;
  }

  var queue = [];

  items.forEach( function( item ) {
    // get x/y object from method
    var position = this._getItemLayoutPosition( item );
    // enqueue
    position.item = item;
    position.isInstant = isInstant || item.isLayoutInstant;
    queue.push( position );
  }, this );

  this._processLayoutQueue( queue );
};

/**
 * get item layout position
 * @param {Outlayer.Item} item
 * @returns {Object} x and y position
 */
proto._getItemLayoutPosition = function( /* item */ ) {
  return {
    x: 0,
    y: 0
  };
};

/**
 * iterate over array and position each item
 * Reason being - separating this logic prevents 'layout invalidation'
 * thx @paul_irish
 * @param {Array} queue
 */
proto._processLayoutQueue = function( queue ) {
  this.updateStagger();
  queue.forEach( function( obj, i ) {
    this._positionItem( obj.item, obj.x, obj.y, obj.isInstant, i );
  }, this );
};

// set stagger from option in milliseconds number
proto.updateStagger = function() {
  var stagger = this.options.stagger;
  if ( stagger === null || stagger === undefined ) {
    this.stagger = 0;
    return;
  }
  this.stagger = getMilliseconds( stagger );
  return this.stagger;
};

/**
 * Sets position of item in DOM
 * @param {Outlayer.Item} item
 * @param {Number} x - horizontal position
 * @param {Number} y - vertical position
 * @param {Boolean} isInstant - disables transitions
 */
proto._positionItem = function( item, x, y, isInstant, i ) {
  if ( isInstant ) {
    // if not transition, just set CSS
    item.goTo( x, y );
  } else {
    item.stagger( i * this.stagger );
    item.moveTo( x, y );
  }
};

/**
 * Any logic you want to do after each layout,
 * i.e. size the container
 */
proto._postLayout = function() {
  this.resizeContainer();
};

proto.resizeContainer = function() {
  var isResizingContainer = this._getOption('resizeContainer');
  if ( !isResizingContainer ) {
    return;
  }
  var size = this._getContainerSize();
  if ( size ) {
    this._setContainerMeasure( size.width, true );
    this._setContainerMeasure( size.height, false );
  }
};

/**
 * Sets width or height of container if returned
 * @returns {Object} size
 *   @param {Number} width
 *   @param {Number} height
 */
proto._getContainerSize = noop;

/**
 * @param {Number} measure - size of width or height
 * @param {Boolean} isWidth
 */
proto._setContainerMeasure = function( measure, isWidth ) {
  if ( measure === undefined ) {
    return;
  }

  var elemSize = this.size;
  // add padding and border width if border box
  if ( elemSize.isBorderBox ) {
    measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight +
      elemSize.borderLeftWidth + elemSize.borderRightWidth :
      elemSize.paddingBottom + elemSize.paddingTop +
      elemSize.borderTopWidth + elemSize.borderBottomWidth;
  }

  measure = Math.max( measure, 0 );
  this.element.style[ isWidth ? 'width' : 'height' ] = measure + 'px';
};

/**
 * emit eventComplete on a collection of items events
 * @param {String} eventName
 * @param {Array} items - Outlayer.Items
 */
proto._emitCompleteOnItems = function( eventName, items ) {
  var _this = this;
  function onComplete() {
    _this.dispatchEvent( eventName + 'Complete', null, [ items ] );
  }

  var count = items.length;
  if ( !items || !count ) {
    onComplete();
    return;
  }

  var doneCount = 0;
  function tick() {
    doneCount++;
    if ( doneCount == count ) {
      onComplete();
    }
  }

  // bind callback
  items.forEach( function( item ) {
    item.once( eventName, tick );
  });
};

/**
 * emits events via EvEmitter and jQuery events
 * @param {String} type - name of event
 * @param {Event} event - original event
 * @param {Array} args - extra arguments
 */
proto.dispatchEvent = function( type, event, args ) {
  // add original event to arguments
  var emitArgs = event ? [ event ].concat( args ) : args;
  this.emitEvent( type, emitArgs );

  if ( jQuery ) {
    // set this.$element
    this.$element = this.$element || jQuery( this.element );
    if ( event ) {
      // create jQuery event
      var $event = jQuery.Event( event );
      $event.type = type;
      this.$element.trigger( $event, args );
    } else {
      // just trigger with type if no event available
      this.$element.trigger( type, args );
    }
  }
};

// -------------------------- ignore & stamps -------------------------- //


/**
 * keep item in collection, but do not lay it out
 * ignored items do not get skipped in layout
 * @param {Element} elem
 */
proto.ignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    item.isIgnored = true;
  }
};

/**
 * return item to layout collection
 * @param {Element} elem
 */
proto.unignore = function( elem ) {
  var item = this.getItem( elem );
  if ( item ) {
    delete item.isIgnored;
  }
};

/**
 * adds elements to stamps
 * @param {NodeList, Array, Element, or String} elems
 */
proto.stamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ) {
    return;
  }

  this.stamps = this.stamps.concat( elems );
  // ignore
  elems.forEach( this.ignore, this );
};

/**
 * removes elements to stamps
 * @param {NodeList, Array, or Element} elems
 */
proto.unstamp = function( elems ) {
  elems = this._find( elems );
  if ( !elems ){
    return;
  }

  elems.forEach( function( elem ) {
    // filter out removed stamp elements
    utils.removeFrom( this.stamps, elem );
    this.unignore( elem );
  }, this );
};

/**
 * finds child elements
 * @param {NodeList, Array, Element, or String} elems
 * @returns {Array} elems
 */
proto._find = function( elems ) {
  if ( !elems ) {
    return;
  }
  // if string, use argument as selector string
  if ( typeof elems == 'string' ) {
    elems = this.element.querySelectorAll( elems );
  }
  elems = utils.makeArray( elems );
  return elems;
};

proto._manageStamps = function() {
  if ( !this.stamps || !this.stamps.length ) {
    return;
  }

  this._getBoundingRect();

  this.stamps.forEach( this._manageStamp, this );
};

// update boundingLeft / Top
proto._getBoundingRect = function() {
  // get bounding rect for container element
  var boundingRect = this.element.getBoundingClientRect();
  var size = this.size;
  this._boundingRect = {
    left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
    top: boundingRect.top + size.paddingTop + size.borderTopWidth,
    right: boundingRect.right - ( size.paddingRight + size.borderRightWidth ),
    bottom: boundingRect.bottom - ( size.paddingBottom + size.borderBottomWidth )
  };
};

/**
 * @param {Element} stamp
**/
proto._manageStamp = noop;

/**
 * get x/y position of element relative to container element
 * @param {Element} elem
 * @returns {Object} offset - has left, top, right, bottom
 */
proto._getElementOffset = function( elem ) {
  var boundingRect = elem.getBoundingClientRect();
  var thisRect = this._boundingRect;
  var size = getSize( elem );
  var offset = {
    left: boundingRect.left - thisRect.left - size.marginLeft,
    top: boundingRect.top - thisRect.top - size.marginTop,
    right: thisRect.right - boundingRect.right - size.marginRight,
    bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
  };
  return offset;
};

// -------------------------- resize -------------------------- //

// enable event handlers for listeners
// i.e. resize -> onresize
proto.handleEvent = utils.handleEvent;

/**
 * Bind layout to window resizing
 */
proto.bindResize = function() {
  window.addEventListener( 'resize', this );
  this.isResizeBound = true;
};

/**
 * Unbind layout to window resizing
 */
proto.unbindResize = function() {
  window.removeEventListener( 'resize', this );
  this.isResizeBound = false;
};

proto.onresize = function() {
  this.resize();
};

utils.debounceMethod( Outlayer, 'onresize', 100 );

proto.resize = function() {
  // don't trigger if size did not change
  // or if resize was unbound. See #9
  if ( !this.isResizeBound || !this.needsResizeLayout() ) {
    return;
  }

  this.layout();
};

/**
 * check if layout is needed post layout
 * @returns Boolean
 */
proto.needsResizeLayout = function() {
  var size = getSize( this.element );
  // check that this.size and size are there
  // IE8 triggers resize on body size change, so they might not be
  var hasSizes = this.size && size;
  return hasSizes && size.innerWidth !== this.size.innerWidth;
};

// -------------------------- methods -------------------------- //

/**
 * add items to Outlayer instance
 * @param {Array or NodeList or Element} elems
 * @returns {Array} items - Outlayer.Items
**/
proto.addItems = function( elems ) {
  var items = this._itemize( elems );
  // add items to collection
  if ( items.length ) {
    this.items = this.items.concat( items );
  }
  return items;
};

/**
 * Layout newly-appended item elements
 * @param {Array or NodeList or Element} elems
 */
proto.appended = function( elems ) {
  var items = this.addItems( elems );
  if ( !items.length ) {
    return;
  }
  // layout and reveal just the new items
  this.layoutItems( items, true );
  this.reveal( items );
};

/**
 * Layout prepended elements
 * @param {Array or NodeList or Element} elems
 */
proto.prepended = function( elems ) {
  var items = this._itemize( elems );
  if ( !items.length ) {
    return;
  }
  // add items to beginning of collection
  var previousItems = this.items.slice(0);
  this.items = items.concat( previousItems );
  // start new layout
  this._resetLayout();
  this._manageStamps();
  // layout new stuff without transition
  this.layoutItems( items, true );
  this.reveal( items );
  // layout previous items
  this.layoutItems( previousItems );
};

/**
 * reveal a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.reveal = function( items ) {
  this._emitCompleteOnItems( 'reveal', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.reveal();
  });
};

/**
 * hide a collection of items
 * @param {Array of Outlayer.Items} items
 */
proto.hide = function( items ) {
  this._emitCompleteOnItems( 'hide', items );
  if ( !items || !items.length ) {
    return;
  }
  var stagger = this.updateStagger();
  items.forEach( function( item, i ) {
    item.stagger( i * stagger );
    item.hide();
  });
};

/**
 * reveal item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.revealItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.reveal( items );
};

/**
 * hide item elements
 * @param {Array}, {Element}, {NodeList} items
 */
proto.hideItemElements = function( elems ) {
  var items = this.getItems( elems );
  this.hide( items );
};

/**
 * get Outlayer.Item, given an Element
 * @param {Element} elem
 * @param {Function} callback
 * @returns {Outlayer.Item} item
 */
proto.getItem = function( elem ) {
  // loop through items to get the one that matches
  for ( var i=0; i < this.items.length; i++ ) {
    var item = this.items[i];
    if ( item.element == elem ) {
      // return item
      return item;
    }
  }
};

/**
 * get collection of Outlayer.Items, given Elements
 * @param {Array} elems
 * @returns {Array} items - Outlayer.Items
 */
proto.getItems = function( elems ) {
  elems = utils.makeArray( elems );
  var items = [];
  elems.forEach( function( elem ) {
    var item = this.getItem( elem );
    if ( item ) {
      items.push( item );
    }
  }, this );

  return items;
};

/**
 * remove element(s) from instance and DOM
 * @param {Array or NodeList or Element} elems
 */
proto.remove = function( elems ) {
  var removeItems = this.getItems( elems );

  this._emitCompleteOnItems( 'remove', removeItems );

  // bail if no items to remove
  if ( !removeItems || !removeItems.length ) {
    return;
  }

  removeItems.forEach( function( item ) {
    item.remove();
    // remove item from collection
    utils.removeFrom( this.items, item );
  }, this );
};

// ----- destroy ----- //

// remove and disable Outlayer instance
proto.destroy = function() {
  // clean up dynamic styles
  var style = this.element.style;
  style.height = '';
  style.position = '';
  style.width = '';
  // destroy items
  this.items.forEach( function( item ) {
    item.destroy();
  });

  this.unbindResize();

  var id = this.element.outlayerGUID;
  delete instances[ id ]; // remove reference to instance by id
  delete this.element.outlayerGUID;
  // remove data for jQuery
  if ( jQuery ) {
    jQuery.removeData( this.element, this.constructor.namespace );
  }

};

// -------------------------- data -------------------------- //

/**
 * get Outlayer instance from element
 * @param {Element} elem
 * @returns {Outlayer}
 */
Outlayer.data = function( elem ) {
  elem = utils.getQueryElement( elem );
  var id = elem && elem.outlayerGUID;
  return id && instances[ id ];
};


// -------------------------- create Outlayer class -------------------------- //

/**
 * create a layout class
 * @param {String} namespace
 */
Outlayer.create = function( namespace, options ) {
  // sub-class Outlayer
  var Layout = subclass( Outlayer );
  // apply new options and compatOptions
  Layout.defaults = utils.extend( {}, Outlayer.defaults );
  utils.extend( Layout.defaults, options );
  Layout.compatOptions = utils.extend( {}, Outlayer.compatOptions  );

  Layout.namespace = namespace;

  Layout.data = Outlayer.data;

  // sub-class Item
  Layout.Item = subclass( Item );

  // -------------------------- declarative -------------------------- //

  utils.htmlInit( Layout, namespace );

  // -------------------------- jQuery bridge -------------------------- //

  // make into jQuery plugin
  if ( jQuery && jQuery.bridget ) {
    jQuery.bridget( namespace, Layout );
  }

  return Layout;
};

function subclass( Parent ) {
  function SubClass() {
    Parent.apply( this, arguments );
  }

  SubClass.prototype = Object.create( Parent.prototype );
  SubClass.prototype.constructor = SubClass;

  return SubClass;
}

// ----- helpers ----- //

// how many milliseconds are in each unit
var msUnits = {
  ms: 1,
  s: 1000
};

// munge time-like parameter into millisecond number
// '0.4s' -> 40
function getMilliseconds( time ) {
  if ( typeof time == 'number' ) {
    return time;
  }
  var matches = time.match( /(^\d*\.?\d*)(\w*)/ );
  var num = matches && matches[1];
  var unit = matches && matches[2];
  if ( !num.length ) {
    return 0;
  }
  num = parseFloat( num );
  var mult = msUnits[ unit ] || 1;
  return num * mult;
}

// ----- fin ----- //

// back in global
Outlayer.Item = Item;

return Outlayer;

}));

},{"./item":213,"ev-emitter":214,"fizzy-ui-utils":43,"get-size":44}],216:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],217:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":222}],218:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._x = 0;
  this._y = 0;
  this._z = null;
  this._A = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._B = null;
Promise._C = null;
Promise._D = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._y === 3) {
    self = self._z;
  }
  if (Promise._B) {
    Promise._B(self);
  }
  if (self._y === 0) {
    if (self._x === 0) {
      self._x = 1;
      self._A = deferred;
      return;
    }
    if (self._x === 1) {
      self._x = 2;
      self._A = [self._A, deferred];
      return;
    }
    self._A.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._y === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._y === 1) {
        resolve(deferred.promise, self._z);
      } else {
        reject(deferred.promise, self._z);
      }
      return;
    }
    var ret = tryCallOne(cb, self._z);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._y = 3;
      self._z = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._y = 1;
  self._z = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._y = 2;
  self._z = newValue;
  if (Promise._C) {
    Promise._C(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._x === 1) {
    handle(self, self._A);
    self._A = null;
  }
  if (self._x === 2) {
    for (var i = 0; i < self._A.length; i++) {
      handle(self, self._A[i]);
    }
    self._A = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":4}],219:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":218}],220:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._D);
  p._y = 1;
  p._z = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

var iterableToArray = function (iterable) {
  if (typeof Array.from === 'function') {
    // ES2015+, iterables exist
    iterableToArray = Array.from;
    return Array.from(iterable);
  }

  // ES5, only arrays and array-likes exist
  iterableToArray = function (x) { return Array.prototype.slice.call(x); };
  return Array.prototype.slice.call(iterable);
}

Promise.all = function (arr) {
  var args = iterableToArray(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._y === 3) {
            val = val._z;
          }
          if (val._y === 1) return res(i, val._z);
          if (val._y === 2) reject(val._z);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

function onSettledFulfill(value) {
  return { status: 'fulfilled', value: value };
}
function onSettledReject(reason) {
  return { status: 'rejected', reason: reason };
}
function mapAllSettled(item) {
  if(item && (typeof item === 'object' || typeof item === 'function')){
    if(item instanceof Promise && item.then === Promise.prototype.then){
      return item.then(onSettledFulfill, onSettledReject);
    }
    var then = item.then;
    if (typeof then === 'function') {
      return new Promise(then.bind(item)).then(onSettledFulfill, onSettledReject)
    }
  }

  return onSettledFulfill(item);
}
Promise.allSettled = function (iterable) {
  return Promise.all(iterableToArray(iterable).map(mapAllSettled));
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    iterableToArray(values).forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

function getAggregateError(errors){
  if(typeof AggregateError === 'function'){
    return new AggregateError(errors,'All promises were rejected');
  }

  var error = new Error('All promises were rejected');

  error.name = 'AggregateError';
  error.errors = errors;

  return error;
}

Promise.any = function promiseAny(values) {
  return new Promise(function(resolve, reject) {
    var promises = iterableToArray(values);
    var hasResolved = false;
    var rejectionReasons = [];

    function resolveOnce(value) {
      if (!hasResolved) {
        hasResolved = true;
        resolve(value);
      }
    }

    function rejectionCheck(reason) {
      rejectionReasons.push(reason);

      if (rejectionReasons.length === promises.length) {
        reject(getAggregateError(rejectionReasons));
      }
    }

    if(promises.length === 0){
      reject(getAggregateError(rejectionReasons));
    } else {
      promises.forEach(function(value){
        Promise.resolve(value).then(resolveOnce, rejectionCheck);
      });
    }
  });
};

},{"./core.js":218}],221:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.finally = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":218}],222:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":218,"./done.js":219,"./es6-extensions.js":220,"./finally.js":221,"./node-extensions.js":223,"./synchronous.js":224}],223:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":218,"asap":3}],224:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._y === 3) {
      return this._z.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._z;
  };

  Promise.prototype.getReason = function () {
    if (this._y === 3) {
      return this._z.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._z;
  };

  Promise.prototype.getState = function () {
    if (this._y === 3) {
      return this._z.getState();
    }
    if (this._y === -1 || this._y === -2) {
      return 0;
    }

    return this._y;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":218}],225:[function(require,module,exports){

const canPromise = require('./can-promise')

const QRCode = require('./core/qrcode')
const CanvasRenderer = require('./renderer/canvas')
const SvgRenderer = require('./renderer/svg-tag.js')

function renderCanvas (renderFunc, canvas, text, opts, cb) {
  const args = [].slice.call(arguments, 1)
  const argsNum = args.length
  const isLastArgCb = typeof args[argsNum - 1] === 'function'

  if (!isLastArgCb && !canPromise()) {
    throw new Error('Callback required as last argument')
  }

  if (isLastArgCb) {
    if (argsNum < 2) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 2) {
      cb = text
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 3) {
      if (canvas.getContext && typeof cb === 'undefined') {
        cb = opts
        opts = undefined
      } else {
        cb = opts
        opts = text
        text = canvas
        canvas = undefined
      }
    }
  } else {
    if (argsNum < 1) {
      throw new Error('Too few arguments provided')
    }

    if (argsNum === 1) {
      text = canvas
      canvas = opts = undefined
    } else if (argsNum === 2 && !canvas.getContext) {
      opts = text
      text = canvas
      canvas = undefined
    }

    return new Promise(function (resolve, reject) {
      try {
        const data = QRCode.create(text, opts)
        resolve(renderFunc(data, canvas, opts))
      } catch (e) {
        reject(e)
      }
    })
  }

  try {
    const data = QRCode.create(text, opts)
    cb(null, renderFunc(data, canvas, opts))
  } catch (e) {
    cb(e)
  }
}

exports.create = QRCode.create
exports.toCanvas = renderCanvas.bind(null, CanvasRenderer.render)
exports.toDataURL = renderCanvas.bind(null, CanvasRenderer.renderToDataURL)

// only svg for now.
exports.toString = renderCanvas.bind(null, function (data, _, opts) {
  return SvgRenderer.render(data, opts)
})

},{"./can-promise":226,"./core/qrcode":242,"./renderer/canvas":249,"./renderer/svg-tag.js":250}],226:[function(require,module,exports){
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157

module.exports = function () {
  return typeof Promise === 'function' && Promise.prototype && Promise.prototype.then
}

},{}],227:[function(require,module,exports){
/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */

const getSymbolSize = require('./utils').getSymbolSize

/**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */
exports.getRowColCoords = function getRowColCoords (version) {
  if (version === 1) return []

  const posCount = Math.floor(version / 7) + 2
  const size = getSymbolSize(version)
  const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2
  const positions = [size - 7] // Last coord is always (size - 7)

  for (let i = 1; i < posCount - 1; i++) {
    positions[i] = positions[i - 1] - intervals
  }

  positions.push(6) // First coord is always 6

  return positions.reverse()
}

/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const coords = []
  const pos = exports.getRowColCoords(version)
  const posLength = pos.length

  for (let i = 0; i < posLength; i++) {
    for (let j = 0; j < posLength; j++) {
      // Skip if position is occupied by finder patterns
      if ((i === 0 && j === 0) || // top-left
          (i === 0 && j === posLength - 1) || // bottom-left
          (i === posLength - 1 && j === 0)) { // top-right
        continue
      }

      coords.push([pos[i], pos[j]])
    }
  }

  return coords
}

},{"./utils":246}],228:[function(require,module,exports){
const Mode = require('./mode')

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */
const ALPHA_NUM_CHARS = [
  '0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
  'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M',
  'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
  ' ', '$', '%', '*', '+', '-', '.', '/', ':'
]

function AlphanumericData (data) {
  this.mode = Mode.ALPHANUMERIC
  this.data = data
}

AlphanumericData.getBitsLength = function getBitsLength (length) {
  return 11 * Math.floor(length / 2) + 6 * (length % 2)
}

AlphanumericData.prototype.getLength = function getLength () {
  return this.data.length
}

AlphanumericData.prototype.getBitsLength = function getBitsLength () {
  return AlphanumericData.getBitsLength(this.data.length)
}

AlphanumericData.prototype.write = function write (bitBuffer) {
  let i

  // Input data characters are divided into groups of two characters
  // and encoded as 11-bit binary codes.
  for (i = 0; i + 2 <= this.data.length; i += 2) {
    // The character value of the first character is multiplied by 45
    let value = ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45

    // The character value of the second digit is added to the product
    value += ALPHA_NUM_CHARS.indexOf(this.data[i + 1])

    // The sum is then stored as 11-bit binary number
    bitBuffer.put(value, 11)
  }

  // If the number of input data characters is not a multiple of two,
  // the character value of the final character is encoded as a 6-bit binary number.
  if (this.data.length % 2) {
    bitBuffer.put(ALPHA_NUM_CHARS.indexOf(this.data[i]), 6)
  }
}

module.exports = AlphanumericData

},{"./mode":239}],229:[function(require,module,exports){
function BitBuffer () {
  this.buffer = []
  this.length = 0
}

BitBuffer.prototype = {

  get: function (index) {
    const bufIndex = Math.floor(index / 8)
    return ((this.buffer[bufIndex] >>> (7 - index % 8)) & 1) === 1
  },

  put: function (num, length) {
    for (let i = 0; i < length; i++) {
      this.putBit(((num >>> (length - i - 1)) & 1) === 1)
    }
  },

  getLengthInBits: function () {
    return this.length
  },

  putBit: function (bit) {
    const bufIndex = Math.floor(this.length / 8)
    if (this.buffer.length <= bufIndex) {
      this.buffer.push(0)
    }

    if (bit) {
      this.buffer[bufIndex] |= (0x80 >>> (this.length % 8))
    }

    this.length++
  }
}

module.exports = BitBuffer

},{}],230:[function(require,module,exports){
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */
function BitMatrix (size) {
  if (!size || size < 1) {
    throw new Error('BitMatrix size must be defined and greater than 0')
  }

  this.size = size
  this.data = new Uint8Array(size * size)
  this.reservedBit = new Uint8Array(size * size)
}

/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */
BitMatrix.prototype.set = function (row, col, value, reserved) {
  const index = row * this.size + col
  this.data[index] = value
  if (reserved) this.reservedBit[index] = true
}

/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */
BitMatrix.prototype.get = function (row, col) {
  return this.data[row * this.size + col]
}

/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */
BitMatrix.prototype.xor = function (row, col, value) {
  this.data[row * this.size + col] ^= value
}

/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */
BitMatrix.prototype.isReserved = function (row, col) {
  return this.reservedBit[row * this.size + col]
}

module.exports = BitMatrix

},{}],231:[function(require,module,exports){
const encodeUtf8 = require('encode-utf8')
const Mode = require('./mode')

function ByteData (data) {
  this.mode = Mode.BYTE
  if (typeof (data) === 'string') {
    data = encodeUtf8(data)
  }
  this.data = new Uint8Array(data)
}

ByteData.getBitsLength = function getBitsLength (length) {
  return length * 8
}

ByteData.prototype.getLength = function getLength () {
  return this.data.length
}

ByteData.prototype.getBitsLength = function getBitsLength () {
  return ByteData.getBitsLength(this.data.length)
}

ByteData.prototype.write = function (bitBuffer) {
  for (let i = 0, l = this.data.length; i < l; i++) {
    bitBuffer.put(this.data[i], 8)
  }
}

module.exports = ByteData

},{"./mode":239,"encode-utf8":41}],232:[function(require,module,exports){
const ECLevel = require('./error-correction-level')

const EC_BLOCKS_TABLE = [
// L  M  Q  H
  1, 1, 1, 1,
  1, 1, 1, 1,
  1, 1, 2, 2,
  1, 2, 2, 4,
  1, 2, 4, 4,
  2, 4, 4, 4,
  2, 4, 6, 5,
  2, 4, 6, 6,
  2, 5, 8, 8,
  4, 5, 8, 8,
  4, 5, 8, 11,
  4, 8, 10, 11,
  4, 9, 12, 16,
  4, 9, 16, 16,
  6, 10, 12, 18,
  6, 10, 17, 16,
  6, 11, 16, 19,
  6, 13, 18, 21,
  7, 14, 21, 25,
  8, 16, 20, 25,
  8, 17, 23, 25,
  9, 17, 23, 34,
  9, 18, 25, 30,
  10, 20, 27, 32,
  12, 21, 29, 35,
  12, 23, 34, 37,
  12, 25, 34, 40,
  13, 26, 35, 42,
  14, 28, 38, 45,
  15, 29, 40, 48,
  16, 31, 43, 51,
  17, 33, 45, 54,
  18, 35, 48, 57,
  19, 37, 51, 60,
  19, 38, 53, 63,
  20, 40, 56, 66,
  21, 43, 59, 70,
  22, 45, 62, 74,
  24, 47, 65, 77,
  25, 49, 68, 81
]

const EC_CODEWORDS_TABLE = [
// L  M  Q  H
  7, 10, 13, 17,
  10, 16, 22, 28,
  15, 26, 36, 44,
  20, 36, 52, 64,
  26, 48, 72, 88,
  36, 64, 96, 112,
  40, 72, 108, 130,
  48, 88, 132, 156,
  60, 110, 160, 192,
  72, 130, 192, 224,
  80, 150, 224, 264,
  96, 176, 260, 308,
  104, 198, 288, 352,
  120, 216, 320, 384,
  132, 240, 360, 432,
  144, 280, 408, 480,
  168, 308, 448, 532,
  180, 338, 504, 588,
  196, 364, 546, 650,
  224, 416, 600, 700,
  224, 442, 644, 750,
  252, 476, 690, 816,
  270, 504, 750, 900,
  300, 560, 810, 960,
  312, 588, 870, 1050,
  336, 644, 952, 1110,
  360, 700, 1020, 1200,
  390, 728, 1050, 1260,
  420, 784, 1140, 1350,
  450, 812, 1200, 1440,
  480, 868, 1290, 1530,
  510, 924, 1350, 1620,
  540, 980, 1440, 1710,
  570, 1036, 1530, 1800,
  570, 1064, 1590, 1890,
  600, 1120, 1680, 1980,
  630, 1204, 1770, 2100,
  660, 1260, 1860, 2220,
  720, 1316, 1950, 2310,
  750, 1372, 2040, 2430
]

/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */
exports.getBlocksCount = function getBlocksCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_BLOCKS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */
exports.getTotalCodewordsCount = function getTotalCodewordsCount (version, errorCorrectionLevel) {
  switch (errorCorrectionLevel) {
    case ECLevel.L:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 0]
    case ECLevel.M:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 1]
    case ECLevel.Q:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 2]
    case ECLevel.H:
      return EC_CODEWORDS_TABLE[(version - 1) * 4 + 3]
    default:
      return undefined
  }
}

},{"./error-correction-level":233}],233:[function(require,module,exports){
exports.L = { bit: 1 }
exports.M = { bit: 0 }
exports.Q = { bit: 3 }
exports.H = { bit: 2 }

function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'l':
    case 'low':
      return exports.L

    case 'm':
    case 'medium':
      return exports.M

    case 'q':
    case 'quartile':
      return exports.Q

    case 'h':
    case 'high':
      return exports.H

    default:
      throw new Error('Unknown EC Level: ' + string)
  }
}

exports.isValid = function isValid (level) {
  return level && typeof level.bit !== 'undefined' &&
    level.bit >= 0 && level.bit < 4
}

exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{}],234:[function(require,module,exports){
const getSymbolSize = require('./utils').getSymbolSize
const FINDER_PATTERN_SIZE = 7

/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */
exports.getPositions = function getPositions (version) {
  const size = getSymbolSize(version)

  return [
    // top-left
    [0, 0],
    // top-right
    [size - FINDER_PATTERN_SIZE, 0],
    // bottom-left
    [0, size - FINDER_PATTERN_SIZE]
  ]
}

},{"./utils":246}],235:[function(require,module,exports){
const Utils = require('./utils')

const G15 = (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0)
const G15_MASK = (1 << 14) | (1 << 12) | (1 << 10) | (1 << 4) | (1 << 1)
const G15_BCH = Utils.getBCHDigit(G15)

/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */
exports.getEncodedBits = function getEncodedBits (errorCorrectionLevel, mask) {
  const data = ((errorCorrectionLevel.bit << 3) | mask)
  let d = data << 10

  while (Utils.getBCHDigit(d) - G15_BCH >= 0) {
    d ^= (G15 << (Utils.getBCHDigit(d) - G15_BCH))
  }

  // xor final data with mask pattern in order to ensure that
  // no combination of Error Correction Level and data mask pattern
  // will result in an all-zero data string
  return ((data << 10) | d) ^ G15_MASK
}

},{"./utils":246}],236:[function(require,module,exports){
const EXP_TABLE = new Uint8Array(512)
const LOG_TABLE = new Uint8Array(256)
/**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */
;(function initTables () {
  let x = 1
  for (let i = 0; i < 255; i++) {
    EXP_TABLE[i] = x
    LOG_TABLE[x] = i

    x <<= 1 // multiply by 2

    // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
    // This means that when a number is 256 or larger, it should be XORed with 0x11D.
    if (x & 0x100) { // similar to x >= 256, but a lot faster (because 0x100 == 256)
      x ^= 0x11D
    }
  }

  // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
  // stay inside the bounds (because we will mainly use this table for the multiplication of
  // two GF numbers, no more).
  // @see {@link mul}
  for (let i = 255; i < 512; i++) {
    EXP_TABLE[i] = EXP_TABLE[i - 255]
  }
}())

/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.log = function log (n) {
  if (n < 1) throw new Error('log(' + n + ')')
  return LOG_TABLE[n]
}

/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */
exports.exp = function exp (n) {
  return EXP_TABLE[n]
}

/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */
exports.mul = function mul (x, y) {
  if (x === 0 || y === 0) return 0

  // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
  // @see {@link initTables}
  return EXP_TABLE[LOG_TABLE[x] + LOG_TABLE[y]]
}

},{}],237:[function(require,module,exports){
const Mode = require('./mode')
const Utils = require('./utils')

function KanjiData (data) {
  this.mode = Mode.KANJI
  this.data = data
}

KanjiData.getBitsLength = function getBitsLength (length) {
  return length * 13
}

KanjiData.prototype.getLength = function getLength () {
  return this.data.length
}

KanjiData.prototype.getBitsLength = function getBitsLength () {
  return KanjiData.getBitsLength(this.data.length)
}

KanjiData.prototype.write = function (bitBuffer) {
  let i

  // In the Shift JIS system, Kanji characters are represented by a two byte combination.
  // These byte values are shifted from the JIS X 0208 values.
  // JIS X 0208 gives details of the shift coded representation.
  for (i = 0; i < this.data.length; i++) {
    let value = Utils.toSJIS(this.data[i])

    // For characters with Shift JIS values from 0x8140 to 0x9FFC:
    if (value >= 0x8140 && value <= 0x9FFC) {
      // Subtract 0x8140 from Shift JIS value
      value -= 0x8140

    // For characters with Shift JIS values from 0xE040 to 0xEBBF
    } else if (value >= 0xE040 && value <= 0xEBBF) {
      // Subtract 0xC140 from Shift JIS value
      value -= 0xC140
    } else {
      throw new Error(
        'Invalid SJIS character: ' + this.data[i] + '\n' +
        'Make sure your charset is UTF-8')
    }

    // Multiply most significant byte of result by 0xC0
    // and add least significant byte to product
    value = (((value >>> 8) & 0xff) * 0xC0) + (value & 0xff)

    // Convert result to a 13-bit binary string
    bitBuffer.put(value, 13)
  }
}

module.exports = KanjiData

},{"./mode":239,"./utils":246}],238:[function(require,module,exports){
/**
 * Data mask pattern reference
 * @type {Object}
 */
exports.Patterns = {
  PATTERN000: 0,
  PATTERN001: 1,
  PATTERN010: 2,
  PATTERN011: 3,
  PATTERN100: 4,
  PATTERN101: 5,
  PATTERN110: 6,
  PATTERN111: 7
}

/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */
const PenaltyScores = {
  N1: 3,
  N2: 3,
  N3: 40,
  N4: 10
}

/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */
exports.isValid = function isValid (mask) {
  return mask != null && mask !== '' && !isNaN(mask) && mask >= 0 && mask <= 7
}

/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */
exports.from = function from (value) {
  return exports.isValid(value) ? parseInt(value, 10) : undefined
}

/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/
exports.getPenaltyN1 = function getPenaltyN1 (data) {
  const size = data.size
  let points = 0
  let sameCountCol = 0
  let sameCountRow = 0
  let lastCol = null
  let lastRow = null

  for (let row = 0; row < size; row++) {
    sameCountCol = sameCountRow = 0
    lastCol = lastRow = null

    for (let col = 0; col < size; col++) {
      let module = data.get(row, col)
      if (module === lastCol) {
        sameCountCol++
      } else {
        if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
        lastCol = module
        sameCountCol = 1
      }

      module = data.get(col, row)
      if (module === lastRow) {
        sameCountRow++
      } else {
        if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
        lastRow = module
        sameCountRow = 1
      }
    }

    if (sameCountCol >= 5) points += PenaltyScores.N1 + (sameCountCol - 5)
    if (sameCountRow >= 5) points += PenaltyScores.N1 + (sameCountRow - 5)
  }

  return points
}

/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */
exports.getPenaltyN2 = function getPenaltyN2 (data) {
  const size = data.size
  let points = 0

  for (let row = 0; row < size - 1; row++) {
    for (let col = 0; col < size - 1; col++) {
      const last = data.get(row, col) +
        data.get(row, col + 1) +
        data.get(row + 1, col) +
        data.get(row + 1, col + 1)

      if (last === 4 || last === 0) points++
    }
  }

  return points * PenaltyScores.N2
}

/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */
exports.getPenaltyN3 = function getPenaltyN3 (data) {
  const size = data.size
  let points = 0
  let bitsCol = 0
  let bitsRow = 0

  for (let row = 0; row < size; row++) {
    bitsCol = bitsRow = 0
    for (let col = 0; col < size; col++) {
      bitsCol = ((bitsCol << 1) & 0x7FF) | data.get(row, col)
      if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++

      bitsRow = ((bitsRow << 1) & 0x7FF) | data.get(col, row)
      if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++
    }
  }

  return points * PenaltyScores.N3
}

/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */
exports.getPenaltyN4 = function getPenaltyN4 (data) {
  let darkCount = 0
  const modulesCount = data.data.length

  for (let i = 0; i < modulesCount; i++) darkCount += data.data[i]

  const k = Math.abs(Math.ceil((darkCount * 100 / modulesCount) / 5) - 10)

  return k * PenaltyScores.N4
}

/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */
function getMaskAt (maskPattern, i, j) {
  switch (maskPattern) {
    case exports.Patterns.PATTERN000: return (i + j) % 2 === 0
    case exports.Patterns.PATTERN001: return i % 2 === 0
    case exports.Patterns.PATTERN010: return j % 3 === 0
    case exports.Patterns.PATTERN011: return (i + j) % 3 === 0
    case exports.Patterns.PATTERN100: return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0
    case exports.Patterns.PATTERN101: return (i * j) % 2 + (i * j) % 3 === 0
    case exports.Patterns.PATTERN110: return ((i * j) % 2 + (i * j) % 3) % 2 === 0
    case exports.Patterns.PATTERN111: return ((i * j) % 3 + (i + j) % 2) % 2 === 0

    default: throw new Error('bad maskPattern:' + maskPattern)
  }
}

/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */
exports.applyMask = function applyMask (pattern, data) {
  const size = data.size

  for (let col = 0; col < size; col++) {
    for (let row = 0; row < size; row++) {
      if (data.isReserved(row, col)) continue
      data.xor(row, col, getMaskAt(pattern, row, col))
    }
  }
}

/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */
exports.getBestMask = function getBestMask (data, setupFormatFunc) {
  const numPatterns = Object.keys(exports.Patterns).length
  let bestPattern = 0
  let lowerPenalty = Infinity

  for (let p = 0; p < numPatterns; p++) {
    setupFormatFunc(p)
    exports.applyMask(p, data)

    // Calculate penalty
    const penalty =
      exports.getPenaltyN1(data) +
      exports.getPenaltyN2(data) +
      exports.getPenaltyN3(data) +
      exports.getPenaltyN4(data)

    // Undo previously applied mask
    exports.applyMask(p, data)

    if (penalty < lowerPenalty) {
      lowerPenalty = penalty
      bestPattern = p
    }
  }

  return bestPattern
}

},{}],239:[function(require,module,exports){
const VersionCheck = require('./version-check')
const Regex = require('./regex')

/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */
exports.NUMERIC = {
  id: 'Numeric',
  bit: 1 << 0,
  ccBits: [10, 12, 14]
}

/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */
exports.ALPHANUMERIC = {
  id: 'Alphanumeric',
  bit: 1 << 1,
  ccBits: [9, 11, 13]
}

/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */
exports.BYTE = {
  id: 'Byte',
  bit: 1 << 2,
  ccBits: [8, 16, 16]
}

/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */
exports.KANJI = {
  id: 'Kanji',
  bit: 1 << 3,
  ccBits: [8, 10, 12]
}

/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */
exports.MIXED = {
  bit: -1
}

/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */
exports.getCharCountIndicator = function getCharCountIndicator (mode, version) {
  if (!mode.ccBits) throw new Error('Invalid mode: ' + mode)

  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid version: ' + version)
  }

  if (version >= 1 && version < 10) return mode.ccBits[0]
  else if (version < 27) return mode.ccBits[1]
  return mode.ccBits[2]
}

/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */
exports.getBestModeForData = function getBestModeForData (dataStr) {
  if (Regex.testNumeric(dataStr)) return exports.NUMERIC
  else if (Regex.testAlphanumeric(dataStr)) return exports.ALPHANUMERIC
  else if (Regex.testKanji(dataStr)) return exports.KANJI
  else return exports.BYTE
}

/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */
exports.toString = function toString (mode) {
  if (mode && mode.id) return mode.id
  throw new Error('Invalid mode')
}

/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */
exports.isValid = function isValid (mode) {
  return mode && mode.bit && mode.ccBits
}

/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */
function fromString (string) {
  if (typeof string !== 'string') {
    throw new Error('Param is not a string')
  }

  const lcStr = string.toLowerCase()

  switch (lcStr) {
    case 'numeric':
      return exports.NUMERIC
    case 'alphanumeric':
      return exports.ALPHANUMERIC
    case 'kanji':
      return exports.KANJI
    case 'byte':
      return exports.BYTE
    default:
      throw new Error('Unknown mode: ' + string)
  }
}

/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */
exports.from = function from (value, defaultValue) {
  if (exports.isValid(value)) {
    return value
  }

  try {
    return fromString(value)
  } catch (e) {
    return defaultValue
  }
}

},{"./regex":244,"./version-check":247}],240:[function(require,module,exports){
const Mode = require('./mode')

function NumericData (data) {
  this.mode = Mode.NUMERIC
  this.data = data.toString()
}

NumericData.getBitsLength = function getBitsLength (length) {
  return 10 * Math.floor(length / 3) + ((length % 3) ? ((length % 3) * 3 + 1) : 0)
}

NumericData.prototype.getLength = function getLength () {
  return this.data.length
}

NumericData.prototype.getBitsLength = function getBitsLength () {
  return NumericData.getBitsLength(this.data.length)
}

NumericData.prototype.write = function write (bitBuffer) {
  let i, group, value

  // The input data string is divided into groups of three digits,
  // and each group is converted to its 10-bit binary equivalent.
  for (i = 0; i + 3 <= this.data.length; i += 3) {
    group = this.data.substr(i, 3)
    value = parseInt(group, 10)

    bitBuffer.put(value, 10)
  }

  // If the number of input digits is not an exact multiple of three,
  // the final one or two digits are converted to 4 or 7 bits respectively.
  const remainingNum = this.data.length - i
  if (remainingNum > 0) {
    group = this.data.substr(i)
    value = parseInt(group, 10)

    bitBuffer.put(value, remainingNum * 3 + 1)
  }
}

module.exports = NumericData

},{"./mode":239}],241:[function(require,module,exports){
const GF = require('./galois-field')

/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */
exports.mul = function mul (p1, p2) {
  const coeff = new Uint8Array(p1.length + p2.length - 1)

  for (let i = 0; i < p1.length; i++) {
    for (let j = 0; j < p2.length; j++) {
      coeff[i + j] ^= GF.mul(p1[i], p2[j])
    }
  }

  return coeff
}

/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */
exports.mod = function mod (divident, divisor) {
  let result = new Uint8Array(divident)

  while ((result.length - divisor.length) >= 0) {
    const coeff = result[0]

    for (let i = 0; i < divisor.length; i++) {
      result[i] ^= GF.mul(divisor[i], coeff)
    }

    // remove all zeros from buffer head
    let offset = 0
    while (offset < result.length && result[offset] === 0) offset++
    result = result.slice(offset)
  }

  return result
}

/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */
exports.generateECPolynomial = function generateECPolynomial (degree) {
  let poly = new Uint8Array([1])
  for (let i = 0; i < degree; i++) {
    poly = exports.mul(poly, new Uint8Array([1, GF.exp(i)]))
  }

  return poly
}

},{"./galois-field":236}],242:[function(require,module,exports){
const Utils = require('./utils')
const ECLevel = require('./error-correction-level')
const BitBuffer = require('./bit-buffer')
const BitMatrix = require('./bit-matrix')
const AlignmentPattern = require('./alignment-pattern')
const FinderPattern = require('./finder-pattern')
const MaskPattern = require('./mask-pattern')
const ECCode = require('./error-correction-code')
const ReedSolomonEncoder = require('./reed-solomon-encoder')
const Version = require('./version')
const FormatInfo = require('./format-info')
const Mode = require('./mode')
const Segments = require('./segments')

/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/

/**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupFinderPattern (matrix, version) {
  const size = matrix.size
  const pos = FinderPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -1; r <= 7; r++) {
      if (row + r <= -1 || size <= row + r) continue

      for (let c = -1; c <= 7; c++) {
        if (col + c <= -1 || size <= col + c) continue

        if ((r >= 0 && r <= 6 && (c === 0 || c === 6)) ||
          (c >= 0 && c <= 6 && (r === 0 || r === 6)) ||
          (r >= 2 && r <= 4 && c >= 2 && c <= 4)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */
function setupTimingPattern (matrix) {
  const size = matrix.size

  for (let r = 8; r < size - 8; r++) {
    const value = r % 2 === 0
    matrix.set(r, 6, value, true)
    matrix.set(6, r, value, true)
  }
}

/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupAlignmentPattern (matrix, version) {
  const pos = AlignmentPattern.getPositions(version)

  for (let i = 0; i < pos.length; i++) {
    const row = pos[i][0]
    const col = pos[i][1]

    for (let r = -2; r <= 2; r++) {
      for (let c = -2; c <= 2; c++) {
        if (r === -2 || r === 2 || c === -2 || c === 2 ||
          (r === 0 && c === 0)) {
          matrix.set(row + r, col + c, true, true)
        } else {
          matrix.set(row + r, col + c, false, true)
        }
      }
    }
  }
}

/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */
function setupVersionInfo (matrix, version) {
  const size = matrix.size
  const bits = Version.getEncodedBits(version)
  let row, col, mod

  for (let i = 0; i < 18; i++) {
    row = Math.floor(i / 3)
    col = i % 3 + size - 8 - 3
    mod = ((bits >> i) & 1) === 1

    matrix.set(row, col, mod, true)
    matrix.set(col, row, mod, true)
  }
}

/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */
function setupFormatInfo (matrix, errorCorrectionLevel, maskPattern) {
  const size = matrix.size
  const bits = FormatInfo.getEncodedBits(errorCorrectionLevel, maskPattern)
  let i, mod

  for (i = 0; i < 15; i++) {
    mod = ((bits >> i) & 1) === 1

    // vertical
    if (i < 6) {
      matrix.set(i, 8, mod, true)
    } else if (i < 8) {
      matrix.set(i + 1, 8, mod, true)
    } else {
      matrix.set(size - 15 + i, 8, mod, true)
    }

    // horizontal
    if (i < 8) {
      matrix.set(8, size - i - 1, mod, true)
    } else if (i < 9) {
      matrix.set(8, 15 - i - 1 + 1, mod, true)
    } else {
      matrix.set(8, 15 - i - 1, mod, true)
    }
  }

  // fixed module
  matrix.set(size - 8, 8, 1, true)
}

/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */
function setupData (matrix, data) {
  const size = matrix.size
  let inc = -1
  let row = size - 1
  let bitIndex = 7
  let byteIndex = 0

  for (let col = size - 1; col > 0; col -= 2) {
    if (col === 6) col--

    while (true) {
      for (let c = 0; c < 2; c++) {
        if (!matrix.isReserved(row, col - c)) {
          let dark = false

          if (byteIndex < data.length) {
            dark = (((data[byteIndex] >>> bitIndex) & 1) === 1)
          }

          matrix.set(row, col - c, dark)
          bitIndex--

          if (bitIndex === -1) {
            byteIndex++
            bitIndex = 7
          }
        }
      }

      row += inc

      if (row < 0 || size <= row) {
        row -= inc
        inc = -inc
        break
      }
    }
  }
}

/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */
function createData (version, errorCorrectionLevel, segments) {
  // Prepare data buffer
  const buffer = new BitBuffer()

  segments.forEach(function (data) {
    // prefix data with mode indicator (4 bits)
    buffer.put(data.mode.bit, 4)

    // Prefix data with character count indicator.
    // The character count indicator is a string of bits that represents the
    // number of characters that are being encoded.
    // The character count indicator must be placed after the mode indicator
    // and must be a certain number of bits long, depending on the QR version
    // and data mode
    // @see {@link Mode.getCharCountIndicator}.
    buffer.put(data.getLength(), Mode.getCharCountIndicator(data.mode, version))

    // add binary data sequence to buffer
    data.write(buffer)
  })

  // Calculate required number of bits
  const totalCodewords = Utils.getSymbolTotalCodewords(version)
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  // Add a terminator.
  // If the bit string is shorter than the total number of required bits,
  // a terminator of up to four 0s must be added to the right side of the string.
  // If the bit string is more than four bits shorter than the required number of bits,
  // add four 0s to the end.
  if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) {
    buffer.put(0, 4)
  }

  // If the bit string is fewer than four bits shorter, add only the number of 0s that
  // are needed to reach the required number of bits.

  // After adding the terminator, if the number of bits in the string is not a multiple of 8,
  // pad the string on the right with 0s to make the string's length a multiple of 8.
  while (buffer.getLengthInBits() % 8 !== 0) {
    buffer.putBit(0)
  }

  // Add pad bytes if the string is still shorter than the total number of required bits.
  // Extend the buffer to fill the data capacity of the symbol corresponding to
  // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
  // and 00010001 (0x11) alternately.
  const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8
  for (let i = 0; i < remainingByte; i++) {
    buffer.put(i % 2 ? 0x11 : 0xEC, 8)
  }

  return createCodewords(buffer, version, errorCorrectionLevel)
}

/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */
function createCodewords (bitBuffer, version, errorCorrectionLevel) {
  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewords = totalCodewords - ecTotalCodewords

  // Total number of blocks
  const ecTotalBlocks = ECCode.getBlocksCount(version, errorCorrectionLevel)

  // Calculate how many blocks each group should contain
  const blocksInGroup2 = totalCodewords % ecTotalBlocks
  const blocksInGroup1 = ecTotalBlocks - blocksInGroup2

  const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks)

  const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks)
  const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1

  // Number of EC codewords is the same for both groups
  const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1

  // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
  const rs = new ReedSolomonEncoder(ecCount)

  let offset = 0
  const dcData = new Array(ecTotalBlocks)
  const ecData = new Array(ecTotalBlocks)
  let maxDataSize = 0
  const buffer = new Uint8Array(bitBuffer.buffer)

  // Divide the buffer into the required number of blocks
  for (let b = 0; b < ecTotalBlocks; b++) {
    const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2

    // extract a block of data from buffer
    dcData[b] = buffer.slice(offset, offset + dataSize)

    // Calculate EC codewords for this data block
    ecData[b] = rs.encode(dcData[b])

    offset += dataSize
    maxDataSize = Math.max(maxDataSize, dataSize)
  }

  // Create final data
  // Interleave the data and error correction codewords from each block
  const data = new Uint8Array(totalCodewords)
  let index = 0
  let i, r

  // Add data codewords
  for (i = 0; i < maxDataSize; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      if (i < dcData[r].length) {
        data[index++] = dcData[r][i]
      }
    }
  }

  // Apped EC codewords
  for (i = 0; i < ecCount; i++) {
    for (r = 0; r < ecTotalBlocks; r++) {
      data[index++] = ecData[r][i]
    }
  }

  return data
}

/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */
function createSymbol (data, version, errorCorrectionLevel, maskPattern) {
  let segments

  if (Array.isArray(data)) {
    segments = Segments.fromArray(data)
  } else if (typeof data === 'string') {
    let estimatedVersion = version

    if (!estimatedVersion) {
      const rawSegments = Segments.rawSplit(data)

      // Estimate best version that can contain raw splitted segments
      estimatedVersion = Version.getBestVersionForData(rawSegments, errorCorrectionLevel)
    }

    // Build optimized segments
    // If estimated version is undefined, try with the highest version
    segments = Segments.fromString(data, estimatedVersion || 40)
  } else {
    throw new Error('Invalid data')
  }

  // Get the min version that can contain data
  const bestVersion = Version.getBestVersionForData(segments, errorCorrectionLevel)

  // If no version is found, data cannot be stored
  if (!bestVersion) {
    throw new Error('The amount of data is too big to be stored in a QR Code')
  }

  // If not specified, use min version as default
  if (!version) {
    version = bestVersion

  // Check if the specified version can contain the data
  } else if (version < bestVersion) {
    throw new Error('\n' +
      'The chosen QR Code version cannot contain this amount of data.\n' +
      'Minimum version required to store current data is: ' + bestVersion + '.\n'
    )
  }

  const dataBits = createData(version, errorCorrectionLevel, segments)

  // Allocate matrix buffer
  const moduleCount = Utils.getSymbolSize(version)
  const modules = new BitMatrix(moduleCount)

  // Add function modules
  setupFinderPattern(modules, version)
  setupTimingPattern(modules)
  setupAlignmentPattern(modules, version)

  // Add temporary dummy bits for format info just to set them as reserved.
  // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
  // since the masking operation must be performed only on the encoding region.
  // These blocks will be replaced with correct values later in code.
  setupFormatInfo(modules, errorCorrectionLevel, 0)

  if (version >= 7) {
    setupVersionInfo(modules, version)
  }

  // Add data codewords
  setupData(modules, dataBits)

  if (isNaN(maskPattern)) {
    // Find best mask pattern
    maskPattern = MaskPattern.getBestMask(modules,
      setupFormatInfo.bind(null, modules, errorCorrectionLevel))
  }

  // Apply mask pattern
  MaskPattern.applyMask(maskPattern, modules)

  // Replace format info bits with correct values
  setupFormatInfo(modules, errorCorrectionLevel, maskPattern)

  return {
    modules: modules,
    version: version,
    errorCorrectionLevel: errorCorrectionLevel,
    maskPattern: maskPattern,
    segments: segments
  }
}

/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */
exports.create = function create (data, options) {
  if (typeof data === 'undefined' || data === '') {
    throw new Error('No input text')
  }

  let errorCorrectionLevel = ECLevel.M
  let version
  let mask

  if (typeof options !== 'undefined') {
    // Use higher error correction level as default
    errorCorrectionLevel = ECLevel.from(options.errorCorrectionLevel, ECLevel.M)
    version = Version.from(options.version)
    mask = MaskPattern.from(options.maskPattern)

    if (options.toSJISFunc) {
      Utils.setToSJISFunction(options.toSJISFunc)
    }
  }

  return createSymbol(data, version, errorCorrectionLevel, mask)
}

},{"./alignment-pattern":227,"./bit-buffer":229,"./bit-matrix":230,"./error-correction-code":232,"./error-correction-level":233,"./finder-pattern":234,"./format-info":235,"./mask-pattern":238,"./mode":239,"./reed-solomon-encoder":243,"./segments":245,"./utils":246,"./version":248}],243:[function(require,module,exports){
const Polynomial = require('./polynomial')

function ReedSolomonEncoder (degree) {
  this.genPoly = undefined
  this.degree = degree

  if (this.degree) this.initialize(this.degree)
}

/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */
ReedSolomonEncoder.prototype.initialize = function initialize (degree) {
  // create an irreducible generator polynomial
  this.degree = degree
  this.genPoly = Polynomial.generateECPolynomial(this.degree)
}

/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */
ReedSolomonEncoder.prototype.encode = function encode (data) {
  if (!this.genPoly) {
    throw new Error('Encoder not initialized')
  }

  // Calculate EC for this data block
  // extends data size to data+genPoly size
  const paddedData = new Uint8Array(data.length + this.degree)
  paddedData.set(data)

  // The error correction codewords are the remainder after dividing the data codewords
  // by a generator polynomial
  const remainder = Polynomial.mod(paddedData, this.genPoly)

  // return EC data blocks (last n byte, where n is the degree of genPoly)
  // If coefficients number in remainder are less than genPoly degree,
  // pad with 0s to the left to reach the needed number of coefficients
  const start = this.degree - remainder.length
  if (start > 0) {
    const buff = new Uint8Array(this.degree)
    buff.set(remainder, start)

    return buff
  }

  return remainder
}

module.exports = ReedSolomonEncoder

},{"./polynomial":241}],244:[function(require,module,exports){
const numeric = '[0-9]+'
const alphanumeric = '[A-Z $%*+\\-./:]+'
let kanji = '(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|' +
  '[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|' +
  '[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|' +
  '[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+'
kanji = kanji.replace(/u/g, '\\u')

const byte = '(?:(?![A-Z0-9 $%*+\\-./:]|' + kanji + ')(?:.|[\r\n]))+'

exports.KANJI = new RegExp(kanji, 'g')
exports.BYTE_KANJI = new RegExp('[^A-Z0-9 $%*+\\-./:]+', 'g')
exports.BYTE = new RegExp(byte, 'g')
exports.NUMERIC = new RegExp(numeric, 'g')
exports.ALPHANUMERIC = new RegExp(alphanumeric, 'g')

const TEST_KANJI = new RegExp('^' + kanji + '$')
const TEST_NUMERIC = new RegExp('^' + numeric + '$')
const TEST_ALPHANUMERIC = new RegExp('^[A-Z0-9 $%*+\\-./:]+$')

exports.testKanji = function testKanji (str) {
  return TEST_KANJI.test(str)
}

exports.testNumeric = function testNumeric (str) {
  return TEST_NUMERIC.test(str)
}

exports.testAlphanumeric = function testAlphanumeric (str) {
  return TEST_ALPHANUMERIC.test(str)
}

},{}],245:[function(require,module,exports){
const Mode = require('./mode')
const NumericData = require('./numeric-data')
const AlphanumericData = require('./alphanumeric-data')
const ByteData = require('./byte-data')
const KanjiData = require('./kanji-data')
const Regex = require('./regex')
const Utils = require('./utils')
const dijkstra = require('dijkstrajs')

/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */
function getStringByteLength (str) {
  return unescape(encodeURIComponent(str)).length
}

/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */
function getSegments (regex, mode, str) {
  const segments = []
  let result

  while ((result = regex.exec(str)) !== null) {
    segments.push({
      data: result[0],
      index: result.index,
      mode: mode,
      length: result[0].length
    })
  }

  return segments
}

/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */
function getSegmentsFromString (dataStr) {
  const numSegs = getSegments(Regex.NUMERIC, Mode.NUMERIC, dataStr)
  const alphaNumSegs = getSegments(Regex.ALPHANUMERIC, Mode.ALPHANUMERIC, dataStr)
  let byteSegs
  let kanjiSegs

  if (Utils.isKanjiModeEnabled()) {
    byteSegs = getSegments(Regex.BYTE, Mode.BYTE, dataStr)
    kanjiSegs = getSegments(Regex.KANJI, Mode.KANJI, dataStr)
  } else {
    byteSegs = getSegments(Regex.BYTE_KANJI, Mode.BYTE, dataStr)
    kanjiSegs = []
  }

  const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs)

  return segs
    .sort(function (s1, s2) {
      return s1.index - s2.index
    })
    .map(function (obj) {
      return {
        data: obj.data,
        mode: obj.mode,
        length: obj.length
      }
    })
}

/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */
function getSegmentBitsLength (length, mode) {
  switch (mode) {
    case Mode.NUMERIC:
      return NumericData.getBitsLength(length)
    case Mode.ALPHANUMERIC:
      return AlphanumericData.getBitsLength(length)
    case Mode.KANJI:
      return KanjiData.getBitsLength(length)
    case Mode.BYTE:
      return ByteData.getBitsLength(length)
  }
}

/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function mergeSegments (segs) {
  return segs.reduce(function (acc, curr) {
    const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null
    if (prevSeg && prevSeg.mode === curr.mode) {
      acc[acc.length - 1].data += curr.data
      return acc
    }

    acc.push(curr)
    return acc
  }, [])
}

/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */
function buildNodes (segs) {
  const nodes = []
  for (let i = 0; i < segs.length; i++) {
    const seg = segs[i]

    switch (seg.mode) {
      case Mode.NUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.ALPHANUMERIC, length: seg.length },
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.ALPHANUMERIC:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: seg.length }
        ])
        break
      case Mode.KANJI:
        nodes.push([seg,
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
        break
      case Mode.BYTE:
        nodes.push([
          { data: seg.data, mode: Mode.BYTE, length: getStringByteLength(seg.data) }
        ])
    }
  }

  return nodes
}

/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */
function buildGraph (nodes, version) {
  const table = {}
  const graph = { start: {} }
  let prevNodeIds = ['start']

  for (let i = 0; i < nodes.length; i++) {
    const nodeGroup = nodes[i]
    const currentNodeIds = []

    for (let j = 0; j < nodeGroup.length; j++) {
      const node = nodeGroup[j]
      const key = '' + i + j

      currentNodeIds.push(key)
      table[key] = { node: node, lastCount: 0 }
      graph[key] = {}

      for (let n = 0; n < prevNodeIds.length; n++) {
        const prevNodeId = prevNodeIds[n]

        if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
          graph[prevNodeId][key] =
            getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) -
            getSegmentBitsLength(table[prevNodeId].lastCount, node.mode)

          table[prevNodeId].lastCount += node.length
        } else {
          if (table[prevNodeId]) table[prevNodeId].lastCount = node.length

          graph[prevNodeId][key] = getSegmentBitsLength(node.length, node.mode) +
            4 + Mode.getCharCountIndicator(node.mode, version) // switch cost
        }
      }
    }

    prevNodeIds = currentNodeIds
  }

  for (let n = 0; n < prevNodeIds.length; n++) {
    graph[prevNodeIds[n]].end = 0
  }

  return { map: graph, table: table }
}

/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */
function buildSingleSegment (data, modesHint) {
  let mode
  const bestMode = Mode.getBestModeForData(data)

  mode = Mode.from(modesHint, bestMode)

  // Make sure data can be encoded
  if (mode !== Mode.BYTE && mode.bit < bestMode.bit) {
    throw new Error('"' + data + '"' +
      ' cannot be encoded with mode ' + Mode.toString(mode) +
      '.\n Suggested mode is: ' + Mode.toString(bestMode))
  }

  // Use Mode.BYTE if Kanji support is disabled
  if (mode === Mode.KANJI && !Utils.isKanjiModeEnabled()) {
    mode = Mode.BYTE
  }

  switch (mode) {
    case Mode.NUMERIC:
      return new NumericData(data)

    case Mode.ALPHANUMERIC:
      return new AlphanumericData(data)

    case Mode.KANJI:
      return new KanjiData(data)

    case Mode.BYTE:
      return new ByteData(data)
  }
}

/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */
exports.fromArray = function fromArray (array) {
  return array.reduce(function (acc, seg) {
    if (typeof seg === 'string') {
      acc.push(buildSingleSegment(seg, null))
    } else if (seg.data) {
      acc.push(buildSingleSegment(seg.data, seg.mode))
    }

    return acc
  }, [])
}

/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */
exports.fromString = function fromString (data, version) {
  const segs = getSegmentsFromString(data, Utils.isKanjiModeEnabled())

  const nodes = buildNodes(segs)
  const graph = buildGraph(nodes, version)
  const path = dijkstra.find_path(graph.map, 'start', 'end')

  const optimizedSegs = []
  for (let i = 1; i < path.length - 1; i++) {
    optimizedSegs.push(graph.table[path[i]].node)
  }

  return exports.fromArray(mergeSegments(optimizedSegs))
}

/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */
exports.rawSplit = function rawSplit (data) {
  return exports.fromArray(
    getSegmentsFromString(data, Utils.isKanjiModeEnabled())
  )
}

},{"./alphanumeric-data":228,"./byte-data":231,"./kanji-data":237,"./mode":239,"./numeric-data":240,"./regex":244,"./utils":246,"dijkstrajs":40}],246:[function(require,module,exports){
let toSJISFunction
const CODEWORDS_COUNT = [
  0, // Not used
  26, 44, 70, 100, 134, 172, 196, 242, 292, 346,
  404, 466, 532, 581, 655, 733, 815, 901, 991, 1085,
  1156, 1258, 1364, 1474, 1588, 1706, 1828, 1921, 2051, 2185,
  2323, 2465, 2611, 2761, 2876, 3034, 3196, 3362, 3532, 3706
]

/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */
exports.getSymbolSize = function getSymbolSize (version) {
  if (!version) throw new Error('"version" cannot be null or undefined')
  if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40')
  return version * 4 + 17
}

/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */
exports.getSymbolTotalCodewords = function getSymbolTotalCodewords (version) {
  return CODEWORDS_COUNT[version]
}

/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */
exports.getBCHDigit = function (data) {
  let digit = 0

  while (data !== 0) {
    digit++
    data >>>= 1
  }

  return digit
}

exports.setToSJISFunction = function setToSJISFunction (f) {
  if (typeof f !== 'function') {
    throw new Error('"toSJISFunc" is not a valid function.')
  }

  toSJISFunction = f
}

exports.isKanjiModeEnabled = function () {
  return typeof toSJISFunction !== 'undefined'
}

exports.toSJIS = function toSJIS (kanji) {
  return toSJISFunction(kanji)
}

},{}],247:[function(require,module,exports){
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */
exports.isValid = function isValid (version) {
  return !isNaN(version) && version >= 1 && version <= 40
}

},{}],248:[function(require,module,exports){
const Utils = require('./utils')
const ECCode = require('./error-correction-code')
const ECLevel = require('./error-correction-level')
const Mode = require('./mode')
const VersionCheck = require('./version-check')

// Generator polynomial used to encode version information
const G18 = (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0)
const G18_BCH = Utils.getBCHDigit(G18)

function getBestVersionForDataLength (mode, length, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, mode)) {
      return currentVersion
    }
  }

  return undefined
}

function getReservedBitsCount (mode, version) {
  // Character count indicator + mode indicator bits
  return Mode.getCharCountIndicator(mode, version) + 4
}

function getTotalBitsFromDataArray (segments, version) {
  let totalBits = 0

  segments.forEach(function (data) {
    const reservedBits = getReservedBitsCount(data.mode, version)
    totalBits += reservedBits + data.getBitsLength()
  })

  return totalBits
}

function getBestVersionForMixedData (segments, errorCorrectionLevel) {
  for (let currentVersion = 1; currentVersion <= 40; currentVersion++) {
    const length = getTotalBitsFromDataArray(segments, currentVersion)
    if (length <= exports.getCapacity(currentVersion, errorCorrectionLevel, Mode.MIXED)) {
      return currentVersion
    }
  }

  return undefined
}

/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */
exports.from = function from (value, defaultValue) {
  if (VersionCheck.isValid(value)) {
    return parseInt(value, 10)
  }

  return defaultValue
}

/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */
exports.getCapacity = function getCapacity (version, errorCorrectionLevel, mode) {
  if (!VersionCheck.isValid(version)) {
    throw new Error('Invalid QR Code version')
  }

  // Use Byte mode as default
  if (typeof mode === 'undefined') mode = Mode.BYTE

  // Total codewords for this QR code version (Data + Error correction)
  const totalCodewords = Utils.getSymbolTotalCodewords(version)

  // Total number of error correction codewords
  const ecTotalCodewords = ECCode.getTotalCodewordsCount(version, errorCorrectionLevel)

  // Total number of data codewords
  const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8

  if (mode === Mode.MIXED) return dataTotalCodewordsBits

  const usableBits = dataTotalCodewordsBits - getReservedBitsCount(mode, version)

  // Return max number of storable codewords
  switch (mode) {
    case Mode.NUMERIC:
      return Math.floor((usableBits / 10) * 3)

    case Mode.ALPHANUMERIC:
      return Math.floor((usableBits / 11) * 2)

    case Mode.KANJI:
      return Math.floor(usableBits / 13)

    case Mode.BYTE:
    default:
      return Math.floor(usableBits / 8)
  }
}

/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */
exports.getBestVersionForData = function getBestVersionForData (data, errorCorrectionLevel) {
  let seg

  const ecl = ECLevel.from(errorCorrectionLevel, ECLevel.M)

  if (Array.isArray(data)) {
    if (data.length > 1) {
      return getBestVersionForMixedData(data, ecl)
    }

    if (data.length === 0) {
      return 1
    }

    seg = data[0]
  } else {
    seg = data
  }

  return getBestVersionForDataLength(seg.mode, seg.getLength(), ecl)
}

/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */
exports.getEncodedBits = function getEncodedBits (version) {
  if (!VersionCheck.isValid(version) || version < 7) {
    throw new Error('Invalid QR Code version')
  }

  let d = version << 12

  while (Utils.getBCHDigit(d) - G18_BCH >= 0) {
    d ^= (G18 << (Utils.getBCHDigit(d) - G18_BCH))
  }

  return (version << 12) | d
}

},{"./error-correction-code":232,"./error-correction-level":233,"./mode":239,"./utils":246,"./version-check":247}],249:[function(require,module,exports){
const Utils = require('./utils')

function clearCanvas (ctx, canvas, size) {
  ctx.clearRect(0, 0, canvas.width, canvas.height)

  if (!canvas.style) canvas.style = {}
  canvas.height = size
  canvas.width = size
  canvas.style.height = size + 'px'
  canvas.style.width = size + 'px'
}

function getCanvasElement () {
  try {
    return document.createElement('canvas')
  } catch (e) {
    throw new Error('You need to specify a canvas element')
  }
}

exports.render = function render (qrData, canvas, options) {
  let opts = options
  let canvasEl = canvas

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!canvas) {
    canvasEl = getCanvasElement()
  }

  opts = Utils.getOptions(opts)
  const size = Utils.getImageWidth(qrData.modules.size, opts)

  const ctx = canvasEl.getContext('2d')
  const image = ctx.createImageData(size, size)
  Utils.qrToImageData(image.data, qrData, opts)

  clearCanvas(ctx, canvasEl, size)
  ctx.putImageData(image, 0, 0)

  return canvasEl
}

exports.renderToDataURL = function renderToDataURL (qrData, canvas, options) {
  let opts = options

  if (typeof opts === 'undefined' && (!canvas || !canvas.getContext)) {
    opts = canvas
    canvas = undefined
  }

  if (!opts) opts = {}

  const canvasEl = exports.render(qrData, canvas, opts)

  const type = opts.type || 'image/png'
  const rendererOpts = opts.rendererOpts || {}

  return canvasEl.toDataURL(type, rendererOpts.quality)
}

},{"./utils":251}],250:[function(require,module,exports){
const Utils = require('./utils')

function getColorAttrib (color, attrib) {
  const alpha = color.a / 255
  const str = attrib + '="' + color.hex + '"'

  return alpha < 1
    ? str + ' ' + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"'
    : str
}

function svgCmd (cmd, x, y) {
  let str = cmd + x
  if (typeof y !== 'undefined') str += ' ' + y

  return str
}

function qrToPath (data, size, margin) {
  let path = ''
  let moveBy = 0
  let newRow = false
  let lineLength = 0

  for (let i = 0; i < data.length; i++) {
    const col = Math.floor(i % size)
    const row = Math.floor(i / size)

    if (!col && !newRow) newRow = true

    if (data[i]) {
      lineLength++

      if (!(i > 0 && col > 0 && data[i - 1])) {
        path += newRow
          ? svgCmd('M', col + margin, 0.5 + row + margin)
          : svgCmd('m', moveBy, 0)

        moveBy = 0
        newRow = false
      }

      if (!(col + 1 < size && data[i + 1])) {
        path += svgCmd('h', lineLength)
        lineLength = 0
      }
    } else {
      moveBy++
    }
  }

  return path
}

exports.render = function render (qrData, options, cb) {
  const opts = Utils.getOptions(options)
  const size = qrData.modules.size
  const data = qrData.modules.data
  const qrcodesize = size + opts.margin * 2

  const bg = !opts.color.light.a
    ? ''
    : '<path ' + getColorAttrib(opts.color.light, 'fill') +
      ' d="M0 0h' + qrcodesize + 'v' + qrcodesize + 'H0z"/>'

  const path =
    '<path ' + getColorAttrib(opts.color.dark, 'stroke') +
    ' d="' + qrToPath(data, size, opts.margin) + '"/>'

  const viewBox = 'viewBox="' + '0 0 ' + qrcodesize + ' ' + qrcodesize + '"'

  const width = !opts.width ? '' : 'width="' + opts.width + '" height="' + opts.width + '" '

  const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + '</svg>\n'

  if (typeof cb === 'function') {
    cb(null, svgTag)
  }

  return svgTag
}

},{"./utils":251}],251:[function(require,module,exports){
function hex2rgba (hex) {
  if (typeof hex === 'number') {
    hex = hex.toString()
  }

  if (typeof hex !== 'string') {
    throw new Error('Color should be defined as hex string')
  }

  let hexCode = hex.slice().replace('#', '').split('')
  if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) {
    throw new Error('Invalid hex color: ' + hex)
  }

  // Convert from short to long form (fff -> ffffff)
  if (hexCode.length === 3 || hexCode.length === 4) {
    hexCode = Array.prototype.concat.apply([], hexCode.map(function (c) {
      return [c, c]
    }))
  }

  // Add default alpha value
  if (hexCode.length === 6) hexCode.push('F', 'F')

  const hexValue = parseInt(hexCode.join(''), 16)

  return {
    r: (hexValue >> 24) & 255,
    g: (hexValue >> 16) & 255,
    b: (hexValue >> 8) & 255,
    a: hexValue & 255,
    hex: '#' + hexCode.slice(0, 6).join('')
  }
}

exports.getOptions = function getOptions (options) {
  if (!options) options = {}
  if (!options.color) options.color = {}

  const margin = typeof options.margin === 'undefined' ||
    options.margin === null ||
    options.margin < 0
    ? 4
    : options.margin

  const width = options.width && options.width >= 21 ? options.width : undefined
  const scale = options.scale || 4

  return {
    width: width,
    scale: width ? 4 : scale,
    margin: margin,
    color: {
      dark: hex2rgba(options.color.dark || '#000000ff'),
      light: hex2rgba(options.color.light || '#ffffffff')
    },
    type: options.type,
    rendererOpts: options.rendererOpts || {}
  }
}

exports.getScale = function getScale (qrSize, opts) {
  return opts.width && opts.width >= qrSize + opts.margin * 2
    ? opts.width / (qrSize + opts.margin * 2)
    : opts.scale
}

exports.getImageWidth = function getImageWidth (qrSize, opts) {
  const scale = exports.getScale(qrSize, opts)
  return Math.floor((qrSize + opts.margin * 2) * scale)
}

exports.qrToImageData = function qrToImageData (imgData, qr, opts) {
  const size = qr.modules.size
  const data = qr.modules.data
  const scale = exports.getScale(size, opts)
  const symbolSize = Math.floor((size + opts.margin * 2) * scale)
  const scaledMargin = opts.margin * scale
  const palette = [opts.color.light, opts.color.dark]

  for (let i = 0; i < symbolSize; i++) {
    for (let j = 0; j < symbolSize; j++) {
      let posDst = (i * symbolSize + j) * 4
      let pxColor = opts.color.light

      if (i >= scaledMargin && j >= scaledMargin &&
        i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
        const iSrc = Math.floor((i - scaledMargin) / scale)
        const jSrc = Math.floor((j - scaledMargin) / scale)
        pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0]
      }

      imgData[posDst++] = pxColor.r
      imgData[posDst++] = pxColor.g
      imgData[posDst++] = pxColor.b
      imgData[posDst] = pxColor.a
    }
  }
}

},{}],252:[function(require,module,exports){
/*!
 * @file ScrollMagic GSAP Animation Plugin.
 *
 * requires: GSAP ~1.14
 * Powered by the Greensock Animation Platform (GSAP): http://www.greensock.com/js
 * Greensock License info at http://www.greensock.com/licensing/
 */
/**
 * This plugin is meant to be used in conjunction with the Greensock Animation Plattform.
 * It offers an easy API to trigger Tweens or synchronize them to the scrollbar movement.
 *
 * Both the `lite` and the `max` versions of the GSAP library are supported.
 * The most basic requirement is `TweenLite`.
 *
 * To have access to this extension, please include `plugins/animation.gsap.js`.
 * @requires {@link http://greensock.com/gsap|GSAP ~1.14.x}
 * @mixin animation.GSAP
 */
var ScrollMagicPluginGsap = function(ScrollMagic, TweenMax, Timeline) {
    var Tween = TweenMax;
    var NAMESPACE = "animation.gsap";

    // (BUILD) - REMOVE IN MINIFY - START
    var console = window.console || {},
        err = Function.prototype.bind.call(
            console.error || console.log || function() {},
            console
        );
    if (!ScrollMagic) {
        err(
            "(" +
                NAMESPACE +
                ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs."
        );
    }
    if (!Tween) {
        err(
            "(" +
                NAMESPACE +
                ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs."
        );
    }
    // (BUILD) - REMOVE IN MINIFY - END

    /*
     * ----------------------------------------------------------------
     * Extensions for Scene
     * ----------------------------------------------------------------
     */
    /**
     * Every instance of ScrollMagic.Scene now accepts an additional option.  
     * See {@link ScrollMagic.Scene} for a complete list of the standard options.
     * @memberof! animation.GSAP#
     * @method new ScrollMagic.Scene(options)
     * @example
     * var scene = new ScrollMagic.Scene({tweenChanges: true});
     *
     * @param {object} [options] - Options for the Scene. The options can be updated at any time.
     * @param {boolean} [options.tweenChanges=false] - Tweens Animation to the progress target instead of setting it.  
                                                      Does not affect animations where duration is `0`.
     */
    /**
     * **Get** or **Set** the tweenChanges option value.
     * This only affects scenes with a duration. If `tweenChanges` is `true`, the progress update when scrolling will not be immediate, but instead the animation will smoothly animate to the target state.
     * For a better understanding, try enabling and disabling this option in the [Scene Manipulation Example](../examples/basic/scene_manipulation.html).
     * @memberof! animation.GSAP#
     * @method Scene.tweenChanges
     *
     * @example
     * // get the current tweenChanges option
     * var tweenChanges = scene.tweenChanges();
     *
     * // set new tweenChanges option
     * scene.tweenChanges(true);
     *
     * @fires {@link Scene.change}, when used as setter
     * @param {boolean} [newTweenChanges] - The new tweenChanges setting of the scene.
     * @returns {boolean} `get` -  Current tweenChanges option value.
     * @returns {Scene} `set` -  Parent object for chaining.
     */
    // add option (TODO: DOC (private for dev))
    ScrollMagic.Scene.addOption(
        "tweenChanges", // name
        false, // default
        function(val) {
            // validation callback
            return !!val;
        }
    );
    // extend scene
    ScrollMagic.Scene.extend(function() {
        var Scene = this,
            _tween;

        // (BUILD) - REMOVE IN MINIFY - START
        var log = function() {
            if (Scene._log) {
                // not available, when main source minified
                Array.prototype.splice.call(
                    arguments,
                    1,
                    0,
                    "(" + NAMESPACE + ")",
                    "->"
                );
                Scene._log.apply(this, arguments);
            }
        };
        // (BUILD) - REMOVE IN MINIFY - END

        // set listeners
        Scene.on("progress.plugin_gsap", function() {
            updateTweenProgress();
        });
        Scene.on("destroy.plugin_gsap", function(e) {
            Scene.removeTween(e.reset);
        });

        /**
         * Update the tween progress to current position.
         * @private
         */
        var updateTweenProgress = function() {
            if (_tween) {
                var progress = Scene.progress(),
                    state = Scene.state();
                if (_tween.repeat && _tween.repeat() === -1) {
                    // infinite loop, so not in relation to progress
                    if (state === "DURING" && _tween.paused()) {
                        _tween.play();
                    } else if (state !== "DURING" && !_tween.paused()) {
                        _tween.pause();
                    }
                } else if (progress != _tween.progress()) {
                    // do we even need to update the progress?
                    // no infinite loop - so should we just play or go to a specific point in time?
                    if (Scene.duration() === 0) {
                        // play the animation
                        if (progress > 0) {
                            // play from 0 to 1
                            _tween.play();
                        } else {
                            // play from 1 to 0
                            _tween.reverse();
                        }
                    } else {
                        // go to a specific point in time
                        if (Scene.tweenChanges() && _tween.tweenTo) {
                            // go smooth
                            _tween.tweenTo(progress * _tween.duration());
                        } else {
                            // just hard set it
                            _tween.progress(progress).pause();
                        }
                    }
                }
            }
        };

        /**
         * Add a tween to the scene.
         * If you want to add multiple tweens, add them into a GSAP Timeline object and supply it instead (see example below).
         *
         * If the scene has a duration, the tween's duration will be projected to the scroll distance of the scene, meaning its progress will be synced to scrollbar movement.
         * For a scene with a duration of `0`, the tween will be triggered when scrolling forward past the scene's trigger position and reversed, when scrolling back.
         * To gain better understanding, check out the [Simple Tweening example](../examples/basic/simple_tweening.html).
         *
         * Instead of supplying a tween this method can also be used as a shorthand for `TweenMax.to()` (see example below).
         * @memberof! animation.GSAP#
         *
         * @example
         * // add a single tween directly
         * scene.setTween(TweenMax.to("obj"), 1, {x: 100});
         *
         * // add a single tween via variable
         * var tween = TweenMax.to("obj"), 1, {x: 100};
         * scene.setTween(tween);
         *
         * // add multiple tweens, wrapped in a timeline.
         * var timeline = new TimelineMax();
         * var tween1 = TweenMax.from("obj1", 1, {x: 100});
         * var tween2 = TweenMax.to("obj2", 1, {y: 100});
         * timeline
         *      .add(tween1)
         *      .add(tween2);
         * scene.addTween(timeline);
         *
         * // short hand to add a TweenMax.to() tween
         * scene.setTween("obj3", 0.5, {y: 100});
         *
         * // short hand to add a TweenMax.to() tween for 1 second
         * // this is useful, when the scene has a duration and the tween duration isn't important anyway
         * scene.setTween("obj3", {y: 100});
         *
         * @param {(object|string)} TweenObject - A TweenMax, TweenLite, TimelineMax or TimelineLite object that should be animated in the scene. Can also be a Dom Element or Selector, when using direct tween definition (see examples).
         * @param {(number|object)} duration - A duration for the tween, or tween parameters. If an object containing parameters are supplied, a default duration of 1 will be used.
         * @param {object} params - The parameters for the tween
         * @returns {Scene} Parent object for chaining.
         */
        Scene.setTween = function(TweenObject, duration, params) {
            var newTween;
            if (arguments.length > 1) {
                if (arguments.length < 3) {
                    params = duration;
                    duration = 1;
                }
                TweenObject = Tween.to(TweenObject, duration, params);
            }
            try {
                // wrap Tween into a Timeline Object if available to include delay and repeats in the duration and standardize methods.
                if (Timeline) {
                    newTween = new Timeline({ smoothChildTiming: true }).add(
                        TweenObject
                    );
                } else {
                    newTween = TweenObject;
                }
                newTween.pause();
            } catch (e) {
                log(
                    1,
                    "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject"
                );
                return Scene;
            }
            if (_tween) {
                // kill old tween?
                Scene.removeTween();
            }
            _tween = newTween;

            // some properties need to be transferred it to the wrapper, otherwise they would get lost.
            if (TweenObject.repeat && TweenObject.repeat() === -1) {
                // TweenMax or TimelineMax Object?
                _tween.repeat(-1);
                _tween.yoyo(TweenObject.yoyo());
            }
            // (BUILD) - REMOVE IN MINIFY - START
            // Some tween validations and debugging helpers

            if (Scene.tweenChanges() && !_tween.tweenTo) {
                log(
                    2,
                    "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic."
                );
            }

            // check if there are position tweens defined for the trigger and warn about it :)
            if (
                _tween &&
                Scene.controller() &&
                Scene.triggerElement() &&
                Scene.loglevel() >= 2
            ) {
                // controller is needed to know scroll direction.
                var triggerTweens = Tween.getTweensOf(Scene.triggerElement()),
                    vertical = Scene.controller().info("vertical");
                triggerTweens.forEach(function(value, index) {
                    var tweenvars = value.vars.css || value.vars,
                        condition = vertical
                            ? tweenvars.top !== undefined ||
                              tweenvars.bottom !== undefined
                            : tweenvars.left !== undefined ||
                              tweenvars.right !== undefined;
                    if (condition) {
                        log(
                            2,
                            "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!"
                        );
                        return false;
                    }
                });
            }

            // warn about tween overwrites, when an element is tweened multiple times
            if (parseFloat(Tween.version) >= 1.14) {
                // onOverwrite only present since GSAP v1.14.0
                var list = _tween.getChildren
                        ? _tween.getChildren(true, true, false)
                        : [_tween], // get all nested tween objects
                    newCallback = function() {
                        log(
                            2,
                            "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another"
                        );
                    };
                for (var i = 0, thisTween, oldCallback; i < list.length; i++) {
                    /*jshint loopfunc: true */
                    thisTween = list[i];
                    if (oldCallback !== newCallback) {
                        // if tweens is added more than once
                        oldCallback = thisTween.vars.onOverwrite;
                        thisTween.vars.onOverwrite = function() {
                            if (oldCallback) {
                                oldCallback.apply(this, arguments);
                            }
                            newCallback.apply(this, arguments);
                        };
                    }
                }
            }
            // (BUILD) - REMOVE IN MINIFY - END
            log(3, "added tween");

            updateTweenProgress();
            return Scene;
        };

        /**
         * Remove the tween from the scene.
         * This will terminate the control of the Scene over the tween.
         *
         * Using the reset option you can decide if the tween should remain in the current state or be rewound to set the target elements back to the state they were in before the tween was added to the scene.
         * @memberof! animation.GSAP#
         *
         * @example
         * // remove the tween from the scene without resetting it
         * scene.removeTween();
         *
         * // remove the tween from the scene and reset it to initial position
         * scene.removeTween(true);
         *
         * @param {boolean} [reset=false] - If `true` the tween will be reset to its initial values.
         * @returns {Scene} Parent object for chaining.
         */
        Scene.removeTween = function(reset) {
            if (_tween) {
                if (reset) {
                    _tween.progress(0).pause();
                }
                _tween.kill();
                _tween = undefined;
                log(
                    3,
                    "removed tween (reset: " + (reset ? "true" : "false") + ")"
                );
            }
            return Scene;
        };
    });
};

module.exports = { ScrollMagicPluginGsap : ScrollMagicPluginGsap };

},{}],253:[function(require,module,exports){
/*!
 * ScrollMagic v2.0.8 (2020-08-14)
 * The javascript library for magical scroll interactions.
 * (c) 2020 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.8
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */
/**
 * @namespace ScrollMagic
 */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(factory);
	} else if (typeof exports === 'object') {
		// CommonJS
		module.exports = factory();
	} else {
		// Browser global
		root.ScrollMagic = factory();
	}
}(this, function () {
	"use strict";

	var ScrollMagic = function () {
		_util.log(2, '(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use \'new ScrollMagic.Controller()\' to create a new controller instance. Use \'new ScrollMagic.Scene()\' to instance a scene.');
	};

	ScrollMagic.version = "2.0.8";

	// TODO: temporary workaround for chrome's scroll jitter bug
	if (typeof (window) !== 'undefined') {
		window.addEventListener("mousewheel", void(0));
	}

	// global const
	var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";

	/**
	 * The main class that is needed once per scroll container.
	 *
	 * @class
	 *
	 * @example
	 * // basic initialization
	 * var controller = new ScrollMagic.Controller();
	 *
	 * // passing options
	 * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
	 *
	 * @param {object} [options] - An object containing one or more options for the controller.
	 * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
	 * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
	 * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
	 * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
											 ** `0` => silent
											 ** `1` => errors
											 ** `2` => errors, warnings
											 ** `3` => errors, warnings, debuginfo
	 * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
	 																										 This interval polls these parameters to fire the necessary events.  
	 																										 If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
	 *
	 */
	ScrollMagic.Controller = function (options) {
		/*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */
		var
			NAMESPACE = 'ScrollMagic.Controller',
			SCROLL_DIRECTION_FORWARD = 'FORWARD',
			SCROLL_DIRECTION_REVERSE = 'REVERSE',
			SCROLL_DIRECTION_PAUSED = 'PAUSED',
			DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;

		/*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */
		var
			Controller = this,
			_options = _util.extend({}, DEFAULT_OPTIONS, options),
			_sceneObjects = [],
			_updateScenesOnNextCycle = false, // can be boolean (true => all scenes) or an array of scenes to be updated
			_scrollPos = 0,
			_scrollDirection = SCROLL_DIRECTION_PAUSED,
			_isDocument = true,
			_viewPortSize = 0,
			_enabled = true,
			_updateTimeout,
			_refreshTimeout;

		/*
		 * ----------------------------------------------------------------
		 * private functions
		 * ----------------------------------------------------------------
		 */

		/**
		 * Internal constructor function of the ScrollMagic Controller
		 * @private
		 */
		var construct = function () {
			for (var key in _options) {
				if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
					log(2, "WARNING: Unknown option \"" + key + "\"");
					delete _options[key];
				}
			}
			_options.container = _util.get.elements(_options.container)[0];
			// check ScrollContainer
			if (!_options.container) {
				log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
				throw NAMESPACE + " init failed."; // cancel
			}
			_isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container);
			// normalize to window
			if (_isDocument) {
				_options.container = window;
			}
			// update container size immediately
			_viewPortSize = getViewportSize();
			// set event handlers
			_options.container.addEventListener("resize", onChange);
			_options.container.addEventListener("scroll", onChange);

			var ri = parseInt(_options.refreshInterval, 10);
			_options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
			scheduleRefresh();

			log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
		};

		/**
		 * Schedule the next execution of the refresh function
		 * @private
		 */
		var scheduleRefresh = function () {
			if (_options.refreshInterval > 0) {
				_refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
			}
		};

		/**
		 * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
		 * @private
		 */
		var getScrollPos = function () {
			return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
		};

		/**
		 * Returns the current viewport Size (width vor horizontal, height for vertical)
		 * @private
		 */
		var getViewportSize = function () {
			return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
		};

		/**
		 * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
		 * Make available publicly for pinned mousewheel workaround.
		 * @private
		 */
		var setScrollPos = this._setScrollPos = function (pos) {
			if (_options.vertical) {
				if (_isDocument) {
					window.scrollTo(_util.get.scrollLeft(), pos);
				} else {
					_options.container.scrollTop = pos;
				}
			} else {
				if (_isDocument) {
					window.scrollTo(pos, _util.get.scrollTop());
				} else {
					_options.container.scrollLeft = pos;
				}
			}
		};

		/**
		 * Handle updates in cycles instead of on scroll (performance)
		 * @private
		 */
		var updateScenes = function () {
			if (_enabled && _updateScenesOnNextCycle) {
				// determine scenes to update
				var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0);
				// reset scenes
				_updateScenesOnNextCycle = false;
				var oldScrollPos = _scrollPos;
				// update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)
				_scrollPos = Controller.scrollPos();
				var deltaScroll = _scrollPos - oldScrollPos;
				if (deltaScroll !== 0) { // scroll position changed?
					_scrollDirection = (deltaScroll > 0) ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
				}
				// reverse order of scenes if scrolling reverse
				if (_scrollDirection === SCROLL_DIRECTION_REVERSE) {
					scenesToUpdate.reverse();
				}
				// update scenes
				scenesToUpdate.forEach(function (scene, index) {
					log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
					scene.update(true);
				});
				if (scenesToUpdate.length === 0 && _options.loglevel >= 3) {
					log(3, "updating 0 Scenes (nothing added to controller)");
				}
			}
		};

		/**
		 * Initializes rAF callback
		 * @private
		 */
		var debounceUpdate = function () {
			_updateTimeout = _util.rAF(updateScenes);
		};

		/**
		 * Handles Container changes
		 * @private
		 */
		var onChange = function (e) {
			log(3, "event fired causing an update:", e.type);
			if (e.type == "resize") {
				// resize
				_viewPortSize = getViewportSize();
				_scrollDirection = SCROLL_DIRECTION_PAUSED;
			}
			// schedule update
			if (_updateScenesOnNextCycle !== true) {
				_updateScenesOnNextCycle = true;
				debounceUpdate();
			}
		};

		var refresh = function () {
			if (!_isDocument) {
				// simulate resize event. Only works for viewport relevant param (performance)
				if (_viewPortSize != getViewportSize()) {
					var resizeEvent;
					try {
						resizeEvent = new Event('resize', {
							bubbles: false,
							cancelable: false
						});
					} catch (e) { // stupid IE
						resizeEvent = document.createEvent("Event");
						resizeEvent.initEvent("resize", false, false);
					}
					_options.container.dispatchEvent(resizeEvent);
				}
			}
			_sceneObjects.forEach(function (scene, index) { // refresh all scenes
				scene.refresh();
			});
			scheduleRefresh();
		};

		/**
		 * Send a debug message to the console.
		 * provided publicly with _log for plugins
		 * @private
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */
		var log = this._log = function (loglevel, output) {
			if (_options.loglevel >= loglevel) {
				Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
				_util.log.apply(window, arguments);
			}
		};
		// for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins
		this._options = _options;

		/**
		 * Sort scenes in ascending order of their start offset.
		 * @private
		 *
		 * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
		 * @return {array} The sorted array of Scenes.
		 */
		var sortScenes = function (ScenesArray) {
			if (ScenesArray.length <= 1) {
				return ScenesArray;
			} else {
				var scenes = ScenesArray.slice(0);
				scenes.sort(function (a, b) {
					return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
				});
				return scenes;
			}
		};

		/**
		 * ----------------------------------------------------------------
		 * public functions
		 * ----------------------------------------------------------------
		 */

		/**
		 * Add one ore more scene(s) to the controller.  
		 * This is the equivalent to `Scene.addTo(controller)`.
		 * @public
		 * @example
		 * // with a previously defined scene
		 * controller.addScene(scene);
		 *
		 * // with a newly created scene.
		 * controller.addScene(new ScrollMagic.Scene({duration : 0}));
		 *
		 * // adding multiple scenes
		 * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
		 *
		 * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
		 * @return {Controller} Parent object for chaining.
		 */
		this.addScene = function (newScene) {
			if (_util.type.Array(newScene)) {
				newScene.forEach(function (scene, index) {
					Controller.addScene(scene);
				});
			} else if (newScene instanceof ScrollMagic.Scene) {
				if (newScene.controller() !== Controller) {
					newScene.addTo(Controller);
				} else if (_sceneObjects.indexOf(newScene) < 0) {
					// new scene
					_sceneObjects.push(newScene); // add to array
					_sceneObjects = sortScenes(_sceneObjects); // sort
					newScene.on("shift.controller_sort", function () { // resort whenever scene moves
						_sceneObjects = sortScenes(_sceneObjects);
					});
					// insert Global defaults.
					for (var key in _options.globalSceneOptions) {
						if (newScene[key]) {
							newScene[key].call(newScene, _options.globalSceneOptions[key]);
						}
					}
					log(3, "adding Scene (now " + _sceneObjects.length + " total)");
				}
			} else {
				log(1, "ERROR: invalid argument supplied for '.addScene()'");
			}
			return Controller;
		};

		/**
		 * Remove one ore more scene(s) from the controller.  
		 * This is the equivalent to `Scene.remove()`.
		 * @public
		 * @example
		 * // remove a scene from the controller
		 * controller.removeScene(scene);
		 *
		 * // remove multiple scenes from the controller
		 * controller.removeScene([scene, scene2, scene3]);
		 *
		 * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
		 * @returns {Controller} Parent object for chaining.
		 */
		this.removeScene = function (Scene) {
			if (_util.type.Array(Scene)) {
				Scene.forEach(function (scene, index) {
					Controller.removeScene(scene);
				});
			} else {
				var index = _sceneObjects.indexOf(Scene);
				if (index > -1) {
					Scene.off("shift.controller_sort");
					_sceneObjects.splice(index, 1);
					log(3, "removing Scene (now " + _sceneObjects.length + " left)");
					Scene.remove();
				}
			}
			return Controller;
		};

		/**
	 * Update one ore more scene(s) according to the scroll position of the container.  
	 * This is the equivalent to `Scene.update()`.  
	 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
	 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
	 * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
	 * @public
	 * @example
	 * // update a specific scene on next cycle
 	 * controller.updateScene(scene);
 	 *
	 * // update a specific scene immediately
	 * controller.updateScene(scene, true);
 	 *
	 * // update multiple scenes scene on next cycle
	 * controller.updateScene([scene1, scene2, scene3]);
	 *
	 * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
	 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
	 										  This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
	 * @return {Controller} Parent object for chaining.
	 */
		this.updateScene = function (Scene, immediately) {
			if (_util.type.Array(Scene)) {
				Scene.forEach(function (scene, index) {
					Controller.updateScene(scene, immediately);
				});
			} else {
				if (immediately) {
					Scene.update(true);
				} else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) { // if _updateScenesOnNextCycle is true, all connected scenes are already scheduled for update
					// prep array for next update cycle
					_updateScenesOnNextCycle = _updateScenesOnNextCycle || [];
					if (_updateScenesOnNextCycle.indexOf(Scene) == -1) {
						_updateScenesOnNextCycle.push(Scene);
					}
					_updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort
					debounceUpdate();
				}
			}
			return Controller;
		};

		/**
		 * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
		 * See `Controller.updateScene()` for more information about what this means.  
		 * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
		 * The only application for this method is when ScrollMagic fails to detect these events.  
		 * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
		 * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
		 * @public
		 * @example
		 * // update the controller on next cycle (saves performance due to elimination of redundant updates)
		 * controller.update();
		 *
		 * // update the controller immediately
		 * controller.update(true);
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
		 * @return {Controller} Parent object for chaining.
		 */
		this.update = function (immediately) {
			onChange({
				type: "resize"
			}); // will update size and set _updateScenesOnNextCycle to true
			if (immediately) {
				updateScenes();
			}
			return Controller;
		};

		/**
		 * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
		 * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
		 * @public
		 *
		 * @since 1.1.0
		 * @example
		 * // scroll to an offset of 100
		 * controller.scrollTo(100);
		 *
		 * // scroll to a DOM element
		 * controller.scrollTo("#anchor");
		 *
		 * // scroll to the beginning of a scene
		 * var scene = new ScrollMagic.Scene({offset: 200});
		 * controller.scrollTo(scene);
		 *
		 * // define a new scroll position modification function (jQuery animate instead of jump)
		 * controller.scrollTo(function (newScrollPos) {
		 *	$("html, body").animate({scrollTop: newScrollPos});
		 * });
		 * controller.scrollTo(100); // call as usual, but the new function will be used instead
		 *
		 * // define a new scroll function with an additional parameter
		 * controller.scrollTo(function (newScrollPos, message) {
		 *  console.log(message);
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter to the defined custom function
		 * controller.scrollTo(100, "my message");
		 *
		 * // define a new scroll function with an additional parameter containing multiple variables
		 * controller.scrollTo(function (newScrollPos, options) {
		 *  someGlobalVar = options.a + options.b;
		 *	$(this).animate({scrollTop: newScrollPos});
		 * });
		 * // call as usual, but supply an extra parameter containing multiple options
		 * controller.scrollTo(100, {a: 1, b: 2});
		 *
		 * // define a new scroll function with a callback supplied as an additional parameter
		 * controller.scrollTo(function (newScrollPos, callback) {
		 *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
		 * });
		 * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
		 * controller.scrollTo(100, function() {
		 *	console.log("scroll has finished.");
		 * });
		 *
		 * @param {mixed} scrollTarget - The supplied argument can be one of these types:
		 * 1. `number` -> The container will scroll to this new scroll offset.
		 * 2. `string` or `object` -> Can be a selector or a DOM object.  
		 *  The container will scroll to the position of this element.
		 * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
		 * 4. `function` -> This function will be used for future scroll position modifications.  
		 *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
		 *  It may also optionally receive an optional additional parameter (see below)  
		 *  _**NOTE:**  
		 *  All other options will still work as expected, using the new function to scroll._
		 * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
		 * @returns {Controller} Parent object for chaining.
		 */
		this.scrollTo = function (scrollTarget, additionalParameter) {
			if (_util.type.Number(scrollTarget)) { // excecute
				setScrollPos.call(_options.container, scrollTarget, additionalParameter);
			} else if (scrollTarget instanceof ScrollMagic.Scene) { // scroll to scene
				if (scrollTarget.controller() === Controller) { // check if the controller is associated with this scene
					Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
				} else {
					log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
				}
			} else if (_util.type.Function(scrollTarget)) { // assign new scroll function
				setScrollPos = scrollTarget;
			} else { // scroll to element
				var elem = _util.get.elements(scrollTarget)[0];
				if (elem) {
					// if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
					while (elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
						elem = elem.parentNode;
					}

					var
						param = _options.vertical ? "top" : "left", // which param is of interest ?
						containerOffset = _util.get.offset(_options.container), // container position is needed because element offset is returned in relation to document, not in relation to container.
						elementOffset = _util.get.offset(elem);

					if (!_isDocument) { // container is not the document root, so substract scroll Position to get correct trigger element position relative to scrollcontent
						containerOffset[param] -= Controller.scrollPos();
					}

					Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
				} else {
					log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
				}
			}
			return Controller;
		};

		/**
		 * **Get** the current scrollPosition or **Set** a new method to calculate it.  
		 * -> **GET**:
		 * When used as a getter this function will return the current scroll position.  
		 * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
		 * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
		 *
		 * -> **SET**:
		 * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
		 * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
		 * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
		 * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
		 * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
		 *
		 * To change the current scroll position please use `Controller.scrollTo()`.
		 * @public
		 *
		 * @example
		 * // get the current scroll Position
		 * var scrollPos = controller.scrollPos();
		 *
		 * // set a new scroll position calculation method
		 * controller.scrollPos(function () {
		 *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
		 * });
		 *
		 * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
		 * @returns {(number|Controller)} Current scroll position or parent object for chaining.
		 */
		this.scrollPos = function (scrollPosMethod) {
			if (!arguments.length) { // get
				return getScrollPos.call(Controller);
			} else { // set
				if (_util.type.Function(scrollPosMethod)) {
					getScrollPos = scrollPosMethod;
				} else {
					log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
				}
			}
			return Controller;
		};

		/**
		 * **Get** all infos or one in particular about the controller.
		 * @public
		 * @example
		 * // returns the current scroll position (number)
		 * var scrollPos = controller.info("scrollPos");
		 *
		 * // returns all infos as an object
		 * var infos = controller.info();
		 *
		 * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
		 							 Valid options are:
		 							 ** `"size"` => the current viewport size of the container
		 							 ** `"vertical"` => true if vertical scrolling, otherwise false
		 							 ** `"scrollPos"` => the current scroll position
		 							 ** `"scrollDirection"` => the last known direction of the scroll
		 							 ** `"container"` => the container element
		 							 ** `"isDocument"` => true if container element is the document.
		 * @returns {(mixed|object)} The requested info(s).
		 */
		this.info = function (about) {
			var values = {
				size: _viewPortSize, // contains height or width (in regard to orientation);
				vertical: _options.vertical,
				scrollPos: _scrollPos,
				scrollDirection: _scrollDirection,
				container: _options.container,
				isDocument: _isDocument
			};
			if (!arguments.length) { // get all as an object
				return values;
			} else if (values[about] !== undefined) {
				return values[about];
			} else {
				log(1, "ERROR: option \"" + about + "\" is not available");
				return;
			}
		};

		/**
		 * **Get** or **Set** the current loglevel option value.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var loglevel = controller.loglevel();
		 *
		 * // set a new value
		 * controller.loglevel(3);
		 *
		 * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
		 * @returns {(number|Controller)} Current loglevel or parent object for chaining.
		 */
		this.loglevel = function (newLoglevel) {
			if (!arguments.length) { // get
				return _options.loglevel;
			} else if (_options.loglevel != newLoglevel) { // set
				_options.loglevel = newLoglevel;
			}
			return Controller;
		};

		/**
		 * **Get** or **Set** the current enabled state of the controller.  
		 * This can be used to disable all Scenes connected to the controller without destroying or removing them.
		 * @public
		 *
		 * @example
		 * // get the current value
		 * var enabled = controller.enabled();
		 *
		 * // disable the controller
		 * controller.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
		 * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
		 */
		this.enabled = function (newState) {
			if (!arguments.length) { // get
				return _enabled;
			} else if (_enabled != newState) { // set
				_enabled = !!newState;
				Controller.updateScene(_sceneObjects, true);
			}
			return Controller;
		};

		/**
		 * Destroy the Controller, all Scenes and everything.
		 * @public
		 *
		 * @example
		 * // without resetting the scenes
		 * controller = controller.destroy();
		 *
		 * // with scene reset
		 * controller = controller.destroy(true);
		 *
		 * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
		 * @returns {null} Null to unset handler variables.
		 */
		this.destroy = function (resetScenes) {
			window.clearTimeout(_refreshTimeout);
			var i = _sceneObjects.length;
			while (i--) {
				_sceneObjects[i].destroy(resetScenes);
			}
			_options.container.removeEventListener("resize", onChange);
			_options.container.removeEventListener("scroll", onChange);
			_util.cAF(_updateTimeout);
			log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
			return null;
		};

		// INIT
		construct();
		return Controller;
	};

	// store pagewide controller options
	var CONTROLLER_OPTIONS = {
		defaults: {
			container: window,
			vertical: true,
			globalSceneOptions: {},
			loglevel: 2,
			refreshInterval: 100
		}
	};
	/*
	 * method used to add an option to ScrollMagic Scenes.
	 */
	ScrollMagic.Controller.addOption = function (name, defaultValue) {
		CONTROLLER_OPTIONS.defaults[name] = defaultValue;
	};
	// instance extension function for plugins
	ScrollMagic.Controller.extend = function (extension) {
		var oldClass = this;
		ScrollMagic.Controller = function () {
			oldClass.apply(this, arguments);
			this.$super = _util.extend({}, this); // copy parent state
			return extension.apply(this, arguments) || this;
		};
		_util.extend(ScrollMagic.Controller, oldClass); // copy properties
		ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype
		ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
	};


	/**
	 * A Scene defines where the controller should react and how.
	 *
	 * @class
	 *
	 * @example
	 * // create a standard scene and add it to a controller
	 * new ScrollMagic.Scene()
	 *		.addTo(controller);
	 *
	 * // create a scene with custom options and assign a handler to it.
	 * var scene = new ScrollMagic.Scene({
	 * 		duration: 100,
	 *		offset: 200,
	 *		triggerHook: "onEnter",
	 *		reverse: false
	 * });
	 *
	 * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
	 							   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
	 							   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
	 * @param {(number|string|function)} [options.duration=0] - The duration of the scene. 
	 					Please see `Scene.duration()` for details.
	 * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
	 * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
	 * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
	 															  Can also be defined using a string:
	 															  ** `"onEnter"` => `1`
	 															  ** `"onCenter"` => `0.5`
	 															  ** `"onLeave"` => `0`
	 * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
	 * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
	 										  ** `0` => silent
	 										  ** `1` => errors
	 										  ** `2` => errors, warnings
	 										  ** `3` => errors, warnings, debuginfo
	 * 
	 */
	ScrollMagic.Scene = function (options) {

		/*
		 * ----------------------------------------------------------------
		 * settings
		 * ----------------------------------------------------------------
		 */

		var
			NAMESPACE = 'ScrollMagic.Scene',
			SCENE_STATE_BEFORE = 'BEFORE',
			SCENE_STATE_DURING = 'DURING',
			SCENE_STATE_AFTER = 'AFTER',
			DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;

		/*
		 * ----------------------------------------------------------------
		 * private vars
		 * ----------------------------------------------------------------
		 */

		var
			Scene = this,
			_options = _util.extend({}, DEFAULT_OPTIONS, options),
			_state = SCENE_STATE_BEFORE,
			_progress = 0,
			_scrollOffset = {
				start: 0,
				end: 0
			}, // reflects the controllers's scroll position for the start and end of the scene respectively
			_triggerPos = 0,
			_enabled = true,
			_durationUpdateMethod,
			_controller;

		/**
		 * Internal constructor function of the ScrollMagic Scene
		 * @private
		 */
		var construct = function () {
			for (var key in _options) { // check supplied options
				if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
					log(2, "WARNING: Unknown option \"" + key + "\"");
					delete _options[key];
				}
			}
			// add getters/setters for all possible options
			for (var optionName in DEFAULT_OPTIONS) {
				addSceneOption(optionName);
			}
			// validate all options
			validateOption();
		};

		/*
		 * ----------------------------------------------------------------
		 * Event Management
		 * ----------------------------------------------------------------
		 */

		var _listeners = {};
		/**
		 * Scene start event.  
		 * Fires whenever the scroll position its the starting point of the scene.  
		 * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#start
		 *
		 * @example
		 * scene.on("start", function (event) {
		 * 	console.log("Hit start point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */
		/**
		 * Scene end event.  
		 * Fires whenever the scroll position its the ending point of the scene.  
		 * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#end
		 *
		 * @example
		 * scene.on("end", function (event) {
		 * 	console.log("Hit end point of scene.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */
		/**
		 * Scene enter event.  
		 * Fires whenever the scene enters the "DURING" state.  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#enter
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 * 	console.log("Scene entered.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene - always `"DURING"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */
		/**
		 * Scene leave event.  
		 * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
		 * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#leave
		 *
		 * @example
		 * scene.on("leave", function (event) {
		 * 	console.log("Scene left.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */
		/**
		 * Scene update event.  
		 * Fires whenever the scene is updated (but not necessarily changes the progress).
		 *
		 * @event ScrollMagic.Scene#update
		 *
		 * @example
		 * scene.on("update", function (event) {
		 * 	console.log("Scene updated.");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
		 * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
		 * @property {number} event.scrollPos - The current scroll position of the container
		 */
		/**
		 * Scene progress event.  
		 * Fires whenever the progress of the scene changes.
		 *
		 * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
		 *
		 * @event ScrollMagic.Scene#progress
		 *
		 * @example
		 * scene.on("progress", function (event) {
		 * 	console.log("Scene progress changed to " + event.progress);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {number} event.progress - Reflects the current progress of the scene
		 * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
		 * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
		 */
		/**
		 * Scene change event.  
		 * Fires whenvever a property of the scene is changed.
		 *
		 * @event ScrollMagic.Scene#change
		 *
		 * @example
		 * scene.on("change", function (event) {
		 * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.what - Indicates what value has been changed
		 * @property {mixed} event.newval - The new value of the changed property
		 */
		/**
		 * Scene shift event.  
		 * Fires whenvever the start or end **scroll offset** of the scene change.
		 * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
		 * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
		 * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
		 *
		 * @event ScrollMagic.Scene#shift
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("shift", function (event) {
		 * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {string} event.reason - Indicates why the scene has shifted
		 */
		/**
		 * Scene destroy event.  
		 * Fires whenvever the scene is destroyed.
		 * This can be used to tidy up custom behaviour used in events.
		 *
		 * @event ScrollMagic.Scene#destroy
		 * @since 1.1.0
		 *
		 * @example
		 * scene.on("enter", function (event) {
		 *        // add custom action
		 *        $("#my-elem").left("200");
		 *      })
		 *      .on("destroy", function (event) {
		 *        // reset my element to start position
		 *        if (event.reset) {
		 *          $("#my-elem").left("0");
		 *        }
		 *      });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
		 */
		/**
		 * Scene add event.  
		 * Fires when the scene is added to a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#add
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("add", function (event) {
		 * 	console.log('Scene was added to a new controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 * @property {boolean} event.controller - The controller object the scene was added to.
		 */
		/**
		 * Scene remove event.  
		 * Fires when the scene is removed from a controller.
		 * This is mostly used by plugins to know that change might be due.
		 *
		 * @event ScrollMagic.Scene#remove
		 * @since 2.0.0
		 *
		 * @example
		 * scene.on("remove", function (event) {
		 * 	console.log('Scene was removed from its controller.');
		 * });
		 *
		 * @property {object} event - The event Object passed to each callback
		 * @property {string} event.type - The name of the event
		 * @property {Scene} event.target - The Scene object that triggered this event
		 */

		/**
		 * Add one ore more event listener.  
		 * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
		 * @method ScrollMagic.Scene#on
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update progress start end enter leave", callback);
		 *
		 * @param {string} names - The name or names of the event the callback should be attached to.
		 * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.on = function (names, callback) {
			if (_util.type.Function(callback)) {
				names = names.trim().split(' ');
				names.forEach(function (fullname) {
					var
						nameparts = fullname.split('.'),
						eventname = nameparts[0],
						namespace = nameparts[1];
					if (eventname != "*") { // disallow wildcards
						if (!_listeners[eventname]) {
							_listeners[eventname] = [];
						}
						_listeners[eventname].push({
							namespace: namespace || '',
							callback: callback
						});
					}
				});
			} else {
				log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
			}
			return Scene;
		};

		/**
		 * Remove one or more event listener.
		 * @method ScrollMagic.Scene#off
		 *
		 * @example
		 * function callback (event) {
		 * 		console.log("Event fired! (" + event.type + ")");
		 * }
		 * // add listeners
		 * scene.on("change update", callback);
		 * // remove listeners
		 * scene.off("change update", callback);
		 *
		 * @param {string} names - The name or names of the event that should be removed.
		 * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.off = function (names, callback) {
			if (!names) {
				log(1, "ERROR: Invalid event name supplied.");
				return Scene;
			}
			names = names.trim().split(' ');
			names.forEach(function (fullname, key) {
				var
					nameparts = fullname.split('.'),
					eventname = nameparts[0],
					namespace = nameparts[1] || '',
					removeList = eventname === '*' ? Object.keys(_listeners) : [eventname];
				removeList.forEach(function (remove) {
					var
						list = _listeners[remove] || [],
						i = list.length;
					while (i--) {
						var listener = list[i];
						if (listener && (namespace === listener.namespace || namespace === '*') && (!callback || callback == listener.callback)) {
							list.splice(i, 1);
						}
					}
					if (!list.length) {
						delete _listeners[remove];
					}
				});
			});
			return Scene;
		};

		/**
		 * Trigger an event.
		 * @method ScrollMagic.Scene#trigger
		 *
		 * @example
		 * this.trigger("change");
		 *
		 * @param {string} name - The name of the event that should be triggered.
		 * @param {object} [vars] - An object containing info that should be passed to the callback.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.trigger = function (name, vars) {
			if (name) {
				var
					nameparts = name.trim().split('.'),
					eventname = nameparts[0],
					namespace = nameparts[1],
					listeners = _listeners[eventname];
				log(3, 'event fired:', eventname, vars ? "->" : '', vars || '');
				if (listeners) {
					listeners.forEach(function (listener, key) {
						if (!namespace || namespace === listener.namespace) {
							listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
						}
					});
				}
			} else {
				log(1, "ERROR: Invalid event name supplied.");
			}
			return Scene;
		};

		// set event listeners
		Scene
			.on("change.internal", function (e) {
				if (e.what !== "loglevel" && e.what !== "tweenChanges") { // no need for a scene update scene with these options...
					if (e.what === "triggerElement") {
						updateTriggerElementPosition();
					} else if (e.what === "reverse") { // the only property left that may have an impact on the current scene state. Everything else is handled by the shift event.
						Scene.update();
					}
				}
			})
			.on("shift.internal", function (e) {
				updateScrollOffset();
				Scene.update(); // update scene to reflect new position
			});

		/**
		 * Send a debug message to the console.
		 * @private
		 * but provided publicly with _log for plugins
		 *
		 * @param {number} loglevel - The loglevel required to initiate output for the message.
		 * @param {...mixed} output - One or more variables that should be passed to the console.
		 */
		var log = this._log = function (loglevel, output) {
			if (_options.loglevel >= loglevel) {
				Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");
				_util.log.apply(window, arguments);
			}
		};

		/**
		 * Add the scene to a controller.  
		 * This is the equivalent to `Controller.addScene(scene)`.
		 * @method ScrollMagic.Scene#addTo
		 *
		 * @example
		 * // add a scene to a ScrollMagic Controller
		 * scene.addTo(controller);
		 *
		 * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.addTo = function (controller) {
			if (!(controller instanceof ScrollMagic.Controller)) {
				log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
			} else if (_controller != controller) {
				// new controller
				if (_controller) { // was associated to a different controller before, so remove it...
					_controller.removeScene(Scene);
				}
				_controller = controller;
				validateOption();
				updateDuration(true);
				updateTriggerElementPosition(true);
				updateScrollOffset();
				_controller.info("container").addEventListener('resize', onContainerResize);
				controller.addScene(Scene);
				Scene.trigger("add", {
					controller: _controller
				});
				log(3, "added " + NAMESPACE + " to controller");
				Scene.update();
			}
			return Scene;
		};

		/**
		 * **Get** or **Set** the current enabled state of the scene.  
		 * This can be used to disable this scene without removing or destroying it.
		 * @method ScrollMagic.Scene#enabled
		 *
		 * @example
		 * // get the current value
		 * var enabled = scene.enabled();
		 *
		 * // disable the scene
		 * scene.enabled(false);
		 *
		 * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
		 * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
		 */
		this.enabled = function (newState) {
			if (!arguments.length) { // get
				return _enabled;
			} else if (_enabled != newState) { // set
				_enabled = !!newState;
				Scene.update(true);
			}
			return Scene;
		};

		/**
		 * Remove the scene from the controller.  
		 * This is the equivalent to `Controller.removeScene(scene)`.
		 * The scene will not be updated anymore until you readd it to a controller.
		 * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
		 * @method ScrollMagic.Scene#remove
		 * @example
		 * // remove the scene from its controller
		 * scene.remove();
		 *
		 * @returns {Scene} Parent object for chaining.
		 */
		this.remove = function () {
			if (_controller) {
				_controller.info("container").removeEventListener('resize', onContainerResize);
				var tmpParent = _controller;
				_controller = undefined;
				tmpParent.removeScene(Scene);
				Scene.trigger("remove");
				log(3, "removed " + NAMESPACE + " from controller");
			}
			return Scene;
		};

		/**
		 * Destroy the scene and everything.
		 * @method ScrollMagic.Scene#destroy
		 * @example
		 * // destroy the scene without resetting the pin and tween to their initial positions
		 * scene = scene.destroy();
		 *
		 * // destroy the scene and reset the pin and tween
		 * scene = scene.destroy(true);
		 *
		 * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
		 * @returns {null} Null to unset handler variables.
		 */
		this.destroy = function (reset) {
			Scene.trigger("destroy", {
				reset: reset
			});
			Scene.remove();
			Scene.off("*.*");
			log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
			return null;
		};


		/**
		 * Updates the Scene to reflect the current state.  
		 * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
		 * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
		 * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
		 * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
		 * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
		 * @method ScrollMagic.Scene#update
		 * @example
		 * // update the scene on next tick
		 * scene.update();
		 *
		 * // update the scene immediately
		 * scene.update(true);
		 *
		 * @fires Scene.update
		 *
		 * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
		 * @returns {Scene} Parent object for chaining.
		 */
		this.update = function (immediately) {
			if (_controller) {
				if (immediately) {
					if (_controller.enabled() && _enabled) {
						var
							scrollPos = _controller.info("scrollPos"),
							newProgress;

						if (_options.duration > 0) {
							newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
						} else {
							newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
						}

						Scene.trigger("update", {
							startPos: _scrollOffset.start,
							endPos: _scrollOffset.end,
							scrollPos: scrollPos
						});

						Scene.progress(newProgress);
					} else if (_pin && _state === SCENE_STATE_DURING) {
						updatePinState(true); // unpin in position
					}
				} else {
					_controller.updateScene(Scene, false);
				}
			}
			return Scene;
		};

		/**
		 * Updates dynamic scene variables like the trigger element position or the duration.
		 * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
		 * 
		 * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
		 * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
		 *
		 * @method ScrollMagic.Scene#refresh
		 * @since 1.1.0
		 * @example
		 * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
		 * 
		 * // change the position of the trigger
		 * $("#trigger").css("top", 500);
		 * // immediately let the scene know of this change
		 * scene.refresh();
		 *
		 * @fires {@link Scene.shift}, if the trigger element position or the duration changed
		 * @fires {@link Scene.change}, if the duration changed
		 *
		 * @returns {Scene} Parent object for chaining.
		 */
		this.refresh = function () {
			updateDuration();
			updateTriggerElementPosition();
			// update trigger element position
			return Scene;
		};

		/**
		 * **Get** or **Set** the scene's progress.  
		 * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
		 * The order in which the events are fired depends on the duration of the scene:
		 *  1. Scenes with `duration == 0`:  
		 *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
		 *  When the trigger position of the scene is passed the events are always fired in this order:  
		 *  `enter`, `start`, `progress` when scrolling forward  
		 *  and  
		 *  `progress`, `start`, `leave` when scrolling in reverse
		 *  2. Scenes with `duration > 0`:  
		 *  Scenes with a set duration have a defined start and end point.  
		 *  When scrolling past the start position of the scene it will fire these events in this order:  
		 *  `enter`, `start`, `progress`  
		 *  When continuing to scroll and passing the end point it will fire these events:  
		 *  `progress`, `end`, `leave`  
		 *  When reversing through the end point these events are fired:  
		 *  `enter`, `end`, `progress`  
		 *  And when continuing to scroll past the start position in reverse it will fire:  
		 *  `progress`, `start`, `leave`  
		 *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
		 * 
		 * In short:  
		 * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
		 * `start` and `end` will always trigger at their respective position.
		 * 
		 * Please review the event descriptions for details on the events and the event object that is passed to the callback.
		 * 
		 * @method ScrollMagic.Scene#progress
		 * @example
		 * // get the current scene progress
		 * var progress = scene.progress();
		 *
		 * // set new scene progress
		 * scene.progress(0.3);
		 *
		 * @fires {@link Scene.enter}, when used as setter
		 * @fires {@link Scene.start}, when used as setter
		 * @fires {@link Scene.progress}, when used as setter
		 * @fires {@link Scene.end}, when used as setter
		 * @fires {@link Scene.leave}, when used as setter
		 *
		 * @param {number} [progress] - The new progress value of the scene `[0-1]`.
		 * @returns {number} `get` -  Current scene progress.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */
		this.progress = function (progress) {
			if (!arguments.length) { // get
				return _progress;
			} else { // set
				var
					doUpdate = false,
					oldState = _state,
					scrollDirection = _controller ? _controller.info("scrollDirection") : 'PAUSED',
					reverseOrForward = _options.reverse || progress >= _progress;
				if (_options.duration === 0) {
					// zero duration scenes
					doUpdate = _progress != progress;
					_progress = progress < 1 && reverseOrForward ? 0 : 1;
					_state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
				} else {
					// scenes with start and end
					if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
						// go back to initial state
						_progress = 0;
						_state = SCENE_STATE_BEFORE;
						doUpdate = true;
					} else if (progress >= 0 && progress < 1 && reverseOrForward) {
						_progress = progress;
						_state = SCENE_STATE_DURING;
						doUpdate = true;
					} else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
						_progress = 1;
						_state = SCENE_STATE_AFTER;
						doUpdate = true;
					} else if (_state === SCENE_STATE_DURING && !reverseOrForward) {
						updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
					}
				}
				if (doUpdate) {
					// fire events
					var
						eventVars = {
							progress: _progress,
							state: _state,
							scrollDirection: scrollDirection
						},
						stateChanged = _state != oldState;

					var trigger = function (eventName) { // tmp helper to simplify code
						Scene.trigger(eventName, eventVars);
					};

					if (stateChanged) { // enter events
						if (oldState !== SCENE_STATE_DURING) {
							trigger("enter");
							trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
						}
					}
					trigger("progress");
					if (stateChanged) { // leave events
						if (_state !== SCENE_STATE_DURING) {
							trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
							trigger("leave");
						}
					}
				}

				return Scene;
			}
		};


		/**
		 * Update the start and end scrollOffset of the container.
		 * The positions reflect what the controller's scroll position will be at the start and end respectively.
		 * Is called, when:
		 *   - Scene event "change" is called with: offset, triggerHook, duration 
		 *   - scroll container event "resize" is called
		 *   - the position of the triggerElement changes
		 *   - the controller changes -> addTo()
		 * @private
		 */
		var updateScrollOffset = function () {
			_scrollOffset = {
				start: _triggerPos + _options.offset
			};
			if (_controller && _options.triggerElement) {
				// take away triggerHook portion to get relative to top
				_scrollOffset.start -= _controller.info("size") * _options.triggerHook;
			}
			_scrollOffset.end = _scrollOffset.start + _options.duration;
		};

		/**
		 * Updates the duration if set to a dynamic function.
		 * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.change}, if the duration changed
		 * @fires {@link Scene.shift}, if the duration changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */
		var updateDuration = function (suppressEvents) {
			// update duration
			if (_durationUpdateMethod) {
				var varname = "duration";
				if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) { // set
					Scene.trigger("change", {
						what: varname,
						newval: _options[varname]
					});
					Scene.trigger("shift", {
						reason: varname
					});
				}
			}
		};

		/**
		 * Updates the position of the triggerElement, if present.
		 * This method is called ...
		 *  - ... when the triggerElement is changed
		 *  - ... when the scene is added to a (new) controller
		 *  - ... in regular intervals from the controller through scene.refresh().
		 * 
		 * @fires {@link Scene.shift}, if the position changed
		 *
		 * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
		 * @private
		 */
		var updateTriggerElementPosition = function (suppressEvents) {
			var
				elementPos = 0,
				telem = _options.triggerElement;
			if (_controller && (telem || _triggerPos > 0)) { // either an element exists or was removed and the triggerPos is still > 0
				if (telem) { // there currently a triggerElement set
					if (telem.parentNode) { // check if element is still attached to DOM
						var
							controllerInfo = _controller.info(),
							containerOffset = _util.get.offset(controllerInfo.container), // container position is needed because element offset is returned in relation to document, not in relation to container.
							param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?

						// if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.
						while (telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
							telem = telem.parentNode;
						}

						var elementOffset = _util.get.offset(telem);

						if (!controllerInfo.isDocument) { // container is not the document root, so substract scroll Position to get correct trigger element position relative to scrollcontent
							containerOffset[param] -= _controller.scrollPos();
						}

						elementPos = elementOffset[param] - containerOffset[param];

					} else { // there was an element, but it was removed from DOM
						log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
						Scene.triggerElement(undefined); // unset, so a change event is triggered
					}
				}

				var changed = elementPos != _triggerPos;
				_triggerPos = elementPos;
				if (changed && !suppressEvents) {
					Scene.trigger("shift", {
						reason: "triggerElementPosition"
					});
				}
			}
		};

		/**
		 * Trigger a shift event, when the container is resized and the triggerHook is > 1.
		 * @private
		 */
		var onContainerResize = function (e) {
			if (_options.triggerHook > 0) {
				Scene.trigger("shift", {
					reason: "containerResize"
				});
			}
		};


		var _validate = _util.extend(SCENE_OPTIONS.validate, {
			// validation for duration handled internally for reference to private var _durationMethod
			duration: function (val) {
				if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
					// percentage value
					var perc = parseFloat(val) / 100;
					val = function () {
						return _controller ? _controller.info("size") * perc : 0;
					};
				}
				if (_util.type.Function(val)) {
					// function
					_durationUpdateMethod = val;
					try {
						val = parseFloat(_durationUpdateMethod.call(Scene));
					} catch (e) {
						val = -1; // will cause error below
					}
				}
				// val has to be float
				val = parseFloat(val);
				if (!_util.type.Number(val) || val < 0) {
					if (_durationUpdateMethod) {
						_durationUpdateMethod = undefined;
						throw ["Invalid return value of supplied function for option \"duration\":", val];
					} else {
						throw ["Invalid value for option \"duration\":", val];
					}
				}
				return val;
			}
		});

		/**
		 * Checks the validity of a specific or all options and reset to default if neccessary.
		 * @private
		 */
		var validateOption = function (check) {
			check = arguments.length ? [check] : Object.keys(_validate);
			check.forEach(function (optionName, key) {
				var value;
				if (_validate[optionName]) { // there is a validation method for this option
					try { // validate value
						value = _validate[optionName](_options[optionName]);
					} catch (e) { // validation failed -> reset to default
						value = DEFAULT_OPTIONS[optionName];
						var logMSG = _util.type.String(e) ? [e] : e;
						if (_util.type.Array(logMSG)) {
							logMSG[0] = "ERROR: " + logMSG[0];
							logMSG.unshift(1); // loglevel 1 for error msg
							log.apply(this, logMSG);
						} else {
							log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
						}
					} finally {
						_options[optionName] = value;
					}
				}
			});
		};

		/**
		 * Helper used by the setter/getters for scene options
		 * @private
		 */
		var changeOption = function (varname, newval) {
			var
				changed = false,
				oldval = _options[varname];
			if (_options[varname] != newval) {
				_options[varname] = newval;
				validateOption(varname); // resets to default if necessary
				changed = oldval != _options[varname];
			}
			return changed;
		};

		// generate getters/setters for all options
		var addSceneOption = function (optionName) {
			if (!Scene[optionName]) {
				Scene[optionName] = function (newVal) {
					if (!arguments.length) { // get
						return _options[optionName];
					} else {
						if (optionName === "duration") { // new duration is set, so any previously set function must be unset
							_durationUpdateMethod = undefined;
						}
						if (changeOption(optionName, newVal)) { // set
							Scene.trigger("change", {
								what: optionName,
								newval: _options[optionName]
							});
							if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) {
								Scene.trigger("shift", {
									reason: optionName
								});
							}
						}
					}
					return Scene;
				};
			}
		};

		/**
		 * **Get** or **Set** the duration option value.
		 *
		 * As a **setter** it accepts three types of parameters:
		 * 1. `number`: Sets the duration of the scene to exactly this amount of pixels.  
		 *   This means the scene will last for exactly this amount of pixels scrolled. Sub-Pixels are also valid.
		 *   A value of `0` means that the scene is 'open end' and no end will be triggered. Pins will never unpin and animations will play independently of scroll progress.
		 * 2. `string`: Always updates the duration relative to parent scroll container.  
		 *   For example `"100%"` will keep the duration always exactly at the inner height of the scroll container.
		 *   When scrolling vertically the width is used for reference respectively.
		 * 3. `function`: The supplied function will be called to return the scene duration.
		 *   This is useful in setups where the duration depends on other elements who might change size. By supplying a function you can return a value instead of updating potentially multiple scene durations.  
		 *   The scene can be referenced inside the callback using `this`.
		 *   _**WARNING:** This is an easy way to kill performance, as the callback will be executed every time `Scene.refresh()` is called, which happens a lot. The interval is defined by the controller (see ScrollMagic.Controller option `refreshInterval`).  
		 *   It's recomended to avoid calculations within the function and use cached variables as return values.  
		 *   This counts double if you use the same function for multiple scenes._
		 *
		 * @method ScrollMagic.Scene#duration
		 * @example
		 * // get the current duration value
		 * var duration = scene.duration();
		 *
		 * // set a new duration
		 * scene.duration(300);
		 *
		 * // set duration responsively to container size
		 * scene.duration("100%");
		 *
		 * // use a function to randomize the duration for some reason.
		 * var durationValueCache;
		 * function durationCallback () {
		 *   return durationValueCache;
		 * }
		 * function updateDuration () {
		 *   durationValueCache = Math.random() * 100;
		 * }
		 * updateDuration(); // set to initial value
		 * scene.duration(durationCallback); // set duration callback
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string|function)} [newDuration] - The new duration setting for the scene.
		 * @returns {number} `get` -  Current scene duration.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** or **Set** the offset option value.
		 * @method ScrollMagic.Scene#offset
		 * @example
		 * // get the current offset
		 * var offset = scene.offset();
		 *
		 * // set a new offset
		 * scene.offset(100);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {number} [newOffset] - The new offset of the scene.
		 * @returns {number} `get` -  Current scene offset.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** or **Set** the triggerElement option value.
		 * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
		 * @method ScrollMagic.Scene#triggerElement
		 * @example
		 * // get the current triggerElement
		 * var triggerElement = scene.triggerElement();
		 *
		 * // set a new triggerElement using a selector
		 * scene.triggerElement("#trigger");
		 * // set a new triggerElement using a DOM object
		 * scene.triggerElement(document.getElementById("trigger"));
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
		 * @returns {(string|object)} `get` -  Current triggerElement.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** or **Set** the triggerHook option value.
		 * @method ScrollMagic.Scene#triggerHook
		 * @example
		 * // get the current triggerHook value
		 * var triggerHook = scene.triggerHook();
		 *
		 * // set a new triggerHook using a string
		 * scene.triggerHook("onLeave");
		 * // set a new triggerHook using a number
		 * scene.triggerHook(0.7);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @fires {@link Scene.shift}, when used as setter
		 * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
		 * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** or **Set** the reverse option value.
		 * @method ScrollMagic.Scene#reverse
		 * @example
		 * // get the current reverse option
		 * var reverse = scene.reverse();
		 *
		 * // set new reverse option
		 * scene.reverse(false);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {boolean} [newReverse] - The new reverse setting of the scene.
		 * @returns {boolean} `get` -  Current reverse option value.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** or **Set** the loglevel option value.
		 * @method ScrollMagic.Scene#loglevel
		 * @example
		 * // get the current loglevel
		 * var loglevel = scene.loglevel();
		 *
		 * // set new loglevel
		 * scene.loglevel(3);
		 *
		 * @fires {@link Scene.change}, when used as setter
		 * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
		 * @returns {number} `get` -  Current loglevel.
		 * @returns {Scene} `set` -  Parent object for chaining.
		 */

		/**
		 * **Get** the associated controller.
		 * @method ScrollMagic.Scene#controller
		 * @example
		 * // get the controller of a scene
		 * var controller = scene.controller();
		 *
		 * @returns {ScrollMagic.Controller} Parent controller or `undefined`
		 */
		this.controller = function () {
			return _controller;
		};

		/**
		 * **Get** the current state.
		 * @method ScrollMagic.Scene#state
		 * @example
		 * // get the current state
		 * var state = scene.state();
		 *
		 * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
		 */
		this.state = function () {
			return _state;
		};

		/**
		 * **Get** the current scroll offset for the start of the scene.  
		 * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
		 * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
		 * @method ScrollMagic.Scene#scrollOffset
		 * @example
		 * // get the current scroll offset for the start and end of the scene.
		 * var start = scene.scrollOffset();
		 * var end = scene.scrollOffset() + scene.duration();
		 * console.log("the scene starts at", start, "and ends at", end);
		 *
		 * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
		 */
		this.scrollOffset = function () {
			return _scrollOffset.start;
		};

		/**
		 * **Get** the trigger position of the scene (including the value of the `offset` option).  
		 * @method ScrollMagic.Scene#triggerPosition
		 * @example
		 * // get the scene's trigger position
		 * var triggerPosition = scene.triggerPosition();
		 *
		 * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
		 */
		this.triggerPosition = function () {
			var pos = _options.offset; // the offset is the basis
			if (_controller) {
				// get the trigger position
				if (_options.triggerElement) {
					// Element as trigger
					pos += _triggerPos;
				} else {
					// return the height of the triggerHook to start at the beginning
					pos += _controller.info("size") * Scene.triggerHook();
				}
			}
			return pos;
		};


		var
			_pin,
			_pinOptions;

		Scene
			.on("shift.internal", function (e) {
				var durationChanged = e.reason === "duration";
				if ((_state === SCENE_STATE_AFTER && durationChanged) || (_state === SCENE_STATE_DURING && _options.duration === 0)) {
					// if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
					updatePinState();
				}
				if (durationChanged) {
					updatePinDimensions();
				}
			})
			.on("progress.internal", function (e) {
				updatePinState();
			})
			.on("add.internal", function (e) {
				updatePinDimensions();
			})
			.on("destroy.internal", function (e) {
				Scene.removePin(e.reset);
			});
		/**
		 * Update the pin state.
		 * @private
		 */
		var updatePinState = function (forceUnpin) {
			if (_pin && _controller) {
				var
					containerInfo = _controller.info(),
					pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins

				if (!forceUnpin && _state === SCENE_STATE_DURING) { // during scene or if duration is 0 and we are past the trigger
					// pinned state
					if (_util.css(pinTarget, "position") != "fixed") {
						// change state before updating pin spacer (position changes due to fixed collapsing might occur.)
						_util.css(pinTarget, {
							"position": "fixed"
						});
						// update pin spacer
						updatePinDimensions();
					}

					var
						fixedPos = _util.get.offset(_pinOptions.spacer, true), // get viewport position of spacer
						scrollDistance = _options.reverse || _options.duration === 0 ?
						containerInfo.scrollPos - _scrollOffset.start // quicker
						:
						Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress

					// add scrollDistance
					fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance;

					// set new values
					_util.css(_pinOptions.spacer.firstChild, {
						top: fixedPos.top,
						left: fixedPos.left
					});
				} else {
					// unpinned state
					var
						newCSS = {
							position: _pinOptions.inFlow ? "relative" : "absolute",
							top: 0,
							left: 0
						},
						change = _util.css(pinTarget, "position") != newCSS.position;

					if (!_pinOptions.pushFollowers) {
						newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
					} else if (_options.duration > 0) { // only concerns scenes with duration
						if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) {
							change = true; // if in after state but havent updated spacer yet (jumped past pin)
						} else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) { // before
							change = true; // jumped past fixed state upward direction
						}
					}
					// set new values
					_util.css(pinTarget, newCSS);
					if (change) {
						// update pin spacer if state changed
						updatePinDimensions();
					}
				}
			}
		};

		/**
		 * Update the pin spacer and/or element size.
		 * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
		 * @private
		 */
		var updatePinDimensions = function () {
			if (_pin && _controller && _pinOptions.inFlow) { // no spacerresize, if original position is absolute
				var
					after = (_state === SCENE_STATE_AFTER),
					before = (_state === SCENE_STATE_BEFORE),
					during = (_state === SCENE_STATE_DURING),
					vertical = _controller.info("vertical"),
					pinTarget = _pinOptions.spacer.firstChild, // usually the pined element but can also be another spacer (cascaded pins)
					marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")),
					css = {};

				// set new size
				// if relsize: spacer -> pin | else: pin -> spacer
				if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
					if (during) {
						_util.css(_pin, {
							"width": _util.get.width(_pinOptions.spacer)
						});
					} else {
						_util.css(_pin, {
							"width": "100%"
						});
					}
				} else {
					// minwidth is needed for cascaded pins.
					css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
					css.width = during ? css["min-width"] : "auto";
				}
				if (_pinOptions.relSize.height) {
					if (during) {
						// the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
						_util.css(_pin, {
							"height": _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
						});
					} else {
						_util.css(_pin, {
							"height": "100%"
						});
					}
				} else {
					// margin is only included if it's a cascaded pin to resolve an IE9 bug
					css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins
					css.height = during ? css["min-height"] : "auto";
				}

				// add space for duration if pushFollowers is true
				if (_pinOptions.pushFollowers) {
					css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
					css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
				}
				_util.css(_pinOptions.spacer, css);
			}
		};

		/**
		 * Updates the Pin state (in certain scenarios)
		 * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
		 * So this function is called on resize and scroll of the document.
		 * @private
		 */
		var updatePinInContainer = function () {
			if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
				updatePinState();
			}
		};

		/**
		 * Updates the Pin spacer size state (in certain scenarios)
		 * If container is resized during pin and relatively sized the size of the pin might need to be updated...
		 * So this function is called on resize of the container.
		 * @private
		 */
		var updateRelativePinSpacer = function () {
			if (_controller && _pin && // well, duh
				_state === SCENE_STATE_DURING && // element in pinned state?
				( // is width or height relatively sized, but not in relation to body? then we need to recalc.
					((_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode)) ||
					(_pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))
				)
			) {
				updatePinDimensions();
			}
		};

		/**
		 * Is called, when the mousewhel is used while over a pinned element inside a div container.
		 * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
		 * @private
		 */
		var onMousewheelOverPin = function (e) {
			if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) { // in pin state
				e.preventDefault();
				_controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
			}
		};

		/**
		 * Pin an element for the duration of the scene.
		 * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
		 * Make sure only one pin is applied to an element at the same time.
		 * An element can be pinned multiple times, but only successively.
		 * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
		 * @method ScrollMagic.Scene#setPin
		 * @example
		 * // pin element and push all following elements down by the amount of the pin duration.
		 * scene.setPin("#pin");
		 *
		 * // pin element and keeping all following elements in their place. The pinned element will move past them.
		 * scene.setPin("#pin", {pushFollowers: false});
		 *
		 * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
		 * @param {object} [settings] - settings for the pin
		 * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
		 												   Ignored, when duration is `0`.
		 * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */
		this.setPin = function (element, settings) {
			var
				defaultSettings = {
					pushFollowers: true,
					spacerClass: "scrollmagic-pin-spacer"
				};
			var pushFollowersActivelySet = settings && settings.hasOwnProperty('pushFollowers');
			settings = _util.extend({}, defaultSettings, settings);

			// validate Element
			element = _util.get.elements(element)[0];
			if (!element) {
				log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
				return Scene; // cancel
			} else if (_util.css(element, "position") === "fixed") {
				log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
				return Scene; // cancel
			}

			if (_pin) { // preexisting pin?
				if (_pin === element) {
					// same pin we already have -> do nothing
					return Scene; // cancel
				} else {
					// kill old pin
					Scene.removePin();
				}

			}
			_pin = element;

			var
				parentDisplay = _pin.parentNode.style.display,
				boundsParams = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];

			_pin.parentNode.style.display = 'none'; // hack start to force css to return stylesheet values instead of calculated px values.
			var
				inFlow = _util.css(_pin, "position") != "absolute",
				pinCSS = _util.css(_pin, boundsParams.concat(["display"])),
				sizeCSS = _util.css(_pin, ["width", "height"]);
			_pin.parentNode.style.display = parentDisplay; // hack end.

			if (!inFlow && settings.pushFollowers) {
				log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
				settings.pushFollowers = false;
			}
			window.setTimeout(function () { // wait until all finished, because with responsive duration it will only be set after scene is added to controller
				if (_pin && _options.duration === 0 && pushFollowersActivelySet && settings.pushFollowers) {
					log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
				}
			}, 0);

			// create spacer and insert
			var
				spacer = _pin.parentNode.insertBefore(document.createElement('div'), _pin),
				spacerCSS = _util.extend(pinCSS, {
					position: inFlow ? "relative" : "absolute",
					boxSizing: "content-box",
					mozBoxSizing: "content-box",
					webkitBoxSizing: "content-box"
				});

			if (!inFlow) { // copy size if positioned absolutely, to work for bottom/right positioned elements.
				_util.extend(spacerCSS, _util.css(_pin, ["width", "height"]));
			}

			_util.css(spacer, spacerCSS);
			spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");
			_util.addClass(spacer, settings.spacerClass);

			// set the pin Options
			_pinOptions = {
				spacer: spacer,
				relSize: { // save if size is defined using % values. if so, handle spacer resize differently...
					width: sizeCSS.width.slice(-1) === "%",
					height: sizeCSS.height.slice(-1) === "%",
					autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
				},
				pushFollowers: settings.pushFollowers,
				inFlow: inFlow, // stores if the element takes up space in the document flow
			};

			if (!_pin.___origStyle) {
				_pin.___origStyle = {};
				var
					pinInlineCSS = _pin.style,
					copyStyles = boundsParams.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
				copyStyles.forEach(function (val) {
					_pin.___origStyle[val] = pinInlineCSS[val] || "";
				});
			}

			// if relative size, transfer it to spacer and make pin calculate it...
			if (_pinOptions.relSize.width) {
				_util.css(spacer, {
					width: sizeCSS.width
				});
			}
			if (_pinOptions.relSize.height) {
				_util.css(spacer, {
					height: sizeCSS.height
				});
			}

			// now place the pin element inside the spacer	
			spacer.appendChild(_pin);
			// and set new css
			_util.css(_pin, {
				position: inFlow ? "relative" : "absolute",
				margin: "auto",
				top: "auto",
				left: "auto",
				bottom: "auto",
				right: "auto"
			});

			if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
				_util.css(_pin, {
					boxSizing: "border-box",
					mozBoxSizing: "border-box",
					webkitBoxSizing: "border-box"
				});
			}

			// add listener to document to update pin position in case controller is not the document.
			window.addEventListener('scroll', updatePinInContainer);
			window.addEventListener('resize', updatePinInContainer);
			window.addEventListener('resize', updateRelativePinSpacer);
			// add mousewheel listener to catch scrolls over fixed elements
			_pin.addEventListener("mousewheel", onMousewheelOverPin);
			_pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);

			log(3, "added pin");

			// finally update the pin to init
			updatePinState();

			return Scene;
		};

		/**
		 * Remove the pin from the scene.
		 * @method ScrollMagic.Scene#removePin
		 * @example
		 * // remove the pin from the scene without resetting it (the spacer is not removed)
		 * scene.removePin();
		 *
		 * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
		 * scene.removePin(true);
		 *
		 * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.removePin = function (reset) {
			if (_pin) {
				if (_state === SCENE_STATE_DURING) {
					updatePinState(true); // force unpin at position
				}
				if (reset || !_controller) { // if there's no controller no progress was made anyway...
					var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...
					if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) { // copy margins to child spacer
						var
							style = _pinOptions.spacer.style,
							values = ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"],
							margins = {};
						values.forEach(function (val) {
							margins[val] = style[val] || "";
						});
						_util.css(pinTarget, margins);
					}
					_pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);
					_pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);
					if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) { // if it's the last pin for this element -> restore inline styles
						// TODO: only correctly set for first pin (when cascading) - how to fix?
						_util.css(_pin, _pin.___origStyle);
						delete _pin.___origStyle;
					}
				}
				window.removeEventListener('scroll', updatePinInContainer);
				window.removeEventListener('resize', updatePinInContainer);
				window.removeEventListener('resize', updateRelativePinSpacer);
				_pin.removeEventListener("mousewheel", onMousewheelOverPin);
				_pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);
				_pin = undefined;
				log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
			}
			return Scene;
		};


		var
			_cssClasses,
			_cssClassElems = [];

		Scene
			.on("destroy.internal", function (e) {
				Scene.removeClassToggle(e.reset);
			});
		/**
		 * Define a css class modification while the scene is active.  
		 * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
		 * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
		 * @method ScrollMagic.Scene#setClassToggle
		 * @example
		 * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
		 * scene.setClassToggle("#my-elem", "myclass");
		 *
		 * // add multiple classes to multiple elements defined by the selector '.classChange'
		 * scene.setClassToggle(".classChange", "class1 class2 class3");
		 *
		 * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
		 * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
		 *
		 * @returns {Scene} Parent object for chaining.
		 */
		this.setClassToggle = function (element, classes) {
			var elems = _util.get.elements(element);
			if (elems.length === 0 || !_util.type.String(classes)) {
				log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
				return Scene;
			}
			if (_cssClassElems.length > 0) {
				// remove old ones
				Scene.removeClassToggle();
			}
			_cssClasses = classes;
			_cssClassElems = elems;
			Scene.on("enter.internal_class leave.internal_class", function (e) {
				var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;
				_cssClassElems.forEach(function (elem, key) {
					toggle(elem, _cssClasses);
				});
			});
			return Scene;
		};

		/**
		 * Remove the class binding from the scene.
		 * @method ScrollMagic.Scene#removeClassToggle
		 * @example
		 * // remove class binding from the scene without reset
		 * scene.removeClassToggle();
		 *
		 * // remove class binding and remove the changes it caused
		 * scene.removeClassToggle(true);
		 *
		 * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
		 * @returns {Scene} Parent object for chaining.
		 */
		this.removeClassToggle = function (reset) {
			if (reset) {
				_cssClassElems.forEach(function (elem, key) {
					_util.removeClass(elem, _cssClasses);
				});
			}
			Scene.off("start.internal_class end.internal_class");
			_cssClasses = undefined;
			_cssClassElems = [];
			return Scene;
		};

		// INIT
		construct();
		return Scene;
	};

	// store pagewide scene options
	var SCENE_OPTIONS = {
		defaults: {
			duration: 0,
			offset: 0,
			triggerElement: undefined,
			triggerHook: 0.5,
			reverse: true,
			loglevel: 2
		},
		validate: {
			offset: function (val) {
				val = parseFloat(val);
				if (!_util.type.Number(val)) {
					throw ["Invalid value for option \"offset\":", val];
				}
				return val;
			},
			triggerElement: function (val) {
				val = val || undefined;
				if (val) {
					var elem = _util.get.elements(val)[0];
					if (elem && elem.parentNode) {
						val = elem;
					} else {
						throw ["Element defined in option \"triggerElement\" was not found:", val];
					}
				}
				return val;
			},
			triggerHook: function (val) {
				var translate = {
					"onCenter": 0.5,
					"onEnter": 1,
					"onLeave": 0
				};
				if (_util.type.Number(val)) {
					val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
				} else if (val in translate) {
					val = translate[val];
				} else {
					throw ["Invalid value for option \"triggerHook\": ", val];
				}
				return val;
			},
			reverse: function (val) {
				return !!val; // force boolean
			},
			loglevel: function (val) {
				val = parseInt(val);
				if (!_util.type.Number(val) || val < 0 || val > 3) {
					throw ["Invalid value for option \"loglevel\":", val];
				}
				return val;
			}
		}, // holder for  validation methods. duration validation is handled in 'getters-setters.js'
		shifts: ["duration", "offset", "triggerHook"], // list of options that trigger a `shift` event
	};
	/*
	 * method used to add an option to ScrollMagic Scenes.
	 * TODO: DOC (private for dev)
	 */
	ScrollMagic.Scene.addOption = function (name, defaultValue, validationCallback, shifts) {
		if (!(name in SCENE_OPTIONS.defaults)) {
			SCENE_OPTIONS.defaults[name] = defaultValue;
			SCENE_OPTIONS.validate[name] = validationCallback;
			if (shifts) {
				SCENE_OPTIONS.shifts.push(name);
			}
		} else {
			ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
		}
	};
	// instance extension function for plugins
	// TODO: DOC (private for dev)
	ScrollMagic.Scene.extend = function (extension) {
		var oldClass = this;
		ScrollMagic.Scene = function () {
			oldClass.apply(this, arguments);
			this.$super = _util.extend({}, this); // copy parent state
			return extension.apply(this, arguments) || this;
		};
		_util.extend(ScrollMagic.Scene, oldClass); // copy properties
		ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype
		ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
	};



	/**
	 * TODO: DOCS (private for dev)
	 * @class
	 * @private
	 */

	ScrollMagic.Event = function (type, namespace, target, vars) {
		vars = vars || {};
		for (var key in vars) {
			this[key] = vars[key];
		}
		this.type = type;
		this.target = this.currentTarget = target;
		this.namespace = namespace || '';
		this.timeStamp = this.timestamp = Date.now();
		return this;
	};

	/*
	 * TODO: DOCS (private for dev)
	 */

	var _util = ScrollMagic._util = (function (window) {
		var U = {},
			i;

		/**
		 * ------------------------------
		 * internal helpers
		 * ------------------------------
		 */

		// parse float and fall back to 0.
		var floatval = function (number) {
			return parseFloat(number) || 0;
		};
		// get current style IE safe (otherwise IE would return calculated values for 'auto')
		var _getComputedStyle = function (elem) {
			return elem.currentStyle ? elem.currentStyle : window.getComputedStyle(elem);
		};

		// get element dimension (width or height)
		var _dimension = function (which, elem, outer, includeMargin) {
			elem = (elem === document) ? window : elem;
			if (elem === window) {
				includeMargin = false;
			} else if (!_type.DomElement(elem)) {
				return 0;
			}
			which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
			var dimension = (outer ? elem['offset' + which] || elem['outer' + which] : elem['client' + which] || elem['inner' + which]) || 0;
			if (outer && includeMargin) {
				var style = _getComputedStyle(elem);
				dimension += which === 'Height' ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
			}
			return dimension;
		};
		// converts 'margin-top' into 'marginTop'
		var _camelCase = function (str) {
			return str.replace(/^[^a-z]+([a-z])/g, '$1').replace(/-([a-z])/g, function (g) {
				return g[1].toUpperCase();
			});
		};

		/**
		 * ------------------------------
		 * external helpers
		 * ------------------------------
		 */

		// extend obj – same as jQuery.extend({}, objA, objB)
		U.extend = function (obj) {
			obj = obj || {};
			for (i = 1; i < arguments.length; i++) {
				if (!arguments[i]) {
					continue;
				}
				for (var key in arguments[i]) {
					if (arguments[i].hasOwnProperty(key)) {
						obj[key] = arguments[i][key];
					}
				}
			}
			return obj;
		};

		// check if a css display type results in margin-collapse or not
		U.isMarginCollapseType = function (str) {
			return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(str) > -1;
		};

		// implementation of requestAnimationFrame
		// based on https://gist.github.com/paulirish/1579671
		var
			lastTime = 0,
			vendors = ['ms', 'moz', 'webkit', 'o'];
		var _requestAnimationFrame = window.requestAnimationFrame;
		var _cancelAnimationFrame = window.cancelAnimationFrame;
		// try vendor prefixes if the above doesn't work
		for (i = 0; !_requestAnimationFrame && i < vendors.length; ++i) {
			_requestAnimationFrame = window[vendors[i] + 'RequestAnimationFrame'];
			_cancelAnimationFrame = window[vendors[i] + 'CancelAnimationFrame'] || window[vendors[i] + 'CancelRequestAnimationFrame'];
		}

		// fallbacks
		if (!_requestAnimationFrame) {
			_requestAnimationFrame = function (callback) {
				var
					currTime = new Date().getTime(),
					timeToCall = Math.max(0, 16 - (currTime - lastTime)),
					id = window.setTimeout(function () {
						callback(currTime + timeToCall);
					}, timeToCall);
				lastTime = currTime + timeToCall;
				return id;
			};
		}
		if (!_cancelAnimationFrame) {
			_cancelAnimationFrame = function (id) {
				window.clearTimeout(id);
			};
		}
		U.rAF = _requestAnimationFrame.bind(window);
		U.cAF = _cancelAnimationFrame.bind(window);

		var
			loglevels = ["error", "warn", "log"],
			console = window.console || {};

		console.log = console.log || function () {}; // no console log, well - do nothing then...
		// make sure methods for all levels exist.
		for (i = 0; i < loglevels.length; i++) {
			var method = loglevels[i];
			if (!console[method]) {
				console[method] = console.log; // prefer .log over nothing
			}
		}
		U.log = function (loglevel) {
			if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
			var now = new Date(),
				time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3),
				method = loglevels[loglevel - 1],
				args = Array.prototype.splice.call(arguments, 1),
				func = Function.prototype.bind.call(console[method], console);
			args.unshift(time);
			func.apply(console, args);
		};

		/**
		 * ------------------------------
		 * type testing
		 * ------------------------------
		 */

		var _type = U.type = function (v) {
			return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
		};
		_type.String = function (v) {
			return _type(v) === 'string';
		};
		_type.Function = function (v) {
			return _type(v) === 'function';
		};
		_type.Array = function (v) {
			return Array.isArray(v);
		};
		_type.Number = function (v) {
			return !_type.Array(v) && (v - parseFloat(v) + 1) >= 0;
		};
		_type.DomElement = function (o) {
			return (
				typeof HTMLElement === "object" || typeof HTMLElement === "function" ? o instanceof HTMLElement || o instanceof SVGElement : //DOM2
				o && typeof o === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string"
			);
		};

		/**
		 * ------------------------------
		 * DOM Element info
		 * ------------------------------
		 */
		// always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors
		var _get = U.get = {};
		_get.elements = function (selector) {
			var arr = [];
			if (_type.String(selector)) {
				try {
					selector = document.querySelectorAll(selector);
				} catch (e) { // invalid selector
					return arr;
				}
			}
			if (_type(selector) === 'nodelist' || _type.Array(selector) || selector instanceof NodeList) {
				for (var i = 0, ref = arr.length = selector.length; i < ref; i++) { // list of elements
					var elem = selector[i];
					arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
				}
			} else if (_type.DomElement(selector) || selector === document || selector === window) {
				arr = [selector]; // only the element
			}
			return arr;
		};
		// get scroll top value
		_get.scrollTop = function (elem) {
			return (elem && typeof elem.scrollTop === 'number') ? elem.scrollTop : window.pageYOffset || 0;
		};
		// get scroll left value
		_get.scrollLeft = function (elem) {
			return (elem && typeof elem.scrollLeft === 'number') ? elem.scrollLeft : window.pageXOffset || 0;
		};
		// get element height
		_get.width = function (elem, outer, includeMargin) {
			return _dimension('width', elem, outer, includeMargin);
		};
		// get element width
		_get.height = function (elem, outer, includeMargin) {
			return _dimension('height', elem, outer, includeMargin);
		};

		// get element position (optionally relative to viewport)
		_get.offset = function (elem, relativeToViewport) {
			var offset = {
				top: 0,
				left: 0
			};
			if (elem && elem.getBoundingClientRect) { // check if available
				var rect = elem.getBoundingClientRect();
				offset.top = rect.top;
				offset.left = rect.left;
				if (!relativeToViewport) { // clientRect is by default relative to viewport...
					offset.top += _get.scrollTop();
					offset.left += _get.scrollLeft();
				}
			}
			return offset;
		};

		/**
		 * ------------------------------
		 * DOM Element manipulation
		 * ------------------------------
		 */

		U.addClass = function (elem, classname) {
			if (classname) {
				if (elem.classList)
					elem.classList.add(classname);
				else
					elem.className += ' ' + classname;
			}
		};
		U.removeClass = function (elem, classname) {
			if (classname) {
				if (elem.classList)
					elem.classList.remove(classname);
				else
					elem.className = elem.className.replace(new RegExp('(^|\\b)' + classname.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
			}
		};
		// if options is string -> returns css value
		// if options is array -> returns object with css value pairs
		// if options is object -> set new css values
		U.css = function (elem, options) {
			if (_type.String(options)) {
				return _getComputedStyle(elem)[_camelCase(options)];
			} else if (_type.Array(options)) {
				var
					obj = {},
					style = _getComputedStyle(elem);
				options.forEach(function (option, key) {
					obj[option] = style[_camelCase(option)];
				});
				return obj;
			} else {
				for (var option in options) {
					var val = options[option];
					if (val == parseFloat(val)) { // assume pixel for seemingly numerical values
						val += 'px';
					}
					elem.style[_camelCase(option)] = val;
				}
			}
		};

		return U;
	}(window || {}));


	ScrollMagic.Scene.prototype.addIndicators = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
		return this;
	}
	ScrollMagic.Scene.prototype.removeIndicators = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');
		return this;
	}
	ScrollMagic.Scene.prototype.setTween = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
		return this;
	}
	ScrollMagic.Scene.prototype.removeTween = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');
		return this;
	}
	ScrollMagic.Scene.prototype.setVelocity = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
		return this;
	}
	ScrollMagic.Scene.prototype.removeVelocity = function () {
		ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');
		return this;
	}

	return ScrollMagic;
}));
},{}],254:[function(require,module,exports){
/*! @license ScrollReveal v4.0.7

	Copyright 2020 Fisssion LLC.

	Licensed under the GNU General Public License 3.0 for
	compatible open source projects and non-commercial use.

	For commercial sites, themes, projects, and applications,
	keep your source code private/proprietary by purchasing
	a commercial license from https://scrollrevealjs.org/
*/
(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.ScrollReveal = factory());
}(this, function () { 'use strict';

	var defaults = {
		delay: 0,
		distance: '0',
		duration: 600,
		easing: 'cubic-bezier(0.5, 0, 0, 1)',
		interval: 0,
		opacity: 0,
		origin: 'bottom',
		rotate: {
			x: 0,
			y: 0,
			z: 0
		},
		scale: 1,
		cleanup: false,
		container: document.documentElement,
		desktop: true,
		mobile: true,
		reset: false,
		useDelay: 'always',
		viewFactor: 0.0,
		viewOffset: {
			top: 0,
			right: 0,
			bottom: 0,
			left: 0
		},
		afterReset: function afterReset() {},
		afterReveal: function afterReveal() {},
		beforeReset: function beforeReset() {},
		beforeReveal: function beforeReveal() {}
	};

	function failure() {
		document.documentElement.classList.remove('sr');

		return {
			clean: function clean() {},
			destroy: function destroy() {},
			reveal: function reveal() {},
			sync: function sync() {},
			get noop() {
				return true
			}
		}
	}

	function success() {
		document.documentElement.classList.add('sr');

		if (document.body) {
			document.body.style.height = '100%';
		} else {
			document.addEventListener('DOMContentLoaded', function () {
				document.body.style.height = '100%';
			});
		}
	}

	var mount = { success: success, failure: failure };

	/*! @license is-dom-node v1.0.4

		Copyright 2018 Fisssion LLC.

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.

	*/
	function isDomNode(x) {
		return typeof window.Node === 'object'
			? x instanceof window.Node
			: x !== null &&
					typeof x === 'object' &&
					typeof x.nodeType === 'number' &&
					typeof x.nodeName === 'string'
	}

	/*! @license is-dom-node-list v1.2.1

		Copyright 2018 Fisssion LLC.

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.

	*/

	function isDomNodeList(x) {
		var prototypeToString = Object.prototype.toString.call(x);
		var regex = /^\[object (HTMLCollection|NodeList|Object)\]$/;

		return typeof window.NodeList === 'object'
			? x instanceof window.NodeList
			: x !== null &&
					typeof x === 'object' &&
					typeof x.length === 'number' &&
					regex.test(prototypeToString) &&
					(x.length === 0 || isDomNode(x[0]))
	}

	/*! @license Tealight v0.3.6

		Copyright 2018 Fisssion LLC.

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.

	*/

	function tealight(target, context) {
	  if ( context === void 0 ) { context = document; }

	  if (target instanceof Array) { return target.filter(isDomNode); }
	  if (isDomNode(target)) { return [target]; }
	  if (isDomNodeList(target)) { return Array.prototype.slice.call(target); }
	  if (typeof target === "string") {
	    try {
	      var query = context.querySelectorAll(target);
	      return Array.prototype.slice.call(query);
	    } catch (err) {
	      return [];
	    }
	  }
	  return [];
	}

	function isObject(x) {
		return (
			x !== null &&
			x instanceof Object &&
			(x.constructor === Object ||
				Object.prototype.toString.call(x) === '[object Object]')
		)
	}

	function each(collection, callback) {
		if (isObject(collection)) {
			var keys = Object.keys(collection);
			return keys.forEach(function (key) { return callback(collection[key], key, collection); })
		}
		if (collection instanceof Array) {
			return collection.forEach(function (item, i) { return callback(item, i, collection); })
		}
		throw new TypeError('Expected either an array or object literal.')
	}

	function logger(message) {
		var details = [], len = arguments.length - 1;
		while ( len-- > 0 ) details[ len ] = arguments[ len + 1 ];

		if (this.constructor.debug && console) {
			var report = "%cScrollReveal: " + message;
			details.forEach(function (detail) { return (report += "\n — " + detail); });
			console.log(report, 'color: #ea654b;'); // eslint-disable-line no-console
		}
	}

	function rinse() {
		var this$1 = this;

		var struct = function () { return ({
			active: [],
			stale: []
		}); };

		var elementIds = struct();
		var sequenceIds = struct();
		var containerIds = struct();

		/**
		 * Take stock of active element IDs.
		 */
		try {
			each(tealight('[data-sr-id]'), function (node) {
				var id = parseInt(node.getAttribute('data-sr-id'));
				elementIds.active.push(id);
			});
		} catch (e) {
			throw e
		}
		/**
		 * Destroy stale elements.
		 */
		each(this.store.elements, function (element) {
			if (elementIds.active.indexOf(element.id) === -1) {
				elementIds.stale.push(element.id);
			}
		});

		each(elementIds.stale, function (staleId) { return delete this$1.store.elements[staleId]; });

		/**
		 * Take stock of active container and sequence IDs.
		 */
		each(this.store.elements, function (element) {
			if (containerIds.active.indexOf(element.containerId) === -1) {
				containerIds.active.push(element.containerId);
			}
			if (element.hasOwnProperty('sequence')) {
				if (sequenceIds.active.indexOf(element.sequence.id) === -1) {
					sequenceIds.active.push(element.sequence.id);
				}
			}
		});

		/**
		 * Destroy stale containers.
		 */
		each(this.store.containers, function (container) {
			if (containerIds.active.indexOf(container.id) === -1) {
				containerIds.stale.push(container.id);
			}
		});

		each(containerIds.stale, function (staleId) {
			var stale = this$1.store.containers[staleId].node;
			stale.removeEventListener('scroll', this$1.delegate);
			stale.removeEventListener('resize', this$1.delegate);
			delete this$1.store.containers[staleId];
		});

		/**
		 * Destroy stale sequences.
		 */
		each(this.store.sequences, function (sequence) {
			if (sequenceIds.active.indexOf(sequence.id) === -1) {
				sequenceIds.stale.push(sequence.id);
			}
		});

		each(sequenceIds.stale, function (staleId) { return delete this$1.store.sequences[staleId]; });
	}

	function clean(target) {
		var this$1 = this;

		var dirty;
		try {
			each(tealight(target), function (node) {
				var id = node.getAttribute('data-sr-id');
				if (id !== null) {
					dirty = true;
					var element = this$1.store.elements[id];
					if (element.callbackTimer) {
						window.clearTimeout(element.callbackTimer.clock);
					}
					node.setAttribute('style', element.styles.inline.generated);
					node.removeAttribute('data-sr-id');
					delete this$1.store.elements[id];
				}
			});
		} catch (e) {
			return logger.call(this, 'Clean failed.', e.message)
		}

		if (dirty) {
			try {
				rinse.call(this);
			} catch (e) {
				return logger.call(this, 'Clean failed.', e.message)
			}
		}
	}

	function destroy() {
		var this$1 = this;

		/**
		 * Remove all generated styles and element ids
		 */
		each(this.store.elements, function (element) {
			element.node.setAttribute('style', element.styles.inline.generated);
			element.node.removeAttribute('data-sr-id');
		});

		/**
		 * Remove all event listeners.
		 */
		each(this.store.containers, function (container) {
			var target =
				container.node === document.documentElement ? window : container.node;
			target.removeEventListener('scroll', this$1.delegate);
			target.removeEventListener('resize', this$1.delegate);
		});

		/**
		 * Clear all data from the store
		 */
		this.store = {
			containers: {},
			elements: {},
			history: [],
			sequences: {}
		};
	}

	/*! @license Rematrix v0.3.0

		Copyright 2018 Julian Lloyd.

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in
		all copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		THE SOFTWARE.
	*/
	/**
	 * @module Rematrix
	 */

	/**
	 * Transformation matrices in the browser come in two flavors:
	 *
	 *  - `matrix` using 6 values (short)
	 *  - `matrix3d` using 16 values (long)
	 *
	 * This utility follows this [conversion guide](https://goo.gl/EJlUQ1)
	 * to expand short form matrices to their equivalent long form.
	 *
	 * @param  {array} source - Accepts both short and long form matrices.
	 * @return {array}
	 */
	function format(source) {
		if (source.constructor !== Array) {
			throw new TypeError('Expected array.')
		}
		if (source.length === 16) {
			return source
		}
		if (source.length === 6) {
			var matrix = identity();
			matrix[0] = source[0];
			matrix[1] = source[1];
			matrix[4] = source[2];
			matrix[5] = source[3];
			matrix[12] = source[4];
			matrix[13] = source[5];
			return matrix
		}
		throw new RangeError('Expected array with either 6 or 16 values.')
	}

	/**
	 * Returns a matrix representing no transformation. The product of any matrix
	 * multiplied by the identity matrix will be the original matrix.
	 *
	 * > **Tip:** Similar to how `5 * 1 === 5`, where `1` is the identity.
	 *
	 * @return {array}
	 */
	function identity() {
		var matrix = [];
		for (var i = 0; i < 16; i++) {
			i % 5 == 0 ? matrix.push(1) : matrix.push(0);
		}
		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing the combined transformations
	 * of both arguments.
	 *
	 * > **Note:** Order is very important. For example, rotating 45°
	 * along the Z-axis, followed by translating 500 pixels along the
	 * Y-axis... is not the same as translating 500 pixels along the
	 * Y-axis, followed by rotating 45° along on the Z-axis.
	 *
	 * @param  {array} m - Accepts both short and long form matrices.
	 * @param  {array} x - Accepts both short and long form matrices.
	 * @return {array}
	 */
	function multiply(m, x) {
		var fm = format(m);
		var fx = format(x);
		var product = [];

		for (var i = 0; i < 4; i++) {
			var row = [fm[i], fm[i + 4], fm[i + 8], fm[i + 12]];
			for (var j = 0; j < 4; j++) {
				var k = j * 4;
				var col = [fx[k], fx[k + 1], fx[k + 2], fx[k + 3]];
				var result =
					row[0] * col[0] + row[1] * col[1] + row[2] * col[2] + row[3] * col[3];

				product[i + k] = result;
			}
		}

		return product
	}

	/**
	 * Attempts to return a 4x4 matrix describing the CSS transform
	 * matrix passed in, but will return the identity matrix as a
	 * fallback.
	 *
	 * > **Tip:** This method is used to convert a CSS matrix (retrieved as a
	 * `string` from computed styles) to its equivalent array format.
	 *
	 * @param  {string} source - `matrix` or `matrix3d` CSS Transform value.
	 * @return {array}
	 */
	function parse(source) {
		if (typeof source === 'string') {
			var match = source.match(/matrix(3d)?\(([^)]+)\)/);
			if (match) {
				var raw = match[2].split(', ').map(parseFloat);
				return format(raw)
			}
		}
		return identity()
	}

	/**
	 * Returns a 4x4 matrix describing X-axis rotation.
	 *
	 * @param  {number} angle - Measured in degrees.
	 * @return {array}
	 */
	function rotateX(angle) {
		var theta = Math.PI / 180 * angle;
		var matrix = identity();

		matrix[5] = matrix[10] = Math.cos(theta);
		matrix[6] = matrix[9] = Math.sin(theta);
		matrix[9] *= -1;

		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing Y-axis rotation.
	 *
	 * @param  {number} angle - Measured in degrees.
	 * @return {array}
	 */
	function rotateY(angle) {
		var theta = Math.PI / 180 * angle;
		var matrix = identity();

		matrix[0] = matrix[10] = Math.cos(theta);
		matrix[2] = matrix[8] = Math.sin(theta);
		matrix[2] *= -1;

		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing Z-axis rotation.
	 *
	 * @param  {number} angle - Measured in degrees.
	 * @return {array}
	 */
	function rotateZ(angle) {
		var theta = Math.PI / 180 * angle;
		var matrix = identity();

		matrix[0] = matrix[5] = Math.cos(theta);
		matrix[1] = matrix[4] = Math.sin(theta);
		matrix[4] *= -1;

		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing 2D scaling. The first argument
	 * is used for both X and Y-axis scaling, unless an optional
	 * second argument is provided to explicitly define Y-axis scaling.
	 *
	 * @param  {number} scalar    - Decimal multiplier.
	 * @param  {number} [scalarY] - Decimal multiplier.
	 * @return {array}
	 */
	function scale(scalar, scalarY) {
		var matrix = identity();

		matrix[0] = scalar;
		matrix[5] = typeof scalarY === 'number' ? scalarY : scalar;

		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing X-axis translation.
	 *
	 * @param  {number} distance - Measured in pixels.
	 * @return {array}
	 */
	function translateX(distance) {
		var matrix = identity();
		matrix[12] = distance;
		return matrix
	}

	/**
	 * Returns a 4x4 matrix describing Y-axis translation.
	 *
	 * @param  {number} distance - Measured in pixels.
	 * @return {array}
	 */
	function translateY(distance) {
		var matrix = identity();
		matrix[13] = distance;
		return matrix
	}

	var getPrefixedCssProp = (function () {
		var properties = {};
		var style = document.documentElement.style;

		function getPrefixedCssProperty(name, source) {
			if ( source === void 0 ) source = style;

			if (name && typeof name === 'string') {
				if (properties[name]) {
					return properties[name]
				}
				if (typeof source[name] === 'string') {
					return (properties[name] = name)
				}
				if (typeof source[("-webkit-" + name)] === 'string') {
					return (properties[name] = "-webkit-" + name)
				}
				throw new RangeError(("Unable to find \"" + name + "\" style property."))
			}
			throw new TypeError('Expected a string.')
		}

		getPrefixedCssProperty.clearCache = function () { return (properties = {}); };

		return getPrefixedCssProperty
	})();

	function style(element) {
		var computed = window.getComputedStyle(element.node);
		var position = computed.position;
		var config = element.config;

		/**
		 * Generate inline styles
		 */
		var inline = {};
		var inlineStyle = element.node.getAttribute('style') || '';
		var inlineMatch = inlineStyle.match(/[\w-]+\s*:\s*[^;]+\s*/gi) || [];

		inline.computed = inlineMatch ? inlineMatch.map(function (m) { return m.trim(); }).join('; ') + ';' : '';

		inline.generated = inlineMatch.some(function (m) { return m.match(/visibility\s?:\s?visible/i); })
			? inline.computed
			: inlineMatch.concat( ['visibility: visible']).map(function (m) { return m.trim(); }).join('; ') + ';';

		/**
		 * Generate opacity styles
		 */
		var computedOpacity = parseFloat(computed.opacity);
		var configOpacity = !isNaN(parseFloat(config.opacity))
			? parseFloat(config.opacity)
			: parseFloat(computed.opacity);

		var opacity = {
			computed: computedOpacity !== configOpacity ? ("opacity: " + computedOpacity + ";") : '',
			generated: computedOpacity !== configOpacity ? ("opacity: " + configOpacity + ";") : ''
		};

		/**
		 * Generate transformation styles
		 */
		var transformations = [];

		if (parseFloat(config.distance)) {
			var axis = config.origin === 'top' || config.origin === 'bottom' ? 'Y' : 'X';

			/**
			 * Let’s make sure our our pixel distances are negative for top and left.
			 * e.g. { origin: 'top', distance: '25px' } starts at `top: -25px` in CSS.
			 */
			var distance = config.distance;
			if (config.origin === 'top' || config.origin === 'left') {
				distance = /^-/.test(distance) ? distance.substr(1) : ("-" + distance);
			}

			var ref = distance.match(/(^-?\d+\.?\d?)|(em$|px$|%$)/g);
			var value = ref[0];
			var unit = ref[1];

			switch (unit) {
				case 'em':
					distance = parseInt(computed.fontSize) * value;
					break
				case 'px':
					distance = value;
					break
				case '%':
					/**
					 * Here we use `getBoundingClientRect` instead of
					 * the existing data attached to `element.geometry`
					 * because only the former includes any transformations
					 * current applied to the element.
					 *
					 * If that behavior ends up being unintuitive, this
					 * logic could instead utilize `element.geometry.height`
					 * and `element.geoemetry.width` for the distance calculation
					 */
					distance =
						axis === 'Y'
							? (element.node.getBoundingClientRect().height * value) / 100
							: (element.node.getBoundingClientRect().width * value) / 100;
					break
				default:
					throw new RangeError('Unrecognized or missing distance unit.')
			}

			if (axis === 'Y') {
				transformations.push(translateY(distance));
			} else {
				transformations.push(translateX(distance));
			}
		}

		if (config.rotate.x) { transformations.push(rotateX(config.rotate.x)); }
		if (config.rotate.y) { transformations.push(rotateY(config.rotate.y)); }
		if (config.rotate.z) { transformations.push(rotateZ(config.rotate.z)); }
		if (config.scale !== 1) {
			if (config.scale === 0) {
				/**
				 * The CSS Transforms matrix interpolation specification
				 * basically disallows transitions of non-invertible
				 * matrixes, which means browsers won't transition
				 * elements with zero scale.
				 *
				 * That’s inconvenient for the API and developer
				 * experience, so we simply nudge their value
				 * slightly above zero; this allows browsers
				 * to transition our element as expected.
				 *
				 * `0.0002` was the smallest number
				 * that performed across browsers.
				 */
				transformations.push(scale(0.0002));
			} else {
				transformations.push(scale(config.scale));
			}
		}

		var transform = {};
		if (transformations.length) {
			transform.property = getPrefixedCssProp('transform');
			/**
			 * The default computed transform value should be one of:
			 * undefined || 'none' || 'matrix()' || 'matrix3d()'
			 */
			transform.computed = {
				raw: computed[transform.property],
				matrix: parse(computed[transform.property])
			};

			transformations.unshift(transform.computed.matrix);
			var product = transformations.reduce(multiply);

			transform.generated = {
				initial: ((transform.property) + ": matrix3d(" + (product.join(', ')) + ");"),
				final: ((transform.property) + ": matrix3d(" + (transform.computed.matrix.join(', ')) + ");")
			};
		} else {
			transform.generated = {
				initial: '',
				final: ''
			};
		}

		/**
		 * Generate transition styles
		 */
		var transition = {};
		if (opacity.generated || transform.generated.initial) {
			transition.property = getPrefixedCssProp('transition');
			transition.computed = computed[transition.property];
			transition.fragments = [];

			var delay = config.delay;
			var duration = config.duration;
			var easing = config.easing;

			if (opacity.generated) {
				transition.fragments.push({
					delayed: ("opacity " + (duration / 1000) + "s " + easing + " " + (delay / 1000) + "s"),
					instant: ("opacity " + (duration / 1000) + "s " + easing + " 0s")
				});
			}

			if (transform.generated.initial) {
				transition.fragments.push({
					delayed: ((transform.property) + " " + (duration / 1000) + "s " + easing + " " + (delay / 1000) + "s"),
					instant: ((transform.property) + " " + (duration / 1000) + "s " + easing + " 0s")
				});
			}

			/**
			 * The default computed transition property should be undefined, or one of:
			 * '' || 'none 0s ease 0s' || 'all 0s ease 0s' || 'all 0s 0s cubic-bezier()'
			 */
			var hasCustomTransition =
				transition.computed && !transition.computed.match(/all 0s|none 0s/);

			if (hasCustomTransition) {
				transition.fragments.unshift({
					delayed: transition.computed,
					instant: transition.computed
				});
			}

			var composed = transition.fragments.reduce(
				function (composition, fragment, i) {
					composition.delayed += i === 0 ? fragment.delayed : (", " + (fragment.delayed));
					composition.instant += i === 0 ? fragment.instant : (", " + (fragment.instant));
					return composition
				},
				{
					delayed: '',
					instant: ''
				}
			);

			transition.generated = {
				delayed: ((transition.property) + ": " + (composed.delayed) + ";"),
				instant: ((transition.property) + ": " + (composed.instant) + ";")
			};
		} else {
			transition.generated = {
				delayed: '',
				instant: ''
			};
		}

		return {
			inline: inline,
			opacity: opacity,
			position: position,
			transform: transform,
			transition: transition
		}
	}

	function animate(element, force) {
		if ( force === void 0 ) force = {};

		var pristine = force.pristine || this.pristine;
		var delayed =
			element.config.useDelay === 'always' ||
			(element.config.useDelay === 'onload' && pristine) ||
			(element.config.useDelay === 'once' && !element.seen);

		var shouldReveal = element.visible && !element.revealed;
		var shouldReset = !element.visible && element.revealed && element.config.reset;

		if (force.reveal || shouldReveal) {
			return triggerReveal.call(this, element, delayed)
		}

		if (force.reset || shouldReset) {
			return triggerReset.call(this, element)
		}
	}

	function triggerReveal(element, delayed) {
		var styles = [
			element.styles.inline.generated,
			element.styles.opacity.computed,
			element.styles.transform.generated.final
		];
		if (delayed) {
			styles.push(element.styles.transition.generated.delayed);
		} else {
			styles.push(element.styles.transition.generated.instant);
		}
		element.revealed = element.seen = true;
		element.node.setAttribute('style', styles.filter(function (s) { return s !== ''; }).join(' '));
		registerCallbacks.call(this, element, delayed);
	}

	function triggerReset(element) {
		var styles = [
			element.styles.inline.generated,
			element.styles.opacity.generated,
			element.styles.transform.generated.initial,
			element.styles.transition.generated.instant
		];
		element.revealed = false;
		element.node.setAttribute('style', styles.filter(function (s) { return s !== ''; }).join(' '));
		registerCallbacks.call(this, element);
	}

	function registerCallbacks(element, isDelayed) {
		var this$1 = this;

		var duration = isDelayed
			? element.config.duration + element.config.delay
			: element.config.duration;

		var beforeCallback = element.revealed
			? element.config.beforeReveal
			: element.config.beforeReset;

		var afterCallback = element.revealed
			? element.config.afterReveal
			: element.config.afterReset;

		var elapsed = 0;
		if (element.callbackTimer) {
			elapsed = Date.now() - element.callbackTimer.start;
			window.clearTimeout(element.callbackTimer.clock);
		}

		beforeCallback(element.node);

		element.callbackTimer = {
			start: Date.now(),
			clock: window.setTimeout(function () {
				afterCallback(element.node);
				element.callbackTimer = null;
				if (element.revealed && !element.config.reset && element.config.cleanup) {
					clean.call(this$1, element.node);
				}
			}, duration - elapsed)
		};
	}

	var nextUniqueId = (function () {
		var uid = 0;
		return function () { return uid++; }
	})();

	function sequence(element, pristine) {
		if ( pristine === void 0 ) pristine = this.pristine;

		/**
		 * We first check if the element should reset.
		 */
		if (!element.visible && element.revealed && element.config.reset) {
			return animate.call(this, element, { reset: true })
		}

		var seq = this.store.sequences[element.sequence.id];
		var i = element.sequence.index;

		if (seq) {
			var visible = new SequenceModel(seq, 'visible', this.store);
			var revealed = new SequenceModel(seq, 'revealed', this.store);

			seq.models = { visible: visible, revealed: revealed };

			/**
			 * If the sequence has no revealed members,
			 * then we reveal the first visible element
			 * within that sequence.
			 *
			 * The sequence then cues a recursive call
			 * in both directions.
			 */
			if (!revealed.body.length) {
				var nextId = seq.members[visible.body[0]];
				var nextElement = this.store.elements[nextId];

				if (nextElement) {
					cue.call(this, seq, visible.body[0], -1, pristine);
					cue.call(this, seq, visible.body[0], +1, pristine);
					return animate.call(this, nextElement, { reveal: true, pristine: pristine })
				}
			}

			/**
			 * If our element isn’t resetting, we check the
			 * element sequence index against the head, and
			 * then the foot of the sequence.
			 */
			if (
				!seq.blocked.head &&
				i === [].concat( revealed.head ).pop() &&
				i >= [].concat( visible.body ).shift()
			) {
				cue.call(this, seq, i, -1, pristine);
				return animate.call(this, element, { reveal: true, pristine: pristine })
			}

			if (
				!seq.blocked.foot &&
				i === [].concat( revealed.foot ).shift() &&
				i <= [].concat( visible.body ).pop()
			) {
				cue.call(this, seq, i, +1, pristine);
				return animate.call(this, element, { reveal: true, pristine: pristine })
			}
		}
	}

	function Sequence(interval) {
		var i = Math.abs(interval);
		if (!isNaN(i)) {
			this.id = nextUniqueId();
			this.interval = Math.max(i, 16);
			this.members = [];
			this.models = {};
			this.blocked = {
				head: false,
				foot: false
			};
		} else {
			throw new RangeError('Invalid sequence interval.')
		}
	}

	function SequenceModel(seq, prop, store) {
		var this$1 = this;

		this.head = [];
		this.body = [];
		this.foot = [];

		each(seq.members, function (id, index) {
			var element = store.elements[id];
			if (element && element[prop]) {
				this$1.body.push(index);
			}
		});

		if (this.body.length) {
			each(seq.members, function (id, index) {
				var element = store.elements[id];
				if (element && !element[prop]) {
					if (index < this$1.body[0]) {
						this$1.head.push(index);
					} else {
						this$1.foot.push(index);
					}
				}
			});
		}
	}

	function cue(seq, i, direction, pristine) {
		var this$1 = this;

		var blocked = ['head', null, 'foot'][1 + direction];
		var nextId = seq.members[i + direction];
		var nextElement = this.store.elements[nextId];

		seq.blocked[blocked] = true;

		setTimeout(function () {
			seq.blocked[blocked] = false;
			if (nextElement) {
				sequence.call(this$1, nextElement, pristine);
			}
		}, seq.interval);
	}

	function initialize() {
		var this$1 = this;

		rinse.call(this);

		each(this.store.elements, function (element) {
			var styles = [element.styles.inline.generated];

			if (element.visible) {
				styles.push(element.styles.opacity.computed);
				styles.push(element.styles.transform.generated.final);
				element.revealed = true;
			} else {
				styles.push(element.styles.opacity.generated);
				styles.push(element.styles.transform.generated.initial);
				element.revealed = false;
			}

			element.node.setAttribute('style', styles.filter(function (s) { return s !== ''; }).join(' '));
		});

		each(this.store.containers, function (container) {
			var target =
				container.node === document.documentElement ? window : container.node;
			target.addEventListener('scroll', this$1.delegate);
			target.addEventListener('resize', this$1.delegate);
		});

		/**
		 * Manually invoke delegate once to capture
		 * element and container dimensions, container
		 * scroll position, and trigger any valid reveals
		 */
		this.delegate();

		/**
		 * Wipe any existing `setTimeout` now
		 * that initialization has completed.
		 */
		this.initTimeout = null;
	}

	function isMobile(agent) {
		if ( agent === void 0 ) agent = navigator.userAgent;

		return /Android|iPhone|iPad|iPod/i.test(agent)
	}

	function deepAssign(target) {
		var sources = [], len = arguments.length - 1;
		while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];

		if (isObject(target)) {
			each(sources, function (source) {
				each(source, function (data, key) {
					if (isObject(data)) {
						if (!target[key] || !isObject(target[key])) {
							target[key] = {};
						}
						deepAssign(target[key], data);
					} else {
						target[key] = data;
					}
				});
			});
			return target
		} else {
			throw new TypeError('Target must be an object literal.')
		}
	}

	function reveal(target, options, syncing) {
		var this$1 = this;
		if ( options === void 0 ) options = {};
		if ( syncing === void 0 ) syncing = false;

		var containerBuffer = [];
		var sequence$$1;
		var interval = options.interval || defaults.interval;

		try {
			if (interval) {
				sequence$$1 = new Sequence(interval);
			}

			var nodes = tealight(target);
			if (!nodes.length) {
				throw new Error('Invalid reveal target.')
			}

			var elements = nodes.reduce(function (elementBuffer, elementNode) {
				var element = {};
				var existingId = elementNode.getAttribute('data-sr-id');

				if (existingId) {
					deepAssign(element, this$1.store.elements[existingId]);

					/**
					 * In order to prevent previously generated styles
					 * from throwing off the new styles, the style tag
					 * has to be reverted to its pre-reveal state.
					 */
					element.node.setAttribute('style', element.styles.inline.computed);
				} else {
					element.id = nextUniqueId();
					element.node = elementNode;
					element.seen = false;
					element.revealed = false;
					element.visible = false;
				}

				var config = deepAssign({}, element.config || this$1.defaults, options);

				if ((!config.mobile && isMobile()) || (!config.desktop && !isMobile())) {
					if (existingId) {
						clean.call(this$1, element);
					}
					return elementBuffer // skip elements that are disabled
				}

				var containerNode = tealight(config.container)[0];
				if (!containerNode) {
					throw new Error('Invalid container.')
				}
				if (!containerNode.contains(elementNode)) {
					return elementBuffer // skip elements found outside the container
				}

				var containerId;
				{
					containerId = getContainerId(
						containerNode,
						containerBuffer,
						this$1.store.containers
					);
					if (containerId === null) {
						containerId = nextUniqueId();
						containerBuffer.push({ id: containerId, node: containerNode });
					}
				}

				element.config = config;
				element.containerId = containerId;
				element.styles = style(element);

				if (sequence$$1) {
					element.sequence = {
						id: sequence$$1.id,
						index: sequence$$1.members.length
					};
					sequence$$1.members.push(element.id);
				}

				elementBuffer.push(element);
				return elementBuffer
			}, []);

			/**
			 * Modifying the DOM via setAttribute needs to be handled
			 * separately from reading computed styles in the map above
			 * for the browser to batch DOM changes (limiting reflows)
			 */
			each(elements, function (element) {
				this$1.store.elements[element.id] = element;
				element.node.setAttribute('data-sr-id', element.id);
			});
		} catch (e) {
			return logger.call(this, 'Reveal failed.', e.message)
		}

		/**
		 * Now that element set-up is complete...
		 * Let’s commit any container and sequence data we have to the store.
		 */
		each(containerBuffer, function (container) {
			this$1.store.containers[container.id] = {
				id: container.id,
				node: container.node
			};
		});
		if (sequence$$1) {
			this.store.sequences[sequence$$1.id] = sequence$$1;
		}

		/**
		 * If reveal wasn't invoked by sync, we want to
		 * make sure to add this call to the history.
		 */
		if (syncing !== true) {
			this.store.history.push({ target: target, options: options });

			/**
			 * Push initialization to the event queue, giving
			 * multiple reveal calls time to be interpreted.
			 */
			if (this.initTimeout) {
				window.clearTimeout(this.initTimeout);
			}
			this.initTimeout = window.setTimeout(initialize.bind(this), 0);
		}
	}

	function getContainerId(node) {
		var collections = [], len = arguments.length - 1;
		while ( len-- > 0 ) collections[ len ] = arguments[ len + 1 ];

		var id = null;
		each(collections, function (collection) {
			each(collection, function (container) {
				if (id === null && container.node === node) {
					id = container.id;
				}
			});
		});
		return id
	}

	/**
	 * Re-runs the reveal method for each record stored in history,
	 * for capturing new content asynchronously loaded into the DOM.
	 */
	function sync() {
		var this$1 = this;

		each(this.store.history, function (record) {
			reveal.call(this$1, record.target, record.options, true);
		});

		initialize.call(this);
	}

	var polyfill = function (x) { return (x > 0) - (x < 0) || +x; };
	var mathSign = Math.sign || polyfill;

	/*! @license miniraf v1.0.1

		Copyright 2018 Fisssion LLC.

		Permission is hereby granted, free of charge, to any person obtaining a copy
		of this software and associated documentation files (the "Software"), to deal
		in the Software without restriction, including without limitation the rights
		to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		copies of the Software, and to permit persons to whom the Software is
		furnished to do so, subject to the following conditions:

		The above copyright notice and this permission notice shall be included in all
		copies or substantial portions of the Software.

		THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
		SOFTWARE.

	*/
	var polyfill$1 = (function () {
		var clock = Date.now();

		return function (callback) {
			var currentTime = Date.now();
			if (currentTime - clock > 16) {
				clock = currentTime;
				callback(currentTime);
			} else {
				setTimeout(function () { return polyfill$1(callback); }, 0);
			}
		}
	})();

	var miniraf = window.requestAnimationFrame ||
		window.webkitRequestAnimationFrame ||
		window.mozRequestAnimationFrame ||
		polyfill$1;

	function getGeometry(target, isContainer) {
		/**
		 * We want to ignore padding and scrollbars for container elements.
		 * More information here: https://goo.gl/vOZpbz
		 */
		var height = isContainer ? target.node.clientHeight : target.node.offsetHeight;
		var width = isContainer ? target.node.clientWidth : target.node.offsetWidth;

		var offsetTop = 0;
		var offsetLeft = 0;
		var node = target.node;

		do {
			if (!isNaN(node.offsetTop)) {
				offsetTop += node.offsetTop;
			}
			if (!isNaN(node.offsetLeft)) {
				offsetLeft += node.offsetLeft;
			}
			node = node.offsetParent;
		} while (node)

		return {
			bounds: {
				top: offsetTop,
				right: offsetLeft + width,
				bottom: offsetTop + height,
				left: offsetLeft
			},
			height: height,
			width: width
		}
	}

	function getScrolled(container) {
		var top, left;
		if (container.node === document.documentElement) {
			top = window.pageYOffset;
			left = window.pageXOffset;
		} else {
			top = container.node.scrollTop;
			left = container.node.scrollLeft;
		}
		return { top: top, left: left }
	}

	function isElementVisible(element) {
		if ( element === void 0 ) element = {};

		var container = this.store.containers[element.containerId];
		if (!container) { return }

		var viewFactor = Math.max(0, Math.min(1, element.config.viewFactor));
		var viewOffset = element.config.viewOffset;

		var elementBounds = {
			top: element.geometry.bounds.top + element.geometry.height * viewFactor,
			right: element.geometry.bounds.right - element.geometry.width * viewFactor,
			bottom: element.geometry.bounds.bottom - element.geometry.height * viewFactor,
			left: element.geometry.bounds.left + element.geometry.width * viewFactor
		};

		var containerBounds = {
			top: container.geometry.bounds.top + container.scroll.top + viewOffset.top,
			right: container.geometry.bounds.right + container.scroll.left - viewOffset.right,
			bottom:
				container.geometry.bounds.bottom + container.scroll.top - viewOffset.bottom,
			left: container.geometry.bounds.left + container.scroll.left + viewOffset.left
		};

		return (
			(elementBounds.top < containerBounds.bottom &&
				elementBounds.right > containerBounds.left &&
				elementBounds.bottom > containerBounds.top &&
				elementBounds.left < containerBounds.right) ||
			element.styles.position === 'fixed'
		)
	}

	function delegate(
		event,
		elements
	) {
		var this$1 = this;
		if ( event === void 0 ) event = { type: 'init' };
		if ( elements === void 0 ) elements = this.store.elements;

		miniraf(function () {
			var stale = event.type === 'init' || event.type === 'resize';

			each(this$1.store.containers, function (container) {
				if (stale) {
					container.geometry = getGeometry.call(this$1, container, true);
				}
				var scroll = getScrolled.call(this$1, container);
				if (container.scroll) {
					container.direction = {
						x: mathSign(scroll.left - container.scroll.left),
						y: mathSign(scroll.top - container.scroll.top)
					};
				}
				container.scroll = scroll;
			});

			/**
			 * Due to how the sequencer is implemented, it’s
			 * important that we update the state of all
			 * elements, before any animation logic is
			 * evaluated (in the second loop below).
			 */
			each(elements, function (element) {
				if (stale || element.geometry === undefined) {
					element.geometry = getGeometry.call(this$1, element);
				}
				element.visible = isElementVisible.call(this$1, element);
			});

			each(elements, function (element) {
				if (element.sequence) {
					sequence.call(this$1, element);
				} else {
					animate.call(this$1, element);
				}
			});

			this$1.pristine = false;
		});
	}

	function isTransformSupported() {
		var style = document.documentElement.style;
		return 'transform' in style || 'WebkitTransform' in style
	}

	function isTransitionSupported() {
		var style = document.documentElement.style;
		return 'transition' in style || 'WebkitTransition' in style
	}

	var version = "4.0.7";

	var boundDelegate;
	var boundDestroy;
	var boundReveal;
	var boundClean;
	var boundSync;
	var config;
	var debug;
	var instance;

	function ScrollReveal(options) {
		if ( options === void 0 ) options = {};

		var invokedWithoutNew =
			typeof this === 'undefined' ||
			Object.getPrototypeOf(this) !== ScrollReveal.prototype;

		if (invokedWithoutNew) {
			return new ScrollReveal(options)
		}

		if (!ScrollReveal.isSupported()) {
			logger.call(this, 'Instantiation failed.', 'This browser is not supported.');
			return mount.failure()
		}

		var buffer;
		try {
			buffer = config
				? deepAssign({}, config, options)
				: deepAssign({}, defaults, options);
		} catch (e) {
			logger.call(this, 'Invalid configuration.', e.message);
			return mount.failure()
		}

		try {
			var container = tealight(buffer.container)[0];
			if (!container) {
				throw new Error('Invalid container.')
			}
		} catch (e) {
			logger.call(this, e.message);
			return mount.failure()
		}

		config = buffer;

		if ((!config.mobile && isMobile()) || (!config.desktop && !isMobile())) {
			logger.call(
				this,
				'This device is disabled.',
				("desktop: " + (config.desktop)),
				("mobile: " + (config.mobile))
			);
			return mount.failure()
		}

		mount.success();

		this.store = {
			containers: {},
			elements: {},
			history: [],
			sequences: {}
		};

		this.pristine = true;

		boundDelegate = boundDelegate || delegate.bind(this);
		boundDestroy = boundDestroy || destroy.bind(this);
		boundReveal = boundReveal || reveal.bind(this);
		boundClean = boundClean || clean.bind(this);
		boundSync = boundSync || sync.bind(this);

		Object.defineProperty(this, 'delegate', { get: function () { return boundDelegate; } });
		Object.defineProperty(this, 'destroy', { get: function () { return boundDestroy; } });
		Object.defineProperty(this, 'reveal', { get: function () { return boundReveal; } });
		Object.defineProperty(this, 'clean', { get: function () { return boundClean; } });
		Object.defineProperty(this, 'sync', { get: function () { return boundSync; } });

		Object.defineProperty(this, 'defaults', { get: function () { return config; } });
		Object.defineProperty(this, 'version', { get: function () { return version; } });
		Object.defineProperty(this, 'noop', { get: function () { return false; } });

		return instance ? instance : (instance = this)
	}

	ScrollReveal.isSupported = function () { return isTransformSupported() && isTransitionSupported(); };

	Object.defineProperty(ScrollReveal, 'debug', {
		get: function () { return debug || false; },
		set: function (value) { return (debug = typeof value === 'boolean' ? value : debug); }
	});

	ScrollReveal();

	return ScrollReveal;

}));

},{}],255:[function(require,module,exports){
(function (global){(function (){
/**
 * simplebar - v6.2.5
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */

var SimpleBar = (function () {
    'use strict';

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var canUseDOM = !!(
      typeof window !== 'undefined' &&
      window.document &&
      window.document.createElement
    );

    var canUseDom = canUseDOM;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

    var freeGlobal$1 = freeGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal$1 || freeSelf || Function('return this')();

    var root$1 = root;

    /** Built-in value references. */
    var Symbol = root$1.Symbol;

    var Symbol$1 = Symbol;

    /** Used for built-in method references. */
    var objectProto$1 = Object.prototype;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto$1.hasOwnProperty;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString$1 = objectProto$1.toString;

    /** Built-in value references. */
    var symToStringTag$1 = Symbol$1 ? Symbol$1.toStringTag : undefined;

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag$1),
          tag = value[symToStringTag$1];

      try {
        value[symToStringTag$1] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString$1.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag$1] = tag;
        } else {
          delete value[symToStringTag$1];
        }
      }
      return result;
    }

    /** Used for built-in method references. */
    var objectProto = Object.prototype;

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /** `Object#toString` result references. */
    var nullTag = '[object Null]',
        undefinedTag = '[object Undefined]';

    /** Built-in value references. */
    var symToStringTag = Symbol$1 ? Symbol$1.toStringTag : undefined;

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /** `Object#toString` result references. */
    var symbolTag = '[object Symbol]';

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /** Used to match a single whitespace character. */
    var reWhitespace = /\s/;

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
     * character of `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the index of the last non-whitespace character.
     */
    function trimmedEndIndex(string) {
      var index = string.length;

      while (index-- && reWhitespace.test(string.charAt(index))) {}
      return index;
    }

    /** Used to match leading whitespace. */
    var reTrimStart = /^\s+/;

    /**
     * The base implementation of `_.trim`.
     *
     * @private
     * @param {string} string The string to trim.
     * @returns {string} Returns the trimmed string.
     */
    function baseTrim(string) {
      return string
        ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
        : string;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /** Used as references for various `Number` constants. */
    var NAN = 0 / 0;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Built-in method references without a dependency on `root`. */
    var freeParseInt = parseInt;

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = function() {
      return root$1.Date.now();
    };

    var now$1 = now;

    /** Error message constants. */
    var FUNC_ERROR_TEXT$1 = 'Expected a function';

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeMax = Math.max,
        nativeMin = Math.min;

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT$1);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now$1();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now$1());
      }

      function debounced() {
        var time = now$1(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /** Error message constants. */
    var FUNC_ERROR_TEXT = 'Expected a function';

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * simplebar-core - v1.2.4
     * Scrollbars, simpler.
     * https://grsmto.github.io/simplebar/
     *
     * Made by Adrien Denat from a fork by Jonathan Nicol
     * Under MIT License
     */

    /******************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    var cachedScrollbarWidth = null;
    var cachedDevicePixelRatio = null;
    if (canUseDom) {
        window.addEventListener('resize', function () {
            if (cachedDevicePixelRatio !== window.devicePixelRatio) {
                cachedDevicePixelRatio = window.devicePixelRatio;
                cachedScrollbarWidth = null;
            }
        });
    }
    function scrollbarWidth() {
        if (cachedScrollbarWidth === null) {
            if (typeof document === 'undefined') {
                cachedScrollbarWidth = 0;
                return cachedScrollbarWidth;
            }
            var body = document.body;
            var box = document.createElement('div');
            box.classList.add('simplebar-hide-scrollbar');
            body.appendChild(box);
            var width = box.getBoundingClientRect().right;
            body.removeChild(box);
            cachedScrollbarWidth = width;
        }
        return cachedScrollbarWidth;
    }

    function getElementWindow$1(element) {
        if (!element ||
            !element.ownerDocument ||
            !element.ownerDocument.defaultView) {
            return window;
        }
        return element.ownerDocument.defaultView;
    }
    function getElementDocument$1(element) {
        if (!element || !element.ownerDocument) {
            return document;
        }
        return element.ownerDocument;
    }
    // Helper function to retrieve options from element attributes
    var getOptions$1 = function (obj) {
        var initialObj = {};
        var options = Array.prototype.reduce.call(obj, function (acc, attribute) {
            var option = attribute.name.match(/data-simplebar-(.+)/);
            if (option) {
                var key = option[1].replace(/\W+(.)/g, function (_, chr) { return chr.toUpperCase(); });
                switch (attribute.value) {
                    case 'true':
                        acc[key] = true;
                        break;
                    case 'false':
                        acc[key] = false;
                        break;
                    case undefined:
                        acc[key] = true;
                        break;
                    default:
                        acc[key] = attribute.value;
                }
            }
            return acc;
        }, initialObj);
        return options;
    };
    function addClasses$1(el, classes) {
        var _a;
        if (!el)
            return;
        (_a = el.classList).add.apply(_a, classes.split(' '));
    }
    function removeClasses$1(el, classes) {
        if (!el)
            return;
        classes.split(' ').forEach(function (className) {
            el.classList.remove(className);
        });
    }
    function classNamesToQuery$1(classNames) {
        return ".".concat(classNames.split(' ').join('.'));
    }

    var helpers = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getElementWindow: getElementWindow$1,
        getElementDocument: getElementDocument$1,
        getOptions: getOptions$1,
        addClasses: addClasses$1,
        removeClasses: removeClasses$1,
        classNamesToQuery: classNamesToQuery$1
    });

    var getElementWindow = getElementWindow$1, getElementDocument = getElementDocument$1, getOptions$2 = getOptions$1, addClasses$2 = addClasses$1, removeClasses = removeClasses$1, classNamesToQuery = classNamesToQuery$1;
    var SimpleBarCore = /** @class */ (function () {
        function SimpleBarCore(element, options) {
            if (options === void 0) { options = {}; }
            var _this = this;
            this.removePreventClickId = null;
            this.minScrollbarWidth = 20;
            this.stopScrollDelay = 175;
            this.isScrolling = false;
            this.isMouseEntering = false;
            this.scrollXTicking = false;
            this.scrollYTicking = false;
            this.wrapperEl = null;
            this.contentWrapperEl = null;
            this.contentEl = null;
            this.offsetEl = null;
            this.maskEl = null;
            this.placeholderEl = null;
            this.heightAutoObserverWrapperEl = null;
            this.heightAutoObserverEl = null;
            this.rtlHelpers = null;
            this.scrollbarWidth = 0;
            this.resizeObserver = null;
            this.mutationObserver = null;
            this.elStyles = null;
            this.isRtl = null;
            this.mouseX = 0;
            this.mouseY = 0;
            this.onMouseMove = function () { };
            this.onWindowResize = function () { };
            this.onStopScrolling = function () { };
            this.onMouseEntered = function () { };
            /**
             * On scroll event handling
             */
            this.onScroll = function () {
                var elWindow = getElementWindow(_this.el);
                if (!_this.scrollXTicking) {
                    elWindow.requestAnimationFrame(_this.scrollX);
                    _this.scrollXTicking = true;
                }
                if (!_this.scrollYTicking) {
                    elWindow.requestAnimationFrame(_this.scrollY);
                    _this.scrollYTicking = true;
                }
                if (!_this.isScrolling) {
                    _this.isScrolling = true;
                    addClasses$2(_this.el, _this.classNames.scrolling);
                }
                _this.showScrollbar('x');
                _this.showScrollbar('y');
                _this.onStopScrolling();
            };
            this.scrollX = function () {
                if (_this.axis.x.isOverflowing) {
                    _this.positionScrollbar('x');
                }
                _this.scrollXTicking = false;
            };
            this.scrollY = function () {
                if (_this.axis.y.isOverflowing) {
                    _this.positionScrollbar('y');
                }
                _this.scrollYTicking = false;
            };
            this._onStopScrolling = function () {
                removeClasses(_this.el, _this.classNames.scrolling);
                if (_this.options.autoHide) {
                    _this.hideScrollbar('x');
                    _this.hideScrollbar('y');
                }
                _this.isScrolling = false;
            };
            this.onMouseEnter = function () {
                if (!_this.isMouseEntering) {
                    addClasses$2(_this.el, _this.classNames.mouseEntered);
                    _this.showScrollbar('x');
                    _this.showScrollbar('y');
                    _this.isMouseEntering = true;
                }
                _this.onMouseEntered();
            };
            this._onMouseEntered = function () {
                removeClasses(_this.el, _this.classNames.mouseEntered);
                if (_this.options.autoHide) {
                    _this.hideScrollbar('x');
                    _this.hideScrollbar('y');
                }
                _this.isMouseEntering = false;
            };
            this._onMouseMove = function (e) {
                _this.mouseX = e.clientX;
                _this.mouseY = e.clientY;
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
                    _this.onMouseMoveForAxis('x');
                }
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
                    _this.onMouseMoveForAxis('y');
                }
            };
            this.onMouseLeave = function () {
                _this.onMouseMove.cancel();
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
                    _this.onMouseLeaveForAxis('x');
                }
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
                    _this.onMouseLeaveForAxis('y');
                }
                _this.mouseX = -1;
                _this.mouseY = -1;
            };
            this._onWindowResize = function () {
                // Recalculate scrollbarWidth in case it's a zoom
                _this.scrollbarWidth = _this.getScrollbarWidth();
                _this.hideNativeScrollbar();
            };
            this.onPointerEvent = function (e) {
                if (!_this.axis.x.track.el ||
                    !_this.axis.y.track.el ||
                    !_this.axis.x.scrollbar.el ||
                    !_this.axis.y.scrollbar.el)
                    return;
                var isWithinTrackXBounds, isWithinTrackYBounds;
                _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
                _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
                if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) {
                    isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
                }
                if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) {
                    isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
                }
                // If any pointer event is called on the scrollbar
                if (isWithinTrackXBounds || isWithinTrackYBounds) {
                    // Prevent event leaking
                    e.stopPropagation();
                    if (e.type === 'pointerdown' && e.pointerType !== 'touch') {
                        if (isWithinTrackXBounds) {
                            _this.axis.x.scrollbar.rect =
                                _this.axis.x.scrollbar.el.getBoundingClientRect();
                            if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) {
                                _this.onDragStart(e, 'x');
                            }
                            else {
                                _this.onTrackClick(e, 'x');
                            }
                        }
                        if (isWithinTrackYBounds) {
                            _this.axis.y.scrollbar.rect =
                                _this.axis.y.scrollbar.el.getBoundingClientRect();
                            if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) {
                                _this.onDragStart(e, 'y');
                            }
                            else {
                                _this.onTrackClick(e, 'y');
                            }
                        }
                    }
                }
            };
            /**
             * Drag scrollbar handle
             */
            this.drag = function (e) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
                if (!_this.draggedAxis || !_this.contentWrapperEl)
                    return;
                var eventOffset;
                var track = _this.axis[_this.draggedAxis].track;
                var trackSize = (_b = (_a = track.rect) === null || _a === void 0 ? void 0 : _a[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
                var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
                var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
                var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : '0px', 10);
                e.preventDefault();
                e.stopPropagation();
                if (_this.draggedAxis === 'y') {
                    eventOffset = e.pageY;
                }
                else {
                    eventOffset = e.pageX;
                }
                // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
                var dragPos = eventOffset -
                    ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) -
                    _this.axis[_this.draggedAxis].dragOffset;
                dragPos = _this.draggedAxis === 'x' && _this.isRtl
                    ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) -
                        scrollbar.size -
                        dragPos
                    : dragPos;
                // Convert the mouse position into a percentage of the scrollbar height/width.
                var dragPerc = dragPos / (trackSize - scrollbar.size);
                // Scroll the content by the same percentage.
                var scrollPos = dragPerc * (contentSize - hostSize);
                // Fix browsers inconsistency on RTL
                if (_this.draggedAxis === 'x' && _this.isRtl) {
                    scrollPos = ((_l = SimpleBarCore.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative)
                        ? -scrollPos
                        : scrollPos;
                }
                _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] =
                    scrollPos;
            };
            /**
             * End scroll handle drag
             */
            this.onEndDrag = function (e) {
                var elDocument = getElementDocument(_this.el);
                var elWindow = getElementWindow(_this.el);
                e.preventDefault();
                e.stopPropagation();
                removeClasses(_this.el, _this.classNames.dragging);
                elDocument.removeEventListener('mousemove', _this.drag, true);
                elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
                _this.removePreventClickId = elWindow.setTimeout(function () {
                    // Remove these asynchronously so we still suppress click events
                    // generated simultaneously with mouseup.
                    elDocument.removeEventListener('click', _this.preventClick, true);
                    elDocument.removeEventListener('dblclick', _this.preventClick, true);
                    _this.removePreventClickId = null;
                });
            };
            /**
             * Handler to ignore click events during drag
             */
            this.preventClick = function (e) {
                e.preventDefault();
                e.stopPropagation();
            };
            this.el = element;
            this.options = __assign(__assign({}, SimpleBarCore.defaultOptions), options);
            this.classNames = __assign(__assign({}, SimpleBarCore.defaultOptions.classNames), options.classNames);
            this.axis = {
                x: {
                    scrollOffsetAttr: 'scrollLeft',
                    sizeAttr: 'width',
                    scrollSizeAttr: 'scrollWidth',
                    offsetSizeAttr: 'offsetWidth',
                    offsetAttr: 'left',
                    overflowAttr: 'overflowX',
                    dragOffset: 0,
                    isOverflowing: true,
                    forceVisible: false,
                    track: { size: null, el: null, rect: null, isVisible: false },
                    scrollbar: { size: null, el: null, rect: null, isVisible: false }
                },
                y: {
                    scrollOffsetAttr: 'scrollTop',
                    sizeAttr: 'height',
                    scrollSizeAttr: 'scrollHeight',
                    offsetSizeAttr: 'offsetHeight',
                    offsetAttr: 'top',
                    overflowAttr: 'overflowY',
                    dragOffset: 0,
                    isOverflowing: true,
                    forceVisible: false,
                    track: { size: null, el: null, rect: null, isVisible: false },
                    scrollbar: { size: null, el: null, rect: null, isVisible: false }
                }
            };
            if (typeof this.el !== 'object' || !this.el.nodeName) {
                throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
            }
            this.onMouseMove = throttle(this._onMouseMove, 64);
            this.onWindowResize = debounce(this._onWindowResize, 64, { leading: true });
            this.onStopScrolling = debounce(this._onStopScrolling, this.stopScrollDelay);
            this.onMouseEntered = debounce(this._onMouseEntered, this.stopScrollDelay);
            this.init();
        }
        /**
         * Helper to fix browsers inconsistency on RTL:
         *  - Firefox inverts the scrollbar initial position
         *  - IE11 inverts both scrollbar position and scrolling offset
         * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
         */
        SimpleBarCore.getRtlHelpers = function () {
            if (SimpleBarCore.rtlHelpers) {
                return SimpleBarCore.rtlHelpers;
            }
            var dummyDiv = document.createElement('div');
            dummyDiv.innerHTML =
                '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
            var scrollbarDummyEl = dummyDiv.firstElementChild;
            var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
            if (!dummyChild)
                return null;
            document.body.appendChild(scrollbarDummyEl);
            scrollbarDummyEl.scrollLeft = 0;
            var dummyContainerOffset = SimpleBarCore.getOffset(scrollbarDummyEl);
            var dummyChildOffset = SimpleBarCore.getOffset(dummyChild);
            scrollbarDummyEl.scrollLeft = -999;
            var dummyChildOffsetAfterScroll = SimpleBarCore.getOffset(dummyChild);
            document.body.removeChild(scrollbarDummyEl);
            SimpleBarCore.rtlHelpers = {
                // determines if the scrolling is responding with negative values
                isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
                // determines if the origin scrollbar position is inverted or not (positioned on left or right)
                isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
            };
            return SimpleBarCore.rtlHelpers;
        };
        SimpleBarCore.prototype.getScrollbarWidth = function () {
            // Try/catch for FF 56 throwing on undefined computedStyles
            try {
                // Detect browsers supporting CSS scrollbar styling and do not calculate
                if ((this.contentWrapperEl &&
                    getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar')
                        .display === 'none') ||
                    'scrollbarWidth' in document.documentElement.style ||
                    '-ms-overflow-style' in document.documentElement.style) {
                    return 0;
                }
                else {
                    return scrollbarWidth();
                }
            }
            catch (e) {
                return scrollbarWidth();
            }
        };
        SimpleBarCore.getOffset = function (el) {
            var rect = el.getBoundingClientRect();
            var elDocument = getElementDocument(el);
            var elWindow = getElementWindow(el);
            return {
                top: rect.top +
                    (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
                left: rect.left +
                    (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
            };
        };
        SimpleBarCore.prototype.init = function () {
            // We stop here on server-side
            if (canUseDom) {
                this.initDOM();
                this.rtlHelpers = SimpleBarCore.getRtlHelpers();
                this.scrollbarWidth = this.getScrollbarWidth();
                this.recalculate();
                this.initListeners();
            }
        };
        SimpleBarCore.prototype.initDOM = function () {
            var _a, _b;
            // assume that element has his DOM already initiated
            this.wrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.wrapper));
            this.contentWrapperEl =
                this.options.scrollableNode ||
                    this.el.querySelector(classNamesToQuery(this.classNames.contentWrapper));
            this.contentEl =
                this.options.contentNode ||
                    this.el.querySelector(classNamesToQuery(this.classNames.contentEl));
            this.offsetEl = this.el.querySelector(classNamesToQuery(this.classNames.offset));
            this.maskEl = this.el.querySelector(classNamesToQuery(this.classNames.mask));
            this.placeholderEl = this.findChild(this.wrapperEl, classNamesToQuery(this.classNames.placeholder));
            this.heightAutoObserverWrapperEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
            this.heightAutoObserverEl = this.el.querySelector(classNamesToQuery(this.classNames.heightAutoObserverEl));
            this.axis.x.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.horizontal)));
            this.axis.y.track.el = this.findChild(this.el, "".concat(classNamesToQuery(this.classNames.track)).concat(classNamesToQuery(this.classNames.vertical)));
            this.axis.x.scrollbar.el =
                ((_a = this.axis.x.track.el) === null || _a === void 0 ? void 0 : _a.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
            this.axis.y.scrollbar.el =
                ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector(classNamesToQuery(this.classNames.scrollbar))) || null;
            if (!this.options.autoHide) {
                addClasses$2(this.axis.x.scrollbar.el, this.classNames.visible);
                addClasses$2(this.axis.y.scrollbar.el, this.classNames.visible);
            }
        };
        SimpleBarCore.prototype.initListeners = function () {
            var _this = this;
            var _a;
            var elWindow = getElementWindow(this.el);
            // Event listeners
            this.el.addEventListener('mouseenter', this.onMouseEnter);
            this.el.addEventListener('pointerdown', this.onPointerEvent, true);
            this.el.addEventListener('mousemove', this.onMouseMove);
            this.el.addEventListener('mouseleave', this.onMouseLeave);
            (_a = this.contentWrapperEl) === null || _a === void 0 ? void 0 : _a.addEventListener('scroll', this.onScroll);
            // Browser zoom triggers a window resize
            elWindow.addEventListener('resize', this.onWindowResize);
            if (!this.contentEl)
                return;
            if (window.ResizeObserver) {
                // Hack for https://github.com/WICG/ResizeObserver/issues/38
                var resizeObserverStarted_1 = false;
                var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
                this.resizeObserver = new resizeObserver(function () {
                    if (!resizeObserverStarted_1)
                        return;
                    elWindow.requestAnimationFrame(function () {
                        _this.recalculate();
                    });
                });
                this.resizeObserver.observe(this.el);
                this.resizeObserver.observe(this.contentEl);
                elWindow.requestAnimationFrame(function () {
                    resizeObserverStarted_1 = true;
                });
            }
            // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
            this.mutationObserver = new elWindow.MutationObserver(function () {
                elWindow.requestAnimationFrame(function () {
                    _this.recalculate();
                });
            });
            this.mutationObserver.observe(this.contentEl, {
                childList: true,
                subtree: true,
                characterData: true
            });
        };
        SimpleBarCore.prototype.recalculate = function () {
            if (!this.heightAutoObserverEl ||
                !this.contentEl ||
                !this.contentWrapperEl ||
                !this.wrapperEl ||
                !this.placeholderEl)
                return;
            var elWindow = getElementWindow(this.el);
            this.elStyles = elWindow.getComputedStyle(this.el);
            this.isRtl = this.elStyles.direction === 'rtl';
            var contentElOffsetWidth = this.contentEl.offsetWidth;
            var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
            var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
            var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
            var elOverflowX = this.elStyles.overflowX;
            var elOverflowY = this.elStyles.overflowY;
            this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
            this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
            var contentElScrollHeight = this.contentEl.scrollHeight;
            var contentElScrollWidth = this.contentEl.scrollWidth;
            this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%';
            // Determine placeholder size
            this.placeholderEl.style.width = isWidthAuto
                ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px")
                : 'auto';
            this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
            var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
            this.axis.x.isOverflowing =
                contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
            this.axis.y.isOverflowing =
                contentElScrollHeight > contentWrapperElOffsetHeight;
            // Set isOverflowing to false if user explicitely set hidden overflow
            this.axis.x.isOverflowing =
                elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
            this.axis.y.isOverflowing =
                elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
            this.axis.x.forceVisible =
                this.options.forceVisible === 'x' || this.options.forceVisible === true;
            this.axis.y.forceVisible =
                this.options.forceVisible === 'y' || this.options.forceVisible === true;
            this.hideNativeScrollbar();
            // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
            var offsetForXScrollbar = this.axis.x.isOverflowing
                ? this.scrollbarWidth
                : 0;
            var offsetForYScrollbar = this.axis.y.isOverflowing
                ? this.scrollbarWidth
                : 0;
            this.axis.x.isOverflowing =
                this.axis.x.isOverflowing &&
                    contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
            this.axis.y.isOverflowing =
                this.axis.y.isOverflowing &&
                    contentElScrollHeight >
                        contentWrapperElOffsetHeight - offsetForXScrollbar;
            this.axis.x.scrollbar.size = this.getScrollbarSize('x');
            this.axis.y.scrollbar.size = this.getScrollbarSize('y');
            if (this.axis.x.scrollbar.el)
                this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
            if (this.axis.y.scrollbar.el)
                this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
            this.positionScrollbar('x');
            this.positionScrollbar('y');
            this.toggleTrackVisibility('x');
            this.toggleTrackVisibility('y');
        };
        /**
         * Calculate scrollbar size
         */
        SimpleBarCore.prototype.getScrollbarSize = function (axis) {
            var _a, _b;
            if (axis === void 0) { axis = 'y'; }
            if (!this.axis[axis].isOverflowing || !this.contentEl) {
                return 0;
            }
            var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
            var trackSize = (_b = (_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
            var scrollbarRatio = trackSize / contentSize;
            var scrollbarSize;
            // Calculate new height/position of drag handle.
            scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
            if (this.options.scrollbarMaxSize) {
                scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
            }
            return scrollbarSize;
        };
        SimpleBarCore.prototype.positionScrollbar = function (axis) {
            var _a, _b, _c;
            if (axis === void 0) { axis = 'y'; }
            var scrollbar = this.axis[axis].scrollbar;
            if (!this.axis[axis].isOverflowing ||
                !this.contentWrapperEl ||
                !scrollbar.el ||
                !this.elStyles) {
                return;
            }
            var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
            var trackSize = ((_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) || 0;
            var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
            var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
            scrollOffset =
                axis === 'x' &&
                    this.isRtl &&
                    ((_b = SimpleBarCore.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero)
                    ? -scrollOffset
                    : scrollOffset;
            if (axis === 'x' && this.isRtl) {
                scrollOffset = ((_c = SimpleBarCore.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative)
                    ? scrollOffset
                    : -scrollOffset;
            }
            var scrollPourcent = scrollOffset / (contentSize - hostSize);
            var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
            handleOffset =
                axis === 'x' && this.isRtl
                    ? -handleOffset + (trackSize - scrollbar.size)
                    : handleOffset;
            scrollbar.el.style.transform =
                axis === 'x'
                    ? "translate3d(".concat(handleOffset, "px, 0, 0)")
                    : "translate3d(0, ".concat(handleOffset, "px, 0)");
        };
        SimpleBarCore.prototype.toggleTrackVisibility = function (axis) {
            if (axis === void 0) { axis = 'y'; }
            var track = this.axis[axis].track.el;
            var scrollbar = this.axis[axis].scrollbar.el;
            if (!track || !scrollbar || !this.contentWrapperEl)
                return;
            if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
                track.style.visibility = 'visible';
                this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
                this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
            }
            else {
                track.style.visibility = 'hidden';
                this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
                this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
            }
            // Even if forceVisible is enabled, scrollbar itself should be hidden
            if (this.axis[axis].isOverflowing) {
                scrollbar.style.display = 'block';
            }
            else {
                scrollbar.style.display = 'none';
            }
        };
        SimpleBarCore.prototype.showScrollbar = function (axis) {
            if (axis === void 0) { axis = 'y'; }
            if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
                addClasses$2(this.axis[axis].scrollbar.el, this.classNames.visible);
                this.axis[axis].scrollbar.isVisible = true;
            }
        };
        SimpleBarCore.prototype.hideScrollbar = function (axis) {
            if (axis === void 0) { axis = 'y'; }
            if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
                removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
                this.axis[axis].scrollbar.isVisible = false;
            }
        };
        SimpleBarCore.prototype.hideNativeScrollbar = function () {
            if (!this.offsetEl)
                return;
            this.offsetEl.style[this.isRtl ? 'left' : 'right'] =
                this.axis.y.isOverflowing || this.axis.y.forceVisible
                    ? "-".concat(this.scrollbarWidth, "px")
                    : '0px';
            this.offsetEl.style.bottom =
                this.axis.x.isOverflowing || this.axis.x.forceVisible
                    ? "-".concat(this.scrollbarWidth, "px")
                    : '0px';
        };
        SimpleBarCore.prototype.onMouseMoveForAxis = function (axis) {
            if (axis === void 0) { axis = 'y'; }
            var currentAxis = this.axis[axis];
            if (!currentAxis.track.el || !currentAxis.scrollbar.el)
                return;
            currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
            currentAxis.scrollbar.rect =
                currentAxis.scrollbar.el.getBoundingClientRect();
            if (this.isWithinBounds(currentAxis.track.rect)) {
                this.showScrollbar(axis);
                addClasses$2(currentAxis.track.el, this.classNames.hover);
                if (this.isWithinBounds(currentAxis.scrollbar.rect)) {
                    addClasses$2(currentAxis.scrollbar.el, this.classNames.hover);
                }
                else {
                    removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
                }
            }
            else {
                removeClasses(currentAxis.track.el, this.classNames.hover);
                if (this.options.autoHide) {
                    this.hideScrollbar(axis);
                }
            }
        };
        SimpleBarCore.prototype.onMouseLeaveForAxis = function (axis) {
            if (axis === void 0) { axis = 'y'; }
            removeClasses(this.axis[axis].track.el, this.classNames.hover);
            removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
            if (this.options.autoHide) {
                this.hideScrollbar(axis);
            }
        };
        /**
         * on scrollbar handle drag movement starts
         */
        SimpleBarCore.prototype.onDragStart = function (e, axis) {
            var _a;
            if (axis === void 0) { axis = 'y'; }
            var elDocument = getElementDocument(this.el);
            var elWindow = getElementWindow(this.el);
            var scrollbar = this.axis[axis].scrollbar;
            // Measure how far the user's mouse is from the top of the scrollbar drag handle.
            var eventOffset = axis === 'y' ? e.pageY : e.pageX;
            this.axis[axis].dragOffset =
                eventOffset - (((_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) || 0);
            this.draggedAxis = axis;
            addClasses$2(this.el, this.classNames.dragging);
            elDocument.addEventListener('mousemove', this.drag, true);
            elDocument.addEventListener('mouseup', this.onEndDrag, true);
            if (this.removePreventClickId === null) {
                elDocument.addEventListener('click', this.preventClick, true);
                elDocument.addEventListener('dblclick', this.preventClick, true);
            }
            else {
                elWindow.clearTimeout(this.removePreventClickId);
                this.removePreventClickId = null;
            }
        };
        SimpleBarCore.prototype.onTrackClick = function (e, axis) {
            var _this = this;
            var _a, _b, _c, _d;
            if (axis === void 0) { axis = 'y'; }
            var currentAxis = this.axis[axis];
            if (!this.options.clickOnTrack ||
                !currentAxis.scrollbar.el ||
                !this.contentWrapperEl)
                return;
            // Preventing the event's default to trigger click underneath
            e.preventDefault();
            var elWindow = getElementWindow(this.el);
            this.axis[axis].scrollbar.rect =
                currentAxis.scrollbar.el.getBoundingClientRect();
            var scrollbar = this.axis[axis].scrollbar;
            var scrollbarOffset = (_b = (_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
            var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : '0px', 10);
            var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
            var t = axis === 'y'
                ? this.mouseY - scrollbarOffset
                : this.mouseX - scrollbarOffset;
            var dir = t < 0 ? -1 : 1;
            var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
            var speed = 40;
            var scrollTo = function () {
                if (!_this.contentWrapperEl)
                    return;
                if (dir === -1) {
                    if (scrolled > scrollSize) {
                        scrolled -= speed;
                        _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                        elWindow.requestAnimationFrame(scrollTo);
                    }
                }
                else {
                    if (scrolled < scrollSize) {
                        scrolled += speed;
                        _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                        elWindow.requestAnimationFrame(scrollTo);
                    }
                }
            };
            scrollTo();
        };
        /**
         * Getter for content element
         */
        SimpleBarCore.prototype.getContentElement = function () {
            return this.contentEl;
        };
        /**
         * Getter for original scrolling element
         */
        SimpleBarCore.prototype.getScrollElement = function () {
            return this.contentWrapperEl;
        };
        SimpleBarCore.prototype.removeListeners = function () {
            var elWindow = getElementWindow(this.el);
            // Event listeners
            this.el.removeEventListener('mouseenter', this.onMouseEnter);
            this.el.removeEventListener('pointerdown', this.onPointerEvent, true);
            this.el.removeEventListener('mousemove', this.onMouseMove);
            this.el.removeEventListener('mouseleave', this.onMouseLeave);
            if (this.contentWrapperEl) {
                this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
            }
            elWindow.removeEventListener('resize', this.onWindowResize);
            if (this.mutationObserver) {
                this.mutationObserver.disconnect();
            }
            if (this.resizeObserver) {
                this.resizeObserver.disconnect();
            }
            // Cancel all debounced functions
            this.onMouseMove.cancel();
            this.onWindowResize.cancel();
            this.onStopScrolling.cancel();
            this.onMouseEntered.cancel();
        };
        /**
         * Remove all listeners from DOM nodes
         */
        SimpleBarCore.prototype.unMount = function () {
            this.removeListeners();
        };
        /**
         * Check if mouse is within bounds
         */
        SimpleBarCore.prototype.isWithinBounds = function (bbox) {
            return (this.mouseX >= bbox.left &&
                this.mouseX <= bbox.left + bbox.width &&
                this.mouseY >= bbox.top &&
                this.mouseY <= bbox.top + bbox.height);
        };
        /**
         * Find element children matches query
         */
        SimpleBarCore.prototype.findChild = function (el, query) {
            var matches = el.matches ||
                el.webkitMatchesSelector ||
                el.mozMatchesSelector ||
                el.msMatchesSelector;
            return Array.prototype.filter.call(el.children, function (child) {
                return matches.call(child, query);
            })[0];
        };
        SimpleBarCore.rtlHelpers = null;
        SimpleBarCore.defaultOptions = {
            forceVisible: false,
            clickOnTrack: true,
            scrollbarMinSize: 25,
            scrollbarMaxSize: 0,
            ariaLabel: 'scrollable content',
            classNames: {
                contentEl: 'simplebar-content',
                contentWrapper: 'simplebar-content-wrapper',
                offset: 'simplebar-offset',
                mask: 'simplebar-mask',
                wrapper: 'simplebar-wrapper',
                placeholder: 'simplebar-placeholder',
                scrollbar: 'simplebar-scrollbar',
                track: 'simplebar-track',
                heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
                heightAutoObserverEl: 'simplebar-height-auto-observer',
                visible: 'simplebar-visible',
                horizontal: 'simplebar-horizontal',
                vertical: 'simplebar-vertical',
                hover: 'simplebar-hover',
                dragging: 'simplebar-dragging',
                scrolling: 'simplebar-scrolling',
                scrollable: 'simplebar-scrollable',
                mouseEntered: 'simplebar-mouse-entered'
            },
            scrollableNode: null,
            contentNode: null,
            autoHide: true
        };
        /**
         * Static functions
         */
        SimpleBarCore.getOptions = getOptions$2;
        SimpleBarCore.helpers = helpers;
        return SimpleBarCore;
    }());

    var _a = SimpleBarCore.helpers, getOptions = _a.getOptions, addClasses = _a.addClasses;
    var SimpleBar = /** @class */ (function (_super) {
        __extends(SimpleBar, _super);
        function SimpleBar() {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var _this = _super.apply(this, args) || this;
            // // Save a reference to the instance, so we know this DOM node has already been instancied
            SimpleBar.instances.set(args[0], _this);
            return _this;
        }
        SimpleBar.initDOMLoadedElements = function () {
            document.removeEventListener('DOMContentLoaded', this.initDOMLoadedElements);
            window.removeEventListener('load', this.initDOMLoadedElements);
            Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]'), function (el) {
                if (el.getAttribute('data-simplebar') !== 'init' &&
                    !SimpleBar.instances.has(el))
                    new SimpleBar(el, getOptions(el.attributes));
            });
        };
        SimpleBar.removeObserver = function () {
            var _a;
            (_a = SimpleBar.globalObserver) === null || _a === void 0 ? void 0 : _a.disconnect();
        };
        SimpleBar.prototype.initDOM = function () {
            var _this = this;
            var _a, _b, _c;
            // make sure this element doesn't have the elements yet
            if (!Array.prototype.filter.call(this.el.children, function (child) {
                return child.classList.contains(_this.classNames.wrapper);
            }).length) {
                // Prepare DOM
                this.wrapperEl = document.createElement('div');
                this.contentWrapperEl = document.createElement('div');
                this.offsetEl = document.createElement('div');
                this.maskEl = document.createElement('div');
                this.contentEl = document.createElement('div');
                this.placeholderEl = document.createElement('div');
                this.heightAutoObserverWrapperEl = document.createElement('div');
                this.heightAutoObserverEl = document.createElement('div');
                addClasses(this.wrapperEl, this.classNames.wrapper);
                addClasses(this.contentWrapperEl, this.classNames.contentWrapper);
                addClasses(this.offsetEl, this.classNames.offset);
                addClasses(this.maskEl, this.classNames.mask);
                addClasses(this.contentEl, this.classNames.contentEl);
                addClasses(this.placeholderEl, this.classNames.placeholder);
                addClasses(this.heightAutoObserverWrapperEl, this.classNames.heightAutoObserverWrapperEl);
                addClasses(this.heightAutoObserverEl, this.classNames.heightAutoObserverEl);
                while (this.el.firstChild) {
                    this.contentEl.appendChild(this.el.firstChild);
                }
                this.contentWrapperEl.appendChild(this.contentEl);
                this.offsetEl.appendChild(this.contentWrapperEl);
                this.maskEl.appendChild(this.offsetEl);
                this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
                this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
                this.wrapperEl.appendChild(this.maskEl);
                this.wrapperEl.appendChild(this.placeholderEl);
                this.el.appendChild(this.wrapperEl);
                (_a = this.contentWrapperEl) === null || _a === void 0 ? void 0 : _a.setAttribute('tabindex', '0');
                (_b = this.contentWrapperEl) === null || _b === void 0 ? void 0 : _b.setAttribute('role', 'region');
                (_c = this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c.setAttribute('aria-label', this.options.ariaLabel);
            }
            if (!this.axis.x.track.el || !this.axis.y.track.el) {
                var track = document.createElement('div');
                var scrollbar = document.createElement('div');
                addClasses(track, this.classNames.track);
                addClasses(scrollbar, this.classNames.scrollbar);
                track.appendChild(scrollbar);
                this.axis.x.track.el = track.cloneNode(true);
                addClasses(this.axis.x.track.el, this.classNames.horizontal);
                this.axis.y.track.el = track.cloneNode(true);
                addClasses(this.axis.y.track.el, this.classNames.vertical);
                this.el.appendChild(this.axis.x.track.el);
                this.el.appendChild(this.axis.y.track.el);
            }
            SimpleBarCore.prototype.initDOM.call(this);
            this.el.setAttribute('data-simplebar', 'init');
        };
        SimpleBar.prototype.unMount = function () {
            SimpleBarCore.prototype.unMount.call(this);
            SimpleBar.instances["delete"](this.el);
        };
        SimpleBar.initHtmlApi = function () {
            this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
            // MutationObserver is IE11+
            if (typeof MutationObserver !== 'undefined') {
                // Mutation observer to observe dynamically added elements
                this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
                this.globalObserver.observe(document, { childList: true, subtree: true });
            }
            // Taken from jQuery `ready` function
            // Instantiate elements already present on the page
            if (document.readyState === 'complete' || // @ts-ignore: IE specific
                (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
                // Handle it asynchronously to allow scripts the opportunity to delay init
                window.setTimeout(this.initDOMLoadedElements);
            }
            else {
                document.addEventListener('DOMContentLoaded', this.initDOMLoadedElements);
                window.addEventListener('load', this.initDOMLoadedElements);
            }
        };
        SimpleBar.handleMutations = function (mutations) {
            mutations.forEach(function (mutation) {
                mutation.addedNodes.forEach(function (addedNode) {
                    if (addedNode.nodeType === 1) {
                        if (addedNode.hasAttribute('data-simplebar')) {
                            !SimpleBar.instances.has(addedNode) &&
                                document.documentElement.contains(addedNode) &&
                                new SimpleBar(addedNode, getOptions(addedNode.attributes));
                        }
                        else {
                            addedNode
                                .querySelectorAll('[data-simplebar]')
                                .forEach(function (el) {
                                if (el.getAttribute('data-simplebar') !== 'init' &&
                                    !SimpleBar.instances.has(el) &&
                                    document.documentElement.contains(el))
                                    new SimpleBar(el, getOptions(el.attributes));
                            });
                        }
                    }
                });
                mutation.removedNodes.forEach(function (removedNode) {
                    if (removedNode.nodeType === 1) {
                        if (removedNode.getAttribute('data-simplebar') === 'init') {
                            SimpleBar.instances.has(removedNode) &&
                                !document.documentElement.contains(removedNode) &&
                                SimpleBar.instances.get(removedNode).unMount();
                        }
                        else {
                            Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function (el) {
                                SimpleBar.instances.has(el) &&
                                    !document.documentElement.contains(el) &&
                                    SimpleBar.instances.get(el).unMount();
                            });
                        }
                    }
                });
            });
        };
        SimpleBar.instances = new WeakMap();
        return SimpleBar;
    }(SimpleBarCore));
    /**
     * HTML API
     * Called only in a browser env.
     */
    if (canUseDom) {
        SimpleBar.initHtmlApi();
    }

    return SimpleBar;

})();

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{}],256:[function(require,module,exports){
(function (setImmediate,clearImmediate){(function (){
var nextTick = require('process/browser.js').nextTick;
var apply = Function.prototype.apply;
var slice = Array.prototype.slice;
var immediateIds = {};
var nextImmediateId = 0;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) { timeout.close(); };

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// That's not how node.js implements it but the exposed api is the same.
exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
  var id = nextImmediateId++;
  var args = arguments.length < 2 ? false : slice.call(arguments, 1);

  immediateIds[id] = true;

  nextTick(function onNextTick() {
    if (immediateIds[id]) {
      // fn.call() is faster so we optimize for the common use-case
      // @see http://jsperf.com/call-apply-segu
      if (args) {
        fn.apply(null, args);
      } else {
        fn.call(null);
      }
      // Prevent ids from leaking
      exports.clearImmediate(id);
    }
  });

  return id;
};

exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
  delete immediateIds[id];
};
}).call(this)}).call(this,require("timers").setImmediate,require("timers").clearImmediate)

},{"process/browser.js":216,"timers":256}],257:[function(require,module,exports){
var Vue // late bind
var version
var map = Object.create(null)
if (typeof window !== 'undefined') {
  window.__VUE_HOT_MAP__ = map
}
var installed = false
var isBrowserify = false
var initHookName = 'beforeCreate'

exports.install = function (vue, browserify) {
  if (installed) { return }
  installed = true

  Vue = vue.__esModule ? vue.default : vue
  version = Vue.version.split('.').map(Number)
  isBrowserify = browserify

  // compat with < 2.0.0-alpha.7
  if (Vue.config._lifecycleHooks.indexOf('init') > -1) {
    initHookName = 'init'
  }

  exports.compatible = version[0] >= 2
  if (!exports.compatible) {
    console.warn(
      '[HMR] You are using a version of vue-hot-reload-api that is ' +
        'only compatible with Vue.js core ^2.0.0.'
    )
    return
  }
}

/**
 * Create a record for a hot module, which keeps track of its constructor
 * and instances
 *
 * @param {String} id
 * @param {Object} options
 */

exports.createRecord = function (id, options) {
  if(map[id]) { return }

  var Ctor = null
  if (typeof options === 'function') {
    Ctor = options
    options = Ctor.options
  }
  makeOptionsHot(id, options)
  map[id] = {
    Ctor: Ctor,
    options: options,
    instances: []
  }
}

/**
 * Check if module is recorded
 *
 * @param {String} id
 */

exports.isRecorded = function (id) {
  return typeof map[id] !== 'undefined'
}

/**
 * Make a Component options object hot.
 *
 * @param {String} id
 * @param {Object} options
 */

function makeOptionsHot(id, options) {
  if (options.functional) {
    var render = options.render
    options.render = function (h, ctx) {
      var instances = map[id].instances
      if (ctx && instances.indexOf(ctx.parent) < 0) {
        instances.push(ctx.parent)
      }
      return render(h, ctx)
    }
  } else {
    injectHook(options, initHookName, function() {
      var record = map[id]
      if (!record.Ctor) {
        record.Ctor = this.constructor
      }
      record.instances.push(this)
    })
    injectHook(options, 'beforeDestroy', function() {
      var instances = map[id].instances
      instances.splice(instances.indexOf(this), 1)
    })
  }
}

/**
 * Inject a hook to a hot reloadable component so that
 * we can keep track of it.
 *
 * @param {Object} options
 * @param {String} name
 * @param {Function} hook
 */

function injectHook(options, name, hook) {
  var existing = options[name]
  options[name] = existing
    ? Array.isArray(existing) ? existing.concat(hook) : [existing, hook]
    : [hook]
}

function tryWrap(fn) {
  return function (id, arg) {
    try {
      fn(id, arg)
    } catch (e) {
      console.error(e)
      console.warn(
        'Something went wrong during Vue component hot-reload. Full reload required.'
      )
    }
  }
}

function updateOptions (oldOptions, newOptions) {
  for (var key in oldOptions) {
    if (!(key in newOptions)) {
      delete oldOptions[key]
    }
  }
  for (var key$1 in newOptions) {
    oldOptions[key$1] = newOptions[key$1]
  }
}

exports.rerender = tryWrap(function (id, options) {
  var record = map[id]
  if (!options) {
    record.instances.slice().forEach(function (instance) {
      instance.$forceUpdate()
    })
    return
  }
  if (typeof options === 'function') {
    options = options.options
  }
  if (record.Ctor) {
    record.Ctor.options.render = options.render
    record.Ctor.options.staticRenderFns = options.staticRenderFns
    record.instances.slice().forEach(function (instance) {
      instance.$options.render = options.render
      instance.$options.staticRenderFns = options.staticRenderFns
      // reset static trees
      // pre 2.5, all static trees are cached together on the instance
      if (instance._staticTrees) {
        instance._staticTrees = []
      }
      // 2.5.0
      if (Array.isArray(record.Ctor.options.cached)) {
        record.Ctor.options.cached = []
      }
      // 2.5.3
      if (Array.isArray(instance.$options.cached)) {
        instance.$options.cached = []
      }

      // post 2.5.4: v-once trees are cached on instance._staticTrees.
      // Pure static trees are cached on the staticRenderFns array
      // (both already reset above)

      // 2.6: temporarily mark rendered scoped slots as unstable so that
      // child components can be forced to update
      var restore = patchScopedSlots(instance)
      instance.$forceUpdate()
      instance.$nextTick(restore)
    })
  } else {
    // functional or no instance created yet
    record.options.render = options.render
    record.options.staticRenderFns = options.staticRenderFns

    // handle functional component re-render
    if (record.options.functional) {
      // rerender with full options
      if (Object.keys(options).length > 2) {
        updateOptions(record.options, options)
      } else {
        // template-only rerender.
        // need to inject the style injection code for CSS modules
        // to work properly.
        var injectStyles = record.options._injectStyles
        if (injectStyles) {
          var render = options.render
          record.options.render = function (h, ctx) {
            injectStyles.call(ctx)
            return render(h, ctx)
          }
        }
      }
      record.options._Ctor = null
      // 2.5.3
      if (Array.isArray(record.options.cached)) {
        record.options.cached = []
      }
      record.instances.slice().forEach(function (instance) {
        instance.$forceUpdate()
      })
    }
  }
})

exports.reload = tryWrap(function (id, options) {
  var record = map[id]
  if (options) {
    if (typeof options === 'function') {
      options = options.options
    }
    makeOptionsHot(id, options)
    if (record.Ctor) {
      if (version[1] < 2) {
        // preserve pre 2.2 behavior for global mixin handling
        record.Ctor.extendOptions = options
      }
      var newCtor = record.Ctor.super.extend(options)
      // prevent record.options._Ctor from being overwritten accidentally
      newCtor.options._Ctor = record.options._Ctor
      record.Ctor.options = newCtor.options
      record.Ctor.cid = newCtor.cid
      record.Ctor.prototype = newCtor.prototype
      if (newCtor.release) {
        // temporary global mixin strategy used in < 2.0.0-alpha.6
        newCtor.release()
      }
    } else {
      updateOptions(record.options, options)
    }
  }
  record.instances.slice().forEach(function (instance) {
    if (instance.$vnode && instance.$vnode.context) {
      instance.$vnode.context.$forceUpdate()
    } else {
      console.warn(
        'Root or manually mounted instance modified. Full reload required.'
      )
    }
  })
})

// 2.6 optimizes template-compiled scoped slots and skips updates if child
// only uses scoped slots. We need to patch the scoped slots resolving helper
// to temporarily mark all scoped slots as unstable in order to force child
// updates.
function patchScopedSlots (instance) {
  if (!instance._u) { return }
  // https://github.com/vuejs/vue/blob/dev/src/core/instance/render-helpers/resolve-scoped-slots.js
  var original = instance._u
  instance._u = function (slots) {
    try {
      // 2.6.4 ~ 2.6.6
      return original(slots, true)
    } catch (e) {
      // 2.5 / >= 2.6.7
      return original(slots, null, true)
    }
  }
  return function () {
    instance._u = original
  }
}

},{}],258:[function(require,module,exports){
(function(e,t){"object"===typeof exports&&"object"===typeof module?module.exports=t():"function"===typeof define&&define.amd?define([],t):"object"===typeof exports?exports["vue-input-facade"]=t():e["vue-input-facade"]=t()})("undefined"!==typeof self?self:this,(function(){return function(e){var t={};function n(o){if(t[o])return t[o].exports;var i=t[o]={i:o,l:!1,exports:{}};return e[o].call(i.exports,i,i.exports,n),i.l=!0,i.exports}return n.m=e,n.c=t,n.d=function(e,t,o){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o})},n.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(n.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)n.d(o,i,function(t){return e[t]}.bind(null,i));return o},n.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s="fb15")}({fb15:function(e,t,n){"use strict";if(n.r(t),n.d(t,"InputFacade",(function(){return j})),n.d(t,"facade",(function(){return _})),n.d(t,"tokens",(function(){return a})),n.d(t,"masker",(function(){return b})),n.d(t,"filter",(function(){return T})),"undefined"!==typeof window){var o=window.document.currentScript,i=o&&o.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);i&&(n.p=i[1])}var a={"#":{pattern:/\d/},X:{pattern:/[0-9a-z]/i},S:{pattern:/[a-z]/i},A:{pattern:/[a-z]/i,transform:e=>e.toLocaleUpperCase()},a:{pattern:/[a-z]/i,transform:e=>e.toLocaleLowerCase()},"\\":{escape:!0},"?":{optional:!0},"*":{repeat:!0},"|":{pipe:!0}};const r="__input-facade__";function s(e){this.masked=this.unmasked=e||""}function u(){return new CustomEvent("input",{bubbles:!0,cancelable:!0,detail:{facade:!0}})}function l(e,t){return(Array.isArray(e)||"string"===typeof e)&&(e={mask:e}),Object.assign(e||{},t)}function d(e){const t=e instanceof HTMLInputElement?e:e.querySelector("input");if(!t)throw new Error("facade directive requires an input element");return t}function c(e,t){const{target:n,detail:o,inputType:i}=e;if(null!==o&&void 0!==o&&o.facade)return!1;if(e.stopPropagation(),["insertCompositionText","insertFromComposition"].includes(i)&&t[r].config.mask)return!1;const a=n.value,s=n.selectionEnd,{oldValue:l}=n[r];p(n,null,{emit:!1},e),f(e,a,s),l!==n.value&&n.dispatchEvent(u())}function f(e,t,n){const{target:o}=e,i=["text","tel","search",null].includes(o.getAttribute("type")),a=o[r]&&o[r].config;if(o!==document.activeElement||!i||!a.mask&&!a.masked)return;const s=e.inputType||"insertText",u=["insertText","insertFromPaste"].includes(s),l=u&&n==t.length;let d=u&&t[n-1];const c=o.value.toLocaleLowerCase();let f=n;if(l)f=c.length;else if(d){d=d.toLocaleLowerCase();let e=f;while(e<=c.length&&c.charAt(e-1)!==d)e++;f=e<=c.length?e:f-1}o.setSelectionRange(f,f),setTimeout((function(){o.setSelectionRange(f,f)}),0)}function p(e,t,{emit:n=!0,force:o=!1}={},i){var a,s;let{config:l,oldValue:d,isComposing:c}=e[r],f=(null===t||void 0===t||null===(a=t.data)||void 0===a||null===(s=a.model)||void 0===s?void 0:s.value)||e.value;if((!l.mask||!c)&&(d=d||"",f=f||"",o||d!==f)){["deleteByCut","deleteContent","deleteContentBackward","deleteContentForward"].includes(null===i||void 0===i?void 0:i.inputType)&&(l={...l,short:!0});let t=b(f,l);if(i&&"function"===typeof l.formatter){const n=l.formatter(t,i);if("string"===typeof n)t=b(n,l);else if(!1===n)return void(e.value=d)}e[r].oldValue=t.masked,e.unmaskedValue=t.unmasked,e.value!==t.masked&&(e.value=t.masked),n&&e.dispatchEvent(u())}}let m=a,v=!1;try{"a".localeCompare("b","i")}catch(I){v="RangeError"===I.name}function h(e){e&&(m=e)}function k(e,t){const n=t.masks.slice().sort((e,t)=>e.length-t.length),o=e=>Object.assign({},t,e),i=(t,n)=>{const i=g(e,o({mask:n})),a=t.unmasked.length,r=i.unmasked.length;return r>a?i:t};if(!n.length)return new s;const a=n.shift();let r=g(e,o({mask:a}));while(n.length){const e=n.shift();r=i(r,e)}return r}function g(e,t){let{mask:n="",tokens:o,prefill:i=!1,short:a=!1}=t;o=o?Object.assign({},m,o):m;let r=new s,u=!1,l=0,d=0,c="";function f(e){const t=n[d+1],i=o[t];return{escape:!(null===e||void 0===e||!e.escape),optional:!(null===i||void 0===i||!i.optional),repeat:!(null===i||void 0===i||!i.repeat),...(null===i||void 0===i?void 0:i.pipe)&&{pipe:n.substring(d).match(/^(.\|)+./g)[0].split("|")}}}while(d<n.length){const t=n[d],i=o[t];let a=e[l];const s=f(i);if(!i||u||s.pipe)if(s.pipe){if(!a)break;const e=s.pipe.find(y.bind(null,a));e&&(r.unmasked+=e,r.masked+=c+e,d+=2*s.pipe.length-1,c=""),l++}else y(a,t)?(r.masked+=c+t,l++,c="",s.optional&&(r.unmasked+=t)):s.optional||(c+=t),u=!1,d+=s.optional?2:1;else{var p,v;if(s.escape){u=!0,d++;continue}if(!a)break;if(null!==(p=i.pattern)&&void 0!==p&&p.test(a))a=(null===(v=i.transform)||void 0===v?void 0:v.call(i,a))||a,r.unmasked+=a,r.masked+=c+a,c="",s.repeat||(d+=s.optional?2:1);else if(s.optional||s.repeat){d+=2;continue}l++}}return(i&&!r.unmasked||!a&&r.unmasked)&&(r.masked+=c),r}function y(e,t){return v?0===(null===e||void 0===e?void 0:e.localeCompare(t,void 0,{sensitivity:"base"})):(null===e||void 0===e?void 0:e.toLocaleLowerCase())===(null===t||void 0===t?void 0:t.toLocaleLowerCase())}function b(e,t){return e=(e||"").toString(),t=l(t),t.mask?Array.isArray(t.mask)?k(e,Object.assign({},t,{masks:t.mask})):g(e,t):new s(e)}const w=r;var _={bind:(e,{value:t,modifiers:n},o)=>{e=d(e);const i=l(t,n);e[w]={config:i},p(e,o,{force:i.prefill})},inserted:e=>{e=d(e);const t=e[w],n=e.parentElement||e,o=t=>{t.target===e&&c(t,e)},i=t=>{t.target===e&&("compositionend"===t.type?(e[w].isComposing=!1,c(t,e)):e[w].isComposing=!0)};n.addEventListener("input",o,!0),n.addEventListener("compositionstart",i,!0),n.addEventListener("compositionupdate",i,!0),n.addEventListener("compositionend",i,!0),t.cleanup=()=>{n.removeEventListener("input",o,!0),n.removeEventListener("compositionstart",i,!0),n.removeEventListener("compositionend",i,!0),n.removeEventListener("compositionupdate",i,!0)}},update:(e,{value:t,oldValue:n,modifiers:o},i)=>{e=d(e),t!==n?(e[w].config=l(t,o),p(e,i,{force:!0})):p(e,i)},unbind:e=>{d(e)[w].cleanup()}},C=function(){var e=this,t=e.$createElement,n=e._self._c||t;return n("input",{directives:[{name:"facade",rawName:"v-facade",value:e.config,expression:"config"}],attrs:{type:"text"},domProps:{value:e.maskedValue},on:{input:e.onInput,change:e.onChange,blur:function(t){return e.$emit("blur")},focus:function(t){return e.$emit("focus")},keyup:function(t){return e.$emit("keyup",t)},keydown:function(t){return e.$emit("keydown",t)}}})},V=[],E={name:"InputFacade",props:{formatter:Function,lazy:{type:Boolean,default:!1},mask:[String,Array],masked:{type:Boolean,default:!1},prefill:{type:Boolean,default:!1},short:{type:Boolean,default:!1},tokens:Object,value:[String,Number]},directives:{facade:_},data(){return{maskedValue:this.value,unmaskedValue:null}},watch:{value(e){e!==this.emittedValue&&(this.maskedValue=e)},mask(e){e||this.masked||(this.maskedValue=this.unmaskedValue)},masked(){this.emitInput()}},computed:{config(){return{mask:this.mask,masked:this.masked,tokens:this.tokens,formatter:this.formatter,prefill:this.prefill,short:this.short}},emittedValue(){return this.mask&&this.masked?this.maskedValue:this.unmaskedValue}},methods:{onInput({target:e}){this.maskedValue=e.value,this.unmaskedValue=e.unmaskedValue,this.lazy||this.emitInput()},onChange(){this.$emit("change",this.emittedValue),this.lazy&&this.emitInput()},emitInput(){this.$emit("input",this.emittedValue)}}},L=E;function x(e,t,n,o,i,a,r,s){var u,l="function"===typeof e?e.options:e;if(t&&(l.render=t,l.staticRenderFns=n,l._compiled=!0),o&&(l.functional=!0),a&&(l._scopeId="data-v-"+a),r?(u=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"===typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),i&&i.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(r)},l._ssrRegister=u):i&&(u=s?function(){i.call(this,(l.functional?this.parent:this).$root.$options.shadowRoot)}:i),u)if(l.functional){l._injectStyles=u;var d=l.render;l.render=function(e,t){return u.call(t),d(e,t)}}else{var c=l.beforeCreate;l.beforeCreate=c?[].concat(c,u):[u]}return{exports:e,options:l}}var S=x(L,C,V,!1,null,null,null),j=S.exports;function O(e,t={}){t.tokens&&h(t.tokens),e.component(j.name,j),e.directive(t.name||"facade",_),e.filter(t.name||"facade",T)}function T(e,t){return b(e,t).masked}var $=O;"undefined"!==typeof window&&window.Vue&&window.Vue.use(O);t["default"]=$}})}));
},{}],259:[function(require,module,exports){
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.VueRecaptcha = factory());
}(this, (function () { 'use strict';

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  var defer = function defer() {
    var state = false; // Resolved or not

    var callbacks = [];

    var resolve = function resolve(val) {
      if (state) {
        return;
      }

      state = true;

      for (var i = 0, len = callbacks.length; i < len; i++) {
        callbacks[i](val);
      }
    };

    var then = function then(cb) {
      if (!state) {
        callbacks.push(cb);
        return;
      }

      cb();
    };

    var deferred = {
      resolved: function resolved() {
        return state;
      },
      resolve: resolve,
      promise: {
        then: then
      }
    };
    return deferred;
  };

  var ownProp = Object.prototype.hasOwnProperty;
  function createRecaptcha() {
    var deferred = defer();
    return {
      notify: function notify() {
        deferred.resolve();
      },
      wait: function wait() {
        return deferred.promise;
      },
      render: function render(ele, options, cb) {
        this.wait().then(function () {
          cb(window.grecaptcha.render(ele, options));
        });
      },
      reset: function reset(widgetId) {
        if (typeof widgetId === 'undefined') {
          return;
        }

        this.assertLoaded();
        this.wait().then(function () {
          return window.grecaptcha.reset(widgetId);
        });
      },
      execute: function execute(widgetId) {
        if (typeof widgetId === 'undefined') {
          return;
        }

        this.assertLoaded();
        this.wait().then(function () {
          return window.grecaptcha.execute(widgetId);
        });
      },
      checkRecaptchaLoad: function checkRecaptchaLoad() {
        if (ownProp.call(window, 'grecaptcha') && ownProp.call(window.grecaptcha, 'render')) {
          this.notify();
        }
      },
      assertLoaded: function assertLoaded() {
        if (!deferred.resolved()) {
          throw new Error('ReCAPTCHA has not been loaded');
        }
      }
    };
  }
  var recaptcha = createRecaptcha();

  if (typeof window !== 'undefined') {
    window.vueRecaptchaApiLoaded = recaptcha.notify;
  }

  var VueRecaptcha = {
    name: 'VueRecaptcha',
    props: {
      sitekey: {
        type: String,
        required: true
      },
      theme: {
        type: String
      },
      badge: {
        type: String
      },
      type: {
        type: String
      },
      size: {
        type: String
      },
      tabindex: {
        type: String
      },
      loadRecaptchaScript: {
        type: Boolean,
        "default": false
      },
      recaptchaScriptId: {
        type: String,
        "default": '__RECAPTCHA_SCRIPT'
      },
      recaptchaHost: {
        type: String,
        "default": 'www.google.com'
      },
      language: {
        type: String,
        "default": ''
      }
    },
    beforeMount: function beforeMount() {
      if (this.loadRecaptchaScript) {
        if (!document.getElementById(this.recaptchaScriptId)) {
          // Note: vueRecaptchaApiLoaded load callback name is per the latest documentation
          var script = document.createElement('script');
          script.id = this.recaptchaScriptId;
          script.src = "https://" + this.recaptchaHost + "/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit&hl=" + this.language;
          script.async = true;
          script.defer = true;
          document.head.appendChild(script);
        }
      }
    },
    mounted: function mounted() {
      var _this = this;

      recaptcha.checkRecaptchaLoad();

      var opts = _extends({}, this.$props, {
        callback: this.emitVerify,
        'expired-callback': this.emitExpired,
        'error-callback': this.emitError
      });

      var container = this.$slots["default"] ? this.$el.children[0] : this.$el;
      recaptcha.render(container, opts, function (id) {
        _this.$widgetId = id;

        _this.$emit('render', id);
      });
    },
    methods: {
      reset: function reset() {
        recaptcha.reset(this.$widgetId);
      },
      execute: function execute() {
        recaptcha.execute(this.$widgetId);
      },
      emitVerify: function emitVerify(response) {
        this.$emit('verify', response);
      },
      emitExpired: function emitExpired() {
        this.$emit('expired');
      },
      emitError: function emitError() {
        this.$emit('error');
      }
    },
    render: function render(h) {
      return h('div', {}, this.$slots["default"]);
    }
  };

  return VueRecaptcha;

})));

},{}],260:[function(require,module,exports){
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-slick-carousel"] = factory();
	else
		root["vue-slick-carousel"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "00ee":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ "0366":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "0497":
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ "057f":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyNames = __webpack_require__("241c").f;

var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return nativeGetOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]'
    ? getWindowNames(it)
    : nativeGetOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ "06cf":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createPropertyDescriptor = __webpack_require__("5c6c");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var has = __webpack_require__("5135");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),

/***/ "07ac":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var $values = __webpack_require__("6f53").values;

// `Object.values` method
// https://tc39.github.io/ecma262/#sec-object.values
$({ target: 'Object', stat: true }, {
  values: function values(O) {
    return $values(O);
  }
});


/***/ }),

/***/ "0cfb":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var createElement = __webpack_require__("cc12");

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),

/***/ "1276":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var isRegExp = __webpack_require__("44e7");
var anObject = __webpack_require__("825a");
var requireObjectCoercible = __webpack_require__("1d80");
var speciesConstructor = __webpack_require__("4840");
var advanceStringIndex = __webpack_require__("8aa5");
var toLength = __webpack_require__("50c4");
var callRegExpExec = __webpack_require__("14c3");
var regexpExec = __webpack_require__("9263");
var fails = __webpack_require__("d039");

var arrayPush = [].push;
var min = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { return !RegExp(MAX_UINT32, 'y'); });

// @@split logic
fixRegExpWellKnownSymbolLogic('split', 2, function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SUPPORTS_Y);


/***/ }),

/***/ "13d5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $reduce = __webpack_require__("d58f").left;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('reduce');
var USES_TO_LENGTH = arrayMethodUsesToLength('reduce', { 1: 0 });

// `Array.prototype.reduce` method
// https://tc39.github.io/ecma262/#sec-array.prototype.reduce
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "14c3":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");
var regexpExec = __webpack_require__("9263");

// `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classof(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};



/***/ }),

/***/ "159b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var forEach = __webpack_require__("17c2");
var createNonEnumerableProperty = __webpack_require__("9112");

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
}


/***/ }),

/***/ "17c2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $forEach = __webpack_require__("b727").forEach;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('forEach');
var USES_TO_LENGTH = arrayMethodUsesToLength('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
module.exports = (!STRICT_METHOD || !USES_TO_LENGTH) ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
} : [].forEach;


/***/ }),

/***/ "1be4":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ "1c0b":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),

/***/ "1c7e":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ "1d80":
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ "1dde":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ "217d":
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ "23cb":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ "23e7":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var setGlobal = __webpack_require__("ce4e");
var copyConstructorProperties = __webpack_require__("e893");
var isForced = __webpack_require__("94ca");

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ "241c":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ "25f0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefine = __webpack_require__("6eeb");
var anObject = __webpack_require__("825a");
var fails = __webpack_require__("d039");
var flags = __webpack_require__("ad6d");

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype) ? flags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}


/***/ }),

/***/ "2d00":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var userAgent = __webpack_require__("342f");

var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] + match[1];
} else if (userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

module.exports = version && +version;


/***/ }),

/***/ "342f":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");

module.exports = getBuiltIn('navigator', 'userAgent') || '';


/***/ }),

/***/ "35a1":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("f5df");
var Iterators = __webpack_require__("3f8c");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "37e8":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var anObject = __webpack_require__("825a");
var objectKeys = __webpack_require__("df75");

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),

/***/ "3b81":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3bbe":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),

/***/ "3ca3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "3f8c":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4160":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var forEach = __webpack_require__("17c2");

// `Array.prototype.forEach` method
// https://tc39.github.io/ecma262/#sec-array.prototype.foreach
$({ target: 'Array', proto: true, forced: [].forEach != forEach }, {
  forEach: forEach
});


/***/ }),

/***/ "428f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");

module.exports = global;


/***/ }),

/***/ "42a0":
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (nonEnumShadows || isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = assign;


/***/ }),

/***/ "44ad":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");
var classof = __webpack_require__("c6b6");

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),

/***/ "44d2":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var create = __webpack_require__("7c73");
var definePropertyModule = __webpack_require__("9bf2");

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "44e7":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var classof = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.github.io/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) == 'RegExp');
};


/***/ }),

/***/ "466d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fixRegExpWellKnownSymbolLogic = __webpack_require__("d784");
var anObject = __webpack_require__("825a");
var toLength = __webpack_require__("50c4");
var requireObjectCoercible = __webpack_require__("1d80");
var advanceStringIndex = __webpack_require__("8aa5");
var regExpExec = __webpack_require__("14c3");

// @@match logic
fixRegExpWellKnownSymbolLogic('match', 1, function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = regexp == undefined ? undefined : regexp[MATCH];
      return matcher !== undefined ? matcher.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative(nativeMatch, regexp, this);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4840":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aFunction = __webpack_require__("1c0b");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.github.io/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? defaultConstructor : aFunction(S);
};


/***/ }),

/***/ "4930":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),

/***/ "4d64":
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__("fc6a");
var toLength = __webpack_require__("50c4");
var toAbsoluteIndex = __webpack_require__("23cb");

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ "4de4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $filter = __webpack_require__("b727").filter;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');
// Edge 14- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('filter');

// `Array.prototype.filter` method
// https://tc39.github.io/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "4df4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__("0366");
var toObject = __webpack_require__("7b0b");
var callWithSafeIterationClosing = __webpack_require__("9bdd");
var isArrayIteratorMethod = __webpack_require__("e95a");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var getIteratorMethod = __webpack_require__("35a1");

// `Array.from` method implementation
// https://tc39.github.io/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ "50c4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ "5135":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "5692":
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__("c430");
var store = __webpack_require__("c6cd");

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "56ef":
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__("d066");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var anObject = __webpack_require__("825a");

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ "5899":
/***/ (function(module, exports) {

// a string of all valid unicode whitespaces
// eslint-disable-next-line max-len
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ "58a8":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");
var whitespaces = __webpack_require__("5899");

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.github.io/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ "5c6c":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "60da":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var objectKeys = __webpack_require__("df75");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");

var nativeAssign = Object.assign;
var defineProperty = Object.defineProperty;

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
module.exports = !nativeAssign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (DESCRIPTORS && nativeAssign({ b: 1 }, nativeAssign(defineProperty({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return nativeAssign({}, A)[symbol] != 7 || objectKeys(nativeAssign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  var propertyIsEnumerable = propertyIsEnumerableModule.f;
  while (argumentsLength > index) {
    var S = IndexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : nativeAssign;


/***/ }),

/***/ "6547":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("a691");
var requireObjectCoercible = __webpack_require__("1d80");

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ "65f0":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var wellKnownSymbol = __webpack_require__("b622");

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.github.io/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};


/***/ }),

/***/ "69f3":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__("7f9a");
var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");
var createNonEnumerableProperty = __webpack_require__("9112");
var objectHas = __webpack_require__("5135");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ "6dd8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["a"] = (index);

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "6ea2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("890c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderTrack_vue_vue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6eeb":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var setGlobal = __webpack_require__("ce4e");
var inspectSource = __webpack_require__("8925");
var InternalStateModule = __webpack_require__("69f3");

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),

/***/ "6f53":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var objectKeys = __webpack_require__("df75");
var toIndexedObject = __webpack_require__("fc6a");
var propertyIsEnumerable = __webpack_require__("d1e7").f;

// `Object.{ entries, values }` methods implementation
var createMethod = function (TO_ENTRIES) {
  return function (it) {
    var O = toIndexedObject(it);
    var keys = objectKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || propertyIsEnumerable.call(O, key)) {
        result.push(TO_ENTRIES ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};

module.exports = {
  // `Object.entries` method
  // https://tc39.github.io/ecma262/#sec-object.entries
  entries: createMethod(true),
  // `Object.values` method
  // https://tc39.github.io/ecma262/#sec-object.values
  values: createMethod(false)
};


/***/ }),

/***/ "7156":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");
var setPrototypeOf = __webpack_require__("d2bb");

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ "7418":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "746f":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var has = __webpack_require__("5135");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineProperty = __webpack_require__("9bf2").f;

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ "7839":
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ "7b0b":
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__("1d80");

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ "7c73":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var defineProperties = __webpack_require__("37e8");
var enumBugKeys = __webpack_require__("7839");
var hiddenKeys = __webpack_require__("d012");
var html = __webpack_require__("1be4");
var documentCreateElement = __webpack_require__("cc12");
var sharedKey = __webpack_require__("f772");

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),

/***/ "7dd0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var createIteratorConstructor = __webpack_require__("9ed3");
var getPrototypeOf = __webpack_require__("e163");
var setPrototypeOf = __webpack_require__("d2bb");
var setToStringTag = __webpack_require__("d44e");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");
var Iterators = __webpack_require__("3f8c");
var IteratorsCore = __webpack_require__("ae93");

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),

/***/ "7f9a":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var inspectSource = __webpack_require__("8925");

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),

/***/ "825a":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),

/***/ "83ab":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),

/***/ "8418":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__("c04e");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ "861d":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "88bc":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, props) {
  object = Object(object);
  return basePickBy(object, props, function(value, key) {
    return key in object;
  });
}

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} props The property identifiers to pick from.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, props, predicate) {
  var index = -1,
      length = props.length,
      result = {};

  while (++index < length) {
    var key = props[index],
        value = object[key];

    if (predicate(value, key)) {
      result[key] = value;
    }
  }
  return result;
}

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = array;
    return apply(func, this, otherArgs);
  };
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [props] The property identifiers to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = baseRest(function(object, props) {
  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
});

module.exports = pick;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "890c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8925":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("c6cd");

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ "8aa5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__("6547").charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ "8e95":
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__("c195");
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ "9020":
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ "90e3":
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),

/***/ "9112":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var definePropertyModule = __webpack_require__("9bf2");
var createPropertyDescriptor = __webpack_require__("5c6c");

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "9263":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpFlags = __webpack_require__("ad6d");
var stickyHelpers = __webpack_require__("9f7f");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y || stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "94ca":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ "99af":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var createProperty = __webpack_require__("8418");
var arraySpeciesCreate = __webpack_require__("65f0");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var wellKnownSymbol = __webpack_require__("b622");
var V8_VERSION = __webpack_require__("2d00");

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.github.io/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, forced: FORCED }, {
  concat: function concat(arg) { // eslint-disable-line no-unused-vars
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ "9bdd":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),

/***/ "9bf2":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var IE8_DOM_DEFINE = __webpack_require__("0cfb");
var anObject = __webpack_require__("825a");
var toPrimitive = __webpack_require__("c04e");

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9ed3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__("ae93").IteratorPrototype;
var create = __webpack_require__("7c73");
var createPropertyDescriptor = __webpack_require__("5c6c");
var setToStringTag = __webpack_require__("d44e");
var Iterators = __webpack_require__("3f8c");

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ "9f7f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var fails = __webpack_require__("d039");

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
// so we use an intermediate function.
function RE(s, f) {
  return RegExp(s, f);
}

exports.UNSUPPORTED_Y = fails(function () {
  // babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

exports.BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});


/***/ }),

/***/ "a15b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var IndexedObject = __webpack_require__("44ad");
var toIndexedObject = __webpack_require__("fc6a");
var arrayMethodIsStrict = __webpack_require__("a640");

var nativeJoin = [].join;

var ES3_STRINGS = IndexedObject != Object;
var STRICT_METHOD = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.github.io/ecma262/#sec-array.prototype.join
$({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),

/***/ "a48b":
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__("0497");

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ "a4d3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var global = __webpack_require__("da84");
var getBuiltIn = __webpack_require__("d066");
var IS_PURE = __webpack_require__("c430");
var DESCRIPTORS = __webpack_require__("83ab");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");
var isArray = __webpack_require__("e8b5");
var isObject = __webpack_require__("861d");
var anObject = __webpack_require__("825a");
var toObject = __webpack_require__("7b0b");
var toIndexedObject = __webpack_require__("fc6a");
var toPrimitive = __webpack_require__("c04e");
var createPropertyDescriptor = __webpack_require__("5c6c");
var nativeObjectCreate = __webpack_require__("7c73");
var objectKeys = __webpack_require__("df75");
var getOwnPropertyNamesModule = __webpack_require__("241c");
var getOwnPropertyNamesExternal = __webpack_require__("057f");
var getOwnPropertySymbolsModule = __webpack_require__("7418");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");
var propertyIsEnumerableModule = __webpack_require__("d1e7");
var createNonEnumerableProperty = __webpack_require__("9112");
var redefine = __webpack_require__("6eeb");
var shared = __webpack_require__("5692");
var sharedKey = __webpack_require__("f772");
var hiddenKeys = __webpack_require__("d012");
var uid = __webpack_require__("90e3");
var wellKnownSymbol = __webpack_require__("b622");
var wrappedWellKnownSymbolModule = __webpack_require__("e538");
var defineWellKnownSymbol = __webpack_require__("746f");
var setToStringTag = __webpack_require__("d44e");
var InternalStateModule = __webpack_require__("69f3");
var $forEach = __webpack_require__("b727").forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);
var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore = shared('wks');
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate($Symbol[PROTOTYPE]);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var isSymbol = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || $propertyIsEnumerable.call(properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.github.io/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return getInternalState(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      redefine(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  // `Symbol.for` method
  // https://tc39.github.io/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.github.io/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.github.io/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.github.io/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.github.io/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
$({ target: 'Object', stat: true, forced: fails(function () { getOwnPropertySymbolsModule.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return getOwnPropertySymbolsModule.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.github.io/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !NATIVE_SYMBOL || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  $({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.github.io/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ "a623":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $every = __webpack_require__("b727").every;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var STRICT_METHOD = arrayMethodIsStrict('every');
var USES_TO_LENGTH = arrayMethodUsesToLength('every');

// `Array.prototype.every` method
// https://tc39.github.io/ecma262/#sec-array.prototype.every
$({ target: 'Array', proto: true, forced: !STRICT_METHOD || !USES_TO_LENGTH }, {
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "a630":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var from = __webpack_require__("4df4");
var checkCorrectnessOfIteration = __webpack_require__("1c7e");

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.github.io/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ "a640":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__("d039");

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};


/***/ }),

/***/ "a691":
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),

/***/ "a9e3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var isForced = __webpack_require__("94ca");
var redefine = __webpack_require__("6eeb");
var has = __webpack_require__("5135");
var classof = __webpack_require__("c6b6");
var inheritIfRequired = __webpack_require__("7156");
var toPrimitive = __webpack_require__("c04e");
var fails = __webpack_require__("d039");
var create = __webpack_require__("7c73");
var getOwnPropertyNames = __webpack_require__("241c").f;
var getOwnPropertyDescriptor = __webpack_require__("06cf").f;
var defineProperty = __webpack_require__("9bf2").f;
var trim = __webpack_require__("58a8").trim;

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classof(create(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.github.io/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.github.io/ecma262/#sec-number-constructor
if (isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classof(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(NativeNumber, key = keys[j]) && !has(NumberWrapper, key)) {
      defineProperty(NumberWrapper, key, getOwnPropertyDescriptor(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global, NUMBER, NumberWrapper);
}


/***/ }),

/***/ "ac1f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var exec = __webpack_require__("9263");

$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ "ad6d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__("825a");

// `RegExp.prototype.flags` getter implementation
// https://tc39.github.io/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "ae40":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var fails = __webpack_require__("d039");
var has = __webpack_require__("5135");

var defineProperty = Object.defineProperty;
var cache = {};

var thrower = function (it) { throw it; };

module.exports = function (METHOD_NAME, options) {
  if (has(cache, METHOD_NAME)) return cache[METHOD_NAME];
  if (!options) options = {};
  var method = [][METHOD_NAME];
  var ACCESSORS = has(options, 'ACCESSORS') ? options.ACCESSORS : false;
  var argument0 = has(options, 0) ? options[0] : thrower;
  var argument1 = has(options, 1) ? options[1] : undefined;

  return cache[METHOD_NAME] = !!method && !fails(function () {
    if (ACCESSORS && !DESCRIPTORS) return true;
    var O = { length: -1 };

    if (ACCESSORS) defineProperty(O, 1, { enumerable: true, get: thrower });
    else O[1] = 1;

    method.call(O, argument0, argument1);
  });
};


/***/ }),

/***/ "ae93":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__("e163");
var createNonEnumerableProperty = __webpack_require__("9112");
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");
var IS_PURE = __webpack_require__("c430");

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ "b041":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classof = __webpack_require__("f5df");

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ "b0c0":
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__("83ab");
var defineProperty = __webpack_require__("9bf2").f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.github.io/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ "b622":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var shared = __webpack_require__("5692");
var has = __webpack_require__("5135");
var uid = __webpack_require__("90e3");
var NATIVE_SYMBOL = __webpack_require__("4930");
var USE_SYMBOL_AS_UID = __webpack_require__("fdbf");

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ "b64b":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var toObject = __webpack_require__("7b0b");
var nativeKeys = __webpack_require__("df75");
var fails = __webpack_require__("d039");

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ "b727":
/***/ (function(module, exports, __webpack_require__) {

var bind = __webpack_require__("0366");
var IndexedObject = __webpack_require__("44ad");
var toObject = __webpack_require__("7b0b");
var toLength = __webpack_require__("50c4");
var arraySpeciesCreate = __webpack_require__("65f0");

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else if (IS_EVERY) return false;  // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6)
};


/***/ }),

/***/ "bcf7":
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__("9020");
var each = __webpack_require__("217d").each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ "c04e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("861d");

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "c195":
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__("bcf7");
var Util = __webpack_require__("217d");
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ "c430":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "c6b6":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "c6cd":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var setGlobal = __webpack_require__("ce4e");

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),

/***/ "c832":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    symbolTag = '[object Symbol]';

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    reLeadingDot = /^\./,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Symbol = root.Symbol,
    splice = arrayProto.splice;

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map'),
    nativeCreate = getNative(Object, 'create');

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = isKey(path, object) ? [path] : castPath(path);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value) {
  return isArray(value) ? value : stringToPath(value);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoize(function(string) {
  string = toString(string);

  var result = [];
  if (reLeadingDot.test(string)) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, string) {
    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result);
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Assign cache to `_.memoize`.
memoize.Cache = MapCache;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "c975":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $indexOf = __webpack_require__("4d64").indexOf;
var arrayMethodIsStrict = __webpack_require__("a640");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD = arrayMethodIsStrict('indexOf');
var USES_TO_LENGTH = arrayMethodUsesToLength('indexOf', { ACCESSORS: true, 1: 0 });

// `Array.prototype.indexOf` method
// https://tc39.github.io/ecma262/#sec-array.prototype.indexof
$({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD || !USES_TO_LENGTH }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "ca84":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toIndexedObject = __webpack_require__("fc6a");
var indexOf = __webpack_require__("4d64").indexOf;
var hiddenKeys = __webpack_require__("d012");

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "cc12":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var isObject = __webpack_require__("861d");

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ "cca6":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var assign = __webpack_require__("60da");

// `Object.assign` method
// https://tc39.github.io/ecma262/#sec-object.assign
$({ target: 'Object', stat: true, forced: Object.assign !== assign }, {
  assign: assign
});


/***/ }),

/***/ "ce4e":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var createNonEnumerableProperty = __webpack_require__("9112");

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ "d012":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "d039":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ "d066":
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__("428f");
var global = __webpack_require__("da84");

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),

/***/ "d1e7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),

/***/ "d28b":
/***/ (function(module, exports, __webpack_require__) {

var defineWellKnownSymbol = __webpack_require__("746f");

// `Symbol.iterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ "d2bb":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("825a");
var aPossiblePrototype = __webpack_require__("3bbe");

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ "d3b7":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var redefine = __webpack_require__("6eeb");
var toString = __webpack_require__("b041");

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ "d44e":
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__("9bf2").f;
var has = __webpack_require__("5135");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ "d58f":
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__("1c0b");
var toObject = __webpack_require__("7b0b");
var IndexedObject = __webpack_require__("44ad");
var toLength = __webpack_require__("50c4");

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction(callbackfn);
    var O = toObject(that);
    var self = IndexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

module.exports = {
  // `Array.prototype.reduce` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduce
  left: createMethod(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.reduceright
  right: createMethod(true)
};


/***/ }),

/***/ "d784":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__("ac1f");
var redefine = __webpack_require__("6eeb");
var fails = __webpack_require__("d039");
var wellKnownSymbol = __webpack_require__("b622");
var regexpExec = __webpack_require__("9263");
var createNonEnumerableProperty = __webpack_require__("9112");

var SPECIES = wellKnownSymbol('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  return 'a'.replace(/./, '$0') === '$0';
})();

var REPLACE = wellKnownSymbol('replace');
// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

module.exports = function (KEY, length, exec, sham) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !(
      REPLACE_SUPPORTS_NAMED_GROUPS &&
      REPLACE_KEEPS_$0 &&
      !REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    )) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      if (regexp.exec === regexpExec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    }, {
      REPLACE_KEEPS_$0: REPLACE_KEEPS_$0,
      REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE: REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE
    });
    var stringMethod = methods[0];
    var regexMethod = methods[1];

    redefine(String.prototype, KEY, stringMethod);
    redefine(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return regexMethod.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return regexMethod.call(string, this); }
    );
  }

  if (sham) createNonEnumerableProperty(RegExp.prototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ "d81d":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var $map = __webpack_require__("b727").map;
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');
// FF49- issue
var USES_TO_LENGTH = arrayMethodUsesToLength('map');

// `Array.prototype.map` method
// https://tc39.github.io/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "da84":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "dbb4":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var ownKeys = __webpack_require__("56ef");
var toIndexedObject = __webpack_require__("fc6a");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var createProperty = __webpack_require__("8418");

// `Object.getOwnPropertyDescriptors` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ "ddb0":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("da84");
var DOMIterables = __webpack_require__("fdbc");
var ArrayIteratorMethods = __webpack_require__("e260");
var createNonEnumerableProperty = __webpack_require__("9112");
var wellKnownSymbol = __webpack_require__("b622");

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),

/***/ "df75":
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__("ca84");
var enumBugKeys = __webpack_require__("7839");

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ "e01a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.github.io/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__("23e7");
var DESCRIPTORS = __webpack_require__("83ab");
var global = __webpack_require__("da84");
var has = __webpack_require__("5135");
var isObject = __webpack_require__("861d");
var defineProperty = __webpack_require__("9bf2").f;
var copyConstructorProperties = __webpack_require__("e893");

var NativeSymbol = global.Symbol;

if (DESCRIPTORS && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ "e163":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var toObject = __webpack_require__("7b0b");
var sharedKey = __webpack_require__("f772");
var CORRECT_PROTOTYPE_GETTER = __webpack_require__("e177");

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),

/***/ "e177":
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__("d039");

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ "e260":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__("fc6a");
var addToUnscopables = __webpack_require__("44d2");
var Iterators = __webpack_require__("3f8c");
var InternalStateModule = __webpack_require__("69f3");
var defineIterator = __webpack_require__("7dd0");

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "e439":
/***/ (function(module, exports, __webpack_require__) {

var $ = __webpack_require__("23e7");
var fails = __webpack_require__("d039");
var toIndexedObject = __webpack_require__("fc6a");
var nativeGetOwnPropertyDescriptor = __webpack_require__("06cf").f;
var DESCRIPTORS = __webpack_require__("83ab");

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetOwnPropertyDescriptor(1); });
var FORCED = !DESCRIPTORS || FAILS_ON_PRIMITIVES;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ "e538":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");

exports.f = wellKnownSymbol;


/***/ }),

/***/ "e893":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("5135");
var ownKeys = __webpack_require__("56ef");
var getOwnPropertyDescriptorModule = __webpack_require__("06cf");
var definePropertyModule = __webpack_require__("9bf2");

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),

/***/ "e8b5":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("c6b6");

// `IsArray` abstract operation
// https://tc39.github.io/ecma262/#sec-isarray
module.exports = Array.isArray || function isArray(arg) {
  return classof(arg) == 'Array';
};


/***/ }),

/***/ "e95a":
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__("b622");
var Iterators = __webpack_require__("3f8c");

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ "eaf9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3b81");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_InnerSlider_vue_vue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f013":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("fdb2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_6_oneOf_1_0_node_modules_css_loader_dist_cjs_js_ref_6_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_6_oneOf_1_2_node_modules_vuetify_loader_lib_loader_js_ref_19_0_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_SliderArrow_vue_vue_type_style_index_0_id_21137603_scoped_true_lang_css___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f5df":
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__("00ee");
var classofRaw = __webpack_require__("c6b6");
var wellKnownSymbol = __webpack_require__("b622");

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f772":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5692");
var uid = __webpack_require__("90e3");

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ "f7fe":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__("4de4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.for-each.js
var es_array_for_each = __webpack_require__("4160");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.join.js
var es_array_join = __webpack_require__("a15b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__("d81d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__("fb6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.values.js
var es_object_values = __webpack_require__("07ac");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__("159b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__("a4d3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__("e439");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__("dbb4");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__("b64b");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/json2mq/index.js
var json2mq = __webpack_require__("a48b");
var json2mq_default = /*#__PURE__*/__webpack_require__.n(json2mq);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/mixinPropsUpdated.vue?vue&type=script&lang=js&



/* harmony default export */ var mixinPropsUpdatedvue_type_script_lang_js_ = ({
  computed: {
    isPropsUpdated: function isPropsUpdated() {
      var _this = this;

      // Read props that need to be listened for changes.
      Object.keys(this.$props).forEach(function (key) {
        return _this[key];
      }); // Return a different value each time. `Date.now()` is not guaranteed to be unique.
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      return this.updateSwitch = !this.updateSwitch;
    }
  },
  watch: {
    isPropsUpdated: function isPropsUpdated() {
      if (typeof this.onPropsUpdated === 'function') {
        this.onPropsUpdated();
      }
    }
  }
});
// CONCATENATED MODULE: ./src/mixinPropsUpdated.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_mixinPropsUpdatedvue_type_script_lang_js_ = (mixinPropsUpdatedvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/mixinPropsUpdated.vue
var mixinPropsUpdated_render, staticRenderFns




/* normalize component */

var component = normalizeComponent(
  src_mixinPropsUpdatedvue_type_script_lang_js_,
  mixinPropsUpdated_render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var mixinPropsUpdated = (component.exports);
// EXTERNAL MODULE: ./node_modules/lodash.pick/index.js
var lodash_pick = __webpack_require__("88bc");
var lodash_pick_default = /*#__PURE__*/__webpack_require__.n(lodash_pick);

// EXTERNAL MODULE: ./node_modules/lodash.assign/index.js
var lodash_assign = __webpack_require__("42a0");
var lodash_assign_default = /*#__PURE__*/__webpack_require__.n(lodash_assign);

// EXTERNAL MODULE: ./node_modules/lodash.get/index.js
var lodash_get = __webpack_require__("c832");
var lodash_get_default = /*#__PURE__*/__webpack_require__.n(lodash_get);

// CONCATENATED MODULE: ./src/vNodeUtils.js





var vNodeUtils_mergeVNodeData = function mergeVNodeData(vnode, name, obj) {
  if (!vnode) {
    return;
  }

  vnode.data = vnode.data || {};
  vnode.data[name] = _objectSpread2({}, vnode.data[name], {}, obj);
};
var setVNodeData = function setVNodeData(vnode, name, value) {
  if (!vnode) {
    return;
  }

  vnode.data = vnode.data || {};
  vnode.data[name] = value;
};
var DATA_KEYS = ['class', 'staticClass', 'style', 'attrs', 'props', 'domProps', 'on', 'nativeOn', 'directives', 'scopesSlots', 'slot', 'ref', 'key'];

function mutateKey(key) {
  return '' + key + "-cloned-cid";
}

function extractData(vnode, isComp) {
  var data = lodash_pick_default()(vnode.data, DATA_KEYS);

  if (isComp) {
    var cOpts = vnode.componentOptions;
    lodash_assign_default()(data, {
      props: cOpts.propsData,
      on: cOpts.listeners
    });
  }

  if (data.key) {
    data.key = mutateKey(data.key);
  }

  return data;
}

var cloneVNode = function cloneVNode(vnode) {
  // use the context that the original vnode was created in.
  var h = vnode.context && vnode.context.$createElement;
  var isComp = !!vnode.componentOptions;
  var isText = !vnode.tag; // this will also match comments but those will be dropped, essentially

  var children = isComp ? vnode.componentOptions.children : vnode.children;
  if (isText) return vnode.text;
  var data = extractData(vnode, isComp);
  var tag = isComp ? vnode.componentOptions.Ctor : vnode.tag;
  var childNodes = children ? children.map(function (c) {
    return cloneVNode(c);
  }) : undefined;
  return h(tag, data, childNodes);
};
var vNodeUtils_copyClassesFrom = function copyClassesFrom(vnode, from) {
  var _from$data = from.data,
      data = _from$data === void 0 ? {} : _from$data;
  setVNodeData(vnode, 'staticClass', data.staticClass);
  vNodeUtils_mergeVNodeData(vnode, 'class', _objectSpread2({}, data.class, {}, from));
};
var vNodeUtils_getData = function getData(vnode, path, defaultValue) {
  if (!vnode) {
    return;
  }

  var data = vnode.data || {};
  return typeof path === 'undefined' ? data : lodash_get_default()(data, path, defaultValue);
};
var vNodeUtils_getStyle = function getStyle(vnode) {
  return _objectSpread2({}, vNodeUtils_getData(vnode, 'staticStyle', {}), {}, vNodeUtils_getData(vnode, 'style', {}));
};
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__("99af");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.every.js
var es_array_every = __webpack_require__("a623");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__("a630");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.index-of.js
var es_array_index_of = __webpack_require__("c975");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.reduce.js
var es_array_reduce = __webpack_require__("13d5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__("a9e3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__("ac1f");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__("3ca3");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__("466d");

// CONCATENATED MODULE: ./src/innerSliderUtils.js















var canUseDOM = function canUseDOM() {
  return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
};
var getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  if (spec.variableWidth) {
    return spec.slideCount;
  }

  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};
var getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }

  return spec.slideCount;
};
var innerSliderUtils_keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match('TEXTAREA|INPUT|SELECT') || !accessibility) return '';
  if (e.keyCode === 37) return rtl ? 'next' : 'previous';
  if (e.keyCode === 39) return rtl ? 'previous' : 'next';
  return '';
};
var siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return 'left';
    }

    return 'right';
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return 'right';
    }

    return 'left';
  }
};
var slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }

  if (rtl) {
    return 0;
  }

  return slidesToShow - 1;
};
var slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }

  if (rtl) {
    return slidesToShow - 1;
  }

  return 0;
}; // startIndex that needs to be present

var lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};
var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);

  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }

  return onDemandSlides;
};
var innerSliderUtils_changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;
  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === 'previous') {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;

    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === 'next') {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;

    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === 'dots') {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;

    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === 'children') {
    // Click on the slides
    targetSlide = options.index;

    if (targetSlide === options.currentSlide) {
      return null;
    }

    if (infinite) {
      var direction = siblingDirection(_objectSpread2({}, spec, {
        targetSlide: targetSlide
      }));

      if (targetSlide > options.currentSlide && direction === 'left') {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === 'right') {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === 'index') {
    targetSlide = Number(options.index);

    if (targetSlide === options.currentSlide) {
      return null;
    }
  }

  return targetSlide;
};
var filterUndefined = function filterUndefined(props) {
  return Object.keys(props).filter(function (key) {
    return props[key] !== undefined;
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
var filterUndefinedOrNull = function filterUndefinedOrNull(props) {
  return Object.keys(props).filter(function (key) {
    return props[key] !== undefined && props[key] !== null;
  }).reduce(function (obj, key) {
    obj[key] = props[key];
    return obj;
  }, {});
};
var innerSliderUtils_swipeStart = function swipeStart(e, swipe, draggable) {
  if (!swipe || !draggable && e.type.indexOf('mouse') !== -1) return '';
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var innerSliderUtils_swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;
  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));

  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return {
      scrolling: true
    };
  }

  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;

  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === 'right' || currentSlide + 1 >= dotCount && swipeDirection === 'left' || !canGoNext(spec) && swipeDirection === 'left') {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;

      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state['edgeDragged'] = true;
      }
    }
  }

  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state['swiped'] = true;
  }

  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }

  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }

  state = _objectSpread2({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
      left: swipeLeft
    }))
  });

  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }

  if (touchObject.swipeLength > 10) {
    state['swiping'] = true;
    e.preventDefault();
  }

  return state;
};
var innerSliderUtils_swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }

  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.

  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };

  if (scrolling) {
    return state;
  }

  if (!touchObject.swipeLength) {
    return state;
  }

  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();

    if (onSwipe) {
      onSwipe(swipeDirection);
    }

    var slideCount, newSlide;

    switch (swipeDirection) {
      case 'left':
      case 'up':
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state['currentDirection'] = 0;
        break;

      case 'right':
      case 'down':
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state['currentDirection'] = 1;
        break;

      default:
        slideCount = currentSlide;
    }

    state['triggerSlideHandler'] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state['trackStyle'] = getTrackAnimateCSS(_objectSpread2({}, spec, {
      left: currentLeft
    }));
  }

  return state;
};
var getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];

  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }

  return indexes;
};
var checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;

  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }

      prevNavigable = navigables[n];
    }
  }

  return index;
};
var getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;

  if (spec.swipeToSlide) {
    var swipedSlide;
    var slickList = spec.listRef;
    var slides = slickList.querySelectorAll('.slick-slide');
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }

    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
}; // given an object and a list of keys, return new object with given keys

var extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};
var PROP_KEYS = {
  TRACK: ['fade', 'cssEase', 'speed', 'infinite', 'centerMode', 'currentSlide', 'lazyLoad', 'lazyLoadedList', 'rtl', 'slideWidth', 'slideHeight', 'listHeight', 'vertical', 'slidesToShow', 'slidesToScroll', 'slideCount', 'trackStyle', 'variableWidth', 'unslick', 'centerPadding'],
  DOT: ['dotsClass', 'slideCount', 'slidesToShow', 'currentSlide', 'slidesToScroll', 'children', 'customPaging', 'infinite'],
  ARROW: ['infinite', 'centerMode', 'currentSlide', 'slideCount', 'slidesToShow', 'prevArrow', 'nextArrow']
}; // whether or not we can go next

var canGoNext = function canGoNext(spec) {
  var canGo = true;

  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }

  return canGo;
};
var innerSliderUtils_slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;
  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide,
      animationLeft,
      finalLeft;
  var state = {},
      nextState = {};

  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};

    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }

    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }

    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = {
      animating: false
    };
  } else {
    finalSlide = animationSlide;

    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }

    animationLeft = getTrackLeft(_objectSpread2({}, spec, {
      slideIndex: animationSlide
    }));
    finalLeft = getTrackLeft(_objectSpread2({}, spec, {
      slideIndex: finalSlide
    }));

    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }

    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread2({}, spec, {
      currentSlide: animationSlide
    })));

    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
          left: finalLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_objectSpread2({}, spec, {
          left: animationLeft
        })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: innerSliderUtils_getTrackCSS(_objectSpread2({}, spec, {
          left: finalLeft
        })),
        swipeLeft: null
      };
    }
  }

  return {
    state: state,
    nextState: nextState
  };
}; // get width of an element

var getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);

  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }

  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return 'left';
  }

  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return 'right';
  }

  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return 'up';
    } else {
      return 'down';
    }
  }

  return 'vertical';
}; // get initialized state

var initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = spec.children.length;
  var listWidth = Math.ceil(getWidth(spec.listRef));
  var trackWidth = Math.ceil(getWidth(spec.trackRef));
  var slideWidth;

  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;

    if (typeof spec.centerPadding === 'string' && spec.centerPadding.slice(-1) === '%') {
      centerPaddingAdj *= listWidth / 100;
    }

    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }

  var slideHeight = spec.listRef && getHeight(spec.listRef.querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;

  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }

  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({
    currentSlide: currentSlide,
    lazyLoadedList: lazyLoadedList
  }, spec);
  lazyLoadedList.concat(slidesToLoad);
  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state['autoplaying'] = 'playing';
  }

  return state;
};
var getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ['slideIndex', 'trackRef', 'infinite', 'centerMode', 'slideCount', 'slidesToShow', 'slidesToScroll', 'slideWidth', 'listWidth', 'variableWidth', 'slideHeight']);
  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;
  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;

  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children

    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    } // shift current slide to center of the frame


    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }

    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }

  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = trackRef.$el;
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;

    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;

      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }

      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};
var getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error('Keys Missing:', spec);
}; // eslint-disable-line no-console

var innerSliderUtils_getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth']);
  var trackWidth, trackHeight;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;

  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }

  var style = {
    opacity: 1,
    transition: '',
    WebkitTransition: ''
  };

  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
    var transform = !spec.vertical ? 'translate3d(' + spec.left + 'px, 0px, 0px)' : 'translate3d(0px, ' + spec.left + 'px, 0px)';
    var msTransform = !spec.vertical ? 'translateX(' + spec.left + 'px)' : 'translateY(' + spec.left + 'px)';
    style = _objectSpread2({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style['top'] = spec.left;
    } else {
      style['left'] = spec.left;
    }
  }

  if (spec.fade) style = {
    opacity: 1
  };
  if (trackWidth) style.width = trackWidth + 'px';
  if (trackHeight) style.height = trackHeight + 'px'; // Fallback for IE8

  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + 'px';
    } else {
      style.marginTop = spec.left + 'px';
    }
  }

  return style;
};
var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ['left', 'variableWidth', 'slideCount', 'slidesToShow', 'slideWidth', 'speed', 'cssEase']);
  var style = innerSliderUtils_getTrackCSS(spec); // useCSS is true by default so it can be undefined

  if (spec.useTransform) {
    style.WebkitTransition = '-webkit-transform ' + spec.speed + 'ms ' + spec.cssEase;
    style.transition = 'transform ' + spec.speed + 'ms ' + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = 'top ' + spec.speed + 'ms ' + spec.cssEase;
    } else {
      style.transition = 'left ' + spec.speed + 'ms ' + spec.cssEase;
    }
  }

  return style;
};
// CONCATENATED MODULE: ./src/defaultProps.js



var defaultProps_props = {
  accessibility: {
    type: Boolean,
    default: true
  },
  adaptiveHeight: {
    type: Boolean,
    default: false
  },
  arrows: {
    type: Boolean,
    default: true
  },
  asNavFor: {
    type: Object,
    default: null
  },
  autoplay: {
    type: Boolean,
    default: false
  },
  autoplaySpeed: {
    type: Number,
    default: 3000
  },
  centerMode: {
    type: Boolean,
    default: false
  },
  centerPadding: {
    type: String,
    default: '50px'
  },
  cssEase: {
    type: String,
    default: 'ease'
  },
  dots: {
    type: Boolean,
    default: false
  },
  dotsClass: {
    type: String,
    default: 'slick-dots'
  },
  draggable: {
    type: Boolean,
    default: true
  },
  edgeFriction: {
    type: Number,
    default: 0.35
  },
  fade: {
    type: Boolean,
    default: false
  },
  focusOnSelect: {
    type: Boolean,
    default: false
  },
  infinite: {
    type: Boolean,
    default: true
  },
  initialSlide: {
    type: Number,
    default: 0
  },
  lazyLoad: {
    type: String,
    default: null
  },
  pauseOnDotsHover: {
    type: Boolean,
    default: false
  },
  pauseOnFocus: {
    type: Boolean,
    default: false
  },
  pauseOnHover: {
    type: Boolean,
    default: true
  },
  responsive: {
    type: Array,
    default: null
  },
  rows: {
    type: Number,
    default: 1
  },
  rtl: {
    type: Boolean,
    default: false
  },
  slidesPerRow: {
    type: Number,
    default: 1
  },
  slidesToScroll: {
    type: Number,
    default: 1
  },
  slidesToShow: {
    type: Number,
    default: 1
  },
  speed: {
    type: Number,
    default: 500
  },
  swipe: {
    type: Boolean,
    default: true
  },
  swipeToSlide: {
    type: Boolean,
    default: false
  },
  touchMove: {
    type: Boolean,
    default: true
  },
  touchThreshold: {
    type: Number,
    default: 5
  },
  useCSS: {
    type: Boolean,
    default: true
  },
  useTransform: {
    type: Boolean,
    default: true
  },
  variableWidth: {
    type: Boolean,
    default: false
  },
  vertical: {
    type: Boolean,
    default: false
  },
  waitForAnimate: {
    type: Boolean,
    default: true
  }
};
var defaultValues = Object.keys(defaultProps_props).reduce(function (acc, key) {
  acc[key] = defaultProps_props[key].default;
  return acc;
}, {});
var types = Object.keys(defaultProps_props).reduce(function (acc, key) {
  acc[key] = defaultProps_props[key].type;
  return acc;
}, {});
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.assign.js
var es_object_assign = __webpack_require__("cca6");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js


function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js



function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__("e01a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__("d28b");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__("e260");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__("d3b7");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__("ddb0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
// EXTERNAL MODULE: ./node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var ResizeObserver_es = __webpack_require__("6dd8");

// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__("f7fe");
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderTrack.vue?vue&type=script&lang=js&








var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }

  slickCloned = index < 0 || index >= spec.slideCount;

  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;

    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }

  var slickCurrent = index === spec.currentSlide;
  return {
    'slick-slide': true,
    'slick-active': slickActive,
    'slick-center': slickCenter,
    'slick-cloned': slickCloned,
    'slick-current': slickCurrent // dubious in case of RTL

  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = typeof spec.slideWidth === 'number' ? "".concat(spec.slideWidth, "px") : spec.slideWidth;
  }

  if (spec.fade) {
    style.position = 'relative';

    if (spec.vertical) {
      style.top = "".concat(-spec.index * parseInt(spec.slideHeight), "px");
    } else {
      style.left = "".concat(-spec.index * parseInt(spec.slideWidth), "px");
    }

    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = 'opacity ' + spec.speed + 'ms ' + spec.cssEase + ', ' + 'visibility ' + spec.speed + 'ms ' + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key != null && String(child.key) || fallbackKey;
};

/* harmony default export */ var SliderTrackvue_type_script_lang_js_ = ({
  name: 'SliderTrack',
  props: PROP_KEYS.TRACK,
  methods: {
    cloneSlide: function cloneSlide(slide, options) {
      var _this = this;

      var clone = cloneVNode(slide);
      clone.key = options.key;
      vNodeUtils_mergeVNodeData(clone, 'class', options.class);
      vNodeUtils_mergeVNodeData(clone, 'attrs', options.attrs);
      vNodeUtils_mergeVNodeData(clone, 'style', options.style);
      vNodeUtils_mergeVNodeData(clone, 'on', {
        click: function click(e) {
          vNodeUtils_getData(slide, 'on.click', function () {})(e);

          _this.$emit('childClicked', options.childOnClickOptions);
        }
      });
      return clone;
    },
    renderSlides: function renderSlides(spec, children) {
      var _this2 = this;

      var h = this.$createElement;
      var key;
      var slides = [];
      var preCloneSlides = [];
      var postCloneSlides = [];
      var childrenCount = children.length;
      var startIndex = lazyStartIndex(spec);
      var endIndex = lazyEndIndex(spec);
      children.forEach(function (elem, index) {
        var child;
        var childOnClickOptions = {
          message: 'children',
          index: index,
          slidesToScroll: spec.slidesToScroll,
          currentSlide: spec.currentSlide
        }; // in case of lazyLoad, whether or not we want to fetch the slide

        if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
          child = elem;
        } else {
          child = h("div");
        }

        var childStyle = getSlideStyle(_objectSpread2({}, spec, {
          index: index
        }));
        var slideClasses = getSlideClasses(_objectSpread2({}, spec, {
          index: index
        })); // push a cloned element of the desired slide

        slides.push(_this2.cloneSlide(child, {
          key: 'original' + getKey(child, index),
          class: slideClasses,
          style: _objectSpread2({
            outline: 'none'
          }, childStyle),
          attrs: {
            tabIndex: '-1',
            'data-index': index,
            'aria-hidden': "".concat(!slideClasses['slick-active'])
          },
          childOnClickOptions: childOnClickOptions
        })); // if slide needs to be precloned or postcloned

        if (spec.infinite && spec.fade === false && childrenCount > spec.slidesToShow) {
          var preCloneNo = childrenCount - index;

          if (preCloneNo <= getPreClones(spec) && childrenCount !== spec.slidesToShow) {
            key = -preCloneNo;

            if (key >= startIndex) {
              child = elem;
            }

            slideClasses = getSlideClasses(_objectSpread2({}, spec, {
              index: key
            }));
            preCloneSlides.push(_this2.cloneSlide(child, {
              key: 'precloned' + getKey(child, key),
              class: slideClasses,
              style: childStyle,
              attrs: {
                tabIndex: '-1',
                'data-index': key,
                'aria-hidden': "".concat(!slideClasses['slick-active'])
              },
              childOnClickOptions: childOnClickOptions
            }));
          }

          if (childrenCount !== spec.slidesToShow) {
            key = childrenCount + index;

            if (key < endIndex) {
              child = elem;
            }

            slideClasses = getSlideClasses(_objectSpread2({}, spec, {
              index: key
            }));
            postCloneSlides.push(_this2.cloneSlide(child, {
              key: 'postcloned' + getKey(child, key),
              class: slideClasses,
              style: childStyle,
              attrs: {
                tabIndex: '-1',
                'data-index': key,
                'aria-hidden': "".concat(!slideClasses['slick-active'])
              },
              childOnClickOptions: childOnClickOptions
            }));
          }
        }
      }, this);

      if (spec.rtl) {
        return preCloneSlides.concat(slides, postCloneSlides).reverse();
      } else {
        return preCloneSlides.concat(slides, postCloneSlides);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var slides = this.renderSlides(this.$props, this.$slots.default);
    return h("div", {
      "class": {
        'slick-track': true,
        'slick-center': this.$props.centerMode
      },
      "style": this.trackStyle
    }, [slides]);
  }
});
// CONCATENATED MODULE: ./src/SliderTrack.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderTrackvue_type_script_lang_js_ = (SliderTrackvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/SliderTrack.vue?vue&type=style&index=0&id=e4caeaf8&scoped=true&lang=css&
var SliderTrackvue_type_style_index_0_id_e4caeaf8_scoped_true_lang_css_ = __webpack_require__("6ea2");

// CONCATENATED MODULE: ./src/SliderTrack.vue
var SliderTrack_render, SliderTrack_staticRenderFns





/* normalize component */

var SliderTrack_component = normalizeComponent(
  src_SliderTrackvue_type_script_lang_js_,
  SliderTrack_render,
  SliderTrack_staticRenderFns,
  false,
  null,
  "e4caeaf8",
  null
  
)

/* harmony default export */ var SliderTrack = (SliderTrack_component.exports);
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__("b0c0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__("25f0");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js







function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderArrow.vue?vue&type=script&lang=js&




/* harmony default export */ var SliderArrowvue_type_script_lang_js_ = ({
  name: 'SliderArrow',
  props: [].concat(_toConsumableArray(PROP_KEYS.ARROW), ['type']),
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var classes = {
      'slick-arrow': true
    };
    var clickable = true;
    var arrow;
    var option = {
      currentSlide: this.currentSlide,
      slideCount: this.slideCount
    };

    if (this.type === 'previous') {
      classes['slick-prev'] = true;

      if (!this.infinite && (this.currentSlide === 0 || this.slideCount <= this.slidesToShow)) {
        classes['slick-disabled'] = true;
        clickable = false;
      }

      option.key = '0';
      arrow = this.prevArrow ? this.prevArrow(option)[0] : h("button", {
        "attrs": {
          "type": "button",
          "data-role": "none"
        },
        "style": "display: block;"
      }, ["Previous"]);
    } else {
      classes['slick-next'] = true;

      if (!canGoNext(this.$props)) {
        classes['slick-disabled'] = true;
        clickable = false;
      }

      option.key = '1';
      arrow = this.nextArrow ? this.nextArrow(option)[0] : h("button", {
        "attrs": {
          "type": "button",
          "data-role": "none"
        },
        "style": "display: block;"
      }, ["Next"]);
    }

    setVNodeData(arrow, 'key', option.key);
    vNodeUtils_mergeVNodeData(arrow, 'class', classes);
    vNodeUtils_mergeVNodeData(arrow, 'on', {
      click: function click() {
        if (clickable) {
          _this.$emit('arrowClicked', {
            message: _this.type
          });
        }
      }
    });
    return arrow;
  }
});
// CONCATENATED MODULE: ./src/SliderArrow.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderArrowvue_type_script_lang_js_ = (SliderArrowvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/SliderArrow.vue?vue&type=style&index=0&id=21137603&scoped=true&lang=css&
var SliderArrowvue_type_style_index_0_id_21137603_scoped_true_lang_css_ = __webpack_require__("f013");

// CONCATENATED MODULE: ./src/SliderArrow.vue
var SliderArrow_render, SliderArrow_staticRenderFns





/* normalize component */

var SliderArrow_component = normalizeComponent(
  src_SliderArrowvue_type_script_lang_js_,
  SliderArrow_render,
  SliderArrow_staticRenderFns,
  false,
  null,
  "21137603",
  null
  
)

/* harmony default export */ var SliderArrow = (SliderArrow_component.exports);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.split.js
var es_string_split = __webpack_require__("1276");

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/SliderDots.vue?vue&type=script&lang=js&







var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

/* harmony default export */ var SliderDotsvue_type_script_lang_js_ = ({
  name: 'SliderDots',
  props: PROP_KEYS.DOT,
  render: function render() {
    var _this = this;

    var h = arguments[0];
    var dotCount = getDotCount({
      slideCount: this.slideCount,
      slidesToScroll: this.slidesToScroll,
      slidesToShow: this.slidesToShow,
      infinite: this.infinite
    }); // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458

    var dots = Array.apply(null, Array(dotCount + 1).join('0').split('')).map(function (x, i) {
      var leftBound = i * _this.slidesToScroll;
      var rightBound = i * _this.slidesToScroll + (_this.slidesToScroll - 1);
      var className = {
        'slick-active': _this.currentSlide >= leftBound && _this.currentSlide <= rightBound
      };
      var dotOptions = {
        message: 'dots',
        index: i,
        slidesToScroll: _this.slidesToScroll,
        currentSlide: _this.currentSlide
      };
      var customPaging = _this.customPaging ? _this.customPaging(i)[0] : h("button", [i + 1]);
      return h("li", {
        "key": i,
        "class": className,
        "on": {
          "click": function click() {
            return _this.$emit('dotClicked', dotOptions);
          }
        }
      }, [customPaging]);
    });
    var wrapperStyle = {
      display: 'block'
    };

    var wrapperClass = _defineProperty({}, this.dotsClass, true);

    return h("ul", {
      "style": wrapperStyle,
      "class": wrapperClass
    }, [dots]);
  }
});
// CONCATENATED MODULE: ./src/SliderDots.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_SliderDotsvue_type_script_lang_js_ = (SliderDotsvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/SliderDots.vue
var SliderDots_render, SliderDots_staticRenderFns




/* normalize component */

var SliderDots_component = normalizeComponent(
  src_SliderDotsvue_type_script_lang_js_,
  SliderDots_render,
  SliderDots_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SliderDots = (SliderDots_component.exports);
// CONCATENATED MODULE: ./src/initialState.js
/* harmony default export */ var initialState = ({
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false,
  // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: {
    startX: 0,
    startY: 0,
    curX: 0,
    curY: 0
  },
  trackStyle: {},
  trackWidth: 0
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/InnerSlider.vue?vue&type=script&lang=js&























/* harmony default export */ var InnerSlidervue_type_script_lang_js_ = ({
  name: 'InnerSlider',
  components: {
    SliderTrack: SliderTrack,
    SliderArrow: SliderArrow,
    SliderDots: SliderDots
  },
  mixins: [mixinPropsUpdated],
  inheritAttrs: false,
  props: _objectSpread2({}, defaultProps_props, {
    unslick: {
      type: Boolean,
      default: false
    },
    prevArrow: Function,
    nextArrow: Function,
    customPaging: Function
  }),
  data: function data() {
    return _objectSpread2({}, initialState, {
      currentSlide: this.initialSlide
    });
  },
  computed: {
    slideCount: function slideCount() {
      return this.$slots.default.length;
    },
    spec: function spec() {
      return _objectSpread2({}, this.$props, {}, this.$data, {
        slideCount: this.slideCount
      });
    }
  },
  created: function created() {
    // non-reactive data
    this.callbackTimers = [];
    this.clickable = true;
    this.debouncedResize = null;
    this.ssrInit();
    this.$parent.$emit('init');

    if (this.lazyLoad) {
      var slidesToLoad = getOnDemandLazySlides(this.spec);

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    var spec = _objectSpread2({
      listRef: this.$refs.list,
      trackRef: this.$refs.track,
      children: this.$slots.default
    }, this.$props);

    this.updateState(spec, true);
    this.adaptHeight();

    if (this.autoPlay) {
      this.autoPlay('update');
    }

    if (this.lazyLoad === 'progressive') {
      this.lazyLoadTimer = setInterval(this.progressiveLazyLoad, 1000);
    }

    this.ro = new ResizeObserver_es["a" /* default */](function () {
      if (_this.animating) {
        _this.onWindowResized(false); // don't set trackStyle hence don't break animation


        _this.callbackTimers.push(setTimeout(function () {
          return _this.onWindowResized();
        }, _this.speed));
      } else {
        _this.onWindowResized();
      }
    });
    this.ro.observe(this.$refs.list);
    Array.prototype.forEach.call(this.$refs.list.querySelectorAll('.slick-slide'), function (slide) {
      slide.onfocus = _this.pauseOnFocus ? _this.onSlideFocus : null;
      slide.onblur = _this.pauseOnFocus ? _this.onSlideBlur : null;
    });

    if (window.addEventListener) {
      window.addEventListener('resize', this.onWindowResized);
    } else {
      window.attachEvent('onresize', this.onWindowResized);
    }
  },
  updated: function updated() {
    this.checkImagesLoad();
    this.$parent.$emit('reInit');

    if (this.lazyLoad) {
      var slidesToLoad = getOnDemandLazySlides(_objectSpread2({}, this.$props, {}, this.$data));

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }
    }

    this.adaptHeight();
  },
  beforeDestroy: function beforeDestroy() {
    this.ro.unobserve(this.$refs.list);

    if (this.animationEndCallback) {
      clearTimeout(this.animationEndCallback);
    }

    if (this.lazyLoadTimer) {
      clearInterval(this.lazyLoadTimer);
    }

    if (this.callbackTimers.length) {
      this.callbackTimers.forEach(function (timer) {
        return clearTimeout(timer);
      });
      this.callbackTimers = [];
    }

    if (window.addEventListener) {
      window.removeEventListener('resize', this.onWindowResized);
    } else {
      window.detachEvent('onresize', this.onWindowResized);
    }

    if (this.autoplayTimer) {
      clearInterval(this.autoplayTimer);
    }
  },
  methods: {
    onPropsUpdated: function onPropsUpdated() {
      var nextProps = this.$props;

      var spec = _objectSpread2({
        listRef: this.$refs.list,
        trackRef: this.$refs.track,
        children: this.$slots.default
      }, nextProps, {}, this.$data);

      var setTrackStyle = false;

      for (var _i = 0, _Object$keys = Object.keys(this.$props); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }

        if (_typeof(nextProps[key]) === 'object' || typeof nextProps[key] === 'function') {
          continue;
        }

        if (nextProps[key] !== this.$props[key]) {
          setTrackStyle = true;
          break;
        }
      }

      this.updateState(spec, setTrackStyle);

      if (this.currentSlide >= this.slideCount) {
        this.changeSlide({
          message: 'index',
          index: this.slideCount - nextProps.slidesToShow,
          currentSlide: this.currentSlide
        });
      }

      if (nextProps.autoplay) {
        this.autoPlay('update');
      } else {
        this.pause('paused');
      }
    },
    updateState: function updateState(spec, setTrackStyle) {
      var updatedState = initializedState(spec);
      spec = _objectSpread2({}, spec, {}, updatedState, {
        slideIndex: updatedState.currentSlide
      });
      var targetLeft = getTrackLeft(spec);
      spec = _objectSpread2({}, spec, {
        left: targetLeft
      });
      var trackStyle = innerSliderUtils_getTrackCSS(spec);

      if (setTrackStyle || this.slideCount !== spec.children.length) {
        updatedState['trackStyle'] = trackStyle;
      }

      Object.assign(this.$data, updatedState);
    },
    adaptHeight: function adaptHeight() {
      if (this.adaptiveHeight && this.$refs.list) {
        var elem = this.$refs.list.querySelector("[data-index=\"".concat(this.currentSlide, "\"]"));
        this.$refs.list.style.height = getHeight(elem) + 'px';
      }
    },
    ssrInit: function ssrInit() {
      var preClones = getPreClones(this.spec);
      var postClones = getPostClones(this.spec);

      if (this.variableWidth) {
        var trackWidth = [],
            trackLeft = [];
        var childrenWidths = [];
        this.$slots.default.forEach(function (child) {
          var _getStyle = vNodeUtils_getStyle(child),
              width = _getStyle.width;

          childrenWidths.push(width);
          trackWidth.push(width);
        });

        for (var i = 0; i < preClones; i++) {
          trackLeft.push(childrenWidths[childrenWidths.length - 1 - i]);
          trackWidth.push(childrenWidths[childrenWidths.length - 1 - i]);
        }

        for (var _i2 = 0; _i2 < postClones; _i2++) {
          trackWidth.push(childrenWidths[_i2]);
        }

        for (var _i3 = 0; _i3 < this.currentSlide; _i3++) {
          trackLeft.push(childrenWidths[_i3]);
        } // filter undefined


        trackWidth = trackWidth.filter(function (o) {
          return o;
        });
        trackLeft = trackLeft.filter(function (o) {
          return o;
        });
        var trackStyle = {
          width: "calc(".concat(trackWidth.join(' + '), ")"),
          left: "calc(".concat(trackLeft.map(function (o) {
            return "-".concat(o);
          }).join(' + '), ")")
        };

        if (this.centerMode) {
          var currentWidth = childrenWidths[this.currentSlide];
          trackStyle.left = "calc(".concat(trackLeft.map(function (o) {
            return "-".concat(o);
          }).join(' + '), " + (100% - ").concat(currentWidth, ") / 2 )");
        }

        this.trackStyle = trackStyle;
      } else {
        var slideCount = preClones + postClones + this.slideCount;

        var _trackWidth = 100 / this.slidesToShow * slideCount;

        var slideWidth = 100 / slideCount;

        var _trackLeft = -slideWidth * (preClones + this.currentSlide) * _trackWidth / 100;

        if (this.centerMode) {
          _trackLeft += (100 - slideWidth * _trackWidth / 100) / 2;
        }

        this.slideWidth = slideWidth + '%';
        this.trackStyle = {
          width: _trackWidth + '%',
          left: _trackLeft + '%'
        };
      }
    },
    slideHandler: function slideHandler(index) {
      var _this2 = this;

      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var asNavFor = this.asNavFor,
          speed = this.speed; // capture currentslide before state is updated

      var currentSlide = this.currentSlide;

      var _slideHandler2 = innerSliderUtils_slideHandler(_objectSpread2({
        index: index
      }, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        useCSS: this.useCSS && !dontAnimate
      })),
          state = _slideHandler2.state,
          nextState = _slideHandler2.nextState;

      if (!state) return;
      this.$parent.$emit('beforeChange', currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this2.lazyLoadedList.indexOf(value) < 0;
      });

      if (slidesToLoad.length) {
        this.$parent.$emit('lazyLoad', slidesToLoad);
      }

      Object.assign(this.$data, state);

      if (asNavFor) {
        asNavFor.goTo(index);
      }

      if (!nextState) return;
      this.animationEndCallback = setTimeout(function () {
        var animating = nextState.animating,
            firstBatch = _objectWithoutProperties(nextState, ["animating"]);

        Object.assign(_this2.$data, firstBatch);

        _this2.callbackTimers.push(setTimeout(function () {
          _this2.animating = animating;
        }, 10));

        _this2.$parent.$emit('afterChange', state.currentSlide); // delete this.animationEndCallback


        _this2.animationEndCallback = undefined;
      }, speed);
    },
    onWindowResized: function onWindowResized(setTrackStyle) {
      var _this3 = this;

      if (this.debouncedResize) this.debouncedResize.cancel();
      this.debouncedResize = lodash_debounce_default()(function () {
        return _this3.resizeWindow(setTrackStyle);
      }, 50);
      this.debouncedResize();
    },
    resizeWindow: function resizeWindow() {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!(this.$refs.track && this.$refs.track.$el)) {
        return;
      }

      var spec = _objectSpread2({
        listRef: this.$refs.list,
        trackRef: this.$refs.track,
        children: this.$slots.default
      }, this.$props, {}, this.$data);

      this.updateState(spec, setTrackStyle);

      if (this.autoplay) {
        this.autoPlay('update');
      } else {
        this.pause('paused');
      } // animating state should be cleared while resizing, otherwise autoplay stops working


      this.animating = false;
      clearTimeout(this.animationEndCallback); // delete this.animationEndCallback

      this.animationEndCallback = undefined;
    },
    checkImagesLoad: function checkImagesLoad() {
      var _this4 = this;

      var images = this.$refs.list.querySelectorAll('.slick-slide img');
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this4.onWindowResized();
        };

        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;

          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }

        if (!image.onload) {
          if (_this4.lazyLoad) {
            image.onload = function () {
              _this4.adaptHeight();

              _this4.callbackTimers.push(setTimeout(_this4.onWindowResized, _this4.speed));
            };
          } else {
            image.onload = handler;

            image.onerror = function () {
              handler();

              _this4.$parent.$emit('lazyLoadError');
            };
          }
        }
      });
    },
    progressiveLazyLoad: function progressiveLazyLoad() {
      var slidesToLoad = [];

      var spec = _objectSpread2({}, this.$props, {}, this.$data);

      for (var index = this.currentSlide; index < this.slideCount + getPostClones(spec); index++) {
        if (this.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }

      for (var _index = this.currentSlide - 1; _index >= -getPreClones(spec); _index--) {
        if (this.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }

      if (slidesToLoad.length > 0) {
        this.lazyLoadedList = this.lazyLoadedList.concat(slidesToLoad);
        this.$parent.$emit('lazyLoad', slidesToLoad);
      } else {
        if (this.lazyLoadTimer) {
          clearInterval(this.lazyLoadTimer); // delete this.lazyLoadTimer;

          this.lazyLoadTimer = undefined;
        }
      }
    },
    clickHandler: function clickHandler(e) {
      if (this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }

      this.clickable = true;
    },
    keyHandler: function keyHandler(e) {
      var dir = innerSliderUtils_keyHandler(e, this.accessibility, this.rtl);

      dir !== '' && this.changeSlide({
        message: dir
      });
    },
    changeSlide: function changeSlide(options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _objectSpread2({}, this.$props, {}, this.$data);

      var targetSlide = innerSliderUtils_changeSlide(spec, options);

      if (targetSlide !== 0 && !targetSlide) return;

      if (dontAnimate === true) {
        this.slideHandler(targetSlide, dontAnimate);
      } else {
        this.slideHandler(targetSlide);
      }
    },
    swipeStart: function swipeStart(e) {
      if (this.verticalSwiping) {
        this.disableBodyScroll();
      }

      var state = innerSliderUtils_swipeStart(e, this.swipe, this.draggable);

      if (state !== '') {
        Object.assign(this.$data, state);
      }
    },
    swipeMove: function swipeMove(e) {
      var _this5 = this;

      var state = innerSliderUtils_swipeMove(e, _objectSpread2({}, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        listRef: this.$refs.list,
        slideIndex: this.currentSlide,
        onEdge: function onEdge(e) {
          return _this5.$parent.$emit('edge', e);
        },
        swipeEvent: function swipeEvent(e) {
          return _this5.$parent.$emit('swipe', e);
        }
      }));

      if (!state) return;

      if (state['swiping']) {
        this.clickable = false;
      }

      Object.assign(this.$data, state);
    },
    swipeEnd: function swipeEnd(e) {
      var state = innerSliderUtils_swipeEnd(e, _objectSpread2({}, this.$props, {}, this.$data, {
        trackRef: this.$refs.track,
        listRef: this.$refs.list,
        slideIndex: this.currentSlide
      }));

      if (!state) return;
      var triggerSlideHandler = state['triggerSlideHandler']; // delete state["triggerSlideHandler"];

      this.triggerSlideHandler = undefined;
      Object.assign(this.$data, state);
      if (triggerSlideHandler === undefined) return;
      this.slideHandler(triggerSlideHandler);

      if (this.verticalSwiping) {
        this.enableBodyScroll();
      }
    },
    prev: function prev() {
      var _this6 = this;

      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      this.callbackTimers.push(setTimeout(function () {
        return _this6.changeSlide({
          message: 'previous'
        });
      }, 0));
    },
    next: function next() {
      var _this7 = this;

      this.callbackTimers.push(setTimeout(function () {
        return _this7.changeSlide({
          message: 'next'
        });
      }, 0));
    },
    goTo: function goTo(slide) {
      var _this8 = this;

      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      slide = Number(slide);
      if (isNaN(slide)) return '';
      this.callbackTimers.push(setTimeout(function () {
        return _this8.changeSlide({
          message: 'index',
          index: slide,
          currentSlide: _this8.currentSlide
        }, dontAnimate);
      }, 0));
    },
    play: function play() {
      var nextIndex;

      if (this.rtl) {
        nextIndex = this.currentSlide - this.slidesToScroll;
      } else {
        if (canGoNext(_objectSpread2({}, this.$props, {}, this.$data))) {
          nextIndex = this.currentSlide + this.slidesToScroll;
        } else {
          return false;
        }
      }

      this.slideHandler(nextIndex);
    },
    autoPlay: function autoPlay(playType) {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
      }

      var autoplaying = this.autoplaying;

      if (playType === 'update') {
        if (autoplaying === 'hovered' || autoplaying === 'focused' || autoplaying === 'paused') {
          return;
        }
      } else if (playType === 'leave') {
        if (autoplaying === 'paused' || autoplaying === 'focused') {
          return;
        }
      } else if (playType === 'blur') {
        if (autoplaying === 'paused' || autoplaying === 'hovered') {
          return;
        }
      }

      this.autoplayTimer = setInterval(this.play, this.autoplaySpeed + 50);
      this.autoplaying = 'playing';
    },
    pause: function pause(pauseType) {
      if (this.autoplayTimer) {
        clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }

      var autoplaying = this.autoplaying;

      if (pauseType === 'paused') {
        this.autoplaying = 'paused';
      } else if (pauseType === 'focused') {
        if (autoplaying === 'hovered' || autoplaying === 'playing') {
          this.autoplaying = 'focused';
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === 'playing') {
          this.autoplaying = 'hovered';
        }
      }
    },
    onDotsOver: function onDotsOver() {
      this.autoplay && this.pause('hovered');
    },
    onDotsLeave: function onDotsLeave() {
      this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
    },
    onTrackOver: function onTrackOver() {
      this.autoplay && this.pause('hovered');
    },
    onTrackLeave: function onTrackLeave() {
      this.autoplay && this.autoplaying === 'hovered' && this.autoPlay('leave');
    },
    onSlideFocus: function onSlideFocus() {
      this.autoplay && this.pause('focused');
    },
    onSlideBlur: function onSlideBlur() {
      this.autoplay && this.autoplaying === 'focused' && this.autoPlay('blur');
    },
    selectHandler: function selectHandler(options) {
      if (this.focusOnSelect) {
        this.changeSlide(options);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var className = {
      'slick-slider': true,
      'slick-initialized': true,
      'slick-vertical': this.vertical
    };
    var trackProps = extractObject(this.spec, PROP_KEYS.TRACK);
    trackProps = filterUndefined(_objectSpread2({}, trackProps));
    var pauseOnHover = this.pauseOnHover;
    var trackNativeOn = filterUndefined({
      mouseenter: pauseOnHover ? this.onTrackOver : undefined,
      mouseover: pauseOnHover ? this.onTrackOver : undefined,
      mouseleave: pauseOnHover ? this.onTrackLeave : undefined
    });
    var dots;

    if (this.dots === true && this.slideCount >= this.slidesToShow) {
      var dotProps = extractObject(this.spec, PROP_KEYS.DOT);
      var pauseOnDotsHover = this.pauseOnDotsHover;
      var dotNativeOn = filterUndefined({
        mouseenter: pauseOnDotsHover ? this.onDotsLeave : undefined,
        mouseover: pauseOnDotsHover ? this.onDotsOver : undefined,
        mouseleave: pauseOnDotsHover ? this.onDotsLeave : undefined
      });
      dots = h(SliderDots, {
        "props": _objectSpread2({}, dotProps),
        "nativeOn": _objectSpread2({}, dotNativeOn),
        "on": {
          "dotClicked": this.changeSlide
        }
      });
    }

    var prevArrow, nextArrow;
    var arrowProps = extractObject(this.spec, PROP_KEYS.ARROW);

    if (this.arrows) {
      prevArrow = h(SliderArrow, {
        "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
          type: 'previous'
        })),
        "on": {
          "arrowClicked": this.changeSlide
        }
      });
      nextArrow = h(SliderArrow, {
        "props": _objectSpread2({}, _objectSpread2({}, arrowProps, {
          type: 'next'
        })),
        "on": {
          "arrowClicked": this.changeSlide
        }
      });
    }

    var verticalHeightStyle = {};

    if (this.vertical) {
      verticalHeightStyle = {
        height: "".concat(this.listHeight, "px")
      };
    }

    var centerPaddingStyle = {};

    if (this.vertical === false) {
      if (this.centerMode === true) {
        centerPaddingStyle = {
          padding: '0px ' + this.centerPadding
        };
      }
    } else {
      if (this.centerMode === true) {
        centerPaddingStyle = {
          padding: this.centerPadding + ' 0px'
        };
      }
    }

    var listStyle = _objectSpread2({}, this.$parent.$vnode.data.style);

    if (!this.unslick) {
      listStyle = _objectSpread2({}, listStyle, {}, filterUndefinedOrNull(verticalHeightStyle), {}, centerPaddingStyle);
    }

    var accessibility = this.accessibility,
        dragging = this.dragging,
        touchMove = this.touchMove;
    var listOn = filterUndefined({
      click: this.clickHandler,
      mousedown: touchMove ? this.swipeStart : undefined,
      mousemove: dragging && touchMove ? this.swipeMove : undefined,
      mouseup: touchMove ? this.swipeEnd : undefined,
      mouseleave: dragging && touchMove ? this.swipeEnd : undefined,
      touchstart: touchMove ? this.swipeStart : undefined,
      touchmove: dragging && touchMove ? this.swipeMove : undefined,
      touchend: touchMove ? this.swipeEnd : undefined,
      touchcancel: dragging && touchMove ? this.swipeEnd : undefined,
      keydown: accessibility ? this.keyHandler : undefined
    });
    return h("div", {
      "class": className,
      "attrs": {
        "dir": !this.unslick ? 'ltr' : false
      }
    }, [!this.unslick ? prevArrow : '', h("div", {
      "ref": "list",
      "class": 'slick-list',
      "on": _objectSpread2({}, listOn),
      "style": listStyle
    }, [h(SliderTrack, {
      "ref": "track",
      "props": _objectSpread2({}, trackProps),
      "nativeOn": _objectSpread2({}, trackNativeOn),
      "on": {
        "childClicked": this.selectHandler
      }
    }, [this.$slots.default])]), !this.unslick ? nextArrow : '', !this.unslick ? dots : '']);
  }
});
// CONCATENATED MODULE: ./src/InnerSlider.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_InnerSlidervue_type_script_lang_js_ = (InnerSlidervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/InnerSlider.vue?vue&type=style&index=0&id=3d1a4f76&scoped=true&lang=css&
var InnerSlidervue_type_style_index_0_id_3d1a4f76_scoped_true_lang_css_ = __webpack_require__("eaf9");

// CONCATENATED MODULE: ./src/InnerSlider.vue
var InnerSlider_render, InnerSlider_staticRenderFns





/* normalize component */

var InnerSlider_component = normalizeComponent(
  src_InnerSlidervue_type_script_lang_js_,
  InnerSlider_render,
  InnerSlider_staticRenderFns,
  false,
  null,
  "3d1a4f76",
  null
  
)

/* harmony default export */ var InnerSlider = (InnerSlider_component.exports);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/vuetify-loader/lib/loader.js??ref--19-0!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/VueSlickCarousel.vue?vue&type=script&lang=js&















var enquire = canUseDOM() && __webpack_require__("8e95");

/* harmony default export */ var VueSlickCarouselvue_type_script_lang_js_ = ({
  name: 'VueSlickCarousel',
  components: {
    InnerSlider: InnerSlider
  },
  mixins: [mixinPropsUpdated],
  inheritAttrs: false,
  props: defaultProps_props,
  data: function data() {
    return {
      breakpoint: null
    };
  },
  computed: {
    settings: function settings() {
      var _this = this;

      var props = filterUndefined(this.$props);
      var settings;
      var newProps;

      if (this.breakpoint) {
        newProps = this.responsive.filter(function (resp) {
          return resp.breakpoint === _this.breakpoint;
        });
        settings = newProps[0].settings === 'unslick' ? 'unslick' : _objectSpread2({}, defaultValues, {}, props, {}, newProps[0].settings);
      } else {
        settings = _objectSpread2({}, defaultValues, {}, props);
      } // force scrolling by one if centerMode is on


      if (settings.centerMode) {
        if (settings.slidesToScroll > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
        }

        settings.slidesToScroll = 1;
      } // force showing one slide and scrolling by one if the fade mode is on


      if (settings.fade) {
        if (settings.slidesToShow > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
        }

        if (settings.slidesToScroll > 1 && "production" !== 'production') {
          // eslint-disable-next-line no-console
          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
        }

        settings.slidesToShow = 1;
        settings.slidesToScroll = 1;
      } // rows and slidesPerRow logic is handled here


      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
        // eslint-disable-next-line no-console
        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
        settings.variableWidth = false;
      }

      return settings;
    }
  },
  created: function created() {
    this.makeBreakpoints();
  },
  beforeDestroy: function beforeDestroy() {
    this.clearBreakpoints();
  },
  methods: {
    prev: function prev() {
      this.$refs.innerSlider.prev();
    },
    next: function next() {
      this.$refs.innerSlider.next();
    },
    goTo: function goTo(slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.$refs.innerSlider.goTo(slide, dontAnimate);
    },
    pause: function pause() {
      this.$refs.innerSlider.pause('paused');
    },
    play: function play() {
      this.$refs.innerSlider.autoPlay('play');
    },
    onPropsUpdated: function onPropsUpdated() {
      this.clearBreakpoints();
      this.makeBreakpoints();
    },
    clearBreakpoints: function clearBreakpoints() {
      this.responsiveMediaHandlers.forEach(function (obj) {
        return enquire.unregister(obj.query, obj.handler);
      });
      this.responsiveMediaHandlers = [];
    },
    media: function media(query, handler) {
      // javascript handler for  css media query
      // when not using server side rendering
      if (!canUseDOM()) {
        return;
      }

      enquire.register(query, handler);
      this.responsiveMediaHandlers.push({
        query: query,
        handler: handler
      });
    },
    makeBreakpoints: function makeBreakpoints() {
      var _this2 = this;

      this.breakpoint = null;
      this.responsiveMediaHandlers = []; // handles responsive breakpoints

      if (this.responsive) {
        var breakpoints = this.responsive.map(function (breakpt) {
          return breakpt.breakpoint;
        }); // sort them in increasing order of their numerical value

        breakpoints.sort(function (x, y) {
          return x - y;
        });
        breakpoints.forEach(function (breakpoint, index) {
          // media query for each breakpoint
          var mediaQuery = json2mq_default()({
            minWidth: index === 0 ? 0 : breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });

          _this2.media(mediaQuery, function () {
            _this2.breakpoint = breakpoint;
          });
        }); // Register media query for full screen. Need to support resize from small to large
        // convert javascript object to media query string

        var query = json2mq_default()({
          minWidth: breakpoints.slice(-1)[0]
        });
        this.media(query, function () {
          _this2.breakpoint = null;
        });
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var settings = this.settings;
    var children = this.$slots.default || [];

    if (settings === 'unslick') {
      return h("div", {
        "class": "regular slider"
      }, [children]);
    }

    settings.prevArrow = this.$scopedSlots.prevArrow;
    settings.nextArrow = this.$scopedSlots.nextArrow;
    settings.customPaging = this.$scopedSlots.customPaging;
    children = children.filter(function (child) {
      return !!child.tag;
    });
    var newChildren = [];
    var currentWidth = null;

    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];

      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];

        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && vNodeUtils_getStyle(children[k])) {
            currentWidth = vNodeUtils_getStyle(children[k]).width;
          }

          if (k >= children.length) break;
          var clonedVNode = cloneVNode(children[k]);
          setVNodeData(clonedVNode, 'key', 100 * i + 10 * j + k);
          vNodeUtils_mergeVNodeData(clonedVNode, 'attrs', {
            tabIndex: -1
          });
          vNodeUtils_mergeVNodeData(clonedVNode, 'style', {
            width: "".concat(100 / settings.slidesPerRow, "%"),
            display: 'inline-block'
          });
          row.push(clonedVNode);
        }

        newSlide.push(h("div", {
          "key": 10 * i + j
        }, [row]));
      }

      if (settings.variableWidth) {
        newChildren.push(h("div", {
          "key": i,
          "style": {
            width: currentWidth
          }
        }, [newSlide]));
      } else {
        newChildren.push(h("div", {
          "key": i
        }, [newSlide]));
      }
    }

    if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }

    return h(InnerSlider, {
      "ref": "innerSlider",
      "props": _objectSpread2({}, settings),
      "key": Object.values(settings).join('')
    }, [newChildren]);
  }
});
// CONCATENATED MODULE: ./src/VueSlickCarousel.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_VueSlickCarouselvue_type_script_lang_js_ = (VueSlickCarouselvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/VueSlickCarousel.vue
var VueSlickCarousel_render, VueSlickCarousel_staticRenderFns




/* normalize component */

var VueSlickCarousel_component = normalizeComponent(
  src_VueSlickCarouselvue_type_script_lang_js_,
  VueSlickCarousel_render,
  VueSlickCarousel_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VueSlickCarousel = (VueSlickCarousel_component.exports);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (VueSlickCarousel);



/***/ }),

/***/ "fb6a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__("23e7");
var isObject = __webpack_require__("861d");
var isArray = __webpack_require__("e8b5");
var toAbsoluteIndex = __webpack_require__("23cb");
var toLength = __webpack_require__("50c4");
var toIndexedObject = __webpack_require__("fc6a");
var createProperty = __webpack_require__("8418");
var wellKnownSymbol = __webpack_require__("b622");
var arrayMethodHasSpeciesSupport = __webpack_require__("1dde");
var arrayMethodUsesToLength = __webpack_require__("ae40");

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');
var USES_TO_LENGTH = arrayMethodUsesToLength('slice', { ACCESSORS: true, 0: 0, 1: 2 });

var SPECIES = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.github.io/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT || !USES_TO_LENGTH }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ "fc6a":
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__("44ad");
var requireObjectCoercible = __webpack_require__("1d80");

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ "fdb2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fdbc":
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ "fdbf":
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__("4930");

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ })

/******/ })["default"];
});

},{}],261:[function(require,module,exports){
(function (global,setImmediate){(function (){
/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
'use strict';

/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "development" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "development" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

{
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (!config.async) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (customSetter) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (isUndef(target) || isPrimitive(target)
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
{
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "development" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (warnMissing && !res) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (isObject(def)) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

{
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

{
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (!isObject(bindObject)) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (key !== '' && key !== null) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (isDef(data) && isDef(data.key) && !isPrimitive(data.key)
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (isDef(data) && isDef(data.nativeOn)) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (vm.$options.renderError) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (Array.isArray(vnode)) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                "timeout (" + (res.timeout) + "ms)"
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (config.performance && mark) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (has[id] != null) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (!config.async) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression = expOrFn.toString();
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (getter == null) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (sharedPropertyDefinition.set === noop) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (config.performance && mark) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    {
      initProxy(vm);
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (config.performance && mark) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (!(this instanceof Vue)
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (name) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (type === 'component') {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (data && data.pre) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (typeof console !== 'undefined' &&
                !hydrationBailed
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    warn &&
    modifiers.prevent && modifiers.passive
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (explicitEnterDuration != null) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (isDef(explicitLeaveDuration)) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (children.length > 1) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (mode && mode !== 'in-out' && mode !== 'out-in'
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (config.productionTip !== false &&
      typeof console !== 'undefined'
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (staticClass) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (!stack.length && options.warn) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (options.outputSourceRange) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (i > pos || !tagName &&
          options.warn
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (options.outputSourceRange) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (options.outputSourceRange) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (options.outputSourceRange) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (children[i].text !== ' ') {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (slotScope) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (el.attrsMap['v-for']) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (el.key) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          value.trim().length === 0
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (name === 'model') {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      map[attrs[i].name] && !isIE && !isEdge
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (dir.modifiers) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (state.maybeComponent(el) &&
    el.tag !== 'slot' &&
    el.tag !== 'template' &&
    !el.key
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (el.children.length !== 1 || ast.type !== 1) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (options.outputSourceRange) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (!template) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (config.performance && mark) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "development" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (config.performance && mark) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

module.exports = Vue;

}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"timers":256}],262:[function(require,module,exports){
(function (process){(function (){
if (process.env.NODE_ENV === 'production') {
  module.exports = require('./vue.common.prod.js')
} else {
  module.exports = require('./vue.common.dev.js')
}

}).call(this)}).call(this,require('_process'))

},{"./vue.common.dev.js":261,"./vue.common.prod.js":263,"_process":216}],263:[function(require,module,exports){
(function (global,setImmediate){(function (){
/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
"use strict";var e=Object.freeze({});function t(e){return null==e}function n(e){return null!=e}function r(e){return!0===e}function i(e){return"string"==typeof e||"number"==typeof e||"symbol"==typeof e||"boolean"==typeof e}function o(e){return null!==e&&"object"==typeof e}var a=Object.prototype.toString;function s(e){return"[object Object]"===a.call(e)}function c(e){var t=parseFloat(String(e));return t>=0&&Math.floor(t)===t&&isFinite(e)}function u(e){return n(e)&&"function"==typeof e.then&&"function"==typeof e.catch}function l(e){return null==e?"":Array.isArray(e)||s(e)&&e.toString===a?JSON.stringify(e,null,2):String(e)}function f(e){var t=parseFloat(e);return isNaN(t)?e:t}function p(e,t){for(var n=Object.create(null),r=e.split(","),i=0;i<r.length;i++)n[r[i]]=!0;return t?function(e){return n[e.toLowerCase()]}:function(e){return n[e]}}var d=p("slot,component",!0),v=p("key,ref,slot,slot-scope,is");function h(e,t){if(e.length){var n=e.indexOf(t);if(n>-1)return e.splice(n,1)}}var m=Object.prototype.hasOwnProperty;function y(e,t){return m.call(e,t)}function g(e){var t=Object.create(null);return function(n){return t[n]||(t[n]=e(n))}}var _=/-(\w)/g,b=g(function(e){return e.replace(_,function(e,t){return t?t.toUpperCase():""})}),$=g(function(e){return e.charAt(0).toUpperCase()+e.slice(1)}),w=/\B([A-Z])/g,C=g(function(e){return e.replace(w,"-$1").toLowerCase()});var x=Function.prototype.bind?function(e,t){return e.bind(t)}:function(e,t){function n(n){var r=arguments.length;return r?r>1?e.apply(t,arguments):e.call(t,n):e.call(t)}return n._length=e.length,n};function k(e,t){t=t||0;for(var n=e.length-t,r=new Array(n);n--;)r[n]=e[n+t];return r}function A(e,t){for(var n in t)e[n]=t[n];return e}function O(e){for(var t={},n=0;n<e.length;n++)e[n]&&A(t,e[n]);return t}function S(e,t,n){}var T=function(e,t,n){return!1},E=function(e){return e};function N(e,t){if(e===t)return!0;var n=o(e),r=o(t);if(!n||!r)return!n&&!r&&String(e)===String(t);try{var i=Array.isArray(e),a=Array.isArray(t);if(i&&a)return e.length===t.length&&e.every(function(e,n){return N(e,t[n])});if(e instanceof Date&&t instanceof Date)return e.getTime()===t.getTime();if(i||a)return!1;var s=Object.keys(e),c=Object.keys(t);return s.length===c.length&&s.every(function(n){return N(e[n],t[n])})}catch(e){return!1}}function j(e,t){for(var n=0;n<e.length;n++)if(N(e[n],t))return n;return-1}function D(e){var t=!1;return function(){t||(t=!0,e.apply(this,arguments))}}var L="data-server-rendered",M=["component","directive","filter"],I=["beforeCreate","created","beforeMount","mounted","beforeUpdate","updated","beforeDestroy","destroyed","activated","deactivated","errorCaptured","serverPrefetch"],F={optionMergeStrategies:Object.create(null),silent:!1,productionTip:!1,devtools:!1,performance:!1,errorHandler:null,warnHandler:null,ignoredElements:[],keyCodes:Object.create(null),isReservedTag:T,isReservedAttr:T,isUnknownElement:T,getTagNamespace:S,parsePlatformTagName:E,mustUseProp:T,async:!0,_lifecycleHooks:I},P=/a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;function R(e,t,n,r){Object.defineProperty(e,t,{value:n,enumerable:!!r,writable:!0,configurable:!0})}var H=new RegExp("[^"+P.source+".$_\\d]");var B,U="__proto__"in{},z="undefined"!=typeof window,V="undefined"!=typeof WXEnvironment&&!!WXEnvironment.platform,K=V&&WXEnvironment.platform.toLowerCase(),J=z&&window.navigator.userAgent.toLowerCase(),q=J&&/msie|trident/.test(J),W=J&&J.indexOf("msie 9.0")>0,Z=J&&J.indexOf("edge/")>0,G=(J&&J.indexOf("android"),J&&/iphone|ipad|ipod|ios/.test(J)||"ios"===K),X=(J&&/chrome\/\d+/.test(J),J&&/phantomjs/.test(J),J&&J.match(/firefox\/(\d+)/)),Y={}.watch,Q=!1;if(z)try{var ee={};Object.defineProperty(ee,"passive",{get:function(){Q=!0}}),window.addEventListener("test-passive",null,ee)}catch(e){}var te=function(){return void 0===B&&(B=!z&&!V&&"undefined"!=typeof global&&(global.process&&"server"===global.process.env.VUE_ENV)),B},ne=z&&window.__VUE_DEVTOOLS_GLOBAL_HOOK__;function re(e){return"function"==typeof e&&/native code/.test(e.toString())}var ie,oe="undefined"!=typeof Symbol&&re(Symbol)&&"undefined"!=typeof Reflect&&re(Reflect.ownKeys);ie="undefined"!=typeof Set&&re(Set)?Set:function(){function e(){this.set=Object.create(null)}return e.prototype.has=function(e){return!0===this.set[e]},e.prototype.add=function(e){this.set[e]=!0},e.prototype.clear=function(){this.set=Object.create(null)},e}();var ae=S,se=0,ce=function(){this.id=se++,this.subs=[]};ce.prototype.addSub=function(e){this.subs.push(e)},ce.prototype.removeSub=function(e){h(this.subs,e)},ce.prototype.depend=function(){ce.target&&ce.target.addDep(this)},ce.prototype.notify=function(){for(var e=this.subs.slice(),t=0,n=e.length;t<n;t++)e[t].update()},ce.target=null;var ue=[];function le(e){ue.push(e),ce.target=e}function fe(){ue.pop(),ce.target=ue[ue.length-1]}var pe=function(e,t,n,r,i,o,a,s){this.tag=e,this.data=t,this.children=n,this.text=r,this.elm=i,this.ns=void 0,this.context=o,this.fnContext=void 0,this.fnOptions=void 0,this.fnScopeId=void 0,this.key=t&&t.key,this.componentOptions=a,this.componentInstance=void 0,this.parent=void 0,this.raw=!1,this.isStatic=!1,this.isRootInsert=!0,this.isComment=!1,this.isCloned=!1,this.isOnce=!1,this.asyncFactory=s,this.asyncMeta=void 0,this.isAsyncPlaceholder=!1},de={child:{configurable:!0}};de.child.get=function(){return this.componentInstance},Object.defineProperties(pe.prototype,de);var ve=function(e){void 0===e&&(e="");var t=new pe;return t.text=e,t.isComment=!0,t};function he(e){return new pe(void 0,void 0,void 0,String(e))}function me(e){var t=new pe(e.tag,e.data,e.children&&e.children.slice(),e.text,e.elm,e.context,e.componentOptions,e.asyncFactory);return t.ns=e.ns,t.isStatic=e.isStatic,t.key=e.key,t.isComment=e.isComment,t.fnContext=e.fnContext,t.fnOptions=e.fnOptions,t.fnScopeId=e.fnScopeId,t.asyncMeta=e.asyncMeta,t.isCloned=!0,t}var ye=Array.prototype,ge=Object.create(ye);["push","pop","shift","unshift","splice","sort","reverse"].forEach(function(e){var t=ye[e];R(ge,e,function(){for(var n=[],r=arguments.length;r--;)n[r]=arguments[r];var i,o=t.apply(this,n),a=this.__ob__;switch(e){case"push":case"unshift":i=n;break;case"splice":i=n.slice(2)}return i&&a.observeArray(i),a.dep.notify(),o})});var _e=Object.getOwnPropertyNames(ge),be=!0;function $e(e){be=e}var we=function(e){var t;this.value=e,this.dep=new ce,this.vmCount=0,R(e,"__ob__",this),Array.isArray(e)?(U?(t=ge,e.__proto__=t):function(e,t,n){for(var r=0,i=n.length;r<i;r++){var o=n[r];R(e,o,t[o])}}(e,ge,_e),this.observeArray(e)):this.walk(e)};function Ce(e,t){var n;if(o(e)&&!(e instanceof pe))return y(e,"__ob__")&&e.__ob__ instanceof we?n=e.__ob__:be&&!te()&&(Array.isArray(e)||s(e))&&Object.isExtensible(e)&&!e._isVue&&(n=new we(e)),t&&n&&n.vmCount++,n}function xe(e,t,n,r,i){var o=new ce,a=Object.getOwnPropertyDescriptor(e,t);if(!a||!1!==a.configurable){var s=a&&a.get,c=a&&a.set;s&&!c||2!==arguments.length||(n=e[t]);var u=!i&&Ce(n);Object.defineProperty(e,t,{enumerable:!0,configurable:!0,get:function(){var t=s?s.call(e):n;return ce.target&&(o.depend(),u&&(u.dep.depend(),Array.isArray(t)&&function e(t){for(var n=void 0,r=0,i=t.length;r<i;r++)(n=t[r])&&n.__ob__&&n.__ob__.dep.depend(),Array.isArray(n)&&e(n)}(t))),t},set:function(t){var r=s?s.call(e):n;t===r||t!=t&&r!=r||s&&!c||(c?c.call(e,t):n=t,u=!i&&Ce(t),o.notify())}})}}function ke(e,t,n){if(Array.isArray(e)&&c(t))return e.length=Math.max(e.length,t),e.splice(t,1,n),n;if(t in e&&!(t in Object.prototype))return e[t]=n,n;var r=e.__ob__;return e._isVue||r&&r.vmCount?n:r?(xe(r.value,t,n),r.dep.notify(),n):(e[t]=n,n)}function Ae(e,t){if(Array.isArray(e)&&c(t))e.splice(t,1);else{var n=e.__ob__;e._isVue||n&&n.vmCount||y(e,t)&&(delete e[t],n&&n.dep.notify())}}we.prototype.walk=function(e){for(var t=Object.keys(e),n=0;n<t.length;n++)xe(e,t[n])},we.prototype.observeArray=function(e){for(var t=0,n=e.length;t<n;t++)Ce(e[t])};var Oe=F.optionMergeStrategies;function Se(e,t){if(!t)return e;for(var n,r,i,o=oe?Reflect.ownKeys(t):Object.keys(t),a=0;a<o.length;a++)"__ob__"!==(n=o[a])&&(r=e[n],i=t[n],y(e,n)?r!==i&&s(r)&&s(i)&&Se(r,i):ke(e,n,i));return e}function Te(e,t,n){return n?function(){var r="function"==typeof t?t.call(n,n):t,i="function"==typeof e?e.call(n,n):e;return r?Se(r,i):i}:t?e?function(){return Se("function"==typeof t?t.call(this,this):t,"function"==typeof e?e.call(this,this):e)}:t:e}function Ee(e,t){var n=t?e?e.concat(t):Array.isArray(t)?t:[t]:e;return n?function(e){for(var t=[],n=0;n<e.length;n++)-1===t.indexOf(e[n])&&t.push(e[n]);return t}(n):n}function Ne(e,t,n,r){var i=Object.create(e||null);return t?A(i,t):i}Oe.data=function(e,t,n){return n?Te(e,t,n):t&&"function"!=typeof t?e:Te(e,t)},I.forEach(function(e){Oe[e]=Ee}),M.forEach(function(e){Oe[e+"s"]=Ne}),Oe.watch=function(e,t,n,r){if(e===Y&&(e=void 0),t===Y&&(t=void 0),!t)return Object.create(e||null);if(!e)return t;var i={};for(var o in A(i,e),t){var a=i[o],s=t[o];a&&!Array.isArray(a)&&(a=[a]),i[o]=a?a.concat(s):Array.isArray(s)?s:[s]}return i},Oe.props=Oe.methods=Oe.inject=Oe.computed=function(e,t,n,r){if(!e)return t;var i=Object.create(null);return A(i,e),t&&A(i,t),i},Oe.provide=Te;var je=function(e,t){return void 0===t?e:t};function De(e,t,n){if("function"==typeof t&&(t=t.options),function(e,t){var n=e.props;if(n){var r,i,o={};if(Array.isArray(n))for(r=n.length;r--;)"string"==typeof(i=n[r])&&(o[b(i)]={type:null});else if(s(n))for(var a in n)i=n[a],o[b(a)]=s(i)?i:{type:i};e.props=o}}(t),function(e,t){var n=e.inject;if(n){var r=e.inject={};if(Array.isArray(n))for(var i=0;i<n.length;i++)r[n[i]]={from:n[i]};else if(s(n))for(var o in n){var a=n[o];r[o]=s(a)?A({from:o},a):{from:a}}}}(t),function(e){var t=e.directives;if(t)for(var n in t){var r=t[n];"function"==typeof r&&(t[n]={bind:r,update:r})}}(t),!t._base&&(t.extends&&(e=De(e,t.extends,n)),t.mixins))for(var r=0,i=t.mixins.length;r<i;r++)e=De(e,t.mixins[r],n);var o,a={};for(o in e)c(o);for(o in t)y(e,o)||c(o);function c(r){var i=Oe[r]||je;a[r]=i(e[r],t[r],n,r)}return a}function Le(e,t,n,r){if("string"==typeof n){var i=e[t];if(y(i,n))return i[n];var o=b(n);if(y(i,o))return i[o];var a=$(o);return y(i,a)?i[a]:i[n]||i[o]||i[a]}}function Me(e,t,n,r){var i=t[e],o=!y(n,e),a=n[e],s=Pe(Boolean,i.type);if(s>-1)if(o&&!y(i,"default"))a=!1;else if(""===a||a===C(e)){var c=Pe(String,i.type);(c<0||s<c)&&(a=!0)}if(void 0===a){a=function(e,t,n){if(!y(t,"default"))return;var r=t.default;if(e&&e.$options.propsData&&void 0===e.$options.propsData[n]&&void 0!==e._props[n])return e._props[n];return"function"==typeof r&&"Function"!==Ie(t.type)?r.call(e):r}(r,i,e);var u=be;$e(!0),Ce(a),$e(u)}return a}function Ie(e){var t=e&&e.toString().match(/^\s*function (\w+)/);return t?t[1]:""}function Fe(e,t){return Ie(e)===Ie(t)}function Pe(e,t){if(!Array.isArray(t))return Fe(t,e)?0:-1;for(var n=0,r=t.length;n<r;n++)if(Fe(t[n],e))return n;return-1}function Re(e,t,n){le();try{if(t)for(var r=t;r=r.$parent;){var i=r.$options.errorCaptured;if(i)for(var o=0;o<i.length;o++)try{if(!1===i[o].call(r,e,t,n))return}catch(e){Be(e,r,"errorCaptured hook")}}Be(e,t,n)}finally{fe()}}function He(e,t,n,r,i){var o;try{(o=n?e.apply(t,n):e.call(t))&&!o._isVue&&u(o)&&!o._handled&&(o.catch(function(e){return Re(e,r,i+" (Promise/async)")}),o._handled=!0)}catch(e){Re(e,r,i)}return o}function Be(e,t,n){if(F.errorHandler)try{return F.errorHandler.call(null,e,t,n)}catch(t){t!==e&&Ue(t,null,"config.errorHandler")}Ue(e,t,n)}function Ue(e,t,n){if(!z&&!V||"undefined"==typeof console)throw e;console.error(e)}var ze,Ve=!1,Ke=[],Je=!1;function qe(){Je=!1;var e=Ke.slice(0);Ke.length=0;for(var t=0;t<e.length;t++)e[t]()}if("undefined"!=typeof Promise&&re(Promise)){var We=Promise.resolve();ze=function(){We.then(qe),G&&setTimeout(S)},Ve=!0}else if(q||"undefined"==typeof MutationObserver||!re(MutationObserver)&&"[object MutationObserverConstructor]"!==MutationObserver.toString())ze="undefined"!=typeof setImmediate&&re(setImmediate)?function(){setImmediate(qe)}:function(){setTimeout(qe,0)};else{var Ze=1,Ge=new MutationObserver(qe),Xe=document.createTextNode(String(Ze));Ge.observe(Xe,{characterData:!0}),ze=function(){Ze=(Ze+1)%2,Xe.data=String(Ze)},Ve=!0}function Ye(e,t){var n;if(Ke.push(function(){if(e)try{e.call(t)}catch(e){Re(e,t,"nextTick")}else n&&n(t)}),Je||(Je=!0,ze()),!e&&"undefined"!=typeof Promise)return new Promise(function(e){n=e})}var Qe=new ie;function et(e){!function e(t,n){var r,i;var a=Array.isArray(t);if(!a&&!o(t)||Object.isFrozen(t)||t instanceof pe)return;if(t.__ob__){var s=t.__ob__.dep.id;if(n.has(s))return;n.add(s)}if(a)for(r=t.length;r--;)e(t[r],n);else for(i=Object.keys(t),r=i.length;r--;)e(t[i[r]],n)}(e,Qe),Qe.clear()}var tt=g(function(e){var t="&"===e.charAt(0),n="~"===(e=t?e.slice(1):e).charAt(0),r="!"===(e=n?e.slice(1):e).charAt(0);return{name:e=r?e.slice(1):e,once:n,capture:r,passive:t}});function nt(e,t){function n(){var e=arguments,r=n.fns;if(!Array.isArray(r))return He(r,null,arguments,t,"v-on handler");for(var i=r.slice(),o=0;o<i.length;o++)He(i[o],null,e,t,"v-on handler")}return n.fns=e,n}function rt(e,n,i,o,a,s){var c,u,l,f;for(c in e)u=e[c],l=n[c],f=tt(c),t(u)||(t(l)?(t(u.fns)&&(u=e[c]=nt(u,s)),r(f.once)&&(u=e[c]=a(f.name,u,f.capture)),i(f.name,u,f.capture,f.passive,f.params)):u!==l&&(l.fns=u,e[c]=l));for(c in n)t(e[c])&&o((f=tt(c)).name,n[c],f.capture)}function it(e,i,o){var a;e instanceof pe&&(e=e.data.hook||(e.data.hook={}));var s=e[i];function c(){o.apply(this,arguments),h(a.fns,c)}t(s)?a=nt([c]):n(s.fns)&&r(s.merged)?(a=s).fns.push(c):a=nt([s,c]),a.merged=!0,e[i]=a}function ot(e,t,r,i,o){if(n(t)){if(y(t,r))return e[r]=t[r],o||delete t[r],!0;if(y(t,i))return e[r]=t[i],o||delete t[i],!0}return!1}function at(e){return i(e)?[he(e)]:Array.isArray(e)?function e(o,a){var s=[];var c,u,l,f;for(c=0;c<o.length;c++)t(u=o[c])||"boolean"==typeof u||(l=s.length-1,f=s[l],Array.isArray(u)?u.length>0&&(st((u=e(u,(a||"")+"_"+c))[0])&&st(f)&&(s[l]=he(f.text+u[0].text),u.shift()),s.push.apply(s,u)):i(u)?st(f)?s[l]=he(f.text+u):""!==u&&s.push(he(u)):st(u)&&st(f)?s[l]=he(f.text+u.text):(r(o._isVList)&&n(u.tag)&&t(u.key)&&n(a)&&(u.key="__vlist"+a+"_"+c+"__"),s.push(u)));return s}(e):void 0}function st(e){return n(e)&&n(e.text)&&!1===e.isComment}function ct(e,t){if(e){for(var n=Object.create(null),r=oe?Reflect.ownKeys(e):Object.keys(e),i=0;i<r.length;i++){var o=r[i];if("__ob__"!==o){for(var a=e[o].from,s=t;s;){if(s._provided&&y(s._provided,a)){n[o]=s._provided[a];break}s=s.$parent}if(!s&&"default"in e[o]){var c=e[o].default;n[o]="function"==typeof c?c.call(t):c}}}return n}}function ut(e,t){if(!e||!e.length)return{};for(var n={},r=0,i=e.length;r<i;r++){var o=e[r],a=o.data;if(a&&a.attrs&&a.attrs.slot&&delete a.attrs.slot,o.context!==t&&o.fnContext!==t||!a||null==a.slot)(n.default||(n.default=[])).push(o);else{var s=a.slot,c=n[s]||(n[s]=[]);"template"===o.tag?c.push.apply(c,o.children||[]):c.push(o)}}for(var u in n)n[u].every(lt)&&delete n[u];return n}function lt(e){return e.isComment&&!e.asyncFactory||" "===e.text}function ft(t,n,r){var i,o=Object.keys(n).length>0,a=t?!!t.$stable:!o,s=t&&t.$key;if(t){if(t._normalized)return t._normalized;if(a&&r&&r!==e&&s===r.$key&&!o&&!r.$hasNormal)return r;for(var c in i={},t)t[c]&&"$"!==c[0]&&(i[c]=pt(n,c,t[c]))}else i={};for(var u in n)u in i||(i[u]=dt(n,u));return t&&Object.isExtensible(t)&&(t._normalized=i),R(i,"$stable",a),R(i,"$key",s),R(i,"$hasNormal",o),i}function pt(e,t,n){var r=function(){var e=arguments.length?n.apply(null,arguments):n({});return(e=e&&"object"==typeof e&&!Array.isArray(e)?[e]:at(e))&&(0===e.length||1===e.length&&e[0].isComment)?void 0:e};return n.proxy&&Object.defineProperty(e,t,{get:r,enumerable:!0,configurable:!0}),r}function dt(e,t){return function(){return e[t]}}function vt(e,t){var r,i,a,s,c;if(Array.isArray(e)||"string"==typeof e)for(r=new Array(e.length),i=0,a=e.length;i<a;i++)r[i]=t(e[i],i);else if("number"==typeof e)for(r=new Array(e),i=0;i<e;i++)r[i]=t(i+1,i);else if(o(e))if(oe&&e[Symbol.iterator]){r=[];for(var u=e[Symbol.iterator](),l=u.next();!l.done;)r.push(t(l.value,r.length)),l=u.next()}else for(s=Object.keys(e),r=new Array(s.length),i=0,a=s.length;i<a;i++)c=s[i],r[i]=t(e[c],c,i);return n(r)||(r=[]),r._isVList=!0,r}function ht(e,t,n,r){var i,o=this.$scopedSlots[e];o?(n=n||{},r&&(n=A(A({},r),n)),i=o(n)||t):i=this.$slots[e]||t;var a=n&&n.slot;return a?this.$createElement("template",{slot:a},i):i}function mt(e){return Le(this.$options,"filters",e)||E}function yt(e,t){return Array.isArray(e)?-1===e.indexOf(t):e!==t}function gt(e,t,n,r,i){var o=F.keyCodes[t]||n;return i&&r&&!F.keyCodes[t]?yt(i,r):o?yt(o,e):r?C(r)!==t:void 0}function _t(e,t,n,r,i){if(n)if(o(n)){var a;Array.isArray(n)&&(n=O(n));var s=function(o){if("class"===o||"style"===o||v(o))a=e;else{var s=e.attrs&&e.attrs.type;a=r||F.mustUseProp(t,s,o)?e.domProps||(e.domProps={}):e.attrs||(e.attrs={})}var c=b(o),u=C(o);c in a||u in a||(a[o]=n[o],i&&((e.on||(e.on={}))["update:"+o]=function(e){n[o]=e}))};for(var c in n)s(c)}else;return e}function bt(e,t){var n=this._staticTrees||(this._staticTrees=[]),r=n[e];return r&&!t?r:(wt(r=n[e]=this.$options.staticRenderFns[e].call(this._renderProxy,null,this),"__static__"+e,!1),r)}function $t(e,t,n){return wt(e,"__once__"+t+(n?"_"+n:""),!0),e}function wt(e,t,n){if(Array.isArray(e))for(var r=0;r<e.length;r++)e[r]&&"string"!=typeof e[r]&&Ct(e[r],t+"_"+r,n);else Ct(e,t,n)}function Ct(e,t,n){e.isStatic=!0,e.key=t,e.isOnce=n}function xt(e,t){if(t)if(s(t)){var n=e.on=e.on?A({},e.on):{};for(var r in t){var i=n[r],o=t[r];n[r]=i?[].concat(i,o):o}}else;return e}function kt(e,t,n,r){t=t||{$stable:!n};for(var i=0;i<e.length;i++){var o=e[i];Array.isArray(o)?kt(o,t,n):o&&(o.proxy&&(o.fn.proxy=!0),t[o.key]=o.fn)}return r&&(t.$key=r),t}function At(e,t){for(var n=0;n<t.length;n+=2){var r=t[n];"string"==typeof r&&r&&(e[t[n]]=t[n+1])}return e}function Ot(e,t){return"string"==typeof e?t+e:e}function St(e){e._o=$t,e._n=f,e._s=l,e._l=vt,e._t=ht,e._q=N,e._i=j,e._m=bt,e._f=mt,e._k=gt,e._b=_t,e._v=he,e._e=ve,e._u=kt,e._g=xt,e._d=At,e._p=Ot}function Tt(t,n,i,o,a){var s,c=this,u=a.options;y(o,"_uid")?(s=Object.create(o))._original=o:(s=o,o=o._original);var l=r(u._compiled),f=!l;this.data=t,this.props=n,this.children=i,this.parent=o,this.listeners=t.on||e,this.injections=ct(u.inject,o),this.slots=function(){return c.$slots||ft(t.scopedSlots,c.$slots=ut(i,o)),c.$slots},Object.defineProperty(this,"scopedSlots",{enumerable:!0,get:function(){return ft(t.scopedSlots,this.slots())}}),l&&(this.$options=u,this.$slots=this.slots(),this.$scopedSlots=ft(t.scopedSlots,this.$slots)),u._scopeId?this._c=function(e,t,n,r){var i=Pt(s,e,t,n,r,f);return i&&!Array.isArray(i)&&(i.fnScopeId=u._scopeId,i.fnContext=o),i}:this._c=function(e,t,n,r){return Pt(s,e,t,n,r,f)}}function Et(e,t,n,r,i){var o=me(e);return o.fnContext=n,o.fnOptions=r,t.slot&&((o.data||(o.data={})).slot=t.slot),o}function Nt(e,t){for(var n in t)e[b(n)]=t[n]}St(Tt.prototype);var jt={init:function(e,t){if(e.componentInstance&&!e.componentInstance._isDestroyed&&e.data.keepAlive){var r=e;jt.prepatch(r,r)}else{(e.componentInstance=function(e,t){var r={_isComponent:!0,_parentVnode:e,parent:t},i=e.data.inlineTemplate;n(i)&&(r.render=i.render,r.staticRenderFns=i.staticRenderFns);return new e.componentOptions.Ctor(r)}(e,Wt)).$mount(t?e.elm:void 0,t)}},prepatch:function(t,n){var r=n.componentOptions;!function(t,n,r,i,o){var a=i.data.scopedSlots,s=t.$scopedSlots,c=!!(a&&!a.$stable||s!==e&&!s.$stable||a&&t.$scopedSlots.$key!==a.$key),u=!!(o||t.$options._renderChildren||c);t.$options._parentVnode=i,t.$vnode=i,t._vnode&&(t._vnode.parent=i);if(t.$options._renderChildren=o,t.$attrs=i.data.attrs||e,t.$listeners=r||e,n&&t.$options.props){$e(!1);for(var l=t._props,f=t.$options._propKeys||[],p=0;p<f.length;p++){var d=f[p],v=t.$options.props;l[d]=Me(d,v,n,t)}$e(!0),t.$options.propsData=n}r=r||e;var h=t.$options._parentListeners;t.$options._parentListeners=r,qt(t,r,h),u&&(t.$slots=ut(o,i.context),t.$forceUpdate())}(n.componentInstance=t.componentInstance,r.propsData,r.listeners,n,r.children)},insert:function(e){var t,n=e.context,r=e.componentInstance;r._isMounted||(r._isMounted=!0,Yt(r,"mounted")),e.data.keepAlive&&(n._isMounted?((t=r)._inactive=!1,en.push(t)):Xt(r,!0))},destroy:function(e){var t=e.componentInstance;t._isDestroyed||(e.data.keepAlive?function e(t,n){if(n&&(t._directInactive=!0,Gt(t)))return;if(!t._inactive){t._inactive=!0;for(var r=0;r<t.$children.length;r++)e(t.$children[r]);Yt(t,"deactivated")}}(t,!0):t.$destroy())}},Dt=Object.keys(jt);function Lt(i,a,s,c,l){if(!t(i)){var f=s.$options._base;if(o(i)&&(i=f.extend(i)),"function"==typeof i){var p;if(t(i.cid)&&void 0===(i=function(e,i){if(r(e.error)&&n(e.errorComp))return e.errorComp;if(n(e.resolved))return e.resolved;var a=Ht;a&&n(e.owners)&&-1===e.owners.indexOf(a)&&e.owners.push(a);if(r(e.loading)&&n(e.loadingComp))return e.loadingComp;if(a&&!n(e.owners)){var s=e.owners=[a],c=!0,l=null,f=null;a.$on("hook:destroyed",function(){return h(s,a)});var p=function(e){for(var t=0,n=s.length;t<n;t++)s[t].$forceUpdate();e&&(s.length=0,null!==l&&(clearTimeout(l),l=null),null!==f&&(clearTimeout(f),f=null))},d=D(function(t){e.resolved=Bt(t,i),c?s.length=0:p(!0)}),v=D(function(t){n(e.errorComp)&&(e.error=!0,p(!0))}),m=e(d,v);return o(m)&&(u(m)?t(e.resolved)&&m.then(d,v):u(m.component)&&(m.component.then(d,v),n(m.error)&&(e.errorComp=Bt(m.error,i)),n(m.loading)&&(e.loadingComp=Bt(m.loading,i),0===m.delay?e.loading=!0:l=setTimeout(function(){l=null,t(e.resolved)&&t(e.error)&&(e.loading=!0,p(!1))},m.delay||200)),n(m.timeout)&&(f=setTimeout(function(){f=null,t(e.resolved)&&v(null)},m.timeout)))),c=!1,e.loading?e.loadingComp:e.resolved}}(p=i,f)))return function(e,t,n,r,i){var o=ve();return o.asyncFactory=e,o.asyncMeta={data:t,context:n,children:r,tag:i},o}(p,a,s,c,l);a=a||{},$n(i),n(a.model)&&function(e,t){var r=e.model&&e.model.prop||"value",i=e.model&&e.model.event||"input";(t.attrs||(t.attrs={}))[r]=t.model.value;var o=t.on||(t.on={}),a=o[i],s=t.model.callback;n(a)?(Array.isArray(a)?-1===a.indexOf(s):a!==s)&&(o[i]=[s].concat(a)):o[i]=s}(i.options,a);var d=function(e,r,i){var o=r.options.props;if(!t(o)){var a={},s=e.attrs,c=e.props;if(n(s)||n(c))for(var u in o){var l=C(u);ot(a,c,u,l,!0)||ot(a,s,u,l,!1)}return a}}(a,i);if(r(i.options.functional))return function(t,r,i,o,a){var s=t.options,c={},u=s.props;if(n(u))for(var l in u)c[l]=Me(l,u,r||e);else n(i.attrs)&&Nt(c,i.attrs),n(i.props)&&Nt(c,i.props);var f=new Tt(i,c,a,o,t),p=s.render.call(null,f._c,f);if(p instanceof pe)return Et(p,i,f.parent,s);if(Array.isArray(p)){for(var d=at(p)||[],v=new Array(d.length),h=0;h<d.length;h++)v[h]=Et(d[h],i,f.parent,s);return v}}(i,d,a,s,c);var v=a.on;if(a.on=a.nativeOn,r(i.options.abstract)){var m=a.slot;a={},m&&(a.slot=m)}!function(e){for(var t=e.hook||(e.hook={}),n=0;n<Dt.length;n++){var r=Dt[n],i=t[r],o=jt[r];i===o||i&&i._merged||(t[r]=i?Mt(o,i):o)}}(a);var y=i.options.name||l;return new pe("vue-component-"+i.cid+(y?"-"+y:""),a,void 0,void 0,void 0,s,{Ctor:i,propsData:d,listeners:v,tag:l,children:c},p)}}}function Mt(e,t){var n=function(n,r){e(n,r),t(n,r)};return n._merged=!0,n}var It=1,Ft=2;function Pt(e,a,s,c,u,l){return(Array.isArray(s)||i(s))&&(u=c,c=s,s=void 0),r(l)&&(u=Ft),function(e,i,a,s,c){if(n(a)&&n(a.__ob__))return ve();n(a)&&n(a.is)&&(i=a.is);if(!i)return ve();Array.isArray(s)&&"function"==typeof s[0]&&((a=a||{}).scopedSlots={default:s[0]},s.length=0);c===Ft?s=at(s):c===It&&(s=function(e){for(var t=0;t<e.length;t++)if(Array.isArray(e[t]))return Array.prototype.concat.apply([],e);return e}(s));var u,l;if("string"==typeof i){var f;l=e.$vnode&&e.$vnode.ns||F.getTagNamespace(i),u=F.isReservedTag(i)?new pe(F.parsePlatformTagName(i),a,s,void 0,void 0,e):a&&a.pre||!n(f=Le(e.$options,"components",i))?new pe(i,a,s,void 0,void 0,e):Lt(f,a,e,s,i)}else u=Lt(i,a,e,s);return Array.isArray(u)?u:n(u)?(n(l)&&function e(i,o,a){i.ns=o;"foreignObject"===i.tag&&(o=void 0,a=!0);if(n(i.children))for(var s=0,c=i.children.length;s<c;s++){var u=i.children[s];n(u.tag)&&(t(u.ns)||r(a)&&"svg"!==u.tag)&&e(u,o,a)}}(u,l),n(a)&&function(e){o(e.style)&&et(e.style);o(e.class)&&et(e.class)}(a),u):ve()}(e,a,s,c,u)}var Rt,Ht=null;function Bt(e,t){return(e.__esModule||oe&&"Module"===e[Symbol.toStringTag])&&(e=e.default),o(e)?t.extend(e):e}function Ut(e){return e.isComment&&e.asyncFactory}function zt(e){if(Array.isArray(e))for(var t=0;t<e.length;t++){var r=e[t];if(n(r)&&(n(r.componentOptions)||Ut(r)))return r}}function Vt(e,t){Rt.$on(e,t)}function Kt(e,t){Rt.$off(e,t)}function Jt(e,t){var n=Rt;return function r(){null!==t.apply(null,arguments)&&n.$off(e,r)}}function qt(e,t,n){Rt=e,rt(t,n||{},Vt,Kt,Jt,e),Rt=void 0}var Wt=null;function Zt(e){var t=Wt;return Wt=e,function(){Wt=t}}function Gt(e){for(;e&&(e=e.$parent);)if(e._inactive)return!0;return!1}function Xt(e,t){if(t){if(e._directInactive=!1,Gt(e))return}else if(e._directInactive)return;if(e._inactive||null===e._inactive){e._inactive=!1;for(var n=0;n<e.$children.length;n++)Xt(e.$children[n]);Yt(e,"activated")}}function Yt(e,t){le();var n=e.$options[t],r=t+" hook";if(n)for(var i=0,o=n.length;i<o;i++)He(n[i],e,null,e,r);e._hasHookEvent&&e.$emit("hook:"+t),fe()}var Qt=[],en=[],tn={},nn=!1,rn=!1,on=0;var an=0,sn=Date.now;if(z&&!q){var cn=window.performance;cn&&"function"==typeof cn.now&&sn()>document.createEvent("Event").timeStamp&&(sn=function(){return cn.now()})}function un(){var e,t;for(an=sn(),rn=!0,Qt.sort(function(e,t){return e.id-t.id}),on=0;on<Qt.length;on++)(e=Qt[on]).before&&e.before(),t=e.id,tn[t]=null,e.run();var n=en.slice(),r=Qt.slice();on=Qt.length=en.length=0,tn={},nn=rn=!1,function(e){for(var t=0;t<e.length;t++)e[t]._inactive=!0,Xt(e[t],!0)}(n),function(e){var t=e.length;for(;t--;){var n=e[t],r=n.vm;r._watcher===n&&r._isMounted&&!r._isDestroyed&&Yt(r,"updated")}}(r),ne&&F.devtools&&ne.emit("flush")}var ln=0,fn=function(e,t,n,r,i){this.vm=e,i&&(e._watcher=this),e._watchers.push(this),r?(this.deep=!!r.deep,this.user=!!r.user,this.lazy=!!r.lazy,this.sync=!!r.sync,this.before=r.before):this.deep=this.user=this.lazy=this.sync=!1,this.cb=n,this.id=++ln,this.active=!0,this.dirty=this.lazy,this.deps=[],this.newDeps=[],this.depIds=new ie,this.newDepIds=new ie,this.expression="","function"==typeof t?this.getter=t:(this.getter=function(e){if(!H.test(e)){var t=e.split(".");return function(e){for(var n=0;n<t.length;n++){if(!e)return;e=e[t[n]]}return e}}}(t),this.getter||(this.getter=S)),this.value=this.lazy?void 0:this.get()};fn.prototype.get=function(){var e;le(this);var t=this.vm;try{e=this.getter.call(t,t)}catch(e){if(!this.user)throw e;Re(e,t,'getter for watcher "'+this.expression+'"')}finally{this.deep&&et(e),fe(),this.cleanupDeps()}return e},fn.prototype.addDep=function(e){var t=e.id;this.newDepIds.has(t)||(this.newDepIds.add(t),this.newDeps.push(e),this.depIds.has(t)||e.addSub(this))},fn.prototype.cleanupDeps=function(){for(var e=this.deps.length;e--;){var t=this.deps[e];this.newDepIds.has(t.id)||t.removeSub(this)}var n=this.depIds;this.depIds=this.newDepIds,this.newDepIds=n,this.newDepIds.clear(),n=this.deps,this.deps=this.newDeps,this.newDeps=n,this.newDeps.length=0},fn.prototype.update=function(){this.lazy?this.dirty=!0:this.sync?this.run():function(e){var t=e.id;if(null==tn[t]){if(tn[t]=!0,rn){for(var n=Qt.length-1;n>on&&Qt[n].id>e.id;)n--;Qt.splice(n+1,0,e)}else Qt.push(e);nn||(nn=!0,Ye(un))}}(this)},fn.prototype.run=function(){if(this.active){var e=this.get();if(e!==this.value||o(e)||this.deep){var t=this.value;if(this.value=e,this.user)try{this.cb.call(this.vm,e,t)}catch(e){Re(e,this.vm,'callback for watcher "'+this.expression+'"')}else this.cb.call(this.vm,e,t)}}},fn.prototype.evaluate=function(){this.value=this.get(),this.dirty=!1},fn.prototype.depend=function(){for(var e=this.deps.length;e--;)this.deps[e].depend()},fn.prototype.teardown=function(){if(this.active){this.vm._isBeingDestroyed||h(this.vm._watchers,this);for(var e=this.deps.length;e--;)this.deps[e].removeSub(this);this.active=!1}};var pn={enumerable:!0,configurable:!0,get:S,set:S};function dn(e,t,n){pn.get=function(){return this[t][n]},pn.set=function(e){this[t][n]=e},Object.defineProperty(e,n,pn)}function vn(e){e._watchers=[];var t=e.$options;t.props&&function(e,t){var n=e.$options.propsData||{},r=e._props={},i=e.$options._propKeys=[];e.$parent&&$e(!1);var o=function(o){i.push(o);var a=Me(o,t,n,e);xe(r,o,a),o in e||dn(e,"_props",o)};for(var a in t)o(a);$e(!0)}(e,t.props),t.methods&&function(e,t){e.$options.props;for(var n in t)e[n]="function"!=typeof t[n]?S:x(t[n],e)}(e,t.methods),t.data?function(e){var t=e.$options.data;s(t=e._data="function"==typeof t?function(e,t){le();try{return e.call(t,t)}catch(e){return Re(e,t,"data()"),{}}finally{fe()}}(t,e):t||{})||(t={});var n=Object.keys(t),r=e.$options.props,i=(e.$options.methods,n.length);for(;i--;){var o=n[i];r&&y(r,o)||(a=void 0,36!==(a=(o+"").charCodeAt(0))&&95!==a&&dn(e,"_data",o))}var a;Ce(t,!0)}(e):Ce(e._data={},!0),t.computed&&function(e,t){var n=e._computedWatchers=Object.create(null),r=te();for(var i in t){var o=t[i],a="function"==typeof o?o:o.get;r||(n[i]=new fn(e,a||S,S,hn)),i in e||mn(e,i,o)}}(e,t.computed),t.watch&&t.watch!==Y&&function(e,t){for(var n in t){var r=t[n];if(Array.isArray(r))for(var i=0;i<r.length;i++)_n(e,n,r[i]);else _n(e,n,r)}}(e,t.watch)}var hn={lazy:!0};function mn(e,t,n){var r=!te();"function"==typeof n?(pn.get=r?yn(t):gn(n),pn.set=S):(pn.get=n.get?r&&!1!==n.cache?yn(t):gn(n.get):S,pn.set=n.set||S),Object.defineProperty(e,t,pn)}function yn(e){return function(){var t=this._computedWatchers&&this._computedWatchers[e];if(t)return t.dirty&&t.evaluate(),ce.target&&t.depend(),t.value}}function gn(e){return function(){return e.call(this,this)}}function _n(e,t,n,r){return s(n)&&(r=n,n=n.handler),"string"==typeof n&&(n=e[n]),e.$watch(t,n,r)}var bn=0;function $n(e){var t=e.options;if(e.super){var n=$n(e.super);if(n!==e.superOptions){e.superOptions=n;var r=function(e){var t,n=e.options,r=e.sealedOptions;for(var i in n)n[i]!==r[i]&&(t||(t={}),t[i]=n[i]);return t}(e);r&&A(e.extendOptions,r),(t=e.options=De(n,e.extendOptions)).name&&(t.components[t.name]=e)}}return t}function wn(e){this._init(e)}function Cn(e){e.cid=0;var t=1;e.extend=function(e){e=e||{};var n=this,r=n.cid,i=e._Ctor||(e._Ctor={});if(i[r])return i[r];var o=e.name||n.options.name,a=function(e){this._init(e)};return(a.prototype=Object.create(n.prototype)).constructor=a,a.cid=t++,a.options=De(n.options,e),a.super=n,a.options.props&&function(e){var t=e.options.props;for(var n in t)dn(e.prototype,"_props",n)}(a),a.options.computed&&function(e){var t=e.options.computed;for(var n in t)mn(e.prototype,n,t[n])}(a),a.extend=n.extend,a.mixin=n.mixin,a.use=n.use,M.forEach(function(e){a[e]=n[e]}),o&&(a.options.components[o]=a),a.superOptions=n.options,a.extendOptions=e,a.sealedOptions=A({},a.options),i[r]=a,a}}function xn(e){return e&&(e.Ctor.options.name||e.tag)}function kn(e,t){return Array.isArray(e)?e.indexOf(t)>-1:"string"==typeof e?e.split(",").indexOf(t)>-1:(n=e,"[object RegExp]"===a.call(n)&&e.test(t));var n}function An(e,t){var n=e.cache,r=e.keys,i=e._vnode;for(var o in n){var a=n[o];if(a){var s=xn(a.componentOptions);s&&!t(s)&&On(n,o,r,i)}}}function On(e,t,n,r){var i=e[t];!i||r&&i.tag===r.tag||i.componentInstance.$destroy(),e[t]=null,h(n,t)}!function(t){t.prototype._init=function(t){var n=this;n._uid=bn++,n._isVue=!0,t&&t._isComponent?function(e,t){var n=e.$options=Object.create(e.constructor.options),r=t._parentVnode;n.parent=t.parent,n._parentVnode=r;var i=r.componentOptions;n.propsData=i.propsData,n._parentListeners=i.listeners,n._renderChildren=i.children,n._componentTag=i.tag,t.render&&(n.render=t.render,n.staticRenderFns=t.staticRenderFns)}(n,t):n.$options=De($n(n.constructor),t||{},n),n._renderProxy=n,n._self=n,function(e){var t=e.$options,n=t.parent;if(n&&!t.abstract){for(;n.$options.abstract&&n.$parent;)n=n.$parent;n.$children.push(e)}e.$parent=n,e.$root=n?n.$root:e,e.$children=[],e.$refs={},e._watcher=null,e._inactive=null,e._directInactive=!1,e._isMounted=!1,e._isDestroyed=!1,e._isBeingDestroyed=!1}(n),function(e){e._events=Object.create(null),e._hasHookEvent=!1;var t=e.$options._parentListeners;t&&qt(e,t)}(n),function(t){t._vnode=null,t._staticTrees=null;var n=t.$options,r=t.$vnode=n._parentVnode,i=r&&r.context;t.$slots=ut(n._renderChildren,i),t.$scopedSlots=e,t._c=function(e,n,r,i){return Pt(t,e,n,r,i,!1)},t.$createElement=function(e,n,r,i){return Pt(t,e,n,r,i,!0)};var o=r&&r.data;xe(t,"$attrs",o&&o.attrs||e,null,!0),xe(t,"$listeners",n._parentListeners||e,null,!0)}(n),Yt(n,"beforeCreate"),function(e){var t=ct(e.$options.inject,e);t&&($e(!1),Object.keys(t).forEach(function(n){xe(e,n,t[n])}),$e(!0))}(n),vn(n),function(e){var t=e.$options.provide;t&&(e._provided="function"==typeof t?t.call(e):t)}(n),Yt(n,"created"),n.$options.el&&n.$mount(n.$options.el)}}(wn),function(e){var t={get:function(){return this._data}},n={get:function(){return this._props}};Object.defineProperty(e.prototype,"$data",t),Object.defineProperty(e.prototype,"$props",n),e.prototype.$set=ke,e.prototype.$delete=Ae,e.prototype.$watch=function(e,t,n){if(s(t))return _n(this,e,t,n);(n=n||{}).user=!0;var r=new fn(this,e,t,n);if(n.immediate)try{t.call(this,r.value)}catch(e){Re(e,this,'callback for immediate watcher "'+r.expression+'"')}return function(){r.teardown()}}}(wn),function(e){var t=/^hook:/;e.prototype.$on=function(e,n){var r=this;if(Array.isArray(e))for(var i=0,o=e.length;i<o;i++)r.$on(e[i],n);else(r._events[e]||(r._events[e]=[])).push(n),t.test(e)&&(r._hasHookEvent=!0);return r},e.prototype.$once=function(e,t){var n=this;function r(){n.$off(e,r),t.apply(n,arguments)}return r.fn=t,n.$on(e,r),n},e.prototype.$off=function(e,t){var n=this;if(!arguments.length)return n._events=Object.create(null),n;if(Array.isArray(e)){for(var r=0,i=e.length;r<i;r++)n.$off(e[r],t);return n}var o,a=n._events[e];if(!a)return n;if(!t)return n._events[e]=null,n;for(var s=a.length;s--;)if((o=a[s])===t||o.fn===t){a.splice(s,1);break}return n},e.prototype.$emit=function(e){var t=this._events[e];if(t){t=t.length>1?k(t):t;for(var n=k(arguments,1),r='event handler for "'+e+'"',i=0,o=t.length;i<o;i++)He(t[i],this,n,this,r)}return this}}(wn),function(e){e.prototype._update=function(e,t){var n=this,r=n.$el,i=n._vnode,o=Zt(n);n._vnode=e,n.$el=i?n.__patch__(i,e):n.__patch__(n.$el,e,t,!1),o(),r&&(r.__vue__=null),n.$el&&(n.$el.__vue__=n),n.$vnode&&n.$parent&&n.$vnode===n.$parent._vnode&&(n.$parent.$el=n.$el)},e.prototype.$forceUpdate=function(){this._watcher&&this._watcher.update()},e.prototype.$destroy=function(){var e=this;if(!e._isBeingDestroyed){Yt(e,"beforeDestroy"),e._isBeingDestroyed=!0;var t=e.$parent;!t||t._isBeingDestroyed||e.$options.abstract||h(t.$children,e),e._watcher&&e._watcher.teardown();for(var n=e._watchers.length;n--;)e._watchers[n].teardown();e._data.__ob__&&e._data.__ob__.vmCount--,e._isDestroyed=!0,e.__patch__(e._vnode,null),Yt(e,"destroyed"),e.$off(),e.$el&&(e.$el.__vue__=null),e.$vnode&&(e.$vnode.parent=null)}}}(wn),function(e){St(e.prototype),e.prototype.$nextTick=function(e){return Ye(e,this)},e.prototype._render=function(){var e,t=this,n=t.$options,r=n.render,i=n._parentVnode;i&&(t.$scopedSlots=ft(i.data.scopedSlots,t.$slots,t.$scopedSlots)),t.$vnode=i;try{Ht=t,e=r.call(t._renderProxy,t.$createElement)}catch(n){Re(n,t,"render"),e=t._vnode}finally{Ht=null}return Array.isArray(e)&&1===e.length&&(e=e[0]),e instanceof pe||(e=ve()),e.parent=i,e}}(wn);var Sn=[String,RegExp,Array],Tn={KeepAlive:{name:"keep-alive",abstract:!0,props:{include:Sn,exclude:Sn,max:[String,Number]},created:function(){this.cache=Object.create(null),this.keys=[]},destroyed:function(){for(var e in this.cache)On(this.cache,e,this.keys)},mounted:function(){var e=this;this.$watch("include",function(t){An(e,function(e){return kn(t,e)})}),this.$watch("exclude",function(t){An(e,function(e){return!kn(t,e)})})},render:function(){var e=this.$slots.default,t=zt(e),n=t&&t.componentOptions;if(n){var r=xn(n),i=this.include,o=this.exclude;if(i&&(!r||!kn(i,r))||o&&r&&kn(o,r))return t;var a=this.cache,s=this.keys,c=null==t.key?n.Ctor.cid+(n.tag?"::"+n.tag:""):t.key;a[c]?(t.componentInstance=a[c].componentInstance,h(s,c),s.push(c)):(a[c]=t,s.push(c),this.max&&s.length>parseInt(this.max)&&On(a,s[0],s,this._vnode)),t.data.keepAlive=!0}return t||e&&e[0]}}};!function(e){var t={get:function(){return F}};Object.defineProperty(e,"config",t),e.util={warn:ae,extend:A,mergeOptions:De,defineReactive:xe},e.set=ke,e.delete=Ae,e.nextTick=Ye,e.observable=function(e){return Ce(e),e},e.options=Object.create(null),M.forEach(function(t){e.options[t+"s"]=Object.create(null)}),e.options._base=e,A(e.options.components,Tn),function(e){e.use=function(e){var t=this._installedPlugins||(this._installedPlugins=[]);if(t.indexOf(e)>-1)return this;var n=k(arguments,1);return n.unshift(this),"function"==typeof e.install?e.install.apply(e,n):"function"==typeof e&&e.apply(null,n),t.push(e),this}}(e),function(e){e.mixin=function(e){return this.options=De(this.options,e),this}}(e),Cn(e),function(e){M.forEach(function(t){e[t]=function(e,n){return n?("component"===t&&s(n)&&(n.name=n.name||e,n=this.options._base.extend(n)),"directive"===t&&"function"==typeof n&&(n={bind:n,update:n}),this.options[t+"s"][e]=n,n):this.options[t+"s"][e]}})}(e)}(wn),Object.defineProperty(wn.prototype,"$isServer",{get:te}),Object.defineProperty(wn.prototype,"$ssrContext",{get:function(){return this.$vnode&&this.$vnode.ssrContext}}),Object.defineProperty(wn,"FunctionalRenderContext",{value:Tt}),wn.version="2.6.12";var En=p("style,class"),Nn=p("input,textarea,option,select,progress"),jn=function(e,t,n){return"value"===n&&Nn(e)&&"button"!==t||"selected"===n&&"option"===e||"checked"===n&&"input"===e||"muted"===n&&"video"===e},Dn=p("contenteditable,draggable,spellcheck"),Ln=p("events,caret,typing,plaintext-only"),Mn=function(e,t){return Hn(t)||"false"===t?"false":"contenteditable"===e&&Ln(t)?t:"true"},In=p("allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,default,defaultchecked,defaultmuted,defaultselected,defer,disabled,enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,required,reversed,scoped,seamless,selected,sortable,translate,truespeed,typemustmatch,visible"),Fn="http://www.w3.org/1999/xlink",Pn=function(e){return":"===e.charAt(5)&&"xlink"===e.slice(0,5)},Rn=function(e){return Pn(e)?e.slice(6,e.length):""},Hn=function(e){return null==e||!1===e};function Bn(e){for(var t=e.data,r=e,i=e;n(i.componentInstance);)(i=i.componentInstance._vnode)&&i.data&&(t=Un(i.data,t));for(;n(r=r.parent);)r&&r.data&&(t=Un(t,r.data));return function(e,t){if(n(e)||n(t))return zn(e,Vn(t));return""}(t.staticClass,t.class)}function Un(e,t){return{staticClass:zn(e.staticClass,t.staticClass),class:n(e.class)?[e.class,t.class]:t.class}}function zn(e,t){return e?t?e+" "+t:e:t||""}function Vn(e){return Array.isArray(e)?function(e){for(var t,r="",i=0,o=e.length;i<o;i++)n(t=Vn(e[i]))&&""!==t&&(r&&(r+=" "),r+=t);return r}(e):o(e)?function(e){var t="";for(var n in e)e[n]&&(t&&(t+=" "),t+=n);return t}(e):"string"==typeof e?e:""}var Kn={svg:"http://www.w3.org/2000/svg",math:"http://www.w3.org/1998/Math/MathML"},Jn=p("html,body,base,head,link,meta,style,title,address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,menuitem,summary,content,element,shadow,template,blockquote,iframe,tfoot"),qn=p("svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view",!0),Wn=function(e){return Jn(e)||qn(e)};function Zn(e){return qn(e)?"svg":"math"===e?"math":void 0}var Gn=Object.create(null);var Xn=p("text,number,password,search,email,tel,url");function Yn(e){if("string"==typeof e){var t=document.querySelector(e);return t||document.createElement("div")}return e}var Qn=Object.freeze({createElement:function(e,t){var n=document.createElement(e);return"select"!==e?n:(t.data&&t.data.attrs&&void 0!==t.data.attrs.multiple&&n.setAttribute("multiple","multiple"),n)},createElementNS:function(e,t){return document.createElementNS(Kn[e],t)},createTextNode:function(e){return document.createTextNode(e)},createComment:function(e){return document.createComment(e)},insertBefore:function(e,t,n){e.insertBefore(t,n)},removeChild:function(e,t){e.removeChild(t)},appendChild:function(e,t){e.appendChild(t)},parentNode:function(e){return e.parentNode},nextSibling:function(e){return e.nextSibling},tagName:function(e){return e.tagName},setTextContent:function(e,t){e.textContent=t},setStyleScope:function(e,t){e.setAttribute(t,"")}}),er={create:function(e,t){tr(t)},update:function(e,t){e.data.ref!==t.data.ref&&(tr(e,!0),tr(t))},destroy:function(e){tr(e,!0)}};function tr(e,t){var r=e.data.ref;if(n(r)){var i=e.context,o=e.componentInstance||e.elm,a=i.$refs;t?Array.isArray(a[r])?h(a[r],o):a[r]===o&&(a[r]=void 0):e.data.refInFor?Array.isArray(a[r])?a[r].indexOf(o)<0&&a[r].push(o):a[r]=[o]:a[r]=o}}var nr=new pe("",{},[]),rr=["create","activate","update","remove","destroy"];function ir(e,i){return e.key===i.key&&(e.tag===i.tag&&e.isComment===i.isComment&&n(e.data)===n(i.data)&&function(e,t){if("input"!==e.tag)return!0;var r,i=n(r=e.data)&&n(r=r.attrs)&&r.type,o=n(r=t.data)&&n(r=r.attrs)&&r.type;return i===o||Xn(i)&&Xn(o)}(e,i)||r(e.isAsyncPlaceholder)&&e.asyncFactory===i.asyncFactory&&t(i.asyncFactory.error))}function or(e,t,r){var i,o,a={};for(i=t;i<=r;++i)n(o=e[i].key)&&(a[o]=i);return a}var ar={create:sr,update:sr,destroy:function(e){sr(e,nr)}};function sr(e,t){(e.data.directives||t.data.directives)&&function(e,t){var n,r,i,o=e===nr,a=t===nr,s=ur(e.data.directives,e.context),c=ur(t.data.directives,t.context),u=[],l=[];for(n in c)r=s[n],i=c[n],r?(i.oldValue=r.value,i.oldArg=r.arg,fr(i,"update",t,e),i.def&&i.def.componentUpdated&&l.push(i)):(fr(i,"bind",t,e),i.def&&i.def.inserted&&u.push(i));if(u.length){var f=function(){for(var n=0;n<u.length;n++)fr(u[n],"inserted",t,e)};o?it(t,"insert",f):f()}l.length&&it(t,"postpatch",function(){for(var n=0;n<l.length;n++)fr(l[n],"componentUpdated",t,e)});if(!o)for(n in s)c[n]||fr(s[n],"unbind",e,e,a)}(e,t)}var cr=Object.create(null);function ur(e,t){var n,r,i=Object.create(null);if(!e)return i;for(n=0;n<e.length;n++)(r=e[n]).modifiers||(r.modifiers=cr),i[lr(r)]=r,r.def=Le(t.$options,"directives",r.name);return i}function lr(e){return e.rawName||e.name+"."+Object.keys(e.modifiers||{}).join(".")}function fr(e,t,n,r,i){var o=e.def&&e.def[t];if(o)try{o(n.elm,e,n,r,i)}catch(r){Re(r,n.context,"directive "+e.name+" "+t+" hook")}}var pr=[er,ar];function dr(e,r){var i=r.componentOptions;if(!(n(i)&&!1===i.Ctor.options.inheritAttrs||t(e.data.attrs)&&t(r.data.attrs))){var o,a,s=r.elm,c=e.data.attrs||{},u=r.data.attrs||{};for(o in n(u.__ob__)&&(u=r.data.attrs=A({},u)),u)a=u[o],c[o]!==a&&vr(s,o,a);for(o in(q||Z)&&u.value!==c.value&&vr(s,"value",u.value),c)t(u[o])&&(Pn(o)?s.removeAttributeNS(Fn,Rn(o)):Dn(o)||s.removeAttribute(o))}}function vr(e,t,n){e.tagName.indexOf("-")>-1?hr(e,t,n):In(t)?Hn(n)?e.removeAttribute(t):(n="allowfullscreen"===t&&"EMBED"===e.tagName?"true":t,e.setAttribute(t,n)):Dn(t)?e.setAttribute(t,Mn(t,n)):Pn(t)?Hn(n)?e.removeAttributeNS(Fn,Rn(t)):e.setAttributeNS(Fn,t,n):hr(e,t,n)}function hr(e,t,n){if(Hn(n))e.removeAttribute(t);else{if(q&&!W&&"TEXTAREA"===e.tagName&&"placeholder"===t&&""!==n&&!e.__ieph){var r=function(t){t.stopImmediatePropagation(),e.removeEventListener("input",r)};e.addEventListener("input",r),e.__ieph=!0}e.setAttribute(t,n)}}var mr={create:dr,update:dr};function yr(e,r){var i=r.elm,o=r.data,a=e.data;if(!(t(o.staticClass)&&t(o.class)&&(t(a)||t(a.staticClass)&&t(a.class)))){var s=Bn(r),c=i._transitionClasses;n(c)&&(s=zn(s,Vn(c))),s!==i._prevClass&&(i.setAttribute("class",s),i._prevClass=s)}}var gr,_r,br,$r,wr,Cr,xr={create:yr,update:yr},kr=/[\w).+\-_$\]]/;function Ar(e){var t,n,r,i,o,a=!1,s=!1,c=!1,u=!1,l=0,f=0,p=0,d=0;for(r=0;r<e.length;r++)if(n=t,t=e.charCodeAt(r),a)39===t&&92!==n&&(a=!1);else if(s)34===t&&92!==n&&(s=!1);else if(c)96===t&&92!==n&&(c=!1);else if(u)47===t&&92!==n&&(u=!1);else if(124!==t||124===e.charCodeAt(r+1)||124===e.charCodeAt(r-1)||l||f||p){switch(t){case 34:s=!0;break;case 39:a=!0;break;case 96:c=!0;break;case 40:p++;break;case 41:p--;break;case 91:f++;break;case 93:f--;break;case 123:l++;break;case 125:l--}if(47===t){for(var v=r-1,h=void 0;v>=0&&" "===(h=e.charAt(v));v--);h&&kr.test(h)||(u=!0)}}else void 0===i?(d=r+1,i=e.slice(0,r).trim()):m();function m(){(o||(o=[])).push(e.slice(d,r).trim()),d=r+1}if(void 0===i?i=e.slice(0,r).trim():0!==d&&m(),o)for(r=0;r<o.length;r++)i=Or(i,o[r]);return i}function Or(e,t){var n=t.indexOf("(");if(n<0)return'_f("'+t+'")('+e+")";var r=t.slice(0,n),i=t.slice(n+1);return'_f("'+r+'")('+e+(")"!==i?","+i:i)}function Sr(e,t){console.error("[Vue compiler]: "+e)}function Tr(e,t){return e?e.map(function(e){return e[t]}).filter(function(e){return e}):[]}function Er(e,t,n,r,i){(e.props||(e.props=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function Nr(e,t,n,r,i){(i?e.dynamicAttrs||(e.dynamicAttrs=[]):e.attrs||(e.attrs=[])).push(Rr({name:t,value:n,dynamic:i},r)),e.plain=!1}function jr(e,t,n,r){e.attrsMap[t]=n,e.attrsList.push(Rr({name:t,value:n},r))}function Dr(e,t,n,r,i,o,a,s){(e.directives||(e.directives=[])).push(Rr({name:t,rawName:n,value:r,arg:i,isDynamicArg:o,modifiers:a},s)),e.plain=!1}function Lr(e,t,n){return n?"_p("+t+',"'+e+'")':e+t}function Mr(t,n,r,i,o,a,s,c){var u;(i=i||e).right?c?n="("+n+")==='click'?'contextmenu':("+n+")":"click"===n&&(n="contextmenu",delete i.right):i.middle&&(c?n="("+n+")==='click'?'mouseup':("+n+")":"click"===n&&(n="mouseup")),i.capture&&(delete i.capture,n=Lr("!",n,c)),i.once&&(delete i.once,n=Lr("~",n,c)),i.passive&&(delete i.passive,n=Lr("&",n,c)),i.native?(delete i.native,u=t.nativeEvents||(t.nativeEvents={})):u=t.events||(t.events={});var l=Rr({value:r.trim(),dynamic:c},s);i!==e&&(l.modifiers=i);var f=u[n];Array.isArray(f)?o?f.unshift(l):f.push(l):u[n]=f?o?[l,f]:[f,l]:l,t.plain=!1}function Ir(e,t,n){var r=Fr(e,":"+t)||Fr(e,"v-bind:"+t);if(null!=r)return Ar(r);if(!1!==n){var i=Fr(e,t);if(null!=i)return JSON.stringify(i)}}function Fr(e,t,n){var r;if(null!=(r=e.attrsMap[t]))for(var i=e.attrsList,o=0,a=i.length;o<a;o++)if(i[o].name===t){i.splice(o,1);break}return n&&delete e.attrsMap[t],r}function Pr(e,t){for(var n=e.attrsList,r=0,i=n.length;r<i;r++){var o=n[r];if(t.test(o.name))return n.splice(r,1),o}}function Rr(e,t){return t&&(null!=t.start&&(e.start=t.start),null!=t.end&&(e.end=t.end)),e}function Hr(e,t,n){var r=n||{},i=r.number,o="$$v";r.trim&&(o="(typeof $$v === 'string'? $$v.trim(): $$v)"),i&&(o="_n("+o+")");var a=Br(t,o);e.model={value:"("+t+")",expression:JSON.stringify(t),callback:"function ($$v) {"+a+"}"}}function Br(e,t){var n=function(e){if(e=e.trim(),gr=e.length,e.indexOf("[")<0||e.lastIndexOf("]")<gr-1)return($r=e.lastIndexOf("."))>-1?{exp:e.slice(0,$r),key:'"'+e.slice($r+1)+'"'}:{exp:e,key:null};_r=e,$r=wr=Cr=0;for(;!zr();)Vr(br=Ur())?Jr(br):91===br&&Kr(br);return{exp:e.slice(0,wr),key:e.slice(wr+1,Cr)}}(e);return null===n.key?e+"="+t:"$set("+n.exp+", "+n.key+", "+t+")"}function Ur(){return _r.charCodeAt(++$r)}function zr(){return $r>=gr}function Vr(e){return 34===e||39===e}function Kr(e){var t=1;for(wr=$r;!zr();)if(Vr(e=Ur()))Jr(e);else if(91===e&&t++,93===e&&t--,0===t){Cr=$r;break}}function Jr(e){for(var t=e;!zr()&&(e=Ur())!==t;);}var qr,Wr="__r",Zr="__c";function Gr(e,t,n){var r=qr;return function i(){null!==t.apply(null,arguments)&&Qr(e,i,n,r)}}var Xr=Ve&&!(X&&Number(X[1])<=53);function Yr(e,t,n,r){if(Xr){var i=an,o=t;t=o._wrapper=function(e){if(e.target===e.currentTarget||e.timeStamp>=i||e.timeStamp<=0||e.target.ownerDocument!==document)return o.apply(this,arguments)}}qr.addEventListener(e,t,Q?{capture:n,passive:r}:n)}function Qr(e,t,n,r){(r||qr).removeEventListener(e,t._wrapper||t,n)}function ei(e,r){if(!t(e.data.on)||!t(r.data.on)){var i=r.data.on||{},o=e.data.on||{};qr=r.elm,function(e){if(n(e[Wr])){var t=q?"change":"input";e[t]=[].concat(e[Wr],e[t]||[]),delete e[Wr]}n(e[Zr])&&(e.change=[].concat(e[Zr],e.change||[]),delete e[Zr])}(i),rt(i,o,Yr,Qr,Gr,r.context),qr=void 0}}var ti,ni={create:ei,update:ei};function ri(e,r){if(!t(e.data.domProps)||!t(r.data.domProps)){var i,o,a=r.elm,s=e.data.domProps||{},c=r.data.domProps||{};for(i in n(c.__ob__)&&(c=r.data.domProps=A({},c)),s)i in c||(a[i]="");for(i in c){if(o=c[i],"textContent"===i||"innerHTML"===i){if(r.children&&(r.children.length=0),o===s[i])continue;1===a.childNodes.length&&a.removeChild(a.childNodes[0])}if("value"===i&&"PROGRESS"!==a.tagName){a._value=o;var u=t(o)?"":String(o);ii(a,u)&&(a.value=u)}else if("innerHTML"===i&&qn(a.tagName)&&t(a.innerHTML)){(ti=ti||document.createElement("div")).innerHTML="<svg>"+o+"</svg>";for(var l=ti.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;l.firstChild;)a.appendChild(l.firstChild)}else if(o!==s[i])try{a[i]=o}catch(e){}}}}function ii(e,t){return!e.composing&&("OPTION"===e.tagName||function(e,t){var n=!0;try{n=document.activeElement!==e}catch(e){}return n&&e.value!==t}(e,t)||function(e,t){var r=e.value,i=e._vModifiers;if(n(i)){if(i.number)return f(r)!==f(t);if(i.trim)return r.trim()!==t.trim()}return r!==t}(e,t))}var oi={create:ri,update:ri},ai=g(function(e){var t={},n=/:(.+)/;return e.split(/;(?![^(]*\))/g).forEach(function(e){if(e){var r=e.split(n);r.length>1&&(t[r[0].trim()]=r[1].trim())}}),t});function si(e){var t=ci(e.style);return e.staticStyle?A(e.staticStyle,t):t}function ci(e){return Array.isArray(e)?O(e):"string"==typeof e?ai(e):e}var ui,li=/^--/,fi=/\s*!important$/,pi=function(e,t,n){if(li.test(t))e.style.setProperty(t,n);else if(fi.test(n))e.style.setProperty(C(t),n.replace(fi,""),"important");else{var r=vi(t);if(Array.isArray(n))for(var i=0,o=n.length;i<o;i++)e.style[r]=n[i];else e.style[r]=n}},di=["Webkit","Moz","ms"],vi=g(function(e){if(ui=ui||document.createElement("div").style,"filter"!==(e=b(e))&&e in ui)return e;for(var t=e.charAt(0).toUpperCase()+e.slice(1),n=0;n<di.length;n++){var r=di[n]+t;if(r in ui)return r}});function hi(e,r){var i=r.data,o=e.data;if(!(t(i.staticStyle)&&t(i.style)&&t(o.staticStyle)&&t(o.style))){var a,s,c=r.elm,u=o.staticStyle,l=o.normalizedStyle||o.style||{},f=u||l,p=ci(r.data.style)||{};r.data.normalizedStyle=n(p.__ob__)?A({},p):p;var d=function(e,t){var n,r={};if(t)for(var i=e;i.componentInstance;)(i=i.componentInstance._vnode)&&i.data&&(n=si(i.data))&&A(r,n);(n=si(e.data))&&A(r,n);for(var o=e;o=o.parent;)o.data&&(n=si(o.data))&&A(r,n);return r}(r,!0);for(s in f)t(d[s])&&pi(c,s,"");for(s in d)(a=d[s])!==f[s]&&pi(c,s,null==a?"":a)}}var mi={create:hi,update:hi},yi=/\s+/;function gi(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.add(t)}):e.classList.add(t);else{var n=" "+(e.getAttribute("class")||"")+" ";n.indexOf(" "+t+" ")<0&&e.setAttribute("class",(n+t).trim())}}function _i(e,t){if(t&&(t=t.trim()))if(e.classList)t.indexOf(" ")>-1?t.split(yi).forEach(function(t){return e.classList.remove(t)}):e.classList.remove(t),e.classList.length||e.removeAttribute("class");else{for(var n=" "+(e.getAttribute("class")||"")+" ",r=" "+t+" ";n.indexOf(r)>=0;)n=n.replace(r," ");(n=n.trim())?e.setAttribute("class",n):e.removeAttribute("class")}}function bi(e){if(e){if("object"==typeof e){var t={};return!1!==e.css&&A(t,$i(e.name||"v")),A(t,e),t}return"string"==typeof e?$i(e):void 0}}var $i=g(function(e){return{enterClass:e+"-enter",enterToClass:e+"-enter-to",enterActiveClass:e+"-enter-active",leaveClass:e+"-leave",leaveToClass:e+"-leave-to",leaveActiveClass:e+"-leave-active"}}),wi=z&&!W,Ci="transition",xi="animation",ki="transition",Ai="transitionend",Oi="animation",Si="animationend";wi&&(void 0===window.ontransitionend&&void 0!==window.onwebkittransitionend&&(ki="WebkitTransition",Ai="webkitTransitionEnd"),void 0===window.onanimationend&&void 0!==window.onwebkitanimationend&&(Oi="WebkitAnimation",Si="webkitAnimationEnd"));var Ti=z?window.requestAnimationFrame?window.requestAnimationFrame.bind(window):setTimeout:function(e){return e()};function Ei(e){Ti(function(){Ti(e)})}function Ni(e,t){var n=e._transitionClasses||(e._transitionClasses=[]);n.indexOf(t)<0&&(n.push(t),gi(e,t))}function ji(e,t){e._transitionClasses&&h(e._transitionClasses,t),_i(e,t)}function Di(e,t,n){var r=Mi(e,t),i=r.type,o=r.timeout,a=r.propCount;if(!i)return n();var s=i===Ci?Ai:Si,c=0,u=function(){e.removeEventListener(s,l),n()},l=function(t){t.target===e&&++c>=a&&u()};setTimeout(function(){c<a&&u()},o+1),e.addEventListener(s,l)}var Li=/\b(transform|all)(,|$)/;function Mi(e,t){var n,r=window.getComputedStyle(e),i=(r[ki+"Delay"]||"").split(", "),o=(r[ki+"Duration"]||"").split(", "),a=Ii(i,o),s=(r[Oi+"Delay"]||"").split(", "),c=(r[Oi+"Duration"]||"").split(", "),u=Ii(s,c),l=0,f=0;return t===Ci?a>0&&(n=Ci,l=a,f=o.length):t===xi?u>0&&(n=xi,l=u,f=c.length):f=(n=(l=Math.max(a,u))>0?a>u?Ci:xi:null)?n===Ci?o.length:c.length:0,{type:n,timeout:l,propCount:f,hasTransform:n===Ci&&Li.test(r[ki+"Property"])}}function Ii(e,t){for(;e.length<t.length;)e=e.concat(e);return Math.max.apply(null,t.map(function(t,n){return Fi(t)+Fi(e[n])}))}function Fi(e){return 1e3*Number(e.slice(0,-1).replace(",","."))}function Pi(e,r){var i=e.elm;n(i._leaveCb)&&(i._leaveCb.cancelled=!0,i._leaveCb());var a=bi(e.data.transition);if(!t(a)&&!n(i._enterCb)&&1===i.nodeType){for(var s=a.css,c=a.type,u=a.enterClass,l=a.enterToClass,p=a.enterActiveClass,d=a.appearClass,v=a.appearToClass,h=a.appearActiveClass,m=a.beforeEnter,y=a.enter,g=a.afterEnter,_=a.enterCancelled,b=a.beforeAppear,$=a.appear,w=a.afterAppear,C=a.appearCancelled,x=a.duration,k=Wt,A=Wt.$vnode;A&&A.parent;)k=A.context,A=A.parent;var O=!k._isMounted||!e.isRootInsert;if(!O||$||""===$){var S=O&&d?d:u,T=O&&h?h:p,E=O&&v?v:l,N=O&&b||m,j=O&&"function"==typeof $?$:y,L=O&&w||g,M=O&&C||_,I=f(o(x)?x.enter:x),F=!1!==s&&!W,P=Bi(j),R=i._enterCb=D(function(){F&&(ji(i,E),ji(i,T)),R.cancelled?(F&&ji(i,S),M&&M(i)):L&&L(i),i._enterCb=null});e.data.show||it(e,"insert",function(){var t=i.parentNode,n=t&&t._pending&&t._pending[e.key];n&&n.tag===e.tag&&n.elm._leaveCb&&n.elm._leaveCb(),j&&j(i,R)}),N&&N(i),F&&(Ni(i,S),Ni(i,T),Ei(function(){ji(i,S),R.cancelled||(Ni(i,E),P||(Hi(I)?setTimeout(R,I):Di(i,c,R)))})),e.data.show&&(r&&r(),j&&j(i,R)),F||P||R()}}}function Ri(e,r){var i=e.elm;n(i._enterCb)&&(i._enterCb.cancelled=!0,i._enterCb());var a=bi(e.data.transition);if(t(a)||1!==i.nodeType)return r();if(!n(i._leaveCb)){var s=a.css,c=a.type,u=a.leaveClass,l=a.leaveToClass,p=a.leaveActiveClass,d=a.beforeLeave,v=a.leave,h=a.afterLeave,m=a.leaveCancelled,y=a.delayLeave,g=a.duration,_=!1!==s&&!W,b=Bi(v),$=f(o(g)?g.leave:g),w=i._leaveCb=D(function(){i.parentNode&&i.parentNode._pending&&(i.parentNode._pending[e.key]=null),_&&(ji(i,l),ji(i,p)),w.cancelled?(_&&ji(i,u),m&&m(i)):(r(),h&&h(i)),i._leaveCb=null});y?y(C):C()}function C(){w.cancelled||(!e.data.show&&i.parentNode&&((i.parentNode._pending||(i.parentNode._pending={}))[e.key]=e),d&&d(i),_&&(Ni(i,u),Ni(i,p),Ei(function(){ji(i,u),w.cancelled||(Ni(i,l),b||(Hi($)?setTimeout(w,$):Di(i,c,w)))})),v&&v(i,w),_||b||w())}}function Hi(e){return"number"==typeof e&&!isNaN(e)}function Bi(e){if(t(e))return!1;var r=e.fns;return n(r)?Bi(Array.isArray(r)?r[0]:r):(e._length||e.length)>1}function Ui(e,t){!0!==t.data.show&&Pi(t)}var zi=function(e){var o,a,s={},c=e.modules,u=e.nodeOps;for(o=0;o<rr.length;++o)for(s[rr[o]]=[],a=0;a<c.length;++a)n(c[a][rr[o]])&&s[rr[o]].push(c[a][rr[o]]);function l(e){var t=u.parentNode(e);n(t)&&u.removeChild(t,e)}function f(e,t,i,o,a,c,l){if(n(e.elm)&&n(c)&&(e=c[l]=me(e)),e.isRootInsert=!a,!function(e,t,i,o){var a=e.data;if(n(a)){var c=n(e.componentInstance)&&a.keepAlive;if(n(a=a.hook)&&n(a=a.init)&&a(e,!1),n(e.componentInstance))return d(e,t),v(i,e.elm,o),r(c)&&function(e,t,r,i){for(var o,a=e;a.componentInstance;)if(a=a.componentInstance._vnode,n(o=a.data)&&n(o=o.transition)){for(o=0;o<s.activate.length;++o)s.activate[o](nr,a);t.push(a);break}v(r,e.elm,i)}(e,t,i,o),!0}}(e,t,i,o)){var f=e.data,p=e.children,m=e.tag;n(m)?(e.elm=e.ns?u.createElementNS(e.ns,m):u.createElement(m,e),g(e),h(e,p,t),n(f)&&y(e,t),v(i,e.elm,o)):r(e.isComment)?(e.elm=u.createComment(e.text),v(i,e.elm,o)):(e.elm=u.createTextNode(e.text),v(i,e.elm,o))}}function d(e,t){n(e.data.pendingInsert)&&(t.push.apply(t,e.data.pendingInsert),e.data.pendingInsert=null),e.elm=e.componentInstance.$el,m(e)?(y(e,t),g(e)):(tr(e),t.push(e))}function v(e,t,r){n(e)&&(n(r)?u.parentNode(r)===e&&u.insertBefore(e,t,r):u.appendChild(e,t))}function h(e,t,n){if(Array.isArray(t))for(var r=0;r<t.length;++r)f(t[r],n,e.elm,null,!0,t,r);else i(e.text)&&u.appendChild(e.elm,u.createTextNode(String(e.text)))}function m(e){for(;e.componentInstance;)e=e.componentInstance._vnode;return n(e.tag)}function y(e,t){for(var r=0;r<s.create.length;++r)s.create[r](nr,e);n(o=e.data.hook)&&(n(o.create)&&o.create(nr,e),n(o.insert)&&t.push(e))}function g(e){var t;if(n(t=e.fnScopeId))u.setStyleScope(e.elm,t);else for(var r=e;r;)n(t=r.context)&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t),r=r.parent;n(t=Wt)&&t!==e.context&&t!==e.fnContext&&n(t=t.$options._scopeId)&&u.setStyleScope(e.elm,t)}function _(e,t,n,r,i,o){for(;r<=i;++r)f(n[r],o,e,t,!1,n,r)}function b(e){var t,r,i=e.data;if(n(i))for(n(t=i.hook)&&n(t=t.destroy)&&t(e),t=0;t<s.destroy.length;++t)s.destroy[t](e);if(n(t=e.children))for(r=0;r<e.children.length;++r)b(e.children[r])}function $(e,t,r){for(;t<=r;++t){var i=e[t];n(i)&&(n(i.tag)?(w(i),b(i)):l(i.elm))}}function w(e,t){if(n(t)||n(e.data)){var r,i=s.remove.length+1;for(n(t)?t.listeners+=i:t=function(e,t){function n(){0==--n.listeners&&l(e)}return n.listeners=t,n}(e.elm,i),n(r=e.componentInstance)&&n(r=r._vnode)&&n(r.data)&&w(r,t),r=0;r<s.remove.length;++r)s.remove[r](e,t);n(r=e.data.hook)&&n(r=r.remove)?r(e,t):t()}else l(e.elm)}function C(e,t,r,i){for(var o=r;o<i;o++){var a=t[o];if(n(a)&&ir(e,a))return o}}function x(e,i,o,a,c,l){if(e!==i){n(i.elm)&&n(a)&&(i=a[c]=me(i));var p=i.elm=e.elm;if(r(e.isAsyncPlaceholder))n(i.asyncFactory.resolved)?O(e.elm,i,o):i.isAsyncPlaceholder=!0;else if(r(i.isStatic)&&r(e.isStatic)&&i.key===e.key&&(r(i.isCloned)||r(i.isOnce)))i.componentInstance=e.componentInstance;else{var d,v=i.data;n(v)&&n(d=v.hook)&&n(d=d.prepatch)&&d(e,i);var h=e.children,y=i.children;if(n(v)&&m(i)){for(d=0;d<s.update.length;++d)s.update[d](e,i);n(d=v.hook)&&n(d=d.update)&&d(e,i)}t(i.text)?n(h)&&n(y)?h!==y&&function(e,r,i,o,a){for(var s,c,l,p=0,d=0,v=r.length-1,h=r[0],m=r[v],y=i.length-1,g=i[0],b=i[y],w=!a;p<=v&&d<=y;)t(h)?h=r[++p]:t(m)?m=r[--v]:ir(h,g)?(x(h,g,o,i,d),h=r[++p],g=i[++d]):ir(m,b)?(x(m,b,o,i,y),m=r[--v],b=i[--y]):ir(h,b)?(x(h,b,o,i,y),w&&u.insertBefore(e,h.elm,u.nextSibling(m.elm)),h=r[++p],b=i[--y]):ir(m,g)?(x(m,g,o,i,d),w&&u.insertBefore(e,m.elm,h.elm),m=r[--v],g=i[++d]):(t(s)&&(s=or(r,p,v)),t(c=n(g.key)?s[g.key]:C(g,r,p,v))?f(g,o,e,h.elm,!1,i,d):ir(l=r[c],g)?(x(l,g,o,i,d),r[c]=void 0,w&&u.insertBefore(e,l.elm,h.elm)):f(g,o,e,h.elm,!1,i,d),g=i[++d]);p>v?_(e,t(i[y+1])?null:i[y+1].elm,i,d,y,o):d>y&&$(r,p,v)}(p,h,y,o,l):n(y)?(n(e.text)&&u.setTextContent(p,""),_(p,null,y,0,y.length-1,o)):n(h)?$(h,0,h.length-1):n(e.text)&&u.setTextContent(p,""):e.text!==i.text&&u.setTextContent(p,i.text),n(v)&&n(d=v.hook)&&n(d=d.postpatch)&&d(e,i)}}}function k(e,t,i){if(r(i)&&n(e.parent))e.parent.data.pendingInsert=t;else for(var o=0;o<t.length;++o)t[o].data.hook.insert(t[o])}var A=p("attrs,class,staticClass,staticStyle,key");function O(e,t,i,o){var a,s=t.tag,c=t.data,u=t.children;if(o=o||c&&c.pre,t.elm=e,r(t.isComment)&&n(t.asyncFactory))return t.isAsyncPlaceholder=!0,!0;if(n(c)&&(n(a=c.hook)&&n(a=a.init)&&a(t,!0),n(a=t.componentInstance)))return d(t,i),!0;if(n(s)){if(n(u))if(e.hasChildNodes())if(n(a=c)&&n(a=a.domProps)&&n(a=a.innerHTML)){if(a!==e.innerHTML)return!1}else{for(var l=!0,f=e.firstChild,p=0;p<u.length;p++){if(!f||!O(f,u[p],i,o)){l=!1;break}f=f.nextSibling}if(!l||f)return!1}else h(t,u,i);if(n(c)){var v=!1;for(var m in c)if(!A(m)){v=!0,y(t,i);break}!v&&c.class&&et(c.class)}}else e.data!==t.text&&(e.data=t.text);return!0}return function(e,i,o,a){if(!t(i)){var c,l=!1,p=[];if(t(e))l=!0,f(i,p);else{var d=n(e.nodeType);if(!d&&ir(e,i))x(e,i,p,null,null,a);else{if(d){if(1===e.nodeType&&e.hasAttribute(L)&&(e.removeAttribute(L),o=!0),r(o)&&O(e,i,p))return k(i,p,!0),e;c=e,e=new pe(u.tagName(c).toLowerCase(),{},[],void 0,c)}var v=e.elm,h=u.parentNode(v);if(f(i,p,v._leaveCb?null:h,u.nextSibling(v)),n(i.parent))for(var y=i.parent,g=m(i);y;){for(var _=0;_<s.destroy.length;++_)s.destroy[_](y);if(y.elm=i.elm,g){for(var w=0;w<s.create.length;++w)s.create[w](nr,y);var C=y.data.hook.insert;if(C.merged)for(var A=1;A<C.fns.length;A++)C.fns[A]()}else tr(y);y=y.parent}n(h)?$([e],0,0):n(e.tag)&&b(e)}}return k(i,p,l),i.elm}n(e)&&b(e)}}({nodeOps:Qn,modules:[mr,xr,ni,oi,mi,z?{create:Ui,activate:Ui,remove:function(e,t){!0!==e.data.show?Ri(e,t):t()}}:{}].concat(pr)});W&&document.addEventListener("selectionchange",function(){var e=document.activeElement;e&&e.vmodel&&Xi(e,"input")});var Vi={inserted:function(e,t,n,r){"select"===n.tag?(r.elm&&!r.elm._vOptions?it(n,"postpatch",function(){Vi.componentUpdated(e,t,n)}):Ki(e,t,n.context),e._vOptions=[].map.call(e.options,Wi)):("textarea"===n.tag||Xn(e.type))&&(e._vModifiers=t.modifiers,t.modifiers.lazy||(e.addEventListener("compositionstart",Zi),e.addEventListener("compositionend",Gi),e.addEventListener("change",Gi),W&&(e.vmodel=!0)))},componentUpdated:function(e,t,n){if("select"===n.tag){Ki(e,t,n.context);var r=e._vOptions,i=e._vOptions=[].map.call(e.options,Wi);if(i.some(function(e,t){return!N(e,r[t])}))(e.multiple?t.value.some(function(e){return qi(e,i)}):t.value!==t.oldValue&&qi(t.value,i))&&Xi(e,"change")}}};function Ki(e,t,n){Ji(e,t,n),(q||Z)&&setTimeout(function(){Ji(e,t,n)},0)}function Ji(e,t,n){var r=t.value,i=e.multiple;if(!i||Array.isArray(r)){for(var o,a,s=0,c=e.options.length;s<c;s++)if(a=e.options[s],i)o=j(r,Wi(a))>-1,a.selected!==o&&(a.selected=o);else if(N(Wi(a),r))return void(e.selectedIndex!==s&&(e.selectedIndex=s));i||(e.selectedIndex=-1)}}function qi(e,t){return t.every(function(t){return!N(t,e)})}function Wi(e){return"_value"in e?e._value:e.value}function Zi(e){e.target.composing=!0}function Gi(e){e.target.composing&&(e.target.composing=!1,Xi(e.target,"input"))}function Xi(e,t){var n=document.createEvent("HTMLEvents");n.initEvent(t,!0,!0),e.dispatchEvent(n)}function Yi(e){return!e.componentInstance||e.data&&e.data.transition?e:Yi(e.componentInstance._vnode)}var Qi={model:Vi,show:{bind:function(e,t,n){var r=t.value,i=(n=Yi(n)).data&&n.data.transition,o=e.__vOriginalDisplay="none"===e.style.display?"":e.style.display;r&&i?(n.data.show=!0,Pi(n,function(){e.style.display=o})):e.style.display=r?o:"none"},update:function(e,t,n){var r=t.value;!r!=!t.oldValue&&((n=Yi(n)).data&&n.data.transition?(n.data.show=!0,r?Pi(n,function(){e.style.display=e.__vOriginalDisplay}):Ri(n,function(){e.style.display="none"})):e.style.display=r?e.__vOriginalDisplay:"none")},unbind:function(e,t,n,r,i){i||(e.style.display=e.__vOriginalDisplay)}}},eo={name:String,appear:Boolean,css:Boolean,mode:String,type:String,enterClass:String,leaveClass:String,enterToClass:String,leaveToClass:String,enterActiveClass:String,leaveActiveClass:String,appearClass:String,appearActiveClass:String,appearToClass:String,duration:[Number,String,Object]};function to(e){var t=e&&e.componentOptions;return t&&t.Ctor.options.abstract?to(zt(t.children)):e}function no(e){var t={},n=e.$options;for(var r in n.propsData)t[r]=e[r];var i=n._parentListeners;for(var o in i)t[b(o)]=i[o];return t}function ro(e,t){if(/\d-keep-alive$/.test(t.tag))return e("keep-alive",{props:t.componentOptions.propsData})}var io=function(e){return e.tag||Ut(e)},oo=function(e){return"show"===e.name},ao={name:"transition",props:eo,abstract:!0,render:function(e){var t=this,n=this.$slots.default;if(n&&(n=n.filter(io)).length){var r=this.mode,o=n[0];if(function(e){for(;e=e.parent;)if(e.data.transition)return!0}(this.$vnode))return o;var a=to(o);if(!a)return o;if(this._leaving)return ro(e,o);var s="__transition-"+this._uid+"-";a.key=null==a.key?a.isComment?s+"comment":s+a.tag:i(a.key)?0===String(a.key).indexOf(s)?a.key:s+a.key:a.key;var c=(a.data||(a.data={})).transition=no(this),u=this._vnode,l=to(u);if(a.data.directives&&a.data.directives.some(oo)&&(a.data.show=!0),l&&l.data&&!function(e,t){return t.key===e.key&&t.tag===e.tag}(a,l)&&!Ut(l)&&(!l.componentInstance||!l.componentInstance._vnode.isComment)){var f=l.data.transition=A({},c);if("out-in"===r)return this._leaving=!0,it(f,"afterLeave",function(){t._leaving=!1,t.$forceUpdate()}),ro(e,o);if("in-out"===r){if(Ut(a))return u;var p,d=function(){p()};it(c,"afterEnter",d),it(c,"enterCancelled",d),it(f,"delayLeave",function(e){p=e})}}return o}}},so=A({tag:String,moveClass:String},eo);function co(e){e.elm._moveCb&&e.elm._moveCb(),e.elm._enterCb&&e.elm._enterCb()}function uo(e){e.data.newPos=e.elm.getBoundingClientRect()}function lo(e){var t=e.data.pos,n=e.data.newPos,r=t.left-n.left,i=t.top-n.top;if(r||i){e.data.moved=!0;var o=e.elm.style;o.transform=o.WebkitTransform="translate("+r+"px,"+i+"px)",o.transitionDuration="0s"}}delete so.mode;var fo={Transition:ao,TransitionGroup:{props:so,beforeMount:function(){var e=this,t=this._update;this._update=function(n,r){var i=Zt(e);e.__patch__(e._vnode,e.kept,!1,!0),e._vnode=e.kept,i(),t.call(e,n,r)}},render:function(e){for(var t=this.tag||this.$vnode.data.tag||"span",n=Object.create(null),r=this.prevChildren=this.children,i=this.$slots.default||[],o=this.children=[],a=no(this),s=0;s<i.length;s++){var c=i[s];c.tag&&null!=c.key&&0!==String(c.key).indexOf("__vlist")&&(o.push(c),n[c.key]=c,(c.data||(c.data={})).transition=a)}if(r){for(var u=[],l=[],f=0;f<r.length;f++){var p=r[f];p.data.transition=a,p.data.pos=p.elm.getBoundingClientRect(),n[p.key]?u.push(p):l.push(p)}this.kept=e(t,null,u),this.removed=l}return e(t,null,o)},updated:function(){var e=this.prevChildren,t=this.moveClass||(this.name||"v")+"-move";e.length&&this.hasMove(e[0].elm,t)&&(e.forEach(co),e.forEach(uo),e.forEach(lo),this._reflow=document.body.offsetHeight,e.forEach(function(e){if(e.data.moved){var n=e.elm,r=n.style;Ni(n,t),r.transform=r.WebkitTransform=r.transitionDuration="",n.addEventListener(Ai,n._moveCb=function e(r){r&&r.target!==n||r&&!/transform$/.test(r.propertyName)||(n.removeEventListener(Ai,e),n._moveCb=null,ji(n,t))})}}))},methods:{hasMove:function(e,t){if(!wi)return!1;if(this._hasMove)return this._hasMove;var n=e.cloneNode();e._transitionClasses&&e._transitionClasses.forEach(function(e){_i(n,e)}),gi(n,t),n.style.display="none",this.$el.appendChild(n);var r=Mi(n);return this.$el.removeChild(n),this._hasMove=r.hasTransform}}}};wn.config.mustUseProp=jn,wn.config.isReservedTag=Wn,wn.config.isReservedAttr=En,wn.config.getTagNamespace=Zn,wn.config.isUnknownElement=function(e){if(!z)return!0;if(Wn(e))return!1;if(e=e.toLowerCase(),null!=Gn[e])return Gn[e];var t=document.createElement(e);return e.indexOf("-")>-1?Gn[e]=t.constructor===window.HTMLUnknownElement||t.constructor===window.HTMLElement:Gn[e]=/HTMLUnknownElement/.test(t.toString())},A(wn.options.directives,Qi),A(wn.options.components,fo),wn.prototype.__patch__=z?zi:S,wn.prototype.$mount=function(e,t){return function(e,t,n){var r;return e.$el=t,e.$options.render||(e.$options.render=ve),Yt(e,"beforeMount"),r=function(){e._update(e._render(),n)},new fn(e,r,S,{before:function(){e._isMounted&&!e._isDestroyed&&Yt(e,"beforeUpdate")}},!0),n=!1,null==e.$vnode&&(e._isMounted=!0,Yt(e,"mounted")),e}(this,e=e&&z?Yn(e):void 0,t)},z&&setTimeout(function(){F.devtools&&ne&&ne.emit("init",wn)},0);var po=/\{\{((?:.|\r?\n)+?)\}\}/g,vo=/[-.*+?^${}()|[\]\/\\]/g,ho=g(function(e){var t=e[0].replace(vo,"\\$&"),n=e[1].replace(vo,"\\$&");return new RegExp(t+"((?:.|\\n)+?)"+n,"g")});var mo={staticKeys:["staticClass"],transformNode:function(e,t){t.warn;var n=Fr(e,"class");n&&(e.staticClass=JSON.stringify(n));var r=Ir(e,"class",!1);r&&(e.classBinding=r)},genData:function(e){var t="";return e.staticClass&&(t+="staticClass:"+e.staticClass+","),e.classBinding&&(t+="class:"+e.classBinding+","),t}};var yo,go={staticKeys:["staticStyle"],transformNode:function(e,t){t.warn;var n=Fr(e,"style");n&&(e.staticStyle=JSON.stringify(ai(n)));var r=Ir(e,"style",!1);r&&(e.styleBinding=r)},genData:function(e){var t="";return e.staticStyle&&(t+="staticStyle:"+e.staticStyle+","),e.styleBinding&&(t+="style:("+e.styleBinding+"),"),t}},_o=function(e){return(yo=yo||document.createElement("div")).innerHTML=e,yo.textContent},bo=p("area,base,br,col,embed,frame,hr,img,input,isindex,keygen,link,meta,param,source,track,wbr"),$o=p("colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source"),wo=p("address,article,aside,base,blockquote,body,caption,col,colgroup,dd,details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,title,tr,track"),Co=/^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,xo=/^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/,ko="[a-zA-Z_][\\-\\.0-9_a-zA-Z"+P.source+"]*",Ao="((?:"+ko+"\\:)?"+ko+")",Oo=new RegExp("^<"+Ao),So=/^\s*(\/?)>/,To=new RegExp("^<\\/"+Ao+"[^>]*>"),Eo=/^<!DOCTYPE [^>]+>/i,No=/^<!\--/,jo=/^<!\[/,Do=p("script,style,textarea",!0),Lo={},Mo={"&lt;":"<","&gt;":">","&quot;":'"',"&amp;":"&","&#10;":"\n","&#9;":"\t","&#39;":"'"},Io=/&(?:lt|gt|quot|amp|#39);/g,Fo=/&(?:lt|gt|quot|amp|#39|#10|#9);/g,Po=p("pre,textarea",!0),Ro=function(e,t){return e&&Po(e)&&"\n"===t[0]};function Ho(e,t){var n=t?Fo:Io;return e.replace(n,function(e){return Mo[e]})}var Bo,Uo,zo,Vo,Ko,Jo,qo,Wo,Zo=/^@|^v-on:/,Go=/^v-|^@|^:|^#/,Xo=/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/,Yo=/,([^,\}\]]*)(?:,([^,\}\]]*))?$/,Qo=/^\(|\)$/g,ea=/^\[.*\]$/,ta=/:(.*)$/,na=/^:|^\.|^v-bind:/,ra=/\.[^.\]]+(?=[^\]]*$)/g,ia=/^v-slot(:|$)|^#/,oa=/[\r\n]/,aa=/\s+/g,sa=g(_o),ca="_empty_";function ua(e,t,n){return{type:1,tag:e,attrsList:t,attrsMap:ma(t),rawAttrsMap:{},parent:n,children:[]}}function la(e,t){Bo=t.warn||Sr,Jo=t.isPreTag||T,qo=t.mustUseProp||T,Wo=t.getTagNamespace||T;t.isReservedTag;zo=Tr(t.modules,"transformNode"),Vo=Tr(t.modules,"preTransformNode"),Ko=Tr(t.modules,"postTransformNode"),Uo=t.delimiters;var n,r,i=[],o=!1!==t.preserveWhitespace,a=t.whitespace,s=!1,c=!1;function u(e){if(l(e),s||e.processed||(e=fa(e,t)),i.length||e===n||n.if&&(e.elseif||e.else)&&da(n,{exp:e.elseif,block:e}),r&&!e.forbidden)if(e.elseif||e.else)a=e,(u=function(e){var t=e.length;for(;t--;){if(1===e[t].type)return e[t];e.pop()}}(r.children))&&u.if&&da(u,{exp:a.elseif,block:a});else{if(e.slotScope){var o=e.slotTarget||'"default"';(r.scopedSlots||(r.scopedSlots={}))[o]=e}r.children.push(e),e.parent=r}var a,u;e.children=e.children.filter(function(e){return!e.slotScope}),l(e),e.pre&&(s=!1),Jo(e.tag)&&(c=!1);for(var f=0;f<Ko.length;f++)Ko[f](e,t)}function l(e){if(!c)for(var t;(t=e.children[e.children.length-1])&&3===t.type&&" "===t.text;)e.children.pop()}return function(e,t){for(var n,r,i=[],o=t.expectHTML,a=t.isUnaryTag||T,s=t.canBeLeftOpenTag||T,c=0;e;){if(n=e,r&&Do(r)){var u=0,l=r.toLowerCase(),f=Lo[l]||(Lo[l]=new RegExp("([\\s\\S]*?)(</"+l+"[^>]*>)","i")),p=e.replace(f,function(e,n,r){return u=r.length,Do(l)||"noscript"===l||(n=n.replace(/<!\--([\s\S]*?)-->/g,"$1").replace(/<!\[CDATA\[([\s\S]*?)]]>/g,"$1")),Ro(l,n)&&(n=n.slice(1)),t.chars&&t.chars(n),""});c+=e.length-p.length,e=p,A(l,c-u,c)}else{var d=e.indexOf("<");if(0===d){if(No.test(e)){var v=e.indexOf("--\x3e");if(v>=0){t.shouldKeepComment&&t.comment(e.substring(4,v),c,c+v+3),C(v+3);continue}}if(jo.test(e)){var h=e.indexOf("]>");if(h>=0){C(h+2);continue}}var m=e.match(Eo);if(m){C(m[0].length);continue}var y=e.match(To);if(y){var g=c;C(y[0].length),A(y[1],g,c);continue}var _=x();if(_){k(_),Ro(_.tagName,e)&&C(1);continue}}var b=void 0,$=void 0,w=void 0;if(d>=0){for($=e.slice(d);!(To.test($)||Oo.test($)||No.test($)||jo.test($)||(w=$.indexOf("<",1))<0);)d+=w,$=e.slice(d);b=e.substring(0,d)}d<0&&(b=e),b&&C(b.length),t.chars&&b&&t.chars(b,c-b.length,c)}if(e===n){t.chars&&t.chars(e);break}}function C(t){c+=t,e=e.substring(t)}function x(){var t=e.match(Oo);if(t){var n,r,i={tagName:t[1],attrs:[],start:c};for(C(t[0].length);!(n=e.match(So))&&(r=e.match(xo)||e.match(Co));)r.start=c,C(r[0].length),r.end=c,i.attrs.push(r);if(n)return i.unarySlash=n[1],C(n[0].length),i.end=c,i}}function k(e){var n=e.tagName,c=e.unarySlash;o&&("p"===r&&wo(n)&&A(r),s(n)&&r===n&&A(n));for(var u=a(n)||!!c,l=e.attrs.length,f=new Array(l),p=0;p<l;p++){var d=e.attrs[p],v=d[3]||d[4]||d[5]||"",h="a"===n&&"href"===d[1]?t.shouldDecodeNewlinesForHref:t.shouldDecodeNewlines;f[p]={name:d[1],value:Ho(v,h)}}u||(i.push({tag:n,lowerCasedTag:n.toLowerCase(),attrs:f,start:e.start,end:e.end}),r=n),t.start&&t.start(n,f,u,e.start,e.end)}function A(e,n,o){var a,s;if(null==n&&(n=c),null==o&&(o=c),e)for(s=e.toLowerCase(),a=i.length-1;a>=0&&i[a].lowerCasedTag!==s;a--);else a=0;if(a>=0){for(var u=i.length-1;u>=a;u--)t.end&&t.end(i[u].tag,n,o);i.length=a,r=a&&i[a-1].tag}else"br"===s?t.start&&t.start(e,[],!0,n,o):"p"===s&&(t.start&&t.start(e,[],!1,n,o),t.end&&t.end(e,n,o))}A()}(e,{warn:Bo,expectHTML:t.expectHTML,isUnaryTag:t.isUnaryTag,canBeLeftOpenTag:t.canBeLeftOpenTag,shouldDecodeNewlines:t.shouldDecodeNewlines,shouldDecodeNewlinesForHref:t.shouldDecodeNewlinesForHref,shouldKeepComment:t.comments,outputSourceRange:t.outputSourceRange,start:function(e,o,a,l,f){var p=r&&r.ns||Wo(e);q&&"svg"===p&&(o=function(e){for(var t=[],n=0;n<e.length;n++){var r=e[n];ya.test(r.name)||(r.name=r.name.replace(ga,""),t.push(r))}return t}(o));var d,v=ua(e,o,r);p&&(v.ns=p),"style"!==(d=v).tag&&("script"!==d.tag||d.attrsMap.type&&"text/javascript"!==d.attrsMap.type)||te()||(v.forbidden=!0);for(var h=0;h<Vo.length;h++)v=Vo[h](v,t)||v;s||(!function(e){null!=Fr(e,"v-pre")&&(e.pre=!0)}(v),v.pre&&(s=!0)),Jo(v.tag)&&(c=!0),s?function(e){var t=e.attrsList,n=t.length;if(n)for(var r=e.attrs=new Array(n),i=0;i<n;i++)r[i]={name:t[i].name,value:JSON.stringify(t[i].value)},null!=t[i].start&&(r[i].start=t[i].start,r[i].end=t[i].end);else e.pre||(e.plain=!0)}(v):v.processed||(pa(v),function(e){var t=Fr(e,"v-if");if(t)e.if=t,da(e,{exp:t,block:e});else{null!=Fr(e,"v-else")&&(e.else=!0);var n=Fr(e,"v-else-if");n&&(e.elseif=n)}}(v),function(e){null!=Fr(e,"v-once")&&(e.once=!0)}(v)),n||(n=v),a?u(v):(r=v,i.push(v))},end:function(e,t,n){var o=i[i.length-1];i.length-=1,r=i[i.length-1],u(o)},chars:function(e,t,n){if(r&&(!q||"textarea"!==r.tag||r.attrsMap.placeholder!==e)){var i,u,l,f=r.children;if(e=c||e.trim()?"script"===(i=r).tag||"style"===i.tag?e:sa(e):f.length?a?"condense"===a&&oa.test(e)?"":" ":o?" ":"":"")c||"condense"!==a||(e=e.replace(aa," ")),!s&&" "!==e&&(u=function(e,t){var n=t?ho(t):po;if(n.test(e)){for(var r,i,o,a=[],s=[],c=n.lastIndex=0;r=n.exec(e);){(i=r.index)>c&&(s.push(o=e.slice(c,i)),a.push(JSON.stringify(o)));var u=Ar(r[1].trim());a.push("_s("+u+")"),s.push({"@binding":u}),c=i+r[0].length}return c<e.length&&(s.push(o=e.slice(c)),a.push(JSON.stringify(o))),{expression:a.join("+"),tokens:s}}}(e,Uo))?l={type:2,expression:u.expression,tokens:u.tokens,text:e}:" "===e&&f.length&&" "===f[f.length-1].text||(l={type:3,text:e}),l&&f.push(l)}},comment:function(e,t,n){if(r){var i={type:3,text:e,isComment:!0};r.children.push(i)}}}),n}function fa(e,t){var n,r;(r=Ir(n=e,"key"))&&(n.key=r),e.plain=!e.key&&!e.scopedSlots&&!e.attrsList.length,function(e){var t=Ir(e,"ref");t&&(e.ref=t,e.refInFor=function(e){var t=e;for(;t;){if(void 0!==t.for)return!0;t=t.parent}return!1}(e))}(e),function(e){var t;"template"===e.tag?(t=Fr(e,"scope"),e.slotScope=t||Fr(e,"slot-scope")):(t=Fr(e,"slot-scope"))&&(e.slotScope=t);var n=Ir(e,"slot");n&&(e.slotTarget='""'===n?'"default"':n,e.slotTargetDynamic=!(!e.attrsMap[":slot"]&&!e.attrsMap["v-bind:slot"]),"template"===e.tag||e.slotScope||Nr(e,"slot",n,function(e,t){return e.rawAttrsMap[":"+t]||e.rawAttrsMap["v-bind:"+t]||e.rawAttrsMap[t]}(e,"slot")));if("template"===e.tag){var r=Pr(e,ia);if(r){var i=va(r),o=i.name,a=i.dynamic;e.slotTarget=o,e.slotTargetDynamic=a,e.slotScope=r.value||ca}}else{var s=Pr(e,ia);if(s){var c=e.scopedSlots||(e.scopedSlots={}),u=va(s),l=u.name,f=u.dynamic,p=c[l]=ua("template",[],e);p.slotTarget=l,p.slotTargetDynamic=f,p.children=e.children.filter(function(e){if(!e.slotScope)return e.parent=p,!0}),p.slotScope=s.value||ca,e.children=[],e.plain=!1}}}(e),function(e){"slot"===e.tag&&(e.slotName=Ir(e,"name"))}(e),function(e){var t;(t=Ir(e,"is"))&&(e.component=t);null!=Fr(e,"inline-template")&&(e.inlineTemplate=!0)}(e);for(var i=0;i<zo.length;i++)e=zo[i](e,t)||e;return function(e){var t,n,r,i,o,a,s,c,u=e.attrsList;for(t=0,n=u.length;t<n;t++)if(r=i=u[t].name,o=u[t].value,Go.test(r))if(e.hasBindings=!0,(a=ha(r.replace(Go,"")))&&(r=r.replace(ra,"")),na.test(r))r=r.replace(na,""),o=Ar(o),(c=ea.test(r))&&(r=r.slice(1,-1)),a&&(a.prop&&!c&&"innerHtml"===(r=b(r))&&(r="innerHTML"),a.camel&&!c&&(r=b(r)),a.sync&&(s=Br(o,"$event"),c?Mr(e,'"update:"+('+r+")",s,null,!1,0,u[t],!0):(Mr(e,"update:"+b(r),s,null,!1,0,u[t]),C(r)!==b(r)&&Mr(e,"update:"+C(r),s,null,!1,0,u[t])))),a&&a.prop||!e.component&&qo(e.tag,e.attrsMap.type,r)?Er(e,r,o,u[t],c):Nr(e,r,o,u[t],c);else if(Zo.test(r))r=r.replace(Zo,""),(c=ea.test(r))&&(r=r.slice(1,-1)),Mr(e,r,o,a,!1,0,u[t],c);else{var l=(r=r.replace(Go,"")).match(ta),f=l&&l[1];c=!1,f&&(r=r.slice(0,-(f.length+1)),ea.test(f)&&(f=f.slice(1,-1),c=!0)),Dr(e,r,i,o,f,c,a,u[t])}else Nr(e,r,JSON.stringify(o),u[t]),!e.component&&"muted"===r&&qo(e.tag,e.attrsMap.type,r)&&Er(e,r,"true",u[t])}(e),e}function pa(e){var t;if(t=Fr(e,"v-for")){var n=function(e){var t=e.match(Xo);if(!t)return;var n={};n.for=t[2].trim();var r=t[1].trim().replace(Qo,""),i=r.match(Yo);i?(n.alias=r.replace(Yo,"").trim(),n.iterator1=i[1].trim(),i[2]&&(n.iterator2=i[2].trim())):n.alias=r;return n}(t);n&&A(e,n)}}function da(e,t){e.ifConditions||(e.ifConditions=[]),e.ifConditions.push(t)}function va(e){var t=e.name.replace(ia,"");return t||"#"!==e.name[0]&&(t="default"),ea.test(t)?{name:t.slice(1,-1),dynamic:!0}:{name:'"'+t+'"',dynamic:!1}}function ha(e){var t=e.match(ra);if(t){var n={};return t.forEach(function(e){n[e.slice(1)]=!0}),n}}function ma(e){for(var t={},n=0,r=e.length;n<r;n++)t[e[n].name]=e[n].value;return t}var ya=/^xmlns:NS\d+/,ga=/^NS\d+:/;function _a(e){return ua(e.tag,e.attrsList.slice(),e.parent)}var ba=[mo,go,{preTransformNode:function(e,t){if("input"===e.tag){var n,r=e.attrsMap;if(!r["v-model"])return;if((r[":type"]||r["v-bind:type"])&&(n=Ir(e,"type")),r.type||n||!r["v-bind"]||(n="("+r["v-bind"]+").type"),n){var i=Fr(e,"v-if",!0),o=i?"&&("+i+")":"",a=null!=Fr(e,"v-else",!0),s=Fr(e,"v-else-if",!0),c=_a(e);pa(c),jr(c,"type","checkbox"),fa(c,t),c.processed=!0,c.if="("+n+")==='checkbox'"+o,da(c,{exp:c.if,block:c});var u=_a(e);Fr(u,"v-for",!0),jr(u,"type","radio"),fa(u,t),da(c,{exp:"("+n+")==='radio'"+o,block:u});var l=_a(e);return Fr(l,"v-for",!0),jr(l,":type",n),fa(l,t),da(c,{exp:i,block:l}),a?c.else=!0:s&&(c.elseif=s),c}}}}];var $a,wa,Ca={expectHTML:!0,modules:ba,directives:{model:function(e,t,n){var r=t.value,i=t.modifiers,o=e.tag,a=e.attrsMap.type;if(e.component)return Hr(e,r,i),!1;if("select"===o)!function(e,t,n){var r='var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return '+(n&&n.number?"_n(val)":"val")+"});";r=r+" "+Br(t,"$event.target.multiple ? $$selectedVal : $$selectedVal[0]"),Mr(e,"change",r,null,!0)}(e,r,i);else if("input"===o&&"checkbox"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null",o=Ir(e,"true-value")||"true",a=Ir(e,"false-value")||"false";Er(e,"checked","Array.isArray("+t+")?_i("+t+","+i+")>-1"+("true"===o?":("+t+")":":_q("+t+","+o+")")),Mr(e,"change","var $$a="+t+",$$el=$event.target,$$c=$$el.checked?("+o+"):("+a+");if(Array.isArray($$a)){var $$v="+(r?"_n("+i+")":i)+",$$i=_i($$a,$$v);if($$el.checked){$$i<0&&("+Br(t,"$$a.concat([$$v])")+")}else{$$i>-1&&("+Br(t,"$$a.slice(0,$$i).concat($$a.slice($$i+1))")+")}}else{"+Br(t,"$$c")+"}",null,!0)}(e,r,i);else if("input"===o&&"radio"===a)!function(e,t,n){var r=n&&n.number,i=Ir(e,"value")||"null";Er(e,"checked","_q("+t+","+(i=r?"_n("+i+")":i)+")"),Mr(e,"change",Br(t,i),null,!0)}(e,r,i);else if("input"===o||"textarea"===o)!function(e,t,n){var r=e.attrsMap.type,i=n||{},o=i.lazy,a=i.number,s=i.trim,c=!o&&"range"!==r,u=o?"change":"range"===r?Wr:"input",l="$event.target.value";s&&(l="$event.target.value.trim()"),a&&(l="_n("+l+")");var f=Br(t,l);c&&(f="if($event.target.composing)return;"+f),Er(e,"value","("+t+")"),Mr(e,u,f,null,!0),(s||a)&&Mr(e,"blur","$forceUpdate()")}(e,r,i);else if(!F.isReservedTag(o))return Hr(e,r,i),!1;return!0},text:function(e,t){t.value&&Er(e,"textContent","_s("+t.value+")",t)},html:function(e,t){t.value&&Er(e,"innerHTML","_s("+t.value+")",t)}},isPreTag:function(e){return"pre"===e},isUnaryTag:bo,mustUseProp:jn,canBeLeftOpenTag:$o,isReservedTag:Wn,getTagNamespace:Zn,staticKeys:function(e){return e.reduce(function(e,t){return e.concat(t.staticKeys||[])},[]).join(",")}(ba)},xa=g(function(e){return p("type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap"+(e?","+e:""))});function ka(e,t){e&&($a=xa(t.staticKeys||""),wa=t.isReservedTag||T,function e(t){t.static=function(e){if(2===e.type)return!1;if(3===e.type)return!0;return!(!e.pre&&(e.hasBindings||e.if||e.for||d(e.tag)||!wa(e.tag)||function(e){for(;e.parent;){if("template"!==(e=e.parent).tag)return!1;if(e.for)return!0}return!1}(e)||!Object.keys(e).every($a)))}(t);if(1===t.type){if(!wa(t.tag)&&"slot"!==t.tag&&null==t.attrsMap["inline-template"])return;for(var n=0,r=t.children.length;n<r;n++){var i=t.children[n];e(i),i.static||(t.static=!1)}if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++){var s=t.ifConditions[o].block;e(s),s.static||(t.static=!1)}}}(e),function e(t,n){if(1===t.type){if((t.static||t.once)&&(t.staticInFor=n),t.static&&t.children.length&&(1!==t.children.length||3!==t.children[0].type))return void(t.staticRoot=!0);if(t.staticRoot=!1,t.children)for(var r=0,i=t.children.length;r<i;r++)e(t.children[r],n||!!t.for);if(t.ifConditions)for(var o=1,a=t.ifConditions.length;o<a;o++)e(t.ifConditions[o].block,n)}}(e,!1))}var Aa=/^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/,Oa=/\([^)]*?\);*$/,Sa=/^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/,Ta={esc:27,tab:9,enter:13,space:32,up:38,left:37,right:39,down:40,delete:[8,46]},Ea={esc:["Esc","Escape"],tab:"Tab",enter:"Enter",space:[" ","Spacebar"],up:["Up","ArrowUp"],left:["Left","ArrowLeft"],right:["Right","ArrowRight"],down:["Down","ArrowDown"],delete:["Backspace","Delete","Del"]},Na=function(e){return"if("+e+")return null;"},ja={stop:"$event.stopPropagation();",prevent:"$event.preventDefault();",self:Na("$event.target !== $event.currentTarget"),ctrl:Na("!$event.ctrlKey"),shift:Na("!$event.shiftKey"),alt:Na("!$event.altKey"),meta:Na("!$event.metaKey"),left:Na("'button' in $event && $event.button !== 0"),middle:Na("'button' in $event && $event.button !== 1"),right:Na("'button' in $event && $event.button !== 2")};function Da(e,t){var n=t?"nativeOn:":"on:",r="",i="";for(var o in e){var a=La(e[o]);e[o]&&e[o].dynamic?i+=o+","+a+",":r+='"'+o+'":'+a+","}return r="{"+r.slice(0,-1)+"}",i?n+"_d("+r+",["+i.slice(0,-1)+"])":n+r}function La(e){if(!e)return"function(){}";if(Array.isArray(e))return"["+e.map(function(e){return La(e)}).join(",")+"]";var t=Sa.test(e.value),n=Aa.test(e.value),r=Sa.test(e.value.replace(Oa,""));if(e.modifiers){var i="",o="",a=[];for(var s in e.modifiers)if(ja[s])o+=ja[s],Ta[s]&&a.push(s);else if("exact"===s){var c=e.modifiers;o+=Na(["ctrl","shift","alt","meta"].filter(function(e){return!c[e]}).map(function(e){return"$event."+e+"Key"}).join("||"))}else a.push(s);return a.length&&(i+=function(e){return"if(!$event.type.indexOf('key')&&"+e.map(Ma).join("&&")+")return null;"}(a)),o&&(i+=o),"function($event){"+i+(t?"return "+e.value+"($event)":n?"return ("+e.value+")($event)":r?"return "+e.value:e.value)+"}"}return t||n?e.value:"function($event){"+(r?"return "+e.value:e.value)+"}"}function Ma(e){var t=parseInt(e,10);if(t)return"$event.keyCode!=="+t;var n=Ta[e],r=Ea[e];return"_k($event.keyCode,"+JSON.stringify(e)+","+JSON.stringify(n)+",$event.key,"+JSON.stringify(r)+")"}var Ia={on:function(e,t){e.wrapListeners=function(e){return"_g("+e+","+t.value+")"}},bind:function(e,t){e.wrapData=function(n){return"_b("+n+",'"+e.tag+"',"+t.value+","+(t.modifiers&&t.modifiers.prop?"true":"false")+(t.modifiers&&t.modifiers.sync?",true":"")+")"}},cloak:S},Fa=function(e){this.options=e,this.warn=e.warn||Sr,this.transforms=Tr(e.modules,"transformCode"),this.dataGenFns=Tr(e.modules,"genData"),this.directives=A(A({},Ia),e.directives);var t=e.isReservedTag||T;this.maybeComponent=function(e){return!!e.component||!t(e.tag)},this.onceId=0,this.staticRenderFns=[],this.pre=!1};function Pa(e,t){var n=new Fa(t);return{render:"with(this){return "+(e?Ra(e,n):'_c("div")')+"}",staticRenderFns:n.staticRenderFns}}function Ra(e,t){if(e.parent&&(e.pre=e.pre||e.parent.pre),e.staticRoot&&!e.staticProcessed)return Ha(e,t);if(e.once&&!e.onceProcessed)return Ba(e,t);if(e.for&&!e.forProcessed)return za(e,t);if(e.if&&!e.ifProcessed)return Ua(e,t);if("template"!==e.tag||e.slotTarget||t.pre){if("slot"===e.tag)return function(e,t){var n=e.slotName||'"default"',r=qa(e,t),i="_t("+n+(r?","+r:""),o=e.attrs||e.dynamicAttrs?Ga((e.attrs||[]).concat(e.dynamicAttrs||[]).map(function(e){return{name:b(e.name),value:e.value,dynamic:e.dynamic}})):null,a=e.attrsMap["v-bind"];!o&&!a||r||(i+=",null");o&&(i+=","+o);a&&(i+=(o?"":",null")+","+a);return i+")"}(e,t);var n;if(e.component)n=function(e,t,n){var r=t.inlineTemplate?null:qa(t,n,!0);return"_c("+e+","+Va(t,n)+(r?","+r:"")+")"}(e.component,e,t);else{var r;(!e.plain||e.pre&&t.maybeComponent(e))&&(r=Va(e,t));var i=e.inlineTemplate?null:qa(e,t,!0);n="_c('"+e.tag+"'"+(r?","+r:"")+(i?","+i:"")+")"}for(var o=0;o<t.transforms.length;o++)n=t.transforms[o](e,n);return n}return qa(e,t)||"void 0"}function Ha(e,t){e.staticProcessed=!0;var n=t.pre;return e.pre&&(t.pre=e.pre),t.staticRenderFns.push("with(this){return "+Ra(e,t)+"}"),t.pre=n,"_m("+(t.staticRenderFns.length-1)+(e.staticInFor?",true":"")+")"}function Ba(e,t){if(e.onceProcessed=!0,e.if&&!e.ifProcessed)return Ua(e,t);if(e.staticInFor){for(var n="",r=e.parent;r;){if(r.for){n=r.key;break}r=r.parent}return n?"_o("+Ra(e,t)+","+t.onceId+++","+n+")":Ra(e,t)}return Ha(e,t)}function Ua(e,t,n,r){return e.ifProcessed=!0,function e(t,n,r,i){if(!t.length)return i||"_e()";var o=t.shift();return o.exp?"("+o.exp+")?"+a(o.block)+":"+e(t,n,r,i):""+a(o.block);function a(e){return r?r(e,n):e.once?Ba(e,n):Ra(e,n)}}(e.ifConditions.slice(),t,n,r)}function za(e,t,n,r){var i=e.for,o=e.alias,a=e.iterator1?","+e.iterator1:"",s=e.iterator2?","+e.iterator2:"";return e.forProcessed=!0,(r||"_l")+"(("+i+"),function("+o+a+s+"){return "+(n||Ra)(e,t)+"})"}function Va(e,t){var n="{",r=function(e,t){var n=e.directives;if(!n)return;var r,i,o,a,s="directives:[",c=!1;for(r=0,i=n.length;r<i;r++){o=n[r],a=!0;var u=t.directives[o.name];u&&(a=!!u(e,o,t.warn)),a&&(c=!0,s+='{name:"'+o.name+'",rawName:"'+o.rawName+'"'+(o.value?",value:("+o.value+"),expression:"+JSON.stringify(o.value):"")+(o.arg?",arg:"+(o.isDynamicArg?o.arg:'"'+o.arg+'"'):"")+(o.modifiers?",modifiers:"+JSON.stringify(o.modifiers):"")+"},")}if(c)return s.slice(0,-1)+"]"}(e,t);r&&(n+=r+","),e.key&&(n+="key:"+e.key+","),e.ref&&(n+="ref:"+e.ref+","),e.refInFor&&(n+="refInFor:true,"),e.pre&&(n+="pre:true,"),e.component&&(n+='tag:"'+e.tag+'",');for(var i=0;i<t.dataGenFns.length;i++)n+=t.dataGenFns[i](e);if(e.attrs&&(n+="attrs:"+Ga(e.attrs)+","),e.props&&(n+="domProps:"+Ga(e.props)+","),e.events&&(n+=Da(e.events,!1)+","),e.nativeEvents&&(n+=Da(e.nativeEvents,!0)+","),e.slotTarget&&!e.slotScope&&(n+="slot:"+e.slotTarget+","),e.scopedSlots&&(n+=function(e,t,n){var r=e.for||Object.keys(t).some(function(e){var n=t[e];return n.slotTargetDynamic||n.if||n.for||Ka(n)}),i=!!e.if;if(!r)for(var o=e.parent;o;){if(o.slotScope&&o.slotScope!==ca||o.for){r=!0;break}o.if&&(i=!0),o=o.parent}var a=Object.keys(t).map(function(e){return Ja(t[e],n)}).join(",");return"scopedSlots:_u(["+a+"]"+(r?",null,true":"")+(!r&&i?",null,false,"+function(e){var t=5381,n=e.length;for(;n;)t=33*t^e.charCodeAt(--n);return t>>>0}(a):"")+")"}(e,e.scopedSlots,t)+","),e.model&&(n+="model:{value:"+e.model.value+",callback:"+e.model.callback+",expression:"+e.model.expression+"},"),e.inlineTemplate){var o=function(e,t){var n=e.children[0];if(n&&1===n.type){var r=Pa(n,t.options);return"inlineTemplate:{render:function(){"+r.render+"},staticRenderFns:["+r.staticRenderFns.map(function(e){return"function(){"+e+"}"}).join(",")+"]}"}}(e,t);o&&(n+=o+",")}return n=n.replace(/,$/,"")+"}",e.dynamicAttrs&&(n="_b("+n+',"'+e.tag+'",'+Ga(e.dynamicAttrs)+")"),e.wrapData&&(n=e.wrapData(n)),e.wrapListeners&&(n=e.wrapListeners(n)),n}function Ka(e){return 1===e.type&&("slot"===e.tag||e.children.some(Ka))}function Ja(e,t){var n=e.attrsMap["slot-scope"];if(e.if&&!e.ifProcessed&&!n)return Ua(e,t,Ja,"null");if(e.for&&!e.forProcessed)return za(e,t,Ja);var r=e.slotScope===ca?"":String(e.slotScope),i="function("+r+"){return "+("template"===e.tag?e.if&&n?"("+e.if+")?"+(qa(e,t)||"undefined")+":undefined":qa(e,t)||"undefined":Ra(e,t))+"}",o=r?"":",proxy:true";return"{key:"+(e.slotTarget||'"default"')+",fn:"+i+o+"}"}function qa(e,t,n,r,i){var o=e.children;if(o.length){var a=o[0];if(1===o.length&&a.for&&"template"!==a.tag&&"slot"!==a.tag){var s=n?t.maybeComponent(a)?",1":",0":"";return""+(r||Ra)(a,t)+s}var c=n?function(e,t){for(var n=0,r=0;r<e.length;r++){var i=e[r];if(1===i.type){if(Wa(i)||i.ifConditions&&i.ifConditions.some(function(e){return Wa(e.block)})){n=2;break}(t(i)||i.ifConditions&&i.ifConditions.some(function(e){return t(e.block)}))&&(n=1)}}return n}(o,t.maybeComponent):0,u=i||Za;return"["+o.map(function(e){return u(e,t)}).join(",")+"]"+(c?","+c:"")}}function Wa(e){return void 0!==e.for||"template"===e.tag||"slot"===e.tag}function Za(e,t){return 1===e.type?Ra(e,t):3===e.type&&e.isComment?(r=e,"_e("+JSON.stringify(r.text)+")"):"_v("+(2===(n=e).type?n.expression:Xa(JSON.stringify(n.text)))+")";var n,r}function Ga(e){for(var t="",n="",r=0;r<e.length;r++){var i=e[r],o=Xa(i.value);i.dynamic?n+=i.name+","+o+",":t+='"'+i.name+'":'+o+","}return t="{"+t.slice(0,-1)+"}",n?"_d("+t+",["+n.slice(0,-1)+"])":t}function Xa(e){return e.replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")}new RegExp("\\b"+"do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,super,throw,while,yield,delete,export,import,return,switch,default,extends,finally,continue,debugger,function,arguments".split(",").join("\\b|\\b")+"\\b");function Ya(e,t){try{return new Function(e)}catch(n){return t.push({err:n,code:e}),S}}function Qa(e){var t=Object.create(null);return function(n,r,i){(r=A({},r)).warn;delete r.warn;var o=r.delimiters?String(r.delimiters)+n:n;if(t[o])return t[o];var a=e(n,r),s={},c=[];return s.render=Ya(a.render,c),s.staticRenderFns=a.staticRenderFns.map(function(e){return Ya(e,c)}),t[o]=s}}var es,ts,ns=(es=function(e,t){var n=la(e.trim(),t);!1!==t.optimize&&ka(n,t);var r=Pa(n,t);return{ast:n,render:r.render,staticRenderFns:r.staticRenderFns}},function(e){function t(t,n){var r=Object.create(e),i=[],o=[];if(n)for(var a in n.modules&&(r.modules=(e.modules||[]).concat(n.modules)),n.directives&&(r.directives=A(Object.create(e.directives||null),n.directives)),n)"modules"!==a&&"directives"!==a&&(r[a]=n[a]);r.warn=function(e,t,n){(n?o:i).push(e)};var s=es(t.trim(),r);return s.errors=i,s.tips=o,s}return{compile:t,compileToFunctions:Qa(t)}})(Ca),rs=(ns.compile,ns.compileToFunctions);function is(e){return(ts=ts||document.createElement("div")).innerHTML=e?'<a href="\n"/>':'<div a="\n"/>',ts.innerHTML.indexOf("&#10;")>0}var os=!!z&&is(!1),as=!!z&&is(!0),ss=g(function(e){var t=Yn(e);return t&&t.innerHTML}),cs=wn.prototype.$mount;wn.prototype.$mount=function(e,t){if((e=e&&Yn(e))===document.body||e===document.documentElement)return this;var n=this.$options;if(!n.render){var r=n.template;if(r)if("string"==typeof r)"#"===r.charAt(0)&&(r=ss(r));else{if(!r.nodeType)return this;r=r.innerHTML}else e&&(r=function(e){if(e.outerHTML)return e.outerHTML;var t=document.createElement("div");return t.appendChild(e.cloneNode(!0)),t.innerHTML}(e));if(r){var i=rs(r,{outputSourceRange:!1,shouldDecodeNewlines:os,shouldDecodeNewlinesForHref:as,delimiters:n.delimiters,comments:n.comments},this),o=i.render,a=i.staticRenderFns;n.render=o,n.staticRenderFns=a}}return cs.call(this,e,t)},wn.compile=rs,module.exports=wn;
}).call(this)}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("timers").setImmediate)

},{"timers":256}],264:[function(require,module,exports){
(function (process,global){(function (){
/*!
 * vuex v3.6.2
 * (c) 2021 Evan You
 * @license MIT
 */
'use strict';

function applyMixin (Vue) {
  var version = Number(Vue.version.split('.')[0]);

  if (version >= 2) {
    Vue.mixin({ beforeCreate: vuexInit });
  } else {
    // override init and inject vuex init procedure
    // for 1.x backwards compatibility.
    var _init = Vue.prototype._init;
    Vue.prototype._init = function (options) {
      if ( options === void 0 ) options = {};

      options.init = options.init
        ? [vuexInit].concat(options.init)
        : vuexInit;
      _init.call(this, options);
    };
  }

  /**
   * Vuex init hook, injected into each instances init hooks list.
   */

  function vuexInit () {
    var options = this.$options;
    // store injection
    if (options.store) {
      this.$store = typeof options.store === 'function'
        ? options.store()
        : options.store;
    } else if (options.parent && options.parent.$store) {
      this.$store = options.parent.$store;
    }
  }
}

var target = typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
    ? global
    : {};
var devtoolHook = target.__VUE_DEVTOOLS_GLOBAL_HOOK__;

function devtoolPlugin (store) {
  if (!devtoolHook) { return }

  store._devtoolHook = devtoolHook;

  devtoolHook.emit('vuex:init', store);

  devtoolHook.on('vuex:travel-to-state', function (targetState) {
    store.replaceState(targetState);
  });

  store.subscribe(function (mutation, state) {
    devtoolHook.emit('vuex:mutation', mutation, state);
  }, { prepend: true });

  store.subscribeAction(function (action, state) {
    devtoolHook.emit('vuex:action', action, state);
  }, { prepend: true });
}

/**
 * Get the first item that pass the test
 * by second argument function
 *
 * @param {Array} list
 * @param {Function} f
 * @return {*}
 */
function find (list, f) {
  return list.filter(f)[0]
}

/**
 * Deep copy the given object considering circular structure.
 * This function caches all nested objects and its copies.
 * If it detects circular structure, use cached copy to avoid infinite loop.
 *
 * @param {*} obj
 * @param {Array<Object>} cache
 * @return {*}
 */
function deepCopy (obj, cache) {
  if ( cache === void 0 ) cache = [];

  // just return if obj is immutable value
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  // if obj is hit, it is in circular structure
  var hit = find(cache, function (c) { return c.original === obj; });
  if (hit) {
    return hit.copy
  }

  var copy = Array.isArray(obj) ? [] : {};
  // put the copy into cache at first
  // because we want to refer it in recursive deepCopy
  cache.push({
    original: obj,
    copy: copy
  });

  Object.keys(obj).forEach(function (key) {
    copy[key] = deepCopy(obj[key], cache);
  });

  return copy
}

/**
 * forEach for object
 */
function forEachValue (obj, fn) {
  Object.keys(obj).forEach(function (key) { return fn(obj[key], key); });
}

function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

function isPromise (val) {
  return val && typeof val.then === 'function'
}

function assert (condition, msg) {
  if (!condition) { throw new Error(("[vuex] " + msg)) }
}

function partial (fn, arg) {
  return function () {
    return fn(arg)
  }
}

// Base data struct for store's module, package with some attribute and method
var Module = function Module (rawModule, runtime) {
  this.runtime = runtime;
  // Store some children item
  this._children = Object.create(null);
  // Store the origin module object which passed by programmer
  this._rawModule = rawModule;
  var rawState = rawModule.state;

  // Store the origin module's state
  this.state = (typeof rawState === 'function' ? rawState() : rawState) || {};
};

var prototypeAccessors = { namespaced: { configurable: true } };

prototypeAccessors.namespaced.get = function () {
  return !!this._rawModule.namespaced
};

Module.prototype.addChild = function addChild (key, module) {
  this._children[key] = module;
};

Module.prototype.removeChild = function removeChild (key) {
  delete this._children[key];
};

Module.prototype.getChild = function getChild (key) {
  return this._children[key]
};

Module.prototype.hasChild = function hasChild (key) {
  return key in this._children
};

Module.prototype.update = function update (rawModule) {
  this._rawModule.namespaced = rawModule.namespaced;
  if (rawModule.actions) {
    this._rawModule.actions = rawModule.actions;
  }
  if (rawModule.mutations) {
    this._rawModule.mutations = rawModule.mutations;
  }
  if (rawModule.getters) {
    this._rawModule.getters = rawModule.getters;
  }
};

Module.prototype.forEachChild = function forEachChild (fn) {
  forEachValue(this._children, fn);
};

Module.prototype.forEachGetter = function forEachGetter (fn) {
  if (this._rawModule.getters) {
    forEachValue(this._rawModule.getters, fn);
  }
};

Module.prototype.forEachAction = function forEachAction (fn) {
  if (this._rawModule.actions) {
    forEachValue(this._rawModule.actions, fn);
  }
};

Module.prototype.forEachMutation = function forEachMutation (fn) {
  if (this._rawModule.mutations) {
    forEachValue(this._rawModule.mutations, fn);
  }
};

Object.defineProperties( Module.prototype, prototypeAccessors );

var ModuleCollection = function ModuleCollection (rawRootModule) {
  // register root module (Vuex.Store options)
  this.register([], rawRootModule, false);
};

ModuleCollection.prototype.get = function get (path) {
  return path.reduce(function (module, key) {
    return module.getChild(key)
  }, this.root)
};

ModuleCollection.prototype.getNamespace = function getNamespace (path) {
  var module = this.root;
  return path.reduce(function (namespace, key) {
    module = module.getChild(key);
    return namespace + (module.namespaced ? key + '/' : '')
  }, '')
};

ModuleCollection.prototype.update = function update$1 (rawRootModule) {
  update([], this.root, rawRootModule);
};

ModuleCollection.prototype.register = function register (path, rawModule, runtime) {
    var this$1 = this;
    if ( runtime === void 0 ) runtime = true;

  if ((process.env.NODE_ENV !== 'production')) {
    assertRawModule(path, rawModule);
  }

  var newModule = new Module(rawModule, runtime);
  if (path.length === 0) {
    this.root = newModule;
  } else {
    var parent = this.get(path.slice(0, -1));
    parent.addChild(path[path.length - 1], newModule);
  }

  // register nested modules
  if (rawModule.modules) {
    forEachValue(rawModule.modules, function (rawChildModule, key) {
      this$1.register(path.concat(key), rawChildModule, runtime);
    });
  }
};

ModuleCollection.prototype.unregister = function unregister (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];
  var child = parent.getChild(key);

  if (!child) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.warn(
        "[vuex] trying to unregister module '" + key + "', which is " +
        "not registered"
      );
    }
    return
  }

  if (!child.runtime) {
    return
  }

  parent.removeChild(key);
};

ModuleCollection.prototype.isRegistered = function isRegistered (path) {
  var parent = this.get(path.slice(0, -1));
  var key = path[path.length - 1];

  if (parent) {
    return parent.hasChild(key)
  }

  return false
};

function update (path, targetModule, newModule) {
  if ((process.env.NODE_ENV !== 'production')) {
    assertRawModule(path, newModule);
  }

  // update target module
  targetModule.update(newModule);

  // update nested modules
  if (newModule.modules) {
    for (var key in newModule.modules) {
      if (!targetModule.getChild(key)) {
        if ((process.env.NODE_ENV !== 'production')) {
          console.warn(
            "[vuex] trying to add a new module '" + key + "' on hot reloading, " +
            'manual reload is needed'
          );
        }
        return
      }
      update(
        path.concat(key),
        targetModule.getChild(key),
        newModule.modules[key]
      );
    }
  }
}

var functionAssert = {
  assert: function (value) { return typeof value === 'function'; },
  expected: 'function'
};

var objectAssert = {
  assert: function (value) { return typeof value === 'function' ||
    (typeof value === 'object' && typeof value.handler === 'function'); },
  expected: 'function or object with "handler" function'
};

var assertTypes = {
  getters: functionAssert,
  mutations: functionAssert,
  actions: objectAssert
};

function assertRawModule (path, rawModule) {
  Object.keys(assertTypes).forEach(function (key) {
    if (!rawModule[key]) { return }

    var assertOptions = assertTypes[key];

    forEachValue(rawModule[key], function (value, type) {
      assert(
        assertOptions.assert(value),
        makeAssertionMessage(path, key, type, value, assertOptions.expected)
      );
    });
  });
}

function makeAssertionMessage (path, key, type, value, expected) {
  var buf = key + " should be " + expected + " but \"" + key + "." + type + "\"";
  if (path.length > 0) {
    buf += " in module \"" + (path.join('.')) + "\"";
  }
  buf += " is " + (JSON.stringify(value)) + ".";
  return buf
}

var Vue; // bind on install

var Store = function Store (options) {
  var this$1 = this;
  if ( options === void 0 ) options = {};

  // Auto install if it is not done yet and `window` has `Vue`.
  // To allow users to avoid auto-installation in some cases,
  // this code should be placed here. See #731
  if (!Vue && typeof window !== 'undefined' && window.Vue) {
    install(window.Vue);
  }

  if ((process.env.NODE_ENV !== 'production')) {
    assert(Vue, "must call Vue.use(Vuex) before creating a store instance.");
    assert(typeof Promise !== 'undefined', "vuex requires a Promise polyfill in this browser.");
    assert(this instanceof Store, "store must be called with the new operator.");
  }

  var plugins = options.plugins; if ( plugins === void 0 ) plugins = [];
  var strict = options.strict; if ( strict === void 0 ) strict = false;

  // store internal state
  this._committing = false;
  this._actions = Object.create(null);
  this._actionSubscribers = [];
  this._mutations = Object.create(null);
  this._wrappedGetters = Object.create(null);
  this._modules = new ModuleCollection(options);
  this._modulesNamespaceMap = Object.create(null);
  this._subscribers = [];
  this._watcherVM = new Vue();
  this._makeLocalGettersCache = Object.create(null);

  // bind commit and dispatch to self
  var store = this;
  var ref = this;
  var dispatch = ref.dispatch;
  var commit = ref.commit;
  this.dispatch = function boundDispatch (type, payload) {
    return dispatch.call(store, type, payload)
  };
  this.commit = function boundCommit (type, payload, options) {
    return commit.call(store, type, payload, options)
  };

  // strict mode
  this.strict = strict;

  var state = this._modules.root.state;

  // init root module.
  // this also recursively registers all sub-modules
  // and collects all module getters inside this._wrappedGetters
  installModule(this, state, [], this._modules.root);

  // initialize the store vm, which is responsible for the reactivity
  // (also registers _wrappedGetters as computed properties)
  resetStoreVM(this, state);

  // apply plugins
  plugins.forEach(function (plugin) { return plugin(this$1); });

  var useDevtools = options.devtools !== undefined ? options.devtools : Vue.config.devtools;
  if (useDevtools) {
    devtoolPlugin(this);
  }
};

var prototypeAccessors$1 = { state: { configurable: true } };

prototypeAccessors$1.state.get = function () {
  return this._vm._data.$$state
};

prototypeAccessors$1.state.set = function (v) {
  if ((process.env.NODE_ENV !== 'production')) {
    assert(false, "use store.replaceState() to explicit replace store state.");
  }
};

Store.prototype.commit = function commit (_type, _payload, _options) {
    var this$1 = this;

  // check object-style commit
  var ref = unifyObjectStyle(_type, _payload, _options);
    var type = ref.type;
    var payload = ref.payload;
    var options = ref.options;

  var mutation = { type: type, payload: payload };
  var entry = this._mutations[type];
  if (!entry) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.error(("[vuex] unknown mutation type: " + type));
    }
    return
  }
  this._withCommit(function () {
    entry.forEach(function commitIterator (handler) {
      handler(payload);
    });
  });

  this._subscribers
    .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
    .forEach(function (sub) { return sub(mutation, this$1.state); });

  if (
    (process.env.NODE_ENV !== 'production') &&
    options && options.silent
  ) {
    console.warn(
      "[vuex] mutation type: " + type + ". Silent option has been removed. " +
      'Use the filter functionality in the vue-devtools'
    );
  }
};

Store.prototype.dispatch = function dispatch (_type, _payload) {
    var this$1 = this;

  // check object-style dispatch
  var ref = unifyObjectStyle(_type, _payload);
    var type = ref.type;
    var payload = ref.payload;

  var action = { type: type, payload: payload };
  var entry = this._actions[type];
  if (!entry) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.error(("[vuex] unknown action type: " + type));
    }
    return
  }

  try {
    this._actionSubscribers
      .slice() // shallow copy to prevent iterator invalidation if subscriber synchronously calls unsubscribe
      .filter(function (sub) { return sub.before; })
      .forEach(function (sub) { return sub.before(action, this$1.state); });
  } catch (e) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.warn("[vuex] error in before action subscribers: ");
      console.error(e);
    }
  }

  var result = entry.length > 1
    ? Promise.all(entry.map(function (handler) { return handler(payload); }))
    : entry[0](payload);

  return new Promise(function (resolve, reject) {
    result.then(function (res) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.after; })
          .forEach(function (sub) { return sub.after(action, this$1.state); });
      } catch (e) {
        if ((process.env.NODE_ENV !== 'production')) {
          console.warn("[vuex] error in after action subscribers: ");
          console.error(e);
        }
      }
      resolve(res);
    }, function (error) {
      try {
        this$1._actionSubscribers
          .filter(function (sub) { return sub.error; })
          .forEach(function (sub) { return sub.error(action, this$1.state, error); });
      } catch (e) {
        if ((process.env.NODE_ENV !== 'production')) {
          console.warn("[vuex] error in error action subscribers: ");
          console.error(e);
        }
      }
      reject(error);
    });
  })
};

Store.prototype.subscribe = function subscribe (fn, options) {
  return genericSubscribe(fn, this._subscribers, options)
};

Store.prototype.subscribeAction = function subscribeAction (fn, options) {
  var subs = typeof fn === 'function' ? { before: fn } : fn;
  return genericSubscribe(subs, this._actionSubscribers, options)
};

Store.prototype.watch = function watch (getter, cb, options) {
    var this$1 = this;

  if ((process.env.NODE_ENV !== 'production')) {
    assert(typeof getter === 'function', "store.watch only accepts a function.");
  }
  return this._watcherVM.$watch(function () { return getter(this$1.state, this$1.getters); }, cb, options)
};

Store.prototype.replaceState = function replaceState (state) {
    var this$1 = this;

  this._withCommit(function () {
    this$1._vm._data.$$state = state;
  });
};

Store.prototype.registerModule = function registerModule (path, rawModule, options) {
    if ( options === void 0 ) options = {};

  if (typeof path === 'string') { path = [path]; }

  if ((process.env.NODE_ENV !== 'production')) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
    assert(path.length > 0, 'cannot register the root module by using registerModule.');
  }

  this._modules.register(path, rawModule);
  installModule(this, this.state, path, this._modules.get(path), options.preserveState);
  // reset store to update getters...
  resetStoreVM(this, this.state);
};

Store.prototype.unregisterModule = function unregisterModule (path) {
    var this$1 = this;

  if (typeof path === 'string') { path = [path]; }

  if ((process.env.NODE_ENV !== 'production')) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  this._modules.unregister(path);
  this._withCommit(function () {
    var parentState = getNestedState(this$1.state, path.slice(0, -1));
    Vue.delete(parentState, path[path.length - 1]);
  });
  resetStore(this);
};

Store.prototype.hasModule = function hasModule (path) {
  if (typeof path === 'string') { path = [path]; }

  if ((process.env.NODE_ENV !== 'production')) {
    assert(Array.isArray(path), "module path must be a string or an Array.");
  }

  return this._modules.isRegistered(path)
};

Store.prototype.hotUpdate = function hotUpdate (newOptions) {
  this._modules.update(newOptions);
  resetStore(this, true);
};

Store.prototype._withCommit = function _withCommit (fn) {
  var committing = this._committing;
  this._committing = true;
  fn();
  this._committing = committing;
};

Object.defineProperties( Store.prototype, prototypeAccessors$1 );

function genericSubscribe (fn, subs, options) {
  if (subs.indexOf(fn) < 0) {
    options && options.prepend
      ? subs.unshift(fn)
      : subs.push(fn);
  }
  return function () {
    var i = subs.indexOf(fn);
    if (i > -1) {
      subs.splice(i, 1);
    }
  }
}

function resetStore (store, hot) {
  store._actions = Object.create(null);
  store._mutations = Object.create(null);
  store._wrappedGetters = Object.create(null);
  store._modulesNamespaceMap = Object.create(null);
  var state = store.state;
  // init all modules
  installModule(store, state, [], store._modules.root, true);
  // reset vm
  resetStoreVM(store, state, hot);
}

function resetStoreVM (store, state, hot) {
  var oldVm = store._vm;

  // bind store public getters
  store.getters = {};
  // reset local getters cache
  store._makeLocalGettersCache = Object.create(null);
  var wrappedGetters = store._wrappedGetters;
  var computed = {};
  forEachValue(wrappedGetters, function (fn, key) {
    // use computed to leverage its lazy-caching mechanism
    // direct inline function use will lead to closure preserving oldVm.
    // using partial to return function with only arguments preserved in closure environment.
    computed[key] = partial(fn, store);
    Object.defineProperty(store.getters, key, {
      get: function () { return store._vm[key]; },
      enumerable: true // for local getters
    });
  });

  // use a Vue instance to store the state tree
  // suppress warnings just in case the user has added
  // some funky global mixins
  var silent = Vue.config.silent;
  Vue.config.silent = true;
  store._vm = new Vue({
    data: {
      $$state: state
    },
    computed: computed
  });
  Vue.config.silent = silent;

  // enable strict mode for new vm
  if (store.strict) {
    enableStrictMode(store);
  }

  if (oldVm) {
    if (hot) {
      // dispatch changes in all subscribed watchers
      // to force getter re-evaluation for hot reloading.
      store._withCommit(function () {
        oldVm._data.$$state = null;
      });
    }
    Vue.nextTick(function () { return oldVm.$destroy(); });
  }
}

function installModule (store, rootState, path, module, hot) {
  var isRoot = !path.length;
  var namespace = store._modules.getNamespace(path);

  // register in namespace map
  if (module.namespaced) {
    if (store._modulesNamespaceMap[namespace] && (process.env.NODE_ENV !== 'production')) {
      console.error(("[vuex] duplicate namespace " + namespace + " for the namespaced module " + (path.join('/'))));
    }
    store._modulesNamespaceMap[namespace] = module;
  }

  // set state
  if (!isRoot && !hot) {
    var parentState = getNestedState(rootState, path.slice(0, -1));
    var moduleName = path[path.length - 1];
    store._withCommit(function () {
      if ((process.env.NODE_ENV !== 'production')) {
        if (moduleName in parentState) {
          console.warn(
            ("[vuex] state field \"" + moduleName + "\" was overridden by a module with the same name at \"" + (path.join('.')) + "\"")
          );
        }
      }
      Vue.set(parentState, moduleName, module.state);
    });
  }

  var local = module.context = makeLocalContext(store, namespace, path);

  module.forEachMutation(function (mutation, key) {
    var namespacedType = namespace + key;
    registerMutation(store, namespacedType, mutation, local);
  });

  module.forEachAction(function (action, key) {
    var type = action.root ? key : namespace + key;
    var handler = action.handler || action;
    registerAction(store, type, handler, local);
  });

  module.forEachGetter(function (getter, key) {
    var namespacedType = namespace + key;
    registerGetter(store, namespacedType, getter, local);
  });

  module.forEachChild(function (child, key) {
    installModule(store, rootState, path.concat(key), child, hot);
  });
}

/**
 * make localized dispatch, commit, getters and state
 * if there is no namespace, just use root ones
 */
function makeLocalContext (store, namespace, path) {
  var noNamespace = namespace === '';

  var local = {
    dispatch: noNamespace ? store.dispatch : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ((process.env.NODE_ENV !== 'production') && !store._actions[type]) {
          console.error(("[vuex] unknown local action type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      return store.dispatch(type, payload)
    },

    commit: noNamespace ? store.commit : function (_type, _payload, _options) {
      var args = unifyObjectStyle(_type, _payload, _options);
      var payload = args.payload;
      var options = args.options;
      var type = args.type;

      if (!options || !options.root) {
        type = namespace + type;
        if ((process.env.NODE_ENV !== 'production') && !store._mutations[type]) {
          console.error(("[vuex] unknown local mutation type: " + (args.type) + ", global type: " + type));
          return
        }
      }

      store.commit(type, payload, options);
    }
  };

  // getters and state object must be gotten lazily
  // because they will be changed by vm update
  Object.defineProperties(local, {
    getters: {
      get: noNamespace
        ? function () { return store.getters; }
        : function () { return makeLocalGetters(store, namespace); }
    },
    state: {
      get: function () { return getNestedState(store.state, path); }
    }
  });

  return local
}

function makeLocalGetters (store, namespace) {
  if (!store._makeLocalGettersCache[namespace]) {
    var gettersProxy = {};
    var splitPos = namespace.length;
    Object.keys(store.getters).forEach(function (type) {
      // skip if the target getter is not match this namespace
      if (type.slice(0, splitPos) !== namespace) { return }

      // extract local getter type
      var localType = type.slice(splitPos);

      // Add a port to the getters proxy.
      // Define as getter property because
      // we do not want to evaluate the getters in this time.
      Object.defineProperty(gettersProxy, localType, {
        get: function () { return store.getters[type]; },
        enumerable: true
      });
    });
    store._makeLocalGettersCache[namespace] = gettersProxy;
  }

  return store._makeLocalGettersCache[namespace]
}

function registerMutation (store, type, handler, local) {
  var entry = store._mutations[type] || (store._mutations[type] = []);
  entry.push(function wrappedMutationHandler (payload) {
    handler.call(store, local.state, payload);
  });
}

function registerAction (store, type, handler, local) {
  var entry = store._actions[type] || (store._actions[type] = []);
  entry.push(function wrappedActionHandler (payload) {
    var res = handler.call(store, {
      dispatch: local.dispatch,
      commit: local.commit,
      getters: local.getters,
      state: local.state,
      rootGetters: store.getters,
      rootState: store.state
    }, payload);
    if (!isPromise(res)) {
      res = Promise.resolve(res);
    }
    if (store._devtoolHook) {
      return res.catch(function (err) {
        store._devtoolHook.emit('vuex:error', err);
        throw err
      })
    } else {
      return res
    }
  });
}

function registerGetter (store, type, rawGetter, local) {
  if (store._wrappedGetters[type]) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.error(("[vuex] duplicate getter key: " + type));
    }
    return
  }
  store._wrappedGetters[type] = function wrappedGetter (store) {
    return rawGetter(
      local.state, // local state
      local.getters, // local getters
      store.state, // root state
      store.getters // root getters
    )
  };
}

function enableStrictMode (store) {
  store._vm.$watch(function () { return this._data.$$state }, function () {
    if ((process.env.NODE_ENV !== 'production')) {
      assert(store._committing, "do not mutate vuex store state outside mutation handlers.");
    }
  }, { deep: true, sync: true });
}

function getNestedState (state, path) {
  return path.reduce(function (state, key) { return state[key]; }, state)
}

function unifyObjectStyle (type, payload, options) {
  if (isObject(type) && type.type) {
    options = payload;
    payload = type;
    type = type.type;
  }

  if ((process.env.NODE_ENV !== 'production')) {
    assert(typeof type === 'string', ("expects string as the type, but found " + (typeof type) + "."));
  }

  return { type: type, payload: payload, options: options }
}

function install (_Vue) {
  if (Vue && _Vue === Vue) {
    if ((process.env.NODE_ENV !== 'production')) {
      console.error(
        '[vuex] already installed. Vue.use(Vuex) should be called only once.'
      );
    }
    return
  }
  Vue = _Vue;
  applyMixin(Vue);
}

/**
 * Reduce the code which written in Vue.js for getting the state.
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} states # Object's item can be a function which accept state and getters for param, you can do something for state and getters in it.
 * @param {Object}
 */
var mapState = normalizeNamespace(function (namespace, states) {
  var res = {};
  if ((process.env.NODE_ENV !== 'production') && !isValidMap(states)) {
    console.error('[vuex] mapState: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(states).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedState () {
      var state = this.$store.state;
      var getters = this.$store.getters;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapState', namespace);
        if (!module) {
          return
        }
        state = module.context.state;
        getters = module.context.getters;
      }
      return typeof val === 'function'
        ? val.call(this, state, getters)
        : state[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for committing the mutation
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} mutations # Object's item can be a function which accept `commit` function as the first param, it can accept another params. You can commit mutation and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapMutations = normalizeNamespace(function (namespace, mutations) {
  var res = {};
  if ((process.env.NODE_ENV !== 'production') && !isValidMap(mutations)) {
    console.error('[vuex] mapMutations: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(mutations).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedMutation () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // Get the commit method from store
      var commit = this.$store.commit;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapMutations', namespace);
        if (!module) {
          return
        }
        commit = module.context.commit;
      }
      return typeof val === 'function'
        ? val.apply(this, [commit].concat(args))
        : commit.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for getting the getters
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} getters
 * @return {Object}
 */
var mapGetters = normalizeNamespace(function (namespace, getters) {
  var res = {};
  if ((process.env.NODE_ENV !== 'production') && !isValidMap(getters)) {
    console.error('[vuex] mapGetters: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(getters).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    // The namespace has been mutated by normalizeNamespace
    val = namespace + val;
    res[key] = function mappedGetter () {
      if (namespace && !getModuleByNamespace(this.$store, 'mapGetters', namespace)) {
        return
      }
      if ((process.env.NODE_ENV !== 'production') && !(val in this.$store.getters)) {
        console.error(("[vuex] unknown getter: " + val));
        return
      }
      return this.$store.getters[val]
    };
    // mark vuex getter for devtools
    res[key].vuex = true;
  });
  return res
});

/**
 * Reduce the code which written in Vue.js for dispatch the action
 * @param {String} [namespace] - Module's namespace
 * @param {Object|Array} actions # Object's item can be a function which accept `dispatch` function as the first param, it can accept anthor params. You can dispatch action and do any other things in this function. specially, You need to pass anthor params from the mapped function.
 * @return {Object}
 */
var mapActions = normalizeNamespace(function (namespace, actions) {
  var res = {};
  if ((process.env.NODE_ENV !== 'production') && !isValidMap(actions)) {
    console.error('[vuex] mapActions: mapper parameter must be either an Array or an Object');
  }
  normalizeMap(actions).forEach(function (ref) {
    var key = ref.key;
    var val = ref.val;

    res[key] = function mappedAction () {
      var args = [], len = arguments.length;
      while ( len-- ) args[ len ] = arguments[ len ];

      // get dispatch function from store
      var dispatch = this.$store.dispatch;
      if (namespace) {
        var module = getModuleByNamespace(this.$store, 'mapActions', namespace);
        if (!module) {
          return
        }
        dispatch = module.context.dispatch;
      }
      return typeof val === 'function'
        ? val.apply(this, [dispatch].concat(args))
        : dispatch.apply(this.$store, [val].concat(args))
    };
  });
  return res
});

/**
 * Rebinding namespace param for mapXXX function in special scoped, and return them by simple object
 * @param {String} namespace
 * @return {Object}
 */
var createNamespacedHelpers = function (namespace) { return ({
  mapState: mapState.bind(null, namespace),
  mapGetters: mapGetters.bind(null, namespace),
  mapMutations: mapMutations.bind(null, namespace),
  mapActions: mapActions.bind(null, namespace)
}); };

/**
 * Normalize the map
 * normalizeMap([1, 2, 3]) => [ { key: 1, val: 1 }, { key: 2, val: 2 }, { key: 3, val: 3 } ]
 * normalizeMap({a: 1, b: 2, c: 3}) => [ { key: 'a', val: 1 }, { key: 'b', val: 2 }, { key: 'c', val: 3 } ]
 * @param {Array|Object} map
 * @return {Object}
 */
function normalizeMap (map) {
  if (!isValidMap(map)) {
    return []
  }
  return Array.isArray(map)
    ? map.map(function (key) { return ({ key: key, val: key }); })
    : Object.keys(map).map(function (key) { return ({ key: key, val: map[key] }); })
}

/**
 * Validate whether given map is valid or not
 * @param {*} map
 * @return {Boolean}
 */
function isValidMap (map) {
  return Array.isArray(map) || isObject(map)
}

/**
 * Return a function expect two param contains namespace and map. it will normalize the namespace and then the param's function will handle the new namespace and the map.
 * @param {Function} fn
 * @return {Function}
 */
function normalizeNamespace (fn) {
  return function (namespace, map) {
    if (typeof namespace !== 'string') {
      map = namespace;
      namespace = '';
    } else if (namespace.charAt(namespace.length - 1) !== '/') {
      namespace += '/';
    }
    return fn(namespace, map)
  }
}

/**
 * Search a special module from store by namespace. if module not exist, print error message.
 * @param {Object} store
 * @param {String} helper
 * @param {String} namespace
 * @return {Object}
 */
function getModuleByNamespace (store, helper, namespace) {
  var module = store._modulesNamespaceMap[namespace];
  if ((process.env.NODE_ENV !== 'production') && !module) {
    console.error(("[vuex] module namespace not found in " + helper + "(): " + namespace));
  }
  return module
}

// Credits: borrowed code from fcomb/redux-logger

function createLogger (ref) {
  if ( ref === void 0 ) ref = {};
  var collapsed = ref.collapsed; if ( collapsed === void 0 ) collapsed = true;
  var filter = ref.filter; if ( filter === void 0 ) filter = function (mutation, stateBefore, stateAfter) { return true; };
  var transformer = ref.transformer; if ( transformer === void 0 ) transformer = function (state) { return state; };
  var mutationTransformer = ref.mutationTransformer; if ( mutationTransformer === void 0 ) mutationTransformer = function (mut) { return mut; };
  var actionFilter = ref.actionFilter; if ( actionFilter === void 0 ) actionFilter = function (action, state) { return true; };
  var actionTransformer = ref.actionTransformer; if ( actionTransformer === void 0 ) actionTransformer = function (act) { return act; };
  var logMutations = ref.logMutations; if ( logMutations === void 0 ) logMutations = true;
  var logActions = ref.logActions; if ( logActions === void 0 ) logActions = true;
  var logger = ref.logger; if ( logger === void 0 ) logger = console;

  return function (store) {
    var prevState = deepCopy(store.state);

    if (typeof logger === 'undefined') {
      return
    }

    if (logMutations) {
      store.subscribe(function (mutation, state) {
        var nextState = deepCopy(state);

        if (filter(mutation, prevState, nextState)) {
          var formattedTime = getFormattedTime();
          var formattedMutation = mutationTransformer(mutation);
          var message = "mutation " + (mutation.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c prev state', 'color: #9E9E9E; font-weight: bold', transformer(prevState));
          logger.log('%c mutation', 'color: #03A9F4; font-weight: bold', formattedMutation);
          logger.log('%c next state', 'color: #4CAF50; font-weight: bold', transformer(nextState));
          endMessage(logger);
        }

        prevState = nextState;
      });
    }

    if (logActions) {
      store.subscribeAction(function (action, state) {
        if (actionFilter(action, state)) {
          var formattedTime = getFormattedTime();
          var formattedAction = actionTransformer(action);
          var message = "action " + (action.type) + formattedTime;

          startMessage(logger, message, collapsed);
          logger.log('%c action', 'color: #03A9F4; font-weight: bold', formattedAction);
          endMessage(logger);
        }
      });
    }
  }
}

function startMessage (logger, message, collapsed) {
  var startMessage = collapsed
    ? logger.groupCollapsed
    : logger.group;

  // render
  try {
    startMessage.call(logger, message);
  } catch (e) {
    logger.log(message);
  }
}

function endMessage (logger) {
  try {
    logger.groupEnd();
  } catch (e) {
    logger.log('—— log end ——');
  }
}

function getFormattedTime () {
  var time = new Date();
  return (" @ " + (pad(time.getHours(), 2)) + ":" + (pad(time.getMinutes(), 2)) + ":" + (pad(time.getSeconds(), 2)) + "." + (pad(time.getMilliseconds(), 3)))
}

function repeat (str, times) {
  return (new Array(times + 1)).join(str)
}

function pad (num, maxLength) {
  return repeat('0', maxLength - num.toString().length) + num
}

var index_cjs = {
  Store: Store,
  install: install,
  version: '3.6.2',
  mapState: mapState,
  mapMutations: mapMutations,
  mapGetters: mapGetters,
  mapActions: mapActions,
  createNamespacedHelpers: createNamespacedHelpers,
  createLogger: createLogger
};

module.exports = index_cjs;

}).call(this)}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"_process":216}],265:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const advent = require('./advent');
const greenfriday = require('./greenfriday');
const giftsetfastlane = require('./giftsetfastlane');
const gtm = require('./modules/google').tagManager;
const easter = require('./easter/easter');

const accordionWrapper = '.js-pdp-accordion-wrapper';

function handleAccordion() {
    const $heading = $('.js-acc-head');
    const $headingInner = $('.js-acc-head-inner');
    const $faqAccordionHead = $('.js-acc-head-button');

    $heading.on('click', function (e, shouldSkipDataLayerPush) {
        accordionToggle($heading, this, shouldSkipDataLayerPush);
    });

    $headingInner.on('click', function () {
        accordionToggle($headingInner, this);
    });

    $('.js-faq-button').on('click', function () {
        advent.pushAdventDataLayerDataForFAQBlock('show more');
    });

    $faqAccordionHead.on('click', faqAccordionToggle);

    if ($faqAccordionHead.length) {
        const $firstFaqItem = $('.js-faq-acc-head').parent().first();
        $firstFaqItem.find('.js-acc-head-button').trigger('click', true);
    }
}


function accordionToggle($selector, context, shouldSkipDataLayerPush) {
    const $textHolderParent = $(context).closest('.text-holder');
    const $gridHolderParent = $(context).closest('.grid-wrap');

    if (!$(context).hasClass('open')) {
        if (isSmallView()) {
            $selector.removeClass('open').next().stop().slideUp().attr('aria-hidden', 'true');
            $selector.parent().attr('aria-haspopup', 'true');
        }
        $(context).addClass('open').next().stop().slideDown('slow', function() {
            if ($textHolderParent.hasClass('js-equal-height')) {
                $gridHolderParent.animate({height: $gridHolderParent.height() + $(context).siblings()[0].offsetHeight});
            }
        }).removeAttr('aria-hidden');

        $(context).parent().removeAttr('aria-haspopup');
        $(context).triggerHandler('opened');
        if (!shouldSkipDataLayerPush) {
            gtm.pushPDPTabsEvent($(context), accordionWrapper);
        }
    } else {
        if ($textHolderParent.hasClass('js-equal-height')) {
            $gridHolderParent.animate({height: $gridHolderParent.height() - $(context).siblings()[0].offsetHeight});
        }

        $(context).removeClass('open').next().stop().slideUp().attr('aria-hidden', 'true');
        $(context).parent().attr('aria-haspopup', 'true');
    }
}

const faqAccordionToggle = (el, skipPushEvent) => {
    const $this = $(el.target);
    const faqHeadClass = '.js-faq-acc-head';
    const faqContentClass = '.js-faq-acc-content';
    const $parent = $this.parent(faqHeadClass);
    const $siblings = $parent.parent().siblings();
    const isExpanded = $parent.hasClass('open-acc');

    if (!isExpanded) {
        $siblings.find(faqHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(faqContentClass).stop().slideDown().attr('aria-hidden', 'false');
        const eventLabel = $parent.data('event-label');
        if (eventLabel && !skipPushEvent) {
            advent.pushAdventDataLayerDataForFAQBlock(eventLabel);
            greenfriday.pushDataLayerDataForFAQBlock(eventLabel);
            giftsetfastlane.pushDataLayerEventForFAQBlock(eventLabel);
            easter.pushDataLayerDataForFAQBlock(eventLabel);
        }
    } else {
        $parent.removeClass('open-acc').attr('aria-expanded', 'false');
        $parent.siblings(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
    }
};

function initializeEvents() {
    handleAccordion();
}

const customAccordion = {
    init: function() {
        initializeEvents();
    }
};

module.exports = customAccordion;

},{"./advent":269,"./easter/easter":424,"./giftsetfastlane":432,"./greenfriday":435,"./modules/google":453,"./modules/helpers/isSmallView":469}],266:[function(require,module,exports){
'use strict';

const queue = [];
let queueTimeout;
let queueProgress = false;

/**
 * Adds a callback together with a duration to the list. Once the duration is
 * expired the callback is removed from the list. Currently this only supports
 * 2 callbacks at once. If more are added they will overwrite the last
 * callback. The reason for this is that you do not want to wait for 10 toaster
 * messages to show and hide.
 *
 * @param {function} callback - The callback to run
 * @param {number} duration - The duration of the callback in milliseconds
 */
function addToQueue(callback, duration) {
    if (typeof callback === 'function') {
        const idx = getNextIndex();

        queue[idx] = {
            callback: callback,
            duration: duration || 0
        };

        runQueue();
    }
}

/**
 * Runs the first callback from the queue and sets a timout for the next one.
 */
function runQueue() {
    if (!queueProgress) {
        const item = queue[0];
        item.callback();

        queueProgress = true;
        queueTimeout = setTimeout(processNextItem, item.duration);
    }
}

/**
 * Prepares the queue for the next callback if present.
 */
function processNextItem() {
    queue.shift();
    queueProgress = false;
    window.clearTimeout(queueTimeout);

    if (queue.length) {
        runQueue();
    }
}

/**
 * Gets the next possible index of the queue to add a callback to. This can be
 * extended later to handle more then 2 callbacks (see comment addToQueueu
 * method).
 *
 * @returns {number} The next index
 */
function getNextIndex() {
    return queue.length > 0 ? 1 : 0;
}

const actionQueue = {
    addToQueue: addToQueue
};

module.exports = actionQueue;

},{}],267:[function(require,module,exports){
'use strict';

const scrollingText = document.querySelectorAll('.js-moving-title');

const setPosition = (step) => {
    scrollingText.forEach((text) => {
        const position = text.dataset.position;
        text.style.transform = `translateX(${position}%)`;
        text.dataset.position = position - step;

        if (position < -200) {
            text.dataset.position = 200;
        }
    });
};

const movingTitle = () => {
    setPosition(0.05);

    requestAnimationFrame(movingTitle);
};

function initializeEvents() {
    window.requestAnimationFrame(movingTitle);
    window.addEventListener('scroll', () => {
        setPosition(0.15);
    });
}

const adventMovingTitle = {
    init: function() {
        initializeEvents();
        movingTitle();
    }
};

module.exports = adventMovingTitle;

},{}],268:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const adventSplitSection = document.querySelectorAll('.js-advent-split');
const shouldInit = adventSplitSection.length > 0;

function adventTextSplit() {
    const circleAdvent = document.querySelector('.circle-advent');
    const paragraph = document.querySelector('.advent-split-text');
    const adventSplitSectionLetters = document.querySelectorAll('.advent-split-text');
    const fullText = paragraph.textContent;
    const wordsNum = fullText.length;
    const text = paragraph.textContent.split('');
    paragraph.innerText = '';

    for (let i = 0; i < text.length; i++) {
        const letter = `<span>${text[i]}</span>`;
        paragraph.innerHTML += letter;
    }

    const scrollObserver = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            if (block.isIntersecting && block.intersectionRatio >= 0.1 && block.boundingClientRect.y > 0) {
              const blockPerc = (block.target.dataset.perc) ? block.target.dataset.perc : 0;
              const perc = Math.round(block.intersectionRatio * 100);
              const perc3 = Math.round(block.intersectionRatio * 10) / 10;
              block.target.dataset.perc = Math.max(blockPerc, perc);
                paragraph.childNodes.forEach((letter, i) => {
                    if (i < wordsNum * perc3 && wordsNum * perc3 <= wordsNum) {
                        letter.classList.add('js-advent-letter');
                        letter.classList.add('advent-text-white');
                    } else {
                        letter.classList.remove('js-advent-letter');
                        letter.classList.remove('advent-text-white');
                    }
                });
            }
        }
    }, {
        threshold: [0, 0.01, 0.02, 0.03, 0.04, 0.05, 0.06, 0.07, 0.08, 0.09, 0.10, 0.11, 0.12, 0.13, 0.14, 0.15, 0.16, 0.17, 0.18, 0.19, 0.20, 0.21, 0.22, 0.23, 0.24, 0.25, 0.26, 0.27, 0.28, 0.29, 0.30, 0.31, 0.32, 0.33, 0.34, 0.35, 0.36, 0.37, 0.38, 0.39, 0.40, 0.41, 0.42, 0.43, 0.44, 0.45, 0.46, 0.47, 0.48, 0.49, 0.50, 0.51, 0.52, 0.53, 0.54, 0.55, 0.56, 0.57, 0.58, 0.59, 0.60, 0.61, 0.62, 0.63, 0.64, 0.65, 0.66, 0.67, 0.68, 0.69, 0.70, 0.71, 0.72, 0.73, 0.74, 0.75, 0.76, 0.77, 0.78, 0.79, 0.80, 0.81, 0.82, 0.83, 0.84, 0.85, 0.86, 0.87, 0.88, 0.89, 0.90, 0.91, 0.92, 0.93, 0.94, 0.95, 0.96, 0.97, 0.98, 0.99, 1]
    });

    adventSplitSectionLetters.forEach((el) => {
      scrollObserver.observe(el);
    });

    function elementsOverlap(elem1, elem2) {
        const dimensionsFirst = elem1.getBoundingClientRect();
        const dimensionsSecond = elem2.getBoundingClientRect();

        return !(
            dimensionsFirst.top > dimensionsSecond.bottom ||
            dimensionsFirst.right < dimensionsSecond.left ||
            dimensionsFirst.bottom < dimensionsSecond.top ||
            dimensionsFirst.left > dimensionsSecond.right
        );
    }

    if (!isSmallView()) {
        let mouseX = 0,
        mouseY = 0,
        circleX = 0,
        circleY = 0;

        $('.js-advent-split').on('mousemove', function(e) {
            mouseX = e.pageX;
            mouseY = e.pageY;

            circleX += ((mouseX - circleX) / 6);
            circleY += ((mouseY - circleY) / 6);

            const scrollLeft = (window.pageXOffset !== undefined) ? window.pageXOffset : (document.documentElement || document.body.parentNode || document.body).scrollLeft;
            const scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;

            $('.circle-advent').css({
                left: circleX - scrollLeft - 250 + 'px',
                top: circleY - scrollTop - 250 + 'px'
            });

            paragraph.childNodes.forEach((letter) => {
                if (elementsOverlap(letter, circleAdvent) && letter.classList.contains('js-advent-letter')) {
                    letter.classList.add('advent-golden');
                } else {
                    letter.classList.remove('advent-golden');
                }
            });
        });
    }
}

function initializeEvents() {
    adventTextSplit();
}

const adventSplit = {
    init: function() {
        if (shouldInit) {
            initializeEvents();
        }
    }
};

module.exports = adventSplit;

},{"./modules/helpers/isSmallView":469}],269:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const scrollHelper = require('./modules/helpers/scroll');
const gtm = require('./modules/google').tagManager;
const {enableScroll} = require('./modules/helpers/scroll');
const {disableScroll} = require('./modules/helpers/scroll');
const getUpdatedURLWithParams = require('./modules/util/getUpdatedURLWithParams');

const QRcode = require('qrcode');
const isTouchDevice = require('./modules/helpers/isTouchDevice');

const $adventBlock = $('.js-advent-block');
const adventOpenBtn = '.js-advent-pulsating-btn';
const adventCloseBtn = '.js-advent-close';

function openAdventOverlay() {
    const $parentAdvent = $(this).closest('.js-advent-block');
    const $adventImageCol = $(this).closest('.js-advent-block').find('.js-advent-col-image');

    if (isSmallView()) {
        $parentAdvent.find('.js-advent-overlay').show().animate({
            left: 0
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: '1',
                marginLeft: 0
            }, 400);
        }).removeAttr('aria-hidden');
        $parentAdvent.removeAttr('aria-haspopup');

        // lock body scroll
        scrollHelper.disableScroll();
    } else {
        if (!$parentAdvent.hasClass('advent-content-block-reverted')) {
            $adventImageCol.find('.js-image-holder').animate({
                marginLeft: 200
            });
        } else {
            $adventImageCol.find('.js-image-holder').animate({
                marginRight: 200
            });
        }

        $parentAdvent.find('.js-advent-overlay').show().animate({
            width: '100%'
        }, 800, function () {
            if (!$parentAdvent.find('.js-advent-nav').hasClass('hidden')){
                setTimeout(function () {
                    $parentAdvent.find('.js-advent-nav').fadeIn();
                }, 600);
            }
        }).removeAttr('aria-hidden');
        setTimeout(function () {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: '1',
                marginLeft: 0
            }, 600);
        }, 200);
        $parentAdvent.removeAttr('aria-haspopup');
    }

    // set correct position of slider (center slide)
    // Keep at the bottom of the function (after animations)
    //   Otherwise it doesn't always work
    const $adventSlider = $parentAdvent.find('.js-slider-advent');
    const $sliderTrack = $adventSlider.find('.drag-list-body');
    const sliderTrackWidth = $sliderTrack.width();
    const centerScroll = (sliderTrackWidth / 2) - ($(window).width() / 2);

    if (isSmallView()) {
        $adventSlider.animate({scrollLeft: centerScroll}, 500, 'easeOutQuad');
    } else {
        $adventSlider.find('.simplebar-content-wrapper').animate({scrollLeft: centerScroll}, 500, 'easeOutQuad');
    }
}

function closeAdventOverlay() {
    const $parentAdvent = $(this).closest('.js-advent-block');
    const $adventImageCol = $(this).closest('.js-advent-block').find('.js-advent-col-image');

    if (isSmallView()) {
        $parentAdvent.find('.js-advent-overlay-inner').animate({
            opacity: 0,
            marginLeft: '-50px'
        }, 600);
        $parentAdvent.find('.js-advent-overlay').animate({
            left: '-=100%'
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay').fadeOut();
        }).attr('aria-hidden', 'true');
        $parentAdvent.attr('aria-haspopup', 'true');

        // unlock body scroll
        scrollHelper.enableScroll();
    } else {
        if (!$parentAdvent.find('.js-advent-nav').hasClass('hidden')){
            $parentAdvent.find('.js-advent-nav').fadeOut();
        }

        if (!$parentAdvent.hasClass('advent-content-block-reverted')) {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: 0,
                marginLeft: '-100px'
            }, 600);

            $adventImageCol.find('.js-image-holder').animate({
                marginLeft: 0
            });
        } else {
            $parentAdvent.find('.js-advent-overlay-inner').animate({
                opacity: 0,
                marginLeft: '100px'
            }, 600);

            $adventImageCol.find('.js-image-holder').animate({
                marginRight: 0
            });
        }
        $parentAdvent.find('.js-advent-overlay').animate({
            width: '-=50%'
        }, 800, function () {
            $parentAdvent.find('.js-advent-overlay').fadeOut();
        }).attr('aria-hidden', 'true');
        $parentAdvent.attr('aria-haspopup', 'true');
    }
}

function responsiveImageSrc() {
    const $imgSwitch = $('.js-responsive-image');

    if ($imgSwitch.length) {
        $imgSwitch.each(function () {
            const $img = $(this);
            if (isSmallView()) {
                if ($img.attr('data-mobile-image') !== '') {
                    $img.attr('src', $img.data('mobile-image'));
                } else {
                    $img.attr('src', $img.data('desktop-image'));
                }
            } else {
                if ($img.data('desktop-image') !== '') {
                    $img.attr('src', $img.data('desktop-image'));
                }
            }
        });
    }
}

function zoomedInWindow() {
    if (window.outerWidth > 1024) {
        $('body').addClass('zoomed-in');
    }
}

/**
 * @description Initialize block
 */
function initBlock() {
    responsiveImageSrc();
}

function pushProductsToDataLayer() {
    const PUSHED_CLASS = 'js-data-layer-product-pushed';

    const $productTiles = $('.js-advent-block');
    const $productTilesToPush = $productTiles.not('.' + PUSHED_CLASS);

    if ($productTilesToPush.length === 0) {
        return;
    }

    $productTilesToPush.each(function(_, tile) {
        const datalayerProduct = $('.js-advent-datalayer-product', tile);

        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());

            if (productData) {
                gtm.pushProductTileView(productData);
            }
        }

        $(tile).addClass(PUSHED_CLASS);
    });
}

function pushProductToDataLayer(productTile) {
    const datalayerProduct = $('.js-advent-datalayer-product', productTile);

    if (datalayerProduct.length > 0) {
        const $productTiles = $('.js-advent-block');
        const index = $productTiles.index(productTile);

        const productData = JSON.parse(datalayerProduct.val());
        productData.position = index + 1;

        gtm.pushProductTileClick(productData);
    }
}

/**
 * @description Initialize event handlers for the packshot
 */
function initializeEvents() {
    $(document).on('click', adventOpenBtn, openAdventOverlay);

    $(document).on('click', adventCloseBtn, closeAdventOverlay);

    $('.js-view-full-details-link').click(function() {
        const $productTile = $(this).parents('.js-advent-block');
        pushProductToDataLayer($productTile);
    });

    $(window).on('resize', function () {
        zoomedInWindow();
    });

    $('.js-all-gifts-close-btn').on('click', function(e) {
        pushCloseButtonEvent();
        e.stopPropagation();
        e.preventDefault();
        enableScroll();

        $(this).addClass('btn-back-flip');

        setTimeout(() => {
            const $product = $(this).closest('.js-advent-reveal-product')[0];
            $product.classList.remove('advent-product-reveal-open');
            $(this).removeClass('btn-back-flip');
        }, 500);

        $('.advent-product-reveal').each(function(){
            $(this).removeClass('advent-toggle-animation');
        });
    });

    $(document).off('click.advent', '.js-advent-ar-analytics').on('click.advent', '.js-advent-ar-analytics',(e) => {
        const $current = $(e.target);
        const popupData = $current.data('popup-data');
        if (!popupData) {
            return;
        }

        const $modelViewers = $('.js-egg-model-viewer');
        let typeClass = $current[0].classList[2];
        let type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : typeClass == 'js-advent-btn-premium' ? 'premium' : 'js-advent-ar-button';

        if (type == 'js-advent-ar-button') {
            typeClass = $current[0].classList[3];

            type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
        }

        if (!isTouchDevice() || !$modelViewers || !$modelViewers.length || !$modelViewers[0].canActivateAR) {
            showArPopUp(type, popupData);
        }
    });

    $(document).on('click', '.js-tab-item', pushDetailTabsEvent);

    $('.js-partial-flip').on('click.advent', pushPngSequenceEvent);

    $('.js-btn-flip-full').on('click.advent', pushPngSequenceEventFullReveal);

    $('.js-advent-banner-btn').on('click.advent', pushShopCalendarsEvent);

    $(document).off('click.advent', '.js-advent-calendar-image').on('click.advent', '.js-advent-calendar-image', (e) => {
        const element = $(e.target).closest('.advent-comparison-item');
        pushProductClickEvent('image', element);
    });

    $(document).off('click.advent', '.js-advent-calendar-text').on('click.advent', '.js-advent-calendar-text', (e) => {
        const element = $(e.target).closest('.advent-comparison-item');
        pushProductClickEvent('text', element);
    });

    $('.js-check-btn').on('click.advent', pushCheckAvailabilityEvent);

    $('.js-advent-menu-item').on('click.advent', (e) => {
        pushClickedTabsEvent(e.target);
    });

    $(document).off('click.advent', '.js-header-logo').on('click.advent', '.js-header-logo', () => { pushPDPClick('rituals advent'); });
    $(document).off('click.advent', '.js-nav-to-main').on('click.advent', '.js-nav-to-main', () => { pushPDPClick('visit rituals.com'); });
    $(document).off('click.advent', '.js-pdp-back').on('click.advent', '.js-pdp-back', () => { pushPDPClick('back'); });
    $(document).off('click.advent', '.js-advent-link').on('click.advent', '.js-advent-link', () => { pushPDPClick('whatsapp / messenger'); });
    $(document).off('click.advent', '.advent-swatch-click').on('click.advent', '.advent-swatch-click', () => {
        const current = $(this).attributes.href.nodeValue;
        const target = current.includes('2d') ? '2D' : current.includes('3d') ? '3D' : 'premium';
        pushPDPClick(target);
    });
}

function getAdventDataLayerData(wrapperElement) {
    const $adventDataLayer = wrapperElement && wrapperElement.length ? $('.js-advent-data-layer', wrapperElement) : $('.js-advent-data-layer');

    if (!$adventDataLayer || !$adventDataLayer.length) {
        return null;
    }

    const adventDataLayerObject = $adventDataLayer.data('data-layer');
    if (!adventDataLayerObject) {
        return null;
    }

    return JSON.parse(JSON.stringify(adventDataLayerObject));
}

function showArPopUp(type, data){
    const arView = {
        show: (data, QRcodeURL, type) => {
            pushExperienceBtnEvent(type);
            window.eventBus.$emit('shouldOpenModal', {
                resources: {
                    heading: data.header,
                    description: data.description
                },
                closeElement: {
                    eventName: 'onCloseElementClick',
                    shouldCloseModal: true
                },
                ctaHolder: {},
                easterModal: true,
                icon: data.icon,
                QRcodeURL: QRcodeURL
            });
        }
    };
    QRcode.toDataURL(getUpdatedURLWithParams({triggerARMode: true, skipAnimation: true}, ['skipAnimation'], true), {width: 180})
        .then((QRcodeURL) => {
            arView.show(data, QRcodeURL, type);
        });
    return;
}

function pushAdventDataLayerDataWithActiveProductImageSlide(eventAction) {
    const adventDataLayerData = getAdventDataLayerDataWithActiveProductImageSlide();
    if (!adventDataLayerData) {
        return;
    }

    if (eventAction) {
        adventDataLayerData['event_action'] = eventAction;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function getAdventDataLayerDataWithActiveProductImageSlide() {
    const adventDataLayerData = getAdventDataLayerData();
    if (!adventDataLayerData) {
        return null;
    }

    const $pdpImages = $('.js-images-wrapper');
    if (!$pdpImages || !$pdpImages.length) {
        return null;
    }

    const $pdpImagesSlider = $('.js-pdp-images-slider', $pdpImages);
    if (!$pdpImagesSlider || !$pdpImagesSlider.length) {
        return null;
    }

    const $activeSlide = $('.slick-active', $pdpImagesSlider);
    if (!$activeSlide || !$activeSlide.length) {
        adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide1';
        return adventDataLayerData;
    }

    adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide' + ($activeSlide.data('slick-index') + 1);

    return adventDataLayerData;
}

function pushAdventDataLayerDataForProductExperienceBlock(wrapperElement, eventAction, eventLabel, eventCategory) {
    const adventDataLayerData = getAdventDataLayerData(wrapperElement);
    if (!adventDataLayerData) {
        return null;
    }

    if (eventAction) {
        adventDataLayerData['event_action'] = eventAction;
    }

    if (eventCategory) {
        adventDataLayerData['event_category'] = eventCategory;
    }

    if (eventLabel) {
        adventDataLayerData['event_label'] = adventDataLayerData['event_label'] + ' - slide' + eventLabel;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function pushAdventDataLayerDataForFAQBlock(eventLabel) {
    const adventDataLayerData = getAdventDataLayerData();
    if (!adventDataLayerData) {
        pushFAQBtnEvent(eventLabel);
        return;
    }

    adventDataLayerData['event_category'] = 'faq';
    adventDataLayerData['event_action'] = 'faq click';

    if (eventLabel) {
        adventDataLayerData['event_label'] = eventLabel;
    }

    gtm.pushDataLayerEvent(adventDataLayerData);
}

function changeCalendarOrder() {
    $('.js-advent-order-0').appendTo($('.js-comparison-block'));
    $('.js-advent-order-1').appendTo($('.js-comparison-block'));
    $('.js-advent-order-2').appendTo($('.js-comparison-block'));
}

function adventAnimation() {
    const adventBlock = document.querySelectorAll('.advent-block-snap');
    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('advent-show');
                }
            });
        },
        {
            rootMargin: '-10px'
        }
    );

    adventBlock.forEach((block) => {
        observer.observe(block);
    });
}

function addShimmerToCalendar() {
    $('.advent-comparison-subhead').each(function() {
        if ($(this).closest('.advent-comparison-item').hasClass('advent-premium-item')) {
            $(this).addClass('advent-shimmer-text');
        }
    });
}

function showFullSliderMobile() {
    if ($('.js-christmas-tree-mobile').length > 0) {
        $('.js-btn-flip-full').on('click', function() {
            disableScroll();
            $('.advent-open-product-full').addClass('advent-product-reveal-open');
        });
    }
}

function pushExperienceBtnEvent(type) {
    gtm.pushDataLayerEvent({
        event: 'advent',
        click_target: 'experience it with AR', /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushGiftWrappingBtnEvent() {
    $(document).off('click.advent', '.gift-wrap-button').on('click.advent', '.gift-wrap-button',() => {
        gtm.pushDataLayerEvent({
            event: 'advent',
            interaction: 'video interection',
            click_target: 'watch video' /* eslint-disable-line camelcase */
        });
    });
}


const updateARbuttons = (src, iosSrc, description) => {
    if (!src || !iosSrc || !description) {
        return;
    }
    const $element = $('.js-advent-ar-button');
    if (!$element || !$element.length) {
        return;
    }
    const popupData = $element.data('popup-data');
    if (!popupData) {
        return;
    }
    popupData.src = src;
    popupData.iosSrc = iosSrc;
    popupData.description = description;

    $element.attr('data-popup-data', JSON.stringify(popupData));
};

const updateARmodel = (src, iosSrc) => {
    if (!src || !iosSrc) {
        return;
    }
    const $element = $('.js-egg-model-viewer');
    if (!$element || !$element.length) {
        return;
    }

    $element.attr('src', src);
    $element.attr('ios-src', iosSrc);
};

function adventNavigation() {
    const sections = document.querySelectorAll('.js-advent-nav-section');
    const navLi = document.querySelectorAll('.js-advent-dots');
    const navMenu = document.querySelectorAll('.js-advent-menu-item');
    const navMenuItems = document.querySelector('.js-advent-menu-items');
    const scrollEl = document.querySelector('.js-menu-list-advent');
    const shouldScrollInPlace = navMenuItems ? navMenuItems.getBoundingClientRect().width > scrollEl.getBoundingClientRect().width : false;
    const shouldObserve = sections.length != 0 && navMenu.length != 0 && navLi.length != 0;

    let previous = '';
    let current = '';
    let currentButton = null;

    if (shouldObserve) {
        const sectionScrollObserver = new IntersectionObserver((navSections) => {
            for (const navSection of navSections) {
                if (navSection.isIntersecting) {
                    current = navSection.target.dataset.adventsection;

                    if (previous != current) {
                        // eslint-disable-next-line no-loop-func
                        navLi.forEach((li) => {
                            li.classList.remove('advent-navigation-dot-filled');
                            if (li.classList.contains(current)) {
                                currentButton = li;
                                li.classList.add('advent-navigation-dot-filled');
                            }
                        });

                        // eslint-disable-next-line no-loop-func
                        navMenu.forEach((li) => {
                            li.classList.remove('advent-current-section');
                            if (li.classList.contains(current)) {
                                li.classList.add('advent-current-section');
                                if (shouldScrollInPlace) {
                                    scrollNavItemIntoView(li, scrollEl);
                                }
                            }
                        });

                        pushScrollBtnEvent(currentButton);
                    }

                    previous = current;
                }
            }
        }, {
            threshold: 0.03
        });

        sections.forEach((el) => {
            sectionScrollObserver.observe(el);
        });

        if (navMenuItems) {
            if (navMenuItems.getBoundingClientRect().width < window.innerWidth) {
                navMenuItems.classList.add('full-width-menu');
            } else {
                navMenuItems.classList.remove('full-width-menu');
            }
        }
    }
}

function scrollNavItemIntoView(el, scroller) {
    const x = el.getBoundingClientRect().x;
    const offset = isSmallView() ? 40 : 40;
    const left = scroller.scrollLeft + (x - offset);

    scroller.scroll({
        left: left,
        behavior: 'smooth'
    });
}

function feedbackBtnPosition() {
    $(window).on('load', function() {
        setTimeout(checkBtn, 500);
    });

    function checkBtn() {
        if ($('.usabilla_live_button_container').length) {
            $('.usabilla_live_button_container').addClass('usabilla-btn-position');
        }
    }
}

function updatingFlyoutOutOfStock() {
    $(window).on('load', function() {
        setTimeout(() => {
            $('.js-generic-flyout').addClass('advent-out-of-stock');
        }, 500);
    });
}

function onOffSwatches() {
    const swatches = document.querySelectorAll('.advent-swatch-item ');
    const currentSwatch = document.querySelector('.advent-swatch-item.advent-shimmer-frame');
    if (!swatches || !currentSwatch || !swatches.length || !currentSwatch.length){
        return;
    }

    currentSwatch.querySelector('video').muted = true;
    currentSwatch.querySelector('video').play();

    if (!isSmallView()) {
        swatches.forEach((swatch) => {
            swatch.addEventListener('mouseover', () => {
                currentSwatch.querySelector('video').pause();
                swatch.querySelector('video').muted = true;
                swatch.querySelector('video').play();
            });

            swatch.addEventListener('mouseout', () => {
                swatch.querySelector('video').pause();
                currentSwatch.querySelector('video').play();
            });
        });
    }
}

function pushDetailTabsEvent() {
    const target = $(this)[0].attributes['data-tab-label'].value;
    const selection = $(this)[0].attributes['data-type'].value;
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'change tabs',
        click_target: target, /* eslint-disable-line camelcase */
        selection: selection
    });
}

function pushPngSequenceEvent() {
    const days = $(this)[0].attributes['data-days'].value;
    const typeClass = $(this)[0].attributes['data-type'].value;
    const type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: days,
        click_target: 'view this gift', /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushPngSequenceEventFullReveal() {
    const typeClass = $(this)[0].attributes['data-type'].value;
    const type = typeClass == 'js-advent-btn-2d' ? '2D' : typeClass == 'js-advent-btn-3d' ? '3D' : 'premium';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'all products',
        click_target: 'view this gift', /* eslint-disable-line camelcase */
        selection: type

    });
}

function pushShopCalendarsEvent() {
    const current = document.querySelector('.js-advent-banner-btn');
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'button click',
        click_target: current.innerHTML /* eslint-disable-line camelcase */
    });
}

function pushProductClickEvent(clickedItem, element) {
    const product = {
        id: element[0].attributes[1].value,
        name: element[0].attributes[2].value,
        price: element[0].attributes[3].value
    };

    let page = 'landing page';

    const videoDiv = document.body.querySelector('.scrollmagic-pin-spacer');
    if (videoDiv){
        page = videoDiv.children[0].className.includes('js-video-holder') ? 'landing page' : 'PDP';
    }

    const item = clickedItem == 'image' ? clickedItem : product.name.includes('2D') ? '2D' : product.name.includes('3D') ? '3D' : 'premium';
    gtm.pushProductClickEvent(item, product, 'advent', page);
}

function pushCheckAvailabilityEvent() {
    const current = document.querySelector('.js-the-ritual-of-title').nextSibling.data;
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'store click',
        click_target: 'checked instore availability', /* eslint-disable-line camelcase */
        selection: current.includes('2D') ? '2D' : current.includes('3D') ? '3D' : 'premium'
    });
}

function pushScrollBtnEvent(button) {
    if (button === null) {
        return;
    }
    const description = button.attributes['data-description'].value;
    const calendarType = description.includes('2D') ? '2D' : description.includes('3D') ? '3D' : description.includes('Premium') ? 'premium' : description.includes('Introducing') ? 'Introducing' : 'side by side';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'scroll dots',
        click_target: description, /* eslint-disable-line camelcase */
        selection: calendarType
    });
}

function pushClickedTabsEvent(tab) {
    if (tab === null) {
        return;
    }
    const description = tab.innerHTML;
    const type = tab.innerHTML.includes('2D') ? '2D' : tab.innerHTML.includes('3D') ? '3D' : tab.innerHTML.includes('Premium') ? 'premium' : tab.innerHTML.includes('Introducing') ? 'Introducing' : 'Side by side';
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'calendar tabs',
        click_target: description, /* eslint-disable-line camelcase */
        selection: type
    });
}

function pushCloseButtonEvent() {
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'button click',
        click_target: 'close', /* eslint-disable-line camelcase */
        page_type: 'product overlay' /* eslint-disable-line camelcase */
    });
}

function pushFAQBtnEvent(label) {
    let page = 'content page';
    const videoDiv = document.body.querySelector('.scrollmagic-pin-spacer');
    if (videoDiv){
        page = videoDiv.children[0].className.includes('js-video-holder') ? 'content page' : 'PDP';
    }
    gtm.pushDataLayerEvent({
        event: 'advent',
        interaction: 'faq expand',
        page_type: page, /* eslint-disable-line camelcase */
        selection: label
    });
}

function pushPDPClick(label) {
    const pdp = document.querySelector('.advent-pdp');
    const type = document.querySelector('.js-the-ritual-of-title').parentNode.innerText;
    const calendar = type.includes('2D') ? '2D' : type.includes('3D') ? '3D' : 'premium';
    if (pdp) {
        gtm.pushDataLayerEvent({
            event: 'advent',
            interaction: 'pdp click',
            selection: calendar,
            click_target: label /* eslint-disable-line camelcase */
        });
    }
}

const advent = {
    init: function() {
        if ($adventBlock.length > 0) {
            initBlock();
            initializeEvents();
            pushProductsToDataLayer();
            changeCalendarOrder();
            adventAnimation();
            addShimmerToCalendar();
            pushGiftWrappingBtnEvent();
            adventNavigation();
            feedbackBtnPosition();
            updatingFlyoutOutOfStock();
            onOffSwatches();
            showFullSliderMobile();
        }
    },
    pushAdventDataLayerDataWithActiveProductImageSlide: pushAdventDataLayerDataWithActiveProductImageSlide,
    pushAdventDataLayerDataForProductExperienceBlock: pushAdventDataLayerDataForProductExperienceBlock,
    pushAdventDataLayerDataForFAQBlock: pushAdventDataLayerDataForFAQBlock,
    getAdventDataLayerDataWithActiveProductImageSlide: getAdventDataLayerDataWithActiveProductImageSlide,
    pushGiftWrappingBtnEvent: pushGiftWrappingBtnEvent,
    pushExperienceBtnEvent: pushExperienceBtnEvent,
    updateARbuttons: updateARbuttons,
    updateARmodel: updateARmodel,
    pushDetailTabsEvent: pushDetailTabsEvent,
    pushPngSequenceEvent: pushPngSequenceEvent,
    pushPngSequenceEventFullReveal: pushPngSequenceEventFullReveal,
    pushShopCalendarsEvent: pushShopCalendarsEvent,
    pushProductClickEvent: pushProductClickEvent,
    pushCheckAvailabilityEvent: pushCheckAvailabilityEvent,
    pushScrollBtnEvent: pushScrollBtnEvent,
    pushClickedTabsEvent: pushClickedTabsEvent,
    pushCloseButtonEvent: pushCloseButtonEvent,
    pushFAQBtnEvent: pushFAQBtnEvent,
    pushPDPClick: pushPDPClick
};

module.exports = advent;


},{"./modules/google":453,"./modules/helpers/isSmallView":469,"./modules/helpers/isTouchDevice":473,"./modules/helpers/scroll":475,"./modules/util/getUpdatedURLWithParams":495,"qrcode":225}],270:[function(require,module,exports){
/**
 * Advent Reveal Class
 * issue: https://rituals.atlassian.net/browse/DL-15114
 */
'use strict';

const advent = require('./advent');
const adventRevealEl = '.js-reveal';
const adventRevealTriggerEl = '.js-reveal-trigger';

const addEvents = () => {
    $(adventRevealTriggerEl).on('click', onClickRevealButton);
};

const onClickRevealButton = (e) => {
    const $target = $(e.currentTarget).closest(adventRevealEl);

    if ($target.hasClass('reveal')) {
        $target.removeClass('reveal');
        setTimeout(() => {
            $target.removeClass('revealed');
        }, 1000);
    } else {
        $target.addClass('reveal');
        setTimeout(() => {
            $target.toggleClass('revealed');
        }, 1000);
    }

    advent.pushAdventDataLayerDataWithActiveProductImageSlide('reveal contents');
};


/**
 * Tests if the adventReveal element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $(adventRevealTriggerEl).length > 0;
};

const adventReveal = {
    init: () => {
        if (shouldInit()) {
            addEvents();
        }
    }
};

module.exports = adventReveal;

},{"./advent":269}],271:[function(require,module,exports){
'use strict';

const elementInViewport = require('./modules/util/elementInViewport');

const animBlockEl = '.js-anim-block';
const animQueuedEl = '.js-anim-queued';

let onScrollTimeout;

const initAnimBlocks = () => {
    const observer = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            const $el = $(block.target);

            if (block.isIntersecting === true) {
                $el.removeClass('not-in-viewport');
                $el.addClass('in-viewport');
            } else {
                $el.removeClass('in-viewport');
                $el.addClass('not-in-viewport');
            }
        }
    }, {
        threshold: [0.05]
    });

    $(animBlockEl).each(function(i, el) {
        observer.observe(el);
    });
};

const supportsIntersectionOberver = () => {
    return 'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};

const bindEvents = () => {
    if ($(animBlockEl).length > 0) {
        $(window).on('scroll', onScrollWindow);
        handleInitialPageView();
    }
};

const onScrollWindow = () => {
    clearTimeout(onScrollTimeout);
    onScrollTimeout = setTimeout(handleOnScrollWindow, 10);
};

const handleOnScrollWindow = () => {
    $(animBlockEl).each(function(index, el) {
        handleAnimationClass(el);
    });
};

const handleInitialPageView = () => {
    $(animBlockEl).not(animQueuedEl).each(function(index, el) {
        handleAnimationClass(el);
    });
};

const handleAnimationClass = (el) => {
    if (elementInViewport(el, 0)) {
        $(el).removeClass('not-in-viewport');
        $(el).addClass('in-viewport');
    } else {
        $(el).removeClass('in-viewport');
        $(el).addClass('not-in-viewport');
    }
};

const animBlock = {
    init: () => {
        if (supportsIntersectionOberver()) {
            initAnimBlocks();
        } else {
            bindEvents();
        }
    }
};

module.exports = animBlock;

},{"./modules/util/elementInViewport":483}],272:[function(require,module,exports){
'use strict';

const counterEl = '.js-animated-counter';
const counterSettings = {
    percLarge: 0.05, // Percentage used for numbers larger then 100
    percSmall: 0.5, // Percentage used for number smaller then or equal to 100
    maxCount: 300
};

const scrollObserver = new IntersectionObserver((tiles) => {
    for (const tile of tiles) {
        if (tile.isIntersecting) {
            const el = tile.target;
            const counterValue = parseInt(el.dataset.counterValue) || 0;
            const unit = el.dataset.counterUnit || '';
            const percentage = counterValue > 100 ? counterSettings.percLarge : counterSettings.percSmall;
            const toCount = Math.min(Math.ceil(counterValue * percentage), counterSettings.maxCount);
            const from = counterValue - toCount;

            startCounter(el, from, counterValue, unit);
            scrollObserver.unobserve(el);
        }
    }
}, {
    threshold: [0.33]
});

/**
 * Creates a changing delay based on the Robbert Penner easing functions.
 * Source: https://github.com/bameyrick/js-easing-functions
 * @param {Number} elapsed Current Number to update Easing with
 * @param {Number} initialValue Initial delay
 * @param {Number} amountOfChange Max delay
 * @param {Number} duration Max Number to update Easing with
 * @returns {Number}
 */
const easeInExpo = (elapsed, initialValue, amountOfChange, duration) => {
    return elapsed === 0 ? initialValue : amountOfChange * Math.pow(2, 10 * (elapsed / duration - 1)) + initialValue;
};

/**
 * Starts observing all counter elements in the DOM
 */
const initObserver = () => {
    document.querySelectorAll(counterEl).forEach((el) => {
        scrollObserver.observe(el);
    });
};

/**
 * Handles the count animation of a given counter element
 * @param {DOM Element} el Counter element to show number in
 * @param {Number} from Start of count
 * @param {Number} to End of count
 * @param {String} unit Unit to append to count like a '%' sign
 */
const startCounter = (el, from, to, unit) => {
    let time = 0;
    const diff = to - from;
    const step = (diff > 100) ? 4 : 1;
    const minTime = 0;
    const maxTime = 5000;

    for (let i = 0; i <= diff; i += step) {
        (function(count, delay) {
            setTimeout(function() {
                el.innerHTML = (from + count).toLocaleString('en-NL') + unit;
            }, delay);
        })(i, time);

        time = easeInExpo(i, minTime, maxTime, diff);
    }
};

/**
 * Check if we should init or not by searching for a selector
 * @returns {Boolean}
 */
 const shouldInit = () => {
    return document.querySelectorAll(counterEl).length > 0;
};

const animatedCounter = {
    init: () => {
        if (shouldInit()) {
            initObserver();
        }
    }
};

module.exports = animatedCounter;

},{}],273:[function(require,module,exports){
/**
 *    (c) 2009-2014 Demandware Inc.
 *    Subject to standard usage terms and conditions
 *    For all details and documentation:
 *    https://bitbucket.com/demandware/sitegenesis
 */

'use strict';

const SitePreferences = window.SitePreferences || {};
const Resources = window.Resources || {};

// responsiveImage is module maintained by DAM team. The next two lines are enough to init dam images and videos loading. Do not remove these lines!
const responsiveImage = require('./dam/responsive_image'); /* eslint-disable-line no-unused-vars */
const damResponsiveVideo = require('./dam/responsive_video'); /* eslint-disable-line no-unused-vars */
const headermenu = require('./header-menu'),
    headerNavigation = require('./navigation'),
    headerCheckout = require('./components/checkout/header/header'),
    countries = require('./countries'),
    productBackButton = require('./productBackButton'),
    google = require('./modules/google'),
    flyout = require('./flyout'),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    tooltip = require('./tooltip'),
    validator = require('./validator'),
    tls = require('./tls'),
    categoryRefinements = require('./category-refinements'),
    ritualsStyles = require('./rituals-styles'),
    responsiveBg = require('./responsive-background'),
    slickSlider = require('./slick-slider'),
    grid = require('./grid'),
    customSelect = require('./select-custom'),
    gst = require('./gst'),
    variant = require('./pages/product/variant'),
    option = require('./pages/product/option'),
    addToCart = require('./pages/product/addToCart'),
    video = require('./video'),
    responsiveVideo = require('./responsive-video'),
    seoText = require('./seo-text'),
    tabs = require('./tabs'),
    backToTop = require('./backtotop'),
    accordion = require('./accordion'),
    advent = require('./advent'),
    whitelist = require('./whitelist'),
    productSlider = require('./product-slider'),
    productFilter = require('./product-filter'),
    productDescription = require('./product-description'),
    scrollAnimation = require('./scrollAnimation'),
    animeBlock = require('./anim-block'),
    toaster = require('./toaster'),
    sectionScroller = require('./sectionScroller'),
    dragList = require('./dragList'),
    productTile = require('./product-tile'),
    footer = require('./footer'),
    productConfiguratorApp = require('./components/product-configurator/product-configurator-app'),
    productConfiguratorInlineApp = require('./components/product-configurator-inline/product-configurator-inline-app'),
    checkoutApp = require('./components/checkout/checkout-app'),
    vueFormApp = require('./components/vue-form/vue-form-app'),
    dynamicFormApp = require('./components/dynamic-form/dynamic-form-app'),
    modalApp = require('./components/modal/modal-app'),
    flyinApp = require('./components/flyin/flyin-app'),
    adventReveal = require('./adventReveal'),
    productExperience = require('./productExperience'),
    leadtime = require('./leadtime'),
    horizontalProductScroll = require('./horizontal-product-scroll'),
    giftsetZoom = require('./giftsetImageZoom'),
    giftReveal = require('./gift-reveal'),
    socialCommerce = require('./social-commerce/social-commerce'),
    collectionIngredients = require('./pages/collection/collection-ingredients'),
    easter = require('./easter/easter'),
    animatedCounter = require('./animated-counter'),
    adventMovingTitle = require('./advent-moving-title'),
    adventTextAnimation = require('./advent-text'),
    bannerSrcHandler = require('./banner-src-handler'),
    stickyAddToCart = require('../js/pages/product/stickyaddtocart'),
    crm23 = require('./crm2_3'),
    genericNavAccordion = require('./generic-nav-accordion');

const helper = {
    debounce: require('./modules/helpers/debounce'),
    isKeyCodeNumber: require('./modules/helpers/isKeyCodeNumber'),
    cookiesAccepted: require('./modules/helpers/cookiesAccepted')
};

const util = {
    isMobile: require('./modules/util/isMobile'),
    isMobileOrTabletWidth: require('./modules/util/isMobileOrTabletWidth'),
    getQueryStringParams: require('./modules/util/getQueryStringParams'),
    getTriggerFromHash: require('./modules/util/getTriggerFromHash'),
    limitCharacters: require('./modules/util/limitCharacters')
};

function initializeEvents() {
    const controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    // accessibility - focus the first element on page, so the user can tab through without first clicking on the page
    if (!util.isMobile()) {
        $('.js-skip-to-content').focus();
    }

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            const text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            const text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;
            let charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // preventing anything except numbers to insert into min/max price input fields
    $(document).on('keypress input copy', '.js-min-price, .js-max-price, .js-price-filter-min, .js-price-filter-max', function (e) {
        const charCode = (e.which) ? e.which : e.keyCode;
        return helper.isKeyCodeNumber(charCode);
    });

    // subscribe email box
    const $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            const val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            const val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    // scroll to top button
    $('.js-scrolltotop').on('click', function(){
        $('html, body').animate({scrollTop: $('body').offset().top}, 800);
    });

    // show welcome message
    const gwpWelcomeBanner = $('.js-gwp-welcome-overlay');
    const showWelcomeToast = util.isMobile() && gwpWelcomeBanner.length > 0 && !gwpWelcomeBanner.hasClass('hide');

    if (showWelcomeToast) {
        toaster.load({
            url: Urls.getGwpWelcomeToastMessage + '?currentPipeline=' + Urls.currentPipeline
        });
    }

    // if it is a linked block, go to href on click
    $(document).on('click keydown', '.js-linked-block', function(e){
        const href = $(this).data('href');

        if ((e.type == 'keydown' && e.which == '13') || e.type == 'click') {
            window.location.href = href;
        }
    });

    //custom styling for checkboxes
    if ($('.js-form').length) {
        $('.js-form').find('.label-inline').each(function () {
            const $inputChecked = $(this).find('input:checked');
            const $label = $(this).find('label');

            if ($inputChecked.length) {
                $(this).find('label').addClass('checked');
            }

            $label.each(function () {
                $(this).on('click', function () {
                    $(this).closest('.label-inline').find('input').on('change', function () {
                        if ($(this).is(':checked')) {
                            $(this).closest('.label-inline').find('label').addClass('checked');
                        } else {
                            $(this).closest('.label-inline').find('label').removeClass('checked');
                        }
                    });
                });
            });
        });

    }

    $(document).on('click', '.js-checkout-opening-hours-button', function () {
        const $this = $(this);

        $this.toggleClass('open');
        $this.next('.js-checkout-opening-hours-list').stop().slideToggle();
    });

    toggleReadMore('.js-discover-toggle', '.js-discover-short', '.js-discover-long');
    toggleReadMore('.js-cop-desc-toggle', '.js-cop-short-desc', '.js-cop-long-desc');

    stickyCheckoutBar();

    if ($('.js-animated-banner').length && !$('.js-animated-banner').closest('.js-encode').length) {
        animateVideoBannerElements();
    }

    $(window).scroll(function() {
        stickyCheckoutBar();
    });

}

function stickyCheckoutBar() {
    if ($('.js-checkout-sticky-bar').length) {
        const scroll = $(window).scrollTop();
        let $mainBtn;

        if ($('.pt_cart').length) {
            $mainBtn = $('.pt_cart .cart-actions .btn--submit');
        } else if ($('.pt_checkout').length) {
            $mainBtn = $('.pt_checkout .js-checkout-step-content:visible .btn-submit');
        }

        if ($mainBtn.length > 0) {
            const mainBtnOffset = $mainBtn.offset().top;
            const mainBtnHeight = $mainBtn.outerHeight();

            if (scroll > mainBtnOffset + mainBtnHeight || scroll + $(window).height() < mainBtnOffset){
                $('.js-checkout-sticky-bar').addClass('show-bar');
                $('.sticky-bar-spacer').addClass('show-bar');
            } else {
                $('.js-checkout-sticky-bar').removeClass('show-bar');
                $('.sticky-bar-spacer').removeClass('show-bar');
            }
        }
    }
}

function toggleReadMore(el, shortText, longText) {
    $(el).on('click', function () {
        const $this = $(this);
        const $shortText = $this.siblings(shortText);
        const $longText = $this.siblings(longText);

        if (!$this.hasClass('open')) {
            $this.addClass('open');
            $shortText.hide();
            $longText.show();
        } else {
            $this.removeClass('open');
            $longText.hide();
            $shortText.show();
        }
    });
}

function animateVideoBannerElements() {
    $('.fade-in-element').each(function(i, element) {
        setTimeout(function() {
            $(element).addClass('visible');
        }, i * 800);
    });
}

/**
 * @private
 * @function
 * @description Checks and gets the anchor id from the url and scrolls to that block
 */
function initPageAnchors(){
    $(document).on('click','[data-jump-to]', function(e){
        e.preventDefault();
        ritualsStyles.jumpToAnchor($(this).data('jump-to'));
    });
}

function scrollToAnchor() {
    const param = util.getQueryStringParams(window.location.href).jumpto;
    let hash = util.getTriggerFromHash();

    if (!param && hash.length === 0) {
        return;
    }
    hash = hash.includes('?') ? hash.split('?')[0] : hash;
    const scrollTarget = param || hash;
    const scrollTargetEl = document.querySelector('[data-anchor-id="' + scrollTarget + '"]');
    const targetShouldLazyLoad = scrollTargetEl ? scrollTargetEl.hasAttribute('data-anchor-islazyloaded') : false;

    if (targetShouldLazyLoad) {
        document.dispatchEvent(new CustomEvent('shouldTriggerLazyload', {detail: scrollTarget}));
    }

    //open appropriate accordion tab
    if ($('.experience-assets-navigationtitle').length) {
        scrollTargetEl.closest('.experience-assets-navigationtitle').querySelector('li .js-generic-nav-button').click();
    }

    setTimeout(() => {
        ritualsStyles.jumpToAnchor(scrollTarget);
    }, 1000);
}

function expandAccordionBasedOnAnchor() {
    const anchorId = util.getQueryStringParams(window.location.href).jumpto;
    const element = $('[data-anchor-id=' + anchorId + ']');
    $(element).addClass('open-acc').attr('aria-expanded', true);
    $(element).parent().find('.faq-accordion-content').attr('aria-hidden', false).show();
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
}

const pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    collection: require('./pages/collection'),
    registry: require('./pages/registry'),
    search: require('./pages/search'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    singlepagecheckout: require('./pages/checkout/singlepagecheckout'),
    checkout: require('./pages/checkout/checkoutlogin'),
    orderconfirmation: require('./pages/checkout/orderconfirmation'),
    faq: require('./pages/faq'),
    jobs: require('./pages/jobs'),
    mag: require('./pages/magazine'),
    customerservice: require('./customerservice'),
    newsletter: require('./newsletter'),
    promotions: require('./pages/promotions'),
    customerbarcode: require('./pages/customerbarcode'),
    giftcard: require('./pages/giftcard'),
    outlet: require('./pages/outlet'),
    hairtemple: require('./pages/hairtemple-landing'),
    registration: require('./pages/registration'),
    whereIsMyOrder: require('./pages/whereIsMyOrder/whereIsMyOrder'),
    faqredesign: require('./pages/faqredesign')
};

const app = {
    init: function () {
        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        initializeDom();
        initializeEvents();

        // Modal and Flyin needs to init first so we know the vue stuff is in place
        modalApp.init();
        flyinApp.init();

        // init specific global components
        ritualsStyles.initInputStyles();
        headermenu.init();
        headerNavigation.init();
        headerCheckout.init();
        tooltip.init();
        flyout.init();
        minicart.init();
        validator.init();
        rating.init();
        categoryRefinements.init();
        productDescription.init();
        addToCart.init();
        variant();
        option();
        video.initGeneric();
        responsiveVideo.init();
        leadtime.init();
        giftReveal.init();
        socialCommerce.init();
        easter.init();
        animatedCounter.init();
        adventMovingTitle.init();

        if ($('.order-confirmation-summary').length) {
            $('.refill-container').hide();
        }

        if ($('.js-product-container-giftset').length > 0) {
            giftsetZoom.init();
        }

        if ($('.js-advent-block').length > 0) {
            advent.init();
        }
        if ($('.js-b2b-signup-form').length > 0) {
            whitelist.init();
        }
        if ($('.js-advent-split').length > 0) {
            adventTextAnimation.init();
        }

        if ($('.js-product-slider-steps').length > 0) {
            productSlider.init();
        }

        if ($('.js-product-filter-block').length > 0) {
            productFilter.init();
        }

        if ($('.product-list-slider-block').length > 0) {
            productTile.init();
        }

        if ($('.js-banner').length > 0) {
            bannerSrcHandler.init();
        }

        if ($('.js-onboarding-page').length > 0){
            stickyAddToCart.init();
        }

        if ($('.js-crm-page').length > 0) {
            crm23.init();
        }

        if ($('.phase-section-wrapper').length > 0) {
            pages.cart.init();
        }

        if ($('.js-generic-nav-acc').length || $('.js-generic-acc-wrapper').length || $('.js-footer-middle-elements').length) {
            genericNavAccordion.init();
        }

        // execute page specific initializations
        $.extend(page, window.pageContext);
        const ns = page.ns;
        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }


        // do not init these in the styleguide (sg)
        if (ns !== 'sg') {
            ritualsStyles.initLazyLoad();
            ritualsStyles.prepareAnimBlocks();
            customSelect.init();
            seoText.init();
            tabs.init();
            backToTop.init();
            accordion.init();
            responsiveBg.init();
            google.places.init();
            google.tagManager.init();
            animeBlock.init();
            sectionScroller.init();
            scrollAnimation.init();
            slickSlider.init();
            horizontalProductScroll.init();

            if ($('.js-concept-highlight-block').length) {
                ritualsStyles.initConceptHighlightHeight();
            }
        }

        // On these pages there's a simple footer without country selector
        if (ns !== 'singlepagecheckout' && ns !== 'checkout' && ns !== 'sg') {
            countries.init();
        }

        if (ns === 'content'){
            pages.customerbarcode.init({format: 'ean13', fontSize: 0, margin: 0, height: 28});
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }

        // init Guided Selling Tool js if is exists in the page
        if ($('.js-gst-wrapper').length > 0 && ns !== 'sg'){
            gst.init();
        }

        // TODO: Find a better location for this.
        // Ticket: https://rituals.atlassian.net/browse/DL-22464
        collectionIngredients.init();

        productBackButton.init();

        fadeIngredientsBlock();
        initPageAnchors();
        footer.init();

        // DL-16302: removed "javascript:;"" from href attributes, here we prevent refreshing a page on click
        $('a[href=""]').on('click', function (e) {
            e.preventDefault();
        });

        if ($('.js-show-switch-session-modal') && $('.js-show-switch-session-modal').length) {
            socialCommerce.showSwitchSessionModal();
        }
    }
};

function fadeIngredientsBlock() {
    if ($('.js-collection-ingredients').length) {
        const offset = $(window).height() / 2;
        const $colsHolder = $('.js-collection-ingredients');
        const $leftCol = $('.js-collection-ingredient-col:first-child');
        const $rightCol = $('.js-collection-ingredient-col:last-child');
        const colsRect = $colsHolder[0].getBoundingClientRect().top;

        if (colsRect < offset) {
            $leftCol.addClass('col-fadein');
            setTimeout(function () {
                $rightCol.addClass('col-fadein');
            }, 1000);
        }
    }
}

function showStickyTopMessage() {
    const $stickyBar = $('.js-sticky-top-message-bar');
    const stickyBarHeight = $stickyBar.outerHeight();

    $('.js-sticky-top-message-placeholder').css('height', stickyBarHeight);

    setTimeout(function () {
        $stickyBar.addClass('loaded');
        initStickyTopMessage();
    }, 1000);
}

function initStickyTopMessage() {
    const $stickyBar = $('.js-sticky-top-message-bar.loaded');
    const $stickyBarHolder = $('.js-sticky-top-message-placeholder');
    const stickyBarHolderRect = $stickyBarHolder[0].getBoundingClientRect().top;

    if (stickyBarHolderRect <= 0) {
        $stickyBar.addClass('sticky');
        $stickyBarHolder.addClass('in-place');
    } else {
        $stickyBar.removeClass('sticky');
        $stickyBarHolder.removeClass('in-place');
    }
}

// general extension functions
(function () {
    String.format = function () {
        let s = arguments[0];
        const len = arguments.length - 1;
        for (let i = 0; i < len; i++) {
            const reg = new RegExp('\\{' + i + '\\}', 'gm');
            s = s.replace(reg, arguments[i + 1]);
        }
        return s;
    };
})();

// initialize app
$(document).ready(function () {
    app.init();
});

$(window).on('load', function () {
    grid.init();

    scrollToAnchor();
    expandAccordionBasedOnAnchor();

    // do not init these in the styleguide (sg)
    if (page.ns !== 'sg') {
        dragList.init();
        adventReveal.init();
        productExperience.init();
    }
    checkoutApp.init();
    vueFormApp.init();
    dynamicFormApp.init();
    pages.product.initOnDomReady();
    productConfiguratorApp.init();
    productConfiguratorInlineApp.init();

    if (helper.cookiesAccepted()) {
        video.initGeneric();
    }

    if (!util.isMobile()) {
        ritualsStyles.initCustomScrollbar();
    }

    if (util.isMobileOrTabletWidth()) {
        minicart.initMobileConfirmation();
    }

    //To prevent the element visibilty while the page is loading we
    //initially set the opacity 0. We set it to 1 by adding this class on page load.
    $('.js-toaster-container, .js-reset-password-confirmation, .js-new-password-confirmation').addClass('page-loaded');

    if ($('.js-page-fullheight').length && !util.isMobileOrTabletWidth()) {
        ritualsStyles.initBottomFooterPosition();
    }

    if ($('.js-sticky-top-message-bar').length) {
        showStickyTopMessage();
    }

    // In case of the UsableNet A11Y logic we need to move the focus to this element
    // Ticket: https://rituals.atlassian.net/browse/DL-23847
    const $usableNetToggle = $('#usntA40Toggle a');

    if (!util.isMobile() && $usableNetToggle.length > 0) {
        $usableNetToggle.parent().attr('tabindex', 0);
        $usableNetToggle.parent().trigger('focus');
        $usableNetToggle.on('blur', function() {
            setTimeout(() => {
                $('.js-skip-to-content').trigger('focus');
            }, 200);
        });
    }
});

$(window).on('resize', helper.debounce(function() {
    if ($('.js-page-fullheight').length && !util.isMobileOrTabletWidth()) {
        ritualsStyles.initBottomFooterPosition();
    }

    if ($('.js-concept-highlight-block').length && !util.isMobile()) {
        ritualsStyles.initConceptHighlightHeight();
    }
}, 200));

$(window).on('scroll', function () {
    fadeIngredientsBlock();

    if ($('.js-sticky-top-message-bar').length) {
        initStickyTopMessage();
    }
});

},{"../js/pages/product/stickyaddtocart":558,"./accordion":265,"./advent":269,"./advent-moving-title":267,"./advent-text":268,"./adventReveal":270,"./anim-block":271,"./animated-counter":272,"./backtotop":274,"./banner-src-handler":275,"./category-refinements":279,"./components/checkout/checkout-app":286,"./components/checkout/header/header":319,"./components/dynamic-form/dynamic-form-app":364,"./components/flyin/flyin-app":366,"./components/modal/modal-app":368,"./components/product-configurator-inline/product-configurator-inline-app":373,"./components/product-configurator/product-configurator-app":390,"./components/vue-form/vue-form-app":405,"./countries":416,"./crm2_3":417,"./customerservice":418,"./dam/responsive_image":420,"./dam/responsive_video":421,"./dragList":423,"./easter/easter":424,"./flyout":425,"./footer":426,"./generic-nav-accordion":427,"./gift-reveal":429,"./giftsetImageZoom":431,"./grid":437,"./gst":438,"./header-menu":440,"./horizontal-product-scroll":441,"./leadtime":442,"./minicart":446,"./modules/google":453,"./modules/helpers/cookiesAccepted":456,"./modules/helpers/debounce":458,"./modules/helpers/isKeyCodeNumber":465,"./modules/util/getQueryStringParams":492,"./modules/util/getTriggerFromHash":494,"./modules/util/isMobile":497,"./modules/util/isMobileOrTabletWidth":498,"./modules/util/limitCharacters":502,"./navigation":515,"./newsletter":517,"./page":518,"./pages/account":519,"./pages/cart":520,"./pages/checkout/checkoutlogin":524,"./pages/checkout/orderconfirmation":526,"./pages/checkout/singlepagecheckout":528,"./pages/collection":534,"./pages/collection/collection-ingredients":531,"./pages/compare":535,"./pages/customerbarcode":536,"./pages/faq":537,"./pages/faqredesign":538,"./pages/giftcard":539,"./pages/hairtemple-landing":540,"./pages/jobs":541,"./pages/magazine":542,"./pages/outlet":544,"./pages/product":552,"./pages/product/addToCart":550,"./pages/product/option":554,"./pages/product/variant":560,"./pages/promotions":562,"./pages/registration":563,"./pages/registry":564,"./pages/search":566,"./pages/storelocator":567,"./pages/whereIsMyOrder/whereIsMyOrder":568,"./pages/wishlist":570,"./product-description":576,"./product-filter":577,"./product-slider":580,"./product-tile":581,"./productBackButton":582,"./productExperience":583,"./rating":586,"./responsive-background":588,"./responsive-video":589,"./rituals-styles":592,"./scrollAnimation":593,"./sectionScroller":595,"./select-custom":596,"./seo-text":597,"./slick-slider":598,"./social-commerce/social-commerce":599,"./tabs":603,"./tls":604,"./toaster":605,"./tooltip":606,"./validator":607,"./video":608,"./whitelist":609}],274:[function(require,module,exports){
'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const isAboveViewport = require('./modules/helpers/isAboveViewport');
const $backToTop = $('.js-scrolltotop');

function backButtonPosition() {
    const stayInformed = $('.stay-informed');

    if (stayInformed.length) {
        const elementIsInView = isInViewport(stayInformed) || isAboveViewport(stayInformed);
        if (elementIsInView) {
            $backToTop.addClass('not-fixed');
            $backToTop.css('margin-bottom', stayInformed.outerHeight());
            return;
        }

        $backToTop.removeClass('not-fixed').css('margin-bottom', '');
        return;
    }
    const bigFooter = $('.js-footer');
    let $endPoint = $('.footer');

    if (bigFooter.length) {
        $endPoint = bigFooter;

        if (isInViewport($endPoint)) {
            $backToTop.addClass('not-fixed');
            return;
        }
    }

    $backToTop.removeClass('not-fixed');
}

function initializeEvents() {
    const viewportHeight = $(window).height();
    let prevScroll = $(document).scrollTop();

    if ($backToTop.length > 0 && !$('.sticky-bar').length) {
        $(window).on('scroll', function() {
            const offsetFromTop = $(window).scrollTop();
            const newScroll = $(document).scrollTop();

            if (offsetFromTop > viewportHeight) {
                $backToTop.addClass('shown');

                if (newScroll < prevScroll) {
                    $backToTop.addClass('shown').removeClass('hide-on-mobile');
                } else {
                    $backToTop.addClass('hide-on-mobile');
                }
                prevScroll = newScroll;
            } else {
                $backToTop.removeClass('shown');
            }

            backButtonPosition();
        });
    }

    if ($('.sticky-bar').length) {
        $('.js-scrolltotop').remove();
    }
}

const backtotop = {
    init: function() {
        initializeEvents();
        backButtonPosition();
    }
};

module.exports = backtotop;

},{"./modules/helpers/isAboveViewport":460,"./modules/helpers/isInViewport":464}],275:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const damHelper = require('./dam/dam-helper');
const banner = '.js-banner';

function changeSrcVideo() {
    if ($('.js-bannersmall-video').length > 0) {
        if (isSmallView()) {
            $('.js-bannersmall-video source').attr('src', $('.js-bannersmall-video source').data('mobilev'));
            $('.js-bannersmall-video')[0].load();
        } else {
            $('.js-bannersmall-video source').attr('src', $('.js-bannersmall-video source').data('desktopv'));
            $('.js-bannersmall-video')[0].load();
        }
    }
}

function changeSrcImage() {
    const bannerImages = $('.js-banner-image');
    if (!bannerImages.length) {
        return;
    }
    for (const banner of bannerImages) {
        const $banner = $(banner);
        if (isSmallView() && $banner.data('mobilev')) {
            $banner.attr('data-src', $banner.data('mobilev'));
        } else {
            $banner.attr('data-src', $banner.data('desktopv'));
        }
        damHelper.updateImages($banner.parent());
    }
}


/**
 * Tests if the dragList element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => document.querySelectorAll(banner).length > 0;


const changeSrcForMedia = {
    init: () => {
        if (shouldInit()) {
            changeSrcVideo();
            changeSrcImage();
        }
    }
};

/**
 * Fix for PD preview
 */
let prevWidth = window.innerWidth;
window.addEventListener('resize', function() {
    if (window.innerWidth !== prevWidth) {
        prevWidth = window.innerWidth;
        changeSrcForMedia.init();
    }
});

module.exports = changeSrcForMedia;

},{"./dam/dam-helper":419,"./modules/helpers/isSmallView":469}],276:[function(require,module,exports){
'use strict';

const dialog = require('./dialog'),
    toaster = require('./toaster'),
    page = require('./page'),
    grid = require('./grid'),
    appendParamsToUrl = require('./modules/util/appendParamsToUrl'),
    ajaxUrl = require('./modules/util/ajaxUrl'),
    minicart = require('./minicart'),
    checkout = require('./pages/checkout/singlepagecheckout'),
    isMobileWidth = require('./modules/util/isMobileWidth'),
    actionQueue = require('./actionQueue'),
    scrollHelper = require('./modules/helpers/scroll');

const maxItems = 1;
let giftAddClicked = false;
let onCart = false;
let onCheckout = false;
let onCloseCallback = null;
let newValue = null;
let previousValue = null;
let counter = 0;

function getMiniCart(options, addedProductId) {
    const url = ajaxUrl(Urls.minicart);

    $.ajax({
        type: 'GET',
        url: url,
        data: {
            pid: addedProductId
        }
    }).done(function (response) {
        if (!isMobileWidth()) {
            minicart.show(response, true);
        } else {
            bonusProductsView.show({ response: response}, false);
        }

        minicart.updateHeaderCartIcon($('.js-flyout-header .js-cart-quantity').val() || $(response).filter('.js-mobile-crm-toast').data('quantity'));
    }).fail(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        }
    });
}

function getGWPBanner() {
    const gwpBannerEl = $('.js-gwp-banner');
    if (!gwpBannerEl.length) {
        return;
    }
    const height = gwpBannerEl.height();

    $.ajax({
        type: 'GET',
        url: Urls.getGwpCOPBanner
    }).done(function (response) {
        gwpBannerEl.empty().append($(response).find('.js-gwp-banner').html()).imagesLoaded(function(){
            if (gwpBannerEl.height() != height) {
                grid.reinitGridLayout(gwpBannerEl.parents('.js-grid-wrap').data('msnryId'));
            }
        });
    }).fail(function (response) {
            // handle error in the response
            if (response.error) {
                throw new Error(response.error);
            }
    });
}

const bonusProductsView = {
    /**
    * @function
    * @description Open the list of bonus products selection dialog
    */
    show: function (data, hideMinicart) {
        if (data.checkout) {
            onCheckout = true;
            data.url += '&onCheckout=true';
        } else if (!data.response || data.response === null) {
            onCart = true;
        }

        if (data.onClose) {
            onCloseCallback = data.onClose;
        }

        if (data.url && data.url !== null) {
           //Skip dialog - show minicart or small toast on mobile
            if (data.isAddedPopup){
                this.getGWPBanner();
                onBonusProductsViewBeforeClose(data);
                return;
            }

            const params = data.url.split('?').length > 1 ? '?' + data.url.split('?')[1] : '';
            let configuration = null;

            $.ajax({
                type: 'GET',
                url: Urls.getBonusProductsVueData + params
            }).done(function (response) {
                configuration = response;
                const flyinId = 'bonusProductChoice';
                const ProductChoiceList = require('./components/products/product-choice-list/product-choice-list.vue');
                const productsList = configuration.bonusProducts.map(bonusProduct => {
                    const analyticsData = {
                        productData: bonusProduct,
                        promotionName: bonusProduct.promotionName,
                        currencyCode: bonusProduct.currencyCode
                    };

                    return {
                        analyticsData: JSON.stringify(analyticsData),
                        id: 'item-' + bonusProduct.productUUID,
                        productName: bonusProduct.productName,
                        productType: bonusProduct.productType,
                        productID: bonusProduct.productID,
                        productUUID: bonusProduct.productUUID,
                        productHeading: bonusProduct.productHeading,
                        bonusDiscountLineItemUUID: bonusProduct.bonusDiscountLineItemUUID,
                        bonusProductID: bonusProduct.bonusProductID,
                        popupProductID: 'popup-product-' + bonusProduct.productID,
                        productImageUrl: bonusProduct.productImageUrl,
                        productImageTitle: bonusProduct.productImageTitle,
                        productImageAlt: bonusProduct.productImageAlt,
                        productImagePlaceholder: bonusProduct.productImagePlaceholder,
                        productImageClass: bonusProduct.productImageClass,
                        refillResource: bonusProduct.refillResource
                    };
                });
                const onChoiceMade = (productID) => {
                    const isCartPage = !!$('.js-cart-page-wrapper').length;
                    const selectedProduct = productsList.find(product => productID === product.productID);
                    const product = {
                        uuid: selectedProduct,
                        pid: selectedProduct.productID,
                        qty: 1,
                        name: selectedProduct.productName,
                        options: []
                    };

                    const url = appendParamsToUrl(Urls.addBonusProduct, {bonusDiscountLineItemUUID: selectedProduct.bonusDiscountLineItemUUID});

                    const bonusproducts = [];
                    bonusproducts.push({product: product});

                    const bonusProducts = {bonusproducts: bonusproducts};
                    if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
                        bonusProducts.bonusproducts[0].product.qty = maxItems;
                    }

                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        cache: false,
                        contentType: 'application/json',
                        url: url,
                        data: JSON.stringify(bonusProducts)
                    }).done(function () {
                        if (isCartPage || onCart) {
                            page.refresh();
                        } else if (!onCheckout) {
                            let addedProductId = '';
                            if ('addedProductId' in data) {
                                addedProductId = data.addedProductId;
                            }
                            getMiniCart({}, addedProductId);
                        } else if (onCheckout){
                            checkout.updateSummary();
                        }
                    }).fail(function (_, textStatus) {
                        if (textStatus === 'parsererror') {
                            console.info(Resources.BAD_RESPONSE);
                        } else {
                            console.info(Resources.SERVER_CONNECTION_ERROR);
                        }
                    });

                    onBonusProductsViewBeforeClose(data);
                };
                scrollHelper.disableScroll();
                window.eventBus.$emit('shouldOpenFlyin', {
                    id: flyinId,
                    content: ProductChoiceList,
                    props: {
                        resources: configuration.resources,
                        products: productsList, onProductPicked: onChoiceMade,
                        selectedID: data.selectedID
                    },
                });
                window.eventBus.$on('flyinClosed', function() {
                    scrollHelper.enableScroll();

                    if (onCloseCallback) {
                        onCloseCallback();
                        // Clear pnCloseCallback so it doesn't open in case of multiple event emits
                        onCloseCallback = null;
                    }
                });

                onBonusProductsViewOpen();
            });

            if (configuration === null) {
                return;
            }

            return;
        } else {
            this.getGWPBanner();
        }

        if (!!data.response && data.response !== null) {
            if (!isMobileWidth()) {
                if (hideMinicart) {
                    minicart.update(data.response);
                } else {
                    minicart.show(data.response, true);
                }
            } else {
                // Check if we need to show the CRM mobile toast
                if (data.response.indexOf('js-mobile-crm-toast')) {
                    minicart.showMobileCrmToast(data.response);
                    if (counter === 0) {
                        //timeout in duration of crm showing animation
                        setTimeout(function() {
                            hideSameNumOfGifts();
                        }, 500);
                    }

                    //reseting counter to 0
                    $('.js-product-details-content .js-add-to-cart').on('click', function() {
                        counter = 0;
                    });

                    //reseting counter to 0 on COP
                    $('.js-product-tile-details-content .js-add-to-cart').each(function() {
                        $(this).on('click', function() {
                            counter = 0;
                        });
                    });
                    counter++;
                } else {
                    actionQueue.addToQueue(function() {
                        minicart.mobileConfirmation(data.response);
                    }, 4500);

                    if (data.displayGwpToast) {
                        showGwpToastMessage();
                    }
                }
            }

            minicart.updateHeaderCartIcon($('.js-flyout-header .js-cart-quantity').val() || $(data.response).filter('.js-mobile-crm-toast').data('quantity'));
        }
    },
    /**
    * @function
    * @description Open bonus product promo prompt dialog
    */
    loadBonusOption: function () {
        const self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) {
            return;
        }

        // get the html from minicart, then trash it
        const bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 720,
                title: Resources.BONUS_PRODUCT,
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function () {
                        const uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = appendParamsToUrl(Urls.getBonusProducts, {
                                bonusDiscountLineItemUUID: uuid,
                                source: 'bonus',
                                format: 'ajax',
                                lazyLoad: 'false',
                                pageStart: 0,
                                pageSize: 10,
                                bonusProductsTotal: -1
                            });
                        $(this).dialog('close');
                        self.show(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function () {
                        $(this).dialog('close');
                    }
                }]
            },
            open: function(){
                $('.js-modal-overlay').show();
                $(document).on('click touchstart', '.js-modal-overlay', function(){
                    dialog.close();
                });
            },
            close: function(){
                $('.js-modal-overlay').hide();
            },
            callback: function () {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    },
    getGWPBanner:getGWPBanner
};

function onBonusProductsViewOpen() {
    giftAddClicked = false;

    const tierStep = $('.js-gwp-tier-step').val();
    const dataLayer = [];
    if (tierStep > 0) {
        dataLayer.push({
            'event': 'GWPPopUpAdd',
            'threshold': tierStep
        });
    }
}

function onBonusProductsViewBeforeClose(data) {
    bonusProductsView.getGWPBanner();

    if (data.isAddedPopup) {
        if (!onCart) {
            getMiniCart({displayGwpToast: data.displayGwpToast});
        }
        return;
    }

    if (data.giftChange || giftAddClicked || onCart) {
        return;
    }

    getMiniCart({displayGwpToast: data.displayGwpToast});
}

function showGwpToastMessage() {
    actionQueue.addToQueue(function() {
        toaster.load({
            url: Urls.GetGwpToastBanner,
            close: function() {
                const isCartPage = $('.pt_cart').length > 0;
                if (isCartPage) {
                    location.reload();
                }
            }
        });
    }, 4500);
}

function hideSameNumOfGifts() {
    //checking if gwp contains any items
    if ($('.js-gwp-promotions').children().length !== 0) {
        newValue = $('.js-gwp-promotions').children().length;
        //if the num of items is the same
        if (previousValue === newValue) {
            $('.gwp-minicart-wrapper .approaching-header').addClass('hide');
            $('.gwp-minicart-wrapper .js-gwp-promotions').addClass('hide');
        //if the new item is added and number increased
        } else if (previousValue < newValue) {
            $('.gwp-minicart-wrapper .approaching-header').removeClass('hide');
            $('.gwp-minicart-wrapper .js-gwp-promotions').removeClass('hide');
            setTimeout(function() {
                //show only newly added gift
                $('.gwp-minicart-wrapper .js-gwp-promotions').each(function() {
                    $(this).children().addClass('hide');
                    $(this).children().last().removeClass('hide');
                });
            }, 250);
        }
        //setting the current num of items
        previousValue = newValue;
    }
}

module.exports = bonusProductsView;

},{"./actionQueue":266,"./components/products/product-choice-list/product-choice-list.vue":403,"./dialog":422,"./grid":437,"./minicart":446,"./modules/helpers/scroll":475,"./modules/util/ajaxUrl":478,"./modules/util/appendParamsToUrl":480,"./modules/util/isMobileWidth":499,"./page":518,"./pages/checkout/singlepagecheckout":528,"./toaster":605}],277:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax');
const damHelper = require('./dam/dam-helper');
const selectors = {
    SWATCH_BTN: '.js-product-swatches-btn',
    TILE: '.js-product-tile',
    TILE_IMAGE_HOLDER: '.js-product-tile-image',
    TILE_IMAGE: '.js-defered-image',
    TILE_PRODUCT_LINK: '.js-product-name-link',
    OUT_OF_STOCK_BUTTON: '.js-out-of-stock-button',
    OUT_OF_STOCK_WRAP:'.js-out-of-stock-wrap',
    TILE_PERSONALIZE_BUTTON: '.js-btn-tile-personalise',
    CART_BUTTON: '.js-add-to-cart',
    CHILD_IDS: 'input[name="childPids"]',
    USER_ACTIONS: '.js-product-user-actions',
    SWATCHES_LIST: '.js-product-swatches-list',
    RITUALS_FORM: '.rituals-form',
    VARIATION_SWATCHES: '.js-variation-swatches',
    TILE_TITLE : '.js-product-name'
};

const classes = {
    SELECTED: 'selected',
    HIDE: 'hide',
    HIDE_AND_DISABLED: 'hide btn--disabled',
    FORM_WIDE: 'form-wide',
};

const bundleVariationSwatches = {
    init: initEvents
};

function initEvents() {
    $(document).on('click', selectors.SWATCH_BTN, function (e) {
        e.preventDefault();
        e.stopPropagation();

        const $parent = $(this).parent();
        if ($parent.hasClass(classes.SELECTED)) {
            return;
        }

        $parent.siblings().removeClass(classes.SELECTED);
        $parent.addClass(classes.SELECTED);

        updateTileValues($(this));
    });
}

function updateTileValues($swatch){
    const data = JSON.parse($swatch.attr('data'));
    const $tileholder = $swatch.closest(selectors.TILE);
    $tileholder.attr('data-href', data.url);

    updateTileImageAttributes($tileholder, data);
    updateTileHeadingAttributes($tileholder, data);
    updateTileDescriptionAttributes($tileholder, data);
    updateCartButton($tileholder, data);
    updateSocialCommerceElement($tileholder, data);
}

function updateSocialCommerceElement(tileElement, data) {
    const $socialCommerceButton = $('.js-social-commerce-button', tileElement);
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    const socialCommerceData = $socialCommerceButton.data('social-commerce');
    if (!socialCommerceData) {
        return;
    }

    let shouldHideSocialCommerceButton = false;

    if ($(selectors.SWATCHES_LIST + selectors.VARIATION_SWATCHES , tileElement).length) {
        shouldHideSocialCommerceButton = !data.isAvailable;
    } else {
        socialCommerceData.configurationId = data.configurationId;
        shouldHideSocialCommerceButton = shouldHideSocialCommerceButton || data.cartButtonAttributes.text;
    }

    $socialCommerceButton.data('social-commerce', socialCommerceData);

    if (shouldHideSocialCommerceButton) {
        $socialCommerceButton.parent().addClass('hide');
        return;
    }

    $socialCommerceButton.parent().removeClass('hide');
}

function updateTileImageAttributes(tileElement, data) {
    const $imageholder = $(tileElement).find(selectors.TILE_IMAGE_HOLDER);
    $imageholder.attr('href', data.url);
    $imageholder.attr('title', data.image.title);

    const $image = $('img', $imageholder);
    $image.css('max-width', data.image.maxWidth);
    $image.attr('data-src', data.image.src);
    $image.attr('src', data.image.src);
    $image.attr('alt', data.image.alt);
    damHelper.updateImages($imageholder);
}

function updateTileHeadingAttributes(tileElement, data) {
    const $productName = tileElement.find(selectors.TILE_PRODUCT_LINK);
    $productName.attr('href', data.url);
}

function updateTileDescriptionAttributes(tileElement, data) {
    if (data.description){
        const $description = tileElement.find('.short-description');
        $description.text(data.description);
    }

    const $showMoreLink = tileElement.find('read-more-link');

    if ($showMoreLink.length > 0) {
        $showMoreLink.attr('href', data.url);
    }
}

function updateCartButton(tileElement, data) {
    const nonBundleSwatches = $(selectors.SWATCHES_LIST + selectors.VARIATION_SWATCHES , tileElement);
    if (nonBundleSwatches.length) {
        const $updateTarget = $(selectors.RITUALS_FORM, tileElement);
        ajax.load({
            url: data.addToCartUrl,
            target: $updateTarget,
            replaceTarget: false,
        });
        return;
    }

    $(selectors.CHILD_IDS, tileElement).val(data.cartButtonAttributes.childIds);
    $('.js-product-configurator-trigger', tileElement).data('product-configuration', JSON.parse(data.cartButtonAttributes.dataProductConfiguration));

    if (data.cartButtonAttributes.text) {
        $(selectors.OUT_OF_STOCK_BUTTON, tileElement).text(data.cartButtonAttributes.text);
        disableCartButton(tileElement);
        return;
    }
    enableCartButton(tileElement);
}

function disableCartButton(tileElement) {
    $(selectors.OUT_OF_STOCK_WRAP + '.hide', tileElement).removeClass(classes.HIDE);
    $(selectors.TILE_PERSONALIZE_BUTTON, tileElement).addClass(classes.HIDE);
    $(selectors.CART_BUTTON, tileElement).addClass(classes.HIDE_AND_DISABLED);
    $(selectors.USER_ACTIONS, tileElement).addClass(classes.FORM_WIDE);
}

function enableCartButton(tileElement) {
    $(selectors.OUT_OF_STOCK_WRAP, tileElement).addClass(classes.HIDE);
    $(selectors.TILE_PERSONALIZE_BUTTON + '.hide', tileElement).removeClass(classes.HIDE);
    $(selectors.CART_BUTTON + '.hide', tileElement).removeClass(classes.HIDE_AND_DISABLED);
    $(selectors.USER_ACTIONS, tileElement).removeClass(classes.FORM_WIDE);
}

module.exports = bundleVariationSwatches;

},{"./dam/dam-helper":419,"./modules/ajax":449}],278:[function(require,module,exports){
'use strict';

require('../app');

},{"../app":273}],279:[function(require,module,exports){
'use strict';
const gtm = require('./modules/google').tagManager;

const categoryRefinements = {
    init: function () {
        // Binds a 'click' event to the refinemets menu dropdown on COP page
        $(document).on('click', '.js-refinebar-dropdown-btn', function(e){
            e.preventDefault();
            $('.js-refinements-bar').toggleClass('open');
            $('.js-refinebar-dropdown, .js-category-refinement').slideToggle();
        });

        $(document).on('click', '.js-refinements-bar', function(e){
            const categoryPath = $(e.target).data('category');

            if (categoryPath !== undefined && categoryPath !== null) {
                gtm.pushNavigationMenuChanges(categoryPath);
            }
        });
    }
};

module.exports = categoryRefinements;

},{"./modules/google":453}],280:[function(require,module,exports){
'use strict';

let config = {};

function handleCtaClick(usePersonalizedName) {
    if (config.addToCartButton) {
        const $addToCartButton = $(config.addToCartButton);
        const $personalizeNameHiddenField = $('input[name="personalizedName"]', $addToCartButton.closest('.product-add-to-cart'));

        if (usePersonalizedName) {
            $personalizeNameHiddenField.val($('#personalizedName').val());
        } else {
            $personalizeNameHiddenField.val('');
            $('#personalizedName').val('');
        }

        $addToCartButton.trigger('click', true);
        return;
    }

    if (!usePersonalizedName) {
        $('#personalizedName').val('');
    }

    config.callback($('#personalizedName').val());
}

const certificateView = {
    show: function (data) {
        config = data;

        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                name: window.Resources.TALISMAN_POPUP_CERTIFICATE_NAME,
                heading: window.Resources.TALISMAN_POPUP_CERTIFICATE_HEADING,
                headingLarge: true,
                error: window.Resources.TALISMAN_POPUP_CERTIFICATE_ERROR,
                description: window.Resources.TALISMAN_POPUP_CERTIFICATE_DESCRIPTION,
                note: window.Resources.TALISMAN_POPUP_CERTIFICATE_NOTE,
                placeholder: window.Resources.TALISMAN_POPUP_CERTIFICATE_PLACEHOLDER
            },
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_SAVE,
                    eventName: 'onPrimaryButtonClick',
                    shouldCloseModal: true,
                    shouldBeValid: true
                },
                {
                    type: 'btn btn--secondary',
                    label: window.Resources.MODAL_SKIP,
                    eventName: 'onSecondaryButtonClick',
                    shouldCloseModal: true,
                }
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: false,
            certificateEdit: true,
            icon: 'ico karma-logo-small'
        });

        window.eventBus.$off('onPrimaryButtonClick').$on('onPrimaryButtonClick', function () {
            handleCtaClick(true);
        });

        window.eventBus.$off('onSecondaryButtonClick').$on('onSecondaryButtonClick', function () {
            handleCtaClick(false);
        });
    }
};

module.exports = certificateView;

},{}],281:[function(require,module,exports){
'use strict';

const page = require('./page'),
    appendParamToURL = require('./modules/util/appendParamToURL'),
    TPromise = require('promise');

let _currentCategory = '';
const MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    const $compareContainer = $('.compare-items');
    const $compareItems = $compareContainer.find('.compare-item');
    const numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}

/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    const $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }

        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active')
        .attr('data-uuid', data.uuid)
        .attr('data-itemid', data.itemid)
        .data('uuid', data.uuid)
        .data('itemid', data.itemid)
        .append($(data.img).clone().addClass('compare-item-image'));
}

/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) {
        return;
    }
    // remove class, data and id from item
    $item.removeClass('active')
        .removeAttr('data-uuid')
        .removeAttr('data-itemid')
        .data('uuid', '')
        .data('itemid', '')
        // remove the image
        .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    const promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    const promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        const $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            const $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            const $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active')
                    .attr('data-uuid', $next.data('uuid'))
                    .attr('data-itemid', $next.data('itemid'))
                    .data('uuid', $next.data('uuid'))
                    .data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    let promise;
    const $items = $('.compare-items .compare-item');
    const $cb = $(args.cb);
    const numActive = $items.filter('.active').length;

    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        const $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) { $cb[0].checked = true; }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) { $cb[0].checked = false; }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    const $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        const $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) {
            $cb[0].checked = false;
        }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) {
            $cb[0].checked = true;
        }
    });
}

function removeItem($item) {
    const uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: ($productTile.length === 0) ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    const $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    const $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        const $productTile = $('#' + $(this).data('uuid'));
        if ($productTile.length === 0) {
            return;
        }
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./modules/util/appendParamToURL":479,"./page":518,"promise":217}],282:[function(require,module,exports){
'use strict';

const {googleFieldMapping, irelandGoogleCountyFieldMapper} = require('./google-field-mapping-countries');

module.exports = {
    data() {
        return {
            autoComplete: null,
            addressFieldsHidden: true,
            enableEditShipping: false,
            enableEditBilling: false
        };
    },
    methods: {
        updateFieldValue(fieldId, value) {
            this.$store.commit('details/updateFieldValue', {formId: this.formId, fieldId, value});
            if (fieldId === 'ssn') {
                this.fillForm(value);
                return;
            }
            if (
                this.$store.getters['details/validateRGCInput'](this.formId) &&
                this.countryCode === 'NL' &&
                ((!this.enableEditShipping && this.formId === 'shippingAddress') ||
                    (!this.enableEditBilling && this.formId === 'billingAddress'))
            ) {
                this.getAddressByRGC(this.formId);
            }
        },
        getAddressByRGC(formId) {
            //rgc NL
            this.$store.dispatch('details/getAddressFromRGC', formId);
            this.addressFieldsHidden = false;
        },
        fillForm(value) {
            //ssn
            this.$store.dispatch('details/getAddressInfo', value);
        },
        layoutElements(elements) {
            const rows = [];
            elements.forEach((element) => {
                if (rows.length > element.position - 1) {
                    const row = rows[Math.floor(element.position - 1)];
                    row.push(element);
                    return;
                }

                rows.push([element]);
            });

            return rows;
        },
        fillAddress() {
            const place = this.autoComplete.getPlace();
            const mappedAddressFields = mapGoogleAddressFields(place.address_components, this.countryCode);

            for (const [fieldId, value] of Object.entries(mappedAddressFields)) {
                this.$store.commit('details/updateFieldValue', {
                    formId: this.formId,
                    fieldId,
                    value
                });
            }
            this.addressFieldsHidden = false;
        },
        initAutoComplete() {
            const addressSearchEl = document.getElementById(this.formId + '_addressSearch');
            if (!addressSearchEl) {
                this.autoComplete = null;
                return;
            }
            if (!this.autoComplete) {
                this.autoComplete = getAutocomplete(addressSearchEl, this.countryCode);
                this.autoComplete.addListener('place_changed', this.fillAddress);
            }
        },
        async initFieldsHK() {
            await this.$store.dispatch('details/setCityHK', this.formId);
            await this.$store.dispatch('details/setDistrictHK', this.formId);
            await this.$store.dispatch('details/setSubdistrictHK', this.formId);
        },
        formatAddress(addressFieldValues, format, addressFieldValueReplacement) {
            let formated = format;
            Object.keys(addressFieldValues).forEach((key) => {
                if (formated.includes('$' + key + '$')) {
                    const data =
                        addressFieldValueReplacement &&
                        addressFieldValueReplacement[key] &&
                        addressFieldValueReplacement[key][addressFieldValues[key]]
                            ? addressFieldValueReplacement[key][addressFieldValues[key]]
                            : addressFieldValues[key];
                    formated = formated.replace('$' + key + '$', data);
                }
            });

            return formated
                .trim()
                .replaceAll(/<br>\s*<br>/g, '<br>')
                .replace(/^<br>/, '');
        },
        getAddressById(addressId) {
            return this.$store.getters['addressBook/getAddressById'](addressId);
        },
        shouldShowHiddenFields(formRows) {
            const addressSearchIndex = formRows.findIndex((row) => row[0].id === 'addressSearch');
            const houseNumberExtensionIndex = formRows.findIndex((row) => row[0].id === 'addressSearchDummy');
            const index = addressSearchIndex !== -1 ? addressSearchIndex : houseNumberExtensionIndex;
            if (index === -1 && houseNumberExtensionIndex === -1) {
                return false;
            }

            return !formRows
                .slice(index + 1, formRows.length - 1)
                .some((row) =>
                    row.some(
                        (element) =>
                            (!!element.state.value && !element.attributes.readOnly) || element.validationErrors.length
                    )
                );
        }
    },
    computed: {
        isFormValidatedAndInvalid() {
            return this.$store.getters['details/isFormValidatedAndInvalid'](this.formId);
        },
        getCityHKValue() {
            if (this.countryCode !== 'HK') {
                return;
            }

            return this.$store.getters['details/getCityHKValue'](this.formId);
        },
        getDistrictHKValue() {
            if (this.countryCode !== 'HK') {
                return;
            }

            return this.$store.getters['details/getDistrictHKValue'](this.formId);
        }
    },
    watch: {
        isFormValidatedAndInvalid(isValidatedAndInvalid) {
            if (isValidatedAndInvalid && this.formRows) {
                this.addressFieldsHidden = this.shouldShowHiddenFields(this.formRows);
            }
        },
        getCityHKValue(newValue) {
            if (this.getCityHKValue && this.countryCode === 'HK' && newValue === this.getCityHKValue) {
                this.$store.dispatch('details/setDistrictHK', this.formId);
            }
        },
        getDistrictHKValue(newValue) {
            if (this.getDistrictHKValue && this.countryCode === 'HK' && newValue === this.getDistrictHKValue) {
                this.$store.dispatch('details/setSubdistrictHK', this.formId);
            }
        }
    },
    updated() {
        this.initAutoComplete();
    },
    mounted() {
        this.initAutoComplete();
        if (this.countryCode === 'HK') {
            this.initFieldsHK();
        }
    }
};

function getAutocomplete(element, country) {
    return new google.maps.places.Autocomplete(element, {
        types: ['address'],
        componentRestrictions: {country}
    });
}

function mapGoogleAddressFields(googleAddressFields, countryCode) {
    const countryMap = googleFieldMapping[countryCode] || googleFieldMapping['default'];
    const stateSelectorforCountries = ['US', 'IE'];
    return googleAddressFields.reduce((accumulator, currentField) => {
        const fieldId = countryMap[currentField.types[0]];
        const typeOfName =
            stateSelectorforCountries.indexOf(countryCode) >= 0 && (fieldId === 'stateUS' || fieldId === 'state')
                ? 'short_name'
                : 'long_name';

        if (!fieldId) {
            return accumulator;
        }

        let currentValue = currentField[typeOfName];
        if (countryCode === 'IE' && fieldId === 'state' && currentValue) {
            const potentialValue = irelandGoogleCountyFieldMapper[currentValue.toUpperCase()];
            if (!potentialValue) {
                return accumulator;
            }
            currentValue = potentialValue;
        }

        accumulator[fieldId] = accumulator[fieldId] ? accumulator[fieldId] + ' ' + currentValue : currentValue;

        return accumulator;
    }, {});
}

},{"./google-field-mapping-countries":318}],283:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const VueInputButton = require('../../../vue-form/vue-input/inputs/vue-input-button.vue');
const VueForm = require('../../../vue-form/vue-form/vue-form.vue');
const AddressFormUtils = require('../../address-form-utils');

module.exports = {
    mixins: [AddressFormUtils],
    props: ['type'],
    computed: {
        ...mapState('details', {
            countryCode: state => state.countryCode,
            enterAddressCTA: state => state.resources.enterAddressCTA
        }),
        ...mapState('addressBook', ['resources']),
        ...mapGetters('details', ['isFormValid', 'getFormAsJSON',
            'firstInvalidShippingElementId', 'firstInvalidBillingElementId']),
        elementIndexes() {
            return {
                salutation: this.formElements.findIndex(element => element.id === 'salutation'),
                addressSearch: this.formElements.findIndex(element => element.id === 'addressSearch'),
                saveAddress: this.formElements.findIndex(element => element.id === 'saveAddress')
            };
        },
        nameElements() {
            return this.elementIndexes.addressSearch !== -1
                ? this.formElements.slice(this.elementIndexes.salutation, this.elementIndexes.addressSearch)
                : this.formElements.slice(this.elementIndexes.salutation, this.elementIndexes.saveAddress);
        },
        addressSearchElement() {
            return this.elementIndexes.addressSearch !== -1
                ? this.formElements[this.elementIndexes.addressSearch]
                : null;
        },
        hiddenElements() {
            return this.elementIndexes.addressSearch !== -1
                ? this.formElements.slice(this.elementIndexes.addressSearch + 1, this.elementIndexes.saveAddress)
                : null;
        },
        saveAddressElement() {
            return this.elementIndexes.saveAddress
                ? this.formElements[this.elementIndexes.saveAddress]
                : null;
        }
    },
    methods: {
        cancel() {
            window.eventBus.$emit('flyinClosed', 'addNewAddress');
        },
        async useThisAddress() {
            this.$store.commit('details/validateForm', this.formId);
            const isValid = this.isFormValid(this.formId);
            if (!isValid) {
                this.addressFieldsHidden = false;
                const elementId = this.formId === 'shippingAddress'
                    ? this.firstInvalidShippingElementId
                    : this.firstInvalidBillingElementId;
                if (elementId) {
                    document.getElementById(elementId).scrollIntoView({
                        behavior: 'smooth', block: 'start'
                    });
                }

                return;
            }
            this.showSpinner = true;
            const address = this.getFormAsJSON(this.formId);
            if (address.saveAddress) {
                this.$store.dispatch('addressBook/createAddress', { address, type: this.type }).finally(() => {
                    window.eventBus.$emit('flyinClosed', 'addNewAddress');
                    window.eventBus.$emit('flyinClosed', 'addressBook');
                });
                return;
            }
            const newAddress = {
                fieldValues: address,
                id: 'temporary' + this.type,
                temporary: true
            };
            this.$store.commit('addressBook/addAddress', newAddress);
            this.$store.commit('addressBook/selectAddress', { type: this.type, addressId: newAddress.id });
            await this.$store.dispatch('addressBook/updateSelectedAddress', { type: this.type, addressId: newAddress.id, tempAddress: newAddress.fieldValues });
            this.showSpinner = false;
            window.eventBus.$emit('flyinClosed', 'addNewAddress');
            window.eventBus.$emit('flyinClosed', 'addressBook');
        }
    },
    data() {
        const formId = 'billingAddress';
        const details = this.$store.state.details;
        const formElements = details.forms[formId].formElements || [];
        const showSpinner = false;
        return {
            formId, formElements, showSpinner
        };
    },
    mounted() {
        const elementIds = this.nameElements.map(element => element.id).concat(
            this.hiddenElements.map(element => element.id),
            [this.saveAddressElement.id]
        );

        this.$store.commit('details/clearElements', { formId: this.formId, elementIds });
    },
    components: {
        VueForm, VueInput, VueInputButton
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(" "+_vm._s(_vm.resources.flyIn.addNewHeading))])]),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c('vue-form',{attrs:{"name":"new-address"}},[_vm._l((_vm.nameElements),function(element){return _c('div',{key:element.id,staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})],1)}),_vm._v(" "),(_vm.addressSearchElement && _vm.addressFieldsHidden)?_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.addressSearchElement}})],1):_vm._e(),_vm._v(" "),(_vm.addressFieldsHidden && _vm.hiddenElements)?_c('div',{staticClass:"vue-form-row reveal-hidden",on:{"click":function($event){_vm.addressFieldsHidden = false}}},[_vm._v("\n            "+_vm._s(_vm.enterAddressCTA)+"\n            ")]):_vm._e(),_vm._v(" "),(!_vm.addressFieldsHidden && _vm.hiddenElements)?_vm._l((_vm.hiddenElements),function(element){return _c('div',{key:element.id,staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})],1)}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.saveAddressElement},on:{"blur":function($event){return _vm.updateFieldValue(_vm.saveAddressElement.id, $event.target.value)}}})],1)],2)],1),_vm._v(" "),_c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn btn--secondary",attrs:{"disabled":_vm.showSpinner},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.resources.flyIn.cancelCTA)+" ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.showSpinner},on:{"click":_vm.useThisAddress}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                "+_vm._s(_vm.resources.flyIn.useCTA)+"\n            ")]:_vm._e()],2)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e64895a", __vue__options__)
  } else {
    hotAPI.reload("data-v-2e64895a", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-form/vue-form.vue":406,"../../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../../vue-form/vue-input/vue-input.vue":415,"../../address-form-utils":282,"vue":262,"vue-hot-reload-api":257,"vuex":264}],284:[function(require,module,exports){
;(function(){
'use strict';

const {mapState} = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const VueInputButton = require('../../../vue-form/vue-input/inputs/vue-input-button.vue');
const VueForm = require('../../../vue-form/vue-form/vue-form.vue');
const AddressFormUtils = require('../../address-form-utils');
const {validateElement} = require('../../../vue-form/vue-input/libs/validator');
const _ = require('lodash');

module.exports = {
    mixins: [AddressFormUtils],
    props: ['addressId', 'type'],
    computed: {
        ...mapState('details', ['countryCode']),
        ...mapState('addressBook', ['resources']),
    },
    methods: {
        cancel() {
            window.eventBus.$emit('flyinClosed', 'editAddress');
        },
        async saveAndUse() {
            this.elements.forEach((element) => {
                element.validationErrors = validateElement(element);
            });
            const isValid = !this.elements.some((element) => element.validationErrors.length > 0);
            if (!isValid) {
                return;
            }

            const address = this.elements.reduce((result, element) => {
                result[element.id] = element.state.value;
                return result;
            }, {});
            address.ID = this.addressId;
            this.showSpinner = true;
            const result = await this.$store.dispatch('addressBook/editAddress', address);
            if (result) {
                this.$store.commit('addressBook/selectAddress', {type: this.type, addressId: this.addressId});
                await this.$store.dispatch('addressBook/updateSelectedAddress', {type: this.type, addressId: this.addressId});
            }
            this.showSpinner = false;
            window.eventBus.$emit('flyinClosed', 'editAddress');
            window.eventBus.$emit('flyinClosed', 'addressBook');
        },
        updateValue(id, value) {
            const element = this.elements.find((element) => element.id === id);
            if (!element) {
                return;
            }
            element.state.value = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;
            if (element.attributes.options && element.attributes.options.length) {
                element.state.selectedOption = element.attributes.options.find((option) => option.id === value);
            }
            element.state.__ob__.dep.notify(); // if the initial value === trimmed value the components won't be notified
            element.validationErrors = validateElement(element);
        }
    },
    data() {
        const currentLocaleAddressConfig = this.$store.state.details.countryCode === 'NL' ? 'addressSearchDummy' : 'addressSearch';
        let elements = _.cloneDeep(this.$store.state.details.forms.billingAddress.formElements);
        const salutationIndex = elements.findIndex((element) => element.id === 'salutation');
        const addressSearch = elements.findIndex((element) => element.id === currentLocaleAddressConfig);
        const saveAddressIndex = elements.findIndex((element) => element.id === 'saveAddress');
        const elementsCopy = [...elements.slice(salutationIndex, addressSearch), ...elements.slice(addressSearch + 1, saveAddressIndex)];

        // This will prevent duplicates because object keys are always unique
        const elementsObj = {};
        for (const element of elementsCopy) {
            elementsObj[element.id] = element;
        }

        // convert the object back to an array
        elements = Object.values(elementsObj);

        const address = this.$store.getters['addressBook/getAddressById'](this.addressId);

        elements.forEach((element) => {
            element.state.value = address.fieldValues[element.id] || '';

            if (element.id === 'stateUS' && address.fieldValues.stateCode) {
                element.state.value = address.fieldValues.stateCode;
            }

            if (element.id === 'state' && address.fieldValues.region) {
                element.state.value = address.fieldValues.region;
            }

            if (element.attributes.options && element.attributes.options.length) {
                element.state.selectedOption = element.attributes.options.find(
                    (option) => option.id === element.state.value
                );
            }
        });
        const showSpinner = false;
        return {
            elements, showSpinner
        };
    },
    components: {
        VueForm, VueInput, VueInputButton
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(" "+_vm._s(_vm.resources.flyIn.editHeading))])]),_vm._v(" "),_c('vue-form',{attrs:{"name":"new-address"}},[_c('div',{staticClass:"section-row"},_vm._l((_vm.elements),function(element){return _c('div',{key:element.id,staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":element},on:{"blur":function($event){return _vm.updateValue(element.id, $event.target.value)}}})],1)}),0)]),_vm._v(" "),_c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn btn--secondary",attrs:{"disabled":_vm.showSpinner},on:{"click":_vm.cancel}},[_vm._v(" "+_vm._s(_vm.resources.flyIn.cancelCTA)+" ")]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.showSpinner},on:{"click":_vm.saveAndUse}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                "+_vm._s(_vm.resources.flyIn.saveAndUseCTA)+"\n            ")]:_vm._e()],2)])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-11dd767b", __vue__options__)
  } else {
    hotAPI.reload("data-v-11dd767b", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-form/vue-form.vue":406,"../../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../../vue-form/vue-input/libs/validator":413,"../../../vue-form/vue-input/vue-input.vue":415,"../../address-form-utils":282,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],285:[function(require,module,exports){
'use strict';

const { mapState } = require('vuex');
const damHelper = require('../../dam/dam-helper');
const ProductChoiceList = require('../products/product-choice-list/product-choice-list.vue');
const flyinId = 'bonusProductChoice';
const scrollHelper = require('../../modules/helpers/scroll');

module.exports = {
    computed: {
        ...mapState('bonusItems', ['resources', 'productsList'])
    },
    methods: {
        showBonusProductsFlyin() {
            scrollHelper.disableScroll();
            window.eventBus.$on('flyinClosed', (id) => {
                scrollHelper.enableScroll();
                if (flyinId === id) {
                    this.bonusProductPicked();
                }
            });
            window.eventBus.$emit('shouldOpenFlyin', {
                id: flyinId,
                content: ProductChoiceList,
                props: { resources: this.resources, products: this.productsList, onProductPicked: this.bonusProductPicked },
            });
        },
        bonusProductPicked(productId) {
            this.$store.dispatch('bonusItems/addBonusProductToBasket', productId || this.productsList[0].productID);
        },
        initImagesAndSlider() {
            damHelper.updateImages(document.getElementById('bonus-product-list'));
        }
    },
    mounted() {
        if (this.productsList && this.productsList.length) {
            this.showBonusProductsFlyin();
        }
    },
    watch: {
        productsList(productsList) {
            if (productsList && productsList.length) {
                this.showBonusProductsFlyin();
            }
        }
    }
};


},{"../../dam/dam-helper":419,"../../modules/helpers/scroll":475,"../products/product-choice-list/product-choice-list.vue":403,"vuex":264}],286:[function(require,module,exports){
'use strict';

const checkoutPlaceholderElementID = '#checkoutApp';

const checkoutApp = {
    init: () => {
        if (shouldInit()) {
            createCheckoutApp();
        }
    }
};

const shouldInit = () => {
    return document.querySelectorAll(checkoutPlaceholderElementID).length > 0;
};

const createCheckoutApp = () => {
    const TopErrorMessage = require('./top-error-message/top-error-message.vue');
    const Vue = require('vue');
    const store = require('./store/index');
    const OrderSummary = require('./order-summary/order-summary.vue');
    const OrderOverviewDesktop = require('./order-overview/order-overview-desktop.vue');
    const OrderOverviewMobile = require('./order-overview/order-overview-mobile.vue');
    const Delivery = require('./delivery/delivery.vue');
    const CustomerDetails = require('./details/details.vue');
    const Payments = require('./payments/payments-block.vue');
    const PlaceOrderBlock = require('./place-order/place-order-block.vue');
    const BonusProductUtil = require('./bonus-product-util');

    const InputFacade = require('vue-input-facade').default;
    Vue.use(InputFacade, {
        tokens: {
            '0': { pattern: /\d/ },
            'X': {
                pattern: /[0-9a-zA-Z]/,
                transform: (c) => c.toUpperCase()
            },
        }
    });

    return new Vue({
        el: checkoutPlaceholderElementID,
        store,
        components: {
            Delivery,
            CustomerDetails,
            OrderSummary,
            OrderOverviewDesktop,
            OrderOverviewMobile,
            Payments,
            TopErrorMessage,
            PlaceOrderBlock
        },
        mixins: [BonusProductUtil]
    });
};

module.exports = checkoutApp;

},{"./bonus-product-util":285,"./delivery/delivery.vue":305,"./details/details.vue":317,"./order-overview/order-overview-desktop.vue":323,"./order-overview/order-overview-mobile.vue":324,"./order-summary/order-summary.vue":327,"./payments/payments-block.vue":339,"./place-order/place-order-block.vue":340,"./store/index":349,"./top-error-message/top-error-message.vue":363,"vue":262,"vue-input-facade":258}],287:[function(require,module,exports){
'use strict';
const {mapGetters, mapState} = require('vuex');

module.exports = {
    computed: {
        ...mapGetters('delivery', [
            'selectedDeliveryMethod',
            'isPickupPersonValid',
            'isPostnummerValid',
            'isPickPostValid'
        ]),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        ...mapGetters('details', [
            'isFieldValid',
            'firstInvalidShippingElementId',
            'firstInvalidBillingElementId',
            'firstInvalidCompanyElementId',
            'getPlaceholderPhoneNumber'
        ]),
        ...mapState('delivery', {
            deliveryResources: 'resources',
            deliveryPostalCode: 'postalCode'
        }),
        ...mapState('details', {
            detailsEditMode: 'editMode',
            detailsResources: 'resources',
            isB2BSite: 'isb2b',
            loggedInCustomer: 'loggedInCustomer'
        }),
        ...mapState('delivery', ['deliverySummary', 'exclusionResults', 'isMember']),
        ...mapState('payments', [
            'environment',
            'clientKey',
            'locale',
            'countryCode',
            'readMode',
            'preselectedPaymentMethod',
            'selectedPaymentMethod',
            'payingFullAmountWithGiftcard',
            'setPaymentMethodError',
            'merchantIdentifier'
        ]),
        ...mapGetters('payments', ['giftcardOptionsField']),
        ...mapState('payments', {paymentsResources: 'resources'}),
        ...mapState('orderSummary', ['orderTotalsPriceForAdyen']),
        ...mapGetters('privacyConsent', {isPrivacyConsentValid: 'isValid'}),
        bankOptionsField() {
            return this.$store.getters['payments/bankOptionsField'](this.selectedPaymentMethod.type);
        }
    },
    methods: {
        validatePostal() {
            const isPostalValid = this.checkIfPostalIsValid();
            if (!isPostalValid) {
                this.$store.commit('delivery/setEditMode', true);
                this.$store.commit('details/addValidationError', {
                    formId: 'shippingAddress',
                    fieldId: 'postalCode',
                    error: this.detailsResources.postalDetailsError
                });
                this.$store.commit('delivery/addPostalCodeError', this.detailsResources.postalDeliveryError);
            }
            return isPostalValid;
        },
        validateDeliveryPostal() {
            const isPostalChanged = this.hasDeliveryPostalChanged();
            if (isPostalChanged) {
                this.$store.commit('delivery/setEditMode', true);
                this.$store.commit('details/addValidationError', {
                    formId: 'shippingAddress',
                    fieldId: 'postalCode',
                    error: this.deliveryResources.deliveryBlockSaveValidationWarning
                });
                this.$store.commit(
                    'delivery/addPostalCodeError',
                    this.deliveryResources.deliveryBlockSaveValidationWarning
                );
            }
            return isPostalChanged;
        },
        checkIfPostalIsValid() {
            return (
                !this.$store.getters['details/shippingPostalCodeValue'] ||
                this.$store.getters['details/shippingPostalCodeValue'] ===
                    this.$store.getters['delivery/postalCodeValue']
            );
        },
        hasDeliveryPostalChanged() {
            return this.deliveryPostalCode !== this.$store.getters['delivery/postalCodeValue'];
        },
        validateDetailsBlock() {
            if (!this.hasSavedAddress) {
                const guestResult = this.validateDetailsNoSavedAddressFlow();
                if (this.countryCode === 'US') {
                    const res = this.triggerDetailsEditModeError(guestResult);
                    if (res && res !== null) {
                        return res;
                    }
                }
                return guestResult;
            }

            const result = this.validateDetailsSavedAddressFlow();

            const res = this.triggerDetailsEditModeError(result);
            if (res && res !== null) {
                return res;
            }

            return result;
        },
        triggerDetailsEditModeError(result) {
            if (this.detailsEditMode) {
                this.$store.commit('details/setShowEditModeError', true);
            }

            if (this.detailsEditMode && result.isValid) {
                return {
                    isValid: false,
                    badElementId: 'detailsSection'
                };
            }
        },
        checkIfDetailsBlockIsValid() {
            if (this.hasSavedAddress) {
                return this.detailsEditMode
                    ? {
                          isValid: false,
                          badElementId: 'detailsSection'
                      }
                    : this.checkIfDetailsSavedAddressFlowIsValid();
            }

            if (this.selectedDeliveryMethod.id === 'homeDelivery') {
                const isPostalValid = this.checkIfPostalIsValid();
                if (!isPostalValid) {
                    return {
                        isValid: false,
                        badElementId: 'shippingAddress_postalCode'
                    };
                }
            }

            return this.checkIfDetailsNoSavedAddressFlowIsValid();
        },
        validateDetailsSavedAddressFlow() {
            this.$store.commit('details/validateForm', 'shippingAddress');
            this.$store.commit('details/validateForm', 'billingAddress');
            const deliveryResult = this.validateDeliveryBlock();
            if (!deliveryResult.isValid) {
                return deliveryResult;
            }
            return this.checkIfDetailsSavedAddressFlowIsValid();
        },
        checkIfDetailsSavedAddressFlowIsValid() {
            const isPhoneValid = this.isFieldValid('shippingAddress', 'phone');
            const isVatValid =
                this.isFieldValid('billingAddress', 'btwVatNumber') && this.isFieldValid('billingAddress', 'nifNumber');
            const badElementId = !isPhoneValid
                ? 'shippingAddress_phone'
                : !isVatValid
                ? 'billingAddress_btwVatNumber'
                : '';

            return {
                isValid: isPhoneValid && isVatValid,
                badElementId
            };
        },
        validateDetailsNoSavedAddressFlow() {
            this.$store.commit('details/validateForm', 'billingAddress');
            this.$store.commit('details/validateForm', 'shippingAddress');
            if (this.isB2BSite) {
                this.$store.commit('details/validateForm', 'companydetails');
            }
            const deliveryResult = this.validateDeliveryBlock();
            if (!deliveryResult.isValid) {
                return deliveryResult;
            }

            if (this.selectedDeliveryMethod.id === 'homeDelivery') {
                const isPostalValid = this.validatePostal();
                const isDeliveryPostalChanged = this.validateDeliveryPostal();
                if (isDeliveryPostalChanged) {
                    return {
                        isValid: false,
                        badElementId: 'deliverySection',
                        errorMessage: this.deliveryResources.deliveryBlockSaveValidationWarning
                    };
                } else if (!isPostalValid) {
                    return {
                        isValid: false,
                        badElementId: 'deliverySection',
                        errorMessage: this.deliveryResources.postalTopBanerError
                    };
                }
            }

            return this.checkIfDetailsNoSavedAddressFlowIsValid();
        },
        checkIfDetailsNoSavedAddressFlowIsValid() {
            const isBillingValid = this.$store.getters['details/isBillingValid'];
            const badElementId = isBillingValid ? '' : this.firstInvalidBillingElementId;
            if (this.selectedDeliveryMethod.id !== 'homeDelivery') {
                const isPhoneValid = this.isFieldValid('shippingAddress', 'phone');
                return {
                    isValid: isBillingValid && isPhoneValid,
                    badElementId: isPhoneValid ? badElementId : 'shippingAddress_phone'
                };
            }

            const isShippingValid = this.$store.getters['details/isShippingValid'];
            if (!isShippingValid) {
                return {
                    isValid: false,
                    badElementId: this.firstInvalidShippingElementId
                };
            }

            const isCompanyDetailsValid = this.$store.getters['details/isCompanyDetailsValid'];
            if (!isCompanyDetailsValid && this.isB2BSite) {
                return {
                    isValid: false,
                    badElementId: this.firstInvalidCompanyElementId
                };
            }

            return {
                isValid: isShippingValid && isBillingValid,
                badElementId
            };
        },
        validateDeliveryBlock() {
            this.$store.commit('delivery/validatePickupPerson');
            this.$store.commit('delivery/validatePostnummer');
            this.$store.commit('delivery/validatePickPost');
            if (
                (this.hasSavedAddress ||
                    (this.deliverySummary.hasLastOrder && this.deliverySummary.hasPostalCodePreApplied)) &&
                this.deliverySummary.editMode
            ) {
                this.$store.commit('delivery/setShowEditModeError', true);
            }

            return this.checkIfDeliveryBlockIsValid();
        },
        checkIfDeliveryBlockIsValid() {
            const isEditMode =
                !(
                    this.hasSavedAddress ||
                    (this.deliverySummary.hasLastOrder && this.deliverySummary.hasPostalCodePreApplied)
                ) || !this.deliverySummary.editMode;

            return {
                isValid:
                    this.selectedDeliveryMethod &&
                    this.selectedDeliveryMethod.selected &&
                    isEditMode &&
                    this.isPickupPersonValid &&
                    this.isPostnummerValid &&
                    this.isPickPostValid,
                badElementId: 'deliverySection'
            };
        },
        checkIfAllBlocksAreValid() {
            return this.checkIfDetailsBlockIsValid().isValid && this.checkIfDeliveryBlockIsValid().isValid;
        },
        submitDetails() {
            if (this.hasSavedAddress) {
                return this.$store.dispatch('details/submitMemberDetails');
            }

            return this.$store.dispatch('details/postForms');
        },
        scrollIntoSection(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        },
        validatePrivacyConsent() {
            this.$store.commit('privacyConsent/validate');
            if (this.isPrivacyConsentValid) {
                return {
                    isValid: true
                };
            }

            return {
                isValid: false,
                badElementId: 'privacyConsent'
            };
        },
        validatePaymentsBlock() {
            const isPaymentBlockValid = {
                isValid: false,
                badElementId: 'paymentsSection'
            };

            if (this.giftcardOptionsField && this.giftcardOptionsField.state.value) {
                return isPaymentBlockValid;
            }

            if (!this.isBankOptionsFieldValid()) {
                return isPaymentBlockValid;
            }

            if (
                !this.readMode &&
                this.preselectedPaymentMethod &&
                (['bcmc', 'scheme'].indexOf(this.selectedPaymentMethod.type) < 0 || this.payingFullAmountWithGiftcard)
            ) {
                this.$store.commit('payments/setShowEditModeError', true);
                return isPaymentBlockValid;
            }

            if (this.preselectedPaymentMethod) {
                this.$store.commit('payments/setShowEditModeError', false);
            }

            if (this.exclusionResults && this.exclusionResults.errorMessage) {
                this.$store.commit('error/setErrorMessage', this.exclusionResults.errorMessage, {root: true});
                return {
                    isValid: false,
                    badElementId: 'deliverySection'
                };
            }

            const validationResult = this.validateDetailsBlock();
            if (!validationResult.isValid) {
                this.$store.commit('details/setEditMode', true);
                this.$store.commit(
                    'error/setErrorMessage',
                    validationResult.errorMessage || this.paymentsResources.errors.missingFields,
                    {root: true}
                );
                this.$store.commit('payments/setPaymentMethodError', this.paymentsResources.errors.requiredFields);

                return {
                    isValid: false,
                    badElementId: 'detailsSection'
                };
            }

            this.$store.commit('error/setErrorMessage', null, {root: true});
            this.$store.commit('payments/setPaymentMethodError', null);

            return this.validatePrivacyConsent();
        },
        paymentMethodConfiguration() {
            return {
                clientKey: this.clientKey,
                environment: this.environment,
                locale: this.locale,
                priceAmount: this.orderTotalsPriceForAdyen.remainingAmountInSmallestUnit,
                priceCurrency: this.orderTotalsPriceForAdyen.currencyCode,
                countryCode: this.countryCode,
                merchantId: this.merchantIdentifier
            };
        },
        amazonPaymentDetails() {
            return {
                countryCode: this.countryCode,
                name:
                    this.deliverySummary.deliveryAddress.firstName +
                    ' ' +
                    this.deliverySummary.deliveryAddress.lastName,
                adressLine1: this.deliverySummary.deliveryAddress.address1,
                city: this.deliverySummary.deliveryAddress.city,
                postalCode: this.deliverySummary.deliveryAddress.postalCode,
                phoneNumber: this.phoneNumber || this.getPlaceholderPhoneNumber
            };
        },
        isBankOptionsFieldValid() {
            if (!this.bankOptionsField) {
                return true;
            }
            this.$store.commit('payments/validateForm', this.selectedPaymentMethod.type);
            return !!this.bankOptionsField.state.selectedOption;
        }
    }
};

},{"vuex":264}],288:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

const AddressOptionTile = require('./address-option-tile/address-option-tile.vue');
const VueInputButton = require('../../../../vue-form/vue-input/inputs/vue-input-button.vue');
const AddNewAddress = require('../../../address-forms/add-new-address/add-new-address.vue');

module.exports = {
    props: ['type'],
    computed: {
        ...mapState('addressBook', {
            defaultAddress: state => state.addresses.filter(address => address.isDefault),
            otherAddresses: state => state.addresses.filter(address => !address.isDefault),
            resources: state => state.resources
        }),
    },
    data() {
        return {
            addNewAddressButton: {
                element: {
                    attributes: {
                        label: 'Add new address'
                    },
                    id: 'apply',
                    elementType: 'input',
                    elementDataType: 'submit'
                }
            }
        };
    },
    methods: {
        showNewAddressForm() {
            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'addNewAddress',
                content: AddNewAddress,
                props: { type: this.type },
                store: this.$store
            });
        }
    },
    components: {
        AddressOptionTile, VueInputButton
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.flyIn.title))])]),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c('button',{staticClass:"btn btn-full-wdth btn-add",on:{"click":_vm.showNewAddressForm}},[_c('span',[_vm._v(_vm._s(_vm.resources.flyIn.addNewCTA))])])]),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.defaultAddressLabel))]),_vm._v(" "),(_vm.defaultAddress.length)?_c('div',{staticClass:"vertical-tile-list"},[_c('address-option-tile',{key:_vm.defaultAddress[0].id + _vm.type,attrs:{"option":_vm.defaultAddress[0],"isInFlyin":true,"type":_vm.type}})],1):_c('div',{staticClass:"inline-alert notify"},[_c('span',[_vm._v(_vm._s(_vm.resources.noDefaultAddressInfo))])])]),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.otherAddressesLabel))]),_vm._v(" "),(_vm.otherAddresses.length)?_c('div',{staticClass:"vertical-tile-list"},[_vm._l((_vm.otherAddresses),function(option){return [(!option.temporary)?_c('address-option-tile',{key:option.id + _vm.type,attrs:{"option":option,"isInFlyin":true,"type":_vm.type}}):_vm._e()]})],2):_c('div',{staticClass:"inline-alert notify"},[_c('span',[_vm._v(_vm._s(_vm.resources.noOtherAddressesInfo))])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-371497c7", __vue__options__)
  } else {
    hotAPI.reload("data-v-371497c7", __vue__options__)
  }
})()}

},{"../../../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../../address-forms/add-new-address/add-new-address.vue":283,"./address-option-tile/address-option-tile.vue":289,"vue":262,"vue-hot-reload-api":257,"vuex":264}],289:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');

const AddressFormUtils = require('../../../../address-form-utils');
const EditAddress = require('../../../../address-forms/edit-address/edit-address.vue');

module.exports = {
    mixins: [AddressFormUtils],
    props: ['option', 'isInFlyin', 'type'],
    computed: {
        ...mapGetters('addressBook', ['getSelectedAddressByType']),
        ...mapGetters('details', [
            'getStateOptions'
        ]),
        ...mapState('addressBook', {
            resources: state => state.resources,
            otherAddresses: state => state.addresses.filter(address => !address.isDefault)
        }),
        formatedAddress() {
            return this.formatAddress(
                this.option.fieldValues,
                this.resources.addressFormat,
                this.getStateOptions
            );
        },
        selected() {
            return this.option.selected;
        }
    },
    data() {
        return {
            inputId: this.option.id + this.type,
            inputName: this.isInFlyin ? 'address-option-flyin' : 'address-option',
            deleteMode: false
        };
    },
    methods: {
        toggleDelete() {
            this.deleteMode = !this.deleteMode;
        },
        updateSelectedAddress() {
            if (!this.selected) {
                this.$store.dispatch('addressBook/updateSelectedAddress', { addressId: this.option.id, type: this.type });
            }
        },
        setSelected() {
            if (!this.selected) {
                window.eventBus.$emit('shouldCloseFlyin');
                this.$store.commit('addressBook/selectAddress', { type: this.type, addressId: this.option.id });
            }
        },
        setDefault() {
            this.$store.dispatch('addressBook/setDefaultAddress', { type: this.type, addressId: this.option.id });
        },
        remove() {
            this.$store.dispatch('addressBook/deleteAddress', this.option.id);
        },
        edit(addressId) {
            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'editAddress',
                content: EditAddress,
                props: { addressId, type: this.type },
                store: this.$store
            });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['checkout-tile', {'has-footer': _vm.isInFlyin}]},[_c('div',{staticClass:"input-type-radio"},[_c('input',{attrs:{"type":"radio","id":_vm.inputId,"name":_vm.inputName},domProps:{"value":_vm.option.id,"checked":!_vm.isInFlyin || _vm.selected},on:{"click":function($event){_vm.setSelected(); _vm.updateSelectedAddress();}}}),_vm._v(" "),_c('label',{staticClass:"vue-form-group-label",attrs:{"for":_vm.inputId}},[_c('span',{staticClass:"body-text"},[_c('b',[_vm._v(_vm._s(_vm.option.fieldValues.firstName)+" "+_vm._s(_vm.option.fieldValues.lastName))]),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatedAddress)}})])]),_vm._v(" "),(_vm.isInFlyin)?_c('footer',{staticClass:"checkout-tile-footer"},[(!_vm.deleteMode)?_c('ul',[(!_vm.option.isDefault)?_c('li',{on:{"click":function($event){return _vm.setDefault()}}},[_c('a',[_vm._v(_vm._s(_vm.resources.setDefaultCTA))])]):_vm._e(),_vm._v(" "),(_vm.option.isDefault)?_c('li',[_vm._v(" ")]):_vm._e(),_vm._v(" "),_c('li',{on:{"click":_vm.toggleDelete}},[_c('a',[_vm._v(_vm._s(_vm.resources.deleteCTA))])]),_vm._v(" "),_c('li',[_c('a',{on:{"click":function($event){return _vm.edit(_vm.option.id)}}},[_vm._v(_vm._s(_vm.resources.editCTA))])])]):_vm._e(),_vm._v(" "),(_vm.deleteMode)?_c('ul',[_c('li',[_vm._v(_vm._s(_vm.resources.removeAddressWarning))]),_vm._v(" "),_c('li',{on:{"click":function($event){return _vm.remove()}}},[_c('a',[_vm._v(_vm._s(_vm.resources.confirmDeleteCTA))])]),_vm._v(" "),_c('li',{on:{"click":_vm.toggleDelete}},[_c('a',[_vm._v(_vm._s(_vm.resources.confirmCancelCTA))])])]):_vm._e()]):_vm._e()])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ff096d2", __vue__options__)
  } else {
    hotAPI.reload("data-v-3ff096d2", __vue__options__)
  }
})()}

},{"../../../../address-form-utils":282,"../../../../address-forms/edit-address/edit-address.vue":284,"vue":262,"vue-hot-reload-api":257,"vuex":264}],290:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');

const AddressOptionTile = require('./address-option-tile-list/address-option-tile/address-option-tile.vue');
const AddressOptionTileList = require('./address-option-tile-list/address-option-tile-list.vue');

module.exports = {
    props: ['headerLabel', 'type'],
    computed: {
        ...mapState('delivery', {
            resources: state => state.resources
        }),
        ...mapGetters('addressBook', ['getSelectedAddressByType']),
        address() {
            return this.getSelectedAddressByType(this.type);
        }
    },
    components: {
        AddressOptionTile
    },
    methods: {
        openFlyout() {
            this.$store.commit('addressBook/setSelectedAddress', this.type);
            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'addressBook',
                content: AddressOptionTileList,
                props: {type: this.type},
                store: this.$store
            });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v("\n    "+_vm._s(_vm.headerLabel || _vm.resources.pickAnAddressLabel)+"\n    "),_c('a',{staticClass:"section-link hide-on-mobile",attrs:{"title":"Select different address"},on:{"click":_vm.openFlyout}},[_vm._v(_vm._s(_vm.resources.pickAnAddressCTA))])]),_vm._v(" "),_c('div',{staticClass:"vertical-tile-list"},[(_vm.address)?_c('div',[_c('address-option-tile',{key:_vm.address.id,attrs:{"option":_vm.address,"isInFlyin":false,"type":_vm.type,"checked":true}})],1):_vm._e(),_vm._v(" "),_c('a',{staticClass:"section-link hide-on-tablet",attrs:{"title":"Select different address"},on:{"click":_vm.openFlyout}},[_vm._v(_vm._s(_vm.resources.pickAnAddressCTA))])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-075f2842", __vue__options__)
  } else {
    hotAPI.reload("data-v-075f2842", __vue__options__)
  }
})()}

},{"./address-option-tile-list/address-option-tile-list.vue":288,"./address-option-tile-list/address-option-tile/address-option-tile.vue":289,"vue":262,"vue-hot-reload-api":257,"vuex":264}],291:[function(require,module,exports){
'use strict';

const mapState = require('vuex').mapState;

const PickupPointPicker = require('./pickup-point-picker.vue');

const SERVICE_BOXBERRY = 'boxberry';

module.exports = {
    computed: {
        ...mapState('delivery', {
            selectedMethod: state => state.deliveryMethods.find(method => method.selected),
        }),
        isBoxberryPickupPointMethodSelected() {
            return this.selectedMethod && this.selectedMethod.service === SERVICE_BOXBERRY;
        }
    },
    methods: {
        showBoxberryPickupPointModal() {
            window.eventBus.$emit('shouldOpenModal', {
                content: PickupPointPicker,
                store: this.$store,
                modalLarge: true,
                centerOnMobile: true,
                customClass: 'boxberry-widget-wrapper'
            });
        },
        isBoxberryPickupPointMethod(method) {
            return method && method.service === SERVICE_BOXBERRY;
        }
    }
};

},{"./pickup-point-picker.vue":292,"vuex":264}],292:[function(require,module,exports){
;(function(){
'use strict';

const { mapState } = require('vuex');

const loadExternalScript = require('../../../../modules/util/loadScripts');

module.exports = {
    computed: {
        ...mapState('delivery', {
            pickupPointMethod: state => state.deliveryMethods.find(method => method.id === 'pickupPoint')
        })
    },
    mounted() {
        const self = this;
        /* eslint-disable camelcase */
        return loadExternalScript(self.pickupPointMethod.widget.url).then(
            function() {
                const options = {
                    settings: {
                        currency: 'Rub',
                        show_price: true,
                        full_widget: true,
                        select_click_point: false,
                        display: {
                            displayonpage: true,
                            element: 'boxberry_map',
                            height: '100%',
                            width: '100%',
                        },
                        widgettoken: self.pickupPointMethod.widget.token,
                        calculator: true,
                        mapprovider: 'osm',
                        maxweight: '',
                        returns_only: false,
                        fav_cities: [1, 4422],
                        lang: 'en',
                    },
                    parcel: {
                        ordersum: 500,
                        paysum: 500,
                        height: 50,
                        width: 50,
                        depth: 50,
                        weight: 1012,
                        type: 1,
                        insurance: 500,
                    },
                    location: {
                        country: '643',
                        city: 'Москва',
                    },
                };

                boxberry.open(self.onPickupPointSelected, options); /* eslint-disable-line no-undef */
            }
        );
        /* eslint-enable camelcase */
    },
    methods : {
        async onPickupPointSelected(pickupPoint) {
            if (pickupPoint) {
                this.$store.commit('delivery/selectDeliveryMethod', this.pickupPointMethod.id);
                await this.$store.dispatch('delivery/updateSelectedOptionAndMethod', {...pickupPoint.pointData, ...pickupPoint.price});
                window.eventBus.$emit('shouldCloseModal');
            }
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"boxberry-widget"}},[_c('div',{staticStyle:{"height":"73vh"},attrs:{"id":"boxberry_map"}})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2cf44d18", __vue__options__)
  } else {
    hotAPI.reload("data-v-2cf44d18", __vue__options__)
  }
})()}

},{"../../../../modules/util/loadScripts":503,"vue":262,"vue-hot-reload-api":257,"vuex":264}],293:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const DeliveryMethodTile = require('./delivery-method-tile/delivery-method-tile.vue');
const LoaderAnimation = require('../loader-animation/loader-animation.vue');

module.exports = {
    computed: {
        ...mapState('delivery', [
            'resources',
            'deliveryMethods',
            'loadingState'
        ]),
        ...mapGetters('delivery', ['hasEnabledDeliveryMethods']),
        methods() {
            return this.deliveryMethods.filter(method => method && Object.keys(method).length !== 0);
        },
        visible() {
            return this.loadingState || (this.$store.state.delivery.deliverySummary.editMode && this.hasEnabledDeliveryMethods);
        }
    },
    components: {
        DeliveryMethodTile,
        LoaderAnimation
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.pickADeliveryMethodLabel))]),_vm._v(" "),(!_vm.loadingState)?_c('div',{staticClass:"horizontal-tile-list"},_vm._l((_vm.methods),function(method){return _c('delivery-method-tile',{key:method.id,attrs:{"method":method}})}),1):_vm._e(),_vm._v(" "),(_vm.loadingState)?_c('loader-animation',{attrs:{"isHorizontal":true,"number":_vm.methods.length}}):_vm._e()],1):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-20d09c55", __vue__options__)
  } else {
    hotAPI.reload("data-v-20d09c55", __vue__options__)
  }
})()}

},{"../loader-animation/loader-animation.vue":307,"./delivery-method-tile/delivery-method-tile.vue":294,"vue":262,"vue-hot-reload-api":257,"vuex":264}],294:[function(require,module,exports){
;(function(){
'use strict';

const GiftwrappingUtils = require('../../giftwrapping-utils');
const BoxberryUtils = require('../../boxberry/boxberry-utils');
const { mapGetters } = require('vuex');

module.exports = {
    mixins: [GiftwrappingUtils, BoxberryUtils],
    props: ['method'],
    computed: {
        ...mapGetters('delivery', ['selectedDeliveryMethod']),
        selectedOption: function () { return this.method.options.find(option => option.selected); }
    },
    methods: {
        async setSelected() {
            if (!this.method.enabled || this.selectedDeliveryMethod && this.selectedDeliveryMethod.id === this.method.id) {
                return;
            }

            if (this.isBoxberryPickupPointMethod(this.method) && !this.selectedOption) {
                this.showBoxberryPickupPointModal();
            }

            this.$store.commit('delivery/selectDeliveryMethod', this.method.id);
            await this.$store.dispatch('delivery/updateSelectedOptionAndMethod');
            this.$store.commit('analytics/handleDeliveryInteraction', this.method.id);

            if (this.giftWrapData && this.giftWrapData.showGiftWrapMessage) {
                this.showGiftwrapInfoModal(this.giftWrapData.giftWrapModalText, this.giftWrapResources.giftWrapModalTitle, this.giftWrapResources.giftWrapModalButtonText);
            }
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.method)?_c('div',{staticClass:"checkout-tile"},[_c('div',{staticClass:"input-type-radio"},[_c('input',{attrs:{"type":"radio","id":_vm.method.id,"name":"delivery-method","disabled":!_vm.method.enabled},domProps:{"value":_vm.method.id,"checked":_vm.method.selected},on:{"click":function($event){return _vm.setSelected()}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.method.id}},[_c('span',{staticClass:"tile-type"},[_vm._v(_vm._s(_vm.method.methodLabel))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_vm._v(_vm._s(_vm.method.description))]),_vm._v(" "),_c('span',{staticClass:"method-price"},[_vm._v(_vm._s(_vm.selectedOption && _vm.selectedOption.price ? _vm.selectedOption.price : _vm.method.price))])])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-500bf40c", __vue__options__)
  } else {
    hotAPI.reload("data-v-500bf40c", __vue__options__)
  }
})()}

},{"../../boxberry/boxberry-utils":291,"../../giftwrapping-utils":306,"vue":262,"vue-hot-reload-api":257,"vuex":264}],295:[function(require,module,exports){
;(function(){
'use strict';

const { mapGetters, mapState } = require('vuex');

const BoxberryUtils = require('../boxberry/boxberry-utils');

const DeliveryOptionTile = require('./delivery-option-tile/delivery-option-tile.vue');
const DeliveryOptionTileListFull = require('./delivery-option-tile-list-all.vue');
const LoaderAnimation = require('../loader-animation/loader-animation.vue');

module.exports = {
    mixins: [BoxberryUtils],
    computed: {
        ...mapGetters('delivery', ['selectedDeliveryMethod']),
        ...mapState('delivery', {
            resources: state => state.resources,
            loadingState: state => state.loadingState
        }),
        shouldShowPickADeliveryOption() {
            return !this.loadingState && (this.isBoxberryPickupPointMethodSelected || this.selectedDeliveryMethod.options.length > 3);
        }
    },
    components: {
        DeliveryOptionTile,
        LoaderAnimation
    },
    methods: {
        async openFlyIn() {
            if (this.selectedDeliveryMethod.id === 'pickupPoint' && this.selectedDeliveryMethod.getMoreEnabled) {
                const success = await this.$store.dispatch('delivery/getMorePickupPoints');
                if (!success) {
                    return;
                }
            }

            window.eventBus.$emit('shouldOpenFlyin', {
                content: DeliveryOptionTileListFull,
                store: this.$store
            });
        },
        openModalOrFlyIn() {
            return this.isBoxberryPickupPointMethodSelected ? this.showBoxberryPickupPointModal() : this.openFlyIn();
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.selectedDeliveryMethod.flyIn.title))])]),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-description"},[_vm._v(_vm._s(_vm.selectedDeliveryMethod.flyIn.description))]),_vm._v(" "),_c('div',{staticClass:"vertical-tile-list"},_vm._l((_vm.selectedDeliveryMethod.options),function(option){return _c('delivery-option-tile',{key:option.id,attrs:{"option":option,"methodId":_vm.selectedDeliveryMethod.id,"isInFlyin":true}})}),1)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-bce3835e", __vue__options__)
  } else {
    hotAPI.reload("data-v-bce3835e", __vue__options__)
  }
})()}

},{"../boxberry/boxberry-utils":291,"../loader-animation/loader-animation.vue":307,"./delivery-option-tile-list-all.vue":295,"./delivery-option-tile/delivery-option-tile.vue":298,"vue":262,"vue-hot-reload-api":257,"vuex":264}],296:[function(require,module,exports){
;(function(){
'use strict';

const { mapGetters, mapState } = require('vuex');

const BoxberryUtils = require('../boxberry/boxberry-utils');

const DeliveryOptionTile = require('./delivery-option-tile/delivery-option-tile.vue');
const DeliveryOptionTileListFull = require('./delivery-option-tile-list-all.vue');
const LoaderAnimation = require('../loader-animation/loader-animation.vue');

module.exports = {
    mixins: [BoxberryUtils],
    computed: {
        ...mapGetters('delivery', ['selectedDeliveryMethod']),
        ...mapState('delivery', {
            resources: state => state.resources,
            loadingState: state => state.loadingState
        }),
        shouldShowPickADeliveryOption() {
            return !this.loadingState && (this.isBoxberryPickupPointMethodSelected || this.selectedDeliveryMethod.options.length > 3);
        }
    },
    components: {
        DeliveryOptionTile,
        LoaderAnimation
    },
    methods: {
        async openFlyIn() {
            if (this.selectedDeliveryMethod.id === 'pickupPoint' && this.selectedDeliveryMethod.getMoreEnabled) {
                const success = await this.$store.dispatch('delivery/getMorePickupPoints');
                if (!success) {
                    return;
                }
            }

            window.eventBus.$emit('shouldOpenFlyin', {
                content: DeliveryOptionTileListFull,
                store: this.$store
            });
        },
        openModalOrFlyIn() {
            return this.isBoxberryPickupPointMethodSelected ? this.showBoxberryPickupPointModal() : this.openFlyIn();
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v("\n    "+_vm._s(_vm.resources.pickADeliveryOptionLabel)+"\n    "),(_vm.shouldShowPickADeliveryOption)?_c('a',{staticClass:"section-link hide-on-mobile",attrs:{"title":_vm.resources.pickADeliveryOptionCTA},on:{"click":function($event){return _vm.openModalOrFlyIn()}}},[_vm._v("\n      "+_vm._s(_vm.resources.pickADeliveryOptionCTA)+"\n    ")]):_vm._e()]),_vm._v(" "),(_vm.resources.unavailableMessage)?_c('div',{staticClass:"inline-alert error"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.resources.unavailableMessage)}})]):_vm._e(),_vm._v(" "),(!_vm.loadingState)?_c('div',{staticClass:"vertical-tile-list"},[_vm._l((_vm.selectedDeliveryMethod.options.slice(0, 3)),function(option){return _c('delivery-option-tile',{key:option.id,attrs:{"option":option,"methodId":_vm.selectedDeliveryMethod.id}})}),_vm._v(" "),(_vm.shouldShowPickADeliveryOption)?_c('a',{staticClass:"section-link hide-on-tablet",attrs:{"title":"Select different delivery option"},on:{"click":function($event){return _vm.openModalOrFlyIn()}}},[_vm._v("\n      "+_vm._s(_vm.resources.pickADeliveryOptionCTA)+"\n    ")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.loadingState)?_c('loader-animation',{attrs:{"number":3}}):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-14fd147d", __vue__options__)
  } else {
    hotAPI.reload("data-v-14fd147d", __vue__options__)
  }
})()}

},{"../boxberry/boxberry-utils":291,"../loader-animation/loader-animation.vue":307,"./delivery-option-tile-list-all.vue":295,"./delivery-option-tile/delivery-option-tile.vue":298,"vue":262,"vue-hot-reload-api":257,"vuex":264}],297:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    props: ['option'],
    computed: {
        description() {
            return this.option.description.replaceAll('<br>', ', ').replaceAll(/\s*,\s*/g, ', ');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.option.id}},[_c('span',{staticClass:"tile-title"},[_c('span',{staticClass:"icon logo-rituals"}),_vm._v(_vm._s(_vm.option.name))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_vm._v("\n      "+_vm._s(_vm.option.time)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"store-distance"},[_vm._v(" "+_vm._s(_vm.option.distance))]),_vm._v(" "),_c('a',{staticClass:"store-maps-link",attrs:{"href":_vm.option.directions.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.option.directions.title))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-901721a0", __vue__options__)
  } else {
    hotAPI.reload("data-v-901721a0", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],298:[function(require,module,exports){
;(function(){
'use strict';

const mapGetters = require('vuex').mapGetters;

const HomeDeliveryOptionTile = require('./home-delivery-option-tile/home-delivery-option-tile.vue');
const ClickAndCollectOptionTile = require('./click-and-collect-option-tile/click-and-collect-option-tile.vue');
const PickupPointOptionTile = require('./pickup-point-option-tile/pickup-point-option-tile.vue');

module.exports = {
    props: ['option', 'methodId', 'isInFlyin'],
    computed: {
        ...mapGetters('delivery', ['selectedDeliveryOption']),
        optionTileType() {
            switch (this.methodId) {
                case 'homeDelivery':
                    return HomeDeliveryOptionTile;
                case 'pickupPoint':
                    return PickupPointOptionTile;
                case 'pickupInStore':
                    return ClickAndCollectOptionTile;
                default:
                    return;
            }
        }
    },
    data() {
        return {
            inputId: this.option.id,
            inputName: this.isInFlyin ? 'delivery-option-flyin' : 'delivery-option'
        };
    },
    methods: {
        setSelected() {
            if (this.selectedDeliveryOption && this.selectedDeliveryOption.id === this.option.id) {
                return;
            }

            window.eventBus.$emit('shouldCloseFlyin');
            this.$store.commit('delivery/selectDeliveryOption', this.option.id);
            this.$store.dispatch('delivery/updateSelectedOptionAndMethod');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-tile"},[_c('div',{staticClass:"input-type-radio"},[_c('input',{attrs:{"type":"radio","id":_vm.inputId,"name":_vm.inputName},domProps:{"value":_vm.option.id,"checked":_vm.option.selected},on:{"click":function($event){return _vm.setSelected()}}}),_vm._v(" "),_c(_vm.optionTileType,{tag:"component",attrs:{"option":_vm.option,"methodId":_vm.methodId,"isInFlyin":_vm.isInFlyin}})],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-298fbd0e", __vue__options__)
  } else {
    hotAPI.reload("data-v-298fbd0e", __vue__options__)
  }
})()}

},{"./click-and-collect-option-tile/click-and-collect-option-tile.vue":297,"./home-delivery-option-tile/home-delivery-option-tile.vue":299,"./pickup-point-option-tile/pickup-point-option-tile.vue":300,"vue":262,"vue-hot-reload-api":257,"vuex":264}],299:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    computed: mapState('delivery', {
        resources: state => state.resources,
    }),
    props: ['option', 'isInFlyin'],
    methods: {
        getDeliveryDescription() {
            if (this.isInFlyin) {
                return this.option.flyIn.description;
            }

            return this.option.description;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.option.id}},[_c('span',{staticClass:"tile-title"},[_c('span',{staticClass:"icon",class:_vm.option.cssClass}),_vm._v(_vm._s(_vm.option.name))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_c('span',[_vm._v(_vm._s(_vm.getDeliveryDescription()))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.isInFlyin)?_c('span',[_vm._v(_vm._s(this.option.flyIn.time))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"delivery-price"},[_vm._v(_vm._s(_vm.option.price))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-38de1a56", __vue__options__)
  } else {
    hotAPI.reload("data-v-38de1a56", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],300:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    props: ['option', 'isInFlyin'],
    computed: {
        description() {
            return this.option.description.replaceAll('<br>', ', ').replaceAll(/\s*,\s*/g, ', ');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.option.id}},[_c('span',{staticClass:"tile-title"},[_c('span',{staticClass:"icon icon-location-alt"}),_vm._v(_vm._s(_vm.option.name))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_vm._v("\n      "+_vm._s(_vm.description)+"\n      "),_c('br'),_vm._v(" "),_c('span',[_vm._v("\n        "+_vm._s(_vm.option.time)+"\n      ")])]),_vm._v(" "),_c('span',{staticClass:"store-distance"},[_vm._v(" "+_vm._s(_vm.option.distance))]),_vm._v(" "),_c('a',{staticClass:"store-maps-link",attrs:{"href":_vm.option.directions.url,"target":"_blank"}},[_vm._v(_vm._s(_vm.option.directions.title))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-19dd6cc4", __vue__options__)
  } else {
    hotAPI.reload("data-v-19dd6cc4", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],301:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    props: ['deliveryOption', 'title']
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deliveryOption)?_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_c('span',{staticClass:"icon logo-rituals"}),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.deliveryOption.name))]),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.deliveryOption.description)}})])]),_vm._v(" "),_c('span',{staticClass:"store-distance"},[_vm._v(" "+_vm._s(_vm.deliveryOption.distance))])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-02c7095f", __vue__options__)
  } else {
    hotAPI.reload("data-v-02c7095f", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],302:[function(require,module,exports){
;(function(){
'use strict';

const HomeDeliverySummary = require('./home-delivery-summary/home-delivery-summary.vue');
const PickupPointSummary = require('./pickup-point-summary/pickup-point-summary.vue');
const ClickAndCollectSummary = require('./click-and-collect-summary/click-and-collect-summary.vue');
const {mapState, mapGetters} = require('vuex');
const AddressFormUtils = require('../../address-form-utils');

module.exports = {

    mixins: [AddressFormUtils],
    computed: {
        ...mapState('delivery', {
            deliveryAddress: (state) => state.deliverySummary.deliveryAddress,
            resources: (state) => state.resources,
            disableEditMode: (state) => state.disableEditMode
        }),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        ...mapGetters('details', [
            'getFormAsJSON',
            'getStateOptions'
        ]),
        ...mapState('details', [
            'countryCode'
        ]),
        showDeliveryAddress() {
            return this.deliveryMethod.id === 'homeDelivery' && this.hasSavedAddress;
        },
        formatedAddress() {
            return this.formatAddress(
                this.deliveryAddress,
                this.resources.addressFormat,
                this.getStateOptions
            );
        },
        showDeliveryTemporaryAddressUS() {
            return this.deliveryMethod.id === 'homeDelivery' && this.formatedTemporaryAddressUS;
        },
        deliveryTemporaryAddressUS() {
            const deliveryAddress = this.getFormAsJSON();
            return deliveryAddress && deliveryAddress.postalCode ? deliveryAddress : '';
        },
        formatedTemporaryAddressUS() {
            if (this.countryCode !== 'US' || this.hasSavedAddress || !this.deliveryTemporaryAddressUS) {return false;}
            return this.formatAddress(
                this.deliveryTemporaryAddressUS,
                this.resources.addressFormat,
                this.getStateOptions
            );
        }
    },
    data() {
        const selectedDeliveryMethod = this.$store.getters['delivery/selectedDeliveryMethod'];
        return {
            deliveryMethod: selectedDeliveryMethod,
            deliveryOption: this.$store.getters['delivery/selectedDeliveryOption'],
            summaryType: getSummaryType(selectedDeliveryMethod.id),
        };
    }
};

function getSummaryType(selectedDeliveryMethodId) {
    switch (selectedDeliveryMethodId) {
        case 'pickupPoint':
            return PickupPointSummary;
        case 'pickupInStore':
            return ClickAndCollectSummary;
        default:
            return HomeDeliverySummary;
    }
}

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.deliveryMethod.methodLabel))]),_vm._v(" "),_c('span',{staticClass:"method-price"},[_vm._v(_vm._s(_vm.deliveryOption ? _vm.deliveryOption.price : _vm.deliveryMethod.price))])]),_vm._v(" "),(_vm.disableEditMode || (_vm.showDeliveryAddress && _vm.deliveryAddress))?_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.deliveryAddress.firstName)+" "+_vm._s(_vm.deliveryAddress.lastName))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatedAddress)}})]):_vm._e(),_vm._v(" "),(_vm.showDeliveryTemporaryAddressUS && _vm.deliveryTemporaryAddressUS)?_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.deliveryTemporaryAddressUS.firstName)+" "+_vm._s(_vm.deliveryTemporaryAddressUS.lastName))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatedTemporaryAddressUS)}})]):_vm._e(),_vm._v(" "),_c(_vm.summaryType,{tag:"component",attrs:{"deliveryOption":_vm.deliveryOption,"title":_vm.deliveryMethod.previewTitle}})],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-45d2fac2", __vue__options__)
  } else {
    hotAPI.reload("data-v-45d2fac2", __vue__options__)
  }
})()}

},{"../../address-form-utils":282,"./click-and-collect-summary/click-and-collect-summary.vue":301,"./home-delivery-summary/home-delivery-summary.vue":303,"./pickup-point-summary/pickup-point-summary.vue":304,"vue":262,"vue-hot-reload-api":257,"vuex":264}],303:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    props: ['deliveryOption', 'title']
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deliveryOption)?_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_c('span',{staticClass:"icon",class:_vm.deliveryOption.cssClass}),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.deliveryOption.name))]),_c('br'),_vm._v("\n          "+_vm._s(_vm.deliveryOption.description)+"\n      ")])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1b4acff6", __vue__options__)
  } else {
    hotAPI.reload("data-v-1b4acff6", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],304:[function(require,module,exports){
;(function(){
'use strict';

const { mapGetters } = require('vuex');

module.exports = {
    props: ['deliveryOption', 'title'],
    computed: {
        ...mapGetters('delivery', [
            'postnummer',
            'pickPost'
        ])
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.deliveryOption)?_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_c('span',{staticClass:"icon icon-location-alt"}),_vm._v(" "),_c('span',[_c('b',[_vm._v(_vm._s(_vm.deliveryOption.name))]),_c('br'),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.deliveryOption.description)}}),_c('br'),_vm._v(" "),(_vm.postnummer)?_c('span',[_vm._v(_vm._s(_vm.postnummer.dHLPostNummer))]):_vm._e(),_vm._v(" "),(_vm.pickPost)?_c('span',[_vm._v(_vm._s(_vm.pickPost.pickPostUserID))]):_vm._e()])]),_vm._v(" "),_c('span',{staticClass:"store-distance"},[_vm._v(" "+_vm._s(_vm.deliveryOption.distance))])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9f277366", __vue__options__)
  } else {
    hotAPI.reload("data-v-9f277366", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],305:[function(require,module,exports){
;(function(){
'use strict';

const {mapState, mapGetters} = require('vuex');
const PostalCodeForm = require('./postal-code-form/postal-code-form.vue');
const DeliveryMethodTileList = require('./delivery-method-tile-list/delivery-method-tile-list.vue');
const DeliveryOptionTileList = require('./delivery-option-tile-list/delivery-option-tile-list.vue');
const DeliverySummary = require('./delivery-summary/delivery-summary.vue');
const PickupPerson = require('./pickup-person/pickup-person.vue');
const AddressPicker = require('./address-picker/address-picker.vue');
const Postnummer = require('./postnummer-field/postnummer.vue');
const PickPost = require('./pick-post-field/pick-post.vue');
const GiftwrappingUtils = require('./giftwrapping-utils');
const BoxberryUtils = require('./boxberry/boxberry-utils');

module.exports = {
    mixins: [GiftwrappingUtils, BoxberryUtils],
    data() {
        return {
            useSameAsShippingBackup: true,
            postalCodeBackup: this.$store.getters['delivery/postalCodeValue'],
            selectedAddressBackup: this.$store.state.delivery.deliverySummary.deliveryAddress,
            selectedMethodIdBackup: this.$store.getters['delivery/selectedDeliveryMethod'].id,
            selectedOptionIdBackup: this.$store.getters['delivery/selectedDeliveryOption']
                ? this.$store.getters['delivery/selectedDeliveryOption'].id : '',
            pickupPersonBackup: {
                isSomeoneElse: false,
                firstName: '',
                lastName: ''
            },
            showSpinner: false
        };
    },
    computed: {
        ...mapState('delivery', [
            'resources',
            'deliverySummary',
            'postalCode',
            'isMember',
            'exclusionResults',
            'deliveryMethods',
            'showEditModeError',
            'skipPostalCode',
            'disableEditMode'
        ]),
        ...mapState('addressBook', ['addresses', 'selectedAddresses']),
        ...mapGetters('delivery', [
            'selectedDeliveryMethod',
            'selectedDeliveryOption',
            'isPickupPersonValid',
            'pickupPerson',
            'postalCodeValue',
            'isPostnummerValid',
            'isPostnummerExist',
            'isPickPostValid',
            'isPickPostExist'
        ]),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        editMode() {
            return this.$store.state.delivery.deliverySummary.editMode;
        },
        saveDeliveryValidation() {
            return this.postalCode == this.$store.getters['delivery/postalCodeValue'];
        },
        enableOptionsChanges() {
            const selectedDeliveryMethod = this.$store.getters['delivery/selectedDeliveryMethod'];
            return selectedDeliveryMethod && (selectedDeliveryMethod.options.length || this.isBoxberryPickupPointMethodSelected);
        },
        showExclusionError() {
            return Boolean(this.exclusionResults.errorMessage && this.exclusionResults.excludedPostal);
        },
        optionsSwitchVisible() {
            return this.editMode && this.deliveryMethods.some((x) => x.enabled);
        },
        shouldShowAddressPicker() {
            return this.editMode && this.selectedDeliveryMethod.id === 'homeDelivery'
                && this.hasSavedAddress && this.selectedDeliveryMethod.selected;
        },
        shouldShowEditModeButtons() {
            return !this.showExclusionError && this.editMode &&
                (this.hasSavedAddress || (this.deliverySummary.hasLastOrder && this.deliverySummary.hasPostalCodePreApplied));
        }
    },
    mounted() {
        if (this.giftWrapData && this.giftWrapData.showGiftWrapMessage) {
            this.showGiftwrapInfoModal(this.giftWrapData.giftWrapModalText, this.giftWrapResources.giftWrapModalTitle, this.giftWrapResources.giftWrapModalButtonText);
        }
        this.backupData();
        this.$store.commit('analytics/handleViewComponent', this.selectedDeliveryMethod.id);
        if (!this.editMode) {
            this.$store.commit('analytics/handleDeliveryInteraction', this.selectedDeliveryMethod.id);
        }
    },
    methods: {
        setEditMode(value) {
            this.$store.commit('delivery/setEditMode', value);
        },
        backupData() {
            this.postalCodeBackup = this.postalCodeValue;
            const selectedAddress = this.selectedAddresses && this.selectedAddresses.selectedShippingAddressId
                ? this.$store.getters['addressBook/getSelectedAddressByType']('shipping')
                : null;
            this.selectedMethodIdBackup = this.selectedDeliveryMethod ? this.selectedDeliveryMethod.id : '';
            this.selectedOptionIdBackup = this.selectedDeliveryOption ? this.selectedDeliveryOption.id : '';
            this.selectedAddressIdBackup = this.selectedAddresses ? this.selectedAddresses.selectedShippingAddressId : '';
            this.tempAddressBackup = selectedAddress && selectedAddress.temporary ? selectedAddress.fieldValues : null;
            this.pickupPersonBackup = {...this.pickupPerson};
        },
        async saveData() {
            this.showSpinner = true;
            this.$store.commit('delivery/validatePickupPerson');
            if (this.isPostnummerExist) {
                this.$store.commit('delivery/validatePostnummer');
            }
            if (this.isPickPostExist) {
                this.$store.commit('delivery/validatePickPost');
            }
            if (!this.isPickupPersonValid || !this.isPostnummerValid || !this.isPickPostValid) {
                this.showSpinner = false;
                return;
            }

            if (this.shouldShowAddressPicker) {
                const address = this.$store.getters['addressBook/getSelectedAddressByType']('shipping');
                const args = {
                    addressId: address.id, type: 'shipping',
                    recalculateTax: true
                };

                if (address.temporary) {
                    args.tempAddress = address.fieldValues;
                }

                const ok = await this.$store.dispatch('addressBook/updateSelectedAddress', args);
                if (!ok) {
                    this.showSpinner = false;
                    return;
                }
            }

            this.$store.dispatch('delivery/updatePickupPerson');
            if (this.isPostnummerExist) {
                this.$store.dispatch('delivery/updatePostnummer');
            }
            if (this.isPickPostExist) {
                this.$store.dispatch('delivery/updatePickPost');
            }
            this.showSpinner = false;
            this.$store.commit('delivery/setShowEditModeError', false);
            this.$store.commit('delivery/setEditMode', false);
            this.$store.commit('analytics/handleDeliveryInteraction', this.selectedDeliveryMethod.id);
            document.getElementById('deliverySection').scrollIntoView({
                behavior: 'smooth'
            });
        },
        async revertEdit() {
            if (this.postalCodeBackup !== this.postalCodeValue) {
                this.$store.commit('delivery/setPostalCode', this.postalCodeBackup);
                await this.$store.dispatch('delivery/submitPostalCode');
            }

            this.$store.commit('delivery/selectDeliveryMethod', this.selectedMethodIdBackup);
            this.$store.commit('delivery/selectDeliveryOption', this.selectedOptionIdBackup);

            this.$store.commit('delivery/setPickupPersonFieldValue', {
                fieldId: 'isSomeoneElse', value: this.pickupPersonBackup.isSomeoneElse
            });
            this.$store.commit('delivery/setPickupPersonFieldValue', {
                fieldId: 'firstName', value: this.pickupPersonBackup.firstName
            });
            this.$store.commit('delivery/setPickupPersonFieldValue', {
                fieldId: 'lastName', value: this.pickupPersonBackup.lastName
            });

            if (this.isPostnummerExist) {
                this.$store.commit('delivery/setPostnummerFieldValue', {
                    fieldId: 'postnummerValue', value: ''
                });
                await this.$store.dispatch('delivery/updatePostnummer');
            }
            if (this.isPickPostExist) {
                this.$store.commit('delivery/setPickPostFieldValue', {
                    fieldId: 'pickPostValue', value: ''
                });
                await this.$store.dispatch('delivery/updatePickPost');
            }
            await this.$store.dispatch('delivery/updateSelectedOptionAndMethod');

            if (this.selectedAddressIdBackup && this.selectedMethodIdBackup === 'homeDelivery') {
                const ok = await this.$store.dispatch('addressBook/updateSelectedAddress', {
                    addressId: this.selectedAddressIdBackup,
                    type: 'shipping',
                    tempAddress: this.tempAddressBackup
                });
                if (!ok) {
                    return;
                }
            }

            this.$store.commit('delivery/setEditMode', false);
        }
    },
    watch: {
        selectedDeliveryMethod(selectedMethod, previousSelectedMethod) {
            const sameAsShippingValue = selectedMethod.id !== 'homeDelivery' ? false : this.useSameAsShippingBackup;
            if (previousSelectedMethod.id === 'homeDelivery') {
                this.useSameAsShippingBackup = this.$store.getters['details/getFieldValue']('billingAddress', 'useSameAsShipping');
            }

            if (previousSelectedMethod.id === 'homeDelivery' && selectedMethod.id === 'homeDelivery') {
                return;
            }

            this.$store.commit('details/updateFieldValue', {
                formId: 'billingAddress', fieldId: 'useSameAsShipping', value: sameAsShippingValue
            });
        }
    },
    components: {
        PostalCodeForm,
        DeliverySummary,
        DeliveryMethodTileList,
        DeliveryOptionTileList,
        PickupPerson,
        Postnummer,
        PickPost,
        AddressPicker
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section",attrs:{"id":"deliverySection"}},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.blockLabel))]),_vm._v(" "),(!_vm.disableEditMode && !_vm.editMode && (!_vm.skipPostalCode || _vm.isMember))?_c('button',{staticClass:"btn btn--secondary",on:{"click":function($event){_vm.backupData(); _vm.setEditMode(true);}}},[_vm._v("\n      "+_vm._s(_vm.resources.editCTA)+"\n    ")]):_vm._e()]),_vm._v(" "),(!_vm.editMode)?_c('delivery-summary'):_vm._e(),_vm._v(" "),(_vm.editMode && !_vm.hasSavedAddress)?_c('postal-code-form'):_vm._e(),_vm._v(" "),_c('delivery-method-tile-list'),_vm._v(" "),(_vm.editMode && _vm.hasSavedAddress && !_vm.shouldShowAddressPicker)?_c('postal-code-form'):_vm._e(),_vm._v(" "),(_vm.shouldShowAddressPicker)?_c('address-picker',{attrs:{"type":'shipping'}}):_vm._e(),_vm._v(" "),(_vm.showExclusionError)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.exclusionResults.errorMessage))])])]):_vm._e(),_vm._v(" "),(_vm.resources.additionalDeliveryMessage)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert notify"},[_c('span',[_vm._v(_vm._s(_vm.resources.additionalDeliveryMessage))])])]):_vm._e(),_vm._v(" "),(!_vm.showExclusionError && _vm.editMode && _vm.enableOptionsChanges)?_c('delivery-option-tile-list'):_vm._e(),_vm._v(" "),(_vm.editMode && _vm.selectedDeliveryMethod.enabled && _vm.selectedDeliveryMethod.id === 'pickupPoint')?_c('pickup-person',{ref:"pickupPerson"}):_vm._e(),_vm._v(" "),(_vm.isPostnummerExist && _vm.editMode && _vm.selectedDeliveryMethod.enabled && _vm.selectedDeliveryMethod.id === 'pickupPoint')?_c('postnummer'):_vm._e(),_vm._v(" "),(_vm.isPickPostExist && _vm.editMode && _vm.selectedDeliveryMethod.enabled && _vm.selectedDeliveryMethod.id === 'pickupPoint')?_c('pick-post'):_vm._e(),_vm._v(" "),(_vm.shouldShowEditModeButtons)?_c('div',{staticClass:"section-row"},[(_vm.showEditModeError)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.saveDeliverySettingsWarning))])]):_vm._e(),_vm._v(" "),(!_vm.saveDeliveryValidation)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.deliveryBlockSaveValidationWarning))])])]):_vm._e(),_vm._v(" "),(_vm.editMode)?_c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn",attrs:{"disabled":!_vm.saveDeliveryValidation || _vm.showSpinner},on:{"click":_vm.saveData}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n            "+_vm._s(_vm.resources.saveDeliverySettingCTA)+"\n        ")]:_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"link",on:{"click":_vm.revertEdit}},[_vm._v(_vm._s(_vm.resources.cancelCTA))])]):_vm._e()]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d3e8858", __vue__options__)
  } else {
    hotAPI.reload("data-v-1d3e8858", __vue__options__)
  }
})()}

},{"./address-picker/address-picker.vue":290,"./boxberry/boxberry-utils":291,"./delivery-method-tile-list/delivery-method-tile-list.vue":293,"./delivery-option-tile-list/delivery-option-tile-list.vue":296,"./delivery-summary/delivery-summary.vue":302,"./giftwrapping-utils":306,"./pick-post-field/pick-post.vue":308,"./pickup-person/pickup-person.vue":309,"./postal-code-form/postal-code-form.vue":310,"./postnummer-field/postnummer.vue":311,"vue":262,"vue-hot-reload-api":257,"vuex":264}],306:[function(require,module,exports){
'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    computed: {
        ...mapState('orderSummary', {
            giftWrapResources: state => state.resources,
            giftWrapData: state => state.giftWrapData
        })
    },
    methods: {
        showGiftwrapInfoModal(giftWrapModalText, giftWrapModalTitle, giftWrapModalButtonText) {
            window.eventBus.$emit('shouldOpenModal', {
                resources: {
                    heading: giftWrapModalTitle,
                    headingLarge: true
                },
                paragraphs: [
                    {
                        text: giftWrapModalText
                    }
                ],
                buttons: [
                    {
                        type: 'btn',
                        label: giftWrapModalButtonText,
                        shouldCloseModal: true
                    }
                ],
                row: {
                    class: 'center-align'
                },
                closeElement: {
                    shouldCloseModal: true
                },
                ctaHolder: {},
                modalFullWidth: false,
                modalLarge: true
            });
        }
    }
};

},{"vuex":264}],307:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    props: ['isHorizontal', 'number'],
    data() {
        return {
            wrapperClass: this.isHorizontal ? 'horizontal' : 'vertical',
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.wrapperClass + '-tile-list']},_vm._l((_vm.number),function(index){return _c('div',{key:index,staticClass:"checkout-tile"},[_c('div',{staticClass:"skeleton-loader"},[_c('div',{class:['skeleton-mask', { 'square': _vm.isHorizontal }]})])])}),0)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-235c0782", __vue__options__)
  } else {
    hotAPI.reload("data-v-235c0782", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],308:[function(require,module,exports){
;(function(){
'use strict';


const { mapState, mapMutations } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    computed: {
        ...mapState('delivery', {
            pickPost: state => state.pickPost.pickPostValue,
            resources: state => state.pickPost.resources
        })
    },
    methods: {
        ...mapMutations('delivery', ['setPickPostFieldValue'])
    },
    components: { VueInput }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.updating)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"pickpost-form"},[_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('vue-input',{attrs:{"element":_vm.pickPost},on:{"blur":function($event){return _vm.setPickPostFieldValue({ fieldId: 'pickPostValue', value: $event.target.value })}}})],1)])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-ef2e3774", __vue__options__)
  } else {
    hotAPI.reload("data-v-ef2e3774", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257,"vuex":264}],309:[function(require,module,exports){
;(function(){
'use strict';


const { mapState, mapMutations } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    computed: mapState('delivery', {
        firstName: state => state.pickupPerson.firstName,
        lastName: state => state.pickupPerson.lastName,
        isSomeoneElse: state => state.pickupPerson.isSomeoneElse,
        resources: state => state.pickupPerson.resources,
        showPickupPersonBlock: state => state.pickupPerson.showPickupPersonBlock
    }),
    methods: {
        ...mapMutations('delivery', ['setPickupPersonFieldValue']),
    },
    components: { VueInput }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.updating && _vm.showPickupPersonBlock.state.value)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.isSomeoneElse},on:{"blur":function($event){return _vm.setPickupPersonFieldValue({ fieldId:'isSomeoneElse', value: $event.target.value })}}})],1),_vm._v(" "),(_vm.isSomeoneElse.state.value)?_c('div',{staticClass:"pickup-person-form"},[_c('span',{staticClass:"section-row-description"},[_vm._v(" "+_vm._s(_vm.resources.description))]),_vm._v(" "),_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('vue-input',{attrs:{"element":_vm.firstName},on:{"blur":function($event){return _vm.setPickupPersonFieldValue({ fieldId:'firstName', value: $event.target.value })}}}),_vm._v(" "),_c('vue-input',{attrs:{"element":_vm.lastName},on:{"blur":function($event){return _vm.setPickupPersonFieldValue({ fieldId:'lastName', value: $event.target.value })}}})],1)]):_vm._e()])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-df9cdde6", __vue__options__)
  } else {
    hotAPI.reload("data-v-df9cdde6", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257,"vuex":264}],310:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const GiftwrappingUtils = require('../giftwrapping-utils');

module.exports = {
    mixins: [GiftwrappingUtils],
    computed: {
        ...mapState('delivery', {
            heading: state => state.postalCodeForm.heading,
            fieldData: state => state.postalCodeForm.form.formElements[0],
            buttonData: state => state.postalCodeForm.form.actions[0]
        }),
        ...mapState('details', [
            'resources', 'countryCode'
        ]),
        ...mapGetters('details', [
            'updateFieldValue'
        ]),
        ...mapGetters('delivery', [
            'selectedDeliveryMethod', 'postalCodeValue'
        ]),
        ...mapGetters('addressBook', [
            'hasSavedAddress', 'removeValidationError'
        ]),
    },
    methods: {
        setPostalCode(postalCode) {
            this.$store.commit('delivery/setPostalCode', postalCode);
            if (this.fieldData.validationErrors.length > 0) {
                this.$store.commit('analytics/handleCheckoutFieldError', {section: 'delivery', message: this.fieldData.validationErrors[0]});
            }
        },
        resetAddressFields() {
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'houseNumber',
                value: ''
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'houseNumberExtension',
                value: ''
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'street',
                value: ''
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'city',
                value: ''
            });
        },
        removeAddrressFieldsErrors() {
            this.$store.commit('details/removeValidationError', {
                formId: 'shippingAddress',
                fieldId: 'houseNumber',
                error: this.resources.houseNumberMissingError
            });
            this.$store.commit('details/removeValidationError', {
                formId: 'shippingAddress',
                fieldId: 'street',
                error: this.resources.streetMissingError
            });
            this.$store.commit('details/removeValidationError', {
                formId: 'shippingAddress',
                fieldId: 'city',
                error: this.resources.cityMissingError
            });
        },
        async submitPostalCode() {
            await this.$store.dispatch('delivery/submitPostalCode');

            if (this.countryCode === 'NL' && this.selectedDeliveryMethod.id === 'homeDelivery' && !this.hasSavedAddress) {
                this.$store.commit('details/updateFieldValue', {
                    formId: 'shippingAddress',
                    fieldId: 'postalCode',
                    value: this.postalCodeValue
                });

                this.resetAddressFields();
                this.removeAddrressFieldsErrors();
            }

            if (this.giftWrapData && this.giftWrapData.showGiftWrapMessage) {
                this.showGiftwrapInfoModal(this.giftWrapData.giftWrapModalText, this.giftWrapResources.giftWrapModalTitle, this.giftWrapResources.giftWrapModalButtonText);
            }

            this.$store.commit('analytics/handleDeliveryInteraction', this.selectedDeliveryMethod.id);
        }
    },
    components: {
        VueInput
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.heading))]),_vm._v(" "),_c('form',{staticClass:"vue-form",attrs:{"method":'POST',"novalidate":"novalidate"},on:{"submit":function($event){$event.preventDefault();return _vm.submitPostalCode($event)}}},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('vue-input',{attrs:{"element":_vm.fieldData},on:{"input":function($event){return _vm.setPostalCode($event.target.value)}}}),_vm._v(" "),_c('vue-input',{attrs:{"element":_vm.buttonData}})],1)])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1d34273f", __vue__options__)
  } else {
    hotAPI.reload("data-v-1d34273f", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"../giftwrapping-utils":306,"vue":262,"vue-hot-reload-api":257,"vuex":264}],311:[function(require,module,exports){
;(function(){
'use strict';


const { mapState, mapMutations } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    computed: {
        ...mapState('delivery', {
            postnummer: state => state.postnummer.postnummerValue,
            resources: state => state.postnummer.resources
        })
    },
    methods: {
        ...mapMutations('delivery', ['setPostnummerFieldValue'])
    },
    components: { VueInput }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.updating)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"postnummer-form"},[_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('vue-input',{attrs:{"element":_vm.postnummer},on:{"blur":function($event){return _vm.setPostnummerFieldValue({ fieldId:'postnummerValue', value: $event.target.value })}}})],1)])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5c5c9a32", __vue__options__)
  } else {
    hotAPI.reload("data-v-5c5c9a32", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257,"vuex":264}],312:[function(require,module,exports){
;(function(){
'use strict';

const AddressFormUtils = require('../../address-form-utils');
const {mapGetters} = require('vuex');

module.exports = {
    mixins: [AddressFormUtils],
    props: ['addressId', 'addressFormat'],
    computed: {
        ...mapGetters('details', [
            'getStateOptions'
        ]),
        address() {
            return this.getAddressById(this.addressId);
        },
        formatedAddress() {
            return this.formatAddress(this.address.fieldValues, this.addressFormat, this.getStateOptions);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"address-summary"},[_c('span',[_vm._v(_vm._s(_vm.address.fieldValues.firstName)+" "+_vm._s(_vm.address.fieldValues.lastName)+" "),_c('br')]),_vm._v(" "),(_vm.address.fieldValues.companyName)?_c('span',[_vm._v(_vm._s(_vm.address.fieldValues.companyName)+" "),_c('br')]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.formatedAddress)}})])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a6e1ca3", __vue__options__)
  } else {
    hotAPI.reload("data-v-6a6e1ca3", __vue__options__)
  }
})()}

},{"../../address-form-utils":282,"vue":262,"vue-hot-reload-api":257,"vuex":264}],313:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const VueInputButton = require('../../../vue-form/vue-input/inputs/vue-input-button.vue');
const VueForm = require('../../../vue-form/vue-form/vue-form.vue');
const AddressPicker = require('../../delivery/address-picker/address-picker.vue');
const AddressSummary = require('../address-summary/address-summary.vue');
const AddressFormUtils = require('../../address-form-utils');

module.exports = {
    mixins: [AddressFormUtils],
    computed: {
        ...mapState('details', [
            'resources', 'countryCode', 'forms', 'isb2b'
        ]),
        ...mapState('addressBook', {
            addressBookResources: 'resources',
            selectedAddresses: state => state.selectedAddresses
        }),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        rowIndexes() {
            return {
                salutation: this.formRows.findIndex(row => row[0].id === 'salutation'),
                addressSearch: this.formRows.findIndex(row => row[0].id === 'addressSearch'),
                vat: this.formRows.findIndex(
                    row => row[0].id === 'btwVatNumber' || row[0].id === 'nifNumber'
                ),
                //used when hiding some rows, and not using or showing searchBar
                houseNumberExtension: this.formRows.findIndex(row => row[0].id === 'addressSearchDummy')
            };
        },
        noSavedBillingAddresUS() {
            return !this.selectedAddresses.selectedBillingAddressId && this.countryCode === 'US';
        },
        sameAsDeliveryAddress() {
            return this.formRows[0][0];
        },
        showNifNumber() {
            return this.formRows[10][0].state.value;
        },
        getFormField() {
            return formFieldsMapping[this.countryCode] || formFieldsMapping['default'];
        },
        namesRows() {
            return this.rowIndexes.addressSearch !== -1
                ? this.formRows.slice(this.rowIndexes.salutation, this.rowIndexes.addressSearch)
                : this.getFormField.namesRows(this.formRows, this.rowIndexes);
        },
        addressSearchRow() {
            return this.rowIndexes.addressSearch !== -1 ? this.formRows[this.rowIndexes.addressSearch] : null;
        },
        hiddenRows() {
            return this.rowIndexes[this.getFormField.addressSearchIndex] !== -1
                ? this.getFormField.hiddenRows(this.formRows, this.rowIndexes)
                : null;
        },
        vatRows() {
            const vatRows = this.rowIndexes.vat !== -1 ? this.formRows.slice(this.rowIndexes.vat) : null;
            const nifNumberIndex = vatRows ? vatRows.findIndex(row => row[0].id === 'nifNumber') : null;
            const addNifNumberIndex = vatRows ? vatRows.findIndex(row => row[0].id === 'addNifNumber') : null;

            if (this.isb2b) {
                if (nifNumberIndex && nifNumberIndex > -1) {
                    vatRows.splice(nifNumberIndex, 1);
                }

                if (addNifNumberIndex && addNifNumberIndex > -1) {
                    vatRows.splice(addNifNumberIndex, 1);
                }
            }

            if (nifNumberIndex && nifNumberIndex > -1 && !this.showNifNumber) {
                vatRows.splice(nifNumberIndex, 1);
                return vatRows;
            }
            return this.rowIndexes.vat !== -1 ? this.formRows.slice(this.rowIndexes.vat) : null;
        },
        isHomeDelivery() {
            const selectedMethod = this.$store.getters['delivery/selectedDeliveryMethod'];
            return selectedMethod && selectedMethod.id === 'homeDelivery';
        }
    },
    data() {
        const formElements = this.$store.state.details.forms.billingAddress.formElements;
        const formRows = this.layoutElements(formElements);
        const addressFieldsHidden = this.shouldShowHiddenFields(formRows);

        return {
            formRows,
            formId: 'billingAddress',
            addressFieldsHidden
        };
    },
    components: {
        VueForm, VueInput, VueInputButton, AddressPicker, AddressSummary
    },
};

// Temporary until the upcoming forms ticket is done
const formFieldsMapping = {
    'RU': {
        hiddenRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.addressSearch + 1, formRows.length),
        namesRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.addressSearch + 1, formRows.length),
        addressSearchIndex: 'addressSearch'
    },
    'NL': {
        hiddenRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.houseNumberExtension + 1, rowIndexes.vat),
        namesRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.salutation, rowIndexes.houseNumberExtension),
        addressSearchIndex: 'houseNumberExtension'
    },
    'default': {
        hiddenRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.addressSearch + 1, rowIndexes.vat),
        namesRows: (formRows, rowIndexes) => formRows.slice(rowIndexes.salutation, rowIndexes.vat),
        addressSearchIndex: 'addressSearch'
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"billing-details"},[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-row-header"},[_vm._v("\n            "+_vm._s(_vm.resources.billingAddressHeader)+"\n        ")]),_vm._v(" "),(_vm.isHomeDelivery)?_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.sameAsDeliveryAddress},on:{"blur":function($event){return _vm.updateFieldValue(_vm.sameAsDeliveryAddress.id, $event.target.value)}}})],1):_vm._e()]),_vm._v(" "),(!_vm.sameAsDeliveryAddress.state.value && (!_vm.hasSavedAddress || _vm.noSavedBillingAddresUS))?[_c('div',{staticClass:"section-row"},_vm._l((_vm.namesRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)}),0),_vm._v(" "),(_vm.addressSearchRow && _vm.addressFieldsHidden)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.addressSearchRow[0]}})],1)]):_vm._e(),_vm._v(" "),(_vm.hiddenRows && _vm.addressFieldsHidden)?_c('div',{staticClass:"reveal-hidden",on:{"click":function($event){_vm.addressFieldsHidden = false; _vm.enableEditBilling = true}}},[_vm._v("\n            "+_vm._s(_vm.resources.enterAddressCTA)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.hiddenRows && !_vm.addressFieldsHidden)?_c('div',{staticClass:"section-row"},_vm._l((_vm.hiddenRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)}),0):_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.sameAsDeliveryAddress.state.value && _vm.hasSavedAddress && !_vm.noSavedBillingAddresUS)?_c('address-picker',{attrs:{"header-label":_vm.resources.billingAddressPickerHeader,"selected-address-id":_vm.selectedAddresses.selectedBillingAddressId,"selection-mutation":_vm.updateAddressMutation,"type":'billing'}}):_vm._e(),_vm._v(" "),(_vm.sameAsDeliveryAddress.state.value && _vm.hasSavedAddress)?_c('div',{staticClass:"section-row"},[_c('address-summary',{attrs:{"address-id":_vm.selectedAddresses.selectedShippingAddressId,"address-format":_vm.addressBookResources.addressFormat}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"section-row"},_vm._l((_vm.vatRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return (element.id !=='saveAddress' || !_vm.sameAsDeliveryAddress.state.value && !_vm.hasSavedAddress)?_c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}}):_vm._e()}),1)}),0),_vm._v(" "),_vm._t("default")],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5bd4d02e", __vue__options__)
  } else {
    hotAPI.reload("data-v-5bd4d02e", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-form/vue-form.vue":406,"../../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../../vue-form/vue-input/vue-input.vue":415,"../../address-form-utils":282,"../../delivery/address-picker/address-picker.vue":290,"../address-summary/address-summary.vue":312,"vue":262,"vue-hot-reload-api":257,"vuex":264}],314:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const AddressFormUtils = require('../../address-form-utils');

module.exports = {
    mixins: [AddressFormUtils],
    computed: {
        ...mapState('details', [
            'resources', 'forms'
        ]),
        ...mapState('addressBook', {
            selectedAddresses: state => state.selectedAddresses
        }),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        namesRows() {
            return this.formRows;
        }
    },
    data() {
        const formElements = this.$store.state.details.forms.companydetails.formElements;
        const formRows = this.layoutElements(formElements);
        const addressFieldsHidden = this.shouldShowHiddenFields(formRows);

        return {
            formRows,
            formId: 'companydetails',
            addressFieldsHidden
        };
    },
    components: {
        VueInput
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"company-details"},[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-row-header"},[_vm._v("\n            "+_vm._s(_vm.resources.blockCompanyLabel)+"\n        ")])]),_vm._v(" "),(!_vm.hasSavedAddress)?[_c('div',{staticClass:"section-row"},_vm._l((_vm.namesRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)}),0)]:_vm._e()],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8600bc26", __vue__options__)
  } else {
    hotAPI.reload("data-v-8600bc26", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"../../address-form-utils":282,"vue":262,"vue-hot-reload-api":257,"vuex":264}],315:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');
const VueInputButton = require('../../../vue-form/vue-input/inputs/vue-input-button.vue');
const VueForm = require('../../../vue-form/vue-form/vue-form.vue');
const AddressFormUtils = require('../../address-form-utils');

module.exports = {
    mixins: [AddressFormUtils],
    computed: {
        ...mapState('details', [
            'resources', 'countryCode', 'forms'
        ]),
        ...mapGetters('addressBook', [
            'hasSavedAddress'
        ]),
        ...mapGetters('details', [
            'showPhoneRow'
        ]),
        rowIndexes() {
            return {
                salutation: this.formRows.findIndex(row => row[0].id === 'salutation'),
                addressSearch: this.formRows.findIndex(row => row[0].id === 'addressSearch'),
                phoneChoice: this.formRows.findIndex(row => row[0].id === 'phoneNumberOptions'),
                ssn: this.formRows.findIndex(row => row[0].id === 'ssn'),
                //used when hiding some rows, and not using or showing searchBar
                houseNumberExtension: this.formRows.findIndex(row => row[0].id === 'addressSearchDummy')
            };
        },
        currentCountryIndexMapper() {
            return rowIndexMapper[this.countryCode] || rowIndexMapper['default'];
        },
        contactRows() {
            const index = this.showPhoneRow ? this.rowIndexes.phoneChoice : this.rowIndexes[this.currentCountryIndexMapper.startingRowIndex];
            return this.formRows.slice(0, index);
        },
        phoneChoiceRows() {
            return this.formRows.slice(1, this.rowIndexes[this.currentCountryIndexMapper.startingRowIndex]);
        },
        namesRows() {
            return this.rowIndexes[this.currentCountryIndexMapper.addressSearchIndex] !== -1
                ? this.formRows.slice(this.rowIndexes[this.currentCountryIndexMapper.startingRowIndex], this.rowIndexes[this.currentCountryIndexMapper.addressSearchIndex])
                : this.formRows.slice(this.rowIndexes[this.currentCountryIndexMapper.startingRowIndex]);
        },
        addressSearchRow() {
            return this.rowIndexes.addressSearch !== -1 ? this.formRows[this.rowIndexes.addressSearch] : null;
        },
        hiddenRows() {
            return this.rowIndexes[this.currentCountryIndexMapper.addressSearchIndex] !== -1
                ? this.formRows.slice(this.rowIndexes[this.currentCountryIndexMapper.addressSearchIndex] + 1)
                : null;
        },
        isHomeDelivery() {
            const selectedMethod = this.$store.getters['delivery/selectedDeliveryMethod'];
            return selectedMethod && selectedMethod.id === 'homeDelivery';
        }
    },
    data() {
        const formElements = this.$store.state.details.forms.shippingAddress.formElements;
        const formRows = this.layoutElements(formElements);
        const addressFieldsHidden = this.shouldShowHiddenFields(formRows);

        return {
            formRows,
            formId: 'shippingAddress',
            addressFieldsHidden
        };
    },
    components: {
        VueForm, VueInput, VueInputButton
    },
};

const rowIndexMapper = {
    'SE': {
        startingRowIndex: 'ssn',
        addressSearchIndex: 'addressSearch'
    },
    'NL':{
        startingRowIndex: 'salutation',
        addressSearchIndex: 'houseNumberExtension'
    },
    'default': {
        startingRowIndex: 'salutation',
        addressSearchIndex: 'addressSearch'
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"delivery-details"},[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-row-header"},[_vm._v("\n           "+_vm._s(_vm.resources.orderConfirmationHeader)+"\n       ")]),_vm._v(" "),_vm._l((_vm.contactRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)})],2),_vm._v(" "),(_vm.showPhoneRow)?[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-row-header"},[_vm._v("\n               "+_vm._s(_vm.resources.phoneChoiceHeader)+"\n           ")]),_vm._v(" "),_vm._l((_vm.phoneChoiceRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)})],2)]:_vm._e(),_vm._v(" "),(!_vm.hasSavedAddress && _vm.isHomeDelivery)?[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-row-header"},[_vm._v("\n               "+_vm._s(_vm.resources.addressDetailsHeader)+"\n           ")]),_vm._v(" "),_vm._l((_vm.namesRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)})],2),_vm._v(" "),(_vm.addressSearchRow && _vm.addressFieldsHidden)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.addressSearchRow[0]}})],1)]):_vm._e(),_vm._v(" "),(_vm.addressFieldsHidden && _vm.hiddenRows)?_c('div',{staticClass:"reveal-hidden",on:{"click":function($event){_vm.addressFieldsHidden = false; _vm.enableEditShipping = true}}},[_vm._v("\n           "+_vm._s(_vm.resources.enterAddressCTA)+"\n       ")]):_vm._e(),_vm._v(" "),(!_vm.addressFieldsHidden && _vm.hiddenRows)?_c('div',{staticClass:"section-row"},_vm._l((_vm.hiddenRows),function(row,index){return _c('div',{key:index,class:['vue-form-row', { 'has-multiple-elements': row.length > 1 }]},_vm._l((row),function(element){return _c('vue-input',{key:element.id,attrs:{"element":element},on:{"blur":function($event){return _vm.updateFieldValue(element.id, $event.target.value)}}})}),1)}),0):_vm._e()]:_vm._e()],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7d275732", __vue__options__)
  } else {
    hotAPI.reload("data-v-7d275732", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-form/vue-form.vue":406,"../../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../../vue-form/vue-input/vue-input.vue":415,"../../address-form-utils":282,"vue":262,"vue-hot-reload-api":257,"vuex":264}],316:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const AddressFormUtils = require('../../address-form-utils');


module.exports = {
    mixins: [AddressFormUtils],
    computed: {
        ...mapState('details', [
            'resources'
        ]),
        ...mapState('delivery', { deliveryResources: 'resources' }),
        ...mapGetters('details', [
            'getFieldValue','phoneNumber', 'getStateOptions'
        ]),
        ...mapState('addressBook', {
            addressFormat: state => state.resources && state.resources.addressFormat,
            selectedBillingAddressId: state => state.selectedAddresses && state.selectedAddresses.selectedBillingAddressId
        }),
        email() {
            return this.getFieldValue('shippingAddress', 'email');
        },
        phone() {
            return this.phoneNumber;
        },
        address() {
            if (this.selectedBillingAddressId) {
                return this.formatAddress(
                    this.getAddressById(this.selectedBillingAddressId).fieldValues,
                    this.addressFormat,
                    this.getStateOptions
                );
            }
            return this.formatAddress(
                this.getFormAsJSON('billingAddress'),
                this.deliveryResources.addressFormat,
                this.getStateOptions
            );
        },
        sameAsDelivery() {
            return this.getFieldValue('billingAddress', 'useSameAsShipping');
        },
        shouldShowVat() {
            return this.getFieldValue('billingAddress', 'btwVatNumber') !== null ||
                this.getFieldValue('billingAddress', 'nifNumber') !== null;
        },
        vat() {
            const vat = this.getFieldValue('billingAddress', 'btwVatNumber');
            const nif = this.getFieldValue('billingAddress', 'nifNumber');

            if (vat) {
                return 'VAT: ' + vat;
            }

            if (nif) {
                return 'NIF: ' + nif;
            }

            return '';
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"section-summary-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.orderConfirmationHeader))]),_vm._v(" "),_c('span',{staticClass:"body-text"},[_vm._v(_vm._s(_vm.email))]),_vm._v(" "),(_vm.phone)?_c('span',{staticClass:"body-text"},[_vm._v(_vm._s(_vm.phone))]):_vm._e(),_vm._v(" "),(!_vm.phone)?_c('span',{staticClass:"body-text dimmed"},[_vm._v(_vm._s(_vm.resources.noPhoneLabel))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"section-summary-row"},[(_vm.sameAsDelivery)?_c('span',[_vm._v(_vm._s(_vm.resources.billingSameAsDeliveryLabel)+" ")]):_vm._e(),_vm._v(" "),(!_vm.sameAsDelivery)?_c('span',[_vm._v(_vm._s(_vm.resources.billingAddressHeader))]):_vm._e(),_vm._v(" "),(!_vm.sameAsDelivery)?_c('span',{staticClass:"body-text",domProps:{"innerHTML":_vm._s(_vm.address)}}):_vm._e(),_vm._v(" "),(_vm.shouldShowVat)?_c('span',{staticClass:"body-text"},[_vm._v(_vm._s(_vm.vat))]):_vm._e(),_vm._v(" "),(_vm.shouldShowVat && !_vm.vat)?_c('span',{staticClass:"body-text dimmed"},[_vm._v(_vm._s(_vm.resources.noVATLabel))]):_vm._e()])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7526633f", __vue__options__)
  } else {
    hotAPI.reload("data-v-7526633f", __vue__options__)
  }
})()}

},{"../../address-form-utils":282,"vue":262,"vue-hot-reload-api":257,"vuex":264}],317:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapGetters } = require('vuex');
const VueInput = require('../../vue-form/vue-input/vue-input.vue');
const VueInputButton = require('../../vue-form/vue-input/inputs/vue-input-button.vue');
const VueForm = require('../../vue-form/vue-form/vue-form.vue');
const DeliveryDetails = require('./delivery-details/delivery-details.vue');
const BillingDetails = require('./billing-details/billing-details.vue');
const CompanyDetails = require('./company-details/company-details.vue');
const DetailsSummary = require('./details-summary/details-summary.vue');
const CheckoutSubmitHandler = require('../checkout-submit-handler');

module.exports = {
    mixins: [CheckoutSubmitHandler],
    computed: {
        ...mapState('details', [
            'resources', 'forms', 'countryCode', 'editMode', 'showEditModeError', 'isMember', 'isb2b', 'disableEditMode'
        ]),
        ...mapState('delivery', {
            deliveryState: 'resources'
        }),
        ...mapGetters('details', [
            'getFieldValue', 'shippingPostalCodeValue', 'billingPostalCodeValue'
        ]),
        ...mapState('addressBook', [
            'selectedAddresses'
        ]),
        ...mapGetters('addressBook', [
            'hasSavedAddress'
        ]),
        ...mapState('payments', { paymentsResources: 'resources' }),
        ...mapGetters('delivery', ['hasEnabledDeliveryMethods', 'postalCodeValue', 'selectedDeliveryMethod']),
        buttonData() {
            return { element: this.forms.actions[0] };
        }
    },
    watch: {
        shippingPostalCodeValue(newValue) {
            if (newValue) {
                this.setStateCode('shippingAddress');
            }
            if (newValue && newValue === this.postalCodeValue) {
                this.removePostalErrors();
            }
        },
        billingPostalCodeValue(newValue) {
            if (newValue) {
                this.setStateCode('billingAddress');
            }
        },
        postalCodeValue(newValue) {
            if (this.shippingPostalCodeValue && newValue === this.shippingPostalCodeValue) {
                this.removePostalErrors();
            }
        }
    },
    data() {
        return {
            saving: false,
            backupData: {}
        };
    },
    mounted() {
        if (!this.editMode) {
            this.$store.commit('analytics/handleDetailsInteraction');
        }
    },
    methods: {
        setStateCode(addressType) {
            return this.$store.dispatch('details/setStateCodeByPostal', addressType);
        },
        removePostalErrors() {
            this.$store.commit('details/removeValidationError', {
                formId: 'shippingAddress',
                fieldId: 'postalCode',
                error: this.resources.postalDetailsError
            });
            this.$store.commit('delivery/removePostalCodeError', this.resources.postalDeliveryError);
            this.$store.commit('error/removeErrorMessage', this.resources.postalTopBanerError || this.deliveryState.deliveryBlockSaveValidationWarning);
        },
        submitForm() {
            const validationResult = this.validateDetailsNoSavedAddressFlow();
            if (validationResult.isValid) {
                return this.$store.dispatch('details/postForms');
            }
            this.scrollIntoSection(validationResult.badElementId);
        },
        saveDetails() {
            const selectedBillingAddressId = this.selectedAddresses && this.selectedAddresses.selectedBillingAddressId;
            if (this.countryCode === 'US' && this.editMode && (!this.hasSavedAddress || !selectedBillingAddressId) && this.selectedDeliveryMethod.id === 'homeDelivery') {
                this.saveAvataxDetails();
            } else {
                this.saveUserDetails();
            }
        },
        async saveUserDetails() {
            const validationResult = this.validateDetailsSavedAddressFlow();
            if (!validationResult.isValid) {
                this.scrollIntoSection(validationResult.badElementId);
                return;
            }
            this.$store.commit('analytics/handleDetailsInteraction');
            this.saving = true;
            await this.$store.dispatch('details/submitMemberDetails');
            this.saving = false;
            this.$store.commit('details/setShowEditModeError', false);
        },
        async saveAvataxDetails() {
            this.$store.commit('details/validateForm', 'billingAddress');
            this.$store.commit('details/validateForm', 'shippingAddress');
            const validationResult = this.validateDetailsNoSavedAddressFlow();
            if (!validationResult.isValid) {
                this.scrollIntoSection(validationResult.badElementId);
                return;
            }
            this.$store.commit('analytics/handleDetailsInteraction');
            this.saving = true;
            await this.$store.dispatch('details/submitGuestDetails');
            this.saving = false;
        },
        setEditState() {
            this.backup();
            this.$store.commit('details/setEditMode', true);
        },
        revertEdit() {
            this.restore();
            this.$store.commit('details/setEditMode', false);
        },
        backup() {
            this.backupData = {
                phoneNumberOptions: this.getFieldValue('shippingAddress', 'phoneNumberOptions'),
                phone: this.getFieldValue('shippingAddress', 'phone'),
                selectedBillingAddressId: this.selectedAddresses && this.selectedAddresses.selectedBillingAddressId,
                useSameAsShipping: this.getFieldValue('billingAddress', 'useSameAsShipping'),
                vat: this.getFieldValue('billingAddress', 'btwVatNumber') || this.getFieldValue('billingAddress', 'nifNumber')
            };
        },
        restore() {
            const type = 'billing';
            // In the case that form is in edit state from the beginning, backup was never done
            if (!Object.keys(this.backupData).length) {
                this.backup();
            }
            const addressId = this.backupData.selectedBillingAddressId;
            const { vat, useSameAsShipping, phone, phoneNumberOptions } = this.backupData;
            this.$store.commit('addressBook/selectAddress', { type, addressId });
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'phoneNumberOptions',
                value: phoneNumberOptions
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'shippingAddress',
                fieldId: 'phone',
                value: phone
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'billingAddress',
                fieldId: 'useSameAsShipping',
                value: useSameAsShipping
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'billingAddress',
                fieldId: 'btwVatNumber',
                value: vat
            });
            this.$store.commit('details/updateFieldValue', {
                formId: 'billingAddress',
                fieldId: 'nifNumber',
                value: vat
            });
        },
        handleInteraction() {
            if (this.checkIfDetailsBlockIsValid().isValid) {
                this.$store.commit('analytics/handleDetailsInteraction');
            }
        }
    },
    components: {
        VueForm, VueInput, VueInputButton, CompanyDetails, DeliveryDetails, BillingDetails, DetailsSummary
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section",attrs:{"id":"detailsSection"},on:{"input":_vm.handleInteraction}},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.blockLabel))]),_vm._v(" "),(!_vm.disableEditMode && !_vm.editMode && _vm.hasEnabledDeliveryMethods)?_c('button',{staticClass:"btn btn--secondary",on:{"click":_vm.setEditState}},[_vm._v("\n        "+_vm._s(_vm.resources.editCTA)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.disableEditMode || (!_vm.editMode && _vm.hasEnabledDeliveryMethods))?[_c('details-summary')]:_vm._e(),_vm._v(" "),(!_vm.disableEditMode && _vm.editMode && _vm.hasEnabledDeliveryMethods)?[(_vm.isb2b)?_c('vue-form',{attrs:{"id":"companydetails","name":_vm.checkout,"method":_vm.POST}},[_c('company-details',{ref:"companyDetails"})],1):_vm._e(),_vm._v(" "),_c('vue-form',{attrs:{"id":"shippingForm","name":_vm.checkout,"method":_vm.POST,"novalidate":false}},[_c('delivery-details',{ref:"deliveryDetails"})],1),_vm._v(" "),_c('vue-form',{attrs:{"id":"billingForm","name":_vm.checkout,"method":_vm.POST,"novalidate":true}},[_c('billing-details',{ref:"billingDetails"},[(_vm.editMode && (_vm.hasSavedAddress || _vm.countryCode === 'US'))?_c('div',{staticClass:"section-row"},[(_vm.showEditModeError)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.saveSettingsWarning))])]):_vm._e(),_vm._v(" "),_c('footer',{class:['section-footer', {'us-footer': _vm.countryCode === 'US' && !_vm.hasSavedAddress}]},[_c('button',{staticClass:"btn",on:{"click":_vm.saveDetails}},[(!_vm.saving)?_c('span',[_vm._v(_vm._s(_vm.resources.saveDetailsCTA))]):_vm._e(),_vm._v(" "),_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.saving }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])]),_vm._v(" "),(_vm.hasSavedAddress)?_c('a',{attrs:{"title":"Cancel"},on:{"click":_vm.revertEdit}},[_vm._v(_vm._s(_vm.resources.cancelCTA))]):_vm._e()])]):_vm._e()])],1)]:_vm._e()],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3cd673da", __vue__options__)
  } else {
    hotAPI.reload("data-v-3cd673da", __vue__options__)
  }
})()}

},{"../../vue-form/vue-form/vue-form.vue":406,"../../vue-form/vue-input/inputs/vue-input-button.vue":407,"../../vue-form/vue-input/vue-input.vue":415,"../checkout-submit-handler":287,"./billing-details/billing-details.vue":313,"./company-details/company-details.vue":314,"./delivery-details/delivery-details.vue":315,"./details-summary/details-summary.vue":316,"vue":262,"vue-hot-reload-api":257,"vuex":264}],318:[function(require,module,exports){
'use strict';

const googleFieldMapping = {
    GB: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        postal_code: 'postalCode'
    },
    RU: {
        street_number: 'address1',
        route: 'address1',
        locality: 'city',
        postal_code: 'postalCode'
    },
    IE: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode',
        administrative_area_level_1: 'state'
    },
    NO: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode'
    },
    SE: {
        street_number: 'houseNumber',
        route: 'street',
        postal_town: 'city',
        locality: 'city',
        postal_code: 'postalCode'
    },
    US: {
        street_number: 'address1',
        route: 'address1',
        locality: 'city',
        postal_code: 'postalCode',
        administrative_area_level_1: 'stateUS'
    },
    default: {
        street_number: 'houseNumber',
        route: 'street',
        locality: 'city',
        postal_code: 'postalCode'
    }
};

const irelandGoogleCountyFieldMapper = {
    CW: 'CW',
    CN: 'CV',
    CE: 'CL',
    CO: 'CK',
    DL: 'DG',
    D: 'DB',
    G: 'GW',
    KY: 'KY',
    'COUNTY KILDARE': 'KD',
    'COUNTY KILKENNY': 'KK',
    LS: 'LS',
    LM: 'LM',
    LK: 'LI',
    LD: 'LF',
    LH: 'LT',
    MO: 'MY',
    MH: 'MT',
    MN: 'MH',
    OY: 'OF',
    RN: 'RC',
    SO: 'SG',
    TA: 'TP',
    WD: 'WF',
    WH: 'WM',
    WX: 'WX',
    WW: 'WW'
};

module.exports = {
    googleFieldMapping,
    irelandGoogleCountyFieldMapper
};

},{}],319:[function(require,module,exports){
'use strict';

const customerServiceInfoClass = '.js-customer-service-info li';
const customerServiceInfo = $(customerServiceInfoClass);

function initializeEvents() {
    customerServiceInfo.on('click', function(e) {
        e.preventDefault();
        $.ajax({
            type: 'GET',
            url: Urls.getCustomerServiceInfoData,
            success: function(response) {
                window.eventBus.$emit('shouldOpenFlyin', {
                    content: {
                        template: response
                    }
                });
            }
        });
    });
}

const shouldInit = () => document.querySelectorAll(customerServiceInfoClass).length > 0;

const headerCheckout = {
    init: function() {
        if (shouldInit()) {
            require('../../../pages/faqredesign').initCheckout();
            initializeEvents();
        }
    }
};

module.exports = headerCheckout;

},{"../../../pages/faqredesign":538}],320:[function(require,module,exports){
;(function(){
'use strict';
const MiniCartLineError = require('../mini-line-item-error/mini-cart-line-error.vue');
const mapState = require('vuex').mapState;
const damHelper = require('../../../../dam/dam-helper');

module.exports = {
    props: {
        item: Object,
        isGift: {
            type: Boolean,
            default: false
        }
    },
    computed: mapState('orderSummary', [
        'resources'
    ]),
    components:{
        MiniCartLineError
    },
    mounted() {
        damHelper.updateImages(this.$refs.miniCartImage);
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.item.freeProductLabel))]),_vm._v(" "),_c('div',{class:['mini-cart-product', {'product-gift-ribbon': _vm.isGift}]},[_c('div',{ref:"miniCartImage",staticClass:"mini-cart-image"},[(_vm.item.productLink)?_c('a',{attrs:{"href":_vm.item.productLink.url,"title":_vm.item.productLink.title}},[(_vm.item.image)?_c('img',{class:_vm.item.image.class,attrs:{"alt":_vm.item.image.alt,"title":_vm.item.image.title,"src":_vm.item.image.placeholder,"data-src":_vm.item.image.src}}):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.item.productLink && _vm.item.image)?_c('img',{class:_vm.item.image.class,attrs:{"alt":_vm.item.image.alt,"title":_vm.item.image.title,"src":_vm.item.image.placeholder,"data-src":_vm.item.image.src}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mini-cart-info"},[(_vm.item.ancientRitual)?_c('div',{staticClass:"mini-cart-small-title"},[_vm._v("\n              "+_vm._s(_vm.item.ancientRitual)+"\n\n              "),(_vm.item.price.discountPrice && !_vm.item.price.standardProductValueResource)?_c('div',{staticClass:"mini-cart-price-wrapper"},[_c('span',{staticClass:"value price-before-discount"},[_vm._v(_vm._s(_vm.item.price.discountPrice))])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mini-cart-name mini-cart-product-name"},[(_vm.item.productLink)?_c('a',{attrs:{"href":_vm.item.productLink.url,"title":_vm.item.productLink.title}},[_vm._v("\n                  "+_vm._s(_vm.item.title)+"\n              ")]):_vm._e(),_vm._v(" "),(!_vm.item.productLink)?_c('div',[_vm._v(_vm._s(_vm.item.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mini-cart-price-wrapper"},[(_vm.item.price.discountPrice)?_c('span',{staticClass:"value price-after-discount"},[_vm._v(_vm._s(_vm.item.price.productPrice))]):_c('span',{staticClass:"mini-cart-price"},[_vm._v(_vm._s(_vm.item.price.productPrice))])])]),_vm._v(" "),(_vm.item.price.showBaseUnitPrice)?_c('div',{staticClass:"mini-cart-unit-base"},[(_vm.item.price.unitBasePrice)?_c('div',{staticClass:"unit-base-price"},[_c('div',[_c('span',{staticClass:"unit-volume"},[_vm._v(_vm._s(_vm.item.price.unitBasePrice.originalVolume))]),_vm._v(" "),_c('span',{staticClass:"base-price"},[_vm._v("("+_vm._s(_vm.item.price.unitBasePrice.basePriceText)+")")])]),_vm._v(" "),_c('div',{staticClass:"unit-base-price legal-note"},[_c('span',[_vm._v(_vm._s(_vm.item.price.resources.vatIncluded))])])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mini-cart-attributes"},[(_vm.item.selectedAttributes)?_c('div',{class:_vm.item.selectedAttributes.cssClass},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.item.selectedAttributes.text))])]):_vm._e()]),_vm._v(" "),(_vm.item.price.discountPrice && _vm.item.price.standardProductValueResource)?_c('div',{staticClass:"mini-cart-details-bottom"},[_c('div',{staticClass:"mini-cart-pricing"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.price.standardProductValueResource + ' ' + _vm.item.price.discountPrice))])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mini-cart-details-bottom"},[(_vm.item.promotionType)?_c('div',{staticClass:"mini-cart-pricing"},[_vm._v("\n                  "+_vm._s(_vm.item.promotionType)+"\n              ")]):_c('div',{staticClass:"mini-cart-pricing"},[_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.item.quantity))]),_vm._v(" "),(_vm.item.errorMessage)?_c('div',{staticClass:"error-form"},[_vm._v("\n                      "+_vm._s(_vm.item.errorMessage)+"\n                  ")]):_vm._e()])])]),_vm._v(" "),_c('mini-cart-line-error',{attrs:{"item":_vm.item}})],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-f9bb4c46", __vue__options__)
  } else {
    hotAPI.reload("data-v-f9bb4c46", __vue__options__)
  }
})()}

},{"../../../../dam/dam-helper":419,"../mini-line-item-error/mini-cart-line-error.vue":321,"vue":262,"vue-hot-reload-api":257,"vuex":264}],321:[function(require,module,exports){
;(function(){
'use strict';

const { mapState } = require('vuex');

module.exports = {
    props: ['item'],

    computed: {
        ...mapState('delivery', [
            'exclusionResults'
        ]),

        errorObject() {
            return this.exclusionResults.excludedProducts[this.item.productId];
        }
    },

    methods: {
        remove() {
            this.$store.dispatch('orderSummary/removeLineItem', this.item.productId);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorObject)?_c('div',{staticClass:"mini-cart-product-error"},[_c('button',{staticClass:"remove-product",attrs:{"type":"button"},on:{"click":_vm.remove}},[_vm._v(_vm._s(_vm.item.resources.removeLabel))]),_vm._v(" "),_c('div',{class:['inline-alert', _vm.errorObject.type]},[_c('span',[_vm._v(_vm._s(_vm.errorObject.message))])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-35833e86", __vue__options__)
  } else {
    hotAPI.reload("data-v-35833e86", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],322:[function(require,module,exports){
;(function(){
'use strict';
const MiniCartLineItem = require('../../lineItems/mini-cart-line-item/mini-cart-line-item.vue');
const mapState = require('vuex').mapState;

module.exports = {
    props: {
        items: Array,
        isGift: {
            type: Boolean,
            default: false
        }
    },
    computed: mapState('orderSummary', [
        'resources'
    ]),
    components:{
        MiniCartLineItem
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout-summary-minicart"},_vm._l((_vm.items),function(item){return _c('mini-cart-line-item',{key:item.id,attrs:{"item":item,"isGift":_vm.isGift}})}),1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-44e3158d", __vue__options__)
  } else {
    hotAPI.reload("data-v-44e3158d", __vue__options__)
  }
})()}

},{"../../lineItems/mini-cart-line-item/mini-cart-line-item.vue":320,"vue":262,"vue-hot-reload-api":257,"vuex":264}],323:[function(require,module,exports){
;(function(){
'use strict';

// This script is used for both desktop and mobile templates

const mapState = require('vuex').mapState;
const CartLineItems = require('./cart-line-items/cart-line-items.vue');
const SendCheckoutLinkButton = require('../../social-commerce/send-checkout-link/send-checkout-link-button.vue');

module.exports = {
    data() {
        return {
            show: true
        };
    },
    computed: mapState('orderSummary', [
        'resources',
        'editLink',
        'orderSubtotal',
        'promotions',
        'taxationPolicyTotalTax',
        'giftCardDeductionAmount',
        'giftCardDeductionAmountValue',
        'giftWrapAndGreetCardPrice',
        'giftWrapAndGreetCardPriceValue',
        'shippingPrice',
        'orderTotalsPrice',
        'lineItems',
        'disableEditMode'
    ]),
    components: {
        CartLineItems,
        SendCheckoutLinkButton
    },
    methods: {
        showHideProducts() {
            this.show = !this.show;
        },
        editCart() {
            this.$store.dispatch('details/saveAddressesToForms');
            window.location.href = this.editLink;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.titleLabel))])]),_vm._v(" "),_c('span',{staticClass:"section-row-header"},[_vm._v("\n        "+_vm._s(_vm.resources.numberOfProducts)+"\n        "),(!_vm.disableEditMode)?_c('a',{staticClass:"section-link",attrs:{"title":_vm.resources.editLabel},on:{"click":_vm.editCart}},[_vm._v("\n            "+_vm._s(_vm.resources.editLabel)+"\n        ")]):_vm._e()]),_vm._v(" "),_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartLineItems}}),_vm._v(" "),(_vm.lineItems.cartGiftWrapLineItems.length)?_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartGiftWrapLineItems}}):_vm._e(),_vm._v(" "),(_vm.lineItems.cartFreeBonusProducts.length)?_c('div',{staticClass:"section-row-wrapper-desktop"},[_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartFreeBonusProducts,"isGift":false}})],1):_vm._e(),_vm._v(" "),(_vm.lineItems.cartGiftLineItems.length)?_c('div',{staticClass:"section-row-wrapper-desktop"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.giftSubtitleLabel))]),_vm._v(" "),_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartGiftLineItems,"isGift":true}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cost-details"},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.subtotalLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderSubtotal))])]),_vm._v(" "),(_vm.promotions)?_c('div',_vm._l((_vm.promotions),function(promotion){return _c('div',{key:promotion.name},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(promotion.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(promotion.discount))])])])}),0):_vm._e(),_vm._v(" "),(_vm.giftCardDeductionAmountValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftCardsLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftCardDeductionAmount))])]):_vm._e(),_vm._v(" "),(_vm.giftWrapAndGreetCardPriceValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftWrapAndGreetCardLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftWrapAndGreetCardPrice))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.deliveryLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.shippingPrice))])]),_vm._v(" "),_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v("\n                "+_vm._s(_vm.resources.totalLabel)+"\n                "),_c('span',{staticClass:"taxes-included"},[_vm._v(_vm._s(_vm.resources.taxesLabel))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTotalsPrice))])])]),_vm._v(" "),_c('div',{staticClass:"btn--checkout"},[_c('send-checkout-link-button')],1)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a191f93a", __vue__options__)
  } else {
    hotAPI.reload("data-v-a191f93a", __vue__options__)
  }
})()}

},{"../../social-commerce/send-checkout-link/send-checkout-link-button.vue":404,"./cart-line-items/cart-line-items.vue":322,"vue":262,"vue-hot-reload-api":257,"vuex":264}],324:[function(require,module,exports){
;(function(){
'use strict';

// This script is used for both desktop and mobile templates

const mapState = require('vuex').mapState;
const CartLineItems = require('./cart-line-items/cart-line-items.vue');
const SendCheckoutLinkButton = require('../../social-commerce/send-checkout-link/send-checkout-link-button.vue');

module.exports = {
    data() {
        return {
            show: true
        };
    },
    computed: mapState('orderSummary', [
        'resources',
        'editLink',
        'orderSubtotal',
        'promotions',
        'taxationPolicyTotalTax',
        'giftCardDeductionAmount',
        'giftCardDeductionAmountValue',
        'giftWrapAndGreetCardPrice',
        'giftWrapAndGreetCardPriceValue',
        'shippingPrice',
        'orderTotalsPrice',
        'lineItems',
        'disableEditMode'
    ]),
    components: {
        CartLineItems,
        SendCheckoutLinkButton
    },
    methods: {
        showHideProducts() {
            this.show = !this.show;
        },
        editCart() {
            this.$store.dispatch('details/saveAddressesToForms');
            window.location.href = this.editLink;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section checkout-section-phone-nospace"},[_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.titleLabel))])]),_vm._v(" "),_c('span',{staticClass:"section-row-header"},[_vm._v("\n            "+_vm._s(_vm.resources.numberOfProducts)+"\n\n            "),(_vm.show)?_c('a',{staticClass:"section-link",on:{"click":_vm.showHideProducts}},[_vm._v(_vm._s(_vm.resources.showProductsLabel))]):_c('a',{staticClass:"section-link",on:{"click":_vm.showHideProducts}},[_vm._v(_vm._s(_vm.resources.hideProductsLabel))])]),_vm._v(" "),(!_vm.show)?_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartLineItems}}):_vm._e(),_vm._v(" "),(!_vm.show && _vm.lineItems.cartGiftWrapLineItems.length)?_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartGiftWrapLineItems}}):_vm._e(),_vm._v(" "),(!_vm.show)?_c('a',{staticClass:"section-link",on:{"click":_vm.editCart}},[_vm._v(_vm._s(_vm.resources.editLabel))]):_vm._e()],1),_vm._v(" "),_c('div',{class:{'section-row': !_vm.show}},[(_vm.lineItems.cartFreeBonusProducts.length && !_vm.show)?_c('div',{staticClass:"section-row-wrapper-mobile"},[_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartFreeBonusProducts,"isGift":false}})],1):_vm._e(),_vm._v(" "),(_vm.lineItems.cartGiftLineItems.length && !_vm.show)?_c('div',{staticClass:"section-row-wrapper-mobile"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.giftSubtitleLabel))]),_vm._v(" "),_c('cart-line-items',{attrs:{"items":_vm.lineItems.cartGiftLineItems,"isGift":true}})],1):_vm._e(),_vm._v(" "),(!_vm.show)?_c('div',{staticClass:"cost-details"},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.subtotalLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderSubtotal))])]),_vm._v(" "),(_vm.promotions)?_c('div',_vm._l((_vm.promotions),function(promotion){return _c('div',{key:promotion.name},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(promotion.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(promotion.discount))])])])}),0):_vm._e(),_vm._v(" "),(_vm.giftCardDeductionAmountValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftCardsLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftCardDeductionAmount))])]):_vm._e(),_vm._v(" "),(_vm.giftWrapAndGreetCardPriceValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftWrapAndGreetCardLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftWrapAndGreetCardPrice))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.deliveryLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.shippingPrice))])])]):_vm._e(),_vm._v(" "),_c('div',{class:['cost-details', {'products-hidden': _vm.show}]},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v("\n                    "+_vm._s(_vm.resources.totalLabel)+"\n                    "),_c('span',{staticClass:"taxes-included"},[_vm._v(_vm._s(_vm.resources.taxesLabel))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTotalsPrice))])])]),_vm._v(" "),(!_vm.show)?_c('div',{staticClass:"btn--checkout"},[_c('send-checkout-link-button')],1):_vm._e()])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-63ade1ab", __vue__options__)
  } else {
    hotAPI.reload("data-v-63ade1ab", __vue__options__)
  }
})()}

},{"../../social-commerce/send-checkout-link/send-checkout-link-button.vue":404,"./cart-line-items/cart-line-items.vue":322,"vue":262,"vue-hot-reload-api":257,"vuex":264}],325:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    data() {
        return {
            showCTA: this.$store.state.coupons.resources.showFieldCTA,
            couponCode: this.$store.state.coupons.couponCodeValue,
            couponApplied: !!this.$store.state.coupons.couponCodeValue,
            showForm: false,
            showSpinner: false,
            showError: false
        };
    },
    computed: mapState('coupons', [
        'resources',
        'couponCodeValue',
        'priceAdjustment',
        'errorMessage',
    ]),
    methods: {
        toggleForm() {
            this.showCTA =
                this.showCTA === this.$store.state.coupons.resources.hideFieldCTA ?
                this.$store.state.coupons.resources.showFieldCTA :
                this.$store.state.coupons.resources.hideFieldCTA;
            this.showForm = this.showCTA === this.$store.state.coupons.resources.hideFieldCTA;
        },
        addCoupon() {
            this.showSpinner = true;
            this.$store
                .dispatch('coupons/addCoupon', this.couponCode)
                .then((success) => {
                    if (!success) {
                        this.showError = true;
                        return;
                    }
                    this.showError = false;
                    this.couponApplied = true;
                    this.showCTA = this.resources.removeCodeCTA;
                })
                .finally(() => {
                    this.showSpinner = false;
                });
        },
        deleteCoupon() {
            this.showSpinner = true;
            this.$store
                .dispatch('coupons/removeCoupon')
                .then((success) => {
                    if (!success) {
                        return;
                    }
                    this.couponApplied = false;
                    this.couponCode = '';
                    this.showForm = false;
                    this.showCTA = this.$store.state.coupons.resources.showFieldCTA;
                })
                .finally(() => {
                    this.showSpinner = false;
                });
        },
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shopping-cart-coupon-row"},[_c('div',{staticClass:"cart-coupon-code-trigger"},[_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n            "+_vm._s(_vm.resources.showFieldLabel)+"\n        ")]),_vm._v(" "),(!_vm.couponCodeValue)?_c('button',{class:['cart-coupon-trigger-btn', {'no-icon': _vm.showForm}],attrs:{"type":"button"},on:{"click":_vm.toggleForm}},[_vm._v("\n            "+_vm._s(_vm.showCTA)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.couponCodeValue)?_c('button',{staticClass:"cart-coupon-trigger-btn no-icon",attrs:{"type":"button"},on:{"click":_vm.deleteCoupon}},[_vm._v("\n            "+_vm._s(_vm.resources.removeCodeCTA)+"\n        ")]):_vm._e()]),_vm._v(" "),(_vm.showForm && !_vm.couponApplied)?_c('div',{staticClass:"cart-coupon-code"},[_c('form',{staticClass:"rituals-form",attrs:{"novalidate":"novalidate"},on:{"submit":function($event){$event.preventDefault();return _vm.addCoupon($event)}}},[_c('fieldset',[_c('div',{class:['coupon-wrapper', {'has-error': _vm.showError}]},[_c('div',{staticClass:"coupon-input"},[_c('div',{staticClass:"coupon-input-field"},[_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n                                "+_vm._s(_vm.resources.couponInputLabel)+"\n                            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.couponCode),expression:"couponCode"}],staticClass:"inputfield-text",attrs:{"type":"text","placeholder":_vm.resources.couponCodePlaceholder,"maxlength":"255","size":"28"},domProps:{"value":(_vm.couponCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.couponCode=$event.target.value}}}),_vm._v(" "),(_vm.showError)?_c('span',{staticClass:"input-field-error"},[_vm._v("\n                                "+_vm._s(_vm.errorMessage)+"\n                            ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"coupon-btn"},[_c('button',{staticClass:"btn"},[_c('div',{class:['spinner', 'white-spinner', {'spinner-visible': _vm.showSpinner}]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                                "+_vm._s(_vm.resources.applyCTA)+"\n                            ")]:_vm._e()],2)])])])])]):_vm._e(),_vm._v(" "),(_vm.couponApplied)?_c('div',{staticClass:"applied-coupon-row"},[_c('span',[_vm._v(" "+_vm._s(_vm.couponCodeValue))]),_vm._v(" "),(!_vm.priceAdjustment)?_c('span',[_vm._v(_vm._s(_vm.resources.notAppliedInfo))]):_vm._e()]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-47b0e1c4", __vue__options__)
  } else {
    hotAPI.reload("data-v-47b0e1c4", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],326:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    data() {
        return {
            eurobonusCode: this.$store.state.eurobonus.eurobonusCodeValue,
            formCollapsed: true,
            showSpinner: false
        };
    },
    computed: mapState('eurobonus', [
        'resources',
        'eurobonusSupported',
        'eurobonusEnabled',
        'eurobonusCodeValue',
        'errorMessage',
        'showError'
    ]),
    methods: {
        showForm() {
            this.formCollapsed = false;
        },
        applyEurobonus() {
            this.showSpinner = true;
            this.$store
                .dispatch('eurobonus/addCode', this.eurobonusCode)
                .finally(() => {
                    this.showSpinner = false;
                });
        },
        removeEurobonus() {
            this.formCollapsed = true;
            this.eurobonusCode = '';
            this.$store.dispatch('eurobonus/removeCode');
        },
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.eurobonusSupported)?_c('div',{staticClass:"cost-detail-row cost-detail-row-block"},[_c('div',{staticClass:"shopping-cart-coupon-row"},[_c('div',{staticClass:"cart-coupon-code-trigger"},[(!_vm.eurobonusEnabled)?[(!_vm.eurobonusEnabled)?_c('label',{staticClass:"cart-coupon-trigger-label cart-coupon-trigger-label-disabled"},[_vm._v("\n                    "+_vm._s(_vm.resources.eurobonusMainLabelDisabled)+"\n                ")]):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.eurobonusEnabled)?[(!_vm.eurobonusCodeValue && _vm.formCollapsed)?[_c('div',{staticClass:"cart-coupon-code-trigger"},[_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n                            "+_vm._s(_vm.resources.eurobonusMainLabel)+"\n                        ")]),_vm._v(" "),_c('button',{staticClass:"cart-coupon-trigger-btn",attrs:{"type":"button"},on:{"click":_vm.showForm}},[_vm._v("\n                            "+_vm._s(_vm.resources.showFieldCTA)+"\n                        ")])])]:_vm._e(),_vm._v(" "),(_vm.eurobonusCodeValue || !_vm.formCollapsed)?[_c('div',{staticClass:"cart-coupon-code-trigger"},[(_vm.eurobonusCodeValue)?_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n                            "+_vm._s(_vm.resources.eurobonusMainLabelApplied)+"\n                        ")]):_vm._e(),_vm._v(" "),(!_vm.eurobonusCodeValue)?_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n                            "+_vm._s(_vm.resources.eurobonusMainLabelApply)+"\n                        ")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"no-icon cart-coupon-trigger-btn",attrs:{"type":"button"},on:{"click":_vm.removeEurobonus}},[_vm._v("\n                            "+_vm._s(_vm.resources.hideFieldCTA)+"\n                        ")])])]:_vm._e()]:_vm._e()],2),_vm._v(" "),_c('span',{staticClass:"body-copy-desc-info",domProps:{"innerHTML":_vm._s(_vm.resources.eurobonusInfo)}}),_vm._v(" "),(_vm.eurobonusEnabled && !_vm.formCollapsed && !_vm.eurobonusCodeValue)?_c('div',{staticClass:"cart-coupon-code"},[_c('form',{staticClass:"rituals-form",attrs:{"novalidate":"novalidate"},on:{"submit":function($event){$event.preventDefault();return _vm.applyEurobonus($event)}}},[_c('fieldset',[_c('div',{class:['coupon-wrapper', {'has-error': _vm.showError}]},[_c('div',{staticClass:"coupon-input coupon-input-number"},[_c('div',{staticClass:"coupon-input-field"},[_c('label',{staticClass:"cart-coupon-trigger-label"},[_vm._v("\n                                    "+_vm._s(_vm.resources.eurobonusInputLabel)+"\n                                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.eurobonusCode),expression:"eurobonusCode"}],staticClass:"inputfield-text",attrs:{"type":"text","placeholder":_vm.resources.eurobonusInputLabel,"maxlength":"9","minlength":"9","size":"28"},domProps:{"value":(_vm.eurobonusCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.eurobonusCode=$event.target.value}}}),_vm._v(" "),(_vm.showError)?_c('span',{staticClass:"input-field-error"},[_vm._v("\n                                    "+_vm._s(_vm.errorMessage)+"\n                                ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"coupon-btn"},[_c('button',{staticClass:"btn"},[_c('div',{class:['spinner', 'white-spinner', {'spinner-visible': _vm.showSpinner}]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                                    "+_vm._s(_vm.resources.applyCTA)+"\n                                ")]:_vm._e()],2)])])])])]):_vm._e()]),_vm._v(" "),(_vm.eurobonusEnabled && _vm.eurobonusCodeValue)?_c('div',{staticClass:"cart-coupon-account-number"},[_c('span',[_vm._v(" "+_vm._s(_vm.resources.eurobonusCodeValueLabel))])]):_vm._e()]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1991f3e8", __vue__options__)
  } else {
    hotAPI.reload("data-v-1991f3e8", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],327:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const CouponForm = require('./coupon-form/coupon-form.vue');
const EurobonusForm = require('./eurobonus-form/eurobonus-form.vue');

module.exports = {
    computed: mapState('orderSummary', [
        'resources',
        'orderSubtotal',
        'taxationPolicyTotalTax',
        'giftCardDeductionAmount',
        'giftCardDeductionAmountValue',
        'giftWrapAndGreetCardPrice',
        'giftWrapAndGreetCardPriceValue',
        'shippingPrice',
        'orderTotalsPrice',
        'shouldShowCouponCode'
    ]),
    components: {
        CouponForm,
        EurobonusForm
    },
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section transparent",attrs:{"id":"orderSummary"}},[_c('div',{staticClass:"cost-details"},[_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.subtotalLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderSubtotal))])]),_vm._v(" "),(_vm.shouldShowCouponCode)?_c('div',{staticClass:"cost-detail-row"},[_c('coupon-form')],1):_vm._e(),_vm._v(" "),_c('eurobonus-form'),_vm._v(" "),(_vm.giftCardDeductionAmountValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftCardsLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftCardDeductionAmount))])]):_vm._e(),_vm._v(" "),(_vm.giftWrapAndGreetCardPriceValue > 0)?_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftWrapAndGreetCardLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.giftWrapAndGreetCardPrice))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v(_vm._s(_vm.resources.deliveryLabel))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.shippingPrice))])]),_vm._v(" "),_c('div',{staticClass:"cost-detail-row"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.resources.totalLabel)+"\n        "),_c('span',{staticClass:"taxes-included"},[_vm._v(_vm._s(_vm.resources.taxesLabel))])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.orderTotalsPrice))])])],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-32379fb8", __vue__options__)
  } else {
    hotAPI.reload("data-v-32379fb8", __vue__options__)
  }
})()}

},{"./coupon-form/coupon-form.vue":325,"./eurobonus-form/eurobonus-form.vue":326,"vue":262,"vue-hot-reload-api":257,"vuex":264}],328:[function(require,module,exports){
;(function(){
'use strict';

const {mapState, mapGetters} = require('vuex');
const axios = require('axios');

const GiftCard = require('./giftcard/giftcard.vue');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    components: {
        GiftCard,
        VueInput
    },

    watch: {
        selectedPaymentMethod(newValue) {
            if (!newValue.type) {
                return;
            }

            this.selectGiftcard('giftcard-options', '');
        }
    },

    computed: {
        ...mapState('payments', [
            'resources',
            'giftcardPaymentError',
            'limitationForGiftCard',
            'appliedGiftcards',
            'paymentMethodResponse',
            'readMode',
            'preselectedPaymentMethod',
            'payingFullAmountWithGiftcard',
            'selectedPaymentMethod',
            'removedGiftCard'
        ]),
        ...mapGetters('payments', [
            'giftcardOptionsField',
            'getFieldValue',
            'hasNoGiftCardOptions',
            'hasOneGiftCardOption',
            'hasMoreGiftCardOption'
        ]),
        ...mapState('orderSummary', [
            'giftCardDeductionAmount',
            'giftCardDeductionAmountValue',
            'orderTotalsPrice',
            'orderTotalsPriceValue',
        ]),
        ...mapState('details', [
            'isb2b'
        ]),
        giftCardType() {
            return this.giftcardOptionsField.state.value;
        },
        isGiftCardSelected() {
            return this.giftCardType && this.giftCardType !== 'none';
        },
        iHaveGiftcardText() {
            return this.hasOneGiftCardOption ?
                this.resources.giftcards.iHaveSpecificGiftcard.replace('{0}', this.giftcardOptionsField.attributes.options[1].id) :
                this.resources.giftcards.iHaveGiftcard;
        },
        needMorePaymentInstruments() {
            return this.appliedGiftcards.length > 0 && this.giftCardDeductionAmountValue > 0 && this.orderTotalsPriceValue > 0;
        },
        showRemovalMessage() {
            return this.appliedGiftcards.length > 0 && this.limitationForGiftCard && this.removedGiftCard;
        },
        hideKlarnaOverTime() {
            const klarnaActive = this.paymentMethodResponse.paymentMethods.filter(function(paymentMethod) {
                return paymentMethod.type === 'klarna_account';
            });
            return klarnaActive.length > 0 && this.appliedGiftcards.length > 0 && this.giftCardDeductionAmountValue > 0 && this.orderTotalsPriceValue > 0 && this.orderTotalsPriceValue < 35;
        },
        showKlarnaOverTime() {
            const klarnaActive = this.paymentMethodResponse.paymentMethods.filter(function(paymentMethod) {
                return paymentMethod.type === 'klarna_account';
            });
            return klarnaActive.length > 0 && this.appliedGiftcards.length > 0 && this.giftCardDeductionAmountValue > 0 && this.orderTotalsPriceValue >= 35;
        },
    },

    methods: {
        removeGiftcard(index, appliedGiftcard) {
            axios.get(window.Urls.removeGiftcard, {
                timeout: 15000,
                params: {
                    brand: appliedGiftcard.brand,
                    cardNumber: appliedGiftcard.cardNumber,
                    editMode: !this.readMode && this.preselectedPaymentMethod
                }
            }).then(resp => {
                if (!resp || !resp.data || resp.data.error) {
                    this.$store.commit('payments/updatePropertyValue', { propertyName: 'giftcardPaymentError', value: resp.data.error});
                    return;
                }

                this.$store.commit('payments/updatePropertyValue', { propertyName: 'limitationForGiftCard', value: resp.data.limitError });
                this.$store.commit('payments/updatePropertyValue', { propertyName: 'removedGiftCard', value: true });
                this.$store.commit('payments/updatePropertyValue', { propertyName: 'giftcardPaymentError', value: null });
                this.$store.dispatch('payments/setGiftCardData', resp.data);
                const enableEurobonus = !(this.appliedGiftcards.length > 0);
                this.$store.dispatch('eurobonus/updateEnabledFlag', enableEurobonus);
            });
        },
        cardAdded() {
            this.updateSelectedGiftcard('giftcard-options', '');
        },
        updateSelectedGiftcard(fieldId, value) {
            this.selectGiftcard(fieldId, value);
            this.$store.commit('payments/backupSelectedPaymentMethod', value);
        },
        selectGiftcard(fieldId, value) {
            this.$store.commit('payments/updatePropertyValue', { propertyName: 'removedGiftCard', value: false });
            this.$store.commit('payments/updateFieldValue', {
                formId: 'giftcards',
                fieldId: fieldId,
                value: value
            });
        },
        displayGiftcardForm(show) {
            const giftcardOptionValue = show ? (this.hasOneGiftCardOption ? this.giftcardOptionsField.attributes.options[1].id : 'none') : '';
            this.updateSelectedGiftcard('giftcard-options', giftcardOptionValue);
            let enableEurobonus = !show;
            if (this.appliedGiftcards.length > 0) {
                enableEurobonus = false;
            }
            this.$store.dispatch('eurobonus/updateEnabledFlag', enableEurobonus);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.readMode)?_c('div',{staticClass:"giftcard",class:{'giftcard-readmode': _vm.appliedGiftcards.length > 0}},[(_vm.appliedGiftcards.length > 0 && !_vm.isb2b)?_c('div',{staticClass:"giftcard-content"},[_c('div',{staticClass:"giftcard-row"},[_c('span',{staticClass:"giftcard-title"},[_vm._v(_vm._s(_vm.iHaveGiftcardText))])])]):_vm._e(),_vm._v(" "),_vm._l((_vm.appliedGiftcards),function(appliedGiftcard,index){return _c('div',{key:appliedGiftcard.id,staticClass:"applied-giftcards-container",attrs:{"value":appliedGiftcard}},[_c('div',{staticClass:"applied-giftcard"},[_c('div',{staticClass:"giftcard-details"},[_c('span',{staticClass:"icon ico ",class:'pay-' + appliedGiftcard.brand + '-small'}),_vm._v(" "),_c('div',{staticClass:"giftcard-details-text"},[_c('div',{staticClass:"details-row"},[_c('span',{staticClass:"gift-card-name"},[_vm._v(_vm._s(appliedGiftcard.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(appliedGiftcard.amount))])]),_vm._v(" "),(appliedGiftcard.amountLeft)?_c('span',{staticClass:"amount-left"},[_vm._v(_vm._s(appliedGiftcard.amountLeft + ' ' + _vm.resources.giftcards.amountRemainingOnThisCard))]):_vm._e()])])])])})],2):_c('div',{staticClass:"giftcard"},[(!_vm.isb2b)?_c('div',{staticClass:"giftcard-content"},[_c('div',{staticClass:"giftcard-row"},[_c('span',{staticClass:"giftcard-title"},[_vm._v(_vm._s(_vm.iHaveGiftcardText))]),_vm._v(" "),(!_vm.giftcardOptionsField.state.value)?_c('button',{staticClass:"giftcard-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.displayGiftcardForm(true)}}},[(_vm.appliedGiftcards.length == 0)?_c('span',{staticClass:"giftcard-text"},[_vm._v(_vm._s(_vm.resources.giftcards.add))]):_vm._e(),_vm._v(" "),(_vm.appliedGiftcards.length > 0)?_c('span',{staticClass:"giftcard-text"},[_vm._v(_vm._s(_vm.resources.giftcards.addanother))]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"giftcard-icon"})]):_vm._e()]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.giftcardOptionsField.state.value),expression:"giftcardOptionsField.state.value"}],staticClass:"giftcard-details-form vue-form"},[(_vm.hasMoreGiftCardOption)?_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":_vm.giftcardOptionsField,"tabindex":""},on:{"blur":function($event){return _vm.updateSelectedGiftcard(_vm.giftcardOptionsField.id, $event.target.value)}}})],1):_vm._e(),_vm._v(" "),(!_vm.isGiftCardSelected)?_c('div',{staticClass:"giftcard-message"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.nonSelectedGiftcardMessage))])]):_vm._e(),_vm._v(" "),(_vm.isGiftCardSelected)?_c('div',{staticClass:"giftcard-form"},[_c('GiftCard',{attrs:{"giftCardType":this.giftCardType},on:{"cancelEditing":function($event){return _vm.displayGiftcardForm(false)},"cardAdded":_vm.cardAdded}})],1):_vm._e()])]):_vm._e(),_vm._v(" "),_vm._l((_vm.appliedGiftcards),function(appliedGiftcard,index){return _c('div',{key:appliedGiftcard.id,staticClass:"applied-giftcards-container",attrs:{"value":appliedGiftcard}},[_c('div',{staticClass:"applied-giftcard"},[_c('div',{staticClass:"giftcard-details"},[_c('span',{staticClass:"icon ico ",class:'pay-' + appliedGiftcard.brand + '-small'}),_vm._v(" "),_c('div',{staticClass:"giftcard-details-text"},[_c('div',{staticClass:"details-row"},[_c('span',{staticClass:"gift-card-name"},[_vm._v(_vm._s(appliedGiftcard.name))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(appliedGiftcard.amount))])]),_vm._v(" "),(appliedGiftcard.amountLeft)?_c('span',{staticClass:"amount-left"},[_vm._v(_vm._s(appliedGiftcard.amountLeft + ' ' + _vm.resources.giftcards.amountRemainingOnThisCard))]):_vm._e()])]),_vm._v(" "),_c('button',{staticClass:"button-remove",on:{"click":function($event){return _vm.removeGiftcard(index, appliedGiftcard)}}},[_vm._v(_vm._s(_vm.resources.remove))])])])}),_vm._v(" "),(_vm.limitationForGiftCard)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.limitError))])]):_vm._e(),_vm._v(" "),(_vm.needMorePaymentInstruments)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.completeTheRemainingAmount))])]):_vm._e(),_vm._v(" "),(_vm.showRemovalMessage)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.removedGiftCard))])]):_vm._e(),_vm._v(" "),(_vm.hideKlarnaOverTime)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.cantPayWithKlarna))])]):_vm._e(),_vm._v(" "),(_vm.payingFullAmountWithGiftcard)?_c('div',[_c('div',{staticClass:"inline-alert confirmation"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.noAdditionalPaymentNeeded))])])]):_vm._e()],2)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5748cd63", __vue__options__)
  } else {
    hotAPI.reload("data-v-5748cd63", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"./giftcard/giftcard.vue":329,"axios":5,"vue":262,"vue-hot-reload-api":257,"vuex":264}],329:[function(require,module,exports){
;(function(){
'use strict';

const VueRecaptcha = require('vue-recaptcha');
const {mapState, mapGetters} = require('vuex');
const axios = require('axios');
const VueInput = require('../../../../vue-form/vue-input/vue-input.vue');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    components: {
        VueInput,
        VueRecaptcha
    },

    props: ['giftCardType'],

    data() {
        return {
            giftCardBalanceAmount: null,
            balanceError: false,
            showSpinner: false
        };
    },

    computed: {
        ...mapState('payments', [
            'resources',
            'readMode',
            'preselectedPaymentMethod',
            'appliedGiftcards',
        ]),
        ...mapGetters('payments', [
            'getField',
            'isFormValid',
            'giftcardOptionsField'
        ]),
        ...mapState('orderSummary', [
            'giftCardDeductionAmountValue',
            'orderTotalsPriceValue',
        ]),
        cardNumberField() {
            return this.getField(this.giftCardType, 'cardNumber-' + this.giftCardType);
        },
        pinField() {
            return this.getField(this.giftCardType, 'pin-' + this.giftCardType);
        },
        cardHolderName() {
            return this.getField(this.giftCardType, 'cardHolderName-' + this.giftCardType);
        },
    },

    methods: {
        updateFieldValue(fieldId, value) {
            this.$store.commit('payments/updateFieldValue', {
                formId: this.giftCardType,
                fieldId: fieldId,
                value: value
            });

            const element = this.getField(this.giftCardType, fieldId);
            if (element.validationErrors.length > 0) {
                this.$store.commit('analytics/handleCheckoutFieldError', {section: 'gift-card', message: element.validationErrors[0]});
            }
        },
        cleanForm() {
            this.giftCardBalanceAmount = null;
            this.$store.commit('payments/clearForm', this.giftCardType);
            this.$store.commit('payments/updatePropertyValue', {propertyName: 'limitationForGiftCard', value: false});
        },
        cancel() {
            this.balanceError = false;
            this.cleanForm();
            this.$emit('cancelEditing');
        },
        async submit(functionName) {
            //case when captcha is enabled
            if (this.resources.giftcards.recaptchaData.recaptchaEnabledGiftcards.indexOf(this.giftcardOptionsField.state.value) > -1) {
                this.$refs.captchaCallBack.value = functionName;
                return await this.$refs.recaptcha.execute();
            } else if (functionName.indexOf('add') > -1) {
                return this.add();
            }
            return this.checkBalance();
        },
        add(recaptchaToken) {
            if (!this.validateGiftCardForm()) {
                this.$store.commit('analytics/handleCheckoutFieldError', {section: 'payment', message: 'Gift card ' + this.giftCardType});
                return;
            }
            this.balanceError = false;
            this.showSpinner = true;
            axios.get(window.Urls.applyGiftcard, {
                timeout: 15000,
                params: {
                    name: this.giftcardOptionsField.state.selectedOption.label,
                    brand: this.giftcardOptionsField.state.value,
                    pin: this.pinField.state.value,
                    cardNumber: this.cardNumberField.state.value,
                    cardHolderName: this.cardHolderName && this.cardHolderName.state.value,
                    editMode: !this.readMode && this.preselectedPaymentMethod,
                    recaptchaToken: recaptchaToken
                }
            }).then((resp) => {
                if (!resp || !resp.data || resp.data.error || !resp.data.appliedGiftcards) {
                    this.$store.commit('payments/updatePropertyValue', {propertyName: 'giftcardPaymentError', value: resp.data.error});
                    this.giftCardBalanceAmount = resp.data.currentCardValue || this.resources.giftcards.defaultBalanceAmount;

                    if (resp.data.currentCardValue <= 0) {
                        this.balanceError = true;
                    } else if (resp.data.error && resp.data.giftcardAlreadyApplied) {
                        this.cardAlreadyInUseError = true;
                    } else {
                        this.$store.commit('payments/updatePropertyValue', {propertyName: 'limitationForGiftCard', value: true});
                        this.limitError = true;
                    }
                    this.showSpinner = false;
                    return;
                }

                this.cleanForm();
                this.$emit('cardAdded');
                this.$store.commit('payments/updatePropertyValue', {propertyName: 'giftcardPaymentError', value: null});
                this.$store.commit('payments/updatePropertyValue', {propertyName: 'limitationForGiftCard', value: resp.data.limitError});
                this.$store.dispatch('payments/setGiftCardData', resp.data);
                this.showSpinner = false;
                if (this.appliedGiftcards.length > 0 && this.giftCardDeductionAmountValue > 0 && this.orderTotalsPriceValue > 0) {
                    this.scrollIntoSection('paymentsSection');
                }
            });
        },
        checkBalance(recaptchaToken) {
            if (!this.validateGiftCardForm()) {
                return;
            }

            axios.post(window.Urls.checkBalanceRest, {
                timeout: 15000,
                params: {
                    pin: this.pinField.state.value,
                    cardNumber: this.cardNumberField.state.value,
                    brand: this.giftcardOptionsField.state.value,
                    recaptchaToken: recaptchaToken
                }
            }).then((resp) => {
                if (!resp || !resp.data || resp.data.error) {
                    this.balanceError = true;
                    this.giftCardBalanceAmount = this.resources.giftcards.defaultBalanceAmount;
                    return;
                }
                this.giftCardBalanceAmount = resp.data.giftCardBalanceAmount;
                this.balanceError = resp.data.shouldShowErrorMessage;
            });
        },
        handleRecaptchaSucess(token) {
            this.resetCaptcha();
            const recaptchaCallBack = this.$refs.captchaCallBack.value;
            if (recaptchaCallBack.indexOf('add') > -1) {
                return this.add(token);
            }
            return this.checkBalance(token);
        },
        resetCaptcha() {
            this.$refs.recaptcha.reset();
        },
        validateGiftCardForm() {
            this.$store.commit('payments/validateForm', this.giftCardType);
            return this.isFormValid(this.giftCardType);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"giftcard-card-section"},[_c('form',{staticClass:"vue-form giftcard-details-form",attrs:{"method":'POST'},on:{"submit":function($event){$event.preventDefault();return _vm.submitPostalCode($event)}}},[(_vm.cardHolderName)?_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{key:_vm.cardHolderName.id,attrs:{"element":_vm.cardHolderName},on:{"input":function ($event) { return _vm.updateFieldValue(_vm.cardHolderName.id, $event.target.value); }}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{key:_vm.cardNumberField.id,attrs:{"element":_vm.cardNumberField},on:{"input":function($event){return _vm.updateFieldValue(_vm.cardNumberField.id, $event.target.value)}}})],1),_vm._v(" "),_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('div',{staticClass:"vue-form-element"},[_c('vue-input',{key:_vm.pinField.id,attrs:{"element":_vm.pinField},on:{"input":function($event){return _vm.updateFieldValue(_vm.pinField.id, $event.target.value)}}})],1),_vm._v(" "),_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',{staticClass:"field-label"},[_vm._v(_vm._s(_vm.resources.giftcards.cardBalance))])]),_vm._v(" "),_c('div',{staticClass:"giftcard-balance"},[_c('div',{staticClass:"giftcard-amount"},[(_vm.giftCardBalanceAmount)?_c('span',[_vm._v(_vm._s(_vm.giftCardBalanceAmount))]):_c('span',[_vm._v("-")])]),_vm._v(" "),_c('button',{staticClass:"giftcard-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.submit('checkBalance')}}},[_c('span',{staticClass:"giftcard-text"},[_vm._v(_vm._s(_vm.resources.giftcards.checkBalance))])])])])]),_vm._v(" "),(_vm.balanceError)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.balanceError))])]):_vm._e(),_vm._v(" "),(_vm.limitError)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.limitError))])]):_vm._e(),_vm._v(" "),(_vm.cardAlreadyInUseError)?_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.resources.giftcards.cardAlreadyInUseError))])]):_vm._e(),_vm._v(" "),(_vm.resources.giftcards.recaptchaData.showRecaptcha)?_c('vue-recaptcha',{ref:"recaptcha",attrs:{"size":"invisible","sitekey":_vm.resources.giftcards.recaptchaData.recaptchaSiteKey},on:{"expired":_vm.resetCaptcha,"verify":_vm.handleRecaptchaSucess}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"button-row"},[_c('button',{staticClass:"giftcard-button btn",attrs:{"type":"button","disabled":_vm.showSpinner},on:{"click":function($event){return _vm.submit('add')}}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                    "+_vm._s(_vm.resources.giftcards.useThisCard)+"\n                ")]:_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"giftcard-button",attrs:{"type":"button"},on:{"click":_vm.cancel}},[_c('span',{staticClass:"giftcard-text"},[_vm._v(_vm._s(_vm.resources.cancel))])])]),_vm._v(" "),_c('vue-input',{ref:"captchaCallBack",attrs:{"hidden":""}})],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ad5e65c", __vue__options__)
  } else {
    hotAPI.reload("data-v-2ad5e65c", __vue__options__)
  }
})()}

},{"../../../../vue-form/vue-input/vue-input.vue":415,"../../../checkout-submit-handler":287,"axios":5,"vue":262,"vue-hot-reload-api":257,"vue-recaptcha":259,"vuex":264}],330:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

const Klarna = require('./payment-methods/klarna/klarna.vue');
const CreditCards = require('./payment-methods/credit-cards/credit-cards.vue');
const Banks = require('./payment-methods/banks/banks.vue');
const Bancontact = require('./payment-methods/bancontact/bancontact-cards.vue');
const Mbway = require('./payment-methods/mbway/mbway.vue');
const Blik = require('./payment-methods/blik/blik.vue');
const AmazonPayHelper = require('../../../../payment-methods/amazonpay');
const CheckoutSubmitHandler = require('../../checkout-submit-handler');

module.exports = {
    components: {
        Klarna,
        CreditCards
    },
    mixins: [CheckoutSubmitHandler],
    props: ['method', 'isSelected', 'readOnly'],
    computed: {
        ...mapState('payments', ['resources', 'selectedPaymentMethod', 'paymentMethodResponse', 'paymentDescriptor']),
        ...mapState('orderSummary', ['orderTotalsPriceValue']),
        methodTileType() {
            switch (this.method.type) {
                case 'scheme':
                    return CreditCards;
                case 'klarna':
                case 'klarna_account':
                case 'klarna_b2b':
                    return Klarna;
                case 'eps':
                case 'ideal':
                case 'onlineBanking_PL':
                    return Banks;
                case 'bcmc':
                    return Bancontact;
                case 'mbway':
                    return Mbway;
                case 'blik':
                    return Blik;
                default:
                    return null;
            }
        }
    },

    methods: {
        selectMethod(method) {
            const newMethod = {...method};
            this.selectedMethod = newMethod;
            this.$emit('selected', newMethod);
        },
        calculateIcon(method) {
            if (this.isCreditCardInReadOnlyMode(method)) {
                return (
                    'https://checkoutshopper-live.adyen.com/checkoutshopper/images/logos/' +
                    this.selectedPaymentMethod.cardData.brand +
                    '.svg'
                );
            }

            return method.type;
        },
        getMethodName(method) {
            if (this.isCreditCardInReadOnlyMode(method)) {
                return this.selectedPaymentMethod.cardData.name + ' Card';
            }
            return method.name;
        },

        isCreditCardInReadOnlyMode(method) {
            if (
                ['scheme', 'bcmc'].indexOf(method.type) >= 0 &&
                ['scheme', 'bcmc'].indexOf(this.selectedPaymentMethod.type) >= 0 &&
                this.readOnly &&
                this.selectedPaymentMethod.cardData
            ) {
                return true;
            }

            return false;
        },
        showAmazonPaymentDescriptor(method) {
            if (
                ['amazonpay'].indexOf(method.type) >= 0 &&
                ['amazonpay'].indexOf(this.selectedPaymentMethod.type) >= 0 &&
                this.readOnly &&
                AmazonPayHelper.getAmazonSessionID()
            ) {
                return true;
            }
            return false;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.method)?_c('div',{staticClass:"checkout-tile payment-tile",class:['input-type-radio ', 'js-' + _vm.method.type, _vm.method.type],attrs:{"id":'js-' + _vm.method.type}},[(!_vm.readOnly)?_c('input',{staticClass:"input-radio required",class:[_vm.method.type],attrs:{"type":"radio","id":_vm.method.type,"name":"paymentMethod","data-required-text":_vm.resources.error},domProps:{"checked":_vm.isSelected},on:{"click":function($event){return _vm.selectMethod(_vm.method)}}}):_vm._e(),_vm._v(" "),_c('label',{class:'checkout-payment-radio' + [_vm.readOnly ? ' readonly' : ''],attrs:{"for":_vm.method.type}},[_c('span',{staticClass:"tile-title"},[(!_vm.isCreditCardInReadOnlyMode(_vm.method))?_c('span',{staticClass:"ico",class:['pay-' + _vm.calculateIcon(_vm.method)]}):_c('span',[_c('img',{staticClass:"creditcard-image",attrs:{"src":_vm.calculateIcon(_vm.method)}})]),_vm._v("\n      "+_vm._s(_vm.getMethodName(_vm.method))+"\n      "),(_vm.showAmazonPaymentDescriptor(_vm.method))?_c('span',{staticClass:"payment-descriptor"},[_vm._v("\n        "+_vm._s(_vm.paymentDescriptor)+"\n      ")]):_vm._e()]),_vm._v(" "),(_vm.isSelected)?_c(_vm.methodTileType,{tag:"component",attrs:{"method":_vm.method,"methodId":_vm.method.type,"readOnly":_vm.readOnly},on:{"selected":function($event){return _vm.selectMethod(_vm.method, $event)}}}):_vm._e()],1)]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-16a90bc0", __vue__options__)
  } else {
    hotAPI.reload("data-v-16a90bc0", __vue__options__)
  }
})()}

},{"../../../../payment-methods/amazonpay":571,"../../checkout-submit-handler":287,"./payment-methods/bancontact/bancontact-cards.vue":331,"./payment-methods/banks/banks.vue":332,"./payment-methods/blik/blik.vue":333,"./payment-methods/credit-cards/credit-cards.vue":335,"./payment-methods/klarna/klarna.vue":336,"./payment-methods/mbway/mbway.vue":337,"vue":262,"vue-hot-reload-api":257,"vuex":264}],331:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AdyenCheckout = require('@adyen/adyen-web');
const CreditCards3DS = require('../credit-cards-3ds/credit-cards-3ds.vue');

module.exports = {
    components: {
        CreditCards3DS
    },

    data() {
        return {
            component: null,
            brandImageUrl: null,
            cardNumberField: {
                valid: false,
                focusLost: false
            },
            expiryField: {
                valid: false,
                focusLost: false
            },
            ignoreFocusLost: false,
            checkout: null
        };
    },

    props: ['method', 'readOnly'],

    computed: {
        ...mapState('payments', [
            'resources',
            'environment',
            'clientKey',
            'locale',
            'paymentData',
            'selectedPaymentMethod',
            'focusCreditCardBlock',
            'isMember',
            'paymentRequiredActionData',
            'setSecuredFieldsStyle'
        ]),

        cardNumberInvalid() {
            return this.validateField(this.cardNumberField);
        },
        expiryDateInvalid() {
            return this.validateField(this.expiryField);
        },
        holderName() {
            if (this.selectedPaymentMethod.cardData) {
                return this.selectedPaymentMethod.cardData.holderName != 'Checkout Shopper PlaceHolder' ?
                    this.selectedPaymentMethod.cardData.holderName || '' : '';
            }

            return '';
        },
        lastFour() {
            if (this.selectedPaymentMethod.cardData) {
                return 'XXXX XXXX XXXX X' + this.selectedPaymentMethod.cardData.lastFour.substring(1,4);
            }

            return '';
        },
        expiryDate() {
            if (this.selectedPaymentMethod.cardData) {
                return this.selectedPaymentMethod.cardData.expiryMonth + '/' + this.selectedPaymentMethod.cardData.expiryYear.substring(2,4);
            }

            return '';
        }
    },

    watch: {
        focusCreditCardBlock(val) {
            if (!val) {
                return;
            }
            this.ignoreFocusLost = true;
            this.$store.commit('payments/focusCreditCardBlock', false);
        },
        paymentRequiredActionData(val) {
            if (!val) {
                return;
            }

            if (val.type == 'redirect') {
                this.handlePaymentRequiredActionData(val, this.component);
                return;
            }

            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'creditCards3DS',
                content: CreditCards3DS,
                store: this.$store,
            });
        }
    },

    mounted() {
        this.initComponent();
    },

    methods: {
        initComponent() {
            if (this.selectedPaymentMethod.type != 'bcmc') {
                return;
            }
            const $that = this;
            const checkout = new AdyenCheckout({
                locale: $that.locale,
                environment: $that.environment,
                clientKey: $that.clientKey
            });

            this.brandImageUrl = null;
            if ($that.readOnly) {
                $that.cardNumberField.valid = true;
                $that.expiryField.valid = true;
            }
            checkout.create('securedfields', {
                type: 'card',
                hasHolderName: true,
                brands: ['bcmc'],
                styles: $that.setSecuredFieldsStyle,
                onChange: function(state, component) {
                    const paymentData = state.isValid ? state.data : null;
                    $that.component = component;
                    $that.$store.commit('payments/setShopperInteraction', null);
                    if (state.isValid && $that.readOnly && $that.selectedPaymentMethod.cardData && $that.selectedPaymentMethod.cardData.id) {
                        paymentData.paymentMethod.storedPaymentMethodId = $that.selectedPaymentMethod.cardData.id;
                        $that.$store.commit('payments/setShopperInteraction', $that.extractShopperInteraction());
                    }
                    $that.$store.commit('payments/setAdyenPaymentData', paymentData);
                    $that.$store.commit('payments/setBrandCode', this.brands[0]);
                },
                onFieldValid: function (field) {
                    if (field.fieldType == 'encryptedCardNumber') {
                        $that.cardNumberField.valid = field.valid;
                    } else if (field.fieldType == 'encryptedExpiryDate') {
                        $that.expiryField.valid = field.valid;
                    }
                },
                onFocus: function (field) {
                    $that.$store.commit('analytics/handlePaymentsInteraction', this.selectedPaymentMethod);
                    if (field.focus) {
                        return;
                    }
                    if (field.fieldType == 'encryptedCardNumber') {
                        $that.cardNumberField.focusLost = true;
                    } else if (field.fieldType == 'encryptedExpiryDate') {
                        $that.expiryField.focusLost = true;
                    }
                }
            }).mount('#custom-bcmc-container');
        },

        extractShopperInteraction() {
            if (!this.selectedPaymentMethod || !this.selectedPaymentMethod.cardData
                || !this.selectedPaymentMethod.cardData.supportedShopperInteractions || this.selectedPaymentMethod.cardData.supportedShopperInteractions.length == 0) {
                return null;
            }

            if (this.selectedPaymentMethod.cardData.supportedShopperInteractions.indexOf('ContAuth') > -1) {
                return 'ContAuth';
            }

            return this.selectedPaymentMethod.cardData.supportedShopperInteractions[0];
        },
        updatePaymentData($event) {
            if (!this.paymentData) {
                return;
            }

            if ($event.target.id == 'cardHolderName') {
                this.$store.commit('payments/setCardHolderName', $event.target.value);
            } else if ($event.target.id == 'saveCreditCard') {
                this.$store.commit('payments/setSaveCreditCard', $event.target.value);
            }
        },

        allowNonNumbersOnly: function ($event) {
            const keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if (keyCode > 47 && keyCode < 58) {
                $event.preventDefault();
                return;
            }
            return true;
        },

        validateField(field) {
            return this.ignoreFocusLost ? !field.valid : (field.focusLost && !field.valid);
        },

        handlePaymentRequiredActionData(paymentRequiredActionData, component) {
            component.handleAction(paymentRequiredActionData);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credit-card-section"},[(_vm.readOnly && _vm.selectedPaymentMethod.cardData)?_c('div',{attrs:{"id":"custom-bcmc-container"}},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',{staticClass:"cardHolderName"},[_vm._v(_vm._s(_vm.holderName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lastFour))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.expiryDate))])])])])])]):_c('div',{attrs:{"id":"custom-bcmc-container"}},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.number))]),_vm._v(" "),(_vm.cardNumberInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedCardNumber-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedCardNumber"}},[_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.brandImageUrl}})])])])]),_vm._v(" "),_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.expiryDate))]),_vm._v(" "),(_vm.expiryDateInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedExpiryDate-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedExpiryDate"}})])])]),_vm._v(" "),_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element half-width"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.holderName))]),_vm._v(" "),(_vm.holderNameInvalid)?_c('span',{staticClass:"error",attrs:{"id":"cardHolderName-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"cardHolderName"},on:{"keypress":_vm.allowNonNumbersOnly,"change":_vm.updatePaymentData}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMember),expression:"isMember"}],staticClass:"vue-form-row no-label"},[_c('div',{staticClass:"vue-form-element"},[_c('div',{staticClass:"vue-form-group"},[_c('div',{staticClass:"vue-form-group-item"},[_c('input',{staticClass:"vue-input vue-input-checkbox",attrs:{"type":"checkbox","id":"saveCreditCard"},on:{"change":_vm.updatePaymentData}}),_vm._v(" "),_c('label',{attrs:{"for":"saveCreditCard"}},[_vm._v(_vm._s(_vm.resources.creditCards.saveCard))])])])])])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b80cb5e4", __vue__options__)
  } else {
    hotAPI.reload("data-v-b80cb5e4", __vue__options__)
  }
})()}

},{"../credit-cards-3ds/credit-cards-3ds.vue":334,"@adyen/adyen-web":1,"vue":262,"vue-hot-reload-api":257,"vuex":264}],332:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

const VueInput = require('../../../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    components: {
        VueInput
    },
    props: ['method'],
    computed: {
        ...mapState('payments', ['resources', 'selectedPaymentMethod', 'readMode']),
        bankOptionsField() {
            return this.$store.getters['payments/bankOptionsField'](this.selectedPaymentMethod.type);
        }
    },

    mounted() {
        if (this.bankOptionsField.state.value) {
            this.method.issuerId = this.bankOptionsField.state.value;
        }
    },

    methods: {
        updateSelectedBank(fieldId, issuerId) {
            if (!issuerId || this.method.issuerId === issuerId) {
                return;
            }

            this.method.issuerId = issuerId;

            if (this.readMode) {
                this.$emit('selected');
            }

            this.$store.commit('payments/updateFieldValue', {
                formId: this.method.type,
                fieldId: fieldId,
                value: issuerId
            });
        },
        setPaymentMethod() {
            return this.$store.dispatch('payments/setSelectedPaymentMethod', {
                paymentMethod: this.selectedPaymentMethod,
                revertChanges: false
            });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.readMode)?_c('div',[_c('span',{staticClass:"select-bank-title"},[_vm._v(_vm._s(_vm.resources.banks.selectBank))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"giftcard-details-form vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{key:_vm.bankOptionsField.id,attrs:{"element":_vm.bankOptionsField,"tabindex":""},on:{"blur":function($event){return _vm.updateSelectedBank(_vm.bankOptionsField.id, $event.target.value)}}})],1)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1c5a4088", __vue__options__)
  } else {
    hotAPI.reload("data-v-1c5a4088", __vue__options__)
  }
})()}

},{"../../../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257,"vuex":264}],333:[function(require,module,exports){
;(function(){
'use strict';

const VueInput = require('../../../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    components: {
        VueInput
    },
    props: ['method'],
    computed: {
        blikPincodeField() {
            return this.$store.getters['payments/blikField'];
        }
    },

    methods: {
        updatePincode(fieldId, pincode) {

            this.$store.commit('payments/updateFieldValue', {
                formId: 'blik',
                fieldId: fieldId,
                value: pincode
            });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"giftcard-details-form vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{key:_vm.blikPincodeField.id,attrs:{"element":_vm.blikPincodeField,"tabindex":""},on:{"blur":function($event){return _vm.updatePincode(_vm.blikPincodeField.id, $event.target.value)}}})],1)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2e32ecd0", __vue__options__)
  } else {
    hotAPI.reload("data-v-2e32ecd0", __vue__options__)
  }
})()}

},{"../../../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257}],334:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AdyenCheckout = require('@adyen/adyen-web');
const axios = require('axios');
const CheckoutSubmitHandler = require('../../../../checkout-submit-handler');

module.exports = {
    mixins: [CheckoutSubmitHandler],
    computed: {
        ...mapState('payments', [
            'environment',
            'clientKey',
            'locale',
            'selectedPaymentMethod',
            'paymentRequiredActionData',
            'paymentData'
        ]),

        isActive() {
            return (
                this.paymentRequiredActionData &&
                this.selectedPaymentMethod &&
                ['bcmc', 'scheme'].indexOf(this.selectedPaymentMethod.type) > -1
            );
        }
    },

    mounted() {
        this.initComponent();
    },

    methods: {
        initComponent() {
            if (!this.isActive) {
                return;
            }

            const $that = this;
            const checkout = new AdyenCheckout({
                locale: $that.locale,
                environment: $that.environment,
                clientKey: $that.clientKey,
                onAdditionalDetails: $that.onAdditionalDetailsCallback
            });

            checkout.createFromAction(this.paymentRequiredActionData).mount('#customCard-action-container');
        },

        async onAdditionalDetailsCallback(state) {
            window.eventBus.$emit('processingPayment', false);

            await axios
                .post(this.selectedPaymentMethod.detailsUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: this.paymentData.brandCode
                    },
                    data: {
                        data: state.data
                    }
                })
                .then((response) => {
                    if (response.data.error) {
                        this.$store.commit('payments/setPaymentMethodError', response.data.errorMessage);
                        window.eventBus.$emit('processingPayment', true);
                        window.eventBus.$emit('shouldCloseFlyin');
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    if (response.data.redirectToURL) {
                        window.location.href = response.data.redirectToURL;
                        return;
                    }

                    window.eventBus.$emit('processingPayment', true);
                    console.error('onAdditionalDetailsCallback: Server responded with unknown response', response.data);
                });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{staticClass:"custom-card-action-container",attrs:{"id":"customCard-action-container"}}):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5540c518", __vue__options__)
  } else {
    hotAPI.reload("data-v-5540c518", __vue__options__)
  }
})()}

},{"../../../../checkout-submit-handler":287,"@adyen/adyen-web":1,"axios":5,"vue":262,"vue-hot-reload-api":257,"vuex":264}],335:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AdyenCheckout = require('@adyen/adyen-web');
const CreditCards3DS = require('../credit-cards-3ds/credit-cards-3ds.vue');

module.exports = {
    components: {
        CreditCards3DS
    },

    data() {
        return {
            isValidCardHolderName: true,
            component: null,
            brandImageUrl: null,
            cardNumberField: {
                valid: false,
                focusLost: false
            },
            expiryField: {
                valid: false,
                focusLost: false
            },
            cvcField: {
                valid: false,
                focusLost: false
            },
            ignoreFocusLost: false,
            checkout: null,
            supportedCoBrands: null,
            securedFields: null
        };
    },

    props: ['method', 'readOnly'],

    computed: {
        ...mapState('payments', [
            'resources',
            'environment',
            'clientKey',
            'locale',
            'paymentData',
            'selectedPaymentMethod',
            'focusCreditCardBlock',
            'isMember',
            'showSaveOption',
            'paymentRequiredActionData',
            'setSecuredFieldsStyle'
        ]),

        cardNumberInvalid() {
            return this.validateField(this.cardNumberField);
        },
        expiryDateInvalid() {
            return this.validateField(this.expiryField);
        },
        cvcInvalid() {
            return this.validateField(this.cvcField);
        },
        holderName() {
            if (this.selectedPaymentMethod.cardData) {
                return this.selectedPaymentMethod.cardData.holderName != 'Checkout Shopper PlaceHolder' ?
                    this.selectedPaymentMethod.cardData.holderName || '' : '';
            }

            return '';
        },
        lastFour() {
            if (this.selectedPaymentMethod.cardData) {
                return 'XXXX XXXX XXXX X' + this.selectedPaymentMethod.cardData.lastFour.substring(1, 4);
            }

            return '';
        },
        expiryDate() {
            if (this.selectedPaymentMethod.cardData) {
                return this.selectedPaymentMethod.cardData.expiryMonth + '/' + this.selectedPaymentMethod.cardData.expiryYear.substring(2, 4);
            }

            return '';
        },
        cardType() {
            if (this.selectedPaymentMethod.cardData) {
                return this.selectedPaymentMethod.cardData.brand;
            }

            return 'card';
        }
    },

    watch: {
        focusCreditCardBlock(val) {
            if (!val) {
                return;
            }
            this.ignoreFocusLost = true;
            this.$store.commit('payments/focusCreditCardBlock', false);
        },
        paymentRequiredActionData(val) {
            if (!val) {
                return;
            }

            if (val.type == 'redirect') {
                this.handlePaymentRequiredActionData(val, this.component);
                return;
            }

            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'creditCards3DS',
                content: CreditCards3DS,
                store: this.$store,
                className: 'credit-card-flyin'
            });
        }
    },

    mounted() {
        this.initComponent();
    },

    methods: {
        initComponent() {
            if (this.selectedPaymentMethod.type != 'scheme') {
                return; // skip loading component on page load if it is not the selected payment method
            }
            const $that = this;
            const checkout = new AdyenCheckout({
                locale: $that.locale,
                environment: $that.environment,
                clientKey: $that.clientKey
            });

            let type = 'card';
            this.brandImageUrl = null;
            if ($that.readOnly) {
                type = $that.cardType;
                $that.cardNumberField.valid = true;
                $that.expiryField.valid = true;
            }
            this.securedFields = checkout.create('securedfields', {
                type: type,
                brands: $that.method.brands,
                styles: $that.setSecuredFieldsStyle,
                ariaLabels: {
                    lang: 'en-GB',
                    encryptedCardNumber: {
                        label: 'Credit or debit card number field'
                    }
                },
                onChange: function (state, component) {
                    const paymentData = state.isValid ? state.data : null; // state.data - Provides the data that you need to pass in the `/payments` call.
                    $that.component = component;
                    $that.$store.commit('payments/setShopperInteraction', null);
                    if (state.isValid && $that.readOnly && $that.selectedPaymentMethod.cardData && $that.selectedPaymentMethod.cardData.id) {
                        paymentData.paymentMethod.storedPaymentMethodId = $that.selectedPaymentMethod.cardData.id;
                        $that.$store.commit('payments/setShopperInteraction', $that.extractShopperInteraction());
                    }
                    $that.$store.commit('payments/setAdyenPaymentData', paymentData);
                },
                onValid: function () { }, /* eslint-disable-line no-empty-function */
                onLoad: function () { }, /* eslint-disable-line no-empty-function */
                onFieldValid: function (field) {
                    if (field.fieldType == 'encryptedCardNumber') {
                        $that.cardNumberField.valid = field.valid;
                    } else if (field.fieldType == 'encryptedExpiryDate') {
                        $that.expiryField.valid = field.valid;
                    } else if (field.fieldType == 'encryptedSecurityCode') {
                        $that.cvcField.valid = field.valid;
                    }
                },
                onBrand: function (state) {
                    $that.$store.commit('payments/setBrandCode', state.brand);
                    $that.brandImageUrl = state.brandImageUrl;
                },
                onError: function () { }, /* eslint-disable-line no-empty-function */
                onFocus: function (field) {
                    $that.$store.commit('analytics/handlePaymentsInteraction', this.selectedPaymentMethod);
                    if (field.focus) {
                        return; // do not validate on focus; validate only on focus lost
                    }
                    if (field.fieldType == 'encryptedCardNumber') {
                        $that.cardNumberField.focusLost = true;
                    } else if (field.fieldType == 'encryptedExpiryDate') {
                        $that.expiryField.focusLost = true;
                    } else if (field.fieldType == 'encryptedSecurityCode') {
                        $that.cvcField.focusLost = true;
                    }
                },
                onBinValue: function () {}, /* eslint-disable-line no-empty-function */
                onBinLookup(pCallbackObj) {
                    // Handle a dual branded result
                    if (pCallbackObj.supportedBrandsRaw.length > 1) {
                        $that.supportedCoBrands = pCallbackObj.supportedBrandsRaw;
                        $that.supportedCoBrands[0].selected = true;
                    }
                }
            }).mount('#customCard-container');
        },

        dualBrandListener(e){
            this.selectCoBrandedCard(e);
            this.securedFields.dualBrandingChangeHandler(e);
        },

        selectCoBrandedCard(e){
            const parentElement = document.getElementById('pmWrapperDual');
            const inputNodes = parentElement.getElementsByTagName('INPUT');
            for (let i = 0; i < inputNodes.length; i++){
                if (inputNodes[i].type === 'radio'){
                    inputNodes[i].checked = false;
                }
            }
            e.currentTarget.children[0].checked = true;
        },

        extractShopperInteraction() {
            if (!this.selectedPaymentMethod || !this.selectedPaymentMethod.cardData
                || !this.selectedPaymentMethod.cardData.supportedShopperInteractions || this.selectedPaymentMethod.cardData.supportedShopperInteractions.length == 0) {
                return null;
            }

            if (this.selectedPaymentMethod.cardData.supportedShopperInteractions.indexOf('ContAuth') > -1) {
                return 'ContAuth';
            }

            return this.selectedPaymentMethod.cardData.supportedShopperInteractions[0]; // ECommerce
        },

        updatePaymentData($event) {
            if (!this.paymentData) {
                return;
            }

            if ($event.target.id == 'cardHolderName') {
                this.$store.commit('payments/setCardHolderName', $event.target.value);
            } else if ($event.target.id == 'saveCreditCard') {
                this.$store.commit('payments/setSaveCreditCard', $event.target.value);
            }
        },

        allowNonNumbersOnly: function ($event) {
            const keyCode = $event.keyCode ? $event.keyCode : $event.which;
            if (keyCode > 47 && keyCode < 58) {
                $event.preventDefault();
                return;
            }
            return true;
        },

        allowWordsOnly(event) {
            const regex = /^[^\p{P}<>\{\}\[\];:\\|\/?#$0-9~^=+]*$/u; //Allow unicode word characters, but not numbers or code characters
            const isValid = regex.test(event.target.value) && regex.test(event.key);
            this.isValidCardHolderName = isValid;
            if (!isValid){
                event.preventDefault();
            }
        },

        validateField(field) {
            if (this.ignoreFocusLost ? !field.valid : (field.focusLost && !field.valid)) {
                this.$store.commit('analytics/handleCheckoutFieldError', {section: 'payment', message: 'Input is invalid'});
            }
            return this.ignoreFocusLost ? !field.valid : (field.focusLost && !field.valid);
        },

        handlePaymentRequiredActionData(paymentRequiredActionData, component) {
            component.handleAction(paymentRequiredActionData);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"credit-card-section"},[(_vm.readOnly && _vm.selectedPaymentMethod.cardData)?_c('div',{attrs:{"id":"customCard-container"}},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',{staticClass:"cardHolderName"},[_vm._v(_vm._s(_vm.holderName))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lastFour))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.expiryDate))])])])]),_vm._v(" "),_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element half-width"},[_c('label',[_c('span',{staticClass:"field-label"},[_vm._v("\n                           "+_vm._s(_vm.resources.creditCards.cvc)+"\n                            "),_c('span',{staticClass:"field-help"},[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.cvcHelpText))])])]),_vm._v(" "),(_vm.cvcInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedSecurityCode-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_vm._m(0)])])])])]):_c('div',{attrs:{"id":"customCard-container"}},[_c('div',{staticClass:"vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.number))]),_vm._v(" "),(_vm.cardNumberInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedCardNumber-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedCardNumber"}},[_c('img',{staticClass:"brand-logo",attrs:{"src":_vm.brandImageUrl}})])])])]),_vm._v(" "),_c('div',{staticClass:"vue-form-row has-multiple-elements"},[_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.expiryDate))]),_vm._v(" "),(_vm.expiryDateInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedExpiryDate-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedExpiryDate"}})])]),_vm._v(" "),_c('div',{staticClass:"vue-form-element"},[_c('label',[_c('span',{staticClass:"field-label"},[_vm._v("\n                            "+_vm._s(_vm.resources.creditCards.cvc)+"\n                            "),_c('span',{staticClass:"field-help"},[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.cvcHelpText))])])]),_vm._v(" "),(_vm.cvcInvalid)?_c('span',{staticClass:"error",attrs:{"id":"encryptedSecurityCode-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"vue-form-row"},[_c('div',{staticClass:"vue-form-element half-width"},[_c('label',[_c('span',[_vm._v(_vm._s(_vm.resources.creditCards.holderName))]),_vm._v(" "),(!_vm.isValidCardHolderName)?_c('span',{staticClass:"error",attrs:{"id":"cardHolderName-error"}},[_vm._v(_vm._s(_vm.resources.errors.invalidInput))]):_vm._e(),_vm._v(" "),_c('input',{attrs:{"type":"text","id":"cardHolderName"},on:{"input":_vm.allowWordsOnly,"keypress":_vm.allowWordsOnly,"focus":_vm.allowWordsOnly,"blur":_vm.allowWordsOnly,"change":_vm.updatePaymentData}})])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSaveOption),expression:"showSaveOption"}],staticClass:"vue-form-row no-label"},[_c('div',{staticClass:"vue-form-element"},[_c('div',{staticClass:"vue-form-group"},[_c('div',{staticClass:"vue-form-group-item"},[_c('input',{staticClass:"vue-input vue-input-checkbox",attrs:{"type":"checkbox","id":"saveCreditCard"},on:{"change":_vm.updatePaymentData}}),_vm._v(" "),_c('label',{attrs:{"for":"saveCreditCard"}},[_vm._v(_vm._s(_vm.resources.creditCards.saveCard))])])])])]),_vm._v(" "),(_vm.supportedCoBrands && _vm.supportedCoBrands.length > 0)?_c('div',{staticClass:"vue-form-row co-branded-cards",attrs:{"id":"pmWrapperDual"}},[_c('div',{staticClass:"vue-form-element"},_vm._l((_vm.supportedCoBrands),function(element){return _c('div',{staticClass:"vue-form-group-item",attrs:{"data-value":element.brand},on:{"click":_vm.dualBrandListener}},[_c('input',{staticClass:"vue-input vue-input-radio",attrs:{"type":"radio","data-value":element.brand},domProps:{"checked":element.selected}}),_vm._v(" "),_c('label',{attrs:{"data-value":element.brand}},[_c('img',{staticClass:"brand-logo",attrs:{"src":element.brandImageUrl,"data-value":element.brand,"alt":element.brand}}),_vm._v(" "),_c('span',{attrs:{"data-value":element.brand}},[_vm._v(_vm._s(element.localeBrand))])])])}),0)]):_vm._e()])])])}
__vue__options__.staticRenderFns = [function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedSecurityCode"}},[_c('span',{staticClass:"icon icon-card-payment"})])},function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-wrapper",attrs:{"data-cse":"encryptedSecurityCode"}},[_c('span',{staticClass:"icon icon-card-payment"})])}]
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-56ea4578", __vue__options__)
  } else {
    hotAPI.reload("data-v-56ea4578", __vue__options__)
  }
})()}

},{"../credit-cards-3ds/credit-cards-3ds.vue":334,"@adyen/adyen-web":1,"vue":262,"vue-hot-reload-api":257,"vuex":264}],336:[function(require,module,exports){
;(function(){
'use strict';

const KlarnaHelper = require('../../../../../../payment-methods/klarna');
const axios = require('axios');
const CheckoutSubmitHandler = require('../../../../checkout-submit-handler');
const {mapState, mapGetters} = require('vuex');
const _ = require('lodash');

module.exports = {
    mixins: [CheckoutSubmitHandler],
    props: ['method'],
    watch: {
        ...[
            'detailsEditMode',
            'deliverySummary.editMode',
            'selectedDeliveryMethod.id',
            'selectedDeliveryOption.id',
            'selectedPaymentMethod.type',
            'getFormsAsJSON',
            'orderTotalsPrice',
            'couponCodeValue'
        ].reduce(
            (watchers, key) => ({
                ...watchers,
                [key](newVal, oldVal) {
                    if (!this.checkIfAllBlocksAreValid()) {
                        return;
                    }

                    if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                        return;
                    }

                    this.initKlarnaWidget();
                }
            }),
            {}
        )
    },
    computed: {
        ...mapState('orderSummary', ['orderTotalsPrice']),
        ...mapState('payments', ['resources', 'adyenData']),
        ...mapGetters('details', ['getFormsAsJSON']),
        ...mapGetters('delivery', ['selectedDeliveryOption']),
        ...mapState('error', ['errorMessage']),
        ...mapState('coupons', ['couponCodeValue']),
        isActive() {
            if (!this.method || ['klarna', 'klarna_account', 'klarna_b2b'].indexOf(this.method.type) < 0) {
                return false;
            }

            if (
                !this.selectedPaymentMethod ||
                ['klarna', 'klarna_account', 'klarna_b2b'].indexOf(this.selectedPaymentMethod.type) < 0
            ) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.preselectedPaymentMethod || (this.preselectedPaymentMethod && this.readMode)) {
                return true;
            }

            return false;
        },
        isBillie() {
            return this.selectedPaymentMethod.type === 'klarna_b2b';
        }
    },

    mounted() {
        this.initKlarnaWidget();
    },

    methods: {
        initKlarnaWidget: _.debounce(async function () {
            if (!this.isActive) {
                this.updateKlarnaData(null);
                return;
            }
            const validationResult = this.checkIfAllBlocksAreValid();
            if (!validationResult) {
                this.updateKlarnaData(null);
                return;
            }
            if (!this.hasSavedAddress) {
                const result = await this.$store.dispatch('details/postForms', true);
                if (!result) {
                    this.updateKlarnaData(null);
                    return;
                }
            }

            this.getKlarnaData();
        }, 500),
        getKlarnaData() {
            initPaymentsModal.show();
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: this.selectedPaymentMethod.type,
                        payment: {
                            paymentMethod: {
                                type: this.selectedPaymentMethod.type,
                                subtype: 'sdk'
                            }
                        }
                    }
                })
                .then((response) => {
                    if (response.data.error) {
                        this.$store.commit('payments/setPaymentMethodError', response.data.errorMessage);
                        this.updateKlarnaData(null);
                        return;
                    }
                    const adyenData = this.extractAdyenDataFromPaymentResponse(response.data.paymentResponse);
                    const selectedPaymentMethod = this.selectedPaymentMethod.type;

                    KlarnaHelper.init(
                        selectedPaymentMethod,
                        adyenData,
                        function callbackFunction(initResponse) {
                            if (!initResponse || !initResponse.show_form) {
                                this.updateKlarnaData(null);
                                return;
                            }
                            this.updateKlarnaData(adyenData);
                        }.bind(this)
                    );
                });
        },
        extractAdyenDataFromPaymentResponse(paymentResponse) {
            if (!paymentResponse || !paymentResponse.fullResponse || !paymentResponse.fullResponse.action) {
                return null;
            }
            const action = paymentResponse.fullResponse.action;
            if (!action.paymentData || !action.sdkData || !action.sdkData.client_token) {
                return null;
            }

            return {
                clientToken: action.sdkData.client_token,
                paymentData: action.paymentData
            };
        },
        updateKlarnaData(klarnaData) {
            const adyenData = {
                loaded: false,
                clientToken: null,
                paymentData: null
            };

            if (klarnaData) {
                adyenData.loaded = true;
                adyenData.clientToken = klarnaData.clientToken;
                adyenData.paymentData = klarnaData.paymentData;
            }

            this.$store.commit('payments/updatePropertyValue', {propertyName: 'adyenData', value: adyenData});

            if (adyenData.loaded) {
                this.$store.commit('payments/setPaymentMethodError', null);
                if (
                    [this.resources.errors.missingFields, this.detailsResources.postalTopBanerError].indexOf(
                        this.errorMessage
                    ) > -1
                ) {
                    this.$store.commit('error/setErrorMessage', null, {root: true});
                }
            }
            initPaymentsModal.close();
        }
    }
};
const initPaymentsModal = {
    show: () => {
        window.eventBus.$emit('shouldOpenModal', {
            paragraphs: [
                {
                    text: Resources['MODAL_INIT_PAYMENTS_MESSAGE']
                }
            ],
            closeElement: null,
            ctaHolder: {},
            hideCloseButton: true
        });
    },
    close: () => {
        window.eventBus.$emit('shouldCloseModal');
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isActive)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.adyenData && _vm.adyenData.loaded),expression:"adyenData && adyenData.loaded"}],staticClass:"klarna-payments-container",class:_vm.isBillie ? 'billie-container' : '',attrs:{"id":"klarna-payments-container"}}):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-4c1b1638", __vue__options__)
  } else {
    hotAPI.reload("data-v-4c1b1638", __vue__options__)
  }
})()}

},{"../../../../../../payment-methods/klarna":573,"../../../../checkout-submit-handler":287,"axios":5,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],337:[function(require,module,exports){
;(function(){
'use strict';

const VueInput = require('../../../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    components: {
        VueInput
    },
    props: ['method'],
    computed: {
        mbwayPhoneNumberField() {
            return this.$store.getters['payments/mbwayField'];
        }
    },

    methods: {
        updatePhoneNumber(fieldId, phoneNumber) {
            this.$store.commit('payments/updateFieldValue', {
                formId: 'mbway',
                fieldId: fieldId,
                value: phoneNumber
            });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"giftcard-details-form vue-form"},[_c('div',{staticClass:"vue-form-row"},[_c('vue-input',{key:_vm.mbwayPhoneNumberField.id,attrs:{"element":_vm.mbwayPhoneNumberField,"tabindex":""},on:{"blur":function($event){return _vm.updatePhoneNumber(_vm.mbwayPhoneNumberField.id, $event.target.value)}}})],1)])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-004aa364", __vue__options__)
  } else {
    hotAPI.reload("data-v-004aa364", __vue__options__)
  }
})()}

},{"../../../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257}],338:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const axios = require('axios');

module.exports = {
    data() {
        return {
            shouldRun: false
        };
    },

    computed: {
        ...mapState('payments', ['resources', 'selectedPaymentMethod']),
        text() {
            const paymentMethodType = this.selectedPaymentMethod.type;
            return this.resources[paymentMethodType].flyinText;
        },
        icon() {
            return 'pay-' + this.selectedPaymentMethod.type;
        }
    },

    props: ['responseData'],

    mounted() {
        this.initComponent();
    },

    methods: {
        initComponent() {
            this.shouldRun = true;
            this.checkPaymentStatus(this.responseData.orderNo, this.responseData.paymentResponse);
        },
        closeFlyin() {
            this.shouldRun = false;
            window.eventBus.$emit('shouldCloseFlyin');
        },
        async checkPaymentStatus(orderNo, paymentResponse) {
            while (this.shouldRun) {
                await axios
                    .get(Urls.checkPaymentStatus, {
                        timeout: 200000,
                        params: {
                            orderNo: orderNo,
                            brandCode:
                                paymentResponse.fullResponse &&
                                paymentResponse.fullResponse.action &&
                                paymentResponse.fullResponse.action.paymentMethodType
                        }
                        // eslint-disable-next-line no-loop-func
                    })
                    .then((resp) => {
                        if (resp.data && resp.data.success && resp.data.redirectToURL) {
                            window.location.href = resp.data.redirectToURL;
                            window.eventBus.$emit('shouldCloseFlyin');
                            this.shouldRun = false;
                            return true;
                        } else if (resp.data && !resp.data.success) {
                            const descriptionElement = $('.js-payment-wait-text');
                            if (descriptionElement.length) {
                                descriptionElement.text(resp.data.errorMessage);
                            }
                            this.shouldRun = false;
                        }
                    });
            }
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"payment-wait-flyin",attrs:{"id":"payment-wait-flyin"}},[_c('h3',[_vm._v("\n        "+_vm._s(_vm.resources.flyin.title)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"js-payment-wait-text payment-wait-text"},[_vm._v("\n        "+_vm._s(_vm.text)+"\n        "),_c('span',{staticClass:"ico",class:_vm.icon})]),_vm._v(" "),_c('footer',{staticClass:"payment-wait-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeFlyin()}}},[_vm._v("\n            "+_vm._s(_vm.resources.flyin.buttonLabel)+"\n        ")])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3ce2911c", __vue__options__)
  } else {
    hotAPI.reload("data-v-3ce2911c", __vue__options__)
  }
})()}

},{"axios":5,"vue":262,"vue-hot-reload-api":257,"vuex":264}],339:[function(require,module,exports){
;(function(){
'use strict';

const {mapState, mapGetters} = require('vuex');
const PaymentMethodTile = require('./payment-method-tile/payment-method-tile.vue');
const GiftcardBlock = require('./giftcards/giftcard-block.vue');
const CheckoutSubmitHandler = require('../checkout-submit-handler');
const ApplePayHelper = require('../../../payment-methods/applepay');
const axios = require('axios');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    components: {
        PaymentMethodTile,
        GiftcardBlock
    },

    data() {
        return {
            showSpinner: false
        };
    },
    mounted() {
        if (this.readMode) {
            this.$store.commit('analytics/handlePaymentsInteraction', this.selectedPaymentMethod);
        }
        const applepayMethod = this.regularPaymentMethods.find(
            (paymentMethod) => ['applepay', 'apple-pay'].indexOf(paymentMethod.type) > -1
        );
        if (!applepayMethod) {
            return;
        }
        ApplePayHelper.applepayIsAvailable(
            this.paymentMethodResponse,
            this.paymentMethodConfiguration(),
            applepayMethod
        ).then((result) => {
            if (result) {
                return;
            }

            axios
                .get(applepayMethod.getPaymentDataUrl, {
                    timeout: 100000,
                    params: {
                        disabledPaymentMethod: applepayMethod.type
                    }
                })
                .then((result) => {
                    this.$store.commit('payments/setPaymentsData', result.data);
                });
        });
    },

    computed: {
        ...mapState('payments', [
            'resources',
            'regularPaymentMethods',
            'showEditModeError',
            'paymentMethodError',
            'paymentMethodResponse',
            'disableEditMode',
            'appliedGiftcards',
        ]),
        ...mapState('orderSummary', [
            'giftCardDeductionAmountValue',
            'orderTotalsPriceValue',
        ]),
        ...mapGetters('payments', ['hasNoGiftCardOptions', 'giftcardOptionsField']),
        ...mapState('delivery', {
            saveDeliverySettingsWarning: (state) => state.resources.saveDeliverySettingsWarning
        }),
        ...mapGetters('delivery', ['hasEnabledDeliveryMethods']),
        hasRegularPaymentMethods() {
            return (
                !this.payingFullAmountWithGiftcard &&
                this.regularPaymentMethods &&
                this.regularPaymentMethods.length > 0
            );
        },
        hasRegularPaymentMethod() {
            return !this.payingFullAmountWithGiftcard && this.selectedPaymentMethod;
        },
        validDetailsAndDeliveryBlock() {
            return this.checkIfAllBlocksAreValid();
        },
        bankOptionsField() {
            return this.$store.getters['payments/bankOptionsField'](this.selectedPaymentMethod.type);
        },
        filteredPaymentMethods() {
            const that = this;
            const filteredPaymentMethods = this.regularPaymentMethods.filter(function(paymentMethod) {
                return paymentMethod.type === 'klarna_account' ? that.orderTotalsPriceValue >= 35 : true;
            });
            return filteredPaymentMethods;
        }
    },
    watch: {
        selectedPaymentMethod() {
            this.removeErrorsFromBlocks();
        },
        readMode() {
            this.showSpinner = false;
            this.removeErrorsFromBlocks();
        },
        validDetailsAndDeliveryBlock(newVal) {
            if (!newVal && !(this.deliverySummary.editMode || this.detailsEditMode)) {
                this.$store.commit('error/setErrorMessage', this.paymentsResources.errors.missingFields, {root: true});
                this.$store.commit('payments/setPaymentMethodError', this.resources.errors.requiredFields);
                return;
            }

            this.removeErrorsFromBlocks();
        }
    },

    methods: {
        selectPaymentMethod(paymentMethod) {
            if (!this.readMode && this.preselectedPaymentMethod) {
                this.$store.commit('payments/updateSelectedPaymentMethod', paymentMethod);
                return;
            }
            this.setPaymentMethod(paymentMethod, false);
            this.$store.commit('analytics/handlePaymentsInteraction', paymentMethod);
        },

        setPaymentMethod(paymentMethod, revertChanges) {
            return this.$store.dispatch('payments/setSelectedPaymentMethod', {
                paymentMethod: paymentMethod,
                revertChanges: revertChanges
            });
        },

        isSelected(index, method) {
            if (this.selectedPaymentMethod) {
                return this.selectedPaymentMethod.type == method.type;
            }

            return index == 0; // select first method if there is no selected one
        },

        async savePaymentChanges() {
            const validationResult = await this.validatePaymentData();
            if (!validationResult) {
                return;
            }

            if (this.giftcardOptionsField && this.giftcardOptionsField.state.value) {
                this.scrollIntoSection('paymentsSection');
                return;
            }

            if (!this.isBankOptionsFieldValid()) {
                this.scrollIntoSection('paymentsSection');
                return;
            }

            this.showSpinner = true;
            this.setPaymentMethod(this.selectedPaymentMethod, false).then((response) => {
                if (!response || response.error) {
                    this.showSpinner = false;
                    return;
                }
                this.$store.commit('payments/updatePreselectedPaymentMethod', this.selectedPaymentMethod);
                this.$store.commit('payments/setReadMode', true);
            });
            this.$store.commit('analytics/handlePaymentsInteraction', this.selectedPaymentMethod);
        },

        async validatePaymentData() {
            const validationResult = this.validateDetailsBlock();
            if (!validationResult.isValid) {
                this.$store.commit('payments/setPaymentMethodError', this.resources.errors.requiredFields);

                this.$store.commit(
                    'error/setErrorMessage',
                    validationResult.errorMessage || this.paymentsResources.errors.missingFields,
                    {root: true}
                );

                this.scrollIntoSection(validationResult.badElementId || 'paymentsSection');
                return Promise.resolve(false);
            }
            if (!this.hasSavedAddress) {
                const result = await this.$store.dispatch('details/postForms', true);
                if (!result) {
                    return Promise.resolve(false);
                }
            }

            return Promise.resolve(true);
        },

        async removePaymentChanges() {
            const validationResult = await this.validatePaymentData();
            if (!validationResult) {
                return;
            }

            this.setPaymentMethod(this.preselectedPaymentMethod, true).then((response) => {
                if (!response || response.error) {
                    return;
                }
                this.$store.commit('payments/setReadMode', true);
            });
        },

        leaveReadMode() {
            this.$store.commit('payments/setReadMode', false);
        },

        removeErrorsFromBlocks() {
            this.$store.commit('payments/setPaymentMethodError', null);
            this.$store.commit('error/setErrorMessage', null, {root: true});
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section",attrs:{"id":"paymentsSection"}},[_c('div',{staticClass:"section-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.title))]),_vm._v(" "),(!_vm.disableEditMode && _vm.readMode && _vm.hasEnabledDeliveryMethods)?_c('button',{staticClass:"btn btn--secondary",on:{"click":function($event){return _vm.leaveReadMode()}}},[_vm._v(_vm._s(_vm.resources.editCTA))]):_vm._e()]),_vm._v(" "),(!_vm.readMode && _vm.hasEnabledDeliveryMethods)?_c('div',{staticClass:"section-row"},[_c('span',{staticClass:"section-row-header"},[_vm._v(_vm._s(_vm.resources.chooseMethod))]),_vm._v(" "),(!_vm.hasNoGiftCardOptions)?_c('giftcard-block',{key:"giftcard"}):_vm._e(),_vm._v(" "),(_vm.paymentMethodError)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.paymentMethodError))])])]):_vm._e(),_vm._v(" "),(_vm.hasRegularPaymentMethods)?_c('div',{staticClass:"vertical-tile-list section-row"},_vm._l((_vm.filteredPaymentMethods),function(method,index){return _c('payment-method-tile',{key:method.type,attrs:{"method":method,"isSelected":_vm.isSelected(index, method),"readOnly":false},on:{"selected":_vm.selectPaymentMethod}})}),1):_vm._e(),_vm._v(" "),(_vm.preselectedPaymentMethod && (['scheme', 'bcmc'].indexOf(_vm.selectedPaymentMethod.type) < 0 || _vm.payingFullAmountWithGiftcard))?_c('div',{staticClass:"section-row"},[(_vm.showEditModeError)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.saveDeliverySettingsWarning))])])]):_vm._e(),_vm._v(" "),_c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.showSpinner},on:{"click":function($event){return _vm.savePaymentChanges()}}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n                        "+_vm._s(_vm.resources.savePaymentSettingsCTA)+"\n                    ")]:_vm._e()],2),_vm._v(" "),_c('button',{staticClass:"link",on:{"click":function($event){return _vm.removePaymentChanges()}}},[_vm._v(_vm._s(_vm.resources.cancelCTA))])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(_vm.readMode && _vm.hasEnabledDeliveryMethods)?_c('div',{staticClass:"section-row"},[(!_vm.hasNoGiftCardOptions)?_c('giftcard-block',{key:"giftcard-readonly"}):_vm._e(),_vm._v(" "),(_vm.paymentMethodError)?_c('div',{staticClass:"section-row"},[_c('div',{staticClass:"inline-alert error"},[_c('span',[_vm._v(_vm._s(_vm.paymentMethodError))])])]):_vm._e(),_vm._v(" "),(_vm.hasRegularPaymentMethod)?_c('div',{staticClass:"vertical-tile-list vertical-tile-list-space"},[_c('payment-method-tile',{key:_vm.selectedPaymentMethod.type + '-readOnly',attrs:{"method":_vm.selectedPaymentMethod,"isSelected":true,"readOnly":true},on:{"selected":_vm.selectPaymentMethod}})],1):_vm._e()],1):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fd694118", __vue__options__)
  } else {
    hotAPI.reload("data-v-fd694118", __vue__options__)
  }
})()}

},{"../../../payment-methods/applepay":572,"../checkout-submit-handler":287,"./giftcards/giftcard-block.vue":328,"./payment-method-tile/payment-method-tile.vue":330,"axios":5,"vue":262,"vue-hot-reload-api":257,"vuex":264}],340:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

const ApplePayButton = require('./place-order-buttons/applepay/applepay-place-order-button.vue');
const PaypalButton = require('./place-order-buttons/paypal/paypal-place-order-button.vue');
const AmazonInitButton = require('./place-order-buttons/amazonpay/amazonpay-button.vue');
const AmazonOrderButton = require('./place-order-buttons/amazonpay/amazonpay-order-button.vue');
const AmazonPaymentButton = require('./place-order-buttons/amazonpay/amazonpay-payment-button.vue');
const DefaultButton = require('./place-order-buttons/default/default-place-order-button.vue');
const DisabledButton = require('./place-order-buttons/default/default-place-order-button-disabled.vue');
const PrivacyConsentInfo = require('./privacy-consent-info/privacy-consent-info.vue');
const SendCheckoutLinkButton = require('../../social-commerce/send-checkout-link/send-checkout-link-button.vue');

module.exports = {
    computed: {
        ...mapState('payments', [
            'selectedPaymentMethod',
            'preselectedPaymentMethod',
            'readMode',
            'payingFullAmountWithGiftcard',
            'amazonButtonType'
        ]),
        buttonType() {
            if (!this.readMode && this.preselectedPaymentMethod) {
                return DefaultButton;
            }

            if (this.payingFullAmountWithGiftcard) {
                return DefaultButton;
            }

            if (['paypalselect', 'paypal'].indexOf(this.selectedPaymentMethod.type) > -1) {
                return PaypalButton;
            }

            if (['applepay', 'apple-pay'].indexOf(this.selectedPaymentMethod.type) > -1) {
                return ApplePayButton;
            }

            if (['amazonpay', 'amazon-pay'].indexOf(this.selectedPaymentMethod.type) > -1){
                switch (this.amazonButtonType) {
                    case 'init':
                        return AmazonInitButton;
                    case 'order':
                        return AmazonOrderButton;
                    case 'payment':
                        return AmazonPaymentButton;
                    default:
                        return DefaultButton;
                }
            }

            // in case there is no preselected payment method, for example on initial visit of the checkout in Sweden
            // or Finland, we don't shown any button
            if (!this.readMode && !this.preselectedPaymentMethod && typeof(this.selectedPaymentMethod.type) === 'undefined') {
                return DisabledButton;
            }

            return DefaultButton;
        },
    },
    components: {
        PrivacyConsentInfo,
        SendCheckoutLinkButton
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"checkout-section transparent",attrs:{"id":"sectionFooter"}},[_c('privacy-consent-info'),_vm._v(" "),_c('div',{staticClass:"section-row"},[_c(_vm.buttonType,{tag:"component"})],1),_vm._v(" "),_c('div',{staticClass:"checkout-row"},[_c('send-checkout-link-button')],1)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dd8d6434", __vue__options__)
  } else {
    hotAPI.reload("data-v-dd8d6434", __vue__options__)
  }
})()}

},{"../../social-commerce/send-checkout-link/send-checkout-link-button.vue":404,"./place-order-buttons/amazonpay/amazonpay-button.vue":341,"./place-order-buttons/amazonpay/amazonpay-order-button.vue":342,"./place-order-buttons/amazonpay/amazonpay-payment-button.vue":343,"./place-order-buttons/applepay/applepay-place-order-button.vue":344,"./place-order-buttons/default/default-place-order-button-disabled.vue":345,"./place-order-buttons/default/default-place-order-button.vue":346,"./place-order-buttons/paypal/paypal-place-order-button.vue":347,"./privacy-consent-info/privacy-consent-info.vue":348,"vue":262,"vue-hot-reload-api":257,"vuex":264}],341:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AmazonPayHelper = require('../../../../../payment-methods/amazonpay');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const _ = require('lodash');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            containerID: 'amazonpay_button-container',
            containerCSSClass: 'amazonpay-button-container',
            fakebuttonCSSClass: 'amazonpay-loading-button',
            showLoadingButton: false
        };
    },

    watch: {
        ...['selectedPaymentMethod.type', 'orderTotalsPrice'].reduce(
            (watchers, key) => ({
                ...watchers,
                [key](newVal, oldVal) {
                    if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                        return;
                    }

                    this.initAmazonButton();
                }
            }),
            {}
        )
    },

    computed: {
        ...mapState('payments', ['paymentMethodResponse', 'resources', '']),
        ...mapState('orderSummary', ['orderTotalsPrice']),
        isActive() {
            if (!this.selectedPaymentMethod || ['amazonpay'].indexOf(this.selectedPaymentMethod.type) < 0) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.readMode && this.preselectedPaymentMethod) {
                return false;
            }

            return true;
        }
    },

    mounted() {
        this.initAmazonButton();
    },

    methods: {
        initAmazonButton() {
            if (!this.isActive) {
                return;
            }
            AmazonPayHelper.init(
                this.paymentMethodResponse,
                document.getElementById(this.containerID),
                this.selectedPaymentMethod,
                this.paymentMethodConfiguration(),
                this.amazonPaymentDetails()
            );
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLoadingButton),expression:"!showLoadingButton"}],class:_vm.containerCSSClass,attrs:{"id":_vm.containerID}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoadingButton),expression:"showLoadingButton"}],class:_vm.fakebuttonCSSClass},[_vm._v(_vm._s(_vm.resources.processingPayment))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-779299cb", __vue__options__)
  } else {
    hotAPI.reload("data-v-779299cb", __vue__options__)
  }
})()}

},{"../../../../../payment-methods/amazonpay":571,"../../../checkout-submit-handler":287,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],342:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AmazonPayHelper = require('../../../../../payment-methods/amazonpay');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const _ = require('lodash');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            containerID: 'amazonpay_order-container',
            containerCSSClass: 'amazonpay-order-container',
            fakebuttonCSSClass: 'amazonpay-loading-button',
            showLoadingButton: false,
        };
    },

    watch: {
        ...[
            'selectedPaymentMethod.type',
            'orderTotalsPrice'
        ].reduce((watchers, key) => ({
            ...watchers, [key](newVal, oldVal){
                if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                    return;
                }

                this.initAmazonButton();
            }
        }), {})
    },

    computed: {
        ...mapState('payments', [
            'paymentMethodResponse',
            'resources'
        ]),
        ...mapState('orderSummary', [
            'orderTotalsPrice'
        ]),
        isActive() {
            if (!this.selectedPaymentMethod || ['amazonpay'].indexOf(this.selectedPaymentMethod.type) < 0) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.readMode && this.preselectedPaymentMethod) {
                return false;
            }

            return true;
        }
    },

    mounted() {
        this.initAmazonButton();
    },

    methods: {
        initAmazonButton() {
            if (!this.isActive) {
                return;
            }
            const amazonCheckoutSessionId = AmazonPayHelper.getAmazonSessionID();

            if (amazonCheckoutSessionId) {
                AmazonPayHelper.initOrder(this.paymentMethodResponse, document.getElementById(this.containerID),
                    this.selectedPaymentMethod, this.paymentMethodConfiguration(), amazonCheckoutSessionId);
                AmazonPayHelper.getPaymentDetails(this.paymentMethodResponse,this.selectedPaymentMethod, this.paymentMethodConfiguration(), amazonCheckoutSessionId, this.setPaymentDescriptor);
            }
        },
        setPaymentDescriptor(shopperDetails) {
            this.$store.commit('payments/setPaymentDescriptor', shopperDetails.paymentDescriptor);
        },
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLoadingButton),expression:"!showLoadingButton"}],class:_vm.containerCSSClass,attrs:{"id":_vm.containerID}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoadingButton),expression:"showLoadingButton"}],class:_vm.fakebuttonCSSClass},[_vm._v(_vm._s(_vm.resources.processingPayment))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b3a4062c", __vue__options__)
  } else {
    hotAPI.reload("data-v-b3a4062c", __vue__options__)
  }
})()}

},{"../../../../../payment-methods/amazonpay":571,"../../../checkout-submit-handler":287,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],343:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const AmazonPayHelper = require('../../../../../payment-methods/amazonpay');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const axios = require('axios');
const _ = require('lodash');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            containerID: 'amazonpay_payment-container',
            containerCSSClass: 'amazonpay-payments-container',
            fakebuttonCSSClass: 'amazonpay-loading-button',
            showLoadingButton: false,
            processingPaymentError: false,
            showProcessingPayemntButton: true
        };
    },

    watch: {
        ...['selectedPaymentMethod.type', 'orderTotalsPrice'].reduce(
            (watchers, key) => ({
                ...watchers,
                [key](newVal, oldVal) {
                    if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                        return;
                    }

                    this.initAmazonButton();
                }
            }),
            {}
        )
    },

    computed: {
        ...mapState('payments', ['paymentMethodResponse', 'resources', 'paymentData']),
        ...mapState('orderSummary', ['orderTotalsPrice']),
        isActive() {
            if (!this.selectedPaymentMethod || ['amazonpay'].indexOf(this.selectedPaymentMethod.type) < 0) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.readMode && this.preselectedPaymentMethod) {
                return false;
            }

            return true;
        },
        payButtonText() {
            if (this.processingPaymentError) {
                return this.selectedPaymentMethod.paymentErrorLabel;
            } else {
                return this.selectedPaymentMethod.processingPaymentLabel;
            }
        }
    },

    mounted() {
        this.initAmazonButton();
    },

    methods: {
        initAmazonButton() {
            if (!this.isActive) {
                return;
            }
            const amazonCheckoutSessionId = AmazonPayHelper.getAmazonSessionID();

            if (amazonCheckoutSessionId) {
                AmazonPayHelper.initPayment(
                    this.paymentMethodResponse,
                    document.getElementById(this.containerID),
                    this.selectedPaymentMethod,
                    this.paymentMethodConfiguration(),
                    this.onSubmitCallback,
                    amazonCheckoutSessionId,
                    this.onAdditionalDetailsCallback
                );
            }
        },
        async onSubmitCallback(state, component) {
            this.$emit('click');

            if (!this.hasSavedAddress) {
                await this.$store.dispatch('details/postForms');
            }
            this.makePayment(state, component);
        },
        makePayment(state, component) {
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: 'amazonpay',
                        payment: state.data,
                        browserInfo: state.data.browserInfo
                    }
                })
                .then((result) => {
                    if (result.data.error == true) {
                        this.processingPaymentError = true;
                        this.$store.commit('payments/setPaymentMethodError', result.data.errorMessage);
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    if (result.data.redirectToURL) {
                        window.location.href = result.data.redirectToURL;
                        return;
                    } else if (result.data.action) {
                        this.showProcessingPayemntButton = false;
                        component.handleAction(result.data.action);
                    }
                });
        },
        onAdditionalDetailsCallback(state) {
            axios
                .post(this.selectedPaymentMethod.detailsUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: 'amazonpay'
                    },
                    data: {
                        amazonData: state.data
                    }
                })
                .then((result) => {
                    if (result.data.error == true || result.data.refused == true) {
                        this.processingPaymentError = true;
                        this.$store.commit('payments/setPaymentMethodError', result.data.errorMessage);
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    this.showProcessingPayemntButton = true;
                    if (result.data.redirectToURL) {
                        window.location.href = result.data.redirectToURL;
                        return;
                    }
                })
                .catch(() => {
                    this.processingPaymentError = true;
                    this.showProcessingPayemntButton = true;
                    return;
                });
        },
        onClickErrorRedirect() {
            if (this.processingPaymentError) {
                window.location.href = this.selectedPaymentMethod.errorRedirectionUrl;
                return;
            }
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showProcessingPayemntButton),expression:"showProcessingPayemntButton"}],staticClass:"btn amazon-processing-button",attrs:{"type":"button","id":"paymentbutton","disabled":_vm.showSpinner},on:{"click":function($event){return _vm.onClickErrorRedirect()}}},[_c('div',{class:['spinner', 'white-spinner', {'spinner-visible': _vm.showSpinner}]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n            "+_vm._s(_vm.payButtonText)+"\n        ")]:_vm._e()],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLoadingButton),expression:"!showLoadingButton"}],class:_vm.containerCSSClass,attrs:{"id":_vm.containerID}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoadingButton),expression:"showLoadingButton"}],class:_vm.fakebuttonCSSClass},[_vm._v(_vm._s(_vm.resources.processingPayment))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-672be2f2", __vue__options__)
  } else {
    hotAPI.reload("data-v-672be2f2", __vue__options__)
  }
})()}

},{"../../../../../payment-methods/amazonpay":571,"../../../checkout-submit-handler":287,"axios":5,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],344:[function(require,module,exports){
;(function(){
'use strict';

const {mapState, mapGetters} = require('vuex');
const ApplePayHelper = require('../../../../../payment-methods/applepay');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const _ = require('lodash');
const axios = require('axios');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            containerID: 'applepay-container',
            containerCSSClass: 'applepay-container'
        };
    },

    watch: {
        ...[
            'detailsEditMode',
            'deliverySummary.editMode',
            'selectedDeliveryMethod.id',
            'selectedDeliveryOption.id',
            'selectedPaymentMethod.type',
            'getFormsAsJSON',
            'orderTotalsPrice'
        ].reduce(
            (watchers, key) => ({
                ...watchers,
                [key](newVal, oldVal) {
                    if (!this.checkIfAllBlocksAreValid()) {
                        return;
                    }

                    if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                        return;
                    }

                    this.initApplepayButton();
                }
            }),
            {}
        )
    },

    computed: {
        ...mapState('payments', ['paymentMethodResponse']),
        ...mapState('orderSummary', ['orderTotalsPrice']),
        ...mapGetters('details', ['getFormsAsJSON']),
        ...mapGetters('delivery', ['selectedDeliveryOption']),
        isActive() {
            if (!this.selectedPaymentMethod || ['applepay', 'apple-pay'].indexOf(this.selectedPaymentMethod.type) < 0) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.readMode && this.preselectedPaymentMethod) {
                return false;
            }

            return true;
        }
    },

    mounted() {
        this.initApplepayButton();
    },

    methods: {
        initApplepayButton() {
            if (!this.isActive) {
                return;
            }

            const userData = {
                shippingContact: this.mapFormAddressToApplepayContactData(this.getFormsAsJSON.shippingAddress),
                billingContact: this.mapFormAddressToApplepayContactData(this.getFormsAsJSON.billingAddress)
            };

            ApplePayHelper.init(
                this.paymentMethodResponse,
                document.getElementById(this.containerID),
                this.selectedPaymentMethod,
                this.paymentMethodConfiguration(),
                userData,
                this.onValidateMerchantCallback,
                this.onAuthorizedCallback
            );
        },
        async onValidateMerchantCallback(resolve, reject, validationURL) {
            this.$emit('click');
            const validationResult = this.validatePaymentsBlock();
            if (!validationResult.isValid) {
                this.scrollIntoSection(validationResult.badElementId);
                reject();
                return;
            }

            if (!this.hasSavedAddress) {
                const result = await this.$store.dispatch('details/postForms', true);
                if (!result) {
                    reject();
                    return;
                }
            }

            this.getSession(resolve, reject, validationURL);
        },
        getSession(resolve, reject, validationURL) {
            axios
                .get(this.selectedPaymentMethod.getApplePaySessionUrl, {
                    timeout: 100000,
                    params: {
                        validationUrl: validationURL
                    }
                })
                .then((result) => {
                    resolve(result.data);
                })
                .catch(() => {
                    reject();
                });
        },
        onAuthorizedCallback(resolve, reject) {
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: 'applepay',
                        payment: {
                            paymentMethod: ApplePayHelper.paymentMethodData
                        }
                    }
                })
                .then((result) => {
                    if (result.data.error == true) {
                        reject();
                        this.$store.commit('payments/setPaymentMethodError', result.data.errorMessage);
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    this.$store.commit('analytics/handlePlaceOrderInteraction', this.selectedPaymentMethod.type);

                    if (result.data.redirectToURL) {
                        resolve({
                            status: 0 // ApplePaySession.STATUS_SUCCESS = 0,
                        });
                        window.location.href = result.data.redirectToURL;
                        return;
                    }

                    reject();
                    console.error('onAuthorizedCallback: Server responded with unknown response', result.data);
                })
                .catch(() => {
                    reject();
                });
        },
        mapFormAddressToApplepayContactData(formAddressJson) {
            const userData = {};
            if (!formAddressJson) {
                return userData;
            }
            userData.givenName = formAddressJson.firstName;
            userData.familyName = formAddressJson.lastName;
            userData.city = formAddressJson.city;
            userData.addressLines = [];
            if (formAddressJson.address1) {
                userData.addressLines.push(formAddressJson.address1);
            }
            if (formAddressJson.address2) {
                userData.addressLines.push(formAddressJson.address2);
            }
            userData.houseNumber = formAddressJson.houseNumber;
            userData.postalCode = formAddressJson.postalCode;
            userData.countryCode = formAddressJson.countryCode;
            userData.phoneNumber = formAddressJson.phone;
            userData.emailAddress = formAddressJson.email;

            return userData;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.containerCSSClass,attrs:{"id":_vm.containerID}})}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-d1a8b48c", __vue__options__)
  } else {
    hotAPI.reload("data-v-d1a8b48c", __vue__options__)
  }
})()}

},{"../../../../../payment-methods/applepay":572,"../../../checkout-submit-handler":287,"axios":5,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],345:[function(require,module,exports){
;(function(){
'use strict';

const CheckoutSubmitHandler = require('../../../checkout-submit-handler');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    computed: {
        payButtonText() {
            return this.selectedPaymentMethod.label;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button","id":"paymentbutton","disabled":""}},[_vm._v("\n        "+_vm._s(_vm.payButtonText)+"\n    ")])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7767ef23", __vue__options__)
  } else {
    hotAPI.reload("data-v-7767ef23", __vue__options__)
  }
})()}

},{"../../../checkout-submit-handler":287,"vue":262,"vue-hot-reload-api":257}],346:[function(require,module,exports){
;(function(){
'use strict';

const {mapState, mapGetters} = require('vuex');
const axios = require('axios');
const KlarnaHelper = require('../../../../../payment-methods/klarna');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const QRcode = require('qrcode'),
    isMobileDevice = require('../../../../../../js/modules/helpers/isMobileDevice');
const PaymentWaitFlyin = require('../../../payments/payment-method-tile/payment-wait-flyin/payment-wait-flyin.vue');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            showSpinner: false
        };
    },

    computed: {
        ...mapState('payments', ['paymentData', 'defaultPaymentMethod', 'resources', 'adyenData']),
        ...mapGetters('payments', ['blikField', 'mbwayField']),
        ...mapState('orderSummary', ['orderTotalsPrice']),
        payButtonText() {
            let price = ' (' + this.orderTotalsPrice + ')';
            if (!this.readMode && this.preselectedPaymentMethod) {
                return this.defaultPaymentMethod.label + price;
            }
            if (this.payingFullAmountWithGiftcard) {
                return this.resources.giftcards.placeOrder;
            }

            if (this.showPriceInButton(this.selectedPaymentMethod.type) < 0) {
                price = '';
            }

            return this.selectedPaymentMethod.label + price;
        }
    },
    methods: {
        showPriceInButton(methodType) {
            return ['scheme', 'bcmc'].indexOf(methodType);
        },
        async onClickPayAndPlaceOrder() {
            this.$emit('click');
            this.showSpinner = true;
            const validationResult = this.validatePaymentsBlock();
            if (!validationResult.isValid) {
                this.showSpinner = false;
                this.scrollIntoSection(validationResult.badElementId);
                return;
            }

            if (!this.hasSavedAddress) {
                const result = await this.$store.dispatch('details/postForms', true);
                if (!result) {
                    this.showSpinner = false;
                    return;
                }
            }

            this.handlePlaceOrder();
        },
        handlePlaceOrder() {
            if (this.payingFullAmountWithGiftcard) {
                this.handleDefaultPayment(); // if order is payed by the giftcards completely ignore the selected payment method (methods are hidden in this case)
                return;
            }

            switch (this.selectedPaymentMethod.type) {
                case 'scheme':
                    this.handleCreditCardPayment();
                    break;
                case 'bcmc':
                    this.handleBancontactCardPayment();
                    break;
                case 'klarna':
                case 'klarna_account':
                case 'klarna_b2b':
                    this.handleKlarnaPayment();
                    break;
                case 'yandex_money':
                case 'yandex_sberbank':
                case 'yandex_alfaclick':
                case 'yandex_promsvyazbank':
                case 'directEbanking':
                case 'eps':
                case 'vipps':
                case 'ideal':
                case 'alipay':
                case 'alipay_hk':
                case 'giropay':
                case 'onlineBanking_PL':
                case 'trustly':
                    this.handleRedirectionPayment();
                    break;
                case 'swish':
                case 'bcmc_mobile':
                    this.handleQRcodePayment();
                    break;
                case 'blik':
                    this.handleBlikPayment();
                    break;
                case 'mbway':
                    this.handleMbwayPayment();
                    break;
                case 'amazonpay':
                    this.handleAmazonRedirect();
                    break;
                default:
                    break;
            }
        },
        handleAmazonRedirect() {
            const paymentMethodData = {
                type: this.selectedPaymentMethod.type
            };

            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 200000,
                    params: {
                        brandCode: this.selectedPaymentMethod.type,
                        payment: {
                            paymentMethod: paymentMethodData
                        }
                    }
                })
                .then(this.handleAmazonResponse);
        },
        handleQRcodePayment() {
            const paymentMethodData = {
                type: this.selectedPaymentMethod.type
            };
            if (this.selectedPaymentMethod.issuerId) {
                paymentMethodData.issuer = this.selectedPaymentMethod.issuerId;
            }
            this.handleWaitPayment(paymentMethodData, this.handleQRcodePaymentResponse);
        },
        handleBlikPayment() {
            const paymentMethodData = {
                type: this.selectedPaymentMethod.type,
                blikCode: this.blikField.state.value
            };
            this.handleWaitPayment(paymentMethodData, this.handleBlikPaymentResponse);
        },
        handleMbwayPayment() {
            const paymentMethodData = {
                type: this.selectedPaymentMethod.type,
                telephoneNumber: this.mbwayField.state.value
            };
            this.handleWaitPayment(paymentMethodData, this.handleMbwayPaymentResponse);
        },
        handleWaitPayment(paymentMethodData, handleResponse) {
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 200000,
                    params: {
                        brandCode: this.selectedPaymentMethod.type,
                        payment: {
                            paymentMethod: paymentMethodData
                        }
                    }
                })
                .then(handleResponse);
        },
        handleRedirectionPayment() {
            const paymentMethodData = {
                type: this.selectedPaymentMethod.type
            };
            if (this.selectedPaymentMethod.issuerId) {
                paymentMethodData.issuer = this.selectedPaymentMethod.issuerId;
            }
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 200000,
                    params: {
                        brandCode: this.selectedPaymentMethod.type,
                        payment: {
                            paymentMethod: paymentMethodData
                        }
                    }
                })
                .then(this.handlePaymentResponse);
        },
        handleDefaultPayment() {
            if (!this.payingFullAmountWithGiftcard) {
                return;
            }

            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 200000,
                    params: {
                        brandCode: 'giftcard'
                    }
                })
                .then(this.handlePaymentResponse);
        },

        handleBancontactCardPayment() {
            if (!this.paymentData || !this.paymentData.adyenData || !this.paymentData.adyenData.paymentMethod) {
                this.$store.commit('payments/focusCreditCardBlock', true);
                this.scrollIntoSection('js-bcmc');
                this.showSpinner = false;
                return;
            }

            this.handleCardPayment();
        },

        handleCreditCardPayment() {
            if (!this.paymentData || !this.paymentData.adyenData || !this.paymentData.adyenData.paymentMethod) {
                this.$store.commit('payments/focusCreditCardBlock', true);
                this.scrollIntoSection('js-scheme');
                this.showSpinner = false;
                return;
            }

            this.handleCardPayment();
        },

        handleKlarnaPayment() {
            if (!this.adyenData || !this.adyenData.loaded) {
                this.$store.commit('payments/setPaymentMethodError', this.resources.errors.requiredFields);
                this.scrollIntoSection('js-klarna');
                this.showSpinner = false;
                return;
            }
            const selectedPaymentMethod = this.selectedPaymentMethod.type;
            KlarnaHelper.authorize(
                selectedPaymentMethod,
                function callbackFunction(authorizationResponse) {
                    if (!authorizationResponse.approved) {
                        this.showSpinner = false;
                    }
                    if (!authorizationResponse.authorization_token) {
                        this.$store.commit('payments/setPaymentMethodError', this.resources.errors.requiredFields);
                        this.scrollIntoSection('js-klarna');
                        this.showSpinner = false;
                        return;
                    }
                    axios
                        .post(this.selectedPaymentMethod.detailsUrl, {
                            timeout: 100000,
                            params: {
                                brandCode: selectedPaymentMethod
                            },
                            data: {
                                klarnaData: {
                                    paymentData: this.adyenData.paymentData,
                                    details: {
                                        authorization_token:
                                            authorizationResponse.authorization_token /* eslint-disable-line camelcase */
                                    }
                                }
                            }
                        })
                        .then(this.handlePaymentResponse);
                }.bind(this)
            );
        },
        handlePaymentResponse(response) {
            if (!response) {
                this.showSpinner = false;
                return;
            }

            if (response.data.error) {
                this.$store.commit('payments/setPaymentMethodError', response.data.errorMessage);
                this.scrollIntoSection('paymentsSection');
                this.showSpinner = false;
                return;
            }

            this.$store.commit('analytics/handlePlaceOrderInteraction', this.selectedPaymentMethod.type);

            if (response.data.redirectToURL) {
                window.location.href = response.data.redirectToURL;
                return;
            }
            console.error('onSubmit: Server responded with unknown response', response.data);
        },
        handleAmazonResponse(response) {
            if (!response) {
                this.showSpinner = false;
                return;
            }

            this.$store.commit('analytics/handlePlaceOrderInteraction', this.selectedPaymentMethod.type);

            if (Urls.checkoutAmazon) {
                window.location.href = Urls.checkoutAmazon;
                return;
            }
        },
        handleRequiredActionResponse(response) {
            if (
                !response.data.error &&
                response.data.paymentResponse &&
                response.data.paymentResponse.fullResponse &&
                response.data.paymentResponse.fullResponse.action
            ) {
                this.showSpinner = false;
                this.$store.commit('analytics/handlePlaceOrderInteraction', this.selectedPaymentMethod.type);
                this.$store.commit(
                    'payments/setPaymentRequiredActionData',
                    response.data.paymentResponse.fullResponse.action
                );
                return;
            }

            return response;
        },
        handleCardPayment() {
            const paymentData = this.paymentData.adyenData;
            if (this.paymentData.cardHolderName) {
                paymentData.paymentMethod.holderName = this.paymentData.cardHolderName;
            }

            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 100000,
                    params: {
                        payment: paymentData,
                        brandCode: this.paymentData.brandCode,
                        saveCreditCard: this.paymentData.saveCreditCard,
                        shopperInteraction: this.paymentData.shopperInteraction,
                        browserInfo: getBrowserInfo()
                    }
                })
                .then(this.handleRequiredActionResponse)
                .then(this.handlePaymentResponse);
        },
        handleQRcodePaymentResponse(response) {
            if (response.data && !response.data.error && !isMobileDevice()) {
                QRcode.toDataURL(response.data.paymentResponse.fullResponse.action.qrCodeData).then((QRCodeImg) => {
                    arView.show(QRCodeImg, this.selectedPaymentMethod.type);
                });
                checkQRPaymentStatus(response.data.orderNo, response.data.paymentResponse);
            } else if (response.data && !response.data.error && isMobileDevice()) {
                window.location.href = response.data.paymentResponse.fullResponse.action.url;
            }
        },
        handleBlikPaymentResponse(response) {
            if (!response.data || response.data.error) {
                this.$store.commit('payments/setPaymentMethodError', response.data.errorMessage);
                this.scrollIntoSection('paymentsSection');
                this.showSpinner = false;
                return;
            }
            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'blik-flyin',
                content: PaymentWaitFlyin,
                props: {
                    responseData: response.data
                },
                store: this.$store
            });
            const that = this;
            window.eventBus.$on('flyinClosed', () => {
                that.showSpinner = false;
            });
        },
        handleMbwayPaymentResponse(response) {
            if (!response.data || response.data.error) {
                this.$store.commit('payments/setPaymentMethodError', response.data.errorMessage);
                this.scrollIntoSection('paymentsSection');
                this.showSpinner = false;
                return;
            }
            window.eventBus.$emit('shouldOpenFlyin', {
                id: 'mbway-flyin',
                content: PaymentWaitFlyin,
                props: {
                    responseData: response.data
                },
                store: this.$store
            });
            const that = this;
            window.eventBus.$on('flyinClosed', () => {
                that.showSpinner = false;
            });
        }
    }
};

const arView = {
    show: (QRcodeURL, selectedPaymentMethod) => {
        window.eventBus.$emit('shouldOpenModal', {
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            ctaHolder: {},
            qrModal: true,
            QRcodeURL: QRcodeURL,
            description: Resources['MODAL_' + selectedPaymentMethod.toUpperCase() + '_MESSAGE']
        });
    }
};

async function checkQRPaymentStatus(orderNo, paymentResponse) {
    let shouldRun = true;
    while (shouldRun) {
        await axios
            .get(Urls.checkPaymentStatus, {
                timeout: 200000,
                params: {
                    orderNo: orderNo,
                    brandCode:
                        paymentResponse.fullResponse &&
                        paymentResponse.fullResponse.action &&
                        paymentResponse.fullResponse.action.paymentMethodType
                }
                // eslint-disable-next-line no-loop-func
            })
            .then((resp) => {
                if (resp.data && resp.data.success && resp.data.redirectToURL) {
                    window.eventBus.$emit('shouldCloseModal', {
                        qrModal: true
                    });
                    shouldRun = false;
                    window.location.href = resp.data.redirectToURL;
                } else if (resp.data && !resp.data.success) {
                    const descriptionElement = $('.js-qr-description');
                    const qrCodeElement = $('.js-qrCode');
                    shouldRun = false;
                    if (descriptionElement.length && qrCodeElement.length) {
                        qrCodeElement.attr('src', '');
                        descriptionElement.text(resp.data.errorMessage);
                    }
                }
            });
    }
}

function getBrowserInfo() {
    return {
        colorDepth: screen.colorDepth,
        javaEnabled: navigator.javaEnabled(),
        language: navigator.language,
        screenHeight: screen.height,
        screenWidth: screen.width,
        timeZoneOffset: new Date().getTimezoneOffset()
    };
}

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"section-footer"},[_c('button',{staticClass:"btn",attrs:{"type":"button","id":"paymentbutton","disabled":_vm.showSpinner},on:{"click":function($event){return _vm.onClickPayAndPlaceOrder()}}},[_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner)?[_vm._v("\n            "+_vm._s(_vm.payButtonText)+"\n        ")]:_vm._e()],2)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-515980f6", __vue__options__)
  } else {
    hotAPI.reload("data-v-515980f6", __vue__options__)
  }
})()}

},{"../../../../../../js/modules/helpers/isMobileDevice":466,"../../../../../payment-methods/klarna":573,"../../../checkout-submit-handler":287,"../../../payments/payment-method-tile/payment-wait-flyin/payment-wait-flyin.vue":338,"axios":5,"qrcode":225,"vue":262,"vue-hot-reload-api":257,"vuex":264}],347:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const PayPalHelper = require('../../../../../payment-methods/paypal');
const CheckoutSubmitHandler = require('../../../checkout-submit-handler');
const axios = require('axios');
const _ = require('lodash');

module.exports = {
    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            containerID: 'paypal-container',
            containerCSSClass: 'paypal-payments-container',
            fakebuttonCSSClass: 'paypal-loading-button',
            showLoadingButton: false
        };
    },

    watch: {
        ...['selectedPaymentMethod.type', 'orderTotalsPrice'].reduce(
            (watchers, key) => ({
                ...watchers,
                [key](newVal, oldVal) {
                    if (_.isEqualWith(JSON.parse(JSON.stringify(newVal)), JSON.parse(JSON.stringify(oldVal)))) {
                        return;
                    }

                    this.initPaypalButton();
                }
            }),
            {}
        )
    },

    computed: {
        ...mapState('payments', ['paymentMethodResponse', 'resources']),
        ...mapState('orderSummary', ['orderTotalsPrice']),
        isActive() {
            if (
                !this.selectedPaymentMethod ||
                ['paypal', 'paypalselect'].indexOf(this.selectedPaymentMethod.type) < 0
            ) {
                return false;
            }

            if (this.payingFullAmountWithGiftcard) {
                return false;
            }

            if (!this.readMode && this.preselectedPaymentMethod) {
                return false;
            }

            return true;
        }
    },

    mounted() {
        this.initPaypalButton();
    },

    methods: {
        initPaypalButton() {
            if (!this.isActive) {
                return;
            }

            PayPalHelper.init(
                this.paymentMethodResponse,
                document.getElementById(this.containerID),
                this.selectedPaymentMethod,
                this.paymentMethodConfiguration(),
                this.onSubmitCallback,
                this.onAdditionalDetailsCallback
            );
        },

        resetPayPalButton(component) {
            component.remove();
            this.initPaypalButton();
        },

        async onSubmitCallback(state, component) {
            this.$emit('click');
            const validationResult = this.validatePaymentsBlock();
            if (!validationResult.isValid) {
                this.resetPayPalButton(component);
                this.scrollIntoSection(validationResult.badElementId);
                throw new Error();
            }

            if (!this.hasSavedAddress) {
                const result = await this.$store.dispatch('details/postForms', true);
                if (!result) {
                    this.resetPayPalButton(component);
                    this.scrollIntoSection(validationResult.badElementId);
                    throw new Error();
                }
            }

            this.makePayment(state, component);
        },
        makePayment(state, component) {
            axios
                .get(this.selectedPaymentMethod.paymentUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: 'paypal',
                        payment: state.data
                    }
                })
                .then((result) => {
                    if (result.data.error == true) {
                        this.resetPayPalButton(component);
                        this.$store.commit('payments/setPaymentMethodError', result.data.errorMessage);
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    if (result.data.paymentResponse.fullResponse.action) {
                        component.handleAction(result.data.paymentResponse.fullResponse.action);
                        return;
                    }
                    console.error('onSubmit: Server responded with unknown response', result.data);
                });
        },
        onAdditionalDetailsCallback(state, component) {
            this.showLoadingButton = true;
            axios
                .post(this.selectedPaymentMethod.detailsUrl, {
                    timeout: 100000,
                    params: {
                        brandCode: 'paypal'
                    },
                    data: {
                        data: state.data
                    }
                })
                .then((result) => {
                    if (result.data.error == true) {
                        this.showLoadingButton = false;
                        this.resetPayPalButton(component);
                        this.$store.commit('payments/setPaymentMethodError', result.data.errorMessage);
                        this.scrollIntoSection('paymentsSection');
                        return;
                    }

                    this.$store.commit('analytics/handlePlaceOrderInteraction', this.selectedPaymentMethod.type);

                    if (result.data.redirectToURL) {
                        window.location.replace(result.data.redirectToURL);
                        return;
                    }

                    this.showLoadingButton = false;
                    console.error('onAdditionalDetails: Server responded with unknown response', result.data);
                });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLoadingButton),expression:"!showLoadingButton"}],class:_vm.containerCSSClass,attrs:{"id":_vm.containerID}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoadingButton),expression:"showLoadingButton"}],class:_vm.fakebuttonCSSClass},[_vm._v(_vm._s(_vm.resources.processingPayment))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c63830cc", __vue__options__)
  } else {
    hotAPI.reload("data-v-c63830cc", __vue__options__)
  }
})()}

},{"../../../../../payment-methods/paypal":574,"../../../checkout-submit-handler":287,"axios":5,"lodash":208,"vue":262,"vue-hot-reload-api":257,"vuex":264}],348:[function(require,module,exports){
;(function(){
'use strict';

const { mapState, mapMutations } = require('vuex');
const VueInput = require('../../../vue-form/vue-input/vue-input.vue');

module.exports = {
    computed: mapState('privacyConsent', [
        'show', 'disclaimer', 'checkbox'
    ]),
    methods: mapMutations('privacyConsent', [
        'updateCheckboxValue'
    ]),
    components: {
        VueInput
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"section-row vue-form",attrs:{"id":"privacyConsent"}},[(_vm.checkbox)?_c('vue-input',{attrs:{"element":_vm.checkbox},on:{"blur":function($event){return _vm.updateCheckboxValue($event.target.value)}}}):_vm._e(),_vm._v(" "),(!_vm.checkbox)?_c('p',{domProps:{"innerHTML":_vm._s(_vm.disclaimer)}}):_vm._e()],1):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-9c1e3d66", __vue__options__)
  } else {
    hotAPI.reload("data-v-9c1e3d66", __vue__options__)
  }
})()}

},{"../../../vue-form/vue-input/vue-input.vue":415,"vue":262,"vue-hot-reload-api":257,"vuex":264}],349:[function(require,module,exports){
'use strict';

const VueX = require('vuex');
const Vue = require('vue');

const couponsModule = require('./modules/coupons');
const errorModule = require('./modules/error');
const orderSummaryModule = require('./modules/order-summary');
const deliveryModule = require('./modules/delivery/delivery');
const addressBookModule = require('./modules/address-book');
const detailsModule = require('./modules/details');
const paymentsModule = require('./modules/payments');
const analyticsModule = require('./modules/analytics');
const bonusItemsModule = require('./modules/bonus-items');
const privacyModule = require('./modules/privacy-consent');
const socialCommerceModule = require('./modules/social-commerce');
const eurobonusModule = require('./modules/eurobonus');

Vue.use(VueX);
const data = JSON.parse(document.getElementById('cart-data').dataset.json);
const checkoutGtmData = JSON.parse(document.getElementById('checkout-gtm-data').dataset.json);

module.exports = new VueX.Store({
    modules: {
        bonusItems: bonusItemsModule(data.bonusItemsData),
        delivery: deliveryModule(data.deliveryData),
        addressBook: addressBookModule(data.addressBookData),
        details: detailsModule(data.detailsData),
        coupons: couponsModule(data.couponData),
        orderSummary: orderSummaryModule(data.orderSummaryData),
        payments: paymentsModule(data.paymentData),
        error: errorModule(data.deliveryData.exclusionResults ? data.deliveryData.exclusionResults.errorMessage : ''),
        analytics: analyticsModule(checkoutGtmData),
        privacyConsent: privacyModule(data.privacyConsentData),
        socialCommerceData: socialCommerceModule(data.socialCommerceData),
        eurobonus: eurobonusModule(data.eurobonusData)
    },
    state: {},
    actions:{},
    mutations:{},
    strict: "development" !== 'production'
});

},{"./modules/address-book":350,"./modules/analytics":351,"./modules/bonus-items":352,"./modules/coupons":353,"./modules/delivery/delivery":354,"./modules/details":356,"./modules/error":357,"./modules/eurobonus":358,"./modules/order-summary":359,"./modules/payments":360,"./modules/privacy-consent":361,"./modules/social-commerce":362,"vue":262,"vuex":264}],350:[function(require,module,exports){
'use strict';

const Vue = require('vue');

const axios = require('axios');
const exclusionResultHandler = require('./delivery/exclusion-result-handler');

module.exports = (addressBookData) => {
    return {
        namespaced: true,
        state: {
            ...addressBookData,
        },
        getters: {
            getAddressById: (state) => (id) => {
                return state.addresses.find(address => address.id === id);
            },
            getSelectedAddressByType: (state) => (type) => {
                const id = type === 'shipping'
                    ? state.selectedAddresses.selectedShippingAddressId
                    : state.selectedAddresses.selectedBillingAddressId;
                return state.addresses.find(address => address.id === id);
            },
            hasSavedAddress: (state) => {
                return state.addresses.length > 0;
            }
        },
        actions: {
            updateSelectedAddress({ state, commit, rootState, rootGetters }, { addressId, type, tempAddress, recalculateTax }) {
                if (type !== 'shipping') {
                    return;
                }
                commit('delivery/setLoadingState', true, { root: true });
                const useSameAsShipping = rootGetters['details/getFieldValue']('billingAddress', 'useSameAsShipping');
                return axios({
                    method: 'post',
                    url: state.urls.setSelectedURL,
                    data: { addressId, type, tempAddress, useSameAsShipping, recalculateTax },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    if (result.data.addressValidationError) {
                        commit('error/setErrorMessage', result.data.addressValidationError, { root: true });
                        commit('delivery/setLoadingState', false, { root: true });
                        return;
                    }

                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, { root: true });
                    commit('updateAddresses', result.data.addressBook);
                    exclusionResultHandler(rootState.delivery.exclusionResults, result.data.delivery.exclusionResults, commit);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    commit('delivery/setLoadingState', false, { root: true });
                    return !result.data.delivery.exclusionResults.excludedPostal;
                });
            },
            setDefaultAddress({ state, commit }, { addressId, type }) {
                return axios({
                    method: 'post',
                    url: state.urls.setDefaultURL,
                    data: { addressId },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('setSelectedAddress', type);
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            deleteAddress({ state, commit }, addressId) {
                return axios({
                    method: 'post',
                    url: state.urls.deleteURL,
                    data: { addressId },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            createAddress({ state, commit, dispatch }, { address, type }) {
                return axios({
                    method: 'post',
                    url: state.urls.create,
                    data: { address },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    const addressId = result.data.addressId;
                    if (addressId) {
                        commit('selectAddress', {
                            type, addressId
                        });
                        dispatch('updateSelectedAddress', {
                            type, addressId
                        });
                    }
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            },
            editAddress({ state, commit }, address) {
                return axios({
                    method: 'post',
                    url: state.urls.edit,
                    data: { address },
                    headers: { 'Content-Type': 'application/json' }
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updateAddresses', result.data.addressBook);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    return true;
                }).catch((error) => {
                    console.error(error.response.data.errorMessage);
                });
            }
        },
        mutations: {
            selectAddress(state, { type, addressId }) {
                if (type === 'shipping') {
                    state.selectedAddresses.selectedShippingAddressId = addressId;
                    return;
                }
                state.selectedAddresses.selectedBillingAddressId = addressId;
            },
            setSelectedAddress(state, type) {
                const id = type === 'shipping'
                    ? state.selectedAddresses.selectedShippingAddressId
                    : state.selectedAddresses.selectedBillingAddressId;

                state.addresses.forEach(address => {
                    address.selected = address.id === id;
                });
            },
            updateAddresses(state, addressBook) {
                Vue.set(state, 'addresses', [...addressBook.addresses]);
                state.selectedAddresses = addressBook.selectedAddresses;
            },
            addAddress(state, newAddress) {
                const addressIndex = state.addresses.findIndex(address => newAddress.id === address.id);
                if (addressIndex) {
                    state.addresses[addressIndex] = newAddress;
                }
                state.addresses.push(newAddress);
            }
        }
    };
};

},{"./delivery/exclusion-result-handler":355,"axios":5,"vue":262}],351:[function(require,module,exports){
'use strict';

module.exports = (checkoutGtmData) => {
    return {
        /* eslint-disable camelcase */
        namespaced: true,
        state: {
            gtm: require('../../../../modules/google').tagManager,
            lastInteractionBlock: '',
            shippingOptionEvent: {
                event: 'add_shipping_info',
                content_group: 'delivery',
                method: '',
                shipping_tier: '',
                page_location: '/checkout/delivery'
            },
            deliveryEventPushed: false,
            detailsEventPushed: false,
            paymentEventPushed: false
        },
        /* eslint-enable camelcase */
        mutations: {
            handleDeliveryInteraction(state, method) {
                if (!state.deliveryEventPushed) {
                    checkoutGtmData.delivery_method = method.toLowerCase();
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 2;
                    event.step_name = 'add delivery method';
                    state.gtm.pushDataLayerEvent(event);
                    state.deliveryEventPushed = true;
                }
            },

            handleDetailsInteraction(state) {
                if (!state.detailsEventPushed) {
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 3;
                    event.step_name = 'add shipping info';
                    state.gtm.pushDataLayerEvent(event);
                    state.detailsEventPushed = true;
                }
            },

            handlePaymentsInteraction(state, paymentMethod) {
                if (!state.paymentEventPushed) {
                    checkoutGtmData.payment_method = paymentMethod && paymentMethod.name ? paymentMethod.name.toLowerCase() : null;
                    const event = Object.assign({}, checkoutGtmData);
                    event.step = 4;
                    event.step_name = 'add payment method';
                    state.gtm.pushDataLayerEvent(event);
                    state.paymentEventPushed = true;
                }
            },

            handleViewComponent(state, method) {
                checkoutGtmData.delivery_method = method.toLowerCase();
                const event = Object.assign({}, checkoutGtmData);
                event.step = 1;
                event.step_name = 'start checkout';
                state.gtm.pushDataLayerEvent(event);
            },

            handlePlaceOrderInteraction(state) {
                const event = Object.assign({}, checkoutGtmData);
                event.step = 5;
                event.step_name = 'complete checkout';
                state.gtm.pushDataLayerEvent(event);
            },

            handleCheckoutFieldError(state, {section, message}) {
                const optionEvent = {};
                optionEvent.event = 'form_field_error';
                optionEvent.error_type = 'form_field_error';
                optionEvent.error_message = message.toLowerCase() || null;
                optionEvent.error_code = null;
                optionEvent.content_name = 'checkout - ' + section;

                state.gtm.pushDataLayerEvent(optionEvent);
            },
        }
    };
};

},{"../../../../modules/google":453}],352:[function(require,module,exports){
'use strict';

const axios = require('axios');

module.exports = (bonusProducsData) => {
    return {
        namespaced: true,
        state: {
            ...bonusProducsData
        },
        getters: {},
        actions: {
            addBonusProductToBasket({ state, commit }, productId) {
                return axios({
                    method: 'post',
                    url: state.addNewURL,
                    data: { productId },
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then((result) => {
                    commit('setBonusProductData', result.data.bonusItems);
                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, { root: true });
                });
            }
        },
        mutations: {
            setBonusProductData(state, bonusProductsState) {
                Object.assign(state, bonusProductsState);
            }
        }
    };
};

},{"axios":5}],353:[function(require,module,exports){
'use strict';

const axios = require('axios');

module.exports = (couponData) => {
    return {
        namespaced: true,
        state: {
            ...couponData,
            errorMessage: ''
        },
        getters: {},
        actions: {
            addCoupon({state, commit, dispatch}, couponCodeValue) {
                const bodyFormData = new FormData();
                bodyFormData.append(state.couponCsrfName, state.couponCsrfToken);
                bodyFormData.append(state.couponInputName, couponCodeValue);
                bodyFormData.append(state.addCouponAction, state.addCouponAction);
                bodyFormData.append(state.resources.isCheckoutPage, true);

                return axios({
                    method: 'post',
                    url: state.couponSubmitURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    commit('setErrorMessage', result.data.errorMessage || '');
                    if (!result.data.errorMessage) {
                        commit('setCodeValue', couponCodeValue);
                        commit('setPriceAdjustment', result.data.couponData.priceAdjustment);
                        commit('setRemoveAction', result.data.couponData.removeCouponAction);
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {
                            root: true
                        });
                        dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    }
                    return !result.data.errorMessage;
                });
            },
            removeCoupon({state, commit, dispatch}) {
                const bodyFormData = new FormData();
                bodyFormData.append(state.couponInputName, state.couponCodeValue);
                bodyFormData.append(state.removeCouponAction, state.removeCouponAction);

                return axios({
                    method: 'post',
                    url: state.couponSubmitURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    if (result.data) {
                        commit('setCodeValue', '');
                        commit('setRemoveAction', '');
                        commit('setPriceAdjustment', '');
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {
                            root: true
                        });
                        dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    }
                    return !!result.data;
                });
            }
        },
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            setCodeValue(state, couponCodeValue) {
                state.couponCodeValue = couponCodeValue;
            },
            setRemoveAction(state, action) {
                state.removeCouponAction = action;
            },
            setPriceAdjustment(state, priceAdjustment) {
                state.priceAdjustment = priceAdjustment;
            }
        }
    };
};

},{"axios":5}],354:[function(require,module,exports){
'use strict';

const Vue = require('vue');
const axios = require('axios');
const {validateElement} = require('../../../../vue-form/vue-input/libs/validator');
const exclusionResultHandler = require('./exclusion-result-handler');

const MAX_OPTIONS_VISIBLE = 3;

module.exports = (deliveryData) => {
    return {
        namespaced: true,
        state: {
            ...deliveryData
        },
        getters: {
            selectedDeliveryOption: (_, getters) => {
                return getters.selectedDeliveryMethod
                    .options.find((option) => option.selected);
            },
            selectedDeliveryMethod: (state) => {
                const selectedMethod = state.deliveryMethods
                    .find((method) => method.selected);
                return selectedMethod ? selectedMethod : state.deliveryMethods[0];
            },
            postalCodeValue: (state) => {
                return state.postalCodeForm.form.formElements[0].state.value;
            },
            isPickupPersonValid: (state, getters) => {
                const firstNameValid = !validateElement(state.pickupPerson.firstName).length;
                const lastNameValid = !validateElement(state.pickupPerson.lastName).length;

                return getters.selectedDeliveryMethod.id !== 'pickupPoint' ||
                    !state.pickupPerson.isSomeoneElse.state.value ||
                    (firstNameValid && lastNameValid);
            },
            pickupPerson: (state) => {
                return {
                    isSomeoneElse: state.pickupPerson.isSomeoneElse.state.value,
                    firstName: state.pickupPerson.firstName.state.value,
                    lastName: state.pickupPerson.lastName.state.value,
                };
            },
            postnummer: (state) => {
                return {
                    dHLPostNummer: state.postnummer ? state.postnummer.postnummerValue.state.value : ''
                };
            },
            isPostnummerValid: (state, getters) => {
                if (state.postnummer && getters.selectedDeliveryMethod.id === 'pickupPoint') {
                    const postnummerValid = !validateElement(state.postnummer.postnummerValue).length;

                    return postnummerValid;
                }

                return true;
            },
            isPostnummerExist: (state) => {
                const postnummer = state.postnummer;

                return postnummer;
            },
            pickPost: (state) => {
                return {
                    pickPostUserID: state.pickPost ? state.pickPost.pickPostValue.state.value : ''
                };
            },
            isPickPostValid: (state, getters) => {
                if (state.pickPost && getters.selectedDeliveryMethod.id === 'pickupPoint') {
                    const pickPostValid = !validateElement(state.pickPost.pickPostValue).length;

                    return pickPostValid;
                }

                return true;
            },
            isPickPostExist: (state) => {
                const pickPost = state.pickPost;

                return pickPost;
            },
            hasEnabledDeliveryMethods: (state) => state.deliveryMethods.some((x) => x.enabled)
        },
        actions: {
            submitPostalCode({state, commit, dispatch}) {
                if (validateElement(state.postalCodeForm.form.formElements[0]).length) {
                    return;
                }
                const postalCode = state.postalCodeForm.form.formElements[0].state.value;
                commit('setLoadingState', true);
                return getLatLong(postalCode)
                    .then((coordinates) => {
                        return axios({
                            method: 'post',
                            url: state.submitPostalCodeURL,
                            data: {postalCode, ...coordinates},
                            headers: {'Content-Type': 'application/json'}
                        });
                    }).then((result) => {
                        commit('setPostalCode', postalCode);
                        exclusionResultHandler(state.exclusionResults, result.data.delivery.exclusionResults, commit);
                        commit('setDeliveryState', result.data.delivery);
                        commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {root: true});
                        dispatch('payments/setGiftCardData', result.data.giftCardData, {root: true});
                        commit('setLoadingState', false);
                    });
            },
            updateSelectedOptionAndMethod({state, commit, dispatch}, selectedOption) {
                const method = state.deliveryMethods.find((method) => method.selected);
                const option = selectedOption || method.options.find((option) => option.selected);
                commit('setLoadingState', true);
                return axios({
                    method: 'post',
                    url: method.updateURL,
                    data: {option, page: 'checkout_v3_page'},
                    headers: {'Content-Type': 'application/json'},
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    exclusionResultHandler(state.exclusionResults, result.data.delivery.exclusionResults, commit);
                    commit('setDeliveryState', result.data.delivery);
                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {root: true});
                    dispatch('payments/setGiftCardData', result.data.giftCardData, {root: true});
                    commit('setLoadingState', false);
                });
            },
            getMorePickupPoints({state, commit}) {
                const pickupPointMethod = state.deliveryMethods.find((method) => method.id === 'pickupPoint');
                if (!pickupPointMethod.selected || pickupPointMethod.options.length < 5 || pickupPointMethod.options.length > 19) {
                    return true;
                }

                return axios({
                    method: 'get',
                    url: pickupPointMethod.getMoreURL
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }

                    commit('updatePickupPoints', result.data.pickupPoint);
                    return true;
                });
            },
            updatePickupPerson({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPickupPersonURL,
                    data: getters.pickupPerson
                });
            },
            updatePostnummer({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPostnummerURL,
                    data: getters.postnummer
                });
            },
            updatePickPost({getters}) {
                if (getters.selectedDeliveryMethod.id !== 'pickupPoint') {
                    return;
                }
                return axios({
                    method: 'post',
                    url: getters.selectedDeliveryMethod.setPickPostURL,
                    data: getters.pickPost
                });
            }
        },
        mutations: {
            selectDeliveryMethod(state, methodId) {
                state.deliveryMethods.forEach((method) => { method.selected = method.id === methodId; });
            },
            selectDeliveryOption(state, optionId) {
                const deliveryOptions = state.deliveryMethods.find((method) => method.selected).options;
                let selectedIndex = 0;
                deliveryOptions.forEach((option, index) => {
                    option.selected = option.id === optionId;
                    if (option.id === optionId) {
                        selectedIndex = index;
                    }
                });

                if (selectedIndex < MAX_OPTIONS_VISIBLE) {
                    return;
                }
                const [selectedOption] = deliveryOptions.splice(selectedIndex, 1);
                deliveryOptions.unshift(selectedOption);
            },
            setPostalCode(state, postalCode) {
                const element = state.postalCodeForm.form.formElements[0];
                element.state.value = postalCode;
                element.validationErrors = validateElement(element);
            },
            addPostalCodeError(state, error) {
                state.postalCodeForm.form.formElements[0].validationErrors = [error];
            },
            removePostalCodeError(state, error) {
                state.postalCodeForm.form.formElements[0].validationErrors =
                    state.postalCodeForm.form.formElements[0].validationErrors.filter((err) => err !== error);
            },
            setDeliveryState(state, deliveryState) {
                const previousEditMode = state.deliverySummary.editMode || deliveryState.exclusionResults.excludedPostal;
                const hadPostalPreApplied = state.deliverySummary.hasPostalCodePreApplied;
                Object.assign(state, deliveryState);
                Object.assign(
                    state.deliverySummary.deliveryAddress,
                    deliveryState.deliverySummary.deliveryAddress
                );
                state.deliverySummary.hasPostalCodePreApplied = hadPostalPreApplied;
                state.deliverySummary.editMode = previousEditMode;
            },
            updatePickupPoints(state, pickupPoint) {
                const pupMethod = state.deliveryMethods.find((method) => method.id === 'pickupPoint');
                Vue.set(pupMethod, 'options', [...pickupPoint.options]);
                pupMethod.flyIn.description = pickupPoint.flyIn.description;
            },
            setPickupPerson(state, pickupPerson) {
                state.pickupPerson = pickupPerson;
            },
            setLoadingState(state, value) {
                state.loadingState = value;
            },
            setEditMode(state, value) {
                state.deliverySummary.editMode = value;
            },
            setPickupPersonFieldValue(state, {fieldId, value}) {
                const field = state.pickupPerson[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            setPostnummerFieldValue(state, {fieldId, value}) {
                const field = state.postnummer[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            setPickPostFieldValue(state, {fieldId, value}) {
                const field = state.pickPost[fieldId];
                if (field) {
                    field.state.value = value;
                    field.validationErrors = validateElement(field);
                }
            },
            validatePickupPerson(state) {
                const method = state.deliveryMethods.find((method) => method.selected);
                if ((method && method.id !== 'pickupPoint') ||
                    !state.pickupPerson.isSomeoneElse.state.value
                ) {
                    return;
                }

                state.pickupPerson.firstName.validationErrors = validateElement(state.pickupPerson.firstName);
                state.pickupPerson.lastName.validationErrors = validateElement(state.pickupPerson.lastName);
            },
            validatePostnummer(state) {
                if (state.postnummer) {
                    state.postnummer.postnummerValue.validationErrors = validateElement(state.postnummer.postnummerValue);
                }
            },
            validatePickPost(state) {
                if (state.pickPost) {
                    state.pickPost.pickPostValue.validationErrors = validateElement(state.pickPost.pickPostValue);
                }
            },
            setShowEditModeError(state, value) {
                state.showEditModeError = value;
            }
        }
    };
};

// TODO: Move function
function getLatLong(postalCode) {
    const country = require('../../../../../modules/util/getCountryFromLocaleCookie')();

    const coordinates = {
        latitude: null,
        longitude: null
    };

    return new Promise(function (resolve) {
        new google.maps.Geocoder().geocode({
            componentRestrictions: {
                country
            },
            address: postalCode.replace(' ', '+') + ',+' + country,
            region: country
        }, function (results, status) {
            if (status !== 'OK') {
                resolve(coordinates);
                return;
            }

            const location = results[0].geometry.location;
            coordinates.latitude = location.lat();
            coordinates.longitude = location.lng();

            resolve(coordinates);
        });
    });
}

},{"../../../../../modules/util/getCountryFromLocaleCookie":488,"../../../../vue-form/vue-input/libs/validator":413,"./exclusion-result-handler":355,"axios":5,"vue":262}],355:[function(require,module,exports){
'use strict';

function exclusionResultHandler(oldExclustionResult, newExclusionResult, commit) {
    if (!oldExclustionResult.errorMessage && !newExclusionResult.errorMessage) {
        return;
    }

    commit('error/setErrorMessage', newExclusionResult.errorMessage, { root: true });
    commit('delivery/addPostalCodeError', newExclusionResult.postalCodeFieldError, { root: true });
}

module.exports = exclusionResultHandler;

},{}],356:[function(require,module,exports){
'use strict';

const axios = require('axios');
const {validateElement, softValidateElementAttributes} = require('../../../vue-form/vue-input/libs/validator');

const ssnMapping = {
    firstname: 'firstName',
    lastname: 'lastName',
    company: 'companyName',
    address: 'street',
    streetnumber: 'houseNumber',
    postalCode: 'postalCode',
    area: 'city',
    mobileNumber: 'phone'
};
const rgcMapping = {
    street: 'street',
    city: 'city',
    mobileNumber: 'phone'
};
module.exports = (detailsData) => ({
    namespaced: true,
    state: {
        ...detailsData
    },
    getters: {
        isShippingValid(state) {
            const elements = state.forms.shippingAddress.formElements;
            return elements.reduce(
                (result, element) => result && !validateElementInFormContext(element, elements).length,
                true
            );
        },
        isCompanyDetailsValid(state) {
            const elements = state.forms.companydetails.formElements;
            return elements.reduce(
                (result, element) => result && !validateElementInFormContext(element, elements).length,
                true
            );
        },
        firstInvalidShippingElementId(state) {
            const elements = state.forms.shippingAddress.formElements;
            const invalidElement = elements.find((element) => validateElementInFormContext(element, elements).length);

            return invalidElement.attributes.formId;
        },
        firstInvalidCompanyElementId(state) {
            const elements = state.forms.companydetails.formElements;
            const invalidElement = elements.find((element) => validateElementInFormContext(element, elements).length);

            return invalidElement.attributes.formId;
        },
        firstInvalidBillingElementId(state) {
            const elements = state.forms.billingAddress.formElements;
            const sameAsDeliveryAddress = state.forms.billingAddress.formElements[0];
            if (sameAsDeliveryAddress.state.value) {
                const vatElement = elements.find(
                    (element) => element.id === 'btwVatNumber' || element.id === 'nifNumber'
                );
                if (vatElement && validateElementInFormContext(vatElement, elements).length) {
                    return vatElement.attributes.formId;
                }
            }

            const invalidElement = elements.find((element) => validateElementInFormContext(element, elements).length);

            return invalidElement.attributes.formId;
        },
        isBillingValid(state) {
            const elements = state.forms.billingAddress.formElements;
            const sameAsDeliveryAddress = state.forms.billingAddress.formElements[0];
            if (sameAsDeliveryAddress.state.value) {
                const vatElement = elements.find(
                    (element) => element.id === 'btwVatNumber' || element.id === 'nifNumber'
                );
                if (vatElement) {
                    return !validateElementInFormContext(vatElement, elements).length;
                }
                return true;
            }

            return elements.reduce(
                (result, element) => result && !validateElementInFormContext(element, elements).length,
                true
            );
        },
        isFormValid: (_, getters) => (formId) => (formId === 'shippingAddress' ? getters.isShippingValid : getters.isBillingValid),
        isFieldValid: (state) => (formId, fieldId) => {
            const form = state.forms[formId];
            const formElements = form ? form.formElements : state.forms.formElements;
            const formElement = formElements.find((element) => element.id === fieldId);
            if (!formElement) {
                return true;
            }
            return !validateElementInFormContext(formElement, formElements).length;
        },
        shippingPostalCodeValue: (state) =>
            state.forms.shippingAddress.formElements.find((element) => element.id === 'postalCode').state.value,
        billingPostalCodeValue: (state) =>
            state.forms.billingAddress.formElements.find((element) => element.id === 'postalCode').state.value,
        getCityHKValue: (state) => (formId) => {
            if (!formId) {
                return;
            }
            return state.forms[formId].formElements.find((element) => element.id === 'city').state.value;
        },
        getDistrictHKValue: (state) => (formId) => {
            if (!formId) {
                return;
            }
            return state.forms[formId].formElements.find((element) => element.id === 'district').state.value;
        },
        getFieldValue: (state) => (formId, fieldId) => {
            const form = state.forms[formId];
            const formElements = form ? form.formElements : state.forms.formElements;
            const formElement = formElements.find((element) => element.id === fieldId);
            return formElement ? formElement.state.value : null;
        },
        phoneNumber: (state) => getPhoneNumber(state.forms.shippingAddress.formElements),
        getFormsAsJSON: (state) => {
            const json = {
                shippingAddress: getElementsAsJSON(state.forms.shippingAddress.formElements),
                billingAddress: getElementsAsJSON(state.forms.billingAddress.formElements),
                companydetails: getElementsAsJSON(state.forms.companydetails.formElements)
            };
            json.shippingAddress.phone = getPhoneNumber(state.forms.shippingAddress.formElements);
            const sameAsDeliveryAddress = state.forms.billingAddress.formElements[0];
            if (sameAsDeliveryAddress && sameAsDeliveryAddress.state.value) {
                Object.keys(json.billingAddress).forEach(function (key) {
                    if (key in json.shippingAddress) {
                        json.billingAddress[key] = json.shippingAddress[key];
                    }
                    if (key === 'saveAddress') {
                        json.billingAddress[key] = false;
                    }
                });
            }

            return json;
        },
        getStateOptions: (state) => {
            const stateAttribute = state.forms.shippingAddress.formElements.find((element) => element.id === 'state');
            if (!stateAttribute) {
                return;
            }

            if (!stateAttribute.attributes.options.length) {
                return;
            }

            return stateAttribute.attributes.options.reduce((acc, option) => {
                if (option.id) {
                    acc.region[option.id] = option.label;
                }
                return acc;
            }, {region: {}});
        },
        getFormAsJSON: (state) => (formId) => {
            const form = state.forms[formId];
            if (!form) {
                return;
            }

            return getElementsAsJSON(form.formElements);
        },
        isFormValidatedAndInvalid: (state) => (formId) => {
            const form = state.forms[formId];
            const formElements = form ? form.formElements : state.forms.formElements;
            return formElements.some((element) => element.validationErrors.length);
        },
        showPhoneRow: (state) =>
            !!state.forms.shippingAddress.formElements.find((element) => element.id === 'phoneNumberOptions'),
        validateRGCInput: (state) => (formId) => {
            const form = state.forms[formId];
            const formElements = form ? form.formElements : state.forms.formElements;
            return validateRGCInput(formElements);
        },
        getPlaceholderPhoneNumber: (state) => getPlaceholderPhoneNumber(state.forms.shippingAddress.formElements)
    },
    actions: {
        postForms({state, commit, getters, rootGetters}, dontSaveAddresses) {
            const forms = getters.getFormsAsJSON;
            forms.pickupPerson = rootGetters['delivery/pickupPerson'];
            forms.dHLPostNummer = rootGetters['delivery/postnummer'];
            forms.pickPostUserID = rootGetters['delivery/pickPost'];
            forms.dontSaveAddresses = dontSaveAddresses || false;

            return axios({
                method: 'post',
                url: state.forms.attributes.actionURL,
                data: forms,
                headers: {'Content-Type': 'application/json'}
            }).then((result) => {
                if (result && result.data && !('skipUpdateFormData' in result.data)) {
                    commit('updateFormData', result.data);
                }
                return true;
            });
        },
        getAddressInfo({state, commit}, value) {
            const url = `${state.ssnField.actionURL}/?ssn=${value}`;
            return axios({
                method: 'post',
                url: url,
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then((result) => {
                if (result.data.result) {
                    const data = JSON.parse(result.data.result);
                    commit('updateFieldsFromSSN', data);
                }
            });
        },
        getAddressFromRGC({state, commit}, formId) {
            const appendParamsToUrl = require('../../../../modules/util/appendParamsToUrl');
            const form = state.forms[formId];
            const formElements = form ? form.formElements : state.forms.formElements;
            const houseNumberField = formElements.find((el) => el.id === 'houseNumber');
            const zipCodeField = formElements.find((el) => el.id === 'postalCode');
            const formPrefix =
                formId === 'shippingAddress'
                    ? 'dwfrm_singleshipping_shippingAddress_addressFields_'
                    : 'dwfrm_billing_billingAddress_addressFields_';
            const url = appendParamsToUrl(Urls.rgcRetrieveAddress, {
                postalCode: zipCodeField.state.value.replace(/\s/g, ''),
                houseNumber: houseNumberField.state.value,
                format: 'ajax',
                formPrefix: formPrefix
            });
            return axios({
                method: 'get',
                url: url,
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then((result) => {
                if (result.data) {
                    commit('updateFieldsFromRGC', {data: result.data, formId: formId});
                }
            });
        },
        submitMemberDetails({state, rootState, commit, getters, rootGetters}) {
            const billingAddressId = rootState.addressBook.selectedAddresses.selectedBillingAddressId;
            const phone = getPhoneNumber(state.forms.shippingAddress.formElements);
            const savePhoneNumber = getters.getFieldValue('shippingAddress', 'savePhoneNumber');
            const selectedPhoneOption = getters.getFieldValue('shippingAddress', 'phoneNumberOptions');
            const vat =
                getters.getFieldValue('billingAddress', 'btwVatNumber') ||
                getters.getFieldValue('billingAddress', 'nifNumber');
            const useSameAsShipping = getters.getFieldValue('billingAddress', 'useSameAsShipping');
            const data = {billingAddressId, phone, vat, useSameAsShipping, savePhoneNumber};
            const address = rootGetters['addressBook/getAddressById'](billingAddressId);
            if (address && address.temporary) {
                data.tempAddress = address.fieldValues;
            }
            data.pickupPerson = rootGetters['delivery/pickupPerson'];
            data.dHLPostNummer = rootGetters['delivery/postnummer'];
            data.pickPostUserID = rootGetters['delivery/pickPost'];
            return axios({
                method: 'post',
                url: state.submitDetailsURL,
                data,
                headers: {'Content-Type': 'application/json'}
            }).then((result) => {
                if (result.data) {
                    commit('updateDetails', result.data);
                }
                commit('setEditMode', false);
                if (selectedPhoneOption) {
                    commit('updateFieldValue', {
                        formId: 'shippingAddress',
                        fieldId: 'phoneNumberOptions',
                        value: selectedPhoneOption
                    });
                }
                return true;
            });
        },
        submitGuestDetails({state, rootState, commit, dispatch, getters}) {
            const isUSUser = true;
            const phone = getPhoneNumber(state.forms.shippingAddress.formElements);
            const useSameAsShipping = getters.getFieldValue('billingAddress', 'useSameAsShipping');
            const savePhoneNumber = getters.getFieldValue('shippingAddress', 'savePhoneNumber');
            const forms = getters.getFormsAsJSON;
            const data = {...forms, phone, useSameAsShipping, savePhoneNumber, isUSUser};

            return axios({
                method: 'post',
                url: state.forms.attributes.actionURL,
                data: data,
                headers: {'Content-Type': 'application/json'}
            }).then((result) => {
                if (result.data.addressValidationError) {
                    commit('error/setErrorMessage', result.data.addressValidationError, {root: true});
                } else {
                    rootState.delivery.deliverySummary.editMode = false;
                    commit('updateDetails', result.data.details);
                    commit('delivery/setDeliveryState', result.data.delivery, {root: true});
                    commit('orderSummary/setOrderSummaryData', result.data.orderSummary, {root: true});
                    commit('addressBook/updateAddresses', result.data.addressBook, {root: true});
                    commit('setEditMode', false);
                    commit('error/setErrorMessage', null, {root: true});

                    const addressObject = result.data.addressObject;
                    for (const adresses in addressObject) {
                        const addressId = addressObject[adresses].ID;
                        const type = addressObject[adresses].type;
                        commit('addressBook/selectAddress', {type, addressId}, {root: true});
                        dispatch('addressBook/updateSelectedAddress', {type, addressId}, {root: true});
                    }
                }
                return true;
            });
        },
        saveAddressesToForms({state, getters}) {
            return axios({
                method: 'post',
                url: state.saveAddressesToFormsURL,
                data: getters.getFormsAsJSON,
                headers: {'Content-Type': 'application/json'}
            });
        },
        setStateCodeByPostal({state, commit, getters}, addressType) {
            if (state.countryCode !== 'US') {
                return;
            }
            const postalCode =
                addressType === 'shippingAddress' ? getters.shippingPostalCodeValue : getters.billingPostalCodeValue;

            return getStateUSCode(postalCode).then((stateUS) => {
                if (stateUS) {
                    commit('updateFieldValue', {
                        formId: addressType,
                        fieldId: 'stateUS',
                        value: stateUS
                    });
                }
            });
        },
        setCityHK({commit}, formId) {
            if (!formId) {
                return;
            }
            return axios({
                method: 'get',
                url: Urls.getTowns,
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then((response) => {
                commit('setFieldValue', {
                    formId: formId,
                    fieldId: 'city',
                    value: response.data.result.towns
                });
            });
        },
        setDistrictHK({commit, getters}, formId) {
            if (!formId) {
                return;
            }
            const appendParamsToUrl = require('../../../../modules/util/appendParamsToUrl');
            const getCityHKValue = getters.getCityHKValue(formId);
            const url = appendParamsToUrl(Urls.getDistrictsForTown, {
                town: getCityHKValue
            });
            return axios({
                method: 'get',
                url: url,
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then((response) => {
                commit('setFieldValue', {
                    formId: formId,
                    fieldId: 'district',
                    value: response.data.result.districts
                });
            });
        },
        setSubdistrictHK({commit, getters}, formId) {
            if (!formId) {
                return;
            }
            const appendParamsToUrl = require('../../../../modules/util/appendParamsToUrl');
            const getDistrictHKValue = getters.getDistrictHKValue(formId);
            const url = appendParamsToUrl(Urls.getSubdistrictsForDistrict, {
                district: getDistrictHKValue
            });
            return axios({
                method: 'get',
                url: url,
                data: {},
                headers: {'Content-Type': 'application/json'}
            }).then((response) => {
                commit('setFieldValue', {
                    formId: formId,
                    fieldId: 'subdistrict',
                    value: response.data.result.subdistricts
                });
            });
        }
    },
    mutations: {
        updateFieldsFromSSN(state, data) {
            const shippingElements = state.forms.shippingAddress.formElements;
            Object.entries(data).forEach(([key, value]) => {
                const fieldId = ssnMapping[key];
                if (!value || !fieldId) {
                    return;
                }
                const field = shippingElements.find((element) => element.id === fieldId);
                if (field) {
                    field.state.value = value;
                }
            });
        },
        updateFieldsFromRGC(state, args) {
            const {data, formId} = args;
            const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
            Object.entries(data.data).forEach(([key, value]) => {
                const fieldId = rgcMapping[key];
                if (!value || !fieldId) {
                    return;
                }
                const field = formElements.find((element) => element.id === fieldId);
                if (field) {
                    field.state.value = value;
                }
            });
        },
        updateDetails(state, newState) {
            Object.assign(state, newState);
        },
        setFieldValue(state, args) {
            const {formId, fieldId, value} = args;
            const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
            const element = formElements.find((element) => element.id === fieldId);
            if (!element) {
                return;
            }
            if (element.attributes.options && element.attributes.options.length !== 0) {
                element.attributes.options.splice(0, element.attributes.options.length);
            }
            value.forEach(function (option) {
                element.attributes.options.push({
                    id: option.value,
                    htmlValue: option.value,
                    label: option.text
                });
            });
            element.state.selectedOption = element.attributes.options[0];
            element.state.__ob__.dep.notify(); // if the initial value === trimmed value the components won't be notified
        },
        updateFieldValue(state, args) {
            const {formId, fieldId, value} = args;
            const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
            const element = formElements.find((element) => element.id === fieldId);
            if (!element) {
                return;
            }
            element.state.value = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;
            if (element.attributes.options && element.attributes.options.length) {
                element.state.selectedOption = element.attributes.options.find((option) => option.id === value);
            }
            element.state.__ob__.dep.notify(); // if the initial value === trimmed value the components won't be notified
            element.softValidationErrors = softValidateElementAttributes(element);
            element.validationErrors = validateElementInFormContext(element, formElements);
            updatePhoneErrors(element, formElements);
            if (element.validationErrors.length > 0) {
                this.commit('analytics/handleCheckoutFieldError', {section: 'details', message: element.validationErrors[0]});
            }
        },
        addValidationError(state, args) {
            const {formId, fieldId, error} = args;
            const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
            const element = formElements.find((element) => element.id === fieldId);
            if (!element) {
                return;
            }
            element.validationErrors.push(error);
        },
        removeValidationError(state, args) {
            const {formId, fieldId, error} = args;
            const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
            const element = formElements.find((element) => element.id === fieldId);
            if (!element) {
                return;
            }
            element.validationErrors = element.validationErrors.filter((err) => err !== error);
        },
        validateForm(state, formId) {
            const elements = state.forms[formId].formElements;
            elements.forEach((element) => {
                element.softValidationErrors = softValidateElementAttributes(element);
                element.validationErrors = validateElementInFormContext(element, elements);
            });
        },
        updatesameAsDeliveryAddress(state, value) {
            state.sameAsDeliveryAddress.state.value = value;
        },
        updateFormData(state, forms) {
            forms.shippingAddress.formElements.forEach((element, i) => {
                state.forms.shippingAddress.formElements[i].validationErrors = element.validationErrors;
            });
            forms.shippingAddress.formElements.forEach((element, i) => {
                state.forms.shippingAddress.formElements[i].softValidationErrors = element.softValidationErrors;
            });
            forms.billingAddress.formElements.forEach((element, i) => {
                state.forms.billingAddress.formElements[i].validationErrors = element.validationErrors;
            });
            forms.billingAddress.formElements.forEach((element, i) => {
                state.forms.billingAddress.formElements[i].softValidationErrors = element.softValidationErrors;
            });
            if (forms.companydetails) {
                forms.companydetails.formElements.forEach((element, i) => {
                    state.forms.companydetails.formElements[i].validationErrors = element.validationErrors;
                });
            }
        },
        copyShippingToBillingAddress(state) {
            const billingElements = state.forms.billingAddress.formElements;
            const shippingElements = state.forms.shippingAddress.formElements;

            billingElements.forEach((element) => {
                const shippingElement = shippingElements.find((shippingElemenet) => shippingElemenet.id === element.id);
                if (shippingElement) {
                    element.state.value = shippingElement.state.value;
                }
            });
        },
        setSelectedBillingAddressId(state, id) {
            state.selectedBillingAddressId = id;
        },
        clearElements(state, {formId, elementIds}) {
            const form = state.forms[formId];
            if (!form) {
                return;
            }

            form.formElements.forEach((element) => {
                if (!elementIds.includes(element.id) || element.attributes.readOnly) {
                    return;
                }
                if (typeof element.state.value === 'boolean') {
                    element.state.value = false;
                    return;
                }
                element.state.value = '';
                element.state.htmlValue = '';
                element.validationErrors = [];
                element.softValidationErrors = [];
                if (element.attributes.options && element.attributes.options.length) {
                    element.state.selectedOption = element.attributes.options[0];
                }
            });
        },
        setEditMode(state, value) {
            state.editMode = value;
        },
        setShowEditModeError(state, value) {
            state.showEditModeError = value;
        }
    }
});

function validateElementInFormContext(element, formElements) {
    if (element.id === 'phone' || element.id === 'phoneNumberOptions') {
        return validatePhoneGroupElements(element, formElements);
    }

    return validateElement(element);
}

function validatePhoneGroupElements(element, formElements) {
    if (element.id === 'phone') {
        return validatePhoneElement(element, formElements);
    }

    return [];
}

function updatePhoneErrors(element, formElements) {
    if (element.id === 'phoneNumberOptions' && element.state.value === 'savedPhoneNumber') {
        const phone = formElements.find((el) => el.id === 'phone');
        if (phone) {
            phone.validationErrors = [];
        }
    }
}

function validatePhoneElement(phone, formElements) {
    const phoneOptions = formElements.find((el) => el.id === 'phoneNumberOptions');
    if (!phoneOptions || phoneOptions.state.value !== 'savedPhoneNumber') {
        return validateElement(phone);
    }

    return [];
}

function getPhoneNumber(formElements) {
    const phoneField = formElements.find((el) => el.id === 'phone');
    const phoneOptions = formElements.find((el) => el.id === 'phoneNumberOptions');
    if (!phoneOptions || phoneOptions.state.value !== 'savedPhoneNumber') {
        return phoneField.state.value;
    }

    return phoneOptions.attributes.options[0].label;
}
function getPlaceholderPhoneNumber(formElements) {
    const phoneField = formElements.find((el) => el.id === 'phone');
    const placeholder = phoneField.attributes.placeholder;
    const plusIndex = placeholder.indexOf('+');

    return placeholder.substring(plusIndex);
}
function validateRGCInput(formElements) {
    const houseNumberField = formElements.find((el) => el.id === 'houseNumber');
    const zipCodeField = formElements.find((el) => el.id === 'postalCode');
    if (houseNumberField && houseNumberField.state.value != '' && zipCodeField && zipCodeField.state.value != '') {
        return true;
    }
}
function getElementsAsJSON(elements) {
    const json = {};
    elements.forEach((element) => {
        json[element.id] = element.state.value;
    });

    return json;
}
function getStateUSCode(postalCode) {
    const country = require('../../../../modules/util/getCountryFromLocaleCookie')();
    const geocoder = new google.maps.Geocoder();
    let stateUSCode = null;

    return new Promise(function (resolve) {
        geocoder.geocode(
            {
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            },
            function (results, status) {
                if (status === 'OK') {
                    const addressComponents = results[0].address_components.filter(function (addressComponent) {
                        return addressComponent.types[0] === 'administrative_area_level_1';
                    });

                    stateUSCode =
                        addressComponents && addressComponents[0] ? addressComponents[0].short_name.toUpperCase() : '';
                    resolve(stateUSCode);
                } else {
                    resolve(stateUSCode);
                }
            }
        );
    });
}

},{"../../../../modules/util/appendParamsToUrl":480,"../../../../modules/util/getCountryFromLocaleCookie":488,"../../../vue-form/vue-input/libs/validator":413,"axios":5}],357:[function(require,module,exports){
'use strict';

module.exports = (errorMessage) => {
    return {
        namespaced: true,
        state: { errorMessage: errorMessage},
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            removeErrorMessage(state, message) {
                if (state.errorMessage === message) {
                    state.errorMessage = null;
                }
            }
        }
    };
};


},{}],358:[function(require,module,exports){
'use strict';

const axios = require('axios');

module.exports = (eurobonusData) => {
    return {
        namespaced: true,
        state: {
            ...eurobonusData,
            errorMessage: '',
            showError: false
        },
        getters: {},
        actions: {
            addCode({state, commit}, eurobonusCode) {
                if (!eurobonusCode || eurobonusCode.length != 9) {
                    commit('setErrorMessage', state.resources.minLengthError);
                    commit('setShowError', true);
                    return false;
                }

                const bodyFormData = new FormData();
                bodyFormData.append(state.eurobonusInputName, eurobonusCode);
                bodyFormData.append(state.eurobonusMemberName, true);

                return axios({
                    method: 'post',
                    url: state.eurobonusApplyURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then((result) => {
                    const isSuccess = result.data.success;
                    if (isSuccess) {
                        commit('setCodeValue', eurobonusCode);
                        commit('setCodeValueLabel', result.data.message);
                    }
                    commit('setErrorMessage', result.data.message);
                    commit('setShowError', !isSuccess);
                });
            },
            removeCode({state, commit}) {
                return axios({
                    method: 'post',
                    url: state.eurobonusRemoveURL,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    commit('setCodeValue', '');
                    commit('setErrorMessage', '');
                    commit('setShowError', false);
                });
            },
            updateEnabledFlag({state, commit}, isEnabled) {
                const bodyFormData = new FormData();
                const eurobonusMemberValue = isEnabled ? !!state.eurobonusCodeValue : false;
                bodyFormData.append(state.eurobonusMemberName, eurobonusMemberValue);

                return axios({
                    method: 'post',
                    url: state.eurobonusUpdateMemberURL,
                    data: bodyFormData,
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                }).then(() => {
                    commit('setEurobonusEnabled', isEnabled);
                    commit('setErrorMessage', '');
                    commit('setShowError', false);
                });
            }
        },
        mutations: {
            setErrorMessage(state, newMessage) {
                state.errorMessage = newMessage;
            },
            setCodeValue(state, eurobonusCode) {
                state.eurobonusCodeValue = eurobonusCode;
            },
            setCodeValueLabel(state, label) {
                state.resources.eurobonusCodeValueLabel = label;
            },
            setEurobonusEnabled(state, value) {
                state.eurobonusEnabled = value;
            },
            setShowError(state, value) {
                state.showError = value;
            }
        }
    };
};

},{"axios":5}],359:[function(require,module,exports){
'use strict';

const axios = require('axios');

module.exports = (orderSummaryData) => {
    return {
        namespaced: true,
        state: { ...orderSummaryData },
        mutations: {
            setOrderSummaryData(state, orderSummaryData) {
                Object.assign(state, orderSummaryData);
            },
            updatePropertyValue(state, args) {
                const { propertyName, value } = args;
                state[propertyName] = value;
            }
        },
        actions: {
            removeLineItem({ state, commit, dispatch }, productId) {
                return axios({
                    method: 'post',
                    url: state.removeItemURL,
                    data: { productId },
                    headers: { 'Content-Type': 'application/json' },
                }).then((result) => {
                    if (result.status !== 200) {
                        return false;
                    }
                    commit('setOrderSummaryData', result.data.orderSummary);
                    commit('delivery/setDeliveryState', result.data.delivery, { root: true });
                    dispatch('payments/setGiftCardData', result.data.giftCardData, { root: true });
                    commit('error/setErrorMessage', result.data.delivery.exclusionResults.errorMessage, { root: true });
                }).catch((error) => {
                    if (error.response && error.response.status === 303 && error.response.data.redirectURL) {
                        window.location.replace(error.response.data.redirectURL);
                    }
                });
            }
        },
    };
};

},{"axios":5}],360:[function(require,module,exports){
'use strict';

const axios = require('axios');
const { validateElement } = require('../../../vue-form/vue-input/libs/validator');

module.exports = (paymentsDTO) => {
    return {
        namespaced: true,
        state: {
            paymentData: {
                adyenData: null,
                cardHolderName: null,
                brandCode: null,
                saveCreditCard: null,
                shopperInteraction: null
            },
            adyenData: {
                loaded: false,
                clientToken: null,
                paymentData: null
            },
            giftcardPaymentError: null,
            focusCreditCardBlock: false,
            paymentRequiredActionData: null, // used when adyen demands additional checks to accept payment
            ...paymentsDTO,
            showEditModeError: false,
            paymentMethodError: null,
            backupedPaymentMethod: null,
            setSecuredFieldsStyle: {
                error: {
                    color: '#d6122d'
                },
                placeholder: {
                    fontFamily: 'ScalaSansOT, Segoe UI, Roboto, Helvetica Neue, sans-serif',
                    fontSize: '16px',
                    color: '#aeaeae',
                    letterSpacing: '0.5px',
                    lineHeight: '24px'
                },
                base: {
                    fontFamily: 'ScalaSansOT, Segoe UI, Roboto, Helvetica Neue, sans-serif',
                    fontSize: '16px',
                    color: '#1A1919',
                    fontSmoothing: 'antialiased',
                    letterSpacing: '0.5px',
                    lineHeight: '24px'
                }
            },
            amazonButtonType: paymentsDTO.amazonButtonType,
            paymentDescriptor: ''
        },
        getters: {
            mbwayField: (state) => {
                return state.forms.mbway.formElements.find(element => element.id === 'mbway-phone-number');
            },
            blikField: (state) => {
                return state.forms.blik.formElements.find(element => element.id === 'blik-pincode');
            },
            bankOptionsField: (state) => (paymentType) => {
                const form = state.forms[paymentType];
                return form && form.formElements.find(element => element.id === 'bank-options-' + paymentType);
            },
            giftcardOptionsField(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options');
            },
            hasNoGiftCardOptions(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length == 1;
            },
            hasOneGiftCardOption(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length == 2;
            },
            hasMoreGiftCardOption(state) {
                return state.forms.giftcards.formElements.find(element => element.id === 'giftcard-options').attributes.options.length > 2;
            },
            getField: (state) => (formId, fieldId) => {
                const form = state.forms[formId];
                const formElements = form ? form.formElements : state.forms.formElements;
                return formElements.find(element => element.id === fieldId);
            },
            getFieldValue: (state) => (formId, fieldId) => {
                const form = state.forms[formId];
                const formElements = form ? form.formElements : state.forms.formElements;
                const formElement = formElements.find(element => element.id === fieldId);
                return formElement ? formElement.state.value : null;
            },
            isFormValid: (state) => (formId) => {
                const elements = state.forms[formId].formElements;
                return elements.reduce((result, element) => {
                    return result && !validateElement(element).length;
                }, true);
            }
        },
        actions: {
            setSelectedPaymentMethod({state, commit, dispatch}, args) {
                const paymentMethod = args.paymentMethod;
                const revertChanges = args.revertChanges;
                const data = {
                    paymentMethod: paymentMethod.type,
                    readMode: !!state.preselectedPaymentMethod,
                    paymentData: paymentMethod.paymentData,
                    revertChanges: revertChanges
                };
                if (paymentMethod.issuerId) {
                    data.issuerId = paymentMethod.issuerId;
                }
                return axios({
                    method: 'post',
                    url: paymentMethod.setPaymentMethodUrl,
                    data: data,
                    headers: { 'Content-Type': 'application/json' },
                })
                    .then((res) => {
                        if (!res || !res.data || res.data.error) {
                            return {error: true};
                        }
                        const newPaymentMethod = {...paymentMethod};
                        if (res.data.giftCardData) {
                            dispatch('setGiftCardData', res.data.giftCardData);
                        }
                        commit('updateSelectedPaymentMethod', newPaymentMethod);
                        commit('updatePropertyValue', {
                            propertyName: 'adyenData',
                            value: {
                                loaded: false,
                                clientToken: null,
                                paymentData: null,
                            }
                        });
                        return {error: false};
                    });
            },
            setGiftCardData({commit}, giftCardData) {
                commit('setAppliedGiftcards', giftCardData.appliedGiftcards);
                commit('orderSummary/updatePropertyValue', { propertyName: 'giftCardDeductionAmount', value: giftCardData.giftCardsTotalAmount }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'giftCardDeductionAmountValue', value: giftCardData.giftCardsTotalAmountValue }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPrice', value: giftCardData.remainingAmount }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPriceValue', value: giftCardData.remainingAmountValue }, { root: true });
                commit('orderSummary/updatePropertyValue', { propertyName: 'orderTotalsPriceForAdyen', value: giftCardData.remainingAmountForAdyen }, { root: true });
                commit('updatePropertyValue', { propertyName: 'payingFullAmountWithGiftcard', value: giftCardData.remainingAmountValue <= 0 });
            }
        },
        mutations: {
            setPaymentsData(state, paymentsData) {
                Object.assign(state, paymentsData);
            },
            updatePropertyValue(state, args) {
                const { propertyName, value } = args;
                state[propertyName] = value;
            },
            updateSelectedPaymentMethod(state, paymentMethod) {
                state.selectedPaymentMethod = paymentMethod;
            },
            updatePreselectedPaymentMethod(state, paymentMethod) {
                state.preselectedPaymentMethod = paymentMethod;
            },
            setReadMode(state, readMode) {
                state.readMode = readMode;
            },
            setAdyenPaymentData(state, adyenPaymentData) {
                state.paymentData.adyenData = adyenPaymentData;
            },
            setCardHolderName(state, cardHolderName) {
                state.paymentData.cardHolderName = cardHolderName;
            },
            setSaveCreditCard(state, saveCreditCard) {
                state.paymentData.saveCreditCard = saveCreditCard === 'on';
            },
            setBrandCode(state, brandCode) {
                state.paymentData.brandCode = brandCode;
            },
            setShopperInteraction(state, shopperInteraction) {
                state.paymentData.shopperInteraction = shopperInteraction;
            },
            setPaymentRequiredActionData(state, paymentRequiredActionData) {
                state.paymentRequiredActionData = paymentRequiredActionData;
            },
            setAppliedGiftcards(state, appliedGiftcards) {
                state.appliedGiftcards = appliedGiftcards;
            },
            setPaymentDescriptor(state, paymentDescriptor) {
                state.paymentDescriptor = paymentDescriptor;
            },
            backupSelectedPaymentMethod(state, giftcardType) {
                if (!giftcardType) {
                    state.selectedPaymentMethod = state.backupedPaymentMethod;
                    state.backupedPaymentMethod = state.defaultPaymentMethod;
                } else {
                    state.backupedPaymentMethod = state.selectedPaymentMethod;
                    state.selectedPaymentMethod = state.defaultPaymentMethod;
                }
            },
            updateFieldValue(state, args) {
                const { formId, fieldId, value } = args;
                const formElements = state.forms[formId] ? state.forms[formId].formElements : state.forms.formElements;
                const element = formElements.find(element => element.id === fieldId);
                if (!element) {
                    return;
                }
                element.state.value = typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;
                if (element.attributes.options && element.attributes.options.length) {
                    element.state.selectedOption = element.attributes.options.find(option => option.id === value);
                }
                element.state.__ob__.dep.notify(); // if the initial value === trimmed value the components won't be notified
                element.validationErrors = validateElement(element);
            },
            validateForm(state, formId) {
                const elements = state.forms[formId].formElements;
                elements.forEach(element => {
                    element.validationErrors = validateElement(element);
                });
            },
            clearForm(state, formId) {
                const form = state.forms[formId];
                if (!form) {
                    return;
                }

                form.formElements.forEach(element => {
                    if (typeof element.state.value === 'boolean') {
                        element.state.value = false;
                        return;
                    }
                    element.state.value = '';
                    element.state.htmlValue = '';
                    element.validationErrors = [];
                    if (element.attributes.options && element.attributes.options.length) {
                        element.state.selectedOption = element.attributes.options[0];
                    }
                });
            },
            setShowEditModeError(state, showEditModeError) {
                state.showEditModeError = showEditModeError;
            },
            focusCreditCardBlock(state, shouldFocus) {
                state.focusCreditCardBlock = shouldFocus;
            },
            setPaymentMethodError(state, paymentMethodError) {
                state.paymentMethodError = paymentMethodError;
            }
        }
    };
};

},{"../../../vue-form/vue-input/libs/validator":413,"axios":5}],361:[function(require,module,exports){
'use strict';

const { validateElement } = require('../../../vue-form/vue-input/libs/validator');

module.exports = (privacyDTO) => {
    return {
        namespaced: true,
        state: {
            ...privacyDTO,
        },
        getters: {
            isValid(state) {
                if (!state.show || !state.checkbox) {
                    return true;
                }
                return validateElement(state.checkbox).length === 0;
            }
        },
        actions: { },
        mutations: {
            updateCheckboxValue(state, value) {
                if (!state.show || !state.checkbox) {
                    return;
                }
                state.checkbox.state.value = value;
                state.checkbox.validationErrors = validateElement(state.checkbox);
            },
            validate(state) {
                if (!state.show || !state.checkbox) {
                    return;
                }
                state.checkbox.validationErrors = validateElement(state.checkbox);
            }
        }
    };
};

},{"../../../vue-form/vue-input/libs/validator":413}],362:[function(require,module,exports){
'use strict';

module.exports = (socialCommerceData) => {
    return {
        namespaced: true,
        state: {
            ...socialCommerceData,
        },
        getters: { },
        actions: { },
        mutations: { }
    };
};

},{}],363:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;

module.exports = {
    data() {
        return {
            offsetTop: 80
        };
    },
    methods: {
        getBannerData() {
            const bannerPlaceholder = document.querySelector('.error-banner-placeholder');
            this.offsetTop = bannerPlaceholder.getBoundingClientRect().top;
        }
    },
    computed: {
        ...mapState('error', [
            'errorMessage'
        ]),
        bannerStyles() {
            if (this.offsetTop <= 0) {
                return {'fixed': true};
            }
        }
    },
    watch: {
        errorMessage (newErrorMessage, errorMessage) {
            if (!newErrorMessage && errorMessage) {
                window.removeEventListener('scroll', this.getBannerData);
                return;
            }
            if (newErrorMessage && !errorMessage) {
                this.$store.commit('analytics/handleCheckoutFieldError', {section: 'details', message: newErrorMessage});
                window.addEventListener('scroll', this.getBannerData);
            }
        }
    },
    mounted() {
        if (this.errorMessage) {
            window.addEventListener('scroll', this.getBannerData);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorMessage)?_c('div',{staticClass:"error-banner-wrapper"},[_c('div',{staticClass:"error-banner-placeholder"}),_vm._v(" "),_c('div',{staticClass:"error-banner",class:_vm.bannerStyles},[_c('div',{staticClass:"inner-wrapper"},[_c('span',{staticClass:"icon error-icon-white"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.errorMessage))])])])]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09a656aa", __vue__options__)
  } else {
    hotAPI.reload("data-v-09a656aa", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257,"vuex":264}],364:[function(require,module,exports){
'use strict';

const dynamicFormAppEl = '.dynamic-form-app';

const createDynamicForms = () => {
    document.querySelectorAll(dynamicFormAppEl).forEach(el => {
        renderDynamicForm(el);
    });
};

const renderDynamicForm = (el) => {
    const Vue = require('vue');
    const DynamicForm = require('./dynamic-form/dynamic-form.vue');

    return new Vue({
        el: el,
        components: {
            DynamicForm
        }
    });
};

const shouldInit = () => {
    return document.querySelectorAll(dynamicFormAppEl).length > 0;
};

const dynamicFormApp = {
    init: () => {
        if (shouldInit()) {
            createDynamicForms();
        }
    }
};

module.exports = dynamicFormApp;

},{"./dynamic-form/dynamic-form.vue":365,"vue":262}],365:[function(require,module,exports){
;(function(){
'use strict';

const axios = require('axios');
const VueForm = require('../../vue-form/vue-form/vue-form.vue');
const VueInput = require('../../vue-form/vue-input/vue-input.vue');

module.exports = {
    name: 'dynamic-form',

    props: {
        form: {
            type: [String, Boolean],
            default: false
        },
        wrap: {
            type: [Boolean],
            default: false
        },
    },

    components: {
        VueForm,
        VueInput
    },

    computed: {
        queryParams() {
            return {};
        }
    },

    mounted() {
        axios
            .get(this.dataUrl, {
                timeout: 10000,
                params: this.queryParams
            })
            .then(resp => {
                this.formActions = resp.data[this.form].actions || resp.data.actions;
                this.formElements = resp.data[this.form].formElements || resp.data.formElements;
            })
            .then(() => {
                this.dataReady = true;
            })
            .catch((error) => {
                console.debug(error);
            });
    },

    data() {
        return {
            dataUrl: 'https://od04.rituals.com/on/demandware.static/Sites-Global-Site/-/en_NL/v1619079272020/dynamic-forms.json',
            formActions: {},
            formElements: {}
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dynamic-form"},[_c('vue-form',[(_vm.wrap)?_vm._l((_vm.formElements),function(formElement){return _c('div',{staticClass:"vue-form-row"},_vm._l((formElement),function(element){return _c('vue-input',{attrs:{"element":element,"tabindex":element.position}})}),1)}):[_vm._l((_vm.formElements),function(element){return _c('div',{staticClass:"vue-form-row"},[_c('vue-input',{attrs:{"element":element,"tabindex":element.position}})],1)}),_vm._v(" "),_c('div',{staticClass:"vue-form-row has-multiple-elements"},_vm._l((_vm.formActions),function(action){return _c('vue-input',{attrs:{"element":{
                        'attributes': action
                    }}})}),1)]],2)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-db1b7b40", __vue__options__)
  } else {
    hotAPI.reload("data-v-db1b7b40", __vue__options__)
  }
})()}

},{"../../vue-form/vue-form/vue-form.vue":406,"../../vue-form/vue-input/vue-input.vue":415,"axios":5,"vue":262,"vue-hot-reload-api":257}],366:[function(require,module,exports){
'use strict';

const Vue = require('vue');
const Flyin = require('./flyin/flyin.vue');

const flyinAppEl = '#flyin-app';
const flyinVueEl = '#flyin';
const flyinTrigger = '.js-flyin-trigger';

/**
 * Add events to all flyin triggers
 * The code below also illustrates how to trigger the Flyin
 */
const initTriggers = () => {
    document.querySelectorAll(flyinTrigger).forEach((trigger) => {
        trigger.addEventListener('click', () => {
            window.eventBus.$emit('shouldOpenFlyin', {
                content: '<div class="generic-flyout-header">Add markup here</div>',
                callback: () => {
                    // Add code for callback here...
                }
            });
        }, false);
    });

    document.addEventListener('keyup', (e) => {
        if (e.code === 'Escape') {
            window.eventBus.$emit('shouldCloseFlyin');
        }
    });
};

/**
 * Setup eventbus to allow Flyin to pass back data
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();
    window.eventBus.$on('shouldOpenFlyin', (data) => {
        if (flyInExists(data.id)) {
            return;
        }
        prepareMarkup(data.id);
        createFlyin(data);
    });

    window.eventBus.$on('flyinOpened', (data) => {
        if (data.callback && typeof data.callback === 'function') {
            data.callback();
        }
    });

    window.eventBus.$on('flyinClosed', (id) => {
        destroyFlyin(id);
    });
};

const flyInExists = (id) => document.querySelector([flyinVueEl, id].join(''));

/**
 * Prepares the markup for the Flyin to be attached to
 */
const prepareMarkup = () => {
    const template = `<div id="${flyinAppEl.substring(1)}" />`;
    document.querySelector('body').insertAdjacentHTML('beforeend', template);
};

/**
 * Attaches the Flyin app to the DOM
 */
const createFlyin = (data) => {
    return new Vue({
        el: flyinAppEl,
        store: data.store,
        components: {Flyin},
        computed: {
            config() {
                return data;
            }
        },
        template: `<flyin :config="config" />`
    });
};

/**
 * Removes the Flyin App from the DOM
 */
const destroyFlyin = (id) => {
    const el = document.querySelector([flyinVueEl, id].join(''));
    if (el) {
        el.parentNode.removeChild(el);
    }
};

const flyinApp = {
    init: () => {
        initTriggers();
        initEventBus();
    }
};

module.exports = flyinApp;

},{"./flyin/flyin.vue":367,"vue":262}],367:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'flyin',

    props: {
        config: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    methods: {
        shouldOpen() {
            this.showBackdrop = true;
            this.cssClasses.push('open');

            setTimeout(() => {
                this.setFocus();
                window.eventBus.$emit('flyinOpened', this.config);
            }, 500);
        },

        shouldClose() {
            if (!this.disableInterface) {
                this.showBackdrop = false;
                this.cssClasses = this.cssClasses.filter((item) => { return item !== 'open'; });

                setTimeout(() => {
                    window.eventBus.$emit('flyinClosed', this.config.id);
                }, 500);
            }
        },

        setFocus() {
            this.$refs.flyinDialog.focus();
        }
    },

    computed: {
        resources() {
            return {
                'close': window.Resources.CLOSE
            };
        },

        content() {
            return this.config.content;
        },

        properties() {
            return this.config.props;
        }
    },

    mounted() {
        setTimeout(() => {
            this.shouldOpen();
        }, 20);

        window.eventBus.$on('shouldCloseFlyin', () => {
            this.shouldClose();
        });

        window.eventBus.$on('processingPayment', (ready) => {
            this.showSpinner = true;
            this.disableInterface = !ready;
        });
    },

    data() {
        return {
            cssClasses: ['generic-dialog-flyout'],
            showBackdrop: false,
            disableInterface: false,
            showSpinner: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.config.className,attrs:{"id":'flyin' + (_vm.config.id || '')}},[_c('div',{ref:"flyinDialog",class:_vm.cssClasses},[_c('span',{staticClass:"sr-only flyout-sr-only",attrs:{"tabindex":"0","aria-hidden":"true"}}),_vm._v(" "),_c('button',{directives:[{name:"show",rawName:"v-show",value:(!_vm.disableInterface),expression:"!disableInterface"}],ref:"flyinCloseButton",staticClass:"side--close icon-close",attrs:{"type":"button","tabindex":"0"},on:{"click":_vm.shouldClose}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.resources.close))])]),_vm._v(" "),_c('section',{staticClass:"generic-flyout-content flyin-component"},[_c('div',{class:['spinner', 'black-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),_c(_vm.content,_vm._b({tag:"component",on:{"close":_vm.shouldClose}},'component',_vm.properties,false))],1)]),_vm._v(" "),_c('transition',{attrs:{"name":"backdrop-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showBackdrop),expression:"showBackdrop"}],staticClass:"modal-overlay flyin-component",on:{"click":_vm.shouldClose}})])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6173a5ec", __vue__options__)
  } else {
    hotAPI.reload("data-v-6173a5ec", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],368:[function(require,module,exports){
'use strict';

const Vue = require('vue');
const Modal = require('./modal/modal.vue');

const modalAppEl = '#app-modal';
const modalVueEl = '#modal';

let modalObject; /* eslint-disable-line */

const initEventBus = () => {
    // Setup eventbus to allow modal to pass back data
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('shouldOpenModal', (data) => {
        prepareMarkup();
        createModal(data);
    });

    window.eventBus.$on('modalClosed', (data) => {
        destroyModal(data.modalCustomId);
    });
};

/**
 * Prepares the markup for the modal to be attached to
 */
const prepareMarkup = () => {
    const template = `
        <div id="app-modal">
        </div>
    `;

    $('body').append(template);
};

/**
 * Creates the Modal App
 */
const createModal = (data) => {
    modalObject = new Vue({
        el: modalAppEl,
        store: data.store,
        components: {
            Modal
        },
        computed: {
            config() {
                return data;
            }
        },
        data() {
            return {
                shouldShowModal: true
            };
        },
        template: `<modal :config = "config"></modal>`,
    });
};

/**
 * Removes the Modal App from the DOM
 */
const destroyModal = () => {
    $(modalVueEl).remove();
};

const modalApp = {
    init: () => {
        initEventBus();
    }
};

module.exports = modalApp;

},{"./modal/modal.vue":369,"vue":262}],369:[function(require,module,exports){
;(function(){
'use strict';

const isMobileDevice = require('../../../modules/helpers/isMobileDevice');
const scrollHelper = require('../../../modules/helpers/scroll');
const validator = require('../../../validator');

module.exports = {
    name: 'modal',

    props: {
        config: Object
    },

    methods: {
        /**
         * Handles the close button click
         */
        handleCloseModal(config) {
            if (config.closeElement && !config.closeElement.shouldCloseModal) {
                this.onElementClick(config.closeElement.eventName, config.closeElement.data);
                return;
            }

            if (config.closeElement && config.closeElement.eventName) {
                this.onElementClick(config.closeElement.eventName, config.closeElement.data);
                this.closeModal();
                return;
            }

            this.closeModal();
        },

        closeModal() {
            this.isModalVisible = false;
        },

        onElementClick(eventName, data) {
            window.eventBus.$emit(eventName, data);
        },

        validatePersonalizedName(value) {
            if (!value || !value.replace(/\s/g, '')) {
                this.msg['personalizedName'] = '';
                this.invalid = true;
                return;
            }
            if (validator.validatePersonalizedName(value)) {
                this.msg['personalizedName'] = '';
                this.invalid = false;
                return;
            }
            this.msg['personalizedName'] = this.config.resources.error;
            this.invalid = true;
        }
    },

    watch: {
        /**
         * Handles the value changes of isModalVisible
         * @param {Boolean} newVal The new value
         */
        isModalVisible(newVal) {
            if (newVal === true) {
                window.eventBus.$emit('modalOpen');
                scrollHelper.disableScroll();

                // TODO: Add this to the flyout.js script and hook into the
                // 'modalOpen' event from there using the VUE eventBus.
                if ($('.js-flyout-container').hasClass('open')) {
                    $('.generic-modal-container').addClass('flyout-open');
                }
            } else {
                scrollHelper.enableScroll();

                setTimeout(() => {
                    window.eventBus.$emit('modalClosed', {modalCustomId: this.config.modalCustomId});
                }, 800);
            }

            setTimeout(() => {
                if (newVal === true && this.isMobile && this.config.shouldModalCloseOnMobile) {
                    this.isModalVisible = false;
                }
            }, 3000);
        },

        personalizedName(value) {
            this.personalizedName = value;
            this.validatePersonalizedName(value);
        }
    },

    computed: {
        content() {
            return this.config.content;
        },
        properties() {
            return this.config.props;
        },
        modalResources() {
            return {
                closeModal: window.Resources.CLOSE_MODAL || 'Close'
            };
        },

        isDisabled: function () {
            return this.invalid;
        },

        enableDraglist() {
            return (this.config.hasOwnProperty('enableDraglist')) ? this.config.enableDraglist : true; /* eslint-disable-line no-prototype-builtins */
        },

        modalCustomId() {
            return 'modal' + (this.config.modalCustomId || '');
        }
    },

    mounted() {
        this.isModalVisible = true;

        if (this.config.mountedEvent) {
            window.eventBus.$emit(this.config.mountedEvent);
        }

        window.eventBus.$on('shouldCloseModal', () => {
            this.handleCloseModal(this.config);
        });
    },

    data() {
        return {
            isMobile: isMobileDevice(),
            isModalVisible: false,
            personalizedName: '',
            msg: [],
            invalid: true
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal",attrs:{"id":_vm.modalCustomId}},[_c('transition',{attrs:{"name":"generic-modal-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],staticClass:"generic-modal-container",class:[{
                'modal-large': _vm.config.modalLarge,
                'centered-on-mobile': _vm.config.centerOnMobile,
                'modal-full-width': _vm.config.modalFullWidth,
                'talisman-certificate': _vm.config.certificateEdit,
                'easter-modal': _vm.config.easterModal,
                'generic-modal-container-small': _vm.config.modalSmall,
                'qr-modal' : _vm.config.qrModal
            },
            _vm.config.customClass]},[_c('div',{staticClass:"content-wrapper"},[(!_vm.config.hideCloseButton)?_c('button',{staticClass:"close-modal icon-close modal-close-icon",on:{"click":function () { return _vm.handleCloseModal(_vm.config); }}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.modalResources.closeModal))])]):_vm._e(),_vm._v(" "),(_vm.content)?_c(_vm.content,_vm._b({tag:"component"},'component',_vm.properties,false)):_c('div',[(_vm.config.productImage && _vm.config.productImage.src)?_c('div',{staticClass:"image-holder"},[_c('img',{class:_vm.config.productImage.class,attrs:{"data-src":_vm.config.productImage.src,"alt":_vm.config.productImage.alt,"src":_vm.config.productImage.placeholder}})]):_vm._e(),_vm._v(" "),(_vm.config.icon)?_c('span',{class:_vm.config.icon}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-holder"},[(_vm.config.resources && _vm.config.resources.heading)?_c('h2',{staticClass:"heading-h4",class:{
                                'heading-large': _vm.config.resources && _vm.config.resources.headingLarge,
                                'heading-small': _vm.config.resources && _vm.config.resources.headingSmall,
                                'heading-large-narrow': _vm.config.resources && _vm.config.resources.headingNarrow
                            },domProps:{"innerHTML":_vm._s(_vm.config.resources.heading)}}):_vm._e(),_vm._v(" "),_vm._l((_vm.config.paragraphs),function(paragraph){return [(paragraph && paragraph.text && !_vm.config.certificateEdit)?_c('p',{class:{
                                'text-large': paragraph.textLarge,
                                'text-color-black': paragraph.textColorBlack,
                                'text-width-limiter': paragraph.textWidthLimiter
                                },domProps:{"innerHTML":_vm._s(paragraph.text)}}):_vm._e()]})],2),_vm._v(" "),(_vm.config.easterModal)?_c('div',[_c('img',{staticClass:"qr-code-easter",attrs:{"src":_vm.config.QRcodeURL,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"qr-code-phara",domProps:{"innerHTML":_vm._s(_vm.config.resources.description)}})]):_vm._e(),_vm._v(" "),(_vm.config.qrModal)?_c('div',[_c('img',{staticClass:"js-qrCode qr-code",attrs:{"src":_vm.config.QRcodeURL,"alt":""}}),_vm._v(" "),_c('p',{staticClass:"js-qr-description qr-code-phara",domProps:{"innerHTML":_vm._s(_vm.config.description)}})]):_vm._e(),_vm._v(" "),(_vm.config.certificateEdit)?_c('div',{staticClass:"talisman-certificate-content",attrs:{"id":"talisman-certificate-content"}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.config.resources.description)}}),_vm._v(" "),_c('label',{attrs:{"for":"personalizedName"}},[_vm._v(_vm._s(_vm.config.resources.name))]),_vm._v(" "),(_vm.msg.personalizedName)?_c('span',{staticClass:"error"},[_vm._v(_vm._s(_vm.msg.personalizedName))]):_vm._e(),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.personalizedName),expression:"personalizedName"}],attrs:{"id":"personalizedName","type":"text","maxlength":"12","placeholder":_vm.config.resources.placeholder},domProps:{"value":(_vm.personalizedName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.personalizedName=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"disclaimer",domProps:{"innerHTML":_vm._s(_vm.config.resources.note)}})]):_vm._e(),_vm._v(" "),(_vm.config.productTiles)?_c('div',{staticClass:"bonus-product-list-slider drag-list",attrs:{"id":"bonus-product-list","data-line-item-detail":_vm.config.configuration && _vm.config.configuration.lidata}},[_c('div',{class:['drag-list-scroll', {'js-drag-list js-drag-list-center': _vm.enableDraglist}],attrs:{"data-list-config":"{\"itemsToShow\":\"1.5\",\"hideArrows\":true, \"hideBar\":true, \"isMobileOnly\": true}"}},[_vm._l((_vm.config.productTiles),function(productTile){return [_c('div',{class:['bonus-product-list-slider-item', {'js-drag-list-item': _vm.enableDraglist}],attrs:{"id":productTile.id,"data-producttype":productTile.productType}},[_c('label',{attrs:{"id":productTile.popupProductID}},[_c('input',{staticClass:"gwp-radio--hidden js-bonus-product-selection",attrs:{"type":"radio","name":"popup-bonus-product-select","data-pid":productTile.productID,"data-productuuid":productTile.productUUID,"data-bonusdiscountlineitemuuid":productTile.bonusDiscountLineItemUUID,"data-bonusproductid":productTile.bonusProductID},domProps:{"checked":productTile.bonusProductID == productTile.productID}}),_vm._v(" "),(productTile && productTile.productName)?_c('span',{staticClass:"product-name",domProps:{"innerHTML":_vm._s(productTile.productName)}}):_vm._e(),_vm._v(" "),(productTile && productTile.productImageUrl)?_c('div',{staticClass:"product-image"},[_c('img',{class:productTile.productImageClass,attrs:{"data-src":productTile.productImageUrl,"alt":productTile.productImageAlt,"title":productTile.productImageTitle,"src":productTile.productImagePlaceholder}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"select-box-wrapper"},[_c('span',{staticClass:"gwp-select-box",attrs:{"aria-labelledby":productTile.popupProductID,"tabindex":"0","role":"radio","aria-checked":productTile.bonusProductID == productTile.productID}})])])])]})],2)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"cta-holder",class:{
                            'cta-holder-row': _vm.config.ctaHolderRow,
                            'hide-on-mobile-and-tablet': _vm.config.ctaHolder.hideOnMobileAndTablet
                        }},[_vm._l((_vm.config.buttons),function(button){return [(button && button.label)?_c('div',{staticClass:"row row-custom-width",class:_vm.config.row && _vm.config.row.rowWidth},[(button && button.prependedBlock)?_c('div',{staticClass:"flag-wrapper",domProps:{"innerHTML":_vm._s(button.prependedBlock)}}):_vm._e(),_vm._v(" "),_c('button',{class:button.type,attrs:{"type":"button","disabled":_vm.isDisabled && button.shouldBeValid},domProps:{"innerHTML":_vm._s(button.label)},on:{"click":function($event){button.shouldCloseModal
                                        ? (button.eventName ? !_vm.onElementClick(button.eventName, button.data) && _vm.closeModal() : _vm.closeModal())
                                        : _vm.onElementClick(button.eventName, button.data)}}})]):_vm._e()]})],2),_vm._v(" "),(_vm.config.configuration && _vm.config.configuration.verificationMessage)?_c('p',{staticClass:"verification-message",domProps:{"innerHTML":_vm._s(_vm.config.configuration.verificationMessage)}}):_vm._e(),_vm._v(" "),(_vm.config.configuration && _vm.config.configuration.fixedTierStep)?_c('input',{staticClass:"js-gwp-tier-step",attrs:{"type":"hidden"},domProps:{"value":_vm.config.configuration.fixedTierStep}}):_vm._e()])],1)])]),_vm._v(" "),_c('transition',{attrs:{"name":"generic-modal-overlay-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModalVisible),expression:"isModalVisible"}],staticClass:"generic-modal-overlay",on:{"click":function () { return _vm.handleCloseModal(_vm.config); }}})])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-61ea0eaa", __vue__options__)
  } else {
    hotAPI.reload("data-v-61ea0eaa", __vue__options__)
  }
})()}

},{"../../../modules/helpers/isMobileDevice":466,"../../../modules/helpers/scroll":475,"../../../validator":607,"vue":262,"vue-hot-reload-api":257}],370:[function(require,module,exports){
'use strict';

const gtm = require('../../modules/google').tagManager;

module.exports = {
    computed: {
        customerSelectedContainer() {
            return this.$store.getters.customerSelectedContainer;
        },
        customerSelectedFiller() {
            return this.$store.getters.customerSelectedFiller;
        },
        productCollection() {
            return this.$store.getters.productData.collection;
        },
        productSelection() {
            return [this.customerSelectedContainer, this.customerSelectedFiller]
                .filter(Boolean)
                .map((part) => part.name)
                .join('/');
        }
    },
    methods: {
        handleStepInteraction(stepCtaName) {
            if (!stepCtaName) {
                return;
            }

            /* eslint-disable camelcase */
            const event = {
                event: 'configurator',
                sublevel_1: 'in-page',
                sublevel_2: this.productCollection,
                click_target: stepCtaName
            };
            /* eslint-enable camelcase */
            if (this.customerSelectedFiller) {
                event['content_group'] = this.customerSelectedFiller.categoryName;
            }
            if (this.productSelection) {
                event.selection = this.productSelection;
            }

            gtm.pushDataLayerEvent(event);
        }
    }
};

},{"../../modules/google":453}],371:[function(require,module,exports){
;(function(){
'use strict';

const Overlay = require('../overlay/overlay.vue');
const SliderControls = require('../slider-controls/slider-controls.vue');
const debounce = require('../../../modules/helpers/debounce');
const Analytics = require('../analytics.js');

module.exports = {
    name: 'fragrance-slider',

    mixins: [Analytics],

    components: {
        Overlay,
        SliderControls
    },

    props: {
        desktopMode: Boolean
    },

    methods: {
        /**
         * Tell parent to proceed to next screen
         */
        nextScreen() {
            this.$emit('clickContinuFragranceSlider');
            this.$store.commit('setUserConfiguration', ['filler', this.selectedPart]);
            this.handleStepInteraction('done');
            window.eventBus.$emit('configuratorChanged', this.userConfiguration);
        },

        /**
         * Tell parent to return to previous screen
         */
        previousScreen() {
            this.$emit('clickReturnSelectedProduct');
        },

        /**
         * Opens the overlay
         * @param {Number} categoryIdx Array index of category
         * @param {Number} optionIdx Array index of option in selected category
         */
        openOverlay(categoryIdx, optionIdx) {
            const option = this.part.categories[categoryIdx].options[optionIdx];

            this.overlayHeading = option.name;
            this.overlayBody = option.description.split('||');
            this.showOverlay = true;
        },

        /**
         * Closes the overlay
         */
        closeOverlay() {
            this.showOverlay = false;
        },

        /**
         * Updates the selected part when the part option is available.
         * @param {Number} catIdx Array index of category
         * @param {Number} optIdx Array index of option
         */
        selectPart(catIdx, optIdx) {
            const option = this.part.categories[catIdx].options[optIdx];

            if (option.available) {
                this.$store.commit('setUserConfiguration', ['filler', option.id]);
            }

            this.$emit('selectFragrance', option.name);
            this.selectedPart = option.id;
            this.partAvailable = option.available;
        },

        /**
         * Scrolls the correct list into view
         * @param {Number} idx Id of list to scroll to
         */
        selectCategory(idx) {
            const optionsRect = document.querySelectorAll('.fragrance-options')[idx].getBoundingClientRect();
            const scrollElement = document.querySelector('.fragrances-scroll-body');

            this.scrollTo(optionsRect.left - scrollElement.getBoundingClientRect().left);
            this.selectedCategory = idx;
            this.muteObserver = true;

            setTimeout(() => {
                this.muteObserver = false;
            }, 400);
        },

        /**
         * Returns the category index of a given part and stores the option index
         * @param {Number} id Part id to look up.
         */
        selectCategoryOfPart(id) {
            let catIdx = 0;
            let found = false;

            for (const [cidx, category] of this.part.categories.entries()) {
                for (const [oidx, option] of category.options.entries()) {
                    if (option.id === id) {
                        this.selectedPartIdx = oidx;
                        catIdx = cidx;
                        found = true;
                        break;
                    }
                }

                if (found) {
                    break;
                }
            }

            return catIdx;
        },

        /**
         * Handles the actual scrolling of the list
         * @param {Number} x New horizontal scroll position
         */
        scrollTo(x) {
            const scrollElement = document.querySelector('.fragrances-scroll-body');
            scrollElement.scrollLeft += x;
        },

        /**
         * Handles the arrow visibility based on scroll position
         * @param {Event} e ScrollEvent object
         */
        onFragranceScroll(e) {
            const {scrollWidth, scrollLeft, offsetWidth} = e.target;
            this.showRightArrow = scrollLeft + offsetWidth < scrollWidth;
            this.showLeftArrow = scrollLeft > 0;
        },

        /**
         * Scrolls the list by clicking on the directional arrows. If
         * scrollByCategory is set to true, we automatically scroll to the
         * first item of the next category. If it is set to false we scroll a
         * number of tiles set by 'itemsToScroll'
         * @param {String} dir Direction of scroll. Can either be 'left' or 'right'
         */
        onClickArrow(dir) {
            if (this.scrollByCategory) {
                const catNum = this.part.categories.length - 1;
                const catPrev = (this.selectCategory === 0) ? catNum : this.selectedCategory - 1;
                const catNext = (this.selectCategory === catNum) ? 0 : this.selectedCategory + 1;
                this.selectCategory((dir === 'left') ? catPrev : catNext);
            } else {
                const itemRect = document.querySelector('.options li').getBoundingClientRect();
                const itemStyle = window.getComputedStyle(document.querySelector('.options li'));
                const itemHorizontalMargins = parseInt(itemStyle.marginLeft) + parseInt(itemStyle.marginRight);
                const scrollDelta = this.itemsToScroll * (itemRect.width + itemHorizontalMargins);
                this.scrollTo((dir === 'left') ? -1 * scrollDelta : scrollDelta);
            }
        },

        /**
         * Adds and inits the Intersection Observer that selects the correct
         * category while scrolling
         */
        initObserver() {
            const observer = new IntersectionObserver((lists) => {
                for (const list of lists) {
                    const isIntersecting = ('ontouchstart' in window) ? list.isIntersecting : list.intersectionRatio === 1;
                    if (isIntersecting && this.muteObserver === false) {
                        const el = list.target;
                        this.selectedCategory = [...el.parentElement.children].indexOf(el);
                        break;
                    }
                }
            }, {
                threshold: [0.25, 0.5, 0.75, 1]
            });

            document.querySelectorAll('.fragrance-options').forEach((el) => {
                observer.observe(el);
            });
        },
    },

    computed: {
        indicatorLeft() {
            const parent = document.querySelector('.fragrance-categories');
            const category = document.querySelectorAll('.fragrance-categories li')[this.selectedCategory];
            const offset = parent ? parent.offsetLeft : 0;
            return category ? category.getBoundingClientRect().left - parent.getBoundingClientRect().x + offset : offset;
        },

        indicatorWidth() {
            const category = document.querySelectorAll('.fragrance-categories li')[this.selectedCategory];
            return category ? category.getBoundingClientRect().width : 100;
        },

        userConfiguration() {
            return this.$store.getters.userConfiguration;
        },

        resources() {
            return this.$store.getters.resources;
        },

        part() {
            return this.$store.getters.fillerPart();
        }
    },

    mounted() {
        this.selectedPart = this.userConfiguration['filler'] || this.part.selected;
        this.selectedCategory = this.selectCategoryOfPart(this.selectedPart);
        this.partAvailable = this.part.categories[this.selectedCategory].options[this.selectedPartIdx].available;

        setTimeout(() => {
            this.skipIndicatorAnimation = false;
        }, 300);

        if ('IntersectionObserver' in window) {
            this.initObserver();
        }

        if (this.desktopMode) {
            document.querySelector('.fragrances-scroll-body').addEventListener('scroll', debounce(this.onFragranceScroll, 10));
        }
    },

    data() {
        return {
            itemsToScroll: 3,
            muteObserver: false,
            overlayBody: [],
            overlayHeading: '',
            partAvailable: false,
            scrollByCategory: true,
            selectedCategory: null,
            selectedPart: null,
            selectedPartIdx: null,
            showLeftArrow: false,
            showOverlay: false,
            showRightArrow: true,
            skipIndicatorAnimation: true
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fragrance-slider"},[_c('overlay',{directives:[{name:"show",rawName:"v-show",value:(_vm.showOverlay),expression:"showOverlay"}],on:{"onClickClose":function($event){return _vm.closeOverlay()}}},[_c('h1',[_vm._v(_vm._s(_vm.overlayHeading))]),_vm._v(" "),_vm._l((_vm.overlayBody),function(paragraph){return _c('p',[_vm._v(_vm._s(paragraph))])})],2),_vm._v(" "),_c('div',{staticClass:"fragrance-header"},[_c('span',{class:['icon',  _vm.part.icon]}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.resources.screens.fragrance.heading))])]),_vm._v(" "),_c('ul',{staticClass:"fragrance-categories"},_vm._l((_vm.part.categories),function(category,idx){return _c('li',{class:{'selected': _vm.selectedCategory === idx}},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.selectCategory(idx)}}},[_c('span',{staticClass:"category-name"},[_vm._v(_vm._s(category.name))])])])}),0),_vm._v(" "),_c('div',{class:['category-indicator', {'skip-animation': _vm.skipIndicatorAnimation}],style:('left: ' + _vm.indicatorLeft + 'px; width: ' + _vm.indicatorWidth + 'px;')}),_vm._v(" "),_c('div',{class:['category-fragrances', {'gradient-left': !_vm.showRightArrow}, {'gradient-right': _vm.showRightArrow}]},[_c('div',{staticClass:"fragrances-scroll-body"},_vm._l((_vm.part.categories),function(category,catIdx){return _c('div',{staticClass:"fragrance-options"},[_c('h4',{staticClass:"category-name"},[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('ul',{staticClass:"options"},_vm._l((category.options),function(option,optIdx){return _c('li',{class:{'selected': _vm.selectedPart === option.id},on:{"click":function($event){return _vm.selectPart(catIdx, optIdx)}}},[_c('a',{attrs:{"href":"javascript:void(0)"}},[(!option.available)?_c('span',{staticClass:"error-message"},[_c('span',{staticClass:"error-badge"}),_vm._v("\n                                "+_vm._s(_vm.resources.global.notInStockShort)+"\n                            ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"icon icon-seal"}),_vm._v(" "),_c('span',{staticClass:"option-name"},[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('span',{staticClass:"option-excerpt"},[_vm._v(_vm._s(option.excerpt))]),_vm._v(" "),_c('span',{staticClass:"option-more",on:{"click":function($event){return _vm.openOverlay(catIdx, optIdx)}}},[_vm._v(_vm._s(_vm.resources.global.readMore))])])])}),0)])}),0)]),_vm._v(" "),_c('slider-controls',{attrs:{"showLeftArrow":_vm.showLeftArrow,"showRightArrow":_vm.showRightArrow},on:{"clickArrowLeft":function($event){return _vm.onClickArrow('left')},"clickArrowRight":function($event){return _vm.onClickArrow('right')}}}),_vm._v(" "),_c('div',{staticClass:"fragrance-footer"},[(!_vm.desktopMode)?_c('button',{staticClass:"btn btn-customize btn--secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.previousScreen()}}},[_c('span',{staticClass:"icon icon-arrow3--left"}),_vm._v(" "),_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.resources.screens.fragrance.buttonChangeProduct))])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-customize",attrs:{"type":"button","disabled":!_vm.partAvailable},on:{"click":function($event){return _vm.nextScreen()}}},[_vm._v("\n            "+_vm._s(_vm.resources.screens.fragrance.buttonDone)+"\n        ")])])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0e62bf95", __vue__options__)
  } else {
    hotAPI.reload("data-v-0e62bf95", __vue__options__)
  }
})()}

},{"../../../modules/helpers/debounce":458,"../analytics.js":370,"../overlay/overlay.vue":372,"../slider-controls/slider-controls.vue":382,"vue":262,"vue-hot-reload-api":257}],372:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'overlay',

    methods: {
        /**
         * Handles click event on close button
         */
        onClickClose() {
            this.$emit('onClickClose');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"overlay-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShow),expression:"shouldShow"}],staticClass:"overlay"},[_c('div',{staticClass:"overlay-slot"},[_c('div',{staticClass:"overlay-body"},[_vm._t("default")],2)]),_vm._v(" "),_c('button',{staticClass:"overlay-close",on:{"click":_vm.onClickClose}},[_c('span',{staticClass:"icon icon-close-thick"})])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fe9cd0d2", __vue__options__)
  } else {
    hotAPI.reload("data-v-fe9cd0d2", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],373:[function(require,module,exports){
'use strict';

const Vue = require('vue');
const VueX = require('vuex');
const VueXStore = require('./product-configurator-inline-store');

const isProduction = "development" === 'production';
const configuratorAppEl = '.js-product-configurator-inline';
const configuratorVueEl = '.product-configurator-inline';

/**
 * Initialise the global Vue properties.
 */
const initVue = () => {
    Vue.use(VueX);
};

/**
 * Setup eventbus to allow configurator comminication with configurator
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('configuratorChanged', (data) => {
        if (!isProduction) {
            console.debug('Configurator Changed Event', data);
        }
    });
};

/**
 * Initializes the Intersection Observer
 */
const initObserver = () => {
    const observer = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            const currentY = block.boundingClientRect.y;
            const previousY = parseInt(block.target.dataset.previousY) || 0;
            let ratioPass = parseInt(block.target.dataset.ratioPass) || 1;

            if (currentY < previousY) {
                // In view from bottom
                if (ratioPass === 1) {
                    block.target.__vue__.$root.inView = true;
                }
            } else {
                // In view from top
                if (ratioPass === 2) {
                    block.target.__vue__.$root.inView = false;
                }
            }

            // To prevent tick set on page load
            if (block.intersectionRatio > 0.2) {
                ratioPass = (ratioPass === 2) ? 1 : 2;
            }

            block.target.setAttribute('data-previous-y', currentY);
            block.target.setAttribute('data-ratio-pass', ratioPass);
        }
    }, {
        threshold: [0.6]
    });

    document.querySelectorAll(configuratorVueEl).forEach(el => {
        observer.observe(el);
    });
};

/**
 * Creates the Product Configurator App
 */
const createConfigurator = (appEl) => {
    const ProductConfiguratorInline = require('./product-configurator-inline/product-configurator-inline.vue');
    const store = VueXStore.init(VueX);
    const configuration = JSON.parse(appEl.dataset.configuration);

    return new Vue({
        el: appEl,
        store,

        components: {
            ProductConfiguratorInline
        },

        props: {
            inView: Boolean
        },

        computed: {
            placeholderId() {
                return configuration.placeholderId.toString();
            },

            collectionId() {
                return configuration.collectionId;
            }
        },

        template: `
            <product-configurator-inline
                :inView="inView"
                :placeholderId="placeholderId"
                :collectionId="collectionId">
            </product-configurator-inline>
        `
    });
};

/**
 * Attaches a configurator app to all placeholders
 */
const prepareConfigurators = () => {
    document.querySelectorAll(configuratorAppEl).forEach(app => {
        createConfigurator(app);
    });
};

/**
 * Tests if the product configurator should init
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return document.querySelectorAll(configuratorAppEl).length > 0;
};

const productConfiguratorInlineApp = {
    init: () => {
        if (shouldInit()) {
            initVue();
            initEventBus();
            prepareConfigurators();
            initObserver();
        }
    }
};

module.exports = productConfiguratorInlineApp;

},{"./product-configurator-inline-store":374,"./product-configurator-inline/product-configurator-inline.vue":375,"vue":262,"vuex":264}],374:[function(require,module,exports){
'use strict';

const Vue = require('vue');

const productConfiguratorInlineStore = {

    init: (VueX) => {
        const state = {
            parts: {},
            resources: {},
            productData: {},
            userConfiguration: {}
        };

        const getters = {
            parts: state => state.parts,
            resources: state => state.resources,
            productData: state => state.productData,
            userConfiguration: state => state.userConfiguration,
            partById: state => (id) => {
                return state.parts.find(part => part.id === id);
            },
            containerPart: state => () => { //bottle or candleholder
                return state.parts.find((part) => 'options' in part);
            },
            fillerPart: state => () => { //fragrance or wax
                return state.parts.find((part) => !('options' in part));
            },
            customerSelectedContainer: (state, getters) => {
                const containerPart = getters.containerPart();
                const selectedContainerId = state.userConfiguration.container;
                if (!selectedContainerId || !containerPart) {
                    return null;
                }
                return containerPart.options.find((container) => container.id === selectedContainerId);
            },
            customerSelectedFiller: (state, getters) => {
                const fillerPart = getters.fillerPart();
                const selectedFillerId = state.userConfiguration.filler;
                if (!selectedFillerId || !fillerPart) {
                    return null;
                }
                for (const category of Object.values(fillerPart.categories)) {
                    for (const option of Object.values(category.options)) {
                        if (option.id === selectedFillerId) {
                            return {
                                categoryName: category.name,
                                ...option
                            };
                        }
                    }
                }
            }
        };

        const mutations = {
            setParts(state, newVal) {
                state.parts = newVal;
            },

            setResources(state, newVal) {
                state.resources = newVal;
            },

            setProductData(state, newVal) {
                state.productData = newVal;
            },

            setUserConfiguration(state, newVal) {
                Vue.set(state.userConfiguration, newVal[0], newVal[1]);
            }
        };

        return new VueX.Store({
            state: state,
            getters: getters,
            mutations: mutations
        });
    }
};

module.exports = productConfiguratorInlineStore;

},{"vue":262}],375:[function(require,module,exports){
;(function(){
'use strict';

const ProductShowcase = require('../product-showcase/product-showcase.vue');
const ProductDescription = require('../product-description/product-description.vue');
const ProductSlider = require('../product-slider/product-slider.vue');
const SelectedProduct = require('../selected-product/selected-product.vue');
const FragranceSlider = require('../fragrance-slider/fragrance-slider.vue');
const ResultSlider = require('../result-slider/result-slider.vue');

const axios = require('axios');

module.exports = {
    name: 'product-configurator-inline',

    components: {
        ProductShowcase,
        ProductDescription,
        ProductSlider,
        SelectedProduct,
        FragranceSlider,
        ResultSlider
    },

    props: {
        inView: Boolean,
        placeholderId: String,
        collectionId: String
    },

    methods: {
        /**
         * Opens next screen
         */
        continuTo(screen) {
            this.showScreenIntro = screen === 'intro';
            this.showScreenSelection = screen === 'selection';
            this.showScreenFragrance = screen === 'fragrance';
            this.showScreenResult = screen === 'result';
        },

        /**
         * Opens previous screen
         */
        returnTo(screen) {
            this.revertTransition = true;

            setTimeout(() => {
                this.continuTo(screen);
            }, 50);

            setTimeout(() => {
                this.revertTransition = false;
            }, 1600);
        },

        /**
         * Sets correct device mode
         */
        onResize() {
            this.desktopMode = window.innerWidth > 1023;
            this.tabletMode = window.innerWidth > 767 && window.innerWidth < 1023;
            this.mobileMode = window.innerWidth < 767;
        },

        /**
         * Sets / updates the name of the selected part
         * @param {String} label Name of selected part
         */
        onPartSelection(part) {
            this.selectedPartName = part.name;
            this.selectedPartImage = part.image;
        },

        /**
         * Sets / updates tje name of the selected fragrance
         * @param {String} label Name of the selected fragrance
         */
        onFragranceSelection(label) {
            this.selectedFragranceName = label;
        },

        /**
         * Sets the initial part name
         */
        setInitialFragranceName() {
            const part = this.$store.getters.partById('fragrance') || this.$store.getters.partById('wax');

            for (const category of Object.values(part.categories)) {
                for (const option of Object.values(category.options)) {
                    if (option.id === part.selected) {
                        return option.name;
                    }
                }
            }
        }
    },

    computed: {
        queryParams() {
            return {
                placeholderId: this.placeholderId,
                collectionId: this.collectionId
            };
        }
    },

    created() {
        window.addEventListener('resize', this.onResize);
    },

    destroyed() {
        window.removeEventListener('resize', this.onResize);
    },

    mounted() {
        this.onResize();
        axios
            .get(this.dataUrl, {
                timeout: 10000,
                params: this.queryParams
            })
            .then(resp => {
                this.$store.commit('setResources', resp.data.resources);
                this.$store.commit('setParts', resp.data.parts);
                this.$store.commit('setProductData', resp.data.productData);
                this.selectedFragranceName = this.setInitialFragranceName();
            })
            .then(() => {
                this.dataReady = true;
            })
            .catch((error) => {
                console.debug(error);
            });
    },

    data() {
        return {
            dataReady: false,
            dataUrl: Urls.getInLineConfiguratorData,
            desktopMode: true,
            tabletMode: false,
            mobileMode: false,
            revertTransition: false,
            selectedFragranceName: '',
            selectedPartImage: '',
            selectedPartName: '',
            showScreenFragrance: false,
            showScreenIntro: true,
            showScreenResult: false,
            showScreenSelection: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-configurator-inline"},[_c('transition',{attrs:{"name":"screen-transition","mode":"out-in"}},[(_vm.showScreenIntro && _vm.dataReady)?_c('div',{key:"screenIntro",class:['screen', 'screen-intro', {'reverted': _vm.revertTransition}]},[_c('product-showcase',{attrs:{"inView":_vm.inView,"desktopMode":_vm.desktopMode}}),_vm._v(" "),_c('product-description',{on:{"clickContinueIntro":function($event){return _vm.continuTo('selection')}}})],1):_vm._e(),_vm._v(" "),(_vm.showScreenSelection)?_c('div',{key:"screenSelection",class:['screen', 'screen-selection', {'reverted': _vm.revertTransition}]},[_c('product-slider',{attrs:{"desktopMode":_vm.desktopMode},on:{"selectPart":_vm.onPartSelection,"clickContinuSelection":function($event){return _vm.continuTo('fragrance')}}})],1):_vm._e(),_vm._v(" "),(_vm.showScreenFragrance)?_c('div',{key:"screenFragrance",class:['screen', 'screen-fragrance', {'reverted': _vm.revertTransition}]},[_c('selected-product',{attrs:{"desktopMode":_vm.desktopMode,"partName":_vm.selectedPartName,"productImage":_vm.selectedPartImage,"fragranceName":_vm.selectedFragranceName},on:{"clickReturnSelectedProduct":function($event){return _vm.returnTo('selection')}}}),_vm._v(" "),_c('fragrance-slider',{attrs:{"desktopMode":_vm.desktopMode},on:{"selectFragrance":_vm.onFragranceSelection,"clickReturnSelectedProduct":function($event){return _vm.returnTo('selection')},"clickContinuFragranceSlider":function($event){return _vm.continuTo('result')}}})],1):_vm._e(),_vm._v(" "),(_vm.showScreenResult)?_c('div',{key:"screenResult",class:['screen', 'screen-result', {'reverted': _vm.revertTransition}]},[_c('result-slider',{attrs:{"mobileMode":_vm.mobileMode},on:{"clickReturnResultSlider":function($event){return _vm.returnTo('selection')}}}),_vm._v(" "),_c('product-description',{attrs:{"hideParagraph":_vm.mobileMode,"isResultScreen":true}})],1):_vm._e()])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-30992d9d", __vue__options__)
  } else {
    hotAPI.reload("data-v-30992d9d", __vue__options__)
  }
})()}

},{"../fragrance-slider/fragrance-slider.vue":371,"../product-description/product-description.vue":376,"../product-showcase/product-showcase.vue":378,"../product-slider/product-slider.vue":379,"../result-slider/result-slider.vue":380,"../selected-product/selected-product.vue":381,"axios":5,"vue":262,"vue-hot-reload-api":257}],376:[function(require,module,exports){
;(function(){
'use strict';

const axios = require('axios');
const addToCart = require('../../../pages/product/addToCart');
const Analytics = require('../analytics.js');

module.exports = {
    name: 'product-description',

    mixins: [Analytics],

    props: {
        isResultScreen: {
            type: Boolean,
            default: false
        },

        hideParagraph: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * Tell parent to proceed to next screen
         */
        nextScreen() {
            this.handleStepInteraction('customize');
            this.$emit('clickContinueIntro');
        },

        /**
         * Set the customised properties for the resultscreen
         */
        setCustomisedProps() {
            for (const option of Object.values(this.container.options)) {
                if (option.id === this.userConfiguration.container) {
                    $('.js-product-image-mobile').attr('data-src', option.image.src);
                    this.customizedUsp.push({
                        'icon': 'icon-ruler',
                        'label': option.productDimensions.dimensions
                    });
                }
            }

            for (const category of Object.values(this.filler.categories)) {
                for (const option of Object.values(category.options)) {
                    if (option.id === this.userConfiguration.filler) {
                        this.customizedHeading = option.title;
                        this.customizedUsp.push({
                            'icon': 'icon-size',
                            'label': option.productUnit
                        }, {
                            'icon': 'icon-duration',
                            'label': option.duration
                        });
                    }
                }
            }
        },

        redirectToPDP() {
            this.handleStepInteraction('details');
            const query = this.resources.screens.result.detailsURLQueryPrefix + '-'
                    + this.userConfiguration.filler + '-'
                    + this.userConfiguration.container;
            location.href =
                this.resources.screens.result.detailsURLBase + '?'
                + 'configurationId=' + query + '&'
                + 'showbacklink=true';
        },

        addToCart() {
            const url = window.Urls.addProduct.toString() || '';
            axios.post(
                url,
                {},
                {
                    params: {
                        pid: this.productData.masterProductId,
                        childPids: this.userConfiguration.filler + ',' + this.userConfiguration.container
                    }
                }
            ).then((result) => {
                addToCart.updateMiniCartOnAddProduct(result.data, false);
            });
        }
    },

    computed: {
        userConfiguration() {
            return this.$store.getters.userConfiguration;
        },

        productData() {
            return this.$store.getters.productData;
        },

        resources() {
            return this.$store.getters.resources;
        },

        container() {
            return this.$store.getters.containerPart();
        },

        filler() {
            return this.$store.getters.fillerPart();
        },

        usps() {
            return this.isResultScreen ? this.customizedUsp : this.resources.usps;
        }
    },

    mounted() {
        this.setCustomisedProps();
    },

    data() {
        return {
            customizedHeading: '',
            customizedBody: '',
            customizedUsp: []
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-description"},[_c('div',{staticClass:"product-info-column product-info-column-details"},[_c('div',{staticClass:"product-info-content"},[(_vm.isResultScreen)?_c('span',{staticClass:"result-label"},[_vm._v(_vm._s(_vm.resources.screens.result.heading))]):_vm._e(),_vm._v(" "),(_vm.isResultScreen)?_c('h3',[_vm._v(_vm._s(_vm.customizedHeading))]):_vm._e(),_vm._v(" "),(!_vm.isResultScreen)?_c('h3',[_vm._v(_vm._s(_vm.resources.screens.intro.heading))]):_vm._e(),_vm._v(" "),(!_vm.hideParagraph)?_c('p',[_vm._v(_vm._s(_vm.resources.screens.intro.body))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product-info-icons"},_vm._l((_vm.usps),function(usp){return _c('div',{staticClass:"item"},[_c('span',{staticClass:"product-info-icon"},[_c('span',{class:['icon', usp.icon]})]),_vm._v(" "),_c('span',{staticClass:"info-text"},[_vm._v("\n                        "+_vm._s(usp.label)+"\n                    ")])])}),0),_vm._v(" "),_c('div',{staticClass:"product-info-footer"},[_c('div',{staticClass:"product-price"},[_c('div',{staticClass:"prices-container"},[_c('span',{staticClass:"price-sales"},[_vm._v("\n                            "+_vm._s(_vm.productData.price.formattedSale)+"\n                        ")])])]),_vm._v(" "),(!_vm.isResultScreen)?_c('button',{staticClass:"btn btn-customize btn--secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextScreen()}}},[_c('span',[_vm._v(_vm._s(_vm.resources.screens.intro.button.label))]),_vm._v(" "),_c('span',{class:_vm.resources.screens.intro.button.icon})]):_vm._e(),_vm._v(" "),(_vm.isResultScreen)?_c('button',{staticClass:"btn",attrs:{"type":"submit"},on:{"click":function($event){return _vm.addToCart()}}},[_vm._v("\n                    "+_vm._s(_vm.resources.global.buttonAddToCart)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.isResultScreen)?_c('button',{staticClass:"btn btn--secondary",attrs:{"type":"submit"},on:{"click":function($event){return _vm.redirectToPDP()}}},[_vm._v("\n                    "+_vm._s(_vm.resources.global.buttonDetails)+"\n                ")]):_vm._e()])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-49b4d2b3", __vue__options__)
  } else {
    hotAPI.reload("data-v-49b4d2b3", __vue__options__)
  }
})()}

},{"../../../pages/product/addToCart":550,"../analytics.js":370,"axios":5,"vue":262,"vue-hot-reload-api":257}],377:[function(require,module,exports){
;(function(){
'use strict';

const damHelper = require('../../../dam/dam-helper');

module.exports = {
    name: 'product-image',

    props: {
        className: {
            type: String,
            default: ''
        },
        image: Object
    },

    methods: {
        onImgLoad() {
            this.isLoaded = true;
        }
    },

    mounted() {
        damHelper.updateImages(this.$refs.productImage);
    },

    data() {
        return {
            isLoaded: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"productImage",staticClass:"product-image",class:[_vm.className, {'loading': !_vm.isLoaded}]},[_c('img',{class:_vm.image.class,attrs:{"data-src":_vm.image.src,"alt":_vm.image.alt,"data-width":_vm.image.width},on:{"load":_vm.onImgLoad}})])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-09826b71", __vue__options__)
  } else {
    hotAPI.reload("data-v-09826b71", __vue__options__)
  }
})()}

},{"../../../dam/dam-helper":419,"vue":262,"vue-hot-reload-api":257}],378:[function(require,module,exports){
;(function(){
'use strict';

const ProductImage = require('../product-image/product-image.vue');

module.exports = {
    name: 'product-showcase',

    components: {
        ProductImage
    },

    props: {
        inView: Boolean,
        desktopMode: Boolean
    },

    methods: {
        /**
         * Shows one product when not configurator not in view.
         * Shows all products when configurator in view.
         * Shows all products whitout any animation when not on desktop.
         * @param {Number} index Index of product in list
         * @returns {Boolean}
         */
        showProductAtIndex(index) {
            return !this.desktopMode || this.inView || (index + 1) % 3 === 0;
        }
    },

    computed: {
        resources() {
            return this.$store.getters.resources;
        },

        images() {
            const imageType = this.desktopMode ? 'desktop' : 'mobile';
            return this.resources.screens.intro.images[imageType];
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-showcase"},[_c('transition-group',{attrs:{"name":"product-showcase-transition","tag":"figure"}},_vm._l((_vm.images),function(image,idx){return _c('product-image',{directives:[{name:"show",rawName:"v-show",value:(_vm.showProductAtIndex(idx)),expression:"showProductAtIndex(idx)"}],key:'image' + idx,attrs:{"image":image}})}),1)],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3e746515", __vue__options__)
  } else {
    hotAPI.reload("data-v-3e746515", __vue__options__)
  }
})()}

},{"../product-image/product-image.vue":377,"vue":262,"vue-hot-reload-api":257}],379:[function(require,module,exports){
;(function(){
'use strict';

const ProductImage = require('../product-image/product-image.vue');
const SliderControls = require('../slider-controls/slider-controls.vue');
const VueSlickCarousel = require('../../../../../node_modules/vue-slick-carousel');
const Analytics = require('../analytics.js');

module.exports = {
    name: 'product-slider',

    mixins: [Analytics],

    components: {
        ProductImage,
        SliderControls,
        VueSlickCarousel
    },

    props: {
        desktopMode: Boolean
    },

    methods: {
        /**
         * Handles click on left arrow
         */
        onClickArrowLeft() {
            this.$refs.carousel.prev();
        },

        /**
         * Handles click on right arrow
         */
        onClickArrowRight() {
            this.$refs.carousel.next();
        },

        /**
         * Handles window resize
         */
        onResizeWindow() {
            this.updateCenterPadding();
        },

        /**
         * Handles event that fires before slides are changed
         * @param {Number} oldIdx Index of old slide
         * @param {Number} newIdx Index of new slide
         */
        onBeforeChange(oldIdx, newIdx) {
            this.currentSlide = newIdx;
        },

        /**
         * Tell parent to proceed to next screen
         */
        nextScreen() {
            this.$store.commit('setUserConfiguration', ['container', this.part.options[this.currentSlide].id]);
            this.$emit('selectPart', {
                name: this.part.options[this.currentSlide].name,
                image: this.part.options[this.currentSlide].image
            });
            this.$emit('clickContinuSelection');
            this.handleStepInteraction('choose this container');
        },

        /**
         * Updates the center padding of the slick slider
         */
        updateCenterPadding() {
            const slidesToShow = this.desktopMode ? this.sliderSettings.slidesToShow : this.sliderSettings.responsive[0].settings.slidesToShow;
            const padding = (window.innerWidth > 1440 ? 1440 : window.innerWidth) / ((this.desktopMode ? 2 : 3) * (slidesToShow + 1));
            this.sliderSettings.centerPadding = padding + 'px';
        }
    },

    computed: {
        initialSlide() {
            const selected = this.userConfiguration['container'] || this.part.selected;
            let slide = 0;

            for (const [idx, option] of this.part.options.entries()) {
                if (option.id === selected) {
                    slide = idx;
                }
            }

            return slide;
        },

        userConfiguration() {
            return this.$store.getters.userConfiguration;
        },

        resources() {
            return this.$store.getters.resources;
        },

        part() {
            return this.$store.getters.containerPart();
        },

        partAvailable() {
            return this.part.options[this.currentSlide].available;
        },

        partName() {
            return this.part.options[this.currentSlide].name;
        }
    },

    created() {
        this.currentSlide = this.initialSlide;
        this.sliderSettings.initialSlide = this.initialSlide;
        window.addEventListener('resize', this.onResizeWindow);
    },

    destroyed() {
        window.removeEventListener('resize', this.onResizeWindow);
    },

    mounted() {
        this.updateCenterPadding();
    },

    data() {
        return {
            currentSlide: 0,
            showLeftArrow: true,
            showRightArrow: true,
            sliderSettings: {
                arrows: false,
                centerMode: true,
                centerPadding: '0',
                dots: false,
                focusOnSelect: true,
                infinite: true,
                initialSlide: 0,
                touchThreshold: 500,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        centerPadding: '25%',
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        centerPadding: '15%',
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }],
                slidesToShow: 3,
                swipe: false,
                waitForAnimate: false
            }
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-slider"},[_c('span',{class:['icon',  _vm.part.icon]}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.resources.screens.containerPicker.heading))]),_vm._v(" "),_c('div',{staticClass:"configurator-slider-body"},[_c('VueSlickCarousel',_vm._b({ref:"carousel",on:{"beforeChange":_vm.onBeforeChange}},'VueSlickCarousel',_vm.sliderSettings,false),_vm._l((_vm.part.options),function(option,idx){return _c('product-image',{attrs:{"className":(idx === _vm.currentSlide) ? 'selected' : '',"image":option.thumb}})}),1)],1),_vm._v(" "),_c('slider-controls',{attrs:{"showLeftArrow":_vm.showLeftArrow,"showRightArrow":_vm.showRightArrow},on:{"clickArrowLeft":function($event){return _vm.onClickArrowLeft()},"clickArrowRight":function($event){return _vm.onClickArrowRight()}}}),_vm._v(" "),_c('div',{staticClass:"configurator-slider-footer"},[_c('div',{staticClass:"part-details"},[_c('transition',{attrs:{"name":"error-message-transition"}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.partAvailable),expression:"!partAvailable"}],staticClass:"error-message"},[_c('span',{staticClass:"error-badge"}),_vm._v("\n                    "+_vm._s(_vm.resources.global.notInStockShort)+"\n                ")])]),_vm._v(" "),_c('span',{class:['part-name', {'not-available': !_vm.partAvailable}]},[_vm._v("\n                "+_vm._s(_vm.partName)+"\n            ")])],1),_vm._v(" "),_c('button',{staticClass:"btn btn-customize",attrs:{"type":"button","disabled":!_vm.partAvailable},on:{"click":function($event){return _vm.nextScreen()}}},[_vm._v("\n            "+_vm._s(_vm.resources.screens.containerPicker.chooseButtonLabel)+"\n        ")])])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-fea322d6", __vue__options__)
  } else {
    hotAPI.reload("data-v-fea322d6", __vue__options__)
  }
})()}

},{"../../../../../node_modules/vue-slick-carousel":260,"../analytics.js":370,"../product-image/product-image.vue":377,"../slider-controls/slider-controls.vue":382,"vue":262,"vue-hot-reload-api":257}],380:[function(require,module,exports){
;(function(){
'use strict';

const ProductImage = require('../product-image/product-image.vue');
const SliderControls = require('../slider-controls/slider-controls.vue');
const VueSlickCarousel = require('../../../../../node_modules/vue-slick-carousel');

module.exports = {
    name: 'result-slider',

    components: {
        ProductImage,
        SliderControls,
        VueSlickCarousel
    },

    props: {
        mobileMode: Boolean
    },

    methods: {
        /**
         * Handles click on left arrow
         */
        onClickArrowLeft() {
            this.$refs.resultCarousel.prev();
        },

        /**
         * Handles click on right arrow
         */
        onClickArrowRight() {
            this.$refs.resultCarousel.next();
        },

        /**
         * Handles event that fires before slides are changed
         * @param {Number} oldIdx Index of old slide
         * @param {Number} newIdx Index of new slide
         */
        onBeforeChange(oldIdx, newIdx) {
            this.currentSlide = newIdx;
        },

        /**
         * Tell parent to return to previous screen
         */
        previousScreen() {
            this.$emit('clickReturnResultSlider');
        },

        /**
         * Sets the left position of the slider indicator
         */
        setIndicatorLeft() {
            this.indicatorLeft = this.indicatorWidth * this.currentSlide;
        },

        /**
         * Sets the width of the slider indicator
         */
        setIndicatorWidth() {
            const activeDotEl = this.$refs.resultCarousel.$root.$el.querySelector('.slick-dots .slick-active');
            const activeDotRect = (activeDotEl) ? activeDotEl.getBoundingClientRect() : '';
            this.indicatorWidth = (activeDotEl) ? activeDotRect.width : 0;
        }
    },

    watch: {
        currentSlide() {
            this.setIndicatorLeft();
        }
    },

    computed: {
        userConfiguration() {
            return this.$store.getters.userConfiguration;
        },

        part() {
            return this.$store.getters.containerPart();
        },

        productOption() {
            for (const option of Object.values(this.part.options)) {
                if (option.id === this.userConfiguration.container) {
                    return option;
                }
            }
        },

        images() {
            const option = this.productOption;
            const images = [option.howToUseImage, option.productLifestyleImage];

            for (const image of Object.values(option.primaryAndSecondaryImages)) {
                images.push(image);
            }

            return images;
        }
    },

    mounted() {
        this.setIndicatorLeft();
        this.setIndicatorWidth();
        this.showLeftArrow = this.showRightArrow = this.images.length > 1;
    },

    data() {
        return {
            currentSlide: 0,
            indicatorLeft: 0,
            indicatorWidth: 0,
            showLeftArrow: true,
            showRightArrow: true,
            sliderSettings: {
                arrows: false,
                centerPadding: '0',
                dots: true,
                infinite: true,
                touchThreshold: 500,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        centerPadding: '20%',
                        focusOnSelect: true,
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                        centerPadding: '14%',
                        focusOnSelect: true,
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }],
                slidesToShow: 1,
                swipe: false,
                waitForAnimate: false
            }
        };
    }
};


})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-slider"},[_c('div',{staticClass:"configured-product"},[_c('VueSlickCarousel',_vm._b({ref:"resultCarousel",on:{"beforeChange":_vm.onBeforeChange}},'VueSlickCarousel',_vm.sliderSettings,false),_vm._l((_vm.images),function(image,idx){return _c('product-image',{attrs:{"className":(idx === _vm.currentSlide) ? 'selected' : '',"image":image}})}),1)],1),_vm._v(" "),_c('button',{staticClass:"icon-restart restart-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.previousScreen()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move back")])]),_vm._v(" "),_c('div',{staticClass:"configurator-slider-indicator"},[_c('span',{staticClass:"configurator-current-slide",style:('left: ' + _vm.indicatorLeft + 'px; width: ' + _vm.indicatorWidth + 'px')})]),_vm._v(" "),_c('slider-controls',{attrs:{"showLeftArrow":_vm.showLeftArrow,"showRightArrow":_vm.showRightArrow,"showArrowBackground":true},on:{"clickArrowLeft":function($event){return _vm.onClickArrowLeft()},"clickArrowRight":function($event){return _vm.onClickArrowRight()}}})],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-b9a520ce", __vue__options__)
  } else {
    hotAPI.reload("data-v-b9a520ce", __vue__options__)
  }
})()}

},{"../../../../../node_modules/vue-slick-carousel":260,"../product-image/product-image.vue":377,"../slider-controls/slider-controls.vue":382,"vue":262,"vue-hot-reload-api":257}],381:[function(require,module,exports){
;(function(){
'use strict';

const ProductImage = require('../product-image/product-image.vue');

module.exports = {
    name: 'selected-product',

    components: {
        ProductImage
    },

    props: {
        desktopMode: Boolean,
        fragranceName: String,
        partName: String,
        productImage: Object
    },

    methods: {
        /**
         * Tell parent to return to previous screen
         */
        previousScreen() {
            this.$emit('clickReturnSelectedProduct');
        }
    },

    computed: {
        userConfiguration() {
            return this.$store.getters.userConfiguration;
        },

        resources() {
            return this.$store.getters.resources;
        },

        assembledPartName() {
            return this.partName + ' - ' + this.fragranceName;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"selected-product"},[_c('product-image',{attrs:{"image":_vm.productImage}}),_vm._v(" "),_c('span',{staticClass:"part-name"},[_vm._v("\n        "+_vm._s(_vm.assembledPartName)+"\n    ")]),_vm._v(" "),(_vm.desktopMode)?_c('button',{staticClass:"btn btn-customize btn--secondary",attrs:{"type":"button"},on:{"click":function($event){return _vm.previousScreen()}}},[_vm._v("\n        "+_vm._s(_vm.resources.screens.fragrance.buttonChangeProduct)+"\n    ")]):_vm._e()],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-c0f0f156", __vue__options__)
  } else {
    hotAPI.reload("data-v-c0f0f156", __vue__options__)
  }
})()}

},{"../product-image/product-image.vue":377,"vue":262,"vue-hot-reload-api":257}],382:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'slider-controls',

    props: {
        showLeftArrow: {
            type: Boolean,
            default: true
        },

        showRightArrow: {
            type: Boolean,
            default: true
        },

        showArrowBackground: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * Handle click event left arrow
         */
        onClickArrowLeft() {
            this.$emit('clickArrowLeft');
        },

        /**
         * Handle click event left arrow
         */
        onClickArrowRight() {
            this.$emit('clickArrowRight');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-slider-controls"},[_c('button',{class:['icon-arrow3--left', 'slider-button', {'hidden': !_vm.showLeftArrow}, {'has-background': _vm.showArrowBackground}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickArrowLeft()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move to left")])]),_vm._v(" "),_c('button',{class:['icon-arrow3--right', 'slider-button', {'hidden': !_vm.showRightArrow}, {'has-background': _vm.showArrowBackground}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickArrowRight()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move to right")])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-3714483b", __vue__options__)
  } else {
    hotAPI.reload("data-v-3714483b", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],383:[function(require,module,exports){
;(function(){
'use strict';

const AssembledProduct = require('../assembled-product/assembled-product.vue');

module.exports = {
    name: 'assembled-product-zoom',

    components: {
        AssembledProduct
    },

    props: {
        isDesktop: Boolean,
        productZoomStyle: [Object, Number]
    },

    methods: {
        /**
         * Calculates the translated Y position
         * @param {event} e - The event triggered by mouse or touch
         * @returns {number} The translated Y position
         */
        getTouchMoveY(e) {
            // Get vertical move delta and offset
            const delta = (typeof e === 'undefined') ? 0 : this.yStartTouch - e.touches[0].pageY;

            // Get vertical translate value for desktop and mobile and keep
            // value within viewport range
            const moveY = this.yProductImage - delta;

            // Return moveY but keep it within viewport range
            return Math.min(Math.max(moveY, -(window.innerHeight)), 0);
        },

        /**
         * Updates the image position using transforms
         * @param {event} e - The event triggered by mouse or touch
         */
        updateImagePosition(e) {
            const top = this.getTouchMoveY(e);
            this.zoomStyleProps['top'] = top + 'px';
        },

        /**
         * Manages the assembledProductCssClass array
         * @param {String} className Name of css class to add
         * @param {Boolean} shouldAdd Switch to add or remove the class
         */
        updateProductCssClass(className, shouldAdd) {
            if (shouldAdd) {
                this.assembledProductCssClass.push(className);
            } else {
                this.assembledProductCssClass = this.assembledProductCssClass.filter(val => val !== className);
            }
        },

        /**
         * Handles mouse click event on close button
         * @param {Event} e Mouse Event
         */
        onClickClose() {
            const delay = (this.showZoomPart && !this.isDesktop) ? 200 : 0;

            // Block further events
            this.isClosing = true;

            // Close level 1
            this.setZoomStyleProps(this.shouldStartWithZoom ? 'zoom-top' : 'zoom-start');

            // Close level 0
            setTimeout(() => {
                this.isActive = false;
                this.showZoomPart = false;
                this.initialMobileZoomStyle = this.productZoomStyle;
            }, delay);

            setTimeout(() => {
                this.showZoom = false;
                this.isClosing = false;
            }, 600 + delay);
        },

        /**
         * Handles mouse enter event on product zoom triggers
         * @param {Event} e Mouse Event
         */
        onMouseEnter(e) {
            if (this.showZoomPart && !this.isClosing) {
                this.setZoomStyleProps(e.target.id);
            }
        },

        /**
         * Handles TouchStart event
         * @param {Event} e TouchEvent
         */
        onTouchStart(e) {
            const top = document.querySelector('.is-product-zoom').getBoundingClientRect().top;

            this.isClickEvent = true;
            this.yProductImage = top || 0;
            this.yStartTouch = e.touches[0].pageY;
            this.updateProductCssClass('move-active', true);
        },

        /**
         * Handles TouchMove event
         * @param {Event} e TouchEvent
         */
        onTouchMove(e) {
            if (this.showZoomPart && !this.isClosing) {
                this.updateImagePosition(e);
            }

            this.isClickEvent = false;
        },

        /**
         * Handles TouchEnd and Click event
         * @param {Event} e TouchEvent
         */
        onTouchEndOrClick(e) {
            this.updateProductCssClass('move-active', false);

            if (this.isClickEvent) {
                // On amulet or bottlecap screen trigger level 1
                if (this.shouldStartWithZoom && !this.isActive) {
                    // Build level 0
                    this.isActive = true;
                    this.showZoom = true;

                    // Build level 1
                    this.showZoomPart = true;
                    this.setZoomStyleProps('zoom-top');

                    setTimeout(() => {
                        this.initialMobileZoomStyle = {};
                    }, 100);

                } else {
                    if (this.showZoomPart) {
                        // Return to level 0
                        this.showZoomPart = false;
                        this.setZoomStyleProps('zoom-start');

                    } else if (this.showZoom) {
                        // Build level 1
                        this.showZoomPart = true;
                        this.setZoomStyleProps(e.target.id);

                    } else {
                        // Build level 0
                        this.isActive = true;
                        this.showZoom = true;
                        this.setZoomStyleProps('zoom-start');

                        setTimeout(() => {
                            this.initialMobileZoomStyle = {};
                        }, 100);
                    }
                }
            }
        },

        /**
         * Sets the transform for the product zoom
         * @param {String} part Part of image to zoom in on
         */
        setZoomStyleProps(part) {
            const transform = 'scale3d(' + this.zoomScaleFactor + ', ' + this.zoomScaleFactor + ', 1)';
            const styleProps = {
                'zoom-top': {
                    'top': '0px',
                    'transform': transform
                },
                'zoom-middle': {
                    'top': -(window.innerHeight / this.zoomScaleFactor) + 'px',
                    'transform': transform
                },
                'zoom-bottom': {
                    'top': -(window.innerHeight) + 'px',
                    'transform': transform
                },
                'zoom-start': {
                    'top': '0px'
                }
            };

            this.zoomStyleProps = styleProps[part];
        }
    },

    watch: {
        footerMode(newVal) {
            const shouldAddClass = newVal === 'optionsFooter' && (this.optionTileType === 4 || this.optionTileType === 5);
            this.updateProductCssClass('start-with-zoom', shouldAddClass);
        },

        productZoomStyle(newVal) {
            this.initialMobileZoomStyle = newVal;
        }
    },

    computed: {
        footerMode() {
            return this.$store.getters.footerMode;
        },

        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        },

        shouldStartWithZoom() {
            return (this.optionTileType === 4 || this.optionTileType === 5) && this.footerMode === 'optionsFooter';
        }
    },

    data() {
        return {
            assembledProductCssClass: ['is-product-zoom'],
            initialMobileZoomStyle: {},
            isActive: false,
            isClickEvent: true,
            isClosing: false,
            showZoom: false,
            showZoomPart: false,
            touchedMobileZoomStyle: {},
            yProductImage: 0,
            yStartTouch: 0,
            zoomScaleFactor: 2,
            zoomStyleProps: {}
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['assembled-product-zoom', {'active': _vm.isActive}],style:(_vm.initialMobileZoomStyle)},[_c('div',{staticClass:"zoom-trigger",attrs:{"id":"zoom-top"},on:{"mouseenter":_vm.onMouseEnter,"click":_vm.onTouchEndOrClick,"touchstart":_vm.onTouchStart,"touchmove":function($event){$event.preventDefault();return _vm.onTouchMove($event)},"touchend":function($event){$event.preventDefault();return _vm.onTouchEndOrClick($event)}}}),_vm._v(" "),_c('div',{staticClass:"zoom-trigger",attrs:{"id":"zoom-middle"},on:{"mouseenter":_vm.onMouseEnter,"click":_vm.onTouchEndOrClick,"touchstart":_vm.onTouchStart,"touchmove":function($event){$event.preventDefault();return _vm.onTouchMove($event)},"touchend":function($event){$event.preventDefault();return _vm.onTouchEndOrClick($event)}}}),_vm._v(" "),_c('div',{staticClass:"zoom-trigger",attrs:{"id":"zoom-bottom"},on:{"mouseenter":_vm.onMouseEnter,"click":_vm.onTouchEndOrClick,"touchstart":_vm.onTouchStart,"touchmove":function($event){$event.preventDefault();return _vm.onTouchMove($event)},"touchend":function($event){$event.preventDefault();return _vm.onTouchEndOrClick($event)}}}),_vm._v(" "),_c('button',{staticClass:"zoom-close",on:{"click":_vm.onClickClose}},[_c('span',{staticClass:"icon icon-close-thick"})]),_vm._v(" "),_c('assembled-product',{attrs:{"cssClass":_vm.assembledProductCssClass,"inlineStyle":_vm.zoomStyleProps,"isVisible":_vm.showZoom,"isDesktop":_vm.isDesktop,"isProductZoom":true}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showZoom),expression:"showZoom"}],staticClass:"zoom-backdrop"})],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-1eb9e83e", __vue__options__)
  } else {
    hotAPI.reload("data-v-1eb9e83e", __vue__options__)
  }
})()}

},{"../assembled-product/assembled-product.vue":384,"vue":262,"vue-hot-reload-api":257}],384:[function(require,module,exports){
;(function(){
'use strict';

const ImageLayer = require('../image-layer/image-layer.vue');

module.exports = {
    name: 'assembled-product',

    components: {
        ImageLayer
    },

    props: {
        isTablet: {
            type: Boolean,
            default: false
        },
        isDesktop: {
            type: Boolean,
            default: false
        },
        isVisible: {
            type: Boolean,
            default: false
        },
        isOverlayVisible: {
            type: Boolean,
            default: false
        },
        isProductZoom: {
            type: Boolean,
            default: false
        },
        cssClass: {
            type: Array,
            default() {
                return [];
            }
        },
        inlineStyle: {
            type: Object,
            default() {
                return {};
            }
        },
        isUpsellScreen: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * Calculates the height of the assembled product
         * @returns {Number} Percentage
         */
        getHeightInPercentage() {
            const footer = document.querySelector('#' + this.footerMode);
            const footerHeight = footer ? footer.getBoundingClientRect().height : 175;
            const footerHeaderHeight = this.getFooterHeaderHeight();
            const totalHeightPerc = (100 / window.innerHeight) * (footerHeight + footerHeaderHeight);
            return 100 - totalHeightPerc;
        },

        /**
         * Returns the height of the header inside the footer. Currently only
         * used incase of tablet mode and when entering the part options.
         */
        getFooterHeaderHeight() {
            return this.isTablet && (this.footerMode == 'optionsFooter' || this.footerMode == 'upsellFooter') ? 150 : 0;
        },

        /**
         * Sets the assembled product height and emits the new settings
         */
        setProductHeight() {
            const height = this.getHeightInPercentage();
            const marginTop = this.getFooterHeaderHeight();

            this.assembledProductStyle = {
                'margin-top': marginTop + 'px',
                'height': height + '%'
            };

            this.$emit('productStyleSet', this.assembledProductStyle);
        },

        /**
         * Zooms in on a product part like a cap or an amulet
         */
        setProductPartZoom(part) {
            if (part === 'top') {
                this.assembledProductClass.push('zoom-top');
            } else if (part === 'middle') {
                this.assembledProductClass.push('zoom-middle');
            } else {
                this.assembledProductClass = this.assembledProductClass.filter(val => (val !== 'zoom-top') && (val !== 'zoom-middle'));
            }
        },

        onClickBack() {
            setTimeout(() => {
                this.$emit('clickBackButton');
            }, this.isDesktop ? 0 : 15);
        }
    },

    watch: {
        isVisible(newVal) {
            if (newVal === true && !this.isDesktop && !this.isProductZoom) {
                setTimeout(() => {
                    this.setProductHeight();
                }, 1200);
            }
        },

        footerMode(newVal, oldVal) {
            if ((this.optionTileType == 1 || this.optionTileType == 2) && !this.isDesktop && !this.isProductZoom) {
                setTimeout(() => {
                    this.setProductHeight();
                }, 300);
            }

            if (newVal == 'upsellFooter' && this.isTablet && !this.isProductZoom) {
                setTimeout(() => {
                    this.setProductHeight();
                }, 300);
            }

            if (oldVal == 'upsellFooter' && !this.isDesktop && !this.isProductZoom) {
                setTimeout(() => {
                    this.setProductHeight();
                }, 300);
            }

            if ((newVal == 'optionsFooter') && !this.isProductZoom) {
                this.setProductPartZoom(this.$store.getters.currentProductPart.zoomImageOnEnter);
            } else {
                this.setProductPartZoom(false);
            }
        },

        cssClass(newVal) {
            this.assembledProductClass = newVal;
        }
    },

    computed: {
        fragranceLabel() {
            const [pid, cid, id] = this.productLayers[0].split('-');
            return this.$store.getters.productParts[pid].categories[cid].options[id].name;
        },

        assembledImage() {
            const productParts = this.$store.getters.productParts;
            const productLayers = this.productLayers;
            const selectedVariants = {};
            productLayers.forEach((layer) => {
                const [pid, cid, id] = layer.split('-');
                const categories = productParts[pid].categories;
                selectedVariants[productParts[pid].resourceId] = categories[cid].options[id];
            });

            if (this.$store.getters.resources.updateData.isTalisman) {
                const primaryImageObject = (this.isUpsellScreen) ?
                    this.$store.getters.resources.updateData.talismanImagePlaceholders.secondaryImageThird :
                    this.$store.getters.resources.updateData.talismanPrimaryImagePlaceholder;
                primaryImageObject.src = String.format(primaryImageObject.urlFormat, selectedVariants.bottle.EAN, selectedVariants.fragrance.EAN,
                    selectedVariants.talisman.EAN, selectedVariants.cap.EAN);

                return primaryImageObject;
            }

            const presentationComponent = selectedVariants.bottle || selectedVariants.candleholder;

            return presentationComponent.image;
        },

        footerMode() {
            return this.$store.getters.footerMode;
        },

        productLayers() {
            return this.$store.getters.productLayers;
        },

        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        },

        shouldShowBackButton() {
            return this.isUpsellScreen;
        }
    },

    mounted() {
        if (this.cssClass.length > 0) {
            this.assembledProductClass = this.cssClass;
        }

        if (this.footerMode == 'upsellFooter' && this.isTablet && !this.isProductZoom) {
            console.debug('Setting Product Height on Mount');

            setTimeout(() => {
                this.setProductHeight();
            }, 100);
        }
    },

    data() {
        return {
            assembledProductStyle: {},
            assembledProductClass: []
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isVisible),expression:"isVisible"}],class:['assembled-product', {'blurred': _vm.isOverlayVisible} ].concat( _vm.assembledProductClass),style:(Object.assign({}, _vm.assembledProductStyle, _vm.inlineStyle))},[(_vm.shouldShowBackButton)?_c('button',{class:['icon-arrow3--left', 'restart-button', 'fixed'],attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickBack()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move back")])]):_vm._e(),_vm._v(" "),_c('image-layer',{attrs:{"wrapperClass":"layer","image":_vm.assembledImage,"shouldUpdateImage":true}}),_vm._v(" "),_c('span',{staticClass:"fragrance-label"},[_vm._v("\n        "+_vm._s(_vm.fragranceLabel)+"\n    ")])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6ca81e8b", __vue__options__)
  } else {
    hotAPI.reload("data-v-6ca81e8b", __vue__options__)
  }
})()}

},{"../image-layer/image-layer.vue":385,"vue":262,"vue-hot-reload-api":257}],385:[function(require,module,exports){
;(function(){
'use strict';

const damHelper = require('../../../dam/dam-helper');

module.exports = {
    name: 'image-layer',

    mounted() {
        damHelper.updateImages(this.$refs.imageLayer);
    },

    updated() {
        if (this.shouldUpdateImage) {
            damHelper.updateImages(this.$refs.imageLayer);
        }
    },

    props: {
        image: Object,
        wrapperClass: String,
        shouldUpdateImage: {
            type: Boolean,
            default: false
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.image && _vm.wrapperClass)?_c('div',{ref:"imageLayer",class:_vm.wrapperClass},[_c('img',{class:_vm.image.class,attrs:{"src":_vm.image.placeholder,"data-src":_vm.image.src,"alt":"","data-width":_vm.image.width}})]):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2dd6febe", __vue__options__)
  } else {
    hotAPI.reload("data-v-2dd6febe", __vue__options__)
  }
})()}

},{"../../../dam/dam-helper":419,"vue":262,"vue-hot-reload-api":257}],386:[function(require,module,exports){
;(function(){
'use strict';

const Overlay = require('../overlay/overlay.vue');
const StatusBar = require('../status-bar/status-bar.vue');
const PartOptions = require('../part-options/part-options.vue');
const ImageLayer = require('../image-layer/image-layer.vue');

module.exports = {
    name: 'options-footer',

    components: {
        Overlay,
        StatusBar,
        PartOptions,
        ImageLayer
    },

    props: {
        isMobile: Boolean,
        isTablet: Boolean,
        isDesktop: Boolean
    },

    methods: {
        /**
         * Accepts the selected part and returns to the main screen
         */
        accept() {
            this.reset();

            setTimeout(() => {
                this.$store.commit('popSnapshot');
                this.$store.commit('setFooterMode', 'partsFooter');
                this.$emit('optionFooterChange', this.shouldShowOverlay);
            }, (this.isTablet ? 100 : 0));
        },

        /**
         * Ignores the selected part and returns to the main screen
         */
        cancel() {
           this.reset();

            setTimeout(() => {
                this.$store.commit('useSnapshot');
                this.$store.commit('setFooterMode', 'partsFooter');
            }, (this.isTablet ? 100 : 0));
        },

        /**
         * Resets local vars
         */
        reset() {
            if (this.isTablet) {
                this.shouldShowHeader = false;
            }
        },

        /**
         * Toggles the overlay visibility and emits update to parent
         */
        toggleOverlay() {
            this.shouldShowOverlay = !this.shouldShowOverlay;
            this.$emit('overlayChange', this.shouldShowOverlay);
        },

        /**
         * Handles the part option onclick emitted from part options component
         * @param {JSON} option JSON object containing the category id and option id of clicked option
         */
        onClickPartOption(option) {
            const [,,id] = this.$store.getters.productLayers[this.currentProductPart.depth].split('-');

            this.selectedPartUnavailable = !this.currentProductPart.categories[option.cid].options[option.id].available;
            this.productPartChanged = option.id == id;
        },

        /**
         * Handles the read more onclick emitted from part options component
         * @param {Object} data Option data to be displayed in the overlay
         */
        onClickPartOptionReadMore(data) {
            this.overlayResource = {
                heading: data.name,
                body: data.description.split('||'),
                notes: [],
                thumb: data.thumb
            };

            if (data.notes) {
                for (let i = 0; i < data.notes.length; i++) {
                    this.overlayResource.notes.push(data.notes[i]);
                }
            }

            this.toggleOverlay();
        },

        /**
         * Handles the close button click emitted from inside of the overlay
         */
        onClickOverlayClose() {
            this.toggleOverlay();
        }
    },

    computed: {
        icon() {
            return this.currentProductPart.icon;
        },

        resource() {
            const resourcePartId = this.currentProductPart.resourceId;
            return this.$store.getters.resources.productParts[resourcePartId];
        },

        hasCategories() {
            return this.currentProductPart.optionTileType === 1;
        },

        currentProductPart() {
            return this.$store.getters.currentProductPart;
        },

        currentPartUnavailable() {
            const [pid, cid, id] = this.$store.getters.productLayers[this.currentProductPart.depth].split('-');
            return !this.$store.getters.productParts[pid].categories[cid].options[id].available;
        },

        statusMessage() {
            const [pid, cid, id] = this.$store.getters.productLayers[this.currentProductPart.depth].split('-');
            const selectedOption = this.$store.getters.productParts[pid].categories[cid].options[id];
            const productName = selectedOption.outOfStockName || selectedOption.name;
            return this.$store.getters.resourceGlobal.unavailableCustom + ' ' + productName;
        },

        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        },

        isZoomImage() {
            return this.currentProductPart.zoomImageOnEnter !== false;
        }
    },

    beforeDestroy() {
        this.shouldShowHeader = false;
    },

    mounted() {
        this.selectedPartUnavailable = this.currentPartUnavailable;
        this.shouldShowHeader = !this.isMobile;
    },

    data() {
        return {
            selectedPartUnavailable: false,
            shouldShowOverlay: false,
            shouldShowHeader: false,
            overlayResource: {},
            productPartChanged: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"optionsFooter",staticClass:"options-footer",class:[
        'options-footer',
        {'has-overlay': _vm.shouldShowOverlay},
        {'is-zoom-image': _vm.isZoomImage},
        {'full-height-footer': _vm.optionTileType === 3}
    ],attrs:{"id":"optionsFooter"}},[_c('transition',{attrs:{"name":"footer-header-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowHeader),expression:"shouldShowHeader"}],staticClass:"footer-header",class:{'has-categories': _vm.hasCategories}},[_c('span',{class:'icon ' + _vm.icon}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.resource.heading))]),_vm._v(" "),(!_vm.isTablet || _vm.optionTileType === 3)?_c('p',[_vm._v(_vm._s(_vm.resource.body))]):_vm._e()])]),_vm._v(" "),_c('overlay',{attrs:{"isDesktop":_vm.isDesktop,"shouldShow":_vm.shouldShowOverlay},on:{"onClickClose":_vm.onClickOverlayClose}},[_c('image-layer',{attrs:{"wrapperClass":"fragrance-image","image":_vm.overlayResource.thumb,"shouldUpdateImage":true}}),_vm._v(" "),(_vm.shouldShowOverlay)?_c('h1',[_vm._v(_vm._s(_vm.overlayResource.heading))]):_vm._e(),_vm._v(" "),_vm._l((_vm.overlayResource.body),function(paragraph){return _c('p',[_vm._v(_vm._s(paragraph))])}),_vm._v(" "),_vm._l((_vm.overlayResource.notes),function(note){return _c('div',{staticClass:"fragrance-note"},[_c('span',{staticClass:"fragrance-title"},[_vm._v(_vm._s(note.Name))]),_vm._v(" "),_c('span',{staticClass:"fragrance-text"},[_vm._v(_vm._s(note.Description))])])})],2),_vm._v(" "),_c('part-options',{attrs:{"isTablet":_vm.isTablet,"isDesktop":_vm.isDesktop},on:{"onClickPart":_vm.onClickPartOption,"onClickReadMore":_vm.onClickPartOptionReadMore}}),_vm._v(" "),_c('transition',{attrs:{"name":"status-bar-transition"}},[_c('status-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPartUnavailable),expression:"selectedPartUnavailable"}],attrs:{"message":_vm.statusMessage}})],1),_vm._v(" "),_c('div',{staticClass:"button-row"},[_c('button',{staticClass:"btn btn--secondary",on:{"click":function($event){return _vm.cancel()}}},[_c('span',{staticClass:"icon icon-close-thick"})]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.selectedPartUnavailable},on:{"click":function($event){return _vm.accept()}}},[_c('span',{staticClass:"icon icon-check"})])])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0fe16321", __vue__options__)
  } else {
    hotAPI.reload("data-v-0fe16321", __vue__options__)
  }
})()}

},{"../image-layer/image-layer.vue":385,"../overlay/overlay.vue":387,"../part-options/part-options.vue":388,"../status-bar/status-bar.vue":398,"vue":262,"vue-hot-reload-api":257}],387:[function(require,module,exports){
;(function(){
'use strict';

const SimpleBar = require('../../../../../node_modules/simplebar/dist/simplebar');
const debounce = require('../../../modules/helpers/debounce');

module.exports = {
    name: 'overlay',

    props: {
        shouldShow: Boolean,
        isDesktop: Boolean
    },

    methods: {
        /**
         * Handles click event on close button
         */
        onClickClose() {
            this.$emit('onClickClose');
        },

        /**
         * Adds the correct gradient when the user scrolls in the overlay
         * @param {Event} e ScrollEvent object
         */
        onOverlayScroll(e) {
            const {scrollHeight, scrollTop, offsetHeight} = e.target;
            const gradientClass = [];

            if (scrollTop + offsetHeight < scrollHeight) {
                gradientClass.push('bottom-gradient');
            }

            if (scrollTop > 0) {
                gradientClass.push('top-gradient');
            }

            this.overlaySlotClass = gradientClass.join(' ');
        }
    },

    computed: {
        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        }
    },

    watch: {
        shouldShow(val) {
            if (val) {
                this.$nextTick(() => {
                    const scrollEl = document.querySelector('.overlay-slot');
                    this.hasScrollBar = scrollEl.scrollHeight > scrollEl.getBoundingClientRect().height;
                });
            } else {
                setTimeout(() => {
                    this.hasScrollBar = false;
                }, 800);
            }
        }
    },

    mounted() {
        const scrollEl = document.querySelector('.overlay-slot');

        if (this.isDesktop) {
            const simpleBar = new SimpleBar(scrollEl, {autoHide: true});
            simpleBar.getScrollElement().addEventListener('scroll', debounce(this.onOverlayScroll, 10));
        } else {
            scrollEl.addEventListener('scroll', debounce(this.onOverlayScroll, 10));
        }
    },

    data() {
        return {
            overlaySlotClass: 'bottom-gradient',
            hasScrollBar: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"overlay-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShow),expression:"shouldShow"}],staticClass:"overlay"},[_c('div',{staticClass:"overlay-slot",class:_vm.overlaySlotClass},[_c('div',{staticClass:"overlay-body",class:[{'fragrance-overlay': _vm.optionTileType === 3}, {'has-scrollbar': _vm.hasScrollBar}]},[_vm._t("default")],2)]),_vm._v(" "),_c('button',{staticClass:"overlay-close",on:{"click":_vm.onClickClose}},[_c('span',{staticClass:"icon icon-close-thick"})])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-34ceb6fa", __vue__options__)
  } else {
    hotAPI.reload("data-v-34ceb6fa", __vue__options__)
  }
})()}

},{"../../../../../node_modules/simplebar/dist/simplebar":255,"../../../modules/helpers/debounce":458,"vue":262,"vue-hot-reload-api":257}],388:[function(require,module,exports){
;(function(){
'use strict';

const debounce = require('../../../modules/helpers/debounce');
const dataLayer = window.dataLayer || [];
const VueSlickCarousel = require('../../../../../node_modules/vue-slick-carousel');
const SliderControls = require('../slider-controls/slider-controls.vue');
const isMobileWidth = require('../../../modules/util/isMobileWidth');
const ImageLayer = require('../image-layer/image-layer.vue');

module.exports = {
    name: 'part-options',

    props: {
        isDesktop: Boolean
    },

    components: {
        VueSlickCarousel,
        SliderControls,
        ImageLayer
    },

    methods: {
        /**
         * Calculates the list width
         * @param {Number} numItems The number of list imtes
         * @returns {StyleObject}
         */
        getListStyle(numItems) {
            const margins = 80;
            const width = numItems * this.optionWidth + margins;
            const style = {
                'width': width + 'px'
            };

            if (width < window.innerWidth) {
                style.margin = '0 auto';
            }

            return !this.isDesktop ? style : {};
        },

        /**
         * Calculates the width and height of an option
         * @returns {StyleObject}
         */
        getOptionDimenions() {
            return {
                'height': this.optionHeight + 'px',
                'width': this.optionWidth + 'px'
            };
        },

        /**
         * Scrolls the correct list into view
         * @param {Number} idx Id of list to scroll to
         */
        selectPart(idx) {
            this.selectedPart = idx;

            if (this.optionTileType === 3) {
                this.$refs.carousel.goTo(this.getAbsoluteIndexInSlider(idx, 0));
            } else {
                if (!this.isDesktop) {
                    const optionListRect = document.getElementById('optionList' + idx).getBoundingClientRect();
                    this.optionSliderElement.scrollLeft += optionListRect.x;
                } else {
                    const optionListRect = document.querySelectorAll('h4.category-name')[idx].getBoundingClientRect();
                    const partOptionsElement = document.querySelector('.part-options');
                    partOptionsElement.scrollTop += (optionListRect.top - partOptionsElement.getBoundingClientRect().top);
                }
            }

            this.setIndicatorStyle();

            this.muteSliderObserver = true;

            setTimeout(() => {
                this.muteSliderObserver = false;
            }, 400);
        },

        /**
         * Checks if current part is selected
         * @param {Number} cid Id of category
         * @returns {String}
         */
        selectedPartClass(cid) {
            return cid === +this.selectedPart ? 'selected' : '';
        },

        /**
         * Selects the option and initiates the image swap
         * @param {Number} cid Id of category
         * @param {Number} id Id of option
         */
        selectOption(cid, id) {
            const selectedProductPart = this.$store.getters.selectedProductPart;
            const optionDepth = this.$store.getters.productParts[selectedProductPart].depth;
            const productLayers = this.$store.getters.productLayers;
            const shouldUpdateFragranceLabel = this.categories[cid].options[id].image === '';

            if (shouldUpdateFragranceLabel) {
                this.$store.commit('setFragranceLabel', this.categories[cid].options[id].name);
            }

            productLayers[optionDepth] = [selectedProductPart, cid, id].join('-');
            this.$emit('onClickPart', {'cid': cid, 'id': id});
            this.$store.commit('setProductLayers', productLayers);
            dataLayer.push({
                event:'configurator_selected_option',
                productGroup: this.categories[cid].name,
                selection: this.categories[cid].options[id].name
            });
        },

        /**
         * Calculates the correct classes for the options
         * @param {Number} cid Id of category
         * @param {Number} id Id of option
         * @returns {String}
         */
        optionClass(cid, id) {
            const productLayers = this.$store.getters.productLayers;
            const selectedProductPart = this.$store.getters.selectedProductPart;
            const option = [selectedProductPart, cid, id].join('-');

            const classes = [];

            if (this.optionTileType === 2) {
                classes.push('has-thumb');
            }

            if (productLayers.indexOf(option) > -1) {
                classes.push('selected');
            }

            return classes.join(' ');
        },

        /**
         * Adds and inits the Intersection Observer that selects the correct
         * category while scrolling
         */
        initObserver() {
            const optionSliderObserver = new IntersectionObserver((lists) => {
                let selectedList;

                for (const list of lists) {
                    if (list.isIntersecting && this.muteSliderObserver === false && (!selectedList || list.intersectionRation > selectedList.intersectionRatio)) {
                        selectedList = list;
                        this.selectedPart = parseInt(selectedList.target.dataset.cid);
                    }
                }

                this.setIndicatorStyle();
                if (selectedList && selectedList.target && selectedList.target.dataset && selectedList.target.dataset.cid) {
                    this.selectedPart = parseInt(selectedList.target.dataset.cid);
                }
            }, {
                threshold: !this.isDesktop ? [0.25] : [0.5]
            });

            this.optionSliderElement = document.getElementById('optionsSlider');
            if (!this.optionSliderElement) {
                return;
            }

            this.optionSliderElement.getElementsByTagName('ul').forEach((el) => {
                optionSliderObserver.observe(el);
            });
        },

        /**
         * Adds the correct gradient when the user scrolls in the part options
         * @param {Event} e ScrollEvent object
         */
        onPartOptionsScroll(e) {
            const {scrollHeight, scrollTop, offsetHeight} = e.target;
            const scrollClass = [];

            if (this.optionTileType !== 3) {
                if (scrollTop + offsetHeight < scrollHeight) {
                    scrollClass.push('bottom-gradient');
                }

                if (scrollTop > 0) {
                    scrollClass.push('top-gradient');
                }

                this.partOptionsClass = scrollClass.join(' ');
            }
        },

        /**
         * Handles click event on read more link
         * @param {Object} option Option data to be transmitted to parent component
         */
        onClickReadMore(option) {
            this.$emit('onClickReadMore', option);
        },

        /**
         * Handles click on left arrow
         */
        onClickArrowLeft() {
            this.$refs.carousel.prev();
        },

        /**
         * Handles click on right arrow
         */
        onClickArrowRight() {
            this.$refs.carousel.next();
        },

        /**
         * Sets current slide as a product option
         * @param {*} slideIndex Index of selected part in slider
         */
        selectCurrentSlideAsOption(slideIndex) {
            const result = this.getCategoryAndProductIndexFromSlideIndex(slideIndex);

            this.selectOption(result.categoryIndex, result.productIndex);
        },

        /**
         * Resolves category and product index from absolute index in slider
         * @param {*} absoluteIndex Absolute index in slider
         */
        getCategoryAndProductIndexFromSlideIndex(absoluteIndex) {
            for (let categoryIndex = 0; categoryIndex < this.categories.length; categoryIndex++) {
                absoluteIndex -= this.categories[categoryIndex].options.length;

                if (absoluteIndex === 0) {
                    return {
                        categoryIndex: categoryIndex + 1,
                        productIndex: 0
                    };
                } else if (absoluteIndex < 0) {
                    return {
                        categoryIndex: categoryIndex,
                        productIndex: this.categories[categoryIndex].options.length + absoluteIndex
                    };
                }
            }

            return {
                categoryIndex: 0,
                productIndex: 0
            };
        },

        /**
         * Handles event that fires before slides are changed
         * @param {Number} oldIdx Index of old slide
         * @param {Number} newIdx Index of new slide
         */
        onBeforeChange(oldIdx, newIdx) {
            this.currentSlide = newIdx;

            this.selectCurrentSlideAsOption(newIdx);

            const itemInfo = this.getCategoryAndProductIndexFromSlideIndex(newIdx);

            this.selectedPart = itemInfo.categoryIndex;
            this.setIndicatorStyle();
            this.checkIfCategoryIsInView();
        },

        /**
         * Checks if the category is in view and scrolls it in view
         */
        checkIfCategoryIsInView() {
            const categoriesList = this.$refs.categoriesSelector;

            if (categoriesList) {
                const selectedCategoryIndex = this.selectedPart || 0;

                const selectedCategoryItem = document.querySelectorAll('ul.categories li')[selectedCategoryIndex];

                const selectedCategoryRect = selectedCategoryItem ? selectedCategoryItem.getBoundingClientRect() : null;
                const categoriesListRect = categoriesList ? categoriesList.getBoundingClientRect() : null;

                const isCategoryInViewport = selectedCategoryRect.left >= categoriesListRect.left &&
                    selectedCategoryRect.right <= categoriesListRect.right;

                if (!isCategoryInViewport) {
                    categoriesList.scrollLeft += selectedCategoryRect.x - categoriesListRect.x;
                }
            }
        },

        /**
         * Checks if the product is on the current slide
         * @param {*} categoryIndex Category index of the current product
         * @param {*} productIndex Product index of the current product
         * @param {*} currentSlideIndex Index of the product in the slider
         */
        checkIfCurrentSlide(categoryIndex, productIndex, currentSlideIndex) {
            return this.getAbsoluteIndexInSlider(categoryIndex, productIndex) === currentSlideIndex;
        },

        /**
         * Resolves the absolute index in the slider from category and product index
         * @param {*} categoryIndex Provided category index
         * @param {*} productIndex Provided product index
         */
        getAbsoluteIndexInSlider(categoryIndex, productIndex) {
            let indexInSlider = productIndex;

            if (categoryIndex > 0) {
                const elementsBefore = this.categories.slice(0, categoryIndex)
                    .map(category => category.options.length)
                    .reduce((a, b) => a + b, 0);

                indexInSlider = elementsBefore + productIndex;
            }

            return indexInSlider;
        },

        /**
         * Adds width and position to the categories indicator
         */
        setIndicatorStyle(withoutTransition) {
            const selected = this.selectedPart || 0;
            const partElement = document.querySelectorAll('ul.categories li')[selected];
            const categoriesElement = document.querySelector('ul.categories');
            const categoriesRect = partElement ? categoriesElement.getBoundingClientRect() : null;
            const partRect = partElement ? partElement.getBoundingClientRect() : null;

            const indicatorStyle = {
                left: (partRect ? (partRect.left - categoriesRect.left) : 0) + 'px',
                width: (partRect ? partRect.width : 0) + 'px',
            };

            if (withoutTransition) {
                indicatorStyle.transition = 'none';
            }

            this.indicatorStyle = indicatorStyle;
        }
    },

    computed: {
        resources() {
            const {readMore, learnMore, notInStockShort} = this.$store.getters.resourceGlobal;

            return {
                notInStockShort: notInStockShort,
                readMore: readMore,
                learnMore: learnMore
            };
        },

        categories() {
            return this.$store.getters.currentProductPart.categories;
        },

        shouldShowCategories() {
            return this.optionTileType === 1 || this.optionTileType === 3;
        },

        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        },

        sliderTransitionName() {
            let transitionName = 'part-options-transition';

            if (this.optionTileType === 3 && !this.isDesktop) {
                transitionName = 'fragrance-slider-transition';
            }

            return transitionName;
        },

        outOfStockType() {
            return this.$store.getters.currentProductPart.outOfStockType;
        },

        optionWidth() {
            return ({
                1: !this.isDesktop ? 280 : 165, // fragrance default
                2: !this.isDesktop ? 145 : 165, // image default
                3: !this.isDesktop ? 230 : 230, // fragrance large
                4: !this.isDesktop ? 280 : 255, // image large
                5: !this.isDesktop ? 145 : 165, // image default
            })[this.optionTileType];
        },

        optionHeight() {
            return ({
                1: !this.isDesktop ? 130 : 260, // fragrance default
                2: !this.isDesktop ? 130 : 170, // image default
                3: !this.isDesktop ? 360 : 360, // fragrance large
                4: !this.isDesktop ? 170 : 216, // image large
                5: !this.isDesktop ? 130 : 170, // image default
            })[this.optionTileType];
        },

        shouldIncreaseHeight() {
            let increase = false;

            if (!this.isDesktop) {
                this.categories.forEach((category) => {
                    category.options.forEach((option) => {
                        if (option.available === false) {
                            increase = true;
                        }
                    });
                });
            }

            return increase;
        },

        computedIndicatorStyle() {
            return this.indicatorStyle;
        },

        isSmallDesktop() {
            return window.innerWidth >= 1024 && window.innerWidth < 1440;
        }
    },

    mounted() {
        this.optionSliderElement = document.getElementById('optionsSlider');

        const [selectedPartIndex, selectedCategoryIndex, selectedProductIndex] = this.$store.getters.productLayers[0].split('-'); /* eslint-disable-line */
        const initiallySelectedIndexInSlider = this.getAbsoluteIndexInSlider(+selectedCategoryIndex, +selectedProductIndex);

        this.sliderSettings.initialSlide = initiallySelectedIndexInSlider;
        this.currentSlide = initiallySelectedIndexInSlider;

        this.shouldShowOptions = true;

        if (this.optionTileType === 3) {
            this.selectedPart = selectedCategoryIndex;
        } else {
            this.selectedPart = 0;
            this.partOptionsClass = 'bottom-gradient';
        }

        this.setIndicatorStyle();
        this.checkIfCategoryIsInView();

        if (this.$refs.categoriesSelector) {
            this.$refs.categoriesSelector.addEventListener('scroll', () => this.setIndicatorStyle(true));
        }

        if ('IntersectionObserver' in window) {
            this.initObserver();
        }

        setTimeout(() => {
            this.indicatorClass = 'allow-animation';
        }, 300);

        if (this.isDesktop) {
            document.querySelector('.part-options').addEventListener('scroll', debounce(this.onPartOptionsScroll, 10));
        }
    },

    data() {
        return {
            optionsSliderStyle: {},
            indicatorClass: '',
            partOptionsClass: '',
            optionSliderElement: null,
            muteSliderObserver: false,
            shouldShowOptions: false,
            selectedPart: null,
            currentSlide: 0,
            showLeftArrow: true,
            showRightArrow: true,
            isMobile: isMobileWidth(),
            indicatorStyle: {
                left: '0px',
                width: '0px',
            },
            sliderSettings: {
                arrows: false,
                dots: false,
                infinite: false,
                initialSlide: 0,
                slidesToShow: 3,
                swipe: false,
                waitForAnimate: false,
                touchThreshold: 500,
                responsive: [{
                    breakpoint: 1440,
                    settings: {
                        centerMode: true,
                        centerPadding: '28%',
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                },{
                    breakpoint: 1024,
                    settings: {
                        centerMode: false,
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        swipe: true
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                        centerPadding: '18%',
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        speed: 150,
                        swipe: true
                    }
                }]
            }
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"part-options",class:[_vm.partOptionsClass, {'part-options-fragrance-slider': _vm.optionTileType === 3}]},[(_vm.shouldShowCategories)?_c('ul',{ref:"categoriesSelector",staticClass:"categories"},_vm._l((_vm.categories),function(category,idx){return _c('li',{class:_vm.selectedPartClass(idx)},[_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.selectPart(idx)}}},[_c('span',{staticClass:"category-name"},[_vm._v(_vm._s(category.name))])])])}),0):_vm._e(),_vm._v(" "),(_vm.shouldShowCategories)?_c('div',{staticClass:"category-indicator-scrim"},[_c('div',{staticClass:"category-indicator",class:_vm.indicatorClass,style:(_vm.computedIndicatorStyle),attrs:{"id":"categoryIndicator"}})]):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":_vm.sliderTransitionName}},[(_vm.optionTileType === 3)?_c('div',{staticClass:"fragrance-options-slider"},[_c('div',{staticClass:"fragrance-slider-body"},[_c('VueSlickCarousel',_vm._b({ref:"carousel",on:{"beforeChange":_vm.onBeforeChange}},'VueSlickCarousel',_vm.sliderSettings,false),[(!_vm.isMobile && !_vm.isSmallDesktop)?_c('div',{staticClass:"slider-gap"}):_vm._e(),_vm._v(" "),_vm._l((_vm.categories),function(category,cid){return _vm._l((category.options),function(option,id){return _c('div',{key:'optionList' + cid,class:{ 'selected' : _vm.checkIfCurrentSlide(cid, id, _vm.currentSlide), 'slider-item': true },style:(_vm.getOptionDimenions()),attrs:{"data-cid":cid,"id":'optionList' + cid}},[_c('div',{staticClass:"content-wrapper"},[(!option.available && _vm.outOfStockType == 'bar')?_c('span',{staticClass:"error-message"},[_c('span',{staticClass:"error-badge"}),_vm._v("\n                                    "+_vm._s(_vm.resources.notInStockShort)+"\n                                ")]):_vm._e(),_vm._v(" "),_c('image-layer',{attrs:{"wrapperClass":"option-image","image":option.thumb}}),_vm._v(" "),_c('span',{staticClass:"option-category"},[_vm._v(_vm._s(category.name))]),_vm._v(" "),_c('span',{staticClass:"option-name"},[_vm._v(_vm._s(option.name))]),_vm._v(" "),_c('div',{staticClass:"option-more-wrapper"},[_c('span',{staticClass:"option-more",on:{"click":function($event){return _vm.onClickReadMore(option)}}},[_vm._v(_vm._s(_vm.resources.learnMore))])])],1)])})}),_vm._v(" "),(!_vm.isMobile && !_vm.isSmallDesktop)?_c('div',{staticClass:"slider-gap"}):_vm._e()],2)],1),_vm._v(" "),_c('slider-controls',{attrs:{"showLeftArrow":_vm.showLeftArrow,"showRightArrow":_vm.showRightArrow},on:{"clickArrowLeft":function($event){return _vm.onClickArrowLeft()},"clickArrowRight":function($event){return _vm.onClickArrowRight()}}})],1):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"part-options-transition"}},[(_vm.optionTileType !== 3)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowOptions),expression:"shouldShowOptions"}],staticClass:"part-options-slider",class:{'has-statusbar': _vm.shouldIncreaseHeight, 'has-wide-tiles': _vm.optionTileType === 4},attrs:{"id":"optionsSlider"}},[_vm._l((_vm.categories),function(category,cid){return [(_vm.isDesktop && _vm.categories.length > 1)?_c('h4',{staticClass:"category-name"},[_vm._v(_vm._s(category.name))]):_vm._e(),_vm._v(" "),_c('ul',{key:'optionList' + cid,staticClass:"options",style:(_vm.getListStyle(category.options.length)),attrs:{"data-cid":cid,"id":'optionList' + cid}},_vm._l((category.options),function(option,id){return _c('li',{class:_vm.optionClass(cid, id),style:(_vm.getOptionDimenions())},[_c('a',{class:{'bottle-wrapper': _vm.optionTileType === 2, 'bottle-cap-wrapper': _vm.optionTileType === 5},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.selectOption(cid, id)}}},[(!option.available && _vm.outOfStockType == 'badge')?_c('span',{staticClass:"error-badge"}):_vm._e(),_vm._v(" "),(!option.available && _vm.outOfStockType == 'bar')?_c('span',{staticClass:"error-message"},[_c('span',{staticClass:"error-badge"}),_vm._v("\n                                "+_vm._s(_vm.resources.notInStockShort)+"\n                            ")]):_vm._e(),_vm._v(" "),(_vm.optionTileType === 2 || _vm.optionTileType === 4 || _vm.optionTileType === 5)?_c('image-layer',{attrs:{"wrapperClass":"option-thumb","image":option.thumb}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"option-name"},[_vm._v(_vm._s(option.name))]),_vm._v(" "),(_vm.optionTileType === 1 || _vm.optionTileType === 4)?_c('span',{staticClass:"option-excerpt"},[_vm._v(_vm._s(option.excerpt))]):_vm._e(),_vm._v(" "),(_vm.optionTileType === 1)?_c('span',{staticClass:"option-more",on:{"click":function($event){return _vm.onClickReadMore(option)}}},[_vm._v(_vm._s(_vm.resources.readMore))]):_vm._e(),_vm._v(" "),(_vm.optionTileType === 4)?_c('span',{staticClass:"option-more",on:{"click":function($event){return _vm.onClickReadMore(option)}}},[_vm._v(_vm._s(_vm.resources.learnMore))]):_vm._e()],1)])}),0)]})],2):_vm._e()])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-660c90be", __vue__options__)
  } else {
    hotAPI.reload("data-v-660c90be", __vue__options__)
  }
})()}

},{"../../../../../node_modules/vue-slick-carousel":260,"../../../modules/helpers/debounce":458,"../../../modules/util/isMobileWidth":499,"../image-layer/image-layer.vue":385,"../slider-controls/slider-controls.vue":397,"vue":262,"vue-hot-reload-api":257}],389:[function(require,module,exports){
;(function(){
'use strict';

const ProductParts = require('../product-parts/product-parts.vue');
const StatusBar = require('../status-bar/status-bar.vue');

module.exports = {
    name: 'parts-footer',

    components: {
        ProductParts,
        StatusBar
    },

    props: {
        isDesktop: Boolean,
        isVisible: Boolean
    },

    methods: {
        /**
         * Accepts the assembled images and closes the configurator
         */
        accept() {
            this.$emit('clickDonePartsButton');
        },

        /**
         * Ignores the assembled images and closes the configurator
         */
        cancel() {
            this.$emit('clickCancelPartsButton');
        }
    },

    computed: {
        resources() {
            const {heading, body} = this.$store.getters.resourcePartsFooter;
            const {accept, decline} = this.$store.getters.resourceGlobal;

            return {
                heading: heading,
                body: body,
                accept: accept,
                decline: decline
            };
        },

        shouldShowStatusBar() {
            const productLayers = this.$store.getters.productLayers;

            for (const layer of productLayers) {
                const [pid, cid, id] = layer.split('-');

                if (!this.$store.getters.productParts[pid].categories[cid].options[id].available) {
                    return true;
                }
            }

            return false;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parts-footer",attrs:{"id":"partsFooter"}},[(_vm.isDesktop)?_c('div',{staticClass:"footer-header"},[_c('h3',{domProps:{"innerHTML":_vm._s(_vm.resources.heading)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.resources.body)}})]):_vm._e(),_vm._v(" "),_c('product-parts',{attrs:{"isDesktop":_vm.isDesktop}}),_vm._v(" "),_c('status-bar',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowStatusBar),expression:"shouldShowStatusBar"}]}),_vm._v(" "),_c('div',{staticClass:"button-row"},[_c('button',{staticClass:"btn btn--secondary",on:{"click":function($event){return _vm.cancel()}}},[_vm._v(_vm._s(_vm.resources.decline))]),_vm._v(" "),_c('button',{staticClass:"btn",attrs:{"disabled":_vm.shouldShowStatusBar},on:{"click":function($event){return _vm.accept()}}},[_vm._v(_vm._s(_vm.resources.accept))])])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-15a00bbe", __vue__options__)
  } else {
    hotAPI.reload("data-v-15a00bbe", __vue__options__)
  }
})()}

},{"../product-parts/product-parts.vue":394,"../status-bar/status-bar.vue":398,"vue":262,"vue-hot-reload-api":257}],390:[function(require,module,exports){
'use strict';

const isProduction = "development" === 'production';

const Vue = require('vue');
const VueX = require('vuex');
const VueXStore = require('./product-configurator-store');
const axios = require('axios');
const ProductPageHandler = require('../../product-page-handler');
const addToCart = require('../../pages/product/addToCart');
const configuratorVueEl = '#product-configurator';
const configuratorAppEl = '.js-product-configurator';
const configuratorAppTriggerEl = '.js-product-configurator-trigger';

let configurator = false;
const props = {
    'productId': '',
    'configurationId': '',
    'productConfiguration': '',
    'actionType': '',
    'actionData': ''
};

/**
 * Initialise the global Vue properties.
 */
const initVue = () => {
    Vue.use(VueX);
};

/**
 * Setup eventbus to allow configurator comminication with configurator
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('addConfiguredProductToCart', (data) => {
        const url = window.Urls.addProduct.toString() || '';
        axios.post(
            url,
            {},
            {
                params: {
                    pid: data.product,
                    childPids: Object.keys(data.selectedComponents).map(key => data.selectedComponents[key].id).join(','),
                    personalizedName: data.personalizedName,
                    configurableFlow: true
                }
            }
        ).then((result) => {
            if (data.actionType == 'updatePDP') {
                ProductPageHandler.updatePage(data);
            }
            $('.js-product-image-mobile').attr('data-src', data.primaryImage.src);
            addToCart.updateMiniCartOnAddProduct(result.data, false);
        });
    });

    window.eventBus.$on('configuratorChanged', (data) => {
        let queryString = '';
        switch (data.actionType) {
            // Redirects to a given page and adds the selected configuration as a QueryString
            case 'redirectTo':
                queryString = data.updateData.urlParameterName + '=';
                if (data.updateData && data.updateData.isTalisman) {
                    queryString += String.format(data.updateData.urlParameterValueFormat, data.product,
                        data.selectedComponents.fragrance.id, data.selectedComponents.bottle.id,
                        data.selectedComponents.cap.id, data.selectedComponents.talisman.id);
                } else {
                    queryString += String.format(data.updateData.urlParameterValueFormat, data.product,
                        (data.selectedComponents.fragrance || data.selectedComponents.wax).id,
                        (data.selectedComponents.bottle || data.selectedComponents.candleholder).id);
                }

                location.href = `${data.actionData}?${queryString}`;
                break;

            // Updates the PDP with the selected configuration
            case 'updatePDP':
                ProductPageHandler.updatePage(data);
                break;
            default:
                break;
        }
    });

    window.eventBus.$on('configuratorClosed', () => {
        destroyConfigurator();
    });

    window.onpopstate = () => {
        window.eventBus.$emit('shouldCloseConfigurator');
    };
};

/**
 * Add click events to all triggers on page
 */
const initTriggers = () => {
    $(document).on('click', configuratorAppTriggerEl, onClickTrigger);
};

/**
 * Handles click event on trigger element
 * @param {Event} e Event object
 */
const onClickTrigger = (e) => {
    e.stopPropagation();
    if (isConfiguratorActive()) {
        return false;
    }

    props.productId = $(e.currentTarget).data('product-id');
    props.configurationId = $(e.currentTarget).data('configuration-id');
    props.productConfiguration = $(e.currentTarget).data('product-configuration');
    props.actionType = $(e.currentTarget).data('action-type') || '';
    props.actionData = $(e.currentTarget).data('action-data') || '';

    history.pushState('', '', window.location.href);

    prepareMarkup();
    createConfigurator();
};

/**
 * Prepares the markup for the configurator to be attached to
 */
const prepareMarkup = () => {
    const template = `
        <div id="app-configurator" class="${configuratorAppEl.substr(1)}">
        </div>
    `;

    $('body').append(template);
};

/**
 * Creates the Product Configurator App
 */
const createConfigurator = () => {
    const ProductConfigurator = require('./product-configurator/product-configurator.vue');
    const store = VueXStore.init(VueX);

    configurator = new Vue({
        el: configuratorAppEl,
        store,

        components: {
            ProductConfigurator
        },

        computed: {
            isProduction() {
                return isProduction;
            },

            productId() {
                return props.productId.toString();
            },

            configurationId() {
                return props.configurationId;
            },

            productConfiguration() {
                return JSON.stringify(props.productConfiguration);
            },

            actionType() {
                return props.actionType;
            },

            actionData() {
                return props.actionData;
            }
        },

        template: `
            <product-configurator
                :isProduction="isProduction"
                :productId="productId"
                :configurationId="configurationId"
                :productConfiguration="productConfiguration"
                :actionType="actionType"
                :actionData="actionData">
            </product-configurator>
        `
    });
};

/**
 * Removes the Product Configurator App from the DOM
 */
const destroyConfigurator = () => {
    configurator = false;
    $(configuratorVueEl).remove();
};

/**
 * Tests if we already have a configurator present
 * @returns {Boolean} result of test
 */
const isConfiguratorActive = () => {
    return configurator !== false;
};

/**
 * Tests if the product configurator should init
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $(configuratorAppTriggerEl).length > 0;
};

const productConfiguratorApp = {
    init: () => {
        if (shouldInit()) {
            initVue();
            initEventBus();
            initTriggers();
        }
    }
};

module.exports = productConfiguratorApp;

},{"../../pages/product/addToCart":550,"../../product-page-handler":579,"./product-configurator-store":391,"./product-configurator/product-configurator.vue":392,"axios":5,"vue":262,"vuex":264}],391:[function(require,module,exports){
'use strict';

const productConfiguratorStore = {
    init: (VueX) => {
        const state = {
            snapshots: [],
            footerMode: 'partsFooter',
            fragranceLabel: 'Imperial Rose',
            selectedProductPart: 0,
            savedProductParts: [],
            productLayers: '0-0-0||1-0-0||2-0-0||3-0-0',
            productParts: [],
            resources: {},
            productId: null,
            upsellData: null
        };

        const getters = {
            snapshots: state => state.snapshots,
            footerMode: state => state.footerMode,
            fragranceLabel: state => state.fragranceLabel,
            selectedProductPart: state => state.selectedProductPart,
            savedProductParts: state => state.savedProductParts,
            productLayers: state => state.productLayers.split('||'),
            productParts: state => state.productParts,
            statusMessages: state => state.resources.statusMessages,
            resources: state => state.resources,
            resourceGlobal: state => state.resources.global,
            resourceIntroMessage: state => state.resources.introMessage,
            resourceStatusMessages: state => state.resources.statusMessages,
            resourceProductParts: state => state.resources.productParts,
            resourcePartsFooter: state => state.resources.partsFooter,
            categories: state => state.categories,
            currentProductPart: state => state.productParts[state.selectedProductPart],
            upsellData: state => state.upsellData,
            productId: state => state.productId
        };

        const mutations = {
            addSnapshot(state) {
                state.snapshots.push(state.productLayers);
            },

            useSnapshot(state) {
                state.productLayers = state.snapshots.pop();
            },

            popSnapshot(state) {
                state.snapshots.pop();
            },

            setFooterMode(state, newVal) {
                state.footerMode = newVal;
            },

            setFragranceLabel(state, newVal) {
                state.fragranceLabel = newVal;
            },

            setProductLayers(state, newVal) {
                state.productLayers = newVal.join('||');
            },

            setUpsellData(state, newVal) {
                state.upsellData = newVal;
            },

            setSelectedProductPart(state, newVal) {
                state.selectedProductPart = newVal;
            },

            confirmProductPartSelected(state) {
                if (state.selectedProductPart !== null &&
                    state.selectedProductPart != undefined &&
                    !state.savedProductParts.includes(state.selectedProductPart)) {
                    state.savedProductParts.push(state.selectedProductPart);
                }
            },

            setProductParts(state, newVal) {
                if (!state.productParts) {
                    state.productParts = newVal;
                    return;
                }
                const Vue = require('vue');
                Vue.set(state, 'productParts', newVal);
                state.productParts = newVal;
            },

            setProductId(state, newVal) {
                state.productId = newVal;
            },

            setResources(state, newVal) {
                state.resources = newVal;
            }
        };

        return new VueX.Store({
            state: state,
            getters: getters,
            mutations: mutations
        });
    }
};

module.exports = productConfiguratorStore;

},{"vue":262}],392:[function(require,module,exports){
;(function(){
'use strict';

const ProductIntro = require('../product-intro/product-intro.vue');
const AssembledProduct = require('../assembled-product/assembled-product.vue');
const AssembledProductZoom = require('../assembled-product-zoom/assembled-product-zoom.vue');
const PartsFooter = require('../parts-footer/parts-footer.vue');
const OptionsFooter = require('../options-footer/options-footer.vue');
const ResultFooter = require('../result-footer/result-footer.vue');
const ResultSlider = require('../result-slider/result-slider.vue');
const UpsellFooter = require('../upsell/footer/upsell-footer.vue');

const isMobileWidth = require('../../../modules/util/isMobileWidth');
const isTabletView = require('../../../modules/helpers/isTabletView');
const scrollHelper = require('../../../modules/helpers/scroll');
const axios = require('axios');
const certificateView = require('../../../certificate-view');

module.exports = {
    name: 'product-configurator',

    components: {
        ProductIntro,
        AssembledProduct,
        AssembledProductZoom,
        PartsFooter,
        OptionsFooter,
        ResultFooter,
        ResultSlider,
        UpsellFooter
    },

    props: {
        isProduction: Boolean,
        productId: String,
        configurationId: String,
        productConfiguration: String,
        actionType: String,
        actionData: String
    },

    methods: {
        /**
         * Removes the last entry in the history object added when opening the
         * configurator
         */
        clearLastHistoryState() {
            window.history.back();
        },

        /**
         * Handles the read more onclick emitted from part options component
         */
        onOverlayChange(isVisible) {
            this.isOverlayVisible = isVisible;
        },

        /**
         * Handles the close button click inside the dialog
         */
        onClickCancelDialogButton() {
            this.shouldShowDialog = false;
            this.clearLastHistoryState();
        },

        /**
         * Handles the close button click emitted from the parts footer component
         */
        onClickCancelPartsButton() {
            this.$store.commit('setProductLayers', this.initialProductLayers);
            this.shouldShowConfigurator = false;
            this.clearLastHistoryState();
        },

        /**
         * Handles the done button click emitted from the parts footer component
         */
        onClickDonePartsButton() {
            if (this.shouldShowUpsellPage) {
                this.upsellBackButtonClicked = false;
                this.$store.commit('setFooterMode', 'upsellFooter');
                return;
            }
            this.shouldShowResultScreen = true;
            this.$store.commit('setFooterMode', 'resultFooter');
        },

        onClickDoneUpsellButton() {
            this.shouldShowResultScreen = true;
            this.$store.commit('setFooterMode', 'resultFooter');
        },

        /**
         * Handles the add to cart button click emitted from the result footer
         */
        onClickResultAddToCartButton() {
            const updatePageData = this.updatePageData;
            if (updatePageData.updateData.isTalisman) {
                certificateView.show({callback: function(personalizedName) {
                    this.shouldShowConfigurator = false;
                    this.clearLastHistoryState();

                    updatePageData.personalizedName = personalizedName;

                    setTimeout(() => {
                        window.eventBus.$emit('addConfiguredProductToCart', updatePageData);
                    }, 500);
                }.bind(this)});
                return;
            }
            this.shouldShowConfigurator = false;
            this.clearLastHistoryState();

            setTimeout(() => {
                window.eventBus.$emit('addConfiguredProductToCart', updatePageData);
            }, 500);
        },

        /**
         * Handles the details button click emitted from the result footer
         */
        onClickResultDetailsButton() {
            this.shouldShowConfigurator = false;
            this.clearLastHistoryState();

            setTimeout(() => {
                window.eventBus.$emit('configuratorChanged', this.updatePageData);
            }, 500);
        },

        /**
         * Handles the back button click emitted from the result footer
         */
        onClickResultBackButton() {
            this.shouldShowResultScreen = false;
            this.shouldShowResultFooterButtons = true;

            if (this.shouldShowUpsellPage) {
                this.$store.commit('setFooterMode', 'upsellFooter');
                return;
            }

            this.$store.commit('setFooterMode', 'partsFooter');
        },

        onClickUpsellBackButton() {
            this.upsellBackButtonClicked = true;
            this.shouldShowResultScreen = false;
            this.shouldShowResultFooterButtons = true;

            setTimeout(() => {
                this.$store.commit('setFooterMode', 'partsFooter');
            }, this.isTablet ? 500 : 0);
        },

        /**
         * Handles the back button click emitted from the result slider.
         * We need to tell the parent to tell a child to go and remove the
         * footer buttons.
         */
        onHideResultFooter() {
            this.shouldShowResultFooterButtons = false;
        },

        /**
         * Handles option footer change
         */
        onOptionFooterChange() {
            this.$store.commit('confirmProductPartSelected');
        },

        /**
         * Stores the new styleData for later use
         * @param {Object} styleData Style properties
         */
        onProductStyleSet(styleData) {
            this.initialProductZoomStyle = styleData;
        }
    },

    watch: {
        /**
         * Handles the value changes of shouldShowConfigurator
         * @param {Boolean} newVal The new value
         */
        shouldShowConfigurator(newVal) {
            if (newVal === true) {
                this.initialProductLayers = JSON.parse(JSON.stringify(this.$store.getters.productLayers));
                scrollHelper.disableScroll();

                setTimeout(() => {
                    this.shouldShowBackdrop = true;
                }, 100);

                setTimeout(() => {
                    this.shouldShowProduct = true;
                }, 1100);

                setTimeout(() => {
                    this.shouldShowFooter = true;
                }, 2100);

                setTimeout(() => {
                    this.partsFooterClass = 'invert-direction';
                }, 2400);
            } else {
                scrollHelper.enableScroll();
                this.shouldShowBackdrop = false;

                setTimeout(() => {
                    this.shouldShowFooter = false;
                    this.shouldShowProduct = false;
                    this.shouldShowAssembledProduct = false;
                    this.shouldShowResultScreen = false;
                    this.partsFooterClass = '';

                    // Fire the closeConfigurator event for cleanup
                    window.eventBus.$emit('configuratorClosed');

                    // Remove event so we can re-add it later
                    window.eventBus.$off('shouldCloseConfigurator');
                }, 800);
            }
        }
    },

    computed: {
        shouldShowUpsellPage() {
            return this.$store.getters.upsellData.shouldShowUpsellPage;
        },

        footerMode() {
            return this.$store.getters.footerMode;
        },

        introMessage() {
            return this.$store.getters.resourceIntroMessage;
        },

        dialogResources() {
            return {
                close: window.Resources.CLOSE || 'Close',
                isLoading: window.Resources.CONFIGURATOR_IS_LOADING || '',
                isError: window.Resources.CONFIGURATOR_HAS_ERROR || ''
            };
        },

        shouldShowIntro() {
            return this.shouldShowConfigurator && this.isDataReady && this.shouldShowBackdrop;
        },

        shouldShowPartsFooter() {
            return this.footerMode === 'partsFooter' && this.shouldShowFooter;
        },

        shouldShowUpsellFooter() {
            return this.footerMode === 'upsellFooter' && this.shouldShowFooter;
        },

        shouldShowOptionsFooter() {
            return this.footerMode === 'optionsFooter' && this.shouldShowFooter;
        },

        shouldShowResultFooter() {
            return this.footerMode === 'resultFooter' && this.shouldShowFooter;
        },

        shouldShowAssembledProductImage() {
            if (this.shouldShowUpsellFooter) {
                return true;
            }

            return !this.shouldShowResultScreen;
        },

        shouldShowAssembledProductZoomImage() {
            const isFullScreenFooter = (this.optionTileType === 3 && this.footerMode === 'optionsFooter') ||
                this.shouldShowUpsellFooter ||
                this.shouldShowResultScreen;

            return (this.isDesktop && !this.shouldShowResultScreen) || (!this.isDesktop && !isFullScreenFooter);
        },

        transitionName() {
            let transitionName = 'switch-footers-transition';

            if (this.optionTileType === 3 && !this.isDesktop) {
                transitionName = 'full-height-footer-transition';
            }

            return transitionName;
        },

        optionTileType() {
            return this.$store.getters.currentProductPart.optionTileType;
        },

        queryParams() {
            return {
                product: this.productId,
                ...JSON.parse(this.productConfiguration)
            };
        },

        updatePageData() {
            const productLayers = this.$store.getters.productLayers;
            const productParts = this.$store.getters.productParts;
            const updateData = JSON.parse(JSON.stringify(this.$store.getters.resources.updateData));
            const selectedComponents = {};

            for (const layer of productLayers) {
                const [pid, cid, id] = layer.split('-');
                const productPart = productParts[pid];
                selectedComponents[productPart.resourceId] = productPart.categories[cid].options[id];
            }

            let primaryImage = null;
            if (updateData.isTalisman) {
                primaryImage = updateData.talismanPrimaryImagePlaceholder;
                primaryImage.src = String.format(primaryImage.urlFormat, selectedComponents.bottle.EAN, selectedComponents.fragrance.EAN,
                    selectedComponents.talisman.EAN, selectedComponents.cap.EAN);
            } else {
                primaryImage = (selectedComponents.bottle || selectedComponents.candleholder).image;
            }

            let actionType = this.actionType;
            let actionData = this.actionData;
            if (this.shouldShowUpsellPage && !this.isOriginalProduct) {
                const selectedProductOption = this.$store.getters.upsellData.products.find(option => option.id === this.$store.getters.productId);
                actionType = selectedProductOption.actionType;
                actionData = selectedProductOption.actionData;
            }

            return {
                selectedComponents: JSON.parse(JSON.stringify(selectedComponents)),
                product: this.$store.getters.productId,
                actionType: actionType,
                actionData: actionData,
                configurationId: this.configurationId,
                primaryImage: primaryImage,
                upsellPageExists: this.shouldShowUpsellPage,
                updateData: updateData
            };
        },
        isOriginalProduct() {
            return this.productId === this.$store.getters.productId;
        }
    },

    created() {
        window.eventBus.$on('shouldCloseConfigurator', () => {
            this.shouldShowConfigurator = false;
        });
    },

    mounted() {
        const url = Urls.getConfigurableProduct;

        this.dialogMessage = this.dialogResources.isLoading;
        this.dialogTimer = setTimeout(() => {
            this.shouldShowDialog = true;
        }, 3000);

        axios.get(url, {
                timeout: 10000,
                params: this.queryParams
            })
            .then((resp) => {
                clearTimeout(this.dialogTimer);

                this.$store.commit('setProductId', this.productId);
                this.$store.commit('setProductParts', resp.data.productParts);
                this.$store.commit('setResources', resp.data.resources);
                this.$store.commit('setProductLayers', resp.data.productLayers);
                this.$store.commit('setUpsellData', resp.data.upsellData);
                this.shouldShowDialog = false;
                this.isDataReady = true;
            })
            .then(() => {
                this.shouldShowConfigurator = true;
            })
            .catch((error) => {
                this.dialogMessage = this.dialogResources.isError;
                this.shouldShowDialog = true;
                this.clearLastHistoryState();
                if (!this.isProduction) {
                    console.debug(error.toJSON());
                }
            });
    },

    data() {
        return {
            isDataReady: false,
            isMobile: isMobileWidth(),
            isTablet: isTabletView(),
            isDesktop: !(isMobileWidth() || isTabletView()),
            isOverlayVisible: false,
            initialProductZoomStyle: 0,
            partsFooterClass: '',
            dialogTimer: null,
            upsellBackButtonClicked: false,
            shouldShowDialog: false,
            shouldShowFooter: false,
            shouldShowProduct: false,
            shouldShowResultScreen: false,
            shouldShowUpsellScreen: false,
            shouldShowResultFooterButtons: true,
            shouldShowAssembledProduct: false,
            shouldShowBackdrop: false,
            shouldShowConfigurator: false,
            initialProductLayers: '',
            dialogMessage: ''
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"product-configurator-transition"}},[(_vm.isDataReady)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowConfigurator),expression:"shouldShowConfigurator"}],staticClass:"product-configurator",attrs:{"id":"product-configurator"}},[(_vm.shouldShowIntro)?_c('product-intro',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.introMessage)}})]):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowProduct),expression:"shouldShowProduct"}],staticClass:"scene"},[_c('assembled-product-zoom',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowAssembledProductZoomImage),expression:"shouldShowAssembledProductZoomImage"}],attrs:{"isDesktop":_vm.isDesktop,"productZoomStyle":_vm.initialProductZoomStyle}}),_vm._v(" "),_c('transition',{attrs:{"name":"assembled-product-transition"}},[(_vm.shouldShowAssembledProductImage)?_c('assembled-product',{attrs:{"isVisible":_vm.shouldShowProduct,"isTablet":_vm.isTablet,"isDesktop":_vm.isDesktop,"isOverlayVisible":_vm.isOverlayVisible,"isUpsellScreen":_vm.shouldShowUpsellFooter},on:{"productStyleSet":_vm.onProductStyleSet,"clickBackButton":_vm.onClickUpsellBackButton}}):_vm._e(),_vm._v(" "),(_vm.shouldShowResultScreen)?_c('result-slider',{attrs:{"isDesktop":_vm.isDesktop},on:{"shouldHideResultFooter":_vm.onHideResultFooter,"clickBackButton":_vm.onClickResultBackButton}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transitionName}},[(_vm.shouldShowUpsellFooter)?_c('upsell-footer',{key:"upsellFooter",class:_vm.partsFooterClass,attrs:{"isMobile":_vm.isMobile,"isTablet":_vm.isTablet,"isDesktop":_vm.isDesktop,"upsellBackButtonClicked":_vm.upsellBackButtonClicked},on:{"clickDonePartsButton":_vm.onClickDoneUpsellButton}}):_vm._e(),_vm._v(" "),(_vm.shouldShowPartsFooter)?_c('parts-footer',{key:"partsFooter",class:_vm.partsFooterClass,attrs:{"isDesktop":_vm.isDesktop},on:{"clickCancelPartsButton":_vm.onClickCancelPartsButton,"clickDonePartsButton":_vm.onClickDonePartsButton}}):_vm._e(),_vm._v(" "),(_vm.shouldShowOptionsFooter)?_c('options-footer',{key:"optionsFooter",attrs:{"isMobile":_vm.isMobile,"isTablet":_vm.isTablet,"isDesktop":_vm.isDesktop},on:{"overlayChange":_vm.onOverlayChange,"optionFooterChange":_vm.onOptionFooterChange}}):_vm._e(),_vm._v(" "),(_vm.shouldShowResultFooter)?_c('result-footer',{key:"resultFooter",attrs:{"isDesktop":_vm.isDesktop,"shouldShowButtons":_vm.shouldShowResultFooterButtons},on:{"clickDetails":_vm.onClickResultDetailsButton,"clickAddToCart":_vm.onClickResultAddToCartButton}}):_vm._e()],1),_vm._v(" "),_c('transition',{attrs:{"name":"footer-backdrop-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isDesktop && _vm.shouldShowFooter),expression:"isDesktop && shouldShowFooter"}],staticClass:"backdrop"})])],1),_vm._v(" "),_c('transition',{attrs:{"name":"backdrop-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowBackdrop),expression:"shouldShowBackdrop"}],staticClass:"backdrop"})]),_vm._v(" "),_c('transition',{attrs:{"name":"scrim-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowBackdrop),expression:"shouldShowBackdrop"}],staticClass:"scrim"})])],1):_vm._e(),_vm._v(" "),(_vm.shouldShowDialog)?_c('div',{staticClass:"product-configurator has-dialog",attrs:{"id":"product-configurator"}},[_c('transition',{attrs:{"name":"dialog-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowDialog),expression:"shouldShowDialog"}],staticClass:"dialog"},[_c('button',{staticClass:"icon-close",attrs:{"type":"button"},on:{"click":_vm.onClickCancelDialogButton}},[_c('span',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.dialogResources.close))])]),_vm._v(" "),_c('p',[_vm._v("\n                    "+_vm._s(_vm.dialogMessage)+"\n                ")]),_vm._v(" "),(_vm.isMobile)?_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":_vm.onClickCancelDialogButton}},[_vm._v("\n                    "+_vm._s(_vm.dialogResources.close)+"\n                ")]):_vm._e(),_vm._v(" "),(!_vm.isMobile)?_c('button',{staticClass:"btn btn--secondary",attrs:{"type":"button"},on:{"click":_vm.onClickCancelDialogButton}},[_vm._v("\n                    "+_vm._s(_vm.dialogResources.close)+"\n                ")]):_vm._e()])]),_vm._v(" "),_c('transition',{attrs:{"name":"scrim-dialog-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowDialog),expression:"shouldShowDialog"}],staticClass:"scrim",on:{"click":_vm.onClickCancelDialogButton}})])],1):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6b7bb801", __vue__options__)
  } else {
    hotAPI.reload("data-v-6b7bb801", __vue__options__)
  }
})()}

},{"../../../certificate-view":280,"../../../modules/helpers/isTabletView":472,"../../../modules/helpers/scroll":475,"../../../modules/util/isMobileWidth":499,"../assembled-product-zoom/assembled-product-zoom.vue":383,"../assembled-product/assembled-product.vue":384,"../options-footer/options-footer.vue":386,"../parts-footer/parts-footer.vue":389,"../product-intro/product-intro.vue":393,"../result-footer/result-footer.vue":395,"../result-slider/result-slider.vue":396,"../upsell/footer/upsell-footer.vue":399,"axios":5,"vue":262,"vue-hot-reload-api":257}],393:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'product-intro',

    watch: {
        shouldShow(newVal) {
            if (newVal === true) {
                this.animateIntro = true;

                // Set a timeout for 2nd part of animation
                setTimeout(() => {
                    this.animateIntro = false;
                }, 1900);

                // Set a timeout to hide the intro after 2nd animation is done
                setTimeout(() => {
                    this.introActive = false;
                }, 2700);
            } else {
                this.animateIntro = false;
                this.introActive = true;
            }
        }
    },

    created() {
        this.shouldShow = true;
    },

    data() {
        return {
            animateIntro: false,
            shouldShow: false,
            introActive: true
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.introActive),expression:"introActive"}],staticClass:"intro"},[_c('transition',{attrs:{"name":"intro-text-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.animateIntro),expression:"animateIntro"}],staticClass:"intro-text"},[_c('p',[_vm._t("default")],2)])]),_vm._v(" "),_c('transition',{attrs:{"name":"intro-backdrop-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.animateIntro),expression:"animateIntro"}],staticClass:"backdrop"})])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2bc73dbf", __vue__options__)
  } else {
    hotAPI.reload("data-v-2bc73dbf", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],394:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'product-parts',

    props: {
        isDesktop: Boolean
    },

    methods: {
        /**
         * Updates the store based on selected part index
         * @param {Number} idx Number of selected part
         */
        select(idx) {
            this.$store.commit('addSnapshot');
            this.$store.commit('setSelectedProductPart', idx);
            this.$store.commit('setFooterMode', 'optionsFooter');
        },

        /**
         * Calculates the selected part name based on selected part depth
         * @param {Number} depth Depth of selected part
         * @returns {String} Name of part
         */
        getPartName(depth) {
            const [pid, cid, id] = this.$store.getters.productLayers[depth].split('-');
            const shouldShowCategory = this.parts[pid].showCategoryinOptionName;
            const optionName = this.parts[pid].categories[cid].options[id].name;
            const categoryName = this.parts[pid].categories[cid].name;

            return optionName + (shouldShowCategory ? ' ' + categoryName : '');
        },

        /**
         * Calculates the selected part availability based on selected part depth
         * @param {Number} depth Depth of selected part
         * @returns {Boolean} Availability of part
         */
        isPartAvailable(depth) {
            const [pid, cid, id] = this.$store.getters.productLayers[depth].split('-');
            return this.parts[pid].categories[cid].options[id].available;
        },

        /**
         * Checks if a configuration setting is changed and changes the icon color accordingly
         * @param {*} idx Number of selected part
         */
        isPartSelected(idx) {
            return this.$store.getters.savedProductParts.includes(idx);
        }
    },

    computed: {
        parts() {
            return this.$store.getters.productParts;
        },

        resources() {
            return {
                notInStockLong: this.$store.getters.resourceGlobal.notInStockLong
            };
        }
    },

    data() {
        return {
            selectedPart: 'Selected Part'
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-parts"},[_c('ul',_vm._l((_vm.parts),function(part,idx){return _c('li',[_c('a',{class:{ 'icon-selected': _vm.isPartSelected(idx) },attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.select(idx)}}},[_c('span',{staticClass:"icon-holder"},[_c('span',{class:'icon ' + part.icon}),_vm._v(" "),(!_vm.isPartAvailable(part.depth) && !_vm.isDesktop)?_c('span',{staticClass:"error-badge"}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"part-name"},[_vm._v(_vm._s(part.name))]),_vm._v(" "),(_vm.isDesktop)?_c('span',{staticClass:"selected-part"},[_vm._v(_vm._s(_vm.getPartName(part.depth)))]):_vm._e(),_vm._v(" "),(!_vm.isPartAvailable(part.depth) && _vm.isDesktop)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.resources.notInStockLong))]):_vm._e()])])}),0)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-a74ed0b2", __vue__options__)
  } else {
    hotAPI.reload("data-v-a74ed0b2", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],395:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'result-footer',

    props: {
        isDesktop: Boolean,
        shouldShowButtons: Boolean
    },

    methods: {
        /**
         * Start cleanup animations and emits event to parent and trigger add to cart logic
         */
        onClickAddToCart() {
            setTimeout(() => {
                this.$emit('clickAddToCart');
            }, this.isDesktop ? 0 : 15);
        },

        /**
         * Start cleanup animations and emits event to parent
         */
         onClickDetails() {
            this.shouldShowButtonRow = false;

            setTimeout(() => {
                this.$emit('clickDetails');
                this.$store.commit('setFooterMode', 'partsFooter');
            }, this.isDesktop ? 0 : 15);
        }
    },

    watch: {
        shouldShowButtons(val) {
            if (val === false) {
                this.shouldShowButtonRow = false;
            }
        }
    },

    computed: {
        resources() {
            return {
                ...this.$store.getters.resourceGlobal,
                bundlePrice: this.$store.getters.resources.updateData.bundlePrice,
                bundleUSP: this.$store.getters.resources.updateData.bundleUSP,
                unitBasePrice: this.$store.getters.resources.updateData.unitBasePrice
            };
        },

        customizedHeading() {
            const [depth, cid, id] = this.$store.getters.productLayers[0].split('-');
            return this.$store.getters.productParts[depth].categories[cid].options[id].stickyBarTitle;
        }
    },

    mounted() {
        setTimeout(() => {
            this.shouldShowButtonRow = true;
        }, this.isDesktop ? 0 : 200);
    },

    data() {
        return {
            shouldShowButtonRow: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-footer",attrs:{"id":"resultFooter"}},[_c('div',{staticClass:"product-description"},[_c('div',{staticClass:"product-info-column product-info-column-details"},[_c('div',{staticClass:"product-info-content"},[_c('span',{staticClass:"result-label"},[_vm._v(_vm._s(_vm.resources.resultHeading))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.customizedHeading))]),_vm._v(" "),(_vm.isDesktop)?_c('p',[_vm._v(_vm._s(_vm.resources.bundleUSP))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"product-info-footer"},[_c('div',{staticClass:"product-price"},[_c('div',{staticClass:"prices-container"},[_c('span',{staticClass:"price-sales"},[_vm._v("\n                                "+_vm._s(_vm.resources.bundlePrice.formattedSale)+"\n                            ")]),_vm._v(" "),(_vm.resources.unitBasePrice)?_c('span',{staticClass:"unit-base-price"},[_vm._v("\n                                "+_vm._s(_vm.resources.vatIncluded)+"\n                                "+_vm._s(_vm.resources.unitBasePriceLabel)+"\n                                "+_vm._s(_vm.resources.unitBasePrice.original_volume)+"\n                                "+_vm._s(_vm.resources.unitBasePrice.base_price_text)+"\n                            ")]):_vm._e()])]),_vm._v(" "),_c('button',{class:['btn', {'active': !_vm.isDesktop && _vm.shouldShowButtonRow}],attrs:{"type":"submit"},on:{"click":_vm.onClickAddToCart}},[_vm._v("\n                        "+_vm._s(_vm.resources.addToCart)+"\n                    ")]),_vm._v(" "),_c('button',{class:['btn', 'btn--secondary', {'active': !_vm.isDesktop && _vm.shouldShowButtonRow}],attrs:{"type":"submit"},on:{"click":_vm.onClickDetails}},[_vm._v("\n                        "+_vm._s(_vm.resources.details)+"\n                    ")])])])])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-009c0c79", __vue__options__)
  } else {
    hotAPI.reload("data-v-009c0c79", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],396:[function(require,module,exports){
;(function(){
'use strict';

const SliderControls = require('../slider-controls/slider-controls.vue');
const VueSlickCarousel = require('../../../../../node_modules/vue-slick-carousel');
const ImageLayer = require('../image-layer/image-layer.vue');

module.exports = {
    name: 'result-slider',

    components: {
        SliderControls,
        VueSlickCarousel,
        ImageLayer
    },

    props: {
        isDesktop: Boolean
    },

    methods: {
        /**
         * Handles the back button click and emits event to parent
         */
         onClickBack() {
            this.$emit('shouldHideResultFooter');
            setTimeout(() => {
                this.$emit('clickBackButton');
            }, this.isDesktop ? 0 : 15);
        },

        /**
         * Handles click on left arrow
         */
         onClickArrowLeft() {
            this.$refs.resultCarousel.prev();
        },

        /**
         * Handles click on right arrow
         */
        onClickArrowRight() {
            this.$refs.resultCarousel.next();
        },

        /**
         * Handles event that fires before slides are changed
         * @param {Number} oldIdx Index of old slide
         * @param {Number} newIdx Index of new slide
         */
        onBeforeChange(oldIdx, newIdx) {
            this.currentSlide = newIdx;
        },

        /**
         * Sets the left position of the slider indicator
         */
        setIndicatorLeft() {
            this.indicatorLeft = this.indicatorWidth * this.currentSlide;
        },

        /**
         * Sets the width of the slider indicator
         */
        setIndicatorWidth() {
            const activeDotEl = this.$refs.resultCarousel.$root.$el.querySelector('.slick-dots .slick-active');
            const activeDotRect = (activeDotEl) ? activeDotEl.getBoundingClientRect() : '';
            this.indicatorWidth = (activeDotEl) ? activeDotRect.width : 0;
        }
    },

    watch: {
        currentSlide() {
            this.setIndicatorLeft();
        }
    },

    computed: {
        images() {
            const allImages = [];
            const productParts = this.$store.getters.productParts;
            const productLayers = this.$store.getters.productLayers;

            if (this.$store.getters.resources.updateData.isTalisman) {
                const selectedVariantsEANs = {};
                productLayers.forEach((layer) => {
                    const [pid, cid, id] = layer.split('-');
                    const categories = productParts[pid].categories;
                    selectedVariantsEANs[productParts[pid].resourceId] = categories[cid].options[id].EAN;
                });

                for (const placeholder of Object.values(this.$store.getters.resources.updateData.talismanImagePlaceholders)) {
                    placeholder.src = String.format(placeholder.urlFormat, selectedVariantsEANs.bottle, selectedVariantsEANs.fragrance,
                        selectedVariantsEANs.talisman, selectedVariantsEANs.cap);
                    allImages.push(placeholder);
                }

                return allImages;
            }

            const [depth, cid, id] = productLayers[1].split('-');
            const presentationComponent = productParts[depth].categories[cid].options[id];
            allImages.push(presentationComponent.howToUseImage);
            allImages.push(presentationComponent.productLifestyleImage);

            for (const image of Object.values(presentationComponent.primaryAndSecondaryImages)) {
                allImages.push(image);
            }

            return allImages;
        }
    },

    mounted() {
        this.setIndicatorLeft();
        this.setIndicatorWidth();
        this.showLeftArrow = this.showRightArrow = this.images.length > 1;
    },

    data() {
        return {
            currentSlide: 0,
            indicatorLeft: 0,
            indicatorWidth: 0,
            showLeftArrow: true,
            showRightArrow: true,
            sliderSettings: {
                arrows: false,
                centerPadding: '0',
                dots: true,
                infinite: true,
                touchThreshold: 500,
                responsive: [{
                    breakpoint: 1024,
                    settings: {
                        centerMode: true,
                        centerPadding: '20%',
                        focusOnSelect: true,
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }, {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                        centerPadding: '14%',
                        focusOnSelect: true,
                        slidesToShow: 1,
                        speed: 150,
                        swipe: true
                    }
                }],
                slidesToShow: 1,
                swipe: false,
                waitForAnimate: false
            }
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"result-slider-wrapper"},[_c('button',{staticClass:"icon-arrow3--left restart-button fixed",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickBack()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move back")])]),_vm._v(" "),_c('div',{ref:"resultSlider",staticClass:"result-slider"},[_c('div',{staticClass:"configured-product"},[_c('VueSlickCarousel',_vm._b({ref:"resultCarousel",on:{"beforeChange":_vm.onBeforeChange}},'VueSlickCarousel',_vm.sliderSettings,false),_vm._l((_vm.images),function(image,idx){return _c('image-layer',{attrs:{"wrapperClass":(idx === _vm.currentSlide) ? 'result-slider-image selected' : 'result-slider-image',"image":image}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"configurator-slider-indicator"},[_c('span',{staticClass:"configurator-current-slide",style:('left: ' + _vm.indicatorLeft + 'px; width: ' + _vm.indicatorWidth + 'px')})]),_vm._v(" "),_c('slider-controls',{attrs:{"showLeftArrow":_vm.showLeftArrow,"showRightArrow":_vm.showRightArrow,"showArrowBackground":true},on:{"clickArrowLeft":function($event){return _vm.onClickArrowLeft()},"clickArrowRight":function($event){return _vm.onClickArrowRight()}}})],1)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2aa70af6", __vue__options__)
  } else {
    hotAPI.reload("data-v-2aa70af6", __vue__options__)
  }
})()}

},{"../../../../../node_modules/vue-slick-carousel":260,"../image-layer/image-layer.vue":385,"../slider-controls/slider-controls.vue":397,"vue":262,"vue-hot-reload-api":257}],397:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'slider-controls',

    props: {
        showLeftArrow: {
            type: Boolean,
            default: true
        },

        showRightArrow: {
            type: Boolean,
            default: true
        },

        showArrowBackground: {
            type: Boolean,
            default: false
        }
    },

    methods: {
        /**
         * Handle click event left arrow
         */
        onClickArrowLeft() {
            this.$emit('clickArrowLeft');
        },

        /**
         * Handle click event left arrow
         */
        onClickArrowRight() {
            this.$emit('clickArrowRight');
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"configurator-slider-controls"},[_c('button',{class:['icon-arrow3--left', 'slider-button', {'hidden': !_vm.showLeftArrow}, {'has-background': _vm.showArrowBackground}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickArrowLeft()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move to left")])]),_vm._v(" "),_c('button',{class:['icon-arrow3--right', 'slider-button', {'hidden': !_vm.showRightArrow}, {'has-background': _vm.showArrowBackground}],attrs:{"type":"button"},on:{"click":function($event){return _vm.onClickArrowRight()}}},[_c('span',{staticClass:"sr-only"},[_vm._v("Move to right")])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-40fbfd27", __vue__options__)
  } else {
    hotAPI.reload("data-v-40fbfd27", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],398:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'status-bar',

    props: {
        message: {
            type: String,
            default: ''
        }
    },

    computed: {
        productLayers() {
            return this.$store.getters.productLayers;
        },
        parts() {
            return this.$store.getters.productParts;
        },
        status() {
            if (this.message && (this.message.length > 0)) {
                return this.message;
            }

            let firstOutOfStockFound = false;
            let unavailableOptionMessage = '';

            for (let index = 0; index < this.productLayers.length; index++) {
                const [pid, cid, id] = this.productLayers[index].split('-');
                const currentOption = this.parts[pid].categories[cid].options[id];
                const part = this.parts[pid];
                if (currentOption.available) {
                    continue;
                }
                if (!firstOutOfStockFound) {
                    firstOutOfStockFound = true;
                    unavailableOptionMessage = this.$store.getters.resourceGlobal.unavailableCustomConfiguration + ' ' + part.resourceName.toLowerCase();
                    continue;
                }
                return this.$store.getters.resourceGlobal.unavailableCustomisation;
            }

            return unavailableOptionMessage;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"status-bar"},[_c('p',[_vm._v(_vm._s(_vm.status))])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-18af52e1", __vue__options__)
  } else {
    hotAPI.reload("data-v-18af52e1", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],399:[function(require,module,exports){
;(function(){
'use strict';

const UpsellPage = require('../page/upsell-page.vue');

module.exports = {
    props: {
        isMobile: Boolean,
        isTablet: Boolean,
        isDesktop: Boolean,
        upsellBackButtonClicked: Boolean
    },

    components: {
        UpsellPage
    },

    computed: {
        resources() {
            return this.$store.getters.upsellData.resources;
        }
    },

    methods: {
        handleFinish() {
            this.shouldShowHeader = this.isTablet ? false : true;

            setTimeout(() => {
                this.$emit('clickDonePartsButton');
            }, this.isTablet ? 800 : 0);
        }
    },

    watch: {
        upsellBackButtonClicked(newVal) {
            this.shouldShowHeader = this.isTablet ? newVal === false : true;
        }
    },

    mounted() {
        this.shouldShowHeader = true;
    },

    data() {
        return {
            shouldShowHeader: false
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"upsellFooter",staticClass:"options-footer upsell-footer full-height-footer",attrs:{"id":"upsellFooter"}},[_c('transition',{attrs:{"name":"footer-header-transition"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowHeader),expression:"shouldShowHeader"}],staticClass:"footer-header"},[_c('h3',[_vm._v(_vm._s(_vm.resources.heading))])])]),_vm._v(" "),_c('upsell-page',{attrs:{"isDesktop":_vm.isDesktop,"isMobile":_vm.isMobile}}),_vm._v(" "),_c('div',{staticClass:"button-row single-button"},[_c('button',{staticClass:"btn",attrs:{"disabled":_vm.shouldShowStatusBar},on:{"click":function($event){return _vm.handleFinish()}}},[_vm._v(_vm._s(_vm.resources.finishedCta))])])],1)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-7b1faddb", __vue__options__)
  } else {
    hotAPI.reload("data-v-7b1faddb", __vue__options__)
  }
})()}

},{"../page/upsell-page.vue":400,"vue":262,"vue-hot-reload-api":257}],400:[function(require,module,exports){
;(function(){
'use strict';

const ProductTile = require('../product-tile/product-tile.vue');

module.exports = {
    props: {
        isMobile: Boolean,
        isDesktop: Boolean
    },
    components: {
        ProductTile
    },
    computed: {
        upsellData() {
            return this.$store.getters.upsellData;
        }
    },
    methods: {
        setSelected(product) {
            this.$store.commit('setProductId', product.id);
            this.$store.commit('setProductParts', product.productParts);
            this.$store.commit('setResources', product.resources);
        },
        isSelected(selectedProductId) {
            return this.$store.getters.productId === selectedProductId;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upsell-options"},[_c('ul',_vm._l((_vm.upsellData.products),function(product){return _c('li',[_c('product-tile',{key:product.id,attrs:{"product":product,"isMobile":_vm.isMobile}})],1)}),0)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-37278ec3", __vue__options__)
  } else {
    hotAPI.reload("data-v-37278ec3", __vue__options__)
  }
})()}

},{"../product-tile/product-tile.vue":401,"vue":262,"vue-hot-reload-api":257}],401:[function(require,module,exports){
;(function(){
'use strict';

const TalismanProductTile = require('./talisman/product-tile.vue');

module.exports = {
    props: {
        isMobile: Boolean,
        product: Object
    },
    computed: {
        upsellData() {
            return this.$store.getters.upsellData;
        },
        upsellProductTileType() {
            switch (this.upsellData.productType){
                case 'talisman':
                    return TalismanProductTile;
                default:
                    return;
            }
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.upsellProductTileType,{tag:"component",attrs:{"product":_vm.product,"isMobile":_vm.isMobile}})}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6d5f208b", __vue__options__)
  } else {
    hotAPI.reload("data-v-6d5f208b", __vue__options__)
  }
})()}

},{"./talisman/product-tile.vue":402,"vue":262,"vue-hot-reload-api":257}],402:[function(require,module,exports){
;(function(){
'use strict';

const damHelper = require('../../../../../dam/dam-helper');

module.exports = {
    props: {
        isMobile: Boolean,
        product: Object
    },
    computed: {
        productName() {
            const [depth, cid, id] = this.$store.getters.productLayers[0].split('-');
            return this.product.productParts[depth].categories[cid].options[id].title;
        },
        productImage() {
            const productLayers = this.$store.getters.productLayers;
            const productParts = this.$store.getters.productParts;
            const selectedComponents = {};
            // const primaryImage = this.product.resources.updateData.talismanPrimaryImagePlaceholder;
            const primaryImage = this.product.resources.updateData.talismanImagePlaceholders.secondaryImageThird;

            for (const layer of productLayers) {
                const [pid, cid, id] = layer.split('-');
                const productPart = productParts[pid];
                selectedComponents[productPart.resourceId] = productPart.categories[cid].options[id];
            }

            primaryImage.src = String.format(
                primaryImage.urlFormat,
                selectedComponents.bottle.EAN,
                selectedComponents.fragrance.EAN,
                selectedComponents.talisman.EAN,
                selectedComponents.cap.EAN
            );

            return primaryImage;
        },
        resources() {
            return {
                ...this.$store.getters.resourceGlobal,
                bundlePrice: this.product.resources.updateData.bundlePrice,
                bundleUSP: this.product.resources.updateData.bundleUSP,
                unitBasePrice: this.product.resources.updateData.unitBasePrice
            };
        },
        selected() {
            return this.$store.getters.productId === this.product.id;
        }
    },
    methods: {
        setSelected() {
            this.$store.commit('setProductId', this.product.id);
            this.$store.commit('setProductParts', this.product.productParts);
            this.$store.commit('setResources', this.product.resources);
        }
    },
    mounted() {
        if (this.isMobile) {
            damHelper.updateImages(this.$refs.upsellImageLayer);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upsell-option"},[(_vm.isMobile)?_c('figure',{ref:"upsellImageLayer"},[_c('img',{class:_vm.productImage.class,attrs:{"alt":"","src":_vm.productImage.placeholder,"data-src":_vm.productImage.src,"data-width":_vm.productImage.width}})]):_vm._e(),_vm._v(" "),_c('label',{class:{'selected': _vm.selected},attrs:{"for":'upsell-product-' + _vm.product.id}},[_c('span',{staticClass:"upsell-product-title",domProps:{"innerHTML":_vm._s(_vm.productName)}}),_vm._v(" "),_c('span',{staticClass:"upsell-product-description"},[_vm._v(_vm._s(_vm.product.description))]),_vm._v(" "),_c('div',{staticClass:"upsell-product-price"},[_c('span',[_vm._v("\n                "+_vm._s(_vm.resources.bundlePrice.formattedSale)+"\n            ")]),_vm._v(" "),(_vm.resources.unitBasePrice)?_c('span',[_vm._v("\n                "+_vm._s(_vm.resources.vatIncluded)+"\n                "+_vm._s(_vm.resources.unitBasePriceLabel)+"\n                "+_vm._s(_vm.resources.unitBasePrice.original_volume)+"\n                "+_vm._s(_vm.resources.unitBasePrice.base_price_text)+"\n            ")]):_vm._e()])]),_vm._v(" "),_c('input',{attrs:{"type":"radio","name":"product-option","id":'upsell-product-' + _vm.product.id,"disabled":!_vm.product.available},domProps:{"value":_vm.product.id,"checked":_vm.selected},on:{"click":function($event){return _vm.setSelected()}}}),_vm._v(" "),(!_vm.product.available)?_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(_vm.resources.notInStockShort))]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-8753468a", __vue__options__)
  } else {
    hotAPI.reload("data-v-8753468a", __vue__options__)
  }
})()}

},{"../../../../../dam/dam-helper":419,"vue":262,"vue-hot-reload-api":257}],403:[function(require,module,exports){
;(function(){
'use strict';

const damHelper = require('../../../dam/dam-helper');
const gtm = require('../../../modules/google').tagManager;

module.exports = {
    name: 'product-choice-list',
    props: {
        products: Array,
        resources: Object,
        selectedID: String,
        onProductPicked: {
            type: Function,
            default: () => undefined
        }
    },
    methods: {
        onProductSelected(option) {
            this.selectedProductID = option.productID;
            this.selectedProduct = option;
        },
        productPicked() {
            this.onProductPicked(this.selectedProductID);
            window.eventBus.$emit('shouldCloseFlyin');
            pushAnalyticsData(this.products[0].analyticsData);
            gtm.pushGwpEvent('choose your gift', this.selectedProduct.productName);
        }
    },
    mounted() {
        damHelper.updateImages(this.$refs.productChoiceOptions);
    },
    updated() {
        damHelper.updateImages(this.$refs.productChoiceOptions);
    },
    data() {
        return {
            selectedProductID: this.selectedID || this.products[0].productID
        };
    }
};

function pushAnalyticsData(analyticsData) {
    const analyticsDataObject = JSON.parse(analyticsData);
    const data = {
        'event': 'addToCartGift',
        'currencyCode': analyticsDataObject.currencyCode,
        'gift': analyticsDataObject.productData,
        'gift_type': analyticsDataObject.promotionName || 'promotional'
    };

    gtm.pushDataLayerEvent(data);
}

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-choice-list"},[_c('div',{staticClass:"product-choice-scroll"},[_c('header',{staticClass:"product-choice-header"},[_c('h2',[_vm._v(_vm._s(_vm.resources.title))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.resources.subtitle))])]),_vm._v(" "),_c('div',{ref:"productChoiceOptions",staticClass:"product-choice-options"},_vm._l((_vm.products),function(option){return _c('div',{key:option.productID,class:['input-type-radio', {'chosen': _vm.selectedProductID === option.productID}]},[_c('input',{attrs:{"type":"radio","id":option.productID,"name":'bonusChoiceProducts'},domProps:{"value":option.productID,"checked":_vm.selectedProductID === option.productID},on:{"click":function($event){return _vm.onProductSelected(option)}}}),_vm._v(" "),_c('label',{staticClass:"vue-form-group-label",attrs:{"for":option.productID}},[_c('span',{staticClass:"option-ritual"},[_vm._v("\n                        "+_vm._s(option.productHeading)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"option-title"},[_vm._v("\n                        "+_vm._s(option.productName)+"\n                    ")]),_vm._v(" "),_c('img',{class:option.productImageClass,attrs:{"src":option.productImagePlaceholder,"alt":option.productImageAlt,"data-src":option.productImageUrl}})])])}),0)]),_vm._v(" "),_c('footer',{staticClass:"product-choice-footer"},[_c('a',{staticClass:"btn",attrs:{"title":_vm.resources.cta},on:{"click":function($event){return _vm.productPicked()}}},[_vm._v("\n            "+_vm._s(_vm.resources.cta)+"\n        ")])])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2ac8da68", __vue__options__)
  } else {
    hotAPI.reload("data-v-2ac8da68", __vue__options__)
  }
})()}

},{"../../../dam/dam-helper":419,"../../../modules/google":453,"vue":262,"vue-hot-reload-api":257}],404:[function(require,module,exports){
;(function(){
'use strict';

const mapState = require('vuex').mapState;
const CheckoutSubmitHandler = require('../../checkout/checkout-submit-handler');
const axios = require('axios');
const socialCommerce = require('../../../social-commerce/social-commerce');

module.exports = {

    mixins: [CheckoutSubmitHandler],

    data() {
        return {
            showSpinner: false,
            showCheckmark: false,
            showButton: !!Object.keys(this.$store.state.socialCommerceData).length
        };
    },

    computed: {
        ...mapState('socialCommerceData', [
            'resources',
            'sendCheckoutLinkEndpointUrl',
            'checkoutLinkConfig'
        ])
    },

    methods: {
        async onClickSendCheckoutLink() {
            if (this.showCheckmark) {
                return;
            }

            this.toggleSpinner(true);

            if (this.checkIfAllBlocksAreValid() && !this.hasSavedAddress) {
                await this.$store.dispatch('details/postForms', true);
            }

            const promise = $.Deferred();
            // Validate platform type and send order overview if "phone" or "email".
            if (this.checkoutLinkConfig.shouldSendOrderOverview) {
                socialCommerce.handleImageSending(this.checkoutLinkConfig.data, this.toggleSpinner)
                    .then(() => { promise.resolve(); });
            } else {
                promise.resolve();
            }

            // Always send checkout link.
            $.when(promise).always(() => {
                axios.get(this.sendCheckoutLinkEndpointUrl, {
                    timeout: 200000,
                    params: {
                        url: window.location.href,
                    }
                }).then((response) => {
                    if (response.data.error) {
                        this.toggleSpinner(false);
                        socialCommerce.errorView.show(response.data, () => {
                            this.onClickSendCheckoutLink();
                        });
                        return;
                    }

                    this.toggleSpinner(true, true);
                });
            });
        },
        toggleSpinner(showSpinner, shouldShowCheckmark) {
            this.showSpinner = false;
            this.showCheckmark = false;
            if (!showSpinner) {
                return;
            }

            if (shouldShowCheckmark) {
                this.showCheckmark = true;
            } else {
                this.showSpinner = true;
            }

            setTimeout(() => {
                this.toggleSpinner(false, shouldShowCheckmark);
            }, 30000);
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"section-footer"},[(_vm.showButton)?_c('button',{staticClass:"btn",attrs:{"type":"button","id":"paymentbutton","disabled":_vm.showSpinner},on:{"click":function($event){return _vm.onClickSendCheckoutLink()}}},[_c('div',{class:[{'send-icon-visible': _vm.showCheckmark}]}),_vm._v(" "),_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': _vm.showSpinner }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')]),_vm._v(" "),(!_vm.showSpinner && !_vm.showCheckmark)?[_vm._v("\n            "+_vm._s(_vm.resources.sendCheckoutLinkButtonText)+"\n        ")]:_vm._e()],2):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-af36bb5c", __vue__options__)
  } else {
    hotAPI.reload("data-v-af36bb5c", __vue__options__)
  }
})()}

},{"../../../social-commerce/social-commerce":599,"../../checkout/checkout-submit-handler":287,"axios":5,"vue":262,"vue-hot-reload-api":257,"vuex":264}],405:[function(require,module,exports){
'use strict';

const vueFormAppEl = '.vue-form-app';

const createVueForms = () => {
    document.querySelectorAll(vueFormAppEl).forEach(el => {
        renderVueForm(el);
    });
};

const renderVueForm = (el) => {
    const Vue = require('vue');
    const VueForm = require('./vue-form/vue-form.vue');
    const VueInput = require('./vue-input/vue-input.vue');

    return new Vue({
        el: el,
        components: {
            VueForm,
            VueInput
        }
    });
};

const shouldInit = () => {
    return document.querySelectorAll(vueFormAppEl).length > 0;
};

const vueFormApp = {
    init: () => {
        if (shouldInit()) {
            createVueForms();
        }
    }
};

module.exports = vueFormApp;

},{"./vue-form/vue-form.vue":406,"./vue-input/vue-input.vue":415,"vue":262}],406:[function(require,module,exports){
;(function(){
'use strict';

module.exports = {
    name: 'vue-form',

    props: {
        action: {
            type: String,
            default: ''
        },
        name: {
            type: String,
            default: ''
        },
        method: {
            type: String,
            default: ''
        },
        novalidate: {
            type: Boolean,
            default: true
        },
        submit: {
            type: Function,
            default: () => { } /* eslint-disable-line no-empty-function */
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-form"},[_c('form',{attrs:{"name":_vm.name,"action":_vm.action,"method":_vm.method,"novalidate":_vm.novalidate},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}}},[_vm._t("default")],2)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-5b89094e", __vue__options__)
  } else {
    hotAPI.reload("data-v-5b89094e", __vue__options__)
  }
})()}

},{"vue":262,"vue-hot-reload-api":257}],407:[function(require,module,exports){
;(function(){
'use strict';

const VueInputMixin = require('../vue-input-mixin');

module.exports = {
    name: 'vue-input-button',
    mixins: [VueInputMixin]
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",attrs:{"id":_vm.attributes.id || _vm.attributes.formId,"value":_vm.attributes.label || _vm.attributes.formId,"name":_vm.attributes.htmlName || _vm.attributes.name,"type":_vm.attributes.type}},[_vm._v("\n  "+_vm._s(_vm.attributes.label || _vm.attributes.id || _vm.attributes.formId)+"\n  "),_c('div',{class:['spinner', 'white-spinner', { 'spinner-visible': false }]},[_c('span'),_vm._v(" "),_c('span'),_vm._v(" "),_c('span')])])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-dfe78840", __vue__options__)
  } else {
    hotAPI.reload("data-v-dfe78840", __vue__options__)
  }
})()}

},{"../vue-input-mixin":414,"vue":262,"vue-hot-reload-api":257}],408:[function(require,module,exports){
;(function(){
'use strict';

const VueInputMixin = require('../vue-input-mixin');

module.exports = {
    name: 'vue-input-group',
    mixins: [VueInputMixin],
    computed: {
        isChecked() {
            return (option) => {
                if (this.attributes.options.length > 1) {
                    return option.id === this.context.element.state.value;
                }
                return this.context.element.state.value;
            };
        }
    },
    methods: {
        selectOption(option) {
            if (this.attributes.options.length > 1) {
                this.listeners.blur({ target: { value: option.id } });
                return;
            }
            return this.listeners.blur({ target: { value: !this.context.element.state.value } });
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-form-group"},_vm._l((_vm.attributes.options),function(option,value){return _c('div',{staticClass:"vue-form-group-item"},[_c('input',_vm._b({class:['vue-input', 'vue-input-' + _vm.type],attrs:{"id":option.id,"type":(_vm.type === 'toggle' ? 'checkbox' : _vm.type),"name":_vm.attributes.htmlName,"tabindex":_vm.context.tabindex,"aria-labelledby":((option.id) + "-label"),"disabled":option.disabled},domProps:{"checked":_vm.isChecked(option)},on:{"click":function($event){return _vm.selectOption(option)}}},'input',_vm.attributes.attributes,false)),_vm._v(" "),_c('label',{staticClass:"vue-form-group-label",attrs:{"id":((option.id) + "-label"),"for":option.id}},[(_vm.type === 'toggle')?_c('span',{staticClass:"toggle"}):_vm._e(),_vm._v(" "),_c('span',{class:['field-label', {'disabled' : option.disabled}]},[_c('span',{domProps:{"innerHTML":_vm._s(option.label)}}),_vm._v(" "),(option.helpText)?_c('span',{staticClass:"field-help"},[_c('span',[_vm._v(_vm._s(option.helpText))])]):_vm._e()])])])}),0)}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-58eb4bc1", __vue__options__)
  } else {
    hotAPI.reload("data-v-58eb4bc1", __vue__options__)
  }
})()}

},{"../vue-input-mixin":414,"vue":262,"vue-hot-reload-api":257}],409:[function(require,module,exports){
;(function(){
'use strict';

const VueInputMixin = require('../vue-input-mixin');

module.exports = {
    name: 'vue-input-label',
    mixins: [VueInputMixin],

    computed: {
        isRequired() {
            return this.attributes.mandatory === true;
        }
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"for":_vm.attributes.name || _vm.attributes.formId,"id":((_vm.attributes.formId) + "-label")}},[_c('span',{staticClass:"field-label"},[_vm._v("\n        "+_vm._s(_vm.attributes.label)+"\n        "),(_vm.attributes.helpText)?_c('span',{staticClass:"field-help"},[_c('span',[_vm._v(_vm._s(_vm.attributes.helpText))])]):_vm._e()]),_vm._v(" "),(!_vm.isRequired)?_c('span',{staticClass:"field-info"},[_vm._v(_vm._s(_vm.attributes.optionalText))]):_vm._e()])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-e5d2dc94", __vue__options__)
  } else {
    hotAPI.reload("data-v-e5d2dc94", __vue__options__)
  }
})()}

},{"../vue-input-mixin":414,"vue":262,"vue-hot-reload-api":257}],410:[function(require,module,exports){
;(function(){
'use strict';

const VueInputMixin = require('../vue-input-mixin');

module.exports = {
    name: 'vue-input-select',
    mixins: [VueInputMixin],

    computed: {
        placeholder() {
            return this.attributes.options[0].label;
        },
        selectedLabel() {
            return this.context.element.state.selectedOption
                ? this.context.element.state.selectedOption.label
                : this.context.element.attributes.options[0].label;
        },
        selectedOptionIcon() {
            return this.context.element.state.selectedOption
                ? this.context.element.state.selectedOption.cssClasses
                : false;
        },
        pickableOptions() {
            return this.attributes.options.filter(option => option.htmlValue);
        }
    },

    methods: {
        toggleOptions() {
            if (this.shouldShowOptions) {
                this.hideOptions();
            } else {
                this.showOptions();
            }
        },

        async showOptions() {
            this.shouldShowOptions = true;
            await this.$nextTick();
            this.$refs.options.focus();
        },

        hideOptions() {
            this.shouldShowOptions = false;
        },

        async reset() {
            this.hideOptions();
            await this.$nextTick();
            this.$refs.button.focus();
        },

        onOptionClick(option) {
            this.listeners.blur({ target: { value: option.htmlValue } });
            this.reset();
        },
        documentClicked(event) {
            if (!this.$el.contains(event.target)) {
                this.hideOptions();
            }
        },
        focusLost(event) {
            if (!this.$el.contains(event.relatedTarget)) {
                this.hideOptions();
            }
        }
    },

    data() {
        return {
            shouldShowOptions: false
        };
    },
    mounted() {
        this.$el.addEventListener('focusout', this.focusLost);
        document.addEventListener('click', this.documentClicked);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.documentClicked);
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-input-select"},[_c('button',{ref:"button",class:[{'open': _vm.shouldShowOptions}, 'vue-input'],attrs:{"type":"button","aria-haspopup":"listbox","id":("" + (_vm.attributes.formId)),"aria-labelledby":((_vm.attributes.formId) + "-label " + (_vm.attributes.formId) + "-button"),"aria-expanded":_vm.shouldShowOptions,"disabled":_vm.attributes.disabled},on:{"click":function($event){$event.preventDefault();return _vm.toggleOptions($event)}}},[(_vm.selectedOptionIcon)?[_c('span',{class:_vm.selectedOptionIcon})]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.selectedLabel))])],2),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.shouldShowOptions),expression:"shouldShowOptions"}],ref:"options",attrs:{"role":"listbox","tabindex":_vm.context.tabindex,"aria-labelledby":((_vm.attributes.formId) + "-label")}},_vm._l((_vm.pickableOptions),function(option,value){return _c('li',{key:value,attrs:{"role":"option","id":((_vm.attributes.formId) + "-option-" + value),"tabindex":"0"},on:{"click":function($event){return _vm.onOptionClick(option)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.onOptionClick(option)}}},[(option.cssClasses)?[_c('span',{class:option.cssClasses})]:_vm._e(),_vm._v("\n            "+_vm._s(option.label)+"\n        ")],2)}),0)])}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-17f954aa", __vue__options__)
  } else {
    hotAPI.reload("data-v-17f954aa", __vue__options__)
  }
})()}

},{"../vue-input-mixin":414,"vue":262,"vue-hot-reload-api":257}],411:[function(require,module,exports){
;(function(){
'use strict';

const VueInputMixin = require('../vue-input-mixin');

module.exports = {
    name: 'vue-input-text',
    mixins: [VueInputMixin],
};


})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g(_vm._b({directives:[{name:"facade",rawName:"v-facade",value:(_vm.attributes.mask),expression:"attributes.mask"}],staticClass:"vue-input",attrs:{"id":_vm.attributes.formId,"type":_vm.type,"name":_vm.attributes.name,"tabindex":_vm.context.tabindex,"aria-labelledby":((_vm.attributes.formId) + "-label"),"placeholder":_vm.attributes.placeholder,"maxlength":_vm.attributes.maxLength,"pattern":_vm.attributes.regEx},domProps:{"value":_vm.context.element.state.value}},'input',_vm.elementAttributes,false),_vm.listeners))}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6efeb1db", __vue__options__)
  } else {
    hotAPI.reload("data-v-6efeb1db", __vue__options__)
  }
})()}

},{"../vue-input-mixin":414,"vue":262,"vue-hot-reload-api":257}],412:[function(require,module,exports){
'use strict';

const REGEX = {
    phone: /^[+]?[ 0-9]{0,20}$/,
    email: /^(?![^@]{65})(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(?=.{1,255}$)((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password: /^.{8,20}$/,
    ssn: /^(19|20)?(\d{6}([-+]|\s)\d{4}|(?!19|20)\d{10})$/,
    nif: /^[0-9]{9}$/,
    emojis: /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/,
};

/**
 * Validation Rules Object
 */
const rules = {
    /**
     * Rule: Test minimum length of form field
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateMinLength(formElement) {
        if (formElement.state.value && formElement.state.value.length < formElement.attributes.minLength) {
            return {
                valid: false,
                errorMessage: formElement.attributes.minLengthError
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test maximum length of form field
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateMaxLength(formElement) {
        if (formElement.state.value && formElement.state.value.length > formElement.attributes.maxLength) {
            return {
                valid: false,
                errorMessage: formElement.attributes.valueError
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test if the value is only alpha numeric
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateNumber(formElement) {
        if (formElement.state.value && isNaN(parseInt(formElement.state.value))) {
            return {
                valid: false,
                errorMessage: 'Hardcoded error message for number'
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test if the value is only alpha numeric and has a minimum value
     * and is above or equal to a minimum value
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateMinValue(formElement) {
        const numberValidationResult = rules.validateNumber(formElement);
        if (!numberValidationResult.valid) {
            return numberValidationResult;
        }

        if (formElement.state.value && formElement.state.value < formElement.attributes.minValue) {
            return {
                valid: false,
                errorMessage: 'Hardcoded error message for minvalue'
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test if the value is only alpha numeric and is below or equal
     * to a maximum value
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateMaxValue(formElement) {
        const numberValidationResult = rules.validateNumber(formElement);
        if (!numberValidationResult.valid) {
            return numberValidationResult;
        }

        if (formElement.state.value && formElement.state.value > formElement.attributes.maxValue) {
            return {
                valid: false,
                errorMessage: 'Hardcoded error message for maxvalue'
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test is a mandatory field has a value
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateMandatory(formElement) {
        const isValueString = typeof formElement.state.value === 'string';
        if (!formElement.attributes.mandatory ||
            (!!formElement.state.value &&
                (!isValueString || (isValueString && formElement.state.value.trim() !== null))
            )
        ) {
            return {
                valid: true
            };
        }

        return {
            valid: false,
            errorMessage: formElement.attributes.missingError
        };
    },

    /**
     * Rule: Test a value using a regular expression
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateRegEx(formElement) {
        if (!formElement.state.value) {
            return {
                valid: true
            };
        }

        const regex = new RegExp(formElement.attributes.regEx);
        if (formElement.attributes.emojiRegex) {
            if (regex.test(formElement.state.value)) {
                return {
                    valid: false,
                    errorMessage: formElement.attributes.valueError
                };
            }

            return {
                valid: true
            };
        }
        if (!regex.test(formElement.state.value)) {
            return {
                valid: false,
                errorMessage: formElement.attributes.valueError
            };
        }

        return {
            valid: true
        };
    },
    /**
     * Rule: Soft validate a value using a regular expression
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    softValidateRegEx(formElement){
        if (!formElement.state.value || !formElement.attributes.softValidateRegEx){
            return {
                valid:true
            };
        }
        const regex = new RegExp(formElement.attributes.softValidateRegEx);
        if (regex.test(formElement.state.value)) {
            return {
                valid: false,
                errorMessage: formElement.attributes.valueWarning
            };
        }
        return {
            valid:true
        };
    },

    /**
     * Rule: Prevent script tag using a regular expression
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateScriptValueRegEx(formElement){
        if (!formElement.state.value || !formElement.attributes.scriptRegEx) {
            return {
                valid: true
            };
        }

        const regex = new RegExp(formElement.attributes.scriptRegEx);
        if (regex.test(formElement.state.value)) {
            return {
                valid: false,
                errorMessage: formElement.attributes.valueError
            };
        }

        return {
            valid: true
        };
    },

    /**
     * Rule: Test for a valid email address
     * @param {JSON Object} formElement The JSON object describing the form element
     * @returns Boolean
     */
    validateEmail(formElement) {
        if (!formElement.state.value) {
            return {
                valid: true
            };
        }

        if (!REGEX.email.test(formElement.state.value.trim())) {
            return {
                valid: false,
                errorMessage: 'Hardcoded error message for email'
            };
        }

        return {
            valid: true
        };
    }
};

module.exports = rules;

},{}],413:[function(require,module,exports){
'use strict';

const rules = require('./rules');

const ATTRIBUTE_VALIDATE_FUNCTIONS = {
    mandatory: rules.validateMandatory,
    minLength: rules.validateMinLength,
    maxLength: rules.validateMaxLength,
    minValue: rules.validateMinValue,
    maxValue: rules.validateMaxValue,
    regEx: rules.validateRegEx,
    scriptRegEx: rules.validateScriptValueRegEx
};

const TYPE_VALIDATE_FUNCTIONS = {
    email: rules.validateEmail,
    date: rules.validateDate
};

/**
 * Form Validator Object
 */
const validator = {
    /**
     * Validates a form element
     * @param {JSON Object} el The JSON object describing the form element
     * @returns Array
     */
    validateElement(el) {
        const errors = [
            ...validator.validateElementAttributes(el),
            ...validator.validateElementTypes(el)
        ];

        return errors;
    },

    /**
     * Validates the attributes of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    validateElementAttributes(el) {
        const errors = [];

        for (const [key, value] of Object.entries(ATTRIBUTE_VALIDATE_FUNCTIONS)) { /* eslint-disable-line no-unused-vars */
            if (!el.attributes.hasOwnProperty(key) || el.attributes[key] === null) { /* eslint-disable-line no-prototype-builtins */
                continue;
            }

            const result = ATTRIBUTE_VALIDATE_FUNCTIONS[key](el);
            if (result.valid) {
                continue;
            }

            errors.push(result.errorMessage);
            break;
        }

        return errors;
    },

    /**
     * Validates the types of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    validateElementTypes(el) {
        const errors = [];

        for (const [key, value] of Object.entries(TYPE_VALIDATE_FUNCTIONS)) { /* eslint-disable-line no-unused-vars */
            if (!el.elementDataType || el.elementDataType !== key) {
                continue;
            }

            const typeResult = TYPE_VALIDATE_FUNCTIONS[key](el);
            if (typeResult.valid) {
                continue;
            }

            errors.push(typeResult.errorMessage);
        }

        return errors;
    },
    /**
     * Soft validates the attributes of a form element
     * @param {JSON Object} el The JSON Object describing the form element
     * @returns Array
     */
    softValidateElementAttributes(el) {
        const errors = [];
        const result = rules.softValidateRegEx(el);
        if (!result.valid) {
            errors.push(result.errorMessage);
        }
        return errors;
    }
};

module.exports = validator;

},{"./rules":412}],414:[function(require,module,exports){
'use strict';

/**
 * Default base for input components.
 */
module.exports = {
    props: {
        context: {
            type: Object,
            required: true
        },

        listeners: {
            type: Object,
            default: () => ({})
        }
    },

    computed: {
        attributes() {
            return this.context.element.attributes;
        },

        elementAttributes() {
            const attributes = {};
            if (this.attributes.readOnly) {
                attributes['readOnly'] = true;
            }

            return attributes;
        },

        type() {
            if (this.context.element.elementType) {
                return this.context.element.elementDataType || this.context.element.elementType;
            } else {
                return this.context.element.type;
            }
        }
    }
};

},{}],415:[function(require,module,exports){
;(function(){
'use strict';

const {mapState} = require('vuex');
const VueInputButton = require('./inputs/vue-input-button.vue');
const VueInputGroup = require('./inputs/vue-input-group.vue');
const VueInputLabel = require('./inputs/vue-input-label.vue');
const VueInputSelect = require('./inputs/vue-input-select.vue');
const VueInputText = require('./inputs/vue-input-text.vue');

module.exports = {
    name: 'vue-input',

    components: {
        VueInputButton,
        VueInputGroup,
        VueInputLabel,
        VueInputSelect,
        VueInputText
    },

    props: {
        element: {
            type: [Object, Array],
            required: true
        },

        tabindex: {
            type: [Number, String, Boolean],
            default: false
        },
    },

    methods: {
        /**
         * Fires when the user types data into the input element
         * @param {Event} event Event object from input field
         */
        onInputInput(event) {
            this.$emit('input', event);
        },

        /**
         * Fires when the the input element looses focus
         * @param {Event} event Event object of input field
         */
        onBlurInput(event) {
            if (!this.isReadOnly) {
                this.$emit('blur', event);
            }
        },

        /**
         * Fires when the the input values changes
         * @param {Event} event Event object of input field
         */
        onChangeInput(event) {
            this.$emit('change', event);
        }
    },

    computed: {
        ...mapState('details', [
            'isb2b'
        ]),
        isReadOnly() {
            return this.element.attributes.readOnly === true;
        },

        hasIcon() {
            return this.iconClasses.length > 0;
        },

        iconClasses() {
            const classes = this.element.attributes.cssClasses ? this.element.attributes.cssClasses.split(' ') : [];
            return classes.filter(cssClass => cssClass.indexOf('icon') !== -1);
        },

        cssClasses() {
            const classes = this.element.attributes.cssClasses ? this.element.attributes.cssClasses.split(' ') : [];
            return classes.filter(cssClass => !this.iconClasses.includes(cssClass));
        },

        hasValidationErrors() {
            return this.element.validationErrors && this.element.validationErrors.length > 0;
        },

        hasSoftValidationWarnings() {
            return this.element.softValidationErrors && this.element.softValidationErrors.length > 0;
        },

        elementType() {
            if (this.element.elementType) {
                return this.element.elementDataType || this.element.elementType;
            } else {
                return this.element.attributes.type;
            }
        },

        shouldShowLabel() {
            return this.elementType !== 'submit' && this.element.attributes.label;
        },

        inputComponent() {
            return this.inputComponents[this.elementType] || this.inputComponents.text;
        },

        inputProperties() {
            return this.$props;
        },

        inputListeners() {
            return Object.assign({}, this.$listeners, {
                input: this.onInputInput,
                blur: this.onBlurInput,
                change: this.onChangeInput
            });
        }
    },

    data() {
        return {
            isHidden: this.element.attributes.hideable || false,
            isOnlyB2B: this.element.attributes.onlyb2b || false,
            inputComponents: {
                button: 'vue-input-button',
                checkbox: 'vue-input-group',
                label: 'vue-input-label',
                radio: 'vue-input-group',
                select: 'vue-input-select',
                submit: 'vue-input-button',
                text: 'vue-input-text',
                toggle: 'vue-input-group'
            },
        };
    }
};

})()
if (module.exports.__esModule) module.exports = module.exports.default
var __vue__options__ = (typeof module.exports === "function"? module.exports.options: module.exports)
if (__vue__options__.functional) {console.error("[vueify] functional components are not supported and should be defined in plain js files using render functions.")}
__vue__options__.render = function render () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.isOnlyB2B && _vm.isb2b || !_vm.isOnlyB2B))?_c('div',{class:['vue-form-element', {'has-warning': _vm.hasSoftValidationWarnings}, {'has-error': _vm.hasValidationErrors}, {'no-label': !_vm.shouldShowLabel}, _vm.cssClasses]},[(_vm.isHidden)?_c('button',{staticClass:"vue-button reveal-hidden",attrs:{"type":"button"},on:{"click":function($event){_vm.isHidden = !_vm.isHidden}}},[_vm._v("\n        "+_vm._s(_vm.element.attributes.labelHidden)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.shouldShowLabel && !_vm.isHidden)?_c(_vm.inputComponents.label,{tag:"component",attrs:{"context":_vm.inputProperties}}):_vm._e(),_vm._v(" "),((_vm.hasIcon || _vm.isReadOnly) && !_vm.isHidden)?[_c('span',{class:[{'icon-read-only': _vm.isReadOnly} ].concat( _vm.iconClasses)})]:_vm._e(),_vm._v(" "),(!_vm.isHidden)?_c(_vm.inputComponent,{tag:"component",attrs:{"context":_vm.inputProperties,"listeners":_vm.inputListeners}}):_vm._e(),_vm._v(" "),(_vm.hasSoftValidationWarnings && !_vm.isHidden)?_c('span',{staticClass:"vue-input-warning"},[_vm._v("\n        "+_vm._s(_vm.element.softValidationErrors.join(', '))+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.hasValidationErrors && !_vm.isHidden)?_c('span',{staticClass:"vue-input-error"},[_vm._v("\n        "+_vm._s(_vm.element.validationErrors.join(', '))+"\n    ")]):_vm._e()],2):_vm._e()}
__vue__options__.staticRenderFns = []
if (module.hot) {(function () {  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-6a5ccfc1", __vue__options__)
  } else {
    hotAPI.reload("data-v-6a5ccfc1", __vue__options__)
  }
})()}

},{"./inputs/vue-input-button.vue":407,"./inputs/vue-input-group.vue":408,"./inputs/vue-input-label.vue":409,"./inputs/vue-input-select.vue":410,"./inputs/vue-input-text.vue":411,"vue":262,"vue-hot-reload-api":257,"vuex":264}],416:[function(require,module,exports){
'use strict';

const util = require('./modules/util');
const isBot = require('./modules/helpers/isBot').isBot;
const ritualsStyles = require('./rituals-styles');

exports.init = function init () {

    showLocaleSelectorDialogIfNeeded();

    const elements = {
        countryList:    $('.js-country_select'),
        languageList:   $('.js-language_select'),
        link:           $('.js-country-selector-link'),
        customSelect:   $('.js-country-selector .js-custom-select')
    };

    if (!elements.countryList.length || !elements.languageList.length || !elements.link.length) {
        return;
    }

    util.sortSelectOptions(elements.countryList);
    util.sortSelectOptions(elements.languageList);
    elements.customSelect.selectric();

    let countryListValue = elements.countryList.val();

    elements.countryList.on('change', function () {
        const currentCountry = elements.countryList.val();
        let positionOfPage = 0;
        positionOfPage = $(document).scrollTop();

        if (countryListValue === currentCountry) {
            positionOfPage = $(document).scrollTop();
            handleSelectricClose(positionOfPage, elements);

            return;
        }

        countryListValue = currentCountry;

        buildLocalesOptions(elements);
        updateFlags(elements);
        updateLink(elements);
        handleSelectricClose(positionOfPage, elements);
    });

    elements.languageList.on('change', function () {
        updateLink(elements);
    });
    buildLocalesOptions(elements);
    updateValues(elements);
    updateFlags(elements);
    updateLink(elements);
};

function handleSelectricClose (positionOfPage, elements) {
    elements.customSelect.off('selectric-close');
    elements.customSelect.on('selectric-close', function() {
        $('html, body').animate({
            scrollTop: positionOfPage
        }, 10);
    });
}

function buildLocalesOptions(elements){
    const locales = elements.countryList.find('option:selected').data('locales');
    const languageList = elements.languageList;

    $('option', languageList).remove();

    locales.forEach((locale) => {
        const option = $('<option>')
            .attr('url', locale.url)
            .attr('label', locale.label)
            .attr('flag', locale.flagImage)
            .attr('is-default', locale.isDefault)
            .val(locale.value)
            .text(locale.label);
        if (locale.isSelected) {
            option.attr('selected','selected');
        }

        languageList.append(option);
    });

    if (!languageList.find('option:selected')) {
        languageList.find('option[is-default=true]').attr('selected','selected');
    }

    util.sortSelectOptions(languageList);
    elements.customSelect.selectric();
}

function updateValues(elements) {
    const selectedCountry = elements.countryList.find('option:selected').val() || elements.countryList.val();
    const selectedLang = elements.languageList.find('option:selected').val() || elements.languageList.val();

    elements.countryList.val(selectedCountry);
    elements.languageList.val(selectedLang);
}

function updateLink(elements) {
    clearStorelocatorDropdown();

    const url = elements.languageList.find('option:selected').attr('url') || '';
    elements.link.attr('href', url);
}

function updateFlags(elements) {
    elements.countryList.css({
        backgroundImage: 'url("' + elements.countryList.find('option:selected').attr('flag') + '")'
    });
}

function clearStorelocatorDropdown() {
    if (typeof(Storage) !== 'undefined' && 'storeLocator' in localStorage) {
        delete localStorage.storeLocator;
    }
}

function showLocaleSelectorDialogIfNeeded() {
    if (navigator.cookieEnabled && !isBot) {
        openLocaleSelectorDialog();
    }
}

function checkIfEaster() {
    if ($('.world').length > 0 && $('.world').hasClass('js-3d-visible')) {
        $('body').addClass('no-scroll');
    }
}

function openLocaleSelectorDialog() {
    const $localePopup = $('#localePopupData');
    if (!$localePopup.length) {
        return;
    }

    const $pdInEditMode = $('#pdInEditMode');
    if ($pdInEditMode.length && $pdInEditMode.val() == true) {
        return;
    }

    const localePopupData = JSON.parse($localePopup.val());

    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: window.Resources.COUNTRY_SELECTOR_HEADING,
            headingLarge: true
        },
        paragraphs: [
            {
                text: window.Resources.COUNTRY_SELECTOR_DESCRIPTION
            }
        ],
        buttons: [
            {
                type: 'link link--large',
                label: localePopupData.linkResourceMessagePrimary,
                prependedBlock: '<span class="flag"><img src="' + localePopupData.flagImagePrimaryUrl + '" alt="" /></span>',
                eventName: 'onPrimaryButtonClick',
                shouldCloseModal: true
            },
            {
                type: 'link link--large',
                label: localePopupData.linkResourceMessageSecondary,
                prependedBlock: '<span class="flag"><img src="' + localePopupData.flagImageSecondaryUrl + '" alt="" /></span>',
                eventName: 'onSecondaryButtonClick',
                shouldCloseModal: false
            }
        ],
        row: {
            class: 'left-align'
        },
        closeElement: {
            eventName: 'onCloseElementClick',
            shouldCloseModal: true
        },
        ctaHolder: {},
        modalLarge: true
    });

    window.eventBus.$on('onPrimaryButtonClick', function() {
        setTimeout(function () {
            checkIfEaster();
            const jumpTo = util.getQueryStringParams(window.location.href).jumpto;
            ritualsStyles.jumpToAnchor(jumpTo);
        }, 100);

        if (localePopupData.redirectCurrentLocaleToHomepage) {
            window.location.href = window.Urls.home;
        }
    });

    window.eventBus.$on('onSecondaryButtonClick', function() {
        util.createCookie('ritualLocaleChanged', 1, 1);
        window.location.href = localePopupData.urlCookie;
    });

    window.eventBus.$on('onCloseElementClick', function() {
        setTimeout(function () {
            checkIfEaster();
            const jumpTo = util.getQueryStringParams(window.location.href).jumpto;
            ritualsStyles.jumpToAnchor(jumpTo);
        }, 100);
    });
}

},{"./modules/helpers/isBot":461,"./modules/util":496,"./rituals-styles":592}],417:[function(require,module,exports){
'use strict';

const resetPassPage = '.js-crm-reset-password';
const gtm = require('./modules/google').tagManager;
const login = require('./login');

function closeResetPasswordToaster() {
    if ($('.js-reset-password-confirmation').hasClass('open')) {
        $('.js-modal-overlay').addClass('flyin-component');
    }

    $('.js-reset-password-close').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });

    $('.js-modal-overlay').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });

    $('.js-continue-password-reset').on('click', function () {
        $('.js-reset-password-confirmation').removeClass('open');
        $('.js-modal-overlay').removeClass('flyin-component');
    });
}

function sendMeMyCardByEmail() {
    $('.js-onboarding-email-card').on('click', function (e) {
        sendCustomerID(e.target.value);
    });
}

function sendCustomerID(customerID) {
    $.ajax({
        url: Urls.sendMemberCardByEmail,
        method: 'POST',
        contentType: 'application/json',
        data: JSON.stringify({
            contactId: customerID
        }),
        success: function(response) {
            if (response.data.toLowerCase() === 'ok') {
                const toasterConteiner = $('.js-reset-password-confirmation.page-loaded');
                const toasterConteinerText = toasterConteiner.find('span.text-container');
                toasterConteinerText.text(response.confirmationMessage);
                toasterConteiner.addClass('open');
            }
        }
    });
}

function pushAnalyticsDataRegistrationForm() {
    const registrationForm = $('#RegistrationSmsForm');
    if (registrationForm.length > 0) {
        registrationForm.submit(function () {
            gtm.pushDataLayerEvent({
                event: 'sign_up',
                emailAddress: registrationForm.data('emailaddress')
            });
        });
    }
}

function pushAnalyticsDataLoginForm() {
    const loginForm = $('.js-crm-in-store-login');
    if (loginForm.length > 0) {
        loginForm.submit(function () {
            gtm.pushDataLayerEvent({
                event: 'login',
                emailAddress: loginForm.data('emailaddress')
            });
        });
    }
}

// CRM 2.3 registration page - show phone number input field when checkbox is checked
function showPhoneNumberOnRegistrationForm() {
    const registrationForm = $('.crm-in-store-register');
    if (registrationForm.length > 0) {
        const addToLoyaltySmsList = $('input[name="dwfrm_profile_customer_loyalty_addtoloyaltysmslist"]');

        if (addToLoyaltySmsList.length > 0) {
            const smsPhone = $('input[name="dwfrm_profile_customer_loyalty_smsPhoneOnboarding"]');
            const smsPhoneFormRow = smsPhone.closest('.form-row');

            smsPhoneFormRow.hide();
            addToLoyaltySmsList.on('click', function () {
                if ($(this).prop('checked')) {
                    smsPhone.removeAttr('disabled');
                    smsPhoneFormRow.addClass('form-number-visible');
                    smsPhoneFormRow.fadeIn();
                } else {
                    smsPhoneFormRow.removeClass('form-number-visible');
                    smsPhoneFormRow.hide();
                    smsPhone.attr('disabled', true);
                }
            });
        }
    }
}
//Back button for Reset password page
function resetPasswordBackButton() {
    $(document).on('click', '.js-account-back', function () {
        const redirectLinkElement = $('.js-onboarding-button-redirect');
        if (redirectLinkElement.length > 0){
            window.location.href = redirectLinkElement.val();
        }
        return;
    });
}

/**
 * Tests if the dragList element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => document.querySelectorAll(resetPassPage).length > 0;


const crm23 = {
    init: function () {
        if (shouldInit()) {
            resetPasswordBackButton();
        }
        pushAnalyticsDataRegistrationForm();
        pushAnalyticsDataLoginForm();
        showPhoneNumberOnRegistrationForm();
        sendMeMyCardByEmail();
        closeResetPasswordToaster();

        if ($('.js-crm-set-password').length > 0) {
            login.init();
        }
    }
};

module.exports = crm23;

},{"./login":443,"./modules/google":453}],418:[function(require,module,exports){
'use strict';

const toaster = require('./toaster');
const isSmallView = require('./modules/helpers/isSmallView');
const customSelect = require('./select-custom');

const customerservice = {
    toasterOptions: {},
    init : function() {
        toaster.def.$toasterGeneralEl = $('.js-toaster-container');
        toaster.init();

        const deleleteOption = $('.js-subreasons-privacy').find('[value*="delete"]');
        const franchiseOption = $('.js-subreasons-business').find('[value*="Rituals store"]');

        this.toasterOptions = {
            'Privacy': {
                optiomn2Element: deleleteOption.length ? deleleteOption : $('.js-subreasons-privacy').find('[value*="Delete"]'),
                toasterSelector:  $('.js-contact-privacy-toaster'),
                disableForm: false
            },
            'Business': {
                optiomn2Element: franchiseOption.length ? franchiseOption : $('.js-subreasons-business').find('[value*="franchise"]'),
                toasterSelector:  $('.js-contact-business-toaster'),
                disableForm: true
            }
        };

        $('select[name$="_contactus_reason1"]').on('change', toggleReason2);
        $('select[name$="_contactus_reason2"]').on('change', handleReason2Change);

        $('body').on('click','#sendBtn', function(e){
            if ($(this).data('disabled')){
                e.preventDefault();
                handleReason2Change();
            }
        });

        toggleReason2();
        bindUploadFileCountValidation();
        getFileName();

        $('.js-custom-file-upload').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        $('.js-contact-privacy-toaster .js-accept-contact-form').on('click', function(){
            $('#ContactForm #sendBtn').data('disabled', false);
        });
    }
};

function handleOptionsChoice(reason1Val){
    if (!customerservice.toasterOptions[reason1Val] || !customerservice.toasterOptions[reason1Val].optiomn2Element.is(':selected')){
        $('#dwfrm_contactus_comment').removeAttr('disabled');
        $('#ContactForm #sendBtn').removeAttr('disabled');
        $('#ContactForm #sendBtn').data('disabled', false);
        return;
    }

    toaster.open({
        target: customerservice.toasterOptions[reason1Val].toasterSelector
    });

    $('#dwfrm_contactus_comment').attr('disabled', true);

    if (customerservice.toasterOptions[reason1Val].disableForm){
        $('#ContactForm #sendBtn').attr('disabled', true);
        return;
    }

    $('#ContactForm #sendBtn').data('disabled', true);
    return;
}

function toggleReason2(e) {
    const reasonSelect = e ? $(e.target) : $('select[name$="_contactus_reason1"]');
    const reasonSelected = reasonSelect.val();

    $('.js-subreasons-select-row').hide();
    $('select[name$="_contactus_reason2"]').prop('disabled', true);

    const reasonid = reasonSelect.find(':selected').data('reasonid');

    handleOrderNumberOnReason1Change(reasonid);
    removeErrorMessageForReason1(reasonSelect, reasonid);

    const reason2Select = $('.js-subreasons-' + reasonid);

    if (!reason2Select.length){
        return;
    }
    reason2Select.find('#dwfrm_contactus_reason2').prop('disabled', false);
    reason2Select.show();
    reason2Select.find('.js-hidden-select').addClass('js-custom-select');
    customSelect.init();

    if (!isSmallView()) {
        reason2Select.find('.js-custom-select').attr('tabindex', '-1');
    }

    handleOptionsChoice(reasonSelected);
}

function handleOrderNumberOnReason1Change(reasonid) {
    const $orderNumber = $('input[name$="_contactus_ordernumber"]');
    const $orderNumberRow = $orderNumber.closest('.js-form-row-order-number');

    if (reasonid == 'orderdeliveryreturn' || reasonid == 'productcomplaint') {
        $orderNumber.addClass('required');
        $orderNumberRow.addClass('required');
        $('.optional-indicator', $orderNumberRow).hide();
        return;
    }

    $orderNumberRow.removeClass('required');
    $orderNumber.removeClass('required');
    $('.optional-indicator', $orderNumberRow).show();
    const $errorMessage = $('span[id$="_contactus_ordernumber-error"]', $orderNumberRow);

    if (Resources.VALIDATE_ORDERNUMBER == $errorMessage.text()) {
        return;
    }

    $errorMessage.remove();
    $orderNumber.prop('area-invalid', false);
    $orderNumber.removeClass('error');
    $orderNumber.removeClass('error-text');
    $orderNumber.removeClass('js-validator-error');
}

function removeErrorMessageForReason1(reasonSelect, reasonid) {
    if (!reasonid) {
        return;
    }

    const $reasonRow = reasonSelect.closest('.js-form-row-reason1');
    $('span[id$="_contactus_reason1-error"]', $reasonRow).remove();
    $reasonRow.prop('area-invalid', false);
    $reasonRow.removeClass('error');
    $reasonRow.removeClass('error-text');
    $reasonRow.removeClass('js-validator-error');

}

function handleReason2Change() {
    return handleOptionsChoice($('select[name$="_contactus_reason1"]').val());
}

function bindUploadFileCountValidation() {
    $('#ContactForm').on('submit', function(e) {
        const $fileUpload = $('#attachment').get(0);

        const attachmentCount = parseInt($fileUpload.files.length);

        if (attachmentCount > 0){
            if (attachmentCount > 5) {
                e.preventDefault();
                $('#js-attachment-file-count-error').show();
                return false;
            }

            const allowedExtensions = $('#allowed-extensions').text().split(',');
            for (let index = 0; index < attachmentCount; index++){
                const fileName = $fileUpload.files[index].name;
                const fileExtension = fileName.split('.').pop();

                if (allowedExtensions.indexOf(fileExtension) == -1){
                    $('#js-attachment-file-extension-error').show();
                    return false;
                }
            }

        }

        $('#js-attachment-file-count-error').hide();
        $('#js-attachment-file-extension-error').hide();

        return true;
    });
}

//get and append the name of the uploaded file
function getFileName() {
    $('.js-file-attach').on('change', function(){
        $('.js-contactus-filename').empty();
        this.files.forEach((file) => {
            $('.js-contactus-filename').append(file.name, '&nbsp;');
        });
        if (this.files.length !== 0) {
            $('.js-contactus-nofiles').hide();
            return;
        }
        $('.js-contactus-nofiles').show();
    });
}

module.exports = customerservice;

},{"./modules/helpers/isSmallView":469,"./select-custom":596,"./toaster":605}],419:[function(require,module,exports){
'use strict';

function updateImages(elements, skipAlreadyLoadedImages) {
    if (!elements) {
        return;
    }
    const selector = skipAlreadyLoadedImages ? '.js-dm-image:not(.dm-responsive-image-initialized)' : '.js-dm-image';
    const $imageElements = $(selector, elements);
    if (!$imageElements || !$imageElements.length) {
        return;
    }

    for (let i = 0; i < $imageElements.length; i++) {
        const imageElement = $imageElements[i];
        if (!imageElement) {
            continue;
        }
        window.dispatchEvent(new CustomEvent('dm.image.init', {
            detail: {
                element: imageElement
            }
        }));
    }
}

function updateVideo(videoElements, config, onInitCallback) {
    if (!videoElements) {
        return;
    }

    for (let i = 0; i < videoElements.length; i++) {
        const videoElement = videoElements[i];
        if (!videoElement) {
            continue;
        }
        window.dispatchEvent(new CustomEvent('dm.video.init', {
            detail: {
                element: videoElement,
                config: config,
                onInitCallback: onInitCallback
            }
        }));
    }
}

module.exports = {
    updateImages: updateImages,
    updateVideo: updateVideo
};

},{}],420:[function(require,module,exports){
/*!************************************************************************
 *
 * CAPGEMINI CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2020 CAPGEMINI NV/SA
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Capgemini NV/SA. The intellectual and
 * technical concepts contained herein are proprietary to
 * Capgemini NV/SA and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Capgemini NV/SA.
 **************************************************************************/
'use strict';

var ResponsiveImage = {
    VERSION: '1.0.8',
    SRC: 'src',
    BREAKPOINTS: 'breakpoints',
    WIDTH: 'width',
    HEIGHT: 'height',
    LOADED_WIDTH: 'loadedWidth',
    RESPONSIVE_CLASS: 'dm-responsive-image',
    STATIC_CLASS: 'dm-static-image',
    INITIALIZED_CLASS: 'dm-responsive-image-initialized',
    IMG_TAG: 'IMG',
    DPR: window.devicePixelRatio > 1.5 ? window.devicePixelRatio : 1.5,
    WATCHED_ELEMENTS: {},
    WATCHED_BREAKPOINTS: [],
    MEDIA_CHANGE_LISTENERS: {},
    AVAILABLE_ASSETS: {},
    IS_LOADED: false,
    DEFAULT_BREAKPOINTS: '768,1025',
    SMART_CROP_RATIOS: {
        'Portrait': 2500 / 5000,
        'Square': 5000 / 5000,
        '4-by-3': 5000 / 3750,
        '3-by-2': 5000 / 3333,
        'Widescreen': 5000 / 2813,
        'Super-widescreen': 5000 / 2143,
		'3-by-4': 3750 / 5000
    },
    PRESET_RATIOS: {
        'Square': 1
    },
    init: function init(isLazy) {
        Array.prototype.forEach.call(document.getElementsByClassName(ResponsiveImage.RESPONSIVE_CLASS), function (element) {
            if (!element.classList.contains(ResponsiveImage.INITIALIZED_CLASS) && (!isLazy || isLazy && ResponsiveImage.isElementInViewport(element))) {
                element.classList.add(ResponsiveImage.INITIALIZED_CLASS);

                ResponsiveImage.initializeElement(element);
                ResponsiveImage.watchElement(element);
            }
        });

        Array.prototype.forEach.call(document.getElementsByClassName(ResponsiveImage.STATIC_CLASS), function (element) {
            if (!element.classList.contains(ResponsiveImage.INITIALIZED_CLASS) && (!isLazy || isLazy && ResponsiveImage.isElementInViewport(element))) {
                element.classList.add(ResponsiveImage.INITIALIZED_CLASS);

                ResponsiveImage.initializeStaticElement(element);
            }
        });

        ResponsiveImage.WATCHED_BREAKPOINTS.forEach(function (breakpoint) {
            if (!ResponsiveImage.MEDIA_CHANGE_LISTENERS[breakpoint]) {
                ResponsiveImage.MEDIA_CHANGE_LISTENERS[breakpoint] = window.matchMedia('(min-width: ' + breakpoint + 'px)').onchange = function () {
                    ResponsiveImage.WATCHED_ELEMENTS[breakpoint].forEach(function (element) {
                        ResponsiveImage.initializeElement(element);
                    });
                };
            }
        });
    },
    watchElement: function watchElement(element) {
        var data = element.dataset;
        var breakpoints = (undefined !== data[ResponsiveImage.BREAKPOINTS] ? data[ResponsiveImage.BREAKPOINTS] : ResponsiveImage.DEFAULT_BREAKPOINTS).split(',');
        if (breakpoints) {
            breakpoints.forEach(function (breakpoint) {
                var parsedBreakpoint = parseInt(breakpoint);

                if (ResponsiveImage.WATCHED_BREAKPOINTS.indexOf(parsedBreakpoint) === -1) {
                    ResponsiveImage.WATCHED_BREAKPOINTS.push(parsedBreakpoint);
                }

                if (ResponsiveImage.WATCHED_ELEMENTS[breakpoint]) {
                    ResponsiveImage.WATCHED_ELEMENTS[breakpoint].push(element);
                } else {
                    ResponsiveImage.WATCHED_ELEMENTS[breakpoint] = [element];
                }
            });
        }
    },
    isElementInViewport: function isElementInViewport(element) {
        //Load all images within 1.5 screen heights
        var rect = element.getBoundingClientRect();

        // Updated the left and right checks because of issues with Banner L.
        // With this fix image that are wider then the viewport will also trigger
        // a true when in view.
        //
        // Ticket: https://rituals.atlassian.net/browse/DL-27918
        // Original line: return rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 1.5 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
        return rect.top >= 0 &&
            rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 1.5 &&
            (
                (rect.left >= 0 && rect.right <= (window.innerWidth || document.documentElement.clientWidth)) ||
                (rect.left < 0 && rect.right > (window.innerWidth || document.documentElement.clientWidth))
            );
    },
    initializeStaticElement: function initializeStaticElement(element) {
        var data = element.dataset;
        var transformations = ResponsiveImage.getAssetTransformations(data);
        var settings = {
            asset: data[ResponsiveImage.SRC],
            width: data[ResponsiveImage.WIDTH] || transformations.wid,
            height: data[ResponsiveImage.HEIGHT] || transformations.hei,
            transformations: transformations
        };

        if (settings.transformations.smartCrop) {
            ResponsiveImage.initializeElementWithSmartCrop(element, settings, data, true);
        } else {
            ResponsiveImage.setStaticSource(element, settings);
        }
    },
    initializeElement: function initializeElement(element, forceInitialization) {
        var data = element.dataset;
        var settings = {
            asset: data[ResponsiveImage.SRC],
            breakpoints: data[ResponsiveImage.BREAKPOINTS] && data[ResponsiveImage.BREAKPOINTS].split(',').sort(function (a, b) {
                return parseInt(a) - parseInt(b);
            }),
            transformations: ResponsiveImage.getAssetTransformations(data),
            width: ResponsiveImage.getWidthForElement(element)
        };

        if (forceInitialization || !data[ResponsiveImage.LOADED_WIDTH] || parseInt(data[ResponsiveImage.LOADED_WIDTH]) < settings.width) {
            if (settings.transformations.smartCrop) {
                ResponsiveImage.initializeElementWithSmartCrop(element, settings, data, false);
            } else if (settings.transformations.preset) {
                ResponsiveImage.initializeElementWithPreset(element, settings);
            } else {
                ResponsiveImage.setSource(element, settings);
            }
        }
    },
    initializeElementWithSmartCrop: function initializeElementWithSmartCrop(element, settings, data, isStaticElement) {
        settings.ratio = ResponsiveImage.SMART_CROP_RATIOS[settings.transformations.smartCrop];
        isStaticElement ? ResponsiveImage.setStaticSource(element, settings) : ResponsiveImage.setSource(element, settings);
    },
    initializeElementWithPreset: function initializeElementWithPreset(element, settings) {
        settings.ratio = ResponsiveImage.PRESET_RATIOS[settings.transformations.preset];
        ResponsiveImage.setSource(element, settings);
    },
    getAssetTransformations: function getAssetTransformations(data) {
        var queryParameters = ResponsiveImage.getQueryParameters(data[ResponsiveImage.SRC] || '');
        queryParameters.smartCrop = ResponsiveImage.getSmartCrop(data);

        return queryParameters;
    },
    getQueryParameters: function getQueryParameters(src) {
        var queryParameters = {};
        var splitSrc = src.split('?');
        var queryString = splitSrc[1];
        if (queryString) {
            var parameters = queryString.split('&');
            for (var i = 0; i < parameters.length; i++) {
                var parameter = parameters[i];
                var splitParameter = parameter.split('=');
                if (splitParameter[0] && splitParameter[1]) {
                    queryParameters[splitParameter[0]] = splitParameter[1];
                } else if (splitParameter[0].indexOf('$') === 0) {
                    queryParameters.preset = splitParameter[0];
                }
            }
        }

        return queryParameters;
    },
    getSmartCrop: function getSmartCrop(data) {
        var src = data[ResponsiveImage.SRC] || '';
        var splitSrc = src.split(':');
        var isWithoutSmartCropInUrl = src.lastIndexOf(':') === 5 || src.lastIndexOf(':') === -1;
        return isWithoutSmartCropInUrl ? '' : splitSrc[splitSrc.length - 1].split('?')[0];
    },
    setStaticSource: function setStaticSource(element, settings) {
        var queryStringPrefix = settings.asset.indexOf('?') === -1 ? '?' : '&';
        var width = settings.width || settings.ratio && settings.height && settings.height * settings.ratio;
        var height = settings.height || settings.ratio && settings.width && settings.width / settings.ratio;
        var imageSize = (width || height)
            ? queryStringPrefix + ((width ? 'wid=' + Math.round(width) : '') +
            (height ? (width ? '&' : '') + 'hei=' + Math.round(height) : ''))
            : '';
        if (element.tagName === ResponsiveImage.IMG_TAG) {
            //Set image source
            element.src = settings.asset + imageSize;
        } else {
            //Set background image
            element.style.backgroundImage = 'url(' + settings.asset + imageSize + ')';
        }
        element.classList.add(ResponsiveImage.INITIALIZED_CLASS);
    },
    setSource: function setSource(element, settings) {
        var data = element.dataset;
        var highestLoadedWidth = ResponsiveImage.AVAILABLE_ASSETS[settings.asset];
        settings.width = ResponsiveImage.getClosestBreakpoint(settings.breakpoints, settings.width) || settings.width;
        data[ResponsiveImage.LOADED_WIDTH] = settings.width;

        if (highestLoadedWidth > settings.width) {
            settings.width = highestLoadedWidth;
        } else {
            settings.requestNewImage = true;
        }

        settings.url = settings.asset + ((settings.asset && settings.asset.indexOf('?') === -1) ? '?' : '&') + 'wid=' + Math.round(settings.width * ResponsiveImage.DPR) + (settings.ratio ? '&hei=' + Math.round(settings.width * ResponsiveImage.DPR / settings.ratio) : '');

        if (element.tagName === ResponsiveImage.IMG_TAG) {
            //Set image source
            ResponsiveImage.setImageSource(element, settings);
        } else {
            //Set background image
            ResponsiveImage.setBackgroundImage(element, settings);
        }
    },
    setImageSource: function setImageSource(element, settings) {
        if (settings.requestNewImage) {
            element.onload = function () {
                ResponsiveImage.AVAILABLE_ASSETS[settings.asset] = settings.width;
            };
        }

        element.src = settings.url;
        element.classList.add(ResponsiveImage.INITIALIZED_CLASS);
    },
    setBackgroundImage: function setBackgroundImage(element, settings) {
        if (settings.requestNewImage) {
            var image = new Image();

            image.onload = function () {
                element.style.backgroundImage = 'url(' + settings.url + ')';
                ResponsiveImage.AVAILABLE_ASSETS[settings.asset] = parseInt(settings.width);
            };

            image.src = settings.url;
        } else {
            element.style.backgroundImage = 'url(' + settings.url + ')';
        }
        element.classList.add(ResponsiveImage.INITIALIZED_CLASS);
    },
    getWidthForElement: function getWidthForElement(element) {
        var width = element.clientWidth;
        if (width > 1) return width;
        width = element.parentElement && ResponsiveImage.getWidthForElement(element.parentElement);
        return width > 1 ? width : 100;
    },
    getClosestBreakpoint: function getClosestBreakpoint(breakpoints, width) {
        return breakpoints && breakpoints.find(function (breakpoint) {
            return breakpoint > width;
        });
    },
    getAssetSource: function getAssetSource(asset, preset) {
        var src = asset ? asset.split("?")[0] : '';
        var splitSrc = src.split(':');
        var isWithoutSmartCropInUrl = src.lastIndexOf(':') === 5 || src.lastIndexOf(':') === -1;
        var startsWithHttps = src.indexOf('https') === 0;
        return (isWithoutSmartCropInUrl ? src : startsWithHttps ? [splitSrc[0], ':', splitSrc[1]].join('') : splitSrc[0]) + (preset ? ('?' + preset) : '');
    },
    fetchSmartCrops: function fetchSmartCrops(url, callback) {
        var handlerName = 'handler_' + Math.floor(Math.random() * 999999) + 1;
        var script = document.createElement('script');
        script.src = url + '&handler=' + handlerName;
        document.getElementsByTagName('head')[0].appendChild(script);

        window[handlerName] = function (data) {
            delete window[handlerName];
            script.parentElement.removeChild(script);
            callback(data);
        };
    },
    fetchImageProps: function fetchImageProps(url, callback) {
        var handlerName = 'handler_' + Math.floor(Math.random() * 999999) + 1;
        var script = document.createElement('script');
        script.src = url + '&handler=' + handlerName;
        document.getElementsByTagName('head')[0].appendChild(script);

        window[handlerName] = function (data) {
            delete window[handlerName];
            script.parentElement.removeChild(script);
            callback(data);
        };
    }
};
window.addEventListener('dm.image.init', function (e) {
    if (e.detail.element.classList.contains(ResponsiveImage.STATIC_CLASS)) {
        ResponsiveImage.initializeStaticElement(e.detail.element);
    } else {
        ResponsiveImage.initializeElement(e.detail.element, true);
    }
});
window.addEventListener('scroll', function () {
    if (!ResponsiveImage.IS_LOADED) {
        ResponsiveImage.IS_LOADED = true;
        ResponsiveImage.init(false);
    }
});
window.addEventListener('DOMContentLoaded', function () {
    ResponsiveImage.init(true);
});

},{}],421:[function(require,module,exports){
'use strict';

var ResponsiveVideo = {
    CLASS: 'dm-responsive-video',
    INITIALIZED_CLASS: 'dm-responsive-video-initialized',
    ASSET: 'asset',
    DATA_ASSET: 'data-asset',
    ID: 'id',
    POSTER_IMAGE: 'posterimage',
    DATA_POSTER_IMAGE: 'data-posterimage',
    CONFIG: 'config',
    DATA_CONFIG: 'data-config',
    VIDEOVIEWER_URL: 'https://rituals.scene7.com/s7viewers/html5/VideoViewer.html',
    VIDEO_FIRST_PART: 'rituals/',
    DEFAULT_LINKS_CONFIG: {
        'serverurl': 'https://rituals.scene7.com/is/image/',
        'contenturl': 'https://rituals.scene7.com/is/content/',
        'videoserverurl': 'https://rituals.scene7.com/is/content',
        'config': 'rituals/Video'
    },
    DEFAULT_CONFIG: {
        'loop': '1',
        'autoplay': '1',
        'mutevolume': '1',
        'singleclick': 'none',
        'waiticon': '0',
        'initialBitrate': '3000',
        'playback': 'progressive'
    },
    IS_LOADED: false,
    INITIALIZED_ELEMENTS: {},
    init: function init(isLazy) {
        Array.prototype.forEach.call(document.getElementsByClassName(ResponsiveVideo.CLASS), function (element) {
            if (!element.classList.contains(ResponsiveVideo.INITIALIZED_CLASS) && (!isLazy || isLazy && ResponsiveVideo.isElementInViewport(element))) {
                element.classList.add(ResponsiveVideo.INITIALIZED_CLASS);
                ResponsiveVideo.initializeElement(element);
            }
        });
    },
    isElementInViewport: function isElementInViewport(element) {
        //Load all videos within 1.5 screen heights
        var rect = element.getBoundingClientRect();
        return rect.top >= 0 && rect.left >= 0 && rect.top <= (window.innerHeight || document.documentElement.clientHeight) * 1.5 && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
    },
    initializeElement: function initializeElement(element, onInitCallback) {
        if (!element) {
            return;
        }

        var customConfig = ResponsiveVideo.getAssetConfig(element);
        var params = {...ResponsiveVideo.DEFAULT_CONFIG, ...ResponsiveVideo.DEFAULT_LINKS_CONFIG, ...customConfig};
        params[ResponsiveVideo.ASSET] = ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.ASSET], ResponsiveVideo.ASSET)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.ASSET], ResponsiveVideo.ASSET);
        params[ResponsiveVideo.POSTER_IMAGE] = ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.POSTER_IMAGE], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.POSTER_IMAGE], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(element.dataset[ResponsiveVideo.ASSET], ResponsiveVideo.POSTER_IMAGE)
            || ResponsiveVideo.getAssetSource(customConfig[ResponsiveVideo.ASSET], ResponsiveVideo.POSTER_IMAGE)
            || params[ResponsiveVideo.ASSET];

        if ( (/iP(ad|od|hone)/i.test(navigator.userAgent) || /Mac|Macintosh/i.test(navigator.userAgent)) &&
		    /WebKit/i.test(navigator.userAgent) && !(/(Chrome|CriOS|FxiOS|OPiOS|mercury|Firefox)/i.test(navigator.userAgent))) {
            params.playback = 'progressive';
        }

        if (!element.id) {
            element.setAttribute(ResponsiveVideo.ID, ResponsiveVideo.CLASS + '-' + new Date().getTime());
        }

        ResponsiveVideo.loadVideo(element, element.id, params, onInitCallback);
    },
    renitializeElement: function updateElement(element, config, onInitCallback) {
        if (!element) {
            return;
        }

        element.removeAttribute(ResponsiveVideo.DATA_ASSET);
        element.removeAttribute(ResponsiveVideo.DATA_POSTER_IMAGE);
        element.removeAttribute(ResponsiveVideo.DATA_CONFIG);
        if (typeof config === 'object' && config !== null) {
            var asset = config[ResponsiveVideo.ASSET];
            delete config[ResponsiveVideo.ASSET];
            var posterimage = config[ResponsiveVideo.POSTER_IMAGE];
            delete config[ResponsiveVideo.POSTER_IMAGE];
            element.setAttribute(ResponsiveVideo.DATA_CONFIG, JSON.stringify(config));
            if (asset) {
                element.setAttribute(ResponsiveVideo.DATA_ASSET, asset);
            }
            if (posterimage) {
                element.setAttribute(ResponsiveVideo.DATA_POSTER_IMAGE, posterimage);
            }
        }

        ResponsiveVideo.initializeElement(element, onInitCallback);
    },
    loadVideo(element, containerId, params, onInitCallback) {
        var s7videoviewer = null;
        if (ResponsiveVideo.INITIALIZED_ELEMENTS[containerId]) {
            s7videoviewer = ResponsiveVideo.INITIALIZED_ELEMENTS[containerId];
            s7videoviewer.dispose();
            delete ResponsiveVideo.INITIALIZED_ELEMENTS[containerId];
        }

        s7videoviewer = new s7viewers.VideoViewer({
            'containerId': containerId,
            'params': params,
            'handlers': {
                'initComplete': function() {
                    element.classList.add(ResponsiveVideo.INITIALIZED_CLASS);
                    ResponsiveVideo.INITIALIZED_ELEMENTS[containerId] = s7videoviewer;
                    if (onInitCallback && {}.toString.call(onInitCallback) === '[object Function]') {
                        onInitCallback();
                    }
                }
            }
        });

        s7videoviewer.init();
    },

    getAssetSource(asset, paramName) {
        if (!asset || !paramName) {
            return null;
        }

        if (asset.indexOf(ResponsiveVideo.VIDEOVIEWER_URL) > -1) {
            asset = asset.replace(ResponsiveVideo.VIDEOVIEWER_URL, '');
            asset = asset.replace('?', '');
            var urlParams = JSON.parse('{"' + asset.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
                function(key, value) {return key === '' ? value : decodeURIComponent(value);});
            asset = urlParams[paramName];
        }

        if (!asset) {
            return null;
        }

        if (asset.indexOf(ResponsiveVideo.DEFAULT_LINKS_CONFIG.contenturl) > -1) {
            asset = asset.replace(ResponsiveVideo.DEFAULT_LINKS_CONFIG.contenturl, '');
        }

        if (asset.indexOf(ResponsiveVideo.DEFAULT_LINKS_CONFIG.serverurl) > -1) {
            asset = asset.replace(ResponsiveVideo.DEFAULT_LINKS_CONFIG.serverurl, '');
        }

        if (asset.indexOf(ResponsiveVideo.VIDEO_FIRST_PART) == 0) {
            return asset;
        }

        return null;
    },
    getAssetConfig(element) {
        try {
            return JSON.parse(element.dataset[ResponsiveVideo.CONFIG]);
        } catch(e) {
            return {};
        }
    },
};

window.addEventListener('dm.video.init', function (e) {
    ResponsiveVideo.renitializeElement(e.detail.element, e.detail.config, e.detail.onInitCallback);
});

window.addEventListener('scroll', function () {
    if (!ResponsiveVideo.IS_LOADED) {
        ResponsiveVideo.IS_LOADED = true;
        ResponsiveVideo.init(false);
    }
});

window.addEventListener('DOMContentLoaded', function () {
    ResponsiveVideo.init(true);
});

},{}],422:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax'),
    appendParamToURL = require('./modules/util/appendParamToURL'),
    _isString = require('lodash/isString'),
    _merge = require('lodash/merge'),
    imagesLoaded = require('imagesloaded');

const dialog = {
    def: {
        $headerElement: $('header.header')
    },
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function (params) {
        let $target, id;

        if (_isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function (params) {
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function (params, target) {
        let position;

        const contentTarget = target || this.$container;

        if (!contentTarget) {
            return;
        }
        const content = params.content || params.html;
        if (!content) {
            return;
        }
        contentTarget.empty().html(content);

        if (!contentTarget.dialog('isOpen')) {
            contentTarget.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }

        if (!position) {
            position = this.settings.position;
        }

        imagesLoaded(contentTarget).on('done', function () {
            contentTarget.dialog('option', 'position', position);
        }.bind(this));

        const callback = (typeof params.callback === 'function') ? params.callback : function () {return;};
        callback();

        $('.js-bonus-product-dialog-wrapper').addClass('js-gwp-open');

        if ($('.gwp-popup-padding').length > 0) {
            $('.js-bonus-product-dialog-wrapper').addClass('no-padding');
            $('.gwp-popup-padding').closest('.ui-dialog').addClass('no-padding');
            $('.gwp-popup-padding').closest('.ui-dialog').css('width', '650px');
        }

        const popupLabelText = $('.js-close-popup-text').html();
        $('.ui-dialog-titlebar-close').attr('aria-label', popupLabelText);
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function (params) {
        if (!this.$container) {
            return;
        }

        if (params.url) {
            params.url = appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                dialogTarget: params.target,
                callback: function (response, target) {
                    params.content = response;
                    this.openWithContent(params, target);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        } else {
            this.$container.dialog('open');
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function () {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');

        $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');

    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    },
    isActive: function () {
        return this.exists() && (this.$container.children.length > 0);
    },
    settings: {
        closeText: '',
        autoOpen: false,
        height: 'auto',
        draggable: false,
        resizable: false,
        modal: false,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        title: '',
        width: '800',
        open: function () {
            //Show dressed down version of the header to disable unwanted navigation (except cookie bar dialog).
            if (!$(this).parent().hasClass('cookie-bar')){
                dialog.def.$headerElement.addClass('header--empty');

                const current = $(this);
                $('body').on('click', '.ui-widget-overlay', function(){
                    current.dialog('close');
                });
            }
        },
        close: function () {
            $(this).dialog('close');
            if (!$('.pt_privacy').length && !$('.js-accept-cookies').length) {
                dialog.def.$headerElement.removeClass('header--empty');
            }
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

$(document).on('click', '.ui-dialog-titlebar-close, .js-close-bonus-popup', function() {
    $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');
});

$(document).on('keyup', function(e) {
    if (e.which == 27 && $('.js-bonus-product-dialog-wrapper').hasClass('js-gwp-open')){
        $('.js-bonus-product-dialog-wrapper').removeClass('js-gwp-open');
   }
});

module.exports = dialog;

},{"./modules/ajax":449,"./modules/util/appendParamToURL":479,"imagesloaded":48,"lodash/isString":204,"lodash/merge":209}],423:[function(require,module,exports){
/**
 * Draglist Class
 * issue: https://rituals.atlassian.net/browse/DL-12313
 *
 * Creates a draggable horizontal list of draggable items
 */
'use strict';

const gtm = require('./modules/google').tagManager;
const debounce = require('./modules/helpers/debounce');
const equalHeight = require('./modules/helpers/equalHeight');
const prepareDeferedImages = require('./modules/helpers/prepareDeferedImages');
const responsiveBg = require('./responsive-background');
const isMobileDevice = require('./modules/helpers/isMobileDevice');
const isTouchDevice = require('./modules/helpers/isTouchDevice');
const damHelper = require('./dam/dam-helper');
const productGrid = require('./product-grid');
const advent = require('./advent');
const tileSelectors = ['.drag-list-body .js-drag-list-item'];

const dragListEl = '.js-drag-list';
const dragListListItemEl = '.js-drag-list-item';
const dragListListItemActiveEl = 'drag-list-item-active';
const dragListControlPrevEl = '.js-drag-list-prev';
const dragListControlNextEl = '.js-drag-list-next';
const PUSHED_CLASS = 'js-data-layer-list-pushed';

let shouldPreventDefault = false;
let isMouseDown = false;
let activeSlide;
let parentWidth = 0;

const dragListElements = [];
const dragListState = {
    'rect': '',
    'startX': 0,
    'clientX': 0,
    'target': '',
};

const dragListDefaults = {
    'horizontalPadding': isMobileDevice() ? 50 : 120,
    'horizontalTileMargin': isMobileDevice() ? 10 : 20,
    'maxTileWidthDesktop': 409,
    'itemsToShow': 4.5,
    'itemsToScroll': 4,
    'responsive': [
        {
            'breakpoint': 1300,
            'settings': {
                'itemsToShow': 3.5,
                'itemsToScroll': 3
            }
        }, {
            'breakpoint': 1100,
            'settings': {
                'itemsToShow': 2.5,
                'itemsToScroll': 3
            }
        }
    ]
};

/**
 * Prepares the markup for the drag list to work
 */
const prepareMarkup = () => {
    // Wrap list in class set calculated width inline.
    $(dragListEl).each((i, el) => {
        if ($(el).hasClass('draglist-prepared')) {
            return false;
        }

        damHelper.updateImages(el);

        if (shouldLazyLoad(el)) {
            initLazyLoad(el);
        } else {
            prepareDeferedImages(el);
        }

        if (getProp(el, 'hideArrows') || !shouldPrepareMarkup(el)) {
            $(el).next().addClass('visually-hidden');
        }

        if (typeof getProp(el, 'horizontalPadding') !== 'undefined') {
            dragListDefaults.horizontalPadding = parseInt(getProp(el, 'horizontalPadding'));
        }

        if (typeof getProp(el, 'horizontalTileMargin') !== 'undefined') {
            dragListDefaults.horizontalTileMargin = parseInt(getProp(el, 'horizontalTileMargin'));
        }

        if (getProp(el, 'hideBar')) {
            $(el).addClass('hidden-bar');
        }

        if (shouldPrepareMarkup(el)) {
            if ($(el).parents('.js-advent-overlay-inner').find('.js-advent-slider-image').length){
                $(el).parents('.js-advent-overlay-inner').find('.js-advent-slider-image').each(function () {
                    prepAdventSliderImg($(this));
                });
            }

            setParentWidth(el);
            setDraglistWidth(el);
            equalHeight($('.product-details-content', el));
            responsiveBg.init();

            if ($(el).hasClass('js-slider-advent')) {
                const $adventImage = $(el).parents('.js-advent-overlay-inner').find('.js-advent-slider-image');
                const imgHeight = $adventImage[0].naturalHeight;
                const track = $(el).find('.drag-list-body');
                const imgSrc = $adventImage.attr('src');
                track.css({
                    'height': imgHeight,
                    'background-image': 'url(' + imgSrc + ')'
                });
            }
        } else {
            $(el).css({'visibility': 'visible'});
            $(el).next().css({'visibility': 'visible'});
        }

        $(el).addClass('draglist-prepared');
    });
};

/**
 * Gets the width of a draglist tile based on 'itemsToShow' prop
 *
 * @param {DOM Element} el The draglist DOM element
 * @returns {Float} Width of tile
 */
const getDraglistTileWidth = (el) => {
    const p = dragListDefaults.horizontalPadding > 0 ? dragListDefaults.horizontalPadding / 2 : 0;
    const w = (parentWidth - p) / getProp(el, 'itemsToShow');
    return Math.min(w, dragListDefaults.maxTileWidthDesktop);
};

/**
 * Sets the width of a certain dragList element
 *
 * @param {DOM Element} el The draglist DOM element
 */
const setDraglistWidth = (el) => {
    let width = 0;
    const hasListBody = $('.drag-list-body', el).length;

    if (hasListBody) {
        $('.drag-list-body', el).contents().unwrap();
    }

    $(el).children().each((i, child) => {
        if (!isMobileDevice() && !$(el).hasClass('js-slider-advent')) {
            const w = getDraglistTileWidth(el);
            $(child).width(w);
        }

        width += $(child).width();
    });

    width += dragListDefaults.horizontalPadding;
    $(el).addClass('init').wrapInner(`<div class="drag-list-body" style="min-width: ${width}px;"></div>`);
};

const setParentWidth = (el) => {
    parentWidth = el.parentNode.getBoundingClientRect().width;
};

/**
 * Resizes the a certain dragList element
 *
 * @param {DOM Element} el The draglist DOM element
 */
const resizeDraglist = (el) => {
    let width = 0;

    $('.drag-list-body', el).children().each((i, child) => {
        if (!isMobileDevice() && !$(el).hasClass('js-slider-advent')) {
            const w = getDraglistTileWidth(el);
            $(child).width(w);
        }

        width += $(child).width();
    });

    width += dragListDefaults.horizontalPadding;
    $('.drag-list-body', el).css({
        'min-width': width + 'px'
    });
};

/*
 * Inits the custom scrollbar logic
 */
const initDragList = () => {
    $(dragListEl).each((i, el) => {
        const $dragListScrollEl = $(el);

        if ($dragListScrollEl.hasClass('draglist-initialized')) {
            return false;
        }

        if (getProp(el, 'isMobileOnly')) {
            // To keep draglistElements array length consistant with number on page
            dragListElements.push('isMobileOnly');
            initAdventConceptHighlightBlockEvents(el);
            $dragListScrollEl.addClass('draglist-initialized');
            return true;
        }

        // Store instance in array.
        dragListElements.push(el);

        // Store index of list to be able to grab the correct one later.
        $dragListScrollEl.data('listIndex', i);

        // Handle radiobutton in list tile
        $dragListScrollEl.find('input[type="radio"]').on('click', {'currentList': el}, onClickRadio);

        // Disable dragging of links and images.
        $dragListScrollEl.find('a, img').attr('draggable', false);

        $dragListScrollEl.on('mousedown', onMouseDown);
        $dragListScrollEl.on('scroll', debounce((e) => { updateControls(e.currentTarget); }, 100));
        $dragListScrollEl.on('scroll', debounce(() => { productGrid.pushProductsToDataLayer(tileSelectors); }, 100));

        // Extend current click behavior set in App.js.
        // Normally we would use the a element.
        $dragListScrollEl.find('.js-linked-block').on('click.dragList', onClick);

        $dragListScrollEl.next().find(dragListControlPrevEl).on('click', {'listIndex': i}, onClickPrev);
        $dragListScrollEl.next().find(dragListControlNextEl).on('click', {'listIndex': i}, onClickNext);
        $dragListScrollEl.addClass('draglist-initialized');

        if (isMobileDevice() && getProp(el, 'useEffect') === 'magnify') {
            $dragListScrollEl.addClass('effect-magnify');
            $dragListScrollEl.off('scroll').on('scroll', () => { onTouchMove(el); });
        }
    });

    $(document).on('mouseup.dragList', onMouseUp);
    $(document).on('mouseup.dragList', debounce(() => { productGrid.pushProductsToDataLayer(tileSelectors); }, 100));
    $(document).on('mousemove.dragList', onMouseMove);
    $(window).on('resize.dragList', debounce(() => { onResize(); }, 200));
};

function initAdventConceptHighlightBlockEvents(el) {
    if (!advent.getAdventDataLayerDataWithActiveProductImageSlide()) {
        return;
    }

    if (isMobileDevice()) {
        $(el).off('scroll').on('scroll', () => { onTouchMove(el, handleAdventDataLayerPush); });
    }
}

function prepAdventSliderImg(img){
    // Prepare slider block
    const fullSlideWidth = parentWidth;
    let imgHeight = img[0].naturalHeight;
    let imgWidth = img[0].naturalWidth;

    // if image is larger than the viewport in height
    if (imgHeight > ($(window).height() * 0.7)){
        imgHeight = $(window).height() * 0.7;
        imgWidth = imgHeight * img[0].naturalWidth / img[0].naturalHeight;
    }

    // calculate amount of full slides
    let fullSlidesAmount = Math.floor(imgWidth / fullSlideWidth) || 1;

    // if fullscreen slides are even, create one less.
    // We need an odd number of slides in order to start slider in the middle
    if (fullSlidesAmount % 2 == 0){
        fullSlidesAmount = fullSlidesAmount - 1;
    }

    // calculate edge slides widths (should always be smaller that the fullwidth ones)
    const edgeSlideWidthDecimal = (imgWidth - (fullSlidesAmount * fullSlideWidth)) / 2;
    const edgeSlideWidth = Math.round(edgeSlideWidthDecimal);

    const totalSlidesCount = fullSlidesAmount + (edgeSlideWidth > 0 ? 2 : 0); // amount of fullscreenslides + edges

    const adventSliderEl = img.closest('.js-advent-overlay').find('.js-slider-advent');

    // attach the empty slide divs
    for (let i = 0; i < totalSlidesCount; i++) {
        adventSliderEl.append($('<div class="advent-slide js-drag-list-item"></div>'));
    }

    const slide = adventSliderEl.find('.js-drag-list-item');

    // give correct widths to the slides
    slide.each(function() {
        if ($(this).is(':first-child') || $(this).is(':last-child')) {
            $(this).css('width', edgeSlideWidth);
        } else {
            $(this).css('width', fullSlideWidth);
        }
    });
}

const calculateScaledTranslatePct = (i, el, min, max) => {
    const {left, right, width} = el.getBoundingClientRect();

    // Clear active class
    $(el).removeClass(dragListListItemActiveEl);

    // Items inside viewport
    if ((left > min && left < max) || (right > min && right < max)) {
        const visiblePx = (left < min) ? right - min : max - left;
        return percentageStepper(0.2, (100 / width) * visiblePx);
    }

    return null;
};

/**
 * Evaluates a draglist item and potentially evaluates it when in viewport
 *
 * @param {Number} i The number of the slide in the draglist element
 * @param {DOM Element} el The element to evaluate and magnify
 * @param {Number} min The minimum postion to start evaluating an element
 * @param {Number} max The maximum position to stop evaluating an element
 */
const setMagnification = (i, el, min, max) => {
    const scaledTranslatePct = calculateScaledTranslatePct(i, el, min, max);
    if (scaledTranslatePct) {
        const scaledTranslateY = (-1 * 20 * scaledTranslatePct);
        el.setAttribute('style', 'transform: translateY(' + scaledTranslateY + 'px);');
        if (scaledTranslatePct === 1) {
            $(el).addClass(dragListListItemActiveEl);
            handleDataLayerPush(i, el);
        }
    }
};

/**
 * Converts the given float to the nearest 0.1, 0.2, ... 0.9, 1
 *
 * @param {Float} min Minimum return value
 * @param {Float} val The percentage (between 0 ... 1)
 * @returns {Float} New number or minimum value
 */
const percentageStepper = (min, val) => {
    const step = (Math.round(Math.ceil(val) / 10) * 10) / 100;
    return step < min ? min : (step > 1) ? 1 : step;
};

/**
 * Handles the datalayer push of element in view
 *
 * @param {Number} i Index of element in view
 * @param {DOM Object} el DOM element in view
 */
const handleDataLayerPush = (i, el) => {
    const $tileToPush = $(el);
    if (i !== activeSlide && !$tileToPush.hasClass(PUSHED_CLASS)) {
        activeSlide = i;

        const datalayerProduct = $('.js-product-tile-datalayer-product', $tileToPush);

        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());

            if (productData) {
                gtm.pushProductTileView(productData);
            }
        }

        $tileToPush.addClass(PUSHED_CLASS);
    }
};

const handleAdventDataLayerPush = (i, el, min, max) => {
    const scaledTranslatePct = calculateScaledTranslatePct(i, el, min, max);
    if (scaledTranslatePct !== 1) {
        return;
    }

    advent.pushAdventDataLayerDataWithActiveProductImageSlide('feature slider');
};

/**
 * Handles lazyLoading of all images inside the individual tiles
 *
 * @param {HTML Element} el Draglist element
 */
const initLazyLoad = (el) => {
    const observer = new IntersectionObserver((blocks) => {
        for (const block of blocks) {
            const $el = $(block.target);

            if (block.isIntersecting === true && !$el.hasClass('lazyloaded')) {
                $el.addClass('lazyloaded');
                prepareDeferedImages($el);
            }
        }
    }, {
        threshold: [0.05]
    });

    observer.observe(el);
};

/**
 * Updates the previous and next button once the scrollbar hits the beginning
 * or the end.
 *
 * @param {HTML Element} el The HTML Element to update
 */
const updateControls = (el) => {
    const isMaxScroll = el.scrollLeft === (el.scrollWidth - el.clientWidth);
    const isMinScroll = el.scrollLeft === 0;

    // Show / hide controls based on scollLeft.
    $(el).closest(dragListEl).toggleClass('left-gradient', !isMinScroll);
    $(el).closest(dragListEl).next().find(dragListControlPrevEl).toggleClass('hidden', isMinScroll);
    $(el).closest(dragListEl).toggleClass('right-gradient', !isMaxScroll);
    $(el).closest(dragListEl).next().find(dragListControlNextEl).toggleClass('hidden', isMaxScroll);
};

/**
 * Sets all the variables needed to be able to move the slider
 *
 * @param {Event} e Mouse down event
 */
const onMouseDown = (e) => {
    const listIndex = $(e.currentTarget).data('listIndex');
    const $dragListScrollEl = $(dragListElements[listIndex]);

    // Setup draglistState using current list.
    dragListState.target = e.currentTarget;
    dragListState.rect = dragListState.target.getBoundingClientRect();
    dragListState.startX = $dragListScrollEl.scrollLeft() + e.clientX - dragListState.rect.x;
    dragListState.clientX = e.clientX;
    isMouseDown = true;
};

/**
 * Resets all the variable to their initial value
 *
 * @param {Event} e Mouse up event
 */
const onMouseUp = () => {
    // Reset state for later use
    dragListState.target = '';
    dragListState.rect = '';
    dragListState.startX = 0;
    dragListState.clientX = 0;
    isMouseDown = false;
};

/**
 * Moves the slider
 *
 * @param {Event} e Mouse move event
 */
const onMouseMove = (e) => {
    if (isMouseDown) {

        // Calculate actual pixels to move dragList instance by
        const dragListX = dragListState.startX - (e.clientX - dragListState.rect.x);

        // Calculate actual moved pixels by pointer
        const deltaX = dragListState.clientX - e.clientX;

        // Determine drag list scroll element.
        const listIndex = $(dragListState.target).data('listIndex');
        const $dragListScrollEl = $(dragListElements[listIndex]);

        $dragListScrollEl.scrollLeft(dragListX);
        shouldPreventDefault = (deltaX > 2 || deltaX < -2);
    }
};

/**
 * Handles the scroll event on mobile
 *
 * @param {DOM Object} el DOM element to magnify
 */
const onTouchMove = (el, dataLayerPushFunction) => {
    const min = el.getBoundingClientRect().left;
    const max = el.getBoundingClientRect().right;
    const children = el.querySelectorAll(dragListListItemEl);

    children.forEach((child, index) => {
        if (dataLayerPushFunction && $.isFunction(dataLayerPushFunction)) {
            dataLayerPushFunction(index, child, min, max);
            return;
        }
        setMagnification(index, child, min, max);
    });
};

/**
 * Makes sure no click is triggered right after moving
 *
 * @param {Event} e Click event
 */
const onClick = (e) => {
    if (shouldPreventDefault) {
        shouldPreventDefault = false;
        e.preventDefault();
        return false;
    }
};

/**
 * Moves list backwards
 *
 * @param {Event} e Click event
 */
const onClickPrev = (e) => {
    const visibleItemIndex = getFirstVisibleItem(e.data.listIndex);
    const dragListScrollEl = dragListElements[e.data.listIndex];
    const listItemWidth = $(dragListScrollEl).find(dragListListItemEl).width();
    const isOutOfRange = visibleItemIndex <= getProp(dragListScrollEl.el || dragListScrollEl , 'itemsToScroll');

    // Calculate next item to scroll to
    const newIndex = visibleItemIndex - getProp(dragListScrollEl.el || dragListScrollEl, 'itemsToScroll');
    const newScrollPos = isOutOfRange ? 0 : listItemWidth * newIndex;

    $(dragListScrollEl).animate({scrollLeft: newScrollPos}, 500, 'easeOutQuad');
    handleGTMScrollEvent(dragListScrollEl, 'left');
};

/**
 * Moves list forwards
 *
 * @param {Event} e Click event
 */
const onClickNext = (e) => {
    const visibleItemIndex = getFirstVisibleItem(e.data.listIndex);
    const dragListScrollEl = dragListElements[e.data.listIndex];
    const listItemWidth = $(dragListScrollEl).find(dragListListItemEl).width();
    const maxScroll = dragListScrollEl.scrollWidth - dragListScrollEl.clientWidth;

    // Calculate next item to scroll to.
    const itemsToScroll = parseInt(getProp(dragListScrollEl.el || dragListScrollEl, 'itemsToScroll'));
    const newIndex = visibleItemIndex + itemsToScroll;
    const isOutOfRange = (listItemWidth * newIndex) >= maxScroll;
    const newScrollPos = isOutOfRange ? maxScroll : listItemWidth * newIndex;

    $(dragListScrollEl).animate({scrollLeft: newScrollPos}, 500, 'easeOutQuad');
    handleGTMScrollEvent(dragListScrollEl, 'right');
};

/**
 * Handles click on radio inside of list tile
 *
 * @param {Event} e Click event
 */
const onClickRadio = (e) => {
    const el = e.data.currentList;
    $('input[type="radio"]', el).each((i, elInput) => {
        elInput.closest(dragListListItemEl).classList.toggle('selected', elInput.checked);
    });
};

/**
 * Recalculates the scrollbar and slide widths for all sliders on resize
 */
const onResize = () => {
    if (!isTouchDevice()) {
        for (const el of dragListElements) {
            if (el !== 'isMobileOnly') {
                const elScroll = $(el.closest(dragListEl))[0];
                resizeDraglist(elScroll);
            }
        }
    }
};

/**
 * Lookup responsive or overridden value. Return default if not exists.
 *
 * @param {String} prop Name of key in settings
 */
const getProp = (el, prop) => {
    const elData = $(el).data('list-config');
    let propValue = dragListDefaults[prop] || false;

    for (const config of dragListDefaults.responsive) {
        if (config.breakpoint && window.innerWidth < config.breakpoint) {
            propValue = config.settings[prop] || propValue;
        }
    }

    // The manually set properties always overrule so checking that one first
    return (typeof elData !== 'undefined' && typeof elData[prop] !== 'undefined') ? elData[prop] : propValue;
};

/**
 * Calculates the first fully visible list item using the scroll position
 *
 * @param {Number} listIndex The index of the drag list
 */
const getFirstVisibleItem = (listIndex) => {
    const $dragListScrollEl = $(dragListElements[listIndex]);
    const dragListItemWidth = $dragListScrollEl.find(dragListListItemEl).width();
    const scrollLeft = $dragListScrollEl.scrollLeft();

    return scrollLeft > 0 ? Math.ceil(scrollLeft / dragListItemWidth) : scrollLeft;
};

/**
 * Tests if the dragList element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $(dragListEl).length > 0;
};

/**
 * Tests to see if we should prepare the markup
 *
 * @param {HTML Element} el The HTML Element
 * @returns {Boolean} result of test
 */
const shouldPrepareMarkup = (el) => {
    return (getProp(el, 'isDesktopOnly') && !isMobileDevice()) ||
        (getProp(el, 'isMobileOnly') && isMobileDevice()) ||
        (!getProp(el, 'isDesktopOnly') && !getProp(el, 'isMobileOnly'));
};

/**
 * Tests to see if element should be lazyloaded and intersection observer
 * is supported
 *
 * @param {DOM Element} el Draglist element to loazyLoad
 * @returns {Boolean} restult of test
 */
const shouldLazyLoad = (el) => {
    return getProp(el, 'lazyLoad') &&
        'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};

/**
 * Pushes horizontal scroll event to datalayer
 * @param {DOM Element} el
 * @param {String} scrollDirection
 * @returns
 */
function handleGTMScrollEvent(el, scrollDirection) {
    const sliderId = $(el).closest('section').data('sliderid');
    const data = {
        'event': 'interaction',
        'interaction_type': 'slider',
        'content_name': sliderId,
        'content_id': sliderId,
        'scroll_direction': scrollDirection
    };

    gtm.pushDataLayerEvent(data);
}

const dragList = {
    init: () => {
        if (shouldInit()) {
            prepareMarkup();
            initDragList();
        }
    }
};

module.exports = dragList;

},{"./advent":269,"./dam/dam-helper":419,"./modules/google":453,"./modules/helpers/debounce":458,"./modules/helpers/equalHeight":459,"./modules/helpers/isMobileDevice":466,"./modules/helpers/isTouchDevice":473,"./modules/helpers/prepareDeferedImages":474,"./product-grid":578,"./responsive-background":588}],424:[function(require,module,exports){
'use strict';

const gtm = require('../modules/google').tagManager;
const QRcode = require('qrcode');
const isTouchDevice = require('../modules/helpers/isTouchDevice');
const getUpdatedURLWithParams = require('../modules/util/getUpdatedURLWithParams');

const pushEvent = (eventAction, eventCategory) => {

    const eventLabel = $('.js-the-ritual-of-title').first().text().trim();

    if (!eventAction) {
        return;
    }

    const event = {
        event: 'easter',
        event_category: eventCategory ? eventCategory : 'pdp', /* eslint-disable-line camelcase */
        event_action: eventAction, /* eslint-disable-line camelcase */
        event_label: eventLabel /* eslint-disable-line camelcase */
    };

    gtm.pushDataLayerEvent(event);
};

const init = () => {

    bindEvents();

    const $modelViewers = $('.js-egg-model-viewer');
    if (!$modelViewers || !$modelViewers.length) {
        removeAndHideElements();
        return;
    }

    if (!$modelViewers[0].canActivateAR) {
        removeAndHideElements(true);
        return;
    }

    if (new URL(window.location.href).searchParams.get('triggerARMode') == 'true') {
        $modelViewers[0].activateAR();
    }

    $modelViewers.on('click', (e) => {
        const $this = $(e.target).closest('.js-easter-ar-block-wrapper');
        pushEvent($this && $this.length ? 'content view in 3D' : 'main view in 3d');
    });

    $modelViewers.on('ar-status', (e) => {
        if (e.detail.status === 'failed') {
            removeAndHideElements(true);
        }
    });

    $modelViewers.on('error', () => {
        removeAndHideElements(true);
    });
};

const removeAndHideElements = (removeElements) => {
    if (removeElements) {
        $('.js-easter-view-block-ar').remove();
        $('.js-egg-model-viewer').remove();
    }

    $('.js-easter-view-block').removeClass('hide');

    if (removeElements) {
        bindEvents();
    }
};

const bindEvents = () => {

    $(document).on('click', '.js-easter-link-whatsapp', () => {
        pushEvent('whatsapp');
    });

    $(document).on('click', '.js-easter-link-messenger', () => {
        pushEvent('messenger');
    });

    $(document).off('click.easter', '.js-easter-ar-button').on('click.easter', '.js-easter-ar-button',(e) => {
        const $this = $(e.target);
        const popupData = $this.data('popup-data');
        if (!popupData) {
            return;
        }

        const $modelViewers = $('.js-egg-model-viewer');

        if (!isTouchDevice() || !$modelViewers || !$modelViewers.length || !$modelViewers[0].canActivateAR) {
            QRcode.toDataURL(getUpdatedURLWithParams({triggerARMode: true, skipAnimation: true}, ['skipAnimation'], true), {width: 180})
            .then(QRcodeURL => {
                arView.show(popupData, QRcodeURL, $this);
            });
            return;
        }
    });
};

const arView = {
    show: (data, QRcodeURL, taget) => {
        const $this = $(taget).closest('.js-easter-ar-block-wrapper');
        pushEvent($this && $this.length ? 'content view in 3D' : 'main view in 3d');
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: data.header,
                description: data.description
            },
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            ctaHolder: {},
            easterModal: true,
            icon: data.icon,
            QRcodeURL: QRcodeURL
        });
    }
};

const updateARbuttons = (src, iosSrc, description) => {
    if (!src || !iosSrc || !description) {
        return;
    }
    const $element = $('.js-easter-ar-button');
    if (!$element || !$element.length) {
        return;
    }
    const popupData = $element.data('popup-data');
    if (!popupData) {
        return;
    }
    popupData.src = src;
    popupData.iosSrc = iosSrc;
    popupData.description = description;

    $element.attr('data-popup-data', JSON.stringify(popupData));
};

const updateARmodel = (src, iosSrc) => {
    if (!src || !iosSrc) {
        return;
    }
    const $element = $('.js-egg-model-viewer');
    if (!$element || !$element.length) {
        return;
    }

    $element.attr('src', src);
    $element.attr('ios-src', iosSrc);
};

const pushDataLayerDataForFAQBlock = (questionText) => {
    const isEasterPDP = $('.js-easter-pdp').length;
    if (isEasterPDP && questionText) {
        pushEvent(questionText);
    }
};


module.exports = {
    init: init,
    updateARbuttons: updateARbuttons,
    updateARmodel: updateARmodel,
    pushEvent: pushEvent,
    pushDataLayerDataForFAQBlock
};

},{"../modules/google":453,"../modules/helpers/isTouchDevice":473,"../modules/util/getUpdatedURLWithParams":495,"qrcode":225}],425:[function(require,module,exports){
'use strict';

const inStore = require('./pages/product/inStore');
const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');
const ritualsFormHelper = require('./rituals-form-helper');
const damHelper = require('./dam/dam-helper');

const isPG = $('.js-pdp-main').hasClass('giftset-pdp-main-container');
const pgCustomizeEvents = {
    onSubmit: $.Event('pgCustomize.onSubmit')
};

function initEvents(){
    // Instore availability flyout
    inStoreFlyoutEvents();

    // close flyouts when clicking the modal overlay or the flyout close button
    $(document).on('click touchstart', '.js-modal-overlay, .js-close-flyout, .js-side--close', function(){
        closeFlyouts();
    });

    $('.js-close-flyout').on('keyup', function(e){
        if (e.which == 13) {
           // on enter close the flyout
           closeFlyouts();
         }
    });

    $(document).on('keyup', function(e) {
        if (e.which == 27 && (
            flyout.def.$minicartFlyout.hasClass('open') ||
            flyout.def.$inStoreAvailabilityEl.hasClass('open') ||
            flyout.def.$inStoreAvailabilityHor.hasClass('open') ||
            flyout.def.$flyoutGeneralEl.hasClass('open'))) {
            // on escape close the flyout
            closeFlyouts();
       }
   });

    //if flyouts are closed, disable tabbing through them
    if (!flyout.def.$minicartFlyout.hasClass('open')) {
        flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$inStoreAvailabilityEl.hasClass('open')) {
        flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$inStoreAvailabilityHor.hasClass('open')) {
        flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    }

    if (!flyout.def.$flyoutGeneralEl.hasClass('open')) {
        flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');
    }

    //if mobile confirmation popup is closed, disable tabbing through it
    if (!$('.js-cart-confirm-mobile').hasClass('open')) {
        $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
    }

    if (isPG) {
        $('.js-mobile-cart-confirmation-link').on('click', function() {
            $(document).trigger(pgCustomizeEvents.onSubmit);
        });
    }
}

/**
 * @function
 * @description inits events for the instore availability flyout
 */
function inStoreFlyoutEvents(){
    // Show extra store info when user clicks arrow
    $('body').on('click', '.js-expand-row-btn', inStoreAccordions);

    $('body').on('keyup', '.js-expand-row-btn', function(e){
        if (e.which == 13) {
           // on enter open the accordion
           inStoreAccordions(e);
        }
    });

}

function inStoreAccordions(e) {
    const $this = $(e.target);
     // prevent bubbling (and collapsing the panel) when clicking in the "call store" button
     if ($this.hasClass('js-call-store-button')){
        return;
    }

    const extraInfoPanel = $this.closest('.js-list-row').find('.js-extra-info');
    extraInfoPanel.toggleClass('collapsed');
    $this.toggleClass('active');

    // get automatic height value of the panel
    const autoHeight = extraInfoPanel.css('height', 'auto').height();

    if (extraInfoPanel.hasClass('collapsed')){
        extraInfoPanel.stop().animate({height: 0}, 300);

        extraInfoPanel.parent().removeClass('active');
    } else {
        extraInfoPanel.height(0).stop().animate({height: autoHeight + 20}, 300); // + 20px to add margin to top
        extraInfoPanel.parent().addClass('active');
    }
}

/**
 * @function
 * @description Open Instore availability flyout
 */
function openInStoreAvailabilityFlyout(skipRefreshing){
    // When ROPO flyout opens refresh flyout, clean previous stores etc
    if (!skipRefreshing){
        inStore.refreshFlyout();
    }

    open({
        flyoutType: 'instoreavailability'
    });
}

/**
 * @function
 * @description Open Instore availability for HOR products flyout
 */
function openInStoreAvailabilityHORFlyout(){
    open({
        flyoutType: 'instoreavailability-hor'
    });
}

/**
 * @function
 * @description General open flyout function
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function open(params){
    if (params.flyoutType) {
        if (params.flyoutType === 'instoreavailability'){
            flyout.def.$inStoreAvailabilityEl.addClass('open');
            $('.js-flyout-skip-to-content').focus();

            //if ROPO is open, enable tabbing through it
            flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '0');

            $(document).on('keydown', '.js-check-instore-availabilty-wrapper', function (e) {
                if (!$('.wrap-details').length) {
                    if (e.which == 9 && !e.shiftKey) {
                        e.preventDefault();
                        $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
                    }
                }
            });

            $('.js-show-more-btn').on('keydown', function (e) {
                if (e.which == 9 && !e.shiftKey) {
                    e.preventDefault();
                    $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
                } else if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    flyout.def.$inStoreAvailabilityEl.find('.wrap-details:last-child .list-row:last-child').focus();
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    if (!$('.wrap-details').length) {
                        $('.js-check-instore-availabilty-wrapper').focus();
                    } else if (!$('.js-show-more-btn').hasClass('js-hidden-show-more')) {
                        $('.js-show-more-btn').focus();
                    } else {
                        $('.wrap-details:last-child .js-list-row:last-child').focus();
                    }
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9) {
                    if ($('.js-flyout-amsterdam').length) {
                        const $this = $(this);
                        e.preventDefault();
                        $this.focus();
                    }
                }
            });

        } else if (params.flyoutType === 'minicart') {
            flyout.def.$minicartFlyout.addClass('open');

            damHelper.updateImages($('.js-minicart-flyout'));

            //if minicart is open, enable tabbing through it
            flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '0');

            $('.js-miniflyout-skip-to-content').focus();
            minicartHeights();
            let $lastButtonMinicart;

            //when a user finishes tabbing through the minicart, they will end up on the close icon
            if ($('.empty-minicart-bottom').length) {
                $lastButtonMinicart = flyout.def.$minicartFlyout.find('.empty-minicart-bottom').find('a.btn');
            } else {
                $lastButtonMinicart = flyout.def.$minicartFlyout.find('.js-minicart-flyout-checkout').find('button.btn');
            }

            $lastButtonMinicart.on('keydown', function (e) {
                if (e.which == 9 && !e.shiftKey) {
                    e.preventDefault();
                    flyout.def.$minicartFlyout.find('.js-close-flyout').focus();
                }
            });

            $('.js-close-flyout').on('keydown', function(e) {
                if (e.which == 9 && e.shiftKey) {
                    e.preventDefault();
                    $lastButtonMinicart.focus();
                }
            });

            if (isPG) {
                $('.js-minicart-flyout-checkout').find('button.btn').on('click', function() {
                    $(document).trigger(pgCustomizeEvents.onSubmit);
                });
            }

            $('.js-minicart-flyout-checkout').find('button[type="submit"]').on('click', function(){
                $(this).addClass('button-loading');
                $(this).find('.js-spinner-general').addClass('spinner-visible');
            });

            $('.js-minicart-flyout-spinner').find('button[type="submit"]').on('click', function(){
                $(this).addClass('hide');
                $('.js-spinner-general.spinner-custom-desktop').addClass('show');
            });
        } else if (params.flyoutType === 'instoreavailability-hor') {
            flyout.def.$inStoreAvailabilityHor.addClass('open');
            $('.js-flyout-skip-to-content').focus();

            //if flyout is open, enable tabbing through it
            flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '0');

            $(document).on('keydown', '.js-check-instore-availabilty-hor-wrapper', function (e) {
                if (!$('.wrap-details').length) {
                    if (e.which == 9 && !e.shiftKey) {
                        e.preventDefault();
                        $('.js-instore-availability-hor-flyout').find('.js-close-flyout').focus();
                    }
                }
            });

            $('.js-close-flyout').on('keydown', function (e) {
                if (e.which == 9) {
                    if ($('.js-flyout-hor').length) {
                        const $this = $(this);
                        e.preventDefault();
                        $this.focus();
                    }
                }
            });

        }
    } else {
        flyout.def.$genericFlyout.addClass('open');

        //if flyout is open, enable tabbing through it
        flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '0');

        $('.js-genericflyout-skip-to-content').focus();

        //when a user finishes tabbing through the general flyout, they will end up on the close icon
        const $lastButtonFlyout = flyout.def.$genericFlyout.find('.js-password-reset-button');

        $lastButtonFlyout.on('keydown', function (e) {
            if (e.which == 9 && !e.shiftKey) {
                e.preventDefault();
                flyout.def.$genericFlyout.find('.js-close-flyout').focus();
            } else if (e.shiftKey && e.which == 9) {
                e.preventDefault();
                flyout.def.$genericFlyout.find('.input-row').find('input').focus();
            }
        });

        $(document).on('keydown', '.js-generic-flyout .js-close-flyout', function(e) {
            if (e.which == 13) {
                closeFlyouts();
                if ($('.js-password-reset-dialog').length) {
                    $('.js-password-reset-dialog').focus();
                }
            }
        });

        $(document).on('keydown', '.js-generic-flyout .js-close-flyout', function(e) {
            if (e.shiftKey && e.which == 9) {
                e.preventDefault();
                $lastButtonFlyout.focus();
            }
        });
    }

    // show modal overlay
    flyout.def.$modalOverlay.fadeIn();

    ritualsFormHelper.init();

    if ($('.js-personalised-promo-block-anchor').length) {
        $('html, body').stop().animate({
            scrollTop: $('.js-product-list-slider-block').offset().top
        }, 1600, 'easeOutQuart');

        setTimeout(() => {
            scrollHelper.disableScroll();
        }, 600);
        $('.js-product-list-slider-block').removeClass('js-personalised-promo-block-anchor');
    } else {
        // lock body scroll
        scrollHelper.disableScroll();
    }

    if (params.close) {
        flyout.def.$genericFlyout.off('closeFlyout');
        flyout.def.$genericFlyout.on('closeFlyout', function () {
            params.close();
        });
    }
}

/**
 * @function
 * @description Loads flyout content from the HTML that is already present on the page
 * @param {html} html content
 */
function loadFromHtml(html, options) {
    flyout.def.$flyoutContent.html(html);

    initEvents();

    const params = {};
    if (options.close){
        params.close = options.close;
    }

    open(params);

    if (options.open) {
        options.open();
    }
}

/**
 * @function
 * @description Loads flyout content through ajax and then opens and inits it
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function load(options){
    ajax.load({
        url: options.url,
        target: flyout.def.$flyoutContent,
        callback: function () {
            initEvents();
            const params = {};
            if (options.close){
                params.close = options.close;
            }
            open(params);
            if (options.open) {
                options.open();
            }
        }
    });
}

/**
 * @function
 * @description Close all flyouts and overlay
 */
function closeFlyouts(){
    // close all flyouts
    flyout.def.$flyoutGeneralEl.removeClass('open');

    $('.js-flyout-opened').focus();
    setTimeout(function() {
        $('.js-flyout-opened').removeClass('js-flyout-opened');
    },400);

    //if flyouts are closed, disable tabbing through them
    flyout.def.$minicartFlyout.find('a, button, .js-miniflyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$inStoreAvailabilityEl.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$inStoreAvailabilityHor.find('.js-close-flyout, input, a, button, .js-check-instore-availabilty-hor-wrapper, .js-flyout-skip-to-content').attr('tabindex', '-1');
    flyout.def.$flyoutGeneralEl.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');

    // remove modal overlay
    flyout.def.$modalOverlay.fadeOut();

    // unlock body scroll
    scrollHelper.enableScroll();

    // Close possible mobile confirmation
    hideMobileConfirmation();

    flyout.def.$flyoutGeneralEl.trigger('closeFlyout');

    if ($('.js-generic-flyout').hasClass('address-flyout')) {
        setTimeout(function () {
            $('.js-generic-flyout').removeClass('address-flyout');
        }, 500);
    }
}

function isOpened() {
    return flyout.def.$genericFlyout.hasClass('open');
}

/**
 * @function
 * @description The hiding of the mobile confirmation
 */
function hideMobileConfirmation() {
    $('.js-cart-confirm-mobile').removeClass('open');
    $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
}

/**
 * @function
 * @description Check minicart contents height to show a shadow if content is scrollable
 */
function minicartHeights() {
    const $miniProducts = flyout.def.$minicartFlyout.find('.js-minicart-flyout-wrapper');
    const $miniTotals = flyout.def.$minicartFlyout.find('.js-minicart-flyout-checkout');

    if ($miniProducts.outerHeight() > flyout.def.$minicartFlyout.height() - $miniTotals.outerHeight()) {
        $miniTotals.addClass('has-shadow');
    } else {
        $miniTotals.removeClass('has-shadow');
    }
}

const flyout = {
    def: {
        $flyoutGeneralEl: $('.js-flyout-container'),
        $inStoreAvailabilityEl: $('.js-instore-availability-flyout'),
        $inStoreAvailabilityHor: $('.js-instore-availability-hor-flyout'),
        $minicartFlyout: $('.js-minicart-flyout'),
        $modalOverlay: $('.js-modal-overlay'),
        $genericFlyout: $('.js-generic-flyout'),
        $flyoutContent: $('.js-flyout-content')
    },
    init: function () {
        initEvents();
        inStore(); //Initialize inStore
    },
    open: open,
    load: load,
    loadFromHtml: loadFromHtml,
    isOpened: isOpened,
    openInStoreAvailabilityFlyout: openInStoreAvailabilityFlyout,
    openInStoreAvailabilityHORFlyout: openInStoreAvailabilityHORFlyout,
    closeFlyouts: closeFlyouts
};

module.exports = flyout;

},{"./dam/dam-helper":419,"./modules/ajax":449,"./modules/helpers/scroll":475,"./pages/product/inStore":551,"./rituals-form-helper":590}],426:[function(require,module,exports){
'use strict';
const pushDataLayer = require('../../src/js/modules/helpers/analyticsHelper');

function openFooterAccordion() {
    const $footerHiddenColumns = $('.js-accordion-inner:nth-child(n+6)');
    const $footerHiddenLinks = $('.js-accordion-content-inner li:nth-child(n+4)');
    const $footerMiddleElements = $('.js-footer-middle-elements');

    $(document).on('mouseover', '.js-footer-accordion', function() {
        $footerHiddenLinks.addClass('visible');
        $footerHiddenColumns.addClass('visible');
        $footerMiddleElements.addClass('slide');
    });
}

function sendAnalyticsEvent() {
  const items = $('.accordion-content li');

  items.on('click', function (e) {
    e.stopPropagation();
    const footerItemText = $(this).find('a').text().trim();
    pushDataLayer({
      event: 'menu_navigation',
      menu: 'footer',
      menu_path: `Footer, ${footerItemText}`.toLowerCase(),
      menu_text: footerItemText.toLowerCase(),
      menu_click: 'text'
    });
  });

  const icons = $('.social--icons li a');
  icons.on('click', function (e) {
    e.stopPropagation();
    const footerIconText = $(this).attr('alt').replace('logo ', '');

    pushDataLayer({
      event: 'menu_navigation',
      menu: 'footer',
      menu_path: `Footer, ${footerIconText}`.toLowerCase(),
      menu_text: footerIconText.toLowerCase(),
      menu_click: 'picture'
    });
  });
}

function initializeEvents() {
    openFooterAccordion();
    sendAnalyticsEvent();
}

const footer = {
  init: function() {
    initializeEvents();
  }
};

module.exports = footer;

},{"../../src/js/modules/helpers/analyticsHelper":455}],427:[function(require,module,exports){
'use strict';

/**
 * FE logic for navigation-accordion PD component
 */

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');

const genericNavAccordion = {
    init : function() {
        handleScreenSize();

        $(document).on('click', '.js-generic-nav-button', function () {
            setActiveTopicDesktop($(this).data('topic-header'));
        });

        $(document).on('change', '.js-dropdown-select', function () {
            setActiveTopicMobile($(':selected', $(this)).data('topic-header'));
        });

        $(document).off('click', '.js-generic-acc-head-button').on('click', '.js-generic-acc-head-button', function(e) {
            accordionToggle($(e.target));
        });


        $('a[data-link-label="cookie-settings"], a[href="cookie-settings"]')
            .addClass('optanon-toggle-display')
            .attr('href', 'javascript:void(0);')
            .attr('onclick', 'OneTrust.ToggleInfoDisplay(); return false');

        $('.optanon-toggle-display').attr('onclick', 'OneTrust.ToggleInfoDisplay(); return false');

        $(document).on('click', 'a[data-link-label="cookie-settings"]', function (e) {
            e.preventDefault();
        });


        let isTouchScrolling = false;
        let isScrolling = false;
        $(window).on('scroll', function() {
            isScrolling = true;
        });
        $(window).on('touchmove', function() {
            isTouchScrolling = true;
        });
        $(window).on('resize', function() {
            //Touch scrolling causes an misleading resize event on IOS
            if (!isTouchScrolling && !isScrolling){
                handleScreenSize();
                isScrolling = false; //reset scrolling flag
            }
        });
        $(window).on('touchend', function() {
            setTimeout(function() {
                isTouchScrolling = false; //reset touchScroll flag
            }, 100);
        });
    }
};

function handleScreenSize() {
    if (!isMobileOrTabletWidth()) {
        setActiveTopicDesktop();
    } else {
        setActiveTopicMobile();
    }
}

function setActiveTopicDesktop(topic) {
    const $topicElement = getTopicElement(topic);
    if (!$topicElement) {return;}

    $('button', '.js-generic-nav').removeClass('active');
    $topicElement.addClass('active');
    const $topicBreadcrumbElement = $('.js-breadcrumb-element-topic', '.js-generic-nav');
    $('span', $topicBreadcrumbElement).text($topicElement.data('topic-header'));

    updateAccordion($topicElement);
}

function setActiveTopicMobile(topic) {
    const $topicMobileElement = getTopicMobileElement(topic);
    if (!$topicMobileElement) {return;}

    $('option', '.js-dropdown-select').removeAttr('selected');
    $topicMobileElement.attr('selected', 'selected');

    updateAccordion($topicMobileElement);
}

function getTopicElement(topic) {
    let $topicToBeSelected = $('button[data-topic-header="' + topic + '"]', '.js-generic-nav');
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('button', '.js-generic-nav')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getTopicMobileElement(topic) {
    let $topicToBeSelected = $('option[data-topic-header="' + topic + '"]','.js-dropdown-select');

    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('option', '.js-dropdown-select')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function updateAccordion(button) {
    const accordionId = $(button).data('accordion-id');
    if (!accordionId) {
        $('.js-generic-accordion-wrapper').empty();
        return;
    }

    const $accordionElement = $('div[data-accordion-id="' + accordionId + '"]').clone();
    if (!$accordionElement || !$accordionElement.length) {
        $('.js-generic-accordion-wrapper').empty();
        return;
    }

    $('.js-generic-accordion-wrapper').empty().append($accordionElement[0]);
    $('.js-generic-accordion-wrapper').children().removeClass('hide');
}

function accordionToggle(button) {
    const accHeadClass = '.js-generic-acc-head';
    const accContentClass = '.js-generic-acc-content';
    const $parent = button.parent(accHeadClass);
    const $siblings = $parent.parent().siblings();

    if (!$parent.hasClass('open-acc')) {
        $siblings.find(accHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(accContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(accContentClass).stop().slideDown().attr('aria-hidden', 'false');
        return;
    }

    $parent.removeClass('open-acc').attr('aria-expanded', 'false');
    $parent.siblings(accContentClass).stop().slideUp().attr('aria-hidden', 'true');
}

module.exports = genericNavAccordion;

},{"./modules/util/isMobileOrTabletWidth":498}],428:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');

function initEvents() {
    if (this.initialized) {
        return;
    }

   genericFlyout.$closeFlyouts.on('keyup', function(e){
        if (e.which == 13) {
           closeFlyouts();
        }
    });

    $(document).on('keyup', function(e) {
        if (e.which !== 27) {
            return;
        }
        closeFlyouts();
   });

   this.initialized = true;

}

function open(params) {
    genericFlyout.def.$genericFlyout.addClass('open');

    handleAccessibility();

    genericFlyout.def.$modalOverlay.fadeIn();

    scrollHelper.disableScroll();

    if (params.open) {
        params.open();
    }

    if (params.close) {
        genericFlyout.def.$genericFlyout.off('closeFlyout');
        genericFlyout.def.$genericFlyout.on('closeFlyout', function () {
            params.close();
        });
    }

    genericFlyout.def.$closeButton.prependTo(genericFlyout.def.$flyoutContent);
}

function closeFlyouts(){
    genericFlyout.def.$genericFlyout.removeClass('open');
    const openedFlyout = $('.js-flyout-opened');
    openedFlyout.focus();
    setTimeout(function() {
        openedFlyout.removeClass('js-flyout-opened');
    },400);

    genericFlyout.def.$genericFlyout.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '-1');

    genericFlyout.def.$modalOverlay.fadeOut();

    scrollHelper.enableScroll();

    genericFlyout.def.$genericFlyout.trigger('closeFlyout');
}

function handleAccessibility() {
    genericFlyout.def.$genericFlyout.find('.js-close-flyout, input, button, a, .js-genericflyout-skip-to-content').attr('tabindex', '0');
    $('.js-genericflyout-skip-to-content', genericFlyout.def.$genericFlyout).focus();
}

function load(options){
    ajax.load({
        url: options.url,
        target: genericFlyout.def.$flyoutContent,
        callback: function () {
            open(options);
        }
    });
}

const genericFlyout = {
    initialized: false,
    def: {
        $modalOverlay: $('.js-modal-overlay'),
        $genericFlyout: $('.js-generic-flyout'),
        $flyoutContent: $('.js-flyout-content'),
        $closeButton: $('.js-generic-flyout .js-close-flyout')
    },
    init: initEvents.bind(this),
    load: load,
    closeFlyouts: closeFlyouts
};

module.exports = genericFlyout;

},{"./modules/ajax":449,"./modules/helpers/scroll":475}],429:[function(require,module,exports){
'use strict';

const gtm = require('./modules/google').tagManager;
const giftRevealSection = document.querySelector('.js-gift-reveal');
const giftRevealButtons = document.querySelectorAll('.js-gift-reveal-btn');
const giftRevealCloseButtons = document.querySelectorAll('.js-giftopen-close-btn');
const phaseVideoElement = document.querySelector('.js-phase-video');
const revealElements = document.querySelectorAll('.js-reveal-element');
const revealDelay = 300;

const shouldInit = () => {
    return giftRevealSection !== null;
};

const giftRevealClick = () => {
    giftRevealButtons.forEach((singleBox) => {
        singleBox.addEventListener('click', function () {
            $('html, body').animate({
                scrollTop: $('.js-crm-hero').length > 0 ? $('.js-gift-reveal').offset().top : 0
            }, '800');
            if (singleBox.closest('.js-gift-reveal-event')){
                pushDataLayerEventCRM(singleBox.closest('.js-gift-reveal-event'));
            }
            this.closest('.phase-section').classList.add('phase-section-open');
            this.closest('.giftopen-single-box').classList.add('giftopen-single-box-open');
            this.classList.add('giftopen-btn-hide');
            const w = window.innerWidth / 2;
            this.closest('.giftopen-single-box').style.left = parseInt(w) + 'px';

            setTimeout(() => {
                this.parentElement.querySelector('.js-giftopen-close-btn').classList.add('giftopen-btn-show');
                this.parentElement.querySelector('.giftopen-timer').classList.add('giftopen-timer-show');
                $(this).parent().parent().find('.gift-reveal-body').css({'display': 'block'})
                    .animate({
                        top: '0',
                        opacity: '1'
                    }, {
                        queue: false,
                        duration: 'slow'
                    });
            }, 1000);
        });
    });
};

const giftRevealClose = () => {
    giftRevealCloseButtons.forEach(singleCloseButton => {
        singleCloseButton.addEventListener('click', function () {
            if (!$('.js-crm-hero').length > 0) {
                $('html, body').animate({
                    scrollTop: 0
                }, '800');
            }

            this.classList.remove('giftopen-btn-show');
            this.nextElementSibling.classList.remove('giftopen-timer-show');
            $(this).parent().parent().parent().find('.gift-reveal-body')
                .animate({
                        opacity: 0,
                        top: '20px'
                    },
                    1000,
                    function() {
                        $(this).removeAttr('style');
                    }
                );

            setTimeout(() => {
                this.closest('.phase-section').classList.remove('phase-section-open');
                this.closest('.giftopen-single-box').classList.remove('giftopen-single-box-open');
                this.parentElement.parentElement.querySelector('.js-gift-reveal-btn').classList.remove('giftopen-btn-hide');
            }, 1000);
        });
    });
};

const pushDataLayerEventCRM = function(event){
    const analyticsData = $(event.attributes['data-analytics']);
    if (!analyticsData) {
        return;
    }
    const analytics = JSON.parse(analyticsData[0].value);
    gtm.pushDataLayerEvent(analytics);
};

const initEvents = () => {
    giftRevealClick();
    giftRevealClose();
};

const initRevealElements = () => {
    prepareRevealElements();

    ['timeupdate', 'loadeddata'].forEach(evt => {
        phaseVideoElement.addEventListener(evt, (e) => {
            if (giftRevealSection.classList.contains('is-loading')) {
                e.target.pause();
                e.target.currentTime = 0;
                giftRevealSection.classList.remove('is-loading');
                fireRevealAnimations();

                setTimeout(() => {
                    e.target.play();
                }, 1400);

                cleanUpRevealElements();
            }
        }, false);
    });
};

const prepareRevealElements = () => {
    revealElements.forEach(el => {
        el.classList.add('reveal-base');
    });
};

const fireRevealAnimations = () => {
    revealElements.forEach((el, idx) => {
        if (el.hasAttribute('data-reveal-group')) {
            const group = el.dataset.revealGroup;
            const groupedEls = document.querySelectorAll(`[data-reveal-group='${group}']`);

            groupedEls.forEach((elInGroup) => {
                setTimeout(() => {
                    elInGroup.classList.add('reveal');
                }, idx * revealDelay);
            });
        } else {
            setTimeout(() => {
                el.classList.add('reveal');
            }, idx * revealDelay);
        }
    });
};

const cleanUpRevealElements = () => {
    setTimeout(() => {
        revealElements.forEach(el => {
            el.classList.remove('reveal-base', 'reveal');
        });
    }, revealElements.length * revealDelay);
};

const giftReveal = {
    init: () => {
        if (shouldInit()) {
            initEvents();
            initRevealElements();
        }
    }
};

module.exports = giftReveal;

},{"./modules/google":453}],430:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax'),
    ajaxUrl = require('./modules/util/ajaxUrl'),
    bonusProductsView = require('./bonus-products-view');

const setAddToCartHandler = function (e) {
    e.preventDefault();
    const form = $(this).closest('form');

    const options = {
        url: ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };
    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {lineItemId: response.result.lineItemId},
                callback: function (response) {
                    bonusProductsView.show({url: $($.parseHTML(response)).find('#js-minicart-bonus-product-url').data('bonusproducturl'), giftChange: false, response: response, isAddedPopup: $($.parseHTML(response)).find('#js-minicart-bonus-product-url').data('showadded')});
                    form.find('input,textarea').val('');
                }
            });
        } else {
            form.find('span.error').hide();
            for (const id in response.errors.FormErrors) {
                let $errorEl = $('#' + id).addClass('error').removeClass('valid').next('.error');
                if (!$errorEl || $errorEl.length === 0) {
                    $errorEl = $('<span for="' + id + '" generated="true" class="error" style=""></span>');
                    $('#' + id).after($errorEl);
                }
                $errorEl.text(response.errors.FormErrors[id].replace(/\\'/g, '\'')).show();
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            console.info(Resources.BAD_RESPONSE);
        } else {
            console.info(Resources.SERVER_CONNECTION_ERROR);
        }
    });
};

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);
};

},{"./bonus-products-view":276,"./modules/ajax":449,"./modules/util/ajaxUrl":478}],431:[function(require,module,exports){
'use strict';

const $giftsetHowTo = $('.js-product-container-giftset');
const gtm = require('./modules/google').tagManager;

const shouldInit = $giftsetHowTo.length > 0;

const handleImageInteraction = (interactionType) => {
    const analyticsData = $giftsetHowTo.data('analytics');
    if (!analyticsData) {
        return;
    }

    gtm.pushDataLayerEvent({
        event: 'gst',
        interaction: interactionType,
        content_type: 'pdp', /* eslint-disable-line camelcase */
        content_name: analyticsData.productTitle /* eslint-disable-line camelcase */
    });
};

function handleShopOverlay() {
    const $imageZoom = $('.js-click-image-to-zoom');
    const $image = $('.js-how-to-use-image-zoomed');
    const $btnClose = $('.js-product-close');

    $imageZoom.on('click', function (){
        if (!$image.hasClass('image-zoomed')) {
            $image.addClass('image-zoomed');
        } else {
            $image.removeClass('image-zoomed');
        }

        handleImageInteraction('zoom');
    });

    $btnClose.on('click', function (){
        $image.removeClass('image-zoomed');
        handleImageInteraction('exit');
    });
}

function initializeEvents() {
    handleShopOverlay();
}

const giftsetZoom = {
    init: function() {
        if (shouldInit) {
            initializeEvents();
        }
    }
};

module.exports = giftsetZoom;

},{"./modules/google":453}],432:[function(require,module,exports){
'use strict';

const gtm = require('./modules/google').tagManager;

function isGiftsetFastlaneSite() {
    const headerLogo = $('.js-header-logo');
    const href = headerLogo.length > 0 && headerLogo[0].href;
    if (href) {
        return href.includes('gifting');
    }
    return false;
}

function pushDataLayerEventForFAQBlock(clickTarget) {
    if (!clickTarget || !isGiftsetFastlaneSite()) {
        return;
    }

    const dataLayerData = {
        'event': 'gst',
        'interaction': 'expand',
        'content_name': 'faq',
        'clickTarget': clickTarget
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

module.exports = {
    pushDataLayerEventForFAQBlock: pushDataLayerEventForFAQBlock
};

},{"./modules/google":453}],433:[function(require,module,exports){
'use strict';

const ritualsStyles = require('./rituals-styles'),
    giftwrapping = require('./giftwrapping'),
    greetingcard = require('./greetingcard'),
    damHelper = require('./dam/dam-helper'),
    taxFreeThresholdPassedWarning = require('./pages/checkout/taxFreeThresholdPassedWarning');

const GiftWrap = function () {
    function init() {
        giftwrapping.init(updateGiftWrapAndGreetingCardBlockAndPrice);
        greetingcard.init(updateGiftWrapAndGreetingCardBlockAndPrice);
    }

    function updateGiftWrapAndGreetingCardBlockAndPrice(updatedHtml) {
        if (!updatedHtml) {
            return;
        }

        const $info = $(updatedHtml).filter('.js-giftwrap-updated-info');

        updateOrderTotals($info);

        updateGiftWrappingAndGreetingCardBlocks($info, '.js-giftwrapping-info', '.js-giftwrap');
        updateGiftWrappingAndGreetingCardBlocks($info, '.js-greetingcard-info', '.js-greetingcard');

        updateGiftWrappingAndGreetingCardLineItems($info, '.js-gift-wrapping-line-item', '.js-cart-giftwrapping-row');
        updateGiftWrappingAndGreetingCardLineItems($info, '.js-greetingcard-line-item', '.js-cart-greetingcard-row');
    }

    function updateGiftWrappingAndGreetingCardLineItems(info, cartItemClass, lineItemClass) {
        const $lineItem = $(cartItemClass, info);
        if ($lineItem.length) {
            const $cartItems = $('.js-cart-items');
            const $cartItem = $(lineItemClass, $cartItems);
            if ($cartItem.length) {
                $cartItem.replaceWith($lineItem.html());
                damHelper.updateImages($(lineItemClass, $cartItems));
                return;
            }

            $cartItems.append($lineItem.html());
            damHelper.updateImages($cartItems);
            return;
        }
    }

    function updateGiftWrappingAndGreetingCardBlocks(info, blockHolderClass, blockClass) {
        const $blockInfo = $(blockHolderClass, info);
        if ($blockInfo.length) {
            $(blockClass).replaceWith($blockInfo.html());
            damHelper.updateImages($(blockClass));
        }
    }

    function updateOrderTotals(info) {
        const $orderTotalsInfo = $('.js-order-totals-info', info);
        if (!$orderTotalsInfo.length) {
            return;
        }

        const orderSubtotalValue = $orderTotalsInfo.find('.js-order-subtotal-value');
        if (orderSubtotalValue.length) {
            $('.js-order-subtotal-value').html(orderSubtotalValue.html());
        }

        const totalPrice = $orderTotalsInfo.find('.js-order-value');
        if (totalPrice.length) {
            $('.js-order-value').html(totalPrice.html());
        }

        const taxFreeThresholdBlock = $orderTotalsInfo.find('.js-tax-warning-block');
        if (!taxFreeThresholdBlock.length) {
            return;
        }

        $('.js-tax-warning-block').html(taxFreeThresholdBlock.html());
        taxFreeThresholdPassedWarning.createDialog();
    }

    function showGiftWrapMessage(page, updateFunction, previousRadioButton, explanationText) {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.GIFTWRAP,
            },
            paragraphs: [
                {
                    text: explanationText
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.CONTINUE,
                    eventName: 'onGiftWrapModalPrimaryButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                eventName: 'onGiftWrapModalCloseElementClick',
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });

        window.eventBus.$off('onGiftWrapModalPrimaryButtonClick');
        window.eventBus.$off('onGiftWrapModalCloseElementClick');

        window.eventBus.$once('onGiftWrapModalPrimaryButtonClick', function() {
            if (updateFunction) {
                updateFunction();
            }
        });

        window.eventBus.$once('onGiftWrapModalCloseElementClick', function() {
            if (updateFunction && page !== 'checkout_page') {
                updateFunction();
            } else {
                if (previousRadioButton) {
                    previousRadioButton.prop('checked', true);
                }
            }
        });
    }

    function enableOrDisableGiftWrap(enable, rewrap, callback) {
        $.ajax({
            type: 'POST',
            url: Urls.enableOrDisableGiftWrap,
            data: 'enable=' + enable + '&rewrap=' + rewrap,
            success: function(data) {
                updateGiftWrapAndGreetingCardBlockAndPrice(data);

                greetingcard.onloadSetSelectedCard();
                initLazyLoad();

                if (callback && $.isFunction(callback)) {
                    callback();
                }
            }
        });
    }

    function getGiftwrapDataForSelectedShippingOption(shippingOption, page, previousRadioButton, callback) {
        $.ajax({
            type: 'POST',
            url: Urls.getGiftwrapDataForSelectedShippingOption,
            contentType: 'application/json',
            data: JSON.stringify({
                shippingOption: shippingOption,
                page: page
            })
        }).done(function(response) {
            if (!response || !response.giftWrapData) {
                if (callback && $.isFunction(callback)) {
                    callback();
                }
                return;
            }
            console.log(response.giftWrapData);

            if (!response.giftWrapData.showGiftWrapMessage) {
                enableOrDisableGiftWrap(response.giftWrapData.enable, response.giftWrapData.rewrap, callback);

                return;
            }

            showGiftWrapMessage(
                page,
                function () {
                    enableOrDisableGiftWrap(response.giftWrapData.enable, response.giftWrapData.rewrap, callback);
                },
                previousRadioButton,
                response.giftWrapData.giftWrapModalText
            );
        });
    }

    function initLazyLoad() {
        if ($('.js-lazy-load').length) {
            ritualsStyles.initLazyLoad();
        }
    }

    return {
        init: init,
        getGiftwrapDataForSelectedShippingOption: getGiftwrapDataForSelectedShippingOption
    };
};

module.exports = new GiftWrap();

},{"./dam/dam-helper":419,"./giftwrapping":434,"./greetingcard":436,"./pages/checkout/taxFreeThresholdPassedWarning":530,"./rituals-styles":592}],434:[function(require,module,exports){
'use strict';

const flyout = require('./flyout'),
    ritualsStyles = require('./rituals-styles'),
    damHelper = require('./dam/dam-helper'),
    gtm = require('./modules/google').tagManager;

const GiftWrapping = function () {
    let resetOption = true;
    let clearGiftWrappingWhenClosed = false;
    const wrappingTypes = {
        NONE: 'none',
        TOGETHER: 'together',
        INDIVIDUAL: 'individual'
    };
    function init(updateGiftWrapAndGreetingCardBlockAndPrice) {
        $(document).on('change', '.js-giftwrap-checkbox', wrap);

        $(document).on('click', '#wrap-together', wrapTogether);

        $(document).on('click', '#wrap-individual', wrapIndividual);

        $(document).on('click', '.js-giftwrap-edit', function () {
            $('#wrap-individual').prop('checked', true);
            showDialog();
            resetOption = false;
        });

        $(document).on('click', '.js-remove-gift-wrapping', function (e) {
            e.preventDefault();
            e.stopPropagation();
            clearGiftWrapping();
        });

        function wrap() {
            const $this = $(this);
            if (!$this.prop('checked')) {
                clearGiftWrapping();
                return;
            }

            const $wrapIndividualCheckbox = $('#wrap-individual');
            if ($wrapIndividualCheckbox.length && $wrapIndividualCheckbox.prop('checked')) {
                $this.prop('checked', true);
                $('.js-giftwrap-options').addClass('enabled');
                resetOption = false;
                clearGiftWrappingWhenClosed = true;
                showDialog();
                return;
            }

            const $wrapTogetherCheckbox = $('#wrap-together');
            if ($wrapTogetherCheckbox.length && ($wrapTogetherCheckbox.prop('checked') || !$wrapTogetherCheckbox.prop('disabled'))) {
                wrapTogether(true);
                return;
            }
        }

        function clearGiftWrapping() {
            wrapProductsOrClearGiftWrapping(wrappingTypes.NONE);
        }

        function wrapTogether(override) {
            resetOption = true;
            if (override || this.checked) {
                $('.js-giftwrap-edit').hide();
                wrapProductsOrClearGiftWrapping(wrappingTypes.TOGETHER);
            }
        }

        function wrapIndividual() {
            resetOption = true;
            if (this.checked) {
                $('.js-giftwrap-edit').show();
                showDialog();

                initLazyLoad();
            }
        }

        function saveGiftWrapping() {
            resetOption = false;
            clearGiftWrappingWhenClosed = false;
            const $giftwrap = $('#giftwrap-container');
            const wrapInfo = $giftwrap.data('wrapinfo');

            const data = {
                'products': []
            };

            for (const prd in wrapInfo.products) {
                data.products.push({
                    'id': wrapInfo.products[prd].id,
                    'plid': wrapInfo.products[prd].plid,
                    'qty': $giftwrap.find('input[name=gift-wrapped-product][value=' + wrapInfo.products[prd].id + wrapInfo.products[prd].plid + ']:checked').length
                });
            }

            wrapProductsOrClearGiftWrapping(wrappingTypes.INDIVIDUAL, data, function() {
                flyout.closeFlyouts();
            });
        }

        function showDialog() {
            const isCheckoutV3 = $('.checkout-v3').length > 0;

            flyout.load({
                url: Urls.giftWrapShowProducts,
                open: function () {
                    const $giftwrap = $('#giftservice-products');
                    damHelper.updateImages($giftwrap);
                    const $saveBtn = $('.js-giftwrap-save');
                    const selectedItemsOnOpen = $giftwrap.find('input[name=gift-wrapped-product]:checked').length;

                    if (isCheckoutV3) {
                        $('.js-generic-flyout').addClass('checkout-v3');
                    }

                    $('.js-generic-flyout').addClass('giftwrap-flyout');

                    $('.js-giftwrap-cancel').on('click', function() {
                        flyout.closeFlyouts();
                    });

                    $saveBtn.on('click', saveGiftWrapping);

                    const checkAllCheckboxShouldBeChecked = $giftwrap.find('input[name=gift-wrapped-product]:checked').length
                        === $giftwrap.find('input[name=gift-wrapped-product]').length;
                    $('#checkall').prop('checked', checkAllCheckboxShouldBeChecked);

                    $giftwrap.on('change', $giftwrap.find('input[name=gift-wrapped-product]'), function() {
                        const checkAllCheckboxShouldBeChecked = $giftwrap.find('input[name=gift-wrapped-product]:checked').length
                            === $giftwrap.find('input[name=gift-wrapped-product]').length;
                        $('#checkall').prop('checked', checkAllCheckboxShouldBeChecked);

                        toggleSaveButton(selectedItemsOnOpen);
                    });

                    $('#checkall').on('change', function() {
                        $giftwrap.find('input[name=gift-wrapped-product]').prop('checked', !!this.checked);
                        toggleSaveButton(selectedItemsOnOpen);
                    });

                    const shouldDisableSaveBtn = $giftwrap.find('input[name=gift-wrapped-product]:checked').length === 0;
                    $saveBtn.prop('disabled', shouldDisableSaveBtn);

                    $('.js-generic-flyout ').find('.js-close-flyout').prependTo('#giftwrap-container .giftwrap-title');
                },
                close: function () {
                    if (resetOption && !$('#wrap-together').prop('disabled')) {
                        $('.js-giftwrap-edit').hide();
                        $('#wrap-together').prop('checked', true);
                    }

                    if (clearGiftWrappingWhenClosed) {
                        $('.js-giftwrap-checkbox').prop('checked', false);
                        $('.js-giftwrap-options').removeClass('enabled');
                        clearGiftWrappingWhenClosed = false;
                    }

                    setTimeout(function() {
                        if (isCheckoutV3) {
                            $('.js-generic-flyout').removeClass('checkout-v3');
                        }
                        $('.js-generic-flyout').removeClass('giftwrap-flyout');
                        $('#giftwrap-container .giftwrap-title').find('.js-close-flyout').prependTo('.js-generic-flyout');
                    }, 1000);
                }
            });
        }

        function toggleSaveButton(selectedItemsOnOpen) {
            const $giftwrap = $('#giftservice-products');
            const $saveBtn = $('.js-giftwrap-save');
            const shouldDisableSaveBtn = $giftwrap.find('input[name=gift-wrapped-product]:checked').length === 0
                && selectedItemsOnOpen === 0;
            $saveBtn.prop('disabled', shouldDisableSaveBtn);
        }
        function wrapProductsOrClearGiftWrapping(wrapType, giftwrapData, callback) {
            let data = 'wrapType=' + wrapType;
            if (giftwrapData && wrapType == wrappingTypes.INDIVIDUAL) {
                data += '&giftwrap_data=' + JSON.stringify(giftwrapData);
            }

            $.ajax({
                type: 'POST',
                url: Urls.wrapProductsOrClearGiftWrapping,
                data: data,
                success: function (data) {

                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    if (callback && $.isFunction(callback)) {
                        callback();
                    }

                    initLazyLoad();
                    pushDataLayerEvent();
                }
            });
        }

        function initLazyLoad() {
            if ($('.js-lazy-load').length) {
                ritualsStyles.initLazyLoad();
            }
        }
    }

    return {
        init: init
    };
};

function pushDataLayerEvent() {
    const $giftWrapDataLayerEl = $('.js-giftwrap-data-layer');
    if (!$giftWrapDataLayerEl || !$giftWrapDataLayerEl.length) {
        return;
    }

    const giftWrapLaterEvent = $giftWrapDataLayerEl.data('data-layer');
    if (!giftWrapLaterEvent) {
        return;
    }

    gtm.pushDataLayerEvent(JSON.parse(JSON.stringify(giftWrapLaterEvent)));
}

module.exports = new GiftWrapping();

},{"./dam/dam-helper":419,"./flyout":425,"./modules/google":453,"./rituals-styles":592}],435:[function(require,module,exports){
'use strict';

const gtm = require('./modules/google').tagManager;

function isGreenFridaySite() {
    const headerLogo = $('.js-header-logo');
    const href = headerLogo.length > 0 && headerLogo[0].href;
    if (href) {
        return href.includes('greenfriday');
    }
    return false;
}

// This function is used for pushing data for:
// - product explanation slider (slick-slider.js)
function pushDataLayerData(eventCategory, eventAction, eventLabel) {
    if (!eventCategory || !eventAction || !eventLabel || !isGreenFridaySite()) {
        return;
    }

    const dataLayerData = {
        'event': 'green_friday',
        'event_category': eventCategory,
        'event_action': eventAction,
        'event_label': eventLabel
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

function pushDataLayerDataForFAQBlock(eventLabel) {
    if (!eventLabel || !isGreenFridaySite()) {
        return;
    }

    const dataLayerData = {
        'event': 'green_friday',
        'event_category': 'faq',
        'event_action': 'click faq',
        'event_label': eventLabel
    };

    gtm.pushDataLayerEvent(dataLayerData);
}

const greenfriday = {
    pushDataLayerData: pushDataLayerData,
    pushDataLayerDataForFAQBlock: pushDataLayerDataForFAQBlock
};

module.exports = greenfriday;

},{"./modules/google":453}],436:[function(require,module,exports){
'use strict';

const ritualsStyles = require('./rituals-styles'),
    gtm = require('./modules/google').tagManager;

const GreetingCard = function () {
    function init(updateGiftWrapAndGreetingCardBlockAndPrice) {
        $(document).on('click', '.js-greetingcard-checkbox', toggle);
        $(document).on('click', '.js-greetingcard-cancel', cancel);
        $(document).on('click', '.js-greetingcard-add', addOrUpdateGreetingCard);
        $(document).on('click', '.js-greetingcard-edit', collapseTextArea);
        $(document).on('click', '.js-remove-greetingcard', function (e) {
            e.preventDefault();
            e.stopPropagation();
            clearGreetingCard();
        });

        initCardSelection();
        initTextArea();

        function initCardSelection() {
            $(document).on('click', '.js-gift-wrapping-card-multiple-option', function(){
                selectCard($(this));
            });

            $(document).on('keydown', '.js-gift-wrapping-card-multiple-option', function(e) {
                if (e.which === 32) {
                    e.preventDefault();
                    selectCard($(this));
                }
            });

            $(document).on('cardSelected', '.js-greetingcard-options', function(e, data) {
                pushDataLayerEvent(data.selectedCard);
            });

            onloadSetSelectedCard();
        }

        function pushDataLayerEvent($selectedCard) {
            if (!$selectedCard || !$selectedCard.length) {
                return;
            }
            const $selectedCardName = $selectedCard.find('.js-card-name');
            if (!$selectedCardName.length) {
                return;
            }
            gtm.pushDataLayerEvent({
                event: 'add_card',
                interaction_type: 'click',
                click_target: $selectedCardName.html().toLowerCase() /* eslint-disable-line camelcase */
            });
        }

        function toggle() {
            if ($('.js-greetingcard-edit').length > 0) {
                clearGreetingCard();
                return;
            }

            if ($(this).prop('checked')) {
                $('.js-greetingcard-options').closest('.js-greetingcard').addClass('enabled');
                $('.js-greetingcard-options').show().trigger('cardSelected', [{selectedCard: getSelectedCard()}]);
                //on initial check send placeholder data
                const data = getGreetingCardInfo();
                updateGiftWrapAndGreetingCardBlockAndPrice(data);
                return;
            }

            $('.js-greetingcard-options').closest('.js-greetingcard').removeClass('enabled');
            $('.js-greetingcard-options').hide();
        }

        const getSelectedCard = () => {
            const $greetingCardWrapper = $('.js-greetingcard-select-card');
            if (!$greetingCardWrapper.length) {
                return null;
            }

            return $greetingCardWrapper.find('.selected');
        };

        function collapseTextArea() {
            const $greetingCardCheckbox = $('.js-greetingcard-checkbox');
            if ($greetingCardCheckbox.is(':checked')) {
                $('.js-greetingcard-options').show();
                return;
            }
            $greetingCardCheckbox.prop('checked', true);
            $('.js-greetingcard-options').show();
        }

        function cancel() {
            if ($('.js-greetingcard-edit').length) {
                $('.js-greetingcard-options').hide();
                return;
            }

            $('.js-greetingcard-checkbox').click();
        }

        function selectCard($greetingCardOption) {
            if (!$greetingCardOption.length) {
                return;
            }

            // set radio button
            const greetingCardId = $greetingCardOption.attr('id');
            const greetingCardUrl = $greetingCardOption.find('img').attr('src');
            const $cardOptions = $('.js-gift-wrapping-card-multiple-option');
            $cardOptions.removeClass('selected');

            const $selectedCard = $cardOptions.filter('#' + greetingCardId);
            $selectedCard.addClass('selected').trigger('cardSelected', [{selectedCard: $selectedCard}]);

            // set data attr to be used during greet card ajax request
            const $greetingCardWrapper = $('.js-greetingcard-select-card');
            $greetingCardWrapper.data('selectedcardid', greetingCardId);
            $greetingCardWrapper.data('selectedcardurl', greetingCardUrl);
        }

        function addOrUpdateGreetingCard() {
            const $textarea = $('.js-personal-message-textarea');
            clearGreetingCardError($textarea);
            setDisabledWithSpinner('.js-greetingcard-add', true);
            $.ajax({
                type: 'POST',
                url: Urls.greetingCardAdd,
                data: getGreetingCardInfo(),
                success: function (data) {
                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    onloadSetSelectedCard();
                    initLazyLoad();
                    setDisabledWithSpinner('.js-greetingcard-add', false);
                },
                error: function(xhr) {
                    if (xhr.status === 400) {
                        setDisabledWithSpinner('.js-greetingcard-add', false);
                        const response = xhr.responseJSON;
                        if (response.error) {
                            showGreetingCardError($textarea, response.reason);
                            setDisabled('.js-greetingcard-add', true);
                            return;
                        }
                    }
                },
            });
        }

        function clearGreetingCard() {
            $.ajax({
                type: 'POST',
                url: Urls.greetingCardRemove,
                success: function (data) {
                    updateGiftWrapAndGreetingCardBlockAndPrice(data);
                    onloadSetSelectedCard();
                    initLazyLoad();
                }
            });
        }

        function initLazyLoad() {
            if ($('.js-lazy-load').length) {
                ritualsStyles.initLazyLoad();
            }
        }

        function getGreetingCardInfo() {
            const greetingCardInfo = {
                cardText: $('.js-personal-message-textarea').val() === '\n' ? $('.js-personal-message-textarea').val('') : $('.js-personal-message-textarea').val(),
                cardId: '',
                cardImgUrl: ''
            };

            const $giftWrappingCard = $('.js-greetingcard-select-card');

            if (!$giftWrappingCard.length) {
                return greetingCardInfo;
            }

            greetingCardInfo.cardId = $giftWrappingCard.data('selectedcardid');
            greetingCardInfo.cardImgUrl = $giftWrappingCard.data('selectedcardurl');

            return greetingCardInfo;
        }
    }

    function onloadSetSelectedCard() {
        const $greetingCardWrapper = $('.js-greetingcard-select-card');

        if (!$greetingCardWrapper.length) {
            return;
        }

        const $cardOptions = $('.js-gift-wrapping-card-multiple-option');
        if (!$cardOptions.length) {
            return;
        }

        const selectedCardId = $greetingCardWrapper.data('selectedcardid');

        const $selectedCard = typeof selectedCardId !== 'undefined' && selectedCardId ?
            $cardOptions.filter('#' + selectedCardId) : $cardOptions.first();

        $selectedCard.addClass('selected');
        $greetingCardWrapper.data('selectedcardid', $selectedCard.attr('id'));
        $greetingCardWrapper.data('selectedcardurl', $selectedCard.find('img').attr('src') || $selectedCard.find('img').data('src'));
    }

    function initTextArea() {
        const textAreaSelector = '.js-personal-message-textarea';
        $(document).on('scroll', textAreaSelector, function () {
            const linesOffset = $(this).scrollTop();
            $('.js-textarea-lines').css('margin-top', '-' + linesOffset + 'px');
        });

        $(document).on('keypress paste', textAreaSelector, function () {
            limitGiftWrapTextLines(this, $(this).val());
        });

        $(document).on('blur', textAreaSelector, function () {
            validateGreetingCardText();
        });

        $(document).on('keyup paste', textAreaSelector, function () {
            const $this = $(this);
            if (stringMayHaveEmoji($this.val())) {
                validateGreetingCardText();
                return;
            }

            clearGreetingCardError($this);
            setDisabled('.js-greetingcard-add', false);
        });

        $(document).on('input paste', textAreaSelector, function () {
            const $msg = $(this);
            const maxLength = $msg.attr('maxlength');
            const currentLength = $msg.val().length;
            const charLeft = maxLength - currentLength;

            $('.js-char-left').html(charLeft);
        });
    }

    function validateGreetingCardText() {
        const $textarea = $('.js-personal-message-textarea');
        $.ajax({
            url: Urls.validateGreetingCardText,
            type: 'POST',
            data: {greetingCardText: $textarea.val()},
            success: function (response) {
                clearGreetingCardError($textarea);
                if (response.error) {
                    showGreetingCardError($textarea, response.reason);
                    setDisabled('.js-greetingcard-add', true);
                    return;
                }

                setDisabled('.js-greetingcard-add', false);
            }
        });
    }

    function stringMayHaveEmoji(str) {
        const lowestPossibleEmojiChar = '\ud800';

        for (const idx in str) {
            const char = str[idx];
            if (char >= lowestPossibleEmojiChar) {
                return true;
            }
        }

        return false;
    }

    function limitGiftWrapTextLines(textAreaElement, oldText) {
        // Wait until the character is actually inserted
        setTimeout(function () {
            // If entering this text made the textarea scroll further down, cancel that text
            if (textAreaElement.scrollHeight - textAreaElement.clientHeight > 1) { // 1px because on the 5th line there's already a scroll bar, and there's a 1px difference
                $(textAreaElement).val(oldText);
            }
        }, 1);
    }

    function showGreetingCardError($textarea, error) {
        $textarea.removeClass('error').parent().parent().find('span.error').remove();
        $textarea.removeClass('valid').addClass('error').parent().before(
            $('<span/>').addClass('error').text(error)
        );
    }

    function clearGreetingCardError($textarea) {
        $textarea.removeClass('error').parent().parent().find('span.error').remove();
    }

    function setDisabledWithSpinner(buttonSelector, disabled) {
        const button = $(buttonSelector);
        if (!button.length) {
            return;
        }

        if (disabled) {
            button.addClass('btn--disabled').addClass('button-loading');
            button.find('.js-spinner-general').addClass('spinner-visible');
            return;
        }

        button.removeClass('btn--disabled').removeClass('button-loading');
        button.find('.js-spinner-general').removeClass('spinner-visible');
    }

    function setDisabled(classSelector, isDisabled) {
        $(classSelector).prop('disabled', isDisabled);
    }

    return {
        init: init,
        onloadSetSelectedCard: onloadSetSelectedCard
    };
};

module.exports = new GreetingCard();

},{"./modules/google":453,"./rituals-styles":592}],437:[function(require,module,exports){
'use strict';

const debounce = require('./modules/helpers/debounce');
const equalHeight = require('./modules/helpers/equalHeight');
const isSmallView = require('./modules/helpers/isSmallView');
const prepareDeferedImages = require('./modules/helpers/prepareDeferedImages');
const scrollHelper = require('./modules/helpers/scroll');

// Masonry
const Masonry = require('masonry-layout');
const ScrollReveal = require('scrollreveal');
const generateUniqueGuid = require('./modules/util/generateUniqueGuid');
const updateQueryStringParameter = require('./modules/util/updateQueryStringParameter');
const getQueryParameter = require('./modules/util/getQueryParameter');
const damHelper = require('./dam/dam-helper');

const tilesSelector = '.js-grid-wrap';
const masonryTileSelector = '.js-grid-item';
const scrollRevealTileSelector = '.js-reveal-tile';
const scrollRevealDurations = [500, 1500, 2500, 3500];
const scrollRevealDistance = ['10px', '20px', '30px', '40px'];
const msnryContainers = new Map();
let initCount = 0;
const isSearchPage = window.pageContext.ns == 'search';
const scrollAnimation = require('./scrollAnimation');
const productGrid = require('./product-grid');
const bundleVariationSwatches = require('./bundle-variation-swatches');

const tileSelectors = ['.js-grid-wrap:not(.js-grid-slider) .js-grid-item:not(.js-block-tile)','.drag-list-body .js-drag-list-item'];

function getGutter(grid){
    if (grid.hasClass('js-question-grid')) {
        return 20;
    } else if (grid.hasClass('js-grid-account')) {
        return 20;
    } else if (grid.hasClass('js-search-grid') && isSmallView()) {
        return 8;
    } else if (isSmallView()) {
        return 10;
    } else if (grid.hasClass('js-search-grid') && isTabletPortraitView()) {
        return 24;
    } else if (grid.hasClass('js-search-grid') && isTabletLandscapeView()) {
        return 18;
    } else if (grid.parents('.js-product-grid-block').length && isTabletPortraitView()) {
        return 30;
    } else if (grid.parents('.js-product-grid-block').length && isTabletLandscapeView()) {
        return 40;
    } else {
        return 60;
    }
}

function isTabletPortraitView() {
    const vpWidth = $(window).width();
    return vpWidth >= 768 && vpWidth <= 825;
}

function isTabletLandscapeView() {
    const vpWidth = $(window).width();
    return vpWidth >= 826 && vpWidth <= 1024;
}

function initMasonry(el) {
    const targetEl = $(el)[0];
    const msnryObj = new Masonry(targetEl, {
        columnWidth: masonryTileSelector,
        gutter: getGutter($(targetEl)),
        itemSelector: masonryTileSelector,
        isFit: true,
        percentPosition: true,
        stagger: '0.1s',
        transitionDuration: 0,
        stamp: '.js-fixed-item'
    });

    $(targetEl).addClass('grid-initialized');

    const msnryId = generateUniqueGuid();
    $(el).data('msnry-id', msnryId);
    msnryContainers.set(msnryId, msnryObj);

    return msnryObj;
}

function initScrollReveal(scrollSelector, gridElement) {
    if (!window.sr){
        window.sr = ScrollReveal();
    } else {
        window.sr.destroy();
    }

    gridElement.find(scrollSelector).each(function(i, el) {
        sr.reveal(el, { /* eslint-disable-line */
            distance: randomArrayKeyValue(scrollRevealDistance),
            duration: randomArrayKeyValue(scrollRevealDurations),
            easing: 'cubic-bezier(0.05, 0.65, 0.3, 1)',
            opacity: 0.2,
            scale: 1,
            viewFactor: 0.2
        });
    });
}

function randomArrayKeyValue(a) {
    return a[Math.floor(Math.random() * a.length)];
}

/**
* @description Initialize Recommendation(Einstein) grid observer and init grids when loaded.
*/
function initRecommendationGridObserver() {
    // set a MutationObserver for each recommendation slot
    $('[id^=cq_recomm]').each(function (index, el){
        const target = $(el)[0];
        // set mutation observer
        const observer = new MutationObserver(function() {

            // Prepare defered images if present
            damHelper.updateImages(target);
            prepareDeferedImages(target);

            // init every grid in that slot
            $(target).imagesLoaded(function () {
                $(target).find(tilesSelector).each(function (index, el) {
                    initMasonry(el);
                    initScrollReveal(scrollRevealTileSelector, $(el));
                });

                layoutMsnry();

                if ($('.js-grid-spinner').length) {
                    $('.js-grid-spinner').removeClass('spinner-visible');
                }
            });

            $(document).trigger('recommendation-grid-loaded'); //Trigger an event so other pages can react to this grid being loaded

            // in the end disconnect the observer
            observer.disconnect();
        });

        // configs for the observer
        const config = {
            childList: true,
            subtree: true
        };

        // set the observer on the target
        observer.observe(target, config);
    });
}

/**
* @description Initialize block
*/
function initBlock() {
    initCount = $('.js-product-tile').length;

    $(document).on('click', '.js-product-tile', function () {
        setScrollYPositionInState();
    });

    if ($(tilesSelector).length) {
        // only init for not empty grids
        $(tilesSelector).each(function (index) { /* eslint-disable-line */
            const $this = $(this);

            // if empty, do nothing
            if ($this.html().trim().length === 0) {
                return true;
            }

            if (!$this.hasClass('js-grid-slider') || !isSmallView()) {

                // Prepare defered images if present
                damHelper.updateImages($this);
                prepareDeferedImages($this);

                // Set height for elements that have class 'js-equal-height'
                equalHeight($('.js-equal-height', this));

                $this.imagesLoaded(function () {
                    $('.js-grid-initial-load-spinner').removeClass('spinner-visible');
                    $('.js-grid-product-number').removeClass('grid-number-hidden');

                    removeEmptyGWP();

                    if (!$this.hasClass('js-question-grid') || ($this.hasClass('js-question-grid') && !isSmallView())) {
                        initGridAndScroll($this);
                    }

                    layoutMsnry();
                    scrollAndResetYPositionInState();
                });
            }

            //do not tab through product name and description in product tile
            $(this).find('.js-product-name-link').attr('tabindex', '-1');
        });
    }

    outOfStockBtnAlignment();
}

function outOfStockBtnAlignment() {
    $(masonryTileSelector + ' .js-out-of-stock-wrap:not(.hide)').each(function () {
        const userActions = $(this).parents('.js-product-user-actions');
        const className = 'form-wide';
        userActions.addClass(className);
    });
}

function removeEmptyGWP() {
    const gwpWrap = $('.js-gwp-grid-item');

    if (!gwpWrap.length || $('.js-gwp-banner', gwpWrap).length) {
        return;
    }

    gwpWrap.remove();
}

function initGridAndScroll(el){
    initMasonry(el);

    // get non empty grids
    const selector = isSmallView() ? tilesSelector + ':not(.js-grid-slider)' : tilesSelector;
    const $grids = $(selector).filter(function () {
        return $.trim($(this).html()).length !== 0;
    });

    if ($grids.length === $('.grid-initialized').length) {
        $grids.each(function(){
            initScrollReveal(scrollRevealTileSelector, $(this));
        });
    }

    if ($('.js-scroll-animation-wrapper').data('animation-type') !== 'banner-video-animation'){
        scrollAnimation.init();
    }
    productGrid.pushProductsToDataLayer(tileSelectors);
}

/**
* @description Initialize event handlers for the grid
*/
function initializeEvents() {
    const recommendationBlock = $('[id^=cq_recomm]');

    // if there are einstein slots and they contain a grid
    if (recommendationBlock.length && recommendationBlock.find(tilesSelector)){
        initRecommendationGridObserver();
    }

    if ($(tilesSelector).length || recommendationBlock.length || $('.js-grid-placeholder').length || $('.js-product-list-slider-block').length) {
        $(window).off('scroll.grid').on('scroll.grid', debounce(function () {
            productGrid.pushProductsToDataLayer(tileSelectors);
        }, 300));
    }
}


const grid = {
    init: function() {
        initBlock();
        loadItemsFromState();
        initializeEvents();
        bundleVariationSwatches.init();
    },
    getContainers: function(){ return msnryContainers;},
    updateLoadMoreUrl: updateLoadMoreUrl,
    updateProductsSeenAndTotalNumbers: updateProductsSeenAndTotalNumbers,
    appendNewElements : appendNewElements,
    reinitGridLayout: reinitGridLayout
};

function loadMoreGrid(event, itemsCount, callback) {
    let $loadMore = $('.js-grid-load-more');

    if (event){
        $loadMore = $(event.target);
    }

    let url = $loadMore.data('grid-next-page-url') || Urls.productPartialGrid;
    const loadedViaUrl = $loadMore.data('grid-next-page-url');
    const ritual = $loadMore.data('ritual');
    const startIndex = $loadMore.data('start-index');
    const endIndex = $loadMore.data('end-index');
    let pageSize = $loadMore.data('page-size');
    const isSearch = $loadMore.data('is-search');

    if (itemsCount && itemsCount > initCount){
        pageSize = itemsCount - initCount;
        url = updateQueryStringParameter(url, 'sz', pageSize);
    } else if (!event){
        callback();
        return;
    }

    const requestFormat = getQueryParameter(url, 'format');
    const source = ($loadMore.parents('section').data('anchor-id') === 'collection-product-grid' && !loadedViaUrl) ? 'collection' : getQueryParameter(url, 'source');

    const requestData = {
        ritual: ritual,
        start: startIndex,
        isSearch: isSearch,
        source: source
    };

    if (!requestFormat){
        requestData.format = 'ajax';
    }

    $.ajax({
        type: 'GET',
        url: url,
        data: requestData,
        success: function (data) {
            if (data) {
                const newElements = $(data);
                newElements.addClass('js-reveal-tile-new');
                const container = $loadMore.parent().prev(':data("msnry-id")');
                container.append(newElements);
                const $container = container.find(newElements.filter('.js-reveal-tile'));
                damHelper.updateImages($container);
                prepareDeferedImages($container);

                $container.imagesLoaded(function() {
                    appendNewElements(newElements, container, event);
                    callback();
                    $('.js-grid-load-more-spinner').removeClass('spinner-visible');
                    $loadMore.removeClass('button-loading');
                    updateProductsSeenAndTotalNumbers();
                });

                if (loadedViaUrl) {
                    updateLoadMoreUrl($loadMore);
                } else {
                    if (endIndex <= startIndex + pageSize) {
                        $('.js-grid-load-more-holder').hide();
                    }

                    $loadMore.data('start-index', startIndex + pageSize);
                    $loadMore.removeAttr('disabled');
                }

                outOfStockBtnAlignment();
                setGridItemCountInState();
            }
        }
    });
}

function setGridItemCountInState() {
    const currentState = window.history.state;
    if (!currentState) {
        return;
    }
    const gridPageSize = $('.js-filtered-grid-placeholder').data('page-size');
    currentState.gridItemCount = currentState.gridItemCount ? (currentState.gridItemCount + gridPageSize) : gridPageSize;
    window.history.replaceState(currentState, '', window.location.href);
}

function setScrollYPositionInState() {
    if (!window.history.state) {
        window.history.pushState({}, '', window.location.href);
    }
    const historyState = window.history.state;
    historyState.scrollYPosition = window.scrollY;
    window.history.replaceState(historyState, '', window.location.href);
}

// Update number of seen and total products on page (above Load More button)
function updateProductsSeenAndTotalNumbers() {
    const productsSeen = $('.js-products-seen-text');
    if (!productsSeen.length) {
        return;
    }
    $('.js-products-seen').text(productsSeen.val());
    productsSeen.remove();

    const totalProducts = $('.js-total-products-text');

    if (!totalProducts.length) {
        return;
    }

    $('.js-total-products').text(totalProducts.val());
    totalProducts.remove();
}

function appendNewElements(newElements, gridWrapper, event){
    const msnryId = gridWrapper.data('msnry-id');
    const msnryObj = msnryContainers.get(msnryId);

    if (!msnryObj) {
        return;
    }

    msnryObj.once('layoutComplete', function () {
        initScrollReveal($('.js-reveal-tile', gridWrapper), gridWrapper);

        if (event && event.screenX === 0) {
            newElements.find('.js-product-tile').eq(0).focus();
        }

        productGrid.pushProductsToDataLayer(tileSelectors);
    });

    msnryObj.appended(newElements);
}

function reinitGridLayout(msnryId){
    const msnryObj = msnryId ? msnryContainers.get(msnryId) : msnryContainers.values().next().value;

    if (!msnryObj) {
        return;
    }

    msnryObj.layout();
}

function updateLoadMoreUrl(loadMoreEl) {
    const $loadMore = loadMoreEl ? loadMoreEl : $('.js-grid-load-more');

    $loadMore.removeAttr('disabled');
    const newUrlField = $('.js-next-product-grid-page-url');

    if (!window.history.state) {
        window.history.pushState({}, '', window.location.href);
    }

    if (newUrlField.length > 0) {
        $loadMore.data('grid-next-page-url', newUrlField.last().val());
        $('.js-grid-load-more-holder').show();
        newUrlField.remove();
        return;
    }

    $('.js-grid-load-more-holder').hide();
}

function loadItemsFromState(){
    if (isSearchPage &&
        history.state &&
        history.state.loaded &&
        history.state.offset &&
        window.performance &&
        window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD
    ) {
        scrollHelper.disableScroll();
        loadMoreGrid(null, history.state.loaded, function() {
            scrollHelper.enableScroll();
            $('html, body').scrollTop(history.state.offset);
            $('.js-grid-load-more').data('grid-next-page-url', history.state.loadurl);

            if ($(this).data('animation-type') !== 'banner-video-animation'){
                scrollAnimation.init();
            }
            $('.js-scroll-animation-wrapper').each(function () {
                const $thisBanner = $(this);
                if ($thisBanner.data('animation-type') === 'candle-holder') {
                    $('img', $thisBanner).each((i, image) => {
                        const src = (isSmallView()) ? $(image).data('mobile-img') : $(image).data('desktop-img');
                        $(image).attr('src', src);
                    });
                }
            });
        });
    }
}

function scrollAndResetYPositionInState() {
    if (window.history.state && window.history.state.scrollYPosition) {
        window.scrollTo(window.scrollX, window.history.state.scrollYPosition);
        window.history.state.gridItemCount = null;
        window.history.state.scrollYPosition = null;
    }
}

function layoutMsnry(){
    if (typeof msnryContainers !== 'undefined') {
        for (const [key, value] of msnryContainers) { /* eslint-disable-line */
            if (value.layouted) {
                continue;
            }

            value.layout();
            value.layouted = true;
        }
    }
}

let stateAlreadySet = false; //Flag to not repeat this function multiple times

function setState(){
    if (stateAlreadySet) {
        return;
    }

    stateAlreadySet = true;
    const count = $('.js-product-tile').length;
    const offset = $(document).scrollTop();
    const loadUrl = $('.js-grid-load-more').data('grid-next-page-url');
    const state = history.state ? history.state : {};
    state.loaded = count;
    state.offset = offset;
    state.loadurl = loadUrl || '';
    history.replaceState(state, '', location.href);
}

$(document).on('click', '.js-grid-load-more', function(e) {
    e.preventDefault();
    $(this).attr('disabled', true);

    loadMoreGrid(e, 0, function(){
        if ($('.js-scroll-animation-wrapper').data('animation-type') !== 'banner-video-animation'){
            scrollAnimation.init();
        }
    });

    $('.js-grid-load-more-spinner').addClass('spinner-visible');
    $(this).addClass('button-loading');
});

function removeToggle(){
    if ($('.js-toggle-slider-promotion').length){
        for (let i = 0; i <= $('.js-toggle-slider-promotion').length; i++){
            const sliderPromoDiv = document.querySelector('.toggle-slider-promo');
            if (sliderPromoDiv){
                sliderPromoDiv.classList.remove('toggle-slider-promo');
            }
        }
    }
}
$(window).on('load', removeToggle);
$(window).on('load', layoutMsnry);

if (isSearchPage){
    $(window).on('beforeunload', setState);
    $(window).on('unload', setState);
    $(document).on('pagehide', setState);
}

module.exports = grid;

},{"./bundle-variation-swatches":277,"./dam/dam-helper":419,"./modules/helpers/debounce":458,"./modules/helpers/equalHeight":459,"./modules/helpers/isSmallView":469,"./modules/helpers/prepareDeferedImages":474,"./modules/helpers/scroll":475,"./modules/util/generateUniqueGuid":486,"./modules/util/getQueryParameter":490,"./modules/util/updateQueryStringParameter":513,"./product-grid":578,"./scrollAnimation":593,"masonry-layout":212,"scrollreveal":254}],438:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax'),
    ritualsStyles = require('./rituals-styles'),
    responsiveBg = require('./responsive-background'),
    grid = require('./grid'),
    video = require('./video'),
    gtm = require('./modules/google'),
    slickSlider = require('./slick-slider'),
    productSlider = require('./product-slider'),
    isSmallView = require('./modules/helpers/isSmallView'),
    productFilter = require('./product-filter'),
    collectionIngredients = require('./pages/collection/collection-ingredients'),
    productDescription = require('./product-description'),
    dragList = require('./dragList');

let numberOfAcceptedAnswers,
    minAcceptedAnswers,
    maxAcceptedAnswers,
    currentQuestionNo,
    quizNamePrefix,
    hairTempleLoadingPage,
    startPage,
    totalQuestionsNumber,
    loadPrevAnswers = false,
    totalSelectedOptions = [],
    outcome;

/**
* @private
* @enum
* @description
*/
const QuizOptionTypes = {
    Regular: 0,
    HairTemple: 1
};

/**
* @private
* @function
* @description Initializes events for the quiz block
*/
function initEvents() {
    initStartAnimation();

    $(document).on('click', '.js-option-block', function(){
        toggleAnswer($(this));
    });

    $(document).on('click', '.js-retake-quiz', function(){
        clearData();
    });

    $(document).on('click', '.js-start-quiz, .js-next-question', function(e){
        e.preventDefault();

        if (!$(e.target).attr('disabled')) {
            if ($(e.target).hasClass('js-next-question')){
                // do next question logic (update answer values, calculations, etc.)
                saveSelectedOptions();
            }

            const selectedOptions = getSelectedOptions();
            let href;

            // If 1 option is selected
            if (selectedOptions.length === 1) {
                href = getLinkToFromSelectedOption() || $(e.target).attr('href');
            } else {
                // Default behaviour when multiple options are selected
                href = $(e.target).attr('href');
            }

            getQuestion(href);
        }
    });

    $(document).on('click', '.js-prev-question', function(e){
        e.preventDefault();

        if (!$(e.target).attr('disabled')) {
            loadPrevAnswers = true;

            const href = $(e.target).attr('href');

            getQuestion(href);
        }
        initStartAnimation();
    });


    $(document).on('click', '.js-quiz-last-question', function(e){
        e.preventDefault();

        saveSelectedOptions();
        calculateAndShowResult();
    });

    $(document).on('click', '.js-more-info-toggle', function(){
        $('.js-content-banner').toggleClass('showing-more-info');
    });

    $(document).on('keydown', '.js-more-info-toggle', function (event) {
        if (event.which == 13 || event.which == 32) {
            event.preventDefault();
            $(this).trigger('click');
        }
    });

    $(document).on('keydown', '.js-option-block', function (event) {
        if (event.which == 13 || event.which == 32) {
            event.preventDefault();
            $(this).trigger('click');
        }
    });

    $(document).on('keydown', '.js-question input[type=text]', function (event) {
        if (event.which == 13) {
            event.preventDefault();
            $('.js-question .js-next-question,.js-quiz-last-question').trigger('click');
        }
    });

    accessibilityCheckboxAdjustment();

    $(window).on('load scroll', function () {
        stickyNavButtons();
    });

    $(window).on('load', function () {
        if ($('.js-collection-ingredients').length > 0) {
            collectionIngredients.init();
        }
    });
}

/**
* @private
* @function
* @description Toggles answer state
*/
function toggleAnswer($optionEl) {
    const $selectedOptions = $('.js-option-block.selected');
    const defaultBgImageClass = '.js-default-responsive-bg';
    const questionBgImageClass = '.js-question-responsive-bg';
    const $copiedBg = $(defaultBgImageClass).prev(questionBgImageClass);

    if (maxAcceptedAnswers) {
        if (($selectedOptions.length > (maxAcceptedAnswers - 1)) && !$optionEl.hasClass('selected')) {
            $selectedOptions.first().removeClass('selected');
            $selectedOptions.first().find('.round-select-box').attr('aria-checked', 'false');
        }
    }

    //$optionEl.toggleClass('selected');
    if ($optionEl.hasClass('selected')) {
        $optionEl.removeClass('selected');
        $optionEl.find('.round-select-box').attr('aria-checked', 'false');
        if ($copiedBg.length) {
            $(defaultBgImageClass).fadeIn(400, function () {
                $copiedBg.remove();
            });
        }
    } else {
        $optionEl.addClass('selected');
        $optionEl.find('.round-select-box').attr('aria-checked', 'true');

        // if option is selected and has its own background
        if ($optionEl.find(questionBgImageClass).length) {
            if ($copiedBg.length) {
                $optionEl.find(questionBgImageClass).clone().prependTo($(defaultBgImageClass).parent());
                $copiedBg.fadeOut(400, function () {
                    $copiedBg.remove();
                });
            } else {
                $optionEl.find(questionBgImageClass).clone().insertBefore(defaultBgImageClass);
                $(defaultBgImageClass).fadeOut(400);
            }
        } else if ($copiedBg.length) {
            $(defaultBgImageClass).fadeIn(400, function () {
                $copiedBg.remove();
            });
        }
    }
    updateUserAnswers();

    // if option is selected and has extra info, show it on the target container below the option wrapper
    if ($optionEl.hasClass('selected') && $optionEl.has('.js-option-extra-info')){
        const infoText = $optionEl.find('.js-option-extra-info').html();
        $('.js-option-extra-info-target').html(infoText);
    } else {
        $('.js-option-extra-info-target').empty();
    }
}

/**
* @private
* @function
* @description Loads the next question with ajax
*/
function getQuestion(href){
    const $targetContainer = $('.js-gst-wrapper');

    ajax.load({
        url: href,
        target: $targetContainer,
        data: {'nocontainer': true},
        replaceTarget: true,
        callback: function() {
            pushStepToDataLayer();

            // get new question configurations
            getQuestionConfigs();

            //reselect previously selected options
            if (loadPrevAnswers) {
                loadSelectedOptions();
                //clear previous selections
                removeSelectedOptions(currentQuestionNo);
                loadPrevAnswers = false;
            }
            // re-init lazy load
            ritualsStyles.initLazyLoad();

            // re-init progress bar
            initProgressBar();
            initCustomerNameValidation();
            initQuizResult();

            // scroll to top of question (useful in mobile)
            $('html, body').animate({
                scrollTop: $('.js-gst-wrapper').offset().top - $('.js-header-wrapper').height() - 20
            }, 200);

            // push the new url to the navigation bar
            window.history.replaceState({},'', this.url);

            responsiveBg.init();

            accessibilityCheckboxAdjustment();
            stickyNavButtons();

            if ($('.js-expand-description-link').length > 0) {
                productDescription.init();
            }

            if ($('.js-collection-ingredients').length > 0) {
                collectionIngredients.init();
            }

            if ($('.js-grid-wrap').length > 0){
                grid.init();
            }

            if ($('.quiz-loader').length > 0) {
                video.initGeneric();
            }

            if ($('.js-product-slider-steps').length > 0) {
                slickSlider.init();
                productSlider.init();
                video.initGeneric();
            }

            if ($('.js-pdp-images-slider').length > 0) {
                slickSlider.init();
            }

            if ($('.js-drag-list').length > 0) {
                dragList.init();
            }

            if ($('.js-product-filter-block').length > 0) {
                productFilter.init();
            }

            if ($(document).find('.js-content-banner-blurred').length) {
                $('.js-content-banner-blurred .js-responsive-bg').addClass('blurred');
                $('.js-quiz-main-content').addClass('visible');
            } else if ($(document).find('.js-content-banner:not(.js-content-banner-blurred').length) {
                $('.js-quiz-main-content').addClass('visible');
            }
        }
    });
}

/**
* @private
* @function
* @description Clears selected options
*/
function clearData() {
    totalSelectedOptions = [];
}

/**
* @private
* @function
* @description Gets question configurations
*/
function getQuestionConfigs() {
    const questionConfig = $('.js-question').data('question-config');

    if (questionConfig) {
        numberOfAcceptedAnswers = questionConfig.numberOfAcceptedAnswers ? questionConfig.numberOfAcceptedAnswers : null;

        if (numberOfAcceptedAnswers) {
            minAcceptedAnswers = numberOfAcceptedAnswers;
            maxAcceptedAnswers = numberOfAcceptedAnswers;
        } else {
            minAcceptedAnswers = questionConfig.minAcceptedAnswers ? questionConfig.minAcceptedAnswers : 1;
            maxAcceptedAnswers = questionConfig.maxAcceptedAnswers ? questionConfig.maxAcceptedAnswers : null;
        }
    }

    //get current question number
    const progressConfig = $('.js-progress-bar').data('bar-config');
    currentQuestionNo = (progressConfig && progressConfig.currentQuestion) ? parseInt(progressConfig.currentQuestion) : 1;
}

/**
* @private
* @function
* @description Gets configurations of quiz
*/
function getQuizConfigs() {
    //get quiz configs
    const quizConfig = $('.js-quiz-container').data('quiz-config');

    if (quizConfig) {
        quizNamePrefix = (quizConfig.quizNamePrefix) ? quizConfig.quizNamePrefix : '';
        hairTempleLoadingPage = (quizConfig.hairTempleLoadingPage) ? quizConfig.hairTempleLoadingPage : '';
        startPage = (quizConfig.startPage) ? quizConfig.startPage : '';
        totalQuestionsNumber = (quizConfig.totalQuestions) ? parseInt(quizConfig.totalQuestions) : 0;
    }
}

/**
* @private
* @function
* @description Updates the user's answers when an option is toggled
*/
function updateUserAnswers() {
    const selectedOptions = $('.js-option-block.selected');

    if (selectedOptions.length >= minAcceptedAnswers && (!maxAcceptedAnswers || selectedOptions.length <= maxAcceptedAnswers)) {
        $('.js-next-question, .js-quiz-last-question').removeAttr('disabled');
    } else {
        $('.js-next-question, .js-quiz-last-question').attr('disabled', 'disabled');
    }
}

/**
 * @private
 * @function
 * @description Gets the 'link-to' data attribute from the selected options.
 * Returns null if not exists
 */
function getLinkToFromSelectedOption() {
    const $selectedOption = $('.js-option-block.selected');
    return $selectedOption.data('link-to');
}

/**
* @private
* @function
* @description Gets selected options
*/
function getSelectedOptions() {
    const result = [];

    const $selectedOptions = $('.js-option-block.selected');
    $selectedOptions.each(function(){
        const $this = $(this);

        const optionType = $this.data('option-type');
        const blockNo = $this.data('block-no');
        const dataWeight = $this.data('weight');
        const productIds = $this.data('product-ids');
        const shampooId = $this.data('shampoo-id');
        const conditionerId = $this.data('conditioner-id');

        const selectedOption = {
            'type': optionType,
            'blockNo': blockNo,
            'dataWeight': dataWeight,
            'productIds': productIds,
            'shampooId': shampooId,
            'conditionerId': conditionerId
        };

        result.push(selectedOption);
    });

    return result;
}

/**
* @private
* @function
* @description Loads previously selected options
*/
function loadSelectedOptions() {
    const selectedOptions = getSelectedOptionsByQuestion(currentQuestionNo);

    if (!!selectedOptions && selectedOptions === null) {
        return;
    }

    $.each(selectedOptions.selectedOptions, function(index, obj) {
        $('.js-option-block').filter(function() {
            if ($(this).data('block-no') == obj.blockNo) {
                toggleAnswer($(this));
            }
        });
    });
}

/**
* @private
* @function
* @description Saves selected options to the array
*/
function saveSelectedOptions() {
    const selectedOptions = getSelectedOptions();

    if (selectedOptions.length == 0){
        return;
    }

    totalSelectedOptions.push({'questionNo': currentQuestionNo, 'selectedOptions' : selectedOptions});
    pushSelectedOptionToDataLayer();
}

/**
* @private
* @function
* @description Saves the outcome into cookie
*/
function calculateAndShowResult() {
    const quizType = getQuizType();
    let targetAssetName = null;

    switch (quizType) {
        case QuizOptionTypes.Regular:
            outcome = calculateOutcomeByType();
            targetAssetName = quizNamePrefix + '-' + outcome + '.html';
            break;
        case QuizOptionTypes.HairTemple:
            outcome = calculateOutcomeByWeight();
            targetAssetName = hairTempleLoadingPage + '.html';
            break;
        default:
            break;
    }

    showQuizResult(targetAssetName);
}

/**
* @private
* @function
* @description shows the result
*/
function showQuizResult(targetAssetName) {
    let href = window.location.href;

    href = href.replace(href.substr(href.lastIndexOf('/') + 1), targetAssetName);
    getQuestion(href);
}

/**
* @private
* @function
* @description Returns selected options for given question no
*/
function getSelectedOptionsByQuestion(questionNo) {
    const result = totalSelectedOptions.filter(function(obj) {
        return obj.questionNo == questionNo;
    });
    return result ? result[0] : null;
}

/**
* @private
* @function
* @description Clears selected options of given question no
*/
function removeSelectedOptions(questionNo) {
    totalSelectedOptions = totalSelectedOptions.filter(function(obj) {
        return obj.questionNo != questionNo;
    });
}

/**
* @private
* @function
* @description Calculates outcome of the selected options
*/
function calculateOutcomeByType() {
    if (totalSelectedOptions.length == 0) {
        return;
    }

    const typeCounts = {};
    $.each(totalSelectedOptions, function(i, objQuestion) {
        $.each(objQuestion.selectedOptions, function(j, options) {
            const types = options.type.split(','); // every block may have multiple types
            $.each(types,function(k, type) {
                typeCounts[type] = (typeCounts[type] || 0) + 1;
            });
        });
    });

    let outcomeType = null;
    for (const key in typeCounts) {
        if (Object.prototype.hasOwnProperty.call(typeCounts, key)) {
            if (outcomeType === null) {
                outcomeType = key;
            } else if (typeCounts[key] > typeCounts[outcomeType]){
                outcomeType = key;
            }

        }
    }

    return outcomeType;
}

/**
* @private
* @function
* @description Calculates outcome of the selected options
*/
function calculateOutcomeByWeight() {
    if (totalSelectedOptions.length == 0) {
        return;
    }

    const quizResult = {
        elixirIds: [],
        customerName: $('input[name=PersonalizedName]').val(),
        shampooId: null,
        conditionerId: null,
        productIds: []
    };

    const weightPerElixir = {};

    $.each(totalSelectedOptions, function(i, objQuestion) {
        $.each(objQuestion.selectedOptions, function(j, option) {
            if (option.dataWeight) {
                const elixirWeight = weightPerElixir[option.type];
                if (elixirWeight) {
                    weightPerElixir[option.type] += parseInt(option.dataWeight);
                } else {
                    weightPerElixir[option.type] = parseInt(option.dataWeight);
                }
            } else if (option.productIds) {
                quizResult.productIds = quizResult.productIds.concat(option.productIds.toString().split(','));
            } else if (option.shampooId || option.conditionerId) {
                quizResult.shampooId = option.shampooId;
                quizResult.conditionerId = option.conditionerId;
            }
        });
    });

    const elixirWeights = sortWeightsDescending(weightPerElixir);

    quizResult.productIds = $.unique(quizResult.productIds.map(function(key){
        return $.trim(decodeURIComponent(key));
    }));

    quizResult.elixirIds.push(elixirWeights[0].elixirId);
    quizResult.elixirIds.push(elixirWeights[1].elixirId);

    return quizResult;
}

/**
* @private
* @function
* @description Gets the quiz type
*/
function getQuizType() {
    if ($('.js-hairtemple-quiz').length > 0) {
        return QuizOptionTypes.HairTemple;
    }

    return QuizOptionTypes.Regular;
}

/**
* @private
* @function
* @description sorts the weights from the hash map in descending order
*/
function sortWeightsDescending(weightPerElixirMap) {
    const elixirWeights = Object.keys(weightPerElixirMap).map(function(key) {
        return {'elixirId' : key, 'value' : weightPerElixirMap[key]};
    });

    return elixirWeights.sort(function(elixir1, elixir2) {
        return Number(elixir2.value) - Number(elixir1.value);
    });
}

/**
* @private
* @function
* @description Gets Progress Bar config and creates the correct dom
*/
function initProgressBar() {
    const $progressBars = $('.js-progress-bar');

    if ($progressBars.length > 0){
        $progressBars.each(function(index, ele){
            const $progressBar = $(ele);


            // add steps to the dom (one extra for styling purposes)
            for (let i = 0; i < (totalQuestionsNumber); i++) {
                const $stepElement = $('<div>', {class: 'step'});

                if (i < currentQuestionNo) {
                    $stepElement.addClass('completed');

                    // if it's the current question, add label
                    if (i == (currentQuestionNo - 1)) {
                        const currentStepLabelText = $progressBar.siblings('.js-question').find('.title').text();
                        const $currentStepLabelElement = $('<div>', {class: 'current-step-label'}).text(currentStepLabelText);
                        $stepElement.append($currentStepLabelElement);
                    }
                }

                if (i == totalQuestionsNumber){
                    $stepElement.addClass('last');
                }

                const targetFinishLabel = $progressBar.find('.js-finish-label');
                $stepElement.insertBefore(targetFinishLabel);
            }

            // show progress bar one it's ready
            $progressBar.css('display', 'flex');

        });
    }
}

function initStartAnimation() {
    if ($('.js-quiz-container .js-responsive-bg').length) {
        if ($('.js-content-banner-blurred').length) {
            setTimeout(function(){
                // blur background image
                $('.js-content-banner-blurred .js-responsive-bg').addClass('blurred')
                    .delay(500)
                    .queue(function() {
                        // make content visible
                        $('.js-quiz-main-content').addClass('visible');
                        $(this).dequeue();
                    });
            }, 1000);
        } else {
            // make content visible
            $('.js-quiz-main-content').addClass('visible');
            $(this).dequeue();
        }
    }
}

function initCustomerNameValidation() {
    if ($('input[name=PersonalizedName]').length > 0) {
        $('body').on('input', 'input[name=PersonalizedName]', function() {
            const $this = $(this);
            const $getResult = $('.js-quiz-last-question');
            let labelText;

            const maxLength = parseInt($this.attr('maxlength'));

            const charNumnberLabel = $this.nextAll('.js-charnumber');
            labelText = maxLength - $this.val().length;

            if ($this.valid()) {
                charNumnberLabel.text(maxLength - $this.val().length);
                $getResult.removeAttr('disabled');
                return;
            }

            labelText = maxLength - $this.val().length;
            charNumnberLabel.text(labelText < 0 ? 0 : labelText);

            $getResult.attr('disabled', 'disabled');
        });
    }
}

const titleUrlRegex = / /g;

function pushStepToDataLayer() {
    const question = $('.js-gst-wrapper .js-question');

    if (!question.length) {
        return;
    }

    const title = question.find('.top-wrapper .heading-h3').text().trim();
    const locale = window.location.pathname.split('/')[1];

    if (getQuizType() === QuizOptionTypes.HairTemple) {
        gtm.pushDataLayerEvent({
            'event': 'hairTemplePage',
            'virtualURL': '/' + locale + '/hair-temple/' + title.replace(titleUrlRegex, '-').toLowerCase(),
            'virtualTitle': 'Hair Temple - ' + title
        });
    }

}

function pushSelectedOptionToDataLayer() {
    const question = $('.js-gst-wrapper .js-question');
    if (!question.length) {
        return;
    }

    const title = question.find('.top-wrapper .heading-h3').text().trim();
    const selectedValues = $.map($('.js-gst-wrapper .js-question .js-option-block.selected'),function(element){
        return $(element).data('option-text-value');
    });

    if (getQuizType() === QuizOptionTypes.HairTemple) {
        gtm.pushDataLayerEvent({
            'event': 'hairTempleSelection',
            'eventCategory': 'Hair Temple',
            'eventAction': title,
            'eventLabel': selectedValues.join('|')
        });
    }
}

function initQuizResult() {
    const $viewResults = $('.js-view-results');

    if ($viewResults.length > 0) {
        const landingPageUrl = String.format('{0}?elixirIds={1}&shampooId={2}&conditionerId={3}&customerName={4}&productIds={5}&startPage={6}', Urls.hairTempleLanding,
                outcome.elixirIds, outcome.shampooId, outcome.conditionerId, outcome.customerName, outcome.productIds, startPage);
        $viewResults.attr('href', landingPageUrl);
    }
}

function accessibilityCheckboxAdjustment() {
    if ($('.js-option-block').length) {
        $('.js-option-block').each(function () {
            const $this = $(this);
            const $optionCheckbox = $this.find('.round-select-box');
            const optionText = $this.find('.option-text').html();

            $optionCheckbox.attr('role', 'checkbox').attr('aria-checked', 'false');
            $optionCheckbox.parent().append('<span class="sr-only">' + optionText + '</span>');

        });
    }
}

function stickyNavButtons() {
    const $btnPlaceholder = $('.js-nav-container');

    if (isSmallView()) {
        if ($btnPlaceholder.length) {
            const $buttons = $('.js-nav-container-inner');
            const btnHeight = $buttons.outerHeight();
            const btnHolderTopPosition = $btnPlaceholder[0].getBoundingClientRect().top;
            const btnBottomPosition = btnHolderTopPosition + btnHeight + 20;
            const windowHeight = $(window).outerHeight();

            if (btnBottomPosition < windowHeight) {
                $btnPlaceholder.removeClass('sticky-buttons');
            } else {
                $btnPlaceholder.addClass('sticky-buttons');
            }
        }
    }
}

const gst = {
    init: function () {
        pushStepToDataLayer();
        initEvents();
        getQuizConfigs();
        getQuestionConfigs();
        initProgressBar();
        initCustomerNameValidation();
    }
};

module.exports = gst;

},{"./dragList":423,"./grid":437,"./modules/ajax":449,"./modules/google":453,"./modules/helpers/isSmallView":469,"./pages/collection/collection-ingredients":531,"./product-description":576,"./product-filter":577,"./product-slider":580,"./responsive-background":588,"./rituals-styles":592,"./slick-slider":598,"./video":608}],439:[function(require,module,exports){
'use strict';

const Promise = require('promise');

const gwpWelcomeMessage = {
    def: {
        $welcomeBannerElement: null,
        $welcomeBannerContentElements: null,
        $welcomeInnerBannerElement: null,
        $approachingDiscountElements: null,
        $welcomeOverlayElement: null,
        delay: 4000
    },
    init: function(options) {
        gwpWelcomeMessage.def.$welcomeBannerElement = options.$parentElement.find('.js-gwp-welcome-banner');
        gwpWelcomeMessage.def.$welcomeBannerContentElements = options.$parentElement.find('.gwp-welcome-banner-title, .gwp-welcome-banner-content');
        gwpWelcomeMessage.def.$welcomeInnerBannerElement = options.$parentElement.find('.js-gwp-welcome-banner-inner');
        gwpWelcomeMessage.def.$approachingDiscountElements = options.$parentElement.find('.js-approaching-discount, .js-gwp-cart-banner');
        gwpWelcomeMessage.def.$welcomeOverlayElement = options.$parentElement.find('.js-gwp-welcome-overlay');
    },
    exists: function() {
        return gwpWelcomeMessage.def.$welcomeBannerElement.length > 0 && !gwpWelcomeMessage.def.$welcomeBannerElement.hasClass('hide');
    },
    promises: {
        hideWelcomeMessagePromise: function hideWelcomeMessage() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$welcomeBannerElement.css('height', gwpWelcomeMessage.def.$welcomeInnerBannerElement.outerHeight());
                gwpWelcomeMessage.def.$welcomeInnerBannerElement.animate({
                    marginTop: '100%'
                }, 1300, function() {
                    gwpWelcomeMessage.def.$welcomeBannerElement.addClass('hide').removeAttr('style');
                    resolve();
                });
            });
        },
        fadeOutTextPromise: function fadeOutText() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$welcomeBannerContentElements.animate({
                    opacity: '0'
                }, 600, function() {
                    resolve();
                });
            });
        },
        fadeInGwpPromise: function fadeInGwp() {
            return new Promise(function(resolve) {
                gwpWelcomeMessage.def.$approachingDiscountElements.fadeIn(300, function() {
                    resolve();
                });
            });
        },
        slideGwpPromise: function slideGwp() {
            return new Promise(function(resolve) {
                const $bonusProduct = $('.slide-gift');

                $bonusProduct.animate({left: 0}, 2000, function() {
                    resolve();
                });
            });
        }
    },

    animate: function() {
        if (!gwpWelcomeMessage.exists()) {
            return;
        }

        setTimeout(function() {
            Promise.all([
                gwpWelcomeMessage.promises.hideWelcomeMessagePromise(),
                gwpWelcomeMessage.promises.fadeOutTextPromise()
            ])
            .then(function() {
                return gwpWelcomeMessage.promises.fadeInGwpPromise();
            })
            .then(function() {
                gwpWelcomeMessage.def.$welcomeOverlayElement.fadeOut(300);
            })
            .then(function() {
                return gwpWelcomeMessage.promises.slideGwpPromise();
            });
        }, gwpWelcomeMessage.def.delay);
    }
};

module.exports = gwpWelcomeMessage;

},{"promise":217}],440:[function(require,module,exports){
'use strict';

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');
const scrollHelper = require('./modules/helpers/scroll');
const searchsuggest = require('./searchsuggest');

const navRow = $('.js-navigation-row');
const navItemClass = '.js-navigation-item';

let scrollPosition = 0;
const windowDesktop = $(window).width() > 1023;
const windowTabletAndMobile = $(window).width() < 1024;
const windowTablet = $(window).width() > 767 & $(window).width() < 1024;
const windowMobile = $(window).width() < 768;

// search functionality vars
const header = $('.js-header');
const headerActions = $('.js-header-actions');
const searchInputToggle = $('.js-search-input-toggle');
const searchInputField = $('.js-search-input-field');
const searchSuggestions = $('.js-search-quick-links');
const headerLogo = $('.js-header-logo');
const closeSearchIcon = $('.js-close-search-bar');
const searchSuggestionsEl = $('.js-search-suggestions-container');
const searchOverlay = $('.js-search-overlay');
const searchInputClear = $('.js-search-clear');
const searchSuggestionsFirstLink = searchSuggestions.find('a').first();
const searchSuggestionsLastLink = searchSuggestions.find('a').last();
const mainNavToggle = $('.js-nav-toggle');
const desktopNavigation = $('.js-nav-desktop');

function initializeEvents() {
    // init search input events
    searchInputToggle.on('click', function(e){
        if (!headerActions.hasClass('search-expand')){
            e.preventDefault();

            if (windowTabletAndMobile) {
                headerActions.addClass('search-expand');
            }

            searchInputField.focus();
        }
    });

    // close search bar if field gets out of focus
    searchInputToggle.on('blur', function(){
        if (headerActions.hasClass('search-expand')){

            if (!isMobileOrTabletWidth()) {
                closeSearchBar();
            }
        }
    });

    // close search bar on close icon click
    closeSearchIcon.on('click', closeSearchBar);

    // show X icon for clearing input value on mobile
    searchInputField.on('input', function () {
        if (windowTabletAndMobile) {
            if ($(this).val() !== ''){
                searchInputToggle.hide();
                searchInputClear.show();

                if (!searchSuggestionsEl.hasClass('active')) {
                    openSearchBar();
                }
            } else {
                searchInputToggle.show();
                searchInputClear.hide();
            }
        }
    });

    searchInputClear.on('click', function () {
        $(this).hide();
        searchInputField.val('');
        searchInputToggle.show();
    });

    // ------ ACCESSIBILITY EVENTS ---------
    searchInputField.on('focus', function(e){
        if (!headerActions.hasClass('search-expand')) {
            if (windowTabletAndMobile) {
                e.preventDefault();
                $('.js-header-search-wrapper').next().find('> a').focus();
            } else {
                openSearchBar();
            }
        } else {
            if (navRow.length) {
                if (windowTabletAndMobile && !navRow.hasClass('active')) {
                    openSearchBar();
                }
            }

            if ($('.js-navigation-inner').length) {
                if (windowMobile && !$('.js-navigation-inner').hasClass('active')) {
                    openSearchBar();
                }
            }
        }
    });

    searchInputField.on('keyup', function (e) {
        if (e.which == 13) {
            if (searchInputField.val() === ''){
                e.preventDefault();
            }
        } else if (e.which === 27){
            closeSearchBar();
        }
    });

    closeSearchIcon.on('keyup', function(e){
        if (e.which === 13) {
            closeSearchBar();
        }
    });

    searchSuggestionsLastLink.on('blur', function() {
        if (windowDesktop) {
            closeSearchBar();
        }
    });

    searchInputField.on('keydown', function (e) {
        if (e.which === 13 && searchInputField.val().trim() === '') {
            e.preventDefault();
        }
    });

    searchInputToggle.on('click', function (e) {
        if (searchInputField.val().trim() === '') {
            e.preventDefault();
        }
    });

    if (windowTabletAndMobile) {
        closeSearchIcon.on('keydown', function(e){
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                searchInputField.focus();
            } else if (e.which === 9 && e.shiftKey) {
                e.preventDefault();

                if (searchSuggestionsEl.hasClass('active')) {
                    $(document).find('.js-search-results-holder a:last-child').focus();
                } else {
                    searchSuggestionsLastLink.focus();
                }
            }
        });
        searchInputField.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                if (searchInputField.val() === '') {
                    searchInputToggle.focus();
                } else {
                    searchInputClear.focus();
                }
            } else if (e.which === 9 && e.shiftKey) {
                e.preventDefault();

                if (searchSuggestionsEl.hasClass('active')) {
                    closeSearchIcon.focus();
                } else if (!searchSuggestionsEl.hasClass('active') && $('.js-navigation-inner').hasClass('active') && windowMobile) {
                    //TODO: refactor when new navigation replaces old one
                    const $mobVisibleLayer = $('.js-nav-mobile').find('.js-visible');
                    if ($mobVisibleLayer.length) {
                        const $mobLastVisibleItem = $mobVisibleLayer.find('> .js-mob-scrollable-container > ul > li:last-child');
                        if ($mobLastVisibleItem.hasClass('has-children')) {
                            $mobLastVisibleItem.find('> .js-mobile-nav-next-lvl').focus();
                        } else {
                            $mobLastVisibleItem.find('> a').focus();
                        }
                    } else {
                        if ($('.js-nav-mobile').find('.js-nav-mobile-additional').length) {
                            $('.js-nav-mobile-additional').find('li:last-child a').focus();
                        } else {
                            $('.js-nav-mobile-main-list').find('> li:last-child > button').focus();
                        }
                    }
                } else {
                    mainNavToggle.focus();
                }
            }
        });
        searchInputToggle.on('keydown', function (e) {
            if (headerActions.hasClass('search-expand')) {
                if (e.which === 9 && !e.shiftKey) {
                    e.preventDefault();

                    if (searchSuggestionsEl.hasClass('active')) {
                        searchSuggestionsFirstLink.focus();
                    } else {
                        if ($('.js-navigation-inner').hasClass('active')) {
                            //TODO: refactor when new navigation replaces old one
                            $('.js-nav-toggle').focus();
                        } else {
                            $(navItemClass).first().find('> a').focus();
                        }
                    }
                } else if (e.which === 9 && e.shiftKey) {
                    e.preventDefault();
                    searchInputField.focus();
                }
            }
        });
        searchInputClear.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                searchInputField.focus();
            }
        });
        searchSuggestionsFirstLink.on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                if (searchInputField.val() === '') {
                    searchInputToggle.focus();
                } else {
                    searchInputClear.focus();
                }
            }
        });
        searchSuggestionsLastLink.on('keydown', function (e) {
            if (e.which === 9 && !e.shiftKey) {
                e.preventDefault();
                closeSearchIcon.focus();
            }
        });
        $('.js-header-search-wrapper').next().find('> a').on('keydown', function (e) {
            if (e.which === 9 && e.shiftKey) {
                e.preventDefault();
                searchInputToggle.focus();
            }
        });
    }
}

function openSearchBar() {
    desktopNavigation.addClass('fade-nav');
    headerActions.addClass('search-expand');
    headerLogo.addClass('fade-out');
    mainNavToggle.addClass('fade-out');
    $('.js-nav-toggle').addClass('fade-out'); //TODO: refactor when new navigation replaces old one

    if (searchInputField.val() !== '') {
        const inputValue = searchInputField.val().trim();
        searchInputField.val(inputValue);
    }

    closeSearchIcon.fadeIn(400, function(){
        searchSuggestionsEl.fadeIn(50).addClass('active');
    });
    searchOverlay.fadeIn(400, function(){
        // init event for overlay
        searchOverlay.on('click', searchOverlayClickHandler);
    });


    // lock body scroll
    scrollPosition = $(window).scrollTop();
    $('body').addClass('body--no-scroll');
    $('body').css('top', -scrollPosition + 'px');

    //only on desktop
    if (!windowMobile) {
        searchOverlay.css({'top': header.height() + 'px'});
    }

    //if navigation is active
    if (windowTablet) {
        if (navRow.hasClass('active')) {
            navRow.addClass('all-visible');
        }
    }
}

function closeSearchBar() {
    $('.js-nav-toggle').removeClass('fade-out'); //TODO: refactor when new navigation replaces old one
    mainNavToggle.removeClass('fade-out');
    closeSearchIcon.fadeOut(50);
    searchSuggestionsEl.hide().removeClass('active');
    searchInputClear.hide();
    searchsuggest.clearResults();
    searchInputField.val('');
    searchOverlay.fadeOut(400, function(){
        searchOverlay.off('click', searchOverlayClickHandler);
        desktopNavigation.removeClass('fade-nav');
    });

    $('body').removeClass('body--no-scroll');
    $(window).scrollTop(scrollPosition);

    if (navRow.length) {
        if (!navRow.hasClass('active')) {
            scrollHelper.enableScroll();
            headerActions.removeClass('search-expand');
            headerLogo.removeClass('fade-out');
        } else if (navRow.hasClass('active')) {
            navRow.removeClass('all-visible');
        }

        if (headerActions.hasClass('search-expand')) {
            mainNavToggle.focus();
        }
    }

    //TODO: refactor when new navigation replaces old one
    if ($('.js-navigation-inner').length) {
        if (!$('.js-navigation-inner').hasClass('active')) {
            scrollHelper.enableScroll();
            headerActions.removeClass('search-expand');
            headerLogo.removeClass('fade-out');
        } else if ($('.js-navigation-inner').hasClass('active')) {
            $('.js-navigation-inner').removeClass('all-visible');
            headerLogo.addClass('fade-out');
            headerActions.addClass('search-expand');
            scrollHelper.disableScroll();
            $('.js-nav-toggle').focus();
        }
    }

    searchInputToggle.show();
}

function searchOverlayClickHandler(){
    closeSearchBar();
}

const headerMenu = {
    init: function() {
        initializeEvents();
        searchsuggest.init();
    },
    closeSearchBar: closeSearchBar
};

module.exports = headerMenu;

},{"./modules/helpers/scroll":475,"./modules/util/isMobileOrTabletWidth":498,"./searchsuggest":594}],441:[function(require,module,exports){
/**
 * Horizontal Product Scroll Class
 * issue: https://rituals.atlassian.net/browse/DL-21863
 *
 * Adds horizontal product scroll functionality similar to the draglist class
 */
'use strict';

const gtm = require('./modules/google').tagManager;

const productScrollSelector = '.js-horizontal-product-scroll';
const scrollBodySelector = '.js-scroll-slides';
const scrollProgressSelector = '.js-scroll-progress';
const introSlide = '.js-intro';
const videoslide = '.js-video-slide';
const videoControls = '.js-responsive-video-controls';
const scrollElements = [];
const trackedDataLayerEvents = [];
const isinView = [];
let currentQuarterNumber = 0;
const scrollState = {
    'active': false,
    'rect': '',
    'startX': 0,
    'clientX': 0,
    'target': ''
};

const scrollObserver = new IntersectionObserver((scrollers) => {
    for (const scroller of scrollers) {
        const currentY = scroller.boundingClientRect.y;
        const previousY = parseInt(scroller.target.dataset.previousY) || 0;
        scroller.target.classList.toggle('intersecting', scroller.isIntersecting);

        if (scroller.isIntersecting) {
            scroller.target.querySelector(introSlide).classList.remove('scroll-bg-white');
        }

        scroller.target.querySelectorAll('.scroll-slide-col').forEach((el, i) => {
            if (scroller.isIntersecting && currentY < previousY) {
                setTimeout(() => {
                    el.style.opacity = '1';
                    el.style.transform = 'translate3d(0, 0, 0)';
                }, i * 150);
            }
        });

        scroller.target.dataset.previousY = currentY;
    }
}, {
    threshold: [0.33, 0.66]
});

/**
 * Prepares the elements and attaches all events to the product scroll
 */
const initScrollers = () => {
    document.querySelectorAll(productScrollSelector).forEach((el, i) => {
        const scrollBody = el.querySelector(scrollBodySelector);

        scrollBody.dataset.listIndex = i;
        scrollBody.querySelectorAll('a, img').forEach((draggableEl) => {
            draggableEl.setAttribute('draggable', 'false');
        });

        scrollBody.addEventListener('scroll', e => {
            setProductScrollProgress(e);
            scrollProgresToDataLayer(e);
            scrollPlayVideo(e);
        });

        scrollBody.addEventListener('mousedown', onMouseDown);
        scrollBody.addEventListener('mouseup', onMouseUp);
        scrollObserver.observe(el);
        scrollElements.push(scrollBody);
    });

    document.addEventListener('mousemove', onMouseMove);
};

/**
 * Sets the progress element based on scroll position
 * @param {Event} e ScrollEvent
 */
const setProductScrollProgress = (e) => {
    const scrollEl = e.currentTarget;
    const progressEl = e.currentTarget.parentNode.querySelector(scrollProgressSelector);
    const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
    const progressVal = (100 / maxScroll) * scrollEl.scrollLeft;

    progressEl.value = Math.max(2, progressVal);
};

const scrollPlayVideo = (e) => {
    const thisVideo = e.currentTarget.parentNode.querySelector(videoslide);
    const rect = thisVideo.getBoundingClientRect().x;
    const thisVideoControls = e.currentTarget.parentNode.querySelector(videoControls);
    let currentNum = 0;

    if (rect <= window.innerWidth) {
        currentNum = 1;
    }

    if (currentNum !== 0 && isinView.indexOf(currentNum) === -1) {
        if (rect <= window.innerWidth) {
            thisVideo.querySelector('video').play();
            thisVideoControls.classList.add('is-playing');
        }

        isinView.push(currentNum);
    }
};

const scrollProgresToDataLayer = (e) => {
    const $progressEl = $(e.currentTarget.parentNode.querySelector(scrollProgressSelector));
    const analyticsData = $progressEl.length > 0 && $progressEl.data('analytics');
    if (!analyticsData) {
        return;
    }

    const scrollEl = e.currentTarget;
    const maxScroll = scrollEl.scrollWidth - scrollEl.clientWidth;
    const progressVal = (100 / maxScroll) * scrollEl.scrollLeft;
    const rounded = Math.round(progressVal * 10) / 10;

    if (rounded >= 25 && rounded < 50) {
        currentQuarterNumber = 25;
    } else if (rounded >= 50 && rounded < 75) {
        currentQuarterNumber = 50;
    } else if (rounded >= 75 && rounded < 100) {
        currentQuarterNumber = 75;
    } else if (rounded == 100){
        currentQuarterNumber = 100;
    }

    if (currentQuarterNumber !== 0 && trackedDataLayerEvents.indexOf(currentQuarterNumber) === -1) {
        trackedDataLayerEvents.push(currentQuarterNumber);
        gtm.pushDataLayerEvent({
            ...analyticsData,
            // eslint-disable-next-line camelcase
            scroll_depth: currentQuarterNumber
        });
    }
};
/**
 * Resets all the variables to their initial value
 */
const onMouseUp = (e) => {
    const scrollEl = scrollElements[e.currentTarget.dataset.listIndex];

    scrollEl.classList.remove('grabbing');
    scrollState.target = '';
    scrollState.rect = '';
    scrollState.startX = 0;
    scrollState.clientX = 0;
    scrollState.active = false;
};

/**
 * Moves the product scroll
 * @param {Event} e Mouse move event
 */
const onMouseMove = (e) => {
    if (scrollState.active) {
        const scrollX = scrollState.startX - (e.clientX - scrollState.rect.x);
        const scrollEl = scrollElements[scrollState.target.dataset.listIndex];

        scrollEl.scrollLeft = scrollX;

        // Dispatch window scroll event so elementInView logic is triggered
        window.dispatchEvent(new CustomEvent('scroll'));
    }
};

/**
 * Sets all the variables needed to be able to move the product scroll
 * @param {Event} e Mouse down event
 */
const onMouseDown = (e) => {
    const scrollEl = scrollElements[e.currentTarget.dataset.listIndex];

    scrollEl.classList.add('grabbing');
    scrollState.target = e.currentTarget;
    scrollState.rect = scrollState.target.getBoundingClientRect();
    scrollState.startX = scrollEl.scrollLeft + e.clientX - scrollState.rect.x;
    scrollState.clientX = e.clientX;
    scrollState.active = true;
};

/**
 * Tests if the product scroll exists on the page
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return document.querySelectorAll(productScrollSelector).length > 0;
};

module.exports = {
    init: () => {
        if (shouldInit()) {
            initScrollers();
        }
    }
};

},{"./modules/google":453}],442:[function(require,module,exports){
/**
 * Leadtime resource loader. Used to dynamicaly load leadtime strings into cached assets.
 * issue: https://rituals.atlassian.net/browse/DL-16479
 */
'use strict';

const leadtimePlaceholderEl = '.js-load-leatime';

function loadLeadtime() {
    const leadtimePlaceholders = $(leadtimePlaceholderEl);
    if (!leadtimePlaceholders.length) {
        return;
    }

    leadtimePlaceholders.each(function (i, placeholderEl) {
        const $placeholderEl = $(placeholderEl);
        const resourceId = $placeholderEl.data('resourceid');
        if (!resourceId) {
            return;
        }

        $.ajax({
            type: 'GET',
            url: Urls.leadtimeGetByResourceId,
            data: {
                rid: resourceId
            },
            success: function (data) {
                if (!data) {
                    return;
                }

                $placeholderEl.replaceWith(data);
            }
        });
    });
}

const leadtime = {
    init: loadLeadtime
};

module.exports = leadtime;

},{}],443:[function(require,module,exports){
'use strict';

const flyout = require('./flyout'),
    page = require('./page'),
    register = require('./pages/registration'),
    getQueryParameter = require('./modules/util/getQueryParameter'),
    isMobile = require('./modules/util/isMobile'),
    isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth'),
    validator = require('./validator'),
    ajax = require('./modules/ajax'),
    scrollHelper = require('./modules/helpers/scroll'),
    isSmallView = require('./modules/helpers/isSmallView'),
    toaster = require('./toaster'),
    ritualsFormHelper = require('./rituals-form-helper'),
    loseGiftGuestWarning = require('./loseGiftGuestWarning'),
    dialog = require('./dialog'),
    gtm = require('./modules/google').tagManager,
    recaptchaConfig = require('./recaptchaConfig'),
    damHelper = require('./dam/dam-helper');

const login = {
    /**
     * @private
     * @function
     * @description init events for the loginPage
     */
    init: function () {
        const pathParams = window.location.search;
        if (pathParams.includes('code')) {
            const dialogText = $('.js-magic-link-email').val();
            openDialog(dialogText);
        }

        if (pathParams.includes('redirected')) {
            const dialogText = $('.js-label-invalid-oobcode').val();
            const dialogButton = $('.js-button-invalid-oobcode').val();
            openDialog(dialogText, dialogButton);
        }

        ritualsFormHelper.init();
        toaster.init();

        //o-auth binding for which icon is clicked
        $('.oAuthIcon').bind('click', function () {
            $('#OAuthProvider').val(this.id);
        });

        //toggle the value of the rememberme checkbox
        $('#dwfrm_login_rememberme').bind('change', function () {
            if ($('#dwfrm_login_rememberme').attr('checked')) {
                $('#rememberme').val('true');
            } else {
                $('#rememberme').val('false');
            }
        });

        bindForProfileCheck();
        bindSetPasswordClick();
        bindResetPasswordClick();
        bindLoginFormSubmit();
        showVerificationMessage();
        bindCompleteFormSubmit();
        initializeNextLoginStep();
        initializeRecaptcha();
        bindDynamicPasswordCheck();

        const guestLoginBtn = $('div.js-guest-button button:first-child');
        guestLoginBtn.on('click', onGuestLoginBtnDown);
        guestLoginBtn.on('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                onGuestLoginBtnDown();
            }
        });

        guestLoginBtn.focusout(function () {
            $('input[id^="dwfrm_login_password"]').removeData('prevent-automatic-validation');
        });

        const forgotPasswordLink = $('.js-password-reset-link');
        forgotPasswordLink.on('click', onforgotPasswordLinkDown);
        forgotPasswordLink.mousedown(onforgotPasswordLinkDown);
        forgotPasswordLink.on('keydown', function (e) {
            if (e.keyCode === 13 || e.keyCode === 32) {
                onforgotPasswordLinkDown();
            }
        });

        $(document).on('click', '.btn-register-submit', function () {
            const errorMessage = $('.error-text:first').text();
            if (errorMessage) {
                gtm.pushDataLayerEvent({
                    event: 'signup',
                    error_type: null,
                    error_message: errorMessage.toLowerCase(),
                    error_code: null,
                    content_name: 'sign up'
                });
            }
            setTimeout(function() {
                $('.error-text').each(function() {
                    if ($(this).is('.input-checkbox.js-validator-error')) {
                        gtm.pushDataLayerEvent({
                            event: 'form_field_error',
                            error_type: 'form_field_error',
                            error_message: 'Terms & condition are not accepted',
                            error_code: null,
                            content_name: 'register page'
                        });
                    }
                });
            }, 500);
        });

        forgotPasswordLink.focusout(function () {
            $('input[id^="dwfrm_login_password"]').removeData('prevent-automatic-validation');
        });

        $('.js-close-flyout').on('keydown.resetpassword', function (e) {
            if (e.which == 9 && e.shiftKey) {
                const $lastButtonFlyout = flyout.def.$genericFlyout.find('.js-homepage-link');
                if (!$lastButtonFlyout.length) {
                    return;
                }
                e.preventDefault();
                flyout.def.$genericFlyout.find('.js-homepage-link').focus();
            }
        });

        $('.js-password-reset-dialog').on('click', function (e) {
            e.preventDefault();
            flyout.load({
                url: $(e.target).attr('href'),
                open: function () {
                    validator.init();
                }
            });
            $(this).addClass('js-flyout-opened');
        });

        //Back button for Account and Reset password page
        $(document).on('click', '.js-account-back', function () {
            window.history.back();
        });

        //Back button on mobile for Checkout login
        $(document).on('click', '.js-login-back', function () {
            window.history.back();
        });

        $('.js-reset-password-confirmation')
            .find('.js-reset-password-close, .js-continue-password-reset')
            .attr('tabindex', '-1');

        //close the reset password popup (toaster on mobile)
        $(document).on(
            'click touchstart',
            '.js-reset-password-close, .js-continue-password-reset, .js-modal-overlay',
            function () {
                $('.js-reset-password-confirmation').removeClass('open');
                $('.js-modal-overlay').fadeOut();
                $('.js-reset-password-confirmation')
                    .find('.js-reset-password-close, .js-continue-password-reset')
                    .attr('tabindex', '-1');
                $('.js-password-reset-button').focus();
            }
        );

        $('.js-new-password-confirmation')
            .find('.js-new-password-close, .js-new-password-reset')
            .attr('tabindex', '-1');

        //close the set new password popup (toaster on mobile)
        $(document).on(
            'click touchstart',
            '.js-new-password-close, .js-new-password-reset, .js-modal-overlay',
            function () {
                $('.js-new-password-confirmation').removeClass('open');
                $('.js-modal-overlay').fadeOut();
                $('.js-new-password-confirmation')
                    .find('.js-new-password-close, .js-new-password-reset')
                    .attr('tabindex', '-1');
            }
        );

        $('body').on('click', '.js-password-reset-link', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const emailField = $('input[id^="dwfrm_login_username"]');
            let emailVal;

            if (emailField.length) {
                emailVal = emailField.val().trim();
            }

            if (!emailVal) {
                window.location.href = $(this).attr('href');
            }
            const passFrm = $('#dwfrm_requestpassword');
            passFrm.find('input.js-emailtopass').val(emailVal);
            passFrm.submit();
        });

        $('.js-password-reset-link').on('keydown', function (e) {
            const key = e.which;
            if (key == 13) {
                $(this).click();
            }
        });

        //toggle password visibility
        $(document).on('click', '.js-toggle-password-visibility', function (e) {
            e.preventDefault();
            const $this = $(this);
            $this.toggleClass('visible');

            if ($this.hasClass('visible')) {
                e.preventDefault();
                $this.prevAll('.input-text.passwordcheck, .inputfield-text').attr('type', 'text');
                return;
            }

            $this.prevAll('.input-text.passwordcheck, .inputfield-text').attr('type', 'password');
        });

        const welcomeBack = getQueryParameter(window.location.href, 'welcomeBack');
        if (welcomeBack) {
            let welcomeBackText = $('.js-new-password-confirmation span.text-container').text();
            welcomeBackText = welcomeBackText.replace('{0}', welcomeBack);
            $('.js-new-password-confirmation span.text-container').text(welcomeBackText);

            if (!$('.pt_account_loggedin').length) {
                $('.js-new-password-confirmation').addClass('open');
                $('.js-modal-overlay').fadeIn();
                $('.js-new-password-confirmation').find('.js-new-password-reset').focus();
                $('.js-new-password-confirmation')
                    .find('.js-new-password-close, .js-new-password-reset')
                    .attr('tabindex', '0');
            }

            $('.js-new-password-reset').on('keydown', function (e) {
                if (e.which == 9) {
                    e.preventDefault();
                    $('.js-new-password-close').focus();
                }
            });

            $('.js-new-password-close').on('keydown', function (e) {
                if (e.which == 9) {
                    e.preventDefault();
                    $('.js-new-password-reset').focus();
                }
            });

            $(document).on('keydown', function (e) {
                if (e.which == 27 && $('.js-new-password-confirmation').hasClass('open')) {
                    e.preventDefault();
                    $('.js-new-password-confirmation').removeClass('open');
                    $('.js-modal-overlay').fadeOut();
                    $('.js-new-password-confirmation')
                        .find('.js-new-password-close, .js-new-password-reset')
                        .attr('tabindex', '-1');
                    $('.js-skip-to-content').focus();
                }
            });
        }

        $(document).on('click', '#btn-checkout-guest', function () {
            const guest = document.getElementById('checkoutAsGuest');
            if (guest) {
                guest.value = 'true';
            }
        });

        $(document).on('click', '#btn-login', function () {
            const guest = document.getElementById('checkoutAsGuest');
            if (guest) {
                guest.value = 'false';
            }
        });

        $(document).on('click', '#btn-checkout-register', function () {
            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');
        });

        //data layer event for errors on username input in login form
        $('input[id^="dwfrm_login_username"]').on('blur', function() {
            if ($(this).hasClass('js-validator-error')) {
                gtm.pushDataLayerEvent({
                    event: 'form_field_error',
                    error_type: 'form_field_error',
                    error_message: 'wrong email, please enter a valid value',
                    error_code: null,
                    content_name: 'login page'
                });
            }
        });
    },
    hideOverlay: hideOverlay
};

const openDialog = function (dialogText, dialogButton) {
    if (!dialogText) {
        return;
    }

    if (!dialogButton) {
        dialogButton = window.Resources.CONTINUE;
    }

    window.eventBus.$emit('shouldOpenModal', {
        paragraphs: [
            {
                text: dialogText
            }
        ],
        buttons: [
            {
                type: 'btn btn--secondary',
                label: dialogButton,
                shouldCloseModal: true
            }
        ],
        ctaHolder: {
            hideOnMobileAndTablet: false
        },
        row: {
            class: 'center-align'
        },
        closeElement: {
            shouldCloseModal: true
        },
        shouldModalCloseOnMobile: false,
        modalCustomId: 'LoginPage'
    });
};

const onGuestLoginBtnDown = function () {
    $('input[id^="dwfrm_login_password"]').data('prevent-automatic-validation', true);
    $('span[id^="dwfrm_login_password"]').addClass('hide').removeAttr('style');
    $('input[id^="dwfrm_login_password"]').removeClass('js-validator-error error');
};

const onforgotPasswordLinkDown = function () {
    $('input[id^="dwfrm_login_password"]').data('prevent-automatic-validation', true);
    $('span[id^="dwfrm_login_password"]').addClass('hide').removeAttr('style');
    $('input[id^="dwfrm_login_password"]').removeClass('js-validator-error error');
};

const bindSetPasswordClick = function () {
    $('body').on('click.resetpassword', '[name$="_resetpassword_send"]', function () {
        const $submit = $(this);
        const $NewPasswordForm = $submit.parents('[name$="NewPasswordForm"]');
        if (!$NewPasswordForm.valid()) {
            return;
        }
        $submit.addClass('btn--disabled').addClass('button-loading');
        $submit.find('.js-spinner-general').addClass('spinner-visible');
    });
};

const bindResetPasswordClick = function () {
    $('body').on('click.resetpassword', '[name$="_requestpassword_send"]', function (e) {
        const $submit = $(this);
        const $requestPasswordForm = $submit.parents('[name$="_requestpassword"]');
        e.preventDefault();
        if (!$requestPasswordForm.valid()) {
            return;
        }
        $submit.addClass('btn--disabled').addClass('button-loading');
        $submit.find('.js-spinner-general').addClass('spinner-visible');

        if (executeRecapthcaForForm($requestPasswordForm)) {
            e.preventDefault();
            return false; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div
        }

        const options = {
            form: $requestPasswordForm,
            triggeredAction: $submit.attr('name'),
            handleCsrfMismatch: function () {
                page.redirect(Urls.csrffailed);
            },
            handleJson: function (response) {
                const emailField = $('#dwfrm_requestpassword_email');

                if (response.showRecaptcha) {
                    initializeInvisibleRecaptcha($requestPasswordForm, 'resetpassword--recaptcha-container');
                    $('#resetpassword--recaptcha-container').removeClass(
                        recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS
                    ); // from now on use recaptcha on page
                    $submit.removeClass('btn--disabled').removeClass('button-loading');
                    $submit.find('.js-spinner-general').removeClass('spinner-visible');
                }

                if (response.errorMessage) {
                    const validator = $requestPasswordForm.validate();

                    validator.showErrors({
                        dwfrm_requestpassword_email: response.errorMessage
                    });

                    if (!response.showRecaptcha) {
                        $submit.removeClass('btn--disabled').removeClass('button-loading');
                        $submit.find('.js-spinner-general').removeClass('spinner-visible');
                    }
                }

                emailField.focus();
            },
            callback: function (response) {
                $submit.removeClass('btn--disabled').removeClass('button-loading');
                $submit.find('.js-spinner-general').removeClass('spinner-visible');
                const $response = $(response);
                if (showResetPasswordError($response)) {
                    return;
                }

                // wrapping $response in a div because it a list of nodes for which selector can not be used
                if ($('<div>').append($response).find('.js-display-recaptcha').length) {
                    initializeInvisibleRecaptcha($requestPasswordForm, 'resetpassword--recaptcha-container');
                    $('#resetpassword--recaptcha-container').removeClass(
                        recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS
                    ); // from now on use recaptcha on page
                }

                const passwordConfirmationText = $(response).filter('.js-reset-password-email').val();

                openDialog(passwordConfirmationText);
            },
            handleError: function () {
                $('.js-flyout-content').html('<h1>' + Resources.SERVER_ERROR + '</h1>');
            }
        };
        ajax.postForm(options);
    });
};

const bindForProfileCheck = function () {
    const loginField = $('.js-profilecheck');
    if (!loginField.length) {
        return;
    }

    loginField.on('blur', function () {
        if (this.value.length > 0) {
            $.ajax({
                dataType: 'json',
                url: Urls.checkAccountStatus,
                data: 'login=' + this.value
            }).done(function (val) {
                if (val.result === 1) {
                    flyout.load({
                        url: Urls.friendlyPasswordReset + '&email=' + $('.js-profilecheck').val()
                    });
                }
            });
        }
    });
};

const bindLoginFormSubmit = function () {
    bindHistoryHandler();

    $(document).on('submit.ajaxflow', '#dwfrm_login.js-loginajax-form', function (e) {
        processLoginSubmit(this, e);
    });

    if (window.location.hash === '#choose') {
        const loginForm = $('#dwfrm_login.js-loginajax-form');
        const email = $('input[name$=customerEmail]').val();

        const emailField = $('input[id^="dwfrm_login_username"]');
        emailField.val(email);

        processLoginSubmit(loginForm, null);
    } else {
        $('.js-loginwrap').removeClass('hide');
    }
};

const processLoginSubmit = function (formElement, e) {
    const form = $(formElement);
    preventDefault(e);

    if (!form.valid()) {
        return;
    }

    const checkoutAsGuest =
        document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;
    const submitElements = form.find('button[type=submit]');

    let submit;
    if (checkoutAsGuest === 'true') {
        submit = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-checkout-guest';
        });
    } else {
        submit = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-login';
        });
    }

    submitElements.addClass('btn--disabled');
    submit.addClass('button-loading');
    submit.find('.js-spinner-general').addClass('spinner-visible');

    history.replaceState(
        {showElement: '.js-loginwrap', removeElement: '.js-ajaxflow'},
        'login-start',
        window.location.href
    );
    history.pushState({formToSubmit: '#dwfrm_login'}, null, window.location.href.split('#')[0] + '#');

    const options = {
        form: form,
        handleJson: handleExistingAccount,
        handleCsrfMismatch: handleLoginCsrfMismatch,
        triggeredAction: submit.attr('name'),
        callback: function (response) {
            if (checkoutAsGuest && response.redirectTo) {
                window.location.replace(response.redirectTo);
                return;
            }
            submitElements.removeClass('btn--disabled');
            submit.removeClass('button-loading');
            submit.find('.js-spinner-general').removeClass('spinner-visible');
            $('[data-page-name]').remove();
            $('.js-loginwrap').hide().after(response);

            initializeNextLoginStep();
        }
    };

    ajax.postForm(options);
};

const preventDefault = function (e) {
    if (e !== null && e !== 'undefined') {
        e.preventDefault();
    }
};

function initializeNextLoginStep() {
    let pageName;

    loseGiftGuestWarning.init();

    const formEl = $('[data-page-name]');

    if (formEl.length > 0) {
        formEl.find('input:not([type=hidden])').first().focus();
        validator.init();
        ritualsFormHelper.init();

        pageName = formEl.data('page-name');

        const imageHolder = formEl.find('.js-account-benefits-image-holder');
        if (imageHolder.length > 0) {
            damHelper.updateImages(imageHolder, true);
        }

        setTimeout(function () {
            const recaptchaContainerId = pageName + '--recaptcha-container';
            const $form = $('#' + recaptchaContainerId).parents('form');
            initializeInvisibleRecaptcha($form, recaptchaContainerId);
        }, 1000);
    }

    if (pageName === 'registration') {
        history.replaceState(
            {showElement: '.js-loginwrap', removeElement: '.js-ajaxflow'},
            'login-start',
            window.location.href
        );
        history.pushState({formToSubmit: '#dwfrm_login'}, null, window.location.href.split('#')[0] + '#');
        bindRegistrationFormSubmit();
        register.init();
        return;
    }

    if (pageName) {
        history.replaceState(
            {showElement: '.js-loginwrap', removeElement: '[data-page-name="' + pageName + '"]'},
            'login-start',
            window.location.href
        );
        history.pushState(
            {formToSubmit: '#dwfrm_login'},
            pageName,
            window.location.href.split('#')[0] + '#' + pageName
        );
    }

    if (isSmallView()) {
        $('html, body').scrollTop(0);
    }
}

function executeRecapthcaForForm(form) {
    const recaptchaContainerId = form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR);
    // if there is recaptcha -> only submit the form once the recaptcha is validated (js-recaptchadone class is set on a form)
    if (
        !form.hasClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS) ||
        form.hasClass(recaptchaConfig.CONSTANTS.CHALLENGE_DONE_CLASS)
    ) {
        recaptchaConfig.removeChallengeDoneClass(recaptchaContainerId); // removes 'js-recaptchadone' class indicator
        return false;
    }

    const recaptchaContainer = form.find('#' + recaptchaContainerId);
    if (recaptchaContainer.length && !recaptchaContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)) {
        recaptchaConfig.executeForContainer(recaptchaContainerId);
        return true; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div (recaptchaConfig.init call params)
    }

    return false;
}

const bindCompleteFormSubmit = function () {
    $('body')
        .off('submit', '#dwfrm_completeaccount.js-loginajax-form')
        .on('submit', '#dwfrm_completeaccount.js-loginajax-form', function (e) {
            const form = $(this);
            e.preventDefault();
            if (!form.valid()) {
                return;
            }

            const submitElements = form.find('button[type=submit]');
            const checkoutAsGuest =
                document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;

            let submit;
            if (checkoutAsGuest === 'true') {
                submit = submitElements.filter(function () {
                    return $(this).attr('id') === 'btn-checkout-guest';
                });
            } else {
                submit = submitElements.filter(function () {
                    return $(this).attr('id') === 'btn-login';
                });
            }

            submitElements.addClass('btn--disabled');
            submit.addClass('button-loading');
            submit.find('.js-spinner-general').addClass('spinner-visible');

            if (executeRecapthcaForForm(form)) {
                e.preventDefault();
                return false; // form will be submitted in the handler function registered for form in recaptcha for 'recaptchaContainerId' div
            }

            const options = {
                form: form,
                handleJson: handleCompleteResponse,
                handleCsrfMismatch: handleLoginCsrfMismatch,
                triggeredAction: submit.attr('name')
            };

            ajax.postForm(options);
        });
};

const bindRegistrationFormSubmit = function () {
    $('body').on('submit', '#RegistrationForm.js-loginajax-form', function (e) {
        const form = $(this);
        e.preventDefault();
        const submit = $(this).find('button[type=submit]');

        if (!form.valid()) {
            return;
        }
        submit.addClass('btn--disabled').addClass('button-loading');
        submit.find('.js-spinner-general').addClass('spinner-visible');

        if (executeRecapthcaForForm(form)) {
            e.preventDefault();
            return false; // form will be submitted in the handler function registered in recaptcha for 'recaptchaContainerId' div
        }

        const options = {
            form: form,
            handleJson: handleRegistrationResponse,
            handleCsrfMismatch: login.handleLoginCsrfMismatch,
            triggeredAction: submit.attr('name')
        };

        ajax.postForm(options);
    });
};

function initializeRecaptcha() {
    const recaptchaLoginFormContainer = $('#recaptcha-container-login');
    if (
        recaptchaLoginFormContainer &&
        !recaptchaLoginFormContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)
    ) {
        initializeInvisibleRecaptcha($('#dwfrm_login'), 'recaptcha-container-login');
    }

    const recaptchaResetPasswordFormContainer = $('#resetpassword--recaptcha-container');
    if (
        recaptchaResetPasswordFormContainer &&
        !recaptchaResetPasswordFormContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS)
    ) {
        initializeInvisibleRecaptcha($('#PasswordResetForm'), 'resetpassword--recaptcha-container');
    }
}

function initializeInvisibleRecaptcha(form, containerId) {
    const recaptchaDefinitions = [
        recaptchaConfig.buildContainerDefinition(form, containerId, recaptchaConfig.defaultVerifyHandler)
    ];
    recaptchaConfig.init(recaptchaDefinitions);
    form.addClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS);
    form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR, containerId);
}

const handleExistingAccount = function (response) {
    $('[data-page-name]').remove();
    const form = $('#dwfrm_login');
    const submitElements = form.find('button[type=submit]');

    const checkoutAsGuest =
        document.getElementById('checkoutAsGuest') && document.getElementById('checkoutAsGuest').value;
    let button;
    if (checkoutAsGuest === 'true') {
        button = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-checkout-guest';
        });
    } else {
        button = submitElements.filter(function () {
            return $(this).attr('id') === 'btn-login';
        });
    }

    const isOnboardingView = $('.js-onboarding-view').length > 0;
    if (isOnboardingView) {
        storeOnboardingLogin();
    }

    if (response.redirectTo) {
        window.location.replace(response.redirectTo);
        return;
    }

    if (response.showPasswordField) {
        form.attr('action', response.continueURL);

        if (!response.ajaxFlow) {
            form.addClass('js-postback');
        }

        const $spinner = $('.js-spinner-general', button);

        button.attr('value', response.buttonLabel);
        button.attr('name', response.buttonHtmlName);
        button.text(response.buttonLabel);
        button.append($spinner);
        $('.js-guest-button').addClass('hidden');
        $('.js-guest-div').addClass('hidden');
        $('.js-page-layout-left-subtitle').text(response.subtitle);
        const elementsToSlide = response.showRecaptcha ? form.find('.hide') : form.find('.js-slidedown.hide');
        loseGiftGuestWarning.init();
        elementsToSlide.slideDown(function () {
            const passwordField = form.find('input[type=password]');
            passwordField.removeAttr('disabled');
            elementsToSlide.removeClass('hide');
            elementsToSlide.find('label, .js-toggle-password-visibility').removeClass('label-disabled');
            if (response.showRecaptcha) {
                initializeInvisibleRecaptcha(form, 'recaptcha-container-login');
            }
            button.removeClass('btn--disabled').removeClass('button-loading');
            button.find('.js-spinner-general').removeClass('spinner-visible');
            passwordField.focus();
        });

        if (response.ajaxFlow) {
            return;
        }

        $('#dwfrm_login.js-loginajax-form').removeClass('js-loginajax-form');
        return;
    }

    if (response.errorHtml) {
        const existingMessage = form.find('.error-form');
        if (!existingMessage.length) {
            form.prepend(response.errorHtml);
        }
        existingMessage.hide().slideDown();
    }

    if (response.showRecaptcha) {
        initializeInvisibleRecaptcha(form, 'recaptcha-container-login');
        button.removeClass('btn--disabled');
        return;
    }

    if (response.validCredentials) {
        handleSuccessfullyLogin(response.showGwpWelcomeMessage);
    }

    submitElements.removeClass('btn--disabled');
    button.removeClass('button-loading');
    button.find('.js-spinner-general').removeClass('spinner-visible');
};

const handleCompleteResponse = function (response) {
    return handleJSONResponse(response, '#dwfrm_completeaccount');
};

const handleRegistrationResponse = function (response) {
    return handleJSONResponse(response, '#RegistrationForm');
};

const handleJSONResponse = function (response, formSelector) {
    if (response.valid) {
        if (response.redirectTo) {
            window.location.replace(response.redirectTo);
            return;
        }
        handleSuccessfullyLogin();
        return;
    }

    let form = $(formSelector);
    if (response.showLogin) {
        form = $('#dwfrm_login');
        $('[data-page-name]').remove();
        $('.js-loginwrap').show();
    } else {
        initializeInvisibleRecaptcha(form, form.find('.recaptcha-container').attr('id'));
    }

    if (response.errorHtml) {
        const existingMessage = form.find('.error-form');
        if (existingMessage.length) {
            existingMessage.remove();
        }
        form.prepend(response.errorHtml);

        existingMessage.hide().slideDown();
    }

    const button = form.find('button[type=submit]');
    button.removeClass('btn--disabled').removeClass('button-loading');
    button.find('.js-spinner-general').removeClass('spinner-visible');
};

const storeOnboardingLogin = function () {
    $('.js-onboarding-hide').each(function () {
        $(this).addClass('hide');
    });
    $('.js-onboarding-show').each(function () {
        $(this).removeClass('hide');
    });
};

const handleLoginCsrfMismatch = function () {
    const options = {
        url: Urls.getLoginPage,
        target: $('.js-loginwrap'),
        replaceTarget: true
    };
    ajax.load(options);
};

const bindHistoryHandler = function () {
    window.onpopstate = function (history) {
        if (!history.state) {
            return true;
        }

        if (history.state.showElement) {
            $(history.state.showElement).show();
        }

        if (history.state.removeElement) {
            $(history.state.removeElement).remove();
        }

        if (history.state.hideElement) {
            $(history.state.hideElement).hide();
        }

        if (history.state.formToSubmit) {
            $(history.state.formToSubmit).submit();
            history.preventDefault();
            history.stopPropagation();
            return false;
        }
    };
};

const handleSuccessfullyLogin = function (showGwpWelcomeMessage) {
    hideOverlay();

    if (showGwpWelcomeMessage && isMobile()) {
        require('./bonus-products-view').getGWPBanner();
        toaster.load({
            url: Urls.getGwpWelcomeToastMessage + '?currentPipeline=' + Urls.currentPipeline,
            close: function () {
                const isCartPage = $('.pt_cart').length > 0;
                if (isCartPage) {
                    location.reload();
                }
            }
        });
    }
};

function hideOverlay() {
    $('.js-login-overlay').animate(
        {
            bottom: '-100%'
        },
        800,
        function () {
            $(this).removeClass('overlay-visible').empty();
        }
    );
    scrollHelper.enableScroll();
}

function showResetPasswordError($response) {
    const error = $response.find('#PasswordResetForm #dwfrm_requestpassword_email-error');
    if (!error.length) {
        return false;
    }
    error.insertBefore($('#dwfrm_requestpassword_email'));
    return true;
}

function showVerificationMessage() {
    const container = $('.js-account-verification');
    if (!container.length) {
        return;
    }

    if (isMobileOrTabletWidth()) {
        toaster.init();
        toaster.def.$toastContent.html(container.html());
        toaster.open({
            close: function () {
                $('.js-modal-overlay').hide();
            }
        });
        return;
    }

    dialog.open({
        html: container.html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 600,
            dialogClass: 'gwp-dialog account-verification-popup',
            open: function () {
                $('.js-modal-overlay').show();
                $(document).on('click touchstart', '.js-modal-overlay', function () {
                    dialog.close();
                });

                $(document).on('click', '.js-gwp-open .js-close-toaster', function () {
                    dialog.close();
                });
            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();
                $(document).off('click', '.js-modal-overlay');
            }
        }
    });
}

function bindDynamicPasswordCheck() {
    const regex = {
        minlength: /^.{8,}$/,
        uppercase: /(?=.*[A-Z])/,
        number: /(?=.*\d)/
    };

    const $passwordInput = $('.dynamic.passwordcheck');
    const $dynamicCheckDiv = $('#dynamiccheck');

    function toggleDynamicCheckDiv() {
        if ($passwordInput.is(':focus') || $passwordInput.val() && $passwordInput.val().length > 0) {
            $dynamicCheckDiv.show();
        } else {
            $dynamicCheckDiv.hide();
        }
    }

    toggleDynamicCheckDiv();

    $passwordInput.on('focus blur', toggleDynamicCheckDiv).on('input', function () {
        const currentValue = $(this).val();

        $.each(regex, function (key, value) {
            const isValid = value.test(currentValue);
            const $target = $('#' + key);

            $target.find('span.js-icon-close').attr('hidden', isValid);
            $target.find('span.js-icon-check').attr('hidden', !isValid);
        });
    });
}

module.exports = login;

},{"./bonus-products-view":276,"./dam/dam-helper":419,"./dialog":422,"./flyout":425,"./loseGiftGuestWarning":445,"./modules/ajax":449,"./modules/google":453,"./modules/helpers/isSmallView":469,"./modules/helpers/scroll":475,"./modules/util/getQueryParameter":490,"./modules/util/isMobile":497,"./modules/util/isMobileOrTabletWidth":498,"./page":518,"./pages/registration":563,"./recaptchaConfig":587,"./rituals-form-helper":590,"./toaster":605,"./validator":607}],444:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax'),
    login = require('./login'),
    scrollHelper = require('./modules/helpers/scroll'),
    isMobile = require('./modules/util/isMobile'),
    toaster = require('./toaster');

const loginOverlay = {
    init: function () {
        if (!isMobile()) {
            return;
        }

        $(document).on('click', '.js-trigger-overlay-login', function (e) {
            e.preventDefault();
            e.stopPropagation();
            initLoadingLoginForm(false);
        });

        $(document).on('click', '.js-trigger-overlay-gwp-login', function (e) {
            e.preventDefault();
            e.stopPropagation();
            initLoadingLoginForm(true, $(this).data('gwpsource'));
        });

        $(document).on('click', '.js-hide-overlay', function (e) {
            e.preventDefault();
            e.stopPropagation();
            login.hideOverlay();
        });
    }
};

const initLoadingLoginForm = function(showGwpWelcomeMessage, gwpsource) {
    toaster.closeToasters();

    const container = $('.js-login-overlay');
    ajax.load({
        skipDataType:true,
        data: {
            showGwpWelcomeMessage: showGwpWelcomeMessage,
            gwpsource: gwpsource,
            isLoginFormOnMobile: true
        },
        url: Urls.getLoginPage,
        target:container,
        handleJson: function (response) {
            if (response.alreadyLoggedIn) {
                //TODO: handle already logged in customer
                return;
            }
        },
        callback: function (response) { /* eslint-disable-line */
            container.addClass('overlay-visible').animate({
                bottom: 0
            }, 800,
            function(){
                login.init();
                scrollHelper.disableScroll();
                container.find('.js-loginwrap .inputfield-text').first().focus();
            });
        }
    });
};


module.exports = loginOverlay;

},{"./login":443,"./modules/ajax":449,"./modules/helpers/scroll":475,"./modules/util/isMobile":497,"./toaster":605}],445:[function(require,module,exports){
'use strict';

const damHelper = require('./dam/dam-helper');

const loseGiftGuestWarning = {
    def: {
        guestCheckoutForm: '.js-guest-checkout-form'
    },

    createBonusWarningDialog: function (guestGwpProductName, guestGwpImage) {
        window.eventBus.$emit('shouldOpenModal', {
            paragraphs: [{
                    text: window.Resources.REMOVE_GIFT_EXPLANATION,
                    textLarge: true
                },
                {
                    text: window.Resources.REMOVE_GIFT_QUESTION,
                    textLarge: true
                }
            ],
            productImage: {
                src: guestGwpImage.src,
                alt: guestGwpProductName,
                class: guestGwpImage.class,
                placeholder: guestGwpImage.placeholder,
            },
            buttons: [{
                    type: 'btn btn--secondary',
                    label: window.Resources.MODAL_NO,
                    eventName: 'onCancelLoseGiftButtonClick',
                    shouldCloseModal: true
                },
                {
                    type: 'btn',
                    label: window.Resources.MODAL_YES,
                    eventName: 'onConfirmLoseGiftButtonClick',
                    shouldCloseModal: true
                }
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: true,
            ctaHolderRow: true
        });

        window.eventBus.$on('onConfirmLoseGiftButtonClick', function () {
            $(document).off('submit.popup', '.js-guest-checkout-form');
            $('.js-guest-checkout-form').find('button').click();
        });

        window.eventBus.$on('onCancelLoseGiftButtonClick', function () {
            const button = $('#btn-checkout-guest');
            button.removeClass('button-loading');
            $('.js-spinner-general', button).removeClass('spinner-visible');
        });

        window.eventBus.$off('modalOpen').$on('modalOpen', function () {
            damHelper.updateImages($('#modal'));
        });
    },

    events: function () {
        $(document).off('submit.popup', loseGiftGuestWarning.def.guestCheckoutForm).on('submit.popup', loseGiftGuestWarning.def.guestCheckoutForm, function (e) {
            const button = $('button[type=submit]', this);
            button.addClass('button-loading');
            $('.js-spinner-general', button).addClass('spinner-visible');
            const guestGwpProductName = $('#js-gwp-for-guest-product-name').val();

            const $guestGWPProductImage = $('#js-gwp-for-guest-product-image');
            if (!$guestGWPProductImage.length) {
                return true;
            }

            const productImage = JSON.parse($guestGWPProductImage.val());

            e.preventDefault();
            loseGiftGuestWarning.createBonusWarningDialog(guestGwpProductName, productImage);
        });
    },

    init: function () {
        loseGiftGuestWarning.events();
    }
};

module.exports = loseGiftGuestWarning;

},{"./dam/dam-helper":419}],446:[function(require,module,exports){
'use strict';

const headerMenu = require('./header-menu');
const flyout = require('./flyout');
const loginOverlay = require('./loginOverlay');
const isMobileWidth = require('./modules/util/isMobileWidth');
const gwpWelcomeMessage = require('./gwp-welcome-message');
const pgminicart = require('./pages/personalisedgifting/pgminicart');
const damHelper = require('./dam/dam-helper');
const ajaxUrl = require('./modules/util/ajaxUrl');
const isDesktopView = require('./modules/helpers/_helpers');

const timer = {
    id: null,
    clear: function () {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function (duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

function displayCRMChoiceModule(discountDataElement, miniCart, openMinicart) {
    const isCartPage = !!$('.js-cart-page-wrapper').length;
    const bonusProductsView = require('./bonus-products-view');
    const url = discountDataElement.data('choice-discount-url');
    const productID = discountDataElement.data('choice-selected-product').toString();
    bonusProductsView.show({
        url: url,
        giftChange: true,
        response: true,
        selectedID: productID,
        onClose: function () {
            if (isMobileWidth()) {
                $.ajax({
                    type: 'GET',
                    url: ajaxUrl(Urls.showPromotionsPopup),
                    success: function (response) {
                        if (!response) {
                            return;
                        }
                        miniCart.showMobileCrmToast(response);
                    }
                });
            } else if (!isCartPage) {
                openMinicart();
            }
        }
    });
}

const minicart = {
    isInitialized: false,
    init: function () {
        if (this.isInitialized) {
            return;
        }
        pgminicart.init(this);

        loginOverlay.init();
        const thisMinicart = this;
        this.$el = $('.js-minicart-flyout');

        const openMinicart = function () {
            const orderSummary = $('.order-confirmation-summary');

            if (orderSummary.length && isDesktopView) {
                window.location.href = Urls.cartShow;
            }

            thisMinicart.show();
            timer.clear();
            $('.js-open-minicart').addClass('js-flyout-opened');

            damHelper.updateImages($('.js-minicart-flyout'));

            if ($('.js-gwp-welcome-banner').length) {
                $('.js-gwp-welcome-banner').addClass('visible');
            }
        };

        $(document).off('click', '.js-open-minicart');
        $(document).on('click', '.js-open-minicart', function (e) {
            if (!isMobileWidth()) {
                e.preventDefault();
                openMinicart();
            }
        });

        this.isInitialized = true;

        const cartPromotionWrapper = $('.js-gwp-shoppingcart-wrapper');
        const minicartPromotionsWrapper = $('.js-gwp-minicart-wrapper');
        if (
            (!!minicartPromotionsWrapper.length && minicartPromotionsWrapper.first().hasClass('js-just-logged-in')) ||
            (!!cartPromotionWrapper.length && cartPromotionWrapper.first().hasClass('js-is-incremented'))
        ) {
            const hasPromotions = minicartPromotionsWrapper.hasClass('js-has-promotions');
            const isCartPage = !!$('.js-cart-page-wrapper').length;
            const isAccountPage = !!$('.js-go-to-overview').length;
            if ((hasPromotions && !isAccountPage) || isCartPage) {
                let discountDataElement = $('.js-incremented-product-data');
                if ($('.js-minicart-discount-data').length) {
                    discountDataElement = $('.js-minicart-discount-data').first();
                }
                if (discountDataElement.length) {
                    displayCRMChoiceModule(discountDataElement, thisMinicart, openMinicart);
                } else {
                    if (isMobileWidth()) {
                        $.ajax({
                            type: 'GET',
                            url: ajaxUrl(Urls.showPromotionsPopup),
                            success: function (response) {
                                if (!response) {
                                    return;
                                }
                                thisMinicart.showMobileCrmToast(response);
                            }
                        });
                    } else {
                        openMinicart();
                    }
                }
            }
        }

        if (!isMobileWidth()) {
            const gwpWelcomeBanner = $('.js-minicart-flyout-inner-content .js-gwp-welcome-banner');
            const shouldDisplayMinicart = gwpWelcomeBanner.length > 0 && !gwpWelcomeBanner.hasClass('hide');

            if (shouldDisplayMinicart) {
                openMinicart();
                thisMinicart.scrollToGwp();
                thisMinicart.animateGwpWelcomeMessage();
            }
        }

        // Show minicart if cart was merged.
        const $mergedAlert = $('.js-cart-merged');

        if ($mergedAlert.length > 0) {
            openMinicart();
        }
    },
    scrollToGwp: function () {
        const minicartWrapper = $('.gwp-minicart-wrapper');
        if (minicartWrapper.length === 0) {
            return;
        }

        const top = minicartWrapper.offset().top;
        $('.js-flyout-section').scrollTop(top);
    },
    animateGwpWelcomeMessage: function () {
        gwpWelcomeMessage.init({
            $parentElement: $('.js-minicart-flyout-inner-content')
        });

        gwpWelcomeMessage.animate();
    },
    updateApproachingDiscounts: function () {
        $.ajax({
            url: Urls.getApproachingDiscounts,
            type: 'GET'
        })
            .done(function (response) {
                $('.js-approaching-discount').html(response);
            })
            .fail(function () {
                window.alert(Resources.BAD_RESPONSE);
            });
    },
    updateProductsAndPrice: function (totalPrice, numberOfProducts, numberOfGifts) {
        $('.js-total-price').text(totalPrice);

        let overviewText = '';
        const $selectedProductsText = $('.js-selected-products');

        const fmtProducts =
            numberOfProducts > 1
                ? $selectedProductsText.data('text-format-multiple-products')
                : $selectedProductsText.data('text-format-one-product');
        const fmtGifts =
            numberOfGifts > 1
                ? $selectedProductsText.data('text-format-multiple-gifts')
                : $selectedProductsText.data('text-format-one-gift');
        const msgProducts = String.format(fmtProducts, numberOfProducts);
        const msgGifts = String.format(fmtGifts, numberOfGifts);

        if (numberOfGifts > 0) {
            overviewText = String.format($selectedProductsText.data('text-format-full-message'), msgProducts, msgGifts);
        } else {
            overviewText = msgProducts;
        }

        $selectedProductsText.text(overviewText);
    },
    updateSelectedGifts: function (currentPromotionId) {
        const slideDuration = 2000;
        let slideLeftDelay = 0;
        const $unselectedPromotions = $('.js-bonus-product.unselected');
        const $selectedPromotions = $('.js-bonus-product:not(.unselected)');

        $selectedPromotions.each(function () {
            const $this = $(this);
            const promotionId = $this.data('promotion-id');

            if (promotionId !== currentPromotionId) {
                slideLeftDelay = slideDuration;

                $this.animate({right: '-150%'}, slideDuration, function () {
                    $this.remove();
                });
            }
        });

        $unselectedPromotions.each(function () {
            const $this = $(this);
            const promotionId = $(this).data('promotion-id');

            if (promotionId === currentPromotionId) {
                setTimeout(function () {
                    $this.removeClass('unselected');
                    $this.css('left', '150%');

                    $this.animate({left: 0}, slideDuration);
                }, slideLeftDelay);
            }
        });
    },
    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function (html, activateTimer) {
        // show the flyout minicart
        this.$el.html(html);
        this.init();

        if (activateTimer) {
            timer.clear();
        }

        flyout.open({
            flyoutType: 'minicart'
        });

        if (activateTimer && !$('.js-gwp-open').length && !$('.checkout-flyout-inner-content').length) {
            // after a time out automatically close it
            timer.start(4000, this.close.bind(this));
        }

        const subtotalBlock = $('.js-minicart-flyout-checkout');
        $('.js-minicart-flyout-inner-content').css('padding-bottom', subtotalBlock.outerHeight());
    },
    /**
     * Updates the minicart without showing it.
     */
    update: function (html) {
        this.$el.html(html);
        this.init();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function () {
        timer.clear();

        // after a time out automatically close it
        timer.start(4000, this.close.bind(this));
        //prevent body scroll
        headerMenu.tools.preventBodyScroll(true);

        // add empty header
        $('.js-header').addClass('header--empty');
    },
    /**
     * @function
     * @description Switch to empty cart view.
     */
    switchToEmptyCart: function () {
        $('.js-minicart-empty').removeClass('hide');
        $('.js-minicart-not-empty').addClass('hide');
        $('.js-selected-products').hide();
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function () {
        if (!$('.js-gwp-open').length) {
            timer.clear();
            flyout.closeFlyouts();
        }
    },
    /**
     * @function
     * @description This triggeres the new CRM 2.0 toast for mobile
     *
     * Ticket: https://rituals.atlassian.net/browse/DL-22421
     */
    showMobileCrmToast: function (html) {
        // Remove elements we do not use
        $('.image-holder, .text-holder', html).remove();

        // Inject new HTML at end of toast el and show the toast with a delay
        // of 500ms
        timer.start(500, function () {
            //remove existing crm toast
            $('.js-mobile-crm-toast').remove();
            $('.js-cart-confirm-mobile').append(html);
            $('.js-cart-confirm-mobile').addClass('mobile-crm-toast-wrapper').addClass('open');
            damHelper.updateImages($('.js-cart-confirm-mobile'));
            $('.js-cart-confirmation-wrapper').attr('tabindex', '0');
            $('.js-modal-overlay').fadeIn();
            $('.js-minicart-flyout-spinner').find('button[type="submit"]').on('click', function(){
                $(this).addClass('hide');
                $('.js-spinner-general.spinner-custom-mobile').addClass('show');

                const spinner = $('.js-spinner-general.spinner-custom-mobile span');
                spinner.css('animation-play-state', 'paused');

                //restart animation iOS fix
                setTimeout(function() {
                    spinner.css('animation-play-state', 'running');
                }, 5);
            });
        });
    },
    /**
     * @function
     * @description To prevent the element visibilty while the page is loading we
     * initially set the opacity 0. We set it to 1 by adding this class on page
     * load.
     *
     * Ticket: https://rituals.atlassian.net/browse/DL-9378
     */
    initMobileConfirmation: function () {
        $('.js-cart-confirm-mobile').addClass('page-loaded');
    },
    /**
     * @function
     * @description When adding to cart on mobile, instead of the minicart a
     * confirmation flyout appears
     */
    mobileConfirmation: function (html) {
        this.$el.html(html);
        this.init();
        timer.start(500, function () {
            $('.js-cart-confirm-mobile').addClass('open');
            damHelper.updateImages($('.js-cart-confirm-mobile'));
            $('.js-cart-confirmation-wrapper').attr('tabindex', '0');
            $('.js-modal-overlay').fadeIn();
        });
        timer.start(4500, minicart.hideMobileConfirmation);
    },
    hideMobileConfirmation: function () {
        $('.js-cart-confirm-mobile').removeClass('open');
        $('.js-cart-confirmation-wrapper').attr('tabindex', '-1');
        $('.js-modal-overlay').fadeOut();
    },
    updateHeaderCartIcon: function (numberOfProducts) {
        // update the quantity in the cart icon circle
        if (!numberOfProducts) {
            $('.js-shopping-circle').text('');
        } else {
            $('.js-shopping-circle').text(numberOfProducts);
        }
    },
    adjustPricePadding: function () {
        $('.js-minicart-product').each(function () {
            const $this = $(this);
            const smallTitle = '.js-mini-cart-small-title';
            const $price = $this.find('.js-mini-cart-price-wrapper');

            if ($this.find(smallTitle).length) {
                const smallTitleHeight = $(smallTitle).outerHeight() + 5;

                $price.css('padding-top', smallTitleHeight);
            } else {
                $price.css('padding-top', 0);
            }
        });
    }
};

module.exports = minicart;

},{"./bonus-products-view":276,"./dam/dam-helper":419,"./flyout":425,"./gwp-welcome-message":439,"./header-menu":440,"./loginOverlay":444,"./modules/helpers/_helpers":454,"./modules/util/ajaxUrl":478,"./modules/util/isMobileWidth":499,"./pages/personalisedgifting/pgminicart":549}],447:[function(require,module,exports){
'use strict';

const getJson = require('./getJson');
const load = require('./load');
const postForm = require('./postForm');

exports.getJson = getJson;
exports.load = load;
exports.postForm = postForm;

},{"./getJson":448,"./load":450,"./postForm":451}],448:[function(require,module,exports){
'use strict';

const toAbsoluteUrl = require('../../modules/util/toAbsoluteUrl');

const currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
const getJson = (options) => {
    options.url = toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: (typeof options.async === 'undefined' || options.async === null) ? true : options.async,
        data: options.data || {}
    })
    // success
    .done((response) => {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail((xhr, textStatus) => {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(() => {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

module.exports = getJson;

},{"../../modules/util/toAbsoluteUrl":511}],449:[function(require,module,exports){
'use strict';

module.exports = require('./_ajax');

},{"./_ajax":447}],450:[function(require,module,exports){
'use strict';

const progress = require('../../progress');
const toAbsoluteUrl = require('../../modules/util/toAbsoluteUrl');
const appendParamToURL = require('../../modules/util/appendParamToURL');

const currentRequests = [];

/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 * @param {Boolean} replaceTarget If true, the target element will be completely replaced with new content
 */
const load = (options) => {
    options.url = toAbsoluteUrl(options.url);

    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        traditional: true,
        xhrFields: {
            withCredentials: true
        }
    })
    .done((response) => {
        // success
        if (options.target) {
            if (options.replaceTarget) {
                $(options.target).replaceWith(response);
            } else {
                $(options.target).empty().html(response);
            }
        }
        if (options.callback) {
            options.callback(response, options.dialogTarget);
        }
    })
    .fail((xhr, textStatus) => {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    })
    .always(() => {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

module.exports = load;

},{"../../modules/util/appendParamToURL":479,"../../modules/util/toAbsoluteUrl":511,"../../progress":584}],451:[function(require,module,exports){
'use strict';

const progress = require('../../progress');
const util = require('../util');

const currentRequests = [];

/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 * @param {Boolean} replaceTarget If true, the target element will be completely replaced with new content
 */
const postForm = (options) => {
    options.url = options.form.attr('action');
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    let data = options.form.serialize();

    if (options.triggeredAction){
        // add form action to data
        data += '&' + options.triggeredAction + '=' + options.triggeredAction;
    }

    // make sure the server knows this is an ajax request
    if (data.indexOf('ajax') === -1) {
        data += '&format=ajax';
    }

    // make the server call
    $.ajax({
        type: 'POST',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: data
    })
    .done(function (response) {
        if (typeof response === 'object'){
            if (!response.success && response.error === 'CSRF Token Mismatch'){
                //TOOD : handle CSRF Token Mismatch on ajax
                if (options.handleCsrfMismatch && $.isFunction(options.handleCsrfMismatch)){
                    options.handleCsrfMismatch();
                    return;
                }
                location.reload();
                return;
            }
            options.handleJson(response);
            return;
        }

        if (options.target) {
            if (options.replaceTarget) {
                $(options.target).replaceWith(response);
            } else {
                $(options.target).empty().html(response);
            }
        }
        if (options.callback && $.isFunction(options.callback)) {
            options.callback(response);
        }
    })
    .fail(function (xhr, textStatus) {
        if (options.handleError && $.isFunction(options.handleError)) {
            options.handleError(textStatus);
        }
    })
    .always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

module.exports = postForm;

},{"../../progress":584,"../util":496}],452:[function(require,module,exports){
'use strict';

const _each = require('lodash/each');
const _merge = require('lodash/merge');
const _flatten = require('lodash/flatten');

const isInViewport = require('../../modules/helpers/isInViewport');
const ajax = require('../../modules/ajax');
const pushDataLayerEvent = require('../../modules/helpers/analyticsHelper');
const getCookie = require('./../util/getCookie');

// global variables
const autocomplete = [];
let storeLocatorAutoComplete, storeLocatorListener;
const ritualsFormHelper = require('../../rituals-form-helper');

// Google Places API
const places = {
    initStoreList: function (countryCode, triggerStoreAddressUpdate) {
        const element = $('.js-check-store-name-textfield');
        //Remove previous autocomplete listeners
        if (storeLocatorListener) {
            google.maps.event.removeListener(storeLocatorListener);
            storeLocatorListener = null;
        }
        if (storeLocatorAutoComplete) {
            google.maps.event.clearInstanceListeners(storeLocatorAutoComplete);
            storeLocatorAutoComplete = null;
        }
        $('.pac-container').remove();

        storeLocatorAutoComplete = new google.maps.places.Autocomplete(element[0], {
            componentRestrictions: {
                country: countryCode
            }
        });

        storeLocatorListener = storeLocatorAutoComplete.addListener('place_changed', triggerStoreAddressUpdate);
    },

    initStockFlyout: function (triggerStockAddressUpdate) {
        const autoCompleteElement = $('.js-check-instore-availabilty-zipcode-textfield');
        if (autoCompleteElement.length > 0) {
            autoCompleteElement.each(function (index, element) {
                if (typeof google === 'object' && typeof google.maps === 'object') {
                    const autocompleteField = new google.maps.places.Autocomplete(
                        element, {
                        componentRestrictions: {
                            country: $('.js-country_select').val() //find country in the footer from locale selector
                        }
                    }
                    );
                    // When the user selects an address from the dropdown, populate the address
                    // fields in the form.
                    autocompleteField.addListener('place_changed', triggerStockAddressUpdate);
                }
            });

            // prevent submitting the form when we select an address with enter key
            autoCompleteElement.keydown(function (e) {
                if (e.keyCode == 13) {
                    e.preventDefault();
                }
            });
        }

    },

    init: function () {
        places.clearPacInstances();

        // Create the autocomplete object, restricting the search to geographical
        // location types.
        const autoCompleteElement = $('[id$=_addressSearch].addressSearch');
        autoCompleteElement.each(function (index, element) {
            autocomplete[index] = new google.maps.places.Autocomplete(
                element, {
                types: [
                    'address'
                ],
                componentRestrictions: {
                    country: places.findRelatedCountryList($(element).closest('fieldset').find('[id$=country]').val())
                }
            }
            );

            autocomplete[index].fieldSet = $(element).closest('fieldset');

            // When the user selects an address from the dropdown, populate the address
            // fields in the form.
            autocomplete[index].addListener('place_changed', places.fillInAddress);
        });

        // prevent submitting the form when we select an address with enter key
        autoCompleteElement.keydown(function (e) {
            if (e.keyCode == 13) {
                e.preventDefault();
            }
        });

        // position the Google Places autocomplete dropdown under the input field in ROPO
        const $instoreAddressInput = $('.js-check-instore-availabilty-zipcode-textfield');
        $instoreAddressInput.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field in Account address list
        const $accountAddressInput = $('.js-account-address-list .inputfield-text.addressSearch');
        $accountAddressInput.on('focus', places.onFocusPacElement);

        //position the Google Places autocomplete dropdown under the input field in Change billing address flyout
        const $accountAddressFormWrapper = $('.js-flyout-content .js-billing-form .inputfield-text.addressSearch');
        $accountAddressFormWrapper.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field in the flyout on step 2 of checkout
        const $shippingAddressFlyoutInput = $('.js-flyout-content .js-shipping_address_form .inputfield-text.addressSearch');
        $shippingAddressFlyoutInput.on('focus', places.onFocusPacElement);

        // position the Google Places autocomplete dropdown under the input field on step 1 of checkout
        const $shippingAddressInput = $('.js-step-1-content .js-checkout-form [id$=_addressSearch]');
        $shippingAddressInput.on('focus', places.onFocusPacElement);

        // correct Google Places autocomplete dropdown position when scrolling in flyout
        $('.stores-flyout-content').scroll(function () {
            const $autoCompleteElement = $('.js-check-instore-availabilty-zipcode-textfield');
            const $placesSuggestionsContainer = $('.pac-container');
            //Set new top to autocomplete dropdown
            const newTop = $autoCompleteElement.offset().top + $autoCompleteElement.outerHeight();
            $placesSuggestionsContainer.css('top', newTop + 'px');
        });

        if (!$('.pac-container').hasClass('places-autocomplete')) {
            autoCompleteElement.on('focus', function () {
                $('.pac-container').addClass('places-autocomplete');
            });
        }
    },

    clearPacInstances: function () {
        _each(autocomplete, function (element) {
            google.maps.event.clearInstanceListeners(element);
        });

        $('.pac-container').remove();
    },

    onFocusPacElement: function () {
        const pacContainer = $('.pac-container');
        $(this).parent().append(pacContainer);
    },

    fillInAddress: function () {
        const place = this.getPlace();
        const currentFieldsetElement = this.fieldSet;

        //DL-28059 - Reversed the order of address components because the postalCode should be filled
        //before the state(postalCode needed for state validation)
        place.address_components.reverse();
        if (place && currentFieldsetElement) {
            // Clear the address fields
            places.clearAutocompleteAddressFields(currentFieldsetElement);
            const currentCountry = currentFieldsetElement.find('[id$=country]')[0].value.toLowerCase();
            let address1 = ' ';

            // Get each component of the address from the place details
            // and fill the corresponding field on the form.
            for (let i = 0; i < place.address_components.length; i++) {
                const addressType = place.address_components[i].types[0];
                const stateSelectorforCountries = ['US', 'IE'];
                const stateAttributeName = currentCountry == 'us' ? 'stateUS' : 'state';

                switch (addressType) {
                    case 'postal_town':
                    case 'locality':
                        currentFieldsetElement.find('[id$=city]').val(place.address_components[i].long_name).valid();
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=city]').trigger('change');
                        break;

                    case 'street_number':
                        if (currentFieldsetElement.find('[id$=houseNumber]').length > 0) {
                            currentFieldsetElement.find('[id$=houseNumber]').val(place.address_components[i].long_name).valid();
                            // trigger change for floating labels
                            currentFieldsetElement.find('[id$=houseNumber]').trigger('change');
                        } else {
                            address1 = place.address_components[i].long_name + address1;
                        }
                        break;

                    case 'route':
                        if (currentFieldsetElement.find('[id$=street]').length > 0) {
                            currentFieldsetElement.find('[id$=street]').val(place.address_components[i].long_name).valid();
                            // trigger change for floating labels
                            currentFieldsetElement.find('[id$=street]').trigger('change');
                        } else {
                            address1 = address1 + place.address_components[i].long_name;
                        }
                        break;

                    case 'postal_code':
                        currentFieldsetElement.find('[id$=postal]').val(place.address_components[i].long_name).trigger('input');
                        $(document).trigger('shippingPostalCode.updated', [currentFieldsetElement.find('[id$=postal]')]);
                        break;

                    case 'administrative_area_level_1':
                        if (stateSelectorforCountries.indexOf(currentCountry.toUpperCase()) < 0) {
                            break;
                        }

                        currentFieldsetElement.find('[id$=postal]').data('state-id', place.address_components[i].short_name.toUpperCase());
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=postal]').trigger('change');

                        currentFieldsetElement.find('[id$=' + stateAttributeName + ']').val(place.address_components[i].short_name.toUpperCase()).valid();
                        // trigger change for floating labels
                        currentFieldsetElement.find('[id$=' + stateAttributeName + ']').trigger('change').selectric('refresh');

                        break;
                    default:
                        break;
                }
            }

            if (address1.length > 0) {
                if (currentFieldsetElement.find('[id$=address1]').length > 0) {
                    currentFieldsetElement.find('[id$=address1]').val(address1).valid();
                    // trigger change for floating labels
                    currentFieldsetElement.find('[id$=address1]').trigger('change');
                } else if (currentFieldsetElement.find('[id$=street]').length > 0) {
                    currentFieldsetElement.find('[id$=street]').val(currentFieldsetElement.find('[id$=street]').val() + ' ' + address1).valid();
                    // trigger change for floating labels
                    currentFieldsetElement.find('[id$=street]').trigger('change');
                }
            }

            ritualsFormHelper.init();
        }
    },

    searchPlace: function (searchQuery, triggerAddressSearched) {
        //Get location from SearchText
        const request = {
            'address': searchQuery
        };

        const service = new google.maps.Geocoder();
        service.geocode(request, triggerAddressSearched);
    },

    getCurrentLocation: function (getCurrentLocationcompletion) {
        //Get Current location
        if (navigator && navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(function (position) {
                places.getLocationFromLatLong(position.coords.latitude, position.coords.longitude, getCurrentLocationcompletion);
            }, function () {
                //Location access denied
                getCurrentLocationcompletion(null, null, null);
            });
        } else {
            //HTML5 Geolocation is not supperted
            getCurrentLocationcompletion(null, null, null);
        }
    },

    getLocationFromLatLong: function (latitude, longitude, getLocationCompletion) {
        if (latitude && longitude) {
            //Get location from Lat,Long
            if (typeof google === 'object' && typeof google.maps === 'object') {
                const geocoder = new google.maps.Geocoder();
                const geolocate = new google.maps.LatLng(latitude, longitude);
                geocoder.geocode({
                    'latLng': geolocate
                }, function (results, status) {
                    if (status == 'OK') {
                        getLocationCompletion(results, latitude, longitude);
                    } else {
                        //Something is wrong
                        getLocationCompletion(null, null, null);
                    }
                });
            }
        } else {
            //Something is wrong
            getLocationCompletion(null, null, null);
        }
    },

    getLatLongFromPostalCode: function (postalCode, country, getCoordinatesCallback) {
        if (!postalCode) {
            return;
        }
        const geocoder = new google.maps.Geocoder();

        const geocoderRequest = {
            componentRestrictions: {
                country: country.toLowerCase()
            },
            address: postalCode.replace(/ /g, '+') + ',+' + country
        };

        if (postalCode.match(/^\d+$/)) {
            geocoderRequest.componentRestrictions.postalCode = postalCode;
        }

        geocoder.geocode(geocoderRequest, function (results, status) {
            if (status === 'OK') {
                const location = results[0].geometry.location;
                getCoordinatesCallback(location.lat(), location.lng());
            } else {
                getCoordinatesCallback(null, null);
            }
        });
    },

    getStateFromPostalCode: function (postalCode, country, setStateCallback) {
        if (postalCode) {
            const geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            }, function (results, status) {
                let state = null;

                if (status === 'OK') {
                    const addressComponents = results[0]['address_components'];
                    for (let i = 0; i < addressComponents.length; i++) {
                        const addressType = addressComponents[i].types[0];

                        if (addressType === 'administrative_area_level_1') {
                            state = addressComponents[i].short_name.toUpperCase();
                        }
                    }
                }

                if (setStateCallback !== undefined && $.isFunction(setStateCallback)) {
                    setStateCallback(state);
                }
            });
        } else {
            if (setStateCallback !== undefined && $.isFunction(setStateCallback)) {
                setStateCallback(null);
            }
        }
    },

    compareStateToPostalCode: function (postalCode, country, state, setIsValidCallback) {
        if (postalCode) {
            new google.maps.Geocoder().geocode({
                componentRestrictions: {
                    postalCode: postalCode,
                    country: country
                }
            }, function (results, status) {
                let valid = false;

                if (status === 'OK') {
                    const addressComponents = results[0]['address_components'];
                    for (let i = 0; i < addressComponents.length; i++) {
                        const addressType = addressComponents[i].types[0];

                        if (addressType === 'administrative_area_level_1') {
                            if (addressComponents[i].long_name.toUpperCase() === state.toUpperCase()
                                || addressComponents[i].short_name.toUpperCase() === state.toUpperCase()) {
                                valid = true;
                            }
                        }
                    }
                }
                if (setIsValidCallback !== undefined && $.isFunction(setIsValidCallback)) {
                    setIsValidCallback(valid);
                }
            });
        } else {
            if (setIsValidCallback !== undefined && $.isFunction(setIsValidCallback)) {
                setIsValidCallback(false);
            }
        }
    },

    setStateFromPostalCode: function (e) {
        if (e.type == 'blur' || e.keyCode == 13) {
            const $postal = $(e.target);
            $postal.data('state-id', '');
            const postalCode = $postal.val();
            const country = $postal.closest('fieldset').find('[id$=_country]').val();
            const $stateUS = $postal.closest('fieldset').find('[id$=_stateUS]');

            places.getStateFromPostalCode(postalCode, country, function (state) {
                const optionIndex = $stateUS.find('option').filter(function () { return $(this).val() === state; }).index();
                $stateUS.prop('selectedIndex', optionIndex).selectric('refresh');
                $postal.data('state-id', state);
                $postal.data('changed', false);
                $stateUS.valid();
            });
        }
    },

    setStateIDDataForPostalCode: function () {
        const $postals = $('[id$=_postal]');

        $postals.each(function () {
            const $postal = $(this);
            $postal.data('state-id', '');

            const postalCode = $postal.val();
            const country = $postal.closest('fieldset').find('[id$=_country]').val();

            places.getStateFromPostalCode(postalCode, country, function (state) {
                $postal.data('state-id', state);
            });
        });
    },

    getReadableAddress: function (results) {
        let fallBackAddress = '';
        for (let indexResult = 0; indexResult < results.length; indexResult++) {
            const result = results[indexResult];
            for (let indexAddressComponent = 0; indexAddressComponent < result.address_components.length; indexAddressComponent++) {
                const addressComponent = result.address_components[indexAddressComponent];
                if (addressComponent.types.indexOf('administrative_area_level_2') != -1) {
                    return result.formatted_address;
                } else if (addressComponent.types.indexOf('administrative_area_level_1') != -1) {
                    fallBackAddress = result.formatted_address;
                }
            }
        }
        return fallBackAddress;
    },

    clearAutocompleteAddressFields: function (currentFieldsetElement) {
        if (currentFieldsetElement) {
            // Clear the address fields
            currentFieldsetElement.find('[id$=city]').val('');
            currentFieldsetElement.find('[id$=houseNumber]').val('');
            currentFieldsetElement.find('[id$=street]').val('');
            currentFieldsetElement.find('[id$=postal]').val('');
            currentFieldsetElement.find('[id$=state]').val('');
        }
    },

    findRelatedCountryList: function (countryCode) {
        switch (countryCode.toUpperCase()) {
            case 'FR':
                return ['FR', 'MC'];
            default:
                return countryCode;
        }
    },
};

// Google Maps API
const maps = {
    config: {},

    init: function (el, icon, config) {
        console.log('[google maps] initialized..');

        if (el) {
            const longitude = parseFloat(el.data('lng')) || -1;
            const latitude = parseFloat(el.data('lat')) || -1;
            const latLng = new google.maps.LatLng(latitude, longitude);
            const svgIcon = [
                '<?xml version="1.0" encoding="UTF-8"?>',
                '<svg width="30px" height="44px" viewBox="0 0 30 44" version="1.1" xmlns="http://www.w3.org/2000/svg">',
                '<path d="M15,44 C15,44 0,23.4783068 0,15.125 C0,6.77169316 6.71572875,0 15,0 C23.2842712,0 30,6.77169316 30,15.125 C30,23.4783068 15,44 15,44 Z M15,20 C17.7614237,20 20,17.7614237 20,15 C20,12.2385763 17.7614237,10 15,10 C12.2385763,10 10,12.2385763 10,15 C10,17.7614237 12.2385763,20 15,20 Z" id="Combined-Shape"></path>',
                '</svg>'
            ].join('\n');

            this.setConfig(config || {
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                center: latLng,
                zoom: 17
            });

            const map = new google.maps.Map(el[0], maps.config);

            const marker = new google.maps.Marker({ /* eslint-disable-line */
                position: latLng,
                map: map,
                title: el.parent().parent().parent().parent().find('h1.title').html(),
                icon: icon || {
                    url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgIcon),
                    scaledSize: new google.maps.Size(30, 44)
                },
                optimized: false
            });
        }
    },

    setConfig: function (cnf) {
        _merge(this.config, cnf);
    }
};

/**
 * Return an array of previously populated objects by key from the datalayer
 * @param  {Array} dataLayer
 * @param  {String} key Data layer keys like products|cart etc.
 * @return {Array}
 */
function getObject(dataLayer, key) {
    if (!dataLayer) {
        return null;
    }

    const dataLayerArr = dataLayer.filter(function (layer) {
        return !(typeof layer['' + key] === 'undefined' || layer['' + key] === null);
    });

    if (!dataLayerArr) {
        return null;
    }

    const dataLayerObj = dataLayerArr.map(function (element) {
        return element['' + key];
    });

    return _flatten(dataLayerObj);
}

/**
 * Bind banner impressions to the trackable banners and push the ones in view
 */
function bindBannerImpressions() {
    const philosophyBanners = $('.philosophy-slot-holder > .search-grid-asset');
    const visibleBanners = [];
    philosophyBanners.each(function (index, element) {
        const internalPromotionElement = $(element).find('[data-internal-promotion]:not([data-is-pushed])');
        const isBannerVisible = isInViewport(element);
        if (isBannerVisible && internalPromotionElement.length > 0) {
            visibleBanners.push(internalPromotionElement);
        }
    });
    const bannersToTrack = $('[data-internal-promotion]:not([data-is-pushed])');
    bannersToTrack.each(function (index, element) {
        const isBannerVisible = isInViewport(element);
        const isPhilosophyBanner = $(element).parents('.philosophy-slot-holder').length != 0;
        if (isBannerVisible && !isPhilosophyBanner) {
            visibleBanners.push(element);
        }
    });
}

/**
 * If there are trackable banners, track them on scroll
 */
function initBannerTrackingEvents() {
    // init banner tracking only if there are banenrs to track
    if ($('[data-internal-promotion]:not([data-is-pushed])').length > 0) {
        $(document).scroll(function () {
            bindBannerImpressions();
        });
    }
}

/**
 * Event to handle impression clicks
 */
function bindInternalPromotionClicks() {
    const title = $('.heading-h1');
    // handle clicks
    $('[data-internal-promotion]').on('click', function (e) {
        e.preventDefault();
        const that = this;
        const internalPromotion = $(that).data('internal-promotion').toLowerCase();

        pushDataLayerEvent({
            'event': 'faq_interaction',
            'interaction_type': 'click',
            'click_target': internalPromotion,
            'faq_category': title && title[0] ? title[0].innerText.toLowerCase() : ''
        });

        if (!that.href) {
            return;
        }
        if (that.target == '_blank') {
            window.open(that.href);
            return;
        }
        window.location = that.href;
    });
}

function bindProductSliderCtaClick() {
    $('[data-product-slider-cta]').on('click', function (e) {
        e.preventDefault();
        const that = this;
        const data = $(that).data('product-slider-cta');
        data.eventTimeout = 2000;
        data.eventCallback = function () {
            if (!that.href) {
                return;
            }
            if (that.target == '_blank') {
                window.open(that.href);
                return;
            }
            window.location = that.href;
        };
        pushDataLayerEvent(data);
    });
}

function bindNewsletterSubscribe() {
    const hideNewsletterCookie = getCookie('_hideNewsletterBlock');
    if ($('.newsletter-subscription-confirmation').length > 0 && hideNewsletterCookie) {
        pushDataLayerEvent({
            event: 'newsletter_subscription',
            click_target: 'subscribe'
        });
    }
}

/**
 * Event to handle checkout forms clicks
 */
function pushCheckoutImpressions() {
    const shippingForm = $('form[id$="_singleshipping_shippingAddress"]');
    shippingForm.on('focusout', 'input,select', function (e) {
        if (!e.originalEvent) {
            return;
        }

        const numberOfFormField = shippingForm.find(':input').index($(this)) + 1; // starts from zero
        let nameOfFormField = '';

        const $inputEl = $(this).hasClass('selectric-input') ? $(this).closest('.selectric-wrapper').find('select') : $(this);

        if ($inputEl.attr('name')) {
            const fieldName = $inputEl.attr('name').split('_');
            if (fieldName.length > 0) {
                nameOfFormField = fieldName[1] + ' ' + fieldName.pop();
            }
        }
        sendCheckoutImp(numberOfFormField, nameOfFormField);
    });

    const $purchaseDataElement = $('#purchase-gtm-data');
    if ($purchaseDataElement.length > 0 && $($purchaseDataElement).val()) {
        pushDataLayerEvent(JSON.parse($($purchaseDataElement).val()));
    }
}


function sendCheckoutImp(numberOfFormField, nameOfFormField) {
    const eventLabel = numberOfFormField + ':' + nameOfFormField;
    pushDataLayerEvent({
        'event': 'checkoutFormAnalysis',
        'eventCategory': 'form analysis',
        'eventAction': 'checkout details',
        'eventLabel': eventLabel
    });
}


function bindMenuItemClick() {
    $('.js-nav-desktop-main-list').on('click', handleMenuItemClick);
    $('.js-nav-mobile-main-list').on('click', handleMenuItemClick);
    $('.js-nav-mobile-main-list').on('touchend', handleMenuItemClick);

    function handleMenuItemClick(e) {
        const target = $(e.target);

        if (!isMenuItem(target)) {
            return '';
        }

        const categoryData = getCategoryData(target);
        if (!categoryData) {
            return;
        }

        const menuCta = getMenuCta(target);

        const isImage = target.attr('data-src');


        pushMenuItemClick(categoryData, menuCta, isImage);
    }

    function isMenuItem(target) {
        const menuCtaSelectors = '[data-menu-cta], [data-menu-cta] *';
        const categoryPathSelectors = '.js-gtm-menu-item, .js-gtm-menu-item *';

        return target.is(categoryPathSelectors) || target.is(menuCtaSelectors);
    }

    function getCategoryData(target) {
        const categoryData = target.closest('[data-analytics]');
        if (!categoryData) {
            return '';
        }

        return categoryData.data('analytics');
    }

    function getMenuCta(target) {
        const menuCtaSelectors = '[data-menu-cta], [data-menu-cta] *';
        if (target.is(menuCtaSelectors)) {
            return target.closest('[data-menu-cta]').data('menuCta');
        }

        return '';
    }

    function pushMenuItemClick(categoryData, menuCta, isImage) {
        const event = {
            event: 'menu_navigation',
            menu: 'header',
            menu_path: categoryData.categoryPath ? categoryData.categoryPath.toLowerCase().replace(/\//g, ',') : 'null',
            menu_text: categoryData.displayNameEn ? categoryData.displayNameEn.toLowerCase() : 'null',
            menu_click: isImage ? 'picture' : 'text'
        };
        if (menuCta) {
            event.cta = menuCta;
        }

        pushDataLayerEvent(event);
    }

    $('.js-nav-toggle .icon-close').on('touchend', function () {
        if (isAnalyticsDisabled()) {
            return;
        }

        const selectedCategory = $('.js-nav-mobile-main-list').find('.js-selected-category');
        if (!selectedCategory || !selectedCategory.length) {
            return;
        }

        selectedCategory.removeClass('js-selected-category');

        const categoryData = getCategoryData(selectedCategory.last());
        if (!categoryData) {
            return;
        }

        const menuCta = $(this).data('menuCta');

        pushMenuItemClick(categoryData, menuCta);
    });
}

function bindGreenFridayClick() {
    $('.js-desktop-shop-the-boxes').on('click', handleGreenFridayClick);
    $('.js-mobile-shop-the-boxes').on('touchend', handleGreenFridayClick);
    $('.js-desktop-shop-this-box').on('click', handleGreenFridayClick);
    $('.js-mobile-shop-this-box').on('touchend', handleGreenFridayClick);

    function handleGreenFridayClick(e) {
        if (isAnalyticsDisabled()) {
            return;
        }

        let action;
        let productName;

        if ($(e.target).hasClass('js-desktop-shop-the-boxes') || $(e.target).hasClass('.js-mobile-shop-the-boxes')) {
            action = 'shop the boxes';
            productName = '';
        } else {
            action = 'shop this box';
            productName = $(e.target).closest('div').children('h2').text();
        }

        const event = {
            event: 'green_friday',
            event_category: 'homepage', /* eslint-disable-line camelcase */
            event_action: action, /* eslint-disable-line camelcase */
            event_label: productName /* eslint-disable-line camelcase */
        };

        pushDataLayerEvent(event);
    }
}

function isAnalyticsDisabled() {
    return typeof (ga) === 'undefined' || !window.ga || !ga.create; /* eslint-disable-line */ //If analytics have been disabled, let the normal click handler take over
}

function pushInStoreAvailability() {
    // handle clicks
    $(document).on('click', '.js-check-instore-availabilty', function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'click',
            'content_name': 'ropo',
            'click_target': 'check instore availability'
        });
    });
}

function pushInStoreAvailabilityCurrentLocation() {
    // handle clicks
    $('.js-check-instore-availabilty-current-location').on('click', function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'input',
            'content_name': 'ropo',
            'click_target': 'use current location',
        });
    });
}

$('#btn-login').on('click', function () {
    setTimeout(function () {
        const existErrorForm = $('.error-text').length;
        if (existErrorForm > 0) {
            pushDataLayerEvent({
                'event': 'form_field_error',
                'error_type': 'server_error',
                'error_message': 'page_not_found',
                'error_code': '404',
                'content_name': 'login'
            });
        }
    }, 2000);
});

function bindLoginFormForgotPassword() {
    $('.js-password-reset-dialog').on('click', function () {
        pushDataLayerEvent({
            'event': 'forgotPassword',
            'eventCategory': 'login',
            'eventAction': 'password forgotten',
            'eventLabel': 'used'
        });
    });
}

function bindLearnMoreClick() {
    $('body').on('click', '.js-go-to-description', function () {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'click on discover more',
            'eventLabel': $('.product-name').length > 0 ? $('.product-name')[0].innerHTML : ''
        });
    });
}

function bindProductDescriptionClick() {
    $('body').on('click', '.js-product-description-section', function () {
        const isSectionOpen = !($(this).attr('aria-selected') == 'true');
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': isSectionOpen ? 'hide product information' : 'show product information',
            'eventLabel': $('.product-name').length > 0 ? $('.product-name')[0].innerHTML : ''
        });
    });
}

function bindCOPFilterEvents() {
    const GA4_FILTER_TYPES = [
        { id: 'ritual', name: 'collection' },
        { id: 'productType', name: 'product' },
        { id: 'range', name: 'range' },
        { id: 'colorGroupHoR', name: 'colour' },
        { id: 'duration', name: 'duration' }
    ];
    let timer;
    let filterSelection = [];

    $(document).on('filterChange', function (e, lastSelectedFilter) {
        if (timer) {
            window.clearTimeout(timer);
        }

        const filterAction = lastSelectedFilter.is(':checked') ? 'added' : 'remove';

        timer = window.setTimeout(function () {
            const attributeId = lastSelectedFilter.data('attribute-id') || lastSelectedFilter.data('refinement-attribute');
            const isNewGTMFilterType = GA4_FILTER_TYPES.some(({ id }) => id === attributeId);

            if (isNewGTMFilterType) {
                const selectedFilter = lastSelectedFilter.data('filter-name') || lastSelectedFilter.data('refinement-value');

                const countElement = $('.js-search-result-count');
                const filterResults = countElement.data('count');
                countElement.remove();

                filterSelection = findActiveFilters();
                const formatedActiveFilter = formatGtmValue(selectedFilter);

                pushFilterData(formatedActiveFilter, filterAction, filterResults);
            }
        }, 400);
    });

    $('body').on('click', '.js-filter-by-container .js-clear-all-btn', function () {
        if (timer) {
            window.clearTimeout(timer);
        }
        if (filterSelection && filterSelection.length > 0) {
            timer = window.setTimeout(function () {
                pushFilterData(null, 'clear', null);
                filterSelection = [];
            }, 400);
        }
    });

    function findActiveFilters() {
        const filterCollection = [];

        GA4_FILTER_TYPES.map(({ id, name }) => {
            const selectedFiltersByType = $('.js-filter-options-container[data-filter-type="' + id + '"] input[type="checkbox"]:checked');
            const filtersByType = selectedFiltersByType.get().map((filter) =>
                formatGtmValue(filter.getAttribute('data-filter-name'))
            );

            if (filtersByType.length) {
                filterCollection.push({ [name]: filtersByType });
            }
        });

        return filterCollection;
    }

    function pushFilterData(filterActionValue, filterAction, filterResults) {
        pushDataLayerEvent({
            'event': 'filter',
            'filter_selection': filterSelection,
            'filter_action': filterAction,
            'filter_action_value': filterActionValue,
            'filter_results': filterResults,
            'filter_type': 'product_list'
        });
    }
}

function formatGtmValue(value) {
    return value.toLowerCase().replace(/\s+/g, '_');
}

function bindPackshotProductEvents() {
    $('body').on('click', '.js-packshot-products svg g[id*="product-id"]', function () {
        const productId = $(this).attr('id').split('-')[2];
        const productCollectionName = $('#productCollectionName').val();

        ajax.load({
            type: 'GET',
            url: Urls.getProductData,
            data: { productId: productId },
            callback: function (productData) {
                const product = JSON.parse(productData);

                if (product) {
                    pushDataLayerEvent({
                        'event': 'collectionProductInfo',
                        'eventCategory': 'collection product info',
                        'eventAction': productCollectionName,
                        'eventLabel': product.name
                    });
                }
            }
        });
    });
}

/**
 * Pushes a "view_search_results" event to the GTM data layer, when the user ends on search page.
 * Information is sent depended on the search phrase or suggestion click was applayed for search.
**/

function pushViewSearchResult() {
    $(document).ready(function () {
        const searchPhrase = $('#pageSearchPhrase');
        const category = $('#pageCategory');

        if (searchPhrase.length || category.length) {
            const searchTerm = searchPhrase.val() || category.data('category-name');
            const searchType = searchPhrase.val() ? 'input' : 'suggestion';
            const amountOfSearchResult = searchPhrase.data('products-count') || category.data('products-count');

            pushDataLayerEvent({
                'event': 'view_search_results',
                'search_term': formatGtmValue(searchTerm),
                'search_type': searchType,
                'amount_of_search_result': amountOfSearchResult
            });
        }
    });
}

/**
 * Pushes a "gwp_signup_click" event to the GTM data layer,
 * when user clicks GWP login button on cart page.
**/

function pushGwpSignupClick() {
    $('.js-gwp-login').on('click', function () {
        pushDataLayerEvent({
            'event': 'gwp_signup_click',
            'click_target': 'login'
        });
    });
}

const tagManager = {
    /**
     * Push adding and removing of products to the datalayer
     *
     * @param {String} key products|cart|search etc
     * @param {String} productId the product id
     * @param {Number} qty the quantity of how many products are effected
     * @param {String} eventName addToCartFromProduct|addToCartFromCategory|addToCartFromProductPackshot
     */
    updateQuantity: function (eventName, dataLayerProduct, qty, productPosition) {
        if (!dataLayerProduct || !eventName) {
            return false;
        }
        if (productPosition && productPosition > 1 && dataLayerProduct.items) {
            dataLayerProduct.items.forEach((item) => {
                item.position = productPosition;
            });
        }
        dataLayerProduct.event = eventName;
        pushDataLayerEvent(dataLayerProduct);
        return true;
    },

    selectVariant: function (key, masterId, variantId, availability) {
        const clone = function clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        };

        const products = getObject(dataLayer, key);

        if (!products) {
            return false;
        }

        // get previously populated objects from the layer
        const selectedProducts = products.filter(function (product) {
            return ((product.sku === masterId) || (product.selectedVariant && product.selectedVariant[0].sku === variantId));
        });

        if (!selectedProducts || selectedProducts.length === 0) {
            return false;
        }

        const product = clone(selectedProducts[0]);
        product.selectedVariant = [{
            'sku': variantId,
            'name': product.name,
            'price': product.price,
            'discount': product.discount,
            'availability': availability
        }];

        pushDataLayerEvent({
            'event': 'selectedVariant',
            'products': [product]
        });

        return true;
    },

    pushVirtualPage: function (url, title, pageCategory) {
        pushDataLayerEvent({
            'event': 'VirtualPageview',
            'virtualPageURL': url,
            'virtualPageTitle': title,
            'page.category': pageCategory
        });
    },

    pushInStoreAvailabilityAddressFill: function () {
        pushDataLayerEvent({
            'event': 'interaction',
            'interaction_type': 'input',
            'content_name': 'ropo',
            'click_target': 'address input'
        });
    },

    bindFormFieldErrorEvents: function () {
        $('form input[type=text], form input[type=email], form input[type=password]').blur(function () {

            if ($(this).data('prevent-automatic-validation')) {
                return;
            }

            if ($(this).valid() == false) {
                pushDataLayerEvent({
                    'event': 'form_field_error',
                    'error_type': 'form_field_error',
                    'error_message': `wrong ${getFormFieldName(this.id)}, please enter a valid value`,
                    'error_code': null,
                    'content_name': $(this).closest('.js-create-account-left-content') && 'register page'
                });
            }
        });
    },

    pushCheckoutEditOrderSummaryEvent: function () {
        pushDataLayerEvent({
            'event': 'editOrderSummary',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'edit order summary'
        });
    },

    pushCheckoutDeliveryAddressChangeEvent: function () {
        pushDataLayerEvent({
            'event': 'deliveryAddressChange',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'change delivery address'
        });
    },

    pushCheckoutAddressDetailsChangeEvent: function () {
        pushDataLayerEvent({
            'event': 'addressDetailsChange',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'change address details'
        });
    },

    pushCheckoutBackToDetailsEvent: function () {
        pushDataLayerEvent({
            'event': 'backToDetails',
            'eventCategory': 'checkout',
            'eventAction': 'event',
            'eventLabel': 'clicked back to details'
        });
    },

    pushCheckoutPaymentMethodEvent: function (paymentMethod, bank) {
        pushDataLayerEvent({
            'event': 'paymentMethod',
            'eventCategory': 'payment method',
            'eventAction': paymentMethod,
            'eventLabel': bank
        });
    },

    pushAddCouponValid: function (couponCode) {
        pushDataLayerEvent({
            'event': 'couponCodeAdded',
            'eventCategory': 'coupon',
            'eventAction': 'used',
            'eventLabel': couponCode
        });
    },

    pushQuantityChange: function (isAdded, productID) {
        pushDataLayerEvent({
            'event': 'cartItemChanged',
            'eventCategory': 'changed cart item amount',
            'eventAction': (isAdded ? 'PLUS' : 'MINUS'),
            'eventLabel': productID
        });
    },

    pushGiftWrap: function (isTogether, isWithMessage) {
        pushDataLayerEvent({
            'event': 'giftWrap',
            'eventCategory': 'personal message gift wrap',
            'eventAction': isTogether ? 'products together' : 'products individually',
            'eventLabel': isWithMessage ? 'with message' : 'without message'
        });
    },

    pushLocalePopupChosen: function (chosenLocale) {
        const localeCurrent = $('#js-locale-in-URL').val();
        const localeSuggested = $('#js-locale-in-Cookie').val();
        pushDataLayerEvent({
            'event': 'localePopUpChoice',
            'localeChoice': chosenLocale,
            'currentLocale': localeCurrent,
            'suggestedLocale': localeSuggested
        });
    },

    pushSortingOnCategoryPage: function (sortingType) {
        const formatedSortingType = sortingType.replace(/[^-\w]+/g, '_').toLowerCase();

        pushDataLayerEvent({
            'event': 'sorting',
            'sorting_action': formatedSortingType,
        });
    },

    pushSortingOnSearchPage: function (sortingType, searchTerm) {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'use sorting \'' + sortingType + '\' on search results page',
            'eventLabel': searchTerm
        });
    },

    pushNavigationMenuChanges: function (category) {
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'select product category',
            'eventLabel': category
        });
    },

    pushViewCartIconClick: function () {
        const cartQuantity = $('.js-shopping-circle')[0].innerText;
        const isEmpty = (!cartQuantity || cartQuantity === '0');
        pushDataLayerEvent({
            'event': 'croAnalysis',
            'eventCategory': 'checkout CRO',
            'eventAction': 'click on cart icon',
            'eventLabel': isEmpty ? 'no items in cart' : 'with items in cart'
        });
    },

    pushDeliveryMethod: function (deliveryMethod) {
        pushDataLayerEvent({
            'event': 'deliveryMethod',
            'eventCategory': 'delivery method',
            'eventAction': deliveryMethod,
            'eventLabel': 'chosen'
        });
    },

    pushCookiesAccepted: function () {
        dataLayer.push({
            'event': 'cookiesAccepted'
        });
    },

    pushCookiesDeclined: function () {
        dataLayer.push({
            'event': 'cookiesDeclined'
        });
    },

    pushProducts: function (products) {
        if (!('products' in products) && !('ecommerce' in products)) { //In case it's just a list of products, wrap it in an object
            products = {
                products: products
            };
        }

        products.event = 'trackProductImpressions'; //Ensure the event is always there

        dataLayer.push(products);
    },

    pushProductTileView: function (product) {
        product.event = 'view_item_list';
        dataLayer.push(product);
    },

    pushProductTileClick: function (product) {
        product.event = 'select_item';
        dataLayer.push(product);
    },

    pushProductTileClickNewTab: function (product) {
        dataLayer.push({
            event: 'productListClickNewTab',
            clickedProducts: [product]
        });
    },

    pushPDPTabsEvent: function (target, cssClass) {
        if (!target || !target.length) {
            return;
        }
        const analyticsData = target.closest(cssClass).data('analytics');
        if (!analyticsData) {
            return;
        }
        const analytics = JSON.parse(JSON.stringify(analyticsData));

        if (analytics.event == 'green_friday') {
            analytics.event_label = target[0].innerText.toLowerCase(); /* eslint-disable-line camelcase */
        } else if (analytics.event == 'easter') {
            analytics.event_action = target.data('tab-label'); /* eslint-disable-line camelcase */
            analytics.event_label = $('.js-the-ritual-of-title').first().text().trim(); /* eslint-disable-line camelcase */
        } else {
            analytics.content_name = decodeURI(analytics.content_name); /* eslint-disable-line camelcase */
            analytics.click_target = target[0].innerText.toLowerCase(); /* eslint-disable-line camelcase */
        }

        pushDataLayerEvent(analytics);
    },
    pushProductClickEvent: function (clickedItem, product, eventName, page) {
        pushDataLayerEvent({
            event: eventName,
            interaction: 'product click',
            click_target: clickedItem, /* eslint-disable-line camelcase */
            ecommerce: {
                click: {
                    actionField: {
                        list: page
                    },
                    products: [{
                        name: product.name,
                        id: product.id,
                        price: product.price
                    }]
                }
            }
        });
    },

    pushGwpEvent: function (action, giftType) {
        pushDataLayerEvent({
            event: 'gwp',
            gwp_action: action,
            gift_type: giftType ? giftType.toLowerCase() : null
        });
    },

    pushDataLayerEvent: pushDataLayerEvent,

    init: function () {
        bindInternalPromotionClicks();
        pushCheckoutImpressions();
        pushInStoreAvailability();
        pushInStoreAvailabilityCurrentLocation();
        bindLoginFormForgotPassword();
        bindLearnMoreClick();
        bindProductDescriptionClick();
        bindBannerImpressions();
        initBannerTrackingEvents();
        bindCOPFilterEvents();
        bindPackshotProductEvents();
        bindMenuItemClick();
        bindGreenFridayClick();
        bindNewsletterSubscribe();
        bindProductSliderCtaClick();
        if (window.location.href.includes('search')) {
            pushViewSearchResult();
        }
        pushGwpSignupClick();
    }
};

const bannerImpressions = {
    init: function () {
        bindBannerImpressions();
        initBannerTrackingEvents();
    }
};

function getFormFieldName(fieldId) {
    const checkParticleRegex = /username|password/;
    const fieldNamePosition = checkParticleRegex.test(fieldId) ? 2 : 1;

    const splits = fieldId.split('_');

    return splits[splits.length - fieldNamePosition];
}

function getFormName(fieldId) {
    const splits = fieldId.split('_');
    return splits[1];
}
// exports
exports.places = places;
exports.maps = maps;
exports.tagManager = tagManager;
exports.bannerImpressions = bannerImpressions;
exports.pushDataLayerEvent = pushDataLayerEvent;

},{"../../modules/ajax":449,"../../modules/helpers/analyticsHelper":455,"../../modules/helpers/isInViewport":464,"../../rituals-form-helper":590,"./../util/getCookie":487,"lodash/each":189,"lodash/flatten":191,"lodash/merge":209}],453:[function(require,module,exports){
'use strict';

module.exports = require('./_google');

},{"./_google":452}],454:[function(require,module,exports){
'use strict';

const helpers = {
    isMobileDevice : require('./isMobileDevice'),
    isTabletDevice : require('./isTabletDevice'),
    isTouchDevice : require('./isTouchDevice'),
    isSmallView : require('./isSmallView'),
    isTabletView : require('./isTabletView'),
    isTabletPortraitView : require('./isTabletPortraitView'),
    isDesktopView : require('./isDesktopView'),
    isDesktopOrTabletLandscapeView : require('./isDesktopOrTabletLandscapeView'),
    isBot : require('./isBot'),
    disableScroll: require('./scroll').disableScroll,
    enableScroll : require('./scroll').enableScroll,
    disableScrollEventsOnEl: require('./scroll').disableScrollEventsOnEl,
    enableScrollEventsOnEl: require('./scroll').enableScrollEventsOnEl,
    cookiesAccepted : require('./cookiesAccepted'),
    setViewportHeight : require('./setViewportHeight'),
    isInViewport: require('./isInViewport'),
    isAboveViewport: require('./isAboveViewport'),
    scrollSmooth : require('./scroll').smoothScroll,
    createSocialShareLink : require('./createSocialShareLink'),
    equalHeight : require('./equalHeight'),
    isKeyCodeNumber: require('./isKeyCodeNumber'),
    isRetina: require('./isRetina'),
    prepareDeferedImages: require('./prepareDeferedImages'),
    debounce: require('./debounce')
};

module.exports = helpers;

},{"./cookiesAccepted":456,"./createSocialShareLink":457,"./debounce":458,"./equalHeight":459,"./isAboveViewport":460,"./isBot":461,"./isDesktopOrTabletLandscapeView":462,"./isDesktopView":463,"./isInViewport":464,"./isKeyCodeNumber":465,"./isMobileDevice":466,"./isRetina":467,"./isSmallView":469,"./isTabletDevice":470,"./isTabletPortraitView":471,"./isTabletView":472,"./isTouchDevice":473,"./prepareDeferedImages":474,"./scroll":475,"./setViewportHeight":476}],455:[function(require,module,exports){
'use strict';

// get the global data layer object
const dataLayer = window.dataLayer || [];

const pushDataLayerEvent = (eventObject) => {
    if (!eventObject) {
        return;
    }

    const executeCallback = function () {
        if (eventObject.eventCallback === undefined || !$.isFunction(eventObject.eventCallback)) {
            return;
        }
        eventObject.eventCallback();
    };

    if (typeof ga === 'undefined' || !window.ga || !ga.create) {
        /* eslint-disable-line */ //If analytics have been disabled, just execute the callback
        executeCallback();
    }

    try {
        dataLayer.push(eventObject);
    } catch (error) {
        console.log('GTM event push failed');
        executeCallback();
    }
};

module.exports = pushDataLayerEvent;

},{}],456:[function(require,module,exports){
'use strict';

const cookieName = 'OptanonAlertBoxClosed';

/**
 * Grabs cookie val and returns it
 * @returns {Boolean} Value in cookie
 */
const getAcceptedCookieVal = () => {
    const cookieVal = document.cookie.match('(^|;) ?' + cookieName + '=([^;]*)(;|$)');
    return !!cookieVal;
};

/**
 * Checks if cookies are accepted and returns a boolean.
 * A cookie val of 1 means the user accepted, a val of 2 means the user did not.
 * @returns {Boolean} accepted or not
 */
const cookiesAccepted = () => {
    return getAcceptedCookieVal();
};

module.exports = cookiesAccepted;

},{}],457:[function(require,module,exports){
'use strict';

const createSocialShareLink = (location, thisEle, data) => {
    const winWidth = 520;
    const winHeight = 350;
    const winTop = (screen.height / 2) - (winHeight / 2);
    const winLeft = (screen.width / 2) - (winWidth / 2);

    const locationUrl = location;
    const locationTitle = document.title;
    const socialNetwork = thisEle.firstChild.className.split('--')[1];

    let baseUrlHref, baseUrlText, baseUrlDisplay, baseUrlMedia, shareUrl, shareWindow;

    switch (socialNetwork){
        case 'facebook':
            baseUrlHref = 'u=' + encodeURIComponent(locationUrl);
            baseUrlDisplay = 'display=popup';
            shareUrl = 'https://www.facebook.com/sharer.php?' + baseUrlHref + '&' + baseUrlDisplay;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'twitter':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            baseUrlText = 'text=' + encodeURIComponent(locationTitle);
            shareUrl = 'https://twitter.com/intent/tweet?' + baseUrlText + '&' + baseUrlHref;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'pinterest':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            baseUrlText = 'description=' + encodeURIComponent(locationTitle);
            baseUrlMedia = data ? 'media=' + data.pdpImg : '';
            shareUrl = 'https://pinterest.com/pin/create/link?' + baseUrlHref + '&' + baseUrlText + '&' + baseUrlMedia;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'google':
            baseUrlHref = 'url=' + encodeURIComponent(locationUrl);
            shareUrl = 'https://plus.google.com/share?' + baseUrlHref;

            shareWindow = window.open(shareUrl, 'sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            shareWindow.opener = null;

            break;

        case 'instagram':
            shareUrl = data ? data.url : '';
            location.replace(shareUrl);

            break;
        default:
            break;
    }
};

module.exports = createSocialShareLink;

},{}],458:[function(require,module,exports){
'use strict';

const debounce = (func, wait, immediate) => {
    let timeout;

    return function() {
        const context = this;
        const args = arguments;
        const later = function() {
            timeout = null;

            if (!immediate) {
                func.apply(context, args);
            }
        };

        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);

        if (callNow) {
            func.apply(context, args);
        }
    };
};

module.exports = debounce;

},{}],459:[function(require,module,exports){
'use strict';

const equalHeight = (arrayItems, count) => {
    if (arrayItems === undefined || arrayItems.length <= 0) {
        return;
    }

    arrayItems.height('');

    let maxH = 0;

    if (!count) {
        arrayItems.each(function () {
            const currentH2 = $(this).outerHeight(true);
            if (currentH2 > maxH) {
                maxH = currentH2;
            }
        });

        arrayItems.css('min-height', maxH);
        return;
    }

    const arrays = [];
    while (arrayItems.length > 0) {
        arrays.push(arrayItems.splice(0, count));
    }

    for (let i = 0; i < arrays.length; i += 1) {
        const data = arrays[i];
        maxH = 0;
        for (let j = 0; j < data.length; j += 1) {
            const currentH = $(data[j]).outerHeight(true);
            if (currentH > maxH) {
                maxH = currentH;
            }
        }

        for (let k = 0; k < data.length; k += 1) {
            $(data[k]).css('min-height', maxH);
        }
    }
};

module.exports = equalHeight;

},{}],460:[function(require,module,exports){
'use strict';

const isAboveViewport = (element) => {
    const pageTop = $(window).scrollTop();
    const elementTop = $(element).offset().top;
    const elementBottom = elementTop + $(element).height();
    return pageTop >= elementBottom;
};

module.exports = isAboveViewport;

},{}],461:[function(require,module,exports){
'use strict';

const isBot = () => {
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera);
    const regexAgent = new RegExp(CustomPreferences.BOT_USER_AGENT_REGEX, 'i');
    return regexAgent.test(userAgent);
};

module.exports = isBot;

},{}],462:[function(require,module,exports){
'use strict';

const isDesktopOrTabletLandscapeView = () => {
    const deviceMinWidth = 1024;
    const vpWidth = $(window).width();

    return vpWidth >= deviceMinWidth;
};

module.exports = isDesktopOrTabletLandscapeView;

},{}],463:[function(require,module,exports){
'use strict';

const isDesktopView = () => {
    const desktopMinWidth = 1025;
    const vpWidth = $(window).width();

    return vpWidth >= desktopMinWidth;
};

module.exports = isDesktopView;

},{}],464:[function(require,module,exports){
'use strict';

const isInViewport = (element, fullyInView) => {
    if (!element) {
        return false;
    }
    const pageTop = $(window).scrollTop();
    const pageBottom = pageTop + $(window).height();
    const elementTop = $(element).offset().top;
    const elementBottom = elementTop + $(element).height();
    const pageLeft = $(window).scrollLeft();
    const pageRight = pageLeft + $(window).width();
    const elementLeft = $(element).offset().left;
    const elementRight = elementLeft + $(element).width();

    if (fullyInView === true) {
        return ((pageTop < elementTop) && (pageBottom > elementBottom) && (pageLeft < elementLeft) && (pageRight > elementRight));
    } else {
        return ((elementTop <= pageBottom) && (elementBottom >= pageTop) && (elementLeft <= pageRight) && (elementRight >= pageLeft));
    }
};

module.exports = isInViewport;

},{}],465:[function(require,module,exports){
'use strict';

const isKeyCodeNumber = (code) => {
    return !(code > 31 && (code < 48 || code > 57));
};

module.exports = isKeyCodeNumber;

},{}],466:[function(require,module,exports){
'use strict';

const isMobileDevice = () => {
    // http://detectmobilebrowsers.com/
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera);
    return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(userAgent.substr(0,4));
};

module.exports = isMobileDevice;

},{}],467:[function(require,module,exports){
'use strict';

const isRetina = () => {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5),(min--moz-device-pixel-ratio: 1.5),(-o-min-device-pixel-ratio: 3/2),(min-resolution: 1.5dppx)';

    if (window.devicePixelRatio > 1) {
        return true;
    }

    if (window.matchMedia && window.matchMedia(mediaQuery).matches) {
        return true;
    }

    return false;
};

module.exports = isRetina;

},{}],468:[function(require,module,exports){
'use strict';

const isSmallTabletView = () => {
    const smallTabletMaxWidth = 849;
    const vpWidth = $(window).width();

    return vpWidth <= smallTabletMaxWidth;
};

module.exports = isSmallTabletView;

},{}],469:[function(require,module,exports){
'use strict';

const isSmallView = () => {
    const mobileMaxWidth = 767;
    const vpWidth = $(window).width();

    return vpWidth <= mobileMaxWidth;
};

module.exports = isSmallView;

},{}],470:[function(require,module,exports){
'use strict';

const isTabletDevice = () => {
    const userAgent = (navigator.userAgent || navigator.vendor || window.opera);
    return /Android|webOS|iPad|BlackBerry/i.test(userAgent);
};

module.exports = isTabletDevice;

},{}],471:[function(require,module,exports){
'use strict';

const isTabletPortraitView = () => {
    const tabletminWidth = 768;
    const tabletMaxWidth = 900;
    const vpWidth = $(window).width();

    return vpWidth >= tabletminWidth && vpWidth < tabletMaxWidth;
};

module.exports = isTabletPortraitView;

},{}],472:[function(require,module,exports){
'use strict';

const isTabletView = () => {
    const tabletminWidth = 768;
    const tabletMaxWidth = 1024;
    const vpWidth = $(window).width();

    return vpWidth >= tabletminWidth && vpWidth <= tabletMaxWidth;
};

module.exports = isTabletView;

},{}],473:[function(require,module,exports){
'use strict';

const isMobileDevice = require('./isMobileDevice');
const isTabletDevice = require('./isTabletDevice');

const isTouchDevice = () => {
    return isMobileDevice() || isTabletDevice();
};

module.exports = isTouchDevice;

},{"./isMobileDevice":466,"./isTabletDevice":470}],474:[function(require,module,exports){
'use strict';

const isTabletDevice = require('./isTabletDevice');

const prepareDeferedImages = (html) => {
    $('.js-defered-image', html).each(function(i, el) {
        const imgSrc = $(el).data('src');
        const imgRetinaSrc = $(el).data('retina-src') || imgSrc;
        $(el).attr('src', isTabletDevice() ? imgRetinaSrc : imgSrc);
    });
};

module.exports = prepareDeferedImages;

},{"./isTabletDevice":470}],475:[function(require,module,exports){
'use strict';

let topScroll = 0;
let isScrollDisabled = false;

/**
 * This will disable window from scrolling, used for modals, popups, fixed elements
 */
const disableScroll = () => {
    if (!isScrollDisabled) {
        topScroll = $(window).scrollTop();
        $('body').css({
            'top': -topScroll + 'px'
        }).addClass('no-scroll');
        $('html').css({
            'height': '100vh'
        });

        isScrollDisabled = true;
    }
};

/**
 * This will enable window to scroll, remembering the previous top scroll offset
 */
const enableScroll = () => {
    $('body').removeAttr('style').removeClass('no-scroll');
    $('html').removeAttr('style');

    isScrollDisabled = false;
    if (topScroll !== 0) {
        $(window).scrollTop(topScroll);
        isScrollDisabled = false;
        topScroll = 0;
    }
};

/**
 * Disables the scrolling by mouse keyboard or touch on an element
 *
 * @param {String} el Selector of element to block scroll on
 */
const disableScrollEventsOnEl = (el) => {
    $(el).on('wheel.helpers mousewheel.helpers touchmove.helpers', (e) => {
        e.preventDefault();
        return false;
    });

    $(document).on('keydown.helpers', (e) => {
        const keys = {
            32: 1, // Spacebar
            33: 1, // PageUp
            34: 1, // PageDown
            35: 1, // End
            36: 1, // Home
            38: 1, // Up
            40: 1 // Down
        };

        if (keys[e.keyCode]) {
            e.preventDefault();
            return false;
        }
    });
};

/**
 * Enables the events that where disables in disableScrollEventsOnEl
 *
 * @param {String} el Selector of element to remove events set in disableScrollEventsOnEl
 */
const enableScrollEventsOnEl = (el) => {
    $(el).off('wheel.helpers mousewheel.helpers touchmove.helpers');
    $(document).off('keydown.helpers');
};

/**
 * @function
 * @description Scrolls a browser window to a given x point
 * @param {String} The x coordinate
 */
const scrollSmooth = (xLocation) => {
    const headerH = $('header.header').outerHeight();
    $('html, body').animate({scrollTop: xLocation - headerH}, 500);
};

module.exports = {
    enableScroll: enableScroll,
    disableScroll: disableScroll,
    enableScrollEventsOnEl: enableScrollEventsOnEl,
    disableScrollEventsOnEl: disableScrollEventsOnEl,
    smoothScroll: scrollSmooth
};

},{}],476:[function(require,module,exports){
'use strict';

const isMobileDevice = require('./isMobileDevice');
const isTabletDevice = require('./isTabletDevice');

/**
 * Set element height with JavaScript - usefull for touch devices what have problems with CSS vh units.
 *
 * @input
 * ele 		: HTML Dom Element to resize
 * param1 	: Optional parameter for setting the height in %, if not set default is used. (default:100%)
 *
 * TODO:
 *  - make @input ele accept also objects and arrays
 */
const setViewportHeight = (ele, param1, forceDesktop) => {
    forceDesktop = typeof forceDesktop !== 'undefined' ? forceDesktop : false;
    let viewportHeight = $(window).height();

    // only MOBILE and TABLET
    if (isMobileDevice() || isTabletDevice() || forceDesktop) {

        // Listen for resize changes
        $(window).resize(function() {
            viewportHeight = $(window).height();

            $(ele).css({
                height: param1 ? (viewportHeight / 100) * param1 + 'px' : viewportHeight + 'px'
            });

        });

        // Listen for orientation changes
        window.addEventListener('orientationchange', function() {
            viewportHeight = $(window).height();
            // Announce the new orientation number
            $(ele).css({
                height: param1 ? (viewportHeight / 100) * param1 + 'px' : viewportHeight + 'px'
            });

        }, false);
    }
};

module.exports = setViewportHeight;

},{"./isMobileDevice":466,"./isTabletDevice":470}],477:[function(require,module,exports){
'use strict';

const util = {
    appendParamToURL: require('./appendParamToURL'),
    updateQueryStringParameter: require('./updateQueryStringParameter'),
    removeParamFromURL: require('./removeParamFromURL'),
    appendParamsToUrl: require('./appendParamToURL'),
    getQueryString: require('./getQueryString'),
    getQueryParameter: require('./getQueryParameter'),
    elementInViewport: require('./elementInViewport'),
    ajaxUrl: require('./ajaxUrl'),
    toAbsoluteUrl: require('./toAbsoluteUrl'),
    loadCssFile: require('./dynamicCss').loadCssFile,
    loadDynamicCss: require('./dynamicCss').loadDynamicCss,
    clearDynamicCss: require('./dynamicCss').clearDynamicCss,
    getQueryStringParams: require('./getQueryStringParams'),
    getLocationHash: require('./getLocationHash'),
    setLocationHash: require('./setLocationHash'),
    getTriggerFromHash: require('./getTriggerFromHash'),
    fillAddressFields: require('./fillAddressFields'),
    limitCharacters: require('./limitCharacters'),
    setDeleteConfirmation: require('./setDeleteConfirmation'),
    scrollBrowser: require('./scrollBrowser'),
    isMobile: require('./isMobile'),
    isMobileWidth: require('./isMobileWidth'),
    isMobileOrTabletWidth: require('./isMobileOrTabletWidth'),
    sortSelectOptions: require('./sortSelectOptions'),
    getCookie: require('./getCookie'),
    createCookie : require('./createCookie'),
    getCountryFromLocaleCookie: require('./getCountryFromLocaleCookie'),
    getScreenBreakpointSize: require('./getScreenBreakpointSize'),
    fixBackgroundImagesFlickerIE: require('./fixBackgroundImagesFlickerIE'),
    isParentalConsentNeeded: require('./isParentalConsentNeeded'),
    generateUniqueGuid: require('./generateUniqueGuid'),
    removeDuplicatesFromArray: require('./removeDuplicatesFromArray'),
    transformValueAsArray: require('./transformValueAsArray'),
    replaceCurrencyFormattedValue: require('./replaceCurrencyFormattedValue'),
    getUpdatedURLWithParams: require('./getUpdatedURLWithParams'),
    latinise: require('./latinise')
};

/**
 * Create a shared util object that we can access from component JS files
 */
window.util = {
    isMobile: util.isMobile,
    transformValueAsArray: util.transformValueAsArray
};

module.exports = util;

},{"./ajaxUrl":478,"./appendParamToURL":479,"./createCookie":481,"./dynamicCss":482,"./elementInViewport":483,"./fillAddressFields":484,"./fixBackgroundImagesFlickerIE":485,"./generateUniqueGuid":486,"./getCookie":487,"./getCountryFromLocaleCookie":488,"./getLocationHash":489,"./getQueryParameter":490,"./getQueryString":491,"./getQueryStringParams":492,"./getScreenBreakpointSize":493,"./getTriggerFromHash":494,"./getUpdatedURLWithParams":495,"./isMobile":497,"./isMobileOrTabletWidth":498,"./isMobileWidth":499,"./isParentalConsentNeeded":500,"./latinise":501,"./limitCharacters":502,"./removeDuplicatesFromArray":504,"./removeParamFromURL":505,"./replaceCurrencyFormattedValue":506,"./scrollBrowser":507,"./setDeleteConfirmation":508,"./setLocationHash":509,"./sortSelectOptions":510,"./toAbsoluteUrl":511,"./transformValueAsArray":512,"./updateQueryStringParameter":513}],478:[function(require,module,exports){
'use strict';

const appendParamToURL = require('./appendParamToURL');

/**
 * @function
 * @description Appends the parameter 'format=ajax' to a given path
 * @param {String} path the relative path
 */
const ajaxUrl = (path) => {
    return appendParamToURL(path, 'format', 'ajax');
};

module.exports = ajaxUrl;

},{"./appendParamToURL":479}],479:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description appends the parameter with the given name and value to the given url and returns the changed url
 * @param {String} url the url to which the parameter will be added
 * @param {String} name the name of the parameter
 * @param {String} value the value of the parameter
 */
const appendParamToURL = (url, name, value) => {
    // quit if the param already exists
    if (url.indexOf(name + '=') !== -1) {
        return url;
    }
    const separator = url.indexOf('?') !== -1 ? '&' : '?';
    return url + separator + name + '=' + encodeURIComponent(value);
};

module.exports = appendParamToURL;

},{}],480:[function(require,module,exports){
'use strict';

const _each = require('lodash/each');
const appendParamToURL = require('./appendParamToURL');

/**
 * @function
 * @description appends the parameters to the given url and returns the changed url
 * @param {String} url the url to which the parameters will be added
 * @param {Object} params
 */
const appendParamsToUrl = (url, params) => {
    let _url = url;
    _each(params, function (value, name) {
        _url = appendParamToURL(_url, name, value);
    }.bind(this));
    return _url;
};

module.exports = appendParamsToUrl;

},{"./appendParamToURL":479,"lodash/each":189}],481:[function(require,module,exports){
'use strict';

const createCookie = (name, value, expDays) => {
    let expires;
    if (expDays) {
        const date = new Date();
        date.setTime(date.getTime() + (expDays * 24 * 60 * 60 * 1000));
        expires = '; expires=' + date.toGMTString();
    } else {
        expires = '';
    }
    document.cookie = name + '=' + value + expires + '; path=/';
};

module.exports = createCookie;

},{}],482:[function(require,module,exports){
'use strict';

// array to keep track of the dynamically loaded CSS files
let loadedCssFiles = [];

/**
 * @function
 * @description Loads css file dynamically from given url
 * @param {String} url The url from which css file will be dynamically loaded.
 */
const loadCssFile = (url) => {
    return $('<link/>').appendTo($('head')).attr({
        type: 'text/css',
        rel: 'stylesheet'
    }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
};

/**
 * @function
 * @description Loads css dynamically from given urls
 * @param {Array} urls Array of urls from which css will be dynamically loaded.
 */
const loadDynamicCss = (urls) => {
    const len = urls.length;
    for (let i = 0; i < len; i++) {
        loadedCssFiles.push(loadCssFile(urls[i]));
    }
};

/**
 * @function
 * @description Removes all css files which were dynamically loaded
 */
const clearDynamicCss = () => {
    let i = loadedCssFiles.length;
    while (0 > i--) {
        $(loadedCssFiles[i]).remove();
    }
    loadedCssFiles = [];
};

module.exports = {
    loadCssFile: loadCssFile,
    loadDynamicCss: loadDynamicCss,
    clearDynamicCss: clearDynamicCss
};

},{}],483:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description
 * @param {String}
 * @param {String}
 */
const elementInViewport = (el, offsetToTop) => {
    const rect = el.getBoundingClientRect();
    const offsetTop = offsetToTop || 0;

    // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
    const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
    const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

    // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
    const vertInView = ((rect.top - offsetTop) <= windowHeight) && (((rect.top - offsetTop) + rect.height) >= 0);
    const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

    return (vertInView && horInView);
};

module.exports = elementInViewport;

},{}],484:[function(require,module,exports){
'use strict';

const getCountryFromLocaleCookie = require('./getCountryFromLocaleCookie');

const fillAddressFields = (address, $form) => {
    for (const field in address) {
        if (field === 'ID' || field === 'UUID' || field === 'key') {
            continue;
        }
        // if the key in address object ends with 'Code', remove that suffix
        // keys that ends with 'Code' are postalCode, stateCode and countryCode
        const $field = $form.find('[name$="' + field.replace('Code', '') + '"]');
        $field .val(address[field]);
        // update the state fields
        if (field === 'countryCode') {
            handleCountryCodeChange($field, $form, address.stateCode);
        }

        if (field === 'postalCode') {
            hanldePostalCodeChange($field);
        }
    }
};

const handleCountryCodeChange = ($field, $form, stateCode) => {
    $field.trigger('change');
    // retrigger state selection after country has changed
    // this results in duplication of the state code, but is a necessary evil
    // for now because sometimes countryCode comes after stateCode
    $form.find('[name$="state"]').val(stateCode);
    if (getCountryFromLocaleCookie() === 'US') {
        const $stateSelect = $form.find('[name$="stateUS"]');
        $stateSelect.val(stateCode);
        $stateSelect.selectric('refresh');
    }
};

const hanldePostalCodeChange = ($field) => {
    if (getCountryFromLocaleCookie() === 'US') {
        $field.trigger('blur');
    }
};

module.exports = fillAddressFields;

},{"./getCountryFromLocaleCookie":488}],485:[function(require,module,exports){
'use strict';

const fixBackgroundImagesFlickerIE = () => {
    // fixing scrolling problems in IE11 and Edge - fixed background flickers on scroll
    if (navigator.userAgent.match(/MSIE 10/i) || navigator.userAgent.match(/Trident\/7\./) || navigator.userAgent.match(/Edge\/1/)) {
        $('body').on('mousewheel', function () {
            event.preventDefault();
            const wd = -(event.deltaY);
            const csp = window.pageYOffset;
            window.scrollTo(0, csp - wd);
        });
    }
};

module.exports = fixBackgroundImagesFlickerIE;

},{}],486:[function(require,module,exports){
'use strict';

const generateUniqueGuid = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
};

module.exports = generateUniqueGuid;

},{}],487:[function(require,module,exports){
'use strict';

const getCookie = (name) => {
    const value = '; ' + document.cookie;
    const parts = value.split('; ' + name + '=');
    if (parts.length == 2) {
        return parts.pop().split(';').shift();
    }
};

module.exports = getCookie;

},{}],488:[function(require,module,exports){
'use strict';

const getCookie = require('./getCookie');

const getCountryFromLocaleCookie = () => {
    const localeCookie = getCookie('_ritualsLocale');
    if (!localeCookie) {
        return '';
    }

    return localeCookie.split(/[||]/)[1];
};

module.exports = getCountryFromLocaleCookie;

},{"./getCookie":487}],489:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Checks the passed location hash returns the cleaned or empty string
 * @param {String} hash The location hash
 */
const getLocationHash = (hash) => {
    return (!hash || hash.length === 0) ? '' : hash.substr(1);
};

module.exports = getLocationHash;

},{}],490:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description gets the query parameter value from URL
 * @param {String} url the url to extra query string from
 * @param {String} parameter name
 */
const getQueryParameter = (url, parameterName) => {
    parameterName = parameterName.replace(/[[]/, '\[').replace(/[]]/, '\]'); /* eslint-disable-line */

    const regexPattern = '[\?&]' + parameterName + '=([^&#]*)';
    const regex = new RegExp(regexPattern);
    const results = regex.exec(url);

    if (results === null || (results && typeof (results[1]) !== 'string' && results[1].length)) {
        return '';
    } else {
        return decodeURIComponent(results[1]).replace(/\W/gi, ' ');
    }
};

module.exports = getQueryParameter;

},{}],491:[function(require,module,exports){
'use strict';

const _isString = require('lodash/isString');

/**
 * @function
 * @description extract the query string from URL
 * @param {String} url the url to extra query string from
 */
const getQueryString = (url) => {
    let qs;
    if (!_isString(url)) { return; }
    const a = document.createElement('a');
    a.href = url;
    if (a.search) {
        qs = a.search.substr(1); // remove the leading ?
    }
    return qs;
};

module.exports = getQueryString;

},{"lodash/isString":204}],492:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Extracts all parameters from a given query string into an object
 * @param {String} qs The query string from which the parameters will be extracted
 */
const getQueryStringParams = (qs) => {
    if (!qs || qs.length === 0) { return {}; }
    const params = {},
        unescapedQS = decodeURIComponent(qs);
    // Use the String::replace method to iterate over each
    // name-value pair in the string.
    unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
        function ($0, $1, $2, $3) {
            params[$1] = $3;
        }
    );
    return params;
};

module.exports = getQueryStringParams;

},{}],493:[function(require,module,exports){
'use strict';

const getScreenBreakpointSize = (width) => {
    const screenWidth = width;

    // breakpoints from css
    const breakpoints = {
        medium: 768,
        larger: 1025
    };

    if (screenWidth < breakpoints.medium) {
        return 'small';
    } else if (screenWidth >= breakpoints.medium && screenWidth < breakpoints.larger) {
        return 'medium';
    } else {
        return 'larger';
    }
};

module.exports = getScreenBreakpointSize;

},{}],494:[function(require,module,exports){
'use strict';

const getLocationHash = require('./getLocationHash');

/**
 * @function
 * @description Checks if the location hash has the String trigger in it
 * and returns it if it has. If not returns empty string
 */
const getTriggerFromHash = () => {
    const hash = getLocationHash(window.location.hash);
    return (hash.indexOf('trigger') === 0) ? hash : '';
};

module.exports = getTriggerFromHash;

},{"./getLocationHash":489}],495:[function(require,module,exports){
'use strict';

const getUpdatedURLWithParams = (urlParams, paramsToRemove, skipHash) => {
    if (!urlParams) {
        return;
    }

    const search = location.search.substring(1);
    const params = search == '' ? {}
        : JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g,'":"') + '"}',
            function(key, value) {return key === '' ? value : decodeURIComponent(value);});

    // Overwrite search object with new key / values from urlParams
    if (urlParams) {
        Object.assign(params, urlParams);
    }

    if (paramsToRemove) {
        paramsToRemove.forEach((key) => {
            delete params[key];
        });
    }

    // Construct new URL and replace state
    return location.origin + location.pathname + '?' + $.param(params) + (!skipHash ? location.hash : '');
};

module.exports = getUpdatedURLWithParams;

},{}],496:[function(require,module,exports){
'use strict';

module.exports = require('./_util');

},{"./_util":477}],497:[function(require,module,exports){
'use strict';

const isMobile = () => {
    const mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
    let idx = 0;
    let isMobile = false;

    // Removing the 'tablet pc 2.0' since this triggers a false positive on laptops with IE11 and a touch screen
    const userAgent = (navigator.userAgent).toLowerCase().replace('tablet pc 2.0; ', '');

    while (mobileAgentHash[idx] && !isMobile) {
        isMobile = (userAgent.indexOf(mobileAgentHash[idx]) >= 0);
        idx++;
    }
    return isMobile;
};

module.exports = isMobile;

},{}],498:[function(require,module,exports){
'use strict';

const isMobileOrTabletWidth = () => {
    const desktopWidth = 1024;

    return $(window).width() < desktopWidth;
};

module.exports = isMobileOrTabletWidth;

},{}],499:[function(require,module,exports){
'use strict';

const isMobileWidth = () => {
    const tabletWidth = 768;

    return $(window).width() < tabletWidth;
};

module.exports = isMobileWidth;

},{}],500:[function(require,module,exports){
'use strict';

const isParentalConsentNeeded = (birthday, limitAge) => {
    const birthdaySplitValue = birthday.split(/[.,\/ -]/);
    const currentCountryCode = util.getCountryFromLocaleCookie();

    const day = currentCountryCode === 'US' ? birthdaySplitValue[1] : birthdaySplitValue[0];
    const month = currentCountryCode === 'US' ? birthdaySplitValue[0] : birthdaySplitValue[1];
    const year = currentCountryCode === 'US' || !birthdaySplitValue[2] ? 1900 : parseInt(birthdaySplitValue[2]);
    const dob = new Date(year, parseInt(month) - 1, day);

    const limitDate = new Date();
    limitDate.setFullYear(limitDate.getFullYear() - limitAge);

    return dob > limitDate;
};

module.exports = isParentalConsentNeeded;

},{}],501:[function(require,module,exports){
'use strict';

const Latinise = {};

Latinise.latinMap = {
'Á':'A',
'Ă':'A',
'Ắ':'A',
'Ặ':'A',
'Ằ':'A',
'Ẳ':'A',
'Ẵ':'A',
'Ǎ':'A',
'Â':'A',
'Ấ':'A',
'Ậ':'A',
'Ầ':'A',
'Ẩ':'A',
'Ẫ':'A',
'Ä':'A',
'Ǟ':'A',
'Ȧ':'A',
'Ǡ':'A',
'Ạ':'A',
'Ȁ':'A',
'À':'A',
'Ả':'A',
'Ȃ':'A',
'Ā':'A',
'Ą':'A',
'Å':'A',
'Ǻ':'A',
'Ḁ':'A',
'Ⱥ':'A',
'Ã':'A',
'д':'d',
'Ꜳ':'AA',
'Æ':'AE',
'Ǽ':'AE',
'Ǣ':'AE',
'Ꜵ':'AO',
'Ꜷ':'AU',
'Ꜹ':'AV',
'Ꜻ':'AV',
'Ꜽ':'AY',
'Ḃ':'B',
'Ḅ':'B',
'Ɓ':'B',
'Ḇ':'B',
'Ƀ':'B',
'Ƃ':'B',
'б':'b',
'в':'v',
'Ć':'C',
'Č':'CH',
'Ç':'C',
'Ḉ':'C',
'Ĉ':'C',
'Ċ':'C',
'Ƈ':'C',
'Ȼ':'C',
'Ď':'D',
'Ḑ':'D',
'Ḓ':'D',
'Ḋ':'D',
'Ḍ':'D',
'Ɗ':'D',
'Ḏ':'D',
'ǲ':'D',
'ǅ':'DZ',
'Đ':'DJ',
'Ƌ':'D',
'Ǳ':'DZ',
'Ǆ':'DZ',
'É':'E',
'Ĕ':'E',
'Ě':'E',
'Ȩ':'E',
'Ḝ':'E',
'Ê':'E',
'Ế':'E',
'Ệ':'E',
'Ề':'E',
'Ể':'E',
'Ễ':'E',
'Ḙ':'E',
'Ë':'E',
'Ė':'E',
'Ẹ':'E',
'Ȅ':'E',
'È':'E',
'Ẻ':'E',
'Ȇ':'E',
'Ē':'E',
'Ḗ':'E',
'Ḕ':'E',
'Ę':'E',
'Ɇ':'E',
'Ẽ':'E',
'Ḛ':'E',
'Ꝫ':'ET',
'Ḟ':'F',
'Ƒ':'F',
'Ǵ':'G',
'Ğ':'G',
'Ǧ':'G',
'Ģ':'G',
'Ĝ':'G',
'Ġ':'G',
'Ɠ':'G',
'Ḡ':'G',
'Ǥ':'G',
'Ḫ':'H',
'Ȟ':'H',
'Ḩ':'H',
'Ĥ':'H',
'Ⱨ':'H',
'Ḧ':'H',
'Ḣ':'H',
'Ḥ':'H',
'Ħ':'H',
'ђ':'dj',
'Í':'I',
'Ĭ':'I',
'Ǐ':'I',
'Î':'I',
'Ï':'I',
'Ḯ':'I',
'İ':'I',
'Ị':'I',
'Ȉ':'I',
'Ì':'I',
'Ỉ':'I',
'Ȋ':'I',
'Ī':'I',
'Į':'I',
'Ɨ':'I',
'Ĩ':'I',
'Ḭ':'I',
'Ꝺ':'D',
'Ꝼ':'F',
'Ᵹ':'G',
'Ꞃ':'R',
'Ꞅ':'S',
'Ꞇ':'T',
'Ꝭ':'IS',
'Ĵ':'J',
'Ɉ':'J',
'Ḱ':'K',
'Ǩ':'K',
'Ķ':'K',
'Ⱪ':'K',
'Ꝃ':'K',
'Ḳ':'K',
'Ƙ':'K',
'Ḵ':'K',
'Ꝁ':'K',
'Ꝅ':'K',
'Ĺ':'L',
'Ƚ':'L',
'Ľ':'L',
'Ļ':'L',
'Ḽ':'L',
'Ḷ':'L',
'Ḹ':'L',
'Ⱡ':'L',
'Ꝉ':'L',
'Ḻ':'L',
'Ŀ':'L',
'Ɫ':'L',
'ǈ':'LJ',
'Ł':'L',
'Ǉ':'LJ',
'Ḿ':'M',
'Ṁ':'M',
'Ṃ':'M',
'Ɱ':'M',
'Ń':'N',
'Ň':'N',
'Ņ':'N',
'Ṋ':'N',
'Ṅ':'N',
'Ṇ':'N',
'Ǹ':'N',
'Ɲ':'N',
'Ṉ':'N',
'Ƞ':'N',
'ǋ':'NJ',
'Ñ':'N',
'Ǌ':'NJ',
'Ó':'O',
'Ŏ':'O',
'Ǒ':'O',
'Ô':'O',
'Ố':'O',
'Ộ':'O',
'Ồ':'O',
'Ổ':'O',
'Ỗ':'O',
'Ö':'O',
'Ȫ':'O',
'Ȯ':'O',
'Ȱ':'O',
'Ọ':'O',
'Ő':'O',
'Ȍ':'O',
'Ò':'O',
'Ỏ':'O',
'Ơ':'O',
'Ớ':'O',
'Ợ':'O',
'Ờ':'O',
'Ở':'O',
'Ỡ':'O',
'Ȏ':'O',
'Ꝋ':'O',
'Ꝍ':'O',
'Ō':'O',
'Ṓ':'O',
'Ṑ':'O',
'Ɵ':'O',
'Ǫ':'O',
'Ǭ':'O',
'Ø':'O',
'Ǿ':'O',
'Õ':'O',
'Ṍ':'O',
'Ṏ':'O',
'Ȭ':'O',
'Ƣ':'OI',
'Ꝏ':'OO',
'Ɛ':'E',
'Ɔ':'O',
'Ȣ':'OU',
'Ṕ':'P',
'Ṗ':'P',
'Ꝓ':'P',
'Ƥ':'P',
'Ꝕ':'P',
'Ᵽ':'P',
'Ꝑ':'P',
'Ꝙ':'Q',
'Ꝗ':'Q',
'Ŕ':'R',
'Ř':'R',
'Ŗ':'R',
'Ṙ':'R',
'Ṛ':'R',
'Ṝ':'R',
'Ȑ':'R',
'Ȓ':'R',
'Ṟ':'R',
'Ɍ':'R',
'Ɽ':'R',
'г':'g',
'Ꜿ':'C',
'Ǝ':'E',
'Ś':'S',
'Ṥ':'SH',
'Š':'S',
'Ṧ':'S',
'Ş':'S',
'Ŝ':'S',
'Ș':'S',
'Ṡ':'S',
'Ṣ':'S',
'Ṩ':'S',
'Ť':'T',
'Ţ':'T',
'Ṱ':'T',
'Ț':'T',
'Ⱦ':'T',
'Ṫ':'T',
'Ṭ':'T',
'Ƭ':'T',
'Ṯ':'T',
'Ʈ':'T',
'Ŧ':'T',
'Ɐ':'A',
'Ꞁ':'L',
'Ɯ':'M',
'Ʌ':'V',
'Ꜩ':'TZ',
'Ú':'U',
'Ŭ':'U',
'Ǔ':'U',
'Û':'U',
'Ṷ':'U',
'Ü':'U',
'Ǘ':'U',
'Ǚ':'U',
'Ǜ':'U',
'Ǖ':'U',
'Ṳ':'U',
'Ụ':'U',
'Ű':'U',
'Ȕ':'U',
'Ù':'U',
'Ủ':'U',
'Ư':'U',
'Ứ':'U',
'Ự':'U',
'Ừ':'U',
'Ử':'U',
'Ữ':'U',
'Ȗ':'U',
'Ū':'U',
'Ṻ':'U',
'Ų':'U',
'Ů':'U',
'Ũ':'U',
'Ṹ':'U',
'Ṵ':'U',
'Ꝟ':'V',
'Ṿ':'V',
'Ʋ':'V',
'Ṽ':'V',
'Ꝡ':'VY',
'Ẃ':'W',
'Ŵ':'W',
'Ẅ':'W',
'Ẇ':'W',
'Ẉ':'W',
'Ẁ':'W',
'Ⱳ':'W',
'Ẍ':'X',
'Ẋ':'X',
'Ý':'Y',
'Ŷ':'Y',
'Ÿ':'Y',
'Ẏ':'Y',
'Ỵ':'Y',
'Ỳ':'Y',
'Ƴ':'Y',
'Ỷ':'Y',
'Ỿ':'Y',
'Ȳ':'Y',
'Ɏ':'Y',
'Ỹ':'Y',
'Ź':'Z',
'Ž':'Z',
'Ẑ':'Z',
'Ⱬ':'Z',
'Ż':'Z',
'Ẓ':'Z',
'Ȥ':'Z',
'Ẕ':'Z',
'Ƶ':'Z',
'Ĳ':'IJ',
'Œ':'OE',
'ᴀ':'A',
'ᴁ':'AE',
'ʙ':'B',
'ᴃ':'B',
'ᴄ':'C',
'ᴅ':'D',
'ᴇ':'E',
'ꜰ':'F',
'ɢ':'G',
'ʛ':'G',
'ʜ':'H',
'ɪ':'I',
'ʁ':'R',
'ᴊ':'J',
'ᴋ':'K',
'ʟ':'L',
'ᴌ':'L',
'ᴍ':'M',
'ɴ':'N',
'ᴏ':'O',
'ɶ':'OE',
'ᴐ':'O',
'ᴕ':'OU',
'ᴘ':'P',
'ʀ':'R',
'ᴎ':'I',
'ᴙ':'Ya',
'ꜱ':'S',
'ᴛ':'T',
'ⱻ':'E',
'ᴚ':'R',
'ᴜ':'U',
'ᴠ':'V',
'ᴡ':'W',
'ʏ':'Y',
'ᴢ':'Z',
'á':'a',
'ă':'a',
'ắ':'a',
'ặ':'a',
'ằ':'a',
'ẳ':'a',
'ẵ':'a',
'ǎ':'a',
'â':'a',
'ấ':'a',
'ậ':'a',
'ầ':'a',
'ẩ':'a',
'ẫ':'a',
'ä':'a',
'ǟ':'a',
'ȧ':'a',
'ǡ':'a',
'ạ':'a',
'ȁ':'a',
'à':'a',
'ả':'a',
'ȃ':'a',
'ā':'a',
'ą':'a',
'ᶏ':'a',
'ẚ':'a',
'å':'a',
'ǻ':'a',
'ḁ':'a',
'ⱥ':'a',
'ã':'a',
'ꜳ':'aa',
'æ':'ae',
'ǽ':'ae',
'ǣ':'ae',
'ꜵ':'ao',
'ꜷ':'au',
'ꜹ':'av',
'ꜻ':'av',
'ꜽ':'ay',
'ḃ':'b',
'ḅ':'b',
'ɓ':'b',
'ḇ':'b',
'ᵬ':'b',
'ᶀ':'b',
'ƀ':'b',
'ƃ':'b',
'ɵ':'o',
'ć':'c',
'č':'ch',
'ç':'c',
'ḉ':'c',
'ĉ':'c',
'ɕ':'c',
'ċ':'c',
'ƈ':'c',
'ȼ':'c',
'ď':'d',
'ḑ':'d',
'ḓ':'d',
'ȡ':'d',
'ḋ':'d',
'ḍ':'d',
'ɗ':'d',
'ᶑ':'d',
'ḏ':'d',
'ᵭ':'d',
'ᶁ':'d',
'đ':'d',
'ɖ':'d',
'ƌ':'d',
'ı':'i',
'ȷ':'j',
'ɟ':'j',
'ʄ':'j',
'ǳ':'dz',
'ǆ':'dz',
'é':'e',
'ĕ':'e',
'ě':'e',
'ȩ':'e',
'ḝ':'e',
'ê':'e',
'ế':'e',
'ệ':'e',
'ề':'e',
'ể':'e',
'ễ':'e',
'ḙ':'e',
'ë':'e',
'ė':'e',
'ẹ':'e',
'ȅ':'e',
'è':'e',
'ẻ':'e',
'ȇ':'e',
'ē':'e',
'ḗ':'e',
'ḕ':'e',
'ⱸ':'e',
'ę':'e',
'ᶒ':'e',
'ɇ':'e',
'ẽ':'e',
'ḛ':'e',
'ꝫ':'et',
'ḟ':'f',
'ƒ':'f',
'ᵮ':'f',
'ᶂ':'f',
'ǵ':'g',
'ğ':'g',
'ǧ':'g',
'ģ':'g',
'ĝ':'g',
'ġ':'g',
'ɠ':'g',
'ḡ':'g',
'ᶃ':'g',
'ǥ':'g',
'ḫ':'h',
'ȟ':'h',
'ḩ':'h',
'ĥ':'h',
'ⱨ':'h',
'ḧ':'h',
'ḣ':'h',
'ḥ':'h',
'ɦ':'h',
'ẖ':'h',
'ħ':'c',
'ф':'f',
'ƕ':'hv',
'н':'n',
'њ':'nj',
'í':'i',
'ĭ':'i',
'ǐ':'i',
'î':'i',
'ï':'i',
'ḯ':'i',
'ị':'i',
'ȉ':'i',
'ì':'i',
'ỉ':'i',
'ȋ':'i',
'ī':'i',
'į':'i',
'ᶖ':'i',
'ɨ':'i',
'ĩ':'i',
'ḭ':'i',
'ꝺ':'d',
'ꝼ':'f',
'ᵹ':'g',
'ꞃ':'r',
'ꞅ':'s',
'ꞇ':'t',
'ꝭ':'is',
'ǰ':'j',
'ĵ':'j',
'ʝ':'j',
'ɉ':'j',
'ḱ':'k',
'ǩ':'k',
'ķ':'k',
'ⱪ':'k',
'ꝃ':'k',
'ḳ':'k',
'ƙ':'k',
'ḵ':'k',
'ᶄ':'k',
'ꝁ':'k',
'ꝅ':'k',
'ĺ':'l',
'ƚ':'l',
'ɬ':'l',
'ľ':'l',
'ļ':'l',
'ḽ':'l',
'ȴ':'l',
'ḷ':'l',
'ḹ':'l',
'ⱡ':'l',
'ꝉ':'l',
'ḻ':'l',
'ŀ':'l',
'ɫ':'l',
'ᶅ':'l',
'ɭ':'l',
'ł':'l',
'ǉ':'lj',
'ſ':'s',
'ẜ':'s',
'ẛ':'s',
'ẝ':'s',
'ḿ':'m',
'ṁ':'m',
'ṃ':'m',
'ɱ':'m',
'ᵯ':'m',
'ᶆ':'m',
'ń':'n',
'ň':'n',
'ņ':'n',
'ṋ':'n',
'ȵ':'n',
'ṅ':'n',
'ṇ':'n',
'ǹ':'n',
'ɲ':'n',
'ṉ':'n',
'ƞ':'n',
'ᵰ':'n',
'ᶇ':'n',
'ɳ':'n',
'ñ':'n',
'и':'i',
'л':'l',
'п':'p',
'љ':'lj',
'ǌ':'nj',
'ó':'o',
'ŏ':'o',
'ǒ':'o',
'ô':'o',
'ố':'o',
'ộ':'o',
'ồ':'o',
'ổ':'o',
'ỗ':'o',
'ö':'o',
'ȫ':'o',
'ȯ':'o',
'ȱ':'o',
'ọ':'o',
'ő':'o',
'ȍ':'o',
'ò':'o',
'ỏ':'o',
'ơ':'o',
'ớ':'o',
'ợ':'o',
'ờ':'o',
'ở':'o',
'ỡ':'o',
'ȏ':'o',
'ꝋ':'o',
'ꝍ':'o',
'ⱺ':'o',
'ō':'o',
'ṓ':'o',
'ṑ':'o',
'ǫ':'o',
'ǭ':'o',
'ø':'o',
'ǿ':'o',
'õ':'o',
'ṍ':'o',
'ṏ':'o',
'ȭ':'o',
'ƣ':'oi',
'ꝏ':'oo',
'ɛ':'e',
'ᶓ':'e',
'ɔ':'o',
'ᶗ':'o',
'ȣ':'ou',
'ṕ':'p',
'ṗ':'p',
'ꝓ':'p',
'ƥ':'p',
'ᵱ':'p',
'ᶈ':'p',
'ꝕ':'p',
'ᵽ':'p',
'ꝑ':'p',
'ꝙ':'q',
'ʠ':'q',
'ɋ':'q',
'ꝗ':'q',
'ŕ':'r',
'ř':'r',
'ŗ':'r',
'ṙ':'r',
'ṛ':'r',
'ṝ':'r',
'ȑ':'r',
'ɾ':'r',
'ᵳ':'r',
'ȓ':'r',
'ṟ':'r',
'ɼ':'r',
'ᵲ':'r',
'ᶉ':'r',
'ɍ':'r',
'ɽ':'r',
'ↄ':'c',
'ꜿ':'c',
'ɘ':'e',
'ɿ':'r',
'ś':'s',
'ṥ':'s',
'š':'s',
'ṧ':'s',
'ş':'s',
'ŝ':'s',
'ș':'s',
'ṡ':'s',
'ṣ':'s',
'ṩ':'s',
'ʂ':'s',
'ᵴ':'s',
'ᶊ':'s',
'ȿ':'s',
'ɡ':'g',
'ᴑ':'o',
'ᴓ':'o',
'ᴝ':'u',
'ť':'t',
'ţ':'t',
'ṱ':'t',
'ț':'t',
'ȶ':'t',
'ẗ':'t',
'ⱦ':'t',
'ṫ':'t',
'ṭ':'t',
'ƭ':'t',
'ṯ':'t',
'ᵵ':'t',
'ƫ':'t',
'ʈ':'t',
'ŧ':'t',
'ᵺ':'th',
'ɐ':'a',
'ᴂ':'ae',
'ǝ':'e',
'ᵷ':'g',
'ɥ':'h',
'ʮ':'h',
'ʯ':'h',
'ᴉ':'i',
'ʞ':'k',
'ꞁ':'l',
'ɯ':'m',
'ɰ':'m',
'ᴔ':'oe',
'ɹ':'r',
'ɻ':'r',
'ɺ':'r',
'ⱹ':'r',
'ʇ':'t',
'ʌ':'v',
'ʍ':'w',
'ʎ':'y',
'ꜩ':'tz',
'ú':'u',
'ŭ':'u',
'ǔ':'u',
'û':'u',
'ṷ':'u',
'ü':'u',
'ǘ':'u',
'ǚ':'u',
'ǜ':'u',
'ǖ':'u',
'ṳ':'u',
'ụ':'u',
'ű':'u',
'ȕ':'u',
'ù':'u',
'ủ':'u',
'ư':'u',
'ứ':'u',
'ự':'u',
'ừ':'u',
'ử':'u',
'ữ':'u',
'ȗ':'u',
'ū':'u',
'ṻ':'u',
'ų':'u',
'ᶙ':'u',
'ů':'u',
'ũ':'u',
'ṹ':'u',
'ṵ':'u',
'ц':'ts',
'ч':'ch',
'џ':'dz',
'ш':'sh',
'ᵫ':'ue',
'ꝸ':'um',
'ⱴ':'v',
'ꝟ':'v',
'ṿ':'v',
'ʋ':'v',
'ᶌ':'v',
'ⱱ':'v',
'ṽ':'v',
'ꝡ':'vy',
'ẃ':'w',
'ŵ':'w',
'ẅ':'w',
'ẇ':'w',
'ẉ':'w',
'ẁ':'w',
'ⱳ':'w',
'ẘ':'w',
'ẍ':'x',
'ẋ':'x',
'ᶍ':'x',
'ý':'y',
'ŷ':'y',
'ÿ':'y',
'ẏ':'y',
'ỵ':'y',
'ỳ':'y',
'ƴ':'u',
'ỷ':'y',
'ỿ':'y',
'ȳ':'y',
'ẙ':'y',
'ɏ':'y',
'ỹ':'y',
'ź':'z',
'ž':'zh',
'ẑ':'z',
'ʑ':'z',
'ⱬ':'z',
'ż':'z',
'ẓ':'z',
'ȥ':'z',
'ẕ':'z',
'ᵶ':'z',
'ᶎ':'z',
'ʐ':'z',
'ƶ':'z',
'ɀ':'z',
'ﬀ':'ff',
'ﬃ':'ffi',
'ﬄ':'ffl',
'ﬁ':'fi',
'ﬂ':'fl',
'ĳ':'ij',
'œ':'oe',
'ﬆ':'st',
'ₐ':'a',
'ₑ':'e',
'ᵢ':'i',
'ⱼ':'j',
'ₒ':'o',
'ᵣ':'r',
'ᵤ':'u',
'ᵥ':'v',
'ₓ':'x',
'ж':'zh',
'з':'z',
};

String.prototype.latinise = function(){
    return this.replace(/[^A-Za-z0-9\[\] ]/g, function(a) {
        return Latinise.latinMap[a] || a;
    });
};

String.prototype.isLatin = function(){
    return this == this.latinise();
};


},{}],502:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Updates the number of the remaining character
 * based on the character limit in a text area
 */
const limitCharacters = () => {
    $('form').find('textarea[data-character-limit]').each(function () {
        const characterLimit = $(this).data('character-limit');
        const charCountHtml = String.format(Resources.CHAR_LIMIT_MSG,
            '<span class="char-remain-count">' + characterLimit + '</span>',
            '<span class="char-allowed-count">' + characterLimit + '</span>');
        let charCountContainer = $(this).next('div.char-count');
        if (charCountContainer.length === 0) {
            charCountContainer = $('<div class="char-count"/>').insertAfter($(this));
        }
        charCountContainer.html(charCountHtml);
        // trigger the keydown event so that any existing character data is calculated
        $(this).change();
    });
};

module.exports = limitCharacters;

},{}],503:[function(require,module,exports){
'use strict';

const loadExternalScript = (scriptSrc) => new Promise((resolve, reject) => {
    let scriptEl = document.querySelector('script[src="' + scriptSrc + '"]');

    if (scriptEl) {
        resolve(scriptEl);
        return;
    }

    scriptEl = document.createElement('script');
    scriptEl.type = 'text/javascript';
    scriptEl.async = true;
    scriptEl.src = scriptSrc;

    scriptEl.addEventListener('error', reject);
    scriptEl.addEventListener('abort', reject);
    scriptEl.addEventListener('load', function loadScriptHandler() {
        resolve(scriptEl);
    });

    document.head.appendChild(scriptEl);
});

module.exports = loadExternalScript;

},{}],504:[function(require,module,exports){
'use strict';

const removeDuplicatesFromArray = (array, prop) => {
    return array.filter(function(obj, pos, arr) {
        return arr.map((mapObj) => mapObj[prop]).indexOf(obj[prop]) === pos;
    });
};

module.exports = removeDuplicatesFromArray;

},{}],505:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description remove the parameter and its value from the given url and returns the changed url
 * @param {String} url the url from which the parameter will be removed
 * @param {String} name the name of parameter that will be removed from url
 */
const removeParamFromURL = (url, name) => {
    if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
        return url;
    }
    let hash;
    const domain = url.split('?')[0];
    let paramUrl = url.split('?')[1];
    const newParams = [];
    // if there is a hash at the end, store the hash
    if (paramUrl.indexOf('#') > -1) {
        hash = paramUrl.split('#')[1] || '';
        paramUrl = paramUrl.split('#')[0];
    }
    const params = paramUrl.split('&');
    for (let i = 0; i < params.length; i++) {
        // put back param to newParams array if it is not the one to be removed
        if (params[i].split('=')[0] !== name) {
            newParams.push(params[i]);
        }
    }
    return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
};

module.exports = removeParamFromURL;

},{}],506:[function(require,module,exports){
'use strict';

const replaceCurrencyFormattedValue = (formattedString, newValue) => {

    const newValueParts = newValue.toFixed(2).toString().split('.');

    const newValueInteger = newValueParts[0];
    const newValueDecimal = newValueParts.length > 1 ? newValueParts[1] : '00';

    const newFormattedValue = formattedString.replace(/[0-9]+([^0-9])[0-9]+/, newValueInteger + '$1' + newValueDecimal);

    return newFormattedValue;
};

module.exports = replaceCurrencyFormattedValue;

},{}],507:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Scrolls a browser window to a given x point
 * @param {String} The x coordinate
 */
const scrollBrowser = (xLocation) => {
    $('html, body').animate({scrollTop: xLocation}, 500);
};

module.exports = scrollBrowser;

},{}],508:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Binds the onclick-event to a delete button on a given container,
 * which opens a confirmation box with a given message
 * @param {String} container The name of element to which the function will be bind
 * @param {String} message The message the will be shown upon a click
 */
const setDeleteConfirmation = (container, message) => {
    $(container).on('click', '.delete', function () {
        return window.confirm(message);
    });
};

module.exports = setDeleteConfirmation;

},{}],509:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Set the location hash
 * @param {String} hash The location hash
 */
const setLocationHash = (hash) => {
    if (!hash || hash.length === 0) {
        return;
    }

    window.location.hash = '#' + hash;
};

module.exports = setLocationHash;

},{}],510:[function(require,module,exports){
'use strict';

const sortSelectOptions = (selectElement) => {
    const currentValue = selectElement.val();
    const optionsList = selectElement.find('option');
    optionsList.sort(function(a, b) {
        const compA = $(a).attr('label').toUpperCase();
        const compB = $(b).attr('label').toUpperCase();
        return (compA < compB) ? -1 : (compA > compB) ? 1 : 0;
    });

    selectElement.html('');
    $(optionsList).each(
        function() {
            const $this = $(this);
            $this.text($this.attr('label'));
            $this.appendTo(selectElement);
        });
    selectElement.val(currentValue);
};

module.exports = sortSelectOptions;

},{}],511:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description
 * @param {String} url
 */
const toAbsoluteUrl = (url) => {
    if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
        url = '/' + url;
    }
    return url;
};

module.exports = toAbsoluteUrl;

},{}],512:[function(require,module,exports){
'use strict';

const transformValueAsArray = (el) => {
    let result = [];
    try {
        result = el.css('transform').match(/[0-9., -]+/)[0].split(',');
    } catch (e) {
        //do nothing
    }
    return result;
};

module.exports = transformValueAsArray;

},{}],513:[function(require,module,exports){
'use strict';

const updateQueryStringParameter = (uri, key, value) => {
    const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
    const separator = uri.indexOf('?') !== -1 ? '&' : '?';
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
        return uri + separator + key + '=' + value;
    }
};

module.exports = updateQueryStringParameter;

},{}],514:[function(require,module,exports){
'use strict';

const isMobileWidth = require('./modules/util/isMobileWidth');

const ROWS_PER_COL = 3;
const MULTICOL_EL = '.js-multicol';
const TEMPLATE = `
  <div class="collection-ingr-col">
    <ul class="collection-ingredients-list">
      $HTML
    </ul>
  </div>
`;

const convertToChunks = () => {
    const multicolListItem = Array.from(document.querySelector(MULTICOL_EL).children);
    const chunks = [];

    for (let i = 0; i < multicolListItem.length; i += ROWS_PER_COL) {
        const chunk = multicolListItem.slice(i, i + ROWS_PER_COL);
        chunks.push(chunk);
    }

    return chunks;
};

const renderCols = () => {
    const multicolEl = document.querySelector(MULTICOL_EL);
    const chunks = convertToChunks();

    multicolEl.innerHTML = '';

    for (const chunk of chunks) {
        let html = '';
        for (let i = 0; i < chunk.length; i += 1) {
            html += chunk[i].outerHTML;
        }
        html = TEMPLATE.replace('$HTML', html);
        multicolEl.insertAdjacentHTML('beforeend', html);
    }
};

const shouldInit = () => document.querySelectorAll(MULTICOL_EL).length > 0 && isMobileWidth();

const multiCol = {
    init: () => {
        if (shouldInit()) {
            renderCols();
        }
    }
};

module.exports = multiCol;

},{"./modules/util/isMobileWidth":499}],515:[function(require,module,exports){
'use strict';

const scrollHelper = require('./modules/helpers/scroll');
const debounce = require('./modules/helpers/debounce');
const damHelper = require('./dam/dam-helper');
const productFilter = require('./product-filter');
const navigationScroller = require('./navigationScroller');

const $header = $('.js-header');
const $hamburgerBtn = $('.js-nav-toggle');
const $navWrapper = $('.js-navigation-inner');
const $navMobile = $('.js-nav-mobile');
const $navMobileFlyinLink = $navMobile.find('.js-mobile-flyin');
const navMobileLayerClass = '.js-nav-mobile-layer';
const navMobileAdditionalClass = '.js-nav-mobile-additional';
const $headerActionLinks = $('.js-header-actions');
const $headerLogo = $('.js-header-logo');
const $navDesktop = $('.js-nav-desktop');
const $navDesktopMainlink = $('.js-nav-desktop-item-link');
const navDesktopLayerClass = '.js-nav-desktop-layer';
const navDesktopOverlay = '.js-nav-desktop-overlay';
const navDesktopCloseBtnClass = '.js-close-desktop-nav';
const navDesktopCloseSubnavClass = '.js-close-desktop-subnav';
const navDesktopFirstLayerClass = '.js-nav-first-layer';
const scrollableMobClass = '> .js-mob-scrollable-container';
const scrollableDesktopClass = '> .js-nav-first-layer > .js-desktop-scrollable-container';
const scrollableDesktopSubnav = '> .js-desktop-scrollable-subcontainer';
const navDesktopScrollableParentClass = '.js-scrollable-parent';
const $navDesktopOpenLayer = $('.js-nav-desktop .js-nav-mobile-sublink');
const navMobileSublinkClass = '.js-nav-mobile-sublink';
const navDesktopSecLayerClass = '.js-nav-desktop-second-layer';
const navigateToMainSite = '.js-nav-to-main';

let isNavScrolling = false;

function addTouchEvents() {
    $('body').on('touchstart.navigation', function () {
        isNavScrolling = false;
    });

    $('body').on('touchmove.navigation', function () {
        isNavScrolling = true;
    });

    $('body').on('touchend.navigation', function () {
        isNavScrolling = false;
        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
    });

    $('.js-mob-scrollable-container').on('scroll.navigation', debounce(function () {
        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
    }, 100));
}

function removeTouchEvents() {
    $('body').off('touchstart.navigation');
    $('body').off('touchmove.navigation');
    $('body').off('touchend.navigation');
    $('.js-mob-scrollable-container').off('scroll.navigation');
}

//open mobile navigation
function toggleMobileNav() {
    $hamburgerBtn.on('click', function () {
        const $this = $(this);

        if (!$this.hasClass('active')) {
            $('body').css({
                'overflow': 'hidden'
            });

            addTouchEvents();

            $header.addClass('nav-active');
            $this.addClass('active');
            $navWrapper.addClass('active');
            $navMobile.stop().fadeIn(200).attr('aria-hidden', 'false');
            if ($(window).width() < 768) {
                $headerActionLinks.addClass('search-expand');
            }
            $headerLogo.attr('tabindex', '-1');

            $navMobileFlyinLink.parent().each(function (index, item) {
                setTimeout(function() {
                    $(item).addClass('flyin');
                }, index * 40);
            });
        } else {
            $('body').removeAttr('style');
            removeTouchEvents();
            closeMobileNavigation();
        }
    });

    $(document).on('keydown', function(e){
        if (e.which == 27 && $hamburgerBtn.hasClass('active')) {
            closeMobileNavigation();
        }
    });
}

function closeMobileNavigation() {
    $hamburgerBtn.removeClass('active');
    $navWrapper.removeClass('active');
    $navMobile.stop().fadeOut(200).attr('aria-hidden', 'true');
    $headerActionLinks.removeClass('search-expand');
    $headerLogo.removeAttr('tabindex').removeClass('fade-out');
    $navMobileFlyinLink.removeClass('flyin');
    $(navMobileLayerClass).removeClass('visible').fadeOut();
    $navMobile.find('li').removeClass('flyin').removeClass('flyout');
    $navMobile.find('a, button').removeAttr('tabindex');
    scrollHelper.enableScroll();
    $header.removeClass('nav-active');
}

//toggle different mobile layers
function toggleMobileNavLayers() {
    $('.js-mobile-nav-next-lvl').on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        if (e.cancelable !== false) {
            e.preventDefault();
        }

        if (!isNavScrolling) {
            const $this = $(this);
            const $parent = $this.parent();

            $this.addClass('js-selected-category');
            $parent.addClass('flyout');
            $parent.siblings().addClass('flyout');
            $this.attr('tabindex', '-1');
            $this.closest('.js-mob-scrollable-container').siblings('.js-nav-layer-back').attr('tabindex', '-1');
            $parent.siblings().find('.js-mobile-flyin').attr('tabindex', '-1');
            $parent.siblings().find('> .js-nav-mobile-sublink').attr('tabindex', '-1');
            $parent.siblings().find('> .js-mobile-nav-next-lvl').attr('tabindex', '-1');
            $(navMobileLayerClass).removeClass('js-visible');

            if (!$this.hasClass('js-skip-load-images')) {
                damHelper.updateImages($this.parent().find('.js-nav-responsive-bg').parent(), true);
            }

            $this.siblings(navMobileLayerClass).addClass('visible js-visible').attr('aria-hidden', 'false').fadeIn('fast', function () {
                const $visibleLayer = $(this);
                const $closestChild = $visibleLayer.find('ul').first().find('> li');
                const $siblingScrollable = $visibleLayer.find('.js-mob-scrollable-container');

                $siblingScrollable.scrollTop(0);

                $closestChild.each(function (index, item) {
                    setTimeout(function() {
                        $(item).addClass('flyin');
                    }, index * 40);
                });

                if ($(navMobileAdditionalClass).length) {
                    $(navMobileAdditionalClass).find('li').addClass('flyout');
                    $(navMobileAdditionalClass).find('li a').attr('tabindex', '-1');
                }

                gradientScrollCheck(navMobileLayerClass, scrollableMobClass);

                if ($parent.siblings().find(navMobileLayerClass).hasClass('visible')) {
                    $parent.siblings().find(navMobileLayerClass).removeClass('visible').hide();
                    $parent.siblings().find(navMobileLayerClass).find('.js-nav-mobile-subnav-item').removeClass('flyin').removeClass('flyout');
                    $parent.siblings().find('.js-nav-mobile-sublink, .js-nav-layer-back, .js-mobile-nav-next-lvl').removeAttr('tabindex');
                }
            });
        }

        setTimeout(() => {
            if ($('.js-nav-item.flyin.flyout').length) {
                $('.js-nav-layer-back').focus();
            } else {
                $('.js-nav-item.flyin:first').find('button').focus();
            }
        }, 750);
    });

    $('.js-nav-layer-back').on('click keydown', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }

        const $backBtn = $(this);
        const $parent = $backBtn.parent(navMobileLayerClass);

        $parent.removeClass('js-visible');
        $parent.find('ul').first().find('> li').removeClass('flyin');

        $parent.removeClass('visible').fadeOut('70', function () {
            const $closestList = $backBtn.closest('ul');
            const $closestListItem = $closestList.parent().find('> ul > li');
            const $additionalLinks = $closestList.siblings(navMobileAdditionalClass);

            $closestList.find('.js-selected-category').removeClass('js-selected-category');

            $closestList.find('> .js-nav-mobile-subnav-item').find('> .js-nav-mobile-sublink').removeAttr('tabindex');
            $closestList.find('> .js-nav-mobile-subnav-item').find('> .js-mobile-nav-next-lvl').removeAttr('tabindex');
            $closestList.parent('.js-mob-scrollable-container').siblings('.js-nav-layer-back').removeAttr('tabindex');

            if ($navMobile.find('.js-clicked').length) {
                const $clickedBanner = $navMobile.find('.js-clicked');
                const $backPanel = $clickedBanner.closest(navMobileLayerClass);

                $clickedBanner.siblings().each(function (index, item) {
                    setTimeout(function() {
                        $(item).removeClass('flyout');
                    }, index * 40);
                });
                $clickedBanner.siblings().find('> .js-nav-mobile-sublink').removeAttr('tabindex');
                $clickedBanner.siblings().find('> .js-mobile-nav-next-lvl').removeAttr('tabindex');
                $backPanel.find('> .js-nav-layer-back').removeAttr('tabindex');
                $clickedBanner.find('button').removeAttr('tabindex').focus();
                $clickedBanner.removeClass('js-clicked').removeClass('flyout');
            } else {
                $closestList.find('.js-mobile-flyin').removeAttr('tabindex');

                $closestListItem.each(function (index, item) {
                    setTimeout(function() {
                        $(item).removeClass('flyout');
                    }, index * 40);
                });

                if ($additionalLinks.length) {
                    $additionalLinks.find('li a').removeAttr('tabindex');
                }
            }

        }).attr('aria-hidden', 'true');

        $parent.parents(navMobileLayerClass).addClass('js-visible');

        gradientScrollCheck(navMobileLayerClass, scrollableMobClass);

        setTimeout(() => {
            if (!$('.js-nav-item.flyin.flyout').length) {
                $('.js-nav-item.flyin:first').find('button').focus();
            } else {
                $('.js-nav-layer-back').focus();
            }
        }, 750);
    });
}

//check if gradient needs to be shown
function gradientScrollCheck(parentEl, scrollableElement) {
    $(parentEl).each(function () {
        if ($(this).hasClass('visible')) {
            const $visibleLayer = $(this);
            const $scrollableEl = $visibleLayer.find(scrollableElement);
            const $innerEl = $scrollableEl.find('> ul');
            const scrollableElTopPos = $scrollableEl.offset().top;
            const scrollableElTopPosCorrected = scrollableElTopPos - 5;
            const innerElTopPos = $innerEl.offset().top;

            if (innerElTopPos < scrollableElTopPosCorrected) {
                $visibleLayer.addClass('top-gradient');
            } else {
                $visibleLayer.removeClass('top-gradient');
            }

            const scrollableElHeight = $scrollableEl.outerHeight();
            const scrollableElBottomPos = scrollableElTopPos + scrollableElHeight + 10;
            const innerElHeight = $innerEl[0].scrollHeight;
            const innerElBottomPos = innerElHeight + innerElTopPos;

            if (innerElBottomPos > scrollableElBottomPos) {
                $visibleLayer.addClass('bottom-gradient');
            } else {
                $visibleLayer.removeClass('bottom-gradient');
            }
        }
    });
}

//check if content banner should be sticky
function stickyContentBanner(parentElement, scrollableEl) {
    $(document).find(parentElement).each(function () {
        const $visibleLayer = $(this);
        const $scrollableEl = $visibleLayer.find(scrollableEl);
        const $innerEl = $scrollableEl.find('> ul');
        const scrollableElTopPos = $scrollableEl.offset().top;
        const innerElTopPos = $innerEl.offset().top;
        const scrollableElHeight = $scrollableEl.outerHeight();
        const scrollableElBottomPos = scrollableElTopPos + scrollableElHeight - 26;
        const innerElHeight = $innerEl[0].scrollHeight;
        const innerElBottomPos = innerElHeight + innerElTopPos;
        const $visibleBanner = $visibleLayer.find('.js-navigation-content-banner');
        const visibleBannerHeight = $visibleBanner.outerHeight();

        if ($visibleBanner.length && innerElBottomPos < scrollableElBottomPos && $visibleLayer.hasClass('visible')) {
            $visibleLayer.addClass('sticky-content-banner');
            if (visibleBannerHeight > 116) {
                $innerEl.css('padding-bottom', visibleBannerHeight);
            } else {
                $innerEl.css('padding-bottom', '');
            }
        } else if ($visibleBanner.length && innerElBottomPos > scrollableElBottomPos && $visibleLayer.hasClass('visible')) {
            $visibleLayer.removeClass('sticky-content-banner');
            $innerEl.css('padding-bottom', '');
        }
    });
}

function mobileAccessibility() {
    $hamburgerBtn.on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            if ($('.js-header-actions').hasClass('search-expand')) {
                $('.js-search-input-toggle').focus();
            } else {
                $('.js-header-actions').find('li:last-child a').focus();
            }
        }
    });

    $('.js-open-minicart').on('keydown', function (e) {
        if ($('.js-navigation-inner').hasClass('active')) {
            if (e.which == 9 && !e.shiftKey) {
                e.preventDefault();
                $hamburgerBtn.focus();
            }
        }
    });

    $('.js-nav-layer-back').on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $hamburgerBtn.focus();
        }
    });

    $navMobile.find('li:last-child').find('> a').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            if ($(this).closest('ul').siblings(navMobileAdditionalClass).length) {
                $(navMobileAdditionalClass).find('li').first().find('a').focus();
            } else {
                $('.js-search-input-field').focus();
            }
        }
    });
}

//open first desktop nav layer
function desktopOpenNav() {
    $navDesktopMainlink.off('click');
    $navDesktopMainlink.on('click', function () {
        const $this = $(this);
        const closedNavigation = !$navDesktopMainlink.hasClass('selected');
        const $activeDropdown = $this.siblings(navDesktopLayerClass);
        const otherDropdown = $this.parent().siblings('.js-desktop-nav-item').find(navDesktopLayerClass);

        if (!$navDesktop.hasClass('copied-links')) {
            $navDesktop.addClass('copied-links');
            appendContentLinkPanel();
        }

        if (!$this.hasClass('selected')) {
            if (closedNavigation) {
                $this.addClass('selected');
                $navDesktop.addClass('active');
                $(navDesktopOverlay).fadeIn();
                $('body').css('overflow', 'hidden');

                $activeDropdown.stop().fadeIn(50, function () {
                    $activeDropdown.addClass('visible');
                    setTimeout(function() {
                        const $closestNavItem = $activeDropdown.find(navMobileSublinkClass);
                        $closestNavItem.each(function (index, item) {
                            setTimeout(function() {
                                $(item).addClass('flyin');
                            }, index * 40);
                        });
                        $activeDropdown.find(navDesktopCloseBtnClass).stop().fadeIn(1000);
                    }, 600);
                    setTimeout(function() {
                        $activeDropdown.addClass('opened');
                    }, 800);
                    gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);
                });
            } else {
                $navDesktopMainlink.removeClass('selected');
                $this.addClass('selected');

                otherDropdown.hide().removeClass('visible').removeClass('opened');
                otherDropdown.find(navMobileSublinkClass).removeClass('flyin');
                otherDropdown.find(navDesktopCloseBtnClass).hide();
                otherDropdown.find(navDesktopOverlay).hide();

                $activeDropdown.show().addClass('visible').addClass('opened');
                $activeDropdown.find(navDesktopCloseBtnClass).show();
                $activeDropdown.find(navDesktopOverlay).show();

                setTimeout(function() {
                    const $closestNavItem = $activeDropdown.find(navMobileSublinkClass);
                    $closestNavItem.each(function (index, item) {
                        setTimeout(function() {
                            $(item).addClass('flyin');
                        }, index * 40);
                    });
                }, 400);
                gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);

                $(navDesktopSecLayerClass).each(function () {
                    const $secondLayer = $(this);
                    if ($secondLayer.hasClass('opened')) {
                        $secondLayer.hide();
                        $(navDesktopFirstLayerClass).removeClass('first-opening');
                        $secondLayer.removeClass('slide-in').removeClass('opened').removeClass('visible');
                        $secondLayer.find(navDesktopScrollableParentClass).removeClass('visible');
                        $secondLayer.find(navDesktopCloseSubnavClass).hide();
                        $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
                        $secondLayer.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
                    }
                });
            }
        }
    });
}

//show second desktop layer
function desktopSubnavInit() {
    $('.js-nav-desktop-subbutton').on('click', function () {
        desktopOpenLayers($(this));
    });

    $('.js-nav-desktop-sublink').on('mouseenter', function () {
        desktopOpenLayers($(this));
    });

    $('.js-nav-mobile-sublink').each(function () {
        const $this = $(this);
        if (!$this.hasClass('js-nav-desktop-subbutton') && !$this.hasClass('js-nav-desktop-sublink')) {
            $this.on('click mouseenter', function () {
                desktopOpenLayers($this);
            });
        }
    });
}

function desktopOpenLayers(el) {
    const $this = el;
    if (!$this.hasClass('active')) {
        const $otherMainitems = $this.parent('.js-nav-mobile-subnav-item').siblings();

        if ($this.parent('.js-nav-mobile-subnav-item').find(navDesktopSecLayerClass).length) {
            $this.siblings(navDesktopSecLayerClass).find(navDesktopScrollableParentClass).addClass('visible');

            damHelper.updateImages($this.parent().find('.js-nav-responsive-bg').parent(), true);

            if (!$otherMainitems.find(navMobileSublinkClass).hasClass('active')) {
                $this.parents(navDesktopFirstLayerClass).addClass('first-opening');
                $this.siblings(navDesktopSecLayerClass).stop().fadeIn(10, function () {
                    const $activeLayer = $(this);

                    $activeLayer.addClass('slide-in');
                    setTimeout(function () {
                        $activeLayer.find(navDesktopCloseSubnavClass).fadeIn(300);
                        $activeLayer.addClass('opened');

                        $activeLayer.find('.js-nav-desktop-sublink-flyin').each(function (index, item) {
                            setTimeout(function() {
                                $(item).addClass('flyin');
                            }, index * 40);
                        });
                    }, 1000);

                    gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                    stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                });
            } else {
                $this.parents(navDesktopFirstLayerClass).removeClass('first-opening');
                $otherMainitems.find(navMobileSublinkClass).removeClass('active');
                $otherMainitems.find(navDesktopSecLayerClass).hide().removeClass('visible').removeClass('slide-in').removeClass('opened');
                $otherMainitems.find(navDesktopScrollableParentClass).removeClass('visible');
                $otherMainitems.find(navDesktopCloseSubnavClass).hide();
                $otherMainitems.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
                $this.siblings(navDesktopSecLayerClass).show().addClass('visible').addClass('opened');
                $this.siblings(navDesktopSecLayerClass).find(navDesktopCloseSubnavClass).show();
                gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
                stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);

                setTimeout(function() {
                    $this.siblings(navDesktopSecLayerClass).find('.js-nav-desktop-sublink-flyin').each(function (index, item) {
                        setTimeout(function() {
                            $(item).addClass('flyin');
                        }, index * 40);
                    });
                }, 100);
            }

            $this.addClass('active');
        } else {
            if ($otherMainitems.find(navMobileSublinkClass).hasClass('active')) {
                el.parents(navDesktopFirstLayerClass).find(navDesktopCloseBtnClass).fadeIn(300);
                el.parents(navDesktopFirstLayerClass).removeClass('first-opening');
                $otherMainitems.find(navMobileSublinkClass).removeClass('active');
                $otherMainitems.find(navDesktopSecLayerClass).hide().removeClass('visible').removeClass('slide-in').removeClass('opened');
                $otherMainitems.find(navDesktopScrollableParentClass).removeClass('visible');
                $otherMainitems.find(navDesktopCloseSubnavClass).hide();
                $otherMainitems.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
            }
        }
    }
}

//close desktop navigation
function desktopCloseNav() {
    $(navDesktopCloseBtnClass).on('click', function () {
        closeDesktopNavigation();
    });

    $(document).on('click', navDesktopCloseSubnavClass, function () {
        closeDesktopSubnavigation($(this));
    });

    $(document).on('keydown', function(e){
        if (e.which == 27 && $navDesktop.hasClass('active')) {
            closeDesktopNavigation();
        }
    });
}

function closeDesktopNavigation() {
    $(navDesktopOverlay).fadeOut();
    $navDesktopMainlink.removeClass('selected').addClass('disabled');
    $(navDesktopCloseBtnClass).hide();
    $(navDesktopLayerClass).removeClass('visible');
    $navDesktop.removeClass('active');
    scrollHelper.enableScroll();

    $(navDesktopSecLayerClass).each(function () {
        const $secondLayer = $(this);
        if ($secondLayer.hasClass('opened')) {
            $secondLayer.parents(navDesktopFirstLayerClass).addClass('first-opening');
            $secondLayer.removeClass('slide-in').removeClass('opened').removeClass('visible');
            $secondLayer.find(navDesktopScrollableParentClass).removeClass('visible');
            $secondLayer.find(navDesktopCloseSubnavClass).hide();
            $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
        }
    });

    setTimeout(function () {
        $navDesktopOpenLayer.removeClass('flyin');
        $(navDesktopLayerClass).stop().fadeOut(function () {
            $navDesktopMainlink.removeClass('disabled');
            $(navDesktopLayerClass).removeClass('opened');
            $(navDesktopSecLayerClass).hide();
            $(navDesktopFirstLayerClass).removeClass('first-opening');
        });
    }, 1000);
}

function closeDesktopSubnavigation(elem) {
    const $this = elem;
    const $firstLayer = $this.parents(navDesktopFirstLayerClass);
    const $secondLayer = $this.parents(navDesktopSecLayerClass);

    $firstLayer.addClass('first-opening');
    $this.hide();
    $this.parents(navDesktopScrollableParentClass).removeClass('visible');
    $secondLayer.removeClass('visible').removeClass('slide-in');
    $secondLayer.siblings(navMobileSublinkClass).removeClass('active');
    $secondLayer.find('.js-nav-desktop-sublink-flyin').removeClass('flyin');
    $firstLayer.find(navMobileSublinkClass).addClass('disabled');
    setTimeout(function () {
        $firstLayer.find(navDesktopCloseBtnClass).fadeIn(400);
    }, 200);
    setTimeout(function () {
        $secondLayer.hide();
        $this.parents('.js-desktop-nav-item').find(navDesktopSecLayerClass).removeClass('opened');
        $firstLayer.removeClass('first-opening');
        $firstLayer.find(navMobileSublinkClass).removeClass('disabled');
    }, 1000);
}

function desktopAccessibility() {
    $navDesktopMainlink.on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey && $navDesktop.hasClass('active') && $(this).parent().is(':last-child') && !$(this).hasClass('selected')) {
            e.preventDefault();
            $(this).parent().siblings('.js-desktop-nav-item:first-child').find('.js-nav-desktop-item-link').focus();
        } else if (e.which == 9 && e.shiftKey && $navDesktop.hasClass('active') && $(this).parent().is(':first-child')) {
            e.preventDefault();
            $(this).parent().siblings('.js-desktop-nav-item:last-child').find('.js-nav-desktop-item-link').focus();
        }
    });

    $(navDesktopCloseBtnClass).on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey && $(this).parents('.js-desktop-nav-item').is(':last-child')) {
            e.preventDefault();
            $(this).parents('.js-desktop-nav-item').siblings('.js-desktop-nav-item:first-child').find('.js-nav-desktop-item-link').focus();
        }
    });

    $('.js-nav-desktop-sublink').on('keydown', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            desktopOpenLayers($(this));
        }
    });

    $('.js-desktop-scrollable-subcontainer').find('li:last-child .js-nav-desktop-tab').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $(this).parents(navDesktopScrollableParentClass).find(navDesktopCloseSubnavClass).focus();
        }
    });

    $(navDesktopCloseSubnavClass).on('keydown', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(this).siblings('.js-desktop-scrollable-subcontainer').find('li:last-child .js-nav-desktop-tab').focus();
        }
    });
}

function navContentBanner() {
    $('.js-navigation-banner-simple').find('button').on('click', function () {
        if ($navDesktop.hasClass('active')) {
            $navDesktop.find('.js-nav-collection-button').click();
        } else {
            const $banner = $(this);
            const $parent = $banner.closest('li');
            const $collectionPanel = $navMobile.find('.js-nav-collection-button').siblings(navMobileLayerClass);

            $parent.addClass('flyout').addClass('js-clicked');
            $parent.siblings().addClass('flyout');
            $banner.attr('tabindex', '-1');
            $banner.closest('.js-mob-scrollable-container').siblings('.js-nav-layer-back').attr('tabindex', '-1');
            $parent.siblings().find('.js-mobile-flyin').attr('tabindex', '-1');
            $parent.siblings().find('> .js-nav-mobile-sublink').attr('tabindex', '-1');
            $parent.siblings().find('> .js-mobile-nav-next-lvl').attr('tabindex', '-1');
            $(navMobileLayerClass).removeClass('js-visible');

            damHelper.updateImages($collectionPanel.parent().find('.js-nav-responsive-bg').parent());

            $collectionPanel.addClass('visible').addClass('js-visible').attr('aria-hidden', 'false').fadeIn('fast', function () {
                const $visibleLayer = $(this);
                const $closestChild = $visibleLayer.find('ul').first().find('> li');

                $closestChild.each(function (index, item) {
                    setTimeout(function() {
                        $(item).addClass('flyin');
                    }, index * 40);
                });

                gradientScrollCheck(navMobileLayerClass, scrollableMobClass);
            });
        }
    });
}

function appendContentLinkPanel() {
    $navDesktop.find('.js-nav-link-to-be-copied').each(function () {
        const $this = $(this);
        const $link = $this.parent('.js-nav-mobile-sublink');
        const linkText = $this.text();
        const linkHref = $link.attr('href');
        const placeholderText = $('.js-nav-content-links-placeholder').html();

        $link.parent().append(placeholderText);
        $link.siblings('.js-nav-desktop-second-layer').find('.js-nav-content-link-copied').text(linkText);
        $link.siblings('.js-nav-desktop-second-layer').find('.js-nav-content-link-copied').parents('.js-nav-desktop-tab').attr('href', linkHref);
    });
}

function onClickNavToMain() {
    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: '',
        },
        paragraphs: [
            {
                text: window.Resources.MODAL_LEAVE_CONFIRMATION_BODY
            }
        ],
        ctaHolder: {},
        buttons: [
            {
                type: 'btn',
                label: window.Resources.MODAL_LEAVE_CONFIRMATION_BUTTON_NO,
                eventName: 'onPrimaryButtonClick',
                shouldCloseModal: true
            }, {
                type: 'btn',
                label: window.Resources.MODAL_LEAVE_CONFIRMATION_BUTTON_YES,
                eventName: 'shouldProceed',
                shouldCloseModal: true
            }
        ],
        closeElement: {
            eventName: 'onCloseElementClick',
            shouldCloseModal: true
        },
        modalLarge: true,
        centerOnMobile: true
    });
}

function initializeEvents() {
    toggleMobileNav();
    toggleMobileNavLayers();
    mobileAccessibility();
    desktopOpenNav();
    desktopSubnavInit();
    desktopCloseNav();
    desktopAccessibility();
    navContentBanner();
    navigationScroller.init();

    $('.js-desktop-scrollable-container').on('scroll', function () {
        gradientScrollCheck(navDesktopLayerClass, scrollableDesktopClass);
    });

    $('.js-desktop-scrollable-subcontainer').on('scroll', function () {
        gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
    });

    $(window).on('resize', function () {
        gradientScrollCheck(navDesktopScrollableParentClass, scrollableDesktopSubnav);
        stickyContentBanner(navDesktopScrollableParentClass, scrollableDesktopSubnav);
    });

    $(document).on('click', '.js-nav-desktop-subpanel-narow', function(e) {
        const $this = $(this);
        const url = $this.children('a')[0].href;
        const urlParts = url.split('#');
        if (urlParts[1]){
            e.stopPropagation();
            closeMobileNavigation();
            closeDesktopNavigation();
            const $productGridBlock = $('.js-product-grid-block');
            const collection = document.querySelector('[data-anchor-id=' + urlParts[1] + ']');
            if ($productGridBlock && collection){
                productFilter.changeTab(collection);
                $('html, body').animate({scrollTop: $productGridBlock.offset().top}, 800);
            }
        }
    });

    initNavigationToMainSite();
}

function initNavigationToMainSite() {
    if ($(navigateToMainSite).length > 0) {
        const navigateToMainSiteCTAs = $(navigateToMainSite); // CTA can exist in header and minicart
        let url = null;

        navigateToMainSiteCTAs.each(function(index, item) {
            const el = $(item);
            url = url || el.data('url');
            el.off('click').on('click', onClickNavToMain);
        });

        window.eventBus.$on('shouldProceed', function() {
            location.href = url || '/';
        });
    }
}

function updateNavigationLinksOnAddToCart(cartIsEmpty) {
    const $subNavItemsByCart = $('a.js-navigation-redirectbycart');
    if ($subNavItemsByCart.length > 0) {
        for (let index = 0; index < $subNavItemsByCart.length; index++) {
            const aItem = $subNavItemsByCart[index];
            const currentUrl = cartIsEmpty ? $(aItem).data('redirecturl') : $(aItem).data('originalurl');
            aItem.setAttribute('href', currentUrl);
        }
    }
}

const headerNavigation = {
    init: function() {
        initializeEvents();
    },
    initNavigationToMainSite: initNavigationToMainSite,
    updateNavigationLinksOnAddToCart: updateNavigationLinksOnAddToCart
};

module.exports = headerNavigation;

},{"./dam/dam-helper":419,"./modules/helpers/debounce":458,"./modules/helpers/scroll":475,"./navigationScroller":516,"./product-filter":577}],516:[function(require,module,exports){
'use strict';

let scrollStartedY = 0;
let scrollCurrentY = 0;
let scrollDelta = 0;
let isScrollingUp = false;
let isMouseWheel = false;
let isTouch = false;
let isTicking = false;

const bodyEl = document.querySelector('body');
const navEl = document.querySelector('.js-header');
const navActionsEl = document.querySelector('.js-header-actions');
const navVisibleBodyClass = 'nav-visible';
const navHiddenBodyClass = 'nav-hidden';
const hideCssClass = 'nav-hide';
const hideThresholdScroll = 10;
const hideThresholdTouch = 15;

const animateNav = () => {
    const hasHideClass = navEl.classList.contains(hideCssClass);
    const hasSearchExpanded = navActionsEl.classList.contains('search-expand');
    const hideThreshold = isTouch ? hideThresholdTouch : hideThresholdScroll;
    const isOverThreshold = scrollDelta > hideThreshold;
    const bodyStyle = window.getComputedStyle(bodyEl);
    const isWindowScrolledToTop = document.documentElement.scrollTop === 0;

    // Check if the overflow property of body is set to hidden
    const overflowHidden = bodyStyle.overflow === 'hidden';

    if (isScrollingUp && hasHideClass && isOverThreshold && !overflowHidden) {
        bodyEl.classList.remove(navHiddenBodyClass);
        bodyEl.classList.add(navVisibleBodyClass);
        navEl.classList.remove(hideCssClass);
    }

    if (!isScrollingUp && !hasHideClass && isOverThreshold && !hasSearchExpanded && !overflowHidden) {
        bodyEl.classList.remove(navVisibleBodyClass);
        bodyEl.classList.add(navHiddenBodyClass);
        navEl.classList.add(hideCssClass);
    }

    if (isScrollingUp && isWindowScrolledToTop && hasHideClass) {
        bodyEl.classList.remove(navHiddenBodyClass);
        bodyEl.classList.add(navVisibleBodyClass);
        navEl.classList.remove(hideCssClass);
    }
};

function mobileCheckOnLongScroll() {
    if (document.documentElement.scrollTop === 0) {
        setTimeout(function(){
            bodyEl.classList.remove(navHiddenBodyClass);
            bodyEl.classList.add(navVisibleBodyClass);
            navEl.classList.remove(hideCssClass);
        }, 250);
    }
}

const onMouseDown = () => {
    isMouseWheel = false;
    scrollStartedY = window.scrollY;
};

const onScroll = () => {
    if (!isMouseWheel) {
        isScrollingUp = window.scrollY < scrollCurrentY;
        scrollDelta = Math.abs(scrollStartedY - window.scrollY);
        scrollCurrentY = window.scrollY;

        if (!isTicking) {
            window.requestAnimationFrame(() => {
                animateNav(scrollDelta, isScrollingUp);
                isTicking = false;
            });

            isTicking = true;
        }
    }
};

const onWheel = (e) => {
    isMouseWheel = true;
    isScrollingUp = e.wheelDelta > 0;
    scrollDelta = Math.abs(e.wheelDelta);
    animateNav(scrollDelta, isScrollingUp);
};

const onTouchStart = () => {
    isTouch = true;
    onMouseDown();
};

const onTouchEnd = () => {
    isTouch = false;
};

const debounce = (func, delay) => {
    let timer;
    return function () {
        clearTimeout(timer);
        timer = setTimeout(func, delay);
    };
};

const debouncedOnScroll = debounce(onScroll, 50);

const initScroll = () => {
    if (navEl && navActionsEl) {
        document.addEventListener('touchstart', onTouchStart);
        document.addEventListener('touchend', onTouchEnd);
        document.addEventListener('touchmove', debouncedOnScroll);
        document.addEventListener('mousedown', onMouseDown);
        document.addEventListener('scroll', () => {
            debouncedOnScroll();
            mobileCheckOnLongScroll();
        });
        document.addEventListener('wheel', onWheel);
    }
};

const navigationScroller = {
    init: () => {
        initScroll();
    }
};

module.exports = navigationScroller;

},{}],517:[function(require,module,exports){
'use strict';

const _ = require('lodash'),
    ajax = require('./modules/ajax'),
    ritualsFormHelper = require('./rituals-form-helper'),
    recaptchaConfig = require('./recaptchaConfig');

    const elements = {
    newsletterSubscribeForm: $('.newsletter-subscribe-form'),
    stores: []
};
const gtm = require('./modules/google').tagManager;
const Resources = window.Resources || {};

exports.init = function () {
    getStoreData(function (data) {
        if (!!data && data !== null) {
            _.each(data, function(store){
                const item = {};
                item['value'] = store.name;
                item['ID'] = store.ID;
                item['label'] = store.name;
                item['storeNumber'] = store.storeNumber;
                elements.stores.push(item);
            });
        }
        $('input[id$="_favoriteStoreSearch"]').autocomplete({
            source: elements.stores,
            minLength: 3, // min char count to show suggestions
            select: function (event, ui) {
                AutoCompleteSelectHandler(event, ui);
            }
        }).bind('keyup', function(){
            $('input[id$="_favoriteStoreID"]').val('');
            $(this).autocomplete('search');
        });
    });

    ritualsFormHelper.init();
    recaptchaConfig.defaultInitializationForFormById('newsletterSubscriptionForm');
};

const AutoCompleteSelectHandler = function (event, ui){
    const selectedObj = ui.item;
    $('input[id$="_favoriteStoreID"]').val(selectedObj.storeNumber);
};

const getStoreData = function (callback) {
    // load store name and id
    ajax.getJson({
        url: Urls.getStoresBasicData,
        dataType: 'json',
        callback: callback
    });
};

$(document).on('click', '.newsletter-submit', function () {
    const email = $('input.email').val();
    const regex =
        /^((")("[^"]+?"@)|(([0-9a-zA-Z_]((\.(?!\.))|[-!#\$%&'\*\+\/=\?\^`\{\}\|~\w])*)(?:[0-9a-zA-Z_-])@))((\[)(\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-zA-Z][-0-9a-zA-Z]*[0-9a-zA-Z]*\.)+[a-zA-Z0-9]{2,17}))$/;
    const isValid = regex.test(email.trim());
    const errorMessage = !email ? Resources.VALIDATE_REQUIRED : !isValid ? Resources.VALIDATE_EMAIL : null;
    if (errorMessage) {
        gtm.pushDataLayerEvent({
            event: 'form_field_error',
            error_type: 'form_field_error',
            error_message: errorMessage,
            error_code: null,
            content_name: 'newsletter subscription'
        });
    }
});

},{"./modules/ajax":449,"./modules/google":453,"./recaptchaConfig":587,"./rituals-form-helper":590,"lodash":208}],518:[function(require,module,exports){
'use strict';

const getQueryStringParams = require('./modules/util/getQueryStringParams');

const page = {
    title: '',
    type: '',
    params: getQueryStringParams(window.location.search.substr(1)),
    redirect: function (newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function () {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./modules/util/getQueryStringParams":492}],519:[function(require,module,exports){
'use strict';

const ajax = require('../modules/ajax'),
    isSmallView = require('../modules/helpers/isSmallView'),
    scrollHelper = require('../modules/helpers/scroll'),
    giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    appendParamsToUrl = require('../modules/util/appendParamsToUrl'),
    setDeleteConfirmation = require('../modules/util/setDeleteConfirmation'),
    getScreenBreakpointSize = require('../modules/util/getScreenBreakpointSize'),
    getQueryParameter = require('../modules/util/getQueryParameter'),
    flyout = require('../flyout'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    validator = require('../validator'),
    registration = require('./registration'),
    prefillAddress = require('../prefill-address'),
    google = require('../modules/google'),
    productTile = require('../product-tile'),
    ritualsStyles = require('../rituals-styles'),
    ritualsFormHelper = require('../rituals-form-helper'),
    customSelect = require('../select-custom'),
    customerbarcode = require('./customerbarcode'),
    damHelper = require('../dam/dam-helper'),
    orderHistory = require('./order-history');

/**
* @function
* @description Initializes the events on the address form (apply, cancel, delete)
* @param {Element} form The form which will be initialized
*/
function initializeAddressForm() {
    const $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();
    validator.init();

    // custom validation rule for state based on zip code for US
    const country = $('[id$=_country]').val();
    if (country === 'US') {
        // set state based on given postal code
        $('[id$=_postal]').on('blur keydown', google.places.setStateFromPostalCode);
        customSelect.init();
        google.places.setStateIDDataForPostalCode();
    }

    $form.on('click', '.js-apply-button', function (e) {
        e.preventDefault();
        $(this).prop('disabled', true);

        if (!$form.valid()) {
            return false;
        }

        const url = appendParamToURL($form.attr('action'), 'format', 'ajax');
        const applyName = $form.find('.js-apply-button').attr('name');
        const options = {
            url: url,
            data: $form.serialize() + '&' + applyName + '=x',
            type: 'POST'
        };

        $.ajax(options).done(function (data) {
            if (typeof(data) !== 'string') {
                if (data.success) {
                    flyout.closeFlyouts();
                    $('.js-account-menu-item').removeClass('active');
                    getAccountPage(Urls.accountOverview);
                } else if (data.error) {
                    page.redirect(Urls.csrffailed);
                } else {
                    $('.js-address_error').val(data.message);
                    $('.js-address_error').show();
                    return false;
                }
            } else {
                $('#dialog-container').html(data);
                account.init();
                tooltip.init();
            }
        });
    })

        .on('click', '.cancel-button, .close-button', function (e) {
            e.preventDefault();
            flyout.closeFlyouts();
        })

        .on('click', '.delete-button', function (e) {
            e.preventDefault();
            if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
                const url = appendParamsToUrl(Urls.deleteAddress, {
                    AddressID: $form.find('#addressid').val(),
                    format: 'ajax'
                });
                $.ajax({
                    url: url,
                    method: 'POST',
                    dataType: 'json'
                }).done(function (data) {
                    if (data.status.toLowerCase() === 'ok') {
                        flyout.closeFlyouts();
                        page.refresh();
                    } else if (data.message.length > 0) {
                        $('.js-address_error').val(data.message);
                        $('.js-address_error').show();
                        return false;
                    } else {
                        flyout.closeFlyouts();
                        page.refresh();
                    }
                });
            }
        });

    initAddressSpecificFields();
}

function initAddressSpecificFields() {
    const country = $('[id$=_country]').val();
    if (country.toLowerCase() !== 'hk') {
        return;
    }

    const preselectedValues = {
        city: $('input[name="preselected-city"]').val(),
        district: $('input[name="preselected-district"]').val(),
        subdistrict: $('input[name="preselected-subdistrict"]').val()
    };

    const $townCityDropDownProfile = $('#dwfrm_profile_address_city');
    const $districtDropDownProfile = $('#dwfrm_profile_address_district');
    const $subdistrictDropDownProfile = $('#dwfrm_profile_address_subdistrict');

    if ($townCityDropDownProfile && $districtDropDownProfile && $subdistrictDropDownProfile) {
        ritualsFormHelper.initTownDistrictFields($townCityDropDownProfile, $districtDropDownProfile, $subdistrictDropDownProfile, preselectedValues);
    }
}

/**
* @private
* @function
* @description Toggles the list of Orders
*/
function toggleFullOrder () {
    function toggleOrder(element) {
        const $orderBlock = $(element);
        const $detailsEl = $orderBlock.find('.js-order-details-dropdown');

        if ($detailsEl.is(':hidden')) {
            $orderBlock.addClass('active');
            $detailsEl.slideDown('slow');
            damHelper.updateImages($detailsEl);
        } else {
            $orderBlock.removeClass('active');
            $detailsEl.slideUp('slow');
        }
    }

    $('body').on('click','.js-order-block', function(){
        toggleOrder(this);
    });

    $('body').on('keydown','.js-order-block', function(event) {
        if (event.which == 13 || event.which == 32) {
            toggleOrder(this);
        }
    });

    $('body').on('click', '.js-order-details-dropdown',function(e){
        e.stopPropagation();
    });
}
/**
* @private
* @function
* @description Binds the events on the address form (edit, create, delete)
*/
function initAddressEvents() {
    $(document).on('click', '.js-address-edit', function (e) {
        e.preventDefault();
        const $addressActions = $(this).parent();

        const countryCode = $addressActions.data('country-code');
        const addressCountryCode = $addressActions.data('address-country-code');

        if (countryCode && countryCode != addressCountryCode) {
            $('html, body').scrollTop(0);

            $.ajax({
                url: Urls.addressEditGetCountrySelector,
                data: {addressCountryCode},
                type: 'POST',
                success: function(response) {
                    $('.js-country-selector-wrapper').html(response);
                    showAccountLocaleSelectDialog();
                }
            });
        } else {
            $(this).addClass('js-triggered-flyout');
            initAddressFlyout(this.href);
        }
    }).on('click', '.js-address-create', function(e) {
        e.preventDefault();
        $(this).addClass('js-triggered-flyout');
        initAddressFlyout(this.href);
    }).on('click', '.js-address-delete', function (e) {
        e.preventDefault();

        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            $.ajax({
                url: appendParamToURL($(this).attr('href'), 'format', 'ajax'),
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    page.redirect(Urls.addressesList);
                } else if (data.message.length > 0) {
                    $('.js-address_error').val(data.message);
                    $('.js-address_error').show();
                    return false;
                } else {
                    page.refresh();
                }
            });
        }
    });
}

/**
 * @private
 * @function
 * @description Opens country siwtch dialog when user tries to edit address from other
 * locale then the current one
 */
function showAccountLocaleSelectDialog() {
    dialog.open({
        target: $('.js-country-select-dialog'),
        options: {
            modal: true,
            dialogClass:'country-selector-dialog account-country-dialog',
            minHeight: 0,
            position: {
                my: 'top',
                at: 'top+15%',
                of: window
            },

            open: function() {
                const countrySelectDialog = $('.js-country-select-dialog');
                const modalOverlay = $('.js-modal-overlay');

                modalOverlay.show();
                countrySelectDialog.addClass('open');

                scrollHelper.disableScroll();

                const title = $('.js-dialog-title').html();
                $('span.ui-dialog-title').append('<h3 class="title">' + title + '</h3>');
                $('span.ui-dialog-title').html(function(i,h){
                    return h.replace(/&nbsp;/g,'');
                });

                const popupLabelText = $('.js-close-popup-text').html();
                $('.ui-dialog-titlebar-close').attr('aria-label', popupLabelText);

                $(document).one('click', '.ui-dialog-titlebar-close, .ui-widget-overlay, .js-close-dialog, .js-modal-overlay', function(e) {
                    e.preventDefault();
                    countrySelectDialog.dialog('close').removeClass('open');
                    modalOverlay.hide();
                    scrollHelper.enableScroll();
                });

                $(document).one('click','.js-redirect-locale',function(e){
                    e.preventDefault();
                    const target = e.target;
                    const url = $(target).attr('href');
                    window.location.href = url;
                });

                $(document).on('keydown', function(e) {
                    if (e.which == 27 && countrySelectDialog.hasClass('open')){
                        countrySelectDialog.dialog('close').removeClass('open');
                        modalOverlay.hide();
                        scrollHelper.enableScroll();
                    }
                });
            },

            autoOpen: true
        }
    });
}

/**
 * @private
 * @function
 * @param {string} href: Url of content to load in flyout
 * @description Shows a flyin with address edit form loaded inside
 */
function initAddressFlyout(href) {
    flyout.load({
        url: href,
        open: function () {
            $('.js-generic-flyout').addClass('address-flyout js-address-flyout');

            const editAddressFlyoutClass = '.js-address-flyout';
            const editAddressFlyoutCloseClass = '.js-address-flyout-inner .js-close-flyout';
            const hasCloseButton = $(editAddressFlyoutCloseClass).length > 0;
            const $flyoutDropdown = $('.js-generic-flyout').find('.js-custom-select');

            if (!hasCloseButton) {
                $(editAddressFlyoutClass).find('.js-close-flyout').appendTo('.js-address-flyout-inner');
            }

            initializeAddressForm();
            google.places.init();
            ritualsStyles.initInputStyles();

            if ($flyoutDropdown.length) {
                customSelect.init();
                $flyoutDropdown.each(function () {
                    if (!$(this).parents('.selectric-js-custom-select').length) {
                        if (!isSmallView()) {
                            $(this).attr('tabindex', '-1');
                        }
                    }
                });
            }

            $('.js-account-address-list').find('input:not(.selectric-input ):first').focus();
            flyoutAccessibility();
        },
        close: function () {
            $(document).find('.js-triggered-flyout').focus().removeClass('js-triggered-flyout');
        }
    });
}

/**
* @private
* @function
* @description Binds the events of the payment methods list (delete card)
*/
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        flyout.load({
            url: $(e.target).attr('href'),
            open: function () {
                open: initializePaymentForm; /* eslint-disable-line */
            }
        });
    });

    const paymentList = $('.payment-list');
    if (paymentList.length === 0) {
        return;
    }

    setDeleteConfirmation(paymentList, String.format(Resources.CONFIRM_DELETE, Resources.TITLE_CREDITCARD));

    $('form[name="payment-remove"]').on('submit', function (e) {
        e.preventDefault();
        // override form submission in order to prevent refresh issues
        const button = $(this).find('.delete');
        $('<input/>').attr({
            type: 'hidden',
            name: button.attr('name'),
            value: button.attr('value') || 'delete card'
        }).appendTo($(this));
        const data = $(this).serialize();
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: data
        })
            .done(function () {
                page.redirect(Urls.paymentsList);
            });
    });
}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        flyout.closeFlyouts();
    });
}

/**
* @private
* @function
* @description Inits account menu click event handlers
*/
function initAccountMenu(){
    $('body').on('click', '.js-account-menu-item, .js-overview-item', function(e){
        e.preventDefault();

        let navigate = true;
        const shouldConfirm = $(this).data('confirmPageChange');

        if (shouldConfirm) {
            navigate = confirm(Resources.CONFIRM_LEAVE_REGISTRATION);
        }

        if (navigate){
            $(this).removeData('confirmPageChange');
            // remove active class from other items and add it to new one
            $('.js-account-menu-item').removeClass('active');
            $(this).addClass('active');

            const href = $(this).attr('href') || $(this).data('href');
            getAccountPage(href);

            const windowSize = $(window).width();
            const breakpointSize = getScreenBreakpointSize(windowSize);

            if (breakpointSize === 'small') {
                if ($(this).data('href')) {
                    //prevent scrolling content while opening a page from account overview panel
                    $('.js-page-content').addClass('no-scrolling');

                    const dataHref = $(this).data('href');
                    const $targetNavItem = $('.js-account-menu-item[href="' + dataHref + '"]');

                    $targetNavItem.addClass('active').click();
                }
            }
        }

        setTimeout(function () {
            ritualsStyles.initInputStyles();
        }, 400);
    });

    $('body').on('click', '.js-back-to-menu', function(){
        if ((breakpointSize === 'small') && (window.location.href !== Urls.accountOverview)) {
            $('.js-account-menu-item').removeClass('active');
            scrollToContent();
        }

        if ((window.location.href === Urls.accountOverview)) {
            scrollToContent();
        }
    });

    $('body').on('click', '.js-go-to-overview', function(e){
        e.preventDefault();
        $('.js-account-menu-item').removeClass('active');
        getAccountPage(Urls.accountOverview);
    });

    $('body').on('click', '.js-account-order-pages a', function(e){
        e.preventDefault();

        const href = $(this).attr('href');
        const $targetContainer = $('.js-content-wrapper');

        ajax.load({
            url: href,
            target: $targetContainer,
            callback: function() {
                // replaces the url in the address bar without pushing an entry to history,
                // useful when refreshing pages on mobile
                window.history.replaceState({},'', href);

                const headerHeight = $('.js-header').outerHeight() + 2;
                $('html, body').animate({scrollTop: $('body').offset().top + headerHeight}, 800);
            }
        });
    });

    // mobile only: if url is not for the account overview, take the user straight to the page they want
    const windowSize = $(window).width();
    const breakpointSize = getScreenBreakpointSize(windowSize);
    if ((breakpointSize === 'small') && (window.location.href !== Urls.accountOverview)) {
        scrollToContent();
    }
}

function initNewsletterEvents() {
    $('.js-newsletter_country_select').val($('#currentCountry').val());
    buildLocalesOptions();
    updateFlags();

    if ($('#countryChanged').val() == 'true') {
        const addressCountryCode = $('#currentCountry').val();
        const languageCode = $('#currentLanguage').val();
        const newsletterPage = true;
        if (!window.location.href.includes($('#currentCountry').val().toLowerCase())) {
            $('html, body').scrollTop(0);

            $.ajax({
                url: Urls.addressEditGetCountrySelector,
                data: {addressCountryCode, newsletterPage, languageCode},
                type: 'POST',
                success: function(response) {
                    $('.js-country-selector-wrapper').html(response);
                    showAccountLocaleSelectDialog();
                }
            });
        }
    }

    $('.js-newsletter_country_select').on('change', function () {
        const countryListValue = $('.js-newsletter_country_select').val();
        const currentCountry = $('#currentCountry').val();
        buildLocalesOptions();
        updateFlags();

        if (countryListValue.toLowerCase() === currentCountry.toLowerCase()) {
            $('.policyCheckbox').hide();
            $('.btn--submit').prop('disabled', false);
            return;
        }

        $('.policyCheckbox').show();
        $('#dwfrm_profile_newsletter_acceptedPolicy').prop('checked', false);
        $('.btn--submit').prop('disabled', true);
    });

    $('#dwfrm_profile_newsletter_acceptedPolicy').on('change', function () {
        if (this.checked) {
            $('.btn--submit').prop('disabled', false);
        } else {
            $('.btn--submit').prop('disabled', true);
        }
    });
}

function initNifEvents() {
    const $inputCheckbox = $('#RegistrationForm input[id$=addNifNumber]');
    const $fieldWrapper = $('#RegistrationForm').find('input[id$=nifNumber]').parent();
    const $inputNif = $('#RegistrationForm').find('input[id$=nifNumber]');

    if (!$inputCheckbox.length) {
        return;
    }

    if ($inputNif.val()) {
        $inputCheckbox.prop('checked', true);
        $fieldWrapper.css('display', 'block');
    } else {
        $inputCheckbox.prop('checked', false);
        $fieldWrapper.css('display', 'none');
    }

    $inputCheckbox.on('change', function() {
        if (!$(this).is(':checked')) {
            $fieldWrapper.css('display', 'none');
            return;
        }

        $fieldWrapper.css('display', 'block');
    });
}

function buildLocalesOptions(){
    const locales = $('.js-newsletter_country_select').find('option:selected').data('locales');
    const languageList = $('.js-newsletter_language_select');

    if (!locales) {
        return;
    }

    $('option', languageList).remove();
    locales.forEach((locale) => {
        const option = $('<option>')
            .attr('url', locale.url)
            .attr('label', locale.label)
            .attr('is-default', locale.isDefault)
            .val(locale.value)
            .text(locale.label);
        if (locale.isSelected) {
            option.attr('selected','selected');
        }

        languageList.append(option);
    });

    if (!languageList.find('option:selected')) {
        languageList.find('option[is-default=true]').attr('selected','selected');
    }
}

function updateFlags() {
    $('.js-newsletter_country_select').css({
        backgroundImage: 'url("' + $('.js-newsletter_country_select').find('option:selected').attr('flag') + '")'
    });
}

function flyoutAccessibility() {
    const addressFlyoutCloseClass = '.js-address-flyout .js-close-flyout';
    $(document).on('keydown', addressFlyoutCloseClass, function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-account-address-list').find('input').first().focus();
        } else if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $('.js-account-address-list .js-apply-button').focus();
        }
    });

    $(document).on('keydown', '.js-address-flyout input:first', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(addressFlyoutCloseClass).focus();
        }
    });
}

/**
* @private
* @function
* @description Loads with ajax the account page content
*/
function getAccountPage(href) {
    const $targetContainer = $('.js-content-wrapper');

    ajax.load({
        url: href,
        target: $targetContainer,
        callback:function(response){
            if (response.includes('loginajax.isml')){
                window.location.replace(Urls.getLoginPage);
            }

            const windowSize = $(window).width();
            const breakpointSize = getScreenBreakpointSize(windowSize);
            const $personalFormSelect = $('.js-account-form-personal').find('.js-custom-select');

            if (breakpointSize === 'small') {
                scrollToContent();
            } else {
                if ($personalFormSelect.length && !$personalFormSelect.parent('.selectric-hide-select').length) {
                    $personalFormSelect.selectric();
                    if (!isSmallView()) {
                        $personalFormSelect.attr('tabindex', '-1');
                    }
                }
            }

            // replaces the url in the address bar without pushing an entry to history,
            // useful when refreshing pages on mobile
            window.history.replaceState({},'', href);

            //(Re-)Initializes any forms that may be present in the newly-loaded page
            validator.init();

            ritualsFormHelper.initializeDataMask();

            if (href.includes('order-history')) {
                orderHistory.init();
            }

            if (href.includes('newsletter-subscriptions')) {
                initNewsletterEvents();
            }

            if (href.includes('edit-profile')) {
                initNifEvents();
            }

            //reinit the barcode image
            if ($('.js-member-barcode').length) {
                customerbarcode.init();
            }
        }
    });
}

/**
* @private
* @function
* @description Scrolls to the main content
*/
function scrollToContent(){
    const $footer = $('.js-footer');
    const $pageContent = $('.js-page-content');
    const $rightContent = $('.js-account-right-content');
    const rightSideActiveClass = 'right-content-active';

    if ($pageContent.hasClass(rightSideActiveClass) && !$pageContent.hasClass('no-scrolling')) { // go to menu view
        $footer.removeClass('fixed');
        $pageContent.removeClass(rightSideActiveClass);
        // go to top of the page
        window.scrollTo(0, 0);
        $pageContent.css({'left': '0'});

        // wait til css animation ends
        $pageContent.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
            if ($(e.target).is(this)){
                $rightContent.hide();
                $(this).removeClass(rightSideActiveClass);
                $(this).off('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
            }
        });
    } else if ($pageContent.hasClass('no-scrolling')) {
        $pageContent.removeClass('no-scrolling');
        ritualsStyles.initInputStyles();
    } else if (!$pageContent.hasClass('no-scrolling')) { // go to page content view
        $footer.addClass('fixed');
        if ($rightContent.length > 0) {
            $rightContent.show();

            // calc left position
            const contentLeftOffset = $rightContent.offset().left;
            $pageContent.css({'left': - contentLeftOffset});

            // wait til css animation ends
            $pageContent.on('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(e) {
                if ($(e.target).is(this)){
                    $(this).addClass(rightSideActiveClass);
                    $(this).off('webkitTransitionEnd transitionend msTransitionEnd oTransitionEnd');
                    showNewPasswordMessage();
                }
            });
        }
    }
}

function showNewPasswordMessage(){
    const welcomeBack = getQueryParameter(window.location.href, 'welcomeBack');

    if (welcomeBack) {
        $('.js-new-password-confirmation').addClass('open');
        $('.js-modal-overlay').fadeIn();
        $('.js-new-password-confirmation').find('.js-new-password-reset').focus();
        $('.js-new-password-confirmation').find('.js-new-password-close, .js-new-password-reset').attr('tabindex', '0');
    }
}

/**
* @private
* @function
* @description Binds the events of the order, address and payment pages
*/
function initializeEvents() {
    initAccountMenu();
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    initNewsletterEvents();
    initNifEvents();
    login.init();
    registration.init();
    const windowSize = $(window).width();

    if (windowSize > 767) {
        showNewPasswordMessage();
    }
}

const account = {
    init: function () {
        initializeEvents();
        giftcert.init();
        prefillAddress.init();
        customerbarcode.init();
        productTile.init();
        ritualsFormHelper.init();
        orderHistory.init();
    },
    initCartLogin: function () {
        login.init();
    }
};

module.exports = account;

},{"../dam/dam-helper":419,"../dialog":422,"../flyout":425,"../giftcert":430,"../login":443,"../modules/ajax":449,"../modules/google":453,"../modules/helpers/isSmallView":469,"../modules/helpers/scroll":475,"../modules/util/appendParamToURL":479,"../modules/util/appendParamsToUrl":480,"../modules/util/getQueryParameter":490,"../modules/util/getScreenBreakpointSize":493,"../modules/util/setDeleteConfirmation":508,"../page":518,"../prefill-address":575,"../product-tile":581,"../rituals-form-helper":590,"../rituals-styles":592,"../select-custom":596,"../tooltip":606,"../validator":607,"./customerbarcode":536,"./order-history":543,"./registration":563}],520:[function(require,module,exports){
'use strict';

const bonusProductsView = require('../bonus-products-view'),
    quantityBlock = require('./product/quantity-block'),
    storeMissingStockWarning = require('./checkout/storeMissingStockWarning'),
    taxFreeThresholdPassedWarning = require('./checkout/taxFreeThresholdPassedWarning'),
    cartStoreInventory = require('../storeinventory/cart'),
    page = require('../page'),
    giftwrap = require('../giftwrap'),
    productTile = require('../product-tile'),
    toaster = require('../toaster'),
    ajax = require('../modules/ajax'),
    validator = require('../validator'),
    isMobile = require('../modules/util/isMobile'),
    shipping = require('./checkout/shipping'),
    gtm = require('../modules/google').tagManager,
    isInViewport = require('../modules/helpers/isInViewport'),
    isSmallView = require('../modules/helpers/isSmallView'),
    dialog = require('../dialog'),
    pgCartUtils = require('./personalisedgifting/pgCartUtils'),
    ritualsFormHelper = require('../rituals-form-helper'),
    places = require('../modules/google').places,
    getCountryFromLocaleCookie = require('../modules/util/getCountryFromLocaleCookie'),
    isMobileOrTabletWidth = require('../modules/util/isMobileOrTabletWidth'),
    damHelper = require('../dam/dam-helper'),
    cartPostalCode = require('./cart/cartPostalCode');

/* To prevent multiple submissions of the form when removing a product from the cart */
let removeItemEvent = false;

/**
* @private
* @function
* @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
*/
function initializeEvents() {
    //initialize quantity buttons on cart page
    quantityBlock.init();

    $(document).on('click', '.js-edit-details', function (e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(e.target).closest('.js-cart-product-user-controls').find('.js-cart-product-variation-edit').toggleClass('open');

        if ($('.js-dangerousgoods-error').length) {
            $(e.target).closest('.js-cart-product-user-controls').siblings('.js-dangerousgoods-error').toggleClass('open');
        }
    });

    $(document).on('click', '.bonus-item-actions a.js-change-bonus-product', function (e) {
        e.preventDefault();

        const viewParameters = {
            url: $(this).data('href'),
            giftChange: true,
            response: null,
            isAddedPopup: $(this).data('showadded'),
            selectedID: String($(this).data('currently-selected'))
        };

        if ($(this).data('change-tiered-promotion')) {
            viewParameters.tieredDiscountId = $(this).closest('.js-bonus-product').find('.js-tiered-gwp-selection').data('discount-id');
        }

        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;

        gtm.pushGwpEvent('choose a different gift', giftName);
        bonusProductsView.show(viewParameters);
    });

    $(document).on('click', '.js-gwp-cart-banner-cta', function() {
        gtm.pushGwpEvent('continue shopping');
    });

    //listener to reset removeItemEvent when action is triggered on popup
    $(document).on('resetPopupDialog', function () {
        removeItemEvent = false;
    });

    $(document).on('keypress', '.js-coupon-input-field input', function (e) {
        if (e.which == 13) {
            e.preventDefault();

            $('.js-coupon-btn button').trigger('click');
        }
    });

    $(document).on('click', '.js-coupon-btn', addCoupon);

    $(document).on('submit', '#postalcode-form', searchByPostalCode);

    //TODO:
    //This is a temporary fix (no better solution for now) for bug [DL-10166].
    disablePostalCodeInputFieldValidationForMouseWithinButtonBorders();

    validator.init();

    // override enter key for coupon code entry
    $(document).on('keydown', 'form input[name$="_couponCode"]', function (e) {
        if (e.which === 13 && $(this).val().length === 0) {
            return false;
        }
    });

    $(document).on('click', 'button[name$="deleteProduct"]', function (e) {
        e.preventDefault();
        if (!removeItemEvent) {
            removeItemEvent = true;

            // initialize quantity block to get the delta quantity value
            quantityBlock.buildObj($($(this)
                .parents('.js-cart-row')
                .find('.js-quantity')));

            // post the event
            quantityBlock.removeFullQuantity();
        }
    });

    $(document).on('click', 'button[name$="deleteProductSet"]', function () {
        const pid = $(this).data('master-product-id');
        if (pid) {
            gtm.updateQuantity('cart', pid.toString(), null, null, null, 1, 'remove_from_cart');
        }
    });

    //DL-3889 Switch between tiered GWPs
    $(document).on('change', '.js-tiered-gwp-selection', function () {
        const uuid = $(this).data('discount-id');

        if (!uuid){
            return;
        }

        $.ajax({
            type: 'POST',
            url: Urls.selectTieredGWP,
            data: {
                'bonusDiscountLineItemUUID': uuid
            },
            success: function(){
                //Refresh the cart to update the view
                page.refresh();
            }
        });

        const giftLabelDiv = $(this).closest('.gift-label');
        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
        gtm.pushGwpEvent('choose one of the gifts', giftName);
    });

     //POC for changing product options in the cart TODO:
     $(document).on('click', '.js-option-change-btn', function(evt) {
        evt.preventDefault();
        const productId = $(this).data('product-id');
        const productLineUUID = $(this).data('line-item-uuid');
        const cartRow = $(this).closest('.js-cart-row');
        const optionValues = cartRow.find('.js-options-dropdown');

        const selectedOptions = {};
        optionValues.each(function(idx, elm){
            const $elm = $(elm);
            selectedOptions[$elm.data('option-id')] = $elm.val();
        });

        $.ajax({
            type: 'POST',
            url: Urls.POCCartChangeOptions,
            data: {
                productId: productId,
                productLineUUID: productLineUUID,
                options: JSON.stringify(selectedOptions)
            },
            success: function(){
                //Refresh the cart to update the view. Also takes care of recalculating the cart (happens on refresh)
                page.refresh();
            }
        });
    });

    // if there is a shipping exclusion open toaster
    if ($('.js-shipment-exclusion-toaster').length > 0 && isMobile()){
        toaster.open({
            target: $('.js-shipment-exclusion-toaster')
        });
    }


    // if there is a product quantity limit open toaster
    if ($('.js-product-quantity-limit-toaster').length > 0){
        toaster.open({
            target: $('.js-product-quantity-limit-toaster')
        });
    }

    $(document).on('click', '.js-delivery-postal-code-edit', function () {
        const $this = $(this);
        const $siblings = $this.parents('.js-delivery-postal-code').find('.js-delivery-postal-code-form');
        $this.parent().hide();
        $siblings.show();
        $('.js-delivery-usp-heading').removeClass('hide');
    });

    $(document).on('change', '.js-option-radio', function() {
        const page = 'cart_page';
        const $this = $(this);
        const defaultOption = $this.data('default-option');
        const shippingOptionId = $this.data('shipping-option-id');
        const shippingService = $this.data('shipping-service');
        const pickupPointCode = $this.data('service-point-code');

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, null, function() {
            shipping.updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updateOrderTotals(response.selectedShippingOption);
            }, defaultOption, null);
        });
    });

    $(document).on('change', '.js-service-point-postnummer-input', function(){
        const dHLPostNummer = $(this).val();
        setHiddenDHLPostNummer(dHLPostNummer);
    });

    $(document).on('click', '.js-cart-submit-btn', function(e){
        const $this = $(this);
        const $form = $this.closest('form');

        if (!isFakeSelectionValid()) {
            return false;
        }

        $('.js-service-point-postnummer-input-error').addClass('hide');
        const accountNumberInput = $('.js-service-point-postnummer-input');
        //if paazl distributor is DHL germany, service points are selected and accountnumber field exists, validate input first
        if ($('.js-pickup-option-radio').is(':checked') && accountNumberInput.length) {
            e.preventDefault();

            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: accountNumberInput.val()
                },
                success: function (data) {
                    if (data.valid) {
                        const deliveryMethod = getDeliveryMethod();
                        gtm.pushDeliveryMethod(deliveryMethod);

                        $form.find('.js-hidden-cart-submit-btn').removeAttr('disabled');
                        $form.submit();

                        $this.addClass('button-loading');
                        $this.find('.js-spinner-general').addClass('spinner-visible');
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            const deliveryMethod = getDeliveryMethod();
            gtm.pushDeliveryMethod(deliveryMethod);

            $this.addClass('button-loading');
            $this.find('.js-spinner-general').addClass('spinner-visible');
        }
    });

    if (document.referrer && !document.referrer.includes('checkout') && !document.referrer.includes('cart')) {
        sessionStorage.setItem('previousURL', document.referrer);
    }
    $(document).on('click', '.js-cart-back', function() {
        const lastPage = sessionStorage.getItem('previousURL');
        if (lastPage) {
            window.location.replace(lastPage);
            return;
        }
        window.history.back();
    });

    shipping.initPickupEvents();
    shipping.initUpdatingShippingInformation(updateOrderTotals);


    $(window).on('resize', function () {
        redesignAdjustment();
        bundlePriceAdjustment();
    });
}

function getDeliveryMethod() {
    const $shippingOption = $('.js-option-radio:checked');
    return $shippingOption.length ? $shippingOption.data('delivery-method-type') : 'unknown';
}

function scrollToErrorMessage(element) {
    if (!isInViewport(element)) {
        let top = element.offset().top;

        const header = $('.js-personalised-gifting-header');
        top = top - (header.height() || 0);

        $('html, body').scrollTop(top);
    }
}

function isFakeSelectionValid() {
    const $fakeSelected = $('[data-fake-errors]:checked');
    const $shippingOptionsError = $('#shippingOptionsError');

    if (!$fakeSelected.length) {
        $shippingOptionsError.text('').addClass('hide');
        return true;
    }

    const postalCodeError = $('span[id^="dwfrm_shippingpostalcode_postal-error"]').text();

    if (postalCodeError !== '') {
        $shippingOptionsError.text('').addClass('hide');
        return false;
    }

    const postalCode = $('input[id^="dwfrm_shippingpostalcode_postal"]').val();
    let errors = $fakeSelected.data('fake-errors');

    if (errors instanceof String) {
        errors = JSON.parse(errors);
    }
    $shippingOptionsError.text(postalCode ? errors.confirmation : errors.missing);
    scrollToErrorMessage($fakeSelected);
    $shippingOptionsError.removeClass('hide');
    return false;
}

function disableNotChosenGifts(){
        $('.js-tiered-gwp-selection:radio').each(function(){
            if ($(this).is(':checked')) {
                $(this).closest('.tiered-gwp-choose').addClass('crm-gift-checked');
                }
            });
            $('.gwp-select-box').click(function () {
            $('.js-tiered-gwp-selection:radio').each(function(){
                $(this).closest('.tiered-gwp-choose').removeClass('crm-gift-checked');
            });
            $(this).closest('.tiered-gwp-choose').addClass('crm-gift-checked');

    });
}

//TODO:
//This is a temporary fix (no better solution for now) for bug [DL-10166].
function disablePostalCodeInputFieldValidationForMouseWithinButtonBorders() {
    $(document).on('mouseenter', '.js-search-by-postalcode', function(){
        $('input[id^="dwfrm_shippingpostalcode_postal"]').data('prevent-automatic-validation', true);
    });
    $(document).on('mouseleave', '.js-search-by-postalcode', function(){
        $('input[id^="dwfrm_shippingpostalcode_postal"]').removeData('prevent-automatic-validation');
    });
}

function updateOrderTotals(selectedShippingOption) {
    $('.js-order-totals .js-order-value').text(selectedShippingOption.totalPrice);
    $('.js-order-totals .js-order-subtotal-value').text(selectedShippingOption.subtotalPrice);
    $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(selectedShippingOption.shippingPrice);

    if (selectedShippingOption.shippingPrice) {
        $('.js-shipping-price').text(selectedShippingOption.shippingPrice);
    }

    if (selectedShippingOption) {
        $('.js-totals-selected-shipping-option').text(selectedShippingOption.resource);
        $('.js-search-by-postalcode-title').text(selectedShippingOption.postalCodeButtonTitle);
    }

    const errorResults = handlePostalErrors(selectedShippingOption.exclusionResult);

    const $cartSubmitElement = $('.js-cart-action-checkout button');

    if (errorResults.enableCheckout) {
        $cartSubmitElement.removeClass('btn--disabled').removeAttr('disabled');
        return;
    }

    $cartSubmitElement.addClass('btn--disabled').attr('disabled', true);
}

function slideDownCouponBlock(){
    $('.js-cart-coupon-code').slideDown(0, {
        start: function () {
            $('.js-cart-coupon-code').css({
                display: 'flex'
            });
        }
    });
}

function applyCoupon() {
    const $form = $('.js-coupon-form');

    const options = {
        url: $form.attr('action'),
        data: $form.serialize() + '&dwfrm_cart_addCoupon=addCoupon', // triggered action
        type: 'POST',
        success: function(result) {
            const hasError = checkCouponResponseForErrors(result);

            if (!hasError && cartHasCouponExcludedAndRegularProducts(result)) {
                showCouponPartialyAppliedPopup(result);
                return;
            }

            updateAfterCouponChange(result);

            if (hasError) {
                $('.js-cart-coupon-trigger-btn').hide();
                slideDownCouponBlock();
                $('.js-cart-addcoupon-error-message').next().find('input').addClass('error-state');
                $('.js-coupon-btn').addClass('error-position');
            }
        },
        error: function() {
            $('.js-cart-coupon-trigger-btn').hide();
            slideDownCouponBlock();
            $('.js-cart-addcoupon-error-message').next().find('input').addClass('error-state');
            $('.js-coupon-btn').addClass('error-position');
        },
        complete: function() {
            $('#add-coupon').removeClass('button-loading');
            $('.js-coupon-code-spinner').removeClass('spinner-visible');
        },
    };

    $.ajax(options);
}

function updateAfterCouponChange(couponAppliedResult) {
    const $result = $(couponAppliedResult);
    const itemsHtml = $result.find('#cart-items-form').html();
    const subtotalsHtml = $result.find('.js-order-totals');
    const giftsInMinicartHTML = $result.find('.js-gwp-minicart-wrapper');
    $('#cart-items-form').html(itemsHtml);
    damHelper.updateImages('#cart-items-form');
    $('.js-order-totals').html(subtotalsHtml);
    $('.js-gwp-minicart-wrapper').html(giftsInMinicartHTML);
    damHelper.updateImages('.js-gwp-minicart-wrapper');

    // get new checkout sticky bar
    ajax.load({
        url: Urls.getStickyCheckoutBar,
        target: $('.js-checkout-sticky-bar'),
        data: {
            shipmentExcludedProductIDs: $('input[name="shipmentExcludedProductIDs"]').val()
        },
        replaceTarget: true
    });

    redesignAdjustment();
    bundlePriceAdjustment();
}

function deleteCoupon() {
    const $form = $('.js-coupon-form');
    const lastCouponIndex = $('.js-cart-row-coupon').length;
    const options = {
        url: $form.attr('action'),
        data: $form.serialize() + `&dwfrm_cart_coupons_i${lastCouponIndex}_deleteCoupon=deleteCoupon`,
        type: 'POST',
        success: function(result) {
            updateAfterCouponChange(result);
        }
    };

    $.ajax(options);
}

function createBonusWarningDialogForAppliedCoupon(removedBonusProductImagesHtml) {
    let removeProducts = false;

    $('.js-free-product-removal').find('.js-free-product-removal-images').html(removedBonusProductImagesHtml);
    $('.js-free-product-removal').find('.js-remove-popup-text').text(Resources.REMOVE_POPUP_COUPON);
    $('#add-coupon').addClass('button-loading');
    $('.js-coupon-code-spinner').addClass('spinner-visible');

    if (isMobileOrTabletWidth()) {
        toaster.def.$toastContent.html($('.js-free-product-removal').html());
        toaster.open({
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(){
                   removeProducts = true;
                   toaster.closeToasters();
                });
                $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                    removeProducts = false;
                    toaster.closeToasters();
                });

            },
            close: function () {
                if (removeProducts) {
                    applyCoupon();

                    return;
                }
                $('#add-coupon').removeClass('button-loading');
                $('.js-coupon-code-spinner').removeClass('spinner-visible');
            }
        });
        return;
    }
    dialog.open({
        html: $('.js-free-product-removal').html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 600,
            dialogClass: 'bonus-dialog-content gwp-dialog',
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                    dialog.close();
                });

                $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(){
                    removeProducts = true;
                    dialog.close();
                });
                $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                    removeProducts = false;
                    dialog.close();
                });

            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();

                if (removeProducts) {
                    applyCoupon();
                    return;
                }

                $('#add-coupon').removeClass('button-loading');
                $('.js-coupon-code-spinner').removeClass('spinner-visible');
            }
        }
    });
}

function showPPPopUp (popUpWrapper, btnAddToCart, quantity) {
    const quantityString = quantity ? (quantity + 1).toString() : '1';
    let changePPProduct = false;

    popUpWrapper.find($('.js-quantity-value')).text(quantityString);

    if (isMobileOrTabletWidth()) {
        toaster.def.$toastContent.html(popUpWrapper.html());
        toaster.open({
            open: function() {
                $('.js-modal-overlay').show();
                $('.js-generic-toaster').addClass('personal-promotion-content');

                $(document).off('click.popup', '.js-change-pp-product').on('click.popup', '.js-change-pp-product', function(){
                    changePPProduct = true;
                    toaster.closeToasters();
                });
                $(document).off('click.popup', '.js-keep-pp-product').on('click.popup', '.js-keep-pp-product', function(){
                    changePPProduct = false;
                    toaster.closeToasters();
                });
            },
            close: function () {
                $('.js-generic-toaster').removeClass('personal-promotion-content');

                if (changePPProduct) {
                    changePPProduct = false;
                    btnAddToCart.click();
                }
            }
        });
    } else {
    dialog.open({
        html: popUpWrapper.html(),
        target: $('.js-bonus-product-dialog-wrapper'),
        options: {
            width: 650,
            dialogClass: 'bonus-dialog-content gwp-dialog personal-promotion-content',
            open: function() {
                $('.js-modal-overlay').show();

                $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                    dialog.close();
                });

                $(document).off('click.popup', '.js-change-pp-product').on('click.popup', '.js-change-pp-product', function(){
                    changePPProduct = true;
                    dialog.close();
                });
                $(document).off('click.popup', '.js-keep-pp-product').on('click.popup', '.js-keep-pp-product', function(){
                    changePPProduct = false;
                    dialog.close();
                });

            },
            close: function () {
                dialog.close();
                $('.js-modal-overlay').hide();

                if (changePPProduct) {
                    btnAddToCart.click();
                }
            }
        }
    });
}
}

function showCouponPartialyAppliedPopup(couponAppliedResult) {
    window.eventBus.$on('couponApplyConfirmed', updateAfterCouponChange);
    window.eventBus.$on('couponApplyCanceled', deleteCoupon);
    window.eventBus.$emit('shouldOpenModal', {
        resources: {
            heading: Resources.COUPON_PARTIALLY_APPLIED_POPUP_HEADING ,
        },
        paragraphs: [
            {
                text: Resources.COUPON_PARTIALLY_APPLIED_POPUP_TEXT
            }
        ],
        ctaHolder: {},
        buttons: [
            {
                type: 'btn',
                label: Resources.COUPON_PARTIALLY_APPLIED_POPUP_CONFIRMED,
                eventName: 'couponApplyConfirmed',
                data: couponAppliedResult,
                shouldCloseModal: true
            }, {
                type: 'btn btn--secondary',
                label: Resources.COUPON_PARTIALLY_APPLIED_POPUP_CANCEL,
                eventName: 'couponApplyCanceled',
                shouldCloseModal: true
            }
        ],
        closeElement: {
            eventName: 'couponApplyCanceled',
            shouldCloseModal: true
        },
        modalLarge: true,
        centerOnMobile: true,
        customClass: 'modal-couponcode'
    });
}

function cartHasCouponExcludedAndRegularProducts(cartHtml) {
    return $(cartHtml).find('.js-has-coupon-excluded-and-regular-products').text() === 'true';
}

function addCoupon(e) {
    e.preventDefault();
    const $form = $('.js-coupon-form');

    $('#add-coupon').addClass('button-loading');
    $('.js-coupon-code-spinner').addClass('spinner-visible');

    $.ajax({
        url: Urls.checkRemoveBonusProductsWithCoupon,
        data: {
            couponCode: $form.find('input[name$=_couponCode]').val()
        }
    // eslint-disable-next-line no-use-before-define
    }).fail(function (jqXHR, status, err) {
        console.error('Failure checking for removed bonus products: ', err);
    })
    .done(function (removedProductImages) {
        if (removedProductImages) {
            //Get the dynamic header and description from the rendered template and place them in the correct place in the popup
            const originHeaderDiv = $(removedProductImages).find('#js-remove-gwp-popup-header');
            const targetHeaderDiv = $('.js-custom-popup-header');
            $(targetHeaderDiv).html($(originHeaderDiv).html());

            createBonusWarningDialogForAppliedCoupon(removedProductImages);
        } else {
            applyCoupon();
        }
    });
}

function searchByPostalCode(e) {
    e.preventDefault();

    const $form = $(this);
    const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

    if ($postalCodeElement.val() === $form.data('current-postal-code')) {
        return;
    }

    if (!$form.valid()) {
        return;
    }

    const $buttonElement = $('.js-search-by-postalcode', $form);
    const $orderTotals = $form.parents('.js-order-totals');
    const $cartSubmitElement = $('.js-cart-action-checkout button');
    const $defaultSelected = $('.js-option-radio:checked', $orderTotals);
    const selectedDefaultRadio = $defaultSelected.length ? '&selectedDefaultRadio=' + $defaultSelected.data('default-option') : '';
    const pickupInStoreEnabled = $('.js-enabled-geolocation', $orderTotals).length;
    const selectedShippingType = $defaultSelected.data('default-option');

    $('.js-cart-row .js-dangerousgoods-error p').text(''); //Remove any product-specific error messages
    $('.js-postal-code-spinner', $buttonElement).addClass('spinner-visible');

    $buttonElement.addClass('button-loading');
    $cartSubmitElement.addClass('btn--disabled').attr('disabled', true);

    const ajaxOptions = {
        url: $form.attr('action'),
        data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode' + selectedDefaultRadio,
        type: 'POST',
        success: function(result) {
            $orderTotals.html(result);
            ritualsFormHelper.initializeDataMask('.js-order-totals');
            validator.init();
            const newSelectedShippingType = $('.js-option-radio:checked', $orderTotals).data('default-option');
            if (selectedShippingType != newSelectedShippingType) {
                giftwrap.getGiftwrapDataForSelectedShippingOption(newSelectedShippingType, 'cart');
            }
            const errorResults = handleHTMLErrors();

            if (errorResults.enableCheckout) {
                $cartSubmitElement.removeClass('btn--disabled').removeAttr('disabled');
            }
            //handleExclusionResults();
        },
        error: function(xhr) {
            if (xhr.status === 400) { //Postal code error will result in a 400 status
                const response = xhr.responseJSON;
                handlePostalErrors(response);
            }
        },
        complete: function() {
            $('.js-postal-code-spinner').removeClass('spinner-visible');
            $('.js-search-by-postalcode').removeClass('button-loading');

            if ($('.js-shipping-home-delivery-select .js-custom-select').parent('.selectric-hide-select').length < 1) {
                $('.js-shipping-home-delivery-select .js-custom-select').selectric();
            }
        }
    };

    if (pickupInStoreEnabled) {
        places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
            ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
            $.ajax(ajaxOptions);
        });
        return;
    }

    $.ajax(ajaxOptions);
}

function showShippingExclusionToasterMessage(shipmentExclusionAssetID) {
    if (shipmentExclusionAssetID) {
        if ($('.js-shipment-exclusion-toaster').length > 0) {
            toaster.open({
                target: $('.js-shipment-exclusion-toaster')
            });
        } else {
            $.ajax({
                url: Urls.getShippingExclusionToastMessage,
                data: {shipmentExclusionAssetID},
                success: function(result) {
                    $('.js-shipment-exlusion-toast-message-container').html(result);
                    toaster.initDef();
                    toaster.open({
                        target: $('.js-shipment-exclusion-toaster')
                    });
                }
            });
        }
    }
}

function handlePostalErrors(errors) {
    const retVal = {
        enableCheckout: errors && errors.EnableCheckout === false ? false : true
    };

    $('#shippingOptionsError').text('').addClass('hide');
    $('.js-cart-row .js-dangerousgoods-error p').text('');
    $('#dwfrm_shippingpostalcode_postal-error').remove();

    const formValidator = $('#postalcode-form').validate();
    formValidator.resetForm();
    if (!errors || !errors.PostalCodeError) {
        return retVal;
    }

    $('.js-delivery-usp-heading.hide').removeClass('hide');
    $('.js-delivery-postal-code-form.hide').removeClass('hide');
    $('.js-postal-code-edit-wrapper:not(.hide)').addClass('hide');
    const $postalCode = $('#dwfrm_shippingpostalcode_postal');

    if ($postalCode.val()) {
        const errorObj = {};
        errorObj[$postalCode.attr('name')] = errors.PostalCodeError;
        formValidator.showErrors(errorObj);
    }

    if (isMobile()) {
        showShippingExclusionToasterMessage(errors.shipmentExclusionAssetID);
    }

    if (errors.ExcludedProductIDs) {
        //TODO
        for (const idx in errors.ExcludedProductIDs) {
            const productId = errors.ExcludedProductIDs[idx];

            const $excludedProductsMessage = $('.js-cart-row[data-product-id=' + productId + '] .js-dangerousgoods-error');
            $excludedProductsMessage.find('p').text(errors.ExcludedProductsMessage);
            $excludedProductsMessage.show();
        }
    }

    return retVal;
}

function handleHTMLErrors() {
    const $errorTextElement = $('#postalError');
    let errors = {};

    if ($errorTextElement.length) {
        errors = JSON.parse($errorTextElement.val());
        $errorTextElement.remove();
    }

    return handlePostalErrors(errors);
}

function checkCouponResponseForErrors(result) {
    const coupons = $(result).find('.cartcoupon');
    const errorMessage = $(result).find('.js-cart-addcoupon-error-message');
    if (coupons.length > 0 && errorMessage.length == 0) {
        const lastCoupon = coupons.last().find('.value')[0].innerText.trim();
        gtm.pushAddCouponValid(lastCoupon);
    }

    return errorMessage.length > 0;
}

function redesignAdjustment() {
    const cartRow = $('.js-cart-row');

    if (cartRow.length) {
        cartRow.each(function () {
            const $this = $(this);
            const cartPrice = $this.find('.js-cart-product-price');
            const cartDescription = $this.find('.js-cart-product-desc').find('.name');
            const quantityButtons = $this.find('.js-item-user-buttons');
            const pgCartWrapper = $('.js-pg-cart-page-wrapper');

            if (cartDescription.length) {
                if (!isSmallView()) {
                    cartPrice.css('padding-top', cartDescription.outerHeight());
                    quantityButtons.css('padding-top', cartDescription.outerHeight() + 2);
                } else if (isSmallView() && pgCartWrapper.length) {
                    cartPrice.css('padding-top', cartDescription.outerHeight() - 1);
                }

                if (pgCartWrapper.length) {
                    cartPrice.addClass('has-padding');
                }
            }
        });
    }
}

function couponCodeToggle() {
    const showCouponField = '.js-cart-coupon-trigger-btn';
    $(document).on('click', showCouponField, function () {
        $(showCouponField).hide();
        slideDownCouponBlock();
    });
}

function bundleToggle() {
    const $bundleWrapper = '.js-bundle-container';

    $(document).on('click', '.js-open-bundle', function () {
        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            $(this).closest('.js-cart-row').next().find($bundleWrapper).stop().show().removeAttr('aria-hidden');

            bundlePriceAdjustment();
        } else {
            $(this).removeClass('open');
            $(this).closest('.js-cart-row').next().find($bundleWrapper).stop().hide().attr('aria-hidden', 'true');
        }
    });
}

function bundlePriceAdjustment() {
    const bundleWrapper = $('.bundle-wrapper');

    if (bundleWrapper.length) {
        bundleWrapper.each(function() {
            const bundlePrice = $(this).find('.js-rowbundle').find('.js-bundle-price');
            const bundleDescription = $(this).find('.js-bundle-product__desc').find('.name');

            if (isSmallView()) {
                bundlePrice.css('padding-top', bundleDescription.outerHeight() + 10);
            } else {
                bundlePrice.css('padding-top', bundleDescription.outerHeight() - 2);
            }
        });
    }
}

function handlePPPopUp () {
    $(document).on('click', '.js-check-promo', function (e) {
        e.preventDefault();

        const productId = e.target.getAttribute('data-product-id');

        $.ajax({
            url: Urls.checkIfPPAlreadyApplied,
            data: {
                productId: productId
            }
        // eslint-disable-next-line no-use-before-define
        }).fail(function (jqXHR, status, err) {
            console.error('Failure checking for existing Personalized Promotion in the Cart ', err);
        }).done(function (response) {
            const btnAddToCart = e.target.closest('.promotion-add-to-cart').querySelector('.js-add-to-cart');

            if (response.addedPPToCart) {
                const popUpWrapper = $('.js-change-pp-product.product-pop-up-' + productId + '');

                showPPPopUp(popUpWrapper, btnAddToCart, response.quantity);
            } else {
                btnAddToCart.click();
            }
        });
    });
}

function setHiddenDHLPostNummer(dHLPostNummer) {
    const hiddenDHLPostNummer = $('input.js-dhl-post-nummer');
    hiddenDHLPostNummer.val(dHLPostNummer);
}

function currentCartAnalyticsB2B() {
    const purchaseDataElement = $('.js-cart-open-event');
    pushDataLayerEventCart(purchaseDataElement);
}

const pushDataLayerEventCart = function(element){
    if (element.length == 0) {
        return;
    }

    const analyticsData = $(element[0].attributes['data-analytics']);

    if (!analyticsData) {
        return;
    }
    gtm.pushDataLayerEvent(JSON.parse(analyticsData[0].value));
};

exports.init = function() {
    storeMissingStockWarning.createDialog();
    taxFreeThresholdPassedWarning.createDialog();
    shipping.initGWPChoosingPopup();
    ritualsFormHelper.initializeDataMask();
    initializeEvents();
    pgCartUtils.init();
    currentCartAnalyticsB2B();
    // init product tile for recommendations block
    productTile.init();
    disableNotChosenGifts();
    redesignAdjustment();
    bundleToggle();
    bundlePriceAdjustment();
    couponCodeToggle();
    handlePPPopUp();

    giftwrap.init();

    // init toaster messages events
    toaster.init();
    cartPostalCode.init();

    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }
};

},{"../bonus-products-view":276,"../dam/dam-helper":419,"../dialog":422,"../giftwrap":433,"../modules/ajax":449,"../modules/google":453,"../modules/helpers/isInViewport":464,"../modules/helpers/isSmallView":469,"../modules/util/getCountryFromLocaleCookie":488,"../modules/util/isMobile":497,"../modules/util/isMobileOrTabletWidth":498,"../page":518,"../product-tile":581,"../rituals-form-helper":590,"../storeinventory/cart":600,"../toaster":605,"../validator":607,"./cart/cartPostalCode":521,"./checkout/shipping":527,"./checkout/storeMissingStockWarning":529,"./checkout/taxFreeThresholdPassedWarning":530,"./personalisedgifting/pgCartUtils":548,"./product/quantity-block":557}],521:[function(require,module,exports){
'use strict';

const validator = require('../../validator'),
    ritualsFormHelper = require('../../rituals-form-helper'),
    places = require('../../modules/google').places,
    getCountryFromLocaleCookie = require('../../modules/util/getCountryFromLocaleCookie');

function searchByPostalCode(e) {
    e.preventDefault();
    const $form = $(this);
    const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

    if ($postalCodeElement.val() === $form.data('current-postal-code')) {
        return;
    }

    if (!$form.valid()) {
        return;
    }

    hideTopError();

    const $buttonElement = $('.js-search-by-postalcode', $form);
    const $orderTotals = $form.parents('.js-order-totals');
    const $cartSubmitElement = $('.js-cart-action-checkout button');
    const pickupInStoreEnabled = $('.js-enabled-geolocation', $orderTotals).length;

    $buttonElement.addClass('btn--disabled').addClass('button-loading');
    $cartSubmitElement.addClass('btn--disabled');
    $('.js-postal-code-spinner', $buttonElement).addClass('spinner-visible');

    const ajaxOptions = {
        url: $form.attr('action'),
        data: $form.serialize() + '&' + $buttonElement.attr('name') + '=searchByPostalCode',
        type: 'POST',
        success: function (result) {
            $orderTotals.html(result);
            ritualsFormHelper.initializeDataMask('.js-order-totals');
            validator.init();
            //giftwrap.getGiftwrapDataForSelectedShippingOption(newSelectedShippingType, 'cart');
            handleExclusionResults();
        },
        error: function (xhr) {
            $buttonElement.removeClass('btn--disabled').removeClass('button-loading');
            $('.js-postal-code-spinner', $buttonElement).removeClass('spinner-visible');
            if (!xhr.status === 400) {
                return;
            }
            const response = xhr.responseJSON;
            showPostalError($postalCodeElement, response);
        },
        complete: function () {
            $cartSubmitElement.removeClass('btn--disabled');
        }
    };

    if (pickupInStoreEnabled) {
        places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
            ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
            $.ajax(ajaxOptions);
        });
        return;
    }

    $.ajax(ajaxOptions);
}

function showPostalError(postalCode, errors) {
    const formValidator = $('#postal-code-form').validate();
    $('#dwfrm_shippingpostalcode_postal-error').remove();
    formValidator.resetForm();
    const errorObj = {};
    errorObj[postalCode.attr('name')] = errors.PostalCodeError;
    formValidator.showErrors(errorObj);
}

function handleExclusionResults() {
    const $exclusionTextElement = $('#exclusionResults');

    if (!$exclusionTextElement.length) {
        handleTopError('');
        $('.js-exclusion-error:not(.js-totally)').remove();
        return;
    }

    const errors = JSON.parse($exclusionTextElement.val()) || {
        excludedProducts: {}
    };

    $('.js-cart-row[data-product-id]').each(function () {
        const productRow = $(this);
        const productId = productRow.data('product-id');
        const $existingError = $('.js-exclusion-error', productRow);
        if (!errors.excludedProducts[productId]) {
            $existingError.remove();
            return;
        }

        if ($existingError.hasClass('js-totally')) {
            return;
        }

        const $newError = $('<div>', {
            'class': 'inline-alert js-exclusion-error'
        });
        $newError.addClass(errors.excludedProducts[productId].type)
            .append('<span>' + errors.excludedProducts[productId].message + '</span>');

        if ($existingError.length) {
            $existingError.replaceWith($newError);
            return;
        }

        productRow.append($newError);

    });

    handleTopError(errors.errorMessage);
}

function editPostal(e) {
    $('#postal-code-form').addClass('active');
    $(e.target).addClass('hide');
}

function addPostal(e) {
    $('#postal-code-form').addClass('active');
    $(e.target).addClass('hide');
}

function handleTopError(errorMessage) {
    const $topError = $('.js-top-error');
    const valid = errorMessage == '' || $topError.hasClass('valid');
    $(document).off('click.postalCode', '.js-cart-action-checkout button');
    $topError.removeClass('valid');

    if (valid) {
        $topError.addClass('hide');
        $(window).off('scroll.toperror');
        return;
    }

    if (errorMessage) {
        $('p', $topError).text(errorMessage);
    }

    $(document).on('click.postalCode', '.js-cart-action-checkout button', function (e) {
        e.preventDefault();
        const $bannerPlaceholder = $('.error-banner-placeholder', $topError);
        $topError.removeClass('hide');
        checkTopPosition($bannerPlaceholder);
        addScrollEvent($bannerPlaceholder);
        removeSpinner($(this));
    });
}

function hideTopError() {
    $('.js-top-error:not(.hide)').addClass('hide');
}

function addScrollEvent(bannerPlaceholder) {
    $(window).on('scroll.toperror', function () {
        checkTopPosition(bannerPlaceholder);
    });
}

function checkTopPosition($bannerPlaceholder) {
    if ($bannerPlaceholder[0].getBoundingClientRect().top <= 0) {
        $bannerPlaceholder.next().addClass('fixed');
        return;
    }

    $bannerPlaceholder.next().removeClass('fixed');
}

function removeSpinner(button) {
    button.addClass('btn--disabled');
    const spinner = $('.js-spinner-general', button);

    if (spinner.length) {
        button.removeClass('button-loading');
        spinner.removeClass('spinner-visible');
    }
}

module.exports = {
    init: function () {
        if (!$('.checkout-v3').length) {
            return;
        }
        $(document).off('submit.postalCode', '#postal-code-form').on('submit.postalCode', '#postal-code-form', searchByPostalCode);
        $(document).off('click.postalCode', '.js-postal-form-trigger-add').on('click.postalCode', '.js-postal-form-trigger-add', addPostal);
        $(document).off('click.postalCode', '.js-postal-form-trigger-edit').on('click.postalCode', '.js-postal-form-trigger-edit', editPostal);
        handleTopError();
    }
};

},{"../../modules/google":453,"../../modules/util/getCountryFromLocaleCookie":488,"../../rituals-form-helper":590,"../../validator":607}],522:[function(require,module,exports){
'use strict';

const fillAddressFields = require('../../modules/util/fillAddressFields');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function (formInit) {
    let form = formInit;
    if (!form || form.length == 0) {
        form = $('.js-checkout-form');
    }
    // select address from list
    $('select[name$="_addressList"]', form).off('change').on('change', function () {
        const selected = $(this).children(':selected').first();
        const selectedAddress = $(selected).data('address');
        if (!selectedAddress) { return; }
        fillAddressFields(selectedAddress, form);

        $('input[name$=_singleshipping_shippingAddress_addressFields_postal]', form).trigger('input.postalerror');

        // re-validate the form
        form.validate().form();
    });
};

},{"../../modules/util/fillAddressFields":484}],523:[function(require,module,exports){
'use strict';

const formHelper = require('../../rituals-form-helper'),
    isSmallView = require('../../modules/helpers/isSmallView');

function handlePostalCompleted(postalCode, e) {

    const $postalCodeElement = $(e.target);

    const $shippingForm = $postalCodeElement.parents('form');
    const $continueBtn = $shippingForm.find('button[type=submit]');

    const validator = $shippingForm.validate();
    if (!$postalCodeElement.valid()) {
        return;
    }

    const $select = $('.js_delivery_date_select').find('.js-custom-select');
    $continueBtn.prop('disabled', true);
    step1ButtonLoading(true);

    $.ajax({
        type: 'GET',
        url: Urls.validatePostalCodeAndGetShippingOptions,
        data: {postalCode: postalCode, shouldGetNewOptions: $select.length > 0},
        success: function(data) {
            if (data.ok) {
                hidePostalCodeErrors($postalCodeElement, $continueBtn, $postalCodeElement.prev('.js-validator-error'));
                updateHomeDeliveryOptions(data, $select);
                return;
            }

            if (data.errorMessage) {
                exports.showPostalCodeErrors($postalCodeElement, $continueBtn, validator, data.errorMessage);
            }

            if (data.location) {
                $continueBtn.data('redirecto', data.location);
            }
        },
        complete: function() {
            if ($select.length > 0) {
                $select.selectric();
                if (!isSmallView()) {
                    $select.attr('tabindex', '-1');
                }
            }
            $continueBtn.removeAttr('disabled');
            step1ButtonLoading(false);
        }
    });
}

function hidePostalCodeErrors(postalCodeElement, continueBtn, errorElement) {
    continueBtn.removeData('redirecto');
    continueBtn.removeData('prevent-submit');
    postalCodeElement.removeData('prevent-automatic-validation');
    postalCodeElement.removeClass('excludedpostalerror');
    postalCodeElement.removeClass('dangerouspostal');
    postalCodeElement.removeClass('error');
    postalCodeElement.removeClass('js-validator-error');
    postalCodeElement.removeClass('js-warn-addded');
    continueBtn.off('click.invalidPostalCode');
    errorElement.remove();
}

function updateHomeDeliveryOptions(data, select) {
    if (data.result && select.length) {
        select.empty();
        const newOptions = data.result;
        const previousSelectedOption = data.selectedDeliveryOption;
        $.each(newOptions.delivery, function(key, value) {
            select.append($('<option></option>').attr('value', value.id).attr('selected', (previousSelectedOption && previousSelectedOption.id === value.id)).text(value.fullDisplayName));
        });
        $('.js_delivery_date_select').removeClass('hide');
        return;
    }

    if (select.length) {
        $('.js_delivery_date_select').addClass('hide');
    }
    return;
}

function step1ButtonLoading(turnOn) {
    const $step1ContinueButton = $('.js-step-1-continue-btn');
    const $spinnerStep1 = $('.js-step-1-spinner');

    $step1ContinueButton.toggleClass('button-loading', turnOn);
    $('.js-checkout-sticky-button').toggleClass('button-loading', turnOn);
    $spinnerStep1.parent().toggleClass('button-loading', turnOn);
    $spinnerStep1.toggleClass('spinner-visible', turnOn);
}

exports.initSearchByPostalCode = function() {
    const postalOptions = {
        onComplete: handlePostalCompleted,
        selectOnFocus: true,
    };

    const $postalInput = $('input[name$=_singleshipping_shippingAddress_addressFields_postal]');
    formHelper.initPostalMask($postalInput, postalOptions);
    $postalInput.off('input.postalerror').on('input.postalerror', function() {
        const $postalCodeElement = $(this);
        hidePostalCodeErrors($postalCodeElement, $postalCodeElement.parents('form').find('button[type=submit]'), $postalCodeElement.prev('.js-validator-error'));
    });

    $(document).off('shippingPostalCode.updated').on('shippingPostalCode.updated', function(e, params) {
        if (!params || !params.length) {
            return;
        }
        const $elements = params.filter('input[name$=_singleshipping_shippingAddress_addressFields_postal]');
        if (!$elements || !$elements.length) {
            return;
        }

        const value = $elements.val();

        if (!value || !value.length) {
            return;
        }

        handlePostalCompleted(value, {'target':$elements});

    });
};

exports.showPostalCodeErrors = function (postalCodeElement, continueBtn, validator, errorMessage) {
    const errorObj = {};
    errorObj[postalCodeElement.attr('name')] = errorMessage;
    validator.showErrors(errorObj);
    postalCodeElement.addClass('excludedpostalerror');
    postalCodeElement.addClass('dangerouspostal');
    postalCodeElement.addClass('error');
    postalCodeElement.addClass('js-validator-error');
    postalCodeElement.addClass('js-warn-addded');

    continueBtn.data('prevent-submit', true);
    postalCodeElement.data('prevent-automatic-validation', true);
    continueBtn.on('click.invalidPostalCode', function(evt){
        evt.preventDefault();
        formHelper.scrollToInputField(postalCodeElement);
        postalCodeElement.focus();
    });
};

},{"../../modules/helpers/isSmallView":469,"../../rituals-form-helper":590}],524:[function(require,module,exports){
'use strict';

const login = require('../../login');
const gtm = require('../../modules/google').tagManager;

const init = function () {
    login.init();

    gtm.bindFormFieldErrorEvents();
};

exports.init = init;

},{"../../login":443,"../../modules/google":453}],525:[function(require,module,exports){
'use strict';

// validation: store address got by KLARNA-GetAddresses
const savedAddress = {
    firstName: '',
    lastName: '',
    street: '',
    housenumber: '',
    city: '',
    zip: '',
    countryCode: ''
};

// SSN matching pattern
const patternSsn = '^\\s*([0-9][0-9][0-9]?[0-9]?)(0[1-9]|[12][0-9])(0[1-9]|[12][0-9]|3[01])\\s*(\.|\-|\/|\s)?\\s*([0-9][0-9][0-9][0-9])\\s*$';
const paymentKlarnaAddressIsValid = $('#js_klarna_valid_address');
const btnKlarnaAjaxGet = $('.js-klarna-ajax-button');
const btnKlarnaClearAll = $('.js-klarna-clearall-button');
const klarnaWaitIndicator = $('.js-klarna-loading-indicator');
const fieldKlarnaError = $('.js-klarna-error');

// address form field selectors
const fieldAddressList = $('select[name$="_singleshipping_addressList"]');
const fieldAddressSearch = $('input[name$="_shippingAddress_addressFields_addressSearch"]');
const fieldSsn = $('input[name$="_shippingAddress_addressFields_ssn"]');
const fieldFirstName = $('input[name$="_shippingAddress_addressFields_firstName"]');
const fieldLastName = $('input[name$="_shippingAddress_addressFields_lastName"]');
const fieldStreet = $('input[name$="_shippingAddress_addressFields_street"]');
const fieldHouseNumber = $('input[name$="_shippingAddress_addressFields_houseNumber"]');
const fieldZip = $('input[name$="_shippingAddress_addressFields_postal"]');
const fieldCity = $('input[name$="_shippingAddress_addressFields_city"]');
const fieldCountry = $('select[name$="_shippingAddress_addressFields_country"]');
const fieldsUseAsBilling = $('input[name$="_shippingAddress_useAsBillingAddress"]');
const labelUseAsBilling = $('label[for$="_shippingAddress_useAsBillingAddress"]');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    // handle the klarna address check button click
    btnKlarnaAjaxGet.on('click', function(e) {
        e.preventDefault();
        requestAddressToKlarna();
    });

    // handle the klarna clear all button click
    btnKlarnaClearAll.on('click', function(e) {
        e.preventDefault();
        clearKlarnaData();
    });

    // toggle the klarna address check button on ssn field changes
    fieldSsn.on('keyup paste change input blur', function(e) {
        toggleSsnButton(e);
    });

    // Updating klarna validation in every change on inputs or texts
    $('.input-text,input-select').change(function() {

        if (fieldFirstName.val() == savedAddress.firstName
                && fieldLastName.val() == savedAddress.lastName
                && fieldStreet.val() == savedAddress.street
                && fieldHouseNumber.val() == savedAddress.housenumber
                && fieldCity.val() == savedAddress.city
                && fieldZip.val().replace(' ', '') == savedAddress.zip.replace(' ', '')) {
            paymentKlarnaAddressIsValid.val('1');
        } else {
            paymentKlarnaAddressIsValid.val('0');
        }
    });

    const ssnUsed = $('#js_klarna_ssn_used');
    if (ssnUsed.val() != undefined && ssnUsed.val() != '') {
        fieldSsn.val(ssnUsed.val());
        btnKlarnaAjaxGet.addClass('hide');
        paymentKlarnaAddressIsValid.val('1');
        lockKlarnaRelatedFields();
    }
};

/**
 * request address data from KLARNA GetAddresses service for swedish customers
 */
function requestAddressToKlarna() {
    paymentKlarnaAddressIsValid.val('0');

    // try to match a valid personnummer (ssn)
    let ssn = fieldSsn.val();
    const pattern = new RegExp(patternSsn);
    if (pattern.test(ssn)) {
        ssn = ssn.replace(pattern, '$1$2$3-$5');
        fieldSsn.val(ssn);
    }

    // get url for the GetAddresses service from the KlarnaPayment cartridge
    const url = Urls.klarnaGetAddress;
    const data = {'ssn': ssn};

    //hide button, show wait message
    btnKlarnaAjaxGet.addClass('hide');
    klarnaWaitIndicator.removeClass('hide');

    $.get(url, data, function (response) {
        if (!response.success) {
            // display ssn validation error information if it is one
            fieldSsn.addClass('error');
            fieldKlarnaError.removeClass('hide');
            btnKlarnaAjaxGet.removeClass('hide');
        } else {
            // if first_name doesn't exist in xml data, assume it is company
            if (response.addresses && (response.addresses.length > 0) && response.addresses[0].fname) {
                // store address for validation
                savedAddress.firstName = response.addresses[0].fname;
                savedAddress.lastName = response.addresses[0].lname;
                savedAddress.street = response.addresses[0].street;
                savedAddress.housenumber = response.addresses[0].housenumber;
                savedAddress.city = response.addresses[0].city;
                savedAddress.zip = response.addresses[0].zip;
                savedAddress.countryCode = response.addresses[0].country;

                lockKlarnaRelatedFields();

                fieldSsn.removeClass('error');
                fieldFirstName.val(savedAddress.firstName).removeClass('error');
                fieldFirstName.trigger('change');
                fieldLastName.val(savedAddress.lastName).removeClass('error');
                fieldLastName.trigger('change');
                fieldStreet.val(savedAddress.street).removeClass('error');
                fieldStreet.trigger('change');
                fieldHouseNumber.val(savedAddress.housenumber).removeClass('error');
                fieldHouseNumber.trigger('change');
                fieldZip.val(savedAddress.zip).removeClass('error');
                fieldZip.trigger('change');
                fieldCity.val(savedAddress.city).removeClass('error');
                fieldCity.trigger('change');
                fieldCountry.removeClass('error');
                fieldCountry.trigger('change');

                fieldKlarnaError.removeClass('error');
                fieldKlarnaError.addClass('hide');
            } else {
                fieldSsn.addClass('error');
                btnKlarnaAjaxGet.removeClass('hide');
                fieldKlarnaError.removeClass('hide');
            }
        }

    })
    .fail(function () {
        fieldSsn.addClass('error');
        btnKlarnaAjaxGet.removeClass('hide');
        fieldKlarnaError.removeClass('hide');
    })
    .always(function() {
        klarnaWaitIndicator.addClass('hide');
    });
}

/**
 * Toggle the ssn address check button
 * enable / disable it depending on the ssn field context
 */
function toggleSsnButton(e) {
    if (e.keyCode != 91 && e.keyCode != 93 && e.keyCode != 18 && e.keyCode != 16 && e.keyCode != 17 && e.keyCode != 27 && e.keyCode != 13 && e.keyCode != 37 && e.keyCode != 38 && e.keyCode != 39 && e.keyCode != 40) {
        const ssn = fieldSsn.val();
        const pattern = new RegExp(patternSsn);

        if (pattern.test(ssn)) {
            btnKlarnaAjaxGet.removeAttr('disabled');
        } else {
            btnKlarnaAjaxGet.attr('disabled', 'disabled');
        }
        fieldKlarnaError.addClass('hide');
    }
}

/**
 * Handle the clear all functionality
 *
 */
function clearKlarnaData() {
    // get url for the GetAddresses service from the KlarnaPayment cartridge
    const url = Urls.removeSSNFromSession;

    $.get(url, function (response) {
        if (response.success) {
            fieldSsn.val('').change(); //trigger input 'change' event to toggle button state
            fieldFirstName.val('');
            fieldLastName.val('');
            fieldStreet.val('');
            fieldHouseNumber.val('');
            fieldZip.val('');
            fieldCity.val('');

            // disable all input fields on successful validation
            fieldAddressList.removeAttr('disabled');
            fieldAddressSearch.removeAttr('readonly');
            fieldSsn.removeAttr('readonly');
            fieldFirstName.removeAttr('readonly');
            fieldLastName.removeAttr('readonly');
            fieldStreet.removeAttr('readonly');
            fieldHouseNumber.removeAttr('readonly');
            fieldZip.removeAttr('readonly');
            fieldCity.removeAttr('readonly');
            fieldCountry.removeAttr('disabled');
            fieldsUseAsBilling.removeClass('hide');
            labelUseAsBilling.removeClass('hide');

            //disable klarna button and use as billing address and google places field, enable clear all button
            btnKlarnaAjaxGet.removeClass('hide');
            btnKlarnaClearAll.addClass('hide');
            fieldKlarnaError.addClass('hide');
        }
    });
}

function lockKlarnaRelatedFields () {
    // disable all input fields on successful validation
    // TODO : address selection dropdown
    fieldAddressList.attr('disabled', 'disabled');
    fieldAddressSearch.attr('readonly', 'readonly');
    fieldSsn.attr('readonly', 'readonly');
    fieldFirstName.attr('readonly', 'readonly');
    fieldLastName.attr('readonly', 'readonly');
    fieldStreet.attr('readonly', 'readonly');
    fieldHouseNumber.attr('readonly', 'readonly');
    fieldZip.attr('readonly', 'readonly');
    fieldCity.attr('readonly', 'readonly');
    fieldCountry.attr('disabled', 'disabled');
    fieldsUseAsBilling.addClass('hide');
    labelUseAsBilling.addClass('hide');

    //disable use as billing address and google places field, enable clear all button
    btnKlarnaClearAll.removeClass('hide');
    fieldsUseAsBilling.prop('checked', true).trigger('change');

    // flag a valid address
    paymentKlarnaAddressIsValid.val('1');

    // validate Klarna fields
    fieldFirstName.valid();
    fieldLastName.valid();
    fieldStreet.valid();
    fieldHouseNumber.valid();
    fieldZip.valid();
    fieldCity.valid();
    fieldCountry.valid();

    fieldSsn.parent().children('span.error').hide();
    fieldFirstName.parent().children('span.error').hide();
    fieldLastName.parent().children('span.error').hide();
    fieldStreet.parent().children('span.error').hide();
    fieldHouseNumber.parent().children('span.error').hide();
    fieldZip.parent().children('span.error').hide();
    fieldCity.parent().children('span.error').hide();
    fieldCountry.parent().children('span.error').hide();
}

},{}],526:[function(require,module,exports){
/**
 * Order Confirmation Page
 */
'use strict';

const gMap = require('../../modules/google').maps;
const gPlaces = require('../../modules/google').places;
const $mapEl = $('.js-google-map');
const miniCart = require('../../minicart');

/**
 * Gets data from map element and converts them to coordinates
 */
const initMap = () => {
    if (drawMap()) {
        return;
    }

    const postalCode = String($mapEl.data('postalcode') || '');
    const countryName = $mapEl.data('country') || '';

    gPlaces.getLatLongFromPostalCode(postalCode, countryName, function(lat, lng) {
        if (lat && lng) {
            $mapEl.data('lat', lat);
            $mapEl.data('lng', lng);

            drawMap();
        }
    });
};

/**
 * Draws the map in the map element using the lat and lng params
 *
 * @param {number} lat lattitude of location
 * @param {number} lng longtitude of location
 */
const drawMap = () => {
    if ($mapEl.data('lat') && $mapEl.data('lng')) {
        if ($mapEl.data('icon')) {
            // Checkout V3
            const lat = $mapEl.data('lat');
            const lng = $mapEl.data('lng');
            const icon = $mapEl.data('icon');
            const center = new google.maps.LatLng(lat, lng);

            // Google Map Style source: https://snazzymaps.com/style/14889/flat-pale
            gMap.init($mapEl, {
                    url: icon,
                    scaledSize: new google.maps.Size(35, 48)
                }, {
                    mapTypeId: google.maps.MapTypeId.ROADMAP,
                    center: center,
                    zoom: 15,
                    panControl: false,
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    overviewMapControl: false,
                    rotateControl: false,
                    styles: [
                        {
                            'featureType': 'administrative',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#6195a0'
                                }
                            ]
                        },
                        {
                            'featureType': 'administrative.province',
                            'elementType': 'geometry.stroke',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape',
                            'elementType': 'geometry',
                            'stylers': [
                                {
                                    'lightness': '0'
                                },
                                {
                                    'saturation': '0'
                                },
                                {
                                    'color': '#f5f5f2'
                                },
                                {
                                    'gamma': '1'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape.man_made',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'lightness': '-3'
                                },
                                {
                                    'gamma': '1.00'
                                }
                            ]
                        },
                        {
                            'featureType': 'landscape.natural.terrain',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'poi',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'poi.park',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#bae5ce'
                                },
                                {
                                    'visibility': 'on'
                                }
                            ]
                        },
                        {
                            'featureType': 'road',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'saturation': -100
                                },
                                {
                                    'lightness': 45
                                },
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#fac9a9'
                                },
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.highway',
                            'elementType': 'labels.text',
                            'stylers': [
                                {
                                    'color': '#4e4e4e'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.arterial',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#787878'
                                }
                            ]
                        },
                        {
                            'featureType': 'road.arterial',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'visibility': 'off'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'visibility': 'simplified'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.airport',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'hue': '#0a00ff'
                                },
                                {
                                    'saturation': '-77'
                                },
                                {
                                    'gamma': '0.57'
                                },
                                {
                                    'lightness': '0'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.rail',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'color': '#43321e'
                                }
                            ]
                        },
                        {
                            'featureType': 'transit.station.rail',
                            'elementType': 'labels.icon',
                            'stylers': [
                                {
                                    'hue': '#ff6c00'
                                },
                                {
                                    'lightness': '4'
                                },
                                {
                                    'gamma': '0.75'
                                },
                                {
                                    'saturation': '-68'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'all',
                            'stylers': [
                                {
                                    'color': '#eaf6f8'
                                },
                                {
                                    'visibility': 'on'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'geometry.fill',
                            'stylers': [
                                {
                                    'color': '#c7eced'
                                }
                            ]
                        },
                        {
                            'featureType': 'water',
                            'elementType': 'labels.text.fill',
                            'stylers': [
                                {
                                    'lightness': '-49'
                                },
                                {
                                    'saturation': '-53'
                                },
                                {
                                    'gamma': '0.79'
                                }
                            ]
                        }
                    ]
                });
        } else {
            // Checkout V2
            gMap.init($mapEl);
        }
        return true;
    }
    return false;
};

/**
 * Checks if a map is present
 *
 * @returns {boolean}
 */
const shouldInitMap = () => {
    return $mapEl.length > 0;
};

const orderConfirmationPage = {
    init: () => {
        $(document).find('.js-acc-head').on('opened', miniCart.adjustPricePadding);
        $(document).find('.js-acc-head').on('click', function() {
            const accLabel = $(this).find('.js-order-summary-accordian');
            const temp = accLabel.data('toggle-label');
            accLabel.data('toggle-label', accLabel.text());
            accLabel.text(temp);
        });
        if (shouldInitMap()) {
            initMap();
        }
    }
};


module.exports = orderConfirmationPage;

},{"../../minicart":446,"../../modules/google":453}],527:[function(require,module,exports){
'use strict';

const formHelper = require('../../rituals-form-helper');
const flyout = require('../../flyout');
const giftwrap = require('../../giftwrap.js');
const validatory = require('../../validator');

const genericFlyout = '.js-generic-flyout';
const editShippingFlyoutClass = '.js-flyout-edit-shipping-options';
const editShippingFlyoutCloseClass = '.js-flyout-edit-shipping-options .js-close-flyout';

const selectors = {
    PICKUP_POINT_WRAPPER: '.js-edit-pickup-points-wrapper',
    PICKUP_IN_STORE_FLYOUT_WRAPPER: '.js-edit-pickup-in-store-wrapper',
    PICKUP_FLYOUT_RADIO_BUTTON: '.js-select-pickup-radio',
    PICKUP_IN_STORE_FLYOUT_ROW: '.js-pickup-in-store-row',
    SHIPPING_OPTIONS_CONTAINER: '.js-shipping-options-container',
    PICKUP_IN_STORE_RADIO_BUTTON: '.js-pickup-in-store-radio',
    SHIPPING_OPTION_ADDRESS: '.js-address'
};

const classes = {
    PICKUP_IN_STORE_FLYOUT_CLASS: 'delivery-wide-flyout'
};

exports.updateShippingInformation = updateShippingInformation;
exports.initUpdatingShippingInformation = initUpdatingShippingInformation;
exports.initPickupEvents = initPickupEvents;


exports.init = function () {
    initGWPChoosingPopup();
    if ($('input[id$="sasEurobonusMember"]').is(':checked')) {
        $('.js-eurobonus-dropdown').removeClass('hide');
    }
    handleBillingAddressFields();
    handleNifNumberSection();

    // validate on keyup for fields with error
    $(document).on('keyup', '.js-step-1-content .error', function (e) {
        //get selection position
        const start = this.selectionStart,
            end = this.selectionEnd;

        if ($(this).data('prevent-automatic-validation')) {
            return;
        }

        $(e.target).valid();
        //set the range
        if ($(e.target).is(':not([type=email], [type=number])')){
            this.setSelectionRange(start, end);
        }
    });

    $(document).on('change', '.js_delivery_date_select :input', function() {
        const selectedOption = $('#dwfrm_singleshipping_deliveryOption option:selected');
        const shippingOptionId = selectedOption.data('shipping-option-id');
        const shippingService = selectedOption.data('shipping-service');
        updateShippingInformation(shippingOptionId, shippingService, null, null, function(response){
            $('.js-shipping-price').text(response.selectedShippingOption.shippingPrice);
            $('.js-order-value').text(response.selectedShippingOption.totalPrice);
            $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(response.selectedShippingOption.totalPrice);
        });
    });
};

exports.initGWPChoosingPopup = initGWPChoosingPopup;
exports.handleBillingAddressFields = handleBillingAddressFields;
exports.handleNifNumberSection = handleNifNumberSection;
exports.handleNifStep2 = handleNifStep2;

function getFlyoutForEditPickupPointsAndStores(selector, additionalClassToFlyout) {
    const $this = $(this);
    const options = getEditPickupPointsAndStoresDeliveryFlyoutOptions(additionalClassToFlyout);
    const flyoutHtml = $(selector).html();
    flyout.loadFromHtml(flyoutHtml, options);
    $this.addClass('js-triggered-flyout');
}

function initPickupEvents() {
    $(document).on('click', '.js-pickup-point-change', function (e) {
        e.preventDefault();

        const $postNummerEl = $(this).closest('.js-checkout-review-box').find('.js-service-point-postnummer-input');
        if ($postNummerEl.length > 0) {
            const postNummer = $postNummerEl.val().trim();
            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: postNummer
                },
                success: function (data) {
                    if (data.valid) {
                        $('#dhl-post-number-for-edit-pup').val(postNummer);
                        $('#dhl-post-number-display-string').val(data.displayDhlString);
                        getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_POINT_WRAPPER);
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_POINT_WRAPPER);
        }
    });

    $(document).on('keydown', '.js-service-point-postnummer-input', function(e) {
        if (e.which === 8 || e.which === 13 || e.which === 16 || e.which === 17 || e.which === 18) {
            return;
        }

        const errorSpan = $('.js-service-point-postnummer-input-error');
        if (!errorSpan.hasClass('hide')) {
            errorSpan.addClass('hide');
        }
    });

    $(document).on('click', '.js-pickup-in-store-change', function () {
        getFlyoutForEditPickupPointsAndStores(selectors.PICKUP_IN_STORE_FLYOUT_WRAPPER, classes.PICKUP_IN_STORE_FLYOUT_CLASS);
        if ($('#find-stores-postalcode-form',$(this))) {
            validatory.init();
            formHelper.initializeDataMask();
        }
    });

    $(document).on('click', '.js-select-pickup-radio:not(.selected)', function () {
        const $this = $(this);
        const $wrapper = $this.parents('.js-flyout-content');
        $('.js-select-pickup-radio.selected', $wrapper).removeClass('selected');
        $this.addClass('selected');
    });

    $(document).on('click', '.js-delivery-flyout-list-toggle', function () {
        const $this = $(this);
        if (!$this.hasClass('open')) {
            $('.js-delivery-flyout-list-toggle', '.js-flyout-content').removeClass('open');
            $('.delivery-flyout-list-details', '.js-flyout-content').stop().slideUp();
            $this.addClass('open');
            $this.parent().next('.delivery-flyout-list-details').stop().slideDown();
        } else {
            $this.removeClass('open');
            $this.parent().next('.delivery-flyout-list-details').stop().slideUp();
        }
    });

    $(document).on('click', '.js-pickup-in-store-see-more', function() {
        const $this = $(this);
        const storesToShow = $this.data('storesToShow');
        const $flyoutContent = $this.closest('.js-flyout-content');
        const $hiddenStores = $('.js-pickup-in-store-row.hide:lt(' + storesToShow + ')', $flyoutContent);
        $hiddenStores.removeClass('hide');
        const $hiddenStoresLeft = $('.js-pickup-in-store-row.hide', $flyoutContent);
        if (!$hiddenStoresLeft.length) {
            $this.remove();
        }
    });
}

function initUpdatingShippingInformation(callback) {
    $(document).on('click','.js-update-selected-pickup-point', function () {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        const $this = $(this);

        const $flyoutContent = $this.closest('.js-flyout-content');
        const $selectedPickup = $('.js-select-pickup-radio.selected', $flyoutContent);

        if (!$selectedPickup.length) {
            return;
        }

        const shippingOptionId = $selectedPickup.data('shipping-option-id');
        const defaultOption = $selectedPickup.data('default-option');
        const pickupPointCode = $selectedPickup.data('service-point-code');
        const shippingService = $selectedPickup.data('shipping-service');

        const shippingDisplayValues = {
            dhlPostNummer: $('#dhl-post-number-for-edit-pup').length ? $('#dhl-post-number-for-edit-pup').val() : null,
            shippingPrice: $this.data('shipping-price'),
        };

        const $postalCodeForm = $('#find-pickup-postalcode-form', $flyoutContent);
        const postalCode = $postalCodeForm.length ? $postalCodeForm.data('current-postal-code') : null;

        const $currentlySelectedOption = page == 'checkout_page' ? $('.js-option-radio:checked', '.js-shipping-options-container') : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $currentlySelectedOption, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, shippingDisplayValues.dhlPostNummer, function(response) {
                updatePickupPointShippingOption(response.selectedShippingOption, shippingDisplayValues, $flyoutContent);
            }, defaultOption, postalCode);
        });
    });

    function updatePickupPointShippingOption(selectedShippingOption, shippingDisplayValues, flyoutContent) {
        if (selectedShippingOption.isDHLPostNummerValid) {
            $('.js-dhl-post-nummer').val(shippingDisplayValues.dhlPostNummer);
        }

        const $destinationPickupPointItem = $('.js-pickup-option-label');
        $('.js-service-point-name', $destinationPickupPointItem).html(selectedShippingOption.name);
        $('.js-address', $destinationPickupPointItem).html(selectedShippingOption.address + ' ' + selectedShippingOption.city);
        $('.js-option-price', $destinationPickupPointItem).html(selectedShippingOption.shippingPrice);

        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');

        $shippingOptionCheckbox.data('service-point-code', selectedShippingOption.code);

        $('.js-edit-pickup-option-item.selected').removeClass('selected');
        $('.js-edit-pickup-option-item[data-pickup-point-code=' + selectedShippingOption.code + ']').addClass('selected');

        const $pickupPointFlyoutWrapper = $('.js-edit-pickup-points-wrapper');
        $pickupPointFlyoutWrapper.empty().html(flyoutContent.html());

        flyout.closeFlyouts();

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }

        callback(selectedShippingOption);
    }

    $(document).on('click', '.js-update-selected-pickup-in-store', function() {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        const $this = $(this);

        const $flyoutContent = $this.closest('.js-flyout-content');
        const $selectedStore = $('.js-select-pickup-radio.selected', $flyoutContent);
        if (!$selectedStore.length) {
            return;
        }

        const shippingOptionId = $selectedStore.data('shipping-option-id');
        const defaultOption = $selectedStore.data('default-option');
        const pickupPointCode = $selectedStore.data('service-point-code');
        const shippingService = $selectedStore.data('shipping-service');

        const shippingDisplayValues = {
            addressWithTime: $selectedStore.data('radioButtonAddressWithTime'),
            postalCode: $('#find-stores-postalcode-form', $flyoutContent).length ? $('#find-stores-postalcode-form', $flyoutContent).data('current-postal-code') : null
        };

        const $currentlySelectedOption = page == 'checkout_page' ? $('.js-option-radio:checked', '.js-shipping-options-container') : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $currentlySelectedOption, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updatePickupInStoreShippingOption(response.selectedShippingOption, shippingDisplayValues, $flyoutContent);
            }, defaultOption, shippingDisplayValues.postalCode);
        });
    });

    function updatePickupInStoreShippingOption(selectedShippingOption, shippingDisplayValues, flyoutContent) {
        const $shippingOptionsContainer = $(selectors.SHIPPING_OPTIONS_CONTAINER);
        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');

        $shippingOptionCheckbox.data('servicePointCode', selectedShippingOption.code);

        const $pickupInStoreAddress = $(selectors.SHIPPING_OPTION_ADDRESS, $shippingOptionsContainer);
        $pickupInStoreAddress.find('strong').text(shippingDisplayValues.addressWithTime);

        const $pickupInStoreFlyoutWrapper = $(selectors.PICKUP_IN_STORE_FLYOUT_WRAPPER);
        $pickupInStoreFlyoutWrapper.empty().html(flyoutContent.html());

        flyout.closeFlyouts();

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }
        callback(selectedShippingOption);
    }

    $(document).on('change', '.js-scheduled-home-delivery-select', function() {
        const page = $('.js-checkout-step-content').length ? 'checkout_page' : 'cart_page';
        if (page == 'checkout_page') {
            $('.js-shipping-option-radio-label').trigger('mousedown');
            $(document).trigger($.Event('checkout.onHomeDeliveryTimeChange'));
            return;
        }

        const $this = $(this);
        const $shippingOption = $('option:selected', $this);

        const shippingOptionId = $shippingOption.data('shipping-option-id');
        const shippingService = $shippingOption.data('shipping-service');
        const pickupPointCode = $shippingOption.data('service-point-code');
        const defaultOption = $shippingOption.data('default-option');

        const shippingDisplayValues = {
            displayName: $shippingOption.data('display-name'),
            displayTime: $shippingOption.data('display-time'),
            optionPrice: $shippingOption.data('shipping-formatted-price')
        };

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, null, function() {
            updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, null, function(response) {
                updateHomeDeliveryShippingOption(response.selectedShippingOption, shippingDisplayValues);
            }, defaultOption, null);
        });
    });

    function updateHomeDeliveryShippingOption(selectedShippingOption, shippingDisplayValues) {
        const $homeDeliveryWrapper = $('.js-home-delivery-wrapper');
        const $shippingOptionName = $('.js-option-title strong', $homeDeliveryWrapper);
        const $shippingOptionPrice = $('.js-delivery-option-price', $homeDeliveryWrapper);

        $shippingOptionName.text(shippingDisplayValues.displayName);
        $shippingOptionPrice.text(shippingDisplayValues.optionPrice);

        if (shippingDisplayValues.displayTime) {
            const $shippingOptionTime = $('.js-option-time', $homeDeliveryWrapper);
            $shippingOptionTime.text(shippingDisplayValues.displayTime);
        }

        const $shippingOptionCheckbox = $('.js-option-radio[data-default-option="' + selectedShippingOption.shippingType + '"]');
        $shippingOptionCheckbox.data('shipping-option-id', selectedShippingOption.id);

        if ($shippingOptionCheckbox.length) {
            $shippingOptionCheckbox.prop('checked', true);
        }

        callback(selectedShippingOption);
    }
}

function getEditPickupPointsAndStoresDeliveryFlyoutOptions(additionalClassForFlyout) {
    return {
        open: function() {
            adjustEditShippingFlyoutOnInit(additionalClassForFlyout);
            editShippingFlyoutAccessibilityAdjust();
        },
        close: function() {
            if (additionalClassForFlyout) {
                $(genericFlyout).removeClass(additionalClassForFlyout);
            }
            resetCloseFlyoutBtnPosition(additionalClassForFlyout);
        }
    };
}

function adjustEditShippingFlyoutOnInit(additionalClassForFlyout) {
    $(genericFlyout).addClass('delivery-wide-flyout');
    if (additionalClassForFlyout) {
        $(genericFlyout).addClass(additionalClassForFlyout);
    }
}

function editShippingFlyoutAccessibilityAdjust() {
    $(document).on('keydown', '.js-flyout-edit-shipping-options .js-postal-code, .js-flyout-edit-shipping-options .js-service-point-zipcode-input', function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();
            $(editShippingFlyoutCloseClass).focus();
        }
    });

    $(document).on('keydown', editShippingFlyoutCloseClass, function (e) {
        if (e.which == 9 && e.shiftKey) {
            e.preventDefault();

            const $editShippingFlyout = $(genericFlyout).find(editShippingFlyoutClass);
            const $updateShippingOption = $editShippingFlyout.find('.js-update-shipping-option');
            const $updateSelectPickupPoint = $editShippingFlyout.find('.js-edit-pickup-option-item');

            if ($updateShippingOption.length) {
                $updateShippingOption.focus();
            } else if ($updateSelectPickupPoint.length) {
                $updateSelectPickupPoint.last().find('.js-select-pickup-radio').focus();
            }
        } else if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $(editShippingFlyoutClass).find('input').first().focus();
        } else if (e.which === 13) {
            e.preventDefault();
            flyout.closeFlyouts();
            resetCloseFlyoutBtnPosition();
        }
    });
}

function resetCloseFlyoutBtnPosition() {
    $(document).find('.js-triggered-flyout').focus();
}

function updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, dhlPostNummer, onUpdate, selectedFakeOption, postalCode) {
    $.ajax({
        type: 'POST',
        url: Urls.setCartShippingMethod,
        contentType: 'application/json',
        data: JSON.stringify({
            service: shippingService,
            optionId: shippingOptionId,
            pickupPointCode: pickupPointCode,
            dhlPostNummer: dhlPostNummer,
            selectedFakeOption: selectedFakeOption,
            postalCode: postalCode
        }),
        success: function(response) {
            if (onUpdate) {
                onUpdate(response);
            }
        }
    });
}

function initGWPChoosingPopup(){
    const nonSelectedGiftLink = $('.bonus-item-actions a.js-select-bonus-product').first();
    if (nonSelectedGiftLink && nonSelectedGiftLink.length > 0) {
        const bonusProductsView = require('../../bonus-products-view');
         bonusProductsView.show({
            url: nonSelectedGiftLink.attr('href'),
            giftChange: false,
            response: null,
            isAddedPopup: nonSelectedGiftLink.data('showadded'),
            checkout: !!nonSelectedGiftLink.data('oncheckout')
        });
     }
}

function handleBillingAddressFields(){
    const $billingAddressForm = $('.js-1st-step-billing');
    if (!$billingAddressForm.length) {
        return;
    }

    const $useAsBillingAddress = $('.js-checkout-form input[id$=useAsBillingAddress]');
    const $billingAddressToCollapse = $('.js-billing-address-collapse');

    if ($billingAddressForm.hasClass('pickup-point')) {
        $useAsBillingAddress.parents('.form-row').hide();
        $useAsBillingAddress.prop('checked', false);
        return;
    }

    if ($useAsBillingAddress.is(':checked')) {
        $billingAddressToCollapse.hide();
    }

    $useAsBillingAddress.on('change', function () {
        $billingAddressToCollapse.slideToggle(400);
    });
}

function handleNifNumberSection() {
    const forms = ['.js-shipping_address_form', '.js-billing-address-form'];

    forms.forEach(function(form) {
        const $formRow = $(form).find('input[id$=addNifNumber').closest('.form-row');
        const $inputCheckbox = $(form).find('input[id$=addNifNumber');
        const $numberFieldWrapper = $(form).find('input[id$=nifNumber]').parent();
        const $inputNumber = $(form).find('input[id$=nifNumber]');

        if (!$inputNumber.val()) {
            $numberFieldWrapper.css('display', 'none');
        } else {
            $inputCheckbox.prop('checked', true);
        }

        $formRow.off('click').on('click', function() {
            handleNifNumberActions($(this).closest('fieldset'));
        });
    });
}

function handleNifStep2() {
    const $form = $('.js-generic-flyout');
    $form.off('click').on('click', function(e) {
        const target = $(e.target);
        if (!target.closest('.form-row').find('input[id$=addNifNumber').length) {
            return;
        }

        handleNifNumberActions($(this));
    });
}

function handleNifNumberActions(element) {
    const $inputCheckbox = element.find('input[id$=addNifNumber]');
    const $numberFieldWrapper = element.find('input[id$=nifNumber]').parent();

    if ($inputCheckbox.is(':checked')) {
        $inputCheckbox.prop('checked', false);
        $numberFieldWrapper.css('display', 'none');
    } else {
        $inputCheckbox.prop('checked', true);
        $numberFieldWrapper.css('display', 'block');
    }
}

},{"../../bonus-products-view":276,"../../flyout":425,"../../giftwrap.js":433,"../../rituals-form-helper":590,"../../validator":607}],528:[function(require,module,exports){
'use strict';

const shipping = require('./shipping');
const address = require('./address');
const progress = require('../../progress');
const prefillAddress = require('../../prefill-address');
const klarna = require('./klarnaGeneral');
const google = require('../../modules/google');
const validator = require('../../validator');
const toaster = require('../../toaster');
const flyout = require('../../flyout');
const ritualsStyles = require('../../rituals-styles');
const fillAddressFields = require('../../modules/util/fillAddressFields');
const formHelpers = require('../../rituals-form-helper');
const customSelect = require('../../select-custom');
//const miniCart = require('../../minicart');
const ritualsFormHelper = require('../../rituals-form-helper');
const isSmallView = require('../../modules/helpers/isSmallView');
const giftwrap = require('../../giftwrap');
const getCountryFromLocaleCookie = require('../../modules/util/getCountryFromLocaleCookie');
const checkoutPostalCode = require('./checkoutPostalCode');
const damHelper = require('../../dam/dam-helper');

const SinglePageCheckout = function () {
    const $step1 = $('.js-step-1');
    const $step1Content = $('.js-step-1-content');
    const $step2 = $('.js-step-2');
    const $step2Content = $('.js-step-2-content');
    const $step3 = $('.js-step-3');
    const $step3Content = $('.js-step-3-content');
    let $currentStep;
    const genericFlyout = '.js-generic-flyout';
    const stickyButtonSelector = '.js-checkout-sticky-button';
    let $addressChanged = false;
    let $previousRadioButton = $('.js-option-radio:checked');
    const stepBtns = {
        step1 : {
            label: Resources.CHECKOUT_GO_TO_STEP_2_LABEL,
            class: 'js-step-1-continue-btn'
        },
        step2 : {
            label: Resources.CHECKOUT_GO_TO_STEP_3_LABEL,
            class: 'js-step-2-continue-btn'
        },
        step3 : {
            label: Resources.CHECKOUT_GO_TO_PAYMENT_LABEL,
            class: 'js-step3-submit'
        }
    };

    const step2KeyPressHandler = function (e) {
        // trigger the next step button on second step while pressing enter key if it is not focused on zip code field
        if (e.which === 13) {
            $('.js-step-2-continue-btn').trigger('click');
        }
    };
    let animationSpeed = 0;

    function updateStickyButton(stepNumber) {
        const $checkoutStickyButton = $(stickyButtonSelector);
        const currentButtonClass = stepBtns[stepNumber].class;
        const currentButtonLabel = stepBtns[stepNumber].label;
        const $spinner = $('.js-spinner-general', $checkoutStickyButton);

        $checkoutStickyButton.data('triggering-action', currentButtonClass);
        $checkoutStickyButton.text(currentButtonLabel);
        $checkoutStickyButton.append($spinner);
    }

    function validateEurobounsField($inputElement){
        $('.js-eurobonus-dropdown').removeClass('eurobonus-valid');
        if ($inputElement.valid()) {
            if ($inputElement.val().length == 0) {
                $inputElement.addClass('error');
                $('#eurobonusError').removeClass('hide').text($inputElement.data('required-text'));
                return false;
            }

            validateEurobonusMemberId($inputElement.val(), null, function(){
                $inputElement.focus();
            });
        }
        return false;
    }

    function initAddressSpecificFields(parentElement, preselectedValues) {
        const country = $('[id$=_country]', parentElement).val();
        if (typeof country !== 'undefined' && country.toLowerCase() !== 'hk') {
            return Promise.all([]);
        }

        const cityField = $('[id$=_addressFields_city]', parentElement);
        const districtField = $('[id$=_addressFields_district]', parentElement);
        const subdistrictField = $('[id$=_addressFields_subdistrict]', parentElement);

        return ritualsFormHelper.initTownDistrictFields(cityField, districtField, subdistrictField, preselectedValues);
    }

    function init() {
        // Make the content containers available from the headers by adding a content property
        $step1.content = $step1Content;
        $step2.content = $step2Content;
        $step3.content = $step3Content;

        shipping.init();
        shipping.initPickupEvents();
        shipping.initUpdatingShippingInformation(updateDeliveryReview);
        prefillAddress.init();
        checkoutPostalCode.initSearchByPostalCode();
        address.init();

        // init js for toaster messages and custom selects
        toaster.init();
        customSelect.init();

        $currentStep = $step1;

        if (pageContext.openStep && pageContext.openStep > 1) {
            window.history.replaceState({'step': pageContext.openStep}, 'step ' + pageContext.openStep, window.location.href);
            showStep(pageContext.openStep);
        } else {
            window.history.replaceState({'step': 1}, 'step 1', window.location.href);
            $(document).trigger('shippingPostalCode.updated', [$('input[name$=_singleshipping_shippingAddress_addressFields_postal]', $step1.content)]);
        }

        initEventsForSetStateFromPostalCode();

        $(document).on('checkout.onHomeDeliveryTimeChange', function () {
            const $flyoutAddressForm = $('.js-edit-delivery-time-wrapper .js-shipping_address_form');
            const $homeDeliveryRadioButton = $('.js-shipping-option-radio');
            setShippingOptionToAddressForm($homeDeliveryRadioButton, $('.js-shipping_address_form', $(genericFlyout)));
            if ($flyoutAddressForm.length) {
                openFlyout($homeDeliveryRadioButton, '.js-edit-delivery-time-wrapper');
                google.places.init(); //Init google places to enable address search field in flyout
                validator.init();
                formHelpers.initializeDataMask();
                checkoutPostalCode.initSearchByPostalCode();
                const $addressForm = $('.js-flyout-content > div').find('.js-checkout-form');
                address.init($addressForm);
                return;
            }

            $('.js-edit-delivery-form').trigger('submit');
        });

        $(document).on('submit', '#find-pickup-postalcode-form', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

            if ($postalCodeElement.val() === $form.data('current-postal-code')) {
                return;
            }

            if (!$form.valid()) {
                return;
            }

            const $pickupPointFlyoutStoresWrapper = $('.js-pickup-options-wrapper', '.js-flyout-content');

            const ajaxOptions = {
                url: $form.attr('action'),
                data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode',
                type: 'POST',
                success: function(result) {
                    const $flyoutView = $(result);
                    $pickupPointFlyoutStoresWrapper.replaceWith($('.js-pickup-options-wrapper', $flyoutView));
                    validator.init();
                    formHelpers.initializeDataMask();
                }
            };

            $.ajax(ajaxOptions);
            return;
        });

        $(document).on('submit', '#find-stores-postalcode-form', function (e) {
            e.preventDefault();

            const $form = $(this);
            const $postalCodeElement = $('#dwfrm_shippingpostalcode_postal', $form);

            if ($postalCodeElement.val() === $form.data('current-postal-code')) {
                return;
            }

            if (!$form.valid()) {
                return;
            }

            const $pickupInStoreFlyoutStoresWrapper = $('.js-pickup-options-wrapper', '.js-flyout-content');

            const ajaxOptions = {
                url: $form.attr('action'),
                data: $form.serialize() + '&dwfrm_cart_searchByPostalCode=searchByPostalCode',
                type: 'POST',
                success: function(result) {
                    const $flyoutView = $(result);
                    $pickupInStoreFlyoutStoresWrapper.replaceWith($('.js-pickup-options-wrapper', $flyoutView));
                    validator.init();
                    formHelpers.initializeDataMask();
                }
            };

            google.places.init();
            google.places.getLatLongFromPostalCode($postalCodeElement.val(), getCountryFromLocaleCookie(), function (latitude, longitude) {
                ajaxOptions.data += '&latitude=' + latitude + '&longitude=' + longitude;
                $.ajax(ajaxOptions);
            });
            return;
        });

        $(document).on('click', '#btnEditOrderSummary', google.tagManager.pushCheckoutEditOrderSummaryEvent);
        $(document).on('click', '#btnEditShippingAddress', google.tagManager.pushCheckoutDeliveryAddressChangeEvent);
        $(document).on('click', '#btnChangeShippingAddressDetails', google.tagManager.pushCheckoutAddressDetailsChangeEvent);
        $(document).on('click', 'div.checkout__header.step-1', google.tagManager.pushCheckoutBackToDetailsEvent);
        $(document).on('click', '.js-step-1-continue-btn', submitInformationForm);
        $(document).on('click', '.js-change-delivery-details-btn', changeDeliveryDetails);
        $(document).on('click', '.js-change-billing-details-btn', changeBillingDetails);
        $(document).on('click', stickyButtonSelector, bindStickyButtonClick);

        $(document).on('click', '.js-gotostep1', function(e) {
            e.preventDefault();
            if ($currentStep != $step1) {
                openStep(1);
            } else {
                $('html, body').animate({scrollTop: 0}, 'slow');
            }

            $('.js-step-1-spinner').removeClass('spinner-visible');
            $('.js-step-1-continue-btn').removeClass('button-loading');
            $(stickyButtonSelector).removeClass('button-loading');
        });

        $(document).on('click', '.js-gotostep1billing', function (e) {
            e.preventDefault();
            if ($currentStep != $step1) {
                openStep(1);
            }
            // buffer it with 6 yo
            $('html, body').animate({
                scrollTop: $('.js-billing-title').offset().top - $('header').height() - 6
            }, 'slow');
        });

        $(document).on('click', '[id$=sasEurobonusMember]', updateEuroBonusInputField);

        $(document).on('keypress input copy', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function (e) {
            if (e.which != 8 && e.which != 0 && e.which < 48 || e.which > 57) {
                return false;
            }

            const $this = $(this);
            const memberCode = $this.val();
            const maxLength = parseInt($this.attr('maxlength'));


            if (memberCode.length >= maxLength) {
                $this.val(memberCode.substr(0, maxLength));
            }

            $('#eurobonusError').addClass('hide').text('');
        });

        $(document).on('change', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function () {
            $('#validatedEurobonusCode').val('');
        });

        $(document).on('focusout', '#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode', function () {
            const $memberCode = $(this);
            validateEurobounsField($memberCode);
        });

        $(document).on('change', '#dwfrm_billing_paymentMethods_birthday', fillHiddenDobFields);
        $(document).on('change', 'input[name=\'brandCode\']', paymentMethodChanged);
        $(document).on('change', 'select[name=\'issuerId\']', idealBankChanged);
        $(document).on('click', '.js-step3-submit', pay);
        // trigger the step 2 button by clicking the stickybar button
        $(document).on('click', '.js-checkout-sticky-button.js-step-2-continue-btn', function () {
            $('.step2-bottom-button .js-step-2-continue-btn').click();
        });
        // Enable animations after the page has loaded
        animationSpeed = 400;

        // Swedish Social Number
        if ($('input[id$=addressFields_ssn]').length > 0) {
            klarna.init();
        }

        $(document).on('change.all', '#shipping_address_form input, #shipping_address_form select', function () {
            if ($(this).closest('.js-company-fields').length) {
                const $billingForm = getBillingForm();
                updateAddressSummary($billingForm);
                return;
            }
            updateAddressSummary();
            $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').closest('div').removeClass('hide');
        });

        $(document).on('change.all', '#billing_address_form input, #billing_address_form select, #company_details_form input, #company_details_form select', function () {
            const $billingForm = getBillingForm();
            updateAddressSummary($billingForm);
        });

        $(document).on('change.all', '[id$=useAsBillingAddress]', function () {
            if (!$(this).is(':checked')) {
                const $billingForm = getBillingForm();
                updateAddressSummary($billingForm);
                return;
            }
            updateAddressSummary();
            $('#dwfrm_singleshipping_shippingAddress_addToAddressBook').closest('div').removeClass('hide');
        });

        function checkIsNifChecked() {
            const $form = $('.js-generic-flyout');
            const $input = $form.find('input[id$=nifNumber]');
            const $fieldWrapper = $input.parent();
            const $addNifNumber = $form.find('input[id$=addNifNumber]');

            if (!$addNifNumber.is(':checked')) {
                $fieldWrapper.css('display', 'none');
            }
        }

        $(document).on('click', '.js-review-edit-address', function () {
            openFlyout(this, '.js-edit-delivery-details-wrapper');
            checkIsNifChecked();
            google.places.init(); //Init google places to enable address search field in flyout
            validator.init();
            formHelpers.initializeDataMask();
            checkoutPostalCode.initSearchByPostalCode();
            const $addressForm = $('.js-flyout-content > div').find('.js-checkout-form');
            address.init($addressForm);

            const preselectedValues = {
                city: $('input[name="preselected-shipping-city"]').val() || '',
                district: $('input[name="preselected-shipping-district"]').val() || '',
                subdistrict: $('input[name="preselected-shipping-subdistrict"]').val() || ''
            };

            const $genericFlyout = $('.js-generic-flyout');
            initAddressSpecificFields($genericFlyout, preselectedValues).then(() => updateAddressSummary());
        });

        $(document).on('click', '.js-review-edit-billing', function () {
            openFlyout(this, '.js-edit-billing-details-wrapper');
            checkIsNifChecked();
            google.places.init();
            validator.init();
            formHelpers.initializeDataMask();
            const $addressForm = $('.js-flyout-content > div').find('.js-billing-form');
            address.init($addressForm);

            const preselectedValues = {
                city: $('input[name="preselected-billing-city"]').val() || '',
                district: $('input[name="preselected-billing-district"]').val() || '',
                subdistrict: $('input[name="preselected-billing-subdistrict"]').val() || ''
            };

            const $genericFlyout = $('.js-generic-flyout');
            initAddressSpecificFields($genericFlyout, preselectedValues).then(() => updateAddressSummary($addressForm));
        });


        $(document).on('submit', '.js-edit-delivery-form', function(evt) {
            evt.preventDefault();
            const form = $(this);
            const page = 'checkout_page';
            const defaultOption = $('.js-shipping-option-radio').data('default-option');

            giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $previousRadioButton, function() {
                const submit = $('button[type=submit]', form);
                const spinner = $('.js-update-delivery-time-spinner', submit);
                submit.addClass('btn--disabled');
                submit.addClass('button-loading');
                spinner.addClass('spinner-visible');
                updateDeliveryTimeFlyout(form, evt);
            });
        });

        function updateDeliveryTimeFlyout(form, evt) {
            const addressForm = $('.js-shipping_address_form', form);
            const selectedOption = $('.js-scheduled-home-delivery-select option:selected');

            if (addressForm.length === 0) { //No address form, update only the option
                updateShippingOption(selectedOption);
                return;
            }

            setShippingOptionToAddressForm(selectedOption, addressForm);
            submitInformationForm(evt, flyout.closeFlyouts, addressForm.closest('form'));
        }

        $(document).on('mousedown', '.js-shipping-option-radio-label', function () {
            $previousRadioButton = $('.js-option-radio:checked');
        });

        $(document).on('click', '.js-checkout-radio [name=shippingoption]', function(evt) {
            const $this = $(this);
            $addressChanged = true;

            if ($this.hasClass('js-shipping-option-radio')) {
                const $flyoutAddressForm = $('.js-edit-delivery-time-wrapper .js-shipping_address_form');
                if ($flyoutAddressForm.length > 0) { //This option requires setting the address form, let's show it right away
                    evt.preventDefault();
                    openFlyout(this, '.js-edit-delivery-time-wrapper');
                    setShippingOptionToAddressForm($this, $('.js-shipping_address_form', $(genericFlyout)));
                    google.places.init(); //Init google places to enable address search field in flyout
                    validator.init();
                    formHelpers.initializeDataMask();
                    checkoutPostalCode.initSearchByPostalCode();
                    return;
                }
            }

            updateShippingOption($this);
        });

        $(document).on('change', 'select[name$=_addressList]', function(e){
            e.preventDefault();

            const $this = $(this);
            const $addressForm = $this.parents('.js-address-form');
            const $selected = $this.children(':selected').first();

            const selectedAddress = $selected.data('address');
            if (!selectedAddress) {
                return;
            }

            fillAddressFields(selectedAddress, $addressForm);
            updateAddressSummary($addressForm);

            const $addToAddressBook = $addressForm.find('[id$=addToAddressBook]');
            if ($addToAddressBook.length > 0) {
                $addToAddressBook.prop('checked', false);
                $addToAddressBook.closest('div').addClass('hide');
            }

            $addressForm.find('[name$=salutation]').selectric('refresh');

            // re-validate the form
            $addressForm.valid();
        });

        $(document).on('input copy', 'div.js-flyout-container input[name$="_address1"]', function(){
            const avataxErrorMessageDivEl = $('div.js-avatax-address-validation-error');
            if (avataxErrorMessageDivEl && avataxErrorMessageDivEl.parents('div.js-flyout-container').length) {
                avataxErrorMessageDivEl.addClass('hide');
            }
        });

        setupBackButtonHistoryFunctionality();

        google.tagManager.bindFormFieldErrorEvents();

        //miniCart.adjustPricePadding();
        adjustPricePadding();

        let addressForm = $('#shipping_address_form');
        const isBillingAddress = $('.js-billing-address-holder').length > 0;

        if (isBillingAddress) {
            addressForm = $('#billing_address_form');
        }

        updateAddressSummary(addressForm);

        const $shippingAddressForm = $('#shipping_address_form');
        const $billingAddressForm = $('#billing_address_form');

        initAddressSpecificFields($shippingAddressForm);
        initAddressSpecificFields($billingAddressForm);
    }

    function setShippingOptionToAddressForm(shippingOption, form){
        const field = $('[id$=deliveryOption]', form);

        if (!shippingOption.length) {
            field.val(null);
        }

        const deliveryOption = {
            shippingOptionId: shippingOption.data('shipping-option-id') || null,
            shippingService: shippingOption.data('shipping-service') || null
        };

        field.val(JSON.stringify(deliveryOption));
    }

    function setupBackButtonHistoryFunctionality() {
        $(document).on('click', '.js-checkout-back', function() {
            window.history.back();
            $('html, body').animate({scrollTop: 0});
        });

        $(window).on('popstate', function(e) {
            const state = e.originalEvent.state;

            if (state && Object.prototype.hasOwnProperty.call(state, 'step')) {
                openStep(state.step, true);
                return;
            }

            openStep(1, true);
        });
    }

    function adjustPricePadding() {
        $('.js-minicart-product').each(function () {
            const $this = $(this);
            const smallTitle = '.js-mini-cart-small-title';
            const $price = $this.find('.js-mini-cart-price-wrapper');

            if ($this.find(smallTitle).length) {
                const smallTitleHeight = $(smallTitle).outerHeight() + 5;

                $price.css('padding-top', smallTitleHeight);
            } else {
                $price.css('padding-top', 0);
            }
        });
    }

    $(document).on('change', '.js-service-point-postnummer-input', function(){
        const dHLPostNummer = $(this).val();
        setHiddenDHLPostNummer(dHLPostNummer);
    });

    function changeDeliveryDetails(e){
        e.preventDefault();
        const $form = $(this).closest('form');
        $form.find('.js-service-point-postnummer-input-error').addClass('hide');
        const accountNumberInput = $form.find('.js-service-point-postnummer-input');
        //if paazl distributor is DHL germany, service points are selected and accountnumber field exists, validate input first
        if (!accountNumberInput.length) {
            submitInformationForm(e, flyout.closeFlyouts, $form);
            return;
        }

        $.ajax({
            type: 'GET',
            url: Urls.checkoutCheckAccountServiceNumberForPaazl,
            data: {
                accountServiceNumber: accountNumberInput.val()
            },
            success: function (data) {
                if (data.valid) {
                    setHiddenDHLPostNummer(accountNumberInput.val());
                    submitInformationForm(e, flyout.closeFlyouts, $form);
                } else {
                    $form.find('.js-service-point-postnummer-input-error').removeClass('hide');
                }
            }
        });
    }

    function changeBillingDetails(e) {
        e.preventDefault();

        const $billingForm = $('.js-flyout-container .js-billing-form');
        const isBillingFormValid = $billingForm.validate().checkForm();

        if (isBillingFormValid) {
            const $spinner = $billingForm.find('.js-step-1-spinner');
            $spinner.parent().addClass('button-loading');
            $spinner.addClass('spinner-visible');

            $.ajax({
                url: $billingForm.attr('action'),
                data: $billingForm.serialize() + '&dwfrm_billing_save=save',
                type: 'POST',
                success: function (result) {
                    const location = getRedirectLocationFromResult(result);
                    if (location) {
                        window.location = result.location;
                        return;
                    }

                    if (result.Errors) {
                        fillValidationFailsFromBE(result.Errors, $billingForm);
                        return;
                    }

                    updateStep2(true);
                    $addressChanged = true;

                    flyout.closeFlyouts();
                },
                complete: function() {
                    $spinner.parent().removeClass('button-loading');
                    $spinner.removeClass('spinner-visible');
                },
                statusCode: {
                    401: function(data) {
                        window.location = data.getResponseHeader('Location');
                    }
                }
            });
        } else {
            $billingForm.valid();
            return false;
        }
    }

    function bindStickyButtonClick(e){
        const stepButtonClass = $(e.target).data('triggering-action');
        $('.' + stepButtonClass).click();
    }

    function getRedirectLocationFromResult(result) {
        if (result !== undefined && result !== null &&
            result.location !== undefined &&
            result.location !== null) {
            return result.location;
        }

        return null;
    }

    function updateEuroBonusInputField() {
        const $eurobonusBlock = $('.js-eurobonus-dropdown');
        const isChecked = $('[id$=sasEurobonusMember]').is(':checked');

        if (isChecked) {
            $eurobonusBlock.removeClass('hide');
        } else {
            $eurobonusBlock.addClass('hide');
        }
    }

    function updateShippingOption(selectedOptionElement) {
        if (selectedOptionElement.length === 0) {
            return;
        }

        const page = 'checkout_page';
        const shippingOptionId = selectedOptionElement.data('shipping-option-id');
        const pickupPointCode = selectedOptionElement.data('service-point-code');
        const shippingService = selectedOptionElement.data('shipping-service');
        const defaultOption = selectedOptionElement.data('default-option');

        const dHLPostNummer = selectedOptionElement.hasClass('js-pickup-option-radio') ? $('.js-service-point-postnummer-input').val() : null;

        giftwrap.getGiftwrapDataForSelectedShippingOption(defaultOption, page, $previousRadioButton, function() {
            shipping.updateShippingInformation(shippingOptionId, shippingService, pickupPointCode, dHLPostNummer, function(response) {
                handleUpdateShippingInformationResponse(response.selectedShippingOption, dHLPostNummer);
            }, defaultOption, null, page);
        });
    }

    function handleUpdateShippingInformationResponse(selectedShippingOption, dHLPostNummer) {
        $addressChanged = true;
        if (selectedShippingOption.exclusionResult) {
            window.location.href = Urls.cartShow;
            return true;
        }
        updateStep2(true);
        if (dHLPostNummer) {
            setHiddenDHLPostNummer(dHLPostNummer);
        }
        flyout.closeFlyouts();
        updateOrderTotals(selectedShippingOption.totalPrice);
    }

    function openFlyout(originalElement, flyoutHtmlSelector) {
        $('.js-service-point-postnummer-input-error').addClass('hide');
        $(genericFlyout).addClass('change-delivery-flyout');

        const options = {
            open: function() {
                formHelpers.init();
                const $flyoutDropdown = $('.js-generic-flyout').find('.js-custom-select');
                $flyoutDropdown.selectric();
                if (!isSmallView()) {
                    $flyoutDropdown.attr('tabindex', '-1');
                }
            }
        };

        const flyoutHtml = $(flyoutHtmlSelector).html();
        flyout.loadFromHtml(flyoutHtml, options);

        $(originalElement).addClass('js-triggered-flyout');

        initEventsForSetStateFromPostalCode();

        $('[name$="_addToAddressBook"]').prop('checked', false);
        $('[name$="_addToAddressBook"]').change(function() {
            const isChecked = $(this).is(':checked');
            const $el = $('[name$="_addToAddressBook"]');
            $el.prop('checked', isChecked);
        });
    }

    function initEventsForSetStateFromPostalCode() {
        const $countries = $('[id$=_country]');

        $countries.each(function() {
            const $country = $(this);

            if ($country.val() === 'US') {
                const $postalCodeEl = $country.closest('fieldset').find('[id$=_postal]');

                $postalCodeEl.on('blur keydown', google.places.setStateFromPostalCode);
                $postalCodeEl.on('keydown.country, change.country',function(){
                    $postalCodeEl.data('changed', true);
                });

                google.places.setStateIDDataForPostalCode();
            }
        });
    }

    function setStateFromPostalCode(callback) {
        if (!callback || !$.isFunction(callback)) {
            return false;
        }

        const countryPromises = [];
        const $countries = $('[id$=_country]');

        $countries.each(function() {
            const $country = $(this);

            if ($country.val() !== 'US') {
                return;
            }

            const $postal = $country.closest('fieldset').find('[id$=_postal]');

            if (!$postal.data('changed')) {
                return;
            }

            $postal.data('state-id', '');

            countryPromises.push(new Promise(function(resolve) {
                const postalCode = $postal.val();
                const $stateUS = $postal.closest('fieldset').find('[id$=_stateUS]');

                google.places.getStateFromPostalCode(postalCode, $country.val(), function (state) {
                    $stateUS.val(state || '');
                    $stateUS.selectric('refresh');
                    $postal.data('state-id', state);
                    $postal.data('changed', false);
                    $stateUS.valid();

                    resolve();
                });
            }));
        });

        return Promise.all(countryPromises)
            .then(callback);
    }

    function fillHiddenDobFields() {
        const $day = $('#dwfrm_billing_paymentMethods_birthDayDay');
        const $month = $('#dwfrm_billing_paymentMethods_birthDayMonth');
        const $year = $('#dwfrm_billing_paymentMethods_birthDayYear');

        const values = $(this).val().split('/');
        $day.val(values[0]);
        $month.val(values[1]);
        $year.val(values[2]);
    }

    /**
     * @function
     * @description this will submit the shipping / billing form information and continue with step 2
     *
     * @param {any} e event object
     */
    function submitInformationForm(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink) {
        e.preventDefault();

        const country = $('[id$=_country]').val();
        if (country !== 'US') {
            return internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink);
        }

        return setStateFromPostalCode(function(){
            internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink);
        });
    }

    function internalSubmitInformation(e, successCallback, checkoutForm, socialCommerceSendCheckoutLink) {
        const avataxErrorMessageDivEl = $('div.js-avatax-address-validation-error');
        if (avataxErrorMessageDivEl) {
            avataxErrorMessageDivEl.addClass('hide');
        }
        if (!checkoutForm) {
            checkoutForm = $(e.target).closest('.js-checkout-form');
        }

        const shippingFormValidation = checkoutForm.validate();
        const validShippingForm = shippingFormValidation ? shippingFormValidation.checkForm() : false;
        const validBillingForm = $('#billing_address_form').validate().checkForm();
        const useSameBillingAddress = $('#checkbox_use_shipping_as_billing').prop('checked');

        const validForm = validShippingForm ? (useSameBillingAddress ? validShippingForm : validBillingForm) : validShippingForm;

        if (!validForm && socialCommerceSendCheckoutLink){
            return false;
        }

        if (!validForm) {
            checkoutForm.valid();
            return false;
        }

        if (e) {
            const redirectTo = $(e.target).data('redirecto');
            if (redirectTo) {
                window.location.href = redirectTo;
                return true;
            }

            const preventSubmit = $(e.target).data('prevent-submit');
            if (preventSubmit) {
                return false;
            }
        }

        const options = {
            url: checkoutForm.attr('action'),
            data: checkoutForm.serialize() + '&dwfrm_singleshipping_shippingAddress_save=save', // triggered action
            type: 'POST',
            success: function (result) {
                if (socialCommerceSendCheckoutLink) {
                    socialCommerceSendCheckoutLink($(e.target), 1);
                    return;
                }
                if (result.location && !result.errorMessage) {
                    window.location = result.location;
                    return;
                }
                if (result.errorMessage) {
                    checkoutPostalCode.showPostalCodeErrors($('#dwfrm_singleshipping_shippingAddress_addressFields_postal', checkoutForm),
                    checkoutForm.find('button[type=submit]'), shippingFormValidation, result.errorMessage);
                    checkoutForm.validate();
                    step1ButtonLoading(false);
                    return;
                }
                if (result.addressValidationError) {
                    if (avataxErrorMessageDivEl && avataxErrorMessageDivEl.parents('div.js-flyout-container').length) {
                        $('.js-avatax-address-validation-error-message').html(result.addressValidationError);
                        avataxErrorMessageDivEl.removeClass('hide');
                        step1ButtonLoading(false);
                        return;
                    }

                    $('.js-address-validation-error-text').html(result.addressValidationError);
                    toaster.open({
                        target: $('.js-address-validation-toaster')
                    });
                    step1ButtonLoading(false);
                    return;
                }
                if (!result.valid && result.validationResults) {
                    fillValidationFailsFromBE(result.validationResults, checkoutForm);
                    step1ButtonLoading(false);
                    return;
                }

                updateStep2(false, function() {
                    step1ButtonLoading(false);
                    if (successCallback) {
                        successCallback();
                    }
                });

            },
            statusCode: {
                401: function(data) {
                    window.location = data.getResponseHeader('Location');
                }
            }
        };

        if (!socialCommerceSendCheckoutLink) {
            step1ButtonLoading(true);
        }
        $.ajax(options);
        return true;
    }

    function step1ButtonLoading(turnOn) {
        const $step1ContinueButton = $('.js-step-1-continue-btn');
        const $spinnerStep1 = $('.js-step-1-spinner');

        $step1ContinueButton.toggleClass('button-loading', turnOn);
        $(stickyButtonSelector).toggleClass('button-loading', turnOn);
        $spinnerStep1.parent().toggleClass('button-loading', turnOn);
        $spinnerStep1.toggleClass('spinner-visible', turnOn);
    }

    function fillValidationFailsFromBE(errors, form) {
        const formValidator = form.validate();
        let selector;
        const errorMessages = {};
        for (let i = 0; i < errors.length; i++) {
            if (errors[i].error) {
                if (errors[i].addresstype == 'billingAddress') {
                    if ($('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress').is(':checked')) {
                        $('#dwfrm_singleshipping_shippingAddress_useAsBillingAddress').attr('checked', false).change();
                    }
                    selector = 'dwfrm_billing_' + errors[i].addresstype + '_addressFields_' + errors[i].errorField;
                } else {
                    selector = 'dwfrm_singleshipping_' + errors[i].addresstype + '_addressFields_' + errors[i].errorField;
                }

                errorMessages[selector] = errors[i].reason;
                formValidator.showErrors(errorMessages);
            }
        }
    }

    function updateAddressSummary(addressForm) {
        if (!addressForm) {
            addressForm = getShippingForm();
        }

        const messageFormat = addressForm.find('.js-address-summary-format').val() || '';
        if (messageFormat === '') {
            return;
        }

        const isHomeDeliveryActive = $('.js-shipping-option-radio:checked').length > 0;
        const isBillingAddress = $('.js-billing-address-holder').length > 0;

        const firstName = addressForm.find('input.firstName').val() || '';
        const lastName = addressForm.find('input.lastName').val() || '';
        const phone = addressForm.find('input.phone').val() || '';

        const pickupPointName = $('.js-pickup-point-name').val();
        const pickupPointAddress = $('.js-pickup-point-address').val();
        const pickupPointPostalCode = $('.js-pickup-point-postalcode').val();
        const pickupPointCity = $('.js-pickup-point-city').val();

        const pickupInStoreAddress = $('.js-pickup-in-store-address').val();
        const pickupInStoreTime = $('.js-pickup-in-store-time').val();
        let fullMessage = '';
        if (!isHomeDeliveryActive && !isBillingAddress && pickupPointName && pickupPointAddress && pickupPointPostalCode && pickupPointCity) {
            let dHLPostNummer = '';
            if (addressForm.find('.js-service-point-postnummer-input').length > 0 && addressForm.find('.js-service-point-postnummer-input').data('distributor') === 'DHL_DE') {
                const dHLPostNummerFormat = $('.js-address-dhlpostnummer-format').val() || '';
                dHLPostNummer = String.format(dHLPostNummerFormat, addressForm.find('.js-dhl-post-nummer').val());
            }
            fullMessage = String.format(messageFormat, pickupPointName, firstName, lastName,
                pickupPointAddress, pickupPointPostalCode, pickupPointCity, dHLPostNummer, phone);
        } else if (!isHomeDeliveryActive && !isBillingAddress && pickupInStoreAddress && pickupInStoreTime) {
            fullMessage = String.format(messageFormat, pickupInStoreAddress, pickupInStoreTime);
        } else {
            const preselectedCity = $('input[name="preselected-shipping-city"]').val() || '';

            const street = addressForm.find('input.street').val() || '';
            const houseNumber = addressForm.find('input.houseNumber').val() || '';
            const houseNumberExtension = addressForm.find('input.houseNumberExtension').val() || '';
            const address1 = addressForm.find('input.address1').val() || '';
            const address2 = addressForm.find('input.address2').val() || '';
            const cityFormField = addressForm.find('[id$=_addressFields_city]');
            let city = preselectedCity;
            if (cityFormField.prop('tagName') === 'INPUT') {
                city = cityFormField.val() || preselectedCity;
            } else if (cityFormField.prop('tagName') === 'SELECT') {
                const selectedCity = cityFormField.find('option:selected');
                city = selectedCity.length && selectedCity.prop('index') !== 0 ? selectedCity.text() : '';
            }
            const state = addressForm.find('select.stateUS').val() || '';
            const postalCode = addressForm.find('input.postal').val() || '';
            const country = $(document).find('input.js-country-name').val() || '';
            const phone = addressForm.find('input.phone').val() || '';
            const districtFromField = addressForm.find('select.district');
            const selectedDistrict = districtFromField.find('option:selected');
            let district = selectedDistrict.length && selectedDistrict.prop('index') !== 0 ? selectedDistrict.text() : '';
            const subdistrictFromField = addressForm.find('select.subdistrict');
            const selectedSubdistrict = subdistrictFromField.find('option:selected');
            let subdistrict = selectedSubdistrict.length && selectedSubdistrict.prop('index') !== 0 ? selectedSubdistrict.text() : '';
            district = district !== '' ? ', ' + district : '';
            subdistrict = subdistrict !== '' ? ', ' + subdistrict : '';
            const email = '';
            const stateCode = '';

            const $companyDetailsForm = getCompanyDetailsForm(addressForm);
            const taxIdNumberFormat = addressForm.find('.js-tax-id-number-format').val() || '';
            const companyName = $companyDetailsForm.find('input.companyName').val() || '';
            const cocNumber = $companyDetailsForm.find('input.cocNumber').val() || '';
            const taxIdNumber = $companyDetailsForm.find('input.vatNumber').val() || getNifValue($companyDetailsForm);

            const fullTaxIdNumber = taxIdNumber && taxIdNumber.length > 0 ? String.format(taxIdNumberFormat, taxIdNumber) : '';

            fullMessage = String.format(messageFormat, firstName, lastName,
            street, houseNumber, houseNumberExtension,
            address1, address2, city, state,
            postalCode, country, phone, district, subdistrict,
            email, stateCode,
            companyName, cocNumber, fullTaxIdNumber);
        }

        addressForm.find('.js-address-holder').html(fullMessage);
    }

    function getNifValue(form) {
        if (form.find('input.addNifNumber').is(':checked')) {
            return form.find('input.nifNumber').val();
        }

        return '';
    }

    function getShippingForm() {
        let $addressForm = $('.js-flyout-content > div').find('.js-shipping_address_form');
        if ($addressForm.length === 0) {
            $addressForm = $('.js-step-1-content').find('.js-shipping_address_form');
        }
        return $addressForm;
    }

    function getBillingForm() {
        let $billingForm = $('.js-flyout-content > div').find('.js-billing-form');
        if ($billingForm.length === 0) {
            $billingForm = $('.js-step-1-content').find('.js-billing-address-form');
        }
        return $billingForm;
    }

    function getCompanyDetailsForm(addressForm) {
        if (companyDetailsExists(addressForm)) {
            return addressForm;
        }

        addressForm = getShippingForm();
        if (companyDetailsExists(addressForm)) {
            return addressForm;
        }

        return getCheckoutForm().find('#company_details_form');
    }

    function getCheckoutForm() {
        let $checkoutForm = $('.js-flyout-content > div').find('.js-checkout-form');
        if ($checkoutForm.length === 0) {
            $checkoutForm = $('.js-step-1-content').find('.js-checkout-form');
        }
        return $checkoutForm;
    }

    function companyDetailsExists(addressForm) {
        return addressForm.find('input.cocNumber').length > 0 || addressForm.find('input.companyName').length > 0 || addressForm.find('input.vatNumber').length > 0 || addressForm.find('input.nifNumber').length > 0;
    }

    function processHistoryUpdates(skipHistoryUpdate, stepIndex) {
        if (skipHistoryUpdate === undefined || !skipHistoryUpdate) {
            window.history.pushState({'step': stepIndex}, 'step ' + stepIndex, window.location.href);
        }
    }

    function updateStep1(skipHistoryUpdate) {
        if ($addressChanged) {
            $.ajax({
                type: 'GET',
                url: Urls.checkoutStep1,
                success: function (data) {
                    showStep1(data);

                    ritualsStyles.initInputStyles();
                    jumpToStep($step1, 1, skipHistoryUpdate);
                    $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');

                }
            });
            return;
        }

        $('.js-step-1-spinner').removeClass('spinner-visible');
        $('.js-step-1-continue-btn').removeClass('button-loading')
            .removeClass('button-loading')
            .removeClass('btn-loader');
        $step2.addClass('disabled');
        $step3.addClass('disabled');
        jumpToStep($step1, 1, skipHistoryUpdate);
    }

    function updateStep2(skipHistoryUpdate, onLoadComplete) {
        processHistoryUpdates(skipHistoryUpdate, 2);

        $.ajax({
            type: 'GET',
            url: Urls.checkoutStep2,
            success: function (data) {
                google.tagManager.pushVirtualPage(Urls.checkoutStep2, Resources.CHECKOUT_STEP2_TITLE, 'review');

                showStep2(data);
                updateSummary();

                updateStickyButton('step2');

                if (onLoadComplete) {
                    onLoadComplete();
                }

                ritualsStyles.initInputStyles();
                $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');
            }
        });
    }

    function showStep2(data) {
        $currentStep = $step2;
        $(stickyButtonSelector).removeClass('button-loading');

        $step1.removeClass('current').removeClass('selected');
        $step1.content.removeClass('open').hide();

        $step3.removeClass('current').removeClass('selected');
        $step3.addClass('disabled');
        $step3.content.hide().removeClass('open');

        $step2.addClass('current selected');
        $step2.content.show().addClass('open').prev().addClass('open');

        $step2.removeClass('disabled');

        if (data) {
            $step2.content.html(data);
            customSelect.init();

        }

        shipping.handleNifStep2();
        // copy the regex from the shipping zip code
        const zipcodeRegex = $('#dwfrm_billing_billingAddress_addressFields_postal').attr('regex');
        $('.js-service-point-zipcode-input').attr('regex', zipcodeRegex);

        $(document).on('keydown', '.js-step-2-continue-btn', step2KeyPressHandler);

        $(document).on('click', '.js-checkout-sticky-button', function () {
            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');
        });

        $(document).off('click', '.js-step-2-continue-btn');
        $(document).on('click', '.js-step-2-continue-btn', function () {
            $('.js-service-point-postnummer-input-error').addClass('hide');

        const $shippingOption = $('.js-option-radio:checked');
        const deliveryMethod = $shippingOption.length ? $shippingOption.data('delivery-method-type') : 'unknown';
            google.tagManager.pushDeliveryMethod(deliveryMethod);

            $(this).addClass('button-loading');
            $(this).find('.js-spinner-general').addClass('spinner-visible');

            updateStep3();
        });
    }

    function showStep1(data) {
        $currentStep = $step1;
        $addressChanged = false;
        $(stickyButtonSelector).removeClass('button-loading');

        $step2.removeClass('current').removeClass('selected');
        $step2.addClass('disabled');
        $step2.content.removeClass('open').hide();

        $step3.removeClass('current').removeClass('selected');
        $step3.addClass('disabled');
        $step3.content.hide().removeClass('open');

        $step1.addClass('current selected');
        $step1.content.show().addClass('open').prev().addClass('open');

        if (data) {
            $step1.content.html(data);
            customSelect.init();
            shipping.handleBillingAddressFields();
            shipping.handleNifNumberSection();
        }

        $step1.removeClass('disabled');
    }

    function updateStep3(skipHistoryUpdate) {
        processHistoryUpdates(skipHistoryUpdate, 3);

        const accountNumberInput = $('input.js-dhl-post-nummer');
        $(document).off('keydown', step2KeyPressHandler);

        const checkoutStep3 = {
            type: 'GET',
            url: Urls.checkoutStep3,
            data: {
                openStep: pageContext.openStep,
                paymentStatus: pageContext.paymentStatus,
                paymentMethodID: pageContext.paymentMethodID,
                accountServiceNumber: accountNumberInput.length ? accountNumberInput.val() : null
            },
            success: function (data) {
                updateSummary();
                google.tagManager.pushVirtualPage(Urls.checkoutStep3, Resources.CHECKOUT_STEP3_TITLE, 'payment');
                showStep3(data);

                updateStickyButton('step3');

                $('.js-checkout-sticky-button').removeClass('button-loading');
                $('.js-checkout-sticky-button').find('.js-spinner-general').removeClass('spinner-visible');

                $('html, body').delay('fast').animate({scrollTop: 0}, 'fast');
            }
        };

        if ($('.js-pickup-option-radio').is(':checked') && $('.js-service-point-postnummer-input').length && accountNumberInput.length) {
            $.ajax({
                type: 'GET',
                url: Urls.checkoutCheckAccountServiceNumberForPaazl,
                data: {
                    accountServiceNumber: accountNumberInput.val()
                },
                success: function (data) {
                    if (data.valid) {
                        $.ajax(checkoutStep3);
                    } else {
                        $('.js-service-point-postnummer-input-error').removeClass('hide');
                    }
                }
            });
        } else {
            $.ajax(checkoutStep3);
        }
    }

    function showStep3(data) {
        $step1.removeClass('current').removeClass('selected');
        $step1.content.hide().removeClass('open');

        $step2.removeClass('current').removeClass('selected').removeClass('disabled');
        $step2.content.hide().removeClass('open');

        $step3.addClass('current selected');
        $step3.content.show().addClass('open');

        $step3.removeClass('disabled');

        if (data) {
            $step3.content.html(data);
            customSelect.init();
        }

        $currentStep = $step3;

        if (!$('.js-hidden-select').hasClass('js-custom-select')) {
            $('.js-hidden-select').addClass('js-custom-select').selectric();
            if (!isSmallView()) {
                $(document).find('.js-custom-select').attr('tabindex', '-1');
            }
        }

        $('.js-summary').addClass('step3');

        const $selectedPaymentMethod = $('#payment input[type=radio][name=brandCode]:checked').val();
        if (!$selectedPaymentMethod) {
            $('#payment input[type=radio][name=brandCode]:first').prop('checked', true);
        }

        // If Klarna Getting Address is used, Use Klarna Payment Method automatically
        if ($('#js_klarna_valid_address').length > 0 && $('#js_klarna_valid_address').val() == '1') {
            if ($('li.js-klarna input[type="radio"]').length > 0) {
                $('li.js-klarna input[type="radio"]').trigger('click');
            }
        }

        //Copy same regex to payment phone field if exist
        checkPhoneFieldRegex();

        // init validations
        validator.init();

        if ($('.js-ideal').find('input[type=radio]').is(':checked')) {
            $('.js-ideal').find('.js-method-extra').slideDown();
        }

        updateEuroBonusInputField();
    }

    //go to the other step by click on the 'save'/'edit' button
    function jumpToStep($stepOpen, stepIndex, skipHistoryUpdate) {
        processHistoryUpdates(skipHistoryUpdate, stepIndex);

        $currentStep.removeClass('current').removeClass('selected');
        $currentStep.content.removeClass('open').hide();

        $stepOpen.addClass('current selected');
        $stepOpen.content.addClass('open').show();
        if ($stepOpen == $step2) {
            $(document).on('keydown', step2KeyPressHandler);
        } else {
            $(document).off('keydown', step2KeyPressHandler);
        }
    }

    function pay(e) {
        if (!validatePaymentMethod()) {
            e.preventDefault();
        }

        pushCheckoutPaymentMethodEvent();

        $(e.target).addClass('button-loading');
        $(e.target).find('.js-spinner-general').addClass('spinner-visible');

        //check eurobonus code is valid, before submit
        const isChecked = $('[id$=sasEurobonusMember]').is(':checked');
        if (isChecked) {
            const memberCode = $('#dwfrm_payment_eurobonusMember_sasEurobonusMemberCode').val();
            if (memberCode && memberCode.length > 0) {
               e.preventDefault();
               $('.js-eurobonus-dropdown').removeClass('eurobonus-valid');
                validateEurobonusMemberId(memberCode, function() {
                    $('#payment').submit();
                }, null);
            }
        }
    }

    function validatePaymentMethod() {
        return $('#payment').validate().form();
    }

    function paymentMethodChanged() {
        $('#payment').validate().resetForm();
        const selectedMethod = $(this).val();

        $('#issuerId').removeClass('required error');
        $('#dwfrm_billing_paymentMethods_birthday').removeClass('required error');
        $('#dwfrm_billing_paymentMethods_phone').removeClass('required error');

        if (selectedMethod === 'ideal') {
            const $issuer = $('#issuerId');
            $issuer.addClass('required');
        }

        if (selectedMethod === 'klarna') {
            const $dob = $('#dwfrm_billing_paymentMethods_birthday');
            const $phone = $('#dwfrm_billing_paymentMethods_phone');
            $dob.addClass('required');
            $phone.addClass('required');
        }

        if (selectedMethod === 'rituals') {
            $('[id$=sasEurobonusMember]').prop('disabled', true);
            $('[id$=sasEurobonusMember]').prop('checked', false);
            $('.js-eurobonus-dropdown').addClass('hide');
        } else {
            $('[id$=sasEurobonusMember]').prop('disabled', false);
        }

        $('#selectedPaymentMethodID').val(selectedMethod);

        const $methodElement = $('.js-' + selectedMethod);
        if ($methodElement.length > 0) {
            const $extra = $methodElement.children('.js-method-extra');
            $('.js-method-extra').slideUp(animationSpeed);
            if ($extra.length > 0) {
                $extra.slideDown(animationSpeed);
            }
        }
    }

    function checkPhoneFieldRegex() {
        const shippingPhoneFieldRegex = $($('input[name$="_shippingAddress_addressFields_phone"]')).attr('regex');
        if (shippingPhoneFieldRegex !== undefined) {
            $('#dwfrm_billing_paymentMethods_phone').attr('regex', shippingPhoneFieldRegex);
        }
    }

    function idealBankChanged() {
        $('li.js-ideal input[type="radio"]').prop('checked', true);
    }

    function pushCheckoutPaymentMethodEvent() {
        const selectedPaymentMethod = $('#payment input[type=radio][name=brandCode]:checked').val();

        let selectedBank = 'chosen';
        if (selectedPaymentMethod === 'ideal') {
            selectedBank = $('select#issuerId > option:checked').text().trim();
        }

        google.tagManager.pushCheckoutPaymentMethodEvent(selectedPaymentMethod, selectedBank);
    }

    /**
     * @function
     * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
     */
    function updateSummary() {
        const $summary = $('.js-summary');

        // indicate progress
        progress.show($summary);

        // load the updated summary area
        $summary.load(Urls.summaryRefreshURL, function () {
            // hide edit shipping method link
            //miniCart.adjustPricePadding();
            adjustPricePadding();
            damHelper.updateImages($('.js-summary'));
            $summary.fadeIn('fast');
            $summary.find('.checkout-mini-cart .minishipment .header a').hide();
            $summary.find('.order-totals-table .order-shipping .label a').hide();
        });
    }

    function validateEurobonusMemberId(memberId, onSuccess, onError) {
        const $btnValidateEurobonusMember = $('#btnValidateEurobonusMember');
        const $eurobonusError = $('#eurobonusError');
        const $eurobonusBlock = $('.js-eurobonus-dropdown');

        $eurobonusBlock.removeClass('eurobonus-valid');
        $btnValidateEurobonusMember.removeClass('btn-success').addClass('btn-loading');
        $eurobonusError.addClass('hide');

        $.ajax({
            type: 'GET',
            url: Urls.checkoutValidateEurobonusMemberId,
            data: {memberId: memberId},
            success: function(data) {
                if (data && data.isMemberValid) {
                    $btnValidateEurobonusMember.addClass('btn-success');
                    $eurobonusBlock.addClass('eurobonus-valid');
                    $('#validatedEurobonusCode').val(memberId);

                    if (onSuccess) {
                        onSuccess();
                    }
                } else {
                    $eurobonusBlock.removeClass('eurobonus-valid');
                    showInvalidEurobonusMemberCode(onError);
                }
            },
            error: function(){
                showInvalidEurobonusMemberCode(onError);
                $eurobonusBlock.removeClass('eurobonus-valid');
            },
            complete: function() {
                $btnValidateEurobonusMember.removeClass('btn-loading');
            }
        });
    }

    function showInvalidEurobonusMemberCode(onError){
        const $sasEurobonusMemberCode = $('.js-eurobonus-code-input');
        const $eurobonusError = $('#eurobonusError');
        const error = $sasEurobonusMemberCode.data('invalid-code-text');

        $eurobonusError.removeClass('hide').text(error);
        $sasEurobonusMemberCode.addClass('error');

        //TODO: This should be done in validator.js
        //Scroll to the input field and focus, but only if this is the first error
        let allErrors = $('input.error');
        if (allErrors.first().is($sasEurobonusMemberCode)) {
            setTimeout(function() { //Small timeout to avoid conflicting with the validator.js animation
                allErrors = $('input.error'); // refreshing all input errors

                if (allErrors.first().is($sasEurobonusMemberCode)) {
                    $('html, body').animate({
                        scrollTop: $sasEurobonusMemberCode.offset().top - $('.js-header').height() - 30
                    }, 50);
                    $sasEurobonusMemberCode.focus();
                }
            }, 100);
        }

        if (onError) {
            onError();
        }
    }

     function openStep(stepNumber, skipHistoryUpdate) {
        animationSpeed = 0;
        switch (stepNumber) {
            case 2:
                updateStep2(skipHistoryUpdate);
                updateStickyButton('step2');
                break;
            case 3:
                updateStep3(skipHistoryUpdate);
                updateStickyButton('step3');
                break;
            case 1:
            default:
                updateStep1(skipHistoryUpdate);
                updateStickyButton('step1');
                break;
        }
        animationSpeed = 400;
    }

    function showStep(stepNumber) {
        switch (stepNumber) {
            case 2:
                showStep2();
                updateStickyButton('step2');
                break;
            case 3:
                showStep3();
                updateStickyButton('step3');
                break;
            case 1:
            default:
                showStep1();
                updateStickyButton('step1');
                break;
        }
    }

    function updateDeliveryReview(selectedShippingOption) {
        updateOrderTotals(selectedShippingOption.totalPrice);
        updateAddressSummary();
        updateStep2(true);
    }

    function updateOrderTotals(price) {
        $('.js-order-totals .js-order-value').text(price);
        $('.js-checkout-sticky-bar .js-sticky-price-container .order-total-amount').text(price);
    }

    function setHiddenDHLPostNummer(dHLPostNummer) {
        const hiddenDHLPostNummer = $('input.js-dhl-post-nummer');
        hiddenDHLPostNummer.val(dHLPostNummer);
    }

    return {
        init: init,
        updateSummary: updateSummary,
        submitInformationForm: submitInformationForm
    };
};

module.exports = new SinglePageCheckout();

},{"../../dam/dam-helper":419,"../../flyout":425,"../../giftwrap":433,"../../modules/google":453,"../../modules/helpers/isSmallView":469,"../../modules/util/fillAddressFields":484,"../../modules/util/getCountryFromLocaleCookie":488,"../../prefill-address":575,"../../progress":584,"../../rituals-form-helper":590,"../../rituals-styles":592,"../../select-custom":596,"../../toaster":605,"../../validator":607,"./address":522,"./checkoutPostalCode":523,"./klarnaGeneral":525,"./shipping":527}],529:[function(require,module,exports){
'use strict';

const stockMissingStockWarning = {
    createDialog: function () {
        if (!$('#storeMissingStockWarning').length) {
            return;
        }
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.MODAL_STORE_NOINVENTORY_HEADING
            },
            paragraphs: [
                {
                    text: window.Resources.MODAL_STORE_NOINVENTORY_MESSAGE
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_STORE_NOINVENTORY_BUTTON_OK,
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });
    }
};

module.exports = stockMissingStockWarning;

},{}],530:[function(require,module,exports){
'use strict';

const taxFreeThresholdPassedWarning = {
    createDialog: function () {
        const $taxFreeThresholdBlock = $('.js-tax-warning');
        const $shouldShowModal = $taxFreeThresholdBlock.attr('data-show-threshold-modal');

        if (!$shouldShowModal) {
            return;
        }

        const taxFreeThresholdPrice = $taxFreeThresholdBlock.data('taxFreeThresholdPrice');
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: String.format(window.Resources.MODAL_TAX_WARNING_HEADING, taxFreeThresholdPrice)
            },
            paragraphs: [{
                text: String.format(window.Resources.MODAL_TAX_WARNING_MESSAGE, taxFreeThresholdPrice)
            }],
            ctaHolder: {},
            buttons: [{
                type: 'btn',
                label: window.Resources.MODAL_TAX_WARNING_OK,
                shouldCloseModal: true
            }],
            closeElement: {
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true,
            customClass: 'threshold-warning'
        });
    }
};

module.exports = taxFreeThresholdPassedWarning;

},{}],531:[function(require,module,exports){
'use strict';

function expandIngredient() {
    $('.js-expand-collection-ingredients').off('click').on('click', function () {
        const $ingredientsBlock = $(this).closest('.js-collection-ingredients');
        const $ingredientItem = $ingredientsBlock.find('.js-collection-text-holder .js-collection-ingredient-col');
        if (!$ingredientsBlock.hasClass('open')) {
            $ingredientsBlock.addClass('open');
            $ingredientItem.stop().show();
        } else {
            $ingredientsBlock.removeClass('open');
            $ingredientItem.not(':first').stop().slideUp(400);
            $('html, body').animate({scrollTop: ($ingredientsBlock.offset().top - 60)}, 400);
        }
    });
}

/**
* @description Initialize block
*/
function initBlock() {
    expandIngredient();
}

const collectionIngredients = {
    init: function() {
        // if ingredients block exists, init
        if ($('.js-collection-ingredients').length > 0){
            initBlock();
        }
    }
};

module.exports = collectionIngredients;

},{}],532:[function(require,module,exports){
'use strict';

function descriptionFadeToggle() {
    const $descriptionBlock = $('.js-collection-description');
    if ($descriptionBlock.length) {
        const offset = $(window).height() / 2;
        const descriptionBlockRect = $descriptionBlock[0].getBoundingClientRect().top;

        if (descriptionBlockRect < offset) {
            if (!$descriptionBlock.hasClass('fadein')) {
                $descriptionBlock.addClass('fadein');
            }
        }
    }
}

/**
 * @description Initialize block
 */
function initBlock() {
    descriptionFadeToggle();
}

/**
 * @description Initialize event handlers for the discover block
 */
function initializeEvents() {
    $(window).scroll(function () {
        descriptionFadeToggle();
    });
}

const description = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = description;

},{}],533:[function(require,module,exports){
'use strict';

const isSmallView = require('../../modules/helpers/isSmallView');
const $imageColumn = $('.js-collection-image-column');

function imageSwitcher() {
    const $imagePlaceholder = $('.js-collection-mobile-placeholder');
    const $imageHolderDesktop = $imageColumn.find('.js-image-holder');
    const $imageHolderMobile = $imagePlaceholder.find('.js-image-holder');

    if (isSmallView()) {
        if ($imageHolderMobile.length < 1) {
            $imagePlaceholder.prepend($imageHolderDesktop);
        }
    } else {
        if ($imageHolderDesktop.length < 1) {
            $imageColumn.prepend($imageHolderMobile);
        }
    }
}

//do not tab through the product name except on the product slider
function removeFocus() {
    $imageColumn.parent().find('.js-product-name-link').attr('tabindex', '-1');
}

/**
 * @description Initialize block
 */
function initBlock() {
    imageSwitcher();
    removeFocus();
}

/**
 * @description Initialize event handlers for the discover block
 */
function initializeEvents() {
    $(window).on('resize', function () {
        imageSwitcher();
    });
}

const highlight = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = highlight;

},{"../../modules/helpers/isSmallView":469}],534:[function(require,module,exports){
'use strict';

const responsiveBg = require('../../responsive-background');
const collectionIngredients = require('./collection-ingredients');
const multiCol = require('../../multi-col');
const highlight = require('./highlight');
const description = require('./description');
const video = require('../../video');
const productTile = require('../../product-tile');
const scrollOffset = 300;
const productFilter = require('../../product-filter');

const $filterBlockSelector = '.js-product-filter-block';

function initEvents(){
    // init general events
    $(document).on('click', '.js-collection-shop-all', function() {
        const collectionName = 'trigger-the-' + $(this).text().split(' ').pop().toLowerCase();
        let collection = null;
        if (document.querySelector('[data-anchor-id=' + collectionName + ']')){
            collection = document.querySelector('[data-anchor-id=' + collectionName + ']');
            productFilter.changeTab(collection);
        }
        $('html, body').animate({scrollTop: $(collection || '.js-product-grid-block').offset().top}, 800);
    });

    $(document).on('click', '.js-trigger-product-list-filter', function() {
        if ($filterBlockSelector.length == 0) {
            return;
        }

        const $this = $(this);
        const triggerName = $this[0].href.split('#').pop();
        if (!triggerName) {
            return;
        }

        let collection = null;
        if (document.querySelector('[data-anchor-id=' + triggerName + ']')){
            collection = document.querySelector('[data-anchor-id=' + triggerName + ']');
            productFilter.changeTab(collection);
        }
        $('html, body').animate({scrollTop: $('.js-product-grid-block').offset().top}, 800);
    });

    $('.js-samples-shop-all').on('click', function() {
        $('html, body').animate({scrollTop: $('.js-collection-cards-block').offset().top}, 800);
    });

    //Load product grid once we scroll past the navigation
    $(document).on('scroll.collectiongrid', function() {
        if ($(window).scrollTop() < scrollOffset) {
            return true;
        }

        $(document).off('scroll.collectiongrid'); //Only load once

        if ($('.js-grid-placeholder').length === 0) { //Only fire if there's a normal product grid in the page (i.e. not for "special" pages like Namaste)
            return;
        }

        let url = '';
        let data = {};
        const subCollectionUrl = $('.js-subcollection-product-grid-url');

        if (subCollectionUrl.length > 0) {
            url = subCollectionUrl.val();
            data = {
                format: 'ajax'
            };
        } else {
            url = Urls.productPartialGrid;
            data = {
                ritual: $('.js-collection-id').val(),
                source: 'collection'
            };
        }

        $.ajax({
            url: url,
            data: data,
            success: function (data) {
                if (!data) {
                    return;
                }

                $('.js-grid-placeholder').html(data).imagesLoaded(function() {
                    if (document.readyState === 'complete') {
                        initGrid();
                    } else {
                        $(window).on('load', function () {
                            initGrid();
                        });
                    }
                });
            }
        });
    });
}

function initGrid() {
    const grid = require('../../grid');
    grid.init();
    video.initGeneric();

    if ($('.js-grid-spinner').length) {
        $('.js-grid-spinner').removeClass('spinner-visible');
    }
}

const collection = {
    init: function() {
        initEvents();

        responsiveBg.init();
        collectionIngredients.init();
        multiCol.init();
        highlight.init();
        description.init();
        video.initGeneric();
        video.initCollection();
        productTile.init();
    }
};

module.exports = collection;

},{"../../grid":437,"../../multi-col":514,"../../product-filter":577,"../../product-tile":581,"../../responsive-background":588,"../../video":608,"./collection-ingredients":531,"./description":532,"./highlight":533}],535:[function(require,module,exports){
'use strict';

const ajax = require('../modules/ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function () {
                page.refresh();
            }
        });
    })
    .on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        const url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
};

},{"../modules/ajax":449,"../page":518,"../product-tile":581,"../quickview":585}],536:[function(require,module,exports){
'use strict';

const JsBarcode = require('jsbarcode');
const defaultOptions = {format: 'ean13', fontSize: 0, margin: 0, height: 100, width: 4};
/**
 * @function
 * @description Initializes the barcode generator
 */
exports.init = function (options) {
    if ($('#js-loyalty-id').length > 0) {
        const cardNumber = $('#js-loyalty-id').val();
        JsBarcode('#js-loyalty-image', cardNumber, options || defaultOptions);
    }

    if ($('.js-member-number').length > 0) {
        const cardNumber = $('.js-member-number').data('member-number');
        const config = {
            background: '#ffffff',
            flat: true,
            fontSize: 0,
            format: 'ean13',
            height: 36,
            lineColor: '#000000',
            margin: 0,
            width: 3
        };

        JsBarcode('.js-member-barcode', cardNumber, config);
    }
};

},{"jsbarcode":50}],537:[function(require,module,exports){
'use strict';
/**
* @class faq
*/

// jquery accordion
require('jquery-ui/ui/widgets/accordion');

const ajax = require('../modules/ajax'),
    getScreenBreakpointSize = require('../modules/util/getScreenBreakpointSize'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    isMobileWidth = require('../modules/util/isMobileWidth'),
    customerservice = require('../customerservice'),
    ritualsFormHelper = require('../rituals-form-helper.js'),
    validator = require('../validator');

const faq = {
    def : {
        headerHeight : 60,
        classResponsive: 'faq-view-mobile',
        container : $('.js-faq-container'),
        item : $('.js-faq-menu-item'),
        optionFirst : $('.js-faq-menu-option:first-child'),
        option : $('.js-faq-menu-option'),
        rightContent : $('.faq-right-content'),
        breakpointSize : getScreenBreakpointSize($(window).width())
    },

    getResponsiveDesign: function () {
        if (faq.def.breakpointSize === 'small') {
            faq.def.container.addClass(faq.def.classResponsive);
        } else {
            faq.def.container.removeClass(faq.def.classResponsive);
        }

        faq.def.rightContent.find('.js-faq-back-button').click(function(){
            faq.def.container.removeClass('active-content');
            $('.faq-contact').removeAttr('style');
        });
    },

    getContentFromFolder : function(folderId, activeQuestionId){
        ajax.load({
            type: 'POST',
            url: Urls.pageFaq,
            target: $('.js-ajax-content'),
            data: {fid: folderId},
            callback: function () {
                let active = false;
                if (activeQuestionId){
                    //Get the question that should start out active
                    const accordionOptions = $('.js-faq-accordion [data-qid]');
                    const selectedOption = $('.js-faq-accordion [data-qid=' + activeQuestionId + ']');
                    const selectedQuestionIndex = accordionOptions.index(selectedOption);
                    if (selectedQuestionIndex > -1) {
                        active = selectedQuestionIndex;
                    }
                }

                $('.js-faq-accordion').accordion({
                    collapsible : true,
                    active: active,
                    header: '> li > :first-child',
                    icons : {
                        'header' : 'icon-plus2',
                        'activeHeader': 'icon-minus2'
                    },
                    heightStyle: 'content',
                    beforeActivate: function(event, ui) {
                        let currHeader;
                        let currContent;

                        // The accordion believes a panel is being opened
                        if (ui.newHeader[0]) {
                            currHeader = ui.newHeader;
                            // The accordion believes a panel is being closed
                        } else {
                            currHeader = ui.oldHeader;
                        }

                        // Since we've changed the default behavior, this detects the actual status
                        const isPanelSelected = currHeader.attr('aria-selected') == 'true';

                        const questionId = $(currHeader).closest('li').data('qid');
                        if (isPanelSelected) {
                            const questionIdInUrl = getQueryStringParams(window.location.search)['qid'];
                            if (questionIdInUrl == questionId) { //Closing the panel currently in the URL
                                const url = removeParamFromURL(window.location.href, 'qid');
                                setUrl(url);
                            }
                        } else {
                            const url = replaceParameterInUrl(window.location.href, 'qid', questionId);
                            setUrl(url);
                        }

                        if (!isMobileWidth()) {
                            currContent = currHeader.next('.ui-accordion-content');

                            // Toggle the panel's header
                            currHeader.stop().toggleClass('ui-corner-all',isPanelSelected).toggleClass('accordion-header-active ui-state-active ui-corner-top', !isPanelSelected).attr('aria-selected', ((!isPanelSelected).toString()));

                            // Toggle the panel's icon
                            currHeader.children('.ui-icon').toggleClass('icon-plus2',isPanelSelected).toggleClass('icon-minus2', !isPanelSelected);

                            // Toggle the panel's content
                            currContent.stop().toggleClass('accordion-content-active',!isPanelSelected);

                            if (isPanelSelected) {
                                currContent.slideUp();
                            } else {
                                currContent.slideDown();
                            }

                            return false; // Cancels the default action
                        }
                    }
                });
                $('.faq-contact').show();
                faq.getResponsiveDesign();
            }
        });
    },

    getContactForm: function () {
        const url = appendParamToURL(Urls.contactUs, 'format', 'ajax');
        ajax.load({
            url: url,
            target: $('.js-ajax-content'),
            callback : function () {
                window.scrollTo(0, 0);
                $('.faq-contact').hide();
                faq.def.rightContent.find('h1').prepend('<span class="icon--medium icon-arrow3--left"></span>');
                faq.getResponsiveDesign();
                customerservice.init();
                $('.js-ajax-content').find('.js-custom-select').selectric();
                $('.js-faq-container').find('.js-faq-menu-item.active').focus();
                $('.js-toaster-container').addClass('page-loaded');
                if (isMobileWidth()) {
                    $('body > .js-contactus-toaster').remove();
                    $('.js-contactus-toaster').appendTo($('body'));
                }
                ritualsFormHelper.init();
                validator.init();
                faq.def.container.addClass('active-content');
            }
        });
    },

    init : function() {
        // get URL params
        const params = getQueryStringParams(window.location.search),
            linkedCategory = params['catid'],
            linkedQuestion = params['qid'];

        // get first FAQ category option
        const firstOption = $(faq.def.option[0]);

        // if URL params link to an FAQ category, load it
        if (linkedCategory){
            const selectedOption = faq.def.option.filter('[data-href=' + linkedCategory + ']');

            if (selectedOption.length == 0) {
                loadCategory(firstOption, true);
            } else {
                loadCategory(selectedOption, false, linkedQuestion);
            }

        } else {
            if (faq.def.breakpointSize !== 'small') {
                loadCategory(firstOption, true);
            }
        }

        faq.getResponsiveDesign();

        $('.js-first-item-show').click(function(){
            loadCategory($(faq.def.option[0]), true);
        });

        $('em.js-display-contact-form').attr('tabindex', 0);

        $('.js-display-contact-form').click(function(){
            faq.getContactForm();
        });

        $('.js-display-contact-form').on('keyup', function(e){
            if (e.which == 13) {
                faq.getContactForm();
            }
        });

        faq.def.option.click(function(){
            loadCategory($(this), false);
        });

        $('.js-faq-menu-item').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        $(window).resize(function() {
            faq.getResponsiveDesign();
        });
    }
};

/**
 *
 * @param {jQuery Element} categoryElement The jQuery element representing the category to load
 * @param {bool} clearUrlCategory If true, the category id parameter will be removed from the URL
 * @param {string} activeQuestionId The question ID that should be activated once loaded. Leave empty to not activate any question
 */
function loadCategory(categoryElement, clearUrlCategory, activeQuestionId){

    let url = window.location.href;

    if (!activeQuestionId) {
        url = removeParamFromURL(window.location.href, 'qid'); //Remove the 2nd-level parameter
    }

    if (clearUrlCategory) {
        url = removeParamFromURL(url, 'catid');
    } else {
        url = replaceParameterInUrl(url, 'catid', categoryElement.data('href'));
    }

    setUrl(url);

    faq.def.option.removeClass('active');
    categoryElement.addClass('active');
    faq.def.container.removeClass('fixed');
    faq.def.container.addClass('active-content');

    if (categoryElement.hasClass('fixed')) {
        faq.def.container.addClass('fixed');
    }

    faq.getContentFromFolder(categoryElement.attr('data-href'), activeQuestionId);

    window.scrollTo(0, 0);
}

function setUrl(url){
    //Clean the URL in case the ? was left over
    if (url[url.length - 1] == '?') {
        url = url.slice(0, -1);
    }

    window.history.replaceState([], null, url);
}

function replaceParameterInUrl(url, name, value){
    const clean = removeParamFromURL(url, name);
    return appendParamToURL(clean, name, value);
}

module.exports = faq;

},{"../customerservice":418,"../modules/ajax":449,"../modules/util/appendParamToURL":479,"../modules/util/getQueryStringParams":492,"../modules/util/getScreenBreakpointSize":493,"../modules/util/isMobileWidth":499,"../modules/util/removeParamFromURL":505,"../rituals-form-helper.js":590,"../validator":607,"jquery-ui/ui/widgets/accordion":49}],538:[function(require,module,exports){
'use strict';

const whereIsMyOrderFormHandler = require('./whereIsMyOrder/whereIsMyOrderFormHandler'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    isMobileOrTabletWidth = require('../modules/util/isMobileOrTabletWidth');

const dataLayer = window.dataLayer || [];

const stickyMobileDropdown = function() {
    const $stickyDropdown = $('.js-faq-theme-mobile-dropdown');

    if (!$stickyDropdown.length) {
        return;
    }
    const $stickyDropdownHolder = $('.js-faq-theme-mobile-dropdown-placeholder');
    const stickyDropdownHolderRect = $stickyDropdownHolder[0].getBoundingClientRect().top;
    const stickyDropdownHeight = $stickyDropdown.outerHeight();
    $stickyDropdownHolder.css('height', stickyDropdownHeight);

    if (stickyDropdownHolderRect <= 0) {
        $stickyDropdown.addClass('sticky');
        $stickyDropdownHolder.addClass('in-place');
        return;
    }

    $stickyDropdown.removeClass('sticky');
    $stickyDropdownHolder.removeClass('in-place');
};

function faqAccordionToggle(button, updateURL) {
    const faqHeadClass = '.js-faq-theme-acc-head';
    const faqContentClass = '.js-faq-theme-acc-content';
    const $parent = button.parent(faqHeadClass);
    const $siblings = $parent.parent().siblings();

    if (!$parent.hasClass('open-acc')) {
        $siblings.find(faqHeadClass).removeClass('open-acc').attr('aria-expanded', 'false');
        $siblings.find(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
        $parent.addClass('open-acc').attr('aria-expanded', 'true');
        $parent.siblings(faqContentClass).stop().slideDown().attr('aria-hidden', 'false');
        if (updateURL) {
            const url = replaceParameterInUrl(window.location.href, button.data('parameter-name'), button.data('article-id'));
            setUrl(url);
        }
        return;
    }

    $parent.removeClass('open-acc').attr('aria-expanded', 'false');
    $parent.siblings(faqContentClass).stop().slideUp().attr('aria-hidden', 'true');
    if (updateURL) {
        const url = removeParamFromURL(window.location.href, button.data('parameter-name'));
        setUrl(url);
    }
}

const faqRedesign = {
    init : function() {
        whereIsMyOrderFormHandler.init();
        loadSelectedTopicAndArticleFromURL();

        $(document).on('click', '.js-faq-nav-button', function () {
            setActiveTopic($(this).data('topic-id'), true);
        });

        $(document).on('change', '.js-dropdown-select', function () {
            setActiveTopic($(':selected', $(this)).data('topic-id'), true);
        });

        initAccoridanBtn();
        initDataLayerPush();

        $(document).on('click', '.js-data-layer-element', function(e) {
            pushDataToDataLayer($(e.currentTarget));
        });

        $(document).on('click', '.js-faq-theme-back-button', function () {
            window.history.back();
        });

        if (isMobileOrTabletWidth()) {
            stickyMobileDropdown();
            $(window).on('scroll', stickyMobileDropdown);
        }

        $(document).off('faq.pushDataLayerObject').on('faq.pushDataLayerObject', function(_, params) {
            if (!params || !params.length) {
                return;
            }
            const $findMyOrderButton = params.filter('.js-find-my-order-button');
            pushDataToDataLayer($findMyOrderButton);
        });
    },
    initCheckout : function() {
        initAccoridanBtn();
        initDataLayerPush();
    }
};

function initAccoridanBtn() {
    $(document).off('click', '.js-faq-theme-acc-head-button').on('click', '.js-faq-theme-acc-head-button', function(e) {
        faqAccordionToggle($(e.target), true);
    });
}

function initDataLayerPush() {
    $(document).off('click', '.js-data-layer-element').on('click', '.js-data-layer-element', function(e) {
        pushDataToDataLayer($(e.currentTarget));
    });
}

function loadSelectedTopicAndArticleFromURL() {
    const params = getQueryStringParams(window.location.href),
        topic = params['catid'],
        article = params['qid'];

    setActiveTopic(topic, false, article);
}

function setActiveTopic(topic, updateUrl, article) {
    const $topicElement = getTopicElement(topic);
    const $topicMobileElement = getTopicMobileElement(topic);

    if (!$topicElement || !$topicMobileElement) {
        return;
    }

    $('button', '.js-faq-nav').removeClass('active');
    $topicElement.addClass('active');
    const $topicBreadcrumbElement = $('.js-breadcrumb-element-topic', '.js-faq-nav');
    $('span', $topicBreadcrumbElement).text($topicElement.data('topic-header'));
    $('option', '.js-dropdown-select').removeAttr('selected');
    $topicMobileElement.attr('selected', 'selected');

    updateArticlesAndDIY($topicElement.data('articles-content-id'), article, $topicElement.data('diy-content-id'));

    if (updateUrl) {
        let url = removeParamFromURL(window.location.href, 'qid');
        url = replaceParameterInUrl(url, $topicElement.data('parameter-name'), $topicElement.data('topic-id'));
        setUrl(url);
    }
}

function getTopicElement(topic) {
    let $topicToBeSelected = $('button[data-topic-id="' + topic + '"]', '.js-faq-nav');
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('button', '.js-faq-nav')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getTopicMobileElement(topic) {
    let $topicToBeSelected = $('option[data-topic-id="' + topic + '"]','.js-dropdown-select');

    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    $topicToBeSelected = $($('option', '.js-dropdown-select')[0]);
    if ($topicToBeSelected && $topicToBeSelected.length) {
        return $topicToBeSelected;
    }

    return false;
}

function getArticleElement(article) {
    const $articleToBeSelected = $('button[data-article-id="' + article + '"].js-faq-theme-acc-head-button');

    if ($articleToBeSelected && $articleToBeSelected.length) {
        return $articleToBeSelected;
    }

    return false;
}

function setUrl(url){
    url = url.replace('?&', '?');
    if (url[url.length - 1] == '?') {
        url = url.slice(0, -1);
    }

    window.history.replaceState([], null, url);
}

function replaceParameterInUrl(url, name, value){
    const clean = removeParamFromURL(url, name);
    return appendParamToURL(clean, name, value);
}

function updateArticlesAndDIY(articlesContentID, article, diyContentID) {
    $.ajax({
        type: 'GET',
        url: Urls.getArticleAndDIYBlocks,
        data: 'articlesContentID=' + articlesContentID + '&diyContentID=' + diyContentID,
        success: function(response) {
            const $data = $(response);
            const $articlesHTML = $data.filter('.js-articles').children();
            const $diyHTML = $data.filter('.js-diy').children();

            $('.js-faq-accordion-wrapper').empty().append($articlesHTML);
            $('.js-faq-diy-wrapper').empty().append($diyHTML);
            const $articleElement = getArticleElement(article);
            if ($articleElement){
                faqAccordionToggle($articleElement, false);
            }
        }
    });
}

function pushDataToDataLayer(element) {
    if (!element || !element.length) {
        return;
    }

    let dataLayerLabel = element.data('data-layer');
    if (!dataLayerLabel) {
        return;
    }
    dataLayerLabel = decodeURIComponent(dataLayerLabel);

    const dataLayerObject = {
        event: 'faq',
        category: 'faq',
        action: 'click faq',
        label: dataLayerLabel
    };

    bindBlockSpecificDataLayerAttributes(element, dataLayerObject);

    dataLayer.push(dataLayerObject);
}

function bindBlockSpecificDataLayerAttributes(element, dataLayerObject) {
    const $faqDIYBlock = element.closest('.js-faq-diy-wrapper');
    if ($faqDIYBlock && $faqDIYBlock.length) {
        dataLayerObject.action = 'do it yourself';
        return;
    }

    const $faqQuestionFormBlock = element.closest('.js-faq-question-form-blocks');
    if (!$faqQuestionFormBlock || !$faqQuestionFormBlock.length) {
        return;
    }

    dataLayerObject.category = 'wimo';

    const $wimoFormWrapper = element.closest('.js-wimo-form-wrapper');

    if (!$wimoFormWrapper || !$wimoFormWrapper.length) {
        return;
    }

    dataLayerObject.action = 'click';
    dataLayerObject.event = element.hasClass('js-find-my-order-button') ? 'order_inquiry_form' : 'login';
}

module.exports = faqRedesign;

},{"../modules/util/appendParamToURL":479,"../modules/util/getQueryStringParams":492,"../modules/util/isMobileOrTabletWidth":498,"../modules/util/removeParamFromURL":505,"./whereIsMyOrder/whereIsMyOrderFormHandler":569}],539:[function(require,module,exports){
'use strict';

const recaptchaConfig = require('../recaptchaConfig');

/**
 * @function
 * @description Initializes the giftcard page events
 */
exports.init = function () {
    $('input[name=dwfrm_giftcard_BalanceCheckerForm_cardNumber]').mask('0000 0000 0000 0000', {});
    $('input[name=dwfrm_giftcard_BalanceCheckerForm_cardNumberPin]').mask('000000', {});

    recaptchaConfig.defaultInitializationForFormById('BalanceCheckerForm');
};

},{"../recaptchaConfig":587}],540:[function(require,module,exports){
'use strict';

const gtm = require('../modules/google').tagManager,
    isInViewport = require('../modules/helpers/isInViewport'),
    prepareDeferedImages = require('../modules/helpers/prepareDeferedImages');

function pushProductsToDataLayer() {
    const PUSHED_CLASS = 'js-data-layer-list-pushed';
    const productTilesToPush = $('.js-hairtemple-wrapper .js-product-tile-details-content:not(.' + PUSHED_CLASS + ')');

    if (productTilesToPush.length === 0){
        $(window).off('scroll.hairtemplelanding');
        return;
    }

    productTilesToPush.each(function(_, tile) {
        const $tile = $(tile);
        if (isInViewport($tile, false)) {
            const datalayerProduct = $tile.parent().find('.js-product-tile-datalayer-product');
            if (datalayerProduct.length > 0) {
                const productData = JSON.parse(datalayerProduct.val());

                if (productData){
                    gtm.pushProductTileView(productData);
                }
            }
            $tile.addClass(PUSHED_CLASS);
        }
    });

}

function initializeEvents(){
    let timer;
    $(window).on('scroll.hairtemplelanding', function(){
        if (timer) {
            window.clearTimeout(timer);
        }
        timer = window.setTimeout(function () {
            pushProductsToDataLayer();
        }, 300);
    });

    $(document).on('click', '.js-hairtemple-wrapper a',function(){
        const datalayerProduct = $(this).parents('.js-product-tile').find('.js-product-tile-datalayer-product');
        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());
            if (productData){
                gtm.pushProductTileClick(productData);
            }
        }
    });

    prepareDeferedImages();
}

const hairtemple = {
    init: function () {
        pushProductsToDataLayer();
        initializeEvents();
    }
};

module.exports = hairtemple;

},{"../modules/google":453,"../modules/helpers/isInViewport":464,"../modules/helpers/prepareDeferedImages":474}],541:[function(require,module,exports){
'use strict';

const dialog = require('../dialog');

const elements = {
    form: $('#jobs'),
    cities: $('.jobs-cities ul'),
    results: $('.jobs-results'),
};

/**
 * Creates a job div element
 * @param  {Object} option Job object
 * @return {String} the html content
 */
function createJobDiv(option){
    return '<div class="job">' +
        '<h2 class="h3">' + option.name + '</h2>' +
        '<p>' +
            option.shortdesc + ' - ' + option.city +
        '</p>' +
        '<a href="' + option.url + '" >' + option.text + '</a>' +
    '</div>';
}

/**
 * Re-creates city and job opening list based on request data
 * Displays no result text on 0 openings or error
 * @param  {Object} data JSON reprsentation of openings
 */
function updateDom(data){
    // first clear the results
    elements.results.empty();

    // if something went wrong, clear the results and cities list
    if (!data.success){
        elements.cities.empty();
        elements.results.append('<span class="jobs-noresult">' + data.message + '</span>');
        return;
    } else {
        // update both the city list and the job results
        const openings = data.openings || [];

        // on country change update the city list and populate openings
        if (data.cities && data.cities.length > 0){
            // save all openings list element
            const $first = elements.cities.find('li.first');
            let count = 0;
            elements.cities.empty();

            data.cities.forEach(function(city){
                count += parseInt(city.count);

                elements.cities.append('<li>' +
                    '<a data-folder="' + city.folderID + '">' +
                        city.displayName +
                        ' <span>( ' + city.count + ' )</span> ' +
                        '</a>' +
                '</li>');

                city.openings.forEach(function(opening){
                    openings.push(opening);
                });
            });

            // set new see all openings element

            $first.find('a').data('folder',elements.form.find('#jobs-country').val());
            $first.find('a span').text('( ' + count + ' )');

            elements.cities.prepend($first);
        }

        if (openings && openings.length > 0){
            openings.forEach(function(option){
                elements.results.append(createJobDiv(option));
            });
        } else {
            elements.cities.empty();
            elements.results.append('<span class="jobs-noresult">' + data.message + '</span>');
        }
    }
}

/**
 * Filters the job data based on key an value
 * @param  {String} key   Country | City
 * @param  {Srtring} value Folder ID
 */
function filter(key, value){
    const data = {};
    data[key] = value;

    $.ajax({
        url: elements.form.attr('action'),
        method: 'GET',
        dataType: 'json',
        data : data
    }).done(function (data) {
        updateDom(data);
    });
}

function openDialog(){
    const $applicationDialog = $('.job-application-dialog');
    if ($applicationDialog.length !== 0){
        // set the form country
        $('.job-application-form form')
            .find('#jobCountry')
            .val(elements.form.find('#jobs-country').val());

        dialog.open({
            target: $applicationDialog,
            options: {
                closeOnEscape: false,
                dialogClass: 'no-close'
            }
        });
    }
}

exports.init = function () {
    elements.form.on('change', '#jobs-country', function(){
        filter('country', $(this).val());
    });

    elements.cities.on('click', 'li.first a', function(){
        elements.form.find('#jobs-country').trigger('change');
    });

    elements.cities.on('click', 'li:not(.first) a', function(){
        filter('city', $(this).data('folder'));
    });

    // open application dialog
    $('.jobs-open-application-form').on('click', 'a', function(){
        openDialog();
    });

    // open application dialog on error
    if ($('.job-application-dialog .job-application-form .confirmation-message').length !== 0){
        openDialog();
    }
};

},{"../dialog":422}],542:[function(require,module,exports){
'use strict';

const Urls = window.Urls || {};
const ritualsStyles = require('../rituals-styles');
const productTile = require('../product-tile');
const _ = require('lodash');
const pushDataLayerEvent = require('../modules/helpers/analyticsHelper');

let mag = {};

mag = {
    // default elements
    def : {
        $window: $(window),
        $main: $('#main'),
        $magLandingBody: $('.mag-landing__body'),
        $magMenuWrapper: $('.js-m-menu__wrapper'),
        $magCategoryMenu: $('.js-m-menu'),
        $magCategoryMenuItems: $('.m-menu__category'),
        $magSubcategoryItems: $('.m-menu__subcategories'),
        $magSocialShare: $('.js-social-share'),
        magPageURL: encodeURIComponent(window.location.href),
        $headerWrapper: $('.js-header-wrapper'),
        $headerSpacer: $('.js-header-spacer')
    },

    // default settings
    settings : {
        magRootFolder : 'mag', // this setup is also in backend
        sessionStorageKey : 'magActiveFolder'
    },

    /**
     * @function
     * @description get articles from single folder
     */
    getContentFromFolder : function(folderId){
        $.ajax({
            type: 'POST',
            url: Urls.getContentFromFolder,
            data: folderId,
            success: function(data) {
                if (data) {
                    mag.def.$magLandingBody.html(data);
                    mag.events(data);
                    ritualsStyles.lazyloadInit();
                }
            }
        });
    },

    tools  : {
        getMagMenuHeight: function() {
            return mag.def.$magMenuWrapper.innerHeight();
        },

        getHeaderHeight: function() {
            return mag.def.$headerWrapper.innerHeight();
        },

        setSpacerHeight: function() {
            const height = mag.tools.getHeaderHeight() + mag.tools.getMagMenuHeight();
            mag.def.$headerSpacer.height(height);
        },

        setMagMenuTop: function() {
            const height = mag.tools.getHeaderHeight();
            mag.def.$magMenuWrapper.css('top',height);
        }
    },
    /**
     * @function
     * @description includes all events for HTML elements
     */
    events : function(){
        mag.def.$magSocialShare.find('[data-service="facebook"]').attr('href','https://www.facebook.com/sharer/sharer.php?u=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="pinterest"]').attr('href','https://www.pinterest.com/pin/create/button/?url=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="twitter"]').attr('href','https://twitter.com/intent/tweet/?url=' + mag.def.magPageURL);
        mag.def.$magSocialShare.find('[data-service="googleplus"]').attr('href', 'https://plus.google.com/share?url=' + mag.def.magPageURL);

        mag.def.$magCategoryMenu.unbind('click').on('click', function(){
            mag.def.$magCategoryMenu.parent().toggleClass('is--selected');
        });

        if (mag.def.$magLandingBody.length === 0){
            mag.def.$magMenuWrapper.removeClass('is--hidden');
            mag.tools.setSpacerHeight();
        }

        if (mag.def.$magLandingBody.length >= 1){
            document.addEventListener('scroll', _.throttle(function(){

                if (mag.def.$window.scrollTop() > 360) {
                   mag.def.$magMenuWrapper.removeClass('is--hidden');
                } else {
                    mag.def.$magMenuWrapper.addClass('is--hidden');
                }
            }, 100));
        }

        mag.def.$magCategoryMenuItems.add(mag.def.$magSubcategoryItems.find('li')).on('click', function (e) {
            e.stopPropagation();
            const clickedNavItem = $(e.target).text().trim();
            pushDataLayerEvent({
                event: 'menu_navigation',
                menu: 'magazine_navigation',
                menu_path: `Magazine, ${clickedNavItem}`.toLowerCase(),
                menu_text: clickedNavItem.toLowerCase(),
                menu_click: 'text'
            });
        });
    },

    /**
     * @function
     * @description main initializing function nothing else should be called from outside of 'mag' module
     */
    init : function(){
        console.log('[mag] initialized..');
        mag.events();
        mag.tools.setMagMenuTop();
        productTile.init();
        $('img.lazy').lazyload();
    }
};

module.exports = mag;

},{"../modules/helpers/analyticsHelper":455,"../product-tile":581,"../rituals-styles":592,"lodash":208}],543:[function(require,module,exports){
'use strict';

const appendParamToURL = require('../modules/util/appendParamToURL');
const damHelper = require('../dam/dam-helper');

const paginator = '.js-paginator';
const pageNumber = '.js-page-number';
const previousPage = '.js-previous-page';
const nextPage = '.js-next-page';

function initialize() {
    $('.js-order-history-spinner').removeClass('spinner-visible');
    $('.js-orders-page-0').removeClass('hide');
    $(paginator).removeClass('hide');

    addEventHandlerToPageNumbers();
    $(nextPage).on('click', selectNextPage);
    $(previousPage).on('click', selectPreviousPage);
    damHelper.updateImages($('.order-image'));
}

function addEventHandlerToPageNumbers() {
    $(pageNumber).off('click');
    $(pageNumber).on('click',
        (event) => selectPage(Number($(event.target).data('page-number')))
    );
}

function selectPage(selectedPageNumber) {
    $(pageNumber).removeClass('selected');
    $('.js-orders-page:not(.hide)').addClass('hide');
    const $pageToShow = $(`.js-orders-page-${selectedPageNumber}`);
    $pageToShow.removeClass('hide');
    updatePageArrows(selectedPageNumber);
    hidePageNumbers(selectedPageNumber);
    const nextPageToken = $pageToShow.data('next-page-token');
    if (nextPageToken) {
        $pageToShow.addClass('hide');
        $('.js-order-history-spinner').addClass('spinner-visible');
        $(paginator).addClass('hide');
        loadOrderPages(nextPageToken, selectedPageNumber);
    }
    $('.js-page-number[data-page-number="' + selectedPageNumber + '"]').addClass('selected');
}

function selectPreviousPage() {
    selectPage(Number($('.js-orders-page:not(.hide)').data('page-number')) - 1);
}

function selectNextPage() {
    selectPage(Number($('.js-orders-page:not(.hide)').data('page-number')) + 1);
}

function loadOrderPages(pageToken, lastPageNumber) {
    let url = appendParamToURL(Urls.getOrderHistoryPages, 'pageToken', pageToken);
    url = appendParamToURL(url, 'pageNumberStart', lastPageNumber);

    $.get(url)
        .done((responsHtml) => {
            const $newPages = $($.parseHTML(responsHtml));
            $('.js-orders-pages').append($newPages);
            $(`.js-orders-page-${lastPageNumber}`).data('next-page-token', '');
            updatePageNumbers(lastPageNumber, $newPages.filter('.js-orders-page').length);
            $(`.js-orders-page-${lastPageNumber}`).removeClass('hide');
            $('.js-order-history-spinner').removeClass('spinner-visible');
            $(paginator).removeClass('hide');
        })
        .fail((jqXHR, textStatus, errorThrown) => console.log('Failed to load orders: ', errorThrown, textStatus));
}

function updatePageNumbers(startPage, numberOfNewPages) {
    const $pageNumbers = $('.js-page-numbers');

    for (let i = startPage + 1; i <= startPage + numberOfNewPages; i++) {
        $pageNumbers.append(`
            <button type="button" class="account-pagination-item js-page-number" data-page-number="${i}">${i + 1}</button>
        `);
    }

    addEventHandlerToPageNumbers();
}

function hidePageNumbers(selectedPageNumber) {
    $(pageNumber).each(function(index) {
        if ((index < selectedPageNumber - 3) || (index > selectedPageNumber + 3)) {
            $(this).addClass('hide');
            return;
        }

        $(this).removeClass('hide');
    });
}

function updatePageArrows(selectedPageNumber) {
    if (selectedPageNumber) {
        $(previousPage).removeClass('hide');
    } else {
        $(previousPage).addClass('hide');
    }

    if ($('.js-orders-page').length - 1 === selectedPageNumber && !$(`.js-orders-page-${selectedPageNumber}`).data('next-page-token')) {
        $(nextPage).addClass('hide');
        return;
    }

    $(nextPage).removeClass('hide');
}

const orderHistory = {
    init: initialize
};

module.exports = orderHistory;

},{"../dam/dam-helper":419,"../modules/util/appendParamToURL":479}],544:[function(require,module,exports){
'use strict';

const ajax = require('../modules/ajax');
const removeParamFromURL = require('../modules/util/removeParamFromURL');
const appendParamsToUrl = require('../modules/util/appendParamsToUrl');
const search = require('./search');
const grid = require('../grid');
const productTile = require('../product-tile');
const isInViewport = require('../modules/helpers/isInViewport');
const isSmallView = require('../modules/helpers/isSmallView');
const scrollHelper = require('../modules/helpers/scroll');
const $filterOverlay = $('.js-refinements-bar');
const $filterPage = $('.js-filter-page');
const $filterOptions = $('.js-filter-options');
const $filterBlockTitle = $('.js-filter-block-title');

const ALL = 'all';

function clearAllFilters(){
    const data = {
        cat: ALL
    };

    getFilteredProducts(data);

    $('.js-filter__block input[type=checkbox]').prop('checked', false);
}

function getFilteredProducts(filterData){
    const path = window.location.pathname;

    if (!('format' in filterData)){
        filterData.format = 'page-element-with-banner';
    }

    $.ajax({
        dataType: 'html',
        url: path,
        data: filterData,
        xhrFields: {
            withCredentials: true
        }
    }).done(function (response) {
        updateProductGrid(response);
        updateUrls();

        updateFilterTags();
        updateMobileFilterText();
    });
}

function updateProductGrid(html) {
    if (!html) {
        return;
    }

    $('.js-grid-wrap .js-grid-item').remove();
    $('.js-grid-wrap').append(html);
    grid.updateLoadMoreUrl();

    //reinit the grid
    $('.js-grid-wrap').imagesLoaded(function() {
        grid.init();
    });
}

function updateUrls() {
    const newUrlElement = $('.js-new-current-url');

    if (newUrlElement.length > 0) {
        const newUrl = newUrlElement.last().val();
        window.history.pushState({'url': newUrl}, '', newUrl);
        newUrlElement.remove();
    }
}

function updateFilters(){
    const url = Urls.getOutletFilterAvailability;

    $.when(getFilterSelection()).done(function(data) {
        ajax.getJson({
            url: url,
            data: data,
            callback: function(response){
                // enable/disable input fields
                $.each(response, function (key, value) {
                    if (typeof value === 'object') {
                        $.each(value, function(key, value) {
                            $('input[data-inputid="' + key + '"]').prop('disabled', value !== true);
                        });
                    } else {
                        $('input[data-inputid="' + key + '"]').prop('disabled', value !== true);
                    }
                });

                // update filter count
                $('.js-filters-count').html(response.count);
            }
        });
    });
}

function getFilterSelection(){
    const categoriesArray = $('input[name="category-categoryflow"]:enabled:checked').map(function () {
        return $(this).val();
    }).get();

    const subCategoriesArray = $('input[name="subcategory"]:enabled:checked').map(function () {
        return $(this).val();
    }).get();

    const categories = categoriesArray.length > 0 ? categoriesArray.join() : ALL;
    const subCategories = subCategoriesArray.length > 0 ? subCategoriesArray.join() : ALL;

    const data = {
        cat: categories,
        subcat: subCategories
    };

    const sortingRule = $('.js-outlet-sort-by-select').data('sorting-rule');
    if (sortingRule) {
        data.srule = sortingRule;
    }

    return data;
}

function applyFilters(){
    $.when(getFilterSelection()).done(function(data) {
        getFilteredProducts(data);
    });
}

function updateFilterTags(){
    const newFilterTagContainer = $('.js-new-active-refinements-list');
    const oldFilterTagContainers = $('.js-active-refinements-list');

    if (newFilterTagContainer.length > 0) {
        const newFilters = $('.js-new-active-refinements-list .js-active-refinements');
        oldFilterTagContainers.empty();
        oldFilterTagContainers.append(newFilters);
        newFilterTagContainer.remove();
    }
}

function updateMobileFilterText(){
    const newFilterTextContainer = $('.js-new-mobile-selected-filters');
    const oldFilterTextContainers = $('.js-filter-selected-item');

    const newFilterText = newFilterTextContainer.text();
    oldFilterTextContainers.text(newFilterText);

    newFilterTextContainer.remove();
}

function initEvents() {
    const $body = $('body');

    //open filter overlay
    $body.off('click', '.js-trigger-mobile-filters');
    $body.on('click', '.js-trigger-mobile-filters', function () {
        $filterOverlay.fadeIn('fast', function () {
            const $this = $(this);
            redesignAdjustments();
            $this.addClass('refinements-visible').removeAttr('aria-hidden');
            $this.find('.js-filter-block-title').focus();

            if (isSmallView()) {
                $('.js-search-results-bar').css('height', '');
            }
        });

        // lock body scroll
        scrollHelper.disableScroll();
    });

    //close filter overlay
    $body.off('click', '.js-background-overlay, .js-filters-close, .js-filter-x-close, .js-filter-option-close');
    $body.on('click', '.js-background-overlay, .js-filters-close, .js-filter-x-close, .js-filter-option-close', function(){
        if (isSmallView()) {
            if ($filterOptions.hasClass('visible')) {
                $filterOptions.addClass('moved-left');
            }

            $filterOverlay.removeClass('refinements-visible').removeClass('moved-left').attr('aria-hidden', 'true');
            $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

            setTimeout(function () {
                $filterOptions.hide().removeClass('visible').removeClass('moved-left').attr('aria-hidden', 'true');
                $filterBlockTitle.removeClass('open');
                $filterOverlay.hide();
            }, 800);
        } else {
            $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
            $filterBlockTitle.removeClass('open');
            $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
            $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
            setTimeout(function () {
                $filterOverlay.hide();
            }, 600);
        }

        // unlock body scroll
        scrollHelper.enableScroll();
    });

    $('.js-filters-close').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-filter-x-close').focus();
        }
    });

    $('.js-filter-x-close').on('keydown', function (e) {
        if (e.shiftKey && e.which == 9) {
            e.preventDefault();
            $('.js-filters-close').focus();
        }
    });

    if (isSmallView()) {
        $('.js-filter-block-title').removeAttr('aria-label aria-expanded');
    }

    //toggle filter items on mobile
    $body.off('click', '.js-filter-block-title');
    $body.on('click', '.js-filter-block-title', function() {
        const ariaLabelText = $(this).text();
        const ariaLabelStateOpen = $('.js-filter-label-open').text();
        const ariaLabelStateClosed = $('.js-filter-label-closed').text();

        if (!$(this).hasClass('open')) {
            $(this).addClass('open');
            if (isSmallView()) {
                $(this).next('.js-filter-options').show('fast', function () {
                    $filterOverlay.addClass('moved-left');
                    $(this).addClass('visible').addClass('visible').removeAttr('aria-hidden');
                });
                $(this).next('.js-filter-options').find('.js-filter-option-back').focus();
            } else {
                $(this).next('.js-filter-options').stop().slideDown().removeAttr('aria-hidden');
                $(this).attr({
                    'aria-label': ariaLabelText + ',' + ariaLabelStateOpen,
                    'aria-expanded' : 'true'
                });
            }
        } else {
            $(this).removeClass('open');
            if (isSmallView()) {
                $(this).next('.js-filter-options').removeClass('visible').attr('aria-hidden', 'true');
            } else {
                $(this).next('.js-filter-options').stop().slideUp().attr('aria-hidden', 'true');
                $(this).attr({
                    'aria-label' : ariaLabelText + ',' + ariaLabelStateClosed,
                    'aria-expanded' : 'false'
                });
            }
        }
    });

    if (isSmallView()) {
        $('.js-clear-filters').on('keydown', function (e) {
            if ($filterOptions.hasClass('visible')) {
                if (e.which == 9) {
                    e.preventDefault();

                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');

                    setTimeout(function () {
                        $filterOptions.hide();
                    }, 600);
                }
            }
        });
    }

    //close categories on mobile
    $body.off('click', '.js-filter-option-back');
    $body.on('click', '.js-filter-option-back', function () {
        if (isSmallView()) {
            $filterOverlay.removeClass('moved-left');
        }
        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
        $filterBlockTitle.removeClass('open');

        setTimeout(function () {
            $filterOptions.hide();
        }, 600);
    });

    $body.off('change', '.js-outlet-sort-by-select');
    $body.on('change', '.js-outlet-sort-by-select', function () {
        const sortingRule = $(this).val();

        let url = removeParamFromURL(location.href, 'format');
        url = removeParamFromURL(url, 'srule');
        url = appendParamsToUrl(url, {
            'format': 'page-element-with-banner',
            'srule': sortingRule
        });

        $.ajax({
            url: url,
            success: function (data) {
                updateProductGrid(data);
                updateUrls();
            }
        });
    });

    $body.off('click', '.js-remove-filter-button');
    $body.on('click', '.js-remove-filter-button', function() {
        const attributeValue = $(this).data('refinement-value');
        $('.js-filter-option[value="' + attributeValue + '"]').prop('checked', false);
        applyFilters();
    });

    // OOP: clear filters
    $body.off('click', '.js-clear-filters');
    $body.on('click', '.js-clear-filters', function() {
        clearAllFilters();

        redesignAdjustments();
    });

    // OOP: listen to filter changes and update filters
    $body.off('change', '.js-filter-option');
    $body.on('change', '.js-filter-option', function() {
        // update filter panel
        updateFilters();

        // apply filters and fetch products
        applyFilters();
    });

    $(document).on('keyup', function(e) {
        if (e.which == 27) {
            // on escape close the overlay
            if ($filterOverlay.hasClass('refinements-visible')) {
                if (isSmallView()) {
                    $filterPage.animate({
                        left: '0'
                    }, 600, 'easeInOutCubic');
                    if ($filterOptions.hasClass('visible')) {
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                        $('.filter-user-actions').css('left', '100%');
                    } else {
                        $filterOverlay.addClass('moved-right').attr('aria-hidden', 'true');
                    }
                    $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

                    setTimeout(function () {
                        $filterOverlay.removeClass('refinements-visible').removeClass('moved-right').removeClass('moved-left');
                        $filterBlockTitle.removeClass('open');
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    }, 800);
                } else {
                    $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');
                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
                }

                // unlock body scroll
                scrollHelper.enableScroll();
            }
       }
   });

    accessibilityAdjustments();
    redesignAdjustments();
    stickyNavBar();
    searchGWPAssetPosition();

    $(window).on('resize', function () {
        accessibilityAdjustments();
        redesignAdjustments();
        searchGWPAssetPosition();
    });

    $(window).scroll(function () {
        stickyNavBar();
    });
}

function accessibilityAdjustments() {
    if (isSmallView()) {
        $('.js-filter-category-title').attr('aria-hidden', 'true');
    } else {
        $('.js-filter-category-title').removeAttr('aria-hidden');
    }
}

function redesignAdjustments() {
    const $filterInner = $('.js-filter-inner');

    if ($filterInner.length) {
        const filterHeaderHeight = $('.js-filter-header').outerHeight();

        $filterInner.css('padding-top', filterHeaderHeight);
    }
}

function stickyNavBar() {
    const $filterBar = $('.js-search-results-bar');
    const $darkBox = $('.js-search-filter-box');

    if ($filterBar.length) {
        const barIsInView = isInViewport($filterBar);
        const boxIsInView = isInViewport($darkBox);
        const filterBarPosition = $filterBar.offset().top;

        if (isSmallView()) {
            if ($(window).scrollTop() >= filterBarPosition) {
                $filterBar.addClass('sticky-filters');
            } else {
                $filterBar.removeClass('sticky-filters');
            }
        } else {
            if (barIsInView) {
                $filterBar.removeClass('sticky-filters');
            } else {
                $filterBar.addClass('sticky-filters');
            }

            if (boxIsInView) {
                $filterBar.removeClass('sticky-filters-visible');
            } else {
                $filterBar.addClass('sticky-filters-visible');
            }
        }
    }
}

function searchGWPAssetPosition() {
    if ($('.js-search-grid-asset').length) {
        const searchAsset = '.js-search-grid-asset';
        const desktopAssetHolder = '.js-search-slot-desktop';
        const mobileFirstGridItem = $('.js-search-result-content').find('.js-grid-item').first();
        if (isSmallView()) {
            $(desktopAssetHolder).find(searchAsset).appendTo(mobileFirstGridItem);
        } else {
            $(mobileFirstGridItem).find(searchAsset).appendTo(desktopAssetHolder);
        }
    }
}

exports.init = function init () {
    initEvents();

    // initialize search page events (e.g.: product options click)
    search.initGridOptionsEvents();
    productTile.init();
};

},{"../grid":437,"../modules/ajax":449,"../modules/helpers/isInViewport":464,"../modules/helpers/isSmallView":469,"../modules/helpers/scroll":475,"../modules/util/appendParamsToUrl":480,"../modules/util/removeParamFromURL":505,"../product-tile":581,"./search":566}],545:[function(require,module,exports){
'use strict';

const genericFlyout = require('../../genericFlyout');
const writeACard = require('../../write-a-card');
const ajax = require('../../modules/ajax');
const dragList = require('../../dragList');

function init() {
    giftCartReview();
    giftCartEdit();
    giftCartCancel();
}

function giftCartReview() {
    $(document).on('click.giftcard', giftCardUtils.reviewGiftCardButton , function (event) {
        event.preventDefault();
        const options = {url: $(this).data('preview-url')};
        $.extend(options, giftCardUtils.flyoutOptions);
        genericFlyout.load(options);
    });
}

function giftCartEdit() {
    $(document).off('submit.giftcard').on('submit.giftcard', giftCardUtils.editForm , function (event) {
        event.preventDefault();
        const form = $(this);
        ajax.postForm({
            form: form,
            handleJson: postCallback
        });
    });
}

function giftCartCancel() {
    $(document).on('click.cancel', giftCardUtils.cancel , function (event) {
        event.preventDefault();
        genericFlyout.closeFlyouts();
    });
}

function openCallback(){
    writeACard.init();
    dragList.init();
}

function postCallback(response) {
    if (response.error){
        //TODO handle error somehow
        return;
    }
    appendNewMessage(response);

    genericFlyout.closeFlyouts();
}

function appendNewMessage(response){
    const giftCardElement = $('[data-giftcard-uuid="' + response.UUID + '"]');
    let giftCardMessageElement = $('.js-giftcard-message', giftCardElement);

    const $giftWrapText = $('#GiftWrapText');
    if ($giftWrapText.length) {
        $giftWrapText.val(response.originalMessageText);
    }

    if (!response.giftCardMessage){
        giftCardMessageElement.remove();
        return;
    }

    if (giftCardMessageElement.length){
        giftCardMessageElement.html(response.giftCardMessage);
        return;
    }
    giftCardMessageElement = $('<span />', {
        class: 'bundle-pg-cart-excerpt js-giftcard-message',
    }).html(response.giftCardMessage).insertBefore($(giftCardUtils.reviewGiftCardButton, giftCardElement));

}

const giftCardUtils = {
    flyoutOptions: {
        open: openCallback
    },
    editForm: '.js-edit-gift-card',
    cancel: '.js-cancel-giftcard-edit',
    reviewGiftCardButton: '.js-gift-card-preview',
    init: init
};

module.exports = giftCardUtils;

},{"../../dragList":423,"../../genericFlyout":428,"../../modules/ajax":449,"../../write-a-card":610}],546:[function(require,module,exports){
'use strict';

const ritualsStyles = require('../../rituals-styles');
const scrollHelper = require('../../modules/helpers/scroll');
const giftsetLightbox = '.js-giftset-lightbox';
const lightboxOpenBtn = '[data-group-id] .js-edit-button';
const lightboxChooseBtn = '.js-lightbox-choose';
const lightboxUndoBtn = '.js-undo-button';
const sliderEl = '.js-giftset-lightbox-slider';
const simplebarEl = '.simplebar-content-wrapper';
const mobileView = $(window).width() < 768;
const defaultImage = $('#defaultImageData').val();

const pgCustomizeEvents = {
    onChange : $.Event('pgCustomize.onChange')
};

function onClickOpenLightbox() {
    $(lightboxOpenBtn).on('click', function () {
        const $this = $(this);
        let groupId = $this.closest('[data-group-id]').data('group-id');
        const $giftsetLightbox = $('.js-giftset-lightbox[data-lightboxgroup-id="' + groupId + '"]');
        const selectedChoice = $(this).parent().prev('.js-group-result-product').val();

        $this.addClass('animating');
        $('body').addClass('visible-lightbox');
        scrollHelper.disableScroll();
        $giftsetLightbox.addClass('visible');

        const $activeLightbox = $('.js-giftset-lightbox.visible');
        groupId = $activeLightbox.data('lightboxgroup-id');
        const choiceId = $('.js-lightbox-slider-item', $activeLightbox).data('choice-id');
        const selectedItem = $('.js-lightbox-slider-item[data-choice-id="' + selectedChoice + '"]', $activeLightbox);
        const $customResults = $('.js-custom-giftset .js-group-result-product').clone();
        const $activeSimplebar = $activeLightbox.find(simplebarEl);

        if (!$this.hasClass('reopened')) {
            setTimeout(function() {
                $this.addClass('reopened');
                ritualsStyles.initLazyLoad();

                $customResults.each(function(i, result) {
                    const $result = $(result);
                    if ($result.attr('id') === groupId) {
                        $result.val(choiceId);
                    }
                });

                // Trigger preload of product image
                preloadProductImage(getFinalProductID($customResults));

                $activeLightbox.find(sliderEl).scrollLeft(0);
                if ($activeSimplebar.length) {
                    $activeSimplebar.scrollLeft(0);
                }
            }, 200);
        } else {
            const scrollPosition = (selectedItem.position().left);
            $activeLightbox.find(sliderEl).scrollLeft(scrollPosition);
            if ($activeSimplebar.length) {
                $activeSimplebar.scrollLeft(scrollPosition);
            }
        }
    });
}

function updateProductList(activeLightbox, choiceId) {
    const productsListHTML = generateProductListElement(activeLightbox, choiceId);
    $('[data-group-id="' + activeLightbox.data('lightboxgroup-id') + '"] .js-giftset-product-list').empty().append(productsListHTML);
}

function resetProductList(groupId) {
    const defaultProductsListHTML = $('[data-lightboxgroup-id="' + groupId + '"] .js-default-products-list').html();
    $('[data-group-id="' + groupId + '"] .js-giftset-product-list').html(defaultProductsListHTML);
}

function resetProductImage() {
    updateImageAttributes(defaultImage);
}

function onClickCloseLightbox() {
    $(document).on('click', '.js-giftset-lightbox-close, .js-giftset-lightbox-overlay', function () {
        $(this).parents(giftsetLightbox).removeClass('visible');
        $('body').removeClass('visible-lightbox');
        scrollHelper.enableScroll();
        $(lightboxOpenBtn).removeClass('animating');
        $(sliderEl).scrollLeft(0);
        if ($(sliderEl).find(simplebarEl).length) {
            $(sliderEl).find(simplebarEl).scrollLeft(0);
        }
    });
}

function updateTotalPrice(finalProductID) {
    $.ajax({
        type: 'GET',
        url: Urls.getTotalPriceForPGProduct,
        data: {pid: finalProductID},
        success: function(data) {
            if (data) {
                const el = $('.js-total-pg-price');
                el.text(data.totalPriceDisplayValue);

                const pgProducts = $('input[name="pgProducts"]');
                if (pgProducts.length > 0) {
                    const dataLayerData = JSON.parse(pgProducts.val());
                    dataLayerData.products[0].price = data.totalPrice;
                    pgProducts.val(JSON.stringify(dataLayerData));
                }
            }
        }
    });
}

function updateDataLayerProductAvailability(finalProductID) {
    $.ajax({
        type: 'GET',
        url: Urls.getProductAvailabilityForPG,
        data: {pid: finalProductID},
        success: function(data) {
            if (data) {
                const pgProducts = $('input[name="pgProducts"]');
                if (pgProducts.length > 0) {
                    const dataLayerData = JSON.parse(pgProducts.val());
                    dataLayerData.products[0].availability = data.availability;
                    pgProducts.val(JSON.stringify(dataLayerData));
                }
            }
        }
    });
}

function onClickChangeGiftset() {
    $(document).on('click', lightboxChooseBtn, function () {
        const $this = $(this);
        const $activeLightbox = $this.parents(giftsetLightbox);
        const groupId = $activeLightbox.data('lightboxgroup-id');
        const openBtn = $('[data-group-id="' + groupId + '"] .js-edit-button');
        openBtn.removeClass('animating');

        const choiceId = $this.closest('.js-lightbox-slider-item').data('choice-id');

        if ($activeLightbox.data('default-choice') === choiceId) {
            openBtn.nextAll(lightboxUndoBtn).hide();
            openBtn.removeClass('repeat');
        } else {
            openBtn.nextAll(lightboxUndoBtn).show();
            openBtn.addClass('repeat');
        }

        $activeLightbox.find('.selected').removeClass('selected');
        $this.addClass('selected');

        $('#' + groupId).val(choiceId);
        updateProductList($activeLightbox, choiceId);
        const finalProductID = getFinalProductID();
        preloadProductImage(finalProductID);
        updateProductImage(finalProductID);
        setFinalProductValue(finalProductID);
        if (mobileView) {
            $activeLightbox.removeClass('visible');
            $('body').removeClass('visible-lightbox');
            scrollHelper.enableScroll();
            $(sliderEl).scrollLeft(0);
            if ($(sliderEl).find(simplebarEl).length) {
                $(sliderEl).find(simplebarEl).scrollLeft(0);
            }
        }
        updateTotalPrice(finalProductID);
        updateDataLayerProductAvailability(finalProductID);

        $(document).trigger(pgCustomizeEvents.onChange);
        $('.js-giftset-lightbox-close').trigger('click');
    });
}

function onClickResetGiftset() {
    $(document).on('click', '.js-undo-button', function () {
        const $this = $(this);
        const groupId = $this.closest('[data-group-id]').data('group-id');
        const lightbox = $('[data-lightboxgroup-id="' + groupId + '"]');

        $('.selected', lightbox).removeClass('selected');
        const choiceId = lightbox.data('default-choice');

        $('[data-choice-id="' + choiceId + '"] .js-lightbox-choose', lightbox).addClass('selected');

        $this.prev().removeClass('repeat');
        resetProductList(groupId);
        resetProductImage(groupId);
        $('#' + groupId).val(choiceId);
        const finalProductID = getFinalProductID();
        setFinalProductValue(finalProductID);
        $this.hide();
        updateTotalPrice(finalProductID);
        updateDataLayerProductAvailability(finalProductID);

        $(document).trigger(pgCustomizeEvents.onChange);
    });
}

function generateProductListElement(activeLightbox, choiceId) {
    const productsJson = $('[data-choice-products-id="' + choiceId + '"]', activeLightbox).val();
    const productsObj = JSON.parse(productsJson);
    const htmlElement = $('<div/>', {
        class: 'list-holder js-lightbox-product-list-inner'
    });
    $.each(productsObj.productsList, function (index, product) {
        htmlElement.append($('<span/>', {
            html: product.title
        }));
    });
    return htmlElement;
}

function preloadProductImage(finalProductID) {
    const imageObj = JSON.parse($('[data-product-image-id="' + finalProductID + '"]').val());
    if (imageObj) {
        const img = new Image();
        img.src = imageObj.largeImg;
    }
}

function updateProductImage(finalProductID) {
    const image = $('[data-product-image-id="' + finalProductID + '"]').val();
    updateImageAttributes(image);
}

function updateImageAttributes(image){
    const imagesObj = JSON.parse(image);
    if (!imagesObj) {
        return;
    }
    const prevImage = $('.js-product-main-image');
    prevImage.attr('src', imagesObj.largeImg);
    prevImage.attr('title', imagesObj.title);


    if (imagesObj.srcset) {
        prevImage.attr('srcset', imagesObj.srcset);
        prevImage.data('product-zoom', JSON.stringify({
            src:imagesObj.retinaImg,
            w:1000,
            h:1000
        }));
    }
}

function getFinalProductID(customResults) {
    // To preload the main image of the current slide we need to pass a
    // customResult to be able to use the logic below.
    const results = customResults || $('.js-custom-giftset .js-group-result-product');

    if (!results.length) {
        return '';
    }

    const existingFinalSetsElement = $('#available-final-productsets');
    if (!existingFinalSetsElement.length) {
        return '';
    }

    let existingFinalSets = existingFinalSetsElement.val().split(',');
    const selectedSubSets = results.toArray().map((group) => group.value);

    for (const idx in selectedSubSets) {
        const subset = selectedSubSets[idx];

        existingFinalSets = existingFinalSets.filter(function (finalSet) {
            return finalSet.indexOf(subset) > -1;
        });

        if (existingFinalSets.length === 1) {
            break;
        }
    }

    return existingFinalSets[0];
}

function setFinalProductValue(finalProductID, element){
    if (!element){
        element = $('input[name="finalProductID"]');
    }
    element.val(finalProductID);
}

const personalisedlightbox = {
    init: function () {
        this.ensureFinalProductIdIsSet();
        onClickOpenLightbox();
        onClickCloseLightbox();
        onClickChangeGiftset();
        onClickResetGiftset();
    },
    ensureFinalProductIdIsSet: function(form){
        const element = form ? $('input[name="finalProductID"]', form) : $('input[name="finalProductID"]');
        if (element.val()){
            return;
        }
        const finalProductID = getFinalProductID() || $('#final-productset-id').val();
        setFinalProductValue(finalProductID, element);
    }
};

module.exports = personalisedlightbox;

},{"../../modules/helpers/scroll":475,"../../rituals-styles":592}],547:[function(require,module,exports){
'use strict';

const sectionScroller = require('../../sectionScroller');
const isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth');

function initEvents(context) {
    // init general events
    context.customiseButton.off('click.personalise').on('click.personalise', function (e) {
        e.preventDefault();
        if (isMobileOrTabletWidth()) {
            sectionScroller.scrollToCustom($('.js-custom-giftset'));
            return;
        }
        sectionScroller.scrollTo($('.js-custom-giftset'));
    });

    context.goToCardButton.off('click.personalise').on('click.personalise', function () {
        sectionScroller.scrollTo($('.js-write-a-card-block'));
    });

    context.readMoreLink.off('click.readmore').on('click.readmore', function () {
        if (!isMobileOrTabletWidth()) {
            sectionScroller.scrollWithOffset($('.js-product-tabs'));
        }
    });
}

function handleScrollingInEditMode(context) {
    if (!context.editModeIndicator.val()) {
        return;
    }
    context.customiseButton.click();
}

const personalise = {
    customiseButton: $('.js-go-to-customise-set'),
    goToCardButton: $('.js-go-to-write-card'),
    editModeIndicator : $('.js-edit-mode-indicator'),
    readMoreLink : $('.js-read-more-link-pg'),
    init: function() {
        initEvents(this);
        handleScrollingInEditMode(this);
    }
};

module.exports = personalise;

},{"../../modules/util/isMobileOrTabletWidth":498,"../../sectionScroller":595}],548:[function(require,module,exports){
'use strict';

const dialog = require('../../dialog'),
    scrollHelper = require('../../modules/helpers/scroll'),
    mobileImageHolder = $('.js-mobile-image-holder');

function initEvents(){
    $(document).on('click', '.js-giftset-replace-accept', replaceGiftSet);

    $(document).on('click.popup', '.js-modal-overlay', function(){
        dialog.close();
    });

    $(document).on('click touchstart', '.js-giftset-replace-close', '.js-modal-overlay', function(){
        dialog.close();
    });

    giftSetToggle();
}

function giftSetToggle() {
    const $pgSetWrapper = '.js-pgset-container';

    $(document).off('click.pgsetexpand').on('click.pgsetexpand', '.js-expand-pgset', function (e) {
        e.preventDefault();
        const $this = $(this);
        const container = $this.closest('.js-cart-row').next().find($pgSetWrapper);
        $this.toggleClass('expanded');
        container.stop().slideToggle(500, function () {
            container.attr('aria-hidden', !$this.hasClass('expanded'));
        });
    });

}

function replaceGiftSet() {
    $('.js-add-to-cart').click();
    dialog.close();
}

/**
 * @description show replacing gift set choices popup
 */
function showReplacePGDialog() {
    dialog.open({
        target: $('#giftset-replace-dialog'),
        options: {
            dialogClass: 'popup-generic-holder',
            width: 600,
            open: function() {
                $('.js-modal-overlay').show();
                scrollHelper.disableScrollEventsOnEl('.js-modal-overlay, .js-giftset-replace-dialog-wrapper, .ui-dialog-titlebar-close');
                $('input[name="showReplacePGPopup"]').val('false');
            },
            close: function(){
                dialog.close();
                scrollHelper.enableScrollEventsOnEl('.js-modal-overlay, .js-giftset-replace-dialog-wrapper, .ui-dialog-titlebar-close');
                $('.js-modal-overlay').hide();
                $('input[name="showReplacePGPopup"]').val('true');
            }
        }
    });
}

function handleMobileMinicartImage(form, response){
    const finalProductId = $('input[name="finalProductID"]', form);
    if (!finalProductId.length || !finalProductId.val()) {
        return;
    }
    const image = $('[data-finalset-image="' + finalProductId.val() + '"]', response);
    if (!image.length) {
        return;
    }
    mobileImageHolder.html(image);
}

const pgCartUtils = {
    init: initEvents,
    showReplacePGDialog: showReplacePGDialog,
    handleMobileMinicartImage: handleMobileMinicartImage
};

module.exports = pgCartUtils;

},{"../../dialog":422,"../../modules/helpers/scroll":475}],549:[function(require,module,exports){
'use strict';

const page = require('../../page');
const giftCardUtils = require('./giftCardUtils');
const gtm = require('../../modules/google').tagManager;

const pgminicart = {
    init: function (minicart) {
        initRemoving(minicart);
        giftCardUtils.init();
    }
};

function initRemoving(minicart){
    if (!minicart) {
        return;
    }
    $(document).off('click.pgminicart');
    $(document).on('click.pgminicart', '.js-pg-minicart-remove', function(e) {
        e.preventDefault();
        const $this = $(this);
        $.ajax({
            url: Urls.removeProductFromCart,
            type: 'POST',
            data: {
                productId: $this.data('product-id'),
                editMode: $('.js-edit-mode-indicator').val() || window.pageContext.type === 'Cart'
            },
            dataType: 'json'
        }).done(function (response) {
            if (response.success) {
                if (response.reload) {
                    page.refresh();
                    return;
                }
                const $product = $this.parents('.mini-cart-product');
                $product.remove();

                minicart.updateProductsAndPrice(response.totalPrice, response.numberOfProducts, 0);
                minicart.updateHeaderCartIcon(response.numberOfProducts);

                if (response.numberOfProducts === 0) {
                    minicart.switchToEmptyCart();
                }

                const customizableSet = $this.data('data-layer-products');
                if (customizableSet) {
                    gtm.updateQuantity('remove_from_cart', customizableSet);
                }
            }
        }).fail(function() {
            window.alert(Resources.BAD_RESPONSE);
        });
    });
}

module.exports = pgminicart;

},{"../../modules/google":453,"../../page":518,"./giftCardUtils":545}],550:[function(require,module,exports){
'use strict';

const page = require('../../page'),
    navigation = require('../../navigation'),
    ajaxUrl = require('../../modules/util/ajaxUrl'),
    Promise = require('promise'),
    bonusProductsView = require('../../bonus-products-view'),
    certificateView = require('../../certificate-view'),
    gtm = require('../../modules/google').tagManager,
    dialog = require('../../dialog'),
    scrollHelper = require('../../modules/helpers/scroll'),
    outOfStock = require('../product/outOfStock'),
    pglightbox = require('../personalisedgifting/lightbox'),
    pgCartUtils = require('../personalisedgifting/pgCartUtils'),
    variations = require('./variations');

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
const addItemToCart = function (form, eventData) {
    const $form = $(form);
    let $qty = $form.find('input[name="Quantity"]');
    const dataLayerProduct = $form.find('input[name="dataLayerProduct"]').length > 0 ? JSON.parse($form.find('input[name="dataLayerProduct"]').val()) : null;

    if ($qty.length === 0 || isNaN($qty.val()) || parseInt($qty.val(), 10) === 0 || $qty.val() < 0) {
        if ($qty.length === 0){
            $qty = $('<input type="hidden" name="Quantity"/>');
        }
        $qty.val('1');
    } else if (parseInt($qty.val()) > 999) {
        $qty.val(999);
    }

    return Promise.resolve($.ajax({
        type: 'POST',
        url: ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            throw new Error(response.error);
        }
        if (response.replaceGiftSet){
            pgCartUtils.showReplacePGDialog();
            return false;
        }
        if (eventData && eventData.eventName) {
            const productPosition = $form.closest('.product-list-slider-item').data('counter');
            gtm.updateQuantity(
                eventData.eventName,
                dataLayerProduct,
                parseInt($qty.val(), 10),
                productPosition);

            // close quickview dialog if product added from quickview
            // which is actually a variant selection from the cop
            if (eventData.isQuickView){
                $('.js-popup-generic').dialog('close');
            }
        }

        return response;
    });
};

/**
 * @description Handler to handle the add to cart event
 */
const addToCart = function (e) {
    e.preventDefault();
    // stop propagation (in case it's a linked product tile)
    e.stopPropagation();

    const $target = $(e.target);
    const $form = $target.closest('form');

    pglightbox.ensureFinalProductIdIsSet($form);

    const eventData = {
        isQuickView: $target.hasClass('js-add-to-cart-quickview'),
        eventName: $target.data('addtocart-event')
    };

    addItemToCart($form, eventData).then(function (response) {
        if (!response) {
            return;
        }

        const $uuid = $form.find('input[name="uuid"]');
        if (($uuid.length > 0 && $uuid.val().length > 0) || pageContext.type === 'Cart') {
            page.refresh();
            return;
        }

        // if add to cart button is in sticky bar
        const ctaAddToCartBtn = $target.closest('.js-sticky-add-to-cart').length > 0;

        const $thumbnailImage = $form.find('input[name="thumbnailImage"]');
        if ($thumbnailImage.length){
            $('.js-product-image-mobile').attr('data-src', $thumbnailImage.val());
        } else {
            pgCartUtils.handleMobileMinicartImage($form, response);
        }

        const discountDataElement = $(response).find('.js-minicart-discount-data');
        if (discountDataElement.length) {
            const addedProductId = discountDataElement.data('added-product-id');
            displayCRMChoiceModule(discountDataElement, addedProductId, response, false);
        } else {
            updateMiniCartOnAddProduct(response, false);
        }

        navigation.initNavigationToMainSite(); // for fastlane sites there is to-home link at the bottom of minicart same as in header
        const cartIsEmpty = false;
        navigation.updateNavigationLinksOnAddToCart(cartIsEmpty);

        // add checkmark on a click
        if ($('.js-sticky-add-to-cart').length) {
            if (ctaAddToCartBtn) {
                $('.js-sticky-add-to-cart .js-add-to-cart').addClass('checked');
                setTimeout(function() {
                    $('.js-sticky-add-to-cart .js-add-to-cart').removeClass('checked');
                }, 4000);
            }
        }
    }.bind(this));
};

function displayCRMChoiceModule(discountDataElement, addedProductId, response, hideMinicart) {
    const url = discountDataElement.data('choice-discount-url');
    const productID = discountDataElement.data('choice-selected-product').toString();
    bonusProductsView.show({
        url: url,
        giftChange: true,
        response: true,
        selectedID: productID,
        addedProductId: addedProductId,
        onClose: function() {
            updateMiniCartOnAddProduct(response, hideMinicart);
        }
    });
}

function updateMiniCartOnAddProduct(response, hideMinicart) {
    const nonSelectedGiftLink = $($.parseHTML(response)).find('.bonus-item-actions a.js-select-bonus-product').first();
    let url = null;
    let showAdded = false;

    if (nonSelectedGiftLink && nonSelectedGiftLink.length > 0) {
        url = nonSelectedGiftLink.attr('href');
        showAdded = nonSelectedGiftLink.data('showadded');
    }
    const displayGwpToast = $(response).find('input[name=DisplayGwpToast]').val() === 'true';
    const showToastNotificationOnFirstAdd = $(response).find('input[name=ShowToastNotificationOnFirstAdd]').val() === 'true';

    bonusProductsView.show({
        url: url,
        giftChange: false,
        response: response,
        isAddedPopup: showAdded,
        displayGwpToast: displayGwpToast || showToastNotificationOnFirstAdd
    }, hideMinicart);

    const cartEl = document.querySelector('.js-shopping-circle');
    cartEl.classList.add('cart-number-show');
}

/**
* @description adjust the quantity
*/
const quantityButtons = function(e){
    e.preventDefault();
    const qInput = $('input[id$=Quantity]');
    const currentAmount = qInput.val() * 1;
    qInput.val($(this).attr('data-count') != '-' ? (currentAmount < 999 ? currentAmount + 1 : 999) : (currentAmount > 1 ? currentAmount - 1 : 1));
};

/**
 * @description check quantity limits
 */
const checkQuantityLimits = function (e) {
    e.preventDefault();

    const qInput = $('input[id$=Quantity]');
    const currentValue = qInput.val();
    if (isNaN(currentValue) || currentValue < 0) {
        qInput.val(1);
    } else if (parseInt(currentValue) >= 999) {
        qInput.val(999);
    }
};

/**
 * @function
 * @description check quantity limits
 */
const openQuickviewFromContent = function (e) {
    const $this = $(this);
    // prevent default behaviour
    e.preventDefault();
    // prevent event bubbling
    e.stopPropagation();
    dialog.open({
        url: $this.attr('href') || $this.data('href'),
        source: 'quickview',
        target: $('.js-popup-generic'),
        options: {
            closeOnEscape: true,
            dialogClass: 'popup-generic-holder',
            width: '640',
            autoOpen: true,
            create: function() {
                // lock body scroll
                scrollHelper.disableScroll();

                $('.js-modal-overlay').show();

                $('body').on('click touchstart', '.js-modal-overlay', function(){
                    dialog.close();
                });

            },
            beforeClose: function() {
                scrollHelper.enableScroll();
                $('.js-modal-overlay').hide();
                $('.js-popup-generic').empty();
            },
            position: {
                my: 'center',
                at: 'center',
                of: window,
                collision: 'flipfit'
            }
        }
    });

    // lock body scroll
    scrollHelper.disableScroll();

    $('.js-modal-overlay').show();
    $('.popup-generic-holder').focus();
};

function showCertificatePopup(event) {
    event.preventDefault();
    event.stopPropagation();
    certificateView.show({addToCartButton: event.target});
}

const pushDataLayerEventEaster = () => {
    const $divWrapper = $('.product-add-to-cart');
    const analyticsData = $divWrapper.find('input[name="analyticsData"]').attr('value');
    if (!analyticsData) {
        return;
    }
    const analytics = JSON.parse(analyticsData);
    analytics.event_label = $('.js-the-ritual-of-title').first().text().trim(); /* eslint-disable-line camelcase */
    gtm.pushDataLayerEvent(analytics);
};

function pushDataLayerEventAdvent(event) {
    const form = $(event).closest('form');
    pglightbox.ensureFinalProductIdIsSet(form);
    const values = form[0][6].defaultValue;
    const product = JSON.parse(values);
    const current = $(event).closest('.advent-comparison-item')[0];
    if (!current) {
        return;
    }

    gtm.pushDataLayerEvent({
        event: 'advent',
        ecommerce: {
            currencyCode: current.attributes['data-currency-code'].value,
            add: {
                products: [{
                    name: product.name,
                    id: product.sku,
                    price: current.attributes['data-product-price'].value
                }]
            }
        }
    });
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = {
    init: function () {
        outOfStock.init();
        pgCartUtils.init();

        $('.js-add-to-cart[disabled]').attr('title', $('.availability-msg').text());

        $(document).on('click', '.js-add-to-cart, .js-add-to-cart-quickview', function(e, skipCertificateForm) {
            const addToCartButton = $(e.target);
            if (addToCartButton.hasClass('js-variations-add-to-cart')){
                const valid = variations.validateVariations(e);
                if (!valid) {
                    return;
                }
                pushDataLayerEventEaster();
            }

            if (!skipCertificateForm && addToCartButton.hasClass('js-add-to-cart-talisman')) {
                showCertificatePopup(e);
                return;
            }

            if (document.querySelector('.js-advent-block')) {
                pushDataLayerEventAdvent(e.target);
            }

            addToCart(e);
        });

        $(document).on('click','.js-quantity-button', quantityButtons);

        /* Quantity input field event */
        $(document).on('blur','input[id$=Quantity]', checkQuantityLimits);

        $(document).on('click', '.js-open-quickview', openQuickviewFromContent);
    },
    updateMiniCartOnAddProduct: updateMiniCartOnAddProduct
};

},{"../../bonus-products-view":276,"../../certificate-view":280,"../../dialog":422,"../../modules/google":453,"../../modules/helpers/scroll":475,"../../modules/util/ajaxUrl":478,"../../navigation":515,"../../page":518,"../personalisedgifting/lightbox":546,"../personalisedgifting/pgCartUtils":548,"../product/outOfStock":555,"./variations":561,"promise":217}],551:[function(require,module,exports){
'use strict';

const google = require('../../modules/google');
const isSmallView = require('../../modules/helpers/isSmallView');

const inStoreData = {
    variationProductID: null,
    latitude: null,
    longitude: null
};


// Initializers
function initializeEvents() {

    // Current location
    $('body').on('click', '.js-check-instore-availabilty-current-location', checkCurrentLocation);

    $('body').on('keyup', '.js-check-instore-availabilty-wrapper', function(e){
        if (e.which == 13) {
           checkCurrentLocation();
        }
    });

    //Show more button
    $('.js-show-more-btn').on('click', function() {
        $('.js-spinner').addClass('spinner-visible');
        const nextPageToken = $('[name=NextPageToken]').last().val() || 0;
        getStoreStock(nextPageToken);
    });

    //Variant selection
    $('.js-swatch-anchor-flyout').on('click', function(e) {
        $('.js-spinner').addClass('spinner-visible');

        updatePDPSizeSelection(this.innerText);
        e.preventDefault();
        e.stopPropagation();
        updateSizeSelectionBar($(this));
        if (!inStoreData.longitude || !inStoreData.latitude) {

            // address field is empty, fill with current location
            cleanFlyoutStores(); //Clean the flyout
            google.places.getCurrentLocation(triggerCurrentLocation);
            return;
        }

        inStoreData.variationProductID = $(this).data('productid');
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);

    });
}

function checkCurrentLocation() {
    $('.js-spinner').addClass('spinner-visible');
    cleanFlyoutStores(); //Clean the flyout
    google.places.getCurrentLocation(triggerCurrentLocation);
}


// Triggers

/*
    Trigger for autocomplete functionality. Once address is selected, we get notified in here
*/
function triggerReceiveAddressAutoComplete() {
    google.tagManager.pushInStoreAvailabilityAddressFill();
    const place = this.getPlace();
    if (place && place.geometry && place.geometry.location) {
        $('.js-spinner').addClass('spinner-visible');

        //Set the location
        inStoreData.latitude = place.geometry.location.lat();
        inStoreData.longitude = place.geometry.location.lng();
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);
    }
}

/*
    Notifier when search for user's address in addressbook
*/
function triggerUserAddressSearched(results, status) {
    $('.js-spinner').addClass('spinner-visible');
    if (status == 'OK') {
        //Set the location
        const result = results[0];
        inStoreData.latitude = result.geometry.location.lat();
        inStoreData.longitude = result.geometry.location.lng();
        setSearchTextfieldText(result.formatted_address);
        cleanFlyoutStores(); //Clean the flyout
        getStoreStock(0);
    }
}

/*
    Notifier when user tap on Current location
*/
function triggerCurrentLocation(result, latitude, longitude) {
    //Check if location is OK
    if (result && latitude && longitude) {
        const cityName = google.places.getReadableAddress(result);
        setSearchTextfieldText(cityName);
        inStoreData.latitude = latitude;
        inStoreData.longitude = longitude;
        cleanFlyoutStores();
        getStoreStock(0);
    } else {
        //Something wrong with current location, just fallback to Request's geolocation
        const RequestLatitude = $('[name=RequestLatitude]')[0].value;
        const RequestLongitude = $('[name=RequestLongitude]')[0].value;
        if (RequestLatitude && RequestLongitude) {
            google.places.getLocationFromLatLong(RequestLatitude, RequestLongitude, triggerCurrentLocationDW);
        } else {
            //Something wrong with DW geolocation, Show error message
            $('.js-location-not-found').show();
        }
    }

}

/*
    Notifier when Google API is finished for location which is from DW's geolocation
*/
function triggerCurrentLocationDW(result, latitude, longitude) {
    //Check if result is OK
    if (result && latitude && longitude) {
        const cityName = google.places.getReadableAddress(result);
        setSearchTextfieldText(cityName);
        inStoreData.latitude = latitude;
        inStoreData.longitude = longitude;

        cleanFlyoutStores();
        getStoreStock(0);
    } else {
        //If something's wrong with DW geolocation, show the error message
        $('.js-location-not-found').show();
    }
}

/*
    Getter ProductID
*/
function getFlyoutProductId() {
    if (inStoreData.variationProductID) {
        return inStoreData.variationProductID;
    }

    const el = $('[name=pid]')[0];
    return el.dataset.retailtu ? el.dataset.retailtu : el.value;
}

/*
    Update variant selector on PDP
*/
function updatePDPSizeSelection(selectedSize) {
    $('.js-swatch-anchor').each(function() {
        if (this.innerText == selectedSize) {
            if ($(this).hasClass('js-swatch-unselectable')) { return; }
            if ($(this).parent('li').hasClass('selected')) { return; }
            $(this).click();
        }
    });
}

/*
   Update the variant selection
*/
function updateSizeSelectionBar($clickedSize) {
    $('.js-swatch-anchor-flyout').each(function() {
        $(this).parent('li').removeClass('selected');
    });
    $clickedSize.parent('li').addClass('selected');
}

/*
    Set text to searchfield
*/
function setSearchTextfieldText(text) {
    $('.js-check-instore-availabilty-zipcode-textfield').val(text);
    // trigger change in input field to activate floating labels
    $('.js-check-instore-availabilty-zipcode-textfield').trigger('change');
}

/*
    Clean stores
*/
function cleanFlyoutStores() {
    $('.js-location-not-found').hide(); //Hide custom error message
    $('.js-size-not-selected').hide(); //Hide size selection error message
    $('.show-more-btn').hide(); //Hide show more button

    //clean previous store list and messages
    $('.stores-list-wrapper .js-list-row').remove();
    $('.stores-list-wrapper .error').remove();
    $('[name=NextPageToken]').remove();
}

/*
    Main get function
*/
function getStoreStock(nextPageToken) {
    const $sizeNotSelected = $('.js-size-not-selected');

    $('.js-location-not-found').hide();
    $('.show-more-btn').hide().addClass('js-hidden-show-more');

    $sizeNotSelected.hide();

    const sizeSelected = $('.flyout-variations li.selectable').length === 0 || $('li.selected .js-swatch-anchor-flyout').length !== 0;
    //if size is not selected, show the error message
    if (!sizeSelected) {
        $('.js-spinner').removeClass('spinner-visible');
        $sizeNotSelected.show();
    } else if (nextPageToken < 25) {
        //maximum of 25 stores
        $.ajax({
            url: Urls.getInStoreAvailability,
            data: {
                productId: getFlyoutProductId(),
                latitude: inStoreData.latitude,
                longitude: inStoreData.longitude,
                nextPageToken: nextPageToken
            }
        }).done(function(response) {
            const responseObj = $(response);
            if (response.length != 0) {
                $('.stores-list-wrapper .error').remove();
                // show list header when there are stores to show in desktop
                $('.js-stores-list-header').addClass('show-header');
            }
            if (nextPageToken == 0) {
                cleanFlyoutStores(); //Clean the flyout
            }
            $('.js-stores-list-wrapper').append(responseObj);
            //More stores button - adds 5 stores to the list to a max of 25 stores
            //When it reached max limit or if the token is null, hide the show more button
            if ($('[name=NextPageToken]').last().val().length > 0 && $('[name=NextPageToken]').last().val() < 25) {
                $('.show-more-btn').show().removeClass('js-hidden-show-more');
            }

            $('.js-spinner').removeClass('spinner-visible');

            if (!isSmallView()){
                $('.js-stores-list-wrapper .js-expand-row-btn').first().find('.store-main-info').click();
            }

            if (nextPageToken > 0) {
                responseObj.find('.js-list-row:first-child').focus();
            }
        });
    }

    $(document).on('keydown', '.wrap-details:last-child .js-list-row:last-child', function(e) {
        if (e.which == 9 && !e.shiftKey) {
            if ($('.show-more-btn').hasClass('js-hidden-show-more')) {
                e.preventDefault();
                $('.js-instore-availability-flyout').find('.js-close-flyout').focus();
            }
        }
    });
}

/**
 * @function
 * @description Initialize JS
 */
module.exports = function() {
    //Initialize Events
    initializeEvents();

    //Initialize Google Place API
    google.places.initStockFlyout(triggerReceiveAddressAutoComplete);
};

module.exports.refreshFlyout = function() {
    //Check if we have some location in memory, If yes, dont get user's address in addressbook
    if (!inStoreData.longitude || !inStoreData.latitude) {
        cleanFlyoutStores();
        //Check if user is loggedin and has valid address. If yes, we search that address in Google API
        const CurrentUserShortAddress = $('[name=CurrentUserShortAddress]')[0].value;
        if (CurrentUserShortAddress !== '') {
            google.places.searchPlace(CurrentUserShortAddress, triggerUserAddressSearched);
        }
    }
};

},{"../../modules/google":453,"../../modules/helpers/isSmallView":469}],552:[function(require,module,exports){
'use strict';

const flyout = require('../../flyout'),
    stickyAddToCart = require('./stickyaddtocart'),
    outOfStock = require('./outOfStock'),
    productIngredient = require('./ingredient'),
    pdpAnimations = require('./pdp-animations'),
    option = require('./option'),
    productTile = require('../../product-tile'),
    video = require('../../video'),
    personalisedGifting = require('../personalisedgifting/personalise'),
    personalisedLightbox = require('../personalisedgifting/lightbox'),
    writeACard = require('../../write-a-card'),
    variations = require('./variations'),
    isSmallView = require('../../modules/helpers/isSmallView'),
    easter = require('../../easter/easter'),
    gtm = require('../../modules/google').tagManager,
    advent = require('../../advent');

const isPg = $('.js-pdp-main').hasClass('giftset-pdp-main-container');

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    $(document).on('click', '.js-check-instore-availabilty', function(){
        const $this = $(this);
        flyout.openInStoreAvailabilityFlyout($this.hasClass('js-amsterdam-availabilty'));
        $(this).addClass('js-flyout-opened');
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('instore availability');
    });

    $(document).on('click', '.js-check-instore-availabilty-hor', function(){
        const $this = $(this);
        flyout.openInStoreAvailabilityHORFlyout($this.hasClass('js-amsterdam-availabilty'));
        $(this).addClass('js-flyout-opened');
    });

    // on click "Read more" link, scroll to accordion
    $(document).on('click', '.js-read-more-link',function(){
        const $accordionEl = $('.js-product-tabs');
        const headerHeight = $('.js-header').height();
        const $descriptionAddcorion = $('.js-description-acc-head');
        const $descriptionTab = $('.js-description-tab');
        handleDataLayerEvents($(this));

        $('html,body').animate({
            scrollTop: $accordionEl.offset().top - headerHeight
        }, 1000);

        if (isSmallView()) {
            if (!$descriptionAddcorion.hasClass('open')){
                setTimeout(function () {
                    $descriptionAddcorion.trigger('click', [true]).focus();
                }, 600);
            }
        } else {
            if (!$descriptionTab.hasClass('selected')){
                setTimeout(function () {
                    $descriptionTab.trigger('click', [true]).focus();
                }, 600);
            }
        }
    });

    if (new URL(window.location.href).searchParams.get('origin') === 'gst_talisman') {
        gtm.pushDataLayerEvent({
            'origin': 'gst_talisman'
        });
    }

    function handleDataLayerEvents(target) {
        if (!target || !target.length) {
            return;
        }

        const analytics = target.data('analytics');
        if (!analytics) {
            return;
        }
        analytics.content_name = decodeURI(analytics.content_name); /* eslint-disable-line camelcase */
        analytics.click_target = decodeURI(analytics.click_target); /* eslint-disable-line camelcase */

        gtm.pushDataLayerEvent(analytics);
    }

    // Only on the Personalised Gifting page.
    // Sets the event handler to ask for confirmation when exiting the page
    if (isPg) {
        $(document).on('pgCustomize.onChange', function() {
            if ($('.js-card-message-textarea').val() != '' || $('.js-undo-button:visible').length > 0) {
                addBeforeUnloadEvent();
            } else {
                removeBeforeUnloadEvent();
            }
        });

        $(document).on('pgCustomize.onSubmit', function() {
            removeBeforeUnloadEvent();
        });
    }

    $('body').on('click', '.js-pdp-back',function() {
        const URL = $(this).data('url');
        if (URL) {
            const ref = document.referrer;
            if (ref === '' || ref.indexOf('rituals') === -1 || ref.indexOf('login') > -1 || ref.indexOf('outlet') === -1){
                window.location = URL;
                return;
            }
        }


        const $easterPDP = $(this).closest('.js-easter-pdp');
        if ($easterPDP && $easterPDP.length) {
            easter.pushEvent('back');
            if ($(this).hasClass('js-breadcrumbs-easter')) {
                $(document).trigger($.Event('easter.startCloseAnimation'));
                return;
            }
        }

        window.history.back();
    });
}

/**
 * Attaches the beforeunload event to the window object with the 'product'
 * namespacing
 */
function addBeforeUnloadEvent() {
    $(window).off('beforeunload.product').on('beforeunload.product', function() {
        return true;
    });
}

/**
 * Removes the beforeunload event from the window object using the 'product'
 * namespacing
 */
function removeBeforeUnloadEvent() {
    $(window).off('beforeunload.product');
}

/**
 * @description Lightweight event init for product quickviews
 */
function initializeQuickviewEvents() {
    option();
}

const product = {
    init: function () {
        initializeEvents();
        productTile.init();
        stickyAddToCart.init();
        outOfStock.init();
        productIngredient.init();
        video.initPDP();
        personalisedGifting.init();
        personalisedLightbox.init();
        writeACard.init();
        variations.initEvents();
    },

    initOnDomReady: function() {
        pdpAnimations.init();
    },

    initializeQuickviewEvents: initializeQuickviewEvents
};

module.exports = product;

},{"../../advent":269,"../../easter/easter":424,"../../flyout":425,"../../modules/google":453,"../../modules/helpers/isSmallView":469,"../../product-tile":581,"../../video":608,"../../write-a-card":610,"../personalisedgifting/lightbox":546,"../personalisedgifting/personalise":547,"./ingredient":553,"./option":554,"./outOfStock":555,"./pdp-animations":556,"./stickyaddtocart":558,"./variations":561}],553:[function(require,module,exports){
'use strict';

const isSmallView = require('../../modules/helpers/isSmallView');

function expandIngredient() {
  $(document).on('click', '.js-expand-ingredients', function () {
    const $parent = $(this).parents('.column-details');
    if (!$parent.hasClass('open')) {
      $parent.addClass('open');
      $(this).siblings('.ingredient-item').stop().show();
    } else {
      $parent.removeClass('open');
      $(this).siblings('.ingredient-item').not(':first').stop().slideUp(400);
      if ($(window).width() < 768) {
        $('html, body').animate({scrollTop: ($parent.offset().top - 90)}, 400);
      }
    }
  });
}

function scrollToIngredients() {
  $(document).on('click', '.js-scroll-ingredients', function () {
    const $ingredientsTab = $('.js-ingredients-tab');
    const $ingredientsAddcorion = $('.js-ingredients-acc-head');

    if (isSmallView()) {
        $('html, body').animate({scrollTop: ($('.js-product-tabs').offset().top - 60)}, 600);
        if (!$ingredientsAddcorion.hasClass('open')) {
            setTimeout(function () {
                $ingredientsAddcorion.click().focus();
            }, 300);
        }
    } else {
        $('html, body').animate({scrollTop: ($ingredientsTab.offset().top - 60)}, 600);
        if (!$ingredientsTab.hasClass('selected')) {
            setTimeout(function () {
                $ingredientsTab.click().focus();
            }, 600);
        }
    }
  });
}

function initializeEvents() {
  $(document).ready(function() {
    expandIngredient();
    scrollToIngredients();
  });
}

const productIngredient = {
  init: function() {
    initializeEvents();
  }
};

module.exports = productIngredient;

},{"../../modules/helpers/isSmallView":469}],554:[function(require,module,exports){
'use strict';

const isMobile = require('../../modules/util/isMobile');
let stateAlreadySet = false;

const initEvents = function(){

    const elixirOutOfStock = $('.js-out-of-stock-btn[data-sticky-type="elixir"]');
    const elixirs = $('.js-product-details-content .js-options-dropdown-custom');
    if (elixirOutOfStock.length && !elixirOutOfStock.attr('style')){
        $('.js-sticky-add-to-cart').hide();
        $('.js-product-details-content .js-personalized-name').attr('disabled',true);
    }
    handleBackToHairTemple();

    handleSelectedElixirs(elixirs);
    // click on swatch - should replace product content with new variant
    $('body').on('click', '.js-swatch-anchor-option', function (e) {
        e.preventDefault();
        // if not selectable, do nothing
        if ($(this).hasClass('swatch__anchor--unselectable')){
            return;
        }

        // update content
        updateContent($(this));

        if ($('.js-sticky-add-to-cart').length > 0){
            updateStickyContent($(this));
        }
    });
    $(document).on('click', '.js-sticky-add-to-cart .js-pdp-select-size-btn, .js-sticky-add-to-cart .js-select-elixir', function(){
        const scrollTopOffset = isMobile() ? $('.js-product-details-content').offset().top : 0;
            $('html, body').animate({scrollTop: scrollTopOffset}, 'slow');
    });

    $('body').on('change', '.js-options-dropdown', function(){
        const $this = $(this);
        // get option li element in PDP main content

        const optionPdpElement = $('ul[data-optionid="' + $this.data('optionid') + '"]').find('li[value=' + $this.val() + '] a');

        updateContent(optionPdpElement);
        updateStickyContent(optionPdpElement);
    });

    $('body').on('change', '.js-product-details-content .js-options-dropdown-custom', function(){
        const $this = $(this);
        const form = $this.parents('form');
        const validator = $(form).validate();
        const options = form.find('.js-options-dropdown-custom');
        const name = form.find('.js-personalized-name');

        const val = $this.val();
        const otherSelect = jQuery.grep(options, function(value) {
            return value.name !== $this.attr('name');
        });
        disableAlreadySelected($(otherSelect), val);

        if (checkOutOfStock(options)){
            validator.resetForm();
            handleOutOfStock(name);
            return;
        }
        name.removeAttr('disabled');
        handleFieldValidation($this, validator);
    });

    $('body').on('input', '.js-product-details-content .js-personalized-name', function(){
        const $this = $(this);
        const charNumnberLabel = $this.nextAll('.js-charnumber');
        const maxlength = parseInt($this.attr('maxlength'), 10);
        const labelText = maxlength - $this.val().length;
        charNumnberLabel.text(labelText < 0 ? 0 : labelText);
        handleFieldValidation($this, $this.parents('form').validate());
    });

    $('body').on('click', '.js-product-details-content .js-add-to-cart', function(e){
        const $this = $(this);
        const form = $this.parents('form');
        if (form.valid()){
            $this.removeClass('btn--disabled');
            return true;
        }
        $this.addClass('btn--disabled');
        e.preventDefault();
        e.stopPropagation();
    });

    if ($('.js-options-dropdown-custom').length || $('.js-personalized-name').length){
        $(window).on('beforeunload', setState);
        $(window).on('unload', setState);
        $(document).on('pagehide', setState);
    }
};

const disableAlreadySelected = function(option, value){
    option.find('.disabled-selected').removeClass('disabled-selected').removeAttr('disabled');
    option.find('[value="' + value + '"]').addClass('disabled-selected').attr('disabled', true);
    option.selectric('refresh');
};

const updateContent = function (element) {
    const parentListItem = element.parent('li');
    const optionValue = parentListItem.attr('value');
    const parentList = parentListItem.parent('ul');
    parentList.find('li').each(function() {$(this).removeClass('selected');});
    parentListItem.addClass('selected');

    if ($('.quickview-popup').length > 0) {
        $('.quickview-popup .js-options-hidden-input').val(optionValue);
        $('.quickview-popup .js-disabled-add-to-cart').hide();
        $('.quickview-popup .js-add-to-cart').show();
    } else {
        $('.js-options-hidden-input').val(optionValue);
        $('.js-options-dropdown').hide();
        $('.js-disabled-add-to-cart').hide();
        $('.js-add-to-cart').show();
    }
};

const enableAddToCart = function(){
    $('.js-product-details-content .js-add-to-cart').removeClass('btn--disabled').show();
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').hide();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').show().removeClass('btn--disabled');
    enableDisableSocialCommerce(true);
};

function enableDisableSocialCommerce(enable) {
    const $socialCommerceButton = $('.js-product-details-content .js-social-commerce-button');
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    if (enable) {
        $socialCommerceButton.parent().removeClass('hide');
        return;
    }

    $socialCommerceButton.parent().addClass('hide');
}

const disableAddToCart = function(){
    $('.js-product-details-content .js-add-to-cart').addClass('btn--disabled');
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').show();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').hide().addClass('btn--disabled');
    enableDisableSocialCommerce();
};

const handleOutOfStock = function(nameEl){
    nameEl.attr('disabled', true);
    $('.js-product-details-content .js-add-to-cart').addClass('btn--disabled').show();
    $('.js-sticky-add-to-cart-form .js-disabled-add-to-cart').hide();
    $('.js-sticky-add-to-cart-form .js-add-to-cart').addClass('btn--disabled').show();
    enableDisableSocialCommerce();
    return;
};

const checkOutOfStock = function(){
    const selected = $('.js-product-details-content option.js-out-of-stock-option:selected');
   return selected.length > 0;
};

const handleFieldValidation = function(element, validator){
    if (element.valid() && validator.checkForm()){
        enableAddToCart();
        return;
    }
    disableAddToCart();
};

const updateStickyContent = function(element){
    const parentListItem = element.parent('li');
    const formattedValue = parentListItem.data('formattedvalue');
    const $priceElement = $('.js-sticky-price-container');

    $priceElement.empty().append('<div class="product-price">' + formattedValue + '</div>');
};

function setState(){
    if (stateAlreadySet) {
        return;
    }
    stateAlreadySet = true;
    const state = history.state || {};
    state.hairtemple = true;
    history.replaceState(state, '', location.href);
    return;
}

function handleBackToHairTemple(){
    if (history.state && history.state.hairtemple && window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD){
        if (checkOutOfStock()){
            handleOutOfStock($('.js-product-details-content .js-personalized-name'));
            return;
        }
        if ($('.js-product-details-content form').valid()){
            enableAddToCart();
            return;
        }
        disableAddToCart();
    }
}

function handleSelectedElixirs(elixirs){
    elixirs.each(function(){
        const $this = $(this);
        const val = $this.val();
        const otherSelect = jQuery.grep(elixirs, function(value) {
            return value.name !== $this.attr('name');
        });
        disableAlreadySelected($(otherSelect), val);
    });
}

module.exports = function () {
    initEvents();
};

},{"../../modules/util/isMobile":497}],555:[function(require,module,exports){
'use strict';

const removeDuplicatesFromArray = require('../../modules/util/removeDuplicatesFromArray'),
    ajaxUrl = require('../../modules/util/ajaxUrl'),
    ajax = require('../../modules/ajax'),
    ritualsStyles = require('../../rituals-styles'),
    Promise = require('promise'),
    flyout = require('../../flyout'),
    formHelpers = require('../../rituals-form-helper'),
    Resources = window.Resources || {},
    damHelper = require('../../dam/dam-helper'),
    gtm = require('../../modules/google').tagManager;

const genericFlyout = '.js-generic-flyout';
let timer;

function initEvents(){
    // on click in the notification PDP button and the close icon in the flyout, open or close
    $(document).off('click', '.js-out-of-stock-btn');
    $(document).on('click', '.js-out-of-stock-btn', function(e){
        e.preventDefault();
        e.stopPropagation();
        const $this = $(this);
        const $adventOutOfStock = $('.js-advent-out-of-stock');
        const source = $this.data('sticky-type');
        const popup = $this.parents('.js-popup-generic');
        // if click comes from packshot out of stock button, get the product
        if ($adventOutOfStock.length){
            getProductBar($('.js-advent-out-of-stock-pid').val());
        }
        if (source === 'showbar') {
            getProductBar($this.closest('form').find('[name=pid]').val());
        } else if (source === 'elixir'){
            const data = getElixirsOutOfStockData($this);
            updateElixirStickyValues(data);
            toggleFlyout();
        } else {
            toggleFlyout();
        }

        if (popup.length) {
            popup.dialog('close');
        }
    });

    //enable/disable the button depending on validation of the email field
    $(document).on('keyup', '.js-stock-notification-email', function(){
        const $form = $(this).closest('form');
        const isValid = $form.validate().checkForm();

        if ($('.js-stock-notification-email')[0].value.length === 0){
            // if input is empty, clean validation and start over
            $form.validate().resetForm();
            $('.js-stock-notification-email').next('.js-validator-error').remove();
        }

        if (isValid){
            $('.js-stock-notification-submit-btn').removeClass('btn--disabled');
        } else {
            $('.js-stock-notification-submit-btn').addClass('btn--disabled');
        }
    });

    //if the field has a validation error, validate on keydown
    $(document).on('keydown', '.js-stock-notification-email.error', function(){
        $(this).valid();
    });

    $(document).off('click', '.js-stock-notification-submit-btn');
    $(document).on('click', '.js-stock-notification-submit-btn', requestBackInStockNotification);
}

function getProductBar(pid) {
    if (!pid) {
        return;
    }
    // empty the flyout
    $('.js-alt-stock-notification-flyout').empty();

    // get new one
    ajax.load({
        url: Urls.getStockNotificationBar,
        data: {pid: pid, source: 'showbar'},
        target: $('.js-alt-stock-notification-flyout'),
        callback: function () {
            // toggle packshot sticky after a tiny timeout
            // fixes the choppy 'open' animation
            setTimeout(function(){
                toggleFlyout();
            }, 10);

            ritualsStyles.initInputStyles();
        }
    });
}

function toggleFlyout(){
    $(genericFlyout).addClass('flyout-out-of-stock');
    const flyoutHtml = $('.js-out-of-stock-wrapper').html();

    const options = {
        open: function() {
            formHelpers.init();
        }
    };

    flyout.loadFromHtml(flyoutHtml, options);
    damHelper.updateImages($('.js-flyout-out-of-stock'));
    window.clearTimeout(timer);
}

function requestBackInStockNotification(evt) {
    evt.preventDefault();

    const emailInput = $(this).parent().find('.js-stock-notification-email');
    const email = emailInput.val();

    if (!emailInput.valid() || !email) {
        return;
    }

    const productId = $('input#hdn_product_id').val();
    const gtmData = $('input#gtm-data').val();
    if (gtmData) {
        gtm.pushDataLayerEvent(JSON.parse(gtmData));
    }

    const $notificationButton = $('.js-stock-notification-submit-btn');
    $notificationButton.addClass('button-loading');
    $notificationButton.find('.js-spinner-general').addClass('spinner-visible');

    Promise.resolve($.ajax({
        type: 'POST',
        url: ajaxUrl(Urls.requestStockNotification),
        contentType: 'application/json',
        dataType: 'html',
        data: JSON.stringify({
            email: email,
            productId: productId
        })
    })).then(function (response) {
        const $outOfStockResponseContainer = $('.js-out-of-stock-response-container', '.js-flyout-container');
        const $outOfStockForm = $('.js-out-of-stock-form', '.js-flyout-container');
        $outOfStockResponseContainer.html(response);
        $outOfStockForm.addClass('js-submitted').hide();
        $outOfStockResponseContainer.removeClass('hide');
    });
}

/**
 * Resets the "notify me when back in stock" form.
 * Updates the product ID used, but leaves the email.
 * Useful when changing product variant (e.g. clothing size)
 * @param {string} productId The product to which a back in stock notification should be requested
 */
function resetForm(productId){
    $('input#hdn_product_id').val(productId);
    flyout.closeFlyouts();
    $('.js-out-of-stock-response-container').addClass('hide');
    $('.js-out-of-stock-response-container').empty();
    $('.js-out-of-stock-form').show();
}

const getElixirsOutOfStockData = function(button){

    const selected = button.parents('.js-product-details-content').find('option.js-out-of-stock-option:selected');
    if (!selected.length) {
        return [];
    }
    const data = $.map(selected, function(el){
        el = $(el);
        return {id: el.attr('value'),name:el.data('value')};
    });
    return removeDuplicatesFromArray(data, 'id');
};

const updateElixirStickyValues = function(data){
    if (!data || !data.length) {
        return;
    }

    const elixirStickyBar = $('.js-flyout-out-of-stock.js-elixir-out-of-stock');
    if (!elixirStickyBar.length){
        const elixirStickyBar = $('.js-flyout-out-of-stock');
        elixirStickyBar.attr('data-sticky-source','elixir').addClass('js-elixir-out-of-stock');
        elixirStickyBar.find('.image-container').remove();
    }

    let message;
    if (data.length === 1){
        $('input#hdn_product_id').val(data[0].id);
        message = String.format(Resources.ELIXIR_OUT_OF_STOCK,data[0].name);
    } else if (data.length === 2) {
        const elixirsIds = data.map(function(el){
            return el.id;
        });

        $('input#hdn_product_id').val(elixirsIds.join('|'));
        message = String.format(Resources.BOTH_ELIXIRS_OUT_OF_STOCK, data[0].name, data[1].name);
    }
    elixirStickyBar.find('div.message').html(message);
};

/**
 * @function
 * @description Binds the click event to the "Keep me posted" button
 */
module.exports = {
    init: initEvents,
    resetForm: resetForm
};

},{"../../dam/dam-helper":419,"../../flyout":425,"../../modules/ajax":449,"../../modules/google":453,"../../modules/util/ajaxUrl":478,"../../modules/util/removeDuplicatesFromArray":504,"../../rituals-form-helper":590,"../../rituals-styles":592,"promise":217}],556:[function(require,module,exports){
/*eslint no-unused-vars:0*/
'use strict';

const isMobileWidth = require('../../modules/util/isMobileWidth');
const isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth');
const isSmallView = require('../../modules/helpers/isSmallView');
const ScrollMagic = require('scrollmagic');
const controller = new ScrollMagic.Controller();

const $mainPdpBlock = $('.js-pdp-main');

// Boolean to check if we are viewing a Personalised Gifting PDP
const isPG = $mainPdpBlock.hasClass('giftset-pdp-main-container');
const isScrub = $('.js-pdp-scrub-slider').length > 0;

// Boolean to check if we are viewing a configurable product
const isConfigurable = $mainPdpBlock.hasClass('js-product-configurable');

// Boolean to check if a product should have animation on mobile
const noMobileAnimaiton = $mainPdpBlock.hasClass('js-no-mobile-animation');

// Animation elements definitions
const scrollMagicTriggerEl = '.js-scroll-magic-trigger';
const productImages = '.js-product-images';
const $imagesSlider = isPG ? $('.js-pg-pdp-image') : $('.js-pdp-images-slider');
const productDetailsContainer = '.js-product-details-container';
const ingredientsImages = '.js-product-ingredients-images';
const ingredientsSceneEl = '.js-ingredients-scene-element';
const $ingredientsDetailsBlock = isPG ? ($('.js-custom-giftset').length > 0 ? $('.js-custom-giftset') : $('.js-write-a-card-block')) : $('.js-product-ingredients-details');
const $ingredientsBlock = $('.js-product-ingredients-block');
const $bottomAnimationBlock = $('.js-bottom-animation-block');
const $pulsatingButton = $('.js-experience-pulsating-button');

/**
* Initialize the scenes for mobile animations
*/
function initHeroScenesMobile() {
    // Pin imageDrag until ingredients
    const imageDragStartOffset = 0;
    const imageDragOffset = ($(window).height() / 2) + imageDragStartOffset;


    let imageDragDuration;

    // Count with ingredients block for duration if it exists
    if ($ingredientsDetailsBlock.length > 0) { // only animate in mobile for ingredients block
        imageDragDuration = $ingredientsDetailsBlock.offset().top - ($(productImages).offset().top || 0) - ($imagesSlider.outerHeight() || 0) - imageDragStartOffset;
    } else {
        // Otherwise get next block and hide behind it
        $mainPdpBlock.addClass('no-ingredients');
        imageDragDuration = $mainPdpBlock.offset().top + $mainPdpBlock.outerHeight() - 50;

        // if there is no ingredients block, the opaque overlay only covers the main block
        $('.js-pdp-opaque-overlay').addClass('cover-main-block-only');
    }

    // scene that pins and drags the product main image
    const sceneImageDrag = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, imageDragDuration),
        offset: imageDragOffset
    })
        .setPin(productImages, {
            pushFollowers: false
        })
        .on('start', function(){
            // show only image - no promotion label or slider bar
            $(productImages).toggleClass('show-image-only');
            // make slider show first picture
            if (!isPG && $imagesSlider.hasClass('slick-initialized')) {
                $imagesSlider.slick('slickGoTo', 0);
            }
            // lock/unlock slider
            if ($imagesSlider.css('pointer-events') === 'none') {
                $imagesSlider.css('pointer-events', 'auto');
            } else {
                $imagesSlider.css('pointer-events', 'none');
            }
        })
        .addTo(controller);

    // Start opacity animation
    const opacityDurationOffset = isPG ? (isMobileWidth() ? 20 : -50) : 150;
    const opacityDuration = imageDragDuration - opacityDurationOffset;

    // Scene that activates the opaque layer behind the product description
    const sceneOpacity = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, opacityDuration),
        offset: imageDragOffset
    })
        .setClassToggle(productDetailsContainer, 'opaque')
        .addTo(controller);

    const blurOpacityDuration = isConfigurable ? 0 : imageDragDuration - opacityDurationOffset;

    // Scene controls blur animation of the main product image
    const sceneBlur = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: Math.max(0, blurOpacityDuration),
        offset: imageDragOffset
    })
        .setClassToggle(productImages, 'blurred')
        .addTo(controller)
        .on('start', function(){
        // hide/show pulsating button
            if ($pulsatingButton.hasClass('hidden')){
                $pulsatingButton.removeClass('hidden');
            } else {
                $pulsatingButton.addClass('hidden');
            }
        });

    if ($ingredientsDetailsBlock.length) {

        // Show ingredients
        const ingredientsOffset = imageDragStartOffset + ($(productDetailsContainer).outerHeight() * 2 / 3); // offset + 2 thirds of the product details block
        const ingredientsDuration = $ingredientsDetailsBlock.offset().top + $ingredientsDetailsBlock.outerHeight() - ingredientsOffset;

        // Scene that controls show/hide of the ingredients images
        const sceneIngredients = new ScrollMagic.Scene({
            triggerElement: scrollMagicTriggerEl,
            duration: Math.max(0, ingredientsDuration),
            offset: ingredientsOffset
        });

        if ($(ingredientsImages).length){
            sceneIngredients.setClassToggle(ingredientsImages, 'show');
        }
        sceneIngredients.addTo(controller);
    }
}

/**
 * Prepared pulsating button elements
 */
function pulsatingButtonPosition() {
    if ($('.js-slider-bar').length > 0) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '62px'
            );
        } else {
            $pulsatingButton.css(
                'bottom', '80px'
            );
        }
    }

    if (($('.js-slider-bar').length == 0) && (($('.js-promotional-label').length == 0))) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '5px'
            );
        } else {
            $pulsatingButton.css(
                'bottom', '0px'
            );
        }
    }

    if (($('.js-promotional-label').length > 0)) {
        if (isSmallView()) {
            $pulsatingButton.css(
                'bottom', '90px'
            );
        }
    }
}

/**
* Initializes the desktop mode
*/
function initDesktop() {
    if (!isScrub && $bottomAnimationBlock.length > 0) {
        const ingredientsBlockExists = !isPG && $ingredientsBlock.length > 0;

        $(productImages).imagesLoaded(function() {
            initHeroScenesDesktop(ingredientsBlockExists);

            if (ingredientsBlockExists) {
                initIngredientScenesDesktop();
            }
        });
    }
}

/**
 * Initializes the ScrollMagic hero scenes for desktop
 *
 * @param {Boolean} isIngredientBlock Switch to determine which end block to
 * use for the scroll animation
 */
function initHeroScenesDesktop(isIngredientBlock) {
    const headerHeight = $('.js-header').height();
    let offset = getimageDragTop();

    const $blockForAnimation = isIngredientBlock ? $ingredientsBlock : $bottomAnimationBlock;

    // TODO: Remove after PG PDP fully developed
    const duration = getElementTop($blockForAnimation) + (getElementHeight($blockForAnimation) / 2) - (getElementHeight($(productImages)) / 2);

    // For larger screens where the offset falls before the trigger
    if (!isPG && offset < ($(productImages).height() + $(productImages).position().top)){
        offset = ($(window).height() / 2) - headerHeight + 40; // 40 px to allow the user to scroll a tiny bit
    }

    $imagesSlider.on('beforeChange', function(){
        // if animation has started, make slider go back to 1st image
        $(window).scroll(function() {
            // make slider show first picture
            if ($imagesSlider.slick('getSlick').slideCount > 1 &&
                $imagesSlider.slick('slickCurrentSlide') !== 0) {
                $imagesSlider.slick('slickGoTo', 0);
            }
        });
    });

    // Pin packshot until ingredients
    const sceneImageDrag = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: duration,
        offset: offset
    })
        .setPin(productImages, {
            pushFollowers: false
        })
        .on('start', function(){
            // Show only image - no promotion label or slider bar
            $(productImages).toggleClass('show-image-only');

            if (!isPG && $imagesSlider.hasClass('slick-initialized')) {
                // Make slider show first picture
                if ($imagesSlider.slick('getSlick').slideCount > 1 &&
                    $imagesSlider.slick('slickCurrentSlide') !== 0) {
                    $imagesSlider.slick('slickGoTo', 0);
                }

                // Lock / unlock slider
                if ($imagesSlider.css('pointer-events') === 'none') {
                    $imagesSlider.css('pointer-events', 'auto');
                } else {
                    $imagesSlider.css('pointer-events', 'none');
                }
            }
        })
        .addTo(controller);

    // Hide experience button a little bit after the hero pin happens
    const sceneExperienceButton = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        duration: duration,
        offset: offset + 60
    })
        .on('start', function(){
            // Hide / show pulsating button
            if ($pulsatingButton.hasClass('hidden')){
                $pulsatingButton.removeClass('hidden');
            } else {
                $pulsatingButton.addClass('hidden');
            }
        })
        .addTo(controller);
}

/**
 * Initializes the ScrollMagic ingredients scenes for desktop
 */
function initIngredientScenesDesktop() {
    const offset = getElementTop($ingredientsBlock) + $(window).height() / 8;

    // Reveal ingredients
    const sceneRevealIngredients = new ScrollMagic.Scene({
        triggerElement: scrollMagicTriggerEl,
        offset: offset
    })
        .setClassToggle(ingredientsSceneEl, 'show')
        .addTo(controller);
}

/**
 * Prepare DOM elements for animations
 */
function getimageDragTop() {
    const headerHeight = $('.js-header').height();
    const mainImageHeight = isPG ? $(window).height() : $('.js-product-main-image').height();
    const productTop = $(productImages).position().top;

    return productTop + (mainImageHeight / 2) + (isPG ? -(headerHeight) : headerHeight);
}

/**
 * Calculates the top part of an element and returns it
 *
 * @param {String} el Selector of element
 * @returns {Integer} Calculated top of element
 */
function getElementTop(el) {
    const offset = -150;
    return $(el).offset().top + (isPG ? 0 : offset);
}

/**
 * Calculates the height of an element and returns is
 *
 * @param {String} el Selector of element
 * @returns {Integer} Calculated height of element
 */
function getElementHeight(el) {
    return $(el).height();
}

/**
* @description Prepare DOM elements for animations
*/
function prepareDOM() {
    // Show ingredient images - hidden on load to preserve page layout
    $(ingredientsImages).show();

    // Add class to PDP root element. Helps isolate animation styles
    if (!isScrub) {
        $('.js-pt-product-details').addClass('animate-scroll');
    }
}

const pdpAnimations = {
    init: function() {
        prepareDOM();

        if ($(scrollMagicTriggerEl).length > 0 && $mainPdpBlock.length) {
            if ((!isPG && !isScrub && !noMobileAnimaiton && isMobileWidth()) || (isPG && isMobileOrTabletWidth())) {
                initHeroScenesMobile();
            } else {
                if (document.readyState === 'complete') {
                    initDesktop();
                } else {
                    $(window).on('load', function () {
                        initDesktop();
                    });
                }
            }
        }

        // Init pulsating button position
        pulsatingButtonPosition();
    }
};

module.exports = pdpAnimations;

},{"../../modules/helpers/isSmallView":469,"../../modules/util/isMobileOrTabletWidth":498,"../../modules/util/isMobileWidth":499,"scrollmagic":253}],557:[function(require,module,exports){
'use strict';

const dialog = require('../../dialog'),
    toaster = require('../../toaster'),
    isMobileOrTabletWidth = require('../../modules/util/isMobileOrTabletWidth'),
    gtm = require('../../modules/google').tagManager;

const Urls = window.Urls || {};
let quantityBlock = {};
let $cache = {};
let removeProducts = false; //Default is false to prevent unintented request when the user makes an action except for 'Yes'

const dataLayer = window.dataLayer || [];
/**
* @Class quantityBlock
* Handle the increment and decrement function of the quantity block on Cart and Product page
*/
quantityBlock = {
    /**
    * @JSON object
    * Includes all default selectors and variables
    */
    def: {
        quantityField: 'js-quantity',
        quantityFieldOldVal: null,
        quantityFieldNewVal: null,
        incrementBtn: '.js-increment',
        decrementBtn: '.js-decrement',
        productObj: {}
    },

    /**
    * @function
    * Creates JSON object with jQuery objects
    */
    initializeCache: function () {
        $cache = {
            $cartTable: $('.js-shopping-cart', '#main'),
            $quantityField: $('.js-quantity', '#main'),
            $incrementBtn: $('.js-increment', '#main'),
            $decrementBtn: $('.js-decrement', '#main'),
            $cartSubmitForm: $('.js-cart-items-form'),
            $bonusProductRemovalPopupContainer: $('.js-free-product-removal')
        };
    },

    /**
    * @function
    * Model for increment functionality
    */
    increment: function () {
        const currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 1) {
            quantityBlock.def.productObj.$inputField.val(1);

        } else if (parseInt(currentValue) >= 999) {
            quantityBlock.def.productObj.$inputField.val(999);

        } else {
            quantityBlock.def.productObj.$inputField.val(parseInt(currentValue) + 1);
        }

        let eventData = $('#line-item-increment-' + quantityBlock.def.productObj.productId).val();
        if (eventData) {
            eventData = JSON.parse(eventData);
        }
        gtm.updateQuantity('add_to_cart', eventData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        quantityBlock.updateCart();
        gtm.pushQuantityChange(true, quantityBlock.def.productObj.productId);
    },

    /**
    * @function
    * Model for decrement functionality
    */
    decrement: function () {
        let currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 1) {
            quantityBlock.def.productObj.$inputField.val(0);
            currentValue = 1;

        } else {
            quantityBlock.def.productObj.$inputField.val(parseInt(currentValue) - 1);
        }

        quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, parseInt(quantityBlock.def.productObj.$inputField.val()), currentValue);
        let eventData = $('#line-item-' + quantityBlock.def.productObj.productId).val();
        if (eventData) {
            eventData = JSON.parse(eventData);
        }
        gtm.updateQuantity('remove_from_cart', eventData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        gtm.pushQuantityChange(false, quantityBlock.def.productObj.productId);
    },

    /**
    * @function
    * check if a bonus product will be removed by this action
    * @input productID: productID of the affected Product
    * @input lineItemUUID: UUID of the affected LineItem
    * @input newQuantity: new Quantity for the affected lineItem
    * @input currentQuantity: old Quantity for the affected lineItem
    * @output boolean of available products for single product
    */
    checkRemoveBonusProducts: function (productID, lineItemUUID, newQuantity, currentQuantity) {
        $.ajax({
            url: Urls.cartCheckRemoveBonusProducts,
            data: {
                pid: productID,
                uuid: lineItemUUID,
                newQuantity: newQuantity
            }
        })
            .fail(function (jqXHR, status, err) {
                console.error('Failure checking for removed bonus products: ', err);
            })
            .done(function (removedProductImages) {
                if (removedProductImages) {
                    //Get the dynamic header and description from the rendered template and place them in the correct place in the popup
                    const originHeaderDiv = $(removedProductImages).find('.js-removed-products-wrapper');
                    const originBodyDiv = $(removedProductImages).find('.js-removed-products-body');
                    const targetHeaderDiv = $('.js-custom-popup-header');
                    const targetBodyDiv = $('.js-custom-popup-body');
                    $(targetHeaderDiv).html($(originHeaderDiv).html());
                    $(targetBodyDiv).html($(originBodyDiv).html());
                    quantityBlock.createBonusWarningDialog(newQuantity, currentQuantity, removedProductImages);
                } else {
                    quantityBlock.getAvailability(quantityBlock.def.productObj.productId,
                        quantityBlock.def.productObj.bundledProducts,
                        quantityBlock.def.productObj.horProducts,
                        quantityBlock.def.productObj.elixirProducts,
                        quantityBlock.def.productObj.$inputField,
                        newQuantity === 0, (newQuantity - currentQuantity),
                        quantityBlock.def.productObj.dataLayerData);
                }
            });
    },

    /**
    * @function
    * Opens the 'these products will be removed' dialog for the current action
    * @input: currentQuantity {number} current quantity for product
    * @input currentQuantity: old Quantity for the affected lineItem
    * @input removedBonusProductImagesHtml: HTML with the images of the bonus products that will be removed if 'yes' is clicked
    */
    createBonusWarningDialog: function (newQuantity, currentQuantity, removedBonusProductImagesHtml) {
        removeProducts = false;

        $cache.$bonusProductRemovalPopupContainer.find('.js-free-product-removal-images').html(removedBonusProductImagesHtml);
        $cache.$bonusProductRemovalPopupContainer.find('.js-remove-popup-text').text(Resources.REMOVE_POPUP);

        if (isMobileOrTabletWidth()) {
            toaster.def.$toastContent.html($cache.$bonusProductRemovalPopupContainer.html());
            toaster.open({
                open: function() {
                    $('.js-modal-overlay').show();

                    $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(e){
                        removeProducts = true;
                        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
                        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
                        gtm.pushGwpEvent('remove gift', giftName);
                        toaster.closeToasters();
                    });
                    $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                        removeProducts = false;
                        toaster.closeToasters();
                    });

                },
                close: bonusWarningClose.bind(this, newQuantity, currentQuantity)
            });
            return;
        }
        dialog.open({
            html: $cache.$bonusProductRemovalPopupContainer.html(),
            target: $('.js-bonus-product-dialog-wrapper'),
            options: {
                width: 600,
                dialogClass: 'bonus-dialog-content gwp-dialog',
                open: function() {
                    $('.js-modal-overlay').show();

                    $(document).off('click.popup', '.js-modal-overlay').on('click.popup', '.js-modal-overlay', function(){
                        dialog.close();
                    });

                    $(document).off('click.popup', '.js-remove-gwp-product').on('click.popup', '.js-remove-gwp-product', function(e){
                        removeProducts = true;
                        const giftLabelDiv = e.currentTarget.parentNode.parentNode.querySelector('.gift-label');
                        const giftName = giftLabelDiv ? giftLabelDiv.textContent : null;
                        gtm.pushGwpEvent('remove gift', giftName);
                        dialog.close();
                    });
                    $(document).off('click.popup', '.js-keep-gwp-product').on('click.popup', '.js-keep-gwp-product', function(){
                        removeProducts = false;
                        dialog.close();
                    });

                },
                close: function () {
                    bonusWarningClose(newQuantity, currentQuantity);
                    dialog.close();
                    $('.js-modal-overlay').hide();
                }
            }
        });
    },

    /**
    * @function
    * Removing all quantity of a product line item
    */
    removeFullQuantity: function () {
        const currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());
        quantityBlock.def.productObj.$inputField.val(0);

        quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, parseInt(quantityBlock.def.productObj.$inputField.val()), currentValue);
    },

    /**
    * @function
    * Model for updating the input text field after change has been done
    */
    changeQuantityField: function () {
        let currentValue = parseInt(quantityBlock.def.productObj.$inputField.val());

        if (isNaN(currentValue) || currentValue < 0) {
            quantityBlock.def.productObj.$inputField.val(0);
            currentValue = 0;

        } else if (parseInt(currentValue) >= 999) {
            quantityBlock.def.productObj.$inputField.val(999);
            currentValue = 999;
        }

        const oldValue = parseInt(quantityBlock.def.quantityFieldOldVal, 10);

        if (currentValue < oldValue) {
            quantityBlock.checkRemoveBonusProducts(quantityBlock.def.productObj.productId, quantityBlock.def.productObj.lineItemUUID, currentValue, oldValue, quantityBlock.def.productObj.dataLayerData);

            return;
        }
        const quantityDelta = currentValue - oldValue;

        if (currentValue === 0 && quantityDelta < 0) {
            gtm.updateQuantity('remove_from_cart', quantityBlock.def.productObj.dataLayerData, Math.abs(quantityBlock.def.productObj.deltaQuantity));
        }
        quantityBlock.updateCart();

    },

    /**
    * @function
    * Check inventory for available products quantity for single product
    * @input pid:numer, string - product ID, quantityInput: jQuery object of HTML input field containing the product quantity
    * @input removed: is this a removed event
    * @input deltaQuantity: how many products were effected by this event
    * @output number of available products for single product
    */
    getAvailability: function (pid, bundledProducts, horProducts, elixirProducts, quantityInput, removed, deltaQuantity, dataLayerData) {
        $.ajax({
            url: Urls.getAvailability,
            data: {
                pid: pid,
                Quantity: quantityInput.val()
            }
        })
            .fail(function () {
                console.log('fail');
            })
            .done(function (data) {
                // open popup and adjust quantity in input field to maximum available products
                if (data && data.availability && !data.availability.isAvailable && data.availability.statusQuantity > 0) {
                    quantityBlock.createDialog(data.availability.levels.IN_STOCK);
                } else {
                    // trigger gtm event
                    // trigger remove only when all product line items for a product
                    // are removed
                    if (removed && deltaQuantity < 0) {
                        gtm.updateQuantity('remove_from_cart', dataLayerData, Math.abs(deltaQuantity));
                    }
                    quantityBlock.updateCart();
                }

            });
    },

    /**
    * @function
    * Opens the 'not available' dialog with the current product
    * @input: {number} maximum available quantity for single product
    */
   createDialog: function () {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.MODAL_NOINVENTORY_HEADING
            },
            paragraphs: [
                {
                    text: window.Resources.MODAL_NOINVENTORY_MESSAGE
                }
            ],
            ctaHolder: {},
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.MODAL_NOINVENTORY_BUTTON_OK,
                    eventName: 'onPrimaryButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                eventName: 'onCloseElementClick',
                shouldCloseModal: true
            },
            modalLarge: true,
            centerOnMobile: true
        });
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the product ID for the given input field ID
    */
    getProductID: function (ele) {
        const productIdArr = ele.attr('id').split('-');
        const productId = productIdArr[productIdArr.length - 1];
        return productId;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the bundled products for the given input field ID
    */
    getBundledProducts: function (ele) {
        const bundledProducts = ele.data('bundled-products');
        return bundledProducts;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the House of Rituals products for the given input field ID
    */
    getHORProducts: function (ele) {
        const horProducts = ele.data('hor-products');
        return horProducts;
    },

    /**
    * @function
    * @input: jQuery object of the input field
    * @output: the elixir products for the given input field ID
    */
    getElixirProducts: function (ele) {
        const elixirProducts = ele.data('elixir-products');
        return elixirProducts;
    },

    /**
    * @function
    * @input: jQuery object of the clicked button
    * @output: the quantity input field object for the given object/button pressed
    */
    getInputField: function (ele) {
        const $inputField = ele.hasClass(quantityBlock.def.quantityField) ? ele : ele.siblings('.' + quantityBlock.def.quantityField);
        return $inputField;
    },

    /**
    * @function
    * @input: jQuery object of the table row
    * @output: the lineitem UUID for the given table row
    */
    getLineItemUUID: function (ele) {
        const lineItemUUID = ele.data('uuid');
        return lineItemUUID;
    },

    /**
    * @function
    * Creates/updates the object in default global scope for single product
    * @input: jQuery object of the clicked button
    */
    buildObj: function (ele) {
        const obj = {};
        obj.$inputField = quantityBlock.getInputField(ele);
        obj.productId = quantityBlock.getProductID(obj.$inputField);
        obj.bundledProducts = quantityBlock.getBundledProducts(obj.$inputField);
        obj.horProducts = quantityBlock.getHORProducts(obj.$inputField);
        obj.elixirProducts = quantityBlock.getElixirProducts(obj.$inputField);
        const cartLineItemElement = obj.$inputField.parents('.js-cart-row').first();
        obj.lineItemUUID = quantityBlock.getLineItemUUID(cartLineItemElement);
        const dataLayerData = cartLineItemElement.find('#line-item-' + obj.productId).val();
        obj.dataLayerData = dataLayerData && JSON.parse(dataLayerData);
        // add this object also to class scope
        quantityBlock.def.productObj = obj;
    },

    /**
    * @function
    * Update Cart after events functions
    */
    updateCart: function () {
        $cache.$cartSubmitForm.submit();
    },

    /**
    * @function
    * Function for initializing all the events for the quantity block
    */
    events: function () {

        /* CART-PAGE: DECREMENT EVENT */
        $(document).on('click', quantityBlock.def.decrementBtn, function (e) {
            e.preventDefault();
            quantityBlock.decrement(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INCREMENT EVENT */
        $(document).on('click', quantityBlock.def.incrementBtn, function (e) {
            e.preventDefault();
            quantityBlock.increment(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INPUT FIELD EVENT */
        $(document).on('blur', '.js-quantity', function (e) {
            e.preventDefault();

            // don't do anything when the value didn't changed from last time
            if ($(this).val() === quantityBlock.def.quantityFieldOldVal) {
                return;
            }

            quantityBlock.changeQuantityField(quantityBlock.buildObj($(this)));
        });

        /* CART-PAGE: INPUT FIELD EVENT - save old value on focus */
        $(document).on('focus', '.js-quantity', function (e) {
            e.preventDefault();

            quantityBlock.def.quantityFieldOldVal = $(this).val();
        });

        // trigger events on enter
        $(document).on('keyup keypress', '.js-quantity', function (e) {
            const keyCode = e.keyCode || e.which;
            if (keyCode === 13) {
                e.preventDefault();
                $(this).trigger('blur');
            }
        });
    },

    /**
    * @function
    * Main initializing function prepared as the only one for export as a module
    */
    init: function () {
        quantityBlock.initializeCache();

        // do not initialize when qunatity block is not present in view
        if ($cache.$quantityField.length <= 0) {
            return;
        }

        quantityBlock.events();
    }
};

module.exports = quantityBlock;

function bonusWarningClose(newQuantity, currentQuantity){
    $(document).trigger('resetPopupDialog');
    if (removeProducts) {
        quantityBlock.getAvailability(quantityBlock.def.productObj.productId,
            quantityBlock.def.productObj.bundledProducts,
            null,
            null,
            quantityBlock.def.productObj.$inputField,
            newQuantity === 0, (newQuantity - currentQuantity),
            quantityBlock.def.productObj.dataLayerData);

            const tierStep = $('.js-gwp-tier-step').val();
            if (tierStep > 0){
                dataLayer.push({
                    'event': 'GWPPopUpDelete',
                    'threshold': tierStep
                });
            }
    } else {
        quantityBlock.def.productObj.$inputField.val(currentQuantity);
    }
    $('.js-modal-overlay').hide();
}

},{"../../dialog":422,"../../modules/google":453,"../../modules/util/isMobileOrTabletWidth":498,"../../toaster":605}],558:[function(require,module,exports){
'use strict';

const ajax = require('../../modules/ajax'),
    isMobile = require('../../modules/util/isMobile'),
    appendParamsToUrl = require('../../modules/util/appendParamsToUrl'),
    isInViewport = require('../../modules/helpers/isInViewport'),
    isAdvent = document.querySelectorAll('.js-advent-block').length > 0,
    isOnboardingPage = document.querySelectorAll('.js-onboarding-page').length > 0;

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    if (stickyAddToCart.def.$pdpButtonEl.length > 0) {
        $(window).on('scroll', windowScrollHandler);
    }

    // handle click in select size or select option - inside the sticky bar only
    $(document).on('click', '.js-sticky-add-to-cart .js-pdp-select-size-btn, .js-sticky-add-to-cart .js-select-option', function(){
        scrollToOptionsPicker();
    });

    $(document).on('stickyAddToCart.onNotSelectedOption', function(){
        scrollToOptionsPicker();
    });

    if (isAdvent) {
        windowScrollHandler();
    }

    if (isOnboardingPage){
        $(window).on('scroll', windowScrollStickyCtaHandler);
    }
}

/**
 * @description window scroll handler for the sticky add to cart
 **/
function windowScrollHandler() {
    getDefs();
    const scroll = $(window).scrollTop(); // how many pixels you've scrolled
    const pdpAddToCartButtonEl = stickyAddToCart.def.$pdpButtonEl.find(stickyAddToCart.def.pdpBtnClass);
    const pdpAddToCartOffset = stickyAddToCart.def.$pdpButtonEl.offset().top; // pixels to the top of the pdp add to cart btn
    const pdpAddToCartHeight = pdpAddToCartButtonEl.height(); // height of pdp add to cart btn
    const footerIsInView = isInViewport('.js-footer');

    // if you've scrolled further than the top of add to cart btn plus its height
    // show sticky bar.
    // else hide sticky bar
    if (isAdvent) {
        stickyAddToCart.def.$stickyBarEl.toggleClass('show-bar', !isInViewport(pdpAddToCartButtonEl) && !footerIsInView);
    } else if (scroll > pdpAddToCartOffset + pdpAddToCartHeight){
        // if there is a packshot hide sticky if packshot or footer are in viewport
        const $packshotEl = $('.js-packshot-container');

        if ($packshotEl.length > 0) {
            const packshotIsInView = isInViewport($packshotEl);
            if (packshotIsInView || footerIsInView) {
                stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
            } else {
                stickyAddToCart.def.$stickyBarEl.addClass('show-bar');
            }
            return;
        } else {
            if (footerIsInView) {
                stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
            } else {
                stickyAddToCart.def.$stickyBarEl.addClass('show-bar');
            }
            return;
        }
    } else {
        stickyAddToCart.def.$stickyBarEl.removeClass('show-bar');
    }
}
function windowScrollStickyCtaHandler(){
    const footerIsInView = isInViewport('.js-footer');
    const heroIsInView = isInViewport('.js-crm-hero');
    const lastNugdeIsInView = isInViewport('.js-last-nudge');
    stickyAddToCart.def.$stickyBarEl.toggleClass('show-bar', !footerIsInView && !heroIsInView && !lastNugdeIsInView);
}
function scrollToOptionsPicker(){
    if (!isMobile()) {
        $('html, body').animate({scrollTop: 0}, 'slow');

        return;
    }

    $('html, body').animate({scrollTop: $('.js-product-details-block').offset().top}, 'slow');
}

/**
 * @description inserts the dropdown in the select size button
 **/
function initVariationsDropdown(){
    $('.js-variations-dropdown').insertAfter('.js-sticky-add-to-cart .js-pdp-select-size-btn');
}

/**
 * @description inserts the dropdown in the select size button
 **/
function initOptionsDropdown(){
    $('.js-sticky-add-to-cart .js-options-dropdown').insertAfter('.js-sticky-add-to-cart .js-select-option');
    $('.js-sticky-add-to-cart .js-options-hidden-input').insertAfter('.js-sticky-add-to-cart .js-select-option');
}

/**
 * @description update add to cart button
 **/
function updateAddToCartBtn(variation, isSelected){
    const $updateTarget = $('.js-sticky-add-to-cart-form');
    const url = Urls.addToCartPartial;

    const $variationElement = $(variation).find('option').length > 0 ? $(variation).find('option:selected') : $(variation);

    const pid = isSelected ? $variationElement.data('masterid') : $variationElement.data('pid');

    const params = {
        pid: pid,
        uuid: ''
    };

    ajax.load({
        url: appendParamsToUrl(url, params),
        target: $updateTarget
    });
}

/**
 * @description refresh values for the cached - useful for ajax'ed elements
 **/
function getDefs(){
    const currentButton =
        $('.js-product-details-content .js-add-to-cart').length > 0
            ? '.js-add-to-cart'
            : $('.js-product-details-content .js-out-of-stock-button').length > 0
                ? '.js-out-of-stock-button'
                : $('.js-product-details-content .js-out-of-stock-btn').length > 0
                    ? '.js-out-of-stock-btn'
                    : false;
    stickyAddToCart.def = {
        $pdpButtonEl: $('.js-pdp-add-to-cart-form'),
        pdpBtnClass: currentButton ? currentButton
            : $('.js-product-details-content .js-product-configurator-trigger').length > 0 ? '.js-product-configurator-trigger' : '.js-select-option',
        $stickyBarEl: $('.js-sticky-add-to-cart'),
        $stickyAddToCartForm: $('.js-sticky-add-to-cart-form')
    };
}

/**
 * @description check if sticky bar exists in the page
 **/
function stickyBarExists(){
    return $('.js-sticky-add-to-cart').length > 0;
}


const stickyAddToCart = {
    init: function() {
        if (stickyBarExists()){
            getDefs();
            initializeEvents();
            initVariationsDropdown();
            initOptionsDropdown();
        }
    },
    updateAddToCartBtn: function(variation, isSelected){
        if (stickyBarExists()){
            updateAddToCartBtn(variation, isSelected);
        }
    }
};

module.exports = stickyAddToCart;

},{"../../modules/ajax":449,"../../modules/helpers/isInViewport":464,"../../modules/util/appendParamsToUrl":480,"../../modules/util/isMobile":497}],559:[function(require,module,exports){
'use strict';

const ajax = require('../../modules/ajax'),
    slickSlider = require('../../slick-slider'),
    damHelper = require('../../dam/dam-helper'),
    socialCommerce = require('../../social-commerce/social-commerce'),
    getUpdatedURLWithParams = require('../../modules/util/getUpdatedURLWithParams'),
    responsiveVideo = require('../../responsive-video');

const updateStateAndUrlParams = (urlParams, paramsToRemove, skipHash) => {
    const newURL = getUpdatedURLWithParams(urlParams, paramsToRemove, skipHash);
    if (!newURL) {
        return;
    }

    window.history.replaceState({}, '', newURL);
    socialCommerce.updateCustomerLastUrl();
};

const updateAddToCartButton = (addToCartUrl) => {
    updateAddToCartButtonBlock(addToCartUrl, '.js-pdp-add-to-cart-form');
};

const updateStickyAddToCartButton = (stickyAddToCartUrl) => {
    updateAddToCartButtonBlock(stickyAddToCartUrl, '.js-sticky-add-to-cart-form');
};

const updateAddToCartButtonBlock = (url, targetClass) => {
    if (!url || !targetClass) {
        return;
    }

    const $updateTarget = $(targetClass);
    ajax.load({
        url: url,
        target: $updateTarget,
        replaceTarget: false,
    });
};

const updateImages = (urlImages, callback) => {
    if (!urlImages) {
        if (callback && $.isFunction(callback)) {
            callback();
        }
        return;
    }
    const targetClass = '.js-images-wrapper';
    const $updateTarget = $(targetClass);
    const $spinner = $('.js-pdp-images-spinner');

    $spinner.addClass('spinner-visible');

    ajax.load({
        url: urlImages,
        target: $updateTarget,
        replaceTarget: true,
        callback: function () {
            $spinner.removeClass('spinner-visible');
            $(targetClass).addClass('fade-out');
            damHelper.updateImages($('.js-images-wrapper'));
            damHelper.updateImages($('.js-pdp-swatches-list'));

            setTimeout(function() {
                $(targetClass).removeClass('fade-out');
                slickSlider.initDefaultSlider();
                $(document).trigger($.Event('productPage.onImageUpdate'));
                if (callback && $.isFunction(callback)) {
                    callback();
                }
            }, 100);
        }
    });
};

const updateProductDetailImage = (variationProductDetailImageUrl) => {
    updateImage(variationProductDetailImageUrl, '.js-product-info-column-image', '.js-product-info-image');
};

const updateProductLifestyleImage = (variationProductLifestyleImageUrl) => {
    updateImage(variationProductLifestyleImageUrl, '.js-product-ingredients-column-image', '.js-product-lifestyle-image');
};

const updateHowToUseImage = (howToUseImageUrl) => {
    updateImage(howToUseImageUrl, '.js-how-to-use-block', '.js-how-to-use-image');
};

const updateEasterARBlockImage = (arBlockImageUrl) => {
    updateImage(arBlockImageUrl, '.js-easter-ar-block', '.js-egg-image');
};

const updateStickyBarImage = (stickyBarImage) => {
    updateImage(stickyBarImage, '.js-sticky-add-to-cart', '.image');
};

const updateImage = (image, imageHolderClass, imageClass) => {
    if (!image || !imageHolderClass || !imageClass) {
        return;
    }

    const $imageHolder = $(imageHolderClass);
    const $target = $(imageClass, $imageHolder);
    if (!$imageHolder.length || !$target.length) {
        return;
    }
    if (Object.prototype.toString.call(image) === '[object Object]') {
        $target.attr('data-src', image.src);
        $target.attr('alt', image.alt);
    } else {
        $target.attr('data-src', image);
    }
    damHelper.updateImages($imageHolder);
};

const trimAndUpdateLongDescription = (usp) => {
    if (!usp) {
        return;
    }

    usp = usp.replaceAll(/[\n]/g,'<br>');
    updateTabsDescription(usp);
    usp = usp.replaceAll('<br>', '');

    const $longDescriptionElement = $('.js-long-description');
    if (!$longDescriptionElement || !$longDescriptionElement.length) {
        return;
    }

    if (usp.length <= 140) {
        $longDescriptionElement.text(usp);
        return;
    }

    const trimmedUSP = usp.substring(0, 137 - $('.js-read-more-link').text().length);
    const currentUSP = $longDescriptionElement.html();
    $longDescriptionElement.html(trimmedUSP + currentUSP.substring(currentUSP.indexOf('<'), currentUSP.length));
};

const updateShortDescription = (shortDescription) => {
    updateText(shortDescription, '.js-product-details-content .short-description');
};

const updateTitle = (title) => {
    updateText(title, '.js-product-details-block .product-name', true);
};


const updateProductTitle = (text) => {
    if (!text){ return;}
    $('.js-product-details-block .product-name').each(function() {
        const $contents = $(this).contents();
        $contents[$contents.length - 1].nodeValue = text;
    });
};

const updateFragrance = (fragrance) => {
    updateText(fragrance, '.scrub-variant');
};

const updateStickyBarTitle = (stickyBarTitle) => {
    updateText(stickyBarTitle, '.js-sticky-add-to-cart .product-name', true);
};

const updateAncientRituals = (ancientRituals) => {
    updateText(ancientRituals, '.js-product-details-block .js-the-ritual-of-title');
};

const updateStickyBarAncientRituals = (stickyBarAncientRituals) => {
    updateText(stickyBarAncientRituals, '.js-sticky-add-to-cart .js-the-ritual-of-title');
};

const updateInfoTitle = (infoTitle) => {
    updateText(infoTitle, '.js-info-title');
};

const updateInfoText = (infoText) => {
    updateText(infoText, '.js-info-description');
};

const updateHowToUseText = (howToUseText) => {
    updateText(howToUseText, '.js-how-to-use-block .js-how-to-use-text');
};

const updateText = (text, targetClass, preserveRituals) => {
    if (!text || !targetClass) {
        return;
    }

    const $target = $(targetClass);
    const $rituals = preserveRituals ? $target.find('span') : null;

    if (!$target || !$target.length) {
        return;
    }

    $target.html(text);
    if (preserveRituals && $rituals && $rituals.length) {
        $target.prepend($rituals);
    }
};

const updateClaimableIngredients = (claimableIngredients) => {
    if (!claimableIngredients) {
        return;
    }
    const $target = $('.product-ingredients-container .product-ingredients-content');
    if (!$target.length) {
        return;
    }
    let itemExposed = '';
    if ($target.children().filter('.ingredient-item-exposed').first()) {
        itemExposed = ' ingredient-item-exposed';
    }

    $target.empty();
    claimableIngredients.forEach(function(claimableIngredient){
        $target.append('<div class="ingredient-item' + itemExposed + '"><h3>' + claimableIngredient.Name + '</h3><p>' + claimableIngredient.Description + '</p></div>');
    });
};

const updateClaimableIngredient = (claimableIngredient) => {
    if (!claimableIngredient) {
        return;
    }
    const $target = $('.js-ingredient-item');
    if (!$target.length) {
        return;
    }
    $('.js-ingredient-title', $target).text(claimableIngredient.Name);
    $('.js-ingredient-text', $target).text(claimableIngredient.Description);
};

const updateChemicalIngredients = (chemicalIngredients) => {
    if (!chemicalIngredients) {
        return;
    }
    const $target = $('.js-ingredient-tab-content-inner .js-tab-expanding-content');
    if (!$target.length) {
        return;
    }
    $target.text(chemicalIngredients);
};

const updateTabsDescription = (tabsDescription) => {
    updateTabsText(tabsDescription, '.js-product-tabs .js-description-tab-content', '.js-product-tabs .js-description-acc-head');
};

const updateTabsIngredients = (chemicalIngredients) => {
    updateTabsText(chemicalIngredients, '.js-product-tabs .js-ingredients-tab-content .js-tab-expanding-content', '.js-product-tabs .js-ingredients-acc-head');
};

const updateTabsContents = (tabsContents) => {
    updateTabsText(tabsContents, '.js-product-tabs .js-contents-tab-content', '.js-product-tabs .js-contents-acc-head');
};

const updateTabsText = (tabsText, desktopSelector, mobileSelector) => {
    if (!tabsText || !desktopSelector || !mobileSelector) {
        return;
    }

    const $desktopTarget = $(desktopSelector);
    if ($desktopTarget && $desktopTarget.length) {
        $desktopTarget.html(tabsText);
    }
    const $mobileTarget = $(mobileSelector).next();
    if ($mobileTarget && $mobileTarget.length) {
        $mobileTarget.html(tabsText);
    }
};

const updateRitualsIcon = (ritualsIconUrl) => {
    const $target = $('.js-ritual-icon');
    if (!$target.length || !$target.length) {
        return;
    }

    if (!ritualsIconUrl) {
        $target.addClass('hide');
        return;
    }

    $target.attr('src', ritualsIconUrl);
    $target.removeClass('hide');
};

const updateBlocksWithColor = (selector, classToAdd, classesToRemove) => {
    if (!selector || !classToAdd) {
        return;
    }

    const $element = $(selector);
    if (!$element || !$element.length) {
        return;
    }

    if (classesToRemove || classesToRemove.length) {
        classesToRemove.forEach((cssClass) => {
            $element.removeClass(cssClass);
        });
    }

    $element.addClass(classToAdd);
};

const updateUSPs = (usps) => {
    if (!usps || Object.prototype.toString.call(usps) !== '[object Object]') {
        return;
    }

    for (const key in usps) {
        if (!usps[key]) {
            continue;
        }
        const $element = $('.js-selected-variant-' + key);
        if (!$element || !$element.length) {
            continue;
        }

        $element.text(usps[key]);
    }
};

const updateVideoSrc = (id, videoSrc) => {
    if (!id || !videoSrc) {
        return;
    }

    responsiveVideo.updateVideoSrc(id, videoSrc);
};

module.exports = {
    updateStickyBarImage: updateStickyBarImage,
    trimAndUpdateLongDescription: trimAndUpdateLongDescription,
    updateProductDetailImage: updateProductDetailImage,
    updateProductLifestyleImage: updateProductLifestyleImage,
    updateImages: updateImages,
    updateHowToUseImage: updateHowToUseImage,
    updateAddToCartButton: updateAddToCartButton,
    updateStickyAddToCartButton: updateStickyAddToCartButton,
    updateShortDescription: updateShortDescription,
    updateTitle: updateTitle,
    updateProductTitle:updateProductTitle,
    updateStickyBarTitle: updateStickyBarTitle,
    updateFragrance: updateFragrance,
    updateClaimableIngredients: updateClaimableIngredients,
    updateClaimableIngredient:updateClaimableIngredient,
    updateChemicalIngredients:updateChemicalIngredients,
    updateAncientRituals: updateAncientRituals,
    updateStickyBarAncientRituals: updateStickyBarAncientRituals,
    updateRitualsIcon: updateRitualsIcon,
    updateInfoTitle: updateInfoTitle,
    updateInfoText: updateInfoText,
    updateHowToUseText: updateHowToUseText,
    updateEasterARBlockImage: updateEasterARBlockImage,
    updateTabsIngredients: updateTabsIngredients,
    updateTabsDescription: updateTabsDescription,
    updateTabsContents: updateTabsContents,
    updateBlocksWithColor: updateBlocksWithColor,
    updateUSPs: updateUSPs,
    updateVideoSrc: updateVideoSrc,
    updateStateAndUrlParams: updateStateAndUrlParams
};

},{"../../dam/dam-helper":419,"../../modules/ajax":449,"../../modules/util/getUpdatedURLWithParams":495,"../../responsive-video":589,"../../slick-slider":598,"../../social-commerce/social-commerce":599}],560:[function(require,module,exports){
'use strict';

const ajax = require('../../modules/ajax'),
    stickyAddToCart = require('./stickyaddtocart'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    appendParamsToUrl = require('../../modules/util/appendParamsToUrl'),
    getQueryStringParams = require('../../modules/util/getQueryStringParams'),
    getQueryString = require('../../modules/util/getQueryString'),
    gtm = require('../../modules/google').tagManager,
    outOfStock = require('./outOfStock');


/**
 * @description update product content with new variant from href, load new content to #product-content panel
 * @param {String} href - url of the new product variant
 * @param {String} forcePdpUpdate - instead of looking for the closest pdp content, updates the main one
 * @param {Boolean} isProductTile - changes the update target class to the product-tile one
 **/
const updateContent = function (href, target, forcePdpUpdate, isProductTile) {

    // get target class to update
    const targetClass = isProductTile ? '.js-product-tile' : '.js-product-details-content';
    // get closest .js-product-details-content in case there are several in a page (like recommendations product quickview in a PDP)
    const $updateTarget = forcePdpUpdate ? $('.js-product-details-content') : $(target).closest(targetClass);

    // if there is a hidden field with the source, pass it along with the params
    let source = '';
    const sourceEl = $(target).closest('.js-product-tile').find('.js-include-source');
    if (sourceEl.length){
        source = sourceEl.text();
    }

    let $pdpForm = $('.js-pdp-add-to-cart-form');
    const qty = $pdpForm.find('input[name="Quantity"]').first().val();
    const params = {
        Quantity: isNaN(qty) ? '1' : qty,
        format: 'ajax',
        source: source,
        productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
    };

    progress.show($('.js-pdp-main'));

    ajax.load({
        url: appendParamsToUrl(href, params),
        target: $updateTarget,
        replaceTarget: isProductTile,
        callback: function () {
            if (SitePreferences.STORE_PICKUP) {
                productStoreInventory.init();
            }

            // update gtm datalayer
            // could be done better by getting the variant values from the
            // response
            $pdpForm = $('.js-pdp-add-to-cart-form');
            const availability = $pdpForm.find('input[name="availableQuantity"]').first().val();
            const variantId = $pdpForm.find('input[name="pid"]').val();
            const qsParams = getQueryStringParams(getQueryString(href));
            const masterId = qsParams.pid;
            if ((masterId !== variantId) && (typeof availability !== 'undefined')){
                gtm.selectVariant('products', masterId, variantId, availability);
            }

            // reinit sticky add to cart
            stickyAddToCart.init();

            // reset the "back in stock" form
            outOfStock.resetForm(variantId);
        }
    });
};

/**
 * @description flyout size selection bar is loading before the pdp page.
 * And flyout is not updating with size selection on pdp, should be updated manually.
 * @param {String} clickedSize - text of the clicked size
 * @param {Boolean} enableDeselect - If true, the customer can deselect a size
 **/
const updateFlyoutVariations = function (clickedSize, enableDeselect) {
    $('.js-swatch-anchor').each(function() {
        if (this.innerText === clickedSize && !($(this).parent('li').hasClass('selected'))) {
            $(this).parent('li').addClass('selected');
        } else if (this.innerText !== clickedSize || enableDeselect) {
            $(this).parent('li').removeClass('selected');
        }
    });
};

/**
 * @description handle variation click
 **/
function variationChangeHandler(e, forcePdpUpdate){
    const target = e.target;

    // if not selectable, do nothing
    if ($(target).hasClass('js-swatch-unselectable')) { return; }

    // //update size selection bar on flyout
    updateFlyoutVariations(target.innerText, true);

    let href;
    let isProductTile = false;

    // if target parent is a product tile, href gets product tile
    // TODO: have this product tile href logic come from the variations.isml
    if ($(target).parents('.js-product-tile').length > 0){

        // if product tile and out of stock, do not select
        if ($(target).parent().hasClass('js-swatch-out-of-stock')) {
            return;
        }

        // get product id from the variation
        const pid = $(target).data('pid');

        const showimage = $(target).closest('.js-grid-wrap').length > 0 ? true : false;

        const params = {
            'pid': pid,
            'showimage': showimage
        };
        href = appendParamsToUrl(Urls.getProductTile, params);
        isProductTile = true;
    } else {
        href = target.href || $(target).find('option:selected').data('href');
    }

    // update content
    updateContent(href, target, forcePdpUpdate, isProductTile);

    const isSelected = $(target).parent('.swatch').hasClass('selected');

    // update add to cart btn in sticky bar
    stickyAddToCart.updateAddToCartBtn(target, isSelected);
}

function cartVariationChangeHandler(e) {
    const $target = $(e.target);

    // if not selectable, do nothing
    if ($target.hasClass('js-swatch-unselectable')) { return; }

    // //update size selection
    updateFlyoutVariations($target[0].innerText, false);

    //Update the product id to send
    const productId = $target.data('pid');
    const pidInputField = $target.closest('.js-cart-product-variation-edit').find('.js-product-variation-edit-product-id');
    pidInputField.val(productId);
}

function initEvents(){
    // click on swatch - should replace product content with new variant
    $('body').on('click', '.js-swatch-anchor-variant', function(e) {
        e.preventDefault();
        e.stopPropagation();
        variationChangeHandler(e);
    });

    //Cart swatch click - different logic than other pages
    $('body').on('click', '.js-cart-swatch-anchor-variant', function(e) {
        e.preventDefault();
        e.stopPropagation();
        cartVariationChangeHandler(e);
    });

    $('body').on('change', '.js-variations-dropdown', function(e){
        variationChangeHandler(e, true);
    });
}

module.exports = function () {
    initEvents();
};

},{"../../modules/ajax":449,"../../modules/google":453,"../../modules/util/appendParamsToUrl":480,"../../modules/util/getQueryString":491,"../../modules/util/getQueryStringParams":492,"../../progress":584,"../../storeinventory/product":602,"./outOfStock":555,"./stickyaddtocart":558}],561:[function(require,module,exports){
'use strict';

const gtm = require('../../modules/google').tagManager;

const updatePDPHandler = require('./updatePDPHandler'),
    damHelper = require('../../dam/dam-helper'),
    easter = require('../../easter/easter');

const variationsEvents = {
    onNotSelectedOption: $.Event('stickyAddToCart.onNotSelectedOption'),
    onOptionChange: $.Event('selectric.setOutOfStockClass'),
    onSwatchChange: $.Event('selectric.filterVisibleOptionsAndSetOutOfStockClass')
};

// Used currently only for the Scrub Bar PDP to prevent multiple clicks on
// variantion buttons before new main image is changed in slider.
// Ticket: https://rituals.atlassian.net/browse/DL-24789
let blockEvent = false;

const pushScrubData = (event) => {
    event = event || 'pdp_swatch_interaction';

    const dataLayerObject = {
        event: event
    };

    gtm.pushDataLayerEvent(dataLayerObject);
};

const updateEasterData = (easterData) => {
    const urlParams = {
        skipAnimation: true
    };
    urlParams[easterData.variationAttribute] = easterData.variationAttributeValue;
    updatePDPHandler.updateStateAndUrlParams(urlParams);
    updatePDPHandler.updateImages(easterData.urlImages, function() {
        updatePDPHandler.updateBlocksWithColor('.js-product-details-container', easterData.colorClass, easterData.allColorClasses);
    });
    updatePDPHandler.updateAncientRituals(easterData.ancientRitual);
    updatePDPHandler.updateShortDescription(easterData.shortDescription);
    updatePDPHandler.updateTitle(easterData.title);
    updatePDPHandler.updateRitualsIcon(easterData.ritualIconUrl);
    updatePDPHandler.updateAddToCartButton(easterData.addToCartUrl);
    easter.updateARbuttons(easterData.src, easterData.iosSrc, easterData.description);
    easter.updateARmodel(easterData.src, easterData.iosSrc);
    updatePDPHandler.updateProductDetailImage(easterData.productDetailImageUrl);
    updatePDPHandler.updateInfoTitle(easterData.detailTitle);
    updatePDPHandler.updateInfoText(easterData.detailDescription);
    updatePDPHandler.updateProductLifestyleImage(easterData.ingredientsBackgroundImageUrl);
    updatePDPHandler.updateClaimableIngredients(easterData.claimableIngredients);
    updatePDPHandler.updateBlocksWithColor('.js-product-ingredients-block', easterData.fullColorClass, easterData.allFullColorClasses);
    updatePDPHandler.updateHowToUseImage(easterData.howToUseImageUrl);
    updatePDPHandler.updateHowToUseText(easterData.howToUseText);
    updatePDPHandler.updateEasterARBlockImage(easterData.arImageUrl);
    updatePDPHandler.updateBlocksWithColor('.js-easter-ar-block', easterData.solidColorClass, easterData.allSolidColorClasses);
    updatePDPHandler.updateTabsIngredients(easterData.chemicalIngredients);
    updatePDPHandler.updateTabsDescription(easterData.usp);
    updatePDPHandler.updateTabsContents(easterData.boxContains);
    updatePDPHandler.updateStickyBarTitle(easterData.title);
    updatePDPHandler.updateStickyBarAncientRituals(easterData.ancientRitual);
    updatePDPHandler.updateStickyBarImage(easterData.stickyBarImage);
    updatePDPHandler.updateStickyAddToCartButton(easterData.stickyAddToCartUrl);
    $(document).trigger($.Event('easter.onSwatchChange'),[easterData.ritual]);
    easter.pushEvent(easterData.color);
};

function updatePrice(price) {
    $('span.js-price-range').html(price);
}

function updateInfoBlock(swatchElement) {
    const infoBlock = swatchElement.data('variationInfoBlock');

    updatePDPHandler.updateInfoTitle(infoBlock.title);
    updatePDPHandler.updateInfoText(infoBlock.description);
    updatePDPHandler.updateProductDetailImage(infoBlock.image);
    updatePDPHandler.updateUSPs(infoBlock.usps);
    updatePDPHandler.updateVideoSrc('details-video', infoBlock.videoSrc);
}

function updateScrubImages() {
    const variantId = $('.js-pdp-swatches-item.selected .js-pdp-swatches-image').data('variationId');
    const imageInSlide = $('.slick-slide:not(.slick-cloned) .js-product-thumbnail[data-variant-id="' + variantId + '"]');
    if (!imageInSlide) {
        return;
    }
    const slickSlide = imageInSlide.closest('.slick-slide');
    if (!slickSlide.hasClass('.slick-active')) {
        imageInSlide.closest('.js-pdp-scrub-slider').slick('slickGoTo', slickSlide.data('slickIndex'), false);
    }

    const $previewImage = $('.js-product-details-block .js-product-preview-image');
    $previewImage.attr('data-src', imageInSlide.data('primaryScrubImage'));
    damHelper.updateImages($previewImage.parent());
}

function swatchVariationChangeHandler(target, data) {
    const $parent = target.parent();
    if ($parent.hasClass('selected')) {
        return;
    }
    const skipImage = data && data.skipImage;
    const eventLabel = data && data.eventLabel;
    $parent.siblings().removeClass('selected');
    $parent.addClass('selected');

    const $swatchImage = target.find('.js-pdp-swatches-image');
    const easterData = $swatchImage.data('variation-easter-data');
    if (easterData && Object.keys(easterData).length) {
        updateEasterData(easterData);
        return;
    }

    const isScrub = $swatchImage.data('variation-is-scrub');
    if (isScrub) {
        blockEvent = true;
        pushScrubData(eventLabel);
    }

    const $dropdown = $('.js-pdp-custom-select');
    const samePrice = $dropdown.data('samePrice');
    const variationUrl = $swatchImage.data('variation-url');
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const entries = urlParams.entries();
    const urlParamsMap = {};
    for (const entry of entries) {
        urlParamsMap[entry[0]] = entry[1];
    }
    if (variationUrl) {
        window.history.replaceState({}, '', variationUrl);
        const paramsToRemove = [$swatchImage.data('variationAttribute')];
        updatePDPHandler.updateStateAndUrlParams(urlParamsMap, paramsToRemove);
    } else {
        urlParamsMap[$swatchImage.data('variationAttribute')] = $swatchImage.data('variationAttributeValue');
        updatePDPHandler.updateStateAndUrlParams(urlParamsMap);
    }

    if (!$dropdown.length || samePrice) {
        if (!skipImage) {
            updatePDPHandler.updateImages($swatchImage.data('variationUrlImages'), updateScrubImages);
        }

        updatePDPHandler.updateStickyBarImage($swatchImage.data('variationStickyBarImage'));
        updatePDPHandler.updateProductLifestyleImage($swatchImage.data('variationIngredientsBackgroundImageUrl'));
    }

    updateInfoBlock($swatchImage);
    updatePDPHandler.trimAndUpdateLongDescription($swatchImage.data('variationUsp'));
    updatePDPHandler.updateClaimableIngredient($swatchImage.data('variationClaimableIngredient'));
    updatePDPHandler.updateChemicalIngredients($swatchImage.data('variationChemicalIngredients'));
    updatePDPHandler.updateProductTitle($swatchImage.data('scrubTitle'));
    updatePDPHandler.updateFragrance($swatchImage.data('variationFragrance'));

    let addToCartUrl = $swatchImage.data('variationAddToCartUrl');
    let stickyAddToCartUrl = $swatchImage.data('variationStickyAddToCartUrl');

    if ($dropdown.length) {
        $(document).trigger(variationsEvents.onSwatchChange, $dropdown);
        const $selectedOption = $dropdown.children(':selected');
        const variationAttributeValue = $selectedOption.data('variationAttributeValue');
        if (variationAttributeValue) {
            const data = $swatchImage.data('variationUrls');

            if (!samePrice) {
                updatePageFromSelectedSize(data[variationAttributeValue]);
            }

            addToCartUrl = data[variationAttributeValue].addToCartUrl;
            stickyAddToCartUrl = data[variationAttributeValue].stickyAddToCartUrl;
        } else if (!samePrice){
            updatePDPHandler.updateImages($swatchImage.data('variationUrlImages'), updateScrubImages);
            updatePDPHandler.updateStickyBarImage($swatchImage.data('variationStickyBarImage'));
            updatePDPHandler.updateProductLifestyleImage($swatchImage.data('variationIngredientsBackgroundImageUrl'));
        }

        $dropdown.selectric('close');
    }
    updatePDPHandler.updateAddToCartButton(addToCartUrl);
    updatePDPHandler.updateStickyAddToCartButton(stickyAddToCartUrl);
    $('.js-pdp-options-dropdown').removeClass('error-field');
}

function dropdownVariationChangeHandler(target) {
    const $dropdown = $('.js-pdp-custom-select');
    const $selectedOption = $dropdown.children(':selected');
    if (target.data('selectedDropdownValue') === $selectedOption.val() || !$selectedOption.data('variationAddToCartUrl')) {
        return;
    }

    const samePrice = $dropdown.length && $dropdown.data('samePrice');
    let addToCartUrl = $selectedOption.data('variationAddToCartUrl');
    let stickyAddToCartUrl = $selectedOption.data('variationStickyAddToCartUrl');
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');
    if ($selectedSwatch.length) {
        const $selectedSwatchImage = $selectedSwatch.find('.js-pdp-swatches-image');
        const variationAttributeValue = $selectedSwatchImage.data('variationAttributeValue');
        const data = $selectedOption.data('variationUrls');
        addToCartUrl = data[variationAttributeValue].addToCartUrl;
        stickyAddToCartUrl = data[variationAttributeValue].stickyAddToCartUrl;
        if (!samePrice) {
            updatePageFromSelectedSize(data[variationAttributeValue]);
        }
    }

    updatePDPHandler.updateAddToCartButton(addToCartUrl);
    updatePDPHandler.updateStickyAddToCartButton(stickyAddToCartUrl);
    target.data('selectedDropdownValue', $selectedOption.val());
    $('.js-pdp-options-dropdown').removeClass('error-field');
    $(document).trigger(variationsEvents.onOptionChange, $dropdown);
    $dropdown.selectric('close');
}

function updatePageFromSelectedSize(selectedElementData) {
    if (!selectedElementData) {
        return;
    }
    updatePrice(selectedElementData.price);
    updatePDPHandler.updateProductLifestyleImage(selectedElementData.ingredientsBackgroundImageUrl);
    updatePDPHandler.updateProductDetailImage(selectedElementData.productDetailImageUrl);
    updatePDPHandler.updateStickyBarImage(JSON.parse(selectedElementData.stickyBarImage));
    updatePDPHandler.updateImages(selectedElementData.urlImages, updateScrubImages);
}

function initEvents(){
    $(document).on('click.swatch', '.js-pdp-swatches-btn', function(e, data) {
        if (!blockEvent) {
            e.preventDefault();
            e.stopPropagation();
            swatchVariationChangeHandler($(this), data);
        }
    });

    $(document).on('mouseover', '.js-pdp-swatches-btn', function() {
        const $selectedSwatchImage = $(this).find('.js-pdp-swatches-image');
        const dynamicSwatchName = $selectedSwatchImage.length ? $selectedSwatchImage.data('variationName') : '';
        $('.js-pdp-swatches-name').text(dynamicSwatchName);
    });

    $(document).on('mouseout', '.js-pdp-swatches-btn', function() {
        const $selectedSwatchImage = $('.js-pdp-swatches-item.selected .js-pdp-swatches-image');
        const dynamicSwatchName = $selectedSwatchImage.length ? $selectedSwatchImage.data('variationName') : '';
        $('.js-pdp-swatches-name').text(dynamicSwatchName);
    });

    $(document).on('click', '.js-pdp-swatches-toggle', function() {
        const $swatchItem = $('.js-pdp-swatches-item');
        const $showSwatchesBtn = $('.js-pdp-swatches-show');
        const $hideSwatchesBtn = $('.js-pdp-swatches-hide');

        if ($swatchItem.hasClass('hidden')) {
            $swatchItem.toggleClass('visible');
        }
        $showSwatchesBtn.toggle();
        $hideSwatchesBtn.toggle();
    });

    $(document).on('change', '.js-pdp-custom-select', function() {
        dropdownVariationChangeHandler($(this));
    });

    $(document).on('click', '.js-select-option', function() {
        const $optionsDropdown = $('.js-pdp-options-dropdown');
        if ($optionsDropdown.length > 0) {
            $('.js-pdp-options-dropdown').addClass('error-field');
        }
    });

    $(document).on('slider.onAfterChange', '.js-slider', function() {
        blockEvent = false;
    });
}

function validateVariations(e) {
    const $swatches = $('.js-pdp-swatches-item');
    const $dropdown = $('.js-pdp-custom-select');
    if ($dropdown.length > 0 && $swatches.length > 0) {
        const $selectedOption = $dropdown.children(':selected');
        if (!$selectedOption.data('variationAddToCartUrl')) {
            $('.js-pdp-options-dropdown').addClass('error-field');
            e.preventDefault();
            e.stopPropagation();
            if ($(e.target).parents('.js-sticky-add-to-cart').length) {
                $(document).trigger(variationsEvents.onNotSelectedOption);
            }
            return false;
        }
    }
    return true;
}

module.exports.initEvents = initEvents;

module.exports.validateVariations = validateVariations;

},{"../../dam/dam-helper":419,"../../easter/easter":424,"../../modules/google":453,"./updatePDPHandler":559}],562:[function(require,module,exports){
'use strict';

const productTile = require('../product-tile');

const promotions = {
    init: function () {
        productTile.init();
    }
};

module.exports = promotions;

},{"../product-tile":581}],563:[function(require,module,exports){
'use strict';

const gtm = require('../modules/google/').tagManager;
const isMobile = require('../modules/util/isMobile');
const recaptchaConfig = require('../recaptchaConfig');

/**
 * @private
 * @function
 * @description Inits click event handlers
 */
function initEvents(){
    if (window.location.search.indexOf('invalid') > -1) {
        //Form validation error, means there were already changes in place
        formChanged();
    }

    initializeRecaptcha();

    // TODO: This needs a better fix.
    if (isMobile()) {
        setTimeout(function() {
            const bTop = Math.abs($('body').offset().top);

            $('iframe[title^=recaptcha]').parent().css({
                'top': bTop
            });
        }, 1500);
    }

    $('body').on('change', '#RegistrationForm input, #RegistrationForm select', formChanged);
    $('body').on('click', '.js-edit-profile-btn-submit', unsetExitConfirmation);
}

/**
 * @private
 * @function
 * @description Shows the "save changes" button and ensures changing page is subject to confirmation
 */
function formChanged(){
    $('.js-edit-profile-btn-submit').removeClass('hide');
    setExitConfirmation();
}

/**
 * @private
 * @function
 * @description Sets the event handler to ask for confirmation when exiting the page
 */
function setExitConfirmation(){
    $(window).on('beforeunload', function(){
        return true;
    });
    $('.js-account-menu-item').data('confirmPageChange', true);
}

/**
 * @private
 * @function
 * @description Unsets the event handler to ask for confirmation when exiting the page
 */
function unsetExitConfirmation(){
    $(window).off('beforeunload');
    $('.js-account-menu-item').removeData('confirmPageChange');
}

function initializeRecaptcha() {
    const recaptchaFormsAndContainers = [
        {formId: 'RegistrationForm', containerId: 'registration--recaptcha-container'},
        {formId: 'RegistrationSmsForm', containerId: 'recaptcha-container-smsregistration'},
        {formId: 'PasswordResetForm', containerId: 'recaptcha-container-resetpassword', showAfterMultipleMistakes: true},
    ];
    const recaptchaDefinitions = [];

    recaptchaFormsAndContainers.forEach(function(el) {
        const recaptchaContainerId = el.containerId;
        const recaptchaContainer = $('#' + recaptchaContainerId);
        if (!recaptchaContainer.length) {
            return;
        }

        let showRecaptcha = true;
        if (el.showAfterMultipleMistakes) {
            // For some pages recaptcha is shown only after couple of user mistakes (RateLimiter on BE).
            // recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS class indicates that recaptcha should not be forced yet (session.privacy.showCaptcha)
            showRecaptcha = !recaptchaContainer.hasClass(recaptchaConfig.CONSTANTS.HIDE_RECAPTCHA_CLASS);
        }

        if (showRecaptcha) {
            const form = $('#' + el.formId);
            recaptchaDefinitions.push(recaptchaConfig.buildContainerDefinition(form, recaptchaContainerId, recaptchaConfig.defaultVerifyHandler));
            form.addClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS);
            form.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR, recaptchaContainerId);
        }
    });

    if (recaptchaDefinitions.length) {
        recaptchaConfig.init(recaptchaDefinitions);
    }
}

const init = function () {
    initEvents();

    //Only set up form error events for loyalty customers
    if ($('form input[type=hidden][name*=customer_loyalty]').length > 0) {
        gtm.bindFormFieldErrorEvents();
    }
};

exports.init = init;

},{"../modules/google/":453,"../modules/util/isMobile":497,"../recaptchaConfig":587}],564:[function(require,module,exports){
'use strict';

const ajax = require('../modules/ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    setDeleteConfirmation = require('../modules/util/setDeleteConfirmation');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    const url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function (data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    const $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            const fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        const addressID = $(this).val();
        if (addressID.length === 0) {
            return;
        }
        populateForm(addressID, $beforeAddress);
    })
    .on('change', 'select[name$="_addressAfterList"]', function () {
        const addressID = $(this).val();
        if (addressID.length === 0) {
            return;
        }
        populateForm(addressID, $afterAddress);
    });

    $('.js-shopping-cart').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        const productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    login.init();
    setDeleteConfirmation('.js-shopping-cart', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../login":443,"../modules/ajax":449,"../modules/util/setDeleteConfirmation":508,"../quickview":585}],565:[function(require,module,exports){
'use strict';

const getQueryString = require('../modules/util/getQueryString'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    isSmallView = require('../modules/helpers/isSmallView'),
    scrollHelper = require('../modules/helpers/scroll'),
    grid = require('../grid');
const pushDataLayerEvent = require('../modules/helpers/analyticsHelper');

let $currentScrollPos; /* eslint-disable-line */
let alreadyFiltered = false;

const $filterOverlay = $('.js-refinements-bar');
const $filterPage = $('.js-filter-page');
const $filterOptions = $('.js-filter-options');
const $filterBlockTitle = $('.js-filter-block-title');

const $mobileChoosenFilters = $('.js-cop-filters-wrapper');
const $filtersList = $mobileChoosenFilters.find('.js-cop-filters-list');
const $filtersListItem = $filtersList.find('.js-cop-filters-item');

//CHECK WITH FE: seems this does nothing, $currentScrollPos isn't in use
if (navigator.userAgent.match(/(iPhone|iPod|iPad)/i)) {
    $(window).scroll(function () {
        $currentScrollPos = $(document).scrollTop();
    });
}

function priceFilterExists(){
    return $('.js-price-filter-block').length > 0;
}

function initializeEvents() {
    const $body = $('body');

    $body.off('click.filters', '.js-trigger-mobile-filters');
    $body.on('click.filters', '.js-trigger-mobile-filters', function () {
        $filterOverlay.fadeIn('fast', function () {
            const $this = $(this);
            $this.addClass('refinements-visible').removeAttr('aria-hidden');
            redesignAdjustments();
            if (!isSmallView()) {
                const $filterTitleProduct = $this.find('.js-filter-title-product');
                $filterTitleProduct.focus().addClass('open');
                $filterTitleProduct.next('.js-filter-options').show().removeAttr('aria-hidden');
            } else {
                $this.find('.js-filter__block').first().find('.js-filter-block-title').focus();
                $this.find('.js-filter-block-title').removeClass('open');
            }
        });

        // lock body scroll
        scrollHelper.disableScroll();
    });

    const filterBlockSelector = '.js-filter__block input[type=checkbox]';
    $body.off('change.filters', filterBlockSelector);
    $body.on('change.filters', filterBlockSelector, function(){
        const filters = getActiveFilters();
        const lastSelectedFilter = $(this);

        applyFilters(filters, null, lastSelectedFilter);
    });

    $body.off('change.filters','.js-price-filter-input');
    $body.on('change.filters','.js-price-filter-input', function () {
        const anyValueChanged = $('.js-price-filter-input').map(function(_, input) {
            return $(input).val() == $(input).data('previous-value');
        }).get().some(function(result){
            return result === false;
        });

        if (anyValueChanged) {
            $('.js-price-wrapper').data('price-filter-changed', true);
            $('.js-price-filter-btn').removeClass('btn--disabled');
        } else {
            $('.js-price-wrapper').data('price-filter-changed', false);
            $('.js-price-filter-btn').addClass('btn--disabled');
        }
    });

    $body.on('keyup', '.js-price-filter-input', function() {
        $('.js-price-filter-btn').removeClass('btn--disabled');
    });

    $body.off('click.filters','.js-price-filter-btn');
    $body.on('click.filters','.js-price-filter-btn', function () {
        const pricesChanged = $(this).closest('.js-price-wrapper').data('price-filter-changed');
        if (pricesChanged == true) {
            const filters = getActiveFilters();
            applyFilters(filters);
        }
    });

    $body.off('click.filters','.js-clear-all-btn');
    $body.on('click.filters','.js-clear-all-btn', function () {
        $('.js-filter__block input[type=checkbox]').prop('checked', false);
        applyFilters({});
    });

    $body.off('click.filters', '.js-background-overlay, .js-btn-close-filter, .js-filter-x-close, .js-filter-option-close');
    $body.on('click.filters', '.js-background-overlay, .js-btn-close-filter, .js-filter-x-close, .js-filter-option-close', function(){
        if (isSmallView()) {
            if ($filterOptions.hasClass('visible')) {
                $filterOptions.addClass('moved-left');
            }

            $filterOverlay.removeClass('refinements-visible').removeClass('moved-left').attr('aria-hidden', 'true');
            $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

            setTimeout(function () {
                $filterOptions.hide().removeClass('visible').removeClass('moved-left').attr('aria-hidden', 'true');
                $filterBlockTitle.removeClass('open');
                $filterOverlay.hide();
            }, 600);
        } else {
            $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
            $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
            setTimeout(function () {
                $filterOverlay.hide();
            }, 600);
        }

        // unlock body scroll
        scrollHelper.enableScroll();
    });

    $('.js-btn-close-filter').on('keydown', function (e) {
        if (e.which == 9 && !e.shiftKey) {
            e.preventDefault();
            $('.js-filter-x-close').focus();
        }
    });

    $('.js-filter-x-close').on('keydown', function (e) {
        if (e.shiftKey && e.which == 9) {
            e.preventDefault();
            $('.js-btn-close-filter').focus();
        }
    });

    $('.js-cop-filters-button').on('click', function (e) {
        const menuText = e.currentTarget.getAttribute('data-category-name') || '';
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'category_navigation',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: menuText.toLowerCase(),
            menu_click: 'text'
        });
    });

    $('.js-breadcrumb-element').on('click', function (e) {
        const span = e.currentTarget.querySelector('span');
        const menuText = span && span.getAttribute('data-name') ? span.getAttribute('data-name') : '';
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'breadcrumb',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: menuText.toLowerCase(),
            menu_click: 'text'
        });
    });

    if (isSmallView()) {
        $('.js-filter-block-title').removeAttr('aria-label aria-expanded');
    }

    $body.off('click.filters', '.js-filter-block-title');
    $body.on('click.filters', '.js-filter-block-title', function() {
        const ariaLabelText = $(this).text();
        const ariaLabelStateOpen = $('.js-filter-label-open').text();
        const ariaLabelStateClosed = $('.js-filter-label-closed').text();

        if (!$(this).hasClass('open')) {
            $(this).addClass('open');

            if (isSmallView()) {
                $(this).next('.js-filter-options').show('fast', function () {
                    $filterOverlay.addClass('moved-left');
                    $(this).addClass('visible').addClass('visible').removeAttr('aria-hidden');
                });
                $(this).next('.js-filter-options').find('.js-filter-option-back').focus();
                $(this).removeAttr('aria-label aria-expanded');
            } else {
                $(this).next('.js-filter-options').stop().slideDown().removeAttr('aria-hidden');
                $(this).attr({
                    'aria-label': ariaLabelText + ',' + ariaLabelStateOpen,
                    'aria-expanded' : 'true'
                });
            }
        } else {
            $(this).removeClass('open');

            if (isSmallView()) {
                $(this).next('.js-filter-options').removeClass('visible').attr('aria-hidden', 'true');
                $(this).removeAttr('aria-label aria-expanded');
            } else {
                $(this).next('.js-filter-options').stop().slideUp().attr('aria-hidden', 'true');
                $(this).attr({
                    'aria-label' : ariaLabelText + ',' + ariaLabelStateClosed,
                    'aria-expanded' : 'false'
                });
            }
        }
    });

    $body.off('click.filters', '.js-filter-option-back');
    $body.on('click.filters', '.js-filter-option-back', function () {
        if (isSmallView()) {
            $filterOverlay.removeClass('moved-left');
        }
        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
        $filterBlockTitle.removeClass('open');

        setTimeout(function () {
            $filterOptions.hide();
        }, 600);
    });

    if (isSmallView()) {
        $filterBlockTitle.on('keydown', function (e) {
            if ($filterOptions.hasClass('visible')) {
                if (e.which == 9) {
                    e.preventDefault();

                    $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    $filterBlockTitle.removeClass('open');

                    setTimeout(function () {
                        $filterOptions.hide();
                    }, 600);
                }
            }
        });
    }

    $(document).on('keyup', function(e) {
        if (e.which == 27) {
            // on escape close the overlay
            if ($filterOverlay.hasClass('refinements-visible')) {
                if (isSmallView()) {
                    $filterPage.animate({
                        left: '0'
                    }, 600, 'easeInOutCubic');
                    if ($filterOptions.hasClass('visible')) {
                        $filterOptions.removeClass('visible').attr('aria-hidden', 'true');
                    } else {
                        $filterOverlay.addClass('moved-right').attr('aria-hidden', 'true');
                    }
                    $('.js-search-results-bar').find('.js-trigger-mobile-filters').focus();

                    setTimeout(function () {
                        $filterOverlay.removeClass('refinements-visible').removeClass('moved-right').removeClass('moved-left');
                        $filterBlockTitle.removeClass('open');
                    }, 600);
                } else {
                    $filterOverlay.removeClass('refinements-visible').attr('aria-hidden', 'true');
                    $('.js-search-filter-box').find('.js-trigger-mobile-filters').focus();
                }

                // unlock body scroll
                scrollHelper.enableScroll();
            }
        }
    });

    // only set up history events if not in the outlet. The outlet will have it's own
    if (window.pageContext.ns != 'outlet') {
        setupHistoryEvent();
    }

    setupFilterTagsBehavior();
    accessibilityAdjustments();
    copMobileFiltersInit();

    $(window).on('resize', function () {
        accessibilityAdjustments();
        redesignAdjustments();
        zoomedInWindow();
        copMobileFiltersPosition();
        copMobileFiltersMultipleRows();
    });

    productTypeFilterAdjustments();
}

function keyIsFilterSpecific(key){
    //Key patterns that won't be kept in the query string because they're specific to these filters and controlled in the back-end
    const filterSpecificKeyPatterns = [/prefn[0-9]+/, /prefv[0-9]+/, /pmin/, /pmax/];

    for (const i in filterSpecificKeyPatterns) {
        const regex = filterSpecificKeyPatterns[i];
        if (key.match(regex)) {
            return true;
        }
    }
    return false;
}

/**
 * Gets the status of the active filters
 * Use result as input for applyFilters
 */
function getActiveFilters(){
    const attributeFilters = {};

    $('.js-filter__block input[type=checkbox]').filter(':checked').each(function(_, htmlElement){
        const element = $(htmlElement);

        const attributeId = element.data('attribute-id');
        if (!(attributeId in attributeFilters)) {
            attributeFilters[attributeId] = [];
        }

        attributeFilters[attributeId].push(element.val());
    });

    let priceFilters = {};
    const priceFilterWrapper = $('.js-price-wrapper');
    if (priceFilterWrapper.length > 0) {
        const filteredByPrice = priceFilterWrapper.data('filtered-by-price') === true;
        const changed = priceFilterWrapper.data('price-filter-changed') === true;

        if (changed || filteredByPrice) {
            priceFilters = {
                min: Number($('.js-price-filter-min').val()),
                max: Number($('.js-price-filter-max').val())
            };
        }
    }

    return {
        attributes: attributeFilters,
        price: priceFilters
    };
}

let currentRequestNumber = 0;

/**
 * Applies the selected attribute or price filters
 * @param {Object} filters Object containing the new filters to be applied
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 */
function applyFilters(filters, skipHistoryPush, lastSelectedFilter){
    const params = {filters: JSON.stringify(filters), format: 'ajax'};

    //Put any non-filter parameters in the params to the request, putting back any spaces
    const qsValues = getQueryStringParams(window.location.search);
    for (const key in qsValues) {
        if (!keyIsFilterSpecific(key)) {
            params[key] = qsValues[key].replace('+', ' ');
        }
    }

    const currentSearchResultUrl = $('#currentSearchResultUrl').val();
    currentRequestNumber ++;

    $.ajax({
        url: currentSearchResultUrl,
        type: 'GET',
        data: params
    }).done(getRenderFunction(filters, skipHistoryPush, currentRequestNumber, lastSelectedFilter)); //Render filters when it finishes with success
}

/**
 * Get a rendering function for the filter request, appropriately pushing to history or not.
 * Returned function will call renderFilteredProducts with the appropriate value of `skipHistoryPush`
 *
 * @param {Object} filters Object containing the applied filters, used to save in the history object
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 * @param {Number} requestNumber Used to verify if the response being received is for the most current request.
 */
function getRenderFunction(filters, skipHistoryPush, requestNumber, lastSelectedFilter) {
    return function(data) {
        renderFilteredProducts(data, filters, skipHistoryPush, requestNumber, lastSelectedFilter);
    };
}

/**
 * Renders the result of the AJAX filter request to the back-end
 * @param {String} data The HTML returned by the back-end
 * @param {Object} filters Object containing the new filters to be applied
 * @param {Boolean} skipHistoryPush If true, don't push this filtering to history
 * @param {Number} requestNumber Used to verify if the response being received is for the most current request. Only renders the response if it is
 */
function renderFilteredProducts(data, filters, skipHistoryPush, requestNumber, lastSelectedFilter) {
    if (currentRequestNumber === requestNumber && data) {

        handleGwpAsset(function(){
            $('.js-grid-wrap .js-grid-item').remove();
            $('.js-grid-wrap').append(data);
        });

        if (lastSelectedFilter) {
            $(document).trigger('filterChange', [lastSelectedFilter]);
        }

        const noHits = $('#js-no-hits');
        //Check for the filter status returned in the results. If there, update filters and pills and remove the status hidden input
        const filterStatusElement = $('.js-new-filter-status');
        if (filterStatusElement.length > 0) {
            const filterStatus = JSON.parse(filterStatusElement.last().val());
            updateFilterStatus(filterStatus);
            updateProductTypePills(filterStatus);
            filterStatusElement.remove();
        }

        const newUrlElement = $('.js-new-current-url');
        if (newUrlElement.length > 0) {
            const newUrl = newUrlElement.last().val();
            if (!skipHistoryPush) {
                saveHistory(newUrl, filters);
            }
            updateSortUrls(newUrl);
            newUrlElement.remove();
        }

        grid.updateLoadMoreUrl();

        const newFilterTagsElement = $('.js-new-filter-tags');
        if (newFilterTagsElement.length > 0) {
            const newFilterTags = newFilterTagsElement.last().html();
            const filterTagWrapper = $('.js-active-refinements-list');

            filterTagWrapper.empty();
            filterTagWrapper.append(newFilterTags);
            setupFilterTagsBehavior();

            const numberOfFilters = $('.js-active-refinements').data('number-of-filters') || 0;
            $('.js-filter-count').text(numberOfFilters > 0 ? '(' + numberOfFilters + ')' : '');

            $('.js-cat-quickfilters-popular').toggle(numberOfFilters === 0);

            newFilterTagsElement.remove();
        }

        const newMobileAppliedFiltersElement = $('.js-new-mobile-applied-filters');
        if (newMobileAppliedFiltersElement.length > 0) {
            //Mark all existing mobile filter divs as not updated
            $('.js-mobile-filters').data('updated', false);

            const newAppliedFilters = newMobileAppliedFiltersElement.find('.js-mobile-filters');
            newAppliedFilters.each(function (_, element) {
                const attributeId = $(element).data('attribute-id');
                const visibleElement = $('.js-mobile-filter-' + attributeId);
                visibleElement.html($(element).html());
                visibleElement.data('updated', true);
            });


            //Clear all mobile filters that weren't updated (no filter values for those)
            $('.js-mobile-filters').filter(function (_, element) {
                return $(element).data('updated') === false;
            }).empty();
            newMobileAppliedFiltersElement.remove();
        }

        const newProductCountElement = $('.js-new-product-count');
        if (newProductCountElement.length > 0) {
            const newProductCountMessage = newProductCountElement.last().text();
            $('.js-btn-close-filter').text(newProductCountMessage);

            newProductCountElement.remove();
        }

        if (noHits.length){
            noHits.parent().removeAttr('style').addClass('no-hits-grid');
            return;
        }

        const productFilterBreadcrumbElement = $('.js-product-filter-breadcrumb');
        if (productFilterBreadcrumbElement.length > 0) {
            const productFilterBreadcrumb = productFilterBreadcrumbElement.last().html();
            const breadcrumbWrapper = $('.js-product-search-breadcrumb');

            breadcrumbWrapper.empty();
            breadcrumbWrapper.append(productFilterBreadcrumb);
            setupFilterTagsBehavior();

            productFilterBreadcrumbElement.remove();
        }

        const productCountMsgElement = $('.js-product-count-msg');
        if (productCountMsgElement.length > 0) {
            const productCountMsg = productCountMsgElement.last().val();
            $('.search-results-summary p').html(productCountMsg);

            productCountMsgElement.remove();
        }

        updateProductCountNumber();
        grid.updateProductsSeenAndTotalNumbers();

        $('.js-grid-wrap').imagesLoaded(function () {
            $('.js-grid-wrap').removeClass('no-hits-grid');
            grid.init();
        });
    }
}

function updateProductCountNumber() {
    const productCountElements = $('.js-product-count-number');
    if (!productCountElements.length) {
        return;
    }
    const count = productCountElements.val();
    $('.js-category-products-count').html(count);

    productCountElements.remove();
}

function updateFilterStatus(filterStatus){
    if (!filterStatus) {
        return;
    }

    for (const key in filterStatus) {
        hideOrShowFilterBlock(filterStatus, key);

        if (key === 'price') {
            const priceInfo = filterStatus[key];
            $('.js-price-filter-min').val(priceInfo.min);
            $('.js-price-filter-min').data('previous-value', priceInfo.min);
            $('.js-price-filter-max').val(priceInfo.max);
            $('.js-price-filter-max').data('previous-value', priceInfo.max);
            $('.js-price-wrapper').data('price-filter-changed', false);
            $('.js-price-wrapper').data('filtered-by-price', priceInfo.isRefined);
            $('.js-price-filter-btn').addClass('btn--disabled');
            return;
        }

        const $filterStatusOptions = $('.js-filter-option[data-attribute-id="' + key + '"]');
        $filterStatusOptions.closest('.filter-item').addClass('hide');
        $('[data-filter-type="' + key + '"] .js-filter-product-count').addClass('hide');

        for (const idx in filterStatus[key]) {
            const status = filterStatus[key][idx];
            const input = $('.js-filter-option[data-attribute-id="' + key + '"][value="' + status.value + '"]');

            if (input.length){
                updateFilterInput(input, status);
                continue;
            }
            appendFilterItem(key,status,idx);
        }

    }
}

function hideOrShowFilterBlock(filterStatus, attributeId) {
    const block = $('.js-filter__block[data-filter-type="' + attributeId + '"]');

    if (!block.hasClass('hide')) {
        block.addClass('hide');
    }

    if (filterStatus[attributeId].length) {
        if (attributeId === 'customizable' && filterStatus[attributeId].length === 1 && filterStatus[attributeId][0].value === 'false') {
            // If only Non-customizable products are available don't shop Filter by Customization block
        } else {
            block.removeClass('hide');
        }
    }
}

function updateFilterInput(input, status){
    const countTextElmt = input.parent().find('.js-filter-product-count');

    if (status.count > 0) {
        countTextElmt.text(status.count);
        input.closest('.filter-item').removeClass('hide');
        countTextElmt.removeClass('hide');
    }
}

function appendFilterItem(attributeId, status, idx) {
    let item;

    if (attributeId === 'colorGroupHoR') {
        item = createColorFilterItem(attributeId, status);
    } else {
        item = createFilterItem(attributeId, status);
    }

    if (attributeId === 'duration') {
        item = createDurationFilterItem(attributeId, status);
    } else {
        item = createFilterItem(attributeId, status);
    }

    let target;
    if (attributeId === 'customizable') {
        if (status.value === 'true') {
            target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(0).parents('.filter-item');
        } else {
            const filterOptions = $('.js-filter-option[data-attribute-id="' + attributeId + '"]');
            target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(filterOptions.length - 1).parents('.filter-item');
            item.insertAfter(target);
            return;
        }
    } else {
        target = $('.js-filter-option[data-attribute-id="' + attributeId + '"]').eq(idx).parents('.filter-item');
    }
    item.insertBefore(target);
}

function createFilterItem(attributeId, status){
    const clonedElement = $('.filter-item').first().clone();
    const input = clonedElement.find('input.js-filter-option');
    input.attr('data-attribute-id', attributeId);
    input.attr('value', status.value);
    input.prop('checked', false);
    const countTextElmt = clonedElement.find('.js-filter-product-count');
    countTextElmt.text(status.count).removeClass('hide');
    const text = clonedElement.find('span.text').text(status.displayValue).append(countTextElmt).removeClass().addClass('text');

    if (attributeId == 'ritual') {
        const ritualColor = status.value.toLowerCase() + '-bg-full-color';
        text.addClass(ritualColor);
    }

    if (status.count > 0) {
        clonedElement.removeClass('hide');
        return clonedElement;
    }

    clonedElement.addClass('hide');
    return clonedElement;
}

function createColorFilterItem(attributeId, status) {
    const filterItem = $('<div><div>').addClass('filter-item filter-item-circle');
    const label = $('<label></label>');
    const input = $('<input></input>').attr('type', 'checkbox')
        .addClass('option js-filter-option')
        .attr('value', status.value)
        .attr('data-attribute-id', attributeId)
        .attr('data-filter-name', status.value);
    const span = $('<span></span>').addClass('text ' + status.value.toLowerCase() + '-product-color').text(status.displayValue);
    const sup = $('<sup></sup>').addClass('js-filter-product-count').text(status.count);
    const spanCheckbox = $('<span></span>').addClass('text-checkbox');

    span.append(sup, spanCheckbox);
    label.append(input, span);
    filterItem.append(label);
    return filterItem;
}


function createDurationFilterItem(attributeId, status) {
    const filterItem = $('<div><div>').addClass('filter-item filter-item-circle');
    const label = $('<label></label>');
    const input = $('<input></input>').attr('type', 'checkbox')
        .addClass('option js-filter-option')
        .attr('value', status.value)
        .attr('data-attribute-id', attributeId)
        .attr('data-filter-name', status.value);
    const span = $('<span></span>').addClass('text ' + status.value.toLowerCase()).text(status.displayValue);
    const sup = $('<sup></sup>').addClass('js-filter-product-count').text(status.count);
    const spanCheckbox = $('<span></span>').addClass('text-checkbox');

    span.append(sup, spanCheckbox);
    label.append(input, span);
    filterItem.append(label);
    return filterItem;
}

/**
 * Saves the current filter state into the browser history
 * @param {string} url The url to save in history
 * @param {Array} selectedFilters Array with the currently selected filters, to save in the history state
 */
function saveHistory(url, selectedFilters){
    if (!alreadyFiltered) {
        alreadyFiltered = true;
        history.pushState(selectedFilters, '', url);
    } else {
        history.replaceState(selectedFilters, '', url);
    }
}

function handleGwpAsset(appendTiles){
    const gwpAsset = $('.js-grid-wrap .js-grid-item:first > .js-search-grid-asset').clone();

    if (appendTiles !== undefined && $.isFunction(appendTiles)) {
        appendTiles();
    }

    if (gwpAsset.length){
        gwpAsset.appendTo($('.js-grid-wrap .js-grid-item:first'));
    }

}
/**
 * Sets up the behavior for the filter tags.
 * Clicking the "desktop" tags removes the values one by one,
 */
function setupFilterTagsBehavior(){
    const $body = $('body');

    $body.off('click.filters', '.js-active-refinements .js-remove-filter-button');
    $body.on('click.filters', '.js-active-refinements .js-remove-filter-button', function(){
        const refinementAttribute = $(this).data('refinement-attribute');
        const refinementValue = $(this).data('refinement-value');
        $('.js-filter-option[data-attribute-id="' + refinementAttribute + '"][value="' + refinementValue + '"]').prop('checked', false);

        const filters = getActiveFilters();
        applyFilters(filters, false, $(this));

        $(this).closest('.js-filter-tag').remove();
    });

    if (priceFilterExists()){
        $body.off('click.filters', '.js-remove-price-filter-button');
        $body.on('click.filters', '.js-remove-price-filter-button', function(){
            const filters = getActiveFilters();
            filters.price = {};
            applyFilters(filters);

            $(this).closest('.js-filter-tag').remove();
        });
    }
}

/**
 * Sets up the event to fire when history navigation happens
 */
function setupHistoryEvent(){
    window.onpopstate = function(history){
        if (history.state) {
            applyFilters(history.state, true);
        } else {
            alreadyFiltered = false; //We left the filter history
            applyFilters({}, true);
        }
    };
}

/**
 * Builds a query string from an object with the individual values
 * @param {object} qsValues Object with the values to include in the query string, in the form {key: value}
 */
function buildQueryString(qsValues){
    const qsParts = [];

    for (const key in qsValues) {
        qsParts.push(key + '=' + encodeURIComponent(qsValues[key]));
    }

    return qsParts.join('&');
}

/**
 * Removes the query string part from a URL
 * @param {string} url
 */
function removeQueryString(url){
    return url.split('?')[0];
}

/**
 * Updates the sorting dropdown options with the currently selected filters
 */
function updateSortUrls(currentUrl) {
    const SORT_RULE_PARAM = 'srule',
        PAGING_PAGE_SIZE = 'sz',
        PAGING_START = 'start',
        QUERY = 'q';

    $('.js-sorting-options option:not([hidden])').each(function () {
        const sortUrl = $(this).val();
        const sortQsValues = getQueryStringParams(getQueryString(sortUrl));

        const currentUrlNoQs = removeQueryString(currentUrl);
        const currentQSValues = getQueryStringParams(getQueryString(currentUrl));

        if (sortQsValues[SORT_RULE_PARAM]) {
            currentQSValues[SORT_RULE_PARAM] = sortQsValues[SORT_RULE_PARAM];
        }
        if (sortQsValues[PAGING_PAGE_SIZE]) {
            currentQSValues[PAGING_PAGE_SIZE] = sortQsValues[PAGING_PAGE_SIZE];
        }
        if (sortQsValues[PAGING_START]) {
            currentQSValues[PAGING_START] = sortQsValues[PAGING_START];
        }
        if (sortQsValues[QUERY]) {
            currentQSValues[QUERY] = sortQsValues[QUERY];
        }

        let finalUrl = currentUrlNoQs;
        const finalQs = buildQueryString(currentQSValues);

        if (finalQs) {
            finalUrl += '?' + finalQs;
        }

        $(this).val(finalUrl);
    });
}

function accessibilityAdjustments() {
    if (isSmallView()) {
        $('.js-filter-category-title').attr('aria-hidden', 'true');
    } else {
        $('.js-filter-category-title').removeAttr('aria-hidden');
    }
}

function redesignAdjustments() {
    const $filterInner = $('.js-filter-inner');
    const filterHeaderHeight = $('.js-filter-header').outerHeight();

    $filterInner.css('padding-top', filterHeaderHeight);
}

function productTypeFilterAdjustments() {
    if (!history.state || !history.state.attributes || !history.state.attributes.productType) {
        return;
    }

    const historyProductTypes = history.state.attributes.productType;
    const $productTypes = $('.js-filter__block input[type=checkbox]').filter(function() {
        return $(this).data('attribute-id') == 'productType';
    });

    $productTypes.each(function() {
        const $this = $(this);
        const shouldBeChecked = historyProductTypes.indexOf($this.val()) != -1;

        if (shouldBeChecked) {
            $this.prop('checked', true);
        } else {
            $this.prop('checked', false);
        }
    });
}

function copMobileFiltersInit() {
    $filtersListItem.each(function () {
        if ($(this).hasClass('selected')) {
            $(this).find('.js-cop-filters-text').attr('tabindex', '-1');
        }
    });

    copMobileFiltersWidth();
    copMobileFiltersToggle();
    copMobileFiltersGradient();
}

function zoomedInWindow() {
    if (window.outerWidth > 1024 && !$('body').hasClass('zoomed-in')) {
        $('body').addClass('zoomed-in');
    }
}

function copMobileFiltersWidth() {
    zoomedInWindow();

    if ($mobileChoosenFilters.length && !$('body').hasClass('zoomed-in')) {
        $filtersList.addClass('no-wrap');
        const filtersListWidth = $filtersList[0].scrollWidth;
        $filtersList.css('width', filtersListWidth);
    } else if ($mobileChoosenFilters.length && $('body').hasClass('zoomed-in')) {
        copMobileFiltersPosition();
        copMobileFiltersMultipleRows();
    }
}

function copMobileFiltersToggle() {
    $('.js-filter-show-more').on('click', function (e) {
        const $this = $(this);
        e.preventDefault();
        if (!$this.hasClass('active')) {
            $this.addClass('active');
            $mobileChoosenFilters.addClass('expanded');
            $filtersListItem.each(function () {
                $(this).removeClass('hidden');
                if ($(this).hasClass('selected')) {
                    $filtersListItem.first().find('.js-cop-filters-button').not('.js-cop-filters-text').focus();
                } else {
                    $filtersListItem.first().find('.js-cop-filters-button').first().focus();
                }
            });
        } else {
            $this.removeClass('active');
            $mobileChoosenFilters.removeClass('expanded');
            copMobileFiltersPosition();
        }
    });
}

function copMobileFiltersPosition() {
    $filtersListItem.each(function () {
        if ($(this).position().top > 0) {
            $(this).addClass('hidden');
        }
    });
}

function copMobileFiltersMultipleRows() {
    if ($filtersList.find('.hidden').length < 1) {
        $('.js-filter-show-more').hide();
    } else {
        $('.js-filter-show-more').show();
    }
}

function copMobileFiltersGradient() {
    if ($mobileChoosenFilters.length) {
        const filtersListWidth = $filtersList[0].scrollWidth;
        const windowWidth = $(window).width() + 10;

        if (filtersListWidth > windowWidth) {
            $mobileChoosenFilters.addClass('right-fade');
        }


        $filtersList.bind('touchmove', function() {
            const listPosition = $filtersList.position().left;
            const listHidden = -1 * listPosition;
            const listVisible = filtersListWidth - listHidden;

            if (filtersListWidth > windowWidth) {
                if (listPosition < -10) {
                    $mobileChoosenFilters.addClass('left-fade');
                } else {
                    $mobileChoosenFilters.removeClass('left-fade');
                }

                if (listVisible > windowWidth) {
                    $mobileChoosenFilters.addClass('right-fade');
                } else {
                    $mobileChoosenFilters.removeClass('right-fade');
                }
            }
        });
    }
}

function initProductTypeFilter(){
    const productTypeFilterSelector = '.js-product-type-filter:not(.selected) .js-apply-filter';
    $(document).off('click.filters', productTypeFilterSelector).on('click.filters', productTypeFilterSelector,
        function(e) {
            triggerCheckboxClick(e, true);
        }
    );

    $(document).off('click.filters', '.js-clear-product-type-filter').on('click.filters','.js-clear-product-type-filter',
        function(e) {
            triggerCheckboxClick(e, false);
        }
    );
}

function createBreadcrumbPath() {
    const path = $('.breadcrumb .breadcrumb-list-item a span')
        .map(function () {
            let dataName = $(this).attr('data-name');
            return dataName && dataName.trim();
        })
        .get()
        .join(', ');

    return path;
}

const breadcrumbPath = createBreadcrumbPath();

function triggerCheckboxClick(e, addClass){
    e.preventDefault();
    const $this = $(e.target).parents('li');
    const matchingCheckbox = $('.js-filter-option[data-attribute-id="' + $this.data('refinement-attribute') + '"][value="' + $this.data('refinement-value') + '"]');
    const checkboxText = $this.data('refinement-name') || '';
    matchingCheckbox.trigger('click');


    if (addClass){
        $this.addClass('selected');
        pushDataLayerEvent({
            event: 'menu_navigation',
            menu: 'category_navigation',
            menu_path: breadcrumbPath.toLowerCase(),
            menu_text: checkboxText.toLowerCase(),
            menu_click: 'text'
        });
        return;
    }
    $this.removeClass('selected');
}

function updateProductTypePills(filterStatus) {
    if (!filterStatus) {
        return;
    }

    $('.js-product-type-filter').each(function() {
        $(this).hide();
    });

    for (const key in filterStatus) {
        if (['productType', 'customizable'].indexOf(key) > -1) {
            for (const idx in filterStatus[key]) {
                const status = filterStatus[key][idx];
                const filterCheckbox = $('.js-filter-option[data-attribute-id="' + key + '"][value="' + status.value + '"]');
                let filterPill = $('.js-product-type-filter[data-refinement-attribute="' + key + '"][data-refinement-value="' + status.value + '"]');

                if (!filterPill.length) {
                    appendMissingProductTypePill(status, key, idx);
                    filterPill = $('.js-product-type-filter[data-refinement-attribute="' + key + '"][data-refinement-value="' + status.value + '"]');

                }
                filterPill.show();

                if (filterCheckbox.is(':checked')) {
                    filterPill.addClass('selected');
                    filterPill.children('.js-apply-filter').attr('tabindex', '1');
                } else {
                    filterPill.removeClass('selected');
                    filterPill.children('.js-apply-filter').removeAttr('tabindex', '1');
                }
            }
        }
    }
}

function appendMissingProductTypePill(status, attributeId) {
    if (attributeId === 'customizable' && status.value == 'true') {
        const customizablePillItem = createProductTypePill(status, attributeId);
        $('.js-product-type-filters').prepend(customizablePillItem);
    } else if (attributeId === 'productType') {
        const productTypePillItem = createProductTypePill(status, attributeId);
        $('.js-product-type-filters').append(productTypePillItem);
    }
}

function createProductTypePill(status, attributeId) {
    const pillItem = $('<li></li>').addClass('js-cop-filters-item js-product-type-filter');
    pillItem.attr('data-refinement-attribute', attributeId).attr('data-refinement-value', status.value);

    const applyFilterButton = $('<button></button>').addClass('text js-apply-filter');

    applyFilterButton.append(status.displayValue);

    const removeFilterButton = $('<button></button>').addClass('remove-filter js-clear-product-type-filter');
    removeFilterButton.append('<span class="icon icon-close"></span>');

    return pillItem.append(applyFilterButton, removeFilterButton);
}

exports.init = function () {
    initializeEvents();
    initProductTypeFilter();
};

exports.handleGwpAsset = handleGwpAsset;

},{"../grid":437,"../modules/helpers/analyticsHelper":455,"../modules/helpers/isSmallView":469,"../modules/helpers/scroll":475,"../modules/util/getQueryString":491,"../modules/util/getQueryStringParams":492}],566:[function(require,module,exports){
'use strict';

const compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    appendParamToURL = require('../modules/util/appendParamToURL'),
    getQueryStringParams = require('../modules/util/getQueryStringParams'),
    getQueryParameter = require('../modules/util/getQueryParameter'),
    removeParamFromURL = require('../modules/util/removeParamFromURL'),
    filter = require('./search-filter'),
    isInViewport = require('../modules/helpers/isInViewport'),
    isSmallView = require('../modules/helpers/isSmallView'),
    debounce = require('../modules/helpers/debounce'),
    customSelect = require('../select-custom'),
    grid = require('../grid'),
    gtm = require('../modules/google').tagManager;

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url) {
    if (!url || url === window.location.href) {
        return;
    }
    progress.show($('.search-result-content'));

    $.ajax({
        url: appendParamToURL(url, 'format', 'ajax'),
        success: function (data) {
            if (data) {

                filter.handleGwpAsset(function(){
                    $('.js-grid-wrap .js-grid-item').remove();
                    $('.js-grid-wrap').append(data);
                });

                compareWidget.init();

                progress.hide();
                history.pushState(undefined, '', url);
                filter.init();

                $('.js-grid-wrap').imagesLoaded(function () {
                    grid.init();
                });

                customSelect.init();
            }
        }
    });
}

function accessibilityAdjustment() {
    const $triggerFilter = $('.js-trigger-mobile-filters');
    $triggerFilter.each(function () {
        if ($(this).parent('.mobile-filter-trigger').length) {
            if (!isSmallView()) {
                $(this).attr('tabindex', '-1').attr('aria-hidden', 'true');
            } else {
                $(this).removeAttr('tabindex').removeAttr('aria-hidden');
            }
        }
    });
}

function searchGWPAssetPosition() {
    if ($('.js-search-grid-asset').length) {
        const searchAsset = '.js-search-grid-asset';
        const desktopAssetHolder = '.js-search-slot-desktop';
        const mobileFirstGridItem = $('.js-search-result-content').find('.js-grid-item').first();
        if (isSmallView()) {
            $(desktopAssetHolder).find(searchAsset).appendTo(mobileFirstGridItem);
        } else {
            $(mobileFirstGridItem).find(searchAsset).appendTo(desktopAssetHolder);
        }
    }
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    const $main = $('#main');

    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        const cb = $(this);
        const tile = cb.closest('.product-tile');

        const func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        const itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });

    });

    // handle events for updating grid
    $main.on('click', '.js-refinement-link, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle events item click. append params.
    $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
        const a = $(this);
        // get current page refinement values
        const wl = window.location;

        const qsParams = (wl.search.length > 1) ? getQueryStringParams(wl.search.substr(1)) : {};
        const hashParams = (wl.hash.length > 1) ? getQueryStringParams(wl.hash.substr(1)) : {};

        // merge hash params with querystring params
        const params = $.extend(hashParams, qsParams);
        if (!params.start) {
            params.start = 0;
        }
        // get the index of the selected item and save as start parameter
        const tile = a.closest('.product-tile');
        const idx = tile.data('idx') ? + tile.data('idx') : 0;

        // convert params.start to integer and add index
        params.start = (+params.start) + (idx + 1);
        // set the hash and allow normal action to continue
        a[0].hash = $.param(params);
    });

    $(window).on('resize', debounce(function () {
        accessibilityAdjustment();
        searchGWPAssetPosition();
    }, 200));

    $(window).scroll(function () {
        stickyNavBar();
    });
}

/**
 * Pushes a "sorting changed" event to the GTM data layer.
 * Depending on the page we're in, sends along the page category
 * or the search phrase.
 */
function pushSortingToDataLayer(sortingType){
    const category = $('#pageCategory').val();
    const searchPhrase = $('#pageSearchPhrase').val();

    if (category) {
        gtm.pushSortingOnCategoryPage(sortingType);
    } else if (searchPhrase) {
        gtm.pushSortingOnSearchPage(sortingType, searchPhrase);
    }
}

function initGridOptionsEvents(){
    const $main = $('#main');
    const start = 'start';
    const size = 'sz';

    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        const selectedOption = $(this).find('option:selected');

        pushSortingToDataLayer(selectedOption.text());
        updateProductListing(selectedOption.val());

        const $loadMore = $('.js-grid-load-more');
        if ($loadMore) {
            const sizeValue = getQueryParameter(selectedOption.val(), size);
            let nextPageUrl = removeParamFromURL(selectedOption.val(), start);

            nextPageUrl = appendParamToURL(nextPageUrl, start, sizeValue);

            $loadMore.data('grid-next-page-url', nextPageUrl);
        }
    })
    .on('change', '.items-per-page select', function () {
        const refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });
}

function stickyNavBar() {
    const $filterBar = $('.js-search-results-bar');

    if (!$filterBar.length) {
        return;
    }

    const barIsInView = isInViewport($filterBar);
    const filterBarPosition = $filterBar.offset().top;

    if (isSmallView()) {
        if ($(window).scrollTop() >= filterBarPosition) {
            $filterBar.addClass('sticky-filters');
            return;
        }

        $filterBar.removeClass('sticky-filters');
        return;
    }

    if (barIsInView) {
        $filterBar.removeClass('sticky-filters');
    } else {
        if ($(window).scrollTop() >= filterBarPosition) {
            $filterBar.addClass('sticky-filters');
        }
    }

    const $darkBox = $('.js-search-filter-box');
    if ($darkBox.length && isInViewport($darkBox)) {
        $filterBar.removeClass('sticky-filters-visible');
        return;
    }

    $filterBar.addClass('sticky-filters-visible');
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    initGridOptionsEvents();
    filter.init();
    compareWidget.init();
    accessibilityAdjustment();
    searchGWPAssetPosition();
    stickyNavBar();
};

exports.initGridOptionsEvents = initGridOptionsEvents;

},{"../compare-widget":281,"../grid":437,"../modules/google":453,"../modules/helpers/debounce":458,"../modules/helpers/isInViewport":464,"../modules/helpers/isSmallView":469,"../modules/util/appendParamToURL":479,"../modules/util/getQueryParameter":490,"../modules/util/getQueryStringParams":492,"../modules/util/removeParamFromURL":505,"../product-tile":581,"../progress":584,"../select-custom":596,"./search-filter":565}],567:[function(require,module,exports){
'use strict';

const _ = require('lodash');
const google = require('../modules/google');

const elements = {
    form: $('.store-locator-form'),
    resultsContainer: $('.store-search-results'),
    loadingIndicator: $('.js-store-locator-locading-indicator'),
    filters: $('.filters'),
    details: $('.store-details'),
    noresult: $('.store-locator-noresult'),
    addressDetails: $('input[id$="_addressDetails"]'),
    countryCode: $('select[id$="_countryCode"]'),
    moreStoresLoader: $('.js-more-stores-loader')
};

let searchPayload = null;

exports.init = function() {
    cleanPayload();

    if (elements.form.length > 0) {
        //Hide activity indicator
        elements.loadingIndicator.removeClass('spinner-visible');

        //Get saved changes
        getSavedChanges();

        //Initialize Google Place AutoComplete Textfield
        google.places.initStoreList(elements.countryCode.val(), triggerReceiveAddressAutoComplete);

        //Disable form submit
        elements.form.on('submit', function(e) {
            e.preventDefault();
            return;
        });

        //Show more button
        $(document).on('click','.show-more-btn', function(e) {
            e.preventDefault();
            const length = $('.store').length;
            searchPayload.nextPageToken = length;
            getStoreList(true);
            elements.moreStoresLoader.addClass('spinner-visible');
        });

        //trigger click function on radio buttons
        $('.js-checkmark').on('keyup', function(e){
            if (e.which == 13) {
                // on enter trigger click function
                $(this).trigger('click');
            }
        });

        //Check country dropdown changes
        elements.countryCode.on('change', function() {
            //Clean the payload
            cleanPayload();

            //Set country code to payload
            searchPayload.checkStoreAvailability = true;
            searchPayload.filterCountryCode = elements.countryCode.val();

            //Save latest changes
            saveChanges();

            //Clear address field
            elements.addressDetails.val('');

            const types = $('input[name$="_storeType"]');
            _.forEach(types, function(object) {
                object.checked = object.classList.contains('normal');
            });

            //Initialize Google Place AutoComplete Textfield
            google.places.initStoreList(elements.countryCode.val(), triggerReceiveAddressAutoComplete);

            //Get Store List (Ajax)
            getStoreList();

        });

        $('input[name$="_storeType"]').on('change', function() {
            searchPayload.storeType = $('input[name$="_storeType"]:checked').val();

            //Reset page
            searchPayload.nextPageToken = 0;

            //Save latest changes
            saveChanges();

            //Get Store List (Ajax)
            getStoreList();
        });

        // Current location
        $('.js-store-list-current-location').on('click', function() {
            // cleanFlyoutStores(); //Clean the flyout
            google.places.getCurrentLocation(tiggerCurrentLocation);
        });

        const searchText = elements.addressDetails.val();
        if (searchText && searchText != '') {
            google.places.searchPlace(searchText, triggerUserAddressSearched);
        } else {
            getStoreList();
        }
    }

    // init embedded google map in details page
    if (elements.details.length > 0) {
        const map = elements.details.find('.store-location').find('.store-map');
        google.maps.init(map);
    }
};


// Local Storage

function saveChanges() {
    const searchText = elements.addressDetails.val();
    const countryCode = elements.countryCode.val();
    const types = getEnabledStoreType();

    if (typeof(Storage) !== 'undefined') {
        const changes = {
            query: searchText,
            countryCode: countryCode,
            types: types
        };
        localStorage.storeLocator = JSON.stringify(changes);
    }
    return;
}

function getSavedChanges() {

    if (typeof(Storage) !== 'undefined' && 'storeLocator' in localStorage) {
        const changes = JSON.parse(localStorage.storeLocator) || {};

        elements.addressDetails.val(changes.query);
        elements.countryCode.val(changes.countryCode);
        searchPayload.filterCountryCode = changes.countryCode;
        _.forEach(changes.types, function(value, key) {
            $('input.' + key + '[name$="_storeType"]').prop('checked', value || false);
        });
        searchPayload.storeType = $('input[name$="_storeType"]:checked').val();
    } else {
        cleanPayload();
    }

    //Get availiability of stores when initializing the page

    searchPayload.checkStoreAvailability = true;
    return;
}

// Google Place API Triggers

/*
    Notifier when AutoComplete Search Textfield is entered
*/
function triggerReceiveAddressAutoComplete() {
    //Check if this is google event
    if (!!this && this !== null) {
        const place = this.getPlace();
        if (place) {
            handleGooglePlaceResults([place]);
            searchPayload.searchText = elements.addressDetails.val();
        }
    } else {
        cleanPayload();
    }

    //Save latest changes
    saveChanges();

    //Get Store List (Ajax)
    getStoreList();
}

/*
    Notifier when search for user's address in addressbook
*/
function triggerUserAddressSearched(results, status) {
    if (status == 'OK' && results && results.count > 0) {
        handleGooglePlaceResults(results);

        //Save latest changes
        saveChanges();

        //Get Store List (Ajax)
        getStoreList();

    }
}

/*
    Notifier when user tap on Current location
*/
function tiggerCurrentLocation(results, latitude, longitude) {
    //Check if location is OK
    if (results && latitude && longitude) {
        handleGooglePlaceResults(results);
        searchPayload.latitude = latitude;
        searchPayload.longitude = longitude;

        //Set Country Code
        if (searchPayload.filterCountryCode) {
            const exists = $('select[id$="_countryCode"] option[value="' + searchPayload.filterCountryCode + '"]').length > 0;
            if (exists) {
                elements.countryCode.val(searchPayload.filterCountryCode);
                elements.addressDetails.val(google.places.getReadableAddress(results));

                //Save latest changes
                saveChanges();

                //Get Store List (Ajax)
                getStoreList();
            }
        }
    }
}

function handleGooglePlaceResults(results) {
    cleanPayload();
    searchPayload.filterCity = getLocationValue('locality', true, results);
    searchPayload.filterPostalCode = getLocationValue('postal_code', true, results);

    if (results && results.length > 0) {
        const result = results[0];
        if (result && result.geometry && result.geometry.location) {
            searchPayload.latitude = result.geometry.location.lat();
            searchPayload.longitude = result.geometry.location.lng();
        }
    }
}

// Helpers

function cleanPayload() {
    let selectedStoreType = $('input[name$="_storeType"]:checked').val();
    if (!selectedStoreType) {
        selectedStoreType = 'normal';
    }
    searchPayload = {
        latitude: '',
        longitude: '',
        countryCode: elements.countryCode.val(),
        filterPostalCode: '',
        filterCity: '',
        filterCountryCode: elements.countryCode.val(),
        searchText: '',
        nextPageToken: 0,
        storeType: selectedStoreType,
        checkStoreAvailability: false
    };
}

function getLocationValue(locationType, isLongName, results) {
    const fallBackAddress = '';
    for (let indexResult = 0; indexResult < results.length; indexResult++) {
        const result = results[indexResult];
        if (result.address_components) {
            for (let indexAddressComponent = 0; indexAddressComponent < result.address_components.length; indexAddressComponent++) {
                const addressComponent = result.address_components[indexAddressComponent];
                if (addressComponent.types.indexOf(locationType) != -1) {
                    return isLongName ? addressComponent.long_name.latinise() : addressComponent.short_name.latinise();
                }
            }
        }
    }
    return fallBackAddress;
}

function getStoreList(skipTypesUpdating) {
    $('.js-load-more-stores').remove();

    const isClearingResult = (searchPayload.nextPageToken == 0);
    showLoadingIndicator(isClearingResult);
    if (isClearingResult) {
        elements.resultsContainer[0].innerHTML = '';
    }
    $.ajax({
        type: 'POST',
        url: Urls.filterStores,
        contentType: 'application/json',
        data: JSON.stringify(searchPayload),
        success: function(htmlData) {
            searchPayload.checkStoreAvailability = false;
            if (htmlData) {
                const data = $($.parseHTML(htmlData));
                const results = data.find('.js-store-item');
                const loadMore = data.find('.js-load-more-stores');
                elements.resultsContainer.append(results);

                if (loadMore.length) {
                    elements.resultsContainer.after(loadMore);
                }

                elements.moreStoresLoader.removeClass('spinner-visible');

                if (!skipTypesUpdating){
                    const selectedStoreType = data.find('input[name="SelectedStoreType"]').val();
                    const availableStoreTypes = data.find('input[name="AvailableStoreTypes"]').val();
                    if (selectedStoreType || availableStoreTypes) {

                        const storeType = $('input[name$="_storeType"]');
                        storeType.each(function(index, object) {

                            if (selectedStoreType) {
                                object.checked = $(object).hasClass(selectedStoreType);
                            }

                            if (availableStoreTypes) {
                                const availableStoreTypesJson = JSON.parse(availableStoreTypes);
                                const row = $(object).closest('.form-row').show();
                                let rowVisible = false;

                                if ($(object).hasClass('normal')) {
                                    rowVisible = availableStoreTypesJson.rgcStoreExist;
                                } else if ($(object).hasClass('city-spa')) {
                                    rowVisible = availableStoreTypesJson.urbanStoreExist;
                                } else if ($(object).hasClass('shop-in-shop')) {
                                    rowVisible = availableStoreTypesJson.deptStoreExist;
                                }

                                if (rowVisible) {
                                    row.show();
                                } else {
                                    row.hide();
                                }
                            }
                        });
                        searchPayload.storeType = $('input[name$="_storeType"]:checked').val();
                    }
                }

                results.first().find('a').first().focus();
            }

            const length = $('.store').length;
            hideLoadingIndicator(length);
        }
    });
}

function getEnabledStoreType() {
    const storeTypes = $('input[name$="_storeType"]:checked');
    const types = {
        'normal': false,
        'city-spa': false,
        'shop-in-shop': false
    };

    storeTypes.each(function(index, object) {
        if ($(object).hasClass('normal')) {
            types['normal'] = true;
        } else if ($(object).hasClass('city-spa')) {
            types['city-spa'] = true;
        } else if ($(object).hasClass('shop-in-shop')) {
            types['shop-in-shop'] = true;
        }
    });

    return types;
}

// Extra Methods

function hideLoadingIndicator(count) {
    elements.loadingIndicator.removeClass('spinner-visible');
    if (count > 0) {
        elements.resultsContainer.css('display', 'inline-block');
    } else {
        elements.noresult.css('display', 'inline-block');
    }
}

function showLoadingIndicator(hideResult) {
    elements.loadingIndicator.addClass('spinner-visible');
    if (hideResult) {
        elements.noresult.hide();
        elements.resultsContainer.hide();
    }
}

//Back button on mobile for Store Details page
$('.js-store-back-button').on('click', function(){
    window.history.back();
});

},{"../modules/google":453,"lodash":208}],568:[function(require,module,exports){
/**
 * Where is My Order Page
 */
'use strict';

const gMap = require('../../modules/google').maps;
const gPlaces = require('../../modules/google').places;
const $mapEl = $('.js-google-map');
const whereIsMyOrderFormHandler = require('./whereIsMyOrderFormHandler');

/**
 * Gets data from map element and converts them to coordinates
 */
const initMap = () => {
    if ($mapEl.data('lat') && $mapEl.data('lng')) {
        gMap.init($mapEl);
        return;
    }

    const postalCode = String($mapEl.data('postalcode') || '');
    const countryName = $mapEl.data('country') || '';

    gPlaces.getLatLongFromPostalCode(postalCode, countryName, drawMap);
};

/**
 * Draws the map in the map element using the lat and lng params
 *
 * @param {number} lat lattitude of location
 * @param {number} lng longtitude of location
 */
const drawMap = (lat, lng) => {
    $mapEl.data('lat', lat);
    $mapEl.data('lng', lng);

    gMap.init($mapEl);
};

/**
 * Checks if a map is present
 *
 * @returns {boolean}
 */
const shouldInitMap = () => {
    return $mapEl.length > 0;
};

function bindEvents() {

    $(document).on('click', '.js-track-and-trace-link', function() {
        const link = $(this).data('link');
        if (!link) {
            return;
        }
        window.open(link, '_blank');
    });

    $(document).on('click', '.js-track-and-trace-toaster', function() {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.WIMO_TOASTER_HEADER,
                headingLarge: true
            },
            paragraphs: [
                {
                    text: window.Resources.WIMO_TOASTER_MESSAGE,
                }
            ],
            buttons: [
                {
                    type: 'btn',
                    label: window.Resources.WIMO_TOASTER_BUTTON,
                    shouldCloseModal: true
                },
            ],
            row: {
                class: 'center-align'
            },
            closeElement: {
                shouldCloseModal: true
            },
            ctaHolder: {},
            modalLarge: true,
            modalFullWidth: true
        });
    });
}

function appendLeadingZeroes(n){
    if (n <= 9) {
      return '0' + n;
    }
    return n;
}

function setCurrentDate() {
    const $refreshTime = $('.js-refresh-time');
    if (!$refreshTime.length) {
        return;
    }
    const currentDatetime = new Date();
    const formattedDate = appendLeadingZeroes(currentDatetime.getDate())
        + '-' + appendLeadingZeroes(currentDatetime.getMonth() + 1) + '-' + currentDatetime.getFullYear().toString().slice(2) + ' '
        + appendLeadingZeroes(currentDatetime.getHours()) + ':' + appendLeadingZeroes(currentDatetime.getMinutes());
    $refreshTime.text(formattedDate);
}

const whereIsMyOrderPage = {
    init: () => {
        bindEvents();
        whereIsMyOrderFormHandler.init();

        if (shouldInitMap()) {
            initMap();
        }
        setCurrentDate();
    }
};

module.exports = whereIsMyOrderPage;

},{"../../modules/google":453,"./whereIsMyOrderFormHandler":569}],569:[function(require,module,exports){
/**
 * Where is My Order Page
 */
'use strict';

const recaptchaConfig = require('../../recaptchaConfig');
const recaptchaEnabled = $('#recaptcha-container-wimo').length;

function handleRecaptchaResponse(response) {
    const $form = $('.js-wimo-form');
    $('.js-recaptcha-response', $form).val(response); // set recaptcha challenge result to be validated on backend
    submitForm($form);
}

function submitForm($form) {
    const formData = {};
    $($form).find('input[name]').each(function (_, node) {
        formData[node.name] = node.value;
    });
    $.post($form.attr('action'), formData)
        .done(function (data) {
            if (!data.success) {
                showError(true, data.errorHtml, data.isSpecialOrderWarningMessage);
                showSpinner($form, false);
                return;
            }
            showError(false);
            $(document).trigger($.Event('faq.pushDataLayerObject'), [$('.js-find-my-order-button', $form)]);
            window.location.href = data.redirectUrl;
        });
}

function showError(visible, errorMsg, isSpecialOrderWarningMessage){
    const $errorRow = $('#error-form');
    const $specialOrderWarningMessage = $('#special-order-warning-message');
    if (visible) {
        const $errorMessageContainer = isSpecialOrderWarningMessage ? $specialOrderWarningMessage : $errorRow;
        $errorMessageContainer.html(errorMsg).show();
        return;
    }
    $errorRow.html('').hide();
    $specialOrderWarningMessage.html('').hide();
}

function showSpinner(form, shouldShowSpinner) {
    const $findMyOrderButton = $('.js-find-my-order-button', form);
    const $findMyOrderButtonSpinner = $('.js-wimo-landing-page-spinner', $findMyOrderButton);
    if (shouldShowSpinner) {
        $findMyOrderButtonSpinner.addClass('spinner-visible');
        $findMyOrderButton.addClass('button-loading');
        return;
    }
    $findMyOrderButton.removeClass('button-loading');
    $findMyOrderButtonSpinner.removeClass('spinner-visible');
}

function isSpinnerVisible() {
    const $findMyOrderButtonSpinner = $('.js-wimo-landing-page-spinner');
    return $findMyOrderButtonSpinner.hasClass('spinner-visible');
}

function bindEvents() {
    $(document).on('submit', '#find-my-order-form', function (e) {
        e.preventDefault();
        if (isSpinnerVisible()) {
            return; // prevent re-submitting while the spinner is visible
        }

        showSpinner($(this), true);
        showError(false);
        if (recaptchaEnabled) {
            recaptchaConfig.executeForContainer('recaptcha-container-wimo');
            return;
        }
        submitForm($(this));
    });
}

const whereIsMyOrderPage = {
    init: () => {
        bindEvents();
        if (recaptchaEnabled) {
            const recaptchaDefinitions = [recaptchaConfig.buildContainerDefinition($('.js-wimo-form'), 'recaptcha-container-wimo', handleRecaptchaResponse)];
            recaptchaConfig.init(recaptchaDefinitions);
        }
    }
};

module.exports = whereIsMyOrderPage;

},{"../../recaptchaConfig":587}],570:[function(require,module,exports){
'use strict';

const page = require('../page'),
    login = require('../login'),
    appendParamToURL = require('../modules/util/appendParamToURL');

exports.init = function () {
    $('#editAddress').on('change', function () {
        page.redirect(appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();

};

},{"../login":443,"../modules/util/appendParamToURL":479,"../page":518}],571:[function(require,module,exports){
'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
    init: function (paymentMethodResponse, container, selectedPaymentMethod, config, paymentDetails) {
        const configuration = {
            locale: config.locale,
            amount: {
                currency: config.priceCurrency,
                value: config.priceAmount
            },
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        checkout
            .create('amazonpay', {
                checkoutMode: 'ProcessOrder',
                addressDetails: {
                    name: paymentDetails.name,
                    addressLine1: paymentDetails.adressLine1,
                    city: paymentDetails.city,
                    postalCode: paymentDetails.postalCode,
                    countryCode: paymentDetails.countryCode,
                    phoneNumber: paymentDetails.phoneNumber
                },

                environment: config.environment,
                currency: config.priceCurrency,
                returnUrl: Urls.checkoutAmazonPayment
            })
            .mount(container);
    },

    initOrder: function (paymentMethodResponse, container, selectedPaymentMethod, config, amazonCheckoutSessionId) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        checkout
            .create('amazonpay', {
                environment: config.environment,
                amount: {
                    currency: config.priceCurrency,
                    value: config.priceAmount
                },
                amazonCheckoutSessionId: amazonCheckoutSessionId,
                returnUrl: Urls.checkoutAmazonPayment,
                showChangePaymentDetailsButton: true // Optional
            })
            .mount(container);
    },

    initPayment: function (
        paymentMethodResponse,
        container,
        selectedPaymentMethod,
        config,
        onSubmitCallback,
        amazonCheckoutSessionId,
        onAdditionalDetailsCallback
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        const amazonPayOrder = checkout
            .create('amazonpay', {
                environment: config.environment,
                showOrderButton: false,
                onSubmit: onSubmitCallback,
                onAdditionalDetails: onAdditionalDetailsCallback,
                amazonCheckoutSessionId: amazonCheckoutSessionId
            })
            .mount(container);

        amazonPayOrder.submit();
    },

    getPaymentDetails: function (
        paymentMethodResponse,
        selectedPaymentMethod,
        config,
        amazonCheckoutSessionId,
        detailsCallBack
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        const checkout = new AdyenCheckout(configuration);
        const amazonPayComponent = checkout.create('amazonpay', {
            environment: config.environment,
            showOrderButton: false,
            amazonCheckoutSessionId: amazonCheckoutSessionId
        });
        amazonPayComponent.getShopperDetails().then((details) => {
            detailsCallBack(details);
        });
    },
    getAmazonSessionID: function () {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        return urlParams.get('amazonCheckoutSessionId');
    }
};

module.exports = exportFunctions;

},{"@adyen/adyen-web":1}],572:[function(require,module,exports){
/* eslint-disable no-empty-function */
'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
    paymentMethodData: null,
    appleWebComponent: null,
    applepayIsAvailable: function (paymentMethodResponse, config, paymentMethod) {
        return this.init(
            paymentMethodResponse,
            null,
            paymentMethod,
            config,
            {shippingContact: {}, billingContact: {}},
            () => {},
            () => {},
            true
        );
    },
    init: function (
        paymentMethodResponse,
        container,
        selectedPaymentMethod,
        config,
        userDataFromStore,
        onValidateMerchantCallback,
        onAuthorizedCallback,
        checkIfApplepayIsAvailable
    ) {
        const configuration = {
            locale: config.locale,
            environment: config.environment,
            clientKey: config.clientKey,
            paymentMethodsResponse: paymentMethodResponse,
            selectedPaymentMethod: selectedPaymentMethod
        };

        if (this.appleWebComponent) {
            this.appleWebComponent.unmount();
        }

        const checkout = new AdyenCheckout(configuration);
        const merchantIdEnvironment =
            config.environment == 'prod' || config.environment == 'live' ? 'prod' : 'development';

        const $that = this;
        this.appleWebComponent = checkout.create('applepay', {
            amount: {
                currency: config.priceCurrency,
                value: config.priceAmount
            },
            countryCode: config.countryCode,
            configuration: {
                merchantName: 'Rituals Cosmetics',
                merchantId: config.merchantId + merchantIdEnvironment,
                billingContact: userDataFromStore.billingContact,
                shippingContact: userDataFromStore.shippingContact
            },
            buttonType: 'plain',
            buttonColor: 'black',
            onValidateMerchant: onValidateMerchantCallback,
            onSubmit: (state) => {
                if (!state.isValid) {
                    $that.paymentMethodData = null;
                    return;
                }
                $that.paymentMethodData = state.data.paymentMethod;
            },
            onAuthorized: onAuthorizedCallback
        });

        if (checkIfApplepayIsAvailable) {
            return this.appleWebComponent
                .isAvailable()
                .then(() => true)
                .catch(() => false);
        }

        this.appleWebComponent
            .isAvailable()
            .then(() => {
                this.appleWebComponent.mount(container);
            })
            .catch((e) => {
                console.error('Apple pay not available', e);
            });
    }
};

module.exports = exportFunctions;

},{"@adyen/adyen-web":1}],573:[function(require,module,exports){
'use strict';

const KlarnaHelper = function () {
    function getPaymentMethodCategory(selectedPaymentMethod) {
        switch (selectedPaymentMethod) {
            case 'klarna_account':
                return 'pay_over_time';
            case 'klarna':
            case 'klarna_b2b':
                return 'pay_later';
            case 'klarna_paynow':
                return 'pay_now';
            default:
                return null;
        }
    }

    function init(selectedPaymentMethod, adyenData, callbackFunction) {
        const paymentMethodCategory = getPaymentMethodCategory(selectedPaymentMethod);
        if (!adyenData || !adyenData.clientToken) {
            callbackFunction({
                show_form: false /* eslint-disable-line camelcase */
            });
            return;
        }

        const script = document.getElementById('klarna-script');
        if (script) {
            script.parentNode.removeChild(script);
        }
        const recaptchaScript = document.createElement('script');
        recaptchaScript.setAttribute('id', 'klarna-script');
        recaptchaScript.setAttribute('src', 'https://x.klarnacdn.net/kp/lib/v1/api.js');
        recaptchaScript.setAttribute('async', true);
        document.head.appendChild(recaptchaScript);
        /* eslint-disable no-undef, camelcase */
        window.klarnaAsyncCallback = function () {
            Klarna.Payments.init({
                client_token: adyenData.clientToken
            });

            Klarna.Payments.load(
                {
                    container: '#klarna-payments-container',
                    payment_method_category: paymentMethodCategory
                },
                callbackFunction
            );
        };
        /* eslint-enable no-undef, camelcase */
    }

    function authorize(selectedPaymentMethod, callbackFunction) {
        const paymentMethodCategory = getPaymentMethodCategory(selectedPaymentMethod);
        /* eslint-disable no-undef, camelcase */
        Klarna.Payments.authorize(
            {
                payment_method_category: paymentMethodCategory
            },
            {},
            callbackFunction
        );
        /* eslint-enable no-undef, camelcase */
    }

    return {
        init: init,
        authorize: authorize
    };
};

module.exports = new KlarnaHelper();

},{}],574:[function(require,module,exports){
'use strict';

const AdyenCheckout = require('@adyen/adyen-web');

const exportFunctions = {
  init: function (paymentMethodResponse, container, selectedPaymentMethod, config, onSubmitCallback, onAdditionalDetailsCallback) {
    const configuration = {
      locale: config.locale,
      environment: config.environment,
      clientKey: config.clientKey,
      paymentMethodsResponse: paymentMethodResponse,
      selectedPaymentMethod: selectedPaymentMethod,
    };

    const checkout = new AdyenCheckout(configuration);
    checkout.create('paypal', {
      environment: config.environment,
      countryCode: config.countryCode, // Only needed for test. This will be automatically retrieved when you are in production.
      amount: {
        currency: config.priceCurrency,
        value: config.priceAmount
      },
      style: {
        color: 'black',
        shape: 'rect',
        label: 'checkout',
        tagline: false
      },
      onSubmit: onSubmitCallback,
      onCancel: (data, component) => {
        // Sets the status of the component when a PayPal payment is cancelled. Return to the initial state.
        component.setStatus('ready');
      },
      onError: (error, component) => {
        // Sets the status of the component when an error occurs. Return to the initial state.
        component.setStatus('ready');
      },
      onAdditionalDetails: onAdditionalDetailsCallback
    }).mount(container);
  },
};

module.exports = exportFunctions;

},{"@adyen/adyen-web":1}],575:[function(require,module,exports){
'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie'),
    appendParamsToUrl = require('./modules/util/appendParamsToUrl'),
    ajax = require('./modules/ajax'),
    shippingFormPrefix = 'dwfrm_singleshipping_shippingAddress_addressFields_',
    billingFormPrefix = 'dwfrm_billing_billingAddress_addressFields_',
    addressFormPrefix = 'dwfrm_profile_address_';

    const prefillAddress = {
    init: function () {
        //only add events for NL forms
        if (getCountryFromLocaleCookie() === 'NL') {
            $('body').on('blur', 'input[id$=' + shippingFormPrefix + 'postal], input[id$=' + shippingFormPrefix + 'houseNumber]', {formPrefix: shippingFormPrefix}, this.handleBlurEvent);
            $('body').on('blur', 'input[id$=' + billingFormPrefix + 'postal], input[id$=' + billingFormPrefix + 'houseNumber]', {formPrefix: billingFormPrefix}, this.handleBlurEvent);
            $('body').on('blur', 'input[id$=' + addressFormPrefix + 'postal], input[id$=' + addressFormPrefix + 'houseNumber]', {formPrefix: addressFormPrefix}, this.handleBlurEvent);
        }
    },

    /**
    * @function
    * @description Handles the blur event on postal code and housenumber fields
    * @param {Object} Event object, includes data
    */
    handleBlurEvent: function (event) {
        const $formFieldset = $(event.target).parents('fieldset');

        const postalCode = encodeURIComponent($.trim($formFieldset.find('#' + event.data.formPrefix + 'postal').val()));
        const houseNumber = encodeURIComponent($.trim($formFieldset.find('#' + event.data.formPrefix + 'houseNumber').val()));

        if (postalCode !== '' && houseNumber !== '') {
            prefillAddress.retrieveAddress(postalCode, houseNumber, event.data.formPrefix);
        }
    },

    /**
    * @function
    * @description Retrieves the address from the RGC service
    * @param {String} A dutch postal code
    * @param {String} A dutch house number
    * @param {String} The form prefix for the form that triggered the call
    */
    retrieveAddress: function (postalCode, houseNumber, formPrefix) {
        const url = appendParamsToUrl(Urls.rgcRetrieveAddress, {
            'postalCode': postalCode,
            'houseNumber': houseNumber,
            'format': 'ajax',
            'formPrefix': formPrefix
        });

        ajax.getJson({
            url: url,
            callback: this.setAddress
        });
    },

    /**
    * @function
    * @description Sets the retrieved Address data on the correct form, does nothing if request failed (error logged on server)
    * @param {Object} A JSON object response from the RGC service
    */
    setAddress: function (response) {
        if (response.success) {
            $('input[id$=' + response.formPrefix + 'street]').val(response.data.street).valid();
            $('input[id$=' + response.formPrefix + 'street]').trigger('change');
            $('input[id$=' + response.formPrefix + 'city]').val(response.data.city).valid();
            $('input[id$=' + response.formPrefix + 'city]').trigger('change');
        }
    }
};

module.exports = prefillAddress;

},{"./modules/ajax":449,"./modules/util/appendParamsToUrl":480,"./modules/util/getCountryFromLocaleCookie":488}],576:[function(require,module,exports){
/**
 * Product Description Helper Class
 */
'use strict';

const triggerEl = '.js-expand-description-link';
const descriptionEl = '.js-full-description';
const shortDescriptionEl = '.js-short-description';
const ellipsisEl = '.js-ellipsis';
const readMoreEl = '.js-read-more';
const readLessEl = '.js-read-less';
const isDesktopView = require('./modules/helpers/isDesktopView');

const bindEvents = () => {
    const isPG = $('.js-pdp-main').hasClass('giftset-pdp-main-container');
    if (!(isPG && isDesktopView())) {
        for (const el of $(triggerEl)) {
            $(el).on('click', onClickTrigger);
        }
    }
};

const onClickTrigger = (e) => {
    e.preventDefault();
   $(e.currentTarget).siblings(descriptionEl).toggleClass('hide');
   $(e.currentTarget).find(readLessEl).toggleClass('hide');
   $(e.currentTarget).find(readMoreEl).toggleClass('hide');
   $(e.currentTarget).siblings(ellipsisEl).toggleClass('hide');
   $(e.currentTarget).siblings(shortDescriptionEl).toggleClass('hide');
};

const shouldInit = () => {
    return $(triggerEl).length > 0;
};

module.exports = {
    init: () => {
        if (shouldInit()) {
            bindEvents();
        }
    }
};

},{"./modules/helpers/isDesktopView":463}],577:[function(require,module,exports){
'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const getTriggerFromHash = require('./modules/util/getTriggerFromHash');
const setLocationHash = require('./modules/util/setLocationHash');
const generateUniqueGuid = require('./modules/util/generateUniqueGuid');
const gtm = require('./modules/google').tagManager;

const $filterBlockSelector = '.js-product-filter-block';
const $filterBlocks = $($filterBlockSelector);
const $filterItemSelector = '.js-filter-item';
const $gridPlaceholderSelector = '.js-filtered-grid-placeholder';
const scrollOffset = 250;
let url = $filterBlocks.prev('.js-filter-block-url').val();

function initialDataLoad(filterBlock) {
    $(document).off('scroll.' + filterBlock.attr('id'));
    const $placeholder = filterBlock.find($gridPlaceholderSelector);
    const hash = getTriggerFromHash() || getTriggerFromDatattribute();
    const $defaultProductFilter = hash ? filterBlock.find('[data-anchor-id=' + hash + ']') : filterBlock.find('.js-product-filters > li:first-child > a');
    $defaultProductFilter.addClass('selected');
    const data = getFilterDataFromElement($defaultProductFilter, $placeholder);
    const pageSize = $placeholder.data('page-size') || 0;
    const stateGridItemCount = (window.history.state && window.history.state.gridItemCount) ? window.history.state.gridItemCount : 0;

    if (pageSize) {
        data.pageSize = pageSize + stateGridItemCount;
    }

    if (!$placeholder.hasClass('is-loaded')) {
        $placeholder.addClass('is-loaded');
        loadProducts(data, $placeholder);
    }
}

function getTriggerFromDatattribute() {
    const dataAttr = $filterBlocks.parent().data('open-tab');
    return typeof dataAttr !== 'undefined' && dataAttr.length > 0 ? 'trigger-' + dataAttr : '';
}

function changeTab(clickedCollection) {
    const $this = $(clickedCollection);
    const $filterBlock = $this.parents($filterBlockSelector);
    $filterBlock.find($filterItemSelector + '.selected').removeClass('selected');
    $this.addClass('selected');
    const $placeholder = $filterBlock.find($gridPlaceholderSelector);
    const data = getFilterDataFromElement($this, $placeholder);
    loadProducts(data, $placeholder);
    setLocationHash($this.data('anchor-id'));
    handleDataLayerEvent($this);
}

function initEvents() {
    $(document).on('click', $filterItemSelector + ':not(.selected)', function () {
        const $this = $(this);
        const $filterBlock = $this.parents($filterBlockSelector);
        $filterBlock.find($filterItemSelector + '.selected').removeClass('selected');
        $this.addClass('selected');
        const $placeholder = $filterBlock.find($gridPlaceholderSelector);
        const data = getFilterDataFromElement($this, $placeholder);
        loadProducts(data, $placeholder);
        setLocationHash($this.data('anchor-id'));
        handleDataLayerEvent($this);
    });

    $(document).on('click', $filterItemSelector + '.selected', function (e) {
        e.preventDefault();
        e.stopPropagation();
    });

    document.addEventListener('shouldTriggerLazyload', function(e) {
        setTimeout(() => {
            initialDataLoad($('[data-anchor-id=' + e.detail + ']'));
        }, 1000);
    }, false);

    $('.js-product-filter-block').each(function () {
        const $this = $(this);
        const blockId = generateUniqueGuid();
        $this.attr('id', blockId);
        if (isInViewport($this)) {
            initialDataLoad($this);
            return true;
        }

        $(document).on('scroll.' + blockId, function () {
            if ($(window).scrollTop() < scrollOffset) {
                return true;
            }
            initialDataLoad($this);
        });
        return true;
    });
}

function loadProducts(data, placeholder) {
    if (!url) {
        url = 'seeMoreLabel' in data ? Urls.showProductsFilterBlock : Urls.showFilteredGrid;
    }

    $.ajax({
        url: url,
        data: data,
        success: function (products) {
            if (!products) {
                return;
            }
            placeholder.html(products).imagesLoaded(function () {
                const grid = require('./grid');
                grid.init();
            });
        }
    });
}

function getFilterDataFromElement(filterElement, $gridPlaceHolder) {
    const $filterElement = $(filterElement);
    const filters = $filterElement.data('filters');
    const seeMoreLabel = $filterElement.data('see-more-label');
    const includeGWP = $filterElement.data('includeGwp');

    //TODO: Refactor this for a proper difference, without resorting to having a "see more" label to distinguish the filter types
    if (seeMoreLabel) { //"Gifting landing page" product filters: A small grid with a link
        return {
            pageSize: $gridPlaceHolder.data('page-size'),
            category: filters.category,
            minPrice: filters.minPrice,
            maxPrice: filters.maxPrice,
            seeMoreLabel: $filterElement.data('see-more-label')
        };
    } else { //"Collection page" product filters: A proper grid with a "see more" button
        return {
            filters: JSON.stringify(filters),
            includeGWP: includeGWP
        };
    }
}

function handleDataLayerEvent(target){
    if (!target || !target.length) {
        return;
    }
    const analytics = target.data('analytics');
    if (!analytics) {
        return;
    }
    analytics.click_target = decodeURI(analytics.click_target); /* eslint-disable-line camelcase */
    gtm.pushDataLayerEvent(analytics);
}

const productFilters = {
    init: function () {
        initEvents();
    },
    changeTab: function (clickedCollection) {
        changeTab(clickedCollection);
    }
};

module.exports = productFilters;

},{"./grid":437,"./modules/google":453,"./modules/helpers/isInViewport":464,"./modules/util/generateUniqueGuid":486,"./modules/util/getTriggerFromHash":494,"./modules/util/setLocationHash":509}],578:[function(require,module,exports){
'use strict';

const gtm = require('./modules/google').tagManager;
const isInViewport = require('./modules/helpers/isInViewport');

const pushProductsToDataLayer = (tileSelectors) => {
    const PUSHED_CLASS = 'js-data-layer-list-pushed';
    const TILE_SELECTORS = (!tileSelectors && tileSelectors.length > 0) ? ['.js-grid-wrap:not(.js-grid-slider) .js-grid-item:not(.js-block-tile)','.drag-list-body .js-drag-list-item'] : tileSelectors;
    TILE_SELECTORS.forEach(TILE_SELECTOR => {
        const productTilesToPush = $(TILE_SELECTOR + ':not(.' + PUSHED_CLASS + ')');

        if (!productTilesToPush.length) {
            return;
        }

        productTilesToPush.each(function(_, tile) {
            const $tile = $(tile);
            const $tileDetails = $('.js-product-tile-details-content', $tile);

            if (!$tileDetails.length || !isInViewport($tileDetails, false)) {
                return;
            }

            const dataLayerProduct = $('.js-product-tile-datalayer-product', tile);

            if (!dataLayerProduct.length) {
                return;
            }

            const productData = JSON.parse(dataLayerProduct.val());
            if (productData) {
                gtm.pushProductTileView(productData);
            }

            $tile.addClass(PUSHED_CLASS);

        });
    });
};

module.exports.pushProductsToDataLayer = pushProductsToDataLayer;

},{"./modules/google":453,"./modules/helpers/isInViewport":464}],579:[function(require,module,exports){
'use strict';

const updatePDPHandler = require('./pages/product/updatePDPHandler');

const productPageHandler = {
    updatePage: function(data) {
        const returnConfig = {};
        const selectedComponents = data.selectedComponents;
        const product = data.product;

        const form = $('input[name="pid"][value="' + product + '"]').parents('form');
        const oldProductConfiguration = $('.js-product-configurator-trigger', form).data('productConfiguration');

        for (const componentName in selectedComponents) {
            selectedComponents[componentName].previousId = oldProductConfiguration[componentName];
            returnConfig[componentName] = selectedComponents[componentName].id;
        }

        const returnSelectedComponentsData = data.updateData && data.updateData.isTalisman ?
            createTalismanDataForPageUpdate(data, selectedComponents) : createDataForPageUpdate(data, selectedComponents);

        const dataForUpdate = {
            returnSelectedComponentsData: returnSelectedComponentsData,
            returnConfig: returnConfig,
            product: product,
            selectedComponents: selectedComponents
        };

        updatePageElements(dataForUpdate.returnSelectedComponentsData);

        updateCartButtonData(dataForUpdate);

        updateSocialCommerceElement(dataForUpdate);
    }
};

function updateSocialCommerceElement(data) {
    const $socialCommerceButton = $('.js-social-commerce-button');
    if (!$socialCommerceButton || !$socialCommerceButton.length) {
        return;
    }

    const $form = $('input[name="pid"][value="' + data.product + '"]').parents('form');
    if (!$form || !$form.length) {
        return;
    }

    const socialCommerceData = $socialCommerceButton.data('social-commerce');
    if (!socialCommerceData) {
        return;
    }

    socialCommerceData.configurationId = data.returnSelectedComponentsData.urlParams['configurationId'];
    $socialCommerceButton.data('social-commerce', socialCommerceData);

    const $addToCartButton = $('.js-add-to-cart', $form);

    if ($addToCartButton.hasClass('hide') || $addToCartButton.hasClass('btn--disabled')) {
        $socialCommerceButton.parent().addClass('hide');
        return;
    }

    $socialCommerceButton.parent().removeClass('hide');
}

function createTalismanDataForPageUpdate(data, selectedComponents) {
    const updateData = data.updateData;

    const urlParamObject = {};
    urlParamObject[updateData.urlParameterName] = String.format(updateData.urlParameterValueFormat, data.product,
        selectedComponents.fragrance.id, selectedComponents.bottle.id, selectedComponents.cap.id, selectedComponents.talisman.id);

    const returnSelectedComponentsData = {};
    returnSelectedComponentsData.urlParams = JSON.parse(JSON.stringify(urlParamObject));
    returnSelectedComponentsData.shortDescription = String.format(updateData.talismanShortDescriptionFormat, selectedComponents.bottle.longDescription,
        selectedComponents.fragrance.productUnit, selectedComponents.cap.longDescription, selectedComponents.talisman.longDescription, selectedComponents.bottle.travelBottleTitle);

    returnSelectedComponentsData.title = selectedComponents.fragrance.title;
    returnSelectedComponentsData.stickyBarTitle = selectedComponents.fragrance.stickyBarTitle;
    const primaryImageObject = updateData.talismanPrimaryImagePlaceholder;
    primaryImageObject.src = String.format(primaryImageObject.urlFormat, selectedComponents.bottle.EAN, selectedComponents.fragrance.EAN,
        selectedComponents.talisman.EAN, selectedComponents.cap.EAN);
    returnSelectedComponentsData.stickyBarImage = primaryImageObject;
    const htuImageObject = updateData.talismanHTUImagePlaceholder;
    if (htuImageObject) {
        htuImageObject.src = String.format(htuImageObject.urlFormat, selectedComponents.bottle.EAN, selectedComponents.fragrance.EAN,
            selectedComponents.talisman.EAN, selectedComponents.cap.EAN);
        returnSelectedComponentsData.howToUseImage = htuImageObject;
    }
    returnSelectedComponentsData.productLifestyleImage = selectedComponents.fragrance.productLifestyleImage;
    returnSelectedComponentsData.ingredientsBlockVideoID = selectedComponents.fragrance.ingredientsBlockVideoID;
    returnSelectedComponentsData.pdpImagesUrl = updateData.pdpImagesUrl + '&' + updateData.urlParameterName + '=' + urlParamObject[updateData.urlParameterName];
    returnSelectedComponentsData.claimableIngredients = selectedComponents.fragrance.notes;
    returnSelectedComponentsData.chemicalIngredients = selectedComponents.fragrance.chemicalIngredients;
    returnSelectedComponentsData.usp = selectedComponents.fragrance.usp;
    returnSelectedComponentsData.productDetailImage = selectedComponents.fragrance.productDetailImage;

    return returnSelectedComponentsData;
}

function createDataForPageUpdate(data, selectedComponents) {
    let presentationComponent = null;
    let mainComponent = null;
    for (const key in selectedComponents) {
        if (['fragrance', 'wax'].indexOf(key) === -1) {
            presentationComponent = selectedComponents[key];
            continue;
        }

        mainComponent = selectedComponents[key];
    }
    const updateData = data.updateData;
    const urlParamObject = {};
    urlParamObject[updateData.urlParameterName] = String.format(updateData.urlParameterValueFormat, data.product,
        mainComponent.id, presentationComponent.id);

    const returnSelectedComponentsData = {};
    returnSelectedComponentsData.title = mainComponent.title;
    returnSelectedComponentsData.stickyBarTitle = mainComponent.stickyBarTitle;
    returnSelectedComponentsData.pdpImagesUrl = presentationComponent.pdpImagesUrl;
    returnSelectedComponentsData.claimableIngredients = mainComponent.claimableIngredients;
    returnSelectedComponentsData.chemicalIngredients = mainComponent.chemicalIngredients;
    const firstPartDescription = [presentationComponent.shortDescription, presentationComponent.bottleShape,
        presentationComponent.nameColorDesign].filter(Boolean).join(' - ');

    const wholeDescription = [firstPartDescription, mainComponent.shortDescription,
        mainComponent.productUnit].filter(Boolean).join(', ');
    returnSelectedComponentsData.shortDescription = wholeDescription;
    returnSelectedComponentsData.stickyBarImage = presentationComponent.stickyBarImage;
    returnSelectedComponentsData.urlParams = JSON.parse(JSON.stringify(urlParamObject));
    returnSelectedComponentsData.howToUseImage = presentationComponent.howToUseImage;
    returnSelectedComponentsData.productLifestyleImage = presentationComponent.productLifestyleImage;
    returnSelectedComponentsData.productDetailImage = presentationComponent.productDetailImage;
    returnSelectedComponentsData.dimensions = presentationComponent.productDimensions;

    return returnSelectedComponentsData;
}

module.exports = productPageHandler;

function updatePageElements(productSelectedComponentsData) {
    updatePDPHandler.updateTitle(productSelectedComponentsData.title);
    updatePDPHandler.updateShortDescription(productSelectedComponentsData.shortDescription);
    updatePDPHandler.updateClaimableIngredients(productSelectedComponentsData.claimableIngredients);
    updatePDPHandler.updateTabsIngredients(productSelectedComponentsData.chemicalIngredients);
    updatePDPHandler.updateImages(productSelectedComponentsData.pdpImagesUrl);
    updatePDPHandler.updateStickyBarTitle(productSelectedComponentsData.stickyBarTitle);
    updatePDPHandler.updateStickyBarImage(productSelectedComponentsData.stickyBarImage);
    updatePDPHandler.updateStateAndUrlParams(productSelectedComponentsData.urlParams);
    updatePDPHandler.updateHowToUseImage(productSelectedComponentsData.howToUseImage && productSelectedComponentsData.howToUseImage.src);
    updatePDPHandler.updateProductLifestyleImage(productSelectedComponentsData.productLifestyleImage && productSelectedComponentsData.productLifestyleImage.src);
    updatePDPHandler.updateProductDetailImage(productSelectedComponentsData.productDetailImage && productSelectedComponentsData.productDetailImage.src);

    //signature and mansion specific block
    updatePDPHandler.updateUSPs(productSelectedComponentsData.dimensions);

    //talisman specific block
    updatePDPHandler.trimAndUpdateLongDescription(productSelectedComponentsData.usp);
    updatePDPHandler.updateVideoSrc('talisman-product-ingredient-video', productSelectedComponentsData.ingredientsBlockVideoID);
}

function updateCartButtonData(data) {
    const form = $('input[name="pid"][value="' + data.product + '"]').parents('form');
    updateHiddenFields(data, form);
    handleOutOfStock(form);
    updateConfiguratorButton(form, data);
}

function updateHiddenFields(data, form) {
    const childPids = $('input[name="childPids"]', form);
    const pids = Object.values(data.returnConfig).join();
    childPids.val(pids);

    const thumbnailImage = $('input[name="thumbnailImage"]', form);
    thumbnailImage.val(data.returnSelectedComponentsData.stickyBarImage.src);

    const horProducts = $('input[name="horProducts"]', form);
    if (horProducts.length > 0) {
        const dataLayerData = JSON.parse(horProducts.val());

        dataLayerData.products.forEach(function(product, i) {
            if (product.finalSku) {
                dataLayerData.products[i].finalSku = data.returnSelectedComponentsData.urlParams.configurationId;
            } else {
                for (const key in data.selectedComponents) {
                    const selectedComponent = data.selectedComponents[key];
                    if (product.sku != selectedComponent.previousId) {
                        continue;
                    }

                    dataLayerData.products[i] = selectedComponent.dataLayerData;
                }
            }
        });
        horProducts.val(JSON.stringify(dataLayerData));
    }
}

function handleOutOfStock(form) {
    const disabledAddToCart = $('.js-add-to-cart.btn--disabled.hide', form);

    if (!disabledAddToCart.length) {
        return;
    }

    disabledAddToCart.removeClass('btn--disabled hide');
    $('.js-out-of-stock-block', form).addClass('hide');
    $('.js-shipping-info.hide').removeClass('hide');
}

function updateConfiguratorButton(form, data) {
    const configuratorButton = $('.js-product-configurator-trigger');

    if (configuratorButton.length) {
        configuratorButton.data('productConfiguration', data.returnConfig);
        configuratorButton.data('productUrlParam', data.returnSelectedComponentsData.urlParams.configurationId);
    }

    const primaryConfiguratorButton = $('.js-product-configurator-trigger.btn--primary', form);

    if (!primaryConfiguratorButton.length) {
        return;
    }

    primaryConfiguratorButton.removeClass('btn--primary').addClass('btn--secondary');
}

},{"./pages/product/updatePDPHandler":559}],580:[function(require,module,exports){
'use strict';

function productSliderFadeIn() {
    const offset = $(window).height() / 2;
    const $sliderHolder = $('.js-product-slider-holder');
    const sliderHolderRect = $sliderHolder[0].getBoundingClientRect().top;


    if (sliderHolderRect < offset) {
        if (!$sliderHolder.hasClass('fadein')) {
            $sliderHolder.addClass('fadein');
        }
    }
}

function toggleReadMoreText() {
    const $shortText = $('.step-intro').find('.js-slider-text-short');
    const $longText = $('.step-intro').find('.js-slider-text-long');

    $(document).on('click', '.js-slider-toggle', function() {
        $longText.toggle();
        $shortText.toggle();
    });
}

/**
 * @description Initialize block
 */
function initBlock() {
    productSliderFadeIn();
    toggleReadMoreText();
}

/**
 * @description Initialize event handlers for the product slider block
 */
function initializeEvents() {
    $(window).scroll(function () {
        productSliderFadeIn();
    });
}

const productSlider = {
    init: function() {
        // if product slider exists, init
        if ($('.js-product-slider-holder').length > 0){
            initBlock();
            initializeEvents();

            // init sticky out of stock bar
            const outOfStock = require('./pages/product/outOfStock');

            outOfStock.init();
        }
    }
};

module.exports = productSlider;

},{"./pages/product/outOfStock":555}],581:[function(require,module,exports){
'use strict';

const gtm = require('./modules/google').tagManager;

/**
 *
 * @param {element} productTile The clicked product tile
 */
function pushProductToDataLayer(productTile) {
    const productData = getProductDataFromProductTile(productTile);
    if (productData) {
        gtm.pushProductTileClick(productData);
    }
}

function getProductDataFromProductTile(productTile) {
    const productDataElement = $('.js-product-tile-datalayer-product', productTile);

    if (!productDataElement.length) {
        return null;
    }

    const productData = JSON.parse(productDataElement.val());
    return productData;
}

function init() {
    //Push product to data layer when (clickable) product tile is clicked
    $(document).on('click.datalayer', '.js-product-tile.js-linked-block', function(){
        pushProductToDataLayer($(this));
    });

    //Push product to data layer when 'view full details' link or the clickable image are clicked
    $(document).on('click.datalayer', '.js-view-full-details-link, .js-product-tile-image' , function(){
        const productTile = $(this).closest('.js-product-tile');

        if (productTile.hasClass('js-linked-block')) { //Don't do anything if the tile itself is clickable
            return;
        }

        pushProductToDataLayer(productTile);
    });

    if ($('.js-personalised-promo-block-anchor').length) {
        $('html, body').stop().animate({
            scrollTop: $('.js-product-list-slider-block').offset().top
        }, 1600, 'easeOutQuart');
    }
}

module.exports = {
    init: init
};

},{"./modules/google":453}],582:[function(require,module,exports){
'use strict';

function handleProductBackButton(){
    if ($('#showbacklink').length){
        const backButton = $('.js-hidden-back-button');
        backButton.removeClass('hide');
        backButton.next('.breadcrumb').remove();
    }
}
exports.init = handleProductBackButton;


},{}],583:[function(require,module,exports){
'use strict';

const isInViewport = require('./modules/helpers/isInViewport');
const isSmallView = require('./modules/helpers/isSmallView');
const damHelper = require('./dam/dam-helper');
const advent = require('./advent');

const $productExperinceBlock = $('.js-product-experience-block');
const $hotspot = $('.js-hotspot');
const $hotspotContainer = $('.js-hotspot-container');
const $videoHolder = $('.js-video-holder');
const $experienceBtn = $('.js-product-experience-button');
const $experienceBtnTrigger = $('.js-experience-btn-animation-trigger');
// const $experienceBtnTriggerMob = $('.js-experience-btn-animation-trigger-mobile');
const $closeButton = $('.js-close-video-overlay');

let ignoreInViewport = false;

damHelper.updateImages('.js-hidden-images-container');

function showExperienceButton() {
    if ($productExperinceBlock.hasClass('full-width') || ignoreInViewport) {
        return;
    }

    // let elementIsInView;
    // if (isSmallView()) {
    //     elementIsInView = isInViewport($experienceBtnTriggerMob);
    // } else {
    //     elementIsInView = isInViewport($experienceBtnTrigger);
    //}

    if (isInViewport($experienceBtnTrigger)) {
        $experienceBtn.addClass('fade-in');
    }
}

function addEvents() {
    $hotspot.on('click', onClickHotspot);
    $experienceBtn.on('click', onClickExperienceButton);
    $closeButton.on('click', onClickCloseButton);
    $(window).on('scroll', showExperienceButton);

    $('.js-product-details-button').on('click', function() {
        const $this = $(this);
        advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'),
            'product_details', $this.closest('.js-drag-list-item').index() + 1, 'product');
    });
}

// function resizeBrowserOnMobile() {
//     if (isSmallView()) {
//         const viewportHeight = $(window).innerHeight() * 0.01;
//         $('html').css('--vh', `${viewportHeight}px`);
//     }
// }

// function expandForMobile(parentContainer) {
//     const videoBlock = parentContainer.find('video');
//     const mediaBlock = parentContainer.find('.js-product-experience-media');
//     const width = videoBlock.width * (window.innerHeight / videoBlock.height);

//     parentContainer.find($videoHolder).css({
//         'width': width
//     });
//     mediaBlock.scrollLeft = (mediaBlock.scrollWidth / 2) - (window.innerWidth / 2);
// }

// function resetForMobileCollapse(parentContainer) {
//     const mediaContainer = parentContainer.find('.js-product-experience-media');

//     mediaContainer.animate({
//         scrollLeft: (mediaContainer.scrollWidth / 2) - (window.innerWidth / 2)
//     }, 300);
// }

function onClickCloseButton() {
    ignoreInViewport = false;
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');

    // if (isSmallView()) {
    //     $parentExperienceBlock.find($('.js-product-experience-block video')).hide();
    //     resetForMobileCollapse($parentExperienceBlock);
    // }

    $parentExperienceBlock.find($hotspotContainer).removeClass('fade-in').addClass('hidden');
    $parentExperienceBlock.find($closeButton).removeClass('visible');

    setTimeout(function() {
        $parentExperienceBlock.removeClass('full-width');
        $parentExperienceBlock.find($experienceBtn).addClass('fade-in');
        $parentExperienceBlock.find($videoHolder).removeAttr('style');

        // if (isSmallView()) {
        //     $('body').removeClass('no-scroll');
        //     $parentExperienceBlock.removeClass('fixed');
        //     $('html, body').animate({
        //         scrollTop: $parentExperienceBlock.data('window-scroll-top')
        //     }, 500);

        //     setTimeout(function() {
        //         $('.js-product-experience-block video').show();
        //     }, 1000);
        // }
    }, isSmallView() ? 300 : 0);

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'exit');
}

function onClickExperienceButton() {
    ignoreInViewport = true;
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');

    // if (isSmallView()) {
    //     $parentExperienceBlock.find($('video')).hide();
    // }

    $parentExperienceBlock.addClass('full-width');

    $parentExperienceBlock.find($closeButton).addClass('visible');
    $parentExperienceBlock.find($experienceBtn).removeClass('fade-in');

    // if (isSmallView()) {
    //     $('html, body').animate({
    //         scrollTop: $parentExperienceBlock.offset().top
    //     }, 500);

    //     setTimeout(function() {
    //         $parentExperienceBlock.addClass('fixed');
    //         $('body').addClass('no-scroll');
    //     }, 500);

    //     expandForMobile($parentExperienceBlock);
    //     $parentExperienceBlock.data('window-scroll-top', $(window).scrollTop());
    //     $parentExperienceBlock.find($hotspotContainer).removeClass('hidden').addClass('fade-in');

    //     setTimeout(function() {
    //         $parentExperienceBlock.find($('video')).show();
    //     }, 1000);
    // } else {
        setTimeout(function() {
            $parentExperienceBlock.find($hotspotContainer).removeClass('hidden').addClass('fade-in');
        }, 1000);
   // }

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'open');
}

function onClickHotspot(e) {
    const $target = $(e.currentTarget);
    const $this = $(this);
    const $parentExperienceBlock = $this.closest('.js-product-experience-block');
    const $closeButton = $parentExperienceBlock.find($('.js-close-video-overlay'));
    const $popup = $parentExperienceBlock.find($('.js-popup'));
    const $popupImage = $parentExperienceBlock.find($('.js-popup .js-popup-image'));
    const $popupBgImage = $parentExperienceBlock.find($('.js-popup .js-popup-bg-image'));
    const $popupSubtitle = $parentExperienceBlock.find($('.js-popup .js-popup-subtitle'));
    const $popupTitle = $parentExperienceBlock.find($('.js-popup .js-popup-title'));
    const $popupDescription = $parentExperienceBlock.find($('.js-popup .js-popup-description'));
    const $popupCloseBtn = $parentExperienceBlock.find($('.js-close-popup'));
    const $hotspotContainer = $parentExperienceBlock.find($('.js-hotspot-container'));
    const $hiddenImage = $parentExperienceBlock.find($('.js-hidden-images-container img'));

    const zoomVideoSrc = $target.attr('data-zoom-src');
    const reverseVideoSrc = $target.attr('data-reverse-src');
    const zoomPosterSrc = $target.attr('data-zoom-poster-src');
    const reversePosterSrc = $target.attr('data-reverse-poster-src');
    const popupSubtitle = $target.attr('data-popup-subtitle');
    const popupTitle = $target.attr('data-popup-title');
    const popupImageSrc = $target.attr('data-popup-image');
    const popupBgImageSrc = $target.attr('data-popup-bg-image');
    const popupDescription = $target.attr('data-popup-description');
    const popupPosition = $target.attr('data-popup-position');
    const bgImageIndex = $target.attr('data-image-id');
    const initialImageId = $parentExperienceBlock.find($('.js-hidden-images-container img:first-child')).attr('data-image-id');

    // append the correct content for the popup that's insinde the hotspot
    $popupSubtitle.append(popupSubtitle);
    $popupTitle.append(popupTitle);
    $popupDescription.append(popupDescription);
    $popupImage.attr('data-src', popupImageSrc);
    $popupBgImage.attr('data-src', popupBgImageSrc);
    $popup.addClass(popupPosition);

    damHelper.updateImages('.js-popup');

    $hotspotContainer.removeClass('fade-in');
    $closeButton.removeClass('visible');

    const $container = $('.js-experience-video-container', $parentExperienceBlock);

    // handle closing the popup
    $popupCloseBtn.on('click', function() {
        $popup.removeClass('open');
        $closeButton.addClass('visible');

        setTimeout(function() {
            $hotspotContainer.addClass('fade-in');
        }, 3000);

        setTimeout(function() {
            // remove the popup content
            $popupSubtitle.empty();
            $popupTitle.empty();
            $popupDescription.empty();
            $popupImage.attr({'src': '', 'data-src': ''});
            $popupBgImage.attr({'src': '', 'data-src': ''});
            $popup.removeClass(popupPosition);
        }, 1000);

        // show the correct hidden image before transition out video
        $hiddenImage.css('z-index', '0');
        $hiddenImage.each(function(index, child) {
            if (child.getAttribute('data-image-id') == bgImageIndex) {
                $(child).css('z-index', '10');
            }
        });

        // start the transition out video
        damHelper.updateVideo($container, {'asset': reverseVideoSrc, 'posterimage': reversePosterSrc, 'loop':'0'},
            function() {
            const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

            $video.off('ended').on('ended', function() {
                // show the correct hidden image before transition out video
                $hiddenImage.css('z-index', '0');
                $hiddenImage.each(function(index, child) {
                    if (child.getAttribute('data-image-id') == initialImageId) {
                        $(child).css('z-index', '10');
                    }
                });

                // start the initial looping video after the transition out video is done
                damHelper.updateVideo($container, {'asset': $container.attr('data-initial-video'), 'posterimage': $container.attr('data-initial-poster')});

                $hotspotContainer.addClass('fade-in');
            });
        });
    });

    // show the correct hidden image before the transition in video
    $hiddenImage.css('z-index', '0');
    $hiddenImage.each(function(index, child) {
        if (child.getAttribute('data-image-id') == initialImageId) {
            $(child).css('z-index', '10');
        }
    });

    // start the transition in video
    damHelper.updateVideo($container, {'asset': zoomVideoSrc, 'posterimage': zoomPosterSrc, 'loop': '0'},
        function() {
        const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

        setTimeout(function() {
            $popup.addClass('open');
        }, 3000);

        $video.off('ended').on('ended', function() {
            // remove the popup and its content after the transition in video is done
            $popup.removeClass('open');

            setTimeout(function() {
                // remove the popup content
                $popupSubtitle.empty();
                $popupTitle.empty();
                $popupDescription.empty();
                $popupImage.attr({'src': '', 'data-src': ''});
                $popupBgImage.attr({'src': '', 'data-src': ''});
                $popup.removeClass(popupPosition);
            }, 1000);

            if (!$closeButton.hasClass('visible')) {
                $closeButton.addClass('visible');
            }

            // show the correct hidden image before the transition out video
            $hiddenImage.css('z-index', '0');
            $hiddenImage.each(function(index, child) {
                if (child.getAttribute('data-image-id') == bgImageIndex) {
                    $(child).css('z-index', '10');
                }
            });

            // start the transition out video
            damHelper.updateVideo($container, {'asset': reverseVideoSrc, 'posterimage': reversePosterSrc, 'loop':'0'},
            function() {
                const $video = $parentExperienceBlock.find($('.s7videoplayer video'));

                $video.off('ended').on('ended', function() {
                    // show the correct hidden image
                    $hiddenImage.css('z-index', '0');
                    $hiddenImage.each(function(index, child) {
                        if (child.getAttribute('data-image-id') == initialImageId) {
                            $(child).css('z-index', '10');
                        }
                    });

                    // start the initial looping video after the transition out video is done
                    damHelper.updateVideo($container, {'asset': $container.attr('data-initial-video'), 'posterimage': $container.attr('data-initial-poster')});

                    $hotspotContainer.addClass('fade-in');
                });
            });
        });
    });

    advent.pushAdventDataLayerDataForProductExperienceBlock($this.closest('.js-product-experience-block'), 'view');
}

/**
 * Checks if the productExperience element exists on the page
 *
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $productExperinceBlock.length > 0;
};

const productExperience = {
    init: () => {
        if (shouldInit()) {
            addEvents();
            showExperienceButton();
            //resizeBrowserOnMobile();
        }
    }
};

module.exports = productExperience;

},{"./advent":269,"./dam/dam-helper":419,"./modules/helpers/isInViewport":464,"./modules/helpers/isSmallView":469}],584:[function(require,module,exports){
'use strict';

let $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
const show = function (container) {
    const target = (!container || $(container).length === 0) ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader')
            .append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};

/**
 * @function
 * @description Hides an AJAX-loader
 */
const hide = function () {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],585:[function(require,module,exports){
'use strict';

const dialog = require('./dialog'),
    product = require('./pages/product'),
    appendParamToURL = require('./modules/util/appendParamToURL'),
    flyout = require('./flyout'),
    _ = require('lodash');


const makeUrl = function (url, source, productListID) {
    if (source) {
        url = appendParamToURL(url, 'source', source);
    }

    if (productListID) {
        url = appendParamToURL(url, 'productlistid', productListID);
    }

    return url;
};

const removeParam = function (url) {
    if (url.indexOf('?') !== -1) {
        return url.substring(0, url.indexOf('?'));
    } else {
        return url;
    }
};

const quickview = {
    init: function () {
        if (!this.exists()) {
            this.$container = $('.js-generic-flyout').addClass('js-quickview-dialog');
        }

        this.productLinks = $('#search-result-items .thumb-link').map(function (index, thumbLink) {
            return $(thumbLink).attr('href');
        });

        product.initializeQuickviewEvents();
    },

    setup: function (qvUrl) {
        const $btnNext = $('.quickview-next'),
            $btnPrev = $('.quickview-prev');

        this.productLinkIndex = _(this.productLinks).findIndex(function (url) {
            return removeParam(url) === removeParam(qvUrl);
        });

        // hide the buttons on the compare page or when there are no other products
        if (this.productLinks.length <= 1 || $('.compareremovecell').length > 0) {
            $btnNext.hide();
            $btnPrev.hide();
            return;
        }

        if (this.productLinkIndex === this.productLinks.length - 1) {
            $btnNext.attr('disabled', 'disabled');
        }

        if (this.productLinkIndex === 0) {
            $btnPrev.attr('disabled', 'disabled');
        }

        $btnNext.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(1);
        }.bind(this));

        $btnPrev.on('click', function (e) {
            e.preventDefault();
            this.navigateQuickview(-1);
        }.bind(this));
    },

    /**
     * @param {Number} step - How many products away from current product to navigate to. Negative number means navigate backward
     */
    navigateQuickview: function (step) {
        // default step to 0
        this.productLinkIndex += (step ? step : 0);
        const url = makeUrl(this.productLinks[this.productLinkIndex], 'quickview');
        dialog.replace({
            url: url,
            callback: this.setup.bind(this, url)
        });
    },

    /**
     * @description show quick view dialog
     * @param {Object} options
     * @param {String} options.url - url of the product details
     * @param {String} options.source - source of the dialog to be appended to URL
     * @param {String} options.productlistid - to be appended to URL
     * @param {Function} options.callback - callback once the dialog is opened
     */
    show: function (options) {
        if (!this.exists()) {
            this.init();
        }

        const url = makeUrl(options.url, options.source, options.productlistid);

        if (options.flyout) {
            flyout.load({
                url: url
            });
        } else {
            dialog.open({
                target: options.target,
                url: url
            });
        }

        $('body').on('click', '.ui-widget-overlay', function(){
            dialog.close();
            $(this.$container).remove();
        });
    },
    exists: function () {
        return this.$container && (this.$container.length > 0);
    }
};

module.exports = quickview;

},{"./dialog":422,"./flyout":425,"./modules/util/appendParamToURL":479,"./pages/product":552,"lodash":208}],586:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */
function hashFn(str) {
    let hash = 5381,
        i = str.length;

    while (i) {
        hash = (hash * 33) ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function () {
        $('.product-review').each(function (index, review) {
            const pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            const rating = getRating(pid);
            const baseRating = Math.floor(rating);
            let starsCount = 0;

            for (let i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }

            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }

            if (starsCount < 5) {
                for (let j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],587:[function(require,module,exports){
'use strict';

function initRecaptcha(recaptchaConfigObj) {
    if (typeof grecaptcha === 'undefined') {
        return;
    }

    function recaptchaCreate(containerDef, callback) {
        const containerid = containerDef.containerId;
        // do not re-init recaptcha in the same container because
        // expiredCaptchaCallback will reset it after it has expired
        if (!$('#' + containerid).length || recaptchaConfigObj.captchaContainers[containerid] != undefined) {
            return;
        }

        recaptchaConfigObj.captchaContainers[containerid] = grecaptcha.render(containerid, {
            sitekey: SitePreferences.RECAPTCHA_SITEKEY,
            callback: callback.bind(this, containerDef),
            size: 'invisible',
            'expired-callback': function(response){
                expiredCaptchaCallback(response, recaptchaConfigObj);
            }
        });
    }

    recaptchaConfigObj.containerDefinitions.forEach(def => {
        recaptchaCreate(def, recaptchaCallback);
    });
}

function recaptchaCallback(def, response) {
    const containerDef = def;

    return new Promise(function (resolve, reject) { /* eslint-disable-line */
        containerDef.handler(response, containerDef);
        resolve();
    });
}

const expiredCaptchaCallback = function(recaptchaRes, recaptchaConfigObj) {
    recaptchaConfigObj.containerDefinitions.forEach(def => {
        grecaptcha.reset(recaptchaConfigObj.captchaContainers[def.containerId]);
    });
};

function defaultVerifyHandler(response, containerDef) {
    const recaptchaResponseElement = containerDef.$form.find('.js-recaptcha-response');

    if (!recaptchaResponseElement.length) {
        return;
    }

    recaptchaResponseElement.val(response);
    containerDef.$form.addClass(_constants.CHALLENGE_DONE_CLASS);
    containerDef.$form.find('[type=submit]').click();
}

function buildContainerDefinition($form, containerId, handlerFunction) {
    return {
        containerId: containerId,
        handler: handlerFunction,
        $form: $form
    };
}

const _constants = {
    CHALLENGE_DONE_CLASS: 'js-recaptchadone', // indicates if recaptcha challenge is resolved
    FORM_EXECUTE_RECAPTCHA_CLASS: 'js-executerecaptcha', // indicates that recaptcha challenge should be presented to customer
    RECAPTCHA_CONTAINER_ID_ATTR: 'recaptchacontainerid', // holds id of div containing recaptcha - only set for parent form element
    HIDE_RECAPTCHA_CLASS: 'js-donotuserecaptcha' // value set to indicate that recaptcha shouldn't be used yet on the page (until RateLimiter decides that on BE side)
};

const recaptchaConfig = {
    containerDefinitions: null,
    captchaContainers: null,
    CONSTANTS: _constants,

    buildContainerDefinition: buildContainerDefinition,
    defaultVerifyHandler: defaultVerifyHandler,
    defaultInitializationForFormById: defaultInitializationForFormById,
    executeForContainer: (containerId) => {
        if (!this.captchaContainers || !grecaptcha) {
            return;
        }

        const recaptchaContainer = this.captchaContainers[containerId];
        grecaptcha.reset(recaptchaContainer);
        grecaptcha.execute(recaptchaContainer);
    },
    removeChallengeDoneClass: (containerId) => {
        const $form = $('#' + containerId).parents('form');
        $form.removeClass(_constants.CHALLENGE_DONE_CLASS);
    },
    init: (newContainerDefinitions) => {
        const self = this;

        if (!self.containerDefinitions) {
            self.containerDefinitions = newContainerDefinitions || [];
        } else {
            newContainerDefinitions.forEach(function(newDef) {
                let addDefinition = true;
                self.containerDefinitions.forEach(function(existingDef) {
                    if (newDef.containerId == existingDef.containerId) {
                        addDefinition = false;
                    }
                });

                if (addDefinition) {
                    self.containerDefinitions.push(newDef);
                }
            });
        }

        if (!self.captchaContainers) {
            self.captchaContainers = {};
        }

        if (typeof grecaptcha !== 'undefined') {
            if (!(grecaptcha.render instanceof Function)) {
                $(document).on('recaptchaReady', function () { // recaptchaReady event is triggered once the recaptcha script is loaded
                    initRecaptcha(self);
                });
            } else {
                initRecaptcha(self);
            }
        }
    }
};

function defaultInitializationForFormById(formId) {
    const recaptchaContainerId = 'recaptcha-container';
    const recaptchaFormContainer = $('#' + recaptchaContainerId);

    if (recaptchaFormContainer && recaptchaFormContainer.length) {
        const $form = $('#' + formId);
        recaptchaConfig.init([buildContainerDefinition($form, recaptchaContainerId, defaultVerifyHandler)]);
        $form.addClass(_constants.FORM_EXECUTE_RECAPTCHA_CLASS);
        $form.data(_constants.RECAPTCHA_CONTAINER_ID_ATTR, recaptchaContainerId);
    }
}

module.exports = recaptchaConfig;

},{}],588:[function(require,module,exports){
'use strict';

const isDesktopView = require('./modules/helpers/isDesktopView');
const isTabletView = require('./modules/helpers/isTabletView');
const isRetina = require('./modules/helpers/isRetina');
const debounce = require('./modules/helpers/debounce');

function getImgSrc(img){
    const $img = img;
    const imgDesktop = $img.data('desktop-img');
    const imgTablet = $img.data('tablet-img');
    const imgMobile = $img.data('mobile-img');
    const imgDesktopRetina = $img.data('desktop-retina');
    const imgTabletRetina = $img.data('tablet-retina');
    const imgMobileRetina = $img.data('mobile-retina');
    let imgUrl;

    if (isRetina()){
        if (isDesktopView()) {
            imgUrl = imgDesktopRetina || imgDesktop;
        } else if (isTabletView()) {
            imgUrl = imgTabletRetina || imgTablet || imgDesktopRetina || imgDesktop;
        } else {
            imgUrl = imgMobileRetina || imgMobile || imgTabletRetina || imgTablet || imgDesktop;
        }
    } else {
        if (isDesktopView()) {
            imgUrl = imgDesktop || imgDesktopRetina;
        } else if (isTabletView()) {
            imgUrl = imgTablet || imgTabletRetina || imgDesktop || imgDesktopRetina;
        } else {
            imgUrl = imgMobile || imgMobileRetina || imgTablet || imgTabletRetina || imgDesktop || imgDesktopRetina;
        }
    }

    $img.attr('data-src', imgUrl);
}

function responsiveBgImg() {
    const $bgSwitch = $('.js-responsive-bg');

    if ($bgSwitch.length) {
        $bgSwitch.each(function () {
            // set correct image src
            getImgSrc($(this));
            // init lazy load
            $(this).lazy();
        });
    }
}

function initializeEvents() {
    responsiveBgImg();

    $(window).on('resize', debounce(function () {
        responsiveBgImg();
    }, 300));
}

const responsiveBg = {
    init: function() {
        initializeEvents();
    }
};

module.exports = responsiveBg;

},{"./modules/helpers/debounce":458,"./modules/helpers/isDesktopView":463,"./modules/helpers/isRetina":467,"./modules/helpers/isTabletView":472}],589:[function(require,module,exports){
'use strict';

const isMobileWidth = require('./modules/util/isMobileWidth');
const elementInViewport = require('./modules/util/elementInViewport');
const advent = require('./advent');

const responsiveVideoElement = '.js-responsive-video';
const videoControls = '.js-responsive-video-controls';
const videoControlBtn = '.js-responsive-video-control-button';
const videoOptionsData = 'responsive-video-options';

const players = [];

function createPlayers() {
    $(responsiveVideoElement).each(function (_, videoElement) {
        const options = $(videoElement).data(videoOptionsData);

        if (!options) {
            return;
        }

        const shouldInitVideo = (
            (isMobileWidth() && !options.hideOnMobile) ||
            (!isMobileWidth() && !options.hideOnDesktop)
        ) && !options.skipOnLoad;

        if (shouldInitVideo) {
            players[options.id] = videoElement;
        }

        if (options.playWhenInView) {
            playWhenInViewport(videoElement);
        }
    });
}

function playVideo(videoElement) {
    if (!videoElement) {
        return;
    }
    $('video', videoElement)[0].play();
}

function pauseVideo(videoElement) {
    if (!videoElement) {
        return;
    }
    $('video', videoElement)[0].pause();
}

function onVideoControlClick() {
    const target = $(this).data('target');
    const controls = $(this).closest(videoControls);

    if (!$(controls).hasClass('is-playing')) {
        $(controls).removeClass('was-paused');
        $(controls).addClass('is-playing');
        playVideo(target);
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('play');
    } else {
        $(controls).addClass('was-paused');
        $(controls).removeClass('is-playing');
        pauseVideo(target);
        advent.pushAdventDataLayerDataWithActiveProductImageSlide('pause');
    }
}

function playWhenInViewport(videoElement) {
    $(window).on('load scroll', function () {
        const controls = $(videoElement).find(videoControls);
        const isOpaque = $(videoElement).parent().css('opacity') == '0';

        if (elementInViewport(videoElement, 0) && !isOpaque) {
            if (!controls.hasClass('was-paused') && !controls.hasClass('is-playing')) {
                playVideo(videoElement);
                controls.addClass('is-playing');
            }
            return;
        }
        pauseVideo(videoElement);
        controls.removeClass('is-playing');
    });
}

function getVideoId(el) {
    const options = JSON.parse(JSON.stringify($(el).data('responsive-video-options')));
    return options.id;
}

function init() {
    createPlayers();

    $(videoControlBtn).on('click', onVideoControlClick);
    $(videoControlBtn).on('keyup', function (e) {
        const target = $(this).data('target');
        const controls = $(this).closest(videoControls);
        const id = getVideoId(target);

        if (typeof players[id] !== 'undefined' && e.originalEvent === KeyboardEvent) {
            if (e.which === 13 || e.which === 32) {
                if (!$(controls).hasClass('is-playing')) {
                    $(controls).removeClass('was-paused');
                    $(controls).addClass('is-playing');
                    playVideo(players[id]);
                } else {
                    $(controls).addClass('was-paused');
                    $(controls).removeClass('is-playing');
                    pauseVideo(players[id]);
                }
            }
        }
    });
}

function updateVideoSrc(videoElementID, newVideoSrc) {
    if (!videoElementID) {
        return;
    }

    const $video = $(`#${videoElementID}`);
    const $src = $('source', $video);

    if (!$video || !$video.length || !$src || !$src.length) {
        return;
    }

    if (!newVideoSrc) {
        showBlock($video, false);
        return;
    }

    const $responsiveVideo = $video.closest('.js-responsive-video');
    if ($responsiveVideo && $responsiveVideo.length) {
        const responsiveVideoOptions = $responsiveVideo.data('responsive-video-options');
        if (responsiveVideoOptions) {
            responsiveVideoOptions.src = newVideoSrc;
            $responsiveVideo.attr('data-responsive-video-options', JSON.stringify(responsiveVideoOptions));
        }
    }

    $src[0].setAttribute('src', newVideoSrc);
    $video[0].load();
    $video[0].play();
    showBlock($video, true);
}

function showBlock(videoElement, showBlock) {
    if (!videoElement) {
        return;
    }

    const $videoHolder = videoElement.closest('.js-video-holder');
    if (!$videoHolder || !$videoHolder.length) {
        return;
    }

    if (showBlock) {
        $videoHolder.removeClass('hide');
        return;
    }

    $videoHolder.addClass('hide');
}

const responsiveVideo = {
    init,
    updateVideoSrc
};

module.exports = responsiveVideo;

},{"./advent":269,"./modules/util/elementInViewport":483,"./modules/util/isMobileWidth":499}],590:[function(require,module,exports){
'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie');
const scrollBrowser = require('./modules/util/scrollBrowser');
const isInViewport = require('./modules/helpers/isInViewport');

let prevSelectedTown = '';
let prevSelectedDistrict = '';
const currentCountryCode = getCountryFromLocaleCookie();

/**
 * @description on init floats labels of fields that are not empty
 **/
function initFormElements() {
    $('form').addClass('rituals-form');

    //global input character counter
    inputCharacterCounter();

    //style the form elements
    formElementsStyling();

    readonlySelect();

    initializeDataMask();

    firstLastNameEmojiValidation();
}

function formElementsStyling() {
    $('input').each(function () {
        const $this = $(this);
        const isDisabled = $this.prop('disabled');

        if (isDisabled) {
            $this.siblings().addClass('label-disabled');
        }
    });
}

function inputCharacterCounter() {
    if ($('.js-character-counter').length) {
        $('.js-character-counter').each(function () {
            const $this = $(this);
            const inputMaxLength = $this.attr('maxlength');
            let inputCharNumber = $this.val().length;
            let inputCharLeft = inputMaxLength - inputCharNumber;
            const counterHTML = '<span class="input-character-counter"><span class="js-charnumber-left">' + inputCharLeft + '</span>/' + inputMaxLength + '</span>';

            $(counterHTML).insertAfter($this);

            const $leftCharactersElement = $(document).find('.js-charnumber-left');

            $this.on('input paste', function () {
                inputCharNumber = $this.val().length;
                inputCharLeft = inputMaxLength - inputCharNumber;

                $leftCharactersElement.text(inputCharLeft);
            });
        });
    }
}

function readonlySelect() {
    const tabetAndMobileView = $(window).width() < 1025;

    $('.js-custom-select').each(function () {
        const $this = $(this);

        if (tabetAndMobileView) {
            const isReadonly = $this.attr('readonly');

            if (isReadonly) {
                $this.attr('tabindex', '-1').addClass('select-readonly');
            }
        }
    });
}

function initializeDataMask(parentSelector) {
    $((parentSelector ? parentSelector + ' ' : '') + 'input[data-mask]:not(.masked)').each(function (idx, element) {
        const $elm = $(element);
        const $mask = $elm.attr('data-mask');

        if ($mask) {
            $elm.addClass('masked').mask($elm.attr('data-mask'));
        }
    });

    if (currentCountryCode !== 'GB') {
        return;
    }

    initUKPostalMask(parentSelector ? $(parentSelector + ' [id$=postal]') : $('[id$=postal]'));
}

function firstLastNameEmojiValidation() {
    const firstName = $('#dwfrm_profile_customer_firstname');
    const lastName = $('#dwfrm_profile_customer_lastname');

    if ((firstName && firstName.val()) || (lastName && lastName.val())) {
        firstName.focus();
        lastName.focus();

        firstName.focusout();
        lastName.focusout();
    }

}


function initPostalMask(postalInput, postalOptions){
    if (currentCountryCode !== 'GB' && postalInput.attr('data-mask')) {
        postalInput.addClass('masked').mask(postalInput.attr('data-mask'), postalOptions);
        return;
    }

    initUKPostalMask(postalInput, postalOptions);
}

function initUKPostalMask(postalInput, postalOptions) {
    if (!postalInput) {
        postalInput = $('[id$=postal]');
    }

    const regexFirstLetter = /[a-pr-uwy-zA-PR-UWY-Z]/;
    const regexSecondLetter = /[a-hk-yA-HK-Y]/;
    const regexNumber = /[0-9]/;
    const regexThirdLetter = /[a-hj-ks-uwA-HJ-KS-UW]/;
    const regexLastLetter = /[a-bd-hjlnp-uw-zA-BD-HJLNP-UW-Z]/;

    const regexA99AA = new RegExp('^' + regexFirstLetter.source + regexNumber.source + '{2}' + regexLastLetter.source + '{1,2}$');
    const regexAA99AA = new RegExp('^' + regexFirstLetter.source + regexSecondLetter.source + regexNumber.source + '{2}' + regexLastLetter.source + '{1,2}$');

    const regexA9Aa = new RegExp('^' + regexFirstLetter.source + regexNumber.source + /[a-zA-Z]/.source + '$');
    const regexA9Ab = new RegExp('^' + regexFirstLetter.source + regexNumber.source + regexThirdLetter.source + '$');

    const ukMaskOptions = {
        'translation': {
            F: {pattern: regexFirstLetter},
            Q: {pattern: regexSecondLetter, optional: true},
            W: {pattern: regexNumber},
            R: {pattern: /[a-zA-Z0-9]/, optional: true},
            E: {pattern: regexLastLetter},
            S: {pattern: /\s/, optional: true},
        },
        onInvalid: function (value, event, field, invalid, options) { /* eslint-disable-line */
            const error = invalid[0];
            value = value.trim();

            if (regexA99AA.test(value + error.v)) {
                field.val(value.substring(0, 2) + ' ' + value.substring(2, value.length) + error.v);
                return;
            }

            if (regexAA99AA.test(value + error.v)) {
                field.val(value.substring(0, 3) + ' ' + value.substring(3, value.length) + error.v);
            }
        },
        onKeyPress: function (value, event, field, options) { /* eslint-disable-line */
            const temp = value.trim();

            if (temp.length >= 3 && regexA9Aa.test(temp.substring(0, 3)) && !regexA9Ab.test(temp.substring(0,3))) {
                field.val(temp.substring(0, 2));
            }
        }
    };

    if (postalOptions) {
        $.extend(true, ukMaskOptions, postalOptions);
    }

    postalInput.data('requires-additional-formatting', true).addClass('masked');

    postalInput.mask('FQWRSWEE', ukMaskOptions);
}

function formatUKPostalCodeSpace(postalElement, value) {
    const regexLastThreeCharacters = /^[0-9][a-bd-hjlnp-uw-zA-BD-HJLNP-UW-Z]{2}$/;

    if (value.length >= 5 && regexLastThreeCharacters.test(value.substring(value.length - 3, value.length))) {
        const temp = value;
        value = temp.substring(0, temp.length - 3) + ' ' + temp.substring(temp.length - 3, temp.length);
        postalElement.val(value);
    }
    return value;
}

function initSocialSecurityCheck() {
    setValidationForSsn(true);

    const ssnOptions = {
        onComplete: handleSSNCompleted,
        selectOnFocus: true
    };

    function handleSSNCompleted(ssn, e, field) {
        if (!$(field).valid()) {
            return;
        }
        const $socialSecurityNumber = $('input[name$=socialSecurityNumber]');
        $socialSecurityNumber.removeAttr('disabled');
        const $error = $('.js-ssn-error');
        $socialSecurityNumber.data('isssnvalid', false);

        $error.addClass('hide');
        $socialSecurityNumber.attr('disabled', true);

        $.ajax({
            type: 'GET',
            url: Urls.getAddressBySsn,
            data: {ssn: $socialSecurityNumber.val()},
            success: function (data) {
                const userAddress = JSON.parse(data.result);

                if (data.result !== null) {
                    const $firstName = $('.js-ssn-firstname');
                    const $lastName = $('.js-ssn-lastname');
                    const $birthday = $('.js-ssn-birthday');
                    const $postalcode = $('.js-ssn-postalcode');
                    const $street = $('.js-ssn-street');
                    const $streetnumber = $('.js-ssn-streetnumber');
                    const $city = $('.js-ssn-city');

                    $firstName.val(userAddress.firstname);
                    $lastName.val(userAddress.lastname);

                    $firstName.trigger('blur');

                    if ($birthday.length && userAddress.birthdate) {
                        const date = new Date(userAddress.birthdate);
                        const dateValue = String.format('{0}/{1}/{2}', date.getDate(), date.getMonth() + 1, date.getFullYear());

                        $birthday.val(dateValue);
                        $birthday.trigger('blur');
                    }

                    if ($postalcode.length && userAddress.postalCode) {
                        $postalcode.val(userAddress.postalCode);
                        $postalcode.trigger('input');
                    }

                    if ($street.length && userAddress.address) {
                        $street.val(userAddress.address);
                        $street.trigger('blur');
                    }

                    if ($streetnumber.length && userAddress.streetnumber) {
                        $streetnumber.val(userAddress.streetnumber);
                        $streetnumber.trigger('blur');
                    }

                    if ($city.length && userAddress.area) {
                        $city.val(userAddress.area);
                        $city.trigger('blur');
                    }

                    $lastName.trigger('change.all');
                    $socialSecurityNumber.data('isssnvalid', true);

                    return;
                }
                $error.removeClass('hide');
                $socialSecurityNumber.data('isssnvalid', false);
            },
            error: function () {
                $error.removeClass('hide');
                $socialSecurityNumber.data('isssnvalid', false);
            },
            complete: function () {
                $socialSecurityNumber.removeAttr('disabled');
            }
        });
    }

    $('input[name$=socialSecurityNumber]').mask('000000-0000', ssnOptions);

    $('input[name$=socialSecurityNumber]').on('focusout', function () {
        return false;
    });

    $('.js-edit-profile-btn-submit').click(function () {
        if ($('input[name$=socialSecurityNumber]').data('isssnvalid') === false) {
            $('input[name$=socialSecurityNumber]').attr('disabled', 'disabled');
        }
        setValidationForSsn(false);
    });

    $('input[name$=socialSecurityNumber]').on('blur', function () {
        if (!$(this).valid()) {
            $(this).closest('.form-row').find('.js-ssn-error').addClass('hide');
        }
    });

    function setValidationForSsn(validate) {
        $('input[name$=socialSecurityNumber]').data('validate', validate);
    }
}

function setSubdistrictDropDown(district, selectedSubdistrict, $subdistrictDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getSubdistrictsForDistrict,
        data: {district},
        success: function (data) {
            if (data && data.result) {
                $subdistrictDropDown.empty();
                const subdistricts = data.result.subdistricts;
                $.each(subdistricts, function (index, item) {
                    $subdistrictDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedSubdistrict !== '') {
                $subdistrictDropDown.val(selectedSubdistrict);
                selectedSubdistrict = '';
            }
            $subdistrictDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

function setDistrictDropDown(town, selectedDistrict, $districtDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getDistrictsForTown,
        data: {town},
        success: function (data) {
            if (data && data.result) {
                $districtDropDown.empty();
                const districts = data.result.districts;
                $.each(districts, function (index, item) {
                    $districtDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedDistrict !== '') {
                $districtDropDown.val(selectedDistrict);
                selectedDistrict = '';
            }

            $districtDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

function setTownDropDown(selectedTown, $townCityDropDown) {
    return $.ajax({
        type: 'GET',
        url: Urls.getTowns,
        success: function (data) {
            if (data && data.result) {
                $townCityDropDown.empty();
                const towns = data.result.towns;
                $.each(towns, function (index, item) {
                    $townCityDropDown.append($('<option></option>').attr('value', item.value).text(item.text));
                });
            }
        },
        complete: function () {
            if (selectedTown !== '') {
                $townCityDropDown.val(selectedTown);
                selectedTown = '';
            }
            $townCityDropDown.removeAttr('disabled').selectric('refresh');
        }
    });
}

const ritualsFormHelper = {
    init: function () {
        initFormElements();
        initSocialSecurityCheck();
    },

    initializeDataMask: initializeDataMask,
    initPostalMask: initPostalMask,

    /**
     * Scrolls to an input field (actually, to a little bit above the label)
     * Useful for e.g. highlighting when an input field has an error
     *
     * @param {Object} inputField The HTML input field to scroll to
     * @param {Number} [scrollTime] (Optional) The time (in ms) for the scroll animation to last. Defaults to 10ms
     */
    scrollToInputField: function (inputField, scrollTime) {
        scrollTime = scrollTime || 10;
        inputField = $(inputField);

        const labelSibling = inputField.siblings('label');
        const label = $('label[for=' + inputField.attr('name') + ']');
        let target;

        if (labelSibling.length) {
            target = labelSibling;
        } else if (!labelSibling.length && label.length) {
            target = label;
        } else if (!labelSibling.length && !label.length) {
            target = inputField;
        }

        const scrollTargetPosition = target[0].getBoundingClientRect().top;

        inputField.focus();

        if (scrollTargetPosition < 0 && isInViewport(inputField)) {
            scrollBrowser(target.offset().top - 20, scrollTime);
        }
    },

    initTownDistrictFields: function (townCityDropDown, districtDropDown, subdistrictDropDown, preselectedValues) {
        const $townCityDropDown = townCityDropDown instanceof jQuery ? townCityDropDown : $(townCityDropDown);
        const $districtDropDown = districtDropDown instanceof jQuery ? districtDropDown : $(districtDropDown);
        const $subdistrictDropDown = subdistrictDropDown instanceof jQuery ? subdistrictDropDown : $(subdistrictDropDown);

        $townCityDropDown.attr('disabled', 'disabled').selectric();
        $districtDropDown.attr('disabled', 'disabled').selectric();
        $subdistrictDropDown.attr('disabled', 'disabled').selectric();

        let selectedTown = '';
        let selectedDistrict = '';
        let selectedSubdistrict = '';

        if (preselectedValues) {
            selectedTown = preselectedValues.city;
            selectedDistrict = preselectedValues.district;
            selectedSubdistrict = preselectedValues.subdistrict;
        }

        selectedTown = $townCityDropDown.find('option:selected').val() || selectedTown;
        selectedDistrict = $districtDropDown.find('option:selected').val() || selectedDistrict;
        selectedSubdistrict = $subdistrictDropDown.find('option:selected').val() || selectedSubdistrict;

        const results = Promise.all([
            setTownDropDown(selectedTown, $townCityDropDown),
            setDistrictDropDown(selectedTown, selectedDistrict, $districtDropDown),
            setSubdistrictDropDown(selectedDistrict, selectedSubdistrict, $subdistrictDropDown)
        ]);

        $townCityDropDown.on('selectric-before-change', function (e) {
            prevSelectedTown = e.target.selectedIndex;
        });

        $districtDropDown.on('selectric-before-change', function (e) {
            prevSelectedDistrict = e.target.selectedIndex;
        });

        $townCityDropDown.change(function (e) {
            if (e.target.selectedIndex !== prevSelectedTown) {
                const selectedTown = e.target.selectedIndex > 0 ? e.target.selectedOptions[0].value : '';
                setDistrictDropDown(selectedTown, '', $districtDropDown);
                setSubdistrictDropDown('', '', $subdistrictDropDown);
                $townCityDropDown.valid();
            }
        });

        $districtDropDown.change(function (e) {
            if (e.target.selectedIndex !== prevSelectedDistrict){
                const selectedDistrict = e.target.selectedIndex > 0 ? e.target.selectedOptions[0].value : '';
                setSubdistrictDropDown(selectedDistrict, '', $subdistrictDropDown);
                $districtDropDown.valid();
            }
        });

        $subdistrictDropDown.change(function () {
            $subdistrictDropDown.valid();
        });

        return results;
    },

    setHKDropDowns: function (town, district, subdistrict, form) {
        const $form = form instanceof jQuery ? form : $(form);
        const $cityField = $form.find('[id$=_addressFields_city]');
        const $districtField = $form.find('[id$=_addressFields_district]');
        const $subdistrictField = $form.find('[id$=_addressFields_subdistrict]');
        setTownDropDown(town, $cityField);
        setDistrictDropDown(town, district, $districtField);
        setSubdistrictDropDown(district, subdistrict, $subdistrictField);
    }
};

module.exports = ritualsFormHelper;
module.exports.formatUKPostalCodeSpace = formatUKPostalCodeSpace;

},{"./modules/helpers/isInViewport":464,"./modules/util/getCountryFromLocaleCookie":488,"./modules/util/scrollBrowser":507}],591:[function(require,module,exports){
'use strict';

const lazyLoadEls = '.js-lazy-load';
const lazyLoadProps = {
    effect: 'fadeIn',
    effectTime: 150
};

/**
 * @description Initializes lazy loading events
 */
function initLazyLoad() {
    const $lazyLoadElements = $(lazyLoadEls);

    if ($lazyLoadElements.length > 0) {
        $lazyLoadElements.lazy(lazyLoadProps);
    }
}

/**
 * @description Prepares all Lazy Load elements. If a data-retina attr exists
 * but not a data-src, create a data-src with the retina url as a fallback.
 */
function prepareLazyLoad() {
    $(lazyLoadEls).each(function() {
        const retinaUrl = $(this).data('retina');
        const srcUrlIsSet = $(this).data('src');

        if (retinaUrl && !srcUrlIsSet) {
            $(this).attr('data-src', retinaUrl);
        }
    });
}

/**
 * @description Triggers previously binded event and lazy loads the elements
 * in the navigation.
 */
function lazyLoadInNavigation(navItem, skipStatus) {
    const $navItem = $(navItem);
    const $lazyLoadEls = $navItem.find(lazyLoadEls);

    if (!skipStatus && $navItem.data('lazyload-status') !== 'loaded') {
        $navItem.data('lazyload-status', 'loaded');
        $lazyLoadEls.lazy(lazyLoadProps);
    }

    if (skipStatus) {
        $lazyLoadEls.lazy(lazyLoadProps);
    }
}

const lazyLoadHelper = {
    init: function() {
        prepareLazyLoad();
        initLazyLoad();
    },

    lazyLoadInNavigation: lazyLoadInNavigation
};

module.exports = lazyLoadHelper;

},{}],592:[function(require,module,exports){
'use strict';

const ritualsFormHelper = require('./rituals-form-helper');
const lazyLoadHelper = require('./rituals-lazyload-helper');
const equalHeight = require('./modules/helpers/equalHeight');
const isMobileWidth = require('./modules/util/isMobileWidth');

/**
 * @description Adds the anime-block classes to all elements listed in the element array
 **/
function prepareAnimBlocks() {
    // list of element that should be converted to an anim-block
    const allowedClasses = [
        '.content-banner',
        '.two-tile-vertical'
    ];

    // list of classes that should not be converted an anim-block
    const skipClasses = [
        '.js-anim-block',
        '.two-tile-vertical-small'
    ];

    $.each(allowedClasses, function(idx, val) {
        $(val).each(function(i, v) {
            const shouldSkip = $(v).is(skipClasses.join(','));
            const containsVideo = $(v).find('.js-vimeo-player').length > 0;

            if (!shouldSkip && !containsVideo) {
                $(v).addClass('js-anim-block not-in-viewport');
            }
        });
    });
}

/**
 * @private
 * @function
 * @description Checks and gets the anchor id from the url and scrolls to that block
 */
function jumpToAnchor(anchorID) {
    if (!anchorID) {
        return;
    }

    const hasTrigger = anchorID.indexOf('trigger') === 0;
    const id = hasTrigger ? 'product-filter-grid' : anchorID;
    const $scrollToEl = $('[data-anchor-id=' + id + ']');
    const $triggerEl = $('[data-anchor-id=' + anchorID + ']');

    if ($scrollToEl.length > 0) {
        $('html, body').animate({
            scrollTop: $scrollToEl.last().offset().top
        }, 800, function(e) {
            if (hasTrigger) {
                e.preventDefault();
                const currentUrl = window.location.href;
                $triggerEl.trigger('click');
                window.location.href = currentUrl;
            }
        });
    }
}

/**
 * @description Initializes custom scrollbar
 **/
function initCustomScrollbarEvents() {
    $('.js-custom-scrollbar').mCustomScrollbar();
}

/**
 * @description Makes footer positioned at the bottom of the page
 **/
function bottomFooterPosition() {
    const $fullHeightPage = $('.js-page-fullheight');
    const footerHeight = $('.footer').outerHeight();

    if ($fullHeightPage.length) {
        $fullHeightPage.css('padding-bottom', footerHeight);
    }
}

/**
 * @description Equal height of concept highlight block
 **/
function conceptHighlightHeight() {
    $('.js-concept-highlight-block').each(function () {
        const $this = $(this);
        const $mediaHolder = $this.find('.js-concept-highlight-media');
        const $textHolder = $this.find('.js-concept-highlight-text');
        const $col = $this.find('.js-concept-highlight-col');

        if (!$this.parents('.js-alternative-code-example').length) {
            equalHeight($mediaHolder, 3);
            equalHeight($textHolder, 3);

            if (!$col.hasClass('visible')) {
                $col.addClass('visible');
            }
        }
    });
}

function appHighlightEqualHeight() {
    const $appHightlightEqualDiv = $('.js-narrow-highlight-media-equal');

    if (!$appHightlightEqualDiv.length){
        return;
    }

    if (isMobileWidth()){
        $appHightlightEqualDiv.css('height','');
        return;
    }

    equalHeight($appHightlightEqualDiv, 2);
}

$(window).on('load resize', function () {
    appHighlightEqualHeight();
});

const ritualsStyles = {
    initInputStyles: function() {
        ritualsFormHelper.init();
    },
    prepareAnimBlocks: function() {
        prepareAnimBlocks();
    },
    initLazyLoad: function(){
        lazyLoadHelper.init();
    },
    jumpToAnchor: function(anchorID) {
        jumpToAnchor(anchorID);
    },
    initCustomScrollbar: function () {
        initCustomScrollbarEvents();
    },
    initBottomFooterPosition: function () {
        bottomFooterPosition();
    },
    initConceptHighlightHeight: function () {
        conceptHighlightHeight();
    },
    initAppHighlightEqualHeight: function () {
        appHighlightEqualHeight();
    }
};

module.exports = ritualsStyles;

},{"./modules/helpers/equalHeight":459,"./modules/util/isMobileWidth":499,"./rituals-form-helper":590,"./rituals-lazyload-helper":591}],593:[function(require,module,exports){
/*eslint no-unused-vars:0*/
/*eslint no-undef:0*/
/**
 * This class implements the scroll animation for the Refill Jar,
 * Candle Holders, Easter Egg Gift Sets and Banner Video (Advent).
 *
 * Jira tickets:
 * https://rituals.atlassian.net/browse/DL-14218
 * https://rituals.atlassian.net/browse/DL-18446
 * https://rituals.atlassian.net/browse/DL-20750
 */
'use strict';

const {Power4} = require('gsap');
const ScrollMagic = require('scrollmagic');
const gsap = require('gsap').gsap;
const ScrollMagicPluginGsap = require('scrollmagic-plugin-gsap');
const isSmallView = require('./modules/helpers/isSmallView');
const isSmallTabletView = require('./modules/helpers/isSmallTabletView');
const isInViewport = require('./modules/helpers/isInViewport');
const isDesktopOrTabletLandscapeView = require('./modules/helpers/isDesktopOrTabletLandscapeView');
const {disableScroll} = require('./modules/helpers/scroll');

const scrollMagicEl = '.js-scroll-magic-trigger';
const scrollEl = '.js-scroll-animation-wrapper:not(.initialized), .js-refill-jar-wrapper:not(.initialized)';
ScrollMagicPluginGsap.ScrollMagicPluginGsap(ScrollMagic, gsap);

/**
 * Initializes the animations. These can be
 * - Refill Jar animation: 'refill-jar' (default)
 * - Candle Holder animation: 'candle-holder'
 * - Easter Egg Gift Set animation: 'easter-egg-gift-set'
 * - Banner Video (Advent): 'banner-video-animation'
 */
const initAnimations = () => {

    $(scrollEl).each((i, el) => {
        const type = $(el).data('animation-type') || 'refill-jar';

        switch (type) {
            case 'candle-holder':
                prepareImages(el);
                if (!isSmallView()) {
                    initCandleHolderAnimation(el);
                }
                break;

            case 'easter-egg-gift-set':
                prepareImages(el);
                initEasterEggGiftSetAnimation(el);
                break;

            case 'banner-video-animation':
                if (!$('.js-grid-wrap').length) {
                    initBannerVideoAnimation(el);
                } else if ($('.js-grid-wrap').length && $('.js-grid-wrap').hasClass('grid-initialized')){
                    initBannerVideoAnimation(el);
                }
                break;

            case 'gift-reveal-animation':
                initGiftRevealAnimation(el);
                break;

            case 'advent-animation-block':
                if (!isSmallTabletView()) {
                    adventAnimationBlock(el);
                }
                break;

            case 'advent-ar-block-an':
                if (!isSmallTabletView()) {
                    adventArBlock(el);
                }
                break;

            case 'advent-usp-block':
                if (!isSmallView()) {
                    adventUspBlock(el);
                }
                break;

            case 'advent-overview-block':
                if (isDesktopOrTabletLandscapeView()) {
                    adventOverviewBlock(el);
                }
                break;

            case 'advent-png-sequence':
                adventPNGSequence(el);
                break;

            case 'advent-hero-block':
                adventHeroBlock(el);
                break;

            case 'advent-text-animation-block':
                adventTextAnimation(el);
                break;

            default:
                initRefillJarAnimation(el);
        }
    });
};


const initGiftRevealAnimation = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $ribbon1 = $('.js-ribbon-1');
    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($ribbon1, 1, {x: 0, y: 0}, {y: 100, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: 100,
        offset: 0
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');
};

/**
 * Initialises the Refill Jar animation
 * @param {DOM Object} el The element to initialise
 */
const initRefillJarAnimation = (el) => {
    const $jarLidEl = $('.js-refill-jar-lid', el);
    const $jarRefilEl = $('.js-refill-jar-content', el);
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];

    const hasTextBlocks = el.parentNode.classList.contains('image-holder-column');
    const jarToY = isSmallView() ? -130 : -230;
    const refillToY = isSmallView() ? -80 : -160;
    const duration = isSmallView() ? '75%' : '65%';
    const offset = -150;

    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($jarLidEl, 1, {x: 0, y: 0}, {y: jarToY, ease: 'none'}),
            gsap.fromTo($jarRefilEl, 1, {x: 0, y: 0}, {y: refillToY, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');

    if (hasTextBlocks) {
        const textBlocks = el.closest('.inner-wrapper').querySelectorAll('.text-holder-column > div');
        textBlocks.forEach((el) => {
            textBlockObserver.observe(el);
        });
    }
};

const textBlockObserver = new IntersectionObserver((textBlocks) => {
    for (const textBlock of textBlocks) {
        if (textBlock.isIntersecting) {
            const el = textBlock.target;
            el.classList.add('text-inner--anim');
            textBlockObserver.unobserve(el);
        }
    }
}, {
    threshold: [0.4]
});

const adventAnimationBlock = (el) => {
    const $headline = $('.headline', el);
    const $specText = $('.specification-text');
    const $specBox = $('.specification-box');
    const adventImage = ('#js-advent-pin-img');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const duration = '65%';
    const offset = 150;

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const controller3 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
            gsap.fromTo($specText, 0.6, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($specBox, 0.6, {opacity: 1}, {opacity: 0, delay: 1, ease: 'none'}),
            gsap.fromTo($('.item', el), 1, {opacity: 1}, {opacity: 0.3, delay: 1.5, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 0.5, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($specText, 0.5, {opacity: 0}, {opacity: 1, delay: 0.25, ease: 'none'}),
            gsap.fromTo($specBox, 0.3, {opacity: 0}, {opacity: 1, delay: 0.35, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 0
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(closingTween)
        .addTo(controller2);

    const scene3 = new ScrollMagic.Scene({
        triggerElement: '.scroll-magic-trigger2',
        duration: '100%',
        offset: 0
    })
        .setPin(adventImage)
        .addTo(controller3);

    $(el).addClass('initialized');
};

const adventArBlock = (el) => {
    const $headline = $('.headline', el);
    const $arText = $('.advent-ar-text');
    const $arButton = $('.js-advent-ar-button');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const duration = '65%';
    const offset = 0;

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
            gsap.fromTo($arButton, 1, {opacity: 1}, {opacity: 0, delay: 0.2, ease: 'none'}),
            gsap.fromTo($arText, 1, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 1, transform: 'rotate(0)'}, {opacity: 1, transform: 'rotate(90deg)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 1, transform: 'scale(1)'}, {opacity: 1, transform: 'scale(0)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.item', el), 1, {opacity: 1}, {opacity: 0, delay: 2, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($headline, 0.5, {opacity: 0}, {opacity: 1, delay: 0.5, ease: 'none'}),
            gsap.fromTo($arButton, 0.5, {opacity: 0}, {opacity: 1, delay: 0.7, ease: 'none'}),
            gsap.fromTo($arText, 0.3, {opacity: 0}, {opacity: 1, delay: 0.9, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 0, transform: 'rotate(-90deg)'}, {opacity: 1, transform: 'rotate(0)', delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.advent-ar-icon'), 1, {opacity: 0, transform: 'scale(0)'}, {opacity: 1, transform: 'scale(1)', delay: 0.5, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 150
    })
        .setTween(closingTween)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventUspBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $colWrapper = $('.concept-highlight-block-advent');

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($colWrapper, 0.5, {opacity: 1}, {opacity: 0, delay: 0.2, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($colWrapper, 0.5, {opacity: 0}, {opacity: 1, delay: 0.2, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%'
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: -400
    })
        .setTween(closingTween)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventOverviewBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const scrollVideo = ('.js-background-video', el);

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onCenter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween2 = gsap.timeline()
        .add([
            gsap.fromTo($('.calendar-overview-header', el), 1, {opacity: 1}, {opacity: 0, delay: 0.1, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {opacity: 1}, {opacity: 0, delay: 0.3, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {opacity: 1}, {opacity: 0, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.calender-overview-box', el), 1, {opacity: 1}, {opacity: 0, delay: 0.7, ease: 'none'}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {opacity: 1}, {opacity: 0, delay: 1.1, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {opacity: 1}, {opacity: 0, delay: 1.2, ease: 'none'})
        ]);

    const closingTween3 = gsap.timeline()
        .add([
            gsap.fromTo($(scrollVideo), 1, {opacity: 1}, {opacity: 0, delay: 1.5, ease: 'none'})
        ]);

    const tween = gsap.timeline()
        .add([
            gsap.fromTo($('.calendar-overview-header', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.5, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-header', el), 1, {opacity: 0}, {opacity: 1, delay: 0.3, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.6, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-subhead', el), 1, {opacity: 0}, {opacity: 1, delay: 0.5, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 0.8, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-text', el), 1, {opacity: 0}, {opacity: 1, delay: 0.7, ease: 'none'}),
            gsap.fromTo($('.calender-overview-box', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1, ease: Power4.easeOut}),
            gsap.fromTo($('.calender-overview-box', el), 1, {opacity: 0}, {opacity: 1, delay: 0.9, ease: 'none'}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1, ease: Power4.easeOut}),
            gsap.fromTo($('.content-list-wrapper', el), 1, {opacity: 0}, {opacity: 1, delay: 1.2, ease: 'none'}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {transform:'translateY(30px)'}, {transform:'translateY(0)', delay: 1.3, ease: Power4.easeOut}),
            gsap.fromTo($('.calendar-overview-disclamer', el), 1, {opacity: 0}, {opacity: 1, delay: 1.4, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%'
    })
        .setTween(tween)
        .addTo(controller);

    if (!$(el).parents().hasClass('js-last-overview-tile')) {
        const closingTween = gsap.timeline()
            .add([
                gsap.fromTo($('.text-wrapper', el), 1, {transform:'translateY(0)'}, {transform:'translateY(-600px)', ease: 'none'})
            ]);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: $scrollMagicEl,
            duration: '100%',
            offset: 0
        })
            .setTween(closingTween)
            .setPin(scrollVideo)
            .addTo(controller2);
    }

    const scene3 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: 0
    })
        .setTween(closingTween2)
        .addTo(controller2);

    const scene4 = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: '55%',
        offset: 350
    })
        .setTween(closingTween3)
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventPNGSequence = (el) => {
    const canvas = document.querySelector('.js-christmas-scroll');
    const context = canvas.getContext('2d');

    const isDesktopView = () => {
        const desktopMinWidth = 1920;
        const vpWidth = $(window).width();

        return vpWidth >= desktopMinWidth;
    };

    const imageWidth = isDesktopView() ? 1920 : window.innerWidth;
    const imageHeight = isSmallView() ? 768 : window.innerHeight;
    const imageX = isSmallView() ? (window.innerWidth / 2) - (imageWidth / 2) : 0;
    const urlContainer = $('.js-advent-png-sequence');
    if (!urlContainer.length){
        return;
    }
    const pngSequenceURL = urlContainer.val();
    const imageDomain = 'https://rituals.scene7.com/is/image/rituals';

    if ($('.js-sticky-add-to-cart').length > 0) {
        $('.christmas-tree-wrapper').addClass('png-animation-cta');
    }

    if ($('.christmas-tree-wrapper').length > 0) {
        $('.christmas-tree-wrapper').addClass('christmas-tree-bottom-mask');
    }

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 0,
            reverse: true
        }
    });

    const currentFrame = (index) => (
        `${pngSequenceURL}_${index.toString().padStart(3, '0')}?resMode=sharp2&wid=${imageWidth}`
    );

    function productFadeIn (productNum) {
        if (!$(productNum).hasClass('advent-product-reveal-fadein')) {
            $(productNum).addClass('advent-product-reveal-fadein');
        }
    }

    function productFadeOut (productNum) {
        if ($(productNum).hasClass('advent-product-reveal-fadein')) {
            $(productNum).removeClass('advent-product-reveal-fadein');
            $(productNum).removeClass('advent-toggle-animation');
        }
    }

    function popUpFadeOut (productNum) {
        if ($(productNum).hasClass('advent-product-reveal-open')) {
            $(productNum).removeClass('advent-product-reveal-open');
        }
    }

    const frameCount = 152;
    const images = [];

    if (navigator.connection && navigator.connection.effectiveType != '4g') {
        let i = 0;
        let y = 0;
        for (i = 0, y = 0; i <= frameCount; i++, y++) {
            if (i % 2 == 0) {
                images[y] = new Image();
                images[y].src = currentFrame(i);
            } else {
                y--;
            }
        }
    } else {
        for (let i = 0; i <= frameCount; i++) {
            images[i] = new Image();
            images[i].src = currentFrame(i);
        }
    }

    canvas.height = isDesktopView() ? 1080 : window.innerHeight;
    canvas.width = isDesktopView() ? 1920 : window.innerWidth;
    const img = new Image();
    img.src = currentFrame(0);
    img.onload = function() {
        context.drawImage(img, imageX, 0);
    };

    const obj = {curImg: 0};

    const tween = navigator.connection && navigator.connection.effectiveType != '4g' ?
        gsap.to(obj, 0.5, {
            curImg: images.length - 1,
            roundProps: 'curImg',
            onUpdate: function () {
                context.drawImage(images[obj.curImg], imageX, 0);
                if (obj.curImg >= 0 && obj.curImg <= 37) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } if (obj.curImg >= 38 && obj.curImg <= 46) {
                    productFadeIn('.advent-product1');
                } else if (obj.curImg >= 47 && obj.curImg <= 55) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } else if (obj.curImg >= 56 && obj.curImg <= 62) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 63 && obj.curImg <= 71) {
                    productFadeIn('.advent-product2');
                } else if (obj.curImg >= 72 && obj.curImg <= 80) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 81 && obj.curImg <= 89) {
                    productFadeOut('.advent-productfull');
                    popUpFadeOut('.advent-open-product-full');
                } else if (obj.curImg >= 90 && obj.curImg <= 95) {
                    productFadeIn('.advent-productfull');
                }
            }
        })
        : gsap.to(obj, 0.5, {
            curImg: images.length - 1,
            roundProps: 'curImg',
            onUpdate: function () {
                context.drawImage(images[obj.curImg], imageX, 0);
                if (obj.curImg >= 0 && obj.curImg <= 61) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } if (obj.curImg >= 62 && obj.curImg <= 69) {
                    productFadeIn('.advent-product1');
                } else if (obj.curImg >= 70 && obj.curImg <= 78) {
                    productFadeOut('.advent-product1');
                    popUpFadeOut('.advent-open-product1');
                } else if (obj.curImg >= 79 && obj.curImg <= 106) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 107 && obj.curImg <= 114) {
                    productFadeIn('.advent-product2');
                } else if (obj.curImg >= 115 && obj.curImg <= 130) {
                    productFadeOut('.advent-product2');
                    popUpFadeOut('.advent-open-product2');
                } else if (obj.curImg >= 131 && obj.curImg <= 147) {
                    productFadeOut('.advent-productfull');
                    popUpFadeOut('.advent-open-product-full');
                } else if (obj.curImg >= 148 && obj.curImg <= 152) {
                    productFadeIn('.advent-productfull');
                }
            }
        });

    $('.js-btn-flip-full').on('click', function(e) {
        disableScroll();
    });

    if (isSmallView()){
        $('.js-btn-flip').on('click', function(e) {
            const $product = $(this).closest('.advent-product-reveal');

            $('.js-advent-reveal-product').each(function(){
                const $currentBlock = $(this)[0].classList[1];

                if ($currentBlock === $product[0].classList[1]) {
                    if ($(this).hasClass('advent-product-reveal-open')) {
                        $(this).removeClass('advent-product-reveal-open');
                        $(`.advent-product-reveal.${$currentBlock}`).removeClass('advent-toggle-mobile-animation');
                        return;
                    } else {
                        $(this).addClass('advent-product-reveal-open');
                        $(`.advent-product-reveal.${$currentBlock}`).addClass('advent-toggle-mobile-animation');
                        return;
                    }
                }
            });
        });
    } else {
        $('.js-btn-flip').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();

            const $product = $(this).closest('.advent-product-reveal');
            $product.addClass('advent-toggle-animation');

            $('.js-advent-reveal-product').each(function(){
                const $currentBlock = $(this)[0].classList[1];

                if ($currentBlock === $product[0].classList[1]) {
                    $(this).addClass('advent-product-reveal-open');
                }
            });
        });
    }

    $('.js-advent-popup-close').on('click', function(e) {
        e.stopPropagation();
        e.preventDefault();

        const $product = $(this).closest('.js-advent-reveal-product')[0];
        $product.classList.remove('advent-product-reveal-open');

        $('.advent-product-reveal').each(function(){
            $(this).removeClass('advent-toggle-animation');
        });
    });

    const scene = new ScrollMagic.Scene({
        triggerElement: '#advent-sticky',
        duration: (frameCount * 50) + 'px',
        offset: -400,
        reverse: true
    })
        .setTween(tween)
        .addTo(controller);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '#advent-sticky',
        duration: (frameCount * 50) + 'px',
        reverse: true
    })
        .setPin('#advent-sticky')
        .addTo(controller);
};

const adventHeroBlock = (el) => {
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $heading = $('.heading-h3', el);
    const $headline = $('.headline', el);
    const $btn = $('.btn', el);
    const $scrollIndicator = $('.scroll-icon', el);
    const $adventOverlay = $('.advent-banner-overlay', el);

    $(document).ready(function() {
        gsap.to($heading, {transform:'translateY(0)', delay: 1.5, ease: Power4.easeOut});
        gsap.to($heading, {opacity: 1, delay: 1.5});
        gsap.to($headline, {transform:'translateY(0)', delay: 2, ease: Power4.easeOut});
        gsap.to($headline, {opacity: 1, delay: 2});
        gsap.to($btn, {transform:'translateY(0)', delay: 2.5, ease: Power4.easeOut});
        gsap.to($btn, {opacity: 1, delay: 2.5});
        gsap.to($scrollIndicator, {opacity: 1, delay: 3});
        gsap.to($adventOverlay, {opacity: 1, delay: 1.5});
    });

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });

    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    setTimeout(function(){
        const closingTween = gsap.timeline()
            .add([
                gsap.fromTo($heading, 1, {opacity: 1}, {opacity: 0, ease: 'none'}),
                gsap.fromTo($headline, 1, {opacity: 1}, {opacity: 0, delay: 0.3, ease: 'none'}),
                gsap.fromTo($btn, 1, {opacity: 1}, {opacity: 0, delay: 0.6, ease: 'none'}),
                gsap.fromTo($scrollIndicator, 1, {opacity: 1}, {opacity: 0, delay: 0.9, ease: 'none'})
            ]);

        const scene = new ScrollMagic.Scene({
            triggerElement: $scrollMagicEl,
            duration: '50%'
        })
            .setTween(closingTween)
            .addTo(controller2);
    }, 3000);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '.js-video-holder',
        duration: '90%'
    })
        .setPin('.js-video-holder')
        .addTo(controller2);

    $(el).addClass('initialized');
};

const adventTextAnimation = (el) => {
    $('.scroll-to-top-link').css('display', 'none');

    const slider = document.querySelector('.js-menu-list-advent');
    let isDown = false;
    let startX;
    let scrollLeft;

    slider.addEventListener('mousedown', (e) => {
        isDown = true;
        slider.classList.add('active');
        startX = e.pageX - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
        $('.advent-horizontal-menu').css('cursor', 'grabbing');
    });

    slider.addEventListener('mouseleave', () => {
        isDown = false;
        slider.classList.remove('active');
    });

    slider.addEventListener('mouseup', () => {
        isDown = false;
        slider.classList.remove('active');
        $('.advent-horizontal-menu').css('cursor', 'grab');
    });

    slider.addEventListener('mousemove', (e) => {
        if (!isDown) {
            return;
        }

        e.preventDefault();
        const x = e.pageX - slider.offsetLeft;
        const walk = (x - startX);
        slider.scrollLeft = scrollLeft - walk;
    });

    const controller = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onEnter'
        }
    });
    const controller2 = new ScrollMagic.Controller({
        globalSceneOptions: {
            triggerHook: 'onLeave'
        }
    });

    const closingTween = gsap.timeline()
        .add([
            gsap.fromTo($('.advent-navigation-dots'), 0.2, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($('.advent-horizontal-menu'), 0.2, {opacity: 0}, {opacity: 1, ease: 'none'}),
            gsap.fromTo($('.advent-menu-item'), 0.2, {transform: 'translateY(20px)', opacity: 0}, {transform: 'translateY(0)', opacity: 1, stagger: 0.1, ease: 'none'}),
            gsap.fromTo($('.advent-navigation-dot'), 0.2, {transform: 'translateX(10px)', opacity: 0}, {transform: 'translateX(0)', opacity: 1, stagger: 0.1, ease: 'none'})
        ]);

    const scene = new ScrollMagic.Scene({
        triggerElement: '.js-advent-split',
        offset: 100
    })
        .setTween(closingTween)
        .on('enter', function(){
            $('.advent-navigation-dots').removeClass('advent-navigation-hidden');
            $('.advent-horizontal-menu').removeClass('advent-navigation-hidden');
        })
        .on('leave', function(){
            $('.advent-horizontal-menu').addClass('advent-navigation-hidden');
            $('.advent-navigation-dots').addClass('advent-navigation-hidden');
        })
        .addTo(controller);

    const hideNavigation = gsap.timeline()
        .add([
            gsap.to($('.advent-horizontal-menu'), {opacity: 0, ease: 'none'}),
            gsap.to($('.advent-navigation-dots'), {opacity: 0, ease: 'none'})
        ]);

    const scene2 = new ScrollMagic.Scene({
        triggerElement: '.simple-text-block',
        offset: 0
    })
        .setTween(hideNavigation)
        .on('enter', function () {
            $('.advent-horizontal-menu').addClass('advent-navigation-hidden');
            $('.advent-navigation-dots').addClass('advent-navigation-hidden');
        })
        .on('leave', function () {
            $('.advent-horizontal-menu').removeClass('advent-navigation-hidden');
            $('.advent-navigation-dots').removeClass('advent-navigation-hidden');
        })
        .addTo(controller);

    const scrollToSection = (el) => {
        $('html, body').stop().animate({
            scrollTop: $(el).offset().top
        }, 1600, 'easeOutQuart');
    };

    $('.js-advent-dots').on('click', function(el) {
        const clickedSection = el.target.classList[1];
        scrollToSection($(`[data-adventsection="${clickedSection}"]`));
    });

    $('.js-advent-menu-item').on('click', function(el) {
        const clickedSection = el.target.classList[1];
        scrollToSection($(`[data-adventsection="${clickedSection}"]`));
    });

    $(el).addClass('initialized');
};

/**
 * Initialised the Candle Holder animation
 * @param {DOM Object} el The element to initialise
 */
const initCandleHolderAnimation = (el) => {
    const $first = $('.first', el);
    const $second = $('.second', el);
    const $fourth = $('.fourth', el);
    const $fifth = $('.fifth', el);
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];

    const duration = '65%';
    const offset = -200;

    const controller = new ScrollMagic.Controller();
    const tween = gsap.timeline()
        .add([
            gsap.fromTo($first, 0.7, {xPercent: -50}, {xPercent: -110}),
            gsap.fromTo($second, 0.7, {xPercent: -50}, {xPercent: -80}),
            gsap.fromTo($fourth, 0.7, {xPercent: -50}, {xPercent: -20}),
            gsap.fromTo($fifth, 0.7, {xPercent: -50}, {xPercent: 10})
        ]);

    new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: offset
    })
        .setTween(tween)
        .addTo(controller);

    $(el).addClass('initialized');
};

/**
 * Initialised the Easter Egg Gift Set animation
 * @param {DOM Object} el The element to initialise
 */
const initEasterEggGiftSetAnimation = (el) => {
    const controller = new ScrollMagic.Controller();
    const $tiles = $('.js-easter-egg-tile', el);
    const offset = isSmallView() ? -200 : -300;

    $tiles.each((i, tile) => {
        const tileTweens = getTileTweens(i, tile);
        const tileTimeline = new gsap.timeline().add(tileTweens);
        const tileScene = new ScrollMagic.Scene({
            triggerElement: tile,
            duration: '100%',
            offset: offset
        })
            .setTween(tileTimeline)
            .addTo(controller);
    });

    $(el).addClass('initialized');
};

/**
 * Initialises the Banner Video animation
 * @param {DOM Object} el The element to initialise
 */
const initBannerVideoAnimation = (el) => {
    const $window = $(window);
    const durationText = isSmallView() ? 350 : 420;
    const widthPercentage = isSmallView() ? '0% 15%' : '0% 13%';
    const $videoEl = $('.js-video-holder', el);
    const $textContainer = $('.js-text-holder');
    const $scrollMagicEl = $(el).prev(scrollMagicEl)[0];
    const $hiddenContentTop = $('.js-hidden-content.top');

    const textHolderHeight = $textContainer.outerHeight();
    const videoHeight = $videoEl.outerHeight();
    const visibleContentHeight = $hiddenContentTop.prev('.visible-content').outerHeight();
    const headerHeight = $('.js-header').outerHeight();

    const secondTrigger = '.js-second-scroll-magic-trigger';
    const duration = '40%';

    // place the trigger on the middle of the video since the animation should start when the video is covering the screen
    $(secondTrigger).css('top', $videoEl.offset().top + videoHeight / 2);
    $hiddenContentTop.css('margin-top', -(visibleContentHeight));

    $window.on('scroll', function() {
        if ($window.scrollTop() > textHolderHeight / 2) {
            $textContainer.addClass('visible');
        } else {
            $textContainer.removeClass('visible');
        }
    });

    const controller = new ScrollMagic.Controller();

    // animations for the text content
    const topMargin = ($window.innerHeight() / 2) - (textHolderHeight / 2) - $textContainer.offset().top - 25;
    const tweenTextMargin = gsap.timeline()
        .add([
            gsap.to($textContainer, 1, {margin: topMargin + ' 0 0 0', duration: 0.3, ease: 'none'})
        ]);

    const moveText = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration
    })
        .setTween(tweenTextMargin)
        .addTo(controller);

    const pinText = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: durationText,
        offset: 0
    })
        .setPin('.js-text-holder', {pushFollowers: false})
        .addTo(controller);

    const tweenVideoDimensions = gsap.timeline()
        .add([
            gsap.fromTo($videoEl, 1, {'clip-path':'inset(' + widthPercentage + ')'}, {'clip-path':'inset(0% 0%)'})
        ]);

    const resizeVideo = new ScrollMagic.Scene({
        triggerElement: $scrollMagicEl,
        duration: duration,
        offset: 0
    })
        .setTween(tweenVideoDimensions)
        .addTo(controller);
};

/**
 * Calculates and returns an array of tile part tweens
 * @param {Number} idx The index of the element to initialise
 * @param {DOM Object} el The element to initialise
 * @returns {Array}
 */
const getTileTweens = (idx, el) => {
    const $parts = $('.js-easter-egg-top, .js-easter-egg-ribbon', el);
    const tileTweens = [];

    $parts.each((i, part) => {
        const $part = $(part);
        const isEgg = $part.hasClass('js-easter-egg-top');
        const duration = isEgg ? 0.8 : 1.8;
        const delay = (isEgg && !isSmallView()) ? (idx * 0.2) : 0;
        const dists = $part.data('travel-dist').split('|');
        const dist = isSmallView() ? parseInt(dists[1]) : parseInt(dists[0]);

        tileTweens.push(
            gsap.fromTo($part, duration, {y: 0}, {y: dist, ease: 'easeInOut', delay: delay})
        );
    });

    return tileTweens;
};

/**
 * Prepares the desktop or mobile images inside an element
 * @param {DOM Object} el The element to prepare the images in
 */
const prepareImages = (el) => {
    $('img', el).each((i, image) => {
        let src;

        // In case of DAM image we need to grab a different data attribute.
        if (typeof $(image).data('src') !== 'undefined') {
            src = $(image).data('src');
        } else {
            src = (isSmallView()) ? $(image).data('mobile-img') : $(image).data('desktop-img');
        }

        $(image).attr('src', src);
    });
};

/**
 * Checks for the presents of a styleguide selector
 * @returns {Boolean}
 */
const isStyleGuide = () => $(scrollEl).parents('.js-alternative-code-example').length > 0;

/**
 * Check if we should init or not by searching for a selector and also making sure it's not initialized in the Styleguide's hidden code
 * @returns {Boolean}
 */
const shouldInit = () => $(scrollEl).length > 0 && !isStyleGuide();

const scrollAnimation = {
    init: () => {
        if (shouldInit()) {
            initAnimations();
        }
    }
};

module.exports = scrollAnimation;

},{"./modules/helpers/isDesktopOrTabletLandscapeView":462,"./modules/helpers/isInViewport":464,"./modules/helpers/isSmallTabletView":468,"./modules/helpers/isSmallView":469,"./modules/helpers/scroll":475,"gsap":45,"scrollmagic":253,"scrollmagic-plugin-gsap":252}],594:[function(require,module,exports){
'use strict';

const isMobileOrTabletWidth = require('./modules/util/isMobileOrTabletWidth');
const appendParamToURL = require('./modules/util/appendParamToURL');
const damHelper = require('./dam/dam-helper');

let currentQuery = null;
let lastQuery = null;
let runningQuery = null;
const delay = 30;
const $suggestionsContainer = $('.js-search-suggestions-container');
const $searchResultsContainer = $('.js-search-results-holder');
const $searchQuickLinksDiv = $('.js-search-quick-links');
const $searchInputField = $('.js-search-input-field');
let suggestionsTotal = $searchQuickLinksDiv.find('a').length;
let selectedSuggestionIdx = - 1;
let suggestionsElementsList = $searchQuickLinksDiv.find('a');
const gtm = require('./modules/google').tagManager;

/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            selectedSuggestionIdx = (selectedSuggestionIdx == -1) ? (suggestionsTotal - 1) : (selectedSuggestionIdx - 1);
            break;
        case 40:
            // keyDown
            selectedSuggestionIdx = (selectedSuggestionIdx >= suggestionsTotal - 1) ? -1 : selectedSuggestionIdx + 1;
            break;
        default:
            // reset
            selectedSuggestionIdx = -1;
            return false;
    }

    if (selectedSuggestionIdx === -1){
        $searchInputField.focus();
    } else {
        suggestionsElementsList.eq(selectedSuggestionIdx).focus();
    }

    return true;
}

const searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function () {

        $(document).on('click', '.product-link', function () {
            const clickTarget = $(this).find('.js-search-suggestion-name').text();
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                search_type: 'suggestion',
                click_target: clickTarget ? clickTarget.replace(/^\s+|\s+$/g, '').toLowerCase() : ''
            });
        });

        $(document).on('click', '.js-search-quick-links a', function () {
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: null,
                search_type: 'suggestion',
                click_target: $(this).text() ? $(this).text().toLowerCase() : ''
            });
        });

        $(document).on('click', '.js-search-view-all-link', function () {
            gtm.pushDataLayerEvent({
                event: 'search',
                search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                search_type: 'input',
                click_target: 'view all products'
            });
        });

        // on key up listener
        $searchInputField.keyup(function (e) {

            // get keyCode (window.event is for IE)
            const keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            if (keyCode === 13) {
                gtm.pushDataLayerEvent({
                    event: 'search',
                    search_term: $($searchInputField).val() ? $($searchInputField).val().toLowerCase() : '',
                    search_type: 'input',
                    click_target: null
                });
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                return;
            }

            currentQuery = $searchInputField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));

        $suggestionsContainer.keyup(function(e){
            // get keyCode (window.event is for IE)
            const keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
        });
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function () {
        const headermenu = require('./header-menu');
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        const reqUrl = appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            const suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $searchResultsContainer.html(suggestionHTML).fadeIn(200);
                damHelper.updateImages($searchResultsContainer);
                $searchQuickLinksDiv.hide();

                if (!isMobileOrTabletWidth()) {
                    $searchResultsContainer.find('a').last().on('blur', function() {
                        headermenu.closeSearchBar();
                    });
                } else {
                    $searchResultsContainer.find('a').last().on('keydown', function (e) {
                        if (e.which == 9 && !e.shiftKey) {
                            e.preventDefault();
                            $('.js-close-search-bar').focus();
                        }
                    });
                }
            }

            // get suggestions elements list
            if ($searchQuickLinksDiv.is(':visible')){
                // if quick links are visible count those instead
                suggestionsElementsList = $searchQuickLinksDiv.find('a');
            } else {
                // if results container is there make a list of those
                suggestionsElementsList = $searchResultsContainer.find('a');
            }

            selectedSuggestionIdx = -1;
            suggestionsTotal = suggestionsElementsList.length;

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }

        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function () {
        if (!$searchResultsContainer) { return; }
        $searchResultsContainer.fadeOut(200, function () {
            $searchResultsContainer.empty();
            $searchQuickLinksDiv.show();
        });

        selectedSuggestionIdx = -1;
        suggestionsElementsList = $searchQuickLinksDiv.find('a');
        suggestionsTotal = suggestionsElementsList.length;
    }
};

module.exports = searchsuggest;

},{"./dam/dam-helper":419,"./header-menu":440,"./modules/google":453,"./modules/util/appendParamToURL":479,"./modules/util/isMobileOrTabletWidth":498}],595:[function(require,module,exports){
/**
 * Section Scroller Class
 * issue: https://rituals.atlassian.net/browse/DL-11122
 *
 * Allows for a section controlled scrolling for desktop
 */
'use strict';

const isMobileDevice = require('./modules/helpers/isMobileDevice');
const isTabletPortraitView = require('./modules/helpers/isTabletPortraitView');
const scrollToSectionEl = '.js-scrollto-section';

let isScrolling = false;

/**
 * Initializes the Intersection Observer and observe our scroll sections
 */
const initSectionScroller = () => {
    const observer = new IntersectionObserver((sections) => {
        for (const section of sections) {
            if (section.isIntersecting === true && section.intersectionRatio > 0.05 && !isScrolling) {
                scrollToSection(section.target);
            }
        }
    }, {
        threshold: 0.05
    });

    $(scrollToSectionEl).each(function(i, el) {
        observer.observe(el);
    });
};

/**
 * Scrolls to a give element
 *
 * @param {Element} el Element to scroll to
 */
const scrollToSection = (el) => {
    isScrolling = true;
    const scrollerSpeed = $('.advent-gradient').length > 0 ? 2500 : 600;

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top
    }, scrollerSpeed, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

const scrollToCustomizableSection = (el) => {
    isScrolling = true;
    const productImageHeight = $('.js-product-images').outerHeight();

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top - productImageHeight
    }, 600, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

const scrollWithOffset = (el) => {
    isScrolling = true;
    const headerOffset = $('.js-header').outerHeight();

    $('html, body').stop().animate({
        scrollTop: $(el).offset().top - headerOffset
    }, 600, 'easeOutQuart', () => {
        isScrolling = false;
    });
};

/**
 * Checks the elements on the page and the device to determine if we should init
 *
 * @returns {Boolean} We should init, true or false
 */
const shouldInit = () => {
    return supportsIntersectionOberver() &&
        $(scrollToSectionEl).length > 0 &&
        !isMobileDevice() &&
        !isTabletPortraitView();
};

/**
 * Checks if the IntersectionObserver is supported
 */
const supportsIntersectionOberver = () => {
    return 'IntersectionObserver' in window &&
        'IntersectionObserverEntry' in window &&
        'intersectionRatio' in window.IntersectionObserverEntry.prototype;
};

const sectionScroller = {
    init: () => {
        if (shouldInit()) {
            initSectionScroller();
        }
    },
    scrollTo: scrollToSection,
    scrollToCustom: scrollToCustomizableSection,
    scrollWithOffset: scrollWithOffset
};

module.exports = sectionScroller;

},{"./modules/helpers/isMobileDevice":466,"./modules/helpers/isTabletPortraitView":471}],596:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');
const gtm = require('./modules/google').tagManager;

function initializeCustomSelect() {
    const $select = $('select.js-custom-select');
    if (!$select.length) {
        return;
    }

    $select.each(function () {
        const $this = $(this);
        bindValidationEvents($this);
        if (skipInitialization($this)) {
            return;
        }

        $this.selectric({
            onBeforeInit: function() {
                if ($this.hasClass('js-pdp-custom-select')){
                    bindOptionsToDataAttribute($this);
                    filterVisibleOptions($this, true);
                }
            },
            onInit: function () {
                if ($this.attr('readonly')){
                    $this.attr('tabindex', '-1');
                    const $selectWrapper = $this.closest('.selectric-js-custom-select');
                    $selectWrapper.addClass('selectric-readonly');
                    $selectWrapper.find('.selectric, .selectric-input').attr('tabindex', '-1');
                }

                if ($this.hasClass('js-pdp-custom-select')) {
                    renderSelectricDropdown($this);
                    setOutOfStockClass($this);
                }
            },
            onRefresh: function() {
                if ($this.hasClass('js-pdp-custom-select')) {
                    renderSelectricDropdown($this);
                    setOutOfStockClass($this);
                }
            },
        });

        if (!isSmallView()) {
            $this.attr('tabindex', '-1');
        }
    });
}

function bindOptionsToDataAttribute(select) {
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');

    if (!$selectedSwatch.length) {
        return;
    }

    const $options = select.find('option').clone();
    $options.removeAttr('out-of-stock');
    select.data('options', $options);
}

function filterVisibleOptions(select, isFirstPass) {
    const $selectedSwatch = $('.js-pdp-swatches-item.selected');

    if (!$selectedSwatch.length) {
        return;
    }

    const $selectedSwatchImage = $selectedSwatch.find('.js-pdp-swatches-image');
    const swatchVariationAttributeValue = $selectedSwatchImage.data('variationAttributeValue');
    const variationUrls = $selectedSwatchImage.data('variationUrls');
    const variationAttributeValues = Object.keys(variationUrls);
    const options = select.data('options').clone();
    const $selectedOption = select.children(':selected');
    let selectedOptionValue = '';
    const items = $.grep(options, function(option, index){ /* eslint-disable-line */
        option = $(option);
        const variationAttributeValue = option.data('variationAttributeValue');
        const dropdownVariationUrls = option.data('variationUrls');

        if (!variationAttributeValue) {
            return true;
        }

        if (variationAttributeValue && variationAttributeValues.indexOf(variationAttributeValue) === -1){
            return false;
        }

        const isOptionOutOfStock = variationUrls[variationAttributeValue].isOutOfStock;
        option.data('variationIsAvailable', !isOptionOutOfStock);
        option.attr('out-of-stock', isOptionOutOfStock);
        option.data('variationTitle', dropdownVariationUrls[swatchVariationAttributeValue].title);
        option.text(dropdownVariationUrls[swatchVariationAttributeValue].title + ' (' + dropdownVariationUrls[swatchVariationAttributeValue].price + ')');
        const alreadySelectedValue = $selectedOption.data('variationAttributeValue') === variationAttributeValue;
        const canBeSelected = isFirstPass || true;
        const selected = alreadySelectedValue && canBeSelected;
        option.attr('selected', selected);
        if (selected) {
            selectedOptionValue = option.val();
        }
        return true;
    });

    select.empty().html(items);
    select.data('selectedDropdownValue', selectedOptionValue);
}

function setOutOfStockClass(select){
    const $selectric = select.parents('.selectric-js-pdp-custom-select');
    const $selectricLabel = $('.selectric', $selectric);
    const $dropdown = select.parents('.js-pdp-options-dropdown');
    const $selectedOption = select.children(':selected');
    const isAvailable = $selectedOption.data('variationIsAvailable');

    if (isAvailable == false) {
        $selectricLabel.addClass('out-of-stock');
        $dropdown.addClass('out-of-stock');
        return;
    }

    $selectricLabel.removeClass('out-of-stock');
    $dropdown.removeClass('out-of-stock');
}

function renderSelectricDropdown(select) {
    const $selectric = select.parents('.selectric-js-pdp-custom-select');

    if (!$selectric.length) {
        return;
    }

    const $visibleOptionList = $('.selectric-items ul', $selectric);

    for (let i = 0; i < select.children().length; i++) {
        const $option = $(select.children()[i]);
        const data = $option.data('variationIsAvailable');

        if (data != true && data != false) {
            continue;
        }

        const $visibleOption = $visibleOptionList.find($('[data-index="' + i + '"]'));

        if (data){
            $visibleOption.removeClass('out-of-stock');
        } else {
            $visibleOption.addClass('out-of-stock');
        }
    }
}

function bindValidationEvents(el){
    if (!el.hasClass('js-selectric-validate')) {
        return;
    }

    el.on('change', function() {
        $(this).valid();
        //gtm event for not selecting any value
        if ($(this).hasClass('js-validator-error')) {
            gtm.pushDataLayerEvent({
                'event': 'form_field_error',
                'error_type': 'form_field_error',
                'error_message': $(this).closest('.js-create-account-left-content') && 'wrong gender value, please select a valid value',
                'error_code': null,
                'content_name': $(this).closest('.js-create-account-left-content') && 'register page'
            });
        }

    });
    //Avoid adding multiple events
    el.removeClass('js-selectric-validate');
}


function skipInitialization(el) {
    return el.parents('.selectric-hide-select').length || el.parents('.js-skip-custom-select').length;
}

const customSelect = {
    init: initializeCustomSelect
};

module.exports = customSelect;

$(document).on('selectric.setOutOfStockClass', function (event, select) {
    select = $(select);
    setOutOfStockClass(select);
});

$(document).on('selectric.filterVisibleOptionsAndSetOutOfStockClass', function (event, select) {
    select = $(select);
    filterVisibleOptions(select);
    if (select.parents('.selectric-js-pdp-custom-select').length) {
        select.selectric('refresh');
    } else {
        setOutOfStockClass(select);
    }
});

},{"./modules/google":453,"./modules/helpers/isSmallView":469}],597:[function(require,module,exports){
'use strict';

const isSmallView = require('./modules/helpers/isSmallView');

function toggleSeo() {
    // SEO text block - expand / collapse
    $(document).on('click','.js-seo-text-toggle', function () {
        const $parentSeoBlock = $(this).closest('.wrapper__seo-block');

        if (!$parentSeoBlock.hasClass('expanded')) {
            $parentSeoBlock.addClass('expanded');
            if ($parentSeoBlock.find('.text__container a').length) {
                $parentSeoBlock.find('.text__container a').attr('tabindex', '0');
            }
        } else {
            $parentSeoBlock.removeClass('expanded');
            if (isSmallView()) {
                $('html, body').animate({scrollTop: ($parentSeoBlock.offset().top - 90)}, 600);
            }
            if ($parentSeoBlock.find('.text__container a').length) {
                $parentSeoBlock.find('.text__container a').attr('tabindex', '-1');
            }
        }
    });
}

function accessibilityAdjustments() {
    if ($('.wrapper__seo-block').length) {
        $('.wrapper__seo-block').each(function () {
            if ($(this).hasClass('expanded') && $(this).find('.text__container a').length) {
                $(this).find('.text__container a').attr('tabindex', '-1');
            }
        });

        $('.js-seo-text-toggle').attr('tabindex', '0');
    }
}

function initializeEvents() {
    toggleSeo();
    accessibilityAdjustments();
}

const seoText = {
    init: function() {
        initializeEvents();
    }
};

module.exports = seoText;

},{"./modules/helpers/isSmallView":469}],598:[function(require,module,exports){
/*
* This class is used to manage slick slider accross the whole website
* */
'use strict';
const gtm = require('./modules/google').tagManager;
const imagesLoaded = require('imagesloaded');
const equalHeight = require('./modules/helpers/equalHeight');
const prepareDeferedImages = require('./modules/helpers/prepareDeferedImages');
const isSmallView = require('./modules/helpers/isSmallView');
const isDesktopView = require('./modules/helpers/isDesktopView');
const isInViewport = require('./modules/helpers/isInViewport');
const debounce = require('./modules/helpers/debounce');
const responsiveBg = require('./responsive-background');
const damHelper = require('./dam/dam-helper');
const advent = require('./advent');
const greenfriday = require('./greenfriday');

let isDragging = false;
let dragStartX = 0;
let dragTarget = '';
let dragOverDot = -1;

const events = {
    onSliderInit : $.Event('slider.onSliderInit'),
    onAfterChange : $.Event('slider.onAfterChange')
};

const SlickControl = function() {
    const def = {
        $slickDefault           : $('.js-slider'),
        sliderIndicatorClass    : '.js-slider-indicator',
        sliderBarClass          : '.js-slider-bar',
        $sliderContentGrid      : $('.js-grid-slider')
    };

    /**
    * Initialize default slick slider
    * There are no special options from here, instead you can define them all from the data attribute in HTML
    */
    this.defaultSlick = function() {
        /* initialize default slick slider */
        if (def.$slickDefault.length > 0) {
            $.each(def.$slickDefault, function(_, el) {
                const $el = $(el);
                const $sliderBar = $el.siblings(def.sliderBarClass) || false;

                prepareDeferedImages(el);
                damHelper.updateImages($el);

                if ($el.hasClass('slick-initialized')) {
                    return true;
                }

                $el.imagesLoaded(function () {
                    // on init prepare and show the slider bar
                    $el.on('init', function(e, slick) {
                        // trigger an event we can hook into from another script
                        $el.trigger(events.onSliderInit, slick);

                        if (slick.slideCount > 1 && $sliderBar !== false) {
                            if (!$el.hasClass('js-product-slider-stacked') || ($el.hasClass('js-product-slider-stacked') && !isSmallView())) {
                                initSliderBar($sliderBar, slick);
                            }
                        } else {
                            // delete slider bar if only 1 slide
                            // helps with animations
                            $el.parent().find(def.sliderBarClass).remove();
                        }
                    });

                    // on beforeChange move the slider indicator to the correct position
                    $el.on('beforeChange', function(e, slick, currentSlide, nextSlide){
                        updateSliderIndicator($sliderBar, slick, nextSlide);
                        const $revealBlock = $sliderBar.closest('.js-reveal');
                        if ($revealBlock && $revealBlock.length) {
                            advent.pushAdventDataLayerDataWithActiveProductImageSlide('reveal content slider');
                        }
                    });

                    $el.on('afterChange', function () {
                        const $element = $('.slick-active').find('.js-banner a.btn');
                        if ($element.length > 0) {
                            gtm.pushNewBannerImpressions($element.attr('data-internal-promotion'));
                        }
                    });

                    const $sliderDots = $el.siblings('.slider-dots');

                    const slickConfig = {
                        arrows: true,
                        appendDots: $sliderDots,
                        dots: true,
                        prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                        nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                        lazyLoad: 'progressive',
                        infinite: false,
                        touchThreshold: 500,
                        speed: 300,
                        responsive: [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    fade: $el.hasClass('js-fullwidth-slider-holder')
                                }
                            }
                        ]
                    };

                    if ($el.hasClass('js-sustainability-slider')) {
                        slickConfig.arrows = false;
                        slickConfig.centerMode = true;
                        slickConfig.centerPadding = '20%';
                        slickConfig.variableWidth = true;
                        slickConfig.mobileFirst = true;
                        slickConfig.responsive = [
                            {
                                breakpoint: 1023,
                                settings: 'unslick'
                            }
                        ];
                    }

                    if ($el.hasClass('js-pdp-scrub-slider')) {
                        const sliderPagerEl = document.querySelector('.js-slide-pager');
                        slickConfig.initialSlide = $('.js-pdp-scrub-slider .js-product-thumbnail').index($('.js-pdp-scrub-slider .js-initial'));
                        slickConfig.centerMode = true;
                        slickConfig.centerPadding = '20%';
                        slickConfig.focusOnSelect = true;
                        slickConfig.infinite = true;
                        slickConfig.speed = 1100;
                        slickConfig.cssEase = 'cubic-bezier(0.5, 0, 0, 1)';
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: {
                                    centerPadding: '17.5%'
                                }
                            }, {
                                breakpoint: 1024,
                                settings: {
                                    centerPadding: '27.5%'
                                }
                            }
                        ];

                        $el.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
                            const variantId = $(slick.$slides[nextSlide]).find('[data-variant-id]').data('variantId');
                            const swatch = $('.js-pdp-swatches-image[data-variation-id="' + variantId + '"]');
                            $el.toggleClass('block-zoom', currentSlide !== nextSlide);

                            if (!swatch.length) {
                                return false;
                            }

                            swatch.closest('.js-pdp-swatches-btn').trigger('click.swatch', {skipImage: false, eventLabel: 'pdp_slider_interaction'});
                        });

                        $el.on('afterChange', function(e, slick, currentSlide) {
                            sliderPagerEl.innerText = `${currentSlide + 1} / ${slick.$slides.length}`;
                            $el.trigger(events.onAfterChange, slick);
                        });
                    }

                    if ($el.hasClass('js-pdp-images-slider')) {
                        slickConfig.fade = true;
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: true
                                }
                            }
                        ];
                    }

                    if ($el.hasClass('js-fullwidth-slider-holder')) {
                        slickConfig.fade = true;
                    }

                    if ($el.hasClass('js-explanation-slider')) {
                        slickConfig.touchThreshold = 5;
                    }

                    if ($el.hasClass('js-product-slider-stacked') && $el.hasClass('product-main-slider')) {
                        slickConfig.responsive = [
                            {
                                breakpoint: 768,
                                settings: 'unslick'
                            }
                        ];
                    }

                    if ($el.hasClass('infinite-slider')) {
                        slickConfig.infinite = true;
                    }

                    if (!$el.parents('.js-alternative-code-example').length && !$el.hasClass('slick-initialized')) {
                        $el.slick(slickConfig);
                    }

                    if ($el.hasClass('product-main-slider')) {
                        const $sliderParent = $el.closest('.js-product-slider-steps').find('.js-product-slider-media-holder');

                        if ($sliderParent.find('.js-product-slider-image-holder').length) {
                            $sliderParent.find('.js-product-slider-image-holder:first-child').addClass('active');
                            $sliderParent.find('.js-product-slider-image-holder:first-child').lazy();

                            $el.on('afterChange', function(e, slick, currentSlide) {
                                $sliderParent.find('.js-product-slider-image-holder.active').removeClass('active');
                                $sliderParent.find('.js-product-slider-image-holder').eq(currentSlide).addClass('active');
                                $sliderParent.find('.js-product-slider-image-holder.active').lazy();
                                pushActiveSlideToDataLayer(false);
                            });
                        } else if ($sliderParent.find('.js-product-slider-media-single-image').length) {
                            $sliderParent.find('.js-product-slider-media-single-image').addClass('active');
                        }

                        equalHeight($el.find('.step-intro'), $el.find('.step-intro').length);
                    }

                    if ($el.hasClass('js-fullwidth-slider-holder')) {
                        $el.on('beforeChange', function() {
                            $('.js-responsive-bg', $el).each(function (idx, bgEl) {
                                const $bgEl = $(bgEl);

                                if (!$bgEl.attr('style')) {
                                    $bgEl.lazy();
                                }
                            });
                        });
                    }
                });
            });
        }
    };

    /**
     * Initializes the Content Grid Slider
     */
    this.contentGridSlider = function(){
        /* initialize content grid slick slider */
        if (def.$sliderContentGrid.length > 0) {
            $.each(def.$sliderContentGrid, function(i, el) {

                prepareDeferedImages(el);
                damHelper.updateImages(el);

                const $sliderBar = $(el).siblings(def.sliderBarClass);

                if ($(el).hasClass('slick-initialized')) {
                    return true;
                }

                // on init prepare and show the slider bar
                $(el).on('init', function(e, slick){
                    if (slick.slideCount > 1) {
                        initSliderBar($sliderBar, slick);
                    } else {
                        // delete slider bar if only 1 slide
                        // helps with animations
                        $(def.sliderBarClass).remove();
                    }
                });

                // on beforeChange move the slider indicator to the correct position
                $(el).on('beforeChange', function(e, slick, currentSlide, nextSlide){
                    updateSliderIndicator($sliderBar, slick, nextSlide);

                    $('.js-responsive-bg').each(function () {
                        if (!$(this).attr('style')) {
                            $(this).lazy();
                        }
                    });
                });

                if (isSmallView()) {
                    const $sliderDots = $(el).siblings('.slider-dots');

                    $(el).slick({
                        accessibility: true,
                        appendDots: $sliderDots,
                        dots: true,
                        arrows: false,
                        lazyLoad: 'progressive',
                        infinite: false,
                        touchThreshold: 500,
                        mobileFirst: true,
                        responsive: [
                            {
                                breakpoint: 1024,
                                settings: 'unslick'
                            }
                        ]
                    });
                }

            });
        }
    };

    /**
     * Initializes the Product List Slider
     */
    this.productListSlider = function() {
        const $sliders = $('.js-product-list-slider');

        $sliders.each(function(i, slider) {
            const $slider = $(slider);
            const $sliderBar = $slider.siblings(def.sliderBarClass);
            const $sliderDots = $slider.siblings('.slider-dots');

            prepareDeferedImages(slider);
            damHelper.updateImages(slider);

            if (isSmallView()) {
                $('.product-list-slider-item.text-item').remove();

                imagesLoaded($slider).on('done', function () {
                    equalHeight($slider.find('.js-product-tile-image').parent());
                });
            }

            $slider.on('beforeChange', function(e, slick, currentSlide, nextSlide) {
                updateSliderIndicator($sliderBar, slick, nextSlide);
            });

            $slider.on('init', function(e, slick) {
                if (slick.$dots) {
                    initSliderBar($sliderBar, slick);
                    bindSliderDragEvents($sliderBar, slick);
                }
            });

            $slider.slick({
                appendDots: $sliderDots,
                arrows: true,
                dots: true,
                draggable: true,
                infinite: false,
                touchThreshold: 500,
                lazyLoad: 'progressive',
                nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                rows: 0,
                slidesToShow: 5.3,
                slidesToScroll: 5,
                speed: 800,
                responsive: [
                    {
                        breakpoint: 1500,
                        settings: {
                            slidesToShow: 4.3,
                            slidesToScroll: 4
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 3.3,
                            slidesToScroll: 3
                        }
                    },
                    {
                        breakpoint: 1100,
                        settings: {
                            slidesToShow: 2.3,
                            slidesToScroll: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            arrows: false,
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                ]
            });
        });
    };

    /**
     * Initialize slider bar and indicator under the slider element
     *
     * @param {jQueryObject} $bar jQuery Object referencing the slider bar
     * @param {SlickObject} slick References the selected Slick Slider object
     */
    function initSliderBar($bar, slick) {
        const $indicator = $bar.children(def.sliderIndicatorClass);

        $bar.show();
        $indicator.width(slick.$dots.find('li').width());
    }

    /**
     * Attaches all the necessary events to be able to drag the slider indicator
     *
     * @param {jQueryObject} $bar The jQuery Object to attach the events too
     * @param {SlickObject} slick References the selected Slick Slider object
     */
    function bindSliderDragEvents($bar, slick) {
        const $indicator = $bar.children(def.sliderIndicatorClass);
        const $slick = slick.$slider;

        $indicator.data('slider-width', getTotalSlidesWidth($slick));
        $indicator.on('mousedown', onDragStart);
        $(document).on('mouseup', {$indicator: $indicator}, onDragEndBody);
        $(document).on('mousemove', {$indicator: $indicator}, onDragBody);
    }

    /**
     * Updates the slider indicator after a slide changed
     *
     * @param {jQueryObject} $bar jQuery Object referencing the slider bar
     * @param {SlickObject} slick References the selected Slick Slider object
     * @param {Integer} nextSlide Number of the next slide
     */
    function updateSliderIndicator($bar, slick, nextSlide) {
        // Exit early if we do not have any pager dots
        if (!slick.$dots || slick.$dots.length === 0) {
            return;
        }

        const $sliderBarIndicator = $bar.children(def.sliderIndicatorClass);
        const slidesToShow = slick.options.slidesToShow;
        const leftOfDots = slick.$dots.offset().left;
        const numDots = $('li', slick.$dots).length;

        // If we show more products on one slide, calculate the next pager dot. Otherwise use nextSlide
        const nextDot = (slidesToShow > 1) ? Math.min(Math.max(Math.floor(nextSlide / numDots), 0), numDots - 1) : nextSlide;

        // Grab the left position of the calculated next dot
        const leftOfSlide = slick.$dots.find('li:eq(' + nextDot + ')').offset().left;

        $sliderBarIndicator.css({
            left: leftOfSlide - leftOfDots
        });
    }
};

/**
 * Handles the MouseDown event
 *
 * @param {Event} e MouseDown event
 */
function onDragStart(e) {
    const $self = $(e.currentTarget);

    if ($self.parent().find('.cloned').length === 0) {
        const $clone = $self.clone().addClass('cloned');
        $self.parent().append($clone);
    }

    isDragging = true;
    dragStartX = e.pageX;
    dragTarget = $self;

    $self.addClass('is-dragging');
}

/**
 * Handles the MouseUp event
 *
 * @param {Event} e MouseUp event
 */
function onDragEndBody() {
    if (isDragging) {

        // Grab the correct scrollbar from the global var
        const $self = dragTarget;

        // Grab the correct clone
        const $indicatorClone = $self.siblings('.cloned');

        // Get the pager dot we want to trigger a click event on.
        const $triggerDot = $self.parent().next().find('li:eq(' + dragOverDot + ') button');

        // Reset everything for next drag event
        isDragging = false;
        dragStartX = 0;
        dragTarget = '';
        dragOverDot = -1;

        $self.removeClass('is-dragging');
        $indicatorClone.remove();
        $triggerDot.trigger('click');
    }
}

/**
 * Handles the MouseMove event
 *
 * @param {Event} e MouseMove event
 */
function onDragBody(e) {
    if (isDragging) {
        const $indicator = dragTarget;
        const $indicatorParent = $indicator.parent();
        const $indicatorClone = $indicator.siblings('.cloned');
        const leftClone = $indicatorClone.offset().left - $indicatorParent.offset().left;
        let leftIndicator = e.pageX - dragStartX + leftClone;
        const leftMax = $indicatorParent.width() - $indicator.width();

        // Set horizontal boundries
        leftIndicator = Math.min(Math.max(leftIndicator, 0), leftMax);

        // Move slider indicator
        $indicator.css({
            left: leftIndicator
        });

        updateSliderDots($indicator);
    }
}

/**
 * Updates the Slick Slider currentSlide property with the one that is closest
 * to the indicator
 *
 * @param {jQueryObject} $indicator References the current slide indicator
 */
function updateSliderDots($indicator) {
    const offset = $indicator.parent().offset().left;
    const dots = $indicator.parent().next().find('li');
    const left = $indicator.offset().left;
    const n = dots.length;

    for (let i = 0; i < n; i++) {
        const $el = $(dots[i]);
        const dotCenter = left + offset + ($el.width() / 2);

        // Determine the pager dot the clone is dragged over and store the index
        if (dotCenter >= $el.offset().left && dotCenter <= $el.offset().left + $el.width() && dragOverDot !== i) {
            dragOverDot = i;
            return;
        }
    }
}

/**
 * Calculates the total width of all the visible slides in the slider
 *
 * @param {SlickObject} slick References the selected Slick Slider object
 * @returns {Float} The calculated width
 */
function getTotalSlidesWidth($slick) {
    const items = $slick.find('.product-list-slider-item');
    const n = items.length;
    let width = 0;

    for (let i = 0; i < n; i++) {
        width += $(items[i]).outerWidth(true);
    }

    return width;
}

function pushActiveSlideToDataLayer(checkViewPort) {
    const allSlidesTiles = $('.js-product-main-slider .js-product-tile');

    if (!allSlidesTiles.length) {
        return;
    }

    const pushedClass = 'js-data-layer-list-pushed';
    let productTileToPush = $('.js-product-main-slider .slick-active .js-product-tile:not(.' + pushedClass + ')');

    if (!productTileToPush.length) {
        return;
    }

    productTileToPush = productTileToPush.eq(0);

    if (!checkViewPort || isInViewport(productTileToPush, false)) {
        const datalayerProduct = $('.js-product-tile-datalayer-product', productTileToPush);

        if (datalayerProduct.length > 0) {
            const productData = JSON.parse(datalayerProduct.val());

            if (productData){
                gtm.pushProductTileView(productData);
            }
        }
        productTileToPush.addClass(pushedClass);
    }
}

function zoomedInWindow() {
    if (window.outerWidth > 1024 && !$('body').hasClass('zoomed-in')) {
        $('body').addClass('zoomed-in');
    }
}

function simpleTextBlockSlider() {
    const $sliderSimpleTextBlock = $('.js-text-block-slider');

    $sliderSimpleTextBlock.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                touchThreshold: 500,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            autoplay: true,
                            speed: 1000,
                            autoplaySpeed: 2000
                        }
                    }
                ]
            });
        }
    });
}

function headerUspSlider() {
    $('.js-header-usp-slider').each(function () {
        $(this).slick({
            accessibility: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 2900,
            draggable: false,
            fade: true,
            mobileFirst: true,
            pauseOnFocus: false,
            pauseOnHover: false,
            speed: 500,
            swipe: false,
            touchMove: false
        });
    });
}

function shippinInfoSlider() {
    const $sliderShippingInfo = $('.js-shipping-info-slider');

    $sliderShippingInfo.each(function () {
        const $this = $(this);

        $this.slick({
            accessibility: true,
            dots: true,
            arrows: false,
            infinite: true,
            mobileFirst: true,
            touchThreshold: 500,
            fade: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        autoplay: true,
                        speed: 1000,
                        autoplaySpeed: 2000
                    }
                }
            ]
        });
    });
}

function conceptHighlightBlockSlider() {
    const $conceptHighlightBlock = $('.js-concept-highlight-block-slider');

    if ($(window).width() < 768) {
        $conceptHighlightBlock.each(function () {
            const $this = $(this);

            $this.on('beforeChange', function() {
                advent.pushAdventDataLayerDataWithActiveProductImageSlide('feature slider');
            });

            $this.on('init', function() {
                responsiveBg.init();
            });

            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                touchThreshold: 500,
                fade: true
            });
        });
    }
}

function writeACardSlider() {
    const $writeACardBlock = $('.js-write-a-card-slider');

    if ($writeACardBlock.hasClass('card-slick-initialized')) {
        return;
    }

    $writeACardBlock.addClass('card-slick-initialized');
    $writeACardBlock.imagesLoaded(function() {
        $writeACardBlock.slick({
            accessibility: true,
            dots: true,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            touchThreshold: 500,
            prevArrow : '<div class="slick-prev"><button type="button" class="icon icon-arrow3--left slider-button slider-prev"></button></div>',
            nextArrow : '<div class="slick-next"><button type="button" class="icon icon-arrow3--right slider-button slider-next"></button></div>',
            lazyLoad: 'progressive',
            speed: 800,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        arrows: true
                    }
                }
            ]
        });
    });
}

function uspSlider() {
    const $uspSlider = $('.js-usp-slider');

    $uspSlider.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                dots: true,
                arrows: false,
                infinite: true,
                mobileFirst: true,
                fade: false,
                touchThreshold: 500,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            autoplay: true,
                            speed: 1000,
                            autoplaySpeed: 4000
                        }
                    }
                ]
            });
        }
    });
}

function tilesSlider() {
    const $threeFilterSlider = $('.js-filter-module-slider');

    $threeFilterSlider.each(function () {
        const $this = $(this);

        $this.slick({
            dots: false,
            arrows: false,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 1.5,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: 'unslick'
                }
            ]
        });
    });
}

function magazineBlockSlider() {
    const $magazineBlockSlider = $('.js-magazine-tile-slider');

    $magazineBlockSlider.each(function () {
        const $this = $(this);

        if ($(window).width() < 768) {
            if (!$this.parents('.js-alternative-code-example').length) {
                $this.slick({
                    accessibility: true,
                    dots: true,
                    arrows: false,
                    infinite: true,
                    touchThreshold: 500,
                    mobileFirst: true,
                    fade: true
                });
            }
        }
    });
}

function twoTileTextBlockSlider() {
    const $twoTileTextBlockSlider = $('.js-two-tile-text-block-slider');

    $twoTileTextBlockSlider.each(function () {
        const $this = $(this);

        if (!$this.parents('.js-alternative-code-example').length) {
            $this.slick({
                accessibility: true,
                arrows: true,
                prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                infinite: false,
                fade: true,
                touchThreshold: 500,
                speed: 800
            });
        }
    });
}

function threeTilesBenefits() {
    const $sliderShippingInfo = $('.js-three-tiles-benefits');

    $sliderShippingInfo.each(function () {
        const $this = $(this);

        if ($(window).width() < 768) {
            $this.slick({
                arrows: false,
                infinite: false,
                centerMode: true
            });
        }
    });
}

function giftopenBoxes() {
    $('.js-giftopen-boxes').each(function () {
        $(this).slick({
            arrows: false,
            centerPadding: '10%',
            centerMode: true,
            mobileFirst: true,
            infinite: false,
            responsive: [{
                breakpoint: 769,
                settings: 'unslick'
            }]
        });
    });
}

function timelineComponentSlider() {
    const $timelineComponentBlock = $('.js-timeline-component-slider');

    $timelineComponentBlock.each(function () {
        const $this = $(this);
        const $progressBar = $('.timeline-progress');
        let slidesNum = 0;

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (slick.slideCount === 8) {
                slidesNum = 4;
            } else if (slick.slideCount === 7) {
                slidesNum = 3;
            } else if (slick.slideCount === 6) {
                slidesNum = 2;
            } else if (slick.slideCount === 5) {
                slidesNum = 1;
            }

            const calc = isSmallView() ? (nextSlide / (slick.slideCount - 1)) * 100 : (nextSlide / slidesNum) * 100;
            $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
        });

        $this.on('init', function(event, slick){
            const slideNum = isSmallView() ? [4,5,6,7] : [1,2,3,4];

            if ($timelineComponentBlock.hasClass('rtl')) {
                if (slick.slideCount === 5) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[0]);
                    }, 0);
                } else if (slick.slideCount === 6) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[1]);
                    }, 0);
                } else if (slick.slideCount === 7) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[2]);
                    }, 0);
                } else if (slick.slideCount === 8) {
                    setTimeout(function () {
                        $('.js-timeline-component-slider').slick('slickGoTo', slideNum[3]);
                    }, 0);
                }
            }
        });

        $this.slick({
            accessibility: true,
            rows: 0,
            draggable: false,
            arrows: true,
            prevArrow : $('.timeline-prev'),
            nextArrow : $('.timeline-next'),
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1250,
                    settings: {
                        slidesToShow: 3.5
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: 3
                    }
                },
                {
                    breakpoint: 950,
                    settings: {
                        slidesToShow: 2.6
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: 500,
                    settings: {
                        slidesToShow: 1,
                        centerMode: true,
                        draggable: true
                    }
                }
            ]
        });

    });
}

function refillImpactSlider () {
    const $refillImpactSlider = $('.js-refill-impact-slider');

    $refillImpactSlider.each(function () {
        const $this = $(this);
        const $progressBar = $('.refill-impact-progress');

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const calc = ((nextSlide) / (slick.slideCount - 1)) * 100;
            $progressBar.css('background-size', calc + '% 100%').attr('aria-valuenow', calc);
        });

        if ($(window).width() < 768) {
            if (!$this.parents('.js-refill-impact-slider').length) {
                $this.slick({
                    accessibility: true,
                    arrows: true,
                    centerMode: true,
                    dots: false,
                    fade: false,
                    infinite: false,
                    mobileFirst: true,
                    nextArrow : $('.slick-next'),
                    prevArrow : $('.slick-prev'),
                    slidesToShow: 1.3,
                    touchThreshold: 500,
                    variableWidth: true
                });
            }
        }
    });
}

function comparisonBlockSlider () {
    const $comparisonBlockSlider = $('.js-comparison-block');
    const $comparisonLine = $('.advent-comparison-line');

    $comparisonBlockSlider.each(function () {
        const $this = $(this);

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            if (nextSlide == 0) {
                $comparisonLine.css('left','0%');
            } else if (nextSlide == 1) {
                $comparisonLine.css('left','33.33%');
            } else if (nextSlide == 2) {
                $comparisonLine.css('left','66.66%');
            }
        });

        if ($(window).width() < 1024) {
            if (!$this.parents('.js-comparison-block').length) {
                $this.slick({
                    accessibility: true,
                    arrows: false,
                    centerMode: true,
                    draggable: true,
                    dots: false,
                    fade: false,
                    infinite: false,
                    mobileFirst: true,
                    slidesToShow: 1.3,
                    touchThreshold: 500,
                    variableWidth: true
                });
            }
        }
    });
}

function allAdventGiftsSlider() {
    const $allAdventGiftsSlider = $('.all-advent-gifts-slider');
    const $showSlidePosition = $('.current-position');

    $allAdventGiftsSlider.each(function () {
        const $this = $(this);

        $this.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            const calc = ((nextSlide) / (slick.slideCount)) * 800;
            $showSlidePosition.css('transform', 'translateX(' + calc + '%)');
        });
        if ($(window).width() > 700) {
            $this
                .slick({
                    accessibility: true,
                    arrows: true,
                    draggable: true,
                    prevArrow : '<div class="slick-prev"><button type="button" class="btn--stripped icon-arrow3--left slider-button slider-prev"></button></div>',
                    nextArrow : '<div class="slick-next"><button type="button" class="btn--stripped icon-arrow3--right slider-button slider-next"></button></div>',
                    slidesToShow: 3.25,
                    slidesToScroll: 3,
                    infinite: false,
                    variableWidth: false,
                    responsive: [
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 2.25,
                                slidesToScroll: 2
                            }
                        }
                    ]
                });
        }
        if (!isDesktopView()) {
            return;
        } else {
            $('.all-advent-gifts').on('wheel', (function(e) {
                e.preventDefault();

                if (e.originalEvent.deltaY < 0) {
                    $allAdventGiftsSlider.slick('slickPrev');
                } else {
                    $allAdventGiftsSlider.slick('slickNext');
                }
            }));
        }
    });
}

function talismanUspSlider() {
    const $talismanUspSlider = $('.js-talisman-usp-slider');

    $talismanUspSlider.each(function () {
        const $this = $(this);

        if ($(window).width() <= 1024) {
            if (!$this.parents('.js-talisman-usp-slider').length) {
                $this.slick({
                    accessibility: true,
                    autoplay: true,
                    arrows: false,
                    dots: true,
                    draggable: true,
                    infinite: true,
                    mobileFirst: true,
                    slidesToShow: 1,
                    speed: 800,
                    touchThreshold: 500
                });
            }
        }
    });
}

/*
* Initialization
* */
function init() {
    const Slick = new SlickControl();

    initDefaultSlider(Slick);

    if ($('.js-grid-slider').length > 0){
        Slick.contentGridSlider();

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', function () {
            zoomedInWindow();
        });
    }

    if ($('.js-text-block-slider').length > 0) {
        simpleTextBlockSlider();
    }

    if ($('.js-header-usp-slider').length > 0) {
        headerUspSlider();
    }

    if ($('.js-shipping-info-slider').length > 0) {
        shippinInfoSlider();
    }

    if ($('.js-product-list-slider').length > 0) {
        Slick.productListSlider();

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', function () {
            zoomedInWindow();
        });
    }

    if ($('.js-concept-highlight-block').length > 0) {
        conceptHighlightBlockSlider();
    }

    if ($('.js-refill-impact-slider').length > 0) {
        refillImpactSlider();
    }

    if (!$('.js-usp-slider').hasClass('slick-initialized')) {
        uspSlider();
    }

    if ($('.js-filter-module-slider').length > 0) {
        tilesSlider();
    }

    if ($('.js-write-a-card-slider').length > 0) {
        writeACardSlider();
    }

    if (!$('.js-two-tile-text-block-slider').hasClass('slick-initialized')) {
        twoTileTextBlockSlider();
    }

    if (!$('.js-magazine-tile-slider').hasClass('slick-initialized')) {
        magazineBlockSlider();
    }

    if (!$('.js-three-tiles-benefits').hasClass('slick-initialized')) {
        threeTilesBenefits();
    }

    if (!$('.js-giftopen-boxes').hasClass('slick-initialized')) {
        giftopenBoxes();
    }

    if ($('.js-timeline-component-slider').length > 0) {
        timelineComponentSlider();
    }

    if ($('.js-comparison-block').length > 0) {
        comparisonBlockSlider();
    }

    if ($('.all-advent-gifts-slider').length > 0) {
        allAdventGiftsSlider();
    }

    if ($('.js-talisman-usp-slider').length > 0) {
        talismanUspSlider();
    }

    $(window).off('scroll.slickSlider').on('scroll.slickSlider', debounce(function () {
        pushActiveSlideToDataLayer(true);
    }, 300));

    $('.js-explanation-slider .js-add-to-cart, .js-explanation-slider .js-explanation-slider-secondary-button').each(function() {
        const $this = $(this);
        $this.on('click', function() {
            const buttonText = this.innerText.toLowerCase();
            const slider = $(this).parents('.js-explanation-slider')[0];
            const productName = $(slider).find('.js-slider-product-title')[0].innerText;
            greenfriday.pushDataLayerData('homepage', buttonText, productName);
        });
    });
}

const initDefaultSlider = (Slick) => {
    Slick = Slick || new SlickControl();

    if ($('.js-slider').length > 0) {
        Slick.defaultSlick(true);

        // sometimes the PDP slider is init before the images are ready
        // this should reinit the necessary sliders on window load
        if ($('.js-pdp-images-slider, .js-pdp-scrub-slider').length > 0) {
            if (!$('.js-pdp-main').hasClass('giftset-pdp-main-container')) {
                $(window).on('load', function() {
                    pushActiveSlideToDataLayer(true);
                });
            }
        }

        //fix for zoomed in desktop view
        zoomedInWindow();

        $(window).off('resize.slider').on('resize.slider', debounce(function () {
            zoomedInWindow();
        }, 200));
    }
};

module.exports = {
    init: init,
    writeACardSlider: writeACardSlider,
    initDefaultSlider: initDefaultSlider
};

},{"./advent":269,"./dam/dam-helper":419,"./greenfriday":435,"./modules/google":453,"./modules/helpers/debounce":458,"./modules/helpers/equalHeight":459,"./modules/helpers/isDesktopView":463,"./modules/helpers/isInViewport":464,"./modules/helpers/isSmallView":469,"./modules/helpers/prepareDeferedImages":474,"./responsive-background":588,"imagesloaded":48}],599:[function(require,module,exports){
(function (Buffer){(function (){
'use strict';

const html2Canvas = require('html2canvas');
const damHelper = require('../dam/dam-helper');
const singlePageCheckout = require('../pages/checkout/singlepagecheckout');
const imageTypes = {
    PRODUCT: 'product',
    ORDEROVERVIEW: 'orderoverview',
    GIFT: 'gift'
};

const init = () => {
    $(document).off('click.socialcommerce').on('click.socialcommerce', '.js-social-commerce-button', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const $this = $(e.currentTarget);
        if ($this.hasClass('button-loading')) {
            return;
        }
        const data = $this.data('social-commerce');
        if (!data) {
            return;
        }
        bindLineItemData($this, data);

        toggleSpinner($this, true);

        handleImageSending(data, $this);
    });

    $(document).on('click', '.js-social-commerce-send-link-button', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const $this = $(e.target);
        if ($this.hasClass('button-loading')) {
            return;
        }
        toggleSpinner($this, true);

        const $activeStep = $(document).find('.checkout-step-btn.current');

        if ($activeStep.hasClass('js-step-1')) {
            if (singlePageCheckout.submitInformationForm(e, null, null, sendCheckoutLink) == false) {
                sendCheckoutLink($this, 1);
            }
        } else if ($activeStep.hasClass('js-step-2')) {
            sendCheckoutLink($this, 2);
        } else if ($activeStep.hasClass('js-step-3')) {
            sendCheckoutLink($this, 3);
        }
    });

    $(document).on('click', '.js-social-commerce-cancel-order', function () {
        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: window.Resources.SC_CANCEL_ORDER_HEADER,
                headingLarge: true,
                headingNarrow: true
            },
            paragraphs: [{
                text: window.Resources.SC_CANCEL_ORDER_TEXT,
                textColorBlack: true,
                textWidthLimiter: true
            }],
            ctaHolder: {},
            buttons: [{
                    type: 'btn btn-full-wdth',
                    label: window.Resources.SC_CANCEL_ORDER_BUTTON_NO,
                    shouldCloseModal: true
                },
                {
                    type: 'btn btn-full-wdth btn--secondary',
                    label: window.Resources.SC_CANCEL_ORDER_BUTTON_YES,
                    eventName: 'onSoSCancelOrderButtonClick',
                    shouldCloseModal: true
                }
            ],
            closeElement: {
                shouldCloseModal: true
            },
            modalSmall: true,
            centerOnMobile: true
        });
    });

    window.eventBus.$on('onSoSCancelOrderButtonClick', function () {
        $.ajax({
            url: Urls.cancelOrder,
        }).done(function () {
            window.location.href = window.Urls.cartShow;
        });
    });
};

const sendCheckoutLink = ($this, step) => {
    const promise = $.Deferred();

    const socialCommerceCheckoutLinkConfig = $this.data('social-commerce-checkout-link-config');

    if (socialCommerceCheckoutLinkConfig && socialCommerceCheckoutLinkConfig.shouldSendOrderOverview) {
        handleImageSending(socialCommerceCheckoutLinkConfig.data, $this)
                .then(() => { promise.resolve(); });
    } else {
        promise.resolve();
    }

    const currentUrl = JSON.parse(JSON.stringify({
        url: window.location.href,
        step: step
    }));
    // Always send checkout link.
    $.when(promise).always(() => {
        $.ajax({
            url: Urls.getCheckoutLink,
            data: currentUrl
        }).done(function (response) {
            if (response.error) {
                toggleSpinner($this, false);
                errorView.show(response, () => {
                    sendCheckoutLink($this, step);
                });
                return;
            }

            toggleSpinner($this, true, true);
        });
    });
};

const handleImageSending = (data, $this) => {
    // There are a lot of asyncronous calls on this flow and $.ajax resolves as soon as the request is done.
    // so using a Deferred to handle the flow.
    const promise = $.Deferred();

    $.ajax({
        url: getUrl(data),
        data: data
    }).done((responseHTML) => {
        const $info = $(responseHTML).filter(getCssClass(data));
        if (!$info || !$info.length) {
            toggleSpinner($this, false);
            return;
        }

        takePictureAndUpload($this, $info[0], data.pid, data.configurationId, getImageType(data))
            .then(() => { promise.resolve(); });
    });

    return promise;
};

const getCssClass = (data) => {
    if (data.isOrderOverview) {
        return '.js-social-commerce-cart-info';
    }
    return '.js-social-commerce-product-info';
};

const getUrl = (data) => {
    if (data.isOrderOverview) {
        return Urls.getCartViewToCapture;
    }
    return Urls.getViewToCapture;
};

const getImageType = (data) => {
    if (data.isOrderOverview) {
        return imageTypes.ORDEROVERVIEW;
    }
    return data.isGift ? imageTypes.GIFT : imageTypes.PRODUCT;
};

const toggleSpinner = (button, showSpinner, shouldShowCheckmark) => {
    if (!button) {
        return;
    }

    if (button && $.isFunction(button)) {
        button(showSpinner, shouldShowCheckmark);
        return;
    }

    const $socialCommerceButtonSpinner = $('.js-social-commerce-spinner', button);
    $socialCommerceButtonSpinner.removeClass('spinner-visible');
    button.removeClass('send-icon-visible');
    button.removeClass('button-loading');
    if (!showSpinner) {
        return;
    }

    button.addClass('button-loading');
    if (shouldShowCheckmark) {
        button.addClass('send-icon-visible');
    } else {
        $socialCommerceButtonSpinner.addClass('spinner-visible');
    }
    setTimeout(function () {
        toggleSpinner(button, false, shouldShowCheckmark);
    }, 30000);
};

const takePictureAndUpload = (button, element, productId, configurationId, imageType) => {
    const options = {
        allowTaint: true,
        useCORS: true,
        logging: true,
        scale: 2
    };

    element = document.body.appendChild(element);
    damHelper.updateImages(element);

    const promise = $.Deferred();
    $(element).imagesLoaded().always(() => {
         const canvasPromise = html2Canvas(element, options)
            .then(canvas => {
                element.remove();
                const dataUrl = canvas.toDataURL();
                const strippedDataUrl = dataUrl.substr(dataUrl.indexOf(',') + 1); // strip the begining part of dataUrl "data:image/png;base64,"
                const formData = new FormData();
                formData.append('imageContent', new Blob([Buffer.from(strippedDataUrl, 'base64')], { /* eslint-disable-line */
                    type: 'image/jpeg'
                }));
                formData.append('productId', productId);
                formData.append('imageType', imageType);
                if (configurationId) {
                    formData.append('configurationId', configurationId);
                }
                return uploadImageAndSendDataToMulesoft(button, formData);
            });

        canvasPromise.finally(() => { promise.resolve(); });
    });

    return promise;
};

const uploadImageAndSendDataToMulesoft = (button, formData) => {
    return $.ajax({
        url: Urls.uploadImageAndSendDataToMulesoft,
        type: 'POST',
        data: formData,
        processData: false,
        contentType: false,
    }).done(function (response) {
        if (!response || response.error) {
            toggleSpinner(button, false);
            errorView.show(response, () => {
                uploadImageAndSendDataToMulesoft(button, formData);
            });
            return;
        }

        toggleSpinner(button, true, true);
    });
};

const errorView = {
    show: (data, callbackFunction) => {
        const firstButtonData = {
            type: 'btn btn-full-wdth',
            label: data.firstButtonLabel,
            shouldCloseModal: true,
            eventName: data.closePopupEvent || 'onCloseElementClick'
        };
        let secondButtonData = null;
        if (data.secondButtonLabel) {
            firstButtonData.eventName = 'onResendLinkButtonClick';
            secondButtonData = {
                type: 'link link--large',
                label: data.secondButtonLabel,
                shouldCloseModal: true
            };
        }
        const closePopupEvent = data.closePopupEvent || 'onCloseElementClick';

        const buttons = [firstButtonData, secondButtonData].filter(Boolean);

        window.eventBus.$emit('shouldOpenModal', {
            resources: {
                heading: data.title,
                headingLarge: true,
                headingNarrow: true
            },
            paragraphs: [{
                text: data.errorMessage,
                textColorBlack: true
            }],
            closeElement: {
                eventName: closePopupEvent,
                shouldCloseModal: true
            },
            row: {
                rowWidth: 'row-full-width'
            },
            modalSmall: true,
            ctaHolder: {},
            buttons: buttons,
            centerOnMobile: true
        });

        window.eventBus.$once('onResendLinkButtonClick', () => {
            if (callbackFunction && $.isFunction(callbackFunction)) {
                callbackFunction();
            }
        });

        window.eventBus.$once('onSwitchSessionModalClick', () => {
            window.close();
        });
    }
};

const updateCustomerLastUrl = () => {
    const isSocialCommerceEnabled = !!$('.js-social-commerce-banner').length;
    if (!isSocialCommerceEnabled) {
        return;
    }

    $.ajax({
        url: Urls.saveCustomerUrl,
        type: 'POST',
        data: {
            customerLastUrl: location.href
        }
    });
};

const bindLineItemData = (target, socialCommerceData) => {
    const $lineItemRow = target.closest('.js-cart-row');
    if (!$lineItemRow.length) {
        return;
    }

    socialCommerceData.lineItemUuid = $lineItemRow.data('uuid');
};

const showSwitchSessionModal = () => {
    const params = {
        firstButtonLabel: window.Resources.SC_SWITCH_SESSION_BUTTON,
        title: window.Resources.SC_SWITCH_SESSION_HEADER,
        errorMessage: window.Resources.SC_SWITCH_SESSION_TEXT,
        closePopupEvent: 'onSwitchSessionModalClick'
    };

    errorView.show(params);
};

module.exports = {
    init: init,
    handleImageSending: handleImageSending,
    errorView: errorView,
    updateCustomerLastUrl: updateCustomerLastUrl,
    showSwitchSessionModal: showSwitchSessionModal
};

}).call(this)}).call(this,require("buffer").Buffer)

},{"../dam/dam-helper":419,"../pages/checkout/singlepagecheckout":528,"buffer":38,"html2canvas":46}],600:[function(require,module,exports){
'use strict';

const inventory = require('./');

const cartInventory = {
    setSelectedStore: function (storeId) {
        const $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address')
            .data('storeId', storeId)
            .attr('data-store-id', storeId)
            .html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability')
            .data('status', storeStatus)
            .attr('data-status', storeStatus)
            .text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function (selectedStore) {
        const self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function (value, storeId) {
        // set loading state
        $('.item-delivery-options')
            .addClass('loading')
            .children().hide();

        const data = {
            plid: this.uuid,
            storepickup: (value === 'store' ? true : false)
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function () {
                // remove loading state
                $('.item-delivery-options').removeClass('loading').children().show();
            }
        });
    },
    init: function () {
        const self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            const selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            const selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":601}],601:[function(require,module,exports){
'use strict';

const _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    appendParamsToUrl = require('../modules/util/appendParamsToUrl');

const newLine = '\n';

const storeTemplate = function (store, selectedStoreId, selectedStoreText) {
    return [
        '<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">',
        '    <p class="store-address">',
        '        ' + store.address1 + '<br/>',
        '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode,
        '    </p>',
        '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>',
        '    <button class="select-store-button" data-store-id="' + store.storeId + '"' +
        (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>',
        '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE),
        '    </button>',
        '</li>'
    ].join(newLine);
};

const storeListTemplate = function (stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-container">',
            '<ul class="store-list">',
            _.map(stores, function (store) {
                return storeTemplate(store, selectedStoreId, selectedStoreText);
            }).join(newLine),
            '</ul>',
            '</div>',
            '<div class="store-list-pagination">',
            '</div>'
        ].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

const zipPromptTemplate = function () {
    return [
        '<div id="preferred-store-panel">',
        '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>',
        '</div>'
    ].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
const validateZipCode = function (zipCode) {
    const regexes = {
            canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
            usa: /^\d{5}(-\d{4})?$/
        };
    let valid = false;
    if (!zipCode) { return; }
    _.each(regexes, function (re) {
        const regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

const storeinventory = {
    zipPrompt: function (callback) {
        const self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function () {
                        const zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function () {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function (pid) {
        return TPromise.resolve($.ajax({
            url: appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function (options) {
        const self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function () {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function () {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        const storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) {
                            return;
                        }
                        $('.store-list .store-tile.selected').removeClass('selected')
                            .find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText)
                            .closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function (zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function () {
        const $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":422,"../modules/util/appendParamsToUrl":480,"lodash":208,"promise":217}],602:[function(require,module,exports){
'use strict';

const _ = require('lodash'),
    inventory = require('./');

const newLine = '\n';

const pdpStoreTemplate = function (store) {
    return [
        '<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">',
        '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode +
        ' ' + store.postalCode + '</div>',
        '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>',
        '</li>'
    ].join(newLine);
};

const pdpStoresListingTemplate = function (stores) {
    if (stores && stores.length) {
        return [
            '<div class="store-list-pdp-container">',
            (stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : ''),
            '    <ul class="store-list-pdp">',
            _.map(stores, pdpStoreTemplate).join(newLine),
            '    </ul>',
            '</div>'
        ].join(newLine);
    }
};

const storesListing = function (stores) {
    // list all stores on PDP page
    if ($('.store-list-pdp-container').length) {
        $('.store-list-pdp-container').remove();
    }
    $('.availability-results').append(pdpStoresListingTemplate(stores));
};

const productInventory = {
    setPreferredStore: function (storeId) {
        User.storeId = storeId;
        $.ajax({
            url: Urls.setPreferredStore,
            type: 'POST',
            data: {storeId: storeId}
        });
    },
    productSelectStore: function () {
        const self = this;
        inventory.getStoresInventory(this.pid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: User.storeId,
                selectedStoreText: Resources.PREFERRED_STORE,
                continueCallback: storesListing,
                selectStoreCallback: self.setPreferredStore
            });
        }).done();
    },
    init: function () {
        const $availabilityContainer = $('.availability-results'),
            self = this;
        this.pid = $('input[name="pid"]').val();

        $('#product-content .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.productSelectStore();
                });
            } else {
                self.productSelectStore();
            }
        });

        if ($availabilityContainer.length) {
            if (User.storeId) {
                inventory.getStoresInventory(this.pid).then(storesListing);
            }

            // See more or less stores in the listing
            $availabilityContainer.on('click', '.stores-toggle', function (e) {
                e.preventDefault();
                $('.store-list-pdp .store-list-item').toggleClass('visible');
                if ($(this).hasClass('collapsed')) {
                    $(this).text(Resources.SEE_LESS);
                } else {
                    $(this).text(Resources.SEE_MORE);
                }
                $(this).toggleClass('collapsed');
            });
        }

    }
};

module.exports = productInventory;

},{"./":601,"lodash":208}],603:[function(require,module,exports){
'use strict';

const debounce = require('./modules/helpers/debounce');
const gtm = require('./modules/google').tagManager;

const tabsHolder = '.js-tabs-holder';
const tabButton = '.js-tab-item';
const tabLine = '.js-tab-line';
const tabContent = '.js-tab-content';
const tabExpandingContent = '.js-tab-expanding-content';
const windowTablet = $(window).width() > 767 & $(window).width() < 1024;

/**
 * @description make first tab and first tab content selected on page load
**/
function onLoadTabs() {
    if ($(tabsHolder).length) {
        $(tabsHolder).each(function () {
            const $this = $(this);
            const $firstTab = $this.find('.js-tabs li:first');

            $('.js-tab-content:first').addClass('active').removeAttr('aria-hidden');
            $firstTab.find(tabButton).addClass('selected');
            ingredientsExpand();
        });
    }
}

function tabsAndAccordiansContent() {
    $('.js-tab-content-inner').each(function() {
        $(this).html($(this).html().trim());
    });
    $('.js-accordion-content').each(function(){
        $(this).html($(this).html().trim());
    });
}

/**
 * @description show / hide tab content
**/
function tabsToggle() {
    $(tabButton).on('click', function (e, shouldSkipDataLayerPush) {
        const $this = $(this);
        const $parent = $this.parents(tabsHolder);
        const $tabs = $parent.find('.js-tabs');
        const thisIndex = $this.parent().index();
        const thisWidth = $this.width();
        const tabsPosition = $tabs.position().left;
        const thisPosition = $this.parent().position().left;
        const thisCorrectedPosition = -1 * tabsPosition + thisPosition;

        if (!$this.hasClass('selected')) {
            if (!shouldSkipDataLayerPush) {
                gtm.pushPDPTabsEvent($this, tabsHolder);
            }
            if (tabsPosition === 0) {
                $parent.find(tabLine).css({
                    'left' : thisPosition,
                    'width' : thisWidth
                });
            } else {
                $parent.find(tabLine).css({
                    'left' : thisCorrectedPosition,
                    'width' : thisWidth
                });
            }

            $parent.find(tabContent).removeClass('active').attr('aria-hidden', 'true');
            $parent.find('.js-tab-content:eq(' + thisIndex + ')').stop().addClass('active').removeAttr('aria-hidden');

            $parent.find(tabButton).removeClass('selected');
            $this.addClass('selected');
        }
    });

    $(document).on('keyup', tabButton, function(){
        if (event.keyCode == 13){
            $(this).click();
        }
    });
}

/**
 * @description check if there is more content for ingredients tab content
**/
function ingredientsExpand() {
    if ($(tabExpandingContent).length) {
        $(tabExpandingContent).each(function () {
            const $this = $(this);
            const boxHeight = $this.outerHeight();
            const parentHeight = $this.parent().outerHeight() + 10;

            if (boxHeight > parentHeight) {
                $this.parents('.js-ingredients-tab-content').addClass('hidden-content');
            }
        });
    }
}

/**
 * @description read more / show less in ingredients tab content
**/
function ingredientsToggle() {
    $('.js-toggle-tab-ingredients').on('click', function () {
        if (!$(this).hasClass('active')) {
            $(this).addClass('active');
            $(this).parent('.js-ingredients-tab-content').find('.js-ingredient-tab-content-inner').css('max-height', 5000);
            $(this).parent('.js-ingredients-tab-content').css('height', 'auto');
        } else {
            $(this).removeClass('active');
            $(this).parent('.js-ingredients-tab-content').find('.js-ingredient-tab-content-inner').css('max-height', '');
            if (windowTablet) {
                $('html, body').animate({scrollTop: ($(this).parents('.js-tabs-holder').offset().top)}, 600);
            }
        }
    });
}

/**
 * @description Initialize block
 */
function initBlock() {
    onLoadTabs();
    tabsToggle();
    tabsAndAccordiansContent();
    ingredientsToggle();
}

/**
 * @description Initialize event handlers for the tabs
 */

function initializeEvents() {
    if ($(tabsHolder).length || $(tabExpandingContent).length) {
        $(window).resize(debounce(function () {
            ingredientsExpand();
        }, 200));
    }
}

const tabs = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = tabs;

},{"./modules/google":453,"./modules/helpers/debounce":458}],604:[function(require,module,exports){
'use strict';

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    const url = 'https://www.howsmyssl.com/a/check';
    const cookieName = 'dw_TLSWarning';
    const cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    const message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    const userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    const badBrowsers = ['MSIE 6.0','MSIE 7.0','MSIE 8.0','MSIE 9.0','MSIE 10.0',
                       'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3',
                       'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({url: Urls.TLSBadTLS});
        }
    }

    function reportBadBrowser () {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({url: Urls.TLSBadBrowser});
    }

    for (let i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const tokens = cookies[i].split('=');
        const cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * @function setCookie
 *
 * @param {string} key - The cookie name
 * @param {string} value - The cookie value
 * @param {integer} minutes - The number of minutes to expire the cookie
 **/
function setCookie (key, value, minutes) {
    const date = new Date();
    date.setTime(date + (minutes * 60 * 1000));

    document.cookie = key + '=' + value + '; expires=' + date.toGMTString() + '; path=/';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{}],605:[function(require,module,exports){
'use strict';

const ajax = require('./modules/ajax');
const scrollHelper = require('./modules/helpers/scroll');
const damHelper = require('./dam/dam-helper');

function initEvents(){
    // close flyouts when clicking the modal overlay or the flyout close button
    $(document).on('click touchstart', '.js-modal-overlay, .js-close-toaster', function(){
        closeToasters();
    });

    $('.js-close-toaster').on('keyup', function(e){
        if (e.which == 13) {
            // on enter close the flyout
            closeToasters();
        }
    });
}

/**
 * @function
 * @description General open flyout function
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function open(params){
    if (params.target) {
        $(params.target).show();

        // add timeout to preserve css animation
        setTimeout(function() {
            $(params.target).addClass('open');

            // show modal overlay
            toaster.def.$modalOverlay.fadeIn();

            damHelper.updateImages($(params.target));
        }, 600);

    } else {
        toaster.def.$genericToast.show();

        setTimeout(function() {
            toaster.def.$genericToast.addClass('open');

            if ($('.gwp-popup-padding').length > 0) {
                $('.gwp-popup-padding').each(function(){
                    $(this).closest('.generic-toaster-container').addClass('no-padding');
                });
            }

            // show modal overlay
            toaster.def.$modalOverlay.fadeIn();

            damHelper.updateImages(toaster.def.$genericToast);
        }, 600);
    }

    if (params.open && typeof params.open == 'function') {
        params.open();
    }

    // lock body scroll
    scrollHelper.disableScroll();

    if (params.close) {
        toaster.def.$genericToast.off('toaster:close');
        toaster.def.$genericToast.on('toaster:close', function () {
            params.close();
        });
    }
}

/**
 * @function
 * @description Loads flyout content through ajax and then opens and inits it
 * @param {object} params
 * can be: instoreavailability, minicart ... TODO: add here more flyouts
 */
function load(options){
    ajax.load({
        url: options.url,
        target: $('.js-generic-toaster > .js-toaster-content'),
        callback: function () {
            initEvents();
            const params = {};

            if (options.close){
                params.close = options.close;
            }

            open(params);
            if (options.open) {
                options.open();
            }
        }
    });
}

/**
 * @function
 * @description Close all flyouts and overlay
 */
function closeToasters(target){
    // if there's a specific target, use that. Otherwise close all toasters
    const $toasterEl = target ? $(target) : toaster.def.$toasterGeneralEl;

    // close all flyouts
    $toasterEl.removeClass('open');

    // hide modal overlay
    toaster.def.$modalOverlay.fadeOut(1000, function(){
        $toasterEl.hide();
        scrollHelper.enableScroll();
        $toasterEl.trigger('toaster:close');
    });
}

function initDef() {
    toaster.def.$toasterGeneralEl = $('.js-toaster-container');
    toaster.def.$modalOverlay = $('.js-modal-overlay');
    toaster.def.$genericToast = $('.js-generic-toaster');
    toaster.def.$toastContent = $('.js-toaster-content');
}

const toaster = {
    def: {
        $toasterGeneralEl: $('.js-toaster-container'),
        $modalOverlay: $('.js-modal-overlay'),
        $genericToast: $('.js-generic-toaster'),
        $toastContent: $('.js-toaster-content')
    },
    init: function () {
        initEvents();
    },
    initDef: initDef,
    open: open,
    load: load,
    closeToasters: closeToasters
};

module.exports = toaster;

},{"./dam/dam-helper":419,"./modules/ajax":449,"./modules/helpers/scroll":475}],606:[function(require,module,exports){
'use strict';

const isMobile = require('./modules/util/isMobile');

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */
exports.init = function () {
    // do not initialize tooltips in mobile devices
    if (!isMobile()){
        $(document).tooltip({
            items: '.tooltip',
            content: function () {
                return $(this).find('.tooltip-content').html();
            },
            position: {
                my: 'center bottom',
                at: 'center top-10'
            }
        });
    }
};

},{"./modules/util/isMobile":497}],607:[function(require,module,exports){
'use strict';

const getCountryFromLocaleCookie = require('./modules/util/getCountryFromLocaleCookie');
const formHelper = require('./rituals-form-helper');
const recaptchaConfig = require('./recaptchaConfig');
const Resources = window.Resources || {};
const google = require('./modules/google');
let isvalidG = true;
const currentCountryCode = getCountryFromLocaleCookie();

const regex = {
    phone: {
        default: /^[+]?[ 0-9]{0,20}$/,
        ru: /^[+]?(?:[\s]*?[0-9]){0,12}[\s]*$/
    },
    notCC: /^(?!(([0-9 -]){13,19})).*$/,
    email: /^((")("[^"]+?"@)|(([0-9a-zA-Z_]((\.(?!\.))|[-!#\$%&'\*\+\/=\?\^`\{\}\|~\w])*)(?:[0-9a-zA-Z_-])@))((\[)(\[(\d{1,3}\.){3}\d{1,3}\])|(([0-9a-zA-Z][-0-9a-zA-Z]*[0-9a-zA-Z]*\.)+[a-zA-Z0-9]{2,17}))$/,
    password: /^(?=.*[A-Z])(?=.*\d).{8,}$/,
    name: /^(?=.*\D)(?!.*[$€£¥]).{2,50}$/,
    minimumTwoCharacters: /^.{2,}$/,
    date : {
        us    : /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])[\/]\d{4}$/,
        other : /^(0?[1-9]|[12][0-9]|3[01])[\/](0?[1-9]|1[012])[\/]\d{4}$/,
        birthdayUS: /^(0?[1-9]|1[012])[\/](0?[1-9]|[12][0-9]|3[01])$/
    },
    ssn: /^(19|20)?(\d{6}([-+]|\s)\d{4}|(?!19|20)\d{10})$/,
    nif: /^[0-9]{9}$/,
    emojis: /(?:[\u2700-\u27bf]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\u0023-\u0039]\ufe0f?\u20e3|\u3299|\u3297|\u303d|\u3030|\u24c2|\ud83c[\udd70-\udd71]|\ud83c[\udd7e-\udd7f]|\ud83c\udd8e|\ud83c[\udd91-\udd9a]|\ud83c[\udde6-\uddff]|[\ud83c[\ude01-\ude02]|\ud83c\ude1a|\ud83c\ude2f|[\ud83c[\ude32-\ude3a]|[\ud83c[\ude50-\ude51]|\u203c|\u2049|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|\u00a9|\u00ae|\u2122|\u2139|\ud83c\udc04|[\u2600-\u26FF]|\u2b05|\u2b06|\u2b07|\u2b1b|\u2b1c|\u2b50|\u2b55|\u231a|\u231b|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\ud83c\udccf|\u2934|\u2935|[\u2190-\u21ff])/,
    cocNumber: currentCountryCode === 'DE' ? /^[a-zA-Z]{3}[0-9]{6}[a-zA-Z]?$/ : (currentCountryCode === 'AT' ? /^[0-9]{6}[a-zA-Z]{1}$/ : /^[0-9]{1,10}$/),
    vat: currentCountryCode == 'PT' ? /^[0-9]{9}$/ : /^.{1,15}$/,
    script: /<(script|img|link|object|embed|iframe)/gi,
    sql: /\b(OR|ALTER|CREATE|DELETE|DROP|EXEC(UTE)?|INSERT(INTO)?|MERGE|SELECT|UPDATE|UNION(ALL)?|--|-- |#|"|==)\b/i
};

const isFieldSafe = (value) => regex.script.test(value) || regex.sql.test(value) ? false : true;


const includesSpecialCharacters = (str) => {
    const charsToCheck = [
        '!',
        '@',
        '#',
        '$',
        '%',
        '^',
        '&',
        '*',
        '(',
        ')',
        '_',
        '+',
        '=',
        '{',
        '}',
        '\\',
        '|',
        '"',
        '"',
        ';',
        ':',
        '<',
        '>',
        ',',
        '/',
        '?',
        '`',
        '~'
    ];
    return charsToCheck.some((char) => str.includes(char));
};

// global form validator settings
const settings = {
    errorClass: 'error js-validator-error error-text',
    errorElement: 'span',
    onkeyup: function (element) {
        if ($(element).data('onkeyup-validate') && !this.checkable(element)) {
            this.element(element);
        }
    },
    onfocusout: function (element) {
        if ($(element).data('prevent-automatic-validation')) {
            return;
        }

        if (!this.checkable(element)) {
            this.element(element);
        }
    },
    errorPlacement: function (error, element) {
        if (element.hasClass('js-warn-addded')) {
            element.siblings('.js-warn-message').addClass('hide');
        }
        if (element.hasClass('js-options-dropdown-custom')){
            error.insertBefore(element.closest('.selectric-wrapper'));
            return;
        }
        if (element.hasClass('js-custom-select')){
            error.insertBefore(element.closest('.selectric-hide-select'));
            return;
        }

        error.insertBefore(element);
    },
    invalidHandler: function(form, validator) {
        const errors = validator.numberOfInvalids();

        if (errors) {
            const errorElement = $(validator.errorList[0].element);

            formHelper.scrollToInputField(errorElement);
        }
    },
    success: function(error, element) {
        element = element.jquery ? element : $(element);

        if (element.hasClass('js-warn-addded')) {
            element.siblings('.js-warn-message').removeClass('hide');
        }
        error.remove();
        $('.js-product-details-content .js-elixir-name-inner').removeClass('js-elixir-error-state');
    }
};
/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
const validatePhone = function(value, el) {
    let isCustomRegexValid = true;
    const trimmedValue = $.trim(value);
    const customRegex = $(el).attr('regex');
    if (typeof customRegex !== 'undefined') {
        isCustomRegexValid = (new RegExp(customRegex)).test(trimmedValue);
    }

    const isOptional = this.optional(el);

    const regexForCountry = currentCountryCode && regex.phone[currentCountryCode.toLowerCase()] || regex.phone['default'];

    const isValid = regexForCountry.test($.trim(value));
    return (isOptional && value.trim() === '') || (isValid && isCustomRegexValid);
};

/**
* @function
* @description Validates that a credit card owner is not a Credit card number
* @param {String} value The owner field which will be validated
* @param {String} el The input field
*/
const validateOwner = function (value) {
    const isValid = regex.notCC.test($.trim(value));
    return isValid;
};

/**
* @function
* @description Validates that a credit card owner is not a Credit card number
* @param {String} value The owner field which will be validated
* @param {String} el The input field
*/
const emptySelect = function (value) {
    return !!value && $.trim(value) !== '';
};

/**
* @function
* @description Validates a given email address against the email regex
* @param {String} value The email address which will be validated
* @param {String} el The input field
*/
const validateEmail = function (value, el) {
    const isOptional = this.optional(el);
    const isValid = regex.email.test($.trim(value));
    return isOptional || isValid;
};
/**
* @function
* @description Validates a given First Name against the emoji regex
* @param {String} value The First Name which will be validated
* @param {String} el The input field
*/
const validateName = function (value, el) {
    return (
        !regex.emojis.test(value.trim()) &&
        isFieldSafe(value) &&
        !includesSpecialCharacters(value) &&
        regex.name.test(value.trim())
    );
};

const validateNameErrorMessage = function (value, el) {
    const trimmedValue = el.value.trim();
    return !regex.minimumTwoCharacters.test(trimmedValue)
        ? Resources.VALIDATE_CUSTOMER_NAME
        : !validateName(trimmedValue, el)
            ? Resources.GLOBAL_INVALID_INPUT
            : '';
};

/**
* @function
* @description Validates a password confirmation field
* @param {String} value The password confirmation value which will be validated
* @param {String} el The input field
*/
const emailConfirmation = function (value, el) {
    const formattedValue = value.toLowerCase();
    const isValid = formattedValue === $(el).closest('fieldset').find('[id$=email]').val().toLowerCase() ? true : false;
    return isValid;
};

/**
* @function
* @description Validates a given email address against the email regex
* @param {String} value The email address which will be validated
* @param {String} el The input field
*/
const validatePassword = function (value, el) { /* eslint-disable-line */
    const isValid = regex.password.test(value);
    return isValid;
};

/**
* @function
* @description Validates a password input
* @param {String} value The password value which will be validated
* @param {String} el The input field
*/
const passwordConfirmation = function (value, el) {
    const isValid = value === $(el).closest('fieldset').find('[id*=_password_]').val() ? true : false;
    return isValid;
};

/**
* @function
* @description Validates a given postal code against the regex
* @param {String} value The postal code which will be validated
* @param {String} el The input field
*/
const validatePostalCode = function (value, el) {
    const $el = $(el);

    if (!$el.hasClass('required') && value === '') {
        return true;
    }

    const postalCodeRegex = new RegExp($(el).attr('regex'));
    let formattedValue = $.trim(value.toUpperCase());

    $el.val(formattedValue);

    let isValid = (postalCodeRegex).test($.trim(formattedValue));

    if (!isValid && $el.data('requires-additional-formatting')){
        formattedValue = formHelper.formatUKPostalCodeSpace($el, formattedValue);
        isValid = (postalCodeRegex).test(formattedValue);
    }
    return isValid;
};

const validateCOCNumber = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }
    const formattedValue = value.toUpperCase();
    $(el).val(formattedValue);
    return regex.cocNumber.test($.trim(formattedValue));
};

const validateVATNumber = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }
    const formattedValue = value.toUpperCase();
    $(el).val(formattedValue);
    return regex.vat.test($.trim(formattedValue));
};

const validateRegexAttribute = function (value, el) {
    if (!$(el).hasClass('required') && value === '') {
        return true;
    }

    const regex = new RegExp($(el).attr('regex'));
    return regex.test($.trim(value));
};

/**
* @function
* @description Validates state based on a given postal code
* @param {String} value The state id which will be validated
* @param {String} el The input field
*/

const setIsValidG = function(value){
    isvalidG = value;
};

const validateStateFromPostal = function (value, el) {
    const $fieldset = $(el).closest('fieldset');
    const $postal = $fieldset.find('[id$=_postal]').val();
    const $country = $fieldset.find('[id$=_country]').val();
    google.places.compareStateToPostalCode($postal, $country,value, setIsValidG);
    return isvalidG;
};

const validateMaxLengthAllowed = function (value, el) {
    const $el = $(el);
    const maxLength = parseInt($el.attr('maxlengthallowed'),10);
    const valid = value.length <= maxLength;

    if (valid) {
        return valid;
    }

    $el.val(value.substr(0, maxLength + 1));
    return false;
};

const validatePersonalizedName = function (value, el) { /* eslint-disable-line */
    return !regex.emojis.test($.trim(value));
};

/**
 * @function
 * @description Validates a given date
 * @param {String} value The date which will be validated
 * @param {String} el The input field
 */
function validateBirthdayOther(value, el) {
    const isOptional = this.optional(el);
    let isValid;

    // if user inputs less than 6 characters, do not validate
    if (value.length < 6) {
        return isOptional;
    }

    const splitValue = getSplitValueDate(value);

    const formattedValue = splitValue.join('/');
    $(el).val(formattedValue);
    // get regex pattern for specific country or use 'other' as default
    const regexDatePatternCountry = regex.date[currentCountryCode.toLowerCase()] ? currentCountryCode.toLowerCase() : 'other';
    isValid = regex.date[regexDatePatternCountry].test($.trim(formattedValue));

    // check if the day is valid (not like 31st of Feb)
    if (isValid) {
        const day = currentCountryCode === 'US' ? splitValue[1] : splitValue[0];
        const month = currentCountryCode === 'US' ? splitValue[0] : splitValue[1];
        const year = splitValue[2];
        const currentYear = new Date().getFullYear();

        const date = new Date(year, parseInt(month) - 1, day);
        isValid = year < currentYear && (Boolean(+date) && date.getDate() === parseInt(day));
    }

    return isOptional || isValid;
}

function getSplitValueDate(value) {
    // add 0 if day or month are a single digit
    const splitValue = value.trim().split(/[.,\/ -]/);

    for (let i = 0; i < splitValue.length; i++) {
        if (i !== splitValue.length - 1 && splitValue[i].length === 1) {
            splitValue[i] = '0' + splitValue[i];
        }

        // if user inputs only 2 digits for the year (here we always consider that the last value)
        // add '19' or '20' in front
        if (i === splitValue.length - 1) {
            const currentYearInTwoDigits = new Date().getFullYear().toString().substr(-2);

            if (splitValue[i].length === 2) {
                splitValue[i] = splitValue[i] < currentYearInTwoDigits ? '20' + splitValue[i] : '19' + splitValue[i];
            }
        }
    }

    return splitValue;
}

function validateBirthdayUS(value, el) {
    const isOptional = this.optional(el);
    let isValid;

    // if user inputs less than 6 characters, do not validate
    if (value.length < 3) {
        return isOptional;
    }

    // add 0 if day or month are a single digit
    const splitValue = value.trim().split(/[.,\/ -]/);
    for (let i = 0; i < splitValue.length; i++) {
        if (i !== splitValue.length && splitValue[i].length === 1) {
            splitValue[i] = '0' + splitValue[i];
        }
    }

    const formattedValue = splitValue.join('/');
    $(el).val(formattedValue);
    isValid = regex.date['birthdayUS'].test($.trim(formattedValue));

    if (currentCountryCode !== 'US') {
        isValid = regex.date['other'].test($.trim(formattedValue + '/1900'));
    }

    // check if the day is valid (not like 31st of Feb)
    if (isValid) {
        let day = splitValue[1];
        let month = splitValue[0];
        const year = 1900;
        if (currentCountryCode !== 'US') {
            day = splitValue[0];
            month = splitValue[1];
        }

        const currentYear = new Date().getFullYear();
        const date = new Date(year, parseInt(month) - 1, day);

        isValid = year < currentYear && (Boolean(+date) && date.getDate() === parseInt(day));
    }

    return isOptional || isValid;
}

function validateDateAgainstNow(value, el) {
    let isValid = false;
    let isDate = false;

    const formattedValue = value.replace(/-| /g, '/');
    $(el).val(formattedValue);

    const dateString = $.trim(formattedValue);

    if (currentCountryCode === 'US'){
        isDate = regex.date.us.test(dateString);
    } else {
        isDate = regex.date.other.test(dateString);
    }

    if (isDate) {
        const parts = dateString.split('/');
        let d;
        if (currentCountryCode === 'US') {
            d = new Date(parts[2], parseInt(parts[0]) - 1, parts[1], 0, 0, 0, 0);
        } else {
            d = new Date(parts[2], parseInt(parts[1]) - 1, parts[0], 0, 0, 0, 0);
        }

        if (d.getTime() <= Date.now()) {
            isValid = true;
        }
    }

    return isValid;
}

function validateSocialSecurityNumber(ssn, el) {
    const isOptional = this.optional(el);
    const validate = $(el).data('validate');

    if (isOptional || !validate) {
        return true;
    }

    return regex.ssn.test(ssn);
}

function validateNifNumber(nifNumber, el) {
    const isOptional = this.optional(el);
    if (isOptional && nifNumber.length === 0) {
        return true;
    }

    return regex.nif.test(nifNumber);
}

function validateLoyaltySMSNewsletter(value, el) {
    if (value !== 'true') {
        return true;
    }

    const phone = $(el).closest('form').find('.smsphone');

    if (!phone.length) {
        return true;
    }

    return !!phone.val().trim().length;
}

function validateSMSPhone(value, el) { /* eslint-disable-line */
    const addToSmsListCheckbox = $('[id$=_addtosmslist]').length ? $('[id$=_addtosmslist]') : $('[id$=_addtoloyaltysmslist]');

    if (!addToSmsListCheckbox.is(':checked')) {
        return true;
    }

    return !!value.trim().length;
}

function validateRequiredAge(value, el) {
    if (currentCountryCode.toLowerCase() === 'us') {
        return true;
    }

    const $el = $(el);
    const minAgePreset = $el.data('min-age');
    const minAge = typeof minAgePreset !== 'undefined' ? minAgePreset : 16;

    const splitValue = getSplitValueDate(value);
    const birtday = new Date(splitValue[2] + '/' + splitValue[1] + '/' + splitValue[0]);
    const now = new Date();

    let diff = now.getFullYear() - birtday.getFullYear();

    if (now.getMonth() < birtday.getMonth()) {
        diff--;
    } else if (birtday.getMonth() === now.getMonth() && now.getDate() < birtday.getDate()) {
        diff--;
    }

    if (diff < minAge) {
        return false;
    }

    return true;
}

function validateRequiredAgeErrorMessage(value, el) {
    const $el = $(el);
    const minAgePreset = $el.data('min-age');
    const minAge = typeof minAgePreset !== 'undefined' ? minAgePreset : 16;
    const errorMessage = String.format(Resources.VALIDATE_BIRTHDAY_MIN_AGE, minAge);

    if (errorMessage) {
        return errorMessage;
    }
}

function validateOrderNumber(value, el) {
    const isOptional = this.optional(el);
    if (isOptional && value.length === 0) {
        return true;
    }

    const orderNumberRegex = new RegExp(Resources.ORDER_VALIDATION_REGEX);
    return orderNumberRegex.test($.trim(value));
}

/**
* Add password validation method to jQuery validation plugin.
* Text fields must have 'passwordcheck' and 'passwordconfirm' css class to be validated
* Note: All password fields must have 'passwordcheck' css class to be validated  (e.g. registration page)
*/
$.validator.methods.required = function(value, element) {
    return !!value && value !== null && (element.type === 'password' || value.trim() !== '');
};

$.validator.addMethod('ordernumber', validateOrderNumber, Resources.VALIDATE_ORDERNUMBER);

$.validator.addMethod('passwordcheck', validatePassword, Resources.VALIDATE_PASSWORD);
$.validator.addMethod('passwordconfirm', passwordConfirmation, Resources.VALIDATE_PASSWORDCONFIRM);

/**
* Add email validation method to jQuery validation plugin.
* Text fields must have 'email' and 'emailconfirm' css class to be validated
*/
$.validator.addMethod('email', validateEmail, Resources.VALIDATE_EMAIL);
$.validator.addMethod('emailconfirm', emailConfirmation, Resources.VALIDATE_EMAILCONFIRM);

/**
* Add First Name and Last Name validation method to jQuery validation plugin.
* Text fields must have 'firstName' and 'lastName' css class to be validated
*/
$.validator.addMethod('firstName', validateName, validateNameErrorMessage);
$.validator.addMethod('lastName', validateName, validateNameErrorMessage);

/**
* Add email validation method to jQuery validation plugin.
* Text fields must have 'email' and 'emailconfirm' css class to be validated
*/
$.validator.addMethod('postal', validatePostalCode, Resources.VALIDATE_POSTALCODE);

$.validator.addMethod('dangerouspostal', function(value, el) {return value && !$(el).hasClass('excludedpostalerror');}, Resources.VALIDATE_DANGEROUS_POSTALCODE);

$.validator.addMethod('cocNumber', validateCOCNumber, Resources.VALIDATE_COCNUMBER);

$.validator.addMethod('btwVatNumber', validateVATNumber, Resources.VALIDATE_VATNUMBER);

$.validator.addMethod('street', validateRegexAttribute, Resources.VALIDATE_STREET);

$.validator.addMethod('houseNumber', validateRegexAttribute, Resources.VALIDATE_HOUSENUMBER);

/**
 * Add state from postal code validation method to jQuery validation plugin.
 * Text fields must have 'state' css class to be validated based on postal code
 */
$.validator.addMethod('stateUS', validateStateFromPostal, Resources.VALIDATE_STATE_FROM_POSTAL);

/**
 * Add date validation method to jQuery validation plugin.
 * Text fields must have 'date' css class to be validated as date
 */
$.validator.addMethod('date-max-now', validateDateAgainstNow, Resources.VALIDATE_DATE_MAX_NOW);
$.validator.addMethod('date', validateBirthdayOther, Resources.VALIDATE_DATE);
$.validator.addMethod('birthday-us', validateBirthdayUS, Resources.VALIDATE_BIRTHDAY_USA);
$.validator.addMethod('min-age', validateRequiredAge, validateRequiredAgeErrorMessage);

/**
 * Add ssn validation method to jQueru validation plugin.
 */
$.validator.addMethod('ssn', validateSocialSecurityNumber, Resources.VALIDATE_SSN);

/**
 * Add NIF validation method to jQuery validation plugin.
 */
 $.validator.addMethod('nif', validateNifNumber, Resources.VALIDATE_NIF);

/**
* Add phone validation method to jQuery validation plugin.
* Text fields must have 'phone' css class to be validated as phone
*/
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
* Add CCOwner validation method to jQuery validation plugin.
* Text fields must have 'owner' css class to be validated as not a credit card
*/
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

$.validator.addMethod('emptyselect', emptySelect, Resources.VALIDATE_REQUIRED);

$.validator.addMethod('personalizedname', validatePersonalizedName, Resources.SPECIAL_CHARACTERS);

$.validator.addMethod('maxlengthallowed', validateMaxLengthAllowed, $.validator.format(Resources.VALIDATE_MAXLENGTH));

$.validator.addMethod('loyaltysmslist', validateLoyaltySMSNewsletter, Resources.VALIDATE_LOYALTYSMS);

$.validator.addMethod('smsphone', validateSMSPhone, Resources.VALIDATE_LOYALTYSMSPHONE);

/**
* Add gift cert amount validation method to jQuery validation plugin.
* Text fields must have 'gift-cert-amont' css class to be validated
*/
$.validator.addMethod('gift-cert-amount', function (value, el) {
    const isOptional = this.optional(el);
    const isValid = (!isNaN(value)) && (parseFloat(value) >= 5) && (parseFloat(value) <= 5000);
    return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
* Add positive number validation method to jQuery validation plugin.
* Text fields must have 'positivenumber' css class to be validated as positivenumber
*/
$.validator.addMethod('positivenumber', function (value) {
    if ($.trim(value).length === 0) { return true; }
    return (!isNaN(value) && Number(value) >= 0);
}, ''); // '' should be replaced with error message if needed

$.extend($.validator.messages, {
    required: Resources.VALIDATE_REQUIRED,
    remote: Resources.VALIDATE_REMOTE,
    email: Resources.VALIDATE_EMAIL,
    url: Resources.VALIDATE_URL,
    date: Resources.VALIDATE_DATE,
    dateISO: Resources.VALIDATE_DATEISO,
    number: Resources.VALIDATE_NUMBER,
    digits: Resources.VALIDATE_DIGITS,
    creditcard: Resources.VALIDATE_CREDITCARD,
    equalTo: Resources.VALIDATE_EQUALTO,
    maxlength: $.validator.format(Resources.VALIDATE_MAXLENGTH),
    minlength: $.validator.format(Resources.VALIDATE_MINLENGTH),
    rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
    range: $.validator.format(Resources.VALIDATE_RANGE),
    max: $.validator.format(Resources.VALIDATE_MAX),
    min: $.validator.format(Resources.VALIDATE_MIN)
});

const validator = {
    regex: regex,
    settings: settings,
    init: function () {
        const self = this;
        $('form:not(.suppress):not(.js-pdp-add-to-cart-form)').each(function () {
            $(this).validate(self.settings);
        });
        $('form.js-pdp-add-to-cart-form').each(function () {
            const settings = $.extend(true, self.settings, {ignore:['hidden:not(select)']});
            $(this).validate(settings);
        });

        //Prevent posting form multiple times
        $(document).off('submit.postback','form.js-postback').on('submit.postback','form.js-postback', function (e) {
            const $this = $(this);
            if ($this.valid()) {
                const submit = $this.find('button[type=submit]');
                submit.addClass('btn--disabled');
                const spinner = $('.js-spinner-general', submit);

                if (spinner.length) {
                    submit.addClass('button-loading');
                    spinner.addClass('spinner-visible');
                }

                const recaptchaContainerId = $this.data(recaptchaConfig.CONSTANTS.RECAPTCHA_CONTAINER_ID_ATTR);
                // if there is recaptcha -> only submit once the recaptcha is validated (js-recaptchadone class will be added after validation)
                if ($('#' + recaptchaContainerId).length > 0 && $this.hasClass(recaptchaConfig.CONSTANTS.FORM_EXECUTE_RECAPTCHA_CLASS) && !$this.hasClass(recaptchaConfig.CONSTANTS.CHALLENGE_DONE_CLASS)) {
                    recaptchaConfig.executeForContainer(recaptchaContainerId);
                    e.preventDefault();
                    return false; // form will be submitted in the handler functino registered in recaptcha for 'recaptchaContainerId' div
                }
                recaptchaConfig.removeChallengeDoneClass(recaptchaContainerId);

                $this.submit(function () {
                    return false;
                });
                return true;
            }
            return false;
        });
    },
    initForm: function (element) {
        $(element).validate(this.settings);
    },

    validatePostalCode: validatePostalCode,
    validatePersonalizedName: validatePersonalizedName
};

$.validator.messages.required = function ($1, ele) { /* eslint-disable-line */
    const requiredText = $(ele).attr('data-required-text');
    return requiredText || '';
};

module.exports = validator;

},{"./modules/google":453,"./modules/util/getCountryFromLocaleCookie":488,"./recaptchaConfig":587,"./rituals-form-helper":590}],608:[function(require,module,exports){
'use strict';

const VimeoPlayer = require('@vimeo/player');
const isMobile = require('./modules/util/isMobile');
const isMobileWidth = require('./modules/util/isMobileWidth');
const elementInViewport = require('./modules/util/elementInViewport');
const getQueryStringParams = require('./modules/util/getQueryStringParams');
const debounce = require('./modules/helpers/debounce');

// elements
const vimeoElement = '.js-vimeo-player';
const vimeoFullscreen = '.js-vimeo-fullscreen';
const vimeoFullscreenBackdrop = '.js-vimeo-fullscreen-backdrop';
const videoControls = '.js-video-controls';
const videoControlBtn = '.js-video-control-button';
const videoClose = '.js-video-close';

const backgroundVideoElement = '.js-background-video';
const experienceVideoButton = '.js-show-fullscreen';

const ceremonySlider = '.js-product-main-slider';
const ceremonyImageHolder = '.js-product-slider-image-holder';

const contentAssetVideoButton = '.js-content-video-button';
const clickEvent = isMobile() ? 'touchstart.video' : 'click.video';

const players = [];
let onFullscreenHoverTimeout;
let currentFullscreenPlayer;

/**
* @function
* @description Creates video players
*/
function createPlayers() {
    $(vimeoElement).each(function(index, el) {
        const options = $(el).data('vimeo-options');

        // Fix for not looping in background mode
        if (options.background === true && !('loop' in options)) {
            options.loop = 1;
        }

        const shouldInitVideo = (
            (isMobileWidth() && !options.hideOnMobile) ||
            (!isMobileWidth() && !options.hideOnDesktop)
        ) && !options.skipOnLoad;

        if (shouldInitVideo) {
            players[options.id] = createPlayer(el, options);
        }

        if (!isMobileWidth() && options.playWhenInView) {
            playWhenInViewport(options.id);
        }
    });
}

/**
* Private function createPlayer
* Based on: https://github.com/vimeo/player.js
*/
function createPlayer(el, options) {
    const player = new VimeoPlayer($(el), options);

    // specific events for product background video
    if ($(el).closest(backgroundVideoElement).length > 0){
        backgroundVideoEvents(player);
    }

    return player;
}

/**
 * @function
 * @description Centralized private play function
 */
function playVideo(id) {
    const player = players[id];

    if (typeof player !== 'undefined') {
        player.getPaused().then(function(paused) {
            if (paused) {
                player.play().then(function(){
                    // The video was played
                }).catch(function(error) {
                    console.debug('Unable to play video');
                    console.debug(error);
                });
            }
        }).catch(function(error) {
            console.debug('Unable to get the paused state of the player.');
            console.debug(error);
        });
    }
}

/**
 * @function
 * @description Centralized private pause function
 */
function pauseVideo(id) {
    const player = players[id];

    if (typeof player !== 'undefined') {
        player.getPaused().then(function(paused) {
            if (!paused) {
                player.pause().then(function(){
                    // The video was paused
                }).catch(function(error) {
                    console.debug('Unable to pause video');
                    console.debug(error);
                });
            }
        }).catch(function(error) {
            console.debug('Unable to get the paused state of the player.');
            console.debug(error);
        });
    }
}

/**
 * @function
 * @description Initializes Background Video Events
 */
function backgroundVideoEvents(player){
    // on start fade in video
    setTimeout(function () {
        $(backgroundVideoElement).addClass('show');
    }, 700);

    player.ready().then(function() {
        if (typeof player._originalElement !== 'undefined') {
            const bgVideoEl = player._originalElement.offsetParent;
            const controls = $(bgVideoEl).find(videoControls);

            if (controls.length > 0) {
                $(controls).addClass('is-playing');
            }
        }
    }).catch(function(error) {
        console.debug('Unable to get the ready state of the player.');
        console.debug(error);
    });
}

function onClickExperienceButton(){
    const $button = $(this);
    // find nearest fullscreen video
    const videoEl = $button.next(vimeoFullscreen).find(vimeoElement)[0];
    openVideoFullscreen(videoEl);
}

/**
 * @function
 * @description Initializes Background Video Events
 */
function openVideoFullscreen(videoEl, tileId) {
    // Make sure to get the right one to deal with the case where multiple videos are in the same page.

    const $videoElWrapped = $(videoEl);
    const currentVimeoFullscreen = $videoElWrapped.closest(vimeoFullscreen);
    const parentFullwidthBlock = currentVimeoFullscreen.closest('.js-fullwidth-slider-block');
    const parentFullwidthSlider = currentVimeoFullscreen.closest('.js-fullwidth-slider-holder');

    // Check if we actually got one.
    if (currentVimeoFullscreen.length === 0) {
        return;
    }

    // If the popup is in a decorative tile or product slider, append it to body.
    // This is needed in order to show it full screen. Otherwise it would show inside of the tile.
    if (currentVimeoFullscreen.closest('.js-grid-decorative-tile-wrapper').length || currentVimeoFullscreen.closest('.js-product-slider-holder').length || parentFullwidthSlider.length) {
        currentVimeoFullscreen.attr('data-tile-id', tileId);
        currentVimeoFullscreen.appendTo('body');
    }

    if (parentFullwidthBlock.length) {
        parentFullwidthBlock.addClass('video-shown');
    }

    // Parse data object
    const options = $(videoEl).data('vimeo-options');

    // Add video to players array if not exist
    if (typeof players[options.id] === 'undefined') {
        players[options.id] = createPlayer(videoEl, options);
    }

    currentFullscreenPlayer = players[options.id];

    if (isMobile()){
        currentFullscreenPlayer.ready().then(function() {
            currentVimeoFullscreen.addClass('active visible');
        }).catch(function(error) {
            console.debug('Unable to get the ready state of the player.');
            console.debug(error);
        });
    } else {
        currentFullscreenPlayer.ready().then(function() {
            // Find videoElement in vimeoFullscreen element
            const videoEl = currentVimeoFullscreen.find(vimeoElement);

            // Calculate the video width and apply to videoEl
            Promise.all([currentFullscreenPlayer.getVideoWidth(), currentFullscreenPlayer.getVideoHeight()]).then(function(dimensions) {
                const factor = dimensions[0] / dimensions[1];
                videoEl.width(Math.floor(videoEl.height() * factor));
            }).catch(function(error) {
                console.debug('Unable to resize video.');
                console.debug(error);
            });

            currentVimeoFullscreen.data('initial-scroll-position', $(window).scrollTop());
            currentVimeoFullscreen.addClass('active visible');
            $('body').addClass('video-fullscreen');
        }).catch(function(error) {
            console.debug('Unable to get the ready state of the player.');
            console.debug(error);
        });
    }

    // bind scroll event so we can close on scroll
    $(window).on('scroll.video', debounce(closeFullscreenOnWindowScroll, 200));

    // bind accessibility events handler on the active element
    $('body').on('keydown.video', function(e) {
        accessibilityEventsHandler(e, options.id);
    });

    if (!isMobile()) {
        setTimeout(function() {
            playVideo(options.id);
        }, 1000);
    }

    setTimeout(function() {
        $(vimeoFullscreenBackdrop).on('click', closeFullscreenVideo);
    }, 100);
}

/**
 * @function
 * @description enables keyboard functionality for the fullscreen video
 */
function accessibilityEventsHandler(e, id) {
    const player = players[id];

    if (e.keyCode === 13 || e.keyCode === 32){ // enter or space - pause/play
        e.preventDefault();

        // get play/pause state
        player.getPaused().then(function(paused) {
            if (paused){
                playVideo(id);
            } else {
                pauseVideo(id);
            }
        }).catch(function(error) {
            console.debug('Unable to get the paused state of the player.');
            console.debug(error);
        });
    } else if (e.keyCode === 27) { // close video on escape
        e.preventDefault();
        closeFullscreenVideo.call(player._originalElement);
    }
}

/**
 * @function
 * @description Close fullscreen video
 */
function closeFullscreenVideo(evt) {
    if (typeof evt !== 'undefined') {
        evt.preventDefault(); //Prevent the close link from navigating
    }

    // get video inside the same fullscreen video element
    const currentVideoElement = $(this).closest(vimeoFullscreen).find(vimeoElement);
    const videoPlayerOptions = currentVideoElement.data('vimeo-options');
    const id = videoPlayerOptions.id;

    if (typeof players[id] !== 'undefined') {
        pauseVideo(id);

        $(this).closest(videoControls).removeClass('active');
        $(vimeoFullscreen).removeClass('active');
        $('body').removeClass('video-fullscreen');
        setTimeout(function() {
            $(vimeoFullscreen).removeClass('visible');
        }, 400);
    }

    // If the popup is in decorative tile or product slider, append it back to that tile from body.
    const $videoFullScreen = $(this).closest('.js-vimeo-fullscreen[data-tile-id]');

    if ($videoFullScreen.length) {
        const tileId = $videoFullScreen.data('tile-id');

        setTimeout(function() {
            $('button[data-tile-id="' + tileId + '"]').parent().append($videoFullScreen);
        }, 500);
    }

    if ($('.js-fullwidth-slider-block').hasClass('video-shown')) {
        $('.js-fullwidth-slider-block').removeClass('video-shown');
    }

    // unbind onScrollWindow callback from scroll event
    $(window).off('scroll.video');

    // unbind accessibility events handler
    $('body').off('keydown.video');

    $(vimeoFullscreenBackdrop).off('click', closeFullscreenVideo);

    if ($(this).closest('.js-product-experience-block').length) {
        $('.js-drag-list').css('z-index', '0');
    }
}

/**
 * @function
 * @description Handle play button click
 */
function onClickVideoPlayPause() {
    const target = $(this).data('target');
    const controls = $(this).closest(videoControls);
    const id = getVideoId(target);

    if (typeof players[id] !== 'undefined') {
        if (!$(controls).hasClass('is-playing')) {
            // in case the video had been intentionally paused, remove flag
            $(controls).removeClass('was-paused');
            $(controls).addClass('is-playing');
            playVideo(id);
        } else {
            // save that the video was paused - prevents playing on scroll
            $(controls).addClass('was-paused');
            $(controls).removeClass('is-playing');
            pauseVideo(id);
        }
    }
}

/**
 * @function
 * @description Handle fullscreen video mouseover
 */
function onMouseOverFullscreen() {
    const controls = $(this).find(videoControls);
    clearTimeout(onFullscreenHoverTimeout);

    if (!controls.hasClass('active')) {
        controls.addClass('active');
    }
}

/**
 * @function
 * @description Handle fullscreen video mouseout
 */
function onMouseOutFullscreen() {
    const controls = $(this).find(videoControls);
    clearTimeout(onFullscreenHoverTimeout);

    onFullscreenHoverTimeout = setTimeout(handleMouseOutFullscreen, 1000, controls);
}

/**
 * @function
 * @description timed out mouseout handler
 */
function handleMouseOutFullscreen(el) {
    el.removeClass('active');
}

/**
 * @function
 * @description control play/pause on scroll in/out of viewport
 */
function playWhenInViewport(id) {
    const player = players[id];

    $(window).on('load scroll', function() {
        if (typeof player._originalElement !== 'undefined') {
            const bgPlayerEl = player._originalElement.offsetParent;
            const controls = $(bgPlayerEl).find(videoControls);
            const isOpaque = $(bgPlayerEl).parent().css('opacity') == '0';

            // when video is in viewport and is visible
            if (elementInViewport(bgPlayerEl, 0) && !isOpaque) {
                // only play if video wasn't paused by the user before
                if (!$(controls).hasClass('was-paused')) {
                    playVideo(id);
                    controls.addClass('is-playing');
                }
            } else {
                pauseVideo(id);
                controls.removeClass('is-playing');
            }
        }
    });
}

/**
 * @function
 * @description close full screen on scroll
 */
function closeFullscreenOnWindowScroll() {
    const start = $(vimeoFullscreen).data('initial-scroll-position') || 0;
    const offset = 100;

    if ($(window).scrollTop() > (start + offset) || $(window).scrollTop() < (start - offset)) {
        $(videoClose).trigger('click');
    }
}

/**
 * @function
 * @description Finds the player id given a video element
 */
function getVideoId(el) {
    const options = $.parseJSON(JSON.stringify($(el).data('vimeo-options')));
    return options.id;
}

/**
 * @function
 * @description Initializes Experience Video - PDP
 */
function initExperienceVideo(){
    // init events
    $(experienceVideoButton).on('click', onClickExperienceButton);
}

/**
 * @function
 * @description Initializes Steps Block Video - Collection page
 */
function initCeremonyStepsVideo(){
    // if there was a video in this slider, set it to start from the beginning
    if (!isMobileWidth()) {
        $(ceremonySlider).on('beforeChange', function(e, slick, currentSlide, nextSlide) {

            // Get current slide and search for video element
            const currentImageHolderEl = $(ceremonyImageHolder).get(currentSlide);
            const currentVideoEl = $(currentImageHolderEl).find(vimeoElement);
            const currentControlsEl = $(currentImageHolderEl).find(videoControls);

            if (currentVideoEl.length > 0) {
                currentControlsEl.removeClass('is-playing was-paused');

                // get video id and pause it
                const id = getVideoId(currentVideoEl);
                pauseVideo(id);
            }

            // Get next slide and search for video element
            const nextImageHolderEl = $(ceremonyImageHolder).get(nextSlide);
            const nextVideoEl = $(nextImageHolderEl).find(vimeoElement);
            const nextControlsEl = $(nextImageHolderEl).find(videoControls);

            if (nextVideoEl.length > 0) {
                nextControlsEl.addClass('is-playing');

                // get video id and play it from the beginning
                const id = getVideoId(nextVideoEl);

                // set video time to 0
                players[id].setCurrentTime(0);
                playVideo(id);
            }
        });
    }
}

/**
 * @function
 * @description Initializes video in content asset
 */
function initContentAssetVideo() {
    // init events
    $(contentAssetVideoButton).off(clickEvent).on(clickEvent, onClickContentAssetButton);

    // create video's
    $(vimeoFullscreen).find(vimeoElement).each(function(idx, el) {
        const options = $.parseJSON(JSON.stringify($(el).data('vimeo-options')));

        // Add video to players array if not exist
        if (typeof players[options.id] === 'undefined') {
            players[options.id] = createPlayer(el, options);
        }
    });

    // if there is an `openvideo` query param in the url and it's true
    if (getQueryStringParams(window.location.href).openvideo){
        // find first fullscreen video
        const videoEl = $(vimeoFullscreen).first().find(vimeoElement)[0];
        openVideoFullscreen(videoEl);
    }
}

function onClickContentAssetButton(e){
    const $button = $(e.target);
    // find nearest fullscreen video
    const videoEl = $button.next(vimeoFullscreen).find(vimeoElement)[0];
    const buttonDataAttr = $button.data('tile-id');


    openVideoFullscreen(videoEl, buttonDataAttr);

    if ($button.closest('.js-product-experience-block').length) {
        $('.js-drag-list').css('z-index', '100');
    }
}

/**
 * @function
 * @description Initializes the video events Collection pages
 */
function initCollectionPageEvents(){
    // init events
    initCeremonyStepsVideo();
}

/**
 * @function
 * @description Initializes the video events in PDP pages
 */
function initPDPEvents(){
    // init events
    if ($(experienceVideoButton)){
        initExperienceVideo();
    }

}

/**
 * @function
 * @description Initializes the video events for content assets in all pages
 */
function initGenericEvents(){
    // init events
    createPlayers();

    $(vimeoFullscreen).on('mouseover', onMouseOverFullscreen);
    $(vimeoFullscreen).on('mouseout', onMouseOutFullscreen);
    $(videoControlBtn).off('click', onClickVideoPlayPause).on('click', onClickVideoPlayPause);
    $(videoClose).on('click', closeFullscreenVideo);

    closeFullscreenOnWindowScroll();

    // accessibility events
    // pause/play on enter
    $(videoControlBtn).on('keyup', function (e) {
        const target = $(this).data('target');
        const controls = $(this).closest(videoControls);
        const id = getVideoId(target);

        // checking if it actually is KeyboardEvent, because of conflicts with click on the same button
        // without this, it was calling the event twice, then Play/Pause didn't work as it should
        if (typeof players[id] !== 'undefined' && e.originalEvent === KeyboardEvent) {
            if (e.which === 13 || e.which === 32) {
                if (!$(controls).hasClass('is-playing')) {
                    // in case the video had been intentionally paused, remove flag
                    $(controls).removeClass('was-paused');
                    $(controls).addClass('is-playing');
                    playVideo(id);
                } else {
                    // save that the video was paused - prevents playing on scroll
                    $(controls).addClass('was-paused');
                    $(controls).removeClass('is-playing');
                    pauseVideo(id);
                }
            }
        }
    });
}

const video = {
    initGeneric: function(){
        // init video events
        initGenericEvents();
        initContentAssetVideo();
    },
    initPDP: function(){
        initPDPEvents();
    },
    initCollection: function(){
        initCollectionPageEvents();
    }
};


module.exports = video;

},{"./modules/helpers/debounce":458,"./modules/util/elementInViewport":483,"./modules/util/getQueryStringParams":492,"./modules/util/isMobile":497,"./modules/util/isMobileWidth":499,"@vimeo/player":2}],609:[function(require,module,exports){
'use strict';

const axios = require('axios');
const gtm = require('./modules/google').tagManager;

function callwhitelist() {
    const url = Urls.sendWhitelistingEmail;
    const signupConfirm = $('.js-b2b-signup');
    const $form = $('#whitelist-form');

    $form.on('submit', function(e) {
        e.preventDefault();
        hashCustomerEmail(Urls.hashCustomerEmail,$form).then((res) => {
            if (whitelistFormValidity(res)){
                //show confirmation signup
                axios.post(url, {
                    timeout: 200000,
                    params: {
                        name: $form[0]['dwfrm_b2bwhitelist_firstname'].value,
                        surname: $form[0]['dwfrm_b2bwhitelist_lastname'].value,
                        email: $form[0]['dwfrm_b2bwhitelist_email'].value,
                        phone: $form[0]['dwfrm_b2bwhitelist_phone'].value,
                        companyName: $form[0]['dwfrm_b2bwhitelist_companyname'].value,
                        vat: $form[0]['dwfrm_b2bwhitelist_vat'].value,
                        business: $form[0]['dwfrm_b2bwhitelist_business'].value,
                        question: $form[0]['dwfrm_b2bwhitelist_question'].value
                    }
                }).then(() => {
                    signupConfirm.addClass('show');
                    formSubmitAnalytics(res);
                }).catch((e) => {
                    console.log('Your whitelist request could not be sent.', e);
                });
            }
        });
    });
}

async function hashCustomerEmail(url,form) {
    const data = await axios.post(url, {
        params: {
            email: form[0]['dwfrm_b2bwhitelist_email'].value
        }
    });
    const result = data.data.hashedEmail;
    return result;
}

function formSubmitAnalytics(hashedEmail) {
    gtm.pushDataLayerEvent({
        'event': 'form_submit',
        click_target: 'request proposal',
        'email': hashedEmail
    });
}

function formSubmitErrorAnalytics(hashedMail) {
    gtm.pushDataLayerEvent({
        'event': 'form_field_error',
        'email': hashedMail,
        'error_type': 'form validation error',
        'error_message': 'please enter valid email',
        'error_code': '404'
    });
}

function resetPlaceholderValue() {
    const inputFields = $('.js-b2b-input');

    inputFields.each(function() {
        $(this).on('focus', () => {
            $(this).addClass('focus');
        });

        $(this).on('focusout', () => {
            $(this).removeClass('focus');
        });
    });
}

function whitelistFormValidity(hashedMail) { //Find all active error validations
    let validation = true;
    const form = {
        name: $('#dwfrm_b2bwhitelist_firstname-error'),
        surname: $('#dwfrm_b2bwhitelist_lastname-error'),
        email: $('#dwfrm_b2bwhitelist_email-error'),
        phone: $('#dwfrm_b2bwhitelist_phone-error'),
        companyName: $('#dwfrm_b2bwhitelist_companyname-error'),
        vat: $('#dwfrm_b2bwhitelist_vat-error'),
        business: $('#dwfrm_b2bwhitelist_business-error')
    };
    Object.keys(form).forEach(function(element) {
        if (form[element].length) {
            validation = false;
        }
    });
    if (validation == false){
        formSubmitErrorAnalytics(hashedMail);
    }
    return validation;
}

const whitelist = {
    init: () => {
        resetPlaceholderValue();
        callwhitelist();
    }
};

module.exports = whitelist;

},{"./modules/google":453,"axios":5}],610:[function(require,module,exports){
'use strict';

const slickSlider = require('./slick-slider');
const isSmallView = require('./modules/helpers/isSmallView');

function cardValidation() {
    // Exit early if we do not have anything to work with
    if ($('.js-card-message-textarea').length === 0) {
        return false;
    }

    const cardButton = $('.js-write-a-card .js-add-to-cart, .js-giftcard-submit');
    const cardTextarea = $('.js-card-message-textarea');
    const emptyCardCheckbox = $('#empty-card');
    const characterCounter = $('.js-characters-left');
    const maxCharacters = cardTextarea.attr('maxlength');

    characterCounter.html(maxCharacters - cardTextarea.val().length);

    const pgCustomizeEvents = {
        onChange: $.Event('pgCustomize.onChange')
    };

    cardButton.prop('disabled', !cardTextarea.val() && !emptyCardCheckbox.is(':checked'));

    cardTextarea.off('input paste').on('input paste', function() {
        const message = $(this).val();
        characterCounter.html(maxCharacters - message.length);
    });

    cardTextarea.off('keyup').on('keyup', function() {
        $(document).trigger(pgCustomizeEvents.onChange);

        if (!cardTextarea.val()) {
            cardButton.prop('disabled', true);
            return;
        }

        if ($(cardButton).prop('disabled')) {
            $(cardButton).prop('disabled', false);
        }
    });

    cardTextarea.off('focus click').on('focus click' , function() {
        if (!emptyCardCheckbox.is(':checked')) {
            return;
        }
        emptyCardCheckbox.prop('checked', false);
        cardButton.prop('disabled', true);
    });

    emptyCardCheckbox.off('change').on('change', function() {
        if (!$(this).is(':checked')) {
            cardTextarea.val(window.cartText || '');
            cardButton.prop('disabled', !window.cartText);
            const message = cardTextarea.val();
            characterCounter.html(maxCharacters - message.length);
            return true;
        }
        window.cartText = cardTextarea.val();

        if (cardTextarea.val()) {
            $(cardTextarea).val('');
            characterCounter.html(maxCharacters);
        }
        cardButton.prop('disabled', false);
    });

    $(document).on('keypress paste', '.js-card-message-textarea', function() {
        limitWriteACardTextLines(this, $(this).val());
    });
}

//Limit the text in the write a card text area
function limitWriteACardTextLines(textAreaElement, oldText) {
    //Wait until the character is actually inserted
    setTimeout(function () {
        let lineHeight = 25;

        if (isSmallView()) {
            lineHeight = 23;
        }

        if (textAreaElement.scrollHeight - textAreaElement.clientHeight > lineHeight) {
            $(textAreaElement).val(oldText);
        }
    }, 1);
}

const writeACard = {
    init: function(){
        slickSlider.writeACardSlider();
        cardValidation();
    }
};

module.exports = writeACard;

},{"./modules/helpers/isSmallView":469,"./slick-slider":598}]},{},[278])

